import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _extends from '@babel/runtime/helpers/extends';
import React, { Component, useState, useMemo, useEffect, useRef, useCallback, Fragment } from 'react';
import { useSelector, connect, useDispatch } from 'react-redux';
import { ListAlt, Save, YoutubeSearchedFor, Search, Check, Send, Tab, Close, VisibilityOff, Visibility } from '@material-ui/icons';
import { formatGQLString, decodeId, formatPageQueryWithCount, graphql, formatPageQuery, graphqlWithVariables, formatMutation, formatQuery, parseData, withModulesManager, MainMenuContribution, FormattedMessage, dispatchMutationResp, dispatchMutationErr, dispatchMutationReq, formatGraphQLError, formatServerError, pageInfo, ControlledField, TextInput, Contributions, withHistory, Searcher as Searcher$2, journalize, coreConfirm, historyPush as historyPush$1, withTooltip, PublishedComponent, useTranslations, Autocomplete, ProgressOrError, Form, formatMessage, useModulesManager, encodeId, useHistory, useDebounceCb, useParams, SearcherPane, InfoButton, SearcherExport, sort, formatSorter, useAuthentication } from '@openimis/fe-core';
import _toConsumableArray from '@babel/runtime/helpers/toConsumableArray';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import _asyncToGenerator from '@babel/runtime/helpers/asyncToGenerator';
import _typeof from '@babel/runtime/helpers/typeof';
import _regeneratorRuntime from '@babel/runtime/regenerator';
import { withTheme, withStyles, makeStyles, createTheme, ThemeProvider } from '@material-ui/core/styles';
import _classCallCheck from '@babel/runtime/helpers/classCallCheck';
import _createClass from '@babel/runtime/helpers/createClass';
import _possibleConstructorReturn from '@babel/runtime/helpers/possibleConstructorReturn';
import _getPrototypeOf from '@babel/runtime/helpers/getPrototypeOf';
import _inherits from '@babel/runtime/helpers/inherits';
import { Grid, Tooltip, IconButton, Fab, Paper, Typography, Divider, Button, TableContainer, Table as Table$2, TableHead, TableRow, TableCell, TableBody, FormControlLabel, Checkbox, Snackbar, Box as Box$1, Card, CardHeader, CardContent, FormControl, InputLabel, Select, MenuItem, CircularProgress as CircularProgress$1, Chip, Dialog as Dialog$1, DialogTitle, DialogContent as DialogContent$1, DialogActions as DialogActions$1, TextField, LinearProgress, FormHelperText, RadioGroup, Radio, Accordion, AccordionSummary, AccordionDetails, FormLabel, ListItemText, makeStyles as makeStyles$2, Modal, Backdrop, Stepper, Step, StepLabel, StepContent, Fade, List, ListItem, ListItemSecondaryAction, DialogContentText, Breadcrumbs, TableFooter, TablePagination, Menu, Avatar, useTheme, ListItemIcon, ButtonGroup, Link, Badge, InputAdornment } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import { bindActionCreators } from 'redux';
import EditIcon from '@material-ui/icons/Edit';
import _debounce from 'lodash/debounce';
import LockOpenIcon from '@material-ui/icons/LockOpen';
import DeleteIcon from '@material-ui/icons/Delete';
import AddBoxIcon from '@material-ui/icons/AddBox';
import '@material-ui/icons/PlaylistAddCheck';
import { useHistory as useHistory$1 } from 'react-router-dom';
import VisibilityIcon from '@material-ui/icons/Visibility';
import { Alert as Alert$1, Autocomplete as Autocomplete$1 } from '@material-ui/lab';
import GetAppIcon from '@material-ui/icons/GetApp';
import DescriptionIcon from '@material-ui/icons/Description';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import BusinessIcon from '@material-ui/icons/Business';
import PhoneIcon from '@material-ui/icons/Phone';
import LocationOnIcon from '@material-ui/icons/LocationOn';
import EventIcon from '@material-ui/icons/Event';
import PersonIcon from '@material-ui/icons/Person';
import InfoIcon from '@material-ui/icons/Info';
import CloseIcon from '@material-ui/icons/Close';
import { useDropzone } from 'react-dropzone';
import IconButton$1 from '@material-ui/core/IconButton';
import Button$1 from '@material-ui/core/Button';
import Typography$1 from '@material-ui/core/Typography';
import Paper$1 from '@material-ui/core/Paper';
import Box from '@material-ui/core/Box';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import Webcam from 'react-webcam';
import PhotoCameraIcon from '@material-ui/icons/PhotoCamera';
import CircularProgress from '@material-ui/core/CircularProgress';
import Cropper from 'react-cropper';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import EmailIcon from '@material-ui/icons/Email';
import AccountBoxIcon from '@material-ui/icons/AccountBox';
import { makeStyles as makeStyles$1 } from '@material-ui/styles';
import OtpInput from 'react-otp-input';
import Alert$2 from '@material-ui/lab/Alert';
import clsx from 'clsx';
import countries from 'i18n-iso-countries';
import enLocale from 'i18n-iso-countries/langs/en.json';
import bnLocale from 'i18n-iso-countries/langs/bn.json';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Autocomplete$2 from '@material-ui/lab/Autocomplete';
import { pdfjs } from 'react-pdf';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import PrintIcon from '@material-ui/icons/Print';
import 'react-quill/dist/quill.snow.css';
import ReactQuill from 'react-quill';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import VerifiedUserIcon from '@material-ui/icons/VerifiedUser';
import SaveIcon from '@material-ui/icons/Save';
import ForwardIcon from '@material-ui/icons/Forward';
import UndoIcon from '@material-ui/icons/Undo';
import RestorePageIcon from '@material-ui/icons/RestorePage';
import DoubleArrowIcon from '@material-ui/icons/DoubleArrow';
import '@material-ui/icons/History';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import MoreHoriz from '@material-ui/icons/MoreHoriz';
import _ from 'lodash';
import { useReactToPrint } from 'react-to-print';
import 'react-pdf/dist/umd/shared/utils';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab$1 from '@material-ui/core/Tab';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import Badge$1 from '@material-ui/core/Badge';
import HourglassFullTwoToneIcon from '@material-ui/icons/HourglassFullTwoTone';
import PeopleAltIcon from '@material-ui/icons/PeopleAlt';
import LocalAtmIcon from '@material-ui/icons/LocalAtm';
import DashboardIcon from '@material-ui/icons/Dashboard';
import { ResponsiveContainer, BarChart, CartesianGrid, XAxis, YAxis, Tooltip as Tooltip$1, Bar, Cell, Legend, PieChart, Pie } from 'recharts';
import 'react-multi-date-picker/plugins/colors';
import AssignmentIcon from '@material-ui/icons/Assignment';
import CancelIcon from '@material-ui/icons/Cancel';
import DraftsIcon from '@material-ui/icons/Drafts';
import CheckIcon from '@material-ui/icons/Check';
import '@material-ui/icons/HelpOutline';
import CheckCircleOutlineTwoToneIcon from '@material-ui/icons/CheckCircleOutlineTwoTone';
import '@material-ui/icons/DoneAll';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import 'moment/moment';
import CancelTwoToneIcon from '@material-ui/icons/CancelTwoTone';
import AssignmentReturnedIcon from '@material-ui/icons/AssignmentReturned';
import ClearAllIcon from '@material-ui/icons/ClearAll';
import SearchIcon from '@material-ui/icons/Search';
import ListIcon from '@material-ui/icons/List';
import BlockIcon from '@material-ui/icons/Block';
import HourglassEmptyIcon from '@material-ui/icons/HourglassEmpty';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import NotificationsIcon from '@material-ui/icons/Notifications';
import Menu$1 from '@material-ui/core/Menu';
import MenuItem$1 from '@material-ui/core/MenuItem';
import ListItemText$1 from '@material-ui/core/ListItemText';
import Divider$1 from '@material-ui/core/Divider';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import CssBaseline from '@material-ui/core/CssBaseline';
import MessageIcon from '@material-ui/icons/Message';
import TodayIcon from '@material-ui/icons/Today';

var mainMenuGrievance$1 = "Grievance";
var resetFilterTooltip$1 = "Reset Filters";
var refreshFilterTooltip$1 = "Search";
var view$1 = "view";
var reject$1 = "reject";
var resend$1 = "resend";
var revert$1 = "revert";
var forward$1 = "forward";
var verify$1 = "verify";
var approve$1 = "Approve";
var messages_en = {
	"location.HealthFacilityFullPath.district": "Division",
	"location.RegionPicker.label": "Division",
	"location.DistrictPicker.label": "District/City Corporation",
	"location.Location2Picker.label": "Upazilla/Thana/Municipalties",
	"location.Location3Picker.label": "Union/Ward",
	"location.locationType.0": "Division",
	"location.locationType.0.placeholder": "Search for a Division...",
	"location.locationType.1": "District/City Corporation",
	"location.locationType.1.placeholder": "Search for a District...",
	"location.locationType.2": "Upazilla/Thana/Municipalties",
	"location.locationType.3": "Union/Ward",
	"location.locationType.4": "Post Office",
	"location.locationType.0.children": "District, Upazilla and Union",
	"location.locationType.1.children": "Union/Ward",
	"location.locationType.2.children": "Union/Ward",
	"location.locationType.0.directChildren": "District/City Corporation",
	"location.locationType.1.directChildren": "Upazilla/Thana/Municipalties",
	"location.locationType.2.directChildren": "Union/Ward",
	"location.locations.searcher.title.0": "Division",
	"location.locations.searcher.title.1": "District/City Corporation",
	"location.locations.searcher.title.2": "Upazila/Thana",
	"location.locations.searcher.title.3": "Union/Ward",
	"location.locations.searcher.title.4": "Post Office",
	"location.locations.searcher.title.3.catchments": "Union/Ward",
	"location.locationType.R": "Division",
	"location.locationType.D": "District/City Corporation",
	"location.locationType.W": "Upazila",
	"location.locationType.V": "Union/Ward",
	"location.locationType.O": "Post Office",
	"menu.workforce": "Workforce",
	"menu.factory.management": "Factory Management",
	"menu.workforce.organizations": "Organizations",
	"menu.workforce.organizations.unit": "Organizations Unit",
	"menu.workforce.organizations.unit.designation": "Organizations Unit Designation",
	"menu.workforce.organizations.employee": "Organizations Employee",
	"menu.workforce.organizations.employee.designation": "Organizations Employee Designation",
	"menu.workforce.office": "Offices",
	"menu.workforce.company": "Companies",
	"menu.workforce.approve.company": "Approve Companies",
	"menu.workforce.factory": "Factories",
	"menu.workforce.factory.employee.designation": "Factory Employee Designation",
	"menu.workforce.employee": "Employees",
	"menu.workforce.registration": "Registration",
	"menu.workforce.application": "Application",
	"menu.workforce.application.process": "Application Process",
	"menu.workforce.banks": "Banks",
	"menu.workforce.documents": "Documents",
	"workforce.employee.other.document": "অন্যান্য ডকুমেন্ট সমূহ",
	"menu.workforce.branch": "Branches",
	"menu.workforce.employee.factory": "Employee Factories",
	"workforce.employee.designation": "Designation",
	"workforce.employee.relationWithApplicant": "Applicant's relationship to the deceased worker",
	"workforce.employee.present_location": "Present Location",
	"workforce.employee.permanent_location": "Permanent Location",
	"workforce.organization.addNewTooltip": "Add Workforce Organizations",
	"workforce.organization.name.en": "Organization Name En",
	"workforce.organization.name.bn": "Organization Name Bn",
	"workforce.organization.location": "Location",
	"workforce.organization.address": "Address",
	"workforce.organization.phone": "Phone",
	"workforce.organization.email": "Organization Email",
	"workforce.organization.website": "Organization website",
	"workforce.organization.type.picker": "Organization Type",
	"workforce.organization.parent": "Parent",
	"workforce.organization.picker": "Organization",
	"workforce.bank.picker": "Bank",
	"workforce.branch.picker": "Branch",
	"workforce.district.branch.picker": "District",
	"workforce.organization.unit.picker": "Unit",
	"workforce.employee.relation.picker": "Select Relation type",
	"workforce.officeType.selector.picker": "Select Office",
	"workforce.EmployeeType.selector.picker": "Select Employee",
	"menu.workforce.association": "Associations",
	"workforce.representative.details": "Representative Details",
	"workforce.representative.name.en": "Representative Name En",
	"workforce.representative.name.bn": "Representative Name Bn",
	"workforce.representative.location": "Representative Location",
	"workforce.representative.address": "Representative Address",
	"workforce.representative.phone": "Representative Phone",
	"workforce.representative.email": "Representative Email",
	"workforce.representative.nid": "Representative NID",
	"workforce.representative.passport": "Representative Passport",
	"workforce.representative.position": "Representative Position",
	"workforce.representative.birthDate": "Representative Birth Date",
	"workforce.association.name.en": "Name En",
	"workforce.association.shortName.en": "Short Name En",
	"workforce.association.name.bn": "Name Bn",
	"workforce.association.shortName.bn": "Short Name Bn",
	"workforce.association.phone": "Phone",
	"workforce.association.email": "Email",
	"workforce.association.address": "Address",
	"workforce.association.webAddress": "Web Address",
	"workforce.association.startDate": "Start Date",
	"workforce.association.status": "Status",
	"workforce.association.minimumSalary": "Minimum Salary",
	"workforce.organization.unit.addNewTooltip": "Add Workforce Organizations Unit",
	"workforce.organization.unit.name.en": "Organization Unit Name En",
	"workforce.organization.unit.name.bn": "Organization Unit Name Bn",
	"workforce.organization.unit.email": "Organization Unit Email",
	"workforce.organization.unit.phone": "Organization Unit Phone",
	"workforce.organization.unit.level": "Organization Unit Level",
	"workforce.organization.unit.parent": "Parent Unit",
	"workforce.organization.unit.designation.addNewTooltip": "Add Organizations Unit Designation",
	"workforce.organization.unit.designation.name.en": "Designation Name En",
	"workforce.organization.unit.designation.name.bn": "Designation Name Bn",
	"workforce.organization.unit.designation.level": "Designation Level",
	"workforce.organization.unit.designation.sequence": "Designation Sequence",
	"workforce.organization.employee.addNewTooltip": "Add Organizations Employee",
	"workforce.organization.employee.name.en": "Name En",
	"workforce.organization.employee.name.bn": "Name Bn",
	"workforce.organization.employee.location": "Organization Employee Location",
	"workforce.organization.employee.address": "Address",
	"workforce.organization.employee.phone": "Phone",
	"workforce.organization.employee.email": "Email",
	"workforce.organization.employee.gender": "Gender",
	"workforce.organization.employee.birthdate": "Organization Employee Birthdate",
	"workforce.organization.employee.nid": "Organization Employee NID",
	"workforce.organization.employee.birth_certificate_no": "Organization Employee Birth Certificate No",
	"workforce.organization.employee.passport_no": "Organization Employee Passport No",
	"workforce.organization.employee.joining_date": "Organization Employee Joining Date",
	"workforce.organization.employee.status": "Status",
	"workforce.office.addNewTooltip": "Add Workforce Office",
	"workforce.office.employer": "Workforce Office Employer",
	"workforce.office.name.en": "Workforce Office Name En",
	"workforce.office.name.bn": "Workforce Office Name Bn",
	"workforce.office.location": "Workforce Office Location",
	"workforce.office.address": "Workforce Office Address",
	"workforce.office.phone": "Workforce Office Phone",
	"workforce.office.email": "Workforce Office Email",
	"workforce.office.website": "Workforce Office Website",
	"workforce.office.parent": "Workforce Office Parent",
	"workforce.office.status": "Workforce Office Status",
	"workforce.office.representative": "Workforce Office Representative",
	"workforce.company.addNewTooltip": "Add Workforce Company",
	"workforce.company.employerId": "Workforce Company EmployerId",
	"workforce.company.employerIdLima": "Workforce Company EmployerId Lima",
	"workforce.company.name.en": "Company Name En",
	"workforce.company.name.bn": "Company Name Bn",
	"workforce.company.location": "Company Location",
	"workforce.company.address": "Company Address",
	"workforce.company.phone": "Company Phone",
	"workforce.company.email": "Company Email",
	"workforce.company.website": "Company Website",
	"workforce.company.count": "Factory Count",
	"workforce.company.licence_type": "Workforce Company Licence Type",
	"workforce.company.licence_number": "Workforce Company Licence Number",
	"workforce.company.business_sector": "Workforce Company Business Sector",
	"workforce.company.foundation_date": "Workforce Company Foundation Date",
	"workforce.company.association_name": "Workforce Company Association Name",
	"workforce.company.association_membership_number": "Workforce Company Association Membership Number",
	"workforce.company.establishment_Name": "Workforce Company Establishment Name",
	"workforce.company.establishment_date": "Workforce Company Establishment Date",
	"workforce.company.status": "Workforce Company Status",
	"workforce.company.representative": "Workforce Representative",
	"workforce.factory.addNewTooltip": "Add Workforce Factory",
	"workforce.factory.name.en": "Workforce Factory Name En",
	"workforce.factory.name.bn": "Workforce Factory Name Bn",
	"workforce.factory.associationType": "Workforce Factory Assocition Type",
	"workforce.factory.location": "Workforce Factory Location",
	"workforce.factory.address": "Workforce Factory Address",
	"workforce.factory.phone": "Workforce Factory Phone",
	"workforce.factory.email": "Workforce Factory Email",
	"workforce.factory.website": "Workforce Factory Website",
	"workforce.factory.status": "Workforce Factory Status",
	"workforce.factory.representative": "Workforce Factory Representative",
	"workforce.employee.addNewTooltip": "Add Workforce Employee",
	"workforce.employee.workforce_employer": "Employer/Company",
	"workforce.employee.workforce_office": "Office",
	"workforce.employee.workforce_factory": "Factory",
	"workforce.employee.first.name.en": "First Name En",
	"workforce.employee.last.name.en": "Last Name En",
	"workforce.employee.first.name.bn": "First Name Bn",
	"workforce.employee.last.name.bn": "Last Name Bn",
	"workforce.employee.other.name": "Other Name",
	"workforce.employee.location": "Location",
	"workforce.employee.address": "Address",
	"workforce.employee.phone": "Phone",
	"workforce.employee.email": "Email",
	"workforce.employee.occupation": "Occupation",
	"workforce.employee.gender": "Gender",
	"workforce.employee.birthdate": "Birth Date",
	"workforce.employee.joindate": "Joining Date",
	"workforce.employee.deathdate": "Death Date",
	"workforce.employee.date": "Date",
	"workforce.employee.nid": "NID",
	"workforce.employee.employee_type": "Type",
	"workforce.employee.birth_certificate_no": "Birth Certificate No",
	"workforce.employee.passport_no": "Passport No",
	"workforce.employee.fathers_name.bn": "Father Name Bn",
	"workforce.employee.fathers_name.en": "Father Name En",
	"workforce.employee.fathers_name": "Father Name",
	"workforce.employee.mothers_name": "Mother Name",
	"workforce.employee.spouse.name": "Spouse Name",
	"workforce.employee.mothers_name.bn": "Mother Name Bn",
	"workforce.employee.mothers_name.en": "Mother Name En",
	"workforce.employee.spouse.name.bn": "Spouse Name Bn",
	"workforce.employee.spouse.name.en": "Spouse Name En",
	"workforce.employee.marital_status": "Marital Status",
	"workforce.employee.percentage_of_cf_grant": "Percentage of CF grant",
	"workforce.employee.eis.percentage_of_cf_grant": "Percentage of EIS grant",
	"workforce.employee.position": "Position",
	"workforce.employee.monthly_earning": "Mothly Earning",
	"workforce.employee.reference_salary": "Reference Salary",
	"workforce.employee.present_address": "Present Address",
	"workforce.employee.permanent_address": "Permanent Address",
	"workforce.employee.status": "Status",
	"workforce.employee.citizenship": "Citizenship",
	"workforce.employee.privacyLaw": "Privacy Law",
	"workforce.employee.insurance_number": "Insurance Number",
	"workforce.employee.lifeStatus": "Life Status",
	"workforce.employee.name.en": "Name En",
	"workforce.employee.name.bn": "Name Bn",
	"workforce.employee.name": "Name",
	"workforce.employee.application.addNewTooltip": "Add Application",
	"workforce.employee.application.workforce_employer": "Workforce Employer",
	"workforce.employee.application.workforce_office": "Workforce Office",
	"workforce.employee.application.workforce_factory": "Workforce Factory",
	"workforce.employee.application.first.name.en": "First Name En",
	"workforce.employee.application.last.name.en": "Last Name En",
	"workforce.employee.application.first.name.bn": "First Name Bn",
	"workforce.employee.application.last.name.bn": "Last Name Bn",
	"workforce.employee.application.other.name": "Other Name",
	"workforce.employee.application.location": "Location",
	"workforce.employee.application.address": "Address",
	"workforce.employee.application.phone": "Phone",
	"workforce.employee.application.applicationType": "Application Type",
	"workforce.employee.application.organizationType": "Organization Type",
	"workforce.employee.application.associationType": "Association Type",
	"workforce.employee.application.email": "E-mail",
	"workforce.employee.application.occupation": "Occupation",
	"workforce.employee.application.gender": "Gender",
	"workforce.employee.application.birthdate": "Birthdate",
	"workforce.employee.application.joindate": "Joindate",
	"workforce.employee.application.deathdate": "Deathdate",
	"workforce.employee.application.nid": "NID",
	"workforce.employee.application.employee_type": "Employee Type",
	"workforce.employee.application.birth_certificate_no": "Birth Certificate No",
	"workforce.employee.application.passport_no": "Passport No",
	"workforce.employee.application.fathers_name.bn": "Father Name Bn",
	"workforce.employee.application.fathers_name.en": "Father Name En",
	"workforce.employee.application.mothers_name.bn": "Mother Name Bn",
	"workforce.employee.application.mothers_name.en": "Mother Name En",
	"workforce.employee.application.spouse.name.bn": "Spouse Name Bn",
	"workforce.employee.application.spouse.name.en": "Spouse Name En",
	"workforce.employee.application.marital_status": "Maritial Status",
	"workforce.employee.application.position": "Position",
	"workforce.employee.application.monthly_earning": "Monthly Earning",
	"workforce.employee.application.reference_salary": "Reference Salary",
	"workforce.employee.application.present_address": "Present Address",
	"workforce.employee.application.permanent_address": "Permanent Address",
	"workforce.employee.application.status": "Status",
	"workforce.employee.application.revertNote": "Revert Note",
	"workforce.employee.application.revert": "Revert",
	"workforce.employee.application.revert.further.investigation": "Further Investigation",
	"workforce.employee.application.applicationDate": "Application Date",
	"workforce.employee.application.currentStatus": "Current Status",
	"workforce.employee.application.assignedBy": "Assigned By",
	"workforce.employee.application.assignedDate": "Assigned Date",
	"workforce.employee.application.citizenship": "Citizenship",
	"workforce.employee.application.privacyLaw": "Privacy Law",
	"workforce.employee.application.insurance_number": "Insurance Number",
	"workforce.employee.application.lifeStatus": "Life Status",
	"workforce.employee.application.factory.nid": "NID",
	"workforce.employee.application.process": "Application Process",
	"workforce.employee.application.forwardTo": "Forward To",
	"workforce.employee.application.addApplication": "Add application",
	"workforce.employee.application.moneyAmount": "Money Amount",
	"workforce.employee.application.verifier": "Verifier",
	"workforce.employee.application.factoryName": "Factory Name",
	"workforce.employee.application.serviceProviderName": "Name of the service provider",
	"workforce.employee.application.totalAmount": "Total amount applied for:",
	"workforce.employee.application.tk": "Taka",
	".": "Send considered applications to the Association office",
	"workforce.employee.application.forwardToSelectionOffice": "Send considered applications to the Selection committee",
	"workforce.employee.application.provideMeetingInfo": "Provide meeting information",
	"workforce.employee.application.preMeetingList": "Previous meeting list",
	"workforce.employee.application.createMeetingSheet": "Create Meeting Sheet",
	"workforce.employee.application.forwardPendingMeetingSheet": "Forward pending meetings",
	"workforce.employee.application.bulkForward": "Bulk Forward",
	"workforce.employee.application.pendingMeetingSheet": "Pending Meeting Sheet",
	"workforce.employee.application.forwardedMeetingSheet": "Forwarded Meeting Sheet",
	"workforce.employee.application.meetingSheet": "Meeting Sheet",
	"workforce.employee.application.meetingDate": "Meeting Date",
	"workforce.employee.application.approveMeetingSheet": "Approved Meeting Sheet",
	"workforce.employee.application.bulkSelect": "Bulk Select",
	"workforce.employee.application.bulkApprove": "Approve",
	"workforce.employee.application.eis_advisor.recommended": "Recommend",
	"workforce.employee.application.eis_committee.recommended": "Approved",
	"workforce.employee.application.receivedDate": "Received Date",
	"workforce.employee.application.sentDate": "Sent Date",
	"workforce.employee.application.sentTo": "Recipient's Name",
	"workforce.employee.application.advisorApproveMeetingSheet": "Special Advisor Approve Meeting Sheet",
	"workforce.employee.application.sentMeetingSheet": "Sent Application",
	"workforce.employee.application.paymentProcess": "Payment Calculation",
	"workforce.application.verified": "Verified Application",
	"workforce.application.sentforverification": "Application Sent for Verification",
	"workforce.application.providePaymentInfo": "Do you want to calculate payment for selected applications?",
	"workforce.banks.nameEn": "Bank Name En",
	"workforce.banks.nameBn": "Bank Name Bn",
	"workforce.banks.branch.nameEn": "Branch Name En",
	"workforce.banks.branch.nameBn": "Branch Name Bn",
	"workforce.banks.address": "Bank  Address",
	"workforce.banks.location": "Bank Headquarter location",
	"workforce.banks.status": "Bank Headquarter status",
	"workforce.banks.routingNumber": "Bank Routing Number",
	"workforce.banks.contactNumber": "Bank Contact Number",
	"workforce.banks.title": "Banks",
	"workforce.banks.branches.title": "Branches",
	"workforce.banks.addNewTooltip": "Add Bank/Branch",
	"workforce.banks.bankCode": "Bank Code",
	"workforce.banks.district": "District",
	"workforce.employee.dependent.name.en": "First Name En",
	"workforce.employee.dependent.name.bn": "First Name Bn",
	"workforce.employee.dependent.father.name": "Father Name",
	"workforce.employee.dependent.mother.name": "Mother Name",
	"workforce.employee.dependent.last.name.en": "Last Name En",
	"workforce.employee.dependent.last.name.bn": "Last Name Bn",
	"workforce.employee.dependent.nid": "NID Number",
	"workforce.employee.dependent.birth.certificate": "Birth Certificate Number",
	"workforce.employee.dependent.birthDate": "Date of Birth",
	"workforce.employee.dependent.deathDate": "Date of Death",
	"workforce.employee.dependent.phone": "Phone Number",
	"workforce.employee.dependent.email": "Email",
	"workforce.employee.dependent.occupation": "Occupation/Profession",
	"workforce.employee.dependent.present.location": "Present Location",
	"workforce.employee.dependent.permanent.location": "Permanent Location",
	"menu.workforce.employee.dependent": "Workforce Employee Dependent",
	"menu.workforce.employee.accident.info": "Accident Info",
	"workforce.employee.accident.info.addNewTooltip": "Add Accident Info",
	"workforce.employee.accident.info.briefDescription": "Brief Description",
	"workforce.employee.accident.info.injuryType": "Injury Type",
	"workforce.employee.accident.info.dateOfAccident": "Date Of Accident",
	"workforce.employee.accident.info.timeOfAccident": "Time Of Accident",
	"workforce.employee.accident.info.typeOfAccident": "Type Of Accident",
	"workforce.employee.accident.info.dutyStatus": "Duty Status",
	"workforce.employee.accident.info.insideOutsideFactory": "Under what circumstances did the accident occur?",
	"workforce.employee.accident.info.reJoiningDate": "Re-Joining Date",
	"workforce.employee.accident.info.breifInfo": "Brief Description of Accident/Incident",
	"workforce.employee.accident.info.breifDoctorsPrescriptionInfo": "Brief Description of the Injury from the Accident/Incidents as per Doctor’s Prescription",
	"workforce.employee.accident.info.injurySite": "Injury Site/Location",
	"workforce.employee.accident.info.injuryDescription": "Injury detains and Description",
	"workforce.employee.accident.info.disAbilityEffect": "Limitations in Occupation and Activities of Daily Living?",
	"workforce.employee.accident.info.presentInjuryBLASchedule1": "Present Injury Matching BLA Schedule 1 Serial no",
	"workforce.employee.accident.info.disabilityPerSchedule": "Disability (Loss of Earning) % as Per BLA Schedule",
	"workforce.employee.accident.info.joiningDate": "Worker's joining date",
	"workforce.tracking.notfound": "No applications found",
	"workforce.employee.accident.info.application.injuryType": "Injury Type",
	"workforce.employee.accident.info.application.dateOfAccident": "Date Of Accident",
	"workforce.employee.accident.info.application.timeOfAccident": "Time Of Accident",
	"workforce.employee.accident.info.application.typeOfAccident": "Type Of Accident",
	"workforce.employee.accident.info.application.dutyStatus": "Duty Status",
	"workforce.employee.accident.info.application.insideOutsideFactory": "Inside Outside Factory",
	"workforce.employee.accident.info.application.reJoiningDate": "ReJoining Date",
	"workforce.employee.account.info.addNewTooltip": "Add Account Info",
	"menu.workforce.employee.account.info": "Account Info",
	"workforce.employee.account.info.accountOwnerName": "Account Owner Name",
	"workforce.employee.account.info.onbehalfOf": "On Behalf Of",
	"workforce.employee.account.info.reference": "Reference",
	"workforce.employee.account.info.bankName": "Bank Name",
	"workforce.employee.account.info.branchName": "Branch Name",
	"workforce.employee.account.info.routingNumber": "Routing Number",
	"workforce.employee.account.info.accountHolderName": "Account Holder Name",
	"workforce.employee.account.info.accountNumber": "Account Number",
	"workforce.employee.account.info.mobileNumber": "Mobile Number",
	"workforce.employee.account.info.status": "Status",
	"workforce.employee.whoseAccount": "Whose Account you want to choose?",
	"workforce.employee.account.self": "Self",
	"workforce.employee.account.dependent": "Select another dependent's bank account",
	"workforce.employee.account.other": "Others Account",
	"workforce.employee.account.info.relationshipWithAccountHolder": "Relationship with account holder",
	"workforce.employee.account.info.accountHolderNid": "Account Holder NID",
	"workforce.employee.account.info.accountHolderDob": "Account Holder Date of Birth",
	"workforce.employee.services.employee.id": "Employee ID",
	"workforce.employee.services.employee.name": "Employee Name",
	"workforce.employee.services.company.name": "Company Name",
	"workforce.employee.services.join.date": "Joining Date",
	"workforce.employee.services.resignation.date": "Resignation Date",
	"workforce.employee.services.monthly.salary": "Monthly Salary",
	"workforce.employee.services.monthly.positon": "Postion",
	"workforce.employee.services.resignation.reason": "Resignation Reason",
	"registration.nid": "National ID (NID)",
	"registration.mobile": "Mobile Number",
	"registration.name": "Name",
	"workforce.application.type.title": "Select Application Type",
	"workforce.application.type.medical.assistance": "Medical Assistance",
	"workforce.application.type.medical.donation": "Medical Donation",
	"workforce.application.type.financial.assistance": "Financial Assistance Form for the Family of Deceased Worker",
	"workforce.application.type.medical.disability": "Application for Financial Assistance due to Permanent and Partial Disability",
	"workforce.application.type.eis.medical.disability": "Application for Financial Assistance due to Permanent and Partial Disability",
	"workforce.application.type.scholarship": "Scholarship Application",
	"workforce.application.type.education.grant": "Education Grant",
	"workforce.application.type.deadly.grant": "Deadly Grant",
	"workforce.application.type.eis.deadly.grant": "Accidental Death Grant",
	"workforce.application.type.maternal.grant": "Maternal Grant",
	"workforce.application.company.type": "Is your company a hundred percent export-oriented?",
	"workforce.application.for": "Application for whom?",
	"workforce.application.for.type.self": "Self",
	"workforce.application.for.type.dependent": "Dependent",
	"workforce.application.for.type.dependent.children": "For Children",
	"workforce.application.for.type.dependent.mother": "For the wife in case of a male worker",
	"workforce.application.reason.type": "Purpose for financial aid?",
	"workforce.application.permission.yes": "Yes",
	"workforce.application.permission.no": "No",
	"workforce.accident.type.fire_accident": "Fire Accident",
	"workforce.accident.type.boiler_explosion": "Boiler Explosion",
	"workforce.accident.type.burn_injury": "Burn Injury",
	"workforce.accident.type.machinery": "Machinery",
	"workforce.accident.type.electric_shock": "Electric Shock",
	"workforce.accident.type.heavy_object_fall": "Heavy Object Fall",
	"workforce.accident.type.road_accident": "Road Accident",
	"workforce.accident.type.others": "Others",
	"workforce.application.educationInfo.boards.barisal": "Barisal",
	"workforce.application.educationInfo.boards.chattogram": "Chattogram",
	"workforce.application.educationInfo.boards.cumilla": "Cumilla",
	"workforce.application.educationInfo.boards.dhaka": "Dhaka",
	"workforce.application.educationInfo.boards.dinajpur": "Dinajpur",
	"workforce.application.educationInfo.boards.jashore": "Jashore",
	"workforce.application.educationInfo.boards.mymensingh": "Mymensingh",
	"workforce.application.educationInfo.boards.rajshahi": "Rajshahi",
	"workforce.application.educationInfo.boards.sylhet": "Sylhet",
	"workforce.application.educationInfo.boards.madrasha_board": "Madrasha Board",
	"workforce.application.educationInfo.boards.technical_board": "Technical Education Board (BTEB)",
	"workforce.application.educationInfo.boards.open_board": "Open Board (BOB)",
	"workforce.application.educationInfo.passingYear": "Passing Year",
	"workforce.application.educationInfo.admissionYear": "Admission Year",
	"workforce.application.educationInfo.rollNo": "Roll Number",
	"workforce.application.educationInfo.IdNo": "ID Number",
	"workforce.application.educationInfo.regNo": "Registration Number",
	"workforce.application.educationInfo.cgpa": "CGPA / GPA",
	"workforce.application.educationInfo.board": "Education Board",
	"workforce.application.educationInfo.university": "University / Institute Name",
	"workforce.application.steps.underGraduate": "Undergraduate",
	"workforce.application.steps.postGraduate": "Postgraduate",
	"workforce.financial.assistance.normalDeath": "Normal Death",
	"workforce.financial.assistance.accidentalDeath": "Accidental Death",
	"workforce.disability.partial": "Partial disability",
	"workforce.disability.permanent": "Permanent disability",
	"workforce.application.employee.children.studyingClass": "Studying Class/Division",
	"workforce.application.employee.children.studyingSemester": "Studying Semester/Year",
	"workforce.application.employee.children.studyingSubject": "Studying Subject/Division",
	"workforce.application.employee.children.educationInstituteName": "Education Institute Name",
	"workforce.application.employee.children.result": "Result",
	"workforce.application.employee.children.bankNameOrAcNo": "Bank Name and AC No (if have)",
	"workforce.application.employee.children.nidOrBirthRegistry": "NID or Birth Registration Certificate",
	"workforce.application.steps.deademployee.applicant.Details": "Applicant's information on behalf of the deceased worker",
	"workforce.application.steps.employeeDetails": "Labour Details",
	"workforce.application.steps.location": "Location",
	"workforce.application.steps.prosurders": "Information of Dependents",
	"workforce.application.steps.accident.info": "Accident Info",
	"workforce.application.steps.treatment.info": "Treatment Info",
	"workforce.application.steps.upload.documents": "Upload Documents",
	"workforce.application.steps.upload": "Upload",
	"workforce.application.steps.capture": "Take a picture",
	"workforce.application.steps.dependent": "Dependent",
	"workforce.application.subHeader.dependent": "Dependent",
	"workforce.application.steps.account.info": "Account Info",
	"workforce.application.steps.aidReason": "Financial Aid Reasons",
	"workforce.application.steps.childInfo": "Children Info",
	"workforce.application.steps.deathLabourDetails": "Death Labour Details",
	"workforce.application.steps.select": "Select",
	"workforce.application.steps.worker.extraInfo": "Worker Workplace Info",
	"workforce.application.steps.dead.worker.extraInfo": "Dead Worker Workplace Info",
	"workforce.application.steps.ssc": "S.S.C or Equvalent",
	"workforce.application.steps.hsc": "H.S.C or Equvalent",
	"workforce.application.steps.skip": "Skip",
	"workforce.application.steps.dependentAdd": "Add Dependent",
	"workforce.application.steps.warishAdd": "Add Nominee",
	"workforce.application.steps.reasonsforSeekingFinancialAssistance": "Reasons for seeking financial assistance (must be within the last 105 days)",
	"workforce.application.steps.previousGrantInfo": "Previous Donation Info",
	"workforce.application.steps.otherInfo": "Other Info",
	"workforce.application.reasons.addComment": "Add Comment",
	"workforce.application.diseaseGrade": "Disease Grade",
	"workforce.application.revert.reasons.addComment": "Reason for revert",
	"workforce.application.reasons.selectedOfficer": "বাছাইকৃত কর্মকর্তা:",
	"workforce.application.reasons.physicalMentalDisability": "Permanent physical and mental disability due to accident (must be within the last 105 days)",
	"workforce.application.reasons.accidentalDeath": "Death due to accident",
	"workforce.application.reasons.curativeTreatment": "Incurable medical treatment",
	"workforce.application.reasons.deathbodyRefinement": "Transport and burial of dead body",
	"workforce.application.reasons.maternalWelfare": "Maternity welfare for female workers in the informal sector",
	"workforce.employee.application.forward": "Forward",
	"workforce.employee.application.forward.ToAssociation": "Forward To Association",
	"workforce.employee.application.forward.ToSectionAdmin": "Forward To Section Admin",
	"workforce.employee.application.forward.ToSelectionCommittee": "Forward To Selection Committee",
	"workforce.employee.application.forwardToSectionAdmin": "Forward To Section Admin",
	"workforce.employee.application.forwardToDoctor": "Forward To Doctor",
	"workforce.employee.application.forwardToDG": "Forward To DG",
	"workforce.registration.desclaimer": "আপনি ইতোমধ্যে নিবন্ধকৃত ব্যবহারকারী কি না? না হলে নিবন্ধন করুন।",
	"workforce.registration.title": "উপকারভোগী নিবন্ধন ফর্ম",
	"workforce.employee.details": "Employee Details",
	"workforce.employee.upload.factory.document": "Upload Missing Factory Documents",
	"workforce.employee.document": "Documents",
	"workforce.employee.application.details": "Employee Application Details",
	"workforce.next": "Next",
	"workforce.back": "Back",
	"workforce.back.application.type": "Back to Application Type",
	"workforce.save.next": "Save and next",
	"workforce.save": "Save",
	"workforce.submit": "Submit",
	"workforce.confirm.submit": "Confirm Submit",
	"workforce.success.message": "✅ Application submitted successfully!",
	"workforce.employee.application.disburse": "Confirm disbursement",
	"workforce.employee.application.approvalByBoard": "List of applications approved by the board",
	"workforce.representative.sameAsRepresentative": "Same as Company Representative",
	"workforce.application.process.all": "All",
	"workforce.application.process.accidental": "Accidental",
	"workforce.application.process.death": "Death",
	"workforce.application.process.disability": "Disability",
	"workforce.application.process.pending": "Pending",
	"workforce.application.process.approved": "Approved",
	"workforce.application.process.rejected": "Rejected",
	"workforce.application.process.reverted": "Reverted",
	"workforce.application.process.forwarded": "Recommended",
	"workforce.application.id": "Application id",
	"workforce.application.date": "Application Date",
	"workforce.application.disabilityInfo": "Disability Info",
	"workforce.application.disabilityDetails": "Disability Reason",
	"workforce.application.expected.date": "Probable date of service",
	"workforce.application.status": "Application Status",
	"workforce.application.draft_applications": "Draft Applications",
	"workforce.application.draft": "Draft Applications",
	"workforce.application.reverted": "Reverted Application",
	"workforce.application.returned": "Returned Application",
	"workforce.application.rejectedApplication": "Rejected Application",
	"workforce.application.steps.taken": "Measures taken",
	"workforce.application.filed": "Applications filed",
	"workforce.new.application": "New Application",
	"workforce.new.eis.application": "New EIS Application",
	"workforce.help.complain": "Help and Complains",
	"workforce.others": "Others",
	"workforce.application.tracking.number": "Tracking Number",
	"workforce.search.here": "Search Here ...",
	"workforce.application.pending": "Pending Applications",
	"workforce.application.approve.applications": "Approve Applications",
	"workforce.application.approve": "Approve",
	"workforce.application.reject": "Reject",
	"workforce.application.verify": "Verify",
	"workforce.application.recommended": "Verify",
	"workforce.application.recent": "Recent Activity",
	"workforce.application.checked": "Checked Applications",
	"workforce.checker1.dashboard": "Welfare Section-1 Data Entry Operator Dashboard",
	"workforce.checker2.dashboard": "Welfare Section-2 Office Assistant-cum-Computer Typist Dashboard",
	"workforce.section1.admin.dashboard": "Section-1 Assistant Director Dashboard",
	"workforce.section2.admin.dashboard": "Section-2 Assistant Director Dashboard",
	"workforce.section1.deputy1.admin.dashboard": "Welfare Section-1 Deputy-Assistant Director Dashboard",
	"workforce.section2.deputy2.admin.dashboard": "Welfare Section-2 Deputy-Assistant Director Dashboard",
	"workforce.blwf.section.admin.dashboard": "BLWF Section Director Dashboard",
	"workforce.section.cf.doctor.dashboard": "Dashboard",
	"workforce.section.blwf.doctor.dashboard": "Dashboard",
	"workforce.section.eis.doctor.dashboard": "EIS Doctor Dashboard",
	"workforce.bgmea.association.dashboard": "BGMEA Association Dashboard",
	"workforce.bkmea.association.dashboard": "BKMEA Association Dashboard",
	"workforce.applicant.dashboard": "Applicant Dashboard",
	"workforce.factory_admin.dashboard": "Factory Admin Dashboard",
	"workforce.cf.approver.dashboard": "Central Fund Selection committee Dashboard",
	"workforce.blwf.approver.dashboard": "Blwf Selection committee Dashboard",
	"workforce.approver.noEntry": "No entries found",
	"workforce.application.myself": "My Applications",
	"workforce.blwf.checker.dashboard": "Dashboard",
	"workforce.blwf.deputy.admin.dashboard": "BLWF Admin-Assistant Director Dashboard",
	"workforce.eis.coordinator.dashboard": "EIS Coordinator Dashboard",
	"workforce.eis.officer.dashboard": "EIS Officer Dashboard",
	"workforce.eis.committe.dashboard": "EIS Committe Dashboard",
	"workforce.eis.financial.dashboard": "EIS Financial Officer Dashboard",
	"workforce.blwf.dol-dife.dashboard": "Dashboard",
	"workforce.bepza.association.dashboard": "BEPZA Association Dashboard",
	"workforce.lfmeab.association.dashboard": "LFMEAB Association Dashboard",
	"workforce.new.application.factory": "New application (on behalf of the applicant)",
	"workforce.new.application.submittedbyapplicant": "Application submitted by the applicant",
	"workforce.employee.application.forwardToAssociation": "Send considered applications to the association office",
	"workforce.eis.association.committe.dashboard": "EIS Association Committe Dashboard",
	"core.LanguageQuickPicker.dialog.title": "Confirm Language",
	"core.LanguageQuickPicker.dialog.message": "You are about to change the language to Bengali. Do you want to proceed?",
	"core.LanguageQuickPicker.dialog.confirm": "Confirm",
	"core.LanguageQuickPicker.dialog.cancel": "Cancel",
	"profile.mainMenu": "Profile",
	"profile.menu.changePassword": "Change Password",
	"profile.menu.myProfile": "My Profile",
	"profile.menu.editProfile": "Edit Profile",
	mainMenuGrievance: mainMenuGrievance$1,
	"menu.grievance.grievances": "Grievances",
	"menu.add_ticket": "Add Grievance",
	"admin.mainMenu": "Administration",
	"admin.menu.claimAdministrators": "Claim Administrators",
	"admin.menu.enrollmentOfficers": "Enrollment Officers",
	"admin.menu.healthFacilities": "Health Facilities",
	"admin.menu.locations": "Locations",
	"admin.menu.medicalItems": "Medical Items",
	"admin.menu.medicalItemsPrices": "Medical Items Price Lists",
	"admin.menu.medicalServices": "Medical Services",
	"admin.menu.medicalServicesPrices": "Medical Services Price Lists",
	"admin.menu.users": "Users",
	"admin.menu.payers": "Payers",
	"admin.menu.products": "Products",
	"admin.menu.usersProfiles": "Users Profiles",
	"workforce.application.employee.selector": "Select Employee",
	"workforce.application.add.employee": "Add Employee",
	"workforce.application.header.labour": "Labour Details",
	"workforce.application.header.employeeSelector.note": "Select the relevant officer or employee easily using their name, National ID (NID), or mobile number to apply.",
	"workforce.application.header.labour.note": "The following information must be filled as per (NID), otherwise the application will be considered rejected.",
	"workforce.application.header.blwf.education.note": "This application is applicable for students pursuing higher education (Bachelor's degree) at government medical colleges, government agricultural or engineering universities, or other government universities.",
	"workforce.application.header.location": "Location",
	"workforce.application.header.child": "Children Details",
	"workforce.application.header.document": "Documents Upload",
	"workforce.application.header.dependent": "Dependent",
	"workforce.application.header.account": "Account Info",
	"workforce.application.header.previousGrant": "Previous Grant Info",
	"workforce.application.header.other": "Other Info",
	"workforce.child.name.bn": "Name (Bangla)",
	"workforce.child.name.en": "Name (English)",
	"workforce.application.dateofReceipt": "Date of Receipt",
	"workforce.application.grantAmount": "Amount Received",
	"workforce.application.reasonforReceipt": "Reason for Receipt",
	"workforce.application.otherInfo": "Other Info (If Have)",
	"workforce.application.nidVerify.loading": "Your information is verifing from LIMS",
	"workforce.application.nidVerify.success": "Your information has been successfully verified from LIMS",
	"workforce.application.nidVerify.error": "Your information has  been failed to verified from LIMS",
	"workforce.application.labourHeadingOne": "Worker Personal information",
	"workforce.application.labourHeadingTwo": "Worker Family information",
	"workforce.application.labourDetails.spouse": "Maternity Wife Information",
	"workforce.application.account.bank": "Want to get help through the bank?",
	"workforce.application.account.mobile": "Want to get assistance through mobile banking?",
	"workforce.application.account.mobile.operator": "Mobile banking operator",
	"workforce.application.account.mobile.operator.msg": "The mobile number you provide must be registered with your National Identity Card (NID)",
	"workforce.employee.accident.info.hospitalName": "Hospital name",
	"workforce.employee.accident.info.admitDate": "admit date",
	"workforce.employee.accident.info.releaseDate": "Release date",
	"workforce.employee.accident.info.doctorName": "Doctor's name",
	"workforce.application.accident.hospitalized": "Was admitted to the hospital?",
	"workforce.application.accident.accidentPlace": "Accident Place",
	"workforce.application.accident.dateOfDiagnosis": "Date of diagnosis",
	"workforce.application.accident.dateOfLastCheckup": "Date of last prescription given by doctor",
	"workforce.application.otherDieses.": "Mention other diseases",
	"workforce.application.disease.name": "Disease name",
	"workforce.application.disease.timeOfAccident": "Accident Time",
	"workforce.application.disease.maternalHeading": "Maternity information",
	"workforce.application.disease.maternal.delivaryDate": "Date of Birth / Expected Birth Date",
	"workforce.application.modal.header": "Selected Application Summary",
	"workforce.table.applicantName": "Customer's Account Name",
	"workforce.table.applicationType": "Application Type",
	"workforce.table.approvedAmount": "Approved Amount",
	"workforce.table.accountNo": "Account No",
	"workforce.table.bankName": "Bank Name",
	"workforce.table.branch": "Branch",
	"workforce.table.close": "Close",
	"workforce.table.printSUmmary": "Print Summary",
	"workforce.table.forwardToDirector": "Forward to Director",
	"workforce.table.totalAmount": "Total Amount",
	"workforce.table.printAdvice": "Print Advice",
	"workforce.table.bftn": "Bank Payment Advice (BFTN)",
	"search.title": "Search Criteria",
	resetFilterTooltip: resetFilterTooltip$1,
	refreshFilterTooltip: refreshFilterTooltip$1,
	"workforce.application.submittedBy": "Submitted By",
	"workforce.application.startDate": "Start Date",
	"workforce.application.endDate": "End Date",
	"workforce.previewDetails.personalInfo": "Personal Info",
	"workforce.previewDetails.statusInfo": "Status Info",
	"workforce.previewDetails.employeeAccidentInfo": "Accident Info",
	"workforce.previewDetails.contactInfo": "Contact Info",
	"workforce.previewDetails.employeeChildrenInfo": "Children Info",
	"workforce.previewDetails.othersInfo": "Others Info",
	"workforce.previewDetails.employeeBankInfo": "Bank Info",
	"workforce.previewDetails.company": "Company Info",
	"workforce.previewDetails.factory": "Factory Info",
	"workforce.previewDetails.educations": "Educational info of Self / Child",
	"workforce.previewDetails.employeeDependentInfo": "Employee Dependent Info",
	"workforce.previewDetails.employeeWarishInfo": "Employee Nominee Info",
	"workforce.previewDetails.dependent": "Dependent Info",
	"workforce.previewDetails.eis.dependent": "Dependent Info",
	"workforce.previewDetails.metadata": "Needed info about application",
	"workforce.application.death.reason": "Death Reason",
	"workforce.application.other.death.reason": "Specify other causes of death",
	"workforce.application.other.desease.reason": "Specify other diseases",
	"workforce.application.deathReason.heart_disease": "Heart Disease",
	"workforce.application.deathReason.stroke": "Stroke",
	"workforce.application.deathReason.old_age": "Old Age",
	"workforce.application.deathReason.cancer": "Cancer",
	"workforce.application.deathReason.diabetes": "Diabetes",
	"workforce.application.deathReason.liver_failure": "Liver Failure",
	"workforce.application.deathReason.kidney_failure": "Kidney Failure",
	"workforce.application.deathReason.asthma": "Asthma / Breathing Problem",
	"workforce.application.deathReason.pneumonia": "Pneumonia",
	"workforce.application.deathReason.chronic": "Chronic Disease",
	"workforce.application.deathReason.OTHER_OPTION": "Others",
	"workforce.worker.label": "worker",
	"workforce.timePicker.hour": "hour",
	"workforce.timePicker.minute": "minute",
	"workforce.employee.nid_or_birth_certificate": "Nid/BirthCertificate No.",
	"workforce.office.dol": "Department of Labour(DOL)",
	"workforce.office.dife": "Department of Inspection for Factories and Establishments(DIFE)",
	"workforce.office.type": "Select Office Type",
	"workforce.tracking.summary": "Tracking Summary",
	"workforce.officer.selector.picker": "Select Officer",
	"workforce.employee.accident.info.title": "Type of disease or accident",
	"workforce.employee.aid.reason.info.cronic": "Description of the disease",
	"workforce.employee.aid.reason.info.maternity": "For Maternity Desease",
	"workforce.employee.aid.reason.info.accident": "Description of the accident",
	"workforce.account.selection.type": "Select Account Type",
	"core.LoginPage.forgotPassword": "পাসওয়ার্ড ভুলে গেছেন?",
	"core.ForgotPasswordPage.pageTitle": "পাসওয়ার্ড ভুলে গেছেন?",
	"workforce.relation.father": "Father",
	"workforce.relation.father.suffix": "Father's",
	"workforce.relation.mother": "Mother",
	"workforce.relation.mother.suffix": "Mother's",
	"workforce.relation.wife": "Wife",
	"workforce.relation.wife.suffix": "Wife's",
	"workforce.relation.husband": "Husband",
	"workforce.relation.husband.suffix": "Husband's",
	"workforce.relation.son": "Son",
	"workforce.relation.son.suffix": "Son's",
	"workforce.relation.daughter": "Daughter",
	"workforce.relation.daughter.suffix": "Daughter's",
	"workforce.relation.brother": "Brother",
	"workforce.relation.brother.suffix": "Brother's",
	"workforce.relation.sister": "Sister",
	"workforce.relation.sister.suffix": "Sister's",
	"workforce.relation.grand_daughter": "Grand Daughter",
	"workforce.relation.grand_daughter.suffix": "Grand Daughter's",
	"workforce.relation.grand_son": "Grand Son",
	"workforce.relation.grand_son.suffix": "Grand Son's",
	"workforce.relation.grand_father": "Grand Father",
	"workforce.relation.grand_father.suffix": "Grand Father's",
	"workforce.relation.grand_mother": "Grand Mother",
	"workforce.relation.grand_mother.suffix": "Grand Mother's",
	"workforce.relation.illigitimate_daughter": "Illigitimate Daughter",
	"workforce.relation.illigitimate_son": "Illigitimate Son",
	"workforce.uploadFile.dependent.photo": "Dependent's Photo",
	"workforce.uploadFile.dependent.nid_or_birthCcertificate": "Dependent's NID or Birth Certificate Photo",
	"workforce.employee.sameAsPresent": "Same as present location",
	"workforce.gender.male": "Male",
	"workforce.gender.female": "Female",
	"workforce.gender.other": "Other",
	"workforce.marital_status.single": "Single",
	"workforce.marital_status.married": "Married",
	"workforce.marital_status.widow": "Widow",
	"workforce.marital_status.widower": "Widower",
	"workforce.marital_status.remarried": "Remarried",
	"workforce.employee.city.road_no": "Road Number / Road Name",
	"workforce.employee.city.house_name": "House Number/ House Name",
	"workforce.employee.city.apartment_number": "Appartment Number",
	"workforce.employee.rural.address": "Address (Rural)",
	"workforce.employee.rural.house_name": "House / Holding Number",
	"workforce.employee.rural.village_road": "Village / Road",
	"workforce.employee.rural.para_mahalla": "Para / Mahalla",
	"workforce.employee.rural.post_office": "Post Office",
	"workforce.applicant.labourHeadingOne": "Applicant's personal info",
	"workforce.applicant.labourHeadingTwo": "Applicant's family info",
	"workforce.previewDetails.applicantInfo": "Applicant info",
	"workforce.applicant.workInfo.title": "Required Information for Workers in Formal/Informal Sectors",
	"workforce.applicant.workInfo.formal.institution_name": "Institution Name",
	"workforce.applicant.workInfo.formal.institution_address": "Institution Address",
	"workforce.applicant.workInfo.informal.current_occupation": "Current Occupation",
	"workforce.applicant.workInfo.informal.workplace": "Workplace",
	"workforce.applicant.workInfo.formal": "Formal",
	"workforce.applicant.workInfo.informal": "Informal",
	"core.LoginPage.loginBtn": "Log in",
	"workforce.dead": "Dead",
	"workforce.account.entry": "",
	"core.error.required": "Required field",
	"core.error.phoneNumberLength": "Phone number must be exactly 11 digits",
	"core.error.nidLength": "NID/Birth Certificate number must be 10, 13 or 17 digits.",
	"core.error.nid.repeat": "The same NID number cannot be used for multiple dependents.",
	"core.error.workerAge": "A worker’s age must be a minimum of 16 years.",
	"core.error.lastCheckup.between150days": "last doctor visiting date should not be more than 105 days",
	"core.error.applicantAge": "A applicant’s age must be a minimum of 12 years.",
	"core.error.deathTime": "Death date is not valid",
	"core.error.dateTime": "Date is not valid",
	"core.error.accidentDate": "Accident date is not valid",
	"core.error.accountNumberLength": "Account number must be 8 to 17",
	"core.error.generel": "Please check that you have filled in all the required information correctly.",
	"core.error.inEligible.dependent": "You were not considered a suitable dependent.",
	"workforce.employee.accident.info.hasRejoined": "Have you rejoined the workplace after recovery?",
	"workforce.previewDetails.uploadedBy.applicant": "Uploaded by Applicant",
	"workforce.previewDetails.uploadedBy.factoryAdmin": "Uploaded by Factory Admin",
	"workforce.register.button": "নিবন্ধন করুন",
	"workforce.select.postOffice": "Post Office",
	"calendar.clearButton": "Clear",
	"workforce.application.forward.message": "Are you sure you want to forward these applications?",
	"workforce.application.forward.message.toAssociation": "Are you sure you want to forward these applications to Association?",
	"workforce.application.forward.message.toSectionAdmin": "Are you sure you want to forward these applications to Section Admin?",
	"workforce.application.forward.message.toSectionUser": "Are you sure you want to forward these applications to Section Data Entry Operator?",
	"workforce.application.forward.message.toDoctor": "Are you sure you want to forward these applications to Doctor?",
	"workforce.application.sign.message.toEisCoordinator": "Are you sure you want to apply your recommendation for this application?",
	"workforce.application.forward.message.toEisCoordinator": "Are you sure you want to forward these applications to EIS Pilot?",
	"workforce.application.forward.message.new.toEisCoordinator": "Do You Want to Forward Application?",
	"workforce.application.forward.message.withoutCompensation.toEisCoordinator": "No Compensation Information provided. Do you want to proceed without adding compensation details?",
	"workforce.application.forward.message.withoutCompensation.eisOfficer.toEisCoordinator": "Please select the Compensation option (Yes or No) before proceeding.",
	"workforce.application.forward.message.toEisCommittee": "Are you sure you want to forward these applications to EIS Committe?",
	"workforce.application.select.message": "Are you sure you want to select these applications?",
	"workforce.application.approve.message": "Are you sure you want to recommend these applications?",
	"workforce.application.doctorapplicationview.approve.message": "Do you want to confirm the disability rate?",
	"workforce.application.reject.message": "Are you sure you want to reject this application?",
	"workforce.confirm.modal.ok": "OK",
	"workforce.modal.print": "Print",
	"workforce.modal.print.advice": "Print Advice",
	"workforce.modal.save.advice": "Save Advice",
	"workforce.modal.print.noa": "Print NOA",
	"workforce.modal.excel": "Export Excel",
	"workforce.modal.word": "Export Word",
	"workforce.modal.close": "Close",
	"workforce.financialAssistance.error.message": "An application has already been submitted for death",
	"workforce.application.info": "Application Info",
	"core.table.resultsLoading": "Loading...",
	"workforce.selectAll": "Select All",
	"workforce.clearSelected": "Clear Selection",
	"workforce.confirm.modal.cancel": "CANCEL",
	"workforce.select.time.range": "Select Time Range",
	"workforce.from.date": "From Date",
	"workforce.to.date": "To Date",
	"workforce.dashboard.application.types": "Application Types",
	"workforce.dashboard.applicant.types": "Applicant Types",
	"workforce.dashboard.financial.info": "Financial Info",
	"workforce.application.dashboard": "Application Dashboard",
	"workforce.application.approved": "Approved Applications",
	"workforce.application.forwarded": "Recommended Applications",
	"workforce.dashboard.total.beneficiary.amount": "Total Beneficiary Amount",
	"core.roleManagement.label": "Role Management",
	"profile.otherNames": "Name BN",
	"profile.lastName": "Name EN",
	"workforce.factoryAdmin.employee.lastAmount": "Last basic salary",
	"workforce.employee.application.printAndForwardToDirector": "Print and send to the director",
	view: view$1,
	reject: reject$1,
	resend: resend$1,
	revert: revert$1,
	forward: forward$1,
	verify: verify$1,
	approve: approve$1,
	"workforce.user.name": "Name",
	"workforce.user.role": "Role",
	"workforce.user.role.admin": "Director General",
	"workforce.user.role.director": "Director",
	"workforce.user.role.factoryAdmin": "Factory Admin",
	"workforce.user.role.bgmeaAssociation": "BGMEA Association",
	"workforce.user.role.bkmeaAssociation": "BKMEA Association",
	"workforce.user.role.sectionAdmin": "Section Admin",
	"workforce.user.role.checker": "Checker",
	"workforce.user.role.checkerTwo": "Checker Two",
	"workforce.user.role.doctor": "Doctor",
	"workforce.user.role.approver": "Approver",
	"workforce.user.role.applicant": "Applicant",
	"workforce.user.role.secretary": "Secretary",
	"workforce.application.rejectReason": "Rejection Reason",
	"workforce.application.proposedAmount.byDoctor": "Proposed grant amount based on medical condition",
	"workforce.application.diagnosis.byDoctor": "Diagnosis Info",
	"workforce.application.lastBaseSalary.byFactoryAdmin": "Last gross salary for the month of the accident",
	"workforce.dependent.isDisabled": "Is the Dependent disable?",
	"workforce.dependent.disabilityType": "Describe Disability type",
	"workforce.eis.factory.admin.accidentInfo.button": "Accident and Medical Details",
	"workforce.eis.coordinator.accidentInfo.button.disability": "Disability Assesment Meeting",
	"workforce.application.acknowledgement.text": "I hereby affirm that all information given above is correct & complete.",
	"workforce.application.accident.otherAccidentType": "Describe other accident type",
	"workforce.application.progressMovement": "Application Movement Progress",
	"workforce.accident.mainType.workplace": "Workplace Accident",
	"workforce.accident.mainType.onDutyRTA": "On Duty RTA",
	"workforce.accident.mainType.commuting": "Commuting Accident",
	"workforce.accident.dailyDutyStart.label": "Daily Duty Schedule (Start)",
	"workforce.accident.dailyDutyEnd.label": "Daily Duty Schedule (End)",
	"workforce.accident.outsideDutyExplanation.label": "Explanation for Accident Occurring Outside Official Duty Hours",
	"workforce.accident.specificType.label": "Type of Accident (Workplace Specific)",
	"workforce.accident.otherAccidentType.label": "Specify Other Accident Type",
	"workforce.accident.dutyStatusWorkplace.label": "Duty Status (Workplace Accident)",
	"workforce.accident.outOfFactoryPlace.label": "Specify the Place of Accident (Outside Factory)",
	"workforce.accident.journeyStartTime.label": "Approximate Starting Time of Journey",
	"workforce.accident.journeyStartPoint.label": "Starting Point of Journey",
	"workforce.accident.journeyDestination.label": "Destination of Journey",
	"workforce.accident.modeOfTravel.label": "Mode of Travelling",
	"workforce.accident.roadDescription.label": "Description of the Road Used by the Worker",
	"workforce.accident.dutyStatusRTA.label": "Duty Status (On Duty RTA)",
	"workforce.accident.travelPurpose.label": "Purpose of Travelling",
	"workforce.accident.workEngagedIn.label": "What work was the worker engaged in at the time of the accident?",
	"workforce.accident.regularTravel.label": "Is the Employee Regularly Travel for this purpose?",
	"workforce.accident.officialOrderIssued.label": "Any Official Order was Issued (Gate Pass, Challan, etc.)?",
	"workforce.accident.officialOrderCopy.label": "Upload Official Order Copy",
	"workforce.accident.detailsOfAccident.label": "Details of the Accident",
	"workforce.accident.otherInjured.label": "Was anyone else injured in this accident?",
	"workforce.accident.otherInjuredName.label": "Name of Injured Person",
	"workforce.accident.otherInjuredDesignation.label": "Designation",
	"workforce.accident.otherInjuredPhone.label": "Phone Number",
	"workforce.accident.otherInjuredType.label": "Type of Injury",
	"workforce.accident.otherInjuredBenefit.label": "Have you applied for any benefit for this worker?",
	"workforce.accident.otherInjuredTracking.label": "Tracking Number (if benefit applied)",
	"workforce.disability.assessmentDetails": "Assesment Details",
	"workforce.disability.dateOfAssessment": "Date of Assessment ",
	"workforce.disability.nameOfAssessmentMeeting": "Name of the Assessment Meeting ",
	"workforce.disability.briefInjuryDescription": "Brief Description of the Injury from the Accident/Incidents as per Doctor’s Prescription",
	"workforce.disability.briefTreatmentDescription": "Brief Description of the Treatment including any Surgery/Medication/Therapy as per Doctor’s Prescription",
	"workforce.disability.physicalExamination": "Physical Examination Findings",
	"workforce.disability.injurySiteLocation": "Injury Site/Location",
	"workforce.disability.injuryDetailsDescription": "Injury detains and Description",
	"workforce.disability.observationCurrentCondition": "Observation After Evaluating the Current Condition of Employee",
	"workforce.disability.limitationsOccupationDailyLiving": "Limitations in Occupation and Activities of Daily Living",
	"workforce.accident.officialComplaint.label": "Was any official complaint filed? (GD/FIR/Postmortem)",
	"workforce.accident.hospitalized.label": "Was the worker admitted to hospital?",
	"workforce.accident.hospitalName.label": "Name of Hospital",
	"workforce.accident.admitDate.label": "Date of Admission",
	"workforce.accident.admitTime.label": "Time of Admission",
	"workforce.accident.hospitalAddress.label": "Hospital Address",
	"workforce.accident.releaseDate.label": "Date of Release/Discharge",
	"workforce.accident.hospitalDoctorName.label": "Doctor's Name (Hospital)",
	"workforce.dependent.eis.eligible": "Eligible",
	"workforce.dependent.eis.inEligible": "Ineligible",
	"workforce.other.compensationInfo": "Compensation Info",
	"workforce.compensation.add": "Add Another Compensation",
	"workforce.compensation.date": "Date of Compensation",
	"workforce.compensation.recievedFrom": "Name of the organization receiving compensation",
	"workforce.compensation.paymentStatus": "Status of payment",
	"workforce.compensation.remarks": "Remarks",
	"workforce.compensation.eligible.ForEISAdjustment": "Eligible for EIS Benefit Adjustment",
	"workforce.paid": "Paid",
	"workforce.unpaid": "Not Paid yet",
	"workforce.processing": "Loading ...",
	"workforce.employee.application.eisApproval.signature": "EIS Approval Signature",
	"workforce.employee.application.eisApproval": "Beneficairy Approval Note",
	"workforce.application.before.association.startDate.error": "The date of the accident can't be later than the start date of the relevant association of the factory.",
	"workforce.application.before.deathDate.error": "The date of the accident cannot be later than the date of death.",
	"workforce.application.before.joiningDate.error": "The date of the accident cannot be earlier than the date of joining.",
	"workforce.application.factory.activation.error": "The factory is not yet operational.",
	"workforce.application.before.eis.startDate.error": "Applications are not allowed for incidents occurring before 21 June 2022 (EIS Pilot start date).",
	"workforce.accident.hospitalInfo.title": "Hospital Info",
	"workforce.accident.addHospital.btn": "Add Hospital Info",
	"workforce.add.hospital.info": "If treated at more than one hospital, click here",
	"workforce.dependent.eligibility.btn": "Save All Dependents",
	"workforce.update.btn": "Update",
	"worforce.dependent.suffix": "'s",
	"workforce.login_name_already_exists": "NID/BirthCertificate number already registered",
	"workforce.phone_number_already_exists": "Phone number already registered",
	"workforce.application.duplicate.found": "A duplicate application already exists for this worker. You will be redirected to the home page.",
	"workforce.accident.placeOfDeath.label": "Place of Death",
	"workforce.accident.dateOfDeath.label": "Date of Death",
	"workforce.accident.timeOfDeath.label": "Time of Death",
	"workforce.accident.mainType.label": "Type of Accident",
	"workforce.application.steps.bankInfo": "Bank Info",
	"workforce.dashboard.overallFilters": "Overall Filters",
	"workforce.dashboard.appSubmissionDate": "Application Submission Date",
	"workforce.dashboard.accidentDate": "Accident Date",
	"workforce.dashboard.allAssociations": "All Associations",
	"workforce.dashboard.filter.all": "All",
	"workforce.dashboard.lastMeetingOverview": "Overview of Last Meetings",
	"workforce.dashboard.lastMeeting.presented": "Total number of applications presented",
	"workforce.dashboard.lastMeeting.approved": "Total number of approved applications",
	"workforce.dashboard.lastMeeting.rejected": "Total number of rejected applications",
	"workforce.dashboard.lastMeeting.reverted": "Total number of reverted applications",
	"workforce.dashboard.ongoingMeetingOverview": "Ongoing Meeting Overview",
	"workforce.dashboard.ongoingMeeting.caseType": "Case Type:",
	"workforce.dashboard.ongoingMeeting.deathCount": "Death count",
	"workforce.dashboard.ongoingMeeting.disabilityCount": "Disability count",
	"workforce.dashboard.ongoingMeeting.accidentType": "Accident Type:",
	"workforce.dashboard.ongoingMeeting.commutingCount": "Commuting count",
	"workforce.dashboard.ongoingMeeting.workplaceCount": "Workplace count",
	"workforce.dashboard.ongoingMeeting.rtaCount": "On-duty RTA count",
	"workforce.dashboard.financialOverview": "Financial Overview",
	"workforce.dashboard.financial.paidTillNow": "Total Paid Till Now",
	"workforce.dashboard.financial.deathTotal": "Death total amount",
	"workforce.dashboard.financial.disabilityTotal": "Disability total amount",
	"workforce.dashboard.financial.approxLifetime": "Total Approx Lifetime",
	"workforce.dashboard.appSegregation": "Application Segregation Based on approval",
	"workforce.dashboard.accidentVsTime": "Accident vs time graph",
	"workforce.dashboard.pipeline": "Pipeline Applications",
	"workforce.dashboard.pipeline.subtitle": "How many applications are waiting at which level",
	"workforce.dashboard.pipeline.factory": "Waiting at Factory Level",
	"workforce.dashboard.pipeline.association": "Waiting at Association Level",
	"workforce.dashboard.pipeline.eis": "Waiting at EIS Level",
	"workforce.dashboard.pending": "Pending Applications",
	"workforce.dashboard.pending.subtitle": "Applications that are not approved yet",
	"workforce.dashboard.pending.verified": "Verified Applications",
	"workforce.dashboard.pending.nonVerified": "Non-verified applications",
	"workforce.dashboard.pending.death": "Death count",
	"workforce.dashboard.pending.disability": "Disability count",
	"workforce.dashboard.overview": "Application Overview",
	"workforce.dashboard.overview.subtitle": "Fetch only approved applications",
	"workforce.dashboard.overview.death": "Death",
	"workforce.dashboard.overview.disability": "Disability",
	"workforce.dashboard.overview.deadMale": "Dead Male Worker",
	"workforce.dashboard.overview.deadFemale": "Dead Female Worker",
	"workforce.dashboard.overview.maleWorker": "Male Worker Count",
	"workforce.dashboard.overview.femaleWorker": "Female Worker Count",
	"workforce.dashboard.beneficiary": "Beneficiary Overview",
	"workforce.dashboard.beneficiary.subtitle": "Only approved applications (Click to manage)",
	"workforce.dashboard.beneficiary.male": "Male Beneficiary Count",
	"workforce.dashboard.beneficiary.female": "Female Beneficiary Count",
	"workforce.dashboard.beneficiary.total": "Total Beneficiary Count",
	"workforce.dashboard.accidentSegregation": "Accident Type Segregation",
	"workforce.dashboard.accidentSegregation.subtitle": "Only approved applications",
	"workforce.dashboard.accidentSegregation.workplace": "Workplace accident",
	"workforce.dashboard.accidentSegregation.commuting": "Commuting accident",
	"workforce.dashboard.accidentSegregation.rta": "On Duty RTA",
	"workforce.dashboard.monitoring": "Beneficiary Monitoring",
	"workforce.dashboard.monitoring.almost18": "Almost 18 years old (17 to < 18)",
	"workforce.dashboard.monitoring.adultFemale": "Adult Female Unmarried",
	"workforce.dashboard.monitoring.elderly": "Elderly Beneficiaries (> 60 Years)",
	"workforce.dashboard.monitoring.widowUnder35": "Widow/Widower under 35 years",
	"workforce.dashboard.verification": "Beneficiary Verification Overview",
	"workforce.dashboard.verification.pending1m": "Pending live verifications (1 month)",
	"workforce.dashboard.verification.pending3m": "Pending live verifications (3 months)",
	"workforce.dashboard.verification.pending6m": "Pending live verifications (6 months)",
	"workforce.dashboard.verification.pending9m": "Pending live verifications (9 months)",
	"workforce.dashboard.verification.successful": "Successful Live Verifications",
	"workforce.dashboard.marriage": "Marriage Status Overview",
	"workforce.dashboard.marriage.widow": "Unmarried Widow",
	"workforce.dashboard.marriage.widower": "Unmarried Widower",
	"workforce.dashboard.marriage.sister": "Unmarried Sister",
	"workforce.dashboard.marriage.daughter": "Unmarried Daughter",
	"workforce.dashboard.marriage.grandDaughter": "Unmarried Grand-daughter",
	"workforce.dashboard.payment": "Monthly Payment Status Counts",
	"workforce.dashboard.payment.subtitle": "Current Month of Current Year",
	"workforce.dashboard.payment.disbursed": "Payment Disbursed",
	"workforce.dashboard.payment.pending": "Payment Pending (Not disbursed)",
	"workforce.dashboard.payment.onHold": "Payment On Hold",
	"workforce.dashboard.months.1": "1 Month",
	"workforce.dashboard.months.3": "3 Months",
	"workforce.dashboard.months.6": "6 Months",
	"workforce.dashboard.months.12": "12 Months",
	"workforce.dashboard.fund.all": "All Funds",
	"workforce.dashboard.fund.cf": "Central Fund",
	"workforce.dashboard.fund.blwf": "Bangladesh Labour Welfare Foundation",
	"workforce.dashboard.fund.eis": "Employee Injury Scheme",
	"workforce.dashboard.chart.processing": "Processing",
	"workforce.dashboard.chart.approved": "Approved",
	"workforce.dashboard.chart.reverted": "Reverted",
	"workforce.dashboard.chart.medical": "Medical",
	"workforce.dashboard.chart.educational": "Educational",
	"workforce.dashboard.chart.maternity": "Maternity",
	"workforce.dashboard.chart.disability": "Permanent Or Curable Disability",
	"workforce.dashboard.chart.numberAccidents": "Number of accidents",
	"workforce.dashboard.assessments.previous": "Previous Assessments' overview",
	"workforce.dashboard.assessments.ongoing": "Ongoing Assessments' Overview",
	"workforce.dashboard.assessments.total": "Total assessments",
	"workforce.dashboard.assessments.byGender": "By Gender",
	"workforce.dashboard.assessments.byAccidentType": "By Accident Types",
	"workforce.dashboard.assessments.maleCount": "Male count",
	"workforce.dashboard.assessments.femaleCount": "Female count",
	"workforce.dashboard.assessments.maleOnly": "Male",
	"workforce.dashboard.assessments.femaleOnly": "Female",
	"workforce.dashboard.assessments.commuting": "Commuting",
	"workforce.dashboard.assessments.workplace": "Workplace accident",
	"workforce.dashboard.assessments.rta": "On duty RTA",
	"workforce.doctor.discussionRequired": "Discussion needed",
	"workforce.doctor.rejectRequest": "Reject",
	"workforce.doctor.recommend": "Recommend",
	"workforce.application.beneficiaryManagement": "Beneficiary Management",
	"workforce.application.beneficiaryPaymentProcess": "Beneficiary Payment Process",
	"workforce.application.beneficiaryDisbursedPayments": "Beneficiary Disbursed Payments",
	"workforce.application.beneficiaryNoaConfirmation": "NOA Confirmation",
	"workforce.application.beneficiaryProcessedPaymentList": "Processed Payments",
	"workforce.application.beneficiaryPayments": "Beneficiary Payments",
	"workforce.modal.saveCalculation": "Save Calculation",
	"workforce.modal.recalculate": "Recalculate",
	"workforce.dashboard": "Dashboard",
	"menu.workforce.association.user.map": "Association User Mapping",
	"workforce.application.beneficiaryBankAdviceList": "Generated Bank Advice List",
	"menu.workforce.committee.management": "Committee Management",
	"workforce.generateBFTN.beneficiary.payment.calculation": "Beneficiary Payment Calculation",
	"workforce.generate.committee.report": "Generate Committee Report",
	"workforce.factory.edit.title": "Edit Factory",
	"workforce.factory.basicInfo": "Basic Information",
	"workforce.factory.contactInfo": "Contact Information",
	"workforce.factory.licenseType": "License Type",
	"workforce.factory.locationInfo": "Location Information",
	"workforce.factory.officeLocation": "Office Location",
	"workforce.factory.officeAddress": "Office Address",
	"workforce.factory.registrationInfo": "Registration Information",
	"workforce.factory.dateOfEstablishment": "Date of Establishment",
	"workforce.factory.eisIncorporationDate": "EIS Incorporation Date",
	"workforce.factory.registrationDate": "Registration Date",
	"workforce.factory.registrationExpiryDate": "Registration Expiry Date",
	"workforce.factory.limaRegistrationNumber": "Lima Registration Number",
	"workforce.factory.licenseNumber": "License Number",
	"workforce.factory.additionalDetails": "Additional Details",
	"workforce.factory.numberOfEmployees": "Approximate Number of Employees",
	"workforce.factory.membershipNumber": "Membership Number",
	"workforce.factory.groupName": "Group Name",
	"workforce.factory.representativeInfo": "Representative Information",
	"workforce.factory.updateSuccessful": "Factory updated successfully",
	"workforce.factory.back": "Back to Factories",
	"workforce.factory.details": "Factory Details",
	"workforce.factory.uploadedDocuments": "Uploaded Documents",
	"workforce.factory.uploadDocuments": "Upload Factory Documents",
	"workforce.factory.noDocuments": "No documents uploaded for this factory",
	"workforce.factory.documentType": "Document Type",
	"workforce.factory.documentFile": "File Name",
	"workforce.factory.documentStatus": "Status",
	"workforce.factory.documentAction": "Action",
	"workforce.factory.viewDocument": "See Document",
	"workforce.factory.approveFactory": "Approve Factory",
	"workforce.factory.confirmApproval": "Confirm Approval",
	"workforce.factory.approveConfirmMsg": "Are you sure you want to approve this factory?",
	"workforce.factory.approveConfirmDesc": "This action will change the factory status to \"active\".",
	"workforce.factory.approving": "Approving...",
	"workforce.factory.confirm": "Confirm",
	"workforce.factory.cancel": "Cancel",
	"workforce.factory.uploaded": "Uploaded",
	"workforce.factory.downloadDocument": "Download Document",
	"workforce.factory.currentDocuments": "Current Documents",
	"workforce.factory.uploadDocumentsHelp": "Upload new documents for this factory. Choose the document type before uploading.",
	"menu.website.legal.guidelines": "Legal Guidelines Management For Website",
	"menu.website.visitor.messages": "Visitor Messages From Website",
	"workforce.processing.data": "Data is processing",
	"workforce.please.wait": "Please wait",
	"workforce.confirm.modal.ok.notEis": "Submit",
	"workforce.application.photo.cropandupload": "CROP & UPLOAD",
	"workforce.application.photo.cropmessage": "You need to crop your selected image to passport size.",
	"workforce.reject.reason": "Add Reject Reason",
	"workforce.reject.reason.placeholder": "Enter reject reason...",
	"workforce.application.rejected": "Rejected Applications",
	"workforce.previous.history.button": "Previous application information",
	"workforce.previous.history.list": "List of previous applications",
	"workforce.accidentType.insideFactory": "Inside the factory",
	"workforce.accidentType.fromWorkplaceToHome": "On the way from workplace to home",
	"workforce.accidentType.fromHomeToWorkplace": "On the way from home to workplace",
	"workforce.accidentType.workRelatedTravel": "On the way to/from another place for official work",
	"workforce.accidentType.otherPlace": "Other place"
};

var mainMenuGrievance = "অভিযোগ";
var resetFilterTooltip = "ফিল্টার রিসেট করুন";
var refreshFilterTooltip = "অনুসন্ধান করুন";
var view = "দেখুন";
var reject = "প্রত্যাখ্যান";
var resend = "পুনরায় পাঠান";
var revert = "ফেরত দিন";
var forward = "অগ্রসর করুন";
var verify = "যাচাই করুন";
var approve = "অনুমোদন করুন";
var messages_bn = {
	"location.HealthFacilityFullPath.district": "বিভাগ",
	"location.RegionPicker.label": "বিভাগ",
	"location.DistrictPicker.label": "জেলা/সিটি কর্পোরেশন",
	"location.Location2Picker.label": "উপজেলা/থানা/পৌরসভা",
	"location.Location3Picker.label": "ইউনিয়ন/ওয়ার্ড",
	"location.Location4Picker.label": "পোস্ট অফিস",
	"location.locationType.0": "বিভাগ",
	"location.locationType.0.placeholder": "বিভাগ খুজুন...",
	"location.locationType.1": "জেলা/সিটি কর্পোরেশন",
	"location.locationType.1.placeholder": "জেলা খুজুন...",
	"location.locationType.2": "উপজেলা/থানা/পৌরসভা",
	"location.locationType.3": "ইউনিয়ন/ওয়ার্ড",
	"location.locationType.4": "পোস্ট অফিস",
	"location.locationType.0.children": "জেলা, উপজেলা ও ইউনিয়ন",
	"location.locationType.1.children": "ইউনিয়ন",
	"location.locationType.2.children": "ইউনিয়ন",
	"location.locationType.0.directChildren": "জেলা/সিটি কর্পোরেশন",
	"location.locationType.1.directChildren": "উপজেলা/থানা/পৌরসভা",
	"location.locationType.2.directChildren": "ইউনিয়ন/ওয়ার্ড",
	"location.locations.searcher.title.0": "বিভাগ",
	"location.locations.searcher.title.1": "জেলা/সিটি কর্পোরেশন",
	"location.locations.searcher.title.2": "উপজেলা/থানা/পৌরসভা",
	"location.locations.searcher.title.3": "ইউনিয়ন/ওয়ার্ড",
	"location.locations.searcher.title.4": "পোস্ট অফিস",
	"location.locations.searcher.title.3.catchments": "ইউনিয়ন/ওয়ার্ড",
	"location.locationType.R": "বিভাগ",
	"location.locationType.D": "জেলা/সিটি কর্পোরেশন",
	"location.locationType.W": "উপজেলা/থানা/পৌরসভা",
	"location.locationType.V": "ইউনিয়ন/ওয়ার্ড",
	"location.locationType.O": "পোস্ট অফিস",
	"core.Autocomplete.loadingText": "লোডিং...",
	"core.table.resultsLoading": "লোডিং...",
	"admin.UserPicker.loadingText": "লোডিং...",
	"admin.EnrolmentOfficerPicker.loadingText": "লোডিং...",
	"location.LocationPicker.loadingText": "লোডিং...",
	"workforce.employee.accident.info.injuryType": "ক্ষতি ধরন",
	"workforce.employee.accident.info.joiningDate": "শ্রমিকের যোগদানের তারিখ",
	"workforce.employee.accident.info.dateOfAccident": "দুর্ঘটনার তারিখ",
	"workforce.employee.accident.info.timeOfAccident": "দুর্ঘটনার সময়",
	"workforce.employee.accident.info.typeOfAccident": "দুর্ঘটনার ধরন",
	"workforce.employee.accident.info.dutyStatus": "ডিউটি ​​স্ট্যাটাস/কর্তব্যের অবস্থা",
	"workforce.employee.accident.info.insideOutsideFactory": "কোন পরিস্থিতিতে দুর্ঘটনা হয়েছে?",
	"workforce.employee.accident.info.reJoiningDate": "সুস্থ হওয়ার পরে পুনরায় কর্মস্থলে যোগদানের তারিখ",
	"workforce.employee.accident.info.breifInfo": "দুর্ঘটনা/ঘটনার সংক্ষিপ্ত বিবরণ",
	"workforce.employee.accident.info.breifDoctorsPrescriptionInfo": "ডাক্তারের প্রেসক্রিপশন অনুযায়ী দুর্ঘটনা/ঘটনা থেকে প্রাপ্ত আঘাতের সংক্ষিপ্ত বিবরণ",
	"workforce.employee.accident.info.injurySite": "আঘাতের স্থান/অবস্থান",
	"workforce.employee.accident.info.injuryDescription": "আঘাতের বিস্তারিত ও বিবরণ",
	"workforce.employee.accident.info.disAbilityEffect": "পেশা ও দৈনন্দিন জীবনের কার্যক্রমে সীমাবদ্ধতা?",
	"workforce.employee.accident.info.presentInjuryBLASchedule1": "বর্তমান আঘাত বিএলএ সূচি ১ এর ক্রমিক নং অনুযায়ী",
	"workforce.employee.accident.info.disabilityPerSchedule": "অক্ষমতা (উপার্জন হ্রাস) % বিএলএ সূচি ১ অনুযায়ী",
	"workforce.employee.workforce_employer": "নিয়োগকারী কোম্পানির নাম",
	"workforce.employee.workforce_office": "অফিস",
	"workforce.employee.workforce_factory": "শ্রমিকের কর্মরত প্রতিষ্ঠান / কারখানার নাম",
	"workforce.employee.first.name.en": "নাম (ইংরেজি)",
	"workforce.employee.last.name.en": "শেষ নাম (ইংরেজি)",
	"workforce.employee.first.name.bn": "নাম (বাংলা)",
	"workforce.employee.last.name.bn": "শেষ নাম (বাংলা)",
	"workforce.employee.other.name": "অন্য নাম",
	"workforce.employee.location": "ঠিকানা",
	"workforce.employee.address": "ঠিকানা",
	"workforce.employee.phone": "ফোন নম্বর",
	"workforce.employee.email": "ই-মেইল",
	"workforce.employee.occupation": "পেশা",
	"workforce.employee.gender": "লিঙ্গ",
	"workforce.employee.birthdate": "জন্ম তারিখ",
	"workforce.employee.joindate": "যোগদানের তারিখ",
	"workforce.employee.deathdate": "মৃত্যুর তারিখ",
	"workforce.employee.date": "তারিখ",
	"workforce.employee.nid": "এনআইডি",
	"workforce.employee.employee_type": "টাইপ",
	"workforce.employee.birth_certificate_no": "জন্ম সনদ নং",
	"workforce.employee.passport_no": "পাসপোর্ট নং",
	"workforce.employee.fathers_name.bn": "পিতার নাম (বাংলা)",
	"workforce.employee.fathers_name.en": "পিতার নাম (ইংরেজি)",
	"workforce.employee.fathers_name": "পিতার নাম",
	"workforce.employee.mothers_name.bn": "মাতার নাম (বাংলা)",
	"workforce.employee.mothers_name.en": "মাতার নাম (ইংরেজি)",
	"workforce.employee.mothers_name": "মাতার নাম",
	"workforce.employee.spouse.name.bn": "স্বামী/স্ত্রীর নাম (বাংলা)",
	"workforce.employee.spouse.name": "স্বামী/স্ত্রীর নাম",
	"workforce.employee.spouse.name.en": "স্বামী/স্ত্রীর নাম (ইংরেজি)",
	"workforce.employee.marital_status": "বৈবাহিক অবস্থা",
	"workforce.employee.percentage_of_cf_grant": "কেন্দ্রীয় তহবিলের অনুদানের শতকরা হার",
	"workforce.employee.eis.percentage_of_cf_grant": "ই.আই.এস. অনুদানের শতকরা হার",
	"workforce.employee.position": "বর্তমান ঠিকানা",
	"workforce.employee.monthly_earning": "মাসিক আয়",
	"workforce.employee.reference_salary": "রেফারেন্স বেতন",
	"workforce.employee.present_address": "ঠিকানা",
	"workforce.employee.permanent_address": "ঠিকানা",
	"workforce.employee.present_location": "বর্তমান ঠিকানা",
	"workforce.employee.permanent_location": "স্থায়ী ঠিকানা",
	"workforce.employee.status": "অবস্থা",
	"workforce.employee.citizenship": "নাগরিকত্ব",
	"workforce.employee.privacyLaw": "গোপনীয়তা আইন",
	"workforce.employee.insurance_number": "বীমা নম্বর",
	"workforce.employee.lifeStatus": "জীবন অবস্থা",
	"workforce.employee.factory.nid": "এনআইডি",
	"workforce.employee.application.addNewTooltip": "আবেদন করুন",
	"workforce.employee.application.workforce_employer": "নিয়োগকর্তা/কোম্পানী",
	"workforce.employee.application.workforce_office": "অফিস",
	"workforce.employee.application.workforce_factory": "শ্রমিকের কর্মরত প্রতিষ্ঠান / কারখানার",
	"workforce.employee.application.first.name.en": "নাম (ইংরেজি)",
	"workforce.employee.application.last.name.en": "শেষ নাম (ইংরেজি)",
	"workforce.employee.application.first.name.bn": "নাম (বাংলা)",
	"workforce.employee.application.last.name.bn": "শেষ নাম (বাংলা)",
	"workforce.employee.application.other.name": "অন্য নাম",
	"workforce.employee.application.location": "ঠিকানা",
	"workforce.employee.application.address": "ঠিকানা",
	"workforce.employee.application.phone": "ফোন নম্বর",
	"workforce.employee.application.applicationType": "আবেদনের ধরন",
	"workforce.employee.application.organizationType": "তহবিল",
	"workforce.employee.application.associationType": "অ্যাসোসিয়েশনের ধরন",
	"workforce.employee.application.email": "ই-মেইল",
	"workforce.employee.application.occupation": "পেশা",
	"workforce.employee.application.gender": "লিঙ্গ",
	"workforce.employee.application.birthdate": "জন্ম তারিখ",
	"workforce.employee.application.joindate": "যোগদানের তারিখ",
	"workforce.employee.application.deathdate": "মৃত্যুর তারিখ",
	"workforce.employee.application.nid": "এনআইডি",
	"workforce.employee.application.employee_type": "টাইপ",
	"workforce.employee.application.birth_certificate_no": "জন্ম সনদ নং",
	"workforce.employee.application.passport_no": "পাসপোর্ট নং",
	"workforce.employee.application.fathers_name.bn": "পিতার নাম (বাংলা)",
	"workforce.employee.application.fathers_name.en": "পিতার নাম (ইংরেজি)",
	"workforce.employee.application.mothers_name.bn": "মাতার নাম (বাংলা)",
	"workforce.employee.application.mothers_name.en": "মাতার নাম (ইংরেজি)",
	"workforce.employee.application.spouse.name.bn": "স্বামী/স্ত্রীর নাম (বাংলা)",
	"workforce.employee.application.spouse.name.en": "স্বামী/স্ত্রীর নাম (ইংরেজি)",
	"workforce.employee.application.marital_status": "বৈবাহিক অবস্থা",
	"workforce.employee.application.position": "Position",
	"workforce.employee.application.monthly_earning": "মাসিক আয়",
	"workforce.employee.application.reference_salary": "Reference Salary",
	"workforce.employee.application.present_address": "বর্তমান ঠিকানা",
	"workforce.employee.application.permanent_address": "স্থায়ী ঠিকানা",
	"workforce.employee.application.status": "অবস্থা",
	"workforce.employee.application.revertNote": "প্রত্যাবর্তিত মন্তব্য",
	"workforce.employee.application.revert": "ফেরত পাঠান",
	"workforce.employee.application.revert.further.investigation": "পুনঃনিরীক্ষণ",
	"workforce.employee.application.applicationDate": "আবেদনের তারিখ",
	"workforce.employee.application.currentStatus": "বর্তমান অবস্থা",
	"workforce.employee.application.assignedBy": "দ্বারা নির্ধারিত",
	"workforce.employee.application.assignedDate": "নির্ধারিত তারিখ",
	"workforce.employee.application.citizenship": "নাগরিকত্",
	"workforce.employee.application.privacyLaw": "গোপনীয়তা আইন",
	"workforce.employee.application.insurance_number": "বীমা নম্বর",
	"workforce.employee.application.lifeStatus": "জীবন অবস্থা",
	"workforce.employee.application.process": "আবেদনসমূহ",
	"workforce.employee.application.forwardTo": "ফরোয়ার্ড করুন",
	"workforce.employee.application.addApplication": "আবেদন যোগ করুন",
	"workforce.employee.application.moneyAmount": "টাকার পরিমাণ",
	"workforce.employee.application.verifier": "যাচাইকারী",
	"workforce.employee.application.factoryName": "ফ্যাক্টরীর নাম",
	"workforce.employee.application.serviceProviderName": "সেবাদানকারী প্রতিষ্ঠানের নাম",
	"workforce.employee.application.totalAmount": "মোট আবেদনকৃত অর্থ:",
	"workforce.employee.application.tk": "টাকা",
	"workforce.employee.application.forward": "ফরওয়ার্ড করুন",
	"workforce.employee.application.forwardToDoctor": "ডক্টরের কাছে ফরওয়ার্ড করুন",
	"workforce.employee.application.forwardToAssociation": "বিবেচ্য আবেদন সমূহ অ্যাসোসিয়েশন অফিসে পাঠান",
	"workforce.employee.application.forwardToSelectionOffice": "নির্বাচিত আবেদনসমূহ যাচাই বাছাই কমিটিতে প্রেরণ করুন",
	"workforce.employee.application.forwardToSectionAdmin": "বিবেচিত আবেদনপত্রগুলি কল্যাণ শাখা বরাবর পাঠান",
	"workforce.employee.application.forwardToDG": "বিবেচিত আবেদনপত্রগুলি মহাপরিচালক বরাবর ফরোয়ার্ড করুন",
	"workforce.employee.application.provideMeetingInfo": "মিটিং এর তথ্য দিন",
	"workforce.employee.application.preMeetingList": "পূর্ববর্তী মিটিং তালিকা",
	"workforce.employee.application.createMeetingSheet": "মিটিং পত্র তৈরি করুন",
	"workforce.employee.application.forwardPendingMeetingSheet": "অনিষ্পন্ন মিটিংগুলো ফরোয়ার্ড করুন",
	"workforce.employee.application.bulkForward": "বাল্ক ফরওয়ার্ড করুন",
	"workforce.employee.application.pendingMeetingSheet": "অনিষ্পন্ন মিটিং কার্যতালিকা",
	"workforce.employee.application.forwardedMeetingSheet": "প্রেরিত মিটিং কার্যতালিকা",
	"workforce.employee.application.meetingSheet": "আগত মিটিং কার্যতালিকা",
	"workforce.employee.application.meetingDate": "মিটিং তারিখ",
	"workforce.employee.application.sentMeetingSheet": "প্রেরিত আবেদন",
	"workforce.employee.application.approveMeetingSheet": "অনুমোদিত আবেদন",
	"workforce.employee.application.bulkSelect": "বাল্ক নির্বাচন করুন",
	"workforce.employee.application.bulkApprove": "বাল্ক অনুমোদন করুন",
	"workforce.employee.application.eis_advisor.recommended": "সুপারিশ করুন",
	"workforce.employee.application.eis_committee.recommended": "অনুমোদন",
	"workforce.employee.application.printAndForwardToDirector": "প্রিন্ট এবং পরিচালকের কাছে প্রেরণ",
	"workforce.employee.application.receivedDate": "প্রাপ্তির তারিখ",
	"workforce.employee.application.sentDate": "প্রেরণের তারিখ",
	"workforce.employee.application.sentTo": "প্রাপকের নাম",
	"workforce.employee.application.advisorApproveMeetingSheet": "স্পেশাল অ্যাডভাইজর এর অনুমোদিত আবেদন",
	"workforce.employee.application.paymentProcess": "পেমেন্ট ক্যালকুলেশন",
	"workforce.application.providePaymentInfo": "আপনি কি নির্বাচিত আবেদনসমূহের পেমেন্ট ক্যালকুলেশন সম্পন্ন করতে চান?",
	"workforce.application.educationInfo.boards.barisal": "বরিশাল",
	"workforce.application.educationInfo.boards.chattogram": "চট্টগ্রাম",
	"workforce.application.educationInfo.boards.cumilla": "কুমিল্লা",
	"workforce.application.educationInfo.boards.dhaka": "ঢাকা",
	"workforce.application.educationInfo.boards.dinajpur": "দিনাজপুর",
	"workforce.application.educationInfo.boards.jashore": "যশোর",
	"workforce.application.educationInfo.boards.mymensingh": "ময়মনসিংহ",
	"workforce.application.educationInfo.boards.rajshahi": "রাজশাহী",
	"workforce.application.educationInfo.boards.sylhet": "সিলেট",
	"workforce.application.educationInfo.boards.madrasha_board": "মাদ্রাসা বোর্ড",
	"workforce.application.educationInfo.boards.technical_board": "কারিগরি বোর্ড",
	"workforce.application.educationInfo.boards.open_board": "উন্মুক্ত বোর্ড",
	"workforce.application.educationInfo.passingYear": "পাসের বছর",
	"workforce.application.educationInfo.admissionYear": "ভর্তির বছর",
	"workforce.application.educationInfo.rollNo": "রোল নম্বর",
	"workforce.application.educationInfo.IdNo": "আইডি নম্বর",
	"workforce.application.educationInfo.regNo": "রেজিস্ট্রেশন নম্বর",
	"workforce.application.educationInfo.cgpa": "সিজিপিএ / জিপিএ",
	"workforce.application.educationInfo.board": "শিক্ষা বোর্ড",
	"workforce.application.educationInfo.university": "বিশ্ববিদ্যালয় / ইনস্টিটিউটের নাম",
	"workforce.application.steps.underGraduate": "স্নাতক বা সমমান",
	"workforce.application.steps.postGraduate": "মাস্টার্স বা সমমান",
	"menu.workforce": "কর্মশক্তি",
	"menu.factory.management": "কারখানা ম্যানেজমেন্ট",
	"menu.workforce.organizations": "সংস্থাসমূহ",
	"menu.workforce.organizations.unit": "সংস্থার ইউনিট",
	"menu.workforce.organizations.unit.designation": "সংস্থা ইউনিট পদবী",
	"menu.workforce.organizations.employee": "প্রতিষ্ঠানের কর্মচারী",
	"menu.workforce.organizations.employee.designation": "প্রতিষ্ঠানের কর্মচারী পদবী",
	"menu.workforce.office": "অফিস সমূহ",
	"menu.workforce.company": "কোম্পানি সমূহ",
	"menu.workforce.approve.company": "কোম্পানি অনুমোদন",
	"menu.workforce.factory": "শ্রমিকের কর্মরত প্রতিষ্ঠান/ কারখানার তথ্য",
	"menu.workforce.factory.employee.designation": "শ্রমিকের কর্মরত প্রতিষ্ঠান / কারখানার কর্মচারী পদবী",
	"menu.workforce.employee": "কর্মচারী",
	"menu.workforce.registration": "নিবন্ধন",
	"menu.workforce.application": "আবেদন",
	"menu.workforce.application.process": "আবেদন প্রক্রিয়া",
	"menu.workforce.banks": "ব্যাংক",
	"workforce.bank.picker": "ব্যাংক",
	"workforce.branch.picker": "শাখা",
	"workforce.district.branch.picker": "জেলা",
	"menu.workforce.branch": "শাখা সমূহ",
	"menu.workforce.employee.factory": "কর্মচারী শ্রমিকের কর্মরত প্রতিষ্ঠান/ কারখানার তথ্য",
	"menu.workforce.documents": "নথিপত্র",
	"menu.workforce.association": "অ্যাসোসিয়েশন",
	"workforce.employee.designation": "পদবী",
	"workforce.employee.relationWithApplicant": "মৃত শ্রমিকের সাথে আবেদনকারীর সম্পর্ক",
	"workforce.employee.accident.info.application.injuryType": "ক্ষতি ধরন",
	"workforce.employee.accident.info.application.dateOfAccident": "দুর্ঘটনার তারিখ",
	"workforce.employee.accident.info.application.timeOfAccident": "দুর্ঘটনার সময়",
	"workforce.employee.accident.info.application.typeOfAccident": "দুর্ঘটনার ধরন",
	"workforce.employee.accident.info.application.dutyStatus": "ডিউটি ​​স্ট্যাটাস/কর্তব্যের অবস্থা",
	"workforce.employee.accident.info.application.insideOutsideFactory": "শ্রমিকের কর্মরত প্রতিষ্ঠান / কারখানার ভিতরে/বাইরে",
	"workforce.employee.accident.info.application.reJoiningDate": "সুস্থ হওয়ার পরে পুনরায় কাজে যোগদানের তারিখ",
	"workforce.application.type.title": "আবেদনের ধরন নির্বাচন করুন",
	"workforce.application.type.medical.assistance": "চিকিৎসা সহায়তা",
	"workforce.application.type.medical.donation": "চিকিৎসা অনুদান",
	"workforce.application.type.financial.assistance": "মৃত শ্রমিক পরিবারের জন্য আর্থিক সহায়তা",
	"workforce.application.type.medical.disability": "স্থায়ী ও আংশিক অক্ষমতা জনিত আর্থিক সহায়তা",
	"workforce.application.type.eis.medical.disability": "দুর্ঘটনা জনিত স্থায়ী ও অস্থায়ী অক্ষমতা জনিত আর্থিক সহায়তা",
	"workforce.application.type.scholarship": " শিক্ষাবৃত্তির আবেদন",
	"workforce.application.type.education.grant": "শিক্ষা অনুদান",
	"workforce.application.type.deadly.grant": "মৃত্যুজনিত অনুদান",
	"workforce.application.type.eis.deadly.grant": "দুর্ঘটনা জনিত মৃত্যু অনুদান",
	"workforce.application.type.maternal.grant": "মাতৃত্বজনিত অনুদান",
	"workforce.application.company.type": "আপনি কি শতভাগ রপ্তানিমুখী সেক্টরে কর্মরত?",
	"workforce.application.reason.type": "আর্থিক সহায়তা কারণ?",
	"workforce.application.permission.yes": "হ্যাঁ",
	"workforce.application.permission.no": "না",
	"workforce.application.for": "কার জন্য আবেদন?",
	"workforce.application.for.type.self": "নিজের জন্য",
	"workforce.application.for.type.dependent": "নির্ভরশীল এর জন্য",
	"workforce.application.for.type.dependent.children": "সন্তানের জন্য",
	"workforce.application.for.type.dependent.mother": "পুরুষ শ্রমিকের ক্ষেত্রে স্ত্রীর জন্য",
	"workforce.financial.assistance.normalDeath": "স্বাভাবিক মৃত্যু",
	"workforce.financial.assistance.accidentalDeath": "দুর্ঘটনাজনিত মৃত্যু",
	"workforce.disability.partial": "আংশিক স্থায়ী অক্ষমতা",
	"workforce.disability.permanent": "সম্পূর্ণ স্থায়ী অক্ষমতা",
	"workforce.application.employee.children.studyingClass": "অধ্যয়নরত শ্রেণী/বিভাগ",
	"workforce.application.employee.children.studyingSemester": "অধ্যয়নরত সেমিস্টার/বছর",
	"workforce.application.employee.children.studyingSubject": "অধ্যয়নরত বিষয়/বিভাগ",
	"workforce.application.employee.children.educationInstituteName": "শিক্ষা প্রতিষ্ঠানের নাম",
	"workforce.application.employee.children.result": "ফলাফল",
	"workforce.application.employee.children.bankNameOrAcNo": "ব্যাংকের নাম এবং অ্যাকাউন্ট নম্বর (যদি থাকে)",
	"workforce.application.employee.children.nidOrBirthRegistry": "এনআইডি/জন্ম সনদ",
	"workforce.employee.account.info.routingNumber": "রাউটিং নম্বর",
	"workforce.employee.account.info.status": "অ্যাকাউন্ট স্ট্যাটাস",
	"workforce.employee.account.info.accountHolderName": "অ্যাকাউন্ট হোল্ডারের নাম",
	"workforce.employee.account.info.accountNumber": "অ্যাকাউন্ট নম্বর",
	"workforce.employee.account.info.mobileNumber": "মোবাইল নম্বর",
	"workforce.employee.whoseAccount": "আপনি কার অ্যাকাউন্ট বেছে নিতে চান?",
	"workforce.employee.account.self": "নিজের",
	"workforce.employee.account.dependent": "অন্যান্য নির্ভর্শীল ব্যক্তিবর্গ হতে নির্বাচন করুন",
	"workforce.employee.account.other": "অন্যের একাউন্ট",
	"workforce.employee.account.info.relationshipWithAccountHolder": "অ্যাকাউন্টধারীর সাথে নির্ভরশীলের সম্পর্ক",
	"workforce.employee.account.info.accountHolderNid": "অ্যাকাউন্টধারীর জাতীয় পরিচয়পত্র",
	"workforce.employee.account.info.accountHolderDob": "অ্যাকাউন্টধারীর জন্মতারিখ",
	"workforce.application.steps.deademployee.applicant.Details": "মৃত শ্রমিকের পক্ষে আবেদনকারীর তথ্য",
	"workforce.application.steps.employeeDetails": "শ্রমিকের বিবরণ",
	"workforce.application.steps.location": "ঠিকানা",
	"workforce.application.steps.prosurders": "পৌষ্যদের তথ্য",
	"workforce.application.steps.accident.info": "দুর্ঘটনার তথ্য",
	"workforce.application.steps.treatment.info": "চিকিৎসার তথ্য",
	"workforce.application.steps.upload.documents": "প্রমাণপত্র আপলোড",
	"workforce.application.steps.upload": "আপলোড",
	"workforce.application.steps.capture": "ছবি তুলুন",
	"workforce.application.steps.dependent": "যার জন্য আবেদন, তার বিবরণ",
	"workforce.application.subHeader.dependent.blwf": "যার জন্য আবেদন করা হয়েছে, তার বিবরণ (নির্ভরশীল)",
	"workforce.application.subHeader.dependent": "সুবিধা ভোগীর বিবরণ",
	"workforce.application.steps.account.info": "অ্যাকাউন্ট তথ্য",
	"workforce.application.steps.aidReason": "আর্থিক সহায়তা কারণ",
	"workforce.application.steps.childInfo": "সন্তানের তথ্য",
	"workforce.application.steps.deathLabourDetails": "মৃত শ্রমিকের বিবরণ",
	"workforce.application.steps.education.details": "শিক্ষাগত যোগ্যতার বিবরণ",
	"workforce.application.steps.select": "নির্বাচন করুন",
	"workforce.application.steps.worker.extraInfo": "শ্রমিকের কর্মস্থলের তথ্য",
	"workforce.application.steps.dead.worker.extraInfo": "মৃত শ্রমিকের কর্মস্থলের তথ্য",
	"workforce.application.steps.ssc": "এস.এস.সি. বা সমমান",
	"workforce.application.steps.hsc": "এইচ.এস.সি. বা সমমান",
	"workforce.application.steps.skip": "বাদ দিন",
	"workforce.application.steps.dependentAdd": "নির্ভরশীল যোগ করুন",
	"workforce.application.steps.warishAdd": "ওয়ারিশ যোগ করুন",
	"workforce.application.steps.reasonsforSeekingFinancialAssistance": "আর্থিক সহায়তা চাওয়ার কারণ (সর্বশেষ সময়সীমা বিগত ১০৫ দিনের মধ্যে হতে হবে)",
	"workforce.application.steps.previousGrantInfo": "পূর্ববর্তী অনুদানের তথ্য",
	"workforce.application.steps.otherInfo": "অন্যান্য তথ্য",
	"workforce.application.reasons.physicalMentalDisability": "দুর্ঘটনাজনিত কারণে দৈহিক ও মানসিকভাবে স্থায়ী অক্ষমতা",
	"workforce.application.reasons.accidentalDeath": "দুর্ঘটনাজনিত কারণে মৃত্যু",
	"workforce.application.reasons.curativeTreatment": "দুরারোগ্য চিকিৎসা",
	"workforce.application.reasons.deathbodyRefinement": "মৃতদেহ পরিবহন ও সৎকার",
	"workforce.application.reasons.maternalWelfare": "অপ্রাতিষ্ঠানিক খাতে কর্মরত মহিলা শ্রমিকের মাতৃত্ব কল্যাণ",
	"workforce.application.reasons.addComment": "মন্তব্য যোগ করুন",
	"workforce.application.diseaseGrade": "রোগের গ্রেড",
	"workforce.application.revert.reasons.addComment": "আবেদন ফেরত পাঠানোর কারণ",
	"workforce.application.reasons.selectedOfficer": "বাছাইকৃত কর্মকর্তা:",
	"workforce.employee.dependent.phone": "ফোন নম্বর",
	"workforce.registration.desclaimer": "আপনি ইতোমধ্যে নিবন্ধকৃত ব্যবহারকারী কি না? না হলে নিবন্ধন করুন",
	"workforce.employee.details": "শ্রমিকের বিবরণ",
	"workforce.employee.upload.factory.document": "অনুপস্থিত ফ্যাক্টরির ডকুমেন্ট আপলোড করুন",
	"workforce.employee.document": "ডকুমেন্ট সমূহ",
	"workforce.employee.other.document": "অন্যান্য ডকুমেন্ট সমূহ",
	"workforce.employee.application.details": "শ্রমিকের আবেদন বিবরণ",
	"workforce.next": "পরবর্তী",
	"workforce.back": "পিছনে",
	"workforce.back.application.type": "প্রথম ধাপে ফিরে যান",
	"workforce.save.next": "সংরক্ষণ করুন এবং পরবর্তী",
	"workforce.save": "সংরক্ষণ করুন",
	"workforce.submit": "জমা দিন",
	"workforce.confirm.submit": "জমা নিশ্চিত করুন",
	"workforce.success.message": "✅ আবেদন সফলভাবে জমা দেওয়া হয়েছে!",
	"workforce.success.message.doctor": "✅ আপনার তথ্য সফলভাবে সংরক্ষণ করা হয়েছে!",
	"workforce.registration.title": "ওটিপি প্রধান করুন।",
	"workforce.employee.name.en": "নাম (ইংরেজি)",
	"workforce.employee.name.bn": "নাম (বাংলা)",
	"workforce.employee.name": "নাম",
	"workforce.application.process.all": "সকল",
	"workforce.application.process.accidental": "দুর্ঘটনাজনিত",
	"workforce.application.process.death": "মৃত্যু",
	"workforce.application.process.disability": "অক্ষমতা",
	"workforce.application.process.pending": "অপেক্ষমান",
	"workforce.application.process.forwarded": "সুপারিশকৃত",
	"workforce.application.process.approved": "অনুমোদিত",
	"workforce.application.process.rejected": "বাতিলকৃত",
	"workforce.application.process.reverted": "প্রত্যাবর্তিত",
	"workforce.application.id": "অ্যাপ্লিকেশন আইডি",
	"workforce.application.date": "আবেদনের তারিখ",
	"workforce.application.disabilityInfo": "অক্ষমতার তথ্য",
	"workforce.application.disabilityDetails": "অক্ষমতার কারণ",
	"workforce.application.expected.date": "সেবা প্রদানের সম্ভাব্য তারিখ",
	"workforce.application.reverted": "ফেরত আসা আবেদন",
	"workforce.application.returned": "ফেরত পাঠানো আবেদন",
	"workforce.application.draft": "খসড়া আবেদ",
	"workforce.application.status": "আবেদনের অবস্থা",
	"workforce.application.draft_applications": "খসড়া আবেদন",
	"workforce.application.steps.taken": "গৃহীত ব্যবস্থা",
	"workforce.application.filed": "দাখিলকৃত আবেদনসমূহ",
	"workforce.new.application": "নতুন আবেদন",
	"workforce.new.eis.application": "নতুন ই.আই.এস. আবেদন",
	"workforce.new.application.factory": "নতুন আবেদন (আবেদনকারীর পক্ষে)",
	"workforce.help.complain": "সাহায্য এবং অভিযোগ",
	"workforce.others": "অন্যান্য",
	"workforce.application.tracking.number": "ট্র্যাকিং নম্বর",
	"workforce.search.here": "অনুসন্ধান করুন...",
	"workforce.application.pending": "আগত আবেদন",
	"workforce.application.approve.applications": "অনুমোদিত আবেদন",
	"workforce.application.approve": "অনুমোদন",
	"workforce.application.verify": "যাচাই",
	"workforce.application.recommended": "ভেরিফাইড",
	"workforce.application.reject": "বাতিল",
	"workforce.application.rejectedApplication": "বাতিলকৃত আবেদন",
	"workforce.application.recent": "সাম্প্রতিক কার্যকলাপ",
	"workforce.application.checked": "পরীক্ষিত আবেদন",
	"workforce.checker1.dashboard": "কল্যাণ শাখা-১ ডাটা এন্ট্রি অপারেটর ড্যাশবোর্ড",
	"workforce.checker2.dashboard": "কল্যাণ শাখা-২ অফিস সহকারী-কাম-কম্পিউটার মুদ্রাক্ষরিক ড্যাশবোর্ড",
	"workforce.section1.admin.dashboard": "কল্যাণ শাখা-১ সহকারী পরিচালকের ড্যাশবোর্ড",
	"workforce.section2.admin.dashboard": "কল্যাণ শাখা-২ সহকারী পরিচালকের ড্যাশবোর্ড",
	"workforce.section1.deputy1.admin.dashboard": "কল্যাণ শাখা-১ উপ-সহকারী পরিচালকের ড্যাশবোর্ড",
	"workforce.section2.deputy2.admin.dashboard": "কল্যাণ শাখা-২ উপ-সহকারী পরিচালকের ড্যাশবোর্ড",
	"workforce.blwf.section.admin.dashboard": "বিএলডাব্লিউএফ শাখা পরিচালকের ড্যাশবোর্ড",
	"workforce.section.cf.doctor.dashboard": "ড্যাশবোর্ড",
	"workforce.section.blwf.doctor.dashboard": "ড্যাশবোর্ড",
	"workforce.section.eis.doctor.dashboard": "ইআইএস ডক্টরের ড্যাশবোর্ড",
	"workforce.bgmea.association.dashboard": "বিজিএমইএ অ্যাসোসিয়েশনের ড্যাশবোর্ড",
	"workforce.bkmea.association.dashboard": "বিকেএমইএ অ্যাসোসিয়েশনের ড্যাশবোর্ড",
	"workforce.applicant.dashboard": "আবেদনকারী ড্যাশবোর্ড",
	"workforce.factory_admin.dashboard": "ফ্যাক্টরি অ্যাডমিনের ড্যাশবোর্ড",
	"workforce.cf.approver.dashboard": "কেন্দ্রীয় তহবিল সিলেকশন কমিটির ড্যাশবোর্ড",
	"workforce.blwf.approver.dashboard": "বিএলডাব্লিউএফ সিলেকশন কমিটির ড্যাশবোর্ড",
	"workforce.approver.noEntry": "কোন এন্ট্রি খুঁজে পাওয়া যায়নি",
	"workforce.application.myself": "সকল আবেদন",
	"workforce.new.application.submittedbyapplicant": "আবেদনকারীর জমাকৃত আবেদন",
	"workforce.application.forwarded": "সুপারিশকৃত আবেদন",
	"workforce.application.approved": "অনুমোদিত আবেদন",
	"workforce.application.sentforverification": "যাচাইএর জন্য প্রেরিত আবেদন",
	"workforce.application.verified": "যাচাইকৃত আবেদন",
	"workforce.application.dashboard": "ড্যাশবোর্ড",
	"workforce.blwf.checker.dashboard": "ড্যাশবোর্ড",
	"workforce.blwf.deputy.admin.dashboard": "বিএলডাব্লিউএফ উপ-সহকারী পরিচালকের ড্যাশবোর্ড",
	"workforce.eis.coordinator.dashboard": "ইআইএস কোঅর্ডিনেটর এর ড্যাশবোর্ড",
	"workforce.eis.officer.dashboard": "ইআইএস অফিসার এর ড্যাশবোর্ড",
	"workforce.eis.committe.dashboard": "ইআইএস কমিটির ড্যাশবোর্ড",
	"workforce.eis.financial.dashboard": "ইআইএস ফিনান্সিয়াল অফিসার এর ড্যাশবোর্ড",
	"workforce.blwf.dol-dife.dashboard": "ড্যাশবোর্ড",
	"workforce.bepza.association.dashboard": "বেপজা অ্যাসোসিয়েশনের ড্যাশবোর্ড",
	"workforce.lfmeab.association.dashboard": "এলএফএমইএবি অ্যাসোসিয়েশনের ড্যাশবোর্ড",
	"workforce.eis.association.committe.dashboard": "ইআইএস অ্যাসোসিয়েশনের কমিটির ড্যাশবোর্ড",
	"core.LanguageQuickPicker.dialog.title": "ভাষা নিশ্চিত করুন",
	"core.LanguageQuickPicker.dialog.message": "আপনি ভাষাটি ইংরেজিতে করতে চলেছেন। আপনি কি এগিয়ে যেতে চান?",
	"core.LanguageQuickPicker.dialog.confirm": "নিশ্চিত করুন",
	"core.LanguageQuickPicker.dialog.cancel": "বাতিল করুন",
	mainMenuGrievance: mainMenuGrievance,
	"menu.grievance.grievances": "অভিযোগ সমূহ",
	"menu.add_ticket": "অভিযোগ যোগ করুন",
	"admin.mainMenu": "প্রশাসন",
	"admin.menu.claimAdministrators": "দাবি প্রশাসক",
	"admin.menu.enrollmentOfficers": "তালিকাভুক্তি কর্মকর্তারা",
	"admin.menu.healthFacilities": "স্বাস্থ্য সুবিধা",
	"admin.menu.locations": "ঠিকানাসমূহ",
	"admin.menu.medicalItems": "মেডিকেল আইটেম",
	"admin.menu.medicalItemsPrices": "চিকিৎসা সামগ্রীর মূল্য তালিকা",
	"admin.menu.medicalServices": "চিকিৎসা সেবা",
	"admin.menu.medicalServicesPrices": "চিকিৎসা সেবার মূল্য তালিকা",
	"admin.menu.users": "ইউজার ম্যানেজমেন্ট",
	"admin.menu.payers": "প্রদানকারী",
	"admin.menu.products": "পণ্য",
	"admin.menu.usersProfiles": "ইউজারদের প্রোফাইল",
	"workforce.application.employee.selector": "কর্মচারী নির্বাচন করুন",
	"workforce.application.add.employee": "কর্মচারী যোগ করুন",
	"workforce.application.header.labour": "আবেদনকারী শ্রমিকের তথ্য",
	"workforce.application.header.labour.note": "নীচের তথ্যগুলি (NID) অনুসারে পূরণ করতে হবে, অন্যথায় আবেদনটি বাতিল বলে বিবেচিত হবে।",
	"workforce.application.header.blwf.education.note": "সরকারি মেডিক্যাল কলেজ অথবা সরকারি কৃষি বা প্রযুক্তি বিশ্ববিদ্যালয় অথবা সরকারি অন্যান্য বিশ্ববিদ্যালয়ের উচ্চ শিক্ষা (স্নাতক)-এর শিক্ষার্থী এর জন্য আবেদনটি প্রযোজ্য।",
	"workforce.application.header.employeeSelector.note": "নাম, জাতীয় পরিচয়পত্র নম্বর (NID) অথবা মোবাইল নম্বর ব্যবহার করে সহজেই আবেদন করার জন্য সংশ্লিষ্ট কর্মকর্তা বা কর্মচারীকে খুঁজে নিন।",
	"workforce.application.header.location": "ঠিকানা",
	"workforce.application.header.child": "সন্তানের তথ্য",
	"workforce.application.header.document": "প্রমাণপত্র আপলোড",
	"workforce.application.header.dependent": "যার জন্য আবেদন, তার বিবরণ",
	"workforce.application.header.account": "অ্যাকাউন্ট তথ্য",
	"workforce.application.header.previousGrant": "পূর্ববর্তী অনুদান তথ্য",
	"workforce.application.header.other": "অন্যান্য তথ্য",
	"workforce.child.name.bn": "নাম (বাংলা)",
	"workforce.child.name.en": "নাম (ইংরেজি)",
	"workforce.spouse.name": "নাম",
	"workforce.application.dateofReceipt": "প্রাপ্তির তারিখ",
	"workforce.application.grantAmount": "প্রাপ্ত অর্থের পরিমাণ",
	"workforce.application.reasonforReceipt": "প্রাপ্তির কারণ",
	"workforce.application.otherInfo": "অন্য কোন তথ্য (যদি থাকে)",
	"workforce.application.nidVerify.loading": "আপনার তথ্যাটি LIMS থেকে যাচাই করা হচ্ছে",
	"workforce.application.nidVerify.success": "আপনার তথ্যাটি LIMS থেকে সফলভাবে যাচাই করা হয়েছে",
	"workforce.application.nidVerify.error": "আপনার তথ্যটি LIMS থেকে যাচাই করা সম্ভব হয়নি",
	"workforce.application.labourHeadingOne": "শ্রমিকের ব্যক্তিগত তথ্য",
	"workforce.application.labourHeadingTwo": "শ্রমিকের পারিবারিক তথ্য",
	"workforce.applicant.labourHeadingOne": "আবেদনকারীর ব্যক্তিগত তথ্য",
	"workforce.applicant.labourHeadingTwo": "আবেদনকারীর পারিবারিক তথ্য",
	"workforce.previewDetails.applicantInfo": "আবেদনকারীর তথ্য",
	"workforce.application.labourDetails.spouse": "প্রসূতি স্ত্রীর তথ্য",
	"workforce.application.account.bank": "ব্যাংকের মাধ্যমে সহায়তা পেতে চান?",
	"workforce.application.account.mobile": "মোবাইল ব্যাংকিংয়ের মাধ্যমে সহায়তা পেতে চান?",
	"workforce.application.account.mobile.operator": "মোবাইল ব্যাংকিং অপারেটর",
	"workforce.application.account.mobile.operator.msg": "আপনার প্রদত্ত মোবাইল নম্বরটি অবশ্যই আপনার জাতীয় পরিচয়পত্র (NID)-এর সাথে নিবন্ধিত থাকতে হবে",
	"workforce.employee.accident.info.hospitalName": "হাসপাতালের নাম",
	"workforce.employee.accident.info.admitDate": "ভর্তির তারিখ",
	"workforce.employee.accident.info.releaseDate": "রিলিজের তারিখ",
	"workforce.employee.accident.info.doctorName": "ডাক্তারের নাম",
	"workforce.application.accident.hospitalized": "হাসপাতালে ভর্তি হয়েছিলেন?",
	"workforce.application.accident.accidentPlace": "দুর্ঘটনা কোথায় হয়েছে?",
	"workforce.application.accident.dateOfDiagnosis": "রোগ নির্ণয়ের তারিখ",
	"workforce.application.accident.dateOfLastCheckup": "ডাক্তার প্রদত্ত সর্বশেষ প্রেসক্রিপশনের তারিখ",
	"workforce.application.accident.": "অন্যান্য রোগ উল্লেখ করুন",
	"workforce.application.disease.name": "রোগের নাম",
	"workforce.application.disease.timeOfAccident": "দুর্ঘটনার সময়",
	"workforce.application.disease.maternalHeading": "মাতৃত্ব সংক্রান্ত তথ্যঃ",
	"workforce.application.disease.maternal.delivaryDate": "সন্তান জন্মের তারিখ / সম্ভাব্য তারিখ",
	"workforce.tracking.notfound": "কোনো আবেদন পাওয়া যায়নি",
	"workforce.application.modal.header": "নির্বাচিত আবেদনের সারাংশ",
	"workforce.table.applicantName": "আবেদনকারীর নাম",
	"workforce.table.applicationType": "আবেদনের ধরণ",
	"workforce.table.approvedAmount": "অনুমোদিত পরিমাণ",
	"workforce.table.accountNo": "অ্যাকাউন্ট নম্বর",
	"workforce.table.bankName": "ব্যাংকের নাম",
	"workforce.table.branch": "শাখা",
	"workforce.table.close": "বন্ধ করুন",
	"workforce.table.printSUmmary": "মিটিং পত্র প্রিন্ট",
	"workforce.table.forwardToDirector": "পরিচালকের কাছে ফরোয়ার্ড করুন",
	"workforce.table.totalAmount": "মোট পরিমাণ",
	"workforce.table.printAdvice": "প্রিন্ট এডভাইস",
	"workforce.table.bftn": "ব্যাংক পেমেন্ট এডভাইস (BFTN)",
	"search.title": "সার্চ করুন",
	resetFilterTooltip: resetFilterTooltip,
	refreshFilterTooltip: refreshFilterTooltip,
	"workforce.application.submittedBy": "জমাদানকারী",
	"workforce.application.startDate": "শুরুর তারিখ",
	"workforce.application.endDate": "শেষ তারিখ",
	"workforce.association.name.en": "নাম (ইংরেজি)",
	"workforce.association.shortName.en": "নাম (ইংরেজি)",
	"workforce.association.name.bn": "নাম (বাংলা)",
	"workforce.association.shortName.bn": "নাম (বাংলা)",
	"workforce.association.phone": "ফোন নম্বর",
	"workforce.association.email": "ই-মেইল",
	"workforce.association.address": "ঠিকানা",
	"workforce.association.webAddress": "ওয়েবসাইটের ঠিকানা",
	"workforce.association.startDate": "শুরুর তারিখ",
	"workforce.association.status": "অবস্থা",
	"workforce.association.minimumSalary": "ন্যূনতম বেতন",
	"workforce.previewDetails.personalInfo": "ব্যক্তিগত তথ্য",
	"workforce.previewDetails.statusInfo": "অবস্থা তথ্য",
	"workforce.previewDetails.employeeAccidentInfo": "দুর্ঘটনার তথ্য",
	"workforce.previewDetails.contactInfo": "যোগাযোগের তথ্য",
	"workforce.previewDetails.employeeChildrenInfo": "সন্তানের তথ্য",
	"workforce.previewDetails.othersInfo": "অন্যান্য তথ্য",
	"workforce.previewDetails.employeeBankInfo": "ব্যাংকের তথ্য",
	"workforce.previewDetails.company": "কোম্পানির তথ্য",
	"workforce.previewDetails.factory": "শ্রমিকের কর্মরত প্রতিষ্ঠান / কারখানার তথ্য",
	"workforce.previewDetails.educations": "নিজের/সন্তানের শিক্ষাগত যোগ্যতা",
	"workforce.previewDetails.employeeDependentInfo": "নির্ভরশীল সদস্যদের তথ্য",
	"workforce.previewDetails.employeeWarishInfo": "ওয়ারিশদের তথ্য",
	"workforce.previewDetails.metadata": "আবেদনের প্রয়োজনীয় তথ্য",
	"workforce.previewDetails.dependent": "ওয়ারিশদের তথ্য",
	"workforce.previewDetails.eis.dependent": "পৌষ্যদের তথ্য",
	"workforce.worker.label": "শ্রমিকের",
	"workforce.application.death.reason": "মৃত্যুর কারণ নির্দিষ্ট করুন",
	"workforce.application.other.death.reason": "মৃত্যুর কারণ নির্দিষ্ট করুন ",
	"workforce.application.other.desease.reason": "রোগ নির্দিষ্ট করুন ",
	"workforce.application.deathReason.heart_disease": "হৃদরোগ",
	"workforce.application.deathReason.stroke": "স্ট্রোক",
	"workforce.application.deathReason.old_age": "বার্ধক্যজনিত মৃত্যু",
	"workforce.application.deathReason.cancer": "ক্যান্সার",
	"workforce.application.deathReason.diabetes": "ডায়াবেটিস",
	"workforce.application.deathReason.liver_failure": "লিভার ফেইলিওর",
	"workforce.application.deathReason.kidney_failure": "কিডনি ফেইলিওর",
	"workforce.application.deathReason.asthma": "অ্যাজমা / শ্বাসকষ্ট",
	"workforce.application.deathReason.pneumonia": "নিউমোনিয়া",
	"workforce.application.deathReason.chronic": "দীর্ঘমেয়াদি রোগ",
	"workforce.application.deathReason.OTHER_OPTION": "অন্যান্য",
	"workforce.accident.type.fire_accident": "অগ্নি দুর্ঘটনা",
	"workforce.accident.type.boiler_explosion": "বয়লার বিস্ফোরণ",
	"workforce.accident.type.burn_injury": "পোড়া আঘাত",
	"workforce.accident.type.machinery": "যন্ত্রপাতি",
	"workforce.accident.type.electric_shock": "বৈদ্যুতিক শক",
	"workforce.accident.type.heavy_object_fall": "ভারী ওজন পতন",
	"workforce.accident.type.road_accident": "সড়ক দুর্ঘটনা",
	"workforce.accident.type.others": "অন্যান্য",
	"workforce.timePicker.hour": "ঘণ্টা",
	"workforce.timePicker.minute": "মিনিট",
	"workforce.office.dol": "শ্রম অধিদপ্তর",
	"workforce.office.dife": "কলশ্রমিকের কর্মরত প্রতিষ্ঠান / কারখানার ও প্রতিষ্ঠান পরিদর্শন অধিদপ্তর",
	"workforce.office.type": "অফিসের ধরন নির্বাচন করুন",
	"workforce.officeType.selector.picker": "অফিস নির্বাচন করুন",
	"workforce.officer.selector.picker": "অফিসার নির্বাচন করুন",
	"workforce.EmployeeType.selector.picker": "কর্মচারী নির্বাচন করুন",
	"workforce.tracking.summary": "ট্র্যাকিং সারাংশ",
	"workforce.employee.nid_or_birth_certificate": "জাতীয় পরিচয়পত্র/জন্ম নিবন্ধন নং",
	"workforce.employee.accident.info.title": "চিকিৎসার বিবরণ",
	"workforce.employee.aid.reason.info.cronic": "রোগের বিবরণ",
	"workforce.employee.aid.reason.info.maternity": "মাতৃত্বকালীন রোগের জন্য",
	"workforce.employee.aid.reason.info.accident": "দুর্ঘটনার বিবরণ",
	"workforce.gender.male": "পুরুষ",
	"workforce.gender.female": "মহিলা",
	"workforce.gender.other": "অন্যান্য",
	"workforce.marital_status.single": "অবিবাহিত",
	"workforce.marital_status.married": "বিবাহিত",
	"workforce.marital_status.widow": "বিধবা",
	"workforce.marital_status.widower": "বিপত্নীক",
	"workforce.marital_status.remarried": "পুনরায় বিবাহিত",
	"workforce.account.selection.type": "অ্যাকাউন্টের ধরণ নির্বাচন করুন",
	"workforce.register.button": "নিবন্ধন করুন",
	"workforce.relation.father": "পিতা",
	"workforce.relation.father.suffix": "পিতার",
	"workforce.relation.mother": "মাতা",
	"workforce.relation.mother.suffix": "মাতার",
	"workforce.relation.wife": "স্ত্রী",
	"workforce.relation.wife.suffix": "স্ত্রীর",
	"workforce.relation.husband": "স্বামী",
	"workforce.relation.husband.suffix": "স্বামীর",
	"workforce.relation.son": "পুত্র",
	"workforce.relation.son.suffix": "পুত্রের",
	"workforce.relation.daughter": "কন্যা",
	"workforce.relation.daughter.suffix": "কন্যার",
	"workforce.relation.brother": "ভাই",
	"workforce.relation.brother.suffix": "ভাইয়ের",
	"workforce.relation.sister": "বোন",
	"workforce.relation.sister.suffix": "বোনের",
	"workforce.relation.grand_daughter": "নাতনি",
	"workforce.relation.grand_daughter.suffix": "নাতনির",
	"workforce.relation.grand_son": "নাতি",
	"workforce.relation.grand_son.suffix": "নাতির",
	"workforce.relation.grand_father": "দাদা",
	"workforce.relation.grand_father.suffix": "দাদার",
	"workforce.relation.grand_mother": "দাদি",
	"workforce.relation.grand_mother.suffix": "দাদির",
	"workforce.relation.illigitimate_daughter": "বিবাহ বহির্ভুত কন্যা সন্তান",
	"workforce.relation.illigitimate_son": "বিবাহ বহির্ভুত পুত্র সন্তান",
	"workforce.employee.relation.picker": "শ্রমিকের সাথে সম্পর্কের ধরন নির্বাচন করুন",
	"workforce.employee.city.road_no": "রোড নাম্বার / রোডের নাম",
	"workforce.employee.city.house_name": "বাসা নম্বর / বাসার নাম",
	"workforce.employee.city.apartment_number": "অ্যাপার্টমেন্ট নাম্বার",
	"workforce.employee.rural.address": "ঠিকানা (গ্রামীণ)",
	"workforce.employee.rural.house_name": "বাসা / হোল্ডিং নম্বর",
	"workforce.employee.rural.village_road": "গ্রাম / রাস্তা",
	"workforce.employee.rural.para_mahalla": "পাড়া / মহল্লা",
	"workforce.employee.rural.post_office": "ডাকঘর",
	"workforce.applicant.workInfo.title": "প্রাতিষ্ঠানিক/ অপ্রাতিষ্ঠানিক খাতে কর্মরত শ্রমিকের ক্ষেত্রে প্রয়োজনীয় তথ্যাবলী",
	"workforce.applicant.workInfo.formal.institution_name": "প্রতিষ্ঠানের নাম",
	"workforce.applicant.workInfo.formal.institution_address": "প্রতিষ্ঠানের ঠিকানা",
	"workforce.applicant.workInfo.informal.current_occupation": "বর্তমান পেশা",
	"workforce.applicant.workInfo.informal.workplace": "কর্মস্থল",
	"workforce.applicant.workInfo.formal": "প্রাতিষ্ঠানিক",
	"workforce.applicant.workInfo.informal": "অপ্রাতিষ্ঠানিক",
	"workforce.employee.accident.info.hasRejoined": "আপনি কি সুস্থ হওয়ার পরে পুনরায় কর্মস্থলে  যোগদান করেছেন?",
	"workforce.dead": "মৃত",
	"workforce.account.entry": "",
	"workforce.uploadFile.dependent.photo": "নির্ভরশীলের ছবি",
	"workforce.uploadFile.dependent.nid_or_birthCcertificate": "জাতীয় পরিচয়পত্র বা জন্মসনদের ছবি",
	"workforce.employee.sameAsPresent": "বর্তমান ঠিকানার অনুরূপ",
	"core.LoginPage.loginBtn": "লগইন",
	"core.error.required": "এই তথ্যটি  আবশ্যক",
	"core.error.phoneNumberLength": "ফোন নম্বর অবশ্যই ১১ সংখ্যার হতে হবে",
	"core.error.nidLength": "এনআইডি/জন্মসনদ নম্বরটি অবশ্যই ১০,১৩ অথবা ১৭ সংখ্যার হতে হবে",
	"core.error.nid.repeat": "একাধিক নির্ভরশীলের জন্য একই জাতীয় পরিচয়পত্র নম্বর ব্যবহার করা যাবে না",
	"core.error.workerAge": "শ্রমিকের বয়স ন্যূনতম ১৬ বছর হতে হবে।",
	"core.error.lastCheckup.between150days": "শেষবার ডাক্তারের কাছে যাওয়ার তারিখ ১০৫ দিনের বেশি হতে পারবেনা ",
	"core.error.applicantAge": "আবেদনকারীর বয়স ন্যূনতম ১২ বছর হতে হবে।",
	"core.error.deathTime": "মৃত্যুর তারিখ সঠিক নয়।",
	"core.error.dateTime": "তারিখ সঠিক নয়।",
	"core.error.accidentDate": "দুর্ঘটনার তারিখ বৈধ নয়",
	"core.error.accountNumberLength": "অ্যাকাউন্ট নম্বর অবশ্যই ৮ থেকে ১৭ অঙ্কের হতে হবে",
	"core.error.generel": "অনুগ্রহ করে পরীক্ষা করে দেখুন যে আপনি সমস্ত প্রয়োজনীয় তথ্য সঠিকভাবে পূরণ করেছেন।",
	"core.error.inEligible.dependent": "আপনাকে উপযুক্ত পোষ্য (নির্ভরশীল) হিসেবে বিবেচনা করা হয়নি।",
	"calendar.clearButton": "মুছে ফেলুন",
	"core.Autocomplete.placeholder": "নির্বাচন করুন...",
	"workforce.factory.associationType": "প্রতিষ্ঠান/ কারখানার অ্যাসোসিয়েশনের ধরণ",
	"workforce.factory.name.en": "প্রতিষ্ঠান/ কারখানার নাম (ইংরেজি)",
	"workforce.factory.name.bn": "প্রতিষ্ঠান/ কারখানার নাম (বাংলা)",
	"workforce.factory.address": "ঠিকানা",
	"workforce.factory.email": "ই-মেইল",
	"workforce.factory.phone": "ফোন নম্বর",
	"workforce.factory.website": "ওয়েবসাইট",
	"workforce.factory.status": "অবস্থা",
	"workforce.office.name.en": "অফিসের নাম (ইংরেজি)",
	"workforce.office.name.bn": "অফিসের নাম (বাংলা)",
	"workforce.office.address": "ঠিকানা",
	"workforce.office.email": "ই-মেইল",
	"workforce.office.phone": "ফোন নম্বর",
	"workforce.office.website": "ওয়েবসাইট",
	"workforce.office.status": "অবস্থা",
	"workforce.representative.name.en": "প্রতিনিধির নাম (ইংরেজি)",
	"workforce.representative.name.bn": "প্রতিনিধির নাম (বাংলা)",
	"workforce.representative.address": "প্রতিনিধির ঠিকানা",
	"workforce.representative.email": "ই-মেইল",
	"workforce.representative.phone": "ফোন নম্বর",
	"workforce.representative.passport": "পাসপোর্ট নম্বর",
	"workforce.representative.nid": "জাতীয় পরিচয়পত্র নম্বর",
	"workforce.representative.position": "পদবী",
	"workforce.representative.birthDate": "জন্ম তারিখ",
	"workforce.representative.sameAsRepresentative": "প্রতিনিধির তথ্য কারখানার তথ্যের অনুরূপ",
	"workforce.representative.title": "প্রতিনিধির তথ্য",
	"workforce.factory.uploadMembershipCertificate": "কারখানার মেম্বারশিপ সার্টিফিকেট আপলোড করুন",
	"workforce.employee.application.beneficiaryReportSheet": "সুবিধাভোগী কল্যাণ হিসাব",
	"core.InternalServerErrorPage.title": "অভ্যন্তরীণ সার্ভার ত্রুটি",
	"core.InternalServerErrorPage.description": "সার্ভারটি একটি অভ্যন্তরীণ ত্রুটি বা ভুল কনফিগারেশনের সম্মুখীন হয়েছে এবং পেইজটি অথবা সেকশনটি লোড করতে পারেনি।",
	"workforce.employee.application.beneficiaryReport": "সুবিধাভোগী কল্যাণ হিসাব",
	"workforce.financialAssistance.error.message": "মৃত্যুর জন্য ইতোমধ্যেই একটি আবেদন করা হয়েছে",
	"workforce.employee.application.disburse": "ডিসবার্স নিশ্চিত করুন",
	"workforce.employee.application.approvalByBoard": "List of applications approved by the board",
	"workforce.previewDetails.uploadedBy.applicant": "আবেদনকারী দ্বারা প্রদত্ত",
	"workforce.previewDetails.uploadedBy.factoryAdmin": "বোর্ড কর্তৃক অনুমোদিত আবেদনের তালিকা",
	"workforce.select.postOffice": "পোস্ট অফিস",
	"workforce.application.forward.message": "আপনি কি নির্বাচিত আবেদনসমূহ ফরওয়ার্ড করতে চান?",
	"workforce.application.forward.message.toAssociation": "আপনি কি নির্বাচিত আবেদনসমূহ অ্যাসোসিয়েশনে ফরওয়ার্ড করতে চান?",
	"workforce.application.forward.message.toSectionAdmin": "আপনি কি নির্বাচিত আবেদনসমূহ শাখা এডমিনে ফরওয়ার্ড করতে চান?",
	"workforce.application.forward.message.toSectionUser": "আপনি কি নির্বাচিত আবেদনসমূহ ডাটা এন্ট্রি অপারেটরে ফরওয়ার্ড করতে চান?",
	"workforce.application.forward.message.toDoctor": "আপনি কি নির্বাচিত আবেদনসমূহ ডক্টরের কাছে ফরওয়ার্ড করতে চান?",
	"workforce.application.forward.message.toEisCoordinator": "আপনি কি যাচাইকৃত আবেদন গুলো ফরওয়ার্ড করতে চান?",
	"workforce.application.forward.message.new.toEisCoordinator": "আপনি কি যাচাইকৃত আবেদন গুলো ফরওয়ার্ড করতে চান?",
	"workforce.application.forward.message.withoutCompensation.toEisCoordinator": "কোনও ক্ষতিপূরণ তথ্য দেওয়া হয়নি। আপনি কি ক্ষতিপূরণের বিবরণ যোগ না করেই এগিয়ে যেতে চান?",
	"workforce.application.sign.message.toEisCoordinator": "আপনি কি এই আবেদনটি সুপারিশ করতে চান?",
	"workforce.application.forward.message.withoutCompensation.eisOfficer.toEisCoordinator": "অনুগ্রহ করে পরবর্তী ধাপে যাওয়ার আগে ক্ষতিপূরণ (হ্যাঁ/না) অপশনটি নির্বাচন করুন।",
	"workforce.application.forward.message.toEisCommittee": "আপনি কি নির্বাচিত আবেদনসমূহ ইআইএস কমিটির কাছে ফরওয়ার্ড করতে চান?",
	"workforce.application.select.message": "আপনি কি এই আবেদনসমূহ নির্বাচন করতে চান?",
	"workforce.application.approve.message": "আপনি কি নির্বাচিত আবেদনসমূহ সুপারিশ করতে চান?",
	"workforce.application.doctor.approve.message": "আপনি কি অক্ষমতার হার নিশ্চিত করতে চান?",
	"workforce.application.reject.message": "আপনি কি নির্বাচিত আবেদনসমূহ বাতিল করতে চান?",
	"workforce.application.resent.message": "আপনি কি নির্বাচিত আবেদনসমূহ  করতে চান?",
	"workforce.confirm.modal.ok": "এগিয়ে যান",
	"workforce.confirm.modal.ok.notEis": "প্রেরণ করুন",
	"workforce.confirm.modal.cancel": "বাতিল করুন",
	"workforce.modal.print": "প্রিন্ট করুন",
	"workforce.modal.print.advice": "এডভাইস প্রিন্ট করুন",
	"workforce.modal.save.advice": "এডভাইস সংরক্ষণ করুন",
	"workforce.modal.print.noa": "NOA প্রিন্ট করুন",
	"workforce.modal.excel": "এক্সেল ফাইল ডাউনলোড করুন",
	"workforce.modal.word": "ওয়ার্ড ফাইল ডাউনলোড করুন",
	"workforce.application.info": "আবেদনের তথ্য",
	"workforce.selectAll": "Select All",
	"workforce.clearSelected": "Clear Selection",
	"workforce.select.time.range": "সময়সীমা নির্বাচন করুন",
	"workforce.from.date": "তারিখ হতে",
	"workforce.to.date": "তারিখ পর্যন্ত",
	"workforce.dashboard.application.types": "আবেদনের ধরণ",
	"workforce.dashboard.applicant.types": "মোট আবেদনকারীর বিবরণ",
	"workforce.dashboard.financial.info": "আর্থিক তথ্য",
	"workforce.dashboard.total.beneficiary.amount": "মোট সুবিধা পরিমাণ",
	"core.roleManagement.label": "রোল ম্যানেজমেন্ট",
	"workforce.modal.close": "বন্ধ করুন",
	view: view,
	reject: reject,
	resend: resend,
	revert: revert,
	forward: forward,
	verify: verify,
	approve: approve,
	"workforce.user.name": "নাম",
	"workforce.user.role": "পদবী",
	"workforce.user.role.admin": "মহাপরিচালক",
	"workforce.user.role.director": "পরিচালক",
	"workforce.user.role.factoryAdmin": "কারখানা প্রশাসক",
	"workforce.user.role.bgmeaAssociation": "বিজিএমইএ সমিতি",
	"workforce.user.role.bkmeaAssociation": "বিকেমইএ সমিতি",
	"workforce.user.role.sectionAdmin": "সেকশন প্রশাসক",
	"workforce.user.role.checker": "চেকার",
	"workforce.user.role.checkerTwo": "চেকার দুই",
	"workforce.user.role.doctor": "ডাক্তার",
	"workforce.user.role.approver": "অনুমোদনকারী",
	"workforce.user.role.applicant": "আবেদনকারী",
	"workforce.user.role.secretary": "সচিব",
	"workforce.application.proposedAmount.byDoctor": "চিকিৎসা অবস্থার ভিত্তিতে প্রস্তাবিত অনুদানের পরিমাণ",
	"workforce.application.diagnosis.byDoctor": "রোগের বিবরণ",
	"workforce.application.lastBaseSalary.byFactoryAdmin": "দুর্ঘটনাকালীন মাসের সর্বশেষ মোট (গ্রস) বেতন",
	"workforce.application.rejectReason": "বাতিল করার কারণ",
	"core.tooltip.logout": "লগ আউট",
	"workforce.factory.addNewTooltip": "ফ্যাক্টরী যোগ করুন",
	"workforce.factory.representative": "ফ্যাক্টরীর প্রতিনিধির তথ্য",
	"workforce.factoryAdmin.employee.lastAmount": "সর্বশেষ মূল বেতন",
	"core.LoginPage.authError": "ইউজারনেম অথবা পাসওয়ার্ড ভূল হয়েছে",
	"core.LoginPage.pageTitle": "লগ-ইন করুন",
	"core.LoginPage.forgotPassword": "পাসওয়ার্ড ভূলে গিয়েছেন?",
	"core.ForgotPasswordPage.pageTitle": "পাসওয়ার্ড ভূলে গিয়েছেন?",
	"workforce.dependent.isDisabled": "নির্ভরশীলটি কি প্রতিবন্ধী?",
	"workforce.dependent.disabilityType": "প্রতিবন্ধিতার ধরন বর্ণনা করুন",
	"workforce.eis.factory.admin.accidentInfo.button": "দুর্ঘটনা ও চিকিৎসার বিবরণ",
	"workforce.eis.coordinator.accidentInfo.button.disability": "অক্ষমতা মূল্যায়নের তথ্য",
	"workforce.application.acknowledgement.text": "আমি নিশ্চিত করছি যে উপরের দেওয়া সমস্ত তথ্য সঠিক এবং সম্পূর্ণ।",
	"workforce.application.accident.otherAccidentType": "অন্যান্য দুর্ঘটনার ধরন বর্ণনা করুন",
	"workforce.application.progressMovement": "আবেদন প্রক্রিয়ার অগ্রগতি",
	"workforce.doctor.discussionRequired": "সিদ্ধান্তের প্রয়োজন",
	"workforce.doctor.rejectRequest": "সুপারিশ (অগ্রহণযোগ্য)",
	"workforce.doctor.recommend": "সুপারিশ (গ্রহণযোগ্য)",
	"workforce.accident.mainType.workplace": "কর্মস্থলে দুর্ঘটনা",
	"workforce.accident.mainType.onDutyRTA": "কর্মস্থলের কাজে যাওয়ার পথে সড়ক দুর্ঘটনা",
	"workforce.accident.mainType.commuting": "বাসা থেকে কর্মস্থল/কর্মস্থল থেকে বাসায় যাওয়ার পথে দুর্ঘটনা",
	"workforce.accident.dailyDutyStart.label": "দৈনিক ডিউটি শুরুর সময়",
	"workforce.accident.dailyDutyEnd.label": "দৈনিক ডিউটি শেষের সময়",
	"workforce.accident.outsideDutyExplanation.label": "অফিসিয়াল ডিউটি সময়ের বাইরে দুর্ঘটনা হওয়ার কারণ ব্যাখ্যা করুন",
	"workforce.accident.specificType.label": "কর্মস্থলে দুর্ঘটনার ধরন (বিস্তারিত)",
	"workforce.accident.otherAccidentType.label": "অন্যান্য দুর্ঘটনার ধরন উল্লেখ করুন",
	"workforce.accident.dutyStatusWorkplace.label": "কর্মস্থলে দুর্ঘটনার সময় কর্মীর ডিউটি স্ট্যাটাস",
	"workforce.accident.outOfFactoryPlace.label": "কারখানার বাইরে দুর্ঘটনাস্থলের বিস্তারিত ঠিকানা",
	"workforce.accident.journeyStartTime.label": "যাত্রা শুরুর আনুমানিক সময়",
	"workforce.accident.journeyStartPoint.label": "যাত্রার শুরুর স্থান",
	"workforce.accident.journeyDestination.label": "গন্তব্যস্থল",
	"workforce.accident.modeOfTravel.label": "চলাচলের মাধ্যম",
	"workforce.accident.roadDescription.label": "কর্মী যে রাস্তা ব্যবহার করেছেন তার বিবরণ",
	"workforce.accident.dutyStatusRTA.label": "কর্মস্থলের কাজে যাওয়ার সময় ডিউটি স্ট্যাটাস",
	"workforce.accident.travelPurpose.label": "ভ্রমণের উদ্দেশ্য",
	"workforce.accident.workEngagedIn.label": "দুর্ঘটনার সময় কর্মী কোন কাজে নিয়োজিত ছিলেন?",
	"workforce.accident.regularTravel.label": "এই উদ্দেশ্যে কর্মী কি নিয়মিত ভ্রমণ করেন?",
	"workforce.accident.officialOrderIssued.label": "কোনো অফিসিয়াল আদেশ/গেট পাস/চালান দেওয়া হয়েছিল কি?",
	"workforce.accident.officialOrderCopy.label": "অফিসিয়াল আদেশের কপি আপলোড করুন",
	"workforce.accident.detailsOfAccident.label": "দুর্ঘটনার বিস্তারিত বিবরণ",
	"workforce.accident.otherInjured.label": "এই দুর্ঘটনায় আর কেউ আহত হয়েছেন কি?",
	"workforce.accident.otherInjuredName.label": "আহত ব্যক্তির নাম",
	"workforce.accident.otherInjuredDesignation.label": "পদবি",
	"workforce.accident.otherInjuredPhone.label": "মোবাইল নম্বর",
	"workforce.accident.otherInjuredType.label": "আঘাতের ধরন",
	"workforce.accident.otherInjuredBenefit.label": "এই কর্মীর জন্য কোনো সুবিধার আবেদন করা হয়েছে কি?",
	"workforce.accident.otherInjuredTracking.label": "ট্র্যাকিং নম্বর (যদি আবেদন করা হয়ে থাকে)",
	"workforce.accident.officialComplaint.label": "কোনো জিডি/এফআইআর/ময়নাতদন্ত হয়েছে কি?",
	"workforce.accident.hospitalized.label": "কর্মী কি হাসপাতালে ভর্তি হয়েছিলেন?",
	"workforce.accident.hospitalName.label": "হাসপাতালের নাম",
	"workforce.accident.admitDate.label": "ভর্তির তারিখ",
	"workforce.accident.admitTime.label": "ভর্তির সময়",
	"workforce.accident.hospitalAddress.label": "হাসপাতালের ঠিকানা",
	"workforce.accident.releaseDate.label": "ছাড়পত্র/ডিসচার্জের তারিখ",
	"workforce.accident.hospitalDoctorName.label": "চিকিৎসকের নাম (হাসপাতাল)",
	"workforce.disability.assessmentDetails": "মূল্যায়নের বিবরণ",
	"workforce.disability.dateOfAssessment": "মূল্যায়নের তারিখ",
	"workforce.disability.nameOfAssessmentMeeting": "মূল্যায়ন সভার নাম",
	"workforce.disability.briefInjuryDescription": "ডাক্তারের প্রেসক্রিপশন অনুযায়ী দুর্ঘটনা/ঘটনা থেকে প্রাপ্ত আঘাতের সংক্ষিপ্ত বিবরণ",
	"workforce.disability.briefTreatmentDescription": "ডাক্তারের প্রেসক্রিপশন অনুযায়ী চিকিৎসার সংক্ষিপ্ত বিবরণ (অপারেশন/ওষুধ/থেরাপি সহ)",
	"workforce.disability.physicalExamination": "শারীরিক পরীক্ষার ফলাফল",
	"workforce.disability.injurySiteLocation": "আঘাতের স্থান/অবস্থান",
	"workforce.disability.injuryDetailsDescription": "আঘাতের বিস্তারিত তথ্য ও বিবরণ",
	"workforce.disability.observationCurrentCondition": "কর্মীর বর্তমান অবস্থা মূল্যায়নের পর পর্যবেক্ষণ",
	"workforce.disability.limitationsOccupationDailyLiving": "কর্মসংস্থান ও দৈনন্দিন কার্যকলাপে সীমাবদ্ধতা",
	"workforce.other.compensationInfo": "ক্ষতিপূরণের তথ্য",
	"workforce.compensation.add": "আরেকটি ক্ষতিপূরণ যোগ করুন",
	"workforce.compensation.date": "ক্ষতিপূরণের তারিখ",
	"workforce.compensation.recievedFrom": "ক্ষতিপূরণ প্রদানকারী প্রতিষ্ঠানের নাম",
	"workforce.compensation.remarks": "মন্তব্য",
	"workforce.compensation.eligible.ForEISAdjustment": "ই.আই.এস. সুবিধা সমন্বয়ের জন্য যোগ্য",
	"workforce.compensation.paymentStatus": "পেমেন্টের অবস্থা",
	"workforce.paid": "পরিশোধিত",
	"workforce.unpaid": "এখনও পরিশোধ করা হয়নি",
	"workforce.processing": "লোডিং ...",
	"workforce.accident.placeOfDeath.label": "মৃত্যুর স্থান",
	"workforce.accident.dateOfDeath.label": "মৃত্যুর তারিখ",
	"workforce.accident.timeOfDeath.label": "মৃত্যুর সময়",
	"workforce.dependent.eis.eligible": "যোগ্য",
	"workforce.dependent.eis.inEligible": "অযোগ্য",
	"workforce.dependent.eligibility.btn": "সমস্ত নির্ভরশীল সংরক্ষণ করুন",
	"workforce.accident.mainType.label": "দুর্ঘটনার ধরন",
	"workforce.employee.application.eisApproval.signature": "ই.আই.এস. অনুমোদনের স্বাক্ষর",
	"workforce.employee.application.eisApproval": "সুবিধাভোগী অনুমোদন নোট",
	"workforce.application.before.association.startDate.error": "আবদেনে উল্লেখিত দূর্ঘটনার তারিখ কারখানার সংশ্লিষ্ট এসোসিয়েশনের শুরুর তারিখ হতে পরে হতে পারবে না।",
	"workforce.application.before.deathDate.error": "দুর্ঘটনার তারিখ মৃত্যুর তারিখের পরে হতে পারবে না।",
	"workforce.application.before.joiningDate.error": "দুর্ঘটনার তারিখ যোগদানের তারিখের আগের হতে পারে না।",
	"workforce.application.factory.activation.error": "কারখানাটি এখনও সক্রিয় হয়নি।",
	"workforce.application.before.eis.startDate.error": "২১ জুন ২০২২ এর আগে সংঘটিত কোনো ঘটনার জন্য EIS পাইলট প্রকল্পে আবেদন গ্রহণযোগ্য নয়।",
	"workforce.accident.hospitalInfo.title": "হাসপাতালের তথ্য",
	"workforce.accident.addHospital.btn": "হাসপাতালের তথ্য যোগ করুন",
	"workforce.add.hospital.info": "একাধিক হাসপাতালে চিকিৎসা গ্রহণ করলে এখানে ক্লিক করুন",
	"workforce.application.steps.bankInfo": "ব্যাংকের তথ্য",
	"workforce.update.btn": "আপডেট",
	"worforce.dependent.suffix": "র",
	"workforce.login_name_already_exists": "জাতীয় পরিচয়পত্র/জন্ম সনদ নম্বর ইতিমধ্যেই নিবন্ধিত",
	"workforce.phone_number_already_exists": "ফোন নম্বর ইতিমধ্যে নিবন্ধিত",
	"workforce.application.duplicate.found": "এই শ্রমিকের জন্য একটি ডুপ্লিকেট আবেদন ইতিমধ্যে বিদ্যমান। আপনাকে হোম পেজে পুনর্নির্দেশিত করা হবে।",
	"workforce.rejoinDate.error": "পুনরায় যোগদানের তারিখ দুর্ঘটনার তারিখের আগে হতে পারে না।",
	"workforce.dashboard.overallFilters": "সার্বিক ফিল্টার",
	"workforce.dashboard.appSubmissionDate": "আবেদন জমার তারিখ",
	"workforce.dashboard.accidentDate": "দুর্ঘটনার তারিখ",
	"workforce.dashboard.allAssociations": "সকল অ্যাসোসিয়েশন",
	"workforce.dashboard.filter.all": "সব",
	"workforce.dashboard.lastMeetingOverview": "পূর্ববর্তী সভার ওভারভিউ",
	"workforce.dashboard.lastMeeting.presented": "উপস্থাপিত মোট আবেদনের সংখ্যা",
	"workforce.dashboard.lastMeeting.approved": "অনুমোদিত মোট আবেদনের সংখ্যা",
	"workforce.dashboard.lastMeeting.rejected": "প্রত্যাখ্যাত মোট আবেদনের সংখ্যা",
	"workforce.dashboard.lastMeeting.reverted": "ঘ. ফেরত পাঠানো মোট আবেদনের সংখ্যা",
	"workforce.dashboard.ongoingMeetingOverview": "চলমান সভার ওভারভিউ",
	"workforce.dashboard.ongoingMeeting.caseType": "আবেদনের ধরন:",
	"workforce.dashboard.ongoingMeeting.deathCount": "মৃত্যুর সংখ্যা",
	"workforce.dashboard.ongoingMeeting.disabilityCount": "অক্ষমতার সংখ্যা",
	"workforce.dashboard.ongoingMeeting.accidentType": "দুর্ঘটনার ধরন:",
	"workforce.dashboard.ongoingMeeting.commutingCount": "যাতায়াতকালীন দুর্ঘটনার সংখ্যা",
	"workforce.dashboard.ongoingMeeting.workplaceCount": "কর্মস্থলের দুর্ঘটনার সংখ্যা",
	"workforce.dashboard.ongoingMeeting.rtaCount": "দায়িত্ব পালনকালে সড়ক দুর্ঘটনার (RTA) সংখ্যা",
	"workforce.dashboard.financialOverview": "আর্থিক ওভারভিউ",
	"workforce.dashboard.financial.paidTillNow": "এ পর্যন্ত মোট পরিশোধিত",
	"workforce.dashboard.financial.deathTotal": "মৃত্যুর মোট পরিমাণ",
	"workforce.dashboard.financial.disabilityTotal": "অক্ষমতার মোট পরিমাণ",
	"workforce.dashboard.financial.approxLifetime": "মোট আনুমানিক আজীবন পরিমাণ",
	"workforce.dashboard.appSegregation": "অনুমোদন ভিত্তিক আবেদন পৃথকীকরণ",
	"workforce.dashboard.accidentVsTime": "দুর্ঘটনা বনাম সময়ের গ্রাফ",
	"workforce.dashboard.pipeline": "প্রক্রিয়াধীন আবেদনসমূহ",
	"workforce.dashboard.pipeline.subtitle": "কোন পর্যায়ে কতগুলো আবেদন অপেক্ষমান আছে",
	"workforce.dashboard.pipeline.factory": "কারখানা পর্যায়ে অপেক্ষমান",
	"workforce.dashboard.pipeline.association": "অ্যাসোসিয়েশন পর্যায়ে অপেক্ষমান",
	"workforce.dashboard.pipeline.eis": "ইআইএস পর্যায়ে অপেক্ষমান",
	"workforce.dashboard.pending": "অপেক্ষমান আবেদনসমূহ",
	"workforce.dashboard.pending.subtitle": "যে আবেদনগুলো এখনও অনুমোদিত হয়নি",
	"workforce.dashboard.pending.verified": "যাচাইকৃত আবেদন",
	"workforce.dashboard.pending.nonVerified": "অযাচাইকৃত আবেদন",
	"workforce.dashboard.pending.death": "মৃত্যুর সংখ্যা",
	"workforce.dashboard.pending.disability": "অক্ষমতার সংখ্যা",
	"workforce.dashboard.overview": "আবেদনের ওভারভিউ",
	"workforce.dashboard.overview.subtitle": "শুধুমাত্র অনুমোদিত আবেদনসমূহ",
	"workforce.dashboard.overview.death": "মৃত্যু",
	"workforce.dashboard.overview.disability": "অক্ষমতা",
	"workforce.dashboard.overview.deadMale": "মৃত পুরুষ কর্মী",
	"workforce.dashboard.overview.deadFemale": "মৃত নারী কর্মী",
	"workforce.dashboard.overview.maleWorker": "পুরুষ কর্মীর সংখ্যা",
	"workforce.dashboard.overview.femaleWorker": "নারী কর্মীর সংখ্যা",
	"workforce.dashboard.beneficiary": "সুবিধাভোগীর ওভারভিউ",
	"workforce.dashboard.beneficiary.subtitle": "শুধুমাত্র অনুমোদিত আবেদনসমূহ (পরিচালনা করতে ক্লিক করুন)",
	"workforce.dashboard.beneficiary.male": "পুরুষ সুবিধাভোগীর সংখ্যা",
	"workforce.dashboard.beneficiary.female": "নারী সুবিধাভোগীর সংখ্যা",
	"workforce.dashboard.beneficiary.total": "মোট সুবিধাভোগীর সংখ্যা",
	"workforce.dashboard.accidentSegregation": "দুর্ঘটনার ধরন পৃথকীকরণ",
	"workforce.dashboard.accidentSegregation.subtitle": "শুধুমাত্র অনুমোদিত আবেদনসমূহ",
	"workforce.dashboard.accidentSegregation.workplace": "কর্মস্থলের দুর্ঘটনা",
	"workforce.dashboard.accidentSegregation.commuting": "যাতায়াতকালীন দুর্ঘটনা",
	"workforce.dashboard.accidentSegregation.rta": "দায়িত্ব পালনকালে সড়ক দুর্ঘটনা (RTA)",
	"workforce.dashboard.monitoring": "সুবিধাভোগী পর্যবেক্ষণ",
	"workforce.dashboard.monitoring.almost18": "বয়স প্রায় ১৮ বছর (১৭ থেকে < ১৮)",
	"workforce.dashboard.monitoring.adultFemale": "প্রাপ্তবয়স্ক অবিবাহিত নারী",
	"workforce.dashboard.monitoring.elderly": "প্রবীণ সুবিধাভোগী (> ৬০ বছর)",
	"workforce.dashboard.monitoring.widowUnder35": "৩৫ বছরের কম বয়সী বিধবা/বিপত্নীক",
	"workforce.dashboard.verification": "সুবিধাভোগী যাচাইকরণের ওভারভিউ",
	"workforce.dashboard.verification.pending1m": "অপেক্ষমান লাইভ যাচাইকরণ (১ মাস)",
	"workforce.dashboard.verification.pending3m": "অপেক্ষমান লাইভ যাচাইকরণ (৩ মাস)",
	"workforce.dashboard.verification.pending6m": "অপেক্ষমান লাইভ যাচাইকরণ (৬ মাস)",
	"workforce.dashboard.verification.pending9m": "অপেক্ষমান লাইভ যাচাইকরণ (৯ মাস)",
	"workforce.dashboard.verification.successful": "সফল লাইভ যাচাইকরণ",
	"workforce.dashboard.marriage": "বৈবাহিক অবস্থার ওভারভিউ",
	"workforce.dashboard.marriage.widow": "অবিবাহিত বিধবা",
	"workforce.dashboard.marriage.widower": "অবিবাহিত বিপত্নীক",
	"workforce.dashboard.marriage.sister": "অবিবাহিত বোন",
	"workforce.dashboard.marriage.daughter": "অবিবাহিত মেয়ে",
	"workforce.dashboard.marriage.grandDaughter": "অবিবাহিত নাতনি",
	"workforce.dashboard.payment": "মাসিক পেমেন্ট স্ট্যাটাসের সংখ্যা",
	"workforce.dashboard.payment.subtitle": "বর্তমান বছরের চলতি মাস",
	"workforce.dashboard.payment.disbursed": "পেমেন্ট প্রদান করা হয়েছে",
	"workforce.dashboard.payment.pending": "পেমেন্ট অপেক্ষমান (প্রদান করা হয়নি)",
	"workforce.dashboard.payment.onHold": "পেমেন্ট স্থগিত আছে",
	"workforce.dashboard.months.1": "১ মাস",
	"workforce.dashboard.months.3": "৩ মাস",
	"workforce.dashboard.months.6": "৬ মাস",
	"workforce.dashboard.months.12": "১২ মাস",
	"workforce.dashboard.fund.all": "সকল তহবিল",
	"workforce.dashboard.fund.cf": "কেন্দ্রীয় তহবিল",
	"workforce.dashboard.fund.blwf": "বাংলাদেশ শ্রমিক কল্যাণ ফাউন্ডেশন",
	"workforce.dashboard.fund.eis": "এমপ্লয়ি ইন্জুরি স্কিম",
	"workforce.dashboard.chart.processing": "প্রক্রিয়াধীন",
	"workforce.dashboard.chart.approved": "অনুমোদিত",
	"workforce.dashboard.chart.reverted": "বাতিল",
	"workforce.dashboard.chart.medical": "চিকিৎসা",
	"workforce.dashboard.chart.educational": "শিক্ষা",
	"workforce.dashboard.chart.maternity": "মাতৃত্ব",
	"workforce.dashboard.chart.disability": "স্থায়ী ও অস্থায়ী অক্ষমতা",
	"workforce.dashboard.chart.numberAccidents": "দুর্ঘটনার সংখ্যা",
	"workforce.dashboard.assessments.previous": "পূর্ববর্তী মূল্যায়নের ওভারভিউ",
	"workforce.dashboard.assessments.ongoing": "চলমান মূল্যায়নের ওভারভিউ",
	"workforce.dashboard.assessments.total": "মোট মূল্যায়ন",
	"workforce.dashboard.assessments.byGender": "লিঙ্গ অনুসারে",
	"workforce.dashboard.assessments.byAccidentType": "দুর্ঘটনার ধরন অনুসারে",
	"workforce.dashboard.assessments.maleCount": "পুরুষের সংখ্যা",
	"workforce.dashboard.assessments.femaleCount": "নারীর সংখ্যা",
	"workforce.dashboard.assessments.maleOnly": "পুরুষ",
	"workforce.dashboard.assessments.femaleOnly": "নারী",
	"workforce.dashboard.assessments.commuting": "যাতায়াতকালীন",
	"workforce.dashboard.assessments.workplace": "কর্মস্থলের দুর্ঘটনা",
	"workforce.dashboard.assessments.rta": "দায়িত্ব পালনকালে সড়ক দুর্ঘটনা (RTA)",
	"profile.mainMenu": "প্রোফাইল",
	"profile.menu.changePassword": "পাসওয়ার্ড পরিবর্তন করুন",
	"profile.ChangePasswordPage.title": "পাসওয়ার্ড পরিবর্তন",
	"profile.ChangePasswordPage.notEqualError": "পাসওয়ার্ড একই নয়",
	"profile.ChangePasswordPage.oldPasswordLabel": "বর্তমান পাসওয়ার্ড",
	"profile.ChangePasswordPage.newPasswordLabel": "নতুন পাসওয়ার্ড",
	"profile.ChangePasswordPage.confirmPasswordLabel": "নতুন পাসওয়ার্ড নিশ্চিত করুন",
	"profile.ChangePasswordPage.submitButton": "সাবমিট করুন",
	"profile.menu.myProfile": "আমার প্রোফাইল",
	"profile.menu.dashboard": "ড্যাশবোর্ড",
	"profile.menu.editProfile": "তথ্য পরিবর্তন",
	"profile.MyProfilePage.title": "আমার প্রোফাইল",
	"profile.MyProfilePage.editTitle": "প্রোফাইল তথ্য পরিবর্তন",
	"profile.roles": "এসাইনকৃত রোলসমূহ",
	"profile.role": "রোল",
	"profile.regions": "বিভাহ",
	"profile.districts": "জেলাসমূহ",
	"profile.userName": "ইউজারনেম",
	"profile.otherNames": "নাম (বাংলা)",
	"profile.lastName": "নাম (ইংরেজি)",
	"profile.email": "ই-মেইল",
	"profile.phone": "ফোন নাম্বার",
	"profile.language": "সিস্টেমের ভাষা",
	"profile.fullname": "পূর্ণ নাম",
	"profile.saveProfile": "তথ্য সংরক্ষণ করুন",
	"profile.updated.successfully": "তথ্য সফলভাবে আপডেট হয়েছে",
	"workforce.application.beneficiaryManagement": "সুবিধাভোগী ব্যবস্থাপনা",
	"workforce.application.beneficiaryPaymentProcess": "সুবিধাভোগী পেমেন্ট প্রসেসিং",
	"workforce.application.beneficiaryDisbursedPayments": "ডিসবার্সকৃত পেমেন্টেসমূহ",
	"workforce.application.beneficiaryNoaConfirmation": "এন.ও.এ কনফার্মেশন",
	"workforce.application.beneficiaryProcessedPaymentList": "প্রসেসকৃত পেমেন্টের তালিকা",
	"workforce.application.beneficiaryPayments": "সুবিধাভোগী পেমেন্টসমূহ",
	"workforce.modal.saveCalculation": "ক্যালকুলেশন সেভ করুন",
	"workforce.modal.recalculate": "পুনরায় ক্যালকুলেশন করুন",
	"workforce.dashboard": "ড্যাশবোর্ড",
	"menu.workforce.association.user.map": "এসোসিয়েশনের সাথে ইউজার ম্যাপিং",
	"workforce.application.beneficiaryBankAdviceList": "জেনারেটকৃত ব্যাংক এডভাইস-সমূহ",
	"menu.workforce.committee.management": "কমিটি ব্যবস্থাপনা",
	"workforce.generateBFTN.beneficiary.payment.calculation": "উপকারভোগীর অর্থ প্রদানের হিসাব",
	"workforce.generate.committee.report": "কমিটির প্রতিবেদন তৈরি করুন",
	"workforce.factory.edit.title": "ফ্যাক্টরি সম্পাদনা করুন",
	"workforce.factory.basicInfo": "মৌলিক তথ্য",
	"workforce.factory.contactInfo": "যোগাযোগ তথ্য",
	"workforce.factory.licenseType": "লাইসেন্সের ধরন",
	"workforce.factory.locationInfo": "অবস্থান তথ্য",
	"workforce.factory.officeLocation": "অফিসের অবস্থান",
	"workforce.factory.officeAddress": "অফিসের ঠিকানা",
	"workforce.factory.registrationInfo": "নিবন্ধন তথ্য",
	"workforce.factory.dateOfEstablishment": "প্রতিষ্ঠার তারিখ",
	"workforce.factory.eisIncorporationDate": "ইআইএস অন্তর্ভুক্তির তারিখ",
	"workforce.factory.registrationDate": "নিবন্ধন তারিখ",
	"workforce.factory.registrationExpiryDate": "নিবন্ধন মেয়াদ শেষের তারিখ",
	"workforce.factory.limaRegistrationNumber": "লিমা নিবন্ধন নম্বর",
	"workforce.factory.licenseNumber": "লাইসেন্স নম্বর",
	"workforce.factory.additionalDetails": "অতিরিক্ত বিবরণ",
	"workforce.factory.numberOfEmployees": "আনুমানিক কর্মচারী সংখ্যা",
	"workforce.factory.membershipNumber": "সদস্যতা নম্বর",
	"workforce.factory.groupName": "গ্রুপের নাম",
	"workforce.factory.representativeInfo": "প্রতিনিধি তথ্য",
	"workforce.factory.updateSuccessful": "ফ্যাক্টরি সফলভাবে আপডেট করা হয়েছে",
	"workforce.factory.back": "ফ্যাক্টরিতে ফিরে যান",
	"workforce.factory.details": "ফ্যাক্টরি বিবরণ",
	"workforce.factory.uploadedDocuments": "আপলোড করা নথিপত্র",
	"workforce.factory.uploadDocuments": "ফ্যাক্টরি নথিপত্র আপলোড করুন",
	"workforce.factory.noDocuments": "এই ফ্যাক্টরির জন্য কোনো নথি আপলোড করা হয়নি",
	"workforce.factory.documentType": "নথির ধরন",
	"workforce.factory.documentFile": "ফাইলের নাম",
	"workforce.factory.documentStatus": "অবস্থা",
	"workforce.factory.documentAction": "কর্ম",
	"workforce.factory.viewDocument": "নথি দেখুন",
	"workforce.factory.approveFactory": "ফ্যাক্টরি অনুমোদন করুন",
	"workforce.factory.confirmApproval": "অনুমোদন নিশ্চিত করুন",
	"workforce.factory.approveConfirmMsg": "আপনি কি এই ফ্যাক্টরি অনুমোদন করতে নিশ্চিত?",
	"workforce.factory.approveConfirmDesc": "এই পদক্ষেপটি ফ্যাক্টরির অবস্থা \"সক্রিয়\" এ পরিবর্তন করবে।",
	"workforce.factory.approving": "অনুমোদন করছে...",
	"workforce.factory.confirm": "নিশ্চিত করুন",
	"workforce.factory.cancel": "বাতিল করুন",
	"workforce.factory.uploaded": "আপলোড করা হয়েছে",
	"workforce.factory.downloadDocument": "নথি ডাউনলোড করুন",
	"workforce.factory.currentDocuments": "বর্তমান নথিসমূহ",
	"workforce.factory.uploadDocumentsHelp": "এই ফ্যাক্টরির জন্য নতুন নথি আপলোড করুন। আপলোড করার আগে নথির ধরন নির্বাচন করুন।",
	"menu.website.legal.guidelines": "ওয়েবসাইটের জন্য আইনী নির্দেশিকা ম্যানেজমেন্ট",
	"menu.website.visitor.messages": "ওয়েবসাইটের ভিজিটরদের মেসেজ",
	"workforce.banks.title": "ব্যাংক",
	"workforce.banks.branches.title": "শাখা সমূহ",
	"workforce.banks.addNewTooltip": "ব্যাংক/শাখা যোগ করুন",
	"workforce.banks.bankCode": "ব্যাংক কোড",
	"workforce.banks.district": "জেলা",
	"workforce.processing.data": "ডেটা প্রক্রিয়াজাত করা হচ্ছে।",
	"workforce.please.wait": "অনুগ্রহ করে অপেক্ষা করুন",
	"workforce.application.photo.cropandupload": "ক্রপ সম্পন্ন করুন এবং আপলোড করুন",
	"workforce.application.photo.cropmessage": "আপনার নির্বাচনকৃত ছবিটিকে পাসপোর্ট সাইজে ক্রপ করতে হবে।",
	"workforce.reject.reason": "প্রত্যাখ্যানের কারণ যোগ করুন",
	"workforce.reject.reason.placeholder": "প্রত্যাখ্যানের কারণ লিখুন...",
	"workforce.application.rejected": "বাতিলকৃত আবেদনসমূহ",
	"workforce.previous.history.button": "পূর্ববর্তী আবেদনের তথ্য",
	"workforce.previous.history.list": "পূর্ববর্তী আবেদনের তালিকা",
	"workforce.accidentType.insideFactory": "কারখানার ভিতরে",
	"workforce.accidentType.fromWorkplaceToHome": "কর্মস্থল থেকে বাসায় যাওয়ার পথে",
	"workforce.accidentType.fromHomeToWorkplace": "বাসা থেকে কর্মস্থলে যাওয়ার পথে",
	"workforce.accidentType.workRelatedTravel": "কর্মস্থল থেকে অফিসের কাজে অন্যত্র যাওয়া/আসার পথে",
	"workforce.accidentType.otherPlace": "অন্যস্থানে"
};

function formatRepresentativeGQL(representative) {
  return "\n    ".concat(representative.id ? "id: \"".concat(formatGQLString(representative.id), "\"") : "", "\n    ").concat(representative.nameEn ? "nameEn: \"".concat(formatGQLString(representative.nameEn), "\"") : "", "\n    ").concat(representative.nameBn ? "nameBn: \"".concat(formatGQLString(representative.nameBn), "\"") : "", "\n    ").concat(representative.location.id ? "locationId: \"".concat(decodeId(representative.location.id), "\"") : "", "\n    ").concat(representative.address ? "address: \"".concat(formatGQLString(representative.address), "\"") : "", "\n    ").concat(representative.phoneNumber ? "phoneNumber: \"".concat(formatGQLString(representative.phoneNumber), "\"") : "", "\n    ").concat(representative.email ? "email: \"".concat(formatGQLString(representative.email), "\"") : "", "\n    ").concat(representative.nid ? "nid: \"".concat(formatGQLString(representative.nid), "\"") : "", "\n    ").concat(representative.passportNo ? "passportNo: \"".concat(formatGQLString(representative.passportNo), "\"") : "", "\n    ").concat(representative.birthDate ? "birthDate: \"".concat(formatGQLString(representative.birthDate), "\"") : "", "\n    ").concat(representative.position ? "position: \"".concat(formatGQLString(representative.position), "\"") : "", "\n    ").concat(representative.type ? "type: \"".concat(formatGQLString(representative.type), "\"") : "", "\n  ");
}
function formatOrganizationGQL(organization) {
  return "\n    ".concat(organization.type ? "type: \"".concat(formatGQLString(organization.type), "\"") : "", "\n    ").concat(organization.id ? "id: \"".concat(organization.id, "\"") : "", "\n    ").concat(organization.nameEn ? "nameEn: \"".concat(formatGQLString(organization.nameEn), "\"") : "", "\n    ").concat(organization.nameBn ? "nameBn: \"".concat(formatGQLString(organization.nameBn), "\"") : "", "\n    ").concat(organization.location.id ? "locationId: \"".concat(decodeId(organization.location.id), "\"") : "", "\n    ").concat(organization.parent ? "parentId: \"".concat(decodeId(organization.parent), "\"") : "", "\n    ").concat(organization.workforceRepresentativeId ? "workforceRepresentativeId: \"".concat(decodeId(organization.workforceRepresentativeId), "\"") : "", "\n    ").concat(organization.address ? "address: \"".concat(formatGQLString(organization.address), "\"") : "", "\n    ").concat(organization.phoneNumber ? "phoneNumber: \"".concat(formatGQLString(organization.phoneNumber), "\"") : "", "\n    ").concat(organization.email ? "email: \"".concat(formatGQLString(organization.email), "\"") : "", "\n    ").concat(organization.website ? "website: \"".concat(formatGQLString(organization.website), "\"") : "", "\n  ");
}
function formatUnitGQL(unit) {
  var _unit$organization;
  console.log(unit);
  return "\n    ".concat(unit.id ? "id: \"".concat(formatGQLString(unit.id), "\"") : "", "\n    ").concat(unit.nameEn ? "nameEn: \"".concat(formatGQLString(unit.nameEn), "\"") : "", "\n    ").concat(unit.nameBn ? "nameBn: \"".concat(formatGQLString(unit.nameBn), "\"") : "", "\n    ").concat(unit.phoneNumber ? "phoneNumber: \"".concat(formatGQLString(unit.phoneNumber), "\"") : "", "\n    ").concat(unit.email ? "email: \"".concat(formatGQLString(unit.email), "\"") : "", "\n    ").concat(unit.level ? "unitLevel: \"".concat(unit.level, "\"") : "", "\n    ").concat(unit.parent && unit.parent.id ? "parentId: \"".concat(decodeId(unit.parent.id), "\"") : "", "\n    ").concat((_unit$organization = unit.organization) !== null && _unit$organization !== void 0 && _unit$organization.id ? "organizationId: \"".concat(decodeId(unit.organization.id), "\"") : "", "\n  ");
}
function formatBankGQL(bank) {
  console.log({
    bank: bank
  });
  return "\n    ".concat(bank !== null && bank !== void 0 && bank.id ? "id: \"".concat(decodeId(bank === null || bank === void 0 ? void 0 : bank.id), "\"") : "", "\n    ").concat(bank !== null && bank !== void 0 && bank.nameEn ? "nameEn: \"".concat(formatGQLString(bank.nameEn), "\"") : "", "\n    ").concat(bank !== null && bank !== void 0 && bank.nameBn ? "nameBn: \"".concat(formatGQLString(bank.nameBn), "\"") : "", "\n    ").concat(bank !== null && bank !== void 0 && bank.bankCode ? "bankCode: \"".concat(formatGQLString(bank.bankCode), "\"") : "", "\n    ").concat(bank !== null && bank !== void 0 && bank.branchCode ? "branchCode: \"".concat(formatGQLString(bank.branchCode), "\"") : "", "\n    ").concat(bank !== null && bank !== void 0 && bank.districtCode ? "districtCode: \"".concat(formatGQLString(bank.districtCode), "\"") : "", "\n    ").concat(bank !== null && bank !== void 0 && bank.districtNameEn ? "districtNameEn: \"".concat(formatGQLString(bank.districtNameEn), "\"") : "", "\n    ").concat(bank !== null && bank !== void 0 && bank.districtNameBn ? "districtNameBn: \"".concat(formatGQLString(bank.districtNameBn), "\"") : "", "\n    ").concat(bank !== null && bank !== void 0 && bank.routingNumber ? "routingNumber: \"".concat(formatGQLString(bank.routingNumber), "\"") : "", "\n    ").concat(bank !== null && bank !== void 0 && bank.parentId ? "parentId: \"".concat(decodeId(bank.parentId), "\"") : "", "\n    ").concat(bank !== null && bank !== void 0 && bank.contactNumber ? "contactNumber: \"".concat(formatGQLString(bank.contactNumber), "\"") : "", "\n    ").concat(bank !== null && bank !== void 0 && bank.type ? "type: \"".concat(formatGQLString(bank.type), "\"") : "", "\n    ").concat(bank !== null && bank !== void 0 && bank.status ? "status: \"".concat(formatGQLString(bank.status), "\"") : "", "\n  ");
}
function formatEducationInfoGQL(education) {
  console.log({
    education: education
  });
  return "\n    ".concat(education !== null && education !== void 0 && education.id ? "id: \"".concat(education === null || education === void 0 ? void 0 : education.id, "\"") : "", "\n    ").concat(education !== null && education !== void 0 && education.applicationId ? "applicationId: \"".concat(education === null || education === void 0 ? void 0 : education.applicationId, "\"") : "", "\n    ").concat(education !== null && education !== void 0 && education.educationLevel ? "educationLevel: \"".concat(education === null || education === void 0 ? void 0 : education.educationLevel, "\"") : "", "\n    ").concat(education !== null && education !== void 0 && education.educationBoard ? "educationBoard: \"".concat(education === null || education === void 0 ? void 0 : education.educationBoard, "\"") : "", "\n    ").concat(education !== null && education !== void 0 && education.passingYear ? "passingYear: \"".concat(education === null || education === void 0 ? void 0 : education.passingYear, "\"") : "", "\n    ").concat(education !== null && education !== void 0 && education.locationId ? "locationId: \"".concat(decodeId(education === null || education === void 0 ? void 0 : education.locationId.id), "\"") : "", "\n    ").concat(education !== null && education !== void 0 && education.rollNumber ? "rollNumber: \"".concat(education === null || education === void 0 ? void 0 : education.rollNumber, "\"") : "", "\n    ").concat(education !== null && education !== void 0 && education.registrationNumber ? "registrationNumber: \"".concat(education === null || education === void 0 ? void 0 : education.registrationNumber, "\"") : "", "\n    ").concat(education !== null && education !== void 0 && education.childNidNo ? "childNidNo: \"".concat(education === null || education === void 0 ? void 0 : education.childNidNo, "\"") : "", "\n    ").concat(education !== null && education !== void 0 && education.childNameEn ? "childNameEn: \"".concat(education === null || education === void 0 ? void 0 : education.childNameEn, "\"") : "", "\n    ").concat(education !== null && education !== void 0 && education.childNameBn ? "childNameBn: \"".concat(education === null || education === void 0 ? void 0 : education.childNameBn, "\"") : "", "\n    ").concat(education !== null && education !== void 0 && education.childBirthDate ? "childBirthDate: \"".concat(education === null || education === void 0 ? void 0 : education.childBirthDate, "\"") : "", "\n    ").concat(education !== null && education !== void 0 && education.childBirthCertificateNo ? "childBirthCertificateNo: \"".concat(education === null || education === void 0 ? void 0 : education.childBirthCertificateNo, "\"") : "", "\n    ").concat(education !== null && education !== void 0 && education.studyClass ? "studyClass: \"".concat(education === null || education === void 0 ? void 0 : education.studyClass, "\"") : "", "\n    ").concat(education !== null && education !== void 0 && education.result ? "result: \"".concat(education === null || education === void 0 ? void 0 : education.result, "\"") : "", "\n    ").concat(education !== null && education !== void 0 && education.institution ? "institution: \"".concat(education === null || education === void 0 ? void 0 : education.institution, "\"") : "", "\n  ");
}
function formatApplicationSummaryGQL(applicationSummary) {
  return "\n    ".concat(applicationSummary !== null && applicationSummary !== void 0 && applicationSummary.id ? "id: \"".concat(formatGQLString(applicationSummary === null || applicationSummary === void 0 ? void 0 : applicationSummary.id), "\"") : "", "\n    ").concat(applicationSummary !== null && applicationSummary !== void 0 && applicationSummary.applicationData ? "applicationData: ".concat(escapeQuotes$1(applicationSummary === null || applicationSummary === void 0 ? void 0 : applicationSummary.applicationData)) : "", "\n    ").concat(applicationSummary.name ? "name: \"".concat(applicationSummary.name, "\"") : "", "\n    ").concat(applicationSummary.remarks ? "remarks: \"".concat(applicationSummary.remarks, "\"") : "", "\n    ").concat(applicationSummary.meetingDate ? "meetingDate: \"".concat(applicationSummary.meetingDate, "\"") : "", "\n    ").concat(applicationSummary !== null && applicationSummary !== void 0 && applicationSummary.status ? "status: \"".concat(formatGQLString(applicationSummary.status), "\"") : "", "\n    ").concat(applicationSummary !== null && applicationSummary !== void 0 && applicationSummary.year ? "year: ".concat(applicationSummary.year) : "", "\n    ").concat(applicationSummary !== null && applicationSummary !== void 0 && applicationSummary.sectionType ? "sectionType: \"".concat(applicationSummary.sectionType, "\"") : "", "\n    ").concat(applicationSummary !== null && applicationSummary !== void 0 && applicationSummary.month ? "month: \"".concat(formatGQLString(applicationSummary.month), "\"") : "", "\n    ").concat(applicationSummary !== null && applicationSummary !== void 0 && applicationSummary.organizationType ? "organizationType: \"".concat(formatGQLString(applicationSummary.organizationType), "\"") : "", "\n    ").concat(applicationSummary !== null && applicationSummary !== void 0 && applicationSummary.userIds ? "userIds: ".concat(escapeQuotes$1(applicationSummary.userIds)) : "", "\n  ");
}
function formatOrganizationEmployeeGQL(employee) {
  return "\n    ".concat(employee.id ? "id: \"".concat(formatGQLString(employee.id), "\"") : "", "\n    ").concat(employee.nameEn ? "nameEn: \"".concat(formatGQLString(employee.nameEn), "\"") : "", "\n    ").concat(employee.nameBn ? "nameBn: \"".concat(formatGQLString(employee.nameBn), "\"") : "", "\n    ").concat(employee.phoneNumber ? "phoneNumber: \"".concat(formatGQLString(employee.phoneNumber), "\"") : "", "\n    ").concat(employee.email ? "email: \"".concat(formatGQLString(employee.email), "\"") : "", "\n    ").concat(employee.birthDate ? "birthDate: \"".concat(employee.birthDate, "\"") : "", "\n    ").concat(employee.gender ? "gender: \"".concat(employee.gender, "\"") : "", "\n    ").concat(employee.firstJoiningDate ? "firstJoiningDate: \"".concat(employee.firstJoiningDate, "\"") : "", "\n    ").concat(employee.birthCertificateNo ? "birthCertificateNo: \"".concat(employee.birthCertificateNo, "\"") : "", "\n    ").concat(employee.nid ? "nid: \"".concat(employee.nid, "\"") : "", "\n    ").concat(employee.passportNo ? "passportNo: \"".concat(employee.passportNo, "\"") : "", "\n    ").concat(employee.address ? "address: \"".concat(employee.address, "\"") : "", "\n    ").concat(decodeId(employee.location.id) ? "locationId: \"".concat(decodeId(employee.location.id), "\"") : "", "\n    ").concat(employee.status ? "status: \"".concat(employee.status, "\"") : "", "\n    ").concat(employee.relatedUserId ? "relatedUserId: \"".concat(employee.relatedUserId, "\"") : "", "\n  ");
}
function formatWorkforceOfficeGQL(office) {
  return "\n    ".concat(office !== null && office !== void 0 && office.id ? "id: \"".concat(formatGQLString(office.id), "\"") : "", "\n    ").concat(office.company ? "workforceEmployerId: \"".concat(office.company, "\"") : "", "\n    ").concat(office.nameEn ? "nameEn: \"".concat(formatGQLString(office.nameEn), "\"") : "", "\n    ").concat(office.nameBn ? "nameBn: \"".concat(formatGQLString(office.nameBn), "\"") : "", "\n    ").concat(office.phoneNumber ? "phoneNumber: \"".concat(formatGQLString(office.phoneNumber), "\"") : "", "\n    ").concat(office.email ? "email: \"".concat(formatGQLString(office.email), "\"") : "", "\n    ").concat(office.website ? "website: \"".concat(office.website, "\"") : "", "\n    ").concat(office.address ? "address: \"".concat(office.address, "\"") : "", "\n    ").concat(office.location.id ? "locationId: \"".concat(decodeId(office.location.id), "\"") : "", "\n    ").concat(office.status ? "status: \"".concat(office.status, "\"") : "", "\n    ").concat(office.isSameCompanyRepresentative ? "isSameCompanyRepresentative: \"".concat(office.isSameCompanyRepresentative, "\"") : "", "\n    ").concat(office.workforceRepresentativeId ? "workforceRepresentativeId: \"".concat(decodeId(office.workforceRepresentativeId), "\"") : "", "\n\n  ");
}
function formatWorkforceOtherCompensationGQL(otherCompensation) {
  return "\n    ".concat(otherCompensation !== null && otherCompensation !== void 0 && otherCompensation.id ? "id: \"".concat(otherCompensation === null || otherCompensation === void 0 ? void 0 : otherCompensation.id, "\"") : "", "\n    ").concat(otherCompensation !== null && otherCompensation !== void 0 && otherCompensation.entryBy ? "entryBy: \"".concat(otherCompensation === null || otherCompensation === void 0 ? void 0 : otherCompensation.entryBy, "\"") : "", "\n    ").concat(otherCompensation !== null && otherCompensation !== void 0 && otherCompensation.dateOfCompensation ? "dateOfCompensation: \"".concat(otherCompensation === null || otherCompensation === void 0 ? void 0 : otherCompensation.dateOfCompensation, "\"") : "", "\n    ").concat(otherCompensation !== null && otherCompensation !== void 0 && otherCompensation.amount ? "amount: \"".concat(otherCompensation === null || otherCompensation === void 0 ? void 0 : otherCompensation.amount, "\"") : "", "\n    ").concat(otherCompensation !== null && otherCompensation !== void 0 && otherCompensation.statusOfPayment ? "statusOfPayment: \"".concat(otherCompensation === null || otherCompensation === void 0 ? void 0 : otherCompensation.statusOfPayment, "\"") : "", "\n    ").concat((otherCompensation === null || otherCompensation === void 0 ? void 0 : otherCompensation.isEisBenefitAdjustmentEligible) !== undefined && (otherCompensation === null || otherCompensation === void 0 ? void 0 : otherCompensation.isEisBenefitAdjustmentEligible) !== null ? "isEisBenefitAdjustmentEligible: \"".concat(otherCompensation.isEisBenefitAdjustmentEligible, "\"") : "", "\n    ").concat(otherCompensation !== null && otherCompensation !== void 0 && otherCompensation.remarks ? "remarks: \"".concat(otherCompensation === null || otherCompensation === void 0 ? void 0 : otherCompensation.remarks, "\"") : "", "\n    ").concat(otherCompensation !== null && otherCompensation !== void 0 && otherCompensation.paymentType ? "paymentType: \"".concat(otherCompensation === null || otherCompensation === void 0 ? void 0 : otherCompensation.paymentType, "\"") : "", "\n    ").concat(otherCompensation !== null && otherCompensation !== void 0 && otherCompensation.receivedFromOrganization ? "receivedFromOrganization: \"".concat(otherCompensation === null || otherCompensation === void 0 ? void 0 : otherCompensation.receivedFromOrganization, "\"") : "", "\n    ").concat(otherCompensation !== null && otherCompensation !== void 0 && otherCompensation.workforceApplicationId ? "workforceApplicationId: \"".concat(otherCompensation === null || otherCompensation === void 0 ? void 0 : otherCompensation.workforceApplicationId, "\"") : "", "\n  ");
}
function formatWorkforceFactoryGQL(factory) {
  var _factory$company, _factory$location, _factory$officeLocati;
  return "\n    ".concat(factory !== null && factory !== void 0 && factory.id ? "id: \"".concat(formatGQLString(factory === null || factory === void 0 ? void 0 : factory.id), "\"") : "", "\n    ").concat(factory !== null && factory !== void 0 && (_factory$company = factory.company) !== null && _factory$company !== void 0 && _factory$company.id ? "workforceEmployerId: \"".concat(factory === null || factory === void 0 ? void 0 : factory.company.id, "\"") : "", "\n    ").concat(factory !== null && factory !== void 0 && factory.nameEn ? "nameEn: \"".concat(formatGQLString(factory === null || factory === void 0 ? void 0 : factory.nameEn), "\"") : "", "\n    ").concat(factory !== null && factory !== void 0 && factory.nameBn ? "nameBn: \"".concat(formatGQLString(factory === null || factory === void 0 ? void 0 : factory.nameBn), "\"") : "", "\n    ").concat(factory !== null && factory !== void 0 && factory.phoneNumber ? "phoneNumber: \"".concat(formatGQLString(factory === null || factory === void 0 ? void 0 : factory.phoneNumber), "\"") : "", "\n    ").concat(factory !== null && factory !== void 0 && factory.email ? "email: \"".concat(formatGQLString(factory === null || factory === void 0 ? void 0 : factory.email), "\"") : "", "\n    ").concat(factory !== null && factory !== void 0 && factory.website ? "website: \"".concat(factory === null || factory === void 0 ? void 0 : factory.website, "\"") : "", "\n    ").concat(factory !== null && factory !== void 0 && factory.address ? "address: \"".concat(factory === null || factory === void 0 ? void 0 : factory.address, "\"") : "", "\n    ").concat(factory !== null && factory !== void 0 && factory.associationType ? "associationType: \"".concat(factory === null || factory === void 0 ? void 0 : factory.associationType, "\"") : "", "\n    ").concat(factory !== null && factory !== void 0 && (_factory$location = factory.location) !== null && _factory$location !== void 0 && _factory$location.id ? "locationId: \"".concat(decodeId(factory === null || factory === void 0 ? void 0 : factory.location.id), "\"") : "", "\n    ").concat(factory !== null && factory !== void 0 && (_factory$officeLocati = factory.officeLocation) !== null && _factory$officeLocati !== void 0 && _factory$officeLocati.id ? "officeLocationId: \"".concat(decodeId(factory === null || factory === void 0 ? void 0 : factory.officeLocation.id), "\"") : "", "\n    ").concat(factory !== null && factory !== void 0 && factory.status ? "status: \"".concat(factory === null || factory === void 0 ? void 0 : factory.status, "\"") : "", "\n    ").concat(factory !== null && factory !== void 0 && factory.workforceRepresentativeId ? "workforceRepresentativeId: \"".concat(decodeId(factory === null || factory === void 0 ? void 0 : factory.workforceRepresentativeId), "\"") : "", "\n    ").concat(factory !== null && factory !== void 0 && factory.isSameCompanyRepresentative ? "isSameCompanyRepresentative: \"".concat(factory === null || factory === void 0 ? void 0 : factory.isSameCompanyRepresentative, "\"") : "", "\n  ");
}
function formatWorkforceCompanyGQL(company) {
  var DummyEmployerId = Date.now() + "";
  return "\n    ".concat(company !== null && company !== void 0 && company.id ? "id: \"".concat(formatGQLString(company === null || company === void 0 ? void 0 : company.id), "\"") : "", "\n    ").concat(company !== null && company !== void 0 && company.employerId ? "employerId: \"".concat(formatGQLString(company === null || company === void 0 ? void 0 : company.employerId), "\"") : "employerId: \"id ".concat(formatGQLString(DummyEmployerId), "\""), "\n    ").concat(company !== null && company !== void 0 && company.employerIdLima ? "employerIdLima: \"id ".concat(formatGQLString(company === null || company === void 0 ? void 0 : company.employerIdLima), "\"") : "", "\n    ").concat(company !== null && company !== void 0 && company.nameBn ? "nameBn: \"".concat(formatGQLString(company.nameBn), "\"") : "", "\n    ").concat(company !== null && company !== void 0 && company.nameEn ? "nameEn: \"".concat(formatGQLString(company.nameEn), "\"") : "", "\n    ").concat(decodeId(company === null || company === void 0 ? void 0 : company.location.id) ? "locationId: \"".concat(decodeId(company.location.id), "\"") : "", "\n    ").concat(company !== null && company !== void 0 && company.address ? "address: \"".concat(company.address, "\"") : "", "\n    ").concat(company !== null && company !== void 0 && company.phoneNumber ? "phoneNumber: \"".concat(formatGQLString(company.phoneNumber), "\"") : "", "\n    ").concat(company !== null && company !== void 0 && company.website ? "website: \"".concat(company.website, "\"") : "", "\n    ").concat(company !== null && company !== void 0 && company.establishmentDate ? "establishmentDate: \"".concat(company.establishmentDate, "\"") : "", "\n    ").concat(company !== null && company !== void 0 && company.establishmentName ? "establishmentName: \"".concat(company.establishmentName, "\"") : "", "\n    ").concat(company !== null && company !== void 0 && company.email ? "email: \"".concat(formatGQLString(company.email), "\"") : "", "\n    ").concat(company !== null && company !== void 0 && company.associationMembershipNumber ? "associationMembershipNumber: \"".concat(company.associationMembershipNumber, "\"") : "", "\n    ").concat(company !== null && company !== void 0 && company.licenceType ? "licenceType: \"".concat(company === null || company === void 0 ? void 0 : company.licenceType, "\"") : "", "\n    ").concat(company !== null && company !== void 0 && company.licenceNumber ? "licenceNumber: \"".concat(company.licenceNumber, "\"") : "", "\n    ").concat(company !== null && company !== void 0 && company.foundationDate ? "foundationDate: \"".concat(company.foundationDate, "\"") : "", "\n    ").concat(company !== null && company !== void 0 && company.businessSector ? "businessSector: \"".concat(company.businessSector, "\"") : "", "\n    ").concat(company !== null && company !== void 0 && company.status ? "status: \"".concat(company.status, "\"") : "", "\n    ").concat(company !== null && company !== void 0 && company.workforceRepresentativeId ? "workforceRepresentativeId: \"".concat(decodeId(company.workforceRepresentativeId), "\"") : "", "\n\n  ");
}
function formatWorkforceEmployeeGQL(employee) {
  var _employee$presentLoca, _employee$permanentLo;
  return "\n    ".concat(employee !== null && employee !== void 0 && employee.id ? "id: \"".concat(formatGQLString(employee.id), "\"") : "", "\n    ").concat(employee.workforceFactoryId ? "workforceFactoryId: \"".concat(employee.workforceFactoryId, "\"") : "", "\n    ").concat(employee.firstNameBn ? "firstNameBn: \"".concat(formatGQLString(employee.firstNameBn), "\"") : "", "\n    ").concat(employee.lastNameBn ? "lastNameBn: \"".concat(formatGQLString(employee.lastNameBn), "\"") : "", "\n    ").concat(employee.firstNameEn ? "firstNameEn: \"".concat(formatGQLString(employee.firstNameEn), "\"") : "", "\n    ").concat(employee.lastNameEn ? "lastNameEn: \"".concat(formatGQLString(employee.lastNameEn), "\"") : "", "\n    ").concat(employee.otherName ? "otherName: \"".concat(formatGQLString(employee.otherName), "\"") : "", "\n    ").concat(employee.phoneNumber ? "phoneNumber: \"".concat(formatGQLString(employee.phoneNumber), "\"") : "", "\n    ").concat(employee.email ? "email: \"".concat(formatGQLString(employee.email), "\"") : "", "\n    ").concat(employee.birthDate ? "birthDate: \"".concat(employee.birthDate, "\"") : "", "\n    ").concat(employee.joinDate ? "joinDate: \"".concat(employee.joinDate, "\"") : "", "\n    ").concat(employee.deathDate ? "deathDate: \"".concat(employee.deathDate, "\"") : "", "\n    ").concat(employee.gender ? "gender: \"".concat(employee.gender, "\"") : "", "\n    ").concat(employee.birthCertificateNo ? "birthCertificateNo: \"".concat(employee.birthCertificateNo, "\"") : "", "\n    ").concat(employee.nid ? "nid: \"".concat(employee.nid, "\"") : "", "\n    ").concat(employee.insuranceNumber ? "insuranceNumber: \"".concat(employee.insuranceNumber, "\"") : "", "\n    ").concat(employee.passportNo ? "passportNo: \"".concat(employee.passportNo, "\"") : "", "\n    ").concat(employee.permanentAddress ? "permanentAddress: ".concat(escapeQuotes$1(employee.permanentAddress)) : "", "\n    ").concat(employee.presentAddress ? "presentAddress: ".concat(escapeQuotes$1(employee.presentAddress)) : "", "\n    ").concat(employee.position ? "position: \"".concat(employee.position, "\"") : "", "\n    ").concat(employee.monthlyEarning ? "monthlyEarning: \"".concat(employee.monthlyEarning, "\"") : "", "\n    ").concat(employee.fatherNameBn ? "fatherNameBn: \"".concat(employee.fatherNameBn, "\"") : "", "\n    ").concat(employee.fatherNameEn ? "fatherNameEn: \"".concat(employee.fatherNameEn, "\"") : "", "\n    ").concat(employee.motherNameBn ? "motherNameBn: \"".concat(employee.motherNameBn, "\"") : "", "\n    ").concat(employee.motherNameEn ? "motherNameEn: \"".concat(employee.motherNameEn, "\"") : "", "\n    ").concat(employee.spouseNameBn ? "spouseNameBn: \"".concat(employee.spouseNameBn, "\"") : "", "\n    ").concat(employee.spouseNameEn ? "spouseNameEn: \"".concat(employee.spouseNameEn, "\"") : "", "\n    ").concat(employee.maritalStatus ? "maritalStatus: \"".concat(employee.maritalStatus, "\"") : "", "\n    ").concat(employee.citizenship ? "citizenship: \"".concat(employee.citizenship, "\"") : "", "\n    ").concat(employee.privacyLaw ? "privacyLaw: \"".concat(employee.privacyLaw, "\"") : "", "\n    ").concat(employee.employeeType ? "employeeType: \"".concat(employee.employeeType, "\"") : "", "\n    ").concat((_employee$presentLoca = employee.presentLocation) !== null && _employee$presentLoca !== void 0 && _employee$presentLoca.id ? "presentLocationId: \"".concat(decodeId(employee.presentLocation.id), "\"") : "", "\n    ").concat((_employee$permanentLo = employee.permanentLocation) !== null && _employee$permanentLo !== void 0 && _employee$permanentLo.id ? "permanentLocationId: \"".concat(decodeId(employee.permanentLocation.id), "\"") : "", "\n    ").concat(employee.status ? "status: \"".concat(employee.status, "\"") : "", "\n    ").concat(employee.lifeStatus ? "lifeStatus: \"".concat(employee.lifeStatus, "\"") : "", "\n    ").concat(employee !== null && employee !== void 0 && employee.relatedUserId ? "relatedUserId: \"".concat(employee.relatedUserId, "\"") : "", "\n    ").concat(employee !== null && employee !== void 0 && employee.roleId ? "roleId: ".concat(employee.roleId) : "", "\n  ");
}
function formatWorkforceAssociationGQL(association) {
  return "\n    ".concat(association !== null && association !== void 0 && association.id ? "id: \"".concat(safeDecodeId(association.id), "\"") : "", "\n    ").concat(association.nameBn ? "nameBn: \"".concat(formatGQLString(association.nameBn), "\"") : "", "\n    ").concat(association.shortNameBn ? "shortNameBn: \"".concat(formatGQLString(association.shortNameBn), "\"") : "", "\n    ").concat(association.nameEn ? "nameEn: \"".concat(formatGQLString(association.nameEn), "\"") : "", "\n    ").concat(association.shortNameEn ? "shortNameEn: \"".concat(formatGQLString(association.shortNameEn), "\"") : "", "\n    ").concat(association.webAddress ? "webAddress: \"".concat(formatGQLString(association.webAddress), "\"") : "", "\n    ").concat(association.startDate ? "startDate: \"".concat(formatGQLString(association.startDate), "\"") : "", "\n    ").concat(association.address ? "address: \"".concat(formatGQLString(association.address), "\"") : "", "\n    ").concat(association.phone ? "phone: \"".concat(formatGQLString(association.phone), "\"") : "", "\n    ").concat(association.email ? "email: \"".concat(formatGQLString(association.email), "\"") : "", "\n    ").concat(association.status ? "status: \"".concat(association.status, "\"") : "", "\n    ").concat(association.minimumSalary ? "minimumSalary: \"".concat(formatGQLString(association.minimumSalary), "\"") : "", "   \n  ");
}

///application   ////
function formatApplicationeGQL(application) {
  var _application$organiza;
  return "\n  ".concat(application !== null && application !== void 0 && application.id ? "id: \"".concat(application === null || application === void 0 ? void 0 : application.id, "\"") : "", "\n  ").concat(application !== null && application !== void 0 && application.workforceEmployeeId ? "workforceEmployeeId: \"".concat(application === null || application === void 0 ? void 0 : application.workforceEmployeeId, "\"") : "", "\n  ").concat(application !== null && application !== void 0 && application.organizationId ? "organizationId: \"".concat(decodeId(application === null || application === void 0 || (_application$organiza = application.organizationId) === null || _application$organiza === void 0 ? void 0 : _application$organiza.id), "\"") : "", "\n  ").concat(application !== null && application !== void 0 && application.organizationType ? "organizationType: \"".concat(formatGQLString(application === null || application === void 0 ? void 0 : application.organizationType), "\"") : "", "\n  ").concat(application !== null && application !== void 0 && application.applicationType ? "applicationType: \"".concat(formatGQLString(application === null || application === void 0 ? void 0 : application.applicationType), "\"") : "", "\n  ").concat(application !== null && application !== void 0 && application.grantAmount ? "grantAmount: \"".concat(application === null || application === void 0 ? void 0 : application.grantAmount, "\"") : "", "\n  ").concat(application !== null && application !== void 0 && application.status ? "status: \"".concat(application === null || application === void 0 ? void 0 : application.status, "\"") : "", "\n  ").concat(application !== null && application !== void 0 && application.trackingNumber ? "trackingNumber: \"".concat(application === null || application === void 0 ? void 0 : application.trackingNumber, "\"") : "", "\n  ").concat(application !== null && application !== void 0 && application.employeeDependentInfo ? "employeeDependentInfo: ".concat(escapeQuotes$1(application === null || application === void 0 ? void 0 : application.employeeDependentInfo)) : "", "\n  ").concat(application !== null && application !== void 0 && application.employeeBankInfo ? "employeeBankInfo: ".concat(escapeQuotes$1(application === null || application === void 0 ? void 0 : application.employeeBankInfo)) : "", "\n  ").concat(application !== null && application !== void 0 && application.employeeApplicantInfo ? "applicantInfo: ".concat(escapeQuotes$1(application === null || application === void 0 ? void 0 : application.employeeApplicantInfo)) : "", "\n  ").concat(application !== null && application !== void 0 && application.employeeAccidentInfo ? "employeeAccidentInfo: ".concat(escapeQuotes$1(application === null || application === void 0 ? void 0 : application.employeeAccidentInfo)) : "", "\n  ").concat(application !== null && application !== void 0 && application.doctorEntries ? "doctorsEntry: ".concat(escapeQuotes$1(application === null || application === void 0 ? void 0 : application.doctorEntries)) : "", "\n  ").concat(application !== null && application !== void 0 && application.institutionInfo ? "institutionInfo: ".concat(escapeQuotes$1(application === null || application === void 0 ? void 0 : application.institutionInfo)) : "", "\n  ").concat(application !== null && application !== void 0 && application.metadata ? "metadata: ".concat(escapeQuotes$1(application === null || application === void 0 ? void 0 : application.metadata)) : "", "\n  ").concat(application !== null && application !== void 0 && application.employeeChildrenInfo ? "employeeChildrenInfo: ".concat(escapeQuotes$1(application === null || application === void 0 ? void 0 : application.employeeChildrenInfo)) : "", "\n  ").concat(application !== null && application !== void 0 && application.employeeDesignationInfo ? "employeeDesignationInfo: ".concat(escapeQuotes$1(application === null || application === void 0 ? void 0 : application.employeeDesignationInfo)) : "", "\n  ").concat(application !== null && application !== void 0 && application.isSubmitted ? "isSubmitted: \"".concat(application === null || application === void 0 ? void 0 : application.isSubmitted, "\"") : "", "\n  ").concat(application !== null && application !== void 0 && application.submittedBy ? "submittedBy: \"".concat(application === null || application === void 0 ? void 0 : application.submittedBy, "\"") : "", "\n  ").concat(application !== null && application !== void 0 && application.associationType ? "associationType: \"".concat(application === null || application === void 0 ? void 0 : application.associationType, "\"") : "", "\n  ").concat(application !== null && application !== void 0 && application.company ? "employeeEmployerId: \"".concat(application === null || application === void 0 ? void 0 : application.company, "\"") : "", "\n  ").concat(application !== null && application !== void 0 && application.factory ? "employeeFactoryId: \"".concat(application === null || application === void 0 ? void 0 : application.factory, "\"") : "", "\n  ").concat(application !== null && application !== void 0 && application.cfApplicationSummaryId ? "cfApplicationSummaryId: \"".concat(application === null || application === void 0 ? void 0 : application.cfApplicationSummaryId, "\"") : "", "\n  ").concat(application !== null && application !== void 0 && application.eisApplicationSummaryId ? "eisApplicationSummaryId: \"".concat(application === null || application === void 0 ? void 0 : application.eisApplicationSummaryId, "\"") : "", "\n  ").concat(application !== null && application !== void 0 && application.blwfApplicationSummaryId ? "blwfApplicationSummaryId: \"".concat(application === null || application === void 0 ? void 0 : application.blwfApplicationSummaryId, "\"") : "", "\n  ").concat(application !== null && application !== void 0 && application.applicationFor ? "applicationFor: \"".concat(application === null || application === void 0 ? void 0 : application.applicationFor, "\"") : "", "\n  ").concat(application !== null && application !== void 0 && application.doctorsDiagnosis ? "doctorsDiagnosis: \"".concat(application === null || application === void 0 ? void 0 : application.doctorsDiagnosis, "\"") : "", "\n  ").concat(application !== null && application !== void 0 && application.doctorsFlag ? "doctorsFlag: \"".concat(application === null || application === void 0 ? void 0 : application.doctorsFlag, "\"") : "", "\n  ").concat(application !== null && application !== void 0 && application.doctorsRecommendedDonation ? "doctorsRecommendedDonation: \"".concat(application === null || application === void 0 ? void 0 : application.doctorsRecommendedDonation, "\"") : "", "\n  ").concat(application !== null && application !== void 0 && application.doctorComment ? "doctorsFlagNote: \"".concat(application === null || application === void 0 ? void 0 : application.doctorComment, "\"") : "", "\n  ").concat(application !== null && application !== void 0 && application.lastBaseSalary ? "lastBaseSalary: \"".concat(application === null || application === void 0 ? void 0 : application.lastBaseSalary, "\"") : "", "\n  ").concat(application !== null && application !== void 0 && application.deceasedWorkerInfo ? "deceasedWorkerInfo: ".concat(escapeQuotes$1(application === null || application === void 0 ? void 0 : application.deceasedWorkerInfo)) : "", "\n   ").concat(application !== null && application !== void 0 && application.eisApprovedAmount ? "eisApprovedAmount: \"".concat(application === null || application === void 0 ? void 0 : application.eisApprovedAmount, "\"") : "", "\n  ").concat(application !== null && application !== void 0 && application.eisCalculatedAmount ? "eisCalculatedAmount: \"".concat(application === null || application === void 0 ? void 0 : application.eisCalculatedAmount, "\"") : "", "\n  ").concat(application !== null && application !== void 0 && application.eisPaymentType ? "eisPaymentType: \"".concat(application === null || application === void 0 ? void 0 : application.eisPaymentType, "\"") : "", "\n  ").concat(application !== null && application !== void 0 && application.eisInitialMonthlyAmount ? "eisInitialMonthlyAmount: \"".concat(application === null || application === void 0 ? void 0 : application.eisInitialMonthlyAmount, "\"") : "", "\n  ").concat(application !== null && application !== void 0 && application.eisMonthlyAmount ? "eisMonthlyAmount: \"".concat(application === null || application === void 0 ? void 0 : application.eisMonthlyAmount, "\"") : "", "\n  ").concat(application !== null && application !== void 0 && application.initialReplacementRate ? "initialReplacementRate: \"".concat(application === null || application === void 0 ? void 0 : application.initialReplacementRate, "\"") : "", "\n  ").concat(application !== null && application !== void 0 && application.pvFactor ? "pvFactor: \"".concat(application === null || application === void 0 ? void 0 : application.pvFactor, "\"") : "", "\n  ").concat(application !== null && application !== void 0 && application.applicantInfoVerification ? "applicantInfoVerification: \"".concat(application === null || application === void 0 ? void 0 : application.applicantInfoVerification, "\"") : "", "\n  ").concat(application !== null && application !== void 0 && application.applicantInfoVerificationRemarks ? "applicantInfoVerificationRemarks: \"".concat(application === null || application === void 0 ? void 0 : application.applicantInfoVerificationRemarks, "\"") : "", "\n  ").concat(application !== null && application !== void 0 && application.deceasedWorkerInfoVerification ? "deceasedWorkerInfoVerification: \"".concat(application === null || application === void 0 ? void 0 : application.deceasedWorkerInfoVerification, "\"") : "", "\n  ").concat(application !== null && application !== void 0 && application.deceasedWorkerInfoVerificationRemarks ? "deceasedWorkerInfoVerificationRemarks: \"".concat(application === null || application === void 0 ? void 0 : application.deceasedWorkerInfoVerificationRemarks, "\"") : "", "\n  ").concat(application !== null && application !== void 0 && application.doctorsEntryVerification ? "doctorsEntryVerification: \"".concat(application === null || application === void 0 ? void 0 : application.doctorsEntryVerification, "\"") : "", "\n  ").concat(application !== null && application !== void 0 && application.doctorsEntryVerificationRemarks ? "doctorsEntryVerificationRemarks: \"".concat(application === null || application === void 0 ? void 0 : application.doctorsEntryVerificationRemarks, "\"") : "", "\n  ").concat(application !== null && application !== void 0 && application.employeeAccidentInfoVerification ? "employeeAccidentInfoVerification: \"".concat(application === null || application === void 0 ? void 0 : application.employeeAccidentInfoVerification, "\"") : "", "\n  ").concat(application !== null && application !== void 0 && application.employeeAccidentInfoVerificationRemarks ? "employeeAccidentInfoVerificationRemarks: \"".concat(application === null || application === void 0 ? void 0 : application.employeeAccidentInfoVerificationRemarks, "\"") : "", "\n  ").concat(application !== null && application !== void 0 && application.employeeBankInfoVerification ? "employeeBankInfoVerification: \"".concat(application === null || application === void 0 ? void 0 : application.employeeBankInfoVerification, "\"") : "", "\n  ").concat(application !== null && application !== void 0 && application.employeeBankInfoVerificationRemarks ? "employeeBankInfoVerificationRemarks: \"".concat(application === null || application === void 0 ? void 0 : application.employeeBankInfoVerificationRemarks, "\"") : "", "\n  ").concat(application !== null && application !== void 0 && application.employeeChildrenInfoVerification ? "employeeChildrenInfoVerification: \"".concat(application === null || application === void 0 ? void 0 : application.employeeChildrenInfoVerification, "\"") : "", "\n  ").concat(application !== null && application !== void 0 && application.employeeChildrenInfoVerificationRemarks ? "employeeChildrenInfoVerificationRemarks: \"".concat(application === null || application === void 0 ? void 0 : application.employeeChildrenInfoVerificationRemarks, "\"") : "", "\n  ").concat(application !== null && application !== void 0 && application.employeeDependentInfoVerification ? "employeeDependentInfoVerification: \"".concat(application === null || application === void 0 ? void 0 : application.employeeDependentInfoVerification, "\"") : "", "\n  ").concat(application !== null && application !== void 0 && application.employeeDependentInfoVerificationRemarks ? "employeeDependentInfoVerificationRemarks: \"".concat(application === null || application === void 0 ? void 0 : application.employeeDependentInfoVerificationRemarks, "\"") : "", "\n  ").concat(application !== null && application !== void 0 && application.institutionInfoVerification ? "institutionInfoVerification: \"".concat(application === null || application === void 0 ? void 0 : application.institutionInfoVerification, "\"") : "", "\n  ").concat(application !== null && application !== void 0 && application.institutionInfoVerificationRemarks ? "institutionInfoVerificationRemarks: \"".concat(application === null || application === void 0 ? void 0 : application.institutionInfoVerificationRemarks, "\"") : "", "\n  ").concat(application !== null && application !== void 0 && application.metadataVerification ? "metadataVerification: \"".concat(application === null || application === void 0 ? void 0 : application.metadataVerification, "\"") : "", "\n  ").concat(application !== null && application !== void 0 && application.metadataVerificationRemarks ? "metadataVerificationRemarks: \"".concat(application === null || application === void 0 ? void 0 : application.metadataVerificationRemarks, "\"") : "", "\n  ").concat(application !== null && application !== void 0 && application.workforceEmployeeVerification ? "workforceEmployeeVerification: \"".concat(application === null || application === void 0 ? void 0 : application.workforceEmployeeVerification, "\"") : "", "\n  ").concat(application !== null && application !== void 0 && application.workforceEmployeeVerificationRemarks ? "workforceEmployeeVerificationRemarks: \"".concat(application === null || application === void 0 ? void 0 : application.workforceEmployeeVerificationRemarks, "\"") : "", "\n  ").concat(application !== null && application !== void 0 && application.eisApprovalIds ? "eisApprovalIds: ".concat(escapeQuotes$1(application === null || application === void 0 ? void 0 : application.eisApprovalIds)) : "", "\n  ").concat(application !== null && application !== void 0 && application.eisApprovedByIds ? "eisApprovedByIds: ".concat(escapeQuotes$1(application === null || application === void 0 ? void 0 : application.eisApprovedByIds)) : "", "\n  ").concat(application !== null && application !== void 0 && application.committeeId ? "committeeId: \"".concat(application === null || application === void 0 ? void 0 : application.committeeId, "\"") : "", "\n  ").concat(application !== null && application !== void 0 && application.committeeRemarks ? "committeeRemarks: \"".concat(application === null || application === void 0 ? void 0 : application.committeeRemarks, "\"") : "", "\n  ").concat(application !== null && application !== void 0 && application.rejectedIds ? "rejectedIds: ".concat(escapeQuotes$1(application === null || application === void 0 ? void 0 : application.rejectedIds)) : "", "\n");
}
///application movement ////
function formatApplicationMovementGQL(application) {
  return "\n  ".concat(application !== null && application !== void 0 && application.id ? "id: \"".concat(application === null || application === void 0 ? void 0 : application.id, "\"") : "", "\n  ").concat(application !== null && application !== void 0 && application.applicationId ? "applicationId: \"".concat(application === null || application === void 0 ? void 0 : application.applicationId, "\"") : "", "\n  ").concat(application !== null && application !== void 0 && application.note ? "note: \"".concat(application === null || application === void 0 ? void 0 : application.note, "\"") : "", "\n  ").concat(application !== null && application !== void 0 && application.action ? "action: \"".concat(application === null || application === void 0 ? void 0 : application.action, "\"") : "", "\n  ").concat(application !== null && application !== void 0 && application.toEmployeeRecordId ? "toEmployeeRecordId: \"".concat(application === null || application === void 0 ? void 0 : application.toEmployeeRecordId, "\"") : "", "\n  ").concat(application !== null && application !== void 0 && application.fromEmployeeRecordId ? "fromEmployeeRecordId: \"".concat(application === null || application === void 0 ? void 0 : application.fromEmployeeRecordId, "\"") : "", "\n  ").concat(application !== null && application !== void 0 && application.toOfficeUnitOrganogramId ? "toOfficeUnitOrganogramId: \"".concat(application === null || application === void 0 ? void 0 : application.toOfficeUnitOrganogramId, "\"") : "", "\n  ").concat(application !== null && application !== void 0 && application.fromOfficeUnitOrganogramId ? "fromOfficeUnitOrganogramId: \"".concat(application === null || application === void 0 ? void 0 : application.fromOfficeUnitOrganogramId, "\"") : "", "\n  ").concat(application !== null && application !== void 0 && application.toOfficeId ? "toOfficeId: \"".concat(application === null || application === void 0 ? void 0 : application.toOfficeId, "\"") : "", "\n  ").concat(application !== null && application !== void 0 && application.fromOfficeId ? "fromOfficeId: \"".concat(application === null || application === void 0 ? void 0 : application.fromOfficeId, "\"") : "", "\n  ").concat(application !== null && application !== void 0 && application.toOfficeUnitId ? "toOfficeUnitId: \"".concat(application === null || application === void 0 ? void 0 : application.toOfficeUnitId, "\"") : "", "\n  ").concat(application !== null && application !== void 0 && application.fromOfficeUnitId ? "fromOfficeUnitId: \"".concat(application === null || application === void 0 ? void 0 : application.fromOfficeUnitId, "\"") : "", "\n  ").concat(application !== null && application !== void 0 && application.isCurrent ? "isCurrent: \"".concat(application === null || application === void 0 ? void 0 : application.isCurrent, "\"") : "", "\n  ").concat(application !== null && application !== void 0 && application.isCc ? "isCc: \"".concat(application === null || application === void 0 ? void 0 : application.isCc, "\"") : "", "\n  ").concat(application !== null && application !== void 0 && application.isCommitteeHead ? "isCommitteeHead: \"".concat(application === null || application === void 0 ? void 0 : application.isCommitteeHead, "\"") : "", "\n  ").concat(application !== null && application !== void 0 && application.isCommitteeMember ? "isCommitteeMember: \"".concat(application === null || application === void 0 ? void 0 : application.isCommitteeMember, "\"") : "", "\n  ").concat(application !== null && application !== void 0 && application.toEmployeeNameBng ? "toEmployeeNameBng: \"".concat(application === null || application === void 0 ? void 0 : application.toEmployeeNameBng, "\"") : "", "\n  ").concat(application !== null && application !== void 0 && application.fromEmployeeNameBng ? "fromEmployeeNameBng: \"".concat(application === null || application === void 0 ? void 0 : application.fromEmployeeNameBng, "\"") : "", "\n  ").concat(application !== null && application !== void 0 && application.toEmployeeNameEng ? "toEmployeeNameEng: \"".concat(application === null || application === void 0 ? void 0 : application.toEmployeeNameEng, "\"") : "", "\n  ").concat(application !== null && application !== void 0 && application.fromEmployeeNameEng ? "fromEmployeeNameEng: \"".concat(application === null || application === void 0 ? void 0 : application.fromEmployeeNameEng, "\"") : "", "\n  ").concat(application !== null && application !== void 0 && application.toEmployeeDesignationBng ? "toEmployeeDesignationBng: \"".concat(application === null || application === void 0 ? void 0 : application.toEmployeeDesignationBng, "\"") : "", "\n  ").concat(application !== null && application !== void 0 && application.fromEmployeeDesignationBng ? "fromEmployeeDesignationBng: \"".concat(application === null || application === void 0 ? void 0 : application.fromEmployeeDesignationBng, "\"") : "", "\n  ").concat(application !== null && application !== void 0 && application.toOfficeNameBng ? "toOfficeNameBng: \"".concat(application === null || application === void 0 ? void 0 : application.toOfficeNameBng, "\"") : "", "\n  ").concat(application !== null && application !== void 0 && application.fromOfficeNameBng ? "fromOfficeNameBng: \"".concat(application === null || application === void 0 ? void 0 : application.fromOfficeNameBng, "\"") : "", "\n  ").concat(application !== null && application !== void 0 && application.toEmployeeUnitNameBng ? "toEmployeeUnitNameBng: \"".concat(application === null || application === void 0 ? void 0 : application.toEmployeeUnitNameBng, "\"") : "", "\n  ").concat(application !== null && application !== void 0 && application.fromEmployeeUnitNameBng ? "fromEmployeeUnitNameBng: \"".concat(application === null || application === void 0 ? void 0 : application.fromEmployeeUnitNameBng, "\"") : "", "\n  ").concat(application !== null && application !== void 0 && application.fromEmployeeUsername ? "fromEmployeeUsername: \"".concat(application === null || application === void 0 ? void 0 : application.fromEmployeeUsername, "\"") : "", "\n  ").concat(application !== null && application !== void 0 && application.deadlineDate ? "deadlineDate: \"".concat(application === null || application === void 0 ? void 0 : application.deadlineDate, "\"") : "", "\n  ").concat(application !== null && application !== void 0 && application.status ? "status: \"".concat(application === null || application === void 0 ? void 0 : application.status, "\"") : "", "\n  ").concat(application !== null && application !== void 0 && application.revertNote ? "revertNote: \"".concat(application === null || application === void 0 ? void 0 : application.revertNote, "\"") : "", "\n  ").concat((application === null || application === void 0 ? void 0 : application.isReverted) !== undefined ? "isReverted: ".concat(application === null || application === void 0 ? void 0 : application.isReverted) : "", "\n  ").concat(application !== null && application !== void 0 && application.revertedById ? "revertedById: \"".concat(application === null || application === void 0 ? void 0 : application.revertedById, "\"") : "", "\n  ").concat(application !== null && application !== void 0 && application.revertingDate ? "revertingDate: \"".concat(application === null || application === void 0 ? void 0 : application.revertingDate, "\"") : "", "\n  ").concat(application !== null && application !== void 0 && application.applicationFromId ? "applicationFromId: \"".concat(application === null || application === void 0 ? void 0 : application.applicationFromId, "\"") : "", "\n  ").concat(application !== null && application !== void 0 && application.applicationToId ? "applicationToId: \"".concat(application === null || application === void 0 ? void 0 : application.applicationToId, "\"") : "", "\n  ").concat(application !== null && application !== void 0 && application.toRoleId ? "toRoleId: \"".concat(application === null || application === void 0 ? void 0 : application.toRoleId, "\"") : "", "\n  ").concat(application !== null && application !== void 0 && application.fromRoleId ? "fromRoleId: \"".concat(application === null || application === void 0 ? void 0 : application.fromRoleId, "\"") : "", "\n  ").concat(application !== null && application !== void 0 && application.fromOfficeDesignationId ? "fromOfficeDesignationId: \"".concat(application === null || application === void 0 ? void 0 : application.fromOfficeDesignationId, "\"") : "", "\n  ").concat(application !== null && application !== void 0 && application.toOfficeDesignationId ? "toOfficeDesignationId: \"".concat(application === null || application === void 0 ? void 0 : application.toOfficeDesignationId, "\"") : "", "\n");
}
function escapeQuotes$1(data) {
  // Check if it's a string and needs escaping
  if (typeof data === "string") {
    return "\"".concat(data.replace(/"/g, '\\"'), "\"");
  }
  // If it's not a string, stringify it properly
  return "\"".concat(JSON.stringify(data).replace(/"/g, '\\"'), "\"");
}
function formatEmployeeDependentGQL(employee) {
  return "\n    ".concat(employee !== null && employee !== void 0 && employee.id ? "id: \"".concat(formatGQLString(employee === null || employee === void 0 ? void 0 : employee.id), "\"") : "", "\n    ").concat(employee.firstNameBn ? "firstNameBn: \"".concat(formatGQLString(employee.firstNameBn), "\"") : "", "\n    ").concat(employee.lastNameBn ? "lastNameBn: \"".concat(formatGQLString(employee.lastNameBn), "\"") : "", "\n    ").concat(employee.firstNameEn ? "firstNameEn: \"".concat(formatGQLString(employee.firstNameEn), "\"") : "", "\n    ").concat(employee.lastNameEn ? "lastNameEn: \"".concat(formatGQLString(employee.lastNameEn), "\"") : "", "\n    ").concat(employee.phoneNumber ? "phoneNumber: \"".concat(formatGQLString(employee.phoneNumber), "\"") : "", "\n    ").concat(employee.email ? "email: \"".concat(formatGQLString(employee.email), "\"") : "", "\n    ").concat(employee.birthDate ? "birthDate: \"".concat(employee.birthDate, "\"") : "", "\n    ").concat(employee.deathDate ? "deathDate: \"".concat(employee.deathDate, "\"") : "", "\n    ").concat(employee.gender ? "gender: \"".concat(employee.gender, "\"") : "", "\n    ").concat(employee.birthCertificateNo ? "birthCertificateNo: \"".concat(employee.birthCertificateNo, "\"") : "", "\n    ").concat(employee.nid ? "nid: \"".concat(employee.nid, "\"") : "", "\n    ").concat(employee.permanentAddress ? "permanentAddress: \"".concat(employee.permanentAddress, "\"") : "", "\n    ").concat(employee.presentAddress ? "presentAddress: \"".concat(employee.presentAddress, "\"") : "", "\n    ").concat(employee.fatherNameBn ? "fatherNameBn: \"".concat(employee.fatherNameBn, "\"") : "", "\n    ").concat(employee.fatherNameEn ? "fatherNameEn: \"".concat(employee.fatherNameEn, "\"") : "", "\n    ").concat(employee.motherNameBn ? "motherNameBn: \"".concat(employee.motherNameBn, "\"") : "", "\n    ").concat(employee.motherNameEn ? "motherNameEn: \"".concat(employee.motherNameEn, "\"") : "", "\n    ").concat(employee.maritalStatus ? "maritalStatus: \"".concat(employee.maritalStatus, "\"") : "", "\n    ").concat(employee.occupation ? "occupation: \"".concat(employee.occupation, "\"") : "", "\n    ").concat(employee.relationType ? "relationType: \"".concat(employee.relationType, "\"") : "", "\n    ").concat(employee.relationWithWorker ? "relationWithWorker: \"".concat(employee.relationWithWorker, "\"") : "", "\n    ").concat(employee.presentLocation.id ? "presentLocationId: \"".concat(decodeId(employee.presentLocation.id), "\"") : "", "\n    ").concat(employee.permanentLocation.id ? "permanentLocationId: \"".concat(decodeId(employee.permanentLocation.id), "\"") : "", "\n    ").concat(employee.status ? "status: \"".concat(employee.status, "\"") : "", "\n    ").concat(employee.lifeStatus ? "lifeStatus: \"".concat(employee.lifeStatus, "\"") : "", "\n  ");
}
function formatWorkforceEmployeeAccidentInfoGQL(employee) {
  return "\n    ".concat(employee.injuryType ? "injuryType: \"".concat(formatGQLString(employee.injuryType), "\"") : "", "\n    ").concat(employee.accidentDate ? "accidentDate: \"".concat(formatGQLString(employee.accidentDate), "\"") : "", "\n    ").concat(employee.accidentPlace ? "accidentPlace: \"".concat(formatGQLString(employee.accidentPlace), "\"") : "", "\n    ").concat(employee.accidentTime ? "accidentTime: \"".concat(employee.accidentTime, "\"") : "", "\n    ").concat(employee.accidentType ? "accidentType: \"".concat(employee.accidentType, "\"") : "", "\n    ").concat(employee.dutyStatus ? "dutyStatus: \"".concat(employee.dutyStatus, "\"") : "", "\n    ").concat(employee.inOutsideFactory ? "inOutsideFactory: \"".concat(employee.inOutsideFactory, "\"") : "", "\n    ").concat(employee.description ? "description: \"".concat(employee.description, "\"") : "", "\n  ");
}
function formatWorkforceEmployeeAccountInfoGQL(employee) {
  return "\n    ".concat(employee.beneficiaryType ? "beneficiaryType: \"".concat(formatGQLString(employee.beneficiaryType), "\"") : "", "\n    ").concat(employee.beneficiaryId ? "beneficiaryId: \"".concat(formatGQLString(employee.beneficiaryId), "\"") : "", "\n    ").concat(employee.onBehalfOf ? "onBehalfOf: \"".concat(formatGQLString(employee.onBehalfOf), "\"") : "", "\n    ").concat(employee.accountHolderName ? "accountHolderName: \"".concat(employee.accountHolderName, "\"") : "", "\n    ").concat(employee.accountNumber ? "accountNumber: \"".concat(employee.accountNumber, "\"") : "", "\n    ").concat(employee.status ? "status: \"".concat(employee.status, "\"") : "", "\n \n  ");
}
function formatUnitDesignationGQL(unitDesignation) {
  return "\n    ".concat(unitDesignation.id ? "id: \"".concat(formatGQLString(unitDesignation.id), "\"") : "", "\n    ").concat(unitDesignation.organization ? "organizationId: \"".concat(decodeId(unitDesignation.organization.id), "\"") : "", "\n    ").concat(unitDesignation.unit ? "unitId: \"".concat(decodeId(unitDesignation.unit.id), "\"") : "", "\n    ").concat(unitDesignation.nameEn ? "nameEn: \"".concat(formatGQLString(unitDesignation.nameEn), "\"") : "", "\n    ").concat(unitDesignation.nameBn ? "nameBn: \"".concat(formatGQLString(unitDesignation.nameBn), "\"") : "", "\n    ").concat(unitDesignation.status !== undefined ? "status: ".concat(unitDesignation.status) : "", "\n    ").concat(unitDesignation.designationLevel !== undefined ? "designationLevel: ".concat(unitDesignation.designationLevel) : "", "\n    ").concat(unitDesignation.designationSequence !== undefined ? "designationSequence: ".concat(unitDesignation.designationSequence) : "", "\n  ");
}

///employee designation gql///
function formatEmployeeDesignationGQL(employeeDesignation) {
  return "\n    ".concat(employeeDesignation.id ? "id: \"".concat(formatGQLString(employeeDesignation.id), "\"") : "", "\n    ").concat(employeeDesignation.designationId ? "designationId: \"".concat(formatGQLString(employeeDesignation.designationId), "\"") : "", "\n    ").concat(employeeDesignation.employeeId ? "employeeId: \"".concat(formatGQLString(employeeDesignation.employeeId), "\"") : "", "\n    ").concat(employeeDesignation.status ? "status: \"".concat(WORKFORCE_STATUS$1.INACTIVE, "\"") : "", "\n    ").concat(employeeDesignation.releaseDate ? "releaseDate: \"".concat(formatGQLString(employeeDesignation.releaseDate), "\"") : "", "\n  ");
}
function formatEmployeeAssignDesignationGQL(employeeAssignDesignation) {
  return "\n    ".concat(employeeAssignDesignation.designationId ? "designationId: \"".concat(formatGQLString(employeeAssignDesignation.designationId), "\"") : "", "\n    ").concat(employeeAssignDesignation.employeeId ? "employeeId: \"".concat(formatGQLString(employeeAssignDesignation.employeeId), "\"") : "", "\n    ").concat(employeeAssignDesignation.status ? "status: \"".concat(WORKFORCE_STATUS$1.ACTIVE, "\"") : "", "\n    ").concat(employeeAssignDesignation.releaseDate ? "releaseDate: \"".concat(formatGQLString(employeeAssignDesignation.joiningDate), "\"") : "", "\n  ");
}
function formatFactoryEmployeeAssignDesignationGQL(employeeAssignDesignation) {
  return "\n    ".concat(employeeAssignDesignation !== null && employeeAssignDesignation !== void 0 && employeeAssignDesignation.id ? "id: \"".concat(employeeAssignDesignation === null || employeeAssignDesignation === void 0 ? void 0 : employeeAssignDesignation.id, "\"") : "", "\n    ").concat(employeeAssignDesignation !== null && employeeAssignDesignation !== void 0 && employeeAssignDesignation.workforceEmployeeId ? "workforceEmployeeId: \"".concat(employeeAssignDesignation === null || employeeAssignDesignation === void 0 ? void 0 : employeeAssignDesignation.workforceEmployeeId, "\"") : "", "\n    ").concat(employeeAssignDesignation !== null && employeeAssignDesignation !== void 0 && employeeAssignDesignation.status ? "status: \"".concat(employeeAssignDesignation === null || employeeAssignDesignation === void 0 ? void 0 : employeeAssignDesignation.status, "\"") : "", "\n    ").concat(employeeAssignDesignation !== null && employeeAssignDesignation !== void 0 && employeeAssignDesignation.position ? "position: \"".concat(employeeAssignDesignation === null || employeeAssignDesignation === void 0 ? void 0 : employeeAssignDesignation.position, "\"") : "", "\n    ").concat(employeeAssignDesignation !== null && employeeAssignDesignation !== void 0 && employeeAssignDesignation.resignatioDate ? "resignationDate: \"".concat(employeeAssignDesignation === null || employeeAssignDesignation === void 0 ? void 0 : employeeAssignDesignation.resignatioDate, "\"") : "", "\n    ").concat(employeeAssignDesignation !== null && employeeAssignDesignation !== void 0 && employeeAssignDesignation.resignatioReason ? "resignationReason: \"".concat(employeeAssignDesignation === null || employeeAssignDesignation === void 0 ? void 0 : employeeAssignDesignation.resignatioReason, "\"") : "", "\n    ").concat(employeeAssignDesignation !== null && employeeAssignDesignation !== void 0 && employeeAssignDesignation.joiningDate ? "joinDate: \"".concat(formatGQLString(employeeAssignDesignation === null || employeeAssignDesignation === void 0 ? void 0 : employeeAssignDesignation.joiningDate), "\"") : "", "\n    ").concat(employeeAssignDesignation !== null && employeeAssignDesignation !== void 0 && employeeAssignDesignation.workforceCompany ? "workforceCompanyId: \"".concat(employeeAssignDesignation === null || employeeAssignDesignation === void 0 ? void 0 : employeeAssignDesignation.workforceCompany, "\"") : "", "\n  ");
}
function formatWorkforceDocumentGQL(workforceDocumentType) {
  return "\n    ".concat(workforceDocumentType !== null && workforceDocumentType !== void 0 && workforceDocumentType.id ? "id: \"".concat(workforceDocumentType === null || workforceDocumentType === void 0 ? void 0 : workforceDocumentType.id, "\"") : "", "\n    ").concat(workforceDocumentType !== null && workforceDocumentType !== void 0 && workforceDocumentType.workforceApplicationId ? "workforceApplicationId: \"".concat(workforceDocumentType === null || workforceDocumentType === void 0 ? void 0 : workforceDocumentType.workforceApplicationId, "\"") : "", "\n    ").concat(workforceDocumentType !== null && workforceDocumentType !== void 0 && workforceDocumentType.applicationSummaryId ? "applicationSummaryId: \"".concat(workforceDocumentType === null || workforceDocumentType === void 0 ? void 0 : workforceDocumentType.applicationSummaryId, "\"") : "", "\n    ").concat(workforceDocumentType !== null && workforceDocumentType !== void 0 && workforceDocumentType.factoryId ? "factoryId: \"".concat(workforceDocumentType === null || workforceDocumentType === void 0 ? void 0 : workforceDocumentType.factoryId, "\"") : "", "\n    ").concat(workforceDocumentType !== null && workforceDocumentType !== void 0 && workforceDocumentType.workforceDependentId ? "workforceDependentId: \"".concat(workforceDocumentType === null || workforceDocumentType === void 0 ? void 0 : workforceDocumentType.workforceDependentId, "\"") : "", "\n    ").concat(workforceDocumentType !== null && workforceDocumentType !== void 0 && workforceDocumentType.workforceDocumentTypeId ? "workforceDocumentTypeId: \"".concat(workforceDocumentType === null || workforceDocumentType === void 0 ? void 0 : workforceDocumentType.workforceDocumentTypeId, "\"") : "", "\n    ").concat(workforceDocumentType !== null && workforceDocumentType !== void 0 && workforceDocumentType.path ? "path: \"".concat(workforceDocumentType === null || workforceDocumentType === void 0 ? void 0 : workforceDocumentType.path, "\"") : "", "\n    ").concat(workforceDocumentType !== null && workforceDocumentType !== void 0 && workforceDocumentType.url ? "url: \"".concat(workforceDocumentType === null || workforceDocumentType === void 0 ? void 0 : workforceDocumentType.url, "\"") : "", "\n\n    ").concat(workforceDocumentType !== null && workforceDocumentType !== void 0 && workforceDocumentType.documentType ? "documentType: \"".concat(formatGQLString(workforceDocumentType === null || workforceDocumentType === void 0 ? void 0 : workforceDocumentType.documentType), "\"") : "", "\n    ").concat(workforceDocumentType !== null && workforceDocumentType !== void 0 && workforceDocumentType.holderType ? "holderType: \"".concat(workforceDocumentType === null || workforceDocumentType === void 0 ? void 0 : workforceDocumentType.holderType, "\"") : "", "\n    ").concat(workforceDocumentType !== null && workforceDocumentType !== void 0 && workforceDocumentType.verifierId ? "verifierId: \"".concat(workforceDocumentType === null || workforceDocumentType === void 0 ? void 0 : workforceDocumentType.verifierId, "\"") : "", "\n    ").concat(workforceDocumentType !== null && workforceDocumentType !== void 0 && workforceDocumentType.approverId ? "approverId: \"".concat(formatGQLString(workforceDocumentType === null || workforceDocumentType === void 0 ? void 0 : workforceDocumentType.approverId), "\"") : "", "\n    ").concat(workforceDocumentType !== null && workforceDocumentType !== void 0 && workforceDocumentType.submissionDate ? "submissionDate: \"".concat(formatGQLString(workforceDocumentType === null || workforceDocumentType === void 0 ? void 0 : workforceDocumentType.submissionDate), "\"") : "", "\n    ").concat(workforceDocumentType !== null && workforceDocumentType !== void 0 && workforceDocumentType.verificationDate ? "verificationDate: \"".concat(workforceDocumentType === null || workforceDocumentType === void 0 ? void 0 : workforceDocumentType.verificationDate, "\"") : "", "\n    ").concat(workforceDocumentType !== null && workforceDocumentType !== void 0 && workforceDocumentType.approvalDate ? "approvalDate: \"".concat(formatGQLString(workforceDocumentType === null || workforceDocumentType === void 0 ? void 0 : workforceDocumentType.approvalDate), "\"") : "", "\n    ").concat(workforceDocumentType !== null && workforceDocumentType !== void 0 && workforceDocumentType.remarks ? "remarks: \"".concat(formatGQLString(workforceDocumentType === null || workforceDocumentType === void 0 ? void 0 : workforceDocumentType.remarks), "\"") : "", "\n    ").concat(workforceDocumentType !== null && workforceDocumentType !== void 0 && workforceDocumentType.status ? "status: \"".concat(formatGQLString(workforceDocumentType === null || workforceDocumentType === void 0 ? void 0 : workforceDocumentType.status), "\"") : "", "\n    ").concat(workforceDocumentType !== null && workforceDocumentType !== void 0 && workforceDocumentType.note ? "note: \"".concat(formatGQLString(workforceDocumentType === null || workforceDocumentType === void 0 ? void 0 : workforceDocumentType.note), "\"") : "", "\n    ").concat(workforceDocumentType !== null && workforceDocumentType !== void 0 && workforceDocumentType.isDeleted ? "isDeleted: \"".concat(workforceDocumentType === null || workforceDocumentType === void 0 ? void 0 : workforceDocumentType.isDeleted, "\"") : "", "\n  ");
}
function formatWorkforceDocumentMapGQL(workforceDocumentType) {
  return "\n    ".concat(workforceDocumentType !== null && workforceDocumentType !== void 0 && workforceDocumentType.id ? "id: \"".concat(workforceDocumentType === null || workforceDocumentType === void 0 ? void 0 : workforceDocumentType.id, "\"") : "", "\n    ").concat(workforceDocumentType !== null && workforceDocumentType !== void 0 && workforceDocumentType.workforceApplicationId ? "workforceApplicationId: \"".concat(workforceDocumentType === null || workforceDocumentType === void 0 ? void 0 : workforceDocumentType.workforceApplicationId, "\"") : "", "\n    ").concat(workforceDocumentType !== null && workforceDocumentType !== void 0 && workforceDocumentType.workforceDocumentId ? "workforceDocumentId: \"".concat(workforceDocumentType === null || workforceDocumentType === void 0 ? void 0 : workforceDocumentType.workforceDocumentId, "\"") : "", "\n    ").concat(workforceDocumentType !== null && workforceDocumentType !== void 0 && workforceDocumentType.verifiedById ? "verifiedById: \"".concat(workforceDocumentType === null || workforceDocumentType === void 0 ? void 0 : workforceDocumentType.verifiedById, "\"") : "", "\n    ").concat(workforceDocumentType !== null && workforceDocumentType !== void 0 && workforceDocumentType.verifiedByRoleId ? "verifiedByRoleId: \"".concat(workforceDocumentType === null || workforceDocumentType === void 0 ? void 0 : workforceDocumentType.verifiedByRoleId, "\"") : "", "\n    ").concat(workforceDocumentType !== null && workforceDocumentType !== void 0 && workforceDocumentType.verificationDate ? "verificationDate: \"".concat(workforceDocumentType === null || workforceDocumentType === void 0 ? void 0 : workforceDocumentType.verificationDate, "\"") : "", "\n\n    ").concat(workforceDocumentType !== null && workforceDocumentType !== void 0 && workforceDocumentType.remarks ? "remarks: \"".concat(formatGQLString(workforceDocumentType === null || workforceDocumentType === void 0 ? void 0 : workforceDocumentType.remarks), "\"") : "", "\n    ").concat(workforceDocumentType !== null && workforceDocumentType !== void 0 && workforceDocumentType.status ? "status: \"".concat(formatGQLString(workforceDocumentType === null || workforceDocumentType === void 0 ? void 0 : workforceDocumentType.status), "\"") : "", "\n    ").concat(workforceDocumentType !== null && workforceDocumentType !== void 0 && workforceDocumentType.note ? "note: \"".concat(formatGQLString(workforceDocumentType === null || workforceDocumentType === void 0 ? void 0 : workforceDocumentType.note), "\"") : "", "\n    ").concat(workforceDocumentType !== null && workforceDocumentType !== void 0 && workforceDocumentType.isDeleted ? "isDeleted: \"".concat(workforceDocumentType === null || workforceDocumentType === void 0 ? void 0 : workforceDocumentType.isDeleted, "\"") : "", "\n  ");
}
function formatWorkforceCompanyStatusGql(company) {
  return "\n    ".concat(company !== null && company !== void 0 && company.id ? "id: \"".concat(formatGQLString(company === null || company === void 0 ? void 0 : company.id), "\"") : "", "\n    ").concat(company !== null && company !== void 0 && company.status ? "status: \"".concat(company.status, "\"") : "", "\n  ");
}
function formatWorkforceAssociationUserMapGQL(associationUserMap) {
  return "\n    ".concat(associationUserMap !== null && associationUserMap !== void 0 && associationUserMap.id ? "id: \"".concat(formatGQLString(associationUserMap === null || associationUserMap === void 0 ? void 0 : associationUserMap.id), "\"") : "", "\n    ").concat(associationUserMap !== null && associationUserMap !== void 0 && associationUserMap.associationId ? "allAssociationId: \"".concat(formatGQLString(associationUserMap === null || associationUserMap === void 0 ? void 0 : associationUserMap.associationId), "\"") : "", "\n    ").concat(associationUserMap.userId ? "userId: ".concat(formatGQLString(associationUserMap.userId)) : "", "\n  ");
}
function formatWorkforceCommitteeGQL(committee) {
  return "\n    ".concat(committee !== null && committee !== void 0 && committee.id ? "id: \"".concat(committee.id, "\"") : "", "\n    ").concat(committee.nameBn ? "nameBn: \"".concat(committee.nameBn, "\"") : "", "\n    ").concat(committee.nameEn ? "nameEn: \"".concat(committee.nameEn, "\"") : "", "  \n    ").concat(committee.associations ? "associations: ".concat(escapeQuotes$1(committee.associations)) : "", "\n    ").concat(committee.organizationType ? "organizationType: \"".concat(committee.organizationType, "\"") : "", "\n    ").concat(committee.approvalType ? "approvalType: \"".concat(committee.approvalType, "\"") : "", "\n  ");
}
function formatWorkforceCommitteeUserMapGQL(usermap) {
  return "\n    ".concat(usermap !== null && usermap !== void 0 && usermap.id ? "id: \"".concat(usermap.id, "\"") : "", "\n    ").concat(usermap !== null && usermap !== void 0 && usermap.committeeId ? "committeeId: \"".concat(usermap.committeeId, "\"") : "", "\n    ").concat(usermap.userId ? "userId: ".concat(usermap.userId) : "", "\n    ").concat((usermap === null || usermap === void 0 ? void 0 : usermap.isNoaSignatureUser) !== undefined ? "isNoaSignatureUser: ".concat(usermap.isNoaSignatureUser) : "", "  \n    ").concat(usermap !== null && usermap !== void 0 && usermap.roleInCommittee ? "roleInCommittee: \"".concat(usermap.roleInCommittee, "\"") : "", "  \n    ").concat(typeof (usermap === null || usermap === void 0 ? void 0 : usermap.isRepresentative) === "boolean" ? "isRepresentative: ".concat(usermap.isRepresentative) : "", "  \n  ");
}
function formatWorkforceCommitteeUserGQL(user) {
  return "\n    ".concat(user !== null && user !== void 0 && user.loginName ? "loginName: \"".concat(user.loginName, "\"") : "", "\n    ").concat(user !== null && user !== void 0 && user.representativeName ? "representativeName: \"".concat(user.representativeName, "\"") : "", "\n    ").concat(user !== null && user !== void 0 && user.representativeNameBn ? "representativeNameBn: \"".concat(user.representativeNameBn, "\"") : "", "\n    ").concat(user !== null && user !== void 0 && user.organizationName ? "organizationName: \"".concat(user.organizationName, "\"") : "", "\n    ").concat(user !== null && user !== void 0 && user.designation ? "designation: \"".concat(user.designation, "\"") : "", "\n    ").concat(user !== null && user !== void 0 && user.representativeType ? "representativeType: \"".concat(user.representativeType, "\"") : "", "\n    ").concat(user !== null && user !== void 0 && user.committeeRole ? "committeeRole: \"".concat(user.committeeRole, "\"") : "", "\n    ").concat(user !== null && user !== void 0 && user.phoneNumber ? "phoneNumber: \"".concat(user.phoneNumber, "\"") : "", "\n    ").concat(user !== null && user !== void 0 && user.email ? "email: \"".concat(user.email, "\"") : "", "\n    ").concat(user !== null && user !== void 0 && user.officeAddress ? "officeAddress: \"".concat(user.officeAddress, "\"") : "", "\n    ").concat(user !== null && user !== void 0 && user.currentAddress ? "currentAddress: \"".concat(user.currentAddress, "\"") : "", "\n  ");
}
function formatWorkforceCommitteeBankAdviceMapGQL(bankAdvice) {
  return "\n    ".concat(bankAdvice !== null && bankAdvice !== void 0 && bankAdvice.id ? "id: \"".concat(bankAdvice.id, "\"") : "", "\n    ").concat(bankAdvice !== null && bankAdvice !== void 0 && bankAdvice.adviceTemplate ? "adviceTemplate: ".concat(escapeQuotes$1(bankAdvice.adviceTemplate)) : "", "\n    ").concat(bankAdvice !== null && bankAdvice !== void 0 && bankAdvice.committeeId ? "committeeId: \"".concat(bankAdvice.committeeId, "\"") : "", "\n  ");
}
function formatWorkforceNotificationGQL(user) {
  return "\n    ".concat(user !== null && user !== void 0 && user.id ? "id: \"".concat(user.id, "\"") : "", "\n    ").concat(user !== null && user !== void 0 && user.isRead ? "isRead: ".concat(user.isRead) : "", "\n    ").concat(user !== null && user !== void 0 && user.allRead ? "allRead: ".concat(user.allRead) : "", "\n    ").concat(user !== null && user !== void 0 && user.notification ? "notification: \"".concat(user.notification, "\"") : "", "\n    ").concat(user !== null && user !== void 0 && user.notificationBn ? "notificationBn: \"".concat(user.notificationBn, "\"") : "", "\n    ").concat(user !== null && user !== void 0 && user.userId ? "userId: ".concat(user.userId) : "", "\n    ").concat(user !== null && user !== void 0 && user.status ? "status: \"".concat(user.status, "\"") : "", "\n    ").concat(user !== null && user !== void 0 && user.workforceApplicationId ? "workforceApplicationId: \"".concat(user.workforceApplicationId, "\"") : "", "\n  ");
}
function formatWebsiteLegalGuidelineGQL(legalGuideline) {
  return "\n    ".concat(legalGuideline !== null && legalGuideline !== void 0 && legalGuideline.id ? "id: \"".concat(legalGuideline.id, "\"") : "", "\n    ").concat(legalGuideline !== null && legalGuideline !== void 0 && legalGuideline.description ? "description: ".concat(escapeQuotes$1(legalGuideline.description)) : "", "\n    ").concat(legalGuideline !== null && legalGuideline !== void 0 && legalGuideline.documentUrl ? "documentUrl: \"".concat(legalGuideline.documentUrl, "\"") : "", "\n    ").concat(legalGuideline !== null && legalGuideline !== void 0 && legalGuideline.documentPath ? "documentPath: \"".concat(legalGuideline.documentPath, "\"") : "", "\n  ");
}

function escapeQuotes(data) {
  // Check if it's a string and needs escaping
  if (typeof data === "string") {
    return "\"".concat(data.replace(/"/g, '\\"'), "\"");
  }
  // If it's not a string, stringify it properly
  return "\"".concat(JSON.stringify(data).replace(/"/g, '\\"'), "\"");
}
function fetchOrganizationsSummary(mm, filters) {
  var projections = ["id", "nameEn", "nameBn", "phoneNumber", "email", "workforceRepresentative { id,nameBn,nameEn,position,email,nid,address,phoneNumber}", "location{name,type,parent{name,type,parent{name,type,parent{name,type}}}}", "address", "type"];
  var payload = formatPageQueryWithCount("workforceOrganizations", filters, projections);
  return graphql(payload, "WORKFORCE_ORGANIZATIONS");
}
function fetchOrganizationsPick(filters) {
  var projections = ["id", "nameEn", "nameBn"];
  var payload = formatPageQueryWithCount("workforceOrganizations", filters, projections);
  return graphql(payload, "WORKFORCE_ORGANIZATIONS_PICKER");
}
function fetchDocumentType(mm, filters) {
  var projections = ["id", "fieldId", "applicationType", "documentType", "applicationFor", "organizationType", "status", "nameEn", "nameBn", "mandatoryForApplicant"];
  var payload = formatPageQueryWithCount("workforceDocumentTypes", filters, projections);
  return graphql(payload, "WORKFORCE_DOCUMENT_TYPE");
}

/// bank picker ///
function fetchBanksPick(mm, filters) {
  var projections = ["id", "nameEn", "nameBn", "parent{id},bankCode,routingNumber"];
  var payload = formatPageQuery("workforceBanks", filters, projections);
  return graphql(payload, "WORKFORCE_BANKS_PICKER");
}
function fetchWorkforceOtp(mm, filters) {
  var projections = ["status", "nameBn", "firstNameEn", "phoneNumber"];
  var payload = formatQuery("workforceOtp", filters, projections);
  return graphql(payload, "WORKFORCE_OTP");
}
function fetchBranchPick(mm, filters) {
  var projections = ["id", "nameEn", "nameBn", "parent{id},bankCode,routingNumber", "districtCode", "districtNameEn", "districtNameBn"];
  var payload = formatPageQuery("workforceBanks", filters, projections);
  return graphql(payload, "WORKFORCE_BRANCH_PICKER");
}
function fetchDistrictBanksPick(mm, filters) {
  var projections = ["id", "nameEn", "nameBn", "parent{id},bankCode,routingNumber", "districtCode", "districtNameEn", "districtNameBn"];
  var payload = formatPageQuery("workforceBanks", filters, projections);
  return graphql(payload, "WORKFORCE_DISTRICT_BANKS_PICKER");
}
function fetchOrganizationUnitsPick(mm, filters) {
  var projections = ["id", "nameEn", "nameBn"];
  var payload = formatPageQueryWithCount("workforceOrganizationUnits", filters, projections);
  return graphql(payload, "WORKFORCE_ORGANIZATION_UNITS_PICKER");
}
function fetchOrganizationUnitsSummary(mm, filters) {
  var projections = ["id", "nameEn", "nameBn", "unitLevel", "phoneNumber", "email"];
  var payload = formatPageQueryWithCount("workforceOrganizationUnits", filters, projections);
  return graphql(payload, "WORKFORCE_ORGANIZATION_UNITS");
}

///unit designation fetch summary///
function fetchUnitDesignationSummary(mm, filters) {
  var projections = ["id", "nameEn", "nameBn", "designationLevel", "designationSequence", "organization{nameEn,nameBn}", "unit{nameEn,nameBn}"];
  var payload = formatPageQueryWithCount("workforceOrganizationUnitDesignations", filters, projections);
  return graphql(payload, "WORKFORCE_ORGANIZATION_UNIT_DESIGNATIONS");
}
function fetchOrganizationEmployeesSummary(mm, filters) {
  var location_projection = "location" + mm.getProjection("location.Location.FlatProjection");
  var projections = ["id", "nameEn", "nameBn", "address", "phoneNumber", "email", "status", "gender", "firstJoiningDate", "birthCertificateNo", "nid", "passportNo", "designations{id,joiningDate,releaseDate,designation{unit{id,organization{id,nameBn}nameBn,unitDesignations{id,nameBn}}}}", location_projection];
  var payload = formatPageQueryWithCount("workforceOrganizationEmployees", filters, projections);
  return graphql(payload, "WORKFORCE_ORGANIZATION_EMPLOYEES");
}
function fetchOrganizationEmployee(mm, filters) {
  var location_projection = "location" + mm.getProjection("location.Location.FlatProjection");
  var projections = ["id", "nameEn", "nameBn", "address", "phoneNumber", "email", "status", "gender", "firstJoiningDate", "birthCertificateNo", "nid", "passportNo", "designations{id,joiningDate,releaseDate,designation{unit{id,organization{id,nameBn}nameBn,unitDesignations{id,nameBn}}}}", location_projection];
  var payload = formatPageQueryWithCount("workforceOrganizationEmployees", filters, projections);
  return graphql(payload, "WORKFORCE_ORGANIZATION_EMPLOYEE");
}
function fetchWorkforceOfficesSummary(mm, filters) {
  var location_projection = "location" + mm.getProjection("location.Location.FlatProjection");
  var projections = ["id", "nameEn", "nameBn", "address", "phoneNumber", "email", "status", "website", "workforceRepresentative { id,nameBn,nameEn,position,email,nid,address,phoneNumber}", location_projection];
  var payload = formatPageQueryWithCount("workforceEmployerOffices", filters, projections);
  return graphql(payload, "WORKFORCE_OFFICES");
}
function fetchWorkforceOffice(mm, filters) {
  var location_projection = "location" + mm.getProjection("location.Location.FlatProjection");
  var projections = ["id", "nameEn", "nameBn", "address", "phoneNumber", "email", "status", location_projection, "website", "workforceEmployer{id}", "workforceRepresentative { id,nameBn,nameEn,position,email,phoneNumber,nid,birthDate, passportNo, address, " + location_projection + "}"];
  var payload = formatPageQueryWithCount("workforceEmployerOffices", filters, projections);
  return graphql(payload, "WORKFORCE_OFFICE");
}
function fetchWorkforceFactoriesSummary(mm, filters) {
  var location_projection = "location" + mm.getProjection("location.Location.FlatProjection");
  var office_location_projection = "officeLocation" + mm.getProjection("location.Location.FlatProjection");
  var projections = ["id", "nameEn", "nameBn", "address", "associationType", "phoneNumber", "email", "status", "website", "registrationExpiryDate", "registrationDate", "officeAddress", "approximateNumberOfEmployee", "limaRegistrationNumber", "licenseNo", "businessSector", "membershipNo", "dateOfFactoryEstablishment", "dateOfEisIncorporation", "futureDate", "licenseType", "groupName", "workforceRepresentative { id,nameBn,nameEn,position,email,nid,address,phoneNumber}", location_projection, office_location_projection];
  var payload = formatPageQueryWithCount("workforceEmployerFactories", filters, projections);
  return graphql(payload, "WORKFORCE_ORGANIZATION_FACTORIES");
}
function fetchWorkforceFactory(mm, filters) {
  var location_projection = "location" + mm.getProjection("location.Location.FlatProjection");
  var office_location_projection = "officeLocation" + mm.getProjection("location.Location.FlatProjection");
  var projections = ["id", "nameEn", "nameBn", "address", "associationType", "phoneNumber", "email", "status", "website", "registrationExpiryDate", "registrationDate", "officeAddress", "approximateNumberOfEmployee", "limaRegistrationNumber", "licenseNo", "businessSector", "membershipNo", "dateOfFactoryEstablishment", "dateOfEisIncorporation", "futureDate", "licenseType", "groupName", location_projection, office_location_projection, "workforceEmployer{id}", "workforceRepresentative { id,nameBn,nameEn,position,email,phoneNumber,nid,birthDate, passportNo, address, " + location_projection + "}"];
  var payload = formatPageQueryWithCount("workforceEmployerFactories", filters, projections);
  return graphql(payload, "WORKFORCE_FACTORY");
}
function fetchWorkforceCompaniesSummary(mm, filters) {
  var location_projection = "location" + mm.getProjection("location.Location.FlatProjection");
  var projections = ["id", "employerId", "employerIdLima", "nameEn", "nameBn", "address", "phoneNumber", "email", "status", "establishmentDate", "associationName", "associationMembershipNumber", "licenceType", "licenceNumber", "website", "businessSector", "foundationDate", "establishmentName", "officeCount", "factoryCount", "workforceRepresentative { id,nameBn,nameEn,position,email,nid,address,phoneNumber}", location_projection];
  var payload = formatPageQueryWithCount("workforceEmployers", filters, projections);
  return graphql(payload, "WORKFORCE_COMPANIES");
}
function fetchCompaniesPick(filters) {
  var projections = ["id", "nameEn", "nameBn"];
  var payload = formatPageQueryWithCount("workforceEmployers", filters, projections);
  return graphql(payload, "WORKFORCE_COMPANIES_PICKER");
}
function fetchDistrictOfficePick(mm, filters) {
  var projections = ["id", "nameEn", "nameBn"];
  var payload = formatPageQueryWithCount("workforceOrganizations", filters, projections);
  return graphql(payload, "WORKFORCE_DISTRICT_OFFICE_PICKER");
}
function fetchOfficesPick(filters) {
  var projections = ["id", "nameEn", "nameBn"];
  var payload = formatPageQueryWithCount("workforceEmployerOffices", filters, projections);
  return graphql(payload, "WORKFORCE_OFFICES_PICKER");
}
function fetchFactoriesPick(mm, filters) {
  var projections = ["id", "nameEn", "nameBn", "workforceEmployer{id}"];
  var payload = formatPageQueryWithCount("workforceEmployerFactories", filters, projections);
  return graphql(payload, "WORKFORCE_FACTORIES_PICKER");
}
function fetchWorkforceCompany(mm, filters) {
  var location_projection = "location" + mm.getProjection("location.Location.FlatProjection");
  var projections = ["id", "employerId", "employerIdLima", "nameEn", "nameBn", "address", "phoneNumber", "email", "status", "establishmentDate", "associationName", "associationMembershipNumber", "licenceType", "licenceNumber", "website", "businessSector", "foundationDate", "establishmentName", location_projection, "workforceRepresentative { id,nameBn,nameEn,position,email,phoneNumber,nid,birthDate, passportNo, address, " + location_projection + "}"];
  var payload = formatPageQueryWithCount("workforceEmployers", filters, projections);
  return graphql(payload, "WORKFORCE_COMPANY");
}
function fetchWorkforceCompanyWithFactoriesAndOffices(mm, filters) {
  var location_projection = "location" + mm.getProjection("location.Location.FlatProjection");
  var projections = ["id", "employerId", "employerIdLima", "nameEn", "nameBn", "address", "phoneNumber", "email", "status", "establishmentDate", "associationName", "associationMembershipNumber", "licenceType", "licenceNumber", "website", "businessSector", "foundationDate", "establishmentName", location_projection, "workforceRepresentative { id,nameBn,nameEn,position,email,phoneNumber,nid,birthDate, passportNo, address, " + location_projection + "}", "factories {id,nameBn,nameEn,address,phoneNumber,email,website,status, " + location_projection + "}", "offices {id,nameBn,nameEn,address,phoneNumber,email,website,status, " + location_projection + "}"];
  var payload = formatPageQueryWithCount("workforceEmployers", filters, projections);
  return graphql(payload, "WORKFORCE_COMPANY");
}
function fetchWorkforceEmployeesSummary(mm, filters) {
  var present_location_projection = "presentLocation" + mm.getProjection("location.Location.FlatProjection");
  var permanent_location_projection = "permanentLocation" + mm.getProjection("location.Location.FlatProjection");
  var projections = ["id", "firstNameBn", "lastNameBn", "firstNameEn", "lastNameEn", "otherName", "phoneNumber", "email", "status", "gender", "birthCertificateNo", "nid", "passportNo", "permanentAddress", "presentAddress", "position", "monthlyEarning", "fatherNameBn", "fatherNameEn", "motherNameBn", "motherNameEn", "spouseNameBn", "spouseNameEn", "maritalStatus", "citizenship", "privacyLaw", "insuranceNumber", "birthDate", "employeeType", "lifeStatus", "deathDate", "relatedUser{id}", present_location_projection, permanent_location_projection];
  var payload = formatPageQueryWithCount("workforceEmployerEmployees", filters, projections);
  return graphql(payload, "WORKFORCE_EMPLOYEES");
}
function fetchWorkforceAllAssociationSummary() {
  var filters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  filters.push("status: \"active\"");
  var projections = ["id", "nameEn", "nameBn", "shortNameEn", "shortNameBn", "phone", "email", "address", "webAddress", "startDate", "status", "minimumSalary"];
  var payload = formatPageQueryWithCount("workforceAllAssociation", filters, projections);
  return graphql(payload, "WORKFORCE_ALL_ASSOCIATIONS");
}
function fetchWorkforceAllAssociation(mm) {
  var filters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  filters.push("status: \"active\"");
  var projections = ["id", "nameEn", "nameBn", "shortNameEn", "shortNameBn", "phone", "email", "address", "webAddress", "status", "minimumSalary"];
  var payload = formatPageQueryWithCount("workforceAllAssociation", filters, projections);
  return graphql(payload, "WORKFORCE_ALL_ASSOCIATIONS");
}
function fetchDependentsSummary(mm, filters) {
  var present_location_projection = "presentLocation" + mm.getProjection("location.Location.FlatProjection");
  var permanent_location_projection = "permanentLocation" + mm.getProjection("location.Location.FlatProjection");
  var projections = ["id", "firstNameBn", "lastNameBn", "firstNameEn", "lastNameEn", "phoneNumber", "email", "maritalStatus", "gender", "occupation", "birthDate", "nid", "lifeStatus", "relationType", "relationWithWorker", "status",
  // "permanentAddress",
  // "presentAddress",
  present_location_projection, permanent_location_projection];
  var payload = formatPageQueryWithCount("workforceEmployeeDependent", filters, projections);
  return graphql(payload, "WORKFORCE_EMPLOYEES_DEPENDENTS");
}
function fetchServicesSummary(mm, filters) {
  var projections = ["id", "workforceCompany{id}", "workforceFactory{id}", "workforceOffice{id}", "position", "joinDate", "resignationDate", "resignationReason", "monthlySalary", "status", "workforceEmployee{id,firstNameEn,firstNameBn,lastNameEn,lastNameBn}"];
  var payload = formatPageQueryWithCount("workforceEmployeeDesignation", filters, projections);
  return graphql(payload, "WORKFORCE_EMPLOYEES_SERVICES");
}
function fetchAccidentInfosSummary(mm, filters) {
  var projections = ["id", "injuryType", "accidentDate", "accidentPlace", "accidentTime", "accidentType", "dutyStatus", "inOutsideFactory", "description"];
  var payload = formatPageQueryWithCount("workforceEmployeeAccident", filters, projections);
  return graphql(payload, "WORKFORCE_EMPLOYEES_ACCIDENTS");
}
function fetchAccidentInfo(mm, filters) {
  var projections = ["id", "injuryType", "accidentDate", "accidentTime", "accidentType", "dutyStatus", "inOutsideFactory", "deathDate", "description"];
  var payload = formatPageQueryWithCount("workforceEmployeeAccident", filters, projections);
  return graphql(payload, "WORKFORCE_EMPLOYEES_ACCIDENT");
}
function fetchAccountInfosSummary(mm, filters) {
  var present_location_projection = "presentLocation" + mm.getProjection("location.Location.FlatProjection");
  var permanent_location_projection = "permanentLocation" + mm.getProjection("location.Location.FlatProjection");
  var projections = ["id", "beneficiaryType", "beneficiaryId", "onBehalfOf", "accountHolderName", "accountNumber", "status", present_location_projection, permanent_location_projection];
  var payload = formatPageQueryWithCount("workforceEmployeeAccountInfo", filters, projections);
  return graphql(payload, "WORKFORCE_EMPLOYEES_ACCOUNTS");
}
function fetchAccountInfo(mm, filters) {
  var present_location_projection = "presentLocation" + mm.getProjection("location.Location.FlatProjection");
  var permanent_location_projection = "permanentLocation" + mm.getProjection("location.Location.FlatProjection");
  var projections = ["id", "beneficiaryType", "beneficiaryId", "onBehalfOf", "accountHolderName", "accountNumber", "status", present_location_projection, permanent_location_projection];
  var payload = formatPageQueryWithCount("workforceEmployeeAccountInfo", filters, projections);
  return graphql(payload, "WORKFORCE_EMPLOYEES_ACCOUNT");
}
function fetchApplicationsSummary(mm, filters) {
  var present_location_projection = "presentLocation" + mm.getProjection("location.Location.FlatProjection");
  var permanent_location_projection = "permanentLocation" + mm.getProjection("location.Location.FlatProjection");
  var projections = ["id", "workforceEmployee{" + present_location_projection + permanent_location_projection + "id,firstNameBn,lastNameBn,firstNameEn,lastNameEn,otherName,phoneNumber,email,status,gender,birthCertificateNo,nid,passportNo,permanentAddress,presentAddress,position,monthlyEarning,fatherNameBn,fatherNameEn,motherNameBn,motherNameEn,spouseNameBn,spouseNameEn,maritalStatus,citizenship,privacyLaw,insuranceNumber,birthDate,employeeType,lifeStatus,deathDate,relatedUser{id}}", "applicantInfo", "dateCreated", "dateUpdated", "organizationType", "applicationType", "status", "employeeFactory{id,nameEn,nameBn}", "trackingNumber", "employeeDependentInfo", "employeeBankInfo", "employeeAccidentInfo", "employeeChildrenInfo", "institutionInfo", "metadata", "educations{edges{node{id,childNameEn,childNameBn}}}", "cfApplicationSummary{id,applicationData,cfApplicationSummary {edges {node {id,status}}}}", "eisApplicationSummary{id,applicationData,eisApplicationSummary {edges {node {id,status}}}}", "blwfApplicationSummary{id,applicationData,blwfApplicationSummary {edges {node {id,status}}}}", "grantMoney {id,grantMoney,applicationTypeNameEn,applicationTypeNameBn}", "grantAmount", "submittedBy", "associationType", "applicationFor", "applicationReceiveDate", "applicationForwardDate", "deceasedWorkerInfo", "eisApprovedAmount", "eisCalculatedAmount", "eisPaymentType", "eisInitialMonthlyAmount", "eisMonthlyAmount", "initialReplacementRate", "pvFactor", "eisVerified", "deceasedWorkerInfo", "eisApprovalIds", "eisApprovedByIds", "lastMovementDate", "doctorsFlag", "doctorsRecommendedDonation", "doctorsDiagnosis", "committeeRemarks", "rejectedIds", "workforceApplicationMovements{id,dateCreated,status,applicationTo {id,loginName}}"];
  var payload = formatPageQueryWithCount("workforceApplication", filters, projections);
  return graphql(payload, "WORKFORCE_APPLICATIONS");
}
function fetchApplicationsSummaryDashboard(mm, filters) {
  var present_location_projection = "presentLocation" + mm.getProjection("location.Location.FlatProjection");
  var permanent_location_projection = "permanentLocation" + mm.getProjection("location.Location.FlatProjection");
  var projections = ["id", "workforceEmployee{" + present_location_projection + permanent_location_projection + "id,firstNameBn,lastNameBn,firstNameEn,lastNameEn,otherName,phoneNumber,email,status,gender,birthCertificateNo,nid,passportNo,permanentAddress,presentAddress,position,monthlyEarning,fatherNameBn,fatherNameEn,motherNameBn,motherNameEn,spouseNameBn,spouseNameEn,maritalStatus,citizenship,privacyLaw,insuranceNumber,birthDate,employeeType,lifeStatus,deathDate,relatedUser{id}}", "applicantInfo", "dateCreated", "dateUpdated", "organizationType", "applicationType", "status", "employeeFactory{id,nameEn,nameBn}", "trackingNumber", "employeeDependentInfo", "workforceEmployeeDependentApplication{edges{node{id,relationWithWorker}}}", "employeeBankInfo", "employeeAccidentInfo", "employeeChildrenInfo", "institutionInfo", "metadata", "educations{edges{node{id,childNameEn,childNameBn}}}", "cfApplicationSummary{id}", "eisApplicationSummary{id}", "blwfApplicationSummary{id}", "grantMoney {id,grantMoney,applicationTypeNameEn,applicationTypeNameBn}", "grantAmount", "submittedBy", "associationType", "applicationFor", "applicationReceiveDate", "applicationForwardDate", "deceasedWorkerInfo", "eisApprovedAmount", "eisCalculatedAmount", "eisPaymentType", "eisInitialMonthlyAmount", "eisMonthlyAmount", "initialReplacementRate", "pvFactor", "eisVerified", "deceasedWorkerInfo", "eisApprovalIds", "eisApprovedByIds", "rejectedIds"];
  var payload = formatPageQueryWithCount("workforceApplication", filters, projections);
  return graphql(payload, "WORKFORCE_APPLICATIONS_DASHBOARD");
}
function fetchApplicationStatusCounts() {
  var filters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var filterString = filters.length > 0 ? "(".concat(filters.join(", "), ")") : "";
  var approvedFilterString = "(statusIn: [\"approved_by_committee\"]".concat(filters.length > 0 ? ", ".concat(filters.join(", ")) : "", ")");
  var rejectedFilterString = "(statusIn: [\"rejected\"]".concat(filters.length > 0 ? ", ".concat(filters.join(", ")) : "", ")");
  var payload = "\n    query {\n      total: workforceApplication".concat(filterString, " {\n        totalCount\n      }\n      approved: workforceApplication").concat(approvedFilterString, " {\n        totalCount\n      }\n      rejected: workforceApplication").concat(rejectedFilterString, " {\n        totalCount\n      }\n    }\n  ");
  return graphql(payload, "WORKFORCE_APPLICATION_STATUS_COUNTS");
}
function fetchSummaryApplications(mm, filters) {
  var projections = ["id", "dateCreated", "organizationType", "applicationData", "status", "name", "meetingDate", "month", "year", "sectionType", "userIds"];
  var payload = formatPageQueryWithCount("workforceApplicationSummary", filters, projections);
  return graphql(payload, "WORKFORCE_APPLICATIONS_SUMMARY");
}
function fetchApplication(mm, filters) {
  var present_location_projection = "presentLocation" + mm.getProjection("location.Location.FlatProjection");
  var permanent_location_projection = "permanentLocation" + mm.getProjection("location.Location.FlatProjection");
  var projections = ["id", "workforceEmployee{" + present_location_projection + permanent_location_projection + ",id,firstNameBn,lastNameBn,firstNameEn,lastNameEn,otherName,phoneNumber,email,status,gender,birthCertificateNo,nid,passportNo,permanentAddress,presentAddress,position,monthlyEarning,fatherNameBn,fatherNameEn,motherNameBn,motherNameEn,spouseNameBn,spouseNameEn,maritalStatus,citizenship,privacyLaw,insuranceNumber,birthDate,employeeType,lifeStatus,deathDate,relatedUser{id}}", "applicantInfo", "organizationType", "dateCreated", "applicationType", "status", "trackingNumber", "employeeDependentInfo", "employeeBankInfo", "employeeAccidentInfo", "employeeChildrenInfo", "workforceApplicationMovements{id,dateCreated,status}", "institutionInfo", "educations{edges{node{id,childNameEn,childNameBn,childBirthDate,childBirthCertificateNo,childNidNo,studyClass,institution,educationLevel,educationBoard,passingYear,rollNumber,registrationNumber,result}}}",
  // "workforceEmployeeDependentApplication{edges{node{id,nameBn,nameEn,fatherNameBn,fatherNameEn,motherNameBn,motherNameEn,nid,birthDate,percentageOfCfGrant,phoneNumber,presentLocation {id},presentAddress,permanentLocation {id},permanentAddress}}}",
  "workforceEmployeeDependentApplication{edges{node{id,dateCreated,nameBn,nameEn,fatherNameBn,fatherNameEn,maritalStatus,gender,percentageOfCfGrant,occupation,email,phoneNumber,birthDate,nid,birthCertificateNo,disabilityStatus,disabilityType,lastVerificationDate,relationWithWorker,attachments,isEligible,remarks,status,employeeBankingDependents{edges{node{id}}},presentAddress,permanentAddress," + present_location_projection + permanent_location_projection + ",bankingInfo{id}}}}", "employeeBankingInfoApplication{edges{node{id,dateCreated,nameBn,nameEn,accountNo,accountHolderName,accountHolderType,status, routingNumber, branch{id,nameBn,nameEn,bankCode,branchCode,routingNumber,districtNameEn,districtNameBn,parent{id,nameBn,nameEn}},dependant{id},relationWithDependent}}}", "metadata", "employeeFactory{id, nameBn, nameEn,membershipNo,registrationDate,registrationExpiryDate,allAssociation{id,nameBn,nameEn,startDate}}", "cfApplicationSummary{id}", "eisApplicationSummary{id}", "blwfApplicationSummary{id}", "grantAmount", "grantMoney {id,grantMoney,applicationTypeNameEn,applicationTypeNameBn}", "submittedBy", "associationType", "applicationFor", "deceasedWorkerInfo", "eisApprovedAmount", "eisCalculatedAmount", "eisPaymentType", "eisInitialMonthlyAmount", "eisMonthlyAmount", "initialReplacementRate", "pvFactor", "lastBaseSalary", "doctorsEntry", "applicantInfoVerification", "applicantInfoVerificationRemarks", "deceasedWorkerInfoVerification", "deceasedWorkerInfoVerificationRemarks", "doctorsEntryVerification", "doctorsEntryVerificationRemarks", "employeeAccidentInfoVerification", "employeeAccidentInfoVerificationRemarks", "employeeBankInfoVerification", "employeeBankInfoVerificationRemarks", "employeeChildrenInfoVerification", "employeeChildrenInfoVerificationRemarks", "employeeDependentInfoVerification", "employeeDependentInfoVerificationRemarks", "institutionInfoVerification", "institutionInfoVerificationRemarks", "metadataVerification", "metadataVerificationRemarks", "workforceEmployeeVerification", "workforceEmployeeVerificationRemarks", "eisApprovalIds", "eisApprovedByIds", "doctorsFlag", "doctorsRecommendedDonation", "doctorsDiagnosis", "committeeId", "committeeRemarks", "rejectedIds"];
  // const filterArray = filters
  //   ? Object.entries(filters).map(([key, value]) => `${key}: "${value}"`)
  //   : [];

  var payload = formatPageQueryWithCount("workforceApplication", filters, projections);
  return graphql(payload, "WORKFORCE_APPLICATION");
}
function fetchWorkforceUserRoleWiseUser(mm, variables) {
  return graphqlWithVariables("\n      query ($roleIds: [String!], $orderBy: [String]) {\n        workforceUserRole(roleIdIn: $roleIds, orderBy: $orderBy) {\n          id\n          roleId\n          userId\n          lastName\n          otherNames\n        }\n      }\n    ", variables, ["ADMIN_WORKFORCE_ROLE_WISE_USERS_REQ", "ADMIN_WORKFORCE_ROLE_WISE_USERS_RESP", "ADMIN_WORKFORCE_ROLE_WISE_USERS_ERR"]);
}
function fetchApplicationWiseMovementList(mm, variables) {
  return graphqlWithVariables("\n      query ($applicationId: String) {\n        workforceApplicationMovement(applicationId: $applicationId) {\n          edges {\n            node {\n              id\n              status\n              revertNote\n              note\n              dateCreated\n              application {\n                id\n                eisApprovalIds\n                eisApprovedByIds\n                rejectedIds\n              }\n              applicationFrom {\n                id\n                lastName\n                otherNames\n                loginName\n              }\n              applicationTo {\n                id\n                lastName\n                otherNames\n                loginName\n                userRoles {\n                  role {\n                    id\n                    name\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n    ", variables, ["WORKFORCE_APPLICATIONS_MOVEMENT_REQ", "WORKFORCE_APPLICATIONS_MOVEMENT_RESP", "WORKFORCE_APPLICATIONS_MOVEMENT_ERR"]);
}
function fetchApplicationMovementsSummary(mm, filters) {
  var projections = ["id", "applicationId", "note", "action", "toEmployeeRecordId", "fromEmployeeRecordId", "toOfficeUnitOrganogramId", "fromOfficeUnitOrganogramId", "toOfficeId", "fromOfficeId", "toOfficeUnitId", "fromOfficeUnitId", "isCurrent", "isCc", "isCommitteeHead", "isCommitteeMember", "toEmployeeNameBng", "fromEmployeeNameBng", "toEmployeeNameEng", "fromEmployeeNameEng", "toEmployeeDesignationBng", "fromEmployeeDesignationBng", "toOfficeNameBng", "fromOfficeNameBng", "toEmployeeUnitNameBng", "fromEmployeeUnitNameBng", "fromEmployeeUsername", "deadlineDate", "status", "revertNote", "isReverted", "revertedById", "revertingDate", "applicationFromId", "applicationToId", "toRoleId", "fromRoleId", "fromOfficeDesignationId", "toOfficeDesignationId"];
  var payload = formatPageQueryWithCount("workforceApplicationMovement", filters, projections);
  return graphql(payload, "WORKFORCE_APPLICATION_MOVEMENTS");
}
function fetchApplicationPackage(mm, filters) {
  var projections = ["id", "applicationData", "meetingDate", "status", "name", "remarks", "year", "month", "organizationType", "sectionType", "userIds"];
  var payload = formatPageQueryWithCount("workforceApplicationSummary", filters, projections);
  return graphql(payload, "WORKFORCE_APPLICATION_SUMMARY");
}
function fetchDiseases(mm, filters) {
  var projections = ["id", "grade", "diseaseType", "diseaseName", "diseaseNo", "minimumDonationAmount", "maximumDonationAmount", "status"];
  var payload = formatPageQueryWithCount("workforceDiseases", filters, projections);
  return graphql(payload, "WORKFORCE_DISEASES");
}
function fetchWorkforceEmployee(mm, filters) {
  var present_location_projection = "presentLocation" + mm.getProjection("location.Location.FlatProjection");
  var permanent_location_projection = "permanentLocation" + mm.getProjection("location.Location.FlatProjection");
  var projections = ["id", "firstNameBn", "lastNameBn", "firstNameEn", "lastNameEn", "otherName", "phoneNumber", "email", "status", "gender", "birthCertificateNo", "nid", "passportNo", "permanentAddress", "presentAddress", "position", "monthlyEarning", "fatherNameBn", "fatherNameEn", "motherNameBn", "motherNameEn", "spouseNameBn", "spouseNameEn", "maritalStatus", "citizenship", "privacyLaw", "insuranceNumber", "birthDate", "employeeType", "lifeStatus", "deathDate", "relatedUser{id}", "workforceFactory{id,nameEn,nameBn}", present_location_projection, permanent_location_projection];
  var payload = formatPageQueryWithCount("workforceEmployerEmployees", filters, projections);
  return graphql(payload, "WORKFORCE_EMPLOYEE");
}
function fetchDependent(mm, filters) {
  var present_location_projection = "presentLocation" + mm.getProjection("location.Location.FlatProjection");
  var permanent_location_projection = "permanentLocation" + mm.getProjection("location.Location.FlatProjection");
  var projections = ["id", "firstNameBn", "lastNameBn", "firstNameEn", "lastNameEn", "phoneNumber", "email", "maritalStatus", "gender", "occupation", "birthDate", "nid", "lifeStatus", "relationType", "relationWithWorker", "status", "percentageOfCfGrant", present_location_projection, permanent_location_projection];
  var payload = formatPageQueryWithCount("workforceEmployeeDependent", filters, projections);
  return graphql(payload, "WORKFORCE_EMPLOYEE_DEPENDENT");
}
function fetchWorkforceEmployeeDependent(mm, filters) {
  var projections = ["id", "nameEn", "nameEn", "relationWithWorker", "status", "percentageOfCfGrant", "bankAccountNo", "nid", 'phoneNumber', "bank{id,nameEn,nameBn,routingNumber,parent{id,nameBn}}", "bankAccountHolderName", "dateCreated"];
  var payload = formatPageQueryWithCount("workforceEmployeeDependent", filters, projections);
  return graphql(payload, "WORKFORCE_EMPLOYEE_DEPENDENT");
}
function fetchService(mm, filters) {
  var projections = ["id", "workforceCompany{id}", "workforceFactory{id}", "workforceOffice{id}", "position", "joinDate", "resignationDate", "resignationReason", "monthlySalary", "status", "workforceEmployee{id,firstNameEn,firstNameBn,lastNameEn,lastNameBn}"];
  var payload = formatPageQueryWithCount("workforceEmployeeDesignation", filters, projections);
  return graphql(payload, "WORKFORCE_EMPLOYEES_SERVICE");
}
function createRepresentative(mutation, clientMutationLabel) {
  console.log({
    mutation: mutation
  });
  var requestedDateTime = new Date();
  return graphql(mutation.payload, ["REP_MUTATION_REQ", "REP_CREATE_REP_RESP", "REP_MUTATION_ERR"], {
    clientMutationId: mutation.clientMutationId,
    clientMutationLabel: clientMutationLabel,
    requestedDateTime: requestedDateTime
  });
}
function updateRepresentative(representativeData, clientMutationLabel) {
  var mutation = formatMutation("updateWorkforceRepresentative", formatRepresentativeGQL(representativeData), clientMutationLabel);
  var requestedDateTime = new Date();
  return graphql(mutation.payload, ["ORG_MUTATION_REQ", "ORG_UPDATE_ORG_RESP", "ORG_MUTATION_ERR"], {
    clientMutationId: mutation.clientMutationId,
    clientMutationLabel: clientMutationLabel,
    requestedDateTime: requestedDateTime
  });
}
function createWorkforceOrganization(organization, clientMutationLabel) {
  var mutation = formatMutation("createWorkforceOrganization", formatOrganizationGQL(organization), clientMutationLabel);
  var requestedDateTime = new Date();
  return graphql(mutation.payload, ["ORG_MUTATION_REQ", "ORG_CREATE_ORG_RESP", "ORG_MUTATION_ERR"], {
    clientMutationId: mutation.clientMutationId,
    clientMutationLabel: clientMutationLabel,
    requestedDateTime: requestedDateTime
  });
}
function updateWorkforceOrganization(representative, clientMutationLabel) {
  var mutation = formatMutation("updateWorkforceOrganization", formatOrganizationGQL(representative), clientMutationLabel);
  var requestedDateTime = new Date();
  return graphql(mutation.payload, ["ORG_MUTATION_REQ", "ORG_UPDATE_ORG_RESP", "ORG_MUTATION_ERR"], {
    clientMutationId: mutation.clientMutationId,
    clientMutationLabel: clientMutationLabel,
    requestedDateTime: requestedDateTime,
    id: representative.id
  });
}
function createWorkforceOtherCompensation(compensation, clientMutationLabel) {
  var mutation = formatMutation("createWorkforceOtherCompensationInfo", formatWorkforceOtherCompensationGQL(compensation), clientMutationLabel);
  var requestedDateTime = new Date();
  return graphql(mutation.payload, ["COMPENSATION_MUTATION_REQ", "COMPENSATION_CREATE_COMPENSATION_RESP", "COMPENSATION_MUTATION_ERR"], {
    clientMutationId: mutation.clientMutationId,
    clientMutationLabel: clientMutationLabel,
    requestedDateTime: requestedDateTime
  });
}
function updateWorkforceOtherCompensation(compensation, clientMutationLabel) {
  var mutation = formatMutation("updateWorkforceOtherCompensationInfo", formatWorkforceOtherCompensationGQL(compensation), clientMutationLabel);
  var requestedDateTime = new Date();
  return graphql(mutation.payload, ["COMPENSATION_MUTATION_REQ", "COMPENSATION_UPDATE_COMPENSATION_RESP", "COMPENSATION_MUTATION_ERR"], {
    clientMutationId: mutation.clientMutationId,
    clientMutationLabel: clientMutationLabel,
    requestedDateTime: requestedDateTime
  });
}

///registration actions///
function createWorkforceOtp(workforceOtp, clientMutationLabel) {
  var mutation = "mutation {\n  createWorkforceOtp(\n    nameBn: \"".concat(workforceOtp.firstNameBn, "\",\n    firstNameEn: \"").concat(workforceOtp.firstNameEn, "\",\n    lastNameEn: \"\",\n    nid: \"").concat(workforceOtp === null || workforceOtp === void 0 ? void 0 : workforceOtp.NID, "\",\n    birthCertificateNo: \"").concat(workforceOtp === null || workforceOtp === void 0 ? void 0 : workforceOtp.birthCertificateNo, "\",\n    phoneNumber: \"").concat(workforceOtp.mobile, "\",\n    status: \"").concat(WORKFORCE_STATUS$1.ACTIVE, "\"\n  ) {\n    internalId\n    error\n    message\n    code\n  }\n}");
  // const mutation = formatMutation(
  //   "createWorkforceOtp",
  //   formatWorkforceOtpGQL(workforceOtp),
  //   clientMutationLabel,
  // );
  var requestedDateTime = new Date();
  return graphql(mutation, ["OTP_MUTATION_REQ", "OTP_CREATE_OTP_RESP", "OTP_MUTATION_ERR"], {
    clientMutationId: mutation.clientMutationId,
    clientMutationLabel: clientMutationLabel,
    requestedDateTime: requestedDateTime
  });
}
function createWorkforceUser(workforceUser, clientMutationLabel) {
  var mutation = "mutation {\n  createWorkforceUser(\n    nameBn: \"".concat(workforceUser.firstNameBn, "\",\n    firstNameEn: \"").concat(workforceUser.firstNameEn, "\",\n    lastNameEn: \" \",\n    nid: \"").concat((workforceUser === null || workforceUser === void 0 ? void 0 : workforceUser.NID) || "", "\",\n    birthCertificateNo: \"").concat((workforceUser === null || workforceUser === void 0 ? void 0 : workforceUser.birthCertificateNo) || "", "\",\n    phoneNumber: \"").concat(workforceUser.mobile, "\",\n    status: \"").concat(WORKFORCE_STATUS$1.ACTIVE, "\",\n    username: \"\",\n    password: \"").concat(workforceUser === null || workforceUser === void 0 ? void 0 : workforceUser.password, "\",\n  ) {\n    internalId\n  }\n}");
  var requestedDateTime = new Date();
  return graphql(mutation, ["USER_MUTATION_REQ", "USER_CREATE_USER_RESP", "USER_MUTATION_ERR"], {
    clientMutationId: mutation.clientMutationId,
    clientMutationLabel: clientMutationLabel,
    requestedDateTime: requestedDateTime
  });
}
function fetchWorkforceDocument(mm, filters) {
  var projections = ["id", "path", "url", "status", "documentType", "holderType", "note", "workforceApplication{id}", "workforceDependent{id}", "workforceEmployeeBankingInfo{id}", "workforceDocumentType{id,nameBn,nameEn,documentType,mandatoryForApplicant,formStepNo,fieldId}", "workforceDocumentMapDocumentId{edges{node{workforceApplication{id},workforceDocument{id},verifiedBy{id},verifiedByRole{id},verificationDate,note,status}}}"];
  var payload = formatPageQueryWithCount("workforceDocuments", filters, projections);
  return graphql(payload, "WORKFORCE_DOCUMENT");
}
function fetchWorkforceOtherCompensation(mm, filters) {
  var projections = ["id", "entryBy", "dateOfCompensation", "amount", "statusOfPayment", "isEisBenefitAdjustmentEligible", "receivedFromOrganization", "remarks", "paymentType"];
  var payload = formatPageQueryWithCount("workforceOtherCompensationInfo", filters, projections);
  return graphql(payload, "WORKFORCE_OTHER_COMPENSATION");
}
function createWorkforceDocument(workforceDocumentType, clientMutationLabel) {
  var mutation = formatMutation("createWorkforceDocument", formatWorkforceDocumentGQL(workforceDocumentType), clientMutationLabel);
  var requestedDateTime = new Date();
  return graphql(mutation.payload, ["DOCUMENT_MUTATION_REQ", "DOCUMENT_CREATE_DOCUMENT_RESP", "DOCUMENT_MUTATION_ERR"], {
    clientMutationId: mutation.clientMutationId,
    clientMutationLabel: clientMutationLabel,
    requestedDateTime: requestedDateTime
  });
}
function updateWorkforceDocument(workforceDocumentType, clientMutationLabel) {
  var mutation = formatMutation("updateWorkforceDocument", formatWorkforceDocumentGQL(workforceDocumentType), clientMutationLabel);
  var requestedDateTime = new Date();
  return graphql(mutation.payload, ["DOCUMENT_MUTATION_REQ", "DOCUMENT_UPDATE_DOCUMENT_RESP", "DOCUMENT_MUTATION_ERR"], {
    clientMutationId: mutation.clientMutationId,
    clientMutationLabel: clientMutationLabel,
    requestedDateTime: requestedDateTime
  });
}
function createWorkforceDocumentMap(workforceDocumentType, clientMutationLabel) {
  var mutation = formatMutation("createWorkforceDocumentMap", formatWorkforceDocumentMapGQL(workforceDocumentType), clientMutationLabel);
  var requestedDateTime = new Date();
  return graphql(mutation.payload, ["DOCUMENT_MUTATION_MAP_REQ", "DOCUMENT_MAP_CREATE_DOCUMENT_RESP", "DOCUMENT_MUTATION_MAP_ERR"], {
    clientMutationId: mutation.clientMutationId,
    clientMutationLabel: clientMutationLabel,
    requestedDateTime: requestedDateTime
  });
}
function createWorkforceOrganizationUnit(unit, clientMutationLabel) {
  var mutation = formatMutation("createWorkforceOrganizationUnit", formatUnitGQL(unit), clientMutationLabel);
  var requestedDateTime = new Date();
  return graphql(mutation.payload, ["ORG_UNIT_MUTATION_REQ", "ORG_UNIT_CREATE_RESP", "ORG_MUTATION_ERR"], {
    clientMutationId: mutation.clientMutationId,
    clientMutationLabel: clientMutationLabel,
    requestedDateTime: requestedDateTime
  });
}
function updateWorkforceOrganizationUnit(unit, clientMutationLabel) {
  var mutation = formatMutation("updateWorkforceOrganizationUnit", formatUnitGQL(unit), clientMutationLabel);
  var requestedDateTime = new Date();
  return graphql(mutation.payload, ["ORG_UNIT_MUTATION_REQ", "ORG_UNIT_CREATE_RESP", "ORG_MUTATION_ERR"], {
    clientMutationId: mutation.clientMutationId,
    clientMutationLabel: clientMutationLabel,
    requestedDateTime: requestedDateTime,
    id: unit.id
  });
}
function createOrganizationEmployee(employee, clientMutationLabel) {
  var mutation = formatMutation("createWorkforceOrganizationEmployee", formatOrganizationEmployeeGQL(employee), clientMutationLabel);
  var requestedDateTime = new Date();
  return graphql(mutation.payload, ["WORKFORCE_ORGANIZATION_EMPLOYEES_REQ", "WORKFORCE_ORGANIZATION_EMPLOYEES_RESP", "WORKFORCE_ORGANIZATION_EMPLOYEES_ERR"], {
    clientMutationId: mutation.clientMutationId,
    clientMutationLabel: clientMutationLabel,
    requestedDateTime: requestedDateTime
  });
}
function updateOrganizationEmployee(employee, clientMutationLabel) {
  var mutation = formatMutation("updateWorkforceOrganizationEmployee", formatOrganizationEmployeeGQL(employee), clientMutationLabel);
  var requestedDateTime = new Date();
  return graphql(mutation.payload, ["WORKFORCE_ORGANIZATION_EMPLOYEES_REQ", "WORKFORCE_ORGANIZATION_EMPLOYEES_RESP", "WORKFORCE_ORGANIZATION_EMPLOYEES_ERR"], {
    clientMutationId: mutation.clientMutationId,
    clientMutationLabel: clientMutationLabel,
    requestedDateTime: requestedDateTime,
    id: employee.id
  });
}
function createWorkforceOffice(office, clientMutationLabel) {
  var mutation = formatMutation("createWorkforceEmployerOffice", formatWorkforceOfficeGQL(office), clientMutationLabel);
  var requestedDateTime = new Date();
  return graphql(mutation.payload, ["WORKFORCE_OFFICES_REQ", "WORKFORCE_OFFICES_RESP", "WORKFORCE_OFFICES_ERR"], {
    clientMutationId: mutation.clientMutationId,
    clientMutationLabel: clientMutationLabel,
    requestedDateTime: requestedDateTime
  });
}
function updateWorkforceOffice(office, clientMutationLabel) {
  var mutation = formatMutation("updateWorkforceEmployerOffice", formatWorkforceOfficeGQL(office), clientMutationLabel);
  var requestedDateTime = new Date();
  return graphql(mutation.payload, ["WORKFORCE_OFFICES_REQ", "WORKFORCE_OFFICES_RESP", "WORKFORCE_OFFICES_ERR"], {
    clientMutationId: mutation.clientMutationId,
    clientMutationLabel: clientMutationLabel,
    requestedDateTime: requestedDateTime
  });
}
function createWorkforceCompany(company, clientMutationLabel) {
  var mutation = formatMutation("createWorkforceEmployer", formatWorkforceCompanyGQL(company), clientMutationLabel);
  console.log({
    mutation: mutation
  });
  var requestedDateTime = new Date();
  return graphql(mutation.payload, ["WORKFORCE_COMPANIES_REQ", "WORKFORCE_COMPANIES_RESP", "WORKFORCE_COMPANIES_ERR"], {
    clientMutationId: mutation.clientMutationId,
    clientMutationLabel: clientMutationLabel,
    requestedDateTime: requestedDateTime
  });
}
function createWorkforceFactory(factory, clientMutationLabel) {
  var mutation = formatMutation("createWorkforceEmployerFactory", formatWorkforceFactoryGQL(factory), clientMutationLabel);
  var requestedDateTime = new Date();
  return graphql(mutation.payload, ["WORKFORCE_FACTORIES_REQ", "WORKFORCE_FACTORIES_RESP", "WORKFORCE_FACTORIES_ERR"], {
    clientMutationId: mutation.clientMutationId,
    clientMutationLabel: clientMutationLabel,
    requestedDateTime: requestedDateTime
  });
}
function updateWorkforceFactory(factory, clientMutationLabel) {
  var mutation = formatMutation("updateWorkforceEmployerFactory", formatWorkforceFactoryGQL(factory), clientMutationLabel);
  var requestedDateTime = new Date();
  return graphql(mutation.payload, ["WORKFORCE_FACTORY_REQ", "WORKFORCE_FACTORY_RESP", "WORKFORCE_FACTORY_ERR"], {
    clientMutationId: mutation.clientMutationId,
    clientMutationLabel: clientMutationLabel,
    requestedDateTime: requestedDateTime,
    id: factory.id
  });
}
function createWorkforceAssociation(association, clientMutationLabel) {
  var mutation = formatMutation("createWorkforceAllAssociation", formatWorkforceAssociationGQL(association), clientMutationLabel);
  var requestedDateTime = new Date();
  return graphql(mutation.payload, ["WORKFORCE_ALL_ASSOCIATIONS_REQ", "WORKFORCE_ALL_ASSOCIATIONS_RESP", "WORKFORCE_ALL_ASSOCIATIONS_ERR"], {
    clientMutationId: mutation.clientMutationId,
    clientMutationLabel: clientMutationLabel,
    requestedDateTime: requestedDateTime
  });
}
function updateWorkforceAssociation(association, clientMutationLabel) {
  var mutation = formatMutation("updateWorkforceAllAssociation", formatWorkforceAssociationGQL(association), clientMutationLabel);
  var requestedDateTime = new Date();
  return graphql(mutation.payload, ["WORKFORCE_ALL_ASSOCIATIONS_REQ", "WORKFORCE_ALL_ASSOCIATIONS_RESP", "WORKFORCE_ALL_ASSOCIATIONS_ERR"], {
    clientMutationId: mutation.clientMutationId,
    clientMutationLabel: clientMutationLabel,
    requestedDateTime: requestedDateTime,
    id: association.id
  });
}
function createWorkforceEmployee(employee, clientMutationLabel) {
  var mutation = formatMutation("createWorkforceEmployerEmployee", formatWorkforceEmployeeGQL(employee), clientMutationLabel);
  var requestedDateTime = new Date();
  return graphql(mutation.payload, ["WORKFORCE_EMPLOYEES_REQ", "WORKFORCE_EMPLOYEES_RESP", "WORKFORCE_EMPLOYEES_ERR"], {
    clientMutationId: mutation.clientMutationId,
    clientMutationLabel: clientMutationLabel,
    requestedDateTime: requestedDateTime
  });
}
function updateWorkforceEmployee(employee, clientMutationLabel) {
  var mutation = formatMutation("updateWorkforceEmployerEmployee", formatWorkforceEmployeeGQL(employee), clientMutationLabel);
  var requestedDateTime = new Date();
  return graphql(mutation.payload, ["WORKFORCE_EMPLOYEES_REQ", "WORKFORCE_EMPLOYEES_RESP", "WORKFORCE_EMPLOYEES_ERR"], {
    clientMutationId: mutation.clientMutationId,
    clientMutationLabel: clientMutationLabel,
    requestedDateTime: requestedDateTime,
    id: employee.id
  });
}
function createAccidentInfo(employee, clientMutationLabel) {
  var mutation = formatMutation("createWorkforceEmployeeAccident", formatWorkforceEmployeeAccidentInfoGQL(employee), clientMutationLabel);
  var requestedDateTime = new Date();
  return graphql(mutation.payload, ["WORKFORCE_EMPLOYEES_ACCIDENT_REQ", "WORKFORCE_EMPLOYEES_ACCIDENT_RESP", "WORKFORCE_EMPLOYEES_ACCIDENT_ERR"], {
    clientMutationId: mutation.clientMutationId,
    clientMutationLabel: clientMutationLabel,
    requestedDateTime: requestedDateTime
  });
}
function updateAccidentInfo(employee, clientMutationLabel) {
  var mutation = formatMutation("updateWorkforceEmployeeAccident", formatWorkforceEmployeeAccidentInfoGQL(employee), clientMutationLabel);
  var requestedDateTime = new Date();
  return graphql(mutation.payload, ["WORKFORCE_EMPLOYEES_ACCIDENT_REQ", "WORKFORCE_EMPLOYEES_ACCIDENT_RESP", "WORKFORCE_EMPLOYEES_ACCIDENT_ERR"], {
    clientMutationId: mutation.clientMutationId,
    clientMutationLabel: clientMutationLabel,
    requestedDateTime: requestedDateTime,
    id: employee.id
  });
}
function createAccountInfo(employee, clientMutationLabel) {
  var mutation = formatMutation("createWorkforceEmployeeAccountInfo", formatWorkforceEmployeeAccountInfoGQL(employee), clientMutationLabel);
  var requestedDateTime = new Date();
  return graphql(mutation.payload, ["WORKFORCE_EMPLOYEES_ACCOUNT_REQ", "WORKFORCE_EMPLOYEES_ACCOUNT_RESP", "WORKFORCE_EMPLOYEES_ACCOUNT_ERR"], {
    clientMutationId: mutation.clientMutationId,
    clientMutationLabel: clientMutationLabel,
    requestedDateTime: requestedDateTime
  });
}
function updateAccountInfo(employee, clientMutationLabel) {
  var mutation = formatMutation("updateWorkforceEmployeeAccountInfo", formatWorkforceEmployeeAccountInfoGQL(employee), clientMutationLabel);
  var requestedDateTime = new Date();
  return graphql(mutation.payload, ["WORKFORCE_EMPLOYEES_ACCOUNT_REQ", "WORKFORCE_EMPLOYEES_ACCOUNT_RESP", "WORKFORCE_EMPLOYEES_ACCOUNT_ERR"], {
    clientMutationId: mutation.clientMutationId,
    clientMutationLabel: clientMutationLabel,
    requestedDateTime: requestedDateTime,
    id: employee.id
  });
}
function createEmployeeDependent(employee, clientMutationLabel) {
  var mutation = formatMutation("createWorkforceEmployeeDependent", formatWorkforceEmployeeGQL(employee), clientMutationLabel);
  var requestedDateTime = new Date();
  return graphql(mutation.payload, ["EMPLOYEE_DEPENDENT_MUTATION_REQ", "EMPLOYEE_DEPENDENT_CREATE_EMPLOYEE_DEPENDENT_RESP", "EMPLOYEE_DEPENDENT_MUTATION_ERR"], {
    clientMutationId: mutation.clientMutationId,
    clientMutationLabel: clientMutationLabel,
    requestedDateTime: requestedDateTime
  });
}
function updateEmployeeDependent$1(employee, clientMutationLabel) {
  var mutation = formatMutation("updateWorkforceEmployeeDependent", formatEmployeeDependentGQL(employee), clientMutationLabel);
  var requestedDateTime = new Date();
  return graphql(mutation.payload, ["EMPLOYEE_DEPENDENT_MUTATION_REQ", "EMPLOYEE_DEPENDENT_UPDATE_EMPLOYEE_DEPENDENT_RESP", "EMPLOYEE_DEPENDENT_MUTATION_ERR"], {
    clientMutationId: mutation.clientMutationId,
    clientMutationLabel: clientMutationLabel,
    requestedDateTime: requestedDateTime,
    id: employee.id
  });
}
function createEmployeeService(employee, clientMutationLabel) {
  var mutation = formatMutation("createWorkforceEmployeeService", formatWorkforceEmployeeGQL(employee), clientMutationLabel);
  var requestedDateTime = new Date();
  return graphql(mutation.payload, ["EMPLOYEE_SERVICE_MUTATION_REQ", "EMPLOYEE_SERVICE_CREATE_EMPLOYEE_SERVICE_RESP", "EMPLOYEE_SERVICE_MUTATION_ERR"], {
    clientMutationId: mutation.clientMutationId,
    clientMutationLabel: clientMutationLabel,
    requestedDateTime: requestedDateTime
  });
}
function updateEmployeeService(employee, clientMutationLabel) {
  var mutation = formatMutation("updateWorkforceEmployeeService", formatEmployeeDependentGQL(employee), clientMutationLabel);
  var requestedDateTime = new Date();
  return graphql(mutation.payload, ["EMPLOYEE_SERVICE_MUTATION_REQ", "EMPLOYEE_SERVICE_UPDATE_EMPLOYEE_SERVICE_RESP", "EMPLOYEE_SERVICE_MUTATION_ERR"], {
    clientMutationId: mutation.clientMutationId,
    clientMutationLabel: clientMutationLabel,
    requestedDateTime: requestedDateTime,
    id: employee.id
  });
}
function updateWorkforceCompany(company, clientMutationLabel) {
  var mutation = formatMutation("updateWorkforceEmployer", formatWorkforceCompanyGQL(company), clientMutationLabel);
  var requestedDateTime = new Date();
  return graphql(mutation.payload, ["WORKFORCE_COMPANIES_REQ", "WORKFORCE_COMPANIES_RESP", "WORKFORCE_COMPANIES_ERR"], {
    clientMutationId: mutation.clientMutationId,
    clientMutationLabel: clientMutationLabel,
    requestedDateTime: requestedDateTime,
    id: company === null || company === void 0 ? void 0 : company.id
  });
}
function updateStatusOfWorkforceCompany(company, clientMutationLabel) {
  var mutation = formatMutation("updateWorkforceEmployerStatus", formatWorkforceCompanyStatusGql(company), clientMutationLabel);
  var requestedDateTime = new Date();
  return graphql(mutation.payload, ["COMPANY_STATUS_MUTATION_REQ", "COMPANY_STATUS_UPDATE_RESP", "COMPANY_STATUS_MUTATION_ERR"], {
    clientMutationId: mutation.clientMutationId,
    clientMutationLabel: clientMutationLabel,
    requestedDateTime: requestedDateTime,
    id: company === null || company === void 0 ? void 0 : company.id
  });
}

////unit designation update /////////
function createUnitDesignation(unitDesignation, clientMutationLabel) {
  var mutation = formatMutation("createWorkforceOrganizationUnitDesignation", formatUnitDesignationGQL(unitDesignation), clientMutationLabel);
  var requestedDateTime = new Date();
  return graphql(mutation.payload, ["UNIT_DESIGNATION_MUTATION_REQ", "UNIT_DESIGNATION_CREATE_UNIT_DESIGNATION_RESP", "UNIT_DESIGNATION_MUTATION_ERR"], {
    clientMutationId: mutation.clientMutationId,
    clientMutationLabel: clientMutationLabel,
    requestedDateTime: requestedDateTime
  });
}
function updateUnitDesignation(unitDesignation, clientMutationLabel) {
  var mutation = formatMutation("updateWorkforceOrganizationUnitDesignation", formatUnitDesignationGQL(unitDesignation), clientMutationLabel);
  var requestedDateTime = new Date();
  return graphql(mutation.payload, ["UNIT_DESIGNATION_MUTATION_REQ", "UNIT_DESIGNATION_UPDATE_UNIT_DESIGNATION_RESP", "UNIT_DESIGNATION_MUTATION_ERR"], {
    clientMutationId: mutation.clientMutationId,
    clientMutationLabel: clientMutationLabel,
    requestedDateTime: requestedDateTime,
    id: unitDesignation.id
  });
}
function fetchOrganization(mm, filters) {
  var location_projection = "location" + mm.getProjection("location.Location.FlatProjection");
  var projections = ["id", "nameEn", "nameBn", "phoneNumber", "email", "website", "parent{id,nameEn,nameBn}", "workforceRepresentative { id,nameBn,nameEn,position,email,phoneNumber,nid,birthDate, passportNo, address, " + location_projection + "}", "address", location_projection];
  var payload = formatPageQueryWithCount("workforceOrganizations", filters, projections);
  return graphql(payload, "WORKFORCE_ORGANIZATION");
}
function fetchOrganizationUnit(mm, filters) {
  var projections = ["id", "nameEn", "nameBn", "phoneNumber", "email", "unitLevel", "parent{id,nameBn,nameEn}", " organization{id,nameBn,nameEn}"];
  var payload = formatPageQueryWithCount("workforceOrganizationUnits", filters, projections);
  return graphql(payload, "WORKFORCE_ORGANIZATION_UNIT");
}

///fetching workforce organization unit designations////
function fetchUnitDesignation(mm, filters) {
  var projections = ["id", "nameEn", "nameBn", "designationLevel", "designationSequence", "unit{id,nameBn,nameEn}", "organization{id,nameBn,nameEn}"];
  var payload = formatPageQueryWithCount("workforceOrganizationUnitDesignations", filters, projections);
  return graphql(payload, "WORKFORCE_ORGANIZATION_UNIT_DESIGNATION");
}

///fetching workforce factory employee////
function fetchFactoryEmployee(mm, filters) {
  var projections = ["id", "employeeDesignationEmployeeId{edges{node{id,workforceFactory{id}}}}", "workforceFactory{id, nameBn, nameEn,membershipNo,registrationDate,status,registrationExpiryDate,allAssociation{id,nameBn,nameEn,startDate}}", "relatedUser{id}"];
  var payload = formatPageQueryWithCount("workforceEmployerEmployees", filters, projections);
  return graphql(payload, "WORKFORCE_EMPLOYEE");
}

///fetching employee designation details

function fetchEmployeeDesignations(filters) {
  var projections = ["id", "nameBn", "email", "nid", "phoneNumber", "designations {id,status,designation{id,nameBn, nameEn,unit{nameBn,nameEn},organization{nameBn,nameEn}}}", "relatedUser {id,loginName}"];
  var payload = formatPageQueryWithCount("workforceOrganizationEmployees", filters, projections);
  return graphql(payload, "WORKFORCE_ORGANIZATIONS_EMPLOYEE_DESIGNATIONS");
}
function updateWorkforceOrganizationEmployeeDesignation(employeeDesignation, clientMutationLabel) {
  var mutation = formatMutation("updateWorkforceOrganizationEmployeeDesignation", formatEmployeeDesignationGQL(employeeDesignation), clientMutationLabel);
  var requestedDateTime = new Date();
  return graphql(mutation.payload, ["EMPLOYEE_DESIGNATION_MUTATION_REQ", "EMPLOYEE_DESIGNATION_MUTATION_ERR", "EMPLOYEE_DESIGNATION_UPDATE_RELEASE_RESP"], {
    clientMutationId: mutation.clientMutationId,
    clientMutationLabel: clientMutationLabel,
    requestedDateTime: requestedDateTime,
    id: employeeDesignation.id
  });
}
function updateWorkforceOrganizationEmployeeAssignDesignation(employeeAssignDesignation, clientMutationLabel) {
  var mutation = formatMutation("createWorkforceOrganizationEmployeeDesignation", formatEmployeeAssignDesignationGQL(employeeAssignDesignation), clientMutationLabel);
  var requestedDateTime = new Date();
  return graphql(mutation.payload, ["EMPLOYEE_ASSIGN_DESIGNATION_MUTATION_REQ", "EMPLOYEE_ASSIGN_DESIGNATION_MUTATION_ERR", "EMPLOYEE_DESIGNATION_UPDATE_ASSIGN_RESP"], {
    clientMutationId: mutation.clientMutationId,
    clientMutationLabel: clientMutationLabel,
    requestedDateTime: requestedDateTime,
    id: employeeAssignDesignation.id
  });
}
function updateWorkforceEmployeeAssignDesignation(employeeAssignDesignation, clientMutationLabel) {
  var mutation = formatMutation("updateWorkforceEmployeeDesignation", formatFactoryEmployeeAssignDesignationGQL(employeeAssignDesignation), clientMutationLabel);
  var requestedDateTime = new Date();
  return graphql(mutation.payload, ["WORKFORCE_ EMPLOYEE_ASSIGN_DESIGNATION_MUTATION_REQ", "WORKFORCE_ EMPLOYEE_ASSIGN_DESIGNATION_MUTATION_ERR", "WORKFORCE_ EMPLOYEE_DESIGNATION_UPDATE_ASSIGN_RESP"], {
    clientMutationId: mutation.clientMutationId,
    clientMutationLabel: clientMutationLabel,
    requestedDateTime: requestedDateTime,
    id: employeeAssignDesignation.id
  });
}
function fetchBank(mm, filters) {
  var location_projection = "location" + mm.getProjection("location.Location.FlatProjection");
  var projections = ["id", "nameEn", "nameBn", "headquarterAddress", "routingNumber", "contactNumber", "parent{id}", "status", "type", location_projection];
  var payload = formatPageQueryWithCount("banks", filters, projections);
  return graphql(payload, "WORKFORCE_BANK");
}
function fetchEmployeeDependent(mm, filters) {
  "location" + mm.getProjection("location.Location.FlatProjection");
  var projections = ["id", "nid", "nameBn", "nameEn"];
  var payload = formatPageQueryWithCount("workforceEmployeeDependent", filters, projections);
  return graphql(payload, "WORKFORCE_DEPENDENT");
}
function createBank(bank, clientMutationLabel) {
  var mutation = formatMutation("createWorkforceBank", formatBankGQL(bank), clientMutationLabel);
  console.log({
    mutation: mutation
  });
  var requestedDateTime = new Date();
  return graphql(mutation.payload, ["BANK_MUTATION_REQ", "BANK_CREATE_BANK_RESP", "BANK_MUTATION_ERR"], {
    clientMutationId: mutation.clientMutationId,
    clientMutationLabel: clientMutationLabel,
    requestedDateTime: requestedDateTime
  });
}
function updateBank(bank, clientMutationLabel) {
  var mutation = formatMutation("updateBank", formatBankGQL(bank), clientMutationLabel);
  console.log({
    mutation: mutation
  });
  var requestedDateTime = new Date();
  return graphql(mutation.payload, ["BANK_MUTATION_REQ", "BANK_UPDATE_BANK_RESP", "BANK_MUTATION_ERR"], {
    clientMutationId: mutation.clientMutationId,
    clientMutationLabel: clientMutationLabel,
    requestedDateTime: requestedDateTime
  });
}
function createApplication(mutation, clientMutationLabel) {
  // const mutation = formatMutation(
  //   "createWorkforceApplication",
  //   formatApplicationeGQL(application),
  //   clientMutationLabel,
  // );

  // console.log({mutation})
  var requestedDateTime = new Date();
  return graphql(mutation.payload, ["APPLICATION_MUTATION_REQ", "APPLICATION_CREATE_APPLICATION_RESP", "APPLICATION_MUTATION_ERR"], {
    clientMutationId: mutation.clientMutationId,
    clientMutationLabel: clientMutationLabel,
    requestedDateTime: requestedDateTime
  });
}
function updateApplication(application, clientMutationLabel) {
  var mutation = formatMutation("updateWorkforceApplication", formatApplicationeGQL(application), clientMutationLabel);
  console.log({
    mutation: mutation
  });
  var requestedDateTime = new Date();
  return graphql(mutation.payload, ["APPLICATION_MUTATION_REQ", "APPLICATION_UPDATE_APPLICATION_RESP", "APPLICATION_MUTATION_ERR"], {
    clientMutationId: mutation.clientMutationId,
    clientMutationLabel: clientMutationLabel,
    requestedDateTime: requestedDateTime
  });
}
function eisPaymentProcessWithoutDate(applicationIds) {
  var recall = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "no";
  var idsArray = Array.isArray(applicationIds) ? applicationIds : [applicationIds];
  var idsString = idsArray.map(function (id) {
    return "\"".concat(id, "\"");
  }).join(",");
  var mutation = "\n    mutation {\n      createWorkforceEisPaymentProcess(\n        workforceApplicationIds: [".concat(idsString, "]\n        recall: \"").concat(recall, "\"\n      ) {\n        success\n        errors\n      }\n    }\n  ");
  return graphql(mutation, "WORKFORCE_EIS_PAYMENT_PROCESS");
}
function testWorkforcePayment(testPaymentData) {
  var mutation = "\n    mutation {\n      testWorkforcePayment(\n        workforceApplicationId: \"".concat(testPaymentData === null || testPaymentData === void 0 ? void 0 : testPaymentData.id, "\"\n      ) {\n        success\n        errors\n      }\n    }\n  ");
  return graphql(mutation, "WORKFORCE_TEST_PAYMENT");
}
function createEducationInfo(education, clientMutationLabel) {
  var mutation = formatMutation("createWorkforceEducation", formatEducationInfoGQL(education), clientMutationLabel);
  console.log({
    mutation: mutation
  });
  var requestedDateTime = new Date();
  return graphql(mutation.payload, ["EDUCATION_INFO_MUTATION_REQ", "EDUCATION_INFO_CREATE_EDUCATION_RESP", "EDUCATION_INFO_MUTATION_ERR"], {
    clientMutationId: mutation.clientMutationId,
    clientMutationLabel: clientMutationLabel,
    requestedDateTime: requestedDateTime
  });
}
function createApplicationMovement(application, clientMutationLabel) {
  var mutation = formatMutation("createWorkforceApplicationMovement", formatApplicationMovementGQL(application), clientMutationLabel);
  console.log({
    mutation: mutation
  });
  var requestedDateTime = new Date();
  return graphql(mutation.payload, ["APPLICATION_MOVEMENT_MUTATION_REQ", "APPLICATION_MOVEMENT_CREATE_APPLICATION_RESP", "APPLICATION_MOVEMENT_MUTATION_ERR"], {
    clientMutationId: mutation.clientMutationId,
    clientMutationLabel: clientMutationLabel,
    requestedDateTime: requestedDateTime
  });
}
function createApplicationSummary(mutation, clientMutationLabel) {
  // const mutation = formatMutation(
  //   "createWorkforceApplicationSummary",
  //   formatApplicationSummaryGQL(applicationSummary),
  //   clientMutationLabel
  // );

  // console.log({ mutation });
  var requestedDateTime = new Date();
  return graphql(mutation.payload, ["APPLICATION_SUMMARY_MUTATION_REQ", "APPLICATION_SUMMARY_CREATE_APPLICATION_RESP", "APPLICATION_SUMMARY_MUTATION_ERR"], {
    clientMutationId: mutation.clientMutationId,
    clientMutationLabel: clientMutationLabel,
    requestedDateTime: requestedDateTime
  });
}
function updateApplicationSummary(applicationSummary, clientMutationLabel) {
  var mutation = formatMutation("updateWorkforceApplicationSummary", formatApplicationSummaryGQL(applicationSummary), clientMutationLabel);

  // console.log({ mutation });
  var requestedDateTime = new Date();
  return graphql(mutation.payload, ["APPLICATION_SUMMARY_MUTATION_REQ", "APPLICATION_SUMMARY_CREATE_APPLICATION_RESP", "APPLICATION_SUMMARY_MUTATION_ERR"], {
    clientMutationId: mutation.clientMutationId,
    clientMutationLabel: clientMutationLabel,
    requestedDateTime: requestedDateTime
  });
}
function fetchInfoIdByClientMutationId(mm, querySchema, clientMutationId, reduxKey) {
  var payload = "{\n  ".concat(querySchema, "(\n    clientMutationId: \"").concat(clientMutationId, "\"\n  ) {\n    edges {\n      node {\n        id\n      }\n    }\n  }\n}\n");
  return graphql(payload, reduxKey);
}
function fetchFactoryPublicInfoIdByClientMutationId(clientMutationId, reduxKey) {
  var payload = "{\n                      workforceEmployerFactoriesPublic(\n                        clientMutationId: \"".concat(clientMutationId, "\"\n                      ){\n                        id\n                      }\n                    }\n                    ");
  return graphql(payload, reduxKey);
}
function fetchFactoryByClientMutationId(mm, clientMutationId) {
  var payload = "{\n  workforceEmployerFactories(\n    clientMutationId: \"".concat(clientMutationId, "\"\n  ) {\n    edges {\n      node {\n        id\n      }\n    }\n  }\n}\n");
  return graphql(payload, "WORKFORCE_FACTORY_BY_FACTORY_MUTATION_ID_RESP");
}
function fetchRepresentativeByClientMutationId(mm, clientMutationId) {
  var payload = "{\n  workforceRepresentatives(\n    clientMutationId: \"".concat(clientMutationId, "\"\n  ) {\n    edges {\n      node {\n        id\n      }\n    }\n  }\n}\n");
  return graphql(payload, "WORKFORCE_REPRESENTATIVE_BY_CLIENT_MUTATION_ID");
}
function fetchApplicationSummaryByClientMutationId(mm, clientMutationId) {
  var payload = "{\n  workforceApplicationSummary(\n    clientMutationId: \"".concat(clientMutationId, "\"\n  ) {\n    edges {\n      node {\n        id\n      }\n    }\n  }\n}\n");
  return graphql(payload, "WORKFORCE_APPLICATION_SUMMARY_BY_CLIENT_MUTATION_ID");
}
function fetchWorkforceSignatures(roleIds) {
  var payload = "{\n  workforceSignatures(relatedUsers: ".concat(JSON.stringify(roleIds), ")\n}\n");
  return graphql(payload, "WORKFORCE_SIGNATURE");
}
function fetchApplicationId(mm, clientMutationId) {
  var payload = "{\n  workforceApplication(\n    clientMutationId: \"".concat(clientMutationId, "\"\n  ) {\n    edges {\n      node {\n        id\n      }\n    }\n  }\n}\n");
  return graphql(payload, "WORKFORCE_APPLICATION_BY_CLIENT_MUTATION_ID");
}
function fetchOrganizationEmployeeDesignation(mm, clientMutationId) {
  var payload = "{\n  workforceOrganizationEmployeeDesignations(employee_Id:\"".concat(clientMutationId, "\") {\n    edges {\n      node {\n        id\n        designation {\n          id\n        }\n      }\n    }\n  }\n}\n");
  return graphql(payload, "WORKFORCE_ORGANIZATION_BY_DESIGNATION_MUTATION_ID");
}
function fetchPostOfficesPick(mm, id) {
  var payload = "{\n  workforcePostoffice(wCodeId: \"".concat(id, "\", orderBy: [\"name_bn\"]){\n    id\n    postCode\n    postOffice\n    nameEn\n    nameBn\n    wCode\n    status\n  }\n}\n");
  return graphql(payload, "WORKFORCE_POST_OFFICE_PICKER");
}
function fetchWorkforceEmployeeDesignation(mm, filters) {
  var projections = ["id", "joinDate", "resignationDate", "resignationReason", "position", "status", "workforceCompany {id,nameEn,nameBn}", "workforceFactory {id,nameEn,nameBn}", "workforceOffice {id}", "workforceEmployee{id,firstNameBn,firstNameEn,email,phoneNumber,birthDate,deathDate,joinDate,presentAddress,insuranceNumber,nid,birthCertificateNo,permanentAddress}"
  // "unitDesignations {id,nameBn,nameEn,activeEmployeeDesignation{id,status,joiningDate,employee{id,nameEn,nameBn,email,phoneNumber}}}",
  ];
  var payload = formatPageQueryWithCount("workforceEmployeeDesignation", filters, projections);
  return graphql(payload, "WORKFORCE_EMPLOYEE_DESIGNATIONS");
}
function fetchWorkforceUnitsWithEmployeeDesignation(filters) {
  var projections = ["id", "nameBn", "nameEn", "unitDesignations {id,nameBn,nameEn,activeEmployeeDesignation{id,status,joiningDate,employee{id,nameEn,nameBn,email,phoneNumber}}}"];
  var payload = formatPageQueryWithCount("workforceOrganizationUnits", filters, projections);
  return graphql(payload, "WORKFORCE_ORGANIZATIONS_UNITWISE_DESIGNATIONS");
}
function verifyNid(mm, clientMutationId) {
  var payload = "{\n  workforceNidVerification(nid:\"8658556249\")\n}\n";
  return graphql(payload, "WORKFORCE_VERIFY_NID");
}
function fetchWorkforceApplicationStatusCount() {
  var payload = "query{\n  pending: workforceApplication(statusIn: [\"".concat(WORKFORCE_STATUS$1.FORWARD_TO_DIRECTOR, "\", \"").concat(WORKFORCE_STATUS$1.FORWARD_TO_DG, "\"]){\n    totalCount\n  }\n  rejected:workforceApplication(statusIn: [\"").concat(WORKFORCE_STATUS$1.REJECTED, "\"]){\n    totalCount\n  }\n  approved:workforceApplication(statusIn: [\"").concat(WORKFORCE_STATUS$1.APPROVED_BY_DG, "\"]){\n    totalCount\n  }\n  pendingForDirector: workforceApplication(statusIn: [\"").concat(WORKFORCE_STATUS$1.FORWARD_TO_DIRECTOR, "\"]){\n    totalCount\n  }\n  rejectedForDirector:workforceApplication(statusIn: [\"").concat(WORKFORCE_STATUS$1.REJECTED, "\"]){\n    totalCount\n  }\n  approvedForDirector:workforceApplication(statusIn: [\"").concat(WORKFORCE_STATUS$1.APPROVED_BY_DIRECTOR, "\"]){\n    totalCount\n  }\n  pendingForFactoryAdmin:workforceApplication(statusIn: [\"").concat(WORKFORCE_STATUS$1.NEW, "\"]){\n    totalCount\n  }\n  rejectedForFactoryAdmin:workforceApplication(statusIn: [\"").concat(WORKFORCE_STATUS$1.REJECTED, "\"]){\n    totalCount\n  }\n  revertedForFactoryAdmin:workforceApplication(statusIn: [\"").concat(WORKFORCE_STATUS$1.REVERT, "\"]){\n    totalCount\n  }\n  pendingForBGMEAAssociation:workforceApplication(statusIn: [\"").concat(WORKFORCE_STATUS$1.FORWARD_TO_ASSOCIATION, "\"]){\n    totalCount\n  }\n  rejectedForBGMEAAssociation:workforceApplication(statusIn: [\"").concat(WORKFORCE_STATUS$1.REJECTED, "\"]){\n    totalCount\n  }\n  revertedForBGMEAAssociation:workforceApplication(statusIn: [\"").concat(WORKFORCE_STATUS$1.REVERT, "\"]){\n    totalCount\n  }\n  pendingForBKMEAAssociation:workforceApplication(statusIn: [\"").concat(WORKFORCE_STATUS$1.FORWARD_TO_ASSOCIATION, "\"]){\n    totalCount\n  }\n  rejectedForBKMEAAssociation:workforceApplication(statusIn: [\"").concat(WORKFORCE_STATUS$1.REJECTED, "\"]){\n    totalCount\n  }\n  revertedForBKMEAAssociation:workforceApplication(statusIn: [\"").concat(WORKFORCE_STATUS$1.REVERT, "\"]){\n    totalCount\n  }\n  pendingForSectionAdmin:workforceApplication(statusIn: [\"").concat(WORKFORCE_STATUS$1.FORWARD_TO_CF_SECTION, "\"]){\n    totalCount\n  }\n  rejectedForSectionAdmin:workforceApplication(statusIn: [\"").concat(WORKFORCE_STATUS$1.REJECTED, "\"]){\n    totalCount\n  }\n  revertedForSectionAdmin:workforceApplication(statusIn: [\"").concat(WORKFORCE_STATUS$1.REVERT, "\"]){\n    totalCount\n  }\n    pendingForChecker:workforceApplication(statusIn: [\"").concat(WORKFORCE_STATUS$1.FORWARD_TO_CF_SECTION, "\"]){\n    totalCount\n  }\n    pendingForCheckerTwo:workforceApplication(statusIn: [\"").concat(WORKFORCE_STATUS$1.FORWARD_TO_CF_SECTION, "\"]){\n    totalCount\n  }\n    pendingForDoctor:workforceApplication(statusIn: [\"").concat(WORKFORCE_STATUS$1.FORWARD_TO_DOCTOR, "\"]){\n    totalCount\n  }\n    pendingForApprover:workforceApplication(statusIn: [\"").concat(WORKFORCE_STATUS$1.FORWARD_TO_COMIITEE, "\"]){\n    totalCount\n  }\n}");
  return graphql(payload, "WORKFORCE_APPLICATION_STATUS_COUNT");
}
function fetchApplicationByDate(months, fromDate, toDate, organizationType) {
  var APPLICATION_FIELDS = "\n    applicationType\n    applicationCount\n    approvedCount\n    rejectedCount\n  ";
  var args = [];
  if (organizationType) {
    args.push("organizationType: \"".concat(organizationType, "\""));
  }
  if (months > 0) {
    args.push("lastMonths: \"".concat(months, "\""));
  } else if (fromDate && toDate) {
    args.push("dateBetween: [\"".concat(fromDate, "\", \"").concat(toDate, "\"]"));
  }
  var argString = args.length > 0 ? "(".concat(args.join(", "), ")") : "";
  var payload = "\n    query {\n      workforceApplicationMatrix".concat(argString, " {\n        ").concat(APPLICATION_FIELDS, "\n      }\n    }\n  ");
  return graphql(payload, "WORKFORCE_APPLICATIONS_BY_DATE");
}
function fetchApplicationMonthWise(months, organizationType) {
  var APPLICATION_FIELDS = "\n    month\n    medical\n    educational\n    death\n    maternityGrant\n    disabilityAssistance\n  ";
  var args = [];
  if (organizationType) {
    args.push("organizationType: \"".concat(organizationType, "\""));
  }
  if (months > 0) {
    args.push("monthsBetween: \"".concat(months, "\""));
  }
  var argString = args.length > 0 ? "(".concat(args.join(", "), ")") : "";
  var payload = "\n    query {\n      workforceMonthwiseApplications".concat(argString, " {\n        ").concat(APPLICATION_FIELDS, "\n      }\n    }\n  ");
  return graphql(payload, "WORKFORCE_APPLICATIONS_MONTH_WISE");
}
function fetchGenderWiseApplicationMatrixByDate(months, fromDate, toDate, organizationType) {
  var GENDER_FIELDS = "\n    totalApplicant\n    totalDependent\n    maleApplicant\n    femaleApplicant\n    maleDependent\n    femaleDependent\n    totalBenefitAmount\n  ";
  var args = [];
  if (organizationType) {
    args.push("organizationType: \"".concat(organizationType, "\""));
  }
  if (months > 0) {
    args.push("lastMonths: \"".concat(months, "\""));
  } else if (fromDate && toDate) {
    args.push("dateBetween: [\"".concat(fromDate, "\", \"").concat(toDate, "\"]"));
  }
  var argString = args.length > 0 ? "(".concat(args.join(", "), ")") : "";
  var payload = "\n    query {\n      workforceGenderwiseMatrix".concat(argString, " {\n        ").concat(GENDER_FIELDS, "\n      }\n    }\n  ");
  return graphql(payload, "GENDER_WISE_APPLICATION_MATRIX_BY_DATE");
}
function fetchApplicationTimeWiseMatrix(organizationType, applicationType, daycount) {
  var organization = organizationType == "সব" || organizationType == "All" || organizationType == "all" ? "" : "organizationType:\"".concat(organizationType, "\"");
  console.log(organizationType);
  var typeList = applicationType.map(function (type) {
    return "\"".concat(type, "\"");
  }).join(", ");
  var dayWiseCount = daycount != null || daycount != "" ? "dayCount: \"".concat(daycount, "\"") : "";
  var payload = "\n    query {\n      workforceApplicationTimewiseMatrix(\n        applicationTypeIn: [".concat(typeList, "]\n        ").concat(organization, "\n        ").concat(dayWiseCount, "\n      ) {\n        totalApplicationCount\n        dayWiseCount {\n          day1\n          day3\n          day7\n          day10\n          day15\n          moreThan15\n        }\n        roleWiseCount {\n          roleName\n          userId\n          lastName\n          otherNames\n          applicationCount\n        }\n      }\n    }\n  ");
  return graphql(payload, "WORKFORCE_APPLICATIONS_TIME_WISE_MATRIX");
}
function fetchUserDistrictsUnauthorized() {
  var payload = formatQuery("userDistricts", null, ["id", "uuid", "code", "name", "parent{id, uuid, code, name}"]);
  return graphql(payload, "LOCATION_USER_DISTRICTS");
}
function fetchEisPaymentProcess(applicationIds, mm) {
  var idsArray = Array.isArray(applicationIds) ? applicationIds : [applicationIds];
  var idsString = idsArray.map(function (id) {
    return "\"".concat(id, "\"");
  }).join(",");
  var present_location_projection = "presentLocation" + mm.getProjection("location.Location.FlatProjection");
  var permanent_location_projection = "permanentLocation" + mm.getProjection("location.Location.FlatProjection");
  var payload = "\n    {\n      workforceEisPaymentProcess(\n        workforceApplicationIdIn: [".concat(idsString, "]\n      ) {\n        id\n        monthIndex\n        year\n        eisMonthlyAmount\n        eisInitialMonthlyAmount\n        eisPaymentType\n        eisApprovedAmount\n        eisCalculatedAmount\n        eisInitialReplacementRate\n        processingDate\n        beneficiaryId\n        isDisbursed\n        approved\n        paymentTypeRemarks\n        onetimeAmount\n        trimonthlyAmount\n        payableAmount\n        phoneNumber\n        noaSmsSent\n        noaConfirmed\n        routingNumber\n        remarks\n        bank {\n          id\n          nameEn\n          nameBn\n          districtNameEn\n          districtNameBn\n          bankCode\n          branchCode\n          routingNumber\n          parent\n          {\n            id\n            nameEn\n            nameBn\n          }\n        }\n        bankAccountNo\n        bankAccountHolderName\n        workforceEmployeeDependent{\n          status\n          nameEn\n          nameBn\n          relationWithWorker\n          disabilityStatus\n          birthDate\n          maritalStatus\n          nid\n          permanentAddress\n          presentAddress\n          ").concat(present_location_projection + permanent_location_projection, "\n          bankAccountNo\n          bank{\n            nameBn\n            districtNameBn\n            bankCode\n            routingNumber\n            parent{\n              nameBn\n            }\n          }\n        }\n        workforceApplication {\n          id\n          lastBaseSalary\n          associationType\n          applicationType\n          organizationType\n          employeeAccidentInfo\n          deceasedWorkerInfo\n          employeeBankInfo\n          doctorsEntry\n          dateCreated\n          trackingNumber\n          status\n          eisApprovalIds\n          eisApprovedByIds\n          eisApplicationSummary{\n            id\n            name\n          }\n          deceasedWorkerInfo\n          workforceEmployee {         \n            id\n            firstNameBn\n            firstNameEn\n            nid\n            birthDate\n            permanentAddress\n            presentAddress\n            ").concat(present_location_projection + permanent_location_projection, "\n\n          }\n          employeeFactory {\n            id\n            nameEn\n            nameBn\n            allAssociation{\n              id\n              nameEn\n              nameBn\n              shortNameBn\n              shortNameEn\n            }\n          }\n        }\n      }\n    }\n  ");
  return graphql(payload, "EIS_PAYMENT_PROCESS", {
    applicationIds: idsArray
  });
}
var setUploadedFiles = function setUploadedFiles(fieldKey, files) {
  return {
    type: "SET_UPLOADED_FILES",
    payload: {
      fieldKey: fieldKey,
      files: files
    }
  };
};
function updateWorkforceEisPaymentProcessPaymentType(eisPaymentData) {
  var mutation = "\n    mutation {\n      updateWorkforceEisPaymentProcessPaymentType(\n        beneficiaryId: \"".concat(eisPaymentData === null || eisPaymentData === void 0 ? void 0 : eisPaymentData.beneficiaryId, "\"\n        paymentType: \"").concat(eisPaymentData === null || eisPaymentData === void 0 ? void 0 : eisPaymentData.eisPaymentType, "\"\n      ) {\n        success\n        errors\n      }\n    }\n  ");
  return graphql(mutation, "UPDATE_WORKFORCE_EIS_PAYMENT_PROCESS_PAYMENT_TYPE");
}
function updateWorkforceEisPaymentProcessApproval(eisPaymentData) {
  var mutation = "\n    mutation {\n      updateWorkforceEisPaymentProcessApproval(\n        beneficiaryId: \"".concat(eisPaymentData === null || eisPaymentData === void 0 ? void 0 : eisPaymentData.beneficiaryId, "\"\n        approved: \"").concat(eisPaymentData === null || eisPaymentData === void 0 ? void 0 : eisPaymentData.approved, "\"\n      ) {\n        success\n        errors\n      }\n    }\n  ");
  return graphql(mutation, "UPDATE_WORKFORCE_EIS_PAYMENT_PROCESS_APPROVAL");
}
function fetchEisPaymentProcessWithFilters(filters, mm) {
  var _filters$processId, _filters$workforceApp, _filters$workforceApp2, _filters$workforceFac, _filters$allAssociati, _filters$beneficiaryI, _filters$status, _filters$beneficiaryS, _filters$approved, _filters$approvalDate, _filters$approvalDate2, _filters$accidentDate, _filters$accidentDate2, _filters$month, _filters$year, _filters$notInStage;
  var present_location_projection = "presentLocation" + mm.getProjection("location.Location.FlatProjection");
  var permanent_location_projection = "permanentLocation" + mm.getProjection("location.Location.FlatProjection");
  var payload = "\n    {\n      workforceEisPaymentProcess(\n        processId: \"".concat((_filters$processId = filters === null || filters === void 0 ? void 0 : filters.processId) !== null && _filters$processId !== void 0 ? _filters$processId : "", "\"\n        workforceApplicationId: \"").concat((_filters$workforceApp = filters === null || filters === void 0 ? void 0 : filters.workforceApplicationId) !== null && _filters$workforceApp !== void 0 ? _filters$workforceApp : "", "\"\n        workforceApplicationTrackingNumber: \"").concat((_filters$workforceApp2 = filters === null || filters === void 0 ? void 0 : filters.workforceApplicationTrackingNumber) !== null && _filters$workforceApp2 !== void 0 ? _filters$workforceApp2 : "", "\"\n        workforceFactoryId: \"").concat((_filters$workforceFac = filters === null || filters === void 0 ? void 0 : filters.workforceFactoryId) !== null && _filters$workforceFac !== void 0 ? _filters$workforceFac : "", "\"\n        allAssociationId: \"").concat((_filters$allAssociati = filters === null || filters === void 0 ? void 0 : filters.allAssociationId) !== null && _filters$allAssociati !== void 0 ? _filters$allAssociati : "", "\"\n        beneficiaryId: \"").concat((_filters$beneficiaryI = filters === null || filters === void 0 ? void 0 : filters.beneficiaryId) !== null && _filters$beneficiaryI !== void 0 ? _filters$beneficiaryI : "", "\"\n        status: \"").concat((_filters$status = filters === null || filters === void 0 ? void 0 : filters.status) !== null && _filters$status !== void 0 ? _filters$status : "", "\"\n        beneficiaryStatus: \"").concat((_filters$beneficiaryS = filters === null || filters === void 0 ? void 0 : filters.beneficiaryStatus) !== null && _filters$beneficiaryS !== void 0 ? _filters$beneficiaryS : "", "\"\n        approved: \"").concat((_filters$approved = filters === null || filters === void 0 ? void 0 : filters.approved) !== null && _filters$approved !== void 0 ? _filters$approved : "", "\"\n        approvalDateFrom: \"").concat((_filters$approvalDate = filters === null || filters === void 0 ? void 0 : filters.approvalDateFrom) !== null && _filters$approvalDate !== void 0 ? _filters$approvalDate : "", "\"\n        approvalDateTo: \"").concat((_filters$approvalDate2 = filters === null || filters === void 0 ? void 0 : filters.approvalDateTo) !== null && _filters$approvalDate2 !== void 0 ? _filters$approvalDate2 : "", "\"\n        accidentDateFrom: \"").concat((_filters$accidentDate = filters === null || filters === void 0 ? void 0 : filters.accidentDateFrom) !== null && _filters$accidentDate !== void 0 ? _filters$accidentDate : "", "\"\n        accidentDateTo: \"").concat((_filters$accidentDate2 = filters === null || filters === void 0 ? void 0 : filters.accidentDateTo) !== null && _filters$accidentDate2 !== void 0 ? _filters$accidentDate2 : "", "\"\n        month: \"").concat((_filters$month = filters === null || filters === void 0 ? void 0 : filters.month) !== null && _filters$month !== void 0 ? _filters$month : "", "\"\n        year: \"").concat((_filters$year = filters === null || filters === void 0 ? void 0 : filters.year) !== null && _filters$year !== void 0 ? _filters$year : "", "\"\n        notInStage: \"").concat((_filters$notInStage = filters === null || filters === void 0 ? void 0 : filters.notInStage) !== null && _filters$notInStage !== void 0 ? _filters$notInStage : "", "\"\n      ) {\n        id\n        monthIndex\n        year\n        eisMonthlyAmount\n        eisInitialMonthlyAmount\n        eisPaymentType\n        eisApprovedAmount\n        eisCalculatedAmount\n        eisInitialReplacementRate\n        incrementAmount\n        decrementAmount\n        incrementDate\n        decrementDate\n        decrementEndDate\n        totalAdjustmentAmount\n        processingDate\n        beneficiaryId\n        beneficiaryStatus\n        remarriageOrDeathDate\n        reason\n        remarks\n        lastLiveCheckDate\n        liveCheckRemarks\n        isDisbursed\n        isEligible\n        approved\n        paymentTypeRemarks\n        onetimeAmount\n        trimonthlyAmount\n        payableAmount\n        phoneNumber\n        arrearAmount\n        arrearPaymentMonth\n        arrearPaymentYear\n        noaSmsSent\n        noaConfirmed\n        noaBlocked\n        routingNumber\n        bank {\n          id\n          nameEn\n          nameBn\n          districtNameEn\n          districtNameBn\n          districtCode\n          bankCode\n          branchCode\n          routingNumber\n          parent\n          {\n            id\n            bankCode\n            districtCode\n            districtNameEn\n            districtNameBn\n            nameEn\n            nameBn\n          }\n        }\n        bankAccountNo\n        bankAccountHolderName\n        workforceEmployeeDependent{\n          id\n          status\n          nameEn\n          nameBn\n          relationWithWorker\n          disabilityStatus\n          birthDate\n          maritalStatus\n          nid\n          permanentAddress\n          presentAddress\n          ").concat(present_location_projection + permanent_location_projection, "\n          bankAccountNo\n          bank{\n            nameBn\n            districtNameBn\n            districtNameEn\n            bankCode\n            routingNumber\n            parent{\n              nameBn\n              districtNameEn\n              districtNameBn\n            }\n          }\n        }\n        workforceApplication {\n          id\n          lastBaseSalary\n          associationType\n          applicationType\n          organizationType\n          employeeAccidentInfo\n          deceasedWorkerInfo\n          employeeBankInfo\n          doctorsEntry\n          dateCreated\n          trackingNumber\n          status\n          eisApprovalIds\n          eisApprovedByIds\n          workforceDocumentApplication {\n            edges {\n              node {\n                id\n                documentType\n                workforceDependent {id}\n                workforceEmployeeBankingInfo {id}\n              }\n            }\n          }\n          workforceEmployee {         \n            id\n            firstNameBn\n            firstNameEn\n            nid\n            permanentAddress\n            presentAddress\n            ").concat(present_location_projection + permanent_location_projection, "\n\n          }\n          employeeFactory {\n            id\n            nameEn\n            nameBn\n            allAssociation{\n              id\n              nameEn\n              nameBn\n              shortNameBn\n              shortNameEn\n            }\n          }\n        }\n      }\n    }\n  ");
  return graphql(payload, "EIS_PAYMENT_PROCESS");
}
function fetchEisPaymentProcessWithoutFilters(filters, mm) {
  var _filters$processId2, _filters$workforceApp3, _filters$workforceApp4, _filters$workforceFac2, _filters$allAssociati2, _filters$beneficiaryI2, _filters$status2, _filters$beneficiaryS2, _filters$approved2, _filters$approvalDate3, _filters$approvalDate4, _filters$accidentDate3, _filters$accidentDate4, _filters$month2, _filters$year2, _filters$notInStage2;
  "presentLocation" + mm.getProjection("location.Location.FlatProjection");
  "permanentLocation" + mm.getProjection("location.Location.FlatProjection");
  var payload = "\n    {\n      workforceEisPaymentProcess(\n        processId: \"".concat((_filters$processId2 = filters === null || filters === void 0 ? void 0 : filters.processId) !== null && _filters$processId2 !== void 0 ? _filters$processId2 : "", "\"\n        workforceApplicationId: \"").concat((_filters$workforceApp3 = filters === null || filters === void 0 ? void 0 : filters.workforceApplicationId) !== null && _filters$workforceApp3 !== void 0 ? _filters$workforceApp3 : "", "\"\n        workforceApplicationTrackingNumber: \"").concat((_filters$workforceApp4 = filters === null || filters === void 0 ? void 0 : filters.workforceApplicationTrackingNumber) !== null && _filters$workforceApp4 !== void 0 ? _filters$workforceApp4 : "", "\"\n        workforceFactoryId: \"").concat((_filters$workforceFac2 = filters === null || filters === void 0 ? void 0 : filters.workforceFactoryId) !== null && _filters$workforceFac2 !== void 0 ? _filters$workforceFac2 : "", "\"\n        allAssociationId: \"").concat((_filters$allAssociati2 = filters === null || filters === void 0 ? void 0 : filters.allAssociationId) !== null && _filters$allAssociati2 !== void 0 ? _filters$allAssociati2 : "", "\"\n        beneficiaryId: \"").concat((_filters$beneficiaryI2 = filters === null || filters === void 0 ? void 0 : filters.beneficiaryId) !== null && _filters$beneficiaryI2 !== void 0 ? _filters$beneficiaryI2 : "", "\"\n        status: \"").concat((_filters$status2 = filters === null || filters === void 0 ? void 0 : filters.status) !== null && _filters$status2 !== void 0 ? _filters$status2 : "", "\"\n        beneficiaryStatus: \"").concat((_filters$beneficiaryS2 = filters === null || filters === void 0 ? void 0 : filters.beneficiaryStatus) !== null && _filters$beneficiaryS2 !== void 0 ? _filters$beneficiaryS2 : "", "\"\n        approved: \"").concat((_filters$approved2 = filters === null || filters === void 0 ? void 0 : filters.approved) !== null && _filters$approved2 !== void 0 ? _filters$approved2 : "", "\"\n        approvalDateFrom: \"").concat((_filters$approvalDate3 = filters === null || filters === void 0 ? void 0 : filters.approvalDateFrom) !== null && _filters$approvalDate3 !== void 0 ? _filters$approvalDate3 : "", "\"\n        approvalDateTo: \"").concat((_filters$approvalDate4 = filters === null || filters === void 0 ? void 0 : filters.approvalDateTo) !== null && _filters$approvalDate4 !== void 0 ? _filters$approvalDate4 : "", "\"\n        accidentDateFrom: \"").concat((_filters$accidentDate3 = filters === null || filters === void 0 ? void 0 : filters.accidentDateFrom) !== null && _filters$accidentDate3 !== void 0 ? _filters$accidentDate3 : "", "\"\n        accidentDateTo: \"").concat((_filters$accidentDate4 = filters === null || filters === void 0 ? void 0 : filters.accidentDateTo) !== null && _filters$accidentDate4 !== void 0 ? _filters$accidentDate4 : "", "\"\n        month: \"").concat((_filters$month2 = filters === null || filters === void 0 ? void 0 : filters.month) !== null && _filters$month2 !== void 0 ? _filters$month2 : "", "\"\n        year: \"").concat((_filters$year2 = filters === null || filters === void 0 ? void 0 : filters.year) !== null && _filters$year2 !== void 0 ? _filters$year2 : "", "\"\n        notInStage: \"").concat((_filters$notInStage2 = filters === null || filters === void 0 ? void 0 : filters.notInStage) !== null && _filters$notInStage2 !== void 0 ? _filters$notInStage2 : "", "\"\n      ) {\n          id\n          beneficiaryId\n          beneficiaryStatus\n          payableAmount\n          incrementAmount\n          incrementDate\n          decrementAmount\n          decrementDate\n          eisApprovedAmount\n          eisPaymentType\n          routingNumber\n          bankAccountNo\n          remarks\n          bank {\n            nameEn\n            routingNumber\n            parent {\n              nameEn\n            }\n          }\n          workforceEmployeeDependent {\n            nameEn\n            nameBn\n            birthDate\n            relationWithWorker\n            maritalStatus\n            disabilityStatus\n          }\n          workforceApplication {\n            trackingNumber\n            applicationType\n            deceasedWorkerInfo\n            workforceEmployee {\n              firstNameEn\n            }\n            employeeFactory {\n              nameEn\n              allAssociation {\n                shortNameEn\n                nameEn\n              }\n            }\n          }\n        }\n    }\n  ");
  return graphql(payload, "EIS_PAYMENT_PROCESS");
}
function updateWorkforceEisBeneficiary(beneficiary) {
  var _beneficiary$benefici, _beneficiary$incremen, _beneficiary$incremen2, _beneficiary$decremen, _beneficiary$decremen2, _beneficiary$benefici2, _beneficiary$reason, _beneficiary$remarks, _beneficiary$remarria, _beneficiary$remarria2, _beneficiary$remarks2;
  var mutation = "\n    mutation {\n      updateWorkforceEisBeneficiary(\n        beneficiaryId: \"".concat((_beneficiary$benefici = beneficiary === null || beneficiary === void 0 ? void 0 : beneficiary.beneficiaryId) !== null && _beneficiary$benefici !== void 0 ? _beneficiary$benefici : "", "\"\n        incrementAmount: \"").concat((_beneficiary$incremen = beneficiary === null || beneficiary === void 0 ? void 0 : beneficiary.incrementAmount) !== null && _beneficiary$incremen !== void 0 ? _beneficiary$incremen : "", "\"\n        incrementDate: \"").concat((_beneficiary$incremen2 = beneficiary === null || beneficiary === void 0 ? void 0 : beneficiary.incrementDate) !== null && _beneficiary$incremen2 !== void 0 ? _beneficiary$incremen2 : "", "\"\n        decrementAmount: \"").concat((_beneficiary$decremen = beneficiary === null || beneficiary === void 0 ? void 0 : beneficiary.decrementAmount) !== null && _beneficiary$decremen !== void 0 ? _beneficiary$decremen : "", "\"\n        decrementDate: \"").concat((_beneficiary$decremen2 = beneficiary === null || beneficiary === void 0 ? void 0 : beneficiary.decrementDate) !== null && _beneficiary$decremen2 !== void 0 ? _beneficiary$decremen2 : "", "\"\n        beneficiaryStatus: \"").concat((_beneficiary$benefici2 = beneficiary === null || beneficiary === void 0 ? void 0 : beneficiary.beneficiaryStatus) !== null && _beneficiary$benefici2 !== void 0 ? _beneficiary$benefici2 : "", "\"\n        reason: \"").concat((_beneficiary$reason = beneficiary === null || beneficiary === void 0 ? void 0 : beneficiary.reason) !== null && _beneficiary$reason !== void 0 ? _beneficiary$reason : "", "\"\n        remarks: \"").concat((_beneficiary$remarks = beneficiary === null || beneficiary === void 0 ? void 0 : beneficiary.remarks) !== null && _beneficiary$remarks !== void 0 ? _beneficiary$remarks : "", "\"\n        remarriageOrDeathDate: \"").concat((_beneficiary$remarria = beneficiary === null || beneficiary === void 0 ? void 0 : beneficiary.remarriageOrDeathDate) !== null && _beneficiary$remarria !== void 0 ? _beneficiary$remarria : "", "\"\n        lastLiveCheckDate: \"").concat((_beneficiary$remarria2 = beneficiary === null || beneficiary === void 0 ? void 0 : beneficiary.remarriageOrDeathDate) !== null && _beneficiary$remarria2 !== void 0 ? _beneficiary$remarria2 : "", "\"\n        liveCheckRemarks: \"").concat((_beneficiary$remarks2 = beneficiary === null || beneficiary === void 0 ? void 0 : beneficiary.remarks) !== null && _beneficiary$remarks2 !== void 0 ? _beneficiary$remarks2 : "", "\"\n        otherBeneficiaryData: ").concat(beneficiary !== null && beneficiary !== void 0 && beneficiary.otherBeneficiaryData ? escapeQuotes(beneficiary === null || beneficiary === void 0 ? void 0 : beneficiary.otherBeneficiaryData) : "", "\n      ) {\n        success\n        errors\n      }\n    }\n  ");
  return graphql(mutation, "UPDATE_WORKFORCE_EIS_BENEFICIARY");
}
function createWorkforceEisPaymentStage(ids, month, year) {
  var idsString = ids.map(function (id) {
    return "\"".concat(id, "\"");
  }).join(",");
  var mutation = "\n    mutation {\n      createWorkforceEisPaymentStage(\n        workforceEisPaymentProcessIdIn: [".concat(idsString, "]\n        month: \"").concat(month, "\"\n        year: \"").concat(year, "\"\n      ) {\n        success\n        errors\n      }\n    }\n  ");
  return graphql(mutation, "CREATE_WORKFORCE_EIS_PAYMENT_STAGE");
}
function deleteWorkforceEisPaymentStage(ids) {
  var idsString = ids.map(function (id) {
    return "\"".concat(id, "\"");
  }).join(",");
  var mutation = "\n    mutation {\n      deleteWorkforceEisPaymentStage(\n        workforceEisPaymentStageIdIn: [".concat(idsString, "]\n      ) {\n        success\n        errors\n      }\n    }\n  ");
  return graphql(mutation, "CREATE_WORKFORCE_EIS_PAYMENT_STAGE");
}
function fetchWorkforceEisPaymentDisbursementStage(filters, mm) {
  var _filters$month4, _filters$year4, _filters$isDisbursed, _filters$notInDisburs, _filters$workforceFac4, _filters$allAssociati4, _filters$workforceEis;
  var present_location_projection = "presentLocation" + mm.getProjection("location.Location.FlatProjection");
  var permanent_location_projection = "permanentLocation" + mm.getProjection("location.Location.FlatProjection");
  var payload = "\n    {\n      workforceEisPaymentDisbursementStage(\n        month: \"".concat((_filters$month4 = filters === null || filters === void 0 ? void 0 : filters.month) !== null && _filters$month4 !== void 0 ? _filters$month4 : "", "\"\n        year: \"").concat((_filters$year4 = filters === null || filters === void 0 ? void 0 : filters.year) !== null && _filters$year4 !== void 0 ? _filters$year4 : "", "\"\n        isDisbursed: \"").concat((_filters$isDisbursed = filters === null || filters === void 0 ? void 0 : filters.isDisbursed) !== null && _filters$isDisbursed !== void 0 ? _filters$isDisbursed : "", "\"\n        notInDisburse: \"").concat((_filters$notInDisburs = filters === null || filters === void 0 ? void 0 : filters.notInDisburse) !== null && _filters$notInDisburs !== void 0 ? _filters$notInDisburs : "", "\"\n        workforceFactoryId: \"").concat((_filters$workforceFac4 = filters === null || filters === void 0 ? void 0 : filters.workforceFactoryId) !== null && _filters$workforceFac4 !== void 0 ? _filters$workforceFac4 : "", "\"\n        allAssociationId: \"").concat((_filters$allAssociati4 = filters === null || filters === void 0 ? void 0 : filters.allAssociationId) !== null && _filters$allAssociati4 !== void 0 ? _filters$allAssociati4 : "", "\"\n        workforceEisBankAdviceId: \"").concat((_filters$workforceEis = filters === null || filters === void 0 ? void 0 : filters.workforceEisBankAdviceId) !== null && _filters$workforceEis !== void 0 ? _filters$workforceEis : "", "\"\n      ) {\n        id\n        monthIndex\n        year\n        eisMonthlyAmount\n        paidAmount\n        eisInitialMonthlyAmount\n        eisPaymentType\n        eisApprovedAmount\n        eisCalculatedAmount\n        eisInitialReplacementRate\n        incrementAmount\n        decrementAmount\n        totalAdjustmentAmount\n        processingDate\n        disbursementDate\n        beneficiaryId\n        isDisbursed\n        phoneNumber\n        userConfirmed\n        routingNumber\n        payFromDate\n        payToDate\n        installmentNumber\n        workforceEisBankAdvice{\n        id\n        isConfirmed\n        confirmationDate\n        }\n        bank {\n          id\n          nameEn\n          nameBn\n          districtNameEn\n          districtNameBn\n          bankCode\n          branchCode\n          routingNumber\n          parent\n          {\n            nameEn\n            nameBn\n          }\n        }\n        bankAccountNo\n        bankAccountHolderName\n        workforceEmployeeDependent{\n          status\n          nameEn\n          nameBn\n          relationWithWorker\n          disabilityStatus\n          birthDate\n          maritalStatus\n          nid\n          permanentAddress\n          presentAddress\n          ").concat(present_location_projection + permanent_location_projection, "\n          bankAccountNo\n          bank{\n            nameBn\n            districtNameBn\n            bankCode\n            routingNumber\n            parent{\n              nameBn\n            }\n          }\n        }\n        workforceApplication {\n          id\n          lastBaseSalary\n          associationType\n          applicationType\n          organizationType\n          employeeAccidentInfo\n          deceasedWorkerInfo\n          employeeBankInfo\n          doctorsEntry\n          dateCreated\n          trackingNumber\n          committeeId\n          eisApprovalIds\n          eisApprovedByIds\n          workforceEmployee {         \n            id\n            firstNameBn\n            firstNameEn\n            nid\n            permanentAddress\n            presentAddress\n            ").concat(present_location_projection + permanent_location_projection, "\n\n          }\n          employeeFactory {\n            id\n            nameEn\n            nameBn\n            allAssociation{\n              id\n              nameEn\n              nameBn\n              shortNameBn\n              shortNameEn\n            }\n          }\n        }\n      }\n    }\n  ");
  return graphql(payload, "EIS_PAYMENT_PROCESS");
}
function createWorkforceEisPaymentDisbursement(ids) {
  var idsString = ids.map(function (id) {
    return "\"".concat(id, "\"");
  }).join(",");
  var mutation = "\n    mutation {\n      createWorkforceEisPaymentDisbursement(\n        workforceEisPaymentStageIdIn: [".concat(idsString, "]\n      ) {\n        success\n        errors\n      }\n    }\n  ");
  return graphql(mutation, "CREATE_WORKFORCE_EIS_PAYMENT_DISBURSEMENT");
}
function fetchApplicationFactoryAssociation(id) {
  var payload = "\n    {\n      workforceApplication(id: \"".concat(id, "\"){\n        edges{\n          node{\n            id\n            employeeFactory{\n              id\n              allAssociation\n              {\n                id\n                shortNameBn\n                shortNameEn\n              }\n            }\n          }\n        }\n      }\n    }\n  ");
  return graphql(payload, "WORKFORCE_APPLICATION_FACTORY_ASSOCIATION");
}
function updateWorkforceEisPaymentByAssociation(payload) {
  var _payload$associationI, _payload$increment, _payload$decrement, _payload$incrementDat, _payload$decrementDat;
  var paymentProcessIds = payload.selectedIds.map(function (id) {
    return "\"".concat(id, "\"");
  }).join(",");
  var mutation = "\n    mutation {\n      updateWorkforceEisPaymentByAssociation(\n        associationId: \"".concat((_payload$associationI = payload === null || payload === void 0 ? void 0 : payload.associationId) !== null && _payload$associationI !== void 0 ? _payload$associationI : "", "\"\n        paymentProcessIds: [").concat(paymentProcessIds, "]\n        increment: \"").concat((_payload$increment = payload === null || payload === void 0 ? void 0 : payload.increment) !== null && _payload$increment !== void 0 ? _payload$increment : "", "\"\n        decrement: \"").concat((_payload$decrement = payload === null || payload === void 0 ? void 0 : payload.decrement) !== null && _payload$decrement !== void 0 ? _payload$decrement : "", "\"\n        incrementDate: \"").concat((_payload$incrementDat = payload === null || payload === void 0 ? void 0 : payload.incrementDate) !== null && _payload$incrementDat !== void 0 ? _payload$incrementDat : "", "\"\n        decrementDate: \"").concat((_payload$decrementDat = payload === null || payload === void 0 ? void 0 : payload.decrementDate) !== null && _payload$decrementDat !== void 0 ? _payload$decrementDat : "", "\"\n      ) {\n        success\n        errors\n      }\n    }\n  ");
  return graphql(mutation, "UPDATE_WORKFORCE_EIS_PAYMENT_BY_ASSOCIATION");
}
function fetchWorkforceAssociationUserMaps(filters) {
  var projections = ["id", "allAssociation {id,nameEn,nameBn, shortNameEn, shortNameBn}", "user {id,loginName}"];
  var payload = formatPageQueryWithCount("workforceAssociationUserMap", filters, projections);
  return graphql(payload, "WORKFORCE_ASSOCIATION_USER_MAPS");
}
function fetchUsersByRoleId(roleIdsArray) {
  var roleIds = roleIdsArray.map(function (id) {
    return "\"".concat(id, "\"");
  }).join(",");
  var payload = "query\n      {\n        workforceUserRole(roleIdIn:[".concat(roleIds, "]) {\n        userId\n        }\n      }");
  return graphql(payload, "WORKFORCE_USERS_BY_ROLE_ID");
}
function createWorkforceAssociationUserMap(map, clientMutationLabel) {
  var mutation = formatMutation("createWorkforceAssociationUserMap", formatWorkforceAssociationUserMapGQL(map), clientMutationLabel);
  var requestedDateTime = new Date();
  return graphql(mutation.payload, ["WORKFORCE_ASSOCIATION_USER_MAP_REQ", "WORKFORCE_ASSOCIATION_USER_MAP_RESP", "WORKFORCE_ASSOCIATION_USER_MAP_ERR"], {
    clientMutationId: mutation.clientMutationId,
    clientMutationLabel: clientMutationLabel,
    requestedDateTime: requestedDateTime
  });
}
function deleteWorkforceAssociationUserMap(payload) {
  var _payload$id;
  var mutation = "\n    mutation {\n      deleteWorkforceAssociationUserMap(\n        mapId: \"".concat((_payload$id = payload === null || payload === void 0 ? void 0 : payload.id) !== null && _payload$id !== void 0 ? _payload$id : "", "\"\n      ) {\n        success\n        errors\n      }\n    }\n  ");
  return graphql(mutation, "DELETE_WORKFORCE_ASSOCIATION_USER_MAP");
}
function fetchWorkforceInteractiveUsers(filters) {
  var _filters$loginName;
  var payload = "\n  query{\n  workforceInteractiveUsers(\n    loginName: \"".concat((_filters$loginName = filters === null || filters === void 0 ? void 0 : filters.loginName) !== null && _filters$loginName !== void 0 ? _filters$loginName : "", "\"\n  ){\n        id\n        loginName\n        lastName\n        otherNames\n      }\n    }\n  ");
  return graphql(payload, "WORKFORCE_INTERACTIVE_USERS");
}
function createWorkforceEisBankAdvice(stageIds, month, year) {
  var idsString = stageIds.map(function (id) {
    return "\"".concat(id, "\"");
  }).join(",");
  var mutation = "\n    mutation {\n      createWorkforceEisBankAdvice(\n        paymentDisbursementStageIds: [".concat(idsString, "]\n        month: \"").concat(month, "\"\n        year: \"").concat(year, "\"\n      ) {\n        success\n        errors\n      }\n    }\n  ");
  return graphql(mutation, "CREATE_WORKFORCE_EIS_BANK_ADVICE");
}
function updateWorkforceEisBankAdvice(advice_id) {
  var mutation = "\n    mutation {\n      updateWorkforceEisBankAdvice(\n        id: \"".concat(advice_id, "\"\n      ) {\n        success\n        errors\n      }\n    }\n  ");
  return graphql(mutation, "UPDATE_WORKFORCE_EIS_BANK_ADVICE");
}
function fetchWorkforceEisBankAdvice(filters) {
  var _filters$month5, _filters$year5;
  var isConfirmString = filters.isConfirmed !== null ? "isConfirmed:" + filters.isConfirmed : "";
  var payload = "\n    {\n      workforceEisBankAdvice(\n        month: \"".concat((_filters$month5 = filters === null || filters === void 0 ? void 0 : filters.month) !== null && _filters$month5 !== void 0 ? _filters$month5 : "", "\"\n        year: \"").concat((_filters$year5 = filters === null || filters === void 0 ? void 0 : filters.year) !== null && _filters$year5 !== void 0 ? _filters$year5 : "", "\"\n        ") + isConfirmString + "\n      ) {\n        id\n        adviceDate\n        isConfirmed\n        remarks\n        month\n        year\n      }\n    }\n  ";
  return graphql(payload, "WORKFORCE_EIS_BANK_ADVICE");
}
function updateWorkforceEisBeneficiaryBank(beneficiary) {
  var _beneficiary$benefici3, _beneficiary$branch, _beneficiary$branch2, _beneficiary$bankAcco, _beneficiary$bankAcco2, _beneficiary$phoneNum;
  var mutation = "\n    mutation {\n      updateWorkforceEisBeneficiaryBank(\n        beneficiaryId: \"".concat((_beneficiary$benefici3 = beneficiary === null || beneficiary === void 0 ? void 0 : beneficiary.beneficiaryId) !== null && _beneficiary$benefici3 !== void 0 ? _beneficiary$benefici3 : "", "\"\n        bankId: \"").concat(beneficiary !== null && beneficiary !== void 0 && (_beneficiary$branch = beneficiary.branch) !== null && _beneficiary$branch !== void 0 && _beneficiary$branch.id ? safeDecodeId(beneficiary === null || beneficiary === void 0 || (_beneficiary$branch2 = beneficiary.branch) === null || _beneficiary$branch2 === void 0 ? void 0 : _beneficiary$branch2.id) : "", "\"\n        bankAccountHolderName: \"").concat((_beneficiary$bankAcco = beneficiary === null || beneficiary === void 0 ? void 0 : beneficiary.bankAccountHolderName) !== null && _beneficiary$bankAcco !== void 0 ? _beneficiary$bankAcco : "", "\"\n        bankAccountNo: \"").concat((_beneficiary$bankAcco2 = beneficiary === null || beneficiary === void 0 ? void 0 : beneficiary.bankAccountNo) !== null && _beneficiary$bankAcco2 !== void 0 ? _beneficiary$bankAcco2 : "", "\"\n        phoneNumber: \"").concat((_beneficiary$phoneNum = beneficiary === null || beneficiary === void 0 ? void 0 : beneficiary.phoneNumber) !== null && _beneficiary$phoneNum !== void 0 ? _beneficiary$phoneNum : "", "\"\n      ) {\n        success\n        errors\n      }\n    }\n  ");
  return graphql(mutation, "UPDATE_WORKFORCE_EIS_BENEFICIARY");
}
function createWorkforceCommittee(payload, clientMutationLabel) {
  var mutation = formatMutation("createWorkforceCommittee", formatWorkforceCommitteeGQL(payload), clientMutationLabel);
  var requestedDateTime = new Date();
  return graphql(mutation.payload, ["WORKFORCE_COMMITTEES_REQ", "WORKFORCE_COMMITTEES_RESP", "WORKFORCE_COMMITTEES_ERR"], {
    clientMutationId: mutation.clientMutationId,
    clientMutationLabel: clientMutationLabel,
    requestedDateTime: requestedDateTime
  });
}
function updateWorkforceCommittee(payload, clientMutationLabel) {
  var mutation = formatMutation("updateWorkforceCommittee", formatWorkforceCommitteeGQL(payload), clientMutationLabel);
  var requestedDateTime = new Date();
  return graphql(mutation.payload, ["WORKFORCE_COMMITTEES_REQ", "WORKFORCE_COMMITTEES_RESP", "WORKFORCE_COMMITTEES_ERR"], {
    clientMutationId: mutation.clientMutationId,
    clientMutationLabel: clientMutationLabel,
    requestedDateTime: requestedDateTime
  });
}
function fetchWorkforceCommittees() {
  var filters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var filterString = "";
  if (filters !== null && Object.keys(filters).length > 0) {
    filterString += "(";
    if (filters !== null && filters !== void 0 && filters.committeeId) {
      filterString += "id: \"".concat(filters.committeeId, "\", ");
    }
    if (filters !== null && filters !== void 0 && filters.organizationType) {
      filterString += "organizationType: \"".concat(filters.organizationType, "\", ");
    }
    filterString += ")";
  }
  var payload = "\n    {\n      workforceCommittees ".concat(filterString, " {\n        id\n        nameEn\n        nameBn\n        approvalType\n        organizationType\n        assignedRole{\n        id\n        name\n        }\n        }\n    }\n    ");
  return graphql(payload, "WORKFORCE_COMMITTEES");
}
function createWorkforceCommitteeUserMap(payload, clientMutationLabel) {
  var mutation = formatMutation("createWorkforceCommitteeUserMap", formatWorkforceCommitteeUserMapGQL(payload), clientMutationLabel);
  var requestedDateTime = new Date();
  return graphql(mutation.payload, ["WORKFORCE_COMMITTEE_USER_MAP_REQ", "WORKFORCE_COMMITTEE_USER_MAP_RESP", "WORKFORCE_COMMITTEE_USER_MAP_ERR"], {
    clientMutationId: mutation.clientMutationId,
    clientMutationLabel: clientMutationLabel,
    requestedDateTime: requestedDateTime
  });
}
function updateWorkforceCommitteeUserMap(payload, clientMutationLabel) {
  var mutation = formatMutation("updateWorkforceCommitteeUserMap", formatWorkforceCommitteeUserMapGQL(payload), clientMutationLabel);
  var requestedDateTime = new Date();
  return graphql(mutation.payload, ["WORKFORCE_COMMITTEE_USER_MAP_REQ", "WORKFORCE_COMMITTEE_USER_MAP_RESP", "WORKFORCE_COMMITTEE_USER_MAP_ERR"], {
    clientMutationId: mutation.clientMutationId,
    clientMutationLabel: clientMutationLabel,
    requestedDateTime: requestedDateTime
  });
}
function fetchWorkforceCommitteeUserMap(filters) {
  var _filters$committeeId;
  var userIds = Array.isArray(filters === null || filters === void 0 ? void 0 : filters.userIds) ? filters.userIds.map(function (id) {
    return "\"".concat(id, "\"");
  }).join(",") : "";
  var payload = "\n    {\n      workforceCommitteeUserMaps(\n        committeeId: \"".concat((_filters$committeeId = filters === null || filters === void 0 ? void 0 : filters.committeeId) !== null && _filters$committeeId !== void 0 ? _filters$committeeId : "", "\"\n        userIdIn: [").concat(userIds, "]\n      ){\n        id\n        committee{\n          id\n          nameEn\n          nameBn\n          approvalType\n          organizationType\n          }\n        user{\n          id\n          loginName\n          lastName\n          otherNames\n          phone\n          }\n        isNoaSignatureUser\n        roleInCommittee\n        isRepresentative\n        workforceCommitteeUser{\n            representativeName\n            representativeNameBn\n            organizationName\n            designation\n            representativeType\n            phoneNumber\n            email\n            officeAddress\n            currentAddress\n            }\n        }\n    }\n    ");
  return graphql(payload, "WORKFORCE_COMMITTEE_USER_MAPS");
}
function updateWorkforceCommitteeUserMapNoaSignature(committeeId, mapId, isNoaSignatureUser) {
  var mutation = "\n  mutation {\n      updateWorkforceCommitteeUserMapNoaSignature(\n        committeeId: \"".concat(committeeId, "\"\n        mapId: \"").concat(mapId, "\"\n        isNoaSignatureUser: ").concat(isNoaSignatureUser, "\n      ) {\n        success\n        errors\n      }\n      }\n  ");
  return graphql(mutation, "UPDATE_WORKFORCE_COMMITTEE_USER_MAP_NOA_SIGNATURE");
}
function deleteWorkforceCommitteeUserMap(mappingId) {
  var mutation = "\n    mutation {\n      deleteWorkforceCommitteeUserMap(\n        id: \"".concat(mappingId, "\"\n      ) {\n        success\n        errors\n      }\n    }\n  ");
  return graphql(mutation, "DELETE_WORKFORCE_COMMITTEE_USER_MAP");
}
function deleteWorkforceCommittee(committeeId) {
  var mutation = "\n    mutation {\n      deleteWorkforceCommittee(\n        id: \"".concat(committeeId, "\"\n      ) {\n        success\n        errors\n      }\n    }\n  ");
  return graphql(mutation, "DELETE_WORKFORCE_COMMITTEE");
}
function fetchRoles(loggedInUserId) {
  var mutation = "\n  {\n  fetchUserRoleByUserId(userId:\"".concat(loggedInUserId, "\"){\n    userId\n    roleId\n    }\n  }");
  return graphql(mutation, "WORKFORCE_USER_ROLES");
}
function createWorkforceCommitteeUser(payload, clientMutationLabel) {
  var mutation = formatMutation("createWorkforceCommitteeUser", formatWorkforceCommitteeUserGQL(payload), clientMutationLabel);
  var requestedDateTime = new Date();
  return graphql(mutation.payload, ["WORKFORCE_COMMITTEE_USER_REQ", "WORKFORCE_COMMITTEE_USER_RESP", "WORKFORCE_COMMITTEE_USER_ERR"], {
    clientMutationId: mutation.clientMutationId,
    clientMutationLabel: clientMutationLabel,
    requestedDateTime: requestedDateTime
  });
}
function fetchWorkforceCommitteeUser(filters) {
  var payload = "\n    {\n      workforceCommitteeUsers{\n        loginName\n        representativeName\n        representativeNameBn\n        organizationName\n        designation\n        representativeType        \n        phoneNumber\n        email\n        officeAddress\n        currentAddress\n        relatedUser{\n          id\n          loginName\n          lastName\n          otherNames\n          phone\n        }\n      }\n    }\n    ";
  return graphql(payload, "WORKFORCE_COMMITTEE_USERS");
}
function fetchWorkforceNoaSignatureByApprovers(userIds) {
  var passUserIds = Array.isArray(userIds) ? userIds.map(function (id) {
    return "\"".concat(id, "\"");
  }).join(",") : "";
  var payload = "\n  {\n    fetchNoaSignatureByApprovers(\n      userIdIn: [".concat(passUserIds, "]\n    )\n      {\n        id\n        documentType\n        url\n      }\n  \n  }\n    ");
  return graphql(payload, "WORKFORCE_NOA_SIGNATURE_BY_APPROVERS");
}
function fetchWorkforceNoaSignerUserByApprovers(userIds) {
  var passUserIds = Array.isArray(userIds) ? userIds.map(function (id) {
    return "\"".concat(id, "\"");
  }).join(",") : "";
  var payload = "\n  {\n    fetchWorkforceNoaSignerUserByApprovers(\n      userIdIn: [".concat(passUserIds, "]\n    )\n      {\n        id\n        roleInCommittee\n        committee\n        {\n          id\n          nameEn\n          nameBn\n        }\n        workforceCommitteeUser{\n          id\n          representativeName\n          representativeNameBn\n          organizationName\n          designation\n          \n        }\n      }\n  \n  }\n    ");
  return graphql(payload, "WORKFORCE_NOA_SIGNATURE_BY_APPROVERS");
}
function fetchNotificationData(filters) {
  var projections = ["id", "isRead", "notification", "notificationBn", "dateCreated", "user{id, loginName}", "workforceApplication{id, trackingNumber}", "status"];
  var payload = formatPageQueryWithCount("workforceNotifications", filters, projections);
  return graphql(payload, "WORKFORCE_NOTIFICATION_DATA");
}
function updateNotification(payload, clientMutationLabel) {
  var mutation = formatMutation("updateWorkforceNotification", formatWorkforceNotificationGQL(payload), clientMutationLabel);
  var requestedDateTime = new Date();
  return graphql(mutation.payload, ["WORKFORCE_WORKFORCE_NOTIFICATION_REQ", "WORKFORCE_WORKFORCE_NOTIFICATION_RESP", "WORKFORCE_WORKFORCE_NOTIFICATION_ERR"], {
    clientMutationId: mutation.clientMutationId,
    clientMutationLabel: clientMutationLabel,
    requestedDateTime: requestedDateTime
  });
}
function fetchCommitteeBankAdviceMap(filters) {
  var projections = ["id", "adviceTemplate", "committee{id}"];
  var payload = formatPageQueryWithCount("workforceCommitteeBankAdviceMaps", filters, projections);
  return graphql(payload, "WORKFORCE_COMMITTEE_BANK_ADVICE");
}
function createWorkforceCommitteeBankAdviceMap(payload, clientMutationLabel) {
  var mutation = formatMutation("createWorkforceCommitteeBankAdviceMap", formatWorkforceCommitteeBankAdviceMapGQL(payload), clientMutationLabel);
  var requestedDateTime = new Date();
  return graphql(mutation.payload, ["WORKFORCE_COMMITTEE_BANK_ADVICE_MAP_REQ", "WORKFORCE_COMMITTEE_BANK_ADVICE_MAP_RESP", "WORKFORCE_COMMITTEE_BANK_ADVICE_MAP_ERR"], {
    clientMutationId: mutation.clientMutationId,
    clientMutationLabel: clientMutationLabel,
    requestedDateTime: requestedDateTime
  });
}
function createWebsiteLegalGuideline(payload, clientMutationLabel) {
  var mutation = formatMutation("createWebsiteLegalGuideline", formatWebsiteLegalGuidelineGQL(payload), clientMutationLabel);
  var requestedDateTime = new Date();
  return graphql(mutation.payload, ["WORKFORCE_WEBSITE_LEGAL_GUIDELINE_REQ", "WORKFORCE_WEBSITE_LEGAL_GUIDELINE_RESP", "WORKFORCE_WEBSITE_LEGAL_GUIDELINE_ERR"], {
    clientMutationId: mutation.clientMutationId,
    clientMutationLabel: clientMutationLabel,
    requestedDateTime: requestedDateTime
  });
}
function updateWebsiteLegalGuideline(payload, clientMutationLabel) {
  var mutation = formatMutation("updateWebsiteLegalGuideline", formatWebsiteLegalGuidelineGQL(payload), clientMutationLabel);
  var requestedDateTime = new Date();
  return graphql(mutation.payload, ["WORKFORCE_WEBSITE_LEGAL_GUIDELINE_REQ", "WORKFORCE_WEBSITE_LEGAL_GUIDELINE_RESP", "WORKFORCE_WEBSITE_LEGAL_GUIDELINE_ERR"], {
    clientMutationId: mutation.clientMutationId,
    clientMutationLabel: clientMutationLabel,
    requestedDateTime: requestedDateTime
  });
}
function fetchWebsiteLegalGuidelines(userIds) {
  var payload = "\n    {\n      websiteLegalGuidelines\n        {\n          id\n          description\n          documentPath\n          documentUrl\n        }\n    }\n      ";
  return graphql(payload, "WORKFORCE_WEBSITE_LEGAL_GUIDELINES");
}
function fetchWebsiteVisitorMessages() {
  var payload = "\n    {\n      websiteVisitorMessages\n        {\n          id\n          visitorName\n          visitorEmail\n          visitorNumber\n          visitorMessage\n          dateCreated\n        }\n    \n    }\n      ";
  return graphql(payload, "WORKFORCE_WEBSITE_VISITOR_MESSAGES");
}
function userPaymentConfirmation(disbursementId, isConfirmed) {
  var mutation = "\n    mutation {\n      userPaymentConfirmation(\n        workforceEisPaymentDisbursementStageId: \"".concat(disbursementId, "\"\n        confirmation: ").concat(isConfirmed, "\n      ) {\n        success\n        errors\n      }\n    }\n  ");
  return graphql(mutation, "USER_PAYMENT_CONFIRMATION");
}
function sendSmsNotification(phoneNumber, message) {
  var mutation = "\n  mutation {\n      sendSmsNotification(\n        phoneNumber: \"".concat(phoneNumber, "\"\n        message: \"").concat(message, "\"\n        ) {\n        success\n        errors\n      }\n      }\n  ");
  return graphql(mutation, "SEND_SMS_NOTIFICATION");
}
function confirmNoa(paymentProcessId) {
  var isSmsSent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var isConfirmed = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var mutation = "\n  mutation {\n      confirmNoa(\n        workforceEisPaymentProcessId: \"".concat(paymentProcessId, "\"\n        confirmation: ").concat(isConfirmed, "\n        isSmsSent: ").concat(isSmsSent, "\n      ) {\n        success\n        errors\n        }\n    }\n  ");
  return graphql(mutation, "CONFIRM_NOA");
}
function blockNoa(paymentProcessId) {
  var isBlocked = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var mutation = "\n  mutation {\n      blockNoa(\n        workforceEisPaymentProcessId: \"".concat(paymentProcessId, "\"\n        isBlocked: ").concat(isBlocked, "\n      ) {\n        success\n        errors\n      }\n    }\n  ");
  return graphql(mutation, "BLOCK_NOA");
}
function fetchWorkforceBankManagement(filters) {
  var _filters$districtsOnl, _filters$banksOnly, _filters$bankId, _filters$districtCode;
  var payload = "\n    {\n      workforceBankManagement(\n        districtsOnly: ".concat((_filters$districtsOnl = filters === null || filters === void 0 ? void 0 : filters.districtsOnly) !== null && _filters$districtsOnl !== void 0 ? _filters$districtsOnl : false, "\n        banksOnly: ").concat((_filters$banksOnly = filters === null || filters === void 0 ? void 0 : filters.banksOnly) !== null && _filters$banksOnly !== void 0 ? _filters$banksOnly : false, "\n        bankId: \"").concat((_filters$bankId = filters === null || filters === void 0 ? void 0 : filters.bankId) !== null && _filters$bankId !== void 0 ? _filters$bankId : "", "\"\n        districtCode: \"").concat((_filters$districtCode = filters === null || filters === void 0 ? void 0 : filters.districtCode) !== null && _filters$districtCode !== void 0 ? _filters$districtCode : "", "\"\n      ) {\n          id\n          nameBn\n          nameEn\n          bankCode\n          branchCode\n          districtCode\n          districtNameEn\n          districtNameBn\n          routingNumber\n          parent{\n            id\n          }\n          contactNumber\n          type\n          status\n        }\n      }\n    ");
  return graphql(payload, ["WORKFORCE_BANK_MANAGEMENT_REQ", "WORKFORCE_BANK_MANAGEMENT_RESP", "WORKFORCE_BANK_MANAGEMENT_ERR"], {
    banksOnly: filters === null || filters === void 0 ? void 0 : filters.banksOnly,
    districtsOnly: filters === null || filters === void 0 ? void 0 : filters.districtsOnly
  });
}
function fetchPrevApplicationHistory(filters) {
  var queryParams = filters.join("\n");
  // const projections = [
  //   "id",
  //   "organizationType",
  //   "status",
  //   "dateCreated",
  //   // "user{id, loginName}",
  //   // "workforceApplication{id, trackingNumber}",
  //   "status"
  // ];
  var payload = "\n    {\n      workforceCheckApplicationDuplicacy(\n        ".concat(queryParams, "\n      ) {\n          id\n          organizationType\n          status\n          dateCreated\n        }\n      }\n    ");
  // const payload = formatPageQueryWithCount("workforceCheckApplicationDuplicacy", filters, projections);
  return graphql(payload, "WORKFORCE_NOTIFICATION_DATA");
}
function fetchWorkforceEisLastPaymentDate(filters) {
  var _filters$beneficiaryI4;
  var payload = "\n    {\n      workforceEisLastPaymentDate(\n        beneficiaryId: \"".concat((_filters$beneficiaryI4 = filters === null || filters === void 0 ? void 0 : filters.beneficiaryId) !== null && _filters$beneficiaryI4 !== void 0 ? _filters$beneficiaryI4 : "", "\"\n      ) {\n        id\n        monthIndex\n        year\n        eisMonthlyAmount\n        eisInitialMonthlyAmount\n        eisPaymentType\n        eisApprovedAmount\n        eisCalculatedAmount\n        eisInitialReplacementRate\n      }\n    }\n  ");
  return graphql(payload, "EIS_LAST_PAYMENT_DATE");
}
function markAllNotificationAsRead(userId) {
  var mutation = "\n  mutation {\n      markAllNotificationAsRead(\n        userId: \"".concat(userId, "\"\n      ) {\n        success\n        errors\n      }\n    }\n  ");
  return graphql(mutation, "MARK_ALL_NOTIFICATIONS_AS_READ");
}
function fetchWorkforceEisBeneficiaries(filters) {
  var _filters$beneficiaryI5;
  var payload = "\n    {\n      workforceEisBeneficiaries(\n        beneficiaryId: \"".concat((_filters$beneficiaryI5 = filters === null || filters === void 0 ? void 0 : filters.beneficiaryId) !== null && _filters$beneficiaryI5 !== void 0 ? _filters$beneficiaryI5 : "", "\"\n      ) {\n        id\n        beneficiaryId\n      }\n    }\n  ");
  return graphql(payload, "EIS_PAYMENT_PROCESS");
}
function fetchWorkforceEisBeneficiaryPayments(filters) {
  var _filters$month6, _filters$year6, _filters$beneficiaryI6;
  var payload = "\n    {\n      workforceEisBeneficiaryPayments(\n        monthIndex: \"".concat((_filters$month6 = filters === null || filters === void 0 ? void 0 : filters.month) !== null && _filters$month6 !== void 0 ? _filters$month6 : "", "\"\n        year: \"").concat((_filters$year6 = filters === null || filters === void 0 ? void 0 : filters.year) !== null && _filters$year6 !== void 0 ? _filters$year6 : "", "\"\n        beneficiaryId: \"").concat((_filters$beneficiaryI6 = filters === null || filters === void 0 ? void 0 : filters.beneficiaryId) !== null && _filters$beneficiaryI6 !== void 0 ? _filters$beneficiaryI6 : "", "\"\n      ) {\n        id\n        monthIndex\n        year\n        eisMonthlyAmount\n        paidAmount\n        eisInitialMonthlyAmount\n        eisPaymentType\n        eisApprovedAmount\n        eisCalculatedAmount\n        eisInitialReplacementRate\n        incrementAmount\n        decrementAmount\n        totalAdjustmentAmount\n        processingDate\n        disbursementDate\n        beneficiaryId\n        isDisbursed\n        phoneNumber\n        userConfirmed\n        routingNumber\n        payFromDate\n        payToDate\n        installmentNumber\n      }\n    }\n  ");
  return graphql(payload, "EIS_PAYMENT_PROCESS");
}

function _createForOfIteratorHelper$d(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray$d(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray$d(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray$d(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray$d(r, a) : void 0; } }
function _arrayLikeToArray$d(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys$26(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$26(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$26(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$26(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function isBase64Encoded(str) {
  // Base64 encoded strings can only contain characters from [A-Za-z0-9+/=]
  var base64RegExp = /^[A-Za-z0-9+/=]+$/;
  return base64RegExp.test(str);
}
function isEmptyObject(obj) {
  return Object.keys(obj).length === 0;
}
var safeApplicationId = function safeApplicationId(applicationId, parsedApplicationData) {
  var _applicationId$;
  console.log("applicationId", applicationId);
  console.log("parsedApplicationData", parsedApplicationData);
  if (applicationId && applicationId.length > 0 && (_applicationId$ = applicationId[0]) !== null && _applicationId$ !== void 0 && _applicationId$.id) {
    return decodeId(applicationId[0].id);
  } else if (parsedApplicationData && parsedApplicationData !== null && parsedApplicationData !== void 0 && parsedApplicationData.id) {
    return parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.id;
  } else {
    return null;
  }
};
function getUserType() {
  var reduxState = useSelector(function (state) {
    return state;
  });
  var user_rights = reduxState.core.user.i_user.rights;
  return getUserTypeFromRights(user_rights);
}
function getUserTypeFromRights(user_rights) {
  var user_type = WORKFORCE_USER_TYPE.APPLICANT;
  if (user_rights.length > 380) {
    user_type = WORKFORCE_USER_TYPE.ADMIN;
  } else {
    if (user_rights.includes(812001)) {
      console.log("checker er moddhe asi");
      user_type = WORKFORCE_USER_TYPE.CHECKER;
    } else if (user_rights.includes(819001)) {
      user_type = WORKFORCE_USER_TYPE.CHECKER_TWO;
    } else if (user_rights.includes(817001)) {
      user_type = WORKFORCE_USER_TYPE.SECTION_ADMIN;
    } else if (user_rights.includes(821002)) {
      user_type = WORKFORCE_USER_TYPE.SECTION_ADMIN_TWO;
    } else if (user_rights.includes(821003)) {
      user_type = WORKFORCE_USER_TYPE.SEC1_DEPUTI_ASST_DIRECTOR;
    } else if (user_rights.includes(821004)) {
      user_type = WORKFORCE_USER_TYPE.SEC2_DEPUTI_ASST_DIRECTOR;
    } else if (user_rights.includes(821005)) {
      user_type = WORKFORCE_USER_TYPE.BLWF_SECTION_ADMIN;
    } else if (user_rights.includes(821007)) {
      user_type = WORKFORCE_USER_TYPE.BLWF_DEPUTI_ASST_DIRECTOR;
    } else if (user_rights.includes(818001)) {
      user_type = WORKFORCE_USER_TYPE.DOCTOR;
    } else if (user_rights.includes(813001) && isCfPath()) {
      user_type = WORKFORCE_USER_TYPE.APPROVER;
    } else if (user_rights.includes(821006) && isBlwfPath()) {
      user_type = WORKFORCE_USER_TYPE.BLWF_APPROVER;
    } else if (user_rights.includes(814001)) {
      user_type = WORKFORCE_USER_TYPE.FACTORY_ADMIN;
    } else if (user_rights.includes(815001)) {
      user_type = WORKFORCE_USER_TYPE.DIRECTOR;
    } else if (user_rights.includes(812009)) {
      user_type = WORKFORCE_USER_TYPE.BLWF_DIRECTOR;
    } else if (user_rights.includes(816001)) {
      user_type = WORKFORCE_USER_TYPE.BGMEA_ASSOCIATION;
    } else if (user_rights.includes(821001)) {
      user_type = WORKFORCE_USER_TYPE.BKMEA_ASSOCIATION;
    } else if (user_rights.includes(812008)) {
      user_type = WORKFORCE_USER_TYPE.BLWF_CHECKER;
    } else if (user_rights.includes(813000)) {
      user_type = WORKFORCE_USER_TYPE.EIS_COORDINATOR;
    } else if (user_rights.includes(813002)) {
      user_type = WORKFORCE_USER_TYPE.EIS_OFFICER;
    } else if (user_rights.includes(813003)) {
      user_type = WORKFORCE_USER_TYPE.EIS_ADVISOR;
    } else if (user_rights.includes(813004)) {
      user_type = WORKFORCE_USER_TYPE.EIS_COMMITTEE;
    } else if (user_rights.includes(816000)) {
      user_type = WORKFORCE_USER_TYPE.EIS_ASSOCIATION_COMMITTEE;
    } else if (user_rights.includes(813005)) {
      user_type = WORKFORCE_USER_TYPE.BLWF_DOCTOR;
    } else if (user_rights.includes(813006)) {
      user_type = WORKFORCE_USER_TYPE.EIS_FINANCIAL_OFFICER;
    } else if (user_rights.includes(813007)) {
      user_type = WORKFORCE_USER_TYPE.EIS_DOCTOR;
    } else if (user_rights.includes(813008)) {
      user_type = WORKFORCE_USER_TYPE.BLWF_DOL_DIFE;
    } else if (user_rights.includes(813009)) {
      user_type = WORKFORCE_USER_TYPE.BEPZA_ASSOCIATION;
    } else if (user_rights.includes(814000)) {
      user_type = WORKFORCE_USER_TYPE.LFMEAB_ASSOCIATION;
    } else if (user_rights.includes(815000)) {
      user_type = WORKFORCE_USER_TYPE.SECRETARY;
    } else if (user_rights.includes(836001)) {
      user_type = WORKFORCE_USER_TYPE.ASSOCIATION;
    } else if (user_rights.includes(818000)) {
      user_type = WORKFORCE_USER_TYPE.MINISTER;
    } else if (user_rights.includes(819000)) {
      user_type = WORKFORCE_USER_TYPE.BLWF_ACCOUNTANT;
    } else if (!isEmptyObject(user_rights)) {
      user_type = WORKFORCE_USER_TYPE.ADMIN;
    }
  }
  return user_type;
}
var safeParse = function safeParse(str) {
  try {
    if (!str) return null;
    var once = JSON.parse(str); // first parse
    return typeof once === "string" ? JSON.parse(once) : once; // second parse if needed
  } catch (e) {
    console.warn("Parsing failed for:", str);
    return null;
  }
};
var tryParse$1 = function tryParse(value) {
  if (typeof value === "string") {
    try {
      var parsed = JSON.parse(value);
      if (_typeof(parsed) === "object" && parsed !== null) {
        return parsed;
      }
    } catch (_unused) {
      return value;
    }
  }
  return value;
};
var getParsedApplication = function getParsedApplication(modulesManager, filters) {
  console.log("hello from getParsedApplication", filters);
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch, getState) {
      var _rawData$workforceEmp2, state, rawData, workforceDependentInfo, dependentInfoWithId, parsedDependentInfo, parsedData;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return dispatch(fetchApplication(modulesManager, filters));
          case 3:
            // Get the current state after the fetch completes
            state = getState();
            rawData = state.workforce.application;
            if (rawData) {
              _context.next = 8;
              break;
            }
            console.warn("No application data found in Redux store");
            return _context.abrupt("return", null);
          case 8:
            console.log("Raw application data:", rawData);
            workforceDependentInfo = safeParse(rawData === null || rawData === void 0 ? void 0 : rawData.employeeDependentInfo);
            dependentInfoWithId = workforceDependentInfo === null || workforceDependentInfo === void 0 ? void 0 : workforceDependentInfo.map(function (dep, idx) {
              var _rawData$workforceEmp;
              var temp = _objectSpread$26(_objectSpread$26({}, dep), {}, {
                id: rawData === null || rawData === void 0 || (_rawData$workforceEmp = rawData.workforceEmployeeDependentApplication) === null || _rawData$workforceEmp === void 0 || (_rawData$workforceEmp = _rawData$workforceEmp[idx]) === null || _rawData$workforceEmp === void 0 ? void 0 : _rawData$workforceEmp.id
              });
              return temp;
            });
            parsedDependentInfo = Array.isArray(rawData === null || rawData === void 0 ? void 0 : rawData.workforceEmployeeDependentApplication) ? rawData === null || rawData === void 0 || (_rawData$workforceEmp2 = rawData.workforceEmployeeDependentApplication) === null || _rawData$workforceEmp2 === void 0 ? void 0 : _rawData$workforceEmp2.map(function (dep) {
              return _objectSpread$26(_objectSpread$26({}, dep), {}, {
                presentAddress: safeParse(dep === null || dep === void 0 ? void 0 : dep.presentAddress),
                permanentAddress: safeParse(dep === null || dep === void 0 ? void 0 : dep.permanentAddress)
              });
            }) : rawData === null || rawData === void 0 ? void 0 : rawData.workforceEmployeeDependentApplication; // Parse the JSON fields safely
            parsedData = _objectSpread$26(_objectSpread$26({}, rawData), {}, {
              employeeDependentInfo: dependentInfoWithId || [{}],
              workforceEmployeeDependentApplication: parsedDependentInfo || [{}],
              employeeBankInfo: safeParse(rawData === null || rawData === void 0 ? void 0 : rawData.employeeBankInfo) || [{}],
              employeeAccidentInfo: safeParse(rawData === null || rawData === void 0 ? void 0 : rawData.employeeAccidentInfo) || {},
              employeeChildrenInfo: safeParse(rawData === null || rawData === void 0 ? void 0 : rawData.employeeChildrenInfo) || {},
              metadata: safeParse(rawData === null || rawData === void 0 ? void 0 : rawData.metadata) || {},
              institutionInfo: safeParse(rawData === null || rawData === void 0 ? void 0 : rawData.institutionInfo) || {},
              deceasedWorkerInfo: safeParse(rawData === null || rawData === void 0 ? void 0 : rawData.deceasedWorkerInfo) || {},
              applicantInfo: safeParse(rawData === null || rawData === void 0 ? void 0 : rawData.applicantInfo) || {}
            });
            return _context.abrupt("return", parsedData);
          case 16:
            _context.prev = 16;
            _context.t0 = _context["catch"](0);
            console.error("Error in getParsedApplication:", _context.t0);
            throw _context.t0;
          case 20:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 16]]);
    }));
    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
};
var getParsedApplicationFromArray = function getParsedApplicationFromArray(applications) {
  var returnArray = [];
  if (!Array.isArray(applications)) return [];
  applications.forEach(function (rawData) {
    var parsedData = _objectSpread$26(_objectSpread$26({}, rawData), {}, {
      employeeDependentInfo: safeParse(rawData.employeeDependentInfo) || {},
      employeeBankInfo: safeParse(rawData.employeeBankInfo) || {},
      employeeAccidentInfo: safeParse(rawData.employeeAccidentInfo) || {},
      employeeChildrenInfo: safeParse(rawData.employeeChildrenInfo) || {},
      metadata: safeParse(rawData.metadata) || {}
    });
    returnArray.push(parsedData);
  });
  return returnArray;
};
var isEmpty$1 = function isEmpty(value) {
  if (typeof value == "undefined" || value == "" || value == null || value == 0) {
    return true;
  }
  return false;
};
var enToBn = function enToBn(input) {
  var _input;
  var numbers = {
    0: "০",
    1: "১",
    2: "২",
    3: "৩",
    4: "৪",
    5: "৫",
    6: "৬",
    7: "৭",
    8: "৮",
    9: "৯"
  };
  var output = "";
  if (typeof input == "number") {
    input = input.toString();
  }
  if (isEmpty$1((_input = input) === null || _input === void 0 ? void 0 : _input.length)) {
    return input;
  }
  for (var i = 0; i < ((_input2 = input) === null || _input2 === void 0 ? void 0 : _input2.length); ++i) {
    var _input2;
    if (numbers.hasOwnProperty(input[i])) {
      output += numbers[input[i]];
    } else {
      output += input[i];
    }
  }
  return output;
};
var normalizeNumberInput = function normalizeNumberInput() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  var map = {
    "০": "0",
    "১": "1",
    "২": "2",
    "৩": "3",
    "৪": "4",
    "৫": "5",
    "৬": "6",
    "৭": "7",
    "৮": "8",
    "৯": "9"
  };
  return value.replace(/[০-৯]/g, function (d) {
    return map[d];
  }) // Bangla → English
  .replace(/\D/g, ""); // Keep only 0-9
};
var conditionalEnToBn = function conditionalEnToBn(num, locale) {
  if (locale === "en") {
    return num;
  } else {
    return enToBn(num);
  }
};
var formatDynamicValue = function formatDynamicValue(value, language) {
  if (value === null || value === undefined || value === "") return "—";
  var strValue = String(value);

  // Skip formatting if it's a translation key (contains a dot)
  if (strValue.includes(".")) {
    return strValue;
  }

  // Format snake_case and camelCase
  var formattedValue = strValue.replace(/_/g, " ").replace(/([a-z])([A-Z])/g, "$1 $2").replace(/\b\w/g, function (c) {
    return c.toUpperCase();
  });

  // Convert numbers to Bangla
  return conditionalEnToBn(formattedValue, language);
};
var getInfoId = function getInfoId(resp, dataKey) {
  var _resp$payload;
  var id = null;
  if (resp !== null && resp !== void 0 && (_resp$payload = resp.payload) !== null && _resp$payload !== void 0 && _resp$payload.data) {
    var _parseData$map;
    var data = (_parseData$map = parseData(resp.payload.data[dataKey]).map(function (info) {
      return _objectSpread$26(_objectSpread$26({}, info), {}, {
        id: decodeId(info.id)
      });
    })) === null || _parseData$map === void 0 ? void 0 : _parseData$map[0];
    id = data === null || data === void 0 ? void 0 : data.id;
  }
  return id;
};
function getThirdStepId(location) {
  var _current2;
  var current = location;
  var step = 0;
  while ((_current = current) !== null && _current !== void 0 && _current.parent && step < 1) {
    var _current;
    current = current.parent;
    step++;
  }

  // after 2 jumps, we're at step 3
  return ((_current2 = current) === null || _current2 === void 0 ? void 0 : _current2.id) || null;
}
var convertBanglaToEnglishDigits = function convertBanglaToEnglishDigits(str) {
  return str.replace(/[০-৯]/g, function (d) {
    return "০১২৩৪৫৬৭৮৯".indexOf(d);
  });
};
var isNotFutureDateBangla = function isNotFutureDateBangla(dateString) {
  if (!dateString) return false;

  // Convert Bangla digits to English first
  var en = convertBanglaToEnglishDigits(dateString);

  // Parse DD-MM-YYYY manually
  var parts = en.split("-");
  if (parts.length !== 3) return false;
  var _parts$map = parts.map(Number),
    _parts$map2 = _slicedToArray(_parts$map, 3),
    day = _parts$map2[0],
    month = _parts$map2[1],
    year = _parts$map2[2];
  var selectedDate = new Date(year, month - 1, day);
  if (isNaN(selectedDate.getTime())) return false;
  var today = new Date();
  today.setHours(0, 0, 0, 0);
  selectedDate.setHours(0, 0, 0, 0);
  return selectedDate <= today;
};
var isNotFutureDate = function isNotFutureDate(dateString) {
  if (!dateString) return false;
  var selectedDate = new Date(dateString);
  var today = new Date();
  today.setHours(0, 0, 0, 0);
  selectedDate.setHours(0, 0, 0, 0);
  return selectedDate <= today;
};
var validateRequiredFields = function validateRequiredFields(containerRef, formatMessage, formdata) {
  var fields = containerRef.current.querySelectorAll("[required]");
  var dependents = (formdata === null || formdata === void 0 ? void 0 : formdata.dependents) || (formdata === null || formdata === void 0 ? void 0 : formdata.employeeDependentInfo) || (formdata === null || formdata === void 0 ? void 0 : formdata.workforceEmployeeDependentApplication);
  console.log({
    fields: fields
  });
  var errors = {};
  fields.forEach(function (field) {
    var _field$value, _field$value$trim, _formdata$employeeAcc;
    var value = ((_field$value = field.value) === null || _field$value === void 0 || (_field$value$trim = _field$value.trim) === null || _field$value$trim === void 0 ? void 0 : _field$value$trim.call(_field$value)) || "";
    if (!value && field.tagName !== "DIV") {
      var _field$parentElement$;
      if ((!field.id || field.id === "rdmp") && (_field$parentElement$ = field.parentElement.previousElementSibling) !== null && _field$parentElement$ !== void 0 && _field$parentElement$.classList && Array.from(field.parentElement.previousElementSibling.classList).some(function (c) {
        return c.startsWith("openIMISDatePicker-label");
      })) {
        field.id = "rdmp";
      }
      var parent = field.parentElement;
      while (parent) {
        if (parent.classList && Array.from(parent.classList).some(function (c) {
          return c.startsWith("DetailedLocation-form");
        })) {
          field.id = "detailedLocation";
          break;
        }
        parent = parent.parentElement;
      }
      errors[field.id || field.name] = formatMessage("core.error.required");
      console.warn("Validation failed for field: ".concat(field.id || field.name));
    }
    if (value && field.tagName !== "DIV") {
      var _field$parentElement$2;
      if ((!field.id || field.id === "rdmp") && (_field$parentElement$2 = field.parentElement.previousElementSibling) !== null && _field$parentElement$2 !== void 0 && _field$parentElement$2.classList && Array.from(field.parentElement.previousElementSibling.classList).some(function (c) {
        return c.startsWith("openIMISDatePicker-label");
      }) && !isNotFutureDateBangla(value)) {
        field.id = "rdmp";
        errors[field.id || field.name] = formatMessage("core.error.dateTime");
        console.warn("Validation failed for field: ".concat(field.id || field.name));
      }
    }
    if (field.id === "phoneNumber") {
      if (value.length !== 11) {
        errors[field.id] = formatMessage("core.error.phoneNumberLength");
        console.warn("Validation failed for phoneNumber: expected 11 digits, got ".concat(value.length));
      }
    }
    if (field.id === "nid") {
      if (!(value.length === 10 || value.length === 13 || value.length === 17)) {
        errors[field.id] = formatMessage("core.error.nidLength");
        console.warn("Validation failed for nid: expected 10, 13 or 17 digits, got ".concat(value.length));
      } else {
        // FIX: Check if the NID appears MORE THAN ONCE in the array
        var duplicateCount = dependents === null || dependents === void 0 ? void 0 : dependents.filter(function (obj) {
          return obj.nid === value;
        }).length;
        if (duplicateCount > 1) {
          errors[field.id] = formatMessage("core.error.nid.repeat");
        }
      }
    }
    if (formdata !== null && formdata !== void 0 && (_formdata$employeeAcc = formdata.employeeAccidentInfo) !== null && _formdata$employeeAcc !== void 0 && _formdata$employeeAcc.dateOfRejoining) {
      var _formdata$employeeAcc2, _formdata$employeeAcc3;
      var accidentDate = new Date(formdata === null || formdata === void 0 || (_formdata$employeeAcc2 = formdata.employeeAccidentInfo) === null || _formdata$employeeAcc2 === void 0 ? void 0 : _formdata$employeeAcc2.accidentDate);
      var rejoinDate = new Date(formdata === null || formdata === void 0 || (_formdata$employeeAcc3 = formdata.employeeAccidentInfo) === null || _formdata$employeeAcc3 === void 0 ? void 0 : _formdata$employeeAcc3.dateOfRejoining);
      if (rejoinDate < accidentDate) {
        errors["dateOfRejoining"] = formatMessage("workforce.rejoinDate.error");
        console.warn("The re-joining date cannot be earlier than the date of the accident.");
      }
    }
    if (field.id === "accountNumber") {
      if (!(value.length >= 8 && value.length <= 17)) {
        errors[field.id] = formatMessage("core.error.accountNumberLength");
        console.warn("Validation failed for phoneNumber: expected 11 digits, got ".concat(value.length));
      }
    }
  });
  return errors;
};

// export const isAtLeast18YearsOld = (birthDateString) => {
//   if (!birthDateString) return false;

//   const birthDate = new Date(birthDateString);
//   const today = new Date();

//   // Calculate the difference in years
//   let age = today.getFullYear() - birthDate.getFullYear();

//   // Adjust if the birthday hasn’t occurred yet this year
//   const hasHadBirthdayThisYear =
//     today.getMonth() > birthDate.getMonth() || (today.getMonth() === birthDate.getMonth() && today.getDate() >= birthDate.getDate());

//   if (!hasHadBirthdayThisYear) {
//     age -= 1;
//   }

//   return age >= 16;
// };
var isAtLeast18YearsOld = function isAtLeast18YearsOld(birthDateString) {
  var ageLimit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 16;
  if (!birthDateString) return false;
  var birthDate = new Date(birthDateString);
  if (isNaN(birthDate.getTime())) return false;
  var today = new Date();
  var age = today.getFullYear() - birthDate.getFullYear();
  var hasHadBirthdayThisYear = today.getMonth() > birthDate.getMonth() || today.getMonth() === birthDate.getMonth() && today.getDate() >= birthDate.getDate();
  if (!hasHadBirthdayThisYear) age--;
  return age >= ageLimit;
};
function extractId(item) {
  if (!item && item !== 0) return null;
  if (_typeof(item) === "object" && item.id !== undefined) return item.id;
  return item;
}
function isNumericString(s) {
  return typeof s === "string" && /^[0-9]+$/.test(s);
}
function looksLikeBase64(s) {
  if (typeof s !== "string") return false;
  if (!/^[A-Za-z0-9+/=]+$/.test(s)) return false;
  if (s.length % 4 !== 0) return false;
  try {
    return btoa(atob(s)) === s;
  } catch (e) {
    return false;
  }
}
function safeDecodeId(maybeEncoded) {
  if (maybeEncoded === null || maybeEncoded === undefined) return maybeEncoded;
  if (typeof maybeEncoded === "number") return maybeEncoded;
  if (_typeof(maybeEncoded) === "object") {
    var extracted = extractId(maybeEncoded);
    if (extracted !== maybeEncoded) return safeDecodeId(extracted);
  }
  var s = String(maybeEncoded);
  if (isNumericString(s)) return s;
  if (looksLikeBase64(s)) {
    try {
      return decodeId(s);
    } catch (err) {
      return s;
    }
  }
  try {
    return decodeId(s);
  } catch (err) {
    return s;
  }
}
function getAssociationNameByUserType(user_type) {
  if (user_type.includes("association")) {
    return user_type.split("_")[0].toUpperCase();
  } else {
    return "";
  }
}
function getApprovalStatus(isApproved) {
  if (isApproved === "yes") {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("b", {
      style: {
        color: "green"
      }
    }, "Approved"));
  } else {
    return "Not Approved Yet";
  }
}
/**
 * @param {string|null} relation
 * @param {string} applicationType
 */
function getFooterContentNew(depObj, workerBirthDate, applicationType, paymentType) {
  console.log("applicationtype", applicationType);
  if (applicationType === "disabilityAssistance" && paymentType == "installment") {
    return /*#__PURE__*/React.createElement(FooterWrapper, null, /*#__PURE__*/React.createElement("ol", {
      style: {
        listStyle: "none",
        paddingLeft: "20px",
        marginTop: "5px"
      }
    }, /*#__PURE__*/React.createElement("li", null, "\u09E7\u0964 \u09B8\u09B0\u09CD\u09AC\u09AE\u09CB\u099F \u09AA\u09CD\u09B0\u09A6\u09C7\u09DF \u09B2\u09BE\u0987\u09AB \u099F\u09BE\u0987\u09AE \u099F\u09AA-\u0986\u09AA \u09AC\u09C7\u09A8\u09BF\u09AB\u09BF\u099F \u09A4\u09CD\u09B0\u09C8\u09AE\u09BE\u09B8\u09BF\u0995 \u09E9 \u0995\u09BF\u09B8\u09CD\u09A4\u09BF\u09B0 \u09AE\u09BE\u09A7\u09CD\u09AF\u09AE\u09C7 \u09AA\u09B0\u09BF\u09B6\u09CB\u09A7 \u0995\u09B0\u09BE \u09B9\u09AC\u09C7\u0964"), /*#__PURE__*/React.createElement("li", null, "\u09E8\u0964 \u09B6\u09CD\u09B0\u09AE\u09BF\u0995\u09C7\u09B0 \u099C\u09C0\u09AC\u09A8\u09BE\u09AC\u09B8\u09CD\u09A5\u09BE\u09B0 \u0995\u09CB\u09A8 \u09AA\u09B0\u09BF\u09AC\u09B0\u09CD\u09A4\u09A8 \u0998\u099F\u09B2\u09C7 (\u09AE\u09C3\u09A4\u09CD\u09AF\u09C1) \u0987.\u0986\u0987.\u098F\u09B8 \u09AA\u09BE\u0987\u09B2\u099F \u09B8\u09CD\u09AA\u09C7\u09B6\u09BE\u09B2 \u0987\u0989\u09A8\u09BF\u099F\u0995\u09C7 \u0985\u09AC\u09B6\u09CD\u09AF\u0987 \u0985\u09AC\u09B9\u09BF\u09A4 \u0995\u09B0\u09A4\u09C7 \u09B9\u09AC\u09C7\u0964"), /*#__PURE__*/React.createElement("li", null, "\u09E9\u0964 \u09AC\u09BF\u09AC\u09BE\u09B9 \u09AC\u09A8\u09CD\u09A7\u09A8\u09C7 \u0986\u09AC\u09A6\u09CD\u09A7 \u09A8\u09BE \u09B9\u0993\u09DF\u09BE \u09AA\u09B0\u09CD\u09AF\u09A8\u09CD\u09A4 \u09AC\u09C7\u09A8\u09BF\u09AB\u09BF\u099F \u09AA\u09BE\u09AC\u09C7\u09A8\u0964"), /*#__PURE__*/React.createElement("li", null, "\u09EA\u0964 \u09A4\u09C8\u09B0\u09C0 \u09AA\u09CB\u09B6\u09BE\u0995 \u09B6\u09BF\u09B2\u09CD\u09AA\u09C7\u09B0 \u0995\u09CD\u09B0\u09C7\u09A4\u09BE/\u09AC\u09CD\u09B0\u09CD\u09AF\u09BE\u09A8\u09CD\u09A1\u09B0\u09BE \u09B8\u09CD\u09AC\u09C7\u099A\u09CD\u099B\u09BE\u09DF \u098F\u09AC\u0982 \u09B8\u09BE\u09AE\u09DF\u09BF\u0995 \u09AD\u09BF\u09A4\u09CD\u09A4\u09BF\u09A4\u09C7/\u0985\u09A8\u09CD\u09A4\u09B0\u09CD\u09AC\u09B0\u09CD\u09A4\u09C0\u0995\u09BE\u09B2\u09C0\u09A8 \u09B8\u09AE\u09BE\u09A7\u09BE\u09A8 \u09B9\u09BF\u09B8\u09C7\u09AC\u09C7 \u099F\u09AA-\u0986\u09AA \u09AC\u09C7\u09A8\u09BF\u09AB\u09BF\u099F \u09AA\u09CD\u09B0\u09A6\u09BE\u09A8\u09C7\u09B0 \u099C\u09A8\u09CD\u09AF \u0987.\u0986\u0987.\u098F\u09B8 \u09AA\u09BE\u0987\u09B2\u099F\u0995\u09C7 \u0985\u09B0\u09CD\u09A5\u09BE\u09DF\u09A8 \u0995\u09B0\u099B\u09C7\u0964")));
  } else if (applicationType === "disabilityAssistance" && paymentType == "onetime") {
    return /*#__PURE__*/React.createElement(FooterWrapper, null, /*#__PURE__*/React.createElement("ol", {
      style: {
        listStyle: "none",
        paddingLeft: "20px",
        marginTop: "5px"
      }
    }, /*#__PURE__*/React.createElement("li", null, "\u09E7\u0964 \u09B8\u09B0\u09CD\u09AC\u09AE\u09CB\u099F \u099F\u09AA-\u0986\u09AA \u09AC\u09C7\u09A8\u09BF\u09AB\u09BF\u099F \u098F\u0995\u0995\u09BE\u09B2\u09C0\u09A8 \u09AA\u09B0\u09BF\u09B6\u09CB\u09A7 \u0995\u09B0\u09BE \u09B9\u09AC\u09C7\u0964"), /*#__PURE__*/React.createElement("li", null, "\u09E8\u0964 \u09B6\u09CD\u09B0\u09AE\u09BF\u0995\u09C7\u09B0 \u099C\u09C0\u09AC\u09A8\u09BE\u09AC\u09B8\u09CD\u09A5\u09BE\u09B0 \u0995\u09CB\u09A8 \u09AA\u09B0\u09BF\u09AC\u09B0\u09CD\u09A4\u09A8 \u0998\u099F\u09B2\u09C7 (\u09AE\u09C3\u09A4\u09CD\u09AF\u09C1) \u0987.\u0986\u0987.\u098F\u09B8 \u09AA\u09BE\u0987\u09B2\u099F \u09B8\u09CD\u09AA\u09C7\u09B6\u09BE\u09B2 \u0987\u0989\u09A8\u09BF\u099F\u0995\u09C7 \u0985\u09AC\u09B6\u09CD\u09AF\u0987 \u0985\u09AC\u09B9\u09BF\u09A4 \u0995\u09B0\u09A4\u09C7 \u09B9\u09AC\u09C7\u0964 "), /*#__PURE__*/React.createElement("li", null, "\u09E9\u0964 \u09A4\u09C8\u09B0\u09C0 \u09AA\u09CB\u09B6\u09BE\u0995 \u09B6\u09BF\u09B2\u09CD\u09AA\u09C7\u09B0 \u0995\u09CD\u09B0\u09C7\u09A4\u09BE/\u09AC\u09CD\u09B0\u09CD\u09AF\u09BE\u09A8\u09CD\u09A1\u09B0\u09BE \u09B8\u09CD\u09AC\u09C7\u099A\u09CD\u099B\u09BE\u09DF \u098F\u09AC\u0982 \u09B8\u09BE\u09AE\u09DF\u09BF\u0995 \u09AD\u09BF\u09A4\u09CD\u09A4\u09BF\u09A4\u09C7/\u0985\u09A8\u09CD\u09A4\u09B0\u09CD\u09AC\u09B0\u09CD\u09A4\u09C0\u0995\u09BE\u09B2\u09C0\u09A8 \u09B8\u09AE\u09BE\u09A7\u09BE\u09A8 \u09B9\u09BF\u09B8\u09C7\u09AC\u09C7 \u099F\u09AA-\u0986\u09AA \u09AC\u09C7\u09A8\u09BF\u09AB\u09BF\u099F \u09AA\u09CD\u09B0\u09A6\u09BE\u09A8\u09C7\u09B0 \u099C\u09A8\u09CD\u09AF \u0987.\u0986\u0987.\u098F\u09B8 \u09AA\u09BE\u0987\u09B2\u099F\u0995\u09C7 \u0985\u09B0\u09CD\u09A5\u09BE\u09DF\u09A8 \u0995\u09B0\u099B\u09C7\u0964")));
  } else if (applicationType === "disabilityAssistance" && paymentType == "monthly") {
    return /*#__PURE__*/React.createElement(FooterWrapper, null, /*#__PURE__*/React.createElement("ol", {
      style: {
        listStyle: "none",
        paddingLeft: "20px",
        marginTop: "5px"
      }
    }, /*#__PURE__*/React.createElement("li", null, "\u09E7\u0964 \u099F\u09AA-\u0986\u09AA \u09AC\u09C7\u09A8\u09BF\u09AB\u09BF\u099F \u09AE\u09BE\u09B8\u09BF\u0995\u09AD\u09BF\u09A4\u09CD\u09A4\u09BF\u09A4\u09C7 \u09AA\u09CD\u09B0\u09A6\u09BE\u09A8 \u0995\u09B0\u09BE \u09B9\u09AC\u09C7 \u09AF\u09A4\u0995\u09CD\u09B7\u09A3 \u09A8\u09BE \u09AC\u09B0\u09CD\u09A3\u09BF\u09A4 \u09B6\u09CD\u09B0\u09AE\u09BF\u0995 \u09AE\u09C3\u09A4\u09CD\u09AF\u09C1\u09AC\u09B0\u09A3 \u0995\u09B0\u09C7\u09A8\u0964"), /*#__PURE__*/React.createElement("li", null, "\u09E8\u0964 \u09B6\u09CD\u09B0\u09AE\u09BF\u0995\u09C7\u09B0 \u099C\u09C0\u09AC\u09A8\u09BE\u09AC\u09B8\u09CD\u09A5\u09BE\u09B0 \u0995\u09CB\u09A8 \u09AA\u09B0\u09BF\u09AC\u09B0\u09CD\u09A4\u09A8 \u0998\u099F\u09B2\u09C7 (\u09AE\u09C3\u09A4\u09CD\u09AF\u09C1) \u0987.\u0986\u0987.\u098F\u09B8 \u09AA\u09BE\u0987\u09B2\u099F \u09B8\u09CD\u09AA\u09C7\u09B6\u09BE\u09B2 \u0987\u0989\u09A8\u09BF\u099F\u0995\u09C7 \u0985\u09AC\u09B6\u09CD\u09AF\u0987 \u0985\u09AC\u09B9\u09BF\u09A4 \u0995\u09B0\u09A4\u09C7 \u09B9\u09AC\u09C7\u0964 \u098F\u0995\u09CD\u09B7\u09C7\u09A4\u09CD\u09B0\u09C7 \u09AF\u09BE\u099A\u09BE\u0987\u0995\u09B0\u09A3 \u09B8\u0982\u0995\u09CD\u09B0\u09BE\u09A8\u09CD\u09A4 \u09AA\u09CD\u09B0\u09AE\u09BE\u09A3\u09AA\u09A4\u09CD\u09B0 \u09AA\u09CD\u09B0\u09A4\u09BF \u09AC\u099B\u09B0\u09BE\u09A8\u09CD\u09A4\u09C7 \u0987.\u0986\u0987.\u098F\u09B8 \u09AA\u09BE\u0987\u09B2\u099F \u09B8\u09CD\u09AA\u09C7\u09B6\u09BE\u09B2 \u0987\u0989\u09A8\u09BF\u099F\u0995\u09C7 \u09AA\u09CD\u09B0\u09A6\u09BE\u09A8 \u0995\u09B0\u09A4\u09C7 \u09B9\u09AC\u09C7\u0964"), /*#__PURE__*/React.createElement("li", null, "\u09E9\u0964 \u09A4\u09C8\u09B0\u09C0 \u09AA\u09CB\u09B6\u09BE\u0995 \u09B6\u09BF\u09B2\u09CD\u09AA\u09C7\u09B0 \u0995\u09CD\u09B0\u09C7\u09A4\u09BE/\u09AC\u09CD\u09B0\u09CD\u09AF\u09BE\u09A8\u09CD\u09A1\u09B0\u09BE \u09B8\u09CD\u09AC\u09C7\u099A\u09CD\u099B\u09BE\u09DF \u098F\u09AC\u0982 \u09B8\u09BE\u09AE\u09DF\u09BF\u0995 \u09AD\u09BF\u09A4\u09CD\u09A4\u09BF\u09A4\u09C7/\u0985\u09A8\u09CD\u09A4\u09B0\u09CD\u09AC\u09B0\u09CD\u09A4\u09C0\u0995\u09BE\u09B2\u09C0\u09A8 \u09B8\u09AE\u09BE\u09A7\u09BE\u09A8 \u09B9\u09BF\u09B8\u09C7\u09AC\u09C7 \u099F\u09AA-\u0986\u09AA \u09AC\u09C7\u09A8\u09BF\u09AB\u09BF\u099F \u09AA\u09CD\u09B0\u09A6\u09BE\u09A8\u09C7\u09B0 \u099C\u09A8\u09CD\u09AF \u0987.\u0986\u0987.\u098F\u09B8 \u09AA\u09BE\u0987\u09B2\u099F\u0995\u09C7 \u0985\u09B0\u09CD\u09A5\u09BE\u09DF\u09A8 \u0995\u09B0\u099B\u09C7\u0964")));
  } else {
    console.log("deps", depObj);
    var age = calculateAge(depObj.birthDate);
    var workerAge = calculateAge(workerBirthDate);
    var relation = (depObj === null || depObj === void 0 ? void 0 : depObj.relationWithWorker) || (depObj === null || depObj === void 0 ? void 0 : depObj.relationType);
    var marital = depObj.maritalStatus;
    depObj.isDisabled;
    if (relation === "workforce.relation.wife" && age >= 16 && marital === "workforce.marital_status.widow") {
      return /*#__PURE__*/React.createElement(FooterWrapper, null, /*#__PURE__*/React.createElement("ol", {
        style: {
          listStyle: "none",
          paddingLeft: "20px",
          marginTop: "5px"
        }
      }, /*#__PURE__*/React.createElement("li", null, "\u09E7\u0964 \u099F\u09AA-\u0986\u09AA \u09AC\u09C7\u09A8\u09BF\u09AB\u09BF\u099F \u09AE\u09BE\u09B8\u09BF\u0995\u09AD\u09BF\u09A4\u09CD\u09A4\u09BF\u09A4\u09C7 \u09AA\u09CD\u09B0\u09A6\u09BE\u09A8 \u0995\u09B0\u09BE \u09B9\u09AC\u09C7 \u09AF\u09A4\u0995\u09CD\u09B7\u09A3 \u09A8\u09BE:", /*#__PURE__*/React.createElement("ol", {
        style: {
          listStyle: "none",
          paddingLeft: "20px",
          marginTop: "5px"
        }
      }, /*#__PURE__*/React.createElement("li", null, "\u0995. \u0989\u09AA\u09AF\u09C1\u0995\u09CD\u09A4 \u09A8\u09BF\u09B0\u09CD\u09AD\u09B0\u09B6\u09C0\u09B2 \u09AC\u09CD\u09AF\u0995\u09CD\u09A4\u09BF \u09AE\u09C3\u09A4\u09CD\u09AF\u09C1\u09AC\u09B0\u09A3 \u0995\u09B0\u09C7\u09A8; \u0985\u09A5\u09AC\u09BE"), /*#__PURE__*/React.createElement("li", null, "\u0996. \u09AA\u09C1\u09A8\u0983\u09AC\u09BF\u09AC\u09BE\u09B9 \u0995\u09B0\u09C7\u09A8\u0964"))), /*#__PURE__*/React.createElement("li", null, "\u09E8\u0964 \u09B6\u09CD\u09B0\u09AE\u09BF\u0995\u09C7\u09B0 \u09B8\u09CD\u09A4\u09CD\u09B0\u09C0\u09B0 \u09AE\u09C3\u09A4\u09CD\u09AF\u09C1 \u09B9\u09B2\u09C7 \u0985\u09A5\u09AC\u09BE \u09AA\u09C1\u09A8\u09B0\u09BE\u09DF \u09AC\u09BF\u09AC\u09BE\u09B9 \u09AC\u09A8\u09CD\u09A7\u09A8\u09C7 \u0986\u09AC\u09A6\u09CD\u09A7 \u09B9\u09B2\u09C7, \u09B8\u09C7\u0995\u09CD\u09B7\u09C7\u09A4\u09CD\u09B0\u09C7 \u09A4\u09BE\u09B0 \u09AA\u09CD\u09B0\u09BE\u09AA\u09CD\u09AF \u09AE\u09BE\u09B8\u09BF\u0995 \u099F\u09AA-\u0986\u09AA \u09AC\u09C7\u09A8\u09BF\u09AB\u09BF\u099F \u09A8\u09BF\u09AE\u09CD\u09AE\u0989\u09B2\u09CD\u09B2\u09C7\u0996\u09BF\u09A4 \u09B9\u09BE\u09B0\u09C7 \u09AE\u09C3\u09A4 \u09B6\u09CD\u09B0\u09AE\u09BF\u0995\u09C7\u09B0 \u0989\u09AA\u09AF\u09C1\u0995\u09CD\u09A4 \u09A8\u09BF\u09B0\u09CD\u09AD\u09B0\u09B6\u09C0\u09B2 \u09B8\u09A8\u09CD\u09A4\u09BE\u09A8\u09A6\u09C7\u09B0 \u09AE\u09A7\u09CD\u09AF\u09C7 \u09AA\u09CD\u09B0\u09A6\u09C7\u09DF \u09B9\u09AC\u09C7\u0964", /*#__PURE__*/React.createElement("ol", {
        style: {
          listStyle: "none",
          paddingLeft: "20px",
          marginTop: "5px"
        }
      }, /*#__PURE__*/React.createElement("li", null, "\u0995. \u098F\u0995 \u0993 \u09A6\u09C1\u0987 \u09B8\u09A8\u09CD\u09A4\u09BE\u09A8\u09C7\u09B0 \u0995\u09CD\u09B7\u09C7\u09A4\u09CD\u09B0\u09C7 \u09EE\u09ED.\u09EB \u09B6\u09A4\u09BE\u0982\u09B6"), /*#__PURE__*/React.createElement("li", null, "\u0996. \u09A6\u09C1\u0987 \u098F\u09B0 \u0985\u09A7\u09BF\u0995 \u09B8\u09A8\u09CD\u09A4\u09BE\u09A8\u09C7\u09B0 \u0995\u09CD\u09B7\u09C7\u09A4\u09CD\u09B0\u09C7 \u09E7\u09E6\u09E6 \u09B6\u09A4\u09BE\u0982\u09B6"))), /*#__PURE__*/React.createElement("li", null, "\u09E9\u0964 \u0985\u09AA\u09CD\u09B0\u09BE\u09AA\u09CD\u09A4\u09AC\u09DF\u09B8\u09CD\u0995 \u0989\u09AA\u09AF\u09C1\u0995\u09CD\u09A4 \u09A8\u09BF\u09B0\u09CD\u09AD\u09B0\u09B6\u09C0\u09B2 \u09AC\u09CD\u09AF\u0995\u09CD\u09A4\u09BF\u09B0 \u09AA\u09CD\u09B0\u09BE\u09AA\u09CD\u09AF \u09AC\u09C7\u09A8\u09BF\u09AB\u09BF\u099F \u09A4\u09BE\u09B0 \u0986\u0987\u09A8\u0997\u09A4 \u0985\u09AD\u09BF\u09AD\u09BE\u09AC\u0995\u09C7\u09B0 \u098F\u0995\u09BE\u0989\u09A8\u09CD\u099F\u09C7 \u09AA\u09B0\u09BF\u09B6\u09CB\u09A7 \u0995\u09B0\u09BE \u09AF\u09BE\u09AC\u09C7\u0964"), /*#__PURE__*/React.createElement("li", null, "\u09EA\u0964 \u0989\u09AA\u09AF\u09C1\u0995\u09CD\u09A4 \u09A8\u09BF\u09B0\u09CD\u09AD\u09B0\u09B6\u09C0\u09B2 \u09AC\u09CD\u09AF\u0995\u09CD\u09A4\u09BF\u09B0 \u099C\u09C0\u09AC\u09A8\u09BE\u09AC\u09B8\u09CD\u09A5\u09BE\u09B0 \u0995\u09CB\u09A8 \u09AA\u09B0\u09BF\u09AC\u09B0\u09CD\u09A4\u09A8 \u0998\u099F\u09B2\u09C7 (\u09AE\u09C3\u09A4\u09CD\u09AF\u09C1, \u09AC\u09BF\u09AC\u09BE\u09B9) \u0987.\u0986\u0987.\u098F\u09B8 \u09AA\u09BE\u0987\u09B2\u099F \u09B8\u09CD\u09AA\u09C7\u09B6\u09BE\u09B2 \u0987\u0989\u09A8\u09BF\u099F\u0995\u09C7 \u0985\u09AC\u09B6\u09CD\u09AF\u0987 \u0985\u09AC\u09B9\u09BF\u09A4 \u0995\u09B0\u09A4\u09C7 \u09B9\u09AC\u09C7\u0964 \u098F\u0995\u09CD\u09B7\u09C7\u09A4\u09CD\u09B0\u09C7 \u09AF\u09BE\u099A\u09BE\u0987\u0995\u09B0\u09A3 \u09B8\u0982\u0995\u09CD\u09B0\u09BE\u09A8\u09CD\u09A4 \u09AA\u09CD\u09B0\u09AE\u09BE\u09A3\u09AA\u09A4\u09CD\u09B0 \u09AA\u09CD\u09B0\u09A4\u09BF \u09AC\u099B\u09B0\u09BE\u09A8\u09CD\u09A4\u09C7 \u0987.\u0986\u0987.\u098F\u09B8 \u09AA\u09BE\u0987\u09B2\u099F \u09B8\u09CD\u09AA\u09C7\u09B6\u09BE\u09B2 \u0987\u0989\u09A8\u09BF\u099F\u0995\u09C7 \u09AA\u09CD\u09B0\u09A6\u09BE\u09A8 \u0995\u09B0\u09A4\u09C7 \u09B9\u09AC\u09C7\u0964"), /*#__PURE__*/React.createElement("li", null, "\u09EB\u0964 \u09A4\u09C8\u09B0\u09C0 \u09AA\u09CB\u09B6\u09BE\u0995 \u09B6\u09BF\u09B2\u09CD\u09AA\u09C7\u09B0 \u0995\u09CD\u09B0\u09C7\u09A4\u09BE/\u09AC\u09CD\u09B0\u09CD\u09AF\u09BE\u09A8\u09CD\u09A1\u09B0\u09BE \u09B8\u09CD\u09AC\u09C7\u099A\u09CD\u099B\u09BE\u09DF \u098F\u09AC\u0982 \u09B8\u09BE\u09AE\u09DF\u09BF\u0995 \u09AD\u09BF\u09A4\u09CD\u09A4\u09BF\u09A4\u09C7/\u0985\u09A8\u09CD\u09A4\u09B0\u09CD\u09AC\u09B0\u09CD\u09A4\u09C0\u0995\u09BE\u09B2\u09C0\u09A8 \u09B8\u09AE\u09BE\u09A7\u09BE\u09A8 \u09B9\u09BF\u09B8\u09C7\u09AC\u09C7 \u099F\u09AA-\u0986\u09AA \u09AC\u09C7\u09A8\u09BF\u09AB\u09BF\u099F \u09AA\u09CD\u09B0\u09A6\u09BE\u09A8\u09C7\u09B0 \u099C\u09A8\u09CD\u09AF \u0987.\u0986\u0987.\u098F\u09B8 \u09AA\u09BE\u0987\u09B2\u099F\u0995\u09C7 \u0985\u09B0\u09CD\u09A5\u09BE\u09DF\u09A8 \u0995\u09B0\u099B\u09C7\u0964")));
    } else if (relation === "workforce.relation.husband" && age > 18 && marital === "workforce.marital_status.widower") ; else if (relation === "workforce.relation.son") {
      return /*#__PURE__*/React.createElement(FooterWrapper, null, /*#__PURE__*/React.createElement("ol", {
        style: {
          listStyle: "none",
          paddingLeft: "20px",
          marginTop: "5px"
        }
      }, /*#__PURE__*/React.createElement("li", null, "\u09E7\u0964 \u099F\u09AA-\u0986\u09AA \u09AC\u09C7\u09A8\u09BF\u09AB\u09BF\u099F \u09AE\u09BE\u09B8\u09BF\u0995\u09AD\u09BF\u09A4\u09CD\u09A4\u09BF\u09A4\u09C7 \u09AA\u09CD\u09B0\u09A6\u09BE\u09A8 \u0995\u09B0\u09BE \u09B9\u09AC\u09C7 \u09AF\u09A4\u0995\u09CD\u09B7\u09A3 \u09A8\u09BE\u2014", /*#__PURE__*/React.createElement("ol", {
        style: {
          listStyle: "none",
          paddingLeft: "20px",
          marginTop: "5px"
        }
      }, /*#__PURE__*/React.createElement("li", null, "\u0995. \u0989\u09AA\u09AF\u09C1\u0995\u09CD\u09A4 \u09A8\u09BF\u09B0\u09CD\u09AD\u09B0\u09B6\u09C0\u09B2 \u09AC\u09CD\u09AF\u0995\u09CD\u09A4\u09BF \u09AE\u09C3\u09A4\u09CD\u09AF\u09C1\u09AC\u09B0\u09A3 \u0995\u09B0\u09C7\u09A8; \u0985\u09A5\u09AC\u09BE"), /*#__PURE__*/React.createElement("li", null, "\u0996. \u09AA\u09CD\u09B0\u09BE\u09AA\u09CD\u09A4\u09AC\u09DF\u09B8\u09CD\u0995 (\u09E7\u09EE \u09AC\u099B\u09B0) \u09B9\u0993\u09DF\u09BE \u09AA\u09B0\u09CD\u09AF\u09A8\u09CD\u09A4 \u09AC\u09C7\u09A8\u09BF\u09AB\u09BF\u099F \u09AA\u09BE\u09AC\u09C7\u09A8\u0964"))), /*#__PURE__*/React.createElement("li", null, "\u09E8\u0964 \u0985\u09AA\u09CD\u09B0\u09BE\u09AA\u09CD\u09A4\u09AC\u09DF\u09B8\u09CD\u0995 \u0989\u09AA\u09AF\u09C1\u0995\u09CD\u09A4 \u09A8\u09BF\u09B0\u09CD\u09AD\u09B0\u09B6\u09C0\u09B2 \u09AC\u09CD\u09AF\u0995\u09CD\u09A4\u09BF\u09B0 \u09AA\u09CD\u09B0\u09BE\u09AA\u09CD\u09AF \u09AC\u09C7\u09A8\u09BF\u09AB\u09BF\u099F \u09A4\u09BE\u09B0 \u0986\u0987\u09A8\u0997\u09A4 \u0985\u09AD\u09BF\u09AD\u09BE\u09AC\u0995\u09C7\u09B0 \u098F\u0995\u09BE\u0989\u09A8\u09CD\u099F\u09C7 \u09AA\u09B0\u09BF\u09B6\u09CB\u09A7 \u0995\u09B0\u09BE \u09AF\u09BE\u09AC\u09C7\u0964"), /*#__PURE__*/React.createElement("li", null, "\u09E9\u0964 \u0989\u09AA\u09AF\u09C1\u0995\u09CD\u09A4 \u09A8\u09BF\u09B0\u09CD\u09AD\u09B0\u09B6\u09C0\u09B2 \u09AC\u09CD\u09AF\u0995\u09CD\u09A4\u09BF\u09B0 \u099C\u09C0\u09AC\u09A8\u09BE\u09AC\u09B8\u09CD\u09A5\u09BE\u09B0 \u0995\u09CB\u09A8 \u09AA\u09B0\u09BF\u09AC\u09B0\u09CD\u09A4\u09A8 \u0998\u099F\u09B2\u09C7 (\u09AE\u09C3\u09A4\u09CD\u09AF\u09C1) \u0987.\u0986\u0987.\u098F\u09B8 \u09AA\u09BE\u0987\u09B2\u099F \u09B8\u09CD\u09AA\u09C7\u09B6\u09BE\u09B2 \u0987\u0989\u09A8\u09BF\u099F\u0995\u09C7 \u0985\u09AC\u09B6\u09CD\u09AF\u0987 \u0985\u09AC\u09B9\u09BF\u09A4 \u0995\u09B0\u09A4\u09C7 \u09B9\u09AC\u09C7\u0964 \u098F\u0995\u09CD\u09B7\u09C7\u09A4\u09CD\u09B0\u09C7 \u09AF\u09BE\u099A\u09BE\u0987\u0995\u09B0\u09A3 \u09B8\u0982\u0995\u09CD\u09B0\u09BE\u09A8\u09CD\u09A4 \u09AA\u09CD\u09B0\u09AE\u09BE\u09A3\u09AA\u09A4\u09CD\u09B0 \u09AA\u09CD\u09B0\u09A4\u09BF \u09AC\u099B\u09B0\u09BE\u09A8\u09CD\u09A4\u09C7 \u0987.\u0986\u0987.\u098F\u09B8 \u09AA\u09BE\u0987\u09B2\u099F \u09B8\u09CD\u09AA\u09C7\u09B6\u09BE\u09B2 \u0987\u0989\u09A8\u09BF\u099F\u0995\u09C7 \u09AA\u09CD\u09B0\u09A6\u09BE\u09A8 \u0995\u09B0\u09A4\u09C7 \u09B9\u09AC\u09C7\u0964"), /*#__PURE__*/React.createElement("li", null, "\u09EA\u0964 \u09A4\u09C8\u09B0\u09C0 \u09AA\u09CB\u09B6\u09BE\u0995 \u09B6\u09BF\u09B2\u09CD\u09AA\u09C7\u09B0 \u0995\u09CD\u09B0\u09C7\u09A4\u09BE/\u09AC\u09CD\u09B0\u09CD\u09AF\u09BE\u09A8\u09CD\u09A1\u09B0\u09BE \u09B8\u09CD\u09AC\u09C7\u099A\u09CD\u099B\u09BE\u09DF \u098F\u09AC\u0982 \u09B8\u09BE\u09AE\u09DF\u09BF\u0995 \u09AD\u09BF\u09A4\u09CD\u09A4\u09BF\u09A4\u09C7/\u0985\u09A8\u09CD\u09A4\u09B0\u09CD\u09AC\u09B0\u09CD\u09A4\u09C0\u0995\u09BE\u09B2\u09C0\u09A8 \u09B8\u09AE\u09BE\u09A7\u09BE\u09A8 \u09B9\u09BF\u09B8\u09C7\u09AC\u09C7 \u099F\u09AA-\u0986\u09AA \u09AC\u09C7\u09A8\u09BF\u09AB\u09BF\u099F \u09AA\u09CD\u09B0\u09A6\u09BE\u09A8\u09C7\u09B0 \u099C\u09A8\u09CD\u09AF \u0987.\u0986\u0987.\u098F\u09B8 \u09AA\u09BE\u0987\u09B2\u099F\u0995\u09C7 \u0985\u09B0\u09CD\u09A5\u09BE\u09DF\u09A8 \u0995\u09B0\u099B\u09C7\u0964")));
    } else if (relation === "workforce.relation.daughter" && marital === "workforce.marital_status.single") {
      return /*#__PURE__*/React.createElement(FooterWrapper, null, /*#__PURE__*/React.createElement("ol", {
        style: {
          listStyle: "none",
          paddingLeft: "20px",
          marginTop: "5px"
        }
      }, /*#__PURE__*/React.createElement("li", null, "\u09E7\u0964 \u099F\u09AA-\u0986\u09AA \u09AC\u09C7\u09A8\u09BF\u09AB\u09BF\u099F \u09AE\u09BE\u09B8\u09BF\u0995\u09AD\u09BF\u09A4\u09CD\u09A4\u09BF\u09A4\u09C7 \u09AA\u09CD\u09B0\u09A6\u09BE\u09A8 \u0995\u09B0\u09BE \u09B9\u09AC\u09C7 \u09AF\u09A4\u0995\u09CD\u09B7\u09A3 \u09A8\u09BE\u2014", /*#__PURE__*/React.createElement("ol", {
        style: {
          listStyleType: "none",
          paddingLeft: "20px",
          marginTop: "5px"
        }
      }, /*#__PURE__*/React.createElement("li", null, "\u0995. \u0989\u09AA\u09AF\u09C1\u0995\u09CD\u09A4 \u09A8\u09BF\u09B0\u09CD\u09AD\u09B0\u09B6\u09C0\u09B2 \u09AC\u09CD\u09AF\u0995\u09CD\u09A4\u09BF \u09AE\u09C3\u09A4\u09CD\u09AF\u09C1\u09AC\u09B0\u09A3 \u0995\u09B0\u09C7\u09A8; \u0985\u09A5\u09AC\u09BE"), /*#__PURE__*/React.createElement("li", null, "\u0996. \u09AC\u09BF\u09AC\u09BE\u09B9 \u09AC\u09A8\u09CD\u09A7\u09A8\u09C7 \u0986\u09AC\u09A6\u09CD\u09A7 \u09A8\u09BE \u09B9\u0993\u09DF\u09BE \u09AA\u09B0\u09CD\u09AF\u09A8\u09CD\u09A4 \u09AC\u09C7\u09A8\u09BF\u09AB\u09BF\u099F \u09AA\u09BE\u09AC\u09C7\u09A8\u0964"))), /*#__PURE__*/React.createElement("li", null, "\u09E8\u0964 \u0985\u09AA\u09CD\u09B0\u09BE\u09AA\u09CD\u09A4\u09AC\u09DF\u09B8\u09CD\u0995 \u0989\u09AA\u09AF\u09C1\u0995\u09CD\u09A4 \u09A8\u09BF\u09B0\u09CD\u09AD\u09B0\u09B6\u09C0\u09B2 \u09AC\u09CD\u09AF\u0995\u09CD\u09A4\u09BF\u09B0 \u09AA\u09CD\u09B0\u09BE\u09AA\u09CD\u09AF \u09AC\u09C7\u09A8\u09BF\u09AB\u09BF\u099F \u09A4\u09BE\u09B0 \u0986\u0987\u09A8\u0997\u09A4 \u0985\u09AD\u09BF\u09AD\u09BE\u09AC\u0995\u09C7\u09B0 \u098F\u0995\u09BE\u0989\u09A8\u09CD\u099F\u09C7 \u09AA\u09B0\u09BF\u09B6\u09CB\u09A7 \u0995\u09B0\u09BE \u09AF\u09BE\u09AC\u09C7\u0964"), /*#__PURE__*/React.createElement("li", null, "\u09E9\u0964 \u0989\u09AA\u09AF\u09C1\u0995\u09CD\u09A4 \u09A8\u09BF\u09B0\u09CD\u09AD\u09B0\u09B6\u09C0\u09B2 \u09AC\u09CD\u09AF\u0995\u09CD\u09A4\u09BF\u09B0 \u099C\u09C0\u09AC\u09A8\u09BE\u09AC\u09B8\u09CD\u09A5\u09BE\u09B0 \u0995\u09CB\u09A8 \u09AA\u09B0\u09BF\u09AC\u09B0\u09CD\u09A4\u09A8 \u0998\u099F\u09B2\u09C7 (\u09AE\u09C3\u09A4\u09CD\u09AF\u09C1/\u09AC\u09BF\u09AC\u09BE\u09B9) \u0987.\u0986\u0987.\u098F\u09B8 \u09AA\u09BE\u0987\u09B2\u099F \u09B8\u09CD\u09AA\u09C7\u09B6\u09BE\u09B2 \u0987\u0989\u09A8\u09BF\u099F\u0995\u09C7 \u0985\u09AC\u09B6\u09CD\u09AF\u0987 \u0985\u09AC\u09B9\u09BF\u09A4 \u0995\u09B0\u09A4\u09C7 \u09B9\u09AC\u09C7\u0964 \u098F\u0995\u09CD\u09B7\u09C7\u09A4\u09CD\u09B0\u09C7 \u09AF\u09BE\u099A\u09BE\u0987\u0995\u09B0\u09A3 \u09B8\u0982\u0995\u09CD\u09B0\u09BE\u09A8\u09CD\u09A4 \u09AA\u09CD\u09B0\u09AE\u09BE\u09A3\u09AA\u09A4\u09CD\u09B0 \u09AA\u09CD\u09B0\u09A4\u09BF \u09AC\u099B\u09B0\u09BE\u09A8\u09CD\u09A4\u09C7 \u0987.\u0986\u0987.\u098F\u09B8 \u09AA\u09BE\u0987\u09B2\u099F \u09B8\u09CD\u09AA\u09C7\u09B6\u09BE\u09B2 \u0987\u0989\u09A8\u09BF\u099F\u0995\u09C7 \u09AA\u09CD\u09B0\u09A6\u09BE\u09A8 \u0995\u09B0\u09A4\u09C7 \u09B9\u09AC\u09C7\u0964"), /*#__PURE__*/React.createElement("li", null, "\u09EA\u0964 \u09A4\u09C8\u09B0\u09C0 \u09AA\u09CB\u09B6\u09BE\u0995 \u09B6\u09BF\u09B2\u09CD\u09AA\u09C7\u09B0 \u0995\u09CD\u09B0\u09C7\u09A4\u09BE/\u09AC\u09CD\u09B0\u09CD\u09AF\u09BE\u09A8\u09CD\u09A1\u09B0\u09BE \u09B8\u09CD\u09AC\u09C7\u099A\u09CD\u099B\u09BE\u09DF \u098F\u09AC\u0982 \u09B8\u09BE\u09AE\u09DF\u09BF\u0995 \u09AD\u09BF\u09A4\u09CD\u09A4\u09BF\u09A4\u09C7/\u0985\u09A8\u09CD\u09A4\u09B0\u09CD\u09AC\u09B0\u09CD\u09A4\u09C0\u0995\u09BE\u09B2\u09C0\u09A8 \u09B8\u09AE\u09BE\u09A7\u09BE\u09A8 \u09B9\u09BF\u09B8\u09C7\u09AC\u09C7 \u099F\u09AA-\u0986\u09AA \u09AC\u09C7\u09A8\u09BF\u09AB\u09BF\u099F \u09AA\u09CD\u09B0\u09A6\u09BE\u09A8\u09C7\u09B0 \u099C\u09A8\u09CD\u09AF \u0987.\u0986\u0987.\u098F\u09B8 \u09AA\u09BE\u0987\u09B2\u099F\u0995\u09C7 \u0985\u09B0\u09CD\u09A5\u09BE\u09DF\u09A8 \u0995\u09B0\u099B\u09C7\u0964")));
    } else if (relation === "workforce.relation.brother" && age < 18) {
      return /*#__PURE__*/React.createElement(FooterWrapper, null, /*#__PURE__*/React.createElement("ol", {
        style: {
          listStyle: "none",
          paddingLeft: "20px",
          marginTop: "5px"
        }
      }, /*#__PURE__*/React.createElement("li", null, "\u09E7\u0964 \u099F\u09AA-\u0986\u09AA \u09AC\u09C7\u09A8\u09BF\u09AB\u09BF\u099F \u09AE\u09BE\u09B8\u09BF\u0995\u09AD\u09BF\u09A4\u09CD\u09A4\u09BF\u09A4\u09C7 \u09AA\u09CD\u09B0\u09A6\u09BE\u09A8 \u0995\u09B0\u09BE \u09B9\u09AC\u09C7 \u09AF\u09A4\u0995\u09CD\u09B7\u09A3 \u09A8\u09BE\u2014", /*#__PURE__*/React.createElement("ol", {
        style: {
          listStyle: "none",
          paddingLeft: "20px",
          marginTop: "5px"
        }
      }, /*#__PURE__*/React.createElement("li", null, "\u0995. \u0989\u09AA\u09AF\u09C1\u0995\u09CD\u09A4 \u09A8\u09BF\u09B0\u09CD\u09AD\u09B0\u09B6\u09C0\u09B2 \u09AC\u09CD\u09AF\u0995\u09CD\u09A4\u09BF \u09AE\u09C3\u09A4\u09CD\u09AF\u09C1\u09AC\u09B0\u09A3 \u0995\u09B0\u09C7\u09A8; \u0985\u09A5\u09AC\u09BE"), /*#__PURE__*/React.createElement("li", null, "\u0996. \u09AA\u09CD\u09B0\u09BE\u09AA\u09CD\u09A4\u09AC\u09DF\u09B8\u09CD\u0995 (\u09E7\u09EE \u09AC\u099B\u09B0) \u09B9\u0993\u09DF\u09BE \u09AA\u09B0\u09CD\u09AF\u09A8\u09CD\u09A4 \u09AC\u09C7\u09A8\u09BF\u09AB\u09BF\u099F \u09AA\u09BE\u09AC\u09C7\u09A8\u0964"))), /*#__PURE__*/React.createElement("li", null, "\u09E8\u0964 \u0985\u09AA\u09CD\u09B0\u09BE\u09AA\u09CD\u09A4\u09AC\u09DF\u09B8\u09CD\u0995 \u0989\u09AA\u09AF\u09C1\u0995\u09CD\u09A4 \u09A8\u09BF\u09B0\u09CD\u09AD\u09B0\u09B6\u09C0\u09B2 \u09AC\u09CD\u09AF\u0995\u09CD\u09A4\u09BF\u09B0 \u09AA\u09CD\u09B0\u09BE\u09AA\u09CD\u09AF \u09AC\u09C7\u09A8\u09BF\u09AB\u09BF\u099F \u09A4\u09BE\u09B0 \u0986\u0987\u09A8\u0997\u09A4 \u0985\u09AD\u09BF\u09AD\u09BE\u09AC\u0995\u09C7\u09B0 \u098F\u0995\u09BE\u0989\u09A8\u09CD\u099F\u09C7 \u09AA\u09B0\u09BF\u09B6\u09CB\u09A7 \u0995\u09B0\u09BE \u09AF\u09BE\u09AC\u09C7\u0964"), /*#__PURE__*/React.createElement("li", null, "\u09E9\u0964 \u0989\u09AA\u09AF\u09C1\u0995\u09CD\u09A4 \u09A8\u09BF\u09B0\u09CD\u09AD\u09B0\u09B6\u09C0\u09B2 \u09AC\u09CD\u09AF\u0995\u09CD\u09A4\u09BF\u09B0 \u099C\u09C0\u09AC\u09A8\u09BE\u09AC\u09B8\u09CD\u09A5\u09BE\u09B0 \u0995\u09CB\u09A8 \u09AA\u09B0\u09BF\u09AC\u09B0\u09CD\u09A4\u09A8 \u0998\u099F\u09B2\u09C7 (\u09AE\u09C3\u09A4\u09CD\u09AF\u09C1) \u0987.\u0986\u0987.\u098F\u09B8 \u09AA\u09BE\u0987\u09B2\u099F \u09B8\u09CD\u09AA\u09C7\u09B6\u09BE\u09B2 \u0987\u0989\u09A8\u09BF\u099F\u0995\u09C7 \u0985\u09AC\u09B6\u09CD\u09AF\u0987 \u0985\u09AC\u09B9\u09BF\u09A4 \u0995\u09B0\u09A4\u09C7 \u09B9\u09AC\u09C7\u0964 \u098F\u0995\u09CD\u09B7\u09C7\u09A4\u09CD\u09B0\u09C7 \u09AF\u09BE\u099A\u09BE\u0987\u0995\u09B0\u09A3 \u09B8\u0982\u0995\u09CD\u09B0\u09BE\u09A8\u09CD\u09A4 \u09AA\u09CD\u09B0\u09AE\u09BE\u09A3\u09AA\u09A4\u09CD\u09B0 \u09AA\u09CD\u09B0\u09A4\u09BF \u09AC\u099B\u09B0\u09BE\u09A8\u09CD\u09A4\u09C7 \u0987.\u0986\u0987.\u098F\u09B8 \u09AA\u09BE\u0987\u09B2\u099F \u09B8\u09CD\u09AA\u09C7\u09B6\u09BE\u09B2 \u0987\u0989\u09A8\u09BF\u099F\u0995\u09C7 \u09AA\u09CD\u09B0\u09A6\u09BE\u09A8 \u0995\u09B0\u09A4\u09C7 \u09B9\u09AC\u09C7\u0964"), /*#__PURE__*/React.createElement("li", null, "\u09EA\u0964 \u09A4\u09C8\u09B0\u09C0 \u09AA\u09CB\u09B6\u09BE\u0995 \u09B6\u09BF\u09B2\u09CD\u09AA\u09C7\u09B0 \u0995\u09CD\u09B0\u09C7\u09A4\u09BE/\u09AC\u09CD\u09B0\u09CD\u09AF\u09BE\u09A8\u09CD\u09A1\u09B0\u09BE \u09B8\u09CD\u09AC\u09C7\u099A\u09CD\u099B\u09BE\u09DF \u098F\u09AC\u0982 \u09B8\u09BE\u09AE\u09DF\u09BF\u0995 \u09AD\u09BF\u09A4\u09CD\u09A4\u09BF\u09A4\u09C7/\u0985\u09A8\u09CD\u09A4\u09B0\u09CD\u09AC\u09B0\u09CD\u09A4\u09C0\u0995\u09BE\u09B2\u09C0\u09A8 \u09B8\u09AE\u09BE\u09A7\u09BE\u09A8 \u09B9\u09BF\u09B8\u09C7\u09AC\u09C7 \u099F\u09AA-\u0986\u09AA \u09AC\u09C7\u09A8\u09BF\u09AB\u09BF\u099F \u09AA\u09CD\u09B0\u09A6\u09BE\u09A8\u09C7\u09B0 \u099C\u09A8\u09CD\u09AF \u0987.\u0986\u0987.\u098F\u09B8 \u09AA\u09BE\u0987\u09B2\u099F\u0995\u09C7 \u0985\u09B0\u09CD\u09A5\u09BE\u09DF\u09A8 \u0995\u09B0\u099B\u09C7\u0964")));
    } else if (relation === "workforce.relation.sister" && marital === "workforce.marital_status.single") {
      return /*#__PURE__*/React.createElement(FooterWrapper, null, /*#__PURE__*/React.createElement("ol", {
        style: {
          listStyle: "none",
          paddingLeft: "20px",
          marginTop: "5px"
        }
      }, /*#__PURE__*/React.createElement("li", null, "\u09E7\u0964 \u099F\u09AA-\u0986\u09AA \u09AC\u09C7\u09A8\u09BF\u09AB\u09BF\u099F \u09AE\u09BE\u09B8\u09BF\u0995\u09AD\u09BF\u09A4\u09CD\u09A4\u09BF\u09A4\u09C7 \u09AA\u09CD\u09B0\u09A6\u09BE\u09A8 \u0995\u09B0\u09BE \u09B9\u09AC\u09C7 \u09AF\u09A4\u0995\u09CD\u09B7\u09A3 \u09A8\u09BE\u2014", /*#__PURE__*/React.createElement("ol", {
        style: {
          listStyle: "none",
          paddingLeft: "20px",
          marginTop: "5px"
        }
      }, /*#__PURE__*/React.createElement("li", null, "\u0995. \u0989\u09AA\u09AF\u09C1\u0995\u09CD\u09A4 \u09A8\u09BF\u09B0\u09CD\u09AD\u09B0\u09B6\u09C0\u09B2 \u09AC\u09CD\u09AF\u0995\u09CD\u09A4\u09BF \u09AE\u09C3\u09A4\u09CD\u09AF\u09C1\u09AC\u09B0\u09A3 \u0995\u09B0\u09C7\u09A8; \u0985\u09A5\u09AC\u09BE"), /*#__PURE__*/React.createElement("li", null, "\u0996. \u09AC\u09BF\u09AC\u09BE\u09B9 \u09AC\u09A8\u09CD\u09A7\u09A8\u09C7 \u0986\u09AC\u09A6\u09CD\u09A7 \u09A8\u09BE \u09B9\u0993\u09DF\u09BE \u09AA\u09B0\u09CD\u09AF\u09A8\u09CD\u09A4 \u09AC\u09C7\u09A8\u09BF\u09AB\u09BF\u099F \u09AA\u09BE\u09AC\u09C7\u09A8\u0964"))), /*#__PURE__*/React.createElement("li", null, "\u09E8\u0964 \u0985\u09AA\u09CD\u09B0\u09BE\u09AA\u09CD\u09A4\u09AC\u09DF\u09B8\u09CD\u0995 \u0989\u09AA\u09AF\u09C1\u0995\u09CD\u09A4 \u09A8\u09BF\u09B0\u09CD\u09AD\u09B0\u09B6\u09C0\u09B2 \u09AC\u09CD\u09AF\u0995\u09CD\u09A4\u09BF\u09B0 \u09AA\u09CD\u09B0\u09BE\u09AA\u09CD\u09AF \u09AC\u09C7\u09A8\u09BF\u09AB\u09BF\u099F \u09A4\u09BE\u09B0 \u0986\u0987\u09A8\u0997\u09A4 \u0985\u09AD\u09BF\u09AD\u09BE\u09AC\u0995\u09C7\u09B0 \u098F\u0995\u09BE\u0989\u09A8\u09CD\u099F\u09C7 \u09AA\u09B0\u09BF\u09B6\u09CB\u09A7 \u0995\u09B0\u09BE \u09AF\u09BE\u09AC\u09C7\u0964"), /*#__PURE__*/React.createElement("li", null, "\u09E9\u0964 \u0989\u09AA\u09AF\u09C1\u0995\u09CD\u09A4 \u09A8\u09BF\u09B0\u09CD\u09AD\u09B0\u09B6\u09C0\u09B2 \u09AC\u09CD\u09AF\u0995\u09CD\u09A4\u09BF\u09B0 \u099C\u09C0\u09AC\u09A8\u09BE\u09AC\u09B8\u09CD\u09A5\u09BE\u09B0 \u0995\u09CB\u09A8 \u09AA\u09B0\u09BF\u09AC\u09B0\u09CD\u09A4\u09A8 \u0998\u099F\u09B2\u09C7 (\u09AE\u09C3\u09A4\u09CD\u09AF\u09C1/\u09AC\u09BF\u09AC\u09BE\u09B9) \u0987.\u0986\u0987.\u098F\u09B8 \u09AA\u09BE\u0987\u09B2\u099F \u09B8\u09CD\u09AA\u09C7\u09B6\u09BE\u09B2 \u0987\u0989\u09A8\u09BF\u099F\u0995\u09C7 \u0985\u09AC\u09B6\u09CD\u09AF\u0987 \u0985\u09AC\u09B9\u09BF\u09A4 \u0995\u09B0\u09A4\u09C7 \u09B9\u09AC\u09C7\u0964 \u098F\u0995\u09CD\u09B7\u09C7\u09A4\u09CD\u09B0\u09C7 \u09AF\u09BE\u099A\u09BE\u0987\u0995\u09B0\u09A3 \u09B8\u0982\u0995\u09CD\u09B0\u09BE\u09A8\u09CD\u09A4 \u09AA\u09CD\u09B0\u09AE\u09BE\u09A3\u09AA\u09A4\u09CD\u09B0 \u09AA\u09CD\u09B0\u09A4\u09BF \u09AC\u099B\u09B0\u09BE\u09A8\u09CD\u09A4\u09C7 \u0987.\u0986\u0987.\u098F\u09B8 \u09AA\u09BE\u0987\u09B2\u099F \u09B8\u09CD\u09AA\u09C7\u09B6\u09BE\u09B2 \u0987\u0989\u09A8\u09BF\u099F\u0995\u09C7 \u09AA\u09CD\u09B0\u09A6\u09BE\u09A8 \u0995\u09B0\u09A4\u09C7 \u09B9\u09AC\u09C7\u0964"), /*#__PURE__*/React.createElement("li", null, "\u09EA\u0964 \u09A4\u09C8\u09B0\u09C0 \u09AA\u09CB\u09B6\u09BE\u0995 \u09B6\u09BF\u09B2\u09CD\u09AA\u09C7\u09B0 \u0995\u09CD\u09B0\u09C7\u09A4\u09BE/\u09AC\u09CD\u09B0\u09CD\u09AF\u09BE\u09A8\u09CD\u09A1\u09B0\u09BE \u09B8\u09CD\u09AC\u09C7\u099A\u09CD\u099B\u09BE\u09DF \u098F\u09AC\u0982 \u09B8\u09BE\u09AE\u09DF\u09BF\u0995 \u09AD\u09BF\u09A4\u09CD\u09A4\u09BF\u09A4\u09C7/\u0985\u09A8\u09CD\u09A4\u09B0\u09CD\u09AC\u09B0\u09CD\u09A4\u09C0\u0995\u09BE\u09B2\u09C0\u09A8 \u09B8\u09AE\u09BE\u09A7\u09BE\u09A8 \u09B9\u09BF\u09B8\u09C7\u09AC\u09C7 \u099F\u09AA-\u0986\u09AA \u09AC\u09C7\u09A8\u09BF\u09AB\u09BF\u099F \u09AA\u09CD\u09B0\u09A6\u09BE\u09A8\u09C7\u09B0 \u099C\u09A8\u09CD\u09AF \u0987.\u0986\u0987.\u098F\u09B8 \u09AA\u09BE\u0987\u09B2\u099F\u0995\u09C7 \u0985\u09B0\u09CD\u09A5\u09BE\u09DF\u09A8 \u0995\u09B0\u099B\u09C7\u0964")));
    } else if (relation === "workforce.relation.father" && age > workerAge || relation === "workforce.relation.mother" && age > workerAge || relation === "workforce.relation.grand_father" || relation === "workforce.relation.grand_mother") {
      return /*#__PURE__*/React.createElement(FooterWrapper, null, /*#__PURE__*/React.createElement("ol", {
        style: {
          listStyle: "none",
          paddingLeft: "20px",
          marginTop: "5px"
        }
      }, /*#__PURE__*/React.createElement("li", null, "\u09E7\u0964 \u099F\u09AA-\u0986\u09AA \u09AC\u09C7\u09A8\u09BF\u09AB\u09BF\u099F \u09AE\u09BE\u09B8\u09BF\u0995\u09AD\u09BF\u09A4\u09CD\u09A4\u09BF\u09A4\u09C7 \u09AA\u09CD\u09B0\u09A6\u09BE\u09A8 \u0995\u09B0\u09BE \u09B9\u09AC\u09C7 \u09AF\u09A4\u0995\u09CD\u09B7\u09A3 \u09A8\u09BE \u0989\u09AA\u09AF\u09C1\u0995\u09CD\u09A4 \u09A8\u09BF\u09B0\u09CD\u09AD\u09B0\u09B6\u09C0\u09B2 \u09AC\u09CD\u09AF\u0995\u09CD\u09A4\u09BF \u09AE\u09C3\u09A4\u09CD\u09AF\u09C1\u09AC\u09B0\u09A3 \u0995\u09B0\u09C7\u09A8\u0964"), /*#__PURE__*/React.createElement("li", null, "\u09E8\u0964 \u09B6\u09CD\u09B0\u09AE\u09BF\u0995\u09C7\u09B0 \u09AA\u09BF\u09A4\u09BE/\u09AE\u09BE\u09A4\u09BE\u09B0 \u0995\u09C7\u0989 \u09AE\u09C3\u09A4\u09CD\u09AF\u09C1\u09AC\u09B0\u09A3 \u0995\u09B0\u09B2\u09C7 \u09B8\u09C7\u0995\u09CD\u09B7\u09C7\u09A4\u09CD\u09B0\u09C7 \u09A4\u09BE\u09B0 \u09AA\u09CD\u09B0\u09BE\u09AA\u09CD\u09AF \u09AE\u09BE\u09B8\u09BF\u0995 \u099F\u09AA-\u0986\u09AA \u09AC\u09C7\u09A8\u09BF\u09AB\u09BF\u099F \u09AA\u09BF\u09A4\u09BE/\u09AE\u09BE\u09A4\u09BE\u09B0 \u09AE\u09A7\u09CD\u09AF\u09C7 \u099C\u09C0\u09AC\u09BF\u09A4 \u09B8\u09A6\u09B8\u09CD\u09AF\u09C7\u09B0 \u09A8\u09BF\u0995\u099F \u09AA\u09CD\u09B0\u09A6\u09C7\u09DF \u09B9\u09AC\u09C7\u0964"), /*#__PURE__*/React.createElement("li", null, "\u09E9\u0964 \u0989\u09AA\u09AF\u09C1\u0995\u09CD\u09A4 \u09A8\u09BF\u09B0\u09CD\u09AD\u09B0\u09B6\u09C0\u09B2 \u09AC\u09CD\u09AF\u0995\u09CD\u09A4\u09BF\u09B0 \u099C\u09C0\u09AC\u09A8\u09BE\u09AC\u09B8\u09CD\u09A5\u09BE\u09B0 \u0995\u09CB\u09A8 \u09AA\u09B0\u09BF\u09AC\u09B0\u09CD\u09A4\u09A8 \u0998\u099F\u09B2\u09C7 (\u09AE\u09C3\u09A4\u09CD\u09AF\u09C1) \u0987.\u0986\u0987.\u098F\u09B8 \u09AA\u09BE\u0987\u09B2\u099F \u09B8\u09CD\u09AA\u09C7\u09B6\u09BE\u09B2 \u0987\u0989\u09A8\u09BF\u099F\u0995\u09C7 \u0985\u09AC\u09B6\u09CD\u09AF\u0987 \u0985\u09AC\u09B9\u09BF\u09A4 \u0995\u09B0\u09A4\u09C7 \u09B9\u09AC\u09C7\u0964 \u098F\u0995\u09CD\u09B7\u09C7\u09A4\u09CD\u09B0\u09C7 \u09AF\u09BE\u099A\u09BE\u0987\u0995\u09B0\u09A3 \u09B8\u0982\u0995\u09CD\u09B0\u09BE\u09A8\u09CD\u09A4 \u09AA\u09CD\u09B0\u09AE\u09BE\u09A3\u09AA\u09A4\u09CD\u09B0 \u09AA\u09CD\u09B0\u09A4\u09BF \u09AC\u099B\u09B0\u09BE\u09A8\u09CD\u09A4\u09C7 \u0987.\u0986\u0987.\u098F\u09B8 \u09AA\u09BE\u0987\u09B2\u099F \u09B8\u09CD\u09AA\u09C7\u09B6\u09BE\u09B2 \u0987\u0989\u09A8\u09BF\u099F\u0995\u09C7 \u09AA\u09CD\u09B0\u09A6\u09BE\u09A8 \u0995\u09B0\u09A4\u09C7 \u09B9\u09AC\u09C7\u0964"), /*#__PURE__*/React.createElement("li", null, "\u09EA\u0964 \u09A4\u09C8\u09B0\u09C0 \u09AA\u09CB\u09B6\u09BE\u0995 \u09B6\u09BF\u09B2\u09CD\u09AA\u09C7\u09B0 \u0995\u09CD\u09B0\u09C7\u09A4\u09BE/\u09AC\u09CD\u09B0\u09CD\u09AF\u09BE\u09A8\u09CD\u09A1\u09B0\u09BE \u09B8\u09CD\u09AC\u09C7\u099A\u09CD\u099B\u09BE\u09DF \u098F\u09AC\u0982 \u09B8\u09BE\u09AE\u09DF\u09BF\u0995 \u09AD\u09BF\u09A4\u09CD\u09A4\u09BF\u09A4\u09C7/ \u0985\u09A8\u09CD\u09A4\u09B0\u09CD\u09AC\u09B0\u09CD\u09A4\u09C0\u0995\u09BE\u09B2\u09C0\u09A8 \u09B8\u09AE\u09BE\u09A7\u09BE\u09A8 \u09B9\u09BF\u09B8\u09C7\u09AC\u09C7 \u099F\u09AA-\u0986\u09AA \u09AC\u09C7\u09A8\u09BF\u09AB\u09BF\u099F \u09AA\u09CD\u09B0\u09A6\u09BE\u09A8\u09C7\u09B0 \u099C\u09A8\u09CD\u09AF \u0987.\u0986\u0987.\u098F\u09B8 \u09AA\u09BE\u0987\u09B2\u099F\u0995\u09C7 \u0985\u09B0\u09CD\u09A5\u09BE\u09DF\u09A8 \u0995\u09B0\u099B\u09C7\u0964")));
    } else if (relation === "workforce.relation.grand_son" && age < 18) {
      return /*#__PURE__*/React.createElement(FooterWrapper, null, /*#__PURE__*/React.createElement("ol", {
        style: {
          listStyle: "none",
          paddingLeft: "20px",
          marginTop: "5px"
        }
      }, /*#__PURE__*/React.createElement("li", null, "\u09E7\u0964 \u099F\u09AA-\u0986\u09AA \u09AC\u09C7\u09A8\u09BF\u09AB\u09BF\u099F \u09AE\u09BE\u09B8\u09BF\u0995\u09AD\u09BF\u09A4\u09CD\u09A4\u09BF\u09A4\u09C7 \u09AA\u09CD\u09B0\u09A6\u09BE\u09A8 \u0995\u09B0\u09BE \u09B9\u09AC\u09C7 \u09AF\u09A4\u0995\u09CD\u09B7\u09A3 \u09A8\u09BE\u2014", /*#__PURE__*/React.createElement("ol", {
        style: {
          listStyle: "none",
          paddingLeft: "20px",
          marginTop: "5px"
        }
      }, /*#__PURE__*/React.createElement("li", null, "\u0989\u09AA\u09AF\u09C1\u0995\u09CD\u09A4 \u09A8\u09BF\u09B0\u09CD\u09AD\u09B0\u09B6\u09C0\u09B2 \u09AC\u09CD\u09AF\u0995\u09CD\u09A4\u09BF \u09AE\u09C3\u09A4\u09CD\u09AF\u09C1\u09AC\u09B0\u09A3 \u0995\u09B0\u09C7\u09A8; \u0985\u09A5\u09AC\u09BE"), /*#__PURE__*/React.createElement("li", null, "\u09AA\u09CD\u09B0\u09BE\u09AA\u09CD\u09A4\u09AC\u09DF\u09B8\u09CD\u0995 (\u09E7\u09EE \u09AC\u099B\u09B0) \u09B9\u0993\u09DF\u09BE \u09AA\u09B0\u09CD\u09AF\u09A8\u09CD\u09A4 \u09AC\u09C7\u09A8\u09BF\u09AB\u09BF\u099F \u09AA\u09BE\u09AC\u09C7\u09A8\u0964"))), /*#__PURE__*/React.createElement("li", null, "\u09E8\u0964 \u0985\u09AA\u09CD\u09B0\u09BE\u09AA\u09CD\u09A4\u09AC\u09DF\u09B8\u09CD\u0995 \u0989\u09AA\u09AF\u09C1\u0995\u09CD\u09A4 \u09A8\u09BF\u09B0\u09CD\u09AD\u09B0\u09B6\u09C0\u09B2 \u09AC\u09CD\u09AF\u0995\u09CD\u09A4\u09BF\u09B0 \u09AA\u09CD\u09B0\u09BE\u09AA\u09CD\u09AF \u09AC\u09C7\u09A8\u09BF\u09AB\u09BF\u099F \u09A4\u09BE\u09B0 \u0986\u0987\u09A8\u0997\u09A4 \u0985\u09AD\u09BF\u09AD\u09BE\u09AC\u0995\u09C7\u09B0 \u098F\u0995\u09BE\u0989\u09A8\u09CD\u099F\u09C7 \u09AA\u09B0\u09BF\u09B6\u09CB\u09A7 \u0995\u09B0\u09BE \u09AF\u09BE\u09AC\u09C7\u0964"), /*#__PURE__*/React.createElement("li", null, "\u09E9\u0964 \u0989\u09AA\u09AF\u09C1\u0995\u09CD\u09A4 \u09A8\u09BF\u09B0\u09CD\u09AD\u09B0\u09B6\u09C0\u09B2 \u09AC\u09CD\u09AF\u0995\u09CD\u09A4\u09BF\u09B0 \u099C\u09C0\u09AC\u09A8\u09BE\u09AC\u09B8\u09CD\u09A5\u09BE\u09B0 \u0995\u09CB\u09A8 \u09AA\u09B0\u09BF\u09AC\u09B0\u09CD\u09A4\u09A8 \u0998\u099F\u09B2\u09C7 (\u09AE\u09C3\u09A4\u09CD\u09AF\u09C1) \u0987.\u0986\u0987.\u098F\u09B8 \u09AA\u09BE\u0987\u09B2\u099F \u09B8\u09CD\u09AA\u09C7\u09B6\u09BE\u09B2 \u0987\u0989\u09A8\u09BF\u099F\u0995\u09C7 \u0985\u09AC\u09B6\u09CD\u09AF\u0987 \u0985\u09AC\u09B9\u09BF\u09A4 \u0995\u09B0\u09A4\u09C7 \u09B9\u09AC\u09C7\u0964 \u098F\u0995\u09CD\u09B7\u09C7\u09A4\u09CD\u09B0\u09C7 \u09AF\u09BE\u099A\u09BE\u0987\u0995\u09B0\u09A3 \u09B8\u0982\u0995\u09CD\u09B0\u09BE\u09A8\u09CD\u09A4 \u09AA\u09CD\u09B0\u09AE\u09BE\u09A3\u09AA\u09A4\u09CD\u09B0 \u09AA\u09CD\u09B0\u09A4\u09BF \u09AC\u099B\u09B0\u09BE\u09A8\u09CD\u09A4\u09C7 \u0987.\u0986\u0987.\u098F\u09B8 \u09AA\u09BE\u0987\u09B2\u099F \u09B8\u09CD\u09AA\u09C7\u09B6\u09BE\u09B2 \u0987\u0989\u09A8\u09BF\u099F\u0995\u09C7 \u09AA\u09CD\u09B0\u09A6\u09BE\u09A8 \u0995\u09B0\u09A4\u09C7 \u09B9\u09AC\u09C7\u0964"), /*#__PURE__*/React.createElement("li", null, "\u09EA\u0964 \u09A4\u09C8\u09B0\u09C0 \u09AA\u09CB\u09B6\u09BE\u0995 \u09B6\u09BF\u09B2\u09CD\u09AA\u09C7\u09B0 \u0995\u09CD\u09B0\u09C7\u09A4\u09BE/\u09AC\u09CD\u09B0\u09CD\u09AF\u09BE\u09A8\u09CD\u09A1\u09B0\u09BE \u09B8\u09CD\u09AC\u09C7\u099A\u09CD\u099B\u09BE\u09DF \u098F\u09AC\u0982 \u09B8\u09BE\u09AE\u09DF\u09BF\u0995 \u09AD\u09BF\u09A4\u09CD\u09A4\u09BF\u09A4\u09C7/\u0985\u09A8\u09CD\u09A4\u09B0\u09CD\u09AC\u09B0\u09CD\u09A4\u09C0\u0995\u09BE\u09B2\u09C0\u09A8 \u09B8\u09AE\u09BE\u09A7\u09BE\u09A8 \u09B9\u09BF\u09B8\u09C7\u09AC\u09C7 \u099F\u09AA-\u0986\u09AA \u09AC\u09C7\u09A8\u09BF\u09AB\u09BF\u099F \u09AA\u09CD\u09B0\u09A6\u09BE\u09A8\u09C7\u09B0 \u099C\u09A8\u09CD\u09AF \u0987.\u0986\u0987.\u098F\u09B8 \u09AA\u09BE\u0987\u09B2\u099F\u0995\u09C7 \u0985\u09B0\u09CD\u09A5\u09BE\u09DF\u09A8 \u0995\u09B0\u099B\u09C7\u0964")));
    } else if (relation === "workforce.relation.grand_daughter" && age < 18) {
      return /*#__PURE__*/React.createElement(FooterWrapper, null, /*#__PURE__*/React.createElement("ol", {
        style: {
          listStyle: "none",
          paddingLeft: "20px",
          marginTop: "5px"
        }
      }, /*#__PURE__*/React.createElement("li", null, "\u09E7\u0964 \u099F\u09AA-\u0986\u09AA \u09AC\u09C7\u09A8\u09BF\u09AB\u09BF\u099F \u09AE\u09BE\u09B8\u09BF\u0995\u09AD\u09BF\u09A4\u09CD\u09A4\u09BF\u09A4\u09C7 \u09AA\u09CD\u09B0\u09A6\u09BE\u09A8 \u0995\u09B0\u09BE \u09B9\u09AC\u09C7 \u09AF\u09A4\u0995\u09CD\u09B7\u09A3 \u09A8\u09BE\u2014", /*#__PURE__*/React.createElement("ol", {
        style: {
          listStyleType: "none",
          paddingLeft: "20px",
          marginTop: "5px"
        }
      }, /*#__PURE__*/React.createElement("li", null, "\u0995. \u0989\u09AA\u09AF\u09C1\u0995\u09CD\u09A4 \u09A8\u09BF\u09B0\u09CD\u09AD\u09B0\u09B6\u09C0\u09B2 \u09AC\u09CD\u09AF\u0995\u09CD\u09A4\u09BF \u09AE\u09C3\u09A4\u09CD\u09AF\u09C1\u09AC\u09B0\u09A3 \u0995\u09B0\u09C7\u09A8; \u0985\u09A5\u09AC\u09BE"), /*#__PURE__*/React.createElement("li", null, "\u0996. \u09AC\u09BF\u09AC\u09BE\u09B9 \u09AC\u09A8\u09CD\u09A7\u09A8\u09C7 \u0986\u09AC\u09A6\u09CD\u09A7 \u09A8\u09BE \u09B9\u0993\u09DF\u09BE \u09AA\u09B0\u09CD\u09AF\u09A8\u09CD\u09A4 \u09AC\u09C7\u09A8\u09BF\u09AB\u09BF\u099F \u09AA\u09BE\u09AC\u09C7\u09A8\u0964"))), /*#__PURE__*/React.createElement("li", null, "\u09E8\u0964 \u0985\u09AA\u09CD\u09B0\u09BE\u09AA\u09CD\u09A4\u09AC\u09DF\u09B8\u09CD\u0995 \u0989\u09AA\u09AF\u09C1\u0995\u09CD\u09A4 \u09A8\u09BF\u09B0\u09CD\u09AD\u09B0\u09B6\u09C0\u09B2 \u09AC\u09CD\u09AF\u0995\u09CD\u09A4\u09BF\u09B0 \u09AA\u09CD\u09B0\u09BE\u09AA\u09CD\u09AF \u09AC\u09C7\u09A8\u09BF\u09AB\u09BF\u099F \u09A4\u09BE\u09B0 \u0986\u0987\u09A8\u0997\u09A4 \u0985\u09AD\u09BF\u09AD\u09BE\u09AC\u0995\u09C7\u09B0 \u098F\u0995\u09BE\u0989\u09A8\u09CD\u099F\u09C7 \u09AA\u09B0\u09BF\u09B6\u09CB\u09A7 \u0995\u09B0\u09BE \u09AF\u09BE\u09AC\u09C7\u0964"), /*#__PURE__*/React.createElement("li", null, "\u09E9\u0964 \u0989\u09AA\u09AF\u09C1\u0995\u09CD\u09A4 \u09A8\u09BF\u09B0\u09CD\u09AD\u09B0\u09B6\u09C0\u09B2 \u09AC\u09CD\u09AF\u0995\u09CD\u09A4\u09BF\u09B0 \u099C\u09C0\u09AC\u09A8\u09BE\u09AC\u09B8\u09CD\u09A5\u09BE\u09B0 \u0995\u09CB\u09A8 \u09AA\u09B0\u09BF\u09AC\u09B0\u09CD\u09A4\u09A8 \u0998\u099F\u09B2\u09C7 (\u09AE\u09C3\u09A4\u09CD\u09AF\u09C1/\u09AC\u09BF\u09AC\u09BE\u09B9) \u0987.\u0986\u0987.\u098F\u09B8 \u09AA\u09BE\u0987\u09B2\u099F \u09B8\u09CD\u09AA\u09C7\u09B6\u09BE\u09B2 \u0987\u0989\u09A8\u09BF\u099F\u0995\u09C7 \u0985\u09AC\u09B6\u09CD\u09AF\u0987 \u0985\u09AC\u09B9\u09BF\u09A4 \u0995\u09B0\u09A4\u09C7 \u09B9\u09AC\u09C7\u0964 \u098F\u0995\u09CD\u09B7\u09C7\u09A4\u09CD\u09B0\u09C7 \u09AF\u09BE\u099A\u09BE\u0987\u0995\u09B0\u09A3 \u09B8\u0982\u0995\u09CD\u09B0\u09BE\u09A8\u09CD\u09A4 \u09AA\u09CD\u09B0\u09AE\u09BE\u09A3\u09AA\u09A4\u09CD\u09B0 \u09AA\u09CD\u09B0\u09A4\u09BF \u09AC\u099B\u09B0\u09BE\u09A8\u09CD\u09A4\u09C7 \u0987.\u0986\u0987.\u098F\u09B8 \u09AA\u09BE\u0987\u09B2\u099F \u09B8\u09CD\u09AA\u09C7\u09B6\u09BE\u09B2 \u0987\u0989\u09A8\u09BF\u099F\u0995\u09C7 \u09AA\u09CD\u09B0\u09A6\u09BE\u09A8 \u0995\u09B0\u09A4\u09C7 \u09B9\u09AC\u09C7\u0964"), /*#__PURE__*/React.createElement("li", null, "\u09EA\u0964 \u09A4\u09C8\u09B0\u09C0 \u09AA\u09CB\u09B6\u09BE\u0995 \u09B6\u09BF\u09B2\u09CD\u09AA\u09C7\u09B0 \u0995\u09CD\u09B0\u09C7\u09A4\u09BE/\u09AC\u09CD\u09B0\u09CD\u09AF\u09BE\u09A8\u09CD\u09A1\u09B0\u09BE \u09B8\u09CD\u09AC\u09C7\u099A\u09CD\u099B\u09BE\u09DF \u098F\u09AC\u0982 \u09B8\u09BE\u09AE\u09DF\u09BF\u0995 \u09AD\u09BF\u09A4\u09CD\u09A4\u09BF\u09A4\u09C7/\u0985\u09A8\u09CD\u09A4\u09B0\u09CD\u09AC\u09B0\u09CD\u09A4\u09C0\u0995\u09BE\u09B2\u09C0\u09A8 \u09B8\u09AE\u09BE\u09A7\u09BE\u09A8 \u09B9\u09BF\u09B8\u09C7\u09AC\u09C7 \u099F\u09AA-\u0986\u09AA \u09AC\u09C7\u09A8\u09BF\u09AB\u09BF\u099F \u09AA\u09CD\u09B0\u09A6\u09BE\u09A8\u09C7\u09B0 \u099C\u09A8\u09CD\u09AF \u0987.\u0986\u0987.\u098F\u09B8 \u09AA\u09BE\u0987\u09B2\u099F\u0995\u09C7 \u0985\u09B0\u09CD\u09A5\u09BE\u09DF\u09A8 \u0995\u09B0\u099B\u09C7\u0964")));
    } else if (relation === "workforce.relation.grand_son_from_daughter" && age < 18) {
      return /*#__PURE__*/React.createElement(FooterWrapper, null, /*#__PURE__*/React.createElement("ol", {
        style: {
          listStyle: "none",
          paddingLeft: "20px",
          marginTop: "5px"
        }
      }, /*#__PURE__*/React.createElement("li", null, "\u09E7\u0964 \u099F\u09AA-\u0986\u09AA \u09AC\u09C7\u09A8\u09BF\u09AB\u09BF\u099F \u09AE\u09BE\u09B8\u09BF\u0995\u09AD\u09BF\u09A4\u09CD\u09A4\u09BF\u09A4\u09C7 \u09AA\u09CD\u09B0\u09A6\u09BE\u09A8 \u0995\u09B0\u09BE \u09B9\u09AC\u09C7 \u09AF\u09A4\u0995\u09CD\u09B7\u09A3 \u09A8\u09BE\u2014", /*#__PURE__*/React.createElement("ol", {
        style: {
          listStyle: "none",
          paddingLeft: "20px",
          marginTop: "5px"
        }
      }, /*#__PURE__*/React.createElement("li", null, "\u0995. \u0989\u09AA\u09AF\u09C1\u0995\u09CD\u09A4 \u09A8\u09BF\u09B0\u09CD\u09AD\u09B0\u09B6\u09C0\u09B2 \u09AC\u09CD\u09AF\u0995\u09CD\u09A4\u09BF \u09AE\u09C3\u09A4\u09CD\u09AF\u09C1\u09AC\u09B0\u09A3 \u0995\u09B0\u09C7\u09A8; \u0985\u09A5\u09AC\u09BE"), /*#__PURE__*/React.createElement("li", null, "\u0996. \u09AA\u09CD\u09B0\u09BE\u09AA\u09CD\u09A4\u09AC\u09DF\u09B8\u09CD\u0995 (\u09E7\u09EE \u09AC\u099B\u09B0) \u09B9\u0993\u09DF\u09BE \u09AA\u09B0\u09CD\u09AF\u09A8\u09CD\u09A4 \u09AC\u09C7\u09A8\u09BF\u09AB\u09BF\u099F \u09AA\u09BE\u09AC\u09C7\u09A8\u0964"))), /*#__PURE__*/React.createElement("li", null, "\u09E8\u0964 \u0985\u09AA\u09CD\u09B0\u09BE\u09AA\u09CD\u09A4\u09AC\u09DF\u09B8\u09CD\u0995 \u0989\u09AA\u09AF\u09C1\u0995\u09CD\u09A4 \u09A8\u09BF\u09B0\u09CD\u09AD\u09B0\u09B6\u09C0\u09B2 \u09AC\u09CD\u09AF\u0995\u09CD\u09A4\u09BF\u09B0 \u09AA\u09CD\u09B0\u09BE\u09AA\u09CD\u09AF \u09AC\u09C7\u09A8\u09BF\u09AB\u09BF\u099F \u09A4\u09BE\u09B0 \u0986\u0987\u09A8\u0997\u09A4 \u0985\u09AD\u09BF\u09AD\u09BE\u09AC\u0995\u09C7\u09B0 \u098F\u0995\u09BE\u0989\u09A8\u09CD\u099F\u09C7 \u09AA\u09B0\u09BF\u09B6\u09CB\u09A7 \u0995\u09B0\u09BE \u09AF\u09BE\u09AC\u09C7\u0964"), /*#__PURE__*/React.createElement("li", null, "\u09E9\u0964 \u0989\u09AA\u09AF\u09C1\u0995\u09CD\u09A4 \u09A8\u09BF\u09B0\u09CD\u09AD\u09B0\u09B6\u09C0\u09B2 \u09AC\u09CD\u09AF\u0995\u09CD\u09A4\u09BF\u09B0 \u099C\u09C0\u09AC\u09A8\u09BE\u09AC\u09B8\u09CD\u09A5\u09BE\u09B0 \u0995\u09CB\u09A8 \u09AA\u09B0\u09BF\u09AC\u09B0\u09CD\u09A4\u09A8 \u0998\u099F\u09B2\u09C7 (\u09AE\u09C3\u09A4\u09CD\u09AF\u09C1) \u0987.\u0986\u0987.\u098F\u09B8 \u09AA\u09BE\u0987\u09B2\u099F \u09B8\u09CD\u09AA\u09C7\u09B6\u09BE\u09B2 \u0987\u0989\u09A8\u09BF\u099F\u0995\u09C7 \u0985\u09AC\u09B6\u09CD\u09AF\u0987 \u0985\u09AC\u09B9\u09BF\u09A4 \u0995\u09B0\u09A4\u09C7 \u09B9\u09AC\u09C7\u0964 \u098F\u0995\u09CD\u09B7\u09C7\u09A4\u09CD\u09B0\u09C7 \u09AF\u09BE\u099A\u09BE\u0987\u0995\u09B0\u09A3 \u09B8\u0982\u0995\u09CD\u09B0\u09BE\u09A8\u09CD\u09A4 \u09AA\u09CD\u09B0\u09AE\u09BE\u09A3\u09AA\u09A4\u09CD\u09B0 \u09AA\u09CD\u09B0\u09A4\u09BF \u09AC\u099B\u09B0\u09BE\u09A8\u09CD\u09A4\u09C7 \u0987.\u0986\u0987.\u098F\u09B8 \u09AA\u09BE\u0987\u09B2\u099F \u09B8\u09CD\u09AA\u09C7\u09B6\u09BE\u09B2 \u0987\u0989\u09A8\u09BF\u099F\u0995\u09C7 \u09AA\u09CD\u09B0\u09A6\u09BE\u09A8 \u0995\u09B0\u09A4\u09C7 \u09B9\u09AC\u09C7\u0964"), /*#__PURE__*/React.createElement("li", null, "\u09EA\u0964 \u09A4\u09C8\u09B0\u09C0 \u09AA\u09CB\u09B6\u09BE\u0995 \u09B6\u09BF\u09B2\u09CD\u09AA\u09C7\u09B0 \u0995\u09CD\u09B0\u09C7\u09A4\u09BE/\u09AC\u09CD\u09B0\u09CD\u09AF\u09BE\u09A8\u09CD\u09A1\u09B0\u09BE \u09B8\u09CD\u09AC\u09C7\u099A\u09CD\u099B\u09BE\u09DF \u098F\u09AC\u0982 \u09B8\u09BE\u09AE\u09DF\u09BF\u0995 \u09AD\u09BF\u09A4\u09CD\u09A4\u09BF\u09A4\u09C7/\u0985\u09A8\u09CD\u09A4\u09B0\u09CD\u09AC\u09B0\u09CD\u09A4\u09C0\u0995\u09BE\u09B2\u09C0\u09A8 \u09B8\u09AE\u09BE\u09A7\u09BE\u09A8 \u09B9\u09BF\u09B8\u09C7\u09AC\u09C7 \u099F\u09AA-\u0986\u09AA \u09AC\u09C7\u09A8\u09BF\u09AB\u09BF\u099F \u09AA\u09CD\u09B0\u09A6\u09BE\u09A8\u09C7\u09B0 \u099C\u09A8\u09CD\u09AF \u0987.\u0986\u0987.\u098F\u09B8 \u09AA\u09BE\u0987\u09B2\u099F\u0995\u09C7 \u0985\u09B0\u09CD\u09A5\u09BE\u09DF\u09A8 \u0995\u09B0\u099B\u09C7\u0964")));
    } else if (relation === "workforce.relation.grand_daughter_from_daughter" && age < 18) {
      return /*#__PURE__*/React.createElement(FooterWrapper, null, /*#__PURE__*/React.createElement("ol", {
        style: {
          listStyle: "none",
          paddingLeft: "20px",
          marginTop: "5px"
        }
      }, /*#__PURE__*/React.createElement("li", null, "\u09E7\u0964 \u099F\u09AA-\u0986\u09AA \u09AC\u09C7\u09A8\u09BF\u09AB\u09BF\u099F \u09AE\u09BE\u09B8\u09BF\u0995\u09AD\u09BF\u09A4\u09CD\u09A4\u09BF\u09A4\u09C7 \u09AA\u09CD\u09B0\u09A6\u09BE\u09A8 \u0995\u09B0\u09BE \u09B9\u09AC\u09C7 \u09AF\u09A4\u0995\u09CD\u09B7\u09A3 \u09A8\u09BE\u2014", /*#__PURE__*/React.createElement("ol", {
        style: {
          listStyle: "none",
          paddingLeft: "20px",
          marginTop: "5px"
        }
      }, /*#__PURE__*/React.createElement("li", null, "\u0995. \u0989\u09AA\u09AF\u09C1\u0995\u09CD\u09A4 \u09A8\u09BF\u09B0\u09CD\u09AD\u09B0\u09B6\u09C0\u09B2 \u09AC\u09CD\u09AF\u0995\u09CD\u09A4\u09BF \u09AE\u09C3\u09A4\u09CD\u09AF\u09C1\u09AC\u09B0\u09A3 \u0995\u09B0\u09C7\u09A8; \u0985\u09A5\u09AC\u09BE"), /*#__PURE__*/React.createElement("li", null, "\u0996. \u09AC\u09BF\u09AC\u09BE\u09B9 \u09AC\u09A8\u09CD\u09A7\u09A8\u09C7 \u0986\u09AC\u09A6\u09CD\u09A7 \u09A8\u09BE \u09B9\u0993\u09DF\u09BE \u09AA\u09B0\u09CD\u09AF\u09A8\u09CD\u09A4 \u09AC\u09C7\u09A8\u09BF\u09AB\u09BF\u099F \u09AA\u09BE\u09AC\u09C7\u09A8\u0964"))), /*#__PURE__*/React.createElement("li", null, "\u09E8\u0964 \u0985\u09AA\u09CD\u09B0\u09BE\u09AA\u09CD\u09A4\u09AC\u09DF\u09B8\u09CD\u0995 \u0989\u09AA\u09AF\u09C1\u0995\u09CD\u09A4 \u09A8\u09BF\u09B0\u09CD\u09AD\u09B0\u09B6\u09C0\u09B2 \u09AC\u09CD\u09AF\u0995\u09CD\u09A4\u09BF\u09B0 \u09AA\u09CD\u09B0\u09BE\u09AA\u09CD\u09AF \u09AC\u09C7\u09A8\u09BF\u09AB\u09BF\u099F \u09A4\u09BE\u09B0 \u0986\u0987\u09A8\u0997\u09A4 \u0985\u09AD\u09BF\u09AD\u09BE\u09AC\u0995\u09C7\u09B0 \u098F\u0995\u09BE\u0989\u09A8\u09CD\u099F\u09C7 \u09AA\u09B0\u09BF\u09B6\u09CB\u09A7 \u0995\u09B0\u09BE \u09AF\u09BE\u09AC\u09C7\u0964"), /*#__PURE__*/React.createElement("li", null, "\u09E9\u0964 \u0989\u09AA\u09AF\u09C1\u0995\u09CD\u09A4 \u09A8\u09BF\u09B0\u09CD\u09AD\u09B0\u09B6\u09C0\u09B2 \u09AC\u09CD\u09AF\u0995\u09CD\u09A4\u09BF\u09B0 \u099C\u09C0\u09AC\u09A8\u09BE\u09AC\u09B8\u09CD\u09A5\u09BE\u09B0 \u0995\u09CB\u09A8 \u09AA\u09B0\u09BF\u09AC\u09B0\u09CD\u09A4\u09A8 \u0998\u099F\u09B2\u09C7 (\u09AE\u09C3\u09A4\u09CD\u09AF\u09C1/\u09AC\u09BF\u09AC\u09BE\u09B9) \u0987.\u0986\u0987.\u098F\u09B8 \u09AA\u09BE\u0987\u09B2\u099F \u09B8\u09CD\u09AA\u09C7\u09B6\u09BE\u09B2 \u0987\u0989\u09A8\u09BF\u099F\u0995\u09C7 \u0985\u09AC\u09B6\u09CD\u09AF\u0987 \u0985\u09AC\u09B9\u09BF\u09A4 \u0995\u09B0\u09A4\u09C7 \u09B9\u09AC\u09C7\u0964 \u098F\u0995\u09CD\u09B7\u09C7\u09A4\u09CD\u09B0\u09C7 \u09AF\u09BE\u099A\u09BE\u0987\u0995\u09B0\u09A3 \u09B8\u0982\u0995\u09CD\u09B0\u09BE\u09A8\u09CD\u09A4 \u09AA\u09CD\u09B0\u09AE\u09BE\u09A3\u09AA\u09A4\u09CD\u09B0 \u09AA\u09CD\u09B0\u09A4\u09BF \u09AC\u099B\u09B0\u09BE\u09A8\u09CD\u09A4\u09C7 \u0987.\u0986\u0987.\u098F\u09B8 \u09AA\u09BE\u0987\u09B2\u099F \u09B8\u09CD\u09AA\u09C7\u09B6\u09BE\u09B2 \u0987\u0989\u09A8\u09BF\u099F\u0995\u09C7 \u09AA\u09CD\u09B0\u09A6\u09BE\u09A8 \u0995\u09B0\u09A4\u09C7 \u09B9\u09AC\u09C7\u0964"), /*#__PURE__*/React.createElement("li", null, "\u09EA\u0964 \u09A4\u09C8\u09B0\u09C0 \u09AA\u09CB\u09B6\u09BE\u0995 \u09B6\u09BF\u09B2\u09CD\u09AA\u09C7\u09B0 \u0995\u09CD\u09B0\u09C7\u09A4\u09BE/\u09AC\u09CD\u09B0\u09CD\u09AF\u09BE\u09A8\u09CD\u09A1\u09B0\u09BE \u09B8\u09CD\u09AC\u09C7\u099A\u09CD\u099B\u09BE\u09DF \u098F\u09AC\u0982 \u09B8\u09BE\u09AE\u09DF\u09BF\u0995 \u09AD\u09BF\u09A4\u09CD\u09A4\u09BF\u09A4\u09C7/\u0985\u09A8\u09CD\u09A4\u09B0\u09CD\u09AC\u09B0\u09CD\u09A4\u09C0\u0995\u09BE\u09B2\u09C0\u09A8 \u09B8\u09AE\u09BE\u09A7\u09BE\u09A8 \u09B9\u09BF\u09B8\u09C7\u09AC\u09C7 \u099F\u09AA-\u0986\u09AA \u09AC\u09C7\u09A8\u09BF\u09AB\u09BF\u099F \u09AA\u09CD\u09B0\u09A6\u09BE\u09A8\u09C7\u09B0 \u099C\u09A8\u09CD\u09AF \u0987.\u0986\u0987.\u098F\u09B8 \u09AA\u09BE\u0987\u09B2\u099F\u0995\u09C7 \u0985\u09B0\u09CD\u09A5\u09BE\u09DF\u09A8 \u0995\u09B0\u099B\u09C7\u0964")));
    } else if (relation === "workforce.relation.daughter_in_law" && marital === "workforce.marital_status.widowed") {
      return "daughter in law noa";
    } else if (relation === "workforce.relation.illegitimate_son") {
      return "haram son noa";
    } else if (relation === "workforce.relation.illegitimate_daughter" && marital === "workforce.marital_status.single") {
      return "haram daughter noa";
    } else {
      return false;
    }
  }
}
var isDateDifference150Days = function isDateDifference150Days(date1, date2) {
  var days = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 150;
  if (!date1 || !date2) return false;
  var d1 = new Date(date1);
  var d2 = new Date(date2);

  // Check if dates are valid
  if (isNaN(d1.getTime()) || isNaN(d2.getTime())) {
    console.warn("Invalid date provided");
    return false;
  }

  // Calculate difference in milliseconds
  var diffTime = Math.abs(d2 - d1);

  // Convert to days
  var diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  return diffDays >= days; // Change to === if you want exactly 150 days
};
function calculateAge(birthDate) {
  if (!birthDate) return 0;
  var dob = new Date(birthDate);
  var today = new Date();
  var age = today.getFullYear() - dob.getFullYear();
  var monthDiff = today.getMonth() - dob.getMonth();
  if (monthDiff < 0 || monthDiff === 0 && today.getDate() < dob.getDate()) {
    age--;
  }
  return age;
}
// 1. Update calculateAge to accept an optional targetDate
function calculateAgeForDependent(birthDate) {
  var targetDate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Date();
  if (!birthDate) return 0;
  var dob = new Date(birthDate);
  var end = new Date(targetDate);
  var age = end.getFullYear() - dob.getFullYear();
  var monthDiff = end.getMonth() - dob.getMonth();
  if (monthDiff < 0 || monthDiff === 0 && end.getDate() < dob.getDate()) {
    age--;
  }
  return age;
}
function getRelationForApi(depObj, workerBirthDate, deathDate) {
  console.log("deps", depObj);
  var age = calculateAgeForDependent(depObj.birthDate, deathDate);
  var workerAge = calculateAgeForDependent(workerBirthDate);
  var relation = (depObj === null || depObj === void 0 ? void 0 : depObj.relationWithWorker) || (depObj === null || depObj === void 0 ? void 0 : depObj.relationType);
  var marital = depObj.maritalStatus;
  var disability = depObj.isDisabled;

  // if (relation !== "workforce.relation.wife" && age < 18 && marital === "workforce.marital_status.married") {
  //   return false;
  // }

  if (relation === "workforce.relation.wife") {
    return age >= 16 && marital === "workforce.marital_status.widow";
  } else if (relation === "workforce.relation.husband") {
    return age > 18 && marital === "workforce.marital_status.widower";
  } else if (relation === "workforce.relation.son") {
    if (age < 18) return true;
    if (age >= 18 && disability === "yes") return true;
    return false;
  } else if (relation === "workforce.relation.daughter") {
    return marital === "workforce.marital_status.single";
  } else if (relation === "workforce.relation.brother") {
    return age < 18;
  } else if (relation === "workforce.relation.sister") {
    return marital === "workforce.marital_status.single";
  } else if (relation === "workforce.relation.father") {
    return age > workerAge;
  } else if (relation === "workforce.relation.mother") {
    return age > workerAge;
  } else if (relation === "workforce.relation.grand_father") {
    return true;
  } else if (relation === "workforce.relation.grand_mother") {
    return true;
  } else if (relation === "workforce.relation.grand_son") {
    return age < 18;
  } else if (relation === "workforce.relation.grand_daughter") {
    return age < 18;
  } else if (relation === "workforce.relation.grand_son_from_daughter") {
    return age < 18;
  } else if (relation === "workforce.relation.grand_daughter_from_daughter") {
    return age < 18;
  } else if (relation === "workforce.relation.daughter_in_law") {
    return marital === "workforce.marital_status.widowed";
  } else if (relation === "workforce.relation.illegitimate_son") {
    return true;
  } else if (relation === "workforce.relation.illegitimate_daughter") {
    return marital === "workforce.marital_status.single";
  } else {
    return false;
  }
}

// -----------------------------
// Reusable Wrapper
// -----------------------------
var FooterWrapper = function FooterWrapper(_ref2) {
  var children = _ref2.children;
  return /*#__PURE__*/React.createElement("div", {
    style: {
      marginTop: "15px"
    }
  }, /*#__PURE__*/React.createElement("strong", null, "\u09AE\u09BE\u09B8\u09BF\u0995 \u099F\u09AA-\u0986\u09AA \u09AC\u09C7\u09A8\u09BF\u09AB\u09BF\u099F \u0993 \u0987.\u0986\u0987.\u098F\u09B8 \u09AA\u09BE\u0987\u09B2\u099F \u09B8\u09AE\u09CD\u09AA\u09B0\u09CD\u0995\u09C7 \u0997\u09C1\u09B0\u09C1\u09A4\u09CD\u09AC\u09AA\u09C2\u09B0\u09CD\u09A3 \u09A4\u09A5\u09CD\u09AF:"), /*#__PURE__*/React.createElement("ol", {
    style: {
      marginTop: "5px",
      paddingLeft: "20px"
    }
  }, children));
};
var getPaymentTypeString = function getPaymentTypeString(paymentType) {
  if (paymentType === "monthly") {
    return "Monthly";
  } else if (paymentType === "onetime") {
    return "One Time";
  } else if (paymentType === "installment") {
    return "Tri Monthly Installment";
  }
};
var getRelationString = function getRelationString(depObj) {
  var age = calculateAge(depObj.birthDate);
  var relation = depObj.relationWithWorker;
  var marital = depObj.maritalStatus;
  var disability = depObj.disabilityStatus;
  if (relation === "workforce.relation.brother") {
    return age < 18 ? "Dependent minor brother" : null;
  } else if (relation === "workforce.relation.sister") {
    if (age < 18) {
      return "Dependent minor sister";
    } else if (marital === "workforce.marital_status.single") {
      return "Dependent unmarried sister";
    } else if (marital === "workforce.marital_status.widowed") {
      return "Dependent widowed sister";
    }
    return null;
  } else if (relation === "workforce.relation.daughter") {
    if (disability === "yes") {
      return "Dependent disabled daughter";
    } else if (age < 18) {
      return "Minor daughter";
    } else if (marital === "workforce.marital_status.single") {
      return "Unmarried daughter";
    } else if (marital === "workforce.marital_status.widowed") {
      return "Dependent widowed daughter";
    }
    return null;
  } else if (relation === "workforce.relation.son") {
    if (disability === "yes") {
      return "Dependent disabled son";
    } else if (age < 18) {
      return "Minor son";
    }
    return null;
  } else if (relation === "workforce.relation.husband") {
    return "Dependent widower";
  } else if (relation === "workforce.relation.wife") {
    return "Widow";
  } else if (relation === "workforce.relation.father") {
    return "Dependent father";
  } else if (relation === "workforce.relation.mother") {
    return "Mother";
  } else if (relation === "workforce.relation.grand_father") {
    return "Dependent paternal grandfather";
  } else if (relation === "workforce.relation.grand_mother") {
    return "Dependent paternal grandmother";
  } else if (relation === "workforce.relation.grand_son") {
    return age < 18 ? "Dependent minor son of a deceased son" : null;
  } else if (relation === "workforce.relation.grand_daughter") {
    return age < 18 ? "Dependent minor daughter of a deceased son" : null;
  } else if (relation === "workforce.relation.grand_son_from_daughter") {
    return age < 18 ? "Dependent minor son of a deceased daughter" : null;
  } else if (relation === "workforce.relation.grand_daughter_from_daughter") {
    return age < 18 ? "Dependent minor daughter of a deceased daughter" : null;
  } else if (relation === "workforce.relation.daughter_in_law") {
    return marital === "workforce.marital_status.widowed" ? "Dependent widowed daughter-in-law" : null;
  } else if (relation === "workforce.relation.illegitimate_son") {
    return "Dependent son born out of wedlock";
  } else if (relation === "workforce.relation.illegitimate_daughter") {
    return marital === "workforce.marital_status.single" ? "Dependent unmarried daughter born out of wedlock" : null;
  }
  return null;
};
function validateMandatoryDocuments(type1Array, type2Array) {
  var errors = [];
  var _iterator = _createForOfIteratorHelper$d(type1Array),
    _step;
  try {
    var _loop = function _loop() {
      var docConfig = _step.value;
      if (docConfig.mandatoryForApplicant === true) {
        var isUploaded = type2Array.some(function (uploadedDoc) {
          return uploadedDoc.documentType === docConfig.documentType;
        });
        if (!isUploaded) {
          errors.push({
            documentType: docConfig.documentType,
            message: "Missing mandatory document: ".concat(docConfig.nameEn, " (").concat(docConfig.nameBn, ")")
          });
        }
      }
    };
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      _loop();
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return errors.length > 0 ? {
    isValid: false,
    errors: errors
  } : {
    isValid: true,
    errors: null
  };
}
function validateMandatoryDocumentsForDependents(documentConfigs,
// documentType from Redux (type1Array)
uploadedFiles,
// uploadDependentFile (pending uploads)
dependents // formData.dependents (contains attachments when saved/loaded)
) {
  var allErrors = [];
  dependents.forEach(function (dep, index) {
    if (!dep) return;
    var isDisabled = dep.isDisabled === "yes"; // key missing or "no" → false

    // Build required documents for THIS dependent
    var requiredConfigs = documentConfigs.filter(function (doc) {
      if (doc.mandatoryForApplicant !== true) return false;
      if (doc.documentType === "disability_certificate" && !isDisabled) return false;
      return true;
    });
    var depPrefix = "dependent_".concat(index, "_");

    // 1. Pending uploads (newly selected files)
    var pending = (uploadedFiles || []).filter(function (f) {
      var _f$fieldKey;
      return (_f$fieldKey = f.fieldKey) === null || _f$fieldKey === void 0 ? void 0 : _f$fieldKey.startsWith(depPrefix);
    });

    // 2. Already saved attachments (from your JSON)
    var saved = (dep.attachments || []).filter(function (att) {
      var _att$fieldKey;
      return (_att$fieldKey = att.fieldKey) === null || _att$fieldKey === void 0 ? void 0 : _att$fieldKey.startsWith(depPrefix);
    });

    // Combine both sources
    var allFilesForThisDep = [].concat(_toConsumableArray(pending), _toConsumableArray(saved));

    // Check every required document
    requiredConfigs.forEach(function (docConfig) {
      var hasFile = allFilesForThisDep.some(function (item) {
        var hasMatchingType = item.documentType === docConfig.documentType;
        if (!hasMatchingType) {
          return false;
        }
        if (Array.isArray(item.files)) {
          return item.files.length > 0;
        }
        return !!(item.path || item.url || item.name);
      });
      if (!hasFile) {
        allErrors.push({
          dependentIndex: index,
          dependentName: dep.nameEn || dep.nameBn || "Dependent ".concat(index + 1),
          documentType: docConfig.documentType,
          message: "Missing mandatory document for ".concat(dep.nameEn || "Dependent ".concat(index + 1), ": ").concat(docConfig.nameEn, " (").concat(docConfig.nameBn, ")")
        });
      }
    });
  });
  return allErrors.length > 0 ? {
    isValid: false,
    errors: allErrors
  } : {
    isValid: true,
    errors: null
  };
}
var validateMandatoryBankDocumentsForAccounts = function validateMandatoryBankDocumentsForAccounts(docsConfig, uploadedBankFiles, bankAccounts) {
  var errors = [];
  var accounts = Array.isArray(bankAccounts) ? bankAccounts : [];
  accounts.forEach(function (account, accountIndex) {
    var accountPrefix = "account_".concat(accountIndex, "_");
    var pending = (uploadedBankFiles || []).filter(function (file) {
      var _file$fieldKey;
      return (_file$fieldKey = file.fieldKey) === null || _file$fieldKey === void 0 ? void 0 : _file$fieldKey.startsWith(accountPrefix);
    });
    var saved = (account !== null && account !== void 0 && account.attachments && typeof account.attachments === "string" ? JSON.parse(account.attachments) : (account === null || account === void 0 ? void 0 : account.attachments) || []).filter(function (att) {
      var _att$fieldKey2;
      return (_att$fieldKey2 = att.fieldKey) === null || _att$fieldKey2 === void 0 ? void 0 : _att$fieldKey2.startsWith(accountPrefix);
    });
    var allFilesForAccount = [].concat(_toConsumableArray(pending), _toConsumableArray(saved));
    docsConfig.forEach(function (docConfig) {
      var hasFile = allFilesForAccount.some(function (item) {
        var typeMatches = item.documentType === docConfig.documentType;
        if (!typeMatches) return false;
        if (Array.isArray(item.files)) return item.files.length > 0;
        return !!(item.path || item.url || item.name);
      });
      if (!hasFile) {
        errors.push({
          accountIndex: accountIndex,
          documentType: docConfig.documentType,
          message: "Missing mandatory bank document for account ".concat(accountIndex + 1, ": ").concat(docConfig.nameEn, " (").concat(docConfig.nameBn, ")")
        });
      }
    });
  });
  return errors.length > 0 ? {
    isValid: false,
    errors: errors
  } : {
    isValid: true,
    errors: null
  };
};
var toBanglaNumber = function toBanglaNumber(str) {
  var banglaDigits = ["০", "১", "২", "৩", "৪", "৫", "৬", "৭", "৮", "৯"];
  return str.toString().replace(/\d/g, function (d) {
    return banglaDigits[d];
  });
};
var fixBrokenUnicode = function fixBrokenUnicode(text) {
  if (typeof text !== "string") return text;

  // Add missing backslash before uXXXX patterns
  var fixed = text.replace(/u([0-9a-fA-F]{4})/g, "\\u$1");
  try {
    return JSON.parse("\"".concat(fixed, "\""));
  } catch (_unused2) {
    return text;
  }
};
var isVerify = function isVerify() {
  if (typeof window !== "undefined") {
    return window.location.href.includes("verify");
  }
  return false; // fallback if window is not defined
};
var formatLabel = function formatLabel(str) {
  return str.replace(/_/g, " ") // replace underscores with spaces
  .replace(/\b\w/g, function (c) {
    return c.toUpperCase();
  }); // capitalize each word
};
var getReturnUrl = function getReturnUrl() {
  var params = new URLSearchParams(window.location.search);
  if (params.has('from')) {
    var from = params.get('from');
    if (from === "eis-site") {
      return "https://mis.eis-pilot-bd.org";
    } else {
      if (window.location.href.includes("skydigitalbd.com") || window.location.href.includes("localhost")) {
        return "https://cf-site-stage.skydigitalbd.com";
      } else {
        return "https://labourwelfare.gov.bd";
      }
    }
  } else {
    if (window.location.href.includes("skydigitalbd.com") || window.location.href.includes("localhost")) {
      return "https://cf-site-stage.skydigitalbd.com";
    } else {
      return "https://labourwelfare.gov.bd";
    }
  }
};
var formatAddress$3 = function formatAddress(locationData, addressData) {
  var _address$postOffice, _location$parent, _location$parent2, _location$parent3;
  var address = tryParse$1(addressData) || {};
  var location = tryParse$1(locationData) || {};
  var postOffice = (address === null || address === void 0 || (_address$postOffice = address.postOffice) === null || _address$postOffice === void 0 ? void 0 : _address$postOffice.nameBn) || (address === null || address === void 0 ? void 0 : address.postOffice);
  var village = [address.houseName, address.paraMahalla, address.villageRoad].filter(Boolean).join(", ");
  var thana = (location === null || location === void 0 || (_location$parent = location.parent) === null || _location$parent === void 0 ? void 0 : _location$parent.name) || (location === null || location === void 0 ? void 0 : location.name);
  var district = (location === null || location === void 0 || (_location$parent2 = location.parent) === null || _location$parent2 === void 0 || (_location$parent2 = _location$parent2.parent) === null || _location$parent2 === void 0 ? void 0 : _location$parent2.name) || (location === null || location === void 0 || (_location$parent3 = location.parent) === null || _location$parent3 === void 0 ? void 0 : _location$parent3.name);
  return {
    village: village,
    postOffice: postOffice,
    thana: thana,
    district: district
  };
};
var getOrdinalNumber = function getOrdinalNumber(number) {
  if (number % 100 >= 11 && number % 100 <= 13) {
    return number + "th";
  }
  switch (number % 10) {
    case 1:
      return number + "st";
    case 2:
      return number + "nd";
    case 3:
      return number + "rd";
    default:
      return number + "th";
  }
};

// English field: remove Bangla characters (Unicode block U+0980–U+09FF)
var filterEnglish = function filterEnglish() {
  var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  return val.replace(/[\u0980-\u09FF]/g, "");
};
// helper: keep only Western digits and Bangla digits (০-৯)
var filterDigits = function filterDigits() {
  var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  return (val || "").toString().replace(/[^0-9\u09E6-\u09EF]/g, "");
};

// Bangla field: remove English letters (keeps Bangla, digits, spaces, punctuation/special chars)
var filterBangla = function filterBangla() {
  var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  return val.replace(/[A-Za-z]/g, "");
};
var isCfPath = function isCfPath() {
  if (typeof window !== "undefined") {
    return window.location.href.includes("cf");
  }
  return false; // fallback if window is not defined
  // return true;
};
var isBlwfPath = function isBlwfPath() {
  if (typeof window !== "undefined") {
    return window.location.href.includes("blwf");
  }
  return false; // fallback if window is not defined
  // return true;
};
var isEisPath = function isEisPath() {
  if (typeof window !== "undefined") {
    return window.location.href.includes("eis");
  }
  return false; // fallback if window is not defined
  // return true;
};

var _banglaLabels;
var MODULE_NAME = "workforce";
var DEFAULT = {
  IS_WORKER: false,
  ENABLE_PUBLIC_PAGE: false,
  SHOW_JOURNAL_SIDEBAR: true,
  DISABLED_VISIBILITY_BOOST: false
};
var EMPTY_STRING = "";
var WORKFORCE_GENDER = [{
  name: "workforce.gender.male",
  id: "M"
}, {
  name: "workforce.gender.female",
  id: "F"
}, {
  name: "workforce.gender.other",
  id: "O"
}];
var ORGANIZATION_TYPE_NAME_BN = {
  cf: "কেন্দ্রীয় তহবিল",
  blwf: "বাংলাদেশ শ্রমিক কল্যাণ ফাউন্ডেশন",
  eis: "এমপ্লয়ী ইনজুরি স্কিম"
};
var ORGANIZATION_TYPE_NAME_EN = {
  cf: "Central Fund",
  blwf: "Bangladesh Labour Welfare Foundation",
  eis: "Employee Injury Scheme"
};
var WORKFORCE_STATUS$1 = {
  ACTIVE: "active",
  INACTIVE: "inactive",
  PENDING: "pending",
  DRAFT: "draft",
  INITIAL: "initial",
  SUSPENDED: "suspended",
  TERMINATED: "terminated",
  ON_LEAVE: "on_leave",
  COMPLETED: "completed",
  ARCHIVED: "archived",
  APPROVED_BY_DG: "approved_by_dg",
  APPROVED_BY_SECRETARY: "approved_by_secretary",
  APPROVED_BY_MINISTER: "approved_by_minister",
  APPROVED_BY_DIRECTOR: "approved_by_director",
  APPROVED_BY_DOCTOR: "approved_by_doctor",
  REJECTED: "rejected",
  REJECTED_BY_DG: "rejected_by_dg",
  DEACTIVATED: "deactivated",
  REINSTATED: "reinstated",
  UNDER_REVIEW: "under_review",
  ESCALATED: "escalated",
  WAITING_FOR_INPUT: "waiting_for_input",
  ON_HOLD: "on_hold",
  CANCELED: "canceled",
  EXPIRED: "expired",
  DISABLED: "disabled",
  REASSIGNED: "reassigned",
  RESIGNED: "resigned",
  FORWARD_TO_DG: "forward_to_dg",
  FORWARD_TO_DIRECTOR: "forward_to_director",
  FORWARD_TO_COMIITEE: "forward_to_comiitee",
  SECOND_FORWARD: "second_forward",
  THIRD_FORWARD: "third_forward",
  NEW: "new",
  REVERT_TO_APPLICANT: "revert_to_applicant",
  REVERT_TO_CHECKER: "revert_to_checker",
  REVERT: "revert",
  FORWARD_TO_ASSOCIATION: "forward_to_association",
  FORWARD_TO_CF_SECTION: "forward_to_cf_section",
  FORWARD_FOR_VERIFICATION: "forward_for_verification",
  VERIFIED: "verified",
  VERIFIED_BY_DOL_DIFE: "verified_by_dol_dife",
  FORWARD_TO_CF_SECTION_ONE: "forward_to_cf_section_one",
  FORWARD_TO_CF_SECTION_TWO: "forward_to_cf_section_two",
  FORWARD_TO_DOCTOR: "forward_to_doctor",
  SELECTED: "selected",
  MEETING_CREATED: "meeting_created",
  FORWARD_TO_EIS_ADVISOR: "forward_to_eis_advisor",
  AMMENDED_APPLICATION: "amended_application",
  APPROVED_BY_COMMITTEE: "approved_by_committee",
  FORWARD_TO_EIS_COORDINATOR: "forward_to_eis_coordinator",
  RESUBMITTED_APPLICATION: "resubmitted_application",
  APPROVED_BY_EIS_ADVISOR: "approved_by_eis_advisor",
  FORWARD_TO_BLWF_SECTION: "forward_to_blwf_section",
  EIS_PAYMENT_PROCESS: "eis_payment_process",
  REJECTED_BY_COMMITTEE: "rejected_by_committee",
  PROPOSED_FOR_REJECTION: "proposed_for_rejection"
};
var STATUS_MAP_BN = {
  active: "সক্রিয়",
  inactive: "নিষ্ক্রিয়",
  pending: "অপেক্ষমাণ",
  draft: "খসড়া",
  initial: "প্রাথমিক",
  suspended: "বহিষ্কৃত",
  terminated: "বাতিল",
  on_leave: "ছুটিতে",
  completed: "সম্পন্ন",
  archived: "আর্কাইভকৃত",
  approved_by_dg: "মহাপরিচালক দ্বারা অনুমোদিত",
  approved_by_director: "পরিচালক দ্বারা অনুমোদিত",
  approved_by_doctor: "ডাক্তার দ্বারা সুপারিশকৃত",
  rejected: "বাতিলকৃত",
  rejected_by_dg: "ডিজি কর্তৃক বাতিলকৃত",
  deactivated: "নিষ্ক্রিয় করা হয়েছে",
  reinstated: "পুনর্বহাল",
  under_review: "পর্যালোচনায় রয়েছে",
  escalated: "উর্ধ্বে প্রেরিত",
  waiting_for_input: "ইনপুটের জন্য অপেক্ষা",
  on_hold: "স্থগিত",
  canceled: "বাতিল করা হয়েছে",
  expired: "মেয়াদোত্তীর্ণ",
  disabled: "অক্ষম",
  reassigned: "পুনরায় বরাদ্দকৃত",
  resigned: "পদত্যাগ করেছেন",
  forward_to_dg: "মহাপরিচালকের কাছে প্রেরণ",
  forward_to_director: "পরিচালকের কাছে প্রেরণ",
  forward_to_comiitee: "কমিটির কাছে প্রেরণ",
  second_forward: "দ্বিতীয় দফা প্রেরণ",
  third_forward: "তৃতীয় দফা প্রেরণ",
  "new": "নতুন",
  revert_to_applicant: "আবেদনকারীর কাছে ফেরত",
  revert_to_checker: "যাচাইকরণকারীর কাছে ফেরত",
  revert: "আবেদন ফেরত পাঠানো হয়েছে",
  forward_to_association: "অ্যাসোসিয়েশনের কাছে প্রেরণ",
  forward_to_cf_section: "সিএফ শাখায় প্রেরণ",
  forward_for_verification: "যাচাইয়ের জন্য প্রেরণ",
  verified: "যাচাইকৃত",
  verified_by_dol_dife: "ডল/ডাইফি দ্বারা যাচাইকৃত",
  forward_to_cf_section_one: "সিএফ শাখা-১ এ প্রেরণ",
  forward_to_cf_section_two: "সিএফ শাখা-২ এ প্রেরণ",
  forward_to_doctor: "ডক্টরের কাছে প্রেরণ",
  selected: "নির্বাচিত",
  meeting_created: "সভা তৈরি হয়েছে",
  forward_to_eis_advisor: "ইআইএস উপদেষ্টার কাছে প্রেরণ",
  amended_application: "সংশোধিত আবেদন",
  approved_by_committee: "কমিটি দ্বারা অনুমোদিত",
  forward_to_eis_coordinator: "ইআইএস কোঅর্ডিনেটর কাছে প্রেরণ",
  resubmitted_application: "পুনরায় জমাকৃত আবেদন",
  approved_by_eis_advisor: "ইআইএস উপদেষ্টা দ্বারা অনুমোদিত",
  forward_to_blwf_section: "বিএলডাব্লিউএফ শাখায় প্রেরণ",
  rejected_by_committee: "কমিটি কর্তৃক বাতিলকৃত",
  proposed_for_rejection: "বাতিলের জন্য প্রস্তাবিত",
  forward_to_factory_admin: "ফ্যাক্টরি অ্যাডমিনের কাছে পাঠানো হয়েছে",
  approved_by_secretary: "সচিব কর্তৃক অনুমোদিত",
  approved_by_minister: "মন্ত্রী কর্তৃক অনুমোদিত"
};
var STATUS_MAP_EN = {
  active: "Active",
  inactive: "Inactive",
  pending: "Pending",
  draft: "Draft",
  initial: "Initial",
  suspended: "Suspended",
  terminated: "Terminated",
  on_leave: "On Leave",
  completed: "Completed",
  archived: "Archived",
  approved_by_dg: "Approved by DG",
  approved_by_director: "Approved by Director",
  approved_by_doctor: "Approved by Doctor",
  rejected: "Rejected",
  rejected_by_dg: "Rejected By DG",
  deactivated: "Deactivated",
  reinstated: "Reinstated",
  under_review: "Under Review",
  escalated: "Escalated",
  waiting_for_input: "Waiting for Input",
  on_hold: "On Hold",
  canceled: "Canceled",
  expired: "Expired",
  disabled: "Disabled",
  reassigned: "Reassigned",
  resigned: "Resigned",
  forward_to_dg: "Forward to DG",
  forward_to_director: "Forward to Director",
  forward_to_comiitee: "Forward to Committee",
  second_forward: "Second Forward",
  third_forward: "Third Forward",
  "new": "New",
  revert_to_applicant: "Revert to Applicant",
  revert_to_checker: "Revert to Checker",
  revert: "Application returned",
  forward_to_association: "Forward to Association",
  forward_to_cf_section: "Forward to CF Section",
  forward_to_cf_section_one: "Forward to CF Section-1",
  forward_to_cf_section_two: "Forward to CF Section-2",
  forward_for_verification: "Forward For Verification",
  verified: "Verified",
  verified_by_dol_dife: "Verified by Dol/Dife",
  forward_to_doctor: "Forward to Doctor",
  selected: "Selected",
  meeting_created: "Meeting Created",
  forward_to_eis_advisor: "Forward to Eis Advisor",
  amended_application: "Amended Application",
  approved_by_committee: "Approved by Committee",
  resubmitted_application: "Resubmitted Application",
  approved_by_eis_advisor: "Approved by Eis Advisor",
  forward_to_eis_coordinator: "Forward to Eis Coordinator",
  rejected_by_committee: "Rejected by committee",
  proposed_for_rejection: "Proposed for Rejection",
  forward_to_factory_admin: "Forwarded to Factory Admin",
  approved_by_secretary: "Approved by Secretary",
  approved_by_minister: "Approved by Minister"
};
var WORKFORCE_USER_TYPE = {
  ADMIN: "admin",
  CHECKER: "checker",
  CHECKER_TWO: "checker_two",
  APPROVER: "approver",
  BLWF_APPROVER: "blwf_approver",
  APPLICANT: "applicant",
  FACTORY_ADMIN: "factory_admin",
  DIRECTOR: "director",
  ASSOCIATION: "association",
  BGMEA_ASSOCIATION: "bgmea_association",
  BKMEA_ASSOCIATION: "bkmea_association",
  SECTION_ADMIN: "section_admin",
  SECTION_ADMIN_TWO: "section_admin_two",
  BLWF_SECTION_ADMIN: "blwf_section_admin",
  DOCTOR: "doctor",
  SEC1_DEPUTI_ASST_DIRECTOR: "sec1_deputi_asst_director ",
  SEC2_DEPUTI_ASST_DIRECTOR: "sec2_deputi_asst_director ",
  BLWF_CHECKER: "blwf_checker",
  BLWF_DEPUTI_ASST_DIRECTOR: "blwf_deputi_asst_director",
  BLWF_DIRECTOR: "blwf_director",
  EIS_COORDINATOR: "eis_coordinator",
  EIS_OFFICER: "eis_officer",
  EIS_ADVISOR: "eis_advisor",
  EIS_COMMITTEE: "eis_committee",
  BLWF_DOCTOR: "blwf_doctor",
  EIS_FINANCIAL_OFFICER: "eis_financial_officer",
  EIS_DOCTOR: "eis_doctor",
  BLWF_DOL_DIFE: "blwf_dol_dife",
  EIS_APPLICANT: "eis_applicant",
  BEPZA_ASSOCIATION: "bepza_association",
  LFMEAB_ASSOCIATION: "lfmeab_association",
  SECRETARY: "secretary",
  EIS_ASSOCIATION_COMMITTEE: "eis_association_committee",
  MINISTER: "minister",
  BLWF_ACCOUNTANT: "blwf_accountant"
};
var WORKFORCE_USER_TYPE_MAP_EN = {
  admin: "Admin",
  checker: "Checker",
  checker_two: "Checker Two",
  approver: "Approver",
  blwf_approver: "Blwf Approver",
  applicant: "Applicant",
  factory_admin: "Factory Admin",
  director: "Director",
  bgmea_association: "BGMEA Association",
  bkmea_association: "BKMEA Association",
  section_admin: "Section Admin",
  section_admin_two: "Section Admin Two",
  blwf_section_admin: "Blwf Section Admin",
  doctor: "Doctor",
  sec1_deputi_asst_director: "Sec1 Deputi Asst Director",
  sec2_deputi_asst_director: "Sec2 Deputi Asst Director",
  blwf_checker: "BLWF Checker",
  blwf_deputi_asst_director: "BLWF Deputi Asst Director",
  blwf_director: "BLWF Director",
  eis_officer: "Eis Officer",
  eis_coordinator: "Eis Coordinator",
  eis_advisor: "Eis Advisor",
  eis_committee: "Eis Committee",
  blwf_doctor: "Blwf Doctor",
  eis_financial_officer: "Eis Financial Officer",
  eis_doctor: "Eis Doctor",
  blwf_dol_dife: "Blwf Dol/Dife",
  bepza_association: "Bepza Association",
  lfmeab_association: "Lfmeab Association",
  eis_association_committee: "Eis Association Committee",
  minister: "Minister",
  blwf_accountant: "Blwf Accountant"
};
var WORKFORCE_USER_TYPE_MAP_BN = {
  admin: "অ্যাডমিন",
  checker: "চেকার",
  checker_two: "চেকার ২",
  approver: "অনুমোদনকারী",
  blwf_approver: "বিএলডাব্লিউএফ অনুমোদনকারী",
  applicant: "আবেদনকারী",
  factory_admin: "ফ্যাক্টরি অ্যাডমিন",
  director: "পরিচালক",
  bgmea_association: "বিজিএমইএ অ্যাসোসিয়েশন",
  bkmea_association: "বিকেএমইএ অ্যাসোসিয়েশন",
  section_admin: "সেকশন-১ অ্যাডমিন",
  section_admin_two: "সেকশন-২ অ্যাডমিন",
  blwf_section_admin: "বিএলডাব্লিউএফ সেকশন অ্যাডমিন",
  doctor: "ডাক্তার",
  sec1_deputi_asst_director: "শাখা-১ উপ-সহকারী পরিচালক",
  sec2_deputi_asst_director: "শাখা-২ উপ-সহকারী পরিচালক",
  blwf_deputi_asst_director: "বিএলডাব্লিউএফ উপ-সহকারী পরিচালক",
  blwf_director: "বিএলডাব্লিউএফ পরিচালক",
  eis_officer: "ইআইএস অফিসার",
  eis_coordinator: "ইআইএস কোঅর্ডিনেটর",
  eis_committee: "ইআইএস কমিটি",
  blwf_doctor: "অনুমোদনকারী ডাক্তার",
  eis_financial_officer: "ইআইএস ফিনান্সিয়াল অফিসার",
  eis_doctor: "ইআইএস ডাক্তার",
  blwf_dol_dife: "বিএলডাব্লিউএফ ডল/ডাইফি",
  bepza_association: "বেপজা অ্যাসোসিয়েশন",
  lfmeab_association: "এলএফএমইএবি অ্যাসোসিয়েশন",
  eis_association_committee: "ইআইএস অ্যাসোসিয়েশন কমিটি",
  minister: "মন্ত্রী",
  blwf_accountant: "বিএলডাব্লিউএফ হিসাবরক্ষক"
};
var WORKFORCE_DOCUMENT_STATUS = {
  FACTORY_ADMIN_VERIFIED: "verified_by_factoryAdmin",
  ASSOCIATION_VERIFIED: "verified_by_association",
  EIS_OFFICER_VERIFIED: "verified_by_eis_officer",
  // SECTION_OFFICER_VERIFIED:"verified_by_section_officer",
  SECTION_OFFICER_VERIFIED: "verified_by_data_entry_officer",
  BLWF_SECTION_OFFICER_VERIFIED: "verified_by_data_entry_officer",
  DOL_DIFE_VERIFIED: "verified_by_dol_dife",
  FACTORY_ADMIN_REJECTED: "rejected_by_factoryAdmin",
  ASSOCIATION_REJECTED: "rejected_by_association",
  EIS_OFFICER_REJECTED: "rejected_by_eis_officer",
  // SECTION_OFFICER_REJECTED:"rejected_by_section_officer",
  DOL_DIFE_REJECTED: "rejected_by_dol_dife",
  BLWF_SECTION_OFFICER_REJECTED: "rejected_by_data_entry_officer",
  SECTION_OFFICER_REJECTED: "rejected_by_data_entry_officer"
};
var WORKFORCE_DOCUMENT_MAP_EN = {
  verified_by_factoryAdmin: "Verified by Factory Admin",
  verified_by_association: "Verified by Association",
  verified_by_eis_officer: "Verified by Eis Officer",
  verified_by_section_officer: "Verified by Section Officer",
  verified_by_data_entry_officer: "Verified by Data Entry Officer",
  verified_by_dol_dife: "Verified by DOL/DIFE",
  rejected_by_factoryAdmin: "Rejected by Factory Admin",
  rejected_by_association: "Rejected by Association",
  rejected_by_eis_officer: "Rejected by Eis Officer",
  rejected_by_section_officer: "Rejected by Section Officer",
  rejected_by_data_entry_officer: "Rejected by Data Entry Officer",
  rejected_by_dol_dife: "Rejected by DOL/DIFE"
};
var WORKFORCE_DOCUMENT_MAP_BN = {
  verified_by_factoryAdmin: "কারখানা প্রশাসক দ্বারা যাচাইকৃত",
  verified_by_association: "এসোসিয়েশন দ্বারা যাচাইকৃত",
  verified_by_eis_officer: "ইআইএস অফিসার দ্বারা যাচাইকৃত",
  verified_by_section_officer: "সেকশন অফিসার দ্বারা যাচাইকৃত",
  verified_by_data_entry_officer: "ডাটা এন্ট্রি অপারেটর দ্বারা যাচাইকৃত",
  verified_by_dol_dife: "শ্রম অধিদপ্তর এবং কল-কারখানা ও প্রতিষ্ঠান পরিদর্শন অধিদপ্তর দ্বারা যাচাইকৃত",
  rejected_by_factoryAdmin: "কারখানা প্রশাসক দ্বারা বাতিলকৃত",
  rejected_by_association: "এসোসিয়েশন দ্বারা বাতিলকৃত",
  rejected_by_eis_officer: "ইআইএস অফিসার দ্বারা বাতিলকৃত",
  rejected_by_section_officer: "সেকশন অফিসার দ্বারা বাতিলকৃত",
  rejected_by_data_entry_officer: "ডাটা এন্ট্রি অপারেটর দ্বারা বাতিলকৃত",
  rejected_by_dol_dife: "শ্রম অধিদপ্তর এবং কল-কারখানা ও প্রতিষ্ঠান পরিদর্শন অধিদপ্তর দ্বারা বাতিলকৃত"
};
var cfStatusOptions = [{
  value: "new",
  label: "নতুন"
}, {
  value: "pending",
  label: "অপেক্ষমাণ"
}, {
  value: "draft",
  label: "খসড়া"
}, {
  value: "suspended",
  label: "বহিষ্কৃত"
}, {
  value: "approved_by_dg",
  label: "মহাপরিচালক দ্বারা অনুমোদিত"
}, {
  value: "approved_by_director",
  label: "পরিচালক দ্বারা অনুমোদিত"
}, {
  value: "approved_by_doctor",
  label: "ডাক্তার দ্বারা সুপারিশকৃত"
}, {
  value: "rejected",
  label: "বাতিলকৃত"
}, {
  value: "rejected_by_dg",
  label: "ডিজি কর্তৃক বাতিলকৃত"
}, {
  value: "deactivated",
  label: "নিষ্ক্রিয় করা হয়েছে"
}, {
  value: "under_review",
  label: "পর্যালোচনায় রয়েছে"
}, {
  value: "canceled",
  label: "বাতিল করা হয়েছে"
}, {
  value: "expired",
  label: "মেয়াদোত্তীর্ণ"
}, {
  value: "disabled",
  label: "অক্ষম"
}, {
  value: "reassigned",
  label: "পুনরায় বরাদ্দকৃত"
}, {
  value: "resigned",
  label: "পদত্যাগ করেছেন"
}, {
  value: "forward_to_dg",
  label: "মহাপরিচালকের কাছে প্রেরণ"
}, {
  value: "forward_to_director",
  label: "পরিচালকের কাছে প্রেরণ"
}, {
  value: "forward_to_comiitee",
  label: "কমিটির কাছে প্রেরণ"
}, {
  value: "second_forward",
  label: "দ্বিতীয় দফা প্রেরণ"
}, {
  value: "revert_to_applicant",
  label: "আবেদনকারীর কাছে ফেরত"
}, {
  value: "revert_to_checker",
  label: "যাচাইকরণকারীর কাছে ফেরত"
}, {
  value: "revert",
  label: "আবেদন ফেরত পাঠানো হয়েছে"
}, {
  value: "forward_to_association",
  label: "অ্যাসোসিয়েশনের কাছে প্রেরণ"
}, {
  value: "forward_to_cf_section",
  label: "সিএফ শাখায় প্রেরণ"
}, {
  value: "forward_to_cf_section_one",
  label: "সিএফ শাখা-১ এ প্রেরণ"
}, {
  value: "forward_to_cf_section_two",
  label: "সিএফ শাখা-২ এ প্রেরণ"
}, {
  value: "forward_to_doctor",
  label: "ডক্টরের কাছে প্রেরণ"
}, {
  value: "selected",
  label: "নির্বাচিত"
}, {
  value: "meeting_created",
  label: "সভা তৈরি হয়েছে"
}, {
  value: "amended_application",
  label: "সংশোধিত আবেদন"
}, {
  value: "approved_by_committee",
  label: "কমিটি দ্বারা অনুমোদিত"
}, {
  value: "forward_for_verification",
  label: "যাচাইয়ের জন্য প্রেরণ"
}];
var blwfStatusOptions = [{
  value: "new",
  label: "নতুন"
}, {
  value: "pending",
  label: "অপেক্ষমাণ"
}, {
  value: "draft",
  label: "খসড়া"
}, {
  value: "completed",
  label: "সম্পন্ন"
}, {
  value: "approved_by_dg",
  label: "মহাপরিচালক দ্বারা অনুমোদিত"
}, {
  value: "approved_by_director",
  label: "পরিচালক দ্বারা অনুমোদিত"
}, {
  value: "approved_by_doctor",
  label: "ডাক্তার দ্বারা সুপারিশকৃত"
}, {
  value: "rejected",
  label: "বাতিলকৃত"
}, {
  value: "rejected_by_dg",
  label: "ডিজি কর্তৃক বাতিলকৃত"
}, {
  value: "deactivated",
  label: "নিষ্ক্রিয় করা হয়েছে"
}, {
  value: "reinstated",
  label: "পুনর্বহাল"
}, {
  value: "under_review",
  label: "পর্যালোচনায় রয়েছে"
}, {
  value: "escalated",
  label: "উর্ধ্বে প্রেরিত"
}, {
  value: "waiting_for_input",
  label: "ইনপুটের জন্য অপেক্ষা"
}, {
  value: "on_hold",
  label: "স্থগিত"
}, {
  value: "canceled",
  label: "বাতিল করা হয়েছে"
}, {
  value: "expired",
  label: "মেয়াদোত্তীর্ণ"
}, {
  value: "disabled",
  label: "অক্ষম"
}, {
  value: "reassigned",
  label: "পুনরায় বরাদ্দকৃত"
}, {
  value: "resigned",
  label: "পদত্যাগ করেছেন"
}, {
  value: "forward_to_dg",
  label: "মহাপরিচালকের কাছে প্রেরণ"
}, {
  value: "forward_to_director",
  label: "পরিচালকের কাছে প্রেরণ"
}, {
  value: "forward_to_comiitee",
  label: "কমিটির কাছে প্রেরণ"
}, {
  value: "second_forward",
  label: "দ্বিতীয় দফা প্রেরণ"
}, {
  value: "revert_to_applicant",
  label: "আবেদনকারীর কাছে ফেরত"
}, {
  value: "revert_to_checker",
  label: "যাচাইকরণকারীর কাছে ফেরত"
}, {
  value: "revert",
  label: "আবেদন ফেরত পাঠানো হয়েছে"
}, {
  value: "forward_to_association",
  label: "অ্যাসোসিয়েশনের কাছে প্রেরণ"
}, {
  value: "forward_to_doctor",
  label: "ডক্টরের কাছে প্রেরণ"
}, {
  value: "selected",
  label: "নির্বাচিত"
}, {
  value: "meeting_created",
  label: "সভা তৈরি হয়েছে"
}, {
  value: "amended_application",
  label: "সংশোধিত আবেদন"
}, {
  value: "approved_by_committee",
  label: "কমিটি দ্বারা অনুমোদিত"
}, {
  value: "forward_for_verification",
  label: "যাচাইয়ের জন্য প্রেরণ"
}];
var eisStatusOptions = [{
  value: "new",
  label: "নতুন"
}, {
  value: "pending",
  label: "অপেক্ষমাণ"
}, {
  value: "draft",
  label: "খসড়া"
}, {
  value: "approved_by_doctor",
  label: "ডাক্তার দ্বারা সুপারিশকৃত"
}, {
  value: "rejected",
  label: "বাতিলকৃত"
}, {
  value: "under_review",
  label: "পর্যালোচনায় রয়েছে"
}, {
  value: "forward_to_comiitee",
  label: "কমিটির কাছে প্রেরণ"
}, {
  value: "second_forward",
  label: "দ্বিতীয় দফা প্রেরণ"
}, {
  value: "revert_to_applicant",
  label: "আবেদনকারীর কাছে ফেরত"
}, {
  value: "revert_to_checker",
  label: "যাচাইকরণকারীর কাছে ফেরত"
}, {
  value: "revert",
  label: "আবেদন ফেরত পাঠানো হয়েছে"
}, {
  value: "forward_to_association",
  label: "অ্যাসোসিয়েশনের কাছে প্রেরণ"
}, {
  value: "forward_to_doctor",
  label: "ডক্টরের কাছে প্রেরণ"
}, {
  value: "selected",
  label: "নির্বাচিত"
}, {
  value: "meeting_created",
  label: "সভা তৈরি হয়েছে"
}, {
  value: "forward_to_eis_advisor",
  label: "ইআইএস উপদেষ্টার কাছে প্রেরণ"
}, {
  value: "amended_application",
  label: "সংশোধিত আবেদন"
}, {
  value: "approved_by_committee",
  label: "কমিটি দ্বারা অনুমোদিত"
}, {
  value: "approved_by_eis_advisor",
  label: "ইআইএস উপদেষ্টা দ্বারা অনুমোদিত"
}, {
  value: "forward_for_verification",
  label: "যাচাইয়ের জন্য প্রেরণ"
}];
var cfApplicationTypeOptions = [{
  value: "medicalAssistance",
  label: "চিকিৎসা অনুদান"
}, {
  value: "scholarship",
  label: "শিক্ষা অনুদান"
}, {
  value: "financialAssistance",
  label: "মৃত্যুজনিত অনুদান"
}, {
  value: "maternityGrant",
  label: "মাতৃত্বজনিত অনুদান"
}, {
  value: "disabilityAssistance",
  label: "স্থায়ী ও আংশিক অক্ষমতা জনিত আর্থিক সহায়তা"
}];
var blwfApplicationTypeOptions = [{
  value: "medicalDonation",
  label: "চিকিৎসা অনুদান"
}, {
  value: "educationGrant",
  label: "শিক্ষা অনুদান"
}, {
  value: "deadlyGrant",
  label: "মৃত্যুজনিত অনুদান"
}, {
  value: "maternityGrant",
  label: "মাতৃত্বজনিত অনুদান"
}];
var eisApplicationTypeOptions = [{
  value: "financialAssistance",
  label: "মৃত্যুজনিত অনুদান"
}, {
  value: "disabilityAssistance",
  label: "স্থায়ী ও আংশিক অক্ষমতা জনিত আর্থিক সহায়তা"
}];
var cfAssociationOptions = [{
  value: "BGMEA",
  label: "বিজিএমইএ"
}, {
  value: "BKMEA",
  label: "বিকেএমইএ"
}];
var eisAssociationOptions = [{
  value: "BEPZA",
  label: "বেপজা"
}, {
  value: "LFMEAB",
  label: "এলএফএমইএবি"
}];
var organizationTypeOptions = [{
  value: "eis",
  label: "EIS"
}, {
  value: "blwf",
  label: "BLWF"
}, {
  value: "cf",
  label: "CF"
}];
var APP_TYPE_DASHBOARD_EN = {
  medical: "Medical Assistance",
  death: "Grant for Death",
  educational: "Educational Grant",
  maternityGrant: "Maternity Grant",
  disabilityAssistance: "Grant for Disability",
  total: "Total"
};
var APP_TYPE_DASHBOARD_BN = {
  medical: "চিকিৎসা অনুদান",
  death: "মৃত্যুজনিত অনুদান",
  educational: "শিক্ষা অনুদান",
  maternityGrant: "মাতৃত্বজনিত অনুদান",
  disabilityAssistance: "স্থায়ী ও আংশিক অক্ষমতা জনিত আর্থিক সহায়তা",
  total: "মোট"
};
var APPLICANT_TYPE_EN = {
  totalApplicant: "Total Applicant",
  totalDependent: "Total Dependent",
  maleApplicant: "Male Applicant",
  femaleApplicant: "Female Applicant",
  maleDependent: "Male Dependent",
  femaleDependent: "Female Dependent"
};
var APPLICANT_TYPE_BN = {
  totalApplicant: "মোট আবেদনকারী",
  totalDependent: "মোট নির্ভরশীল",
  maleApplicant: "পুরুষ আবেদনকারী",
  femaleApplicant: "মহিলা আবেদনকারী",
  maleDependent: "পুরুষ নির্ভরশীল",
  femaleDependent: "মহিলা নির্ভরশীল"
};
var submittedByOptions = [{
  value: "applicant",
  label: "আবেদনকারী"
}, {
  value: "factory_admin",
  label: "ফ্যাক্টরি অ্যাডমিন"
}];
var banglaLabels$1 = (_banglaLabels = {
  nameEn: "নাম (ইংরেজি)",
  nameBn: "নাম (বাংলা)",
  firstNameEn: "নাম (ইংরেজি)",
  firstNameBn: "নাম (বাংলা)",
  fatherNameEn: "পিতার নাম (ইংরেজি)",
  fatherNameBn: "পিতার নাম (বাংলা)",
  motherNameEn: "মাতার নাম (ইংরেজি)",
  motherNameBn: "মাতার নাম (বাংলা)",
  spouseNameEn: "স্বামীর / স্ত্রীর নাম (ইংরেজি)",
  spouseNameBn: "স্বামী/স্ত্রীর নাম (বাংলা)",
  citizenship: "নাগরিকত্ব",
  nid: "এনআইডি",
  birthCertificate: "জন্ম সনদ",
  birthCertificateNo: "জন্ম সনদ নম্বর",
  birthDate: "জন্ম তারিখ",
  insuranceNumber: "ইনসুরেন্স নম্বর",
  gender: "লিঙ্গ",
  maritalStatus: "বৈবাহিক অবস্থা",
  phoneNumber: "ফোন নম্বর",
  email: "ইমেইল",
  lifeStatus: "জীবিত অবস্থা",
  deathDate: "মৃত্যুর তারিখ",
  monthlyEarning: "মাসিক আয়",
  presentAddress: "বর্তমান ঠিকানা",
  permanentAddress: "স্থায়ী ঠিকানা",
  presentLocation: "বর্তমান এলাকা",
  permanentLocation: "স্থায়ী এলাকা",
  accountNumber: "অ্যাকাউন্ট নম্বর",
  accountHolderName: "হোল্ডারের নাম",
  routingNumber: "রাউটিং নম্বর",
  branch: "শাখা",
  // cronicDiseaseType: "জটিল রোগের ধরন",
  cronicDiseaseType: "রোগের ধরন",
  grantAmount: "অনুদানের পরিমাণ",
  diagnosisDate: "রোগ নির্ণয়ের তারিখ",
  doctorName: "ডাক্তারের নাম",
  admitted: "হাসপাতালে ভর্তি",
  hospitalName: "হাসপাতালের নাম",
  admitDate: "ভর্তির তারিখ",
  releaseDate: "ছাড়পত্রের তারিখ",
  hospitalDoctorName: "হাসপাতালের ডাক্তার",
  accidentType: "দুর্ঘটনার ধরণ",
  accidentPlace: "দুর্ঘটনার স্থান",
  accidentDate: "দুর্ঘটনার তারিখ",
  accidentTime: "দুর্ঘটনার সময়",
  inOutsideFactory: "কারখানার ভিতরে/বাইরে",
  reJoiningDate: "পুনঃযোগদানের তারিখ",
  educationInstituteName: "শিক্ষা প্রতিষ্ঠানের নাম",
  studyingClass: "অধ্যয়নরত শ্রেণী",
  educationLevel: "শিক্ষার স্তর",
  childNameEn: "শিশুর নাম (ইংরেজি)",
  childNameBn: "শিশুর নাম (বাংলা)",
  childBirthDate: "জন্ম তারিখ",
  childBirthCertificateNo: "জন্ম সনদ নম্বর",
  childNidNo: "এনআইডি নম্বর",
  institution: "শিক্ষা প্রতিষ্ঠান",
  studyClass: "শ্রেণি",
  educationBoard: "বোর্ড",
  passingYear: "পাসিং বছর",
  rollNumber: "রোল নম্বর",
  registrationNumber: "রেজিস্ট্রেশন নম্বর",
  result: "ফলাফল",
  otherInfo: "অন্যান্য তথ্য",
  dateofReceipt: "গ্রহণের তারিখ",
  reasonforReceipt: "গ্রহণের কারণ",
  disabilityType: "প্রতিবন্ধিতার ধরণ",
  deathType: "মৃত্যুর ধরণ",
  scholarshipFor: "স্কলারশিপের উদ্দেশ্য",
  employeeDependentInfo: isEisPath() ? "নির্ভরশীল সদস্যদের তথ্য" : "ওয়ারিশদের তথ্য",
  workforceEmployeeDependentApplication: isEisPath() ? "নির্ভরশীল সদস্যদের তথ্য" : "ওয়ারিশদের তথ্য",
  employeeBankInfo: "শ্রমিকের ব্যাংক তথ্য",
  employeeBankingInfoApplication: "শ্রমিকের ব্যাংক তথ্য",
  applicant_type: "আবেদনকারীর ধরণ",
  bankCode: "ব্যাংক কোড",
  bank: "ব্যাংক",
  educations: "শিক্ষাগত তথ্য",
  spouseBn: "স্বামী/স্ত্রীর নাম (বাংলা)",
  spouseEn: "স্বামী/স্ত্রীর নাম (ইংরেজি)",
  spouseFatherNameEn: "স্বামী/স্ত্রীর পিতার নাম (ইংরেজি)",
  spouseFatherNameBn: "স্বামী/স্ত্রীর পিতার নাম (বাংলা)",
  spouseBirthDate: "স্বামী/স্ত্রীর জন্ম তারিখ",
  spouseNid: "স্বামী/স্ত্রীর এনআইডি",
  applicantInfo: "আবেদনকারীর তথ্য",
  workforceApplicant: "আবেদনকারীর তথ্য",
  workforceEmployee: "শ্রমিকের তথ্য",
  relationWithApplicant: "আবেদনকারীর সাথে সম্পর্ক",
  houseName: "বাড়ির নাম",
  paraMahalla: "পাড়া মহল্লা",
  villageRoad: "গ্রামের রাস্তা",
  extraInfo: "অতিরিক্ত তথ্য",
  postOffice: "ডাকঘর",
  postCode: "পোস্ট কোড"
}, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_banglaLabels, "nameEn", "নাম (ইংরেজি)"), "nameBn", "নাম (বাংলা)"), "name", "নাম"), "roadName", "রাস্তার নাম"), "apartmentNumber", "অ্যাপার্টমেন্ট নম্বর"), "relationType", "সম্পর্কের ধরণ"), "bankCode", "ব্যাংক কোড"), "routingNumber", "রাউটিং নম্বর"), "districtCode", "জেলা কোড"), "districtNameEn", "জেলার নাম (ইংরেজি)"), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_banglaLabels, "districtNameBn", "জেলার নাম (বাংলা)"), "employeeAccidentInfo", "শ্রমিকের চিকিৎসার তথ্য"), "ApplicantName", "আবেদনকারীর নাম"), "ApplicantFactoryName", "আবেদনকারীর কর্মরত প্রতিষ্ঠান"), "FactoryMembershipNo", "কারখানার সদস্যপদ নং"), "FactoryRegistrationDate", "কারখানার নিবন্ধনের তারিখ"), "FactoryRegistrationExpiryDate", "কারখানার নিবন্ধনের মেয়াদ শেষ তারিখ"), "ApplicantDesignation", "প্রতিষ্ঠানে আবেদনকারীর পদবী"), "ApplicationType", "আবেদনের ধরণ"), "OrganizationType", "সেবাদানকারী প্রতিষ্ঠান"), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_banglaLabels, "TrackingNumber", "ট্র্যাকিং নাম্বার"), "Status", "অবস্থা"), "SubmittedBy", "জমা দিয়েছেন"), "GrantAmount", "অনুদানের পরিমাণ"), "CreatedDate", "আবেদনের তারিখ"), "appliedOn", "আবেদনের তারিখ"), "metadata", "অন্যান্য তথ্য"), "employeeChildrenInfo", "শিক্ষাগত তথ্য"), "applicationFor", "আবেদন কার জন্য"), "bank", "ব্যাংক"), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_banglaLabels, "district", "জেলা"), "branch", "শাখা"), "employeeBankInfo", "শ্রমিকের ব্যাংক তথ্য"), "ApplicationFor", "আবেদনকারীর ধরন"), "dependents", isEisPath() ? "নির্ভরশীল সদস্যদের তথ্য" : "ওয়ারিশদের তথ্য"), "institutionInfo", "প্রতিষ্ঠানের তথ্য"), "position", "পদবী"), "grade", "গ্রেড"), "diseaseNo", "রোগ নং"), "diseaseName", "রোগের নাম"), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_banglaLabels, "maximumDonationAmount", "সর্বোচ্চ দানের পরিমাণ"), "minimumDonationAmount", "ন্যূনতম অনুদানের পরিমাণ"), "status", "অবস্থা"), "diseaseType", "রোগের ধরন"), "workerType", "শ্রমিকের ধরন"), "instituteName", "প্রতিষ্ঠানের নাম"), "instituteAddress", "প্রতিষ্ঠানের ঠিকানা"), "aboutWork", "কাজের ধরণ"), "workingPlace", "কর্মস্থলের বিবরণ"), "deceasedWorkerInfo", "মৃত শ্রমিকের তথ্য"), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_banglaLabels, "aidReasonType", "সাহায্যের কারণের ধরণ"), "accidentMainType", "দুর্ঘটনা প্রধান ধরণ"), "dailyDutyStart", "দৈনিক কর্তব্য শুরু"), "dailyDutyEnd", "দৈনিক কর্তব্য সমাপ্তি"), "outsideDutyExplanation", "বাইরের দায়িত্বব্যাখ্যা"), "accidentSpecificType", "দুর্ঘটনার ধরণ"), "detailsOfAccident", "দুর্ঘটনার বিবরণ"), "dutyStatusWorkplace", "কর্তব্যের অবস্থা কর্মক্ষেত্রে"), "placeOfDeath", "মৃত্যুর স্থান"), "dateOfDeath", "মৃত্যুর তারিখ"), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_banglaLabels, "timeOfDeath", "মৃত্যুর সময়"), "otherAccidentType", "অন্যান্য দুর্ঘটনার ধরণ"), "outOfFactoryPlace", "কারখানার বাইরে"), "journeyStartTime", "যাত্রা শুরুর সময়"), "journeyStartPoint", "যাত্রা শুরুর বিন্দু"), "journeyDestination", "যাত্রাগন্তব্য"), "modeOfTravel", "ভ্রমণের ধরণ"), "roadDescription", "রাস্তার বর্ণনা"), "dutyStatusRTA", "ডিউটি ​​স্ট্যাটাস আরটিএ"), "travelPurpose", "ভ্রমণউদ্দেশ্য"), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_banglaLabels, "regularTravel", "নিয়মিত ভ্রমণ"), "workEngagedIn", "কাজে নিযুক্ত"), "otherInjuredName", "অন্যান্য আহত নাম"), "otherInjuredDesignation", "অন্যান্য আহত পদবী"), "otherInjuredPhone", "অন্যান্য আহত ফোন"), "otherInjuredType", "অন্যান্য আহত প্রকার"), "otherInjuredBenefit", "অন্যান্য আহত সুবিধা"), "otherInjuredTracking", "অন্যান্য আহত ট্র্যাকিং নম্বর"), "relationWithWorker", "শ্রমিকের সাথে সম্পর্ক"), "presentAddressAndLocation", "বর্তমান ঠিকানা এবং অবস্থান"), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_banglaLabels, "permanentAddressAndLocation", "স্থায়ী ঠিকানা এবং অবস্থান"), "factory", "কারখানা"), "hospitalList", "হাসপাতালের তথ্য"), "admitTime", "ভর্তি সময়"), "hospitalAddress", "হাসপাতালের ঠিকানা"), "isEligible", "যোগ্য"), "lastGrossSalary", "সর্বশেষ মোট (গ্রস) বেতন"), "doctorsEntry", "ডাক্তার প্রদত্ত তথ্য"), "doctorsAssesment", "ডাক্তারদের মূল্যায়ন"), "doctorAssesmentComment", "ডাক্তার মূল্যায়ন মন্তব্য"), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_banglaLabels, "doctorsProposedDonation", "ডাক্তার প্রস্তাবিত অনুদান"), "doctorsActionFlag", "ডাক্তারদের কার্যক্রমের পতাকা"), "accountNo", "অ্যাকাউন্ট নম্বর"), "branchCode", "শাখা কোড"), "lastCheckupDate", "শেষ চেকআপের তারিখ"), "donationReason", "অনুদানের  কারণ"), "otherDisease", "অন্যান্য রোগ"), "percentageOfCfGrant", "সিএফ (CF) অনুদানের হার"), "CommitteeRemarks", "কমিটির মন্তব্য"));
var roleMaxDayCount = {
  "admin": 15,
  "checker": 3,
  "checker_two": 3,
  "approver": 5,
  "blwf_approver": 5,
  "applicant": 100,
  "factory_admin": 15,
  "director": 15,
  "bgmea_association": 5,
  "bkmea_association": 5,
  "section_admin": 5,
  "section_admin_two": 5,
  "blwf_section_admin": 5,
  "doctor": 7,
  "sec1_deputi_asst_director ": 10,
  "sec2_deputi_asst_director ": 10,
  "blwf_checker": 3,
  "blwf_deputi_asst_director": 10,
  "blwf_director": 15,
  "eis_coordinator": 5,
  "eis_officer": 5,
  "eis_advisor": 5,
  "eis_committee": 5,
  "blwf_doctor": 7,
  "eis_financial_officer": 5,
  "eis_doctor": 5,
  "blwf_dol_dife": 5,
  "eis_applicant": 6,
  "bepza_association": 7,
  "lfmeab_association": 10,
  "eis_association_committee": 5
};
var colorCode = {
  0: '#cfffd3',
  20: '#f3fdc7',
  40: '#dffbff',
  60: '#fce1c9ff',
  80: '#fdc8c8',
  100: '#fddcf9'
};
var RELATION_LABEL_MAP = {
  "workforce.relation.father": "Father",
  "workforce.relation.mother": "Mother",
  "workforce.relation.wife": "Wife",
  "workforce.relation.husband": "Husband",
  "workforce.relation.son": "Son",
  "workforce.relation.daughter": "Daughter",
  "workforce.relation.brother": "Brother",
  "workforce.relation.sister": "Sister",
  "workforce.relation.grand_daughter": "Grand Daughter",
  "workforce.relation.grand_son": "Grand Son",
  "workforce.relation.grand_father": "Grand Father",
  "workforce.relation.grand_mother": "Grand Mother"
};
var RELATION_LABEL_BANGLA_MAP = {
  "workforce.relation.father": "পিতা",
  "workforce.relation.mother": "মাতা",
  "workforce.relation.wife": "স্ত্রী",
  "workforce.relation.husband": "স্বামী",
  "workforce.relation.son": "পুত্র",
  "workforce.relation.daughter": "কন্যা",
  "workforce.relation.brother": "ভাই",
  "workforce.relation.sister": "বোন",
  "workforce.relation.grand_daughter": "নাতনি",
  "workforce.relation.grand_son": "নাতি",
  "workforce.relation.grand_father": "দাদা",
  "workforce.relation.grand_mother": "দাদি"
};
var EIS_PAYMENT_TYPES = {
  "monthly": "Monthly",
  "onetime": "One Time",
  "installment": "Tri Monthly Installment"
};

var ROUTE_HOME = "home";
var ROUTE_ADMINISTRATIVE_LOGIN = "administrative/login";
var ROUTE_WORKFORCE_ORGANIZATIONS = "workforce/organizations";
var ROUTE_WORKFORCE_ORGANIZATIONS_UNITS = "workforce/organizations/units";
var ROUTE_ORGANIZATIONS_UNIT_DESIGNATIONS = "workforce/organizations/unit/designations";
var ROUTE_ORGANIZATIONS_UNIT_DESIGNATIONS_DESIGNATION = "workforce/organizations/unit/designations/designation";
var ROUTE_WORKFORCE_ORGANIZATIONS_ORGANIZATION = "workforce/organizations/organization";
var ROUTE_WORKFORCE_ORGANIZATIONS_UNITS_UNIT = "workforce/organizations/units/unit";
var ROUTE_WORKFORCE_ORGANIZATIONS_EMPLOYEES = "workforce/organizations/employees";
var ROUTE_WORKFORCE_ORGANIZATIONS_EMPLOYEES_EMPLOYEE = "workforce/organizations/employees/employee";
var ROUTE_WORKFORCE_ORGANIZATIONS_EMPLOYEES_EMPLOYEE_ACCOUNT_INFO = "workforce/organizations/employees/employee/account-info";
var ROUTE_WORKFORCE_ORGANIZATIONS_EMPLOYEES_EMPLOYEE_SERVICES = "workforce/organizations/employees/employee/services";
var ROUTE_WORKFORCE_ORGANIZATIONS_EMPLOYEES_DESIGNATION = "workforce/organizations/employees/designation";
var ROUTE_WORKFORCE_OFFICES = "workforce/offices";
var ROUTE_WORKFORCE_OFFICES_OFFICE = "workforce/offices/office";
var ROUTE_WORKFORCE_COMPANIES = "workforce/companies";
var ROUTE_WORKFORCE_APPROVE_COMPANIES = "workforce/approve/companies";
var ROUTE_WORKFORCE_APPROVE_COMPANIES_COMPANY = "workforce/approve/companies/company";
var ROUTE_WORKFORCE_APPROVE_EDIT_COMPANIES_COMPANY = "workforce/approve/edit/companies/company";
var ROUTE_WORKFORCE_COMPANIES_COMPANY = "workforce/companies/company";
var ROUTE_WORKFORCE_EDIT_COMPANIES_COMPANY = "workforce/edit/companies/company";
var ROUTE_WORKFORCE_FACTORIES = "workforce/factories";
var ROUTE_WORKFORCE_FACTORIES_FACTORY = "workforce/factories/factory";
var ROUTE_WORKFORCE_FACTORIES_FACTORY_VIEW = "workforce/factories/factory/view";
var ROUTE_WORKFORCE_EMPLOYEES = "workforce/employees";
var ROUTE_WORKFORCE_EMPLOYEES_EMPLOYEE = "workforce/employees/employee";
var ROUTE_WORKFORCE_EMPLOYEES_DEPENDENTS = "workforce/employees/dependents";
var ROUTE_WORKFORCE_EMPLOYEES_DEPENDENTS_DEPENDENT = "workforce/employees/dependents/dependent";
var ROUTE_WORKFORCE_EMPLOYEES_SERVICES = "workforce/employees/services";
var ROUTE_WORKFORCE_EMPLOYEES_SERVICES_SERVICE = "workforce/employees/services/service";
var ROUTE_WORKFORCE_EMPLOYEES_ACCIDENT_INFOS = "workforce/employees/accident/infos";
var ROUTE_WORKFORCE_EMPLOYEES_ACCIDENT_INFOS_INFO = "workforce/employees/accident/infos/info";
var ROUTE_WORKFORCE_EMPLOYEES_ACCOUNT_INFOS = "workforce/employees/account/infos";
var ROUTE_WORKFORCE_EMPLOYEES_ACCOUNT_INFOS_INFO = "workforce/employees/account/infos/info";
var ROUTE_WORKFORCE_EMPLOYEE_FACTORIES = "workforce/employee/factories";
var ROUTE_WORKFORCE_FACTORY_EMPLOYEE_DESIGNATION = "workforce/employee/factory/employee/designation";
var ROUTE_WORKFORCE_BANKS = "workforce/banks";
var ROUTE_WORKFORCE_BANKS_BANK = "workforce/banks/bank";
var ROUTE_WORKFORCE_ASSOCIATIONS = "workforce/associations";
var ROUTE_WORKFORCE_ASSOCIATIONS_ASSOCIATION = "workforce/associations/association";
var ROUTE_WORKFORCE_REGISTRATION = "registration";
var ROUTE_WORKFORCE_APPLICATION = "workforce/application";
var ROUTE_WORKFORCE_APPLICATION_EIS = "workforce/application/eis";
var ROUTE_WORKFORCE_APPLICATIONS_PROCESS = "workforce/applications/process";
var ROUTE_WORKFORCE_APPLICATIONS_APPLICATION_VIEW_PROCESS = "workforce/applications/application/view";
var ROUTE_WORKFORCE_APPLICATIONS_APPLICATION_VERIFY = "workforce/applications/application/verify";
var ROUTE_WORKFORCE_APPLICATIONS_APPLICATION_ACTIONS = "workforce/applications/application/actions";
var ROUTE_WORKFORCE_APPLICATIONS_APPLICATION_RESEND = "workforce/applications/application/resend";
var ROUTE_WORKFORCE_REPORTS_BENEFICIARY_REPORT = "workforce/reports/beneficiary-report";
var ROUTE_WORKFORCE_ASSOCIATION_USER_MAP = "workforce/associations/user-map";
var ROUTE_WORKFORCE_COMMITTEE_MANAGEMENT = "workforce/committee-management";
var ROUTE_WORKFORCE_VERIFY_CONFIRMATION = "workforce/confirmation";
var ROUTE_WORKFORCE_NOA_CONFIRMATION = "noa/confirmation";
var ROUTE_WEBSITE_LEGAL_GUIDELINES = "workforce/website/legal-guidelines";
var ROUTE_WEBSITE_VISITOR_MESSAGES = "workforce/website/visitor-messages";

// export const ROUTE_WORKFORCE_ORGANIZATIONS_EMPLOYEES_DESIGNATION_EMPLOYEE = "workforce/organizations/employees/employee";

var RIGHT_ORGANIZATION_CREATE = 801003;
var RIGHT_ORGANIZATION_EDIT = 801004;

function WorkforceMainMenu(props) {
  var user_type = getUserType();
  var entries = [
  // {
  //   text: <FormattedMessage module={MODULE_NAME} id="menu.workforce.organizations" />,
  //   icon: <ListAlt />,
  //   route: `/${ROUTE_WORKFORCE_ORGANIZATIONS}`,
  //   id: `menu.workforce.organizations`,
  //   // filter: (rights) => rights.includes(RIGHT_TICKET_SEARCH),
  // },
  // {
  //   text: <FormattedMessage module={MODULE_NAME} id="menu.workforce.organizations.unit" />,
  //   icon: <ListAlt />,
  //   route: `/${ROUTE_WORKFORCE_ORGANIZATIONS_UNITS}`,
  //   id: `menu.workforce.organizations.unit`,
  //   // filter: (rights) => rights.includes(RIGHT_TICKET_SEARCH),
  // },
  // {
  //   text: <FormattedMessage module={MODULE_NAME} id="menu.workforce.organizations.unit.designation" />,
  //   icon: <ListAlt />,
  //   route: `/${ROUTE_ORGANIZATIONS_UNIT_DESIGNATIONS}`,
  //   id: `menu.workforce.organizations.unit.designation`,
  //   // filter: (rights) => rights.includes(RIGHT_TICKET_SEARCH),
  // },
  // {
  //   text: <FormattedMessage module={MODULE_NAME} id="menu.workforce.organizations.employee" />,
  //   icon: <ListAlt />,
  //   route: `/${ROUTE_WORKFORCE_ORGANIZATIONS_EMPLOYEES}`,
  //   id: `menu.workforce.organizations.employee`,
  //   // filter: (rights) => rights.includes(RIGHT_TICKET_SEARCH),
  // },
  // {
  //   text: <FormattedMessage module={MODULE_NAME} id="menu.workforce.organizations.employee.designation" />,
  //   icon: <ListAlt />,
  //   route: `/${ROUTE_WORKFORCE_ORGANIZATIONS_EMPLOYEES_DESIGNATION}`,
  //   id: `menu.workforce.organizations.employee.designation`,
  //   // filter: (rights) => rights.includes(RIGHT_TICKET_SEARCH),
  // },
  // {
  //   text: <FormattedMessage module={MODULE_NAME} id="menu.workforce.company" />,
  //   icon: <ListAlt />,
  //   route: `/${ROUTE_WORKFORCE_COMPANIES}`,
  //   id: `menu.workforce.companies`,
  //   // filter: (rights) => rights.includes(RIGHT_TICKET_SEARCH),
  // },

  // {
  //   text: <FormattedMessage module={MODULE_NAME} id="menu.workforce.office" />,
  //   icon: <ListAlt />,
  //   route: `/${ROUTE_WORKFORCE_OFFICES}`,
  //   id: `menu.workforce.offices`,
  //   // filter: (rights) => rights.includes(RIGHT_TICKET_SEARCH),
  // },
  {
    text: /*#__PURE__*/React.createElement(FormattedMessage, {
      module: MODULE_NAME,
      id: "menu.workforce.factory"
    }),
    icon: /*#__PURE__*/React.createElement(ListAlt, null),
    route: "/".concat(ROUTE_WORKFORCE_FACTORIES),
    id: "menu.workforce.factories"
    // filter: (rights) => rights.includes(RIGHT_TICKET_SEARCH),
  },
  // {
  //   text: <FormattedMessage module={MODULE_NAME} id="menu.workforce.factory.employee.designation" />,
  //   icon: <ListAlt />,
  //   route: `/${ROUTE_WORKFORCE_FACTORY_EMPLOYEE_DESIGNATION}`,
  //   id: `menu.workforce.factory.employee.designation`,
  //   // filter: (rights) => rights.includes(RIGHT_TICKET_SEARCH),
  // },
  // {
  //   text: <FormattedMessage module={MODULE_NAME} id="menu.workforce.approve.company" />,
  //   icon: <ListAlt />,
  //   route: `/${ROUTE_WORKFORCE_APPROVE_COMPANIES}`,
  //   id: `menu.workforce.approve.company`,
  //   filter: (rights) => rights.includes(RIGHT_WORKFORCE_EMPLOYER_APPROVE),
  // },
  {
    text: /*#__PURE__*/React.createElement(FormattedMessage, {
      module: MODULE_NAME,
      id: "menu.workforce.employee"
    }),
    icon: /*#__PURE__*/React.createElement(ListAlt, null),
    route: "/".concat(ROUTE_WORKFORCE_EMPLOYEES),
    id: "menu.workforce.employees"
    // filter: (rights) => rights.includes(RIGHT_TICKET_SEARCH),
  }, {
    text: /*#__PURE__*/React.createElement(FormattedMessage, {
      module: MODULE_NAME,
      id: "menu.workforce.application"
    }),
    icon: /*#__PURE__*/React.createElement(ListAlt, null),
    route: "/".concat(ROUTE_WORKFORCE_APPLICATION),
    id: "menu.workforce.application"
  }, {
    text: /*#__PURE__*/React.createElement(FormattedMessage, {
      module: MODULE_NAME,
      id: "menu.workforce.application.process"
    }),
    icon: /*#__PURE__*/React.createElement(ListAlt, null),
    route: "/".concat(ROUTE_WORKFORCE_APPLICATIONS_PROCESS),
    id: "menu.workforce.application.process"
  }, {
    text: /*#__PURE__*/React.createElement(FormattedMessage, {
      module: MODULE_NAME,
      id: "menu.workforce.banks"
    }),
    icon: /*#__PURE__*/React.createElement(ListAlt, null),
    route: "/".concat(ROUTE_WORKFORCE_BANKS),
    id: "menu.workforce.banks"
    // filter: (rights) => rights.includes(RIGHT_TICKET_SEARCH),
  }, {
    text: /*#__PURE__*/React.createElement(FormattedMessage, {
      module: MODULE_NAME,
      id: "menu.workforce.association"
    }),
    icon: /*#__PURE__*/React.createElement(ListAlt, null),
    route: "/".concat(ROUTE_WORKFORCE_ASSOCIATIONS),
    id: "menu.workforce.association"
    // filter: (rights) => rights.includes(RIGHT_TICKET_SEARCH),
  },
  // {
  //   text: <FormattedMessage module={MODULE_NAME} id="menu.workforce.documents" />,
  //   icon: <ListAlt />,
  //   route: `/${ROUTE_WORKFORCE_DOCUMENTS}`,
  //   id: `menu.workforce.documents`,
  //   // filter: (rights) => rights.includes(RIGHT_TICKET_SEARCH),
  // },
  {
    text: /*#__PURE__*/React.createElement(FormattedMessage, {
      module: MODULE_NAME,
      id: "menu.workforce.association.user.map"
    }),
    icon: /*#__PURE__*/React.createElement(ListAlt, null),
    route: "/".concat(ROUTE_WORKFORCE_ASSOCIATION_USER_MAP),
    id: "menu.workforce.association.user.map"
    // filter: (rights) => rights.includes(RIGHT_TICKET_SEARCH),
  }, {
    text: /*#__PURE__*/React.createElement(FormattedMessage, {
      module: MODULE_NAME,
      id: "menu.workforce.association.user.map"
    }),
    icon: /*#__PURE__*/React.createElement(ListAlt, null),
    route: "/".concat(ROUTE_WORKFORCE_ASSOCIATION_USER_MAP),
    id: "menu.workforce.association.user.map"
    // filter: (rights) => rights.includes(RIGHT_TICKET_SEARCH),
  }, {
    text: /*#__PURE__*/React.createElement(FormattedMessage, {
      module: MODULE_NAME,
      id: "menu.workforce.committee.management"
    }),
    icon: /*#__PURE__*/React.createElement(ListAlt, null),
    route: "/".concat(ROUTE_WORKFORCE_COMMITTEE_MANAGEMENT),
    id: "menu.workforce.committee.management"
    // filter: (rights) => rights.includes(RIGHT_TICKET_SEARCH),
  }

  // {
  //   text: <FormattedMessage module={MODULE_NAME} id="menu.workforce.employee.factory" />,
  //   icon: <ListAlt />,
  //   route: `/${ROUTE_WORKFORCE_EMPLOYEE_FACTORIES}`,
  //   // filter: (rights) => rights.includes(RIGHT_TICKET_SEARCH),
  // },
  ];
  var association_entries = [{
    text: /*#__PURE__*/React.createElement(FormattedMessage, {
      module: MODULE_NAME,
      id: "menu.workforce.factory"
    }),
    icon: /*#__PURE__*/React.createElement(ListAlt, null),
    route: "/".concat(ROUTE_WORKFORCE_FACTORIES),
    id: "menu.workforce.factories"
    // filter: (rights) => rights.includes(RIGHT_TICKET_SEARCH),
  },
  // {
  //   text: <FormattedMessage module={MODULE_NAME} id="menu.workforce.factory.employee.designation" />,
  //   icon: <ListAlt />,
  //   route: `/${ROUTE_WORKFORCE_FACTORY_EMPLOYEE_DESIGNATION}`,
  //   id: `menu.workforce.factory.employee.designation`,
  //   // filter: (rights) => rights.includes(RIGHT_TICKET_SEARCH),
  // },

  {
    text: /*#__PURE__*/React.createElement(FormattedMessage, {
      module: MODULE_NAME,
      id: "menu.workforce.employee"
    }),
    icon: /*#__PURE__*/React.createElement(ListAlt, null),
    route: "/".concat(ROUTE_WORKFORCE_EMPLOYEES),
    id: "menu.workforce.employees"
    // filter: (rights) => rights.includes(RIGHT_TICKET_SEARCH),
  }, {
    text: /*#__PURE__*/React.createElement(FormattedMessage, {
      module: MODULE_NAME,
      id: "menu.workforce.association.user.map"
    }),
    icon: /*#__PURE__*/React.createElement(ListAlt, null),
    route: "/".concat(ROUTE_WORKFORCE_ASSOCIATION_USER_MAP),
    id: "menu.workforce.association.user.map"
    // filter: (rights) => rights.includes(RIGHT_TICKET_SEARCH),
  }];
  var factory_admin_entries = [{
    text: /*#__PURE__*/React.createElement(FormattedMessage, {
      module: MODULE_NAME,
      id: "menu.workforce.employee"
    }),
    icon: /*#__PURE__*/React.createElement(ListAlt, null),
    route: "/".concat(ROUTE_WORKFORCE_EMPLOYEES),
    id: "menu.workforce.employees"
    // filter: (rights) => rights.includes(RIGHT_TICKET_SEARCH),
  }];
  if (user_type === WORKFORCE_USER_TYPE.ADMIN || user_type === WORKFORCE_USER_TYPE.EIS_COORDINATOR || user_type === WORKFORCE_USER_TYPE.SECTION_ADMIN || user_type === WORKFORCE_USER_TYPE.SECTION_ADMIN_TWO || user_type === WORKFORCE_USER_TYPE.BLWF_SECTION_ADMIN) {
    if (user_type === WORKFORCE_USER_TYPE.ADMIN) {
      entries.push({
        text: /*#__PURE__*/React.createElement(FormattedMessage, {
          module: MODULE_NAME,
          id: "menu.website.legal.guidelines"
        }),
        icon: /*#__PURE__*/React.createElement(ListAlt, null),
        route: "/".concat(ROUTE_WEBSITE_LEGAL_GUIDELINES),
        id: "workforce.route.website.legal.guidelines"
        // filter: (rights) => rights.includes(RIGHT_TICKET_SEARCH),
      });
      entries.push({
        text: /*#__PURE__*/React.createElement(FormattedMessage, {
          module: MODULE_NAME,
          id: "menu.website.visitor.messages"
        }),
        icon: /*#__PURE__*/React.createElement(ListAlt, null),
        route: "/".concat(ROUTE_WEBSITE_VISITOR_MESSAGES),
        id: "workforce.route.website.visitor.messages"
        // filter: (rights) => rights.includes(RIGHT_TICKET_SEARCH),
      });
    }
    return /*#__PURE__*/React.createElement(MainMenuContribution, _extends({}, props, {
      header: /*#__PURE__*/React.createElement(FormattedMessage, {
        module: "workforce",
        id: "menu.workforce"
      }),
      entries: entries,
      menuId: "WorkforceMainMenu"
    }));
  } else if (user_type === WORKFORCE_USER_TYPE.ASSOCIATION) {
    return /*#__PURE__*/React.createElement(MainMenuContribution, _extends({}, props, {
      header: /*#__PURE__*/React.createElement(FormattedMessage, {
        module: "workforce",
        id: "menu.factory.management"
      }),
      entries: association_entries,
      menuId: "WorkforceMainMenu"
    }));
  } else if (user_type == WORKFORCE_USER_TYPE.FACTORY_ADMIN) {
    return /*#__PURE__*/React.createElement(MainMenuContribution, _extends({}, props, {
      header: /*#__PURE__*/React.createElement(FormattedMessage, {
        module: "workforce",
        id: "menu.factory.management"
      }),
      entries: factory_admin_entries,
      menuId: "WorkforceMainMenu"
    }));
  } else {
    return /*#__PURE__*/React.createElement(React.Fragment, null);
  }
}
var mapStateToProps$1v = function mapStateToProps(state) {
  return {
    rights: !!state.core && !!state.core.user && !!state.core.user.i_user ? state.core.user.i_user.rights : []
  };
};
var WorkforceMainMenu$1 = withModulesManager(connect(mapStateToProps$1v)(WorkforceMainMenu));

var REQUEST = function REQUEST(actionTypeName) {
  return "".concat(actionTypeName, "_REQ");
};
var SUCCESS = function SUCCESS(actionTypeName) {
  return "".concat(actionTypeName, "_RESP");
};
var ERROR = function ERROR(actionTypeName) {
  return "".concat(actionTypeName, "_ERR");
};
var CLEAR = function CLEAR(actionTypeName) {
  return "".concat(actionTypeName, "_CLEAR");
};

function ownKeys$25(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$25(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$25(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$25(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var ACTION_TYPE = {};
var getUploadIdentity = function getUploadIdentity() {
  var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return (item === null || item === void 0 ? void 0 : item.path) || (item === null || item === void 0 ? void 0 : item.url) || (item === null || item === void 0 ? void 0 : item.name) || (item === null || item === void 0 ? void 0 : item.fieldKey) || (item === null || item === void 0 ? void 0 : item.documentId) || "";
};
var mergeUploadItems = function mergeUploadItems() {
  var existingItems = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var incomingItem = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var normalizedExisting = Array.isArray(existingItems) ? existingItems : [];
  var normalizedIncoming = incomingItem && _typeof(incomingItem) === "object" ? incomingItem : null;
  if (!normalizedIncoming) {
    return normalizedExisting;
  }
  var incomingIdentity = getUploadIdentity(normalizedIncoming);
  if (!incomingIdentity) {
    return [].concat(_toConsumableArray(normalizedExisting), [normalizedIncoming]);
  }
  var existingIndex = normalizedExisting.findIndex(function (item) {
    return getUploadIdentity(item) === incomingIdentity;
  });
  if (existingIndex >= 0) {
    var updated = _toConsumableArray(normalizedExisting);
    updated[existingIndex] = _objectSpread$25(_objectSpread$25({}, updated[existingIndex]), normalizedIncoming);
    return updated;
  }
  return [].concat(_toConsumableArray(normalizedExisting), [normalizedIncoming]);
};
var removeUploadItem = function removeUploadItem() {
  var existingItems = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var identifier = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
  var normalizedExisting = Array.isArray(existingItems) ? existingItems : [];
  if (!identifier) {
    return normalizedExisting;
  }
  return normalizedExisting.filter(function (item) {
    return getUploadIdentity(item) !== identifier;
  });
};
function reducer() {
  var _ref, _parseData$map, _parseData$map2, _parseData$map3, _parseData$map4, _parseData$map5, _parseData$map6, _parseData$map7, _parseData$map8, _parseData$map9, _parseData$map10, _parseData$map11, _parseData$map12, _parseData$map13, _parseData$map14, _action$payload, _parseData$map15, _parseData$map16, _parseData$map17;
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (_ref = {
    ///organizations states
    fetchingOrganizations: false,
    errorOrganizations: null,
    fetchedOrganizations: false,
    organizations: [],
    organizationsPageInfo: {
      totalCount: 0
    },
    fetchingOrganization: false,
    errorOrganization: null,
    fetchedOrganization: false,
    organization: null,
    organizationPageInfo: {
      totalCount: 0
    },
    fetchingOrganizationsPick: false,
    errorOrganizationsPick: null,
    fetchedOrganizationsPick: false,
    organizationsPick: [],
    fetchingNotificationData: false,
    errorNotificationData: null,
    fetchedNotificationData: false,
    notificationData: [],
    notificationDataPageInfo: null,
    fetchingDocumentType: false,
    errorDocumentType: null,
    fetchedDocumentType: false,
    documentType: [],
    fetchingBanksPick: false,
    errorBanksPick: null,
    fetchedBanksPick: false,
    banksPick: [],
    fetchingPostOfficesPick: false,
    errorPostOfficesPick: null,
    fetchedPostOfficesPick: false,
    postOfficesPick: [],
    fetchingWorkforceOtp: false,
    errorWorkforceOtp: null,
    fetchedWorkforceOtp: false,
    workforceOtp: null,
    fetchingBranchPick: false,
    errorBranchPick: null,
    fetchedBranchPick: false,
    branchPick: [],
    fetchingDistrictBanksPick: false,
    errorDistrictBanksPick: null,
    fetchedDistrictBanksPick: false,
    districtBanksPick: [],
    ///representative states
    fetchingRepresentatives: false,
    errorRepresentatives: null,
    fetchedRepresentatives: false,
    representatives: [],
    representativesPageInfo: {
      totalCount: 0
    },
    fetchedRepresentativeByClientMutationId: null,
    fetchedApplicationIdByClientMutationId: null,
    fetchedApplicationSummaryIdByClientMutationId: null,
    fetchedWorkforceOrganizationByDesignationId: null,
    fetchedWorkforceFactoryId: null,
    verifyNidDetails: null,
    ///organizations employee states
    fetchingOrganizationEmployees: false,
    errorOrganizationEmployees: null,
    fetchedOrganizationEmployees: false,
    organizationEmployees: [],
    organizationEmployeesPageInfo: {
      totalCount: 0
    },
    fetchingOrganizationEmployee: false,
    errorOrganizationEmployee: null,
    fetchedOrganizationEmployee: false,
    organizationEmployee: null,
    organizationEmployeePageInfo: {
      totalCount: 0
    },
    ////employee dependent states
    fetchingEmployeeDependents: false,
    errorEmployeeDependents: null,
    fetchedEmployeeDependents: false,
    employeeDependents: [],
    employeeDependentsPageInfo: {
      totalCount: 0
    },
    fetchingEmployeeDependent: false,
    errorEmployeeDependent: null,
    fetchedEmployeeDependent: false,
    employeeDependent: null,
    employeeDependentPageInfo: {
      totalCount: 0
    },
    ///committee bank advice map///
    fetchingCommitteeBankAdviceMap: true,
    fetchedCommitteeBankAdviceMap: false,
    committeeBankAdviceMap: [],
    errorCommitteeBankAdviceMap: null,
    ////employee services states
    fetchingEmployeeServices: false,
    errorEmployeeServices: null,
    fetchedEmployeeServices: false,
    employeeServices: [],
    employeeServicesPageInfo: {
      totalCount: 0
    },
    fetchingEmployeeService: false,
    errorEmployeeService: null,
    fetchedEmployeeService: false,
    employeeService: null,
    employeeServicePageInfo: {
      totalCount: 0
    },
    ///workforce office states
    fetchingWorkforceOffices: false,
    errorWorkforceOffices: null,
    fetchedWorkforceOffices: false,
    workforceOffices: [],
    workforceOfficesPageInfo: {
      totalCount: 0
    },
    fetchingWorkforceOffice: false,
    errorWorkforceOffice: null,
    fetchedWorkforceOffice: false,
    workforceOffice: null,
    workforceOfficePageInfo: {
      totalCount: 0
    },
    fetchingWorkforceOfficesPick: false,
    errorWorkforceOfficesPick: null,
    fetchedWorkforceOfficesPick: false,
    workforceOfficesPick: [],
    ///workforce factory states
    fetchingWorkforceFactories: false,
    errorWorkforceFactories: null,
    fetchedWorkforceFactories: false,
    workforceFactories: [],
    workforceFactoriesPageInfo: {
      totalCount: 0
    },
    fetchingWorkforceFactory: false,
    errorWorkforceFactory: null,
    fetchedWorkforceFactory: false,
    workforceFactory: null,
    workforceFactoryPageInfo: {
      totalCount: 0
    },
    fetchingWorkforceFactoriesPick: false,
    errorWorkforceFactoriesPick: null,
    fetchedWorkforceFactoriesPick: false,
    workforceFactoriesPick: [],
    ///workforce company states
    fetchingWorkforceCompanies: false,
    errorWorkforceCompanies: null,
    fetchedWorkforceCompanies: false,
    workforceCompanies: [],
    workforceCompaniesPageInfo: {
      totalCount: 0
    },
    fetchingWorkforceCompany: false,
    errorWorkforceCompany: null,
    fetchedWorkforceCompany: false,
    workforceCompany: null,
    workforceCompanyPageInfo: {
      totalCount: 0
    },
    fetchingWorkforceCompaniesPick: false,
    errorWorkforceCompaniesPick: null,
    fetchedWorkforceCompaniesPick: false,
    workforceCompaniesPick: [],
    fetchingDistrictOfficePick: false,
    errorDistrictOfficePick: null,
    fetchedDistrictOfficePick: false,
    districtOfficePick: [],
    fetchingEmployeePick: false,
    errorEmployeePick: null,
    fetchedEmployeePick: false,
    employeePick: [],
    ///workforce employee states
    fetchingWorkforceEmployees: false,
    errorWorkforceEmployees: null,
    fetchedWorkforceEmployees: false,
    workforceEmployees: [],
    workforceEmployeesPageInfo: {
      totalCount: 0
    },
    fetchingWorkforceEmployee: false,
    errorWorkforceEmployee: null,
    fetchedWorkforceEmployee: false,
    workforceEmployee: null,
    workforceEmployeePageInfo: {
      totalCount: 0
    },
    ///Unit Designations states
    fetchingUnitDesignations: false,
    errorUnitDesignations: null,
    fetchedUnitDesignations: false,
    unitDesignations: [],
    unitDesignationsPageInfo: {
      totalCount: 0
    },
    fetchingUnitDesignation: false,
    errorUnitDesignation: null,
    fetchedUnitDesignation: false,
    unitDesignation: null,
    ///organization unit states
    fetchingOrganizationUnitsPick: false,
    errorOrganizationUnitsPick: null,
    fetchedOrganizationUnitsPick: false,
    organizationUnitsPick: [],
    fetchingOrganizationUnits: false,
    errorOrganizationUnits: null,
    fetchedOrganizationUnits: false,
    organizationUnits: [],
    organizationUnitsPageInfo: {
      totalCount: 0
    },
    fetchingOrganizationUnit: false,
    errorOrganizationUnit: null,
    fetchedOrganizationUnit: false,
    organizationUnit: null,
    organizationUnitPageInfo: {
      totalCount: 0
    },
    fetchingGrievanceConfig: false,
    fetchedGrievanceConfig: false,
    errorGrievanceConfig: null,
    grievanceConfig: null,
    ///employee designation states
    fetchingEmployeeDesignationData: false,
    fetchedEmployeeDesignationData: false,
    errorEmployeeDesignationData: null,
    employeeDesignationData: null,
    fetchingUnitWiseDesignationData: false,
    fetchedUnitWiseDesignationData: false,
    errorUnitWiseDesignationData: null,
    unitWiseDesignationData: null,
    fetchingWorkforceEmployeeDesignation: false,
    fetchedWorkforceEmployeeDesignation: false,
    errorWorkforceEmployeeDesignation: null,
    workforceEmployeeDesignation: null,
    ///Bank states
    fetchingBanks: false,
    errorBanks: null,
    fetchedBanks: false,
    banks: [],
    banksPageInfo: {
      totalCount: 0
    },
    fetchingBank: false,
    errorBank: null,
    fetchedBank: false,
    bank: null,
    bankPageInfo: {
      totalCount: 0
    },
    fetchingWorkforceDependent: false,
    errorWorkforceDependent: null,
    fetchedWorkforceDependent: false,
    workforceDependent: [],
    workforceDocumentPageInfo: {
      totalCount: 0
    },
    submittingMutation: false,
    mutation: {},
    ////employee accident states
    fetchingEmployeeAccidents: false,
    errorEmployeeAccidents: null,
    fetchedEmployeeAccidents: false,
    employeeAccidents: [],
    employeeAccidentsPageInfo: {
      totalCount: 0
    },
    fetchingEmployeeAccident: false,
    errorEmployeeAccident: null,
    fetchedEmployeeAccident: false,
    employeeAccident: null,
    employeeAccidentPageInfo: {
      totalCount: 0
    },
    ///workforce document ///
    fetchingDocument: false,
    errorDocument: null,
    fetchedDocument: false,
    document: [],
    documentPageInfo: {
      totalCount: 0
    },
    ///workforce other compensation ///
    fetchingOtherCompensation: false,
    errorOtherCompensation: null,
    fetchedOtherCompensation: false,
    otherCompensation: [],
    otherCompensationPageInfo: {
      totalCount: 0
    },
    ////employee Account states
    fetchingEmployeeAccounts: false,
    errorEmployeeAccounts: null,
    fetchedEmployeeAccounts: false,
    employeeAccounts: [],
    employeeAccountsPageInfo: {
      totalCount: 0
    },
    fetchingEmployeeAccount: false,
    errorEmployeeAccount: null,
    fetchedEmployeeAccount: false,
    employeeAccount: null,
    employeeAccountPageInfo: {
      totalCount: 0
    },
    ////Application states
    fetchingApplications: false,
    errorApplications: null,
    fetchedApplications: false,
    applications: [],
    applicationsPageInfo: {
      totalCount: 0
    },
    fetchingApplicationsSummary: false,
    errorApplicationsSummary: null,
    fetchedApplicationsSummary: false,
    applicationsSummary: [],
    applicationsSummaryPageInfo: {
      totalCount: 0
    },
    fetchingApplication: false,
    errorApplication: null,
    fetchedApplication: false,
    application: null,
    applicationPageInfo: {
      totalCount: 0
    }
  }, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_ref, "fetchingApplications", false), "errorApplications", null), "fetchedApplications", false), "applications", []), "applicationsPageInfo", {
    totalCount: 0
  }), "fetchingApplicationsDashboard", false), "errorApplicationsDashboard", null), "fetchedApplicationsDashboard", false), "applicationsDashboard", []), "applicationsDashboardPageInfo", {
    totalCount: 0
  }), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_ref, "fetchingDiseases", false), "errorDiseases", null), "fetchedDiseases", false), "diseases", []), "diseasesPageInfo", {
    totalCount: 0
  }), "fetchingApplication", false), "errorApplication", null), "fetchedApplication", false), "application", null), "applicationPageInfo", {
    totalCount: 0
  }), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_ref, "fetchingApplicationMovements", false), "errorApplicationMovements", null), "fetchedApplicationMovements", false), "applicationMovements", []), "applicationMovementsPageInfo", {
    totalCount: 0
  }), "fetchingApplicationMovement", false), "errorApplicationMovement", null), "fetchedApplicationMovement", false), "applicationMovement", null), "applicationMovementPageInfo", {
    totalCount: 0
  }), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_ref, "fetchingApplicationSummary", false), "errorApplicationSummary", null), "fetchedApplicationSummary", false), "applicationSummary", null), "applicationSummaryPageInfo", {
    totalCount: 0
  }), "fetchingRoleWiseUsers", false), "errorRoleWiseUsers", null), "fetchedRoleWiseUsers", false), "roleWiseUsers", []), "roleWiseUsersPageInfo", {
    totalCount: 0
  }), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_ref, "fetchingEisPayments", false), "errorEisPayments", null), "fetchedEisPayments", false), "eisPayments", []), "eisPaymentsPageInfo", {
    totalCount: 0
  }), "fetchingWorkforceAllAssociations", false), "errorWorkforceAllAssociations", null), "fetchedWorkforceAllAssociations", false), "workforceAllAssociations", []), "workforceAllAssociationsPageInfo", {
    totalCount: 0
  }), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_ref, "fetchingWorkforceCommittees", false), "errorWorkforceCommittees", null), "fetchedWorkforceCommittees", false), "workforceCommittees", []), "workforceCommitteesPageInfo", {
    totalCount: 0
  }), "fetchingWorkforceAllAssociation", false), "errorWorkforceAllAssociation", null), "fetchedWorkforceAllAssociation", false), "workforceAllAssociation", null), "workforceAllAssociationPageInfo", {
    totalCount: 0
  }), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_ref, "fetchingWorkforceAssociationMap", false), "errorWorkforceAssociationMap", null), "fetchedWorkforceAssociationMap", false), "workforceAssociationMap", null), "workforceAssociationMapPageInfo", {
    totalCount: 0
  }), "fetchedSignatureData", []), "uploadedFilesByField", {}), "workforceOtpId", ""), "selectedEmployee", null), "uploadFile", []), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_ref, "uploadDependentFile", []), "uploadBankFile", []), "roles", []), "workforceApplicationStatusCount", {}));
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case "SET_UPLOADED_FILES":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        uploadedFilesByField: _objectSpread$25(_objectSpread$25({}, state.uploadedFilesByField), {}, _defineProperty({}, action.payload.fieldKey, action.payload.files))
      });
    case "REMOVE_UPLOAD_FILE_DATA":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        uploadFile: (state.uploadFile || []).filter(function (item) {
          return item.path !== action.payload;
        })
      });
    case "REMOVE_UPLOADED_FILE":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        uploadedFilesByField: _objectSpread$25(_objectSpread$25({}, state.uploadedFilesByField), {}, _defineProperty({}, action.payload.fieldKey, (state.uploadedFilesByField[action.payload.fieldKey] || []).filter(function (f) {
          return (f === null || f === void 0 ? void 0 : f.name) !== action.payload.fileName;
        })))
      });
    case "CLEAR_ALL_UPLOADED_FILES":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        uploadedFilesByField: {}
      });
    case "SET_UPLOAD_FILE_DATA":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        uploadFile: mergeUploadItems(state.uploadFile, action.payload)
      });
    case "SET_UPLOAD_DEPENDENT_FILE_DATA":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        uploadDependentFile: mergeUploadItems(state.uploadDependentFile, action.payload)
      });
    case "REMOVE_UPLOAD_DEPENDENT_FILE_DATA":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        uploadDependentFile: removeUploadItem(state.uploadDependentFile, action.payload)
      });
    case "SET_UPLOAD_DEPENDENT_BANK_DATA":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        uploadBankFile: mergeUploadItems(state.uploadBankFile, action.payload)
      });
    case "REMOVE_UPLOAD_DEPENDENT_BANK_DATA":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        uploadBankFile: removeUploadItem(state.uploadBankFile, action.payload)
      });
    case "SET_SELECTED_EMPLOYEE":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        selectedEmployee: action.payload
      });
    case "REPLACE_UPLOAD_FILE_DATA":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        uploadFile: action.payload
      });
    case "REPLACE_UPLOAD_DEPENDENT_FILE_DATA":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        uploadDependentFile: action.payload
      });
    case "REPLACE_UPLOAD_DEPENDENT_BANK_DATA":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        uploadBankFile: action.payload
      });
    case "WORKFORCE_REMOVE_UPLOAD_FILE":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        uploadFile: removeUploadItem(state.uploadFile, action.payload)
      });
    case "WORKFORCE_REMOVE_DEPENDENT_FILE":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        uploadDependentFile: removeUploadItem(state.uploadDependentFile, action.payload)
      });
    case "WORKFORCE_REMOVE_BANK_FILE":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        uploadBankFile: removeUploadItem(state.uploadBankFile, action.payload)
      });
    /// all associations////
    case "WORKFORCE_ALL_ASSOCIATIONS_REQ":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        fetchingWorkforceAllAssociations: true,
        fetchedWorkforceAllAssociations: false,
        workforceAllAssociations: [],
        workforceAllAssociationsPageInfo: {
          totalCount: 0
        },
        errorWorkforceAllAssociations: null
      });
    case "WORKFORCE_ALL_ASSOCIATIONS_RESP":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        fetchingWorkforceAllAssociations: false,
        fetchedWorkforceAllAssociations: true,
        workforceAllAssociations: parseData(action.payload.data.workforceAllAssociation),
        workforceAllAssociationsPageInfo: pageInfo(action.payload.data.workforceAllAssociation),
        errorWorkforceAllAssociations: formatGraphQLError(action.payload)
      });
    case "WORKFORCE_ALL_ASSOCIATIONS_ERR":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        fetching: false,
        error: formatServerError(action.payload)
      });

    //workforce committee

    case "WORKFORCE_COMMITTEES_REQ":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        fetchingWorkforceCommittees: true,
        fetchedWorkforceCommittees: false,
        workforceCommittees: [],
        workforceCommitteesPageInfo: {
          totalCount: 0
        },
        errorworkforceCommittees: null
      });
    case "WORKFORCE_COMMITTEES_RESP":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        fetchingWorkforceCommittees: false,
        fetchedWorkforceCommittees: true,
        workforceCommittees: parseData(action.payload.data.workforceCommittee),
        workforceCommitteesPageInfo: pageInfo(action.payload.data.workforceCommittee),
        errorworkforceCommittees: formatGraphQLError(action.payload)
      });
    case "WORKFORCE_COMMITTEES_ERR":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        fetching: false,
        error: formatServerError(action.payload)
      });

    // workforce committee user map

    //workforce committee

    case "WORKFORCE_COMMITTEE_USER_MAP_REQ":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        fetchingWorkforceCommitteeUserMap: true,
        fetchedWorkforceCommitteeUserMap: false,
        workforceCommitteeUserMap: [],
        workforceCommitteeUserMapPageInfo: {
          totalCount: 0
        },
        errorWorkforceCommitteeUserMap: null
      });
    case "WORKFORCE_COMMITTEE_USER_MAP_RESP":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        fetchingWorkforceCommitteeUserMap: false,
        fetchedWorkforceCommitteeUserMap: true,
        workforceCommitteeUserMap: parseData(action.payload.data.workforceCommitteeUserMap),
        workforceCommitteeUserMapPageInfo: pageInfo(action.payload.data.workforceCommitteeUserMap),
        errorWorkforceCommitteeUserMap: formatGraphQLError(action.payload)
      });
    case "WORKFORCE_COMMITTEE_USER_MAP_ERR":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        fetching: false,
        error: formatServerError(action.payload)
      });
    case "WORKFORCE_ASSOCIATION_USER_MAP_REQ":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        fetchingWorkforceAssociationMap: true,
        fetchedWorkforceAssociationMap: false,
        workforceAssociationMap: null,
        workforceAssociationMapPageInfo: {
          totalCount: 0
        },
        errorWorkforceAssociationMap: null
      });
    case "WORKFORCE_ASSOCIATION_USER_MAP_RESP":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        fetchingWorkforceAssociationMap: false,
        fetchedWorkforceAssociationMap: true,
        workforceAssociationMap: parseData(action.payload.data.workforceAssociationUserMap),
        workforceAssociationMapPageInfo: pageInfo(action.payload.data.workforceAssociationUserMap),
        errorWorkforceAssociationMap: formatGraphQLError(action.payload)
      });
    case "WORKFORCE_ASSOCIATION_USER_MAP_ERR":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        fetchingWorkforceAssociationMap: false,
        errorWorkforceAssociationMap: formatServerError(action.payload)
      });
    case "WORKFORCE_ORGANIZATIONS_REQ":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        fetchingOrganizations: true,
        fetchedOrganizations: false,
        organizations: [],
        organizationsPageInfo: {
          totalCount: 0
        },
        errorOrganizations: null
      });
    case "WORKFORCE_ORGANIZATIONS_RESP":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        fetchingOrganizations: false,
        fetchedOrganizations: true,
        organizations: parseData(action.payload.data.workforceOrganizations),
        organizationsPageInfo: pageInfo(action.payload.data.workforceOrganizations),
        errorOrganizations: formatGraphQLError(action.payload)
      });
    case "WORKFORCE_ORGANIZATIONS_ERR":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        fetching: false,
        error: formatServerError(action.payload)
      });
    case "WORKFORCE_ORGANIZATION_REQ":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        fetchingOrganization: true,
        fetchedOrganization: false,
        organization: null,
        errorOrganization: null
      });
    case "WORKFORCE_ORGANIZATION_RESP":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        fetchingOrganization: false,
        fetchedOrganization: true,
        organization: (_parseData$map = parseData(action.payload.data.workforceOrganizations).map(function (Organization) {
          return _objectSpread$25(_objectSpread$25({}, Organization), {}, {
            id: decodeId(Organization.id)
          });
        })) === null || _parseData$map === void 0 ? void 0 : _parseData$map[0],
        errorOrganization: formatGraphQLError(action.payload)
      });
    case "WORKFORCE_DOCUMENT_REQ":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        fetchingDocument: true,
        fetchedDocument: false,
        document: null,
        errorDocument: null
      });
    case "WORKFORCE_DOCUMENT_RESP":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        fetchingDocument: false,
        fetchedDocument: true,
        document: parseData(action.payload.data.workforceDocuments).map(function (doc) {
          return _objectSpread$25(_objectSpread$25({}, doc), {}, {
            worforceDocumentMap: parseData(doc === null || doc === void 0 ? void 0 : doc.workforceDocumentMapDocumentId)
          });
        }),
        errorDocument: formatGraphQLError(action.payload)
      });
    case "WORKFORCE_OTHER_COMPENSATION_REQ":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        fetchingOtherCompensation: true,
        fetchedOtherCompensation: false,
        otherCompensation: null,
        errorOtherCompensation: null
      });
    case "WORKFORCE_OTHER_COMPENSATION_RESP":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        fetchingOtherCompensation: false,
        fetchedOtherCompensation: true,
        otherCompensation: parseData(action.payload.data.workforceOtherCompensationInfo),
        errorDocument: formatGraphQLError(action.payload)
      });
    case "WORKFORCE_ORGANIZATION_UNIT_DESIGNATIONS_REQ":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        fetchingUnitDesignations: true,
        fetchedUnitDesignations: false,
        unitDesignations: [],
        unitDesignationsPageInfo: {
          totalCount: 0
        },
        errorUnitDesignations: null
      });
    case "WORKFORCE_ORGANIZATION_UNIT_DESIGNATIONS_RESP":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        fetchingUnitDesignations: false,
        fetchedUnitDesignations: true,
        unitDesignations: parseData(action.payload.data.workforceOrganizationUnitDesignations),
        unitDesignationsPageInfo: pageInfo(action.payload.data.workforceOrganizationUnitDesignations),
        errorUnitDesignations: formatGraphQLError(action.payload)
      });
    case "WORKFORCE_ORGANIZATION_UNIT_DESIGNATIONS_ERR":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        fetching: false,
        error: formatServerError(action.payload)
      });
    case "WORKFORCE_NOTIFICATION_DATA_REQ":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        fetchingNotificationData: true,
        fetchedNotificationData: false,
        notificationData: [],
        notificationDataPageInfo: {
          totalCount: 0
        },
        errorNotificationData: null
      });
    case "WORKFORCE_NOTIFICATION_DATA_RESP":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        fetchingNotificationData: false,
        fetchedNotificationData: true,
        notificationData: parseData(action.payload.data.workforceNotification),
        notificationDataPageInfo: pageInfo(action.payload.data.workforceNotification),
        errorNotificationData: formatGraphQLError(action.payload)
      });
    case "WORKFORCE_NOTIFICATION_DATA_ERR":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        fetching: false,
        error: formatServerError(action.payload)
      });
    case "WORKFORCE_ORGANIZATIONS_PICKER_REQ":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        fetchingOrganizationsPick: true,
        fetchedOrganizationsPick: false,
        organizationsPick: [],
        errorOrganizationsPick: null
      });
    case "WORKFORCE_ORGANIZATIONS_PICKER_RESP":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        fetchingOrganizationsPick: false,
        fetchedOrganizationsPick: true,
        organizationsPick: parseData(action.payload.data.workforceOrganizations),
        errorOrganizationsPick: formatGraphQLError(action.payload)
      });
    case "WORKFORCE_ORGANIZATIONS_PICKER_ERR":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        fetching: false,
        errorOrganizationsPick: formatServerError(action.payload)
      });
    case "WORKFORCE_DOCUMENT_TYPE_REQ":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        fetchingDocumentType: true,
        fetchedDocumentType: false,
        documentType: [],
        errorDocumentType: null
      });
    case "WORKFORCE_DOCUMENT_TYPE_RESP":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        fetchingDocumentType: false,
        fetchedDocumentType: true,
        documentType: parseData(action.payload.data.workforceDocumentTypes),
        errorDocumentType: formatGraphQLError(action.payload)
      });
    case "WORKFORCE_DOCUMENT_TYPE_ERR":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        fetching: false,
        errorDocumentType: formatServerError(action.payload)
      });
    case "WORKFORCE_COMMITTEE_BANK_ADVICE_REQ":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        fetchingCommitteeBankAdviceMap: true,
        fetchedCommitteeBankAdviceMap: false,
        committeeBankAdviceMap: [],
        errorCommitteeBankAdviceMap: null
      });
    case "WORKFORCE_COMMITTEE_BANK_ADVICE_RESP":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        fetchingCommitteeBankAdviceMap: false,
        fetchedCommitteeBankAdviceMap: true,
        committeeBankAdviceMap: parseData(action.payload.data.workforceCommitteeBankAdviceMaps),
        errorCommitteeBankAdviceMap: formatGraphQLError(action.payload)
      });
    case "WORKFORCE_COMMITTEE_BANK_ADVICE_ERR":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        fetching: false,
        errorDocumentType: formatServerError(action.payload)
      });
    case "WORKFORCE_BANKS_PICKER_REQ":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        fetchingWorkforceDocumentsPick: true,
        fetchedBanksPick: false,
        banksPick: [],
        errorBanksPick: null
      });
    case "WORKFORCE_BANKS_PICKER_RESP":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        fetchingWorkforceDocumentsPick: false,
        fetchedBanksPick: true,
        banksPick: parseData(action.payload.data.workforceBanks),
        errorBanksPick: formatGraphQLError(action.payload)
      });
    case "WORKFORCE_BANKS_PICKER_ERR":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        fetching: false,
        errorBanksPick: formatServerError(action.payload)
      });
    case "WORKFORCE_POST_OFFICE_PICKER_REQ":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        fetchingPostOfficesPick: true,
        fetchedPostOfficesPick: false,
        postOfficesPick: [],
        errorPostOfficesPick: null
      });
    case "WORKFORCE_POST_OFFICE_PICKER_RESP":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        fetchingPostOfficesPick: false,
        fetchedPostOfficesPick: true,
        postOfficesPick: action.payload.data.workforcePostoffice,
        errorPostOfficesPick: formatGraphQLError(action.payload)
      });
    case "WORKFORCE_POST_OFFICE_PICKER_ERR":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        fetching: false,
        errorPostOfficesPick: formatServerError(action.payload)
      });
    case "WORKFORCE_OTP_REQ":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        fetchingWorkforceOtp: true,
        fetchedWorkforceOtp: false,
        workforceOtp: null,
        errorWorkforceOtp: null
      });
    case "WORKFORCE_OTP_RESP":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        fetchingWorkforceOtp: false,
        fetchedWorkforceOtp: true,
        workforceOtp: action.payload.data.workforceOtp,
        errorWorkforceOtp: formatGraphQLError(action.payload)
      });
    case "WORKFORCE_OTP_ERR":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        fetching: false,
        errorWorkforceOtp: formatServerError(action.payload)
      });
    case "WORKFORCE_BRANCH_PICKER_REQ":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        fetchingBranchPick: true,
        fetchedBranchPick: false,
        branchPick: [],
        errorBranchPick: null
      });
    case "WORKFORCE_BRANCH_PICKER_RESP":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        fetchinBranchPick: false,
        fetcheBranchPick: true,
        branchPick: parseData(action.payload.data.workforceBanks),
        erroBranchPick: formatGraphQLError(action.payload)
      });
    case "WORKFORCE_BRANCH_PICKER_ERR":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        fetching: false,
        errorBranchPick: formatServerError(action.payload)
      });
    case "WORKFORCE_DISTRICT_BANKS_PICKER_RESP":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        fetchinDistrictBanksPick: false,
        fetcheDistrictBanksPick: true,
        districtBanksPick: parseData(action.payload.data.workforceBanks),
        errorDistrictBanksPick: formatGraphQLError(action.payload)
      });
    case "WORKFORCE_DISTRICT_BANKS_PICKER_ERR":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        fetching: false,
        errorDistrictBanksPick: formatServerError(action.payload)
      });
    case "WORKFORCE_DISTRICT_BANKS_PICKER_REQ":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        fetchingDistrictBanksPick: true,
        fetchedDistrictBanksPick: false,
        districtBanksPick: [],
        errorDistrictBanksPick: null
      });
    case "WORKFORCE_ORGANIZATION_UNITS_PICKER_REQ":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        fetchingOrganizationUnitsPick: true,
        fetchedOrganizationUnitsPick: false,
        organizationUnitsPick: [],
        errorOrganizationUnitsPick: null
      });
    case "WORKFORCE_ORGANIZATION_UNITS_PICKER_RESP":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        fetchingOrganizationUnitsPick: false,
        fetchedOrganizationUnitsPick: true,
        organizationUnitsPick: parseData(action.payload.data.workforceOrganizationUnits),
        errorOrganizationUnitsPick: formatGraphQLError(action.payload)
      });
    case "WORKFORCE_ORGANIZATION_UNIT_DESIGNATION_REQ":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        fetchingUnitDesignation: true,
        fetchedUnitDesignation: false,
        unitDesignation: null,
        errorUnitDesignation: null
      });
    case "WORKFORCE_ORGANIZATION_UNIT_DESIGNATION_RESP":
      console.log(action.payload.data.workforceOrganizationUnitDesignations);
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        fetchingUnitDesignation: false,
        fetchedUnitDesignation: true,
        unitDesignation: (_parseData$map2 = parseData(action.payload.data.workforceOrganizationUnitDesignations).map(function (unitDesignation) {
          return _objectSpread$25(_objectSpread$25({}, unitDesignation), {}, {
            id: decodeId(unitDesignation.id)
          });
        })) === null || _parseData$map2 === void 0 ? void 0 : _parseData$map2[0],
        errorUnitDesignation: formatGraphQLError(action.payload)
      });
    case "WORKFORCE_ORGANIZATION_UNIT_REQ":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        fetchingOrganizationUnit: true,
        fetchedOrganizationUnit: false,
        organizationUnit: null,
        errorOrganizationUnit: null
      });
    case "WORKFORCE_ORGANIZATION_UNIT_RESP":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        fetchingOrganizationUnit: false,
        fetchedOrganizationUnit: true,
        organizationUnit: (_parseData$map3 = parseData(action.payload.data.workforceOrganizationUnits).map(function (OrganizationUnit) {
          return _objectSpread$25(_objectSpread$25({}, OrganizationUnit), {}, {
            id: decodeId(OrganizationUnit.id)
          });
        })) === null || _parseData$map3 === void 0 ? void 0 : _parseData$map3[0],
        errorOrganizationUnit: formatGraphQLError(action.payload)
      });
    case "WORKFORCE_REPRESENTATIVES_REQ":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        fetchingRepresentatives: true,
        fetchedRepresentatives: false,
        representatives: [],
        representativesPageInfo: {
          totalCount: 0
        },
        errorRepresentatives: null
      });
    case "WORKFORCE_REPRESENTATIVES_RESP":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        fetchingRepresentatives: false,
        fetchedRepresentatives: true,
        representatives: parseData(action.payload.data.workforceRepresentatives),
        representativesPageInfo: pageInfo(action.payload.data.workforceRepresentatives),
        errorRepresentatives: formatGraphQLError(action.payload)
      });
    case "WORKFORCE_REPRESENTATIVES_ERR":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        fetching: false,
        error: formatServerError(action.payload)
      });
    case "WORKFORCE_ORGANIZATION_UNITS_REQ":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        fetchingOrganizationUnits: true,
        fetchedOrganizationUnits: false,
        organizationUnits: [],
        organizationUnitsPageInfo: {
          totalCount: 0
        },
        errorOrganizationUnits: null
      });
    case "WORKFORCE_ORGANIZATION_UNITS_RESP":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        fetchingOrganizationUnits: false,
        fetchedOrganizationUnits: true,
        organizationUnits: parseData(action.payload.data.workforceOrganizationUnits),
        organizationUnitsPageInfo: pageInfo(action.payload.data.workforceOrganizationUnits),
        errorOrganizationUnits: formatGraphQLError(action.payload)
      });
    case "WORKFORCE_ORGANIZATION_UNITS_ERR":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        fetching: false,
        error: formatServerError(action.payload)
      });
    case "WORKFORCE_ORGANIZATION_EMPLOYEES_REQ":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        fetchingOrganizationEmployees: true,
        fetchedOrganizationEmployees: false,
        organizationEmployees: [],
        organizationEmployeesPageInfo: {
          totalCount: 0
        },
        errorOrganizationEmployees: null
      });
    case "WORKFORCE_ORGANIZATION_EMPLOYEES_RESP":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        fetchingOrganizationEmployees: false,
        fetchedOrganizationEmployeess: true,
        organizationEmployees: parseData(action.payload.data.workforceOrganizationEmployees),
        organizationEmployeesPageInfo: pageInfo(action.payload.data.workforceOrganizationEmployees),
        errorOrganizationEmployees: formatGraphQLError(action.payload)
      });
    case "WORKFORCE_ORGANIZATION_EMPLOYEES_ERR":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        fetching: false,
        error: formatServerError(action.payload)
      });
    case "WORKFORCE_ORGANIZATION_EMPLOYEE_REQ":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        fetchingOrganizationEmployee: true,
        fetchedOrganizationEmployee: false,
        organizationEmployee: null,
        errorOrganizationEmployee: null
      });
    case "WORKFORCE_ORGANIZATION_EMPLOYEE_RESP":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        fetchingOrganizationEmployee: false,
        fetchedOrganizationEmployee: true,
        organizationEmployee: (_parseData$map4 = parseData(action.payload.data.workforceOrganizationEmployees).map(function (organizationEmployee) {
          return _objectSpread$25(_objectSpread$25({}, organizationEmployee), {}, {
            id: decodeId(organizationEmployee.id)
          });
        })) === null || _parseData$map4 === void 0 ? void 0 : _parseData$map4[0],
        errorOrganizationEmployee: formatGraphQLError(action.payload)
      });

    ///employee dependent ///
    case "WORKFORCE_EMPLOYEE_DEPENDENT_REQ":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        fetchingEmployeeDependent: true,
        fetchedEmployeeDependent: false,
        employeeDependent: null,
        errorEmployeeDependent: null
      });
    case "WORKFORCE_EMPLOYEE_DEPENDENT_RESP":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        fetchingEmployeeDependent: false,
        fetchedEmployeeDependent: true,
        employeeDependent: (_parseData$map5 = parseData(action.payload.data.workforceEmployeeDependent).map(function (organizationEmployee) {
          return _objectSpread$25(_objectSpread$25({}, organizationEmployee), {}, {
            id: decodeId(organizationEmployee.id)
          });
        })) === null || _parseData$map5 === void 0 ? void 0 : _parseData$map5[0],
        errorEmployeeDependent: formatGraphQLError(action.payload)
      });
    case "WORKFORCE_EMPLOYEES_DEPENDENTS_REQ":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        fetchingEmployeeDependents: true,
        fetchedEmployeeDependents: false,
        employeeDependents: [],
        employeeDependentsPageInfo: {
          totalCount: 0
        },
        errorEmployeeDependents: null
      });
    case "WORKFORCE_EMPLOYEES_DEPENDENTS_RESP":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        fetchingEmployeeDependents: false,
        fetchedEmployeeDependents: true,
        employeeDependents: parseData(action.payload.data.workforceEmployeeDependent),
        employeeDependentsPageInfo: pageInfo(action.payload.data.workforceEmployeeDependent),
        errorEmployeeDependents: formatGraphQLError(action.payload)
      });
    case "WORKFORCE_EMPLOYEES_DEPENDENTS_ERR":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        fetching: false,
        error: formatServerError(action.payload)
      });

    ///employee services
    case "WORKFORCE_EMPLOYEE_SERVICE_REQ":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        fetchingEmployeeService: true,
        fetchedEmployeeService: false,
        employeeService: null,
        errorEmployeeService: null
      });
    case "WORKFORCE_EMPLOYEE_SERVICE_RESP":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        fetchingEmployeeService: false,
        fetchedEmployeeService: true,
        employeeService: (_parseData$map6 = parseData(action.payload.data.workforceEmployeeDesignation).map(function (employeeService) {
          return _objectSpread$25(_objectSpread$25({}, employeeService), {}, {
            id: decodeId(employeeService.id)
          });
        })) === null || _parseData$map6 === void 0 ? void 0 : _parseData$map6[0],
        errorEmployeeService: formatGraphQLError(action.payload)
      });
    case "WORKFORCE_EMPLOYEES_SERVICES_REQ":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        fetchingEmployeeServices: true,
        fetchedEmployeeServices: false,
        employeeServices: [],
        employeeServicesPageInfo: {
          totalCount: 0
        },
        errorEmployeeServices: null
      });
    case "WORKFORCE_EMPLOYEES_SERVICES_RESP":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        fetchingEmployeeServices: false,
        fetchedEmployeeServices: true,
        employeeServices: parseData(action.payload.data.workforceEmployeeDesignation),
        employeeServicesPageInfo: pageInfo(action.payload.data.workforceEmployeeDesignation),
        errorEmployeeServices: formatGraphQLError(action.payload)
      });
    case "WORKFORCE_EMPLOYEES_SERVICES_ERR":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        fetching: false,
        error: formatServerError(action.payload)
      });

    //employee accident //
    case "WORKFORCE_EMPLOYEE_ACCIDENT_REQ":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        fetchingEmployeeAccident: true,
        fetchedEmployeeAccident: false,
        employeeAccident: null,
        errorEmployeeAccident: null
      });
    case "WORKFORCE_EMPLOYEE_ACCIDENT_RESP":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        fetchingEmployeeAccident: false,
        fetchedEmployeeAccident: true,
        employeeAccident: (_parseData$map7 = parseData(action.payload.data.workforceEmployeeAccident).map(function (organizationEmployee) {
          return _objectSpread$25(_objectSpread$25({}, organizationEmployee), {}, {
            id: decodeId(organizationEmployee.id)
          });
        })) === null || _parseData$map7 === void 0 ? void 0 : _parseData$map7[0],
        errorEmployeeAccident: formatGraphQLError(action.payload)
      });
    case "WORKFORCE_EMPLOYEES_ACCIDENTS_REQ":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        fetchingEmployeeAccidents: true,
        fetchedEmployeeAccidents: false,
        employeeAccidents: [],
        employeeAccidentsPageInfo: {
          totalCount: 0
        },
        errorEmployeeAccidents: null
      });
    case "WORKFORCE_EMPLOYEES_ACCIDENTS_RESP":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        fetchingEmployeeAccidents: false,
        fetchedEmployeeAccidents: true,
        employeeAccidents: parseData(action.payload.data.workforceEmployeeAccident),
        employeeAccidentsPageInfo: pageInfo(action.payload.data.workforceEmployeeAccident),
        errorEmployeeAccidents: formatGraphQLError(action.payload)
      });
    case "WORKFORCE_EMPLOYEES_ACCIDENTS_ERR":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        fetching: false,
        error: formatServerError(action.payload)
      });

    //employee account //
    case "WORKFORCE_EMPLOYEE_ACCOUNT_REQ":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        fetchingEmployeeAccount: true,
        fetchedEmployeeAccount: false,
        employeeAccount: null,
        errorEmployeeAccount: null
      });
    case "WORKFORCE_EMPLOYEE_ACCOUNT_RESP":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        fetchingEmployeeAccount: false,
        fetchedEmployeeAccount: true,
        employeeAccount: (_parseData$map8 = parseData(action.payload.data.workforceEmployeeAccount).map(function (organizationEmployee) {
          return _objectSpread$25(_objectSpread$25({}, organizationEmployee), {}, {
            id: decodeId(organizationEmployee.id)
          });
        })) === null || _parseData$map8 === void 0 ? void 0 : _parseData$map8[0],
        errorEmployeeAccount: formatGraphQLError(action.payload)
      });
    case "WORKFORCE_EMPLOYEES_ACCOUNTS_REQ":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        fetchingEmployeeAccounts: true,
        fetchedEmployeeAccounts: false,
        employeeAccounts: [],
        employeeAccountsPageInfo: {
          totalCount: 0
        },
        errorEmployeeAccounts: null
      });
    case "WORKFORCE_EMPLOYEES_ACCOUNTS_RESP":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        fetchingEmployeeAccounts: false,
        fetchedEmployeeAccounts: true,
        employeeAccounts: parseData(action.payload.data.workforceEmployeeAccount),
        employeeAccountsPageInfo: pageInfo(action.payload.data.workforceEmployeeAccount),
        errorEmployeeAccounts: formatGraphQLError(action.payload)
      });
    case "WORKFORCE_EMPLOYEES_ACCOUNTS_ERR":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        fetching: false,
        error: formatServerError(action.payload)
      });

    ////workforce organization employee designation////
    case "WORKFORCE_ORGANIZATIONS_EMPLOYEE_DESIGNATIONS_REQ":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        fetchingEmployeeDesignationData: true,
        fetchedEmployeeDesignationData: false,
        errorEmployeeDesignationData: null,
        employeeDesignationData: null
      });
    case "WORKFORCE_ORGANIZATIONS_EMPLOYEE_DESIGNATIONS_RESP":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        fetchingEmployeeDesignationData: false,
        fetchedEmployeeDesignationData: true,
        employeeDesignationData: (_parseData$map9 = parseData(action.payload.data.workforceOrganizationEmployees).map(function (employeeDesignation) {
          return _objectSpread$25(_objectSpread$25({}, employeeDesignation), {}, {
            id: decodeId(employeeDesignation.id)
          });
        })) === null || _parseData$map9 === void 0 ? void 0 : _parseData$map9[0],
        errorEmployeeDesignationData: formatGraphQLError(action.payload)
      });
    case "WORKFORCE_ORGANIZATIONS_EMPLOYEE_DESIGNATIONS_ERR":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        fetching: false,
        error: formatServerError(action.payload)
      });
    case "WORKFORCE_ORGANIZATIONS_UNITWISE_DESIGNATIONS_REQ":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        fetchingUnitWiseDesignationData: true,
        fetchedUnitWiseDesignationData: false,
        errorUnitWiseDesignationData: null,
        unitWiseDesignationData: null
      });
    case "WORKFORCE_ORGANIZATIONS_UNITWISE_DESIGNATIONS_RESP":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        fetchingUnitWiseDesignationData: false,
        fetchedUnitWiseDesignationData: true,
        unitWiseDesignationData: parseData(action.payload.data.workforceOrganizationUnits)
        // errorUnitWiseDesignationData: formatGraphQLError(action.payload),
      });
    case "WORKFORCE_ORGANIZATIONS_UNITWISE_DESIGNATIONS_ERR":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        fetching: false,
        error: formatServerError(action.payload)
      });
    case "WORKFORCE_EMPLOYEE_DESIGNATIONS_REQ":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        fetchingWorkforceEmployeeDesignation: true,
        fetchedWorkforceEmployeeDesignation: false,
        errorWorkforceEmployeeDesignation: null,
        workforceEmployeeDesignation: null
      });
    case "WORKFORCE_EMPLOYEE_DESIGNATIONS_RESP":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        fetchingWorkforceEmployeeDesignation: false,
        fetchedWorkforceEmployeeDesignation: true,
        workforceEmployeeDesignation: parseData(action.payload.data.workforceEmployeeDesignation)
        // errorUnitWiseDesignationData: formatGraphQLError(action.payload),
      });
    case "WORKFORCE_EMPLOYEE_DESIGNATIONS_ERR":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        fetching: false,
        error: formatServerError(action.payload)
      });

    // start workforce office
    case "WORKFORCE_OFFICES_REQ":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        fetchingWorkforceOffices: true,
        fetchedWorkforceOffices: false,
        workforceOffices: [],
        workforceOfficesPageInfo: {
          totalCount: 0
        },
        errorWorkforceOffices: null
      });
    case "WORKFORCE_OFFICES_RESP":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        fetchingWorkforceOffices: false,
        fetchedWorkforceOffices: true,
        workforceOffices: parseData(action.payload.data.workforceEmployerOffices),
        workforceOfficesPageInfo: pageInfo(action.payload.data.workforceEmployerOffices),
        errorWorkforceOffices: formatGraphQLError(action.payload)
      });
    case "WORKFORCE_OFFICES_ERR":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        fetching: false,
        error: formatServerError(action.payload)
      });
    case "WORKFORCE_OFFICE_REQ":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        fetchingWorkforceOffice: true,
        fetchedWorkforceOffice: false,
        workforceOffice: null,
        errorWorkforceOffice: null
      });
    case "WORKFORCE_OFFICE_RESP":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        fetchingWorkforceOffice: false,
        fetchedWorkforceOffice: true,
        workforceOffice: (_parseData$map10 = parseData(action.payload.data.workforceEmployerOffices).map(function (workforceOffice) {
          return _objectSpread$25(_objectSpread$25({}, workforceOffice), {}, {
            id: decodeId(workforceOffice.id)
          });
        })) === null || _parseData$map10 === void 0 ? void 0 : _parseData$map10[0],
        errorWorkforceOffice: formatGraphQLError(action.payload)
      });
    case "WORKFORCE_OFFICES_PICKER_REQ":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        fetchingWorkforceOfficesPick: true,
        fetchedWorkforceOfficesPick: false,
        workforceOfficesPick: [],
        errorWorkforceOfficesPick: null
      });
    case "WORKFORCE_OFFICES_PICKER_RESP":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        fetchingWorkforceOfficesPick: false,
        fetchedWorkforceOfficesPick: true,
        workforceOfficesPick: parseData(action.payload.data.workforceEmployerOffices),
        errorWorkforceOfficesPick: formatGraphQLError(action.payload)
      });

    // end workforce office

    // start workforce factory
    case "WORKFORCE_ORGANIZATION_FACTORIES_REQ":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        fetchingWorkforceFactories: true,
        fetchedWorkforceFactories: false,
        workforceFactories: [],
        workforceFactoriesPageInfo: {
          totalCount: 0
        },
        errorWorkforceFactories: null
      });
    case "WORKFORCE_ORGANIZATION_FACTORIES_RESP":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        fetchingWorkforceFactories: false,
        fetchedWorkforceFactories: true,
        workforceFactories: parseData(action.payload.data.workforceEmployerFactories),
        workforceFactoriesPageInfo: pageInfo(action.payload.data.workforceEmployerFactories),
        errorWorkforceFactories: formatGraphQLError(action.payload)
      });
    case "WORKFORCE_ORGANIZATION_FACTORIES_ERR":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        fetching: false,
        error: formatServerError(action.payload)
      });
    case "WORKFORCE_FACTORY_REQ":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        fetchingWorkforceFactory: true,
        fetchedWorkforceFactory: false,
        workforceFactory: null,
        errorWorkforceFactory: null
      });
    case "WORKFORCE_FACTORY_RESP":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        fetchingWorkforceFactory: false,
        fetchedWorkforceFactory: true,
        workforceFactory: (_parseData$map11 = parseData(action.payload.data.workforceEmployerFactories).map(function (WorkforceFactory) {
          return _objectSpread$25(_objectSpread$25({}, WorkforceFactory), {}, {
            id: decodeId(WorkforceFactory.id)
          });
        })) === null || _parseData$map11 === void 0 ? void 0 : _parseData$map11[0],
        errorWorkforceFactory: formatGraphQLError(action.payload)
      });
    case "WORKFORCE_FACTORIES_PICKER_REQ":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        fetchingWorkforceFactoriesPick: true,
        fetchedWorkforceFactoriesPick: false,
        workforceFactoriesPick: [],
        errorWorkforceFactoriesPick: null
      });
    case "WORKFORCE_FACTORIES_PICKER_RESP":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        fetchingWorkforceFactoriesPick: false,
        fetchedWorkforceFactoriesPick: true,
        workforceFactoriesPick: parseData(action.payload.data.workforceEmployerFactories),
        errorWorkforceFactoriesPick: formatGraphQLError(action.payload)
      });

    // end workforce factory

    // start workforce company
    case "WORKFORCE_COMPANIES_REQ":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        fetchingWorkforceCompanies: true,
        fetchedWorkforceCompanies: false,
        workforceCompanies: [],
        workforceCompaniesPageInfo: {
          totalCount: 0
        },
        errorWorkforceCompanies: null
      });
    case "WORKFORCE_COMPANIES_RESP":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        fetchingWorkforceCompanies: false,
        fetchedWorkforceCompanies: true,
        workforceCompanies: parseData(action.payload.data.workforceEmployers),
        workforceCompaniesPageInfo: pageInfo(action.payload.data.workforceEmployers),
        errorWorkforceCompanies: formatGraphQLError(action.payload)
      });
    case "WORKFORCE_COMPANIES_ERR":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        fetching: false,
        error: formatServerError(action.payload)
      });
    case "WORKFORCE_COMPANY_REQ":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        fetchingWorkforceCompany: true,
        fetchedWorkforceCompany: false,
        workforceCompany: null,
        errorWorkforceCompany: null
      });
    case "WORKFORCE_COMPANY_RESP":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        fetchingWorkforceCompany: false,
        fetchedWorkforceCompany: true,
        workforceCompany: (_parseData$map12 = parseData(action.payload.data.workforceEmployers).map(function (workforceCompany) {
          return _objectSpread$25(_objectSpread$25({}, workforceCompany), {}, {
            id: decodeId(workforceCompany.id)
          });
        })) === null || _parseData$map12 === void 0 ? void 0 : _parseData$map12[0],
        errorWorkforceCompany: formatGraphQLError(action.payload)
      });
    case "WORKFORCE_COMPANIES_PICKER_REQ":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        fetchingWorkforceCompaniesPick: true,
        fetchedWorkforceCompaniesPick: false,
        workforceCompaniesPick: [],
        errorWorkforceCompaniesPick: null
      });
    case "WORKFORCE_COMPANIES_PICKER_RESP":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        fetchingWorkforceCompaniesPick: false,
        fetchedWorkforceCompaniesPick: true,
        workforceCompaniesPick: parseData(action.payload.data.workforceEmployers).map(function (workforceCompany) {
          return _objectSpread$25(_objectSpread$25({}, workforceCompany), {}, {
            id: decodeId(workforceCompany.id)
          });
        }),
        errorWorkforceCompaniesPick: formatGraphQLError(action.payload)
      });
    case "WORKFORCE_DISTRICT_OFFICE_PICKER_REQ":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        fetchingDistrictOfficePick: true,
        fetchedDistrictOfficePick: false,
        districtOfficePick: [],
        errorDistrictOfficePick: null
      });
    case "WORKFORCE_DISTRICT_OFFICE_PICKER_RESP":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        fetchingDistrictOfficePick: false,
        fetchedDistrictOfficePick: true,
        districtOfficePick: parseData(action.payload.data.workforceEmployers).map(function (workforceCompany) {
          return _objectSpread$25(_objectSpread$25({}, workforceCompany), {}, {
            id: decodeId(workforceCompany.id)
          });
        }),
        errorDistrictOfficePick: formatGraphQLError(action.payload)
      });
    case "WORKFORCE_EMPLOYEE_PICKER_REQ":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        fetchingEmployeePick: true,
        fetchedEmployeePick: false,
        employeePick: [],
        errorEmployeePick: null
      });
    case "WORKFORCE_EMPLOYEE_PICKER_RESP":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        fetchingEmployeePick: false,
        fetchedEmployeePick: true,
        employeePick: parseData(action.payload.data.workforceOrganizationEmployees).map(function (workforceEmployee) {
          return _objectSpread$25(_objectSpread$25({}, workforceEmployee), {}, {
            id: decodeId(workforceEmployee.id)
          });
        }),
        errorEmployeePick: formatGraphQLError(action.payload)
      });

    // end workforce company

    //start workforce employee
    case "WORKFORCE_EMPLOYEES_REQ":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        fetchingWorkforceEmployees: true,
        fetchedWorkforceEmployees: false,
        workforceEmployees: [],
        workforceEmployeesPageInfo: {
          totalCount: 0
        },
        errorWorkforceEmployees: null
      });
    case "WORKFORCE_EMPLOYEES_RESP":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        fetchingWorkforceEmployees: false,
        fetchedWorkforceEmployeess: true,
        workforceEmployees: parseData(action.payload.data.workforceEmployerEmployees),
        workforceEmployeesPageInfo: pageInfo(action.payload.data.workforceEmployerEmployees),
        errorWorkforceEmployees: formatGraphQLError(action.payload)
      });
    case "WORKFORCE_EMPLOYEES_ERR":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        fetching: false,
        error: formatServerError(action.payload)
      });
    case "WORKFORCE_EMPLOYEE_REQ":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        fetchingWorkforceEmployee: true,
        fetchedWorkforceEmployee: false,
        workforceEmployee: null,
        errorWorkforceEmployee: null
      });
    case "WORKFORCE_EMPLOYEE_RESP":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        fetchingWorkforceEmployee: false,
        fetchedWorkforceEmployee: true,
        workforceEmployee: (_parseData$map13 = parseData(action.payload.data.workforceEmployerEmployees).map(function (workforceEmployee) {
          return _objectSpread$25(_objectSpread$25({}, workforceEmployee), {}, {
            id: decodeId(workforceEmployee.id)
          });
        })) === null || _parseData$map13 === void 0 ? void 0 : _parseData$map13[0],
        errorWorkforceEmployee: formatGraphQLError(action.payload)
      });

    //// Admin workforce role-wise users ////
    case "ADMIN_WORKFORCE_ROLE_WISE_USERS_REQ":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        fetchingRoleWiseUsers: true,
        fetchedRoleWiseUsers: false,
        roleWiseUsers: [],
        roleWiseUsersPageInfo: {
          totalCount: 0
        },
        errorRoleWiseUsers: null
      });
    case "ADMIN_WORKFORCE_ROLE_WISE_USERS_RESP":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        fetchingRoleWiseUsers: false,
        fetchedRoleWiseUsers: true,
        roleWiseUsers: action.payload.data.workforceUserRole,
        roleWiseUsersPageInfo: pageInfo(action.payload.data.workforceUserRole),
        errorRoleWiseUsers: formatGraphQLError(action.payload)
      });
    case "ADMIN_WORKFORCE_ROLE_WISE_USERS_ERR":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        fetchingRoleWiseUsers: false,
        fetchedRoleWiseUsers: false,
        roleWiseUsers: [],
        roleWiseUsersPageInfo: {
          totalCount: 0
        },
        errorRoleWiseUsers: formatServerError(action.payload)
      });

    //// eis payment process ////
    case "EIS_PAYMENT_PROCESS_REQ":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        fetchingEisPayments: true,
        fetchedEisPayments: false,
        eisPayments: [],
        eisPaymentsPageInfo: {
          totalCount: 0
        },
        errorEisPayments: null
      });
    case "EIS_PAYMENT_PROCESS_RESP":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        fetchingEisPayments: false,
        fetchedEisPayments: true,
        eisPayments: action.payload.data.workforceEisPaymentProcess,
        eisPaymentsPageInfo: pageInfo(action.payload.data.workforceEisPaymentProcess),
        errorEisPayments: formatGraphQLError(action.payload)
      });
    case "EIS_PAYMENT_PROCESS_ERR":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        fetchingEisPayments: false,
        fetchedEisPayments: false,
        eisPayments: [],
        eisPaymentsPageInfo: {
          totalCount: 0
        },
        errorEisPayments: formatServerError(action.payload)
      });

    //end workforce employee

    case "WORKFORCE_REPRESENTATIVE_BY_CLIENT_MUTATION_ID_RESP":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        fetchedRepresentativeByClientMutationId: parseData(action.payload.data.workforceRepresentatives)
      });
    case "WORKFORCE_APPLICATION_BY_CLIENT_MUTATION_ID_RESP":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        fetchedApplicationIdByClientMutationId: parseData(action.payload.data.workforceApplication)
      });
    case "WORKFORCE_APPLICATION_SUMMARY_BY_CLIENT_MUTATION_ID":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        fetchedApplicationSummaryIdByClientMutationId: parseData(action.payload.data.workforceApplicationSummary)
      });
    case "WORKFORCE_ORGANIZATION_BY_DESIGNATION_MUTATION_ID_RESP":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        fetchedWorkforceOrganizationByDesignationId: parseData(action.payload.data.workforceOrganizationEmployeeDesignations.designation.id)
      });
    case "WORKFORCE_FACTORY_BY_FACTORY_MUTATION_ID_RESP":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        fetchedWorkforceFactoryId: parseData(action.payload.data.workforceEmployerFactories)
      });
    case "WORKFORCE_INFO_ID_BY_CLIENT_MUTATION_ID_RESP":
      return _objectSpread$25({}, state);
    case "WORKFORCE_VERIFY_NID_RESP":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        verifyNidDetails: action.payload.data.workforceNidVerification
      });
    case "WORKFORCE_SIGNATURE_RESP":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        fetchedSignatureData: parseData(action.payload.data.workforceApplication)
      });

    /// bank actions////
    case "WORKFORCE_BANKS_REQ":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        fetchingWorkforceDocuments: true,
        fetchedBanks: false,
        banks: [],
        banksPageInfo: {
          totalCount: 0
        },
        errorBanks: null
      });
    case "WORKFORCE_BANKS_RESP":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        fetchingWorkforceDocuments: false,
        fetchedBanks: true,
        banks: parseData(action.payload.data.banks),
        banksPageInfo: pageInfo(action.payload.data.banks),
        errorBanks: formatGraphQLError(action.payload)
      });
    case "WORKFORCE_BANKS_ERR":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        fetching: false,
        error: formatServerError(action.payload)
      });
    case "WORKFORCE_BANK_REQ":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        fetchingBank: true,
        fetchedBank: false,
        bank: null,
        errorBank: null
      });
    case "WORKFORCE_BANK_RESP":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        fetchingBank: false,
        fetchedBank: true,
        bank: (_parseData$map14 = parseData(action.payload.data.banks).map(function (bank) {
          return _objectSpread$25(_objectSpread$25({}, bank), {}, {
            id: decodeId(bank.id)
          });
        })) === null || _parseData$map14 === void 0 ? void 0 : _parseData$map14[0],
        errorBank: formatGraphQLError(action.payload)
      });
    case "WORKFORCE_DEPENDENT_REQ":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        fetchingWorkforceDependent: true,
        fetchedWorkforceDependent: false,
        workforceDependent: [],
        errorWorkforceDependent: null
      });
    case "WORKFORCE_DEPENDENT_RESP":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        fetchingWorkforceDependent: false,
        fetchedWorkforceDependent: true,
        workforceDependent: parseData(action.payload.data.workforceEmployeeDependent),
        errorWorkforceDependent: formatGraphQLError(action.payload)
      });

    /// Application actions////
    case "WORKFORCE_APPLICATIONS_REQ":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        fetchingApplications: true,
        fetchedApplications: false,
        applications: [],
        applicationsPageInfo: {
          totalCount: 0
        },
        errorApplications: null
      });
    case "WORKFORCE_APPLICATIONS_RESP":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        fetchingApplications: false,
        fetchedApplications: true,
        applications: parseData(action.payload.data.workforceApplication).map(function (application) {
          return _objectSpread$25(_objectSpread$25({}, application), {}, {
            educations: parseData(application.educations)
          });
        }),
        applicationsPageInfo: pageInfo(action.payload.data.workforceApplication),
        errorApplications: formatGraphQLError(action.payload)
      });
    case "WORKFORCE_APPLICATIONS_ERR":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        fetching: false,
        error: formatServerError(action.payload)
      });
    case "WORKFORCE_APPLICATIONS_DASHBOARD_REQ":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        fetchingApplicationsDashboard: true,
        fetchedApplicationsDashboard: false,
        applicationsDashboard: [],
        applicationsDashboardPageInfo: {
          totalCount: 0
        },
        errorApplicationsDashboard: null
      });
    case "WORKFORCE_APPLICATIONS_DASHBOARD_RESP":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        fetchingApplicationsDashboard: false,
        fetchedApplicationsDashboard: true,
        applicationsDashboard: parseData(action.payload.data.workforceApplication).map(function (application) {
          return _objectSpread$25(_objectSpread$25({}, application), {}, {
            educations: parseData(application.educations)
          });
        }),
        applicationsDashboardPageInfo: pageInfo(action.payload.data.workforceApplication),
        errorApplicationsDashboard: formatGraphQLError(action.payload)
      });
    case "WORKFORCE_APPLICATIONS_DASHBOARD_ERR":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        fetching: false,
        error: formatServerError(action.payload)
      });
    case "WORKFORCE_USER_ROLES_RESP":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        roles: action === null || action === void 0 || (_action$payload = action.payload) === null || _action$payload === void 0 || (_action$payload = _action$payload.data) === null || _action$payload === void 0 ? void 0 : _action$payload.fetchUserRoleByUserId
      });
    case "WORKFORCE_DISEASES_REQ":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        fetchingDiseases: true,
        fetchedDiseases: false,
        diseases: [],
        diseasesPageInfo: {
          totalCount: 0
        },
        errorDiseases: null
      });
    case "WORKFORCE_DISEASES_RESP":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        fetchingDiseases: false,
        fetchedDiseases: true,
        diseases: parseData(action.payload.data.workforceDiseases),
        diseasesPageInfo: pageInfo(action.payload.data.workforceDiseases),
        errorDiseases: formatGraphQLError(action.payload)
      });
    case "WORKFORCE_DISEASES_ERR":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        fetching: false,
        error: formatServerError(action.payload)
      });
    case "WORKFORCE_APPLICATIONS_SUMMARY_REQ":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        fetchingApplicationsSummary: true,
        fetchedApplicationsSummary: false,
        applicationsSummary: [],
        applicationsSummaryPageInfo: {
          totalCount: 0
        },
        errorApplicationsSummary: null
      });
    case "WORKFORCE_APPLICATIONS_SUMMARY_RESP":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        fetchingApplicationsSummary: false,
        fetchedApplicationsSummary: true,
        applicationsSummary: parseData(action.payload.data.workforceApplicationSummary),
        applicationsSummaryPageInfo: pageInfo(action.payload.data.workforceApplicationSummary),
        errorApplicationsSummary: formatGraphQLError(action.payload)
      });
    case "WORKFORCE_APPLICATIONS_SUMMARY_ERR":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        fetching: false,
        error: formatServerError(action.payload)
      });
    case "WORKFORCE_APPLICATION_REQ":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        fetchingApplication: true,
        fetchedApplication: false,
        // application: null,
        errorApplication: null
      });
    case "WORKFORCE_APPLICATION_RESP":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        fetchingApplication: false,
        fetchedApplication: true,
        application: (_parseData$map15 = parseData(action.payload.data.workforceApplication).map(function (application) {
          return _objectSpread$25(_objectSpread$25({}, application), {}, {
            id: decodeId(application.id),
            educations: parseData(application.educations),
            workforceEmployeeDependentApplication: parseData(application.workforceEmployeeDependentApplication),
            employeeBankingInfoApplication: parseData(application.employeeBankingInfoApplication)
          });
        })) === null || _parseData$map15 === void 0 ? void 0 : _parseData$map15[0],
        errorApplication: formatGraphQLError(action.payload)
      });

    /// Application movement actions////
    case "WORKFORCE_APPLICATIONS_MOVEMENT_REQ":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        fetchingApplicationMovements: true,
        fetchedApplicationMovements: false,
        applicationMovements: [],
        applicationMovementsPageInfo: {
          totalCount: 0
        },
        errorApplicationMovements: null
      });
    case "WORKFORCE_APPLICATIONS_MOVEMENT_RESP":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        fetchingApplicationMovements: false,
        fetchedApplicationMovements: true,
        applicationMovements: parseData(action.payload.data.workforceApplicationMovement),
        applicationMovementsPageInfo: pageInfo(action.payload.data.workforceApplicationMovement),
        errorApplicationMovements: formatGraphQLError(action.payload)
      });
    case "WORKFORCE_APPLICATIONS_MOVEMENT_ERR":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        fetchingApplicationMovements: false,
        errorApplicationMovements: formatServerError(action.payload)
      });
    case "WORKFORCE_APPLICATION_MOVEMENT_REQ":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        fetchingApplicationMovement: true,
        fetchedApplicationMovement: false,
        applicationMovement: null,
        errorApplication: null
      });
    case "WORKFORCE_APPLICATION_MOVEMENT_RESP":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        fetchingApplicationMovement: false,
        fetchedApplicationMovement: true,
        applicationMovement: (_parseData$map16 = parseData(action.payload.data.workforceApplicationMovement).map(function (application) {
          return _objectSpread$25(_objectSpread$25({}, application), {}, {
            id: decodeId(application.id)
          });
        })) === null || _parseData$map16 === void 0 ? void 0 : _parseData$map16[0],
        errorApplication: formatGraphQLError(action.payload)
      });

    /// Application summary actions////

    case "WORKFORCE_APPLICATION_SUMMARY_REQ":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        fetchingApplicationSummary: true,
        fetchedApplicationSummary: false,
        applicationSummary: null,
        applicationSummaryPageInfo: null
      });
    case "WORKFORCE_APPLICATION_SUMMARY_RESP":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        fetchingApplicationSummary: false,
        fetchedApplicationSummary: true,
        applicationSummaryPageInfo: (_parseData$map17 = parseData(action.payload.data.workforceApplicationSummary).map(function (application) {
          return _objectSpread$25(_objectSpread$25({}, application), {}, {
            id: decodeId(application.id)
          });
        })) === null || _parseData$map17 === void 0 ? void 0 : _parseData$map17[0],
        errorApplicationSummary: formatGraphQLError(action.payload)
      });
    case "ORG_UNIT_CREATE_RESP":
      return dispatchMutationResp(state, action);
    case CLEAR(ACTION_TYPE.CLEAR_TICKET):
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        fetchingOrganization: false,
        fetchedOrganization: false,
        Organization: null,
        errorOrganization: null
      });
    case REQUEST(ACTION_TYPE.GET_GRIEVANCE_CONFIGURATION):
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        fetchingGrievanceConfig: true,
        fetchedGrievanceConfig: false,
        errorGrievanceConfig: null,
        grievanceConfig: null
      });
    case SUCCESS(ACTION_TYPE.GET_GRIEVANCE_CONFIGURATION):
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        fetchingGrievanceConfig: false,
        fetchedGrievanceConfig: true,
        errorGrievanceConfig: null,
        grievanceConfig: action.payload.data.grievanceConfig
      });
    case ERROR(ACTION_TYPE.GET_GRIEVANCE_CONFIGURATION):
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        fetchingGrievanceConfig: false,
        fetchedGrievanceConfig: false,
        errorGrievanceConfig: formatGraphQLError(action.payload),
        grievanceConfig: null
      });
    case "WORKFORCE_APPLICATION_STATUS_COUNT_RESP":
      return _objectSpread$25(_objectSpread$25({}, state), {}, {
        workforceApplicationStatusCount: action.payload.data
      });
    case REQUEST(ACTION_TYPE.MUTATION):
      return dispatchMutationReq(state, action);
    case ERROR(ACTION_TYPE.MUTATION):
      return dispatchMutationErr(state, action);
    case SUCCESS(ACTION_TYPE.RESOLVE_BY_COMMENT):
      return dispatchMutationResp(state, "resolveGrievanceByComment", action);
    case SUCCESS(ACTION_TYPE.REOPEN_TICKET):
      return dispatchMutationResp(state, "reopenTicket", action);
    case "ORG_MUTATION_REQ":
      {
        return dispatchMutationReq(state, action);
      }
    case "ORG_MUTATION_ERR":
      return dispatchMutationErr(state, action);
    case "ORG_CREATE_ORG_RESP":
      return dispatchMutationResp(state, "createOrganization", action);
    case "ORG_UPDATE_ORG_RESP":
      return dispatchMutationResp(state, "updateOrganization", action);
    case "COMPENSATION_MUTATION_REQ":
      {
        return dispatchMutationReq(state, action);
      }
    case "COMPENSATION_MUTATION_ERR":
      return dispatchMutationErr(state, action);
    case "COMPENSATION_CREATE_COMPENSATION_RESP":
      return dispatchMutationResp(state, "createOrganization", action);
    case "COMPENSATION_UPDATE_COMPENSATION_RESP":
      return dispatchMutationResp(state, "updateOrganization", action);
    case "OTP_MUTATION_REQ":
      {
        return dispatchMutationReq(state, action);
      }
    case "OTP_MUTATION_ERR":
      return dispatchMutationErr(state, action);
    case "OTP_CREATE_OTP_RESP":
      return dispatchMutationResp(state, "createWorkforceOtp", action);
    case "OTP_UPDATE_OTP_RESP":
      return dispatchMutationResp(state, "updateOtp", action);
    case "USER_MUTATION_REQ":
      {
        return dispatchMutationReq(state, action);
      }
    case "USER_MUTATION_ERR":
      return dispatchMutationErr(state, action);
    case "USER_CREATE_USER_RESP":
      return dispatchMutationResp(state, "createWorkforceUser", action);
    case "USER_UPDATE_USER_RESP":
      return dispatchMutationResp(state, "updateUser", action);
    case "DOCUMENT_MUTATION_REQ":
      {
        return dispatchMutationReq(state, action);
      }
    case "DOCUMENT_MUTATION_ERR":
      return dispatchMutationErr(state, action);
    case "DOCUMENT_CREATE_DOCUMENT_RESP":
      return dispatchMutationResp(state, "createWorkforceDocument", action);
    case "DOCUMENT_UPDATE_DOCUMENT_RESP":
      return dispatchMutationResp(state, "updateWorkforceDocument", action);
    case "DOCUMENT_MUTATION_MAP_REQ":
      {
        return dispatchMutationReq(state, action);
      }
    case "DOCUMENT_MUTATION_MAP_ERR":
      return dispatchMutationErr(state, action);
    case "DOCUMENT_MAP_CREATE_DOCUMENT_RESP":
      return dispatchMutationResp(state, "createWorkforceDocument", action);
    case "DOCUMENT_MAP_UPDATE_DOCUMENT_RESP":
      return dispatchMutationResp(state, "updateWorkforceDocument", action);
    case "COMPANY_STATUS_MUTATION_REQ":
      {
        return dispatchMutationReq(state, action);
      }
    case "COMPANY_STATUS_MUTATION_ERR":
      return dispatchMutationErr(state, action);
    case "COMPANY_STATUS_CREATE_RESP":
      return dispatchMutationResp(state, "createOrganization", action);
    case "COMPANY_STATUS_UPDATE_RESP":
      return dispatchMutationResp(state, "updateOrganization", action);
    case "REP_MUTATION_REQ":
      {
        return dispatchMutationReq(state, action);
      }
    case "REP_MUTATION_ERR":
      return dispatchMutationErr(state, action);
    case "REP_CREATE_REP_RESP":
      return dispatchMutationResp(state, "createRepresentative", action);
    case "REP_UPDATE_REP_RESP":
      return dispatchMutationResp(state, "updateRepresentative", action);
    case "UNIT_DESIGNATION_MUTATION_REQ":
      {
        return dispatchMutationReq(state, action);
      }
    case "UNIT_DESIGNATION_MUTATION_ERR":
      return dispatchMutationErr(state, action);
    case "UNIT_DESIGNATION_CREATE_UNIT_DESIGNATION_RESP":
      return dispatchMutationResp(state, "createOrganization", action);
    case "UNIT_DESIGNATION_UPDATE_UNIT_DESIGNATION_RESP":
      return dispatchMutationResp(state, "createOrganization", action);
    case "EMPLOYEE_DESIGNATION_MUTATION_REQ":
      {
        return dispatchMutationReq(state, action);
      }
    case "EMPLOYEE_DESIGNATION_MUTATION_ERR":
      return dispatchMutationErr(state, action);
    case "EMPLOYEE_DESIGNATION_UPDATE_RELEASE_RESP":
      return dispatchMutationResp(state, "updateOrganization", action);
    case "EMPLOYEE_ASSIGN_DESIGNATION_MUTATION_REQ":
      {
        return dispatchMutationReq(state, action);
      }
    case "EMPLOYEE_ASSIGN_DESIGNATION_MUTATION_ERR":
      return dispatchMutationErr(state, action);
    case "EMPLOYEE_DESIGNATION_UPDATE_ASSIGN_RESP":
      return dispatchMutationResp(state, "createWorkforceOrganizationEmployeeDesignation", action);
    case "WORKFORCE_EMPLOYEE_ASSIGN_DESIGNATION_MUTATION_REQ":
      {
        return dispatchMutationReq(state, action);
      }
    case "WORKFORCE_EMPLOYEE_ASSIGN_DESIGNATION_MUTATION_ERR":
      return dispatchMutationErr(state, action);
    case "WORKFORCE_EMPLOYEE_DESIGNATION_UPDATE_ASSIGN_RESP":
      return dispatchMutationResp(state, "createWorkforceEmployeeDesignation", action);
    case "BANK_MUTATION_REQ":
      {
        return dispatchMutationReq(state, action);
      }
    case "BANK_MUTATION_ERR":
      return dispatchMutationErr(state, action);
    case "BANK_CREATE_BANK_RESP":
      return dispatchMutationResp(state, "createBank", action);
    case "BANK_UPDATE_BANK_RESP":
      return dispatchMutationResp(state, "updateBank", action);
    case "DEPENDENT_MUTATION_REQ":
      {
        return dispatchMutationReq(state, action);
      }
    case "DEPENDENT_MUTATION_ERR":
      return dispatchMutationErr(state, action);
    case "DEPENDENT_CREATE_DEPENDENT_RESP":
      return dispatchMutationResp(state, "createWorkforceEmployeeDependent", action);
    case "DEPENDENT_UPDATE_DEPENDENT_RESP":
      return dispatchMutationResp(state, "updateWorkforceEmployeeDependent", action);
    case "EDUCATION_INFO_MUTATION_REQ":
      {
        return dispatchMutationReq(state, action);
      }
    case "EDUCATION_INFO_MUTATION_ERR":
      return dispatchMutationErr(state, action);
    case "EDUCATION_INFO_CREATE_EDUCATION_RESP":
      return dispatchMutationResp(state, "createWorkforceEducation", action);
    case "EDUCATION_INFO_UPDATE_EDUCATION_RESP":
      return dispatchMutationResp(state, "updateWorkforceEducation", action);
    case "DEPENDENT_INFO_MUTATION_REQ":
      {
        return dispatchMutationReq(state, action);
      }
    case "DEPENDENT_INFO_MUTATION_ERR":
      return dispatchMutationErr(state, action);
    case "DEPENDENT_INFO_CREATE_DEPENDENT_RESP":
      return dispatchMutationResp(state, "createWorkforceDependentInfo", action);
    case "DEPENDENT_INFO_UPDATE_DEPENDENT_RESP":
      return dispatchMutationResp(state, "updateWorkforceDependentInfo", action);
    case "APPLICATION_MUTATION_REQ":
      {
        return dispatchMutationReq(state, action);
      }
    case "APPLICATION_MUTATION_ERR":
      return dispatchMutationErr(state, action);
    case "APPLICATION_CREATE_APPLICATION_RESP":
      return dispatchMutationResp(state, "createWorkforceApplication", action);
    case "APPLICATION_UPDATE_APPLICATION_RESP":
      return dispatchMutationResp(state, "updateWorkforceApplication", action);
    case "APPLICATION_MOVEMENT_MUTATION_REQ":
      {
        return dispatchMutationReq(state, action);
      }
    case "APPLICATION_MOVEMENT_MUTATION_ERR":
      return dispatchMutationErr(state, action);
    case "APPLICATION_MOVEMENT_CREATE_APPLICATION_RESP":
      return dispatchMutationResp(state, "createWorkforceApplicationMovement", action);
    case "APPLICATION_MOVEMENT_UPDATE_APPLICATION_RESP":
      return dispatchMutationResp(state, "updateWorkforceApplicationMovement", action);
    case "APPLICATION_SUMMARY_MUTATION_REQ":
      {
        return dispatchMutationReq(state, action);
      }
    case "APPLICATION_SUMMARY_MUTATION_ERR":
      return dispatchMutationErr(state, action);
    case "APPLICATION_SUMMARY_CREATE_APPLICATION_RESP":
      return dispatchMutationResp(state, "createWorkforceApplicationSummary", action);
    case "EMPLOYEE_DEPENDENT_MUTATION_REQ":
      {
        return dispatchMutationReq(state, action);
      }
    case "EMPLOYEE_DEPENDENT_MUTATION_ERR":
      return dispatchMutationErr(state, action);
    case "EMPLOYEE_DEPENDENT_CREATE_EMPLOYEE_DEPENDENT_RESP":
      return dispatchMutationResp(state, "createBank", action);
    case "EMPLOYEE_DEPENDENT_UPDATE_EMPLOYEE_DEPENDENT_RESP":
      return dispatchMutationResp(state, "updateBank", action);
    case "EMPLOYEE_SERVICE_MUTATION_REQ":
      return dispatchMutationReq(state, action);
    case "EMPLOYEE_SERVICE_MUTATION_ERR":
      return dispatchMutationErr(state, action);
    case "EMPLOYEE_SERVICE_CREATE_EMPLOYEE_SERVICE_RESP":
      return dispatchMutationResp(state, "createBank", action);
    case "EMPLOYEE_SERVICE_UPDATE_EMPLOYEE_SERVICE_RESP":
      return dispatchMutationResp(state, "updateBank", action);
    default:
      return state;
  }
}

function _callSuper$1H(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$1H() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$1H() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$1H = function _isNativeReflectConstruct() { return !!t; })(); }
var styles$1y = function styles(theme) {
  return {
    dialogTitle: theme.dialog.title,
    dialogContent: theme.dialog.content,
    form: {
      padding: 0
    },
    item: {
      padding: theme.spacing(1)
    },
    paperDivider: theme.paper.divider
  };
};
var WORKFORCE_ORGANIZATION_FILTER_CONTRIBUTION_KEY = "workforce.organization.Filter";
var OrganizationFilter = /*#__PURE__*/function (_Component) {
  function OrganizationFilter() {
    var _this;
    _classCallCheck(this, OrganizationFilter);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper$1H(this, OrganizationFilter, [].concat(args));
    _defineProperty(_this, "debouncedOnChangeFilter", _debounce(_this.props.onChangeFilters, 800));
    _defineProperty(_this, "_filterValue", function (k) {
      var filters = _this.props.filters;
      return !!filters && !!filters[k] ? filters[k].value : null;
    });
    _defineProperty(_this, "_onChangeReporter", function (k, v) {
      _this.props.onChangeFilters([{
        id: k,
        value: v,
        filter: "".concat(k, ": \"").concat(decodeId(v === null || v === void 0 ? void 0 : v.id), "\"")
      }]);
    });
    _defineProperty(_this, "_onChangeCheckbox", function (key, value) {
      var filters = [{
        id: key,
        value: value,
        filter: "".concat(key, ": ").concat(value)
      }];
      _this.props.onChangeFilters(filters);
      _this.props.setShowHistoryFilter(value);
    });
    return _this;
  }
  _inherits(OrganizationFilter, _Component);
  return _createClass(OrganizationFilter, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        classes = _this$props.classes,
        filters = _this$props.filters,
        onChangeFilters = _this$props.onChangeFilters;
      return /*#__PURE__*/React.createElement(Grid, {
        container: true,
        className: classes.form
      }, /*#__PURE__*/React.createElement(ControlledField, {
        module: MODULE_NAME,
        id: "workforce.organization.name.en",
        field: /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 3,
          className: classes.item
        }, /*#__PURE__*/React.createElement(TextInput, {
          module: MODULE_NAME,
          label: "workforce.organization.name.en",
          name: "nameEn",
          value: this._filterValue("nameEn"),
          onChange: function onChange(v) {
            return _this2.debouncedOnChangeFilter([{
              id: 'nameEn',
              value: v,
              filter: "nameEn_Icontains: \"".concat(v, "\"")
            }]);
          }
        }))
      }), /*#__PURE__*/React.createElement(ControlledField, {
        module: MODULE_NAME,
        id: "workforce.organization.name.bn",
        field: /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 3,
          className: classes.item
        }, /*#__PURE__*/React.createElement(TextInput, {
          module: MODULE_NAME,
          label: "workforce.organization.name.bn",
          name: "nameBn",
          value: this._filterValue("nameBn"),
          onChange: function onChange(v) {
            return _this2.debouncedOnChangeFilter([{
              id: 'nameBn',
              value: v,
              filter: "nameBn_Icontains: \"".concat(v, "\"")
            }]);
          }
        }))
      }), /*#__PURE__*/React.createElement(ControlledField, {
        module: MODULE_NAME,
        id: "workforce.organization.address",
        field: /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 3,
          className: classes.item
        }, /*#__PURE__*/React.createElement(TextInput, {
          module: MODULE_NAME,
          label: "workforce.organization.address",
          name: "address",
          value: this._filterValue("address"),
          onChange: function onChange(v) {
            return _this2.debouncedOnChangeFilter([{
              id: 'address',
              value: v,
              filter: "address_Icontains: \"".concat(v, "\"")
            }]);
          }
        }))
      }), /*#__PURE__*/React.createElement(ControlledField, {
        module: MODULE_NAME,
        id: "workforce.organization.phone",
        field: /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 3,
          className: classes.item
        }, /*#__PURE__*/React.createElement(TextInput, {
          module: MODULE_NAME,
          label: "workforce.organization.phone",
          name: "phoneNumber",
          value: this._filterValue("phoneNumber"),
          onChange: function onChange(v) {
            return _this2.debouncedOnChangeFilter([{
              id: 'phoneNumber',
              value: v,
              filter: "phoneNumber_Icontains: \"".concat(v, "\"")
            }]);
          }
        }))
      }), /*#__PURE__*/React.createElement(ControlledField, {
        module: MODULE_NAME,
        id: "workforce.representative.name.en",
        field: /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 3,
          className: classes.item
        }, /*#__PURE__*/React.createElement(TextInput, {
          module: MODULE_NAME,
          label: "workforce.representative.name.en",
          name: "workforceRepresentative__nameEn",
          value: this._filterValue("workforceRepresentative__nameEn"),
          onChange: function onChange(v) {
            return _this2.debouncedOnChangeFilter([{
              id: 'workforceRepresentative__nameEn',
              value: v,
              filter: "workforceRepresentative__nameEn_Icontains: \"".concat(v, "\"")
            }]);
          }
        }))
      }), /*#__PURE__*/React.createElement(ControlledField, {
        module: MODULE_NAME,
        id: "workforce.representative.name.bn",
        field: /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 3,
          className: classes.item
        }, /*#__PURE__*/React.createElement(TextInput, {
          module: MODULE_NAME,
          label: "workforce.representative.name.bn",
          name: "workforceRepresentative__nameBn",
          value: this._filterValue("workforceRepresentative__nameBn"),
          onChange: function onChange(v) {
            return _this2.debouncedOnChangeFilter([{
              id: 'workforceRepresentative__nameBn',
              value: v,
              filter: "workforceRepresentative__nameBn_Icontains: \"".concat(v, "\"")
            }]);
          }
        }))
      }), /*#__PURE__*/React.createElement(ControlledField, {
        module: MODULE_NAME,
        id: "workforce.representative.address",
        field: /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 3,
          className: classes.item
        }, /*#__PURE__*/React.createElement(TextInput, {
          module: MODULE_NAME,
          label: "workforce.representative.address",
          name: "workforceRepresentative__address",
          value: this._filterValue("workforceRepresentative__address"),
          onChange: function onChange(v) {
            return _this2.debouncedOnChangeFilter([{
              id: 'workforceRepresentative__address',
              value: v,
              filter: "workforceRepresentative__address_Icontains: \"".concat(v, "\"")
            }]);
          }
        }))
      }), /*#__PURE__*/React.createElement(ControlledField, {
        module: MODULE_NAME,
        id: "workforce.representative.phone",
        field: /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 3,
          className: classes.item
        }, /*#__PURE__*/React.createElement(TextInput, {
          module: MODULE_NAME,
          label: "workforce.representative.phone",
          name: "workforceRepresentative__phone",
          value: this._filterValue("workforceRepresentative__phone"),
          onChange: function onChange(v) {
            return _this2.debouncedOnChangeFilter([{
              id: 'workforceRepresentative__phone',
              value: v,
              filter: "workforceRepresentative__phone_Icontains: \"".concat(v, "\"")
            }]);
          }
        }))
      }), /*#__PURE__*/React.createElement(Contributions, {
        filters: filters,
        onChangeFilters: onChangeFilters,
        contributionKey: WORKFORCE_ORGANIZATION_FILTER_CONTRIBUTION_KEY
      }));
    }
  }]);
}(Component);
var OrganizationFilter$1 = withModulesManager(withTheme(withStyles(styles$1y)(OrganizationFilter)));

function _callSuper$1G(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$1G() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$1G() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$1G = function _isNativeReflectConstruct() { return !!t; })(); }
function ownKeys$24(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$24(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$24(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$24(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var styles$1x = function styles(theme) {
  return {
    paper: _objectSpread$24(_objectSpread$24({}, theme.paper.paper), {}, {
      margin: 0
    }),
    paperHeader: _objectSpread$24(_objectSpread$24({}, theme.paper.header), {}, {
      padding: 10
    }),
    tableTitle: theme.table.title,
    fab: theme.fab,
    button: {
      margin: theme.spacing(1)
    },
    item: {
      padding: theme.spacing(1)
    }
  };
};
var OrganizationSearcher = /*#__PURE__*/function (_Component) {
  function OrganizationSearcher(props) {
    var _this;
    _classCallCheck(this, OrganizationSearcher);
    _this = _callSuper$1G(this, OrganizationSearcher, [props]);
    _defineProperty(_this, "fetch", function (prms) {
      var showHistoryFilter = _this.state.showHistoryFilter;
      _this.setState({
        displayVersion: showHistoryFilter
      });
      _this.props.fetchOrganizationsSummary(_this.props.modulesManager, prms);
    });
    _defineProperty(_this, "rowIdentifier", function (r) {
      return r.uuid;
    });
    _defineProperty(_this, "isShowHistory", function () {
      return _this.state.displayVersion;
    });
    _defineProperty(_this, "filtersToQueryParams", function (state) {
      var prms = Object.keys(state.filters).filter(function (f) {
        return !!state.filters[f].filter;
      }).map(function (f) {
        return state.filters[f].filter;
      });
      prms.push("first: ".concat(state.pageSize));
      if (state.afterCursor) {
        prms.push("after: \"".concat(state.afterCursor, "\""));
      }
      if (state.beforeCursor) {
        prms.push("before: \"".concat(state.beforeCursor, "\""));
      }
      if (state.orderBy) {
        prms.push("orderBy: [\"".concat(state.orderBy, "\"]"));
      }
      return prms;
    });
    _defineProperty(_this, "headers", function () {
      return ["workforce.organization.name.en", "workforce.organization.name.bn", "workforce.organization.address", "workforce.organization.phone", "workforce.representative.details", _this.isShowHistory() ? 'workforce.version' : ''];
    });
    _defineProperty(_this, "sorts", function () {
      return [];
    });
    _defineProperty(_this, "itemFormatters", function () {
      var formatters = [function (workforce) {
        return workforce.nameEn;
      }, function (workforce) {
        return workforce.nameBn;
      }, function (workforce) {
        return workforce.address;
      }, function (workforce) {
        return workforce.phoneNumber;
      }, function (workforce) {
        var _workforce$workforceR, _workforce$workforceR2, _workforce$workforceR3, _workforce$workforceR4;
        var nameEn = ((_workforce$workforceR = workforce.workforceRepresentative) === null || _workforce$workforceR === void 0 ? void 0 : _workforce$workforceR.nameEn) || "N/A";
        var nameBn = ((_workforce$workforceR2 = workforce.workforceRepresentative) === null || _workforce$workforceR2 === void 0 ? void 0 : _workforce$workforceR2.nameBn) || "N/A";
        var address = ((_workforce$workforceR3 = workforce.workforceRepresentative) === null || _workforce$workforceR3 === void 0 ? void 0 : _workforce$workforceR3.address) || "N/A";
        var phone = ((_workforce$workforceR4 = workforce.workforceRepresentative) === null || _workforce$workforceR4 === void 0 ? void 0 : _workforce$workforceR4.phoneNumber) || "N/A";
        return "Name En: ".concat(nameEn, "\n, Name Bn: ").concat(nameBn, "\n, Address: ").concat(address, "\n, Phone: ").concat(phone, "\n");
      }, function (workforce) {
        return _this.isShowHistory() ? workforce === null || workforce === void 0 ? void 0 : workforce.version : null;
      }];

      // if (this.props.rights.includes(RIGHT_ORGANIZATION_EDIT)) {
      formatters.push(function (workforce) {
        return /*#__PURE__*/React.createElement(Tooltip, {
          title: "Edit"
        }, /*#__PURE__*/React.createElement(IconButton, {
          disabled: workforce === null || workforce === void 0 ? void 0 : workforce.isHistory,
          onClick: function onClick() {
            historyPush$1(_this.props.modulesManager, _this.props.history, 'workforce.route.organizations.organization', [decodeId(workforce.id)], false);
          }
        }, /*#__PURE__*/React.createElement(EditIcon, null)));
      });

      // }
      return formatters;
    });
    _defineProperty(_this, "rowDisabled", function (selection, i) {
      return !!i.validityTo;
    });
    _defineProperty(_this, "rowLocked", function (selection, i) {
      return !!i.clientMutationId;
    });
    _this.state = {
      // open: false,
      chfid: null,
      confirmedAction: null,
      reset: 0,
      showHistoryFilter: false,
      displayVersion: false
    };
    _this.rowsPerPageOptions = [10, 20, 50, 100];
    _this.defaultPageSize = 10;
    return _this;
  }
  _inherits(OrganizationSearcher, _Component);
  return _createClass(OrganizationSearcher, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState, snapshot) {
      if (prevProps.submittingMutation && !this.props.submittingMutation) {
        this.props.journalize(this.props.mutation);
        this.setState({
          reset: prevState.reset + 1
        });
      } else if (!prevProps.confirmed && this.props.confirmed) {
        this.state.confirmedAction();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props;
        _this$props.intl;
        var organizations = _this$props.organizations,
        organizationsPageInfo = _this$props.organizationsPageInfo,
        fetchingOrganizations = _this$props.fetchingOrganizations,
        fetchedOrganizations = _this$props.fetchedOrganizations,
        errorOrganizations = _this$props.errorOrganizations,
        filterPaneContributionsKey = _this$props.filterPaneContributionsKey,
        cacheFiltersKey = _this$props.cacheFiltersKey,
        _onDoubleClick = _this$props.onDoubleClick;
      var count = organizationsPageInfo.totalCount;
      var filterPane = function filterPane(_ref) {
        var filters = _ref.filters,
          onChangeFilters = _ref.onChangeFilters;
        return /*#__PURE__*/React.createElement(OrganizationFilter$1, {
          filters: filters,
          onChangeFilters: onChangeFilters,
          setShowHistoryFilter: function setShowHistoryFilter(showHistoryFilter) {
            return _this2.setState({
              showHistoryFilter: showHistoryFilter
            });
          }
        });
      };
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Searcher$2, {
        module: MODULE_NAME,
        cacheFiltersKey: cacheFiltersKey,
        FilterPane: filterPane,
        filterPaneContributionsKey: filterPaneContributionsKey,
        items: organizations,
        itemsPageInfo: organizationsPageInfo,
        fetchingItems: fetchingOrganizations,
        fetchedItems: fetchedOrganizations,
        errorItems: errorOrganizations
        // tableTitle={formatMessageWithValues(intl, MODULE_NAME, "ticketSummaries", { count })}
        ,
        tableTitle: /*#__PURE__*/React.createElement(FormattedMessage, {
          module: MODULE_NAME,
          id: "menu.workforce.organizations",
          values: count
        }),
        rowsPerPageOptions: this.rowsPerPageOptions,
        defaultPageSize: this.defaultPageSize,
        fetch: this.fetch,
        rowIdentifier: this.rowIdentifier,
        filtersToQueryParams: this.filtersToQueryParams,
        defaultOrderBy: "-dateCreated",
        headers: this.headers,
        itemFormatters: this.itemFormatters,
        sorts: this.sorts,
        rowDisabled: this.rowDisabled,
        rowLocked: this.rowLocked,
        onDoubleClick: function onDoubleClick(i) {
          return !i.clientMutationId && _onDoubleClick(i);
        },
        reset: this.state.reset
      }));
    }
  }]);
}(Component);
var mapStateToProps$1u = function mapStateToProps(state) {
  return (
    // console.log(state),
    {
      rights: !!state.core && !!state.core.user && !!state.core.user.i_user ? state.core.user.i_user.rights : [],
      organizations: state.workforce.organizations,
      organizationsPageInfo: state.workforce.organizationsPageInfo,
      fetchingOrganizations: state.workforce.fetchingOrganizations,
      fetchedOrganizations: state.workforce.fetchedOrganizations,
      errorOrganizations: state.workforce.errorOrganizations,
      submittingMutation: state.workforce.submittingMutation,
      mutation: state.workforce.mutation,
      confirmed: state.core.confirmed
    }
  );
};
var mapDispatchToProps$R = function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    fetchOrganizationsSummary: fetchOrganizationsSummary,
    journalize: journalize,
    coreConfirm: coreConfirm
  }, dispatch);
};
var OrganizationSearcher$1 = withModulesManager(withHistory(connect(mapStateToProps$1u, mapDispatchToProps$R)(withTheme(withStyles(styles$1x)(OrganizationSearcher)))));

function _callSuper$1F(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$1F() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$1F() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$1F = function _isNativeReflectConstruct() { return !!t; })(); }
var styles$1w = function styles(theme) {
  return {
    page: theme.page,
    fab: theme.fab,
    ROUTE_WORKFORCE_ORGANIZATIONS_ORGANIZATION: ROUTE_WORKFORCE_ORGANIZATIONS_ORGANIZATION
  };
};
var WorkforceOrganizationsPage = /*#__PURE__*/function (_Component) {
  function WorkforceOrganizationsPage() {
    var _this;
    _classCallCheck(this, WorkforceOrganizationsPage);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper$1F(this, WorkforceOrganizationsPage, [].concat(args));
    _defineProperty(_this, "onDoubleClick", function (organization) {
      var newTab = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var routeParams = ["workforce.route.organizations.organization", [decodeId(organization.id)]];
      if (organization !== null && organization !== void 0 && organization.isHistory) {
        routeParams[1].push(organization.version);
      }
      historyPush$1.apply(void 0, [_this.props.modulesManager, _this.props.history].concat(routeParams, [newTab]));
    });
    _defineProperty(_this, "onAdd", function () {
      historyPush$1(_this.props.modulesManager, _this.props.history, "workforce.route.organizations.organization");
    });
    return _this;
  }
  _inherits(WorkforceOrganizationsPage, _Component);
  return _createClass(WorkforceOrganizationsPage, [{
    key: "render",
    value: function render() {
      var _this$props = this.props;
        _this$props.intl;
        var classes = _this$props.classes;
        _this$props.rights;
      return /*#__PURE__*/React.createElement("div", {
        className: classes.page
      }, /*#__PURE__*/React.createElement(OrganizationSearcher$1, {
        cacheFiltersKey: "ticketPageFiltersCache",
        onDoubleClick: this.onDoubleClick
      }), withTooltip(/*#__PURE__*/React.createElement("div", {
        className: classes.fab
      }, /*#__PURE__*/React.createElement(Fab, {
        color: "primary",
        onClick: this.onAdd
      }, /*#__PURE__*/React.createElement(AddIcon, null))), /*#__PURE__*/React.createElement(FormattedMessage, {
        module: MODULE_NAME,
        id: "workforce.organization.addNewTooltip"
      })));
    }
  }]);
}(Component);
var mapStateToProps$1t = function mapStateToProps(state) {
  return {
    rights: !!state.core && !!state.core.user && !!state.core.user.i_user ? state.core.user.i_user.rights : []
  };
};
var WorkforceOrganizationsPage$1 = withModulesManager(withHistory(connect(mapStateToProps$1t)(withTheme(withStyles(styles$1w)(WorkforceOrganizationsPage)))));

// import TextInput from "./TextInput"; // Replace with your actual TextInput component
// import PublishedComponent from "./PublishedComponent"; // Replace with your actual PublishedComponent

var useStyles$1H = makeStyles(function (theme) {
  return {
    paper: theme.paper.paper,
    tableTitle: theme.table.title,
    item: theme.paper.item,
    fullHeight: {
      height: "100%"
    }
  };
});
var WorkforceForm = function WorkforceForm(_ref) {
  var title = _ref.title,
    stateEdited = _ref.stateEdited,
    isSaved = _ref.isSaved,
    updateAttribute = _ref.updateAttribute;
    _ref.save;
    var fields = _ref.fields;
  var classes = useStyles$1H();
  return /*#__PURE__*/React.createElement("div", {
    className: classes.page
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(Paper, {
    className: classes.paper
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    className: classes.tableTitle
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    className: classes.tableTitle
  }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: title,
    values: {
      label: EMPTY_STRING
    }
  })))), /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 2,
    className: classes.item
  }, fields.map(function (field, index) {
    return /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: field.type === "location" ? 12 : 6,
      key: index,
      className: classes.item
    }, field.type === "text" && /*#__PURE__*/React.createElement(TextInput, {
      label: field.label,
      value: field.value || stateEdited[field.key] || "",
      onChange: function onChange(v) {
        return updateAttribute(field.key, v);
      },
      required: field.required,
      readOnly: isSaved,
      type: field.inputType || "text"
    }), field.type === "number" && /*#__PURE__*/React.createElement(TextInput, {
      label: field.label,
      value: field.value || stateEdited[field.key] || "",
      onChange: function onChange(v) {
        return updateAttribute(field.key, v);
      },
      required: field.required,
      readOnly: isSaved,
      type: field.type || "text"
    }), field.type === "email" && /*#__PURE__*/React.createElement(TextInput, {
      label: field.label,
      value: field.value || stateEdited[field.key] || "",
      onChange: function onChange(v) {
        return updateAttribute(field.key, v);
      },
      required: field.required,
      readOnly: isSaved,
      type: "email"
    }), field.type === "date" && /*#__PURE__*/React.createElement(PublishedComponent, {
      pubRef: "workforce.DatePicker",
      label: field.label,
      value: field.value || stateEdited[field.key] || "",
      onChange: function onChange(v) {
        return updateAttribute(field.key, v);
      },
      readOnly: isSaved,
      required: field.required
    }), field.type === "location" && /*#__PURE__*/React.createElement(PublishedComponent, {
      pubRef: "location.DetailedLocation",
      withNull: true,
      split: true,
      value: field.value,
      onChange: function onChange(location) {
        return updateAttribute("repLocation", location);
      },
      readOnly: isSaved,
      required: true
      // readOnly={false}
      ,
      filterLabels: false
    }), field.type === "hidden" && /*#__PURE__*/React.createElement("input", {
      value: stateEdited[field.value] || "",
      onChange: function onChange(v) {
        return updateAttribute(field.key, v);
      },
      required: field.required,
      readOnly: isSaved,
      type: field.type || "hidden"
    }));
  }))))));
};

var OrganizationTypePicker = function OrganizationTypePicker(_ref) {
  _ref.modulesManager;
    var _onChange = _ref.onChange,
    readOnly = _ref.readOnly,
    required = _ref.required,
    _ref$withLabel = _ref.withLabel,
    withLabel = _ref$withLabel === void 0 ? true : _ref$withLabel,
    withPlaceholder = _ref.withPlaceholder,
    value = _ref.value,
    label = _ref.label,
    placeholder = _ref.placeholder,
    filterOptions = _ref.filterOptions,
    filterSelectedOptions = _ref.filterSelectedOptions;
    _ref.multiple;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2);
    _useState2[0];
    var setSearchString = _useState2[1];
  var _useTranslations = useTranslations("workforce"),
    formatMessage = _useTranslations.formatMessage;

  // Adjust the options to match the WORKFORCE_ORGANIZATION_TYPE format
  var WORKFORCE_ORGANIZATION_TYPE = ["organization", "association"];

  // Find the selected option
  var selectedOption = useMemo(function () {
    return WORKFORCE_ORGANIZATION_TYPE.includes(value) ? value : null;
  }, [value]);
  return /*#__PURE__*/React.createElement(Autocomplete, {
    multiple: false,
    required: required,
    placeholder: placeholder !== null && placeholder !== void 0 ? placeholder : "",
    label: label !== null && label !== void 0 ? label : formatMessage("workforce.organization.employee.gender"),
    withLabel: withLabel,
    withPlaceholder: withPlaceholder,
    readOnly: readOnly,
    isLoading: false // Set to false if not loading data dynamically
    ,
    options: WORKFORCE_ORGANIZATION_TYPE,
    value: selectedOption,
    getOptionLabel: function getOptionLabel(option) {
      return option;
    } // Since options are strings, return the string directly
    ,
    onChange: function onChange(option) {
      return _onChange(option, option !== null && option !== void 0 ? option : null);
    },
    filterOptions: filterOptions,
    filterSelectedOptions: filterSelectedOptions,
    onInputChange: setSearchString
  });
};

function ownKeys$23(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$23(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$23(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$23(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper$1E(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$1E() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$1E() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$1E = function _isNativeReflectConstruct() { return !!t; })(); }
var styles$1v = function styles(theme) {
  return {
    paper: theme.paper.paper,
    tableTitle: theme.table.title,
    item: theme.paper.item,
    fullHeight: {
      height: "100%"
    }
  };
};
var EditWorkforceOrganizationPage = /*#__PURE__*/function (_Component) {
  function EditWorkforceOrganizationPage(props) {
    var _this;
    _classCallCheck(this, EditWorkforceOrganizationPage);
    _this = _callSuper$1E(this, EditWorkforceOrganizationPage, [props]);
    _defineProperty(_this, "updateAttribute", function (key, value) {
      _this.setState(function (prevState) {
        return {
          stateEdited: _objectSpread$23(_objectSpread$23({}, prevState.stateEdited), {}, _defineProperty({}, key, value)),
          isSaved: false
        };
      });
    });
    _defineProperty(_this, "save", function () {
      var _stateEdited$workforc, _stateEdited$workforc2, _stateEdited$workforc3, _stateEdited$workforc4, _stateEdited$workforc5, _stateEdited$workforc6, _stateEdited$workforc7, _stateEdited$workforc8, _stateEdited$workforc9, _stateEdited$workforc10, _stateEdited$parent;
      var _this$props = _this.props;
        _this$props.grievanceConfig;
        var dispatch = _this$props.dispatch;
      var stateEdited = _this.state.stateEdited;
      var representativeData = {
        nameBn: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.repNameBn) || (stateEdited === null || stateEdited === void 0 || (_stateEdited$workforc = stateEdited.workforceRepresentative) === null || _stateEdited$workforc === void 0 ? void 0 : _stateEdited$workforc.nameBn),
        nameEn: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.repName) || (stateEdited === null || stateEdited === void 0 || (_stateEdited$workforc2 = stateEdited.workforceRepresentative) === null || _stateEdited$workforc2 === void 0 ? void 0 : _stateEdited$workforc2.nameEn),
        location: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.repLocation) || (stateEdited === null || stateEdited === void 0 || (_stateEdited$workforc3 = stateEdited.workforceRepresentative) === null || _stateEdited$workforc3 === void 0 ? void 0 : _stateEdited$workforc3.location),
        address: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.repAddress) || (stateEdited === null || stateEdited === void 0 || (_stateEdited$workforc4 = stateEdited.workforceRepresentative) === null || _stateEdited$workforc4 === void 0 ? void 0 : _stateEdited$workforc4.address),
        phoneNumber: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.repPhone) || (stateEdited === null || stateEdited === void 0 || (_stateEdited$workforc5 = stateEdited.workforceRepresentative) === null || _stateEdited$workforc5 === void 0 ? void 0 : _stateEdited$workforc5.phoneNumber),
        email: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.repEmail) || (stateEdited === null || stateEdited === void 0 || (_stateEdited$workforc6 = stateEdited.workforceRepresentative) === null || _stateEdited$workforc6 === void 0 ? void 0 : _stateEdited$workforc6.email),
        nid: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.nid) || (stateEdited === null || stateEdited === void 0 || (_stateEdited$workforc7 = stateEdited.workforceRepresentative) === null || _stateEdited$workforc7 === void 0 ? void 0 : _stateEdited$workforc7.nid),
        passportNo: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.passport) || (stateEdited === null || stateEdited === void 0 || (_stateEdited$workforc8 = stateEdited.workforceRepresentative) === null || _stateEdited$workforc8 === void 0 ? void 0 : _stateEdited$workforc8.passportNo),
        birthDate: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.birthDate) || (stateEdited === null || stateEdited === void 0 || (_stateEdited$workforc9 = stateEdited.workforceRepresentative) === null || _stateEdited$workforc9 === void 0 ? void 0 : _stateEdited$workforc9.birthDate),
        position: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.position) || (stateEdited === null || stateEdited === void 0 || (_stateEdited$workforc10 = stateEdited.workforceRepresentative) === null || _stateEdited$workforc10 === void 0 ? void 0 : _stateEdited$workforc10.position),
        id: decodeId(stateEdited.workforceRepresentative.id),
        type: stateEdited.type
      };
      var organizationData = {
        type: stateEdited.type,
        nameBn: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.titleBn) || stateEdited.nameBn,
        nameEn: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.title) || stateEdited.nameEn,
        location: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.location) || stateEdited.location,
        address: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.address) || stateEdited.address,
        phoneNumber: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.phone) || stateEdited.phoneNumber,
        email: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.email) || stateEdited.email,
        website: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.website) || stateEdited.website,
        workforceRepresentativeId: stateEdited.workforceRepresentative.id,
        parent: (stateEdited === null || stateEdited === void 0 || (_stateEdited$parent = stateEdited.parent) === null || _stateEdited$parent === void 0 ? void 0 : _stateEdited$parent.id) || null,
        id: stateEdited.id
      };
      dispatch(updateRepresentative(representativeData, "Update Representative ".concat(representativeData.nameEn)));
      dispatch(updateWorkforceOrganization(organizationData, "Update Organization ".concat(organizationData.nameEn)));
      console.log({
        organizationData: organizationData
      });
      console.log({
        representativeData: representativeData
      });
      _this.setState({
        isSaved: true
      });
    });
    _this.state = {
      stateEdited: props.organization || {},
      isSaved: false
    };
    return _this;
  }
  _inherits(EditWorkforceOrganizationPage, _Component);
  return _createClass(EditWorkforceOrganizationPage, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.organization !== this.props.organization) {
        this.setState({
          stateEdited: this.props.organization
        });
      }
      if (prevProps.submittingMutation && !this.props.submittingMutation) {
        this.props.dispatch(journalize(this.props.mutation));
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var classes = this.props.classes;
      var _this$state = this.state,
        stateEdited = _this$state.stateEdited,
        isSaved = _this$state.isSaved;
      console.log({
        stateEdited: stateEdited
      });
      return /*#__PURE__*/React.createElement("div", {
        className: classes.page
      }, /*#__PURE__*/React.createElement(Grid, {
        container: true
      }, /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12
      }, /*#__PURE__*/React.createElement(Paper, {
        className: classes.paper
      }, /*#__PURE__*/React.createElement(Grid, {
        container: true,
        className: classes.tableTitle
      }, /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12,
        className: classes.tableTitle
      }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(FormattedMessage, {
        module: MODULE_NAME,
        id: "Organization",
        values: {
          label: EMPTY_STRING
        }
      })))), /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement(Grid, {
        container: true,
        className: classes.item
      }, /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.organization.name.en",
        value: stateEdited.nameEn,
        onChange: function onChange(v) {
          return _this2.updateAttribute("title", v);
        },
        required: true,
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.organization.name.bn",
        value: stateEdited.nameBn || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("titleBn", v);
        },
        required: true,
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(PublishedComponent, {
        pubRef: "workforceOrganization.OrganizationPicker",
        value: stateEdited.parent || null,
        onChange: function onChange(option) {
          return _this2.updateAttribute("parent", option);
        },
        required: true,
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.organization.phone",
        value: stateEdited.phoneNumber || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("phone", v);
        },
        required: true,
        type: "number",
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.organization.email",
        value: stateEdited.email || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("email", v);
        },
        required: true,
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.organization.website",
        value: stateEdited.website || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("website", v);
        },
        required: true,
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12,
        className: classes.item
      }, /*#__PURE__*/React.createElement(PublishedComponent, {
        pubRef: "location.DetailedLocation",
        withNull: true,
        value: stateEdited.location,
        onChange: function onChange(location) {
          return _this2.updateAttribute("location", location);
        },
        readOnly: isSaved,
        required: true,
        split: true,
        filterLabels: false
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.organization.address",
        value: stateEdited.address || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("address", v);
        },
        required: true,
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(OrganizationTypePicker, {
        value: stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.type,
        label: /*#__PURE__*/React.createElement(FormattedMessage, {
          id: "workforce.organization.type.picker",
          module: "workforce"
        }),
        onChange: function onChange(v) {
          return _this2.updateAttribute("type", v);
        },
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12,
        className: classes.item
      }, /*#__PURE__*/React.createElement(WorkforceForm, {
        title: "Workforce Representative Info",
        stateEdited: stateEdited,
        isSaved: isSaved,
        updateAttribute: this.updateAttribute,
        fields: [{
          key: "repName",
          label: "workforce.representative.name.en",
          type: "text",
          required: true,
          value: stateEdited.workforceRepresentative.nameEn
        }, {
          key: "repNameBn",
          label: "workforce.representative.name.bn",
          type: "text",
          required: true,
          value: stateEdited.workforceRepresentative.nameBn
        }, {
          key: "position",
          label: "workforce.representative.position",
          type: "text",
          required: true,
          value: stateEdited.workforceRepresentative.position
        }, {
          key: "repPhone",
          label: "workforce.representative.phone",
          type: "number",
          required: true,
          value: stateEdited.workforceRepresentative.phoneNumber
        }, {
          key: "repEmail",
          label: "workforce.representative.email",
          type: "text",
          required: true,
          value: stateEdited.workforceRepresentative.email
        }, {
          key: "nid",
          label: "workforce.representative.nid",
          type: "number",
          required: true,
          value: stateEdited.workforceRepresentative.nid
        }, {
          key: "birthDate",
          label: "workforce.representative.birthDate",
          type: "date",
          required: false,
          value: stateEdited.workforceRepresentative.birthDate
        }, {
          key: "passport",
          label: "workforce.representative.passport",
          type: "text",
          required: false,
          value: stateEdited.workforceRepresentative.passportNo
        }, {
          key: "repLocation",
          label: "workforce.representative.location",
          type: "location",
          required: true,
          value: stateEdited.workforceRepresentative.location
        }, {
          key: "repAddress",
          label: "workforce.representative.address",
          type: "text",
          required: true,
          value: stateEdited.workforceRepresentative.address
        }]
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 11,
        className: classes.item
      }), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 1,
        className: classes.item
      }, /*#__PURE__*/React.createElement(IconButton, {
        variant: "contained",
        component: "label",
        color: "primary",
        onClick: this.save,
        disabled: isSaved
      }, /*#__PURE__*/React.createElement(Save, null)))), /*#__PURE__*/React.createElement(Divider, null)))));
    }
  }]);
}(Component);
var mapStateToProps$1s = function mapStateToProps(state) {
  return {
    // submittingMutation: state.grievanceSocialProtection.submittingMutation,
    // mutation: state.grievanceSocialProtection.mutation,
    // grievanceConfig: state.grievanceSocialProtection.grievanceConfig,
    organization: state.workforce.organization
  };
};
var EditWorkforceOrganizationPage$1 = connect(mapStateToProps$1s)(withTheme(withStyles(styles$1v)(EditWorkforceOrganizationPage)));

function ownKeys$22(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$22(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$22(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$22(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper$1D(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$1D() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$1D() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$1D = function _isNativeReflectConstruct() { return !!t; })(); }
var styles$1u = function styles(theme) {
  return {
    paper: theme.paper.paper,
    tableTitle: theme.table.title,
    item: theme.paper.item,
    fullHeight: {
      height: "100%"
    }
  };
};
var AddWorkforceOrganizationPage = /*#__PURE__*/function (_Component) {
  function AddWorkforceOrganizationPage(props) {
    var _this;
    _classCallCheck(this, AddWorkforceOrganizationPage);
    _this = _callSuper$1D(this, AddWorkforceOrganizationPage, [props]);
    _defineProperty(_this, "save", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _stateEdited$parent;
      var stateEdited, _this$props, dispatch, representativeData, representativeMutation, representativeClientMutationId, representativeId, organizationData;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            stateEdited = _this.state.stateEdited;
            _this$props = _this.props, _this$props.grievanceConfig, dispatch = _this$props.dispatch;
            representativeData = {
              type: stateEdited.type,
              nameBn: stateEdited.repNameBn,
              nameEn: stateEdited.repName,
              location: stateEdited.repLocation,
              address: stateEdited.repAddress,
              phoneNumber: stateEdited.repPhone,
              email: stateEdited.repEmail,
              nid: stateEdited.nid,
              passportNo: stateEdited.passport,
              birthDate: stateEdited.birthDate,
              position: stateEdited.position
            };
            console.log({
              representativeData: representativeData
            });
            _context.next = 6;
            return formatMutation("createWorkforceRepresentative", formatRepresentativeGQL(representativeData), "Created Representative ".concat(representativeData.nameEn));
          case 6:
            representativeMutation = _context.sent;
            representativeClientMutationId = representativeMutation.clientMutationId;
            _context.next = 10;
            return dispatch(createRepresentative(representativeMutation, "Created Representative ".concat(representativeData.nameEn)));
          case 10:
            _context.next = 12;
            return dispatch(fetchRepresentativeByClientMutationId(_this.props.modulesManger, representativeClientMutationId));
          case 12:
            representativeId = _this.props.representativeId[0].id;
            organizationData = {
              type: stateEdited.type,
              nameBn: stateEdited.titleBn,
              nameEn: stateEdited.title,
              location: stateEdited.location,
              address: stateEdited.address,
              phoneNumber: stateEdited.phone,
              email: stateEdited.email,
              website: stateEdited.website,
              parent: (stateEdited === null || stateEdited === void 0 || (_stateEdited$parent = stateEdited.parent) === null || _stateEdited$parent === void 0 ? void 0 : _stateEdited$parent.id) || null,
              // workforceRepresentativeId:this.state.workforce.fetchedRepresentativeByClientMutationId,
              workforceRepresentativeId: representativeId
            };
            console.log({
              organizationData: organizationData
            });
            _context.next = 17;
            return dispatch(createWorkforceOrganization(organizationData, "Created Organization ".concat(organizationData.nameEn)));
          case 17:
            _this.setState({
              isSaved: true
            });
          case 18:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })));
    _defineProperty(_this, "updateAttribute", function (key, value) {
      _this.setState(function (prevState) {
        return {
          stateEdited: _objectSpread$22(_objectSpread$22({}, prevState.stateEdited), {}, _defineProperty({}, key, value)),
          isSaved: false
        };
      });
    });
    _defineProperty(_this, "handleFileUpload", function (uploadedFiles) {
      _this.setState({
        uploadedFiles: uploadedFiles
      });
    });
    _this.state = {
      stateEdited: {},
      isSaved: false
    };
    return _this;
  }
  _inherits(AddWorkforceOrganizationPage, _Component);
  return _createClass(AddWorkforceOrganizationPage, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props2 = this.props,
        submittingMutation = _this$props2.submittingMutation,
        mutation = _this$props2.mutation,
        dispatch = _this$props2.dispatch;
      if (!submittingMutation && prevProps.submittingMutation !== submittingMutation) {
        dispatch(journalize(mutation));
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var classes = this.props.classes;
      var _this$state = this.state,
        stateEdited = _this$state.stateEdited,
        isSaved = _this$state.isSaved,
        uploadedFiles = _this$state.uploadedFiles;
      console.log({
        uploadedFiles: uploadedFiles
      });
      return /*#__PURE__*/React.createElement("div", {
        className: classes.page
      }, /*#__PURE__*/React.createElement(Grid, {
        container: true
      }, /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12
      }, /*#__PURE__*/React.createElement(Paper, {
        className: classes.paper
      }, /*#__PURE__*/React.createElement(Grid, {
        container: true,
        className: classes.tableTitle
      }, /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12,
        className: classes.tableTitle
      }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(FormattedMessage, {
        module: MODULE_NAME,
        id: "Organization",
        values: {
          label: EMPTY_STRING
        }
      })))), /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement(Grid, {
        container: true,
        className: classes.item
      }, /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.organization.name.en",
        value: stateEdited.title || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("title", v);
        },
        required: true,
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.organization.name.bn",
        value: stateEdited.titleBn || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("titleBn", v);
        },
        required: true,
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(PublishedComponent, {
        pubRef: "workforceOrganization.OrganizationPicker",
        value: stateEdited.parent || null,
        onChange: function onChange(option) {
          return _this2.updateAttribute("parent", option);
        },
        required: true,
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.organization.phone",
        value: stateEdited.phone || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("phone", v);
        },
        required: true,
        type: "number",
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.organization.email",
        value: stateEdited.email || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("email", v);
        },
        required: true,
        type: "email",
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.organization.website",
        value: stateEdited.website || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("website", v);
        },
        required: true,
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12,
        className: classes.item
      }, /*#__PURE__*/React.createElement(PublishedComponent, {
        pubRef: "location.DetailedLocation",
        withNull: true,
        value: stateEdited.location || null,
        onChange: function onChange(location) {
          return _this2.updateAttribute("location", location);
        },
        readOnly: isSaved,
        required: true,
        split: true
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.organization.address",
        value: stateEdited.address || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("address", v);
        },
        required: true,
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(OrganizationTypePicker, {
        value: stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.type,
        label: /*#__PURE__*/React.createElement(FormattedMessage, {
          id: "workforce.organization.type.picker",
          module: "workforce"
        }),
        onChange: function onChange(v) {
          return _this2.updateAttribute("type", v);
        },
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12,
        className: classes.item
      }, /*#__PURE__*/React.createElement(WorkforceForm, {
        title: "Workforce Representative Info",
        stateEdited: stateEdited,
        isSaved: isSaved,
        updateAttribute: this.updateAttribute,
        fields: [{
          key: "repName",
          label: "workforce.representative.name.en",
          type: "text",
          required: true
        }, {
          key: "repNameBn",
          label: "workforce.representative.name.bn",
          type: "text",
          required: true
        }, {
          key: "position",
          label: "workforce.representative.position",
          type: "text",
          required: true
        }, {
          key: "repPhone",
          label: "workforce.representative.phone",
          type: "number",
          required: true
        }, {
          key: "repEmail",
          label: "workforce.representative.email",
          type: "email",
          required: true
        }, {
          key: "nid",
          label: "workforce.representative.nid",
          type: "number",
          required: true
        }, {
          key: "passport",
          label: "workforce.representative.passport",
          type: "text",
          required: false
        }, {
          key: "birthDate",
          label: "workforce.representative.birthDate",
          type: "date",
          required: false
        }, {
          key: "repLocation",
          label: "workforce.representative.location",
          type: "location",
          required: true
        }, {
          key: "repAddress",
          label: "workforce.representative.address",
          type: "text",
          required: true
        }]
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 11,
        className: classes.item
      }), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 1,
        className: classes.item
      }, /*#__PURE__*/React.createElement(IconButton, {
        variant: "contained",
        component: "label",
        color: "primary",
        onClick: this.save,
        disabled: isSaved
      }, /*#__PURE__*/React.createElement(Save, null)))), /*#__PURE__*/React.createElement(Divider, null)))));
    }
  }]);
}(Component);
var mapStateToProps$1r = function mapStateToProps(state) {
  return {
    submittingMutation: state.workforce.submittingMutation,
    mutation: state.workforce.mutation,
    representativeId: state.workforce.fetchedRepresentativeByClientMutationId,
    grievanceConfig: state.workforce.grievanceConfig
  };
};
var AddWorkforceOrganizationPage$1 = connect(mapStateToProps$1r)(withStyles(styles$1u)(AddWorkforceOrganizationPage));

function ownKeys$21(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$21(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$21(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$21(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper$1C(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$1C() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$1C() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$1C = function _isNativeReflectConstruct() { return !!t; })(); }
var OrganizationForm = /*#__PURE__*/function (_Component) {
  function OrganizationForm(props) {
    var _this;
    _classCallCheck(this, OrganizationForm);
    _this = _callSuper$1C(this, OrganizationForm, [props]);
    _defineProperty(_this, "reload", function () {
      _this.props.fetchComments(_this.state.ticket);
    });
    _defineProperty(_this, "canSave", function () {
      if (!_this.state.ticket.reporter) return false;
      if (!_this.state.ticket.category) return false;
      return true;
    });
    _defineProperty(_this, "_save", function (ticket) {
      _this.setState({
        lockNew: !ticket.uuid
      }, function () {
        return _this.props.save(ticket);
      });
    });
    _defineProperty(_this, "onEditedChanged", function (ticket) {
      _this.setState({
        ticket: ticket
      });
    });
    _defineProperty(_this, "reopenTicket", function () {
      var _this$props = _this.props,
        intl = _this$props.intl,
        ticket = _this$props.ticket;
      _this.props.reopenTicket(ticket.id, formatMessage(intl, MODULE_NAME, "reopenTicket.mutation.label"));
    });
    _this.state = {
      lockNew: false,
      reset: 0,
      organizationUuid: null,
      ticket: _this._newTicket()
    };
    return _this;
  }
  _inherits(OrganizationForm, _Component);
  return _createClass(OrganizationForm, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // this.props.fetchGrievanceConfiguration();
      if (this.props.organizationUuid) {
        this.setState(function (state, props) {
          return {
            organizationUuid: props.organizationUuid
          };
        });
      }
    }

    // eslint-disable-next-line react/sort-comp
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // this.props.clearTicket();
    }

    // eslint-disable-next-line no-unused-vars
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState, snapshot) {
      if (prevProps.fetchedOrganization !== this.props.fetchedOrganization && !!this.props.fetchedOrganization && !!this.props.ticket) {
        this.setState(function (state, props) {
          return {
            ticket: _objectSpread$21({}, props.ticket),
            organizationUuid: props.ticket.id,
            lockNew: false
          };
        });
      } else if (prevState.organizationUuid !== this.state.organizationUuid) {
        var filters = ["id: \"".concat(this.state.organizationUuid, "\"")];
        if (this.props.ticketVersion) filters.push("ticketVersion: ".concat(this.props.ticketVersion));
        this.props.fetchOrganization(this.props.modulesManager, filters);
      } else if (prevProps.organizationUuid && !this.props.organizationUuid) {
        this.setState({
          ticket: this._newTicket(),
          lockNew: false,
          organizationUuid: null
        });
      } else if (prevProps.submittingMutation && !this.props.submittingMutation) {
        var _this$props2;
        this.props.journalize(this.props.mutation);
        this.setState(function (state) {
          return {
            reset: state.reset + 1
          };
        });
        if ((_this$props2 = this.props) !== null && _this$props2 !== void 0 && (_this$props2 = _this$props2.ticket) !== null && _this$props2 !== void 0 && _this$props2.id) {
          this.props.fetchOrganization(this.props.modulesManager, ["id: \"".concat(this.state.organizationUuid, "\"")]);
        }
      }
    }

    // eslint-disable-next-line react/sort-comp
  }, {
    key: "_newTicket",
    value: function _newTicket() {
      return {};
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
        fetchingOrganization = _this$props3.fetchingOrganization,
        fetchedOrganization = _this$props3.fetchedOrganization,
        errorOrganization = _this$props3.errorOrganization,
        save = _this$props3.save,
        back = _this$props3.back;
      var _this$state = this.state,
        lockNew = _this$state.lockNew,
        reset = _this$state.reset,
        update = _this$state.update,
        overview = _this$state.overview,
        organizationUuid = _this$state.organizationUuid,
        ticket = _this$state.ticket;
      var readOnly = lockNew || !!ticket.validityTo || this.props.readOnly;
      [{
        doIt: this.reopenTicket,
        icon: /*#__PURE__*/React.createElement(LockOpenIcon, null),
        // onlyIfDirty: ticket.status !== TICKET_STATUSES.CLOSED,
        disabled: ticket.isHistory
      }];
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ProgressOrError, {
        progress: fetchingOrganization,
        error: errorOrganization
      }), (!!fetchedOrganization || !organizationUuid) && /*#__PURE__*/React.createElement(Form, {
        module: MODULE_NAME,
        edited_id: organizationUuid,
        edited: ticket,
        reset: reset,
        update: update,
        title: "workforce"
        // titleParams={{ label: ticketLabel(this.state.ticket) }}
        ,
        titleParams: {
          label: "Label"
        },
        back: back,
        save: save ? this._save : null,
        canSave: this.canSave,
        reload: (organizationUuid || readOnly) && this.reload,
        readOnly: readOnly,
        overview: overview,
        Panels: organizationUuid ? [EditWorkforceOrganizationPage$1] : [AddWorkforceOrganizationPage$1],
        onEditedChanged: this.onEditedChanged
        // actions={actions}
      }));
    }
  }]);
}(Component); // eslint-disable-next-line no-unused-vars
var mapStateToProps$1q = function mapStateToProps(state, props) {
  return {
    rights: !!state.core && !!state.core.user && !!state.core.user.i_user ? state.core.user.i_user.rights : [],
    fetchingOrganization: state.workforce.fetchingOrganization,
    errorOrganization: state.workforce.errorOrganization,
    fetchedOrganization: state.workforce.fetchedOrganization,
    organization: state.workforce.organization,
    submittingMutation: state.workforce.submittingMutation,
    mutation: state.workforce.mutation,
    grievanceConfig: state.workforce.grievanceConfig
  };
};
var mapDispatchToProps$Q = function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    fetchOrganization: fetchOrganization,
    journalize: journalize
  }, dispatch);
};
var OrganizationForm$1 = withModulesManager(connect(mapStateToProps$1q, mapDispatchToProps$Q)(OrganizationForm));

function _callSuper$1B(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$1B() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$1B() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$1B = function _isNativeReflectConstruct() { return !!t; })(); }
var styles$1t = function styles(theme) {
  return {
    page: theme.page,
    lockedPage: theme.page.locked
  };
};
var WorkforceOrganizationPage = /*#__PURE__*/function (_Component) {
  function WorkforceOrganizationPage() {
    var _this;
    _classCallCheck(this, WorkforceOrganizationPage);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper$1B(this, WorkforceOrganizationPage, [].concat(args));
    _defineProperty(_this, "add", function () {
      historyPush$1(_this.props.modulesManager, _this.props.history, "grievance.route.ticket");
    });
    _defineProperty(_this, "save", function (organization) {
      if (!organization.id) {
        _this.props.createWorkforceOrganization(_this.props.modulesManager, organization, "Create");
      } else {
        _this.props.updateWorkforceOrganization(_this.props.modulesManager, organization, "Update");
      }
    });
    return _this;
  }
  _inherits(WorkforceOrganizationPage, _Component);
  return _createClass(WorkforceOrganizationPage, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        classes = _this$props.classes,
        modulesManager = _this$props.modulesManager,
        history = _this$props.history,
        rights = _this$props.rights,
        organizationUuid = _this$props.organizationUuid,
        overview = _this$props.overview;
        _this$props.organization;
        var organizationVersion = _this$props.organizationVersion;
      // const readOnly = organization?.status === TICKET_STATUSES.CLOSED || ticket?.isHistory;
      var readOnly = false;
      // if (!(rights.includes(RIGHT_ORGANIZATION_CREATE) || rights.includes(RIGHT_ORGANIZATION_EDIT))) return null;
      return /*#__PURE__*/React.createElement("div", {
        className: "".concat(null, " ").concat(classes.page)
      }, /*#__PURE__*/React.createElement(OrganizationForm$1, {
        overview: overview,
        organizationUuid: organizationUuid,
        organizationVersion: organizationVersion,
        readOnly: readOnly,
        back: function back() {
          return historyPush$1(modulesManager, history, "workforce.route.organizations");
        },
        add: rights.includes(RIGHT_ORGANIZATION_CREATE) ? this.add : null,
        save: rights.includes(RIGHT_ORGANIZATION_EDIT) ? this.save : null
      }));
    }
  }]);
}(Component);
var mapStateToProps$1p = function mapStateToProps(state, props) {
  return {
    rights: !!state.core && !!state.core.user && !!state.core.user.i_user ? state.core.user.i_user.rights : [],
    organizationUuid: props.match.params.organization_uuid,
    organizationVersion: props.match.params.version,
    organization: state.workforce.organization
  };
};
var mapDispatchToProps$P = function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    createWorkforceOrganization: createWorkforceOrganization,
    updateWorkforceOrganization: updateWorkforceOrganization
  }, dispatch);
};
var WorkforceOrganizationPage$1 = withHistory(withModulesManager(connect(mapStateToProps$1p, mapDispatchToProps$P)(withTheme(withStyles(styles$1t)(WorkforceOrganizationPage)))));

function _callSuper$1A(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$1A() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$1A() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$1A = function _isNativeReflectConstruct() { return !!t; })(); }
var styles$1s = function styles(theme) {
  return {
    dialogTitle: theme.dialog.title,
    dialogContent: theme.dialog.content,
    form: {
      padding: 0
    },
    item: {
      padding: theme.spacing(1)
    },
    paperDivider: theme.paper.divider
  };
};
var WORKFORCE_ORGANIZATION_UNIT_FILTER_CONTRIBUTION_KEY = "workforce.organization.unit.Filter";
var OrganizationUnitFilter = /*#__PURE__*/function (_Component) {
  function OrganizationUnitFilter() {
    var _this;
    _classCallCheck(this, OrganizationUnitFilter);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper$1A(this, OrganizationUnitFilter, [].concat(args));
    _defineProperty(_this, "debouncedOnChangeFilter", _debounce(_this.props.onChangeFilters, 800));
    _defineProperty(_this, "_filterValue", function (k) {
      var filters = _this.props.filters;
      return !!filters && !!filters[k] ? filters[k].value : null;
    });
    _defineProperty(_this, "_onChangeReporter", function (k, v) {
      _this.props.onChangeFilters([{
        id: k,
        value: v,
        filter: "".concat(k, ": \"").concat(decodeId(v === null || v === void 0 ? void 0 : v.id), "\"")
      }]);
    });
    _defineProperty(_this, "_onChangeCheckbox", function (key, value) {
      var filters = [{
        id: key,
        value: value,
        filter: "".concat(key, ": ").concat(value)
      }];
      _this.props.onChangeFilters(filters);
      _this.props.setShowHistoryFilter(value);
    });
    return _this;
  }
  _inherits(OrganizationUnitFilter, _Component);
  return _createClass(OrganizationUnitFilter, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        classes = _this$props.classes,
        filters = _this$props.filters,
        onChangeFilters = _this$props.onChangeFilters;
      return /*#__PURE__*/React.createElement(Grid, {
        container: true,
        className: classes.form
      }, /*#__PURE__*/React.createElement(ControlledField, {
        module: MODULE_NAME,
        id: "workforce.organization.name.en",
        field: /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 3,
          className: classes.item
        }, /*#__PURE__*/React.createElement(TextInput, {
          module: MODULE_NAME,
          label: "workforce.organization.name.en",
          name: "nameEn",
          value: this._filterValue("nameEn"),
          onChange: function onChange(v) {
            return _this2.debouncedOnChangeFilter([{
              id: 'nameEn',
              value: v,
              filter: "nameEn_Icontains: \"".concat(v, "\"")
            }]);
          }
        }))
      }), /*#__PURE__*/React.createElement(ControlledField, {
        module: MODULE_NAME,
        id: "workforce.organization.name.bn",
        field: /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 3,
          className: classes.item
        }, /*#__PURE__*/React.createElement(TextInput, {
          module: MODULE_NAME,
          label: "workforce.organization.name.bn",
          name: "nameBn",
          value: this._filterValue("nameBn"),
          onChange: function onChange(v) {
            return _this2.debouncedOnChangeFilter([{
              id: 'nameBn',
              value: v,
              filter: "nameBn_Icontains: \"".concat(v, "\"")
            }]);
          }
        }))
      }), /*#__PURE__*/React.createElement(ControlledField, {
        module: MODULE_NAME,
        id: "workforce.organization.unit.level",
        field: /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 3,
          className: classes.item
        }, /*#__PURE__*/React.createElement(TextInput, {
          module: MODULE_NAME,
          label: "workforce.organization.unit.level",
          name: "unit.level",
          value: this._filterValue("unitLevel"),
          onChange: function onChange(v) {
            return _this2.debouncedOnChangeFilter([{
              id: 'unitLevel',
              value: v,
              filter: "unitLevel: \"".concat(v, "\"")
            }]);
          }
        }))
      }), /*#__PURE__*/React.createElement(ControlledField, {
        module: MODULE_NAME,
        id: "workforce.organization.unit.phone",
        field: /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 3,
          className: classes.item
        }, /*#__PURE__*/React.createElement(TextInput, {
          module: MODULE_NAME,
          label: "workforce.organization.unit.phone",
          name: "address",
          value: this._filterValue("phoneNumber"),
          onChange: function onChange(v) {
            return _this2.debouncedOnChangeFilter([{
              id: 'phoneNumber',
              value: v,
              filter: "phoneNumber_Icontains: \"".concat(v, "\"")
            }]);
          }
        }))
      }), /*#__PURE__*/React.createElement(Contributions, {
        filters: filters,
        onChangeFilters: onChangeFilters,
        contributionKey: WORKFORCE_ORGANIZATION_UNIT_FILTER_CONTRIBUTION_KEY
      }));
    }
  }]);
}(Component);
var OrganizationUnitFilter$1 = withModulesManager(withTheme(withStyles(styles$1s)(OrganizationUnitFilter)));

function _callSuper$1z(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$1z() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$1z() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$1z = function _isNativeReflectConstruct() { return !!t; })(); }
function ownKeys$20(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$20(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$20(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$20(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var styles$1r = function styles(theme) {
  return {
    paper: _objectSpread$20(_objectSpread$20({}, theme.paper.paper), {}, {
      margin: 0
    }),
    paperHeader: _objectSpread$20(_objectSpread$20({}, theme.paper.header), {}, {
      padding: 10
    }),
    tableTitle: theme.table.title,
    fab: theme.fab,
    button: {
      margin: theme.spacing(1)
    },
    item: {
      padding: theme.spacing(1)
    }
  };
};
var OrganizationUnitSearcher = /*#__PURE__*/function (_Component) {
  function OrganizationUnitSearcher(props) {
    var _this;
    _classCallCheck(this, OrganizationUnitSearcher);
    _this = _callSuper$1z(this, OrganizationUnitSearcher, [props]);
    _defineProperty(_this, "fetch", function (prms) {
      var showHistoryFilter = _this.state.showHistoryFilter;
      _this.setState({
        displayVersion: showHistoryFilter
      });
      _this.props.fetchOrganizationUnitsSummary(_this.props.modulesManager, prms);
    });
    _defineProperty(_this, "rowIdentifier", function (r) {
      return r.uuid;
    });
    _defineProperty(_this, "isShowHistory", function () {
      return _this.state.displayVersion;
    });
    _defineProperty(_this, "filtersToQueryParams", function (state) {
      var prms = Object.keys(state.filters).filter(function (f) {
        return !!state.filters[f].filter;
      }).map(function (f) {
        return state.filters[f].filter;
      });
      prms.push("first: ".concat(state.pageSize));
      if (state.afterCursor) {
        prms.push("after: \"".concat(state.afterCursor, "\""));
      }
      if (state.beforeCursor) {
        prms.push("before: \"".concat(state.beforeCursor, "\""));
      }
      if (state.orderBy) {
        prms.push("orderBy: [\"".concat(state.orderBy, "\"]"));
      }
      return prms;
    });
    _defineProperty(_this, "headers", function () {
      return ["workforce.organization.name.en", "workforce.organization.name.bn", "workforce.organization.unit.level", "workforce.organization.unit.phone", "workforce.organization.unit.email", _this.isShowHistory() ? 'workforce.version' : ''];
    });
    _defineProperty(_this, "sorts", function () {
      return [];
    });
    _defineProperty(_this, "itemFormatters", function () {
      var formatters = [function (organizationunit) {
        return organizationunit.nameEn;
      }, function (organizationunit) {
        return organizationunit.nameBn;
      }, function (organizationunit) {
        return organizationunit.unitLevel;
      }, function (organizationunit) {
        return organizationunit.phoneNumber;
      }, function (organizationunit) {
        return organizationunit.email;
      }, function (organizationunit) {
        return _this.isShowHistory() ? organizationunit === null || organizationunit === void 0 ? void 0 : organizationunit.version : null;
      }];
      formatters.push(function (organizationunit) {
        return /*#__PURE__*/React.createElement(Tooltip, {
          title: "Edit"
        }, /*#__PURE__*/React.createElement(IconButton, {
          disabled: organizationunit === null || organizationunit === void 0 ? void 0 : organizationunit.isHistory,
          onClick: function onClick() {
            historyPush$1(_this.props.modulesManager, _this.props.history, 'workforce.route.organizations.units.unit', [decodeId(organizationunit.id)], false);
          }
        }, /*#__PURE__*/React.createElement(EditIcon, null)));
      });
      // }
      return formatters;
    });
    _defineProperty(_this, "rowDisabled", function (selection, i) {
      return !!i.validityTo;
    });
    _defineProperty(_this, "rowLocked", function (selection, i) {
      return !!i.clientMutationId;
    });
    _this.state = {
      // open: false,
      chfid: null,
      confirmedAction: null,
      reset: 0,
      showHistoryFilter: false,
      displayVersion: false
    };
    _this.rowsPerPageOptions = [10, 20, 50, 100];
    _this.defaultPageSize = 10;
    return _this;
  }
  _inherits(OrganizationUnitSearcher, _Component);
  return _createClass(OrganizationUnitSearcher, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState, snapshot) {
      if (prevProps.submittingMutation && !this.props.submittingMutation) {
        this.props.journalize(this.props.mutation);
        this.setState({
          reset: prevState.reset + 1
        });
      } else if (!prevProps.confirmed && this.props.confirmed) {
        this.state.confirmedAction();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props;
        _this$props.intl;
        var organizationUnits = _this$props.organizationUnits,
        organizationUnitsPageInfo = _this$props.organizationUnitsPageInfo,
        fetchingOrganizationUnits = _this$props.fetchingOrganizationUnits,
        fetchedOrganizationUnits = _this$props.fetchedOrganizationUnits,
        errorOrganizationUnits = _this$props.errorOrganizationUnits,
        filterPaneContributionsKey = _this$props.filterPaneContributionsKey,
        cacheFiltersKey = _this$props.cacheFiltersKey,
        _onDoubleClick = _this$props.onDoubleClick;
      organizationUnitsPageInfo.totalCount;
      var filterPane = function filterPane(_ref) {
        var filters = _ref.filters,
          onChangeFilters = _ref.onChangeFilters;
        return /*#__PURE__*/React.createElement(OrganizationUnitFilter$1, {
          filters: filters,
          onChangeFilters: onChangeFilters,
          setShowHistoryFilter: function setShowHistoryFilter(showHistoryFilter) {
            return _this2.setState({
              showHistoryFilter: showHistoryFilter
            });
          }
        });
      };
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Searcher$2, {
        module: MODULE_NAME,
        cacheFiltersKey: cacheFiltersKey,
        FilterPane: filterPane,
        filterPaneContributionsKey: filterPaneContributionsKey,
        items: organizationUnits,
        itemsPageInfo: organizationUnitsPageInfo,
        fetchingItems: fetchingOrganizationUnits,
        fetchedItems: fetchedOrganizationUnits,
        errorItems: errorOrganizationUnits
        // tableTitle={formatMessageWithValues(intl, MODULE_NAME, "ticketSummaries", { count })}
        ,
        tableTitle: /*#__PURE__*/React.createElement(FormattedMessage, {
          module: MODULE_NAME,
          id: "menu.workforce.organizations.unit"
        }),
        rowsPerPageOptions: this.rowsPerPageOptions,
        defaultPageSize: this.defaultPageSize,
        fetch: this.fetch,
        rowIdentifier: this.rowIdentifier,
        filtersToQueryParams: this.filtersToQueryParams,
        defaultOrderBy: "-dateCreated",
        headers: this.headers,
        itemFormatters: this.itemFormatters,
        sorts: this.sorts,
        rowDisabled: this.rowDisabled,
        rowLocked: this.rowLocked,
        onDoubleClick: function onDoubleClick(i) {
          return !i.clientMutationId && _onDoubleClick(i);
        },
        reset: this.state.reset
      }));
    }
  }]);
}(Component);
var mapStateToProps$1o = function mapStateToProps(state) {
  return (
    // console.log(state),
    {
      rights: !!state.core && !!state.core.user && !!state.core.user.i_user ? state.core.user.i_user.rights : [],
      organizationUnits: state.workforce.organizationUnits,
      organizationUnitsPageInfo: state.workforce.organizationUnitsPageInfo,
      fetchingOrganizationUnits: state.workforce.fetchingOrganizationUnits,
      fetchedOrganizationUnits: state.workforce.fetchedOrganizationUnits,
      errorOrganizationUnits: state.workforce.errorOrganizationUnits,
      submittingMutation: state.workforce.submittingMutation,
      mutation: state.workforce.mutation,
      confirmed: state.core.confirmed
    }
  );
};
var mapDispatchToProps$O = function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    fetchOrganizationUnitsSummary: fetchOrganizationUnitsSummary,
    journalize: journalize,
    coreConfirm: coreConfirm
  }, dispatch);
};
var OrganizationUnitSearcher$1 = withModulesManager(withHistory(connect(mapStateToProps$1o, mapDispatchToProps$O)(withTheme(withStyles(styles$1r)(OrganizationUnitSearcher)))));

function _callSuper$1y(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$1y() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$1y() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$1y = function _isNativeReflectConstruct() { return !!t; })(); }
var styles$1q = function styles(theme) {
  return {
    page: theme.page,
    fab: theme.fab,
    ROUTE_WORKFORCE_ORGANIZATIONS_UNITS_UNIT: ROUTE_WORKFORCE_ORGANIZATIONS_UNITS_UNIT
  };
};
var WorkforceOrganizationsUnitsPage = /*#__PURE__*/function (_Component) {
  function WorkforceOrganizationsUnitsPage() {
    var _this;
    _classCallCheck(this, WorkforceOrganizationsUnitsPage);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper$1y(this, WorkforceOrganizationsUnitsPage, [].concat(args));
    _defineProperty(_this, "onDoubleClick", function (organization) {
      var newTab = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var routeParams = ["workforce.route.organizations.units.unit", [decodeId(organization.id)]];
      if (organization !== null && organization !== void 0 && organization.isHistory) {
        routeParams[1].push(organization.version);
      }
      historyPush$1.apply(void 0, [_this.props.modulesManager, _this.props.history].concat(routeParams, [newTab]));
    });
    _defineProperty(_this, "onAdd", function () {
      historyPush$1(_this.props.modulesManager, _this.props.history, "workforce.route.organizations.units.unit");
    });
    return _this;
  }
  _inherits(WorkforceOrganizationsUnitsPage, _Component);
  return _createClass(WorkforceOrganizationsUnitsPage, [{
    key: "render",
    value: function render() {
      var _this$props = this.props;
        _this$props.intl;
        var classes = _this$props.classes;
        _this$props.rights;
      return /*#__PURE__*/React.createElement("div", {
        className: classes.page
      }, /*#__PURE__*/React.createElement(OrganizationUnitSearcher$1, {
        cacheFiltersKey: "ticketPageFiltersCache",
        onDoubleClick: this.onDoubleClick
      }), withTooltip(/*#__PURE__*/React.createElement("div", {
        className: classes.fab
      }, /*#__PURE__*/React.createElement(Fab, {
        color: "primary",
        onClick: this.onAdd
      }, /*#__PURE__*/React.createElement(AddIcon, null))), /*#__PURE__*/React.createElement(FormattedMessage, {
        module: MODULE_NAME,
        id: "workforce.organization.unit.addNewTooltip"
      })));
    }
  }]);
}(Component);
var mapStateToProps$1n = function mapStateToProps(state) {
  return {
    rights: !!state.core && !!state.core.user && !!state.core.user.i_user ? state.core.user.i_user.rights : []
  };
};
var WorkforceOrganizationUnitsPage = withModulesManager(withHistory(connect(mapStateToProps$1n)(withTheme(withStyles(styles$1q)(WorkforceOrganizationsUnitsPage)))));

function ownKeys$1$(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$1$(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$1$(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1$(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper$1x(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$1x() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$1x() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$1x = function _isNativeReflectConstruct() { return !!t; })(); }
var styles$1p = function styles(theme) {
  return {
    paper: theme.paper.paper,
    tableTitle: theme.table.title,
    item: theme.paper.item,
    fullHeight: {
      height: "100%"
    }
  };
};
var EditWorkforceOrganizationUnitPage = /*#__PURE__*/function (_Component) {
  function EditWorkforceOrganizationUnitPage(props) {
    var _this;
    _classCallCheck(this, EditWorkforceOrganizationUnitPage);
    _this = _callSuper$1x(this, EditWorkforceOrganizationUnitPage, [props]);
    _defineProperty(_this, "updateAttribute", function (key, value) {
      _this.setState(function (prevState) {
        return {
          stateEdited: _objectSpread$1$(_objectSpread$1$({}, prevState.stateEdited), {}, _defineProperty({}, key, value)),
          isSaved: false
        };
      });
    });
    _defineProperty(_this, "save", function () {
      var _this$props = _this.props;
        _this$props.grievanceConfig;
        var dispatch = _this$props.dispatch;
      var stateEdited = _this.state.stateEdited;
      var organizationUnitData = {
        organization: stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.organization,
        nameBn: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.titleBn) || stateEdited.nameBn,
        nameEn: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.title) || stateEdited.nameEn,
        phoneNumber: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.phone) || stateEdited.phoneNumber,
        email: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.email) || stateEdited.email,
        level: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.unitLevel) || stateEdited.unitLevel,
        id: stateEdited.id
      };
      dispatch(updateWorkforceOrganizationUnit(organizationUnitData, "Update Organization Unit ".concat(organizationUnitData.nameEn)));
      console.log({
        organizationUnitData: organizationUnitData
      });
      _this.setState({
        isSaved: true
      });
    });
    _this.state = {
      stateEdited: props.organizationUnit || {},
      isSaved: false
    };
    return _this;
  }
  _inherits(EditWorkforceOrganizationUnitPage, _Component);
  return _createClass(EditWorkforceOrganizationUnitPage, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.organizationUnit !== this.props.organizationUnit) {
        this.setState({
          stateEdited: this.props.organizationUnit
        });
      }
      if (prevProps.submittingMutation && !this.props.submittingMutation) {
        this.props.dispatch(journalize(this.props.mutation));
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var classes = this.props.classes;
      var _this$state = this.state,
        stateEdited = _this$state.stateEdited,
        isSaved = _this$state.isSaved;
      return /*#__PURE__*/React.createElement("div", {
        className: classes.page
      }, /*#__PURE__*/React.createElement(Grid, {
        container: true
      }, /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12
      }, /*#__PURE__*/React.createElement(Paper, {
        className: classes.paper
      }, /*#__PURE__*/React.createElement(Grid, {
        container: true,
        className: classes.tableTitle
      }, /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12,
        className: classes.tableTitle
      }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(FormattedMessage, {
        module: MODULE_NAME,
        id: "Organization Unit",
        values: {
          label: EMPTY_STRING
        }
      })))), /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement(Grid, {
        container: true,
        className: classes.item
      }, /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12,
        className: classes.item
      }, /*#__PURE__*/React.createElement(PublishedComponent, {
        pubRef: "workforceOrganization.OrganizationPicker",
        value: stateEdited.organization || null,
        label: /*#__PURE__*/React.createElement(FormattedMessage, {
          module: "workforce",
          id: "workforce.organization.picker"
        }),
        onChange: function onChange(option) {
          return _this2.updateAttribute("organization", option);
        },
        required: true,
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.organization.unit.name.en",
        value: stateEdited.nameEn,
        onChange: function onChange(v) {
          return _this2.updateAttribute("title", v);
        },
        required: true,
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.organization.unit.name.bn",
        value: stateEdited.nameBn || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("titleBn", v);
        },
        required: true,
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.organization.unit.phone",
        value: stateEdited.phoneNumber || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("phone", v);
        },
        required: true,
        type: "number",
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.organization.unit.email",
        value: stateEdited.email || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("email", v);
        },
        required: true,
        type: "email",
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.organization.unit.level",
        value: stateEdited.unitLevel || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("unitLevel", v);
        },
        required: true,
        type: "number",
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 11,
        className: classes.item
      }), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 1,
        className: classes.item
      }, /*#__PURE__*/React.createElement(IconButton, {
        variant: "contained",
        component: "label",
        color: "primary",
        onClick: this.save,
        disabled: isSaved
      }, /*#__PURE__*/React.createElement(Save, null)))), /*#__PURE__*/React.createElement(Divider, null)))));
    }
  }]);
}(Component);
var mapStateToProps$1m = function mapStateToProps(state) {
  return {
    organizationUnit: state.workforce.organizationUnit
  };
};
var EditWorkforceOrganizationUnitPage$1 = connect(mapStateToProps$1m)(withStyles(styles$1p)(EditWorkforceOrganizationUnitPage));

var OrganizationUnitPicker = function OrganizationUnitPicker(_ref) {
  var modulesManager = _ref.modulesManager,
    _onChange = _ref.onChange,
    readOnly = _ref.readOnly,
    required = _ref.required,
    _ref$withLabel = _ref.withLabel,
    withLabel = _ref$withLabel === void 0 ? true : _ref$withLabel,
    withPlaceholder = _ref.withPlaceholder,
    value = _ref.value,
    label = _ref.label,
    placeholder = _ref.placeholder,
    filterOptions = _ref.filterOptions,
    filterSelectedOptions = _ref.filterSelectedOptions,
    multiple = _ref.multiple;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2);
    _useState2[0];
    var setSearchString = _useState2[1];
  var _useTranslations = useTranslations("workforce"),
    formatMessage = _useTranslations.formatMessage;
  var dispatch = useDispatch();
  useEffect(function () {
    return dispatch(fetchOrganizationUnitsPick(modulesManager, []));
  }, []);
  var isLoading = useSelector(function (state) {
    return state.workforce["fetchingOrganizationUnitsPick"];
  });
  var data = useSelector(function (state) {
    var _state$workforce;
    return (_state$workforce = state.workforce["organizationUnitsPick"]) !== null && _state$workforce !== void 0 ? _state$workforce : [];
  });
  var error = useSelector(function (state) {
    return state.workforce["errorOrganizationUnitsPick"];
  });
  return /*#__PURE__*/React.createElement(Autocomplete, {
    multiple: multiple,
    required: required,
    placeholder: placeholder !== null && placeholder !== void 0 ? placeholder : "",
    label: label !== null && label !== void 0 ? label : formatMessage("workforce.organization.parent"),
    error: error,
    withLabel: withLabel,
    withPlaceholder: withPlaceholder,
    readOnly: readOnly,
    options: data,
    isLoading: isLoading,
    value: value,
    getOptionLabel: function getOptionLabel(option) {
      return "".concat(option.nameEn);
    },
    onChange: function onChange(option) {
      return _onChange(option, option ? "".concat(option) : null);
    },
    filterOptions: filterOptions,
    filterSelectedOptions: filterSelectedOptions,
    onInputChange: setSearchString
  });
};

function ownKeys$1_(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$1_(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$1_(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1_(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper$1w(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$1w() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$1w() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$1w = function _isNativeReflectConstruct() { return !!t; })(); }
var styles$1o = function styles(theme) {
  return {
    paper: theme.paper.paper,
    tableTitle: theme.table.title,
    item: theme.paper.item,
    fullHeight: {
      height: "100%"
    }
  };
};
var AddWorkforceOrganizationUnitPage = /*#__PURE__*/function (_Component) {
  function AddWorkforceOrganizationUnitPage(props) {
    var _this;
    _classCallCheck(this, AddWorkforceOrganizationUnitPage);
    _this = _callSuper$1w(this, AddWorkforceOrganizationUnitPage, [props]);
    _defineProperty(_this, "save", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var stateEdited, dispatch, unitData;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            stateEdited = _this.state.stateEdited;
            dispatch = _this.props.dispatch;
            unitData = {
              nameBn: stateEdited.titleBn,
              nameEn: stateEdited.title,
              phoneNumber: stateEdited.phone,
              email: stateEdited.email,
              level: stateEdited.level,
              parent: stateEdited.parent,
              organization: stateEdited.organization
            };
            _context.next = 5;
            return dispatch(createWorkforceOrganizationUnit(unitData, "Created Organization Unit ".concat(unitData.nameEn)));
          case 5:
            _this.setState({
              isSaved: true
            });
          case 6:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })));
    _defineProperty(_this, "updateAttribute", function (key, value) {
      _this.setState(function (prevState) {
        return {
          stateEdited: _objectSpread$1_(_objectSpread$1_({}, prevState.stateEdited), {}, _defineProperty({}, key, value)),
          isSaved: false
        };
      });
    });
    _defineProperty(_this, "onUpdateOrganization", function (key, value) {
      var dispatch = _this.props.dispatch;
      _this.updateAttribute(key, value);
      var organizationId = value && value.id ? decodeId(value.id) : "00000000-0000-0000-0000-000000000000";
      var filters = ["organization_Id: \"".concat(formatGQLString(organizationId), "\"")];
      return dispatch(fetchOrganizationUnitsPick(_this.props.modulesManager, filters));
    });
    _this.state = {
      stateEdited: {},
      isSaved: false
    };
    return _this;
  }
  _inherits(AddWorkforceOrganizationUnitPage, _Component);
  return _createClass(AddWorkforceOrganizationUnitPage, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props = this.props,
        submittingMutation = _this$props.submittingMutation,
        mutation = _this$props.mutation,
        dispatch = _this$props.dispatch;
      if (!submittingMutation && prevProps.submittingMutation !== submittingMutation) {
        dispatch(journalize(mutation));
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var classes = this.props.classes;
      var _this$state = this.state,
        stateEdited = _this$state.stateEdited,
        isSaved = _this$state.isSaved;
      var isSaveDisabled = !(stateEdited.title && stateEdited.organization);
      return /*#__PURE__*/React.createElement("div", {
        className: classes.page
      }, /*#__PURE__*/React.createElement(Grid, {
        container: true
      }, /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12
      }, /*#__PURE__*/React.createElement(Paper, {
        className: classes.paper
      }, /*#__PURE__*/React.createElement(Grid, {
        container: true,
        className: classes.tableTitle
      }, /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12,
        className: classes.tableTitle
      }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(FormattedMessage, {
        module: MODULE_NAME,
        id: "Organization Unit",
        values: {
          label: EMPTY_STRING
        }
      })))), /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement(Grid, {
        container: true,
        className: classes.item
      }, /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(PublishedComponent, {
        pubRef: "workforceOrganization.OrganizationPicker",
        value: stateEdited.organization || null,
        label: /*#__PURE__*/React.createElement(FormattedMessage, {
          module: "workforce",
          id: "workforce.organization.picker"
        }),
        onChange: function onChange(option) {
          return _this2.onUpdateOrganization("organization", option);
        },
        required: true,
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(OrganizationUnitPicker, {
        value: stateEdited.parent || null,
        onChange: function onChange(option) {
          return _this2.updateAttribute("parent", option);
        },
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.organization.unit.name.en",
        value: stateEdited.title || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("title", v);
        },
        required: true,
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.organization.unit.name.bn",
        value: stateEdited.titleBn || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("titleBn", v);
        },
        required: true,
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.organization.unit.phone",
        value: stateEdited.phone || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("phone", v);
        },
        required: true,
        type: "number",
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.organization.unit.email",
        value: stateEdited.email || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("email", v);
        },
        required: true,
        type: "email",
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.organization.unit.level",
        value: stateEdited.level || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("level", v);
        },
        required: true,
        type: "number",
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 11,
        className: classes.item
      }), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 1,
        className: classes.item
      }, /*#__PURE__*/React.createElement(IconButton, {
        variant: "contained",
        component: "label",
        color: "primary",
        onClick: this.save,
        disabled: isSaveDisabled || isSaved
      }, /*#__PURE__*/React.createElement(Save, null)))), /*#__PURE__*/React.createElement(Divider, null)))));
    }
  }]);
}(Component);
var mapStateToProps$1l = function mapStateToProps(state) {
  return {
    submittingMutation: state.workforce.submittingMutation,
    mutation: state.workforce.mutation
  };
};
var AddWorkforceOrganizationUnitPage$1 = connect(mapStateToProps$1l)(withStyles(styles$1o)(AddWorkforceOrganizationUnitPage));

function ownKeys$1Z(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$1Z(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$1Z(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1Z(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper$1v(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$1v() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$1v() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$1v = function _isNativeReflectConstruct() { return !!t; })(); }
var OrganizationUnitForm = /*#__PURE__*/function (_Component) {
  function OrganizationUnitForm(props) {
    var _this;
    _classCallCheck(this, OrganizationUnitForm);
    _this = _callSuper$1v(this, OrganizationUnitForm, [props]);
    _defineProperty(_this, "reload", function () {
      // this.props.fetchComments(
      //   this.state.ticket,
      // );
    });
    _defineProperty(_this, "canSave", function () {});
    _defineProperty(_this, "_save", function (ticket) {
      _this.setState({
        lockNew: !ticket.uuid
      }, function () {
        return _this.props.save(ticket);
      });
    });
    _defineProperty(_this, "onEditedChanged", function (ticket) {
      _this.setState({
        ticket: ticket
      });
    });
    _defineProperty(_this, "reopenTicket", function () {
      var _this$props = _this.props,
        intl = _this$props.intl,
        ticket = _this$props.ticket;
      _this.props.reopenTicket(ticket.id, formatMessage(intl, MODULE_NAME, "reopenTicket.mutation.label"));
    });
    _this.state = {
      lockNew: false,
      reset: 0,
      organizationUnitUuid: null,
      ticket: _this._newTicket()
    };
    return _this;
  }
  _inherits(OrganizationUnitForm, _Component);
  return _createClass(OrganizationUnitForm, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.organizationUnitUuid) {
        this.setState(function (state, props) {
          return {
            organizationUnitUuid: props.organizationUnitUuid
          };
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // this.props.clearTicket();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState, snapshot) {
      if (prevProps.fetchedOrganizationUnit !== this.props.fetchedOrganizationUnit && !!this.props.fetchedOrganizationUnit && !!this.props.organizationUnit) {
        this.setState(function (state, props) {
          return {
            organizationUnit: _objectSpread$1Z({}, props.organizationUnit),
            organizationUnitUuid: props.organizationUnit.id,
            lockNew: false
          };
        });
      } else if (prevState.organizationUnitUuid !== this.state.organizationUnitUuid) {
        var filters = ["id: \"".concat(this.state.organizationUnitUuid, "\"")];
        // if (this.props.ticketVersion) filters.push(`ticketVersion: ${this.props.ticketVersion}`);
        this.props.fetchOrganizationUnit(this.props.modulesManager, filters);
      } else if (prevProps.submittingMutation && !this.props.submittingMutation) {
        var _this$props2;
        this.props.journalize(this.props.mutation);
        this.setState(function (state) {
          return {
            reset: state.reset + 1
          };
        });
        if ((_this$props2 = this.props) !== null && _this$props2 !== void 0 && (_this$props2 = _this$props2.organizationUnit) !== null && _this$props2 !== void 0 && _this$props2.id) {
          this.props.fetchOrganizationUnit(this.props.modulesManager, ["id: \"".concat(this.state.organizationUnitUuid, "\"")]);
        }
      }
    }

    // eslint-disable-next-line react/sort-comp
  }, {
    key: "_newTicket",
    value: function _newTicket() {
      return {};
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
        fetchingTicket = _this$props3.fetchingTicket,
        fetchedOrganizationUnit = _this$props3.fetchedOrganizationUnit,
        errorTicket = _this$props3.errorTicket,
        save = _this$props3.save,
        back = _this$props3.back;
      var _this$state = this.state,
        lockNew = _this$state.lockNew,
        reset = _this$state.reset,
        update = _this$state.update,
        overview = _this$state.overview,
        organizationUnitUuid = _this$state.organizationUnitUuid,
        ticket = _this$state.ticket;
      var readOnly = lockNew || !!ticket.validityTo || this.props.readOnly;
      [{
        doIt: this.reopenTicket,
        icon: /*#__PURE__*/React.createElement(LockOpenIcon, null),
        // onlyIfDirty: ticket.status !== TICKET_STATUSES.CLOSED,
        disabled: ticket.isHistory
      }];
      console.log({
        organizationUnitUuid: organizationUnitUuid
      });
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ProgressOrError, {
        progress: fetchingTicket,
        error: errorTicket
      }), (!!fetchedOrganizationUnit || !organizationUnitUuid) && /*#__PURE__*/React.createElement(Form, {
        module: MODULE_NAME,
        edited_id: organizationUnitUuid,
        edited: ticket,
        reset: reset,
        update: update,
        title: "Workforce Organizations Unit"
        // titleParams={{ label: ticketLabel(this.state.ticket) }}
        ,
        titleParams: {
          label: "Label"
        },
        back: back,
        save: save ? this._save : null,
        canSave: this.canSave,
        reload: (organizationUnitUuid || readOnly) && this.reload,
        readOnly: readOnly,
        overview: overview,
        Panels: organizationUnitUuid ? [EditWorkforceOrganizationUnitPage$1] : [AddWorkforceOrganizationUnitPage$1],
        onEditedChanged: this.onEditedChanged
        // actions={actions}
      }));
    }
  }]);
}(Component); // eslint-disable-next-line no-unused-vars
var mapStateToProps$1k = function mapStateToProps(state, props) {
  return {
    rights: !!state.core && !!state.core.user && !!state.core.user.i_user ? state.core.user.i_user.rights : [],
    fetchingTicket: state.workforce.fetchingTicket,
    errorTicket: state.workforce.errorTicket,
    fetchedOrganizationUnit: state.workforce.fetchedOrganizationUnit,
    ticket: state.workforce.ticket,
    submittingMutation: state.workforce.submittingMutation,
    mutation: state.workforce.mutation,
    grievanceConfig: state.workforce.grievanceConfig
  };
};
var mapDispatchToProps$N = function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    fetchOrganizationUnit: fetchOrganizationUnit,
    journalize: journalize
  }, dispatch);
};
var OrganizationUnitForm$1 = withModulesManager(connect(mapStateToProps$1k, mapDispatchToProps$N)(OrganizationUnitForm));

function _callSuper$1u(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$1u() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$1u() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$1u = function _isNativeReflectConstruct() { return !!t; })(); }
var styles$1n = function styles(theme) {
  return {
    page: theme.page,
    lockedPage: theme.page.locked
  };
};
var WorkforceOrganizationUnitPage = /*#__PURE__*/function (_Component) {
  function WorkforceOrganizationUnitPage() {
    var _this;
    _classCallCheck(this, WorkforceOrganizationUnitPage);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper$1u(this, WorkforceOrganizationUnitPage, [].concat(args));
    _defineProperty(_this, "add", function () {
      historyPush$1(_this.props.modulesManager, _this.props.history, "grievance.route.ticket");
    });
    _defineProperty(_this, "save", function (ticket) {
      if (!ticket.id) {
        _this.props.createWorkforceOrganizationUnit(_this.props.modulesManager, ticket, "Create");
      } else {
        _this.props.updateWorkforceOrganizationUnit(_this.props.modulesManager, ticket, "Update");
      }
    });
    return _this;
  }
  _inherits(WorkforceOrganizationUnitPage, _Component);
  return _createClass(WorkforceOrganizationUnitPage, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        classes = _this$props.classes,
        modulesManager = _this$props.modulesManager,
        history = _this$props.history,
        rights = _this$props.rights,
        organizationUnitUuid = _this$props.organizationUnitUuid,
        overview = _this$props.overview;
        _this$props.organization;
        var ticketVersion = _this$props.ticketVersion;
      // const readOnly = ticket?.status === TICKET_STATUSES.CLOSED || ticket?.isHistory;
      var readOnly = false;
      // if (!(rights.includes(RIGHT_ORGANIZATION_CREATE) || rights.includes(RIGHT_ORGANIZATION_EDIT))) return null;
      return /*#__PURE__*/React.createElement("div", {
        className: "".concat(null, " ").concat(classes.page)
      }, /*#__PURE__*/React.createElement(OrganizationUnitForm$1, {
        overview: overview,
        organizationUnitUuid: organizationUnitUuid,
        ticketVersion: ticketVersion,
        readOnly: readOnly,
        back: function back() {
          return historyPush$1(modulesManager, history, "workforce.route.organizations.units");
        },
        add: rights.includes(RIGHT_ORGANIZATION_CREATE) ? this.add : null,
        save: rights.includes(RIGHT_ORGANIZATION_EDIT) ? this.save : null
      }));
    }
  }]);
}(Component);
var mapStateToProps$1j = function mapStateToProps(state, props) {
  return {
    rights: !!state.core && !!state.core.user && !!state.core.user.i_user ? state.core.user.i_user.rights : [],
    organizationUnitUuid: props.match.params.organization_unit_uuid
  };
};
var mapDispatchToProps$M = function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    createWorkforceOrganizationUnit: createWorkforceOrganizationUnit,
    updateWorkforceOrganizationUnit: updateWorkforceOrganizationUnit
  }, dispatch);
};
var WorkforceOrganizationUnitPage$1 = withHistory(withModulesManager(connect(mapStateToProps$1j, mapDispatchToProps$M)(withTheme(withStyles(styles$1n)(WorkforceOrganizationUnitPage)))));

var OrganizationPicker = function OrganizationPicker(_ref) {
  var modulesManager = _ref.modulesManager,
    _onChange = _ref.onChange,
    readOnly = _ref.readOnly,
    required = _ref.required,
    _ref$withLabel = _ref.withLabel,
    withLabel = _ref$withLabel === void 0 ? true : _ref$withLabel,
    withPlaceholder = _ref.withPlaceholder,
    value = _ref.value,
    label = _ref.label,
    placeholder = _ref.placeholder,
    filterOptions = _ref.filterOptions,
    filterSelectedOptions = _ref.filterSelectedOptions,
    multiple = _ref.multiple;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2);
    _useState2[0];
    var setSearchString = _useState2[1];
  var _useTranslations = useTranslations("workforce"),
    formatMessage = _useTranslations.formatMessage;
  var dispatch = useDispatch();
  useEffect(function () {
    return dispatch(fetchOrganizationsPick(modulesManager));
  }, []);
  var isLoading = useSelector(function (state) {
    return state.workforce["fetchingOrganizationsPick"];
  });
  var data = useSelector(function (state) {
    var _state$workforce;
    return (_state$workforce = state.workforce["organizationsPick"]) !== null && _state$workforce !== void 0 ? _state$workforce : [];
  });
  var error = useSelector(function (state) {
    return state.workforce["errorOrganizationsPick"];
  });
  return /*#__PURE__*/React.createElement(Autocomplete, {
    multiple: multiple,
    required: required,
    placeholder: placeholder !== null && placeholder !== void 0 ? placeholder : "",
    label: label !== null && label !== void 0 ? label : formatMessage("workforce.organization.parent"),
    error: error,
    withLabel: withLabel,
    withPlaceholder: withPlaceholder,
    readOnly: readOnly,
    options: data,
    isLoading: isLoading,
    value: value,
    getOptionLabel: function getOptionLabel(option) {
      return "".concat(option.nameEn);
    },
    onChange: function onChange(option) {
      return _onChange(option, option ? "".concat(option) : null);
    },
    filterOptions: filterOptions,
    filterSelectedOptions: filterSelectedOptions,
    onInputChange: setSearchString
  });
};

var CompanyPicker = function CompanyPicker(_ref) {
  var modulesManager = _ref.modulesManager,
    _onChange = _ref.onChange,
    readOnly = _ref.readOnly,
    required = _ref.required,
    _ref$withLabel = _ref.withLabel,
    withLabel = _ref$withLabel === void 0 ? true : _ref$withLabel,
    withPlaceholder = _ref.withPlaceholder,
    value = _ref.value,
    label = _ref.label,
    placeholder = _ref.placeholder,
    filterOptions = _ref.filterOptions,
    filterSelectedOptions = _ref.filterSelectedOptions,
    multiple = _ref.multiple;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2);
    _useState2[0];
    var setSearchString = _useState2[1];
  var _useTranslations = useTranslations("workforce"),
    formatMessage = _useTranslations.formatMessage;
  var dispatch = useDispatch();
  useEffect(function () {
    return dispatch(fetchCompaniesPick(modulesManager));
  }, []);
  var isLoading = useSelector(function (state) {
    return state.workforce["fetchingWorkforceCompaniesPick"];
  });
  var data = useSelector(function (state) {
    var _state$workforce;
    return (_state$workforce = state.workforce["workforceCompaniesPick"]) !== null && _state$workforce !== void 0 ? _state$workforce : [];
  });
  var error = useSelector(function (state) {
    return state.workforce["errorWorkforceCompaniesPick"];
  });
  var selectedOption = useMemo(function () {
    return data.find(function (option) {
      return option.id === value;
    }) || null;
  }, [value]);
  return /*#__PURE__*/React.createElement(Autocomplete, {
    multiple: multiple,
    required: required,
    placeholder: placeholder !== null && placeholder !== void 0 ? placeholder : "",
    label: label !== null && label !== void 0 ? label : formatMessage("workforce.organization.parent"),
    error: error,
    withLabel: withLabel,
    withPlaceholder: withPlaceholder,
    readOnly: readOnly,
    options: data,
    isLoading: isLoading,
    value: selectedOption,
    getOptionLabel: function getOptionLabel(option) {
      return "".concat(option.nameEn);
    },
    onChange: function onChange(option) {
      return _onChange(option, option ? "".concat(option) : null);
    },
    filterOptions: filterOptions,
    filterSelectedOptions: filterSelectedOptions,
    onInputChange: setSearchString
  });
};

var OfficePicker = function OfficePicker(_ref) {
  var modulesManager = _ref.modulesManager,
    _onChange = _ref.onChange,
    readOnly = _ref.readOnly,
    required = _ref.required,
    _ref$withLabel = _ref.withLabel,
    withLabel = _ref$withLabel === void 0 ? true : _ref$withLabel,
    withPlaceholder = _ref.withPlaceholder,
    value = _ref.value,
    label = _ref.label,
    placeholder = _ref.placeholder,
    filterOptions = _ref.filterOptions,
    filterSelectedOptions = _ref.filterSelectedOptions,
    multiple = _ref.multiple;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2);
    _useState2[0];
    var setSearchString = _useState2[1];
  var _useTranslations = useTranslations("workforce"),
    formatMessage = _useTranslations.formatMessage;
  var dispatch = useDispatch();
  useEffect(function () {
    return dispatch(fetchOfficesPick(modulesManager));
  }, []);
  var isLoading = useSelector(function (state) {
    return state.workforce["fetchingWorkforceOfficesPick"];
  });
  var data = useSelector(function (state) {
    var _state$workforce;
    return (_state$workforce = state.workforce["workforceOfficesPick"]) !== null && _state$workforce !== void 0 ? _state$workforce : [];
  });
  var error = useSelector(function (state) {
    return state.workforce["errorWorkforceOfficesPick"];
  });
  var selectedOption = useMemo(function () {
    return data.find(function (option) {
      return option.id === value;
    }) || null;
  }, [value]);
  return /*#__PURE__*/React.createElement(Autocomplete, {
    multiple: multiple,
    required: required,
    placeholder: placeholder !== null && placeholder !== void 0 ? placeholder : "",
    label: label !== null && label !== void 0 ? label : formatMessage("workforce.organization.parent"),
    error: error,
    withLabel: withLabel,
    withPlaceholder: withPlaceholder,
    readOnly: readOnly,
    options: data,
    isLoading: isLoading,
    value: selectedOption,
    getOptionLabel: function getOptionLabel(option) {
      return "".concat(option.nameEn);
    },
    onChange: function onChange(option) {
      return _onChange(option, option ? "".concat(option) : null);
    },
    filterOptions: filterOptions,
    filterSelectedOptions: filterSelectedOptions,
    onInputChange: setSearchString
  });
};

var FactoryPicker = function FactoryPicker(_ref) {
  var id = _ref.id;
    _ref.modulesManager;
    var _onChange = _ref.onChange,
    readOnly = _ref.readOnly,
    required = _ref.required,
    _ref$withLabel = _ref.withLabel,
    withLabel = _ref$withLabel === void 0 ? true : _ref$withLabel,
    withPlaceholder = _ref.withPlaceholder,
    value = _ref.value,
    label = _ref.label,
    placeholder = _ref.placeholder,
    filterOptions = _ref.filterOptions,
    filterSelectedOptions = _ref.filterSelectedOptions,
    multiple = _ref.multiple;
    _ref.companyId;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2);
    _useState2[0];
    var setSearchString = _useState2[1];
  var _useTranslations = useTranslations("workforce"),
    formatMessage = _useTranslations.formatMessage;
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2);
    _useState4[0];
    _useState4[1];
  var loggedInUserId = useSelector(function (state) {
    var _state$core;
    return (_state$core = state.core) === null || _state$core === void 0 || (_state$core = _state$core.user) === null || _state$core === void 0 || (_state$core = _state$core.i_user) === null || _state$core === void 0 ? void 0 : _state$core.id;
  });
  var mm = useModulesManager();
  var dispatch = useDispatch();
  var locale = useSelector(function (state) {
    var _state$core2;
    return ((_state$core2 = state.core) === null || _state$core2 === void 0 || (_state$core2 = _state$core2.user) === null || _state$core2 === void 0 || (_state$core2 = _state$core2.i_user) === null || _state$core2 === void 0 ? void 0 : _state$core2.language) || "en";
  });
  var _useState5 = useState(null),
    _useState6 = _slicedToArray(_useState5, 2),
    userFactoryId = _useState6[0],
    setUserFactoryId = _useState6[1];
  useEffect(function () {
    var cancelled = false;
    var loadUserFactory = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _response$payload, _node$workforceFactor, _node$workforceFactor2;
        var response, node, factoryId;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (loggedInUserId) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return");
            case 2:
              _context.next = 4;
              return dispatch(fetchWorkforceEmployee(mm, ["relatedUser_Id: \"".concat(safeDecodeId(loggedInUserId), "\"")]));
            case 4:
              response = _context.sent;
              node = response === null || response === void 0 || (_response$payload = response.payload) === null || _response$payload === void 0 || (_response$payload = _response$payload.data) === null || _response$payload === void 0 || (_response$payload = _response$payload.workforceEmployerEmployees) === null || _response$payload === void 0 || (_response$payload = _response$payload.edges) === null || _response$payload === void 0 || (_response$payload = _response$payload[0]) === null || _response$payload === void 0 ? void 0 : _response$payload.node;
              factoryId = (_node$workforceFactor = node === null || node === void 0 || (_node$workforceFactor2 = node.workforceFactory) === null || _node$workforceFactor2 === void 0 ? void 0 : _node$workforceFactor2.id) !== null && _node$workforceFactor !== void 0 ? _node$workforceFactor : null;
              if (!cancelled) setUserFactoryId(factoryId);
            case 8:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function loadUserFactory() {
        return _ref2.apply(this, arguments);
      };
    }();
    loadUserFactory();
    return function () {
      cancelled = true;
    };
  }, [dispatch, loggedInUserId, mm]);
  useEffect(function () {
    var rawFactoryId = value !== null && value !== void 0 ? value : userFactoryId;
    var factoryId = rawFactoryId ? safeDecodeId(rawFactoryId) : null;
    dispatch(fetchFactoriesPick(mm, factoryId != null ? ["id: \"".concat(factoryId, "\"")] : ["status: \"active\""]));
  }, [dispatch, mm, value, userFactoryId]);
  var isLoading = useSelector(function (state) {
    return state.workforce["fetchingWorkforceFactoriesPick"];
  });
  var data = useSelector(function (state) {
    var _state$workforce;
    return (_state$workforce = state.workforce["workforceFactoriesPick"]) !== null && _state$workforce !== void 0 ? _state$workforce : [];
  });
  var error = useSelector(function (state) {
    return state.workforce["errorWorkforceFactoriesPick"];
  });

  // const data = useMemo(() => {
  //   return data.filter(factory => decodeId(factory.workforceEmployer.id) === companyId);
  // }, [data, companyId]);

  var selectedOption = useMemo(function () {
    return data.find(function (option) {
      return option.id === value;
    }) || null;
  }, [value, data]);
  return /*#__PURE__*/React.createElement(Autocomplete, {
    id: id,
    multiple: multiple,
    required: required,
    placeholder: placeholder !== null && placeholder !== void 0 ? placeholder : "",
    label: label !== null && label !== void 0 ? label : formatMessage("workforce.organization.parent"),
    error: error,
    withLabel: withLabel,
    withPlaceholder: withPlaceholder,
    readOnly: readOnly,
    options: data,
    isLoading: isLoading,
    value: selectedOption,
    getOptionLabel: function getOptionLabel(option) {
      return locale === "en" ? "".concat(option.nameEn) : "".concat(option.nameBn);
    },
    onChange: function onChange(option) {
      return _onChange(option, option ? "".concat(option) : null);
    },
    filterOptions: filterOptions,
    filterSelectedOptions: filterSelectedOptions,
    onInputChange: setSearchString
  });
};

var useStyles$1G = makeStyles(function () {
  return {
    modernWrapper: {
      "& .MuiFormControl-root": {
        marginTop: 4,
        width: "100%"
      },
      "& .MuiInputBase-root": {
        borderRadius: 12,
        transition: "all 0.3s ease",
        boxShadow: "0 1px 2px rgba(0,0,0,0.04)",
        minHeight: 56,
        fontSize: "16px",
        lineHeight: "33px",
        fontFamily: "'Nikosh', sans-serif"
      },
      "& .MuiOutlinedInput-root": {
        minHeight: 56,
        fontFamily: "'Nikosh', sans-serif"
      },
      "& .MuiInputBase-input": {
        padding: "16.5px 14px",
        fontSize: "16px",
        lineHeight: "33px",
        fontFamily: "'Nikosh', sans-serif",
        boxSizing: "border-box"
      },
      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: "#e5e7eb"
      },
      "&:hover .MuiOutlinedInput-notchedOutline": {
        borderColor: "#6366f1"
      },
      "& .Mui-focused .MuiOutlinedInput-notchedOutline": {
        borderColor: "#4f46e5",
        borderWidth: 2
      },
      "& .MuiInputLabel-root": {
        fontWeight: 500,
        fontSize: "16px",
        fontFamily: "'Nikosh', sans-serif"
      },
      "& .MuiInputLabel-root.Mui-focused": {
        color: "#4f46e5"
      },
      "& .MuiSvgIcon-root": {
        fontSize: "1.5rem"
      },
      "& .MuiIconButton-root": {
        padding: 8
      }
    }
  };
});
var DatePicker = function DatePicker(_ref) {
  _ref.intl;
    _ref.classes;
    _ref.disablePast;
    _ref.module;
    var label = _ref.label,
    _ref$readOnly = _ref.readOnly,
    readOnly = _ref$readOnly === void 0 ? false : _ref$readOnly,
    _ref$required = _ref.required,
    required = _ref$required === void 0 ? false : _ref$required,
    _ref$fullWidth = _ref.fullWidth,
    fullWidth = _ref$fullWidth === void 0 ? true : _ref$fullWidth,
    _ref$format = _ref.format,
    format = _ref$format === void 0 ? "DD-MM-YYYY" : _ref$format,
    reset = _ref.reset;
    _ref.modulesManager;
    var minDate = _ref.minDate,
    maxDate = _ref.maxDate,
    value = _ref.value,
    _onChange = _ref.onChange,
    secondaryCalendarEnabled = _ref.secondaryCalendarEnabled,
    _ref$secondaryCalenda = _ref.secondaryCalendarType,
    secondaryCalendarType = _ref$secondaryCalenda === void 0 ? "default" : _ref$secondaryCalenda,
    _ref$secondaryCalenda2 = _ref.secondaryCalendarLocale,
    secondaryCalendarLocale = _ref$secondaryCalenda2 === void 0 ? "bengali_en" : _ref$secondaryCalenda2;
  var styles = useStyles$1G();
  var userLanguage = useSelector(function (state) {
    var _state$core;
    return ((_state$core = state.core) === null || _state$core === void 0 || (_state$core = _state$core.user) === null || _state$core === void 0 || (_state$core = _state$core.i_user) === null || _state$core === void 0 ? void 0 : _state$core.language) || "en";
  });
  var isSecondaryCalendarEnabled = useMemo(function () {
    if (secondaryCalendarEnabled) {
      return secondaryCalendarEnabled;
    }
    return userLanguage !== "en";
  }, [secondaryCalendarEnabled, userLanguage]);

  // const dateValue = useMemo(() => {
  //   if (reset) return null;

  //   const original = typeof value === "string" ? new Date(value) : value;
  //   if (!original || isNaN(original)) return value;

  //   const adjusted = new Date(original);
  //   adjusted.setDate(adjusted.getDate() - 1);
  //   return adjusted;
  // }, [reset, value]);
  var dateValue = useMemo(function () {
    if (reset) return null;
    var original = typeof value === "string" ? new Date(value) : value;
    if (!original || isNaN(original)) return value;
    if (userLanguage !== "fr") return original;
    var adjusted = new Date(original);
    adjusted.setDate(adjusted.getDate() - 1);
    return adjusted;
  }, [reset, value, userLanguage]);
  // const dateValue = reset ? null : value || null;

  return /*#__PURE__*/React.createElement("div", {
    className: styles.modernWrapper
  }, /*#__PURE__*/React.createElement(PublishedComponent, {
    pubRef: "core.DatePicker",
    label: label,
    value: dateValue,
    onChange: function onChange(val) {
      if (val === null || val === "" || val === undefined) {
        _onChange(null);
      } else {
        _onChange(val);
      }
    },
    editable: false,
    readOnly: readOnly,
    required: required,
    fullWidth: fullWidth,
    minDate: minDate,
    maxDate: maxDate,
    format: format,
    secondaryCalendarEnabled: isSecondaryCalendarEnabled,
    secondCalendarType: secondaryCalendarType,
    secondCalendarLocale: secondaryCalendarLocale,
    inputProps: {
      readOnly: true
    }
  }));
};

function ownKeys$1Y(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$1Y(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$1Y(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1Y(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper$1t(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$1t() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$1t() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$1t = function _isNativeReflectConstruct() { return !!t; })(); }
var styles$1m = function styles(theme) {
  return {
    paper: theme.paper.paper,
    tableTitle: theme.table.title,
    item: theme.paper.item,
    fullHeight: {
      height: "100%"
    }
  };
};
var AddUnitDesignationPage = /*#__PURE__*/function (_Component) {
  function AddUnitDesignationPage(props) {
    var _this;
    _classCallCheck(this, AddUnitDesignationPage);
    _this = _callSuper$1t(this, AddUnitDesignationPage, [props]);
    _defineProperty(_this, "save", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var stateEdited, _this$props, dispatch, unitDesignationData;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            stateEdited = _this.state.stateEdited;
            _this$props = _this.props, _this$props.grievanceConfig, dispatch = _this$props.dispatch;
            unitDesignationData = {
              nameBn: stateEdited.titleBn,
              nameEn: stateEdited.title,
              organization: stateEdited.organization,
              unit: stateEdited.unit,
              designationLevel: stateEdited.level,
              designationSequence: stateEdited.sequence
            };
            console.log({
              unitDesignationData: unitDesignationData
            });
            _context.next = 6;
            return dispatch(createUnitDesignation(unitDesignationData, "Created unit designation ".concat(unitDesignationData.nameEn)));
          case 6:
            _this.setState({
              isSaved: true
            });
          case 7:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })));
    _defineProperty(_this, "updateAttribute", function (key, value) {
      _this.setState(function (prevState) {
        return {
          stateEdited: _objectSpread$1Y(_objectSpread$1Y({}, prevState.stateEdited), {}, _defineProperty({}, key, value)),
          isSaved: false
        };
      });
    });
    _this.state = {
      stateEdited: {},
      isSaved: false
    };
    return _this;
  }
  _inherits(AddUnitDesignationPage, _Component);
  return _createClass(AddUnitDesignationPage, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props2 = this.props,
        submittingMutation = _this$props2.submittingMutation,
        mutation = _this$props2.mutation,
        dispatch = _this$props2.dispatch;
      if (!submittingMutation && prevProps.submittingMutation !== submittingMutation) {
        dispatch(journalize(mutation));
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var classes = this.props.classes;
      var _this$state = this.state,
        stateEdited = _this$state.stateEdited,
        isSaved = _this$state.isSaved;
      return /*#__PURE__*/React.createElement("div", {
        className: classes.page
      }, /*#__PURE__*/React.createElement(Grid, {
        container: true
      }, /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12
      }, /*#__PURE__*/React.createElement(Paper, {
        className: classes.paper
      }, /*#__PURE__*/React.createElement(Grid, {
        container: true,
        className: classes.tableTitle
      }, /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12,
        className: classes.tableTitle
      }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(FormattedMessage, {
        module: MODULE_NAME,
        id: "Unit Designations",
        values: {
          label: EMPTY_STRING
        }
      })))), /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement(Grid, {
        container: true,
        className: classes.item
      }, /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.organization.unit.designation.name.en",
        value: stateEdited.title || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("title", v);
        },
        required: true,
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.organization.unit.designation.name.bn",
        value: stateEdited.titleBn || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("titleBn", v);
        },
        required: true,
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(PublishedComponent, {
        pubRef: "workforceOrganization.OrganizationPicker",
        value: stateEdited.organization || null,
        label: /*#__PURE__*/React.createElement(FormattedMessage, {
          module: "workforce",
          id: "workforce.organization.picker"
        }),
        onChange: function onChange(option) {
          return _this2.updateAttribute("organization", option);
        },
        required: true,
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(OrganizationUnitPicker, {
        value: stateEdited.parent || null,
        onChange: function onChange(option) {
          return _this2.updateAttribute("unit", option);
        },
        readOnly: isSaved,
        label: /*#__PURE__*/React.createElement(FormattedMessage, {
          module: "workforce",
          id: "workforce.organization.unit.picker"
        })
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.organization.unit.designation.level",
        value: stateEdited.level || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("level", v);
        },
        required: true,
        type: "number",
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.organization.unit.designation.sequence",
        value: stateEdited.sequence || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("sequence", v);
        },
        required: true,
        type: "number",
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 11,
        className: classes.item
      }), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 1,
        className: classes.item
      }, /*#__PURE__*/React.createElement(IconButton, {
        variant: "contained",
        component: "label",
        color: "primary",
        onClick: this.save,
        disabled: isSaved
      }, /*#__PURE__*/React.createElement(Save, null)))), /*#__PURE__*/React.createElement(Divider, null)))));
    }
  }]);
}(Component);
var mapStateToProps$1i = function mapStateToProps(state) {
  return {
    submittingMutation: state.workforce.submittingMutation,
    mutation: state.workforce.mutation,
    representativeId: state.workforce.fetchedRepresentativeByClientMutationId,
    grievanceConfig: state.workforce.grievanceConfig
  };
};
var AddUnitDesignationPage$1 = connect(mapStateToProps$1i)(withStyles(styles$1m)(AddUnitDesignationPage));

function ownKeys$1X(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$1X(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$1X(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1X(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper$1s(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$1s() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$1s() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$1s = function _isNativeReflectConstruct() { return !!t; })(); }
var styles$1l = function styles(theme) {
  return {
    paper: theme.paper.paper,
    tableTitle: theme.table.title,
    item: theme.paper.item,
    fullHeight: {
      height: "100%"
    }
  };
};
var EditUnitDesignationPage = /*#__PURE__*/function (_Component) {
  function EditUnitDesignationPage(props) {
    var _this;
    _classCallCheck(this, EditUnitDesignationPage);
    _this = _callSuper$1s(this, EditUnitDesignationPage, [props]);
    _defineProperty(_this, "updateAttribute", function (key, value) {
      _this.setState(function (prevState) {
        return {
          stateEdited: _objectSpread$1X(_objectSpread$1X({}, prevState.stateEdited), {}, _defineProperty({}, key, value)),
          isSaved: false
        };
      });
    });
    _defineProperty(_this, "save", function () {
      var _this$props = _this.props;
        _this$props.grievanceConfig;
        var dispatch = _this$props.dispatch;
      var stateEdited = _this.state.stateEdited;
      var organizationUnitDesignationData = {
        organization: stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.organization,
        unit: stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.unit,
        nameBn: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.titleBn) || (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.nameBn),
        nameEn: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.title) || (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.nameEn),
        designationSequence: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.designationSequence) || (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.sequence),
        designationLevel: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.designationLevel) || (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.level),
        id: stateEdited.id
      };
      dispatch(updateUnitDesignation(organizationUnitDesignationData, "Update Organization Unit Designaiton ".concat(organizationUnitDesignationData.nameEn)));
      console.log({
        organizationUnitDesignationData: organizationUnitDesignationData
      });
      _this.setState({
        isSaved: true
      });
    });
    _this.state = {
      stateEdited: props.unitDesignation || {},
      isSaved: false
    };
    return _this;
  }
  _inherits(EditUnitDesignationPage, _Component);
  return _createClass(EditUnitDesignationPage, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.unitDesignation !== this.props.unitDesignation) {
        this.setState({
          stateEdited: this.props.unitDesignation
        });
      }
      if (prevProps.submittingMutation && !this.props.submittingMutation) {
        this.props.dispatch(journalize(this.props.mutation));
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var classes = this.props.classes;
      var _this$state = this.state,
        stateEdited = _this$state.stateEdited,
        isSaved = _this$state.isSaved;
      console.log({
        stateEdited: stateEdited
      });
      return /*#__PURE__*/React.createElement("div", {
        className: classes.page
      }, /*#__PURE__*/React.createElement(Grid, {
        container: true
      }, /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12
      }, /*#__PURE__*/React.createElement(Paper, {
        className: classes.paper
      }, /*#__PURE__*/React.createElement(Grid, {
        container: true,
        className: classes.tableTitle
      }, /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12,
        className: classes.tableTitle
      }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(FormattedMessage, {
        module: MODULE_NAME,
        id: "Unit Designation",
        values: {
          label: EMPTY_STRING
        }
      })))), /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement(Grid, {
        container: true,
        className: classes.item
      }, /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(PublishedComponent, {
        pubRef: "workforceOrganization.OrganizationPicker",
        value: stateEdited.organization || null,
        label: /*#__PURE__*/React.createElement(FormattedMessage, {
          module: "workforce",
          id: "workforce.organization.picker"
        }),
        onChange: function onChange(option) {
          return _this2.updateAttribute("organization", option);
        },
        required: true,
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(OrganizationUnitPicker, {
        value: stateEdited.unit || null,
        onChange: function onChange(option) {
          return _this2.updateAttribute("unit", option);
        },
        readOnly: isSaved,
        label: /*#__PURE__*/React.createElement(FormattedMessage, {
          module: "workforce",
          id: "workforce.organization.unit.picker"
        })
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.organization.unit.designation.name.en",
        value: stateEdited.nameEn,
        onChange: function onChange(v) {
          return _this2.updateAttribute("title", v);
        },
        required: true,
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.organization.unit.designation.name.bn",
        value: stateEdited.nameBn || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("titleBn", v);
        },
        required: true,
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.organization.unit.designation.sequence",
        value: stateEdited.designationSequence || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("sequence", v);
        },
        required: true,
        type: "number",
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.organization.unit.designation.level",
        value: stateEdited.designationLevel || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("level", v);
        },
        required: true,
        type: "number",
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 11,
        className: classes.item
      }), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 1,
        className: classes.item
      }, /*#__PURE__*/React.createElement(IconButton, {
        variant: "contained",
        component: "label",
        color: "primary",
        onClick: this.save,
        disabled: isSaved
      }, /*#__PURE__*/React.createElement(Save, null)))), /*#__PURE__*/React.createElement(Divider, null)))));
    }
  }]);
}(Component);
var mapStateToProps$1h = function mapStateToProps(state) {
  return {
    // submittingMutation: state.grievanceSocialProtection.submittingMutation,
    // mutation: state.grievanceSocialProtection.mutation,
    // grievanceConfig: state.grievanceSocialProtection.grievanceConfig,
    unitDesignation: state.workforce.unitDesignation
  };
};
var EditUnitDesignationPage$1 = connect(mapStateToProps$1h)(withStyles(styles$1l)(EditUnitDesignationPage));

function ownKeys$1W(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$1W(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$1W(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1W(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper$1r(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$1r() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$1r() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$1r = function _isNativeReflectConstruct() { return !!t; })(); }
var UnitDesignationForm = /*#__PURE__*/function (_Component) {
  function UnitDesignationForm(props) {
    var _this;
    _classCallCheck(this, UnitDesignationForm);
    _this = _callSuper$1r(this, UnitDesignationForm, [props]);
    _this.state = {
      lockNew: false,
      reset: 0,
      unitDesignationUuid: null
    };
    return _this;
  }
  _inherits(UnitDesignationForm, _Component);
  return _createClass(UnitDesignationForm, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.unitDesignationUuid) {
        this.setState(function (state, props) {
          return {
            unitDesignationUuid: props.unitDesignationUuid
          };
        });
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState, snapshot) {
      if (prevProps.fetchedUnitDesignation !== this.props.fetchedUnitDesignation && !!this.props.fetchedUnitDesignation && !!this.props.unitDesignation) {
        this.setState(function (state, props) {
          return {
            unitDesignation: _objectSpread$1W({}, props.unitDesignation),
            unitDesignationUuid: props.unitDesignation.id,
            lockNew: false
          };
        });
      } else if (prevState.unitDesignationUuid !== this.state.unitDesignationUuid) {
        var filters = ["id: \"".concat(this.state.unitDesignationUuid, "\"")];
        this.props.fetchUnitDesignation(this.props.modulesManager, filters);
      } else if (prevProps.submittingMutation && !this.props.submittingMutation) {
        var _this$props;
        this.props.journalize(this.props.mutation);
        this.setState(function (state) {
          return {
            reset: state.reset + 1
          };
        });
        if ((_this$props = this.props) !== null && _this$props !== void 0 && (_this$props = _this$props.unitDesignation) !== null && _this$props !== void 0 && _this$props.id) {
          this.props.fetchUnitDesignation(this.props.modulesManager, ["id: \"".concat(this.state.unitDesignationUuid, "\"")]);
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        fetchingUnitDesignations = _this$props2.fetchingUnitDesignations,
        fetchedUnitDesignation = _this$props2.fetchedUnitDesignation,
        errorUnitDesignations = _this$props2.errorUnitDesignations,
        save = _this$props2.save,
        back = _this$props2.back;
      var _this$state = this.state;
        _this$state.lockNew;
        var reset = _this$state.reset,
        update = _this$state.update,
        overview = _this$state.overview,
        unitDesignationUuid = _this$state.unitDesignationUuid,
        ticket = _this$state.ticket;
      var readOnly = false;
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ProgressOrError, {
        progress: fetchingUnitDesignations,
        error: errorUnitDesignations
      }), (!!fetchedUnitDesignation || !unitDesignationUuid) && /*#__PURE__*/React.createElement(Form, {
        module: MODULE_NAME,
        edited_id: unitDesignationUuid,
        edited: ticket,
        reset: reset,
        update: update,
        title: "workforce"
        // titleParams={{ label: ticketLabel(this.state.ticket) }}
        ,
        titleParams: {
          label: "Label"
        },
        back: back,
        save: save ? this._save : null,
        canSave: this.canSave,
        reload: (unitDesignationUuid || readOnly) && this.reload,
        readOnly: readOnly,
        overview: overview,
        Panels: unitDesignationUuid ? [EditUnitDesignationPage$1] : [AddUnitDesignationPage$1],
        onEditedChanged: this.onEditedChanged
        // actions={actions}
      }));
    }
  }]);
}(Component);
var mapStateToProps$1g = function mapStateToProps(state, props) {
  return {
    rights: !!state.core && !!state.core.user && !!state.core.user.i_user ? state.core.user.i_user.rights : [],
    fetchingUnitDesignations: state.workforce.fetchingUnitDesignations,
    errorUnitDesignations: state.workforce.errorUnitDesignations,
    fetchedUnitDesignation: state.workforce.fetchedUnitDesignation,
    unitDesignation: state.workforce.unitDesignation,
    submittingMutation: state.workforce.submittingMutation,
    mutation: state.workforce.mutation,
    grievanceConfig: state.workforce.grievanceConfig
  };
};
var mapDispatchToProps$L = function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    fetchUnitDesignation: fetchUnitDesignation,
    journalize: journalize
  }, dispatch);
};
var UnitDesignationForm$1 = withModulesManager(connect(mapStateToProps$1g, mapDispatchToProps$L)(UnitDesignationForm));

function _callSuper$1q(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$1q() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$1q() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$1q = function _isNativeReflectConstruct() { return !!t; })(); }
var styles$1k = function styles(theme) {
  return {
    page: theme.page,
    lockedPage: theme.page.locked
  };
};
var UnitDesignationPage = /*#__PURE__*/function (_Component) {
  function UnitDesignationPage() {
    var _this;
    _classCallCheck(this, UnitDesignationPage);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper$1q(this, UnitDesignationPage, [].concat(args));
    _defineProperty(_this, "add", function () {
      historyPush$1(_this.props.modulesManager, _this.props.history, "grievance.route.ticket");
    });
    _defineProperty(_this, "save", function (organization) {
      if (!organization.id) {
        _this.props.createWorkforceOrganization(_this.props.modulesManager, organization, "Create");
      } else {
        _this.props.updateWorkforceOrganization(_this.props.modulesManager, organization, "Update");
      }
    });
    return _this;
  }
  _inherits(UnitDesignationPage, _Component);
  return _createClass(UnitDesignationPage, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        classes = _this$props.classes,
        modulesManager = _this$props.modulesManager,
        history = _this$props.history,
        rights = _this$props.rights,
        unitDesignationUuid = _this$props.unitDesignationUuid,
        overview = _this$props.overview;
        _this$props.unitDesignation;
        var organizationVersion = _this$props.organizationVersion;
      // const readOnly = organization?.status === TICKET_STATUSES.CLOSED || ticket?.isHistory;
      var readOnly = false;
      // if (!(rights.includes(RIGHT_ORGANIZATION_CREATE) || rights.includes(RIGHT_ORGANIZATION_EDIT))) return null;
      return /*#__PURE__*/React.createElement("div", {
        className: "".concat(null, " ").concat(classes.page)
      }, /*#__PURE__*/React.createElement(UnitDesignationForm$1, {
        overview: overview,
        unitDesignationUuid: unitDesignationUuid,
        organizationVersion: organizationVersion,
        readOnly: readOnly,
        back: function back() {
          return historyPush$1(modulesManager, history, "workforce.route.unit.designations");
        },
        add: rights.includes(RIGHT_ORGANIZATION_CREATE) ? this.add : null,
        save: rights.includes(RIGHT_ORGANIZATION_EDIT) ? this.save : null
      }));
    }
  }]);
}(Component);
var mapStateToProps$1f = function mapStateToProps(state, props) {
  return {
    rights: !!state.core && !!state.core.user && !!state.core.user.i_user ? state.core.user.i_user.rights : [],
    unitDesignationUuid: props.match.params.organization_unit_designation_uuid,
    organizationVersion: props.match.params.version,
    unitDesignation: state.workforce.unitDesignation
  };
};
var mapDispatchToProps$K = function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    createWorkforceOrganization: createWorkforceOrganization,
    updateWorkforceOrganization: updateWorkforceOrganization
  }, dispatch);
};
var UnitDesignationPage$1 = withHistory(withModulesManager(connect(mapStateToProps$1f, mapDispatchToProps$K)(withTheme(withStyles(styles$1k)(UnitDesignationPage)))));

function _callSuper$1p(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$1p() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$1p() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$1p = function _isNativeReflectConstruct() { return !!t; })(); }
var styles$1j = function styles(theme) {
  return {
    dialogTitle: theme.dialog.title,
    dialogContent: theme.dialog.content,
    form: {
      padding: 0
    },
    item: {
      padding: theme.spacing(1)
    },
    paperDivider: theme.paper.divider
  };
};
var WORKFORCE_UNIT_DESIGNATION_FILTER_CONTRIBUTION_KEY = "workforce.unit.designation.Filter";
var UnitDesignationFilter = /*#__PURE__*/function (_Component) {
  function UnitDesignationFilter() {
    var _this;
    _classCallCheck(this, UnitDesignationFilter);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper$1p(this, UnitDesignationFilter, [].concat(args));
    _defineProperty(_this, "debouncedOnChangeFilter", _debounce(_this.props.onChangeFilters, 800));
    _defineProperty(_this, "_filterValue", function (k) {
      var filters = _this.props.filters;
      return !!filters && !!filters[k] ? filters[k].value : null;
    });
    _defineProperty(_this, "_onChangeReporter", function (k, v) {
      _this.props.onChangeFilters([{
        id: k,
        value: v,
        filter: "".concat(k, ": \"").concat(decodeId(v === null || v === void 0 ? void 0 : v.id), "\"")
      }]);
    });
    _defineProperty(_this, "_onChangeCheckbox", function (key, value) {
      var filters = [{
        id: key,
        value: value,
        filter: "".concat(key, ": ").concat(value)
      }];
      _this.props.onChangeFilters(filters);
      _this.props.setShowHistoryFilter(value);
    });
    return _this;
  }
  _inherits(UnitDesignationFilter, _Component);
  return _createClass(UnitDesignationFilter, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        classes = _this$props.classes,
        filters = _this$props.filters,
        onChangeFilters = _this$props.onChangeFilters;
      return /*#__PURE__*/React.createElement(Grid, {
        container: true,
        className: classes.form
      }, /*#__PURE__*/React.createElement(ControlledField, {
        module: MODULE_NAME,
        id: "workforce.organization.unit.designation.name.en",
        field: /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 3,
          className: classes.item
        }, /*#__PURE__*/React.createElement(TextInput, {
          module: MODULE_NAME,
          label: "workforce.organization.unit.designation.name.en",
          name: "nameEn",
          value: this._filterValue("nameEn"),
          onChange: function onChange(v) {
            return _this2.debouncedOnChangeFilter([{
              id: 'nameEn',
              value: v,
              filter: "nameEn_Icontains: \"".concat(v, "\"")
            }]);
          }
        }))
      }), /*#__PURE__*/React.createElement(ControlledField, {
        module: MODULE_NAME,
        id: "workforce.organization.unit.designation.name.bn",
        field: /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 3,
          className: classes.item
        }, /*#__PURE__*/React.createElement(TextInput, {
          module: MODULE_NAME,
          label: "workforce.organization.unit.designation.name.bn",
          name: "nameBn",
          value: this._filterValue("nameBn"),
          onChange: function onChange(v) {
            return _this2.debouncedOnChangeFilter([{
              id: 'nameBn',
              value: v,
              filter: "nameBn_Icontains: \"".concat(v, "\"")
            }]);
          }
        }))
      }), /*#__PURE__*/React.createElement(ControlledField, {
        module: MODULE_NAME,
        id: "workforce.organization.unit.designation.level",
        field: /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 3,
          className: classes.item
        }, /*#__PURE__*/React.createElement(TextInput, {
          module: MODULE_NAME,
          label: "workforce.organization.unit.designation.level",
          name: "designationLevel",
          value: this._filterValue("designationLevel"),
          onChange: function onChange(v) {
            return _this2.debouncedOnChangeFilter([{
              id: 'unitLevel',
              value: v,
              filter: "unitLevel: \"".concat(v, "\"")
            }]);
          }
        }))
      }), /*#__PURE__*/React.createElement(ControlledField, {
        module: MODULE_NAME,
        id: "workforce.organization.unit.designation.sequence",
        field: /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 3,
          className: classes.item
        }, /*#__PURE__*/React.createElement(TextInput, {
          module: MODULE_NAME,
          label: "workforce.organization.unit.designation.sequence",
          name: "designationSequence",
          value: this._filterValue("designationSequence"),
          onChange: function onChange(v) {
            return _this2.debouncedOnChangeFilter([{
              id: 'phoneNumber',
              value: v,
              filter: "phoneNumber_Icontains: \"".concat(v, "\"")
            }]);
          }
        }))
      }), /*#__PURE__*/React.createElement(Contributions, {
        filters: filters,
        onChangeFilters: onChangeFilters,
        contributionKey: WORKFORCE_UNIT_DESIGNATION_FILTER_CONTRIBUTION_KEY
      }));
    }
  }]);
}(Component);
var UnitDesignationFilter$1 = withModulesManager(withTheme(withStyles(styles$1j)(UnitDesignationFilter)));

function _callSuper$1o(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$1o() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$1o() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$1o = function _isNativeReflectConstruct() { return !!t; })(); }
function ownKeys$1V(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$1V(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$1V(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1V(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var styles$1i = function styles(theme) {
  return {
    paper: _objectSpread$1V(_objectSpread$1V({}, theme.paper.paper), {}, {
      margin: 0
    }),
    paperHeader: _objectSpread$1V(_objectSpread$1V({}, theme.paper.header), {}, {
      padding: 10
    }),
    tableTitle: theme.table.title,
    fab: theme.fab,
    button: {
      margin: theme.spacing(1)
    },
    item: {
      padding: theme.spacing(1)
    }
  };
};
var UnitDesignationSearcher = /*#__PURE__*/function (_Component) {
  function UnitDesignationSearcher(props) {
    var _this;
    _classCallCheck(this, UnitDesignationSearcher);
    _this = _callSuper$1o(this, UnitDesignationSearcher, [props]);
    _defineProperty(_this, "fetch", function (prms) {
      var showHistoryFilter = _this.state.showHistoryFilter;
      _this.setState({
        displayVersion: showHistoryFilter
      });
      _this.props.fetchUnitDesignationSummary(_this.props.modulesManager, prms);
    });
    _defineProperty(_this, "rowIdentifier", function (r) {
      return r.uuid;
    });
    _defineProperty(_this, "isShowHistory", function () {
      return _this.state.displayVersion;
    });
    _defineProperty(_this, "filtersToQueryParams", function (state) {
      var prms = Object.keys(state.filters).filter(function (f) {
        return !!state.filters[f].filter;
      }).map(function (f) {
        return state.filters[f].filter;
      });
      prms.push("first: ".concat(state.pageSize));
      if (state.afterCursor) {
        prms.push("after: \"".concat(state.afterCursor, "\""));
      }
      if (state.beforeCursor) {
        prms.push("before: \"".concat(state.beforeCursor, "\""));
      }
      if (state.orderBy) {
        prms.push("orderBy: [\"".concat(state.orderBy, "\"]"));
      }
      return prms;
    });
    _defineProperty(_this, "headers", function () {
      return ["workforce.organization.name.en", "workforce.organization.unit.name.en", "workforce.organization.unit.designation.name.en", "workforce.organization.unit.designation.name.bn", "workforce.organization.unit.designation.level", "workforce.organization.unit.designation.sequence"];
    });
    _defineProperty(_this, "sorts", function () {
      return [];
    });
    _defineProperty(_this, "itemFormatters", function () {
      var formatters = [function (unitdesignation) {
        return unitdesignation.organization.nameEn;
      }, function (unitdesignation) {
        return unitdesignation.unit.nameEn;
      }, function (unitdesignation) {
        return unitdesignation.nameEn;
      }, function (unitdesignation) {
        return unitdesignation.nameBn;
      }, function (unitdesignation) {
        return unitdesignation.designationLevel;
      }, function (unitdesignation) {
        return unitdesignation.designationSequence;
      }];

      // if (this.props.rights.includes(RIGHT_ORGANIZATION_EDIT)) {
      formatters.push(function (workforce) {
        return /*#__PURE__*/React.createElement(Tooltip, {
          title: "Edit"
        }, /*#__PURE__*/React.createElement(IconButton, {
          disabled: workforce === null || workforce === void 0 ? void 0 : workforce.isHistory,
          onClick: function onClick() {
            historyPush$1(_this.props.modulesManager, _this.props.history, 'workforce.route.unit.designations.designation', [decodeId(workforce.id)], false);
          }
        }, /*#__PURE__*/React.createElement(EditIcon, null)));
      });
      // }
      return formatters;
    });
    _defineProperty(_this, "rowDisabled", function (selection, i) {
      return !!i.validityTo;
    });
    _defineProperty(_this, "rowLocked", function (selection, i) {
      return !!i.clientMutationId;
    });
    _this.state = {
      // open: false,
      chfid: null,
      confirmedAction: null,
      reset: 0,
      showHistoryFilter: false,
      displayVersion: false
    };
    _this.rowsPerPageOptions = [10, 20, 50, 100];
    _this.defaultPageSize = 10;
    return _this;
  }
  _inherits(UnitDesignationSearcher, _Component);
  return _createClass(UnitDesignationSearcher, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState, snapshot) {
      if (prevProps.submittingMutation && !this.props.submittingMutation) {
        this.props.journalize(this.props.mutation);
        this.setState({
          reset: prevState.reset + 1
        });
      } else if (!prevProps.confirmed && this.props.confirmed) {
        this.state.confirmedAction();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props;
        _this$props.intl;
        var unitDesignations = _this$props.unitDesignations,
        unitDesignationsPageInfo = _this$props.unitDesignationsPageInfo,
        fetchingUnitDesignations = _this$props.fetchingUnitDesignations,
        fetchedUnitDesignations = _this$props.fetchedUnitDesignations,
        errorUnitDesignations = _this$props.errorUnitDesignations,
        filterPaneContributionsKey = _this$props.filterPaneContributionsKey,
        cacheFiltersKey = _this$props.cacheFiltersKey,
        _onDoubleClick = _this$props.onDoubleClick;
      var count = unitDesignationsPageInfo.totalCount;
      console.log({
        unitDesignations: unitDesignations
      });
      var filterPane = function filterPane(_ref) {
        var filters = _ref.filters,
          onChangeFilters = _ref.onChangeFilters;
        return /*#__PURE__*/React.createElement(UnitDesignationFilter$1, {
          filters: filters,
          onChangeFilters: onChangeFilters,
          setShowHistoryFilter: function setShowHistoryFilter(showHistoryFilter) {
            return _this2.setState({
              showHistoryFilter: showHistoryFilter
            });
          }
        });
      };
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Searcher$2, {
        module: MODULE_NAME,
        cacheFiltersKey: cacheFiltersKey,
        FilterPane: filterPane,
        filterPaneContributionsKey: filterPaneContributionsKey,
        items: unitDesignations,
        itemsPageInfo: unitDesignationsPageInfo,
        fetchingItems: fetchingUnitDesignations,
        fetchedItems: fetchedUnitDesignations,
        errorItems: errorUnitDesignations
        // tableTitle={formatMessageWithValues(intl, MODULE_NAME, "ticketSummaries", { count })}
        ,
        tableTitle: /*#__PURE__*/React.createElement(FormattedMessage, {
          module: MODULE_NAME,
          id: "menu.workforce.organizations.unit.designation",
          values: count
        }),
        rowsPerPageOptions: this.rowsPerPageOptions,
        defaultPageSize: this.defaultPageSize,
        fetch: this.fetch,
        rowIdentifier: this.rowIdentifier,
        filtersToQueryParams: this.filtersToQueryParams,
        defaultOrderBy: "-dateCreated",
        headers: this.headers,
        itemFormatters: this.itemFormatters,
        sorts: this.sorts,
        rowDisabled: this.rowDisabled,
        rowLocked: this.rowLocked,
        onDoubleClick: function onDoubleClick(i) {
          return !i.clientMutationId && _onDoubleClick(i);
        },
        reset: this.state.reset
      }));
    }
  }]);
}(Component);
var mapStateToProps$1e = function mapStateToProps(state) {
  return (
    // console.log(state),
    {
      rights: !!state.core && !!state.core.user && !!state.core.user.i_user ? state.core.user.i_user.rights : [],
      unitDesignations: state.workforce.unitDesignations,
      unitDesignationsPageInfo: state.workforce.unitDesignationsPageInfo,
      fetchingUnitDesignations: state.workforce.fetchingUnitDesignations,
      fetchedUnitDesignations: state.workforce.fetchedUnitDesignations,
      errorUnitDesignations: state.workforce.errorUnitDesignations,
      submittingMutation: state.workforce.submittingMutation,
      mutation: state.workforce.mutation,
      confirmed: state.core.confirmed
    }
  );
};
var mapDispatchToProps$J = function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    fetchUnitDesignationSummary: fetchUnitDesignationSummary,
    journalize: journalize,
    coreConfirm: coreConfirm
  }, dispatch);
};
var UnitDesignationSearcher$1 = withModulesManager(withHistory(connect(mapStateToProps$1e, mapDispatchToProps$J)(withTheme(withStyles(styles$1i)(UnitDesignationSearcher)))));

function _callSuper$1n(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$1n() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$1n() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$1n = function _isNativeReflectConstruct() { return !!t; })(); }
var styles$1h = function styles(theme) {
  return {
    page: theme.page,
    fab: theme.fab,
    ROUTE_WORKFORCE_ORGANIZATIONS_ORGANIZATION: ROUTE_WORKFORCE_ORGANIZATIONS_ORGANIZATION
  };
};
var UnitDesignationsPage = /*#__PURE__*/function (_Component) {
  function UnitDesignationsPage() {
    var _this;
    _classCallCheck(this, UnitDesignationsPage);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper$1n(this, UnitDesignationsPage, [].concat(args));
    _defineProperty(_this, "onDoubleClick", function (unitDesignation) {
      var newTab = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var routeParams = ["workforce.route.unit.designations.designation", [decodeId(unitDesignation.id)]];
      if (unitDesignation !== null && unitDesignation !== void 0 && unitDesignation.isHistory) {
        routeParams[1].push(unitDesignation.version);
      }
      historyPush$1.apply(void 0, [_this.props.modulesManager, _this.props.history].concat(routeParams, [newTab]));
    });
    _defineProperty(_this, "onAdd", function () {
      historyPush$1(_this.props.modulesManager, _this.props.history, "workforce.route.unit.designations.designation");
    });
    return _this;
  }
  _inherits(UnitDesignationsPage, _Component);
  return _createClass(UnitDesignationsPage, [{
    key: "render",
    value: function render() {
      var _this$props = this.props;
        _this$props.intl;
        var classes = _this$props.classes;
        _this$props.rights;
      return /*#__PURE__*/React.createElement("div", {
        className: classes.page
      }, /*#__PURE__*/React.createElement(UnitDesignationSearcher$1, {
        cacheFiltersKey: "ticketPageFiltersCache",
        onDoubleClick: this.onDoubleClick
      }), withTooltip(/*#__PURE__*/React.createElement("div", {
        className: classes.fab
      }, /*#__PURE__*/React.createElement(Fab, {
        color: "primary",
        onClick: this.onAdd
      }, /*#__PURE__*/React.createElement(AddIcon, null))), /*#__PURE__*/React.createElement(FormattedMessage, {
        module: MODULE_NAME,
        id: "workforce.organization.addNewTooltip"
      })));
    }
  }]);
}(Component);
var mapStateToProps$1d = function mapStateToProps(state) {
  return {
    rights: !!state.core && !!state.core.user && !!state.core.user.i_user ? state.core.user.i_user.rights : []
  };
};
var UnitDesignationsPage$1 = withModulesManager(withHistory(connect(mapStateToProps$1d)(withTheme(withStyles(styles$1h)(UnitDesignationsPage)))));

function _callSuper$1m(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$1m() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$1m() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$1m = function _isNativeReflectConstruct() { return !!t; })(); }
var styles$1g = function styles(theme) {
  return {
    dialogTitle: theme.dialog.title,
    dialogContent: theme.dialog.content,
    form: {
      padding: 0
    },
    item: {
      padding: theme.spacing(1)
    },
    paperDivider: theme.paper.divider
  };
};
var WORKFORCE_ORGANIZATION_EMPLOYEE_FILTER_CONTRIBUTION_KEY$2 = "workforce.organization.employee.Filter";
var OrganizationEmployeeFilter = /*#__PURE__*/function (_Component) {
  function OrganizationEmployeeFilter() {
    var _this;
    _classCallCheck(this, OrganizationEmployeeFilter);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper$1m(this, OrganizationEmployeeFilter, [].concat(args));
    _defineProperty(_this, "debouncedOnChangeFilter", _debounce(_this.props.onChangeFilters, 800));
    _defineProperty(_this, "_filterValue", function (k) {
      var filters = _this.props.filters;
      return !!filters && !!filters[k] ? filters[k].value : null;
    });
    _defineProperty(_this, "_onChangeReporter", function (k, v) {
      _this.props.onChangeFilters([{
        id: k,
        value: v,
        filter: "".concat(k, ": \"").concat(decodeId(v === null || v === void 0 ? void 0 : v.id), "\"")
      }]);
    });
    _defineProperty(_this, "_onChangeCheckbox", function (key, value) {
      var filters = [{
        id: key,
        value: value,
        filter: "".concat(key, ": ").concat(value)
      }];
      _this.props.onChangeFilters(filters);
      _this.props.setShowHistoryFilter(value);
    });
    return _this;
  }
  _inherits(OrganizationEmployeeFilter, _Component);
  return _createClass(OrganizationEmployeeFilter, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        classes = _this$props.classes,
        filters = _this$props.filters,
        onChangeFilters = _this$props.onChangeFilters;
      return /*#__PURE__*/React.createElement(Grid, {
        container: true,
        className: classes.form
      }, /*#__PURE__*/React.createElement(ControlledField, {
        module: MODULE_NAME,
        id: "workforce.organization.name.employee.en",
        field: /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 3,
          className: classes.item
        }, /*#__PURE__*/React.createElement(TextInput, {
          module: MODULE_NAME,
          label: "workforce.organization.employee.name.en",
          name: "nameEn",
          value: this._filterValue("nameEn"),
          onChange: function onChange(v) {
            return _this2.debouncedOnChangeFilter([{
              id: 'nameEn',
              value: v,
              filter: "nameEn_Icontains: \"".concat(v, "\"")
            }]);
          }
        }))
      }), /*#__PURE__*/React.createElement(ControlledField, {
        module: MODULE_NAME,
        id: "workforce.organization.employee.name.bn",
        field: /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 3,
          className: classes.item
        }, /*#__PURE__*/React.createElement(TextInput, {
          module: MODULE_NAME,
          label: "workforce.organization.employee.name.bn",
          name: "nameBn",
          value: this._filterValue("nameBn"),
          onChange: function onChange(v) {
            return _this2.debouncedOnChangeFilter([{
              id: 'nameBn',
              value: v,
              filter: "nameBn_Icontains: \"".concat(v, "\"")
            }]);
          }
        }))
      }), /*#__PURE__*/React.createElement(ControlledField, {
        module: MODULE_NAME,
        id: "workforce.organization.employee.phone",
        field: /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 3,
          className: classes.item
        }, /*#__PURE__*/React.createElement(TextInput, {
          module: MODULE_NAME,
          label: "workforce.organization.employee.phone",
          name: "address",
          value: this._filterValue("phoneNumber"),
          onChange: function onChange(v) {
            return _this2.debouncedOnChangeFilter([{
              id: 'phoneNumber',
              value: v,
              filter: "phoneNumber_Icontains: \"".concat(v, "\"")
            }]);
          }
        }))
      }), /*#__PURE__*/React.createElement(ControlledField, {
        module: MODULE_NAME,
        id: "workforce.organization.employee.status",
        field: /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 3,
          className: classes.item
        }, /*#__PURE__*/React.createElement(TextInput, {
          module: MODULE_NAME,
          label: "workforce.organization.employee.status",
          name: "status",
          value: this._filterValue("status"),
          onChange: function onChange(v) {
            return _this2.debouncedOnChangeFilter([{
              id: 'status',
              value: v,
              filter: "status: \"".concat(v, "\"")
            }]);
          }
        }))
      }), /*#__PURE__*/React.createElement(Contributions, {
        filters: filters,
        onChangeFilters: onChangeFilters,
        contributionKey: WORKFORCE_ORGANIZATION_EMPLOYEE_FILTER_CONTRIBUTION_KEY$2
      }));
    }
  }]);
}(Component);
var OrganizationEmployeeFilter$1 = withModulesManager(withTheme(withStyles(styles$1g)(OrganizationEmployeeFilter)));

function _callSuper$1l(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$1l() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$1l() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$1l = function _isNativeReflectConstruct() { return !!t; })(); }
function ownKeys$1U(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$1U(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$1U(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1U(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var styles$1f = function styles(theme) {
  return {
    paper: _objectSpread$1U(_objectSpread$1U({}, theme.paper.paper), {}, {
      margin: 0
    }),
    paperHeader: _objectSpread$1U(_objectSpread$1U({}, theme.paper.header), {}, {
      padding: 10
    }),
    tableTitle: theme.table.title,
    fab: theme.fab,
    button: {
      margin: theme.spacing(1)
    },
    item: {
      padding: theme.spacing(1)
    }
  };
};
var OrganizationEmployeeSearcher = /*#__PURE__*/function (_Component) {
  function OrganizationEmployeeSearcher(props) {
    var _this;
    _classCallCheck(this, OrganizationEmployeeSearcher);
    _this = _callSuper$1l(this, OrganizationEmployeeSearcher, [props]);
    _defineProperty(_this, "fetch", function (prms) {
      var showHistoryFilter = _this.state.showHistoryFilter;
      _this.setState({
        displayVersion: showHistoryFilter
      });
      _this.props.fetchOrganizationEmployeesSummary(_this.props.modulesManager, prms);
    });
    _defineProperty(_this, "rowIdentifier", function (r) {
      return r.uuid;
    });
    _defineProperty(_this, "isShowHistory", function () {
      return _this.state.displayVersion;
    });
    _defineProperty(_this, "filtersToQueryParams", function (state) {
      var prms = Object.keys(state.filters).filter(function (f) {
        return !!state.filters[f].filter;
      }).map(function (f) {
        return state.filters[f].filter;
      });
      prms.push("first: ".concat(state.pageSize));
      if (state.afterCursor) {
        prms.push("after: \"".concat(state.afterCursor, "\""));
      }
      if (state.beforeCursor) {
        prms.push("before: \"".concat(state.beforeCursor, "\""));
      }
      if (state.orderBy) {
        prms.push("orderBy: [\"".concat(state.orderBy, "\"]"));
      }
      return prms;
    });
    _defineProperty(_this, "headers", function () {
      return ["workforce.organization.employee.name.en", "workforce.organization.employee.name.bn", "workforce.organization.employee.phone", "workforce.organization.employee.email", "workforce.organization.employee.address", "workforce.organization.employee.gender", "workforce.organization.employee.status", _this.isShowHistory() ? "workforce.version" : ""];
    });
    _defineProperty(_this, "sorts", function () {
      return [];
    });
    _defineProperty(_this, "itemFormatters", function () {
      var formatters = [function (organizationemployee) {
        return organizationemployee.nameEn;
      }, function (organizationemployee) {
        return organizationemployee.nameBn;
      }, function (organizationemployee) {
        return organizationemployee.phoneNumber;
      }, function (organizationemployee) {
        return organizationemployee.email;
      }, function (organizationemployee) {
        return organizationemployee.address;
      }, function (organizationemployee) {
        return organizationemployee.gender;
      }, function (organizationemployee) {
        return organizationemployee.status;
      }, function (organizationemployee) {
        return _this.isShowHistory() ? organizationemployee === null || organizationemployee === void 0 ? void 0 : organizationemployee.version : null;
      }];
      formatters.push(function (organizationemployee) {
        return /*#__PURE__*/React.createElement(Tooltip, {
          title: "Edit"
        }, /*#__PURE__*/React.createElement(IconButton, {
          disabled: organizationemployee === null || organizationemployee === void 0 ? void 0 : organizationemployee.isHistory,
          onClick: function onClick() {
            historyPush$1(_this.props.modulesManager, _this.props.history, "workforce.route.organizations.employees.employee", [decodeId(organizationemployee.id)], false);
          }
        }, /*#__PURE__*/React.createElement(EditIcon, null)));
      });
      return formatters;
    });
    _defineProperty(_this, "rowDisabled", function (selection, i) {
      return !!i.validityTo;
    });
    _defineProperty(_this, "rowLocked", function (selection, i) {
      return !!i.clientMutationId;
    });
    _this.state = {
      chfid: null,
      confirmedAction: null,
      reset: 0,
      showHistoryFilter: false,
      displayVersion: false
    };
    _this.rowsPerPageOptions = [10, 20, 50, 100];
    _this.defaultPageSize = 10;
    return _this;
  }
  _inherits(OrganizationEmployeeSearcher, _Component);
  return _createClass(OrganizationEmployeeSearcher, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState, snapshot) {
      if (prevProps.submittingMutation && !this.props.submittingMutation) {
        this.props.journalize(this.props.mutation);
        this.setState({
          reset: prevState.reset + 1
        });
      } else if (!prevProps.confirmed && this.props.confirmed) {
        this.state.confirmedAction();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props;
        _this$props.intl;
        var organizationEmployees = _this$props.organizationEmployees,
        organizationEmployeesPageInfo = _this$props.organizationEmployeesPageInfo,
        fetchingOrganizationEmployees = _this$props.fetchingOrganizationEmployees,
        fetchedOrganizationEmployees = _this$props.fetchedOrganizationEmployees,
        errorOrganizationEmployees = _this$props.errorOrganizationEmployees,
        filterPaneContributionsKey = _this$props.filterPaneContributionsKey,
        cacheFiltersKey = _this$props.cacheFiltersKey,
        _onDoubleClick = _this$props.onDoubleClick;
      organizationEmployeesPageInfo.totalCount;
      var filterPane = function filterPane(_ref) {
        var filters = _ref.filters,
          onChangeFilters = _ref.onChangeFilters;
        return /*#__PURE__*/React.createElement(OrganizationEmployeeFilter$1, {
          filters: filters,
          onChangeFilters: onChangeFilters,
          setShowHistoryFilter: function setShowHistoryFilter(showHistoryFilter) {
            return _this2.setState({
              showHistoryFilter: showHistoryFilter
            });
          }
        });
      };
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Searcher$2, {
        module: MODULE_NAME,
        cacheFiltersKey: cacheFiltersKey,
        FilterPane: filterPane,
        filterPaneContributionsKey: filterPaneContributionsKey,
        items: organizationEmployees,
        itemsPageInfo: organizationEmployeesPageInfo,
        fetchingItems: fetchingOrganizationEmployees,
        fetchedItems: fetchedOrganizationEmployees,
        errorItems: errorOrganizationEmployees,
        tableTitle: /*#__PURE__*/React.createElement(FormattedMessage, {
          module: MODULE_NAME,
          id: "menu.workforce.organizations.employee"
        }),
        rowsPerPageOptions: this.rowsPerPageOptions,
        defaultPageSize: this.defaultPageSize,
        fetch: this.fetch,
        rowIdentifier: this.rowIdentifier,
        filtersToQueryParams: this.filtersToQueryParams,
        defaultOrderBy: "-dateCreated",
        headers: this.headers,
        itemFormatters: this.itemFormatters,
        sorts: this.sorts,
        rowDisabled: this.rowDisabled,
        rowLocked: this.rowLocked,
        onDoubleClick: function onDoubleClick(i) {
          return !i.clientMutationId && _onDoubleClick(i);
        },
        reset: this.state.reset
      }));
    }
  }]);
}(Component);
var mapStateToProps$1c = function mapStateToProps(state) {
  return {
    rights: !!state.core && !!state.core.user && !!state.core.user.i_user ? state.core.user.i_user.rights : [],
    organizationEmployees: state.workforce.organizationEmployees,
    organizationEmployeesPageInfo: state.workforce.organizationEmployeesPageInfo,
    fetchingOrganizationEmployees: state.workforce.fetchingOrganizationEmployees,
    fetchedOrganizationEmployees: state.workforce.fetchedOrganizationEmployees,
    errorOrganizationEmployees: state.workforce.errorOrganizationEmployees,
    submittingMutation: state.workforce.submittingMutation,
    mutation: state.workforce.mutation,
    confirmed: state.core.confirmed
  };
};
var mapDispatchToProps$I = function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    fetchOrganizationEmployeesSummary: fetchOrganizationEmployeesSummary,
    journalize: journalize,
    coreConfirm: coreConfirm
  }, dispatch);
};
var OrganizationEmployeeSearcher$1 = withModulesManager(withHistory(connect(mapStateToProps$1c, mapDispatchToProps$I)(withTheme(withStyles(styles$1f)(OrganizationEmployeeSearcher)))));

function _callSuper$1k(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$1k() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$1k() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$1k = function _isNativeReflectConstruct() { return !!t; })(); }
var styles$1e = function styles(theme) {
  return {
    page: theme.page,
    fab: theme.fab,
    ROUTE_WORKFORCE_ORGANIZATIONS_EMPLOYEES_EMPLOYEE: ROUTE_WORKFORCE_ORGANIZATIONS_EMPLOYEES_EMPLOYEE
  };
};
var OrganizationEmployeesPage = /*#__PURE__*/function (_Component) {
  function OrganizationEmployeesPage() {
    var _this;
    _classCallCheck(this, OrganizationEmployeesPage);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper$1k(this, OrganizationEmployeesPage, [].concat(args));
    _defineProperty(_this, "onDoubleClick", function (employee) {
      var newTab = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var routeParams = ["workforce.route.organizations.employees.employee", [decodeId(employee.id)]];
      if (employee !== null && employee !== void 0 && employee.isHistory) {
        routeParams[1].push(employee.version);
      }
      historyPush$1.apply(void 0, [_this.props.modulesManager, _this.props.history].concat(routeParams, [newTab]));
    });
    _defineProperty(_this, "onAdd", function () {
      historyPush$1(_this.props.modulesManager, _this.props.history, "workforce.route.organizations.employees.employee");
    });
    return _this;
  }
  _inherits(OrganizationEmployeesPage, _Component);
  return _createClass(OrganizationEmployeesPage, [{
    key: "render",
    value: function render() {
      var _this$props = this.props;
        _this$props.intl;
        var classes = _this$props.classes;
        _this$props.rights;
      return /*#__PURE__*/React.createElement("div", {
        className: classes.page
      }, /*#__PURE__*/React.createElement(OrganizationEmployeeSearcher$1, {
        cacheFiltersKey: "ticketPageFiltersCache",
        onDoubleClick: this.onDoubleClick
      }), withTooltip(/*#__PURE__*/React.createElement("div", {
        className: classes.fab
      }, /*#__PURE__*/React.createElement(Fab, {
        color: "primary",
        onClick: this.onAdd
      }, /*#__PURE__*/React.createElement(AddIcon, null))), /*#__PURE__*/React.createElement(FormattedMessage, {
        module: MODULE_NAME,
        id: "workforce.organization.employee.addNewTooltip"
      })));
    }
  }]);
}(Component);
var mapStateToProps$1b = function mapStateToProps(state) {
  return {
    rights: !!state.core && !!state.core.user && !!state.core.user.i_user ? state.core.user.i_user.rights : []
  };
};
var OrganizationEmployeesPage$1 = withModulesManager(withHistory(connect(mapStateToProps$1b)(withTheme(withStyles(styles$1e)(OrganizationEmployeesPage)))));

var EmployeeGenderPicker = function EmployeeGenderPicker(_ref) {
  _ref.modulesManager;
    var _onChange = _ref.onChange,
    readOnly = _ref.readOnly,
    required = _ref.required,
    _ref$withLabel = _ref.withLabel,
    withLabel = _ref$withLabel === void 0 ? true : _ref$withLabel,
    withPlaceholder = _ref.withPlaceholder,
    value = _ref.value,
    label = _ref.label,
    placeholder = _ref.placeholder,
    filterOptions = _ref.filterOptions,
    filterSelectedOptions = _ref.filterSelectedOptions;
    _ref.multiple;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2);
    _useState2[0];
    var setSearchString = _useState2[1];
  var _useTranslations = useTranslations("workforce"),
    formatMessage = _useTranslations.formatMessage;
  var selectedOption = useMemo(function () {
    return WORKFORCE_GENDER.find(function (option) {
      return option.name === value;
    }) || null;
  }, [value]);
  return /*#__PURE__*/React.createElement(Autocomplete, {
    multiple: false,
    required: required,
    placeholder: placeholder !== null && placeholder !== void 0 ? placeholder : "",
    label: label !== null && label !== void 0 ? label : formatMessage("workforce.organization.employee.gender"),
    withLabel: withLabel,
    withPlaceholder: withPlaceholder,
    readOnly: readOnly,
    isLoading: true,
    options: WORKFORCE_GENDER,
    value: selectedOption,
    getOptionLabel: function getOptionLabel(option) {
      return formatMessage(option.name);
    },
    onChange: function onChange(option) {
      return _onChange(option, option ? "".concat(option) : null);
    },
    filterOptions: filterOptions,
    filterSelectedOptions: filterSelectedOptions,
    onInputChange: setSearchString
  });
};

function ownKeys$1T(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$1T(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$1T(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1T(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper$1j(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$1j() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$1j() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$1j = function _isNativeReflectConstruct() { return !!t; })(); }
var styles$1d = function styles(theme) {
  return {
    paper: theme.paper.paper,
    tableTitle: theme.table.title,
    item: theme.paper.item,
    fullHeight: {
      height: "100%"
    }
  };
};
var EditOrganizationEmployeePage = /*#__PURE__*/function (_Component) {
  function EditOrganizationEmployeePage(props) {
    var _this;
    _classCallCheck(this, EditOrganizationEmployeePage);
    _this = _callSuper$1j(this, EditOrganizationEmployeePage, [props]);
    _defineProperty(_this, "updateAttribute", function (key, value) {
      _this.setState(function (prevState) {
        return {
          stateEdited: _objectSpread$1T(_objectSpread$1T({}, prevState.stateEdited), {}, _defineProperty({}, key, value)),
          isSaved: false
        };
      });
    });
    _defineProperty(_this, "save", function () {
      var _stateEdited$gender;
      var _this$props = _this.props;
        _this$props.grievanceConfig;
        var dispatch = _this$props.dispatch;
      var stateEdited = _this.state.stateEdited;
      var organizationEmployeeData = {
        nameBn: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.titleBn) || stateEdited.nameBn,
        nameEn: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.title) || stateEdited.nameEn,
        phoneNumber: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.phone) || stateEdited.phoneNumber,
        email: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.email) || stateEdited.email,
        gender: (stateEdited === null || stateEdited === void 0 || (_stateEdited$gender = stateEdited.gender) === null || _stateEdited$gender === void 0 ? void 0 : _stateEdited$gender.id) || stateEdited.gender.id,
        birthDate: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.birthDate) || stateEdited.birthDate,
        birthCertificateNo: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.birthCertificateNo) || stateEdited.birthCertificateNo,
        firstJoiningDate: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.firstJoiningDate) || stateEdited.firstJoiningDate,
        passportNo: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.passportNo) || stateEdited.passportNo,
        address: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.address) || stateEdited.address,
        location: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.location) || stateEdited.location,
        id: stateEdited.id
      };
      dispatch(updateOrganizationEmployee(organizationEmployeeData, "Update Organization Employee ".concat(organizationEmployeeData.nameEn)));
      _this.setState({
        isSaved: true
      });
    });
    _this.state = {
      stateEdited: props.organizationEmployee || {},
      isSaved: false
    };
    return _this;
  }
  _inherits(EditOrganizationEmployeePage, _Component);
  return _createClass(EditOrganizationEmployeePage, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.organizationEmployee !== this.props.organizationEmployee) {
        this.setState({
          stateEdited: this.props.organizationEmployee
        });
      }
      if (prevProps.submittingMutation && !this.props.submittingMutation) {
        this.props.dispatch(journalize(this.props.mutation));
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var classes = this.props.classes;
      var _this$state = this.state,
        stateEdited = _this$state.stateEdited,
        isSaved = _this$state.isSaved;
      return /*#__PURE__*/React.createElement("div", {
        className: classes.page
      }, /*#__PURE__*/React.createElement(Grid, {
        container: true
      }, /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12
      }, /*#__PURE__*/React.createElement(Paper, {
        className: classes.paper
      }, /*#__PURE__*/React.createElement(Grid, {
        container: true,
        className: classes.tableTitle
      }, /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12,
        className: classes.tableTitle
      }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(FormattedMessage, {
        module: MODULE_NAME,
        id: "Organizations Employee",
        values: {
          label: EMPTY_STRING
        }
      })))), /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement(Grid, {
        container: true,
        className: classes.item
      }, /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.organization.employee.name.en",
        value: stateEdited.nameEn,
        onChange: function onChange(v) {
          return _this2.updateAttribute("title", v);
        },
        required: true,
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.organization.employee.name.bn",
        value: stateEdited.nameBn || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("titleBn", v);
        },
        required: true,
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.organization.employee.phone",
        value: stateEdited.phoneNumber || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("phone", v);
        },
        type: "number",
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.organization.employee.email",
        value: stateEdited.email || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("email", v);
        },
        type: "email",
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(EmployeeGenderPicker, {
        value: stateEdited.gender || "",
        label: /*#__PURE__*/React.createElement(FormattedMessage, {
          id: "workforce.organization.employee.gender",
          module: "workforce"
        }),
        onChange: function onChange(v) {
          return _this2.updateAttribute("gender", v);
        },
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(PublishedComponent, {
        pubRef: "workforce.DatePicker",
        label: "workforce.organization.employee.birthdate",
        value: stateEdited.birthDate || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("birthDate", v);
        },
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(PublishedComponent, {
        pubRef: "workforce.DatePicker",
        label: "workforce.organization.employee.joining_date",
        value: stateEdited.firstJoiningDate || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("firstJoiningDate", v);
        },
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.organization.employee.birth_certificate_no",
        value: stateEdited.birthCertificateNo || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("birthCertificateNo", v);
        },
        type: "number",
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.organization.employee.nid",
        value: stateEdited.nid || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("nid", v);
        },
        type: "number",
        required: true,
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.organization.employee.passport_no",
        value: stateEdited.passportNo || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("passportNo", v);
        },
        type: "number",
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.organization.employee.address",
        value: stateEdited.address || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("address", v);
        },
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12,
        className: classes.item
      }, /*#__PURE__*/React.createElement(PublishedComponent, {
        pubRef: "location.DetailedLocation",
        withNull: true,
        value: stateEdited.location || null,
        onChange: function onChange(location) {
          return _this2.updateAttribute("location", location);
        },
        readOnly: isSaved,
        required: true,
        split: true
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 11,
        className: classes.item
      }), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 1,
        className: classes.item
      }, /*#__PURE__*/React.createElement(IconButton, {
        variant: "contained",
        component: "label",
        color: "primary",
        onClick: this.save,
        disabled: isSaved
      }, /*#__PURE__*/React.createElement(Save, null)))), /*#__PURE__*/React.createElement(Divider, null)))));
    }
  }]);
}(Component);
var mapStateToProps$1a = function mapStateToProps(state) {
  return {
    organizationEmployee: state.workforce.organizationEmployee
  };
};
var EditOrganizationEmployeePage$1 = connect(mapStateToProps$1a)(withStyles(styles$1d)(EditOrganizationEmployeePage));

function ownKeys$1S(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$1S(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$1S(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1S(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper$1i(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$1i() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$1i() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$1i = function _isNativeReflectConstruct() { return !!t; })(); }
var styles$1c = function styles(theme) {
  return {
    paper: theme.paper.paper,
    tableTitle: theme.table.title,
    item: theme.paper.item,
    fullHeight: {
      height: "100%"
    }
  };
};
var AddWorkforceEmployeePage$1 = /*#__PURE__*/function (_Component) {
  function AddWorkforceEmployeePage(props) {
    var _this;
    _classCallCheck(this, AddWorkforceEmployeePage);
    _this = _callSuper$1i(this, AddWorkforceEmployeePage, [props]);
    _defineProperty(_this, "save", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var stateEdited, dispatch, workforceEmployeeData;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            stateEdited = _this.state.stateEdited;
            dispatch = _this.props.dispatch;
            workforceEmployeeData = {
              nameBn: stateEdited.titleBn,
              nameEn: stateEdited.title,
              phoneNumber: stateEdited.phone,
              email: stateEdited.email,
              birthDate: stateEdited.birthDate,
              gender: stateEdited.gender.id,
              firstJoiningDate: stateEdited.firstJoiningDate,
              birthCertificateNo: stateEdited.birthCertificateNo,
              nid: stateEdited.nid,
              passportNo: stateEdited.passportNo,
              address: stateEdited.address,
              location: stateEdited.location,
              status: WORKFORCE_STATUS$1.ACTIVE,
              organizationEmployee: stateEdited.organizationEmployee
            };
            _context.next = 5;
            return dispatch(createOrganizationEmployee(workforceEmployeeData, "Created Organization Employee ".concat(workforceEmployeeData.nameEn)));
          case 5:
            _this.setState({
              isSaved: true
            });
          case 6:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })));
    _defineProperty(_this, "updateAttribute", function (key, value) {
      _this.setState(function (prevState) {
        return {
          stateEdited: _objectSpread$1S(_objectSpread$1S({}, prevState.stateEdited), {}, _defineProperty({}, key, value)),
          isSaved: false
        };
      });
    });
    _this.state = {
      stateEdited: {},
      isSaved: false
    };
    return _this;
  }
  _inherits(AddWorkforceEmployeePage, _Component);
  return _createClass(AddWorkforceEmployeePage, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props = this.props,
        submittingMutation = _this$props.submittingMutation,
        mutation = _this$props.mutation,
        dispatch = _this$props.dispatch;
      if (!submittingMutation && prevProps.submittingMutation !== submittingMutation) {
        dispatch(journalize(mutation));
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this,
        _stateEdited$gender;
      var classes = this.props.classes;
      var _this$state = this.state,
        stateEdited = _this$state.stateEdited,
        isSaved = _this$state.isSaved;
      console.log({
        stateEdited: stateEdited
      });
      return /*#__PURE__*/React.createElement("div", {
        className: classes.page
      }, /*#__PURE__*/React.createElement(Grid, {
        container: true
      }, /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12
      }, /*#__PURE__*/React.createElement(Paper, {
        className: classes.paper
      }, /*#__PURE__*/React.createElement(Grid, {
        container: true,
        className: classes.tableTitle
      }, /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12,
        className: classes.tableTitle
      }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(FormattedMessage, {
        module: MODULE_NAME,
        id: "Organizations Employee",
        values: {
          label: EMPTY_STRING
        }
      })))), /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement(Grid, {
        container: true,
        className: classes.item
      }, /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.organization.employee.name.en",
        value: stateEdited.title || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("title", v);
        },
        required: true,
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.organization.employee.name.bn",
        value: stateEdited.titleBn || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("titleBn", v);
        },
        required: true,
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.organization.employee.phone",
        value: stateEdited.phone || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("phone", v);
        },
        type: "number",
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.organization.employee.email",
        value: stateEdited.email || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("email", v);
        },
        type: "email",
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(EmployeeGenderPicker, {
        value: stateEdited === null || stateEdited === void 0 || (_stateEdited$gender = stateEdited.gender) === null || _stateEdited$gender === void 0 ? void 0 : _stateEdited$gender.id,
        label: /*#__PURE__*/React.createElement(FormattedMessage, {
          id: "workforce.organization.employee.gender",
          module: "workforce"
        }),
        onChange: function onChange(v) {
          return _this2.updateAttribute("gender", v);
        },
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(PublishedComponent, {
        pubRef: "workforce.DatePicker",
        label: "workforce.organization.employee.birthdate",
        value: stateEdited.birthDate || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("birthDate", v);
        },
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(PublishedComponent, {
        pubRef: "workforce.DatePicker",
        label: "workforce.organization.employee.joining_date",
        value: stateEdited.firstJoiningDate || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("firstJoiningDate", v);
        },
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.organization.employee.birth_certificate_no",
        value: stateEdited.birthCertificateNo || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("birthCertificateNo", v);
        },
        type: "number",
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.organization.employee.nid",
        value: stateEdited.nid || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("nid", v);
        },
        type: "number",
        required: true,
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.organization.employee.passport_no",
        value: stateEdited.passportNo || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("passportNo", v);
        },
        type: "number",
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12,
        className: classes.item
      }, /*#__PURE__*/React.createElement(PublishedComponent, {
        pubRef: "location.DetailedLocation",
        withNull: true,
        value: stateEdited.location || null,
        onChange: function onChange(location) {
          return _this2.updateAttribute("location", location);
        },
        readOnly: isSaved,
        required: true,
        split: true
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.organization.employee.address",
        value: stateEdited.address || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("address", v);
        },
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 11,
        className: classes.item
      }), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 1,
        className: classes.item
      }, /*#__PURE__*/React.createElement(IconButton, {
        variant: "contained",
        component: "label",
        color: "primary",
        onClick: this.save,
        disabled: isSaved
      }, /*#__PURE__*/React.createElement(Save, null)))), /*#__PURE__*/React.createElement(Divider, null)))));
    }
  }]);
}(Component);
var mapStateToProps$19 = function mapStateToProps(state) {
  return {
    submittingMutation: state.workforce.submittingMutation,
    mutation: state.workforce.mutation
  };
};
var AddOrganizationEmployeePage = connect(mapStateToProps$19)(withStyles(styles$1c)(AddWorkforceEmployeePage$1));

function ownKeys$1R(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$1R(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$1R(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1R(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper$1h(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$1h() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$1h() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$1h = function _isNativeReflectConstruct() { return !!t; })(); }
var OrganizationEmployeeForm = /*#__PURE__*/function (_Component) {
  function OrganizationEmployeeForm(props) {
    var _this;
    _classCallCheck(this, OrganizationEmployeeForm);
    _this = _callSuper$1h(this, OrganizationEmployeeForm, [props]);
    _defineProperty(_this, "reload", function () {});
    _defineProperty(_this, "canSave", function () {});
    _defineProperty(_this, "_save", function (ticket) {
      _this.setState({
        lockNew: !ticket.uuid
      }, function () {
        return _this.props.save(ticket);
      });
    });
    _defineProperty(_this, "onEditedChanged", function (ticket) {
      _this.setState({
        ticket: ticket
      });
    });
    _defineProperty(_this, "reopenTicket", function () {
      var _this$props = _this.props,
        intl = _this$props.intl,
        ticket = _this$props.ticket;
      _this.props.reopenTicket(ticket.id, formatMessage(intl, MODULE_NAME, "reopenTicket.mutation.label"));
    });
    _this.state = {
      lockNew: false,
      reset: 0,
      organizationEmployeeUuid: null,
      ticket: _this._newTicket()
    };
    return _this;
  }
  _inherits(OrganizationEmployeeForm, _Component);
  return _createClass(OrganizationEmployeeForm, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.organizationEmployeeUuid) {
        this.setState(function (state, props) {
          return {
            organizationEmployeeUuid: props.organizationEmployeeUuid
          };
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {}
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState, snapshot) {
      if (prevProps.fetchedOrganizationEmployee !== this.props.fetchedOrganizationEmployee && !!this.props.fetchedOrganizationEmployee && !!this.props.organizationEmployee) {
        this.setState(function (state, props) {
          return {
            organizationEmployee: _objectSpread$1R({}, props.organizationEmployee),
            organizationEmployeeUuid: props.organizationEmployee.id,
            lockNew: false
          };
        });
      } else if (prevState.organizationEmployeeUuid !== this.state.organizationEmployeeUuid) {
        var filters = ["id: \"".concat(this.state.organizationEmployeeUuid, "\"")];
        this.props.fetchOrganizationEmployee(this.props.modulesManager, filters);
      } else if (prevProps.submittingMutation && !this.props.submittingMutation) {
        var _this$props2;
        this.props.journalize(this.props.mutation);
        this.setState(function (state) {
          return {
            reset: state.reset + 1
          };
        });
        if ((_this$props2 = this.props) !== null && _this$props2 !== void 0 && (_this$props2 = _this$props2.organizationEmployee) !== null && _this$props2 !== void 0 && _this$props2.id) {
          this.props.fetchOrganizationEmployee(this.props.modulesManager, ["id: \"".concat(this.state.organizationEmployeeUuid, "\"")]);
        }
      }
    }
  }, {
    key: "_newTicket",
    value: function _newTicket() {
      return {};
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
        fetchingTicket = _this$props3.fetchingTicket,
        fetchedOrganizationEmployee = _this$props3.fetchedOrganizationEmployee,
        errorTicket = _this$props3.errorTicket,
        save = _this$props3.save,
        back = _this$props3.back;
      var _this$state = this.state,
        lockNew = _this$state.lockNew,
        reset = _this$state.reset,
        update = _this$state.update,
        overview = _this$state.overview,
        organizationEmployeeUuid = _this$state.organizationEmployeeUuid,
        ticket = _this$state.ticket;
      var readOnly = lockNew || !!ticket.validityTo || this.props.readOnly;
      [{
        doIt: this.reopenTicket,
        icon: /*#__PURE__*/React.createElement(LockOpenIcon, null),
        disabled: ticket.isHistory
      }];
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ProgressOrError, {
        progress: fetchingTicket,
        error: errorTicket
      }), (!!fetchedOrganizationEmployee || !organizationEmployeeUuid) && /*#__PURE__*/React.createElement(Form, {
        module: MODULE_NAME,
        edited_id: organizationEmployeeUuid,
        edited: ticket,
        reset: reset,
        update: update,
        title: "Organizations Employee",
        titleParams: {
          label: "Label"
        },
        back: back,
        save: save ? this._save : null,
        canSave: this.canSave,
        reload: (organizationEmployeeUuid || readOnly) && this.reload,
        readOnly: readOnly,
        overview: overview,
        Panels: organizationEmployeeUuid ? [EditOrganizationEmployeePage$1] : [AddOrganizationEmployeePage],
        onEditedChanged: this.onEditedChanged
      }));
    }
  }]);
}(Component); // eslint-disable-next-line no-unused-vars
var mapStateToProps$18 = function mapStateToProps(state, props) {
  return {
    rights: !!state.core && !!state.core.user && !!state.core.user.i_user ? state.core.user.i_user.rights : [],
    fetchingTicket: state.workforce.fetchingTicket,
    errorTicket: state.workforce.errorTicket,
    fetchedOrganizationEmployee: state.workforce.fetchedOrganizationEmployee,
    ticket: state.workforce.ticket,
    submittingMutation: state.workforce.submittingMutation,
    mutation: state.workforce.mutation,
    grievanceConfig: state.workforce.grievanceConfig
  };
};
var mapDispatchToProps$H = function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    fetchOrganizationEmployee: fetchOrganizationEmployee,
    journalize: journalize
  }, dispatch);
};
var OrganizationEmployeeForm$1 = withModulesManager(connect(mapStateToProps$18, mapDispatchToProps$H)(OrganizationEmployeeForm));

function _callSuper$1g(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$1g() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$1g() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$1g = function _isNativeReflectConstruct() { return !!t; })(); }
var styles$1b = function styles(theme) {
  return {
    page: theme.page,
    lockedPage: theme.page.locked
  };
};
var OrganizationEmployeePage = /*#__PURE__*/function (_Component) {
  function OrganizationEmployeePage() {
    var _this;
    _classCallCheck(this, OrganizationEmployeePage);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper$1g(this, OrganizationEmployeePage, [].concat(args));
    _defineProperty(_this, "add", function () {
      historyPush$1(_this.props.modulesManager, _this.props.history, "grievance.route.ticket");
    });
    _defineProperty(_this, "save", function (employee) {
      if (!employee.id) {
        _this.props.createOrganizationEmployee(_this.props.modulesManager, employee, "Create");
      } else {
        _this.props.updateOrganizationEmployee(_this.props.modulesManager, employee, "Update");
      }
    });
    return _this;
  }
  _inherits(OrganizationEmployeePage, _Component);
  return _createClass(OrganizationEmployeePage, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        classes = _this$props.classes,
        modulesManager = _this$props.modulesManager,
        history = _this$props.history,
        rights = _this$props.rights,
        organizationEmployeeUuid = _this$props.organizationEmployeeUuid,
        overview = _this$props.overview,
        organizationVersion = _this$props.organizationVersion;
      // const readOnly = organization?.status === TICKET_STATUSES.CLOSED || ticket?.isHistory;
      var readOnly = false;
      // if (!(rights.includes(RIGHT_ORGANIZATION_CREATE) || rights.includes(RIGHT_ORGANIZATION_EDIT))) return null;
      return /*#__PURE__*/React.createElement("div", {
        className: "".concat(null, " ").concat(classes.page)
      }, /*#__PURE__*/React.createElement(OrganizationEmployeeForm$1, {
        overview: overview,
        organizationEmployeeUuid: organizationEmployeeUuid,
        organizationVersion: organizationVersion,
        readOnly: readOnly,
        back: function back() {
          return historyPush$1(modulesManager, history, "workforce.route.organizations.employees");
        },
        add: rights.includes(RIGHT_ORGANIZATION_CREATE) ? this.add : null,
        save: rights.includes(RIGHT_ORGANIZATION_EDIT) ? this.save : null
      }));
    }
  }]);
}(Component);
var mapStateToProps$17 = function mapStateToProps(state, props) {
  return {
    rights: !!state.core && !!state.core.user && !!state.core.user.i_user ? state.core.user.i_user.rights : [],
    organizationEmployeeUuid: props.match.params.organization_employee_uuid,
    organizationVersion: props.match.params.version,
    employee: state.workforce.employee
  };
};
var mapDispatchToProps$G = function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    createOrganizationEmployee: createOrganizationEmployee,
    updateOrganizationEmployee: updateOrganizationEmployee
  }, dispatch);
};
var OrganizationEmployeePage$1 = withHistory(withModulesManager(connect(mapStateToProps$17, mapDispatchToProps$G)(withTheme(withStyles(styles$1b)(OrganizationEmployeePage)))));

function ownKeys$1Q(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$1Q(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$1Q(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1Q(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var styles$1a = function styles(theme) {
  return {
    dialogTitle: theme.dialog.title,
    dialogContent: theme.dialog.content,
    form: {
      padding: 0
    },
    item: {
      padding: theme.spacing(1)
    },
    paperDivider: theme.paper.divider
  };
};
var useStyles$1F = makeStyles(function (theme) {
  return {
    paper: theme.paper.paper,
    tableTitle: _objectSpread$1Q(_objectSpread$1Q({}, theme.table.title), {}, {
      padding: theme.spacing(0.5, 1) // Reduced vertical padding
    }),
    headerButton: _objectSpread$1Q(_objectSpread$1Q({}, theme.table.title), {}, {
      padding: theme.spacing(0),
      textAlign: "right"
    }),
    item: theme.paper.item,
    fullHeight: {
      height: "100%"
    },
    largeButton: {
      fontSize: "1rem" // Larger font size for buttons
      // padding: theme.spacing(1.5), // Larger padding for buttons
    }
  };
});
var EmployeeDesignationSearcher = function EmployeeDesignationSearcher(_ref) {
  var handleSearch = _ref.handleSearch,
    onEmailChange = _ref.onEmailChange,
    onNidChange = _ref.onNidChange;
  var classes = useStyles$1F();
  useDispatch();
  // const modulesManager = useModulesManager();

  var _useState = useState(""),
    _useState2 = _slicedToArray(_useState, 2),
    email = _useState2[0],
    setEmail = _useState2[1];
  var _useState3 = useState(""),
    _useState4 = _slicedToArray(_useState3, 2),
    nid = _useState4[0],
    setNid = _useState4[1];

  // const handleSearch = () => {
  //   const prms = [];
  //   prms.push(`email: "${email}"`);
  //   // prms.push(`designations_Status: "${WORKFORCE_STATUS.ACTIVE}"`);
  //   dispatch(fetchEmployeeDesignations(modulesManager, prms));
  // };

  var handleReset = function handleReset() {
    setEmail("");
    setNid("");
    console.log("Filters reset");
  };
  return /*#__PURE__*/React.createElement("div", {
    className: classes.page
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    className: classes.form
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(Paper, {
    className: classes.paper
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    className: classes.tableTitle,
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 9
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5",
    fontWeight: "bold"
  }, "Employee Designation")), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 2,
    className: classes.headerButton
  }, /*#__PURE__*/React.createElement(Button, {
    size: "large",
    className: classes.largeButton,
    onClick: handleReset,
    startIcon: /*#__PURE__*/React.createElement(YoutubeSearchedFor, null)
  }, "Reset Filters")), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 1,
    className: classes.tableTitle
  }, /*#__PURE__*/React.createElement(Button, {
    size: "large",
    className: classes.largeButton,
    onClick: function onClick() {
      return handleSearch();
    },
    startIcon: /*#__PURE__*/React.createElement(Search, null)
  }, "Search"))), /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 2,
    className: classes.item
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6,
    className: classes.item
  }, /*#__PURE__*/React.createElement(TextInput, {
    label: "Email",
    value: email || "",
    onChange: function onChange(value) {
      return onEmailChange(value);
    },
    required: true,
    readOnly: false,
    type: "email"
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6,
    className: classes.item
  }, /*#__PURE__*/React.createElement(TextInput, {
    label: "User NID",
    value: nid,
    onChange: function onChange(value) {
      return onNidChange(value);
    },
    required: true,
    readOnly: false,
    type: "number"
  })))))));
};

// export default EmployeeDesignationSearcher
var EmployeeDesignationSearcher$1 = withModulesManager(withTheme(withStyles(styles$1a)(EmployeeDesignationSearcher)));

function ownKeys$1P(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$1P(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$1P(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1P(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var useStyles$1E = makeStyles(function (theme) {
  return {
    paper: theme.paper.paper,
    root: _objectSpread$1P(_objectSpread$1P({}, theme.paper.paper), {}, {
      padding: theme.spacing(0),
      justifyContent: "space-around"
    }),
    userCard: _objectSpread$1P(_objectSpread$1P({}, theme.paper.paper), {}, {
      padding: theme.spacing(0)
    }),
    userCard2: _objectSpread$1P(_objectSpread$1P({}, theme.paper.paper), {}, {
      padding: theme.spacing(1),
      textAlign: "left",
      margin: "0px"
    }),
    tableContainer: {
      padding: theme.spacing(1)
    },
    tableHeader: _objectSpread$1P(_objectSpread$1P({}, theme.table.title), {}, {
      padding: theme.spacing(0.5, 1),
      fontSize: "18px",
      fontWeight: "bold"
    }),
    deleteButton: {
      color: theme.palette.error.main
    }
  };
});
var EmployeeDesignationInfo = function EmployeeDesignationInfo(_ref) {
  var userData = _ref.userData,
    employeeDesignationData = _ref.employeeDesignationData,
    onReleaseDateChange = _ref.onReleaseDateChange;
  var classes = useStyles$1E();
  var dispatch = useDispatch();
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    releaseDate = _useState2[0],
    setReleaseDate = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    tableData = _useState4[0],
    setTableData = _useState4[1];
  useEffect(function () {
    // Assign data only when employeeDesignationData changes
    if (employeeDesignationData !== null && employeeDesignationData !== void 0 && employeeDesignationData.designations) {
      setTableData(employeeDesignationData.designations);
    }
  }, [employeeDesignationData]);
  var handleRelease = function handleRelease(row) {
    var _row$designation;
    var updateReleaseDate = {
      releaseDate: releaseDate,
      id: decodeId(row.id),
      designationId: decodeId(row === null || row === void 0 || (_row$designation = row.designation) === null || _row$designation === void 0 ? void 0 : _row$designation.id),
      employeeId: employeeDesignationData === null || employeeDesignationData === void 0 ? void 0 : employeeDesignationData.id,
      status: "inactive"
    };
    dispatch(updateWorkforceOrganizationEmployeeDesignation(updateReleaseDate, "updated Organization Employee designation ".concat(employeeDesignationData.nameBn)));
    setTableData(function (prevData) {
      return prevData.map(function (item) {
        return item.id === row.id ? _objectSpread$1P(_objectSpread$1P({}, item), {}, {
          status: "inactive"
        }) : item;
      });
    });
    onReleaseDateChange(releaseDate);
  };
  console.log({
    releaseDate: releaseDate
  });
  return /*#__PURE__*/React.createElement(Paper, {
    className: classes.paper
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 0,
    className: classes.root
  }, userData && userData.name && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 4
  }, /*#__PURE__*/React.createElement(Paper, {
    className: classes.userCard
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.tableHeader
  }, "Employee Info"), /*#__PURE__*/React.createElement(Paper, {
    className: classes.userCard2
  }, /*#__PURE__*/React.createElement(Typography, null, "Name: ", userData.name), /*#__PURE__*/React.createElement(Typography, null, "Email: ", userData.email), /*#__PURE__*/React.createElement(Typography, null, "Phone: ", userData.phone), /*#__PURE__*/React.createElement(Typography, null, "NID: ", userData.nid)))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 8
  }, /*#__PURE__*/React.createElement(Paper, {
    className: classes.paper
  }, /*#__PURE__*/React.createElement(TableContainer, null, /*#__PURE__*/React.createElement(Table$2, {
    size: "small"
  }, /*#__PURE__*/React.createElement(TableHead, {
    className: classes.tableHeader
  }, /*#__PURE__*/React.createElement(TableRow, null, /*#__PURE__*/React.createElement(TableCell, null, "Organization"), /*#__PURE__*/React.createElement(TableCell, null, "Unit"), /*#__PURE__*/React.createElement(TableCell, null, "Designation"), /*#__PURE__*/React.createElement(TableCell, null, "Release Date"), /*#__PURE__*/React.createElement(TableCell, null))), /*#__PURE__*/React.createElement(TableBody, null, tableData.map(function (row, index) {
    var _row$designation2, _row$designation3, _row$designation4;
    return (row === null || row === void 0 ? void 0 : row.status) === WORKFORCE_STATUS$1.ACTIVE && /*#__PURE__*/React.createElement(TableRow, {
      key: index
    }, /*#__PURE__*/React.createElement(TableCell, null, row === null || row === void 0 || (_row$designation2 = row.designation) === null || _row$designation2 === void 0 || (_row$designation2 = _row$designation2.organization) === null || _row$designation2 === void 0 ? void 0 : _row$designation2.nameBn), /*#__PURE__*/React.createElement(TableCell, null, row === null || row === void 0 || (_row$designation3 = row.designation) === null || _row$designation3 === void 0 || (_row$designation3 = _row$designation3.unit) === null || _row$designation3 === void 0 ? void 0 : _row$designation3.nameBn), /*#__PURE__*/React.createElement(TableCell, null, row === null || row === void 0 || (_row$designation4 = row.designation) === null || _row$designation4 === void 0 ? void 0 : _row$designation4.nameBn), /*#__PURE__*/React.createElement(TableCell, null, /*#__PURE__*/React.createElement(PublishedComponent, {
      pubRef: "workforce.DatePicker",
      label: "Release Date",
      onChange: function onChange(v) {
        return setReleaseDate(v);
      },
      readOnly: false,
      required: false
    })), /*#__PURE__*/React.createElement(TableCell, null, /*#__PURE__*/React.createElement(IconButton, {
      className: classes.deleteButton,
      onClick: function onClick() {
        return handleRelease(row);
      }
    }, /*#__PURE__*/React.createElement(DeleteIcon, null))));
  })))))))));
};

// export default EmployeeDesignationInfo;
var EmployeeDesignaitonInfo = withModulesManager(withTheme(EmployeeDesignationInfo));

function ownKeys$1O(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$1O(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$1O(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1O(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var useStyles$1D = makeStyles(function (theme) {
  return {
    paper: theme.paper.paper,
    root: _objectSpread$1O(_objectSpread$1O({}, theme.paper.paper), {}, {
      padding: theme.spacing(0),
      justifyContent: "space-around"
    }),
    table: {
      borderCollapse: "collapse" // Ensure the borders look seamless
    },
    tableRow: {
      "&:hover": {
        backgroundColor: theme.palette.action.hover // Optional: Highlight on hover
      },
      height: "40px",
      maxHeight: "20px",
      minHeight: 0
    },
    tableCell: {
      border: "1px solid #bab5b5",
      // Light border for each cell
      padding: "0px 10px",
      // Remove all padding for maximum compactness
      lineHeight: 0.5,
      // Reduce line height
      fontSize: "0.8rem" // Optional: Adjust font size for better compactness
    },
    userCard: _objectSpread$1O(_objectSpread$1O({}, theme.paper.paper), {}, {
      padding: theme.spacing(0)
    }),
    userCard2: _objectSpread$1O(_objectSpread$1O({}, theme.paper.paper), {}, {
      padding: theme.spacing(1),
      textAlign: "left",
      margin: "0px"
    }),
    tableContainer: {
      padding: theme.spacing(1)
    },
    tableHeader: _objectSpread$1O(_objectSpread$1O({}, theme.table.title), {}, {
      padding: theme.spacing(0.5, 1),
      fontSize: "16px",
      // Reduce header font size slightly
      fontWeight: "bold"
    }),
    assignButton: {
      color: theme.palette.success.main
    }
  };
});
var AssignDesignation = function AssignDesignation(_ref) {
  _ref.userData;
    var stateEdited = _ref.stateEdited;
    _ref.updateAttribute;
    _ref.tableData;
    var handleSearch = _ref.handleSearch,
    unitWiseDesignations = _ref.unitWiseDesignations,
    fetchUnitWiseDesignations = _ref.fetchUnitWiseDesignations;
  var classes = useStyles$1D();
  useModulesManager();
  var dispatch = useDispatch();
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    assignDate = _useState2[0],
    setAssignDate = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    disabledAssignButton = _useState4[0],
    setDisabledAssignButton = _useState4[1]; // Track button disabled state

  var employeeDesignationData = useSelector(function (state) {
    return state.workforce["employeeDesignationData"];
  });

  // const fetchUnitWiseDesignations = async (v) => {
  //   const prms = [];
  //   prms.push(`organization_Id: "${decodeId(v.id)}"`);
  //   prms.push(`orderBy:["unit_level", "unit_designations__designation_level"]`);

  //   await dispatch(
  //     fetchWorkforceUnitsWithEmployeeDesignation(modulesManager, prms),
  //   );
  // };
  // const unitWiseDesignations = useSelector(
  //   (state) => state.workforce[`unitWiseDesignationData`],
  // );

  var handleAssign = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(row) {
      var assignData;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            setDisabledAssignButton(true);
            assignData = {
              designationId: decodeId(row.id),
              employeeId: employeeDesignationData.id,
              joiningDate: assignDate,
              status: WORKFORCE_STATUS$1.ACTIVE
            };
            _context.next = 4;
            return dispatch(updateWorkforceOrganizationEmployeeAssignDesignation(assignData, "updated Organization Employee designation ".concat(row.nameEn)));
          case 4:
            handleSearch();
          case 5:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function handleAssign(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  console.log({
    unitWiseDesignations: unitWiseDesignations
  });
  return /*#__PURE__*/React.createElement(Paper, {
    className: classes.paper
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 0,
    className: classes.root
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    className: classes.userCard,
    spacing: 2
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.tableHeader
  }, "Assign")), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 4
  }, /*#__PURE__*/React.createElement(PublishedComponent, {
    pubRef: "workforceOrganization.OrganizationPicker",
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      module: "workforce",
      id: "workforce.organization.picker"
    }),
    value: stateEdited.organization || null,
    onChange: function onChange(v) {
      return fetchUnitWiseDesignations(v);
    },
    required: true,
    readOnly: false
  })), unitWiseDesignations === null || unitWiseDesignations === void 0 ? void 0 : unitWiseDesignations.map(function (unit) {
    return /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      key: unit.id
    }, /*#__PURE__*/React.createElement(TableContainer, null, /*#__PURE__*/React.createElement(Table$2, {
      size: "small"
    }, /*#__PURE__*/React.createElement(TableHead, {
      className: classes.tableHeader
    }, /*#__PURE__*/React.createElement(TableRow, null, /*#__PURE__*/React.createElement(TableCell, {
      colSpan: 4
    }, /*#__PURE__*/React.createElement("b", null, unit.nameBn)))), /*#__PURE__*/React.createElement(TableBody, null, unit === null || unit === void 0 ? void 0 : unit.unitDesignations.map(function (row, index) {
      var _row$activeEmployeeDe, _row$activeEmployeeDe2;
      return /*#__PURE__*/React.createElement(TableRow, {
        key: index,
        className: classes.tableRow
      }, /*#__PURE__*/React.createElement(TableCell, {
        className: classes.tableCell,
        style: {
          width: "50%"
        }
      }, row === null || row === void 0 ? void 0 : row.nameEn), row !== null && row !== void 0 && row.activeEmployeeDesignation && (row === null || row === void 0 ? void 0 : row.activeEmployeeDesignation.length) > 0 ? /*#__PURE__*/React.createElement(TableCell, {
        className: classes.tableCell,
        colSpan: 2,
        style: {
          textAlign: "center"
        }
      }, row === null || row === void 0 || (_row$activeEmployeeDe = row.activeEmployeeDesignation[0]) === null || _row$activeEmployeeDe === void 0 ? void 0 : _row$activeEmployeeDe.employee.nameEn, " ", row === null || row === void 0 || (_row$activeEmployeeDe2 = row.activeEmployeeDesignation[0]) === null || _row$activeEmployeeDe2 === void 0 ? void 0 : _row$activeEmployeeDe2.employee.email) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TableCell, {
        className: classes.tableCell,
        style: {
          width: "30%"
        }
      }, /*#__PURE__*/React.createElement(PublishedComponent, {
        pubRef: "workforce.DatePicker",
        label: "Assign Date",
        onChange: function onChange(v) {
          return setAssignDate(v);
        },
        readOnly: disabledAssignButton ? true : false,
        required: false
      })), /*#__PURE__*/React.createElement(TableCell, {
        className: classes.tableCell,
        style: {
          width: "20%"
        }
      }, /*#__PURE__*/React.createElement(IconButton, {
        disabled: disabledAssignButton,
        className: classes.assignButton,
        onClick: function onClick() {
          return handleAssign(row);
        }
      }, /*#__PURE__*/React.createElement(AddBoxIcon, null)))));
    })))));
  })))));
};

// export default AssignDesignation;
var AssignDesignation$1 = withModulesManager(withTheme(AssignDesignation));

function ownKeys$1N(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$1N(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$1N(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1N(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper$1f(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$1f() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$1f() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$1f = function _isNativeReflectConstruct() { return !!t; })(); }
var OrganizationEmployeeDesignationPage = /*#__PURE__*/function (_Component) {
  function OrganizationEmployeeDesignationPage(props) {
    var _this;
    _classCallCheck(this, OrganizationEmployeeDesignationPage);
    _this = _callSuper$1f(this, OrganizationEmployeeDesignationPage, [props]);
    _defineProperty(_this, "updateAttribute", function (key, value) {
      _this.setState(function (prevState) {
        return {
          stateEdited: _objectSpread$1N(_objectSpread$1N({}, prevState.stateEdited), {}, _defineProperty({}, key, value)),
          isSaved: false
        };
      });
    });
    _defineProperty(_this, "handleSearch", function () {
      var _this$state = _this.state,
        email = _this$state.email,
        nid = _this$state.nid;
      var prms = [];
      if (email) {
        prms.push("email: \"".concat(email, "\""));
      }
      if (nid) {
        prms.push("nid: \"".concat(nid, "\""));
      }
      _this.props.fetchEmployeeDesignations(prms);
    });
    _defineProperty(_this, "handleEmailChange", function (email) {
      _this.setState({
        email: email
      });
    });
    _defineProperty(_this, "handleNidChange", function (nid) {
      _this.setState({
        nid: nid
      });
    });
    _defineProperty(_this, "fetchUnitWiseDesignations", /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(v) {
        var prms;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              prms = [];
              prms.push("organization_Id: \"".concat(decodeId(v === null || v === void 0 ? void 0 : v.id), "\""));
              prms.push("orderBy:[\"unit_level\", \"unit_designations__designation_level\"]");
              _context.next = 5;
              return _this.props.fetchWorkforceUnitsWithEmployeeDesignation(prms);
            case 5:
              _this.setState({
                selectedOrganization: v
              });
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
    _defineProperty(_this, "handleReleaseDateChange", function (date) {
      _this.setState({
        releaseDate: date
      });
    });
    _this.state = {
      stateEdited: {},
      isSaved: false
    };
    return _this;
  }
  _inherits(OrganizationEmployeeDesignationPage, _Component);
  return _createClass(OrganizationEmployeeDesignationPage, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var _this$props$employeeD;
      if (prevProps.employeeDesignationData !== this.props.employeeDesignationData && (_this$props$employeeD = this.props.employeeDesignationData) !== null && _this$props$employeeD !== void 0 && _this$props$employeeD.organization) {
        this.fetchUnitWiseDesignations(this.props.employeeDesignationData.organization);
      }
      if (prevState.releaseDate !== this.state.releaseDate && this.state.selectedOrganization) {
        this.fetchUnitWiseDesignations(this.state.selectedOrganization);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        employeeDesignationData = _this$props.employeeDesignationData,
        unitWiseDesignationData = _this$props.unitWiseDesignationData;
      var _this$state2 = this.state,
        stateEdited = _this$state2.stateEdited;
        _this$state2.isSaved;
        _this$state2.email;
        _this$state2.nid;
        _this$state2.releaseDate;
        _this$state2.selectedOrganization;
      var userData = {
        name: (employeeDesignationData === null || employeeDesignationData === void 0 ? void 0 : employeeDesignationData.nameBn) || "",
        email: (employeeDesignationData === null || employeeDesignationData === void 0 ? void 0 : employeeDesignationData.email) || "",
        phone: (employeeDesignationData === null || employeeDesignationData === void 0 ? void 0 : employeeDesignationData.phoneNumber) || "",
        nid: (employeeDesignationData === null || employeeDesignationData === void 0 ? void 0 : employeeDesignationData.nid) || ""
      };
      var tableData = (employeeDesignationData === null || employeeDesignationData === void 0 ? void 0 : employeeDesignationData.designations) || [];
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(EmployeeDesignationSearcher$1, {
        handleSearch: this.handleSearch,
        onEmailChange: this.handleEmailChange,
        onNidChange: this.handleNidChange
      }), /*#__PURE__*/React.createElement(EmployeeDesignaitonInfo, {
        employeeDesignationData: employeeDesignationData,
        userData: userData,
        tableData: tableData,
        fetchUnitWiseDesignations: this.fetchUnitWiseDesignations,
        onReleaseDateChange: this.handleReleaseDateChange
      }), /*#__PURE__*/React.createElement(AssignDesignation$1, {
        userData: userData,
        stateEdited: stateEdited,
        updateAttribute: this.updateAttribute,
        tableData: tableData,
        handleSearch: this.handleSearch,
        unitWiseDesignations: unitWiseDesignationData,
        fetchUnitWiseDesignations: this.fetchUnitWiseDesignations,
        onValueChange: this.handleValueChange
      }));
    }
  }]);
}(Component);
var mapStateToProps$16 = function mapStateToProps(state) {
  return {
    employeeDesignationData: state.workforce.employeeDesignationData,
    unitWiseDesignationData: state.workforce.unitWiseDesignationData
  };
};

// const mapDispatchToProps = (dispatch) => ({
//   // fetchEmployeeDesignations: bindActionCreators(fetchEmployeeDesignations, dispatch),
// });

var mapDispatchToProps$F = function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    fetchEmployeeDesignations: fetchEmployeeDesignations,
    fetchWorkforceUnitsWithEmployeeDesignation: fetchWorkforceUnitsWithEmployeeDesignation // Add the function here
  }, dispatch);
};
var OrganizationEmployeeDesignationPage$1 = connect(mapStateToProps$16, mapDispatchToProps$F)(withModulesManager(OrganizationEmployeeDesignationPage));

function _callSuper$1e(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$1e() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$1e() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$1e = function _isNativeReflectConstruct() { return !!t; })(); }
var styles$19 = function styles(theme) {
  return {
    dialogTitle: theme.dialog.title,
    dialogContent: theme.dialog.content,
    form: {
      padding: 0
    },
    item: {
      padding: theme.spacing(1)
    },
    paperDivider: theme.paper.divider
  };
};
var WORKFORCE_OFFICE_FILTER_CONTRIBUTION_KEY = "workforce.OFFICE.Filter";
var WorkforceOfficeFilter = /*#__PURE__*/function (_Component) {
  function WorkforceOfficeFilter() {
    var _this;
    _classCallCheck(this, WorkforceOfficeFilter);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper$1e(this, WorkforceOfficeFilter, [].concat(args));
    _defineProperty(_this, "debouncedOnChangeFilter", _debounce(_this.props.onChangeFilters, 800));
    _defineProperty(_this, "_filterValue", function (k) {
      var filters = _this.props.filters;
      return !!filters && !!filters[k] ? filters[k].value : null;
    });
    _defineProperty(_this, "_onChangeReporter", function (k, v) {
      _this.props.onChangeFilters([{
        id: k,
        value: v,
        filter: "".concat(k, ": \"").concat(decodeId(v === null || v === void 0 ? void 0 : v.id), "\"")
      }]);
    });
    _defineProperty(_this, "_onChangeCheckbox", function (key, value) {
      var filters = [{
        id: key,
        value: value,
        filter: "".concat(key, ": ").concat(value)
      }];
      _this.props.onChangeFilters(filters);
      _this.props.setShowHistoryFilter(value);
    });
    return _this;
  }
  _inherits(WorkforceOfficeFilter, _Component);
  return _createClass(WorkforceOfficeFilter, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        classes = _this$props.classes,
        filters = _this$props.filters,
        onChangeFilters = _this$props.onChangeFilters;
      return /*#__PURE__*/React.createElement(Grid, {
        container: true,
        className: classes.form
      }, /*#__PURE__*/React.createElement(ControlledField, {
        module: MODULE_NAME,
        id: "workforce.office.name.en",
        field: /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 3,
          className: classes.item
        }, /*#__PURE__*/React.createElement(TextInput, {
          module: MODULE_NAME,
          label: "workforce.office.name.en",
          name: "nameEn",
          value: this._filterValue("nameEn"),
          onChange: function onChange(v) {
            return _this2.debouncedOnChangeFilter([{
              id: 'nameEn',
              value: v,
              filter: "nameEn_Icontains: \"".concat(v, "\"")
            }]);
          }
        }))
      }), /*#__PURE__*/React.createElement(ControlledField, {
        module: MODULE_NAME,
        id: "workforce.office.name.bn",
        field: /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 3,
          className: classes.item
        }, /*#__PURE__*/React.createElement(TextInput, {
          module: MODULE_NAME,
          label: "workforce.office.name.bn",
          name: "nameBn",
          value: this._filterValue("nameBn"),
          onChange: function onChange(v) {
            return _this2.debouncedOnChangeFilter([{
              id: 'nameBn',
              value: v,
              filter: "nameBn_Icontains: \"".concat(v, "\"")
            }]);
          }
        }))
      }), /*#__PURE__*/React.createElement(ControlledField, {
        module: MODULE_NAME,
        id: "workforce.office.phone",
        field: /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 3,
          className: classes.item
        }, /*#__PURE__*/React.createElement(TextInput, {
          module: MODULE_NAME,
          label: "workforce.office.phone",
          name: "address",
          value: this._filterValue("phoneNumber"),
          onChange: function onChange(v) {
            return _this2.debouncedOnChangeFilter([{
              id: 'phoneNumber',
              value: v,
              filter: "phoneNumber_Icontains: \"".concat(v, "\"")
            }]);
          }
        }))
      }), /*#__PURE__*/React.createElement(ControlledField, {
        module: MODULE_NAME,
        id: "workforce.office.status",
        field: /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 3,
          className: classes.item
        }, /*#__PURE__*/React.createElement(TextInput, {
          module: MODULE_NAME,
          label: "workforce.office.status",
          name: "status",
          value: this._filterValue("status"),
          onChange: function onChange(v) {
            return _this2.debouncedOnChangeFilter([{
              id: 'status',
              value: v,
              filter: "status: \"".concat(v, "\"")
            }]);
          }
        }))
      }), /*#__PURE__*/React.createElement(Contributions, {
        filters: filters,
        onChangeFilters: onChangeFilters,
        contributionKey: WORKFORCE_OFFICE_FILTER_CONTRIBUTION_KEY
      }));
    }
  }]);
}(Component);
var WorkforceOfficeFilter$1 = withModulesManager(withTheme(withStyles(styles$19)(WorkforceOfficeFilter)));

function _callSuper$1d(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$1d() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$1d() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$1d = function _isNativeReflectConstruct() { return !!t; })(); }
function ownKeys$1M(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$1M(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$1M(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1M(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var styles$18 = function styles(theme) {
  return {
    paper: _objectSpread$1M(_objectSpread$1M({}, theme.paper.paper), {}, {
      margin: 0
    }),
    paperHeader: _objectSpread$1M(_objectSpread$1M({}, theme.paper.header), {}, {
      padding: 10
    }),
    tableTitle: theme.table.title,
    fab: theme.fab,
    button: {
      margin: theme.spacing(1)
    },
    item: {
      padding: theme.spacing(1)
    }
  };
};
var WorkforceOfficeSearcher = /*#__PURE__*/function (_Component) {
  function WorkforceOfficeSearcher(props) {
    var _this;
    _classCallCheck(this, WorkforceOfficeSearcher);
    _this = _callSuper$1d(this, WorkforceOfficeSearcher, [props]);
    _defineProperty(_this, "fetch", function (prms) {
      var showHistoryFilter = _this.state.showHistoryFilter;
      _this.setState({
        displayVersion: showHistoryFilter
      });
      _this.props.fetchWorkforceOfficesSummary(_this.props.modulesManager, prms);
    });
    _defineProperty(_this, "rowIdentifier", function (r) {
      return r.uuid;
    });
    _defineProperty(_this, "isShowHistory", function () {
      return _this.state.displayVersion;
    });
    _defineProperty(_this, "filtersToQueryParams", function (state) {
      var prms = Object.keys(state.filters).filter(function (f) {
        return !!state.filters[f].filter;
      }).map(function (f) {
        return state.filters[f].filter;
      });
      prms.push("first: ".concat(state.pageSize));
      if (state.afterCursor) {
        prms.push("after: \"".concat(state.afterCursor, "\""));
      }
      if (state.beforeCursor) {
        prms.push("before: \"".concat(state.beforeCursor, "\""));
      }
      if (state.orderBy) {
        prms.push("orderBy: [\"".concat(state.orderBy, "\"]"));
      }
      return prms;
    });
    _defineProperty(_this, "headers", function () {
      return ["workforce.office.name.en", "workforce.office.name.bn", "workforce.office.phone", "workforce.office.email", "workforce.office.address", "workforce.office.website", "workforce.office.status", _this.isShowHistory() ? 'workforce.version' : ''];
    });
    _defineProperty(_this, "sorts", function () {
      return [];
    });
    _defineProperty(_this, "itemFormatters", function () {
      var formatters = [function (workforceoffice) {
        return workforceoffice.nameEn;
      }, function (workforceoffice) {
        return workforceoffice.nameBn;
      }, function (workforceoffice) {
        return workforceoffice.phoneNumber;
      }, function (workforceoffice) {
        return workforceoffice.email;
      }, function (workforceoffice) {
        return workforceoffice.address;
      }, function (workforceoffice) {
        return workforceoffice.website;
      }, function (workforceoffice) {
        return workforceoffice.status;
      }, function (workforceoffice) {
        return _this.isShowHistory() ? workforceoffice === null || workforceoffice === void 0 ? void 0 : workforceoffice.version : null;
      }];
      formatters.push(function (workforceoffice) {
        return /*#__PURE__*/React.createElement(Tooltip, {
          title: "Edit"
        }, /*#__PURE__*/React.createElement(IconButton, {
          disabled: workforceoffice === null || workforceoffice === void 0 ? void 0 : workforceoffice.isHistory,
          onClick: function onClick() {
            historyPush$1(_this.props.modulesManager, _this.props.history, 'workforce.route.offices.office', [decodeId(workforceoffice.id)], false);
          }
        }, /*#__PURE__*/React.createElement(EditIcon, null)));
      });
      return formatters;
    });
    _defineProperty(_this, "rowDisabled", function (selection, i) {
      return !!i.validityTo;
    });
    _defineProperty(_this, "rowLocked", function (selection, i) {
      return !!i.clientMutationId;
    });
    _this.state = {
      chfid: null,
      confirmedAction: null,
      reset: 0,
      showHistoryFilter: false,
      displayVersion: false
    };
    _this.rowsPerPageOptions = [10, 20, 50, 100];
    _this.defaultPageSize = 10;
    return _this;
  }
  _inherits(WorkforceOfficeSearcher, _Component);
  return _createClass(WorkforceOfficeSearcher, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState, snapshot) {
      if (prevProps.submittingMutation && !this.props.submittingMutation) {
        this.props.journalize(this.props.mutation);
        this.setState({
          reset: prevState.reset + 1
        });
      } else if (!prevProps.confirmed && this.props.confirmed) {
        this.state.confirmedAction();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props;
        _this$props.intl;
        var workforceOffices = _this$props.workforceOffices,
        workforceOfficesPageInfo = _this$props.workforceOfficesPageInfo,
        fetchingWorkforceOffices = _this$props.fetchingWorkforceOffices,
        fetchedWorkforceOffices = _this$props.fetchedWorkforceOffices,
        errorWorkforceOffices = _this$props.errorWorkforceOffices,
        filterPaneContributionsKey = _this$props.filterPaneContributionsKey,
        cacheFiltersKey = _this$props.cacheFiltersKey,
        _onDoubleClick = _this$props.onDoubleClick;
      workforceOfficesPageInfo.totalCount;
      var filterPane = function filterPane(_ref) {
        var filters = _ref.filters,
          onChangeFilters = _ref.onChangeFilters;
        return /*#__PURE__*/React.createElement(WorkforceOfficeFilter$1, {
          filters: filters,
          onChangeFilters: onChangeFilters,
          setShowHistoryFilter: function setShowHistoryFilter(showHistoryFilter) {
            return _this2.setState({
              showHistoryFilter: showHistoryFilter
            });
          }
        });
      };
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Searcher$2, {
        module: MODULE_NAME,
        cacheFiltersKey: cacheFiltersKey,
        FilterPane: filterPane,
        filterPaneContributionsKey: filterPaneContributionsKey,
        items: workforceOffices,
        itemsPageInfo: workforceOfficesPageInfo,
        fetchingItems: fetchingWorkforceOffices,
        fetchedItems: fetchedWorkforceOffices,
        errorItems: errorWorkforceOffices,
        tableTitle: /*#__PURE__*/React.createElement(FormattedMessage, {
          module: MODULE_NAME,
          id: "menu.workforce.office"
        }),
        rowsPerPageOptions: this.rowsPerPageOptions,
        defaultPageSize: this.defaultPageSize,
        fetch: this.fetch,
        rowIdentifier: this.rowIdentifier,
        filtersToQueryParams: this.filtersToQueryParams,
        defaultOrderBy: "-dateCreated",
        headers: this.headers,
        itemFormatters: this.itemFormatters,
        sorts: this.sorts,
        rowDisabled: this.rowDisabled,
        rowLocked: this.rowLocked,
        onDoubleClick: function onDoubleClick(i) {
          return !i.clientMutationId && _onDoubleClick(i);
        },
        reset: this.state.reset
      }));
    }
  }]);
}(Component);
var mapStateToProps$15 = function mapStateToProps(state) {
  return {
    rights: !!state.core && !!state.core.user && !!state.core.user.i_user ? state.core.user.i_user.rights : [],
    workforceOffices: state.workforce.workforceOffices,
    workforceOfficesPageInfo: state.workforce.workforceOfficesPageInfo,
    fetchingWorkforceOffices: state.workforce.fetchingWorkforceOffices,
    fetchedWorkforceOffices: state.workforce.fetchedWorkforceOffices,
    errorWorkforceOffices: state.workforce.errorWorkforceOffices,
    submittingMutation: state.workforce.submittingMutation,
    mutation: state.workforce.mutation,
    confirmed: state.core.confirmed
  };
};
var mapDispatchToProps$E = function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    fetchWorkforceOfficesSummary: fetchWorkforceOfficesSummary,
    journalize: journalize,
    coreConfirm: coreConfirm
  }, dispatch);
};
var OrganizationOfficeSearcher = withModulesManager(withHistory(connect(mapStateToProps$15, mapDispatchToProps$E)(withTheme(withStyles(styles$18)(WorkforceOfficeSearcher)))));

function _callSuper$1c(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$1c() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$1c() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$1c = function _isNativeReflectConstruct() { return !!t; })(); }
var styles$17 = function styles(theme) {
  return {
    page: theme.page,
    fab: theme.fab,
    ROUTE_WORKFORCE_OFFICES_OFFICE: ROUTE_WORKFORCE_OFFICES_OFFICE
  };
};
var WorkforceOfficesPage = /*#__PURE__*/function (_Component) {
  function WorkforceOfficesPage() {
    var _this;
    _classCallCheck(this, WorkforceOfficesPage);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper$1c(this, WorkforceOfficesPage, [].concat(args));
    _defineProperty(_this, "onDoubleClick", function (office) {
      var newTab = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var routeParams = ['workforce.route.offices.office', [decodeId(office.id)]];
      if (office !== null && office !== void 0 && office.isHistory) {
        routeParams[1].push(office.version);
      }
      historyPush$1.apply(void 0, [_this.props.modulesManager, _this.props.history].concat(routeParams, [newTab]));
    });
    _defineProperty(_this, "onAdd", function () {
      historyPush$1(_this.props.modulesManager, _this.props.history, 'workforce.route.offices.office');
    });
    return _this;
  }
  _inherits(WorkforceOfficesPage, _Component);
  return _createClass(WorkforceOfficesPage, [{
    key: "render",
    value: function render() {
      var _this$props = this.props;
        _this$props.intl;
        var classes = _this$props.classes;
        _this$props.rights;
      return /*#__PURE__*/React.createElement("div", {
        className: classes.page
      }, /*#__PURE__*/React.createElement(OrganizationOfficeSearcher, {
        cacheFiltersKey: "ticketPageFiltersCache",
        onDoubleClick: this.onDoubleClick
      }), withTooltip(/*#__PURE__*/React.createElement("div", {
        className: classes.fab
      }, /*#__PURE__*/React.createElement(Fab, {
        color: "primary",
        onClick: this.onAdd
      }, /*#__PURE__*/React.createElement(AddIcon, null))), /*#__PURE__*/React.createElement(FormattedMessage, {
        module: MODULE_NAME,
        id: "workforce.office.addNewTooltip"
      })));
    }
  }]);
}(Component);
var mapStateToProps$14 = function mapStateToProps(state) {
  return {
    rights: !!state.core && !!state.core.user && !!state.core.user.i_user ? state.core.user.i_user.rights : []
  };
};
var OrganizationOfficesPage = withModulesManager(withHistory(connect(mapStateToProps$14)(withTheme(withStyles(styles$17)(WorkforceOfficesPage)))));

function ownKeys$1L(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$1L(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$1L(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1L(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper$1b(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$1b() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$1b() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$1b = function _isNativeReflectConstruct() { return !!t; })(); }
var styles$16 = function styles(theme) {
  return {
    paper: theme.paper.paper,
    tableTitle: theme.table.title,
    item: theme.paper.item,
    fullHeight: {
      height: "100%"
    }
  };
};
var EditWorkforceOfficePage = /*#__PURE__*/function (_Component) {
  function EditWorkforceOfficePage(props) {
    var _this;
    _classCallCheck(this, EditWorkforceOfficePage);
    _this = _callSuper$1b(this, EditWorkforceOfficePage, [props]);
    _defineProperty(_this, "updateAttribute", function (key, value) {
      _this.setState(function (prevState) {
        return {
          stateEdited: _objectSpread$1L(_objectSpread$1L({}, prevState.stateEdited), {}, _defineProperty({}, key, value)),
          isSaved: false
        };
      });
    });
    _defineProperty(_this, "save", function () {
      var _this$props = _this.props;
        _this$props.grievanceConfig;
        var dispatch = _this$props.dispatch;
      var stateEdited = _this.state.stateEdited;
      if (!_this.state.isSameRepresentative) {
        var _stateEdited$workforc, _stateEdited$workforc2, _stateEdited$workforc3, _stateEdited$workforc4, _stateEdited$workforc5, _stateEdited$workforc6, _stateEdited$workforc7, _stateEdited$workforc8, _stateEdited$workforc9, _stateEdited$workforc10;
        var representativeData = {
          type: "organization",
          nameBn: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.repNameBn) || (stateEdited === null || stateEdited === void 0 || (_stateEdited$workforc = stateEdited.workforceRepresentative) === null || _stateEdited$workforc === void 0 ? void 0 : _stateEdited$workforc.nameBn),
          nameEn: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.repName) || (stateEdited === null || stateEdited === void 0 || (_stateEdited$workforc2 = stateEdited.workforceRepresentative) === null || _stateEdited$workforc2 === void 0 ? void 0 : _stateEdited$workforc2.nameEn),
          location: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.repLocation) || (stateEdited === null || stateEdited === void 0 || (_stateEdited$workforc3 = stateEdited.workforceRepresentative) === null || _stateEdited$workforc3 === void 0 ? void 0 : _stateEdited$workforc3.location),
          address: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.repAddress) || (stateEdited === null || stateEdited === void 0 || (_stateEdited$workforc4 = stateEdited.workforceRepresentative) === null || _stateEdited$workforc4 === void 0 ? void 0 : _stateEdited$workforc4.address),
          phoneNumber: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.repPhone) || (stateEdited === null || stateEdited === void 0 || (_stateEdited$workforc5 = stateEdited.workforceRepresentative) === null || _stateEdited$workforc5 === void 0 ? void 0 : _stateEdited$workforc5.phoneNumber),
          email: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.repEmail) || (stateEdited === null || stateEdited === void 0 || (_stateEdited$workforc6 = stateEdited.workforceRepresentative) === null || _stateEdited$workforc6 === void 0 ? void 0 : _stateEdited$workforc6.email),
          nid: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.nid) || (stateEdited === null || stateEdited === void 0 || (_stateEdited$workforc7 = stateEdited.workforceRepresentative) === null || _stateEdited$workforc7 === void 0 ? void 0 : _stateEdited$workforc7.nid),
          passportNo: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.passport) || (stateEdited === null || stateEdited === void 0 || (_stateEdited$workforc8 = stateEdited.workforceRepresentative) === null || _stateEdited$workforc8 === void 0 ? void 0 : _stateEdited$workforc8.passportNo),
          birthDate: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.birthDate) || (stateEdited === null || stateEdited === void 0 || (_stateEdited$workforc9 = stateEdited.workforceRepresentative) === null || _stateEdited$workforc9 === void 0 ? void 0 : _stateEdited$workforc9.birthDate),
          position: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.position) || (stateEdited === null || stateEdited === void 0 || (_stateEdited$workforc10 = stateEdited.workforceRepresentative) === null || _stateEdited$workforc10 === void 0 ? void 0 : _stateEdited$workforc10.position),
          id: decodeId(stateEdited.workforceRepresentative.id)
        };
        var _workforceOfficeData = {
          nameBn: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.titleBn) || stateEdited.nameBn,
          nameEn: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.title) || stateEdited.nameEn,
          phoneNumber: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.phoneNumber) || stateEdited.phoneNumber,
          email: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.email) || stateEdited.email,
          gender: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.gender) || stateEdited.gender,
          birthDate: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.birthDate) || stateEdited.birthDate,
          website: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.website) || stateEdited.website,
          address: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.address) || stateEdited.address,
          location: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.location) || stateEdited.location,
          isSameCompanyRepresentative: _this.state.isSameRepresentative ? "1" : "0",
          workforceRepresentativeId: stateEdited.workforceRepresentative.id,
          company: decodeId(stateEdited.workforceEmployer.id),
          id: stateEdited.id
        };
        dispatch(updateRepresentative(representativeData, "Update Representative ".concat(representativeData.nameEn)));
        dispatch(updateWorkforceOffice(_workforceOfficeData, "Update Workforce Office ".concat(_workforceOfficeData.nameEn)));
        console.log({
          workforceOfficeData: _workforceOfficeData
        });
      }
      var workforceOfficeData = {
        nameBn: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.titleBn) || stateEdited.nameBn,
        nameEn: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.title) || stateEdited.nameEn,
        phoneNumber: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.phoneNumber) || stateEdited.phoneNumber,
        email: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.email) || stateEdited.email,
        gender: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.gender) || stateEdited.gender,
        birthDate: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.birthDate) || stateEdited.birthDate,
        website: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.website) || stateEdited.website,
        address: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.address) || stateEdited.address,
        location: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.location) || stateEdited.location,
        isSameCompanyRepresentative: _this.state.isSameRepresentative ? "1" : "0",
        workforceRepresentativeId: stateEdited.workforceRepresentative.id,
        company: decodeId(stateEdited.workforceEmployer.id),
        id: stateEdited.id
      };
      dispatch(updateWorkforceOffice(workforceOfficeData, "Update Workforce Office ".concat(workforceOfficeData.nameEn)));
      _this.setState({
        isSaved: true
      });
    });
    _this.state = {
      stateEdited: props.workforceOffice || {},
      isSaved: false,
      isSameRepresentative: true
    };
    return _this;
  }
  _inherits(EditWorkforceOfficePage, _Component);
  return _createClass(EditWorkforceOfficePage, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.workforceOffice !== this.props.workforceOffice) {
        this.setState({
          stateEdited: this.props.workforceOffice
        });
      }
      if (prevProps.submittingMutation && !this.props.submittingMutation) {
        this.props.dispatch(journalize(this.props.mutation));
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _stateEdited$workforc11,
        _this2 = this;
      var classes = this.props.classes;
      var _this$state = this.state,
        stateEdited = _this$state.stateEdited,
        isSaved = _this$state.isSaved,
        isSameRepresentative = _this$state.isSameRepresentative;
      console.log({
        stateEdited: stateEdited
      });
      return /*#__PURE__*/React.createElement("div", {
        className: classes.page
      }, /*#__PURE__*/React.createElement(Grid, {
        container: true
      }, /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12
      }, /*#__PURE__*/React.createElement(Paper, {
        className: classes.paper
      }, /*#__PURE__*/React.createElement(Grid, {
        container: true,
        className: classes.tableTitle
      }, /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12,
        className: classes.tableTitle
      }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(FormattedMessage, {
        module: MODULE_NAME,
        id: "Workforce Office",
        values: {
          label: EMPTY_STRING
        }
      })))), /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement(Grid, {
        container: true,
        className: classes.item
      }, /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(CompanyPicker, {
        value: decodeId(stateEdited === null || stateEdited === void 0 || (_stateEdited$workforc11 = stateEdited.workforceEmployer) === null || _stateEdited$workforc11 === void 0 ? void 0 : _stateEdited$workforc11.id),
        label: /*#__PURE__*/React.createElement(FormattedMessage, {
          id: "workforce.employee.workforce_employer",
          module: "workforce"
        }),
        required: true,
        onChange: function onChange(v) {
          return _this2.updateAttribute("company", v);
        },
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(FormControlLabel, {
        control: /*#__PURE__*/React.createElement(Checkbox, {
          color: "primary",
          checked: isSameRepresentative,
          disabled: false,
          onChange: function onChange(e) {
            _this2.setState({
              isSameRepresentative: !isSameRepresentative
            });
          }
        }),
        label: /*#__PURE__*/React.createElement(FormattedMessage, {
          id: "workforce.representative.sameAsRepresentative",
          module: "workforce"
        })
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.office.name.en",
        value: stateEdited.nameEn || stateEdited.title || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("title", v);
        },
        required: true,
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.office.name.bn",
        value: stateEdited.nameBn || stateEdited.titleBn || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("titleBn", v);
        },
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.office.phone",
        value: stateEdited.phoneNumber || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("phoneNumber", v);
        },
        type: "number",
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.office.email",
        value: stateEdited.email || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("email", v);
        },
        type: "email",
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.office.website",
        value: stateEdited.website || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("website", v);
        },
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.office.address",
        value: stateEdited.address || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("address", v);
        },
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(PublishedComponent, {
        pubRef: "location.DetailedLocation",
        withNull: true,
        value: stateEdited.location || null,
        onChange: function onChange(location) {
          return _this2.updateAttribute("location", location);
        },
        readOnly: isSaved,
        required: true,
        split: true
      })), /*#__PURE__*/React.createElement(React.Fragment, null, !isSameRepresentative && /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12,
        className: classes.item
      }, /*#__PURE__*/React.createElement(WorkforceForm, {
        title: "Workforce Representative Info",
        stateEdited: stateEdited,
        isSaved: isSaved,
        updateAttribute: this.updateAttribute,
        fields: [{
          key: "repName",
          label: "workforce.representative.name.en",
          type: "text",
          required: true,
          value: stateEdited.workforceRepresentative.nameEn
        }, {
          key: "repNameBn",
          label: "workforce.representative.name.bn",
          type: "text",
          required: true,
          value: stateEdited.workforceRepresentative.nameBn
        }, {
          key: "position",
          label: "workforce.representative.position",
          type: "text",
          required: true,
          value: stateEdited.workforceRepresentative.position
        }, {
          key: "repPhone",
          label: "workforce.representative.phone",
          type: "number",
          required: true,
          value: stateEdited.workforceRepresentative.phoneNumber
        }, {
          key: "repEmail",
          label: "workforce.representative.email",
          type: "text",
          required: true,
          value: stateEdited.workforceRepresentative.email
        }, {
          key: "nid",
          label: "workforce.representative.nid",
          type: "number",
          required: true,
          value: stateEdited.workforceRepresentative.nid
        }, {
          key: "birthDate",
          label: "workforce.representative.birthDate",
          type: "date",
          required: false,
          value: stateEdited.workforceRepresentative.birthDate
        }, {
          key: "passport",
          label: "workforce.representative.passport",
          type: "text",
          required: false,
          value: stateEdited.workforceRepresentative.passportNo
        }, {
          key: "repLocation",
          label: "workforce.representative.location",
          type: "location",
          required: true,
          value: stateEdited.workforceRepresentative.location
        }, {
          key: "repAddress",
          label: "workforce.representative.address",
          type: "text",
          required: true,
          value: stateEdited.workforceRepresentative.address
        }]
      }))), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 11,
        className: classes.item
      }), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 1,
        className: classes.item
      }, /*#__PURE__*/React.createElement(IconButton, {
        variant: "contained",
        component: "label",
        color: "primary",
        onClick: this.save,
        disabled: isSaved
      }, /*#__PURE__*/React.createElement(Save, null)))), /*#__PURE__*/React.createElement(Divider, null)))));
    }
  }]);
}(Component);
var mapStateToProps$13 = function mapStateToProps(state) {
  return {
    workforceOffice: state.workforce.workforceOffice
  };
};
var EditWorkforceOfficePage$1 = connect(mapStateToProps$13)(withStyles(styles$16)(EditWorkforceOfficePage));

function ownKeys$1K(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$1K(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$1K(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1K(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper$1a(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$1a() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$1a() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$1a = function _isNativeReflectConstruct() { return !!t; })(); }
var styles$15 = function styles(theme) {
  return {
    paper: theme.paper.paper,
    tableTitle: theme.table.title,
    item: theme.paper.item,
    fullHeight: {
      height: "100%"
    }
  };
};
var AddWorkforceOfficePage = /*#__PURE__*/function (_Component) {
  function AddWorkforceOfficePage(props) {
    var _this;
    _classCallCheck(this, AddWorkforceOfficePage);
    _this = _callSuper$1a(this, AddWorkforceOfficePage, [props]);
    _defineProperty(_this, "save", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var stateEdited, dispatch, representativeId, representativeData, representativeMutation, representativeClientMutationId, _workforceOfficeData, workforceOfficeData;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            stateEdited = _this.state.stateEdited;
            dispatch = _this.props.dispatch;
            representativeId = EMPTY_STRING;
            if (_this.state.isSameRepresentative) {
              _context.next = 17;
              break;
            }
            representativeData = {
              type: "organization",
              nameBn: stateEdited.repNameBn,
              nameEn: stateEdited.repName,
              location: stateEdited.repLocation,
              address: stateEdited.repAddress,
              phoneNumber: stateEdited.repPhone,
              email: stateEdited.repEmail,
              nid: stateEdited.nid,
              passportNo: stateEdited.passport,
              birthDate: stateEdited.birthDate,
              position: stateEdited.position
            };
            _context.next = 7;
            return formatMutation("createWorkforceRepresentative", formatRepresentativeGQL(representativeData), "Created Representative ".concat(representativeData.nameEn));
          case 7:
            representativeMutation = _context.sent;
            representativeClientMutationId = representativeMutation.clientMutationId;
            _context.next = 11;
            return dispatch(createRepresentative(representativeMutation, "Created Representative ".concat(representativeData.nameEn)));
          case 11:
            _context.next = 13;
            return dispatch(fetchRepresentativeByClientMutationId(_this.props.modulesManger, representativeClientMutationId));
          case 13:
            representativeId = _this.props.representativeId[0].id;
            _workforceOfficeData = {
              company: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.company.id) || stateEdited.company.id,
              representative: stateEdited.representative,
              nameBn: stateEdited.titleBn,
              nameEn: stateEdited.title,
              phoneNumber: stateEdited.phoneNumber,
              email: stateEdited.email,
              website: stateEdited.website,
              address: stateEdited.address,
              location: stateEdited.location,
              status: WORKFORCE_STATUS$1.DRAFT,
              isSameCompanyRepresentative: _this.state.isSameRepresentative ? "1" : "0",
              workforceRepresentativeId: representativeId,
              workforceOffice: stateEdited.workforceOffice
            };
            _context.next = 17;
            return dispatch(createWorkforceOffice(_workforceOfficeData, "Created Workforce Office ".concat(_workforceOfficeData.nameEn)));
          case 17:
            workforceOfficeData = {
              company: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.company.id) || stateEdited.company.id,
              representative: stateEdited.representative,
              nameBn: stateEdited.titleBn,
              nameEn: stateEdited.title,
              phoneNumber: stateEdited.phoneNumber,
              email: stateEdited.email,
              website: stateEdited.website,
              address: stateEdited.address,
              location: stateEdited.location,
              status: WORKFORCE_STATUS$1.DRAFT,
              isSameCompanyRepresentative: _this.state.isSameRepresentative ? "1" : "0",
              workforceRepresentativeId: representativeId,
              workforceOffice: stateEdited.workforceOffice
            };
            _context.next = 20;
            return dispatch(createWorkforceOffice(workforceOfficeData, "Created Workforce Office ".concat(workforceOfficeData.nameEn)));
          case 20:
            _this.setState({
              isSaved: true
            });
          case 21:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })));
    _defineProperty(_this, "updateAttribute", function (key, value) {
      _this.setState(function (prevState) {
        return {
          stateEdited: _objectSpread$1K(_objectSpread$1K({}, prevState.stateEdited), {}, _defineProperty({}, key, value)),
          isSaved: false
        };
      });
    });
    _this.state = {
      stateEdited: {},
      isSaved: false,
      isSameRepresentative: true
    };
    return _this;
  }
  _inherits(AddWorkforceOfficePage, _Component);
  return _createClass(AddWorkforceOfficePage, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props = this.props,
        submittingMutation = _this$props.submittingMutation,
        mutation = _this$props.mutation,
        dispatch = _this$props.dispatch;
      if (!submittingMutation && prevProps.submittingMutation !== submittingMutation) {
        dispatch(journalize(mutation));
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _stateEdited$company,
        _this2 = this;
      var classes = this.props.classes;
      var _this$state = this.state,
        stateEdited = _this$state.stateEdited,
        isSaved = _this$state.isSaved,
        isSameRepresentative = _this$state.isSameRepresentative;
      console.log({
        isSameRepresentative: isSameRepresentative
      });
      return /*#__PURE__*/React.createElement("div", {
        className: classes.page
      }, /*#__PURE__*/React.createElement(Grid, {
        container: true
      }, /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12
      }, /*#__PURE__*/React.createElement(Paper, {
        className: classes.paper
      }, /*#__PURE__*/React.createElement(Grid, {
        container: true,
        className: classes.tableTitle
      }, /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12,
        className: classes.tableTitle
      }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(FormattedMessage, {
        module: MODULE_NAME,
        id: "Workforce Office",
        values: {
          label: EMPTY_STRING
        }
      })))), /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement(Grid, {
        container: true,
        className: classes.item
      }, /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(CompanyPicker, {
        value: stateEdited === null || stateEdited === void 0 || (_stateEdited$company = stateEdited.company) === null || _stateEdited$company === void 0 ? void 0 : _stateEdited$company.id,
        label: /*#__PURE__*/React.createElement(FormattedMessage, {
          id: "workforce.employee.workforce_employer",
          module: "workforce"
        }),
        required: true,
        onChange: function onChange(v) {
          return _this2.updateAttribute("company", v);
        },
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(FormControlLabel, {
        control: /*#__PURE__*/React.createElement(Checkbox, {
          color: "primary",
          checked: isSameRepresentative,
          disabled: false,
          onChange: function onChange(e) {
            _this2.setState({
              isSameRepresentative: !isSameRepresentative
            });
          }
        }),
        label: /*#__PURE__*/React.createElement(FormattedMessage, {
          id: "workforce.representative.sameAsRepresentative",
          module: "workforce"
        })
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.office.name.en",
        value: stateEdited.title || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("title", v);
        },
        required: true,
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.office.name.bn",
        value: stateEdited.titleBn || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("titleBn", v);
        },
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.office.phone",
        value: stateEdited.phoneNumber || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("phoneNumber", v);
        },
        type: "number",
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.office.email",
        value: stateEdited.email || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("email", v);
        },
        type: "email",
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.office.website",
        value: stateEdited.website || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("website", v);
        },
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.office.address",
        value: stateEdited.address || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("address", v);
        },
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12,
        className: classes.item
      }, /*#__PURE__*/React.createElement(PublishedComponent, {
        pubRef: "location.DetailedLocation",
        withNull: true,
        value: stateEdited.location || null,
        onChange: function onChange(location) {
          return _this2.updateAttribute("location", location);
        },
        readOnly: isSaved,
        required: true,
        split: true
      })), /*#__PURE__*/React.createElement(React.Fragment, null, !isSameRepresentative && /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12,
        className: classes.item
      }, /*#__PURE__*/React.createElement(WorkforceForm, {
        title: "Workforce Representative Info",
        stateEdited: stateEdited,
        isSaved: isSaved,
        updateAttribute: this.updateAttribute,
        fields: [{
          key: "repName",
          label: "workforce.representative.name.en",
          type: "text",
          required: true
        }, {
          key: "repNameBn",
          label: "workforce.representative.name.bn",
          type: "text",
          required: true
        }, {
          key: "position",
          label: "workforce.representative.position",
          type: "text",
          required: true
        }, {
          key: "repPhone",
          label: "workforce.representative.phone",
          type: "number",
          required: true
        }, {
          key: "repEmail",
          label: "workforce.representative.email",
          type: "email",
          required: true
        }, {
          key: "nid",
          label: "workforce.representative.nid",
          type: "number",
          required: true
        }, {
          key: "passport",
          label: "workforce.representative.passport",
          type: "text",
          required: false
        }, {
          key: "birthDate",
          label: "workforce.representative.birthDate",
          type: "date",
          required: false
        }, {
          key: "repLocation",
          label: "workforce.representative.location",
          type: "location",
          required: true
        }, {
          key: "repAddress",
          label: "workforce.representative.address",
          type: "text",
          required: true
        }]
      }))), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 11,
        className: classes.item
      }), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 1,
        className: classes.item
      }, /*#__PURE__*/React.createElement(IconButton, {
        variant: "contained",
        component: "label",
        color: "primary",
        onClick: this.save,
        disabled: isSaved
      }, /*#__PURE__*/React.createElement(Save, null)))), /*#__PURE__*/React.createElement(Divider, null)))));
    }
  }]);
}(Component);
var mapStateToProps$12 = function mapStateToProps(state) {
  return {
    submittingMutation: state.workforce.submittingMutation,
    representativeId: state.workforce.fetchedRepresentativeByClientMutationId,
    mutation: state.workforce.mutation
  };
};
var AddWorkforceOfficePage$1 = connect(mapStateToProps$12)(withStyles(styles$15)(AddWorkforceOfficePage));

function ownKeys$1J(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$1J(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$1J(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1J(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper$19(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$19() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$19() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$19 = function _isNativeReflectConstruct() { return !!t; })(); }
var WorkforceOfficeForm = /*#__PURE__*/function (_Component) {
  function WorkforceOfficeForm(props) {
    var _this;
    _classCallCheck(this, WorkforceOfficeForm);
    _this = _callSuper$19(this, WorkforceOfficeForm, [props]);
    _defineProperty(_this, "reload", function () {});
    _defineProperty(_this, "canSave", function () {});
    _defineProperty(_this, "_save", function (ticket) {
      _this.setState({
        lockNew: !ticket.uuid
      }, function () {
        return _this.props.save(ticket);
      });
    });
    _defineProperty(_this, "onEditedChanged", function (ticket) {
      _this.setState({
        ticket: ticket
      });
    });
    _defineProperty(_this, "reopenTicket", function () {
      var _this$props = _this.props,
        intl = _this$props.intl,
        ticket = _this$props.ticket;
      _this.props.reopenTicket(ticket.id, formatMessage(intl, MODULE_NAME, "reopenTicket.mutation.label"));
    });
    _this.state = {
      lockNew: false,
      reset: 0,
      workforceOfficeUuid: null,
      ticket: _this._newTicket()
    };
    return _this;
  }
  _inherits(WorkforceOfficeForm, _Component);
  return _createClass(WorkforceOfficeForm, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.workforceOfficeUuid) {
        this.setState(function (state, props) {
          return {
            workforceOfficeUuid: props.workforceOfficeUuid
          };
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {}
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState, snapshot) {
      if (prevProps.fetchedWorkforceOffice !== this.props.fetchedWorkforceOffice && !!this.props.fetchedWorkforceOffice && !!this.props.workforceOffice) {
        this.setState(function (state, props) {
          return {
            workforceOffice: _objectSpread$1J({}, props.workforceOffice),
            workforceOfficeUuid: props.workforceOffice.id,
            lockNew: false
          };
        });
      } else if (prevState.workforceOfficeUuid !== this.state.workforceOfficeUuid) {
        var filters = ["id: \"".concat(this.state.workforceOfficeUuid, "\"")];
        this.props.fetchWorkforceOffice(this.props.modulesManager, filters);
      } else if (prevProps.submittingMutation && !this.props.submittingMutation) {
        var _this$props2;
        this.props.journalize(this.props.mutation);
        this.setState(function (state) {
          return {
            reset: state.reset + 1
          };
        });
        if ((_this$props2 = this.props) !== null && _this$props2 !== void 0 && (_this$props2 = _this$props2.workforceOffice) !== null && _this$props2 !== void 0 && _this$props2.id) {
          this.props.fetchWorkforceOffice(this.props.modulesManager, ["id: \"".concat(this.state.workforceOfficeUuid, "\"")]);
        }
      }
    }
  }, {
    key: "_newTicket",
    value: function _newTicket() {
      return {};
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
        fetchingTicket = _this$props3.fetchingTicket,
        fetchedWorkforceOffice = _this$props3.fetchedWorkforceOffice,
        errorTicket = _this$props3.errorTicket,
        save = _this$props3.save,
        back = _this$props3.back;
      var _this$state = this.state,
        lockNew = _this$state.lockNew,
        reset = _this$state.reset,
        update = _this$state.update,
        overview = _this$state.overview,
        workforceOfficeUuid = _this$state.workforceOfficeUuid,
        ticket = _this$state.ticket;
      var readOnly = lockNew || !!ticket.validityTo || this.props.readOnly;
      [{
        doIt: this.reopenTicket,
        icon: /*#__PURE__*/React.createElement(LockOpenIcon, null),
        disabled: ticket.isHistory
      }];
      console.log({
        workforceOfficeUuid: workforceOfficeUuid
      });
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ProgressOrError, {
        progress: fetchingTicket,
        error: errorTicket
      }), (!!fetchedWorkforceOffice || !workforceOfficeUuid) && /*#__PURE__*/React.createElement(Form, {
        module: MODULE_NAME,
        edited_id: workforceOfficeUuid,
        edited: ticket,
        reset: reset,
        update: update,
        title: "Workforce Office",
        titleParams: {
          label: "Label"
        },
        back: back,
        save: save ? this._save : null,
        canSave: this.canSave,
        reload: (workforceOfficeUuid || readOnly) && this.reload,
        readOnly: readOnly,
        overview: overview,
        Panels: workforceOfficeUuid ? [EditWorkforceOfficePage$1] : [AddWorkforceOfficePage$1],
        onEditedChanged: this.onEditedChanged
      }));
    }
  }]);
}(Component); // eslint-disable-next-line no-unused-vars
var mapStateToProps$11 = function mapStateToProps(state, props) {
  return {
    rights: !!state.core && !!state.core.user && !!state.core.user.i_user ? state.core.user.i_user.rights : [],
    fetchingTicket: state.workforce.fetchingTicket,
    errorTicket: state.workforce.errorTicket,
    fetchedWorkforceOffice: state.workforce.fetchedWorkforceOffice,
    ticket: state.workforce.ticket,
    submittingMutation: state.workforce.submittingMutation,
    mutation: state.workforce.mutation,
    grievanceConfig: state.workforce.grievanceConfig
  };
};
var mapDispatchToProps$D = function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    fetchWorkforceOffice: fetchWorkforceOffice,
    journalize: journalize
  }, dispatch);
};
var WorkforceOfficeForm$1 = withModulesManager(connect(mapStateToProps$11, mapDispatchToProps$D)(WorkforceOfficeForm));

function _callSuper$18(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$18() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$18() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$18 = function _isNativeReflectConstruct() { return !!t; })(); }
var styles$14 = function styles(theme) {
  return {
    page: theme.page,
    lockedPage: theme.page.locked
  };
};
var WorkforceOfficePage = /*#__PURE__*/function (_Component) {
  function WorkforceOfficePage() {
    var _this;
    _classCallCheck(this, WorkforceOfficePage);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper$18(this, WorkforceOfficePage, [].concat(args));
    _defineProperty(_this, "add", function () {
      historyPush$1(_this.props.modulesManager, _this.props.history, "grievance.route.ticket");
    });
    _defineProperty(_this, "save", function (office) {
      if (!office.id) {
        _this.props.createWorkforceOffice(_this.props.modulesManager, office, "Create");
      } else {
        _this.props.updateWorkforceOffice(_this.props.modulesManager, office, "Update");
      }
    });
    return _this;
  }
  _inherits(WorkforceOfficePage, _Component);
  return _createClass(WorkforceOfficePage, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        classes = _this$props.classes,
        modulesManager = _this$props.modulesManager,
        history = _this$props.history,
        rights = _this$props.rights,
        workforceOfficeUuid = _this$props.workforceOfficeUuid,
        overview = _this$props.overview,
        organizationVersion = _this$props.organizationVersion;
      // const readOnly = organization?.status === TICKET_STATUSES.CLOSED || ticket?.isHistory;
      var readOnly = false;
      // if (!(rights.includes(RIGHT_ORGANIZATION_CREATE) || rights.includes(RIGHT_ORGANIZATION_EDIT))) return null;
      return /*#__PURE__*/React.createElement("div", {
        className: "".concat(null, " ").concat(classes.page)
      }, /*#__PURE__*/React.createElement(WorkforceOfficeForm$1, {
        overview: overview,
        workforceOfficeUuid: workforceOfficeUuid,
        organizationVersion: organizationVersion,
        readOnly: readOnly,
        back: function back() {
          return historyPush$1(modulesManager, history, "workforce.route.offices");
        },
        add: rights.includes(RIGHT_ORGANIZATION_CREATE) ? this.add : null,
        save: rights.includes(RIGHT_ORGANIZATION_EDIT) ? this.save : null
      }));
    }
  }]);
}(Component);
var mapStateToProps$10 = function mapStateToProps(state, props) {
  return {
    rights: !!state.core && !!state.core.user && !!state.core.user.i_user ? state.core.user.i_user.rights : [],
    workforceOfficeUuid: props.match.params.workforce_office_uuid,
    organizationVersion: props.match.params.version,
    office: state.workforce.office
  };
};
var mapDispatchToProps$C = function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    createWorkforceOffice: createWorkforceOffice,
    updateWorkforceOffice: updateWorkforceOffice
  }, dispatch);
};
var OrganizationOfficePage = withHistory(withModulesManager(connect(mapStateToProps$10, mapDispatchToProps$C)(withTheme(withStyles(styles$14)(WorkforceOfficePage)))));

var CompanyStatusPicker = function CompanyStatusPicker(_ref) {
  _ref.modulesManager;
    var _onChange = _ref.onChange,
    readOnly = _ref.readOnly,
    required = _ref.required,
    _ref$withLabel = _ref.withLabel,
    withLabel = _ref$withLabel === void 0 ? true : _ref$withLabel,
    withPlaceholder = _ref.withPlaceholder,
    value = _ref.value,
    label = _ref.label,
    placeholder = _ref.placeholder,
    filterOptions = _ref.filterOptions,
    filterSelectedOptions = _ref.filterSelectedOptions;
    _ref.multiple;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2);
    _useState2[0];
    var setSearchString = _useState2[1];
  var _useTranslations = useTranslations("workforce"),
    formatMessage = _useTranslations.formatMessage;

  // Adjust the options to match the WORKFORCE_COMPANY_STATUS format
  var WORKFORCE_COMPANY_STATUS = ["Draft", "Pending", "Approve"];

  // Find the selected option
  var selectedOption = useMemo(function () {
    return WORKFORCE_COMPANY_STATUS.includes(value) ? value : null;
  }, [value]);
  return /*#__PURE__*/React.createElement(Autocomplete, {
    multiple: false,
    required: required,
    placeholder: placeholder !== null && placeholder !== void 0 ? placeholder : "",
    label: label !== null && label !== void 0 ? label : formatMessage("workforce.organization.employee.gender"),
    withLabel: withLabel,
    withPlaceholder: withPlaceholder,
    readOnly: readOnly,
    isLoading: false // Set to false if not loading data dynamically
    ,
    options: WORKFORCE_COMPANY_STATUS,
    value: selectedOption,
    getOptionLabel: function getOptionLabel(option) {
      return option;
    } // Since options are strings, return the string directly
    ,
    onChange: function onChange(option) {
      return _onChange(option, option !== null && option !== void 0 ? option : null);
    },
    filterOptions: filterOptions,
    filterSelectedOptions: filterSelectedOptions,
    onInputChange: setSearchString
  });
};

function _callSuper$17(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$17() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$17() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$17 = function _isNativeReflectConstruct() { return !!t; })(); }
var styles$13 = function styles(theme) {
  return {
    dialogTitle: theme.dialog.title,
    dialogContent: theme.dialog.content,
    form: {
      padding: 0
    },
    item: {
      padding: theme.spacing(1)
    },
    paperDivider: theme.paper.divider
  };
};
var WORKFORCE_COMPANY_FILTER_CONTRIBUTION_KEY = "workforce.company.Filter";
var WorkforceCOmpanyFilter = /*#__PURE__*/function (_Component) {
  function WorkforceCOmpanyFilter() {
    var _this;
    _classCallCheck(this, WorkforceCOmpanyFilter);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper$17(this, WorkforceCOmpanyFilter, [].concat(args));
    _defineProperty(_this, "debouncedOnChangeFilter", _debounce(_this.props.onChangeFilters, 800));
    _defineProperty(_this, "_filterValue", function (k) {
      var filters = _this.props.filters;
      return !!filters && !!filters[k] ? filters[k].value : null;
    });
    _defineProperty(_this, "_onChangeReporter", function (k, v) {
      _this.props.onChangeFilters([{
        id: k,
        value: v,
        filter: "".concat(k, ": \"").concat(decodeId(v === null || v === void 0 ? void 0 : v.id), "\"")
      }]);
    });
    _defineProperty(_this, "_onChangeCheckbox", function (key, value) {
      var filters = [{
        id: key,
        value: value,
        filter: "".concat(key, ": ").concat(value)
      }];
      _this.props.onChangeFilters(filters);
      _this.props.setShowHistoryFilter(value);
    });
    return _this;
  }
  _inherits(WorkforceCOmpanyFilter, _Component);
  return _createClass(WorkforceCOmpanyFilter, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        classes = _this$props.classes,
        filters = _this$props.filters,
        onChangeFilters = _this$props.onChangeFilters;
      return /*#__PURE__*/React.createElement(Grid, {
        container: true,
        className: classes.form
      }, /*#__PURE__*/React.createElement(ControlledField, {
        module: MODULE_NAME,
        id: "workforce.company.name.en",
        field: /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 3,
          className: classes.item
        }, /*#__PURE__*/React.createElement(TextInput, {
          module: MODULE_NAME,
          label: "workforce.company.name.en",
          name: "nameEn",
          value: this._filterValue("nameEn"),
          onChange: function onChange(v) {
            return _this2.debouncedOnChangeFilter([{
              id: 'nameEn',
              value: v,
              filter: "nameEn_Icontains: \"".concat(v, "\"")
            }]);
          }
        }))
      }), /*#__PURE__*/React.createElement(ControlledField, {
        module: MODULE_NAME,
        id: "workforce.company.name.bn",
        field: /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 3,
          className: classes.item
        }, /*#__PURE__*/React.createElement(TextInput, {
          module: MODULE_NAME,
          label: "workforce.company.name.bn",
          name: "nameBn",
          value: this._filterValue("nameBn"),
          onChange: function onChange(v) {
            return _this2.debouncedOnChangeFilter([{
              id: 'nameBn',
              value: v,
              filter: "nameBn_Icontains: \"".concat(v, "\"")
            }]);
          }
        }))
      }), /*#__PURE__*/React.createElement(ControlledField, {
        module: MODULE_NAME,
        id: "workforce.company.phone",
        field: /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 3,
          className: classes.item
        }, /*#__PURE__*/React.createElement(TextInput, {
          module: MODULE_NAME,
          label: "workforce.company.phone",
          name: "address",
          value: this._filterValue("phoneNumber"),
          onChange: function onChange(v) {
            return _this2.debouncedOnChangeFilter([{
              id: 'phoneNumber',
              value: v,
              filter: "phoneNumber_Icontains: \"".concat(v, "\"")
            }]);
          }
        }))
      }), /*#__PURE__*/React.createElement(ControlledField, {
        module: MODULE_NAME,
        id: "workforce.company.status",
        field: /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 3,
          className: classes.item
        }, /*#__PURE__*/React.createElement(CompanyStatusPicker, {
          value: this._filterValue("status"),
          label: /*#__PURE__*/React.createElement(FormattedMessage, {
            id: "workforce.company.status",
            module: "workforce"
          }),
          onChange: function onChange(v) {
            return _this2.debouncedOnChangeFilter([{
              id: 'status',
              value: v,
              filter: "status: \"".concat(v, "\"")
            }]);
          },
          readOnly: false
        }))
      }), /*#__PURE__*/React.createElement(Contributions, {
        filters: filters,
        onChangeFilters: onChangeFilters,
        contributionKey: WORKFORCE_COMPANY_FILTER_CONTRIBUTION_KEY
      }));
    }
  }]);
}(Component);
var WorkforceCompanyFilter = withModulesManager(withTheme(withStyles(styles$13)(WorkforceCOmpanyFilter)));

function _callSuper$16(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$16() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$16() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$16 = function _isNativeReflectConstruct() { return !!t; })(); }
function ownKeys$1I(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$1I(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$1I(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1I(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

var styles$12 = function styles(theme) {
  return {
    paper: _objectSpread$1I(_objectSpread$1I({}, theme.paper.paper), {}, {
      margin: 0
    }),
    paperHeader: _objectSpread$1I(_objectSpread$1I({}, theme.paper.header), {}, {
      padding: 10
    }),
    tableTitle: theme.table.title,
    fab: theme.fab,
    button: {
      margin: theme.spacing(1)
    },
    item: {
      padding: theme.spacing(1)
    },
    horizontalButtonContainer: theme.buttonContainer.horizontal
  };
};
var WorkforceCompanySearcher = /*#__PURE__*/function (_Component) {
  function WorkforceCompanySearcher(props) {
    var _this;
    _classCallCheck(this, WorkforceCompanySearcher);
    _this = _callSuper$16(this, WorkforceCompanySearcher, [props]);
    _defineProperty(_this, "fetch", function (prms) {
      var showHistoryFilter = _this.state.showHistoryFilter;
      _this.setState({
        displayVersion: showHistoryFilter
      });
      _this.props.fetchWorkforceCompaniesSummary(_this.props.modulesManager, prms);
    });
    _defineProperty(_this, "rowIdentifier", function (r) {
      return r.uuid;
    });
    _defineProperty(_this, "isShowHistory", function () {
      return _this.state.displayVersion;
    });
    _defineProperty(_this, "filtersToQueryParams", function (state) {
      var prms = Object.keys(state.filters).filter(function (f) {
        return !!state.filters[f].filter;
      }).map(function (f) {
        return state.filters[f].filter;
      });
      prms.push("first: ".concat(state.pageSize));
      if (state.afterCursor) {
        prms.push("after: \"".concat(state.afterCursor, "\""));
      }
      if (state.beforeCursor) {
        prms.push("before: \"".concat(state.beforeCursor, "\""));
      }
      if (state.orderBy) {
        prms.push("orderBy: [\"".concat(state.orderBy, "\"]"));
      }
      return prms;
    });
    _defineProperty(_this, "headers", function () {
      return ["workforce.company.name.en", "workforce.company.name.bn", "workforce.company.phone", "workforce.company.email", "workforce.company.address", "workforce.company.website", "workforce.company.count", _this.isShowHistory() ? "workforce.version" : ""];
    });
    _defineProperty(_this, "sorts", function () {
      return [];
    });
    _defineProperty(_this, "requestApproval", function (workforceCompany) {
      _this.props.dispatch;
      console.log({
        workforceCompany: workforceCompany
      });
      var workforceCompanyData = _this.props.history.location.pathname === "/workforce/approve/companies" ? {
        id: decodeId(workforceCompany.id),
        status: WORKFORCE_STATUS$1.APPROVED
      } : {
        id: decodeId(workforceCompany.id),
        status: WORKFORCE_STATUS$1.PENDING
      };
      _this.props.updateStatusOfWorkforceCompany(workforceCompanyData, "Update Workforce Company ".concat(workforceCompany.nameEn));
      _this.setState({
        isDisable: true
      });
    });
    _defineProperty(_this, "itemFormatters", function () {
      var formatters = [function (workforcecompany) {
        return workforcecompany.nameEn;
      }, function (workforcecompany) {
        return workforcecompany.nameBn;
      }, function (workforcecompany) {
        return workforcecompany.phoneNumber;
      }, function (workforcecompany) {
        return workforcecompany.email;
      }, function (workforcecompany) {
        return workforcecompany.address;
      }, function (workforcecompany) {
        return workforcecompany.website;
      }, function (workforcecompany) {
        return workforcecompany.factoryCount;
      }, function (workforcecompany) {
        return _this.isShowHistory() ? workforcecompany === null || workforcecompany === void 0 ? void 0 : workforcecompany.version : null;
      }];
      formatters.push(function (workforcecompany) {
        return /*#__PURE__*/React.createElement("div", {
          className: _this.props.classes.horizontalButtonContainer
        }, /*#__PURE__*/React.createElement(Tooltip, {
          title: "Edit"
        }, /*#__PURE__*/React.createElement(IconButton, {
          disabled: workforcecompany === null || workforcecompany === void 0 ? void 0 : workforcecompany.isHistory,
          onClick: function onClick() {
            historyPush$1(_this.props.modulesManager, _this.props.history, _this.props.history.location.pathname === "/workforce/approve/companies" ? "workforce.route.approve.edit.companies.company" : "workforce.route.edit.companies.company", [decodeId(workforcecompany.id)], false);
          }
        }, /*#__PURE__*/React.createElement(EditIcon, null))), _this.props.history.location.pathname === "/workforce/approve/companies" ? /*#__PURE__*/React.createElement(Tooltip, {
          title: "Approve"
        }, /*#__PURE__*/React.createElement(IconButton, {
          onClick: function onClick() {
            return _this.requestApproval(workforcecompany);
          },
          disabled: workforcecompany.status === WORKFORCE_STATUS$1.APPROVED ? true : false
        }, /*#__PURE__*/React.createElement(Check, null))) : /*#__PURE__*/React.createElement(Tooltip, {
          title: "Approve"
        }, /*#__PURE__*/React.createElement(IconButton, {
          onClick: function onClick() {
            return _this.requestApproval(workforcecompany);
          },
          disabled: workforcecompany.factoryCount === 0 ? true : false
        }, /*#__PURE__*/React.createElement(Send, null))), /*#__PURE__*/React.createElement(Tooltip, {
          title: "view"
        }, /*#__PURE__*/React.createElement(IconButton, {
          disabled: workforcecompany === null || workforcecompany === void 0 ? void 0 : workforcecompany.isHistory,
          onClick: function onClick() {
            historyPush$1(_this.props.modulesManager, _this.props.history, _this.props.history.location.pathname === "/workforce/approve/companies" ? "workforce.route.approve.companies.company" : "workforce.route.companies.company", [decodeId(workforcecompany.id)], false);
          }
        }, /*#__PURE__*/React.createElement(Tab, null))));
      });
      return formatters;
    });
    _defineProperty(_this, "rowDisabled", function (selection, i) {
      return !!i.validityTo;
    });
    _defineProperty(_this, "rowLocked", function (selection, i) {
      return !!i.clientMutationId;
    });
    _this.state = {
      chfid: null,
      confirmedAction: null,
      reset: 0,
      showHistoryFilter: false,
      displayVersion: false
    };
    _this.rowsPerPageOptions = [10, 20, 50, 100];
    _this.defaultPageSize = 10;
    return _this;
  }

  // componentDidMount() {
  //   console.log("Current URL Path:", this.props.location.pathname);
  // }
  _inherits(WorkforceCompanySearcher, _Component);
  return _createClass(WorkforceCompanySearcher, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState, snapshot) {
      if (prevProps.submittingMutation && !this.props.submittingMutation) {
        this.props.journalize(this.props.mutation);
        this.setState({
          reset: prevState.reset + 1
        });
      } else if (!prevProps.confirmed && this.props.confirmed) {
        this.state.confirmedAction();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props;
        _this$props.intl;
        var workforceCompanies = _this$props.workforceCompanies,
        workforceCompaniesPageInfo = _this$props.workforceCompaniesPageInfo,
        fetchingWorkforceCompanies = _this$props.fetchingWorkforceCompanies,
        fetchedWorkforceCompanies = _this$props.fetchedWorkforceCompanies,
        errorWorkforceCompanies = _this$props.errorWorkforceCompanies,
        filterPaneContributionsKey = _this$props.filterPaneContributionsKey,
        cacheFiltersKey = _this$props.cacheFiltersKey,
        _onDoubleClick = _this$props.onDoubleClick;
      this.state.isDisable;
      workforceCompaniesPageInfo.totalCount;
      var pendingCompanies = workforceCompanies.filter(function (company) {
        return company.status === "pending";
      });
      console.log({
        pendingCompanies: pendingCompanies
      });
      var filterPane = function filterPane(_ref) {
        var filters = _ref.filters,
          onChangeFilters = _ref.onChangeFilters;
        return /*#__PURE__*/React.createElement(WorkforceCompanyFilter, {
          filters: filters,
          onChangeFilters: onChangeFilters,
          setShowHistoryFilter: function setShowHistoryFilter(showHistoryFilter) {
            return _this2.setState({
              showHistoryFilter: showHistoryFilter
            });
          }
        });
      };
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Searcher$2, {
        module: MODULE_NAME,
        cacheFiltersKey: cacheFiltersKey,
        FilterPane: filterPane,
        filterPaneContributionsKey: filterPaneContributionsKey,
        items: this.props.history.location.pathname === "/workforce/approve/companies" ? pendingCompanies : workforceCompanies,
        itemsPageInfo: workforceCompaniesPageInfo,
        fetchingItems: fetchingWorkforceCompanies,
        fetchedItems: fetchedWorkforceCompanies,
        errorItems: errorWorkforceCompanies,
        tableTitle: /*#__PURE__*/React.createElement(FormattedMessage, {
          module: MODULE_NAME,
          id: "menu.workforce.company"
        }),
        rowsPerPageOptions: this.rowsPerPageOptions,
        defaultPageSize: this.defaultPageSize,
        fetch: this.fetch,
        rowIdentifier: this.rowIdentifier,
        filtersToQueryParams: this.filtersToQueryParams,
        defaultOrderBy: "-dateCreated",
        headers: this.headers,
        itemFormatters: this.itemFormatters,
        sorts: this.sorts,
        rowDisabled: this.rowDisabled,
        rowLocked: this.rowLocked,
        onDoubleClick: function onDoubleClick(i) {
          return !i.clientMutationId && _onDoubleClick(i);
        },
        reset: this.state.reset
      }));
    }
  }]);
}(Component);
var mapStateToProps$$ = function mapStateToProps(state) {
  return {
    rights: !!state.core && !!state.core.user && !!state.core.user.i_user ? state.core.user.i_user.rights : [],
    workforceCompanies: state.workforce.workforceCompanies,
    workforceCompaniesPageInfo: state.workforce.workforceCompaniesPageInfo,
    fetchingWorkforceCompanies: state.workforce.fetchingWorkforceCompanies,
    fetchedWorkforceCompanies: state.workforce.fetchedWorkforceCompanies,
    errorWorkforceCompanies: state.workforce.errorWorkforceCompanies,
    submittingMutation: state.workforce.submittingMutation,
    mutation: state.workforce.mutation,
    confirmed: state.core.confirmed
  };
};
var mapDispatchToProps$B = function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    fetchWorkforceCompaniesSummary: fetchWorkforceCompaniesSummary,
    updateStatusOfWorkforceCompany: updateStatusOfWorkforceCompany,
    journalize: journalize,
    coreConfirm: coreConfirm
  }, dispatch);
};
var OrganizationCompanySearcher = withModulesManager(withHistory(connect(mapStateToProps$$, mapDispatchToProps$B)(withTheme(withStyles(styles$12)(WorkforceCompanySearcher)))));

function _callSuper$15(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$15() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$15() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$15 = function _isNativeReflectConstruct() { return !!t; })(); }
var styles$11 = function styles(theme) {
  return {
    page: theme.page,
    fab: theme.fab,
    ROUTE_WORKFORCE_COMPANIES_COMPANY: ROUTE_WORKFORCE_COMPANIES_COMPANY
  };
};
var OrganizationCompaniesPage = /*#__PURE__*/function (_Component) {
  function OrganizationCompaniesPage() {
    var _this;
    _classCallCheck(this, OrganizationCompaniesPage);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper$15(this, OrganizationCompaniesPage, [].concat(args));
    _defineProperty(_this, "onDoubleClick", function (company) {
      var newTab = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var routeParams = ["workforce.route.companies.company", [decodeId(company.id)]];
      if (company !== null && company !== void 0 && company.isHistory) {
        routeParams[1].push(company.version);
      }
      historyPush$1.apply(void 0, [_this.props.modulesManager, _this.props.history].concat(routeParams, [newTab]));
    });
    _defineProperty(_this, "onAdd", function () {
      var path = _this.props.history.location.pathname;
      var isApprove = path.includes("approve");
      console.log({
        isApprove: isApprove
      });
      historyPush$1(_this.props.modulesManager, _this.props.history, isApprove ? "workforce.route.approve.companies.company" : "workforce.route.companies.company");
    });
    return _this;
  }
  _inherits(OrganizationCompaniesPage, _Component);
  return _createClass(OrganizationCompaniesPage, [{
    key: "render",
    value: function render() {
      var _this$props = this.props;
        _this$props.intl;
        var classes = _this$props.classes;
        _this$props.rights;
      return /*#__PURE__*/React.createElement("div", {
        className: classes.page
      }, /*#__PURE__*/React.createElement(OrganizationCompanySearcher, {
        cacheFiltersKey: "ticketPageFiltersCache",
        onDoubleClick: this.onDoubleClick
      }), withTooltip(/*#__PURE__*/React.createElement("div", {
        className: classes.fab
      }, /*#__PURE__*/React.createElement(Fab, {
        color: "primary",
        onClick: this.onAdd
      }, /*#__PURE__*/React.createElement(AddIcon, null))), /*#__PURE__*/React.createElement(FormattedMessage, {
        module: MODULE_NAME,
        id: "workforce.company.addNewTooltip"
      })));
    }
  }]);
}(Component);
var mapStateToProps$_ = function mapStateToProps(state) {
  return {
    rights: !!state.core && !!state.core.user && !!state.core.user.i_user ? state.core.user.i_user.rights : []
  };
};
var OrganizationCompaniesPage$1 = withModulesManager(withHistory(connect(mapStateToProps$_)(withTheme(withStyles(styles$11)(OrganizationCompaniesPage)))));

function ownKeys$1H(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$1H(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$1H(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1H(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper$14(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$14() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$14() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$14 = function _isNativeReflectConstruct() { return !!t; })(); }
var styles$10 = function styles(theme) {
  return {
    paper: theme.paper.paper,
    tableTitle: theme.table.title,
    item: theme.paper.item,
    fullHeight: {
      height: "100%"
    }
  };
};
var EditWorkforceCompanyPage = /*#__PURE__*/function (_Component) {
  function EditWorkforceCompanyPage(props) {
    var _this;
    _classCallCheck(this, EditWorkforceCompanyPage);
    _this = _callSuper$14(this, EditWorkforceCompanyPage, [props]);
    _defineProperty(_this, "updateAttribute", function (key, value) {
      _this.setState(function (prevState) {
        return {
          stateEdited: _objectSpread$1H(_objectSpread$1H({}, prevState.stateEdited), {}, _defineProperty({}, key, value)),
          isSaved: false
        };
      });
    });
    _defineProperty(_this, "save", function () {
      var _stateEdited$workforc, _stateEdited$workforc2, _stateEdited$workforc3, _stateEdited$workforc4, _stateEdited$workforc5, _stateEdited$workforc6, _stateEdited$workforc7, _stateEdited$workforc8, _stateEdited$workforc9, _stateEdited$workforc10;
      var dispatch = _this.props.dispatch;
      var stateEdited = _this.state.stateEdited;
      var representativeData = {
        type: "organization",
        nameBn: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.repNameBn) || (stateEdited === null || stateEdited === void 0 || (_stateEdited$workforc = stateEdited.workforceRepresentative) === null || _stateEdited$workforc === void 0 ? void 0 : _stateEdited$workforc.nameBn),
        nameEn: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.repName) || (stateEdited === null || stateEdited === void 0 || (_stateEdited$workforc2 = stateEdited.workforceRepresentative) === null || _stateEdited$workforc2 === void 0 ? void 0 : _stateEdited$workforc2.nameEn),
        location: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.repLocation) || (stateEdited === null || stateEdited === void 0 || (_stateEdited$workforc3 = stateEdited.workforceRepresentative) === null || _stateEdited$workforc3 === void 0 ? void 0 : _stateEdited$workforc3.location),
        address: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.repAddress) || (stateEdited === null || stateEdited === void 0 || (_stateEdited$workforc4 = stateEdited.workforceRepresentative) === null || _stateEdited$workforc4 === void 0 ? void 0 : _stateEdited$workforc4.address),
        phoneNumber: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.repPhone) || (stateEdited === null || stateEdited === void 0 || (_stateEdited$workforc5 = stateEdited.workforceRepresentative) === null || _stateEdited$workforc5 === void 0 ? void 0 : _stateEdited$workforc5.phoneNumber),
        email: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.repEmail) || (stateEdited === null || stateEdited === void 0 || (_stateEdited$workforc6 = stateEdited.workforceRepresentative) === null || _stateEdited$workforc6 === void 0 ? void 0 : _stateEdited$workforc6.email),
        nid: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.nid) || (stateEdited === null || stateEdited === void 0 || (_stateEdited$workforc7 = stateEdited.workforceRepresentative) === null || _stateEdited$workforc7 === void 0 ? void 0 : _stateEdited$workforc7.nid),
        passportNo: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.passport) || (stateEdited === null || stateEdited === void 0 || (_stateEdited$workforc8 = stateEdited.workforceRepresentative) === null || _stateEdited$workforc8 === void 0 ? void 0 : _stateEdited$workforc8.passportNo),
        birthDate: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.birthDate) || (stateEdited === null || stateEdited === void 0 || (_stateEdited$workforc9 = stateEdited.workforceRepresentative) === null || _stateEdited$workforc9 === void 0 ? void 0 : _stateEdited$workforc9.birthDate),
        position: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.position) || (stateEdited === null || stateEdited === void 0 || (_stateEdited$workforc10 = stateEdited.workforceRepresentative) === null || _stateEdited$workforc10 === void 0 ? void 0 : _stateEdited$workforc10.position),
        id: decodeId(stateEdited.workforceRepresentative.id)
      };
      var workforceCompanyData = {
        nameBn: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.titleBn) || stateEdited.nameBn,
        nameEn: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.title) || stateEdited.nameEn,
        phoneNumber: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.phone) || stateEdited.phoneNumber,
        email: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.email) || stateEdited.email,
        gender: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.gender) || stateEdited.gender,
        birthDate: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.birthDate) || stateEdited.birthDate,
        birthCertificateNo: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.birthCertificateNo) || stateEdited.birthCertificateNo,
        firstJoiningDate: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.firstJoiningDate) || stateEdited.firstJoiningDate,
        passportNo: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.passportNo) || stateEdited.passportNo,
        address: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.address) || stateEdited.address,
        location: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.location) || stateEdited.location,
        associationName: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.associationName) || stateEdited.associationName,
        associationMembershipNumber: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.associationMembershipNumber) || stateEdited.associationMembershipNumber,
        establishmentName: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.establishmentName) || stateEdited.establishmentName,
        establishment_date: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.establishment_date) || stateEdited.establishment_date,
        workforceRepresentativeId: stateEdited.workforceRepresentative.id,
        id: stateEdited.id,
        employerId: stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.employerId,
        employerIdLima: stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.employerIdLima,
        licenceType: stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.licenceType,
        businessSector: stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.businessSector
      };
      dispatch(updateRepresentative(representativeData, "Update Representative ".concat(representativeData.nameEn)));
      dispatch(updateWorkforceCompany(workforceCompanyData, "Update Workforce Company ".concat(workforceCompanyData.nameEn)));
      console.log({
        workforceCompanyData: workforceCompanyData
      });
      _this.setState({
        isSaved: true
      });
    });
    _this.state = {
      stateEdited: props.workforceCompany || {},
      isSaved: false
    };
    return _this;
  }
  _inherits(EditWorkforceCompanyPage, _Component);
  return _createClass(EditWorkforceCompanyPage, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.workforceCompany !== this.props.workforceCompany) {
        this.setState({
          stateEdited: this.props.workforceCompany
        });
      }
      if (prevProps.submittingMutation && !this.props.submittingMutation) {
        this.props.dispatch(journalize(this.props.mutation));
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var classes = this.props.classes;
      var _this$state = this.state,
        stateEdited = _this$state.stateEdited,
        isSaved = _this$state.isSaved;
      var path = this.props.history.location.pathname.includes("approve");
      console.log({
        path: path
      });
      return /*#__PURE__*/React.createElement("div", {
        className: classes.page
      }, /*#__PURE__*/React.createElement(Grid, {
        container: true
      }, /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12
      }, /*#__PURE__*/React.createElement(Paper, {
        className: classes.paper
      }, /*#__PURE__*/React.createElement(Grid, {
        container: true,
        className: classes.tableTitle
      }, /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12,
        className: classes.tableTitle
      }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(FormattedMessage, {
        module: MODULE_NAME,
        id: "Organizations Company",
        values: {
          label: EMPTY_STRING
        }
      })))), /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement(Grid, {
        container: true,
        className: classes.item
      }, /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.company.employerId",
        value: stateEdited.employerId || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("employerId", v);
        },
        required: true,
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.company.employerIdLima",
        value: stateEdited.employerIdLima || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("employerIdLima", v);
        },
        required: true,
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.company.name.en",
        value: stateEdited.nameEn || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("nameEn", v);
        },
        required: true,
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.company.name.bn",
        value: stateEdited.nameBn || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("nameBn", v);
        },
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.company.phone",
        value: stateEdited.phoneNumber || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("phoneNumber", v);
        },
        type: "number",
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.company.email",
        value: stateEdited.email || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("email", v);
        },
        type: "email",
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.company.website",
        value: stateEdited.website || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("website", v);
        },
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.company.licence_type",
        value: stateEdited.licenceType || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("licenceType", v);
        },
        readOnly: isSaved,
        required: true
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.company.licence_number",
        value: stateEdited.licenceNumber || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("licenceNumber", v);
        },
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.company.business_sector",
        value: stateEdited.businessSector || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("businessSector", v);
        },
        readOnly: isSaved,
        required: true
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(PublishedComponent, {
        pubRef: "workforce.DatePicker",
        label: "workforce.company.foundation_date",
        value: stateEdited.foundationDate || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("foundationDate", v);
        },
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.company.association_name",
        value: stateEdited.associationName || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("associationName", v);
        },
        readOnly: isSaved,
        required: true
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.company.association_membership_number",
        value: stateEdited.associationMembershipNumber || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("associationMembershipNumber", v);
        },
        readOnly: isSaved,
        required: true
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.company.establishment_Name",
        value: stateEdited.establishmentName || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("establishmentName", v);
        },
        readOnly: isSaved,
        required: true
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(PublishedComponent, {
        pubRef: "workforce.DatePicker",
        label: "workforce.company.establishment_date",
        value: stateEdited.establishmentDate || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("establishmentDate", v);
        },
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.company.address",
        value: stateEdited.address || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("address", v);
        },
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12,
        className: classes.item
      }, /*#__PURE__*/React.createElement(PublishedComponent, {
        pubRef: "location.DetailedLocation",
        withNull: true,
        value: stateEdited.location || null,
        onChange: function onChange(location) {
          return _this2.updateAttribute("location", location);
        },
        readOnly: isSaved,
        required: true,
        split: true
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12,
        className: classes.item
      }, /*#__PURE__*/React.createElement(WorkforceForm, {
        title: "Workforce Representative Info",
        stateEdited: stateEdited,
        isSaved: isSaved,
        updateAttribute: this.updateAttribute,
        fields: [{
          key: "repName",
          label: "workforce.representative.name.en",
          type: "text",
          required: true,
          value: stateEdited.workforceRepresentative.nameEn
        }, {
          key: "repNameBn",
          label: "workforce.representative.name.bn",
          type: "text",
          required: true,
          value: stateEdited.workforceRepresentative.nameBn
        }, {
          key: "position",
          label: "workforce.representative.position",
          type: "text",
          required: true,
          value: stateEdited.workforceRepresentative.position
        }, {
          key: "repPhone",
          label: "workforce.representative.phone",
          type: "number",
          required: true,
          value: stateEdited.workforceRepresentative.phoneNumber
        }, {
          key: "repEmail",
          label: "workforce.representative.email",
          type: "text",
          required: true,
          value: stateEdited.workforceRepresentative.email
        }, {
          key: "nid",
          label: "workforce.representative.nid",
          type: "number",
          required: true,
          value: stateEdited.workforceRepresentative.nid
        }, {
          key: "birthDate",
          label: "workforce.representative.birthDate",
          type: "date",
          required: false,
          value: stateEdited.workforceRepresentative.birthDate
        }, {
          key: "passport",
          label: "workforce.representative.passport",
          type: "text",
          required: false,
          value: stateEdited.workforceRepresentative.passportNo
        }, {
          key: "repLocation",
          label: "workforce.representative.location",
          type: "location",
          required: true,
          value: stateEdited.workforceRepresentative.location
        }, {
          key: "repAddress",
          label: "workforce.representative.address",
          type: "text",
          required: true,
          value: stateEdited.workforceRepresentative.address
        }]
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 11,
        className: classes.item
      }), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 1,
        className: classes.item
      }, /*#__PURE__*/React.createElement(IconButton, {
        variant: "contained",
        component: "label",
        color: "primary",
        onClick: this.save,
        disabled: isSaved
      }, /*#__PURE__*/React.createElement(Save, null)))), /*#__PURE__*/React.createElement(Divider, null)))));
    }
  }]);
}(Component);
var mapStateToProps$Z = function mapStateToProps(state) {
  return {
    workforceCompany: state.workforce.workforceCompany
  };
};
var EditWorkforceCompanyPage$1 = connect(mapStateToProps$Z)(withStyles(styles$10)(EditWorkforceCompanyPage));

function ownKeys$1G(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$1G(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$1G(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1G(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper$13(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$13() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$13() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$13 = function _isNativeReflectConstruct() { return !!t; })(); }
var styles$$ = function styles(theme) {
  return {
    paper: theme.paper.paper,
    tableTitle: theme.table.title,
    item: theme.paper.item,
    fullHeight: {
      height: "100%"
    }
  };
};
var AddWorkforceCompanyPage = /*#__PURE__*/function (_Component) {
  function AddWorkforceCompanyPage(props) {
    var _this;
    _classCallCheck(this, AddWorkforceCompanyPage);
    _this = _callSuper$13(this, AddWorkforceCompanyPage, [props]);
    _defineProperty(_this, "save", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var stateEdited, dispatch, representativeData, representativeMutation, representativeClientMutationId, representativeId, workforceCompanyData;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            stateEdited = _this.state.stateEdited;
            dispatch = _this.props.dispatch;
            representativeData = {
              type: "company",
              nameBn: stateEdited.repNameBn,
              nameEn: stateEdited.repName,
              location: stateEdited.repLocation,
              address: stateEdited.repAddress,
              phoneNumber: stateEdited.repPhone,
              email: stateEdited.repEmail,
              nid: stateEdited.nid,
              passportNo: stateEdited.passport,
              birthDate: stateEdited.birthDate,
              position: stateEdited.position
            };
            _context.next = 5;
            return formatMutation("createWorkforceRepresentative", formatRepresentativeGQL(representativeData), "Created Representative ".concat(representativeData.nameEn));
          case 5:
            representativeMutation = _context.sent;
            representativeClientMutationId = representativeMutation.clientMutationId;
            console.log({
              representativeClientMutationId: representativeClientMutationId
            });
            _context.next = 10;
            return dispatch(createRepresentative(representativeMutation, "Created Representative ".concat(representativeData.nameEn)));
          case 10:
            _context.next = 12;
            return dispatch(fetchRepresentativeByClientMutationId(_this.props.modulesManger, representativeClientMutationId));
          case 12:
            representativeId = _this.props.representativeId[0].id;
            console.log({
              representativeId: representativeId
            });
            workforceCompanyData = {
              nameBn: stateEdited.titleBn,
              nameEn: stateEdited.title,
              phoneNumber: stateEdited.phoneNumber,
              email: stateEdited.email,
              website: stateEdited.website,
              address: stateEdited.address,
              location: stateEdited.location,
              establishmentDate: stateEdited.establishmentDate,
              associationName: stateEdited.associationName,
              associationMembershipNumber: stateEdited.associationMembershipNumber,
              licenceType: stateEdited.licenceType,
              licenceNumber: stateEdited.licenceNumber,
              foundationDate: stateEdited.foundationDate,
              businessSector: stateEdited.businessSector,
              establishmentName: stateEdited.establishmentName,
              status: WORKFORCE_STATUS$1.DRAFT,
              workforceRepresentativeId: representativeId,
              workforceCompany: stateEdited.workforceCompany,
              employerIdLima: stateEdited.employerIdLima
            };
            _context.next = 17;
            return dispatch(createWorkforceCompany(workforceCompanyData, "Created Workforce Company ".concat(workforceCompanyData.nameEn)));
          case 17:
            _this.setState({
              isSaved: true
            });
          case 18:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })));
    _defineProperty(_this, "updateAttribute", function (key, value) {
      _this.setState(function (prevState) {
        return {
          stateEdited: _objectSpread$1G(_objectSpread$1G({}, prevState.stateEdited), {}, _defineProperty({}, key, value)),
          isSaved: false
        };
      });
    });
    _this.state = {
      stateEdited: {},
      isSaved: false
    };
    return _this;
  }
  _inherits(AddWorkforceCompanyPage, _Component);
  return _createClass(AddWorkforceCompanyPage, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props = this.props,
        submittingMutation = _this$props.submittingMutation,
        mutation = _this$props.mutation,
        dispatch = _this$props.dispatch;
      if (!submittingMutation && prevProps.submittingMutation !== submittingMutation) {
        dispatch(journalize(mutation));
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var classes = this.props.classes;
      var _this$state = this.state,
        stateEdited = _this$state.stateEdited,
        isSaved = _this$state.isSaved;
      return /*#__PURE__*/React.createElement("div", {
        className: classes.page
      }, /*#__PURE__*/React.createElement(Grid, {
        container: true
      }, /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12
      }, /*#__PURE__*/React.createElement(Paper, {
        className: classes.paper
      }, /*#__PURE__*/React.createElement(Grid, {
        container: true,
        className: classes.tableTitle
      }, /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12,
        className: classes.tableTitle
      }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(FormattedMessage, {
        module: MODULE_NAME,
        id: "Workforce Company",
        values: {
          label: EMPTY_STRING
        }
      })))), /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement(Grid, {
        container: true,
        className: classes.item
      }, /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.company.employerIdLima",
        value: stateEdited.employerIdLima || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("employerIdLima", v);
        },
        required: true,
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.company.name.en",
        value: stateEdited.title || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("title", v);
        },
        required: true,
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.company.name.bn",
        value: stateEdited.titleBn || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("titleBn", v);
        },
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.company.phone",
        value: stateEdited.phoneNumber || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("phoneNumber", v);
        },
        type: "number",
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.company.email",
        value: stateEdited.email || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("email", v);
        },
        type: "email",
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.company.website",
        value: stateEdited.website || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("website", v);
        },
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.company.licence_type",
        value: stateEdited.licenceType || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("licenceType", v);
        },
        readOnly: isSaved,
        required: true
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.company.licence_number",
        value: stateEdited.licenceNumber || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("licenceNumber", v);
        },
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.company.business_sector",
        value: stateEdited.businessSector || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("businessSector", v);
        },
        readOnly: isSaved,
        required: true
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(PublishedComponent, {
        pubRef: "workforce.DatePicker",
        label: "workforce.company.foundation_date",
        value: stateEdited.foundationDate || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("foundationDate", v);
        },
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.company.association_name",
        value: stateEdited.associationName || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("associationName", v);
        },
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.company.association_membership_number",
        value: stateEdited.associationMembershipNumber || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("associationMembershipNumber", v);
        },
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.company.establishment_Name",
        value: stateEdited.establishmentName || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("establishmentName", v);
        },
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(PublishedComponent, {
        pubRef: "workforce.DatePicker",
        label: "workforce.company.establishment_date",
        value: stateEdited.establishmentDate || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("establishmentDate", v);
        },
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.company.address",
        value: stateEdited.address || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("address", v);
        },
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(PublishedComponent, {
        pubRef: "location.DetailedLocation",
        withNull: true,
        value: stateEdited.location || null,
        onChange: function onChange(location) {
          return _this2.updateAttribute("location", location);
        },
        readOnly: isSaved,
        required: true,
        split: true
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12,
        className: classes.item
      }, /*#__PURE__*/React.createElement(WorkforceForm, {
        title: "Workforce Representative Info",
        stateEdited: stateEdited,
        isSaved: isSaved,
        updateAttribute: this.updateAttribute,
        fields: [{
          key: "repName",
          label: "workforce.representative.name.en",
          type: "text",
          required: true
        }, {
          key: "repNameBn",
          label: "workforce.representative.name.bn",
          type: "text",
          required: true
        }, {
          key: "position",
          label: "workforce.representative.position",
          type: "text",
          required: true
        }, {
          key: "repPhone",
          label: "workforce.representative.phone",
          type: "number",
          required: true
        }, {
          key: "repEmail",
          label: "workforce.representative.email",
          type: "email",
          required: true
        }, {
          key: "nid",
          label: "workforce.representative.nid",
          type: "number",
          required: true
        }, {
          key: "passport",
          label: "workforce.representative.passport",
          type: "text",
          required: false
        }, {
          key: "birthDate",
          label: "workforce.representative.birthDate",
          type: "date",
          required: true
        }, {
          key: "repLocation",
          label: "workforce.representative.location",
          type: "location",
          required: true
        }, {
          key: "repAddress",
          label: "workforce.representative.address",
          type: "text",
          required: true
        }]
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 11,
        className: classes.item
      }), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 1,
        className: classes.item
      }, /*#__PURE__*/React.createElement(IconButton, {
        variant: "contained",
        component: "label",
        color: "primary",
        onClick: this.save,
        disabled: isSaved
      }, /*#__PURE__*/React.createElement(Save, null)))), /*#__PURE__*/React.createElement(Divider, null)))));
    }
  }]);
}(Component);
var mapStateToProps$Y = function mapStateToProps(state) {
  return {
    submittingMutation: state.workforce.submittingMutation,
    representativeId: state.workforce.fetchedRepresentativeByClientMutationId,
    mutation: state.workforce.mutation
  };
};
var AddWorkforceCompanyPage$1 = connect(mapStateToProps$Y)(withStyles(styles$$)(AddWorkforceCompanyPage));

function ownKeys$1F(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$1F(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$1F(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1F(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper$12(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$12() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$12() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$12 = function _isNativeReflectConstruct() { return !!t; })(); }
var styles$_ = function styles(theme) {
  return {
    paper: theme.paper.paper,
    tableTitle: theme.table.title,
    item: theme.paper.item,
    fullHeight: {
      height: "100%"
    }
  };
};
var ViewWorkforceCompanyPage = /*#__PURE__*/function (_Component) {
  function ViewWorkforceCompanyPage(props) {
    var _this;
    _classCallCheck(this, ViewWorkforceCompanyPage);
    _this = _callSuper$12(this, ViewWorkforceCompanyPage, [props]);
    _defineProperty(_this, "updateAttribute", function (key, value) {
      _this.setState(function (prevState) {
        return {
          stateEdited: _objectSpread$1F(_objectSpread$1F({}, prevState.stateEdited), {}, _defineProperty({}, key, value)),
          isSaved: false
        };
      });
    });
    _defineProperty(_this, "save", function () {
      var _stateEdited$workforc, _stateEdited$workforc2, _stateEdited$workforc3, _stateEdited$workforc4, _stateEdited$workforc5, _stateEdited$workforc6, _stateEdited$workforc7, _stateEdited$workforc8, _stateEdited$workforc9, _stateEdited$workforc10;
      var dispatch = _this.props.dispatch;
      var stateEdited = _this.state.stateEdited;
      var representativeData = {
        type: "organization",
        nameBn: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.repNameBn) || (stateEdited === null || stateEdited === void 0 || (_stateEdited$workforc = stateEdited.workforceRepresentative) === null || _stateEdited$workforc === void 0 ? void 0 : _stateEdited$workforc.nameBn),
        nameEn: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.repName) || (stateEdited === null || stateEdited === void 0 || (_stateEdited$workforc2 = stateEdited.workforceRepresentative) === null || _stateEdited$workforc2 === void 0 ? void 0 : _stateEdited$workforc2.nameEn),
        location: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.repLocation) || (stateEdited === null || stateEdited === void 0 || (_stateEdited$workforc3 = stateEdited.workforceRepresentative) === null || _stateEdited$workforc3 === void 0 ? void 0 : _stateEdited$workforc3.location),
        address: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.repAddress) || (stateEdited === null || stateEdited === void 0 || (_stateEdited$workforc4 = stateEdited.workforceRepresentative) === null || _stateEdited$workforc4 === void 0 ? void 0 : _stateEdited$workforc4.address),
        phoneNumber: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.repPhone) || (stateEdited === null || stateEdited === void 0 || (_stateEdited$workforc5 = stateEdited.workforceRepresentative) === null || _stateEdited$workforc5 === void 0 ? void 0 : _stateEdited$workforc5.phoneNumber),
        email: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.repEmail) || (stateEdited === null || stateEdited === void 0 || (_stateEdited$workforc6 = stateEdited.workforceRepresentative) === null || _stateEdited$workforc6 === void 0 ? void 0 : _stateEdited$workforc6.email),
        nid: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.nid) || (stateEdited === null || stateEdited === void 0 || (_stateEdited$workforc7 = stateEdited.workforceRepresentative) === null || _stateEdited$workforc7 === void 0 ? void 0 : _stateEdited$workforc7.nid),
        passportNo: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.passport) || (stateEdited === null || stateEdited === void 0 || (_stateEdited$workforc8 = stateEdited.workforceRepresentative) === null || _stateEdited$workforc8 === void 0 ? void 0 : _stateEdited$workforc8.passportNo),
        birthDate: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.birthDate) || (stateEdited === null || stateEdited === void 0 || (_stateEdited$workforc9 = stateEdited.workforceRepresentative) === null || _stateEdited$workforc9 === void 0 ? void 0 : _stateEdited$workforc9.birthDate),
        position: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.position) || (stateEdited === null || stateEdited === void 0 || (_stateEdited$workforc10 = stateEdited.workforceRepresentative) === null || _stateEdited$workforc10 === void 0 ? void 0 : _stateEdited$workforc10.position),
        id: decodeId(stateEdited.workforceRepresentative.id)
      };
      var workforceCompanyData = {
        nameBn: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.titleBn) || stateEdited.nameBn,
        nameEn: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.title) || stateEdited.nameEn,
        phoneNumber: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.phone) || stateEdited.phoneNumber,
        email: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.email) || stateEdited.email,
        gender: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.gender) || stateEdited.gender,
        birthDate: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.birthDate) || stateEdited.birthDate,
        birthCertificateNo: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.birthCertificateNo) || stateEdited.birthCertificateNo,
        firstJoiningDate: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.firstJoiningDate) || stateEdited.firstJoiningDate,
        passportNo: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.passportNo) || stateEdited.passportNo,
        address: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.address) || stateEdited.address,
        location: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.location) || stateEdited.location,
        associationName: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.associationName) || stateEdited.associationName,
        associationMembershipNumber: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.associationMembershipNumber) || stateEdited.associationMembershipNumber,
        establishmentName: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.establishmentName) || stateEdited.establishmentName,
        establishment_date: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.establishment_date) || stateEdited.establishment_date,
        workforceRepresentativeId: stateEdited.workforceRepresentative.id,
        id: stateEdited.id,
        employerId: stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.employerId,
        employerIdLima: stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.employerIdLima,
        licenceType: stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.licenceType,
        businessSector: stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.businessSector
      };
      dispatch(updateRepresentative(representativeData, "Update Representative ".concat(representativeData.nameEn)));
      dispatch(updateWorkforceCompany(workforceCompanyData, "Update Workforce Company ".concat(workforceCompanyData.nameEn)));
      console.log({
        workforceCompanyData: workforceCompanyData
      });
      _this.setState({
        isSaved: true
      });
    });
    _this.state = {
      stateEdited: props.workforceCompany || {},
      isSaved: false
    };
    return _this;
  }
  _inherits(ViewWorkforceCompanyPage, _Component);
  return _createClass(ViewWorkforceCompanyPage, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.workforceCompany !== this.props.workforceCompany) {
        this.setState({
          stateEdited: this.props.workforceCompany
        });
      }
      if (prevProps.submittingMutation && !this.props.submittingMutation) {
        this.props.dispatch(journalize(this.props.mutation));
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this,
        _stateEdited$factorie,
        _stateEdited$factorie2,
        _stateEdited$offices,
        _stateEdited$offices2;
      var classes = this.props.classes;
      var _this$state = this.state,
        stateEdited = _this$state.stateEdited,
        isSaved = _this$state.isSaved;

      // const path = this.props.history.location.pathname.includes("approve")

      console.log({
        stateEdited: stateEdited
      });
      return /*#__PURE__*/React.createElement("div", {
        className: classes.page
      }, /*#__PURE__*/React.createElement(Grid, {
        container: true
      }, /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12
      }, /*#__PURE__*/React.createElement(Paper, {
        className: classes.paper
      }, /*#__PURE__*/React.createElement(Grid, {
        container: true,
        className: classes.tableTitle
      }, /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12,
        className: classes.tableTitle
      }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(FormattedMessage, {
        module: MODULE_NAME,
        id: "Organizations Company details",
        values: {
          label: EMPTY_STRING
        }
      })))), /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement(Grid, {
        container: true,
        className: classes.item
      }, /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.company.employerId",
        value: stateEdited.employerId || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("employerId", v);
        },
        required: true,
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.company.employerIdLima",
        value: stateEdited.employerIdLima || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("employerIdLima", v);
        },
        required: true,
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.company.name.en",
        value: stateEdited.nameEn || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("nameEn", v);
        },
        required: true,
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.company.name.bn",
        value: stateEdited.nameBn || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("nameBn", v);
        },
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.company.phone",
        value: stateEdited.phoneNumber || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("phoneNumber", v);
        },
        type: "number",
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.company.email",
        value: stateEdited.email || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("email", v);
        },
        type: "email",
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.company.website",
        value: stateEdited.website || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("website", v);
        },
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.company.licence_type",
        value: stateEdited.licenceType || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("licenceType", v);
        },
        readOnly: isSaved,
        required: true
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.company.licence_number",
        value: stateEdited.licenceNumber || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("licenceNumber", v);
        },
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.company.business_sector",
        value: stateEdited.businessSector || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("businessSector", v);
        },
        readOnly: isSaved,
        required: true
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(PublishedComponent, {
        pubRef: "workforce.DatePicker",
        label: "workforce.company.foundation_date",
        value: stateEdited.foundationDate || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("foundationDate", v);
        },
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.company.association_name",
        value: stateEdited.associationName || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("associationName", v);
        },
        readOnly: isSaved,
        required: true
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.company.association_membership_number",
        value: stateEdited.associationMembershipNumber || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("associationMembershipNumber", v);
        },
        readOnly: isSaved,
        required: true
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.company.establishment_Name",
        value: stateEdited.establishmentName || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("establishmentName", v);
        },
        readOnly: isSaved,
        required: true
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(PublishedComponent, {
        pubRef: "workforce.DatePicker",
        label: "workforce.company.establishment_date",
        value: stateEdited.establishmentDate || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("establishmentDate", v);
        },
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.company.address",
        value: stateEdited.address || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("address", v);
        },
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12,
        className: classes.item
      }, /*#__PURE__*/React.createElement(PublishedComponent, {
        pubRef: "location.DetailedLocation",
        withNull: true,
        value: stateEdited.location || null,
        onChange: function onChange(location) {
          return _this2.updateAttribute("location", location);
        },
        readOnly: isSaved,
        required: true,
        split: true
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12,
        className: classes.item
      }, /*#__PURE__*/React.createElement(WorkforceForm, {
        title: "Workforce Representative Info",
        stateEdited: stateEdited,
        isSaved: isSaved,
        updateAttribute: this.updateAttribute,
        fields: [{
          key: "repName",
          label: "workforce.representative.name.en",
          type: "text",
          required: true,
          value: stateEdited.workforceRepresentative.nameEn
        }, {
          key: "repNameBn",
          label: "workforce.representative.name.bn",
          type: "text",
          required: true,
          value: stateEdited.workforceRepresentative.nameBn
        }, {
          key: "position",
          label: "workforce.representative.position",
          type: "text",
          required: true,
          value: stateEdited.workforceRepresentative.position
        }, {
          key: "repPhone",
          label: "workforce.representative.phone",
          type: "number",
          required: true,
          value: stateEdited.workforceRepresentative.phoneNumber
        }, {
          key: "repEmail",
          label: "workforce.representative.email",
          type: "text",
          required: true,
          value: stateEdited.workforceRepresentative.email
        }, {
          key: "nid",
          label: "workforce.representative.nid",
          type: "number",
          required: true,
          value: stateEdited.workforceRepresentative.nid
        }, {
          key: "birthDate",
          label: "workforce.representative.birthDate",
          type: "date",
          required: false,
          value: stateEdited.workforceRepresentative.birthDate
        }, {
          key: "passport",
          label: "workforce.representative.passport",
          type: "text",
          required: false,
          value: stateEdited.workforceRepresentative.passportNo
        }, {
          key: "repLocation",
          label: "workforce.representative.location",
          type: "location",
          required: true,
          value: stateEdited.workforceRepresentative.location
        }, {
          key: "repAddress",
          label: "workforce.representative.address",
          type: "text",
          required: true,
          value: stateEdited.workforceRepresentative.address
        }]
      })), /*#__PURE__*/React.createElement(Paper, {
        className: classes.paper
      }, /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12,
        className: classes.item
      }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement("b", null, " Factories"))), /*#__PURE__*/React.createElement(Grid, {
        container: true,
        className: classes.item
      }, (stateEdited === null || stateEdited === void 0 || (_stateEdited$factorie = stateEdited.factories) === null || _stateEdited$factorie === void 0 ? void 0 : _stateEdited$factorie.length) === 0 ? /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12,
        className: classes.item
      }, /*#__PURE__*/React.createElement(Typography, null, " No Factories available")) : stateEdited === null || stateEdited === void 0 || (_stateEdited$factorie2 = stateEdited.factories) === null || _stateEdited$factorie2 === void 0 ? void 0 : _stateEdited$factorie2.map(function (factory) {
        return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 6,
          className: classes.item
        }, /*#__PURE__*/React.createElement(TextInput, {
          label: "Factory Name En",
          value: factory.nameEn || ""
          // onChange={(v) => this.updateAttribute("nameEn", v)}
          // required
          // readOnly={isSaved}
        })), /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 6,
          className: classes.item
        }, /*#__PURE__*/React.createElement(TextInput, {
          label: "Factory Name Bn",
          value: factory.nameBn || ""
          // onChange={(v) => this.updateAttribute("nameEn", v)}
          // required
          // readOnly={isSaved}
        })), /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 6,
          className: classes.item
        }, /*#__PURE__*/React.createElement(TextInput, {
          label: "Factory Address",
          value: factory.address || ""
          // onChange={(v) => this.updateAttribute("nameEn", v)}
          // required
          // readOnly={isSaved}
        })), /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 6,
          className: classes.item
        }, /*#__PURE__*/React.createElement(TextInput, {
          label: "Factory phoneNumber",
          value: factory.phoneNumber || ""
          // onChange={(v) => this.updateAttribute("nameEn", v)}
          // required
          // readOnly={isSaved}
        })), /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 6,
          className: classes.item
        }, /*#__PURE__*/React.createElement(TextInput, {
          label: "Factory email",
          value: factory.email || ""
          // onChange={(v) => this.updateAttribute("nameEn", v)}
          // required
          // readOnly={isSaved}
        })), /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 6,
          className: classes.item
        }, /*#__PURE__*/React.createElement(TextInput, {
          label: "Factory website",
          value: factory.website || ""
          // onChange={(v) => this.updateAttribute("nameEn", v)}
          // required
          // readOnly={isSaved}
        })), /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 12,
          className: classes.item
        }, /*#__PURE__*/React.createElement(PublishedComponent, {
          pubRef: "location.DetailedLocation",
          withNull: true,
          value: factory.location || null,
          readOnly: isSaved,
          required: true,
          split: true
        })));
      }))), /*#__PURE__*/React.createElement(Paper, {
        className: classes.paper
      }, /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12,
        className: classes.item
      }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement("b", null, " Offices"))), /*#__PURE__*/React.createElement(Grid, {
        container: true,
        className: classes.item
      }, (stateEdited === null || stateEdited === void 0 || (_stateEdited$offices = stateEdited.offices) === null || _stateEdited$offices === void 0 ? void 0 : _stateEdited$offices.length) === 0 ? /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12,
        className: classes.item
      }, /*#__PURE__*/React.createElement(Typography, null, " No Offices available")) : stateEdited === null || stateEdited === void 0 || (_stateEdited$offices2 = stateEdited.offices) === null || _stateEdited$offices2 === void 0 ? void 0 : _stateEdited$offices2.map(function (office) {
        return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 6,
          className: classes.item
        }, /*#__PURE__*/React.createElement(TextInput, {
          label: "Office Name En",
          value: office.nameEn || ""
          // onChange={(v) => this.updateAttribute("nameEn", v)}
          // required
          // readOnly={isSaved}
        })), /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 6,
          className: classes.item
        }, /*#__PURE__*/React.createElement(TextInput, {
          label: "Office Name Bn",
          value: office.nameBn || ""
          // onChange={(v) => this.updateAttribute("nameEn", v)}
          // required
          // readOnly={isSaved}
        })), /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 6,
          className: classes.item
        }, /*#__PURE__*/React.createElement(TextInput, {
          label: "Office Address",
          value: office.address || ""
          // onChange={(v) => this.updateAttribute("nameEn", v)}
          // required
          // readOnly={isSaved}
        })), /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 6,
          className: classes.item
        }, /*#__PURE__*/React.createElement(TextInput, {
          label: "Office phoneNumber",
          value: office.phoneNumber || ""
          // onChange={(v) => this.updateAttribute("nameEn", v)}
          // required
          // readOnly={isSaved}
        })), /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 6,
          className: classes.item
        }, /*#__PURE__*/React.createElement(TextInput, {
          label: "Office email",
          value: office.email || ""
          // onChange={(v) => this.updateAttribute("nameEn", v)}
          // required
          // readOnly={isSaved}
        })), /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 6,
          className: classes.item
        }, /*#__PURE__*/React.createElement(TextInput, {
          label: "Office website",
          value: office.website || ""
          // onChange={(v) => this.updateAttribute("nameEn", v)}
          // required
          // readOnly={isSaved}
        })), /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 12,
          className: classes.item
        }, /*#__PURE__*/React.createElement(PublishedComponent, {
          pubRef: "location.DetailedLocation",
          withNull: true,
          value: office.location || null,
          readOnly: isSaved,
          required: true,
          split: true
        })));
      }))), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 11,
        className: classes.item
      }), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 1,
        className: classes.item
      })), /*#__PURE__*/React.createElement(Divider, null)))));
    }
  }]);
}(Component);
var mapStateToProps$X = function mapStateToProps(state) {
  return {
    workforceCompany: state.workforce.workforceCompany
  };
};
var ViewWorkforceCompanyPage$1 = connect(mapStateToProps$X)(withStyles(styles$_)(ViewWorkforceCompanyPage));

function ownKeys$1E(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$1E(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$1E(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1E(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper$11(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$11() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$11() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$11 = function _isNativeReflectConstruct() { return !!t; })(); }
var WorkforceCompanyForm = /*#__PURE__*/function (_Component) {
  function WorkforceCompanyForm(props) {
    var _this;
    _classCallCheck(this, WorkforceCompanyForm);
    _this = _callSuper$11(this, WorkforceCompanyForm, [props]);
    _defineProperty(_this, "reload", function () {});
    _defineProperty(_this, "canSave", function () {});
    _defineProperty(_this, "_save", function (ticket) {
      _this.setState({
        lockNew: !ticket.uuid
      }, function () {
        return _this.props.save(ticket);
      });
    });
    _defineProperty(_this, "onEditedChanged", function (ticket) {
      _this.setState({
        ticket: ticket
      });
    });
    _defineProperty(_this, "reopenTicket", function () {
      var _this$props = _this.props,
        intl = _this$props.intl,
        ticket = _this$props.ticket;
      _this.props.reopenTicket(ticket.id, formatMessage(intl, MODULE_NAME, "reopenTicket.mutation.label"));
    });
    _this.state = {
      lockNew: false,
      reset: 0,
      workforceCompanyUuid: null,
      ticket: _this._newTicket()
    };
    return _this;
  }
  _inherits(WorkforceCompanyForm, _Component);
  return _createClass(WorkforceCompanyForm, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.workforceCompanyUuid) {
        this.setState(function (state, props) {
          return {
            workforceCompanyUuid: props.workforceCompanyUuid
          };
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {}
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState, snapshot) {
      if (prevProps.fetchedWorkforceCompany !== this.props.fetchedWorkforceCompany && !!this.props.fetchedWorkforceCompany && !!this.props.workforceCompany) {
        this.setState(function (state, props) {
          return {
            workforceCompany: _objectSpread$1E({}, props.workforceCompany),
            workforceCompanyUuid: props.workforceCompany.id,
            lockNew: false
          };
        });
      } else if (prevState.workforceCompanyUuid !== this.state.workforceCompanyUuid) {
        var filters = ["id: \"".concat(this.state.workforceCompanyUuid, "\"")];
        if (this.props.workforceCompanyUuid && !this.props.isEdit) {
          this.props.fetchWorkforceCompanyWithFactoriesAndOffices(this.props.modulesManager, filters);
        } else {
          this.props.fetchWorkforceCompany(this.props.modulesManager, filters);
        }
      } else if (prevProps.submittingMutation && !this.props.submittingMutation) {
        var _this$props2;
        this.props.journalize(this.props.mutation);
        this.setState(function (state) {
          return {
            reset: state.reset + 1
          };
        });
        if ((_this$props2 = this.props) !== null && _this$props2 !== void 0 && (_this$props2 = _this$props2.workforceCompany) !== null && _this$props2 !== void 0 && _this$props2.id) {
          if (this.props.workforceCompanyUuid && !this.props.isEdit) {
            this.props.fetchWorkforceCompanyWithFactoriesAndOffices(this.props.modulesManager, ["id: \"".concat(this.state.workforceCompanyUuid, "\"")]);
          } else {
            this.props.fetchWorkforceCompany(this.props.modulesManager, ["id: \"".concat(this.state.workforceCompanyUuid, "\"")]);
          }
        }
      }
    }
  }, {
    key: "_newTicket",
    value: function _newTicket() {
      return {};
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
        fetchingTicket = _this$props3.fetchingTicket,
        fetchedWorkforceCompany = _this$props3.fetchedWorkforceCompany,
        errorTicket = _this$props3.errorTicket,
        save = _this$props3.save,
        back = _this$props3.back,
        isEdit = _this$props3.isEdit;
      var _this$state = this.state,
        lockNew = _this$state.lockNew,
        reset = _this$state.reset,
        update = _this$state.update,
        overview = _this$state.overview,
        workforceCompanyUuid = _this$state.workforceCompanyUuid,
        ticket = _this$state.ticket;
      var readOnly = lockNew || !!ticket.validityTo || this.props.readOnly;
      [{
        doIt: this.reopenTicket,
        icon: /*#__PURE__*/React.createElement(LockOpenIcon, null),
        disabled: ticket.isHistory
      }];
      console.log("Hello", workforceCompanyUuid && !isEdit);
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ProgressOrError, {
        progress: fetchingTicket,
        error: errorTicket
      }), (!!fetchedWorkforceCompany || !workforceCompanyUuid) && /*#__PURE__*/React.createElement(Form, {
        module: MODULE_NAME,
        edited_id: workforceCompanyUuid,
        edited: ticket,
        reset: reset,
        update: update,
        title: "Workforce Company",
        titleParams: {
          label: "Label"
        },
        back: back,
        save: save ? this._save : null,
        canSave: this.canSave,
        reload: (workforceCompanyUuid || readOnly) && this.reload,
        readOnly: readOnly,
        overview: overview,
        Panels: workforceCompanyUuid && !isEdit ? [ViewWorkforceCompanyPage$1] : workforceCompanyUuid && isEdit ? [EditWorkforceCompanyPage$1] : [AddWorkforceCompanyPage$1],
        onEditedChanged: this.onEditedChanged
      }));
    }
  }]);
}(Component); // eslint-disable-next-line no-unused-vars
var mapStateToProps$W = function mapStateToProps(state, props) {
  return {
    rights: !!state.core && !!state.core.user && !!state.core.user.i_user ? state.core.user.i_user.rights : [],
    fetchingTicket: state.workforce.fetchingTicket,
    errorTicket: state.workforce.errorTicket,
    fetchedWorkforceCompany: state.workforce.fetchedWorkforceCompany,
    ticket: state.workforce.ticket,
    submittingMutation: state.workforce.submittingMutation,
    mutation: state.workforce.mutation,
    grievanceConfig: state.workforce.grievanceConfig
  };
};
var mapDispatchToProps$A = function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    fetchWorkforceCompany: fetchWorkforceCompany,
    fetchWorkforceCompanyWithFactoriesAndOffices: fetchWorkforceCompanyWithFactoriesAndOffices,
    journalize: journalize
  }, dispatch);
};
var WorkforceCompanyForm$1 = withModulesManager(connect(mapStateToProps$W, mapDispatchToProps$A)(WorkforceCompanyForm));

function _callSuper$10(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$10() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$10() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$10 = function _isNativeReflectConstruct() { return !!t; })(); }
var styles$Z = function styles(theme) {
  return {
    page: theme.page,
    lockedPage: theme.page.locked
  };
};
var WorkforceCompanyPage = /*#__PURE__*/function (_Component) {
  function WorkforceCompanyPage() {
    var _this;
    _classCallCheck(this, WorkforceCompanyPage);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper$10(this, WorkforceCompanyPage, [].concat(args));
    _defineProperty(_this, "add", function () {
      historyPush$1(_this.props.modulesManager, _this.props.history, "grievance.route.ticket");
    });
    _defineProperty(_this, "save", function (company) {
      if (!company.id) {
        _this.props.createWorkforceCompany(_this.props.modulesManager, company, "Create");
      } else {
        _this.props.updateWorkforceCompany(_this.props.modulesManager, company, "Update");
      }
    });
    return _this;
  }
  _inherits(WorkforceCompanyPage, _Component);
  return _createClass(WorkforceCompanyPage, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        classes = _this$props.classes,
        modulesManager = _this$props.modulesManager,
        history = _this$props.history,
        rights = _this$props.rights,
        workforceCompanyUuid = _this$props.workforceCompanyUuid,
        overview = _this$props.overview,
        organizationVersion = _this$props.organizationVersion;
      // const readOnly = organization?.status === TICKET_STATUSES.CLOSED || ticket?.isHistory;
      var readOnly = false;
      var path = this.props.history.location.pathname;
      var isEdit = path.includes("edit");
      var isApprove = path.includes("approve");

      // if (!(rights.includes(RIGHT_ORGANIZATION_CREATE) || rights.includes(RIGHT_ORGANIZATION_EDIT))) return null;
      return /*#__PURE__*/React.createElement("div", {
        className: "".concat(null, " ").concat(classes.page)
      }, /*#__PURE__*/React.createElement(WorkforceCompanyForm$1, {
        overview: overview,
        workforceCompanyUuid: workforceCompanyUuid,
        organizationVersion: organizationVersion,
        readOnly: readOnly,
        back: function back() {
          return historyPush$1(modulesManager, history, isApprove ? "workforce.route.approve.companies" : "workforce.route.companies");
        },
        add: rights.includes(RIGHT_ORGANIZATION_CREATE) ? this.add : null,
        save: rights.includes(RIGHT_ORGANIZATION_EDIT) ? this.save : null,
        isEdit: isEdit
      }));
    }
  }]);
}(Component);
var mapStateToProps$V = function mapStateToProps(state, props) {
  return {
    rights: !!state.core && !!state.core.user && !!state.core.user.i_user ? state.core.user.i_user.rights : [],
    workforceCompanyUuid: props.match.params.workforce_company_uuid,
    organizationVersion: props.match.params.version,
    company: state.workforce.company
  };
};
var mapDispatchToProps$z = function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    createWorkforceCompany: createWorkforceCompany,
    updateWorkforceCompany: updateWorkforceCompany
  }, dispatch);
};
var OrganizationCompanyPage = withHistory(withModulesManager(connect(mapStateToProps$V, mapDispatchToProps$z)(withTheme(withStyles(styles$Z)(WorkforceCompanyPage)))));

function _callSuper$$(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$$() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$$() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$$ = function _isNativeReflectConstruct() { return !!t; })(); }
var styles$Y = function styles(theme) {
  return {
    dialogTitle: theme.dialog.title,
    dialogContent: theme.dialog.content,
    form: {
      padding: 0
    },
    item: {
      padding: theme.spacing(1)
    },
    paperDivider: theme.paper.divider
  };
};
var WORKFORCE_FACTORY_FILTER_CONTRIBUTION_KEY = "workforce.factory.Filter";
var WorkforceFactoryFilter = /*#__PURE__*/function (_Component) {
  function WorkforceFactoryFilter() {
    var _this;
    _classCallCheck(this, WorkforceFactoryFilter);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper$$(this, WorkforceFactoryFilter, [].concat(args));
    _defineProperty(_this, "debouncedOnChangeFilter", _debounce(_this.props.onChangeFilters, 800));
    _defineProperty(_this, "_filterValue", function (k) {
      var filters = _this.props.filters;
      return !!filters && !!filters[k] ? filters[k].value : null;
    });
    _defineProperty(_this, "_onChangeReporter", function (k, v) {
      _this.props.onChangeFilters([{
        id: k,
        value: v,
        filter: "".concat(k, ": \"").concat(decodeId(v === null || v === void 0 ? void 0 : v.id), "\"")
      }]);
    });
    _defineProperty(_this, "_onChangeCheckbox", function (key, value) {
      var filters = [{
        id: key,
        value: value,
        filter: "".concat(key, ": ").concat(value)
      }];
      _this.props.onChangeFilters(filters);
      _this.props.setShowHistoryFilter(value);
    });
    return _this;
  }
  _inherits(WorkforceFactoryFilter, _Component);
  return _createClass(WorkforceFactoryFilter, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        classes = _this$props.classes,
        filters = _this$props.filters,
        onChangeFilters = _this$props.onChangeFilters;
      return /*#__PURE__*/React.createElement(Grid, {
        container: true,
        className: classes.form
      }, /*#__PURE__*/React.createElement(ControlledField, {
        module: MODULE_NAME,
        id: "workforce.factory.name.en",
        field: /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 3,
          className: classes.item
        }, /*#__PURE__*/React.createElement(TextInput, {
          module: MODULE_NAME,
          label: "workforce.factory.name.en",
          name: "nameEn",
          value: this._filterValue("nameEn"),
          onChange: function onChange(v) {
            return _this2.debouncedOnChangeFilter([{
              id: 'nameEn',
              value: v,
              filter: "nameEn_Icontains: \"".concat(v, "\"")
            }]);
          }
        }))
      }), /*#__PURE__*/React.createElement(ControlledField, {
        module: MODULE_NAME,
        id: "workforce.factory.name.bn",
        field: /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 3,
          className: classes.item
        }, /*#__PURE__*/React.createElement(TextInput, {
          module: MODULE_NAME,
          label: "workforce.factory.name.bn",
          name: "nameBn",
          value: this._filterValue("nameBn"),
          onChange: function onChange(v) {
            return _this2.debouncedOnChangeFilter([{
              id: 'nameBn',
              value: v,
              filter: "nameBn_Icontains: \"".concat(v, "\"")
            }]);
          }
        }))
      }), /*#__PURE__*/React.createElement(ControlledField, {
        module: MODULE_NAME,
        id: "workforce.factory.phone",
        field: /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 3,
          className: classes.item
        }, /*#__PURE__*/React.createElement(TextInput, {
          module: MODULE_NAME,
          label: "workforce.factory.phone",
          name: "address",
          value: this._filterValue("phoneNumber"),
          onChange: function onChange(v) {
            return _this2.debouncedOnChangeFilter([{
              id: 'phoneNumber',
              value: v,
              filter: "phoneNumber_Icontains: \"".concat(v, "\"")
            }]);
          }
        }))
      }), /*#__PURE__*/React.createElement(ControlledField, {
        module: MODULE_NAME,
        id: "workforce.representative.phone",
        field: /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 3,
          className: classes.item
        }, /*#__PURE__*/React.createElement(TextInput, {
          module: MODULE_NAME,
          label: "workforce.representative.phone",
          name: "address",
          value: this._filterValue("workforceRepresentative.phoneNumber"),
          onChange: function onChange(v) {
            return _this2.debouncedOnChangeFilter([{
              id: 'workforceRepresentative.phoneNumber',
              value: v,
              filter: "workforceRepresentative_PhoneNumber_Icontains: \"".concat(v, "\"")
            }]);
          }
        }))
      }), /*#__PURE__*/React.createElement(ControlledField, {
        module: MODULE_NAME,
        id: "workforce.factory.status",
        field: /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 3,
          className: classes.item
        }, /*#__PURE__*/React.createElement(TextInput, {
          module: MODULE_NAME,
          label: "workforce.factory.status",
          name: "status",
          value: this._filterValue("status"),
          onChange: function onChange(v) {
            return _this2.debouncedOnChangeFilter([{
              id: 'status',
              value: v,
              filter: "status: \"".concat(v, "\"")
            }]);
          }
        }))
      }), /*#__PURE__*/React.createElement(Contributions, {
        filters: filters,
        onChangeFilters: onChangeFilters,
        contributionKey: WORKFORCE_FACTORY_FILTER_CONTRIBUTION_KEY
      }));
    }
  }]);
}(Component);
var WorkforceFactoryFilter$1 = withModulesManager(withTheme(withStyles(styles$Y)(WorkforceFactoryFilter)));

function _callSuper$_(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$_() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$_() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$_ = function _isNativeReflectConstruct() { return !!t; })(); }
function ownKeys$1D(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$1D(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$1D(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1D(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var styles$X = function styles(theme) {
  return {
    paper: _objectSpread$1D(_objectSpread$1D({}, theme.paper.paper), {}, {
      margin: 0
    }),
    paperHeader: _objectSpread$1D(_objectSpread$1D({}, theme.paper.header), {}, {
      padding: 10
    }),
    tableTitle: theme.table.title,
    fab: theme.fab,
    button: {
      margin: theme.spacing(1)
    },
    item: {
      padding: theme.spacing(1)
    }
  };
};
var WorkforceFactorySearcher = /*#__PURE__*/function (_Component) {
  function WorkforceFactorySearcher(props) {
    var _this;
    _classCallCheck(this, WorkforceFactorySearcher);
    _this = _callSuper$_(this, WorkforceFactorySearcher, [props]);
    _defineProperty(_this, "fetch", function (prms) {
      var showHistoryFilter = _this.state.showHistoryFilter;
      _this.setState({
        displayVersion: showHistoryFilter
      });
      if (_this.props.association) {
        prms.push("allAssociationIdIn: [".concat(_this.props.association, "]"));
      }
      _this.props.fetchWorkforceFactoriesSummary(_this.props.modulesManager, prms);
    });
    _defineProperty(_this, "rowIdentifier", function (r) {
      return r.uuid;
    });
    _defineProperty(_this, "isShowHistory", function () {
      return _this.state.displayVersion;
    });
    _defineProperty(_this, "filtersToQueryParams", function (state) {
      var prms = Object.keys(state.filters).filter(function (f) {
        return !!state.filters[f].filter;
      }).map(function (f) {
        return state.filters[f].filter;
      });
      prms.push("first: ".concat(state.pageSize));
      if (state.afterCursor) {
        prms.push("after: \"".concat(state.afterCursor, "\""));
      }
      if (state.beforeCursor) {
        prms.push("before: \"".concat(state.beforeCursor, "\""));
      }
      if (state.orderBy) {
        prms.push("orderBy: [\"".concat(state.orderBy, "\"]"));
      }
      return prms;
    });
    _defineProperty(_this, "headers", function () {
      return ["workforce.factory.associationType", "workforce.factory.name.en", "workforce.factory.name.bn", "workforce.factory.phone", "workforce.representative.phone", "workforce.factory.email", "workforce.factory.address", "workforce.factory.website", "workforce.factory.status", _this.isShowHistory() ? 'workforce.version' : ''];
    });
    _defineProperty(_this, "handleFactoryUserApprove", function (workforceFactory) {
      var approveFactoryUser = workforceFactory;
      approveFactoryUser.id = decodeId(workforceFactory === null || workforceFactory === void 0 ? void 0 : workforceFactory.id);
      approveFactoryUser["status"] = "active";
      console.log(workforceFactory === null || workforceFactory === void 0 ? void 0 : workforceFactory.id);
      console.log(approveFactoryUser);
      _this.props.updateWorkforceFactory(approveFactoryUser, "Update Workforce Factory ");
    });
    _defineProperty(_this, "sorts", function () {
      return [];
    });
    _defineProperty(_this, "itemFormatters", function () {
      var formatters = [function (workforcefactory) {
        return workforcefactory.associationType;
      }, function (workforcefactory) {
        return workforcefactory.nameEn;
      }, function (workforcefactory) {
        return workforcefactory.nameBn;
      }, function (workforcefactory) {
        return workforcefactory.phoneNumber;
      }, function (workforcefactory) {
        var _workforcefactory$wor;
        return (_workforcefactory$wor = workforcefactory.workforceRepresentative) === null || _workforcefactory$wor === void 0 ? void 0 : _workforcefactory$wor.phoneNumber;
      }, function (workforcefactory) {
        return workforcefactory.email;
      }, function (workforcefactory) {
        return workforcefactory.address;
      }, function (workforcefactory) {
        return workforcefactory.website;
      }, function (workforcefactory) {
        return workforcefactory.status;
      }, function (workforcefactory) {
        return _this.isShowHistory() ? workforcefactory === null || workforcefactory === void 0 ? void 0 : workforcefactory.version : null;
      }];
      formatters.push(function (workforcefactory) {
        return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Tooltip, {
          title: "View"
        }, /*#__PURE__*/React.createElement(IconButton, {
          disabled: workforcefactory === null || workforcefactory === void 0 ? void 0 : workforcefactory.isHistory,
          onClick: function onClick() {
            historyPush$1(_this.props.modulesManager, _this.props.history, 'workforce.route.factories.factory.view', [decodeId(workforcefactory.id)], false);
          }
        }, /*#__PURE__*/React.createElement(VisibilityIcon, null))), /*#__PURE__*/React.createElement(Tooltip, {
          title: "Edit"
        }, /*#__PURE__*/React.createElement(IconButton, {
          disabled: workforcefactory === null || workforcefactory === void 0 ? void 0 : workforcefactory.isHistory,
          onClick: function onClick() {
            historyPush$1(_this.props.modulesManager, _this.props.history, 'workforce.route.factories.factory', [decodeId(workforcefactory.id)], false);
          }
        }, /*#__PURE__*/React.createElement(EditIcon, null))), /*#__PURE__*/React.createElement(Tooltip, {
          title: "approve"
        }, /*#__PURE__*/React.createElement(IconButton, {
          disabled: workforcefactory === null || workforcefactory === void 0 ? void 0 : workforcefactory.isHistory,
          onClick: function onClick() {
            return _this.handleFactoryUserApprove(workforcefactory);
          }
        }, /*#__PURE__*/React.createElement(Check, null))));
      });
      return formatters;
    });
    _defineProperty(_this, "rowDisabled", function (selection, i) {
      return !!i.validityTo;
    });
    _defineProperty(_this, "rowLocked", function (selection, i) {
      return !!i.clientMutationId;
    });
    _this.state = {
      chfid: null,
      confirmedAction: null,
      reset: 0,
      showHistoryFilter: false,
      displayVersion: false
    };
    _this.rowsPerPageOptions = [10, 20, 50, 100];
    _this.defaultPageSize = 10;
    return _this;
  }
  _inherits(WorkforceFactorySearcher, _Component);
  return _createClass(WorkforceFactorySearcher, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState, snapshot) {
      if (prevProps.submittingMutation && !this.props.submittingMutation) {
        this.props.journalize(this.props.mutation);
        this.setState({
          reset: prevState.reset + 1
        });
      } else if (!prevProps.confirmed && this.props.confirmed) {
        this.state.confirmedAction();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props;
        _this$props.intl;
        var workforceFactories = _this$props.workforceFactories,
        workforceFactoriesPageInfo = _this$props.workforceFactoriesPageInfo,
        fetchingWorkforceFactories = _this$props.fetchingWorkforceFactories,
        fetchedWorkforceFactories = _this$props.fetchedWorkforceFactories,
        errorWorkforceFactories = _this$props.errorWorkforceFactories,
        filterPaneContributionsKey = _this$props.filterPaneContributionsKey,
        cacheFiltersKey = _this$props.cacheFiltersKey,
        _onDoubleClick = _this$props.onDoubleClick;
        _this$props.association;
      workforceFactoriesPageInfo.totalCount;
      var filterPane = function filterPane(_ref) {
        var filters = _ref.filters,
          onChangeFilters = _ref.onChangeFilters;
        return /*#__PURE__*/React.createElement(WorkforceFactoryFilter$1, {
          filters: filters,
          onChangeFilters: onChangeFilters,
          setShowHistoryFilter: function setShowHistoryFilter(showHistoryFilter) {
            return _this2.setState({
              showHistoryFilter: showHistoryFilter
            });
          }
        });
      };
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Searcher$2, {
        module: MODULE_NAME,
        cacheFiltersKey: cacheFiltersKey,
        FilterPane: filterPane,
        filterPaneContributionsKey: filterPaneContributionsKey,
        items: workforceFactories,
        itemsPageInfo: workforceFactoriesPageInfo,
        fetchingItems: fetchingWorkforceFactories,
        fetchedItems: fetchedWorkforceFactories,
        errorItems: errorWorkforceFactories,
        tableTitle: /*#__PURE__*/React.createElement(FormattedMessage, {
          module: MODULE_NAME,
          id: "menu.workforce.factory"
        }),
        rowsPerPageOptions: this.rowsPerPageOptions,
        defaultPageSize: this.defaultPageSize,
        fetch: this.fetch,
        rowIdentifier: this.rowIdentifier,
        filtersToQueryParams: this.filtersToQueryParams,
        defaultOrderBy: "-dateCreated",
        headers: this.headers,
        itemFormatters: this.itemFormatters,
        sorts: this.sorts,
        rowDisabled: this.rowDisabled,
        rowLocked: this.rowLocked,
        onDoubleClick: function onDoubleClick(i) {
          return !i.clientMutationId && _onDoubleClick(i);
        },
        reset: this.state.reset
      }));
    }
  }]);
}(Component);
var mapStateToProps$U = function mapStateToProps(state) {
  return {
    rights: !!state.core && !!state.core.user && !!state.core.user.i_user ? state.core.user.i_user.rights : [],
    workforceFactories: state.workforce.workforceFactories,
    workforceFactoriesPageInfo: state.workforce.workforceFactoriesPageInfo,
    fetchingWorkforceFactories: state.workforce.fetchingWorkforceFactories,
    fetchedWorkforceFactories: state.workforce.fetchedWorkforceFactories,
    errorWorkforceFactories: state.workforce.errorWorkforceFactories,
    submittingMutation: state.workforce.submittingMutation,
    mutation: state.workforce.mutation,
    confirmed: state.core.confirmed
  };
};
var mapDispatchToProps$y = function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    fetchWorkforceFactoriesSummary: fetchWorkforceFactoriesSummary,
    journalize: journalize,
    coreConfirm: coreConfirm,
    updateWorkforceFactory: updateWorkforceFactory
  }, dispatch);
};
var OrganizationFactorySearcher = withModulesManager(withHistory(connect(mapStateToProps$U, mapDispatchToProps$y)(withTheme(withStyles(styles$X)(WorkforceFactorySearcher)))));

var styles$W = function styles(theme) {
  return {
    page: theme.page,
    fab: theme.fab,
    ROUTE_WORKFORCE_FACTORIES_FACTORY: ROUTE_WORKFORCE_FACTORIES_FACTORY
  };
};
var OrganizationFactoriesPage = function OrganizationFactoriesPage(props) {
  var modulesManager = props.modulesManager,
    history = props.history;
    props.intl;
    var classes = props.classes;
    props.rights;
  var dispatch = useDispatch();
  var _useState = useState(""),
    _useState2 = _slicedToArray(_useState, 2),
    associationIds = _useState2[0],
    setAssociationIds = _useState2[1];
  // const user_type = getUserType();
  // const association= getAssociationNameByUserType(user_type);
  var _useState3 = useState(true),
    _useState4 = _slicedToArray(_useState3, 2),
    loading = _useState4[0],
    setLoading = _useState4[1];
  var reduxState = useSelector(function (state) {
    return state;
  });
  var loggedInUserId = reduxState.core.user.i_user.id;
  var loadAssociationIds = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _response$payload$dat, _response$payload;
      var filters, response, edges, associationIdsArray, associationIdsString;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            filters = [];
            filters.push("userId:" + loggedInUserId);
            _context.next = 4;
            return dispatch(fetchWorkforceAssociationUserMaps(filters));
          case 4:
            response = _context.sent;
            // .then(response => {
            edges = (_response$payload$dat = response === null || response === void 0 || (_response$payload = response.payload) === null || _response$payload === void 0 || (_response$payload = _response$payload.data) === null || _response$payload === void 0 || (_response$payload = _response$payload.workforceAssociationUserMap) === null || _response$payload === void 0 ? void 0 : _response$payload.edges) !== null && _response$payload$dat !== void 0 ? _response$payload$dat : [];
            associationIdsArray = edges.map(function (edge) {
              return safeDecodeId(edge.node.allAssociation.id);
            });
            associationIdsString = associationIdsArray.map(function (id) {
              return "\"".concat(id, "\"");
            }).join(",");
            setAssociationIds(associationIdsString);
            setLoading(false);

            // })
            // .catch(err => {
            //   console.error("Association fetch error:", err);
            // });
          case 10:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function loadAssociationIds() {
      return _ref.apply(this, arguments);
    };
  }();
  useEffect(function () {
    loadAssociationIds();
  }, [dispatch, loggedInUserId]);
  var onDoubleClick = function onDoubleClick(factory) {
    var newTab = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var routeParams = ["workforce.route.factories.factory", [decodeId(factory.id)]];
    if (factory !== null && factory !== void 0 && factory.isHistory) {
      routeParams[1].push(factory.version);
    }
    historyPush$1.apply(void 0, [modulesManager, history].concat(routeParams, [newTab]));
  };
  var onAdd = function onAdd() {
    historyPush$1(modulesManager, history, "workforce.route.factories.factory");
  };
  if (loading) {
    return /*#__PURE__*/React.createElement("div", null, "Loading...");
  }
  return /*#__PURE__*/React.createElement("div", {
    className: classes.page
  }, /*#__PURE__*/React.createElement(OrganizationFactorySearcher, {
    cacheFiltersKey: "ticketPageFiltersCache",
    onDoubleClick: onDoubleClick,
    association: associationIds
  }), withTooltip(/*#__PURE__*/React.createElement("div", {
    className: classes.fab
  }, /*#__PURE__*/React.createElement(Fab, {
    color: "primary",
    onClick: onAdd
  }, /*#__PURE__*/React.createElement(AddIcon, null))), /*#__PURE__*/React.createElement(FormattedMessage, {
    module: MODULE_NAME,
    id: "workforce.factory.addNewTooltip"
  })));
};
var mapStateToProps$T = function mapStateToProps(state) {
  return {
    rights: !!state.core && !!state.core.user && !!state.core.user.i_user ? state.core.user.i_user.rights : []
  };
};
var OrganizationFactoriesPage$1 = connect(mapStateToProps$T)(withModulesManager(withHistory(withTheme(withStyles(styles$W)(OrganizationFactoriesPage)))));

function _createForOfIteratorHelper$c(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray$c(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray$c(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray$c(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray$c(r, a) : void 0; } }
function _arrayLikeToArray$c(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys$1C(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$1C(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$1C(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1C(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var useStyles$1C = makeStyles(function (theme) {
  return {
    dropzone: {
      border: "2px dashed #005f67",
      backgroundColor: "#eefbff",
      padding: theme.spacing(0.3),
      textAlign: "center",
      cursor: "pointer",
      borderRadius: 8,
      transition: "0.3s",
      "&:hover": {
        backgroundColor: "#ddf5ff"
      }
    },
    uploadIcon: {
      color: "#005f67",
      fontSize: 25
    },
    fileList: {
      backgroundColor: "#DBEEF0",
      marginTop: theme.spacing(1),
      padding: theme.spacing(0.2)
    },
    fileItem: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      padding: theme.spacing(0.2),
      borderBottom: "1px solid #005f67",
      borderRadius: 5,
      backgroundColor: "#DBEEF0",
      marginTop: theme.spacing(0.5)
    },
    fileName: {
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
      maxWidth: "80%",
      fontSize: "0.85rem"
    },
    button: {
      marginTop: 6,
      padding: "2px 6px",
      fontSize: "0.65rem"
    },
    deleteIcon: {
      fontSize: "1rem",
      color: "black"
    },
    cropContainer: {
      width: "100%",
      height: 400,
      background: "#333"
    }
  };
});
var FileUploader = function FileUploader(_ref) {
  var fieldKey = _ref.fieldKey,
    documentId = _ref.documentId,
    onFileChange = _ref.onFileChange,
    applicationId = _ref.applicationId,
    documentType = _ref.documentType,
    documentProp = _ref.documentProp,
    uploadedBy = _ref.uploadedBy;
  var classes = useStyles$1C();
  var dispatch = useDispatch();

  // Webcam States
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    webcamOpen = _useState2[0],
    setWebcamOpen = _useState2[1];
  var webcamRef = useRef(null);

  // Cropper States
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    cropDialogOpen = _useState4[0],
    setCropDialogOpen = _useState4[1];
  var _useState5 = useState(null),
    _useState6 = _slicedToArray(_useState5, 2),
    imageToCrop = _useState6[0],
    setImageToCrop = _useState6[1];
  var _useState7 = useState(null),
    _useState8 = _slicedToArray(_useState7, 2),
    pendingFileMeta = _useState8[0],
    setPendingFileMeta = _useState8[1];
  var cropperRef = useRef(null);

  // Load Cropper CSS dynamically to avoid bundler issues
  useEffect(function () {
    var styleId = "cropperjs-styles";
    if (!document.getElementById(styleId)) {
      var link = document.createElement("link");
      link.id = styleId;
      link.rel = "stylesheet";
      link.href = "https://cdnjs.cloudflare.com/ajax/libs/cropperjs/1.5.13/cropper.min.css";
      document.head.appendChild(link);
    }
  }, []);
  var getUploadIdentity = function getUploadIdentity() {
    var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return (item === null || item === void 0 ? void 0 : item.path) || (item === null || item === void 0 ? void 0 : item.url) || (item === null || item === void 0 ? void 0 : item.name) || (item === null || item === void 0 ? void 0 : item.fieldKey) || (item === null || item === void 0 ? void 0 : item.documentId) || "";
  };
  var mergeUploadEntries = function mergeUploadEntries() {
    var existingItems = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var incomingItem = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var normalizedExisting = Array.isArray(existingItems) ? existingItems : [];
    var normalizedIncoming = incomingItem && _typeof(incomingItem) === "object" ? incomingItem : null;
    if (!normalizedIncoming) {
      return normalizedExisting;
    }
    var incomingIdentity = getUploadIdentity(normalizedIncoming);
    if (!incomingIdentity) {
      return [].concat(_toConsumableArray(normalizedExisting), [normalizedIncoming]);
    }
    var existingIndex = normalizedExisting.findIndex(function (item) {
      return getUploadIdentity(item) === incomingIdentity;
    });
    if (existingIndex >= 0) {
      var updated = _toConsumableArray(normalizedExisting);
      updated[existingIndex] = _objectSpread$1C(_objectSpread$1C({}, updated[existingIndex]), normalizedIncoming);
      return updated;
    }
    return [].concat(_toConsumableArray(normalizedExisting), [normalizedIncoming]);
  };
  var updateGlobalUploadState = useCallback(function (nextItems) {
    var normalizedItems = Array.isArray(nextItems) ? nextItems : [];
    if (uploadedBy === "dependent") {
      dispatch({
        type: "REPLACE_UPLOAD_DEPENDENT_FILE_DATA",
        payload: normalizedItems
      });
    } else if (uploadedBy === "bank") {
      dispatch({
        type: "REPLACE_UPLOAD_DEPENDENT_BANK_DATA",
        payload: normalizedItems
      });
    } else {
      dispatch({
        type: "REPLACE_UPLOAD_FILE_DATA",
        payload: normalizedItems
      });
    }
  }, [dispatch, uploadedBy]);
  var savedFiles = useSelector(function (state) {
    var _state$workforce$uplo;
    return ((_state$workforce$uplo = state.workforce.uploadedFilesByField) === null || _state$workforce$uplo === void 0 ? void 0 : _state$workforce$uplo[fieldKey]) || [];
  });
  var _useState9 = useState([]),
    _useState10 = _slicedToArray(_useState9, 2),
    files = _useState10[0],
    setFiles = _useState10[1];
  var _useState11 = useState(false),
    _useState12 = _slicedToArray(_useState11, 2),
    isUploading = _useState12[0],
    setIsUploading = _useState12[1];
  var filesRef = useRef([]);
  var globalUploadFile = useSelector(function (state) {
    return state.workforce.uploadFile || [];
  });
  var globalDependentFile = useSelector(function (state) {
    return state.workforce.uploadDependentFile || [];
  });
  var globalBankFile = useSelector(function (state) {
    return state.workforce.uploadBankFile || [];
  });
  useEffect(function () {
    var savedFilesString = JSON.stringify(savedFiles || []);
    var currentFilesString = JSON.stringify(filesRef.current || []);
    if (savedFilesString !== currentFilesString) {
      var syncedFiles = Array.isArray(savedFiles) ? savedFiles : [];
      filesRef.current = syncedFiles;
      setFiles(syncedFiles);
    }
  }, [savedFiles, fieldKey]);
  var syncFilesWithState = useCallback(function (nextFiles) {
    var normalizedFiles = Array.isArray(nextFiles) ? nextFiles : [];
    var dedupedFiles = normalizedFiles.filter(function (file, index, array) {
      var identity = (file === null || file === void 0 ? void 0 : file.path) || (file === null || file === void 0 ? void 0 : file.url) || (file === null || file === void 0 ? void 0 : file.name);
      return index === array.findIndex(function (candidate) {
        return ((candidate === null || candidate === void 0 ? void 0 : candidate.path) || (candidate === null || candidate === void 0 ? void 0 : candidate.url) || (candidate === null || candidate === void 0 ? void 0 : candidate.name)) === identity;
      });
    });
    filesRef.current = dedupedFiles;
    setFiles(dedupedFiles);
    dispatch(setUploadedFiles(fieldKey, dedupedFiles));
    return dedupedFiles;
  }, [dispatch, fieldKey]);
  var needsCropping = useCallback(function () {
    if (!documentType) return false;
    var typeStr = documentType.toLowerCase();
    var hasPhotoOrPic = typeStr.includes("photo") || typeStr.includes("picture");
    var hasBodyPart = typeStr.includes("body part");
    return hasPhotoOrPic && !hasBodyPart;
  }, [documentType]);
  var uploadFileToApi = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(file) {
      var formData, response, responseData, fileWithInfo, createDocumentData, nextUploadList;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            formData = new FormData();
            formData.append("file", file);
            formData.append("name", file.name);
            _context.prev = 3;
            _context.next = 6;
            return fetch("/api/workforce/document/upload", {
              method: "POST",
              credentials: "include",
              body: formData
            });
          case 6:
            response = _context.sent;
            if (response.ok) {
              _context.next = 10;
              break;
            }
            console.error("Upload failed for ".concat(file.name));
            return _context.abrupt("return", null);
          case 10:
            _context.next = 12;
            return response.json();
          case 12:
            responseData = _context.sent;
            fileWithInfo = {
              name: file.name,
              path: responseData.file_path,
              url: responseData.file_url,
              documentId: documentId,
              documentPropId: documentProp === null || documentProp === void 0 ? void 0 : documentProp.id
            };
            createDocumentData = {
              path: responseData.file_path,
              url: responseData.file_url,
              workforceDocumentTypeId: documentProp !== null && documentProp !== void 0 && documentProp.id ? decodeId(documentProp.id) : "",
              documentType: documentType,
              holder: "57",
              holderType: uploadedBy || "applicant",
              fieldKey: fieldKey,
              documentId: documentId
            };
            nextUploadList = mergeUploadEntries(uploadedBy === "dependent" ? globalDependentFile : uploadedBy === "bank" ? globalBankFile : globalUploadFile, _objectSpread$1C(_objectSpread$1C({}, createDocumentData), {}, {
              holderType: "applicant"
            }));
            if (uploadedBy === "dependent") {
              dispatch({
                type: "SET_UPLOAD_DEPENDENT_FILE_DATA",
                payload: _objectSpread$1C(_objectSpread$1C({}, createDocumentData), {}, {
                  holderType: "applicant"
                })
              });
            } else if (uploadedBy === "bank") {
              dispatch({
                type: "SET_UPLOAD_DEPENDENT_BANK_DATA",
                payload: _objectSpread$1C(_objectSpread$1C({}, createDocumentData), {}, {
                  holderType: "applicant"
                })
              });
            } else {
              dispatch({
                type: "SET_UPLOAD_FILE_DATA",
                payload: createDocumentData
              });
            }
            updateGlobalUploadState(nextUploadList);
            if (applicationId && uploadedBy === "factoryAdmin") {
              console.log("create document data", createDocumentData);
              dispatch(createWorkforceDocument(_objectSpread$1C(_objectSpread$1C({}, createDocumentData), {}, {
                workforceApplicationId: uploadedBy ? applicationId : safeApplicationId(applicationId)
              }), "Created workforce document "));
            }
            if (applicationId && uploadedBy !== "factoryAdmin") {
              console.log("create document data", createDocumentData);
              dispatch(createWorkforceDocument(_objectSpread$1C(_objectSpread$1C({}, createDocumentData), {}, {
                workforceApplicationId: uploadedBy ? applicationId : safeApplicationId(applicationId)
              }), "Created workforce document "));
            }
            return _context.abrupt("return", fileWithInfo);
          case 23:
            _context.prev = 23;
            _context.t0 = _context["catch"](3);
            console.error("Upload error:", _context.t0);
            return _context.abrupt("return", null);
          case 27:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[3, 23]]);
    }));
    return function uploadFileToApi(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  var onDrop = useCallback(/*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(acceptedFiles) {
      var MAX_SIZE_BYTES, validFiles, file, reader, uploadedResponses, _iterator, _step, _file, res, mergedFiles;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            if (!(isUploading || acceptedFiles.length === 0)) {
              _context2.next = 2;
              break;
            }
            return _context2.abrupt("return");
          case 2:
            MAX_SIZE_BYTES = 50 * 1024 * 1024; // 50MB
            validFiles = acceptedFiles.filter(function (file) {
              return file.size <= MAX_SIZE_BYTES;
            });
            if (!(validFiles.length === 0)) {
              _context2.next = 7;
              break;
            }
            alert("File size exceeds 50MB limit."); // Replace with your app's toast/snackbar notification if preferred
            return _context2.abrupt("return");
          case 7:
            if (!needsCropping()) {
              _context2.next = 13;
              break;
            }
            file = validFiles[0];
            reader = new FileReader();
            reader.onload = function () {
              setImageToCrop(reader.result);
              setPendingFileMeta({
                name: file.name,
                type: file.type || "image/jpeg"
              });
              setCropDialogOpen(true);
            };
            reader.readAsDataURL(file);
            return _context2.abrupt("return");
          case 13:
            setIsUploading(true);
            _context2.prev = 14;
            uploadedResponses = [];
            _iterator = _createForOfIteratorHelper$c(validFiles);
            _context2.prev = 17;
            _iterator.s();
          case 19:
            if ((_step = _iterator.n()).done) {
              _context2.next = 27;
              break;
            }
            _file = _step.value;
            _context2.next = 23;
            return uploadFileToApi(_file);
          case 23:
            res = _context2.sent;
            if (res) uploadedResponses.push(res);
          case 25:
            _context2.next = 19;
            break;
          case 27:
            _context2.next = 32;
            break;
          case 29:
            _context2.prev = 29;
            _context2.t0 = _context2["catch"](17);
            _iterator.e(_context2.t0);
          case 32:
            _context2.prev = 32;
            _iterator.f();
            return _context2.finish(32);
          case 35:
            mergedFiles = syncFilesWithState([].concat(_toConsumableArray(filesRef.current || []), uploadedResponses));
            if (onFileChange) {
              onFileChange(fieldKey, {
                files: mergedFiles,
                documentType: documentType,
                documentPropId: documentProp === null || documentProp === void 0 ? void 0 : documentProp.id,
                documentId: documentId
              });
            }
          case 37:
            _context2.prev = 37;
            setIsUploading(false);
            return _context2.finish(37);
          case 40:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[14,, 37, 40], [17, 29, 32, 35]]);
    }));
    return function (_x2) {
      return _ref3.apply(this, arguments);
    };
  }(), [isUploading, syncFilesWithState, fieldKey, onFileChange, documentType, documentProp, documentId, needsCropping]);
  var handleCropSave = function handleCropSave() {
    var imageElement = cropperRef === null || cropperRef === void 0 ? void 0 : cropperRef.current;
    var cropper = imageElement === null || imageElement === void 0 ? void 0 : imageElement.cropper;
    if (cropper) {
      setIsUploading(true);
      cropper.getCroppedCanvas().toBlob(/*#__PURE__*/function () {
        var _ref4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3(blob) {
          var croppedFile, uploadedFile, mergedFiles;
          return _regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) switch (_context3.prev = _context3.next) {
              case 0:
                if (blob) {
                  _context3.next = 4;
                  break;
                }
                console.error("Canvas is empty");
                setIsUploading(false);
                return _context3.abrupt("return");
              case 4:
                croppedFile = new File([blob], pendingFileMeta.name, {
                  type: pendingFileMeta.type
                });
                setCropDialogOpen(false);
                setImageToCrop(null);
                _context3.prev = 7;
                _context3.next = 10;
                return uploadFileToApi(croppedFile);
              case 10:
                uploadedFile = _context3.sent;
                if (uploadedFile) {
                  mergedFiles = syncFilesWithState([].concat(_toConsumableArray(filesRef.current || []), [uploadedFile]));
                  if (onFileChange) {
                    onFileChange(fieldKey, {
                      files: mergedFiles,
                      documentType: documentType,
                      documentPropId: documentProp === null || documentProp === void 0 ? void 0 : documentProp.id,
                      documentId: documentId
                    });
                  }
                }
              case 12:
                _context3.prev = 12;
                setIsUploading(false);
                return _context3.finish(12);
              case 15:
              case "end":
                return _context3.stop();
            }
          }, _callee3, null, [[7,, 12, 15]]);
        }));
        return function (_x3) {
          return _ref4.apply(this, arguments);
        };
      }(), pendingFileMeta.type, 1);
    }
  };
  var removeFile = function removeFile(fileName) {
    var fileToRemove = files.find(function (f) {
      return (f === null || f === void 0 ? void 0 : f.name) === fileName;
    });
    if (fileToRemove) {
      var identifier = (fileToRemove === null || fileToRemove === void 0 ? void 0 : fileToRemove.path) || (fileToRemove === null || fileToRemove === void 0 ? void 0 : fileToRemove.url) || (fileToRemove === null || fileToRemove === void 0 ? void 0 : fileToRemove.name) || fileName;
      var filteredFiles = (filesRef.current || []).filter(function (f) {
        return (f === null || f === void 0 ? void 0 : f.name) !== fileName;
      });
      syncFilesWithState(filteredFiles);
      var removeType = "WORKFORCE_REMOVE_UPLOAD_FILE";
      if (uploadedBy === "dependent") removeType = "WORKFORCE_REMOVE_DEPENDENT_FILE";
      if (uploadedBy === "bank") removeType = "WORKFORCE_REMOVE_BANK_FILE";
      dispatch({
        type: removeType,
        payload: identifier
      });
      var currentUploadList = uploadedBy === "dependent" ? globalDependentFile : uploadedBy === "bank" ? globalBankFile : globalUploadFile;
      var nextUploadList = (currentUploadList || []).filter(function (item) {
        return getUploadIdentity(item) !== identifier;
      });
      updateGlobalUploadState(nextUploadList);
      if (onFileChange) {
        onFileChange(fieldKey, {
          files: filteredFiles,
          documentType: documentType,
          documentPropId: documentProp === null || documentProp === void 0 ? void 0 : documentProp.id,
          documentId: documentId
        });
      }
    }
  };
  var captureAndUpload = /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
      var imageSrc, response, blob, file, uploadedFile, mergedFiles;
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            imageSrc = webcamRef.current.getScreenshot(); // Check if cropping is needed
            if (!needsCropping()) {
              _context4.next = 7;
              break;
            }
            setImageToCrop(imageSrc);
            setPendingFileMeta({
              name: "capture_".concat(Date.now(), ".jpg"),
              type: "image/jpeg"
            });
            setCropDialogOpen(true);
            setWebcamOpen(false);
            return _context4.abrupt("return");
          case 7:
            setIsUploading(true);
            _context4.prev = 8;
            _context4.next = 11;
            return fetch(imageSrc);
          case 11:
            response = _context4.sent;
            _context4.next = 14;
            return response.blob();
          case 14:
            blob = _context4.sent;
            file = new File([blob], "capture_".concat(Date.now(), ".jpg"), {
              type: "image/jpeg"
            });
            _context4.next = 18;
            return uploadFileToApi(file);
          case 18:
            uploadedFile = _context4.sent;
            if (uploadedFile) {
              mergedFiles = syncFilesWithState([].concat(_toConsumableArray(filesRef.current || []), [uploadedFile]));
              if (onFileChange) {
                onFileChange(fieldKey, {
                  files: mergedFiles,
                  documentType: documentType,
                  documentPropId: documentProp === null || documentProp === void 0 ? void 0 : documentProp.id,
                  documentId: documentId
                });
              }
            }
          case 20:
            _context4.prev = 20;
            setIsUploading(false);
            setWebcamOpen(false);
            return _context4.finish(20);
          case 24:
          case "end":
            return _context4.stop();
        }
      }, _callee4, null, [[8,, 20, 24]]);
    }));
    return function captureAndUpload() {
      return _ref5.apply(this, arguments);
    };
  }();
  var _useDropzone = useDropzone({
      onDrop: onDrop,
      multiple: false,
      onDropRejected: function onDropRejected(fileRejections) {
        var isTooLarge = fileRejections.some(function (rejection) {
          return rejection.errors.some(function (error) {
            return error.code === "file-too-large";
          });
        });
        if (isTooLarge) {
          alert("File size exceeds 50MB limit.");
        }
      },
      maxSize: 50 * 1024 * 1024,
      accept: {
        "application/pdf": [".pdf"],
        "application/msword": [".doc"],
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document": [".docx"],
        "image/png": [".png"],
        "image/jpeg": [".jpg", ".jpeg"],
        "image/gif": [".gif"]
      }
    }),
    getRootProps = _useDropzone.getRootProps,
    getInputProps = _useDropzone.getInputProps;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Paper$1, {
    className: classes.dropzone
  }, /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    style: {
      gap: "24px"
    }
  }, /*#__PURE__*/React.createElement(Box, _extends({}, !isUploading ? getRootProps() : {}, {
    display: "flex",
    alignItems: "center",
    style: {
      gap: 8,
      cursor: isUploading ? "not-allowed" : "pointer",
      opacity: isUploading ? 0.5 : 1,
      pointerEvents: isUploading ? "none" : "auto"
    }
  }), /*#__PURE__*/React.createElement("input", _extends({}, getInputProps(), {
    disabled: isUploading
  })), isUploading ? /*#__PURE__*/React.createElement(CircularProgress, {
    size: 22
  }) : /*#__PURE__*/React.createElement(CloudUploadIcon, {
    className: classes.uploadIcon
  }), /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.application.steps.upload"
  }, function (msg) {
    return /*#__PURE__*/React.createElement(Typography$1, {
      variant: "body2"
    }, msg);
  })), /*#__PURE__*/React.createElement(Box, {
    onClick: function onClick() {
      if (isUploading) return;
      if (/Mobi|Android/i.test(navigator.userAgent)) {
        document.getElementById("cameraCaptureInput").click();
      } else {
        setWebcamOpen(true);
      }
    },
    style: {
      display: "flex",
      alignItems: "center",
      gap: "8px",
      cursor: isUploading ? "not-allowed" : "pointer",
      opacity: isUploading ? 0.5 : 1
    }
  }, /*#__PURE__*/React.createElement(PhotoCameraIcon, {
    color: "action"
  }), /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.application.steps.capture"
  }, function (msg) {
    return /*#__PURE__*/React.createElement(Typography$1, {
      variant: "body2"
    }, msg);
  })), /*#__PURE__*/React.createElement("input", {
    id: "cameraCaptureInput",
    type: "file",
    accept: "image/*",
    capture: "environment",
    style: {
      display: "none"
    },
    onChange: function onChange(e) {
      if (e.target.files && e.target.files.length > 0) {
        onDrop(Array.from(e.target.files));
      }
    }
  }))), /*#__PURE__*/React.createElement(Dialog, {
    open: webcamOpen,
    onClose: function onClose() {
      return setWebcamOpen(false);
    },
    maxWidth: "sm",
    fullWidth: true
  }, /*#__PURE__*/React.createElement(DialogContent, null, /*#__PURE__*/React.createElement(Webcam, {
    audio: false,
    ref: webcamRef,
    screenshotFormat: "image/jpeg",
    style: {
      width: "100%"
    }
  })), /*#__PURE__*/React.createElement(DialogActions, null, /*#__PURE__*/React.createElement(Button$1, {
    onClick: function onClick() {
      return setWebcamOpen(false);
    },
    variant: "outlined",
    color: "error"
  }, "Cancel"), /*#__PURE__*/React.createElement(Button$1, {
    onClick: captureAndUpload,
    variant: "contained",
    color: "primary"
  }, "Capture & Upload"))), /*#__PURE__*/React.createElement(Dialog, {
    open: cropDialogOpen,
    onClose: function onClose() {
      return setCropDialogOpen(false);
    },
    maxWidth: "sm",
    fullWidth: true
  }, /*#__PURE__*/React.createElement(DialogContent, {
    style: {
      padding: 0
    }
  }, /*#__PURE__*/React.createElement(Paper$1, {
    style: {
      padding: "8px",
      backgroundColor: "#fff",
      color: "#005f67"
    }
  }, /*#__PURE__*/React.createElement(Typography$1, {
    variant: "body2",
    style: {
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.application.photo.cropmessage"
  }))), imageToCrop && /*#__PURE__*/React.createElement(Cropper, {
    src: imageToCrop,
    className: classes.cropContainer,
    ref: cropperRef,
    aspectRatio: 3 / 4,
    viewMode: 1,
    dragMode: "move",
    cropBoxResizable: false,
    cropBoxMovable: false,
    toggleDragModeOnDblclick: false,
    guides: true
  })), /*#__PURE__*/React.createElement(DialogActions, null, /*#__PURE__*/React.createElement(Button$1, {
    onClick: function onClick() {
      return setCropDialogOpen(false);
    },
    variant: "outlined",
    color: "error"
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.confirm.modal.cancel"
  })), /*#__PURE__*/React.createElement(Button$1, {
    onClick: handleCropSave,
    variant: "contained",
    color: "primary",
    disabled: isUploading
  }, isUploading ? /*#__PURE__*/React.createElement(CircularProgress, {
    size: 24
  }) : /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.application.photo.cropandupload"
  })))), files.length > 0 && /*#__PURE__*/React.createElement(Paper$1, {
    className: classes.fileList
  }, files.map(function (file, index) {
    if (!file) return null;
    return /*#__PURE__*/React.createElement(Box, {
      key: "".concat(file.name, "-").concat(index),
      className: classes.fileItem
    }, /*#__PURE__*/React.createElement(Typography$1, {
      variant: "body2",
      className: classes.fileName,
      onClick: function onClick() {
        var fileUrl = file.url || (file.file ? URL.createObjectURL(file.file) : null);
        if (fileUrl) {
          var link = document.createElement("a");
          link.href = fileUrl;
          link.download = file.name;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      },
      style: {
        cursor: "pointer",
        textDecoration: "underline",
        color: "#005f67"
      }
    }, file.name), /*#__PURE__*/React.createElement(Box, {
      display: "flex",
      alignItems: "center"
    }, /*#__PURE__*/React.createElement(IconButton$1, {
      onClick: function onClick() {
        return removeFile(file.name);
      },
      size: "small"
    }, /*#__PURE__*/React.createElement(CloseIcon, {
      color: "secondary",
      className: classes.deleteIcon
    })), /*#__PURE__*/React.createElement("input", {
      id: "additionalFileInput-".concat(fieldKey, "-").concat(index),
      type: "file",
      hidden: true,
      accept: ".pdf,.doc,.docx,.png,.jpg,.jpeg,.gif",
      onChange: function onChange(e) {
        if (e.target.files && e.target.files.length > 0) {
          onDrop(Array.from(e.target.files));
        }
      }
    })));
  })));
};

function ownKeys$1B(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$1B(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$1B(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1B(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper$Z(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$Z() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$Z() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$Z = function _isNativeReflectConstruct() { return !!t; })(); }
var styles$V = function styles(theme) {
  return {
    paper: {
      background: "linear-gradient(135deg, #f5f7fa 0%, #e9ecef 100%)",
      padding: theme.spacing(3)
    },
    tableTitle: {
      backgroundColor: "#006273",
      color: "white",
      padding: theme.spacing(3),
      borderRadius: "12px",
      marginBottom: theme.spacing(3),
      boxShadow: "0 8px 32px rgba(102, 126, 234, 0.3)"
    },
    item: theme.paper.item,
    fullHeight: {
      height: "100%"
    },
    sectionCard: {
      marginBottom: theme.spacing(3),
      boxShadow: "0 8px 32px rgba(0,0,0,0.08)",
      borderRadius: "16px",
      border: "1px solid rgba(255,255,255,0.8)",
      transition: "all 0.3s ease",
      "&:hover": {
        boxShadow: "0 12px 40px rgba(0,0,0,0.12)",
        transform: "translateY(-2px)"
      }
    },
    sectionHeader: {
      backgroundColor: "#006273",
      color: "white",
      padding: theme.spacing(2.5),
      borderRadius: "16px 16px 0 0",
      display: "flex",
      alignItems: "center"
    },
    sectionIcon: {
      marginRight: theme.spacing(1.5),
      fontSize: "1.4rem"
    },
    sectionTitle: {
      color: "white",
      fontWeight: "700",
      fontSize: "1.15rem",
      display: "flex",
      alignItems: "center"
    },
    buttonGroup: {
      display: "flex",
      gap: theme.spacing(1.5),
      justifyContent: "flex-end",
      marginTop: theme.spacing(3),
      paddingTop: theme.spacing(2),
      borderTop: "1px solid #e9ecef"
    },
    saveButton: {
      backgroundColor: "#11998e",
      color: "white",
      fontWeight: "600",
      padding: "10px 28px",
      borderRadius: "8px",
      transition: "all 0.3s ease",
      "&:hover": {
        boxShadow: "0 8px 24px rgba(17, 153, 142, 0.4)",
        transform: "translateY(-2px)"
      }
    },
    closeButton: {
      fontWeight: "600",
      padding: "10px 28px",
      borderRadius: "8px",
      border: "2px solid #667eea",
      color: "#667eea",
      transition: "all 0.3s ease",
      "&:hover": {
        backgroundColor: "rgba(102, 126, 234, 0.1)",
        transform: "translateY(-2px)"
      }
    },
    gridField: {
      marginBottom: theme.spacing(2)
    },
    cardContent: {
      padding: theme.spacing(3),
      "&:last-child": {
        paddingBottom: theme.spacing(3)
      }
    },
    divider: {
      margin: theme.spacing(3, 0),
      backgroundColor: "rgba(0,0,0,0.08)"
    }
  };
};
var EditWorkforceFactoryPage = /*#__PURE__*/function (_Component) {
  function EditWorkforceFactoryPage(props) {
    var _this;
    _classCallCheck(this, EditWorkforceFactoryPage);
    _this = _callSuper$Z(this, EditWorkforceFactoryPage, [props]);
    _defineProperty(_this, "formatKey", function (key, language) {
      var cleanKey = key.split(".").pop();
      // if (["fr", "bangla", "bd"].includes(language) && banglaLabels[cleanKey]) {
      //   return banglaLabels[cleanKey];
      // }
      return cleanKey.replace(/_/g, " ").replace(/([a-z])([A-Z])/g, "$1 $2").replace(/\b\w/g, function (c) {
        return c.toUpperCase();
      });
    });
    _defineProperty(_this, "openReuploadModal", function (document) {
      _this.setState({
        reuploadDocument: document,
        reuploadFile: null,
        reuploadOpen: true
      });
    });
    _defineProperty(_this, "closeReuploadModal", function () {
      _this.setState({
        reuploadDocument: null,
        reuploadFile: null,
        reuploadOpen: false,
        reuploadSubmitting: false
      });
    });
    _defineProperty(_this, "handleReuploadChange", /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(fieldKey, uploadData) {
        var _uploadData$files, _reuploadDocument$wor;
        var reuploadDocument, uploadedFile, payload;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              reuploadDocument = _this.state.reuploadDocument;
              uploadedFile = uploadData === null || uploadData === void 0 || (_uploadData$files = uploadData.files) === null || _uploadData$files === void 0 ? void 0 : _uploadData$files[0];
              if (!(!reuploadDocument || !(uploadedFile !== null && uploadedFile !== void 0 && uploadedFile.path) || !(uploadedFile !== null && uploadedFile !== void 0 && uploadedFile.url))) {
                _context.next = 4;
                break;
              }
              return _context.abrupt("return");
            case 4:
              payload = {
                id: safeDecodeId(reuploadDocument.id),
                path: uploadedFile.path,
                url: uploadedFile.url,
                factoryId: safeDecodeId(_this.state.stateEdited.id),
                workforceDocumentTypeId: (_reuploadDocument$wor = reuploadDocument.workforceDocumentType) !== null && _reuploadDocument$wor !== void 0 && _reuploadDocument$wor.id ? safeDecodeId(reuploadDocument.workforceDocumentType.id) : undefined,
                documentType: reuploadDocument.documentType,
                holderType: reuploadDocument.holderType || "factory",
                note: "Document reuploaded"
              };
              _context.prev = 5;
              _context.next = 8;
              return _this.props.updateWorkforceDocument(payload, "Update workforce factory document");
            case 8:
              _context.next = 10;
              return _this.fetchDocuments(_this.state.stateEdited.id);
            case 10:
              _this.closeReuploadModal();
              _context.next = 16;
              break;
            case 13:
              _context.prev = 13;
              _context.t0 = _context["catch"](5);
              console.error("Failed to update workforce document:", _context.t0);
            case 16:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[5, 13]]);
      }));
      return function (_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }());
    _defineProperty(_this, "handleReuploadChange", function (fieldKey, uploadData) {
      var _uploadData$files2;
      var uploadedFile = uploadData === null || uploadData === void 0 || (_uploadData$files2 = uploadData.files) === null || _uploadData$files2 === void 0 ? void 0 : _uploadData$files2[0];
      if (!(uploadedFile !== null && uploadedFile !== void 0 && uploadedFile.path) || !(uploadedFile !== null && uploadedFile !== void 0 && uploadedFile.url)) {
        return;
      }
      _this.setState({
        reuploadFile: uploadedFile
      });
    });
    _defineProperty(_this, "submitReupload", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var _reuploadDocument$wor2;
      var _this$state, reuploadDocument, reuploadFile, stateEdited, payload;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _this$state = _this.state, reuploadDocument = _this$state.reuploadDocument, reuploadFile = _this$state.reuploadFile, stateEdited = _this$state.stateEdited;
            if (!(!reuploadDocument || !reuploadFile)) {
              _context2.next = 3;
              break;
            }
            return _context2.abrupt("return");
          case 3:
            payload = {
              id: safeDecodeId(reuploadDocument.id),
              path: reuploadFile.path,
              url: reuploadFile.url,
              factoryId: safeDecodeId(stateEdited.id),
              workforceDocumentTypeId: (_reuploadDocument$wor2 = reuploadDocument.workforceDocumentType) !== null && _reuploadDocument$wor2 !== void 0 && _reuploadDocument$wor2.id ? safeDecodeId(reuploadDocument.workforceDocumentType.id) : undefined,
              documentType: reuploadDocument.documentType,
              holderType: reuploadDocument.holderType || "factory",
              note: "Document reuploaded"
            };
            _this.setState({
              reuploadSubmitting: true
            });
            _context2.prev = 5;
            _context2.next = 8;
            return _this.props.updateWorkforceDocument(payload, "Update workforce factory document");
          case 8:
            _context2.next = 10;
            return _this.fetchDocuments(stateEdited.id);
          case 10:
            _this.setState({
              reuploadDocument: null,
              reuploadFile: null,
              reuploadOpen: false,
              reuploadSubmitting: false
            });
            _context2.next = 17;
            break;
          case 13:
            _context2.prev = 13;
            _context2.t0 = _context2["catch"](5);
            console.error("Failed to update workforce document:", _context2.t0);
            _this.setState({
              reuploadSubmitting: false
            });
          case 17:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[5, 13]]);
    })));
    _defineProperty(_this, "fetchAssociations", function () {
      var _this$props = _this.props,
        dispatch = _this$props.dispatch;
        _this$props.modulesManager;
      _this.setState({
        fetchingAssociations: true
      });
      dispatch(fetchWorkforceAllAssociationSummary([])).then(function (response) {
        var _response$payload;
        // const associations = parseData(response.payload.data.workforceAllAssociations).edges.map(edge => edge.node);
        var associations = parseData(response === null || response === void 0 || (_response$payload = response.payload) === null || _response$payload === void 0 || (_response$payload = _response$payload.data) === null || _response$payload === void 0 ? void 0 : _response$payload.workforceAllAssociation);
        console.log({
          associations: associations
        });
        _this.setState({
          associations: _toConsumableArray(associations),
          fetchingAssociations: false
        });
      })["catch"](function (error) {
        console.error("Error fetching associations:", error);
        _this.setState({
          fetchingAssociations: false
        });
      });
    });
    _defineProperty(_this, "fetchDocuments", function (factoryId) {
      var _this$props2 = _this.props,
        dispatch = _this$props2.dispatch,
        modulesManager = _this$props2.modulesManager;
      _this.setState({
        fetchingDocuments: true
      });
      dispatch(fetchWorkforceDocument(modulesManager, ["holderType: \"factory\"", "workforceFactoryId: \"".concat(factoryId, "\"")])).then(function (response) {
        // const docs = response.payload.data.workforceDocuments.edges.map(edge => edge.node);
        var docs = parseData(response.payload.data.workforceDocuments);
        console.log({
          docs: docs
        });
        _this.setState({
          documents: docs,
          fetchingDocuments: false
        });
        // } else {
        //   this.setState({ fetchingDocuments: false });
        // }
      })["catch"](function (error) {
        console.error("Error fetching documents:", error);
        _this.setState({
          fetchingDocuments: false
        });
      });
    });
    _defineProperty(_this, "handleDownloadDocument", function (doc) {
      if (doc !== null && doc !== void 0 && doc.url) {
        var fileUrl = window.location.origin + doc.url;
        window.open(fileUrl, "_blank");
      }
    });
    _defineProperty(_this, "updateAttribute", function (key, value) {
      _this.setState(function (prevState) {
        return {
          stateEdited: _objectSpread$1B(_objectSpread$1B({}, prevState.stateEdited), {}, _defineProperty({}, key, value)),
          isSaved: false
        };
      });
    });
    _defineProperty(_this, "updateNestedAttribute", function (parentKey, childKey, value) {
      _this.setState(function (prevState) {
        return {
          stateEdited: _objectSpread$1B(_objectSpread$1B({}, prevState.stateEdited), {}, _defineProperty({}, parentKey, _objectSpread$1B(_objectSpread$1B({}, prevState.stateEdited[parentKey]), {}, _defineProperty({}, childKey, value)))),
          isSaved: false
        };
      });
    });
    _defineProperty(_this, "save", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      var _stateEdited$workforc, _stateEdited$workforc12, _stateEdited$workforc13;
      var stateEdited, dispatch, _stateEdited$workforc2, _stateEdited$workforc3, _stateEdited$workforc4, _stateEdited$workforc5, _stateEdited$workforc6, _stateEdited$workforc7, _stateEdited$workforc8, _stateEdited$workforc9, _stateEdited$workforc10, _stateEdited$workforc11, representativeData, workforceFactoryData;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            stateEdited = _this.state.stateEdited;
            dispatch = _this.props.dispatch; // Update representative if needed
            if ((_stateEdited$workforc = stateEdited.workforceRepresentative) !== null && _stateEdited$workforc !== void 0 && _stateEdited$workforc.id) {
              representativeData = {
                type: "organization",
                nameBn: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.repNameBn) || (stateEdited === null || stateEdited === void 0 || (_stateEdited$workforc2 = stateEdited.workforceRepresentative) === null || _stateEdited$workforc2 === void 0 ? void 0 : _stateEdited$workforc2.nameBn),
                nameEn: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.repName) || (stateEdited === null || stateEdited === void 0 || (_stateEdited$workforc3 = stateEdited.workforceRepresentative) === null || _stateEdited$workforc3 === void 0 ? void 0 : _stateEdited$workforc3.nameEn),
                location: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.repLocation) || (stateEdited === null || stateEdited === void 0 || (_stateEdited$workforc4 = stateEdited.workforceRepresentative) === null || _stateEdited$workforc4 === void 0 ? void 0 : _stateEdited$workforc4.location),
                address: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.repAddress) || (stateEdited === null || stateEdited === void 0 || (_stateEdited$workforc5 = stateEdited.workforceRepresentative) === null || _stateEdited$workforc5 === void 0 ? void 0 : _stateEdited$workforc5.address),
                phoneNumber: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.repPhone) || (stateEdited === null || stateEdited === void 0 || (_stateEdited$workforc6 = stateEdited.workforceRepresentative) === null || _stateEdited$workforc6 === void 0 ? void 0 : _stateEdited$workforc6.phoneNumber),
                email: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.repEmail) || (stateEdited === null || stateEdited === void 0 || (_stateEdited$workforc7 = stateEdited.workforceRepresentative) === null || _stateEdited$workforc7 === void 0 ? void 0 : _stateEdited$workforc7.email),
                nid: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.nid) || (stateEdited === null || stateEdited === void 0 || (_stateEdited$workforc8 = stateEdited.workforceRepresentative) === null || _stateEdited$workforc8 === void 0 ? void 0 : _stateEdited$workforc8.nid),
                passportNo: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.passport) || (stateEdited === null || stateEdited === void 0 || (_stateEdited$workforc9 = stateEdited.workforceRepresentative) === null || _stateEdited$workforc9 === void 0 ? void 0 : _stateEdited$workforc9.passportNo),
                birthDate: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.birthDate) || (stateEdited === null || stateEdited === void 0 || (_stateEdited$workforc10 = stateEdited.workforceRepresentative) === null || _stateEdited$workforc10 === void 0 ? void 0 : _stateEdited$workforc10.birthDate),
                position: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.position) || (stateEdited === null || stateEdited === void 0 || (_stateEdited$workforc11 = stateEdited.workforceRepresentative) === null || _stateEdited$workforc11 === void 0 ? void 0 : _stateEdited$workforc11.position),
                id: decodeId(stateEdited.workforceRepresentative.id)
              };
              dispatch(updateRepresentative(representativeData, "Update Representative ".concat(representativeData.nameEn)));
            }

            // Update factory
            workforceFactoryData = {
              id: decodeId(stateEdited.id),
              nameBn: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.nameBn) || (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.titleBn),
              nameEn: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.nameEn) || (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.title),
              phoneNumber: stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.phoneNumber,
              email: stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.email,
              address: stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.address,
              officeAddress: stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.officeAddress,
              associationType: stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.associationType,
              website: stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.website,
              location: stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.location,
              officeLocation: stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.officeLocation,
              licenseType: stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.licenseType,
              dateOfFactoryEstablishment: stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.dateOfFactoryEstablishment,
              dateOfEisIncorporation: stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.dateOfEisIncorporation,
              registrationDate: stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.registrationDate,
              registrationExpiryDate: stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.registrationExpiryDate,
              approximateNumberOfEmployee: stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.approximateNumberOfEmployee,
              limaRegistrationNumber: stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.limaRegistrationNumber,
              licenseNo: stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.licenseNo,
              businessSector: stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.businessSector,
              membershipNo: stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.membershipNo,
              groupName: stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.groupName,
              workforceRepresentativeId: (_stateEdited$workforc12 = stateEdited.workforceRepresentative) === null || _stateEdited$workforc12 === void 0 ? void 0 : _stateEdited$workforc12.id,
              company: (_stateEdited$workforc13 = stateEdited.workforceEmployer) === null || _stateEdited$workforc13 === void 0 ? void 0 : _stateEdited$workforc13.id
            };
            dispatch(updateWorkforceFactory(workforceFactoryData, "Update Workforce Factory ".concat(workforceFactoryData.nameEn)));
          case 5:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    })));
    _this.state = {
      stateEdited: props.workforceFactory || {},
      isSaved: false,
      isSameRepresentative: true,
      showSuccessMessage: false,
      documents: [],
      fetchingDocuments: false,
      associations: [],
      fetchingAssociations: false,
      reuploadDocument: null,
      reuploadFile: null,
      reuploadOpen: false,
      reuploadSubmitting: false
    };
    return _this;
  }
  _inherits(EditWorkforceFactoryPage, _Component);
  return _createClass(EditWorkforceFactoryPage, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props$workforce;
      // Fetch associations when component mounts
      this.fetchAssociations();
      if ((_this$props$workforce = this.props.workforceFactory) !== null && _this$props$workforce !== void 0 && _this$props$workforce.id) {
        this.fetchDocuments(this.props.workforceFactory.id);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.workforceFactory !== this.props.workforceFactory) {
        var _this$props$workforce2;
        this.setState({
          stateEdited: this.props.workforceFactory
        });
        // Fetch documents when factory loads
        if ((_this$props$workforce2 = this.props.workforceFactory) !== null && _this$props$workforce2 !== void 0 && _this$props$workforce2.id) {
          this.fetchDocuments(this.props.workforceFactory.id);
        }
      }
      if (prevProps.submittingMutation && !this.props.submittingMutation) {
        var _this$props$mutation, _this$props$mutation2;
        this.props.dispatch(journalize(this.props.mutation));
        if (((_this$props$mutation = this.props.mutation) === null || _this$props$mutation === void 0 ? void 0 : _this$props$mutation.status) === 200 || ((_this$props$mutation2 = this.props.mutation) === null || _this$props$mutation2 === void 0 ? void 0 : _this$props$mutation2.status) === 201) {
          this.setState({
            showSuccessMessage: true
          });
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this,
        _stateEdited$workforc14,
        _stateEdited$workforc15,
        _stateEdited$workforc16,
        _stateEdited$workforc17,
        _stateEdited$workforc18,
        _stateEdited$workforc19,
        _stateEdited$workforc20,
        _stateEdited$workforc21,
        _this$state$reuploadD,
        _this$state$reuploadD2;
      var _this$props3 = this.props,
        classes = _this$props3.classes;
        _this$props3.theme;
      var _this$state2 = this.state,
        stateEdited = _this$state2.stateEdited,
        isSaved = _this$state2.isSaved,
        showSuccessMessage = _this$state2.showSuccessMessage,
        associations = _this$state2.associations;
      console.log({
        stateEdited: stateEdited
      });
      console.log({
        associations: associations
      });
      var foundAssociation = associations === null || associations === void 0 ? void 0 : associations.find(function (res) {
        return (res === null || res === void 0 ? void 0 : res.shortNameEn) === (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.associationType);
      });
      console.log({
        foundAssociation: foundAssociation
      });
      console.log("faltu document", this.state.reuploadDocument);
      var disableAssociationSelect = getAssociationNameByUserType(this.props.userType) === "" ? false : true;
      return /*#__PURE__*/React.createElement("div", {
        className: classes.paper
      }, /*#__PURE__*/React.createElement(Snackbar, {
        open: showSuccessMessage,
        autoHideDuration: 5000,
        onClose: function onClose() {
          return _this2.setState({
            showSuccessMessage: false
          });
        },
        anchorOrigin: {
          vertical: "top",
          horizontal: "right"
        }
      }, /*#__PURE__*/React.createElement(Alert$1, {
        severity: "success"
      }, /*#__PURE__*/React.createElement(FormattedMessage, {
        id: "workforce.factory.updateSuccessful",
        defaultMessage: "Factory updated successfully"
      }))), /*#__PURE__*/React.createElement(Grid, {
        container: true,
        spacing: 3
      }, /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12
      }, /*#__PURE__*/React.createElement(Box$1, {
        className: classes.tableTitle
      }, /*#__PURE__*/React.createElement(Grid, {
        container: true,
        alignItems: "center"
      }, /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12
      }, /*#__PURE__*/React.createElement(Box$1, {
        display: "flex",
        alignItems: "center"
      }, /*#__PURE__*/React.createElement(BusinessIcon, {
        style: {
          fontSize: "2.5rem",
          marginRight: "16px",
          color: "white"
        }
      }), /*#__PURE__*/React.createElement(Box$1, null, /*#__PURE__*/React.createElement(Typography, {
        variant: "h4",
        style: {
          color: "white",
          fontWeight: "700"
        }
      }, /*#__PURE__*/React.createElement(FormattedMessage, {
        module: MODULE_NAME,
        id: "workforce.factory.edit.title",
        defaultMessage: "Edit Factory"
      })), /*#__PURE__*/React.createElement(Typography, {
        variant: "caption",
        style: {
          color: "rgba(255,255,255,0.8)"
        }
      }, stateEdited.nameEn && "".concat(stateEdited.nameEn)))))))), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12
      }, /*#__PURE__*/React.createElement(Card, {
        className: classes.sectionCard
      }, /*#__PURE__*/React.createElement(CardHeader, {
        className: classes.sectionHeader,
        title: /*#__PURE__*/React.createElement(Typography, {
          className: classes.sectionTitle
        }, /*#__PURE__*/React.createElement(BusinessIcon, {
          className: classes.sectionIcon
        }), /*#__PURE__*/React.createElement(FormattedMessage, {
          id: "workforce.factory.basicInfo",
          defaultMessage: "Basic Information"
        }))
      }), /*#__PURE__*/React.createElement(CardContent, {
        className: classes.cardContent
      }, /*#__PURE__*/React.createElement(Grid, {
        container: true,
        spacing: 2
      }, /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12,
        sm: 6,
        className: classes.gridField
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.factory.name.en",
        value: stateEdited.nameEn || stateEdited.title || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("nameEn", v);
        },
        required: true,
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12,
        sm: 6,
        className: classes.gridField
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.factory.name.bn",
        value: stateEdited.nameBn || stateEdited.titleBn || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("nameBn", v);
        },
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12,
        sm: 6,
        className: classes.gridField
      }, /*#__PURE__*/React.createElement(FormControl, {
        fullWidth: true
      }, /*#__PURE__*/React.createElement(InputLabel, {
        id: "association-type-label"
      }, "Association Type"), /*#__PURE__*/React.createElement(Select, {
        labelId: "association-type-label",
        value: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.associationType) || "",
        onChange: function onChange(e) {
          return _this2.updateAttribute("associationType", e.target.value);
        },
        label: "Association Type",
        disabled: isSaved || disableAssociationSelect,
        required: true
      }, associations.map(function (assoc) {
        return /*#__PURE__*/React.createElement(MenuItem, {
          key: assoc.id,
          value: assoc.shortNameEn
        }, assoc.shortNameEn);
      })))), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12,
        sm: 6,
        className: classes.gridField
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.factory.licenseType",
        value: stateEdited.licenseType || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("licenseType", v);
        },
        readOnly: isSaved
      }))))), /*#__PURE__*/React.createElement(Card, {
        className: classes.sectionCard
      }, /*#__PURE__*/React.createElement(CardHeader, {
        className: classes.sectionHeader,
        title: /*#__PURE__*/React.createElement(Typography, {
          className: classes.sectionTitle
        }, /*#__PURE__*/React.createElement(PhoneIcon, {
          className: classes.sectionIcon
        }), /*#__PURE__*/React.createElement(FormattedMessage, {
          id: "workforce.factory.contactInfo",
          defaultMessage: "Contact Information"
        }))
      }), /*#__PURE__*/React.createElement(CardContent, {
        className: classes.cardContent
      }, /*#__PURE__*/React.createElement(Grid, {
        container: true,
        spacing: 2
      }, /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12,
        sm: 6,
        className: classes.gridField
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.factory.phone",
        value: stateEdited.phoneNumber || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("phoneNumber", v);
        },
        type: "number",
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12,
        sm: 6,
        className: classes.gridField
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.factory.email",
        value: stateEdited.email || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("email", v);
        },
        type: "email",
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12,
        className: classes.gridField
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.factory.website",
        value: stateEdited.website || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("website", v);
        },
        readOnly: isSaved
      }))))), /*#__PURE__*/React.createElement(Card, {
        className: classes.sectionCard
      }, /*#__PURE__*/React.createElement(CardHeader, {
        className: classes.sectionHeader,
        title: /*#__PURE__*/React.createElement(Typography, {
          className: classes.sectionTitle
        }, /*#__PURE__*/React.createElement(LocationOnIcon, {
          className: classes.sectionIcon
        }), /*#__PURE__*/React.createElement(FormattedMessage, {
          id: "workforce.factory.locationInfo",
          defaultMessage: "Location Information"
        }))
      }), /*#__PURE__*/React.createElement(CardContent, {
        className: classes.cardContent
      }, /*#__PURE__*/React.createElement(Grid, {
        container: true,
        spacing: 2
      }, /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12,
        className: classes.gridField
      }, /*#__PURE__*/React.createElement(Typography, {
        variant: "subtitle2",
        style: {
          marginBottom: "8px",
          fontWeight: "bold"
        }
      }, /*#__PURE__*/React.createElement(FormattedMessage, {
        id: "workforce.factory.location",
        defaultMessage: "Factory Location"
      })), /*#__PURE__*/React.createElement(PublishedComponent, {
        pubRef: "location.DetailedLocation",
        withNull: true,
        value: stateEdited.location || null,
        onChange: function onChange(location) {
          return _this2.updateAttribute("location", location);
        },
        readOnly: isSaved,
        required: true,
        split: true
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12,
        className: classes.gridField
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.factory.address",
        value: stateEdited.address || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("address", v);
        },
        readOnly: isSaved,
        multiline: true,
        rows: 2
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12,
        className: classes.gridField
      }, /*#__PURE__*/React.createElement(Typography, {
        variant: "subtitle2",
        style: {
          marginBottom: "8px",
          fontWeight: "bold"
        }
      }, /*#__PURE__*/React.createElement(FormattedMessage, {
        id: "workforce.factory.officeLocation",
        defaultMessage: "Office Location"
      })), /*#__PURE__*/React.createElement(PublishedComponent, {
        pubRef: "location.DetailedLocation",
        withNull: true,
        value: stateEdited.officeLocation || null,
        onChange: function onChange(location) {
          return _this2.updateAttribute("officeLocation", location);
        },
        readOnly: isSaved,
        split: true
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12,
        className: classes.gridField
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.factory.officeAddress",
        value: stateEdited.officeAddress || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("officeAddress", v);
        },
        readOnly: isSaved,
        multiline: true,
        rows: 2
      }))))), /*#__PURE__*/React.createElement(Card, {
        className: classes.sectionCard
      }, /*#__PURE__*/React.createElement(CardHeader, {
        className: classes.sectionHeader,
        title: /*#__PURE__*/React.createElement(Typography, {
          className: classes.sectionTitle
        }, /*#__PURE__*/React.createElement(EventIcon, {
          className: classes.sectionIcon
        }), /*#__PURE__*/React.createElement(FormattedMessage, {
          id: "workforce.factory.registrationInfo",
          defaultMessage: "Registration Information"
        }))
      }), /*#__PURE__*/React.createElement(CardContent, {
        className: classes.cardContent
      }, /*#__PURE__*/React.createElement(Grid, {
        container: true,
        spacing: 2
      }, /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12,
        sm: 6,
        className: classes.gridField
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.factory.dateOfEstablishment",
        value: stateEdited.dateOfFactoryEstablishment || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("dateOfFactoryEstablishment", v);
        },
        type: "date",
        readOnly: isSaved,
        InputLabelProps: {
          shrink: true
        }
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12,
        sm: 6,
        className: classes.gridField
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.factory.eisIncorporationDate",
        value: stateEdited.dateOfEisIncorporation || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("dateOfEisIncorporation", v);
        },
        type: "date",
        readOnly: isSaved,
        InputLabelProps: {
          shrink: true
        }
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12,
        sm: 6,
        className: classes.gridField
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.factory.registrationDate",
        value: stateEdited.registrationDate || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("registrationDate", v);
        },
        type: "date",
        readOnly: isSaved,
        InputLabelProps: {
          shrink: true
        }
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12,
        sm: 6,
        className: classes.gridField
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.factory.registrationExpiryDate",
        value: stateEdited.registrationExpiryDate || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("registrationExpiryDate", v);
        },
        type: "date",
        readOnly: isSaved,
        InputLabelProps: {
          shrink: true
        }
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12,
        sm: 6,
        className: classes.gridField
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.factory.limaRegistrationNumber",
        value: stateEdited.limaRegistrationNumber || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("limaRegistrationNumber", v);
        },
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12,
        sm: 6,
        className: classes.gridField
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.factory.licenseNumber",
        value: stateEdited.licenseNo || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("licenseNo", v);
        },
        readOnly: isSaved
      }))))), /*#__PURE__*/React.createElement(Card, {
        className: classes.sectionCard
      }, /*#__PURE__*/React.createElement(CardHeader, {
        className: classes.sectionHeader,
        title: /*#__PURE__*/React.createElement(Typography, {
          className: classes.sectionTitle
        }, /*#__PURE__*/React.createElement(InfoIcon, {
          className: classes.sectionIcon
        }), /*#__PURE__*/React.createElement(FormattedMessage, {
          id: "workforce.factory.additionalDetails",
          defaultMessage: "Additional Details"
        }))
      }), /*#__PURE__*/React.createElement(CardContent, {
        className: classes.cardContent
      }, /*#__PURE__*/React.createElement(Grid, {
        container: true,
        spacing: 2
      }, /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12,
        sm: 6,
        className: classes.gridField
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.factory.numberOfEmployees",
        value: stateEdited.approximateNumberOfEmployee || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("approximateNumberOfEmployee", v);
        },
        type: "number",
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12,
        sm: 6,
        className: classes.gridField
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.factory.businessSector",
        value: stateEdited.businessSector || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("businessSector", v);
        },
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12,
        sm: 6,
        className: classes.gridField
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.factory.membershipNumber",
        value: stateEdited.membershipNo || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("membershipNo", v);
        },
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12,
        sm: 6,
        className: classes.gridField
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.factory.groupName",
        value: stateEdited.groupName || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("groupName", v);
        },
        readOnly: isSaved
      }))))), stateEdited.workforceRepresentative && /*#__PURE__*/React.createElement(Card, {
        className: classes.sectionCard
      }, /*#__PURE__*/React.createElement(CardHeader, {
        className: classes.sectionHeader,
        title: /*#__PURE__*/React.createElement(Typography, {
          className: classes.sectionTitle
        }, /*#__PURE__*/React.createElement(PersonIcon, {
          className: classes.sectionIcon
        }), /*#__PURE__*/React.createElement(FormattedMessage, {
          id: "workforce.factory.representativeInfo",
          defaultMessage: "Representative Information"
        }))
      }), /*#__PURE__*/React.createElement(CardContent, {
        className: classes.cardContent
      }, /*#__PURE__*/React.createElement(Grid, {
        container: true,
        spacing: 2
      }, /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12,
        sm: 6,
        className: classes.gridField
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.representative.name.en",
        value: ((_stateEdited$workforc14 = stateEdited.workforceRepresentative) === null || _stateEdited$workforc14 === void 0 ? void 0 : _stateEdited$workforc14.nameEn) || "",
        onChange: function onChange(v) {
          return _this2.updateNestedAttribute("workforceRepresentative", "nameEn", v);
        },
        readOnly: isSaved,
        required: true
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12,
        sm: 6,
        className: classes.gridField
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.representative.name.bn",
        value: ((_stateEdited$workforc15 = stateEdited.workforceRepresentative) === null || _stateEdited$workforc15 === void 0 ? void 0 : _stateEdited$workforc15.nameBn) || "",
        onChange: function onChange(v) {
          return _this2.updateNestedAttribute("workforceRepresentative", "nameBn", v);
        },
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12,
        sm: 6,
        className: classes.gridField
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.representative.position",
        value: ((_stateEdited$workforc16 = stateEdited.workforceRepresentative) === null || _stateEdited$workforc16 === void 0 ? void 0 : _stateEdited$workforc16.position) || "",
        onChange: function onChange(v) {
          return _this2.updateNestedAttribute("workforceRepresentative", "position", v);
        },
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12,
        sm: 6,
        className: classes.gridField
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.representative.phone",
        value: ((_stateEdited$workforc17 = stateEdited.workforceRepresentative) === null || _stateEdited$workforc17 === void 0 ? void 0 : _stateEdited$workforc17.phoneNumber) || "",
        onChange: function onChange(v) {
          return _this2.updateNestedAttribute("workforceRepresentative", "phoneNumber", v);
        },
        type: "number",
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12,
        sm: 6,
        className: classes.gridField
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.representative.email",
        value: ((_stateEdited$workforc18 = stateEdited.workforceRepresentative) === null || _stateEdited$workforc18 === void 0 ? void 0 : _stateEdited$workforc18.email) || "",
        onChange: function onChange(v) {
          return _this2.updateNestedAttribute("workforceRepresentative", "email", v);
        },
        type: "email",
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12,
        sm: 6,
        className: classes.gridField
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.representative.nid",
        value: ((_stateEdited$workforc19 = stateEdited.workforceRepresentative) === null || _stateEdited$workforc19 === void 0 ? void 0 : _stateEdited$workforc19.nid) || "",
        onChange: function onChange(v) {
          return _this2.updateNestedAttribute("workforceRepresentative", "nid", v);
        },
        type: "number",
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12,
        sm: 6,
        className: classes.gridField
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.representative.birthDate",
        value: ((_stateEdited$workforc20 = stateEdited.workforceRepresentative) === null || _stateEdited$workforc20 === void 0 ? void 0 : _stateEdited$workforc20.birthDate) || "",
        onChange: function onChange(v) {
          return _this2.updateNestedAttribute("workforceRepresentative", "birthDate", v);
        },
        type: "date",
        readOnly: isSaved,
        InputLabelProps: {
          shrink: true
        }
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12,
        sm: 6,
        className: classes.gridField
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.representative.passport",
        value: ((_stateEdited$workforc21 = stateEdited.workforceRepresentative) === null || _stateEdited$workforc21 === void 0 ? void 0 : _stateEdited$workforc21.passportNo) || "",
        onChange: function onChange(v) {
          return _this2.updateNestedAttribute("workforceRepresentative", "passportNo", v);
        },
        readOnly: isSaved
      }))))), /*#__PURE__*/React.createElement(Card, {
        className: classes.sectionCard
      }, /*#__PURE__*/React.createElement(CardHeader, {
        className: classes.sectionHeader,
        title: /*#__PURE__*/React.createElement(Typography, {
          className: classes.sectionTitle
        }, /*#__PURE__*/React.createElement(DescriptionIcon, {
          className: classes.sectionIcon
        }), /*#__PURE__*/React.createElement(FormattedMessage, {
          id: "workforce.factory.uploadedDocuments",
          defaultMessage: "Uploaded Documents"
        }))
      }), /*#__PURE__*/React.createElement(CardContent, {
        className: classes.cardContent
      }, this.state.fetchingDocuments ? /*#__PURE__*/React.createElement(Box$1, {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "200px"
      }, /*#__PURE__*/React.createElement(CircularProgress$1, null)) : this.state.documents && this.state.documents.length > 0 ? /*#__PURE__*/React.createElement(Box$1, {
        style: {
          marginBottom: "24px"
        }
      }, /*#__PURE__*/React.createElement(Typography, {
        variant: "subtitle2",
        style: {
          marginBottom: "16px",
          fontWeight: "bold"
        }
      }, /*#__PURE__*/React.createElement(FormattedMessage, {
        id: "workforce.factory.currentDocuments",
        defaultMessage: "Current Documents"
      })), /*#__PURE__*/React.createElement(Table$2, null, /*#__PURE__*/React.createElement(TableHead, null, /*#__PURE__*/React.createElement(TableRow, {
        style: {
          backgroundColor: "#f5f5f5"
        }
      }, /*#__PURE__*/React.createElement(TableCell, {
        style: {
          fontWeight: "bold"
        }
      }, /*#__PURE__*/React.createElement(FormattedMessage, {
        id: "workforce.factory.documentType",
        defaultMessage: "Document Type"
      })), /*#__PURE__*/React.createElement(TableCell, {
        style: {
          fontWeight: "bold"
        }
      }, /*#__PURE__*/React.createElement(FormattedMessage, {
        id: "workforce.factory.documentFile",
        defaultMessage: "File Name"
      })), /*#__PURE__*/React.createElement(TableCell, {
        style: {
          fontWeight: "bold"
        }
      }, /*#__PURE__*/React.createElement(FormattedMessage, {
        id: "workforce.factory.documentStatus",
        defaultMessage: "Status"
      })), /*#__PURE__*/React.createElement(TableCell, {
        style: {
          fontWeight: "bold",
          textAlign: "center"
        }
      }, /*#__PURE__*/React.createElement(FormattedMessage, {
        id: "workforce.factory.documentAction",
        defaultMessage: "Action"
      })))), /*#__PURE__*/React.createElement(TableBody, null, this.state.documents.map(function (doc, index) {
        var _doc$workforceDocumen, _doc$workforceDocumen2, _doc$path, _doc$status, _doc$status2, _doc$status3;
        return /*#__PURE__*/React.createElement(TableRow, {
          key: index,
          style: {
            "&:hover": {
              backgroundColor: "#f5f5f5"
            }
          }
        }, /*#__PURE__*/React.createElement(TableCell, null, /*#__PURE__*/React.createElement(Box$1, {
          display: "flex",
          alignItems: "center"
        }, /*#__PURE__*/React.createElement(DescriptionIcon, {
          style: {
            marginRight: "8px",
            color: _this2.props.theme.palette.primary.main
          }
        }), /*#__PURE__*/React.createElement(Box$1, null, /*#__PURE__*/React.createElement(Typography, {
          variant: "body2",
          style: {
            fontWeight: "bold"
          }
        }, ((_doc$workforceDocumen = doc.workforceDocumentType) === null || _doc$workforceDocumen === void 0 ? void 0 : _doc$workforceDocumen.nameEn) || _this2.formatKey(doc === null || doc === void 0 ? void 0 : doc.documentType)), /*#__PURE__*/React.createElement(Typography, {
          variant: "caption",
          color: "textSecondary"
        }, (_doc$workforceDocumen2 = doc.workforceDocumentType) === null || _doc$workforceDocumen2 === void 0 ? void 0 : _doc$workforceDocumen2.nameBn)))), /*#__PURE__*/React.createElement(TableCell, null, /*#__PURE__*/React.createElement(Typography, {
          variant: "body2"
        }, ((_doc$path = doc.path) === null || _doc$path === void 0 ? void 0 : _doc$path.split("/").pop()) || "Document")), /*#__PURE__*/React.createElement(TableCell, null, /*#__PURE__*/React.createElement(Chip, {
          size: "small",
          label: ((_doc$status = doc.status) === null || _doc$status === void 0 ? void 0 : _doc$status.toUpperCase()) || "PENDING",
          color: ((_doc$status2 = doc.status) === null || _doc$status2 === void 0 ? void 0 : _doc$status2.toLowerCase()) === "approved" ? "primary" : ((_doc$status3 = doc.status) === null || _doc$status3 === void 0 ? void 0 : _doc$status3.toLowerCase()) === "rejected" ? "secondary" : "default",
          variant: "outlined"
        })), /*#__PURE__*/React.createElement(TableCell, {
          align: "center"
        }, /*#__PURE__*/React.createElement(Tooltip, {
          title: "Download Document"
        }, /*#__PURE__*/React.createElement(Button, {
          size: "small",
          color: "primary",
          onClick: function onClick() {
            return _this2.handleDownloadDocument(doc);
          },
          disabled: !doc.url,
          startIcon: /*#__PURE__*/React.createElement(GetAppIcon, null)
        }, /*#__PURE__*/React.createElement(FormattedMessage, {
          id: "workforce.factory.viewDocument",
          defaultMessage: "View"
        })))), /*#__PURE__*/React.createElement(TableCell, {
          align: "center"
        }, /*#__PURE__*/React.createElement(Tooltip, {
          title: "Reupload Document"
        }, /*#__PURE__*/React.createElement(Button, {
          size: "small",
          color: "primary",
          startIcon: /*#__PURE__*/React.createElement(EditIcon, null),
          onClick: function onClick() {
            return _this2.openReuploadModal(doc);
          }
        }, "Reupload")), /*#__PURE__*/React.createElement(Tooltip, {
          title: "View Document"
        }, /*#__PURE__*/React.createElement(Button, {
          size: "small",
          color: "primary",
          onClick: function onClick() {
            return _this2.handleDownloadDocument(doc);
          },
          disabled: !doc.url,
          startIcon: /*#__PURE__*/React.createElement(GetAppIcon, null)
        }, /*#__PURE__*/React.createElement(FormattedMessage, {
          id: "workforce.factory.viewDocument",
          defaultMessage: "View"
        })))));
      })))) : null)), /*#__PURE__*/React.createElement(Divider, {
        className: classes.divider
      }), /*#__PURE__*/React.createElement(Box$1, {
        className: classes.buttonGroup
      }, /*#__PURE__*/React.createElement(Button, {
        onClick: function onClick() {
          return window.history.back();
        },
        variant: "outlined",
        className: classes.closeButton,
        startIcon: /*#__PURE__*/React.createElement(Close, null)
      }, /*#__PURE__*/React.createElement(FormattedMessage, {
        id: "workforce.modal.close"
      })), /*#__PURE__*/React.createElement(Button, {
        onClick: this.save,
        variant: "contained",
        className: classes.saveButton,
        startIcon: /*#__PURE__*/React.createElement(Save, null),
        disabled: isSaved
      }, /*#__PURE__*/React.createElement(FormattedMessage, {
        id: "core.save"
      }))))), /*#__PURE__*/React.createElement(Dialog$1, {
        open: this.state.reuploadOpen,
        onClose: this.closeReuploadModal,
        fullWidth: true,
        maxWidth: "sm"
      }, /*#__PURE__*/React.createElement(DialogTitle, null, "Reupload Document", /*#__PURE__*/React.createElement(IconButton, {
        onClick: this.closeReuploadModal,
        style: {
          "float": "right"
        }
      }, /*#__PURE__*/React.createElement(CloseIcon, null))), /*#__PURE__*/React.createElement(DialogContent$1, null, this.state.reuploadDocument && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography, {
        variant: "subtitle1",
        gutterBottom: true
      }, ((_this$state$reuploadD = this.state.reuploadDocument.workforceDocumentType) === null || _this$state$reuploadD === void 0 ? void 0 : _this$state$reuploadD.nameEn) || this.formatKey((_this$state$reuploadD2 = this.state.reuploadDocument) === null || _this$state$reuploadD2 === void 0 ? void 0 : _this$state$reuploadD2.documentType)), /*#__PURE__*/React.createElement(FileUploader, {
        fieldKey: "factory-reupload-".concat(this.state.reuploadDocument.id),
        documentId: this.state.reuploadDocument.id,
        documentType: this.state.reuploadDocument.documentType,
        documentProp: this.state.reuploadDocument.workforceDocumentType,
        uploadedBy: "factory",
        onFileChange: this.handleReuploadChange
      }))), /*#__PURE__*/React.createElement(DialogActions$1, null, /*#__PURE__*/React.createElement(Button, {
        onClick: this.closeReuploadModal,
        disabled: this.state.reuploadSubmitting
      }, "Cancel"), /*#__PURE__*/React.createElement(Button, {
        variant: "contained",
        color: "primary",
        onClick: this.submitReupload,
        disabled: !this.state.reuploadFile || this.state.reuploadSubmitting
      }, this.state.reuploadSubmitting ? "Submitting..." : "Submit"))));
    }
  }]);
}(Component);
var mapStateToProps$S = function mapStateToProps(state) {
  return {
    workforceFactory: state.workforce.workforceFactory,
    userType: getUserTypeFromRights(state.core.user.i_user.rights)
  };
};
var mapDispatchToProps$x = function mapDispatchToProps(dispatch) {
  return _objectSpread$1B(_objectSpread$1B({}, bindActionCreators({
    updateWorkforceDocument: updateWorkforceDocument,
    fetchWorkforceDocument: fetchWorkforceDocument
  }, dispatch)), {}, {
    dispatch: dispatch
  });
};
var EditWorkforceFactoryPage$1 = connect(mapStateToProps$S, mapDispatchToProps$x)(withModulesManager(withStyles(styles$V)(EditWorkforceFactoryPage)));

function ownKeys$1A(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$1A(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$1A(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1A(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper$Y(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$Y() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$Y() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$Y = function _isNativeReflectConstruct() { return !!t; })(); }
var styles$U = function styles(theme) {
  return {
    paper: theme.paper.paper,
    tableTitle: theme.table.title,
    item: theme.paper.item,
    fullHeight: {
      height: "100%"
    }
  };
};
var AddWorkforceFactoryPage = /*#__PURE__*/function (_Component) {
  function AddWorkforceFactoryPage(props) {
    var _this;
    _classCallCheck(this, AddWorkforceFactoryPage);
    _this = _callSuper$Y(this, AddWorkforceFactoryPage, [props]);
    _defineProperty(_this, "save", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var _stateEdited$company$, _stateEdited$company;
      var stateEdited, handleFactoryAndDocument, _this$props$represent, representativeData, representativeMutation, representativeClientMutationId, workforceFactoryData;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            stateEdited = _this.state.stateEdited;
            handleFactoryAndDocument = /*#__PURE__*/function () {
              var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(workforceFactoryData) {
                var _res$meta, res, clientMutationId, fetchRes, factoryId, uploadFile;
                return _regeneratorRuntime.wrap(function _callee$(_context) {
                  while (1) switch (_context.prev = _context.next) {
                    case 0:
                      _context.prev = 0;
                      _context.next = 3;
                      return _this.props.createWorkforceFactory(workforceFactoryData, "Created Workforce Factory ".concat(workforceFactoryData.nameEn));
                    case 3:
                      res = _context.sent;
                      clientMutationId = res === null || res === void 0 || (_res$meta = res.meta) === null || _res$meta === void 0 ? void 0 : _res$meta.clientMutationId;
                      if (clientMutationId) {
                        _context.next = 8;
                        break;
                      }
                      console.warn("No clientMutationId returned from createWorkforceFactory");
                      return _context.abrupt("return");
                    case 8:
                      _context.next = 10;
                      return _this.props.fetchFactoryPublicInfoIdByClientMutationId(clientMutationId, "WORKFORCE_INFO_ID_BY_CLIENT_MUTATION_ID_RESP");
                    case 10:
                      fetchRes = _context.sent;
                      console.log(fetchRes);
                      factoryId = getInfoId(fetchRes, "workforceEmployerFactories");
                      if (!factoryId && _this.props.factoryId) {
                        factoryId = _this.props.factoryId;
                      }
                      console.log("Factory created with ID:", factoryId);
                      uploadFile = _this.props.uploadFile;
                      if (!(factoryId && uploadFile)) {
                        _context.next = 21;
                        break;
                      }
                      _context.next = 19;
                      return _this.props.createWorkforceDocument(_objectSpread$1A(_objectSpread$1A({}, uploadFile), {}, {
                        factoryId: factoryId,
                        holderType: "factory",
                        documentType: "factory_membership_certificate"
                      }), "Created workforce document");
                    case 19:
                      _context.next = 22;
                      break;
                    case 21:
                      console.warn("Cannot create document yet — missing:", {
                        factoryId: factoryId,
                        uploadFile: uploadFile
                      });
                    case 22:
                      _context.next = 27;
                      break;
                    case 24:
                      _context.prev = 24;
                      _context.t0 = _context["catch"](0);
                      console.error("Error in handleFactoryAndDocument:", _context.t0);
                    case 27:
                    case "end":
                      return _context.stop();
                  }
                }, _callee, null, [[0, 24]]);
              }));
              return function handleFactoryAndDocument(_x) {
                return _ref2.apply(this, arguments);
              };
            }();
            if (_this.state.isSameRepresentative) {
              _context2.next = 13;
              break;
            }
            representativeData = {
              type: "organization",
              nameBn: stateEdited.repNameBn,
              nameEn: stateEdited.repName,
              location: stateEdited.repLocation,
              address: stateEdited.repAddress,
              phoneNumber: stateEdited.repPhone,
              email: stateEdited.repEmail,
              nid: stateEdited.nid,
              passportNo: stateEdited.passport,
              birthDate: stateEdited.birthDate,
              position: stateEdited.position
            };
            _context2.next = 6;
            return formatMutation("createWorkforceRepresentative", formatRepresentativeGQL(representativeData), "Created Representative ".concat(representativeData.nameEn));
          case 6:
            representativeMutation = _context2.sent;
            representativeClientMutationId = representativeMutation.clientMutationId;
            _context2.next = 10;
            return _this.props.createRepresentative(representativeMutation, "Created Representative ".concat(representativeData.nameEn));
          case 10:
            _context2.next = 12;
            return _this.props.fetchRepresentativeByClientMutationId(_this.props.modulesManger, representativeClientMutationId);
          case 12:
            representativeId = ((_this$props$represent = _this.props.representativeId[0]) === null || _this$props$represent === void 0 ? void 0 : _this$props$represent.id) || EMPTY_STRING;
          case 13:
            workforceFactoryData = {
              company: (_stateEdited$company$ = stateEdited === null || stateEdited === void 0 || (_stateEdited$company = stateEdited.company) === null || _stateEdited$company === void 0 ? void 0 : _stateEdited$company.id) !== null && _stateEdited$company$ !== void 0 ? _stateEdited$company$ : "",
              nameBn: stateEdited.titleBn,
              nameEn: stateEdited.title,
              phoneNumber: stateEdited.phone,
              email: stateEdited.email,
              website: stateEdited.website,
              address: stateEdited.address,
              associationType: stateEdited.associationType,
              location: stateEdited.location,
              status: WORKFORCE_STATUS$1.DRAFT,
              holderType: "factory",
              // isSameCompanyRepresentative: this.state.isSameRepresentative ? "1" : "0",
              isSameCompanyRepresentative: "0",
              // workforceRepresentativeId: representativeId,
              workforceFactory: stateEdited.workforceFactory
            };
            _context2.next = 16;
            return handleFactoryAndDocument(workforceFactoryData);
          case 16:
            _this.setState({
              isSaved: true
            });
            window.location.href('/workforce/factories');
          case 18:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    })));
    _defineProperty(_this, "updateAttribute", function (key, value) {
      _this.setState(function (prevState) {
        return {
          stateEdited: _objectSpread$1A(_objectSpread$1A({}, prevState.stateEdited), {}, _defineProperty({}, key, value)),
          isSaved: false
        };
      });
    });
    _this.state = {
      stateEdited: {},
      isSaved: false,
      isSameRepresentative: true
    };
    return _this;
  }
  _inherits(AddWorkforceFactoryPage, _Component);
  return _createClass(AddWorkforceFactoryPage, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props = this.props,
        submittingMutation = _this$props.submittingMutation,
        mutation = _this$props.mutation,
        dispatch = _this$props.dispatch;
      if (!submittingMutation && prevProps.submittingMutation !== submittingMutation) {
        dispatch(journalize(mutation));
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var currentPath = window.location.pathname;
      if (currentPath.includes("workforce/factories/factory")) ;
      this.props.fetchUserDistrictsUnauthorized();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props2 = this.props,
        classes = _this$props2.classes;
        _this$props2.mutation;
      var _this$state = this.state,
        stateEdited = _this$state.stateEdited,
        isSaved = _this$state.isSaved;
        _this$state.isSameRepresentative;
      var disableAssociationSelect = false;
      if (this.props.userType && this.props.userType.includes("association")) {
        disableAssociationSelect = true;
      }
      var associationValue = "";
      if (this.props.userType && this.props.userType.includes("association")) {
        associationValue = this.props.userType.split("_")[0].toUpperCase();
      }
      return /*#__PURE__*/React.createElement("div", {
        className: classes.page
      }, /*#__PURE__*/React.createElement(Grid, {
        container: true
      }, /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12
      }, /*#__PURE__*/React.createElement(Paper, {
        className: classes.paper
      }, /*#__PURE__*/React.createElement(Grid, {
        container: true,
        className: classes.tableTitle
      }, /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12,
        className: classes.tableTitle
      }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(FormattedMessage, {
        module: MODULE_NAME,
        id: "\u09AB\u09CD\u09AF\u09BE\u0995\u09CD\u099F\u09B0\u09C0 \u09B0\u09C7\u099C\u09BF\u09B8\u09CD\u099F\u09CD\u09B0\u09C7\u09B6\u09A8",
        values: {
          label: EMPTY_STRING
        }
      })))), /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement(Grid, {
        container: true,
        className: classes.item
      }, /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.factory.name.en",
        value: stateEdited.title || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("title", v);
        },
        required: true,
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.factory.name.bn",
        value: stateEdited.titleBn || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("titleBn", v);
        },
        readOnly: isSaved,
        required: true
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.factory.phone",
        value: stateEdited.phone || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("phone", v);
        },
        type: "number",
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.factory.email",
        value: stateEdited.email || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("email", v);
        },
        type: "email",
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(FormattedMessage, {
        id: "workforce.factory.uploadMembershipCertificate",
        module: "workforce"
      }), " ", /*#__PURE__*/React.createElement("span", null, "*")), /*#__PURE__*/React.createElement(FileUploader, {
        fieldKey: "associationCertificate",
        onFileChange: function onFileChange(v) {
          return _this2.updateAttribute("associationCertificate", v);
        },
        documentType: "ASSOCIATION_MEMBERSHIP_CERTIFICATE"
      }), /*#__PURE__*/React.createElement("input", {
        key: stateEdited !== null && stateEdited !== void 0 && stateEdited.associationCertificate ? 'hasFile' : 'noFile',
        type: "file",
        style: {
          display: 'none'
        },
        required: true,
        onInvalid: function onInvalid(e) {
          return e.target.setCustomValidity("Please upload the certificate");
        },
        onInput: function onInput(e) {
          return e.target.setCustomValidity("");
        }
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.factory.website",
        value: stateEdited.website || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("website", v);
        },
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.factory.address",
        value: stateEdited.address || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("address", v);
        },
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(FormControl, {
        fullWidth: true
      }, /*#__PURE__*/React.createElement(InputLabel, {
        required: true,
        id: "association-type-label"
      }, /*#__PURE__*/React.createElement(FormattedMessage, {
        id: "workforce.factory.associationType",
        module: "workforce"
      })), /*#__PURE__*/React.createElement(Select, {
        labelId: "association-type-label",
        value: associationValue != "" ? associationValue : stateEdited.associationType ? stateEdited.associationType : "",
        onChange: function onChange(e) {
          return _this2.updateAttribute("associationType", e.target.value);
        },
        label: "Association Type",
        readOnly: disableAssociationSelect,
        disabled: isSaved
      }, /*#__PURE__*/React.createElement(MenuItem, {
        value: "BGMEA"
      }, "BGMEA"), /*#__PURE__*/React.createElement(MenuItem, {
        value: "BKMEA"
      }, "BKMEA"), /*#__PURE__*/React.createElement(MenuItem, {
        value: "LFMEAB"
      }, "LFMEAB"), /*#__PURE__*/React.createElement(MenuItem, {
        value: "BEPZA"
      }, "BEPZA")))), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12,
        className: classes.item
      }, /*#__PURE__*/React.createElement(PublishedComponent, {
        pubRef: "location.DetailedLocation",
        withNull: true,
        value: stateEdited.location || null,
        onChange: function onChange(location) {
          return _this2.updateAttribute("location", location);
        },
        readOnly: isSaved,
        required: true,
        split: true
      })), /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12,
        className: classes.item
      }, /*#__PURE__*/React.createElement(WorkforceForm, {
        title: "workforce.representative.title",
        stateEdited: stateEdited,
        isSaved: isSaved,
        updateAttribute: this.updateAttribute,
        fields: [{
          key: "repName",
          label: "workforce.representative.name.en",
          type: "text",
          required: true
        }, {
          key: "repNameBn",
          label: "workforce.representative.name.bn",
          type: "text",
          required: true
        }, {
          key: "position",
          label: "workforce.representative.position",
          type: "text",
          required: true
        }, {
          key: "repPhone",
          label: "workforce.representative.phone",
          type: "number",
          required: true
        }, {
          key: "repEmail",
          label: "workforce.representative.email",
          type: "email",
          required: true
        }, {
          key: "nid",
          label: "workforce.representative.nid",
          type: "number",
          required: true
        }, {
          key: "passport",
          label: "workforce.representative.passport",
          type: "text",
          required: false
        }, {
          key: "birthDate",
          label: "workforce.representative.birthDate",
          type: "date",
          required: false
        }, {
          key: "repLocation",
          label: "workforce.representative.location",
          type: "location",
          required: true
        }, {
          key: "repAddress",
          label: "workforce.representative.address",
          type: "text",
          required: true
        }]
      }))), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 11,
        className: classes.item
      }), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 1,
        className: classes.item
      }, /*#__PURE__*/React.createElement(IconButton, {
        variant: "contained",
        component: "label",
        color: "primary",
        onClick: this.save,
        disabled: isSaved
      }, /*#__PURE__*/React.createElement(Save, null)))), /*#__PURE__*/React.createElement(Divider, null)))));
    }
  }]);
}(Component);
var mapStateToProps$R = function mapStateToProps(state) {
  return {
    submittingMutation: state.workforce.submittingMutation,
    mutation: state.workforce.mutation,
    representativeId: state.workforce.fetchedRepresentativeByClientMutationId,
    factoryId: state.workforce.fetchedWorkforceFactoryId,
    uploadFile: state.workforce.uploadFile
    // userType: getUserTypeFromRights(state.core.user.i_user.rights),
  };
};
var mapDispatchToProps$w = function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    fetchUserDistrictsUnauthorized: fetchUserDistrictsUnauthorized,
    createWorkforceFactory: createWorkforceFactory,
    createRepresentative: createRepresentative,
    fetchRepresentativeByClientMutationId: fetchRepresentativeByClientMutationId,
    fetchFactoryByClientMutationId: fetchFactoryByClientMutationId,
    createWorkforceDocument: createWorkforceDocument,
    fetchInfoIdByClientMutationId: fetchInfoIdByClientMutationId,
    fetchFactoryPublicInfoIdByClientMutationId: fetchFactoryPublicInfoIdByClientMutationId
  }, dispatch);
};
var AddWorkforceFactoryPage$1 = connect(mapStateToProps$R, mapDispatchToProps$w)(withStyles(styles$U)(AddWorkforceFactoryPage));

function ownKeys$1z(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$1z(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$1z(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1z(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper$X(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$X() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$X() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$X = function _isNativeReflectConstruct() { return !!t; })(); }
var WorkforceFactoryForm = /*#__PURE__*/function (_Component) {
  function WorkforceFactoryForm(props) {
    var _this;
    _classCallCheck(this, WorkforceFactoryForm);
    _this = _callSuper$X(this, WorkforceFactoryForm, [props]);
    _defineProperty(_this, "reload", function () {});
    _defineProperty(_this, "canSave", function () {});
    _defineProperty(_this, "_save", function (workforceFactory) {
      _this.setState({
        lockNew: !workforceFactory.uuid
      }, function () {
        return _this.props.save(workforceFactory);
      });
    });
    _defineProperty(_this, "onEditedChanged", function (workforceFactory) {
      _this.setState({
        workforceFactory: workforceFactory
      });
    });
    _defineProperty(_this, "reopenTicket", function () {
      var _this$props = _this.props,
        intl = _this$props.intl,
        workforceFactory = _this$props.workforceFactory;
      _this.props.reopenTicket(workforceFactory.id, formatMessage(intl, MODULE_NAME, "reopenTicket.mutation.label"));
    });
    _this.state = {
      lockNew: false,
      reset: 0,
      workforceFactoryUuid: null,
      workforceFactory: _this._newTicket()
    };
    return _this;
  }
  _inherits(WorkforceFactoryForm, _Component);
  return _createClass(WorkforceFactoryForm, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.workforceFactoryUuid) {
        this.setState(function (state, props) {
          return {
            workforceFactoryUuid: props.workforceFactoryUuid
          };
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {}
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState, snapshot) {
      if (prevProps.fetchedWorkforceFactory !== this.props.fetchedWorkforceFactory && !!this.props.fetchedWorkforceFactory && !!this.props.workforceFactory) {
        this.setState(function (state, props) {
          return {
            workforceFactory: _objectSpread$1z({}, props.workforceFactory),
            workforceFactoryUuid: props.workforceFactory.id,
            lockNew: false
          };
        });
      } else if (prevState.workforceFactoryUuid !== this.state.workforceFactoryUuid) {
        var filters = ["id: \"".concat(this.state.workforceFactoryUuid, "\"")];
        this.props.fetchWorkforceFactory(this.props.modulesManager, filters);
      } else if (prevProps.submittingMutation && !this.props.submittingMutation) {
        var _this$props2;
        this.props.journalize(this.props.mutation);
        this.setState(function (state) {
          return {
            reset: state.reset + 1
          };
        });
        if ((_this$props2 = this.props) !== null && _this$props2 !== void 0 && (_this$props2 = _this$props2.workforceFactory) !== null && _this$props2 !== void 0 && _this$props2.id) {
          this.props.fetchWorkforceFactory(this.props.modulesManager, ["id: \"".concat(this.state.workforceFactoryUuid, "\"")]);
        }
      }
    }
  }, {
    key: "_newTicket",
    value: function _newTicket() {
      return {};
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
        fetchingWorkforceFactory = _this$props3.fetchingWorkforceFactory,
        fetchedWorkforceFactory = _this$props3.fetchedWorkforceFactory,
        errorWorkforceFactory = _this$props3.errorWorkforceFactory,
        save = _this$props3.save,
        back = _this$props3.back;
      var _this$state = this.state,
        lockNew = _this$state.lockNew,
        reset = _this$state.reset,
        update = _this$state.update,
        overview = _this$state.overview,
        workforceFactoryUuid = _this$state.workforceFactoryUuid,
        workforceFactory = _this$state.workforceFactory;
      var readOnly = lockNew || !!workforceFactory.validityTo || this.props.readOnly;
      [{
        doIt: this.reopenTicket,
        icon: /*#__PURE__*/React.createElement(LockOpenIcon, null),
        disabled: workforceFactory.isHistory
      }];
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ProgressOrError, {
        progress: fetchingWorkforceFactory,
        error: errorWorkforceFactory
      }), (!!fetchedWorkforceFactory || !workforceFactoryUuid) && /*#__PURE__*/React.createElement(Form, {
        module: MODULE_NAME,
        edited_id: workforceFactoryUuid,
        edited: workforceFactory,
        reset: reset,
        update: update,
        title: "\u09AB\u09CD\u09AF\u09BE\u0995\u09CD\u099F\u09B0\u09C0 \u09B0\u09C7\u099C\u09BF\u09B8\u09CD\u099F\u09CD\u09B0\u09C7\u09B6\u09A8",
        titleParams: {
          label: "Label"
        },
        back: back,
        save: save ? this._save : null,
        canSave: this.canSave,
        reload: (workforceFactoryUuid || readOnly) && this.reload,
        readOnly: readOnly,
        overview: overview,
        Panels: workforceFactoryUuid ? [EditWorkforceFactoryPage$1] : [AddWorkforceFactoryPage$1],
        onEditedChanged: this.onEditedChanged
      }));
    }
  }]);
}(Component); // eslint-disable-next-line no-unused-vars
var mapStateToProps$Q = function mapStateToProps(state, props) {
  return {
    rights: !!state.core && !!state.core.user && !!state.core.user.i_user ? state.core.user.i_user.rights : [],
    fetchingWorkforceFactory: state.workforce.fetchingWorkforceFactory,
    errorWorkforceFactory: state.workforce.errorWorkforceFactory,
    fetchedWorkforceFactory: state.workforce.fetchedWorkforceFactory,
    workforceFactory: state.workforce.workforceFactory,
    submittingMutation: state.workforce.submittingMutation,
    mutation: state.workforce.mutation,
    grievanceConfig: state.workforce.grievanceConfig
  };
};
var mapDispatchToProps$v = function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    fetchWorkforceFactory: fetchWorkforceFactory,
    journalize: journalize
  }, dispatch);
};
var WorkforceFactoryForm$1 = withModulesManager(connect(mapStateToProps$Q, mapDispatchToProps$v)(WorkforceFactoryForm));

function _callSuper$W(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$W() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$W() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$W = function _isNativeReflectConstruct() { return !!t; })(); }
var styles$T = function styles(theme) {
  return {
    page: theme.page,
    lockedPage: theme.page.locked
  };
};
var WorkforceFactoryPage = /*#__PURE__*/function (_Component) {
  function WorkforceFactoryPage() {
    var _this;
    _classCallCheck(this, WorkforceFactoryPage);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper$W(this, WorkforceFactoryPage, [].concat(args));
    _defineProperty(_this, "add", function () {
      historyPush$1(_this.props.modulesManager, _this.props.history, "grievance.route.ticket");
    });
    _defineProperty(_this, "save", function (workforceFactory) {
      if (!workforceFactory.id) {
        _this.props.createWorkforceEmployee(_this.props.modulesManager, workforceFactory, "Create");
      } else {
        _this.props.updateWorkforceEmployee(_this.props.modulesManager, workforceFactory, "Update");
      }
    });
    return _this;
  }
  _inherits(WorkforceFactoryPage, _Component);
  return _createClass(WorkforceFactoryPage, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        classes = _this$props.classes,
        modulesManager = _this$props.modulesManager,
        history = _this$props.history,
        rights = _this$props.rights,
        workforceFactoryUuid = _this$props.workforceFactoryUuid,
        overview = _this$props.overview,
        organizationVersion = _this$props.organizationVersion;
      // const readOnly = organization?.status === TICKET_STATUSES.CLOSED || ticket?.isHistory;
      var readOnly = false;
      // if (!(rights.includes(RIGHT_ORGANIZATION_CREATE) || rights.includes(RIGHT_ORGANIZATION_EDIT))) return null;
      return /*#__PURE__*/React.createElement("div", {
        className: "".concat(null, " ").concat(classes.page)
      }, /*#__PURE__*/React.createElement(WorkforceFactoryForm$1, {
        overview: overview,
        workforceFactoryUuid: workforceFactoryUuid,
        organizationVersion: organizationVersion,
        readOnly: readOnly,
        back: function back() {
          return historyPush$1(modulesManager, history, "workforce.route.factories");
        },
        add: rights.includes(RIGHT_ORGANIZATION_CREATE) ? this.add : null,
        save: rights.includes(RIGHT_ORGANIZATION_EDIT) ? this.save : null
      }));
    }
  }]);
}(Component);
var mapStateToProps$P = function mapStateToProps(state, props) {
  return {
    rights: !!state.core && !!state.core.user && !!state.core.user.i_user ? state.core.user.i_user.rights : [],
    workforceFactoryUuid: props.match.params.workforce_factory_uuid,
    organizationVersion: props.match.params.version,
    workforceFactory: state.workforce.workforceFactory
  };
};
var mapDispatchToProps$u = function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    createWorkforceEmployee: createWorkforceEmployee,
    updateWorkforceEmployee: updateWorkforceEmployee
  }, dispatch);
};
var OrganizationFactoryPage = withHistory(withModulesManager(connect(mapStateToProps$P, mapDispatchToProps$u)(withTheme(withStyles(styles$T)(WorkforceFactoryPage)))));

var useStyles$1B = makeStyles(function (theme) {
  return {
    root: {
      padding: theme.spacing(2),
      backgroundColor: "#f5f5f5",
      minHeight: "100vh"
    },
    header: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      marginBottom: theme.spacing(3)
    },
    backButton: {
      marginRight: theme.spacing(2)
    },
    title: {
      color: theme.palette.primary.main,
      fontWeight: "bold"
    },
    card: {
      marginBottom: theme.spacing(2),
      boxShadow: "0 2px 8px rgba(0,0,0,0.1)"
    },
    cardHeader: {
      background: "linear-gradient(135deg, ".concat(theme.palette.primary.main, " 0%, ").concat(theme.palette.primary.dark, " 100%)"),
      color: "white",
      padding: theme.spacing(2)
    },
    cardTitle: {
      color: "white",
      fontWeight: "bold",
      fontSize: "1.2rem"
    },
    section: {
      marginBottom: theme.spacing(2)
    },
    fieldBox: {
      padding: theme.spacing(1.5),
      marginBottom: theme.spacing(1),
      background: "#fafafa",
      borderRadius: "4px",
      borderLeft: "4px solid ".concat(theme.palette.primary.main)
    },
    fieldLabel: {
      fontWeight: "bold",
      color: theme.palette.text.secondary,
      fontSize: "0.85rem",
      textTransform: "uppercase",
      letterSpacing: "0.5px"
    },
    fieldValue: {
      color: theme.palette.text.primary,
      fontSize: "1rem",
      marginTop: theme.spacing(0.5),
      wordBreak: "break-word"
    },
    statusChip: {
      marginBottom: theme.spacing(2)
    },
    repCard: {
      background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
      color: "white",
      marginTop: theme.spacing(2)
    },
    repCardContent: {
      padding: theme.spacing(2)
    },
    repField: {
      marginBottom: theme.spacing(1.5),
      display: "flex",
      alignItems: "flex-start"
    },
    repIcon: {
      marginRight: theme.spacing(1),
      marginTop: theme.spacing(0.3)
    },
    repText: {
      flex: 1
    },
    repLabel: {
      fontWeight: "bold",
      fontSize: "0.9rem"
    },
    repValue: {
      marginTop: theme.spacing(0.3),
      fontSize: "1rem"
    },
    buttonGroup: {
      display: "flex",
      gap: theme.spacing(1),
      marginTop: theme.spacing(2)
    },
    approveButton: {
      background: "linear-gradient(135deg, ".concat(theme.palette.success.main, " 0%, ").concat(theme.palette.success.dark, " 100%)"),
      color: "white"
    },
    backNavButton: {
      marginRight: theme.spacing(1)
    },
    skeleton: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      minHeight: "400px"
    },
    inlineIcon: {
      verticalAlign: "middle",
      marginRight: theme.spacing(0.5)
    },
    grayText: {
      color: theme.palette.text.disabled
    },
    documentCard: {
      marginBottom: theme.spacing(2),
      transition: "all 0.3s ease",
      "&:hover": {
        boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
        transform: "translateY(-2px)"
      }
    },
    documentIcon: {
      fontSize: "2rem",
      color: theme.palette.primary.main,
      marginRight: theme.spacing(1)
    },
    documentRow: {
      "&:hover": {
        backgroundColor: "#f5f5f5"
      }
    },
    downloadBtn: {
      textTransform: "none",
      marginLeft: theme.spacing(1)
    },
    documentType: {
      display: "inline-block",
      padding: theme.spacing(0.5, 1),
      borderRadius: "4px",
      fontSize: "0.75rem",
      fontWeight: "bold",
      marginRight: theme.spacing(1)
    },
    noDocuments: {
      textAlign: "center",
      padding: theme.spacing(3),
      color: theme.palette.text.secondary
    }
  };
});
var WorkforceFactoryViewPage = function WorkforceFactoryViewPage(_ref) {
  var _reduxState$core, _factory$status, _factory$status2, _factory$status3;
  var match = _ref.match,
    history = _ref.history,
    modulesManager = _ref.modulesManager;
  var classes = useStyles$1B();
  var dispatch = useDispatch();
  var workforceFactoryUuid = match.params.workforce_factory_uuid;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    approveDialog = _useState2[0],
    setApproveDialog = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isApproving = _useState4[0],
    setIsApproving = _useState4[1];
  var _useState5 = useState([]),
    _useState6 = _slicedToArray(_useState5, 2),
    documents = _useState6[0],
    setDocuments = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    fetchingDocuments = _useState8[0],
    setFetchingDocuments = _useState8[1];
  var reduxState = useSelector(function (state) {
    return state;
  });
  var locale = (reduxState === null || reduxState === void 0 || (_reduxState$core = reduxState.core) === null || _reduxState$core === void 0 || (_reduxState$core = _reduxState$core.user) === null || _reduxState$core === void 0 || (_reduxState$core = _reduxState$core.i_user) === null || _reduxState$core === void 0 ? void 0 : _reduxState$core.language) || 'en';
  var _useSelector = useSelector(function (state) {
      var factoryData = state.workforce.workforceFactory || {};
      return {
        factory: Array.isArray(factoryData) ? factoryData[0] : factoryData,
        fetching: state.workforce.fetchingWorkforceFactory,
        approving: state.workforce.submittingMutation
      };
    }),
    factory = _useSelector.factory,
    fetching = _useSelector.fetching,
    approving = _useSelector.approving;
  useEffect(function () {
    if (workforceFactoryUuid) {
      dispatch(fetchWorkforceFactory(modulesManager, ["id: \"".concat(workforceFactoryUuid, "\"")]));
    }
  }, [workforceFactoryUuid, dispatch, modulesManager]);

  // Fetch documents for this factory
  useEffect(function () {
    if (factory !== null && factory !== void 0 && factory.id) {
      setFetchingDocuments(true);
      var factoryId = factory.id;
      dispatch(fetchWorkforceDocument(modulesManager, ["holderType: \"factory\"", "workforceFactoryId: \"".concat(factoryId, "\"")])).then(function (response) {
        var _response$payload;
        if (response !== null && response !== void 0 && (_response$payload = response.payload) !== null && _response$payload !== void 0 && (_response$payload = _response$payload.data) !== null && _response$payload !== void 0 && (_response$payload = _response$payload.workforceDocuments) !== null && _response$payload !== void 0 && _response$payload.edges) {
          var docs = response.payload.data.workforceDocuments.edges.map(function (edge) {
            return edge.node;
          });
          setDocuments(docs);
        }
        setFetchingDocuments(false);
      })["catch"](function (error) {
        console.error("Error fetching documents:", error);
        setFetchingDocuments(false);
      });
    }
  }, [factory === null || factory === void 0 ? void 0 : factory.id, dispatch, modulesManager]);
  var handleApprove = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _factory$workforceRep, _factory$workforceEmp, factoryData;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            setIsApproving(true);
            try {
              factoryData = {
                id: factory.id,
                nameEn: factory.nameEn,
                nameBn: factory.nameBn,
                status: "active",
                phoneNumber: factory.phoneNumber,
                email: factory.email,
                address: factory.address,
                associationType: factory.associationType,
                website: factory.website,
                location: factory.location,
                workforceRepresentativeId: (_factory$workforceRep = factory.workforceRepresentative) === null || _factory$workforceRep === void 0 ? void 0 : _factory$workforceRep.id,
                company: (_factory$workforceEmp = factory.workforceEmployer) === null || _factory$workforceEmp === void 0 ? void 0 : _factory$workforceEmp.id
              };
              dispatch(updateWorkforceFactory(factoryData, "Approve Workforce Factory ".concat(factory.nameEn)));
              setApproveDialog(false);
              // Reload the page after approval
              setTimeout(function () {
                window.location.reload();
              }, 1000);
            } catch (error) {
              console.error("Error approving factory:", error);
            } finally {
              setIsApproving(false);
            }
          case 2:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function handleApprove() {
      return _ref2.apply(this, arguments);
    };
  }();
  var getStatusColor = function getStatusColor(status) {
    switch (status === null || status === void 0 ? void 0 : status.toLowerCase()) {
      case "active":
        return "success";
      case "inactive":
        return "default";
      case "pending":
        return "warning";
      default:
        return "default";
    }
  };
  var formatLocationName = function formatLocationName(location) {
    var _location$parent, _location$parent2;
    if (!location) return "N/A";
    if (typeof location === "string") return location;
    var parts = [];
    if (location.name) parts.push(location.name);
    if ((_location$parent = location.parent) !== null && _location$parent !== void 0 && _location$parent.name) parts.push(location.parent.name);
    if ((_location$parent2 = location.parent) !== null && _location$parent2 !== void 0 && (_location$parent2 = _location$parent2.parent) !== null && _location$parent2 !== void 0 && _location$parent2.name) parts.push(location.parent.parent.name);
    return parts.join(", ") || "N/A";
  };

  // Translation helper
  var t = function t(enText, bnText) {
    return locale === 'fr' ? bnText : enText;
  };

  // Handle document download
  var handleDownloadDocument = function handleDownloadDocument(doc) {
    if (doc !== null && doc !== void 0 && doc.url) {
      var fullUrl = window.location.origin + doc.url;
      window.open(fullUrl, '_blank');
    }
  };
  if (fetching) {
    return /*#__PURE__*/React.createElement("div", {
      className: classes.root
    }, /*#__PURE__*/React.createElement("div", {
      className: classes.skeleton
    }, /*#__PURE__*/React.createElement(CircularProgress$1, {
      size: 60
    })));
  }
  if (!factory || Object.keys(factory).length === 0) {
    return /*#__PURE__*/React.createElement("div", {
      className: classes.root
    }, /*#__PURE__*/React.createElement("div", {
      className: classes.skeleton
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "h6",
      color: "textSecondary"
    }, "Factory not found")));
  }
  return /*#__PURE__*/React.createElement("div", {
    className: classes.root
  }, /*#__PURE__*/React.createElement(Box$1, {
    className: classes.header
  }, /*#__PURE__*/React.createElement(Box$1, {
    display: "flex",
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(Button, {
    startIcon: /*#__PURE__*/React.createElement(ArrowBackIcon, null),
    onClick: function onClick() {
      return history.goBack();
    },
    className: classes.backNavButton
  }, t('Back', 'ফিরে যান')), /*#__PURE__*/React.createElement(Typography, {
    variant: "h4",
    className: classes.title
  }, t('Factory Details', 'ফ্যাক্টরি বিবরণ'))), /*#__PURE__*/React.createElement(Chip, {
    label: ((_factory$status = factory.status) === null || _factory$status === void 0 ? void 0 : _factory$status.toUpperCase()) || "PENDING",
    color: getStatusColor(factory.status),
    variant: "outlined",
    className: classes.statusChip
  }), /*#__PURE__*/React.createElement(Button, {
    variant: "outlined",
    startIcon: /*#__PURE__*/React.createElement(EditIcon, null),
    onClick: function onClick() {
      return history.push("/".concat(ROUTE_WORKFORCE_FACTORIES_FACTORY, "/").concat(workforceFactoryUuid));
    },
    style: {
      borderColor: '#667eea',
      color: '#667eea',
      fontWeight: '600'
    }
  }, t('Edit Factory', 'ফ্যাক্টরি সম্পাদনা করুন')), ((_factory$status2 = factory.status) === null || _factory$status2 === void 0 ? void 0 : _factory$status2.toLowerCase()) !== "active" && /*#__PURE__*/React.createElement(Button, {
    variant: "contained",
    color: "primary",
    startIcon: /*#__PURE__*/React.createElement(CheckCircleIcon, null),
    onClick: function onClick() {
      return setApproveDialog(true);
    },
    disabled: approving || isApproving,
    className: classes.approveButton
  }, approving ? t('Approving...', 'অনুমোদন করছে...') : t('Approve Factory', 'ফ্যাক্টরি অনুমোদন করুন'))), /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 2
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(Card, {
    className: classes.card
  }, /*#__PURE__*/React.createElement(CardHeader, {
    className: classes.cardHeader,
    title: /*#__PURE__*/React.createElement(Typography, {
      className: classes.cardTitle
    }, factory.nameEn),
    subheader: factory.nameBn && /*#__PURE__*/React.createElement(Typography, {
      style: {
        color: "rgba(255,255,255,0.8)"
      }
    }, factory.nameBn)
  }), /*#__PURE__*/React.createElement(CardContent, null, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 2
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 6,
    md: 4
  }, /*#__PURE__*/React.createElement(Box$1, {
    className: classes.fieldBox
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.fieldLabel
  }, t('Association Type', 'সংস্থার ধরন')), /*#__PURE__*/React.createElement(Typography, {
    className: classes.fieldValue
  }, factory.associationType || "N/A"))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 6,
    md: 4
  }, /*#__PURE__*/React.createElement(Box$1, {
    className: classes.fieldBox
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.fieldLabel
  }, t('Status', 'অবস্থা')), /*#__PURE__*/React.createElement(Typography, {
    className: classes.fieldValue
  }, /*#__PURE__*/React.createElement(Chip, {
    size: "small",
    label: ((_factory$status3 = factory.status) === null || _factory$status3 === void 0 ? void 0 : _factory$status3.toUpperCase()) || "N/A",
    color: getStatusColor(factory.status)
  })))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 6,
    md: 4
  }, /*#__PURE__*/React.createElement(Box$1, {
    className: classes.fieldBox
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.fieldLabel
  }, t('License Type', 'লাইসেন্স ধরন')), /*#__PURE__*/React.createElement(Typography, {
    className: classes.fieldValue
  }, factory.licenseType || "N/A"))))))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 6
  }, /*#__PURE__*/React.createElement(Card, {
    className: classes.card
  }, /*#__PURE__*/React.createElement(CardHeader, {
    className: classes.cardHeader,
    title: /*#__PURE__*/React.createElement(Typography, {
      className: classes.cardTitle
    }, t('Contact Information', 'যোগাযোগ তথ্য'))
  }), /*#__PURE__*/React.createElement(CardContent, null, /*#__PURE__*/React.createElement(Box$1, {
    className: classes.fieldBox
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.fieldLabel
  }, /*#__PURE__*/React.createElement(PhoneIcon, {
    className: classes.inlineIcon,
    fontSize: "small"
  }), t('Phone Number', 'ফোন নম্বর')), /*#__PURE__*/React.createElement(Typography, {
    className: classes.fieldValue
  }, factory.phoneNumber || "N/A")), /*#__PURE__*/React.createElement(Box$1, {
    className: classes.fieldBox
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.fieldLabel
  }, /*#__PURE__*/React.createElement(EmailIcon, {
    className: classes.inlineIcon,
    fontSize: "small"
  }), t('Email', 'ইমেইল')), /*#__PURE__*/React.createElement(Typography, {
    className: classes.fieldValue
  }, factory.email || "N/A")), /*#__PURE__*/React.createElement(Box$1, {
    className: classes.fieldBox
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.fieldLabel
  }, t('Website', 'ওয়েবসাইট')), /*#__PURE__*/React.createElement(Typography, {
    className: classes.fieldValue
  }, factory.website ? /*#__PURE__*/React.createElement("a", {
    href: factory.website,
    target: "_blank",
    rel: "noopener noreferrer"
  }, factory.website) : "N/A"))))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 6
  }, /*#__PURE__*/React.createElement(Card, {
    className: classes.card
  }, /*#__PURE__*/React.createElement(CardHeader, {
    className: classes.cardHeader,
    title: /*#__PURE__*/React.createElement(Typography, {
      className: classes.cardTitle
    }, t('Location & Address', 'অবস্থান এবং ঠিকানা'))
  }), /*#__PURE__*/React.createElement(CardContent, null, /*#__PURE__*/React.createElement(Box$1, {
    className: classes.fieldBox
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.fieldLabel
  }, /*#__PURE__*/React.createElement(LocationOnIcon, {
    className: classes.inlineIcon,
    fontSize: "small"
  }), t('Factory Location', 'ফ্যাক্টরি অবস্থান')), /*#__PURE__*/React.createElement(Typography, {
    className: classes.fieldValue
  }, formatLocationName(factory.location))), /*#__PURE__*/React.createElement(Box$1, {
    className: classes.fieldBox
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.fieldLabel
  }, t('Factory Address', 'ফ্যাক্টরি ঠিকানা')), /*#__PURE__*/React.createElement(Typography, {
    className: classes.fieldValue
  }, factory.address || "N/A")), /*#__PURE__*/React.createElement(Box$1, {
    className: classes.fieldBox
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.fieldLabel
  }, /*#__PURE__*/React.createElement(LocationOnIcon, {
    className: classes.inlineIcon,
    fontSize: "small"
  }), t('Office Location', 'অফিস অবস্থান')), /*#__PURE__*/React.createElement(Typography, {
    className: classes.fieldValue
  }, formatLocationName(factory.officeLocation))), /*#__PURE__*/React.createElement(Box$1, {
    className: classes.fieldBox
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.fieldLabel
  }, t('Office Address', 'অফিস ঠিকানা')), /*#__PURE__*/React.createElement(Typography, {
    className: classes.fieldValue
  }, factory.officeAddress || "N/A"))))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 6
  }, /*#__PURE__*/React.createElement(Card, {
    className: classes.card
  }, /*#__PURE__*/React.createElement(CardHeader, {
    className: classes.cardHeader,
    title: /*#__PURE__*/React.createElement(Typography, {
      className: classes.cardTitle
    }, t('Factory Information', 'ফ্যাক্টরি তথ্য'))
  }), /*#__PURE__*/React.createElement(CardContent, null, /*#__PURE__*/React.createElement(Box$1, {
    className: classes.fieldBox
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.fieldLabel
  }, /*#__PURE__*/React.createElement(EventIcon, {
    className: classes.inlineIcon,
    fontSize: "small"
  }), t('Est. Establishment Date', 'প্রাক্তন প্রতিষ্ঠাতা তারিখ')), /*#__PURE__*/React.createElement(Typography, {
    className: classes.fieldValue
  }, factory.dateOfFactoryEstablishment || "N/A")), /*#__PURE__*/React.createElement(Box$1, {
    className: classes.fieldBox
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.fieldLabel
  }, t('EIS Incorporation Date', 'EIS ইনকর্পোরেশন তারিখ')), /*#__PURE__*/React.createElement(Typography, {
    className: classes.fieldValue
  }, factory.dateOfEisIncorporation || "N/A")), /*#__PURE__*/React.createElement(Box$1, {
    className: classes.fieldBox
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.fieldLabel
  }, t('Registration Date', 'নিবন্ধন তারিখ')), /*#__PURE__*/React.createElement(Typography, {
    className: classes.fieldValue
  }, factory.registrationDate || "N/A")), /*#__PURE__*/React.createElement(Box$1, {
    className: classes.fieldBox
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.fieldLabel
  }, t('Registration Expiry Date', 'নিবন্ধন মেয়াদ শেষের তারিখ')), /*#__PURE__*/React.createElement(Typography, {
    className: classes.fieldValue
  }, factory.registrationExpiryDate || "N/A"))))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 6
  }, /*#__PURE__*/React.createElement(Card, {
    className: classes.card
  }, /*#__PURE__*/React.createElement(CardHeader, {
    className: classes.cardHeader,
    title: /*#__PURE__*/React.createElement(Typography, {
      className: classes.cardTitle
    }, t('Additional Details', 'অতিরিক্ত বিবরণ'))
  }), /*#__PURE__*/React.createElement(CardContent, null, /*#__PURE__*/React.createElement(Box$1, {
    className: classes.fieldBox
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.fieldLabel
  }, t('Approx. Number of Employees', 'আনুমানিক কর্মচারী সংখ্যা')), /*#__PURE__*/React.createElement(Typography, {
    className: classes.fieldValue
  }, factory.approximateNumberOfEmployee || "N/A")), /*#__PURE__*/React.createElement(Box$1, {
    className: classes.fieldBox
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.fieldLabel
  }, t('Lima Registration Number', 'লিমা নিবন্ধন নম্বর')), /*#__PURE__*/React.createElement(Typography, {
    className: classes.fieldValue
  }, factory.limaRegistrationNumber || "N/A")), /*#__PURE__*/React.createElement(Box$1, {
    className: classes.fieldBox
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.fieldLabel
  }, t('License Number', 'লাইসেন্স নম্বর')), /*#__PURE__*/React.createElement(Typography, {
    className: classes.fieldValue
  }, factory.licenseNo || "N/A")), /*#__PURE__*/React.createElement(Box$1, {
    className: classes.fieldBox
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.fieldLabel
  }, t('Business Sector', 'ব্যবসায়িক খাত')), /*#__PURE__*/React.createElement(Typography, {
    className: classes.fieldValue
  }, factory.businessSector || "N/A")), /*#__PURE__*/React.createElement(Box$1, {
    className: classes.fieldBox
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.fieldLabel
  }, t('Membership Number', 'সদস্যপদ নম্বর')), /*#__PURE__*/React.createElement(Typography, {
    className: classes.fieldValue
  }, factory.membershipNo || "N/A")), /*#__PURE__*/React.createElement(Box$1, {
    className: classes.fieldBox
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.fieldLabel
  }, t('Group Name', 'গ্রুপ নাম')), /*#__PURE__*/React.createElement(Typography, {
    className: classes.fieldValue
  }, factory.groupName || "N/A"))))), factory.workforceRepresentative && /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(Card, {
    className: "".concat(classes.card, " ").concat(classes.repCard)
  }, /*#__PURE__*/React.createElement(CardHeader, {
    title: /*#__PURE__*/React.createElement(Typography, {
      className: classes.cardTitle,
      style: {
        fontSize: "1.2rem",
        marginBottom: "0.5rem"
      }
    }, /*#__PURE__*/React.createElement(PersonIcon, {
      style: {
        marginRight: "8px"
      }
    }), t('Representative Information', 'প্রতিনিধি তথ্য'))
  }), /*#__PURE__*/React.createElement(CardContent, {
    className: classes.repCardContent
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 2
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 6
  }, /*#__PURE__*/React.createElement(Box$1, {
    className: classes.repField
  }, /*#__PURE__*/React.createElement(Box$1, {
    className: classes.repText
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.repLabel
  }, t('Name (English)', 'নাম (ইংরেজি)')), /*#__PURE__*/React.createElement(Typography, {
    className: classes.repValue
  }, factory.workforceRepresentative.nameEn || "N/A")))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 6
  }, /*#__PURE__*/React.createElement(Box$1, {
    className: classes.repField
  }, /*#__PURE__*/React.createElement(Box$1, {
    className: classes.repText
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.repLabel
  }, t('Name (Bangla)', 'নাম (বাংলা)')), /*#__PURE__*/React.createElement(Typography, {
    className: classes.repValue
  }, factory.workforceRepresentative.nameBn || "N/A")))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 6
  }, /*#__PURE__*/React.createElement(Box$1, {
    className: classes.repField
  }, /*#__PURE__*/React.createElement(Box$1, {
    className: classes.repText
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.repLabel
  }, t('Position', 'অবস্থান')), /*#__PURE__*/React.createElement(Typography, {
    className: classes.repValue
  }, factory.workforceRepresentative.position || "N/A")))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 6
  }, /*#__PURE__*/React.createElement(Box$1, {
    className: classes.repField
  }, /*#__PURE__*/React.createElement(Box$1, {
    className: classes.repText
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.repLabel
  }, t('Phone', 'ফোন')), /*#__PURE__*/React.createElement(Typography, {
    className: classes.repValue
  }, factory.workforceRepresentative.phoneNumber || "N/A")))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 6
  }, /*#__PURE__*/React.createElement(Box$1, {
    className: classes.repField
  }, /*#__PURE__*/React.createElement(Box$1, {
    className: classes.repText
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.repLabel
  }, t('Email', 'ইমেইল')), /*#__PURE__*/React.createElement(Typography, {
    className: classes.repValue
  }, factory.workforceRepresentative.email || "N/A")))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 6
  }, /*#__PURE__*/React.createElement(Box$1, {
    className: classes.repField
  }, /*#__PURE__*/React.createElement(Box$1, {
    className: classes.repText
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.repLabel
  }, t('NID', 'জাতীয় পরিচয়পত্র')), /*#__PURE__*/React.createElement(Typography, {
    className: classes.repValue
  }, factory.workforceRepresentative.nid || "N/A")))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 6
  }, /*#__PURE__*/React.createElement(Box$1, {
    className: classes.repField
  }, /*#__PURE__*/React.createElement(Box$1, {
    className: classes.repText
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.repLabel
  }, t('Birth Date', 'জন্মতারিখ')), /*#__PURE__*/React.createElement(Typography, {
    className: classes.repValue
  }, factory.workforceRepresentative.birthDate || "N/A")))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 6
  }, /*#__PURE__*/React.createElement(Box$1, {
    className: classes.repField
  }, /*#__PURE__*/React.createElement(Box$1, {
    className: classes.repText
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.repLabel
  }, t('Passport Number', 'পাসপোর্ট নম্বর')), /*#__PURE__*/React.createElement(Typography, {
    className: classes.repValue
  }, factory.workforceRepresentative.passportNo || "N/A")))))))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(Card, {
    className: classes.card
  }, /*#__PURE__*/React.createElement(CardHeader, {
    className: classes.cardHeader,
    title: /*#__PURE__*/React.createElement(Typography, {
      className: classes.cardTitle
    }, /*#__PURE__*/React.createElement(DescriptionIcon, {
      style: {
        marginRight: "8px",
        verticalAlign: "middle"
      }
    }), t('Uploaded Documents', 'আপলোড করা নথি'))
  }), /*#__PURE__*/React.createElement(CardContent, null, fetchingDocuments ? /*#__PURE__*/React.createElement(Box$1, {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "200px"
  }, /*#__PURE__*/React.createElement(CircularProgress$1, null)) : documents && documents.length > 0 ? /*#__PURE__*/React.createElement(Table$2, null, /*#__PURE__*/React.createElement(TableHead, null, /*#__PURE__*/React.createElement(TableRow, {
    style: {
      backgroundColor: "#f5f5f5"
    }
  }, /*#__PURE__*/React.createElement(TableCell, {
    style: {
      fontWeight: "bold"
    }
  }, t('Document Type', 'নথির ধরন')), /*#__PURE__*/React.createElement(TableCell, {
    style: {
      fontWeight: "bold"
    }
  }, t('File Name', 'ফাইলের নাম')), /*#__PURE__*/React.createElement(TableCell, {
    style: {
      fontWeight: "bold"
    }
  }, t('File Type', 'ফাইলের ধরন')), /*#__PURE__*/React.createElement(TableCell, {
    style: {
      fontWeight: "bold"
    }
  }, t('Status', 'অবস্থা')), /*#__PURE__*/React.createElement(TableCell, {
    style: {
      fontWeight: "bold",
      textAlign: "center"
    }
  }, t('Action', 'কর্ম')))), /*#__PURE__*/React.createElement(TableBody, null, documents.map(function (doc, index) {
    var _doc$workforceDocumen, _doc$workforceDocumen2, _doc$path, _doc$status, _doc$status2, _doc$status3;
    return /*#__PURE__*/React.createElement(TableRow, {
      key: index,
      className: classes.documentRow
    }, /*#__PURE__*/React.createElement(TableCell, null, /*#__PURE__*/React.createElement(Box$1, {
      display: "flex",
      alignItems: "center"
    }, /*#__PURE__*/React.createElement(DescriptionIcon, {
      className: classes.documentIcon
    }), /*#__PURE__*/React.createElement(Box$1, null, /*#__PURE__*/React.createElement(Typography, {
      variant: "body2",
      style: {
        fontWeight: "bold"
      }
    }, ((_doc$workforceDocumen = doc.workforceDocumentType) === null || _doc$workforceDocumen === void 0 ? void 0 : _doc$workforceDocumen.nameEn) || 'Document'), /*#__PURE__*/React.createElement(Typography, {
      variant: "caption",
      color: "textSecondary"
    }, (_doc$workforceDocumen2 = doc.workforceDocumentType) === null || _doc$workforceDocumen2 === void 0 ? void 0 : _doc$workforceDocumen2.nameBn)))), /*#__PURE__*/React.createElement(TableCell, null, /*#__PURE__*/React.createElement(Typography, {
      variant: "body2"
    }, ((_doc$path = doc.path) === null || _doc$path === void 0 ? void 0 : _doc$path.split('/').pop()) || 'Document'), /*#__PURE__*/React.createElement(Typography, {
      variant: "caption",
      color: "textSecondary"
    }, t('Uploaded', 'আপলোড করা হয়েছে'))), /*#__PURE__*/React.createElement(TableCell, null, /*#__PURE__*/React.createElement(Typography, {
      variant: "body2"
    }, formatLabel(doc.documentType) || '--')), /*#__PURE__*/React.createElement(TableCell, null, /*#__PURE__*/React.createElement(Chip, {
      size: "small",
      label: ((_doc$status = doc.status) === null || _doc$status === void 0 ? void 0 : _doc$status.toUpperCase()) || 'PENDING',
      color: ((_doc$status2 = doc.status) === null || _doc$status2 === void 0 ? void 0 : _doc$status2.toLowerCase()) === 'approved' ? 'primary' : ((_doc$status3 = doc.status) === null || _doc$status3 === void 0 ? void 0 : _doc$status3.toLowerCase()) === 'rejected' ? 'secondary' : 'default',
      variant: "outlined"
    })), /*#__PURE__*/React.createElement(TableCell, {
      align: "center"
    }, /*#__PURE__*/React.createElement(Tooltip, {
      title: t('Download Document', 'নথি ডাউনলোড করুন')
    }, /*#__PURE__*/React.createElement(Button, {
      size: "small",
      color: "primary",
      onClick: function onClick() {
        return handleDownloadDocument(doc);
      },
      disabled: !doc.url,
      className: classes.downloadBtn
    }, locale === 'fr' ? 'নথিটি দেখুন' : 'See Document'))));
  }))) : /*#__PURE__*/React.createElement(Box$1, {
    className: classes.noDocuments
  }, /*#__PURE__*/React.createElement(DescriptionIcon, {
    style: {
      fontSize: "3rem",
      marginBottom: "16px",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement(Typography, {
    variant: "body2"
  }, t('No documents uploaded for this factory', 'এই ফ্যাক্টরির জন্য কোনো নথি আপলোড করা হয়নি'))))))), /*#__PURE__*/React.createElement(Dialog$1, {
    open: approveDialog,
    onClose: function onClose() {
      return setApproveDialog(false);
    },
    maxWidth: "sm",
    fullWidth: true
  }, /*#__PURE__*/React.createElement(DialogTitle, null, t('Confirm Approval', 'অনুমোদন নিশ্চিত করুন')), /*#__PURE__*/React.createElement(DialogContent$1, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    gutterBottom: true
  }, t('Are you sure you want to approve this factory?', 'আপনি কি এই ফ্যাক্টরি অনুমোদন করতে নিশ্চিত?')), /*#__PURE__*/React.createElement(Typography, {
    variant: "body1",
    style: {
      fontWeight: "bold"
    }
  }, factory.nameEn), /*#__PURE__*/React.createElement(Typography, {
    variant: "caption",
    color: "textSecondary"
  }, t('This action will change the factory status to "active".', 'এই পদক্ষেপটি ফ্যাক্টরির অবস্থা "সক্রিয়" এ পরিবর্তন করবে।'))), /*#__PURE__*/React.createElement(DialogActions$1, null, /*#__PURE__*/React.createElement(Button, {
    onClick: function onClick() {
      return setApproveDialog(false);
    }
  }, t('Cancel', 'বাতিল করুন')), /*#__PURE__*/React.createElement(Button, {
    onClick: handleApprove,
    color: "primary",
    variant: "contained",
    disabled: isApproving
  }, isApproving ? t('Approving...', 'অনুমোদন করছে...') : t('Confirm', 'নিশ্চিত করুন')))));
};
var WorkforceFactoryViewPage$1 = withModulesManager(withHistory(WorkforceFactoryViewPage));

function _callSuper$V(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$V() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$V() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$V = function _isNativeReflectConstruct() { return !!t; })(); }
var styles$S = function styles(theme) {
  return {
    dialogTitle: theme.dialog.title,
    dialogContent: theme.dialog.content,
    form: {
      padding: 0
    },
    item: {
      padding: theme.spacing(1)
    },
    paperDivider: theme.paper.divider
  };
};
var WORKFORCE_EMPLOYEE_FILTER_CONTRIBUTION_KEY = "workforce.employee.Filter";
var WorkforceEmployeeFilter = /*#__PURE__*/function (_Component) {
  function WorkforceEmployeeFilter() {
    var _this;
    _classCallCheck(this, WorkforceEmployeeFilter);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper$V(this, WorkforceEmployeeFilter, [].concat(args));
    _defineProperty(_this, "debouncedOnChangeFilter", _debounce(_this.props.onChangeFilters, 800));
    _defineProperty(_this, "_filterValue", function (k) {
      var filters = _this.props.filters;
      return !!filters && !!filters[k] ? filters[k].value : null;
    });
    _defineProperty(_this, "_onChangeReporter", function (k, v) {
      _this.props.onChangeFilters([{
        id: k,
        value: v,
        filter: "".concat(k, ": \"").concat(decodeId(v === null || v === void 0 ? void 0 : v.id), "\"")
      }]);
    });
    _defineProperty(_this, "_onChangeCheckbox", function (key, value) {
      var filters = [{
        id: key,
        value: value,
        filter: "".concat(key, ": ").concat(value)
      }];
      _this.props.onChangeFilters(filters);
      _this.props.setShowHistoryFilter(value);
    });
    return _this;
  }
  _inherits(WorkforceEmployeeFilter, _Component);
  return _createClass(WorkforceEmployeeFilter, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        classes = _this$props.classes,
        filters = _this$props.filters,
        onChangeFilters = _this$props.onChangeFilters;
      return /*#__PURE__*/React.createElement(Grid, {
        container: true,
        className: classes.form
      }, /*#__PURE__*/React.createElement(ControlledField, {
        module: MODULE_NAME,
        id: "workforce.employee.first.name.en",
        field: /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 3,
          className: classes.item
        }, /*#__PURE__*/React.createElement(TextInput, {
          module: MODULE_NAME,
          label: "workforce.employee.first.name.en",
          name: "firstNameEn",
          value: this._filterValue("firstNameEn"),
          onChange: function onChange(v) {
            return _this2.debouncedOnChangeFilter([{
              id: "firstNameEn",
              value: v,
              filter: "nameEn_Icontains: \"".concat(v, "\"")
            }]);
          }
        }))
      }), /*#__PURE__*/React.createElement(ControlledField, {
        module: MODULE_NAME,
        id: "workforce.employee.first.name.bn",
        field: /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 3,
          className: classes.item
        }, /*#__PURE__*/React.createElement(TextInput, {
          module: MODULE_NAME,
          label: "workforce.employee.first.name.bn",
          name: "firstNameBn",
          value: this._filterValue("firstNameBn"),
          onChange: function onChange(v) {
            return _this2.debouncedOnChangeFilter([{
              id: "firstNameBn",
              value: v,
              filter: "firstNameBn_Icontains: \"".concat(v, "\"")
            }]);
          }
        }))
      }), /*#__PURE__*/React.createElement(ControlledField, {
        module: MODULE_NAME,
        id: "workforce.employee.nid",
        field: /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 3,
          className: classes.item
        }, /*#__PURE__*/React.createElement(TextInput, {
          module: MODULE_NAME,
          label: "workforce.employee.nid",
          name: "address",
          value: this._filterValue("nid"),
          onChange: function onChange(v) {
            return _this2.debouncedOnChangeFilter([{
              id: "nid",
              value: v,
              filter: "nid: \"".concat(v, "\"")
            }]);
          }
        }))
      }), /*#__PURE__*/React.createElement(ControlledField, {
        module: MODULE_NAME,
        id: "workforce.employee.phone",
        field: /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 3,
          className: classes.item
        }, /*#__PURE__*/React.createElement(TextInput, {
          module: MODULE_NAME,
          label: "workforce.employee.phone",
          name: "address",
          value: this._filterValue("phoneNumber"),
          onChange: function onChange(v) {
            return _this2.debouncedOnChangeFilter([{
              id: "phoneNumber",
              value: v,
              filter: "phoneNumber: \"".concat(v, "\"")
            }]);
          }
        }))
      }), /*#__PURE__*/React.createElement(Contributions, {
        filters: filters,
        onChangeFilters: onChangeFilters,
        contributionKey: WORKFORCE_EMPLOYEE_FILTER_CONTRIBUTION_KEY
      }));
    }
  }]);
}(Component);
var WorkforceEmployeeFilter$1 = withModulesManager(withTheme(withStyles(styles$S)(WorkforceEmployeeFilter)));

function _callSuper$U(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$U() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$U() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$U = function _isNativeReflectConstruct() { return !!t; })(); }
function ownKeys$1y(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$1y(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$1y(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1y(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var styles$R = function styles(theme) {
  return {
    paper: _objectSpread$1y(_objectSpread$1y({}, theme.paper.paper), {}, {
      margin: 0
    }),
    paperHeader: _objectSpread$1y(_objectSpread$1y({}, theme.paper.header), {}, {
      padding: 10
    }),
    tableTitle: theme.table.title,
    fab: theme.fab,
    button: {
      margin: theme.spacing(1)
    },
    item: {
      padding: theme.spacing(1)
    },
    horizontalButtonContainer: _objectSpread$1y(_objectSpread$1y({}, theme.buttonContainer.horizontal), {}, {
      display: "flex",
      alignItems: "center",
      gap: theme.spacing(1)
    }),
    compactButton: {
      maxHeight: "30px",
      minWidth: "80px",
      padding: "1px 4px",
      borderRadius: "6px",
      backgroundColor: "#006273",
      color: "white",
      fontSize: "0.7rem",
      textTransform: "none",
      marginRight: "2px",
      "&:hover": {
        backgroundColor: "#004a5e"
      }
    },
    buttonContainer: {
      display: "flex",
      gap: theme.spacing(1)
    }
  };
};
var WorkforceEmployeeSearcher = /*#__PURE__*/function (_Component) {
  function WorkforceEmployeeSearcher(props) {
    var _this;
    _classCallCheck(this, WorkforceEmployeeSearcher);
    _this = _callSuper$U(this, WorkforceEmployeeSearcher, [props]);
    _defineProperty(_this, "fetch", /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(prms) {
        var showHistoryFilter, loggedInUserId;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              showHistoryFilter = _this.state.showHistoryFilter;
              loggedInUserId = _this.props.loggedInUserId;
              _this.setState({
                displayVersion: showHistoryFilter
              });
              _this.props.fetchFactoryEmployee(_this.props.modulesManager, ["relatedUser_Id: \"".concat(encodeId(_this.props.modulesManager, "InteractiveUserGQLType", loggedInUserId), "\"")]).then(function (res) {
                var _res$payload, _edges$, _factoryId$id;
                var edges = (res === null || res === void 0 || (_res$payload = res.payload) === null || _res$payload === void 0 || (_res$payload = _res$payload.data) === null || _res$payload === void 0 || (_res$payload = _res$payload.workforceEmployerEmployees) === null || _res$payload === void 0 ? void 0 : _res$payload.edges) || [];
                var node = (_edges$ = edges[0]) === null || _edges$ === void 0 ? void 0 : _edges$.node;
                var factoryId = (node === null || node === void 0 ? void 0 : node.workforceFactory) || null;
                _this.props.fetchWorkforceEmployeesSummary(_this.props.modulesManager, ["workforceFactoryId:\"".concat((_factoryId$id = factoryId === null || factoryId === void 0 ? void 0 : factoryId.id) !== null && _factoryId$id !== void 0 ? _factoryId$id : "", "\"")]);
              });
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
    _defineProperty(_this, "rowIdentifier", function (r) {
      return r.uuid;
    });
    _defineProperty(_this, "isShowHistory", function () {
      return _this.state.displayVersion;
    });
    _defineProperty(_this, "filtersToQueryParams", function (state) {
      var prms = Object.keys(state.filters).filter(function (f) {
        return !!state.filters[f].filter;
      }).map(function (f) {
        return state.filters[f].filter;
      });
      prms.push("first: ".concat(state.pageSize));
      if (state.afterCursor) {
        prms.push("after: \"".concat(state.afterCursor, "\""));
      }
      if (state.beforeCursor) {
        prms.push("before: \"".concat(state.beforeCursor, "\""));
      }
      if (state.orderBy) {
        prms.push("orderBy: [\"".concat(state.orderBy, "\"]"));
      }
      return prms;
    });
    _defineProperty(_this, "headers", function () {
      return ["workforce.employee.first.name.en", "workforce.employee.first.name.bn", "workforce.employee.nid", "workforce.employee.phone", "workforce.employee.email", _this.isShowHistory() ? "workforce.version" : ""];
    });
    _defineProperty(_this, "sorts", function () {
      return [];
    });
    _defineProperty(_this, "itemFormatters", function () {
      var formatters = [function (workforceemployee) {
        return workforceemployee.firstNameEn;
      }, function (workforceemployee) {
        return workforceemployee.firstNameBn;
      }, function (workforceemployee) {
        return workforceemployee.nid;
      }, function (workforceemployee) {
        return workforceemployee.phoneNumber;
      }, function (workforceemployee) {
        return workforceemployee.email;
      }, function (workforceemployee) {
        return _this.isShowHistory() ? workforceemployee === null || workforceemployee === void 0 ? void 0 : workforceemployee.version : null;
      }];
      formatters.push(function (workforceemployee) {
        return /*#__PURE__*/React.createElement("div", {
          className: _this.props.classes.horizontalButtonContainer
        }, /*#__PURE__*/React.createElement(Tooltip, {
          title: "Edit"
        }, /*#__PURE__*/React.createElement(IconButton, {
          disabled: workforceemployee === null || workforceemployee === void 0 ? void 0 : workforceemployee.isHistory,
          onClick: function onClick() {
            historyPush$1(_this.props.modulesManager, _this.props.history, "workforce.route.employees.employee", [decodeId(workforceemployee.id)], false);
          }
        }, /*#__PURE__*/React.createElement(EditIcon, null))), /*#__PURE__*/React.createElement(Tooltip, {
          title: "Account Info"
        }, /*#__PURE__*/React.createElement(IconButton, {
          disabled: workforceemployee === null || workforceemployee === void 0 ? void 0 : workforceemployee.isHistory,
          onClick: function onClick() {
            historyPush$1(_this.props.modulesManager, _this.props.history, "workforce.route.employees.account.infos", [decodeId(workforceemployee.id)], false);
          }
        }, /*#__PURE__*/React.createElement(AccountBoxIcon, null))), /*#__PURE__*/React.createElement(Tooltip, {
          title: "Accident Info"
        }, /*#__PURE__*/React.createElement(Button, {
          className: _this.props.classes.compactButton,
          disabled: workforceemployee === null || workforceemployee === void 0 ? void 0 : workforceemployee.isHistory,
          onClick: function onClick() {
            historyPush$1(_this.props.modulesManager, _this.props.history, "workforce.route.employees.accident.infos", [decodeId(workforceemployee.id)], false);
          }
        }, "Accident Info")), /*#__PURE__*/React.createElement(Tooltip, {
          title: "Services"
        }, /*#__PURE__*/React.createElement(Button, {
          className: _this.props.classes.compactButton,
          disabled: workforceemployee === null || workforceemployee === void 0 ? void 0 : workforceemployee.isHistory,
          onClick: function onClick() {
            historyPush$1(_this.props.modulesManager, _this.props.history, "workforce.route.employees.services", [decodeId(workforceemployee.id)], false);
          }
        }, "Services")), /*#__PURE__*/React.createElement(Tooltip, {
          title: "Dependent"
        }, /*#__PURE__*/React.createElement(Button, {
          className: _this.props.classes.compactButton,
          disabled: workforceemployee === null || workforceemployee === void 0 ? void 0 : workforceemployee.isHistory,
          onClick: function onClick() {
            historyPush$1(_this.props.modulesManager, _this.props.history, "workforce.route.employees.dependents", [decodeId(workforceemployee.id)], false);
          }
        }, "Dependent")));
      });
      return formatters;
    });
    _defineProperty(_this, "rowDisabled", function (selection, i) {
      return !!i.validityTo;
    });
    _defineProperty(_this, "rowLocked", function (selection, i) {
      return !!i.clientMutationId;
    });
    _this.state = {
      chfid: null,
      confirmedAction: null,
      reset: 0,
      showHistoryFilter: false,
      displayVersion: false
    };
    _this.rowsPerPageOptions = [10, 20, 50, 100];
    _this.defaultPageSize = 10;
    return _this;
  }
  _inherits(WorkforceEmployeeSearcher, _Component);
  return _createClass(WorkforceEmployeeSearcher, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState, snapshot) {
      if (prevProps.submittingMutation && !this.props.submittingMutation) {
        this.props.journalize(this.props.mutation);
        this.setState({
          reset: prevState.reset + 1
        });
      } else if (!prevProps.confirmed && this.props.confirmed) {
        this.state.confirmedAction();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props;
        _this$props.intl;
        var workforceEmployees = _this$props.workforceEmployees,
        workforceEmployeesPageInfo = _this$props.workforceEmployeesPageInfo,
        fetchingWorkforceEmployees = _this$props.fetchingWorkforceEmployees,
        fetchedWorkforceEmployees = _this$props.fetchedWorkforceEmployees,
        errorWorkforceEmployees = _this$props.errorWorkforceEmployees,
        filterPaneContributionsKey = _this$props.filterPaneContributionsKey,
        cacheFiltersKey = _this$props.cacheFiltersKey,
        _onDoubleClick = _this$props.onDoubleClick;
      console.log({
        workforceEmployees: workforceEmployees
      });
      workforceEmployeesPageInfo.totalCount;
      var filterPane = function filterPane(_ref2) {
        var filters = _ref2.filters,
          onChangeFilters = _ref2.onChangeFilters;
        return /*#__PURE__*/React.createElement(WorkforceEmployeeFilter$1, {
          filters: filters,
          onChangeFilters: onChangeFilters,
          setShowHistoryFilter: function setShowHistoryFilter(showHistoryFilter) {
            return _this2.setState({
              showHistoryFilter: showHistoryFilter
            });
          }
        });
      };
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Searcher$2, {
        module: MODULE_NAME,
        cacheFiltersKey: cacheFiltersKey,
        FilterPane: filterPane,
        filterPaneContributionsKey: filterPaneContributionsKey,
        items: workforceEmployees,
        itemsPageInfo: workforceEmployeesPageInfo,
        fetchingItems: fetchingWorkforceEmployees,
        fetchedItems: fetchedWorkforceEmployees,
        errorItems: errorWorkforceEmployees,
        tableTitle: /*#__PURE__*/React.createElement(FormattedMessage, {
          module: MODULE_NAME,
          id: "menu.workforce.employee"
        }),
        rowsPerPageOptions: this.rowsPerPageOptions,
        defaultPageSize: this.defaultPageSize,
        fetch: this.fetch,
        rowIdentifier: this.rowIdentifier,
        filtersToQueryParams: this.filtersToQueryParams,
        defaultOrderBy: "-dateCreated",
        headers: this.headers,
        itemFormatters: this.itemFormatters,
        sorts: this.sorts,
        rowDisabled: this.rowDisabled,
        rowLocked: this.rowLocked,
        onDoubleClick: function onDoubleClick(i) {
          return !i.clientMutationId && _onDoubleClick(i);
        },
        reset: this.state.reset
      }));
    }
  }]);
}(Component);
var mapStateToProps$O = function mapStateToProps(state) {
  var _state$core;
  return {
    rights: !!state.core && !!state.core.user && !!state.core.user.i_user ? state.core.user.i_user.rights : [],
    workforceEmployees: state.workforce.workforceEmployees,
    workforceEmployeesPageInfo: state.workforce.workforceEmployeesPageInfo,
    fetchingWorkforceEmployees: state.workforce.fetchingWorkforceEmployees,
    fetchedWorkforceEmployees: state.workforce.fetchedWorkforceEmployees,
    errorWorkforceEmployees: state.workforce.errorWorkforceEmployees,
    submittingMutation: state.workforce.submittingMutation,
    mutation: state.workforce.mutation,
    confirmed: state.core.confirmed,
    loggedInUserId: (_state$core = state.core) === null || _state$core === void 0 || (_state$core = _state$core.user) === null || _state$core === void 0 || (_state$core = _state$core.i_user) === null || _state$core === void 0 ? void 0 : _state$core.id
  };
};
var mapDispatchToProps$t = function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    fetchFactoryEmployee: fetchFactoryEmployee,
    fetchWorkforceEmployeesSummary: fetchWorkforceEmployeesSummary,
    journalize: journalize,
    coreConfirm: coreConfirm
  }, dispatch);
};
var WorkforceEmployeeSearcher$1 = withModulesManager(withHistory(connect(mapStateToProps$O, mapDispatchToProps$t)(withTheme(withStyles(styles$R)(WorkforceEmployeeSearcher)))));

function _callSuper$T(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$T() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$T() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$T = function _isNativeReflectConstruct() { return !!t; })(); }
var styles$Q = function styles(theme) {
  return {
    page: theme.page,
    fab: theme.fab,
    ROUTE_WORKFORCE_EMPLOYEES_EMPLOYEE: ROUTE_WORKFORCE_EMPLOYEES_EMPLOYEE
  };
};
var WorkforceEmployeesPage = /*#__PURE__*/function (_Component) {
  function WorkforceEmployeesPage() {
    var _this;
    _classCallCheck(this, WorkforceEmployeesPage);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper$T(this, WorkforceEmployeesPage, [].concat(args));
    _defineProperty(_this, "onDoubleClick", function (employee) {
      var newTab = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var routeParams = ["workforce.route.employees.employee", [decodeId(employee.id)]];
      if (employee !== null && employee !== void 0 && employee.isHistory) {
        routeParams[1].push(employee.version);
      }
      historyPush$1.apply(void 0, [_this.props.modulesManager, _this.props.history].concat(routeParams, [newTab]));
    });
    _defineProperty(_this, "onAdd", function () {
      historyPush$1(_this.props.modulesManager, _this.props.history, "workforce.route.employees.employee");
    });
    return _this;
  }
  _inherits(WorkforceEmployeesPage, _Component);
  return _createClass(WorkforceEmployeesPage, [{
    key: "render",
    value: function render() {
      var _this$props = this.props;
        _this$props.intl;
        var classes = _this$props.classes;
        _this$props.rights;
      return /*#__PURE__*/React.createElement("div", {
        className: classes.page
      }, /*#__PURE__*/React.createElement(WorkforceEmployeeSearcher$1, {
        cacheFiltersKey: "ticketPageFiltersCache",
        onDoubleClick: this.onDoubleClick
      }), withTooltip(/*#__PURE__*/React.createElement("div", {
        className: classes.fab
      }, /*#__PURE__*/React.createElement(Fab, {
        color: "primary",
        onClick: this.onAdd
      }, /*#__PURE__*/React.createElement(AddIcon, null))), /*#__PURE__*/React.createElement(FormattedMessage, {
        module: MODULE_NAME,
        id: "workforce.employee.addNewTooltip"
      })));
    }
  }]);
}(Component);
var mapStateToProps$N = function mapStateToProps(state) {
  return {
    rights: !!state.core && !!state.core.user && !!state.core.user.i_user ? state.core.user.i_user.rights : [],
    userType: getUserTypeFromRights(state.core.user.i_user.rights)
  };
};
var WorkforceEmployeesPage$1 = withModulesManager(withHistory(connect(mapStateToProps$N)(withTheme(withStyles(styles$Q)(WorkforceEmployeesPage)))));

var EmployeeLifeStatusPicker = function EmployeeLifeStatusPicker(_ref) {
  _ref.modulesManager;
    var _onChange = _ref.onChange,
    readOnly = _ref.readOnly,
    required = _ref.required,
    _ref$withLabel = _ref.withLabel,
    withLabel = _ref$withLabel === void 0 ? true : _ref$withLabel,
    withPlaceholder = _ref.withPlaceholder,
    value = _ref.value,
    label = _ref.label,
    placeholder = _ref.placeholder,
    filterOptions = _ref.filterOptions,
    filterSelectedOptions = _ref.filterSelectedOptions;
    _ref.multiple;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2);
    _useState2[0];
    var setSearchString = _useState2[1];
  var _useTranslations = useTranslations("workforce"),
    formatMessage = _useTranslations.formatMessage;

  // Adjust the options to match the EMPLOYEE_LIFE_STATUS format
  var EMPLOYEE_LIFE_STATUS = ["Alive", "Deceased"];

  // Find the selected option
  var selectedOption = useMemo(function () {
    return EMPLOYEE_LIFE_STATUS.includes(value) ? value : null;
  }, [value]);
  return /*#__PURE__*/React.createElement(Autocomplete, {
    multiple: false,
    required: required,
    placeholder: placeholder !== null && placeholder !== void 0 ? placeholder : "",
    label: label !== null && label !== void 0 ? label : formatMessage("workforce.employee.lifeStatus"),
    withLabel: withLabel,
    withPlaceholder: withPlaceholder,
    readOnly: readOnly,
    isLoading: false // Set to false if not loading data dynamically
    ,
    options: EMPLOYEE_LIFE_STATUS,
    value: selectedOption,
    getOptionLabel: function getOptionLabel(option) {
      return option;
    } // Since options are strings, return the string directly
    ,
    onChange: function onChange(option) {
      return _onChange(option, option !== null && option !== void 0 ? option : null);
    },
    filterOptions: filterOptions,
    filterSelectedOptions: filterSelectedOptions,
    onInputChange: setSearchString
  });
};

var EmployeeMaritalStatusPicker = function EmployeeMaritalStatusPicker(_ref) {
  var id = _ref.id;
    _ref.modulesManager;
    var _onChange = _ref.onChange,
    readOnly = _ref.readOnly,
    required = _ref.required,
    _ref$withLabel = _ref.withLabel,
    withLabel = _ref$withLabel === void 0 ? true : _ref$withLabel,
    withPlaceholder = _ref.withPlaceholder,
    value = _ref.value,
    label = _ref.label,
    placeholder = _ref.placeholder,
    filterOptions = _ref.filterOptions,
    filterSelectedOptions = _ref.filterSelectedOptions;
    _ref.multiple;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2);
    _useState2[0];
    var setSearchString = _useState2[1];
  var _useTranslations = useTranslations("workforce"),
    formatMessage = _useTranslations.formatMessage;

  // Adjust the options to match the EMPLOYEE_MARITAL_STATUS format
  var EMPLOYEE_MARITAL_STATUS = ["workforce.marital_status.single", "workforce.marital_status.married", "workforce.marital_status.widow", "workforce.marital_status.widower"
  // "workforce.marital_status.remarried"
  ];

  // Find the selected option
  var selectedOption = useMemo(function () {
    return EMPLOYEE_MARITAL_STATUS.includes(value) ? value : null;
  }, [value]);
  return /*#__PURE__*/React.createElement(Autocomplete, {
    id: id,
    multiple: false,
    required: required,
    placeholder: placeholder !== null && placeholder !== void 0 ? placeholder : "",
    label: label !== null && label !== void 0 ? label : formatMessage("workforce.employee.marital_status"),
    withLabel: withLabel,
    withPlaceholder: withPlaceholder,
    readOnly: readOnly,
    isLoading: false // Set to false if not loading data dynamically
    ,
    options: EMPLOYEE_MARITAL_STATUS,
    value: selectedOption,
    getOptionLabel: function getOptionLabel(option) {
      return formatMessage(option);
    } // Since options are strings, return the string directly
    ,
    onChange: function onChange(option) {
      return _onChange(option, option !== null && option !== void 0 ? option : null);
    },
    filterOptions: filterOptions,
    filterSelectedOptions: filterSelectedOptions,
    onInputChange: setSearchString
  });
};

function ownKeys$1x(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$1x(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$1x(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1x(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper$S(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$S() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$S() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$S = function _isNativeReflectConstruct() { return !!t; })(); }
var styles$P = function styles(theme) {
  return {
    paper: theme.paper.paper,
    tableTitle: theme.table.title,
    item: theme.paper.item,
    fullHeight: {
      height: "100%"
    }
  };
};
var EditWorkforceEmployeePage = /*#__PURE__*/function (_Component) {
  function EditWorkforceEmployeePage(props) {
    var _this;
    _classCallCheck(this, EditWorkforceEmployeePage);
    _this = _callSuper$S(this, EditWorkforceEmployeePage, [props]);
    _defineProperty(_this, "updateAttribute", function (key, value) {
      _this.setState(function (prevState) {
        return {
          stateEdited: _objectSpread$1x(_objectSpread$1x({}, prevState.stateEdited), {}, _defineProperty({}, key, value)),
          isSaved: false
        };
      });
    });
    _defineProperty(_this, "save", function () {
      var _stateEdited$gender;
      var _this$props = _this.props;
        _this$props.grievanceConfig;
        var dispatch = _this$props.dispatch;
      var stateEdited = _this.state.stateEdited;
      var workforceEmployeeData = {
        company: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.company.id) || stateEdited.company.id,
        factory: decodeId(stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.factory.id) || decodeId(stateEdited.factory.id),
        firstNameBn: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.firstNameBn) || stateEdited.firstNameBn,
        lastNameBn: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.lastNameBn) || stateEdited.lastNameBn,
        otherName: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.otherName) || stateEdited.otherName,
        firstNameEn: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.firstNameEn) || stateEdited.firstNameEn,
        lastNameEn: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.lastNameEn) || stateEdited.lastNameEn,
        phoneNumber: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.phoneNumber) || stateEdited.phoneNumber,
        email: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.email) || stateEdited.email,
        gender: (stateEdited === null || stateEdited === void 0 || (_stateEdited$gender = stateEdited.gender) === null || _stateEdited$gender === void 0 ? void 0 : _stateEdited$gender.id) || stateEdited.gender.id,
        birthDate: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.birthDate) || stateEdited.birthDate,
        joinDate: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.joinDate) || stateEdited.joinDate,
        deathDate: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.deathDate) || stateEdited.deathDate,
        employeeType: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.employeeType) || stateEdited.employeeType,
        lifeStatus: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.lifeStatus) || stateEdited.lifeStatus,
        permanentAddress: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.permanentAddress) || stateEdited.permanentAddress,
        presentAddress: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.presentAddress) || stateEdited.presentAddress,
        position: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.position) || stateEdited.position,
        monthlyEarning: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.monthlyEarning) || stateEdited.monthlyEarning,
        fatherNameBn: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.fatherNameBn) || stateEdited.fatherNameBn,
        fatherNameEn: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.fatherNameEn) || stateEdited.fatherNameEn,
        motherNameBn: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.motherNameBn) || stateEdited.motherNameBn,
        motherNameEn: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.motherNameEn) || stateEdited.motherNameEn,
        spouseNameBn: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.spouseNameBn) || stateEdited.spouseNameBn,
        spouseNameEn: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.spouseNameEn) || stateEdited.spouseNameEn,
        insuranceNumber: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.insuranceNumber) || stateEdited.insuranceNumber,
        birthCertificateNo: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.birthCertificateNo) || stateEdited.birthCertificateNo,
        passportNo: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.passportNo) || stateEdited.passportNo,
        nid: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.nid) || stateEdited.nid,
        citizenship: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.citizenship) || stateEdited.citizenship,
        privacyLaw: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.privacyLaw) || stateEdited.privacyLaw,
        maritalStatus: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.maritalStatus) || stateEdited.maritalStatus,
        presentLocation: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.presentLocation) || stateEdited.presentLocation,
        permanentLocation: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.permanentLocation) || stateEdited.permanentLocation,
        id: stateEdited.id
      };
      dispatch(updateWorkforceEmployee(workforceEmployeeData, "Update Workforce Employee ".concat(workforceEmployeeData.nameEn)));
      _this.setState({
        isSaved: true
      });
    });
    _this.state = {
      stateEdited: props.workforceEmployee || {},
      isSaved: false
    };
    return _this;
  }
  _inherits(EditWorkforceEmployeePage, _Component);
  return _createClass(EditWorkforceEmployeePage, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.workforceEmployee !== this.props.workforceEmployee) {
        this.setState({
          stateEdited: this.props.workforceEmployee
        });
      }
      if (prevProps.submittingMutation && !this.props.submittingMutation) {
        this.props.dispatch(journalize(this.props.mutation));
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this,
        _stateEdited$company,
        _stateEdited$factory,
        _stateEdited$company2;
      var classes = this.props.classes;
      var _this$state = this.state,
        stateEdited = _this$state.stateEdited,
        isSaved = _this$state.isSaved;
      return /*#__PURE__*/React.createElement("div", {
        className: classes.page
      }, /*#__PURE__*/React.createElement(Grid, {
        container: true
      }, /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12
      }, /*#__PURE__*/React.createElement(Paper, {
        className: classes.paper
      }, /*#__PURE__*/React.createElement(Grid, {
        container: true,
        className: classes.tableTitle
      }, /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12,
        className: classes.tableTitle
      }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(FormattedMessage, {
        module: MODULE_NAME,
        id: "Workforce Employee",
        values: {
          label: EMPTY_STRING
        }
      })))), /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement(Grid, {
        container: true,
        className: classes.item
      }, /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.employee.nid",
        value: stateEdited.nid || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("nid", v);
        },
        type: "number",
        required: true,
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(PublishedComponent, {
        pubRef: "workforce.DatePicker",
        label: "workforce.employee.birthdate",
        value: stateEdited.birthDate || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("birthDate", v);
        },
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(CompanyPicker, {
        value: stateEdited === null || stateEdited === void 0 || (_stateEdited$company = stateEdited.company) === null || _stateEdited$company === void 0 ? void 0 : _stateEdited$company.id,
        label: /*#__PURE__*/React.createElement(FormattedMessage, {
          id: "workforce.employee.workforce_employer",
          module: "workforce"
        }),
        required: true,
        onChange: function onChange(v) {
          return _this2.updateAttribute("company", v);
        },
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(FactoryPicker, {
        value: stateEdited === null || stateEdited === void 0 || (_stateEdited$factory = stateEdited.factory) === null || _stateEdited$factory === void 0 ? void 0 : _stateEdited$factory.id,
        label: /*#__PURE__*/React.createElement(FormattedMessage, {
          id: "workforce.employee.workforce_factory",
          module: "workforce"
        }),
        companyId: stateEdited === null || stateEdited === void 0 || (_stateEdited$company2 = stateEdited.company) === null || _stateEdited$company2 === void 0 ? void 0 : _stateEdited$company2.id,
        required: true,
        onChange: function onChange(v) {
          return _this2.updateAttribute("factory", v);
        },
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(EmployeeLifeStatusPicker, {
        value: stateEdited.lifeStatus || "",
        label: /*#__PURE__*/React.createElement(FormattedMessage, {
          id: "workforce.employee.lifeStatus",
          module: "workforce"
        }),
        required: true,
        onChange: function onChange(v) {
          return _this2.updateAttribute("lifeStatus", v);
        },
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(PublishedComponent, {
        pubRef: "workforce.DatePicker",
        label: "workforce.employee.deathdate",
        value: stateEdited.deathDate || "",
        readOnly: stateEdited.lifeStatus === "Deceased" ? false : true,
        onChange: function onChange(v) {
          return _this2.updateAttribute("deathDate", v);
        }
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(EmployeeGenderPicker, {
        value: stateEdited.gender || "",
        label: /*#__PURE__*/React.createElement(FormattedMessage, {
          id: "workforce.employee.gender",
          module: "workforce"
        }),
        onChange: function onChange(v) {
          return _this2.updateAttribute("gender", v);
        },
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.employee.monthly_earning",
        value: stateEdited.monthlyEarning || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("monthlyEarning", v);
        },
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(PublishedComponent, {
        pubRef: "workforce.DatePicker",
        label: "workforce.employee.joindate",
        value: stateEdited.joinDate || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("joinDate", v);
        },
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.employee.first.name.en",
        value: stateEdited.firstNameEn || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("firstNameEn", v);
        },
        required: true,
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.employee.first.name.bn",
        value: stateEdited.firstNameBn || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("firstNameBn", v);
        },
        required: true,
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.employee.last.name.en",
        value: stateEdited.lastNameEn || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("lastNameEn", v);
        },
        required: true,
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.employee.last.name.bn",
        value: stateEdited.lastNameBn || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("lastNameBn", v);
        },
        required: true,
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.employee.other.name",
        value: stateEdited.otherName || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("otherName", v);
        },
        required: true,
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.employee.position",
        value: stateEdited.position || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("position", v);
        },
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.employee.fathers_name.en",
        value: stateEdited.fatherNameEn || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("fatherNameEn", v);
        },
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.employee.fathers_name.bn",
        value: stateEdited.fatherNameBn || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("fatherNameBn", v);
        },
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.employee.mothers_name.en",
        value: stateEdited.motherNameEn || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("motherNameEn", v);
        },
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.employee.mothers_name.bn",
        value: stateEdited.motherNameBn || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("motherNameBn", v);
        },
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.employee.spouse.name.en",
        value: stateEdited.spouseNameEn || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("spouseNameEn", v);
        },
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.employee.spouse.name.bn",
        value: stateEdited.spouseNameBn || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("spouseNameBn", v);
        },
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.employee.phone",
        value: stateEdited.phoneNumber || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("phoneNumber", v);
        },
        type: "number",
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.employee.email",
        value: stateEdited.email || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("email", v);
        },
        type: "email",
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.employee.citizenship",
        value: stateEdited.citizenship || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("citizenship", v);
        },
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.employee.privacyLaw",
        value: stateEdited.privacyLaw || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("privacyLaw", v);
        },
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.employee.birth_certificate_no",
        value: stateEdited.birthCertificateNo || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("birthCertificateNo", v);
        },
        type: "number",
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.employee.insurance_number",
        value: stateEdited.insuranceNumber || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("insuranceNumber", v);
        },
        required: true,
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.employee.passport_no",
        value: stateEdited.passportNo || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("passportNo", v);
        },
        type: "number",
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.employee.marital_status",
        value: stateEdited.maritalStatus || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("maritalStatus", v);
        },
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.employee.present_address",
        value: stateEdited.presentAddress || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("presentAddress", v);
        },
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.employee.permanent_address",
        value: stateEdited.permanentAddress || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("permanentAddress", v);
        },
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12,
        className: classes.item
      }, /*#__PURE__*/React.createElement("p", null, "Present Location"), /*#__PURE__*/React.createElement(PublishedComponent, {
        pubRef: "location.DetailedLocation",
        withNull: true,
        value: stateEdited.presentLocation || null,
        onChange: function onChange(presentLocation) {
          return _this2.updateAttribute("presentLocation", presentLocation);
        },
        readOnly: isSaved,
        required: true,
        split: true
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12,
        className: classes.item
      }, /*#__PURE__*/React.createElement("p", null, "Permanent Location"), /*#__PURE__*/React.createElement(PublishedComponent, {
        pubRef: "location.DetailedLocation",
        withNull: true,
        value: stateEdited.permanentLocation || null,
        onChange: function onChange(permanentLocation) {
          return _this2.updateAttribute("permanentLocation", permanentLocation);
        },
        readOnly: isSaved,
        required: true,
        split: true
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 11,
        className: classes.item
      }), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 1,
        className: classes.item
      }, /*#__PURE__*/React.createElement(IconButton, {
        variant: "contained",
        component: "label",
        color: "primary",
        onClick: this.save,
        disabled: isSaved
      }, /*#__PURE__*/React.createElement(Save, null)))), /*#__PURE__*/React.createElement(Divider, null)))));
    }
  }]);
}(Component);
var mapStateToProps$M = function mapStateToProps(state) {
  return {
    workforceEmployee: state.workforce.workforceEmployee
  };
};
var EditWorkforceEmployeePage$1 = connect(mapStateToProps$M)(withStyles(styles$P)(EditWorkforceEmployeePage));

function ownKeys$1w(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$1w(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$1w(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1w(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var styles$O = function styles(theme) {
  return {
    paper: theme.paper.paper,
    tableTitle: theme.table.title,
    item: theme.paper.item,
    fullHeight: {
      height: "100%"
    }
  };
};
var AddWorkforceEmployeePage = withStyles(styles$O)(function (_ref) {
  var _stateEdited$factory2, _workforceEmployee$wo2, _stateEdited$factory3, _workforceEmployee$wo3, _stateEdited$company, _workforceEmployee$wo4, _stateEdited$gender2;
  var classes = _ref.classes;
  var dispatch = useDispatch();
  var modulesManager = useModulesManager();
  useSelector(function (state) {
    return state.workforce.submittingMutation;
  });
  var workforceEmployee = useSelector(function (state) {
    return state.workforce.workforceEmployee;
  });
  useSelector(function (state) {
    return state.workforce.mutation;
  });
  var loggedInUserId = useSelector(function (state) {
    var _state$core;
    return (_state$core = state.core) === null || _state$core === void 0 || (_state$core = _state$core.user) === null || _state$core === void 0 || (_state$core = _state$core.i_user) === null || _state$core === void 0 ? void 0 : _state$core.id;
  });
  var _useState = useState({}),
    _useState2 = _slicedToArray(_useState, 2),
    stateEdited = _useState2[0],
    setStateEdited = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isSaved = _useState4[0],
    setIsSaved = _useState4[1];
  var _useState5 = useState(null),
    _useState6 = _slicedToArray(_useState5, 2);
    _useState6[0];
    var setWorkforceFactoryId = _useState6[1];
  useEffect(function () {
    var _loggedInUserId = {
        loggedInUserId: loggedInUserId
      },
      userId = _loggedInUserId.loggedInUserId;
    console.log({
      userId: userId
    });
    if (userId) {
      console.log({
        userId: userId
      });
      var filters = ["relatedUser_Id: \"".concat(safeDecodeId(userId), "\"")];
      console.log({
        filters: filters
      });
      dispatch(fetchFactoryEmployee(modulesManager, filters)).then(function (res) {
        var _res$payload, _edges$;
        var edges = (res === null || res === void 0 || (_res$payload = res.payload) === null || _res$payload === void 0 || (_res$payload = _res$payload.data) === null || _res$payload === void 0 || (_res$payload = _res$payload.workforceEmployerEmployees) === null || _res$payload === void 0 ? void 0 : _res$payload.edges) || [];
        var node = (_edges$ = edges[0]) === null || _edges$ === void 0 ? void 0 : _edges$.node;
        var factoryId = (node === null || node === void 0 ? void 0 : node.workforceFactory) || null;
        setWorkforceFactoryId(factoryId);
      });
    }
    return function () {
    };
    // toggleSecondaryCalendar()
  }, [loggedInUserId, modulesManager]);
  var save = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _stateEdited$factory, _workforceEmployee$wo, _stateEdited$gender;
      var workforceEmployeeData;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            workforceEmployeeData = {
              workforceFactoryId: safeDecodeId((_stateEdited$factory = stateEdited.factory) === null || _stateEdited$factory === void 0 ? void 0 : _stateEdited$factory.id) || safeDecodeId(workforceEmployee === null || workforceEmployee === void 0 || (_workforceEmployee$wo = workforceEmployee.workforceFactory) === null || _workforceEmployee$wo === void 0 ? void 0 : _workforceEmployee$wo.id) || null,
              firstNameBn: stateEdited.firstNameBn || null,
              firstNameEn: stateEdited.firstNameEn || null,
              phoneNumber: stateEdited.phoneNumber || null,
              email: stateEdited.email || null,
              gender: ((_stateEdited$gender = stateEdited.gender) === null || _stateEdited$gender === void 0 ? void 0 : _stateEdited$gender.id) || null,
              birthDate: stateEdited.birthDate || null,
              permanentAddress: stateEdited.permanentAddress || null,
              presentAddress: stateEdited.presentAddress || null,
              monthlyEarning: stateEdited.monthlyEarning || null,
              fatherNameBn: stateEdited.fatherNameBn || null,
              fatherNameEn: stateEdited.fatherNameEn || null,
              motherNameBn: stateEdited.motherNameBn || null,
              motherNameEn: stateEdited.motherNameEn || null,
              spouseNameBn: stateEdited.spouseNameBn || null,
              spouseNameEn: stateEdited.spouseNameEn || null,
              nid: stateEdited.nid || null,
              roleId: 0
            };
            console.log({
              workforceEmployeeData: workforceEmployeeData
            });
            _context.next = 4;
            return dispatch(createWorkforceEmployee(workforceEmployeeData, "Created Workforce Employee ".concat(stateEdited.title)));
          case 4:
            setIsSaved(true);
            setTimeout(function () {
              window.location.reload();
            }, 2000);
          case 6:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function save() {
      return _ref2.apply(this, arguments);
    };
  }();
  var updateAttribute = function updateAttribute(key, value) {
    setStateEdited(function (prevState) {
      return _objectSpread$1w(_objectSpread$1w({}, prevState), {}, _defineProperty({}, key, value));
    });
    setIsSaved(false);
  };
  var isSaveDisabled = !stateEdited.nid || !stateEdited.firstNameEn || !stateEdited.firstNameBn || !stateEdited.phoneNumber || !((_stateEdited$factory2 = stateEdited.factory) !== null && _stateEdited$factory2 !== void 0 && _stateEdited$factory2.id || workforceEmployee !== null && workforceEmployee !== void 0 && (_workforceEmployee$wo2 = workforceEmployee.workforceFactory) !== null && _workforceEmployee$wo2 !== void 0 && _workforceEmployee$wo2.id);
  return /*#__PURE__*/React.createElement("div", {
    className: classes.page
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(Paper, {
    className: classes.paper
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    className: classes.tableTitle
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    className: classes.tableTitle
  }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: MODULE_NAME,
    id: "Workforce Employee",
    values: {
      label: EMPTY_STRING
    }
  })))), /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement(Grid, {
    container: true,
    className: classes.item
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6,
    className: classes.item
  }, /*#__PURE__*/React.createElement(TextInput, {
    label: "workforce.employee.nid",
    value: stateEdited.nid || "",
    onChange: function onChange(v) {
      return updateAttribute("nid", v);
    },
    type: "number",
    required: true,
    readOnly: isSaved
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6,
    className: classes.item
  }, /*#__PURE__*/React.createElement(FactoryPicker, {
    value: (stateEdited === null || stateEdited === void 0 || (_stateEdited$factory3 = stateEdited.factory) === null || _stateEdited$factory3 === void 0 ? void 0 : _stateEdited$factory3.id) || (workforceEmployee === null || workforceEmployee === void 0 || (_workforceEmployee$wo3 = workforceEmployee.workforceFactory) === null || _workforceEmployee$wo3 === void 0 ? void 0 : _workforceEmployee$wo3.id),
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.employee.workforce_factory",
      module: "workforce"
    }),
    required: true,
    companyId: stateEdited === null || stateEdited === void 0 || (_stateEdited$company = stateEdited.company) === null || _stateEdited$company === void 0 ? void 0 : _stateEdited$company.id,
    onChange: function onChange(v) {
      return updateAttribute("factory", v);
    },
    readOnly: (_workforceEmployee$wo4 = workforceEmployee === null || workforceEmployee === void 0 ? void 0 : workforceEmployee.workforceFactory) !== null && _workforceEmployee$wo4 !== void 0 ? _workforceEmployee$wo4 : isSaved
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6,
    className: classes.item
  }, /*#__PURE__*/React.createElement(TextInput, {
    label: "workforce.employee.first.name.en",
    value: stateEdited.firstNameEn || "",
    onChange: function onChange(v) {
      return updateAttribute("firstNameEn", v);
    },
    required: true,
    readOnly: isSaved
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6,
    className: classes.item
  }, /*#__PURE__*/React.createElement(TextInput, {
    label: "workforce.employee.first.name.bn",
    value: stateEdited.firstNameBn || "",
    onChange: function onChange(v) {
      return updateAttribute("firstNameBn", v);
    },
    required: true,
    readOnly: isSaved
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6,
    className: classes.item
  }, /*#__PURE__*/React.createElement(EmployeeGenderPicker, {
    value: stateEdited === null || stateEdited === void 0 || (_stateEdited$gender2 = stateEdited.gender) === null || _stateEdited$gender2 === void 0 ? void 0 : _stateEdited$gender2.id,
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.employee.gender",
      module: "workforce"
    }),
    onChange: function onChange(v) {
      return updateAttribute("gender", v);
    },
    readOnly: isSaved
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6,
    className: classes.item
  }, /*#__PURE__*/React.createElement(PublishedComponent, {
    pubRef: "workforce.DatePicker",
    label: "workforce.employee.birthdate",
    value: stateEdited.birthDate || "",
    onChange: function onChange(v) {
      return updateAttribute("birthDate", v);
    },
    readOnly: isSaved
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6,
    className: classes.item
  }, /*#__PURE__*/React.createElement(TextInput, {
    label: "workforce.employee.monthly_earning",
    value: stateEdited.monthlyEarning || "",
    onChange: function onChange(v) {
      return updateAttribute("monthlyEarning", v);
    }
    // required
    ,
    readOnly: isSaved
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6,
    className: classes.item
  }, /*#__PURE__*/React.createElement(TextInput, {
    label: "workforce.employee.fathers_name.en",
    value: stateEdited.fatherNameEn || "",
    onChange: function onChange(v) {
      return updateAttribute("fatherNameEn", v);
    },
    readOnly: isSaved
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6,
    className: classes.item
  }, /*#__PURE__*/React.createElement(TextInput, {
    label: "workforce.employee.fathers_name.bn",
    value: stateEdited.fatherNameBn || "",
    onChange: function onChange(v) {
      return updateAttribute("fatherNameBn", v);
    },
    readOnly: isSaved
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6,
    className: classes.item
  }, /*#__PURE__*/React.createElement(TextInput, {
    label: "workforce.employee.mothers_name.en",
    value: stateEdited.motherNameEn || "",
    onChange: function onChange(v) {
      return updateAttribute("motherNameEn", v);
    },
    readOnly: isSaved
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6,
    className: classes.item
  }, /*#__PURE__*/React.createElement(TextInput, {
    label: "workforce.employee.mothers_name.bn",
    value: stateEdited.motherNameBn || "",
    onChange: function onChange(v) {
      return updateAttribute("motherNameBn", v);
    },
    readOnly: isSaved
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6,
    className: classes.item
  }, /*#__PURE__*/React.createElement(TextInput, {
    label: "workforce.employee.spouse.name.en",
    value: stateEdited.spouseNameEn || "",
    onChange: function onChange(v) {
      return updateAttribute("spouseNameEn", v);
    },
    readOnly: isSaved
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6,
    className: classes.item
  }, /*#__PURE__*/React.createElement(TextInput, {
    label: "workforce.employee.spouse.name.bn",
    value: stateEdited.spouseNameBn || "",
    onChange: function onChange(v) {
      return updateAttribute("spouseNameBn", v);
    },
    readOnly: isSaved
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6,
    className: classes.item
  }, /*#__PURE__*/React.createElement(TextInput, {
    label: "workforce.employee.phone",
    value: stateEdited.phoneNumber || "",
    onChange: function onChange(v) {
      return updateAttribute("phoneNumber", v);
    },
    type: "number",
    required: true,
    readOnly: isSaved
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6,
    className: classes.item
  }, /*#__PURE__*/React.createElement(TextInput, {
    label: "workforce.employee.email",
    value: stateEdited.email || "",
    onChange: function onChange(v) {
      return updateAttribute("email", v);
    },
    type: "email",
    readOnly: isSaved
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 11,
    className: classes.item
  }), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 1,
    className: classes.item
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "primary",
    component: "label",
    color: "primary",
    onClick: function onClick() {
      return save();
    },
    disabled: isSaveDisabled || isSaved,
    title: isSaveDisabled ? "Please Check all the required fields" : "Save"
  }, /*#__PURE__*/React.createElement(Save, null), " Save"))), /*#__PURE__*/React.createElement(Divider, null)))));
});

function ownKeys$1v(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$1v(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$1v(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1v(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper$R(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$R() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$R() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$R = function _isNativeReflectConstruct() { return !!t; })(); }
var WorkforceEmployeeForm = /*#__PURE__*/function (_Component) {
  function WorkforceEmployeeForm(props) {
    var _this;
    _classCallCheck(this, WorkforceEmployeeForm);
    _this = _callSuper$R(this, WorkforceEmployeeForm, [props]);
    _defineProperty(_this, "reload", function () {});
    _defineProperty(_this, "canSave", function () {});
    _defineProperty(_this, "_save", function (ticket) {
      _this.setState({
        lockNew: !ticket.uuid
      }, function () {
        return _this.props.save(ticket);
      });
    });
    _defineProperty(_this, "onEditedChanged", function (ticket) {
      _this.setState({
        ticket: ticket
      });
    });
    _defineProperty(_this, "reopenTicket", function () {
      var _this$props = _this.props,
        intl = _this$props.intl,
        ticket = _this$props.ticket;
      _this.props.reopenTicket(ticket.id, formatMessage(intl, MODULE_NAME, "reopenTicket.mutation.label"));
    });
    _this.state = {
      lockNew: false,
      reset: 0,
      workforceEmployeeUuid: null,
      ticket: _this._newTicket()
    };
    return _this;
  }
  _inherits(WorkforceEmployeeForm, _Component);
  return _createClass(WorkforceEmployeeForm, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.workforceEmployeeUuid) {
        this.setState(function (state, props) {
          return {
            workforceEmployeeUuid: props.workforceEmployeeUuid
          };
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {}
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState, snapshot) {
      if (prevProps.fetchedWorkforceEmployee !== this.props.fetchedWorkforceEmployee && !!this.props.fetchedWorkforceEmployee && !!this.props.workforceEmployee) {
        this.setState(function (state, props) {
          return {
            workforceEmployee: _objectSpread$1v({}, props.workforceEmployee),
            workforceEmployeeUuid: props.workforceEmployee.id,
            lockNew: false
          };
        });
      } else if (prevState.workforceEmployeeUuid !== this.state.workforceEmployeeUuid) {
        var filters = ["id: \"".concat(this.state.workforceEmployeeUuid, "\"")];
        this.props.fetchWorkforceEmployee(this.props.modulesManager, filters);
      } else if (prevProps.submittingMutation && !this.props.submittingMutation) {
        var _this$props2;
        this.props.journalize(this.props.mutation);
        this.setState(function (state) {
          return {
            reset: state.reset + 1
          };
        });
        if ((_this$props2 = this.props) !== null && _this$props2 !== void 0 && (_this$props2 = _this$props2.workforceEmployee) !== null && _this$props2 !== void 0 && _this$props2.id) {
          this.props.fetchWorkforceEmployee(this.props.modulesManager, ["id: \"".concat(this.state.workforceEmployeeUuid, "\"")]);
        }
      }
    }
  }, {
    key: "_newTicket",
    value: function _newTicket() {
      return {};
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
        fetchingTicket = _this$props3.fetchingTicket,
        fetchedWorkforceEmployee = _this$props3.fetchedWorkforceEmployee,
        errorTicket = _this$props3.errorTicket,
        save = _this$props3.save,
        back = _this$props3.back;
      var _this$state = this.state,
        lockNew = _this$state.lockNew,
        reset = _this$state.reset,
        update = _this$state.update,
        overview = _this$state.overview,
        workforceEmployeeUuid = _this$state.workforceEmployeeUuid,
        ticket = _this$state.ticket;
      var readOnly = lockNew || !!ticket.validityTo || this.props.readOnly;
      [{
        doIt: this.reopenTicket,
        icon: /*#__PURE__*/React.createElement(LockOpenIcon, null),
        disabled: ticket.isHistory
      }];
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ProgressOrError, {
        progress: fetchingTicket,
        error: errorTicket
      }), (!!fetchedWorkforceEmployee || !workforceEmployeeUuid) && /*#__PURE__*/React.createElement(Form, {
        module: MODULE_NAME,
        edited_id: workforceEmployeeUuid,
        edited: ticket,
        reset: reset,
        update: update,
        title: "Workforce Employee",
        titleParams: {
          label: "Label"
        },
        back: back,
        save: save ? this._save : null,
        canSave: this.canSave,
        reload: (workforceEmployeeUuid || readOnly) && this.reload,
        readOnly: readOnly,
        overview: overview,
        Panels: workforceEmployeeUuid ? [EditWorkforceEmployeePage$1] : [AddWorkforceEmployeePage],
        onEditedChanged: this.onEditedChanged
      }));
    }
  }]);
}(Component); // eslint-disable-next-line no-unused-vars
var mapStateToProps$L = function mapStateToProps(state, props) {
  return {
    rights: !!state.core && !!state.core.user && !!state.core.user.i_user ? state.core.user.i_user.rights : [],
    fetchingTicket: state.workforce.fetchingTicket,
    errorTicket: state.workforce.errorTicket,
    fetchedWorkforceEmployee: state.workforce.fetchedWorkforceEmployee,
    ticket: state.workforce.ticket,
    submittingMutation: state.workforce.submittingMutation,
    mutation: state.workforce.mutation,
    grievanceConfig: state.workforce.grievanceConfig
  };
};
var mapDispatchToProps$s = function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    fetchWorkforceEmployee: fetchWorkforceEmployee,
    journalize: journalize
  }, dispatch);
};
var WorkforceEmployeeForm$1 = withModulesManager(connect(mapStateToProps$L, mapDispatchToProps$s)(WorkforceEmployeeForm));

function _callSuper$Q(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$Q() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$Q() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$Q = function _isNativeReflectConstruct() { return !!t; })(); }
var styles$N = function styles(theme) {
  return {
    page: theme.page,
    lockedPage: theme.page.locked
  };
};
var WorkforceEmployeePage = /*#__PURE__*/function (_Component) {
  function WorkforceEmployeePage() {
    var _this;
    _classCallCheck(this, WorkforceEmployeePage);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper$Q(this, WorkforceEmployeePage, [].concat(args));
    _defineProperty(_this, "add", function () {
      historyPush$1(_this.props.modulesManager, _this.props.history, "grievance.route.ticket");
    });
    _defineProperty(_this, "save", function (employee) {
      if (!employee.id) {
        _this.props.createWorkforceEmployee(_this.props.modulesManager, employee, "Create");
      } else {
        _this.props.updateWorkforceEmployee(_this.props.modulesManager, employee, "Update");
      }
    });
    return _this;
  }
  _inherits(WorkforceEmployeePage, _Component);
  return _createClass(WorkforceEmployeePage, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        classes = _this$props.classes,
        modulesManager = _this$props.modulesManager,
        history = _this$props.history,
        rights = _this$props.rights,
        workforceEmployeeUuid = _this$props.workforceEmployeeUuid,
        overview = _this$props.overview,
        organizationVersion = _this$props.organizationVersion;
      // const readOnly = organization?.status === TICKET_STATUSES.CLOSED || ticket?.isHistory;
      var readOnly = false;
      // if (!(rights.includes(RIGHT_ORGANIZATION_CREATE) || rights.includes(RIGHT_ORGANIZATION_EDIT))) return null;
      return /*#__PURE__*/React.createElement("div", {
        className: "".concat(null, " ").concat(classes.page)
      }, /*#__PURE__*/React.createElement(WorkforceEmployeeForm$1, {
        overview: overview,
        workforceEmployeeUuid: workforceEmployeeUuid,
        organizationVersion: organizationVersion,
        readOnly: readOnly,
        back: function back() {
          return historyPush$1(modulesManager, history, "workforce.route.employees");
        },
        add: rights.includes(RIGHT_ORGANIZATION_CREATE) ? this.add : null,
        save: rights.includes(RIGHT_ORGANIZATION_EDIT) ? this.save : null
      }));
    }
  }]);
}(Component);
var mapStateToProps$K = function mapStateToProps(state, props) {
  return {
    rights: !!state.core && !!state.core.user && !!state.core.user.i_user ? state.core.user.i_user.rights : [],
    workforceEmployeeUuid: props.match.params.workforce_employee_uuid,
    organizationVersion: props.match.params.version,
    employee: state.workforce.employee,
    userType: getUserTypeFromRights(state.core.user.i_user.rights)
  };
};
var mapDispatchToProps$r = function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    createWorkforceEmployee: createWorkforceEmployee,
    updateWorkforceEmployee: updateWorkforceEmployee
  }, dispatch);
};
var WorkforceEmployeePage$1 = withHistory(withModulesManager(connect(mapStateToProps$K, mapDispatchToProps$r)(withTheme(withStyles(styles$N)(WorkforceEmployeePage)))));

var BanksPicker$1 = function BanksPicker(_ref) {
  var _ref$id = _ref.id,
    id = _ref$id === void 0 ? "bank" : _ref$id,
    modulesManager = _ref.modulesManager,
    _onChange = _ref.onChange,
    readOnly = _ref.readOnly,
    required = _ref.required,
    _ref$withLabel = _ref.withLabel,
    withLabel = _ref$withLabel === void 0 ? true : _ref$withLabel,
    withPlaceholder = _ref.withPlaceholder,
    value = _ref.value,
    label = _ref.label,
    placeholder = _ref.placeholder,
    filterOptions = _ref.filterOptions,
    filterSelectedOptions = _ref.filterSelectedOptions,
    multiple = _ref.multiple;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2);
    _useState2[0];
    var setSearchString = _useState2[1];
  var _useTranslations = useTranslations("workforce"),
    formatMessage = _useTranslations.formatMessage;
  var dispatch = useDispatch();
  useEffect(function () {
    return dispatch(fetchBanksPick(modulesManager, ["type:\"main\""]));
  }, []);
  var isLoading = useSelector(function (state) {
    return state.workforce["fetchingBanksPick"];
  });
  var data = useSelector(function (state) {
    var _state$workforce;
    return (_state$workforce = state.workforce["banksPick"]) !== null && _state$workforce !== void 0 ? _state$workforce : [];
  });
  var error = useSelector(function (state) {
    return state.workforce["errorBanksPick"];
  });
  var selectedOption = useMemo(function () {
    return data.find(function (option) {
      return option.id === value;
    }) || null;
  }, [value, data]);
  console.log({
    selectedOption: selectedOption
  });
  var locale = useSelector(function (state) {
    var _state$core;
    return ((_state$core = state.core) === null || _state$core === void 0 || (_state$core = _state$core.user) === null || _state$core === void 0 || (_state$core = _state$core.i_user) === null || _state$core === void 0 ? void 0 : _state$core.language) || "en";
  });
  return /*#__PURE__*/React.createElement(Autocomplete, {
    id: id,
    multiple: multiple,
    required: required,
    placeholder: placeholder !== null && placeholder !== void 0 ? placeholder : "",
    label: label !== null && label !== void 0 ? label : formatMessage("workforce.bank.picker"),
    error: error,
    withLabel: withLabel,
    withPlaceholder: withPlaceholder,
    readOnly: readOnly,
    options: data,
    isLoading: isLoading,
    value: selectedOption,
    getOptionLabel: function getOptionLabel(option) {
      return locale === "en" ? (option === null || option === void 0 ? void 0 : option.nameEn) || (option === null || option === void 0 ? void 0 : option.nameBn) || "" : (option === null || option === void 0 ? void 0 : option.nameBn) || (option === null || option === void 0 ? void 0 : option.nameEn) || "";
    }
    // getOptionLabel={(option) => option.nameEn }
    ,
    onChange: function onChange(option) {
      return _onChange(option, option ? "".concat(option) : null);
    },
    filterOptions: filterOptions,
    filterSelectedOptions: filterSelectedOptions,
    onInputChange: setSearchString
    // onOpen={fetchBanks}
  });
};

var BankBranchModal = function BankBranchModal(_ref) {
  var open = _ref.open,
    onClose = _ref.onClose,
    onSuccess = _ref.onSuccess,
    mode = _ref.mode,
    districts = _ref.districts;
    _ref.banks;
  var dispatch = useDispatch();
  var modulesManager = useModulesManager();
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    loading = _useState2[0],
    setLoading = _useState2[1];

  // Bank form fields
  var _useState3 = useState(""),
    _useState4 = _slicedToArray(_useState3, 2),
    nameEn = _useState4[0],
    setNameEn = _useState4[1];
  var _useState5 = useState(""),
    _useState6 = _slicedToArray(_useState5, 2),
    nameBn = _useState6[0],
    setNameBn = _useState6[1];
  var _useState7 = useState(""),
    _useState8 = _slicedToArray(_useState7, 2),
    bankCode = _useState8[0],
    setBankCode = _useState8[1];

  // Branch form fields
  var _useState9 = useState(null),
    _useState10 = _slicedToArray(_useState9, 2),
    parentId = _useState10[0],
    setParentId = _useState10[1];
  var _useState11 = useState(""),
    _useState12 = _slicedToArray(_useState11, 2),
    districtCode = _useState12[0],
    setDistrictCode = _useState12[1];
  var _useState13 = useState(""),
    _useState14 = _slicedToArray(_useState13, 2),
    branchCode = _useState14[0],
    setBranchCode = _useState14[1];
  var _useState15 = useState(""),
    _useState16 = _slicedToArray(_useState15, 2),
    routingNumber = _useState16[0],
    setRoutingNumber = _useState16[1];
  var _useState17 = useState(""),
    _useState18 = _slicedToArray(_useState17, 2),
    contactNumber = _useState18[0],
    setContactNumber = _useState18[1];
  var handleClose = function handleClose() {
    resetForm();
    onClose();
  };
  var resetForm = function resetForm() {
    setNameEn("");
    setNameBn("");
    setBankCode("");
    setParentId(null);
    setDistrictCode("");
    setBranchCode("");
    setRoutingNumber("");
    setContactNumber("");
  };
  var validateBankForm = function validateBankForm() {
    return nameEn.trim() && nameBn.trim() && bankCode.trim();
  };
  var validateBranchForm = function validateBranchForm() {
    return parentId && districtCode.trim() && branchCode.trim() && routingNumber.trim();
  };
  var handleSubmit = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var bankData, selectedDistrict;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            setLoading(true);
            _context.prev = 1;
            bankData = {};
            if (!(mode === "bank")) {
              _context.next = 11;
              break;
            }
            if (validateBankForm()) {
              _context.next = 8;
              break;
            }
            alert("Please fill in all required fields for Bank");
            setLoading(false);
            return _context.abrupt("return");
          case 8:
            bankData = {
              nameEn: nameEn.trim(),
              nameBn: nameBn.trim(),
              bankCode: bankCode.trim(),
              type: "main",
              status: "active"
            };
            _context.next = 18;
            break;
          case 11:
            if (!(mode === "branch")) {
              _context.next = 18;
              break;
            }
            if (validateBranchForm()) {
              _context.next = 16;
              break;
            }
            alert("Please fill in all required fields for Branch");
            setLoading(false);
            return _context.abrupt("return");
          case 16:
            // Find district details
            selectedDistrict = districts.find(function (d) {
              return d.districtCode === districtCode;
            });
            bankData = {
              nameEn: nameEn.trim(),
              nameBn: nameBn.trim(),
              parentId: parentId.id,
              bankCode: parentId.bankCode.trim(),
              branchCode: branchCode.trim(),
              districtCode: districtCode,
              districtNameEn: (selectedDistrict === null || selectedDistrict === void 0 ? void 0 : selectedDistrict.districtNameEn) || "",
              districtNameBn: (selectedDistrict === null || selectedDistrict === void 0 ? void 0 : selectedDistrict.districtNameBn) || "",
              routingNumber: routingNumber.trim(),
              contactNumber: contactNumber.trim(),
              type: "branch",
              status: "active"
            };
          case 18:
            _context.next = 20;
            return dispatch(createBank(bankData, "".concat(mode === "bank" ? "Create Bank" : "Create Branch")));
          case 20:
            handleClose();
            if (onSuccess) onSuccess();
            _context.next = 28;
            break;
          case 24:
            _context.prev = 24;
            _context.t0 = _context["catch"](1);
            console.error("Error submitting:", _context.t0);
            alert("Error submitting. Please try again.");
          case 28:
            _context.prev = 28;
            setLoading(false);
            return _context.finish(28);
          case 31:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[1, 24, 28, 31]]);
    }));
    return function handleSubmit() {
      return _ref2.apply(this, arguments);
    };
  }();
  var getUniqueDistricts = function getUniqueDistricts() {
    var districtMap = {};
    districts.forEach(function (item) {
      if (item.districtCode && item.districtNameEn) {
        districtMap[item.districtCode] = {
          districtCode: item.districtCode,
          districtNameEn: item.districtNameEn,
          districtNameBn: item.districtNameBn
        };
      }
    });
    return Object.values(districtMap);
  };
  var uniqueDistricts = getUniqueDistricts();
  return /*#__PURE__*/React.createElement(Dialog$1, {
    open: open,
    onClose: handleClose,
    maxWidth: "sm",
    fullWidth: true
  }, /*#__PURE__*/React.createElement(DialogTitle, null, mode === "bank" ? "Add New Bank" : "Add New Branch"), /*#__PURE__*/React.createElement(DialogContent$1, {
    style: {
      marginTop: "16px"
    }
  }, mode === "bank" ? /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 2
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(TextField, {
    autoFocus: true,
    margin: "dense",
    id: "nameEn",
    label: "Bank Name (English)",
    type: "text",
    fullWidth: true,
    value: nameEn,
    onChange: function onChange(e) {
      return setNameEn(e.target.value);
    },
    disabled: loading
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(TextField, {
    margin: "dense",
    id: "nameBn",
    label: "Bank Name (Bengali)",
    type: "text",
    fullWidth: true,
    value: nameBn,
    onChange: function onChange(e) {
      return setNameBn(e.target.value);
    },
    disabled: loading
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(TextField, {
    margin: "dense",
    id: "bankCode",
    label: "Bank Code",
    type: "text",
    fullWidth: true,
    value: bankCode,
    onChange: function onChange(e) {
      return setBankCode(e.target.value);
    },
    disabled: loading
  }))) : /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 2
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(TextField, {
    autoFocus: true,
    margin: "dense",
    id: "nameEn",
    label: "Branch Name (English)",
    type: "text",
    fullWidth: true,
    value: nameEn,
    onChange: function onChange(e) {
      return setNameEn(e.target.value);
    },
    disabled: loading
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(TextField, {
    margin: "dense",
    id: "nameBn",
    label: "Branch Name (Bengali)",
    type: "text",
    fullWidth: true,
    value: nameBn,
    onChange: function onChange(e) {
      return setNameBn(e.target.value);
    },
    disabled: loading
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(BanksPicker$1, {
    modulesManager: modulesManager,
    value: parentId,
    onChange: function onChange(e) {
      return setParentId(e);
    },
    required: true,
    withLabel: true,
    label: "Select Bank",
    readOnly: loading
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(TextField, {
    select: true,
    margin: "dense",
    id: "districtCode",
    label: "Select District",
    type: "text",
    fullWidth: true,
    value: districtCode,
    onChange: function onChange(e) {
      return setDistrictCode(e.target.value);
    },
    disabled: loading,
    SelectProps: {
      "native": true
    }
  }, /*#__PURE__*/React.createElement("option", {
    value: ""
  }, "-- Select District --"), uniqueDistricts === null || uniqueDistricts === void 0 ? void 0 : uniqueDistricts.map(function (district) {
    return /*#__PURE__*/React.createElement("option", {
      key: district.districtCode,
      value: district.districtCode
    }, district.districtNameEn, " - ", district.districtNameBn);
  }))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(TextField, {
    margin: "dense",
    id: "branchCode",
    label: "Branch Code",
    type: "text",
    fullWidth: true,
    value: branchCode,
    onChange: function onChange(e) {
      return setBranchCode(e.target.value);
    },
    disabled: loading
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(TextField, {
    margin: "dense",
    id: "routingNumber",
    label: "Routing Number",
    type: "text",
    fullWidth: true,
    value: routingNumber,
    onChange: function onChange(e) {
      return setRoutingNumber(e.target.value);
    },
    disabled: loading
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(TextField, {
    margin: "dense",
    id: "contactNumber",
    label: "Contact Number (Optional)",
    type: "text",
    fullWidth: true,
    value: contactNumber,
    onChange: function onChange(e) {
      return setContactNumber(e.target.value);
    },
    disabled: loading
  })))), /*#__PURE__*/React.createElement(DialogActions$1, null, /*#__PURE__*/React.createElement(Button, {
    onClick: handleClose,
    color: "secondary",
    disabled: loading
  }, "Cancel"), /*#__PURE__*/React.createElement(Button, {
    onClick: handleSubmit,
    color: "primary",
    variant: "contained",
    disabled: loading || mode === "bank" && !validateBankForm() || mode === "branch" && !validateBranchForm()
  }, loading ? /*#__PURE__*/React.createElement(CircularProgress$1, {
    size: 24
  }) : "Submit")));
};

var useStyles$1A = makeStyles(function (theme) {
  return {
    page: theme.page,
    fab: theme.fab,
    tableTitle: theme.table.title,
    filterContainer: {
      padding: theme.spacing(2),
      backgroundColor: theme.palette.background.paper
    },
    filterField: {
      marginRight: theme.spacing(2),
      minWidth: 200
    }
  };
});
var WorkforceBanksPage = function WorkforceBanksPage() {
  var dispatch = useDispatch();
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    banks = _useState2[0],
    setBanks = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    districts = _useState4[0],
    setDistricts = _useState4[1];
  var _useState5 = useState([]),
    _useState6 = _slicedToArray(_useState5, 2),
    branches = _useState6[0],
    setBranches = _useState6[1];
  var classes = useStyles$1A();

  // Modal state
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    modalOpen = _useState8[0],
    setModalOpen = _useState8[1];
  var _useState9 = useState(null),
    _useState10 = _slicedToArray(_useState9, 2),
    modalMode = _useState10[0],
    setModalMode = _useState10[1]; // "bank" or "branch"

  // State
  var _useState11 = useState(null),
    _useState12 = _slicedToArray(_useState11, 2),
    selectedBankId = _useState12[0],
    setSelectedBankId = _useState12[1];
  var _useState13 = useState(""),
    _useState14 = _slicedToArray(_useState13, 2),
    selectedDistrictCode = _useState14[0],
    setSelectedDistrictCode = _useState14[1];

  // Actions / Methods
  var fetchBanks = function fetchBanks() {
    dispatch(fetchWorkforceBankManagement({
      banksOnly: true
    })).then(function (response) {
      var _response$payload;
      setBanks((response === null || response === void 0 || (_response$payload = response.payload) === null || _response$payload === void 0 || (_response$payload = _response$payload.data) === null || _response$payload === void 0 ? void 0 : _response$payload.workforceBankManagement) || []);
    });
  };
  var fetchDistricts = function fetchDistricts() {
    dispatch(fetchWorkforceBankManagement({
      districtsOnly: true
    })).then(function (response) {
      var _response$payload2;
      setDistricts((response === null || response === void 0 || (_response$payload2 = response.payload) === null || _response$payload2 === void 0 || (_response$payload2 = _response$payload2.data) === null || _response$payload2 === void 0 ? void 0 : _response$payload2.workforceBankManagement) || []);
    });
  };
  var fetchBranches = function fetchBranches() {
    var bankId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var districtCode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    dispatch(fetchWorkforceBankManagement({
      banksOnly: false,
      districtsOnly: false,
      bankId: bankId || "",
      districtCode: districtCode || ""
    })).then(function (response) {
      var _response$payload3;
      setBranches((response === null || response === void 0 || (_response$payload3 = response.payload) === null || _response$payload3 === void 0 || (_response$payload3 = _response$payload3.data) === null || _response$payload3 === void 0 ? void 0 : _response$payload3.workforceBankManagement) || []);
    });
  };

  // Lifecycle emulation (componentDidMount)
  useEffect(function () {
    fetchBanks();
    fetchDistricts();
  }, [dispatch]);

  // Handlers
  var handleDistrictChange = function handleDistrictChange(event) {
    var value = event.target.value;
    setSelectedDistrictCode(value);
    fetchBranches(safeDecodeId(selectedBankId), value);
  };
  var handleBankChange = function handleBankChange(event) {
    var value = event.target.value;
    setSelectedBankId(value);
    fetchBranches(safeDecodeId(value), selectedDistrictCode);
  };
  var handleOpenModal = function handleOpenModal(mode) {
    setModalMode(mode);
    setModalOpen(true);
  };
  var handleCloseModal = function handleCloseModal() {
    setModalOpen(false);
    setModalMode(null);
  };
  var handleModalSuccess = function handleModalSuccess() {
    // Refresh data after successful submission
    fetchBanks();
    fetchDistricts();
    fetchBranches(safeDecodeId(selectedBankId), selectedDistrictCode);
  };
  var getUniqueDistricts = function getUniqueDistricts(data) {
    var districtMap = {};
    data.forEach(function (item) {
      if (item.districtCode && item.districtNameEn) {
        districtMap[item.districtCode] = {
          districtCode: item.districtCode,
          districtNameEn: item.districtNameEn,
          districtNameBn: item.districtNameBn
        };
      }
    });
    return Object.values(districtMap);
  };
  var uniqueDistricts = getUniqueDistricts(districts);
  return /*#__PURE__*/React.createElement("div", {
    className: classes.page
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 3
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(Box$1, {
    display: "flex",
    justifyContent: "flex-end",
    gap: 3
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "contained",
    color: "primary",
    onClick: function onClick() {
      return handleOpenModal("bank");
    }
  }, "Add Bank"), /*#__PURE__*/React.createElement(Button, {
    variant: "contained",
    color: "primary",
    onClick: function onClick() {
      return handleOpenModal("branch");
    },
    style: {
      marginLeft: "15px"
    }
  }, "Add Branch"))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6",
    className: classes.tableTitle
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: MODULE_NAME,
    id: "workforce.banks.title"
  })), /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement(TableContainer, {
    component: Paper
  }, /*#__PURE__*/React.createElement(Table$2, {
    size: "small"
  }, /*#__PURE__*/React.createElement(TableHead, null, /*#__PURE__*/React.createElement(TableRow, null, /*#__PURE__*/React.createElement(TableCell, null, "Name (EN)"), /*#__PURE__*/React.createElement(TableCell, null, "Name (BN)"), /*#__PURE__*/React.createElement(TableCell, null, "Bank Code"), /*#__PURE__*/React.createElement(TableCell, null, "Routing Number"), /*#__PURE__*/React.createElement(TableCell, null, "Action"))), /*#__PURE__*/React.createElement(TableBody, null, banks === null || banks === void 0 ? void 0 : banks.map(function (bank) {
    return /*#__PURE__*/React.createElement(TableRow, {
      key: bank.id
    }, /*#__PURE__*/React.createElement(TableCell, null, bank.nameEn), /*#__PURE__*/React.createElement(TableCell, null, bank.nameBn), /*#__PURE__*/React.createElement(TableCell, null, bank.bankCode), /*#__PURE__*/React.createElement(TableCell, null, bank.routingNumber), /*#__PURE__*/React.createElement(TableCell, null, /*#__PURE__*/React.createElement(IconButton, {
      onClick: function onClick() {
        setSelectedBankId(safeDecodeId(bank.id));
        fetchBranches(safeDecodeId(bank.id), selectedDistrictCode);
      },
      style: {
        backgroundColor: selectedBankId === bank.id ? "#1976d2" : "transparent",
        color: selectedBankId === bank.id ? "#fff" : "#1976d2"
      }
    }, /*#__PURE__*/React.createElement(VisibilityIcon, null))));
  }))))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6",
    className: classes.tableTitle
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: MODULE_NAME,
    id: "workforce.banks.branches.title"
  })), /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement("div", {
    className: classes.filterContainer
  }, /*#__PURE__*/React.createElement("select", {
    className: classes.filterField,
    value: selectedBankId || "",
    onChange: handleBankChange,
    style: {
      padding: "8px",
      marginRight: "16px"
    }
  }, /*#__PURE__*/React.createElement("option", {
    value: ""
  }, "All Banks"), banks === null || banks === void 0 ? void 0 : banks.map(function (bank) {
    return /*#__PURE__*/React.createElement("option", {
      key: bank.id,
      value: bank.id
    }, bank.nameEn, " - ", bank.nameBn);
  })), /*#__PURE__*/React.createElement("select", {
    className: classes.filterField,
    value: selectedDistrictCode || "",
    onChange: handleDistrictChange,
    style: {
      padding: "8px"
    }
  }, /*#__PURE__*/React.createElement("option", {
    value: ""
  }, "All Districts"), uniqueDistricts === null || uniqueDistricts === void 0 ? void 0 : uniqueDistricts.map(function (district) {
    return /*#__PURE__*/React.createElement("option", {
      key: district.districtCode,
      value: district.districtCode
    }, district.districtNameEn, " - ", district.districtNameBn);
  }))), /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement(TableContainer, {
    component: Paper
  }, /*#__PURE__*/React.createElement(Table$2, {
    size: "small"
  }, /*#__PURE__*/React.createElement(TableHead, null, /*#__PURE__*/React.createElement(TableRow, null, /*#__PURE__*/React.createElement(TableCell, null, "Name (EN)"), /*#__PURE__*/React.createElement(TableCell, null, "Name (BN)"), /*#__PURE__*/React.createElement(TableCell, null, "Routing Number"), /*#__PURE__*/React.createElement(TableCell, null, "Contact Number"), /*#__PURE__*/React.createElement(TableCell, null, "District"))), /*#__PURE__*/React.createElement(TableBody, null, branches === null || branches === void 0 ? void 0 : branches.map(function (branch) {
    return /*#__PURE__*/React.createElement(TableRow, {
      key: branch.id
    }, /*#__PURE__*/React.createElement(TableCell, null, branch.nameEn), /*#__PURE__*/React.createElement(TableCell, null, branch.nameBn), /*#__PURE__*/React.createElement(TableCell, null, branch.routingNumber), /*#__PURE__*/React.createElement(TableCell, null, branch.contactNumber), /*#__PURE__*/React.createElement(TableCell, null, branch.districtNameEn, " / ", branch.districtNameBn));
  })))))), /*#__PURE__*/React.createElement(BankBranchModal, {
    open: modalOpen,
    onClose: handleCloseModal,
    onSuccess: handleModalSuccess,
    mode: modalMode,
    districts: districts,
    banks: banks
  }));
};

function ownKeys$1u(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$1u(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$1u(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1u(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper$P(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$P() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$P() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$P = function _isNativeReflectConstruct() { return !!t; })(); }
var styles$M = function styles(theme) {
  return {
    paper: theme.paper.paper,
    tableTitle: theme.table.title,
    item: theme.paper.item,
    fullHeight: {
      height: "100%"
    }
  };
};
var EditWorkforceBankPage = /*#__PURE__*/function (_Component) {
  function EditWorkforceBankPage(props) {
    var _this;
    _classCallCheck(this, EditWorkforceBankPage);
    _this = _callSuper$P(this, EditWorkforceBankPage, [props]);
    _defineProperty(_this, "updateAttribute", function (key, value) {
      _this.setState(function (prevState) {
        return {
          stateEdited: _objectSpread$1u(_objectSpread$1u({}, prevState.stateEdited), {}, _defineProperty({}, key, value)),
          isSaved: false
        };
      });
    });
    _defineProperty(_this, "save", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var stateEdited, _this$props, dispatch, bankData, _stateEdited$parent, _stateEdited$bank, bankBranchData;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            stateEdited = _this.state.stateEdited;
            _this$props = _this.props, _this$props.grievanceConfig, dispatch = _this$props.dispatch;
            if (!(!stateEdited.bank && !(stateEdited !== null && stateEdited !== void 0 && stateEdited.parent))) {
              _context.next = 9;
              break;
            }
            bankData = {
              id: stateEdited.id,
              nameEn: stateEdited.nameEn,
              nameBn: stateEdited.nameBn,
              address: stateEdited.headquarterAddress,
              locationId: stateEdited.location,
              status: WORKFORCE_STATUS$1.ACTIVE,
              type: 'bank'
            };
            console.log({
              bankData: bankData
            });
            _context.next = 7;
            return dispatch(updateBank(bankData, "update Bank ".concat(bankData.nameEn)));
          case 7:
            _context.next = 13;
            break;
          case 9:
            bankBranchData = {
              id: stateEdited.id,
              nameEn: stateEdited.nameEn,
              nameBn: stateEdited.nameBn,
              parentId: ((_stateEdited$parent = stateEdited.parent) === null || _stateEdited$parent === void 0 ? void 0 : _stateEdited$parent.id) || (stateEdited === null || stateEdited === void 0 || (_stateEdited$bank = stateEdited.bank) === null || _stateEdited$bank === void 0 ? void 0 : _stateEdited$bank.id),
              routingNumber: stateEdited.routingNumber,
              contactNumber: stateEdited.contactNumber,
              address: stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.headquarterAddress,
              locationId: stateEdited.location,
              status: WORKFORCE_STATUS$1.ACTIVE,
              type: 'branch'
            };
            console.log({
              bankBranchData: bankBranchData
            });
            _context.next = 13;
            return dispatch(updateBank(bankBranchData, "update Branch ".concat(bankBranchData.nameEn)));
          case 13:
            _this.setState({
              isSaved: true
            });
          case 14:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })));
    _this.state = {
      stateEdited: props.bank || {},
      isSaved: false
    };
    return _this;
  }
  _inherits(EditWorkforceBankPage, _Component);
  return _createClass(EditWorkforceBankPage, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.bank !== this.props.bank) {
        this.setState({
          stateEdited: this.props.bank
        });
      }
      if (prevProps.submittingMutation && !this.props.submittingMutation) {
        this.props.dispatch(journalize(this.props.mutation));
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _stateEdited$bank2,
        _this2 = this;
      var classes = this.props.classes;
      var _this$state = this.state,
        stateEdited = _this$state.stateEdited,
        isSaved = _this$state.isSaved;
      console.log({
        stateEdited: stateEdited
      });
      return /*#__PURE__*/React.createElement("div", {
        className: classes.page
      }, /*#__PURE__*/React.createElement(Grid, {
        container: true
      }, /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12
      }, /*#__PURE__*/React.createElement(Paper, {
        className: classes.paper
      }, /*#__PURE__*/React.createElement(Grid, {
        container: true,
        className: classes.tableTitle
      }, /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12,
        className: classes.tableTitle
      }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(FormattedMessage, {
        module: MODULE_NAME,
        id: "Banks",
        values: {
          label: EMPTY_STRING
        }
      })))), /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement(Grid, {
        container: true,
        className: classes.item
      }, stateEdited.type !== "bank" && /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(PublishedComponent, {
        pubRef: "workforce.BanksPicker",
        value: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.parent.id) || (stateEdited === null || stateEdited === void 0 || (_stateEdited$bank2 = stateEdited.bank) === null || _stateEdited$bank2 === void 0 ? void 0 : _stateEdited$bank2.id) || null,
        label: /*#__PURE__*/React.createElement(FormattedMessage, {
          module: "workforce",
          id: "workforce.bank.picker"
        }),
        onChange: function onChange(option) {
          return _this2.updateAttribute("bank", option);
        },
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: stateEdited.bank ? "workforce.banks.branch.nameEn" : "workforce.banks.nameEn",
        value: stateEdited.nameEn || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("nameEn", v);
        },
        required: true,
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: stateEdited.bank ? "workforce.banks.branch.nameBn" : "workforce.banks.nameBn",
        value: stateEdited.nameBn || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("nameBn", v);
        },
        required: true,
        readOnly: isSaved
      })), stateEdited.type !== "bank" && /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.banks.routingNumber",
        value: stateEdited.routingNumber || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("routingNumber", v);
        },
        required: true,
        readOnly: isSaved
      })), stateEdited.type !== "bank" && /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.banks.contactNumber",
        value: stateEdited.contactNumber || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("contactNumber", v);
        },
        required: true,
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.banks.address",
        value: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.headquarterAddress) || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("headquarterAddress", v);
        },
        required: true,
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12,
        className: classes.item
      }, /*#__PURE__*/React.createElement(PublishedComponent, {
        pubRef: "location.DetailedLocation",
        withNull: true,
        value: stateEdited.location || null,
        onChange: function onChange(location) {
          return _this2.updateAttribute("location", location);
        },
        readOnly: isSaved,
        required: true,
        split: true
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 11,
        className: classes.item
      }), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 1,
        className: classes.item
      }, /*#__PURE__*/React.createElement(IconButton, {
        variant: "contained",
        component: "label",
        color: "primary",
        onClick: this.save,
        disabled: isSaved
      }, /*#__PURE__*/React.createElement(Save, null)))), /*#__PURE__*/React.createElement(Divider, null)))));
    }
  }]);
}(Component);
var mapStateToProps$J = function mapStateToProps(state) {
  return {
    // submittingMutation: state.grievanceSocialProtection.submittingMutation,
    // mutation: state.grievanceSocialProtection.mutation,
    // grievanceConfig: state.grievanceSocialProtection.grievanceConfig,
    bank: state.workforce.bank
  };
};
var EditWorkforceBankPage$1 = connect(mapStateToProps$J)(withTheme(withStyles(styles$M)(EditWorkforceBankPage)));

function ownKeys$1t(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$1t(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$1t(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1t(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper$O(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$O() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$O() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$O = function _isNativeReflectConstruct() { return !!t; })(); }
var styles$L = function styles(theme) {
  return {
    paper: theme.paper.paper,
    tableTitle: theme.table.title,
    item: theme.paper.item,
    fullHeight: {
      height: "100%"
    }
  };
};
var AddWorkforceBankPage = /*#__PURE__*/function (_Component) {
  function AddWorkforceBankPage(props) {
    var _this;
    _classCallCheck(this, AddWorkforceBankPage);
    _this = _callSuper$O(this, AddWorkforceBankPage, [props]);
    _defineProperty(_this, "save", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var stateEdited, _this$props, dispatch, bankData, _stateEdited$bank, bankBranchData;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            stateEdited = _this.state.stateEdited;
            _this$props = _this.props, _this$props.grievanceConfig, dispatch = _this$props.dispatch;
            if (stateEdited.bank) {
              _context.next = 8;
              break;
            }
            bankData = {
              nameEn: stateEdited.nameEn,
              nameBn: stateEdited.nameBn,
              address: stateEdited.headquarterAddress,
              locationId: stateEdited.location,
              status: WORKFORCE_STATUS$1.ACTIVE,
              type: "bank"
            };
            _context.next = 6;
            return dispatch(createBank(bankData, "Created Bank ".concat(bankData.nameEn)));
          case 6:
            _context.next = 11;
            break;
          case 8:
            bankBranchData = {
              nameEn: stateEdited.nameEn,
              nameBn: stateEdited.nameBn,
              parentId: stateEdited === null || stateEdited === void 0 || (_stateEdited$bank = stateEdited.bank) === null || _stateEdited$bank === void 0 ? void 0 : _stateEdited$bank.id,
              routingNumber: stateEdited.routingNumber,
              contactNumber: stateEdited.contactNumber,
              address: stateEdited.headquarterAddress,
              locationId: stateEdited.location,
              status: WORKFORCE_STATUS$1.ACTIVE,
              type: "branch"
            };
            _context.next = 11;
            return dispatch(createBank(bankBranchData, "Created Branch ".concat(bankBranchData.nameEn)));
          case 11:
            _this.setState({
              isSaved: true
            });
          case 12:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })));
    _defineProperty(_this, "updateAttribute", function (key, value) {
      _this.setState(function (prevState) {
        return {
          stateEdited: _objectSpread$1t(_objectSpread$1t({}, prevState.stateEdited), {}, _defineProperty({}, key, value)),
          isSaved: false
        };
      });
    });
    _defineProperty(_this, "handleFileUpload", function (uploadedFiles) {
      _this.setState({
        uploadedFiles: uploadedFiles
      });
    });
    _this.state = {
      stateEdited: {},
      isSaved: false
    };
    return _this;
  }
  _inherits(AddWorkforceBankPage, _Component);
  return _createClass(AddWorkforceBankPage, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props2 = this.props,
        submittingMutation = _this$props2.submittingMutation,
        mutation = _this$props2.mutation,
        dispatch = _this$props2.dispatch;
      if (!submittingMutation && prevProps.submittingMutation !== submittingMutation) {
        dispatch(journalize(mutation));
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var classes = this.props.classes;
      var _this$state = this.state,
        stateEdited = _this$state.stateEdited,
        isSaved = _this$state.isSaved;
        _this$state.uploadedFiles;
      console.log({
        stateEdited: stateEdited
      });
      return /*#__PURE__*/React.createElement("div", {
        className: classes.page
      }, /*#__PURE__*/React.createElement(Grid, {
        container: true
      }, /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12
      }, /*#__PURE__*/React.createElement(Paper, {
        className: classes.paper
      }, /*#__PURE__*/React.createElement(Grid, {
        container: true,
        className: classes.tableTitle
      }, /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12,
        className: classes.tableTitle
      }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(FormattedMessage, {
        module: MODULE_NAME,
        id: "Banks",
        values: {
          label: EMPTY_STRING
        }
      })))), /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement(Grid, {
        container: true,
        className: classes.item
      }, /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(PublishedComponent, {
        pubRef: "workforce.BanksPicker",
        value: stateEdited.bank || null,
        label: /*#__PURE__*/React.createElement(FormattedMessage, {
          module: "workforce",
          id: "workforce.bank.picker"
        }),
        onChange: function onChange(option) {
          return _this2.updateAttribute("bank", option);
        },
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: stateEdited.bank ? "workforce.banks.branch.nameEn" : "workforce.banks.nameEn",
        value: stateEdited.name || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("nameEn", v);
        },
        required: true,
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: stateEdited.bank ? "workforce.banks.branch.nameBn" : "workforce.banks.nameBn",
        value: stateEdited.name || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("nameBn", v);
        },
        required: true,
        readOnly: isSaved
      })), stateEdited.bank && /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.banks.routingNumber",
        value: stateEdited.name || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("routingNumber", v);
        },
        required: true,
        readOnly: isSaved
      })), stateEdited.bank && /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.banks.contactNumber",
        value: stateEdited.name || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("contactNumber", v);
        },
        required: true,
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.banks.address",
        value: stateEdited.address || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("headquarterAddress", v);
        },
        required: true,
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12,
        className: classes.item
      }, /*#__PURE__*/React.createElement(PublishedComponent, {
        pubRef: "location.DetailedLocation",
        withNull: true,
        value: stateEdited.location || null,
        onChange: function onChange(location) {
          return _this2.updateAttribute("location", location);
        },
        readOnly: isSaved,
        required: true,
        split: true
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 11,
        className: classes.item
      }), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 1,
        className: classes.item
      }, /*#__PURE__*/React.createElement(IconButton, {
        variant: "contained",
        component: "label",
        color: "primary",
        onClick: this.save,
        disabled: isSaved
      }, /*#__PURE__*/React.createElement(Save, null)))), /*#__PURE__*/React.createElement(Divider, null)))));
    }
  }]);
}(Component);
var mapStateToProps$I = function mapStateToProps(state) {
  return {
    submittingMutation: state.workforce.submittingMutation,
    mutation: state.workforce.mutation,
    representativeId: state.workforce.fetchedRepresentativeByClientMutationId
  };
};
var AddWorkforceBankPage$1 = connect(mapStateToProps$I)(withStyles(styles$L)(AddWorkforceBankPage));

function ownKeys$1s(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$1s(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$1s(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1s(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper$N(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$N() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$N() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$N = function _isNativeReflectConstruct() { return !!t; })(); }
var BanksForm = /*#__PURE__*/function (_Component) {
  function BanksForm(props) {
    var _this;
    _classCallCheck(this, BanksForm);
    _this = _callSuper$N(this, BanksForm, [props]);
    _defineProperty(_this, "reload", function () {
      _this.props.fetchComments(_this.state.ticket);
    });
    _defineProperty(_this, "canSave", function () {
      if (!_this.state.ticket.reporter) return false;
      if (!_this.state.ticket.category) return false;
      return true;
    });
    _defineProperty(_this, "_save", function (ticket) {
      _this.setState({
        lockNew: !ticket.uuid
      }, function () {
        return _this.props.save(ticket);
      });
    });
    _defineProperty(_this, "onEditedChanged", function (ticket) {
      _this.setState({
        ticket: ticket
      });
    });
    _defineProperty(_this, "reopenTicket", function () {
      var _this$props = _this.props,
        intl = _this$props.intl,
        ticket = _this$props.ticket;
      _this.props.reopenTicket(ticket.id, formatMessage(intl, MODULE_NAME, "reopenTicket.mutation.label"));
    });
    _this.state = {
      lockNew: false,
      reset: 0,
      bankUuid: null,
      ticket: _this._newTicket()
    };
    return _this;
  }
  _inherits(BanksForm, _Component);
  return _createClass(BanksForm, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // this.props.fetchGrievanceConfiguration();
      if (this.props.bankUuid) {
        this.setState(function (state, props) {
          return {
            bankUuid: props.bankUuid
          };
        });
      }
    }

    // eslint-disable-next-line react/sort-comp
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // this.props.clearTicket();
    }

    // eslint-disable-next-line no-unused-vars
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState, snapshot) {
      if (prevProps.fetchedBank !== this.props.fetchedBank && !!this.props.fetchedBank && !!this.props.ticket) {
        this.setState(function (state, props) {
          return {
            ticket: _objectSpread$1s({}, props.ticket),
            bankUuid: props.ticket.id,
            lockNew: false
          };
        });
      } else if (prevState.bankUuid !== this.state.bankUuid) {
        var filters = ["id: \"".concat(this.state.bankUuid, "\"")];
        if (this.props.ticketVersion) filters.push("ticketVersion: ".concat(this.props.ticketVersion));
        this.props.fetchBank(this.props.modulesManager, filters);
      } else if (prevProps.bankUuid && !this.props.bankUuid) {
        this.setState({
          ticket: this._newTicket(),
          lockNew: false,
          bankUuid: null
        });
      } else if (prevProps.submittingMutation && !this.props.submittingMutation) {
        var _this$props2;
        this.props.journalize(this.props.mutation);
        this.setState(function (state) {
          return {
            reset: state.reset + 1
          };
        });
        if ((_this$props2 = this.props) !== null && _this$props2 !== void 0 && (_this$props2 = _this$props2.ticket) !== null && _this$props2 !== void 0 && _this$props2.id) {
          this.props.fetchBank(this.props.modulesManager, ["id: \"".concat(this.state.bankUuid, "\"")]);
        }
      }
    }

    // eslint-disable-next-line react/sort-comp
  }, {
    key: "_newTicket",
    value: function _newTicket() {
      return {};
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
        fetchingBank = _this$props3.fetchingBank,
        fetchedBank = _this$props3.fetchedBank,
        errorBank = _this$props3.errorBank,
        save = _this$props3.save,
        back = _this$props3.back;
      var _this$state = this.state,
        lockNew = _this$state.lockNew,
        reset = _this$state.reset,
        update = _this$state.update,
        overview = _this$state.overview,
        bankUuid = _this$state.bankUuid,
        ticket = _this$state.ticket;
      var readOnly = lockNew || !!ticket.validityTo || this.props.readOnly;
      [{
        doIt: this.reopenTicket,
        icon: /*#__PURE__*/React.createElement(LockOpenIcon, null),
        // onlyIfDirty: ticket.status !== TICKET_STATUSES.CLOSED,
        disabled: ticket.isHistory
      }];
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ProgressOrError, {
        progress: fetchingBank,
        error: errorBank
      }), (!!fetchedBank || !bankUuid) && /*#__PURE__*/React.createElement(Form, {
        module: MODULE_NAME,
        edited_id: bankUuid,
        edited: ticket,
        reset: reset,
        update: update,
        title: bankUuid ? "Edit Bank" : "Add Bank"
        // titleParams={{ label: ticketLabel(this.state.ticket) }}
        ,
        titleParams: {
          label: "Label"
        },
        back: back,
        save: save ? this._save : null,
        canSave: this.canSave,
        reload: (bankUuid || readOnly) && this.reload,
        readOnly: readOnly,
        overview: overview,
        Panels: bankUuid ? [EditWorkforceBankPage$1] : [AddWorkforceBankPage$1],
        onEditedChanged: this.onEditedChanged
        // actions={actions}
      }));
    }
  }]);
}(Component); // eslint-disable-next-line no-unused-vars
var mapStateToProps$H = function mapStateToProps(state, props) {
  return {
    rights: !!state.core && !!state.core.user && !!state.core.user.i_user ? state.core.user.i_user.rights : [],
    fetchingBank: state.workforce.fetchingBank,
    fetchedBank: state.workforce.fetchedBank,
    submittingMutation: state.workforce.submittingMutation,
    mutation: state.workforce.mutation,
    grievanceConfig: state.workforce.grievanceConfig
  };
};
var mapDispatchToProps$q = function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    fetchBank: fetchBank,
    journalize: journalize
  }, dispatch);
};
var BanksForm$1 = withModulesManager(connect(mapStateToProps$H, mapDispatchToProps$q)(BanksForm));

function _callSuper$M(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$M() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$M() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$M = function _isNativeReflectConstruct() { return !!t; })(); }
var styles$K = function styles(theme) {
  return {
    page: theme.page,
    lockedPage: theme.page.locked
  };
};
var WorkforceBankPage = /*#__PURE__*/function (_Component) {
  function WorkforceBankPage() {
    var _this;
    _classCallCheck(this, WorkforceBankPage);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper$M(this, WorkforceBankPage, [].concat(args));
    _defineProperty(_this, "add", function () {
      historyPush$1(_this.props.modulesManager, _this.props.history, "grievance.route.ticket");
    });
    _defineProperty(_this, "save", function (organization) {
      if (!organization.id) {
        _this.props.createWorkforceOrganization(_this.props.modulesManager, organization, "Create");
      } else {
        _this.props.updateWorkforceOrganization(_this.props.modulesManager, organization, "Update");
      }
    });
    return _this;
  }
  _inherits(WorkforceBankPage, _Component);
  return _createClass(WorkforceBankPage, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        classes = _this$props.classes,
        modulesManager = _this$props.modulesManager,
        history = _this$props.history,
        rights = _this$props.rights,
        bankUuid = _this$props.bankUuid,
        overview = _this$props.overview;
        _this$props.organization;
        var organizationVersion = _this$props.organizationVersion;
      // const readOnly = organization?.status === TICKET_STATUSES.CLOSED || ticket?.isHistory;
      var readOnly = false;
      // if (!(rights.includes(RIGHT_ORGANIZATION_CREATE) || rights.includes(RIGHT_ORGANIZATION_EDIT))) return null;
      return /*#__PURE__*/React.createElement("div", {
        className: "".concat(null, " ").concat(classes.page)
      }, /*#__PURE__*/React.createElement(BanksForm$1, {
        overview: overview,
        bankUuid: bankUuid,
        organizationVersion: organizationVersion,
        readOnly: readOnly,
        back: function back() {
          return historyPush$1(modulesManager, history, "workforce.route.banks");
        },
        add: rights.includes(RIGHT_ORGANIZATION_CREATE) ? this.add : null,
        save: rights.includes(RIGHT_ORGANIZATION_EDIT) ? this.save : null
      }));
    }
  }]);
}(Component);
var mapStateToProps$G = function mapStateToProps(state, props) {
  return {
    rights: !!state.core && !!state.core.user && !!state.core.user.i_user ? state.core.user.i_user.rights : [],
    bankUuid: props.match.params.bank_uuid,
    organizationVersion: props.match.params.version,
    bank: state.workforce.bank
  };
};
var mapDispatchToProps$p = function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    createWorkforceOrganization: createWorkforceOrganization,
    updateWorkforceOrganization: updateWorkforceOrganization
  }, dispatch);
};
var WorkforceBankPage$1 = withHistory(withModulesManager(connect(mapStateToProps$G, mapDispatchToProps$p)(withTheme(withStyles(styles$K)(WorkforceBankPage)))));

var RelationPicker = function RelationPicker(_ref) {
  _ref.modulesManager;
    var _onChange = _ref.onChange,
    readOnly = _ref.readOnly,
    required = _ref.required,
    _ref$withLabel = _ref.withLabel,
    withLabel = _ref$withLabel === void 0 ? true : _ref$withLabel,
    withPlaceholder = _ref.withPlaceholder,
    value = _ref.value,
    label = _ref.label,
    placeholder = _ref.placeholder,
    filterOptions = _ref.filterOptions,
    filterSelectedOptions = _ref.filterSelectedOptions;
    _ref.multiple;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2);
    _useState2[0];
    var setSearchString = _useState2[1];
  var _useTranslations = useTranslations("workforce"),
    formatMessage = _useTranslations.formatMessage;

  // Adjust the options to match the EMPLOYEE_RELATION format
  var EMPLOYEE_RELATION = ["spouse", "orphan", "parant", "other", "guardian"];

  // Find the selected option
  var selectedOption = useMemo(function () {
    return EMPLOYEE_RELATION.includes(value) ? value : null;
  }, [value]);
  return /*#__PURE__*/React.createElement(Autocomplete, {
    multiple: false,
    required: required,
    placeholder: placeholder !== null && placeholder !== void 0 ? placeholder : "",
    label: label !== null && label !== void 0 ? label : formatMessage("workforce.employee.relation.picker"),
    withLabel: withLabel,
    withPlaceholder: withPlaceholder,
    readOnly: readOnly,
    isLoading: false // Set to false if not loading data dynamically
    ,
    options: EMPLOYEE_RELATION,
    value: selectedOption,
    getOptionLabel: function getOptionLabel(option) {
      return option;
    } // Since options are strings, return the string directly
    ,
    onChange: function onChange(option) {
      return _onChange(option, option !== null && option !== void 0 ? option : null);
    },
    filterOptions: filterOptions,
    filterSelectedOptions: filterSelectedOptions,
    onInputChange: setSearchString
  });
};

function _callSuper$L(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$L() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$L() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$L = function _isNativeReflectConstruct() { return !!t; })(); }
// import { FormattedMessage } from "../../../../../openimis-fe-core_js/src";

var styles$J = function styles(theme) {
  return {
    dialogTitle: theme.dialog.title,
    dialogContent: theme.dialog.content,
    form: {
      padding: 0
    },
    item: {
      padding: theme.spacing(1)
    },
    paperDivider: theme.paper.divider
  };
};
var WORKFORCE_ORGANIZATION_EMPLOYEE_FILTER_CONTRIBUTION_KEY$1 = "workforce.organization.employee.Filter";
var DependentFilter$1 = /*#__PURE__*/function (_Component) {
  function DependentFilter() {
    var _this;
    _classCallCheck(this, DependentFilter);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper$L(this, DependentFilter, [].concat(args));
    _defineProperty(_this, "debouncedOnChangeFilter", _debounce(_this.props.onChangeFilters, 800));
    _defineProperty(_this, "_filterValue", function (k) {
      var filters = _this.props.filters;
      return !!filters && !!filters[k] ? filters[k].value : null;
    });
    _defineProperty(_this, "_onChangeReporter", function (k, v) {
      _this.props.onChangeFilters([{
        id: k,
        value: v,
        filter: "".concat(k, ": \"").concat(decodeId(v === null || v === void 0 ? void 0 : v.id), "\"")
      }]);
    });
    _defineProperty(_this, "_onChangeCheckbox", function (key, value) {
      var filters = [{
        id: key,
        value: value,
        filter: "".concat(key, ": ").concat(value)
      }];
      _this.props.onChangeFilters(filters);
      _this.props.setShowHistoryFilter(value);
    });
    return _this;
  }
  _inherits(DependentFilter, _Component);
  return _createClass(DependentFilter, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        classes = _this$props.classes,
        filters = _this$props.filters,
        onChangeFilters = _this$props.onChangeFilters;
      return /*#__PURE__*/React.createElement(Grid, {
        container: true,
        className: classes.form
      }, /*#__PURE__*/React.createElement(ControlledField, {
        module: MODULE_NAME,
        id: "workforce.organization.name.employee.en",
        field: /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 3,
          className: classes.item
        }, /*#__PURE__*/React.createElement(TextInput, {
          module: MODULE_NAME,
          label: "workforce.organization.employee.name.en",
          name: "nameEn",
          value: this._filterValue("nameEn"),
          onChange: function onChange(v) {
            return _this2.debouncedOnChangeFilter([{
              id: "nameEn",
              value: v,
              filter: "nameEn_Icontains: \"".concat(v, "\"")
            }]);
          }
        }))
      }), /*#__PURE__*/React.createElement(ControlledField, {
        module: MODULE_NAME,
        id: "workforce.organization.employee.name.bn",
        field: /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 3,
          className: classes.item
        }, /*#__PURE__*/React.createElement(RelationPicker, {
          module: MODULE_NAME,
          value: this._filterValue("relation"),
          label: /*#__PURE__*/React.createElement(FormattedMessage, {
            id: "workforce.employee.relation.picker",
            module: "workforce"
          }),
          onChange: function onChange(v) {
            return _this2.debouncedOnChangeFilter([{
              id: "relation",
              value: v,
              filter: "relation_Icontains: \"".concat(v, "\"")
            }]);
          }
          // onChange={(v) => this.updateAttribute("lifeStatus", v)}
          // readOnly={isSaved}
        }))
      }), /*#__PURE__*/React.createElement(ControlledField, {
        module: MODULE_NAME,
        id: "workforce.organization.employee.phone",
        field: /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 3,
          className: classes.item
        }, /*#__PURE__*/React.createElement(EmployeeLifeStatusPicker, {
          module: MODULE_NAME,
          value: this._filterValue("lifeStatus"),
          label: /*#__PURE__*/React.createElement(FormattedMessage, {
            id: "workforce.employee.lifeStatus",
            module: "workforce"
          }),
          onChange: function onChange(v) {
            return _this2.debouncedOnChangeFilter([{
              id: "lifeStatus",
              value: v,
              filter: "lifeStatus_Icontains: \"".concat(v, "\"")
            }]);
          }
          // onChange={(v) => this.updateAttribute("lifeStatus", v)}
          // readOnly={isSaved}
        }))
      }), /*#__PURE__*/React.createElement(Contributions, {
        filters: filters,
        onChangeFilters: onChangeFilters,
        contributionKey: WORKFORCE_ORGANIZATION_EMPLOYEE_FILTER_CONTRIBUTION_KEY$1
      }));
    }
  }]);
}(Component);
var DependentFilter$2 = withModulesManager(withTheme(withStyles(styles$J)(DependentFilter$1)));

function _callSuper$K(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$K() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$K() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$K = function _isNativeReflectConstruct() { return !!t; })(); }
function ownKeys$1r(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$1r(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$1r(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1r(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var styles$I = function styles(theme) {
  return {
    paper: _objectSpread$1r(_objectSpread$1r({}, theme.paper.paper), {}, {
      margin: 0
    }),
    paperHeader: _objectSpread$1r(_objectSpread$1r({}, theme.paper.header), {}, {
      padding: 10
    }),
    tableTitle: theme.table.title,
    fab: theme.fab,
    button: {
      margin: theme.spacing(1)
    },
    item: {
      padding: theme.spacing(1)
    },
    horizontalButtonContainer: _objectSpread$1r(_objectSpread$1r({}, theme.buttonContainer.horizontal), {}, {
      display: "flex",
      alignItems: "center",
      gap: theme.spacing(1)
    }),
    compactButton: {
      maxHeight: "30px",
      minWidth: "80px",
      padding: "1px 4px",
      borderRadius: "6px",
      backgroundColor: "#006273",
      color: "white",
      fontSize: "0.7rem",
      textTransform: "none",
      marginRight: "2px",
      "&:hover": {
        backgroundColor: "#004a5e"
      }
    },
    buttonContainer: {
      display: "flex",
      gap: theme.spacing(1)
    }
  };
};
var DependentSearcher = /*#__PURE__*/function (_Component) {
  function DependentSearcher(props) {
    var _this;
    _classCallCheck(this, DependentSearcher);
    _this = _callSuper$K(this, DependentSearcher, [props]);
    _defineProperty(_this, "fetch", function (prms) {
      var _this$state = _this.state,
        showHistoryFilter = _this$state.showHistoryFilter;
        _this$state.workforceEmployeeUuid;
      _this.setState({
        displayVersion: showHistoryFilter
      });
      _this.props.fetchDependentsSummary(_this.props.modulesManager, prms);
      _this.props.fetchWorkforceEmployee(_this.props.modulesManager, ["id: \"".concat(_this.state.workforceEmployeeUuid, "\"")]);
    });
    _defineProperty(_this, "rowIdentifier", function (r) {
      return r.uuid;
    });
    _defineProperty(_this, "isShowHistory", function () {
      return _this.state.displayVersion;
    });
    _defineProperty(_this, "filtersToQueryParams", function (state) {
      var prms = Object.keys(state.filters).filter(function (f) {
        return !!state.filters[f].filter;
      }).map(function (f) {
        return state.filters[f].filter;
      });
      prms.push("first: ".concat(state.pageSize));
      if (state.afterCursor) {
        prms.push("after: \"".concat(state.afterCursor, "\""));
      }
      if (state.beforeCursor) {
        prms.push("before: \"".concat(state.beforeCursor, "\""));
      }
      if (state.orderBy) {
        prms.push("orderBy: [\"".concat(state.orderBy, "\"]"));
      }
      return prms;
    });
    _defineProperty(_this, "headers", function () {
      return ["workforce.employee.first.name.en", "workforce.employee.first.name.bn", "workforce.employee.nid", "workforce.employee.phone", "workforce.employee.email", _this.isShowHistory() ? "workforce.version" : ""];
    });
    _defineProperty(_this, "sorts", function () {
      return [];
    });
    _defineProperty(_this, "itemFormatters", function () {
      var formatters = [function (workforceemployee) {
        return workforceemployee.firstNameEn;
      }, function (workforceemployee) {
        return workforceemployee.firstNameBn;
      }, function (workforceemployee) {
        return workforceemployee.nid;
      }, function (workforceemployee) {
        return workforceemployee.phoneNumber;
      }, function (workforceemployee) {
        return workforceemployee.email;
      }, function (workforceemployee) {
        return _this.isShowHistory() ? workforceemployee === null || workforceemployee === void 0 ? void 0 : workforceemployee.version : null;
      }];
      formatters.push(function (workforceemployee) {
        return /*#__PURE__*/React.createElement(Tooltip, {
          title: "Edit"
        }, /*#__PURE__*/React.createElement(IconButton, {
          disabled: workforceemployee === null || workforceemployee === void 0 ? void 0 : workforceemployee.isHistory,
          onClick: function onClick() {
            historyPush$1(_this.props.modulesManager, _this.props.history, "workforce.route.employees.dependents.dependent", [decodeId(workforceemployee.id)], false);
          }
        }, /*#__PURE__*/React.createElement(EditIcon, null)));
      });
      return formatters;
    });
    _defineProperty(_this, "rowDisabled", function (selection, i) {
      return !!i.validityTo;
    });
    _defineProperty(_this, "rowLocked", function (selection, i) {
      return !!i.clientMutationId;
    });
    _this.state = {
      chfid: null,
      confirmedAction: null,
      reset: 0,
      showHistoryFilter: false,
      workforceEmployeeUuid: null,
      displayVersion: false
    };
    _this.rowsPerPageOptions = [10, 20, 50, 100];
    _this.defaultPageSize = 10;
    return _this;
  }
  _inherits(DependentSearcher, _Component);
  return _createClass(DependentSearcher, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.workforceEmployeeUuid) {
        this.setState(function (state, props) {
          return {
            workforceEmployeeUuid: props.workforceEmployeeUuid
          };
        });
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState, snapshot) {
      if (prevProps.submittingMutation && !this.props.submittingMutation) {
        this.props.journalize(this.props.mutation);
        this.setState({
          reset: prevState.reset + 1
        });
      } else if (!prevProps.confirmed && this.props.confirmed) {
        this.state.confirmedAction();
      }
      if (prevProps.fetchedWorkforceEmployee !== this.props.fetchedWorkforceEmployee && !!this.props.fetchedWorkforceEmployee && !!this.props.workforceEmployee) {
        this.setState(function (state, props) {
          return {
            workforceEmployee: _objectSpread$1r({}, props.workforceEmployee),
            workforceEmployeeUuid: props.workforceEmployee.id,
            lockNew: false
          };
        });
      } else if (prevState.workforceEmployeeUuid !== this.state.workforceEmployeeUuid) {
        var filters = ["id: \"".concat(this.state.workforceEmployeeUuid, "\"")];
        this.props.fetchWorkforceEmployee(this.props.modulesManager, filters);
      } else if (prevProps.submittingMutation && !this.props.submittingMutation) {
        var _this$props;
        this.props.journalize(this.props.mutation);
        this.setState(function (state) {
          return {
            reset: state.reset + 1
          };
        });
        if ((_this$props = this.props) !== null && _this$props !== void 0 && (_this$props = _this$props.workforceEmployee) !== null && _this$props !== void 0 && _this$props.id) {
          this.props.fetchWorkforceEmployee(this.props.modulesManager, ["id: \"".concat(this.state.workforceEmployeeUuid, "\"")]);
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props2 = this.props;
        _this$props2.intl;
        var employeeDependents = _this$props2.employeeDependents,
        employeeDependentsPageInfo = _this$props2.employeeDependentsPageInfo,
        fetchingEmployeeDependents = _this$props2.fetchingEmployeeDependents,
        fetchedEmployeeDependents = _this$props2.fetchedEmployeeDependents,
        fetchedWorkforceEmployee = _this$props2.fetchedWorkforceEmployee,
        errorEmployeeDependents = _this$props2.errorEmployeeDependents,
        filterPaneContributionsKey = _this$props2.filterPaneContributionsKey,
        cacheFiltersKey = _this$props2.cacheFiltersKey,
        _onDoubleClick = _this$props2.onDoubleClick;
      var _this$state2 = this.state;
        _this$state2.lockNew;
        _this$state2.reset;
        _this$state2.update;
        _this$state2.overview;
        var workforceEmployeeUuid = _this$state2.workforceEmployeeUuid;
        _this$state2.ticket;
      employeeDependentsPageInfo.totalCount;
      var filterPane = function filterPane(_ref) {
        var filters = _ref.filters,
          onChangeFilters = _ref.onChangeFilters;
        return /*#__PURE__*/React.createElement(DependentFilter$2, {
          filters: filters,
          onChangeFilters: onChangeFilters,
          setShowHistoryFilter: function setShowHistoryFilter(showHistoryFilter) {
            return _this2.setState({
              showHistoryFilter: showHistoryFilter
            });
          }
        });
      };
      console.log({
        employeeDependents: employeeDependents
      });
      return /*#__PURE__*/React.createElement(React.Fragment, null, (!!fetchedWorkforceEmployee || !workforceEmployeeUuid) && /*#__PURE__*/React.createElement(Searcher$2, {
        module: MODULE_NAME,
        cacheFiltersKey: cacheFiltersKey,
        FilterPane: filterPane,
        filterPaneContributionsKey: filterPaneContributionsKey,
        items: employeeDependents,
        itemsPageInfo: employeeDependentsPageInfo,
        fetchingItems: fetchingEmployeeDependents,
        fetchedItems: fetchedEmployeeDependents,
        errorItems: errorEmployeeDependents,
        tableTitle: /*#__PURE__*/React.createElement(FormattedMessage, {
          module: MODULE_NAME,
          id: "menu.workforce.employee.dependent"
        }),
        rowsPerPageOptions: this.rowsPerPageOptions,
        defaultPageSize: this.defaultPageSize,
        fetch: this.fetch,
        rowIdentifier: this.rowIdentifier,
        filtersToQueryParams: this.filtersToQueryParams,
        defaultOrderBy: "-dateCreated",
        headers: this.headers,
        itemFormatters: this.itemFormatters,
        sorts: this.sorts,
        rowDisabled: this.rowDisabled,
        rowLocked: this.rowLocked,
        onDoubleClick: function onDoubleClick(i) {
          return !i.clientMutationId && _onDoubleClick(i);
        },
        reset: this.state.reset
      }));
    }
  }]);
}(Component);
var mapStateToProps$F = function mapStateToProps(state) {
  return {
    rights: !!state.core && !!state.core.user && !!state.core.user.i_user ? state.core.user.i_user.rights : [],
    employeeDependents: state.workforce.employeeDependents,
    employeeDependentsPageInfo: state.workforce.employeeDependentsPageInfo,
    fetchingEmployeeDependents: state.workforce.fetchingEmployeeDependents,
    fetchedEmployeeDependents: state.workforce.fetchedEmployeeDependents,
    fetchedWorkforceEmployee: state.workforce.fetchedWorkforceEmployee,
    workforceEmployee: state.workforce.workforceEmployee,
    errorEmployeeDependents: state.workforce.errorEmployeeDependents,
    submittingMutation: state.workforce.submittingMutation,
    mutation: state.workforce.mutation,
    confirmed: state.core.confirmed
  };
};
var mapDispatchToProps$o = function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    fetchDependentsSummary: fetchDependentsSummary,
    fetchWorkforceEmployee: fetchWorkforceEmployee,
    journalize: journalize,
    coreConfirm: coreConfirm
  }, dispatch);
};
var DependentSearcher$1 = withModulesManager(withHistory(connect(mapStateToProps$F, mapDispatchToProps$o)(withTheme(withStyles(styles$I)(DependentSearcher)))));

function _callSuper$J(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$J() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$J() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$J = function _isNativeReflectConstruct() { return !!t; })(); }
var styles$H = function styles(theme) {
  return {
    page: theme.page,
    fab: theme.fab,
    ROUTE_WORKFORCE_ORGANIZATIONS_EMPLOYEES_EMPLOYEE: ROUTE_WORKFORCE_ORGANIZATIONS_EMPLOYEES_EMPLOYEE
  };
};
var DependentsPage = /*#__PURE__*/function (_Component) {
  function DependentsPage() {
    var _this;
    _classCallCheck(this, DependentsPage);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper$J(this, DependentsPage, [].concat(args));
    _defineProperty(_this, "onDoubleClick", function (employee) {
      var newTab = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var routeParams = ["workforce.route.employees.dependents.dependent", [decodeId(employee.id)]];
      if (employee !== null && employee !== void 0 && employee.isHistory) {
        routeParams[1].push(employee.version);
      }
      historyPush$1.apply(void 0, [_this.props.modulesManager, _this.props.history].concat(routeParams, [newTab]));
    });
    _defineProperty(_this, "onAdd", function () {
      historyPush$1(_this.props.modulesManager, _this.props.history, "workforce.route.employees.dependents.dependent");
    });
    return _this;
  }
  _inherits(DependentsPage, _Component);
  return _createClass(DependentsPage, [{
    key: "render",
    value: function render() {
      var _this$props = this.props;
        _this$props.intl;
        var classes = _this$props.classes;
        _this$props.rights;
        var workforceEmployeeUuid = _this$props.workforceEmployeeUuid;
      return /*#__PURE__*/React.createElement("div", {
        className: classes.page
      }, /*#__PURE__*/React.createElement(DependentSearcher$1, {
        cacheFiltersKey: "ticketPageFiltersCache",
        onDoubleClick: this.onDoubleClick,
        workforceEmployeeUuid: workforceEmployeeUuid
      }), withTooltip(/*#__PURE__*/React.createElement("div", {
        className: classes.fab
      }, /*#__PURE__*/React.createElement(Fab, {
        color: "primary",
        onClick: this.onAdd
      }, /*#__PURE__*/React.createElement(AddIcon, null))), /*#__PURE__*/React.createElement(FormattedMessage, {
        module: MODULE_NAME,
        id: "workforce.organization.employee.addNewTooltip"
      })));
    }
  }]);
}(Component);
var mapStateToProps$E = function mapStateToProps(state) {
  return {
    rights: !!state.core && !!state.core.user && !!state.core.user.i_user ? state.core.user.i_user.rights : [],
    workforceEmployeeUuid: props.match.params.workforce_employee_uuid
  };
};
var DependentsPage$1 = withModulesManager(withHistory(connect(mapStateToProps$E)(withTheme(withStyles(styles$H)(DependentsPage)))));

function ownKeys$1q(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$1q(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$1q(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1q(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper$I(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$I() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$I() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$I = function _isNativeReflectConstruct() { return !!t; })(); }
var styles$G = function styles(theme) {
  return {
    paper: theme.paper.paper,
    tableTitle: theme.table.title,
    item: theme.paper.item,
    fullHeight: {
      height: "100%"
    }
  };
};
var EditDependentPage = /*#__PURE__*/function (_Component) {
  function EditDependentPage(props) {
    var _this;
    _classCallCheck(this, EditDependentPage);
    _this = _callSuper$I(this, EditDependentPage, [props]);
    _defineProperty(_this, "updateAttribute", function (key, value) {
      _this.setState(function (prevState) {
        return {
          stateEdited: _objectSpread$1q(_objectSpread$1q({}, prevState.stateEdited), {}, _defineProperty({}, key, value)),
          isSaved: false
        };
      });
    });
    _defineProperty(_this, "save", function () {
      var _stateEdited$gender;
      var _this$props = _this.props;
        _this$props.grievanceConfig;
        var dispatch = _this$props.dispatch;
      var stateEdited = _this.state.stateEdited;
      var employeeDependentData = {
        firstNameBn: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.firstNameBn) || stateEdited.firstNameBn,
        lastNameBn: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.lastNameBn) || stateEdited.lastNameBn,
        firstNameEn: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.firstNameEn) || stateEdited.firstNameEn,
        lastNameEn: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.lastNameEn) || stateEdited.lastNameEn,
        phoneNumber: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.phoneNumber) || stateEdited.phoneNumber,
        email: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.email) || stateEdited.email,
        gender: (stateEdited === null || stateEdited === void 0 || (_stateEdited$gender = stateEdited.gender) === null || _stateEdited$gender === void 0 ? void 0 : _stateEdited$gender.id) || stateEdited.gender.id,
        birthDate: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.birthDate) || stateEdited.birthDate,
        deathDate: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.deathDate) || stateEdited.deathDate,
        lifeStatus: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.lifeStatus) || stateEdited.lifeStatus,
        permanentAddress: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.permanentAddress) || stateEdited.permanentAddress,
        presentAddress: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.presentAddress) || stateEdited.presentAddress,
        monthlyEarning: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.monthlyEarning) || stateEdited.monthlyEarning,
        fatherNameBn: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.fatherNameBn) || stateEdited.fatherNameBn,
        fatherNameEn: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.fatherNameEn) || stateEdited.fatherNameEn,
        motherNameBn: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.motherNameBn) || stateEdited.motherNameBn,
        motherNameEn: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.motherNameEn) || stateEdited.motherNameEn,
        insuranceNumber: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.insuranceNumber) || stateEdited.insuranceNumber,
        birthCertificateNo: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.birthCertificateNo) || stateEdited.birthCertificateNo,
        nid: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.nid) || stateEdited.nid,
        maritalStatus: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.maritalStatus) || stateEdited.maritalStatus,
        occupation: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.occupation) || stateEdited.occupation,
        presentLocation: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.presentLocation) || stateEdited.presentLocation,
        permanentLocation: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.permanentLocation) || stateEdited.permanentLocation,
        relationType: "dependent",
        relationWithWorker: "Wife",
        id: stateEdited.id
      };
      dispatch(updateEmployeeDependent$1(employeeDependentData, "Update Workforce Employee ".concat(employeeDependentData.nameEn)));
      _this.setState({
        isSaved: true
      });
    });
    _this.state = {
      stateEdited: props.employeeDependent || {},
      isSaved: false
    };
    return _this;
  }
  _inherits(EditDependentPage, _Component);
  return _createClass(EditDependentPage, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.employeeDependent !== this.props.employeeDependent) {
        this.setState({
          stateEdited: this.props.employeeDependent
        });
      }
      if (prevProps.submittingMutation && !this.props.submittingMutation) {
        this.props.dispatch(journalize(this.props.mutation));
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var classes = this.props.classes;
      var _this$state = this.state,
        stateEdited = _this$state.stateEdited,
        isSaved = _this$state.isSaved;
      console.log({
        stateEdited: stateEdited
      });
      return /*#__PURE__*/React.createElement("div", {
        className: classes.page
      }, /*#__PURE__*/React.createElement(Grid, {
        container: true
      }, /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12
      }, /*#__PURE__*/React.createElement(Paper, {
        className: classes.paper
      }, /*#__PURE__*/React.createElement(Grid, {
        container: true,
        className: classes.tableTitle
      }, /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12,
        className: classes.tableTitle
      }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(FormattedMessage, {
        module: MODULE_NAME,
        id: "Employee Dependent",
        values: {
          label: EMPTY_STRING
        }
      })))), /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement(Grid, {
        container: true,
        className: classes.item
      }, /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.employee.nid",
        value: stateEdited.nid || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("nid", v);
        },
        type: "number",
        required: true,
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(PublishedComponent, {
        pubRef: "workforce.DatePicker",
        label: "workforce.employee.birthdate",
        value: stateEdited.birthDate || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("birthDate", v);
        },
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(EmployeeLifeStatusPicker, {
        value: stateEdited.lifeStatus || "",
        label: /*#__PURE__*/React.createElement(FormattedMessage, {
          id: "workforce.employee.lifeStatus",
          module: "workforce"
        }),
        required: true,
        onChange: function onChange(v) {
          return _this2.updateAttribute("lifeStatus", v);
        },
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(PublishedComponent, {
        pubRef: "workforce.DatePicker",
        label: "workforce.employee.deathdate",
        value: stateEdited.deathDate || "",
        readOnly: stateEdited.lifeStatus === "Deceased" ? false : true,
        onChange: function onChange(v) {
          return _this2.updateAttribute("deathDate", v);
        }
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(EmployeeGenderPicker, {
        value: stateEdited.gender || "",
        label: /*#__PURE__*/React.createElement(FormattedMessage, {
          id: "workforce.employee.gender",
          module: "workforce"
        }),
        onChange: function onChange(v) {
          return _this2.updateAttribute("gender", v);
        },
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.employee.first.name.en",
        value: stateEdited.firstNameEn || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("firstNameEn", v);
        },
        required: true,
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.employee.first.name.bn",
        value: stateEdited.firstNameBn || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("firstNameBn", v);
        },
        required: true,
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.employee.last.name.en",
        value: stateEdited.lastNameEn || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("lastNameEn", v);
        },
        required: true,
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.employee.last.name.bn",
        value: stateEdited.lastNameBn || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("lastNameBn", v);
        },
        required: true,
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.employee.fathers_name.en",
        value: stateEdited.fatherNameEn || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("fatherNameEn", v);
        },
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.employee.fathers_name.bn",
        value: stateEdited.fatherNameBn || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("fatherNameBn", v);
        },
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.employee.mothers_name.en",
        value: stateEdited.motherNameEn || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("motherNameEn", v);
        },
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.employee.mothers_name.bn",
        value: stateEdited.motherNameBn || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("motherNameBn", v);
        },
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.employee.phone",
        value: stateEdited.phoneNumber || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("phoneNumber", v);
        },
        type: "number",
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.employee.email",
        value: stateEdited.email || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("email", v);
        },
        type: "email",
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.employee.occupation",
        value: stateEdited.occupation || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("occupation", v);
        },
        type: "email",
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.employee.birth_certificate_no",
        value: stateEdited.birthCertificateNo || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("birthCertificateNo", v);
        },
        type: "number",
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.employee.marital_status",
        value: stateEdited.maritalStatus || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("maritalStatus", v);
        },
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.employee.present_address",
        value: stateEdited.presentAddress || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("presentAddress", v);
        },
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.employee.permanent_address",
        value: stateEdited.permanentAddress || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("permanentAddress", v);
        },
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12,
        className: classes.item
      }, /*#__PURE__*/React.createElement("p", null, "Present Location"), /*#__PURE__*/React.createElement(PublishedComponent, {
        pubRef: "location.DetailedLocation",
        withNull: true,
        value: stateEdited.presentLocation || null,
        onChange: function onChange(presentLocation) {
          return _this2.updateAttribute("presentLocation", presentLocation);
        },
        readOnly: isSaved,
        required: true,
        split: true
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12,
        className: classes.item
      }, /*#__PURE__*/React.createElement("p", null, "Permanent Location"), /*#__PURE__*/React.createElement(PublishedComponent, {
        pubRef: "location.DetailedLocation",
        withNull: true,
        value: stateEdited.permanentLocation || null,
        onChange: function onChange(permanentLocation) {
          return _this2.updateAttribute("permanentLocation", permanentLocation);
        },
        readOnly: isSaved,
        required: true,
        split: true
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 11,
        className: classes.item
      }), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 1,
        className: classes.item
      }, /*#__PURE__*/React.createElement(IconButton, {
        variant: "contained",
        component: "label",
        color: "primary",
        onClick: this.save,
        disabled: isSaved
      }, /*#__PURE__*/React.createElement(Save, null)))), /*#__PURE__*/React.createElement(Divider, null)))));
    }
  }]);
}(Component);
var mapStateToProps$D = function mapStateToProps(state) {
  return {
    employeeDependent: state.workforce.employeeDependent
  };
};
var EditDependentPage$1 = connect(mapStateToProps$D)(withStyles(styles$G)(EditDependentPage));

function ownKeys$1p(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$1p(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$1p(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1p(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper$H(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$H() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$H() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$H = function _isNativeReflectConstruct() { return !!t; })(); }
var styles$F = function styles(theme) {
  return {
    paper: theme.paper.paper,
    tableTitle: theme.table.title,
    item: theme.paper.item,
    fullHeight: {
      height: "100%"
    }
  };
};
var AddDependentPage = /*#__PURE__*/function (_Component) {
  function AddDependentPage(props) {
    var _this;
    _classCallCheck(this, AddDependentPage);
    _this = _callSuper$H(this, AddDependentPage, [props]);
    _defineProperty(_this, "save", function () {
      var _stateEdited$gender;
      var _this$props = _this.props;
        _this$props.grievanceConfig;
        var dispatch = _this$props.dispatch;
      var stateEdited = _this.state.stateEdited;
      var employeeDependentData = {
        firstNameBn: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.firstNameBn) || stateEdited.firstNameBn,
        lastNameBn: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.lastNameBn) || stateEdited.lastNameBn,
        firstNameEn: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.firstNameEn) || stateEdited.firstNameEn,
        lastNameEn: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.lastNameEn) || stateEdited.lastNameEn,
        phoneNumber: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.phoneNumber) || stateEdited.phoneNumber,
        email: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.email) || stateEdited.email,
        gender: (stateEdited === null || stateEdited === void 0 || (_stateEdited$gender = stateEdited.gender) === null || _stateEdited$gender === void 0 ? void 0 : _stateEdited$gender.id) || stateEdited.gender.id,
        birthDate: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.birthDate) || stateEdited.birthDate,
        deathDate: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.deathDate) || stateEdited.deathDate,
        lifeStatus: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.lifeStatus) || stateEdited.lifeStatus,
        permanentAddress: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.permanentAddress) || stateEdited.permanentAddress,
        presentAddress: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.presentAddress) || stateEdited.presentAddress,
        monthlyEarning: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.monthlyEarning) || stateEdited.monthlyEarning,
        fatherNameBn: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.fatherNameBn) || stateEdited.fatherNameBn,
        fatherNameEn: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.fatherNameEn) || stateEdited.fatherNameEn,
        motherNameBn: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.motherNameBn) || stateEdited.motherNameBn,
        motherNameEn: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.motherNameEn) || stateEdited.motherNameEn,
        insuranceNumber: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.insuranceNumber) || stateEdited.insuranceNumber,
        birthCertificateNo: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.birthCertificateNo) || stateEdited.birthCertificateNo,
        nid: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.nid) || stateEdited.nid,
        maritalStatus: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.maritalStatus) || stateEdited.maritalStatus,
        occupation: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.occupation) || stateEdited.occupation,
        presentLocation: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.presentLocation) || stateEdited.presentLocation,
        permanentLocation: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.permanentLocation) || stateEdited.permanentLocation,
        relationType: "dependent",
        relationWithWorker: "Wife",
        id: stateEdited.id
      };
      dispatch(updateEmployeeDependent(employeeDependentData, "Update Workforce Employee ".concat(employeeDependentData.nameEn)));
      _this.setState({
        isSaved: true
      });
    });
    _defineProperty(_this, "updateAttribute", function (key, value) {
      _this.setState(function (prevState) {
        return {
          stateEdited: _objectSpread$1p(_objectSpread$1p({}, prevState.stateEdited), {}, _defineProperty({}, key, value)),
          isSaved: false
        };
      });
    });
    _this.state = {
      stateEdited: {},
      isSaved: false
    };
    return _this;
  }
  _inherits(AddDependentPage, _Component);
  return _createClass(AddDependentPage, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props2 = this.props,
        submittingMutation = _this$props2.submittingMutation,
        mutation = _this$props2.mutation,
        dispatch = _this$props2.dispatch;
      if (!submittingMutation && prevProps.submittingMutation !== submittingMutation) {
        dispatch(journalize(mutation));
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var classes = this.props.classes;
      var _this$state = this.state,
        stateEdited = _this$state.stateEdited,
        isSaved = _this$state.isSaved;
      console.log({
        stateEdited: stateEdited
      });
      return /*#__PURE__*/React.createElement("div", {
        className: classes.page
      }, /*#__PURE__*/React.createElement(Grid, {
        container: true
      }, /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12
      }, /*#__PURE__*/React.createElement(Paper, {
        className: classes.paper
      }, /*#__PURE__*/React.createElement(Grid, {
        container: true,
        className: classes.tableTitle
      }, /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12,
        className: classes.tableTitle
      }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(FormattedMessage, {
        module: MODULE_NAME,
        id: "Workforce Employee",
        values: {
          label: EMPTY_STRING
        }
      })))), /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement(Grid, {
        container: true,
        className: classes.item
      }, /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.employee.nid",
        value: stateEdited.nid || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("nid", v);
        },
        type: "number",
        required: true,
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(PublishedComponent, {
        pubRef: "workforce.DatePicker",
        label: "workforce.employee.birthdate",
        value: stateEdited.birthDate || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("birthDate", v);
        },
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(EmployeeLifeStatusPicker, {
        value: stateEdited.lifeStatus || "",
        label: /*#__PURE__*/React.createElement(FormattedMessage, {
          id: "workforce.employee.lifeStatus",
          module: "workforce"
        }),
        required: true,
        onChange: function onChange(v) {
          return _this2.updateAttribute("lifeStatus", v);
        },
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(PublishedComponent, {
        pubRef: "workforce.DatePicker",
        label: "workforce.employee.deathdate",
        value: stateEdited.deathDate || "",
        readOnly: stateEdited.lifeStatus === "Deceased" ? false : true,
        onChange: function onChange(v) {
          return _this2.updateAttribute("deathDate", v);
        }
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(EmployeeGenderPicker, {
        value: stateEdited.gender || "",
        label: /*#__PURE__*/React.createElement(FormattedMessage, {
          id: "workforce.employee.gender",
          module: "workforce"
        }),
        onChange: function onChange(v) {
          return _this2.updateAttribute("gender", v);
        },
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.employee.first.name.en",
        value: stateEdited.firstNameEn || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("firstNameEn", v);
        },
        required: true,
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.employee.first.name.bn",
        value: stateEdited.firstNameBn || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("firstNameBn", v);
        },
        required: true,
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.employee.last.name.en",
        value: stateEdited.lastNameEn || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("lastNameEn", v);
        },
        required: true,
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.employee.last.name.bn",
        value: stateEdited.lastNameBn || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("lastNameBn", v);
        },
        required: true,
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.employee.fathers_name.en",
        value: stateEdited.fatherNameEn || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("fatherNameEn", v);
        },
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.employee.fathers_name.bn",
        value: stateEdited.fatherNameBn || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("fatherNameBn", v);
        },
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.employee.mothers_name.en",
        value: stateEdited.motherNameEn || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("motherNameEn", v);
        },
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.employee.mothers_name.bn",
        value: stateEdited.motherNameBn || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("motherNameBn", v);
        },
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.employee.phone",
        value: stateEdited.phoneNumber || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("phoneNumber", v);
        },
        type: "number",
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.employee.email",
        value: stateEdited.email || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("email", v);
        },
        type: "email",
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.employee.occupation",
        value: stateEdited.occupation || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("occupation", v);
        },
        type: "email",
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.employee.birth_certificate_no",
        value: stateEdited.birthCertificateNo || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("birthCertificateNo", v);
        },
        type: "number",
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.employee.marital_status",
        value: stateEdited.maritalStatus || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("maritalStatus", v);
        },
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.employee.present_address",
        value: stateEdited.presentAddress || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("presentAddress", v);
        },
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.employee.permanent_address",
        value: stateEdited.permanentAddress || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("permanentAddress", v);
        },
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12,
        className: classes.item
      }, /*#__PURE__*/React.createElement("p", null, "Present Location"), /*#__PURE__*/React.createElement(PublishedComponent, {
        pubRef: "location.DetailedLocation",
        withNull: true,
        value: stateEdited.presentLocation || null,
        onChange: function onChange(presentLocation) {
          return _this2.updateAttribute("presentLocation", presentLocation);
        },
        readOnly: isSaved,
        required: true,
        split: true
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12,
        className: classes.item
      }, /*#__PURE__*/React.createElement("p", null, "Permanent Location"), /*#__PURE__*/React.createElement(PublishedComponent, {
        pubRef: "location.DetailedLocation",
        withNull: true,
        value: stateEdited.permanentLocation || null,
        onChange: function onChange(permanentLocation) {
          return _this2.updateAttribute("permanentLocation", permanentLocation);
        },
        readOnly: isSaved,
        required: true,
        split: true
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 11,
        className: classes.item
      }), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 1,
        className: classes.item
      }, /*#__PURE__*/React.createElement(IconButton, {
        variant: "contained",
        component: "label",
        color: "primary",
        onClick: this.save,
        disabled: isSaved
      }, /*#__PURE__*/React.createElement(Save, null)))), /*#__PURE__*/React.createElement(Divider, null)))));
    }
  }]);
}(Component);
var mapStateToProps$C = function mapStateToProps(state) {
  return {
    submittingMutation: state.workforce.submittingMutation,
    mutation: state.workforce.mutation
  };
};
var AddDependentPage$1 = connect(mapStateToProps$C)(withStyles(styles$F)(AddDependentPage));

function ownKeys$1o(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$1o(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$1o(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1o(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper$G(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$G() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$G() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$G = function _isNativeReflectConstruct() { return !!t; })(); }
// import EditDependentPage from "../../../pages/workforce-employee/dependent/EditDependentPage";
// import AddDependentPage from "../../../pages/workforce-employee/dependent/AddDependentPage";
var DependentForm = /*#__PURE__*/function (_Component) {
  function DependentForm(props) {
    var _this;
    _classCallCheck(this, DependentForm);
    _this = _callSuper$G(this, DependentForm, [props]);
    _defineProperty(_this, "reload", function () {});
    _defineProperty(_this, "canSave", function () {});
    _defineProperty(_this, "_save", function (ticket) {
      _this.setState({
        lockNew: !ticket.uuid
      }, function () {
        return _this.props.save(ticket);
      });
    });
    _defineProperty(_this, "onEditedChanged", function (ticket) {
      _this.setState({
        ticket: ticket
      });
    });
    _defineProperty(_this, "reopenTicket", function () {
      var _this$props = _this.props,
        intl = _this$props.intl,
        ticket = _this$props.ticket;
      _this.props.reopenTicket(ticket.id, formatMessage(intl, MODULE_NAME, "reopenTicket.mutation.label"));
    });
    _this.state = {
      lockNew: false,
      reset: 0,
      dependentUuid: null,
      ticket: _this._newTicket()
    };
    return _this;
  }
  _inherits(DependentForm, _Component);
  return _createClass(DependentForm, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.dependentUuid) {
        this.setState(function (state, props) {
          return {
            dependentUuid: props.dependentUuid
          };
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {}
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState, snapshot) {
      if (prevProps.fetchedEmployeeDependent !== this.props.fetchedEmployeeDependent && !!this.props.fetchedEmployeeDependent && !!this.props.organizationEmployee) {
        this.setState(function (state, props) {
          return {
            organizationEmployee: _objectSpread$1o({}, props.organizationEmployee),
            dependentUuid: props.organizationEmployee.id,
            lockNew: false
          };
        });
      } else if (prevState.dependentUuid !== this.state.dependentUuid) {
        var filters = ["id: \"".concat(this.state.dependentUuid, "\"")];
        this.props.fetchDependent(this.props.modulesManager, filters);
      } else if (prevProps.submittingMutation && !this.props.submittingMutation) {
        var _this$props2;
        this.props.journalize(this.props.mutation);
        this.setState(function (state) {
          return {
            reset: state.reset + 1
          };
        });
        if ((_this$props2 = this.props) !== null && _this$props2 !== void 0 && (_this$props2 = _this$props2.organizationEmployee) !== null && _this$props2 !== void 0 && _this$props2.id) {
          this.props.fetchDependent(this.props.modulesManager, ["id: \"".concat(this.state.dependentUuid, "\"")]);
        }
      }
    }
  }, {
    key: "_newTicket",
    value: function _newTicket() {
      return {};
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
        fetchingTicket = _this$props3.fetchingTicket,
        fetchedEmployeeDependent = _this$props3.fetchedEmployeeDependent,
        errorTicket = _this$props3.errorTicket,
        save = _this$props3.save,
        back = _this$props3.back;
      var _this$state = this.state,
        lockNew = _this$state.lockNew,
        reset = _this$state.reset,
        update = _this$state.update,
        overview = _this$state.overview,
        dependentUuid = _this$state.dependentUuid,
        ticket = _this$state.ticket;
      var readOnly = lockNew || !!ticket.validityTo || this.props.readOnly;
      [{
        doIt: this.reopenTicket,
        icon: /*#__PURE__*/React.createElement(LockOpenIcon, null),
        disabled: ticket.isHistory
      }];
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ProgressOrError, {
        progress: fetchingTicket,
        error: errorTicket
      }), (!!fetchedEmployeeDependent || !dependentUuid) && /*#__PURE__*/React.createElement(Form, {
        module: MODULE_NAME,
        edited_id: dependentUuid,
        edited: ticket,
        reset: reset,
        update: update,
        title: "Employee Dependent",
        titleParams: {
          label: "Label"
        },
        back: back,
        save: save ? this._save : null,
        canSave: this.canSave,
        reload: (dependentUuid || readOnly) && this.reload,
        readOnly: readOnly,
        overview: overview,
        Panels: dependentUuid ? [EditDependentPage$1] : [AddDependentPage$1],
        onEditedChanged: this.onEditedChanged
      }));
    }
  }]);
}(Component); // eslint-disable-next-line no-unused-vars
var mapStateToProps$B = function mapStateToProps(state, props) {
  return {
    rights: !!state.core && !!state.core.user && !!state.core.user.i_user ? state.core.user.i_user.rights : [],
    fetchingTicket: state.workforce.fetchingTicket,
    errorTicket: state.workforce.errorTicket,
    fetchedEmployeeDependent: state.workforce.fetchedEmployeeDependent,
    ticket: state.workforce.ticket,
    submittingMutation: state.workforce.submittingMutation,
    mutation: state.workforce.mutation,
    grievanceConfig: state.workforce.grievanceConfig
  };
};
var mapDispatchToProps$n = function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    fetchDependent: fetchDependent,
    journalize: journalize
  }, dispatch);
};
var DependentForm$1 = withModulesManager(connect(mapStateToProps$B, mapDispatchToProps$n)(DependentForm));

function _callSuper$F(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$F() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$F() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$F = function _isNativeReflectConstruct() { return !!t; })(); }
var styles$E = function styles(theme) {
  return {
    page: theme.page,
    lockedPage: theme.page.locked
  };
};
var DependentPage = /*#__PURE__*/function (_Component) {
  function DependentPage() {
    var _this;
    _classCallCheck(this, DependentPage);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper$F(this, DependentPage, [].concat(args));
    _defineProperty(_this, "add", function () {
      historyPush$1(_this.props.modulesManager, _this.props.history, "grievance.route.ticket");
    });
    _defineProperty(_this, "save", function (employee) {
      if (!employee.id) {
        _this.props.createEmployeeDependent(_this.props.modulesManager, employee, "Create");
      } else {
        _this.props.updateEmployeeDependent(_this.props.modulesManager, employee, "Update");
      }
    });
    return _this;
  }
  _inherits(DependentPage, _Component);
  return _createClass(DependentPage, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        classes = _this$props.classes,
        modulesManager = _this$props.modulesManager,
        history = _this$props.history,
        rights = _this$props.rights,
        dependentUuid = _this$props.dependentUuid,
        overview = _this$props.overview,
        organizationVersion = _this$props.organizationVersion;
      // const readOnly = organization?.status === TICKET_STATUSES.CLOSED || ticket?.isHistory;
      var readOnly = false;
      // if (!(rights.includes(RIGHT_ORGANIZATION_CREATE) || rights.includes(RIGHT_ORGANIZATION_EDIT))) return null;
      return /*#__PURE__*/React.createElement("div", {
        className: "".concat(null, " ").concat(classes.page)
      }, /*#__PURE__*/React.createElement(DependentForm$1, {
        overview: overview,
        dependentUuid: dependentUuid,
        organizationVersion: organizationVersion,
        readOnly: readOnly,
        back: function back() {
          return historyPush$1(modulesManager, history, "workforce.route.employees.dependents");
        },
        add: rights.includes(RIGHT_ORGANIZATION_CREATE) ? this.add : null,
        save: rights.includes(RIGHT_ORGANIZATION_EDIT) ? this.save : null
      }));
    }
  }]);
}(Component);
var mapStateToProps$A = function mapStateToProps(state, props) {
  return {
    rights: !!state.core && !!state.core.user && !!state.core.user.i_user ? state.core.user.i_user.rights : [],
    dependentUuid: props.match.params.dependent_uuid,
    organizationVersion: props.match.params.version,
    employee: state.workforce.employee
  };
};
var mapDispatchToProps$m = function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    createEmployeeDependent: createEmployeeDependent,
    updateEmployeeDependent: updateEmployeeDependent$1
  }, dispatch);
};
var DependentPage$1 = withHistory(withModulesManager(connect(mapStateToProps$A, mapDispatchToProps$m)(withTheme(withStyles(styles$E)(DependentPage)))));

var EmployeeInjuryTypePicker$1 = function EmployeeInjuryTypePicker(_ref) {
  _ref.modulesManager;
    var _onChange = _ref.onChange,
    readOnly = _ref.readOnly,
    required = _ref.required,
    _ref$withLabel = _ref.withLabel,
    withLabel = _ref$withLabel === void 0 ? true : _ref$withLabel,
    withPlaceholder = _ref.withPlaceholder,
    value = _ref.value,
    label = _ref.label,
    placeholder = _ref.placeholder,
    filterOptions = _ref.filterOptions,
    filterSelectedOptions = _ref.filterSelectedOptions;
    _ref.multiple;
    var applicationType = _ref.applicationType;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2);
    _useState2[0];
    var setSearchString = _useState2[1];
  var _useTranslations = useTranslations("workforce"),
    formatMessage = _useTranslations.formatMessage;

  // Adjust the options to match the EMPLOYEE_INJURY_TYPE format
  // const EMPLOYEE_INJURY_TYPE = ["Disabled", "Deceased"];
  var EMPLOYEE_INJURY_TYPE = ["অক্ষম", "মৃত"];
  var EMPLOYEE_ASSISTANCE_INJURY_TYPE = ["অক্ষম"];

  // Find the selected option
  var selectedOption = useMemo(function () {
    return EMPLOYEE_INJURY_TYPE.includes(value) ? value : null;
  }, [value]);
  return /*#__PURE__*/React.createElement(Autocomplete, {
    multiple: false,
    required: required,
    placeholder: placeholder !== null && placeholder !== void 0 ? placeholder : "",
    label: label !== null && label !== void 0 ? label : formatMessage("workforce.employee.injuryType"),
    withLabel: withLabel,
    withPlaceholder: withPlaceholder,
    readOnly: readOnly,
    isLoading: false // Set to false if not loading data dynamically
    ,
    options: applicationType ? EMPLOYEE_ASSISTANCE_INJURY_TYPE : EMPLOYEE_INJURY_TYPE,
    value: selectedOption,
    getOptionLabel: function getOptionLabel(option) {
      return option;
    } // Since options are strings, return the string directly
    ,
    onChange: function onChange(option) {
      return _onChange(option, option !== null && option !== void 0 ? option : null);
    },
    filterOptions: filterOptions,
    filterSelectedOptions: filterSelectedOptions,
    onInputChange: setSearchString
  });
};

var EmployeeAccidentTypePicker$1 = function EmployeeAccidentTypePicker(_ref) {
  var id = _ref.id;
    _ref.modulesManager;
    var _onChange = _ref.onChange,
    readOnly = _ref.readOnly,
    required = _ref.required,
    _ref$withLabel = _ref.withLabel,
    withLabel = _ref$withLabel === void 0 ? true : _ref$withLabel,
    withPlaceholder = _ref.withPlaceholder,
    value = _ref.value,
    label = _ref.label,
    placeholder = _ref.placeholder,
    filterOptions = _ref.filterOptions,
    filterSelectedOptions = _ref.filterSelectedOptions;
    _ref.multiple;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2);
    _useState2[0];
    var setSearchString = _useState2[1];
  var _useTranslations = useTranslations("workforce"),
    formatMessage = _useTranslations.formatMessage;

  // Adjust the options to match the EMPLOYEE_ACCIDENT_TYPE format
  // const EMPLOYEE_ACCIDENT_TYPE = ["Fire Accident", "Boiler Explosion","Burn Injury","Machinery","Electric Shock","Heavy Weight Fall","Commuting RTA","RTA","Others"];
  var EMPLOYEE_ACCIDENT_TYPE = ["workforce.accident.type.fire_accident", "workforce.accident.type.boiler_explosion", "workforce.accident.type.burn_injury", "workforce.accident.type.machinery", "workforce.accident.type.electric_shock", "workforce.accident.type.heavy_object_fall", "workforce.accident.type.road_accident", "workforce.accident.type.others"];

  // Find the selected option
  var selectedOption = useMemo(function () {
    return EMPLOYEE_ACCIDENT_TYPE.includes(value) ? value : null;
  }, [value]);
  return /*#__PURE__*/React.createElement(Autocomplete, {
    id: id,
    multiple: false,
    required: required,
    placeholder: placeholder !== null && placeholder !== void 0 ? placeholder : "",
    label: label !== null && label !== void 0 ? label : formatMessage("workforce.employee.accident.info.typeOfAccient"),
    withLabel: withLabel,
    withPlaceholder: withPlaceholder,
    readOnly: readOnly,
    isLoading: false // Set to false if not loading data dynamically
    ,
    options: EMPLOYEE_ACCIDENT_TYPE,
    value: selectedOption,
    getOptionLabel: function getOptionLabel(option) {
      return formatMessage(option);
    } // Since options are strings, return the string directly
    ,
    onChange: function onChange(option) {
      return _onChange(option, option !== null && option !== void 0 ? option : null);
    },
    filterOptions: filterOptions,
    filterSelectedOptions: filterSelectedOptions,
    onInputChange: setSearchString
  });
};

var EmployeeInsideOutsideFactoryPicker$1 = function EmployeeInsideOutsideFactoryPicker(_ref) {
  var id = _ref.id;
    _ref.modulesManager;
    var _onChange = _ref.onChange,
    readOnly = _ref.readOnly,
    required = _ref.required,
    _ref$withLabel = _ref.withLabel,
    withLabel = _ref$withLabel === void 0 ? true : _ref$withLabel,
    withPlaceholder = _ref.withPlaceholder,
    value = _ref.value,
    label = _ref.label,
    placeholder = _ref.placeholder,
    filterOptions = _ref.filterOptions,
    filterSelectedOptions = _ref.filterSelectedOptions;
    _ref.multiple;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2);
    _useState2[0];
    var setSearchString = _useState2[1];
  var _useTranslations = useTranslations("workforce"),
    formatMessage = _useTranslations.formatMessage;

  // Adjust the options to match the EMPLOYEE_INSIDE_OUTSIDE_FACTORY format
  // const EMPLOYEE_INSIDE_OUTSIDE_FACTORY = ["Inside Factory", "Outside Factory"];
  var EMPLOYEE_INSIDE_OUTSIDE_FACTORY = ["workforce.accidentType.insideFactory", "workforce.accidentType.fromWorkplaceToHome", "workforce.accidentType.fromHomeToWorkplace", "workforce.accidentType.workRelatedTravel", "workforce.accidentType.otherPlace"];

  // Find the selected option
  var selectedOption = useMemo(function () {
    return EMPLOYEE_INSIDE_OUTSIDE_FACTORY.includes(value) ? value : null;
  }, [value]);
  return /*#__PURE__*/React.createElement(Autocomplete, {
    id: id,
    multiple: false,
    required: required,
    placeholder: placeholder !== null && placeholder !== void 0 ? placeholder : "",
    label: label !== null && label !== void 0 ? label : formatMessage("workforce.employee.accident.info.insideOutsideFactory"),
    withLabel: withLabel,
    withPlaceholder: withPlaceholder,
    readOnly: readOnly,
    isLoading: false // Set to false if not loading data dynamically
    ,
    options: EMPLOYEE_INSIDE_OUTSIDE_FACTORY,
    value: selectedOption,
    getOptionLabel: function getOptionLabel(option) {
      return formatMessage(option);
    } // Since options are strings, return the string directly
    ,
    onChange: function onChange(option) {
      return _onChange(option, option !== null && option !== void 0 ? option : null);
    },
    filterOptions: filterOptions,
    filterSelectedOptions: filterSelectedOptions,
    onInputChange: setSearchString
  });
};

function _callSuper$E(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$E() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$E() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$E = function _isNativeReflectConstruct() { return !!t; })(); }
var styles$D = function styles(theme) {
  return {
    dialogTitle: theme.dialog.title,
    dialogContent: theme.dialog.content,
    form: {
      padding: 0
    },
    item: {
      padding: theme.spacing(1)
    },
    paperDivider: theme.paper.divider
  };
};
var WORKFORCE_EMPLOYEE_AACIDENT_INFO_FILTER_CONTRIBUTION_KEY = "workforce.employee.accident.info.Filter";
var AccidentInfoFilter$1 = /*#__PURE__*/function (_Component) {
  function AccidentInfoFilter() {
    var _this;
    _classCallCheck(this, AccidentInfoFilter);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper$E(this, AccidentInfoFilter, [].concat(args));
    _defineProperty(_this, "debouncedOnChangeFilter", _debounce(_this.props.onChangeFilters, 800));
    _defineProperty(_this, "_filterValue", function (k) {
      var filters = _this.props.filters;
      return !!filters && !!filters[k] ? filters[k].value : null;
    });
    _defineProperty(_this, "_onChangeReporter", function (k, v) {
      _this.props.onChangeFilters([{
        id: k,
        value: v,
        filter: "".concat(k, ": \"").concat(decodeId(v === null || v === void 0 ? void 0 : v.id), "\"")
      }]);
    });
    _defineProperty(_this, "_onChangeCheckbox", function (key, value) {
      var filters = [{
        id: key,
        value: value,
        filter: "".concat(key, ": ").concat(value)
      }];
      _this.props.onChangeFilters(filters);
      _this.props.setShowHistoryFilter(value);
    });
    return _this;
  }
  _inherits(AccidentInfoFilter, _Component);
  return _createClass(AccidentInfoFilter, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        classes = _this$props.classes,
        filters = _this$props.filters,
        onChangeFilters = _this$props.onChangeFilters;
      return /*#__PURE__*/React.createElement(Grid, {
        container: true,
        className: classes.form
      }, /*#__PURE__*/React.createElement(ControlledField, {
        module: MODULE_NAME,
        id: "workforce.employee.accident.info.injuryType",
        field: /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 3,
          className: classes.item
        }, /*#__PURE__*/React.createElement(EmployeeInjuryTypePicker$1, {
          value: this._filterValue("injuryType"),
          label: /*#__PURE__*/React.createElement(FormattedMessage, {
            id: "workforce.employee.accident.info.injuryType",
            module: "workforce"
          }),
          onChange: function onChange(v) {
            return _this2.debouncedOnChangeFilter([{
              id: 'injuryType',
              value: v,
              filter: "injuryType: \"".concat(v, "\"")
            }]);
          },
          readOnly: false
        }))
      }), /*#__PURE__*/React.createElement(ControlledField, {
        module: MODULE_NAME,
        id: "workforce.employee.accident.info.typeOfAccident",
        field: /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 3,
          className: classes.item
        }, /*#__PURE__*/React.createElement(EmployeeAccidentTypePicker$1, {
          value: this._filterValue("accidentType"),
          label: /*#__PURE__*/React.createElement(FormattedMessage, {
            id: "workforce.employee.accident.info.typeOfAccident",
            module: "workforce"
          }),
          onChange: function onChange(v) {
            return _this2.debouncedOnChangeFilter([{
              id: 'accidentType',
              value: v,
              filter: "accidentType: \"".concat(v, "\"")
            }]);
          },
          readOnly: false
        }))
      }), /*#__PURE__*/React.createElement(ControlledField, {
        module: MODULE_NAME,
        id: "workforce.employee.accident.info.insideOutsideFactory",
        field: /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 3,
          className: classes.item
        }, /*#__PURE__*/React.createElement(EmployeeInsideOutsideFactoryPicker$1, {
          value: this._filterValue("inOutsideFactory"),
          label: /*#__PURE__*/React.createElement(FormattedMessage, {
            id: "workforce.employee.accident.info.insideOutsideFactory",
            module: "workforce"
          }),
          onChange: function onChange(v) {
            return _this2.debouncedOnChangeFilter([{
              id: 'inOutsideFactory',
              value: v,
              filter: "inOutsideFactory: \"".concat(v, "\"")
            }]);
          },
          readOnly: false
        }))
      }), /*#__PURE__*/React.createElement(Contributions, {
        filters: filters,
        onChangeFilters: onChangeFilters,
        contributionKey: WORKFORCE_EMPLOYEE_AACIDENT_INFO_FILTER_CONTRIBUTION_KEY
      }));
    }
  }]);
}(Component);
var AccidentInfoFilter$2 = withModulesManager(withTheme(withStyles(styles$D)(AccidentInfoFilter$1)));

function _callSuper$D(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$D() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$D() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$D = function _isNativeReflectConstruct() { return !!t; })(); }
function ownKeys$1n(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$1n(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$1n(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1n(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var styles$C = function styles(theme) {
  return {
    paper: _objectSpread$1n(_objectSpread$1n({}, theme.paper.paper), {}, {
      margin: 0
    }),
    paperHeader: _objectSpread$1n(_objectSpread$1n({}, theme.paper.header), {}, {
      padding: 10
    }),
    tableTitle: theme.table.title,
    fab: theme.fab,
    button: {
      margin: theme.spacing(1)
    },
    item: {
      padding: theme.spacing(1)
    },
    horizontalButtonContainer: _objectSpread$1n(_objectSpread$1n({}, theme.buttonContainer.horizontal), {}, {
      display: "flex",
      alignItems: "center",
      gap: theme.spacing(1)
    }),
    compactButton: {
      maxHeight: "30px",
      minWidth: "80px",
      padding: "1px 4px",
      borderRadius: "6px",
      backgroundColor: "#006273",
      color: "white",
      fontSize: "0.7rem",
      textTransform: "none",
      marginRight: "2px",
      "&:hover": {
        backgroundColor: "#004a5e"
      }
    },
    buttonContainer: {
      display: "flex",
      gap: theme.spacing(1)
    }
  };
};
var AccidentInfoSearcher = /*#__PURE__*/function (_Component) {
  function AccidentInfoSearcher(props) {
    var _this;
    _classCallCheck(this, AccidentInfoSearcher);
    _this = _callSuper$D(this, AccidentInfoSearcher, [props]);
    _defineProperty(_this, "fetch", function (prms) {
      var showHistoryFilter = _this.state.showHistoryFilter;
      _this.setState({
        displayVersion: showHistoryFilter
      });
      _this.props.fetchAccidentInfosSummary(_this.props.modulesManager, prms);
    });
    _defineProperty(_this, "rowIdentifier", function (r) {
      return r.uuid;
    });
    _defineProperty(_this, "isShowHistory", function () {
      return _this.state.displayVersion;
    });
    _defineProperty(_this, "filtersToQueryParams", function (state) {
      var prms = Object.keys(state.filters).filter(function (f) {
        return !!state.filters[f].filter;
      }).map(function (f) {
        return state.filters[f].filter;
      });
      prms.push("first: ".concat(state.pageSize));
      if (state.afterCursor) {
        prms.push("after: \"".concat(state.afterCursor, "\""));
      }
      if (state.beforeCursor) {
        prms.push("before: \"".concat(state.beforeCursor, "\""));
      }
      if (state.orderBy) {
        prms.push("orderBy: [\"".concat(state.orderBy, "\"]"));
      }
      return prms;
    });
    _defineProperty(_this, "headers", function () {
      return ["workforce.employee.accident.info.injuryType", "workforce.employee.accident.info.dateOfAccident", "workforce.employee.accident.info.typeOfAccident", "workforce.employee.accident.info.dutyStatus", "workforce.employee.accident.info.insideOutsideFactory",
      // "workforce.employee.accident.info.reJoiningDate",
      _this.isShowHistory() ? "workforce.version" : ""];
    });
    _defineProperty(_this, "sorts", function () {
      return [];
    });
    _defineProperty(_this, "itemFormatters", function () {
      var _organizationemployee;
      var formatters = [function (organizationemployee) {
        return organizationemployee.injuryType;
      }, function (organizationemployee) {
        return organizationemployee.accidentDate;
      }, function (organizationemployee) {
        return organizationemployee.accidentPlace;
      }, function (organizationemployee) {
        return organizationemployee.accidentType;
      }, function (organizationemployee) {
        return organizationemployee.dutyStatus;
      }, function (organizationemployee) {
        return organizationemployee.inOutsideFactory;
      }, _this.isShowHistory() ? (_organizationemployee = organizationemployee) === null || _organizationemployee === void 0 ? void 0 : _organizationemployee.version : null];
      formatters.push(function (organizationemployee) {
        return /*#__PURE__*/React.createElement(Tooltip, {
          title: "Edit"
        }, /*#__PURE__*/React.createElement(IconButton, {
          disabled: organizationemployee === null || organizationemployee === void 0 ? void 0 : organizationemployee.isHistory,
          onClick: function onClick() {
            historyPush$1(_this.props.modulesManager, _this.props.history, "workforce.route.employees.accident.infos.info", [decodeId(organizationemployee.id)], false);
          }
        }, /*#__PURE__*/React.createElement(EditIcon, null)));
      });
      return formatters;
    });
    _defineProperty(_this, "rowDisabled", function (selection, i) {
      return !!i.validityTo;
    });
    _defineProperty(_this, "rowLocked", function (selection, i) {
      return !!i.clientMutationId;
    });
    _this.state = {
      chfid: null,
      confirmedAction: null,
      reset: 0,
      showHistoryFilter: false,
      displayVersion: false
    };
    _this.rowsPerPageOptions = [10, 20, 50, 100];
    _this.defaultPageSize = 10;
    return _this;
  }
  _inherits(AccidentInfoSearcher, _Component);
  return _createClass(AccidentInfoSearcher, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState, snapshot) {
      if (prevProps.submittingMutation && !this.props.submittingMutation) {
        this.props.journalize(this.props.mutation);
        this.setState({
          reset: prevState.reset + 1
        });
      } else if (!prevProps.confirmed && this.props.confirmed) {
        this.state.confirmedAction();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props;
        _this$props.intl;
        var employeeAccidents = _this$props.employeeAccidents,
        employeeAccidentsPageInfo = _this$props.employeeAccidentsPageInfo,
        fetchingEmployeeAccidents = _this$props.fetchingEmployeeAccidents,
        fetchedEmployeeAccidents = _this$props.fetchedEmployeeAccidents,
        errorEmployeeAccidents = _this$props.errorEmployeeAccidents,
        filterPaneContributionsKey = _this$props.filterPaneContributionsKey,
        cacheFiltersKey = _this$props.cacheFiltersKey,
        _onDoubleClick = _this$props.onDoubleClick;
      employeeAccidentsPageInfo.totalCount;
      var filterPane = function filterPane(_ref) {
        var filters = _ref.filters,
          onChangeFilters = _ref.onChangeFilters;
        return /*#__PURE__*/React.createElement(AccidentInfoFilter$2, {
          filters: filters,
          onChangeFilters: onChangeFilters,
          setShowHistoryFilter: function setShowHistoryFilter(showHistoryFilter) {
            return _this2.setState({
              showHistoryFilter: showHistoryFilter
            });
          }
        });
      };
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Searcher$2, {
        module: MODULE_NAME,
        cacheFiltersKey: cacheFiltersKey,
        FilterPane: filterPane,
        filterPaneContributionsKey: filterPaneContributionsKey,
        items: employeeAccidents,
        itemsPageInfo: employeeAccidentsPageInfo,
        fetchingItems: fetchingEmployeeAccidents,
        fetchedItems: fetchedEmployeeAccidents,
        errorItems: errorEmployeeAccidents,
        tableTitle: /*#__PURE__*/React.createElement(FormattedMessage, {
          module: MODULE_NAME,
          id: "menu.workforce.employee.accident.info"
        }),
        rowsPerPageOptions: this.rowsPerPageOptions,
        defaultPageSize: this.defaultPageSize,
        fetch: this.fetch,
        rowIdentifier: this.rowIdentifier,
        filtersToQueryParams: this.filtersToQueryParams,
        defaultOrderBy: "-dateCreated",
        headers: this.headers,
        itemFormatters: this.itemFormatters,
        sorts: this.sorts,
        rowDisabled: this.rowDisabled,
        rowLocked: this.rowLocked,
        onDoubleClick: function onDoubleClick(i) {
          return !i.clientMutationId && _onDoubleClick(i);
        },
        reset: this.state.reset
      }));
    }
  }]);
}(Component);
var mapStateToProps$z = function mapStateToProps(state) {
  return {
    rights: !!state.core && !!state.core.user && !!state.core.user.i_user ? state.core.user.i_user.rights : [],
    employeeAccidents: state.workforce.employeeAccidents,
    employeeAccidentsPageInfo: state.workforce.employeeAccidentsPageInfo,
    fetchingEmployeeAccidents: state.workforce.fetchingEmployeeAccidents,
    fetchedEmployeeAccidents: state.workforce.fetchedEmployeeAccidents,
    errorEmployeeAccidents: state.workforce.errorEmployeeAccidents,
    submittingMutation: state.workforce.submittingMutation,
    mutation: state.workforce.mutation,
    confirmed: state.core.confirmed
  };
};
var mapDispatchToProps$l = function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    fetchAccidentInfosSummary: fetchAccidentInfosSummary,
    journalize: journalize,
    coreConfirm: coreConfirm
  }, dispatch);
};
var AccidentInfoSearcher$1 = withModulesManager(withHistory(connect(mapStateToProps$z, mapDispatchToProps$l)(withTheme(withStyles(styles$C)(AccidentInfoSearcher)))));

function _callSuper$C(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$C() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$C() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$C = function _isNativeReflectConstruct() { return !!t; })(); }
var styles$B = function styles(theme) {
  return {
    page: theme.page,
    fab: theme.fab,
    ROUTE_WORKFORCE_EMPLOYEES_ACCIDENT_INFOS_INFO: ROUTE_WORKFORCE_EMPLOYEES_ACCIDENT_INFOS_INFO
  };
};
var AccidentInfosPage = /*#__PURE__*/function (_Component) {
  function AccidentInfosPage() {
    var _this;
    _classCallCheck(this, AccidentInfosPage);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper$C(this, AccidentInfosPage, [].concat(args));
    _defineProperty(_this, "onDoubleClick", function (employee) {
      var newTab = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var routeParams = ["workforce.route.employees.accident.infos.info", [decodeId(employee.id)]];
      if (employee !== null && employee !== void 0 && employee.isHistory) {
        routeParams[1].push(employee.version);
      }
      historyPush$1.apply(void 0, [_this.props.modulesManager, _this.props.history].concat(routeParams, [newTab]));
    });
    _defineProperty(_this, "onAdd", function () {
      historyPush$1(_this.props.modulesManager, _this.props.history, "workforce.route.employees.accident.infos.info");
    });
    return _this;
  }
  _inherits(AccidentInfosPage, _Component);
  return _createClass(AccidentInfosPage, [{
    key: "render",
    value: function render() {
      var _this$props = this.props;
        _this$props.intl;
        var classes = _this$props.classes;
        _this$props.rights;
      return /*#__PURE__*/React.createElement("div", {
        className: classes.page
      }, /*#__PURE__*/React.createElement(AccidentInfoSearcher$1, {
        cacheFiltersKey: "ticketPageFiltersCache",
        onDoubleClick: this.onDoubleClick
      }), withTooltip(/*#__PURE__*/React.createElement("div", {
        className: classes.fab
      }, /*#__PURE__*/React.createElement(Fab, {
        color: "primary",
        onClick: this.onAdd
      }, /*#__PURE__*/React.createElement(AddIcon, null))), /*#__PURE__*/React.createElement(FormattedMessage, {
        module: MODULE_NAME,
        id: "workforce.employee.accident.info.addNewTooltip"
      })));
    }
  }]);
}(Component);
var mapStateToProps$y = function mapStateToProps(state) {
  return {
    rights: !!state.core && !!state.core.user && !!state.core.user.i_user ? state.core.user.i_user.rights : []
  };
};
var AccidentInfosPage$1 = withModulesManager(withHistory(connect(mapStateToProps$y)(withTheme(withStyles(styles$B)(AccidentInfosPage)))));

function ownKeys$1m(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$1m(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$1m(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1m(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper$B(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$B() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$B() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$B = function _isNativeReflectConstruct() { return !!t; })(); }
var styles$A = function styles(theme) {
  return {
    paper: theme.paper.paper,
    tableTitle: theme.table.title,
    item: theme.paper.item,
    fullHeight: {
      height: "100%"
    }
  };
};
var EditAccidentInfoPage$1 = /*#__PURE__*/function (_Component) {
  function EditAccidentInfoPage(props) {
    var _this;
    _classCallCheck(this, EditAccidentInfoPage);
    _this = _callSuper$B(this, EditAccidentInfoPage, [props]);
    _defineProperty(_this, "updateAttribute", function (key, value) {
      _this.setState(function (prevState) {
        return {
          stateEdited: _objectSpread$1m(_objectSpread$1m({}, prevState.stateEdited), {}, _defineProperty({}, key, value)),
          isSaved: false
        };
      });
    });
    _defineProperty(_this, "save", function () {
      var _this$props = _this.props;
        _this$props.grievanceConfig;
        var dispatch = _this$props.dispatch;
      var stateEdited = _this.state.stateEdited;
      var accidentInfoData = {
        accidentDate: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.accidentDate) || stateEdited.accidentDate,
        accidentPlace: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.accidentPlace) || stateEdited.accidentPlace,
        injuryType: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.injuryType) || stateEdited.injuryType,
        accidentTime: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.accidentTime) || stateEdited.accidentTime,
        accidentType: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.accidentType) || stateEdited.accidentType,
        dutyStatus: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.dutyStatus) || stateEdited.dutyStatus,
        description: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.description) || stateEdited.description,
        inOutsideFactory: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.inOutsideFactory) || stateEdited.inOutsideFactory,
        reJoiningDate: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.reJoiningDate) || stateEdited.reJoiningDate,
        id: stateEdited.id
      };
      dispatch(updateAccidentInfo(accidentInfoData, "Update Accident Info ".concat(accidentInfoData.nameEn)));
      _this.setState({
        isSaved: true
      });
    });
    _this.state = {
      stateEdited: props.employeeAccident || {},
      isSaved: false
    };
    return _this;
  }
  _inherits(EditAccidentInfoPage, _Component);
  return _createClass(EditAccidentInfoPage, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.employeeAccident !== this.props.employeeAccident) {
        this.setState({
          stateEdited: this.props.employeeAccident
        });
      }
      if (prevProps.submittingMutation && !this.props.submittingMutation) {
        this.props.dispatch(journalize(this.props.mutation));
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var classes = this.props.classes;
      var _this$state = this.state,
        stateEdited = _this$state.stateEdited,
        isSaved = _this$state.isSaved;
      return /*#__PURE__*/React.createElement("div", {
        className: classes.page
      }, /*#__PURE__*/React.createElement(Grid, {
        container: true
      }, /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12
      }, /*#__PURE__*/React.createElement(Paper, {
        className: classes.paper
      }, /*#__PURE__*/React.createElement(Grid, {
        container: true,
        className: classes.tableTitle
      }, /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12,
        className: classes.tableTitle
      }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(FormattedMessage, {
        module: MODULE_NAME,
        id: "Accident Info",
        values: {
          label: EMPTY_STRING
        }
      }))), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(EmployeeInjuryTypePicker, {
        value: stateEdited.lifeStatus || "",
        label: /*#__PURE__*/React.createElement(FormattedMessage, {
          id: "workforce.employee.accident.info.injuryType",
          module: "workforce"
        }),
        required: true,
        onChange: function onChange(v) {
          return _this2.updateAttribute("injuryType", v);
        },
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(PublishedComponent, {
        pubRef: "workforce.DatePicker",
        label: "workforce.employee.accident.info.dateOfAccident",
        value: stateEdited.accidentDate || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("accidentDate", v);
        },
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(PublishedComponent, {
        pubRef: "workforce.DatePicker",
        label: "workforce.employee.accident.info.timeOfAccident",
        value: stateEdited.accidentTime || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("accidentTime", v);
        },
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(EmployeeAccidentTypePicker, {
        value: stateEdited.accidentType || "",
        label: /*#__PURE__*/React.createElement(FormattedMessage, {
          id: "workforce.employee.accident.info.typeOfAccident",
          module: "workforce"
        }),
        required: true,
        onChange: function onChange(v) {
          return _this2.updateAttribute("accidentType", v);
        },
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(EmployeeDutyStatusPicker, {
        value: stateEdited.dutyStatus || "",
        label: /*#__PURE__*/React.createElement(FormattedMessage, {
          id: "workforce.employee.accident.info.dutyStatus",
          module: "workforce"
        }),
        required: true,
        onChange: function onChange(v) {
          return _this2.updateAttribute("dutyStatus", v);
        },
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(EmployeeInsideOutsideFactoryPicker, {
        value: stateEdited.inOutsideFactory || "",
        label: /*#__PURE__*/React.createElement(FormattedMessage, {
          id: "workforce.employee.accident.info.insideOutsideFactory",
          module: "workforce"
        }),
        required: true,
        onChange: function onChange(v) {
          return _this2.updateAttribute("inOutsideFactory", v);
        },
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(PublishedComponent, {
        pubRef: "workforce.DatePicker",
        label: "workforce.employee.accident.info.reJoiningDate",
        value: stateEdited.reJoiningDate || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("reJoiningDate", v);
        },
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 11,
        className: classes.item
      }), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 1,
        className: classes.item
      }, /*#__PURE__*/React.createElement(IconButton, {
        variant: "contained",
        component: "label",
        color: "primary",
        onClick: this.save,
        disabled: isSaved
      }, /*#__PURE__*/React.createElement(Save, null)))), /*#__PURE__*/React.createElement(Divider, null)))));
    }
  }]);
}(Component);
var mapStateToProps$x = function mapStateToProps(state) {
  return {
    employeeAccident: state.workforce.employeeAccident
  };
};
var EditAccidentInfoPage$2 = connect(mapStateToProps$x)(withStyles(styles$A)(EditAccidentInfoPage$1));

var EmployeeDutyStatusPicker$1 = function EmployeeDutyStatusPicker(_ref) {
  var _formatMessage;
  var id = _ref.id;
    _ref.modulesManager;
    var _onChange = _ref.onChange,
    readOnly = _ref.readOnly,
    required = _ref.required,
    _ref$withLabel = _ref.withLabel,
    withLabel = _ref$withLabel === void 0 ? true : _ref$withLabel,
    withPlaceholder = _ref.withPlaceholder,
    value = _ref.value,
    label = _ref.label,
    placeholder = _ref.placeholder,
    filterOptions = _ref.filterOptions,
    filterSelectedOptions = _ref.filterSelectedOptions;
    _ref.multiple;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2);
    _useState2[0];
    var setSearchString = _useState2[1];
  var _useTranslations = useTranslations("workforce"),
    formatMessage = _useTranslations.formatMessage;

  // Adjust the options to match the EMPLOYEE_DUTY_STATUS format
  // const EMPLOYEE_DUTY_STATUS = ["On Duty", "Off Duty","Commuting","Others"];
  var EMPLOYEE_DUTY_STATUS = ["অন ​​ডিউটি", "অফ ডিউটি", "যাতায়াত", "অন্যান্য"];

  // Find the selected option
  var selectedOption = useMemo(function () {
    return EMPLOYEE_DUTY_STATUS.includes(value) ? value : null;
  }, [value]);
  return /*#__PURE__*/React.createElement(Autocomplete, {
    id: id,
    multiple: false,
    required: required,
    placeholder: placeholder !== null && placeholder !== void 0 ? placeholder : "",
    label: (_formatMessage = formatMessage(label)) !== null && _formatMessage !== void 0 ? _formatMessage : formatMessage("workforce.employee.accident.info.dutyStatus"),
    withLabel: withLabel,
    withPlaceholder: withPlaceholder,
    readOnly: readOnly,
    isLoading: false // Set to false if not loading data dynamically
    ,
    options: EMPLOYEE_DUTY_STATUS,
    value: selectedOption,
    getOptionLabel: function getOptionLabel(option) {
      return option;
    } // Since options are strings, return the string directly
    ,
    onChange: function onChange(option) {
      return _onChange(option, option !== null && option !== void 0 ? option : null);
    },
    filterOptions: filterOptions,
    filterSelectedOptions: filterSelectedOptions,
    onInputChange: setSearchString
  });
};

function ownKeys$1l(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$1l(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$1l(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1l(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper$A(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$A() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$A() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$A = function _isNativeReflectConstruct() { return !!t; })(); }
var styles$z = function styles(theme) {
  return {
    paper: theme.paper.paper,
    tableTitle: theme.table.title,
    item: theme.paper.item,
    fullHeight: {
      height: "100%"
    }
  };
};
var AddAccidentInfoPage$1 = /*#__PURE__*/function (_Component) {
  function AddAccidentInfoPage(props) {
    var _this;
    _classCallCheck(this, AddAccidentInfoPage);
    _this = _callSuper$A(this, AddAccidentInfoPage, [props]);
    _defineProperty(_this, "save", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var stateEdited, dispatch, accidentInfoData;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            stateEdited = _this.state.stateEdited;
            dispatch = _this.props.dispatch;
            accidentInfoData = {
              accidentDate: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.accidentDate) || stateEdited.accidentDate,
              accidentPlace: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.accidentPlace) || stateEdited.accidentPlace,
              injuryType: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.injuryType) || stateEdited.injuryType,
              accidentTime: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.accidentTime) || stateEdited.accidentTime,
              accidentType: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.accidentType) || stateEdited.accidentType,
              dutyStatus: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.dutyStatus) || stateEdited.dutyStatus,
              description: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.description) || stateEdited.description,
              inOutsideFactory: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.inOutsideFactory) || stateEdited.inOutsideFactory,
              reJoiningDate: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.reJoiningDate) || stateEdited.reJoiningDate,
              workforceEmployee: stateEdited.workforceEmployee
            };
            console.log({
              accidentInfoData: accidentInfoData
            });
            _context.next = 6;
            return dispatch(createAccidentInfo(accidentInfoData, "Created Accident Info ".concat(stateEdited.title)));
          case 6:
            _this.setState({
              isSaved: true
            });
          case 7:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })));
    _defineProperty(_this, "updateAttribute", function (key, value) {
      _this.setState(function (prevState) {
        return {
          stateEdited: _objectSpread$1l(_objectSpread$1l({}, prevState.stateEdited), {}, _defineProperty({}, key, value)),
          isSaved: false
        };
      });
    });
    _this.state = {
      stateEdited: {},
      isSaved: false
    };
    return _this;
  }
  _inherits(AddAccidentInfoPage, _Component);
  return _createClass(AddAccidentInfoPage, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props = this.props,
        submittingMutation = _this$props.submittingMutation,
        mutation = _this$props.mutation,
        dispatch = _this$props.dispatch;
      if (!submittingMutation && prevProps.submittingMutation !== submittingMutation) {
        dispatch(journalize(mutation));
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var classes = this.props.classes;
      var _this$state = this.state,
        stateEdited = _this$state.stateEdited,
        isSaved = _this$state.isSaved;
      return /*#__PURE__*/React.createElement("div", {
        className: classes.page
      }, /*#__PURE__*/React.createElement(Grid, {
        container: true
      }, /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12
      }, /*#__PURE__*/React.createElement(Paper, {
        className: classes.paper
      }, /*#__PURE__*/React.createElement(Grid, {
        container: true,
        className: classes.tableTitle
      }, /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12,
        className: classes.tableTitle
      }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(FormattedMessage, {
        module: MODULE_NAME,
        id: "Accident Info",
        values: {
          label: EMPTY_STRING
        }
      })))), /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement(Grid, {
        container: true,
        className: classes.item
      }, /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(EmployeeInjuryTypePicker$1, {
        value: stateEdited.lifeStatus || "",
        label: /*#__PURE__*/React.createElement(FormattedMessage, {
          id: "workforce.employee.accident.info.injuryType",
          module: "workforce"
        }),
        required: true,
        onChange: function onChange(v) {
          return _this2.updateAttribute("injuryType", v);
        },
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(PublishedComponent, {
        pubRef: "workforce.DatePicker",
        label: "workforce.employee.accident.info.dateOfAccident",
        value: stateEdited.accidentDate || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("accidentDate", v);
        },
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(PublishedComponent, {
        pubRef: "workforce.DatePicker",
        label: "workforce.employee.accident.info.timeOfAccident",
        value: stateEdited.accidentTime || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("accidentTime", v);
        },
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(EmployeeAccidentTypePicker$1, {
        value: stateEdited.accidentType || "",
        label: /*#__PURE__*/React.createElement(FormattedMessage, {
          id: "workforce.employee.accident.info.typeOfAccident",
          module: "workforce"
        }),
        required: true,
        onChange: function onChange(v) {
          return _this2.updateAttribute("accidentType", v);
        },
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(EmployeeDutyStatusPicker$1, {
        value: stateEdited.dutyStatus || "",
        label: /*#__PURE__*/React.createElement(FormattedMessage, {
          id: "workforce.employee.accident.info.dutyStatus",
          module: "workforce"
        }),
        required: true,
        onChange: function onChange(v) {
          return _this2.updateAttribute("dutyStatus", v);
        },
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(EmployeeInsideOutsideFactoryPicker$1, {
        value: stateEdited.inOutsideFactory || "",
        label: /*#__PURE__*/React.createElement(FormattedMessage, {
          id: "workforce.employee.accident.info.insideOutsideFactory",
          module: "workforce"
        }),
        required: true,
        onChange: function onChange(v) {
          return _this2.updateAttribute("inOutsideFactory", v);
        },
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(PublishedComponent, {
        pubRef: "workforce.DatePicker",
        label: "workforce.employee.accident.info.reJoiningDate",
        value: stateEdited.reJoiningDate || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("reJoiningDate", v);
        },
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 11,
        className: classes.item
      }), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 1,
        className: classes.item
      }, /*#__PURE__*/React.createElement(IconButton, {
        variant: "contained",
        component: "label",
        color: "primary",
        onClick: function onClick() {
          return _this2.save();
        },
        disabled: isSaved
      }, /*#__PURE__*/React.createElement(Save, null)))), /*#__PURE__*/React.createElement(Divider, null)))));
    }
  }]);
}(Component);
var mapStateToProps$w = function mapStateToProps(state) {
  return {
    submittingMutation: state.workforce.submittingMutation,
    mutation: state.workforce.mutation
  };
};
var AddAccidentInfoPage$2 = connect(mapStateToProps$w)(withStyles(styles$z)(AddAccidentInfoPage$1));

function ownKeys$1k(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$1k(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$1k(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1k(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper$z(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$z() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$z() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$z = function _isNativeReflectConstruct() { return !!t; })(); }
var AccidentInfoForm = /*#__PURE__*/function (_Component) {
  function AccidentInfoForm(props) {
    var _this;
    _classCallCheck(this, AccidentInfoForm);
    _this = _callSuper$z(this, AccidentInfoForm, [props]);
    _defineProperty(_this, "reload", function () {});
    _defineProperty(_this, "canSave", function () {});
    _defineProperty(_this, "_save", function (ticket) {
      _this.setState({
        lockNew: !ticket.uuid
      }, function () {
        return _this.props.save(ticket);
      });
    });
    _defineProperty(_this, "onEditedChanged", function (ticket) {
      _this.setState({
        ticket: ticket
      });
    });
    _defineProperty(_this, "reopenTicket", function () {
      var _this$props = _this.props,
        intl = _this$props.intl,
        ticket = _this$props.ticket;
      _this.props.reopenTicket(ticket.id, formatMessage(intl, MODULE_NAME, "reopenTicket.mutation.label"));
    });
    _this.state = {
      lockNew: false,
      reset: 0,
      workforceEmployeeUuid: null,
      ticket: _this._newTicket()
    };
    return _this;
  }
  _inherits(AccidentInfoForm, _Component);
  return _createClass(AccidentInfoForm, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.workforceEmployeeUuid) {
        this.setState(function (state, props) {
          return {
            workforceEmployeeUuid: props.workforceEmployeeUuid
          };
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {}
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState, snapshot) {
      if (prevProps.fetchedEmployeeAccident !== this.props.fetchedEmployeeAccident && !!this.props.fetchedEmployeeAccident && !!this.props.organizationEmployee) {
        this.setState(function (state, props) {
          return {
            organizationEmployee: _objectSpread$1k({}, props.organizationEmployee),
            workforceEmployeeUuid: props.organizationEmployee.id,
            lockNew: false
          };
        });
      } else if (prevState.workforceEmployeeUuid !== this.state.workforceEmployeeUuid) {
        var filters = ["id: \"".concat(this.state.workforceEmployeeUuid, "\"")];
        this.props.fetchAccidentInfo(this.props.modulesManager, filters);
      } else if (prevProps.submittingMutation && !this.props.submittingMutation) {
        var _this$props2;
        this.props.journalize(this.props.mutation);
        this.setState(function (state) {
          return {
            reset: state.reset + 1
          };
        });
        if ((_this$props2 = this.props) !== null && _this$props2 !== void 0 && (_this$props2 = _this$props2.organizationEmployee) !== null && _this$props2 !== void 0 && _this$props2.id) {
          this.props.fetchAccidentInfo(this.props.modulesManager, ["id: \"".concat(this.state.workforceEmployeeUuid, "\"")]);
        }
      }
    }
  }, {
    key: "_newTicket",
    value: function _newTicket() {
      return {};
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
        fetchingTicket = _this$props3.fetchingTicket,
        fetchedEmployeeAccident = _this$props3.fetchedEmployeeAccident,
        errorTicket = _this$props3.errorTicket,
        save = _this$props3.save,
        back = _this$props3.back;
      var _this$state = this.state,
        lockNew = _this$state.lockNew,
        reset = _this$state.reset,
        update = _this$state.update,
        overview = _this$state.overview,
        workforceEmployeeUuid = _this$state.workforceEmployeeUuid,
        ticket = _this$state.ticket;
      var readOnly = lockNew || !!ticket.validityTo || this.props.readOnly;
      [{
        doIt: this.reopenTicket,
        icon: /*#__PURE__*/React.createElement(LockOpenIcon, null),
        disabled: ticket.isHistory
      }];
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ProgressOrError, {
        progress: fetchingTicket,
        error: errorTicket
      }), (!!fetchedEmployeeAccident || !workforceEmployeeUuid) && /*#__PURE__*/React.createElement(Form, {
        module: MODULE_NAME,
        edited_id: workforceEmployeeUuid,
        edited: ticket,
        reset: reset,
        update: update,
        title: "Accident Info",
        titleParams: {
          label: "Label"
        },
        back: back,
        save: save ? this._save : null,
        canSave: this.canSave,
        reload: (workforceEmployeeUuid || readOnly) && this.reload,
        readOnly: readOnly,
        overview: overview,
        Panels: workforceEmployeeUuid ? [EditAccidentInfoPage$2] : [AddAccidentInfoPage$2],
        onEditedChanged: this.onEditedChanged
      }));
    }
  }]);
}(Component); // eslint-disable-next-line no-unused-vars
var mapStateToProps$v = function mapStateToProps(state, props) {
  return {
    rights: !!state.core && !!state.core.user && !!state.core.user.i_user ? state.core.user.i_user.rights : [],
    fetchingTicket: state.workforce.fetchingTicket,
    errorTicket: state.workforce.errorTicket,
    fetchedEmployeeAccident: state.workforce.fetchedEmployeeAccident,
    ticket: state.workforce.ticket,
    submittingMutation: state.workforce.submittingMutation,
    mutation: state.workforce.mutation,
    grievanceConfig: state.workforce.grievanceConfig
  };
};
var mapDispatchToProps$k = function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    fetchAccidentInfo: fetchAccidentInfo,
    journalize: journalize
  }, dispatch);
};
var AccidentInfoForm$1 = withModulesManager(connect(mapStateToProps$v, mapDispatchToProps$k)(AccidentInfoForm));

function _callSuper$y(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$y() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$y() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$y = function _isNativeReflectConstruct() { return !!t; })(); }
var styles$y = function styles(theme) {
  return {
    page: theme.page,
    lockedPage: theme.page.locked
  };
};
var AccidentInfoPage = /*#__PURE__*/function (_Component) {
  function AccidentInfoPage() {
    var _this;
    _classCallCheck(this, AccidentInfoPage);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper$y(this, AccidentInfoPage, [].concat(args));
    _defineProperty(_this, "add", function () {
      historyPush$1(_this.props.modulesManager, _this.props.history, "grievance.route.ticket");
    });
    _defineProperty(_this, "save", function (accidentinfo) {
      if (!accidentinfo.id) {
        _this.props.createAccidentInfo(_this.props.modulesManager, accidentinfo, "Create");
      } else {
        _this.props.updateAccidentInfo(_this.props.modulesManager, accidentinfo, "Update");
      }
    });
    return _this;
  }
  _inherits(AccidentInfoPage, _Component);
  return _createClass(AccidentInfoPage, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        classes = _this$props.classes,
        modulesManager = _this$props.modulesManager,
        history = _this$props.history,
        rights = _this$props.rights,
        workforceEmployeeUuid = _this$props.workforceEmployeeUuid,
        overview = _this$props.overview,
        organizationVersion = _this$props.organizationVersion;
      var readOnly = false;
      return /*#__PURE__*/React.createElement("div", {
        className: "".concat(null, " ").concat(classes.page)
      }, /*#__PURE__*/React.createElement(AccidentInfoForm$1, {
        overview: overview,
        workforceEmployeeUuid: workforceEmployeeUuid,
        organizationVersion: organizationVersion,
        readOnly: readOnly,
        back: function back() {
          return historyPush$1(modulesManager, history, "workforce.route.employees.accident.infos");
        },
        add: rights.includes(RIGHT_ORGANIZATION_CREATE) ? this.add : null,
        save: rights.includes(RIGHT_ORGANIZATION_EDIT) ? this.save : null
      }));
    }
  }]);
}(Component);
var mapStateToProps$u = function mapStateToProps(state, props) {
  return {
    rights: !!state.core && !!state.core.user && !!state.core.user.i_user ? state.core.user.i_user.rights : [],
    workforceEmployeeUuid: props.match.params.workforce_employee_uuid,
    organizationVersion: props.match.params.version,
    accidentinfo: state.workforce.accidentinfo
  };
};
var mapDispatchToProps$j = function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    createAccidentInfo: createAccidentInfo,
    updateAccidentInfo: updateAccidentInfo
  }, dispatch);
};
var AccidentInfoPage$1 = withHistory(withModulesManager(connect(mapStateToProps$u, mapDispatchToProps$j)(withTheme(withStyles(styles$y)(AccidentInfoPage)))));

function _callSuper$x(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$x() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$x() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$x = function _isNativeReflectConstruct() { return !!t; })(); }
var styles$x = function styles(theme) {
  return {
    dialogTitle: theme.dialog.title,
    dialogContent: theme.dialog.content,
    form: {
      padding: 0
    },
    item: {
      padding: theme.spacing(1)
    },
    paperDivider: theme.paper.divider
  };
};
var WORKFORCE_EMPLOYEE_ACCOUNT_INFO_FILTER_CONTRIBUTION_KEY = "workforce.employee.account.info.Filter";
var AccidentInfoFilter = /*#__PURE__*/function (_Component) {
  function AccidentInfoFilter() {
    var _this;
    _classCallCheck(this, AccidentInfoFilter);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper$x(this, AccidentInfoFilter, [].concat(args));
    _defineProperty(_this, "debouncedOnChangeFilter", _debounce(_this.props.onChangeFilters, 800));
    _defineProperty(_this, "_filterValue", function (k) {
      var filters = _this.props.filters;
      return !!filters && !!filters[k] ? filters[k].value : null;
    });
    _defineProperty(_this, "_onChangeReporter", function (k, v) {
      _this.props.onChangeFilters([{
        id: k,
        value: v,
        filter: "".concat(k, ": \"").concat(decodeId(v === null || v === void 0 ? void 0 : v.id), "\"")
      }]);
    });
    _defineProperty(_this, "_onChangeCheckbox", function (key, value) {
      var filters = [{
        id: key,
        value: value,
        filter: "".concat(key, ": ").concat(value)
      }];
      _this.props.onChangeFilters(filters);
      _this.props.setShowHistoryFilter(value);
    });
    return _this;
  }
  _inherits(AccidentInfoFilter, _Component);
  return _createClass(AccidentInfoFilter, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        classes = _this$props.classes,
        filters = _this$props.filters,
        onChangeFilters = _this$props.onChangeFilters;
      return /*#__PURE__*/React.createElement(Grid, {
        container: true,
        className: classes.form
      }, /*#__PURE__*/React.createElement(ControlledField, {
        module: MODULE_NAME,
        id: "workforce.employee.account.info.bankName",
        field: /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 3,
          className: classes.item
        }, /*#__PURE__*/React.createElement(BanksPicker$1, {
          value: this._filterValue("bank"),
          label: /*#__PURE__*/React.createElement(FormattedMessage, {
            id: "workforce.employee.account.info.bankName",
            module: "workforce"
          }),
          onChange: function onChange(v) {
            return _this2.debouncedOnChangeFilter([{
              id: 'bank',
              value: v,
              filter: "bank: \"".concat(v, "\"")
            }]);
          },
          readOnly: false
        }))
      }), /*#__PURE__*/React.createElement(ControlledField, {
        module: MODULE_NAME,
        id: "workforce.employee.account.info.branchName",
        field: /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 3,
          className: classes.item
        }, /*#__PURE__*/React.createElement(BanksPicker$1, {
          value: this._filterValue("bank"),
          label: /*#__PURE__*/React.createElement(FormattedMessage, {
            id: "workforce.employee.account.info.branchName",
            module: "workforce"
          }),
          onChange: function onChange(v) {
            return _this2.debouncedOnChangeFilter([{
              id: 'bank',
              value: v,
              filter: "bank: \"".concat(v, "\"")
            }]);
          },
          readOnly: false
        }))
      }), /*#__PURE__*/React.createElement(ControlledField, {
        module: MODULE_NAME,
        id: "workforce.employee.account.info.accountHolderName",
        field: /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 3,
          className: classes.item
        }, /*#__PURE__*/React.createElement(TextInput, {
          module: MODULE_NAME,
          label: "workforce.employee.account.info.accountHolderName",
          name: "firstNameBn",
          value: this._filterValue("firstNameBn"),
          onChange: function onChange(v) {
            return _this2.debouncedOnChangeFilter([{
              id: "firstNameBn",
              value: v,
              filter: "firstNameBn_Icontains: \"".concat(v, "\"")
            }]);
          }
        }))
      }), /*#__PURE__*/React.createElement(Contributions, {
        filters: filters,
        onChangeFilters: onChangeFilters,
        contributionKey: WORKFORCE_EMPLOYEE_ACCOUNT_INFO_FILTER_CONTRIBUTION_KEY
      }));
    }
  }]);
}(Component);
var AccountInfoFilter = withModulesManager(withTheme(withStyles(styles$x)(AccidentInfoFilter)));

function _callSuper$w(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$w() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$w() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$w = function _isNativeReflectConstruct() { return !!t; })(); }
function ownKeys$1j(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$1j(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$1j(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1j(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var styles$w = function styles(theme) {
  return {
    paper: _objectSpread$1j(_objectSpread$1j({}, theme.paper.paper), {}, {
      margin: 0
    }),
    paperHeader: _objectSpread$1j(_objectSpread$1j({}, theme.paper.header), {}, {
      padding: 10
    }),
    tableTitle: theme.table.title,
    fab: theme.fab,
    button: {
      margin: theme.spacing(1)
    },
    item: {
      padding: theme.spacing(1)
    },
    horizontalButtonContainer: _objectSpread$1j(_objectSpread$1j({}, theme.buttonContainer.horizontal), {}, {
      display: "flex",
      alignItems: "center",
      gap: theme.spacing(1)
    }),
    compactButton: {
      maxHeight: "30px",
      minWidth: "80px",
      padding: "1px 4px",
      borderRadius: "6px",
      backgroundColor: "#006273",
      color: "white",
      fontSize: "0.7rem",
      textTransform: "none",
      marginRight: "2px",
      "&:hover": {
        backgroundColor: "#004a5e"
      }
    },
    buttonContainer: {
      display: "flex",
      gap: theme.spacing(1)
    }
  };
};
var AccountInfoSearcher = /*#__PURE__*/function (_Component) {
  function AccountInfoSearcher(props) {
    var _this;
    _classCallCheck(this, AccountInfoSearcher);
    _this = _callSuper$w(this, AccountInfoSearcher, [props]);
    _defineProperty(_this, "fetch", function (prms) {
      var showHistoryFilter = _this.state.showHistoryFilter;
      _this.setState({
        displayVersion: showHistoryFilter
      });
      _this.props.fetchAccountInfosSummary(_this.props.modulesManager, prms);
    });
    _defineProperty(_this, "rowIdentifier", function (r) {
      return r.uuid;
    });
    _defineProperty(_this, "isShowHistory", function () {
      return _this.state.displayVersion;
    });
    _defineProperty(_this, "filtersToQueryParams", function (state) {
      var prms = Object.keys(state.filters).filter(function (f) {
        return !!state.filters[f].filter;
      }).map(function (f) {
        return state.filters[f].filter;
      });
      prms.push("first: ".concat(state.pageSize));
      if (state.afterCursor) {
        prms.push("after: \"".concat(state.afterCursor, "\""));
      }
      if (state.beforeCursor) {
        prms.push("before: \"".concat(state.beforeCursor, "\""));
      }
      if (state.orderBy) {
        prms.push("orderBy: [\"".concat(state.orderBy, "\"]"));
      }
      return prms;
    });
    _defineProperty(_this, "headers", function () {
      return ["workforce.employee.account.info.accountOwnerName", "workforce.employee.account.info.onbehalfOf", "workforce.employee.account.info.reference", "workforce.employee.account.info.bankName", "workforce.employee.account.info.branchName", "workforce.employee.account.info.routingNumber", "workforce.employee.account.info.accountHolderName", "workforce.employee.account.info.status", _this.isShowHistory() ? "workforce.version" : ""];
    });
    _defineProperty(_this, "sorts", function () {
      return [];
    });
    _defineProperty(_this, "beneficiaryType", void 0);
    _defineProperty(_this, "itemFormatters", function () {
      var _organizationemployee;
      var formatters = [function (organizationemployee) {
        return organizationemployee.accountHolderName;
      }, function (organizationemployee) {
        return organizationemployee.onBehalfOf;
      }, function (organizationemployee) {
        return organizationemployee.onBehalfOf;
      }, function (organizationemployee) {
        return organizationemployee.bankId;
      }, function (organizationemployee) {
        return organizationemployee.branchName;
      }, function (organizationemployee) {
        return organizationemployee.branchName;
      }, function (organizationemployee) {
        return organizationemployee.routingNumber;
      }, function (organizationemployee) {
        return organizationemployee.accountHolderName;
      }, function (organizationemployee) {
        return organizationemployee.status;
      }, _this.isShowHistory() ? (_organizationemployee = organizationemployee) === null || _organizationemployee === void 0 ? void 0 : _organizationemployee.version : null];
      formatters.push(function (organizationemployee) {
        return /*#__PURE__*/React.createElement(Tooltip, {
          title: "Edit"
        }, /*#__PURE__*/React.createElement(IconButton, {
          disabled: organizationemployee === null || organizationemployee === void 0 ? void 0 : organizationemployee.isHistory,
          onClick: function onClick() {
            historyPush$1(_this.props.modulesManager, _this.props.history, "workforce.route.employees.account.infos.info", [decodeId(organizationemployee.id)], false);
          }
        }, /*#__PURE__*/React.createElement(EditIcon, null)));
      });
      return formatters;
    });
    _defineProperty(_this, "rowDisabled", function (selection, i) {
      return !!i.validityTo;
    });
    _defineProperty(_this, "rowLocked", function (selection, i) {
      return !!i.clientMutationId;
    });
    _this.state = {
      chfid: null,
      confirmedAction: null,
      reset: 0,
      showHistoryFilter: false,
      displayVersion: false
    };
    _this.rowsPerPageOptions = [10, 20, 50, 100];
    _this.defaultPageSize = 10;
    return _this;
  }
  _inherits(AccountInfoSearcher, _Component);
  return _createClass(AccountInfoSearcher, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState, snapshot) {
      if (prevProps.submittingMutation && !this.props.submittingMutation) {
        this.props.journalize(this.props.mutation);
        this.setState({
          reset: prevState.reset + 1
        });
      } else if (!prevProps.confirmed && this.props.confirmed) {
        this.state.confirmedAction();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props;
        _this$props.intl;
        var employeeAccounts = _this$props.employeeAccounts,
        employeeAccountsPageInfo = _this$props.employeeAccountsPageInfo,
        fetchingEmployeeAccounts = _this$props.fetchingEmployeeAccounts,
        fetchedEmployeeAccounts = _this$props.fetchedEmployeeAccounts,
        errorEmployeeAccounts = _this$props.errorEmployeeAccounts,
        filterPaneContributionsKey = _this$props.filterPaneContributionsKey,
        cacheFiltersKey = _this$props.cacheFiltersKey,
        _onDoubleClick = _this$props.onDoubleClick;
      employeeAccountsPageInfo.totalCount;
      var filterPane = function filterPane(_ref) {
        var filters = _ref.filters,
          onChangeFilters = _ref.onChangeFilters;
        return /*#__PURE__*/React.createElement(AccountInfoFilter, {
          filters: filters,
          onChangeFilters: onChangeFilters,
          setShowHistoryFilter: function setShowHistoryFilter(showHistoryFilter) {
            return _this2.setState({
              showHistoryFilter: showHistoryFilter
            });
          }
        });
      };
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Searcher$2, {
        module: MODULE_NAME,
        cacheFiltersKey: cacheFiltersKey,
        FilterPane: filterPane,
        filterPaneContributionsKey: filterPaneContributionsKey,
        items: employeeAccounts,
        itemsPageInfo: employeeAccountsPageInfo,
        fetchingItems: fetchingEmployeeAccounts,
        fetchedItems: fetchedEmployeeAccounts,
        errorItems: errorEmployeeAccounts,
        tableTitle: /*#__PURE__*/React.createElement(FormattedMessage, {
          module: MODULE_NAME,
          id: "menu.workforce.employee.account.info"
        }),
        rowsPerPageOptions: this.rowsPerPageOptions,
        defaultPageSize: this.defaultPageSize,
        fetch: this.fetch,
        rowIdentifier: this.rowIdentifier,
        filtersToQueryParams: this.filtersToQueryParams,
        defaultOrderBy: "-dateCreated",
        headers: this.headers,
        itemFormatters: this.itemFormatters,
        sorts: this.sorts,
        rowDisabled: this.rowDisabled,
        rowLocked: this.rowLocked,
        onDoubleClick: function onDoubleClick(i) {
          return !i.clientMutationId && _onDoubleClick(i);
        },
        reset: this.state.reset
      }));
    }
  }]);
}(Component);
var mapStateToProps$t = function mapStateToProps(state) {
  return {
    rights: !!state.core && !!state.core.user && !!state.core.user.i_user ? state.core.user.i_user.rights : [],
    employeeAccounts: state.workforce.employeeAccounts,
    employeeAccountsPageInfo: state.workforce.employeeAccountsPageInfo,
    fetchingEmployeeAccounts: state.workforce.fetchingEmployeeAccounts,
    fetchedEmployeeAccounts: state.workforce.fetchedEmployeeAccounts,
    errorEmployeeAccounts: state.workforce.errorEmployeeAccounts,
    submittingMutation: state.workforce.submittingMutation,
    mutation: state.workforce.mutation,
    confirmed: state.core.confirmed
  };
};
var mapDispatchToProps$i = function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    fetchAccountInfosSummary: fetchAccountInfosSummary,
    journalize: journalize,
    coreConfirm: coreConfirm
  }, dispatch);
};
var AccountInfoSearcher$1 = withModulesManager(withHistory(connect(mapStateToProps$t, mapDispatchToProps$i)(withTheme(withStyles(styles$w)(AccountInfoSearcher)))));

function _callSuper$v(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$v() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$v() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$v = function _isNativeReflectConstruct() { return !!t; })(); }
var styles$v = function styles(theme) {
  return {
    page: theme.page,
    fab: theme.fab,
    ROUTE_WORKFORCE_EMPLOYEES_ACCIDENT_INFOS_INFO: ROUTE_WORKFORCE_EMPLOYEES_ACCIDENT_INFOS_INFO
  };
};
var AccountInfosPage = /*#__PURE__*/function (_Component) {
  function AccountInfosPage() {
    var _this;
    _classCallCheck(this, AccountInfosPage);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper$v(this, AccountInfosPage, [].concat(args));
    _defineProperty(_this, "onDoubleClick", function (employee) {
      var newTab = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var routeParams = ["workforce.route.employees.account.infos.info", [decodeId(employee.id)]];
      if (employee !== null && employee !== void 0 && employee.isHistory) {
        routeParams[1].push(employee.version);
      }
      historyPush$1.apply(void 0, [_this.props.modulesManager, _this.props.history].concat(routeParams, [newTab]));
    });
    _defineProperty(_this, "onAdd", function () {
      historyPush$1(_this.props.modulesManager, _this.props.history, "workforce.route.employees.account.infos.info");
    });
    return _this;
  }
  _inherits(AccountInfosPage, _Component);
  return _createClass(AccountInfosPage, [{
    key: "render",
    value: function render() {
      var _this$props = this.props;
        _this$props.intl;
        var classes = _this$props.classes;
        _this$props.rights;
      return /*#__PURE__*/React.createElement("div", {
        className: classes.page
      }, /*#__PURE__*/React.createElement(AccountInfoSearcher$1, {
        cacheFiltersKey: "ticketPageFiltersCache",
        onDoubleClick: this.onDoubleClick
      }), withTooltip(/*#__PURE__*/React.createElement("div", {
        className: classes.fab
      }, /*#__PURE__*/React.createElement(Fab, {
        color: "primary",
        onClick: this.onAdd
      }, /*#__PURE__*/React.createElement(AddIcon, null))), /*#__PURE__*/React.createElement(FormattedMessage, {
        module: MODULE_NAME,
        id: "workforce.employee.account.info.addNewTooltip"
      })));
    }
  }]);
}(Component);
var mapStateToProps$s = function mapStateToProps(state) {
  return {
    rights: !!state.core && !!state.core.user && !!state.core.user.i_user ? state.core.user.i_user.rights : []
  };
};
var AccountInfosPage$1 = withModulesManager(withHistory(connect(mapStateToProps$s)(withTheme(withStyles(styles$v)(AccountInfosPage)))));

function ownKeys$1i(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$1i(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$1i(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1i(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper$u(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$u() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$u() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$u = function _isNativeReflectConstruct() { return !!t; })(); }
var styles$u = function styles(theme) {
  return {
    paper: theme.paper.paper,
    tableTitle: theme.table.title,
    item: theme.paper.item,
    fullHeight: {
      height: "100%"
    }
  };
};
var EditAccidentInfoPage = /*#__PURE__*/function (_Component) {
  function EditAccidentInfoPage(props) {
    var _this;
    _classCallCheck(this, EditAccidentInfoPage);
    _this = _callSuper$u(this, EditAccidentInfoPage, [props]);
    _defineProperty(_this, "updateAttribute", function (key, value) {
      _this.setState(function (prevState) {
        return {
          stateEdited: _objectSpread$1i(_objectSpread$1i({}, prevState.stateEdited), {}, _defineProperty({}, key, value)),
          isSaved: false
        };
      });
    });
    _defineProperty(_this, "save", function () {
      var _this$props = _this.props;
        _this$props.grievanceConfig;
        var dispatch = _this$props.dispatch;
      var stateEdited = _this.state.stateEdited;
      var accountInfoData = {
        bank: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.bank) || stateEdited.bank,
        accountHolderName: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.accountHolderName) || stateEdited.accountHolderName,
        routingNumber: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.routingNumber) || stateEdited.routingNumber,
        accountNumber: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.accountNumber) || stateEdited.accountNumber,
        status: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.status) || stateEdited.status,
        id: stateEdited.id
      };
      dispatch(updateAccountInfo(accountInfoData, "Update Account Info ".concat(accountInfoData.nameEn)));
      _this.setState({
        isSaved: true
      });
    });
    _this.state = {
      stateEdited: props.employeeAccount || {},
      isSaved: false
    };
    return _this;
  }
  _inherits(EditAccidentInfoPage, _Component);
  return _createClass(EditAccidentInfoPage, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.employeeAccount !== this.props.employeeAccount) {
        this.setState({
          stateEdited: this.props.employeeAccount
        });
      }
      if (prevProps.submittingMutation && !this.props.submittingMutation) {
        this.props.dispatch(journalize(this.props.mutation));
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var classes = this.props.classes;
      var _this$state = this.state,
        stateEdited = _this$state.stateEdited,
        isSaved = _this$state.isSaved;
      return /*#__PURE__*/React.createElement("div", {
        className: classes.page
      }, /*#__PURE__*/React.createElement(Grid, {
        container: true
      }, /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12
      }, /*#__PURE__*/React.createElement(Paper, {
        className: classes.paper
      }, /*#__PURE__*/React.createElement(Grid, {
        container: true,
        className: classes.tableTitle
      }, /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12,
        className: classes.tableTitle
      }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(FormattedMessage, {
        module: MODULE_NAME,
        id: "Account Info",
        values: {
          label: EMPTY_STRING
        }
      }))), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(BanksPicker, {
        value: stateEdited.bank || "",
        label: /*#__PURE__*/React.createElement(FormattedMessage, {
          id: "workforce.employee.account.info.bankName",
          module: "workforce"
        }),
        required: true,
        onChange: function onChange(v) {
          return _this2.updateAttribute("bank", v);
        },
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(BanksPicker, {
        value: stateEdited.bank || "",
        label: /*#__PURE__*/React.createElement(FormattedMessage, {
          id: "workforce.employee.account.info.branchName",
          module: "workforce"
        }),
        required: true,
        onChange: function onChange(v) {
          return _this2.updateAttribute("bank", v);
        },
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.employee.account.info.accountHolderName",
        value: stateEdited.accountHolderName || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("accountHolderName", v);
        },
        required: true,
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.employee.account.info.routingNumber",
        value: stateEdited.routingNumber || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("routingNumber", v);
        },
        required: true,
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.employee.account.info.accountNumber",
        value: stateEdited.accountNumber || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("accountNumber", v);
        },
        required: true,
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.employee.account.info.status",
        value: stateEdited.status || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("status", v);
        },
        required: true,
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 11,
        className: classes.item
      }), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 1,
        className: classes.item
      }, /*#__PURE__*/React.createElement(IconButton, {
        variant: "contained",
        component: "label",
        color: "primary",
        onClick: this.save,
        disabled: isSaved
      }, /*#__PURE__*/React.createElement(Save, null)))), /*#__PURE__*/React.createElement(Divider, null)))));
    }
  }]);
}(Component);
var mapStateToProps$r = function mapStateToProps(state) {
  return {
    employeeAccount: state.workforce.employeeAccount
  };
};
var EditAccountInfoPage = connect(mapStateToProps$r)(withStyles(styles$u)(EditAccidentInfoPage));

function ownKeys$1h(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$1h(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$1h(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1h(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper$t(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$t() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$t() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$t = function _isNativeReflectConstruct() { return !!t; })(); }
var styles$t = function styles(theme) {
  return {
    paper: theme.paper.paper,
    tableTitle: theme.table.title,
    item: theme.paper.item,
    fullHeight: {
      height: "100%"
    }
  };
};
var AddAccidentInfoPage = /*#__PURE__*/function (_Component) {
  function AddAccidentInfoPage(props) {
    var _this;
    _classCallCheck(this, AddAccidentInfoPage);
    _this = _callSuper$t(this, AddAccidentInfoPage, [props]);
    _defineProperty(_this, "save", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var stateEdited, dispatch, accountInfoData;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            stateEdited = _this.state.stateEdited;
            dispatch = _this.props.dispatch;
            accountInfoData = {
              bank: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.bank) || stateEdited.bank,
              accountHolderName: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.accountHolderName) || stateEdited.accountHolderName,
              routingNumber: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.routingNumber) || stateEdited.routingNumber,
              accountNumber: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.accountNumber) || stateEdited.accountNumber,
              status: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.status) || stateEdited.status,
              workforceEmployee: stateEdited.workforceEmployee
            };
            _context.next = 5;
            return dispatch(createAccountInfo(accountInfoData, "Created Account Info ".concat(stateEdited.title)));
          case 5:
            _this.setState({
              isSaved: true
            });
          case 6:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })));
    _defineProperty(_this, "updateAttribute", function (key, value) {
      _this.setState(function (prevState) {
        return {
          stateEdited: _objectSpread$1h(_objectSpread$1h({}, prevState.stateEdited), {}, _defineProperty({}, key, value)),
          isSaved: false
        };
      });
    });
    _this.state = {
      stateEdited: {},
      isSaved: false
    };
    return _this;
  }
  _inherits(AddAccidentInfoPage, _Component);
  return _createClass(AddAccidentInfoPage, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props = this.props,
        submittingMutation = _this$props.submittingMutation,
        mutation = _this$props.mutation,
        dispatch = _this$props.dispatch;
      if (!submittingMutation && prevProps.submittingMutation !== submittingMutation) {
        dispatch(journalize(mutation));
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var classes = this.props.classes;
      var _this$state = this.state,
        stateEdited = _this$state.stateEdited,
        isSaved = _this$state.isSaved;
      return /*#__PURE__*/React.createElement("div", {
        className: classes.page
      }, /*#__PURE__*/React.createElement(Grid, {
        container: true
      }, /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12
      }, /*#__PURE__*/React.createElement(Paper, {
        className: classes.paper
      }, /*#__PURE__*/React.createElement(Grid, {
        container: true,
        className: classes.tableTitle
      }, /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12,
        className: classes.tableTitle
      }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(FormattedMessage, {
        module: MODULE_NAME,
        id: "Account Info",
        values: {
          label: EMPTY_STRING
        }
      })))), /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement(Grid, {
        container: true,
        className: classes.item
      }, /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(BanksPicker, {
        value: stateEdited.bank || "",
        label: /*#__PURE__*/React.createElement(FormattedMessage, {
          id: "workforce.employee.account.info.bankName",
          module: "workforce"
        }),
        required: true,
        onChange: function onChange(v) {
          return _this2.updateAttribute("bank", v);
        },
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(BanksPicker, {
        value: stateEdited.bank || "",
        label: /*#__PURE__*/React.createElement(FormattedMessage, {
          id: "workforce.employee.account.info.branchName",
          module: "workforce"
        }),
        required: true,
        onChange: function onChange(v) {
          return _this2.updateAttribute("bank", v);
        },
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.employee.account.info.accountHolderName",
        value: stateEdited.accountHolderName || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("accountHolderName", v);
        },
        required: true,
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.employee.account.info.routingNumber",
        value: stateEdited.routingNumber || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("routingNumber", v);
        },
        required: true,
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.employee.account.info.accountNumber",
        value: stateEdited.accountNumber || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("accountNumber", v);
        },
        required: true,
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.employee.account.info.status",
        value: stateEdited.status || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("status", v);
        },
        required: true,
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 1,
        className: classes.item
      }, /*#__PURE__*/React.createElement(IconButton, {
        variant: "contained",
        component: "label",
        color: "primary",
        onClick: function onClick() {
          return _this2.save();
        },
        disabled: isSaved
      }, /*#__PURE__*/React.createElement(Save, null)))), /*#__PURE__*/React.createElement(Divider, null)))));
    }
  }]);
}(Component);
var mapStateToProps$q = function mapStateToProps(state) {
  return {
    submittingMutation: state.workforce.submittingMutation,
    mutation: state.workforce.mutation
  };
};
var AddAccountInfoPage = connect(mapStateToProps$q)(withStyles(styles$t)(AddAccidentInfoPage));

function ownKeys$1g(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$1g(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$1g(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1g(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper$s(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$s() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$s() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$s = function _isNativeReflectConstruct() { return !!t; })(); }
var AccountInfoForm = /*#__PURE__*/function (_Component) {
  function AccountInfoForm(props) {
    var _this;
    _classCallCheck(this, AccountInfoForm);
    _this = _callSuper$s(this, AccountInfoForm, [props]);
    _defineProperty(_this, "reload", function () {});
    _defineProperty(_this, "canSave", function () {});
    _defineProperty(_this, "_save", function (ticket) {
      _this.setState({
        lockNew: !ticket.uuid
      }, function () {
        return _this.props.save(ticket);
      });
    });
    _defineProperty(_this, "onEditedChanged", function (ticket) {
      _this.setState({
        ticket: ticket
      });
    });
    _defineProperty(_this, "reopenTicket", function () {
      var _this$props = _this.props,
        intl = _this$props.intl,
        ticket = _this$props.ticket;
      _this.props.reopenTicket(ticket.id, formatMessage(intl, MODULE_NAME, "reopenTicket.mutation.label"));
    });
    _this.state = {
      lockNew: false,
      reset: 0,
      workforceEmployeeUuid: null,
      ticket: _this._newTicket()
    };
    return _this;
  }
  _inherits(AccountInfoForm, _Component);
  return _createClass(AccountInfoForm, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.workforceEmployeeUuid) {
        this.setState(function (state, props) {
          return {
            workforceEmployeeUuid: props.workforceEmployeeUuid
          };
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {}
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState, snapshot) {
      if (prevProps.fetchedEmployeeAccount !== this.props.fetchedEmployeeAccount && !!this.props.fetchedEmployeeAccount && !!this.props.organizationEmployee) {
        this.setState(function (state, props) {
          return {
            organizationEmployee: _objectSpread$1g({}, props.organizationEmployee),
            workforceEmployeeUuid: props.organizationEmployee.id,
            lockNew: false
          };
        });
      } else if (prevState.workforceEmployeeUuid !== this.state.workforceEmployeeUuid) {
        var filters = ["id: \"".concat(this.state.workforceEmployeeUuid, "\"")];
        this.props.fetchAccountInfo(this.props.modulesManager, filters);
      } else if (prevProps.submittingMutation && !this.props.submittingMutation) {
        var _this$props2;
        this.props.journalize(this.props.mutation);
        this.setState(function (state) {
          return {
            reset: state.reset + 1
          };
        });
        if ((_this$props2 = this.props) !== null && _this$props2 !== void 0 && (_this$props2 = _this$props2.organizationEmployee) !== null && _this$props2 !== void 0 && _this$props2.id) {
          this.props.fetchAccountInfo(this.props.modulesManager, ["id: \"".concat(this.state.workforceEmployeeUuid, "\"")]);
        }
      }
    }
  }, {
    key: "_newTicket",
    value: function _newTicket() {
      return {};
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
        fetchingTicket = _this$props3.fetchingTicket,
        fetchedEmployeeAccount = _this$props3.fetchedEmployeeAccount,
        errorTicket = _this$props3.errorTicket,
        save = _this$props3.save,
        back = _this$props3.back;
      var _this$state = this.state,
        lockNew = _this$state.lockNew,
        reset = _this$state.reset,
        update = _this$state.update,
        overview = _this$state.overview,
        workforceEmployeeUuid = _this$state.workforceEmployeeUuid,
        ticket = _this$state.ticket;
      var readOnly = lockNew || !!ticket.validityTo || this.props.readOnly;
      [{
        doIt: this.reopenTicket,
        icon: /*#__PURE__*/React.createElement(LockOpenIcon, null),
        disabled: ticket.isHistory
      }];
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ProgressOrError, {
        progress: fetchingTicket,
        error: errorTicket
      }), (!!fetchedEmployeeAccount || !workforceEmployeeUuid) && /*#__PURE__*/React.createElement(Form, {
        module: MODULE_NAME,
        edited_id: workforceEmployeeUuid,
        edited: ticket,
        reset: reset,
        update: update,
        title: "Account Info",
        titleParams: {
          label: "Label"
        },
        back: back,
        save: save ? this._save : null,
        canSave: this.canSave,
        reload: (workforceEmployeeUuid || readOnly) && this.reload,
        readOnly: readOnly,
        overview: overview,
        Panels: workforceEmployeeUuid ? [EditAccountInfoPage] : [AddAccountInfoPage],
        onEditedChanged: this.onEditedChanged
      }));
    }
  }]);
}(Component); // eslint-disable-next-line no-unused-vars
var mapStateToProps$p = function mapStateToProps(state, props) {
  return {
    rights: !!state.core && !!state.core.user && !!state.core.user.i_user ? state.core.user.i_user.rights : [],
    fetchingTicket: state.workforce.fetchingTicket,
    errorTicket: state.workforce.errorTicket,
    fetchedEmployeeAccount: state.workforce.fetchedEmployeeAccount,
    ticket: state.workforce.ticket,
    submittingMutation: state.workforce.submittingMutation,
    mutation: state.workforce.mutation,
    grievanceConfig: state.workforce.grievanceConfig
  };
};
var mapDispatchToProps$h = function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    fetchAccountInfo: fetchAccountInfo,
    journalize: journalize
  }, dispatch);
};
var AccountInfoForm$1 = withModulesManager(connect(mapStateToProps$p, mapDispatchToProps$h)(AccountInfoForm));

function _callSuper$r(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$r() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$r() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$r = function _isNativeReflectConstruct() { return !!t; })(); }
var styles$s = function styles(theme) {
  return {
    page: theme.page,
    lockedPage: theme.page.locked
  };
};
var AccoutInfoPage = /*#__PURE__*/function (_Component) {
  function AccoutInfoPage() {
    var _this;
    _classCallCheck(this, AccoutInfoPage);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper$r(this, AccoutInfoPage, [].concat(args));
    _defineProperty(_this, "add", function () {
      historyPush$1(_this.props.modulesManager, _this.props.history, "grievance.route.ticket");
    });
    _defineProperty(_this, "save", function (accountinfo) {
      if (!accountinfo.id) {
        _this.props.createAccidentInfo(_this.props.modulesManager, accountinfo, "Create");
      } else {
        _this.props.updateAccidentInfo(_this.props.modulesManager, accountinfo, "Update");
      }
    });
    return _this;
  }
  _inherits(AccoutInfoPage, _Component);
  return _createClass(AccoutInfoPage, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        classes = _this$props.classes,
        modulesManager = _this$props.modulesManager,
        history = _this$props.history,
        rights = _this$props.rights,
        workforceEmployeeUuid = _this$props.workforceEmployeeUuid,
        overview = _this$props.overview,
        organizationVersion = _this$props.organizationVersion;
      var readOnly = false;
      return /*#__PURE__*/React.createElement("div", {
        className: "".concat(null, " ").concat(classes.page)
      }, /*#__PURE__*/React.createElement(AccountInfoForm$1, {
        overview: overview,
        workforceEmployeeUuid: workforceEmployeeUuid,
        organizationVersion: organizationVersion,
        readOnly: readOnly,
        back: function back() {
          return historyPush$1(modulesManager, history, "workforce.route.employees.account.infos");
        },
        add: rights.includes(RIGHT_ORGANIZATION_CREATE) ? this.add : null,
        save: rights.includes(RIGHT_ORGANIZATION_EDIT) ? this.save : null
      }));
    }
  }]);
}(Component);
var mapStateToProps$o = function mapStateToProps(state, props) {
  return {
    rights: !!state.core && !!state.core.user && !!state.core.user.i_user ? state.core.user.i_user.rights : [],
    workforceEmployeeUuid: props.match.params.workforce_employee_uuid,
    organizationVersion: props.match.params.version,
    accountinfo: state.workforce.accountinfo
  };
};
var mapDispatchToProps$g = function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    createAccidentInfo: createAccidentInfo,
    updateAccidentInfo: updateAccidentInfo
  }, dispatch);
};
var AccountInfoPage = withHistory(withModulesManager(connect(mapStateToProps$o, mapDispatchToProps$g)(withTheme(withStyles(styles$s)(AccoutInfoPage)))));

function _callSuper$q(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$q() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$q() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$q = function _isNativeReflectConstruct() { return !!t; })(); }
// import { FormattedMessage } from "../../../../../openimis-fe-core_js/src";

var styles$r = function styles(theme) {
  return {
    dialogTitle: theme.dialog.title,
    dialogContent: theme.dialog.content,
    form: {
      padding: 0
    },
    item: {
      padding: theme.spacing(1)
    },
    paperDivider: theme.paper.divider
  };
};
var WORKFORCE_ORGANIZATION_EMPLOYEE_FILTER_CONTRIBUTION_KEY = "workforce.organization.employee.Filter";
var ServicesFilter = /*#__PURE__*/function (_Component) {
  function ServicesFilter() {
    var _this;
    _classCallCheck(this, ServicesFilter);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper$q(this, ServicesFilter, [].concat(args));
    _defineProperty(_this, "debouncedOnChangeFilter", _debounce(_this.props.onChangeFilters, 800));
    _defineProperty(_this, "_filterValue", function (k) {
      var filters = _this.props.filters;
      return !!filters && !!filters[k] ? filters[k].value : null;
    });
    _defineProperty(_this, "_onChangeReporter", function (k, v) {
      _this.props.onChangeFilters([{
        id: k,
        value: v,
        filter: "".concat(k, ": \"").concat(decodeId(v === null || v === void 0 ? void 0 : v.id), "\"")
      }]);
    });
    _defineProperty(_this, "_onChangeCheckbox", function (key, value) {
      var filters = [{
        id: key,
        value: value,
        filter: "".concat(key, ": ").concat(value)
      }];
      _this.props.onChangeFilters(filters);
      _this.props.setShowHistoryFilter(value);
    });
    return _this;
  }
  _inherits(ServicesFilter, _Component);
  return _createClass(ServicesFilter, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        classes = _this$props.classes,
        filters = _this$props.filters,
        onChangeFilters = _this$props.onChangeFilters;
      return /*#__PURE__*/React.createElement(Grid, {
        container: true,
        className: classes.form
      }, /*#__PURE__*/React.createElement(ControlledField, {
        module: MODULE_NAME,
        id: "workforce.organization.name.employee.en",
        field: /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 3,
          className: classes.item
        }, /*#__PURE__*/React.createElement(TextInput, {
          module: MODULE_NAME,
          label: "workforce.organization.employee.name.en",
          name: "nameEn",
          value: this._filterValue("nameEn"),
          onChange: function onChange(v) {
            return _this2.debouncedOnChangeFilter([{
              id: "nameEn",
              value: v,
              filter: "nameEn_Icontains: \"".concat(v, "\"")
            }]);
          }
        }))
      }), /*#__PURE__*/React.createElement(ControlledField, {
        module: MODULE_NAME,
        id: "workforce.organization.employee.name.bn",
        field: /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 3,
          className: classes.item
        }, /*#__PURE__*/React.createElement(RelationPicker, {
          module: MODULE_NAME,
          value: this._filterValue("relation"),
          label: /*#__PURE__*/React.createElement(FormattedMessage, {
            id: "workforce.employee.relation.picker",
            module: "workforce"
          }),
          onChange: function onChange(v) {
            return _this2.debouncedOnChangeFilter([{
              id: "relation",
              value: v,
              filter: "relation_Icontains: \"".concat(v, "\"")
            }]);
          }
          // onChange={(v) => this.updateAttribute("lifeStatus", v)}
          // readOnly={isSaved}
        }))
      }), /*#__PURE__*/React.createElement(ControlledField, {
        module: MODULE_NAME,
        id: "workforce.organization.employee.phone",
        field: /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 3,
          className: classes.item
        }, /*#__PURE__*/React.createElement(EmployeeLifeStatusPicker, {
          module: MODULE_NAME,
          value: this._filterValue("lifeStatus"),
          label: /*#__PURE__*/React.createElement(FormattedMessage, {
            id: "workforce.employee.lifeStatus",
            module: "workforce"
          }),
          onChange: function onChange(v) {
            return _this2.debouncedOnChangeFilter([{
              id: "lifeStatus",
              value: v,
              filter: "lifeStatus_Icontains: \"".concat(v, "\"")
            }]);
          }
          // onChange={(v) => this.updateAttribute("lifeStatus", v)}
          // readOnly={isSaved}
        }))
      }), /*#__PURE__*/React.createElement(Contributions, {
        filters: filters,
        onChangeFilters: onChangeFilters,
        contributionKey: WORKFORCE_ORGANIZATION_EMPLOYEE_FILTER_CONTRIBUTION_KEY
      }));
    }
  }]);
}(Component);
var DependentFilter = withModulesManager(withTheme(withStyles(styles$r)(ServicesFilter)));

function _callSuper$p(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$p() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$p() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$p = function _isNativeReflectConstruct() { return !!t; })(); }
function ownKeys$1f(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$1f(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$1f(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1f(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var styles$q = function styles(theme) {
  return {
    paper: _objectSpread$1f(_objectSpread$1f({}, theme.paper.paper), {}, {
      margin: 0
    }),
    paperHeader: _objectSpread$1f(_objectSpread$1f({}, theme.paper.header), {}, {
      padding: 10
    }),
    tableTitle: theme.table.title,
    fab: theme.fab,
    button: {
      margin: theme.spacing(1)
    },
    item: {
      padding: theme.spacing(1)
    },
    horizontalButtonContainer: _objectSpread$1f(_objectSpread$1f({}, theme.buttonContainer.horizontal), {}, {
      display: "flex",
      alignItems: "center",
      gap: theme.spacing(1)
    }),
    compactButton: {
      maxHeight: "30px",
      minWidth: "80px",
      padding: "1px 4px",
      borderRadius: "6px",
      backgroundColor: "#006273",
      color: "white",
      fontSize: "0.7rem",
      textTransform: "none",
      marginRight: "2px",
      "&:hover": {
        backgroundColor: "#004a5e"
      }
    },
    buttonContainer: {
      display: "flex",
      gap: theme.spacing(1)
    }
  };
};
var ServicesSearcher = /*#__PURE__*/function (_Component) {
  function ServicesSearcher(props) {
    var _this;
    _classCallCheck(this, ServicesSearcher);
    _this = _callSuper$p(this, ServicesSearcher, [props]);
    _defineProperty(_this, "fetch", function (prms) {
      var showHistoryFilter = _this.state.showHistoryFilter;
      _this.setState({
        displayVersion: showHistoryFilter
      });
      _this.props.fetchServicesSummary(_this.props.modulesManager, prms);
    });
    _defineProperty(_this, "rowIdentifier", function (r) {
      return r.uuid;
    });
    _defineProperty(_this, "isShowHistory", function () {
      return _this.state.displayVersion;
    });
    _defineProperty(_this, "filtersToQueryParams", function (state) {
      var prms = Object.keys(state.filters).filter(function (f) {
        return !!state.filters[f].filter;
      }).map(function (f) {
        return state.filters[f].filter;
      });
      prms.push("first: ".concat(state.pageSize));
      if (state.afterCursor) {
        prms.push("after: \"".concat(state.afterCursor, "\""));
      }
      if (state.beforeCursor) {
        prms.push("before: \"".concat(state.beforeCursor, "\""));
      }
      if (state.orderBy) {
        prms.push("orderBy: [\"".concat(state.orderBy, "\"]"));
      }
      return prms;
    });
    _defineProperty(_this, "headers", function () {
      return ["workforce.employee.first.name.en", "workforce.employee.first.name.bn", "workforce.employee.last.name.en", "workforce.employee.last.name.bn", "workforce.employee.position", "workforce.employee.services.resignation.date", "workforce.employee.status", _this.isShowHistory() ? "workforce.version" : ""];
    });
    _defineProperty(_this, "sorts", function () {
      return [];
    });
    _defineProperty(_this, "itemFormatters", function () {
      var formatters = [function (workforceEmployeeServices) {
        return workforceEmployeeServices.workforceEmployee.firstNameEn;
      }, function (workforceEmployeeServices) {
        return workforceEmployeeServices.workforceEmployee.firstNameBn;
      }, function (workforceEmployeeServices) {
        return workforceEmployeeServices.workforceEmployee.lastNameEn;
      }, function (workforceEmployeeServices) {
        return workforceEmployeeServices.workforceEmployee.lastNameBn;
      }, function (workforceEmployeeServices) {
        return workforceEmployeeServices.position;
      }, function (workforceEmployeeServices) {
        return workforceEmployeeServices.resignationDate;
      }, function (workforceEmployeeServices) {
        return workforceEmployeeServices.status;
      }, function (workforceEmployeeServices) {
        return _this.isShowHistory() ? workforceEmployeeServices === null || workforceEmployeeServices === void 0 ? void 0 : workforceEmployeeServices.version : null;
      }];
      formatters.push(function (workforceEmployeeServices) {
        return /*#__PURE__*/React.createElement(Tooltip, {
          title: "Edit"
        }, /*#__PURE__*/React.createElement(IconButton, {
          disabled: workforceEmployeeServices === null || workforceEmployeeServices === void 0 ? void 0 : workforceEmployeeServices.isHistory,
          onClick: function onClick() {
            historyPush$1(_this.props.modulesManager, _this.props.history, "workforce.route.employees.services.service", [decodeId(workforceEmployeeServices.id)], false);
          }
        }, /*#__PURE__*/React.createElement(EditIcon, null)));
      });
      return formatters;
    });
    _defineProperty(_this, "rowDisabled", function (selection, i) {
      return !!i.validityTo;
    });
    _defineProperty(_this, "rowLocked", function (selection, i) {
      return !!i.clientMutationId;
    });
    _this.state = {
      chfid: null,
      confirmedAction: null,
      reset: 0,
      showHistoryFilter: false,
      displayVersion: false
    };
    _this.rowsPerPageOptions = [10, 20, 50, 100];
    _this.defaultPageSize = 10;
    return _this;
  }
  _inherits(ServicesSearcher, _Component);
  return _createClass(ServicesSearcher, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState, snapshot) {
      if (prevProps.submittingMutation && !this.props.submittingMutation) {
        this.props.journalize(this.props.mutation);
        this.setState({
          reset: prevState.reset + 1
        });
      } else if (!prevProps.confirmed && this.props.confirmed) {
        this.state.confirmedAction();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props;
        _this$props.intl;
        var employeeServices = _this$props.employeeServices,
        employeeServicesPageInfo = _this$props.employeeServicesPageInfo,
        fetchingEmployeeServices = _this$props.fetchingEmployeeServices,
        fetchedEmployeeServices = _this$props.fetchedEmployeeServices,
        errorEmployeeServices = _this$props.errorEmployeeServices,
        filterPaneContributionsKey = _this$props.filterPaneContributionsKey,
        cacheFiltersKey = _this$props.cacheFiltersKey,
        _onDoubleClick = _this$props.onDoubleClick;
      employeeServicesPageInfo.totalCount;
      var filterPane = function filterPane(_ref) {
        var filters = _ref.filters,
          onChangeFilters = _ref.onChangeFilters;
        return /*#__PURE__*/React.createElement(DependentFilter, {
          filters: filters,
          onChangeFilters: onChangeFilters,
          setShowHistoryFilter: function setShowHistoryFilter(showHistoryFilter) {
            return _this2.setState({
              showHistoryFilter: showHistoryFilter
            });
          }
        });
      };
      console.log({
        employeeServices: employeeServices
      });
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Searcher$2, {
        module: MODULE_NAME,
        cacheFiltersKey: cacheFiltersKey,
        FilterPane: filterPane,
        filterPaneContributionsKey: filterPaneContributionsKey,
        items: employeeServices,
        itemsPageInfo: employeeServicesPageInfo,
        fetchingItems: fetchingEmployeeServices,
        fetchedItems: fetchedEmployeeServices,
        errorItems: errorEmployeeServices,
        tableTitle: /*#__PURE__*/React.createElement(FormattedMessage, {
          module: MODULE_NAME,
          id: "menu.workforce.employee.dependent"
        }),
        rowsPerPageOptions: this.rowsPerPageOptions,
        defaultPageSize: this.defaultPageSize,
        fetch: this.fetch,
        rowIdentifier: this.rowIdentifier,
        filtersToQueryParams: this.filtersToQueryParams,
        defaultOrderBy: "-dateCreated",
        headers: this.headers,
        itemFormatters: this.itemFormatters,
        sorts: this.sorts,
        rowDisabled: this.rowDisabled,
        rowLocked: this.rowLocked,
        onDoubleClick: function onDoubleClick(i) {
          return !i.clientMutationId && _onDoubleClick(i);
        },
        reset: this.state.reset
      }));
    }
  }]);
}(Component);
var mapStateToProps$n = function mapStateToProps(state) {
  return {
    rights: !!state.core && !!state.core.user && !!state.core.user.i_user ? state.core.user.i_user.rights : [],
    employeeServices: state.workforce.employeeServices,
    employeeServicesPageInfo: state.workforce.employeeServicesPageInfo,
    fetchingEmployeeServices: state.workforce.fetchingEmployeeServices,
    fetchedEmployeeServices: state.workforce.fetchedEmployeeServices,
    errorEmployeeServices: state.workforce.errorEmployeeServices,
    submittingMutation: state.workforce.submittingMutation,
    mutation: state.workforce.mutation,
    confirmed: state.core.confirmed
  };
};
var mapDispatchToProps$f = function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    fetchServicesSummary: fetchServicesSummary,
    journalize: journalize,
    coreConfirm: coreConfirm
  }, dispatch);
};
var ServicesSearcher$1 = withModulesManager(withHistory(connect(mapStateToProps$n, mapDispatchToProps$f)(withTheme(withStyles(styles$q)(ServicesSearcher)))));

function _callSuper$o(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$o() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$o() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$o = function _isNativeReflectConstruct() { return !!t; })(); }
var styles$p = function styles(theme) {
  return {
    page: theme.page,
    fab: theme.fab,
    ROUTE_WORKFORCE_ORGANIZATIONS_EMPLOYEES_EMPLOYEE: ROUTE_WORKFORCE_ORGANIZATIONS_EMPLOYEES_EMPLOYEE
  };
};
var ServicesPage = /*#__PURE__*/function (_Component) {
  function ServicesPage() {
    var _this;
    _classCallCheck(this, ServicesPage);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper$o(this, ServicesPage, [].concat(args));
    _defineProperty(_this, "onDoubleClick", function (employee) {
      var newTab = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var routeParams = ["workforce.route.employees.dependents.dependent", [decodeId(employee.id)]];
      if (employee !== null && employee !== void 0 && employee.isHistory) {
        routeParams[1].push(employee.version);
      }
      historyPush$1.apply(void 0, [_this.props.modulesManager, _this.props.history].concat(routeParams, [newTab]));
    });
    _defineProperty(_this, "onAdd", function () {
      historyPush$1(_this.props.modulesManager, _this.props.history, "workforce.route.employees.services.service");
    });
    return _this;
  }
  _inherits(ServicesPage, _Component);
  return _createClass(ServicesPage, [{
    key: "render",
    value: function render() {
      var _this$props = this.props;
        _this$props.intl;
        var classes = _this$props.classes;
        _this$props.rights;
      return /*#__PURE__*/React.createElement("div", {
        className: classes.page
      }, /*#__PURE__*/React.createElement(ServicesSearcher$1, {
        cacheFiltersKey: "ticketPageFiltersCache",
        onDoubleClick: this.onDoubleClick
      }), withTooltip(/*#__PURE__*/React.createElement("div", {
        className: classes.fab
      }, /*#__PURE__*/React.createElement(Fab, {
        color: "primary",
        onClick: this.onAdd
      }, /*#__PURE__*/React.createElement(AddIcon, null))), /*#__PURE__*/React.createElement(FormattedMessage, {
        module: MODULE_NAME,
        id: "workforce.organization.employee.addNewTooltip"
      })));
    }
  }]);
}(Component);
var mapStateToProps$m = function mapStateToProps(state) {
  return {
    rights: !!state.core && !!state.core.user && !!state.core.user.i_user ? state.core.user.i_user.rights : []
  };
};
var ServicesPage$1 = withModulesManager(withHistory(connect(mapStateToProps$m)(withTheme(withStyles(styles$p)(ServicesPage)))));

function ownKeys$1e(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$1e(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$1e(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1e(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper$n(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$n() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$n() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$n = function _isNativeReflectConstruct() { return !!t; })(); }
var styles$o = function styles(theme) {
  return {
    paper: theme.paper.paper,
    tableTitle: theme.table.title,
    item: theme.paper.item,
    fullHeight: {
      height: "100%"
    }
  };
};
var EditServicesPage = /*#__PURE__*/function (_Component) {
  function EditServicesPage(props) {
    var _this;
    _classCallCheck(this, EditServicesPage);
    _this = _callSuper$n(this, EditServicesPage, [props]);
    _defineProperty(_this, "updateAttribute", function (key, value) {
      _this.setState(function (prevState) {
        return {
          stateEdited: _objectSpread$1e(_objectSpread$1e({}, prevState.stateEdited), {}, _defineProperty({}, key, value)),
          isSaved: false
        };
      });
    });
    _defineProperty(_this, "save", function () {
      var _stateEdited$gender;
      var _this$props = _this.props;
        _this$props.grievanceConfig;
        var dispatch = _this$props.dispatch;
      var stateEdited = _this.state.stateEdited;
      var employeeDependentData = {
        firstNameBn: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.firstNameBn) || stateEdited.firstNameBn,
        lastNameBn: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.lastNameBn) || stateEdited.lastNameBn,
        firstNameEn: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.firstNameEn) || stateEdited.firstNameEn,
        lastNameEn: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.lastNameEn) || stateEdited.lastNameEn,
        phoneNumber: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.phoneNumber) || stateEdited.phoneNumber,
        email: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.email) || stateEdited.email,
        gender: (stateEdited === null || stateEdited === void 0 || (_stateEdited$gender = stateEdited.gender) === null || _stateEdited$gender === void 0 ? void 0 : _stateEdited$gender.id) || stateEdited.gender.id,
        birthDate: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.birthDate) || stateEdited.birthDate,
        deathDate: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.deathDate) || stateEdited.deathDate,
        lifeStatus: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.lifeStatus) || stateEdited.lifeStatus,
        permanentAddress: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.permanentAddress) || stateEdited.permanentAddress,
        presentAddress: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.presentAddress) || stateEdited.presentAddress,
        monthlyEarning: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.monthlyEarning) || stateEdited.monthlyEarning,
        fatherNameBn: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.fatherNameBn) || stateEdited.fatherNameBn,
        fatherNameEn: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.fatherNameEn) || stateEdited.fatherNameEn,
        motherNameBn: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.motherNameBn) || stateEdited.motherNameBn,
        motherNameEn: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.motherNameEn) || stateEdited.motherNameEn,
        insuranceNumber: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.insuranceNumber) || stateEdited.insuranceNumber,
        birthCertificateNo: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.birthCertificateNo) || stateEdited.birthCertificateNo,
        nid: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.nid) || stateEdited.nid,
        maritalStatus: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.maritalStatus) || stateEdited.maritalStatus,
        occupation: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.occupation) || stateEdited.occupation,
        presentLocation: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.presentLocation) || stateEdited.presentLocation,
        permanentLocation: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.permanentLocation) || stateEdited.permanentLocation,
        relationType: "dependent",
        relationWithWorker: "Wife",
        id: stateEdited.id
      };
      dispatch(updateEmployeeDependent$1(employeeDependentData, "Update Workforce Employee ".concat(employeeDependentData.nameEn)));
      _this.setState({
        isSaved: true
      });
    });
    _this.state = {
      stateEdited: props.employeeService || {},
      isSaved: false
    };
    return _this;
  }
  _inherits(EditServicesPage, _Component);
  return _createClass(EditServicesPage, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.employeeService !== this.props.employeeService) {
        this.setState({
          stateEdited: this.props.employeeService
        });
      }
      if (prevProps.submittingMutation && !this.props.submittingMutation) {
        this.props.dispatch(journalize(this.props.mutation));
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _stateEdited$factory,
        _this2 = this,
        _stateEdited$company;
      var classes = this.props.classes;
      var _this$state = this.state,
        stateEdited = _this$state.stateEdited,
        isSaved = _this$state.isSaved;
      console.log({
        stateEdited: stateEdited
      });
      return /*#__PURE__*/React.createElement("div", {
        className: classes.page
      }, /*#__PURE__*/React.createElement(Grid, {
        container: true
      }, /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12
      }, /*#__PURE__*/React.createElement(Paper, {
        className: classes.paper
      }, /*#__PURE__*/React.createElement(Grid, {
        container: true,
        className: classes.tableTitle
      }, /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12,
        className: classes.tableTitle
      }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(FormattedMessage, {
        module: MODULE_NAME,
        id: "Employee Service",
        values: {
          label: EMPTY_STRING
        }
      })))), /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement(Grid, {
        container: true,
        className: classes.item
      }, /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(FactoryPicker, {
        value: stateEdited === null || stateEdited === void 0 || (_stateEdited$factory = stateEdited.factory) === null || _stateEdited$factory === void 0 ? void 0 : _stateEdited$factory.id,
        label: /*#__PURE__*/React.createElement(FormattedMessage, {
          id: "workforce.employee.workforce_factory",
          module: "workforce"
        }),
        required: true,
        onChange: function onChange(v) {
          return _this2.updateAttribute("factory", v);
        },
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(CompanyPicker, {
        value: stateEdited === null || stateEdited === void 0 || (_stateEdited$company = stateEdited.company) === null || _stateEdited$company === void 0 ? void 0 : _stateEdited$company.id,
        label: /*#__PURE__*/React.createElement(FormattedMessage, {
          id: "workforce.employee.services.company.name",
          module: "workforce"
        }),
        required: true,
        onChange: function onChange(v) {
          return _this2.updateAttribute("company", v);
        },
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.employee.services.employee.name",
        value: stateEdited.employeeName || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("employeeName", v);
        },
        required: true,
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.employee.position",
        value: stateEdited.position || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("position", v);
        },
        required: true,
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(PublishedComponent, {
        pubRef: "workforce.DatePicker",
        label: "workforce.employee.services.join.date",
        value: stateEdited.joinDate || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("joinDate", v);
        },
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(PublishedComponent, {
        pubRef: "workforce.DatePicker",
        label: "workforce.employee.services.resignation.date",
        value: stateEdited.resignationDate || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("resignationDate", v);
        },
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.employee.services.monthly.salary",
        value: stateEdited.salary || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("salary", v);
        },
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.employee.services.resignation.reason",
        value: stateEdited.resignationReason || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("resignationReason", v);
        },
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 11,
        className: classes.item
      }), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 1,
        className: classes.item
      }, /*#__PURE__*/React.createElement(IconButton, {
        variant: "contained",
        component: "label",
        color: "primary",
        onClick: this.save,
        disabled: isSaved
      }, /*#__PURE__*/React.createElement(Save, null)))), /*#__PURE__*/React.createElement(Divider, null)))));
    }
  }]);
}(Component);
var mapStateToProps$l = function mapStateToProps(state) {
  return {
    employeeService: state.workforce.employeeService
  };
};
var EditServicesPage$1 = connect(mapStateToProps$l)(withStyles(styles$o)(EditServicesPage));

function ownKeys$1d(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$1d(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$1d(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1d(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper$m(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$m() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$m() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$m = function _isNativeReflectConstruct() { return !!t; })(); }
var styles$n = function styles(theme) {
  return {
    paper: theme.paper.paper,
    tableTitle: theme.table.title,
    item: theme.paper.item,
    fullHeight: {
      height: "100%"
    }
  };
};
var AddServicesPage = /*#__PURE__*/function (_Component) {
  function AddServicesPage(props) {
    var _this;
    _classCallCheck(this, AddServicesPage);
    _this = _callSuper$m(this, AddServicesPage, [props]);
    _defineProperty(_this, "save", function () {
      var _stateEdited$gender;
      var _this$props = _this.props;
        _this$props.grievanceConfig;
        var dispatch = _this$props.dispatch;
      var stateEdited = _this.state.stateEdited;
      var employeeDependentData = {
        firstNameBn: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.firstNameBn) || stateEdited.firstNameBn,
        lastNameBn: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.lastNameBn) || stateEdited.lastNameBn,
        firstNameEn: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.firstNameEn) || stateEdited.firstNameEn,
        lastNameEn: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.lastNameEn) || stateEdited.lastNameEn,
        phoneNumber: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.phoneNumber) || stateEdited.phoneNumber,
        email: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.email) || stateEdited.email,
        gender: (stateEdited === null || stateEdited === void 0 || (_stateEdited$gender = stateEdited.gender) === null || _stateEdited$gender === void 0 ? void 0 : _stateEdited$gender.id) || stateEdited.gender.id,
        birthDate: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.birthDate) || stateEdited.birthDate,
        deathDate: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.deathDate) || stateEdited.deathDate,
        lifeStatus: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.lifeStatus) || stateEdited.lifeStatus,
        permanentAddress: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.permanentAddress) || stateEdited.permanentAddress,
        presentAddress: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.presentAddress) || stateEdited.presentAddress,
        monthlyEarning: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.monthlyEarning) || stateEdited.monthlyEarning,
        fatherNameBn: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.fatherNameBn) || stateEdited.fatherNameBn,
        fatherNameEn: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.fatherNameEn) || stateEdited.fatherNameEn,
        motherNameBn: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.motherNameBn) || stateEdited.motherNameBn,
        motherNameEn: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.motherNameEn) || stateEdited.motherNameEn,
        insuranceNumber: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.insuranceNumber) || stateEdited.insuranceNumber,
        birthCertificateNo: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.birthCertificateNo) || stateEdited.birthCertificateNo,
        nid: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.nid) || stateEdited.nid,
        maritalStatus: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.maritalStatus) || stateEdited.maritalStatus,
        occupation: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.occupation) || stateEdited.occupation,
        presentLocation: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.presentLocation) || stateEdited.presentLocation,
        permanentLocation: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.permanentLocation) || stateEdited.permanentLocation,
        relationType: "dependent",
        relationWithWorker: "Wife",
        id: stateEdited.id
      };
      dispatch(updateEmployeeDependent(employeeDependentData, "Update Workforce Employee ".concat(employeeDependentData.nameEn)));
      _this.setState({
        isSaved: true
      });
    });
    _defineProperty(_this, "updateAttribute", function (key, value) {
      _this.setState(function (prevState) {
        return {
          stateEdited: _objectSpread$1d(_objectSpread$1d({}, prevState.stateEdited), {}, _defineProperty({}, key, value)),
          isSaved: false
        };
      });
    });
    _this.state = {
      stateEdited: {},
      isSaved: false
    };
    return _this;
  }
  _inherits(AddServicesPage, _Component);
  return _createClass(AddServicesPage, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props2 = this.props,
        submittingMutation = _this$props2.submittingMutation,
        mutation = _this$props2.mutation,
        dispatch = _this$props2.dispatch;
      if (!submittingMutation && prevProps.submittingMutation !== submittingMutation) {
        dispatch(journalize(mutation));
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _stateEdited$factory,
        _this2 = this,
        _stateEdited$company;
      var classes = this.props.classes;
      var _this$state = this.state,
        stateEdited = _this$state.stateEdited,
        isSaved = _this$state.isSaved;
      console.log({
        stateEdited: stateEdited
      });
      return /*#__PURE__*/React.createElement("div", {
        className: classes.page
      }, /*#__PURE__*/React.createElement(Grid, {
        container: true
      }, /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12
      }, /*#__PURE__*/React.createElement(Paper, {
        className: classes.paper
      }, /*#__PURE__*/React.createElement(Grid, {
        container: true,
        className: classes.tableTitle
      }, /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12,
        className: classes.tableTitle
      }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(FormattedMessage, {
        module: MODULE_NAME,
        id: "Employee Service",
        values: {
          label: EMPTY_STRING
        }
      })))), /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement(Grid, {
        container: true,
        className: classes.item
      }, /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(FactoryPicker, {
        value: stateEdited === null || stateEdited === void 0 || (_stateEdited$factory = stateEdited.factory) === null || _stateEdited$factory === void 0 ? void 0 : _stateEdited$factory.id,
        label: /*#__PURE__*/React.createElement(FormattedMessage, {
          id: "workforce.employee.workforce_factory",
          module: "workforce"
        }),
        required: true,
        onChange: function onChange(v) {
          return _this2.updateAttribute("factory", v);
        },
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(CompanyPicker, {
        value: stateEdited === null || stateEdited === void 0 || (_stateEdited$company = stateEdited.company) === null || _stateEdited$company === void 0 ? void 0 : _stateEdited$company.id,
        label: /*#__PURE__*/React.createElement(FormattedMessage, {
          id: "workforce.employee.services.company.name",
          module: "workforce"
        }),
        required: true,
        onChange: function onChange(v) {
          return _this2.updateAttribute("company", v);
        },
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.employee.services.employee.name",
        value: stateEdited.employeeName || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("employeeName", v);
        },
        required: true,
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.employee.position",
        value: stateEdited.position || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("position", v);
        },
        required: true,
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(PublishedComponent, {
        pubRef: "workforce.DatePicker",
        label: "workforce.employee.services.join.date",
        value: stateEdited.joinDate || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("joinDate", v);
        },
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(PublishedComponent, {
        pubRef: "workforce.DatePicker",
        label: "workforce.employee.services.resignation.date",
        value: stateEdited.resignationDate || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("resignationDate", v);
        },
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.employee.services.monthly.salary",
        value: stateEdited.salary || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("salary", v);
        },
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.employee.services.resignation.reason",
        value: stateEdited.resignationReason || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("resignationReason", v);
        },
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 11,
        className: classes.item
      }), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 1,
        className: classes.item
      }, /*#__PURE__*/React.createElement(IconButton, {
        variant: "contained",
        component: "label",
        color: "primary",
        onClick: this.save,
        disabled: isSaved
      }, /*#__PURE__*/React.createElement(Save, null)))), /*#__PURE__*/React.createElement(Divider, null)))));
    }
  }]);
}(Component);
var mapStateToProps$k = function mapStateToProps(state) {
  return {
    submittingMutation: state.workforce.submittingMutation,
    mutation: state.workforce.mutation
  };
};
var AddServicesPage$1 = connect(mapStateToProps$k)(withStyles(styles$n)(AddServicesPage));

function ownKeys$1c(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$1c(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$1c(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1c(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper$l(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$l() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$l() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$l = function _isNativeReflectConstruct() { return !!t; })(); }
var ServicesForm = /*#__PURE__*/function (_Component) {
  function ServicesForm(props) {
    var _this;
    _classCallCheck(this, ServicesForm);
    _this = _callSuper$l(this, ServicesForm, [props]);
    _defineProperty(_this, "reload", function () {});
    _defineProperty(_this, "canSave", function () {});
    _defineProperty(_this, "_save", function (ticket) {
      _this.setState({
        lockNew: !ticket.uuid
      }, function () {
        return _this.props.save(ticket);
      });
    });
    _defineProperty(_this, "onEditedChanged", function (ticket) {
      _this.setState({
        ticket: ticket
      });
    });
    _defineProperty(_this, "reopenTicket", function () {
      var _this$props = _this.props,
        intl = _this$props.intl,
        ticket = _this$props.ticket;
      _this.props.reopenTicket(ticket.id, formatMessage(intl, MODULE_NAME, "reopenTicket.mutation.label"));
    });
    _this.state = {
      lockNew: false,
      reset: 0,
      serviceUuid: null,
      ticket: _this._newTicket()
    };
    return _this;
  }
  _inherits(ServicesForm, _Component);
  return _createClass(ServicesForm, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.serviceUuid) {
        this.setState(function (state, props) {
          return {
            serviceUuid: props.serviceUuid
          };
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {}
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState, snapshot) {
      if (prevProps.fetchedEmployeeService !== this.props.fetchedEmployeeService && !!this.props.fetchedEmployeeService && !!this.props.employeeService) {
        this.setState(function (state, props) {
          return {
            employeeService: _objectSpread$1c({}, props.employeeService),
            serviceUuid: props.employeeService.id,
            lockNew: false
          };
        });
      } else if (prevState.serviceUuid !== this.state.serviceUuid) {
        var filters = ["id: \"".concat(this.state.serviceUuid, "\"")];
        this.props.fetchService(this.props.modulesManager, filters);
      } else if (prevProps.submittingMutation && !this.props.submittingMutation) {
        var _this$props2;
        this.props.journalize(this.props.mutation);
        this.setState(function (state) {
          return {
            reset: state.reset + 1
          };
        });
        if ((_this$props2 = this.props) !== null && _this$props2 !== void 0 && (_this$props2 = _this$props2.employeeService) !== null && _this$props2 !== void 0 && _this$props2.id) {
          this.props.fetchService(this.props.modulesManager, ["id: \"".concat(this.state.serviceUuid, "\"")]);
        }
      }
    }
  }, {
    key: "_newTicket",
    value: function _newTicket() {
      return {};
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
        fetchingTicket = _this$props3.fetchingTicket,
        fetchedEmployeeService = _this$props3.fetchedEmployeeService,
        errorTicket = _this$props3.errorTicket,
        save = _this$props3.save,
        back = _this$props3.back;
      var _this$state = this.state,
        lockNew = _this$state.lockNew,
        reset = _this$state.reset,
        update = _this$state.update,
        overview = _this$state.overview,
        serviceUuid = _this$state.serviceUuid,
        ticket = _this$state.ticket;
      var readOnly = lockNew || !!ticket.validityTo || this.props.readOnly;
      [{
        doIt: this.reopenTicket,
        icon: /*#__PURE__*/React.createElement(LockOpenIcon, null),
        disabled: ticket.isHistory
      }];
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ProgressOrError, {
        progress: fetchingTicket,
        error: errorTicket
      }), (!!fetchedEmployeeService || !serviceUuid) && /*#__PURE__*/React.createElement(Form, {
        module: MODULE_NAME,
        edited_id: serviceUuid,
        edited: ticket,
        reset: reset,
        update: update,
        title: "Employee Service",
        titleParams: {
          label: "Label"
        },
        back: back,
        save: save ? this._save : null,
        canSave: this.canSave,
        reload: (serviceUuid || readOnly) && this.reload,
        readOnly: readOnly,
        overview: overview,
        Panels: serviceUuid ? [EditServicesPage$1] : [AddServicesPage$1],
        onEditedChanged: this.onEditedChanged
      }));
    }
  }]);
}(Component); // eslint-disable-next-line no-unused-vars
var mapStateToProps$j = function mapStateToProps(state, props) {
  return {
    rights: !!state.core && !!state.core.user && !!state.core.user.i_user ? state.core.user.i_user.rights : [],
    fetchingTicket: state.workforce.fetchingTicket,
    errorTicket: state.workforce.errorTicket,
    fetchedEmployeeService: state.workforce.fetchedEmployeeService,
    ticket: state.workforce.ticket,
    submittingMutation: state.workforce.submittingMutation,
    mutation: state.workforce.mutation,
    grievanceConfig: state.workforce.grievanceConfig
  };
};
var mapDispatchToProps$e = function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    fetchService: fetchService,
    journalize: journalize
  }, dispatch);
};
var ServicesForm$1 = withModulesManager(connect(mapStateToProps$j, mapDispatchToProps$e)(ServicesForm));

function _callSuper$k(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$k() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$k() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$k = function _isNativeReflectConstruct() { return !!t; })(); }
var styles$m = function styles(theme) {
  return {
    page: theme.page,
    lockedPage: theme.page.locked
  };
};
var ServicePage = /*#__PURE__*/function (_Component) {
  function ServicePage() {
    var _this;
    _classCallCheck(this, ServicePage);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper$k(this, ServicePage, [].concat(args));
    _defineProperty(_this, "add", function () {
      historyPush$1(_this.props.modulesManager, _this.props.history, "grievance.route.ticket");
    });
    _defineProperty(_this, "save", function (employee) {
      if (!employee.id) {
        _this.props.createEmployeeDependent(_this.props.modulesManager, employee, "Create");
      } else {
        _this.props.updateEmployeeDependent(_this.props.modulesManager, employee, "Update");
      }
    });
    return _this;
  }
  _inherits(ServicePage, _Component);
  return _createClass(ServicePage, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        classes = _this$props.classes,
        modulesManager = _this$props.modulesManager,
        history = _this$props.history,
        rights = _this$props.rights,
        serviceUuid = _this$props.serviceUuid,
        overview = _this$props.overview,
        organizationVersion = _this$props.organizationVersion;
      // const readOnly = organization?.status === TICKET_STATUSES.CLOSED || ticket?.isHistory;
      var readOnly = false;
      // if (!(rights.includes(RIGHT_ORGANIZATION_CREATE) || rights.includes(RIGHT_ORGANIZATION_EDIT))) return null;
      return /*#__PURE__*/React.createElement("div", {
        className: "".concat(null, " ").concat(classes.page)
      }, /*#__PURE__*/React.createElement(ServicesForm$1, {
        overview: overview,
        serviceUuid: serviceUuid,
        organizationVersion: organizationVersion,
        readOnly: readOnly,
        back: function back() {
          return historyPush$1(modulesManager, history, "workforce.route.employees.services");
        },
        add: rights.includes(RIGHT_ORGANIZATION_CREATE) ? this.add : null,
        save: rights.includes(RIGHT_ORGANIZATION_EDIT) ? this.save : null
      }));
    }
  }]);
}(Component);
var mapStateToProps$i = function mapStateToProps(state, props) {
  return {
    rights: !!state.core && !!state.core.user && !!state.core.user.i_user ? state.core.user.i_user.rights : [],
    serviceUuid: props.match.params.service_uuid,
    organizationVersion: props.match.params.version,
    employeeService: state.workforce.employeeService
  };
};
var mapDispatchToProps$d = function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    createEmployeeService: createEmployeeService,
    updateEmployeeService: updateEmployeeService
  }, dispatch);
};
var ServicePage$1 = withHistory(withModulesManager(connect(mapStateToProps$i, mapDispatchToProps$d)(withTheme(withStyles(styles$m)(ServicePage)))));

function Alert(props) {
  return /*#__PURE__*/React.createElement(Alert$2, _extends({
    elevation: 6,
    variant: "filled"
  }, props));
}
var CustomSnackbar = function CustomSnackbar(_ref) {
  var open = _ref.open,
    onClose = _ref.onClose,
    message = _ref.message,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? "info" : _ref$type,
    _ref$duration = _ref.duration,
    duration = _ref$duration === void 0 ? 4000 : _ref$duration,
    _ref$position = _ref.position,
    position = _ref$position === void 0 ? {
      vertical: "top",
      horizontal: "center"
    } : _ref$position;
  return /*#__PURE__*/React.createElement(Snackbar, {
    open: open,
    autoHideDuration: duration,
    onClose: onClose,
    anchorOrigin: position
  }, /*#__PURE__*/React.createElement(Alert, {
    onClose: onClose,
    severity: type
  }, message));
};

function ownKeys$1b(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$1b(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$1b(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1b(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// import { REGISTRATION_ERROR_BN } from "../../constants";

var useStyles$1z = makeStyles$1(function (theme) {
  return {
    container: {
      position: "absolute",
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
      margin: "auto",
      display: "flex",
      justifyContent: "center",
      alignItems: "center"
    },
    paper: {
      padding: theme.spacing(4),
      width: 600,
      textAlign: "center",
      borderRadius: 12,
      background: "#d9e9eb" // Original background
    },
    inputContainer: {
      textAlign: "left"
    },
    otpInput: {
      width: "30rem",
      // Original size
      height: "3rem",
      margin: "0 2rem",
      fontSize: "2rem",
      borderRadius: 8,
      border: "1px solid #ccc",
      textAlign: "center",
      outline: "none",
      transition: "border-color 0.2s ease-in-out",
      "&:focus": {
        borderColor: "#1976d2"
      }
    }
  };
});
var REGISTRATION_ERROR_BN = {
  phone_number_already_exists: "ফোন নম্বর ইতিমধ্যে নিবন্ধিত",
  login_name_already_exists: "জাতীয় পরিচয়পত্র/জন্ম সনদ নম্বর ইতিমধ্যেই নিবন্ধিত"
};
var REGISTRATION_ERROR_EN = {
  phone_number_already_exists: "Phone number already exists",
  login_name_already_exists: "NID/Birth Certificate number already exists"
};
var RegistrationPage = function RegistrationPage() {
  var _useState = useState("bn"),
    _useState2 = _slicedToArray(_useState, 2),
    lang = _useState2[0],
    setLang = _useState2[1];
  var classes = useStyles$1z();
  var dispatch = useDispatch();
  var modulesManager = useModulesManager();
  var _useTranslations = useTranslations("core.RegistrationPage", modulesManager);
    _useTranslations.formatMessage;
  var _useState3 = useState(1),
    _useState4 = _slicedToArray(_useState3, 2),
    step = _useState4[0],
    setStep = _useState4[1];
  var _useState5 = useState({}),
    _useState6 = _slicedToArray(_useState5, 2),
    errors = _useState6[0],
    setErrors = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    isSubmitting = _useState8[0],
    setSubmitting = _useState8[1];
  var _useState9 = useState({
      openErrorModal: false,
      errorMessage: ""
    }),
    _useState10 = _slicedToArray(_useState9, 2),
    alertMessage = _useState10[0],
    setAlertMessage = _useState10[1];
  var internalId = useSelector(function (state) {
    var _state$workforce;
    return (_state$workforce = state.workforce) === null || _state$workforce === void 0 || (_state$workforce = _state$workforce.mutation) === null || _state$workforce === void 0 ? void 0 : _state$workforce.id;
  });
  var _useState11 = useState({
      NID_BirthCertificate: "",
      mobile: "",
      firstNameBn: "",
      firstNameEn: "",
      otp: "",
      password: "OpenBDcfEis@2025!",
      // Step 3 bypassed for now and new password by tahir for overcome password validation issue
      confirmPassword: "OpenBDcfEis@2025!"
      // password: "Password@123", // Step 3 bypassed for now
      // confirmPassword: "Password@123",
    }),
    _useState12 = _slicedToArray(_useState11, 2),
    formData = _useState12[0],
    setFormData = _useState12[1];
  var _useState13 = useState({
      status: "",
      message: null
    }),
    _useState14 = _slicedToArray(_useState13, 2),
    serverResponse = _useState14[0],
    setServerResponse = _useState14[1];
  var handleInputChange = function handleInputChange(key) {
    return function (val) {
      setErrors(_objectSpread$1b(_objectSpread$1b({}, errors), {}, _defineProperty({}, key, null)));
      setFormData(_objectSpread$1b(_objectSpread$1b({}, formData), {}, _defineProperty({}, key, val)));
    };
  };
  var validateStep1 = function validateStep1() {
    var newErrors = {};
    var idVal = (formData.NID_BirthCertificate || "").toString().trim();
    var mobVal = (formData.mobile || "").toString().trim();
    if (!formData.firstNameBn) newErrors.firstNameBn = lang == "bn" ? "নাম (বাংলা) আবশ্যক" : "Name (Bangla) is required";
    if (!formData.firstNameEn) newErrors.firstNameEn = "Name (English) is required";
    if (![10, 13, 17].includes(idVal.length)) {
      newErrors.nid = lang == "bn" ? "এনআইডি অথবা জন্ম নিবন্ধন ১০, ১৩ অথবা ১৭ ডিজিট হতে হবে" : "NID or Birth Certificate must be 10, 13 or 17 digits";
    }
    if (mobVal.length !== 11) {
      newErrors.phoneNumber = lang == "bn" ? "মোবাইল নম্বর ১১ ডিজিট হতে হবে" : "Mobile number must be 11 digits";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  var handleNext = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var payload;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            setServerResponse({
              status: "",
              message: null
            });
            if (!(step === 1 && validateStep1())) {
              _context.next = 7;
              break;
            }
            setSubmitting(true);
            payload = _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, formData.NID_BirthCertificate.length === 17 ? "birthCertificateNo" : "NID", formData.NID_BirthCertificate), "firstNameBn", formData.firstNameBn), "firstNameEn", formData.firstNameEn), "mobile", formData.mobile);
            try {
              dispatch(createWorkforceOtp(payload, "Created Workforce Office ".concat(payload.firstNameEn))).then(function (res) {
                var _res$payload, _res$payload2;
                console.log("hello", res);
                // Add .trim() to remove extra spaces
                var resErrMsg = res === null || res === void 0 || (_res$payload = res.payload) === null || _res$payload === void 0 || (_res$payload = _res$payload.data) === null || _res$payload === void 0 || (_res$payload = _res$payload.createWorkforceOtp) === null || _res$payload === void 0 || (_res$payload = _res$payload.error) === null || _res$payload === void 0 ? void 0 : _res$payload.trim();
                var isInternalId = res === null || res === void 0 || (_res$payload2 = res.payload) === null || _res$payload2 === void 0 || (_res$payload2 = _res$payload2.data) === null || _res$payload2 === void 0 || (_res$payload2 = _res$payload2.createWorkforceOtp) === null || _res$payload2 === void 0 ? void 0 : _res$payload2.internalId;
                var errorMessage = lang === "bn" ? REGISTRATION_ERROR_BN[resErrMsg] : REGISTRATION_ERROR_EN[resErrMsg];
                console.log({
                  errorMessage: errorMessage
                });
                if (isInternalId === null) {
                  setAlertMessage({
                    openErrorModal: true,
                    errorMessage: errorMessage
                  });
                } else {
                  setStep(2);
                }
              })["catch"](function (err) {
                return console.log("hello2", err);
              });
            } catch (e) {
              setServerResponse({
                status: "ERROR",
                message: lang == "bn" ? "OTP পাঠাতে সমস্যা হয়েছে" : "Problem sending OTP"
              });
            } finally {
              setSubmitting(false);
            }
            _context.next = 11;
            break;
          case 7:
            if (!(step === 2)) {
              _context.next = 11;
              break;
            }
            setSubmitting(true);
            // Original OTP verification call
            _context.next = 11;
            return dispatch(fetchWorkforceOtp(modulesManager, ["id:\"".concat(internalId, "\",otp:\"").concat(formData.otp, "\"")])).then(function (res) {
              var _res$payload3;
              var isValidOtp = (res === null || res === void 0 || (_res$payload3 = res.payload) === null || _res$payload3 === void 0 || (_res$payload3 = _res$payload3.data) === null || _res$payload3 === void 0 || (_res$payload3 = _res$payload3.workforceOtp) === null || _res$payload3 === void 0 ? void 0 : _res$payload3.status) === "active";
              if (isValidOtp) {
                handleSubmit();
              } else {
                setServerResponse({
                  status: "ERROR",
                  message: lang === "bn" ? "ভুল OTP. দয়া করে আবার চেষ্টা করুন।" : "Invalid OTP. Please try again."
                });
              }
            })["catch"](function () {
              setServerResponse({
                status: "ERROR",
                message: lang === "bn" ? "OTP যাচাই করতে সমস্যা হয়েছে।" : "Problem verifying OTP."
              });
            })["finally"](function () {
              setSubmitting(false);
            });
          case 11:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function handleNext() {
      return _ref.apply(this, arguments);
    };
  }();
  var handleSubmit = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var payload;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            payload = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, formData.NID_BirthCertificate.length === 17 ? "birthCertificateNo" : "NID", formData.NID_BirthCertificate), "firstNameBn", formData.firstNameBn), "firstNameEn", formData.firstNameEn), "mobile", formData.mobile), "password", formData.password);
            _context2.next = 3;
            return dispatch(createWorkforceUser(payload)).then(function () {
              // window.location.href = getReturnUrl() || '/';
              window.location.href = window.location.href = window.location.origin + "/login";
            });
          case 3:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function handleSubmit() {
      return _ref2.apply(this, arguments);
    };
  }();
  console.log({
    registration: formData
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, isSubmitting && /*#__PURE__*/React.createElement(LinearProgress, null), /*#__PURE__*/React.createElement("div", {
    className: classes.container
  }, /*#__PURE__*/React.createElement(Paper, {
    className: classes.paper,
    elevation: 3
  }, /*#__PURE__*/React.createElement(Box$1, {
    display: "flex",
    justifyContent: "flex-start"
  }, /*#__PURE__*/React.createElement(Button, {
    startIcon: /*#__PURE__*/React.createElement(ArrowBackIcon, null),
    href: getReturnUrl(),
    variant: "text",
    color: "primary",
    style: {
      padding: "3px"
    }
  }, lang == "bn" ? "হোম পেজে ফিরে যান" : "Back to home")), /*#__PURE__*/React.createElement(Box$1, {
    display: "flex",
    justifyContent: "flex-end",
    mt: -4
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "primary",
    color: "primary",
    style: {
      padding: "3px"
    },
    onClick: function onClick() {
      return setLang(lang == "bn" ? "en" : "bn");
    }
  }, lang == "bn" ? "বাংলা" : "English")), /*#__PURE__*/React.createElement(Typography, {
    variant: "h5",
    color: "primary"
  }, lang == "bn" ? "উপকারভোগী নিবন্ধন ফর্ম" : "Beneficiary Registration Form"), /*#__PURE__*/React.createElement("form", {
    onSubmit: function onSubmit(e) {
      return e.preventDefault();
    }
  }, /*#__PURE__*/React.createElement(Box$1, {
    mt: 2,
    className: classes.inputContainer
  }, step === 1 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Box$1, {
    style: {
      padding: 2
    }
  }, /*#__PURE__*/React.createElement(TextInput, {
    id: "nameBn",
    required: true,
    label: lang == "bn" ? "নাম (বাংলা)" : "Name (Bangla)",
    fullWidth: true,
    value: formData.firstNameBn,
    formatInput: filterBangla,
    onChange: function onChange(v) {
      return handleInputChange("firstNameBn")(filterBangla(v));
    },
    error: !!errors.firstNameBn
  }), errors.firstNameBn && /*#__PURE__*/React.createElement(FormHelperText, {
    error: true
  }, errors.firstNameBn)), /*#__PURE__*/React.createElement(Box$1, {
    style: {
      padding: 2
    }
  }, /*#__PURE__*/React.createElement(TextInput, {
    id: "nameEn",
    required: true,
    label: lang == "bn" ? "নাম (ইংরেজি)" : "Name (English)",
    fullWidth: true,
    value: formData.firstNameEn,
    formatInput: filterEnglish,
    onChange: function onChange(v) {
      return handleInputChange("firstNameEn")(filterEnglish(v));
    },
    error: !!errors.firstNameEn
  }), errors.firstNameEn && /*#__PURE__*/React.createElement(FormHelperText, {
    error: true
  }, errors.firstNameEn)), /*#__PURE__*/React.createElement(Box$1, {
    style: {
      padding: 2
    }
  }, /*#__PURE__*/React.createElement(TextInput, {
    id: "nid",
    required: true,
    label: lang == "bn" ? "জাতীয় পরিচয়পত্র (এনআইডি) / জন্ম সনদ নম্বর" : "National ID / Birth Certificate Number",
    fullWidth: true,
    value: formData.NID_BirthCertificate,
    onChange: function onChange(value) {
      return handleInputChange("NID_BirthCertificate")(value.replace(/\D/g, ""));
    },
    error: !!errors.nid
  }), errors.nid && /*#__PURE__*/React.createElement(FormHelperText, {
    error: true
  }, errors.nid)), /*#__PURE__*/React.createElement(Box$1, {
    style: {
      padding: 2
    }
  }, /*#__PURE__*/React.createElement(TextInput, {
    id: "phoneNumber",
    required: true,
    label: lang == "bn" ? "মোবাইল নম্বর (ইউজারনেম)" : "Mobile Number (Username)",
    fullWidth: true,
    value: formData.mobile,
    onChange: function onChange(value) {
      return handleInputChange("mobile")(normalizeNumberInput(value).replace(/\D/g, ""));
    },
    error: !!errors.phoneNumber
  }), errors.phoneNumber && /*#__PURE__*/React.createElement(FormHelperText, {
    error: true
  }, errors.phoneNumber))), step === 2 && /*#__PURE__*/React.createElement(Box$1, {
    display: "flex",
    justifyContent: "center",
    my: 3
  }, /*#__PURE__*/React.createElement(OtpInput, {
    value: formData.otp,
    onChange: function onChange(val) {
      return setFormData(_objectSpread$1b(_objectSpread$1b({}, formData), {}, {
        otp: val
      }));
    },
    numInputs: 5,
    renderSeparator: /*#__PURE__*/React.createElement("span", null, "-"),
    inputStyle: classes.otpInput,
    renderInput: function renderInput(props) {
      return /*#__PURE__*/React.createElement("input", props);
    }
  })), (serverResponse === null || serverResponse === void 0 ? void 0 : serverResponse.message) && /*#__PURE__*/React.createElement(Box$1, {
    color: serverResponse.status === "ERROR" ? "error.main" : "success.main",
    mt: 2,
    textAlign: "center"
  }, serverResponse.message), /*#__PURE__*/React.createElement(Button, {
    fullWidth: true,
    onClick: handleNext,
    disabled: isSubmitting,
    color: "primary",
    variant: "contained",
    style: {
      marginTop: 16
    }
  }, step === 1 ? lang == "bn" ? "পরবর্তী" : "Next" : lang == "bn" ? "সাবমিট করুন" : "Submit"), step !== 1 && /*#__PURE__*/React.createElement(Button, {
    fullWidth: true,
    onClick: function onClick() {
      step == 1 ? window.location.href = getReturnUrl() : setStep(step - 1);
      setServerResponse({
        status: "",
        message: null
      });
    },
    startIcon: /*#__PURE__*/React.createElement(ArrowBackIcon, null),
    color: "primary",
    variant: "text",
    style: {
      marginTop: 8
    }
  }, lang == "bn" ? "পিছনে" : "Back")))), /*#__PURE__*/React.createElement(CustomSnackbar, {
    open: alertMessage.openErrorModal,
    onClose: function onClose() {
      return setAlertMessage({
        openErrorModal: false,
        errorMessage: ""
      });
    },
    type: "error",
    message: alertMessage === null || alertMessage === void 0 ? void 0 : alertMessage.errorMessage,
    duration: 5000
  })));
};

var WorkforceEmployeePicker = function WorkforceEmployeePicker(_ref) {
  var modulesManager = _ref.modulesManager,
    workforceFactoryId = _ref.workforceFactoryId,
    _onChange = _ref.onChange,
    readOnly = _ref.readOnly,
    required = _ref.required,
    _ref$withLabel = _ref.withLabel,
    withLabel = _ref$withLabel === void 0 ? true : _ref$withLabel,
    withPlaceholder = _ref.withPlaceholder,
    value = _ref.value,
    label = _ref.label,
    placeholder = _ref.placeholder,
    filterSelectedOptions = _ref.filterSelectedOptions,
    multiple = _ref.multiple;
  var _useState = useState(""),
    _useState2 = _slicedToArray(_useState, 2);
    _useState2[0];
    var setSearchString = _useState2[1];
  var _useTranslations = useTranslations("workforce"),
    formatMessage = _useTranslations.formatMessage;
  var user = useSelector(function (state) {
    var _state$core;
    return (_state$core = state.core) === null || _state$core === void 0 ? void 0 : _state$core.user;
  });
  console.log("user infos", user);
  var dispatch = useDispatch();
  useEffect(function () {
    dispatch(fetchWorkforceEmployeesSummary(modulesManager, ["workforceFactoryId:\"".concat(workforceFactoryId, "\"")]));
  }, []);
  var isLoading = useSelector(function (state) {
    return state.workforce["fetchingWorkforceEmployees"];
  });
  var data = useSelector(function (state) {
    var _state$workforce;
    return (_state$workforce = state.workforce["workforceEmployees"]) !== null && _state$workforce !== void 0 ? _state$workforce : [];
  });
  var error = useSelector(function (state) {
    return state.workforce["errorWorkforceEmployees"];
  });
  var selectedOption = useMemo(function () {
    return data.find(function (option) {
      return option.id === value;
    }) || null;
  }, [value, data]);
  var locale = useSelector(function (state) {
    var _state$core2;
    return ((_state$core2 = state.core) === null || _state$core2 === void 0 || (_state$core2 = _state$core2.user) === null || _state$core2 === void 0 || (_state$core2 = _state$core2.i_user) === null || _state$core2 === void 0 ? void 0 : _state$core2.language) || "en";
  });
  var customFilterOptions = function customFilterOptions(options, _ref2) {
    var inputValue = _ref2.inputValue;
    var lowerInput = inputValue.toLowerCase();
    return options.filter(function (opt) {
      var _opt$nid, _opt$phoneNumber, _opt$firstNameBn, _opt$firstNameEn;
      return ((_opt$nid = opt.nid) === null || _opt$nid === void 0 ? void 0 : _opt$nid.toLowerCase().includes(lowerInput)) || ((_opt$phoneNumber = opt.phoneNumber) === null || _opt$phoneNumber === void 0 ? void 0 : _opt$phoneNumber.toLowerCase().includes(lowerInput)) || ((_opt$firstNameBn = opt.firstNameBn) === null || _opt$firstNameBn === void 0 ? void 0 : _opt$firstNameBn.toLowerCase().includes(lowerInput)) || ((_opt$firstNameEn = opt.firstNameEn) === null || _opt$firstNameEn === void 0 ? void 0 : _opt$firstNameEn.toLowerCase().includes(lowerInput));
    });
  };
  console.log({
    selectedOption: selectedOption
  });
  return /*#__PURE__*/React.createElement(Autocomplete, {
    multiple: multiple,
    required: required,
    placeholder: placeholder !== null && placeholder !== void 0 ? placeholder : "",
    label: label !== null && label !== void 0 ? label : formatMessage("workforce.bank.picker"),
    error: error,
    withLabel: withLabel,
    withPlaceholder: withPlaceholder,
    readOnly: readOnly,
    options: data,
    isLoading: isLoading,
    value: selectedOption,
    getOptionLabel: function getOptionLabel(option) {
      return locale === "en" ? option.firstNameEn : option.firstNameBn;
    },
    onChange: function onChange(option) {
      console.log("WorkforceEmployeePicker selected:", option);
      _onChange(option, option ? option.id : null);
    },
    filterOptions: customFilterOptions,
    filterSelectedOptions: filterSelectedOptions,
    onInputChange: function onInputChange(text) {
      return setSearchString(text);
    },
    textFieldProps: {
      inputProps: {
        inputMode: "numeric",
        pattern: "[0-9০-৯]*" // allow English + Bangla numbers
      }
    }
    // onOpen={fetchEmployees}
  });
};

var useStyles$1y = makeStyles(function (theme) {
  return {
    title: {
      fontWeight: 800
    },
    paper: {
      padding: theme.spacing(2),
      width: "100%",
      maxWidth: 650,
      margin: "auto"
    },
    section: {
      marginTop: theme.spacing(3)
    }
  };
});
var ApplicationTypeSelector = function ApplicationTypeSelector(_ref) {
  var _parsedApplicationDat, _selectedFactory$fact2, _employeeData$company;
  var workforceFactoryId = _ref.workforceFactoryId,
    modulesManager = _ref.modulesManager,
    onSelect = _ref.onSelect,
    selectedApplicationType = _ref.selectedApplicationType,
    parsedApplicationData = _ref.parsedApplicationData,
    selectedFactory = _ref.selectedFactory,
    setSelectedFactory = _ref.setSelectedFactory;
  var _useState = useState("no"),
    _useState2 = _slicedToArray(_useState, 2),
    isExportOriented = _useState2[0],
    setIsExportOriented = _useState2[1];
  var classes = useStyles$1y();
  var dispatch = useDispatch();
  var employeeData = useSelector(function (state) {
    var _state$workforce;
    return (_state$workforce = state.workforce) === null || _state$workforce === void 0 ? void 0 : _state$workforce.workforceEmployee;
  });
  var selectedEmployee = useSelector(function (state) {
    var _state$workforce2;
    return (_state$workforce2 = state.workforce) === null || _state$workforce2 === void 0 ? void 0 : _state$workforce2.selectedEmployee;
  });
  var _useState3 = useState(""),
    _useState4 = _slicedToArray(_useState3, 2),
    localApplicationType = _useState4[0],
    setLocalApplicationType = _useState4[1];
  var history = useHistory();
  var user_type = getUserType();
  var handleEmployeeChange = function handleEmployeeChange(employee) {
    dispatch({
      type: "SET_SELECTED_EMPLOYEE",
      payload: employee
    });
  };

  // 1. Logic to AUTOMATICALLY set Yes/No based on factory selection
  useEffect(function () {
    var _selectedFactory$fact;
    var exportStatus = selectedFactory !== null && selectedFactory !== void 0 && selectedFactory.id || selectedFactory !== null && selectedFactory !== void 0 && (_selectedFactory$fact = selectedFactory.factory) !== null && _selectedFactory$fact !== void 0 && _selectedFactory$fact.id ? "yes" : "no";
    setIsExportOriented(exportStatus);
    if (selectedApplicationType) {
      onSelect(selectedApplicationType, exportStatus);
    }
  }, [selectedFactory, selectedApplicationType, onSelect]);

  // 2. Initial load logic (for edit mode)
  useEffect(function () {
    if (!parsedApplicationData) return;
    var applicationType = parsedApplicationData.applicationType || "";
    var exportStatus = parsedApplicationData.organizationType === "cf" ? "yes" : "no";
    setLocalApplicationType(applicationType);
    setIsExportOriented(exportStatus);
    onSelect(applicationType, exportStatus);

    // dispatch({
    //   type: "SET_SELECTED_EMPLOYEE",
    //   payload: parsedApplicationData.workforceEmployee,
    // });
    if (parsedApplicationData.workforceEmployee) {
      dispatch({
        type: "SET_SELECTED_EMPLOYEE",
        payload: parsedApplicationData.workforceEmployee
      });
    }
  }, [parsedApplicationData, onSelect, dispatch]);
  var handleApplicationTypeChange = function handleApplicationTypeChange(event) {
    var value = event.target.value;
    setLocalApplicationType(value);
    onSelect(value, isExportOriented);
  };
  return /*#__PURE__*/React.createElement(Paper, {
    className: classes.paper,
    elevation: 0
  }, user_type !== WORKFORCE_USER_TYPE.APPLICANT && /*#__PURE__*/React.createElement(Box$1, null, /*#__PURE__*/React.createElement(Typography, {
    style: {
      textAlign: "center",
      color: "red",
      fontWeight: "bold",
      marginBottom: 8
    }
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "workforce.application.header.employeeSelector.note",
    module: "workforce"
  })), /*#__PURE__*/React.createElement(Grid, {
    container: true,
    alignItems: "center",
    spacing: 2
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 8
  }, /*#__PURE__*/React.createElement(WorkforceEmployeePicker, {
    modulesManager: modulesManager,
    workforceFactoryId: workforceFactoryId === null || workforceFactoryId === void 0 ? void 0 : workforceFactoryId.id,
    value: (selectedEmployee === null || selectedEmployee === void 0 ? void 0 : selectedEmployee.id) || (parsedApplicationData === null || parsedApplicationData === void 0 || (_parsedApplicationDat = parsedApplicationData.workforceEmployee) === null || _parsedApplicationDat === void 0 ? void 0 : _parsedApplicationDat.id),
    onChange: handleEmployeeChange,
    required: true,
    readOnly: false,
    withLabel: true,
    withPlaceholder: true,
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      module: "workforce",
      id: "workforce.application.employee.selector"
    }),
    placeholder: "Type to search employee"
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 4
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "contained",
    color: "primary",
    onClick: function onClick() {
      return historyPush$1(modulesManager, history, "workforce.route.employees.employee");
    }
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.application.add.employee"
  }))))), !isBlwfPath() && /*#__PURE__*/React.createElement(Box$1, {
    mt: 3
  }, /*#__PURE__*/React.createElement(FactoryPicker, {
    id: "application-type-factory"
    // FIX: Pass the ID directly from the object (fallback to nested only if necessary)
    ,
    value: safeDecodeId(selectedFactory === null || selectedFactory === void 0 ? void 0 : selectedFactory.id) || safeDecodeId(selectedFactory === null || selectedFactory === void 0 || (_selectedFactory$fact2 = selectedFactory.factory) === null || _selectedFactory$fact2 === void 0 ? void 0 : _selectedFactory$fact2.id) || safeDecodeId(workforceFactoryId === null || workforceFactoryId === void 0 ? void 0 : workforceFactoryId.id),
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.employee.workforce_factory",
      module: "workforce"
    }),
    required: true,
    companyId: employeeData === null || employeeData === void 0 || (_employeeData$company = employeeData.company) === null || _employeeData$company === void 0 ? void 0 : _employeeData$company.id,
    onChange: function onChange(v) {
      // v is the whole factory object
      setSelectedFactory(v);
    },
    readOnly: false
  })), /*#__PURE__*/React.createElement(FormControl, {
    component: "fieldset",
    className: classes.section
  }, !isBlwfPath() || isExportOriented === "yes" ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6",
    className: classes.title
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "workforce.application.type.title",
    module: "workforce"
  })), /*#__PURE__*/React.createElement(RadioGroup, {
    value: localApplicationType,
    onChange: handleApplicationTypeChange
  }, /*#__PURE__*/React.createElement(FormControlLabel, {
    value: "medicalAssistance",
    control: /*#__PURE__*/React.createElement(Radio, {
      color: "primary"
    }),
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.application.type.medical.donation",
      module: "workforce"
    })
  }), /*#__PURE__*/React.createElement(FormControlLabel, {
    value: "maternityGrant",
    control: /*#__PURE__*/React.createElement(Radio, {
      color: "primary"
    }),
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.application.type.maternal.grant",
      module: "workforce"
    })
  }), /*#__PURE__*/React.createElement(FormControlLabel, {
    value: "scholarship",
    control: /*#__PURE__*/React.createElement(Radio, {
      color: "primary"
    }),
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.application.type.education.grant",
      module: "workforce"
    })
  }), /*#__PURE__*/React.createElement(FormControlLabel, {
    value: "disabilityAssistance",
    control: /*#__PURE__*/React.createElement(Radio, {
      color: "primary"
    }),
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.application.type.medical.disability",
      module: "workforce"
    })
  }), /*#__PURE__*/React.createElement(FormControlLabel, {
    value: "financialAssistance",
    control: /*#__PURE__*/React.createElement(Radio, {
      color: "primary"
    }),
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.application.type.deadly.grant",
      module: "workforce"
    })
  }))) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6",
    className: classes.title
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "workforce.application.type.title",
    module: "workforce"
  })), /*#__PURE__*/React.createElement(RadioGroup, {
    value: localApplicationType,
    onChange: handleApplicationTypeChange
  }, /*#__PURE__*/React.createElement(FormControlLabel, {
    value: "medicalDonation",
    control: /*#__PURE__*/React.createElement(Radio, {
      color: "primary"
    }),
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.application.type.medical.donation",
      module: "workforce"
    })
  }), /*#__PURE__*/React.createElement(FormControlLabel, {
    value: "maternityGrant",
    control: /*#__PURE__*/React.createElement(Radio, {
      color: "primary"
    }),
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.application.type.maternal.grant",
      module: "workforce"
    })
  }), /*#__PURE__*/React.createElement(FormControlLabel, {
    value: "educationGrant",
    control: /*#__PURE__*/React.createElement(Radio, {
      color: "primary"
    }),
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.application.type.education.grant",
      module: "workforce"
    })
  }), /*#__PURE__*/React.createElement(FormControlLabel, {
    value: "deadlyGrant",
    control: /*#__PURE__*/React.createElement(Radio, {
      color: "primary"
    }),
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.application.type.deadly.grant",
      module: "workforce"
    })
  })))));
};

countries.registerLocale(enLocale);
countries.registerLocale(bnLocale);
var CountryPicker = function CountryPicker(_ref) {
  var id = _ref.id,
    _ref$label = _ref.label,
    label = _ref$label === void 0 ? "Country" : _ref$label,
    value = _ref.value,
    _onChange = _ref.onChange,
    _ref$required = _ref.required,
    required = _ref$required === void 0 ? false : _ref$required,
    _ref$fullWidth = _ref.fullWidth,
    fullWidth = _ref$fullWidth === void 0 ? true : _ref$fullWidth,
    _ref$readOnly = _ref.readOnly,
    readOnly = _ref$readOnly === void 0 ? false : _ref$readOnly,
    _ref$language = _ref.language,
    language = _ref$language === void 0 ? "en" : _ref$language;
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    countryList = _useState2[0],
    setCountryList = _useState2[1];
  useEffect(function () {
    try {
      var countryNames = countries.getNames(language, {
        select: "official"
      });
      var formattedList = Object.entries(countryNames).map(function (_ref2) {
        var _ref3 = _slicedToArray(_ref2, 2),
          code = _ref3[0],
          name = _ref3[1];
        return {
          value: code,
          label: name
        };
      });
      setCountryList(formattedList);
    } catch (error) {
      console.error("Unsupported language code: ".concat(language), error);
    }
  }, [language]);
  return /*#__PURE__*/React.createElement(FormControl, {
    fullWidth: fullWidth,
    required: required
  }, /*#__PURE__*/React.createElement(InputLabel, {
    id: "country-picker-label"
  }, label), /*#__PURE__*/React.createElement(Select, {
    labelId: "country-picker-label",
    value: value,
    onChange: function onChange(e) {
      return _onChange(e.target.value);
    },
    disabled: readOnly,
    inputProps: {
      id: id
    }
  }, countryList.map(function (country) {
    return /*#__PURE__*/React.createElement(MenuItem, {
      key: country.value,
      value: country.value
    }, country.label);
  })));
};

function ownKeys$1a(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$1a(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$1a(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1a(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var useStyles$1x = makeStyles(function (theme) {
  return {
    container: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center"
      // height: "100vh",
    },
    paper: {
      padding: theme.spacing(2)
    },
    buttonContainer: {
      marginTop: theme.spacing(2),
      display: "flex",
      justifyContent: "space-between"
    },
    flex: {
      display: "flex",
      flexWrap: "wrap"
    }
  };
});
var EmployeeDetailsForm2 = function EmployeeDetailsForm2(_ref) {
  var _formData$institution8, _formData$metadata4, _formData$employeeAcc;
  var handleChange = _ref.handleChange,
    errors = _ref.errors,
    formData = _ref.formData,
    setFormData = _ref.setFormData,
    selectedApplicationType = _ref.selectedApplicationType,
    applicationId = _ref.applicationId,
    formStepNo = _ref.formStepNo,
    isDisabled = _ref.isDisabled,
    dependentIndex = _ref.dependentIndex,
    accountIndex = _ref.accountIndex;
  var classes = useStyles$1x();
  useHistory();
  var modulesManager = useModulesManager();
  var _useTranslations = useTranslations("core.RegistrationPage", modulesManager);
    _useTranslations.formatMessage;
  var dispatch = useDispatch();
  var locale = useSelector(function (state) {
    var _state$core;
    return (_state$core = state.core) === null || _state$core === void 0 || (_state$core = _state$core.user) === null || _state$core === void 0 || (_state$core = _state$core.i_user) === null || _state$core === void 0 ? void 0 : _state$core.language;
  });
  useEffect(function () {
    if (formData.applicationType && formData.organizationType) {
      if ((formData === null || formData === void 0 ? void 0 : formData.applicationForSelf) === "yes" && (formData === null || formData === void 0 ? void 0 : formData.organizationType) === "cf") {
        return dispatch(fetchDocumentType(modulesManager, ["orderBy: [\"documentTypeNo\"]", "applicationFor: \"self\"", "applicationType:\"".concat(selectedApplicationType, "\""), "organizationType:\"".concat(formData === null || formData === void 0 ? void 0 : formData.organizationType, "\""), "formStepNo:\"".concat(formStepNo, "\"")]));
      } else if ((formData === null || formData === void 0 ? void 0 : formData.applicationType) === "disabilityAssistance") {
        if ((formData === null || formData === void 0 ? void 0 : formData.metadata.disabilityType) === "permanent") {
          return dispatch(fetchDocumentType(modulesManager, ["orderBy: [\"documentTypeNo\"]", "applicationFor: \"permanent_disability\"", "applicationType:\"".concat(selectedApplicationType, "\""), "organizationType:\"".concat(formData === null || formData === void 0 ? void 0 : formData.organizationType, "\""), "formStepNo:\"".concat(formStepNo, "\"")]));
        } else {
          return dispatch(fetchDocumentType(modulesManager, ["orderBy: [\"documentTypeNo\"]", "applicationFor: \"temporary_disability\"", "applicationType:\"".concat(selectedApplicationType, "\""), "organizationType:\"".concat(formData === null || formData === void 0 ? void 0 : formData.organizationType, "\""), "formStepNo:\"".concat(formStepNo, "\"")]));
        }
      } else if ((formData === null || formData === void 0 ? void 0 : formData.applicationType) === "financialAssistance") {
        var _formData$metadata;
        if ((formData === null || formData === void 0 || (_formData$metadata = formData.metadata) === null || _formData$metadata === void 0 ? void 0 : _formData$metadata.deathType) === "normalDeath") {
          return dispatch(fetchDocumentType(modulesManager, ["orderBy: [\"documentTypeNo\"]", "applicationFor: \"normal_death\"", "applicationType:\"".concat(selectedApplicationType, "\""), "organizationType:\"".concat(formData === null || formData === void 0 ? void 0 : formData.organizationType, "\""), "formStepNo:\"".concat(formStepNo, "\"")]));
        } else {
          return dispatch(fetchDocumentType(modulesManager, ["orderBy: [\"documentTypeNo\"]", "applicationFor: \"accidental_death\"", "applicationType:\"".concat(selectedApplicationType, "\""), "organizationType:\"".concat(formData === null || formData === void 0 ? void 0 : formData.organizationType, "\""), "formStepNo:\"".concat(formStepNo, "\"")]));
        }
      } else if ((formData === null || formData === void 0 ? void 0 : formData.applicationType) === "deadlyGrant") {
        var _formData$metadata2, _formData$institution, _formData$metadata3, _formData$institution2;
        if ((formData === null || formData === void 0 || (_formData$metadata2 = formData.metadata) === null || _formData$metadata2 === void 0 ? void 0 : _formData$metadata2.deathType) === "normalDeath" && (formData === null || formData === void 0 || (_formData$institution = formData.institutionInfo) === null || _formData$institution === void 0 ? void 0 : _formData$institution.workerType) === "formal") {
          return dispatch(fetchDocumentType(modulesManager, ["orderBy: [\"documentTypeNo\"]", "applicationForIn: [\"normal_death\",\"normal_death_institutional\",\"normal_death_institutional_on_work\"]", "applicationType:\"".concat(selectedApplicationType, "\""), "organizationType:\"".concat(formData === null || formData === void 0 ? void 0 : formData.organizationType, "\""), "formStepNo:\"".concat(formStepNo, "\"")]));
        } else if ((formData === null || formData === void 0 || (_formData$metadata3 = formData.metadata) === null || _formData$metadata3 === void 0 ? void 0 : _formData$metadata3.deathType) === "normalDeath" && (formData === null || formData === void 0 || (_formData$institution2 = formData.institutionInfo) === null || _formData$institution2 === void 0 ? void 0 : _formData$institution2.workerType) === "informal") {
          return dispatch(fetchDocumentType(modulesManager, ["orderBy: [\"documentTypeNo\"]", "applicationForIn: [\"normal_death\",\"normal_death_non_institutional\"]", "applicationType:\"".concat(selectedApplicationType, "\""), "organizationType:\"".concat(formData.organizationType, "\""), "formStepNo:\"".concat(formStepNo, "\"")]));
        } else {
          return dispatch(fetchDocumentType(modulesManager, ["orderBy: [\"documentTypeNo\"]", "applicationFor: \"accidental_death\"", "applicationType:\"".concat(selectedApplicationType, "\""), "organizationType:\"".concat(formData === null || formData === void 0 ? void 0 : formData.organizationType, "\""), "formStepNo:\"".concat(formStepNo, "\"")]));
        }
        // return dispatch(
        //   fetchDocumentType(modulesManager, [
        //     `orderBy: ["documentTypeNo"]`,
        //     `applicationForIn: ["normal_death","normal_death_institutional","normal_death_institutional_on_work"]`,
        //     `applicationType:"${selectedApplicationType}"`,
        //     `organizationType:"${formData.organizationType}"`,
        //     `formStepNo:"${formStepNo}"`,
        //   ])
        // );
      } else if ((formData === null || formData === void 0 ? void 0 : formData.applicationType) === "medicalDonation" && (formData === null || formData === void 0 ? void 0 : formData.applicationForSelf) === "yes" && (formData === null || formData === void 0 ? void 0 : formData.organizationType) === "blwf") {
        var _formData$institution3;
        if ((formData === null || formData === void 0 || (_formData$institution3 = formData.institutionInfo) === null || _formData$institution3 === void 0 ? void 0 : _formData$institution3.workerType) === "formal") {
          return dispatch(fetchDocumentType(modulesManager, ["orderBy: [\"documentTypeNo\"]", 'applicationForIn: ["self","self_institutional"]', "applicationType:\"".concat(selectedApplicationType, "\""), "organizationType:\"".concat(formData.organizationType, "\""), "formStepNo:\"".concat(formStepNo, "\"")]));
        } else {
          return dispatch(fetchDocumentType(modulesManager, ["orderBy: [\"documentTypeNo\"]", "applicationForIn: [\"self\",\"self_non_institutional\"]", "applicationType:\"".concat(selectedApplicationType, "\""), "organizationType:\"".concat(formData.organizationType, "\""), "formStepNo:\"".concat(formStepNo, "\"")]));
        }
      } else if (formData.applicationType === "medicalDonation" && formData.applicationForSelf === "no" && formData.organizationType === "blwf") {
        var _formData$institution4;
        if ((formData === null || formData === void 0 || (_formData$institution4 = formData.institutionInfo) === null || _formData$institution4 === void 0 ? void 0 : _formData$institution4.workerType) === "formal") {
          return dispatch(fetchDocumentType(modulesManager, ["orderBy: [\"documentTypeNo\"]", "applicationForIn: [\"dependent\",\"dependent_institutional\"]", "applicationType:\"".concat(selectedApplicationType, "\""), "organizationType:\"".concat(formData.organizationType, "\""), "formStepNo:\"".concat(formStepNo, "\"")]));
        } else {
          return dispatch(fetchDocumentType(modulesManager, ["orderBy: [\"documentTypeNo\"]", "applicationForIn: [\"dependent\",\"dependent_non_institutional\"]", "applicationType:\"".concat(selectedApplicationType, "\""), "organizationType:\"".concat(formData.organizationType, "\""), "formStepNo:\"".concat(formStepNo, "\"")]));
        }
      } else if (formData.applicationType === "maternityGrant" && formData.organizationType === "blwf" && formData.applicationForSelf === "yes") {
        var _formData$institution5;
        if ((formData === null || formData === void 0 || (_formData$institution5 = formData.institutionInfo) === null || _formData$institution5 === void 0 ? void 0 : _formData$institution5.workerType) === "formal") {
          return dispatch(fetchDocumentType(modulesManager, ["orderBy: [\"documentTypeNo\"]", "applicationForIn: [\"self\",\"self_institutional\"]", "applicationType:\"".concat(selectedApplicationType, "\""), "organizationType:\"".concat(formData.organizationType, "\""), "formStepNo:\"".concat(formStepNo, "\"")]));
        } else {
          return dispatch(fetchDocumentType(modulesManager, ["orderBy: [\"documentTypeNo\"]", "applicationForIn: [\"self\",\"self_non_institutional\"]", "applicationType:\"".concat(selectedApplicationType, "\""), "organizationType:\"".concat(formData.organizationType, "\""), "formStepNo:\"".concat(formStepNo, "\"")]));
        }
      } else if (formData.applicationType === "maternityGrant" && formData.organizationType === "blwf" && formData.applicationForSelf === "no") {
        var _formData$institution6;
        if ((formData === null || formData === void 0 || (_formData$institution6 = formData.institutionInfo) === null || _formData$institution6 === void 0 ? void 0 : _formData$institution6.workerType) === "formal") {
          return dispatch(fetchDocumentType(modulesManager, ["orderBy: [\"documentTypeNo\"]", "applicationForIn: [\"dependent\",\"dependent_institutional\"]", "applicationType:\"".concat(selectedApplicationType, "\""), "organizationType:\"".concat(formData.organizationType, "\""), "formStepNo:\"".concat(formStepNo, "\"")]));
        } else {
          return dispatch(fetchDocumentType(modulesManager, ["orderBy: [\"documentTypeNo\"]", "applicationForIn: [\"dependent\",\"dependent_non_institutional\"]", "applicationType:\"".concat(selectedApplicationType, "\""), "organizationType:\"".concat(formData.organizationType, "\""), "formStepNo:\"".concat(formStepNo, "\"")]));
        }
      } else if (formData.applicationType === "educationGrant" && formData.organizationType === "blwf") {
        var _formData$institution7;
        if ((formData === null || formData === void 0 || (_formData$institution7 = formData.institutionInfo) === null || _formData$institution7 === void 0 ? void 0 : _formData$institution7.workerType) === "formal") {
          return dispatch(fetchDocumentType(modulesManager, ["orderBy: [\"documentTypeNo\"]", "applicationForIn: [\"dependent\",\"dependent_institutional\"]", "applicationType:\"".concat(selectedApplicationType, "\""), "organizationType:\"".concat(formData.organizationType, "\""), "formStepNo:\"".concat(formStepNo, "\"")]));
        } else {
          return dispatch(fetchDocumentType(modulesManager, ["orderBy: [\"documentTypeNo\"]", "applicationForIn: [\"dependent\",\"dependent_non_institutional\"]", "applicationType:\"".concat(selectedApplicationType, "\""), "organizationType:\"".concat(formData.organizationType, "\""), "formStepNo:\"".concat(formStepNo, "\"")]));
        }
      } else {
        return dispatch(fetchDocumentType(modulesManager, ["orderBy: [\"documentTypeNo\"]", "applicationFor: \"dependent\"", "applicationType:\"".concat(selectedApplicationType, "\""), "organizationType:\"".concat(formData.organizationType, "\""), "formStepNo:\"".concat(formStepNo, "\"")]));
      }
    }
  }, [selectedApplicationType, formData === null || formData === void 0 ? void 0 : formData.organizationType, formStepNo, formData === null || formData === void 0 || (_formData$institution8 = formData.institutionInfo) === null || _formData$institution8 === void 0 ? void 0 : _formData$institution8.workerType, formData === null || formData === void 0 || (_formData$metadata4 = formData.metadata) === null || _formData$metadata4 === void 0 ? void 0 : _formData$metadata4.disabilityType, isDisabled, formData === null || formData === void 0 || (_formData$employeeAcc = formData.employeeAccidentInfo) === null || _formData$employeeAcc === void 0 ? void 0 : _formData$employeeAcc.admitted]);
  useSelector(function (state) {
    return state.workforce["fetchingDocumentType"];
  });
  var data = useSelector(function (state) {
    var _state$workforce;
    return (_state$workforce = state.workforce["documentType"]) !== null && _state$workforce !== void 0 ? _state$workforce : [];
  });
  useSelector(function (state) {
    return state.workforce["errorDocumentType"];
  });
  var uploadedFilesByField = useSelector(function (state) {
    return state.workforce.uploadedFilesByField || {};
  });
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2);
    _useState2[0];
    var setUploadedFiles = _useState2[1];
  var handleFileChange = function handleFileChange(fieldKey, files) {
    setUploadedFiles(function (prevFiles) {
      var existingIndex = prevFiles.findIndex(function (item) {
        return item.fieldKey === fieldKey;
      });
      if (existingIndex !== -1) {
        var updatedFiles = _toConsumableArray(prevFiles);
        updatedFiles[existingIndex] = {
          fieldKey: fieldKey,
          files: files
        };
        return updatedFiles;
      } else {
        return [].concat(_toConsumableArray(prevFiles), [{
          fieldKey: fieldKey,
          files: files
        }]);
      }
    });

    // Optionally also update `formData` if needed
    if (setFormData) {
      setFormData(function (prev) {
        return _objectSpread$1a(_objectSpread$1a({}, prev), {}, {
          uploadedDocs: _objectSpread$1a(_objectSpread$1a({}, prev.uploadedDocs || {}), {}, _defineProperty({}, fieldKey, files))
        });
      });
    }
  };
  console.log({
    fahim: dependentIndex
  });
  console.log({
    fahimA: handleChange
  });
  return /*#__PURE__*/React.createElement(Box$1, {
    mt: 1
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 2
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(Paper, {
    className: classes.paper,
    elevation: 0
  }, /*#__PURE__*/React.createElement(Box$1, {
    mb: 4,
    textAlign: "center",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "workforce.application.header.document",
    module: "workforce"
  })), /*#__PURE__*/React.createElement(Grid, {
    container: true,
    className: classes.item,
    spacing: 2
  }, data.map(function (document, index) {
    var _formData$employeeAcc2, _formData$employeeAcc3, _uploadedFilesByField, _errors$documents;
    console.log({
      isDisabled: isDisabled
    });
    if ((document === null || document === void 0 ? void 0 : document.documentType) === "disability_certificate" && (isDisabled === "no" || isDisabled === undefined)) {
      return null;
    }
    if (!isEisPath() && (document === null || document === void 0 ? void 0 : document.documentType) === "discharge certificate" && ((formData === null || formData === void 0 || (_formData$employeeAcc2 = formData.employeeAccidentInfo) === null || _formData$employeeAcc2 === void 0 ? void 0 : _formData$employeeAcc2.admitted) === "no" || (formData === null || formData === void 0 || (_formData$employeeAcc3 = formData.employeeAccidentInfo) === null || _formData$employeeAcc3 === void 0 ? void 0 : _formData$employeeAcc3.admitted) === undefined)) {
      return null;
    }
    var fieldKey = document.fieldId;
    var uniqueFieldKey = fieldKey;
    if (dependentIndex !== undefined) {
      uniqueFieldKey = "dependent_".concat(dependentIndex, "_").concat(fieldKey);
    } else if (accountIndex !== undefined) {
      uniqueFieldKey = "account_".concat(accountIndex, "_").concat(fieldKey);
    }
    var hasFiles = (((_uploadedFilesByField = uploadedFilesByField[uniqueFieldKey]) === null || _uploadedFilesByField === void 0 ? void 0 : _uploadedFilesByField.length) || 0) > 0;
    // const hasFiles = (uploadedFilesByField[fieldKey]?.length || 0) > 0;
    var hasError = errors === null || errors === void 0 || (_errors$documents = errors.documents) === null || _errors$documents === void 0 ? void 0 : _errors$documents.some(function (err) {
      if (err.documentType !== document.documentType) return false;
      if (dependentIndex !== undefined) return err.dependentIndex === dependentIndex;
      if (accountIndex !== undefined) return err.accountIndex === accountIndex;
      return err.dependentIndex === undefined && err.accountIndex === undefined;
    });
    return /*#__PURE__*/React.createElement(Grid, {
      container: true,
      spacing: 2,
      alignItems: "center",
      style: {
        marginBottom: "12px",
        border: "1px solid #006273"
      },
      key: document.fieldId
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 5
    }, /*#__PURE__*/React.createElement(Typography, {
      style: {
        color: hasError ? "red" : "inherit"
      }
    }, conditionalEnToBn(index + 1, locale), ". ", locale === "en" ? document === null || document === void 0 ? void 0 : document.nameEn : document === null || document === void 0 ? void 0 : document.nameBn, " ", (document === null || document === void 0 ? void 0 : document.mandatoryForApplicant) && /*#__PURE__*/React.createElement("sup", {
      style: {
        color: "red"
      }
    }, "*"))), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 6
    }, (formData === null || formData === void 0 ? void 0 : formData.applicationType) === "deadlyGrant" || (formData === null || formData === void 0 ? void 0 : formData.applicationType) === "financialAssistance" ? /*#__PURE__*/React.createElement(FileUploader, {
      fieldKey: uniqueFieldKey,
      onFileChange: handleChange,
      applicationId: applicationId,
      documentType: document.documentType,
      documentProp: document,
      uploadedBy: formStepNo === "employeeDependentInfo" ? "dependent" : formStepNo === "employeeBankInfo" ? "bank" : "applicant"
    }) : /*#__PURE__*/React.createElement(FileUploader, {
      fieldKey: uniqueFieldKey,
      onFileChange: handleChange ? handleChange : handleFileChange,
      applicationId: applicationId,
      documentType: document.documentType,
      documentProp: document
      // uploadedBy={formStepNo === "employeeDependentInfo" ? "dependent" : formStepNo === "employeeBankInfo" ? "bank" : "applicant"}
      ,
      uploadedBy: formStepNo === "employeeDependentInfo" ? "dependent" : formStepNo === "employeeBankInfo" ? "bank" : "applicant"
    })), hasFiles && /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 1
    }, /*#__PURE__*/React.createElement(CheckCircleIcon, {
      style: {
        color: "green"
      }
    })));
  })), /*#__PURE__*/React.createElement(Divider, null)))));
};

function ownKeys$19(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$19(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$19(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$19(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// import CustomDateTimePicker from "../../pickers/CustomDatePicker";

var useStyles$1w = makeStyles(function (theme) {
  return {
    container: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center"
    },
    paper: {
      padding: theme.spacing(2)
    },
    buttonContainer: {
      marginTop: theme.spacing(2),
      display: "flex",
      justifyContent: "space-between"
    },
    item: theme.paper.item,
    overrideReadOnly: {
      "& .MuiInputBase-root.Mui-disabled": {
        color: "#808080 !important" // Text value color (gray)
      },
      "& .MuiFormLabel-root.Mui-disabled": {
        color: "".concat(theme.palette.text.primary, " !important") // Label color (black or customize as needed)
      }
    }
  };
});
var EmployeeDetailsForm = function EmployeeDetailsForm(_ref) {
  var _reduxState$core, _formData$workforceEm, _formData$workforceEm2, _formData$workforceEm3, _formData$workforceEm4, _formData$workforceEm5, _formData$workforceEm6, _formData$workforceEm7, _formData$workforceEm8, _formData$workforceEm9, _formData$workforceEm10, _formData$workforceEm11, _formData$deceasedWor, _formData$workforceEm12, _formData$workforceFa, _formData$factory, _formData$workforceEm13, _formData$workforceEm14, _formData$workforceEm15, _formData$workforceEm16, _formData$workforceEm17, _formData$workforceEm18, _formData$workforceEm19, _formData$workforceEm20, _formData$workforceEm21, _formData$workforceEm22, _formData$metadata, _formData$metadata2, _formData$metadata3, _formData$metadata4, _formData$metadata5;
  var handleChange = _ref.handleChange,
    formData = _ref.formData,
    setFormData = _ref.setFormData,
    nidOrBcn = _ref.nidOrBcn,
    setNidOrBcn = _ref.setNidOrBcn,
    errors = _ref.errors;
  var classes = useStyles$1w();
  useHistory();
  var modulesManager = useModulesManager();
  var _useTranslations = useTranslations("core.RegistrationPage", modulesManager),
    formatMessage = _useTranslations.formatMessage;
  var reduxState = useSelector(function (state) {
    return state;
  });
  var getDeathLabel = function getDeathLabel(labelKey) {
    return formData.applicationType === "financialAssistance" ? "".concat(formatMessage("workforce.dead"), " ").concat(formatMessage(labelKey)) : formatMessage(labelKey);
  };
  var locale = reduxState === null || reduxState === void 0 || (_reduxState$core = reduxState.core) === null || _reduxState$core === void 0 || (_reduxState$core = _reduxState$core.user) === null || _reduxState$core === void 0 || (_reduxState$core = _reduxState$core.i_user) === null || _reduxState$core === void 0 ? void 0 : _reduxState$core.language;
  console.log("formData from employee Details form", formData);
  return /*#__PURE__*/React.createElement(Box$1, null, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 2
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(Paper, {
    className: classes.paper,
    elevation: 0
  }, /*#__PURE__*/React.createElement(Typography, {
    style: {
      color: "red",
      textAlign: "center",
      fontWeight: "bold",
      fontSize: "small",
      marginBottom: "20px"
    }
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "workforce.application.header.labour.note",
    module: "workforce"
  })), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement("b", null, getDeathLabel("workforce.application.labourHeadingOne"))), /*#__PURE__*/React.createElement(Grid, {
    container: true,
    className: clsx(classes.item, classes.overrideReadOnly),
    spacing: 2
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6,
    className: clsx(classes.item, classes.overrideReadOnly)
  }, /*#__PURE__*/React.createElement(TextInput, {
    id: "nameBn",
    label: "workforce.employee.name.bn",
    value: (formData === null || formData === void 0 || (_formData$workforceEm = formData.workforceEmployee) === null || _formData$workforceEm === void 0 ? void 0 : _formData$workforceEm.nameBn) || "",
    formatInput: filterBangla,
    onChange: function onChange(v) {
      return handleChange("nameBn", filterBangla(v));
    },
    required: true,
    readOnly: false,
    error: !!errors.nameBn,
    helperText: errors.nameBn
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6,
    className: clsx(classes.item, classes.overrideReadOnly)
  }, /*#__PURE__*/React.createElement(TextInput, {
    id: "nameEn",
    label: "workforce.employee.name.en",
    value: (formData === null || formData === void 0 || (_formData$workforceEm2 = formData.workforceEmployee) === null || _formData$workforceEm2 === void 0 ? void 0 : _formData$workforceEm2.nameEn) || "",
    formatInput: filterEnglish,
    onChange: function onChange(v) {
      return handleChange("nameEn", filterEnglish(v));
    },
    required: true,
    readOnly: false,
    error: !!errors.nameEn,
    helperText: errors.nameEn
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6,
    className: clsx(classes.item, classes.overrideReadOnly)
  }, /*#__PURE__*/React.createElement(PublishedComponent, {
    pubRef: "workforce.DatePicker",
    label: "workforce.employee.birthdate",
    value: (formData === null || formData === void 0 || (_formData$workforceEm3 = formData.workforceEmployee) === null || _formData$workforceEm3 === void 0 ? void 0 : _formData$workforceEm3.birthDate) || "",
    onChange: function onChange(v) {
      return handleChange("birthDate", v);
    },
    readOnly: false,
    required: true
  }), errors.rdmp && /*#__PURE__*/React.createElement(FormHelperText, {
    error: true
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: errors === null || errors === void 0 ? void 0 : errors.rdmp
  }))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6,
    className: clsx(classes.item, classes.overrideReadOnly)
  }, /*#__PURE__*/React.createElement(EmployeeGenderPicker, {
    value: _typeof(formData === null || formData === void 0 || (_formData$workforceEm4 = formData.workforceEmployee) === null || _formData$workforceEm4 === void 0 ? void 0 : _formData$workforceEm4.gender) === "object" ? formData === null || formData === void 0 || (_formData$workforceEm5 = formData.workforceEmployee) === null || _formData$workforceEm5 === void 0 || (_formData$workforceEm5 = _formData$workforceEm5.gender) === null || _formData$workforceEm5 === void 0 ? void 0 : _formData$workforceEm5.name : formData === null || formData === void 0 || (_formData$workforceEm6 = formData.workforceEmployee) === null || _formData$workforceEm6 === void 0 ? void 0 : _formData$workforceEm6.gender,
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.employee.gender",
      module: "workforce"
    }),
    onChange: function onChange(v) {
      return handleChange("gender", v);
    },
    readOnly: false
  })), formData.applicationType !== "financialAssistance" && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6,
    className: clsx(classes.item, classes.overrideReadOnly)
  }, /*#__PURE__*/React.createElement(TextInput, {
    id: "phoneNumber",
    label: "workforce.employee.phone",
    value: (formData === null || formData === void 0 || (_formData$workforceEm7 = formData.workforceEmployee) === null || _formData$workforceEm7 === void 0 ? void 0 : _formData$workforceEm7.phoneNumber) || "",
    formatInput: filterDigits,
    onChange: function onChange(v) {
      return handleChange("phoneNumber", filterDigits(v));
    },
    type: "text",
    required: true,
    readOnly: false,
    inputProps: {
      inputMode: "numeric",
      maxLength: 11
    },
    error: !!errors.phoneNumber,
    helperText: errors.phoneNumber
  }), errors.phoneNumber && /*#__PURE__*/React.createElement(FormHelperText, {
    error: true
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: errors.phoneNumber
  }))), !isBlwfPath() && /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6,
    className: clsx(classes.item, classes.overrideReadOnly)
  }, /*#__PURE__*/React.createElement(TextInput, {
    label: "workforce.employee.email",
    value: (formData === null || formData === void 0 || (_formData$workforceEm8 = formData.workforceEmployee) === null || _formData$workforceEm8 === void 0 ? void 0 : _formData$workforceEm8.email) || "",
    onChange: function onChange(v) {
      return handleChange("email", v);
    },
    type: "email",
    readOnly: false
  }))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6,
    className: clsx(classes.item, classes.overrideReadOnly)
  }, /*#__PURE__*/React.createElement(CountryPicker, {
    id: "citizenship",
    label: formatMessage("workforce.employee.citizenship"),
    value: (formData === null || formData === void 0 || (_formData$workforceEm9 = formData.workforceEmployee) === null || _formData$workforceEm9 === void 0 ? void 0 : _formData$workforceEm9.citizenship) || "",
    onChange: function onChange(v) {
      return handleChange("citizenship", v);
    },
    readOnly: false
    // required
    ,
    language: locale === "fr" ? "bn" : "en"
  }), errors.citizenship && /*#__PURE__*/React.createElement(FormHelperText, {
    error: true
  }, errors.citizenship)), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6,
    className: clsx(classes.item, classes.overrideReadOnly)
  }, /*#__PURE__*/React.createElement(EmployeeMaritalStatusPicker, {
    id: "maritalStatus",
    value: (formData === null || formData === void 0 || (_formData$workforceEm10 = formData.workforceEmployee) === null || _formData$workforceEm10 === void 0 ? void 0 : _formData$workforceEm10.maritalStatus) || "",
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.employee.marital_status",
      module: "workforce"
    }),
    required: true,
    onChange: function onChange(v) {
      return handleChange("maritalStatus", v);
    },
    readOnly: false
  }), errors.maritalStatus && /*#__PURE__*/React.createElement(FormHelperText, {
    error: true
  }, errors.maritalStatus)), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6,
    className: classes.item
  }, /*#__PURE__*/React.createElement(TextInput, {
    id: "nid",
    label: "workforce.employee.nid_or_birth_certificate",
    value: (formData === null || formData === void 0 || (_formData$workforceEm11 = formData.workforceEmployee) === null || _formData$workforceEm11 === void 0 ? void 0 : _formData$workforceEm11.nid) || (formData === null || formData === void 0 || (_formData$deceasedWor = formData.deceasedWorkerInfo) === null || _formData$deceasedWor === void 0 ? void 0 : _formData$deceasedWor.nid) || "",
    formatInput: function formatInput(val) {
      return (val || "").toString().replace(/\D/g, "").slice(0, 17);
    }
    // inputProps={{ inputMode: "numeric", pattern: "[0-9০-৯]*",maxLength: 17 }}
    ,
    onChange: function onChange(v) {
      var numericValue = (v || "").replace(/\D/g, "").slice(0, 17);
      setNidOrBcn(_objectSpread$19(_objectSpread$19({}, nidOrBcn), {}, {
        nid: numericValue
      }));
      handleChange("nid", numericValue);
    },
    type: "text",
    inputProps: {
      inputMode: "numeric",
      pattern: "[0-9০-৯]*",
      maxLength: 17
    },
    required: true,
    readOnly: false,
    error: !!errors.nid,
    helperText: errors.nid
  }), errors.nid && /*#__PURE__*/React.createElement(FormHelperText, {
    error: true
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: errors.nid
  }))), !isBlwfPath() && /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6,
    className: classes.item
  }, /*#__PURE__*/React.createElement(TextInput, {
    label: "workforce.employee.designation",
    value: (formData === null || formData === void 0 || (_formData$workforceEm12 = formData.workforceEmployee) === null || _formData$workforceEm12 === void 0 ? void 0 : _formData$workforceEm12.position) || "",
    onChange: function onChange(v) {
      return handleChange("position", v);
    },
    readOnly: false
  })), ((formData === null || formData === void 0 ? void 0 : formData.organizationType) === "cf" || (formData === null || formData === void 0 ? void 0 : formData.organizationType) === "eis") && /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6,
    className: classes.item
  }, /*#__PURE__*/React.createElement(FactoryPicker, {
    id: "factory",
    required: true,
    value: (formData === null || formData === void 0 || (_formData$workforceFa = formData.workforceFactoryId) === null || _formData$workforceFa === void 0 ? void 0 : _formData$workforceFa.id) || (formData === null || formData === void 0 || (_formData$factory = formData.factory) === null || _formData$factory === void 0 ? void 0 : _formData$factory.id) || (formData === null || formData === void 0 || (_formData$workforceEm13 = formData.workforceEmployee) === null || _formData$workforceEm13 === void 0 || (_formData$workforceEm13 = _formData$workforceEm13.factory) === null || _formData$workforceEm13 === void 0 ? void 0 : _formData$workforceEm13.id),
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.employee.workforce_factory",
      module: "workforce"
    }),
    companyId: formData === null || formData === void 0 || (_formData$workforceEm14 = formData.workforceEmployee) === null || _formData$workforceEm14 === void 0 || (_formData$workforceEm14 = _formData$workforceEm14.company) === null || _formData$workforceEm14 === void 0 ? void 0 : _formData$workforceEm14.id,
    onChange: function onChange(v) {
      // handleChange("factory", v, "employeeDesignation");
      handleChange("factory", v);
    },
    readOnly: formData !== null && formData !== void 0 && formData.workforceFactoryId ? true : false
  }), errors.factory && /*#__PURE__*/React.createElement(FormHelperText, {
    error: true
  }, errors.factory)), formData.applicationType === ("deadlyGrant" ) ? /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6,
    className: clsx(classes.item, classes.overrideReadOnly)
  }, /*#__PURE__*/React.createElement(PublishedComponent, {
    pubRef: "workforce.DatePicker",
    label: "workforce.employee.deathdate",
    value: (formData === null || formData === void 0 || (_formData$workforceEm15 = formData.workforceEmployee) === null || _formData$workforceEm15 === void 0 ? void 0 : _formData$workforceEm15.deathDate) || "",
    readOnly: false,
    onChange: function onChange(v) {
      return handleChange("deathDate", v);
    }
    // readOnly={true}
  }), errors.deathDate && /*#__PURE__*/React.createElement(FormHelperText, {
    error: true
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: errors.deathDate
  }))) : null), /*#__PURE__*/React.createElement(Divider, {
    style: {
      margin: "25px 0px"
    }
  }), /*#__PURE__*/React.createElement(Typography, {
    style: {
      marginTop: 4
    }
  }, /*#__PURE__*/React.createElement("b", null, getDeathLabel("workforce.application.labourHeadingTwo"))), /*#__PURE__*/React.createElement(Grid, {
    container: true,
    className: clsx(classes.item, classes.overrideReadOnly),
    spacing: 2
  }, (formData === null || formData === void 0 ? void 0 : formData.organizationType) === "eis" && /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6,
    className: clsx(classes.item, classes.overrideReadOnly)
  }, /*#__PURE__*/React.createElement(TextInput, {
    id: "fatherNameEn",
    label: "workforce.employee.fathers_name.en",
    value: (formData === null || formData === void 0 || (_formData$workforceEm16 = formData.workforceEmployee) === null || _formData$workforceEm16 === void 0 ? void 0 : _formData$workforceEm16.fatherNameEn) || "",
    onChange: function onChange(v) {
      return handleChange("fatherNameEn", v);
    },
    readOnly: false,
    required: true,
    error: !!errors.fatherNameEn,
    helperText: errors.fatherNameEn
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: (formData === null || formData === void 0 ? void 0 : formData.organizationType) === "eis" ? 6 : 12,
    className: clsx(classes.item, classes.overrideReadOnly)
  }, /*#__PURE__*/React.createElement(TextInput, {
    id: "fatherNameBn",
    label: (formData === null || formData === void 0 ? void 0 : formData.organizationType) === "eis" ? "workforce.employee.fathers_name.bn" : "workforce.employee.fathers_name",
    value: (formData === null || formData === void 0 || (_formData$workforceEm17 = formData.workforceEmployee) === null || _formData$workforceEm17 === void 0 ? void 0 : _formData$workforceEm17.fatherNameBn) || "",
    onChange: function onChange(v) {
      return handleChange("fatherNameBn", v);
    },
    readOnly: false,
    required: true,
    error: !!errors.fatherNameBn,
    helperText: errors.fatherNameBn
  })), (formData === null || formData === void 0 ? void 0 : formData.organizationType) === "eis" && /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6,
    className: clsx(classes.item, classes.overrideReadOnly)
  }, /*#__PURE__*/React.createElement(TextInput, {
    id: "motherNameEn",
    label: "workforce.employee.mothers_name.en",
    value: (formData === null || formData === void 0 || (_formData$workforceEm18 = formData.workforceEmployee) === null || _formData$workforceEm18 === void 0 ? void 0 : _formData$workforceEm18.motherNameEn) || "",
    onChange: function onChange(v) {
      return handleChange("motherNameEn", v);
    },
    readOnly: false,
    required: true,
    error: !!errors.motherNameEn,
    helperText: errors.motherNameEn
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: (formData === null || formData === void 0 ? void 0 : formData.organizationType) === "eis" ? 6 : 12,
    className: clsx(classes.item, classes.overrideReadOnly)
  }, /*#__PURE__*/React.createElement(TextInput, {
    id: "motherNameBn",
    label: (formData === null || formData === void 0 ? void 0 : formData.organizationType) === "eis" ? "workforce.employee.mothers_name.bn" : "workforce.employee.mothers_name",
    value: (formData === null || formData === void 0 || (_formData$workforceEm19 = formData.workforceEmployee) === null || _formData$workforceEm19 === void 0 ? void 0 : _formData$workforceEm19.motherNameBn) || "",
    onChange: function onChange(v) {
      return handleChange("motherNameBn", v);
    },
    readOnly: false,
    required: true,
    error: !!errors.motherNameBn,
    helperText: errors.motherNameBn
  })), (formData === null || formData === void 0 || (_formData$workforceEm20 = formData.workforceEmployee) === null || _formData$workforceEm20 === void 0 ? void 0 : _formData$workforceEm20.maritalStatus) === "workforce.marital_status.married" && /*#__PURE__*/React.createElement(React.Fragment, null, (formData === null || formData === void 0 ? void 0 : formData.organizationType) === "eis" && /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6,
    className: clsx(classes.item, classes.overrideReadOnly)
  }, /*#__PURE__*/React.createElement(TextInput, {
    id: "spouseNameEn",
    label: "workforce.employee.spouse.name.en",
    formatInput: filterEnglish,
    value: (formData === null || formData === void 0 || (_formData$workforceEm21 = formData.workforceEmployee) === null || _formData$workforceEm21 === void 0 ? void 0 : _formData$workforceEm21.spouseNameEn) || "",
    onChange: function onChange(v) {
      return handleChange("spouseNameEn", filterEnglish(v));
    },
    readOnly: false
    // required
    ,
    error: !!errors.spouseNameEn,
    helperText: errors.spouseNameEn
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: (formData === null || formData === void 0 ? void 0 : formData.organizationType) === "eis" ? 6 : 12,
    className: clsx(classes.item, classes.overrideReadOnly)
  }, /*#__PURE__*/React.createElement(TextInput, {
    id: "spouseNameBn",
    label: (formData === null || formData === void 0 ? void 0 : formData.organizationType) === "eis" ? "workforce.employee.spouse.name.bn" : "workforce.employee.spouse.name",
    value: (formData === null || formData === void 0 || (_formData$workforceEm22 = formData.workforceEmployee) === null || _formData$workforceEm22 === void 0 ? void 0 : _formData$workforceEm22.spouseNameBn) || "",
    formatInput: function formatInput(val) {
      return (formData === null || formData === void 0 ? void 0 : formData.organizationType) === "eis" ? filterBangla(val) : (val || "").toString();
    },
    onChange: function onChange(v) {
      return handleChange("spouseNameBn", (formData === null || formData === void 0 ? void 0 : formData.organizationType) === "eis" ? filterBangla(v) : v);
    },
    readOnly: false,
    error: !!errors.spouseNameBn,
    helperText: errors.spouseNameBn
  })))), formData.applicationType === "maternityGrant" && formData.applicationForSelf === "no" && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography, {
    style: {
      marginTop: 16
    }
  }, /*#__PURE__*/React.createElement("b", null, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "workforce.application.labourDetails.spouse",
    module: "workforce"
  }))), /*#__PURE__*/React.createElement(Grid, {
    container: true,
    className: clsx(classes.item, classes.overrideReadOnly),
    spacing: 2
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    className: clsx(classes.item, classes.overrideReadOnly)
  }, /*#__PURE__*/React.createElement(TextInput, {
    id: "spouseEn",
    label: "workforce.spouse.name",
    value: (formData === null || formData === void 0 || (_formData$metadata = formData.metadata) === null || _formData$metadata === void 0 ? void 0 : _formData$metadata.spouseEn) || "",
    onChange: function onChange(v) {
      return setFormData("spouseEn", v, "metadata");
    },
    required: true,
    readOnly: false,
    error: !!errors.spouseEn,
    helperText: errors.spouseEn
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6,
    className: clsx(classes.item, classes.overrideReadOnly)
  }, /*#__PURE__*/React.createElement(TextInput, {
    label: "workforce.employee.fathers_name",
    value: (formData === null || formData === void 0 || (_formData$metadata2 = formData.metadata) === null || _formData$metadata2 === void 0 ? void 0 : _formData$metadata2.fatherNameEn) || "",
    onChange: function onChange(v) {
      return setFormData("spouseFatherNameEn", v, "metadata");
    },
    readOnly: false
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6,
    className: clsx(classes.item, classes.overrideReadOnly)
  }, /*#__PURE__*/React.createElement(TextInput, {
    label: "workforce.employee.mothers_name",
    value: (formData === null || formData === void 0 || (_formData$metadata3 = formData.metadata) === null || _formData$metadata3 === void 0 ? void 0 : _formData$metadata3.motherNameEn) || "",
    onChange: function onChange(v) {
      return setFormData("spouseMotherNameEn", v, "metadata");
    },
    readOnly: false
    // required
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6,
    className: clsx(classes.item, classes.overrideReadOnly)
  }, /*#__PURE__*/React.createElement(TextInput, {
    id: "spouseNid",
    label: "workforce.application.employee.children.nidOrBirthRegistry",
    value: (formData === null || formData === void 0 || (_formData$metadata4 = formData.metadata) === null || _formData$metadata4 === void 0 ? void 0 : _formData$metadata4.spouseNid) || "",
    formatInput: function formatInput(val) {
      return (val || "").toString().replace(/\D/g, "").slice(0, 17);
    },
    onChange: function onChange(v) {
      var numericValue = (v || "").replace(/\D/g, "").slice(0, 17);
      setFormData("spouseNid", numericValue, "metadata");
    },
    type: "text",
    inputProps: {
      inputMode: "numeric",
      pattern: "[0-9০-৯]*",
      maxLength: 17
    },
    readOnly: false,
    required: true,
    error: !!errors.spouseNid,
    helperText: errors.spouseNid
  }), errors.nid && /*#__PURE__*/React.createElement(FormHelperText, {
    error: true
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "core.error.nidLength"
  }))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6,
    className: clsx(classes.item, classes.overrideReadOnly)
  }, /*#__PURE__*/React.createElement(PublishedComponent, {
    pubRef: "workforce.DatePicker",
    label: "workforce.employee.birthdate",
    value: (formData === null || formData === void 0 || (_formData$metadata5 = formData.metadata) === null || _formData$metadata5 === void 0 ? void 0 : _formData$metadata5.spouseBirthDate) || "",
    onChange: function onChange(v) {
      return setFormData("spouseBirthDate", v, "metadata");
    },
    readOnly: false,
    required: true
  }), errors.rdmp && /*#__PURE__*/React.createElement(FormHelperText, {
    error: true
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: errors === null || errors === void 0 ? void 0 : errors.rdmp
  }))))), /*#__PURE__*/React.createElement(Divider, null)))), /*#__PURE__*/React.createElement(EmployeeDetailsForm2, {
    errors: errors,
    handleChange: function handleChange() {},
    formData: formData,
    selectedApplicationType: formData.applicationType,
    formStepNo: "workforceEmployee"
  }));
};

// Custom debounce hook
var useDebounce$1 = function useDebounce(callback, delay) {
  var timer = useRef(null);
  var debouncedFn = useCallback(function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    if (timer.current) clearTimeout(timer.current);
    timer.current = setTimeout(function () {
      callback.apply(void 0, args);
    }, delay);
  }, [callback, delay]);
  return debouncedFn;
};
var PostOfficePicker = function PostOfficePicker(_ref) {
  var _ref$id = _ref.id,
    id = _ref$id === void 0 ? "postOffice" : _ref$id,
    locationId = _ref.locationId,
    modulesManager = _ref.modulesManager,
    _onChange = _ref.onChange,
    readOnly = _ref.readOnly,
    _ref$required = _ref.required,
    required = _ref$required === void 0 ? true : _ref$required,
    _ref$withLabel = _ref.withLabel,
    withLabel = _ref$withLabel === void 0 ? true : _ref$withLabel,
    withPlaceholder = _ref.withPlaceholder,
    value = _ref.value,
    label = _ref.label,
    placeholder = _ref.placeholder,
    filterOptions = _ref.filterOptions,
    filterSelectedOptions = _ref.filterSelectedOptions,
    multiple = _ref.multiple;
  var _useState = useState(""),
    _useState2 = _slicedToArray(_useState, 2),
    searchString = _useState2[0],
    setSearchString = _useState2[1];
  var _useTranslations = useTranslations("workforce"),
    formatMessage = _useTranslations.formatMessage;
  var locale = useSelector(function (state) {
    var _state$core;
    return ((_state$core = state.core) === null || _state$core === void 0 || (_state$core = _state$core.user) === null || _state$core === void 0 || (_state$core = _state$core.i_user) === null || _state$core === void 0 ? void 0 : _state$core.language) || "en";
  });
  var dispatch = useDispatch();
  useEffect(function () {
    if (locationId) {
      dispatch(fetchPostOfficesPick(modulesManager, decodeId(locationId)));
    }
  }, [locationId]);
  var isLoading = useSelector(function (state) {
    return state.workforce["fetchingPostOfficesPick"];
  });
  var fetchedData = useSelector(function (state) {
    var _state$workforce;
    return (_state$workforce = state.workforce["postOfficesPick"]) !== null && _state$workforce !== void 0 ? _state$workforce : [];
  });
  var error = useSelector(function (state) {
    return state.workforce["errorPostOfficesPick"];
  });
  var selectedOption = useMemo(function () {
    if (!value) return null;
    // if (typeof value === "string" || typeof value === "number") {
    //   return fetchedData.find((option) => option.id === value) || null;
    // }
    return value || null;
  }, [value, fetchedData]);
  var options = useMemo(function () {
    var opts = _toConsumableArray(fetchedData);
    if (selectedOption && !opts.find(function (o) {
      return o.id === selectedOption.id;
    })) {
      opts = [].concat(_toConsumableArray(opts), [selectedOption]);
    }
    if (searchString && !opts.find(function (o) {
      var _o$nameEn, _o$nameBn;
      return ((_o$nameEn = o.nameEn) === null || _o$nameEn === void 0 ? void 0 : _o$nameEn.toLowerCase()) === searchString.toLowerCase() || ((_o$nameBn = o.nameBn) === null || _o$nameBn === void 0 ? void 0 : _o$nameBn.toLowerCase()) === searchString.toLowerCase();
    })) {
      opts = [].concat(_toConsumableArray(opts), [{
        id: '',
        nameEn: searchString,
        nameBn: searchString
      }]);
    }
    return opts;
  }, [fetchedData, selectedOption, searchString]);
  var debouncedHandleType = useDebounce$1(function (name) {
    if (!name) return;
    var exists = fetchedData.find(function (d) {
      var _d$nameEn, _d$nameBn;
      return ((_d$nameEn = d.nameEn) === null || _d$nameEn === void 0 ? void 0 : _d$nameEn.toLowerCase()) === name.toLowerCase() || ((_d$nameBn = d.nameBn) === null || _d$nameBn === void 0 ? void 0 : _d$nameBn.toLowerCase()) === name.toLowerCase();
    }) || null;
    if (exists) {
      if (!selectedOption || selectedOption.id !== exists.id) {
        _onChange(exists);
      }
    } else {
      if (!selectedOption || selectedOption.nameEn !== name) {
        var newOption = {
          id: null,
          nameEn: name,
          nameBn: name
        };
        _onChange(newOption);
      }
    }
  }, 800);
  useEffect(function () {
    if (searchString) {
      debouncedHandleType(searchString);
    }
  }, [searchString, debouncedHandleType]);
  return /*#__PURE__*/React.createElement(Autocomplete, {
    id: id,
    multiple: multiple,
    required: required,
    placeholder: placeholder !== null && placeholder !== void 0 ? placeholder : "",
    label: label !== null && label !== void 0 ? label : formatMessage("workforce.postOffice.picker"),
    error: error,
    withLabel: withLabel,
    withPlaceholder: withPlaceholder,
    readOnly: readOnly,
    options: options,
    isLoading: isLoading,
    value: fixBrokenUnicode(selectedOption),
    getOptionLabel: function getOptionLabel(option) {
      return fixBrokenUnicode(locale === "en" ? (option === null || option === void 0 ? void 0 : option.nameEn) || "" : (option === null || option === void 0 ? void 0 : option.nameBn) || "");
    },
    onChange: function onChange(option) {
      return _onChange(option);
    },
    filterOptions: filterOptions,
    filterSelectedOptions: filterSelectedOptions,
    onInputChange: function onInputChange(val) {
      return setSearchString(val);
    }
  });
};

function ownKeys$18(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$18(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$18(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$18(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var CustomDetailedLocation = function CustomDetailedLocation(_ref) {
  var _ref$locationType = _ref.locationType,
    locationType = _ref$locationType === void 0 ? "city" : _ref$locationType,
    onChange = _ref.onChange,
    addressKey = _ref.addressKey,
    _ref$data = _ref.data,
    data = _ref$data === void 0 ? {} : _ref$data,
    readOnly = _ref.readOnly,
    locationData = _ref.locationData,
    errors = _ref.errors;
  var _useState = useState({}),
    _useState2 = _slicedToArray(_useState, 2),
    localData = _useState2[0],
    setLocalData = _useState2[1];
  var firstRender = useRef(true);
  var thirdStepId = getThirdStepId(locationData);
  console.log({
    thirdStepId: thirdStepId
  });
  // Parse and initialize from passed `data` once on mount or when `data` changes (external)
  useEffect(function () {
    if (typeof data === "string") {
      try {
        var parsed = JSON.parse(data);
        setLocalData(parsed || {});
      } catch (err) {
        console.error("Invalid JSON in data prop:", err);
        setLocalData({});
      }
    } else if (_typeof(data) === "object" && data !== null) {
      setLocalData(data);
    } else {
      setLocalData({});
    }
  }, [data]);

  // Update parent only when localData changes by user input (not initial mount)
  useEffect(function () {
    if (firstRender.current) {
      firstRender.current = false;
      return;
    }
    onChange === null || onChange === void 0 || onChange(addressKey, JSON.stringify(localData));
  }, [localData]); // Only trigger on localData change

  var updateField = function updateField(key, value) {
    setLocalData(function (prev) {
      return _objectSpread$18(_objectSpread$18({}, prev), {}, _defineProperty({}, key, value));
    });
  };
  console.log('localdata', localData);
  return /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 1
  }, locationType === "city" && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 4
  }, /*#__PURE__*/React.createElement(PostOfficePicker, {
    id: "postOffice",
    value: localData.postOffice,
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.select.postOffice",
      module: "workforce"
    }),
    locationId: thirdStepId,
    onChange: function onChange(v) {
      return updateField("postOffice", v);
    },
    required: true,
    readOnly: readOnly
  }), (errors === null || errors === void 0 ? void 0 : errors.postOffice) && /*#__PURE__*/React.createElement(FormHelperText, {
    error: true
  }, errors === null || errors === void 0 ? void 0 : errors.postOffice)), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 4
  }, /*#__PURE__*/React.createElement(TextInput, {
    label: "workforce.employee.city.road_no",
    value: localData.roadName || "",
    onChange: function onChange(v) {
      return updateField("roadName", v);
    },
    InputProps: {
      margin: "dense"
    },
    readOnly: readOnly
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 4
  }, /*#__PURE__*/React.createElement(TextInput, {
    label: "workforce.employee.city.house_name",
    value: localData.houseName || "",
    onChange: function onChange(v) {
      return updateField("houseName", v);
    },
    InputProps: {
      margin: "dense"
    },
    readOnly: readOnly
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 4
  }, /*#__PURE__*/React.createElement(TextInput, {
    label: "workforce.employee.city.apartment_number",
    value: localData.apartmentNumber || "",
    onChange: function onChange(v) {
      return updateField("apartmentNumber", v);
    },
    InputProps: {
      margin: "dense"
    },
    readOnly: readOnly
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 4
  }, /*#__PURE__*/React.createElement(TextInput, {
    value: localData.extraInfo || "",
    label: "\xA0",
    onChange: function onChange(v) {
      return updateField("extraInfo", v);
    },
    InputProps: {
      margin: "dense"
    },
    readOnly: readOnly
  }))), locationType === "rural" && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 4
  }, /*#__PURE__*/React.createElement(PostOfficePicker, {
    id: "postOffice",
    value: localData.postOffice || null,
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.select.postOffice",
      module: "workforce"
    }),
    locationId: thirdStepId,
    onChange: function onChange(v) {
      return updateField("postOffice", v);
    },
    required: true,
    readOnly: readOnly
  }), (errors === null || errors === void 0 ? void 0 : errors.postOffice) && /*#__PURE__*/React.createElement(FormHelperText, {
    error: true
  }, errors === null || errors === void 0 ? void 0 : errors.postOffice)), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 4
  }, /*#__PURE__*/React.createElement(TextInput, {
    label: "workforce.employee.rural.house_name",
    value: localData.houseName || "",
    onChange: function onChange(v) {
      return updateField("houseName", v);
    },
    InputProps: {
      margin: "dense"
    },
    readOnly: readOnly
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 4
  }, /*#__PURE__*/React.createElement(TextInput, {
    label: "workforce.employee.rural.para_mahalla",
    value: localData.paraMahalla || "",
    onChange: function onChange(v) {
      return updateField("paraMahalla", v);
    },
    InputProps: {
      margin: "dense"
    },
    readOnly: readOnly
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 4
  }, /*#__PURE__*/React.createElement(TextInput, {
    label: "workforce.employee.rural.village_road",
    value: localData.villageRoad || "",
    onChange: function onChange(v) {
      return updateField("villageRoad", v);
    },
    InputProps: {
      margin: "dense"
    },
    readOnly: readOnly
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 4
  }, /*#__PURE__*/React.createElement(TextInput, {
    value: localData.extraInfo || "",
    label: "\xA0",
    onChange: function onChange(v) {
      return updateField("extraInfo", v);
    },
    InputProps: {
      margin: "dense"
    },
    readOnly: readOnly
  }))));
};

var useStyles$1v = makeStyles(function (theme) {
  return {
    paper: {
      padding: theme.spacing(2)
    },
    item: {
      marginBottom: theme.spacing(2)
    }
  };
});
var EmployeeLocationForm = function EmployeeLocationForm(_ref) {
  var _formData$workforceEm3, _formData$workforceEm4, _formData$workforceEm5, _formData$workforceEm6, _formData$workforceEm7, _formData$workforceEm8, _formData$workforceEm9, _formData$workforceEm10, _formData$workforceEm11, _formData$workforceEm12, _formData$workforceEm13, _formData$workforceEm14;
  var handleChange = _ref.handleChange,
    formData = _ref.formData,
    errors = _ref.errors;
    _ref.applicationId;
  var classes = useStyles$1v();
  useHistory();
  var modulesManager = useModulesManager();
  var _useTranslations = useTranslations("core.RegistrationPage", modulesManager),
    formatMessage = _useTranslations.formatMessage;
  useSelector(function (state) {
    var _state$core;
    return (_state$core = state.core) === null || _state$core === void 0 || (_state$core = _state$core.user) === null || _state$core === void 0 || (_state$core = _state$core.i_user) === null || _state$core === void 0 ? void 0 : _state$core.language;
  });
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    sameAsPresent = _useState2[0],
    setSameAsPresent = _useState2[1];

  // ================= VISIBILITY LOGIC =================
  var showPresentAddress = useMemo(function () {
    var appType = formData === null || formData === void 0 ? void 0 : formData.applicationType;
    var orgType = formData === null || formData === void 0 ? void 0 : formData.organizationType;

    // 1. Identify Restricted Scenarios
    // Condition: Application is (financialAssistance OR deadlyGrant) AND Organization is (cf OR blwf)
    // Note: Checking both 'deadlyGrant' and 'DeadlyGrant' to be safe with casing
    var isRestrictedApp = ["financialAssistance", "deadlyGrant", "DeadlyGrant"].includes(appType);
    var isRestrictedOrg = ["cf", "blwf"].includes(orgType);
    if (isRestrictedApp && isRestrictedOrg) {
      return false; // HIDE Present Address
    }

    // 2. Default: SHOW Present Address (includes 'eis' and all other application types)
    return true;
  }, [formData === null || formData === void 0 ? void 0 : formData.applicationType, formData === null || formData === void 0 ? void 0 : formData.organizationType]);
  // ====================================================

  useMemo(function () {
    if (sameAsPresent && showPresentAddress) {
      var _formData$workforceEm, _formData$workforceEm2;
      var presentLocation = (formData === null || formData === void 0 || (_formData$workforceEm = formData.workforceEmployee) === null || _formData$workforceEm === void 0 ? void 0 : _formData$workforceEm.presentLocation) || null;
      var presentAddress = (formData === null || formData === void 0 || (_formData$workforceEm2 = formData.workforceEmployee) === null || _formData$workforceEm2 === void 0 ? void 0 : _formData$workforceEm2.presentAddress) || "";
      handleChange("permanentLocation", presentLocation);
      try {
        var parsedAddress = JSON.parse(presentAddress);
        handleChange("permanentAddress", JSON.stringify(parsedAddress));
      } catch (err) {
        handleChange("permanentAddress", presentAddress);
      }
    }
  }, [sameAsPresent, showPresentAddress, formData === null || formData === void 0 || (_formData$workforceEm3 = formData.workforceEmployee) === null || _formData$workforceEm3 === void 0 ? void 0 : _formData$workforceEm3.presentLocation, formData === null || formData === void 0 || (_formData$workforceEm4 = formData.workforceEmployee) === null || _formData$workforceEm4 === void 0 ? void 0 : _formData$workforceEm4.presentAddress]);
  var isCityLocation = function isCityLocation(locationObj) {
    var current = locationObj;
    while (current) {
      var _current$name;
      if (current.name && current.name.includes("সিটি কর্পোরেশন")) {
        return true;
      } else if ((_current$name = current.name) !== null && _current$name !== void 0 && _current$name.includes("পৌরসভা")) {
        return true;
      }
      current = current.parent;
    }
    return false;
  };
  var getDeathLabel = function getDeathLabel(labelKey) {
    return formData.applicationType === "financialAssistance" ? "".concat(formatMessage("workforce.dead"), " ").concat(formatMessage("workforce.worker.label"), "  ").concat(formatMessage(labelKey)) : formatMessage(labelKey);
  };
  return /*#__PURE__*/React.createElement(Box$1, {
    mt: 1
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 2
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(Paper, {
    className: classes.paper,
    elevation: 0
  }, /*#__PURE__*/React.createElement(Box$1, {
    mb: 4,
    textAlign: "center",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "workforce.application.header.location",
    module: "workforce"
  })), /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 2
  }, showPresentAddress && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement("b", null, getDeathLabel("workforce.employee.present_location")), /*#__PURE__*/React.createElement(PublishedComponent, {
    pubRef: "location.DetailedLocation",
    withNull: true,
    value: (formData === null || formData === void 0 || (_formData$workforceEm5 = formData.workforceEmployee) === null || _formData$workforceEm5 === void 0 ? void 0 : _formData$workforceEm5.presentLocation) || null,
    onChange: function onChange(presentLocation) {
      return handleChange("presentLocation", presentLocation);
    },
    readOnly: false,
    required: true,
    split: true
  }), (errors === null || errors === void 0 ? void 0 : errors.detailedLocation) && /*#__PURE__*/React.createElement(FormHelperText, {
    error: true
  }, errors === null || errors === void 0 ? void 0 : errors.detailedLocation)), (formData === null || formData === void 0 || (_formData$workforceEm6 = formData.workforceEmployee) === null || _formData$workforceEm6 === void 0 ? void 0 : _formData$workforceEm6.presentLocation) && /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(CustomDetailedLocation, {
    id: "presentLocationCustomDetailedLocation",
    locationType: isCityLocation(formData === null || formData === void 0 || (_formData$workforceEm7 = formData.workforceEmployee) === null || _formData$workforceEm7 === void 0 ? void 0 : _formData$workforceEm7.presentLocation) ? "city" : "rural",
    onChange: handleChange,
    addressKey: "presentAddress",
    data: formData === null || formData === void 0 || (_formData$workforceEm8 = formData.workforceEmployee) === null || _formData$workforceEm8 === void 0 ? void 0 : _formData$workforceEm8.presentAddress,
    readOnly: false,
    locationData: formData === null || formData === void 0 || (_formData$workforceEm9 = formData.workforceEmployee) === null || _formData$workforceEm9 === void 0 ? void 0 : _formData$workforceEm9.presentLocation,
    errors: errors
  }))), /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(Divider, {
    style: {
      margin: "25px 0px"
    }
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement("b", null, getDeathLabel("workforce.employee.permanent_location")), showPresentAddress && /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(FormControlLabel, {
    control: /*#__PURE__*/React.createElement(Checkbox, {
      color: "primary",
      checked: sameAsPresent,
      onChange: function onChange(e) {
        return setSameAsPresent(e.target.checked);
      }
    }),
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.employee.sameAsPresent",
      defaultMessage: "Same as present location"
    })
  })), /*#__PURE__*/React.createElement(PublishedComponent, {
    pubRef: "location.DetailedLocation",
    withNull: true,
    value: (formData === null || formData === void 0 || (_formData$workforceEm10 = formData.workforceEmployee) === null || _formData$workforceEm10 === void 0 ? void 0 : _formData$workforceEm10.permanentLocation) || null,
    onChange: function onChange(permanentLocation) {
      return handleChange("permanentLocation", permanentLocation);
    },
    readOnly: sameAsPresent,
    required: true,
    split: true
  }), (errors === null || errors === void 0 ? void 0 : errors.detailedLocation) && /*#__PURE__*/React.createElement(FormHelperText, {
    error: true
  }, errors === null || errors === void 0 ? void 0 : errors.detailedLocation)), (formData === null || formData === void 0 || (_formData$workforceEm11 = formData.workforceEmployee) === null || _formData$workforceEm11 === void 0 ? void 0 : _formData$workforceEm11.permanentLocation) && /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(CustomDetailedLocation, {
    id: "permanentLocationCustomDetailedLocation",
    locationType: isCityLocation(formData === null || formData === void 0 || (_formData$workforceEm12 = formData.workforceEmployee) === null || _formData$workforceEm12 === void 0 ? void 0 : _formData$workforceEm12.permanentLocation) ? "city" : "rural",
    onChange: handleChange,
    addressKey: "permanentAddress",
    data: formData === null || formData === void 0 || (_formData$workforceEm13 = formData.workforceEmployee) === null || _formData$workforceEm13 === void 0 ? void 0 : _formData$workforceEm13.permanentAddress,
    readOnly: sameAsPresent,
    locationData: formData === null || formData === void 0 || (_formData$workforceEm14 = formData.workforceEmployee) === null || _formData$workforceEm14 === void 0 ? void 0 : _formData$workforceEm14.permanentLocation
  })))), /*#__PURE__*/React.createElement(Divider, null)))));
};

var RelationWithWorkerPicker = function RelationWithWorkerPicker(_ref) {
  var id = _ref.id,
    _ref$applicantInfo = _ref.applicantInfo,
    applicantInfo = _ref$applicantInfo === void 0 ? "" : _ref$applicantInfo;
    _ref.modulesManager;
    var _onChange = _ref.onChange,
    readOnly = _ref.readOnly,
    required = _ref.required,
    _ref$withLabel = _ref.withLabel,
    withLabel = _ref$withLabel === void 0 ? true : _ref$withLabel,
    _ref$excludeRelation = _ref.excludeRelation,
    excludeRelation = _ref$excludeRelation === void 0 ? null : _ref$excludeRelation,
    withPlaceholder = _ref.withPlaceholder,
    value = _ref.value,
    label = _ref.label,
    placeholder = _ref.placeholder,
    filterOptions = _ref.filterOptions,
    filterSelectedOptions = _ref.filterSelectedOptions;
    _ref.multiple;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2);
    _useState2[0];
    var setSearchString = _useState2[1];
  var _useTranslations = useTranslations("workforce"),
    formatMessage = _useTranslations.formatMessage;
  var user_type = getUserType();

  // Adjust the options to match the EMPLOYEE_RELATION format
  var EMPLOYEE_RELATION = ["workforce.relation.father", "workforce.relation.mother", "workforce.relation.wife", "workforce.relation.husband", "workforce.relation.son", "workforce.relation.daughter", "workforce.relation.brother", "workforce.relation.sister", "workforce.relation.grand_daughter", "workforce.relation.grand_son", "workforce.relation.grand_father", "workforce.relation.grand_mother"
  // "workforce.relation.illigitimate_son",
  // "workforce.relation.illigitimate_daughter"
  ];
  var options = useMemo(function () {
    // const baseOptions = (user_type === WORKFORCE_USER_TYPE.FACTORY_ADMIN && applicantInfo === "factory_admin")
    //   ? EMPLOYEE_RELATION_APPLICANT
    //   : EMPLOYEE_RELATION;
    var baseOptions = EMPLOYEE_RELATION;
    if (!excludeRelation) return baseOptions;
    return baseOptions.filter(function (option) {
      return option !== excludeRelation;
    });
  }, [user_type, applicantInfo, excludeRelation]);

  // Find the selected option
  var selectedOption = useMemo(function () {
    return EMPLOYEE_RELATION.includes(value) ? value : null;
  }, [value]);
  return /*#__PURE__*/React.createElement(Autocomplete, {
    id: id,
    multiple: false,
    required: required,
    placeholder: placeholder !== null && placeholder !== void 0 ? placeholder : "",
    label: label !== null && label !== void 0 ? label : formatMessage("workforce.employee.relation.picker"),
    withLabel: withLabel,
    withPlaceholder: withPlaceholder,
    readOnly: readOnly,
    isLoading: false // Set to false if not loading data dynamically
    ,
    options: options,
    value: selectedOption,
    getOptionLabel: function getOptionLabel(option) {
      return formatMessage(option);
    } // Since options are strings, return the string directly
    ,
    onChange: function onChange(option) {
      return _onChange(option, option !== null && option !== void 0 ? option : null);
    },
    filterOptions: filterOptions,
    filterSelectedOptions: filterSelectedOptions,
    onInputChange: setSearchString
  });
};

function ownKeys$17(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$17(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$17(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$17(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var CustomDependentLocation = function CustomDependentLocation(_ref) {
  var location = _ref.location,
    onChange = _ref.onChange,
    addressKey = _ref.addressKey,
    data = _ref.data,
    readOnly = _ref.readOnly,
    locationData = _ref.locationData,
    errors = _ref.errors;
  var _useState = useState("rural"),
    _useState2 = _slicedToArray(_useState, 2),
    locationType = _useState2[0],
    setLocationType = _useState2[1];
  var _useState3 = useState(data || {}),
    _useState4 = _slicedToArray(_useState3, 2),
    localData = _useState4[0],
    setLocalData = _useState4[1];
  var thirdStepId = getThirdStepId(locationData);
  var firstRender = useRef(true);
  // Update internal state when external data changes
  useEffect(function () {
    if (data) {
      try {
        var parsedData = typeof data === "string" ? JSON.parse(data) : data;
        setLocalData(parsedData || {});
      } catch (error) {
        console.error("Invalid address JSON:", error);
        setLocalData({});
      }
    } else {
      setLocalData({});
    }
  }, [data]);

  // Determine if location is city or rural
  useEffect(function () {
    var isCity = checkIfCity(location);
    setLocationType(isCity ? "city" : "rural");
  }, [location]);
  var checkIfCity = function checkIfCity(location) {
    var current = location;
    while (current) {
      var _current$name, _current$name2;
      if ((_current$name = current.name) !== null && _current$name !== void 0 && _current$name.includes("সিটি কর্পোরেশন")) {
        return true;
      } else if ((_current$name2 = current.name) !== null && _current$name2 !== void 0 && _current$name2.includes("পৌরসভা")) {
        return true;
      }
      current = current.parent;
    }
    return false;
  };
  useEffect(function () {
    if (firstRender.current) {
      firstRender.current = false;
      return;
    }
    onChange === null || onChange === void 0 || onChange(addressKey, JSON.stringify(localData));
  }, [localData]);
  var updateField = function updateField(key, value) {
    var updatedData = _objectSpread$17(_objectSpread$17({}, localData), {}, _defineProperty({}, key, value));
    setLocalData(updatedData);
    // if (onChange) {
    //   onChange(addressKey, updatedData);
    // }
  };
  return /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 1
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 4
  }, /*#__PURE__*/React.createElement(PostOfficePicker, {
    id: "postOffice",
    value: localData.postOffice,
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.select.postOffice",
      module: "workforce"
    }),
    locationId: thirdStepId,
    onChange: function onChange(v) {
      return updateField("postOffice", v);
    },
    required: true,
    readOnly: readOnly
  }), (errors === null || errors === void 0 ? void 0 : errors.postOffice) && /*#__PURE__*/React.createElement(FormHelperText, {
    error: true
  }, errors === null || errors === void 0 ? void 0 : errors.postOffice)), locationType === "city" && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 4
  }, /*#__PURE__*/React.createElement(TextInput, {
    label: "workforce.employee.city.road_no",
    value: localData.roadName || "",
    onChange: function onChange(v) {
      return updateField("roadName", v);
    },
    readOnly: readOnly
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 4
  }, /*#__PURE__*/React.createElement(TextInput, {
    label: "workforce.employee.city.house_name",
    value: localData.houseName || "",
    onChange: function onChange(v) {
      return updateField("houseName", v);
    },
    readOnly: readOnly
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 4
  }, /*#__PURE__*/React.createElement(TextInput, {
    label: "workforce.employee.city.apartment_number",
    value: localData.apartmentNumber || "",
    onChange: function onChange(v) {
      return updateField("apartmentNumber", v);
    },
    readOnly: readOnly
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 4
  }, /*#__PURE__*/React.createElement(TextInput
  //   label="workforce.employee.city.extra_info"
  , {
    label: "\xA0",
    value: localData.extraInfo || "",
    onChange: function onChange(v) {
      return updateField("extraInfo", v);
    },
    readOnly: readOnly
  }))), locationType === "rural" && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 4
  }, /*#__PURE__*/React.createElement(TextInput, {
    label: "workforce.employee.rural.house_name",
    value: localData.houseName || "",
    onChange: function onChange(v) {
      return updateField("houseName", v);
    },
    readOnly: readOnly
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 4
  }, /*#__PURE__*/React.createElement(TextInput, {
    label: "workforce.employee.rural.para_mahalla",
    value: localData.paraMahalla || "",
    onChange: function onChange(v) {
      return updateField("paraMahalla", v);
    },
    readOnly: readOnly
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 4
  }, /*#__PURE__*/React.createElement(TextInput, {
    label: "workforce.employee.rural.village_road",
    value: localData.villageRoad || "",
    onChange: function onChange(v) {
      return updateField("villageRoad", v);
    },
    readOnly: readOnly
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 4
  }, /*#__PURE__*/React.createElement(TextInput
  //   label="workforce.employee.rural.extra_info"
  , {
    label: "\xA0",
    value: localData.extraInfo || "",
    onChange: function onChange(v) {
      return updateField("extraInfo", v);
    },
    readOnly: readOnly
  }))));
};

function ownKeys$16(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$16(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$16(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$16(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var useStyles$1u = makeStyles(function (theme) {
  return {
    paper: {
      padding: theme.spacing(2),
      marginBottom: theme.spacing(2),
      boxShadow: "3px"
    },
    buttonContainer: {
      display: "flex",
      justifyContent: "space-between",
      marginTop: theme.spacing(2)
    }
  };
});
var EmployeeDependentForm = function EmployeeDependentForm(_ref) {
  var applicationType = _ref.applicationType,
    dependents = _ref.dependents,
    handleChange = _ref.handleChange,
    addItem = _ref.addItem,
    removeItem = _ref.removeItem,
    expanded = _ref.expanded,
    setExpanded = _ref.setExpanded,
    formdata = _ref.formdata,
    errors = _ref.errors;
  var classes = useStyles$1u();
  var modulesManager = useModulesManager();
  var _useTranslations = useTranslations("core.RegistrationPage", modulesManager),
    formatMessage = _useTranslations.formatMessage;
  useSelector(function (state) {
    var _state$core;
    return (_state$core = state.core) === null || _state$core === void 0 || (_state$core = _state$core.user) === null || _state$core === void 0 || (_state$core = _state$core.i_user) === null || _state$core === void 0 ? void 0 : _state$core.language;
  });
  var normalizedDependents = useMemo(function () {
    return Array.isArray(dependents) ? dependents : dependents ? [dependents] : [];
  }, [dependents]);
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    sameAsPresent = _useState2[0],
    setSameAsPresent = _useState2[1];
  useEffect(function () {
    if (Array.isArray(normalizedDependents)) {
      setSameAsPresent(function (prev) {
        return normalizedDependents.map(function (_, index) {
          return (prev === null || prev === void 0 ? void 0 : prev[index]) || false;
        });
      });
    }
  }, [normalizedDependents]);
  var handleCheckboxChange = useCallback(function (index, e) {
    var _dependents$index, _dependents$index2;
    var isChecked = e.target.checked;
    setSameAsPresent(function (prev) {
      var updated = _toConsumableArray(prev || []);
      updated[index] = isChecked;
      return updated;
    });
    var presentLocation = (dependents === null || dependents === void 0 || (_dependents$index = dependents[index]) === null || _dependents$index === void 0 ? void 0 : _dependents$index.presentLocation) || null;
    var presentAddress = (dependents === null || dependents === void 0 || (_dependents$index2 = dependents[index]) === null || _dependents$index2 === void 0 ? void 0 : _dependents$index2.presentAddress) || "";
    handleChange(index, "permanentLocation", isChecked ? presentLocation : null);
    handleChange(index, "permanentAddress", isChecked ? presentAddress : "");
  }, [dependents, handleChange]);
  var getRelationAwareLabel = useCallback(function (dependent, labelKey) {
    return applicationType === "financialAssistance" && dependent !== null && dependent !== void 0 && dependent.relationType ? "".concat(formatMessage(dependent.relationType + ".suffix"), " ").concat(formatMessage(labelKey)) : formatMessage(labelKey);
  }, [applicationType, formatMessage]);
  var handleAttachmentChange = useCallback(function (index, fieldKey, value) {
    var normalizeAttachments = function normalizeAttachments(attachments) {
      if (!attachments) return [];
      if (typeof attachments === "string") {
        try {
          var parsed = JSON.parse(attachments);
          return Array.isArray(parsed) ? parsed : [];
        } catch (error) {
          return [];
        }
      }
      return Array.isArray(attachments) ? attachments : [];
    };
    handleChange(index, "attachments", function (currentAttachments) {
      var _value$files;
      var normalizedAttachments = normalizeAttachments(currentAttachments);
      if (!(value !== null && value !== void 0 && (_value$files = value.files) !== null && _value$files !== void 0 && _value$files.length)) {
        return normalizedAttachments.filter(function (att) {
          return att.fieldKey !== fieldKey;
        });
      }
      return normalizedAttachments.some(function (att) {
        return att.fieldKey === fieldKey;
      }) ? normalizedAttachments.map(function (att) {
        return att.fieldKey === fieldKey ? _objectSpread$16(_objectSpread$16({}, att), {}, {
          fieldKey: fieldKey,
          files: value.files,
          documentType: value.documentType,
          documentPropId: value.documentPropId
        }) : att;
      }) : [].concat(_toConsumableArray(normalizedAttachments), [{
        fieldKey: fieldKey,
        files: value.files,
        documentType: value.documentType,
        documentPropId: value.documentPropId
      }]);
    });
  }, [handleChange]);
  var onPickerChange = function onPickerChange(v, index) {
    var _formdata$workforceAp;
    handleChange(index, "relationType", v);
    var employee = formdata === null || formdata === void 0 ? void 0 : formdata.workforceEmployee;
    handleChange(index, "fatherNameEn", "");
    handleChange(index, "fatherNameBn", "");
    handleChange(index, "motherNameEn", "");
    handleChange(index, "motherNameBn", "");
    handleChange(index, "nameEn", "");
    handleChange(index, "nameBn", "");
    handleChange(index, "presentLocation", null);
    handleChange(index, "permanentLocation", null);
    handleChange(index, "presentAddress", "");
    handleChange(index, "permanentAddress", "");
    if (v === (formdata === null || formdata === void 0 || (_formdata$workforceAp = formdata.workforceApplicant) === null || _formdata$workforceAp === void 0 ? void 0 : _formdata$workforceAp.relationWithApplicant)) {
      var _formdata$workforceAp2, _formdata$workforceAp3, _formdata$workforceAp4, _formdata$workforceAp5, _formdata$workforceAp6, _formdata$workforceAp7, _formdata$workforceAp8, _formdata$workforceAp9, _formdata$workforceAp10, _formdata$workforceAp11, _formdata$workforceAp12, _formdata$workforceAp13, _formdata$workforceAp14;
      handleChange(index, "birthDate", formdata === null || formdata === void 0 || (_formdata$workforceAp2 = formdata.workforceApplicant) === null || _formdata$workforceAp2 === void 0 ? void 0 : _formdata$workforceAp2.birthDate);
      handleChange(index, "phoneNumber", formdata === null || formdata === void 0 || (_formdata$workforceAp3 = formdata.workforceApplicant) === null || _formdata$workforceAp3 === void 0 ? void 0 : _formdata$workforceAp3.phoneNumber);
      handleChange(index, "nameEn", formdata === null || formdata === void 0 || (_formdata$workforceAp4 = formdata.workforceApplicant) === null || _formdata$workforceAp4 === void 0 ? void 0 : _formdata$workforceAp4.nameEn);
      handleChange(index, "nameBn", formdata === null || formdata === void 0 || (_formdata$workforceAp5 = formdata.workforceApplicant) === null || _formdata$workforceAp5 === void 0 ? void 0 : _formdata$workforceAp5.nameBn);
      handleChange(index, "fatherNameEn", formdata === null || formdata === void 0 || (_formdata$workforceAp6 = formdata.workforceApplicant) === null || _formdata$workforceAp6 === void 0 ? void 0 : _formdata$workforceAp6.fatherNameEn);
      handleChange(index, "fatherNameBn", formdata === null || formdata === void 0 || (_formdata$workforceAp7 = formdata.workforceApplicant) === null || _formdata$workforceAp7 === void 0 ? void 0 : _formdata$workforceAp7.fatherNameBn);
      handleChange(index, "motherNameEn", formdata === null || formdata === void 0 || (_formdata$workforceAp8 = formdata.workforceApplicant) === null || _formdata$workforceAp8 === void 0 ? void 0 : _formdata$workforceAp8.motherNameEn);
      handleChange(index, "motherNameBn", formdata === null || formdata === void 0 || (_formdata$workforceAp9 = formdata.workforceApplicant) === null || _formdata$workforceAp9 === void 0 ? void 0 : _formdata$workforceAp9.motherNameBn);
      handleChange(index, "nid", formdata === null || formdata === void 0 || (_formdata$workforceAp10 = formdata.workforceApplicant) === null || _formdata$workforceAp10 === void 0 ? void 0 : _formdata$workforceAp10.nid);
      handleChange(index, "presentLocation", formdata === null || formdata === void 0 || (_formdata$workforceAp11 = formdata.workforceApplicant) === null || _formdata$workforceAp11 === void 0 ? void 0 : _formdata$workforceAp11.presentLocation);
      handleChange(index, "permanentLocation", formdata === null || formdata === void 0 || (_formdata$workforceAp12 = formdata.workforceApplicant) === null || _formdata$workforceAp12 === void 0 ? void 0 : _formdata$workforceAp12.permanentLocation);
      handleChange(index, "presentAddress", formdata === null || formdata === void 0 || (_formdata$workforceAp13 = formdata.workforceApplicant) === null || _formdata$workforceAp13 === void 0 ? void 0 : _formdata$workforceAp13.presentAddress);
      handleChange(index, "permanentAddress", formdata === null || formdata === void 0 || (_formdata$workforceAp14 = formdata.workforceApplicant) === null || _formdata$workforceAp14 === void 0 ? void 0 : _formdata$workforceAp14.permanentAddress);
    } else if (["workforce.relation.son", "workforce.relation.daughter"].includes(v) && employee) {
      handleChange(index, "fatherNameEn", employee.nameEn);
      handleChange(index, "fatherNameBn", employee.nameBn);
      handleChange(index, "presentLocation", employee.presentLocation);
      handleChange(index, "permanentLocation", employee.permanentLocation);
      handleChange(index, "presentAddress", employee.presentAddress);
      handleChange(index, "permanentAddress", employee.permanentAddress);
    } else if (["workforce.relation.father"].includes(v) && employee) {
      handleChange(index, "nameEn", employee.fatherNameEn);
      handleChange(index, "nameBn", employee.fatherNameBn);
      handleChange(index, "presentLocation", employee.presentLocation);
      handleChange(index, "permanentLocation", employee.presentLocation);
      handleChange(index, "presentAddress", employee.presentAddress);
      handleChange(index, "permanentAddress", employee.presentAddress);
    } else if (["workforce.relation.mother"].includes(v) && employee) {
      handleChange(index, "nameEn", employee.motherNameEn);
      handleChange(index, "nameBn", employee.motherNameBn);
      handleChange(index, "presentLocation", employee.presentLocation);
      handleChange(index, "permanentLocation", employee.presentLocation);
      handleChange(index, "presentAddress", employee.presentAddress);
      handleChange(index, "permanentAddress", employee.presentAddress);
    }
  };
  var isFirstDependentValid = useMemo(function () {
    var _normalizedDependents, _normalizedDependents2;
    return (normalizedDependents === null || normalizedDependents === void 0 || (_normalizedDependents = normalizedDependents[0]) === null || _normalizedDependents === void 0 ? void 0 : _normalizedDependents.nid) && (normalizedDependents === null || normalizedDependents === void 0 || (_normalizedDependents2 = normalizedDependents[0]) === null || _normalizedDependents2 === void 0 ? void 0 : _normalizedDependents2.nameEn);
  }, [normalizedDependents]);
  return /*#__PURE__*/React.createElement(Box$1, {
    mt: 1
  }, normalizedDependents === null || normalizedDependents === void 0 ? void 0 : normalizedDependents.map(function (dependent, index) {
    var _formdata$deceasedWor, _formdata$workforceEm, _formdata$metadata, _dependent$phoneNumbe, _dependents$index3, _dependents$index4, _dependents$index5, _dependents$index6, _dependents$index7, _dependents$index8, _dependents$index9, _dependents$index10;
    var isFatherSelected = normalizedDependents.find(function (d) {
      return d.relationType === "workforce.relation.father";
    });
    var previousRelation = index > 0 && isFatherSelected != null ? "workforce.relation.father" : null;
    var isVerified = isVerify();
    var workerBirthDate = isVerified ? formdata === null || formdata === void 0 || (_formdata$deceasedWor = formdata.deceasedWorkerInfo) === null || _formdata$deceasedWor === void 0 ? void 0 : _formdata$deceasedWor.birthDate : formdata === null || formdata === void 0 || (_formdata$workforceEm = formdata.workforceEmployee) === null || _formdata$workforceEm === void 0 ? void 0 : _formdata$workforceEm.birthDate;
    // const isEligible =dependent?.isEligible?dependent?.isEligible: getRelationForApi(normalizedDependents[index], workerBirthDate);
    var isEisFinancialAssistance = applicationType === "financialAssistance" && (formdata === null || formdata === void 0 ? void 0 : formdata.organizationType) === "eis";
    var targetDate = isEisFinancialAssistance ? formdata === null || formdata === void 0 || (_formdata$metadata = formdata.metadata) === null || _formdata$metadata === void 0 ? void 0 : _formdata$metadata.deathDate : undefined;
    var isEligible = getRelationForApi(normalizedDependents[index], workerBirthDate, targetDate);
    console.log("Single Beneficiary", dependent);
    console.log({
      isEligible: isEligible
    });
    var hasData = ((dependent === null || dependent === void 0 ? void 0 : dependent.relationType) || (dependent === null || dependent === void 0 ? void 0 : dependent.relationWithWorker)) && ((dependent === null || dependent === void 0 ? void 0 : dependent.birthDate) || (dependent === null || dependent === void 0 ? void 0 : dependent.nid));
    return /*#__PURE__*/React.createElement(Accordion, {
      key: index,
      expanded: expanded === index,
      onChange: function onChange(_, isExpanded) {
        return setExpanded(isExpanded ? index : false);
      }
    }, /*#__PURE__*/React.createElement(AccordionSummary, {
      expandIcon: /*#__PURE__*/React.createElement(ExpandMoreIcon, null)
    }, /*#__PURE__*/React.createElement(Grid, {
      container: true,
      spacing: 0,
      alignItems: "center",
      justifyContent: "space-between"
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 8,
      sm: 9
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "subtitle2",
      style: {
        fontWeight: "bold"
      }
    }, applicationType === "financialAssistance" && (formdata === null || formdata === void 0 ? void 0 : formdata.organizationType) !== "eis" ? /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.previewDetails.dependent",
      module: "workforce"
    }) : formdata.organizationType === "eis" ? /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.previewDetails.eis.dependent",
      module: "workforce"
    }) : isBlwfPath() ? /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.application.subHeader.dependent.blwf",
      module: "workforce"
    }) : /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.application.subHeader.dependent",
      module: "workforce"
    })), /*#__PURE__*/React.createElement(Typography, null, dependent.nameEn || "")), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 4,
      sm: 3,
      style: {
        textAlign: "right",
        paddingRight: "8px"
      }
    }, hasData && !isEligible && /*#__PURE__*/React.createElement(Typography, {
      variant: "caption",
      style: {
        fontWeight: "bold",
        color: isEligible ? "#2e7d32" : "#d32f2f",
        border: "1px solid ".concat(isEligible ? "#2e7d32" : "#d32f2f"),
        backgroundColor: isEligible ? "rgba(46, 125, 50, 0.04)" : "rgba(211, 47, 47, 0.04)",
        padding: "4px 8px",
        borderRadius: "4px",
        display: "inline-block"
      }
    }, !isEligible && /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.dependent.eis.inEligible"
    }))))), /*#__PURE__*/React.createElement(AccordionDetails, null, /*#__PURE__*/React.createElement(Paper, {
      className: classes.paper,
      elevation: 0
    }, /*#__PURE__*/React.createElement(Grid, {
      container: true,
      spacing: 2
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12
    }, /*#__PURE__*/React.createElement(RelationWithWorkerPicker, {
      id: "relationType",
      value: (dependent === null || dependent === void 0 ? void 0 : dependent.relationType) || (dependent === null || dependent === void 0 ? void 0 : dependent.relationWithWorker) || "",
      required: true,
      onChange: function onChange(v) {
        return onPickerChange(v, index);
      },
      readOnly: false,
      excludeRelation: previousRelation
    }), errors.relationType && /*#__PURE__*/React.createElement(FormHelperText, {
      error: true
    }, errors.relationType)), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 6
    }, /*#__PURE__*/React.createElement(TextInput, {
      id: "nameBn",
      label: getRelationAwareLabel(dependent, "workforce.employee.name.bn"),
      value: dependent.nameBn || "",
      formatInput: filterBangla,
      onChange: function onChange(v) {
        return handleChange(index, "nameBn", filterBangla(v));
      },
      required: true,
      error: !!errors.nameBn,
      helperText: errors.nameBn
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 6
    }, /*#__PURE__*/React.createElement(TextInput, {
      id: "nameEn",
      label: getRelationAwareLabel(dependent, "workforce.employee.name.en"),
      value: dependent.nameEn || "",
      formatInput: filterEnglish,
      onChange: function onChange(v) {
        return handleChange(index, "nameEn", filterEnglish(v));
      },
      required: true,
      error: !!errors.nameEn,
      helperText: errors.nameEn
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 6
    }, /*#__PURE__*/React.createElement(TextInput, {
      label: getRelationAwareLabel(dependent, "workforce.employee.fathers_name"),
      value: dependent.fatherNameEn || "",
      onChange: function onChange(v) {
        return handleChange(index, "fatherNameEn", v);
      }
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 6
    }, /*#__PURE__*/React.createElement(TextInput, {
      label: getRelationAwareLabel(dependent, "workforce.employee.mothers_name"),
      value: dependent.motherNameEn || "",
      onChange: function onChange(v) {
        return handleChange(index, "motherNameEn", v);
      }
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 6
    }, /*#__PURE__*/React.createElement(PublishedComponent, {
      pubRef: "workforce.DatePicker",
      label: getRelationAwareLabel(dependent, "workforce.employee.birthdate"),
      value: dependent.birthDate || "",
      required: true,
      onChange: function onChange(v) {
        return handleChange(index, "birthDate", v);
      }
    }), errors.rdmp && /*#__PURE__*/React.createElement(FormHelperText, {
      error: true
    }, /*#__PURE__*/React.createElement(FormattedMessage, {
      id: errors.rdmp
    }))), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 6
    }, /*#__PURE__*/React.createElement(TextInput, {
      id: "nid",
      label: getRelationAwareLabel(dependent, "workforce.application.employee.children.nidOrBirthRegistry"),
      value: dependent.nid || "",
      onChange: function onChange(v) {
        var numericValue = (v || "").replace(/\D/g, "").slice(0, 17);
        handleChange(index, "nid", numericValue);
      },
      formatInput: function formatInput(val) {
        return (val || "").toString().replace(/\D/g, "").slice(0, 17);
      },
      type: "text",
      inputProps: {
        inputMode: "numeric",
        pattern: "[0-9০-৯]*",
        maxLength: 17
      },
      required: true,
      error: !!errors.nid,
      helperText: errors.nid
    }), errors.nid && /*#__PURE__*/React.createElement(FormHelperText, {
      error: true
    }, /*#__PURE__*/React.createElement(FormattedMessage, {
      id: errors.nid
    }))), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 6
    }, /*#__PURE__*/React.createElement(TextInput, {
      label: getRelationAwareLabel(dependent, "workforce.employee.phone"),
      value: dependent.phoneNumber || "",
      onChange: function onChange(v) {
        return handleChange(index, "phoneNumber", v);
      },
      type: "number"
    }), (dependent === null || dependent === void 0 || (_dependent$phoneNumbe = dependent.phoneNumber) === null || _dependent$phoneNumbe === void 0 ? void 0 : _dependent$phoneNumbe.length) != 11 && /*#__PURE__*/React.createElement(FormHelperText, {
      error: true
    }, /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "core.error.phoneNumberLength"
    }))), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 6
    }, /*#__PURE__*/React.createElement(EmployeeMaritalStatusPicker, {
      id: "maritalStatus",
      value: (dependent === null || dependent === void 0 ? void 0 : dependent.maritalStatus) || "",
      label: /*#__PURE__*/React.createElement(FormattedMessage, {
        id: "workforce.employee.marital_status",
        module: "workforce"
      }),
      required: true,
      onChange: function onChange(v) {
        return handleChange(index, "maritalStatus", v);
      },
      readOnly: false
    }), errors.maritalStatus && /*#__PURE__*/React.createElement(FormHelperText, {
      error: true
    }, errors.maritalStatus)), (formdata === null || formdata === void 0 ? void 0 : formdata.organizationType) === "cf" && (formdata === null || formdata === void 0 ? void 0 : formdata.applicationType) === "financialAssistance" && /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 6
    }, /*#__PURE__*/React.createElement(TextInput, {
      id: "percentage_of_grant",
      label: (formdata === null || formdata === void 0 ? void 0 : formdata.organizationType) === "eis" ? formatMessage("workforce.employee.eis.percentage_of_cf_grant") : formatMessage("workforce.employee.percentage_of_cf_grant"),
      value: (dependent === null || dependent === void 0 ? void 0 : dependent.percentageOfCfGrant) || (dependent === null || dependent === void 0 ? void 0 : dependent.percentage_of_grant) || "",
      onChange: function onChange(v) {
        return handleChange(index, "percentage_of_grant", normalizeNumberInput(v));
      },
      required: true,
      error: !!errors.percentage_of_grant,
      helperText: errors.percentage_of_grant
    }), errors.percentage_of_grant && /*#__PURE__*/React.createElement(FormHelperText, {
      error: true
    }, /*#__PURE__*/React.createElement(FormattedMessage, {
      id: errors.percentage_of_grant
    }))), (formdata === null || formdata === void 0 ? void 0 : formdata.organizationType) === "eis" && (((dependent === null || dependent === void 0 ? void 0 : dependent.relationType) || (dependent === null || dependent === void 0 ? void 0 : dependent.relationWithWorker)) === "workforce.relation.son" || ((dependent === null || dependent === void 0 ? void 0 : dependent.relationType) || (dependent === null || dependent === void 0 ? void 0 : dependent.relationWithWorker)) === "workforce.relation.daughter") && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 6,
      className: classes.item
    }, /*#__PURE__*/React.createElement(FormControl, {
      component: "fieldset"
    }, /*#__PURE__*/React.createElement(FormLabel, null, /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.dependent.isDisabled",
      defaultMessage: "Is the dependent disabled?",
      module: "workforce"
    })), /*#__PURE__*/React.createElement(RadioGroup, {
      row: true,
      value: (dependent === null || dependent === void 0 ? void 0 : dependent.isDisabled) || "no",
      onChange: function onChange(e) {
        return handleChange(index, "isDisabled", e.target.value);
      },
      defaultValue: "no"
    }, /*#__PURE__*/React.createElement(FormControlLabel, {
      value: "yes",
      control: /*#__PURE__*/React.createElement(Radio, {
        color: "primary"
      }),
      label: /*#__PURE__*/React.createElement(FormattedMessage, {
        id: "workforce.application.permission.yes",
        module: "workforce"
      })
    }), /*#__PURE__*/React.createElement(FormControlLabel, {
      value: "no",
      control: /*#__PURE__*/React.createElement(Radio, {
        color: "primary"
      }),
      label: /*#__PURE__*/React.createElement(FormattedMessage, {
        id: "workforce.application.permission.no",
        module: "workforce"
      })
    })))), (dependent === null || dependent === void 0 ? void 0 : dependent.isDisabled) === "yes" && /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 6,
      className: classes.item
    }, /*#__PURE__*/React.createElement(TextInput, {
      id: "disabilityType",
      label: formatMessage("workforce.dependent.disabilityType") || "Describe disability",
      value: dependent.disabilityType || "",
      onChange: function onChange(v) {
        return handleChange(index, "disabilityType", v);
      },
      required: true,
      error: !!(errors !== null && errors !== void 0 && errors.disabilityType),
      helperText: errors === null || errors === void 0 ? void 0 : errors.disabilityType
    }))), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12
    }, /*#__PURE__*/React.createElement("b", null, formatMessage("workforce.employee.present_location")), /*#__PURE__*/React.createElement(PublishedComponent, {
      pubRef: "location.DetailedLocation",
      withNull: true,
      value: (dependents === null || dependents === void 0 || (_dependents$index3 = dependents[index]) === null || _dependents$index3 === void 0 ? void 0 : _dependents$index3.presentLocation) || null,
      onChange: function onChange(v) {
        return handleChange(index, "presentLocation", v);
      },
      required: true,
      split: true
    }), (errors === null || errors === void 0 ? void 0 : errors.detailedLocation) && /*#__PURE__*/React.createElement(FormHelperText, {
      error: true
    }, errors === null || errors === void 0 ? void 0 : errors.detailedLocation)), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12
    }, /*#__PURE__*/React.createElement(CustomDependentLocation, {
      location: dependents === null || dependents === void 0 || (_dependents$index4 = dependents[index]) === null || _dependents$index4 === void 0 ? void 0 : _dependents$index4.presentLocation,
      onChange: function onChange(key, value) {
        return handleChange(index, key, value);
      },
      addressKey: "presentAddress",
      data: dependents === null || dependents === void 0 || (_dependents$index5 = dependents[index]) === null || _dependents$index5 === void 0 ? void 0 : _dependents$index5.presentAddress,
      locationData: dependents === null || dependents === void 0 || (_dependents$index6 = dependents[index]) === null || _dependents$index6 === void 0 ? void 0 : _dependents$index6.presentLocation,
      errors: errors
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12
    }, /*#__PURE__*/React.createElement("b", null, formatMessage("workforce.employee.permanent_location")), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12
    }, /*#__PURE__*/React.createElement(FormControlLabel, {
      control: /*#__PURE__*/React.createElement(Checkbox, {
        color: "primary",
        checked: (sameAsPresent === null || sameAsPresent === void 0 ? void 0 : sameAsPresent[index]) || false,
        onChange: function onChange(e) {
          return handleCheckboxChange(index, e);
        }
      }),
      label: formatMessage("workforce.employee.sameAsPresent")
    })), /*#__PURE__*/React.createElement(PublishedComponent, {
      pubRef: "location.DetailedLocation",
      withNull: true,
      value: (dependents === null || dependents === void 0 || (_dependents$index7 = dependents[index]) === null || _dependents$index7 === void 0 ? void 0 : _dependents$index7.permanentLocation) || null,
      onChange: function onChange(v) {
        return handleChange(index, "permanentLocation", v);
      },
      readOnly: !!sameAsPresent[index],
      required: true,
      split: true
    }), (errors === null || errors === void 0 ? void 0 : errors.detailedLocation) && /*#__PURE__*/React.createElement(FormHelperText, {
      error: true
    }, errors === null || errors === void 0 ? void 0 : errors.detailedLocation)), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12
    }, /*#__PURE__*/React.createElement(CustomDependentLocation, {
      location: dependents === null || dependents === void 0 || (_dependents$index8 = dependents[index]) === null || _dependents$index8 === void 0 ? void 0 : _dependents$index8.permanentLocation,
      onChange: function onChange(key, value) {
        return handleChange(index, key, value);
      },
      addressKey: "permanentAddress",
      data: dependents === null || dependents === void 0 || (_dependents$index9 = dependents[index]) === null || _dependents$index9 === void 0 ? void 0 : _dependents$index9.permanentAddress,
      readOnly: !!sameAsPresent[index],
      locationData: dependents === null || dependents === void 0 || (_dependents$index10 = dependents[index]) === null || _dependents$index10 === void 0 ? void 0 : _dependents$index10.permanentLocation
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12
    }, /*#__PURE__*/React.createElement(EmployeeDetailsForm2, {
      errors: errors,
      handleChange: function handleChange(fieldKey, value) {
        return handleAttachmentChange(index, fieldKey, value);
      },
      formData: formdata,
      selectedApplicationType: applicationType,
      isDisabled: dependent === null || dependent === void 0 ? void 0 : dependent.isDisabled,
      formStepNo: "employeeDependentInfo",
      dependentIndex: index
    })), applicationType === "financialAssistance" && /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      className: classes.buttonContainer
    }, /*#__PURE__*/React.createElement(Button, {
      variant: "contained",
      style: {
        backgroundColor: applicationType !== "financialAssistance" || dependents.length === 1 ? "#B0B0B0" : "#d32f2f",
        color: "white"
      },
      onClick: function onClick() {
        return removeItem(index);
      },
      disabled: applicationType !== "financialAssistance" || dependents.length === 1
    }, /*#__PURE__*/React.createElement(FormattedMessage, {
      module: "workforce",
      id: "workforce.application.steps.skip"
    })))))));
  }), applicationType === "financialAssistance" && /*#__PURE__*/React.createElement(Button, {
    variant: "contained",
    color: "primary",
    onClick: addItem,
    disabled: !isFirstDependentValid
  }, isCfPath() || isBlwfPath() ? /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "workforce.application.steps.warishAdd",
    defaultMessage: "Add Nominee"
  }) : /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "workforce.application.steps.dependentAdd",
    defaultMessage: "Add New Dependent"
  })));
};

var OTHER_ID$1 = "OTHER_OPTION";
var DiseaseMultiSelectPicker = function DiseaseMultiSelectPicker(_ref) {
  var id = _ref.id,
    _ref$selectedDiseases = _ref.selectedDiseases,
    selectedDiseases = _ref$selectedDiseases === void 0 ? [] : _ref$selectedDiseases,
    onChange = _ref.onChange,
    onOtherDiseaseChange = _ref.onOtherDiseaseChange,
    required = _ref.required,
    otherDiseaseValue = _ref.otherDiseaseValue,
    handleChange = _ref.handleChange;
  var dispatch = useDispatch();
  var modulesManager = useModulesManager();
  var selectRef = useRef(null);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    open = _useState2[0],
    setOpen = _useState2[1];
  useEffect(function () {
    dispatch(fetchDiseases(modulesManager, ""));
  }, [dispatch, modulesManager]);
  var diseaseList = useSelector(function (state) {
    var _state$workforce$dise;
    return (_state$workforce$dise = state.workforce["diseases"]) !== null && _state$workforce$dise !== void 0 ? _state$workforce$dise : [];
  });
  var handleSelectChange = function handleSelectChange(event) {
    var selectedIds = Array.from(new Set(event.target.value));
    var selectedObjects = selectedIds.map(function (id) {
      if (id === OTHER_ID$1) {
        return {
          id: OTHER_ID$1,
          diseaseName: "অন্যান্য"
        };
      }
      return diseaseList.find(function (d) {
        return d.id === id;
      }) || {
        id: id
      };
    });
    onChange(selectedObjects);
    var totalAmount = selectedObjects.filter(function (d) {
      return d.id !== OTHER_ID$1;
    }).map(function (d) {
      return d.minimumDonationAmount || 0;
    }).reduce(function (sum, val) {
      return sum + val;
    }, 0);
    if (handleChange) {
      handleChange("grantAmount", totalAmount);
    }
  };
  var handleClose = function handleClose() {
    setOpen(false); // Manually close the menu
  };
  var handleOpen = function handleOpen() {
    setOpen(true); // Manually open the menu
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FormControl, {
    fullWidth: true
  }, /*#__PURE__*/React.createElement(InputLabel, {
    required: true
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "workforce.application.disease.name",
    defaultMessage: "\u09B0\u09CB\u0997\u09C7\u09B0 \u09A8\u09BE\u09AE",
    module: "workforce"
  })), /*#__PURE__*/React.createElement(Select, {
    ref: selectRef,
    open: open // Controlled state
    ,
    onOpen: handleOpen // Sync state when opened
    ,
    onClose: handleClose,
    multiple: true,
    value: selectedDiseases.map(function (d) {
      return d.id;
    }),
    onChange: handleSelectChange,
    renderValue: function renderValue(selectedIds) {
      return selectedIds.map(function (id) {
        if (id === OTHER_ID$1) return "অন্যান্য";
        var match = diseaseList.find(function (d) {
          return d.id === id;
        });
        return match ? match.diseaseName : id;
      }).join(", ");
    },
    required: required,
    inputProps: {
      id: id
    },
    MenuProps: {
      PaperProps: {
        style: {
          maxHeight: 450,
          width: 360,
          marginTop: 8
        }
      },
      anchorOrigin: {
        vertical: "bottom",
        horizontal: "left"
      },
      transformOrigin: {
        vertical: "top",
        horizontal: "left"
      },
      getContentAnchorEl: null
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      position: "sticky",
      top: 0,
      backgroundColor: "white",
      zIndex: 20,
      display: "flex",
      justifyContent: "flex-end",
      padding: "4px 8px",
      borderBottom: "1px solid #eee"
    }
  }, /*#__PURE__*/React.createElement(IconButton, {
    size: "small",
    onClick: function onClick(e) {
      e.stopPropagation();
      handleClose();
    }
  }, /*#__PURE__*/React.createElement(CloseIcon, {
    fontSize: "small"
  }))), diseaseList.map(function (disease) {
    return /*#__PURE__*/React.createElement(MenuItem, {
      key: disease.id,
      value: disease.id,
      dense: true
    }, /*#__PURE__*/React.createElement(Checkbox, {
      checked: selectedDiseases.some(function (d) {
        return d.id === disease.id;
      }),
      color: "primary"
    }), /*#__PURE__*/React.createElement(ListItemText, {
      primary: disease.diseaseName
    }));
  }), /*#__PURE__*/React.createElement(MenuItem, {
    key: OTHER_ID$1,
    value: OTHER_ID$1,
    dense: true
  }, /*#__PURE__*/React.createElement(Checkbox, {
    checked: selectedDiseases.some(function (d) {
      return d.id === OTHER_ID$1;
    }),
    color: "primary"
  }), /*#__PURE__*/React.createElement(ListItemText, {
    primary: "\u0985\u09A8\u09CD\u09AF\u09BE\u09A8\u09CD\u09AF"
  })))), selectedDiseases.some(function (d) {
    return d.id === OTHER_ID$1;
  }) && /*#__PURE__*/React.createElement(TextField, {
    fullWidth: true,
    label: "\u0985\u09A8\u09CD\u09AF\u09BE\u09A8\u09CD\u09AF \u09B0\u09CB\u0997 \u09A8\u09BF\u09B0\u09CD\u09A6\u09BF\u09B7\u09CD\u099F \u0995\u09B0\u09C1\u09A8",
    value: otherDiseaseValue || "",
    onChange: function onChange(e) {
      return onOtherDiseaseChange(e.target.value);
    },
    margin: "normal"
  }));
};

function ownKeys$15(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$15(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$15(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$15(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

// Bangla digit mapping
var banglaDigits = ["০", "১", "২", "৩", "৪", "৫", "৬", "৭", "৮", "৯"];
var toBanglaDigit = function toBanglaDigit(number) {
  return number.toString().split("").map(function (d) {
    return banglaDigits[d] || d;
  }).join("");
};
var useStyles$1t = makeStyles$2(function (theme) {
  return {
    formControl: {
      minWidth: 80,
      marginRight: theme.spacing(1)
    },
    label: {
      fontSize: "13px",
      color: "#0e6c6f",
      fontWeight: 500,
      marginBottom: "4px"
    }
  };
});
var CustomTimePicker = function CustomTimePicker(_ref) {
  _ref.id;
    var _ref$label = _ref.label,
    label = _ref$label === void 0 ? "সময়" : _ref$label,
    value = _ref.value,
    onChange = _ref.onChange;
  var classes = useStyles$1t();
  var language = useSelector(function (state) {
    var _state$core$user$i_us, _state$core;
    return (_state$core$user$i_us = state === null || state === void 0 || (_state$core = state.core) === null || _state$core === void 0 || (_state$core = _state$core.user) === null || _state$core === void 0 || (_state$core = _state$core.i_user) === null || _state$core === void 0 ? void 0 : _state$core.language) !== null && _state$core$user$i_us !== void 0 ? _state$core$user$i_us : "en";
  });
  var parseTime = function parseTime() {
    if (!value) return {
      hour: "",
      minute: "",
      period: ""
    };
    var _value$split = value.split(" "),
      _value$split2 = _slicedToArray(_value$split, 2),
      t = _value$split2[0],
      p = _value$split2[1];
    var _t$split = t.split(":"),
      _t$split2 = _slicedToArray(_t$split, 2),
      h = _t$split2[0],
      m = _t$split2[1];
    return {
      hour: h,
      minute: m,
      period: p || "AM"
    };
  };
  var _useState = useState(parseTime()),
    _useState2 = _slicedToArray(_useState, 2),
    time = _useState2[0],
    setTime = _useState2[1];
  useEffect(function () {
    if (time.hour && time.minute && time.period) {
      onChange("".concat(time.hour, ":").concat(time.minute, " ").concat(time.period));
    }
  }, [time]);

  // Dynamically format hours/minutes based on language
  var displayHours = useMemo(function () {
    return Array.from({
      length: 12
    }, function (_, i) {
      var val = String(i + 1).padStart(2, "0");
      return {
        value: val,
        label: language === "fr" ? toBanglaDigit(val) : val
      };
    });
  }, [language]);
  var displayMinutes = useMemo(function () {
    return Array.from({
      length: 60
    }, function (_, i) {
      var val = String(i).padStart(2, "0");
      return {
        value: val,
        label: language === "fr" ? toBanglaDigit(val) : val
      };
    });
  }, [language]);
  var handleChange = function handleChange(key) {
    return function (event) {
      setTime(function (prev) {
        return _objectSpread$15(_objectSpread$15({}, prev), {}, _defineProperty({}, key, event.target.value));
      });
    };
  };
  return /*#__PURE__*/React.createElement("div", null, label && /*#__PURE__*/React.createElement(Typography, {
    className: classes.label
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: label
  })), /*#__PURE__*/React.createElement(Grid, {
    container: true,
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(FormControl, {
    className: classes.formControl
  }, /*#__PURE__*/React.createElement(Select, {
    value: time.hour,
    onChange: handleChange("hour"),
    inputProps: {
      'aria-label': 'Without label'
    },
    displayEmpty: true
  }, /*#__PURE__*/React.createElement(MenuItem, {
    value: "",
    disabled: true
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.timePicker.hour"
  })), displayHours.map(function (h) {
    return /*#__PURE__*/React.createElement(MenuItem, {
      key: h.value,
      value: h.value
    }, h.label);
  })), /*#__PURE__*/React.createElement(FormHelperText, null, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.timePicker.hour"
  }))), /*#__PURE__*/React.createElement(FormControl, {
    className: classes.formControl
  }, /*#__PURE__*/React.createElement(Select, {
    value: time.minute,
    inputProps: {
      'aria-label': 'Without label'
    },
    displayEmpty: true,
    onChange: handleChange("minute")
  }, /*#__PURE__*/React.createElement(MenuItem, {
    value: "",
    disabled: true
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.timePicker.minute"
  })), displayMinutes.map(function (m) {
    return /*#__PURE__*/React.createElement(MenuItem, {
      key: m.value,
      value: m.value
    }, m.label);
  })), /*#__PURE__*/React.createElement(FormHelperText, null, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.timePicker.minute"
  }))), /*#__PURE__*/React.createElement(FormControl, {
    className: classes.formControl
  }, /*#__PURE__*/React.createElement(Select, {
    value: time.period,
    onChange: handleChange("period"),
    inputProps: {
      'aria-label': 'Without label'
    },
    displayEmpty: true
  }, /*#__PURE__*/React.createElement(MenuItem, {
    value: "",
    disabled: true
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "AM/PM"
  })), /*#__PURE__*/React.createElement(MenuItem, {
    value: "AM"
  }, "AM"), /*#__PURE__*/React.createElement(MenuItem, {
    value: "PM"
  }, "PM")), /*#__PURE__*/React.createElement(FormHelperText, null, "AM/PM"))));
};

var useStyles$1s = makeStyles(function (theme) {
  return {
    paper: {
      padding: theme.spacing(2)
    },
    item: {
      marginBottom: theme.spacing(2)
    },
    title: {
      fontWeight: 800
    }
  };
});
var EmployeeAccidentInfoForm = function EmployeeAccidentInfoForm(_ref) {
  var _formData$employeeAcc, _formData$employeeAcc2, _formData$employeeAcc3, _formData$employeeAcc4, _formData$employeeAcc5, _formData$employeeAcc8, _formData$employeeAcc9, _formData$employeeAcc10, _formData$employeeAcc11, _formData$employeeAcc12, _formData$employeeAcc13, _formData$employeeAcc14, _formData$employeeAcc15, _formData$employeeAcc16, _formData$employeeAcc17, _formData$employeeAcc18, _formData$employeeAcc19, _formData$employeeAcc20, _formData$employeeAcc21, _formData$employeeAcc22, _formData$employeeAcc23, _formData$employeeAcc24, _formData$employeeAcc25, _formData$employeeAcc26, _formData$employeeAcc27, _formData$employeeAcc28, _formData$employeeAcc29, _formData$employeeAcc30, _formData$employeeAcc31, _formData$employeeAcc32, _formData$employeeAcc33, _formData$employeeAcc34, _formData$employeeAcc35;
  var _handleChange = _ref.handleChange,
    formData = _ref.formData;
    _ref.setFormData;
    var applicationType = _ref.applicationType,
    errors = _ref.errors;
  var classes = useStyles$1s();
  var modulesManager = useModulesManager();
  var _useTranslations = useTranslations("core.RegistrationPage", modulesManager);
    _useTranslations.formatMessage;
  var _useState = useState((formData === null || formData === void 0 || (_formData$employeeAcc = formData.employeeAccidentInfo) === null || _formData$employeeAcc === void 0 ? void 0 : _formData$employeeAcc.aidReasonType) || ((formData === null || formData === void 0 ? void 0 : formData.applicationType) === "disabilityAssistance" || (formData === null || formData === void 0 ? void 0 : formData.organizationType) === "eis" ? "accident" : "disease")),
    _useState2 = _slicedToArray(_useState, 2),
    aidReasonType = _useState2[0],
    setAidReasonType = _useState2[1];
  var _useState3 = useState((formData === null || formData === void 0 || (_formData$employeeAcc2 = formData.employeeAccidentInfo) === null || _formData$employeeAcc2 === void 0 ? void 0 : _formData$employeeAcc2.cronicDiseaseType) || []),
    _useState4 = _slicedToArray(_useState3, 2),
    selectedDiseases = _useState4[0];
    _useState4[1];
  var _useState5 = useState((formData === null || formData === void 0 || (_formData$employeeAcc3 = formData.employeeAccidentInfo) === null || _formData$employeeAcc3 === void 0 ? void 0 : _formData$employeeAcc3.admitted) || "no"),
    _useState6 = _slicedToArray(_useState5, 2),
    isAdmitted = _useState6[0],
    setIsAdmitted = _useState6[1];
  var _useState7 = useState((formData === null || formData === void 0 || (_formData$employeeAcc4 = formData.employeeAccidentInfo) === null || _formData$employeeAcc4 === void 0 ? void 0 : _formData$employeeAcc4.disAbilityEffect) || "no"),
    _useState8 = _slicedToArray(_useState7, 2),
    disAbilityEffect = _useState8[0],
    setDisAbilityEffect = _useState8[1];
  var _useState9 = useState((formData === null || formData === void 0 || (_formData$employeeAcc5 = formData.employeeAccidentInfo) === null || _formData$employeeAcc5 === void 0 ? void 0 : _formData$employeeAcc5.hasRejoined) || "no"),
    _useState10 = _slicedToArray(_useState9, 2),
    hasRejoined = _useState10[0],
    setHasRejoined = _useState10[1];
  useEffect(function () {
    var _formData$employeeAcc6, _formData$employeeAcc7;
    if (!(formData !== null && formData !== void 0 && (_formData$employeeAcc6 = formData.employeeAccidentInfo) !== null && _formData$employeeAcc6 !== void 0 && _formData$employeeAcc6.aidReasonType)) {
      _handleChange("aidReasonType", aidReasonType);
    }
    if (!(formData !== null && formData !== void 0 && (_formData$employeeAcc7 = formData.employeeAccidentInfo) !== null && _formData$employeeAcc7 !== void 0 && _formData$employeeAcc7.admitted)) {
      _handleChange("admitted", isAdmitted);
    }
  }, []);
  var handleOptionChange = function handleOptionChange(event) {
    var newValue = event.target.value;
    setAidReasonType(newValue);
    _handleChange("aidReasonType", newValue);
  };
  var handleHasRejoinedChange = function handleHasRejoinedChange(event) {
    var value = event.target.value;
    setHasRejoined(value);
    _handleChange("hasRejoined", value, "employeeAccidentInfo");
  };
  var handleAdmittedChange = function handleAdmittedChange(event) {
    var value = event.target.value;
    setIsAdmitted(value);
    _handleChange("admitted", value);
  };
  var handleDisabilityEffect = function handleDisabilityEffect(event) {
    var value = event.target.value;
    setDisAbilityEffect(value);
    _handleChange("disabilityEffect", value);
  };
  return /*#__PURE__*/React.createElement(Box$1, {
    mt: 2
  }, /*#__PURE__*/React.createElement(Paper, {
    className: classes.paper,
    elevation: 0
  }, /*#__PURE__*/React.createElement(Typography, {
    mb: 4,
    style: {
      textAlign: "center",
      fontWeight: "bold",
      fontSize: "small",
      margin: "15px"
    }
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "workforce.application.steps.treatment.info",
    module: "workforce"
  })), /*#__PURE__*/React.createElement(Typography, {
    variant: "h6",
    gutterBottom: true
  }, applicationType === "disabilityAssistance" ? /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "workforce.application.disabilityDetails"
  }) : /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "workforce.employee.accident.info.title"
  })), ((formData === null || formData === void 0 ? void 0 : formData.applicationType) !== "disabilityAssistance" || (formData === null || formData === void 0 ? void 0 : formData.organizationType) === "eis") && /*#__PURE__*/React.createElement(RadioGroup, {
    column: true,
    value: (formData === null || formData === void 0 || (_formData$employeeAcc8 = formData.employeeAccidentInfo) === null || _formData$employeeAcc8 === void 0 ? void 0 : _formData$employeeAcc8.aidReasonType) || aidReasonType || "disease",
    onChange: handleOptionChange
  }, /*#__PURE__*/React.createElement(FormControlLabel, {
    value: "disease",
    control: /*#__PURE__*/React.createElement(Radio, {
      color: "primary"
    }),
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.employee.aid.reason.info.cronic"
    })
  }), /*#__PURE__*/React.createElement(FormControlLabel, {
    value: "accident",
    control: /*#__PURE__*/React.createElement(Radio, {
      color: "primary"
    }),
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.employee.aid.reason.info.accident"
    })
  })), /*#__PURE__*/React.createElement(Divider, {
    style: {
      margin: "16px 0"
    }
  }), aidReasonType === "disease" && /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 1
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6,
    className: classes.item
  }, /*#__PURE__*/React.createElement(DiseaseMultiSelectPicker, {
    id: "cronicDiseaseType",
    selectedDiseases: (formData === null || formData === void 0 || (_formData$employeeAcc9 = formData.employeeAccidentInfo) === null || _formData$employeeAcc9 === void 0 ? void 0 : _formData$employeeAcc9.cronicDiseaseType) || [],
    onChange: function onChange(value) {
      return _handleChange("cronicDiseaseType", value, "employeeAccidentInfo");
    },
    onOtherDiseaseChange: function onOtherDiseaseChange(value) {
      return _handleChange("otherDisease", value, "employeeAccidentInfo");
    },
    otherDiseaseValue: (formData === null || formData === void 0 || (_formData$employeeAcc10 = formData.employeeAccidentInfo) === null || _formData$employeeAcc10 === void 0 ? void 0 : _formData$employeeAcc10.otherDisease) || "",
    handleChange: function handleChange(key, value) {
      return _handleChange(key, value, null);
    },
    required: true
  }), (errors === null || errors === void 0 ? void 0 : errors.cronicDiseaseType) && /*#__PURE__*/React.createElement(FormHelperText, {
    error: true
  }, errors === null || errors === void 0 ? void 0 : errors.cronicDiseaseType)), selectedDiseases.includes("অন্যান্য") && /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6,
    className: classes.item
  }, /*#__PURE__*/React.createElement(TextInput, {
    label: "workforce.application.accident.otherDieses",
    value: (formData === null || formData === void 0 || (_formData$employeeAcc11 = formData.employeeAccidentInfo) === null || _formData$employeeAcc11 === void 0 ? void 0 : _formData$employeeAcc11.otherDisease) || "",
    onChange: function onChange(v) {
      return _handleChange("cronicDiseaseType", v);
    }
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6,
    className: classes.item
  }, /*#__PURE__*/React.createElement(PublishedComponent, {
    pubRef: "workforce.DatePicker",
    label: "workforce.application.accident.dateOfDiagnosis",
    value: (formData === null || formData === void 0 || (_formData$employeeAcc12 = formData.employeeAccidentInfo) === null || _formData$employeeAcc12 === void 0 ? void 0 : _formData$employeeAcc12.diagnosisDate) || "",
    onChange: function onChange(v) {
      return _handleChange("diagnosisDate", v);
    },
    readOnly: false,
    required: true
  }), (errors === null || errors === void 0 ? void 0 : errors.rdmp) && /*#__PURE__*/React.createElement(FormHelperText, {
    error: true
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: errors === null || errors === void 0 ? void 0 : errors.rdmp
  }))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6,
    className: classes.item
  }, /*#__PURE__*/React.createElement(TextInput, {
    label: "workforce.employee.accident.info.doctorName",
    value: (formData === null || formData === void 0 || (_formData$employeeAcc13 = formData.employeeAccidentInfo) === null || _formData$employeeAcc13 === void 0 ? void 0 : _formData$employeeAcc13.doctorName) || "",
    onChange: function onChange(v) {
      return _handleChange("doctorName", v);
    }
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6,
    className: classes.item
  }, /*#__PURE__*/React.createElement(PublishedComponent, {
    pubRef: "workforce.DatePicker",
    label: "workforce.application.accident.dateOfLastCheckup",
    value: (formData === null || formData === void 0 || (_formData$employeeAcc14 = formData.employeeAccidentInfo) === null || _formData$employeeAcc14 === void 0 ? void 0 : _formData$employeeAcc14.lastCheckupDate) || "",
    onChange: function onChange(v) {
      return _handleChange("lastCheckupDate", v);
    },
    readOnly: false,
    required: true
  }), (errors === null || errors === void 0 ? void 0 : errors.rdmp) && /*#__PURE__*/React.createElement(FormHelperText, {
    error: true
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: errors === null || errors === void 0 ? void 0 : errors.rdmp
  }))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    className: classes.item
  }, /*#__PURE__*/React.createElement(FormControl, {
    component: "fieldset"
  }, /*#__PURE__*/React.createElement(FormLabel, null, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "workforce.application.accident.hospitalized",
    defaultMessage: "\u09B9\u09BE\u09B8\u09AA\u09BE\u09A4\u09BE\u09B2\u09C7 \u09AD\u09B0\u09CD\u09A4\u09BF \u09B9\u09AF\u09BC\u09C7\u099B\u09BF\u09B2\u09C7\u09A8?",
    module: "workforce"
  })), /*#__PURE__*/React.createElement(RadioGroup, {
    row: true,
    value: isAdmitted,
    onChange: handleAdmittedChange
  }, /*#__PURE__*/React.createElement(FormControlLabel, {
    value: "yes",
    control: /*#__PURE__*/React.createElement(Radio, {
      color: "primary"
    }),
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.application.permission.yes",
      module: "workforce"
    })
  }), /*#__PURE__*/React.createElement(FormControlLabel, {
    value: "no",
    control: /*#__PURE__*/React.createElement(Radio, {
      color: "primary"
    }),
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.application.permission.no",
      module: "workforce"
    })
  })))), isAdmitted === "yes" && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6,
    className: classes.item
  }, /*#__PURE__*/React.createElement(TextInput, {
    id: "hospitalName",
    label: "workforce.employee.accident.info.hospitalName",
    value: (formData === null || formData === void 0 || (_formData$employeeAcc15 = formData.employeeAccidentInfo) === null || _formData$employeeAcc15 === void 0 ? void 0 : _formData$employeeAcc15.hospitalName) || "",
    onChange: function onChange(v) {
      return _handleChange("hospitalName", v);
    },
    required: true,
    error: !!(errors !== null && errors !== void 0 && errors.hospitalName),
    helperText: errors === null || errors === void 0 ? void 0 : errors.hospitalName
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6,
    className: classes.item
  }, /*#__PURE__*/React.createElement(PublishedComponent, {
    pubRef: "workforce.DatePicker",
    label: "workforce.employee.accident.info.admitDate",
    value: (formData === null || formData === void 0 || (_formData$employeeAcc16 = formData.employeeAccidentInfo) === null || _formData$employeeAcc16 === void 0 ? void 0 : _formData$employeeAcc16.admitDate) || "",
    onChange: function onChange(v) {
      return _handleChange("admitDate", v);
    },
    readOnly: false,
    required: true
  }), (errors === null || errors === void 0 ? void 0 : errors.rdmp) && /*#__PURE__*/React.createElement(FormHelperText, {
    error: true
  }, errors === null || errors === void 0 ? void 0 : errors.rdmp)), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6,
    className: classes.item
  }, /*#__PURE__*/React.createElement(PublishedComponent, {
    pubRef: "workforce.DatePicker",
    label: "workforce.employee.accident.info.releaseDate",
    value: (formData === null || formData === void 0 || (_formData$employeeAcc17 = formData.employeeAccidentInfo) === null || _formData$employeeAcc17 === void 0 ? void 0 : _formData$employeeAcc17.releaseDate) || "",
    onChange: function onChange(v) {
      return _handleChange("releaseDate", v);
    },
    readOnly: false,
    required: true
  }), (errors === null || errors === void 0 ? void 0 : errors.rdmp) && /*#__PURE__*/React.createElement(FormHelperText, {
    error: true
  }, errors === null || errors === void 0 ? void 0 : errors.rdmp)), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6,
    className: classes.item
  }, /*#__PURE__*/React.createElement(TextInput, {
    label: "workforce.employee.accident.info.doctorName",
    value: (formData === null || formData === void 0 || (_formData$employeeAcc18 = formData.employeeAccidentInfo) === null || _formData$employeeAcc18 === void 0 ? void 0 : _formData$employeeAcc18.hospitalDoctorName) || "",
    onChange: function onChange(v) {
      return _handleChange("hospitalDoctorName", v);
    }
  })))), aidReasonType === "accident" && /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 2
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6,
    className: classes.item
  }, /*#__PURE__*/React.createElement(EmployeeAccidentTypePicker$1, {
    id: "accidentType",
    value: (formData === null || formData === void 0 || (_formData$employeeAcc19 = formData.employeeAccidentInfo) === null || _formData$employeeAcc19 === void 0 ? void 0 : _formData$employeeAcc19.accidentType) || "",
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.employee.accident.info.typeOfAccident",
      module: "workforce"
    }),
    required: true,
    onChange: function onChange(v) {
      return _handleChange("accidentType", v);
    },
    readOnly: false
  }), (errors === null || errors === void 0 ? void 0 : errors.accidentType) && /*#__PURE__*/React.createElement(FormHelperText, {
    error: true
  }, errors === null || errors === void 0 ? void 0 : errors.accidentType)), (formData === null || formData === void 0 || (_formData$employeeAcc20 = formData.employeeAccidentInfo) === null || _formData$employeeAcc20 === void 0 ? void 0 : _formData$employeeAcc20.accidentType) === "workforce.accident.type.others" && /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6,
    className: classes.item
  }, /*#__PURE__*/React.createElement(TextInput, {
    id: "otherAccidentType",
    label: "workforce.application.accident.otherAccidentType",
    value: (formData === null || formData === void 0 || (_formData$employeeAcc21 = formData.employeeAccidentInfo) === null || _formData$employeeAcc21 === void 0 ? void 0 : _formData$employeeAcc21.otherAccidentType) || "",
    required: true,
    onChange: function onChange(v) {
      return _handleChange("otherAccidentType", v);
    },
    error: !!(errors !== null && errors !== void 0 && errors.otherAccidentType),
    helperText: !!(errors !== null && errors !== void 0 && errors.otherAccidentType)
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6,
    className: classes.item
  }, /*#__PURE__*/React.createElement(TextInput, {
    id: "accidentPlace",
    label: "workforce.application.accident.accidentPlace",
    value: (formData === null || formData === void 0 || (_formData$employeeAcc22 = formData.employeeAccidentInfo) === null || _formData$employeeAcc22 === void 0 ? void 0 : _formData$employeeAcc22.accidentPlace) || "",
    onChange: function onChange(v) {
      return _handleChange("accidentPlace", v);
    },
    required: true,
    error: !!(errors !== null && errors !== void 0 && errors.accidentPlace),
    helperText: errors === null || errors === void 0 ? void 0 : errors.accidentPlace
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6,
    className: classes.item
  }, /*#__PURE__*/React.createElement(PublishedComponent, {
    pubRef: "workforce.DatePicker",
    label: "workforce.employee.accident.info.dateOfAccident",
    value: (formData === null || formData === void 0 || (_formData$employeeAcc23 = formData.employeeAccidentInfo) === null || _formData$employeeAcc23 === void 0 ? void 0 : _formData$employeeAcc23.accidentDate) || "",
    onChange: function onChange(v) {
      return _handleChange("accidentDate", v);
    },
    readOnly: false,
    required: true
  }), (errors === null || errors === void 0 ? void 0 : errors.accidentDate) && /*#__PURE__*/React.createElement(FormHelperText, {
    error: true
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: errors === null || errors === void 0 ? void 0 : errors.accidentDate
  }))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6,
    className: classes.item
  }, /*#__PURE__*/React.createElement(CustomTimePicker, {
    label: "workforce.employee.accident.info.timeOfAccident",
    value: (formData === null || formData === void 0 || (_formData$employeeAcc24 = formData.employeeAccidentInfo) === null || _formData$employeeAcc24 === void 0 ? void 0 : _formData$employeeAcc24.accidentTime) || "",
    onChange: function onChange(value) {
      return _handleChange("accidentTime", value);
    }
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6,
    className: classes.item
  }, /*#__PURE__*/React.createElement(EmployeeInsideOutsideFactoryPicker$1, {
    id: "inOutsideFactory",
    value: (formData === null || formData === void 0 || (_formData$employeeAcc25 = formData.employeeAccidentInfo) === null || _formData$employeeAcc25 === void 0 ? void 0 : _formData$employeeAcc25.inOutsideFactory) || "",
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.employee.accident.info.insideOutsideFactory",
      module: "workforce"
    }),
    required: true,
    onChange: function onChange(v) {
      return _handleChange("inOutsideFactory", v);
    },
    readOnly: false
  }), (errors === null || errors === void 0 ? void 0 : errors.inOutsideFactory) && /*#__PURE__*/React.createElement(FormHelperText, {
    error: true
  }, errors === null || errors === void 0 ? void 0 : errors.inOutsideFactory)), !isBlwfPath() && /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    className: classes.item
  }, /*#__PURE__*/React.createElement(FormControl, {
    component: "fieldset"
  }, /*#__PURE__*/React.createElement(FormLabel, null, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "workforce.employee.accident.info.hasRejoined",
    defaultMessage: "\u0986\u09AA\u09A8\u09BF \u0995\u09BF \u09B8\u09C1\u09B8\u09CD\u09A5 \u09B9\u0993\u09DF\u09BE\u09B0 \u09AA\u09B0\u09C7 \u09AA\u09C1\u09A8\u09B0\u09BE\u09DF \u0995\u09B0\u09CD\u09AE\u09B8\u09CD\u09A5\u09B2\u09C7 \u09AF\u09CB\u0997\u09A6\u09BE\u09A8 \u0995\u09B0\u09C7\u099B\u09C7\u09A8?",
    module: "workforce"
  })), /*#__PURE__*/React.createElement(RadioGroup, {
    row: true,
    value: hasRejoined,
    onChange: handleHasRejoinedChange
  }, /*#__PURE__*/React.createElement(FormControlLabel, {
    value: "yes",
    control: /*#__PURE__*/React.createElement(Radio, {
      color: "primary"
    }),
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.application.permission.yes",
      module: "workforce"
    })
  }), /*#__PURE__*/React.createElement(FormControlLabel, {
    value: "no",
    control: /*#__PURE__*/React.createElement(Radio, {
      color: "primary"
    }),
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.application.permission.no",
      module: "workforce"
    })
  })))), hasRejoined === "yes" && /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6,
    className: classes.item
  }, /*#__PURE__*/React.createElement(PublishedComponent, {
    pubRef: "workforce.DatePicker",
    label: "workforce.employee.accident.info.reJoiningDate",
    value: (formData === null || formData === void 0 || (_formData$employeeAcc26 = formData.employeeAccidentInfo) === null || _formData$employeeAcc26 === void 0 ? void 0 : _formData$employeeAcc26.reJoiningDate) || "",
    onChange: function onChange(v) {
      return _handleChange("reJoiningDate", v);
    },
    readOnly: false
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    className: classes.item
  }, /*#__PURE__*/React.createElement(FormControl, {
    component: "fieldset"
  }, /*#__PURE__*/React.createElement(FormLabel, null, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "workforce.application.accident.hospitalized",
    defaultMessage: "\u09B9\u09BE\u09B8\u09AA\u09BE\u09A4\u09BE\u09B2\u09C7 \u09AD\u09B0\u09CD\u09A4\u09BF \u09B9\u09AF\u09BC\u09C7\u099B\u09BF\u09B2\u09C7\u09A8?",
    module: "workforce"
  })), /*#__PURE__*/React.createElement(RadioGroup, {
    row: true,
    value: isAdmitted,
    onChange: handleAdmittedChange
  }, /*#__PURE__*/React.createElement(FormControlLabel, {
    value: "yes",
    control: /*#__PURE__*/React.createElement(Radio, {
      color: "primary"
    }),
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.application.permission.yes",
      module: "workforce"
    })
  }), /*#__PURE__*/React.createElement(FormControlLabel, {
    value: "no",
    control: /*#__PURE__*/React.createElement(Radio, {
      color: "primary"
    }),
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.application.permission.no",
      module: "workforce"
    })
  })))), isAdmitted === "yes" && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6,
    className: classes.item
  }, /*#__PURE__*/React.createElement(TextInput, {
    label: "workforce.employee.accident.info.hospitalName",
    value: (formData === null || formData === void 0 || (_formData$employeeAcc27 = formData.employeeAccidentInfo) === null || _formData$employeeAcc27 === void 0 ? void 0 : _formData$employeeAcc27.hospitalName) || "",
    onChange: function onChange(v) {
      return _handleChange("hospitalName", v);
    }
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6,
    className: classes.item
  }, /*#__PURE__*/React.createElement(PublishedComponent, {
    pubRef: "workforce.DatePicker",
    label: "workforce.employee.accident.info.admitDate",
    value: (formData === null || formData === void 0 || (_formData$employeeAcc28 = formData.employeeAccidentInfo) === null || _formData$employeeAcc28 === void 0 ? void 0 : _formData$employeeAcc28.admitDate) || "",
    onChange: function onChange(v) {
      return _handleChange("admitDate", v);
    },
    readOnly: false
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6,
    className: classes.item
  }, /*#__PURE__*/React.createElement(PublishedComponent, {
    pubRef: "workforce.DatePicker",
    label: "workforce.employee.accident.info.releaseDate",
    value: (formData === null || formData === void 0 || (_formData$employeeAcc29 = formData.employeeAccidentInfo) === null || _formData$employeeAcc29 === void 0 ? void 0 : _formData$employeeAcc29.releaseDate) || "",
    onChange: function onChange(v) {
      return _handleChange("releaseDate", v);
    },
    readOnly: false
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6,
    className: classes.item
  }, /*#__PURE__*/React.createElement(TextInput, {
    label: "workforce.employee.accident.info.doctorName",
    value: (formData === null || formData === void 0 || (_formData$employeeAcc30 = formData.employeeAccidentInfo) === null || _formData$employeeAcc30 === void 0 ? void 0 : _formData$employeeAcc30.hospitalDoctorName) || "",
    onChange: function onChange(v) {
      return _handleChange("hospitalDoctorName", v);
    }
  }))), (formData === null || formData === void 0 ? void 0 : formData.organizationType) === "eis" && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6,
    className: classes.item
  }, /*#__PURE__*/React.createElement(TextInput, {
    label: "workforce.employee.accident.info.breifInfo",
    value: (formData === null || formData === void 0 || (_formData$employeeAcc31 = formData.employeeAccidentInfo) === null || _formData$employeeAcc31 === void 0 ? void 0 : _formData$employeeAcc31.accidentBriefInfo) || "",
    onChange: function onChange(v) {
      return _handleChange("accidentBriefInfo", v);
    }
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6,
    className: classes.item
  }, /*#__PURE__*/React.createElement(TextInput, {
    label: "workforce.employee.accident.info.injurySite",
    value: (formData === null || formData === void 0 || (_formData$employeeAcc32 = formData.employeeAccidentInfo) === null || _formData$employeeAcc32 === void 0 ? void 0 : _formData$employeeAcc32.injurySite) || "",
    onChange: function onChange(v) {
      return _handleChange("injurySite", v);
    }
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6,
    className: classes.item
  }, /*#__PURE__*/React.createElement(TextInput, {
    label: "workforce.employee.accident.info.injuryDescription",
    value: (formData === null || formData === void 0 || (_formData$employeeAcc33 = formData.employeeAccidentInfo) === null || _formData$employeeAcc33 === void 0 ? void 0 : _formData$employeeAcc33.injuryDescription) || "",
    onChange: function onChange(v) {
      return _handleChange("injuryDescription", v);
    }
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    className: classes.item
  }, /*#__PURE__*/React.createElement(FormControl, {
    component: "fieldset"
  }, /*#__PURE__*/React.createElement(FormLabel, null, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "workforce.employee.accident.info.disAbilityEffect",
    module: "workforce"
  })), /*#__PURE__*/React.createElement(RadioGroup, {
    row: true,
    value: disAbilityEffect,
    onChange: handleDisabilityEffect
  }, /*#__PURE__*/React.createElement(FormControlLabel, {
    value: "yes",
    control: /*#__PURE__*/React.createElement(Radio, {
      color: "primary"
    }),
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.application.permission.yes",
      module: "workforce"
    })
  }), /*#__PURE__*/React.createElement(FormControlLabel, {
    value: "no",
    control: /*#__PURE__*/React.createElement(Radio, {
      color: "primary"
    }),
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.application.permission.no",
      module: "workforce"
    })
  })))), disAbilityEffect === "yes" && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6,
    className: classes.item
  }, /*#__PURE__*/React.createElement(TextInput, {
    label: "workforce.employee.accident.info.disabilityPerSchedule",
    value: (formData === null || formData === void 0 || (_formData$employeeAcc34 = formData.employeeAccidentInfo) === null || _formData$employeeAcc34 === void 0 ? void 0 : _formData$employeeAcc34.disabilityPerSchedule) || "",
    onChange: function onChange(v) {
      return _handleChange("disabilityPerSchedule", v);
    }
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6,
    className: classes.item
  }, /*#__PURE__*/React.createElement(TextInput, {
    label: "workforce.employee.accident.info.presentInjuryBLASchedule1",
    value: (formData === null || formData === void 0 || (_formData$employeeAcc35 = formData.employeeAccidentInfo) === null || _formData$employeeAcc35 === void 0 ? void 0 : _formData$employeeAcc35.presentInjuryBLASchedule1) || "",
    onChange: function onChange(v) {
      return _handleChange("presentInjuryBLASchedule1", v);
    }
  })))))), /*#__PURE__*/React.createElement(EmployeeDetailsForm2, {
    errors: errors,
    handleChange: function handleChange() {},
    formData: formData,
    selectedApplicationType: formData.applicationType,
    formStepNo: "employeeAccidentInfo"
  }));
};

function ownKeys$14(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$14(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$14(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$14(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var useDebounce = function useDebounce(callback, delay) {
  var timer = useRef(null);
  var debouncedFn = useCallback(function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    if (timer.current) clearTimeout(timer.current);
    timer.current = setTimeout(function () {
      callback.apply(void 0, args);
    }, delay);
  }, [callback, delay]);
  return debouncedFn;
};
var BranchPicker = function BranchPicker(_ref) {
  var _ref$id = _ref.id,
    id = _ref$id === void 0 ? "branch" : _ref$id,
    modulesManager = _ref.modulesManager,
    _onChange = _ref.onChange,
    readOnly = _ref.readOnly,
    required = _ref.required,
    _ref$withLabel = _ref.withLabel,
    withLabel = _ref$withLabel === void 0 ? true : _ref$withLabel,
    withPlaceholder = _ref.withPlaceholder,
    value = _ref.value,
    label = _ref.label,
    placeholder = _ref.placeholder,
    filterOptions = _ref.filterOptions,
    filterSelectedOptions = _ref.filterSelectedOptions,
    multiple = _ref.multiple,
    bankId = _ref.bankId,
    districtName = _ref.districtName;
  var _useTranslations = useTranslations("workforce"),
    formatMessage = _useTranslations.formatMessage;
  var dispatch = useDispatch();
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    searchString = _useState2[0],
    setSearchString = _useState2[1];
  var locale = useSelector(function (state) {
    var _state$core;
    return ((_state$core = state.core) === null || _state$core === void 0 || (_state$core = _state$core.user) === null || _state$core === void 0 || (_state$core = _state$core.i_user) === null || _state$core === void 0 ? void 0 : _state$core.language) || "en";
  });
  useEffect(function () {
    if (bankId && districtName) {
      dispatch(fetchBranchPick(modulesManager, ["type:\"branch\",bankCode: \"".concat(bankId, "\",orderBy: \"districtNameBn\", districtNameBn: \"").concat(districtName, "\"")])); // Fetching branches
    }
  }, [bankId, districtName]); // Runs only when bankId changes

  var isLoading = useSelector(function (state) {
    return state.workforce["fetchingBranchPick"];
  });
  var allData = useSelector(function (state) {
    var _state$workforce;
    return (_state$workforce = state.workforce["branchPick"]) !== null && _state$workforce !== void 0 ? _state$workforce : [];
  });
  var error = useSelector(function (state) {
    return state.workforce["errorBranchPick"];
  });

  // Filtering branches that belong to the selected bank
  // const branches = useMemo(() => {
  //   return allData.filter((branch) => branch?.parent?.id === bankId); // Assuming `parentBankId` links branches to banks
  // }, [allData, bankId]);

  var selectedOption = useMemo(function () {
    if (!value) return null;
    if (typeof value === "string") {
      return allData.find(function (option) {
        return option.id === value;
      }) || null;
    }
    return value;
  }, [value, allData]);
  console.log({
    allData: allData
  });
  var options = useMemo(function () {
    var opts = _toConsumableArray(allData);
    if (selectedOption && !opts.find(function (o) {
      return o.id === selectedOption.id;
    })) {
      opts = [].concat(_toConsumableArray(opts), [selectedOption]);
    }
    if (searchString && !opts.find(function (o) {
      var _o$nameEn, _o$nameBn;
      return ((_o$nameEn = o.nameEn) === null || _o$nameEn === void 0 ? void 0 : _o$nameEn.toLowerCase()) === searchString.toLowerCase() || ((_o$nameBn = o.nameBn) === null || _o$nameBn === void 0 ? void 0 : _o$nameBn.toLowerCase()) === searchString.toLowerCase();
    })) {
      opts = [].concat(_toConsumableArray(opts), [{
        id: null,
        nameEn: searchString,
        nameBn: searchString
      }]);
    }
    return opts;
  }, [allData, selectedOption, searchString]);
  var debouncedHandleType = useDebounce(function (name) {
    if (!name) return;
    var exists = allData.find(function (d) {
      var _d$nameEn, _d$nameBn;
      return ((_d$nameEn = d.nameEn) === null || _d$nameEn === void 0 ? void 0 : _d$nameEn.toLowerCase()) === name.toLowerCase() || ((_d$nameBn = d.nameBn) === null || _d$nameBn === void 0 ? void 0 : _d$nameBn.toLowerCase()) === name.toLowerCase();
    }) || null;
    if (exists) {
      if (!selectedOption || selectedOption.id !== exists.id) {
        _onChange(exists);
      }
    } else {
      if (!selectedOption || selectedOption.nameEn !== name) {
        var newOption = {
          id: null,
          nameEn: name,
          nameBn: name
        };
        _onChange(newOption);
      }
    }
  }, 800);
  useEffect(function () {
    if (searchString) {
      debouncedHandleType(searchString);
    }
  }, [searchString, debouncedHandleType]);
  return /*#__PURE__*/React.createElement(Autocomplete, {
    id: id,
    multiple: multiple,
    required: required,
    placeholder: placeholder !== null && placeholder !== void 0 ? placeholder : "",
    label: label !== null && label !== void 0 ? label : formatMessage("workforce.branch.picker"),
    error: error,
    withLabel: withLabel,
    withPlaceholder: withPlaceholder,
    readOnly: readOnly,
    options: options // Using filtered branches
    ,
    isLoading: isLoading,
    value: selectedOption,
    renderInput: function renderInput(params) {
      return /*#__PURE__*/React.createElement(TextField, _extends({}, params, {
        label: label !== null && label !== void 0 ? label : formatMessage("workforce.branch.picker"),
        placeholder: placeholder !== null && placeholder !== void 0 ? placeholder : "",
        required: required,
        error: !!error,
        inputProps: _objectSpread$14(_objectSpread$14({}, params.inputProps), {}, {
          readOnly: true,
          style: {
            cursor: "pointer"
          }
        })
      }));
    }
    // getOptionLabel={(option) => `${option.nameEn}`}
    ,
    getOptionLabel: function getOptionLabel(option) {
      return locale === "en" ? option === null || option === void 0 ? void 0 : option.nameEn : option === null || option === void 0 ? void 0 : option.nameBn;
    },
    onChange: function onChange(option) {
      return _onChange(option, option ? "".concat(option) : null);
    },
    filterOptions: filterOptions,
    filterSelectedOptions: filterSelectedOptions,
    onInputChange: setSearchString
  });
};

var MobileBankingPicker = function MobileBankingPicker(_ref) {
  _ref.modulesManager;
    var _onChange = _ref.onChange,
    readOnly = _ref.readOnly,
    required = _ref.required,
    _ref$withLabel = _ref.withLabel,
    withLabel = _ref$withLabel === void 0 ? true : _ref$withLabel,
    withPlaceholder = _ref.withPlaceholder,
    value = _ref.value,
    label = _ref.label,
    placeholder = _ref.placeholder,
    filterOptions = _ref.filterOptions,
    filterSelectedOptions = _ref.filterSelectedOptions;
    _ref.multiple;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2);
    _useState2[0];
    var setSearchString = _useState2[1];
  var _useTranslations = useTranslations("workforce");
    _useTranslations.formatMessage;

  // Adjust the options to match the EMPLOYEE_LIFE_STATUS format
  var EMPLOYEE_LIFE_STATUS = ["বিকাশ", "নগদ", "রকেট", "উপায়", "শিওরক্যাশ", "সেলফিন", "ট্যাপ", "মাই ক্যাশ", "এমক্যাশ", "ফার্স্ট ক্যাশ", "ওকে ওয়ালেট", "টেলিক্যাশ", "ইসলামিক ওয়ালেট", "মেঘনা পে"];

  // Find the selected option
  var selectedOption = useMemo(function () {
    return EMPLOYEE_LIFE_STATUS.includes(value) ? value : null;
  }, [value]);
  return /*#__PURE__*/React.createElement(Autocomplete, {
    multiple: false,
    required: required,
    placeholder: placeholder !== null && placeholder !== void 0 ? placeholder : "",
    label: label !== null && label !== void 0 ? label : "Mobile Banking Options",
    withLabel: withLabel,
    withPlaceholder: withPlaceholder,
    readOnly: readOnly,
    isLoading: false // Set to false if not loading data dynamically
    ,
    options: EMPLOYEE_LIFE_STATUS,
    value: selectedOption,
    getOptionLabel: function getOptionLabel(option) {
      return option;
    } // Since options are strings, return the string directly
    ,
    onChange: function onChange(option) {
      return _onChange(option, option !== null && option !== void 0 ? option : null);
    },
    filterOptions: filterOptions,
    filterSelectedOptions: filterSelectedOptions,
    onInputChange: setSearchString
  });
};

var DistrictBanks = function DistrictBanks(_ref) {
  var _ref$id = _ref.id,
    id = _ref$id === void 0 ? "districtBank" : _ref$id,
    modulesManager = _ref.modulesManager,
    _onChange = _ref.onChange,
    readOnly = _ref.readOnly,
    required = _ref.required,
    _ref$withLabel = _ref.withLabel,
    withLabel = _ref$withLabel === void 0 ? true : _ref$withLabel,
    withPlaceholder = _ref.withPlaceholder,
    value = _ref.value,
    label = _ref.label,
    placeholder = _ref.placeholder,
    filterOptions = _ref.filterOptions,
    filterSelectedOptions = _ref.filterSelectedOptions,
    multiple = _ref.multiple,
    bankId = _ref.bankId;
  var _useTranslations = useTranslations("workforce"),
    formatMessage = _useTranslations.formatMessage;
  var dispatch = useDispatch();
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2);
    _useState2[0];
    var setSearchString = _useState2[1];
  useEffect(function () {
    if (bankId) {
      dispatch(fetchDistrictBanksPick(modulesManager, ["type:\"branch\",bankCode: \"".concat(bankId, "\",orderBy: \"districtNameBn\", getUnique: \"true\"")])); // Fetching branches
    }
  }, [bankId]); // Runs only when bankId changes

  var isLoading = useSelector(function (state) {
    return state.workforce["fetchinDistrictBanksPick"];
  });
  var allData = useSelector(function (state) {
    var _state$workforce;
    return (_state$workforce = state.workforce["districtBanksPick"]) !== null && _state$workforce !== void 0 ? _state$workforce : [];
  });
  var error = useSelector(function (state) {
    return state.workforce["errorDistrictBanksPick"];
  });

  // Filtering branches that belong to the selected bank
  // const branches = useMemo(() => {
  //   return allData.filter((branch) => branch?.parent?.id === bankId); // Assuming `parentBankId` links branches to banks
  // }, [allData, bankId]);

  // const selectedOption = useMemo(
  //   () => allData.find((option) => option.id === value) || null,
  //   [value, allData]
  // );
  var selectedOption = value || null;
  console.log({
    allData: allData
  });
  var locale = useSelector(function (state) {
    var _state$core;
    return ((_state$core = state.core) === null || _state$core === void 0 || (_state$core = _state$core.user) === null || _state$core === void 0 || (_state$core = _state$core.i_user) === null || _state$core === void 0 ? void 0 : _state$core.language) || "en";
  });
  return /*#__PURE__*/React.createElement(Autocomplete, {
    id: id,
    multiple: multiple,
    required: required,
    placeholder: placeholder !== null && placeholder !== void 0 ? placeholder : "",
    label: label !== null && label !== void 0 ? label : formatMessage("workforce.branch.picker"),
    error: error,
    withLabel: withLabel,
    withPlaceholder: withPlaceholder,
    readOnly: readOnly,
    options: allData // Using filtered branches
    ,
    isLoading: isLoading,
    value: selectedOption
    // getOptionLabel={(option) => `${option.nameEn}`}
    ,
    getOptionLabel: function getOptionLabel(option) {
      return locale === "en" ? option === null || option === void 0 ? void 0 : option.districtNameEn : option === null || option === void 0 ? void 0 : option.districtNameBn;
    },
    onChange: function onChange(option) {
      return _onChange(option, option ? "".concat(option) : null);
    },
    filterOptions: filterOptions,
    filterSelectedOptions: filterSelectedOptions,
    onInputChange: setSearchString
  });
};

function ownKeys$13(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$13(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$13(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$13(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var useStyles$1r = makeStyles(function (theme) {
  return {
    paper: {
      padding: theme.spacing(2)
    },
    item: {
      marginBottom: theme.spacing(2)
    },
    buttonContainer: {
      marginTop: theme.spacing(2)
    }
  };
});
var EmployeeAccountInfoForm = function EmployeeAccountInfoForm(_ref) {
  var _applicationId$2;
  var formdata = _ref.formdata,
    accounts = _ref.accounts,
    handleChange = _ref.handleChange;
    _ref.addItem;
    var removeItem = _ref.removeItem,
    expanded = _ref.expanded,
    setExpanded = _ref.setExpanded,
    applicationId = _ref.applicationId,
    errors = _ref.errors;
  var classes = useStyles$1r();
  var modulesManager = useModulesManager();
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    loading = _useState2[0],
    setLoading = _useState2[1];
  var _useTranslations = useTranslations("core.RegistrationPage", modulesManager);
    _useTranslations.formatMessage;
  var dispatch = useDispatch();
  var _useState3 = useState([{}]),
    _useState4 = _slicedToArray(_useState3, 2),
    showAccounts = _useState4[0];
    _useState4[1]; // Local array to control visible accounts

  var dependent = useSelector(function (state) {
    return state.workforce.workforceDependent;
  });
  useEffect(function () {
    var _applicationId$;
    console.log("abc", applicationId);
    if (applicationId && (_applicationId$ = applicationId[0]) !== null && _applicationId$ !== void 0 && _applicationId$.id) {
      setLoading(true);
      dispatch(fetchEmployeeDependent(modulesManager, ["workforceApplication_Id:\"".concat(decodeId(applicationId[0].id), "\"")]));
      setLoading(false);
    }
  }, [applicationId]);
  if (loading) return /*#__PURE__*/React.createElement("b", null, "Loading ...");
  useEffect(function () {
    if ((dependent === null || dependent === void 0 ? void 0 : dependent.length) > 0) {
      setExpanded(0);
      dependent === null || dependent === void 0 || dependent.map(function (dep, index) {
        handleChange(index, "accountHolderName", dep === null || dep === void 0 ? void 0 : dep.nameBn);
        handleChange(index, "dependentId", dep === null || dep === void 0 ? void 0 : dep.id);
        handleChange(index, "dependentNid", dep === null || dep === void 0 ? void 0 : dep.nid);
        handleChange(index, "accountHolderType", "self");
      });
    } else {
      var _formdata$workforceEm;
      handleChange(0, "accountHolderName", formdata === null || formdata === void 0 || (_formdata$workforceEm = formdata.workforceEmployee) === null || _formdata$workforceEm === void 0 ? void 0 : _formdata$workforceEm.nameBn);
    }
  }, [dependent]);
  var handleAccountChange = function handleAccountChange(index, key, value) {
    var _dependent$index;
    var nestedKey = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    console.log(dependent);
    var hasDependent = Array.isArray(dependent) && dependent.length > 0;
    var hasFormDependents = Array.isArray(formdata === null || formdata === void 0 ? void 0 : formdata.dependents) && formdata.dependents.some(function (item) {
      return Object.keys(item).length > 0;
    });
    // const isDependent = Array.isArray(dependent) && dependent.some((item) => Object.keys(item).length > 0);
    var isDependent = hasDependent && hasFormDependents;
    var dependentId = isDependent ? dependent === null || dependent === void 0 || (_dependent$index = dependent[index]) === null || _dependent$index === void 0 ? void 0 : _dependent$index.id : null;
    console.log({
      isDependent: isDependent
    });
    var baseAccount = _objectSpread$13(_objectSpread$13({}, accounts[index] || {}), {}, {
      applicant_type: isDependent ? "dependent" : "applicant"
    }, isDependent && {
      id: dependentId
    });
    if (nestedKey) {
      handleChange(index, key, _objectSpread$13(_objectSpread$13({}, baseAccount[key] || {}), {}, _defineProperty({}, nestedKey, value)));
    } else {
      handleChange(index, key, value);
    }
    handleChange(index, "applicant_type", isDependent ? "dependent" : "applicant");
    if (isDependent && dependentId) {
      handleChange(index, "id", dependentId);
    }
  };
  var allowAdd = !applicationId || !((_applicationId$2 = applicationId[0]) !== null && _applicationId$2 !== void 0 && _applicationId$2.id);
  var handleAttachmentChange = useCallback(function (index, fieldKey, value) {
    var normalizeAttachments = function normalizeAttachments(attachments) {
      if (!attachments) return [];
      if (typeof attachments === "string") {
        try {
          var parsed = JSON.parse(attachments);
          return Array.isArray(parsed) ? parsed : [];
        } catch (error) {
          return [];
        }
      }
      return Array.isArray(attachments) ? attachments : [];
    };
    handleChange(index, "attachments", function (currentAttachments) {
      var _value$files;
      var normalizedAttachments = normalizeAttachments(currentAttachments);
      if (!(value !== null && value !== void 0 && (_value$files = value.files) !== null && _value$files !== void 0 && _value$files.length)) {
        return normalizedAttachments.filter(function (att) {
          return att.fieldKey !== fieldKey;
        });
      }
      return normalizedAttachments.some(function (att) {
        return att.fieldKey === fieldKey;
      }) ? normalizedAttachments.map(function (att) {
        return att.fieldKey === fieldKey ? _objectSpread$13(_objectSpread$13({}, att), {}, {
          fieldKey: fieldKey,
          files: value.files,
          documentType: value.documentType,
          documentPropId: value.documentPropId
        }) : att;
      }) : [].concat(_toConsumableArray(normalizedAttachments), [{
        fieldKey: fieldKey,
        files: value.files,
        documentType: value.documentType,
        documentPropId: value.documentPropId
      }]);
    });
  }, [handleChange]);
  console.log({
    applicationId: applicationId
  });
  console.log({
    dependent: dependent
  });
  return /*#__PURE__*/React.createElement(Box$1, {
    mt: 1
  }, /*#__PURE__*/React.createElement(Typography, {
    mb: 4,
    style: {
      textAlign: "center",
      fontWeight: "bold",
      fontSize: "small",
      margin: "15px"
    }
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "workforce.application.steps.account.info",
    module: "workforce"
  })), ((dependent === null || dependent === void 0 ? void 0 : dependent.length) > 0 ? dependent : [{}]).map(function (dependentValue, index) {
    var _account$bank, _account$bank2, _account$bank3, _account$district, _dependent$index2, _formdata$workforceEm2, _dependent$index3, _formdata$workforceEm3, _account$branch;
    var account = accounts[index] || {};
    var accountType = (account === null || account === void 0 ? void 0 : account.accountType) || "bank";
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Accordion, {
      key: index,
      expanded: expanded === index,
      onChange: function onChange() {
        return setExpanded(expanded === index ? false : index);
      }
    }, /*#__PURE__*/React.createElement(AccordionSummary, {
      expandIcon: /*#__PURE__*/React.createElement(ExpandMoreIcon, null)
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "subtitle2",
      style: {
        fontWeight: "bold"
      }
    }, dependentValue === null || dependentValue === void 0 ? void 0 : dependentValue.nameBn, " ", (dependentValue === null || dependentValue === void 0 ? void 0 : dependentValue.nameBn) && "এর", " ", /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.previewDetails.employeeBankInfo",
      defaultMessage: "Bank Account ".concat(index + 1)
    }))), /*#__PURE__*/React.createElement(AccordionDetails, null, /*#__PURE__*/React.createElement(Grid, {
      container: true,
      spacing: 2
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12
    }, /*#__PURE__*/React.createElement(Paper, {
      className: classes.paper,
      elevation: 0
    }, /*#__PURE__*/React.createElement(FormControl, {
      component: "fieldset"
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "subtitle1",
      style: {
        fontWeight: "bold"
      }
    }, /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.account.selection.type",
      defaultMessage: "Select Account Type"
    })), /*#__PURE__*/React.createElement(RadioGroup, {
      row: true,
      value: accountType,
      onChange: function onChange(e) {
        return handleAccountChange(index, "accountType", e.target.value);
      }
    }, /*#__PURE__*/React.createElement(FormControlLabel, {
      value: "bank",
      control: /*#__PURE__*/React.createElement(Radio, {
        color: "primary"
      }),
      label: /*#__PURE__*/React.createElement(FormattedMessage, {
        id: "workforce.application.account.bank"
      })
    }), /*#__PURE__*/React.createElement(FormControlLabel, {
      disabled: true,
      value: "mobile",
      control: /*#__PURE__*/React.createElement(Radio, {
        color: "primary"
      }),
      label: /*#__PURE__*/React.createElement(FormattedMessage, {
        id: "workforce.application.account.mobile"
      })
    }))), accountType === "mobile" && /*#__PURE__*/React.createElement(Grid, {
      container: true,
      spacing: 2
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 6,
      className: classes.item
    }, /*#__PURE__*/React.createElement(MobileBankingPicker, {
      id: "bankingOptions",
      value: (account === null || account === void 0 ? void 0 : account.bankingOptions) || "",
      label: /*#__PURE__*/React.createElement(FormattedMessage, {
        id: "workforce.application.account.mobile.operator"
      }),
      onChange: function onChange(v) {
        return handleAccountChange(index, "bankingOptions", v);
      },
      required: true,
      readOnly: false
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 6,
      className: classes.item
    }, /*#__PURE__*/React.createElement(TextInput, {
      id: "accountNumber",
      label: "workforce.employee.account.info.mobileNumber",
      value: (account === null || account === void 0 ? void 0 : account.accountNumber) || "",
      onChange: function onChange(v) {
        return handleAccountChange(index, "accountNumber", v);
      },
      required: true,
      readOnly: false,
      error: !!errors.accountNumber,
      helperText: errors.accountNumber
    }))), /*#__PURE__*/React.createElement(Grid, {
      container: true,
      spacing: 2
    }, accountType === "bank" && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 6,
      className: classes.item
    }, /*#__PURE__*/React.createElement(PublishedComponent, {
      pubRef: "workforce.BanksPicker",
      value: (account === null || account === void 0 || (_account$bank = account.bank) === null || _account$bank === void 0 ? void 0 : _account$bank.id) || null,
      label: /*#__PURE__*/React.createElement(FormattedMessage, {
        id: "workforce.bank.picker"
      }),
      onChange: function onChange(v) {
        return handleAccountChange(index, "bank", v);
      },
      required: true,
      readOnly: false
    }), errors.bank && /*#__PURE__*/React.createElement(FormHelperText, {
      error: true
    }, errors.bank)), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 6,
      className: classes.item
    }, /*#__PURE__*/React.createElement(DistrictBanks, {
      id: "districtBank",
      value: (account === null || account === void 0 ? void 0 : account.district) || null // Pass the whole object, not just id
      ,
      label: /*#__PURE__*/React.createElement(FormattedMessage, {
        id: "workforce.district.branch.picker"
      }),
      bankId: account === null || account === void 0 || (_account$bank2 = account.bank) === null || _account$bank2 === void 0 ? void 0 : _account$bank2.bankCode,
      onChange: function onChange(v) {
        return handleAccountChange(index, "district", v);
      } // Save full object
      ,
      required: true,
      readOnly: false
    }), errors.districtBank && /*#__PURE__*/React.createElement(FormHelperText, {
      error: true
    }, errors.districtBank)), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 6,
      className: classes.item
    }, /*#__PURE__*/React.createElement(BranchPicker, {
      id: "branch",
      value: (account === null || account === void 0 ? void 0 : account.branch) || "",
      label: /*#__PURE__*/React.createElement(FormattedMessage, {
        id: "workforce.branch.picker"
      }),
      bankId: account === null || account === void 0 || (_account$bank3 = account.bank) === null || _account$bank3 === void 0 ? void 0 : _account$bank3.bankCode,
      districtName: account === null || account === void 0 || (_account$district = account.district) === null || _account$district === void 0 ? void 0 : _account$district.districtNameBn,
      onChange: function onChange(v) {
        return handleAccountChange(index, "branch", v);
      },
      required: true,
      readOnly: false
    }), errors.branch && /*#__PURE__*/React.createElement(FormHelperText, {
      error: true
    }, errors.branch)), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 6,
      className: classes.item
    }, /*#__PURE__*/React.createElement(TextInput, {
      id: "accountHolderName",
      label: "workforce.employee.account.info.accountHolderName",
      value: (account === null || account === void 0 ? void 0 : account.accountHolderName) || (dependent === null || dependent === void 0 || (_dependent$index2 = dependent[index]) === null || _dependent$index2 === void 0 ? void 0 : _dependent$index2.nameBn) || (formdata === null || formdata === void 0 || (_formdata$workforceEm2 = formdata.workforceEmployee) === null || _formdata$workforceEm2 === void 0 ? void 0 : _formdata$workforceEm2.nameBn),
      onChange: function onChange(v) {
        return handleAccountChange(index, "accountHolderName", v);
      },
      required: true,
      readOnly: (account === null || account === void 0 ? void 0 : account.accountHolderName) || (dependent === null || dependent === void 0 || (_dependent$index3 = dependent[index]) === null || _dependent$index3 === void 0 ? void 0 : _dependent$index3.nameBn) || (formdata === null || formdata === void 0 || (_formdata$workforceEm3 = formdata.workforceEmployee) === null || _formdata$workforceEm3 === void 0 ? void 0 : _formdata$workforceEm3.nameBn),
      error: !!errors.accountHolderName,
      helperText: errors.accountHolderName
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 6,
      className: classes.item
    }, /*#__PURE__*/React.createElement(TextInput, {
      id: "routingNumber",
      label: "workforce.employee.account.info.routingNumber",
      value: (account === null || account === void 0 || (_account$branch = account.branch) === null || _account$branch === void 0 ? void 0 : _account$branch.routingNumber) || "",
      onChange: function onChange(v) {
        return handleAccountChange(index, "routingNumber", normalizeNumberInput(v));
      },
      readOnly: false,
      required: true,
      error: !!errors.routingNumber,
      helperText: errors.routingNumber
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 6,
      className: classes.item
    }, /*#__PURE__*/React.createElement(TextInput, {
      id: "accountNumber",
      label: "workforce.employee.account.info.accountNumber",
      value: (account === null || account === void 0 ? void 0 : account.accountNumber) || "",
      onChange: function onChange(v) {
        return handleAccountChange(index, "accountNumber", normalizeNumberInput(v));
      },
      required: true,
      readOnly: false,
      error: !!errors.accountNumber,
      helperText: errors.accountNumber
    })))), /*#__PURE__*/React.createElement(Divider, {
      style: {
        margin: "16px 0"
      }
    }), /*#__PURE__*/React.createElement(Box$1, {
      className: classes.buttonContainer
    }, /*#__PURE__*/React.createElement(Button, {
      variant: "contained",
      color: "secondary",
      onClick: function onClick() {
        return removeItem(index);
      },
      disabled: showAccounts.length === 1 || !allowAdd
    }, /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.application.steps.skip",
      defaultMessage: "Remove Account"
    }))))))), /*#__PURE__*/React.createElement(EmployeeDetailsForm2, {
      errors: errors,
      handleChange: function handleChange(fieldKey, value) {
        return handleAttachmentChange(index, fieldKey, value);
      },
      formData: formdata,
      selectedApplicationType: formdata.applicationType,
      formStepNo: "employeeBankInfo",
      accountIndex: index
    })));
  }));
};

var useStyles$1q = makeStyles(function (theme) {
  return {
    container: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center"
    },
    paper: {
      padding: theme.spacing(2),
      width: 700
    },
    buttonContainer: {
      marginTop: theme.spacing(2),
      display: "flex",
      justifyContent: "flex-end",
      gap: theme.spacing(1)
    }
  };
});
var NidVerification = function NidVerification(_ref) {
  var formData = _ref.formData,
    nidOrBcn = _ref.nidOrBcn;
    _ref.modulesManager;
    var setDisableConfirmSubmit = _ref.setDisableConfirmSubmit;
  console.log({
    nidOrBcn: nidOrBcn
  });
  var classes = useStyles$1q();
  var dispatch = useDispatch();
  useEffect(function () {
    return dispatch(verifyNid());
  }, []);
  var data = useSelector(function (state) {
    return state.workforce["verifyNidDetails"];
  });
  console.log("verify nid", data);
  if (data !== null && data !== void 0 && data.error) {
    setDisableConfirmSubmit(true);
  }
  return /*#__PURE__*/React.createElement("div", {
    className: classes.container
  }, /*#__PURE__*/React.createElement(Box$1, {
    p: 0,
    className: classes.paper
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 1
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(CardContent, null, (formData.organizationType !== "blwf" || formData.organizationType !== "eis") && /*#__PURE__*/React.createElement(Typography, {
    variant: "body1",
    className: classes.title
  }, data && !data.error ? /*#__PURE__*/React.createElement("b", {
    style: {
      color: "#25D366"
    }
  }, "\u2705 ", /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.application.nidVerify.success"
  })) : data && data !== null && data !== void 0 && data.error ? /*#__PURE__*/React.createElement("b", {
    style: {
      color: "red"
    }
  }, "\u274C ", /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.application.nidVerify.error"
  })) : /*#__PURE__*/React.createElement("b", null, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.application.nidVerify.loading"
  }))), /*#__PURE__*/React.createElement(Divider, {
    style: {
      margin: "10px 0"
    }
  }), /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 2
  }, data && !(data !== null && data !== void 0 && data.error) ? /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement("b", null, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.employee.name.en"
  }), ":"), " ", data === null || data === void 0 ? void 0 : data.nameEN, /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("b", null, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.employee.name.bn"
  }), ":"), " ", data === null || data === void 0 ? void 0 : data.nameBN, /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("b", null, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.employee.fathers_name.bn"
  }), ":"), " ", data === null || data === void 0 ? void 0 : data.fatherNameBN, /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("b", null, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.employee.mothers_name.bn"
  }), ":"), " ", data === null || data === void 0 ? void 0 : data.motherNameBN, /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("b", null, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.employee.birthdate"
  }), ":"), " ", data === null || data === void 0 ? void 0 : data.dateOfBirth, /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("b", null, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.employee.nid"
  }), ":"), " ", data === null || data === void 0 ? void 0 : data.nidNumber, /*#__PURE__*/React.createElement("br", null))) : data && data !== null && data !== void 0 && data.error ? null : /*#__PURE__*/React.createElement("b", null, "loading ..."))))))));
};

var useStyles$1p = makeStyles(function (theme) {
  return {
    container: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center"
    },
    paper: {
      padding: theme.spacing(1),
      width: 700
    },
    buttonContainer: {
      marginTop: theme.spacing(2),
      display: "flex",
      justifyContent: "flex-end",
      gap: theme.spacing(1)
    }
  };
});
var ApplicationFormSubmitted = function ApplicationFormSubmitted() {
  var classes = useStyles$1p();
  var history = useHistory();
  setTimeout(function () {
    history.push("/home");
    window.location.reload();
  }, 2000);
  return /*#__PURE__*/React.createElement("div", {
    className: classes.container
  }, /*#__PURE__*/React.createElement(Paper, {
    className: classes.paper,
    elevation: 0
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5",
    align: "center",
    color: "primary"
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.success.message"
  }))));
};

pdfjs.GlobalWorkerOptions.workerSrc = "//cdnjs.cloudflare.com/ajax/libs/pdf.js/".concat(pdfjs.version, "/pdf.worker.js");
var getFileType = function getFileType() {
  var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  var lowerUrl = url.toLowerCase();
  if (/\.(jpg|jpeg|png|gif)$/i.test(lowerUrl)) return "image";
  if (lowerUrl.endsWith(".pdf")) return "pdf";
  if (lowerUrl.endsWith(".docx")) return "docx";
  return "unsupported";
};
var DocumentReviewAccordion = function DocumentReviewAccordion(_ref) {
  var _file$workforceDocume, _file$workforceDocume2, _file$status, _file$status2;
  var file = _ref.file,
    index = _ref.index,
    documentId = _ref.documentId,
    onCommentChange = _ref.onCommentChange,
    onVerify = _ref.onVerify,
    onReject = _ref.onReject,
    locale = _ref.locale,
    onFileChange = _ref.onFileChange,
    _ref$fromResend = _ref.fromResend,
    fromResend = _ref$fromResend === void 0 ? false : _ref$fromResend,
    viewedFromFlag = _ref.viewedFromFlag;
  var type = getFileType(file === null || file === void 0 ? void 0 : file.url);
  var user_type = getUserType();
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2);
    _useState2[0];
    _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    openRejectModal = _useState4[0],
    setOpenRejectModal = _useState4[1];
  var _useState5 = useState(""),
    _useState6 = _slicedToArray(_useState5, 2),
    tempComment = _useState6[0],
    setTempComment = _useState6[1];
  var _useState7 = useState(null),
    _useState8 = _slicedToArray(_useState7, 2),
    selectedFileIndex = _useState8[0],
    setSelectedFileIndex = _useState8[1];
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Accordion, null, /*#__PURE__*/React.createElement(AccordionSummary, {
    expandIcon: /*#__PURE__*/React.createElement(ExpandMoreIcon, {
      className: "material-icons"
    })
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    alignItems: "center",
    justifyContent: "space-between"
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true
  }, /*#__PURE__*/React.createElement(Typography, null, locale === "en" ? file === null || file === void 0 || (_file$workforceDocume = file.workforceDocumentType) === null || _file$workforceDocume === void 0 ? void 0 : _file$workforceDocume.nameEn : file === null || file === void 0 || (_file$workforceDocume2 = file.workforceDocumentType) === null || _file$workforceDocume2 === void 0 ? void 0 : _file$workforceDocume2.nameBn, " ", type === "pdf" ? "(PDF)" : type === "image" ? "(Image)" : type === "docx" ? "(DOCX)" : "(Unsupported)")), /*#__PURE__*/React.createElement(Grid, {
    item: true
  }, /*#__PURE__*/React.createElement(Typography, {
    style: {
      color: file !== null && file !== void 0 && (_file$status = file.status) !== null && _file$status !== void 0 && _file$status.includes("verified") ? "green" : file !== null && file !== void 0 && (_file$status2 = file.status) !== null && _file$status2 !== void 0 && _file$status2.includes("rejected") ? "red" : "black",
      fontWeight: "bold"
    }
  }, locale === "fr" ? WORKFORCE_DOCUMENT_MAP_BN[file === null || file === void 0 ? void 0 : file.status] : WORKFORCE_DOCUMENT_MAP_EN[file === null || file === void 0 ? void 0 : file.status])))), /*#__PURE__*/React.createElement(AccordionDetails, null, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 2
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, type === "image" && /*#__PURE__*/React.createElement("img", {
    src: file.url,
    alt: "preview",
    style: {
      width: "100%",
      maxHeight: 300,
      objectFit: "contain"
    }
  }), type === "pdf" && /*#__PURE__*/React.createElement("iframe", {
    title: "PDF Viewer",
    src: file.url,
    width: "100%",
    height: "600px",
    style: {
      border: "1px solid #ccc",
      borderRadius: 4
    }
  }), type === "docx" && /*#__PURE__*/React.createElement("iframe", {
    title: "DOCX Viewer",
    src: "https://view.officeapps.live.com/op/embed.aspx?src=".concat(encodeURIComponent(file.url)),
    width: "100%",
    height: "500px",
    frameBorder: "0"
  }), type === "unsupported" && /*#__PURE__*/React.createElement(Typography, {
    color: "error"
  }, "Unsupported file type")), fromResend && ["rejected", "rejected_by_eis_office", "rejected_by_data_entry_officer", "rejected_by_factoryAdmin", "rejected_by_association", "rejected_by_eis_officer", "rejected_by_dol_dife"].includes(file === null || file === void 0 ? void 0 : file.status) && /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement(Typography, null, locale === "en" ? file === null || file === void 0 ? void 0 : file.workforceDocumentType.nameEn : file === null || file === void 0 ? void 0 : file.workforceDocumentType.nameBn), /*#__PURE__*/React.createElement(FileUploader, {
    fieldKey: "resend_".concat(documentId || index),
    documentId: documentId,
    onFileChange: onFileChange,
    documentType: file.documentType,
    documentProp: file
    // uploadedBy={"factoryAdmin"}
  })), ![WORKFORCE_USER_TYPE.APPLICANT, WORKFORCE_USER_TYPE.EIS_ADVISOR, WORKFORCE_USER_TYPE.EIS_COMMITTEE, WORKFORCE_USER_TYPE.EIS_ASSOCIATION_COMMITTEE].includes(user_type) && viewedFromFlag && viewedFromFlag === "verify" && /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    style: {
      display: "flex",
      gap: 8
    }
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "contained",
    color: "primary",
    onClick: function onClick() {
      return onVerify(index);
    },
    fullWidth: true
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.application.recommended"
  })), /*#__PURE__*/React.createElement(Button, {
    variant: "outlined",
    color: "error",
    onClick: function onClick() {
      setSelectedFileIndex(index);
      setOpenRejectModal(true);
    },
    fullWidth: true
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.application.reject"
  })))))), /*#__PURE__*/React.createElement(Modal, {
    open: openRejectModal,
    onClose: function onClose() {
      return setOpenRejectModal(false);
    }
  }, /*#__PURE__*/React.createElement(Box$1, {
    style: _defineProperty({
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      backgroundColor: "white",
      padding: 20,
      borderRadius: 8,
      width: 400,
      boxShadow: "0 2px 10px rgba(0,0,0,0.2)"
    }, "position", "relative")
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: function onClick() {
      return setOpenRejectModal(false);
    },
    style: {
      position: "absolute",
      top: 8,
      right: 8,
      minWidth: "auto",
      padding: 4,
      color: "#666"
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: "material-icons"
  }, "close")), /*#__PURE__*/React.createElement(Typography, {
    variant: "h6",
    gutterBottom: true
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.application.rejectReason",
    defaultMessage: "Provide Rejection Comment"
  })), /*#__PURE__*/React.createElement(TextField, {
    label: "Comment",
    fullWidth: true,
    variant: "outlined",
    size: "small",
    multiline: true,
    rows: 3,
    value: tempComment,
    onChange: function onChange(e) {
      return setTempComment(e.target.value);
    }
  }), /*#__PURE__*/React.createElement(Box$1, {
    mt: 2,
    display: "flex",
    justifyContent: "flex-end"
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "contained",
    color: "secondary",
    onClick: function onClick() {
      onCommentChange(selectedFileIndex, tempComment);
      onReject(selectedFileIndex);
      setTempComment("");
      setOpenRejectModal(false);
    }
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.application.reject"
  }))))));
};

function ownKeys$12(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$12(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$12(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$12(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var useStyles$1o = makeStyles(function (theme) {
  return {
    paper: {
      padding: theme.spacing(2)
    },
    item: {
      marginBottom: theme.spacing(2)
    },
    title: {
      fontWeight: 800,
      marginTop: theme.spacing(2) // Keep a little margin for visual separation if dividers are used
    }
  };
});

// DOCX Requirement S.L 01 - Main Accident Type Selection
var DOCX_ACCIDENT_TYPES = {
  WORKPLACE: "workforce.accident.mainType.workplace",
  ON_DUTY_RTA: "workforce.accident.mainType.onDutyRTA",
  COMMUTING: "workforce.accident.mainType.commuting"
};
var FactoryAdminAccidentForm = function FactoryAdminAccidentForm(_ref) {
  var _formData$employeeAcc, _formData$employeeAcc2, _formData$employeeAcc3, _formData$employeeAcc4, _formData$employeeAcc5, _formData$employeeAcc6, _formData$employeeAcc7, _formData$employeeAcc8, _formData$employeeAcc9, _formData$employeeAcc10, _formData$employeeAcc11, _formData$employeeAcc12, _formData$employeeAcc13, _formData$employeeAcc14, _formData$employeeAcc15, _formData$employeeAcc16, _formData$employeeAcc24, _formData$employeeAcc25, _formData$employeeAcc26, _formData$employeeAcc27, _formData$employeeAcc28, _formData$employeeAcc29, _formData$employeeAcc30, _formData$employeeAcc31, _formData$employeeAcc32, _formData$employeeAcc33, _formData$employeeAcc34, _formData$employeeAcc35, _formData$employeeAcc36, _formData$employeeAcc37, _formData$employeeAcc38, _formData$employeeAcc39, _formData$employeeAcc40, _formData$employeeAcc41, _formData$employeeAcc42, _formData$employeeAcc43, _formData$employeeAcc44, _formData$employeeAcc45, _formData$employeeAcc46, _formData$employeeAcc47, _formData$employeeAcc48, _formData$employeeAcc49, _formData$employeeAcc50, _formData$employeeAcc51, _formData$employeeAcc52, _formData$employeeAcc53, _formData$employeeAcc54, _formData$employeeAcc55, _formData$employeeAcc56, _formData$employeeAcc57, _formData$employeeAcc58, _formData$employeeAcc59, _formData$employeeAcc60;
  var handleChange = _ref.handleChange,
    formData = _ref.formData;
    _ref.setFormData;
    var applicationType = _ref.applicationType,
    errors = _ref.errors;
  var classes = useStyles$1o();
  var modulesManager = useModulesManager();
  var _useTranslations = useTranslations("core.RegistrationPage", modulesManager);
    _useTranslations.formatMessage;
  var user_type = getUserType();

  // PRESERVED ORIGINAL STATES
  var _useState = useState((formData === null || formData === void 0 || (_formData$employeeAcc = formData.employeeAccidentInfo) === null || _formData$employeeAcc === void 0 ? void 0 : _formData$employeeAcc.aidReasonType) || ((formData === null || formData === void 0 ? void 0 : formData.applicationType) === "disabilityAssistance" || (formData === null || formData === void 0 ? void 0 : formData.organizationType) === "eis" ? "accident" : "disease")),
    _useState2 = _slicedToArray(_useState, 2),
    aidReasonType = _useState2[0],
    setAidReasonType = _useState2[1];
  var _useState3 = useState((formData === null || formData === void 0 || (_formData$employeeAcc2 = formData.employeeAccidentInfo) === null || _formData$employeeAcc2 === void 0 ? void 0 : _formData$employeeAcc2.cronicDiseaseType) || []),
    _useState4 = _slicedToArray(_useState3, 2);
    _useState4[0];
    _useState4[1];
  var _useState5 = useState((formData === null || formData === void 0 || (_formData$employeeAcc3 = formData.employeeAccidentInfo) === null || _formData$employeeAcc3 === void 0 ? void 0 : _formData$employeeAcc3.admitted) || "no"),
    _useState6 = _slicedToArray(_useState5, 2),
    isAdmitted = _useState6[0],
    setIsAdmitted = _useState6[1];
  var _useState7 = useState((formData === null || formData === void 0 || (_formData$employeeAcc4 = formData.employeeAccidentInfo) === null || _formData$employeeAcc4 === void 0 ? void 0 : _formData$employeeAcc4.disAbilityEffect) || "no"),
    _useState8 = _slicedToArray(_useState7, 2);
    _useState8[0];
    _useState8[1];
  var _useState9 = useState((formData === null || formData === void 0 || (_formData$employeeAcc5 = formData.employeeAccidentInfo) === null || _formData$employeeAcc5 === void 0 ? void 0 : _formData$employeeAcc5.hasRejoined) || "yes"),
    _useState10 = _slicedToArray(_useState9, 2),
    hasRejoined = _useState10[0],
    setHasRejoined = _useState10[1];

  // NEW STATES BASED ON DOCX REQUIREMENTS
  var _useState11 = useState((formData === null || formData === void 0 || (_formData$employeeAcc6 = formData.employeeAccidentInfo) === null || _formData$employeeAcc6 === void 0 ? void 0 : _formData$employeeAcc6.accidentMainType) || DOCX_ACCIDENT_TYPES.WORKPLACE),
    _useState12 = _slicedToArray(_useState11, 2),
    selectedDocxAccidentType = _useState12[0],
    setSelectedDocxAccidentType = _useState12[1];
  var _useState13 = useState((formData === null || formData === void 0 || (_formData$employeeAcc7 = formData.employeeAccidentInfo) === null || _formData$employeeAcc7 === void 0 ? void 0 : _formData$employeeAcc7.officialOrderIssued) || "no"),
    _useState14 = _slicedToArray(_useState13, 2),
    officialOrderIssued = _useState14[0],
    setOfficialOrderIssued = _useState14[1];
  var _useState15 = useState((formData === null || formData === void 0 || (_formData$employeeAcc8 = formData.employeeAccidentInfo) === null || _formData$employeeAcc8 === void 0 ? void 0 : _formData$employeeAcc8.officialComplaint) || "no"),
    _useState16 = _slicedToArray(_useState15, 2),
    officialComplaint = _useState16[0],
    setOfficialComplaint = _useState16[1];
  var _useState17 = useState((formData === null || formData === void 0 || (_formData$employeeAcc9 = formData.employeeAccidentInfo) === null || _formData$employeeAcc9 === void 0 ? void 0 : _formData$employeeAcc9.otherInjured) || "no"),
    _useState18 = _slicedToArray(_useState17, 2),
    otherInjured = _useState18[0],
    setOtherInjured = _useState18[1];
  var _useState19 = useState((formData === null || formData === void 0 || (_formData$employeeAcc10 = formData.employeeAccidentInfo) === null || _formData$employeeAcc10 === void 0 || (_formData$employeeAcc10 = _formData$employeeAcc10.hospitalList) === null || _formData$employeeAcc10 === void 0 ? void 0 : _formData$employeeAcc10.length) > 0 ? formData.employeeAccidentInfo.hospitalList : [{
      hospitalName: (formData === null || formData === void 0 || (_formData$employeeAcc11 = formData.employeeAccidentInfo) === null || _formData$employeeAcc11 === void 0 ? void 0 : _formData$employeeAcc11.hospitalName) || "",
      admitDate: (formData === null || formData === void 0 || (_formData$employeeAcc12 = formData.employeeAccidentInfo) === null || _formData$employeeAcc12 === void 0 ? void 0 : _formData$employeeAcc12.admitDate) || null,
      admitTime: (formData === null || formData === void 0 || (_formData$employeeAcc13 = formData.employeeAccidentInfo) === null || _formData$employeeAcc13 === void 0 ? void 0 : _formData$employeeAcc13.admitTime) || null,
      hospitalAddress: (formData === null || formData === void 0 || (_formData$employeeAcc14 = formData.employeeAccidentInfo) === null || _formData$employeeAcc14 === void 0 ? void 0 : _formData$employeeAcc14.hospitalAddress) || "",
      releaseDate: (formData === null || formData === void 0 || (_formData$employeeAcc15 = formData.employeeAccidentInfo) === null || _formData$employeeAcc15 === void 0 ? void 0 : _formData$employeeAcc15.releaseDate) || null,
      hospitalDoctorName: (formData === null || formData === void 0 || (_formData$employeeAcc16 = formData.employeeAccidentInfo) === null || _formData$employeeAcc16 === void 0 ? void 0 : _formData$employeeAcc16.hospitalDoctorName) || ""
    }]),
    _useState20 = _slicedToArray(_useState19, 2),
    hospitalList = _useState20[0],
    setHospitalList = _useState20[1];

  // Handler to add a new empty hospital form
  var handleAddHospital = function handleAddHospital() {
    var newList = [].concat(_toConsumableArray(hospitalList), [{
      hospitalName: "",
      admitDate: null,
      admitTime: null,
      hospitalAddress: "",
      releaseDate: null,
      hospitalDoctorName: ""
    }]);
    setHospitalList(newList);
    handleChange("hospitalList", newList); // Updates parent formData with the array
  };

  // Handler to remove a hospital form by index
  var handleRemoveHospital = function handleRemoveHospital(index) {
    var newList = _toConsumableArray(hospitalList);
    newList.splice(index, 1);
    setHospitalList(newList);
    handleChange("hospitalList", newList);
  };

  // Handler to update specific fields within a specific hospital entry
  var handleHospitalFieldChange = function handleHospitalFieldChange(index, fieldName, value) {
    var newList = _toConsumableArray(hospitalList);
    newList[index] = _objectSpread$12(_objectSpread$12({}, newList[index]), {}, _defineProperty({}, fieldName, value));
    setHospitalList(newList);
    handleChange("hospitalList", newList);
  };
  useEffect(function () {
    var _formData$metadata, _formData$employeeAcc17, _formData$employeeAcc18, _formData$employeeAcc19, _formData$employeeAcc20;
    var metadataDeathDate = formData === null || formData === void 0 || (_formData$metadata = formData.metadata) === null || _formData$metadata === void 0 ? void 0 : _formData$metadata.deathDate;
    var accidentDeathDate = formData === null || formData === void 0 || (_formData$employeeAcc17 = formData.employeeAccidentInfo) === null || _formData$employeeAcc17 === void 0 ? void 0 : _formData$employeeAcc17.dateOfDeath;
    if (!(formData !== null && formData !== void 0 && (_formData$employeeAcc18 = formData.employeeAccidentInfo) !== null && _formData$employeeAcc18 !== void 0 && _formData$employeeAcc18.aidReasonType)) {
      handleChange("aidReasonType", aidReasonType);
    }
    if (!(formData !== null && formData !== void 0 && (_formData$employeeAcc19 = formData.employeeAccidentInfo) !== null && _formData$employeeAcc19 !== void 0 && _formData$employeeAcc19.admitted)) {
      handleChange("admitted", isAdmitted);
    }
    if (!(formData !== null && formData !== void 0 && (_formData$employeeAcc20 = formData.employeeAccidentInfo) !== null && _formData$employeeAcc20 !== void 0 && _formData$employeeAcc20.accidentMainType)) {
      handleChange("accidentMainType", selectedDocxAccidentType);
    }
    if (metadataDeathDate && !accidentDeathDate) {
      handleChange("dateOfDeath", metadataDeathDate);
    }
  }, []);

  // --- HANDLERS (PRESERVED) ---
  var handleOptionChange = function handleOptionChange(event) {
    var newValue = event.target.value;
    setAidReasonType(newValue);
    // Assuming original handleChange for top-level fields
    handleChange("aidReasonType", newValue);
  };
  var handleHasRejoinedChange = function handleHasRejoinedChange(event) {
    var value = event.target.value;
    setHasRejoined(value);
    handleChange("hasRejoined", value);
  };
  var handleAdmittedChange = function handleAdmittedChange(event) {
    var value = event.target.value;
    setIsAdmitted(value);
    handleChange("admitted", value);
  };

  // --- HANDLERS (NEW DOCX) ---
  var handleDocxAccidentTypeChange = function handleDocxAccidentTypeChange(event) {
    var value = event.target.value;
    setSelectedDocxAccidentType(value);
    handleChange("accidentMainType", value);
  };
  var handleOfficialOrderChange = function handleOfficialOrderChange(event) {
    var value = event.target.value;
    setOfficialOrderIssued(value);
    handleChange("officialOrderIssued", value);
  };
  var handleOfficialComplaintChange = function handleOfficialComplaintChange(event) {
    var value = event.target.value;
    setOfficialComplaint(value);
    handleChange("officialComplaint", value);
  };
  var handleOtherInjuredChange = function handleOtherInjuredChange(event) {
    var value = event.target.value;
    setOtherInjured(value);
    handleChange("otherInjured", value);
  };
  var isOutsideDutyHours = function isOutsideDutyHours() {
    var _formData$employeeAcc21, _formData$employeeAcc22, _formData$employeeAcc23;
    var startVal = formData === null || formData === void 0 || (_formData$employeeAcc21 = formData.employeeAccidentInfo) === null || _formData$employeeAcc21 === void 0 ? void 0 : _formData$employeeAcc21.dailyDutyStart;
    var endVal = formData === null || formData === void 0 || (_formData$employeeAcc22 = formData.employeeAccidentInfo) === null || _formData$employeeAcc22 === void 0 ? void 0 : _formData$employeeAcc22.dailyDutyEnd;
    var accidentVal = formData === null || formData === void 0 || (_formData$employeeAcc23 = formData.employeeAccidentInfo) === null || _formData$employeeAcc23 === void 0 ? void 0 : _formData$employeeAcc23.accidentTime;

    // Helper: Convert "09:05 PM", "21:05", or Date Objects to Total Minutes
    var getMinutes = function getMinutes(input) {
      if (!input) return null;

      // 1. Handle String with AM/PM (Your specific format: "09:05 PM")
      if (typeof input === "string" && input.match(/PM|AM/i)) {
        var match = input.match(/(\d+):(\d+)\s*(AM|PM)/i);
        if (match) {
          var _match = _slicedToArray(match, 4);
            _match[0];
            var hours = _match[1],
            minutes = _match[2],
            modifier = _match[3];
          hours = parseInt(hours, 10);
          minutes = parseInt(minutes, 10);

          // Convert to 24-hour format
          if (hours === 12 && modifier.toUpperCase() === "AM") {
            hours = 0; // 12 AM is 00:00
          } else if (hours !== 12 && modifier.toUpperCase() === "PM") {
            hours += 12; // 1 PM to 11 PM -> add 12
          }
          return hours * 60 + minutes;
        }
      }

      // 2. Handle String without AM/PM (24-hour format: "21:05")
      if (typeof input === "string" && input.includes(":")) {
        var _input$split$map = input.split(":").map(function (v) {
            return parseInt(v, 10);
          }),
          _input$split$map2 = _slicedToArray(_input$split$map, 2),
          h = _input$split$map2[0],
          m = _input$split$map2[1];
        if (!isNaN(h) && !isNaN(m)) {
          return h * 60 + m;
        }
      }

      // 3. Handle Date Objects (If the picker returns a Date object directly)
      if (input instanceof Date || _typeof(input) === "object" && input.toDate) {
        var d = input.toDate ? input.toDate() : input;
        return d.getHours() * 60 + d.getMinutes();
      }
      return null;
    };
    var startMins = getMinutes(startVal);
    var endMins = getMinutes(endVal);
    var accidentMins = getMinutes(accidentVal);

    // If calculation failed for any reason (missing data), hide the field
    if (startMins === null || endMins === null || accidentMins === null) {
      return false;
    }

    // LOGIC: Compare minutes
    if (startMins <= endMins) {
      // SCENARIO A: Standard Shift (e.g., 09:00 AM to 06:00 PM) -> (540 to 1080)
      // Outside if BEFORE start OR AFTER end
      return accidentMins < startMins || accidentMins > endMins;
    } else {
      // SCENARIO B: Night Shift crossing midnight (e.g., 10:00 PM to 06:00 AM)
      // Outside is the day time gap
      return accidentMins > endMins && accidentMins < startMins;
    }
  };
  console.log(formData);
  // --- RENDERING STARTS HERE ---
  return /*#__PURE__*/React.createElement(Box$1, {
    mt: 2
  }, /*#__PURE__*/React.createElement(Paper, {
    className: classes.paper,
    elevation: 0
  }, ((formData === null || formData === void 0 ? void 0 : formData.applicationType) !== "disabilityAssistance" || (formData === null || formData === void 0 ? void 0 : formData.organizationType) === "eis") && /*#__PURE__*/React.createElement(RadioGroup, {
    column: true,
    value: (formData === null || formData === void 0 || (_formData$employeeAcc24 = formData.employeeAccidentInfo) === null || _formData$employeeAcc24 === void 0 ? void 0 : _formData$employeeAcc24.aidReasonType) || aidReasonType || "disease",
    onChange: handleOptionChange
  }, /*#__PURE__*/React.createElement(FormControlLabel, {
    value: "accident",
    control: /*#__PURE__*/React.createElement(Radio, {
      color: "primary"
    }),
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.employee.aid.reason.info.accident"
    })
  })), /*#__PURE__*/React.createElement(Divider, {
    style: {
      margin: "16px 0"
    }
  }), aidReasonType === "accident" && /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 2
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    className: classes.item
  }, /*#__PURE__*/React.createElement(FormControl, {
    component: "fieldset",
    fullWidth: true
  }, /*#__PURE__*/React.createElement(FormLabel, null, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "workforce.accident.mainType.label",
    defaultMessage: "Type of Accident (Main Category - S.L 01)"
  })), /*#__PURE__*/React.createElement(RadioGroup, {
    row: true,
    value: selectedDocxAccidentType,
    onChange: handleDocxAccidentTypeChange
  }, Object.values(DOCX_ACCIDENT_TYPES).map(function (type) {
    return /*#__PURE__*/React.createElement(FormControlLabel, {
      key: type,
      value: type,
      control: /*#__PURE__*/React.createElement(Radio, {
        color: "primary"
      }),
      label: /*#__PURE__*/React.createElement(FormattedMessage, {
        id: type
      })
    });
  })), (errors === null || errors === void 0 ? void 0 : errors.accidentMainType) && /*#__PURE__*/React.createElement(FormHelperText, {
    error: true
  }, errors === null || errors === void 0 ? void 0 : errors.accidentMainType))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6,
    className: classes.item
  }, /*#__PURE__*/React.createElement(CustomTimePicker, {
    label: "workforce.accident.dailyDutyStart.label",
    value: (formData === null || formData === void 0 || (_formData$employeeAcc25 = formData.employeeAccidentInfo) === null || _formData$employeeAcc25 === void 0 ? void 0 : _formData$employeeAcc25.dailyDutyStart) || "",
    onChange: function onChange(value) {
      return handleChange("dailyDutyStart", value);
    }
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6,
    className: classes.item
  }, /*#__PURE__*/React.createElement(CustomTimePicker, {
    label: "workforce.accident.dailyDutyEnd.label",
    value: (formData === null || formData === void 0 || (_formData$employeeAcc26 = formData.employeeAccidentInfo) === null || _formData$employeeAcc26 === void 0 ? void 0 : _formData$employeeAcc26.dailyDutyEnd) || "",
    onChange: function onChange(value) {
      return handleChange("dailyDutyEnd", value);
    }
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6,
    className: classes.item
  }, /*#__PURE__*/React.createElement(PublishedComponent, {
    pubRef: "workforce.DatePicker",
    label: "workforce.employee.accident.info.joiningDate",
    value: (formData === null || formData === void 0 || (_formData$employeeAcc27 = formData.employeeAccidentInfo) === null || _formData$employeeAcc27 === void 0 ? void 0 : _formData$employeeAcc27.joiningDate) || "",
    onChange: function onChange(v) {
      return handleChange("joiningDate", v);
    },
    required: true
  }), (errors === null || errors === void 0 ? void 0 : errors.rdmp) && /*#__PURE__*/React.createElement(FormHelperText, {
    error: true
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: errors === null || errors === void 0 ? void 0 : errors.rdmp
  }))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6,
    className: classes.item
  }, /*#__PURE__*/React.createElement(PublishedComponent, {
    pubRef: "workforce.DatePicker",
    label: "workforce.employee.accident.info.dateOfAccident",
    value: (formData === null || formData === void 0 || (_formData$employeeAcc28 = formData.employeeAccidentInfo) === null || _formData$employeeAcc28 === void 0 ? void 0 : _formData$employeeAcc28.accidentDate) || "",
    onChange: function onChange(v) {
      return handleChange("accidentDate", v);
    },
    required: true
  }), (errors === null || errors === void 0 ? void 0 : errors.rdmp) && /*#__PURE__*/React.createElement(FormHelperText, {
    error: true
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: errors === null || errors === void 0 ? void 0 : errors.rdmp
  }))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6,
    className: classes.item
  }, /*#__PURE__*/React.createElement(CustomTimePicker, {
    id: "accidentTime",
    label: "workforce.employee.accident.info.timeOfAccident",
    value: (formData === null || formData === void 0 || (_formData$employeeAcc29 = formData.employeeAccidentInfo) === null || _formData$employeeAcc29 === void 0 ? void 0 : _formData$employeeAcc29.accidentTime) || "",
    onChange: function onChange(value) {
      return handleChange("accidentTime", value);
    },
    required: true
  })), isOutsideDutyHours() && /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    className: classes.item
  }, /*#__PURE__*/React.createElement(TextInput, {
    label: "workforce.accident.outsideDutyExplanation.label",
    value: (formData === null || formData === void 0 || (_formData$employeeAcc30 = formData.employeeAccidentInfo) === null || _formData$employeeAcc30 === void 0 ? void 0 : _formData$employeeAcc30.outsideDutyExplanation) || "",
    onChange: function onChange(v) {
      return handleChange("outsideDutyExplanation", v);
    },
    multiline: true,
    rows: 2
  })), selectedDocxAccidentType === DOCX_ACCIDENT_TYPES.WORKPLACE && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6,
    className: classes.item
  }, /*#__PURE__*/React.createElement(EmployeeAccidentTypePicker$1, {
    id: "accidentSpecificType",
    value: (formData === null || formData === void 0 || (_formData$employeeAcc31 = formData.employeeAccidentInfo) === null || _formData$employeeAcc31 === void 0 ? void 0 : _formData$employeeAcc31.accidentSpecificType) || "",
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.accident.specificType.label",
      defaultMessage: "Type of Accident"
    }),
    required: true,
    onChange: function onChange(v) {
      return handleChange("accidentSpecificType", v);
    },
    readOnly: false
  }), (errors === null || errors === void 0 ? void 0 : errors.accidentSpecificType) && /*#__PURE__*/React.createElement(FormHelperText, {
    error: true
  }, errors === null || errors === void 0 ? void 0 : errors.accidentSpecificType)), (formData === null || formData === void 0 || (_formData$employeeAcc32 = formData.employeeAccidentInfo) === null || _formData$employeeAcc32 === void 0 ? void 0 : _formData$employeeAcc32.accidentSpecificType) === "workforce.accident.type.others" && /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6,
    className: classes.item
  }, /*#__PURE__*/React.createElement(TextInput, {
    id: "otherAccidentType",
    label: "workforce.application.accident.otherAccidentType",
    value: (formData === null || formData === void 0 || (_formData$employeeAcc33 = formData.employeeAccidentInfo) === null || _formData$employeeAcc33 === void 0 ? void 0 : _formData$employeeAcc33.otherAccidentType) || "",
    required: true,
    onChange: function onChange(v) {
      return handleChange("otherAccidentType", v);
    },
    error: !!errors.otherAccidentType,
    helperText: errors.otherAccidentType
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6,
    className: classes.item
  }, /*#__PURE__*/React.createElement(EmployeeInsideOutsideFactoryPicker$1, {
    id: "inOutsideFactory",
    value: (formData === null || formData === void 0 || (_formData$employeeAcc34 = formData.employeeAccidentInfo) === null || _formData$employeeAcc34 === void 0 ? void 0 : _formData$employeeAcc34.inOutsideFactory) || "",
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.employee.accident.info.insideOutsideFactory",
      defaultMessage: "Place of Accident"
    }),
    required: true,
    onChange: function onChange(v) {
      return handleChange("inOutsideFactory", v);
    }
  }), (errors === null || errors === void 0 ? void 0 : errors.inOutsideFactory) && /*#__PURE__*/React.createElement(FormHelperText, {
    error: true
  }, errors === null || errors === void 0 ? void 0 : errors.inOutsideFactory)), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6,
    className: classes.item
  }, /*#__PURE__*/React.createElement(EmployeeDutyStatusPicker$1, {
    id: "dutyStatusWorkplace",
    value: (formData === null || formData === void 0 || (_formData$employeeAcc35 = formData.employeeAccidentInfo) === null || _formData$employeeAcc35 === void 0 ? void 0 : _formData$employeeAcc35.dutyStatusWorkplace) || "",
    label: "workforce.employee.accident.info.dutyStatus",
    onChange: function onChange(v) {
      return handleChange("dutyStatusWorkplace", v);
    },
    required: true
  }), (errors === null || errors === void 0 ? void 0 : errors.dutyStatusWorkplace) && /*#__PURE__*/React.createElement(FormHelperText, {
    error: true
  }, errors === null || errors === void 0 ? void 0 : errors.dutyStatusWorkplace)), ((formData === null || formData === void 0 || (_formData$employeeAcc36 = formData.employeeAccidentInfo) === null || _formData$employeeAcc36 === void 0 ? void 0 : _formData$employeeAcc36.inOutsideFactory) === "কর্মস্থল থেকে বাসায় যাওয়ার পথে" || (formData === null || formData === void 0 || (_formData$employeeAcc37 = formData.employeeAccidentInfo) === null || _formData$employeeAcc37 === void 0 ? void 0 : _formData$employeeAcc37.inOutsideFactory) === "বাসা থেকে কর্মস্থলে যাওয়ার পথে" || (formData === null || formData === void 0 || (_formData$employeeAcc38 = formData.employeeAccidentInfo) === null || _formData$employeeAcc38 === void 0 ? void 0 : _formData$employeeAcc38.inOutsideFactory) === "অন্যস্থানে") && /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6,
    className: classes.item
  }, /*#__PURE__*/React.createElement(TextInput, {
    id: "outOfFactoryPlace",
    label: "workforce.accident.outOfFactoryPlace.label",
    value: (formData === null || formData === void 0 || (_formData$employeeAcc39 = formData.employeeAccidentInfo) === null || _formData$employeeAcc39 === void 0 ? void 0 : _formData$employeeAcc39.outOfFactoryPlace) || "",
    onChange: function onChange(v) {
      return handleChange("outOfFactoryPlace", v);
    },
    required: true,
    error: !!errors.outOfFactoryPlace,
    helperText: errors.outOfFactoryPlace
  }))), (selectedDocxAccidentType === DOCX_ACCIDENT_TYPES.COMMUTING || selectedDocxAccidentType === DOCX_ACCIDENT_TYPES.ON_DUTY_RTA) && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6,
    className: classes.item
  }, /*#__PURE__*/React.createElement(CustomTimePicker, {
    label: "workforce.accident.journeyStartTime.label",
    value: (formData === null || formData === void 0 || (_formData$employeeAcc40 = formData.employeeAccidentInfo) === null || _formData$employeeAcc40 === void 0 ? void 0 : _formData$employeeAcc40.journeyStartTime) || "",
    onChange: function onChange(value) {
      return handleChange("journeyStartTime", value);
    }
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6,
    className: classes.item
  }, /*#__PURE__*/React.createElement(TextInput, {
    id: "journeyStartPoint",
    label: "workforce.accident.journeyStartPoint.label",
    value: (formData === null || formData === void 0 || (_formData$employeeAcc41 = formData.employeeAccidentInfo) === null || _formData$employeeAcc41 === void 0 ? void 0 : _formData$employeeAcc41.journeyStartPoint) || "",
    onChange: function onChange(v) {
      return handleChange("journeyStartPoint", v);
    },
    required: true,
    error: !!errors.journeyStartPoint,
    helperText: errors.journeyStartPoint
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6,
    className: classes.item
  }, /*#__PURE__*/React.createElement(TextInput, {
    id: "journeyDestination",
    label: "workforce.accident.journeyDestination.label",
    value: (formData === null || formData === void 0 || (_formData$employeeAcc42 = formData.employeeAccidentInfo) === null || _formData$employeeAcc42 === void 0 ? void 0 : _formData$employeeAcc42.journeyDestination) || "",
    onChange: function onChange(v) {
      return handleChange("journeyDestination", v);
    },
    required: true,
    error: !!errors.journeyDestination,
    helperText: errors.journeyDestination
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6,
    className: classes.item
  }, /*#__PURE__*/React.createElement(TextInput, {
    id: "modeOfTravel",
    label: "workforce.accident.modeOfTravel.label",
    value: (formData === null || formData === void 0 || (_formData$employeeAcc43 = formData.employeeAccidentInfo) === null || _formData$employeeAcc43 === void 0 ? void 0 : _formData$employeeAcc43.modeOfTravel) || "",
    onChange: function onChange(v) {
      return handleChange("modeOfTravel", v);
    },
    required: true,
    error: !!errors.modeOfTravel,
    helperText: errors.modeOfTravel
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    className: classes.item
  }, /*#__PURE__*/React.createElement(TextInput, {
    label: "workforce.accident.roadDescription.label",
    value: (formData === null || formData === void 0 || (_formData$employeeAcc44 = formData.employeeAccidentInfo) === null || _formData$employeeAcc44 === void 0 ? void 0 : _formData$employeeAcc44.roadDescription) || "",
    onChange: function onChange(v) {
      return handleChange("roadDescription", v);
    },
    multiline: true,
    rows: 2
  }))), selectedDocxAccidentType === DOCX_ACCIDENT_TYPES.ON_DUTY_RTA && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6,
    className: classes.item
  }, /*#__PURE__*/React.createElement(EmployeeDutyStatusPicker$1, {
    id: "dutyStatusRTA",
    value: (formData === null || formData === void 0 || (_formData$employeeAcc45 = formData.employeeAccidentInfo) === null || _formData$employeeAcc45 === void 0 ? void 0 : _formData$employeeAcc45.dutyStatusRTA) || "",
    label: "workforce.employee.accident.info.dutyStatus",
    onChange: function onChange(v) {
      return handleChange("dutyStatusRTA", v);
    },
    required: true
  }), (errors === null || errors === void 0 ? void 0 : errors.dutyStatusRTA) && /*#__PURE__*/React.createElement(FormHelperText, {
    error: true
  }, errors === null || errors === void 0 ? void 0 : errors.dutyStatusRTA)), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6,
    className: classes.item
  }, /*#__PURE__*/React.createElement(TextInput, {
    id: "travelPurpose",
    label: "workforce.accident.travelPurpose.label",
    value: (formData === null || formData === void 0 || (_formData$employeeAcc46 = formData.employeeAccidentInfo) === null || _formData$employeeAcc46 === void 0 ? void 0 : _formData$employeeAcc46.travelPurpose) || "",
    onChange: function onChange(v) {
      return handleChange("travelPurpose", v);
    },
    required: true,
    error: !!errors.travelPurpose,
    helperText: errors.travelPurpose
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6,
    className: classes.item
  }, /*#__PURE__*/React.createElement(FormControl, {
    component: "fieldset"
  }, /*#__PURE__*/React.createElement(FormLabel, null, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "workforce.accident.regularTravel.label"
  })), /*#__PURE__*/React.createElement(RadioGroup, {
    row: true,
    value: (formData === null || formData === void 0 || (_formData$employeeAcc47 = formData.employeeAccidentInfo) === null || _formData$employeeAcc47 === void 0 ? void 0 : _formData$employeeAcc47.regularTravel) || "no",
    onChange: function onChange(e) {
      return handleChange("regularTravel", e.target.value);
    }
  }, /*#__PURE__*/React.createElement(FormControlLabel, {
    value: "yes",
    control: /*#__PURE__*/React.createElement(Radio, {
      color: "primary"
    }),
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.application.permission.yes"
    })
  }), /*#__PURE__*/React.createElement(FormControlLabel, {
    value: "no",
    control: /*#__PURE__*/React.createElement(Radio, {
      color: "primary"
    }),
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.application.permission.no"
    })
  })))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6,
    className: classes.item
  }, /*#__PURE__*/React.createElement(FormControl, {
    component: "fieldset"
  }, /*#__PURE__*/React.createElement(FormLabel, null, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "workforce.accident.officialOrderIssued.label"
  })), /*#__PURE__*/React.createElement(RadioGroup, {
    row: true,
    value: officialOrderIssued,
    onChange: handleOfficialOrderChange
  }, /*#__PURE__*/React.createElement(FormControlLabel, {
    value: "yes",
    control: /*#__PURE__*/React.createElement(Radio, {
      color: "primary"
    }),
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.application.permission.yes"
    })
  }), /*#__PURE__*/React.createElement(FormControlLabel, {
    value: "no",
    control: /*#__PURE__*/React.createElement(Radio, {
      color: "primary"
    }),
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.application.permission.no"
    })
  })))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    className: classes.item
  }, /*#__PURE__*/React.createElement(TextInput, {
    label: "workforce.accident.workEngagedIn.label",
    value: (formData === null || formData === void 0 || (_formData$employeeAcc48 = formData.employeeAccidentInfo) === null || _formData$employeeAcc48 === void 0 ? void 0 : _formData$employeeAcc48.workEngagedIn) || "",
    onChange: function onChange(v) {
      return handleChange("workEngagedIn", v);
    },
    multiline: true,
    rows: 2
  }))), /*#__PURE__*/React.createElement(Divider, {
    style: {
      margin: "16px 0"
    }
  }), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    className: classes.item
  }, /*#__PURE__*/React.createElement(TextInput, {
    id: "detailsOfAccident",
    label: "workforce.accident.detailsOfAccident.label",
    value: (formData === null || formData === void 0 || (_formData$employeeAcc49 = formData.employeeAccidentInfo) === null || _formData$employeeAcc49 === void 0 ? void 0 : _formData$employeeAcc49.detailsOfAccident) || "",
    onChange: function onChange(v) {
      return handleChange("detailsOfAccident", v);
    },
    required: true,
    multiline: true,
    rows: 3,
    error: !!(errors !== null && errors !== void 0 && errors.detailsOfAccident),
    helperText: errors === null || errors === void 0 ? void 0 : errors.detailsOfAccident
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    className: classes.item
  }, /*#__PURE__*/React.createElement(FormControl, {
    component: "fieldset"
  }, /*#__PURE__*/React.createElement(FormLabel, null, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "workforce.accident.otherInjured.label"
  })), /*#__PURE__*/React.createElement(RadioGroup, {
    row: true,
    value: otherInjured,
    onChange: handleOtherInjuredChange
  }, /*#__PURE__*/React.createElement(FormControlLabel, {
    value: "yes",
    control: /*#__PURE__*/React.createElement(Radio, {
      color: "primary"
    }),
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.application.permission.yes"
    })
  }), /*#__PURE__*/React.createElement(FormControlLabel, {
    value: "no",
    control: /*#__PURE__*/React.createElement(Radio, {
      color: "primary"
    }),
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.application.permission.no"
    })
  })))), otherInjured === "yes" && /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    className: classes.item
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle2",
    gutterBottom: true
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "workforce.accident.otherInjuredName.label"
  })), /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 2
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement(TextInput, {
    label: "workforce.employee.name",
    value: (formData === null || formData === void 0 || (_formData$employeeAcc50 = formData.employeeAccidentInfo) === null || _formData$employeeAcc50 === void 0 ? void 0 : _formData$employeeAcc50.otherInjuredName) || "",
    onChange: function onChange(v) {
      return handleChange("otherInjuredName", v);
    }
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement(TextInput, {
    label: "workforce.employee.designation",
    value: (formData === null || formData === void 0 || (_formData$employeeAcc51 = formData.employeeAccidentInfo) === null || _formData$employeeAcc51 === void 0 ? void 0 : _formData$employeeAcc51.otherInjuredDesignation) || "",
    onChange: function onChange(v) {
      return handleChange("otherInjuredDesignation", v);
    }
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement(TextInput, {
    label: "workforce.employee.phone",
    value: (formData === null || formData === void 0 || (_formData$employeeAcc52 = formData.employeeAccidentInfo) === null || _formData$employeeAcc52 === void 0 ? void 0 : _formData$employeeAcc52.otherInjuredPhone) || "",
    onChange: function onChange(v) {
      return handleChange("otherInjuredPhone", v);
    }
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement(TextInput, {
    label: "workforce.accident.otherInjuredType.label",
    value: (formData === null || formData === void 0 || (_formData$employeeAcc53 = formData.employeeAccidentInfo) === null || _formData$employeeAcc53 === void 0 ? void 0 : _formData$employeeAcc53.otherInjuredType) || "",
    onChange: function onChange(v) {
      return handleChange("otherInjuredType", v);
    }
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6,
    className: classes.item
  }, /*#__PURE__*/React.createElement(FormControl, {
    component: "fieldset",
    fullWidth: true
  }, /*#__PURE__*/React.createElement(FormLabel, null, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "workforce.accident.otherInjuredBenefit.label"
  })), /*#__PURE__*/React.createElement(RadioGroup, {
    row: true,
    value: (formData === null || formData === void 0 || (_formData$employeeAcc54 = formData.employeeAccidentInfo) === null || _formData$employeeAcc54 === void 0 ? void 0 : _formData$employeeAcc54.otherInjuredBenefit) || "no",
    onChange: function onChange(e) {
      return handleChange("otherInjuredBenefit", e.target.value, "employeeAccidentInfo");
    }
  }, /*#__PURE__*/React.createElement(FormControlLabel, {
    value: "yes",
    control: /*#__PURE__*/React.createElement(Radio, {
      color: "primary"
    }),
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.application.permission.yes"
    })
  }), /*#__PURE__*/React.createElement(FormControlLabel, {
    value: "no",
    control: /*#__PURE__*/React.createElement(Radio, {
      color: "primary"
    }),
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.application.permission.no"
    })
  })))), (formData === null || formData === void 0 || (_formData$employeeAcc55 = formData.employeeAccidentInfo) === null || _formData$employeeAcc55 === void 0 ? void 0 : _formData$employeeAcc55.otherInjuredBenefit) === "yes" && /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6,
    className: classes.item
  }, /*#__PURE__*/React.createElement(TextInput, {
    label: "workforce.accident.otherInjuredTracking.label",
    value: (formData === null || formData === void 0 || (_formData$employeeAcc56 = formData.employeeAccidentInfo) === null || _formData$employeeAcc56 === void 0 ? void 0 : _formData$employeeAcc56.otherInjuredTracking) || "",
    onChange: function onChange(v) {
      return handleChange("otherInjuredTracking", v, "employeeAccidentInfo");
    }
  })))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6,
    className: classes.item
  }, /*#__PURE__*/React.createElement(FormControl, {
    component: "fieldset"
  }, /*#__PURE__*/React.createElement(FormLabel, null, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "workforce.accident.officialComplaint.label"
  })), /*#__PURE__*/React.createElement(RadioGroup, {
    row: true,
    value: officialComplaint,
    onChange: handleOfficialComplaintChange
  }, /*#__PURE__*/React.createElement(FormControlLabel, {
    value: "yes",
    control: /*#__PURE__*/React.createElement(Radio, {
      color: "primary"
    }),
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.application.permission.yes"
    })
  }), /*#__PURE__*/React.createElement(FormControlLabel, {
    value: "no",
    control: /*#__PURE__*/React.createElement(Radio, {
      color: "primary"
    }),
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.application.permission.no"
    })
  })))), /*#__PURE__*/React.createElement(Divider, {
    style: {
      margin: "16px 0"
    }
  }), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    className: classes.item
  }, /*#__PURE__*/React.createElement(FormControl, {
    component: "fieldset"
  }, /*#__PURE__*/React.createElement(FormLabel, null, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "workforce.accident.hospitalized.label"
  })), /*#__PURE__*/React.createElement(RadioGroup, {
    row: true,
    value: isAdmitted,
    onChange: handleAdmittedChange
  }, /*#__PURE__*/React.createElement(FormControlLabel, {
    value: "yes",
    control: /*#__PURE__*/React.createElement(Radio, {
      color: "primary"
    }),
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.application.permission.yes"
    })
  }), /*#__PURE__*/React.createElement(FormControlLabel, {
    value: "no",
    control: /*#__PURE__*/React.createElement(Radio, {
      color: "primary"
    }),
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.application.permission.no"
    })
  })))), isAdmitted === "yes" && /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, hospitalList.map(function (hospital, index) {
    return /*#__PURE__*/React.createElement(Box$1, {
      key: index,
      mb: 2,
      p: 2,
      border: 1,
      borderColor: "grey.300",
      borderRadius: 4,
      style: {
        backgroundColor: "#fafafa"
      }
    }, /*#__PURE__*/React.createElement(Grid, {
      container: true,
      spacing: 2
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      style: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center"
      }
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "subtitle2",
      style: {
        fontWeight: "bold"
      }
    }, /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.accident.hospitalInfo.title",
      defaultMessage: "Hospital Information"
    }), " #", index + 1), hospitalList.length > 1 && /*#__PURE__*/React.createElement(IconButton, {
      size: "small",
      onClick: function onClick() {
        return handleRemoveHospital(index);
      },
      style: {
        color: "red"
      }
    }, /*#__PURE__*/React.createElement(DeleteIcon, null))), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 6
    }, /*#__PURE__*/React.createElement(TextInput, {
      label: "workforce.accident.hospitalName.label",
      value: hospital.hospitalName || "",
      onChange: function onChange(v) {
        return handleHospitalFieldChange(index, "hospitalName", v);
      }
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 6
    }, /*#__PURE__*/React.createElement(PublishedComponent, {
      pubRef: "workforce.DatePicker",
      label: "workforce.accident.admitDate.label",
      value: hospital.admitDate || "",
      onChange: function onChange(v) {
        return handleHospitalFieldChange(index, "admitDate", v);
      }
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 6
    }, /*#__PURE__*/React.createElement(CustomTimePicker, {
      label: "workforce.accident.admitTime.label",
      value: hospital.admitTime || "",
      onChange: function onChange(v) {
        return handleHospitalFieldChange(index, "admitTime", v);
      }
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 6
    }, /*#__PURE__*/React.createElement(TextInput, {
      label: "workforce.accident.hospitalAddress.label",
      value: hospital.hospitalAddress || "",
      onChange: function onChange(v) {
        return handleHospitalFieldChange(index, "hospitalAddress", v);
      },
      multiline: true
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 6
    }, /*#__PURE__*/React.createElement(PublishedComponent, {
      pubRef: "workforce.DatePicker",
      label: "workforce.employee.accident.info.releaseDate",
      value: hospital.releaseDate || "",
      onChange: function onChange(v) {
        return handleHospitalFieldChange(index, "releaseDate", v);
      },
      readOnly: false,
      required: true
    }), (errors === null || errors === void 0 ? void 0 : errors.rdmp) && /*#__PURE__*/React.createElement(FormHelperText, {
      error: true
    }, /*#__PURE__*/React.createElement(FormattedMessage, {
      id: errors === null || errors === void 0 ? void 0 : errors.rdmp
    }))), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 6
    }, /*#__PURE__*/React.createElement(TextInput, {
      label: "workforce.accident.hospitalDoctorName.label",
      value: hospital.hospitalDoctorName || "",
      onChange: function onChange(v) {
        return handleHospitalFieldChange(index, "hospitalDoctorName", v);
      }
    }))));
  }), /*#__PURE__*/React.createElement(Typography, {
    style: {
      color: "red"
    }
  }, "**", /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "workforce.add.hospital.info"
  }), "**"), /*#__PURE__*/React.createElement(Box$1, {
    mt: 1
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "outlined",
    color: "primary",
    startIcon: /*#__PURE__*/React.createElement(AddIcon, null),
    onClick: handleAddHospital
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "workforce.accident.addHospital.btn",
    defaultMessage: "Add Another Hospital"
  })))), (formData === null || formData === void 0 ? void 0 : formData.applicationType) === "financialAssistance" && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Divider, {
    style: {
      margin: "16px 0"
    }
  }), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6,
    className: classes.item
  }, /*#__PURE__*/React.createElement(TextInput, {
    label: "workforce.accident.placeOfDeath.label",
    value: (formData === null || formData === void 0 || (_formData$employeeAcc57 = formData.employeeAccidentInfo) === null || _formData$employeeAcc57 === void 0 ? void 0 : _formData$employeeAcc57.placeOfDeath) || "",
    onChange: function onChange(v) {
      return handleChange("placeOfDeath", v);
    }
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6,
    className: classes.item
  }, /*#__PURE__*/React.createElement(PublishedComponent, {
    pubRef: "workforce.DatePicker",
    label: "workforce.accident.dateOfDeath.label",
    value: (formData === null || formData === void 0 || (_formData$employeeAcc58 = formData.employeeAccidentInfo) === null || _formData$employeeAcc58 === void 0 ? void 0 : _formData$employeeAcc58.dateOfDeath) || "",
    onChange: function onChange(v) {
      return handleChange("dateOfDeath", v);
    }
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6,
    className: classes.item
  }, /*#__PURE__*/React.createElement(CustomTimePicker, {
    label: "workforce.accident.timeOfDeath.label",
    value: (formData === null || formData === void 0 || (_formData$employeeAcc59 = formData.employeeAccidentInfo) === null || _formData$employeeAcc59 === void 0 ? void 0 : _formData$employeeAcc59.timeOfDeath) || "",
    onChange: function onChange(value) {
      return handleChange("timeOfDeath", value);
    }
  }))), applicationType === "disabilityAssistance" && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Divider, {
    style: {
      margin: "16px 0"
    }
  }), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6,
    className: classes.item
  }, /*#__PURE__*/React.createElement(FormControl, {
    component: "fieldset"
  }, /*#__PURE__*/React.createElement(FormLabel, null, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "workforce.employee.accident.info.hasRejoined"
  })), /*#__PURE__*/React.createElement(RadioGroup, {
    row: true,
    value: hasRejoined,
    onChange: handleHasRejoinedChange
  }, /*#__PURE__*/React.createElement(FormControlLabel, {
    value: "yes",
    control: /*#__PURE__*/React.createElement(Radio, {
      color: "primary"
    }),
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.application.permission.yes"
    })
  }), /*#__PURE__*/React.createElement(FormControlLabel, {
    value: "no",
    control: /*#__PURE__*/React.createElement(Radio, {
      color: "primary"
    }),
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.application.permission.no"
    })
  })))), hasRejoined === "yes" && /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6,
    className: classes.item
  }, /*#__PURE__*/React.createElement(PublishedComponent, {
    pubRef: "workforce.DatePicker",
    label: "workforce.employee.accident.info.reJoiningDate",
    value: (formData === null || formData === void 0 || (_formData$employeeAcc60 = formData.employeeAccidentInfo) === null || _formData$employeeAcc60 === void 0 ? void 0 : _formData$employeeAcc60.dateOfRejoining) || "",
    onChange: function onChange(v) {
      return handleChange("dateOfRejoining", v);
    },
    required: true
  }), (errors === null || errors === void 0 ? void 0 : errors.rdmp) && /*#__PURE__*/React.createElement(FormHelperText, {
    error: true
  }, errors === null || errors === void 0 ? void 0 : errors.rdmp))))), (formData === null || formData === void 0 ? void 0 : formData.applicationType) === "disabilityAssistance" && user_type != WORKFORCE_USER_TYPE.EIS_COORDINATOR && /*#__PURE__*/React.createElement(EmployeeDetailsForm2, {
    errors: errors,
    handleChange: function handleChange() {},
    formData: formData,
    selectedApplicationType: formData.applicationType,
    formStepNo: "employeeAccidentInfo"
  }));
};

var useStyles$1n = makeStyles(function (theme) {
  return {
    paper: {
      padding: theme.spacing(2),
      "@media print": {
        padding: 0,
        border: "none",
        boxShadow: "none" // Good to add for print
      }
    },
    item: {
      marginBottom: theme.spacing(2),
      "@media print": {
        pageBreakInside: "avoid"
      }
    },
    title: {
      fontWeight: 800
    },
    sectionTitle: {
      fontWeight: "bold",
      marginBottom: theme.spacing(1)
    },
    doctorCard: {
      border: "1px solid #ddd",
      padding: theme.spacing(2),
      marginBottom: theme.spacing(2),
      borderRadius: 8
    },
    removeBtn: {
      color: theme.palette.error.main
    },
    docTitle: {
      fontWeight: "bold",
      fontSize: "18px",
      textAlign: "center",
      textTransform: "uppercase",
      color: "#006273"
    },
    docSubTitle: {
      fontWeight: "bold",
      fontSize: "16px",
      textAlign: "center",
      marginBottom: "4px",
      color: "#006273"
    },
    docText: {
      fontSize: "12px",
      textAlign: "center",
      fontFamily: "Arial, sans-serif",
      color: "#006273"
    },
    signatureContainer: {
      marginTop: "60px",
      width: "100%",
      // Ensure the signature block doesn't break across pages awkwardly
      pageBreakInside: "avoid"
    },
    signatureBlock: {
      // marginTop: "40px",
      borderTop: "1px solid #000",
      paddingTop: "5px",
      fontSize: "11px",
      whiteSpace: "pre-line",
      lineHeight: 1.2,
      color: "#000"
    },
    overrideReadOnly: {
      "& .MuiInputBase-root.Mui-disabled": {
        color: "#808080 !important"
      },
      "& .MuiFormLabel-root.Mui-disabled": {
        color: "".concat(theme.palette.text.primary, " !important")
      }
    }
  };
});
var EisDoctorEntries = function EisDoctorEntries(_ref) {
  var _formData$employeeAcc, _meetingData$3, _formData$doctorsEntr, _formData$employeeAcc2, _meetingData$4, _formData$doctorsEntr2, _formData$employeeAcc3, _formData$employeeAcc4, _formData$doctorsEntr3, _formData$employeeAcc5, _formData$doctorsEntr4, _formData$employeeAcc6, _formData$doctorsEntr5, _formData$employeeAcc7, _formData$doctorsEntr6, _formData$employeeAcc8, _formData$doctorsEntr7, _formData$doctorsEntr8, _formData$employeeAcc9, _formData$doctorsEntr9, _formData$employeeAcc10, _formData$doctorsEntr10;
  var handleChange = _ref.handleChange,
    formData = _ref.formData;
    _ref.setFormData;
    _ref.applicationType;
    _ref.errors;
  var classes = useStyles$1n();
  var dispatch = useDispatch();
  var modulesManager = useModulesManager();
  var user_type = getUserType();
  var _useTranslations = useTranslations("core.RegistrationPage", modulesManager);
    _useTranslations.formatMessage;
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2);
    _useState2[0];
    var setMovements = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2);
    _useState4[0];
    var setLastRevertMovement = _useState4[1];
  var _useState5 = useState([]),
    _useState6 = _slicedToArray(_useState5, 2);
    _useState6[0];
    var setRevertNotes = _useState6[1];
  var _useState7 = useState([]),
    _useState8 = _slicedToArray(_useState7, 2),
    eisApprovalSignature = _useState8[0],
    setEisApprovalSignature = _useState8[1];
  var summaryData = useSelector(function (state) {
    var _state$workforce;
    return (_state$workforce = state.workforce["applicationsSummary"]) !== null && _state$workforce !== void 0 ? _state$workforce : [];
  });
  //   const meetingData = summaryData?.find(m => {
  //   if (!m?.applicationData) return false;

  //   try {
  //     const rawArray = JSON.parse(m.applicationData);           // ["base64id1", "base64id2", ...]
  //     console.log("Raw applicationData array:", rawArray);

  //     if (!Array.isArray(rawArray) || rawArray.length === 0) {
  //       console.warn("applicationData parsed but not useful array", rawArray);
  //       return false;
  //     }

  //     // Try both ways — most projects are inconsistent here
  //     const decodedIds = rawArray.map(id => {
  //       const dec = safeDecodeId(id);
  //       console.log(`Decoded: ${id} → ${dec}`);
  //       return dec;
  //     });

  //     const targetId = formData?.id;
  //     console.log("Target formData.id =", targetId);

  //     // Variant A: compare decoded vs decoded
  //     const foundA = decodedIds.some(decoded => decoded === targetId);

  //     // Variant B: compare encoded vs encoded (most common bug pattern)
  //     const foundB = rawArray.some(encoded => encoded === targetId);

  //     console.log({ foundA, foundB, targetId });

  //     return foundA || foundB;

  //   } catch (err) {
  //     console.error("Failed to parse applicationData:", m.id, err);
  //     return false;
  //   }
  // });

  var meetingData = summaryData === null || summaryData === void 0 ? void 0 : summaryData.filter(function (m) {
    var parsedApplicationData = safeParse(m === null || m === void 0 ? void 0 : m.applicationData);
    if (Array.isArray(parsedApplicationData)) {
      return parsedApplicationData.includes(formData === null || formData === void 0 ? void 0 : formData.id);
    }
    if (parsedApplicationData && _typeof(parsedApplicationData) === "object") {
      return Object.values(parsedApplicationData).includes(formData === null || formData === void 0 ? void 0 : formData.id);
    }
    return false;
  });
  // const meetingData = summaryData?.filter((m) => {
  //   const parsedApplicationData = safeParse(m?.applicationData);
  //   console.log({ parsedApplicationData });
  //   // const decodedApplicationData = safeDecodeId(parsedApplicationData)
  //   return parsedApplicationData?.includes(formData?.id);
  // });

  console.log("Final meetingData:", meetingData);
  console.log({
    fromDoctor: meetingData
  });
  var _useState9 = useState((formData === null || formData === void 0 || (_formData$employeeAcc = formData.employeeAccidentInfo) === null || _formData$employeeAcc === void 0 ? void 0 : _formData$employeeAcc.hasLimitations) || "no"),
    _useState10 = _slicedToArray(_useState9, 2),
    hasLimitations = _useState10[0],
    setHasLimitations = _useState10[1];
  console.log("eis doctors entry", formData);
  var fetchApplicationMovement = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _response$payload, _rawMovements$, firstAppId, response, rawData, rawMovements, actualNodes, senderIds, clean, lastRevert;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            // 1. Get Application ID
            firstAppId = formData === null || formData === void 0 ? void 0 : formData.id;
            if (firstAppId) {
              _context.next = 5;
              break;
            }
            console.log("No valid application ID found.");
            return _context.abrupt("return");
          case 5:
            _context.next = 7;
            return dispatch(fetchApplicationWiseMovementList(modulesManager, {
              applicationId: firstAppId
            }));
          case 7:
            response = _context.sent;
            // 3. Parse Data
            rawData = response === null || response === void 0 || (_response$payload = response.payload) === null || _response$payload === void 0 || (_response$payload = _response$payload.data) === null || _response$payload === void 0 ? void 0 : _response$payload.workforceApplicationMovement;
            rawMovements = []; // Handle parsing if it's a string, or use directly if object
            if (typeof rawData === "string") {
              try {
                rawMovements = JSON.parse(rawData);
              } catch (e) {}
            } else {
              rawMovements = rawData || [];
            }

            // Ensure it is an array
            if (!Array.isArray(rawMovements)) rawMovements = [rawMovements];

            // 4. Extract Nodes from 'edges'
            actualNodes = [];
            if (rawMovements.length > 0 && (_rawMovements$ = rawMovements[0]) !== null && _rawMovements$ !== void 0 && _rawMovements$.edges) {
              actualNodes = rawMovements[0].edges.map(function (edge) {
                return edge.node;
              });
            } else {
              actualNodes = rawMovements;
            }

            // 5. Extract IDs
            senderIds = actualNodes.filter(function (item) {
              return (item === null || item === void 0 ? void 0 : item.status) === "forward_to_doctor";
            }).map(function (item) {
              var _node$applicationTo;
              var node = item.node || item; // Handle if double nested
              return node !== null && node !== void 0 && (_node$applicationTo = node.applicationTo) !== null && _node$applicationTo !== void 0 && _node$applicationTo.id ? safeDecodeId(node.applicationTo.id) : null;
            }).filter(function (id) {
              return id !== null;
            });
            console.log({
              senderIds: senderIds
            });
            console.log("Sender IDs List:", senderIds);
            _context.next = 19;
            return dispatch(fetchWorkforceSignatures(_toConsumableArray(senderIds))).then(function (res) {
              var _res$payload;
              console.log("signature response", res);
              setEisApprovalSignature(res === null || res === void 0 || (_res$payload = res.payload) === null || _res$payload === void 0 || (_res$payload = _res$payload.data) === null || _res$payload === void 0 ? void 0 : _res$payload.workforceSignatures);
            });
          case 19:
            // 6. Revert Note Logic
            clean = function clean(html) {
              return (html === null || html === void 0 ? void 0 : html.replace(/<\/?[^>]+(>|$)/g, "")) || "";
            };
            lastRevert = _toConsumableArray(actualNodes).reverse().find(function (m) {
              return m.revertNote;
            });
            if (lastRevert) lastRevert.revertNote = clean(lastRevert.revertNote);
            setMovements(actualNodes);
            setLastRevertMovement(lastRevert);
            setRevertNotes(lastRevert ? [lastRevert.revertNote] : []);
            _context.next = 30;
            break;
          case 27:
            _context.prev = 27;
            _context.t0 = _context["catch"](0);
            console.error("Failed to load application movements", _context.t0);
          case 30:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 27]]);
    }));
    return function fetchApplicationMovement() {
      return _ref2.apply(this, arguments);
    };
  }();
  useEffect(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    var _meetingData$, _meetingData$2;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          fetchApplicationMovement();
          handleChange("dateOfAssessment", meetingData === null || meetingData === void 0 || (_meetingData$ = meetingData[0]) === null || _meetingData$ === void 0 ? void 0 : _meetingData$.meetingDate);
          handleChange("nameOfAssessmentMeeting", meetingData === null || meetingData === void 0 || (_meetingData$2 = meetingData[0]) === null || _meetingData$2 === void 0 ? void 0 : _meetingData$2.name);
        case 3:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  })), []);
  var handleLimitationsChange = function handleLimitationsChange(event) {
    var value = event.target.value;
    setHasLimitations(value);
    handleChange("hasLimitations", value);
  };

  // console.log({fromDoctor:meetingData});
  return /*#__PURE__*/React.createElement(Box$1, {
    mt: 2
  }, user_type === WORKFORCE_USER_TYPE.EIS_COORDINATOR && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography, {
    className: classes.docTitle
  }, "Employment Injury Scheme-Pilot"), /*#__PURE__*/React.createElement(Typography, {
    className: classes.docSubTitle
  }, "Disability Assessment Meeting"), /*#__PURE__*/React.createElement(Typography, {
    className: classes.docText
  }, "EIS PILOT Special Unit, 196, Sromo Bhaban (9th Floor), Bijoynagar, Dhaka, 1000"), /*#__PURE__*/React.createElement(Typography, {
    className: classes.docText
  }, "Email: specialunit@eis-pilot-bd.org, Phone: 01886-921030, Website: eis-pilot-bd.org"), /*#__PURE__*/React.createElement(Box$1, {
    mt: 3,
    mb: 1
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    justify: "space-between"
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true
  }, /*#__PURE__*/React.createElement(Typography, {
    style: {
      fontWeight: "bold",
      fontSize: "12px",
      fontFamily: "Arial"
    }
  }, user_type === WORKFORCE_USER_TYPE.EIS_DOCTOR && "EIS-GB Sub Committee Meeting No: 16")), /*#__PURE__*/React.createElement(Grid, {
    item: true
  }, /*#__PURE__*/React.createElement(Typography, {
    style: {
      fontWeight: "bold",
      fontSize: "12px",
      fontFamily: "Arial"
    }
  }, "Date: ", new Date().toLocaleDateString()))))), /*#__PURE__*/React.createElement(Paper, {
    className: classes.paper,
    elevation: 0
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6",
    className: classes.sectionTitle
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "workforce.disability.assessmentDetails",
    defaultMessage: "Assessment Details"
  })), /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 2
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6,
    className: clsx(classes.item, classes.overrideReadOnly)
  }, /*#__PURE__*/React.createElement(PublishedComponent, {
    pubRef: "workforce.DatePicker",
    label: "workforce.disability.dateOfAssessment",
    value: (meetingData === null || meetingData === void 0 || (_meetingData$3 = meetingData[0]) === null || _meetingData$3 === void 0 ? void 0 : _meetingData$3.meetingDate) || (formData === null || formData === void 0 || (_formData$doctorsEntr = formData.doctorsEntry) === null || _formData$doctorsEntr === void 0 ? void 0 : _formData$doctorsEntr.dateOfAssessment) || (formData === null || formData === void 0 || (_formData$employeeAcc2 = formData.employeeAccidentInfo) === null || _formData$employeeAcc2 === void 0 ? void 0 : _formData$employeeAcc2.dateOfAssessment) || "",
    onChange: function onChange(v) {
      return handleChange("dateOfAssessment", v);
    },
    required: true,
    readOnly: user_type === WORKFORCE_USER_TYPE.EIS_COORDINATOR
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6,
    className: clsx(classes.item, classes.overrideReadOnly)
  }, /*#__PURE__*/React.createElement(TextInput, {
    label: "workforce.disability.nameOfAssessmentMeeting",
    value: (meetingData === null || meetingData === void 0 || (_meetingData$4 = meetingData[0]) === null || _meetingData$4 === void 0 ? void 0 : _meetingData$4.name) || (formData === null || formData === void 0 || (_formData$doctorsEntr2 = formData.doctorsEntry) === null || _formData$doctorsEntr2 === void 0 ? void 0 : _formData$doctorsEntr2.nameOfAssessmentMeeting) || (formData === null || formData === void 0 || (_formData$employeeAcc3 = formData.employeeAccidentInfo) === null || _formData$employeeAcc3 === void 0 ? void 0 : _formData$employeeAcc3.nameOfAssessmentMeeting) || "",
    onChange: function onChange(v) {
      return handleChange("nameOfAssessmentMeeting", v);
    },
    required: true,
    readOnly: user_type === WORKFORCE_USER_TYPE.EIS_COORDINATOR
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    className: clsx(classes.item, classes.overrideReadOnly)
  }, /*#__PURE__*/React.createElement(TextInput, {
    multiline: true,
    rows: 6,
    label: "workforce.disability.briefInjuryDescription",
    value: (formData === null || formData === void 0 || (_formData$employeeAcc4 = formData.employeeAccidentInfo) === null || _formData$employeeAcc4 === void 0 ? void 0 : _formData$employeeAcc4.briefInjuryDescription) || (formData === null || formData === void 0 || (_formData$doctorsEntr3 = formData.doctorsEntry) === null || _formData$doctorsEntr3 === void 0 ? void 0 : _formData$doctorsEntr3.briefInjuryDescription) || "",
    onChange: function onChange(v) {
      return handleChange("briefInjuryDescription", v);
    },
    required: true,
    readOnly: user_type === WORKFORCE_USER_TYPE.EIS_COORDINATOR
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    className: clsx(classes.item, classes.overrideReadOnly)
  }, /*#__PURE__*/React.createElement(TextInput, {
    multiline: true,
    rows: 6,
    label: "workforce.disability.briefTreatmentDescription",
    value: (formData === null || formData === void 0 || (_formData$employeeAcc5 = formData.employeeAccidentInfo) === null || _formData$employeeAcc5 === void 0 ? void 0 : _formData$employeeAcc5.briefTreatmentDescription) || (formData === null || formData === void 0 || (_formData$doctorsEntr4 = formData.doctorsEntry) === null || _formData$doctorsEntr4 === void 0 ? void 0 : _formData$doctorsEntr4.briefTreatmentDescription) || "",
    onChange: function onChange(v) {
      return handleChange("briefTreatmentDescription", v);
    },
    required: true,
    readOnly: user_type === WORKFORCE_USER_TYPE.EIS_COORDINATOR
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    className: classes.item
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle1",
    className: classes.sectionTitle
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "workforce.disability.physicalExamination",
    defaultMessage: "Physical Examination Findings"
  }))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6,
    className: clsx(classes.item, classes.overrideReadOnly)
  }, /*#__PURE__*/React.createElement(TextInput, {
    label: "workforce.disability.injurySiteLocation",
    value: (formData === null || formData === void 0 || (_formData$employeeAcc6 = formData.employeeAccidentInfo) === null || _formData$employeeAcc6 === void 0 ? void 0 : _formData$employeeAcc6.injurySiteLocation) || (formData === null || formData === void 0 || (_formData$doctorsEntr5 = formData.doctorsEntry) === null || _formData$doctorsEntr5 === void 0 ? void 0 : _formData$doctorsEntr5.injurySiteLocation) || "",
    onChange: function onChange(v) {
      return handleChange("injurySiteLocation", v);
    },
    required: true,
    readOnly: user_type === WORKFORCE_USER_TYPE.EIS_COORDINATOR
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6,
    className: clsx(classes.item, classes.overrideReadOnly)
  }, /*#__PURE__*/React.createElement(TextInput
  //   multiline
  //   rows={4}
  , {
    label: "workforce.disability.injuryDetailsDescription",
    value: (formData === null || formData === void 0 || (_formData$employeeAcc7 = formData.employeeAccidentInfo) === null || _formData$employeeAcc7 === void 0 ? void 0 : _formData$employeeAcc7.injuryDetailsDescription) || (formData === null || formData === void 0 || (_formData$doctorsEntr6 = formData.doctorsEntry) === null || _formData$doctorsEntr6 === void 0 ? void 0 : _formData$doctorsEntr6.injuryDetailsDescription) || "",
    onChange: function onChange(v) {
      return handleChange("injuryDetailsDescription", v);
    },
    required: true,
    readOnly: user_type === WORKFORCE_USER_TYPE.EIS_COORDINATOR
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    className: clsx(classes.item, classes.overrideReadOnly)
  }, /*#__PURE__*/React.createElement(TextInput, {
    multiline: true,
    rows: 4,
    label: "workforce.disability.observationCurrentCondition",
    value: (formData === null || formData === void 0 || (_formData$employeeAcc8 = formData.employeeAccidentInfo) === null || _formData$employeeAcc8 === void 0 ? void 0 : _formData$employeeAcc8.observationCurrentCondition) || (formData === null || formData === void 0 || (_formData$doctorsEntr7 = formData.doctorsEntry) === null || _formData$doctorsEntr7 === void 0 ? void 0 : _formData$doctorsEntr7.observationCurrentCondition) || "",
    onChange: function onChange(v) {
      return handleChange("observationCurrentCondition", v);
    },
    required: true,
    readOnly: user_type === WORKFORCE_USER_TYPE.EIS_COORDINATOR
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6,
    className: clsx(classes.item, classes.overrideReadOnly)
  }, /*#__PURE__*/React.createElement(FormControl, {
    component: "fieldset"
  }, /*#__PURE__*/React.createElement(FormLabel, null, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "workforce.disability.limitationsOccupationDailyLiving",
    defaultMessage: "Limitations in Occupation and Activities of Daily Living"
  })), /*#__PURE__*/React.createElement(RadioGroup, {
    row: true,
    value: hasLimitations || (formData === null || formData === void 0 || (_formData$doctorsEntr8 = formData.doctorsEntry) === null || _formData$doctorsEntr8 === void 0 ? void 0 : _formData$doctorsEntr8.hasLimitations),
    onChange: handleLimitationsChange
  }, /*#__PURE__*/React.createElement(FormControlLabel, {
    value: "yes",
    control: /*#__PURE__*/React.createElement(Radio, {
      color: "primary"
    }),
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.application.permission.yes"
    })
  }), /*#__PURE__*/React.createElement(FormControlLabel, {
    value: "no",
    control: /*#__PURE__*/React.createElement(Radio, {
      color: "primary"
    }),
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.application.permission.no"
    })
  })))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6,
    className: clsx(classes.item, classes.overrideReadOnly)
  }, /*#__PURE__*/React.createElement(TextInput, {
    label: "workforce.employee.accident.info.disabilityPerSchedule",
    value: (formData === null || formData === void 0 || (_formData$employeeAcc9 = formData.employeeAccidentInfo) === null || _formData$employeeAcc9 === void 0 ? void 0 : _formData$employeeAcc9.disabilityPerSchedule) || (formData === null || formData === void 0 || (_formData$doctorsEntr9 = formData.doctorsEntry) === null || _formData$doctorsEntr9 === void 0 ? void 0 : _formData$doctorsEntr9.disabilityPerSchedule) || "",
    onChange: function onChange(v) {
      return handleChange("disabilityPerSchedule", v);
    },
    readOnly: user_type === WORKFORCE_USER_TYPE.EIS_COORDINATOR
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6,
    className: clsx(classes.item, classes.overrideReadOnly)
  }, /*#__PURE__*/React.createElement(TextInput, {
    label: "workforce.employee.accident.info.presentInjuryBLASchedule1",
    value: (formData === null || formData === void 0 || (_formData$employeeAcc10 = formData.employeeAccidentInfo) === null || _formData$employeeAcc10 === void 0 ? void 0 : _formData$employeeAcc10.presentInjuryBLASchedule1) || (formData === null || formData === void 0 || (_formData$doctorsEntr10 = formData.doctorsEntry) === null || _formData$doctorsEntr10 === void 0 ? void 0 : _formData$doctorsEntr10.presentInjuryBLASchedule1) || "",
    onChange: function onChange(v) {
      return handleChange("presentInjuryBLASchedule1", v);
    },
    readOnly: user_type === WORKFORCE_USER_TYPE.EIS_COORDINATOR
  })))), user_type === WORKFORCE_USER_TYPE.EIS_COORDINATOR && /*#__PURE__*/React.createElement(Box$1, {
    mt: 4
  }, /*#__PURE__*/React.createElement(Typography, {
    style: {
      fontWeight: "bold",
      textDecoration: "underline",
      color: "#000"
    }
  }, "Signature of EIS Doctors:"), /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 2,
    className: classes.signatureContainer
  }, eisApprovalSignature === null || eisApprovalSignature === void 0 ? void 0 : eisApprovalSignature.filter(function (sig) {
    var _sig$role;
    return ["eis doctor"].includes(sig === null || sig === void 0 || (_sig$role = sig.role) === null || _sig$role === void 0 || (_sig$role = _sig$role.name) === null || _sig$role === void 0 ? void 0 : _sig$role.toLowerCase());
  }).map(function (sig, i) {
    var _sig$workforce_docume, _sig$role2;
    return /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 3,
      key: i
    }, sig !== null && sig !== void 0 && (_sig$workforce_docume = sig.workforce_document) !== null && _sig$workforce_docume !== void 0 && _sig$workforce_docume.url ? /*#__PURE__*/React.createElement("img", {
      src: sig.workforce_document.url,
      alt: "signature",
      style: {
        width: "100%",
        maxHeight: 80,
        objectFit: "contain"
      }
    }) : /*#__PURE__*/React.createElement(Typography, {
      variant: "caption",
      style: {
        fontStyle: "italic",
        color: "#999"
      }
    }, "Signature not available"), /*#__PURE__*/React.createElement("div", {
      className: classes.signatureBlock
    }, /*#__PURE__*/React.createElement("p", null, sig === null || sig === void 0 ? void 0 : sig.last_name), /*#__PURE__*/React.createElement("p", null, sig === null || sig === void 0 || (_sig$role2 = sig.role) === null || _sig$role2 === void 0 ? void 0 : _sig$role2.name)));
  }))));
};

function ownKeys$11(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$11(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$11(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$11(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var useStyles$1m = makeStyles(function (theme) {
  return {
    modal: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      overflow: "hidden"
    },
    paper: {
      backgroundColor: theme.palette.background.paper,
      borderRadius: 10,
      boxShadow: theme.shadows[5],
      padding: theme.spacing(2),
      width: "90vw",
      maxWidth: function maxWidth(props) {
        return props.maxWidth || 850;
      },
      maxHeight: "90vh",
      display: "flex",
      flexDirection: "column",
      outline: "none",
      overflow: "hidden",
      position: "relative",
      // 1. Let the paper flow downwards freely
      "@media print": {
        display: "block !important",
        position: "static !important",
        width: "100% !important",
        maxWidth: "100% !important",
        height: "auto !important",
        maxHeight: "none !important",
        overflow: "visible !important",
        boxShadow: "none !important",
        background: "white !important",
        margin: "0 !important",
        padding: "20px !important"
      }
    },
    header: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      marginBottom: theme.spacing(2),
      "@media print": {
        display: "none !important"
      }
    },
    content: {
      flex: 1,
      overflowY: "auto",
      overflowX: "hidden",
      marginBottom: theme.spacing(2),
      paddingRight: theme.spacing(1),
      boxSizing: "border-box",
      // 2. Remove scrolling constraints so it can overflow onto Page 2
      "@media print": {
        overflow: "visible !important",
        height: "auto !important",
        maxHeight: "none !important",
        display: "block !important"
      }
    },
    actions: {
      display: "flex",
      justifyContent: "flex-end",
      gap: theme.spacing(1),
      marginTop: theme.spacing(1),
      "@media print": {
        display: "none !important"
      }
    },
    loaderOverlay: {
      /* keep your existing loaderOverlay styles */
    },
    "@global": {
      "@media print": {
        "html, body": {
          height: "auto !important",
          minHeight: "100% !important",
          overflow: "visible !important",
          backgroundColor: "white !important"
        },
        // 3. Hide the background application safely
        // MUI Modals get appended to the body with role="presentation"
        "body > *:not([role='presentation'])": {
          display: "none !important"
        },
        // 4. Kill the Flexbox centering and Fixed positioning on the Modal wrapper!
        "body > [role='presentation'], .MuiModal-root": {
          display: "block !important",
          // Kills the flex centering (fixes the top gap)
          position: "static !important",
          // Kills fixed position (fixes the pagination issue)
          height: "auto !important",
          overflow: "visible !important",
          inset: "auto !important"
        },
        // Ensure intermediate wrappers flow properly
        "body > [role='presentation'] > div": {
          display: "block !important",
          position: "static !important",
          height: "auto !important",
          overflow: "visible !important"
        },
        ".MuiBackdrop-root": {
          display: "none !important"
        }
      }
    }
  };
});
var EisFactoryAdminModal = function EisFactoryAdminModal(_ref) {
  var open = _ref.open,
    onClose = _ref.onClose,
    application = _ref.application,
    _ref$showActions = _ref.showActions,
    showActions = _ref$showActions === void 0 ? true : _ref$showActions,
    maxWidth = _ref.maxWidth,
    viewType = _ref.viewType;
  var classes = useStyles$1m({
    maxWidth: maxWidth
  });
  var _useState = useState(application || {}),
    _useState2 = _slicedToArray(_useState, 2),
    formData = _useState2[0],
    setFormData = _useState2[1];
  var _useState3 = useState({}),
    _useState4 = _slicedToArray(_useState3, 2),
    errors = _useState4[0],
    setErrors = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    loading = _useState6[0],
    setLoading = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    alertMessage = _useState8[0],
    setAlertMessage = _useState8[1];
  var _useState9 = useState(false),
    _useState10 = _slicedToArray(_useState9, 2),
    deathAlertMessage = _useState10[0],
    setDeathAlertMessage = _useState10[1];
  var _useState11 = useState(false),
    _useState12 = _slicedToArray(_useState11, 2),
    accidentDateAlertMessage = _useState12[0],
    setAccidentDateAlertMessage = _useState12[1];
  var _useTranslations = useTranslations("workforce"),
    formatMessage = _useTranslations.formatMessage;
  var documentType = useSelector(function (state) {
    return state.workforce.documentType;
  });
  var uploadFile = useSelector(function (state) {
    return state.workforce.uploadFile;
  });
  var dispatch = useDispatch();
  var stepRef = useRef(null);
  var user_type = getUserType();

  // 1. Identify if the current user is a Doctor (Reused logic)
  var isDoctor = (application === null || application === void 0 ? void 0 : application.organizationType) === "eis" && (user_type === WORKFORCE_USER_TYPE.DOCTOR || user_type === WORKFORCE_USER_TYPE.BLWF_DOCTOR || user_type === WORKFORCE_USER_TYPE.EIS_DOCTOR);
  var renderDoctorEntries = viewType === "doctorEntries" || isDoctor;
  var _handleChange = function handleChange(key, value) {
    var parent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    setFormData(function (prev) {
      if (parent) {
        return _objectSpread$11(_objectSpread$11({}, prev), {}, _defineProperty({}, parent, _objectSpread$11(_objectSpread$11({}, prev[parent]), {}, _defineProperty({}, key, value))));
      }
      return _objectSpread$11(_objectSpread$11({}, prev), {}, _defineProperty({}, key, value));
    });
  };
  var handleSubmit = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var newErrors, documentValidation, _formData$employeeFac, _formData$employeeAcc, _formData$employeeAcc2, _formData$employeeAcc3, allAssociationDate, accidentDate, deathDate, joiningDate, _JSON$stringify, _JSON$stringify2, uploadPromises, updateApplicationData;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            // 2. Validate Required Fields
            newErrors = validateRequiredFields(stepRef, formatMessage, formData);
            delete newErrors.documents;
            documentValidation = validateMandatoryDocuments(documentType, uploadFile);
            if (!(documentValidation !== null && documentValidation !== void 0 && documentValidation.isValid)) {
              newErrors.documents = documentValidation === null || documentValidation === void 0 ? void 0 : documentValidation.errors;
            }
            setErrors(newErrors);
            console.log({
              newErrors: newErrors
            });
            console.log({
              documentValidation: documentValidation
            });
            if (!(Object.keys(newErrors).length > 0)) {
              _context.next = 9;
              break;
            }
            return _context.abrupt("return");
          case 9:
            if (isDoctor) {
              _context.next = 23;
              break;
            }
            allAssociationDate = new Date(formData === null || formData === void 0 || (_formData$employeeFac = formData.employeeFactory) === null || _formData$employeeFac === void 0 || (_formData$employeeFac = _formData$employeeFac.allAssociation) === null || _formData$employeeFac === void 0 ? void 0 : _formData$employeeFac.startDate);
            accidentDate = new Date(formData === null || formData === void 0 || (_formData$employeeAcc = formData.employeeAccidentInfo) === null || _formData$employeeAcc === void 0 ? void 0 : _formData$employeeAcc.accidentDate);
            deathDate = new Date(formData === null || formData === void 0 || (_formData$employeeAcc2 = formData.employeeAccidentInfo) === null || _formData$employeeAcc2 === void 0 ? void 0 : _formData$employeeAcc2.dateOfDeath);
            joiningDate = new Date(formData === null || formData === void 0 || (_formData$employeeAcc3 = formData.employeeAccidentInfo) === null || _formData$employeeAcc3 === void 0 ? void 0 : _formData$employeeAcc3.joiningDate);
            if (!(allAssociationDate > accidentDate)) {
              _context.next = 17;
              break;
            }
            setAlertMessage(true);
            return _context.abrupt("return");
          case 17:
            if (!(accidentDate > deathDate)) {
              _context.next = 20;
              break;
            }
            setDeathAlertMessage(true);
            return _context.abrupt("return");
          case 20:
            if (!(joiningDate > accidentDate)) {
              _context.next = 23;
              break;
            }
            setAccidentDateAlertMessage(true);
            return _context.abrupt("return");
          case 23:
            // 4. Unified Submission Logic
            setLoading(true);
            _context.prev = 24;
            if (!(uploadFile && uploadFile.length > 0)) {
              _context.next = 29;
              break;
            }
            uploadPromises = uploadFile.map(function (file) {
              return dispatch(createWorkforceDocument(_objectSpread$11(_objectSpread$11({}, file), {}, {
                status: "verified",
                workforceApplicationId: application === null || application === void 0 ? void 0 : application.id
              }), "Created workforce document"));
            });
            _context.next = 29;
            return Promise.all(uploadPromises);
          case 29:
            updateApplicationData = {
              id: application === null || application === void 0 ? void 0 : application.id,
              employeeAccidentInfo: (_JSON$stringify = JSON.stringify(formData === null || formData === void 0 ? void 0 : formData.employeeAccidentInfo)) === null || _JSON$stringify === void 0 || (_JSON$stringify = _JSON$stringify.replace(/\\n/g, "\\\\n")) === null || _JSON$stringify === void 0 ? void 0 : _JSON$stringify.replace(/\\r/g, "\\\\r"),
              doctorEntries: (_JSON$stringify2 = JSON.stringify(formData !== null && formData !== void 0 && formData.doctorEntries ? Object.fromEntries(Object.entries(formData.doctorEntries).map(function (_ref3) {
                var _ref4 = _slicedToArray(_ref3, 2),
                  k = _ref4[0],
                  v = _ref4[1];
                return [k, typeof v === "string" ? v.replace(/\\/g, "/") : v];
              })) : formData === null || formData === void 0 ? void 0 : formData.doctorEntries)) === null || _JSON$stringify2 === void 0 || (_JSON$stringify2 = _JSON$stringify2.replace(/\\n/g, "\\\\n")) === null || _JSON$stringify2 === void 0 ? void 0 : _JSON$stringify2.replace(/\\r/g, "\\\\r")
            };
            console.log({
              updateApplicationData: updateApplicationData
            });
            _context.next = 33;
            return dispatch(updateApplication(updateApplicationData, "update workforce application ".concat(formData.firstNameEn)));
          case 33:
            _context.next = 35;
            return dispatch(testWorkforcePayment({
              id: application === null || application === void 0 ? void 0 : application.id
            }));
          case 35:
            window.location.reload();
            _context.next = 42;
            break;
          case 38:
            _context.prev = 38;
            _context.t0 = _context["catch"](24);
            console.error("Submission failed:", _context.t0);
            setLoading(false);
          case 42:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[24, 38]]);
    }));
    return function handleSubmit() {
      return _ref2.apply(this, arguments);
    };
  }();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Modal, {
    open: open,
    onClose: loading ? null : onClose,
    className: classes.modal,
    closeAfterTransition: true,
    BackdropComponent: Backdrop,
    BackdropProps: {
      timeout: 300
    }
  }, /*#__PURE__*/React.createElement(Box$1, {
    className: classes.paper,
    id: "print-paper"
  }, loading && /*#__PURE__*/React.createElement("div", {
    className: classes.loaderOverlay
  }, /*#__PURE__*/React.createElement(CircularProgress$1, null), /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    style: {
      marginTop: 10
    }
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "workforce.processing",
    defaultMessage: "Processing..."
  }))), /*#__PURE__*/React.createElement("div", {
    className: classes.header
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6",
    style: {
      textAlign: "center",
      fontWeight: "bold"
    }
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "workforce.eis.factory.admin.accidentInfo.button",
    module: "workforce"
  })), /*#__PURE__*/React.createElement(IconButton, {
    onClick: onClose,
    size: "small",
    style: {
      color: "black"
    },
    disabled: loading
  }, /*#__PURE__*/React.createElement(CloseIcon, null))), /*#__PURE__*/React.createElement(Divider, null), renderDoctorEntries ? /*#__PURE__*/React.createElement(Box$1, {
    className: classes.content,
    ref: stepRef,
    id: "printable-content"
  }, /*#__PURE__*/React.createElement(EisDoctorEntries, {
    handleChange: function handleChange(key, value) {
      return _handleChange(key, value, "doctorEntries");
    },
    formData: formData,
    setFormData: setFormData,
    applicationType: "disabilityAssistance",
    errors: errors
  })) : /*#__PURE__*/React.createElement(Box$1, {
    className: classes.content,
    ref: stepRef
  }, /*#__PURE__*/React.createElement(FactoryAdminAccidentForm, {
    handleChange: function handleChange(key, value) {
      return _handleChange(key, value, "employeeAccidentInfo");
    },
    formData: formData,
    setFormData: setFormData,
    applicationType: formData === null || formData === void 0 ? void 0 : formData.applicationType,
    errors: errors
  })), showActions && /*#__PURE__*/React.createElement("div", {
    className: classes.actions
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: onClose,
    variant: "outlined",
    disabled: loading
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "workforce.confirm.modal.cancel"
  })), /*#__PURE__*/React.createElement(Button, {
    onClick: handleSubmit,
    color: "primary",
    variant: "contained",
    disabled: loading || user_type === WORKFORCE_USER_TYPE.EIS_COORDINATOR
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "workforce.submit"
  })), user_type === WORKFORCE_USER_TYPE.EIS_COORDINATOR && /*#__PURE__*/React.createElement(Button, {
    onClick: function onClick() {
      return window.print();
    },
    variant: "outlined",
    disabled: loading
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "workforce.modal.print"
  }))))), /*#__PURE__*/React.createElement(CustomSnackbar, {
    open: alertMessage,
    onClose: function onClose() {
      return setAlertMessage(false);
    },
    type: "error",
    message: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.application.before.association.startDate.error",
      module: "workforce"
    })
  }), /*#__PURE__*/React.createElement(CustomSnackbar, {
    open: deathAlertMessage,
    onClose: function onClose() {
      return setDeathAlertMessage(false);
    },
    type: "error",
    message: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.application.before.deathDate.error",
      module: "workforce"
    })
  }), /*#__PURE__*/React.createElement(CustomSnackbar, {
    open: accidentDateAlertMessage,
    onClose: function onClose() {
      return setAccidentDateAlertMessage(false);
    },
    type: "error",
    message: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.application.before.joiningDate.error",
      module: "workforce"
    })
  }));
};

function ownKeys$10(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$10(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$10(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$10(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var DoctorsEntries = function DoctorsEntries(_ref) {
  var application = _ref.application;
  var dispatch = useDispatch();
  var user_type = getUserType();

  // Parse doctorEntries JSON if it exists
  var doctorEntriesData = {};
  try {
    doctorEntriesData = application !== null && application !== void 0 && application.doctorEntries ? JSON.parse(application.doctorEntries) : {};
  } catch (error) {
    console.error("Error parsing doctorEntries JSON:", error);
  }
  var _useState = useState(doctorEntriesData.doctorsProposedDonation || (application === null || application === void 0 ? void 0 : application.doctorsRecommendedDonation) || ""),
    _useState2 = _slicedToArray(_useState, 2),
    proposedAmount = _useState2[0],
    setProposedAmount = _useState2[1];
  var _useState3 = useState(doctorEntriesData.doctorsAssesment || (application === null || application === void 0 ? void 0 : application.doctorsDiagnosis) || ""),
    _useState4 = _slicedToArray(_useState3, 2),
    doctorDiagnosis = _useState4[0],
    setDoctorDiagnosis = _useState4[1];
  var _useState5 = useState(doctorEntriesData.doctorAssesmentComment || (application === null || application === void 0 ? void 0 : application.doctorComment) || ""),
    _useState6 = _slicedToArray(_useState5, 2),
    doctorComment = _useState6[0],
    setDoctorComment = _useState6[1];
  var _useState7 = useState(""),
    _useState8 = _slicedToArray(_useState7, 2),
    diseaseGrade = _useState8[0],
    setDiseaseGrade = _useState8[1];
  var _useState9 = useState(doctorEntriesData.doctorsActionFlag || (application === null || application === void 0 ? void 0 : application.doctorsFlag) || ""),
    _useState10 = _slicedToArray(_useState9, 2),
    doctorsActions = _useState10[0],
    setDoctorsActions = _useState10[1];
  var _useState11 = useState(false),
    _useState12 = _slicedToArray(_useState11, 2),
    openAccidentInfoModal = _useState12[0],
    setOpenAccidentInfoModal = _useState12[1];
  var _useState13 = useState(""),
    _useState14 = _slicedToArray(_useState13, 2),
    modalViewType = _useState14[0],
    setModalViewType = _useState14[1];
  var _useState15 = useState({
      openResponseBar: false,
      status: "workforce.success.message.doctor",
      type: "success"
    }),
    _useState16 = _slicedToArray(_useState15, 2),
    openSnackBar = _useState16[0],
    setOpenSnackBar = _useState16[1];
  var handleSelectCheckbox = function handleSelectCheckbox(event) {
    setDoctorsActions(event.target.value);
    // Reset fields when changing option
    setDoctorDiagnosis("");
    setDoctorComment("");
  };
  var handleUpdateGrantAmount = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var updateApplicationData;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            updateApplicationData = {
              id: application === null || application === void 0 ? void 0 : application.id,
              doctorsRecommendedDonation: proposedAmount,
              doctorsDiagnosis: doctorDiagnosis || null,
              doctorComment: doctorComment || null,
              doctorsFlag: doctorsActions,
              diseaseGrade: diseaseGrade,
              doctorEntries: JSON.stringify({
                doctorsAssesment: (doctorDiagnosis || "").replace(/\\/g, "/") || null,
                doctorAssesmentComment: (doctorComment || "").replace(/\\/g, "/") || null,
                doctorsProposedDonation: proposedAmount,
                doctorsActionFlag: doctorsActions
              })
            };
            _context.prev = 1;
            console.log("Doctor Update Payload:", updateApplicationData);
            _context.next = 5;
            return dispatch(updateApplication(updateApplicationData, "update workforce application"));
          case 5:
            setOpenSnackBar({
              openResponseBar: true,
              status: "আপনার মতামত সফলভাবে সংরক্ষিত করা হয়েছে!",
              type: "success"
            });
            _context.next = 11;
            break;
          case 8:
            _context.prev = 8;
            _context.t0 = _context["catch"](1);
            setOpenSnackBar({
              openResponseBar: true,
              status: "আপনার মতামত সংরক্ষণ করা যায়নি।",
              type: "error"
            });
          case 11:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[1, 8]]);
    }));
    return function handleUpdateGrantAmount() {
      return _ref2.apply(this, arguments);
    };
  }();
  console.log({
    fromCFdoctor: application
  });
  console.log({
    doctorComment: doctorComment
  });
  console.log({
    doctorDiagnosis: doctorDiagnosis
  });
  console.log({
    doctorsActions: doctorsActions
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 2,
    style: {
      marginTop: "10px"
    }
  }, user_type !== WORKFORCE_USER_TYPE.EIS_COORDINATOR && user_type !== WORKFORCE_USER_TYPE.EIS_DOCTOR && /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(TextInput, {
    label: "workforce.application.proposedAmount.byDoctor",
    value: proposedAmount,
    onChange: function onChange(v) {
      return setProposedAmount(v);
    }
  })), application.organizationType != "eis" && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(RadioGroup, {
    value: doctorsActions,
    onChange: handleSelectCheckbox
  }, /*#__PURE__*/React.createElement(FormControlLabel, {
    value: "recommend",
    control: /*#__PURE__*/React.createElement(Radio, {
      color: "primary"
    }),
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.doctor.recommend",
      module: "workforce"
    })
  }), /*#__PURE__*/React.createElement(FormControlLabel, {
    value: "reject_request",
    control: /*#__PURE__*/React.createElement(Radio, {
      color: "primary"
    }),
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.doctor.rejectRequest",
      module: "workforce"
    })
  }))), doctorsActions === "recommend" && /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(TextInput, {
    label: "workforce.application.diagnosis.byDoctor",
    value: doctorDiagnosis,
    onChange: function onChange(v) {
      return setDoctorDiagnosis(v);
    },
    multiline: true,
    rows: 3
  })), (doctorsActions === "discussion_required" || doctorsActions === "reject_request") && /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(TextInput, {
    label: "workforce.application.reasons.addComment",
    value: doctorComment,
    onChange: function onChange(v) {
      return setDoctorComment(v);
    },
    multiline: true,
    rows: 3
  })), isBlwfPath() && /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(TextInput, {
    label: "workforce.application.diseaseGrade",
    value: diseaseGrade,
    onChange: function onChange(v) {
      return setDiseaseGrade(v);
    }
  }))), user_type !== WORKFORCE_USER_TYPE.EIS_COORDINATOR && user_type !== WORKFORCE_USER_TYPE.EIS_DOCTOR && /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 3
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "contained",
    color: "primary",
    onClick: handleUpdateGrantAmount,
    disabled: !doctorsActions && !proposedAmount
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "workforce.submit",
    module: "workforce"
  }))), (application === null || application === void 0 ? void 0 : application.organizationType) === "eis" && /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    style: {
      display: "flex",
      gap: "16px"
    }
  }, user_type === WORKFORCE_USER_TYPE.EIS_COORDINATOR && (application === null || application === void 0 ? void 0 : application.applicationType) === "disabilityAssistance" ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
    variant: "contained",
    color: "primary",
    onClick: function onClick() {
      setModalViewType("doctorEntries");
      setOpenAccidentInfoModal(true);
    }
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "workforce.eis.coordinator.accidentInfo.button.disability",
    module: "workforce"
  })), /*#__PURE__*/React.createElement(Button, {
    variant: "contained",
    color: "primary",
    onClick: function onClick() {
      setModalViewType("accidentInfo");
      setOpenAccidentInfoModal(true);
    }
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "workforce.eis.factory.admin.accidentInfo.button",
    module: "workforce"
  }))) : /*#__PURE__*/React.createElement(Button, {
    variant: "contained",
    color: "primary",
    onClick: function onClick() {
      setModalViewType(""); // Default fallback
      setOpenAccidentInfoModal(true);
    },
    fullwidth: true
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "workforce.eis.factory.admin.accidentInfo.button",
    module: "workforce"
  })))), openAccidentInfoModal && /*#__PURE__*/React.createElement(EisFactoryAdminModal, {
    open: openAccidentInfoModal,
    viewType: modalViewType,
    onClose: function onClose() {
      return setOpenAccidentInfoModal(false);
    },
    application: application
  }), /*#__PURE__*/React.createElement(CustomSnackbar, {
    open: openSnackBar === null || openSnackBar === void 0 ? void 0 : openSnackBar.openResponseBar,
    onClose: function onClose() {
      return setOpenSnackBar(_objectSpread$10(_objectSpread$10({}, openSnackBar), {}, {
        openResponseBar: false
      }));
    },
    type: openSnackBar === null || openSnackBar === void 0 ? void 0 : openSnackBar.type,
    message: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: openSnackBar === null || openSnackBar === void 0 ? void 0 : openSnackBar.status,
      module: "workforce"
    })
  }));
};

var useStyles$1l = makeStyles(function (theme) {
  return {
    root: {
      width: "100%",
      backgroundColor: "transparent"
    },
    stepLabel: {
      fontWeight: 600
    },
    labelRow: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center"
    },
    dateText: {
      fontSize: "0.85rem",
      color: theme.palette.text.secondary
    },
    infoText: {
      marginTop: theme.spacing(0.5),
      fontSize: "0.9rem",
      color: theme.palette.text.secondary
    },
    statusText: {
      fontWeight: 600,
      color: theme.palette.primary.main
    }
  };
});
var ApplicationMovementStepper = function ApplicationMovementStepper(_ref) {
  var _ref$data = _ref.data,
    data = _ref$data === void 0 ? [] : _ref$data,
    language = _ref.language;
  var classes = useStyles$1l();
  var activeStep = data && data.length > 0 ? data.length - 1 : 0;
  return /*#__PURE__*/React.createElement(Paper, {
    elevation: 2,
    className: classes.root
  }, /*#__PURE__*/React.createElement(Box$1, {
    p: 3
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6",
    gutterBottom: true
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "workforce.application.progressMovement",
    module: "workforce"
  })), /*#__PURE__*/React.createElement(Stepper, {
    activeStep: activeStep,
    orientation: "vertical"
  }, data === null || data === void 0 ? void 0 : data.map(function (step, index) {
    var key = Object.keys(WORKFORCE_USER_TYPE_MAP_EN).find(function (k) {
      return WORKFORCE_USER_TYPE_MAP_EN[k] === step.role;
    });
    return /*#__PURE__*/React.createElement(Step, {
      key: step.id || index,
      completed: index < activeStep
    }, /*#__PURE__*/React.createElement(StepLabel, null, /*#__PURE__*/React.createElement(Box$1, {
      className: classes.labelRow
    }, /*#__PURE__*/React.createElement(Typography, {
      className: classes.stepLabel
    }, language === "en" ? WORKFORCE_USER_TYPE_MAP_EN[key] : WORKFORCE_USER_TYPE_MAP_BN[key], " \u2014 ", step.name), step.date && /*#__PURE__*/React.createElement(Typography, {
      className: classes.dateText
    }, step.date))), /*#__PURE__*/React.createElement(StepContent, null, /*#__PURE__*/React.createElement(Typography, {
      className: classes.infoText
    }, " ", /*#__PURE__*/React.createElement("span", {
      className: classes.statusText
    }, language === "en" ? STATUS_MAP_EN[step.status] : STATUS_MAP_BN[step.status] || "N/A")), step.note && /*#__PURE__*/React.createElement(Typography, {
      className: classes.infoText
    }, step.note), step.revertNote && /*#__PURE__*/React.createElement(Typography, {
      className: classes.infoText
    }, /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.application.revertNote",
      defaultMessage: "Revert Note:"
    }), " ", step.revertNote)));
  }))));
};

function ownKeys$$(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$$(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$$(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$$(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var useStyles$1k = makeStyles$2(function (theme) {
  return {
    modal: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    },
    modalPaper: {
      backgroundColor: theme.palette.background.paper,
      boxShadow: theme.shadows[5],
      padding: theme.spacing(0),
      width: "90%",
      maxWidth: "600px",
      maxHeight: "90vh",
      height: "70vh",
      display: "flex",
      flexDirection: "column",
      outline: "none",
      borderRadius: theme.shape.borderRadius
    },
    modalHeader: {
      padding: theme.spacing(2, 3),
      borderBottom: "1px solid #e0e0e0",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center"
    },
    modalBody: {
      padding: theme.spacing(3),
      overflowY: "auto",
      flex: 1
    },
    modalFooter: {
      padding: theme.spacing(2),
      borderTop: "1px solid #e0e0e0",
      display: "flex",
      justifyContent: "flex-end",
      gap: theme.spacing(1)
    },
    entryBox: {
      backgroundColor: "#f9f9f9",
      padding: theme.spacing(2),
      borderRadius: theme.spacing(1),
      marginBottom: theme.spacing(2),
      border: "1px solid #e0e0e0",
      position: "relative"
    },
    deleteBtn: {
      position: "absolute",
      top: theme.spacing(0.5),
      right: theme.spacing(0.5),
      color: theme.palette.error.main
    },
    sectionHeader: {
      marginBottom: theme.spacing(2),
      fontWeight: 600
    }
  };
});
var initialEntry = {
  id: null,
  // Track ID for updates
  receivedFrom: "",
  dateOfCompensation: null,
  amount: "",
  paymentStatus: "",
  eisBenefitAdjustment: "",
  remarks: ""
};
var normalizeBoolean = function normalizeBoolean(value) {
  if (value === true || value === "true") {
    return true;
  }
  if (value === false || value === "false") {
    return false;
  }
  return "";
};
var CompensationFormModal = function CompensationFormModal(_ref) {
  var application = _ref.application,
    open = _ref.open,
    onClose = _ref.onClose;
    _ref.onSubmit;
    var _ref$entryType = _ref.entryType,
    entryType = _ref$entryType === void 0 ? "factory" : _ref$entryType;
  var classes = useStyles$1k();
  var _useTranslations = useTranslations("workforce"),
    formatMessage = _useTranslations.formatMessage;
  var formRef = useRef(null);
  var _useState = useState([initialEntry]),
    _useState2 = _slicedToArray(_useState, 2),
    formData = _useState2[0],
    setFormData = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    showErrorSnackbar = _useState4[0],
    setShowErrorSnackbar = _useState4[1];
  var _useState5 = useState({}),
    _useState6 = _slicedToArray(_useState5, 2),
    errors = _useState6[0],
    setErrors = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    loader = _useState8[0],
    setLoader = _useState8[1];
  var dispatch = useDispatch();
  var modulesManager = useModulesManager();
  var user_type = getUserType();
  useEffect(function () {
    // Only fetch if modal is open and we have an application ID
    setLoader(true);
    if (open && application !== null && application !== void 0 && application.id) {
      dispatch(fetchWorkforceOtherCompensation(modulesManager, ["workforceApplicationId:\"".concat(application === null || application === void 0 ? void 0 : application.id, "\"")])).then(function (res) {
        var _res$payload;
        var fetchOtherCompensation = parseData(res === null || res === void 0 || (_res$payload = res.payload) === null || _res$payload === void 0 || (_res$payload = _res$payload.data) === null || _res$payload === void 0 ? void 0 : _res$payload.workforceOtherCompensationInfo);
        console.log(fetchOtherCompensation);
        var formattedData = fetchOtherCompensation.map(function (item) {
          return _objectSpread$$(_objectSpread$$({}, item), {}, {
            amount: item.amount !== null && item.amount !== undefined ? Number(item.amount).toFixed(2) : "",
            eisBenefitAdjustment: normalizeBoolean(item.isEisBenefitAdjustmentEligible)
          });
        });
        if (fetchOtherCompensation && fetchOtherCompensation.length > 0) {
          setFormData(formattedData);
        } else {
          // If empty array or null, reset to initial entry
          setFormData([_objectSpread$$({}, initialEntry)]);
        }
      })["catch"](function (err) {
        console.error("Error fetching compensation:", err);
        setFormData([_objectSpread$$({}, initialEntry)]);
      })["finally"](function () {
        setLoader(false);
      });
    } else if (open) {
      // If opening without an ID (new application context), reset form
      setFormData([_objectSpread$$({}, initialEntry)]);
    }
  }, [open, application === null || application === void 0 ? void 0 : application.id, dispatch, modulesManager]); // Added proper dependencies

  var handleChange = function handleChange(index, key) {
    return function (eventOrValue) {
      var value = eventOrValue;
      if (eventOrValue && eventOrValue.target) {
        value = eventOrValue.target.value;
      }
      setFormData(function (prev) {
        var newArray = _toConsumableArray(prev);
        newArray[index] = _objectSpread$$(_objectSpread$$({}, newArray[index]), {}, _defineProperty({}, key, value));
        return newArray;
      });
    };
  };
  var handleAddEntry = function handleAddEntry() {
    setFormData([].concat(_toConsumableArray(formData), [_objectSpread$$({}, initialEntry)]));
  };
  var handleRemoveEntry = function handleRemoveEntry(index) {
    var values = _toConsumableArray(formData);
    // If deleting an item that exists in DB (has ID), you might need a delete API call here.
    // For now, we just remove it from the UI list.
    if (values.length > 1) {
      values.splice(index, 1);
      setFormData(values);
    }
  };
  var handleFormSubmit = function handleFormSubmit() {
    var validationErrors = validateRequiredFields(formRef, formatMessage, formData);
    if (user_type === WORKFORCE_USER_TYPE.EIS_OFFICER) {
      formData === null || formData === void 0 || formData.forEach(function (item, index) {
        var isSelected = item.eisBenefitAdjustment === true || item.eisBenefitAdjustment === false;
        if (!isSelected) {
          // Track the error using a dynamic key unique to this row item
          validationErrors["eisBenefitAdjustment-".concat(index)] = formatMessage("core.error.required");
        }
      });
    }
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors); // Save to state if you want to display them
      setShowErrorSnackbar(true);
      console.error("Validation failed:", validationErrors);
      return; // STOP SUBMISSION HERE
    }

    // Clear previous errors if validation passes
    setErrors({});
    formData === null || formData === void 0 || formData.forEach(function (item) {
      var payload = {
        workforceApplicationId: safeDecodeId(application === null || application === void 0 ? void 0 : application.id),
        entryBy: user_type === WORKFORCE_USER_TYPE.FACTORY_ADMIN ? "factory" : "officer",
        dateOfCompensation: item.dateOfCompensation,
        amount: item.amount,
        receivedFromOrganization: item === null || item === void 0 ? void 0 : item.receivedFrom,
        statusOfPayment: item.paymentStatus,
        // Send the current radio value
        isEisBenefitAdjustmentEligible: item.eisBenefitAdjustment,
        remarks: item.remarks
      };
      console.log("SENDING TO DATABASE:", payload);
      if (item.id) {
        // UPDATE: Include the ID in the payload for the update action
        var updatePayload = _objectSpread$$(_objectSpread$$({}, payload), {}, {
          id: safeDecodeId(item.id)
        });
        console.log("Updating Payload:", updatePayload);
        dispatch(updateWorkforceOtherCompensation(updatePayload, "update other compensation info"));
      } else {
        // CREATE
        console.log("Creating Payload:", payload);
        dispatch(createWorkforceOtherCompensation(payload, "create other compensation info"));
      }
    });
    onClose();
  };
  var isOfficer = entryType === "officer";
  console.log({
    fahimFarooq: formData
  });
  if (loader) {
    return /*#__PURE__*/React.createElement(Modal, {
      className: classes.modal,
      open: open,
      onClose: onClose,
      closeAfterTransition: true,
      BackdropComponent: Backdrop,
      BackdropProps: {
        timeout: 500
      }
    }, /*#__PURE__*/React.createElement(Fade, {
      "in": open
    }, /*#__PURE__*/React.createElement(Paper, {
      className: classes.modalPaper
    }, /*#__PURE__*/React.createElement("div", {
      className: classes.modalHeader
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "h6"
    }, isOfficer ? "Officer Compensation Entry" : "Factory Compensation Entry"), /*#__PURE__*/React.createElement(IconButton, {
      onClick: onClose,
      size: "small"
    }, /*#__PURE__*/React.createElement(CloseIcon, null))), /*#__PURE__*/React.createElement(Typography, {
      variant: "h4"
    }, "Loading ..."))));
  }
  return /*#__PURE__*/React.createElement(Modal, {
    className: classes.modal,
    open: open,
    onClose: onClose,
    closeAfterTransition: true,
    BackdropComponent: Backdrop,
    BackdropProps: {
      timeout: 500
    }
  }, /*#__PURE__*/React.createElement(Fade, {
    "in": open
  }, /*#__PURE__*/React.createElement(Paper, {
    className: classes.modalPaper
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.modalHeader
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6"
  }, isOfficer ? "Officer Compensation Entry" : "Factory Compensation Entry"), /*#__PURE__*/React.createElement(IconButton, {
    onClick: onClose,
    size: "small"
  }, /*#__PURE__*/React.createElement(CloseIcon, null))), /*#__PURE__*/React.createElement("div", {
    className: classes.modalBody,
    ref: formRef
  }, Array.isArray(formData) && formData.map(function (entry, index) {
    var _entry$amount;
    return /*#__PURE__*/React.createElement("div", {
      key: index,
      className: classes.entryBox
    }, /*#__PURE__*/React.createElement(Grid, {
      container: true,
      justify: "space-between",
      alignItems: "center"
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "subtitle1",
      className: classes.sectionHeader
    }, "Entry #", index + 1), formData.length > 1 && /*#__PURE__*/React.createElement(IconButton, {
      size: "small",
      className: classes.deleteBtn,
      onClick: function onClick() {
        return handleRemoveEntry(index);
      }
    }, /*#__PURE__*/React.createElement(DeleteIcon, null))), /*#__PURE__*/React.createElement(Grid, {
      container: true,
      spacing: 2
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 6
    }, /*#__PURE__*/React.createElement(TextInput, {
      label: "workforce.compensation.recievedFrom",
      fullWidth: true,
      value: entry.receivedFrom || (entry === null || entry === void 0 ? void 0 : entry.receivedFromOrganization) || " ",
      onChange: handleChange(index, "receivedFrom")
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 6
    }, /*#__PURE__*/React.createElement(PublishedComponent, {
      pubRef: "workforce.DatePicker",
      label: "workforce.compensation.date",
      value: entry.dateOfCompensation,
      onChange: handleChange(index, "dateOfCompensation"),
      readOnly: false,
      required: true
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 6
    }, /*#__PURE__*/React.createElement(TextInput, {
      label: "workforce.employee.application.moneyAmount",
      type: "number",
      fullWidth: true,
      value: (_entry$amount = entry === null || entry === void 0 ? void 0 : entry.amount) !== null && _entry$amount !== void 0 ? _entry$amount : ""
      // onBlur={() => {
      //   if (entry?.amount !== "" && entry?.amount !== null && !isNaN(entry?.amount)) {
      //     handleChange(index, "amount")(Number(entry?.amount).toFixed(2));
      //   }
      // }}
      ,
      onChange: handleChange(index, "amount"),
      inputProps: {
        step: "0.01"
      }
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 6
    }, /*#__PURE__*/React.createElement(TextField, {
      select: true,
      label: /*#__PURE__*/React.createElement(FormattedMessage, {
        id: "workforce.compensation.paymentStatus",
        defaultMessage: "Status of Payment"
      }),
      fullWidth: true,
      value: entry.paymentStatus || entry.statusOfPayment || "",
      onChange: handleChange(index, "paymentStatus")
    }, /*#__PURE__*/React.createElement(MenuItem, {
      value: "Paid"
    }, /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.paid",
      defaultMessage: "Paid"
    })), /*#__PURE__*/React.createElement(MenuItem, {
      value: "unPaid"
    }, /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.unpaid",
      defaultMessage: "Not paid yet"
    })))), (user_type === WORKFORCE_USER_TYPE.EIS_OFFICER || user_type === WORKFORCE_USER_TYPE.EIS_COORDINATOR) && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12
    }, /*#__PURE__*/React.createElement(FormControl, {
      component: "fieldset",
      error: !!errors["eisBenefitAdjustment-".concat(index)]
    }, /*#__PURE__*/React.createElement(FormLabel, {
      component: "legend",
      required: user_type === WORKFORCE_USER_TYPE.EIS_OFFICER
    }, /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.compensation.eligible.ForEISAdjustment"
    })), /*#__PURE__*/React.createElement(RadioGroup, {
      row: true,
      value: entry.eisBenefitAdjustment === true ? "true" : entry.eisBenefitAdjustment === false ? "false" : "",
      onChange: function onChange(e) {
        var value = e.target.value === "true";
        handleChange(index, "eisBenefitAdjustment")(value);
        if (errors["eisBenefitAdjustment-".concat(index)]) {
          setErrors(function (prev) {
            var updated = _objectSpread$$({}, prev);
            delete updated["eisBenefitAdjustment-".concat(index)];
            return updated;
          });
        }
      }
    }, /*#__PURE__*/React.createElement(FormControlLabel, {
      value: "true",
      control: /*#__PURE__*/React.createElement(Radio, {
        color: "primary"
      }),
      label: "Yes"
    }), /*#__PURE__*/React.createElement(FormControlLabel, {
      value: "false",
      control: /*#__PURE__*/React.createElement(Radio, {
        color: "primary"
      }),
      label: "No"
    })))), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 6
    }, /*#__PURE__*/React.createElement(TextInput, {
      label: "workforce.compensation.remarks",
      fullWidth: true,
      value: entry.remarks,
      onChange: handleChange(index, "remarks")
    })))));
  }), /*#__PURE__*/React.createElement(Button, {
    startIcon: /*#__PURE__*/React.createElement(AddCircleOutlineIcon, null),
    color: "primary",
    onClick: handleAddEntry,
    style: {
      marginTop: "8px"
    }
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "workforce.compensation.add"
  }))), /*#__PURE__*/React.createElement("div", {
    className: classes.modalFooter
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: onClose,
    color: "secondary"
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "workforce.confirm.modal.cancel"
  })), /*#__PURE__*/React.createElement(Button, {
    onClick: handleFormSubmit,
    color: "primary",
    variant: "contained"
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "workforce.submit"
  }))), /*#__PURE__*/React.createElement(CustomSnackbar, {
    open: showErrorSnackbar // Use the new state
    ,
    onClose: function onClose() {
      return setShowErrorSnackbar(false);
    } // Allow it to close
    ,
    type: "error",
    message: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "core.error.generel",
      module: "workforce"
    }),
    duration: 4000
  }))));
};

var useStyles$1j = makeStyles(function (theme) {
  return {
    loaderContainer: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      minHeight: 150
    },
    chipContainer: {
      display: "flex",
      gap: theme.spacing(1),
      alignItems: "center"
    },
    statusChip: {
      textTransform: "capitalize",
      fontWeight: "bold"
    },
    emptyText: {
      padding: theme.spacing(2),
      textAlign: "center"
    }
  };
});
var getStatusColor = function getStatusColor(status) {
  var s = status === null || status === void 0 ? void 0 : status.toLowerCase();
  if (s !== null && s !== void 0 && s.includes("reject")) return "secondary";
  if (s !== null && s !== void 0 && s.includes("new") || s !== null && s !== void 0 && s.includes("forward") || s !== null && s !== void 0 && s.includes("approve")) return "primary";
  return "default";
};
var formatKey$1 = function formatKey(key, language) {
  var cleanKey = key.split(".").pop();
  if (["fr", "bangla", "bd"].includes(language) && banglaLabels$1[cleanKey]) {
    return banglaLabels$1[cleanKey];
  }
  return cleanKey.replace(/_/g, " ").replace(/([a-z])([A-Z])/g, "$1 $2").replace(/\b\w/g, function (c) {
    return c.toUpperCase();
  });
};
var ApplicationPreviousHistory = function ApplicationPreviousHistory(_ref) {
  var open = _ref.open,
    onClose = _ref.onClose,
    application = _ref.application;
  var classes = useStyles$1j();
  var dispatch = useDispatch();
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    history = _useState2[0],
    setHistory = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    loading = _useState4[0],
    setLoading = _useState4[1];
  var language = useSelector(function (state) {
    var _state$core;
    return (_state$core = state.core) === null || _state$core === void 0 || (_state$core = _state$core.user) === null || _state$core === void 0 || (_state$core = _state$core.i_user) === null || _state$core === void 0 ? void 0 : _state$core.language;
  });
  useEffect(function () {
    if (!application || !open) return;
    var isMounted = true;
    setLoading(true);
    var loadHistory = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _application$applican, _application$workforc, _res$payload, filters, res, _res$payload2;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              filters = ["financialAssistance", "DeadlyGrant"].includes(application === null || application === void 0 ? void 0 : application.type) ? ["nid: \"".concat(application === null || application === void 0 || (_application$applican = application.applicantInfo) === null || _application$applican === void 0 ? void 0 : _application$applican.nid, "\""), "getOtherApplicationList: true", "applicationTypeIn:[\"".concat(application === null || application === void 0 ? void 0 : application.applicationType, "\"]")] : ["nid: \"".concat(application === null || application === void 0 || (_application$workforc = application.workforceEmployee) === null || _application$workforc === void 0 ? void 0 : _application$workforc.nid, "\""), "getOtherApplicationList: true", "applicationTypeIn:[\"".concat(application === null || application === void 0 ? void 0 : application.applicationType, "\"]")];
              _context.next = 4;
              return dispatch(fetchPrevApplicationHistory(filters));
            case 4:
              res = _context.sent;
              if (res !== null && res !== void 0 && (_res$payload = res.payload) !== null && _res$payload !== void 0 && (_res$payload = _res$payload.data) !== null && _res$payload !== void 0 && _res$payload.workforceCheckApplicationDuplicacy) {
                setHistory(res === null || res === void 0 || (_res$payload2 = res.payload) === null || _res$payload2 === void 0 || (_res$payload2 = _res$payload2.data) === null || _res$payload2 === void 0 ? void 0 : _res$payload2.workforceCheckApplicationDuplicacy);
              }
              _context.next = 11;
              break;
            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](0);
              console.error("Failed to fetch application history:", _context.t0);
            case 11:
              _context.prev = 11;
              if (isMounted) setLoading(false);
              return _context.finish(11);
            case 14:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[0, 8, 11, 14]]);
      }));
      return function loadHistory() {
        return _ref2.apply(this, arguments);
      };
    }();
    loadHistory();
    return function () {
      isMounted = false;
    };
  }, [application, open, dispatch]);
  return /*#__PURE__*/React.createElement(Dialog$1, {
    open: open,
    onClose: onClose,
    maxWidth: "sm",
    fullWidth: true
  }, /*#__PURE__*/React.createElement(DialogTitle, null, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "workforce.previous.history.list"
  })), /*#__PURE__*/React.createElement(DialogContent$1, {
    dividers: true
  }, loading ? /*#__PURE__*/React.createElement(Box$1, {
    className: classes.loaderContainer
  }, /*#__PURE__*/React.createElement(CircularProgress$1, {
    size: 30
  })) : history.length === 0 ? /*#__PURE__*/React.createElement(Typography, {
    className: classes.emptyText,
    color: "textSecondary"
  }, "No previous history found.") : /*#__PURE__*/React.createElement(List, {
    disablePadding: true
  }, history.map(function (app, index) {
    var _app$dateCreated;
    return /*#__PURE__*/React.createElement(React.Fragment, {
      key: app.id
    }, /*#__PURE__*/React.createElement(ListItem, null, /*#__PURE__*/React.createElement(ListItemText, {
      primary: "".concat(formatKey$1("OrganizationType", language), ": ").concat(formatKey$1(app === null || app === void 0 ? void 0 : app.organizationType, language)),
      secondary: "".concat(formatKey$1("appliedOn", language), ": ").concat(conditionalEnToBn((app === null || app === void 0 || (_app$dateCreated = app.dateCreated) === null || _app$dateCreated === void 0 ? void 0 : _app$dateCreated.split("T")[0]) || "—", language))
    }), /*#__PURE__*/React.createElement(Box$1, {
      className: classes.chipContainer
    }, /*#__PURE__*/React.createElement(Chip, {
      label: language === "en" ? STATUS_MAP_EN[app.status] : STATUS_MAP_BN[app === null || app === void 0 ? void 0 : app.status],
      color: getStatusColor(app.status),
      size: "small",
      className: classes.statusChip
    }))), index < history.length - 1 && /*#__PURE__*/React.createElement(Divider, {
      component: "li"
    }));
  }))), /*#__PURE__*/React.createElement(DialogActions$1, null, /*#__PURE__*/React.createElement(Button, {
    onClick: onClose,
    color: "primary"
  }, "Close")));
};

var CommitteeMeetingApplicationList = function CommitteeMeetingApplicationList(_ref) {
  var _application$eisAppli;
  var application = _ref.application;
  var dispatch = useDispatch();
  var modulesManager = useModulesManager();
  useHistory();
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    meetingApplicationList = _useState2[0],
    setMeetingApplicationList = _useState2[1];
  var loadedSummaryId = useRef(null);
  var summaryId = safeDecodeId(application === null || application === void 0 || (_application$eisAppli = application.eisApplicationSummary) === null || _application$eisAppli === void 0 ? void 0 : _application$eisAppli.id);
  useEffect(function () {
    if (!summaryId || loadedSummaryId.current === summaryId) return undefined;
    loadedSummaryId.current = summaryId;
    var isCurrent = true;
    dispatch(fetchApplicationsSummary(modulesManager, ["eisApplicationSummaryId:\"".concat(summaryId, "\"")])).then(function (res) {
      var _res$payload;
      if (!isCurrent) return;
      var applicationList = parseData(res === null || res === void 0 || (_res$payload = res.payload) === null || _res$payload === void 0 || (_res$payload = _res$payload.data) === null || _res$payload === void 0 ? void 0 : _res$payload.workforceApplication) || [];
      setMeetingApplicationList(applicationList);
    });
    return function () {
      isCurrent = false;
    };
  }, [dispatch, modulesManager, summaryId]);
  return /*#__PURE__*/React.createElement(Box$1, {
    width: "100%",
    bgcolor: "background.paper",
    style: {
      maxHeight: 400,
      overflow: 'auto'
    }
  }, /*#__PURE__*/React.createElement(List, {
    disablePadding: true
  }, meetingApplicationList.map(function (app) {
    var _app$workforceEmploye;
    var deceasedWorkerInfo = safeParse(app === null || app === void 0 ? void 0 : app.deceasedWorkerInfo);
    return /*#__PURE__*/React.createElement(ListItem, {
      key: app === null || app === void 0 ? void 0 : app.id,
      divider: true
    }, /*#__PURE__*/React.createElement(ListItemText, {
      primary: (app === null || app === void 0 ? void 0 : app.applicationType) === "financialAssistance" ? deceasedWorkerInfo === null || deceasedWorkerInfo === void 0 ? void 0 : deceasedWorkerInfo.nameEn : app === null || app === void 0 || (_app$workforceEmploye = app.workforceEmployee) === null || _app$workforceEmploye === void 0 ? void 0 : _app$workforceEmploye.nameEn,
      secondary: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography, {
        component: "span",
        variant: "body2",
        color: "textPrimary"
      }, app === null || app === void 0 ? void 0 : app.applicationType), " \u2014 ".concat(app === null || app === void 0 ? void 0 : app.status))
    }), /*#__PURE__*/React.createElement(ListItemSecondaryAction, null, /*#__PURE__*/React.createElement(Button, {
      size: "small",
      variant: "outlined",
      onClick: function onClick() {
        return window.location.href = window.location.origin + "/workforce/applications/application/view/".concat(safeDecodeId(app === null || app === void 0 ? void 0 : app.id));
      }
    }, "View")));
  })));
};

function ownKeys$_(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$_(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$_(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$_(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var useStyles$1i = makeStyles(function (theme) {
  return {
    root: {
      padding: theme.spacing(3)
    },
    sidebar: {
      padding: theme.spacing(2),
      background: "#f5f5f5",
      borderRadius: 8
    },
    accordion: {
      marginBottom: theme.spacing(2),
      borderRadius: 8,
      boxShadow: "0px 2px 4px rgba(0,0,0,0.1)"
    },
    sectionTitle: {
      fontWeight: 600,
      marginBottom: theme.spacing(1),
      textTransform: "capitalize"
    },
    titleColor: {
      background: "#EEFBFF"
    },
    itemRow: {
      marginBottom: theme.spacing(0.5)
    },
    label: {
      fontWeight: "bold",
      color: "#555",
      marginRight: 6
    },
    value: {
      color: "#222",
      wordBreak: "break-word"
    },
    nestedCard: {
      marginBottom: theme.spacing(2),
      padding: theme.spacing(1),
      background: "#fafafa",
      borderRadius: 8
    },
    bulkActionContainer: {
      marginTop: theme.spacing(2),
      padding: theme.spacing(2),
      background: "#e3f2fd",
      borderRadius: 8,
      display: "flex",
      justifyContent: "flex-end",
      alignItems: "center"
    },
    verificationBox: {
      marginTop: theme.spacing(3),
      padding: theme.spacing(2),
      borderTop: "1px dashed #ccc",
      backgroundColor: "#fffdf0" // Light yellow tint to distinguish verification area
    }
  };
});

// ... [hiddenKeys, formatKey, tryParse, isEmpty functions remain unchanged] ...
var hiddenKeys = ["id", "uuid", "__typename", "applicationId", "parent", "code", "type", "employeeFactory", "associationType", "applicationFor", "employeeDependentInfo", "employeeBankInfo", "educations", "applicationForSelf", "insuranceNumber", "grantMoney", "relatedUser", "doctorsDiagnosis", "doctorsFlag", "doctorsRecommendedDonation", "lastBaseSalary", "doctorsFlagNote", "eisApprovedAmount", "eisCalculatedAmount", "eisPaymentType", "eisInitialMonthlyAmount", "eisMonthlyAmount", "initialReplacementRate", "eisApplicationSummary", "cfApplicationSummary", "blwfApplicationSummary", "pvFactor", "dependentId", "attachments", "dateCreated",
// "doctorsEntry",
"wCode", "applicantInfoVerification", "applicantInfoVerificationRemarks", "deceasedWorkerInfoVerification", "deceasedWorkerInfoVerificationRemarks", "doctorsEntryVerification", "doctorsEntryVerificationRemarks", "employeeAccidentInfoVerification", "employeeAccidentInfoVerificationRemarks", "employeeBankInfoVerification", "employeeBankInfoVerificationRemarks", "employeeChildrenInfoVerification", "employeeChildrenInfoVerificationRemarks", "employeeDependentInfoVerification", "employeeDependentInfoVerificationRemarks", "institutionInfoVerification", "institutionInfoVerificationRemarks", "metadataVerification", "metadataVerificationRemarks", "workforceEmployeeVerification", "workforceEmployeeVerificationRemarks", "metadata", "workforceFactoryId", "uploadedNidFile", "uploadedBirthCertificateFile", "educationGrant_certified_copy_of_educational_certificate", "educationGrant_last_educational_marksheet_copy", "educationGrant_scholarship_dependent_labour_foundation_grant_information", "educationGrant_certification_letter_from_the_department_head_of_the_organization", "workerType", "workforceApplicationMovements", "committeeId", "isSubmitted", "status", "diseaseNo", "minimumDonationAmount", "maximumDonationAmount", "accountHolderType", "dependant"];
var formatKey = function formatKey(key, language) {
  var cleanKey = key.split(".").pop();
  if (["fr", "bangla", "bd"].includes(language) && banglaLabels$1[cleanKey]) {
    return banglaLabels$1[cleanKey];
  }
  return cleanKey.replace(/_/g, " ").replace(/([a-z])([A-Z])/g, "$1 $2").replace(/\b\w/g, function (c) {
    return c.toUpperCase();
  });
};
var tryParse = function tryParse(value) {
  if (typeof value === "string") {
    try {
      var parsed = JSON.parse(value);
      if (_typeof(parsed) === "object" && parsed !== null) {
        return parsed;
      }
    } catch (_unused) {
      return value;
    }
  }
  return value;
};
var isEmpty = function isEmpty(value) {
  if (value == null) return true;
  if (Array.isArray(value)) {
    if (value.length === 0) return true;
    return value.every(function (item) {
      return item == null || _typeof(item) === "object" && Object.keys(item).length === 0;
    });
  }
  if (_typeof(value) === "object") return Object.keys(value).length === 0;
  return false;
};
var formatAddress$2 = function formatAddress(locationData, addressData) {
  var _address$postOffice, _address$postOffice2, _location$parent, _location$parent2, _location$parent3;
  // TryParse handles both JSON strings and objects
  var address = fixBrokenUnicode(tryParse(addressData)) || {};
  var location = fixBrokenUnicode(tryParse(locationData)) || {};
  var postOffice = fixBrokenUnicode((address === null || address === void 0 || (_address$postOffice = address.postOffice) === null || _address$postOffice === void 0 ? void 0 : _address$postOffice.nameBn) || (address === null || address === void 0 || (_address$postOffice2 = address.postOffice) === null || _address$postOffice2 === void 0 ? void 0 : _address$postOffice2.nameEn) || "—");
  var village = [fixBrokenUnicode(address.houseName), fixBrokenUnicode(address.paraMahalla), fixBrokenUnicode(address.villageRoad)].filter(Boolean).join(", ");

  // Navigate location parents for Thana/District
  var thana = (location === null || location === void 0 || (_location$parent = location.parent) === null || _location$parent === void 0 ? void 0 : _location$parent.name) || (location === null || location === void 0 ? void 0 : location.name); // Fallback if structure varies
  var district = (location === null || location === void 0 || (_location$parent2 = location.parent) === null || _location$parent2 === void 0 || (_location$parent2 = _location$parent2.parent) === null || _location$parent2 === void 0 ? void 0 : _location$parent2.name) || (location === null || location === void 0 || (_location$parent3 = location.parent) === null || _location$parent3 === void 0 ? void 0 : _location$parent3.name);
  return {
    village: village,
    postOffice: postOffice,
    thana: thana,
    district: district
  };
};

/**
 * Recursive renderer for objects & arrays in Grid format
 */
var _renderDetails = function renderDetails(data, classes) {
  var parentKey = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";
  var language = arguments.length > 3 ? arguments[3] : undefined;
  var fileStates = arguments.length > 4 ? arguments[4] : undefined;
  var handleCommentChange = arguments.length > 5 ? arguments[5] : undefined;
  var handleFileVerify = arguments.length > 6 ? arguments[6] : undefined;
  var handleFileReject = arguments.length > 7 ? arguments[7] : undefined;
  var eligibilityMap = arguments.length > 8 ? arguments[8] : undefined;
  var handleEligibilityChange = arguments.length > 9 ? arguments[9] : undefined;
  var user_type = arguments.length > 10 ? arguments[10] : undefined;
  var remarksMap = arguments.length > 11 ? arguments[11] : undefined;
  var
  // <--- NEW ARGUMENT
  handleRemarksChange = arguments.length > 12 ? arguments[12] : undefined;
  var viewedFromFlag = arguments.length > 13 ? arguments[13] : undefined;
  if (!data) return null;

  // --- UPDATED: Merge Logic to support formatAddress ---
  var mergeAddressAndLocation = function mergeAddressAndLocation(obj) {
    var parsedObj = Object.fromEntries(Object.entries(obj).map(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
        k = _ref2[0],
        v = _ref2[1];
      return [k, tryParse(v)];
    }));
    var newObj = _objectSpread$_({}, parsedObj);
    if (parsedObj.presentAddress || parsedObj.presentLocation) {
      newObj.presentAddressAndLocation = {
        locationData: parsedObj.presentLocation,
        addressData: parsedObj.presentAddress
      };
      delete newObj.presentAddress;
      delete newObj.presentLocation;
    }
    if (parsedObj.permanentAddress || parsedObj.permanentLocation) {
      newObj.permanentAddressAndLocation = {
        locationData: parsedObj.permanentLocation,
        addressData: parsedObj.permanentAddress
      };
      delete newObj.permanentAddress;
      delete newObj.permanentLocation;
    }
    return newObj;
  };
  var mergedData = _typeof(data) === "object" && !Array.isArray(data) ? mergeAddressAndLocation(data) : Array.isArray(data) ? data.map(function (item) {
    return _typeof(item) === "object" ? mergeAddressAndLocation(item) : tryParse(item);
  }) : tryParse(data);

  // const mergedData =
  //   typeof data === "object" && !Array.isArray(data)
  //     ? mergeAddressAndLocation(data)
  //     : Array.isArray(data)
  //     ? data.map((item) => (typeof item === "object" ? mergeAddressAndLocation(item) : tryParse(item)))
  //     : tryParse(data);

  // Handle arrays of objects
  if (Array.isArray(mergedData)) {
    return mergedData.map(function (item, idx) {
      if (_typeof(item) !== "object" || !item) return null;
      var scalars = Object.entries(item).filter(function (_ref3) {
        var _ref4 = _slicedToArray(_ref3, 2),
          key = _ref4[0],
          value = _ref4[1];
        return _typeof(value) !== "object" && ![].concat(hiddenKeys, _toConsumableArray(user_type != WORKFORCE_USER_TYPE.BLWF_DOCTOR && user_type != WORKFORCE_USER_TYPE.DOCTOR ? ["status", "grade", "diseaseNo", "diseaseType", "minimumDonationAmount", "maximumDonationAmount"] : [])).includes(key) && value !== null && value !== undefined && value !== "";
      });
      var objects = Object.entries(item).filter(function (_ref5) {
        var _ref6 = _slicedToArray(_ref5, 2),
          key = _ref6[0],
          value = _ref6[1];
        return _typeof(value) === "object" && value && ![].concat(hiddenKeys, _toConsumableArray(user_type != WORKFORCE_USER_TYPE.BLWF_DOCTOR && user_type != WORKFORCE_USER_TYPE.DOCTOR ? ["status", "grade", "diseaseNo", "diseaseType", "minimumDonationAmount", "maximumDonationAmount"] : []), ["attachments", "employeeBankingDependents"]).includes(key);
      });
      var matchingFiles = [];
      if (parentKey === "workforceEmployeeDependentApplication" && item !== null && item !== void 0 && item.id && fileStates) {
        matchingFiles = fileStates.map(function (f, i) {
          return _objectSpread$_(_objectSpread$_({}, f), {}, {
            _originalIndex: i
          });
        }).filter(function (f) {
          var _f$workforceDependent;
          return (f === null || f === void 0 || (_f$workforceDependent = f.workforceDependent) === null || _f$workforceDependent === void 0 ? void 0 : _f$workforceDependent.id) === item.id;
        });
      }
      if (parentKey === "employeeBankingInfoApplication" && item !== null && item !== void 0 && item.id && fileStates) {
        matchingFiles = fileStates.map(function (f, i) {
          return _objectSpread$_(_objectSpread$_({}, f), {}, {
            _originalIndex: i
          });
        }).filter(function (f) {
          var _f$workforceEmployeeB;
          return (f === null || f === void 0 || (_f$workforceEmployeeB = f.workforceEmployeeBankingInfo) === null || _f$workforceEmployeeB === void 0 ? void 0 : _f$workforceEmployeeB.id) === item.id;
        });
      }
      var isAllowedUser = [WORKFORCE_USER_TYPE.EIS_COORDINATOR, WORKFORCE_USER_TYPE.EIS_OFFICER].includes(user_type);
      return /*#__PURE__*/React.createElement(Card, {
        key: idx,
        className: classes.nestedCard
      }, /*#__PURE__*/React.createElement(CardContent, null, /*#__PURE__*/React.createElement(Typography, {
        variant: "subtitle1",
        gutterBottom: true,
        style: {
          fontWeight: "bold",
          fontSize: "large"
        }
      }, formatKey(parentKey, language), " ", enToBn(idx + 1)), /*#__PURE__*/React.createElement(Divider, {
        style: {
          marginBottom: 12
        }
      }), /*#__PURE__*/React.createElement(Grid, {
        container: true,
        spacing: 2
      }, scalars.map(function (_ref7) {
        var _ref8 = _slicedToArray(_ref7, 2),
          key = _ref8[0],
          value = _ref8[1];
        return /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 6,
          key: key,
          className: classes.itemRow
        }, /*#__PURE__*/React.createElement(Typography, {
          variant: "body1",
          className: classes.value
        }, /*#__PURE__*/React.createElement("span", {
          className: classes.label,
          style: {
            fontWeight: "bold"
          }
        }, formatKey(key, language), ":"), " ", /*#__PURE__*/React.createElement(FormattedMessage, {
          id: formatDynamicValue(value, language),
          module: "workforce"
        })));
      })), objects.map(function (_ref9) {
        var _ref10 = _slicedToArray(_ref9, 2),
          key = _ref10[0],
          value = _ref10[1];
        return /*#__PURE__*/React.createElement(Box$1, {
          key: key,
          mt: 2
        }, /*#__PURE__*/React.createElement(Typography, {
          variant: "subtitle1",
          className: classes.label,
          style: {
            fontWeight: "bold",
            fontSize: "large",
            background: "#EEFBFF",
            padding: 3
          }
        }, key === "presentAddressAndLocation" ? language === "en" ? "Present Address & Location" : "বর্তমান ঠিকানা" : key === "permanentAddressAndLocation" ? language === "en" ? "Permanent Address & Location" : "স্থায়ী ঠিকানা" : formatKey(key, language)), _renderDetails(value, classes, key, language, fileStates, handleCommentChange, handleFileVerify, handleFileReject, eligibilityMap, handleEligibilityChange, user_type, remarksMap, handleRemarksChange));
      }), matchingFiles.length > 0 && /*#__PURE__*/React.createElement(Box$1, {
        mt: 2
      }, /*#__PURE__*/React.createElement(Typography, {
        variant: "h6",
        style: {
          marginTop: 3,
          marginBottom: 5
        }
      }, /*#__PURE__*/React.createElement(FormattedMessage, {
        module: "workforce",
        id: "workforce.employee.document"
      })), matchingFiles.map(function (file) {
        return /*#__PURE__*/React.createElement(DocumentReviewAccordion, {
          key: file._originalIndex,
          file: file,
          index: file._originalIndex,
          onCommentChange: handleCommentChange,
          onVerify: handleFileVerify,
          onReject: handleFileReject,
          locale: language,
          viewedFromFlag: viewedFromFlag
        });
      })), parentKey === "workforceEmployeeDependentApplication" && isAllowedUser && /*#__PURE__*/React.createElement(Box$1, {
        mt: 3,
        p: 2,
        style: {
          background: "#f0f7ff",
          borderRadius: 8,
          border: "1px solid #d1e3f0"
        }
      }, /*#__PURE__*/React.createElement(Grid, {
        container: true,
        spacing: 2,
        alignItems: "center"
      }, /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12,
        md: 6
      }, /*#__PURE__*/React.createElement(FormControl, {
        component: "fieldset"
      }, /*#__PURE__*/React.createElement(FormLabel, {
        component: "legend",
        style: {
          fontWeight: "bold",
          fontSize: "0.9rem",
          color: "#333",
          marginBottom: 8
        }
      }, language === "en" ? "Is beneficiary eligible?" : "উপকারভোগী কি যোগ্য?"), /*#__PURE__*/React.createElement(RadioGroup, {
        row: true,
        "aria-label": "eligibility",
        name: "eligibility-".concat(item.id),
        value: (eligibilityMap === null || eligibilityMap === void 0 ? void 0 : eligibilityMap[item.id]) !== undefined ? eligibilityMap[item.id] : (item === null || item === void 0 ? void 0 : item.isEligible) === true ? "yes" : (item === null || item === void 0 ? void 0 : item.isEligible) === false ? "no" : "",
        onChange: function onChange(e) {
          return handleEligibilityChange(item.id, e.target.value);
        }
      }, /*#__PURE__*/React.createElement(FormControlLabel, {
        value: "yes",
        control: /*#__PURE__*/React.createElement(Radio, {
          color: "primary"
        }),
        label: language === "en" ? "Yes" : "হ্যাঁ"
      }), /*#__PURE__*/React.createElement(FormControlLabel, {
        value: "no",
        control: /*#__PURE__*/React.createElement(Radio, {
          color: "primary"
        }),
        label: language === "en" ? "No" : "না"
      })))), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12,
        md: 6
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: language === "en" ? "Remarks" : "মন্তব্য",
        placeholder: language === "en" ? "Enter remarks here..." : "এখানে মন্তব্য লিখুন...",
        value: (remarksMap === null || remarksMap === void 0 ? void 0 : remarksMap[item.id]) !== undefined ? remarksMap[item.id] : (item === null || item === void 0 ? void 0 : item.remarks) || "",
        onChange: function onChange(value) {
          return handleRemarksChange(item.id, value);
        },
        fullWidth: true,
        multiline: true,
        required: eligibilityMap[item.id],
        error: eligibilityMap[item.id],
        helperText: eligibilityMap[item === null || item === void 0 ? void 0 : item.id] && (!remarksMap[item === null || item === void 0 ? void 0 : item.id] || remarksMap[item === null || item === void 0 ? void 0 : item.id].trim() === "") ? language === "en" ? "Remarks required" : "মন্তব্য আবশ্যক" : ""
      }))))));
    });
  }

  // Handle object data
  if (_typeof(mergedData) === "object" && mergedData !== null) {
    if (parentKey === "presentAddressAndLocation" || parentKey === "permanentAddressAndLocation") {
      var _formatAddress = formatAddress$2(mergedData.locationData, mergedData.addressData),
        village = _formatAddress.village,
        postOffice = _formatAddress.postOffice,
        thana = _formatAddress.thana,
        district = _formatAddress.district;
      return /*#__PURE__*/React.createElement(Grid, {
        container: true,
        spacing: 2
      }, /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.itemRow
      }, /*#__PURE__*/React.createElement(Typography, {
        variant: "body1",
        className: classes.value
      }, /*#__PURE__*/React.createElement("span", {
        className: classes.label
      }, language === "en" ? "Village/Road/House" : "গ্রাম/রাস্তা/বাড়ি", ":"), " ", village || "—")), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.itemRow
      }, /*#__PURE__*/React.createElement(Typography, {
        variant: "body1",
        className: classes.value
      }, /*#__PURE__*/React.createElement("span", {
        className: classes.label
      }, language === "en" ? "Post Office" : "পোস্ট অফিস", ":"), " ", postOffice || "—")), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.itemRow
      }, /*#__PURE__*/React.createElement(Typography, {
        variant: "body1",
        className: classes.value
      }, /*#__PURE__*/React.createElement("span", {
        className: classes.label
      }, language === "en" ? "Thana" : "থানা", ":"), " ", thana || "—")), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.itemRow
      }, /*#__PURE__*/React.createElement(Typography, {
        variant: "body1",
        className: classes.value
      }, /*#__PURE__*/React.createElement("span", {
        className: classes.label
      }, language === "en" ? "District" : "জেলা", ":"), " ", district || "—")));
    }
    var scalars = Object.entries(mergedData).filter(function (_ref11) {
      var _ref12 = _slicedToArray(_ref11, 2),
        key = _ref12[0],
        value = _ref12[1];
      return _typeof(value) !== "object" && ![].concat(hiddenKeys, _toConsumableArray(user_type != WORKFORCE_USER_TYPE.BLWF_DOCTOR && user_type != WORKFORCE_USER_TYPE.DOCTOR ? ["status", "grade", "diseaseNo", "diseaseType", "minimumDonationAmount", "maximumDonationAmount"] : [])).includes(key) && value !== null && value !== undefined && value !== "";
    });
    var objects = Object.entries(mergedData).filter(function (_ref13) {
      var _ref14 = _slicedToArray(_ref13, 2),
        key = _ref14[0],
        value = _ref14[1];
      var parsed = tryParse(value);
      return _typeof(parsed) === "object" && parsed && ![].concat(hiddenKeys, _toConsumableArray(user_type != WORKFORCE_USER_TYPE.BLWF_DOCTOR && user_type != WORKFORCE_USER_TYPE.DOCTOR ? ["status", "grade", "diseaseNo", "diseaseType", "minimumDonationAmount", "maximumDonationAmount"] : [])).includes(key);
    });
    return /*#__PURE__*/React.createElement(Grid, {
      container: true,
      spacing: 2
    }, scalars.map(function (_ref15) {
      var _ref16 = _slicedToArray(_ref15, 2),
        key = _ref16[0],
        value = _ref16[1];
      return /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        key: key,
        className: classes.itemRow
      }, /*#__PURE__*/React.createElement(Typography, {
        variant: "body1",
        className: classes.value
      }, /*#__PURE__*/React.createElement("span", {
        className: classes.label,
        style: {
          fontWeight: "bold"
        }
      }, formatKey(key, language), ":"), " ", /*#__PURE__*/React.createElement(FormattedMessage, {
        id: formatDynamicValue(value, language),
        module: "workforce"
      })));
    }), objects.map(function (_ref17) {
      var _ref18 = _slicedToArray(_ref17, 2),
        key = _ref18[0],
        value = _ref18[1];
      var parsedValue = tryParse(value);
      return /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12,
        key: key
      }, /*#__PURE__*/React.createElement(Typography, {
        variant: "subtitle1",
        className: classes.label,
        style: {
          fontWeight: "bold",
          fontSize: "large",
          background: "#EEFBFF",
          padding: 3
        }
      }, formatKey(key, language)), _renderDetails(parsedValue, classes, key, language, fileStates, handleCommentChange, handleFileVerify, handleFileReject, eligibilityMap, handleEligibilityChange, user_type, remarksMap, handleRemarksChange));
    }));
  }
  return null;
};
var PREFERRED_SECTION_ORDER = ["workforceEmployee", "deceasedWorkerInfo", "applicantInfo", "workforceEmployeeDependentApplication",
// "employeeBankInfo",
"employeeBankingInfoApplication"];

// 2. Define keys to ignore (these were previously inside your map function)
var IGNORED_KEYS = ["applicationType", "organizationType", "trackingNumber", "status", "grantAmount", "submittedBy", "dateCreated", "employeeDependentInfo", "eisApprovedByIds", "eisApprovalIds"];
var VERIFICATION_FIELD_MAP = {
  applicantInfo: {
    statusKey: "applicantInfoVerification",
    remarksKey: "applicantInfoVerificationRemarks"
  },
  deceasedWorkerInfo: {
    statusKey: "deceasedWorkerInfoVerification",
    remarksKey: "deceasedWorkerInfoVerificationRemarks"
  },
  doctorsEntry: {
    statusKey: "doctorsEntryVerification",
    remarksKey: "doctorsEntryVerificationRemarks"
  },
  employeeAccidentInfo: {
    statusKey: "employeeAccidentInfoVerification",
    remarksKey: "employeeAccidentInfoVerificationRemarks"
  },
  employeeBankingInfoApplication: {
    statusKey: "employeeBankInfoVerification",
    remarksKey: "employeeBankInfoVerificationRemarks"
  },
  workforceEmployeeDependentApplication: {
    statusKey: "employeeDependentInfoVerification",
    remarksKey: "employeeDependentInfoVerificationRemarks"
  },
  employeeChildrenInfo: {
    statusKey: "employeeChildrenInfoVerification",
    remarksKey: "employeeChildrenInfoVerificationRemarks"
  },
  institutionInfo: {
    statusKey: "institutionInfoVerification",
    remarksKey: "institutionInfoVerificationRemarks"
  },
  metadata: {
    statusKey: "metadataVerification",
    remarksKey: "metadataVerificationRemarks"
  },
  workforceEmployee: {
    statusKey: "workforceEmployeeVerification",
    remarksKey: "workforceEmployeeVerificationRemarks"
  }
};
var ApplicationViewPage = function ApplicationViewPage(_ref19) {
  var application = _ref19.application,
    filteredDocumentTypes = _ref19.filteredDocumentTypes;
    _ref19.applicationUuid;
    var onFileChange = _ref19.onFileChange,
    fileStates = _ref19.fileStates,
    handleCommentChange = _ref19.handleCommentChange,
    handleFileVerify = _ref19.handleFileVerify,
    handleFileReject = _ref19.handleFileReject,
    viewedFromFlag = _ref19.viewedFromFlag,
    movementLogs = _ref19.movementLogs;
  var classes = useStyles$1i();
  var language = useSelector(function (state) {
    var _state$core;
    return (_state$core = state.core) === null || _state$core === void 0 || (_state$core = _state$core.user) === null || _state$core === void 0 || (_state$core = _state$core.i_user) === null || _state$core === void 0 ? void 0 : _state$core.language;
  });
  var user_type = getUserType();
  var dispatch = useDispatch();
  var _useState = useState(""),
    _useState2 = _slicedToArray(_useState, 2),
    lastSalaryAmount = _useState2[0],
    setLastSalaryAmount = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    openAccidentInfoModal = _useState4[0],
    setOpenAccidentInfoModal = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    openCompensationInfoModal = _useState6[0],
    setOpenCompensationInfoModal = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    openSalaryButton = _useState8[0],
    setOpenSalaryButton = _useState8[1];
  var _useState9 = useState(false),
    _useState10 = _slicedToArray(_useState9, 2),
    openHistoryModal = _useState10[0],
    setOpenHistoryModal = _useState10[1];
  var _useState11 = useState(false),
    _useState12 = _slicedToArray(_useState11, 2),
    loading = _useState12[0],
    setLoading = _useState12[1];

  // --- Eligibility State ---
  var _useState13 = useState({}),
    _useState14 = _slicedToArray(_useState13, 2),
    eligibilityMap = _useState14[0],
    setEligibilityMap = _useState14[1];
  var _useState15 = useState({}),
    _useState16 = _slicedToArray(_useState15, 2),
    remarksMap = _useState16[0],
    setRemarksMap = _useState16[1];
  var _useState17 = useState({}),
    _useState18 = _slicedToArray(_useState17, 2),
    verificationState = _useState18[0],
    setVerificationState = _useState18[1];
  useEffect(function () {
    if (application) {
      var initialState = {};
      Object.keys(VERIFICATION_FIELD_MAP).forEach(function (sectionKey) {
        var config = VERIFICATION_FIELD_MAP[sectionKey];
        if (application[config.statusKey] || application[config.remarksKey]) {
          initialState[sectionKey] = {
            status: application[config.statusKey],
            remarks: application[config.remarksKey] || ""
          };
        }
      });
      setVerificationState(initialState);
    }
  }, [application]);
  var handleVerificationChange = function handleVerificationChange(sectionKey, field, value) {
    setVerificationState(function (prev) {
      return _objectSpread$_(_objectSpread$_({}, prev), {}, _defineProperty({}, sectionKey, _objectSpread$_(_objectSpread$_({}, prev[sectionKey]), {}, _defineProperty({}, field, value))));
    });
  };
  var saveVerification = function saveVerification(sectionKey) {
    setLoading(true);
    var config = VERIFICATION_FIELD_MAP[sectionKey];
    if (!config) return;
    var currentData = verificationState[sectionKey] || {};
    var payload = _defineProperty(_defineProperty({
      id: application.id
    }, config.statusKey, currentData.status), config.remarksKey, currentData.remarks);
    console.log("hello from verification update", payload);
    dispatch(updateApplication(payload, "Update verification for ".concat(sectionKey))).then(function () {
      return setLoading(false);
    });
    // Optional: reload or show toast
    // .then(() => window.location.reload());
  };

  // 1. Update Local Map
  var handleEligibilityChange = function handleEligibilityChange(id, value) {
    setEligibilityMap(function (prev) {
      return _objectSpread$_(_objectSpread$_({}, prev), {}, _defineProperty({}, id, value));
    });
  };
  var handleRemarksChange = function handleRemarksChange(id, value) {
    setRemarksMap(function (prev) {
      return _objectSpread$_(_objectSpread$_({}, prev), {}, _defineProperty({}, id, value));
    });
  };

  // 2. Bulk Save Function
  var handleSaveAllDependents = function handleSaveAllDependents() {
    setLoading(true);
    var currentDependents = (application === null || application === void 0 ? void 0 : application.workforceEmployeeDependentApplication) || [];
    var formattedDependentsList = currentDependents.map(function (dep) {
      // --- Existing Eligibility Logic ---
      var updatedIsEligible = dep.isEligible;
      if (eligibilityMap.hasOwnProperty(dep.id)) {
        updatedIsEligible = eligibilityMap[dep.id] === "yes";
      }

      // --- NEW: Remarks Logic ---
      var updatedRemarks = dep.remarks; // Default to existing DB value
      if (remarksMap.hasOwnProperty(dep.id)) {
        updatedRemarks = remarksMap[dep.id]; // Override if user typed something
      }

      // --- Existing Attachment Logic ---
      var parsedAttachments = dep.attachments;
      if (typeof dep.attachments === "string") {
        try {
          parsedAttachments = JSON.parse(dep.attachments);
        } catch (error) {
          console.warn("Error parsing attachments for dependent", dep.id, error);
          parsedAttachments = [];
        }
      }
      return _objectSpread$_(_objectSpread$_({}, dep), {}, {
        isEligible: updatedIsEligible,
        remarks: updatedRemarks,
        // <--- Add this field to the payload
        isDisabled: dep.disabilityStatus,
        relationType: dep.relationWithWorker,
        attachments: parsedAttachments
      });
    });
    var payload = {
      id: application.id,
      employeeDependentInfo: JSON.stringify(formattedDependentsList).replace(/\\/g, "").replace(/"{/g, "{").replace(/}"/g, "}")
    };
    console.log("update application payload", payload);
    dispatch(updateApplication(payload, "update workforce dependent info")).then(function () {
      setLoading(false);
      window.location.reload();
    });
  };
  var hasUnsavedChanges = Object.keys(eligibilityMap).length > 0 || Object.keys(remarksMap).length > 0;
  var handleLastSalaryAmount = function handleLastSalaryAmount(amount) {
    setOpenSalaryButton(true);
    var updateApplicationData = {
      id: application === null || application === void 0 ? void 0 : application.id,
      lastBaseSalary: conditionalEnToBn(amount, "fr")
    };
    dispatch(updateApplication(updateApplicationData, "update workforce application")).then(function () {
      setOpenSalaryButton(false);
      window.location.reload();
    });
  };

  // Sidebar summary fields
  var sidebarFields = useMemo(function () {
    var _application$applican, _application$applican2, _application$workforc, _application$workforc2, _application$workforc3, _application$workforc4, _application$workforc5, _application$workforc6, _application$workforc7, _application$workforc8, _application$employee, _application$employee2, _application$employee3, _application$employee4, _application$employee5, _application$workforc9, _application$grantMon, _application$grantMon2, _application$dateCrea;
    return _objectSpread$_(_objectSpread$_(_objectSpread$_(_objectSpread$_({
      ApplicantName: (application === null || application === void 0 ? void 0 : application.applicationType) === "financialAssistance" || (application === null || application === void 0 ? void 0 : application.applicationType) === "deadlyGrant" ? language === "en" ? (application === null || application === void 0 || (_application$applican = application.applicantInfo) === null || _application$applican === void 0 ? void 0 : _application$applican.nameEn) || "—" : (application === null || application === void 0 || (_application$applican2 = application.applicantInfo) === null || _application$applican2 === void 0 ? void 0 : _application$applican2.nameBn) || "—" : language === "en" ? ((application === null || application === void 0 || (_application$workforc = application.workforceEmployee) === null || _application$workforc === void 0 ? void 0 : _application$workforc.firstNameEn) || (application === null || application === void 0 || (_application$workforc2 = application.workforceEmployee) === null || _application$workforc2 === void 0 ? void 0 : _application$workforc2.nameEn)) + " " + ((application === null || application === void 0 || (_application$workforc3 = application.workforceEmployee) === null || _application$workforc3 === void 0 ? void 0 : _application$workforc3.lastNameEn) != null ? application === null || application === void 0 || (_application$workforc4 = application.workforceEmployee) === null || _application$workforc4 === void 0 ? void 0 : _application$workforc4.lastNameEn : "") : ((application === null || application === void 0 || (_application$workforc5 = application.workforceEmployee) === null || _application$workforc5 === void 0 ? void 0 : _application$workforc5.firstNameBn) || (application === null || application === void 0 || (_application$workforc6 = application.workforceEmployee) === null || _application$workforc6 === void 0 ? void 0 : _application$workforc6.nameBn)) + " " + ((application === null || application === void 0 || (_application$workforc7 = application.workforceEmployee) === null || _application$workforc7 === void 0 ? void 0 : _application$workforc7.lastNameBn) != null ? application === null || application === void 0 || (_application$workforc8 = application.workforceEmployee) === null || _application$workforc8 === void 0 ? void 0 : _application$workforc8.lastNameBn : ""),
      ApplicantFactoryName: language === "en" ? application === null || application === void 0 || (_application$employee = application.employeeFactory) === null || _application$employee === void 0 ? void 0 : _application$employee.nameEn : application === null || application === void 0 || (_application$employee2 = application.employeeFactory) === null || _application$employee2 === void 0 ? void 0 : _application$employee2.nameBn
    }, (user_type === WORKFORCE_USER_TYPE.BEPZA_ASSOCIATION || user_type === WORKFORCE_USER_TYPE.BGMEA_ASSOCIATION || user_type === WORKFORCE_USER_TYPE.BKMEA_ASSOCIATION || user_type === WORKFORCE_USER_TYPE.LFMEAB_ASSOCIATION) && {
      FactoryMembershipNo: (application === null || application === void 0 || (_application$employee3 = application.employeeFactory) === null || _application$employee3 === void 0 ? void 0 : _application$employee3.membershipNo) || "—",
      FactoryRegistrationDate: application !== null && application !== void 0 && (_application$employee4 = application.employeeFactory) !== null && _application$employee4 !== void 0 && _application$employee4.registrationDate ? conditionalEnToBn(application.employeeFactory.registrationDate.split("T")[0], language) : "—",
      FactoryRegistrationExpiryDate: application !== null && application !== void 0 && (_application$employee5 = application.employeeFactory) !== null && _application$employee5 !== void 0 && _application$employee5.registrationExpiryDate ? conditionalEnToBn(application.employeeFactory.registrationExpiryDate.split("T")[0], language) : "—"
    }), (application === null || application === void 0 ? void 0 : application.applicationType) !== "financialAssistance" && {
      ApplicantDesignation: application === null || application === void 0 || (_application$workforc9 = application.workforceEmployee) === null || _application$workforc9 === void 0 ? void 0 : _application$workforc9.position
    }), (user_type === WORKFORCE_USER_TYPE.FACTORY_ADMIN || user_type === WORKFORCE_USER_TYPE.EIS_OFFICER || user_type === WORKFORCE_USER_TYPE.EIS_COORDINATOR) && {
      lastGrossSalary: (application === null || application === void 0 ? void 0 : application.lastBaseSalary) || "—"
    }), {}, {
      ApplicationType: (language === "en" ? application === null || application === void 0 || (_application$grantMon = application.grantMoney) === null || _application$grantMon === void 0 ? void 0 : _application$grantMon.applicationTypeNameEn : application === null || application === void 0 || (_application$grantMon2 = application.grantMoney) === null || _application$grantMon2 === void 0 ? void 0 : _application$grantMon2.applicationTypeNameBn) || (application === null || application === void 0 ? void 0 : application.applicationType),
      OrganizationType: language === "en" ? ORGANIZATION_TYPE_NAME_EN[application === null || application === void 0 ? void 0 : application.organizationType] : ORGANIZATION_TYPE_NAME_BN[application === null || application === void 0 ? void 0 : application.organizationType],
      TrackingNumber: application.trackingNumber,
      Status: language === "en" ? STATUS_MAP_EN[application.status] : STATUS_MAP_BN[application === null || application === void 0 ? void 0 : application.status],
      SubmittedBy: application.submittedBy === "applicant" ? language === "en" ? "Applicant" : "আবেদনকারী" : application.submittedBy,
      CreatedDate: conditionalEnToBn((application === null || application === void 0 || (_application$dateCrea = application.dateCreated) === null || _application$dateCrea === void 0 ? void 0 : _application$dateCrea.split("T")[0]) || "—", language),
      ApplicationFor: (application === null || application === void 0 ? void 0 : application.applicationFor) == "self" ? language === "en" ? "Self" : "নিজের জন্য" : language === "en" ? "Dependent" : "নির্ভরশীলের জন্য"
    }, (user_type === WORKFORCE_USER_TYPE.APPROVER || user_type === WORKFORCE_USER_TYPE.BLWF_APPROVER || user_type === WORKFORCE_USER_TYPE.EIS_COMMITTEE) && {
      CommitteeRemarks: application === null || application === void 0 ? void 0 : application.committeeRemarks
    });
  }, [application]);
  var mapFormStepNo = function mapFormStepNo(fileStepNo, sectionKey, application) {
    var isDeathCase = ["financialAssistance", "deadlyGrant"].includes(application === null || application === void 0 ? void 0 : application.applicationType);
    if (isDeathCase && fileStepNo === "workforceEmployee") {
      return "deceasedWorkerInfo";
    }
    if (fileStepNo === "educations") {
      return "employeeChildrenInfo";
    }
    return fileStepNo;
  };
  var isNotEmpty = function isNotEmpty(value) {
    return !isEmpty(value);
  };

  // Check if user is allowed to save dependents
  var isAllowedUser = [WORKFORCE_USER_TYPE.EIS_COORDINATOR, WORKFORCE_USER_TYPE.EIS_OFFICER].includes(user_type);
  // const hasUnsavedChanges = Object.keys(eligibilityMap).length > 0;

  var sortedKeys = useMemo(function () {
    if (!application) return [];
    var appKeys = Object.keys(application);
    var currentPreferredSectionOrder = [].concat(PREFERRED_SECTION_ORDER);
    if (user_type === WORKFORCE_USER_TYPE.EIS_DOCTOR) {
      currentPreferredSectionOrder = currentPreferredSectionOrder.filter(function (key) {
        return key !== "employeeBankInfo" && key !== "employeeBankingInfoApplication";
      });
    }
    var ordered = currentPreferredSectionOrder.filter(function (key) {
      return appKeys.includes(key);
    });
    var allIgnored = [].concat(IGNORED_KEYS, _toConsumableArray(hiddenKeys.filter(function (item) {
      return !(application !== null && application !== void 0 && application.status) && (item === "employeeBankInfo" || item === "employeeDependentInfo" || item === "metadata") ? false : true;
    })));
    var others = appKeys.filter(function (key) {
      return !currentPreferredSectionOrder.includes(key) && !allIgnored.includes(key) && !(user_type === WORKFORCE_USER_TYPE.EIS_DOCTOR && (key === "employeeBankInfo" || key === "employeeBankingInfoApplication"));
    });
    return [].concat(_toConsumableArray(ordered), _toConsumableArray(others));
  }, [application, user_type]);
  var RESTRICTED_VERIFICATION_ROLES = [WORKFORCE_USER_TYPE.APPLICANT, WORKFORCE_USER_TYPE.EIS_ADVISOR, WORKFORCE_USER_TYPE.EIS_COMMITTEE, WORKFORCE_USER_TYPE.EIS_ASSOCIATION_COMMITTEE];
  console.log({
    view: application
  });
  console.log({
    verificationState: verificationState
  });
  console.log({
    fileStates: fileStates
  });
  console.log({
    lastSalaryAmount: lastSalaryAmount
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 3,
    className: classes.root
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 4
  }, /*#__PURE__*/React.createElement(Paper, {
    className: classes.sidebar
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6",
    gutterBottom: true,
    style: {
      fontWeight: "bold"
    }
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.application.info"
  })), /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement(Box$1, {
    mt: 2
  }, Object.entries(sidebarFields).map(function (_ref20) {
    var _ref21 = _slicedToArray(_ref20, 2),
      label = _ref21[0],
      value = _ref21[1];
    return /*#__PURE__*/React.createElement(Typography, {
      variant: "body1",
      className: classes.value
    }, /*#__PURE__*/React.createElement("span", {
      className: classes.label,
      style: {
        fontWeight: "bold"
      }
    }, formatKey(label, language), ":"), " ", value || "—");
  }))), (user_type === WORKFORCE_USER_TYPE.EIS_COMMITTEE || user_type === WORKFORCE_USER_TYPE.EIS_ASSOCIATION_COMMITTEE) && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(CommitteeMeetingApplicationList, {
    application: application
  })), viewedFromFlag === "view" && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ApplicationMovementStepper, {
    data: movementLogs,
    language: language
  })), viewedFromFlag === "verify" && !isEisPath() && /*#__PURE__*/React.createElement(Box$1, {
    style: {
      margin: 2
    }
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "contained",
    color: "primary",
    onClick: function onClick() {
      return setOpenHistoryModal(true);
    },
    style: {
      paddingY: 0
    }
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "workforce.previous.history.button"
  }))), user_type === WORKFORCE_USER_TYPE.FACTORY_ADMIN && filteredDocumentTypes && (filteredDocumentTypes === null || filteredDocumentTypes === void 0 ? void 0 : filteredDocumentTypes.length) > 0 && /*#__PURE__*/React.createElement(Typography, {
    variant: "h6",
    style: {
      marginTop: 6
    }
  }, /*#__PURE__*/React.createElement("b", null, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.employee.upload.factory.document"
  }))), user_type === WORKFORCE_USER_TYPE.FACTORY_ADMIN && viewedFromFlag === "verify" && /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 2,
    style: {
      marginTop: "10px"
    }
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 9
  }, /*#__PURE__*/React.createElement(TextInput, {
    label: "workforce.application.lastBaseSalary.byFactoryAdmin",
    value: lastSalaryAmount || (application === null || application === void 0 ? void 0 : application.lastBaseSalary) || "",
    onChange: function onChange(e) {
      return setLastSalaryAmount(normalizeNumberInput(e));
    }
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 3
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "contained",
    color: "primary"
    // disabled={application?.lastBaseSalary !== null ? true : openSalaryButton ? true : false}
    ,
    onClick: function onClick() {
      return handleLastSalaryAmount(lastSalaryAmount);
    }
  }, openSalaryButton ? /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "core.table.resultsLoading",
    module: "workforce"
  }) : /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "workforce.submit",
    module: "workforce"
  }))), (application === null || application === void 0 ? void 0 : application.organizationType) === "eis" && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "contained",
    color: "primary",
    onClick: function onClick() {
      return setOpenAccidentInfoModal(true);
    },
    fullwidth: true,
    disabled: isNotEmpty(application === null || application === void 0 ? void 0 : application.employeeAccidentInfo)
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "workforce.eis.factory.admin.accidentInfo.button",
    module: "workforce"
  }))))), user_type === WORKFORCE_USER_TYPE.FACTORY_ADMIN && viewedFromFlag === "verify" && /*#__PURE__*/React.createElement(React.Fragment, null, filteredDocumentTypes === null || filteredDocumentTypes === void 0 ? void 0 : filteredDocumentTypes.map(function (document, index) {
    return /*#__PURE__*/React.createElement(Box$1, {
      style: {
        marginTop: "10px"
      }
    }, /*#__PURE__*/React.createElement(Typography, null, language === "en" ? document === null || document === void 0 ? void 0 : document.nameEn : document === null || document === void 0 ? void 0 : document.nameBn), /*#__PURE__*/React.createElement(FileUploader, {
      fieldKey: document.fieldId,
      applicationId: application === null || application === void 0 ? void 0 : application.id,
      onFileChange: onFileChange,
      documentType: document.documentType,
      documentProp: document,
      uploadedBy: "factoryAdmin"
    }));
  })), (user_type === WORKFORCE_USER_TYPE.EIS_COORDINATOR || user_type === WORKFORCE_USER_TYPE.EIS_OFFICER || user_type === WORKFORCE_USER_TYPE.FACTORY_ADMIN) && (application === null || application === void 0 ? void 0 : application.organizationType) === "eis" && /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 2,
    style: {
      marginTop: "10px"
    }
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "contained",
    color: "primary",
    onClick: function onClick() {
      return setOpenCompensationInfoModal(true);
    },
    fullwidth: true
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "workforce.other.compensationInfo",
    module: "workforce"
  })))), (user_type === WORKFORCE_USER_TYPE.DOCTOR || user_type === WORKFORCE_USER_TYPE.BLWF_DOCTOR || user_type === WORKFORCE_USER_TYPE.EIS_DOCTOR || user_type === WORKFORCE_USER_TYPE.EIS_COORDINATOR) && viewedFromFlag === "verify" && /*#__PURE__*/React.createElement(DoctorsEntries, {
    application: application
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 8
  }, sortedKeys.map(function (key) {
    var _verificationState$ke, _verificationState$ke2, _verificationState$ke3, _verificationState$ke4, _verificationState$ke5, _verificationState$ke6, _verificationState$ke7, _verificationState$ke8, _verificationState$ke9, _verificationState$ke10, _verificationState$ke11, _verificationState$ke12;
    var value = application[key];
    if (key === "workforceEmployee" && ["financialAssistance", "deadlyGrant"].includes(application === null || application === void 0 ? void 0 : application.applicationType)) {
      return null;
    }
    var parsedValue = tryParse(value);
    if (!parsedValue || isEmpty(parsedValue)) return null;
    var currentVerificationStatus = (_verificationState$ke = verificationState[key]) === null || _verificationState$ke === void 0 ? void 0 : _verificationState$ke.status;
    return /*#__PURE__*/React.createElement(Accordion, {
      key: key,
      className: classes.accordion,
      style: {
        background: "#B7D4D8"
      }
    }, /*#__PURE__*/React.createElement(AccordionSummary, {
      expandIcon: /*#__PURE__*/React.createElement(ExpandMoreIcon, null)
    }, /*#__PURE__*/React.createElement(Box$1, {
      display: "flex",
      alignItems: "center",
      width: "100%",
      justifyContent: "space-between",
      pr: 2
    }, /*#__PURE__*/React.createElement(Typography, {
      className: classes.sectionTitle
    }, formatKey(key, language)), currentVerificationStatus && /*#__PURE__*/React.createElement(Box$1, {
      style: {
        backgroundColor: currentVerificationStatus === "correct" ? "#4caf50" : "#f44336",
        // Green for Correct, Red for Incorrect
        color: "#fff",
        padding: "2px 10px",
        borderRadius: "12px",
        fontSize: "0.75rem",
        fontWeight: "bold",
        textTransform: "uppercase",
        marginLeft: "10px"
      }
    }, currentVerificationStatus === "correct" ? language === "en" ? "Correct" : "সঠিক" : language === "en" ? "Incorrect" : "ভুল"))), /*#__PURE__*/React.createElement(AccordionDetails, {
      style: {
        display: "block",
        background: "white"
      }
    }, _renderDetails(value, classes, key, language, fileStates, handleCommentChange, handleFileVerify, handleFileReject, eligibilityMap, handleEligibilityChange, user_type, remarksMap, handleRemarksChange, viewedFromFlag), key === "workforceEmployeeDependentApplication" && isAllowedUser && /*#__PURE__*/React.createElement(Box$1, {
      className: classes.bulkActionContainer
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "body2",
      style: {
        marginRight: 15,
        color: "#666"
      }
    }, language === "en" ? "Select eligibility for dependents above, then click save." : "উপরের নির্ভরশীলদের জন্য যোগ্যতা নির্বাচন করুন, তারপর সংরক্ষণ করুন এ ক্লিক করুন।"), /*#__PURE__*/React.createElement(Button, {
      variant: "contained",
      color: "primary",
      onClick: handleSaveAllDependents,
      disabled: !hasUnsavedChanges || loading
    }, loading ? /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "core.table.resultsLoading"
    }) : /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.dependent.eligibility.btn"
    }))), fileStates && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography, {
      variant: "h6",
      style: {
        marginTop: 3
      }
    }, /*#__PURE__*/React.createElement(FormattedMessage, {
      module: "workforce",
      id: "workforce.employee.document"
    })), fileStates === null || fileStates === void 0 ? void 0 : fileStates.filter(function (item, originalIdx) {
      var _item$workforceDocume;
      item._originalIndex = originalIdx;
      return mapFormStepNo(item === null || item === void 0 || (_item$workforceDocume = item.workforceDocumentType) === null || _item$workforceDocume === void 0 ? void 0 : _item$workforceDocume.formStepNo, key, application) === key;
    }).map(function (file) {
      return /*#__PURE__*/React.createElement(DocumentReviewAccordion, {
        key: file._originalIndex,
        file: file,
        index: file._originalIndex,
        onCommentChange: handleCommentChange,
        onVerify: handleFileVerify,
        onReject: handleFileReject,
        locale: language,
        viewedFromFlag: viewedFromFlag
      });
    })), viewedFromFlag === "verify" && VERIFICATION_FIELD_MAP[key] && !RESTRICTED_VERIFICATION_ROLES.includes(user_type) && /*#__PURE__*/React.createElement(Box$1, {
      className: classes.verificationBox
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "subtitle1",
      style: {
        fontWeight: "bold",
        marginBottom: 8
      }
    }, language === "en" ? "Section Verification" : "সেকশন যাচাইকরণ"), /*#__PURE__*/React.createElement(Grid, {
      container: true,
      spacing: 2,
      alignItems: "center"
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 4
    }, /*#__PURE__*/React.createElement(FormControl, {
      component: "fieldset"
    }, /*#__PURE__*/React.createElement(RadioGroup, {
      row: true,
      name: "verify-".concat(key),
      value: ((_verificationState$ke2 = verificationState[key]) === null || _verificationState$ke2 === void 0 ? void 0 : _verificationState$ke2.status) || "",
      onChange: function onChange(e) {
        return handleVerificationChange(key, "status", e.target.value);
      }
    }, /*#__PURE__*/React.createElement(FormControlLabel, {
      value: "correct",
      control: /*#__PURE__*/React.createElement(Radio, {
        color: "primary"
      }),
      label: language === "en" ? "Correct" : "সঠিক"
    }), /*#__PURE__*/React.createElement(FormControlLabel, {
      value: "incorrect",
      control: /*#__PURE__*/React.createElement(Radio, {
        color: "primary"
      }),
      label: language === "en" ? "Incorrect" : "ভুল"
    })))), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 6
    }, /*#__PURE__*/React.createElement(TextInput, {
      label: language === "en" ? "Remarks" : "মন্তব্য",
      placeholder: language === "en" ? "Enter verification remarks" : "যাচাইকরণ মন্তব্য লিখুন",
      value: ((_verificationState$ke3 = verificationState[key]) === null || _verificationState$ke3 === void 0 ? void 0 : _verificationState$ke3.remarks) || "",
      onChange: function onChange(e) {
        return handleVerificationChange(key, "remarks", typeof e === "string" ? e : e.target.value);
      },
      fullWidth: true,
      multiline: true
      // --- ADD THESE LINES ---
      ,
      required: ((_verificationState$ke4 = verificationState[key]) === null || _verificationState$ke4 === void 0 ? void 0 : _verificationState$ke4.status) === "incorrect",
      error: ((_verificationState$ke5 = verificationState[key]) === null || _verificationState$ke5 === void 0 ? void 0 : _verificationState$ke5.status) === "incorrect" && (!((_verificationState$ke6 = verificationState[key]) !== null && _verificationState$ke6 !== void 0 && _verificationState$ke6.remarks) || ((_verificationState$ke7 = verificationState[key]) === null || _verificationState$ke7 === void 0 ? void 0 : _verificationState$ke7.remarks.trim()) === ""),
      helperText: ((_verificationState$ke8 = verificationState[key]) === null || _verificationState$ke8 === void 0 ? void 0 : _verificationState$ke8.status) === "incorrect" && (!((_verificationState$ke9 = verificationState[key]) !== null && _verificationState$ke9 !== void 0 && _verificationState$ke9.remarks) || ((_verificationState$ke10 = verificationState[key]) === null || _verificationState$ke10 === void 0 ? void 0 : _verificationState$ke10.remarks.trim()) === "") ? language === "en" ? "Remarks required" : "মন্তব্য আবশ্যক" : ""
      // -----------------------
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 2
    }, /*#__PURE__*/React.createElement(Button, {
      variant: "contained",
      color: "primary",
      fullWidth: true,
      onClick: function onClick() {
        return saveVerification(key);
      },
      disabled: loading || ((_verificationState$ke11 = verificationState[key]) === null || _verificationState$ke11 === void 0 ? void 0 : _verificationState$ke11.status) === "incorrect" && !((_verificationState$ke12 = verificationState[key]) !== null && _verificationState$ke12 !== void 0 && _verificationState$ke12.remarks)
    }, loading ? /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "core.table.resultsLoading"
    }) : /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.update.btn"
    })))))));
  }), fileStates && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6",
    style: {
      marginTop: 3
    }
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.employee.other.document"
  })), fileStates === null || fileStates === void 0 ? void 0 : fileStates.filter(function (item, originalIdx) {
    var _item$workforceDocume2, _item$workforceDocume3;
    item._originalIndex = originalIdx;
    return (item === null || item === void 0 || (_item$workforceDocume2 = item.workforceDocumentType) === null || _item$workforceDocume2 === void 0 ? void 0 : _item$workforceDocume2.formStepNo) === "workforceDocument" || (item === null || item === void 0 || (_item$workforceDocume3 = item.workforceDocumentType) === null || _item$workforceDocume3 === void 0 ? void 0 : _item$workforceDocume3.mandatoryForApplicant) === false;
  }).map(function (file) {
    return /*#__PURE__*/React.createElement(DocumentReviewAccordion, {
      key: file._originalIndex,
      file: file,
      index: file._originalIndex,
      onCommentChange: handleCommentChange,
      onVerify: handleFileVerify,
      onReject: handleFileReject,
      locale: language,
      viewedFromFlag: viewedFromFlag
    });
  })))), openAccidentInfoModal && /*#__PURE__*/React.createElement(EisFactoryAdminModal, {
    open: openAccidentInfoModal,
    onClose: function onClose() {
      return setOpenAccidentInfoModal(false);
    },
    application: application
  }), /*#__PURE__*/React.createElement(CompensationFormModal, {
    open: openCompensationInfoModal,
    application: application,
    onClose: function onClose() {
      return setOpenCompensationInfoModal(false);
    },
    entryType: "factory"
  }), openHistoryModal && /*#__PURE__*/React.createElement(ApplicationPreviousHistory, {
    open: openHistoryModal,
    onClose: function onClose() {
      return setOpenHistoryModal(false);
    },
    application: application
  }));
};

function ownKeys$Z(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$Z(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$Z(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$Z(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var useStyles$1h = makeStyles(function (theme) {
  return {
    container: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center"
    },
    paper: {
      padding: theme.spacing(1),
      width: 700
    },
    buttonContainer: {
      marginTop: theme.spacing(2),
      display: "flex",
      justifyContent: "flex-end",
      gap: theme.spacing(1)
    }
  };
});
var MedicalAssistanceForm = function MedicalAssistanceForm(_ref) {
  var _formData$workforceEm, _formData$workforceEm2;
  var workforceFactoryId = _ref.workforceFactoryId,
    organizationType = _ref.organizationType,
    selectedApplicationType = _ref.selectedApplicationType,
    applicationForSelf = _ref.applicationForSelf,
    selectedFactory = _ref.selectedFactory,
    parsedApplicationData = _ref.parsedApplicationData;
  var employeeData = useSelector(function (state) {
    return state.workforce.workforceEmployee;
  });
  var documentType = useSelector(function (state) {
    return state.workforce.documentType;
  });
  var modulesManager = useModulesManager();
  var _useTranslations = useTranslations("workforce"),
    formatMessage = _useTranslations.formatMessage;
  var stepRef = useRef(null);
  var _useState = useState({}),
    _useState2 = _slicedToArray(_useState, 2),
    errors = _useState2[0],
    setErrors = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    acknowledged = _useState4[0],
    setAcknowledged = _useState4[1];
  var applicationId = useSelector(function (state) {
    var _state$workforce$fetc;
    return (_state$workforce$fetc = state.workforce["fetchedApplicationIdByClientMutationId"]) !== null && _state$workforce$fetc !== void 0 ? _state$workforce$fetc : [];
  });
  var uploadFile = useSelector(function (state) {
    return state.workforce.uploadFile;
  });
  var uploadBankFile = useSelector(function (state) {
    return state.workforce.uploadBankFile;
  });
  var uploadDependentFile = useSelector(function (state) {
    return state.workforce.uploadDependentFile;
  });
  var classes = useStyles$1h();
  var dispatch = useDispatch();
  var _useState5 = useState(0),
    _useState6 = _slicedToArray(_useState5, 2),
    expanded = _useState6[0],
    setExpanded = _useState6[1];
  var _useState7 = useState(0),
    _useState8 = _slicedToArray(_useState7, 2),
    activeStep = _useState8[0],
    setActiveStep = _useState8[1];
  var _useState9 = useState(false),
    _useState10 = _slicedToArray(_useState9, 2),
    showErrorSnackbar = _useState10[0],
    setShowErrorSnackbar = _useState10[1];
  var _useState11 = useState(false),
    _useState12 = _slicedToArray(_useState11, 2),
    isSubmitted = _useState12[0],
    setIsSubmitted = _useState12[1];
  var _useState13 = useState(false),
    _useState14 = _slicedToArray(_useState13, 2),
    showVerifyNid = _useState14[0],
    setShowVerifyNid = _useState14[1];
  var _useState15 = useState(false),
    _useState16 = _slicedToArray(_useState15, 2),
    isNavigationBlocked = _useState16[0],
    setIsNavigationBlocked = _useState16[1];
  var _useState17 = useState(false),
    _useState18 = _slicedToArray(_useState17, 2),
    showPreview = _useState18[0],
    setShowPreview = _useState18[1];
  var reduxState = useSelector(function (state) {
    return state;
  });
  var _useState19 = useState(false),
    _useState20 = _slicedToArray(_useState19, 2);
    _useState20[0];
    var setDisableConfirmSubmit = _useState20[1];
  var user_type = getUserType();
  var _useState21 = useState({
      workforceEmployee: {
        nameEn: "",
        nameBn: "",
        lastNameEn: "",
        position: "",
        fatherNameEn: "",
        fatherNameBn: "",
        motherNameEn: "",
        motherNameBn: "",
        spouseNameEn: "",
        spouseNameBn: "",
        phoneNumber: "",
        email: "",
        birthDate: "",
        deathDate: "",
        joinDate: "",
        nid: "",
        birthCertificateNo: "",
        insuranceNumber: "",
        lifeStatus: "",
        gender: "",
        maritalStatus: "",
        monthlyEarning: "",
        uploadedNidFile: [],
        citizenship: "",
        uploadedBirthCertificateFile: [],
        permanentAddress: "",
        permanentLocation: "",
        presentLocation: "",
        presentAddress: "",
        organizationId: ""
      },
      company: null,
      factory: selectedFactory || null,
      workforceFactoryId: workforceFactoryId || "",
      isSubmitted: "no",
      organizationType: "",
      applicationType: "",
      applicationForSelf: applicationForSelf,
      dependents: [{}],
      employeeBankInfo: [{}],
      employeeAccidentInfo: {},
      id: ""
    }),
    _useState22 = _slicedToArray(_useState21, 2),
    formData = _useState22[0],
    setFormData = _useState22[1];
  var _useState23 = useState({
      nid: (formData === null || formData === void 0 || (_formData$workforceEm = formData.workforceEmployee) === null || _formData$workforceEm === void 0 ? void 0 : _formData$workforceEm.nid) || "",
      birthCertificateNo: formData === null || formData === void 0 || (_formData$workforceEm2 = formData.workforceEmployee) === null || _formData$workforceEm2 === void 0 ? void 0 : _formData$workforceEm2.birthCertificateNo
    }),
    _useState24 = _slicedToArray(_useState23, 2),
    nidOrBcn = _useState24[0],
    setNidOrBcn = _useState24[1];
  useEffect(function () {
    var _applicationId$;
    if (applicationId && applicationId.length > 0 && (_applicationId$ = applicationId[0]) !== null && _applicationId$ !== void 0 && _applicationId$.id) {
      setFormData(function (prev) {
        return _objectSpread$Z(_objectSpread$Z({}, prev), {}, {
          applicationId: applicationId[0].id
        });
      });
    }
  }, [applicationId]);
  // Fetch employee data based on username
  var fetchEmployeeWithUser = function fetchEmployeeWithUser() {
    if (reduxState.workforce.selectedEmployee) {
      dispatch(fetchWorkforceEmployee(modulesManager, ["id: \"".concat(decodeId(reduxState.workforce.selectedEmployee.id), "\"")]));
    } else {
      dispatch(fetchWorkforceEmployee(modulesManager, ["relatedUser_LoginName_Iexact: \"".concat(reduxState.core.user.username, "\"")]));
    }
  };
  useEffect(function () {
    if (reduxState.core.user.username) {
      fetchEmployeeWithUser();
    }
  }, [reduxState.core.user.username]);
  useEffect(function () {
    var _parsedApplicationDat, _formData$workforceEm3, _formData$workforceEm4;
    if (!(employeeData !== null && employeeData !== void 0 && employeeData.id) && !(parsedApplicationData !== null && parsedApplicationData !== void 0 && (_parsedApplicationDat = parsedApplicationData.workforceEmployee) !== null && _parsedApplicationDat !== void 0 && _parsedApplicationDat.id)) {
      return;
    }
    // When employeeData is fetched, set it into the form state
    setFormData({
      id: (parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.id) || "",
      workforceEmployee: {
        id: (employeeData === null || employeeData === void 0 ? void 0 : employeeData.id) || reduxState.core.user.id || "",
        organization: employeeData.organization,
        nameEn: employeeData.firstNameEn || "",
        nameBn: employeeData.firstNameBn || "",
        lastNameEn: " ",
        position: employeeData.position || "",
        fatherNameEn: employeeData.fatherNameEn || "",
        fatherNameBn: employeeData.fatherNameBn || "",
        motherNameEn: employeeData.motherNameEn || "",
        motherNameBn: employeeData.motherNameBn || "",
        spouseNameEn: employeeData.spouseNameEn || "",
        spouseNameBn: employeeData.spouseNameBn || "",
        phoneNumber: employeeData.phoneNumber || "",
        email: employeeData.email || "",
        citizenship: employeeData.citizenship || "",
        birthDate: employeeData.birthDate || "",
        deathDate: employeeData.deathDate || "",
        joinDate: employeeData.joinDate || "",
        nid: employeeData.nid || "",
        birthCertificateNo: employeeData.birthCertificateNo || "",
        insuranceNumber: employeeData.insuranceNumber || "",
        lifeStatus: employeeData.lifeStatus || "",
        gender: employeeData.gender || "",
        maritalStatus: employeeData.maritalStatus || "",
        monthlyEarning: employeeData.monthlyEarning || "",
        uploadedNidFile: employeeData.uploadedNidFile || [],
        uploadedBirthCertificateFile: employeeData.uploadedBirthCertificateFile || [],
        permanentAddress: employeeData.permanentAddress || "",
        permanentLocation: employeeData.permanentLocation || "",
        presentLocation: employeeData.presentLocation || "",
        presentAddress: employeeData.presentAddress || ""
      },
      company: employeeData.company || (formData === null || formData === void 0 || (_formData$workforceEm3 = formData.workforceEmployee) === null || _formData$workforceEm3 === void 0 || (_formData$workforceEm3 = _formData$workforceEm3.company) === null || _formData$workforceEm3 === void 0 ? void 0 : _formData$workforceEm3.id) || null,
      factory: employeeData.factory || (formData === null || formData === void 0 || (_formData$workforceEm4 = formData.workforceEmployee) === null || _formData$workforceEm4 === void 0 || (_formData$workforceEm4 = _formData$workforceEm4.factory) === null || _formData$workforceEm4 === void 0 ? void 0 : _formData$workforceEm4.id) || (parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.employeeFactory) || workforceFactoryId || selectedFactory || null,
      applicationForSelf: applicationForSelf,
      workforceFactoryId: workforceFactoryId || "",
      organizationType: (parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.organizationType) || organizationType,
      applicationType: (parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.applicationType) || selectedApplicationType,
      grantAmount: (parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.grantAmount) || (parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.employeeAccidentInfo.grantAmount),
      dependents: (parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.employeeDependentInfo) || employeeData.dependents || [{}],
      employeeBankInfo: (parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.employeeBankInfo) || (employeeData === null || employeeData === void 0 ? void 0 : employeeData.employeeBankInfo) || [{}],
      employeeAccidentInfo: (parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.employeeAccidentInfo) || (employeeData === null || employeeData === void 0 ? void 0 : employeeData.employeeAccidentInfo) || {},
      metadata: (parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.metadata) || (employeeData === null || employeeData === void 0 ? void 0 : employeeData.metadata) || {},
      applicantInfo: (parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.applicantInfo) || (employeeData === null || employeeData === void 0 ? void 0 : employeeData.metadata) || {}
    });
  }, [employeeData === null || employeeData === void 0 ? void 0 : employeeData.id, parsedApplicationData, user_type]); // Trigger this useEffect when `employeeData` changes.

  // Handle form input changes
  var _handleChange = function handleChange(key, value) {
    var parent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    setFormData(function (prev) {
      if (parent) {
        return _objectSpread$Z(_objectSpread$Z({}, prev), {}, _defineProperty({}, parent, _objectSpread$Z(_objectSpread$Z({}, prev[parent]), {}, _defineProperty({}, key, value))));
      }
      return _objectSpread$Z(_objectSpread$Z({}, prev), {}, _defineProperty({}, key, value));
    });
  };
  var handleNext = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var newErrors, isBankStep, isDependentStep, documentValidation, BANK_DOC, bankDocsConfig, generalDocsConfig, _formData$workforceEm5, nextStep, shouldBlockNavigation, fakeErrors, _formData$workforceEm6, _formData$workforceEm7, _formData$workforceEm8, _formData$workforceEm9, _formData$workforceEm10, _formData$workforceEm11, _formData$workforceEm12, _formData$workforceEm13, _formData$workforceEm14, _formData$workforceEm15, _formData$workforceEm16, _formData$workforceEm17, _formData$workforceEm18, _formData$workforceEm19, _formData$workforceEm20, _formData$workforceEm21, _formData$workforceEm22, _formData$workforceEm23, _formData$workforceEm24, _formData$workforceEm25, _formData$workforceEm26, _formData$workforceEm27, _formData$workforceEm28, workforceEmployeeData, _formData$workforceEm29, _parsedApplicationDat2, _formData$workforceEm30, _formData$factory, _formData$factory2, createApplicationData, applicationMutation, applicationClientMutationId, fetchRes, applicationgetId, updateApplicationData, _parsedApplicationDat3, _formData$workforceEm31, _formData$factory3, _formData$factory4, _updateApplicationData;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            console.log(activeStep);
            newErrors = validateRequiredFields(stepRef, formatMessage, formData);
            newErrors === null || newErrors === void 0 || delete newErrors.documents;
            isBankStep = (formData === null || formData === void 0 ? void 0 : formData.applicationForSelf) === "yes" && activeStep === 3 || (formData === null || formData === void 0 ? void 0 : formData.applicationForSelf) === "yes" && activeStep === 4;
            isDependentStep = (formData === null || formData === void 0 ? void 0 : formData.applicationForSelf) === "no" && activeStep === 2;
            documentValidation = {
              isValid: true,
              errors: null
            };
            BANK_DOC = "applicants bank check copy";
            if (isDependentStep) {
              // Specialized validation for the Dependent Step
              documentValidation = validateMandatoryDocumentsForDependents(documentType, uploadDependentFile || [], formData.dependents || []);
            } else if (isBankStep) {
              // Filter only for Bank Documents
              bankDocsConfig = (documentType || []).filter(function (doc) {
                return doc.documentType === BANK_DOC;
              });
              documentValidation = validateMandatoryBankDocumentsForAccounts(bankDocsConfig, uploadBankFile || [], formData.employeeBankInfo || []);
            } else {
              // Filter out Bank Documents for general info steps
              generalDocsConfig = (documentType || []).filter(function (doc) {
                return doc.documentType !== BANK_DOC;
              }).filter(function (doc) {
                var _formData$employeeAcc, _formData$employeeAcc2;
                if (!isEisPath() && doc.documentType === "discharge certificate" && ((formData === null || formData === void 0 || (_formData$employeeAcc = formData.employeeAccidentInfo) === null || _formData$employeeAcc === void 0 ? void 0 : _formData$employeeAcc.admitted) === "no" || (formData === null || formData === void 0 || (_formData$employeeAcc2 = formData.employeeAccidentInfo) === null || _formData$employeeAcc2 === void 0 ? void 0 : _formData$employeeAcc2.admitted) === undefined)) {
                  return false;
                }
                return true;
              });
              documentValidation = validateMandatoryDocuments(generalDocsConfig, uploadFile || []);
            }
            if (!documentValidation.isValid) {
              newErrors.documents = documentValidation.errors;
            }
            setErrors(newErrors);
            console.log({
              newErrors: newErrors
            });
            console.log({
              documentValidation: documentValidation
            });
            if (Object.keys(newErrors).length > 0 && !(newErrors !== null && newErrors !== void 0 && newErrors.documents)) {
              setShowErrorSnackbar(true);
            } else {
              setShowErrorSnackbar(false);
            }
            if (!(Object.keys(newErrors).length === 0)) {
              _context.next = 81;
              break;
            }
            nextStep = activeStep + 1;
            shouldBlockNavigation = (formData === null || formData === void 0 ? void 0 : formData.applicationForSelf) === "no" && activeStep === 2;
            if (!(nextStep === 1 && !isAtLeast18YearsOld(formData === null || formData === void 0 || (_formData$workforceEm5 = formData.workforceEmployee) === null || _formData$workforceEm5 === void 0 ? void 0 : _formData$workforceEm5.birthDate))) {
              _context.next = 24;
              break;
            }
            fakeErrors = _objectSpread$Z(_objectSpread$Z({}, newErrors), {}, {
              rdmp: "core.error.workerAge"
            });
            setErrors(fakeErrors);
            console.log({
              fakeErrors: fakeErrors
            });
            return _context.abrupt("return", false);
          case 24:
            if (shouldBlockNavigation) {
              setIsNavigationBlocked(true);
            }
            if (!(nextStep === 1 || nextStep === 2)) {
              _context.next = 32;
              break;
            }
            // const nidValue = formData?.workforceEmployee?.nid;
            workforceEmployeeData = {
              nameEn: formData === null || formData === void 0 || (_formData$workforceEm6 = formData.workforceEmployee) === null || _formData$workforceEm6 === void 0 ? void 0 : _formData$workforceEm6.nameEn,
              nameBn: formData === null || formData === void 0 || (_formData$workforceEm7 = formData.workforceEmployee) === null || _formData$workforceEm7 === void 0 ? void 0 : _formData$workforceEm7.nameBn,
              lastNameEn: "",
              phoneNumber: formData === null || formData === void 0 || (_formData$workforceEm8 = formData.workforceEmployee) === null || _formData$workforceEm8 === void 0 ? void 0 : _formData$workforceEm8.phoneNumber,
              email: formData === null || formData === void 0 || (_formData$workforceEm9 = formData.workforceEmployee) === null || _formData$workforceEm9 === void 0 ? void 0 : _formData$workforceEm9.email,
              gender: formData === null || formData === void 0 || (_formData$workforceEm10 = formData.workforceEmployee) === null || _formData$workforceEm10 === void 0 || (_formData$workforceEm10 = _formData$workforceEm10.gender) === null || _formData$workforceEm10 === void 0 ? void 0 : _formData$workforceEm10.name,
              birthDate: formData === null || formData === void 0 || (_formData$workforceEm11 = formData.workforceEmployee) === null || _formData$workforceEm11 === void 0 ? void 0 : _formData$workforceEm11.birthDate,
              deathDate: formData === null || formData === void 0 || (_formData$workforceEm12 = formData.workforceEmployee) === null || _formData$workforceEm12 === void 0 ? void 0 : _formData$workforceEm12.deathDate,
              lifeStatus: formData === null || formData === void 0 || (_formData$workforceEm13 = formData.workforceEmployee) === null || _formData$workforceEm13 === void 0 ? void 0 : _formData$workforceEm13.lifeStatus,
              permanentAddress: formData === null || formData === void 0 || (_formData$workforceEm14 = formData.workforceEmployee) === null || _formData$workforceEm14 === void 0 ? void 0 : _formData$workforceEm14.permanentAddress,
              presentAddress: formData === null || formData === void 0 || (_formData$workforceEm15 = formData.workforceEmployee) === null || _formData$workforceEm15 === void 0 ? void 0 : _formData$workforceEm15.presentAddress,
              position: formData === null || formData === void 0 || (_formData$workforceEm16 = formData.workforceEmployee) === null || _formData$workforceEm16 === void 0 ? void 0 : _formData$workforceEm16.position,
              monthlyEarning: formData === null || formData === void 0 || (_formData$workforceEm17 = formData.workforceEmployee) === null || _formData$workforceEm17 === void 0 ? void 0 : _formData$workforceEm17.monthlyEarning,
              insuranceNumber: " ",
              fatherNameBn: formData === null || formData === void 0 || (_formData$workforceEm18 = formData.workforceEmployee) === null || _formData$workforceEm18 === void 0 ? void 0 : _formData$workforceEm18.fatherNameBn,
              fatherNameEn: formData === null || formData === void 0 || (_formData$workforceEm19 = formData.workforceEmployee) === null || _formData$workforceEm19 === void 0 ? void 0 : _formData$workforceEm19.fatherNameEn,
              motherNameBn: formData === null || formData === void 0 || (_formData$workforceEm20 = formData.workforceEmployee) === null || _formData$workforceEm20 === void 0 ? void 0 : _formData$workforceEm20.motherNameBn,
              motherNameEn: formData === null || formData === void 0 || (_formData$workforceEm21 = formData.workforceEmployee) === null || _formData$workforceEm21 === void 0 ? void 0 : _formData$workforceEm21.motherNameEn,
              spouseNameBn: formData === null || formData === void 0 || (_formData$workforceEm22 = formData.workforceEmployee) === null || _formData$workforceEm22 === void 0 ? void 0 : _formData$workforceEm22.spouseNameBn,
              spouseNameEn: formData === null || formData === void 0 || (_formData$workforceEm23 = formData.workforceEmployee) === null || _formData$workforceEm23 === void 0 ? void 0 : _formData$workforceEm23.spouseNameEn,
              citizenship: formData === null || formData === void 0 || (_formData$workforceEm24 = formData.workforceEmployee) === null || _formData$workforceEm24 === void 0 ? void 0 : _formData$workforceEm24.citizenship,
              maritalStatus: formData === null || formData === void 0 || (_formData$workforceEm25 = formData.workforceEmployee) === null || _formData$workforceEm25 === void 0 ? void 0 : _formData$workforceEm25.maritalStatus,
              presentLocation: formData === null || formData === void 0 || (_formData$workforceEm26 = formData.workforceEmployee) === null || _formData$workforceEm26 === void 0 ? void 0 : _formData$workforceEm26.presentLocation,
              permanentLocation: formData === null || formData === void 0 || (_formData$workforceEm27 = formData.workforceEmployee) === null || _formData$workforceEm27 === void 0 ? void 0 : _formData$workforceEm27.permanentLocation,
              id: (formData === null || formData === void 0 || (_formData$workforceEm28 = formData.workforceEmployee) === null || _formData$workforceEm28 === void 0 ? void 0 : _formData$workforceEm28.id) || reduxState.core.user.id
            };
            console.log("Update Submitting formData:", workforceEmployeeData);
            _context.next = 30;
            return dispatch(updateWorkforceEmployee(workforceEmployeeData, "Update Workforce Employee ".concat(workforceEmployeeData.nameEn)));
          case 30:
            _context.next = 67;
            break;
          case 32:
            if (!(nextStep === 3)) {
              _context.next = 63;
              break;
            }
            createApplicationData = {
              workforceEmployeeId: (formData === null || formData === void 0 || (_formData$workforceEm29 = formData.workforceEmployee) === null || _formData$workforceEm29 === void 0 ? void 0 : _formData$workforceEm29.id) || (parsedApplicationData === null || parsedApplicationData === void 0 || (_parsedApplicationDat2 = parsedApplicationData.workforceEmployee) === null || _parsedApplicationDat2 === void 0 ? void 0 : _parsedApplicationDat2.id),
              company: formData === null || formData === void 0 || (_formData$workforceEm30 = formData.workforceEmployee) === null || _formData$workforceEm30 === void 0 || (_formData$workforceEm30 = _formData$workforceEm30.company) === null || _formData$workforceEm30 === void 0 ? void 0 : _formData$workforceEm30.id,
              factory: formData !== null && formData !== void 0 && (_formData$factory = formData.factory) !== null && _formData$factory !== void 0 && _formData$factory.id ? safeDecodeId(formData === null || formData === void 0 || (_formData$factory2 = formData.factory) === null || _formData$factory2 === void 0 ? void 0 : _formData$factory2.id) : null,
              organizationType: formData.organizationType,
              applicationType: formData.applicationType,
              grantAmount: formData === null || formData === void 0 ? void 0 : formData.employeeAccidentInfo.grantAmount,
              employeeDesignationInfo: JSON.stringify(formData.employeeDesignationInfo),
              employeeBankInfo: JSON.stringify(formData.employeeBankInfo),
              employeeDependentInfo: JSON.stringify(formData.dependents).replace(/\\/g, "").replace(/"{/g, "{").replace(/}"/g, "}"),
              employeeAccidentInfo: JSON.stringify(formData === null || formData === void 0 ? void 0 : formData.employeeAccidentInfo),
              status: WORKFORCE_STATUS$1.DRAFT,
              applicationFor: applicationForSelf === "yes" ? "self" : "dependent"
            };
            console.log({
              createApplicationData: createApplicationData
            });
            if (parsedApplicationData) {
              _context.next = 55;
              break;
            }
            _context.next = 38;
            return formatMutation("createWorkforceApplication", formatApplicationeGQL(createApplicationData), "Created application ");
          case 38:
            applicationMutation = _context.sent;
            applicationClientMutationId = applicationMutation.clientMutationId;
            console.log("applicationClientMutationId", applicationClientMutationId);
            _context.next = 43;
            return dispatch(createApplication(applicationMutation, "Created workforce application "));
          case 43:
            _context.next = 45;
            return dispatch(fetchInfoIdByClientMutationId(modulesManager, "workforceApplication", applicationClientMutationId, "WORKFORCE_APPLICATION_BY_CLIENT_MUTATION_ID"));
          case 45:
            fetchRes = _context.sent;
            applicationgetId = getInfoId(fetchRes, "workforceApplication");
            console.log("hello there", applicationgetId);
            if (!applicationgetId && applicationId) {
              applicationgetId = applicationId;
            }
            if (!uploadDependentFile) {
              _context.next = 52;
              break;
            }
            _context.next = 52;
            return dispatch(fetchEmployeeDependent(modulesManager, ["workforceApplication_Id:\"".concat(applicationgetId, "\"")])).then(function (res) {
              var _res$payload;
              var dependentId = res === null || res === void 0 || (_res$payload = res.payload) === null || _res$payload === void 0 || (_res$payload = _res$payload.data) === null || _res$payload === void 0 || (_res$payload = _res$payload.workforceEmployeeDependent) === null || _res$payload === void 0 || (_res$payload = _res$payload.edges[0]) === null || _res$payload === void 0 || (_res$payload = _res$payload.node) === null || _res$payload === void 0 ? void 0 : _res$payload.id;
              uploadDependentFile.map(function (file, index) {
                dispatch(createWorkforceDocument(_objectSpread$Z(_objectSpread$Z({}, file), {}, {
                  workforceApplicationId: applicationgetId,
                  workforceDependentId: safeDecodeId(dependentId)
                }), "Created workforce document "));
              });
            });
          case 52:
            dispatch(updateApplication(createApplicationData, "update workforce application ".concat(formData.firstNameEn)));
            _context.next = 61;
            break;
          case 55:
            updateApplicationData = _objectSpread$Z({
              id: parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.id
            }, createApplicationData);
            console.log("i am from update", updateApplicationData);
            if (!uploadDependentFile) {
              _context.next = 60;
              break;
            }
            _context.next = 60;
            return dispatch(fetchEmployeeDependent(modulesManager, ["workforceApplication_Id:\"".concat(parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.id, "\"")])).then(function (res) {
              var _res$payload2;
              var dependentId = res === null || res === void 0 || (_res$payload2 = res.payload) === null || _res$payload2 === void 0 || (_res$payload2 = _res$payload2.data) === null || _res$payload2 === void 0 || (_res$payload2 = _res$payload2.workforceEmployeeDependent) === null || _res$payload2 === void 0 || (_res$payload2 = _res$payload2.edges[0]) === null || _res$payload2 === void 0 || (_res$payload2 = _res$payload2.node) === null || _res$payload2 === void 0 ? void 0 : _res$payload2.id;
              console.log({
                dependentId: dependentId
              });
              uploadDependentFile.map(function (file, index) {
                dispatch(createWorkforceDocument(_objectSpread$Z(_objectSpread$Z({}, file), {}, {
                  workforceApplicationId: parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.id,
                  workforceDependentId: safeDecodeId(dependentId)
                }), "Created workforce document "));
              });
            });
          case 60:
            dispatch(updateApplication(updateApplicationData, "update workforce application "));
          case 61:
            _context.next = 67;
            break;
          case 63:
            console.log(applicationId);
            _updateApplicationData = {
              id: safeApplicationId(applicationId, parsedApplicationData),
              workforceEmployeeId: (formData === null || formData === void 0 ? void 0 : formData.workforceEmployee.id) || (parsedApplicationData === null || parsedApplicationData === void 0 || (_parsedApplicationDat3 = parsedApplicationData.workforceEmployee) === null || _parsedApplicationDat3 === void 0 ? void 0 : _parsedApplicationDat3.id),
              company: formData === null || formData === void 0 || (_formData$workforceEm31 = formData.workforceEmployee) === null || _formData$workforceEm31 === void 0 || (_formData$workforceEm31 = _formData$workforceEm31.company) === null || _formData$workforceEm31 === void 0 ? void 0 : _formData$workforceEm31.id,
              factory: formData !== null && formData !== void 0 && (_formData$factory3 = formData.factory) !== null && _formData$factory3 !== void 0 && _formData$factory3.id ? safeDecodeId(formData === null || formData === void 0 || (_formData$factory4 = formData.factory) === null || _formData$factory4 === void 0 ? void 0 : _formData$factory4.id) : null,
              organizationType: organizationType || (parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.organizationType),
              applicationType: selectedApplicationType || (parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.applicationType),
              grantAmount: formData === null || formData === void 0 ? void 0 : formData.employeeAccidentInfo.grantAmount,
              employeeBankInfo: JSON.stringify(formData.employeeBankInfo) || JSON.stringify(parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.employeeBankInfo),
              employeeDependentInfo: JSON.stringify(formData.dependents).replace(/\\/g, "").replace(/"{/g, "{").replace(/}"/g, "}") || JSON.stringify(parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.employeeDependentInfo).replace(/\\/g, "").replace(/"{/g, "{").replace(/}"/g, "}"),
              employeeAccidentInfo: JSON.stringify(formData === null || formData === void 0 ? void 0 : formData.employeeAccidentInfo) || JSON.stringify(parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.employeeAccidentInfo),
              status: WORKFORCE_STATUS$1.DRAFT,
              applicationFor: applicationForSelf === "yes" ? "self" : "dependent"
            };
            console.log("i am from accident info", _updateApplicationData);
            dispatch(updateApplication(_updateApplicationData, "update workforce application ".concat(formData.firstNameEn)));
          case 67:
            if (!shouldBlockNavigation) {
              _context.next = 79;
              break;
            }
            _context.prev = 68;
            if (!(parsedApplicationData !== null && parsedApplicationData !== void 0 && parsedApplicationData.id)) {
              _context.next = 74;
              break;
            }
            _context.next = 72;
            return dispatch(fetchEmployeeDependent(modulesManager, ["workforceApplication_Id:\"".concat(parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.id, "\"")]));
          case 72:
            _context.next = 76;
            break;
          case 74:
            _context.next = 76;
            return dispatch(fetchEmployeeDependent(modulesManager, ["workforceApplication_Id:\"".concat(safeApplicationId(applicationId), "\"")]));
          case 76:
            _context.prev = 76;
            setIsNavigationBlocked(false);
            return _context.finish(76);
          case 79:
            if (nextStep < steps.length) {
              setActiveStep(nextStep);
            }
            return _context.abrupt("return", true);
          case 81:
            return _context.abrupt("return", false);
          case 82:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[68,, 76, 79]]);
    }));
    return function handleNext() {
      return _ref2.apply(this, arguments);
    };
  }();
  var handleBack = function handleBack() {
    return setActiveStep(function (prevStep) {
      return prevStep - 1;
    });
  };
  var handleArrayFieldChange = function handleArrayFieldChange(fieldKey, index, key, value) {
    setFormData(function (prev) {
      var items = Array.isArray(prev[fieldKey]) ? _toConsumableArray(prev[fieldKey]) : [];
      var currentItem = items[index] || {};
      var nextValue = typeof value === "function" ? value(currentItem[key]) : value;
      items[index] = _objectSpread$Z(_objectSpread$Z({}, currentItem), {}, _defineProperty({}, key, nextValue));
      return _objectSpread$Z(_objectSpread$Z({}, prev), {}, _defineProperty({}, fieldKey, items));
    });
  };
  var addArrayFieldItem = function addArrayFieldItem(fieldKey) {
    var defaultItem = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    setFormData(function (prev) {
      var items = Array.isArray(prev[fieldKey]) ? _toConsumableArray(prev[fieldKey]) : [{}];
      var updated = [].concat(_toConsumableArray(items), [defaultItem]);
      setExpanded === null || setExpanded === void 0 || setExpanded(updated.length - 1); // optional chaining
      return _objectSpread$Z(_objectSpread$Z({}, prev), {}, _defineProperty({}, fieldKey, updated));
    });
  };
  var removeArrayFieldItem = function removeArrayFieldItem(fieldKey, index) {
    setFormData(function (prev) {
      var items = Array.isArray(prev[fieldKey]) ? _toConsumableArray(prev[fieldKey]) : [];
      var updated = items.filter(function (_, i) {
        return i !== index;
      });
      return _objectSpread$Z(_objectSpread$Z({}, prev), {}, _defineProperty({}, fieldKey, updated));
    });
  };
  var handleSubmit = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var submittedBy, _parsedApplicationDat4, _formData$workforceEm32, _formData$factory5, _formData$factory6, updateApplicationData;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            console.log({
              tazwer: formData
            });
            if (!uploadBankFile) {
              _context2.next = 4;
              break;
            }
            _context2.next = 4;
            return Promise.all(uploadBankFile.map(function (file) {
              return dispatch(createWorkforceDocument(_objectSpread$Z(_objectSpread$Z({}, file), {}, {
                workforceApplicationId: safeApplicationId(applicationId, parsedApplicationData)
              }), "Created workforce document"));
            }));
          case 4:
            _context2.next = 6;
            return Promise.all(uploadFile.map(function (file, index) {
              dispatch(createWorkforceDocument(_objectSpread$Z(_objectSpread$Z({}, file), {}, {
                workforceApplicationId: safeApplicationId(applicationId)
              }), "Created workforce document "));
            }));
          case 6:
            submittedBy = user_type === WORKFORCE_USER_TYPE.APPLICANT ? "applicant" : user_type === WORKFORCE_USER_TYPE.FACTORY_ADMIN ? "factory_admin" : "UNKNOWN";
            try {
              updateApplicationData = {
                id: safeApplicationId(applicationId, parsedApplicationData),
                workforceEmployeeId: (formData === null || formData === void 0 ? void 0 : formData.workforceEmployee.id) || (parsedApplicationData === null || parsedApplicationData === void 0 || (_parsedApplicationDat4 = parsedApplicationData.workforceEmployee) === null || _parsedApplicationDat4 === void 0 ? void 0 : _parsedApplicationDat4.id),
                company: formData === null || formData === void 0 || (_formData$workforceEm32 = formData.workforceEmployee) === null || _formData$workforceEm32 === void 0 || (_formData$workforceEm32 = _formData$workforceEm32.company) === null || _formData$workforceEm32 === void 0 ? void 0 : _formData$workforceEm32.id,
                factory: formData !== null && formData !== void 0 && (_formData$factory5 = formData.factory) !== null && _formData$factory5 !== void 0 && _formData$factory5.id ? safeDecodeId(formData === null || formData === void 0 || (_formData$factory6 = formData.factory) === null || _formData$factory6 === void 0 ? void 0 : _formData$factory6.id) : null,
                organizationType: organizationType || (parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.organizationType),
                applicationType: selectedApplicationType || (parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.applicationType),
                grantAmount: formData === null || formData === void 0 ? void 0 : formData.employeeAccidentInfo.grantAmount,
                employeeBankInfo: JSON.stringify(formData.employeeBankInfo) || JSON.stringify(parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.employeeBankInfo),
                employeeDependentInfo: JSON.stringify(formData.dependents).replace(/\\/g, "").replace(/"{/g, "{").replace(/}"/g, "}") || JSON.stringify(parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.employeeDependentInfo).replace(/\\/g, "").replace(/"{/g, "{").replace(/}"/g, "}"),
                employeeAccidentInfo: JSON.stringify(formData === null || formData === void 0 ? void 0 : formData.employeeAccidentInfo) || JSON.stringify(parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.employeeAccidentInfo),
                status: WORKFORCE_STATUS$1.NEW,
                applicationFor: applicationForSelf === "yes" ? "self" : "dependent",
                submittedBy: submittedBy
              }; // const createApplicationMovementData = {
              //   applicationId: safeApplicationId(applicationId, parsedApplicationData),
              //   status: WORKFORCE_STATUS.NEW,
              //   note: "একটি নতুন আবেদন করা হয়েছে",
              //   applicationFromId: reduxState.core?.user?.i_user?.id,
              //   applicationToId: 165,
              //   toRoleId: 25,
              // };
              console.log("hello i am from submit", updateApplicationData);
              dispatch(updateApplication(updateApplicationData, "update workforce application "));
              // dispatch(createApplicationMovement(createApplicationMovementData, `create workforce movement`));
            } catch (err) {
              console.error("Submit failed:", err);
            }
          case 8:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function handleSubmit() {
      return _ref3.apply(this, arguments);
    };
  }();
  console.log({
    murad: uploadFile
  });
  console.log({
    uploadDependentFile: uploadDependentFile
  });
  var steps = [{
    label: "workforce.application.steps.employeeDetails",
    content: /*#__PURE__*/React.createElement(EmployeeDetailsForm, {
      handleChange: function handleChange(key, value) {
        return _handleChange(key, value, "workforceEmployee");
      },
      setNidOrBcn: setNidOrBcn,
      nidOrBcn: nidOrBcn,
      formData: formData,
      errors: errors
    })
  }, {
    label: "workforce.application.steps.location",
    content: /*#__PURE__*/React.createElement(EmployeeLocationForm, {
      errors: errors,
      handleChange: function handleChange(key, value) {
        return _handleChange(key, value, "workforceEmployee");
      },
      formData: formData
    })
  }].concat(_toConsumableArray(applicationForSelf === "no" ? [{
    label: "workforce.application.steps.dependent",
    content: /*#__PURE__*/React.createElement(EmployeeDependentForm, {
      applicationType: formData.applicationType,
      dependents: formData.dependents,
      handleChange: function handleChange(index, key, value) {
        return handleArrayFieldChange("dependents", index, key, value);
      },
      addItem: function addItem() {
        return addArrayFieldItem("dependents", {
          fullName: "",
          relationship: ""
        });
      },
      removeItem: function removeItem(index) {
        return removeArrayFieldItem("dependents", index);
      },
      expanded: expanded,
      formdata: formData,
      setExpanded: setExpanded,
      errors: errors
    })
  }] : []), [{
    label: "workforce.application.steps.treatment.info",
    content: /*#__PURE__*/React.createElement(EmployeeAccidentInfoForm, {
      handleChange: function handleChange(key, value) {
        return _handleChange(key, value, "employeeAccidentInfo");
      },
      formData: formData,
      setFormData: setFormData,
      errors: errors
    })
  }, {
    label: "workforce.application.steps.account.info",
    content: /*#__PURE__*/React.createElement(EmployeeAccountInfoForm, {
      accounts: formData.employeeBankInfo,
      formdata: formData,
      handleChange: function handleChange(index, key, value) {
        return handleArrayFieldChange("employeeBankInfo", index, key, value);
      },
      addItem: function addItem() {
        return addArrayFieldItem("employeeBankInfo", {
          accountHolderName: "",
          bankName: "",
          accountNumber: "",
          branchName: ""
        });
      },
      removeItem: function removeItem(index) {
        return removeArrayFieldItem("employeeBankInfo", index);
      },
      expanded: expanded,
      setExpanded: setExpanded,
      errors: errors
    })
  }
  // {
  //   label: "workforce.application.steps.upload.documents",
  //   content: (
  //     <EmployeeDetailsForm2
  //       handleChange={handleChange}
  //       formData={formData}
  //       selectedApplicationType={selectedApplicationType}
  //       formStepNo={"workforceDocument"}
  //     />
  //   ),
  // },
  ]);
  console.log({
    tazwer: reduxState.core.user.id
  });
  console.log({
    fahimTazwer: formData
  });
  if (showPreview) {
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ApplicationViewPage, {
      application: formData,
      language: "fr"
    }), /*#__PURE__*/React.createElement("div", {
      className: classes.buttonContainer
    }, /*#__PURE__*/React.createElement(Button, {
      variant: "outlined",
      color: "error",
      onClick: function onClick() {
        setShowPreview(false);
      }
    }, /*#__PURE__*/React.createElement(FormattedMessage, {
      module: "workforce",
      id: "workforce.back"
    })), /*#__PURE__*/React.createElement(Button, {
      variant: "contained",
      color: "primary",
      onClick: function onClick() {
        setShowPreview(false);
        setShowVerifyNid(true);
      }
    }, /*#__PURE__*/React.createElement(FormattedMessage, {
      module: "workforce",
      id: "workforce.submit"
    }))));
  }
  if (showVerifyNid) {
    return /*#__PURE__*/React.createElement("div", {
      className: classes.container
    }, /*#__PURE__*/React.createElement(Paper, {
      className: classes.paper,
      elevation: 0
    }, /*#__PURE__*/React.createElement(NidVerification, {
      formData: formData,
      nidOrBcn: nidOrBcn,
      setDisableConfirmSubmit: setDisableConfirmSubmit
    }), /*#__PURE__*/React.createElement("div", {
      className: classes.buttonContainer
    }, /*#__PURE__*/React.createElement(Button, {
      variant: "contained",
      color: "primary"
      // disabled={disableConfirmSubmit}
      ,
      onClick: /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return handleSubmit();
            case 2:
              setShowVerifyNid(false);
              setIsSubmitted(true);
            case 4:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))
    }, /*#__PURE__*/React.createElement(FormattedMessage, {
      module: "workforce",
      id: "workforce.confirm.submit"
    })))));
  }
  if (isSubmitted) {
    return /*#__PURE__*/React.createElement(ApplicationFormSubmitted, null);
  }
  return /*#__PURE__*/React.createElement("div", {
    className: classes.container
  }, /*#__PURE__*/React.createElement(Paper, {
    className: classes.paper,
    elevation: 0
  }, /*#__PURE__*/React.createElement(Stepper, {
    activeStep: activeStep,
    alternativeLabel: true,
    style: {
      padding: "0px"
    }
  }, steps.map(function (step, index) {
    return /*#__PURE__*/React.createElement(Step, {
      key: index
    }, /*#__PURE__*/React.createElement(StepLabel, null, /*#__PURE__*/React.createElement(FormattedMessage, {
      module: "workforce",
      id: step.label
    })));
  })), /*#__PURE__*/React.createElement(Box$1, {
    mt: 0,
    ref: stepRef
  }, steps[activeStep].content), activeStep === steps.length - 1 && /*#__PURE__*/React.createElement(Box$1, null, /*#__PURE__*/React.createElement(FormControlLabel, {
    control: /*#__PURE__*/React.createElement(Checkbox, {
      checked: acknowledged,
      onChange: function onChange(e) {
        return setAcknowledged(e.target.checked);
      },
      style: {
        color: "blue"
      }
    }),
    label: /*#__PURE__*/React.createElement(Typography, {
      variant: "body2"
    }, /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.application.acknowledgement.text",
      module: "workforce"
    }))
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.buttonContainer
  }, activeStep > 0 && /*#__PURE__*/React.createElement(Button, {
    onClick: handleBack,
    variant: "outlined"
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.back"
  })), activeStep < steps.length - 1 ? /*#__PURE__*/React.createElement(Button, {
    variant: "contained",
    color: "primary",
    onClick: handleNext
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.save.next"
  })) : /*#__PURE__*/React.createElement(Button, {
    variant: "contained",
    color: "primary",
    disabled: !acknowledged,
    onClick: /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
      var isSuccess;
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return handleNext();
          case 2:
            isSuccess = _context4.sent;
            if (isSuccess) setShowPreview(true);
          case 4:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }))
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.submit"
  })))), /*#__PURE__*/React.createElement(Dialog$1, {
    open: isNavigationBlocked,
    onClose: function onClose() {},
    disableBackdropClick: true,
    disableEscapeKeyDown: true,
    maxWidth: "sm",
    fullWidth: true
  }, /*#__PURE__*/React.createElement(Box$1, {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: 4,
    gap: 2
  }, /*#__PURE__*/React.createElement(CircularProgress$1, {
    size: 60,
    thickness: 4
  }), /*#__PURE__*/React.createElement(Typography, {
    variant: "h6",
    align: "center"
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "workforce.processing.data",
    module: "workforce"
  })), /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    align: "center",
    color: "textSecondary"
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "workforce.please.wait",
    module: "workforce"
  })))), /*#__PURE__*/React.createElement(CustomSnackbar, {
    open: showErrorSnackbar // Use the new state
    ,
    onClose: function onClose() {
      return setShowErrorSnackbar(false);
    } // Allow it to close
    ,
    type: "error",
    message: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "core.error.generel",
      module: "workforce"
    }),
    duration: 4000
  }));
};

var useStyles$1g = makeStyles(function (theme) {
  return {
    paper: {
      padding: theme.spacing(2)
    },
    item: {
      marginBottom: theme.spacing(2)
    },
    title: {
      fontWeight: 800
    }
  };
});
var EmployeeMaternalInfoForm = function EmployeeMaternalInfoForm(_ref) {
  var _formData$employeeAcc, _formData$employeeAcc2, _formData$employeeAcc3, _formData$employeeAcc4, _formData$employeeAcc5, _formData$employeeAcc6, _formData$employeeAcc7, _formData$employeeAcc8;
  var handleChange = _ref.handleChange,
    formData = _ref.formData;
    _ref.setFormData;
    _ref.applicationType;
    _ref.required;
    var errors = _ref.errors;
  var classes = useStyles$1g();
  var modulesManager = useModulesManager();
  var _useTranslations = useTranslations("core.RegistrationPage", modulesManager);
    _useTranslations.formatMessage;
  var _useState = useState((formData === null || formData === void 0 || (_formData$employeeAcc = formData.employeeAccidentInfo) === null || _formData$employeeAcc === void 0 ? void 0 : _formData$employeeAcc.accidentType) || "disease"),
    _useState2 = _slicedToArray(_useState, 2);
    _useState2[0];
    _useState2[1];
  var _useState3 = useState((formData === null || formData === void 0 || (_formData$employeeAcc2 = formData.employeeAccidentInfo) === null || _formData$employeeAcc2 === void 0 ? void 0 : _formData$employeeAcc2.cronicDiseaseType) || []),
    _useState4 = _slicedToArray(_useState3, 2);
    _useState4[0];
    _useState4[1];
  var _useState5 = useState((formData === null || formData === void 0 || (_formData$employeeAcc3 = formData.employeeAccidentInfo) === null || _formData$employeeAcc3 === void 0 ? void 0 : _formData$employeeAcc3.admitted) || "no"),
    _useState6 = _slicedToArray(_useState5, 2);
    _useState6[0];
    _useState6[1];
  return /*#__PURE__*/React.createElement(Box$1, {
    mt: 2
  }, /*#__PURE__*/React.createElement(Paper, {
    className: classes.paper,
    elevation: 0
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle1",
    style: {
      fontWeight: "bold",
      textAlign: "center",
      width: "100%"
    },
    gutterBottom: true
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "workforce.application.disease.maternalHeading"
  })), /*#__PURE__*/React.createElement(Divider, {
    style: {
      margin: "16px 0"
    }
  }), /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 1
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6,
    className: classes.item
  }, /*#__PURE__*/React.createElement(PublishedComponent, {
    pubRef: "workforce.DatePicker",
    label: "workforce.application.disease.maternal.delivaryDate",
    value: (formData === null || formData === void 0 || (_formData$employeeAcc4 = formData.employeeAccidentInfo) === null || _formData$employeeAcc4 === void 0 ? void 0 : _formData$employeeAcc4.diagnosisDate) || "",
    onChange: function onChange(v) {
      return handleChange("diagnosisDate", v);
    },
    readOnly: false,
    required: (formData === null || formData === void 0 ? void 0 : formData.applicationForSelf) === "yes" ? true : false
  }), errors.rdmp && /*#__PURE__*/React.createElement(FormHelperText, {
    error: true
  }, errors.rdmp)), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6,
    className: classes.item
  }, /*#__PURE__*/React.createElement(TextInput, {
    label: "workforce.employee.accident.info.hospitalName",
    value: (formData === null || formData === void 0 || (_formData$employeeAcc5 = formData.employeeAccidentInfo) === null || _formData$employeeAcc5 === void 0 ? void 0 : _formData$employeeAcc5.hospitalName) || "",
    onChange: function onChange(v) {
      return handleChange("hospitalName", v);
    },
    required: (formData === null || formData === void 0 ? void 0 : formData.applicationForSelf) === "yes" ? false : true
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6,
    className: classes.item
  }, /*#__PURE__*/React.createElement(PublishedComponent, {
    pubRef: "workforce.DatePicker",
    label: "workforce.employee.accident.info.admitDate",
    value: (formData === null || formData === void 0 || (_formData$employeeAcc6 = formData.employeeAccidentInfo) === null || _formData$employeeAcc6 === void 0 ? void 0 : _formData$employeeAcc6.admitDate) || "",
    onChange: function onChange(v) {
      return handleChange("admitDate", v);
    },
    readOnly: false,
    required: (formData === null || formData === void 0 ? void 0 : formData.applicationForSelf) === "yes" ? false : true
  }), errors.rdmp && /*#__PURE__*/React.createElement(FormHelperText, {
    error: true
  }, errors.rdmp)), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6,
    className: classes.item
  }, /*#__PURE__*/React.createElement(PublishedComponent, {
    pubRef: "workforce.DatePicker",
    label: "workforce.employee.accident.info.releaseDate",
    value: (formData === null || formData === void 0 || (_formData$employeeAcc7 = formData.employeeAccidentInfo) === null || _formData$employeeAcc7 === void 0 ? void 0 : _formData$employeeAcc7.releaseDate) || "",
    onChange: function onChange(v) {
      return handleChange("releaseDate", v);
    },
    readOnly: false,
    required: (formData === null || formData === void 0 ? void 0 : formData.applicationForSelf) === "yes" ? false : true
  }), errors.rdmp && /*#__PURE__*/React.createElement(FormHelperText, {
    error: true
  }, errors.rdmp)), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6,
    className: classes.item
  }, /*#__PURE__*/React.createElement(TextInput, {
    label: "workforce.employee.accident.info.doctorName",
    value: (formData === null || formData === void 0 || (_formData$employeeAcc8 = formData.employeeAccidentInfo) === null || _formData$employeeAcc8 === void 0 ? void 0 : _formData$employeeAcc8.hospitalDoctorName) || "",
    onChange: function onChange(v) {
      return handleChange("hospitalDoctorName", v);
    }
  })))), /*#__PURE__*/React.createElement(EmployeeDetailsForm2, {
    errors: errors,
    handleChange: function handleChange() {},
    formData: formData,
    selectedApplicationType: formData.applicationType,
    formStepNo: "employeeAccidentInfo"
  }));
};

var styles$l = function styles(theme) {
  return {
    paper: {
      padding: theme.spacing(0),
      width: "100%"
    },
    container: {
      display: "flex",
      justifyContent: "center",
      alignItems: "flex-start",
      width: "100%"
    },
    cardGridItem: {
      display: "flex",
      flexDirection: "column"
    },
    card: {
      flex: 1,
      display: "flex",
      flexDirection: "column"
    }
  };
};
var banglaLabels = {
  // same as your original banglaLabels object...
  nameEn: "নাম (ইংরেজি)",
  nameBn: "নাম (বাংলা)",
  fatherNameEn: "পিতার নাম (ইংরেজি)",
  fatherNameBn: "পিতার নাম (বাংলা)",
  motherNameEn: "মাতার নাম (ইংরেজি)",
  motherNameBn: "মাতার নাম (বাংলা)",
  spouseNameEn: "স্বামীর / স্ত্রীর নাম (ইংরেজি)",
  spouseNameBn: "স্বামী/স্ত্রীর নাম (বাংলা)",
  citizenship: "নাগরিকত্ব",
  nid: "এনআইডি",
  birthCertificate: "জন্ম সনদ",
  birthCertificateNo: "জন্ম সনদ নম্বর",
  birthDate: "জন্ম তারিখ",
  insuranceNumber: "ইনসুরেন্স নম্বর",
  gender: "লিঙ্গ",
  maritalStatus: "বৈবাহিক অবস্থা",
  phoneNumber: "ফোন নম্বর",
  email: "ইমেইল",
  lifeStatus: "জীবিত অবস্থা",
  deathDate: "মৃত্যুর তারিখ",
  monthlyEarning: "মাসিক আয়",
  presentAddress: "বর্তমান ঠিকানা",
  permanentAddress: "স্থায়ী ঠিকানা",
  presentLocation: "বর্তমান এলাকা",
  permanentLocation: "স্থায়ী এলাকা",
  accountNumber: "অ্যাকাউন্ট নম্বর",
  accountHolderName: "হোল্ডারের নাম",
  routingNumber: "রাউটিং নম্বর",
  branch: "শাখা",
  cronicDiseaseType: "জটিল রোগের ধরন",
  grantAmount: "অনুদানের পরিমাণ",
  diagnosisDate: "রোগ নির্ণয়ের তারিখ",
  doctorName: "ডাক্তারের নাম",
  admitted: "হাসপাতালে ভর্তি",
  hospitalName: "হাসপাতালের নাম",
  admitDate: "ভর্তির তারিখ",
  releaseDate: "ছাড়পত্রের তারিখ",
  hospitalDoctorName: "হাসপাতালের ডাক্তার",
  accidentType: "দুর্ঘটনার ধরণ",
  accidentPlace: "দুর্ঘটনার স্থান",
  accidentDate: "দুর্ঘটনার তারিখ",
  accidentTime: "দুর্ঘটনার সময়",
  inOutsideFactory: "কারখানার ভিতরে/বাইরে",
  reJoiningDate: "পুনঃযোগদানের তারিখ",
  educationInstituteName: "শিক্ষা প্রতিষ্ঠানের নাম",
  studyingClass: "অধ্যয়নরত শ্রেণী",
  educationLevel: "শিক্ষার স্তর",
  childNameEn: "শিশুর নাম (ইংরেজি)",
  childNameBn: "শিশুর নাম (বাংলা)",
  childBirthDate: "জন্ম তারিখ",
  childBirthCertificateNo: "জন্ম সনদ নম্বর",
  childNidNo: "এনআইডি নম্বর",
  institution: "শিক্ষা প্রতিষ্ঠান",
  studyClass: "শ্রেণি",
  educationBoard: "বোর্ড",
  passingYear: "পাসিং বছর",
  rollNumber: "রোল নম্বর",
  registrationNumber: "রেজিস্ট্রেশন নম্বর",
  result: "ফলাফল",
  otherInfo: "অন্যান্য তথ্য",
  dateofReceipt: "গ্রহণের তারিখ",
  reasonforReceipt: "গ্রহণের কারণ",
  disabilityType: "প্রতিবন্ধিতার ধরণ",
  deathType: "মৃত্যুর ধরণ",
  scholarshipFor: "স্কলারশিপের উদ্দেশ্য",
  employeeDependentInfo: "নির্ভরশীল সদস্যদের তথ্য",
  employeeWarishInfo: "ওয়ারিশদের তথ্য",
  employeeBankInfo: "শ্রমিকের ব্যাংক তথ্য",
  applicant_type: "আবেদনকারীর ধরণ",
  bankCode: "ব্যাংক কোড",
  bank: "ব্যাংক",
  educations: "শিক্ষাগত তথ্য",
  spouseBn: "স্বামী/স্ত্রীর নাম (বাংলা)",
  spouseEn: "স্বামী/স্ত্রীর নাম (ইংরেজি)",
  spouseFatherNameEn: "স্বামী/স্ত্রীর পিতার নাম (ইংরেজি)",
  spouseFatherNameBn: "স্বামী/স্ত্রীর পিতার নাম (বাংলা)",
  spouseBirthDate: "স্বামী/স্ত্রীর জন্ম তারিখ",
  spouseNid: "স্বামী/স্ত্রীর এনআইডি",
  applicantInfo: "আবেদনকারীর তথ্য",
  relationWithApplicant: "আবেদনকারীর সাথে সম্পর্ক"
};
var PreviewDetails = function PreviewDetails(_ref) {
  var _ref$formData = _ref.formData,
    formData = _ref$formData === void 0 ? {} : _ref$formData,
    classes = _ref.classes,
    _ref$language = _ref.language,
    language = _ref$language === void 0 ? "en" : _ref$language;
  var formatKey = function formatKey(key) {
    var cleanKey = key.split(".").pop();
    if (["fr", "bangla", "bd"].includes(language) && banglaLabels[cleanKey]) {
      return banglaLabels[cleanKey];
    }
    return cleanKey.replace(/_/g, " ").replace(/([A-Z])/g, " $1").replace(/^./, function (str) {
      return str.toUpperCase();
    });
  };
  var parseIfJson = function parseIfJson(val) {
    if (typeof val === "string") {
      try {
        var parsed = JSON.parse(val);
        if (_typeof(parsed) === "object") return parsed;
      } catch (_unused) {}
    }
    return val;
  };
  var renderValue = function renderValue(value) {
    if (Array.isArray(value)) {
      return value.length === 0 ? "N/A" : value.map(function (item, idx) {
        return /*#__PURE__*/React.createElement(Box$1, {
          key: idx,
          mb: 0
        }, _typeof(item) === "object" ? renderNestedObject(item) : item);
      });
    } else if (typeof value === "string" && value.trim().startsWith("{")) {
      var parsed = parseIfJson(value);
      return _typeof(parsed) === "object" ? renderNestedObject(parsed) : parsed;
    } else if (_typeof(value) === "object" && value !== null) {
      if ("code" in value && "name" in value) {
        return "".concat(value.name, " (").concat(value.code, ")");
      }
      return renderNestedObject(value);
    } else {
      return value !== null && value !== void 0 ? value : "N/A";
    }
  };
  var renderNestedObject = function renderNestedObject(obj) {
    if (!obj || _typeof(obj) !== "object") return null;
    return /*#__PURE__*/React.createElement(Box$1, {
      pl: 1
    }, Object.entries(obj).filter(function (_ref2) {
      var _ref3 = _slicedToArray(_ref2, 1),
        k = _ref3[0];
      return !["id", "parent", "cronicDiseaseType"].includes(k);
    }).map(function (_ref4, i) {
      var _ref5 = _slicedToArray(_ref4, 2),
        k = _ref5[0],
        v = _ref5[1];
      return /*#__PURE__*/React.createElement(Typography, {
        variant: "body2",
        key: i
      }, /*#__PURE__*/React.createElement("b", null, formatKey(k), ":"), " ", renderValue(v));
    }));
  };
  var renderSection = function renderSection(title, data) {
    if (!data || _typeof(data) !== "object") return null;
    var filteredEntries = Object.entries(data).filter(function (_ref6) {
      var _ref7 = _slicedToArray(_ref6, 1),
        k = _ref7[0];
      return !["id", "uuid", "parent", "workforceEmployer", "cronicDiseaseType"].includes(k);
    });
    if (filteredEntries.length === 0) return null;
    return /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 6,
      className: classes.cardGridItem,
      key: title
    }, /*#__PURE__*/React.createElement(Card, {
      className: classes.card
    }, /*#__PURE__*/React.createElement(CardContent, null, /*#__PURE__*/React.createElement(Typography, {
      variant: "h6",
      gutterBottom: true
    }, /*#__PURE__*/React.createElement(FormattedMessage, {
      module: "workforce",
      id: title,
      defaultMessage: formatKey(title)
    })), /*#__PURE__*/React.createElement(Divider, {
      style: {
        marginBottom: "10px"
      }
    }), /*#__PURE__*/React.createElement(Grid, {
      container: true,
      spacing: 2
    }, filteredEntries.map(function (_ref8, idx) {
      var _ref9 = _slicedToArray(_ref8, 2),
        key = _ref9[0],
        value = _ref9[1];
      return /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12,
        sm: 6,
        key: idx
      }, /*#__PURE__*/React.createElement(Typography, {
        variant: "body2"
      }, /*#__PURE__*/React.createElement("b", null, formatKey(key), ":"), " ", renderValue(value)));
    })))));
  };
  var renderArraySection = function renderArraySection(title, arrayData) {
    if (!Array.isArray(arrayData) || arrayData.length === 0) return null;
    var nonEmptyItems = arrayData.filter(function (item) {
      return item && _typeof(item) === "object" && Object.keys(item).length > 0;
    });
    if (nonEmptyItems.length === 0) return null;
    return /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 6,
      className: classes.cardGridItem,
      key: title
    }, /*#__PURE__*/React.createElement(Card, {
      className: classes.card
    }, /*#__PURE__*/React.createElement(CardContent, null, /*#__PURE__*/React.createElement(Typography, {
      variant: "h6",
      gutterBottom: true
    }, formatKey(title)), /*#__PURE__*/React.createElement(Divider, {
      style: {
        marginBottom: "10px"
      }
    }), nonEmptyItems.map(function (item, index) {
      return /*#__PURE__*/React.createElement(Box$1, {
        key: index,
        mb: 1,
        pl: 1
      }, /*#__PURE__*/React.createElement(Typography, {
        variant: "subtitle2"
      }, formatKey(title), " #", index + 1), renderNestedObject(item));
    }))));
  };
  var isFileUploadField = function isFileUploadField(value) {
    return Array.isArray(value) && value.length > 0 && value.every(function (item) {
      return _typeof(item) === "object" && item !== null && ("path" in item || "relativePath" in item);
    });
  };
  var renderWorkforceEmployeeSections = function renderWorkforceEmployeeSections(employeeData) {
    if (!employeeData || _typeof(employeeData) !== "object") return null;
    var personalFields = ["nameEn", "nameBn", "fatherNameEn", "fatherNameBn", "motherNameEn", "motherNameBn", "spouseName", "spouseNameEn", "spouseNameBn", "citizenship", "nid", "birthCertificate", "birthCertificateNo", "birthDate", "insuranceNumber", "gender", "maritalStatus", "lifeStatus", "deathDate", "monthlyEarning"];
    var contactFields = ["email", "phoneNumber", "presentAddress", "permanentAddress", "presentLocation", "permanentLocation"];
    var statusFields = [];
    var accidentFields = ["diagnosisDate", "hospitalName", "admitDate", "releaseDate", "hospitalDoctorName"];
    var pickFields = function pickFields(fields) {
      return fields.reduce(function (acc, field) {
        if (employeeData[field] !== undefined) acc[field] = employeeData[field];
        return acc;
      }, {});
    };
    var personalInfo = pickFields(personalFields);
    var contactInfo = pickFields(contactFields);
    var statusInfo = pickFields(statusFields);
    var accidentInfo = pickFields(accidentFields);
    var childrenInfo = formData === null || formData === void 0 ? void 0 : formData.employeeChildrenInfo;
    return /*#__PURE__*/React.createElement(React.Fragment, null, renderSection("workforce.previewDetails.personalInfo", personalInfo), renderSection("workforce.previewDetails.statusInfo", statusInfo), renderSection("workforce.previewDetails.accidentInfo", accidentInfo), renderSection("workforce.previewDetails.contactInfo", contactInfo), childrenInfo && Object.keys(childrenInfo).length > 0 && renderSection("workforce.previewDetails.employeeChildrenInfo", childrenInfo));
  };
  var renderDependentsSection = function renderDependentsSection(dependents) {
    if (!Array.isArray(dependents) || dependents.length === 0) return null;
    var filteredItems = dependents.filter(function (dep) {
      return dep && _typeof(dep) === "object";
    });
    return /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 6,
      className: classes.cardGridItem,
      key: "employeeDependentInfo"
    }, /*#__PURE__*/React.createElement(Card, {
      className: classes.card
    }, /*#__PURE__*/React.createElement(CardContent, null, /*#__PURE__*/React.createElement(Typography, {
      variant: "h6",
      gutterBottom: true
    }, isCfPath() || isBlwfPath() ? /*#__PURE__*/React.createElement(FormattedMessage, {
      module: "workforce",
      id: "workforce.previewDetails.employeeWarishInfo",
      defaultMessage: formatKey("employeeWarishInfo")
    }) : /*#__PURE__*/React.createElement(FormattedMessage, {
      module: "workforce",
      id: "workforce.previewDetails.employeeDependentInfo",
      defaultMessage: formatKey("employeeDependentInfo")
    })), /*#__PURE__*/React.createElement(Divider, {
      style: {
        marginBottom: "10px"
      }
    }), filteredItems.map(function (dep, index) {
      return /*#__PURE__*/React.createElement(Box$1, {
        key: index,
        mb: 2,
        pl: 1
      }, /*#__PURE__*/React.createElement(Typography, {
        variant: "body2",
        gutterBottom: true,
        style: {
          textAlign: "center",
          fontWeight: "bold"
        }
      }, /*#__PURE__*/React.createElement(FormattedMessage, {
        module: "workforce",
        id: "workforce.previewDetails.dependent",
        defaultMessage: "Dependent #".concat(index + 1)
      })), /*#__PURE__*/React.createElement(Grid, {
        container: true,
        spacing: 2
      }, Object.entries(dep).map(function (_ref10, idx) {
        var _ref11 = _slicedToArray(_ref10, 2),
          key = _ref11[0],
          value = _ref11[1];
        return /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 12,
          sm: 6,
          key: idx
        }, /*#__PURE__*/React.createElement(Typography, {
          variant: "body2"
        }, /*#__PURE__*/React.createElement("b", null, formatKey(key), ":"), " ", renderValue(value)));
      })));
    }))));
  };
  var renderOthersInfoSection = function renderOthersInfoSection() {
    var primitiveFields = Object.entries(formData).filter(function (_ref12) {
      var _ref13 = _slicedToArray(_ref12, 2),
        key = _ref13[0],
        value = _ref13[1];
      return _typeof(value) !== "object" && !["id", "uuid", "parent", "applicationType", "organizationType", "applicationForSelf", "workforceEmployee", "workforceApplicant", "applicantInfo"].includes(key);
    }).reduce(function (acc, _ref14) {
      var _ref15 = _slicedToArray(_ref14, 2),
        key = _ref15[0],
        value = _ref15[1];
      acc[key] = value;
      return acc;
    }, {});
    return renderSection("workforce.previewDetails.othersInfo", primitiveFields);
  };
  var renderDynamicSections = function renderDynamicSections() {
    return Object.entries(formData).map(function (_ref16) {
      var _ref17 = _slicedToArray(_ref16, 2),
        key = _ref17[0],
        value = _ref17[1];
      if (!value || ["id", "uuid", "parent", "applicationType", "organizationType", "applicationForSelf", "applicantInfo"].includes(key)) return null;
      if (_typeof(value) === "object" && value !== null && !Array.isArray(value) && !isFileUploadField(value)) {
        // Render nested object section (like dependents, bankInfo, etc.)
        if (key === "workforceEmployee" || key === "workforceApplicant") {
          return renderWorkforceEmployeeSections(value);
        }
        if (key === "applicantInfo") {
          var parsedApplicant = parseIfJson(value);
          if (_typeof(parsedApplicant) === "object" && parsedApplicant !== null) {
            return renderSection("workforce.previewDetails.applicantInfo", parsedApplicant);
          }
        }
        if (key === "employeeDependentInfo" || key === "dependents") {
          return renderDependentsSection(value);
        }
        if (Array.isArray(value) && value.length > 0 && _typeof(value[0]) === "object") {
          return renderArraySection(key, value);
        }
        if (_typeof(value) === "object" && value !== null) {
          return renderSection("workforce.previewDetails.".concat(key), value);
        }
      }
      return null;
    });
  };
  return /*#__PURE__*/React.createElement("div", {
    className: classes === null || classes === void 0 ? void 0 : classes.container
  }, /*#__PURE__*/React.createElement(Box$1, {
    p: 0,
    className: classes === null || classes === void 0 ? void 0 : classes.paper
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 2
  }, renderDynamicSections(), renderOthersInfoSection())));
};
connect()(withStyles(styles$l)(PreviewDetails));

var useStyles$1f = makeStyles(function (theme) {
  return {
    title: {
      fontWeight: "bold"
    },
    section: {
      marginTop: theme.spacing(3)
    }
  };
});
var WorkerExtraInfo = function WorkerExtraInfo(_ref) {
  var _formData$institution, _formData$institution2, _formData$institution3, _formData$institution4, _formData$institution5, _formData$institution6, _formData$institution7;
  var handleChange = _ref.handleChange,
    formData = _ref.formData,
    errors = _ref.errors;
  var modulesManager = useModulesManager();
  var _useTranslations = useTranslations("core.RegistrationPage", modulesManager),
    formatMessage = _useTranslations.formatMessage;
  var classes = useStyles$1f();
  var dispatch = useDispatch();
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    suggestions = _useState2[0],
    setSuggestions = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    loading = _useState4[0],
    setLoading = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    showFactoryPopup = _useState6[0],
    setShowFactoryPopup = _useState6[1];
  var _useState7 = useState(""),
    _useState8 = _slicedToArray(_useState7, 2),
    factoryPopupMessage = _useState8[0],
    setFactoryPopupMessage = _useState8[1];
  var locale = useSelector(function (state) {
    var _state$core;
    return ((_state$core = state.core) === null || _state$core === void 0 || (_state$core = _state$core.user) === null || _state$core === void 0 || (_state$core = _state$core.i_user) === null || _state$core === void 0 ? void 0 : _state$core.language) || "en";
  });
  var searchFactoryByName = useDebounceCb(/*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(value) {
      var filters, _response$payload, response, edges;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!(!value || value.trim().length < 2)) {
              _context.next = 3;
              break;
            }
            setSuggestions([]);
            return _context.abrupt("return");
          case 3:
            setLoading(true);
            filters = ["searchName: \"".concat(value.trim().replace(/"/g, '\\"'), "\""), "status: \"active\""];
            _context.prev = 5;
            _context.next = 8;
            return dispatch(fetchFactoriesPick(modulesManager, filters));
          case 8:
            response = _context.sent;
            edges = (response === null || response === void 0 || (_response$payload = response.payload) === null || _response$payload === void 0 || (_response$payload = _response$payload.data) === null || _response$payload === void 0 || (_response$payload = _response$payload.workforceEmployerFactories) === null || _response$payload === void 0 ? void 0 : _response$payload.edges) || [];
            setSuggestions(edges.map(function (edge) {
              return edge.node || edge;
            }));
            _context.next = 16;
            break;
          case 13:
            _context.prev = 13;
            _context.t0 = _context["catch"](5);
            setSuggestions([]);
          case 16:
            _context.prev = 16;
            setLoading(false);
            return _context.finish(16);
          case 19:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[5, 13, 16, 19]]);
    }));
    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }(), 400);
  var handleSelection = function handleSelection(event, value, reason) {
    if (reason === "select-option" && value && _typeof(value) === "object") {
      var name = locale === "en" ? value.nameEn : value.nameBn || "";
      handleChange("instituteName", name);
      locale === "en" ? setFactoryPopupMessage("Your factory ".concat(name, " is 100% export oriented company. You can apply from ")) : setFactoryPopupMessage("\u0986\u09AA\u09A8\u09BE\u09A6\u09C7\u09B0 \u0995\u09BE\u09B0\u0996\u09BE\u09A8\u09BE ".concat(name, " \u098F\u0995\u099F\u09BF \u09B6\u09A4\u09AD\u09BE\u0997 \u09B0\u09AA\u09CD\u09A4\u09BE\u09A8\u09BF\u09AE\u09C1\u0996\u09C0 \u09AA\u09CD\u09B0\u09A4\u09BF\u09B7\u09CD\u09A0\u09BE\u09A8\u0964 \u0986\u09AC\u09C7\u09A6\u09A8 \u0995\u09B0\u09A4\u09C7 \u09B9\u09B2\u09C7 \u09AD\u09BF\u099C\u09BF\u099F \u0995\u09B0\u09C1\u09A8 "));
      setShowFactoryPopup(true);
    } else {
      handleChange("instituteName", value || "");
    }
  };
  var handleCloseModal = function handleCloseModal() {
    setShowFactoryPopup(false);
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography, {
    mb: 4,
    style: {
      textAlign: "center",
      fontWeight: "bold",
      fontSize: "small",
      margin: "15px"
    }
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "workforce.application.steps.worker.extraInfo",
    module: "workforce"
  })), /*#__PURE__*/React.createElement(FormControl, {
    component: "fieldset",
    fullWidth: true
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body1",
    className: "".concat(classes.title, " ").concat(classes.section)
  }, formatMessage("workforce.applicant.workInfo.title")), /*#__PURE__*/React.createElement(RadioGroup, {
    value: formData === null || formData === void 0 || (_formData$institution = formData.institutionInfo) === null || _formData$institution === void 0 ? void 0 : _formData$institution.workerType,
    onChange: function onChange(e) {
      return handleChange("workerType", e.target.value);
    }
  }, /*#__PURE__*/React.createElement(FormControlLabel, {
    value: "formal",
    control: /*#__PURE__*/React.createElement(Radio, {
      color: "primary"
    }),
    label: formatMessage("workforce.applicant.workInfo.formal")
  }), /*#__PURE__*/React.createElement(FormControlLabel, {
    value: "informal",
    control: /*#__PURE__*/React.createElement(Radio, {
      color: "primary"
    }),
    label: formatMessage("workforce.applicant.workInfo.informal")
  })), (formData === null || formData === void 0 || (_formData$institution2 = formData.institutionInfo) === null || _formData$institution2 === void 0 ? void 0 : _formData$institution2.workerType) === "formal" && /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 2,
    className: classes.section
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement(Autocomplete$1, {
    freeSolo: true,
    options: suggestions,
    getOptionLabel: function getOptionLabel(option) {
      return typeof option === "string" ? option : locale === "en" ? option.nameEn : option.nameBn;
    },
    onInputChange: function onInputChange(event, newInputValue, reason) {
      if (reason === "input") {
        handleChange("instituteName", newInputValue);
        searchFactoryByName(newInputValue);
      }
    },
    onChange: handleSelection,
    loading: loading,
    value: (formData === null || formData === void 0 || (_formData$institution3 = formData.institutionInfo) === null || _formData$institution3 === void 0 ? void 0 : _formData$institution3.instituteName) || "",
    renderInput: function renderInput(params) {
      return /*#__PURE__*/React.createElement(TextField, _extends({}, params, {
        label: formatMessage("workforce.applicant.workInfo.formal.institution_name"),
        variant: "standard",
        required: true,
        error: !!errors.instituteName,
        helperText: errors.instituteName
      }));
    }
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement(TextInput, {
    id: "instituteAddress",
    label: formatMessage("workforce.applicant.workInfo.formal.institution_address"),
    value: (formData === null || formData === void 0 || (_formData$institution4 = formData.institutionInfo) === null || _formData$institution4 === void 0 ? void 0 : _formData$institution4.instituteAddress) || "",
    required: true,
    onChange: function onChange(e) {
      return handleChange("instituteAddress", e);
    },
    error: !!errors.instituteAddress,
    helperText: errors.instituteAddress
  }))), (formData === null || formData === void 0 || (_formData$institution5 = formData.institutionInfo) === null || _formData$institution5 === void 0 ? void 0 : _formData$institution5.workerType) === "informal" && /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 2,
    className: classes.section
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement(TextInput, {
    id: "aboutWork",
    label: formatMessage("workforce.applicant.workInfo.informal.current_occupation"),
    value: (formData === null || formData === void 0 || (_formData$institution6 = formData.institutionInfo) === null || _formData$institution6 === void 0 ? void 0 : _formData$institution6.aboutWork) || "",
    required: true,
    onChange: function onChange(e) {
      return handleChange("aboutWork", e);
    },
    error: !!errors.aboutWork,
    helperText: errors.aboutWork
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement(TextInput, {
    id: "workingPlace",
    label: formatMessage("workforce.applicant.workInfo.informal.workplace"),
    value: (formData === null || formData === void 0 || (_formData$institution7 = formData.institutionInfo) === null || _formData$institution7 === void 0 ? void 0 : _formData$institution7.workingPlace) || "",
    required: true,
    onChange: function onChange(e) {
      return handleChange("workingPlace", e);
    },
    error: !!errors.workingPlace,
    helperText: errors.workingPlace
  }))), /*#__PURE__*/React.createElement(EmployeeDetailsForm2, {
    errors: errors,
    handleChange: function handleChange() {},
    formData: formData,
    selectedApplicationType: formData === null || formData === void 0 ? void 0 : formData.applicationType,
    formStepNo: "institutionInfo"
  })), /*#__PURE__*/React.createElement(Dialog$1, {
    open: showFactoryPopup,
    onClose: handleCloseModal
  }, /*#__PURE__*/React.createElement(DialogTitle, null, "Information"), /*#__PURE__*/React.createElement(DialogContent$1, null, /*#__PURE__*/React.createElement(DialogContentText, null, factoryPopupMessage, " ", /*#__PURE__*/React.createElement("a", {
    href: "https://labourwelfare.gov.bd/",
    target: "_blank",
    rel: "noopener noreferrer"
  }, "cf.com"))), /*#__PURE__*/React.createElement(DialogActions$1, null, /*#__PURE__*/React.createElement(Button, {
    onClick: handleCloseModal,
    color: "primary",
    autoFocus: true
  }, "OK"))));
};

function ownKeys$Y(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$Y(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$Y(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$Y(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var useStyles$1e = makeStyles(function (theme) {
  return {
    container: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center"
    },
    paper: {
      padding: theme.spacing(1),
      width: 700
    },
    buttonContainer: {
      marginTop: theme.spacing(2),
      display: "flex",
      justifyContent: "flex-end",
      gap: theme.spacing(1)
    }
  };
});
var MaternalGrantForm = function MaternalGrantForm(_ref) {
  var _formData$workforceEm, _formData$workforceEm2;
  var workforceFactoryId = _ref.workforceFactoryId,
    organizationType = _ref.organizationType,
    selectedApplicationType = _ref.selectedApplicationType,
    applicationForSelf = _ref.applicationForSelf,
    selectedFactory = _ref.selectedFactory,
    parsedApplicationData = _ref.parsedApplicationData;
  var employeeData = useSelector(function (state) {
    return state.workforce["workforceEmployee"];
  });
  var modulesManager = useModulesManager();
  var _useTranslations = useTranslations("workforce"),
    formatMessage = _useTranslations.formatMessage;
  var stepRef = useRef(null);
  var _useState = useState({}),
    _useState2 = _slicedToArray(_useState, 2),
    errors = _useState2[0],
    setErrors = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    acknowledged = _useState4[0],
    setAcknowledged = _useState4[1];
  var applicationId = useSelector(function (state) {
    var _state$workforce$fetc;
    return (_state$workforce$fetc = state.workforce["fetchedApplicationIdByClientMutationId"]) !== null && _state$workforce$fetc !== void 0 ? _state$workforce$fetc : [];
  });
  var classes = useStyles$1e();
  var dispatch = useDispatch();
  var _useState5 = useState(0),
    _useState6 = _slicedToArray(_useState5, 2),
    activeStep = _useState6[0],
    setActiveStep = _useState6[1];
  var _useState7 = useState(0),
    _useState8 = _slicedToArray(_useState7, 2),
    expanded = _useState8[0],
    setExpanded = _useState8[1];
  var _useState9 = useState(false),
    _useState10 = _slicedToArray(_useState9, 2),
    isSubmitted = _useState10[0],
    setIsSubmitted = _useState10[1];
  var _useState11 = useState(false),
    _useState12 = _slicedToArray(_useState11, 2),
    showVerifyNid = _useState12[0],
    setShowVerifyNid = _useState12[1];
  var _useState13 = useState(false),
    _useState14 = _slicedToArray(_useState13, 2),
    showPreview = _useState14[0],
    setShowPreview = _useState14[1];
  var _useState15 = useState(false),
    _useState16 = _slicedToArray(_useState15, 2),
    showErrorSnackbar = _useState16[0],
    setShowErrorSnackbar = _useState16[1];
  var reduxState = useSelector(function (state) {
    return state;
  });
  var _useState17 = useState(false),
    _useState18 = _slicedToArray(_useState17, 2);
    _useState18[0];
    var setDisableConfirmSubmit = _useState18[1];
  var documentType = useSelector(function (state) {
    return state.workforce.documentType;
  });
  var uploadFile = useSelector(function (state) {
    return state.workforce.uploadFile;
  });
  var uploadBankFile = useSelector(function (state) {
    return state.workforce.uploadBankFile;
  });
  var user_type = getUserType();
  var _useState19 = useState({
      workforceEmployee: {
        nameEn: "",
        nameBn: "",
        lastNameEn: "",
        position: "",
        fatherNameEn: "",
        fatherNameBn: "",
        motherNameEn: "",
        motherNameBn: "",
        spouseNameEn: "",
        spouseNameBn: "",
        phoneNumber: "",
        email: "",
        birthDate: "",
        deathDate: "",
        joinDate: "",
        nid: "",
        birthCertificateNo: "",
        insuranceNumber: "",
        lifeStatus: "",
        gender: "",
        maritalStatus: "",
        monthlyEarning: "",
        uploadedNidFile: [],
        citizenship: "",
        uploadedBirthCertificateFile: [],
        permanentAddress: "",
        permanentLocation: "",
        presentLocation: "",
        presentAddress: "",
        organizationId: ""
      },
      company: null,
      factory: selectedFactory || null,
      workforceFactoryId: workforceFactoryId || "",
      isSubmitted: "no",
      organizationType: "",
      applicationType: "",
      applicationForSelf: applicationForSelf,
      employeeBankInfo: [{}],
      employeeAccidentInfo: {},
      id: ""
    }),
    _useState20 = _slicedToArray(_useState19, 2),
    formData = _useState20[0],
    setFormData = _useState20[1];
  var _useState21 = useState({
      nid: (formData === null || formData === void 0 || (_formData$workforceEm = formData.workforceEmployee) === null || _formData$workforceEm === void 0 ? void 0 : _formData$workforceEm.nid) || "",
      birthCertificateNo: formData === null || formData === void 0 || (_formData$workforceEm2 = formData.workforceEmployee) === null || _formData$workforceEm2 === void 0 ? void 0 : _formData$workforceEm2.birthCertificateNo
    }),
    _useState22 = _slicedToArray(_useState21, 2),
    nidOrBcn = _useState22[0],
    setNidOrBcn = _useState22[1];
  useEffect(function () {
    var _applicationId$;
    if (applicationId && applicationId.length > 0 && (_applicationId$ = applicationId[0]) !== null && _applicationId$ !== void 0 && _applicationId$.id) {
      setFormData(function (prev) {
        return _objectSpread$Y(_objectSpread$Y({}, prev), {}, {
          applicationId: applicationId[0].id
        });
      });
    }
  }, [applicationId]);
  // Fetch employee data based on username
  var fetchEmployeeWithUser = function fetchEmployeeWithUser() {
    if (reduxState.workforce.selectedEmployee) {
      dispatch(fetchWorkforceEmployee(modulesManager, ["id: \"".concat(decodeId(reduxState.workforce.selectedEmployee.id), "\"")]));
    } else {
      dispatch(fetchWorkforceEmployee(modulesManager, ["relatedUser_LoginName_Iexact: \"".concat(reduxState.core.user.username, "\"")]));
    }
  };
  useEffect(function () {
    if (reduxState.core.user.username) {
      fetchEmployeeWithUser();
    }
  }, [reduxState.core.user.username]);
  useEffect(function () {
    var _formData$workforceEm3, _formData$workforceEm4;
    if (!(employeeData !== null && employeeData !== void 0 && employeeData.id)) return;
    // When employeeData is fetched, set it into the form state
    setFormData({
      id: (parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.id) || "",
      workforceEmployee: {
        id: (employeeData === null || employeeData === void 0 ? void 0 : employeeData.id) || reduxState.core.user.id || "",
        organization: employeeData.organization,
        nameEn: employeeData.firstNameEn || "",
        nameBn: employeeData.firstNameBn || "",
        lastNameEn: " ",
        position: employeeData.position || "",
        fatherNameEn: employeeData.fatherNameEn || "",
        fatherNameBn: employeeData.fatherNameBn || "",
        motherNameEn: employeeData.motherNameEn || "",
        motherNameBn: employeeData.motherNameBn || "",
        spouseNameEn: employeeData.spouseNameEn || "",
        spouseNameBn: employeeData.spouseNameBn || "",
        phoneNumber: employeeData.phoneNumber || "",
        email: employeeData.email || "",
        citizenship: employeeData.citizenship || "",
        birthDate: employeeData.birthDate || "",
        deathDate: employeeData.deathDate || "",
        joinDate: employeeData.joinDate || "",
        nid: employeeData.nid || "",
        birthCertificateNo: employeeData.birthCertificateNo || "",
        insuranceNumber: employeeData.insuranceNumber || "",
        lifeStatus: employeeData.lifeStatus || "",
        gender: employeeData.gender || "",
        maritalStatus: employeeData.maritalStatus || "",
        monthlyEarning: employeeData.monthlyEarning || "",
        uploadedNidFile: employeeData.uploadedNidFile || [],
        uploadedBirthCertificateFile: employeeData.uploadedBirthCertificateFile || [],
        permanentAddress: employeeData.permanentAddress || "",
        permanentLocation: employeeData.permanentLocation || "",
        presentLocation: employeeData.presentLocation || "",
        presentAddress: employeeData.presentAddress || ""
      },
      company: employeeData.company || (formData === null || formData === void 0 || (_formData$workforceEm3 = formData.workforceEmployee) === null || _formData$workforceEm3 === void 0 || (_formData$workforceEm3 = _formData$workforceEm3.company) === null || _formData$workforceEm3 === void 0 ? void 0 : _formData$workforceEm3.id) || null,
      factory: employeeData.factory || (formData === null || formData === void 0 || (_formData$workforceEm4 = formData.workforceEmployee) === null || _formData$workforceEm4 === void 0 || (_formData$workforceEm4 = _formData$workforceEm4.factory) === null || _formData$workforceEm4 === void 0 ? void 0 : _formData$workforceEm4.id) || (parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.employeeFactory) || workforceFactoryId || selectedFactory || null,
      applicationForSelf: applicationForSelf,
      workforceFactoryId: workforceFactoryId || "",
      organizationType: (parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.organizationType) || organizationType,
      applicationType: (parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.applicationType) || selectedApplicationType,
      grantAmount: (parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.grantAmount) || (parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.employeeAccidentInfo.grantAmount),
      institutionInfo: (parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.institutionInfo) || (employeeData === null || employeeData === void 0 ? void 0 : employeeData.institutionInfo) || {},
      dependents: (parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.employeeDependentInfo) || (employeeData === null || employeeData === void 0 ? void 0 : employeeData.dependents) || [{}],
      employeeBankInfo: (parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.employeeBankInfo) || (employeeData === null || employeeData === void 0 ? void 0 : employeeData.employeeBankInfo) || [{}],
      employeeAccidentInfo: (parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.employeeAccidentInfo) || (employeeData === null || employeeData === void 0 ? void 0 : employeeData.employeeAccidentInfo) || {},
      metadata: (parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.metadata) || (employeeData === null || employeeData === void 0 ? void 0 : employeeData.metadata) || {}
    });
    // }
  }, [employeeData === null || employeeData === void 0 ? void 0 : employeeData.id, parsedApplicationData, user_type]); // Trigger this useEffect when `employeeData` changes.

  // Handle form input changes
  var _handleChange = function handleChange(key, value) {
    var parent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    setFormData(function (prev) {
      if (parent) {
        return _objectSpread$Y(_objectSpread$Y({}, prev), {}, _defineProperty({}, parent, _objectSpread$Y(_objectSpread$Y({}, prev[parent]), {}, _defineProperty({}, key, value))));
      }
      return _objectSpread$Y(_objectSpread$Y({}, prev), {}, _defineProperty({}, key, value));
    });
  };
  var handleNext = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var newErrors, isBankStep, isDetailsStep, isTreatmentStep, isDocumentStep, documentValidation, BANK_DOC, bankDocsConfig, generalDocsConfig, hasErrors, _formData$workforceEm5, _formData$metadata, nextStep, fakeErrors, _formData$workforceEm6, _formData$workforceEm7, _formData$workforceEm8, _formData$workforceEm9, _formData$workforceEm10, _formData$workforceEm11, _formData$workforceEm12, _formData$workforceEm13, _formData$workforceEm14, _formData$workforceEm15, _formData$workforceEm16, _formData$workforceEm17, _formData$workforceEm18, _formData$workforceEm19, _formData$workforceEm20, _formData$workforceEm21, _formData$workforceEm22, _formData$workforceEm23, _formData$workforceEm24, _formData$workforceEm25, _formData$workforceEm26, _formData$workforceEm27, _formData$workforceEm28, workforceEmployeeData, _formData$workforceEm29, _parsedApplicationDat, _formData$workforceEm30, _formData$factory, _formData$factory2, createApplicationData, applicationMutation, applicationClientMutationId, updateApplicationData, _parsedApplicationDat2, _formData$workforceEm31, _formData$factory3, _formData$factory4, _updateApplicationData;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            console.log(activeStep);
            newErrors = validateRequiredFields(stepRef, formatMessage, formData);
            newErrors === null || newErrors === void 0 || delete newErrors.documents;
            isBankStep = organizationType === "eis" && activeStep === 2 || organizationType !== "eis" && activeStep === 3;
            isDetailsStep = activeStep === 0;
            isTreatmentStep = organizationType === "eis" && activeStep === 3 || organizationType !== "eis" && activeStep === 4;
            isDocumentStep = isDetailsStep || isBankStep || isTreatmentStep;
            documentValidation = {
              isValid: true,
              errors: null
            };
            BANK_DOC = "applicants bank check copy";
            if (isBankStep) {
              bankDocsConfig = (documentType || []).filter(function (doc) {
                return doc.documentType === BANK_DOC;
              });
              documentValidation = validateMandatoryBankDocumentsForAccounts(bankDocsConfig, uploadBankFile || [], formData.employeeBankInfo || []);
            } else if (isDetailsStep || isTreatmentStep) {
              generalDocsConfig = (documentType || []).filter(function (doc) {
                return doc.documentType !== BANK_DOC;
              });
              documentValidation = validateMandatoryDocuments(generalDocsConfig, uploadFile || []);
            }
            if (isDocumentStep && !documentValidation.isValid) {
              newErrors.documents = documentValidation.errors;
            }
            hasErrors = Object.keys(newErrors).length > 0;
            setShowErrorSnackbar(hasErrors);
            console.log({
              newErrors: newErrors
            });
            setErrors(newErrors);
            if (!(Object.keys(newErrors).length === 0)) {
              _context.next = 56;
              break;
            }
            nextStep = activeStep + 1;
            if (!(nextStep === 1 && !isAtLeast18YearsOld(formData === null || formData === void 0 || (_formData$workforceEm5 = formData.workforceEmployee) === null || _formData$workforceEm5 === void 0 ? void 0 : _formData$workforceEm5.birthDate) && !isAtLeast18YearsOld(formData === null || formData === void 0 || (_formData$metadata = formData.metadata) === null || _formData$metadata === void 0 ? void 0 : _formData$metadata.spouseBirthDate))) {
              _context.next = 24;
              break;
            }
            fakeErrors = _objectSpread$Y(_objectSpread$Y({}, newErrors), {}, {
              rdmp: "core.error.workerAge"
            });
            setErrors(fakeErrors);
            console.log({
              fakeErrors: fakeErrors
            });
            return _context.abrupt("return", false);
          case 24:
            if (nextStep < steps.length) {
              setActiveStep(nextStep);
            }
            if (!(nextStep === 1 || nextStep === 2)) {
              _context.next = 32;
              break;
            }
            // const nidValue = formData?.workforceEmployee?.nid;
            workforceEmployeeData = {
              nameEn: formData === null || formData === void 0 || (_formData$workforceEm6 = formData.workforceEmployee) === null || _formData$workforceEm6 === void 0 ? void 0 : _formData$workforceEm6.nameEn,
              nameBn: formData === null || formData === void 0 || (_formData$workforceEm7 = formData.workforceEmployee) === null || _formData$workforceEm7 === void 0 ? void 0 : _formData$workforceEm7.nameBn,
              lastNameEn: "",
              phoneNumber: formData === null || formData === void 0 || (_formData$workforceEm8 = formData.workforceEmployee) === null || _formData$workforceEm8 === void 0 ? void 0 : _formData$workforceEm8.phoneNumber,
              email: formData === null || formData === void 0 || (_formData$workforceEm9 = formData.workforceEmployee) === null || _formData$workforceEm9 === void 0 ? void 0 : _formData$workforceEm9.email,
              gender: formData === null || formData === void 0 || (_formData$workforceEm10 = formData.workforceEmployee) === null || _formData$workforceEm10 === void 0 || (_formData$workforceEm10 = _formData$workforceEm10.gender) === null || _formData$workforceEm10 === void 0 ? void 0 : _formData$workforceEm10.name,
              birthDate: formData === null || formData === void 0 || (_formData$workforceEm11 = formData.workforceEmployee) === null || _formData$workforceEm11 === void 0 ? void 0 : _formData$workforceEm11.birthDate,
              deathDate: formData === null || formData === void 0 || (_formData$workforceEm12 = formData.workforceEmployee) === null || _formData$workforceEm12 === void 0 ? void 0 : _formData$workforceEm12.deathDate,
              lifeStatus: formData === null || formData === void 0 || (_formData$workforceEm13 = formData.workforceEmployee) === null || _formData$workforceEm13 === void 0 ? void 0 : _formData$workforceEm13.lifeStatus,
              permanentAddress: formData === null || formData === void 0 || (_formData$workforceEm14 = formData.workforceEmployee) === null || _formData$workforceEm14 === void 0 ? void 0 : _formData$workforceEm14.permanentAddress,
              presentAddress: formData === null || formData === void 0 || (_formData$workforceEm15 = formData.workforceEmployee) === null || _formData$workforceEm15 === void 0 ? void 0 : _formData$workforceEm15.presentAddress,
              position: formData === null || formData === void 0 || (_formData$workforceEm16 = formData.workforceEmployee) === null || _formData$workforceEm16 === void 0 ? void 0 : _formData$workforceEm16.position,
              monthlyEarning: formData === null || formData === void 0 || (_formData$workforceEm17 = formData.workforceEmployee) === null || _formData$workforceEm17 === void 0 ? void 0 : _formData$workforceEm17.monthlyEarning,
              insuranceNumber: " ",
              fatherNameBn: formData === null || formData === void 0 || (_formData$workforceEm18 = formData.workforceEmployee) === null || _formData$workforceEm18 === void 0 ? void 0 : _formData$workforceEm18.fatherNameBn,
              fatherNameEn: formData === null || formData === void 0 || (_formData$workforceEm19 = formData.workforceEmployee) === null || _formData$workforceEm19 === void 0 ? void 0 : _formData$workforceEm19.fatherNameEn,
              motherNameBn: formData === null || formData === void 0 || (_formData$workforceEm20 = formData.workforceEmployee) === null || _formData$workforceEm20 === void 0 ? void 0 : _formData$workforceEm20.motherNameBn,
              motherNameEn: formData === null || formData === void 0 || (_formData$workforceEm21 = formData.workforceEmployee) === null || _formData$workforceEm21 === void 0 ? void 0 : _formData$workforceEm21.motherNameEn,
              spouseNameBn: formData === null || formData === void 0 || (_formData$workforceEm22 = formData.workforceEmployee) === null || _formData$workforceEm22 === void 0 ? void 0 : _formData$workforceEm22.spouseNameBn,
              spouseNameEn: formData === null || formData === void 0 || (_formData$workforceEm23 = formData.workforceEmployee) === null || _formData$workforceEm23 === void 0 ? void 0 : _formData$workforceEm23.spouseNameEn,
              citizenship: formData === null || formData === void 0 || (_formData$workforceEm24 = formData.workforceEmployee) === null || _formData$workforceEm24 === void 0 ? void 0 : _formData$workforceEm24.citizenship,
              maritalStatus: formData === null || formData === void 0 || (_formData$workforceEm25 = formData.workforceEmployee) === null || _formData$workforceEm25 === void 0 ? void 0 : _formData$workforceEm25.maritalStatus,
              presentLocation: formData === null || formData === void 0 || (_formData$workforceEm26 = formData.workforceEmployee) === null || _formData$workforceEm26 === void 0 ? void 0 : _formData$workforceEm26.presentLocation,
              permanentLocation: formData === null || formData === void 0 || (_formData$workforceEm27 = formData.workforceEmployee) === null || _formData$workforceEm27 === void 0 ? void 0 : _formData$workforceEm27.permanentLocation,
              id: (formData === null || formData === void 0 || (_formData$workforceEm28 = formData.workforceEmployee) === null || _formData$workforceEm28 === void 0 ? void 0 : _formData$workforceEm28.id) || reduxState.core.user.id
            };
            console.log("Update Submitting formData:", workforceEmployeeData);
            _context.next = 30;
            return dispatch(updateWorkforceEmployee(workforceEmployeeData, "Update Workforce Employee ".concat(workforceEmployeeData.nameEn)));
          case 30:
            _context.next = 55;
            break;
          case 32:
            if (!(nextStep === 3 && formData.organizationType === "cf" || nextStep === 4 && formData.organizationType === "blwf")) {
              _context.next = 51;
              break;
            }
            console.log("Create application formData:", formData);
            createApplicationData = {
              workforceEmployeeId: (formData === null || formData === void 0 || (_formData$workforceEm29 = formData.workforceEmployee) === null || _formData$workforceEm29 === void 0 ? void 0 : _formData$workforceEm29.id) || (parsedApplicationData === null || parsedApplicationData === void 0 || (_parsedApplicationDat = parsedApplicationData.workforceEmployee) === null || _parsedApplicationDat === void 0 ? void 0 : _parsedApplicationDat.id),
              company: formData === null || formData === void 0 || (_formData$workforceEm30 = formData.workforceEmployee) === null || _formData$workforceEm30 === void 0 || (_formData$workforceEm30 = _formData$workforceEm30.company) === null || _formData$workforceEm30 === void 0 ? void 0 : _formData$workforceEm30.id,
              factory: formData !== null && formData !== void 0 && (_formData$factory = formData.factory) !== null && _formData$factory !== void 0 && _formData$factory.id ? safeDecodeId(formData === null || formData === void 0 || (_formData$factory2 = formData.factory) === null || _formData$factory2 === void 0 ? void 0 : _formData$factory2.id) : null,
              organizationType: formData.organizationType,
              applicationType: formData.applicationType,
              grantAmount: formData === null || formData === void 0 ? void 0 : formData.employeeAccidentInfo.grantAmount,
              institutionInfo: JSON.stringify(formData.institutionInfo),
              employeeDesignationInfo: JSON.stringify(formData.employeeDesignationInfo),
              employeeBankInfo: JSON.stringify(formData.employeeBankInfo),
              employeeDependentInfo: JSON.stringify(formData === null || formData === void 0 ? void 0 : formData.dependents),
              employeeAccidentInfo: JSON.stringify(formData === null || formData === void 0 ? void 0 : formData.employeeAccidentInfo),
              metadata: JSON.stringify(formData.metadata),
              status: WORKFORCE_STATUS$1.DRAFT,
              applicationFor: applicationForSelf === "yes" ? "self" : "dependent"
            };
            console.log({
              createApplicationData: createApplicationData
            });
            if (parsedApplicationData) {
              _context.next = 46;
              break;
            }
            applicationMutation = formatMutation("createWorkforceApplication", formatApplicationeGQL(createApplicationData), "Created application");
            applicationClientMutationId = applicationMutation.clientMutationId;
            console.log("applicationClientMutationId", applicationClientMutationId);
            _context.next = 42;
            return dispatch(createApplication(applicationMutation, "Created workforce application "));
          case 42:
            _context.next = 44;
            return dispatch(fetchApplicationId(modulesManager, applicationClientMutationId));
          case 44:
            _context.next = 49;
            break;
          case 46:
            updateApplicationData = _objectSpread$Y({
              id: parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.id
            }, createApplicationData);
            console.log("i am from update", updateApplicationData);
            dispatch(updateApplication(updateApplicationData, "update workforce application ".concat(formData.firstNameEn)));
          case 49:
            _context.next = 55;
            break;
          case 51:
            // console.clear();
            console.log(applicationId);
            _updateApplicationData = {
              id: safeApplicationId(applicationId, parsedApplicationData),
              workforceEmployeeId: (formData === null || formData === void 0 ? void 0 : formData.workforceEmployee.id) || (parsedApplicationData === null || parsedApplicationData === void 0 || (_parsedApplicationDat2 = parsedApplicationData.workforceEmployee) === null || _parsedApplicationDat2 === void 0 ? void 0 : _parsedApplicationDat2.id),
              company: formData === null || formData === void 0 || (_formData$workforceEm31 = formData.workforceEmployee) === null || _formData$workforceEm31 === void 0 || (_formData$workforceEm31 = _formData$workforceEm31.company) === null || _formData$workforceEm31 === void 0 ? void 0 : _formData$workforceEm31.id,
              factory: formData !== null && formData !== void 0 && (_formData$factory3 = formData.factory) !== null && _formData$factory3 !== void 0 && _formData$factory3.id ? safeDecodeId(formData === null || formData === void 0 || (_formData$factory4 = formData.factory) === null || _formData$factory4 === void 0 ? void 0 : _formData$factory4.id) : null,
              organizationType: organizationType || (parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.organizationType),
              applicationType: selectedApplicationType || (parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.applicationType),
              grantAmount: formData === null || formData === void 0 ? void 0 : formData.employeeAccidentInfo.grantAmount,
              employeeBankInfo: JSON.stringify(formData.employeeBankInfo) || JSON.stringify(parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.employeeBankInfo),
              employeeDependentInfo: JSON.stringify(formData === null || formData === void 0 ? void 0 : formData.dependents).replace(/\\/g, "").replace(/"{/g, "{").replace(/}"/g, "}") || JSON.stringify(parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.employeeDependentInfo).replace(/\\/g, "").replace(/"{/g, "{").replace(/}"/g, "}"),
              employeeAccidentInfo: JSON.stringify(formData === null || formData === void 0 ? void 0 : formData.employeeAccidentInfo) || JSON.stringify(parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.employeeAccidentInfo),
              metadata: JSON.stringify(formData.metadata),
              institutionInfo: JSON.stringify(formData.institutionInfo),
              status: WORKFORCE_STATUS$1.DRAFT,
              applicationFor: applicationForSelf === "yes" ? "self" : "dependent"
            };
            console.log("i am from accident info", _updateApplicationData);
            dispatch(updateApplication(_updateApplicationData, "update workforce application ".concat(formData.firstNameEn)));
          case 55:
            return _context.abrupt("return", true);
          case 56:
            return _context.abrupt("return", false);
          case 57:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function handleNext() {
      return _ref2.apply(this, arguments);
    };
  }();
  var handleBack = function handleBack() {
    return setActiveStep(function (prevStep) {
      return prevStep - 1;
    });
  };
  var handleArrayFieldChange = function handleArrayFieldChange(fieldKey, index, key, value) {
    setFormData(function (prev) {
      var items = Array.isArray(prev[fieldKey]) ? _toConsumableArray(prev[fieldKey]) : [];
      var currentItem = items[index] || {};
      var nextValue = typeof value === "function" ? value(currentItem[key]) : value;
      items[index] = _objectSpread$Y(_objectSpread$Y({}, currentItem), {}, _defineProperty({}, key, nextValue));
      return _objectSpread$Y(_objectSpread$Y({}, prev), {}, _defineProperty({}, fieldKey, items));
    });
  };
  var addArrayFieldItem = function addArrayFieldItem(fieldKey) {
    var defaultItem = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    setFormData(function (prev) {
      var items = Array.isArray(prev[fieldKey]) ? _toConsumableArray(prev[fieldKey]) : [{}];
      var updated = [].concat(_toConsumableArray(items), [defaultItem]);
      setExpanded === null || setExpanded === void 0 || setExpanded(updated.length - 1); // optional chaining
      return _objectSpread$Y(_objectSpread$Y({}, prev), {}, _defineProperty({}, fieldKey, updated));
    });
  };
  var removeArrayFieldItem = function removeArrayFieldItem(fieldKey, index) {
    setFormData(function (prev) {
      var items = Array.isArray(prev[fieldKey]) ? _toConsumableArray(prev[fieldKey]) : [];
      var updated = items.filter(function (_, i) {
        return i !== index;
      });
      return _objectSpread$Y(_objectSpread$Y({}, prev), {}, _defineProperty({}, fieldKey, updated));
    });
  };
  var handleSubmit = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var _parsedApplicationDat3, _formData$workforceEm32, _formData$factory5, _formData$factory6;
      var submittedBy, updateApplicationData;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            console.log({
              tazwer: formData
            });
            if (!uploadBankFile) {
              _context2.next = 4;
              break;
            }
            _context2.next = 4;
            return Promise.all(uploadBankFile.map(function (file) {
              return dispatch(createWorkforceDocument(_objectSpread$Y(_objectSpread$Y({}, file), {}, {
                workforceApplicationId: safeApplicationId(applicationId, parsedApplicationData)
              }), "Created workforce document"));
            }));
          case 4:
            _context2.next = 6;
            return Promise.all(uploadFile.map(function (file, index) {
              dispatch(createWorkforceDocument(_objectSpread$Y(_objectSpread$Y({}, file), {}, {
                workforceApplicationId: safeApplicationId(applicationId)
              }), "Created workforce document "));
            }));
          case 6:
            submittedBy = user_type === WORKFORCE_USER_TYPE.APPLICANT ? "applicant" : user_type === WORKFORCE_USER_TYPE.FACTORY_ADMIN ? "factory_admin" : "UNKNOWN";
            updateApplicationData = {
              id: safeApplicationId(applicationId, parsedApplicationData),
              workforceEmployeeId: (formData === null || formData === void 0 ? void 0 : formData.workforceEmployee.id) || (parsedApplicationData === null || parsedApplicationData === void 0 || (_parsedApplicationDat3 = parsedApplicationData.workforceEmployee) === null || _parsedApplicationDat3 === void 0 ? void 0 : _parsedApplicationDat3.id),
              company: formData === null || formData === void 0 || (_formData$workforceEm32 = formData.workforceEmployee) === null || _formData$workforceEm32 === void 0 || (_formData$workforceEm32 = _formData$workforceEm32.company) === null || _formData$workforceEm32 === void 0 ? void 0 : _formData$workforceEm32.id,
              factory: formData !== null && formData !== void 0 && (_formData$factory5 = formData.factory) !== null && _formData$factory5 !== void 0 && _formData$factory5.id ? safeDecodeId(formData === null || formData === void 0 || (_formData$factory6 = formData.factory) === null || _formData$factory6 === void 0 ? void 0 : _formData$factory6.id) : null,
              organizationType: organizationType || (parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.organizationType),
              applicationType: selectedApplicationType || (parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.applicationType),
              grantAmount: formData === null || formData === void 0 ? void 0 : formData.employeeAccidentInfo.grantAmount,
              institutionInfo: JSON.stringify(formData.institutionInfo),
              employeeBankInfo: JSON.stringify(formData.employeeBankInfo) || JSON.stringify(parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.employeeBankInfo),
              employeeDependentInfo: JSON.stringify(formData === null || formData === void 0 ? void 0 : formData.dependents).replace(/\\/g, "").replace(/"{/g, "{").replace(/}"/g, "}") || JSON.stringify(parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.employeeDependentInfo).replace(/\\/g, "").replace(/"{/g, "{").replace(/}"/g, "}"),
              employeeAccidentInfo: JSON.stringify(formData === null || formData === void 0 ? void 0 : formData.employeeAccidentInfo) || JSON.stringify(parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.employeeAccidentInfo),
              metadata: JSON.stringify(formData.metadata),
              applicationFor: applicationForSelf === "yes" ? "self" : "dependent",
              status: WORKFORCE_STATUS$1.NEW,
              submittedBy: submittedBy
            }; // const createApplicationMovementData = {
            //   applicationId: safeApplicationId(applicationId, parsedApplicationData),
            //   status: WORKFORCE_STATUS.NEW,
            //   note: "একটি নতুন আবেদন করা হয়েছে",
            //   applicationFromId: reduxState.core?.user?.i_user?.id,
            //   applicationToId: 165,
            //   toRoleId: 25,
            // applicationToId: user_type === WORKFORCE_USER_TYPE.FACTORY_ADMIN ? 165 : user_type === WORKFORCE_USER_TYPE.BLWF_DOL_DIFE ? 210 : null,
            // toRoleId: user_type === WORKFORCE_USER_TYPE.FACTORY_ADMIN ? 25 : user_type === WORKFORCE_USER_TYPE.BLWF_DOL_DIFE ? 51 : null,
            // };
            console.log("hello i am from submit", updateApplicationData);
            dispatch(updateApplication(updateApplicationData, "update workforce application "));
            // dispatch(createApplicationMovement(createApplicationMovementData, `create workforce movement`));
          case 10:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function handleSubmit() {
      return _ref3.apply(this, arguments);
    };
  }();
  var steps = [{
    label: "workforce.application.steps.employeeDetails",
    content: /*#__PURE__*/React.createElement(EmployeeDetailsForm, {
      handleChange: function handleChange(key, value) {
        return _handleChange(key, value, "workforceEmployee");
      },
      setFormData: _handleChange,
      setNidOrBcn: setNidOrBcn,
      nidOrBcn: nidOrBcn,
      formData: formData,
      errors: errors
    })
  }, {
    label: "workforce.application.steps.location",
    content: /*#__PURE__*/React.createElement(EmployeeLocationForm, {
      handleChange: function handleChange(key, value) {
        return _handleChange(key, value, "workforceEmployee");
      },
      formData: formData
    })
  }].concat(_toConsumableArray(formData.organizationType === "blwf" ? [{
    label: "workforce.application.steps.worker.extraInfo",
    content: /*#__PURE__*/React.createElement(WorkerExtraInfo, {
      errors: errors,
      handleChange: function handleChange(key, value) {
        return _handleChange(key, value, "institutionInfo");
      },
      formData: formData
    })
  }] : []), [{
    label: "workforce.application.steps.account.info",
    content: /*#__PURE__*/React.createElement(EmployeeAccountInfoForm, {
      accounts: formData.employeeBankInfo,
      formdata: formData,
      handleChange: function handleChange(index, key, value) {
        return handleArrayFieldChange("employeeBankInfo", index, key, value);
      },
      addItem: function addItem() {
        return addArrayFieldItem("employeeBankInfo", {
          accountHolderName: "",
          bankName: "",
          accountNumber: "",
          branchName: ""
        });
      },
      removeItem: function removeItem(index) {
        return removeArrayFieldItem("employeeBankInfo", index);
      },
      expanded: expanded,
      setExpanded: setExpanded,
      errors: errors
    })
  }, {
    label: "workforce.application.steps.treatment.info",
    content: /*#__PURE__*/React.createElement(EmployeeMaternalInfoForm, {
      handleChange: function handleChange(key, value) {
        return _handleChange(key, value, "employeeAccidentInfo");
      },
      formData: formData,
      setFormData: setFormData,
      errors: errors
    })
  }
  // {
  //   label: "workforce.application.steps.upload.documents",
  //   content: (
  //     <EmployeeDetailsForm2 handleChange={handleChange} formData={formData} selectedApplicationType={selectedApplicationType}  formStepNo={"workforceDocument"}/>
  //   ),
  // },
  ]);
  console.log({
    tazwer: reduxState.core.user.id
  });
  console.log({
    fahimTazwer: formData
  });
  if (showPreview) {
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ApplicationViewPage, {
      application: formData,
      language: "fr"
    }), /*#__PURE__*/React.createElement("div", {
      className: classes.buttonContainer
    }, /*#__PURE__*/React.createElement(Button, {
      variant: "outlined",
      color: "error",
      onClick: function onClick() {
        setShowPreview(false);
      }
    }, /*#__PURE__*/React.createElement(FormattedMessage, {
      module: "workforce",
      id: "workforce.back"
    })), /*#__PURE__*/React.createElement(Button, {
      variant: "contained",
      color: "primary",
      onClick: function onClick() {
        setShowPreview(false);
        setShowVerifyNid(true);
      }
    }, /*#__PURE__*/React.createElement(FormattedMessage, {
      module: "workforce",
      id: "workforce.submit"
    }))));
  }
  if (showVerifyNid) {
    return /*#__PURE__*/React.createElement("div", {
      className: classes.container
    }, /*#__PURE__*/React.createElement(Paper, {
      className: classes.paper,
      elevation: 0
    }, /*#__PURE__*/React.createElement(NidVerification, {
      formData: formData,
      nidOrBcn: nidOrBcn,
      setDisableConfirmSubmit: setDisableConfirmSubmit
    }), /*#__PURE__*/React.createElement("div", {
      className: classes.buttonContainer
    }, /*#__PURE__*/React.createElement(Button, {
      variant: "contained",
      color: "primary"
      // disabled={disableConfirmSubmit}
      ,
      onClick: /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return handleSubmit();
            case 2:
              setShowVerifyNid(false);
              setIsSubmitted(true);
            case 4:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))
    }, /*#__PURE__*/React.createElement(FormattedMessage, {
      module: "workforce",
      id: "workforce.confirm.submit"
    })))));
  }
  if (isSubmitted) {
    return /*#__PURE__*/React.createElement(ApplicationFormSubmitted, null);
  }
  return /*#__PURE__*/React.createElement("div", {
    className: classes.container
  }, /*#__PURE__*/React.createElement(Paper, {
    className: classes.paper,
    elevation: 0
  }, /*#__PURE__*/React.createElement(Stepper, {
    activeStep: activeStep,
    alternativeLabel: true,
    style: {
      padding: "0px"
    }
  }, steps.map(function (step, index) {
    return /*#__PURE__*/React.createElement(Step, {
      key: index
    }, /*#__PURE__*/React.createElement(StepLabel, null, /*#__PURE__*/React.createElement(FormattedMessage, {
      module: "workforce",
      id: step.label
    })));
  })), /*#__PURE__*/React.createElement(Box$1, {
    mt: 0,
    ref: stepRef
  }, steps[activeStep].content), activeStep === steps.length - 1 && /*#__PURE__*/React.createElement(Box$1, null, /*#__PURE__*/React.createElement(FormControlLabel, {
    control: /*#__PURE__*/React.createElement(Checkbox, {
      checked: acknowledged,
      onChange: function onChange(e) {
        return setAcknowledged(e.target.checked);
      },
      style: {
        color: "blue"
      }
    }),
    label: /*#__PURE__*/React.createElement(Typography, {
      variant: "body2"
    }, /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.application.acknowledgement.text",
      module: "workforce"
    }))
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.buttonContainer
  }, activeStep > 0 && /*#__PURE__*/React.createElement(Button, {
    onClick: handleBack,
    variant: "outlined"
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.back"
  })), activeStep < steps.length - 1 ? /*#__PURE__*/React.createElement(Button, {
    variant: "contained",
    color: "primary",
    onClick: handleNext
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.save.next"
  })) : /*#__PURE__*/React.createElement(Button, {
    variant: "contained",
    color: "primary",
    disabled: !acknowledged,
    onClick: /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
      var isSuccess;
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return handleNext();
          case 2:
            isSuccess = _context4.sent;
            if (isSuccess) setShowPreview(true);
          case 4:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }))
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.submit"
  })))), /*#__PURE__*/React.createElement(CustomSnackbar, {
    open: showErrorSnackbar // Use the new state
    ,
    onClose: function onClose() {
      return setShowErrorSnackbar(false);
    } // Allow it to close
    ,
    type: "error",
    message: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "core.error.generel",
      module: "workforce"
    }),
    duration: 4000
  }));
};

var useStyles$1d = makeStyles(function (theme) {
  return {
    title: {
      fontWeight: "bold"
    },
    paper: {
      padding: theme.spacing(2),
      width: "100%",
      // Ensures it doesn't overflow
      maxWidth: 650,
      // Restrict max width
      margin: "auto" // Centers the Paper component
    },
    section: {
      marginTop: theme.spacing(3)
    }
  };
});
var MedicalDonationCheckbox = function MedicalDonationCheckbox(_ref) {
  var _formData$metadata;
  var handleChange = _ref.handleChange,
    formData = _ref.formData;
    _ref.errors;
  var modulesManager = useModulesManager();
  var _useState = useState(""),
    _useState2 = _slicedToArray(_useState, 2);
    _useState2[0];
    _useState2[1];
  var _useState3 = useState(""),
    _useState4 = _slicedToArray(_useState3, 2),
    donationReason = _useState4[0],
    setDonationReason = _useState4[1];
  var _useTranslations = useTranslations("core.RegistrationPage", modulesManager);
    _useTranslations.formatMessage;
  var classes = useStyles$1d();
  var handleDonationReason = function handleDonationReason(event) {
    var value = event.target.value;
    setDonationReason(value);
    handleChange("donationReason", value);
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography, {
    mb: 4,
    style: {
      textAlign: "center",
      fontWeight: "bold",
      fontSize: "small",
      margin: "15px"
    }
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "workforce.application.steps.select",
    module: "workforce"
  })), /*#__PURE__*/React.createElement(FormControl, {
    component: "fieldset"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body1",
    className: "".concat(classes.title, " ").concat(classes.section)
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.application.steps.reasonsforSeekingFinancialAssistance"
  })), /*#__PURE__*/React.createElement(RadioGroup, {
    value: donationReason || (formData === null || formData === void 0 || (_formData$metadata = formData.metadata) === null || _formData$metadata === void 0 ? void 0 : _formData$metadata.donationReason),
    onChange: handleDonationReason
  }, /*#__PURE__*/React.createElement(FormControlLabel, {
    value: "physicalMentalDisability",
    control: /*#__PURE__*/React.createElement(Radio, {
      color: "primary"
    }),
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      module: "workforce",
      id: "workforce.application.reasons.physicalMentalDisability"
    })
  }), /*#__PURE__*/React.createElement(FormControlLabel, {
    value: "curativeTreatment",
    control: /*#__PURE__*/React.createElement(Radio, {
      color: "primary"
    }),
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      module: "workforce",
      id: "workforce.application.reasons.curativeTreatment"
    })
  }))));
};

function ownKeys$X(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$X(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$X(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$X(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var useStyles$1c = makeStyles(function (theme) {
  return {
    container: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center"
    },
    paper: {
      padding: theme.spacing(2),
      width: 700
    },
    buttonContainer: {
      marginTop: theme.spacing(2),
      display: "flex",
      justifyContent: "flex-end",
      gap: theme.spacing(1)
    }
  };
});
var MedicalDonationForm = function MedicalDonationForm(_ref) {
  var _formData$workforceEm, _formData$workforceEm2;
  var workforceFactoryId = _ref.workforceFactoryId,
    organizationType = _ref.organizationType,
    selectedApplicationType = _ref.selectedApplicationType,
    applicationForSelf = _ref.applicationForSelf,
    selectedFactory = _ref.selectedFactory,
    parsedApplicationData = _ref.parsedApplicationData;
  var employeeData = useSelector(function (state) {
    var _state$workforce$work;
    return (_state$workforce$work = state.workforce["workforceEmployee"]) !== null && _state$workforce$work !== void 0 ? _state$workforce$work : [];
  });
  var modulesManager = useModulesManager();
  var _useTranslations = useTranslations("workforce"),
    formatMessage = _useTranslations.formatMessage;
  var stepRef = useRef(null);
  var _useState = useState({}),
    _useState2 = _slicedToArray(_useState, 2),
    errors = _useState2[0],
    setErrors = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    acknowledged = _useState4[0],
    setAcknowledged = _useState4[1];
  var applicationId = useSelector(function (state) {
    var _state$workforce$fetc;
    return (_state$workforce$fetc = state.workforce["fetchedApplicationIdByClientMutationId"]) !== null && _state$workforce$fetc !== void 0 ? _state$workforce$fetc : [];
  });
  var uploadFile = useSelector(function (state) {
    return state.workforce.uploadFile;
  });
  var uploadBankFile = useSelector(function (state) {
    return state.workforce.uploadBankFile;
  });
  var uploadDependentFile = useSelector(function (state) {
    return state.workforce.uploadDependentFile;
  });
  var documentType = useSelector(function (state) {
    return state.workforce.documentType;
  });
  var classes = useStyles$1c();
  var dispatch = useDispatch();
  var _useState5 = useState(0),
    _useState6 = _slicedToArray(_useState5, 2),
    expanded = _useState6[0],
    setExpanded = _useState6[1];
  var _useState7 = useState(0),
    _useState8 = _slicedToArray(_useState7, 2),
    activeStep = _useState8[0],
    setActiveStep = _useState8[1];
  var _useState9 = useState(false),
    _useState10 = _slicedToArray(_useState9, 2),
    showErrorSnackbar = _useState10[0],
    setShowErrorSnackbar = _useState10[1];
  var _useState11 = useState(null),
    _useState12 = _slicedToArray(_useState11, 2);
    _useState12[0];
    _useState12[1];
  var _useState13 = useState(false),
    _useState14 = _slicedToArray(_useState13, 2),
    isNavigationBlocked = _useState14[0],
    setIsNavigationBlocked = _useState14[1];
  var _useState15 = useState(false),
    _useState16 = _slicedToArray(_useState15, 2);
    _useState16[0];
    var setIsDependentSaved = _useState16[1];
  var _useState17 = useState(false),
    _useState18 = _slicedToArray(_useState17, 2),
    isSubmitted = _useState18[0],
    setIsSubmitted = _useState18[1];
  var _useState19 = useState(false),
    _useState20 = _slicedToArray(_useState19, 2),
    showVerifyNid = _useState20[0],
    setShowVerifyNid = _useState20[1];
  var _useState21 = useState(false),
    _useState22 = _slicedToArray(_useState21, 2),
    showPreview = _useState22[0],
    setShowPreview = _useState22[1];
  var _useState23 = useState(false),
    _useState24 = _slicedToArray(_useState23, 2);
    _useState24[0];
    var setDisableConfirmSubmit = _useState24[1];
  var user_type = getUserType();
  var reduxState = useSelector(function (state) {
    return state;
  });
  var _useState25 = useState({
      nid: (formData === null || formData === void 0 || (_formData$workforceEm = formData.workforceEmployee) === null || _formData$workforceEm === void 0 ? void 0 : _formData$workforceEm.nid) || "",
      birthCertificateNo: formData === null || formData === void 0 || (_formData$workforceEm2 = formData.workforceEmployee) === null || _formData$workforceEm2 === void 0 ? void 0 : _formData$workforceEm2.birthCertificateNo
    }),
    _useState26 = _slicedToArray(_useState25, 2),
    nidOrBcn = _useState26[0],
    setNidOrBcn = _useState26[1];
  var _useState27 = useState({
      workforceEmployee: {
        nameEn: "",
        nameBn: "",
        lastNameEn: "",
        position: "",
        fatherNameEn: "",
        fatherNameBn: "",
        motherNameEn: "",
        motherNameBn: "",
        spouseNameEn: "",
        spouseNameBn: "",
        phoneNumber: "",
        email: "",
        birthDate: "",
        deathDate: "",
        joinDate: "",
        nid: "",
        birthCertificateNo: "",
        insuranceNumber: "",
        lifeStatus: "",
        gender: "",
        maritalStatus: "",
        monthlyEarning: "",
        uploadedNidFile: [],
        citizenship: "",
        uploadedBirthCertificateFile: [],
        permanentAddress: "",
        permanentLocation: "",
        presentLocation: "",
        presentAddress: "",
        organizationId: ""
      },
      company: null,
      factory: selectedFactory || null,
      workforceFactoryId: workforceFactoryId || "",
      isSubmitted: "no",
      organizationType: "",
      applicationType: "",
      applicationForSelf: applicationForSelf,
      dependents: [{}],
      employeeBankInfo: {
        bank: null,
        branch: null,
        accountHolderName: "",
        routingNumber: "",
        accountNumber: ""
      },
      employeeAccidentInfo: {},
      institutionInfo: {},
      id: ""
    }),
    _useState28 = _slicedToArray(_useState27, 2),
    formData = _useState28[0],
    setFormData = _useState28[1];
  useEffect(function () {
    var _applicationId$;
    if (applicationId && applicationId.length > 0 && (_applicationId$ = applicationId[0]) !== null && _applicationId$ !== void 0 && _applicationId$.id) {
      setFormData(function (prev) {
        return _objectSpread$X(_objectSpread$X({}, prev), {}, {
          applicationId: applicationId[0].id
        });
      });
    }
  }, [applicationId]);

  // Fetch employee data based on username
  var fetchEmployeeWithUser = function fetchEmployeeWithUser() {
    dispatch(fetchWorkforceEmployee(modulesManager, ["relatedUser_LoginName_Iexact: \"".concat(reduxState.core.user.username, "\"")]));
  };
  useEffect(function () {
    if (reduxState.core.user.username) {
      fetchEmployeeWithUser();
    }
  }, [reduxState.core.user.username]);
  useEffect(function () {
    if (employeeData) {
      var _formData$workforceEm3, _formData$workforceEm4;
      // When employeeData is fetched, set it into the form state
      setFormData({
        id: (parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.id) || "",
        workforceEmployee: {
          id: (employeeData === null || employeeData === void 0 ? void 0 : employeeData.id) || reduxState.core.user.id || "",
          organization: employeeData.organization,
          nameEn: employeeData.firstNameEn || "",
          nameBn: employeeData.firstNameBn || "",
          lastNameEn: " ",
          position: employeeData.position || "",
          fatherNameEn: employeeData.fatherNameEn || "",
          fatherNameBn: employeeData.fatherNameBn || "",
          motherNameEn: employeeData.motherNameEn || "",
          motherNameBn: employeeData.motherNameBn || "",
          spouseNameEn: employeeData.spouseNameEn || "",
          spouseNameBn: employeeData.spouseNameBn || "",
          phoneNumber: employeeData.phoneNumber || "",
          email: employeeData.email || "",
          citizenship: employeeData.citizenship || "",
          birthDate: employeeData.birthDate || "",
          deathDate: employeeData.deathDate || "",
          joinDate: employeeData.joinDate || "",
          nid: employeeData.nid || "",
          birthCertificateNo: employeeData.birthCertificateNo || "",
          insuranceNumber: employeeData.insuranceNumber || "",
          lifeStatus: employeeData.lifeStatus || "",
          gender: employeeData.gender || "",
          maritalStatus: employeeData.maritalStatus || "",
          monthlyEarning: employeeData.monthlyEarning || "",
          uploadedNidFile: employeeData.uploadedNidFile || [],
          uploadedBirthCertificateFile: employeeData.uploadedBirthCertificateFile || [],
          permanentAddress: employeeData.permanentAddress || "",
          permanentLocation: employeeData.permanentLocation || "",
          presentLocation: employeeData.presentLocation || "",
          presentAddress: employeeData.presentAddress || ""
        },
        company: employeeData.company || (formData === null || formData === void 0 || (_formData$workforceEm3 = formData.workforceEmployee) === null || _formData$workforceEm3 === void 0 || (_formData$workforceEm3 = _formData$workforceEm3.company) === null || _formData$workforceEm3 === void 0 ? void 0 : _formData$workforceEm3.id) || null,
        factory: employeeData.factory || (formData === null || formData === void 0 || (_formData$workforceEm4 = formData.workforceEmployee) === null || _formData$workforceEm4 === void 0 || (_formData$workforceEm4 = _formData$workforceEm4.factory) === null || _formData$workforceEm4 === void 0 ? void 0 : _formData$workforceEm4.id) || (parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.employeeFactory) || workforceFactoryId || selectedFactory || null,
        applicationForSelf: applicationForSelf,
        workforceFactoryId: workforceFactoryId || "",
        organizationType: (parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.organizationType) || organizationType,
        applicationType: (parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.applicationType) || selectedApplicationType,
        grantAmount: (parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.grantAmount) || (parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.employeeAccidentInfo.grantAmount),
        dependents: (parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.employeeDependentInfo) || employeeData.dependents || [{}],
        employeeBankInfo: (parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.employeeBankInfo) || (employeeData === null || employeeData === void 0 ? void 0 : employeeData.employeeBankInfo) || [{}],
        employeeAccidentInfo: (parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.employeeAccidentInfo) || (employeeData === null || employeeData === void 0 ? void 0 : employeeData.employeeAccidentInfo) || {},
        institutionInfo: (parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.institutionInfo) || (employeeData === null || employeeData === void 0 ? void 0 : employeeData.institutionInfo) || {},
        metadata: (parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.metadata) || (employeeData === null || employeeData === void 0 ? void 0 : employeeData.metadata) || {}
      });
    }
  }, [employeeData === null || employeeData === void 0 ? void 0 : employeeData.id, parsedApplicationData]);

  // Handle form input changes
  var _handleChange = function handleChange(key, value) {
    var parent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    setFormData(function (prev) {
      if (parent) {
        return _objectSpread$X(_objectSpread$X({}, prev), {}, _defineProperty({}, parent, _objectSpread$X(_objectSpread$X({}, prev[parent]), {}, _defineProperty({}, key, value))));
      }
      return _objectSpread$X(_objectSpread$X({}, prev), {}, _defineProperty({}, key, value));
    });
  };
  var handleNext = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var newErrors, isBankStep, isDependentStep, isTreatmentStep, documentValidation, BANK_DOC, generalDocsConfig, bankDocsConfig, hasErrors, _formData$workforceEm5, _formData$employeeAcc3, _formData$employeeAcc4, _formData$employeeAcc5, _formData$employeeAcc6, nextStep, shouldBlockNavigation, fakeErrors, _fakeErrors, _formData$workforceEm6, _formData$workforceEm7, _formData$workforceEm8, _formData$workforceEm9, _formData$workforceEm10, _formData$workforceEm11, _formData$workforceEm12, _formData$workforceEm13, _formData$workforceEm14, _formData$workforceEm15, _formData$workforceEm16, _formData$workforceEm17, _formData$workforceEm18, _formData$workforceEm19, _formData$workforceEm20, _formData$workforceEm21, _formData$workforceEm22, _formData$workforceEm23, _formData$workforceEm24, _formData$workforceEm25, _formData$workforceEm26, _formData$workforceEm27, _formData$workforceEm28, workforceEmployeeData, _formData$workforceEm29, _parsedApplicationDat, _formData$workforceEm30, _formData$factory, _formData$factory2, createApplicationData, applicationMutation, applicationClientMutationId, fetchRes, applicationgetId, updateApplicationData, _parsedApplicationDat2, _formData$workforceEm31, _formData$factory3, _formData$factory4, _updateApplicationData, _parsedApplicationDat3, _formData$workforceEm32, _formData$factory5, _formData$factory6, _updateApplicationData2;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            console.log({
              formData: formData
            });
            newErrors = validateRequiredFields(stepRef, formatMessage, formData);
            newErrors === null || newErrors === void 0 || delete newErrors.documents;
            isBankStep = applicationForSelf === "yes" ? activeStep === 5 : activeStep === 6;
            isDependentStep = applicationForSelf === "no" && activeStep === 4;
            isTreatmentStep = applicationForSelf === "yes" ? activeStep === 4 : activeStep === 5;
            documentValidation = {
              isValid: true,
              errors: null
            };
            BANK_DOC = "applicants bank check copy";
            if (isDependentStep) {
              documentValidation = validateMandatoryDocumentsForDependents(documentType, uploadDependentFile || [], formData.dependents || []);
            } else if (isTreatmentStep) {
              generalDocsConfig = (documentType || []).filter(function (doc) {
                return doc.documentType !== BANK_DOC;
              }).filter(function (doc) {
                var _formData$employeeAcc, _formData$employeeAcc2;
                if (!isEisPath() && doc.documentType === "discharge certificate" && ((formData === null || formData === void 0 || (_formData$employeeAcc = formData.employeeAccidentInfo) === null || _formData$employeeAcc === void 0 ? void 0 : _formData$employeeAcc.admitted) === "no" || (formData === null || formData === void 0 || (_formData$employeeAcc2 = formData.employeeAccidentInfo) === null || _formData$employeeAcc2 === void 0 ? void 0 : _formData$employeeAcc2.admitted) === undefined)) {
                  return false;
                }
                return true;
              });
              documentValidation = validateMandatoryDocuments(generalDocsConfig, uploadFile || []);
            } else if (isBankStep) {
              bankDocsConfig = (documentType || []).filter(function (doc) {
                return doc.documentType === BANK_DOC;
              });
              documentValidation = validateMandatoryBankDocumentsForAccounts(bankDocsConfig, uploadBankFile || [], formData.employeeBankInfo || []);
            }
            if ((isDependentStep || isTreatmentStep || isBankStep) && !documentValidation.isValid) {
              newErrors.documents = documentValidation.errors;
            }
            hasErrors = Object.keys(newErrors).length > 0;
            setShowErrorSnackbar(hasErrors);
            console.log({
              newErrors: newErrors
            });
            console.log({
              documentValidation: documentValidation
            });
            setErrors(newErrors);
            if (!(Object.keys(newErrors).length === 0)) {
              _context.next = 99;
              break;
            }
            nextStep = activeStep + 1;
            shouldBlockNavigation = (formData === null || formData === void 0 ? void 0 : formData.applicationForSelf) === "no" && activeStep === 4;
            if (!(nextStep === 2 && !isAtLeast18YearsOld(formData === null || formData === void 0 || (_formData$workforceEm5 = formData.workforceEmployee) === null || _formData$workforceEm5 === void 0 ? void 0 : _formData$workforceEm5.birthDate))) {
              _context.next = 25;
              break;
            }
            fakeErrors = _objectSpread$X(_objectSpread$X({}, newErrors), {}, {
              rdmp: "core.error.workerAge"
            });
            setErrors(fakeErrors);
            console.log({
              fakeErrors: fakeErrors
            });
            return _context.abrupt("return", false);
          case 25:
            if (!(applicationForSelf === "yes" ? nextStep === 5 && isDateDifference150Days(formData === null || formData === void 0 || (_formData$employeeAcc3 = formData.employeeAccidentInfo) === null || _formData$employeeAcc3 === void 0 ? void 0 : _formData$employeeAcc3.diagnosisDate, formData === null || formData === void 0 || (_formData$employeeAcc4 = formData.employeeAccidentInfo) === null || _formData$employeeAcc4 === void 0 ? void 0 : _formData$employeeAcc4.lastCheckupDate, 150) : nextStep === 6 && isDateDifference150Days(formData === null || formData === void 0 || (_formData$employeeAcc5 = formData.employeeAccidentInfo) === null || _formData$employeeAcc5 === void 0 ? void 0 : _formData$employeeAcc5.diagnosisDate, formData === null || formData === void 0 || (_formData$employeeAcc6 = formData.employeeAccidentInfo) === null || _formData$employeeAcc6 === void 0 ? void 0 : _formData$employeeAcc6.lastCheckupDate, 150))) {
              _context.next = 32;
              break;
            }
            _fakeErrors = _objectSpread$X(_objectSpread$X({}, newErrors), {}, {
              rdmp: "core.error.lastCheckup.between150days"
            });
            setErrors(_fakeErrors);
            console.log({
              fakeErrors: _fakeErrors
            });
            return _context.abrupt("return", false);
          case 32:
            if (shouldBlockNavigation) {
              setIsNavigationBlocked(true);
            }
            if (!(nextStep === 2 || nextStep === 3)) {
              _context.next = 40;
              break;
            }
            workforceEmployeeData = {
              nameEn: formData === null || formData === void 0 || (_formData$workforceEm6 = formData.workforceEmployee) === null || _formData$workforceEm6 === void 0 ? void 0 : _formData$workforceEm6.nameEn,
              nameBn: formData === null || formData === void 0 || (_formData$workforceEm7 = formData.workforceEmployee) === null || _formData$workforceEm7 === void 0 ? void 0 : _formData$workforceEm7.nameBn,
              lastNameEn: "",
              phoneNumber: formData === null || formData === void 0 || (_formData$workforceEm8 = formData.workforceEmployee) === null || _formData$workforceEm8 === void 0 ? void 0 : _formData$workforceEm8.phoneNumber,
              email: formData === null || formData === void 0 || (_formData$workforceEm9 = formData.workforceEmployee) === null || _formData$workforceEm9 === void 0 ? void 0 : _formData$workforceEm9.email,
              gender: formData === null || formData === void 0 || (_formData$workforceEm10 = formData.workforceEmployee) === null || _formData$workforceEm10 === void 0 || (_formData$workforceEm10 = _formData$workforceEm10.gender) === null || _formData$workforceEm10 === void 0 ? void 0 : _formData$workforceEm10.name,
              birthDate: formData === null || formData === void 0 || (_formData$workforceEm11 = formData.workforceEmployee) === null || _formData$workforceEm11 === void 0 ? void 0 : _formData$workforceEm11.birthDate,
              deathDate: formData === null || formData === void 0 || (_formData$workforceEm12 = formData.workforceEmployee) === null || _formData$workforceEm12 === void 0 ? void 0 : _formData$workforceEm12.deathDate,
              lifeStatus: formData === null || formData === void 0 || (_formData$workforceEm13 = formData.workforceEmployee) === null || _formData$workforceEm13 === void 0 ? void 0 : _formData$workforceEm13.lifeStatus,
              permanentAddress: formData === null || formData === void 0 || (_formData$workforceEm14 = formData.workforceEmployee) === null || _formData$workforceEm14 === void 0 ? void 0 : _formData$workforceEm14.permanentAddress,
              presentAddress: formData === null || formData === void 0 || (_formData$workforceEm15 = formData.workforceEmployee) === null || _formData$workforceEm15 === void 0 ? void 0 : _formData$workforceEm15.presentAddress,
              position: formData === null || formData === void 0 || (_formData$workforceEm16 = formData.workforceEmployee) === null || _formData$workforceEm16 === void 0 ? void 0 : _formData$workforceEm16.position,
              monthlyEarning: formData === null || formData === void 0 || (_formData$workforceEm17 = formData.workforceEmployee) === null || _formData$workforceEm17 === void 0 ? void 0 : _formData$workforceEm17.monthlyEarning,
              insuranceNumber: " ",
              fatherNameBn: formData === null || formData === void 0 || (_formData$workforceEm18 = formData.workforceEmployee) === null || _formData$workforceEm18 === void 0 ? void 0 : _formData$workforceEm18.fatherNameBn,
              fatherNameEn: formData === null || formData === void 0 || (_formData$workforceEm19 = formData.workforceEmployee) === null || _formData$workforceEm19 === void 0 ? void 0 : _formData$workforceEm19.fatherNameEn,
              motherNameBn: formData === null || formData === void 0 || (_formData$workforceEm20 = formData.workforceEmployee) === null || _formData$workforceEm20 === void 0 ? void 0 : _formData$workforceEm20.motherNameBn,
              motherNameEn: formData === null || formData === void 0 || (_formData$workforceEm21 = formData.workforceEmployee) === null || _formData$workforceEm21 === void 0 ? void 0 : _formData$workforceEm21.motherNameEn,
              spouseNameBn: formData === null || formData === void 0 || (_formData$workforceEm22 = formData.workforceEmployee) === null || _formData$workforceEm22 === void 0 ? void 0 : _formData$workforceEm22.spouseNameBn,
              spouseNameEn: formData === null || formData === void 0 || (_formData$workforceEm23 = formData.workforceEmployee) === null || _formData$workforceEm23 === void 0 ? void 0 : _formData$workforceEm23.spouseNameEn,
              citizenship: formData === null || formData === void 0 || (_formData$workforceEm24 = formData.workforceEmployee) === null || _formData$workforceEm24 === void 0 ? void 0 : _formData$workforceEm24.citizenship,
              maritalStatus: formData === null || formData === void 0 || (_formData$workforceEm25 = formData.workforceEmployee) === null || _formData$workforceEm25 === void 0 ? void 0 : _formData$workforceEm25.maritalStatus,
              presentLocation: formData === null || formData === void 0 || (_formData$workforceEm26 = formData.workforceEmployee) === null || _formData$workforceEm26 === void 0 ? void 0 : _formData$workforceEm26.presentLocation,
              permanentLocation: formData === null || formData === void 0 || (_formData$workforceEm27 = formData.workforceEmployee) === null || _formData$workforceEm27 === void 0 ? void 0 : _formData$workforceEm27.permanentLocation,
              id: (formData === null || formData === void 0 || (_formData$workforceEm28 = formData.workforceEmployee) === null || _formData$workforceEm28 === void 0 ? void 0 : _formData$workforceEm28.id) || reduxState.core.user.id
            };
            console.log("Update Submitting formData:", formData);
            _context.next = 38;
            return dispatch(updateWorkforceEmployee(workforceEmployeeData, "Update Workforce Employee ".concat(workforceEmployeeData.nameEn)));
          case 38:
            _context.next = 85;
            break;
          case 40:
            if (!(nextStep === 1)) {
              _context.next = 72;
              break;
            }
            console.log("Create application formData:", formData);
            createApplicationData = {
              workforceEmployeeId: (formData === null || formData === void 0 || (_formData$workforceEm29 = formData.workforceEmployee) === null || _formData$workforceEm29 === void 0 ? void 0 : _formData$workforceEm29.id) || (parsedApplicationData === null || parsedApplicationData === void 0 || (_parsedApplicationDat = parsedApplicationData.workforceEmployee) === null || _parsedApplicationDat === void 0 ? void 0 : _parsedApplicationDat.id),
              company: formData === null || formData === void 0 || (_formData$workforceEm30 = formData.workforceEmployee) === null || _formData$workforceEm30 === void 0 || (_formData$workforceEm30 = _formData$workforceEm30.company) === null || _formData$workforceEm30 === void 0 ? void 0 : _formData$workforceEm30.id,
              factory: formData !== null && formData !== void 0 && (_formData$factory = formData.factory) !== null && _formData$factory !== void 0 && _formData$factory.id ? safeDecodeId(formData === null || formData === void 0 || (_formData$factory2 = formData.factory) === null || _formData$factory2 === void 0 ? void 0 : _formData$factory2.id) : null,
              organizationType: formData.organizationType,
              applicationType: formData.applicationType,
              grantAmount: formData === null || formData === void 0 ? void 0 : formData.employeeAccidentInfo.grantAmount,
              employeeDesignationInfo: JSON.stringify(formData.employeeDesignationInfo),
              employeeBankInfo: JSON.stringify(formData.employeeBankInfo),
              employeeDependentInfo: JSON.stringify(formData.dependents).replace(/\\/g, "").replace(/"{/g, "{").replace(/}"/g, "}"),
              employeeAccidentInfo: JSON.stringify(formData === null || formData === void 0 ? void 0 : formData.employeeAccidentInfo),
              institutionInfo: JSON.stringify(formData === null || formData === void 0 ? void 0 : formData.institutionInfo),
              metadata: JSON.stringify(formData === null || formData === void 0 ? void 0 : formData.metadata),
              status: WORKFORCE_STATUS$1.DRAFT,
              applicationFor: applicationForSelf === "yes" ? "self" : "dependent"
            };
            console.log({
              createApplicationData: createApplicationData
            });
            if (parsedApplicationData) {
              _context.next = 64;
              break;
            }
            _context.next = 47;
            return formatMutation("createWorkforceApplication", formatApplicationeGQL(createApplicationData), "Created application ");
          case 47:
            applicationMutation = _context.sent;
            applicationClientMutationId = applicationMutation.clientMutationId;
            console.log("applicationClientMutationId", applicationClientMutationId);
            _context.next = 52;
            return dispatch(createApplication(applicationMutation, "Created workforce application "));
          case 52:
            _context.next = 54;
            return dispatch(fetchInfoIdByClientMutationId(modulesManager, "workforceApplication", applicationClientMutationId, "WORKFORCE_APPLICATION_BY_CLIENT_MUTATION_ID"));
          case 54:
            fetchRes = _context.sent;
            applicationgetId = getInfoId(fetchRes, "workforceApplication");
            console.log("hello there", applicationgetId);
            if (!applicationgetId && applicationId) {
              applicationgetId = applicationId;
            }
            if (!uploadDependentFile) {
              _context.next = 61;
              break;
            }
            _context.next = 61;
            return dispatch(fetchEmployeeDependent(modulesManager, ["workforceApplication_Id:\"".concat(applicationgetId, "\"")])).then(function (res) {
              var _res$payload;
              var dependentId = res === null || res === void 0 || (_res$payload = res.payload) === null || _res$payload === void 0 || (_res$payload = _res$payload.data) === null || _res$payload === void 0 || (_res$payload = _res$payload.workforceEmployeeDependent) === null || _res$payload === void 0 || (_res$payload = _res$payload.edges[0]) === null || _res$payload === void 0 || (_res$payload = _res$payload.node) === null || _res$payload === void 0 ? void 0 : _res$payload.id;
              uploadDependentFile.map(function (file, index) {
                dispatch(createWorkforceDocument(_objectSpread$X(_objectSpread$X({}, file), {}, {
                  workforceApplicationId: applicationgetId,
                  workforceDependentId: safeDecodeId(dependentId)
                }), "Created workforce document "));
              });
            });
          case 61:
            dispatch(updateApplication(createApplicationData, "update workforce application ".concat(formData.firstNameEn)));
            _context.next = 70;
            break;
          case 64:
            updateApplicationData = _objectSpread$X({
              id: parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.id
            }, createApplicationData);
            console.log("i am from update", updateApplicationData);
            if (!uploadDependentFile) {
              _context.next = 69;
              break;
            }
            _context.next = 69;
            return dispatch(fetchEmployeeDependent(modulesManager, ["workforceApplication_Id:\"".concat(parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.id, "\"")])).then(function (res) {
              var _res$payload2;
              var dependentId = res === null || res === void 0 || (_res$payload2 = res.payload) === null || _res$payload2 === void 0 || (_res$payload2 = _res$payload2.data) === null || _res$payload2 === void 0 || (_res$payload2 = _res$payload2.workforceEmployeeDependent) === null || _res$payload2 === void 0 || (_res$payload2 = _res$payload2.edges[0]) === null || _res$payload2 === void 0 || (_res$payload2 = _res$payload2.node) === null || _res$payload2 === void 0 ? void 0 : _res$payload2.id;
              console.log({
                dependentId: dependentId
              });
              uploadDependentFile.map(function (file, index) {
                dispatch(createWorkforceDocument(_objectSpread$X(_objectSpread$X({}, file), {}, {
                  workforceApplicationId: parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.id,
                  workforceDependentId: safeDecodeId(dependentId)
                }), "Created workforce document "));
              });
            });
          case 69:
            dispatch(updateApplication(updateApplicationData, "update workforce application "));
          case 70:
            _context.next = 85;
            break;
          case 72:
            if (!(nextStep === 5)) {
              _context.next = 82;
              break;
            }
            _updateApplicationData = {
              id: safeApplicationId(applicationId, parsedApplicationData),
              workforceEmployeeId: (formData === null || formData === void 0 ? void 0 : formData.workforceEmployee.id) || (parsedApplicationData === null || parsedApplicationData === void 0 || (_parsedApplicationDat2 = parsedApplicationData.workforceEmployee) === null || _parsedApplicationDat2 === void 0 ? void 0 : _parsedApplicationDat2.id),
              company: formData === null || formData === void 0 || (_formData$workforceEm31 = formData.workforceEmployee) === null || _formData$workforceEm31 === void 0 || (_formData$workforceEm31 = _formData$workforceEm31.company) === null || _formData$workforceEm31 === void 0 ? void 0 : _formData$workforceEm31.id,
              factory: formData !== null && formData !== void 0 && (_formData$factory3 = formData.factory) !== null && _formData$factory3 !== void 0 && _formData$factory3.id ? safeDecodeId(formData === null || formData === void 0 || (_formData$factory4 = formData.factory) === null || _formData$factory4 === void 0 ? void 0 : _formData$factory4.id) : null,
              organizationType: organizationType || (parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.organizationType),
              applicationType: selectedApplicationType || (parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.applicationType),
              grantAmount: formData === null || formData === void 0 ? void 0 : formData.employeeAccidentInfo.grantAmount,
              employeeBankInfo: JSON.stringify(formData.employeeBankInfo) || JSON.stringify(parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.employeeBankInfo),
              employeeDependentInfo: JSON.stringify(formData.dependents).replace(/\\/g, "").replace(/"{/g, "{").replace(/}"/g, "}") || JSON.stringify(parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.employeeDependentInfo).replace(/\\/g, "").replace(/"{/g, "{").replace(/}"/g, "}"),
              employeeAccidentInfo: JSON.stringify(formData === null || formData === void 0 ? void 0 : formData.employeeAccidentInfo) || JSON.stringify(parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.employeeAccidentInfo),
              institutionInfo: JSON.stringify(formData === null || formData === void 0 ? void 0 : formData.institutionInfo),
              metadata: JSON.stringify(formData === null || formData === void 0 ? void 0 : formData.metadata),
              status: WORKFORCE_STATUS$1.DRAFT,
              applicationFor: applicationForSelf === "yes" ? "self" : "dependent"
            };
            console.log(uploadDependentFile);
            if (!(uploadDependentFile !== null && uploadDependentFile !== void 0 && uploadDependentFile.length)) {
              _context.next = 78;
              break;
            }
            _context.next = 78;
            return Promise.all(uploadDependentFile.map(function (file) {
              return dispatch(createWorkforceDocument(_objectSpread$X(_objectSpread$X({}, file), {}, {
                workforceApplicationId: safeApplicationId(applicationId, parsedApplicationData)
              }), "Created workforce document"));
            }));
          case 78:
            _context.next = 80;
            return dispatch(updateApplication(_updateApplicationData, "update workforce application")).then(function (res) {
              return setIsDependentSaved(true);
            });
          case 80:
            _context.next = 85;
            break;
          case 82:
            _updateApplicationData2 = {
              id: safeApplicationId(applicationId, parsedApplicationData),
              workforceEmployeeId: (formData === null || formData === void 0 ? void 0 : formData.workforceEmployee.id) || (parsedApplicationData === null || parsedApplicationData === void 0 || (_parsedApplicationDat3 = parsedApplicationData.workforceEmployee) === null || _parsedApplicationDat3 === void 0 ? void 0 : _parsedApplicationDat3.id),
              company: formData === null || formData === void 0 || (_formData$workforceEm32 = formData.workforceEmployee) === null || _formData$workforceEm32 === void 0 || (_formData$workforceEm32 = _formData$workforceEm32.company) === null || _formData$workforceEm32 === void 0 ? void 0 : _formData$workforceEm32.id,
              factory: formData !== null && formData !== void 0 && (_formData$factory5 = formData.factory) !== null && _formData$factory5 !== void 0 && _formData$factory5.id ? safeDecodeId(formData === null || formData === void 0 || (_formData$factory6 = formData.factory) === null || _formData$factory6 === void 0 ? void 0 : _formData$factory6.id) : null,
              organizationType: organizationType || (parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.organizationType),
              applicationType: selectedApplicationType || (parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.applicationType),
              grantAmount: formData === null || formData === void 0 ? void 0 : formData.employeeAccidentInfo.grantAmount,
              employeeBankInfo: JSON.stringify(formData.employeeBankInfo) || JSON.stringify(parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.employeeBankInfo),
              employeeDependentInfo: JSON.stringify(formData.dependents).replace(/\\/g, "").replace(/"{/g, "{").replace(/}"/g, "}") || JSON.stringify(parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.employeeDependentInfo).replace(/\\/g, "").replace(/"{/g, "{").replace(/}"/g, "}"),
              employeeAccidentInfo: JSON.stringify(formData === null || formData === void 0 ? void 0 : formData.employeeAccidentInfo) || JSON.stringify(parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.employeeAccidentInfo),
              institutionInfo: JSON.stringify(formData === null || formData === void 0 ? void 0 : formData.institutionInfo),
              metadata: JSON.stringify(formData === null || formData === void 0 ? void 0 : formData.metadata),
              status: WORKFORCE_STATUS$1.DRAFT,
              applicationFor: applicationForSelf === "yes" ? "self" : "dependent"
            };
            console.log("i am from accident info", _updateApplicationData2);
            dispatch(updateApplication(_updateApplicationData2, "update workforce application ".concat(formData.firstNameEn)));
          case 85:
            if (!shouldBlockNavigation) {
              _context.next = 97;
              break;
            }
            _context.prev = 86;
            if (!(parsedApplicationData !== null && parsedApplicationData !== void 0 && parsedApplicationData.id)) {
              _context.next = 92;
              break;
            }
            _context.next = 90;
            return dispatch(fetchEmployeeDependent(modulesManager, ["workforceApplication_Id:\"".concat(parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.id, "\"")]));
          case 90:
            _context.next = 94;
            break;
          case 92:
            _context.next = 94;
            return dispatch(fetchEmployeeDependent(modulesManager, ["workforceApplication_Id:\"".concat(safeApplicationId(applicationId), "\"")]));
          case 94:
            _context.prev = 94;
            setIsNavigationBlocked(false);
            return _context.finish(94);
          case 97:
            if (nextStep < steps.length) {
              setActiveStep(nextStep);
            }
            return _context.abrupt("return", true);
          case 99:
            return _context.abrupt("return", false);
          case 100:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[86,, 94, 97]]);
    }));
    return function handleNext() {
      return _ref2.apply(this, arguments);
    };
  }();
  var handleBack = function handleBack() {
    return setActiveStep(function (prevStep) {
      return prevStep - 1;
    });
  };
  var handleArrayFieldChange = function handleArrayFieldChange(fieldKey, index, key, value) {
    setFormData(function (prev) {
      var items = Array.isArray(prev[fieldKey]) ? _toConsumableArray(prev[fieldKey]) : [];
      var currentItem = items[index] || {};
      var nextValue = typeof value === "function" ? value(currentItem[key]) : value;
      items[index] = _objectSpread$X(_objectSpread$X({}, currentItem), {}, _defineProperty({}, key, nextValue));
      return _objectSpread$X(_objectSpread$X({}, prev), {}, _defineProperty({}, fieldKey, items));
    });
  };
  var addArrayFieldItem = function addArrayFieldItem(fieldKey) {
    var defaultItem = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    setFormData(function (prev) {
      var items = Array.isArray(prev[fieldKey]) ? _toConsumableArray(prev[fieldKey]) : [{}];
      var updated = [].concat(_toConsumableArray(items), [defaultItem]);
      setExpanded === null || setExpanded === void 0 || setExpanded(updated.length - 1); // optional chaining
      return _objectSpread$X(_objectSpread$X({}, prev), {}, _defineProperty({}, fieldKey, updated));
    });
  };
  var removeArrayFieldItem = function removeArrayFieldItem(fieldKey, index) {
    setFormData(function (prev) {
      var items = Array.isArray(prev[fieldKey]) ? _toConsumableArray(prev[fieldKey]) : [];
      var updated = items.filter(function (_, i) {
        return i !== index;
      });
      return _objectSpread$X(_objectSpread$X({}, prev), {}, _defineProperty({}, fieldKey, updated));
    });
  };
  var handleSubmit = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var _parsedApplicationDat4, _formData$workforceEm33, _formData$factory7, _formData$factory8;
      var submittedBy, updateApplicationData;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            console.log({
              tazwer: formData
            });
            if (!uploadBankFile) {
              _context2.next = 4;
              break;
            }
            _context2.next = 4;
            return Promise.all(uploadBankFile.map(function (file) {
              return dispatch(createWorkforceDocument(_objectSpread$X(_objectSpread$X({}, file), {}, {
                workforceApplicationId: safeApplicationId(applicationId, parsedApplicationData)
              }), "Created workforce document"));
            }));
          case 4:
            _context2.next = 6;
            return Promise.all(uploadFile.map(function (file, index) {
              dispatch(createWorkforceDocument(_objectSpread$X(_objectSpread$X({}, file), {}, {
                workforceApplicationId: safeApplicationId(applicationId)
              }), "Created workforce document "));
            }));
          case 6:
            submittedBy = user_type === WORKFORCE_USER_TYPE.APPLICANT ? "applicant" : user_type === WORKFORCE_USER_TYPE.FACTORY_ADMIN ? "factory_admin" : "UNKNOWN";
            updateApplicationData = {
              id: safeApplicationId(applicationId, parsedApplicationData),
              workforceEmployeeId: (formData === null || formData === void 0 ? void 0 : formData.workforceEmployee.id) || (parsedApplicationData === null || parsedApplicationData === void 0 || (_parsedApplicationDat4 = parsedApplicationData.workforceEmployee) === null || _parsedApplicationDat4 === void 0 ? void 0 : _parsedApplicationDat4.id),
              company: formData === null || formData === void 0 || (_formData$workforceEm33 = formData.workforceEmployee) === null || _formData$workforceEm33 === void 0 || (_formData$workforceEm33 = _formData$workforceEm33.company) === null || _formData$workforceEm33 === void 0 ? void 0 : _formData$workforceEm33.id,
              factory: formData !== null && formData !== void 0 && (_formData$factory7 = formData.factory) !== null && _formData$factory7 !== void 0 && _formData$factory7.id ? safeDecodeId(formData === null || formData === void 0 || (_formData$factory8 = formData.factory) === null || _formData$factory8 === void 0 ? void 0 : _formData$factory8.id) : null,
              organizationType: organizationType || (parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.organizationType),
              applicationType: selectedApplicationType || (parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.applicationType),
              grantAmount: formData === null || formData === void 0 ? void 0 : formData.employeeAccidentInfo.grantAmount,
              employeeBankInfo: JSON.stringify(formData.employeeBankInfo) || JSON.stringify(parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.employeeBankInfo),
              employeeDependentInfo: JSON.stringify(formData.dependents).replace(/\\/g, "").replace(/"{/g, "{").replace(/}"/g, "}") || JSON.stringify(parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.employeeDependentInfo).replace(/\\/g, "").replace(/"{/g, "{").replace(/}"/g, "}"),
              employeeAccidentInfo: JSON.stringify(formData === null || formData === void 0 ? void 0 : formData.employeeAccidentInfo) || JSON.stringify(parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.employeeAccidentInfo),
              institutionInfo: JSON.stringify(formData === null || formData === void 0 ? void 0 : formData.institutionInfo),
              metadata: JSON.stringify(formData === null || formData === void 0 ? void 0 : formData.metadata),
              status: WORKFORCE_STATUS$1.NEW,
              applicationFor: applicationForSelf === "yes" ? "self" : "dependent",
              submittedBy: submittedBy
            }; // const createApplicationMovementData = {
            //   applicationId: safeApplicationId(applicationId, parsedApplicationData),
            //   status: WORKFORCE_STATUS.NEW,
            //   note: "একটি নতুন আবেদন করা হয়েছে",
            //   applicationFromId: reduxState.core?.user?.i_user?.id,
            //   applicationToId: 210,
            //   toRoleId: 51,
            // };
            console.log("hello i am from submit", updateApplicationData);
            dispatch(updateApplication(updateApplicationData, "update workforce application "));
            // dispatch(createApplicationMovement(createApplicationMovementData, `create workforce movement`));
            // setShowPreview(true);
            // setIsSubmitted(true);
          case 10:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function handleSubmit() {
      return _ref3.apply(this, arguments);
    };
  }();
  var steps = [{
    label: "workforce.application.steps.select",
    content: /*#__PURE__*/React.createElement(MedicalDonationCheckbox, {
      errors: errors,
      handleChange: function handleChange(key, value) {
        return _handleChange(key, value, "metadata");
      },
      formData: formData
    })
  }, {
    label: "workforce.application.steps.employeeDetails",
    content: /*#__PURE__*/React.createElement(EmployeeDetailsForm, {
      handleChange: function handleChange(key, value) {
        return _handleChange(key, value, "workforceEmployee");
      },
      setNidOrBcn: setNidOrBcn,
      nidOrBcn: nidOrBcn,
      formData: formData,
      errors: errors
    })
  }, {
    label: "workforce.application.steps.location",
    content: /*#__PURE__*/React.createElement(EmployeeLocationForm, {
      errors: errors,
      handleChange: function handleChange(key, value) {
        return _handleChange(key, value, "workforceEmployee");
      },
      formData: formData
    })
  }, {
    label: "workforce.application.steps.worker.extraInfo",
    content: /*#__PURE__*/React.createElement(WorkerExtraInfo, {
      errors: errors,
      handleChange: function handleChange(key, value) {
        return _handleChange(key, value, "institutionInfo");
      },
      formData: formData
    })
  }].concat(_toConsumableArray(applicationForSelf === "no" ? [{
    label: "workforce.application.steps.dependent",
    content: /*#__PURE__*/React.createElement(EmployeeDependentForm, {
      applicationType: formData.applicationType,
      dependents: formData.dependents,
      handleChange: function handleChange(index, key, value) {
        return handleArrayFieldChange("dependents", index, key, value);
      },
      addItem: function addItem() {
        return addArrayFieldItem("dependents", {
          fullName: "",
          relationship: ""
        });
      },
      removeItem: function removeItem(index) {
        return removeArrayFieldItem("dependents", index);
      },
      expanded: expanded,
      formdata: formData,
      setExpanded: setExpanded,
      errors: errors
    })
  }] : []), [{
    label: "workforce.application.steps.treatment.info",
    content: /*#__PURE__*/React.createElement(EmployeeAccidentInfoForm, {
      handleChange: function handleChange(key, value) {
        return _handleChange(key, value, "employeeAccidentInfo");
      },
      formData: formData,
      setFormData: setFormData,
      errors: errors
    })
  }, {
    label: "workforce.application.steps.account.info",
    content: /*#__PURE__*/React.createElement(EmployeeAccountInfoForm, {
      accounts: formData.employeeBankInfo,
      formdata: formData,
      handleChange: function handleChange(index, key, value) {
        return handleArrayFieldChange("employeeBankInfo", index, key, value);
      },
      addItem: function addItem() {
        return addArrayFieldItem("employeeBankInfo", {
          accountHolderName: "",
          bankName: "",
          accountNumber: "",
          branchName: ""
        });
      },
      removeItem: function removeItem(index) {
        return removeArrayFieldItem("employeeBankInfo", index);
      },
      expanded: expanded,
      setExpanded: setExpanded,
      errors: errors
    })
  }]);
  console.log({
    tazwer: formData
  });
  if (showPreview) {
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ApplicationViewPage, {
      application: formData,
      language: "fr"
    }), /*#__PURE__*/React.createElement("div", {
      className: classes.buttonContainer
    }, /*#__PURE__*/React.createElement(Button, {
      variant: "outlined",
      color: "error",
      onClick: function onClick() {
        setShowPreview(false);
      }
    }, /*#__PURE__*/React.createElement(FormattedMessage, {
      module: "workforce",
      id: "workforce.back"
    })), /*#__PURE__*/React.createElement(Button, {
      variant: "contained",
      color: "primary",
      onClick: function onClick() {
        setShowPreview(false);
        setShowVerifyNid(true);
      }
    }, /*#__PURE__*/React.createElement(FormattedMessage, {
      module: "workforce",
      id: "workforce.submit"
    }))));
  }
  if (showVerifyNid) {
    return /*#__PURE__*/React.createElement("div", {
      className: classes.container
    }, /*#__PURE__*/React.createElement(Paper, {
      className: classes.paper,
      elevation: 0
    }, /*#__PURE__*/React.createElement(NidVerification, {
      formData: formData,
      nidOrBcn: nidOrBcn,
      setDisableConfirmSubmit: setDisableConfirmSubmit
    }), /*#__PURE__*/React.createElement("div", {
      className: classes.buttonContainer
    }, /*#__PURE__*/React.createElement(Button, {
      variant: "contained",
      color: "primary"
      // disabled={disableConfirmSubmit}
      ,
      onClick: /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return handleSubmit();
            case 2:
              setShowVerifyNid(false);
              setIsSubmitted(true);
            case 4:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))
    }, /*#__PURE__*/React.createElement(FormattedMessage, {
      module: "workforce",
      id: "workforce.confirm.submit"
    })))));
  }
  if (isSubmitted) {
    return /*#__PURE__*/React.createElement(ApplicationFormSubmitted, null);
  }
  return /*#__PURE__*/React.createElement("div", {
    className: classes.container
  }, /*#__PURE__*/React.createElement(Paper, {
    className: classes.paper,
    elevation: 0
  }, /*#__PURE__*/React.createElement(Stepper, {
    activeStep: activeStep,
    alternativeLabel: true,
    style: {
      padding: "0px"
    }
  }, steps.map(function (step, index) {
    return /*#__PURE__*/React.createElement(Step, {
      key: index
    }, /*#__PURE__*/React.createElement(StepLabel, null, /*#__PURE__*/React.createElement(FormattedMessage, {
      module: "workforce",
      id: step.label
    })));
  })), /*#__PURE__*/React.createElement(Box$1, {
    mt: 0,
    ref: stepRef
  }, steps[activeStep].content), activeStep === steps.length - 1 && /*#__PURE__*/React.createElement(Box$1, null, /*#__PURE__*/React.createElement(FormControlLabel, {
    control: /*#__PURE__*/React.createElement(Checkbox, {
      checked: acknowledged,
      onChange: function onChange(e) {
        return setAcknowledged(e.target.checked);
      },
      style: {
        color: "blue"
      }
    }),
    label: /*#__PURE__*/React.createElement(Typography, {
      variant: "body2"
    }, /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.application.acknowledgement.text",
      module: "workforce"
    }))
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.buttonContainer
  }, activeStep > 0 && /*#__PURE__*/React.createElement(Button, {
    onClick: handleBack,
    variant: "outlined"
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.back"
  }), " "), activeStep < steps.length - 1 ? /*#__PURE__*/React.createElement(Button, {
    variant: "contained",
    color: "primary",
    onClick: handleNext
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.save.next"
  })) : /*#__PURE__*/React.createElement(Button, {
    variant: "contained",
    color: "primary",
    disabled: !acknowledged,
    onClick: /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
      var isSuccess;
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return handleNext();
          case 2:
            isSuccess = _context4.sent;
            if (isSuccess) setShowPreview(true);
          case 4:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }))
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.submit"
  })))), /*#__PURE__*/React.createElement(Dialog$1, {
    open: isNavigationBlocked,
    onClose: function onClose() {},
    disableBackdropClick: true,
    disableEscapeKeyDown: true,
    maxWidth: "sm",
    fullWidth: true
  }, /*#__PURE__*/React.createElement(Box$1, {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: 4,
    gap: 2
  }, /*#__PURE__*/React.createElement(CircularProgress$1, {
    size: 60,
    thickness: 4
  }), /*#__PURE__*/React.createElement(Typography, {
    variant: "h6",
    align: "center"
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "workforce.processing.data",
    module: "workforce"
  })), /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    align: "center",
    color: "textSecondary"
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "workforce.please.wait",
    module: "workforce"
  })))), /*#__PURE__*/React.createElement(CustomSnackbar, {
    open: showErrorSnackbar // Use the new state
    ,
    onClose: function onClose() {
      return setShowErrorSnackbar(false);
    } // Allow it to close
    ,
    type: "error",
    message: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "core.error.generel",
      module: "workforce"
    }),
    duration: 4000
  }));
};

var useStyles$1b = makeStyles(function (theme) {
  return {
    title: {
      fontWeight: 'bold'
    },
    paper: {
      padding: theme.spacing(2),
      width: "100%",
      // Ensures it doesn't overflow
      maxWidth: 650,
      // Restrict max width
      margin: "auto" // Centers the Paper component
    },
    section: {
      marginTop: theme.spacing(3)
    },
    formSection: {
      marginLeft: theme.spacing(2)
    }
  };
});
var ApplicationReasonForDisability = function ApplicationReasonForDisability(_ref) {
  var _formData$metadata;
  var modulesManager = _ref.modulesManager,
    handleChange = _ref.handleChange,
    deathType = _ref.deathType,
    setDeathType = _ref.setDeathType;
    _ref.errors;
    var formData = _ref.formData;
  var _useTranslations = useTranslations("core.RegistrationPage", modulesManager);
    _useTranslations.formatMessage;
  var classes = useStyles$1b();
  var handleDeathTypeChange = function handleDeathTypeChange(event) {
    var value = event.target.value;
    setDeathType(value);
    handleChange("disabilityType", value);
    // onSelect(selectedApplicationType, value); // Pass both selections
  };
  return /*#__PURE__*/React.createElement(FormControl, {
    component: "fieldset",
    className: classes.formSection
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body1",
    className: "".concat(classes.title, " ").concat(classes.section)
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "workforce.application.reason.type",
    module: "workforce"
  })), /*#__PURE__*/React.createElement(RadioGroup, {
    value: (formData === null || formData === void 0 || (_formData$metadata = formData.metadata) === null || _formData$metadata === void 0 ? void 0 : _formData$metadata.disabilityType) || deathType,
    onChange: handleDeathTypeChange
  }, /*#__PURE__*/React.createElement(FormControlLabel, {
    value: "partial",
    control: /*#__PURE__*/React.createElement(Radio, {
      color: "primary"
    }),
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.disability.partial",
      module: "workforce"
    })
  }), /*#__PURE__*/React.createElement(FormControlLabel, {
    value: "permanent",
    control: /*#__PURE__*/React.createElement(Radio, {
      color: "primary"
    }),
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.disability.permanent",
      module: "workforce"
    })
  })));
};

function ownKeys$W(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$W(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$W(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$W(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var useStyles$1a = makeStyles(function (theme) {
  return {
    container: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center"
    },
    paper: {
      padding: theme.spacing(2),
      width: 700
    },
    buttonContainer: {
      marginTop: theme.spacing(2),
      display: "flex",
      justifyContent: "flex-end",
      gap: theme.spacing(1)
    }
  };
});
var DisabilityForm = function DisabilityForm(_ref) {
  var _formData$workforceEm, _formData$workforceEm2;
  var workforceFactoryId = _ref.workforceFactoryId,
    organizationType = _ref.organizationType,
    selectedApplicationType = _ref.selectedApplicationType,
    applicationForSelf = _ref.applicationForSelf,
    parsedApplicationData = _ref.parsedApplicationData,
    selectedFactory = _ref.selectedFactory;
  var modulesManager = useModulesManager();
  var _useTranslations = useTranslations("workforce"),
    formatMessage = _useTranslations.formatMessage;
  var stepRef = useRef(null);
  var _useState = useState({}),
    _useState2 = _slicedToArray(_useState, 2),
    errors = _useState2[0],
    setErrors = _useState2[1];
  var _useState3 = useState({}),
    _useState4 = _slicedToArray(_useState3, 2);
    _useState4[0];
    _useState4[1];
  var applicationId = useSelector(function (state) {
    var _state$workforce$fetc;
    return (_state$workforce$fetc = state.workforce["fetchedApplicationIdByClientMutationId"]) !== null && _state$workforce$fetc !== void 0 ? _state$workforce$fetc : [];
  });
  var classes = useStyles$1a();
  var dispatch = useDispatch();
  var _useState5 = useState(0),
    _useState6 = _slicedToArray(_useState5, 2),
    activeStep = _useState6[0],
    setActiveStep = _useState6[1];
  var _useState7 = useState(0),
    _useState8 = _slicedToArray(_useState7, 2),
    expanded = _useState8[0],
    setExpanded = _useState8[1];
  var _useState9 = useState(false),
    _useState10 = _slicedToArray(_useState9, 2),
    acknowledged = _useState10[0],
    setAcknowledged = _useState10[1];
  var _useState11 = useState(false),
    _useState12 = _slicedToArray(_useState11, 2),
    showErrorSnackbar = _useState12[0],
    setShowErrorSnackbar = _useState12[1];
  var _useState13 = useState(false),
    _useState14 = _slicedToArray(_useState13, 2),
    isSubmitted = _useState14[0],
    setIsSubmitted = _useState14[1];
  var _useState15 = useState(false),
    _useState16 = _slicedToArray(_useState15, 2),
    showVerifyNid = _useState16[0],
    setShowVerifyNid = _useState16[1];
  var _useState17 = useState(false),
    _useState18 = _slicedToArray(_useState17, 2);
    _useState18[0];
    var setDisableConfirmSubmit = _useState18[1];
  var _useState19 = useState(false),
    _useState20 = _slicedToArray(_useState19, 2),
    showPreview = _useState20[0],
    setShowPreview = _useState20[1];
  var _useState21 = useState(""),
    _useState22 = _slicedToArray(_useState21, 2),
    deathType = _useState22[0],
    setDeathType = _useState22[1];
  var _useState23 = useState({
      nid: (formData === null || formData === void 0 || (_formData$workforceEm = formData.workforceEmployee) === null || _formData$workforceEm === void 0 ? void 0 : _formData$workforceEm.nid) || "",
      birthCertificateNo: formData === null || formData === void 0 || (_formData$workforceEm2 = formData.workforceEmployee) === null || _formData$workforceEm2 === void 0 ? void 0 : _formData$workforceEm2.birthCertificateNo
    }),
    _useState24 = _slicedToArray(_useState23, 2),
    nidOrBcn = _useState24[0],
    setNidOrBcn = _useState24[1];
  var reduxState = useSelector(function (state) {
    return state;
  });
  var documentType = useSelector(function (state) {
    return state.workforce.documentType;
  });
  var uploadFile = useSelector(function (state) {
    return state.workforce.uploadFile;
  });
  var uploadBankFile = useSelector(function (state) {
    return state.workforce.uploadBankFile;
  });
  var user_type = getUserType();
  var _useState25 = useState({
      workforceEmployee: {
        firstNameEn: "",
        firstNameBn: "",
        lastNameEn: "",
        lastNameBn: "",
        otherName: "",
        position: "",
        fatherNameEn: "",
        fatherNameBn: "",
        motherNameEn: "",
        motherNameBn: "",
        spouseNameEn: "",
        spouseNameBn: "",
        phoneNumber: "",
        email: "",
        birthDate: "",
        deathDate: "",
        joinDate: "",
        nid: "",
        birthCertificateNo: "",
        insuranceNumber: "",
        lifeStatus: "",
        gender: "",
        maritalStatus: "",
        monthlyEarning: "",
        uploadedNidFile: [],
        citizenship: "",
        uploadedBirthCertificateFile: [],
        permanentAddress: "",
        permanentLocation: "",
        presentLocation: "",
        presentAddress: "",
        organizationId: ""
      },
      deathType: "",
      company: null,
      factory: selectedFactory || workforceFactoryId || null,
      workforceFactoryId: workforceFactoryId || "",
      isSubmitted: "no",
      organizationType: "",
      applicationType: "",
      dependents: {},
      employeeBankInfo: [{}],
      employeeAccidentInfo: {},
      metadata: {},
      id: ""
    }),
    _useState26 = _slicedToArray(_useState25, 2),
    formData = _useState26[0],
    setFormData = _useState26[1];
  var employeeData = user_type === WORKFORCE_USER_TYPE.FACTORY_ADMIN ? useSelector(function (state) {
    var _state$workforce$sele;
    return (_state$workforce$sele = state.workforce["selectedEmployee"]) !== null && _state$workforce$sele !== void 0 ? _state$workforce$sele : [];
  }) : useSelector(function (state) {
    var _state$workforce$work;
    return (_state$workforce$work = state.workforce["workforceEmployee"]) !== null && _state$workforce$work !== void 0 ? _state$workforce$work : [];
  });

  // Fetch employee data based on username
  var fetchEmployeeWithUser = function fetchEmployeeWithUser() {
    if (reduxState.workforce.selectedEmployee) {
      dispatch(fetchWorkforceEmployee(modulesManager, ["id: \"".concat(decodeId(reduxState.workforce.selectedEmployee.id), "\"")]));
    } else {
      dispatch(fetchWorkforceEmployee(modulesManager, ["relatedUser_LoginName_Iexact: \"".concat(reduxState.core.user.username, "\"")]));
    }
  };
  useEffect(function () {
    var _applicationId$;
    if (applicationId && applicationId.length > 0 && (_applicationId$ = applicationId[0]) !== null && _applicationId$ !== void 0 && _applicationId$.id) {
      setFormData(function (prev) {
        return _objectSpread$W(_objectSpread$W({}, prev), {}, {
          applicationId: applicationId[0].id
        });
      });
    }
  }, [applicationId]);
  useEffect(function () {
    if (reduxState.core.user.username) {
      fetchEmployeeWithUser();
    }
  }, [reduxState.core.user.username]);
  useEffect(function () {
    var _parsedApplicationDat, _formData$workforceEm3, _formData$workforceEm4;
    if (!(employeeData !== null && employeeData !== void 0 && employeeData.id) && !(parsedApplicationData !== null && parsedApplicationData !== void 0 && (_parsedApplicationDat = parsedApplicationData.workforceEmployee) !== null && _parsedApplicationDat !== void 0 && _parsedApplicationDat.id)) {
      return;
    }
    // if (employeeData) {
    // When employeeData is fetched, set it into the form state
    setFormData({
      id: (parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.id) || "",
      workforceEmployee: {
        id: (employeeData === null || employeeData === void 0 ? void 0 : employeeData.id) || reduxState.core.user.id || "",
        organization: employeeData.organization,
        nameEn: employeeData.firstNameEn || "",
        nameBn: employeeData.firstNameBn || "",
        lastNameEn: " ",
        position: employeeData.position || "",
        fatherNameEn: employeeData.fatherNameEn || "",
        fatherNameBn: employeeData.fatherNameBn || "",
        motherNameEn: employeeData.motherNameEn || "",
        motherNameBn: employeeData.motherNameBn || "",
        spouseNameEn: employeeData.spouseNameEn || "",
        spouseNameBn: employeeData.spouseNameBn || "",
        phoneNumber: employeeData.phoneNumber || "",
        email: employeeData.email || "",
        citizenship: employeeData.citizenship || "",
        birthDate: employeeData.birthDate || "",
        deathDate: employeeData.deathDate || "",
        joinDate: employeeData.joinDate || "",
        nid: employeeData.nid || "",
        birthCertificateNo: employeeData.birthCertificateNo || "",
        insuranceNumber: employeeData.insuranceNumber || "",
        lifeStatus: employeeData.lifeStatus || "",
        gender: employeeData.gender || "",
        maritalStatus: employeeData.maritalStatus || "",
        monthlyEarning: employeeData.monthlyEarning || "",
        uploadedNidFile: employeeData.uploadedNidFile || [],
        uploadedBirthCertificateFile: employeeData.uploadedBirthCertificateFile || [],
        permanentAddress: employeeData.permanentAddress || "",
        permanentLocation: employeeData.permanentLocation || "",
        presentLocation: employeeData.presentLocation || "",
        presentAddress: employeeData.presentAddress || ""
      },
      company: employeeData.company || (formData === null || formData === void 0 || (_formData$workforceEm3 = formData.workforceEmployee) === null || _formData$workforceEm3 === void 0 || (_formData$workforceEm3 = _formData$workforceEm3.company) === null || _formData$workforceEm3 === void 0 ? void 0 : _formData$workforceEm3.id) || null,
      factory: employeeData.factory || (formData === null || formData === void 0 || (_formData$workforceEm4 = formData.workforceEmployee) === null || _formData$workforceEm4 === void 0 || (_formData$workforceEm4 = _formData$workforceEm4.factory) === null || _formData$workforceEm4 === void 0 ? void 0 : _formData$workforceEm4.id) || (parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.employeeFactory) || workforceFactoryId || selectedFactory || null,
      applicationForSelf: applicationForSelf,
      workforceFactoryId: workforceFactoryId || "",
      organizationType: (parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.organizationType) || organizationType,
      applicationType: (parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.applicationType) || selectedApplicationType,
      grantAmount: (parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.grantAmount) || (parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.employeeAccidentInfo.grantAmount),
      dependents: (parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.employeeDependentInfo) || (employeeData === null || employeeData === void 0 ? void 0 : employeeData.dependents) || [{}],
      employeeBankInfo: (parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.employeeBankInfo) || (employeeData === null || employeeData === void 0 ? void 0 : employeeData.employeeBankInfo) || [{}],
      employeeAccidentInfo: (parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.employeeAccidentInfo) || (employeeData === null || employeeData === void 0 ? void 0 : employeeData.employeeAccidentInfo) || {},
      metadata: (parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.metadata) || (employeeData === null || employeeData === void 0 ? void 0 : employeeData.metadata) || {}
    });
    // }
  }, [employeeData === null || employeeData === void 0 ? void 0 : employeeData.id, parsedApplicationData]); // Trigger this useEffect when `employeeData` changes.

  // Handle form input changes
  var _handleChange = function handleChange(key, value) {
    var parent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    setFormData(function (prev) {
      if (parent) {
        return _objectSpread$W(_objectSpread$W({}, prev), {}, _defineProperty({}, parent, _objectSpread$W(_objectSpread$W({}, prev[parent]), {}, _defineProperty({}, key, value))));
      }
      return _objectSpread$W(_objectSpread$W({}, prev), {}, _defineProperty({}, key, value));
    });
  };
  var handleNext = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var newErrors, isBankStep, files, documentValidation, BANK_DOC, bankDocsConfig, generalDocsConfig, _formData$factory, _formData$factory2, _formData$workforceEm5, _formData$workforceEm6, _formData$workforceEm7, nextStep, resolvedFactoryId, fakeErrors, _formData$workforceEm8, _formData$workforceEm9, _formData$workforceEm10, _formData$workforceEm11, _formData$workforceEm12, _formData$workforceEm13, _formData$workforceEm14, _formData$workforceEm15, _formData$workforceEm16, _formData$workforceEm17, _formData$workforceEm18, _formData$workforceEm19, _formData$workforceEm20, _formData$workforceEm21, _formData$workforceEm22, _formData$workforceEm23, _formData$workforceEm24, _formData$workforceEm25, _formData$workforceEm26, _formData$workforceEm27, _formData$workforceEm28, _formData$workforceEm29, _formData$workforceEm30, workforceEmployeeData, _formData$workforceEm31, _parsedApplicationDat2, _formData$workforceEm32, _formData$factory3, _formData$factory4, createApplicationData, applicationMutation, applicationClientMutationId, updateApplicationData, _formData$workforceEm33, _parsedApplicationDat3, _formData$workforceEm34, _updateApplicationData, _formData$workforceEm35, _parsedApplicationDat4, _formData$workforceEm36, _createApplicationData, _applicationMutation, _applicationClientMutationId, _updateApplicationData2, _parsedApplicationDat5, _formData$workforceEm37, _updateApplicationData3;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            console.log({
              activeStep: activeStep
            });
            console.log({
              handleNext: formData
            });
            console.log({
              uploadFile: uploadFile
            });
            newErrors = validateRequiredFields(stepRef, formatMessage, formData); // 2. ALWAYS clear previous document errors first (this prevents the "sticky" error after back/forth)
            delete newErrors.documents;

            // 3. Identify current step type
            isBankStep = (formData === null || formData === void 0 ? void 0 : formData.organizationType) === "eis" && activeStep === 2 || (formData === null || formData === void 0 ? void 0 : formData.organizationType) !== "eis" && activeStep === 4;
            files = isBankStep ? uploadBankFile : uploadFile;
            documentValidation = {
              isValid: true,
              errors: null
            };
            BANK_DOC = "applicants bank check copy";
            if (isBankStep) {
              bankDocsConfig = (documentType || []).filter(function (doc) {
                return doc.documentType === BANK_DOC;
              });
              documentValidation = validateMandatoryBankDocumentsForAccounts(bankDocsConfig, uploadBankFile || [], formData.employeeBankInfo || []);
            } else {
              generalDocsConfig = (documentType || []).filter(function (doc) {
                return doc.documentType !== BANK_DOC;
              }).filter(function (doc) {
                var _formData$employeeAcc, _formData$employeeAcc2;
                if (!isEisPath() && doc.documentType === "discharge certificate" && ((formData === null || formData === void 0 || (_formData$employeeAcc = formData.employeeAccidentInfo) === null || _formData$employeeAcc === void 0 ? void 0 : _formData$employeeAcc.admitted) === "no" || (formData === null || formData === void 0 || (_formData$employeeAcc2 = formData.employeeAccidentInfo) === null || _formData$employeeAcc2 === void 0 ? void 0 : _formData$employeeAcc2.admitted) === undefined)) {
                  return false;
                }
                return true;
              });
              documentValidation = validateMandatoryDocuments(generalDocsConfig, files);
            }
            if (!documentValidation.isValid) {
              newErrors.documents = documentValidation.errors;
            }
            if (Object.keys(newErrors).length > 0) {
              setShowErrorSnackbar(true);
            } else {
              setShowErrorSnackbar(false);
            }
            console.log({
              newErrors: newErrors
            });
            console.log({
              documentValidation: documentValidation
            });
            setErrors(newErrors);
            console.log({
              newErrors: newErrors
            });
            console.log({
              uploadFile: uploadFile
            });
            console.log({
              documentType: documentType
            });
            if (!(Object.keys(newErrors).length === 0)) {
              _context.next = 78;
              break;
            }
            nextStep = activeStep + 1;
            resolvedFactoryId = formData !== null && formData !== void 0 && (_formData$factory = formData.factory) !== null && _formData$factory !== void 0 && _formData$factory.id ? safeDecodeId(formData === null || formData === void 0 || (_formData$factory2 = formData.factory) === null || _formData$factory2 === void 0 ? void 0 : _formData$factory2.id) : formData !== null && formData !== void 0 && (_formData$workforceEm5 = formData.workforceEmployee) !== null && _formData$workforceEm5 !== void 0 && (_formData$workforceEm5 = _formData$workforceEm5.factory) !== null && _formData$workforceEm5 !== void 0 && _formData$workforceEm5.id ? safeDecodeId(formData === null || formData === void 0 || (_formData$workforceEm6 = formData.workforceEmployee) === null || _formData$workforceEm6 === void 0 || (_formData$workforceEm6 = _formData$workforceEm6.factory) === null || _formData$workforceEm6 === void 0 ? void 0 : _formData$workforceEm6.id) : null; // if (organizationType === "eis" && eisSteps.length - 1 === activeStep) setShowPreview(true);
            if (!((nextStep === 1 && organizationType === "eis" || nextStep === 2 && organizationType !== "eis") && !isAtLeast18YearsOld(formData === null || formData === void 0 || (_formData$workforceEm7 = formData.workforceEmployee) === null || _formData$workforceEm7 === void 0 ? void 0 : _formData$workforceEm7.birthDate))) {
              _context.next = 28;
              break;
            }
            fakeErrors = _objectSpread$W(_objectSpread$W({}, newErrors), {}, {
              rdmp: "core.error.workerAge"
            });
            setErrors(fakeErrors);
            console.log({
              fakeErrors: fakeErrors
            });
            return _context.abrupt("return", false);
          case 28:
            setActiveStep(nextStep);
            if (!(nextStep === 1 && organizationType === "eis" || nextStep === 2 || nextStep === 3 && organizationType !== "eis")) {
              _context.next = 51;
              break;
            }
            workforceEmployeeData = {
              nameEn: formData === null || formData === void 0 || (_formData$workforceEm8 = formData.workforceEmployee) === null || _formData$workforceEm8 === void 0 ? void 0 : _formData$workforceEm8.nameEn,
              nameBn: formData === null || formData === void 0 || (_formData$workforceEm9 = formData.workforceEmployee) === null || _formData$workforceEm9 === void 0 ? void 0 : _formData$workforceEm9.nameBn,
              lastNameEn: "",
              phoneNumber: formData === null || formData === void 0 || (_formData$workforceEm10 = formData.workforceEmployee) === null || _formData$workforceEm10 === void 0 ? void 0 : _formData$workforceEm10.phoneNumber,
              email: formData === null || formData === void 0 || (_formData$workforceEm11 = formData.workforceEmployee) === null || _formData$workforceEm11 === void 0 ? void 0 : _formData$workforceEm11.email,
              gender: formData === null || formData === void 0 || (_formData$workforceEm12 = formData.workforceEmployee) === null || _formData$workforceEm12 === void 0 || (_formData$workforceEm12 = _formData$workforceEm12.gender) === null || _formData$workforceEm12 === void 0 ? void 0 : _formData$workforceEm12.name,
              birthDate: formData === null || formData === void 0 || (_formData$workforceEm13 = formData.workforceEmployee) === null || _formData$workforceEm13 === void 0 ? void 0 : _formData$workforceEm13.birthDate,
              deathDate: formData === null || formData === void 0 || (_formData$workforceEm14 = formData.workforceEmployee) === null || _formData$workforceEm14 === void 0 ? void 0 : _formData$workforceEm14.deathDate,
              lifeStatus: formData === null || formData === void 0 || (_formData$workforceEm15 = formData.workforceEmployee) === null || _formData$workforceEm15 === void 0 ? void 0 : _formData$workforceEm15.lifeStatus,
              permanentAddress: formData === null || formData === void 0 || (_formData$workforceEm16 = formData.workforceEmployee) === null || _formData$workforceEm16 === void 0 ? void 0 : _formData$workforceEm16.permanentAddress,
              presentAddress: formData === null || formData === void 0 || (_formData$workforceEm17 = formData.workforceEmployee) === null || _formData$workforceEm17 === void 0 ? void 0 : _formData$workforceEm17.presentAddress,
              position: formData === null || formData === void 0 || (_formData$workforceEm18 = formData.workforceEmployee) === null || _formData$workforceEm18 === void 0 ? void 0 : _formData$workforceEm18.position,
              monthlyEarning: formData === null || formData === void 0 || (_formData$workforceEm19 = formData.workforceEmployee) === null || _formData$workforceEm19 === void 0 ? void 0 : _formData$workforceEm19.monthlyEarning,
              insuranceNumber: " ",
              fatherNameBn: formData === null || formData === void 0 || (_formData$workforceEm20 = formData.workforceEmployee) === null || _formData$workforceEm20 === void 0 ? void 0 : _formData$workforceEm20.fatherNameBn,
              fatherNameEn: formData === null || formData === void 0 || (_formData$workforceEm21 = formData.workforceEmployee) === null || _formData$workforceEm21 === void 0 ? void 0 : _formData$workforceEm21.fatherNameEn,
              motherNameBn: formData === null || formData === void 0 || (_formData$workforceEm22 = formData.workforceEmployee) === null || _formData$workforceEm22 === void 0 ? void 0 : _formData$workforceEm22.motherNameBn,
              motherNameEn: formData === null || formData === void 0 || (_formData$workforceEm23 = formData.workforceEmployee) === null || _formData$workforceEm23 === void 0 ? void 0 : _formData$workforceEm23.motherNameEn,
              spouseNameBn: formData === null || formData === void 0 || (_formData$workforceEm24 = formData.workforceEmployee) === null || _formData$workforceEm24 === void 0 ? void 0 : _formData$workforceEm24.spouseNameBn,
              spouseNameEn: formData === null || formData === void 0 || (_formData$workforceEm25 = formData.workforceEmployee) === null || _formData$workforceEm25 === void 0 ? void 0 : _formData$workforceEm25.spouseNameEn,
              citizenship: formData === null || formData === void 0 || (_formData$workforceEm26 = formData.workforceEmployee) === null || _formData$workforceEm26 === void 0 ? void 0 : _formData$workforceEm26.citizenship,
              maritalStatus: formData === null || formData === void 0 || (_formData$workforceEm27 = formData.workforceEmployee) === null || _formData$workforceEm27 === void 0 ? void 0 : _formData$workforceEm27.maritalStatus,
              presentLocation: formData === null || formData === void 0 || (_formData$workforceEm28 = formData.workforceEmployee) === null || _formData$workforceEm28 === void 0 ? void 0 : _formData$workforceEm28.presentLocation,
              permanentLocation: formData === null || formData === void 0 || (_formData$workforceEm29 = formData.workforceEmployee) === null || _formData$workforceEm29 === void 0 ? void 0 : _formData$workforceEm29.permanentLocation,
              id: safeDecodeId(employeeData === null || employeeData === void 0 ? void 0 : employeeData.id) || safeDecodeId(formData === null || formData === void 0 || (_formData$workforceEm30 = formData.workforceEmployee) === null || _formData$workforceEm30 === void 0 ? void 0 : _formData$workforceEm30.id) || safeDecodeId(reduxState.core.user.id)
            };
            console.log("Update Submitting formData:", formData);
            _context.next = 34;
            return dispatch(updateWorkforceEmployee(workforceEmployeeData, "Update Workforce Employee ".concat(workforceEmployeeData.nameEn)));
          case 34:
            if (!(organizationType === "eis" && nextStep === 1)) {
              _context.next = 49;
              break;
            }
            createApplicationData = {
              workforceEmployeeId: safeDecodeId(employeeData === null || employeeData === void 0 ? void 0 : employeeData.id) || safeDecodeId(formData === null || formData === void 0 || (_formData$workforceEm31 = formData.workforceEmployee) === null || _formData$workforceEm31 === void 0 ? void 0 : _formData$workforceEm31.id) || safeDecodeId(parsedApplicationData === null || parsedApplicationData === void 0 || (_parsedApplicationDat2 = parsedApplicationData.workforceEmployee) === null || _parsedApplicationDat2 === void 0 ? void 0 : _parsedApplicationDat2.id),
              organizationType: formData.organizationType,
              applicationType: formData.applicationType,
              company: formData === null || formData === void 0 || (_formData$workforceEm32 = formData.workforceEmployee) === null || _formData$workforceEm32 === void 0 || (_formData$workforceEm32 = _formData$workforceEm32.company) === null || _formData$workforceEm32 === void 0 ? void 0 : _formData$workforceEm32.id,
              factory: formData !== null && formData !== void 0 && (_formData$factory3 = formData.factory) !== null && _formData$factory3 !== void 0 && _formData$factory3.id ? safeDecodeId(formData === null || formData === void 0 || (_formData$factory4 = formData.factory) === null || _formData$factory4 === void 0 ? void 0 : _formData$factory4.id) : null,
              grantAmount: formData === null || formData === void 0 ? void 0 : formData.employeeAccidentInfo.grantAmount,
              metadata: JSON.stringify(formData.metadata),
              status: WORKFORCE_STATUS$1.DRAFT,
              applicationFor: applicationForSelf === "yes" ? "self" : applicationForSelf === "" ? "" : "dependent"
            };
            if (parsedApplicationData) {
              _context.next = 46;
              break;
            }
            applicationMutation = formatMutation("createWorkforceApplication", formatApplicationeGQL(createApplicationData), "Created application");
            applicationClientMutationId = applicationMutation.clientMutationId;
            console.log("applicationClientMutationId", applicationClientMutationId);
            _context.next = 42;
            return dispatch(createApplication(applicationMutation, "Created workforce application "));
          case 42:
            _context.next = 44;
            return dispatch(fetchApplicationId(modulesManager, applicationClientMutationId));
          case 44:
            _context.next = 49;
            break;
          case 46:
            updateApplicationData = _objectSpread$W({
              id: parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.id
            }, createApplicationData);
            console.log("i am from update", updateApplicationData);
            dispatch(updateApplication(updateApplicationData, "update workforce application ".concat(formData.firstNameEn)));
          case 49:
            _context.next = 77;
            break;
          case 51:
            if (!(nextStep === 4)) {
              _context.next = 58;
              break;
            }
            console.log("Create application formData:", formData);
            _updateApplicationData = {
              id: safeApplicationId(applicationId, parsedApplicationData),
              workforceEmployeeId: safeDecodeId(employeeData === null || employeeData === void 0 ? void 0 : employeeData.id) || safeDecodeId(formData === null || formData === void 0 || (_formData$workforceEm33 = formData.workforceEmployee) === null || _formData$workforceEm33 === void 0 ? void 0 : _formData$workforceEm33.id) || safeDecodeId(parsedApplicationData === null || parsedApplicationData === void 0 || (_parsedApplicationDat3 = parsedApplicationData.workforceEmployee) === null || _parsedApplicationDat3 === void 0 ? void 0 : _parsedApplicationDat3.id),
              company: formData === null || formData === void 0 || (_formData$workforceEm34 = formData.workforceEmployee) === null || _formData$workforceEm34 === void 0 || (_formData$workforceEm34 = _formData$workforceEm34.company) === null || _formData$workforceEm34 === void 0 ? void 0 : _formData$workforceEm34.id,
              factory: resolvedFactoryId,
              organizationType: formData.organizationType,
              applicationType: formData.applicationType,
              grantAmount: formData === null || formData === void 0 ? void 0 : formData.employeeAccidentInfo.grantAmount,
              employeeDesignationInfo: JSON.stringify(formData.employeeDesignationInfo),
              employeeBankInfo: JSON.stringify(formData.employeeBankInfo),
              employeeAccidentInfo: JSON.stringify(formData === null || formData === void 0 ? void 0 : formData.employeeAccidentInfo),
              metadata: JSON.stringify(formData.metadata),
              status: WORKFORCE_STATUS$1.DRAFT,
              applicationFor: applicationForSelf === "yes" ? "self" : applicationForSelf === "" ? "" : "dependent"
            };
            console.log({
              updateApplicationData: _updateApplicationData
            });
            dispatch(updateApplication(_updateApplicationData, "update workforce application ".concat(formData.firstNameEn)));
            _context.next = 77;
            break;
          case 58:
            if (!(nextStep === 1 && organizationType !== "eis" || nextStep === 3 && organizationType === "eis")) {
              _context.next = 75;
              break;
            }
            _createApplicationData = {
              workforceEmployeeId: safeDecodeId(employeeData === null || employeeData === void 0 ? void 0 : employeeData.id) || safeDecodeId(formData === null || formData === void 0 || (_formData$workforceEm35 = formData.workforceEmployee) === null || _formData$workforceEm35 === void 0 ? void 0 : _formData$workforceEm35.id) || safeDecodeId(parsedApplicationData === null || parsedApplicationData === void 0 || (_parsedApplicationDat4 = parsedApplicationData.workforceEmployee) === null || _parsedApplicationDat4 === void 0 ? void 0 : _parsedApplicationDat4.id),
              organizationType: formData.organizationType,
              applicationType: formData.applicationType,
              company: formData === null || formData === void 0 || (_formData$workforceEm36 = formData.workforceEmployee) === null || _formData$workforceEm36 === void 0 || (_formData$workforceEm36 = _formData$workforceEm36.company) === null || _formData$workforceEm36 === void 0 ? void 0 : _formData$workforceEm36.id,
              factory: resolvedFactoryId,
              grantAmount: formData === null || formData === void 0 ? void 0 : formData.employeeAccidentInfo.grantAmount,
              metadata: JSON.stringify(formData.metadata),
              status: WORKFORCE_STATUS$1.DRAFT,
              applicationFor: applicationForSelf === "yes" ? "self" : applicationForSelf === "" ? "" : "dependent"
            };
            if (parsedApplicationData) {
              _context.next = 70;
              break;
            }
            _applicationMutation = formatMutation("createWorkforceApplication", formatApplicationeGQL(_createApplicationData), "Created application");
            _applicationClientMutationId = _applicationMutation.clientMutationId;
            console.log("applicationClientMutationId", _applicationClientMutationId);
            _context.next = 66;
            return dispatch(createApplication(_applicationMutation, "Created workforce application "));
          case 66:
            _context.next = 68;
            return dispatch(fetchApplicationId(modulesManager, _applicationClientMutationId));
          case 68:
            _context.next = 73;
            break;
          case 70:
            _updateApplicationData2 = _objectSpread$W({
              id: parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.id
            }, _createApplicationData);
            console.log("i am from update", _updateApplicationData2);
            dispatch(updateApplication(_updateApplicationData2, "update workforce application ".concat(formData.firstNameEn)));
          case 73:
            _context.next = 77;
            break;
          case 75:
            _updateApplicationData3 = {
              // id: decodeId(applicationId[0]?.id) || parsedApplicationData?.id,
              id: safeApplicationId(applicationId, parsedApplicationData),
              workforceEmployeeId: safeDecodeId(formData === null || formData === void 0 ? void 0 : formData.workforceEmployee.id) || safeDecodeId(parsedApplicationData === null || parsedApplicationData === void 0 || (_parsedApplicationDat5 = parsedApplicationData.workforceEmployee) === null || _parsedApplicationDat5 === void 0 ? void 0 : _parsedApplicationDat5.id) || safeDecodeId(employeeData === null || employeeData === void 0 ? void 0 : employeeData.id),
              company: formData === null || formData === void 0 || (_formData$workforceEm37 = formData.workforceEmployee) === null || _formData$workforceEm37 === void 0 || (_formData$workforceEm37 = _formData$workforceEm37.company) === null || _formData$workforceEm37 === void 0 ? void 0 : _formData$workforceEm37.id,
              factory: resolvedFactoryId,
              organizationType: organizationType || (parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.organizationType),
              applicationType: selectedApplicationType || (parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.applicationType),
              grantAmount: formData === null || formData === void 0 ? void 0 : formData.employeeAccidentInfo.grantAmount,
              employeeBankInfo: JSON.stringify(formData.employeeBankInfo) || JSON.stringify(parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.employeeBankInfo),
              employeeAccidentInfo: JSON.stringify(formData === null || formData === void 0 ? void 0 : formData.employeeAccidentInfo) || JSON.stringify(parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.employeeAccidentInfo),
              metadata: JSON.stringify(formData.metadata),
              status: WORKFORCE_STATUS$1.DRAFT,
              applicationFor: applicationForSelf === "yes" ? "self" : applicationForSelf === "" ? "" : "dependent"
            };
            dispatch(updateApplication(_updateApplicationData3, "update workforce application ".concat(formData.firstNameEn)));
          case 77:
            return _context.abrupt("return", true);
          case 78:
            return _context.abrupt("return", false);
          case 79:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function handleNext() {
      return _ref2.apply(this, arguments);
    };
  }();
  var handleBack = function handleBack() {
    return setActiveStep(activeStep - 1);
  };
  var handleSubmit = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var _formData$factory5, _formData$factory6, _formData$workforceEm38, _formData$workforceEm39, _parsedApplicationDat6, _formData$workforceEm40;
      var resolvedFactoryId, submittedBy, updateApplicationData;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            resolvedFactoryId = formData !== null && formData !== void 0 && (_formData$factory5 = formData.factory) !== null && _formData$factory5 !== void 0 && _formData$factory5.id ? safeDecodeId(formData === null || formData === void 0 || (_formData$factory6 = formData.factory) === null || _formData$factory6 === void 0 ? void 0 : _formData$factory6.id) : formData !== null && formData !== void 0 && (_formData$workforceEm38 = formData.workforceEmployee) !== null && _formData$workforceEm38 !== void 0 && (_formData$workforceEm38 = _formData$workforceEm38.factory) !== null && _formData$workforceEm38 !== void 0 && _formData$workforceEm38.id ? safeDecodeId(formData === null || formData === void 0 || (_formData$workforceEm39 = formData.workforceEmployee) === null || _formData$workforceEm39 === void 0 || (_formData$workforceEm39 = _formData$workforceEm39.factory) === null || _formData$workforceEm39 === void 0 ? void 0 : _formData$workforceEm39.id) : null;
            console.log({
              tazwer: formData
            });
            if (!uploadBankFile) {
              _context2.next = 5;
              break;
            }
            _context2.next = 5;
            return Promise.all(uploadBankFile.map(function (file) {
              return dispatch(createWorkforceDocument(_objectSpread$W(_objectSpread$W({}, file), {}, {
                workforceApplicationId: safeApplicationId(applicationId, parsedApplicationData)
              }), "Created workforce document"));
            }));
          case 5:
            _context2.next = 7;
            return Promise.all(uploadFile.map(function (file, index) {
              dispatch(createWorkforceDocument(_objectSpread$W(_objectSpread$W({}, file), {}, {
                workforceApplicationId: safeApplicationId(applicationId)
              }), "Created workforce document "));
            }));
          case 7:
            submittedBy = user_type === WORKFORCE_USER_TYPE.APPLICANT ? "applicant" : user_type === WORKFORCE_USER_TYPE.FACTORY_ADMIN ? "factory_admin" : "UNKNOWN";
            updateApplicationData = {
              // id: decodeId(applicationId[0]?.id) || parsedApplicationData?.id,
              id: safeApplicationId(applicationId, parsedApplicationData),
              workforceEmployeeId: safeDecodeId(formData === null || formData === void 0 ? void 0 : formData.workforceEmployee.id) || safeDecodeId(parsedApplicationData === null || parsedApplicationData === void 0 || (_parsedApplicationDat6 = parsedApplicationData.workforceEmployee) === null || _parsedApplicationDat6 === void 0 ? void 0 : _parsedApplicationDat6.id) || safeDecodeId(employeeData === null || employeeData === void 0 ? void 0 : employeeData.id),
              company: formData === null || formData === void 0 || (_formData$workforceEm40 = formData.workforceEmployee) === null || _formData$workforceEm40 === void 0 || (_formData$workforceEm40 = _formData$workforceEm40.company) === null || _formData$workforceEm40 === void 0 ? void 0 : _formData$workforceEm40.id,
              factory: resolvedFactoryId,
              organizationType: organizationType || (parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.organizationType),
              applicationType: selectedApplicationType || (parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.applicationType),
              grantAmount: formData === null || formData === void 0 ? void 0 : formData.employeeAccidentInfo.grantAmount,
              employeeBankInfo: JSON.stringify(formData.employeeBankInfo) || JSON.stringify(parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.employeeBankInfo),
              employeeDependentInfo: JSON.stringify(formData.dependents) || JSON.stringify(parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.employeeDependentInfo),
              employeeAccidentInfo: JSON.stringify(formData === null || formData === void 0 ? void 0 : formData.employeeAccidentInfo) || JSON.stringify(parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.employeeAccidentInfo),
              metadata: JSON.stringify(formData.metadata),
              status: WORKFORCE_STATUS$1.NEW,
              applicationFor: applicationForSelf === "yes" ? "self" : applicationForSelf === "" ? "" : "dependent",
              submittedBy: submittedBy
            }; // const createApplicationMovementData = {
            //   applicationId: safeApplicationId(applicationId, parsedApplicationData),
            //   status: WORKFORCE_STATUS.NEW,
            //   note: "একটি নতুন আবেদন করা হয়েছে",
            //   applicationFromId: reduxState.core?.user?.i_user?.id,
            //   applicationToId: 165,
            //   toRoleId: 25,
            // };
            // console.log("hello i am from submit", createApplicationMovementData)
            // await dispatch(createApplicationMovement(createApplicationMovementData, `create workforce movement`));
            _context2.next = 11;
            return dispatch(updateApplication(updateApplicationData, "update workforce application "));
          case 11:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function handleSubmit() {
      return _ref3.apply(this, arguments);
    };
  }();
  var handleArrayFieldChange = function handleArrayFieldChange(fieldKey, index, key, value) {
    setFormData(function (prev) {
      var items = Array.isArray(prev[fieldKey]) ? _toConsumableArray(prev[fieldKey]) : [];
      var currentItem = items[index] || {};
      var nextValue = typeof value === "function" ? value(currentItem[key]) : value;
      items[index] = _objectSpread$W(_objectSpread$W({}, currentItem), {}, _defineProperty({}, key, nextValue));
      return _objectSpread$W(_objectSpread$W({}, prev), {}, _defineProperty({}, fieldKey, items));
    });
  };
  var addArrayFieldItem = function addArrayFieldItem(fieldKey) {
    var defaultItem = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    setFormData(function (prev) {
      var items = Array.isArray(prev[fieldKey]) ? _toConsumableArray(prev[fieldKey]) : [{}];
      var updated = [].concat(_toConsumableArray(items), [defaultItem]);
      setExpanded === null || setExpanded === void 0 || setExpanded(updated.length - 1); // optional chaining
      return _objectSpread$W(_objectSpread$W({}, prev), {}, _defineProperty({}, fieldKey, updated));
    });
  };
  var removeArrayFieldItem = function removeArrayFieldItem(fieldKey, index) {
    setFormData(function (prev) {
      var items = Array.isArray(prev[fieldKey]) ? _toConsumableArray(prev[fieldKey]) : [];
      var updated = items.filter(function (_, i) {
        return i !== index;
      });
      return _objectSpread$W(_objectSpread$W({}, prev), {}, _defineProperty({}, fieldKey, updated));
    });
  };
  if (showPreview) {
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ApplicationViewPage, {
      application: formData,
      language: "fr"
    }), /*#__PURE__*/React.createElement("div", {
      className: classes.buttonContainer
    }, /*#__PURE__*/React.createElement(Button, {
      variant: "outlined",
      color: "error",
      onClick: function onClick() {
        setShowPreview(false);
      }
    }, /*#__PURE__*/React.createElement(FormattedMessage, {
      module: "workforce",
      id: "workforce.back"
    })), /*#__PURE__*/React.createElement(Button, {
      variant: "contained",
      color: "primary",
      onClick: function onClick() {
        setShowPreview(false);
        setShowVerifyNid(true);
      }
    }, /*#__PURE__*/React.createElement(FormattedMessage, {
      module: "workforce",
      id: "workforce.submit"
    }))));
  }
  if (showVerifyNid) {
    return /*#__PURE__*/React.createElement("div", {
      className: classes.container
    }, /*#__PURE__*/React.createElement(Paper, {
      className: classes.paper,
      elevation: 0
    }, /*#__PURE__*/React.createElement(NidVerification, {
      formData: formData,
      nidOrBcn: nidOrBcn,
      setDisableConfirmSubmit: setDisableConfirmSubmit
    }), /*#__PURE__*/React.createElement("div", {
      className: classes.buttonContainer
    }, /*#__PURE__*/React.createElement(Button, {
      variant: "contained",
      color: "primary"
      // disabled={disableConfirmSubmit}
      ,
      onClick: /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return handleSubmit();
            case 2:
              setShowVerifyNid(false);
              setIsSubmitted(true);
            case 4:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))
    }, /*#__PURE__*/React.createElement(FormattedMessage, {
      module: "workforce",
      id: "workforce.confirm.submit"
    })))));
  }
  if (isSubmitted) {
    return /*#__PURE__*/React.createElement(ApplicationFormSubmitted, null);
  }
  var steps = ["workforce.application.steps.aidReason", "workforce.application.steps.employeeDetails", "workforce.application.steps.location", "workforce.application.disabilityInfo", "workforce.application.steps.account.info"
  // "workforce.application.steps.upload.documents",
  ];
  var eisSteps = [
  // "workforce.application.steps.aidReason",
  "workforce.application.steps.employeeDetails", "workforce.application.steps.location", "workforce.application.steps.account.info"
  // "workforce.application.disabilityInfo",
  // "workforce.application.steps.upload.documents",
  ];
  console.log({
    formData: formData
  });
  return /*#__PURE__*/React.createElement("div", {
    className: classes.container
  }, /*#__PURE__*/React.createElement(Paper, {
    className: classes.paper,
    elevation: 0
  }, /*#__PURE__*/React.createElement(Stepper, {
    activeStep: activeStep,
    alternativeLabel: true,
    style: {
      padding: "0px"
    }
  }, (formData === null || formData === void 0 ? void 0 : formData.organizationType) === "eis" ? eisSteps === null || eisSteps === void 0 ? void 0 : eisSteps.map(function (label) {
    return /*#__PURE__*/React.createElement(Step, {
      key: label
    }, /*#__PURE__*/React.createElement(StepLabel, null, /*#__PURE__*/React.createElement(FormattedMessage, {
      module: "workforce",
      id: label
    })));
  }) : steps === null || steps === void 0 ? void 0 : steps.map(function (label) {
    return /*#__PURE__*/React.createElement(Step, {
      key: label
    }, /*#__PURE__*/React.createElement(StepLabel, null, /*#__PURE__*/React.createElement(FormattedMessage, {
      module: "workforce",
      id: label
    })));
  })), /*#__PURE__*/React.createElement(Box$1, {
    mt: 0,
    ref: stepRef
  }, function () {
    // Determine the current step label for clarity
    steps[activeStep];

    // 1️⃣ Skip Disability Reason if organizationType === "eis"
    if ((formData === null || formData === void 0 ? void 0 : formData.organizationType) === "eis") {
      switch (activeStep) {
        case 0:
          return /*#__PURE__*/React.createElement(EmployeeDetailsForm, {
            handleChange: function handleChange(key, value) {
              return _handleChange(key, value, "workforceEmployee");
            },
            formData: formData,
            setNidOrBcn: setNidOrBcn,
            nidOrBcn: nidOrBcn,
            errors: errors
          });
        case 1:
          return /*#__PURE__*/React.createElement(EmployeeLocationForm, {
            handleChange: function handleChange(key, value) {
              return _handleChange(key, value, "workforceEmployee");
            },
            formData: formData
          });
        case 2:
          return /*#__PURE__*/React.createElement(EmployeeAccountInfoForm, {
            accounts: formData.employeeBankInfo,
            formdata: formData,
            handleChange: function handleChange(index, key, value) {
              return handleArrayFieldChange("employeeBankInfo", index, key, value);
            },
            addItem: function addItem() {
              return addArrayFieldItem("employeeBankInfo", {
                accountHolderName: "",
                bankName: "",
                accountNumber: "",
                branchName: ""
              });
            },
            removeItem: function removeItem(index) {
              return removeArrayFieldItem("employeeBankInfo", index);
            },
            expanded: expanded,
            setExpanded: setExpanded,
            errors: errors
          });
        default:
          return null;
      }
    }

    // 2️⃣ Normal flow (non-EIS)
    switch (activeStep) {
      case 0:
        return /*#__PURE__*/React.createElement(ApplicationReasonForDisability, {
          modulesManager: modulesManager,
          setDeathType: setDeathType,
          handleChange: function handleChange(key, value) {
            return _handleChange(key, value, "metadata");
          },
          deathType: deathType,
          errors: errors,
          formData: formData
        });
      case 1:
        return /*#__PURE__*/React.createElement(EmployeeDetailsForm, {
          handleChange: function handleChange(key, value) {
            return _handleChange(key, value, "workforceEmployee");
          },
          formData: formData,
          setNidOrBcn: setNidOrBcn,
          nidOrBcn: nidOrBcn,
          errors: errors
        });
      case 2:
        return /*#__PURE__*/React.createElement(EmployeeLocationForm, {
          handleChange: function handleChange(key, value) {
            return _handleChange(key, value, "workforceEmployee");
          },
          formData: formData
        });
      case 4:
        return /*#__PURE__*/React.createElement(EmployeeAccountInfoForm, {
          accounts: formData.employeeBankInfo,
          formdata: formData,
          handleChange: function handleChange(index, key, value) {
            return handleArrayFieldChange("employeeBankInfo", index, key, value);
          },
          addItem: function addItem() {
            return addArrayFieldItem("employeeBankInfo", {
              accountHolderName: "",
              bankName: "",
              accountNumber: "",
              branchName: ""
            });
          },
          removeItem: function removeItem(index) {
            return removeArrayFieldItem("employeeBankInfo", index);
          },
          expanded: expanded,
          setExpanded: setExpanded,
          errors: errors
        });
      case 3:
        return /*#__PURE__*/React.createElement(EmployeeAccidentInfoForm, {
          handleChange: function handleChange(key, value) {
            return _handleChange(key, value, "employeeAccidentInfo");
          },
          formData: formData,
          setFormData: setFormData,
          applicationType: "disabilityAssistance",
          errors: errors
        });
      default:
        return null;
    }
  }()), /*#__PURE__*/React.createElement(Box$1, null, ((formData === null || formData === void 0 ? void 0 : formData.organizationType) !== "eis" && activeStep === steps.length - 1 || (formData === null || formData === void 0 ? void 0 : formData.organizationType) === "eis" && activeStep === eisSteps.length - 1) && /*#__PURE__*/React.createElement(Box$1, null, /*#__PURE__*/React.createElement(FormControlLabel, {
    control: /*#__PURE__*/React.createElement(Checkbox, {
      checked: acknowledged,
      onChange: function onChange(e) {
        return setAcknowledged(e.target.checked);
      },
      style: {
        color: "blue"
      }
    }),
    label: /*#__PURE__*/React.createElement(Typography, {
      variant: "body2"
    }, /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.application.acknowledgement.text",
      module: "workforce"
    }))
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.buttonContainer
  }, activeStep > 0 && /*#__PURE__*/React.createElement(Button, {
    onClick: handleBack,
    variant: "outlined"
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.back"
  })), (formData === null || formData === void 0 ? void 0 : formData.organizationType) !== "eis" && activeStep < steps.length - 1 || (formData === null || formData === void 0 ? void 0 : formData.organizationType) === "eis" && activeStep < eisSteps.length - 1 ? /*#__PURE__*/React.createElement(Button, {
    variant: "contained",
    color: "primary",
    onClick: handleNext
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.save.next"
  })) :
  /*#__PURE__*/
  // 👇 Cleaned up Submit Button for ALL cases
  React.createElement(Button, {
    variant: "contained",
    color: "primary",
    disabled: !acknowledged,
    onClick: /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
      var isSuccess;
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return handleNext();
          case 2:
            isSuccess = _context4.sent;
            if (isSuccess) {
              setShowPreview(true);
            }
          case 4:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }))
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.submit"
  }))))), /*#__PURE__*/React.createElement(CustomSnackbar, {
    open: showErrorSnackbar // Use the new state
    ,
    onClose: function onClose() {
      return setShowErrorSnackbar(false);
    } // Allow it to close
    ,
    type: "error",
    message: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "core.error.generel",
      module: "workforce"
    }),
    duration: 4000
  }));
};

makeStyles(function (theme) {
  return {
    container: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center"
    },
    paper: {
      padding: theme.spacing(2)
    },
    buttonContainer: {
      marginTop: theme.spacing(2),
      display: "flex",
      justifyContent: "space-between"
    }
  };
});

function ownKeys$V(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$V(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$V(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$V(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var useStyles$19 = makeStyles(function (theme) {
  return {
    container: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center"
    },
    paper: {
      padding: theme.spacing(2)
    },
    item: {
      marginTop: theme.spacing(1)
    }
  };
});
var PreviousGrantInfoForm = function PreviousGrantInfoForm(_ref) {
  var _formData$metadata, _formData$metadata2, _formData$metadata3;
  var handleChange = _ref.handleChange,
    formData = _ref.formData,
    setFormData = _ref.setFormData,
    errors = _ref.errors;
  var classes = useStyles$19();
  var dispatch = useDispatch();
  var modulesManager = useModulesManager();
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2);
    _useState2[0];
    var setPreviousApplicationData = _useState2[1];
  useEffect(function () {
    var _formData$workforceEm;
    dispatch(fetchApplication(modulesManager, ["workforceEmployee_Nid: \"".concat(formData === null || formData === void 0 || (_formData$workforceEm = formData.workforceEmployee) === null || _formData$workforceEm === void 0 ? void 0 : _formData$workforceEm.nid, "\",application_Status:\"approved_by_director\"")])).then(function (res) {
      var _res$payload;
      var response = parseData(res === null || res === void 0 || (_res$payload = res.payload) === null || _res$payload === void 0 || (_res$payload = _res$payload.data) === null || _res$payload === void 0 ? void 0 : _res$payload.workforceApplication);
      var firstItem = response === null || response === void 0 ? void 0 : response[0];
      if (firstItem) {
        setPreviousApplicationData([firstItem]);
        firstItem.metadata || firstItem;
        setFormData(function (prev) {
          var _firstItem$workforceA;
          return _objectSpread$V(_objectSpread$V({}, prev), {}, {
            metadata: _objectSpread$V(_objectSpread$V({}, prev === null || prev === void 0 ? void 0 : prev.metadata), {}, {
              dateofReceipt: (firstItem === null || firstItem === void 0 || (_firstItem$workforceA = firstItem.workforceApplicationMovements) === null || _firstItem$workforceA === void 0 || (_firstItem$workforceA = _firstItem$workforceA.find(function (item) {
                return (item === null || item === void 0 ? void 0 : item.status) === "approved_by_director";
              })) === null || _firstItem$workforceA === void 0 || (_firstItem$workforceA = _firstItem$workforceA.dateCreated) === null || _firstItem$workforceA === void 0 ? void 0 : _firstItem$workforceA.split("T")[0]) || "",
              grantAmount: firstItem.grantAmount || ""
              // reasonforReceipt: prefillData.reasonforReceipt || "",
            })
          });
        });
      } else {
        setPreviousApplicationData([]);
      }
    });
  }, []);
  return /*#__PURE__*/React.createElement(Box$1, {
    mt: 1
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 2
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(Paper, {
    className: classes.paper,
    elevation: 0
  }, /*#__PURE__*/React.createElement(Box$1, {
    mb: 4,
    textAlign: "center",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "workforce.application.header.previousGrant",
    module: "workforce"
  })), /*#__PURE__*/React.createElement(Grid, {
    container: true,
    className: classes.item,
    spacing: 2
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6,
    className: classes.item
  }, /*#__PURE__*/React.createElement(PublishedComponent, {
    pubRef: "workforce.DatePicker",
    label: "workforce.application.dateofReceipt",
    value: (formData === null || formData === void 0 || (_formData$metadata = formData.metadata) === null || _formData$metadata === void 0 ? void 0 : _formData$metadata.dateofReceipt) || "",
    onChange: function onChange(v) {
      return handleChange("dateofReceipt", v);
    },
    readOnly: false
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6,
    className: classes.item
  }, /*#__PURE__*/React.createElement(TextInput, {
    id: "grantAmount",
    label: "workforce.application.grantAmount",
    value: (formData === null || formData === void 0 || (_formData$metadata2 = formData.metadata) === null || _formData$metadata2 === void 0 ? void 0 : _formData$metadata2.grantAmount) || "",
    onChange: function onChange(v) {
      return handleChange("grantAmount", v);
    },
    readOnly: false,
    required: true,
    error: !!errors.grantAmount,
    helperText: errors.grantAmount
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    className: classes.item
  }, /*#__PURE__*/React.createElement(TextInput, {
    id: "reasonforReceipt",
    label: "workforce.application.reasonforReceipt",
    value: (formData === null || formData === void 0 || (_formData$metadata3 = formData.metadata) === null || _formData$metadata3 === void 0 ? void 0 : _formData$metadata3.reasonforReceipt) || "",
    onChange: function onChange(v) {
      return handleChange("reasonforReceipt", v);
    },
    readOnly: false,
    error: !!errors.reasonforReceipt,
    helperText: errors.reasonforReceipt
  }))), /*#__PURE__*/React.createElement(Divider, null)))));
};

makeStyles(function (theme) {
  return {
    container: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center"
    },
    paper: {
      padding: theme.spacing(2)
    },
    buttonContainer: {
      marginTop: theme.spacing(2),
      display: "flex",
      justifyContent: "space-between"
    }
  };
});

var BoardPicker = function BoardPicker(_ref) {
  _ref.modulesManager;
    var _onChange = _ref.onChange,
    readOnly = _ref.readOnly,
    required = _ref.required,
    _ref$withLabel = _ref.withLabel,
    withLabel = _ref$withLabel === void 0 ? true : _ref$withLabel,
    withPlaceholder = _ref.withPlaceholder,
    value = _ref.value,
    label = _ref.label,
    placeholder = _ref.placeholder,
    filterOptions = _ref.filterOptions,
    filterSelectedOptions = _ref.filterSelectedOptions;
    _ref.multiple;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2);
    _useState2[0];
    var setSearchString = _useState2[1];
  var _useTranslations = useTranslations("workforce"),
    formatMessage = _useTranslations.formatMessage;

  // Adjust the options to match the BOARDS format
  var BOARDS = ["workforce.application.educationInfo.boards.barisal", "workforce.application.educationInfo.boards.chattogram", "workforce.application.educationInfo.boards.cumilla", "workforce.application.educationInfo.boards.dhaka", "workforce.application.educationInfo.boards.rajshahi", "workforce.application.educationInfo.boards.dinajpur", "workforce.application.educationInfo.boards.sylhet", "workforce.application.educationInfo.boards.jashore", "workforce.application.educationInfo.boards.mymensingh", "workforce.application.educationInfo.boards.madrasha_board", "workforce.application.educationInfo.boards.technical_board", "workforce.application.educationInfo.boards.open_board"];

  // Find the selected option
  var selectedOption = useMemo(function () {
    return BOARDS.includes(value) ? value : null;
  }, [value]);
  return /*#__PURE__*/React.createElement(Autocomplete, {
    multiple: false,
    required: required,
    placeholder: placeholder !== null && placeholder !== void 0 ? placeholder : "",
    label: label !== null && label !== void 0 ? label : formatMessage("workforce.application.educationInfo.board"),
    withLabel: withLabel,
    withPlaceholder: withPlaceholder,
    readOnly: readOnly,
    isLoading: false // Set to false if not loading data dynamically
    ,
    options: BOARDS,
    value: selectedOption,
    getOptionLabel: function getOptionLabel(option) {
      return formatMessage(option);
    } // Since options are strings, return the string directly
    ,
    onChange: function onChange(option) {
      return _onChange(option, option !== null && option !== void 0 ? option : null);
    },
    filterOptions: filterOptions,
    filterSelectedOptions: filterSelectedOptions,
    onInputChange: setSearchString
  });
};

// Generate years from 2000 to current year
var currentYear = new Date().getFullYear();
var years = Array.from({
  length: currentYear - 1990 + 1
}, function (_, i) {
  return 1990 + i;
});
var YearPicker = function YearPicker(_ref) {
  var id = _ref.id,
    value = _ref.value,
    _onChange = _ref.onChange,
    label = _ref.label,
    _ref$required = _ref.required,
    required = _ref$required === void 0 ? false : _ref$required;
  return /*#__PURE__*/React.createElement(FormControl, {
    fullWidth: true,
    required: required
  }, /*#__PURE__*/React.createElement(InputLabel, null, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: label,
    module: "workforce"
  })), /*#__PURE__*/React.createElement(Select, {
    id: id,
    value: value || "",
    onChange: function onChange(e) {
      return _onChange(e.target.value);
    },
    inputProps: {
      id: id
    }
  }, years.map(function (year) {
    return /*#__PURE__*/React.createElement(MenuItem, {
      key: year,
      value: year
    }, year);
  })));
};

var useStyles$18 = makeStyles(function (theme) {
  return {
    title: {
      fontWeight: "bold"
    },
    paper: {
      padding: theme.spacing(2),
      width: "100%",
      maxWidth: 650,
      margin: "auto"
    },
    section: {
      marginTop: theme.spacing(3)
    },
    formSection: {
      marginLeft: theme.spacing(2)
    }
  };
});
var EducationInfoForm = function EducationInfoForm(_ref) {
  var _formData$employeeChi, _formData$employeeChi2, _formData$employeeChi3, _formData$employeeChi4, _formData$employeeChi5, _formData$employeeChi6, _formData$employeeChi7, _formData$employeeChi8, _formData$employeeChi9, _formData$employeeChi10, _formData$employeeChi11, _formData$employeeChi12;
  var modulesManager = _ref.modulesManager,
    handleChange = _ref.handleChange,
    formData = _ref.formData;
    _ref.applicationForSelf;
    var errors = _ref.errors;
  var _useTranslations = useTranslations("core.RegistrationPage", modulesManager);
    _useTranslations.formatMessage;
  var classes = useStyles$18();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FormControl, {
    component: "fieldset",
    className: classes.formSection
  }, /*#__PURE__*/React.createElement(Typography, {
    mb: 4,
    style: {
      color: "red",
      textAlign: "center",
      fontWeight: "bold",
      fontSize: "small",
      margin: "15px"
    }
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "workforce.application.header.blwf.education.note",
    module: "workforce"
  })), /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 2,
    className: classes.section
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6,
    className: classes.item
  }, /*#__PURE__*/React.createElement(TextInput, {
    id: "nameEn",
    label: "workforce.child.name.en",
    value: (formData === null || formData === void 0 || (_formData$employeeChi = formData.employeeChildrenInfo) === null || _formData$employeeChi === void 0 ? void 0 : _formData$employeeChi.nameEn) || "",
    formatInput: filterEnglish,
    onChange: function onChange(v) {
      return handleChange("nameEn", filterEnglish(v));
    },
    required: true,
    readOnly: false,
    error: !!errors.nameEn,
    helperText: errors.nameEn
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6,
    className: classes.item
  }, /*#__PURE__*/React.createElement(TextInput, {
    id: "nameBn",
    label: "workforce.child.name.bn",
    value: (formData === null || formData === void 0 || (_formData$employeeChi2 = formData.employeeChildrenInfo) === null || _formData$employeeChi2 === void 0 ? void 0 : _formData$employeeChi2.nameBn) || "",
    formatInput: filterBangla,
    onChange: function onChange(v) {
      return handleChange("nameBn", filterBangla(v));
    },
    required: true,
    readOnly: false,
    error: !!errors.nameBn,
    helperText: errors.nameBn
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6,
    className: classes.item
  }, /*#__PURE__*/React.createElement(TextInput, {
    id: "nid",
    label: "workforce.application.employee.children.nidOrBirthRegistry",
    value: (formData === null || formData === void 0 || (_formData$employeeChi3 = formData.employeeChildrenInfo) === null || _formData$employeeChi3 === void 0 ? void 0 : _formData$employeeChi3.nid) || "",
    onChange: function onChange(v) {
      return handleChange("nid", v);
    },
    type: "number",
    readOnly: false,
    required: true,
    error: !!errors.nid,
    helperText: errors.nid
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6,
    className: classes.item
  }, /*#__PURE__*/React.createElement(PublishedComponent, {
    pubRef: "workforce.DatePicker",
    label: "workforce.employee.birthdate",
    value: (formData === null || formData === void 0 || (_formData$employeeChi4 = formData.employeeChildrenInfo) === null || _formData$employeeChi4 === void 0 ? void 0 : _formData$employeeChi4.birthDate) || "",
    onChange: function onChange(v) {
      return handleChange("birthDate", v);
    },
    readOnly: false
    // required
  }))), /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 2,
    className: classes.section
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement(TextInput, {
    id: "university",
    label: "workforce.application.educationInfo.university",
    value: (formData === null || formData === void 0 || (_formData$employeeChi5 = formData.employeeChildrenInfo) === null || _formData$employeeChi5 === void 0 ? void 0 : _formData$employeeChi5.university) || "",
    onChange: function onChange(v) {
      return handleChange("university", v);
    },
    type: "text",
    required: true,
    error: !!errors.university,
    helperText: errors.university,
    readOnly: false
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement(YearPicker, {
    id: "admissionYear",
    label: "workforce.application.educationInfo.admissionYear",
    value: (formData === null || formData === void 0 || (_formData$employeeChi6 = formData.employeeChildrenInfo) === null || _formData$employeeChi6 === void 0 ? void 0 : _formData$employeeChi6.admissionYear) || "",
    onChange: function onChange(v) {
      return handleChange("admissionYear", v);
    },
    required: true
  }), errors.admissionYear && /*#__PURE__*/React.createElement(FormHelperText, {
    error: true
  }, errors.admissionYear)), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement(TextInput, {
    id: "idNo",
    label: "workforce.application.educationInfo.IdNo",
    value: (formData === null || formData === void 0 || (_formData$employeeChi7 = formData.employeeChildrenInfo) === null || _formData$employeeChi7 === void 0 ? void 0 : _formData$employeeChi7.idNo) || "",
    onChange: function onChange(v) {
      return handleChange("idNo", v);
    },
    type: "number",
    required: true,
    error: !!errors.idNo,
    helperText: errors.idNo,
    readOnly: false
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement(TextInput, {
    id: "regNo",
    label: "workforce.application.educationInfo.regNo",
    value: (formData === null || formData === void 0 || (_formData$employeeChi8 = formData.employeeChildrenInfo) === null || _formData$employeeChi8 === void 0 ? void 0 : _formData$employeeChi8.regNo) || "",
    onChange: function onChange(v) {
      return handleChange("regNo", v);
    },
    type: "number",
    required: true,
    error: !!errors.regNo,
    helperText: errors.regNo,
    readOnly: false
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6,
    className: classes.item
  }, /*#__PURE__*/React.createElement(TextInput, {
    id: "studyingClass",
    label: "workforce.application.employee.children.studyingSemester",
    value: (formData === null || formData === void 0 || (_formData$employeeChi9 = formData.employeeChildrenInfo) === null || _formData$employeeChi9 === void 0 ? void 0 : _formData$employeeChi9.studyingClass) || "",
    onChange: function onChange(v) {
      return handleChange("studyingClass", v);
    },
    readOnly: false,
    required: (formData === null || formData === void 0 || (_formData$employeeChi10 = formData.employeeChildrenInfo) === null || _formData$employeeChi10 === void 0 ? void 0 : _formData$employeeChi10.educationGrantFor) === "underGraduate" || (formData === null || formData === void 0 || (_formData$employeeChi11 = formData.employeeChildrenInfo) === null || _formData$employeeChi11 === void 0 ? void 0 : _formData$employeeChi11.educationGrantFor) === "postGraduate" ? true : false,
    error: !!errors.studyingClass,
    helperText: errors.studyingClass
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement(TextInput, {
    id: "cgpa",
    label: "workforce.application.educationInfo.cgpa",
    value: (formData === null || formData === void 0 || (_formData$employeeChi12 = formData.employeeChildrenInfo) === null || _formData$employeeChi12 === void 0 ? void 0 : _formData$employeeChi12.cgpa) || "",
    onChange: function onChange(v) {
      return handleChange("cgpa", v);
    }
    // type="text"
    ,
    required: true,
    error: !!errors.cgpa,
    helperText: errors.cgpa,
    readOnly: false
  })))), /*#__PURE__*/React.createElement(EmployeeDetailsForm2, {
    handleChange: handleChange,
    formData: formData,
    selectedApplicationType: formData.applicationType,
    formStepNo: "educations",
    errors: errors
  }));
};

function ownKeys$U(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$U(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$U(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$U(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var useStyles$17 = makeStyles(function (theme) {
  return {
    container: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center"
    },
    paper: {
      padding: theme.spacing(1),
      width: 700
    },
    buttonContainer: {
      marginTop: theme.spacing(2),
      display: "flex",
      justifyContent: "flex-end",
      gap: theme.spacing(1)
    },
    overrides: {
      MuiStepper: {
        root: {
          backgroundColor: "transparent",
          // override MuiStepper-root globally
          padding: "16px"
        }
      }
    }
  };
});
var EducationGrantForm = function EducationGrantForm(_ref) {
  var _formData$workforceEm, _formData$workforceEm2;
  var workforceFactoryId = _ref.workforceFactoryId,
    organizationType = _ref.organizationType,
    selectedApplicationType = _ref.selectedApplicationType,
    applicationForSelf = _ref.applicationForSelf,
    parsedApplicationData = _ref.parsedApplicationData,
    selectedFactory = _ref.selectedFactory;
  var employeeData = useSelector(function (state) {
    return state.workforce["workforceEmployee"];
  });
  var modulesManager = useModulesManager();
  var _useTranslations = useTranslations("workforce"),
    formatMessage = _useTranslations.formatMessage;
  var stepRef = useRef(null);
  var _useState = useState({}),
    _useState2 = _slicedToArray(_useState, 2),
    errors = _useState2[0],
    setErrors = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    acknowledged = _useState4[0],
    setAcknowledged = _useState4[1];
  var applicationId = useSelector(function (state) {
    var _state$workforce$fetc;
    return (_state$workforce$fetc = state.workforce["fetchedApplicationIdByClientMutationId"]) !== null && _state$workforce$fetc !== void 0 ? _state$workforce$fetc : [];
  });
  var classes = useStyles$17();
  var dispatch = useDispatch();
  var _useState5 = useState(0),
    _useState6 = _slicedToArray(_useState5, 2),
    activeStep = _useState6[0],
    setActiveStep = _useState6[1];
  var _useState7 = useState(0),
    _useState8 = _slicedToArray(_useState7, 2),
    expanded = _useState8[0],
    setExpanded = _useState8[1];
  var _useState9 = useState(false),
    _useState10 = _slicedToArray(_useState9, 2),
    isSubmitted = _useState10[0],
    setIsSubmitted = _useState10[1];
  var _useState11 = useState(false),
    _useState12 = _slicedToArray(_useState11, 2),
    showVerifyNid = _useState12[0],
    setShowVerifyNid = _useState12[1];
  var _useState13 = useState(false),
    _useState14 = _slicedToArray(_useState13, 2),
    showErrorSnackbar = _useState14[0],
    setShowErrorSnackbar = _useState14[1];
  var _useState15 = useState(false),
    _useState16 = _slicedToArray(_useState15, 2),
    showPreview = _useState16[0],
    setShowPreview = _useState16[1];
  var _useState17 = useState(false),
    _useState18 = _slicedToArray(_useState17, 2);
    _useState18[0];
    var setDisableConfirmSubmit = _useState18[1];
  var _useState19 = useState({
      nid: (formData === null || formData === void 0 || (_formData$workforceEm = formData.workforceEmployee) === null || _formData$workforceEm === void 0 ? void 0 : _formData$workforceEm.nid) || "",
      birthCertificateNo: formData === null || formData === void 0 || (_formData$workforceEm2 = formData.workforceEmployee) === null || _formData$workforceEm2 === void 0 ? void 0 : _formData$workforceEm2.birthCertificateNo
    }),
    _useState20 = _slicedToArray(_useState19, 2),
    nidOrBcn = _useState20[0];
    _useState20[1];
  var uploadFile = useSelector(function (state) {
    return state.workforce.uploadFile;
  });
  var uploadBankFile = useSelector(function (state) {
    return state.workforce.uploadBankFile;
  });
  var documentType = useSelector(function (state) {
    return state.workforce.documentType;
  });
  var user_type = getUserType();
  var reduxState = useSelector(function (state) {
    return state;
  });
  var _useState21 = useState({
      workforceEmployee: {
        nameEn: "",
        nameBn: "",
        lastNameEn: "",
        position: "",
        fatherNameEn: "",
        fatherNameBn: "",
        motherNameEn: "",
        motherNameBn: "",
        spouseNameEn: "",
        spouseNameBn: "",
        phoneNumber: "",
        email: "",
        birthDate: "",
        deathDate: "",
        joinDate: "",
        nid: "",
        birthCertificateNo: "",
        insuranceNumber: "",
        lifeStatus: "",
        gender: "",
        maritalStatus: "",
        monthlyEarning: "",
        uploadedNidFile: [],
        citizenship: "",
        uploadedBirthCertificateFile: [],
        permanentAddress: "",
        permanentLocation: "",
        presentLocation: "",
        presentAddress: "",
        organizationId: ""
      },
      employeeChildrenInfo: {},
      previousGrantInfo: {
        dateofReceipt: "",
        grantAmount: "",
        reasonforReceipt: ""
      },
      otherInfo: "",
      company: null,
      factory: selectedFactory || null,
      workforceFactoryId: workforceFactoryId || "",
      isSubmitted: "no",
      organizationType: "",
      applicationType: "",
      applicationForSelf: applicationForSelf,
      employeeBankInfo: [{}],
      id: ""
    }),
    _useState22 = _slicedToArray(_useState21, 2),
    formData = _useState22[0],
    setFormData = _useState22[1];

  // Fetch employee data based on username
  var fetchEmployeeWithUser = function fetchEmployeeWithUser() {
    dispatch(fetchWorkforceEmployee(modulesManager, ["relatedUser_LoginName_Iexact: \"".concat(reduxState.core.user.username, "\"")]));
  };
  useEffect(function () {
    if (reduxState.core.user.username) {
      fetchEmployeeWithUser();
    }
  }, [reduxState.core.user.username]);
  useEffect(function () {
    var _formData$workforceEm3;
    if (!(employeeData !== null && employeeData !== void 0 && employeeData.id)) return;
    // When employeeData is fetched, set it into the form state
    setFormData({
      id: (parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.id) || "",
      workforceEmployee: {
        id: (employeeData === null || employeeData === void 0 ? void 0 : employeeData.id) || reduxState.core.user.id || "",
        organization: employeeData.organization,
        nameEn: employeeData.firstNameEn || "",
        nameBn: employeeData.firstNameBn || "",
        lastNameEn: " ",
        position: employeeData.position || "",
        fatherNameEn: employeeData.fatherNameEn || "",
        fatherNameBn: employeeData.fatherNameBn || "",
        motherNameEn: employeeData.motherNameEn || "",
        motherNameBn: employeeData.motherNameBn || "",
        spouseNameEn: employeeData.spouseNameEn || "",
        spouseNameBn: employeeData.spouseNameBn || "",
        phoneNumber: employeeData.phoneNumber || "",
        email: employeeData.email || "",
        citizenship: employeeData.citizenship || "",
        birthDate: employeeData.birthDate || "",
        deathDate: employeeData.deathDate || "",
        joinDate: employeeData.joinDate || "",
        nid: employeeData.nid || "",
        birthCertificateNo: employeeData.birthCertificateNo || "",
        insuranceNumber: employeeData.insuranceNumber || "",
        lifeStatus: employeeData.lifeStatus || "",
        gender: employeeData.gender || "",
        maritalStatus: employeeData.maritalStatus || "",
        monthlyEarning: employeeData.monthlyEarning || "",
        uploadedNidFile: employeeData.uploadedNidFile || [],
        uploadedBirthCertificateFile: employeeData.uploadedBirthCertificateFile || [],
        permanentAddress: employeeData.permanentAddress || "",
        permanentLocation: employeeData.permanentLocation || "",
        presentLocation: employeeData.presentLocation || "",
        presentAddress: employeeData.presentAddress || ""
      },
      company: employeeData.company || null,
      factory: employeeData.factory || (formData === null || formData === void 0 || (_formData$workforceEm3 = formData.workforceEmployee) === null || _formData$workforceEm3 === void 0 || (_formData$workforceEm3 = _formData$workforceEm3.factory) === null || _formData$workforceEm3 === void 0 ? void 0 : _formData$workforceEm3.id) || (parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.employeeFactory) || workforceFactoryId || selectedFactory || null,
      applicationForSelf: applicationForSelf,
      workforceFactoryId: workforceFactoryId || "",
      organizationType: (parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.organizationType) || organizationType,
      applicationType: (parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.applicationType) || selectedApplicationType,
      employeeBankInfo: (parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.employeeBankInfo) || (employeeData === null || employeeData === void 0 ? void 0 : employeeData.employeeBankInfo) || [{}],
      employeeAccidentInfo: (parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.employeeAccidentInfo) || (employeeData === null || employeeData === void 0 ? void 0 : employeeData.employeeAccidentInfo) || {},
      employeeChildrenInfo: (parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.employeeChildrenInfo) || employeeData.employeeChildrenInfo || {},
      previousGrantInfo: employeeData.previousGrantInfo || {},
      otherInfo: employeeData.otherInfo || {}
    });
    // }
  }, [employeeData === null || employeeData === void 0 ? void 0 : employeeData.id, parsedApplicationData, user_type]); // Trigger this useEffect when `employeeData` changes.

  // Handle form input changes
  var _handleChange = function handleChange(key, value) {
    var parent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    setFormData(function (prev) {
      if (parent) {
        return _objectSpread$U(_objectSpread$U({}, prev), {}, _defineProperty({}, parent, _objectSpread$U(_objectSpread$U({}, prev[parent]), {}, _defineProperty({}, key, value))));
      }
      return _objectSpread$U(_objectSpread$U({}, prev), {}, _defineProperty({}, key, value));
    });
  };
  var handleNext = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var newErrors, isBankStep, isChildStep, isDetailsStep, isDocumentStep, documentValidation, BANK_DOC, bankDocsConfig, generalDocsConfig, hasErrors, _formData$workforceEm4, nextStep, fakeErrors, _formData$workforceEm5, _formData$workforceEm6, _formData$workforceEm7, _formData$workforceEm8, _formData$workforceEm9, _formData$workforceEm10, _formData$workforceEm11, _formData$workforceEm12, _formData$workforceEm13, _formData$workforceEm14, _formData$workforceEm15, _formData$workforceEm16, _formData$workforceEm17, _formData$workforceEm18, _formData$workforceEm19, _formData$workforceEm20, _formData$workforceEm21, _formData$workforceEm22, _formData$workforceEm23, _formData$workforceEm24, _formData$workforceEm25, _formData$workforceEm26, _formData$workforceEm27, workforceEmployeeData, _formData$workforceEm28, _parsedApplicationDat, _formData$workforceEm29, _formData$factory, _formData$factory2, createApplicationData, _formData$employeeChi, _formData$employeeChi2, _formData$employeeChi3, _formData$employeeChi4, _formData$employeeChi5, _formData$employeeChi6, _formData$employeeChi7, _formData$employeeChi8, _formData$employeeChi9, _formData$employeeChi10, _formData$employeeChi11, _formData$employeeChi12, _formData$employeeChi13, applicationMutation, applicationClientMutationId, fetchRes, applicationgetId, createEducation, updateApplicationData, _parsedApplicationDat2, _formData$workforceEm30, _formData$factory3, _formData$factory4, _updateApplicationData;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            console.log({
              formData: formData
            });
            newErrors = validateRequiredFields(stepRef, formatMessage, formData);
            newErrors === null || newErrors === void 0 || delete newErrors.documents;
            isBankStep = activeStep === 5;
            isChildStep = activeStep === 3;
            isDetailsStep = activeStep === 0;
            isDocumentStep = isDetailsStep || isChildStep || isBankStep;
            documentValidation = {
              isValid: true,
              errors: null
            };
            BANK_DOC = "applicants bank check copy";
            if (isBankStep) {
              bankDocsConfig = (documentType || []).filter(function (doc) {
                return doc.documentType === BANK_DOC;
              });
              documentValidation = validateMandatoryBankDocumentsForAccounts(bankDocsConfig, uploadBankFile || [], formData.employeeBankInfo || []);
            } else if (isDetailsStep || isChildStep) {
              // Validate general documents (exclude bank docs)
              generalDocsConfig = (documentType || []).filter(function (doc) {
                return doc.documentType !== BANK_DOC;
              });
              documentValidation = validateMandatoryDocuments(generalDocsConfig, uploadFile || []);
            }
            if (isDocumentStep && !documentValidation.isValid) {
              newErrors.documents = documentValidation.errors;
            }
            hasErrors = Object.keys(newErrors).length > 0;
            setShowErrorSnackbar(hasErrors);
            console.log({
              newErrors: newErrors
            });
            console.log({
              documentValidation: documentValidation
            });
            setErrors(newErrors);
            if (!(Object.keys(newErrors).length === 0)) {
              _context.next = 62;
              break;
            }
            nextStep = activeStep + 1;
            if (!(nextStep === 1 && !isAtLeast18YearsOld(formData === null || formData === void 0 || (_formData$workforceEm4 = formData.workforceEmployee) === null || _formData$workforceEm4 === void 0 ? void 0 : _formData$workforceEm4.birthDate))) {
              _context.next = 25;
              break;
            }
            fakeErrors = _objectSpread$U(_objectSpread$U({}, newErrors), {}, {
              rdmp: "core.error.workerAge"
            });
            setErrors(fakeErrors);
            console.log({
              fakeErrors: fakeErrors
            });
            return _context.abrupt("return", false);
          case 25:
            if (nextStep < steps.length) {
              setActiveStep(nextStep);
            }
            if (!(nextStep === 1 || nextStep === 2)) {
              _context.next = 33;
              break;
            }
            workforceEmployeeData = {
              nameEn: formData === null || formData === void 0 || (_formData$workforceEm5 = formData.workforceEmployee) === null || _formData$workforceEm5 === void 0 ? void 0 : _formData$workforceEm5.nameEn,
              nameBn: formData === null || formData === void 0 || (_formData$workforceEm6 = formData.workforceEmployee) === null || _formData$workforceEm6 === void 0 ? void 0 : _formData$workforceEm6.nameBn,
              lastNameEn: "",
              phoneNumber: formData === null || formData === void 0 || (_formData$workforceEm7 = formData.workforceEmployee) === null || _formData$workforceEm7 === void 0 ? void 0 : _formData$workforceEm7.phoneNumber,
              email: formData === null || formData === void 0 || (_formData$workforceEm8 = formData.workforceEmployee) === null || _formData$workforceEm8 === void 0 ? void 0 : _formData$workforceEm8.email,
              gender: formData === null || formData === void 0 || (_formData$workforceEm9 = formData.workforceEmployee) === null || _formData$workforceEm9 === void 0 || (_formData$workforceEm9 = _formData$workforceEm9.gender) === null || _formData$workforceEm9 === void 0 ? void 0 : _formData$workforceEm9.name,
              birthDate: formData === null || formData === void 0 || (_formData$workforceEm10 = formData.workforceEmployee) === null || _formData$workforceEm10 === void 0 ? void 0 : _formData$workforceEm10.birthDate,
              deathDate: formData === null || formData === void 0 || (_formData$workforceEm11 = formData.workforceEmployee) === null || _formData$workforceEm11 === void 0 ? void 0 : _formData$workforceEm11.deathDate,
              lifeStatus: formData === null || formData === void 0 || (_formData$workforceEm12 = formData.workforceEmployee) === null || _formData$workforceEm12 === void 0 ? void 0 : _formData$workforceEm12.lifeStatus,
              permanentAddress: formData === null || formData === void 0 || (_formData$workforceEm13 = formData.workforceEmployee) === null || _formData$workforceEm13 === void 0 ? void 0 : _formData$workforceEm13.permanentAddress,
              presentAddress: formData === null || formData === void 0 || (_formData$workforceEm14 = formData.workforceEmployee) === null || _formData$workforceEm14 === void 0 ? void 0 : _formData$workforceEm14.presentAddress,
              position: formData === null || formData === void 0 || (_formData$workforceEm15 = formData.workforceEmployee) === null || _formData$workforceEm15 === void 0 ? void 0 : _formData$workforceEm15.position,
              monthlyEarning: formData === null || formData === void 0 || (_formData$workforceEm16 = formData.workforceEmployee) === null || _formData$workforceEm16 === void 0 ? void 0 : _formData$workforceEm16.monthlyEarning,
              insuranceNumber: " ",
              fatherNameBn: formData === null || formData === void 0 || (_formData$workforceEm17 = formData.workforceEmployee) === null || _formData$workforceEm17 === void 0 ? void 0 : _formData$workforceEm17.fatherNameBn,
              fatherNameEn: formData === null || formData === void 0 || (_formData$workforceEm18 = formData.workforceEmployee) === null || _formData$workforceEm18 === void 0 ? void 0 : _formData$workforceEm18.fatherNameEn,
              motherNameBn: formData === null || formData === void 0 || (_formData$workforceEm19 = formData.workforceEmployee) === null || _formData$workforceEm19 === void 0 ? void 0 : _formData$workforceEm19.motherNameBn,
              motherNameEn: formData === null || formData === void 0 || (_formData$workforceEm20 = formData.workforceEmployee) === null || _formData$workforceEm20 === void 0 ? void 0 : _formData$workforceEm20.motherNameEn,
              spouseNameBn: formData === null || formData === void 0 || (_formData$workforceEm21 = formData.workforceEmployee) === null || _formData$workforceEm21 === void 0 ? void 0 : _formData$workforceEm21.spouseNameBn,
              spouseNameEn: formData === null || formData === void 0 || (_formData$workforceEm22 = formData.workforceEmployee) === null || _formData$workforceEm22 === void 0 ? void 0 : _formData$workforceEm22.spouseNameEn,
              citizenship: formData === null || formData === void 0 || (_formData$workforceEm23 = formData.workforceEmployee) === null || _formData$workforceEm23 === void 0 ? void 0 : _formData$workforceEm23.citizenship,
              maritalStatus: formData === null || formData === void 0 || (_formData$workforceEm24 = formData.workforceEmployee) === null || _formData$workforceEm24 === void 0 ? void 0 : _formData$workforceEm24.maritalStatus,
              presentLocation: formData === null || formData === void 0 || (_formData$workforceEm25 = formData.workforceEmployee) === null || _formData$workforceEm25 === void 0 ? void 0 : _formData$workforceEm25.presentLocation,
              permanentLocation: formData === null || formData === void 0 || (_formData$workforceEm26 = formData.workforceEmployee) === null || _formData$workforceEm26 === void 0 ? void 0 : _formData$workforceEm26.permanentLocation,
              id: (formData === null || formData === void 0 || (_formData$workforceEm27 = formData.workforceEmployee) === null || _formData$workforceEm27 === void 0 ? void 0 : _formData$workforceEm27.id) || reduxState.core.user.id
            };
            console.log("Update Submitting formData:", formData);
            _context.next = 31;
            return dispatch(updateWorkforceEmployee(workforceEmployeeData, "Update Workforce Employee ".concat(workforceEmployeeData.nameEn)));
          case 31:
            _context.next = 61;
            break;
          case 33:
            if (!(nextStep === 4)) {
              _context.next = 59;
              break;
            }
            createApplicationData = {
              workforceEmployeeId: (formData === null || formData === void 0 || (_formData$workforceEm28 = formData.workforceEmployee) === null || _formData$workforceEm28 === void 0 ? void 0 : _formData$workforceEm28.id) || (parsedApplicationData === null || parsedApplicationData === void 0 || (_parsedApplicationDat = parsedApplicationData.workforceEmployee) === null || _parsedApplicationDat === void 0 ? void 0 : _parsedApplicationDat.id),
              organizationType: formData.organizationType,
              applicationType: formData.applicationType,
              company: formData === null || formData === void 0 || (_formData$workforceEm29 = formData.workforceEmployee) === null || _formData$workforceEm29 === void 0 || (_formData$workforceEm29 = _formData$workforceEm29.company) === null || _formData$workforceEm29 === void 0 ? void 0 : _formData$workforceEm29.id,
              factory: formData !== null && formData !== void 0 && (_formData$factory = formData.factory) !== null && _formData$factory !== void 0 && _formData$factory.id ? safeDecodeId(formData === null || formData === void 0 || (_formData$factory2 = formData.factory) === null || _formData$factory2 === void 0 ? void 0 : _formData$factory2.id) : null,
              employeeDesignationInfo: JSON.stringify(formData.employeeDesignationInfo),
              employeeBankInfo: JSON.stringify(formData.employeeBankInfo),
              employeeChildrenInfo: JSON.stringify(formData.employeeChildrenInfo),
              institutionInfo: JSON.stringify(formData.institutionInfo),
              metadata: JSON.stringify(formData.metadata),
              status: WORKFORCE_STATUS$1.DRAFT,
              applicationFor: applicationForSelf === "yes" ? "self" : applicationForSelf === "" ? "" : "dependent"
            };
            if (parsedApplicationData) {
              _context.next = 54;
              break;
            }
            _context.next = 38;
            return formatMutation("createWorkforceApplication", formatApplicationeGQL(createApplicationData), "Created application ".concat(formData.workforceEmployee.nameEn));
          case 38:
            applicationMutation = _context.sent;
            applicationClientMutationId = applicationMutation.clientMutationId;
            console.log("applicationClientMutationId", applicationClientMutationId);
            _context.next = 43;
            return dispatch(createApplication(applicationMutation, "Created workforce application ".concat(formData.firstNameEn)));
          case 43:
            _context.next = 45;
            return dispatch(fetchInfoIdByClientMutationId(modulesManager, "workforceApplication", applicationClientMutationId, "WORKFORCE_APPLICATION_BY_CLIENT_MUTATION_ID"));
          case 45:
            fetchRes = _context.sent;
            applicationgetId = getInfoId(fetchRes, "workforceApplication");
            console.log("hello there", applicationgetId);
            if (!applicationgetId && applicationId) {
              applicationgetId = applicationId;
            }
            createEducation = {
              applicationId: applicationgetId,
              educationLevel: formData === null || formData === void 0 || (_formData$employeeChi = formData.employeeChildrenInfo) === null || _formData$employeeChi === void 0 ? void 0 : _formData$employeeChi.scholarshipFor,
              educationBoard: formData === null || formData === void 0 || (_formData$employeeChi2 = formData.employeeChildrenInfo) === null || _formData$employeeChi2 === void 0 ? void 0 : _formData$employeeChi2.board,
              admissionYear: formData === null || formData === void 0 || (_formData$employeeChi3 = formData.employeeChildrenInfo) === null || _formData$employeeChi3 === void 0 ? void 0 : _formData$employeeChi3.admissionYear,
              IdNumber: formData === null || formData === void 0 || (_formData$employeeChi4 = formData.employeeChildrenInfo) === null || _formData$employeeChi4 === void 0 ? void 0 : _formData$employeeChi4.idNo,
              registrationNumber: formData === null || formData === void 0 || (_formData$employeeChi5 = formData.employeeChildrenInfo) === null || _formData$employeeChi5 === void 0 ? void 0 : _formData$employeeChi5.regNo,
              result: formData === null || formData === void 0 || (_formData$employeeChi6 = formData.employeeChildrenInfo) === null || _formData$employeeChi6 === void 0 ? void 0 : _formData$employeeChi6.cgpa,
              institution: formData === null || formData === void 0 || (_formData$employeeChi7 = formData.employeeChildrenInfo) === null || _formData$employeeChi7 === void 0 ? void 0 : _formData$employeeChi7.university,
              childBirthDate: formData === null || formData === void 0 || (_formData$employeeChi8 = formData.employeeChildrenInfo) === null || _formData$employeeChi8 === void 0 ? void 0 : _formData$employeeChi8.birthDate,
              childNameEn: formData === null || formData === void 0 || (_formData$employeeChi9 = formData.employeeChildrenInfo) === null || _formData$employeeChi9 === void 0 ? void 0 : _formData$employeeChi9.nameEn,
              childNameBn: formData === null || formData === void 0 || (_formData$employeeChi10 = formData.employeeChildrenInfo) === null || _formData$employeeChi10 === void 0 ? void 0 : _formData$employeeChi10.nameBn,
              childNidNo: formData === null || formData === void 0 || (_formData$employeeChi11 = formData.employeeChildrenInfo) === null || _formData$employeeChi11 === void 0 ? void 0 : _formData$employeeChi11.nid,
              childBirthCertificateNo: formData === null || formData === void 0 || (_formData$employeeChi12 = formData.employeeChildrenInfo) === null || _formData$employeeChi12 === void 0 ? void 0 : _formData$employeeChi12.nid,
              studyClass: formData === null || formData === void 0 || (_formData$employeeChi13 = formData.employeeChildrenInfo) === null || _formData$employeeChi13 === void 0 ? void 0 : _formData$employeeChi13.studyingClass
            };
            _context.next = 52;
            return dispatch(createEducationInfo(createEducation, "Created workforce education Info"));
          case 52:
            _context.next = 57;
            break;
          case 54:
            updateApplicationData = _objectSpread$U({
              id: parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.id
            }, createApplicationData);
            console.log("i am from update", updateApplicationData);
            dispatch(updateApplication(updateApplicationData, "update workforce application ".concat(formData.firstNameEn)));
          case 57:
            _context.next = 61;
            break;
          case 59:
            _updateApplicationData = {
              id: safeApplicationId(applicationId, parsedApplicationData),
              workforceEmployeeId: (formData === null || formData === void 0 ? void 0 : formData.workforceEmployee.id) || (parsedApplicationData === null || parsedApplicationData === void 0 || (_parsedApplicationDat2 = parsedApplicationData.workforceEmployee) === null || _parsedApplicationDat2 === void 0 ? void 0 : _parsedApplicationDat2.id),
              company: formData === null || formData === void 0 || (_formData$workforceEm30 = formData.workforceEmployee) === null || _formData$workforceEm30 === void 0 || (_formData$workforceEm30 = _formData$workforceEm30.company) === null || _formData$workforceEm30 === void 0 ? void 0 : _formData$workforceEm30.id,
              factory: formData !== null && formData !== void 0 && (_formData$factory3 = formData.factory) !== null && _formData$factory3 !== void 0 && _formData$factory3.id ? safeDecodeId(formData === null || formData === void 0 || (_formData$factory4 = formData.factory) === null || _formData$factory4 === void 0 ? void 0 : _formData$factory4.id) : null,
              organizationType: organizationType || (parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.organizationType),
              applicationType: selectedApplicationType || (parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.applicationType),
              institutionInfo: JSON.stringify(formData.institutionInfo),
              employeeBankInfo: JSON.stringify(formData.employeeBankInfo) || JSON.stringify(parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.employeeBankInfo),
              employeeChildrenInfo: JSON.stringify(formData.employeeChildrenInfo) || JSON.stringify(parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.employeeChildrenInfo),
              metadata: JSON.stringify(formData.metadata),
              status: WORKFORCE_STATUS$1.DRAFT,
              applicationFor: applicationForSelf === "yes" ? "self" : applicationForSelf === "" ? "" : "dependent"
            };
            dispatch(updateApplication(_updateApplicationData, "update workforce application ".concat(formData.firstNameEn)));
          case 61:
            return _context.abrupt("return", true);
          case 62:
            return _context.abrupt("return", false);
          case 63:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function handleNext() {
      return _ref2.apply(this, arguments);
    };
  }();
  var handleBack = function handleBack() {
    return setActiveStep(function (prevStep) {
      return prevStep - 1;
    });
  };
  var handleArrayFieldChange = function handleArrayFieldChange(fieldKey, index, key, value) {
    setFormData(function (prev) {
      var items = Array.isArray(prev[fieldKey]) ? _toConsumableArray(prev[fieldKey]) : [];
      var currentItem = items[index] || {};
      var nextValue = typeof value === "function" ? value(currentItem[key]) : value;
      items[index] = _objectSpread$U(_objectSpread$U({}, currentItem), {}, _defineProperty({}, key, nextValue));
      return _objectSpread$U(_objectSpread$U({}, prev), {}, _defineProperty({}, fieldKey, items));
    });
  };
  var addArrayFieldItem = function addArrayFieldItem(fieldKey) {
    var defaultItem = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    setFormData(function (prev) {
      var items = Array.isArray(prev[fieldKey]) ? _toConsumableArray(prev[fieldKey]) : [{}];
      var updated = [].concat(_toConsumableArray(items), [defaultItem]);
      setExpanded === null || setExpanded === void 0 || setExpanded(updated.length - 1); // optional chaining
      return _objectSpread$U(_objectSpread$U({}, prev), {}, _defineProperty({}, fieldKey, updated));
    });
  };
  var removeArrayFieldItem = function removeArrayFieldItem(fieldKey, index) {
    setFormData(function (prev) {
      var items = Array.isArray(prev[fieldKey]) ? _toConsumableArray(prev[fieldKey]) : [];
      var updated = items.filter(function (_, i) {
        return i !== index;
      });
      return _objectSpread$U(_objectSpread$U({}, prev), {}, _defineProperty({}, fieldKey, updated));
    });
  };
  var handleSubmit = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var _parsedApplicationDat3, _formData$workforceEm31, _formData$factory5, _formData$factory6;
      var submittedBy, updateApplicationData;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            console.log({
              tazwer: formData
            });
            if (!uploadBankFile) {
              _context2.next = 4;
              break;
            }
            _context2.next = 4;
            return Promise.all(uploadBankFile.map(function (file) {
              return dispatch(createWorkforceDocument(_objectSpread$U(_objectSpread$U({}, file), {}, {
                workforceApplicationId: safeApplicationId(applicationId, parsedApplicationData)
              }), "Created workforce document"));
            }));
          case 4:
            _context2.next = 6;
            return Promise.all(uploadFile.map(function (file, index) {
              dispatch(createWorkforceDocument(_objectSpread$U(_objectSpread$U({}, file), {}, {
                workforceApplicationId: safeApplicationId(applicationId)
              }), "Created workforce document "));
            }));
          case 6:
            submittedBy = user_type === WORKFORCE_USER_TYPE.APPLICANT ? "applicant" : user_type === WORKFORCE_USER_TYPE.FACTORY_ADMIN ? "factory_admin" : "UNKNOWN";
            updateApplicationData = {
              // id: decodeId(applicationId[0]?.id) || parsedApplicationData?.id,
              id: safeApplicationId(applicationId, parsedApplicationData),
              workforceEmployeeId: (formData === null || formData === void 0 ? void 0 : formData.workforceEmployee.id) || (parsedApplicationData === null || parsedApplicationData === void 0 || (_parsedApplicationDat3 = parsedApplicationData.workforceEmployee) === null || _parsedApplicationDat3 === void 0 ? void 0 : _parsedApplicationDat3.id),
              company: formData === null || formData === void 0 || (_formData$workforceEm31 = formData.workforceEmployee) === null || _formData$workforceEm31 === void 0 || (_formData$workforceEm31 = _formData$workforceEm31.company) === null || _formData$workforceEm31 === void 0 ? void 0 : _formData$workforceEm31.id,
              factory: formData !== null && formData !== void 0 && (_formData$factory5 = formData.factory) !== null && _formData$factory5 !== void 0 && _formData$factory5.id ? safeDecodeId(formData === null || formData === void 0 || (_formData$factory6 = formData.factory) === null || _formData$factory6 === void 0 ? void 0 : _formData$factory6.id) : null,
              organizationType: organizationType || (parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.organizationType),
              applicationType: selectedApplicationType || (parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.applicationType),
              institutionInfo: JSON.stringify(formData.institutionInfo),
              employeeBankInfo: JSON.stringify(formData.employeeBankInfo) || JSON.stringify(parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.employeeBankInfo),
              employeeAccidentInfo: JSON.stringify(formData === null || formData === void 0 ? void 0 : formData.employeeAccidentInfo) || JSON.stringify(parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.employeeAccidentInfo),
              metadata: JSON.stringify(formData.metadata),
              status: WORKFORCE_STATUS$1.NEW,
              applicationFor: applicationForSelf === "yes" ? "self" : applicationForSelf === "" ? "" : "dependent",
              submittedBy: submittedBy
            };
            console.log("hello i am from submit", updateApplicationData);
            dispatch(updateApplication(updateApplicationData, "update workforce application "));
            // dispatch(createApplicationMovement(createApplicationMovementData, `create workforce movement`));
          case 10:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function handleSubmit() {
      return _ref3.apply(this, arguments);
    };
  }();
  var steps = [{
    label: "workforce.application.steps.employeeDetails",
    content: /*#__PURE__*/React.createElement(EmployeeDetailsForm, {
      errors: errors,
      handleChange: function handleChange(key, value) {
        return _handleChange(key, value, "workforceEmployee");
      },
      formData: formData
    })
  }, {
    label: "workforce.application.steps.location",
    content: /*#__PURE__*/React.createElement(EmployeeLocationForm, {
      handleChange: function handleChange(key, value) {
        return _handleChange(key, value, "workforceEmployee");
      },
      formData: formData
    })
  }, {
    label: "workforce.application.steps.worker.extraInfo",
    content: /*#__PURE__*/React.createElement(WorkerExtraInfo, {
      errors: errors,
      handleChange: function handleChange(key, value) {
        return _handleChange(key, value, "institutionInfo");
      },
      formData: formData
    })
  }, {
    label: "workforce.application.steps.childInfo",
    content: /*#__PURE__*/React.createElement(EducationInfoForm, {
      handleChange: function handleChange(key, value) {
        return _handleChange(key, value, "employeeChildrenInfo");
      },
      formData: formData,
      errors: errors,
      applicationForSelf: applicationForSelf
    })
  }, {
    label: "workforce.application.steps.previousGrantInfo",
    content: /*#__PURE__*/React.createElement(PreviousGrantInfoForm, {
      errors: errors,
      handleChange: function handleChange(key, value) {
        return _handleChange(key, value, "metadata");
      },
      formData: formData,
      setFormData: setFormData
    })
  }, {
    label: "workforce.application.steps.account.info",
    content: /*#__PURE__*/React.createElement(EmployeeAccountInfoForm, {
      accounts: formData.employeeBankInfo,
      formdata: formData,
      handleChange: function handleChange(index, key, value) {
        return handleArrayFieldChange("employeeBankInfo", index, key, value);
      },
      addItem: function addItem() {
        return addArrayFieldItem("employeeBankInfo", {
          accountHolderName: "",
          bankName: "",
          accountNumber: "",
          branchName: ""
        });
      },
      removeItem: function removeItem(index) {
        return removeArrayFieldItem("employeeBankInfo", index);
      },
      expanded: expanded,
      setExpanded: setExpanded,
      errors: errors
    })
  }];
  if (showPreview) {
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ApplicationViewPage, {
      application: formData,
      language: "fr"
    }), /*#__PURE__*/React.createElement("div", {
      className: classes.buttonContainer
    }, /*#__PURE__*/React.createElement(Button, {
      variant: "outlined",
      color: "error",
      onClick: function onClick() {
        setShowPreview(false);
      }
    }, /*#__PURE__*/React.createElement(FormattedMessage, {
      module: "workforce",
      id: "workforce.back"
    })), /*#__PURE__*/React.createElement(Button, {
      variant: "contained",
      color: "primary",
      onClick: function onClick() {
        setShowPreview(false);
        setShowVerifyNid(true);
      }
    }, /*#__PURE__*/React.createElement(FormattedMessage, {
      module: "workforce",
      id: "workforce.submit"
    }))));
  }
  if (showVerifyNid) {
    return /*#__PURE__*/React.createElement("div", {
      className: classes.container
    }, /*#__PURE__*/React.createElement(Paper, {
      className: classes.paper,
      elevation: 0
    }, /*#__PURE__*/React.createElement(NidVerification, {
      formData: formData,
      nidOrBcn: nidOrBcn,
      setDisableConfirmSubmit: setDisableConfirmSubmit
    }), /*#__PURE__*/React.createElement("div", {
      className: classes.buttonContainer
    }, /*#__PURE__*/React.createElement(Button, {
      variant: "contained",
      color: "primary",
      onClick: /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return handleSubmit();
            case 2:
              setShowVerifyNid(false);
              setIsSubmitted(true);
            case 4:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))
    }, /*#__PURE__*/React.createElement(FormattedMessage, {
      module: "workforce",
      id: "workforce.confirm.submit"
    })))));
  }
  if (isSubmitted) {
    return /*#__PURE__*/React.createElement(ApplicationFormSubmitted, null);
  }
  return /*#__PURE__*/React.createElement("div", {
    className: classes.container
  }, /*#__PURE__*/React.createElement(Paper, {
    className: classes.paper,
    elevation: 0
  }, /*#__PURE__*/React.createElement(Stepper, {
    activeStep: activeStep,
    alternativeLabel: true,
    style: {
      padding: "0px"
    }
  }, steps.map(function (step, index) {
    return /*#__PURE__*/React.createElement(Step, {
      key: index
    }, /*#__PURE__*/React.createElement(StepLabel, null, /*#__PURE__*/React.createElement(FormattedMessage, {
      module: "workforce",
      id: step.label
    })));
  })), /*#__PURE__*/React.createElement(Box$1, {
    mt: 0,
    ref: stepRef
  }, steps[activeStep].content), activeStep === steps.length - 1 && /*#__PURE__*/React.createElement(Box$1, null, /*#__PURE__*/React.createElement(FormControlLabel, {
    control: /*#__PURE__*/React.createElement(Checkbox, {
      checked: acknowledged,
      onChange: function onChange(e) {
        return setAcknowledged(e.target.checked);
      },
      style: {
        color: "blue"
      }
    }),
    label: /*#__PURE__*/React.createElement(Typography, {
      variant: "body2"
    }, /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.application.acknowledgement.text",
      module: "workforce"
    }))
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.buttonContainer
  }, activeStep > 0 && /*#__PURE__*/React.createElement(Button, {
    onClick: handleBack,
    variant: "outlined"
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.back"
  })), activeStep < steps.length - 1 ? /*#__PURE__*/React.createElement(Button, {
    variant: "contained",
    color: "primary",
    onClick: handleNext
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.save.next"
  })) : /*#__PURE__*/React.createElement(Button, {
    variant: "contained",
    color: "primary",
    disabled: !acknowledged,
    onClick: /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
      var isSuccess;
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return handleNext();
          case 2:
            isSuccess = _context4.sent;
            if (isSuccess) setShowPreview(true);
          case 4:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }))
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.submit"
  })))), /*#__PURE__*/React.createElement(CustomSnackbar, {
    open: showErrorSnackbar // Use the new state
    ,
    onClose: function onClose() {
      return setShowErrorSnackbar(false);
    } // Allow it to close
    ,
    type: "error",
    message: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "core.error.generel",
      module: "workforce"
    }),
    duration: 4000
  }));
};

function ownKeys$T(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$T(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$T(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$T(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var useStyles$16 = makeStyles(function (theme) {
  return {
    container: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center"
    },
    paper: {
      padding: theme.spacing(2)
    },
    buttonContainer: {
      marginTop: theme.spacing(2),
      display: "flex",
      justifyContent: "space-between"
    },
    item: theme.paper.item,
    overrideReadOnly: {
      "& .MuiInputBase-root.Mui-disabled": {
        color: "#808080 !important"
      },
      "& .MuiFormLabel-root.Mui-disabled": {
        color: "".concat(theme.palette.text.primary, " !important")
      }
    }
  };
});
var ApplicantDetailsForm = function ApplicantDetailsForm(_ref) {
  var _reduxState$core, _formData$workforceAp3, _formData$workforceAp4, _formData$workforceAp5, _formData$workforceAp6, _formData$workforceAp7, _formData$workforceAp8, _formData$workforceAp9, _formData$workforceAp10, _formData$workforceAp11, _formData$workforceAp12, _formData$workforceAp13, _formData$workforceAp14, _formData$workforceAp15, _formData$workforceAp16, _formData$workforceAp17, _formData$workforceAp18, _formData$workforceAp19, _formData$workforceAp20, _formData$workforceAp21, _formData$workforceAp22, _formData$workforceAp23, _formData$workforceAp24, _formData$workforceAp25, _formData$workforceAp26, _formData$workforceAp27, _formData$workforceAp28, _formData$workforceAp29, _formData$workforceAp30, _formData$workforceAp31;
  var handleChange = _ref.handleChange,
    formData = _ref.formData;
    _ref.setFormData;
    var nidOrBcn = _ref.nidOrBcn,
    setNidOrBcn = _ref.setNidOrBcn,
    errors = _ref.errors;
  var classes = useStyles$16();
  useHistory();
  var modulesManager = useModulesManager();
  var _useTranslations = useTranslations("core.RegistrationPage", modulesManager),
    formatMessage = _useTranslations.formatMessage;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    sameAsPresent = _useState2[0],
    setSameAsPresent = _useState2[1];
  useSelector(function (state) {
    var _state$workforce;
    return (_state$workforce = state.workforce["workforceApplicant"]) !== null && _state$workforce !== void 0 ? _state$workforce : [];
  });
  var reduxState = useSelector(function (state) {
    return state;
  });
  var locale = reduxState === null || reduxState === void 0 || (_reduxState$core = reduxState.core) === null || _reduxState$core === void 0 || (_reduxState$core = _reduxState$core.user) === null || _reduxState$core === void 0 || (_reduxState$core = _reduxState$core.i_user) === null || _reduxState$core === void 0 ? void 0 : _reduxState$core.language;
  var isCityLocation = function isCityLocation(locationObj) {
    var current = locationObj;
    while (current) {
      var _current$name;
      if (current.name && current.name.includes("সিটি কর্পোরেশন")) {
        return true;
      } else if ((_current$name = current.name) !== null && _current$name !== void 0 && _current$name.includes("পৌরসভা")) {
        return true;
      }
      current = current.parent;
    }
    return false; // not a city
  };
  useEffect(function () {
    if (sameAsPresent) {
      var _formData$workforceAp, _formData$workforceAp2;
      var presentLocation = (formData === null || formData === void 0 || (_formData$workforceAp = formData.workforceApplicant) === null || _formData$workforceAp === void 0 ? void 0 : _formData$workforceAp.presentLocation) || null;
      var presentAddress = (formData === null || formData === void 0 || (_formData$workforceAp2 = formData.workforceApplicant) === null || _formData$workforceAp2 === void 0 ? void 0 : _formData$workforceAp2.presentAddress) || "";
      handleChange("permanentLocation", presentLocation);
      handleChange("permanentAddress", presentAddress);
    }
  }, [sameAsPresent, formData === null || formData === void 0 || (_formData$workforceAp3 = formData.workforceApplicant) === null || _formData$workforceAp3 === void 0 ? void 0 : _formData$workforceAp3.presentLocation, formData === null || formData === void 0 || (_formData$workforceAp4 = formData.workforceApplicant) === null || _formData$workforceAp4 === void 0 ? void 0 : _formData$workforceAp4.presentAddress]);
  console.log("hello bangladesh", formData);
  return /*#__PURE__*/React.createElement(Box$1, null, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 2
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(Paper, {
    className: classes.paper,
    elevation: 0
  }, /*#__PURE__*/React.createElement(Box$1, {
    mb: 4,
    color: "red"
  }, /*#__PURE__*/React.createElement("h3", null, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "workforce.application.header.labour.note",
    module: "workforce"
  }))), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement("b", null, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "workforce.applicant.labourHeadingOne",
    module: "workforce"
  }))), /*#__PURE__*/React.createElement(Grid, {
    container: true,
    className: clsx(classes.item, classes.overrideReadOnly),
    spacing: 2
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6,
    className: clsx(classes.item, classes.overrideReadOnly)
  }, /*#__PURE__*/React.createElement(TextInput, {
    id: "nameBn",
    label: "workforce.employee.name.bn",
    value: (formData === null || formData === void 0 || (_formData$workforceAp5 = formData.workforceApplicant) === null || _formData$workforceAp5 === void 0 ? void 0 : _formData$workforceAp5.nameBn) || "",
    onChange: function onChange(v) {
      return handleChange("nameBn", v);
    },
    required: true,
    readOnly: false,
    error: !!errors.nameBn,
    helperText: errors.nameBn
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6,
    className: clsx(classes.item, classes.overrideReadOnly)
  }, /*#__PURE__*/React.createElement(TextInput, {
    id: "nameEn",
    label: "workforce.employee.name.en",
    value: (formData === null || formData === void 0 || (_formData$workforceAp6 = formData.workforceApplicant) === null || _formData$workforceAp6 === void 0 ? void 0 : _formData$workforceAp6.nameEn) || "",
    onChange: function onChange(v) {
      return handleChange("nameEn", v);
    },
    required: true,
    readOnly: false,
    error: !!errors.nameEn,
    helperText: errors.nameEn
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6,
    className: clsx(classes.item, classes.overrideReadOnly)
  }, /*#__PURE__*/React.createElement(EmployeeGenderPicker, {
    value: _typeof(formData === null || formData === void 0 || (_formData$workforceAp7 = formData.workforceApplicant) === null || _formData$workforceAp7 === void 0 ? void 0 : _formData$workforceAp7.gender) === "object" ? formData === null || formData === void 0 || (_formData$workforceAp8 = formData.workforceApplicant) === null || _formData$workforceAp8 === void 0 || (_formData$workforceAp8 = _formData$workforceAp8.gender) === null || _formData$workforceAp8 === void 0 ? void 0 : _formData$workforceAp8.name : formData === null || formData === void 0 || (_formData$workforceAp9 = formData.workforceApplicant) === null || _formData$workforceAp9 === void 0 ? void 0 : _formData$workforceAp9.gender,
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.employee.gender",
      module: "workforce"
    }),
    onChange: function onChange(v) {
      return handleChange("gender", v);
    },
    readOnly: false
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6,
    className: clsx(classes.item, classes.overrideReadOnly)
  }, /*#__PURE__*/React.createElement(TextInput, {
    id: "phoneNumber",
    label: "workforce.employee.phone",
    value: (formData === null || formData === void 0 || (_formData$workforceAp10 = formData.workforceApplicant) === null || _formData$workforceAp10 === void 0 ? void 0 : _formData$workforceAp10.phoneNumber) || "",
    formatInput: filterDigits,
    onChange: function onChange(v) {
      return handleChange("phoneNumber", filterDigits(v));
    },
    type: "text",
    required: true,
    readOnly: false,
    inputProps: {
      inputMode: "numeric",
      maxLength: 11
    },
    error: !!errors.phoneNumber,
    helperText: errors.phoneNumber
  }), errors.phoneNumber && /*#__PURE__*/React.createElement(FormHelperText, {
    error: true
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: errors.phoneNumber
  }))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6,
    className: clsx(classes.item, classes.overrideReadOnly)
  }, /*#__PURE__*/React.createElement(CountryPicker, {
    id: "citizenship",
    label: formatMessage("workforce.employee.citizenship"),
    value: (formData === null || formData === void 0 || (_formData$workforceAp11 = formData.workforceApplicant) === null || _formData$workforceAp11 === void 0 ? void 0 : _formData$workforceAp11.citizenship) || "",
    onChange: function onChange(v) {
      return handleChange("citizenship", v);
    },
    readOnly: false
    // required
    ,
    language: locale === "fr" ? "bn" : "en"
  }), errors.citizenship && /*#__PURE__*/React.createElement(FormHelperText, {
    error: true
  }, errors.citizenship)), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6,
    className: clsx(classes.item, classes.overrideReadOnly)
  }, /*#__PURE__*/React.createElement(PublishedComponent, {
    pubRef: "workforce.DatePicker",
    label: "workforce.employee.birthdate",
    value: (formData === null || formData === void 0 || (_formData$workforceAp12 = formData.workforceApplicant) === null || _formData$workforceAp12 === void 0 ? void 0 : _formData$workforceAp12.birthDate) || "",
    onChange: function onChange(v) {
      return handleChange("birthDate", v);
    },
    readOnly: false,
    required: true
  }), errors.rdmp && /*#__PURE__*/React.createElement(FormHelperText, {
    error: true
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: errors.rdmp
  }))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6,
    className: classes.item
  }, /*#__PURE__*/React.createElement(TextInput, {
    id: "nid",
    label: "workforce.employee.nid_or_birth_certificate",
    value: (formData === null || formData === void 0 || (_formData$workforceAp13 = formData.workforceApplicant) === null || _formData$workforceAp13 === void 0 ? void 0 : _formData$workforceAp13.nid) || (formData === null || formData === void 0 || (_formData$workforceAp14 = formData.workforceApplicant) === null || _formData$workforceAp14 === void 0 ? void 0 : _formData$workforceAp14.birthCertificateNo) || "",
    formatInput: function formatInput(val) {
      return (val || "").toString().replace(/\D/g, "").slice(0, 17);
    },
    inputProps: {
      maxLength: 17
    },
    onChange: function onChange(v) {
      var numericValue = (v || "").replace(/\D/g, "").slice(0, 17);
      setNidOrBcn(_objectSpread$T(_objectSpread$T({}, nidOrBcn), {}, {
        nid: numericValue
      }));
      handleChange("nid", v);
    },
    type: "number",
    required: true,
    readOnly: false,
    error: !!errors.nid,
    helperText: errors.nid
  }), errors.nid && /*#__PURE__*/React.createElement(FormHelperText, {
    error: true
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: errors.nid
  }))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6,
    className: classes.item
  }, /*#__PURE__*/React.createElement(RelationWithWorkerPicker, {
    id: "relationWithApplicant",
    applicantInfo: "factory_admin",
    value: (formData === null || formData === void 0 || (_formData$workforceAp15 = formData.workforceApplicant) === null || _formData$workforceAp15 === void 0 ? void 0 : _formData$workforceAp15.relationWithApplicant) || "",
    label: formatMessage("workforce.employee.relationWithApplicant"),
    required: true,
    onChange: function onChange(v) {
      return handleChange("relationWithApplicant", v);
    },
    readOnly: false
  }), errors.relationWithApplicant && /*#__PURE__*/React.createElement(FormHelperText, {
    error: true
  }, errors.relationWithApplicant))), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement("b", null, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "workforce.applicant.labourHeadingTwo",
    module: "workforce"
  }))), /*#__PURE__*/React.createElement(Grid, {
    container: true,
    className: clsx(classes.item, classes.overrideReadOnly),
    spacing: 2
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6,
    className: clsx(classes.item, classes.overrideReadOnly)
  }, /*#__PURE__*/React.createElement(TextInput, {
    id: "fatherNameEn",
    label: "workforce.employee.fathers_name.en",
    value: (formData === null || formData === void 0 || (_formData$workforceAp16 = formData.workforceApplicant) === null || _formData$workforceAp16 === void 0 ? void 0 : _formData$workforceAp16.fatherNameEn) || "",
    formatInput: filterEnglish,
    onChange: function onChange(v) {
      return handleChange("fatherNameEn", filterEnglish(v));
    },
    readOnly: false,
    required: true,
    error: !!errors.fatherNameEn,
    helperText: errors.fatherNameEn
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6,
    className: clsx(classes.item, classes.overrideReadOnly)
  }, /*#__PURE__*/React.createElement(TextInput, {
    id: "fatherNmaeBn",
    label: "workforce.employee.fathers_name.bn",
    value: (formData === null || formData === void 0 || (_formData$workforceAp17 = formData.workforceApplicant) === null || _formData$workforceAp17 === void 0 ? void 0 : _formData$workforceAp17.fatherNameBn) || "",
    formatInput: filterBangla,
    onChange: function onChange(v) {
      return handleChange("fatherNameBn", filterBangla(v));
    },
    readOnly: false,
    required: true,
    error: !!errors.fatherNameBn,
    helperText: errors.fatherNameBn
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6,
    className: clsx(classes.item, classes.overrideReadOnly)
  }, /*#__PURE__*/React.createElement(TextInput, {
    id: "motherNameEn",
    label: "workforce.employee.mothers_name.en",
    value: (formData === null || formData === void 0 || (_formData$workforceAp18 = formData.workforceApplicant) === null || _formData$workforceAp18 === void 0 ? void 0 : _formData$workforceAp18.motherNameEn) || "",
    formatInput: filterEnglish,
    onChange: function onChange(v) {
      return handleChange("motherNameEn", filterEnglish(v));
    },
    readOnly: false,
    required: true,
    error: !!errors.motherNameEn,
    helperText: errors.motherNameEn
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6,
    className: clsx(classes.item, classes.overrideReadOnly)
  }, /*#__PURE__*/React.createElement(TextInput, {
    label: "workforce.employee.mothers_name.bn",
    value: (formData === null || formData === void 0 || (_formData$workforceAp19 = formData.workforceApplicant) === null || _formData$workforceAp19 === void 0 ? void 0 : _formData$workforceAp19.motherNameBn) || "",
    formatInput: filterBangla,
    onChange: function onChange(v) {
      return handleChange("motherNameBn", filterBangla(v));
    },
    readOnly: false,
    required: true
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6,
    className: clsx(classes.item, classes.overrideReadOnly)
  }, /*#__PURE__*/React.createElement(TextInput, {
    label: "workforce.employee.spouse.name.en",
    value: (formData === null || formData === void 0 || (_formData$workforceAp20 = formData.workforceApplicant) === null || _formData$workforceAp20 === void 0 ? void 0 : _formData$workforceAp20.spouseNameEn) || "",
    onChange: function onChange(v) {
      return handleChange("spouseNameEn", v);
    },
    readOnly: false
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6,
    className: clsx(classes.item, classes.overrideReadOnly)
  }, /*#__PURE__*/React.createElement(TextInput, {
    label: "workforce.employee.spouse.name.bn",
    value: (formData === null || formData === void 0 || (_formData$workforceAp21 = formData.workforceApplicant) === null || _formData$workforceAp21 === void 0 ? void 0 : _formData$workforceAp21.spouseNameBn) || "",
    onChange: function onChange(v) {
      return handleChange("spouseNameBn", v);
    },
    readOnly: false
  }))), /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 2
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement("b", null, formatMessage("workforce.employee.present_location")), /*#__PURE__*/React.createElement(PublishedComponent, {
    pubRef: "location.DetailedLocation",
    withNull: true,
    value: (formData === null || formData === void 0 || (_formData$workforceAp22 = formData.workforceApplicant) === null || _formData$workforceAp22 === void 0 ? void 0 : _formData$workforceAp22.presentLocation) || null,
    onChange: function onChange(presentLocation) {
      return handleChange("presentLocation", presentLocation);
    },
    readOnly: false,
    required: true,
    split: true
  }), (errors === null || errors === void 0 ? void 0 : errors.detailedLocation) && /*#__PURE__*/React.createElement(FormHelperText, {
    error: true
  }, errors === null || errors === void 0 ? void 0 : errors.detailedLocation)), (formData === null || formData === void 0 || (_formData$workforceAp23 = formData.workforceApplicant) === null || _formData$workforceAp23 === void 0 ? void 0 : _formData$workforceAp23.presentLocation) && /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(CustomDetailedLocation, {
    locationType: isCityLocation(formData === null || formData === void 0 || (_formData$workforceAp24 = formData.workforceApplicant) === null || _formData$workforceAp24 === void 0 ? void 0 : _formData$workforceAp24.presentLocation) ? "city" : "rural",
    onChange: handleChange,
    addressKey: "presentAddress",
    data: formData === null || formData === void 0 || (_formData$workforceAp25 = formData.workforceApplicant) === null || _formData$workforceAp25 === void 0 ? void 0 : _formData$workforceAp25.presentAddress,
    readOnly: false,
    locationData: formData === null || formData === void 0 || (_formData$workforceAp26 = formData.workforceApplicant) === null || _formData$workforceAp26 === void 0 ? void 0 : _formData$workforceAp26.presentLocation,
    errors: errors
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement("b", null, formatMessage("workforce.employee.permanent_location")), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(FormControlLabel, {
    control: /*#__PURE__*/React.createElement(Checkbox, {
      color: "primary",
      checked: sameAsPresent,
      onChange: function onChange(e) {
        return setSameAsPresent(e.target.checked);
      }
    }),
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.employee.sameAsPresent",
      defaultMessage: "Same as present location"
    })
  })), /*#__PURE__*/React.createElement(PublishedComponent, {
    pubRef: "location.DetailedLocation",
    withNull: true,
    value: (formData === null || formData === void 0 || (_formData$workforceAp27 = formData.workforceApplicant) === null || _formData$workforceAp27 === void 0 ? void 0 : _formData$workforceAp27.permanentLocation) || null,
    onChange: function onChange(permanentLocation) {
      return handleChange("permanentLocation", permanentLocation);
    },
    readOnly: sameAsPresent,
    required: true,
    split: true
  }), (errors === null || errors === void 0 ? void 0 : errors.detailedLocation) && /*#__PURE__*/React.createElement(FormHelperText, {
    error: true
  }, errors === null || errors === void 0 ? void 0 : errors.detailedLocation)), (formData === null || formData === void 0 || (_formData$workforceAp28 = formData.workforceApplicant) === null || _formData$workforceAp28 === void 0 ? void 0 : _formData$workforceAp28.permanentLocation) && /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(CustomDetailedLocation, {
    locationType: isCityLocation(formData === null || formData === void 0 || (_formData$workforceAp29 = formData.workforceApplicant) === null || _formData$workforceAp29 === void 0 ? void 0 : _formData$workforceAp29.permanentLocation) ? "city" : "rural",
    onChange: handleChange,
    addressKey: "permanentAddress",
    data: formData === null || formData === void 0 || (_formData$workforceAp30 = formData.workforceApplicant) === null || _formData$workforceAp30 === void 0 ? void 0 : _formData$workforceAp30.permanentAddress,
    readOnly: sameAsPresent,
    locationData: formData === null || formData === void 0 || (_formData$workforceAp31 = formData.workforceApplicant) === null || _formData$workforceAp31 === void 0 ? void 0 : _formData$workforceAp31.permanentLocation,
    errors: errors
  }))), /*#__PURE__*/React.createElement(Divider, null)))), /*#__PURE__*/React.createElement(EmployeeDetailsForm2, {
    errors: errors,
    handleChange: function handleChange() {},
    formData: formData,
    selectedApplicationType: formData === null || formData === void 0 ? void 0 : formData.applicationType,
    formStepNo: "applicantInfo"
  }));
};

var OTHER_ID = "OTHER_OPTION";

// ✅ List of translation keys as plain strings
var deathReasonKeys = ["heart_disease", "stroke", "old_age", "cancer", "diabetes", "liver_failure", "kidney_failure", "asthma", "pneumonia", "chronic", OTHER_ID];
var DeathReasonPicker = function DeathReasonPicker(_ref) {
  var id = _ref.id,
    _ref$selectedReason = _ref.selectedReason,
    selectedReason = _ref$selectedReason === void 0 ? "" : _ref$selectedReason,
    handleChange = _ref.handleChange,
    onOtherDiseaseChange = _ref.onOtherDiseaseChange,
    _ref$required = _ref.required,
    required = _ref$required === void 0 ? true : _ref$required,
    otherDiseaseValue = _ref.otherDiseaseValue;
  var handleSelectChange = function handleSelectChange(event) {
    var value = event.target.value;
    handleChange("deathReason", value); // You can change "deathReason" to a prop if needed
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FormControl, {
    fullWidth: true
  }, /*#__PURE__*/React.createElement(InputLabel, {
    required: true
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "workforce.application.death.reason",
    defaultMessage: "\u09AE\u09C3\u09A4\u09CD\u09AF\u09C1\u09B0 \u0995\u09BE\u09B0\u09A3",
    module: "workforce"
  })), /*#__PURE__*/React.createElement(Select, {
    value: selectedReason,
    onChange: handleSelectChange,
    required: required,
    inputProps: {
      id: id
    }
  }, deathReasonKeys.map(function (key) {
    return /*#__PURE__*/React.createElement(MenuItem, {
      key: key,
      value: key
    }, /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.application.deathReason.".concat(key)
    }));
  }))), selectedReason === OTHER_ID && /*#__PURE__*/React.createElement(TextField, {
    fullWidth: true,
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      module: "workforce",
      id: "workforce.application.other.death.reason",
      defaultMessage: "\u09AE\u09C3\u09A4\u09CD\u09AF\u09C1\u09B0 \u0995\u09BE\u09B0\u09A3 \u09A8\u09BF\u09B0\u09CD\u09A6\u09BF\u09B7\u09CD\u099F \u0995\u09B0\u09C1\u09A8"
    }),
    value: otherDiseaseValue || "",
    onChange: function onChange(e) {
      return onOtherDiseaseChange(e.target.value);
    },
    margin: "normal"
  }));
};

var useStyles$15 = makeStyles(function (theme) {
  return {
    paper: {
      padding: theme.spacing(2)
    }
  };
});
var ApplicationReason = function ApplicationReason(_ref) {
  var _formData$metadata, _formData$metadata3, _formData$metadata4, _formData$metadata5, _formData$metadata6, _formData$metadata7, _formData$metadata8;
  var _handleChange = _ref.handleChange,
    formData = _ref.formData,
    errors = _ref.errors;
  var classes = useStyles$15();
  var organizationType = formData === null || formData === void 0 ? void 0 : formData.organizationType;
  var _useTranslations = useTranslations("core.RegistrationPage");
    _useTranslations.formatMessage;
  var deathType = organizationType === "eis" ? "accidentalDeath" : (formData === null || formData === void 0 || (_formData$metadata = formData.metadata) === null || _formData$metadata === void 0 ? void 0 : _formData$metadata.deathType) || "";
  useEffect(function () {
    var _formData$metadata2;
    var currentDeathType = formData === null || formData === void 0 || (_formData$metadata2 = formData.metadata) === null || _formData$metadata2 === void 0 ? void 0 : _formData$metadata2.deathType;
    if (organizationType === "eis") {
      if (currentDeathType !== "accidentalDeath") {
        _handleChange("deathType", "accidentalDeath", "metadata");
      }
    } else if (!currentDeathType) {
      _handleChange("deathType", "accidentalDeath", "metadata");
    }
  }, [organizationType, formData === null || formData === void 0 || (_formData$metadata3 = formData.metadata) === null || _formData$metadata3 === void 0 ? void 0 : _formData$metadata3.deathType, _handleChange]);
  var handleApplicationReason = function handleApplicationReason(event) {
    var value = event.target.value;
    _handleChange("deathType", value, "metadata");

    // Reset conditionally visible fields
    if (value === "normalDeath") {
      _handleChange("injuryType", "", "metadata");
      _handleChange("deathReason", "", "metadata");
    } else if (value === "accidentalDeath") {
      _handleChange("deathCause", "", "metadata");
      _handleChange("deathReason", "", "metadata");
    } else {
      _handleChange("injuryType", "", "metadata");
      _handleChange("deathCause", "", "metadata");
    }
  };
  return /*#__PURE__*/React.createElement(Box$1, {
    mt: 1
  }, /*#__PURE__*/React.createElement(Paper, {
    className: classes.paper,
    elevation: 0
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 2
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(FormControl, {
    component: "fieldset",
    fullWidth: true
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle1",
    style: {
      fontWeight: "bold",
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "workforce.application.reason.type",
    module: "workforce"
  })), /*#__PURE__*/React.createElement(RadioGroup, {
    row: true,
    value: organizationType === "eis" ? "accidentalDeath" : deathType,
    onChange: handleApplicationReason
  }, organizationType !== "eis" && /*#__PURE__*/React.createElement(FormControlLabel, {
    value: "normalDeath",
    control: /*#__PURE__*/React.createElement(Radio, {
      color: "primary"
    }),
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.financial.assistance.normalDeath",
      module: "workforce"
    })
  }), /*#__PURE__*/React.createElement(FormControlLabel, {
    value: "accidentalDeath",
    control: /*#__PURE__*/React.createElement(Radio, {
      color: "primary"
    }),
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.financial.assistance.accidentalDeath",
      module: "workforce"
    })
  })))), deathType === "normalDeath" && /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement(DeathReasonPicker, {
    id: "deathReason",
    required: true,
    selectedReason: (formData === null || formData === void 0 || (_formData$metadata4 = formData.metadata) === null || _formData$metadata4 === void 0 ? void 0 : _formData$metadata4.deathReason) || "",
    handleChange: function handleChange(key, value) {
      return _handleChange(key, value, "metadata");
    },
    onOtherDiseaseChange: function onOtherDiseaseChange(value) {
      return _handleChange("otherReason", value, "metadata");
    },
    otherDiseaseValue: (formData === null || formData === void 0 || (_formData$metadata5 = formData.metadata) === null || _formData$metadata5 === void 0 ? void 0 : _formData$metadata5.otherReason) || ""
  }), errors.deathReason && /*#__PURE__*/React.createElement(FormHelperText, {
    error: true
  }, errors.deathReason)), deathType === "accidentalDeath" && /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement(EmployeeAccidentTypePicker$1, {
    id: "accidentReason",
    value: (formData === null || formData === void 0 || (_formData$metadata6 = formData.metadata) === null || _formData$metadata6 === void 0 ? void 0 : _formData$metadata6.accidentReason) || "",
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.employee.accident.info.typeOfAccident",
      module: "workforce"
    }),
    required: true,
    onChange: function onChange(v) {
      return _handleChange("accidentReason", v, "metadata");
    },
    readOnly: false
  }), errors.accidentReason && /*#__PURE__*/React.createElement(FormHelperText, {
    error: true
  }, errors.accidentReason)), (deathType === "normalDeath" || deathType === "accidentalDeath") && /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement(PublishedComponent, {
    pubRef: "workforce.DatePicker",
    label: "workforce.employee.deathdate",
    value: (formData === null || formData === void 0 || (_formData$metadata7 = formData.metadata) === null || _formData$metadata7 === void 0 ? void 0 : _formData$metadata7.deathDate) || "",
    onChange: function onChange(v) {
      return _handleChange("deathDate", v, "metadata");
    },
    readOnly: false,
    required: true
  }), errors.rdmp && /*#__PURE__*/React.createElement(FormHelperText, {
    error: true
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: errors.rdmp
  }))), deathType === "other" && /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement(TextInput, {
    id: "deathReason",
    label: "workforce.financial.assistance.deathReason",
    value: (formData === null || formData === void 0 || (_formData$metadata8 = formData.metadata) === null || _formData$metadata8 === void 0 ? void 0 : _formData$metadata8.deathReason) || "",
    onChange: function onChange(v) {
      return _handleChange("deathReason", v, "metadata");
    },
    required: true,
    error: !!errors.deathReason,
    helperText: errors.deathReason
  })))));
};

var ParentDependentPicker = function ParentDependentPicker(_ref) {
  var _ref$id = _ref.id,
    id = _ref$id === void 0 ? "parentDependent" : _ref$id,
    label = _ref.label,
    placeholder = _ref.placeholder,
    _ref$withLabel = _ref.withLabel,
    withLabel = _ref$withLabel === void 0 ? true : _ref$withLabel,
    _ref$withPlaceholder = _ref.withPlaceholder,
    withPlaceholder = _ref$withPlaceholder === void 0 ? true : _ref$withPlaceholder,
    _ref$required = _ref.required,
    required = _ref$required === void 0 ? false : _ref$required,
    _ref$readOnly = _ref.readOnly,
    readOnly = _ref$readOnly === void 0 ? false : _ref$readOnly,
    value = _ref.value,
    _onChange = _ref.onChange,
    _ref$options = _ref.options,
    options = _ref$options === void 0 ? [] : _ref$options,
    filterOptions = _ref.filterOptions,
    filterSelectedOptions = _ref.filterSelectedOptions,
    _ref$multiple = _ref.multiple,
    multiple = _ref$multiple === void 0 ? false : _ref$multiple;
  var _useTranslations = useTranslations("workforce"),
    formatMessage = _useTranslations.formatMessage;

  // Detect current language (en/bn)
  var locale = useSelector(function (state) {
    var _state$core;
    return ((_state$core = state.core) === null || _state$core === void 0 || (_state$core = _state$core.user) === null || _state$core === void 0 || (_state$core = _state$core.i_user) === null || _state$core === void 0 ? void 0 : _state$core.language) || "en";
  });

  // Memoize selected option
  var selectedOption = useMemo(function () {
    if (!value) return null;
    var valueId = _typeof(value) === "object" ? value.id : value;
    return options.find(function (opt) {
      return safeDecodeId(opt.id) === safeDecodeId(valueId);
    }) || null;
  }, [value, options]);
  return /*#__PURE__*/React.createElement(Autocomplete, {
    id: id,
    multiple: multiple,
    required: required,
    placeholder: placeholder !== null && placeholder !== void 0 ? placeholder : "",
    label: label !== null && label !== void 0 ? label : formatMessage("Select Parent Dependent"),
    withLabel: withLabel,
    withPlaceholder: withPlaceholder,
    readOnly: readOnly,
    options: options,
    value: selectedOption,
    getOptionLabel: function getOptionLabel(option) {
      return locale === "en" ? (option === null || option === void 0 ? void 0 : option.nameEn) || (option === null || option === void 0 ? void 0 : option.nameBn) || "" : (option === null || option === void 0 ? void 0 : option.nameBn) || (option === null || option === void 0 ? void 0 : option.nameEn) || "";
    },
    onChange: function onChange(option) {
      // send the selected object and ID
      _onChange(option, option ? option.id : null);
    },
    filterOptions: filterOptions,
    filterSelectedOptions: filterSelectedOptions,
    onInputChange: function onInputChange() {}
  });
};

function ownKeys$S(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$S(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$S(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$S(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _createForOfIteratorHelper$b(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray$b(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray$b(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray$b(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray$b(r, a) : void 0; } }
function _arrayLikeToArray$b(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var useStyles$14 = makeStyles(function (theme) {
  return {
    paper: {
      padding: theme.spacing(2)
    },
    item: {
      marginBottom: theme.spacing(2)
    },
    buttonContainer: {
      marginTop: theme.spacing(2)
    }
  };
});
var EmployeeDeathAccountInfoForm = function EmployeeDeathAccountInfoForm(_ref) {
  var _applicationId$3;
  var formdata = _ref.formdata,
    accounts = _ref.accounts,
    handleChange = _ref.handleChange;
    _ref.addItem;
    var removeItem = _ref.removeItem,
    expanded = _ref.expanded,
    setExpanded = _ref.setExpanded,
    applicationId = _ref.applicationId,
    errors = _ref.errors;
  var classes = useStyles$14();
  var modulesManager = useModulesManager();
  var _useTranslations = useTranslations("core.RegistrationPage", modulesManager),
    formatMessage = _useTranslations.formatMessage;
  var dispatch = useDispatch();
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    loading = _useState2[0],
    setLoading = _useState2[1];
  var dependent = useSelector(function (state) {
    return state.workforce.workforceDependent;
  });

  // Fetch dependents if application exists
  useEffect(function () {
    var _applicationId$, _applicationId$2;
    if (applicationId && (_applicationId$ = applicationId[0]) !== null && _applicationId$ !== void 0 && _applicationId$.id) {
      setLoading(true);
      dispatch(fetchEmployeeDependent(modulesManager, ["workforceApplication_Id:\"".concat(safeDecodeId(applicationId[0].id), "\"")])).then(function (res) {
        return console.log("from account dependent", res);
      });
      setLoading(false);
    }
    if (applicationId && !((_applicationId$2 = applicationId[0]) !== null && _applicationId$2 !== void 0 && _applicationId$2.id)) {
      setLoading(true);
      dispatch(fetchEmployeeDependent(modulesManager, ["workforceApplication_Id:\"".concat(safeDecodeId(applicationId), "\"")])).then(function (res) {
        return console.log("from account dependent", res);
      });
      setLoading(false);
    }
  }, [applicationId]);
  if (loading) return /*#__PURE__*/React.createElement("b", null, "Loading...");

  // Autofill account holder names from dependents or employee
  // Autofill account holder names from dependents or employee and respect saved data
  useEffect(function () {
    if ((dependent === null || dependent === void 0 ? void 0 : dependent.length) > 0) {
      setExpanded(0);
      dependent.forEach(function (dep, index) {
        var _existingAccount, _existingAccount2, _existingAccount3, _existingAccount4, _existingAccount5;
        var existingAccount = null;
        var _iterator = _createForOfIteratorHelper$b(accounts),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var account = _step.value;
            if (account.dependentId === dep.id) {
              existingAccount = account;
              break;
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
        if (existingAccount === null) {
          existingAccount = accounts[index] || {};
        }
        // const existingAccount = accounts[index] || {};

        handleChange(index, "accountHolderName", ((_existingAccount = existingAccount) === null || _existingAccount === void 0 ? void 0 : _existingAccount.accountHolderName) || (dep === null || dep === void 0 ? void 0 : dep.nameEn));
        handleChange(index, "dependentId", ((_existingAccount2 = existingAccount) === null || _existingAccount2 === void 0 ? void 0 : _existingAccount2.dependentId) || (dep === null || dep === void 0 ? void 0 : dep.id));
        handleChange(index, "dependentNid", ((_existingAccount3 = existingAccount) === null || _existingAccount3 === void 0 ? void 0 : _existingAccount3.dependentNid) || (dep === null || dep === void 0 ? void 0 : dep.nid));

        // Check if the backend saved a parentDependentId
        if ((_existingAccount4 = existingAccount) !== null && _existingAccount4 !== void 0 && _existingAccount4.parentDependentId) {
          handleChange(index, "accountHolderType", "select_from_another_dependent");

          // Extract the string ID if the backend returns an object
          // const parentId = typeof existingAccount.parentDependentId === "object"
          //   ? existingAccount.parentDependentId.id
          //   : existingAccount.parentDependentId;

          // handleChange(index, "parentDependentId", parentId);
        } else if ((_existingAccount5 = existingAccount) !== null && _existingAccount5 !== void 0 && _existingAccount5.accountHolderType) {
          // Respect "other" or any natively saved type
          handleChange(index, "accountHolderType", existingAccount.accountHolderType);
        } else {
          handleChange(index, "accountHolderType", "self");
        }
      });
    } else {
      var _formdata$workforceEm;
      var existingAccount = accounts[0] || {};
      handleChange(0, "accountHolderName", existingAccount.accountHolderName || (formdata === null || formdata === void 0 || (_formdata$workforceEm = formdata.workforceEmployee) === null || _formdata$workforceEm === void 0 ? void 0 : _formdata$workforceEm.nameEn));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dependent]);

  // simplified flat update handler
  var handleAccountChange = function handleAccountChange(index, key, value) {
    var _dependent$index;
    var nestedKey = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    console.log(dependent);
    var isDependent = Array.isArray(dependent) && dependent.length > 0;
    var dependentId = isDependent ? dependent === null || dependent === void 0 || (_dependent$index = dependent[index]) === null || _dependent$index === void 0 ? void 0 : _dependent$index.id : null;
    var baseAccount = _objectSpread$S(_objectSpread$S({}, accounts[index] || {}), {}, {
      applicant_type: isDependent ? "dependent" : "applicant"
    }, isDependent && {
      id: dependentId
    });
    if (nestedKey) {
      handleChange(index, key, _objectSpread$S(_objectSpread$S({}, baseAccount[key] || {}), {}, _defineProperty({}, nestedKey, value)));
    } else {
      handleChange(index, key, value);
    }
    handleChange(index, "applicant_type", isDependent ? "dependent" : "applicant");
    if (isDependent && dependentId) {
      handleChange(index, "id", dependentId);
    }
  };
  var allowAdd = !applicationId || !((_applicationId$3 = applicationId[0]) !== null && _applicationId$3 !== void 0 && _applicationId$3.id);
  var handleAttachmentChange = useCallback(function (index, fieldKey, value) {
    var normalizeAttachments = function normalizeAttachments(attachments) {
      if (!attachments) return [];
      if (typeof attachments === "string") {
        try {
          var parsed = JSON.parse(attachments);
          return Array.isArray(parsed) ? parsed : [];
        } catch (error) {
          return [];
        }
      }
      return Array.isArray(attachments) ? attachments : [];
    };
    handleChange(index, "attachments", function (currentAttachments) {
      var _value$files;
      var normalizedAttachments = normalizeAttachments(currentAttachments);
      if (!(value !== null && value !== void 0 && (_value$files = value.files) !== null && _value$files !== void 0 && _value$files.length)) {
        return normalizedAttachments.filter(function (att) {
          return att.fieldKey !== fieldKey;
        });
      }
      return normalizedAttachments.some(function (att) {
        return att.fieldKey === fieldKey;
      }) ? normalizedAttachments.map(function (att) {
        return att.fieldKey === fieldKey ? _objectSpread$S(_objectSpread$S({}, att), {}, {
          fieldKey: fieldKey,
          files: value.files,
          documentType: value.documentType,
          documentPropId: value.documentPropId
        }) : att;
      }) : [].concat(_toConsumableArray(normalizedAttachments), [{
        fieldKey: fieldKey,
        files: value.files,
        documentType: value.documentType,
        documentPropId: value.documentPropId
      }]);
    });
  }, [handleChange]);
  console.log({
    accounts: accounts
  });
  return /*#__PURE__*/React.createElement(Box$1, {
    mt: 1
  }, /*#__PURE__*/React.createElement(Typography, {
    mb: 4,
    style: {
      textAlign: "center",
      fontWeight: "bold",
      fontSize: "small",
      margin: "15px"
    }
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "workforce.application.steps.account.info",
    module: "workforce"
  })), ((dependent === null || dependent === void 0 ? void 0 : dependent.length) > 0 ? dependent : [{}]).map(function (dependentValue, index) {
    var _account, _account2, _account3, _dependent$index2, _formdata$workforceEm2, _account4, _account5, _dependent$filter, _account6, _account7, _account8, _account9, _account10, _account11, _account12, _dependent$index3, _formdata$workforceEm3, _ref2, _account$routingNumbe, _account13, _account14, _account15;
    // const account = accounts[index] || {};
    var account = null;
    var _iterator2 = _createForOfIteratorHelper$b(accounts),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var acc = _step2.value;
        if (acc.dependentId === dependentValue.id) {
          account = acc;
          break;
        }
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
    if (account === null) {
      account = accounts[index] || {};
    }
    var accountType = ((_account = account) === null || _account === void 0 ? void 0 : _account.accountType) || "bank";

    // 🎯 New field: whose account?
    var accountHolderType = ((_account2 = account) === null || _account2 === void 0 ? void 0 : _account2.accountHolderType) || "self";
    console.log("account holder 1", (_account3 = account) === null || _account3 === void 0 ? void 0 : _account3.accountHolderName);
    console.log("account holder 2", dependent === null || dependent === void 0 || (_dependent$index2 = dependent[index]) === null || _dependent$index2 === void 0 ? void 0 : _dependent$index2.nameEn);
    console.log("account holder 3", formdata === null || formdata === void 0 || (_formdata$workforceEm2 = formdata.workforceEmployee) === null || _formdata$workforceEm2 === void 0 ? void 0 : _formdata$workforceEm2.nameEn);
    return /*#__PURE__*/React.createElement(Accordion, {
      key: index,
      expanded: expanded === index,
      onChange: function onChange() {
        return setExpanded(expanded === index ? false : index);
      }
    }, /*#__PURE__*/React.createElement(AccordionSummary, {
      expandIcon: /*#__PURE__*/React.createElement(ExpandMoreIcon, null)
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "subtitle2",
      style: {
        fontWeight: "bold"
      }
    }, (_account4 = account) === null || _account4 === void 0 ? void 0 : _account4.accountHolderName, " ", ((_account5 = account) === null || _account5 === void 0 ? void 0 : _account5.accountHolderName) && "এর", " ", /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.previewDetails.employeeBankInfo",
      defaultMessage: "Bank Account ".concat(index + 1)
    }))), /*#__PURE__*/React.createElement(AccordionDetails, null, /*#__PURE__*/React.createElement(Grid, {
      container: true,
      spacing: 2
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12
    }, /*#__PURE__*/React.createElement(FormControl, {
      component: "fieldset"
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "subtitle1",
      style: {
        fontWeight: "bold"
      }
    }, /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.employee.whoseAccount"
    })), /*#__PURE__*/React.createElement(RadioGroup, {
      row: true,
      value: accountHolderType,
      onChange: function onChange(e) {
        return handleAccountChange(index, "accountHolderType", e.target.value);
      }
    }, /*#__PURE__*/React.createElement(FormControlLabel, {
      value: "self",
      control: /*#__PURE__*/React.createElement(Radio, {
        color: "primary"
      }),
      label: /*#__PURE__*/React.createElement(FormattedMessage, {
        id: "workforce.employee.account.self"
      })
    }), isEisPath() && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FormControlLabel
    // disabled={isCfPath()}
    , {
      value: "select_from_another_dependent",
      control: /*#__PURE__*/React.createElement(Radio, {
        color: "primary"
      }),
      label: /*#__PURE__*/React.createElement(FormattedMessage, {
        id: "workforce.employee.account.dependent"
      })
    }), /*#__PURE__*/React.createElement(FormControlLabel
    // disabled={isCfPath()}
    , {
      value: "other",
      control: /*#__PURE__*/React.createElement(Radio, {
        color: "primary"
      }),
      label: /*#__PURE__*/React.createElement(FormattedMessage, {
        id: "workforce.employee.account.other"
      })
    }))))), accountHolderType === "select_from_another_dependent" && /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12
    }, /*#__PURE__*/React.createElement(ParentDependentPicker, {
      value: account.parentDependentId || "",
      onChange: function onChange(v) {
        return handleAccountChange(index, "parentDependentId", v);
      },
      options: dependent === null || dependent === void 0 || (_dependent$filter = dependent.filter(function (d, i) {
        return i !== index;
      })) === null || _dependent$filter === void 0 ? void 0 : _dependent$filter.map(function (dep) {
        var parentAccount = accounts.find(function (acc) {
          return acc.dependentId === dep.id;
        });
        return {
          id: (parentAccount === null || parentAccount === void 0 ? void 0 : parentAccount.id) || dep.id,
          nameEn: dep.nameEn,
          nameBn: dep.nameBn
        };
      })
    })), accountHolderType !== "select_from_another_dependent" && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12
    }, /*#__PURE__*/React.createElement(Paper, {
      className: classes.paper,
      elevation: 0
    }, /*#__PURE__*/React.createElement(FormControl, {
      component: "fieldset"
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "subtitle1",
      style: {
        fontWeight: "bold"
      }
    }, /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.account.selection.type",
      defaultMessage: "Select Account Type"
    })), /*#__PURE__*/React.createElement(RadioGroup, {
      row: true,
      value: accountType,
      onChange: function onChange(e) {
        return handleAccountChange(index, "accountType", e.target.value);
      }
    }, /*#__PURE__*/React.createElement(FormControlLabel, {
      value: "bank",
      control: /*#__PURE__*/React.createElement(Radio, {
        color: "primary"
      }),
      label: /*#__PURE__*/React.createElement(FormattedMessage, {
        id: "workforce.application.account.bank"
      })
    }), /*#__PURE__*/React.createElement(FormControlLabel, {
      disabled: true,
      value: "mobile",
      control: /*#__PURE__*/React.createElement(Radio, {
        color: "primary"
      }),
      label: /*#__PURE__*/React.createElement(FormattedMessage, {
        id: "workforce.application.account.mobile"
      })
    }))), accountType === "bank" && /*#__PURE__*/React.createElement(Grid, {
      container: true,
      spacing: 2
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 6
    }, /*#__PURE__*/React.createElement(PublishedComponent, {
      pubRef: "workforce.BanksPicker",
      value: ((_account6 = account) === null || _account6 === void 0 || (_account6 = _account6.bank) === null || _account6 === void 0 ? void 0 : _account6.id) || null,
      label: /*#__PURE__*/React.createElement(FormattedMessage, {
        id: "workforce.bank.picker"
      }),
      onChange: function onChange(v) {
        return handleAccountChange(index, "bank", v);
      },
      required: true
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 6
    }, /*#__PURE__*/React.createElement(DistrictBanks, {
      id: "districtBank",
      value: ((_account7 = account) === null || _account7 === void 0 ? void 0 : _account7.district) || null,
      bankId: (_account8 = account) === null || _account8 === void 0 || (_account8 = _account8.bank) === null || _account8 === void 0 ? void 0 : _account8.bankCode,
      label: /*#__PURE__*/React.createElement(FormattedMessage, {
        id: "workforce.district.branch.picker"
      }),
      onChange: function onChange(v) {
        return handleAccountChange(index, "district", v);
      },
      required: true
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 6
    }, /*#__PURE__*/React.createElement(BranchPicker, {
      id: "branch",
      value: ((_account9 = account) === null || _account9 === void 0 ? void 0 : _account9.branch) || "",
      bankId: (_account10 = account) === null || _account10 === void 0 || (_account10 = _account10.bank) === null || _account10 === void 0 ? void 0 : _account10.bankCode,
      districtName: (_account11 = account) === null || _account11 === void 0 || (_account11 = _account11.district) === null || _account11 === void 0 ? void 0 : _account11.districtNameBn,
      label: /*#__PURE__*/React.createElement(FormattedMessage, {
        id: "workforce.branch.picker"
      }),
      onChange: function onChange(v) {
        handleAccountChange(index, "branch", v);
        if (v !== null && v !== void 0 && v.routingNumber) {
          handleAccountChange(index, "routingNumber", v.routingNumber);
        }
      },
      required: true
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 6
    }, /*#__PURE__*/React.createElement(TextInput, {
      id: "accountHolderName",
      label: "workforce.employee.account.info.accountHolderName",
      value: ((_account12 = account) === null || _account12 === void 0 ? void 0 : _account12.accountHolderName) || (dependent === null || dependent === void 0 || (_dependent$index3 = dependent[index]) === null || _dependent$index3 === void 0 ? void 0 : _dependent$index3.nameEn) || (formdata === null || formdata === void 0 || (_formdata$workforceEm3 = formdata.workforceEmployee) === null || _formdata$workforceEm3 === void 0 ? void 0 : _formdata$workforceEm3.nameEn),
      onChange: function onChange(v) {
        return handleAccountChange(index, "accountHolderName", v);
      }
      // readOnly={account?.accountHolderName || dependent?.[index]?.nameEn || formdata?.workforceEmployee?.nameEn}
      ,
      required: true
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 6
    }, /*#__PURE__*/React.createElement(TextInput, {
      id: "routingNumber",
      label: "workforce.employee.account.info.routingNumber",
      value: (_ref2 = (_account$routingNumbe = (_account13 = account) === null || _account13 === void 0 ? void 0 : _account13.routingNumber) !== null && _account$routingNumbe !== void 0 ? _account$routingNumbe : (_account14 = account) === null || _account14 === void 0 || (_account14 = _account14.branch) === null || _account14 === void 0 ? void 0 : _account14.routingNumber) !== null && _ref2 !== void 0 ? _ref2 : "",
      onChange: function onChange(v) {
        return handleAccountChange(index, "routingNumber", normalizeNumberInput(v));
      },
      required: true
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 6
    }, /*#__PURE__*/React.createElement(TextInput, {
      id: "accountNumber",
      label: "workforce.employee.account.info.accountNumber",
      value: ((_account15 = account) === null || _account15 === void 0 ? void 0 : _account15.accountNumber) || "",
      onChange: function onChange(v) {
        return handleAccountChange(index, "accountNumber", normalizeNumberInput(v));
      },
      required: true
    }))), accountHolderType === "other" && /*#__PURE__*/React.createElement(Grid, {
      container: true,
      spacing: 2,
      style: {
        marginTop: 12
      }
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 6
    }, /*#__PURE__*/React.createElement(TextInput, {
      id: "relationshipWithAccountHolder",
      label: "workforce.employee.account.info.relationshipWithAccountHolder",
      value: account.relationshipWithAccountHolder || "",
      onChange: function onChange(v) {
        return handleAccountChange(index, "relationshipWithAccountHolder", v);
      },
      required: true
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 6
    }, /*#__PURE__*/React.createElement(TextInput, {
      id: "otherAccountHolderNid",
      label: "workforce.employee.account.info.accountHolderNid",
      value: account.otherAccountHolderNid || "",
      onChange: function onChange(v) {
        return handleAccountChange(index, "otherAccountHolderNid", normalizeNumberInput(v));
      },
      required: true
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 6
    }, /*#__PURE__*/React.createElement(PublishedComponent, {
      pubRef: "workforce.DatePicker",
      label: "workforce.employee.account.info.accountHolderDob",
      value: account.otherAccountHolderDob || "",
      onChange: function onChange(v) {
        return handleAccountChange(index, "otherAccountHolderDob", v);
      },
      readOnly: false,
      required: true
    }), errors.rdmp && /*#__PURE__*/React.createElement(FormHelperText, {
      error: true
    }, formatMessage(errors === null || errors === void 0 ? void 0 : errors.rdmp)))), /*#__PURE__*/React.createElement(Divider, {
      style: {
        margin: "16px 0"
      }
    }), /*#__PURE__*/React.createElement(Button, {
      variant: "contained",
      color: "secondary",
      onClick: function onClick() {
        return removeItem(index);
      },
      disabled: !allowAdd
    }, /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.application.steps.skip",
      defaultMessage: "Remove Account"
    }))))))), /*#__PURE__*/React.createElement(EmployeeDetailsForm2, {
      errors: errors,
      handleChange: function handleChange(fieldKey, value) {
        return handleAttachmentChange(index, fieldKey, value);
      },
      formData: formdata,
      selectedApplicationType: formdata.applicationType,
      formStepNo: "employeeBankInfo",
      accountIndex: index
    }));
  }));
};

function ownKeys$R(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$R(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$R(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$R(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var useStyles$13 = makeStyles(function (theme) {
  return {
    container: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center"
    },
    paper: {
      padding: theme.spacing(2),
      width: 700
    },
    buttonContainer: {
      marginTop: theme.spacing(2),
      display: "flex",
      justifyContent: "flex-end",
      gap: theme.spacing(1)
    }
  };
});
var steps$1 = ["workforce.application.steps.aidReason", "workforce.application.steps.deademployee.applicant.Details", "workforce.application.steps.deathLabourDetails", "workforce.application.steps.location", "workforce.application.steps.prosurders", "workforce.application.steps.account.info"
// "workforce.application.steps.upload.documents",
];
var FinancialAssistanceForm = function FinancialAssistanceForm(_ref) {
  var _formData$workforceEm, _formData$workforceEm2;
  var selectedEmployeeData = _ref.selectedEmployeeData,
    workforceFactoryId = _ref.workforceFactoryId,
    organizationType = _ref.organizationType,
    selectedApplicationType = _ref.selectedApplicationType,
    parsedApplicationData = _ref.parsedApplicationData,
    applicationForSelf = _ref.applicationForSelf,
    selectedFactory = _ref.selectedFactory;
  useSelector(function (state) {
    var _state$workforce$work;
    return (_state$workforce$work = state.workforce["workforceApplicant"]) !== null && _state$workforce$work !== void 0 ? _state$workforce$work : [];
  });
  var modulesManager = useModulesManager();
  var _useTranslations = useTranslations("workforce"),
    formatMessage = _useTranslations.formatMessage;
  var stepRef = useRef(null);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    alertMessage = _useState2[0],
    setAlertMessage = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    dependentErr = _useState4[0],
    setDependentErr = _useState4[1];
  var _useState5 = useState({}),
    _useState6 = _slicedToArray(_useState5, 2),
    errors = _useState6[0],
    setErrors = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    acknowledged = _useState8[0],
    setAcknowledged = _useState8[1];
  var applicationId = useSelector(function (state) {
    var _state$workforce$fetc;
    return (_state$workforce$fetc = state.workforce["fetchedApplicationIdByClientMutationId"]) !== null && _state$workforce$fetc !== void 0 ? _state$workforce$fetc : null;
  });
  // const dependentId = useSelector((state) => state.workforce["workforceDependent"] ?? []);
  var documentType = useSelector(function (state) {
    return state.workforce.documentType;
  });
  var uploadFile = useSelector(function (state) {
    return state.workforce.uploadFile;
  });
  var uploadDependentFile = useSelector(function (state) {
    return state.workforce.uploadDependentFile;
  });
  var uploadBankFile = useSelector(function (state) {
    return state.workforce.uploadBankFile;
  });
  var classes = useStyles$13();
  var dispatch = useDispatch();
  var _useState9 = useState(0),
    _useState10 = _slicedToArray(_useState9, 2),
    expanded = _useState10[0],
    setExpanded = _useState10[1];
  var _useState11 = useState(false),
    _useState12 = _slicedToArray(_useState11, 2),
    isDependentSaved = _useState12[0],
    setIsDependentSaved = _useState12[1];
  var _useState13 = useState(0),
    _useState14 = _slicedToArray(_useState13, 2),
    activeStep = _useState14[0],
    setActiveStep = _useState14[1];
  var _useState15 = useState(false),
    _useState16 = _slicedToArray(_useState15, 2),
    isSubmitted = _useState16[0],
    setIsSubmitted = _useState16[1];
  var _useState17 = useState(false),
    _useState18 = _slicedToArray(_useState17, 2),
    showVerifyNid = _useState18[0],
    setShowVerifyNid = _useState18[1];
  var _useState19 = useState(false),
    _useState20 = _slicedToArray(_useState19, 2),
    showPreview = _useState20[0],
    setShowPreview = _useState20[1];
  var _useState21 = useState(""),
    _useState22 = _slicedToArray(_useState21, 2),
    deathType = _useState22[0],
    setDeathType = _useState22[1];
  var _useState23 = useState(false),
    _useState24 = _slicedToArray(_useState23, 2);
    _useState24[0];
    var setDisableConfirmSubmit = _useState24[1];
  var _useState25 = useState(false),
    _useState26 = _slicedToArray(_useState25, 2),
    showErrorSnackbar = _useState26[0],
    setShowErrorSnackbar = _useState26[1];
  var _useState27 = useState({}),
    _useState28 = _slicedToArray(_useState27, 2);
    _useState28[0];
    var setStepLoadingState = _useState28[1];
  var _useState29 = useState(false),
    _useState30 = _slicedToArray(_useState29, 2),
    isNavigationBlocked = _useState30[0],
    setIsNavigationBlocked = _useState30[1];
  var _useState31 = useState(false),
    _useState32 = _slicedToArray(_useState31, 2),
    showDuplicateError = _useState32[0],
    setShowDuplicateError = _useState32[1];
  var history = useHistory();
  var _useState33 = useState({
      nid: (formData === null || formData === void 0 || (_formData$workforceEm = formData.workforceEmployee) === null || _formData$workforceEm === void 0 ? void 0 : _formData$workforceEm.nid) || "",
      birthCertificateNo: formData === null || formData === void 0 || (_formData$workforceEm2 = formData.workforceEmployee) === null || _formData$workforceEm2 === void 0 ? void 0 : _formData$workforceEm2.birthCertificateNo
    }),
    _useState34 = _slicedToArray(_useState33, 2),
    nidOrBcn = _useState34[0],
    setNidOrBcn = _useState34[1];
  var reduxState = useSelector(function (state) {
    return state;
  });
  var loggedId = useSelector(function (state) {
    var _state$core;
    return (_state$core = state.core) === null || _state$core === void 0 || (_state$core = _state$core.user) === null || _state$core === void 0 || (_state$core = _state$core.i_user) === null || _state$core === void 0 ? void 0 : _state$core.id;
  });
  console.log({
    loggedId: loggedId
  });
  console.log({
    employeeData: employeeData
  });
  var user_type = getUserType();
  var _useState35 = useState({
      workforceEmployee: {
        nameEn: "",
        nameBn: "",
        lastNameEn: "",
        position: "",
        fatherNameEn: "",
        fatherNameBn: "",
        motherNameEn: "",
        motherNameBn: "",
        spouseNameEn: "",
        spouseNameBn: "",
        phoneNumber: "",
        email: "",
        birthDate: "",
        deathDate: "",
        joinDate: "",
        nid: "",
        birthCertificateNo: "",
        insuranceNumber: "",
        lifeStatus: "",
        gender: "",
        maritalStatus: "",
        monthlyEarning: "",
        uploadedNidFile: [],
        citizenship: "",
        uploadedBirthCertificateFile: [],
        permanentAddress: "",
        permanentLocation: "",
        presentLocation: "",
        presentAddress: "",
        organizationId: ""
      },
      workforceApplicant: {
        nameEn: "",
        nameBn: "",
        fatherNameEn: "",
        fatherNameBn: "",
        motherNameEn: "",
        motherNameBn: "",
        spouseNameEn: "",
        spouseNameBn: "",
        phoneNumber: "",
        birthDate: "",
        nid: "",
        birthCertificateNo: "",
        gender: "",
        permanentAddress: "",
        permanentLocation: "",
        presentLocation: "",
        presentAddress: "",
        organizationId: ""
      },
      deathType: deathType,
      company: null,
      factory: selectedFactory || null,
      workforceFactoryId: workforceFactoryId || "",
      isSubmitted: "no",
      organizationType: organizationType,
      applicationType: "",
      dependents: [{}],
      employeeBankInfo: [{}],
      employeeAccidentInfo: {},
      deceasedWorkerInfo: {},
      metadata: {},
      id: ""
    }),
    _useState36 = _slicedToArray(_useState35, 2),
    formData = _useState36[0],
    setFormData = _useState36[1];
  var employeeData = useSelector(function (state) {
    var _state$workforce$work2;
    return (_state$workforce$work2 = state.workforce["workforceEmployee"]) !== null && _state$workforce$work2 !== void 0 ? _state$workforce$work2 : [];
  });
  var pickedEmployeeData = selectedEmployeeData;
  console.log({
    fromFactoryAdminSelectedData: selectedEmployeeData
  });
  useEffect(function () {
    var _applicationId$;
    if (applicationId && applicationId.length > 0 && (_applicationId$ = applicationId[0]) !== null && _applicationId$ !== void 0 && _applicationId$.id) {
      setFormData(function (prev) {
        return _objectSpread$R(_objectSpread$R({}, prev), {}, {
          applicationId: applicationId[0].id
        });
      });
    }
  }, [applicationId]);
  useEffect(function () {
    if (reduxState.core.user.username) {
      dispatch(fetchWorkforceEmployee(modulesManager, ["relatedUser_LoginName_Iexact: \"".concat(reduxState.core.user.username, "\"")]));
    }
  }, [reduxState.core.user.username]);
  useEffect(function () {
    var _employeeData$related;
    var isLoggedInApplicant = loggedId == safeDecodeId(employeeData === null || employeeData === void 0 || (_employeeData$related = employeeData.relatedUser) === null || _employeeData$related === void 0 ? void 0 : _employeeData$related.id);
    console.log({
      isLoggedInApplicant: isLoggedInApplicant
    });
    if (employeeData || parsedApplicationData) {
      // When employeeData is fetched, set it into the form state
      setFormData(function (prev) {
        var _prev$workforceApplic, _parsedApplicationDat, _prev$workforceApplic2, _parsedApplicationDat2, _prev$workforceApplic3, _parsedApplicationDat3, _prev$workforceApplic4, _parsedApplicationDat4, _prev$workforceApplic5, _parsedApplicationDat5, _prev$workforceApplic6, _parsedApplicationDat6, _prev$workforceApplic7, _parsedApplicationDat7, _prev$workforceApplic8, _parsedApplicationDat8, _prev$workforceApplic9, _parsedApplicationDat9, _prev$workforceApplic10, _parsedApplicationDat10, _prev$workforceApplic11, _parsedApplicationDat11, _prev$workforceApplic12, _parsedApplicationDat12, _prev$workforceApplic13, _parsedApplicationDat13, _prev$workforceApplic14, _parsedApplicationDat14, _prev$workforceApplic15, _parsedApplicationDat15, _prev$workforceApplic16, _parsedApplicationDat16, _prev$workforceApplic17, _parsedApplicationDat17, _prev$workforceApplic18, _parsedApplicationDat18, _prev$workforceApplic19, _parsedApplicationDat19, _prev$workforceApplic20, _parsedApplicationDat20, _prev$workforceApplic21, _parsedApplicationDat21, _prev$workforceApplic22, _parsedApplicationDat22, _prev$workforceApplic23, _parsedApplicationDat23, _prev$workforceApplic24, _parsedApplicationDat24, _prev$workforceApplic25, _parsedApplicationDat25, _prev$workforceApplic26, _parsedApplicationDat26, _prev$workforceApplic27, _parsedApplicationDat27, _prev$workforceApplic28, _parsedApplicationDat28, _prev$workforceApplic29, _parsedApplicationDat29, _prev$workforceApplic30, _parsedApplicationDat30, _prev$workforceApplic31, _parsedApplicationDat31, _prev$workforceApplic32, _parsedApplicationDat32, _prev$workforceApplic33, _parsedApplicationDat33, _prev$workforceApplic34, _parsedApplicationDat34, _prev$workforceApplic35, _parsedApplicationDat35, _prev$workforceApplic36, _parsedApplicationDat36, _prev$workforceApplic37, _parsedApplicationDat37, _prev$workforceApplic38, _parsedApplicationDat38, _prev$workforceEmploy, _prev$workforceEmploy2, _prev$workforceEmploy3, _prev$workforceEmploy4, _prev$workforceEmploy5, _prev$workforceEmploy6, _prev$workforceEmploy7, _prev$workforceEmploy8, _prev$workforceEmploy9, _prev$workforceEmploy10, _prev$workforceEmploy11, _prev$workforceEmploy12, _parsedApplicationDat39, _prev$workforceEmploy13, _parsedApplicationDat40, _prev$workforceEmploy14, _parsedApplicationDat41, _prev$workforceEmploy15, _prev$workforceEmploy16, _prev$workforceEmploy17, _prev$workforceEmploy18, _prev$workforceEmploy19, _prev$workforceEmploy20, _prev$workforceEmploy21, _parsedApplicationDat42, _prev$workforceEmploy22, _parsedApplicationDat43, _prev$workforceEmploy23, _parsedApplicationDat44, _prev$workforceEmploy24, _parsedApplicationDat45, _prev$workforceEmploy25, _parsedApplicationDat46, _prev$workforceEmploy26, _parsedApplicationDat47, _prev$workforceEmploy27, _parsedApplicationDat48, _prev$workforceEmploy28, _parsedApplicationDat49, _prev$workforceEmploy29, _parsedApplicationDat50, _prev$workforceEmploy30, _parsedApplicationDat51, _prev$workforceEmploy31, _parsedApplicationDat52, _prev$workforceEmploy32, _parsedApplicationDat53, _prev$workforceEmploy33, _parsedApplicationDat54, _prev$workforceEmploy34, _parsedApplicationDat55, _prev$workforceEmploy35, _parsedApplicationDat56, _prev$workforceEmploy36, _parsedApplicationDat57, _prev$workforceEmploy37, _parsedApplicationDat58, _prev$workforceEmploy38, _parsedApplicationDat59, _prev$workforceEmploy39, _parsedApplicationDat60, _formData$workforceEm3, _formData$employeeFac, _formData$workforceEm4, _prev$deceasedWorkerI, _parsedApplicationDat61, _prev$deceasedWorkerI2, _parsedApplicationDat62, _prev$deceasedWorkerI3, _parsedApplicationDat63, _prev$deceasedWorkerI4, _parsedApplicationDat64, _prev$deceasedWorkerI5, _parsedApplicationDat65, _prev$deceasedWorkerI6, _parsedApplicationDat66, _prev$deceasedWorkerI7, _parsedApplicationDat67, _prev$deceasedWorkerI8, _parsedApplicationDat68, _prev$deceasedWorkerI9, _parsedApplicationDat69, _prev$deceasedWorkerI10, _parsedApplicationDat70, _prev$deceasedWorkerI11, _parsedApplicationDat71, _prev$deceasedWorkerI12, _parsedApplicationDat72, _prev$deceasedWorkerI13, _parsedApplicationDat73, _prev$deceasedWorkerI14, _parsedApplicationDat74, _prev$workforceEmploy40, _prev$deceasedWorkerI15, _prev$workforceEmploy41, _parsedApplicationDat75, _prev$deceasedWorkerI16, _prev$workforceEmploy42, _parsedApplicationDat76, _prev$deceasedWorkerI17, _parsedApplicationDat77, _prev$deceasedWorkerI18, _parsedApplicationDat78, _prev$deceasedWorkerI19, _parsedApplicationDat79, _prev$deceasedWorkerI20, _parsedApplicationDat80, _prev$deceasedWorkerI21, _parsedApplicationDat81;
        return _objectSpread$R(_objectSpread$R({}, prev), {}, {
          id: (parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.id) || "",
          workforceApplicant: user_type === WORKFORCE_USER_TYPE.FACTORY_ADMIN ? _objectSpread$R(_objectSpread$R({}, prev.workforceApplicant), {}, {
            // Preserve the data the user has already typed!
            nameEn: ((_prev$workforceApplic = prev.workforceApplicant) === null || _prev$workforceApplic === void 0 ? void 0 : _prev$workforceApplic.nameEn) || (parsedApplicationData === null || parsedApplicationData === void 0 || (_parsedApplicationDat = parsedApplicationData.applicantInfo) === null || _parsedApplicationDat === void 0 ? void 0 : _parsedApplicationDat.nameEn) || "",
            nameBn: ((_prev$workforceApplic2 = prev.workforceApplicant) === null || _prev$workforceApplic2 === void 0 ? void 0 : _prev$workforceApplic2.nameBn) || (parsedApplicationData === null || parsedApplicationData === void 0 || (_parsedApplicationDat2 = parsedApplicationData.applicantInfo) === null || _parsedApplicationDat2 === void 0 ? void 0 : _parsedApplicationDat2.nameBn) || "",
            fatherNameEn: ((_prev$workforceApplic3 = prev.workforceApplicant) === null || _prev$workforceApplic3 === void 0 ? void 0 : _prev$workforceApplic3.fatherNameEn) || (parsedApplicationData === null || parsedApplicationData === void 0 || (_parsedApplicationDat3 = parsedApplicationData.applicantInfo) === null || _parsedApplicationDat3 === void 0 ? void 0 : _parsedApplicationDat3.fatherNameEn) || "",
            fatherNameBn: ((_prev$workforceApplic4 = prev.workforceApplicant) === null || _prev$workforceApplic4 === void 0 ? void 0 : _prev$workforceApplic4.fatherNameBn) || (parsedApplicationData === null || parsedApplicationData === void 0 || (_parsedApplicationDat4 = parsedApplicationData.applicantInfo) === null || _parsedApplicationDat4 === void 0 ? void 0 : _parsedApplicationDat4.fatherNameBn) || "",
            motherNameEn: ((_prev$workforceApplic5 = prev.workforceApplicant) === null || _prev$workforceApplic5 === void 0 ? void 0 : _prev$workforceApplic5.motherNameEn) || (parsedApplicationData === null || parsedApplicationData === void 0 || (_parsedApplicationDat5 = parsedApplicationData.applicantInfo) === null || _parsedApplicationDat5 === void 0 ? void 0 : _parsedApplicationDat5.motherNameEn) || "",
            motherNameBn: ((_prev$workforceApplic6 = prev.workforceApplicant) === null || _prev$workforceApplic6 === void 0 ? void 0 : _prev$workforceApplic6.motherNameBn) || (parsedApplicationData === null || parsedApplicationData === void 0 || (_parsedApplicationDat6 = parsedApplicationData.applicantInfo) === null || _parsedApplicationDat6 === void 0 ? void 0 : _parsedApplicationDat6.motherNameBn) || "",
            spouseNameEn: ((_prev$workforceApplic7 = prev.workforceApplicant) === null || _prev$workforceApplic7 === void 0 ? void 0 : _prev$workforceApplic7.spouseNameEn) || (parsedApplicationData === null || parsedApplicationData === void 0 || (_parsedApplicationDat7 = parsedApplicationData.applicantInfo) === null || _parsedApplicationDat7 === void 0 ? void 0 : _parsedApplicationDat7.spouseNameEn) || "",
            spouseNameBn: ((_prev$workforceApplic8 = prev.workforceApplicant) === null || _prev$workforceApplic8 === void 0 ? void 0 : _prev$workforceApplic8.spouseNameBn) || (parsedApplicationData === null || parsedApplicationData === void 0 || (_parsedApplicationDat8 = parsedApplicationData.applicantInfo) === null || _parsedApplicationDat8 === void 0 ? void 0 : _parsedApplicationDat8.spouseNameBn) || "",
            phoneNumber: ((_prev$workforceApplic9 = prev.workforceApplicant) === null || _prev$workforceApplic9 === void 0 ? void 0 : _prev$workforceApplic9.phoneNumber) || (parsedApplicationData === null || parsedApplicationData === void 0 || (_parsedApplicationDat9 = parsedApplicationData.applicantInfo) === null || _parsedApplicationDat9 === void 0 ? void 0 : _parsedApplicationDat9.phoneNumber) || "",
            citizenship: ((_prev$workforceApplic10 = prev.workforceApplicant) === null || _prev$workforceApplic10 === void 0 ? void 0 : _prev$workforceApplic10.citizenship) || (parsedApplicationData === null || parsedApplicationData === void 0 || (_parsedApplicationDat10 = parsedApplicationData.applicantInfo) === null || _parsedApplicationDat10 === void 0 ? void 0 : _parsedApplicationDat10.citizenship) || "",
            relationWithApplicant: ((_prev$workforceApplic11 = prev.workforceApplicant) === null || _prev$workforceApplic11 === void 0 ? void 0 : _prev$workforceApplic11.relationWithApplicant) || (parsedApplicationData === null || parsedApplicationData === void 0 || (_parsedApplicationDat11 = parsedApplicationData.applicantInfo) === null || _parsedApplicationDat11 === void 0 ? void 0 : _parsedApplicationDat11.relationWithApplicant) || "",
            birthDate: ((_prev$workforceApplic12 = prev.workforceApplicant) === null || _prev$workforceApplic12 === void 0 ? void 0 : _prev$workforceApplic12.birthDate) || (parsedApplicationData === null || parsedApplicationData === void 0 || (_parsedApplicationDat12 = parsedApplicationData.applicantInfo) === null || _parsedApplicationDat12 === void 0 ? void 0 : _parsedApplicationDat12.birthDate) || "",
            gender: ((_prev$workforceApplic13 = prev.workforceApplicant) === null || _prev$workforceApplic13 === void 0 ? void 0 : _prev$workforceApplic13.gender) || (parsedApplicationData === null || parsedApplicationData === void 0 || (_parsedApplicationDat13 = parsedApplicationData.applicantInfo) === null || _parsedApplicationDat13 === void 0 ? void 0 : _parsedApplicationDat13.gender) || "",
            nid: ((_prev$workforceApplic14 = prev.workforceApplicant) === null || _prev$workforceApplic14 === void 0 ? void 0 : _prev$workforceApplic14.nid) || (parsedApplicationData === null || parsedApplicationData === void 0 || (_parsedApplicationDat14 = parsedApplicationData.applicantInfo) === null || _parsedApplicationDat14 === void 0 ? void 0 : _parsedApplicationDat14.nid) || "",
            birthCertificateNo: ((_prev$workforceApplic15 = prev.workforceApplicant) === null || _prev$workforceApplic15 === void 0 ? void 0 : _prev$workforceApplic15.birthCertificateNo) || (parsedApplicationData === null || parsedApplicationData === void 0 || (_parsedApplicationDat15 = parsedApplicationData.applicantInfo) === null || _parsedApplicationDat15 === void 0 ? void 0 : _parsedApplicationDat15.birthCertificateNo) || "",
            permanentAddress: ((_prev$workforceApplic16 = prev.workforceApplicant) === null || _prev$workforceApplic16 === void 0 ? void 0 : _prev$workforceApplic16.permanentAddress) || (parsedApplicationData === null || parsedApplicationData === void 0 || (_parsedApplicationDat16 = parsedApplicationData.applicantInfo) === null || _parsedApplicationDat16 === void 0 ? void 0 : _parsedApplicationDat16.permanentAddress) || "",
            permanentLocation: ((_prev$workforceApplic17 = prev.workforceApplicant) === null || _prev$workforceApplic17 === void 0 ? void 0 : _prev$workforceApplic17.permanentLocation) || (parsedApplicationData === null || parsedApplicationData === void 0 || (_parsedApplicationDat17 = parsedApplicationData.applicantInfo) === null || _parsedApplicationDat17 === void 0 ? void 0 : _parsedApplicationDat17.permanentLocation) || "",
            presentLocation: ((_prev$workforceApplic18 = prev.workforceApplicant) === null || _prev$workforceApplic18 === void 0 ? void 0 : _prev$workforceApplic18.presentLocation) || (parsedApplicationData === null || parsedApplicationData === void 0 || (_parsedApplicationDat18 = parsedApplicationData.applicantInfo) === null || _parsedApplicationDat18 === void 0 ? void 0 : _parsedApplicationDat18.presentLocation) || "",
            presentAddress: ((_prev$workforceApplic19 = prev.workforceApplicant) === null || _prev$workforceApplic19 === void 0 ? void 0 : _prev$workforceApplic19.presentAddress) || (parsedApplicationData === null || parsedApplicationData === void 0 || (_parsedApplicationDat19 = parsedApplicationData.applicantInfo) === null || _parsedApplicationDat19 === void 0 ? void 0 : _parsedApplicationDat19.presentAddress) || ""
          }) : _objectSpread$R(_objectSpread$R({}, prev.workforceApplicant), {}, {
            // Preserve the data the user has already typed!
            nameEn: ((_prev$workforceApplic20 = prev.workforceApplicant) === null || _prev$workforceApplic20 === void 0 ? void 0 : _prev$workforceApplic20.nameEn) || (parsedApplicationData === null || parsedApplicationData === void 0 || (_parsedApplicationDat20 = parsedApplicationData.applicantInfo) === null || _parsedApplicationDat20 === void 0 ? void 0 : _parsedApplicationDat20.nameEn) || (employeeData === null || employeeData === void 0 ? void 0 : employeeData.firstNameEn) || "",
            nameBn: ((_prev$workforceApplic21 = prev.workforceApplicant) === null || _prev$workforceApplic21 === void 0 ? void 0 : _prev$workforceApplic21.nameBn) || (parsedApplicationData === null || parsedApplicationData === void 0 || (_parsedApplicationDat21 = parsedApplicationData.applicantInfo) === null || _parsedApplicationDat21 === void 0 ? void 0 : _parsedApplicationDat21.nameBn) || (employeeData === null || employeeData === void 0 ? void 0 : employeeData.firstNameBn) || "",
            fatherNameEn: ((_prev$workforceApplic22 = prev.workforceApplicant) === null || _prev$workforceApplic22 === void 0 ? void 0 : _prev$workforceApplic22.fatherNameEn) || (parsedApplicationData === null || parsedApplicationData === void 0 || (_parsedApplicationDat22 = parsedApplicationData.applicantInfo) === null || _parsedApplicationDat22 === void 0 ? void 0 : _parsedApplicationDat22.fatherNameEn) || (employeeData === null || employeeData === void 0 ? void 0 : employeeData.fatherNameEn) || "",
            fatherNameBn: ((_prev$workforceApplic23 = prev.workforceApplicant) === null || _prev$workforceApplic23 === void 0 ? void 0 : _prev$workforceApplic23.fatherNameBn) || (parsedApplicationData === null || parsedApplicationData === void 0 || (_parsedApplicationDat23 = parsedApplicationData.applicantInfo) === null || _parsedApplicationDat23 === void 0 ? void 0 : _parsedApplicationDat23.fatherNameBn) || (employeeData === null || employeeData === void 0 ? void 0 : employeeData.fatherNameBn) || "",
            motherNameEn: ((_prev$workforceApplic24 = prev.workforceApplicant) === null || _prev$workforceApplic24 === void 0 ? void 0 : _prev$workforceApplic24.motherNameEn) || (parsedApplicationData === null || parsedApplicationData === void 0 || (_parsedApplicationDat24 = parsedApplicationData.applicantInfo) === null || _parsedApplicationDat24 === void 0 ? void 0 : _parsedApplicationDat24.motherNameEn) || (employeeData === null || employeeData === void 0 ? void 0 : employeeData.motherNameEn) || "",
            motherNameBn: ((_prev$workforceApplic25 = prev.workforceApplicant) === null || _prev$workforceApplic25 === void 0 ? void 0 : _prev$workforceApplic25.motherNameBn) || (parsedApplicationData === null || parsedApplicationData === void 0 || (_parsedApplicationDat25 = parsedApplicationData.applicantInfo) === null || _parsedApplicationDat25 === void 0 ? void 0 : _parsedApplicationDat25.motherNameBn) || (employeeData === null || employeeData === void 0 ? void 0 : employeeData.motherNameBn) || "",
            spouseNameEn: ((_prev$workforceApplic26 = prev.workforceApplicant) === null || _prev$workforceApplic26 === void 0 ? void 0 : _prev$workforceApplic26.spouseNameEn) || (parsedApplicationData === null || parsedApplicationData === void 0 || (_parsedApplicationDat26 = parsedApplicationData.applicantInfo) === null || _parsedApplicationDat26 === void 0 ? void 0 : _parsedApplicationDat26.spouseNameEn) || (employeeData === null || employeeData === void 0 ? void 0 : employeeData.spouseNameEn) || "",
            spouseNameBn: ((_prev$workforceApplic27 = prev.workforceApplicant) === null || _prev$workforceApplic27 === void 0 ? void 0 : _prev$workforceApplic27.spouseNameBn) || (parsedApplicationData === null || parsedApplicationData === void 0 || (_parsedApplicationDat27 = parsedApplicationData.applicantInfo) === null || _parsedApplicationDat27 === void 0 ? void 0 : _parsedApplicationDat27.spouseNameBn) || (employeeData === null || employeeData === void 0 ? void 0 : employeeData.spouseNameBn) || "",
            phoneNumber: ((_prev$workforceApplic28 = prev.workforceApplicant) === null || _prev$workforceApplic28 === void 0 ? void 0 : _prev$workforceApplic28.phoneNumber) || (parsedApplicationData === null || parsedApplicationData === void 0 || (_parsedApplicationDat28 = parsedApplicationData.applicantInfo) === null || _parsedApplicationDat28 === void 0 ? void 0 : _parsedApplicationDat28.phoneNumber) || (employeeData === null || employeeData === void 0 ? void 0 : employeeData.phoneNumber) || "",
            citizenship: ((_prev$workforceApplic29 = prev.workforceApplicant) === null || _prev$workforceApplic29 === void 0 ? void 0 : _prev$workforceApplic29.citizenship) || (parsedApplicationData === null || parsedApplicationData === void 0 || (_parsedApplicationDat29 = parsedApplicationData.applicantInfo) === null || _parsedApplicationDat29 === void 0 ? void 0 : _parsedApplicationDat29.citizenship) || (employeeData === null || employeeData === void 0 ? void 0 : employeeData.citizenship) || "",
            relationWithApplicant: ((_prev$workforceApplic30 = prev.workforceApplicant) === null || _prev$workforceApplic30 === void 0 ? void 0 : _prev$workforceApplic30.relationWithApplicant) || (parsedApplicationData === null || parsedApplicationData === void 0 || (_parsedApplicationDat30 = parsedApplicationData.applicantInfo) === null || _parsedApplicationDat30 === void 0 ? void 0 : _parsedApplicationDat30.relationWithApplicant) || "",
            birthDate: ((_prev$workforceApplic31 = prev.workforceApplicant) === null || _prev$workforceApplic31 === void 0 ? void 0 : _prev$workforceApplic31.birthDate) || (parsedApplicationData === null || parsedApplicationData === void 0 || (_parsedApplicationDat31 = parsedApplicationData.applicantInfo) === null || _parsedApplicationDat31 === void 0 ? void 0 : _parsedApplicationDat31.birthDate) || (employeeData === null || employeeData === void 0 ? void 0 : employeeData.birthDate) || "",
            gender: ((_prev$workforceApplic32 = prev.workforceApplicant) === null || _prev$workforceApplic32 === void 0 ? void 0 : _prev$workforceApplic32.gender) || (parsedApplicationData === null || parsedApplicationData === void 0 || (_parsedApplicationDat32 = parsedApplicationData.applicantInfo) === null || _parsedApplicationDat32 === void 0 ? void 0 : _parsedApplicationDat32.gender) || (employeeData === null || employeeData === void 0 ? void 0 : employeeData.gender) || "",
            nid: ((_prev$workforceApplic33 = prev.workforceApplicant) === null || _prev$workforceApplic33 === void 0 ? void 0 : _prev$workforceApplic33.nid) || (parsedApplicationData === null || parsedApplicationData === void 0 || (_parsedApplicationDat33 = parsedApplicationData.applicantInfo) === null || _parsedApplicationDat33 === void 0 ? void 0 : _parsedApplicationDat33.nid) || (employeeData === null || employeeData === void 0 ? void 0 : employeeData.nid) || "",
            birthCertificateNo: ((_prev$workforceApplic34 = prev.workforceApplicant) === null || _prev$workforceApplic34 === void 0 ? void 0 : _prev$workforceApplic34.birthCertificateNo) || (parsedApplicationData === null || parsedApplicationData === void 0 || (_parsedApplicationDat34 = parsedApplicationData.applicantInfo) === null || _parsedApplicationDat34 === void 0 ? void 0 : _parsedApplicationDat34.birthCertificateNo) || (employeeData === null || employeeData === void 0 ? void 0 : employeeData.birthCertificateNo) || "",
            permanentAddress: ((_prev$workforceApplic35 = prev.workforceApplicant) === null || _prev$workforceApplic35 === void 0 ? void 0 : _prev$workforceApplic35.permanentAddress) || (parsedApplicationData === null || parsedApplicationData === void 0 || (_parsedApplicationDat35 = parsedApplicationData.applicantInfo) === null || _parsedApplicationDat35 === void 0 ? void 0 : _parsedApplicationDat35.permanentAddress) || (employeeData === null || employeeData === void 0 ? void 0 : employeeData.permanentAddress) || "",
            permanentLocation: ((_prev$workforceApplic36 = prev.workforceApplicant) === null || _prev$workforceApplic36 === void 0 ? void 0 : _prev$workforceApplic36.permanentLocation) || (parsedApplicationData === null || parsedApplicationData === void 0 || (_parsedApplicationDat36 = parsedApplicationData.applicantInfo) === null || _parsedApplicationDat36 === void 0 ? void 0 : _parsedApplicationDat36.permanentLocation) || (employeeData === null || employeeData === void 0 ? void 0 : employeeData.permanentLocation) || "",
            presentLocation: ((_prev$workforceApplic37 = prev.workforceApplicant) === null || _prev$workforceApplic37 === void 0 ? void 0 : _prev$workforceApplic37.presentLocation) || (parsedApplicationData === null || parsedApplicationData === void 0 || (_parsedApplicationDat37 = parsedApplicationData.applicantInfo) === null || _parsedApplicationDat37 === void 0 ? void 0 : _parsedApplicationDat37.presentLocation) || (employeeData === null || employeeData === void 0 ? void 0 : employeeData.presentLocation) || "",
            presentAddress: ((_prev$workforceApplic38 = prev.workforceApplicant) === null || _prev$workforceApplic38 === void 0 ? void 0 : _prev$workforceApplic38.presentAddress) || (parsedApplicationData === null || parsedApplicationData === void 0 || (_parsedApplicationDat38 = parsedApplicationData.applicantInfo) === null || _parsedApplicationDat38 === void 0 ? void 0 : _parsedApplicationDat38.presentAddress) || (employeeData === null || employeeData === void 0 ? void 0 : employeeData.presentAddress) || ""
          }),
          workforceEmployee: parsedApplicationData ? _objectSpread$R(_objectSpread$R({}, parsedApplicationData.deceasedWorkerInfo), {}, {
            // Retain the existing workforceEmployee id
            id: (_prev$workforceEmploy = prev.workforceEmployee) === null || _prev$workforceEmploy === void 0 ? void 0 : _prev$workforceEmploy.id
          }) : user_type === WORKFORCE_USER_TYPE.FACTORY_ADMIN ? _objectSpread$R(_objectSpread$R({}, prev.workforceEmployee), {}, {
            nameEn: ((_prev$workforceEmploy2 = prev.workforceEmployee) === null || _prev$workforceEmploy2 === void 0 ? void 0 : _prev$workforceEmploy2.nameEn) || (pickedEmployeeData === null || pickedEmployeeData === void 0 ? void 0 : pickedEmployeeData.firstNameEn) || "",
            nameBn: ((_prev$workforceEmploy3 = prev.workforceEmployee) === null || _prev$workforceEmploy3 === void 0 ? void 0 : _prev$workforceEmploy3.nameBn) || (pickedEmployeeData === null || pickedEmployeeData === void 0 ? void 0 : pickedEmployeeData.firstNameBn) || "",
            fatherNameEn: ((_prev$workforceEmploy4 = prev.workforceEmployee) === null || _prev$workforceEmploy4 === void 0 ? void 0 : _prev$workforceEmploy4.fatherNameEn) || (pickedEmployeeData === null || pickedEmployeeData === void 0 ? void 0 : pickedEmployeeData.fatherNameEn) || "",
            fatherNameBn: ((_prev$workforceEmploy5 = prev.workforceEmployee) === null || _prev$workforceEmploy5 === void 0 ? void 0 : _prev$workforceEmploy5.fatherNameBn) || (pickedEmployeeData === null || pickedEmployeeData === void 0 ? void 0 : pickedEmployeeData.fatherNameBn) || "",
            motherNameEn: ((_prev$workforceEmploy6 = prev.workforceEmployee) === null || _prev$workforceEmploy6 === void 0 ? void 0 : _prev$workforceEmploy6.motherNameEn) || (pickedEmployeeData === null || pickedEmployeeData === void 0 ? void 0 : pickedEmployeeData.motherNameEn) || "",
            motherNameBn: ((_prev$workforceEmploy7 = prev.workforceEmployee) === null || _prev$workforceEmploy7 === void 0 ? void 0 : _prev$workforceEmploy7.motherNameBn) || (pickedEmployeeData === null || pickedEmployeeData === void 0 ? void 0 : pickedEmployeeData.motherNameBn) || "",
            spouseNameEn: ((_prev$workforceEmploy8 = prev.workforceEmployee) === null || _prev$workforceEmploy8 === void 0 ? void 0 : _prev$workforceEmploy8.spouseNameEn) || (pickedEmployeeData === null || pickedEmployeeData === void 0 ? void 0 : pickedEmployeeData.spouseNameEn) || "",
            spouseNameBn: ((_prev$workforceEmploy9 = prev.workforceEmployee) === null || _prev$workforceEmploy9 === void 0 ? void 0 : _prev$workforceEmploy9.spouseNameBn) || (pickedEmployeeData === null || pickedEmployeeData === void 0 ? void 0 : pickedEmployeeData.spouseNameBn) || "",
            citizenship: ((_prev$workforceEmploy10 = prev.workforceEmployee) === null || _prev$workforceEmploy10 === void 0 ? void 0 : _prev$workforceEmploy10.citizenship) || (pickedEmployeeData === null || pickedEmployeeData === void 0 ? void 0 : pickedEmployeeData.citizenship) || "",
            phoneNumber: ((_prev$workforceEmploy11 = prev.workforceEmployee) === null || _prev$workforceEmploy11 === void 0 ? void 0 : _prev$workforceEmploy11.phoneNumber) || (pickedEmployeeData === null || pickedEmployeeData === void 0 ? void 0 : pickedEmployeeData.phoneNumber) || "",
            relationWithApplicant: ((_prev$workforceEmploy12 = prev.workforceEmployee) === null || _prev$workforceEmploy12 === void 0 ? void 0 : _prev$workforceEmploy12.relationWithApplicant) || (parsedApplicationData === null || parsedApplicationData === void 0 || (_parsedApplicationDat39 = parsedApplicationData.deceasedWorkerInfo) === null || _parsedApplicationDat39 === void 0 ? void 0 : _parsedApplicationDat39.relationWithApplicant) || "",
            birthDate: ((_prev$workforceEmploy13 = prev.workforceEmployee) === null || _prev$workforceEmploy13 === void 0 ? void 0 : _prev$workforceEmploy13.birthDate) || (parsedApplicationData === null || parsedApplicationData === void 0 || (_parsedApplicationDat40 = parsedApplicationData.deceasedWorkerInfo) === null || _parsedApplicationDat40 === void 0 ? void 0 : _parsedApplicationDat40.birthDate) || (pickedEmployeeData === null || pickedEmployeeData === void 0 ? void 0 : pickedEmployeeData.birthDate) || "",
            gender: ((_prev$workforceEmploy14 = prev.workforceEmployee) === null || _prev$workforceEmploy14 === void 0 ? void 0 : _prev$workforceEmploy14.gender) || (parsedApplicationData === null || parsedApplicationData === void 0 || (_parsedApplicationDat41 = parsedApplicationData.deceasedWorkerInfo) === null || _parsedApplicationDat41 === void 0 ? void 0 : _parsedApplicationDat41.gender) || (pickedEmployeeData === null || pickedEmployeeData === void 0 ? void 0 : pickedEmployeeData.gender) || "",
            nid: ((_prev$workforceEmploy15 = prev.workforceEmployee) === null || _prev$workforceEmploy15 === void 0 ? void 0 : _prev$workforceEmploy15.nid) || (pickedEmployeeData === null || pickedEmployeeData === void 0 ? void 0 : pickedEmployeeData.nid) || "",
            birthCertificateNo: ((_prev$workforceEmploy16 = prev.workforceEmployee) === null || _prev$workforceEmploy16 === void 0 ? void 0 : _prev$workforceEmploy16.birthCertificateNo) || (pickedEmployeeData === null || pickedEmployeeData === void 0 ? void 0 : pickedEmployeeData.birthCertificateNo) || "",
            permanentAddress: ((_prev$workforceEmploy17 = prev.workforceEmployee) === null || _prev$workforceEmploy17 === void 0 ? void 0 : _prev$workforceEmploy17.permanentAddress) || (pickedEmployeeData === null || pickedEmployeeData === void 0 ? void 0 : pickedEmployeeData.permanentAddress) || "",
            permanentLocation: ((_prev$workforceEmploy18 = prev.workforceEmployee) === null || _prev$workforceEmploy18 === void 0 ? void 0 : _prev$workforceEmploy18.permanentLocation) || (pickedEmployeeData === null || pickedEmployeeData === void 0 ? void 0 : pickedEmployeeData.permanentLocation) || "",
            presentLocation: ((_prev$workforceEmploy19 = prev.workforceEmployee) === null || _prev$workforceEmploy19 === void 0 ? void 0 : _prev$workforceEmploy19.presentLocation) || (pickedEmployeeData === null || pickedEmployeeData === void 0 ? void 0 : pickedEmployeeData.presentLocation) || "",
            presentAddress: ((_prev$workforceEmploy20 = prev.workforceEmployee) === null || _prev$workforceEmploy20 === void 0 ? void 0 : _prev$workforceEmploy20.presentAddress) || (pickedEmployeeData === null || pickedEmployeeData === void 0 ? void 0 : pickedEmployeeData.presentAddress) || ""
          }) : _objectSpread$R(_objectSpread$R(_objectSpread$R({}, prev.workforceEmployee), parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.deceasedWorkerInfo), {}, {
            nameEn: ((_prev$workforceEmploy21 = prev.workforceEmployee) === null || _prev$workforceEmploy21 === void 0 ? void 0 : _prev$workforceEmploy21.nameEn) || (parsedApplicationData === null || parsedApplicationData === void 0 || (_parsedApplicationDat42 = parsedApplicationData.deceasedWorkerInfo) === null || _parsedApplicationDat42 === void 0 ? void 0 : _parsedApplicationDat42.nameEn) || "",
            nameBn: ((_prev$workforceEmploy22 = prev.workforceEmployee) === null || _prev$workforceEmploy22 === void 0 ? void 0 : _prev$workforceEmploy22.nameBn) || (parsedApplicationData === null || parsedApplicationData === void 0 || (_parsedApplicationDat43 = parsedApplicationData.deceasedWorkerInfo) === null || _parsedApplicationDat43 === void 0 ? void 0 : _parsedApplicationDat43.nameBn) || "",
            fatherNameEn: ((_prev$workforceEmploy23 = prev.workforceEmployee) === null || _prev$workforceEmploy23 === void 0 ? void 0 : _prev$workforceEmploy23.fatherNameEn) || (parsedApplicationData === null || parsedApplicationData === void 0 || (_parsedApplicationDat44 = parsedApplicationData.deceasedWorkerInfo) === null || _parsedApplicationDat44 === void 0 ? void 0 : _parsedApplicationDat44.fatherNameEn) || "",
            fatherNameBn: ((_prev$workforceEmploy24 = prev.workforceEmployee) === null || _prev$workforceEmploy24 === void 0 ? void 0 : _prev$workforceEmploy24.fatherNameBn) || (parsedApplicationData === null || parsedApplicationData === void 0 || (_parsedApplicationDat45 = parsedApplicationData.deceasedWorkerInfo) === null || _parsedApplicationDat45 === void 0 ? void 0 : _parsedApplicationDat45.fatherNameBn) || "",
            motherNameEn: ((_prev$workforceEmploy25 = prev.workforceEmployee) === null || _prev$workforceEmploy25 === void 0 ? void 0 : _prev$workforceEmploy25.motherNameEn) || (parsedApplicationData === null || parsedApplicationData === void 0 || (_parsedApplicationDat46 = parsedApplicationData.deceasedWorkerInfo) === null || _parsedApplicationDat46 === void 0 ? void 0 : _parsedApplicationDat46.motherNameEn) || "",
            motherNameBn: ((_prev$workforceEmploy26 = prev.workforceEmployee) === null || _prev$workforceEmploy26 === void 0 ? void 0 : _prev$workforceEmploy26.motherNameBn) || (parsedApplicationData === null || parsedApplicationData === void 0 || (_parsedApplicationDat47 = parsedApplicationData.deceasedWorkerInfo) === null || _parsedApplicationDat47 === void 0 ? void 0 : _parsedApplicationDat47.motherNameBn) || "",
            spouseNameEn: ((_prev$workforceEmploy27 = prev.workforceEmployee) === null || _prev$workforceEmploy27 === void 0 ? void 0 : _prev$workforceEmploy27.spouseNameEn) || (parsedApplicationData === null || parsedApplicationData === void 0 || (_parsedApplicationDat48 = parsedApplicationData.deceasedWorkerInfo) === null || _parsedApplicationDat48 === void 0 ? void 0 : _parsedApplicationDat48.spouseNameEn) || "",
            spouseNameBn: ((_prev$workforceEmploy28 = prev.workforceEmployee) === null || _prev$workforceEmploy28 === void 0 ? void 0 : _prev$workforceEmploy28.spouseNameBn) || (parsedApplicationData === null || parsedApplicationData === void 0 || (_parsedApplicationDat49 = parsedApplicationData.deceasedWorkerInfo) === null || _parsedApplicationDat49 === void 0 ? void 0 : _parsedApplicationDat49.spouseNameBn) || "",
            phoneNumber: ((_prev$workforceEmploy29 = prev.workforceEmployee) === null || _prev$workforceEmploy29 === void 0 ? void 0 : _prev$workforceEmploy29.phoneNumber) || (parsedApplicationData === null || parsedApplicationData === void 0 || (_parsedApplicationDat50 = parsedApplicationData.deceasedWorkerInfo) === null || _parsedApplicationDat50 === void 0 ? void 0 : _parsedApplicationDat50.phoneNumber) || "",
            birthDate: ((_prev$workforceEmploy30 = prev.workforceEmployee) === null || _prev$workforceEmploy30 === void 0 ? void 0 : _prev$workforceEmploy30.birthDate) || (parsedApplicationData === null || parsedApplicationData === void 0 || (_parsedApplicationDat51 = parsedApplicationData.deceasedWorkerInfo) === null || _parsedApplicationDat51 === void 0 ? void 0 : _parsedApplicationDat51.birthDate) || "",
            gender: ((_prev$workforceEmploy31 = prev.workforceEmployee) === null || _prev$workforceEmploy31 === void 0 ? void 0 : _prev$workforceEmploy31.gender) || (parsedApplicationData === null || parsedApplicationData === void 0 || (_parsedApplicationDat52 = parsedApplicationData.deceasedWorkerInfo) === null || _parsedApplicationDat52 === void 0 ? void 0 : _parsedApplicationDat52.gender) || "",
            citizenship: ((_prev$workforceEmploy32 = prev.workforceEmployee) === null || _prev$workforceEmploy32 === void 0 ? void 0 : _prev$workforceEmploy32.citizenship) || (parsedApplicationData === null || parsedApplicationData === void 0 || (_parsedApplicationDat53 = parsedApplicationData.deceasedWorkerInfo) === null || _parsedApplicationDat53 === void 0 ? void 0 : _parsedApplicationDat53.citizenship) || "",
            maritalStatus: ((_prev$workforceEmploy33 = prev.workforceEmployee) === null || _prev$workforceEmploy33 === void 0 ? void 0 : _prev$workforceEmploy33.maritalStatus) || (parsedApplicationData === null || parsedApplicationData === void 0 || (_parsedApplicationDat54 = parsedApplicationData.deceasedWorkerInfo) === null || _parsedApplicationDat54 === void 0 ? void 0 : _parsedApplicationDat54.maritalStatus) || "",
            nid: ((_prev$workforceEmploy34 = prev.workforceEmployee) === null || _prev$workforceEmploy34 === void 0 ? void 0 : _prev$workforceEmploy34.nid) || (parsedApplicationData === null || parsedApplicationData === void 0 || (_parsedApplicationDat55 = parsedApplicationData.deceasedWorkerInfo) === null || _parsedApplicationDat55 === void 0 ? void 0 : _parsedApplicationDat55.nid) || "",
            birthCertificateNo: ((_prev$workforceEmploy35 = prev.workforceEmployee) === null || _prev$workforceEmploy35 === void 0 ? void 0 : _prev$workforceEmploy35.birthCertificateNo) || (parsedApplicationData === null || parsedApplicationData === void 0 || (_parsedApplicationDat56 = parsedApplicationData.deceasedWorkerInfo) === null || _parsedApplicationDat56 === void 0 ? void 0 : _parsedApplicationDat56.birthCertificateNo) || "",
            permanentAddress: ((_prev$workforceEmploy36 = prev.workforceEmployee) === null || _prev$workforceEmploy36 === void 0 ? void 0 : _prev$workforceEmploy36.permanentAddress) || (parsedApplicationData === null || parsedApplicationData === void 0 || (_parsedApplicationDat57 = parsedApplicationData.deceasedWorkerInfo) === null || _parsedApplicationDat57 === void 0 ? void 0 : _parsedApplicationDat57.permanentAddress) || "",
            permanentLocation: ((_prev$workforceEmploy37 = prev.workforceEmployee) === null || _prev$workforceEmploy37 === void 0 ? void 0 : _prev$workforceEmploy37.permanentLocation) || (parsedApplicationData === null || parsedApplicationData === void 0 || (_parsedApplicationDat58 = parsedApplicationData.deceasedWorkerInfo) === null || _parsedApplicationDat58 === void 0 ? void 0 : _parsedApplicationDat58.permanentLocation) || "",
            presentLocation: ((_prev$workforceEmploy38 = prev.workforceEmployee) === null || _prev$workforceEmploy38 === void 0 ? void 0 : _prev$workforceEmploy38.presentLocation) || (parsedApplicationData === null || parsedApplicationData === void 0 || (_parsedApplicationDat59 = parsedApplicationData.deceasedWorkerInfo) === null || _parsedApplicationDat59 === void 0 ? void 0 : _parsedApplicationDat59.presentLocation) || "",
            presentAddress: ((_prev$workforceEmploy39 = prev.workforceEmployee) === null || _prev$workforceEmploy39 === void 0 ? void 0 : _prev$workforceEmploy39.presentAddress) || (parsedApplicationData === null || parsedApplicationData === void 0 || (_parsedApplicationDat60 = parsedApplicationData.deceasedWorkerInfo) === null || _parsedApplicationDat60 === void 0 ? void 0 : _parsedApplicationDat60.presentAddress) || ""
          }),
          company: (employeeData === null || employeeData === void 0 ? void 0 : employeeData.company) || (formData === null || formData === void 0 || (_formData$workforceEm3 = formData.workforceEmployee) === null || _formData$workforceEm3 === void 0 || (_formData$workforceEm3 = _formData$workforceEm3.company) === null || _formData$workforceEm3 === void 0 ? void 0 : _formData$workforceEm3.id) || null,
          factory: (formData === null || formData === void 0 ? void 0 : formData.factory) || (formData === null || formData === void 0 || (_formData$employeeFac = formData.employeeFactory) === null || _formData$employeeFac === void 0 ? void 0 : _formData$employeeFac.id) || employeeData.factory || (formData === null || formData === void 0 || (_formData$workforceEm4 = formData.workforceEmployee) === null || _formData$workforceEm4 === void 0 || (_formData$workforceEm4 = _formData$workforceEm4.factory) === null || _formData$workforceEm4 === void 0 ? void 0 : _formData$workforceEm4.id) || (parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.employeeFactory) || workforceFactoryId || selectedFactory || null,
          applicationForSelf: applicationForSelf,
          workforceFactoryId: workforceFactoryId || "",
          organizationType: (parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.organizationType) || organizationType,
          applicationType: (parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.applicationType) || selectedApplicationType,
          grantAmount: (parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.grantAmount) || (parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.employeeAccidentInfo.grantAmount),
          dependents: prev.dependents && Object.keys(prev.dependents[0] || {}).length > 0 && prev.dependents[0].fullName !== "" ? prev.dependents : (parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.employeeDependentInfo) || [{}],
          employeeBankInfo: prev.employeeBankInfo && Object.keys(prev.employeeBankInfo[0] || {}).length > 0 && prev.employeeBankInfo[0].accountNumber !== "" ? prev.employeeBankInfo : (parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.employeeBankInfo) || (employeeData === null || employeeData === void 0 ? void 0 : employeeData.employeeBankInfo) || [{}],
          employeeAccidentInfo: (parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.employeeAccidentInfo) || (employeeData === null || employeeData === void 0 ? void 0 : employeeData.employeeAccidentInfo) || {},
          metadata: (parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.metadata) || (formData === null || formData === void 0 ? void 0 : formData.metadata) || {},
          applicantInfo: (parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.applicantInfo) || (employeeData === null || employeeData === void 0 ? void 0 : employeeData.metadata) || {},
          deceasedWorkerInfo: user_type === WORKFORCE_USER_TYPE.FACTORY_ADMIN ? _objectSpread$R(_objectSpread$R({}, prev.deceasedWorkerInfo), {}, {
            nameEn: ((_prev$deceasedWorkerI = prev.deceasedWorkerInfo) === null || _prev$deceasedWorkerI === void 0 ? void 0 : _prev$deceasedWorkerI.nameEn) || (parsedApplicationData === null || parsedApplicationData === void 0 || (_parsedApplicationDat61 = parsedApplicationData.deceasedWorkerInfo) === null || _parsedApplicationDat61 === void 0 ? void 0 : _parsedApplicationDat61.nameEn) || (employeeData === null || employeeData === void 0 ? void 0 : employeeData.firstNameEn) || "",
            nameBn: ((_prev$deceasedWorkerI2 = prev.deceasedWorkerInfo) === null || _prev$deceasedWorkerI2 === void 0 ? void 0 : _prev$deceasedWorkerI2.nameBn) || (parsedApplicationData === null || parsedApplicationData === void 0 || (_parsedApplicationDat62 = parsedApplicationData.deceasedWorkerInfo) === null || _parsedApplicationDat62 === void 0 ? void 0 : _parsedApplicationDat62.nameBn) || (employeeData === null || employeeData === void 0 ? void 0 : employeeData.firstNameBn) || "",
            fatherNameEn: ((_prev$deceasedWorkerI3 = prev.deceasedWorkerInfo) === null || _prev$deceasedWorkerI3 === void 0 ? void 0 : _prev$deceasedWorkerI3.fatherNameEn) || (parsedApplicationData === null || parsedApplicationData === void 0 || (_parsedApplicationDat63 = parsedApplicationData.deceasedWorkerInfo) === null || _parsedApplicationDat63 === void 0 ? void 0 : _parsedApplicationDat63.fatherNameEn) || (employeeData === null || employeeData === void 0 ? void 0 : employeeData.fatherNameEn) || "",
            fatherNameBn: ((_prev$deceasedWorkerI4 = prev.deceasedWorkerInfo) === null || _prev$deceasedWorkerI4 === void 0 ? void 0 : _prev$deceasedWorkerI4.fatherNameBn) || (parsedApplicationData === null || parsedApplicationData === void 0 || (_parsedApplicationDat64 = parsedApplicationData.deceasedWorkerInfo) === null || _parsedApplicationDat64 === void 0 ? void 0 : _parsedApplicationDat64.fatherNameBn) || (employeeData === null || employeeData === void 0 ? void 0 : employeeData.fatherNameBn) || "",
            motherNameEn: ((_prev$deceasedWorkerI5 = prev.deceasedWorkerInfo) === null || _prev$deceasedWorkerI5 === void 0 ? void 0 : _prev$deceasedWorkerI5.motherNameEn) || (parsedApplicationData === null || parsedApplicationData === void 0 || (_parsedApplicationDat65 = parsedApplicationData.deceasedWorkerInfo) === null || _parsedApplicationDat65 === void 0 ? void 0 : _parsedApplicationDat65.motherNameEn) || (employeeData === null || employeeData === void 0 ? void 0 : employeeData.motherNameEn) || "",
            motherNameBn: ((_prev$deceasedWorkerI6 = prev.deceasedWorkerInfo) === null || _prev$deceasedWorkerI6 === void 0 ? void 0 : _prev$deceasedWorkerI6.motherNameBn) || (parsedApplicationData === null || parsedApplicationData === void 0 || (_parsedApplicationDat66 = parsedApplicationData.deceasedWorkerInfo) === null || _parsedApplicationDat66 === void 0 ? void 0 : _parsedApplicationDat66.motherNameBn) || (employeeData === null || employeeData === void 0 ? void 0 : employeeData.motherNameBn) || "",
            spouseNameEn: ((_prev$deceasedWorkerI7 = prev.deceasedWorkerInfo) === null || _prev$deceasedWorkerI7 === void 0 ? void 0 : _prev$deceasedWorkerI7.spouseNameEn) || (parsedApplicationData === null || parsedApplicationData === void 0 || (_parsedApplicationDat67 = parsedApplicationData.deceasedWorkerInfo) === null || _parsedApplicationDat67 === void 0 ? void 0 : _parsedApplicationDat67.spouseNameEn) || (employeeData === null || employeeData === void 0 ? void 0 : employeeData.spouseNameEn) || "",
            spouseNameBn: ((_prev$deceasedWorkerI8 = prev.deceasedWorkerInfo) === null || _prev$deceasedWorkerI8 === void 0 ? void 0 : _prev$deceasedWorkerI8.spouseNameBn) || (parsedApplicationData === null || parsedApplicationData === void 0 || (_parsedApplicationDat68 = parsedApplicationData.deceasedWorkerInfo) === null || _parsedApplicationDat68 === void 0 ? void 0 : _parsedApplicationDat68.spouseNameBn) || (employeeData === null || employeeData === void 0 ? void 0 : employeeData.spouseNameBn) || "",
            citizenship: ((_prev$deceasedWorkerI9 = prev.deceasedWorkerInfo) === null || _prev$deceasedWorkerI9 === void 0 ? void 0 : _prev$deceasedWorkerI9.citizenship) || (parsedApplicationData === null || parsedApplicationData === void 0 || (_parsedApplicationDat69 = parsedApplicationData.deceasedWorkerInfo) === null || _parsedApplicationDat69 === void 0 ? void 0 : _parsedApplicationDat69.citizenship) || (employeeData === null || employeeData === void 0 ? void 0 : employeeData.citizenship) || "",
            phoneNumber: ((_prev$deceasedWorkerI10 = prev.deceasedWorkerInfo) === null || _prev$deceasedWorkerI10 === void 0 ? void 0 : _prev$deceasedWorkerI10.phoneNumber) || (parsedApplicationData === null || parsedApplicationData === void 0 || (_parsedApplicationDat70 = parsedApplicationData.deceasedWorkerInfo) === null || _parsedApplicationDat70 === void 0 ? void 0 : _parsedApplicationDat70.phoneNumber) || (employeeData === null || employeeData === void 0 ? void 0 : employeeData.phoneNumber) || "",
            relationWithApplicant: ((_prev$deceasedWorkerI11 = prev.deceasedWorkerInfo) === null || _prev$deceasedWorkerI11 === void 0 ? void 0 : _prev$deceasedWorkerI11.relationWithApplicant) || (parsedApplicationData === null || parsedApplicationData === void 0 || (_parsedApplicationDat71 = parsedApplicationData.deceasedWorkerInfo) === null || _parsedApplicationDat71 === void 0 ? void 0 : _parsedApplicationDat71.relationWithApplicant) || "",
            birthDate: ((_prev$deceasedWorkerI12 = prev.deceasedWorkerInfo) === null || _prev$deceasedWorkerI12 === void 0 ? void 0 : _prev$deceasedWorkerI12.birthDate) || (parsedApplicationData === null || parsedApplicationData === void 0 || (_parsedApplicationDat72 = parsedApplicationData.deceasedWorkerInfo) === null || _parsedApplicationDat72 === void 0 ? void 0 : _parsedApplicationDat72.birthDate) || "",
            gender: ((_prev$deceasedWorkerI13 = prev.deceasedWorkerInfo) === null || _prev$deceasedWorkerI13 === void 0 ? void 0 : _prev$deceasedWorkerI13.gender) || (parsedApplicationData === null || parsedApplicationData === void 0 || (_parsedApplicationDat73 = parsedApplicationData.deceasedWorkerInfo) === null || _parsedApplicationDat73 === void 0 ? void 0 : _parsedApplicationDat73.gender) || "",
            position: ((_prev$deceasedWorkerI14 = prev.deceasedWorkerInfo) === null || _prev$deceasedWorkerI14 === void 0 ? void 0 : _prev$deceasedWorkerI14.position) || (parsedApplicationData === null || parsedApplicationData === void 0 || (_parsedApplicationDat74 = parsedApplicationData.deceasedWorkerInfo) === null || _parsedApplicationDat74 === void 0 ? void 0 : _parsedApplicationDat74.position) || ((_prev$workforceEmploy40 = prev.workforceEmployee) === null || _prev$workforceEmploy40 === void 0 ? void 0 : _prev$workforceEmploy40.position) || "",
            maritalStatus: ((_prev$deceasedWorkerI15 = prev.deceasedWorkerInfo) === null || _prev$deceasedWorkerI15 === void 0 ? void 0 : _prev$deceasedWorkerI15.maritalStatus) || ((_prev$workforceEmploy41 = prev.workforceEmployee) === null || _prev$workforceEmploy41 === void 0 ? void 0 : _prev$workforceEmploy41.maritalStatus) || (parsedApplicationData === null || parsedApplicationData === void 0 || (_parsedApplicationDat75 = parsedApplicationData.deceasedWorkerInfo) === null || _parsedApplicationDat75 === void 0 ? void 0 : _parsedApplicationDat75.maritalStatus) || "",
            nid: ((_prev$deceasedWorkerI16 = prev.deceasedWorkerInfo) === null || _prev$deceasedWorkerI16 === void 0 ? void 0 : _prev$deceasedWorkerI16.nid) || ((_prev$workforceEmploy42 = prev.workforceEmployee) === null || _prev$workforceEmploy42 === void 0 ? void 0 : _prev$workforceEmploy42.nid) || (parsedApplicationData === null || parsedApplicationData === void 0 || (_parsedApplicationDat76 = parsedApplicationData.deceasedWorkerInfo) === null || _parsedApplicationDat76 === void 0 ? void 0 : _parsedApplicationDat76.nid) || (employeeData === null || employeeData === void 0 ? void 0 : employeeData.nid) || "",
            birthCertificateNo: ((_prev$deceasedWorkerI17 = prev.deceasedWorkerInfo) === null || _prev$deceasedWorkerI17 === void 0 ? void 0 : _prev$deceasedWorkerI17.birthCertificateNo) || (parsedApplicationData === null || parsedApplicationData === void 0 || (_parsedApplicationDat77 = parsedApplicationData.deceasedWorkerInfo) === null || _parsedApplicationDat77 === void 0 ? void 0 : _parsedApplicationDat77.birthCertificateNo) || (employeeData === null || employeeData === void 0 ? void 0 : employeeData.birthCertificateNo) || "",
            permanentAddress: ((_prev$deceasedWorkerI18 = prev.deceasedWorkerInfo) === null || _prev$deceasedWorkerI18 === void 0 ? void 0 : _prev$deceasedWorkerI18.permanentAddress) || (parsedApplicationData === null || parsedApplicationData === void 0 || (_parsedApplicationDat78 = parsedApplicationData.deceasedWorkerInfo) === null || _parsedApplicationDat78 === void 0 ? void 0 : _parsedApplicationDat78.permanentAddress) || (employeeData === null || employeeData === void 0 ? void 0 : employeeData.permanentAddress) || "",
            permanentLocation: ((_prev$deceasedWorkerI19 = prev.deceasedWorkerInfo) === null || _prev$deceasedWorkerI19 === void 0 ? void 0 : _prev$deceasedWorkerI19.permanentLocation) || (parsedApplicationData === null || parsedApplicationData === void 0 || (_parsedApplicationDat79 = parsedApplicationData.deceasedWorkerInfo) === null || _parsedApplicationDat79 === void 0 ? void 0 : _parsedApplicationDat79.permanentLocation) || (employeeData === null || employeeData === void 0 ? void 0 : employeeData.permanentLocation) || "",
            presentLocation: ((_prev$deceasedWorkerI20 = prev.deceasedWorkerInfo) === null || _prev$deceasedWorkerI20 === void 0 ? void 0 : _prev$deceasedWorkerI20.presentLocation) || (parsedApplicationData === null || parsedApplicationData === void 0 || (_parsedApplicationDat80 = parsedApplicationData.deceasedWorkerInfo) === null || _parsedApplicationDat80 === void 0 ? void 0 : _parsedApplicationDat80.presentLocation) || (employeeData === null || employeeData === void 0 ? void 0 : employeeData.presentLocation) || "",
            presentAddress: ((_prev$deceasedWorkerI21 = prev.deceasedWorkerInfo) === null || _prev$deceasedWorkerI21 === void 0 ? void 0 : _prev$deceasedWorkerI21.presentAddress) || (parsedApplicationData === null || parsedApplicationData === void 0 || (_parsedApplicationDat81 = parsedApplicationData.deceasedWorkerInfo) === null || _parsedApplicationDat81 === void 0 ? void 0 : _parsedApplicationDat81.presentAddress) || (employeeData === null || employeeData === void 0 ? void 0 : employeeData.presentAddress) || ""
          }) : (parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.deceasedWorkerInfo) || {}
        });
      });
    }
  }, [employeeData === null || employeeData === void 0 ? void 0 : employeeData.id, parsedApplicationData, user_type]);

  // 2. Add the useEffect inside the FinancialAssistanceForm component
  useEffect(function () {
    var prefillReduxFiles = function prefillReduxFiles(dataArray) {
      dataArray === null || dataArray === void 0 || dataArray.forEach(function (item) {
        var attachments = typeof (item === null || item === void 0 ? void 0 : item.attachments) === "string" ? JSON.parse(item.attachments) : item === null || item === void 0 ? void 0 : item.attachments;
        attachments === null || attachments === void 0 || attachments.forEach(function (att) {
          var _att$files;
          if ((att === null || att === void 0 || (_att$files = att.files) === null || _att$files === void 0 ? void 0 : _att$files.length) > 0 && att !== null && att !== void 0 && att.fieldKey) {
            dispatch(setUploadedFiles(att.fieldKey, att.files));
          }
        });
      });
    };
    if (parsedApplicationData) {
      prefillReduxFiles((parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.employeeDependentInfo) || []);
      prefillReduxFiles((parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.employeeBankInfo) || []);
    }
  }, [dispatch, parsedApplicationData]);

  // Handle form input changes
  var _handleChange = function handleChange(key, value) {
    var parent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    setFormData(function (prev) {
      if (parent) {
        return _objectSpread$R(_objectSpread$R({}, prev), {}, _defineProperty({}, parent, _objectSpread$R(_objectSpread$R({}, prev[parent]), {}, _defineProperty({}, key, value))));
      }
      return _objectSpread$R(_objectSpread$R({}, prev), {}, _defineProperty({}, key, value));
    });
  };
  var handleNext = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _formData$metadata;
      var newErrors, allAssociationDate, deathDate, IS_APPLICANT_STEP, IS_EMPLOYEE_STEP, IS_DEPENDENT_STEP, IS_BANK_STEP, documentValidation, BANK_DOC_TYPE, bankDocsConfig, generalDocsConfig, isCfGrantMode, totalPercentage, _formData$workforceEm5, _formData$workforceAp, nextStep, fakeErrors, _formData$workforceEm6, _formData$deceasedWor, workerBirthDate, currentDependents, validDependents, _formData$deceasedWor2, _formData$workforceEm7, _duplicacyResponse$pa, _formData$workforceEm8, _formData$workforceEm9, _formData$workforceEm10, _formData$workforceEm11, _formData$workforceEm12, _formData$workforceEm13, _formData$workforceEm14, _formData$workforceEm15, _formData$workforceEm16, _formData$workforceEm17, _formData$workforceEm18, _formData$workforceEm19, _formData$workforceEm20, _formData$workforceEm21, _formData$workforceEm22, _formData$workforceEm23, _formData$workforceEm24, _formData$workforceEm25, _formData$workforceEm26, _formData$workforceEm27, _formData$workforceEm28, _formData$workforceEm29, _formData$workforceEm30, _formData$workforceEm31, _formData$workforceEm32, _formData$deceasedWor3, _formData$workforceEm33, _formData$deceasedWor4, duplicacyFilters, duplicacyResponse, duplicacyData, updateApplicationData, _formData$workforceEm34, _formData$workforceEm35, _formData$workforceEm36, _formData$deceasedWor5, _formData$workforceEm37, _formData$deceasedWor6, _formData$factory, createApplicationData, applicationMutation, applicationClientMutationId, _updateApplicationData, _formData$workforceEm38, _formData$workforceEm39, _formData$deceasedWor7, _formData$workforceEm40, _formData$deceasedWor8, _formData$factory2, _updateApplicationData2, _formData$workforceEm41, _formData$workforceEm42, _formData$deceasedWor9, _formData$workforceEm43, _formData$deceasedWor10, _formData$factory3, _updateApplicationData3;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!isNavigationBlocked) {
              _context.next = 2;
              break;
            }
            return _context.abrupt("return");
          case 2:
            newErrors = validateRequiredFields(stepRef, formatMessage, formData);
            delete newErrors.documents;
            allAssociationDate = new Date("2022-06-21");
            deathDate = new Date(formData === null || formData === void 0 || (_formData$metadata = formData.metadata) === null || _formData$metadata === void 0 ? void 0 : _formData$metadata.deathDate);
            IS_APPLICANT_STEP = activeStep === 1;
            IS_EMPLOYEE_STEP = activeStep === 2;
            IS_DEPENDENT_STEP = activeStep === 4;
            IS_BANK_STEP = activeStep === 5; // 4. Document Validation Logic
            documentValidation = {
              isValid: true,
              errors: null
            };
            BANK_DOC_TYPE = "applicants bank check copy";
            if (IS_DEPENDENT_STEP) {
              // Specialized validation for the Dependent Step
              documentValidation = validateMandatoryDocumentsForDependents(documentType, uploadDependentFile || [], formData.dependents || []);
            } else if (IS_BANK_STEP) {
              // Filter only for Bank Documents
              bankDocsConfig = (documentType || []).filter(function (doc) {
                return doc.documentType === BANK_DOC_TYPE;
              });
              documentValidation = validateMandatoryBankDocumentsForAccounts(bankDocsConfig, uploadBankFile || [], formData.employeeBankInfo || []);
            } else if (IS_EMPLOYEE_STEP || IS_APPLICANT_STEP) {
              // Filter out Bank Documents for general info steps
              generalDocsConfig = (documentType || []).filter(function (doc) {
                return doc.documentType !== BANK_DOC_TYPE;
              });
              documentValidation = validateMandatoryDocuments(generalDocsConfig, uploadFile || []);
            }

            // 5. Assign Document Errors if the current step is a "document step"
            if (!documentValidation.isValid) {
              newErrors.documents = documentValidation.errors;
            }
            isCfGrantMode = (formData === null || formData === void 0 ? void 0 : formData.organizationType) === "cf" && (formData === null || formData === void 0 ? void 0 : formData.applicationType) === "financialAssistance";
            if (!(IS_DEPENDENT_STEP && isCfGrantMode)) {
              _context.next = 25;
              break;
            }
            totalPercentage = formData === null || formData === void 0 ? void 0 : formData.dependents.reduce(function (sum, dep) {
              var val = Number((dep === null || dep === void 0 ? void 0 : dep.percentageOfCfGrant) || (dep === null || dep === void 0 ? void 0 : dep.percentage_of_grant) || 0);
              return sum + (isNaN(val) ? 0 : val);
            }, 0);
            if (!(totalPercentage !== 100)) {
              _context.next = 25;
              break;
            }
            setErrors(function (prevErrors) {
              return _objectSpread$R(_objectSpread$R({}, prevErrors), {}, {
                percentage_of_grant: "Total percentage must be exactly 100%"
              });
            });
            setShowErrorSnackbar(true);
            return _context.abrupt("return");
          case 25:
            setErrors(newErrors);
            console.log({
              newErrors: newErrors
            });
            console.log({
              documentValidation: documentValidation
            });
            if (Object.keys(newErrors).length > 0 && !(newErrors !== null && newErrors !== void 0 && newErrors.documents)) {
              setShowErrorSnackbar(true);
            } else {
              setShowErrorSnackbar(false);
            }
            if (!(Object.keys(newErrors).length === 0 || (newErrors === null || newErrors === void 0 ? void 0 : newErrors.documents) === null)) {
              _context.next = 106;
              break;
            }
            nextStep = activeStep + 1;
            if (!(nextStep === 3 && !isAtLeast18YearsOld(formData === null || formData === void 0 || (_formData$workforceEm5 = formData.workforceEmployee) === null || _formData$workforceEm5 === void 0 ? void 0 : _formData$workforceEm5.birthDate) || nextStep === 2 && !isAtLeast18YearsOld(formData === null || formData === void 0 || (_formData$workforceAp = formData.workforceApplicant) === null || _formData$workforceAp === void 0 ? void 0 : _formData$workforceAp.birthDate, 12))) {
              _context.next = 37;
              break;
            }
            fakeErrors = nextStep === 2 ? _objectSpread$R(_objectSpread$R({}, newErrors), {}, {
              rdmp: "core.error.applicantAge"
            }) : _objectSpread$R(_objectSpread$R({}, newErrors), {}, {
              rdmp: "core.error.workerAge"
            });
            setErrors(fakeErrors);
            return _context.abrupt("return", false);
          case 37:
            if (!(nextStep === 5 && (formData === null || formData === void 0 ? void 0 : formData.organizationType) === "eis")) {
              _context.next = 44;
              break;
            }
            workerBirthDate = (formData === null || formData === void 0 || (_formData$workforceEm6 = formData.workforceEmployee) === null || _formData$workforceEm6 === void 0 ? void 0 : _formData$workforceEm6.birthDate) || (formData === null || formData === void 0 || (_formData$deceasedWor = formData.deceasedWorkerInfo) === null || _formData$deceasedWor === void 0 ? void 0 : _formData$deceasedWor.birthDate);
            currentDependents = (formData === null || formData === void 0 ? void 0 : formData.dependents) || [];
            validDependents = currentDependents.filter(function (dep) {
              return getRelationForApi(dep, workerBirthDate);
            });
            if (!(validDependents.length !== currentDependents.length)) {
              _context.next = 44;
              break;
            }
            setDependentErr(true);
            return _context.abrupt("return", false);
          case 44:
            if (!((formData === null || formData === void 0 ? void 0 : formData.organizationType) === "eis" && allAssociationDate > deathDate)) {
              _context.next = 47;
              break;
            }
            setAlertMessage(true);
            return _context.abrupt("return", false);
          case 47:
            // ===== LOADING BLOCK: Prevent moving to bank step until dependent data is ready =====
            if (nextStep === 5) {
              setIsNavigationBlocked(true);
              setStepLoadingState(function (prev) {
                return _objectSpread$R(_objectSpread$R({}, prev), {}, _defineProperty({}, nextStep, true));
              });
            }
            if (!(nextStep === 3 || nextStep === 4)) {
              _context.next = 63;
              break;
            }
            // Duplicacy check
            duplicacyFilters = ["nid: \"".concat((formData === null || formData === void 0 || (_formData$deceasedWor2 = formData.deceasedWorkerInfo) === null || _formData$deceasedWor2 === void 0 ? void 0 : _formData$deceasedWor2.nid) || (formData === null || formData === void 0 || (_formData$workforceEm7 = formData.workforceEmployee) === null || _formData$workforceEm7 === void 0 ? void 0 : _formData$workforceEm7.nid), "\""), "organizationType: \"".concat(organizationType, "\""), "getOtherApplicationList: false", "applicationTypeIn: [\"financialAssistance\"]"];
            _context.next = 52;
            return dispatch(fetchPrevApplicationHistory(duplicacyFilters));
          case 52:
            duplicacyResponse = _context.sent;
            duplicacyData = duplicacyResponse === null || duplicacyResponse === void 0 || (_duplicacyResponse$pa = duplicacyResponse.payload) === null || _duplicacyResponse$pa === void 0 || (_duplicacyResponse$pa = _duplicacyResponse$pa.data) === null || _duplicacyResponse$pa === void 0 ? void 0 : _duplicacyResponse$pa.workforceCheckApplicationDuplicacy;
            if (!(duplicacyData && duplicacyData.length > 0)) {
              _context.next = 58;
              break;
            }
            setShowDuplicateError(true);
            setTimeout(function () {
              history.push("/home");
              window.location.reload();
            }, 5000);
            return _context.abrupt("return");
          case 58:
            ({
              nameEn: formData === null || formData === void 0 || (_formData$workforceEm8 = formData.workforceEmployee) === null || _formData$workforceEm8 === void 0 ? void 0 : _formData$workforceEm8.nameEn,
              nameBn: formData === null || formData === void 0 || (_formData$workforceEm9 = formData.workforceEmployee) === null || _formData$workforceEm9 === void 0 ? void 0 : _formData$workforceEm9.nameBn,
              lastNameEn: "",
              phoneNumber: formData === null || formData === void 0 || (_formData$workforceEm10 = formData.workforceEmployee) === null || _formData$workforceEm10 === void 0 ? void 0 : _formData$workforceEm10.phoneNumber,
              email: formData === null || formData === void 0 || (_formData$workforceEm11 = formData.workforceEmployee) === null || _formData$workforceEm11 === void 0 ? void 0 : _formData$workforceEm11.email,
              gender: formData === null || formData === void 0 || (_formData$workforceEm12 = formData.workforceEmployee) === null || _formData$workforceEm12 === void 0 || (_formData$workforceEm12 = _formData$workforceEm12.gender) === null || _formData$workforceEm12 === void 0 ? void 0 : _formData$workforceEm12.name,
              birthDate: formData === null || formData === void 0 || (_formData$workforceEm13 = formData.workforceEmployee) === null || _formData$workforceEm13 === void 0 ? void 0 : _formData$workforceEm13.birthDate,
              deathDate: formData === null || formData === void 0 || (_formData$workforceEm14 = formData.workforceEmployee) === null || _formData$workforceEm14 === void 0 ? void 0 : _formData$workforceEm14.deathDate,
              lifeStatus: formData === null || formData === void 0 || (_formData$workforceEm15 = formData.workforceEmployee) === null || _formData$workforceEm15 === void 0 ? void 0 : _formData$workforceEm15.lifeStatus,
              permanentAddress: formData === null || formData === void 0 || (_formData$workforceEm16 = formData.workforceEmployee) === null || _formData$workforceEm16 === void 0 ? void 0 : _formData$workforceEm16.permanentAddress,
              presentAddress: formData === null || formData === void 0 || (_formData$workforceEm17 = formData.workforceEmployee) === null || _formData$workforceEm17 === void 0 ? void 0 : _formData$workforceEm17.presentAddress,
              position: formData === null || formData === void 0 || (_formData$workforceEm18 = formData.workforceEmployee) === null || _formData$workforceEm18 === void 0 ? void 0 : _formData$workforceEm18.position,
              monthlyEarning: formData === null || formData === void 0 || (_formData$workforceEm19 = formData.workforceEmployee) === null || _formData$workforceEm19 === void 0 ? void 0 : _formData$workforceEm19.monthlyEarning,
              insuranceNumber: " ",
              fatherNameBn: formData === null || formData === void 0 || (_formData$workforceEm20 = formData.workforceEmployee) === null || _formData$workforceEm20 === void 0 ? void 0 : _formData$workforceEm20.fatherNameBn,
              fatherNameEn: formData === null || formData === void 0 || (_formData$workforceEm21 = formData.workforceEmployee) === null || _formData$workforceEm21 === void 0 ? void 0 : _formData$workforceEm21.fatherNameEn,
              motherNameBn: formData === null || formData === void 0 || (_formData$workforceEm22 = formData.workforceEmployee) === null || _formData$workforceEm22 === void 0 ? void 0 : _formData$workforceEm22.motherNameBn,
              motherNameEn: formData === null || formData === void 0 || (_formData$workforceEm23 = formData.workforceEmployee) === null || _formData$workforceEm23 === void 0 ? void 0 : _formData$workforceEm23.motherNameEn,
              spouseNameBn: formData === null || formData === void 0 || (_formData$workforceEm24 = formData.workforceEmployee) === null || _formData$workforceEm24 === void 0 ? void 0 : _formData$workforceEm24.spouseNameBn,
              spouseNameEn: formData === null || formData === void 0 || (_formData$workforceEm25 = formData.workforceEmployee) === null || _formData$workforceEm25 === void 0 ? void 0 : _formData$workforceEm25.spouseNameEn,
              citizenship: formData === null || formData === void 0 || (_formData$workforceEm26 = formData.workforceEmployee) === null || _formData$workforceEm26 === void 0 ? void 0 : _formData$workforceEm26.citizenship,
              maritalStatus: formData === null || formData === void 0 || (_formData$workforceEm27 = formData.workforceEmployee) === null || _formData$workforceEm27 === void 0 ? void 0 : _formData$workforceEm27.maritalStatus,
              presentLocation: formData === null || formData === void 0 || (_formData$workforceEm28 = formData.workforceEmployee) === null || _formData$workforceEm28 === void 0 ? void 0 : _formData$workforceEm28.presentLocation,
              permanentLocation: formData === null || formData === void 0 || (_formData$workforceEm29 = formData.workforceEmployee) === null || _formData$workforceEm29 === void 0 ? void 0 : _formData$workforceEm29.permanentLocation,
              id: safeDecodeId(formData === null || formData === void 0 || (_formData$workforceEm30 = formData.workforceEmployee) === null || _formData$workforceEm30 === void 0 ? void 0 : _formData$workforceEm30.id) || safeDecodeId(reduxState.core.user.id)
            }); // await dispatch(updateWorkforceEmployee(workforceEmployeeData, `Update Workforce Employee ${workforceEmployeeData.nameEn}`));
            updateApplicationData = {
              // id: decodeId(applicationId[0]?.id) || parsedApplicationData?.id,
              id: safeApplicationId(applicationId, parsedApplicationData),
              workforceEmployeeId: safeDecodeId(employeeData === null || employeeData === void 0 ? void 0 : employeeData.id) || safeDecodeId(reduxState.core.user.id),
              company: formData === null || formData === void 0 || (_formData$workforceEm31 = formData.workforceEmployee) === null || _formData$workforceEm31 === void 0 || (_formData$workforceEm31 = _formData$workforceEm31.company) === null || _formData$workforceEm31 === void 0 ? void 0 : _formData$workforceEm31.id,
              factory: formData !== null && formData !== void 0 && (_formData$workforceEm32 = formData.workforceEmployee) !== null && _formData$workforceEm32 !== void 0 && (_formData$workforceEm32 = _formData$workforceEm32.factory) !== null && _formData$workforceEm32 !== void 0 && _formData$workforceEm32.id || formData !== null && formData !== void 0 && (_formData$deceasedWor3 = formData.deceasedWorkerInfo) !== null && _formData$deceasedWor3 !== void 0 && (_formData$deceasedWor3 = _formData$deceasedWor3.factory) !== null && _formData$deceasedWor3 !== void 0 && _formData$deceasedWor3.id ? safeDecodeId((formData === null || formData === void 0 || (_formData$workforceEm33 = formData.workforceEmployee) === null || _formData$workforceEm33 === void 0 || (_formData$workforceEm33 = _formData$workforceEm33.factory) === null || _formData$workforceEm33 === void 0 ? void 0 : _formData$workforceEm33.id) || (formData === null || formData === void 0 || (_formData$deceasedWor4 = formData.deceasedWorkerInfo) === null || _formData$deceasedWor4 === void 0 || (_formData$deceasedWor4 = _formData$deceasedWor4.factory) === null || _formData$deceasedWor4 === void 0 ? void 0 : _formData$deceasedWor4.id)) : null,
              organizationType: organizationType || (parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.organizationType),
              applicationType: selectedApplicationType || (parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.applicationType),
              grantAmount: formData === null || formData === void 0 ? void 0 : formData.employeeAccidentInfo.grantAmount,
              employeeBankInfo: JSON.stringify(formData.employeeBankInfo) || JSON.stringify(parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.employeeBankInfo),
              // employeeDependentInfo: JSON.stringify(formData.dependents) || JSON.stringify(parsedApplicationData?.employeeDependentInfo),
              employeeDependentInfo: JSON.stringify(formData.dependents).replace(/\\/g, "").replace(/"{/g, "{").replace(/}"/g, "}") || JSON.stringify(parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.employeeDependentInfo).replace(/\\/g, "").replace(/"{/g, "{").replace(/}"/g, "}"),
              employeeAccidentInfo: JSON.stringify(formData === null || formData === void 0 ? void 0 : formData.employeeAccidentInfo) || JSON.stringify(parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.employeeAccidentInfo),
              metadata: JSON.stringify(formData.metadata),
              deceasedWorkerInfo: JSON.stringify(formData.workforceEmployee).replace(/\\/g, "").replace(/"{/g, "{").replace(/}"/g, "}").replace(/\\\\\\/g, "\\\\"),
              status: WORKFORCE_STATUS$1.DRAFT,
              applicationFor: applicationForSelf === "yes" ? "self" : applicationForSelf === "" ? "" : "dependent"
            };
            dispatch(updateApplication(updateApplicationData, "update workforce application"));
            _context.next = 104;
            break;
          case 63:
            if (!(nextStep === 1)) {
              _context.next = 78;
              break;
            }
            createApplicationData = {
              workforceEmployeeId: safeDecodeId(employeeData === null || employeeData === void 0 ? void 0 : employeeData.id) || safeDecodeId(formData === null || formData === void 0 || (_formData$workforceEm34 = formData.workforceEmployee) === null || _formData$workforceEm34 === void 0 ? void 0 : _formData$workforceEm34.id) || safeDecodeId(reduxState.core.user.id),
              company: formData === null || formData === void 0 || (_formData$workforceEm35 = formData.workforceEmployee) === null || _formData$workforceEm35 === void 0 || (_formData$workforceEm35 = _formData$workforceEm35.company) === null || _formData$workforceEm35 === void 0 ? void 0 : _formData$workforceEm35.id,
              factory: formData !== null && formData !== void 0 && (_formData$workforceEm36 = formData.workforceEmployee) !== null && _formData$workforceEm36 !== void 0 && (_formData$workforceEm36 = _formData$workforceEm36.factory) !== null && _formData$workforceEm36 !== void 0 && _formData$workforceEm36.id || formData !== null && formData !== void 0 && (_formData$deceasedWor5 = formData.deceasedWorkerInfo) !== null && _formData$deceasedWor5 !== void 0 && (_formData$deceasedWor5 = _formData$deceasedWor5.factory) !== null && _formData$deceasedWor5 !== void 0 && _formData$deceasedWor5.id || formData !== null && formData !== void 0 && formData.factory ? safeDecodeId((formData === null || formData === void 0 || (_formData$workforceEm37 = formData.workforceEmployee) === null || _formData$workforceEm37 === void 0 || (_formData$workforceEm37 = _formData$workforceEm37.factory) === null || _formData$workforceEm37 === void 0 ? void 0 : _formData$workforceEm37.id) || (formData === null || formData === void 0 || (_formData$deceasedWor6 = formData.deceasedWorkerInfo) === null || _formData$deceasedWor6 === void 0 || (_formData$deceasedWor6 = _formData$deceasedWor6.factory) === null || _formData$deceasedWor6 === void 0 ? void 0 : _formData$deceasedWor6.id) || (formData === null || formData === void 0 || (_formData$factory = formData.factory) === null || _formData$factory === void 0 ? void 0 : _formData$factory.id)) : null,
              organizationType: formData.organizationType,
              applicationType: formData.applicationType,
              grantAmount: formData === null || formData === void 0 ? void 0 : formData.employeeAccidentInfo.grantAmount,
              employeeDesignationInfo: JSON.stringify(formData === null || formData === void 0 ? void 0 : formData.employeeDesignationInfo),
              employeeBankInfo: JSON.stringify(formData === null || formData === void 0 ? void 0 : formData.employeeBankInfo),
              employeeDependentInfo: JSON.stringify(formData.dependents).replace(/\\/g, "").replace(/"{/g, "{").replace(/}"/g, "}") || JSON.stringify(parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.employeeDependentInfo).replace(/\\/g, "").replace(/"{/g, "{").replace(/}"/g, "}"),
              employeeAccidentInfo: JSON.stringify(formData === null || formData === void 0 ? void 0 : formData.employeeAccidentInfo),
              metadata: JSON.stringify(formData === null || formData === void 0 ? void 0 : formData.metadata),
              status: WORKFORCE_STATUS$1.DRAFT,
              applicationFor: applicationForSelf === "yes" ? "self" : applicationForSelf === "" ? "" : "dependent"
            };
            if (parsedApplicationData) {
              _context.next = 74;
              break;
            }
            _context.next = 68;
            return formatMutation("createWorkforceApplication", formatApplicationeGQL(createApplicationData), "Created application ");
          case 68:
            applicationMutation = _context.sent;
            applicationClientMutationId = applicationMutation.clientMutationId;
            _context.next = 72;
            return dispatch(createApplication(applicationMutation, "Created workforce application ")).then(function (res) {
              // await dispatch(fetchApplicationId(modulesManager, applicationClientMutationId));
              var fetchRes = dispatch(fetchInfoIdByClientMutationId(modulesManager, "workforceApplication", applicationClientMutationId, "WORKFORCE_APPLICATION_BY_CLIENT_MUTATION_ID"));
              var applicationgetId = getInfoId(fetchRes, "workforceApplication");
              if (!applicationgetId && applicationId) {
                applicationgetId = applicationId;
              } else {
                applicationId = applicationgetId;
              }
            });
          case 72:
            _context.next = 76;
            break;
          case 74:
            _updateApplicationData = _objectSpread$R({
              id: parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.id
            }, createApplicationData);
            dispatch(updateApplication(_updateApplicationData, "update workforce application "));
          case 76:
            _context.next = 104;
            break;
          case 78:
            if (!(nextStep === 5)) {
              _context.next = 102;
              break;
            }
            _updateApplicationData2 = {
              // id: decodeId(applicationId[0]?.id) || parsedApplicationData?.id,
              id: safeApplicationId(applicationId, parsedApplicationData),
              workforceEmployeeId: safeDecodeId(employeeData === null || employeeData === void 0 ? void 0 : employeeData.id) || safeDecodeId(reduxState.core.user.id),
              company: formData === null || formData === void 0 || (_formData$workforceEm38 = formData.workforceEmployee) === null || _formData$workforceEm38 === void 0 || (_formData$workforceEm38 = _formData$workforceEm38.company) === null || _formData$workforceEm38 === void 0 ? void 0 : _formData$workforceEm38.id,
              factory: formData !== null && formData !== void 0 && (_formData$workforceEm39 = formData.workforceEmployee) !== null && _formData$workforceEm39 !== void 0 && (_formData$workforceEm39 = _formData$workforceEm39.factory) !== null && _formData$workforceEm39 !== void 0 && _formData$workforceEm39.id || formData !== null && formData !== void 0 && (_formData$deceasedWor7 = formData.deceasedWorkerInfo) !== null && _formData$deceasedWor7 !== void 0 && (_formData$deceasedWor7 = _formData$deceasedWor7.factory) !== null && _formData$deceasedWor7 !== void 0 && _formData$deceasedWor7.id || formData !== null && formData !== void 0 && formData.factory ? safeDecodeId((formData === null || formData === void 0 || (_formData$workforceEm40 = formData.workforceEmployee) === null || _formData$workforceEm40 === void 0 || (_formData$workforceEm40 = _formData$workforceEm40.factory) === null || _formData$workforceEm40 === void 0 ? void 0 : _formData$workforceEm40.id) || (formData === null || formData === void 0 || (_formData$deceasedWor8 = formData.deceasedWorkerInfo) === null || _formData$deceasedWor8 === void 0 || (_formData$deceasedWor8 = _formData$deceasedWor8.factory) === null || _formData$deceasedWor8 === void 0 ? void 0 : _formData$deceasedWor8.id) || (formData === null || formData === void 0 || (_formData$factory2 = formData.factory) === null || _formData$factory2 === void 0 ? void 0 : _formData$factory2.id)) : null,
              organizationType: organizationType || (parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.organizationType),
              applicationType: selectedApplicationType || (parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.applicationType),
              grantAmount: formData === null || formData === void 0 ? void 0 : formData.employeeAccidentInfo.grantAmount,
              employeeBankInfo: JSON.stringify(formData.employeeBankInfo) || JSON.stringify(parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.employeeBankInfo),
              employeeApplicantInfo: JSON.stringify(formData.workforceApplicant).replace(/\\/g, "").replace(/"{/g, "{").replace(/}"/g, "}") || JSON.stringify(parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.workforceApplicant).replace(/\\/g, "").replace(/"{/g, "{").replace(/}"/g, "}"),
              employeeDependentInfo: JSON.stringify(formData.dependents).replace(/\\/g, "").replace(/"{/g, "{").replace(/}"/g, "}") || JSON.stringify(parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.employeeDependentInfo).replace(/\\/g, "").replace(/"{/g, "{").replace(/}"/g, "}"),
              deceasedWorkerInfo: JSON.stringify(formData.workforceEmployee).replace(/\\/g, "").replace(/"{/g, "{").replace(/}"/g, "}").replace(/\\\\\\/g, "\\\\"),
              employeeAccidentInfo: JSON.stringify(formData === null || formData === void 0 ? void 0 : formData.employeeAccidentInfo) || JSON.stringify(parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.employeeAccidentInfo),
              metadata: JSON.stringify(formData.metadata),
              status: WORKFORCE_STATUS$1.DRAFT,
              applicationFor: applicationForSelf === "yes" ? "self" : applicationForSelf === "" ? "" : "dependent"
            };
            console.log(uploadDependentFile);
            if (!(uploadDependentFile !== null && uploadDependentFile !== void 0 && uploadDependentFile.length)) {
              _context.next = 84;
              break;
            }
            _context.next = 84;
            return Promise.all(uploadDependentFile.map(function (file) {
              return dispatch(createWorkforceDocument(_objectSpread$R(_objectSpread$R({}, file), {}, {
                workforceApplicationId: safeApplicationId(applicationId, parsedApplicationData)
              }), "Created workforce document"));
            }));
          case 84:
            _context.next = 86;
            return dispatch(updateApplication(_updateApplicationData2, "update workforce application")).then(function (res) {
              return setIsDependentSaved(true);
            });
          case 86:
            _context.prev = 86;
            if (!(parsedApplicationData !== null && parsedApplicationData !== void 0 && parsedApplicationData.id)) {
              _context.next = 92;
              break;
            }
            _context.next = 90;
            return dispatch(fetchEmployeeDependent(modulesManager, ["workforceApplication_Id:\"".concat(parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.id, "\"")]));
          case 90:
            _context.next = 94;
            break;
          case 92:
            _context.next = 94;
            return dispatch(fetchEmployeeDependent(modulesManager, ["workforceApplication_Id:\"".concat(safeApplicationId(applicationId), "\"")]));
          case 94:
            _context.prev = 94;
            // Move to next step and unblock navigation after data fetch completes
            setActiveStep(nextStep);
            setIsNavigationBlocked(false);
            setStepLoadingState(function (prev) {
              return _objectSpread$R(_objectSpread$R({}, prev), {}, _defineProperty({}, nextStep, false));
            });
            return _context.finish(94);
          case 99:
            return _context.abrupt("return", true);
          case 102:
            _updateApplicationData3 = {
              // id: decodeId(applicationId[0]?.id) || parsedApplicationData?.id,
              id: safeApplicationId(applicationId, parsedApplicationData),
              workforceEmployeeId: safeDecodeId(employeeData === null || employeeData === void 0 ? void 0 : employeeData.id) || safeDecodeId(reduxState.core.user.id),
              company: formData === null || formData === void 0 || (_formData$workforceEm41 = formData.workforceEmployee) === null || _formData$workforceEm41 === void 0 || (_formData$workforceEm41 = _formData$workforceEm41.company) === null || _formData$workforceEm41 === void 0 ? void 0 : _formData$workforceEm41.id,
              factory: formData !== null && formData !== void 0 && (_formData$workforceEm42 = formData.workforceEmployee) !== null && _formData$workforceEm42 !== void 0 && (_formData$workforceEm42 = _formData$workforceEm42.factory) !== null && _formData$workforceEm42 !== void 0 && _formData$workforceEm42.id || formData !== null && formData !== void 0 && (_formData$deceasedWor9 = formData.deceasedWorkerInfo) !== null && _formData$deceasedWor9 !== void 0 && (_formData$deceasedWor9 = _formData$deceasedWor9.factory) !== null && _formData$deceasedWor9 !== void 0 && _formData$deceasedWor9.id || formData !== null && formData !== void 0 && formData.factory ? safeDecodeId((formData === null || formData === void 0 || (_formData$workforceEm43 = formData.workforceEmployee) === null || _formData$workforceEm43 === void 0 || (_formData$workforceEm43 = _formData$workforceEm43.factory) === null || _formData$workforceEm43 === void 0 ? void 0 : _formData$workforceEm43.id) || (formData === null || formData === void 0 || (_formData$deceasedWor10 = formData.deceasedWorkerInfo) === null || _formData$deceasedWor10 === void 0 || (_formData$deceasedWor10 = _formData$deceasedWor10.factory) === null || _formData$deceasedWor10 === void 0 ? void 0 : _formData$deceasedWor10.id) || (formData === null || formData === void 0 || (_formData$factory3 = formData.factory) === null || _formData$factory3 === void 0 ? void 0 : _formData$factory3.id)) : null,
              organizationType: organizationType || (parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.organizationType),
              applicationType: selectedApplicationType || (parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.applicationType),
              grantAmount: formData === null || formData === void 0 ? void 0 : formData.employeeAccidentInfo.grantAmount,
              employeeBankInfo: JSON.stringify(formData.employeeBankInfo) || JSON.stringify(parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.employeeBankInfo),
              // employeeDependentInfo: JSON.stringify(formData.dependents) || JSON.stringify(parsedApplicationData?.employeeDependentInfo),
              employeeApplicantInfo: JSON.stringify(formData.workforceApplicant).replace(/\\/g, "").replace(/"{/g, "{").replace(/}"/g, "}") || JSON.stringify(parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.workforceApplicant).replace(/\\/g, "").replace(/"{/g, "{").replace(/}"/g, "}"),
              employeeDependentInfo: JSON.stringify(formData.dependents).replace(/\\/g, "").replace(/"{/g, "{").replace(/}"/g, "}") || JSON.stringify(parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.employeeDependentInfo).replace(/\\/g, "").replace(/"{/g, "{").replace(/}"/g, "}"),
              employeeAccidentInfo: JSON.stringify(formData === null || formData === void 0 ? void 0 : formData.employeeAccidentInfo) || JSON.stringify(parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.employeeAccidentInfo),
              metadata: JSON.stringify(formData.metadata),
              deceasedWorkerInfo: JSON.stringify(formData.deceasedWorkerInfo).replace(/\\/g, "").replace(/"{/g, "{").replace(/}"/g, "}").replace(/\\\\\\/g, "\\\\"),
              // deceasedWorkerInfo: JSON.stringify(formData.workforceEmployee),
              status: WORKFORCE_STATUS$1.DRAFT,
              applicationFor: applicationForSelf === "yes" ? "self" : applicationForSelf === "" ? "" : "dependent"
            }; // if (uploadBankFile) {
            //   await uploadBankFile.map((file) => {
            //     const appId = applicationId || formData?.id;
            //     return dispatch(
            //       createWorkforceDocument(
            //         { ...file, workforceApplicationId: safeApplicationId(applicationId, parsedApplicationData) },
            //         `Created workforce document`,
            //       ),
            //     );
            //   });
            // }
            dispatch(updateApplication(_updateApplicationData3, "update workforce application"));
          case 104:
            // Set active step and unblock navigation (except for step 5 which handles it separately)
            if (nextStep !== 5) {
              setActiveStep(nextStep);
              setIsNavigationBlocked(false);
            }
            return _context.abrupt("return", true);
          case 106:
            return _context.abrupt("return", false);
          case 107:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[86,, 94, 99]]);
    }));
    return function handleNext() {
      return _ref2.apply(this, arguments);
    };
  }();
  var handleBack = function handleBack() {
    return setActiveStep(function (prevStep) {
      return prevStep - 1;
    });
  };
  var handleArrayFieldChange = function handleArrayFieldChange(fieldKey, index, key, value) {
    setFormData(function (prev) {
      var items = Array.isArray(prev[fieldKey]) ? _toConsumableArray(prev[fieldKey]) : [];
      var currentItem = items[index] || {};
      var nextValue = typeof value === "function" ? value(currentItem[key]) : value;
      items[index] = _objectSpread$R(_objectSpread$R({}, currentItem), {}, _defineProperty({}, key, nextValue));
      return _objectSpread$R(_objectSpread$R({}, prev), {}, _defineProperty({}, fieldKey, items));
    });
  };
  var addArrayFieldItem = function addArrayFieldItem(fieldKey) {
    var defaultItem = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    setFormData(function (prev) {
      var items = Array.isArray(prev[fieldKey]) ? _toConsumableArray(prev[fieldKey]) : [{}];
      var updated = [].concat(_toConsumableArray(items), [defaultItem]);
      setExpanded === null || setExpanded === void 0 || setExpanded(updated.length - 1); // optional chaining
      return _objectSpread$R(_objectSpread$R({}, prev), {}, _defineProperty({}, fieldKey, updated));
    });
  };
  var removeArrayFieldItem = function removeArrayFieldItem(fieldKey, index) {
    setFormData(function (prev) {
      var items = Array.isArray(prev[fieldKey]) ? _toConsumableArray(prev[fieldKey]) : [];
      var updated = items.filter(function (_, i) {
        return i !== index;
      });
      return _objectSpread$R(_objectSpread$R({}, prev), {}, _defineProperty({}, fieldKey, updated));
    });
  };
  var handleSubmit = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var _parsedApplicationDat82, _formData$workforceEm44, _formData$workforceEm45, _formData$deceasedWor11, _formData$workforceEm46, _formData$deceasedWor12, _formData$factory4;
      var submittedBy, updateApplicationData;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            if (!uploadBankFile) {
              _context2.next = 3;
              break;
            }
            _context2.next = 3;
            return Promise.all(uploadBankFile.map(function (file) {
              return dispatch(createWorkforceDocument(_objectSpread$R(_objectSpread$R({}, file), {}, {
                workforceApplicationId: safeApplicationId(applicationId, parsedApplicationData)
              }), "Created workforce document"));
            }));
          case 3:
            _context2.next = 5;
            return Promise.all(uploadFile.map(function (file, index) {
              // const createDocumentData = { ...file, workforceApplicationId: safeApplicationId(applicationId,parsedApplicationData) }
              // console.log({createDocumentData})
              return dispatch(createWorkforceDocument(_objectSpread$R(_objectSpread$R({}, file), {}, {
                workforceApplicationId: safeApplicationId(applicationId, parsedApplicationData)
              }), "Created workforce document "));
            }));
          case 5:
            submittedBy = user_type === WORKFORCE_USER_TYPE.APPLICANT ? "applicant" : user_type === WORKFORCE_USER_TYPE.FACTORY_ADMIN ? "factory_admin" : "UNKNOWN";
            updateApplicationData = {
              // id: decodeId(applicationId[0]?.id) || parsedApplicationData?.id,
              id: safeApplicationId(applicationId, parsedApplicationData),
              workforceEmployeeId: safeDecodeId(formData === null || formData === void 0 ? void 0 : formData.workforceEmployee.id) || safeDecodeId(parsedApplicationData === null || parsedApplicationData === void 0 || (_parsedApplicationDat82 = parsedApplicationData.workforceEmployee) === null || _parsedApplicationDat82 === void 0 ? void 0 : _parsedApplicationDat82.id) || safeDecodeId(employeeData === null || employeeData === void 0 ? void 0 : employeeData.id),
              company: formData === null || formData === void 0 || (_formData$workforceEm44 = formData.workforceEmployee) === null || _formData$workforceEm44 === void 0 || (_formData$workforceEm44 = _formData$workforceEm44.company) === null || _formData$workforceEm44 === void 0 ? void 0 : _formData$workforceEm44.id,
              factory: formData !== null && formData !== void 0 && (_formData$workforceEm45 = formData.workforceEmployee) !== null && _formData$workforceEm45 !== void 0 && (_formData$workforceEm45 = _formData$workforceEm45.factory) !== null && _formData$workforceEm45 !== void 0 && _formData$workforceEm45.id || formData !== null && formData !== void 0 && (_formData$deceasedWor11 = formData.deceasedWorkerInfo) !== null && _formData$deceasedWor11 !== void 0 && (_formData$deceasedWor11 = _formData$deceasedWor11.factory) !== null && _formData$deceasedWor11 !== void 0 && _formData$deceasedWor11.id || formData !== null && formData !== void 0 && formData.factory ? safeDecodeId((formData === null || formData === void 0 || (_formData$workforceEm46 = formData.workforceEmployee) === null || _formData$workforceEm46 === void 0 || (_formData$workforceEm46 = _formData$workforceEm46.factory) === null || _formData$workforceEm46 === void 0 ? void 0 : _formData$workforceEm46.id) || (formData === null || formData === void 0 || (_formData$deceasedWor12 = formData.deceasedWorkerInfo) === null || _formData$deceasedWor12 === void 0 || (_formData$deceasedWor12 = _formData$deceasedWor12.factory) === null || _formData$deceasedWor12 === void 0 ? void 0 : _formData$deceasedWor12.id) || (formData === null || formData === void 0 || (_formData$factory4 = formData.factory) === null || _formData$factory4 === void 0 ? void 0 : _formData$factory4.id)) : null,
              organizationType: organizationType || (parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.organizationType),
              applicationType: selectedApplicationType || (parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.applicationType),
              grantAmount: formData === null || formData === void 0 ? void 0 : formData.employeeAccidentInfo.grantAmount,
              employeeBankInfo: JSON.stringify(formData.employeeBankInfo) || JSON.stringify(parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.employeeBankInfo),
              employeeApplicantInfo: JSON.stringify(formData.workforceApplicant).replace(/\\/g, "").replace(/"{/g, "{").replace(/}"/g, "}") || JSON.stringify(parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.workforceApplicant).replace(/\\/g, "").replace(/"{/g, "{").replace(/}"/g, "}"),
              // employeeDependentInfo: JSON.stringify(formData.dependents) || JSON.stringify(parsedApplicationData?.employeeDependentInfo),
              employeeDependentInfo: JSON.stringify(formData.dependents).replace(/\\/g, "").replace(/"{/g, "{").replace(/}"/g, "}") || JSON.stringify(parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.employeeDependentInfo).replace(/\\/g, "").replace(/"{/g, "{").replace(/}"/g, "}"),
              employeeAccidentInfo: JSON.stringify(formData === null || formData === void 0 ? void 0 : formData.employeeAccidentInfo) || JSON.stringify(parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.employeeAccidentInfo),
              metadata: JSON.stringify(formData.metadata),
              deceasedWorkerInfo: JSON.stringify(formData.workforceEmployee).replace(/\\/g, "").replace(/"{/g, "{").replace(/}"/g, "}").replace(/\\\\\\/g, "\\\\"),
              status: WORKFORCE_STATUS$1.NEW,
              applicationFor: applicationForSelf === "yes" ? "self" : applicationForSelf === "" ? "" : "dependent",
              submittedBy: submittedBy
            };
            dispatch(updateApplication(updateApplicationData, "update workforce application "));

            // dispatch(createApplicationMovement(createApplicationMovementData, `create workforce movement`));
          case 8:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function handleSubmit() {
      return _ref3.apply(this, arguments);
    };
  }();
  if (showPreview) {
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ApplicationViewPage, {
      application: formData,
      language: "fr"
    }), /*#__PURE__*/React.createElement("div", {
      className: classes.buttonContainer
    }, /*#__PURE__*/React.createElement(Button, {
      variant: "outlined",
      color: "error",
      onClick: function onClick() {
        setShowPreview(false);
      }
    }, /*#__PURE__*/React.createElement(FormattedMessage, {
      module: "workforce",
      id: "workforce.back"
    })), /*#__PURE__*/React.createElement(Button, {
      variant: "contained",
      color: "primary",
      onClick: function onClick() {
        setShowPreview(false);
        setShowVerifyNid(true);
      }
    }, /*#__PURE__*/React.createElement(FormattedMessage, {
      module: "workforce",
      id: "workforce.submit"
    }))));
  }
  if (showVerifyNid) {
    return /*#__PURE__*/React.createElement("div", {
      className: classes.container
    }, /*#__PURE__*/React.createElement(Paper, {
      className: classes.paper,
      elevation: 0
    }, /*#__PURE__*/React.createElement(NidVerification, {
      formData: formData,
      nidOrBcn: nidOrBcn,
      setDisableConfirmSubmit: setDisableConfirmSubmit
    }), /*#__PURE__*/React.createElement("div", {
      className: classes.buttonContainer
    }, /*#__PURE__*/React.createElement(Button, {
      variant: "contained",
      color: "primary"
      // disabled={disableConfirmSubmit}
      ,
      onClick: /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return handleSubmit();
            case 2:
              setShowVerifyNid(false);
              setIsSubmitted(true);
            case 4:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))
    }, /*#__PURE__*/React.createElement(FormattedMessage, {
      module: "workforce",
      id: "workforce.confirm.submit"
    })))));
  }
  if (isSubmitted) {
    return /*#__PURE__*/React.createElement(ApplicationFormSubmitted, null);
  }
  console.log({
    fromFactoryAdmin: employeeData
  });
  console.log({
    tazwer: formData
  });
  console.log({
    uploadFile: uploadFile
  });
  console.log({
    uploadBankFile: uploadBankFile
  });
  console.log({
    uploadDependentFile: uploadDependentFile
  });
  console.log({
    errors: errors
  });
  return /*#__PURE__*/React.createElement("div", {
    className: classes.container
  }, /*#__PURE__*/React.createElement(Paper, {
    className: classes.paper,
    elevation: 0
  }, /*#__PURE__*/React.createElement(Stepper, {
    activeStep: activeStep,
    alternativeLabel: true,
    style: {
      padding: "0px"
    }
  }, steps$1.map(function (label) {
    return /*#__PURE__*/React.createElement(Step, {
      key: label
    }, /*#__PURE__*/React.createElement(StepLabel, null, /*#__PURE__*/React.createElement(FormattedMessage, {
      module: "workforce",
      id: label
    })));
  })), /*#__PURE__*/React.createElement(Box$1, {
    mt: 0,
    ref: stepRef
  }, activeStep === 0 ? /*#__PURE__*/React.createElement(ApplicationReason, {
    modulesManager: modulesManager,
    handleChange: function handleChange(key, value) {
      return _handleChange(key, value, "metadata");
    },
    formData: formData,
    setDeathType: setDeathType,
    deathType: deathType,
    errors: errors
  }) : activeStep === 1 ? /*#__PURE__*/React.createElement(ApplicantDetailsForm, {
    handleChange: function handleChange(key, value) {
      return _handleChange(key, value, "workforceApplicant");
    },
    formData: formData,
    setNidOrBcn: setNidOrBcn,
    nidOrBcn: nidOrBcn,
    errors: errors
  }) : activeStep === 2 ? /*#__PURE__*/React.createElement(EmployeeDetailsForm, {
    handleChange: function handleChange(key, value) {
      return _handleChange(key, value, "workforceEmployee");
    },
    formData: formData,
    setNidOrBcn: setNidOrBcn,
    nidOrBcn: nidOrBcn,
    errors: errors
  }) : activeStep === 3 ? /*#__PURE__*/React.createElement(EmployeeLocationForm, {
    handleChange: function handleChange(key, value) {
      return _handleChange(key, value, "workforceEmployee");
    },
    formData: formData
  }) : activeStep === 4 ? /*#__PURE__*/React.createElement(EmployeeDependentForm, {
    applicationType: formData.applicationType,
    dependents: formData.dependents,
    handleChange: function handleChange(index, key, value) {
      return handleArrayFieldChange("dependents", index, key, value);
    },
    addItem: function addItem() {
      return addArrayFieldItem("dependents", {
        fullName: "",
        relationship: ""
      });
    },
    removeItem: function removeItem(index) {
      return removeArrayFieldItem("dependents", index);
    },
    expanded: expanded,
    setExpanded: setExpanded,
    formdata: formData,
    errors: errors
  }) : activeStep === 5 ? /*#__PURE__*/React.createElement(React.Fragment, null, !isDependentSaved ? /*#__PURE__*/React.createElement(Box$1, {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    minHeight: "400px",
    gap: 2
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6"
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "workforce.loading.bank.data",
    module: "workforce"
  }))) : /*#__PURE__*/React.createElement(EmployeeDeathAccountInfoForm, {
    formdata: formData,
    accounts: formData.employeeBankInfo,
    handleChange: function handleChange(index, key, value) {
      return handleArrayFieldChange("employeeBankInfo", index, key, value);
    },
    addItem: function addItem() {
      return addArrayFieldItem("employeeBankInfo", {
        accountHolderName: "",
        bankName: "",
        accountNumber: "",
        branchName: ""
      });
    },
    removeItem: function removeItem(index) {
      return removeArrayFieldItem("employeeBankInfo", index);
    },
    expanded: expanded,
    setExpanded: setExpanded,
    applicationId: applicationId,
    errors: errors
  })) : null), activeStep === steps$1.length - 1 && /*#__PURE__*/React.createElement(Box$1, null, /*#__PURE__*/React.createElement(FormControlLabel, {
    control: /*#__PURE__*/React.createElement(Checkbox, {
      checked: acknowledged,
      onChange: function onChange(e) {
        return setAcknowledged(e.target.checked);
      },
      style: {
        color: "blue"
      }
    }),
    label: /*#__PURE__*/React.createElement(Typography, {
      variant: "body2"
    }, /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.application.acknowledgement.text",
      module: "workforce"
    }))
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.buttonContainer
  }, activeStep > 0 && /*#__PURE__*/React.createElement(Button, {
    onClick: handleBack,
    variant: "outlined"
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.back"
  }), " "), activeStep < steps$1.length - 1 ? /*#__PURE__*/React.createElement(Button, {
    variant: "contained",
    color: "primary",
    onClick: handleNext
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.save.next"
  })) : /*#__PURE__*/React.createElement(Button, {
    variant: "contained",
    color: "primary",
    disabled: !acknowledged,
    onClick: /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
      var isSuccess;
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return handleNext();
          case 2:
            isSuccess = _context4.sent;
            if (isSuccess) setShowPreview(true);
          case 4:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }))
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.submit"
  })))), /*#__PURE__*/React.createElement(Dialog$1, {
    open: isNavigationBlocked,
    onClose: function onClose() {},
    disableBackdropClick: true,
    disableEscapeKeyDown: true,
    maxWidth: "sm",
    fullWidth: true
  }, /*#__PURE__*/React.createElement(Box$1, {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: 4,
    gap: 2
  }, /*#__PURE__*/React.createElement(CircularProgress$1, {
    size: 60,
    thickness: 4
  }), /*#__PURE__*/React.createElement(Typography, {
    variant: "h6",
    align: "center"
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "workforce.processing.data",
    module: "workforce"
  })), /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    align: "center",
    color: "textSecondary"
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "workforce.please.wait",
    module: "workforce"
  })))), /*#__PURE__*/React.createElement(CustomSnackbar, {
    open: alertMessage,
    onClose: function onClose() {
      return setAlertMessage(false);
    },
    type: "error",
    message: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.application.before.eis.startDate.error",
      module: "workforce"
    }),
    duration: 5000
  }), /*#__PURE__*/React.createElement(CustomSnackbar, {
    open: showErrorSnackbar // Use the new state
    ,
    onClose: function onClose() {
      return setShowErrorSnackbar(false);
    } // Allow it to close
    ,
    type: "error",
    message: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "core.error.generel",
      module: "workforce"
    }),
    duration: 4000
  }), /*#__PURE__*/React.createElement(CustomSnackbar, {
    open: dependentErr,
    onClose: function onClose() {
      return setDependentErr(false);
    },
    type: "error",
    message: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "core.error.inEligible.dependent"
    }),
    duration: 5000
  }), /*#__PURE__*/React.createElement(CustomSnackbar, {
    open: showDuplicateError,
    onClose: function onClose() {
      return setShowDuplicateError(false);
    },
    type: "error",
    message: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.application.duplicate.found",
      module: "workforce"
    }),
    duration: 5000
  }));
};

var useStyles$12 = makeStyles(function (theme) {
  return {
    title: {
      fontWeight: "bold"
    },
    paper: {
      padding: theme.spacing(2),
      width: "100%",
      maxWidth: 650,
      margin: "auto"
    },
    section: {
      marginTop: theme.spacing(3)
    },
    formSection: {
      marginLeft: theme.spacing(2)
    }
  };
});
var ScholarshipApplicationCheckbox = function ScholarshipApplicationCheckbox(_ref) {
  var _formData$employeeChi, _formData$employeeChi2, _formData$employeeChi3, _formData$employeeChi4, _formData$employeeChi5, _formData$employeeChi6, _formData$employeeChi7, _formData$employeeChi8, _formData$employeeChi9, _formData$employeeChi10, _formData$employeeChi11, _formData$employeeChi12, _formData$employeeChi13, _formData$employeeChi14, _formData$employeeChi15, _formData$employeeChi16, _formData$employeeChi17, _formData$employeeChi18, _formData$employeeChi19, _formData$employeeChi20;
  var modulesManager = _ref.modulesManager,
    handleChange = _ref.handleChange;
    _ref.selectedScholarshipOption;
    _ref.setSelectedScholarshipOption;
    var formData = _ref.formData,
    applicationForSelf = _ref.applicationForSelf,
    errors = _ref.errors;
  var _useTranslations = useTranslations("core.RegistrationPage", modulesManager),
    formatMessage = _useTranslations.formatMessage;
  var classes = useStyles$12();
  var handleselectedScholarshipOptionChange = function handleselectedScholarshipOptionChange(event) {
    var value = event.target.value;
    handleChange("scholarshipFor", value);
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FormControl, {
    component: "fieldset",
    className: classes.formSection
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 2,
    className: classes.section
  }, applicationForSelf === "no" && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6,
    className: classes.item
  }, /*#__PURE__*/React.createElement(TextInput, {
    id: "nameEn",
    label: "workforce.child.name.en",
    value: (formData === null || formData === void 0 || (_formData$employeeChi = formData.employeeChildrenInfo) === null || _formData$employeeChi === void 0 ? void 0 : _formData$employeeChi.nameEn) || "",
    formatInput: filterEnglish,
    onChange: function onChange(v) {
      return handleChange("nameEn", filterEnglish(v));
    },
    required: true,
    error: !!errors.nameEn,
    helperText: errors.nameEn,
    readOnly: false
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6,
    className: classes.item
  }, /*#__PURE__*/React.createElement(TextInput, {
    id: "nameBn",
    label: "workforce.child.name.bn",
    value: (formData === null || formData === void 0 || (_formData$employeeChi2 = formData.employeeChildrenInfo) === null || _formData$employeeChi2 === void 0 ? void 0 : _formData$employeeChi2.nameBn) || "",
    formatInput: filterBangla,
    onChange: function onChange(v) {
      return handleChange("nameBn", filterBangla(v));
    },
    required: true,
    readOnly: false,
    error: !!errors.nameBn,
    helperText: errors.nameBn
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6,
    className: classes.item
  }, /*#__PURE__*/React.createElement(TextInput, {
    id: "nid",
    label: "workforce.application.employee.children.nidOrBirthRegistry",
    value: (formData === null || formData === void 0 || (_formData$employeeChi3 = formData.employeeChildrenInfo) === null || _formData$employeeChi3 === void 0 ? void 0 : _formData$employeeChi3.nid) || "",
    onChange: function onChange(v) {
      return handleChange("nid", v);
    },
    type: "number",
    readOnly: false,
    required: true,
    error: !!errors.nid,
    helperText: errors.nid
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6,
    className: classes.item
  }, /*#__PURE__*/React.createElement(PublishedComponent, {
    pubRef: "workforce.DatePicker",
    label: "workforce.employee.birthdate",
    value: (formData === null || formData === void 0 || (_formData$employeeChi4 = formData.employeeChildrenInfo) === null || _formData$employeeChi4 === void 0 ? void 0 : _formData$employeeChi4.birthDate) || "",
    onChange: function onChange(v) {
      return handleChange("birthDate", v);
    },
    readOnly: false
    // required
  })))), /*#__PURE__*/React.createElement(Typography, {
    variant: "body1",
    className: "".concat(classes.title, " ").concat(classes.section)
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "workforce.application.steps.select",
    module: "workforce"
  })), /*#__PURE__*/React.createElement(RadioGroup, {
    value: (formData === null || formData === void 0 || (_formData$employeeChi5 = formData.employeeChildrenInfo) === null || _formData$employeeChi5 === void 0 ? void 0 : _formData$employeeChi5.scholarshipFor) || "",
    onChange: handleselectedScholarshipOptionChange
  }, /*#__PURE__*/React.createElement(FormControlLabel, {
    value: "ssc",
    control: /*#__PURE__*/React.createElement(Radio, {
      color: "primary"
    }),
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.application.steps.ssc",
      module: "workforce"
    })
  }), /*#__PURE__*/React.createElement(FormControlLabel, {
    value: "hsc",
    control: /*#__PURE__*/React.createElement(Radio, {
      color: "primary"
    }),
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.application.steps.hsc",
      module: "workforce"
    })
  }), /*#__PURE__*/React.createElement(FormControlLabel, {
    value: "underGraduate",
    control: /*#__PURE__*/React.createElement(Radio, {
      color: "primary"
    }),
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.application.steps.underGraduate",
      module: "workforce"
    })
  })), /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 2,
    className: classes.section
  }, (formData === null || formData === void 0 || (_formData$employeeChi6 = formData.employeeChildrenInfo) === null || _formData$employeeChi6 === void 0 ? void 0 : _formData$employeeChi6.scholarshipFor) === "underGraduate" || (formData === null || formData === void 0 || (_formData$employeeChi7 = formData.employeeChildrenInfo) === null || _formData$employeeChi7 === void 0 ? void 0 : _formData$employeeChi7.scholarshipFor) === "postGraduate" ? /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement(TextInput, {
    id: "university",
    label: "workforce.application.educationInfo.university",
    value: (formData === null || formData === void 0 || (_formData$employeeChi8 = formData.employeeChildrenInfo) === null || _formData$employeeChi8 === void 0 ? void 0 : _formData$employeeChi8.university) || "",
    onChange: function onChange(v) {
      return handleChange("university", v);
    },
    type: "text",
    required: true,
    readOnly: false,
    error: !!errors.university,
    helperText: errors.university
  })) : /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement(BoardPicker, {
    id: "board",
    value: (formData === null || formData === void 0 || (_formData$employeeChi9 = formData.employeeChildrenInfo) === null || _formData$employeeChi9 === void 0 ? void 0 : _formData$employeeChi9.board) || "",
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.application.educationInfo.board",
      module: "workforce"
    }),
    required: true,
    onChange: function onChange(v) {
      return handleChange("board", v);
    },
    readOnly: false
  }), errors.board && /*#__PURE__*/React.createElement(FormHelperText, {
    error: true
  }, errors.board)), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement(YearPicker, {
    id: "passingYear",
    label: (formData === null || formData === void 0 || (_formData$employeeChi10 = formData.employeeChildrenInfo) === null || _formData$employeeChi10 === void 0 ? void 0 : _formData$employeeChi10.scholarshipFor) === "underGraduate" ? formatMessage("workforce.application.educationInfo.admissionYear") : formatMessage("workforce.application.educationInfo.passingYear"),
    value: (formData === null || formData === void 0 || (_formData$employeeChi11 = formData.employeeChildrenInfo) === null || _formData$employeeChi11 === void 0 ? void 0 : _formData$employeeChi11.passingYear) || "",
    onChange: function onChange(v) {
      return handleChange("passingYear", v);
    },
    required: true
  }), errors.passingYear && /*#__PURE__*/React.createElement(FormHelperText, {
    error: true
  }, errors.passingYear)), (formData === null || formData === void 0 || (_formData$employeeChi12 = formData.employeeChildrenInfo) === null || _formData$employeeChi12 === void 0 ? void 0 : _formData$employeeChi12.scholarshipFor) === "underGraduate" ? /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement(TextInput, {
    id: "idNo",
    label: "workforce.application.educationInfo.IdNo",
    value: (formData === null || formData === void 0 || (_formData$employeeChi13 = formData.employeeChildrenInfo) === null || _formData$employeeChi13 === void 0 ? void 0 : _formData$employeeChi13.idNo) || "",
    onChange: function onChange(v) {
      return handleChange("idNo", v);
    },
    type: "number",
    required: true,
    readOnly: false,
    error: !!errors.idNo,
    helperText: errors.idNo
  })) : /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement(TextInput, {
    id: "rollNo",
    label: "workforce.application.educationInfo.rollNo",
    value: (formData === null || formData === void 0 || (_formData$employeeChi14 = formData.employeeChildrenInfo) === null || _formData$employeeChi14 === void 0 ? void 0 : _formData$employeeChi14.rollNo) || "",
    onChange: function onChange(v) {
      return handleChange("rollNo", v);
    },
    type: "number",
    required: true,
    readOnly: false,
    error: !!errors.rollNo,
    helperText: errors.rollNo
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement(TextInput, {
    id: "regNo",
    label: "workforce.application.educationInfo.regNo",
    value: (formData === null || formData === void 0 || (_formData$employeeChi15 = formData.employeeChildrenInfo) === null || _formData$employeeChi15 === void 0 ? void 0 : _formData$employeeChi15.regNo) || "",
    onChange: function onChange(v) {
      return handleChange("regNo", v);
    },
    type: "number",
    required: true,
    readOnly: false,
    error: !!errors.regNo,
    helperText: errors.regNo
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6,
    className: classes.item
  }, /*#__PURE__*/React.createElement(TextInput, {
    id: "studyingClass",
    label: (formData === null || formData === void 0 || (_formData$employeeChi16 = formData.employeeChildrenInfo) === null || _formData$employeeChi16 === void 0 ? void 0 : _formData$employeeChi16.scholarshipFor) === "underGraduate" ? formatMessage("workforce.application.employee.children.studyingSemester") : formatMessage("workforce.application.employee.children.studyingClass"),
    value: (formData === null || formData === void 0 || (_formData$employeeChi17 = formData.employeeChildrenInfo) === null || _formData$employeeChi17 === void 0 ? void 0 : _formData$employeeChi17.studyingClass) || "",
    onChange: function onChange(v) {
      return handleChange("studyingClass", v);
    },
    readOnly: false,
    required: (formData === null || formData === void 0 || (_formData$employeeChi18 = formData.employeeChildrenInfo) === null || _formData$employeeChi18 === void 0 ? void 0 : _formData$employeeChi18.scholarshipFor) === "underGraduate" || (formData === null || formData === void 0 || (_formData$employeeChi19 = formData.employeeChildrenInfo) === null || _formData$employeeChi19 === void 0 ? void 0 : _formData$employeeChi19.scholarshipFor) === "postGraduate" ? true : false,
    error: !!errors.studyingClass,
    helperText: errors.studyingClass
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement(TextInput, {
    id: "cgpa",
    label: "workforce.application.educationInfo.cgpa",
    value: (formData === null || formData === void 0 || (_formData$employeeChi20 = formData.employeeChildrenInfo) === null || _formData$employeeChi20 === void 0 ? void 0 : _formData$employeeChi20.cgpa) || "",
    onChange: function onChange(v) {
      return handleChange("cgpa", v);
    }
    // type="text"
    ,
    required: true,
    readOnly: false,
    error: !!errors.cgpa,
    helperText: errors.cgpa
  })))), /*#__PURE__*/React.createElement(EmployeeDetailsForm2, {
    handleChange: function handleChange() {},
    formData: formData,
    selectedApplicationType: formData.applicationType,
    errors: errors,
    formStepNo: "educations"
  }));
};

function ownKeys$Q(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$Q(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$Q(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$Q(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var useStyles$11 = makeStyles(function (theme) {
  return {
    container: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center"
    },
    paper: {
      padding: theme.spacing(2),
      width: 700
    },
    buttonContainer: {
      marginTop: theme.spacing(2),
      display: "flex",
      justifyContent: "flex-end",
      gap: theme.spacing(1)
    }
  };
});
var ScholarshipApplicationForm = function ScholarshipApplicationForm(_ref) {
  var _formData$workforceEm, _formData$workforceEm2;
  var workforceFactoryId = _ref.workforceFactoryId,
    organizationType = _ref.organizationType,
    selectedApplicationType = _ref.selectedApplicationType,
    applicationForSelf = _ref.applicationForSelf,
    selectedFactory = _ref.selectedFactory,
    parsedApplicationData = _ref.parsedApplicationData;
  var employeeData = useSelector(function (state) {
    return state.workforce["workforceEmployee"];
  });
  var modulesManager = useModulesManager();
  var _useTranslations = useTranslations("workforce"),
    formatMessage = _useTranslations.formatMessage;
  var stepRef = useRef(null);
  var _useState = useState({}),
    _useState2 = _slicedToArray(_useState, 2),
    errors = _useState2[0],
    setErrors = _useState2[1];
  var applicationId = useSelector(function (state) {
    var _state$workforce$fetc;
    return (_state$workforce$fetc = state.workforce["fetchedApplicationIdByClientMutationId"]) !== null && _state$workforce$fetc !== void 0 ? _state$workforce$fetc : [];
  });
  var classes = useStyles$11();
  var dispatch = useDispatch();
  var _useState3 = useState(0),
    _useState4 = _slicedToArray(_useState3, 2),
    activeStep = _useState4[0],
    setActiveStep = _useState4[1];
  var _useState5 = useState(0),
    _useState6 = _slicedToArray(_useState5, 2),
    expanded = _useState6[0],
    setExpanded = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    acknowledged = _useState8[0],
    setAcknowledged = _useState8[1];
  var _useState9 = useState(false),
    _useState10 = _slicedToArray(_useState9, 2),
    isSubmitted = _useState10[0],
    setIsSubmitted = _useState10[1];
  var _useState11 = useState(""),
    _useState12 = _slicedToArray(_useState11, 2),
    selectedScholarshipOption = _useState12[0],
    setSelectedScholarshipOption = _useState12[1];
  var _useState13 = useState(false),
    _useState14 = _slicedToArray(_useState13, 2),
    showErrorSnackbar = _useState14[0],
    setShowErrorSnackbar = _useState14[1];
  var _useState15 = useState(false),
    _useState16 = _slicedToArray(_useState15, 2),
    showVerifyNid = _useState16[0],
    setShowVerifyNid = _useState16[1];
  var _useState17 = useState(false),
    _useState18 = _slicedToArray(_useState17, 2),
    showPreview = _useState18[0],
    setShowPreview = _useState18[1];
  var reduxState = useSelector(function (state) {
    return state;
  });
  var documentType = useSelector(function (state) {
    return state.workforce.documentType;
  });
  var _useState19 = useState(false),
    _useState20 = _slicedToArray(_useState19, 2);
    _useState20[0];
    var setDisableConfirmSubmit = _useState20[1];
  var _useState21 = useState({
      nid: (formData === null || formData === void 0 || (_formData$workforceEm = formData.workforceEmployee) === null || _formData$workforceEm === void 0 ? void 0 : _formData$workforceEm.nid) || "",
      birthCertificateNo: formData === null || formData === void 0 || (_formData$workforceEm2 = formData.workforceEmployee) === null || _formData$workforceEm2 === void 0 ? void 0 : _formData$workforceEm2.birthCertificateNo
    }),
    _useState22 = _slicedToArray(_useState21, 2),
    nidOrBcn = _useState22[0],
    setNidOrBcn = _useState22[1];
  var uploadFile = useSelector(function (state) {
    return state.workforce.uploadFile;
  });
  var uploadBankFile = useSelector(function (state) {
    return state.workforce.uploadBankFile;
  });
  var user_type = getUserType();
  var _useState23 = useState({
      workforceEmployee: {
        firstNameEn: "",
        firstNameBn: "",
        lastNameEn: "",
        lastNameBn: "",
        otherName: "",
        position: "",
        fatherNameEn: "",
        fatherNameBn: "",
        motherNameEn: "",
        motherNameBn: "",
        spouseNameEn: "",
        spouseNameBn: "",
        phoneNumber: "",
        email: "",
        birthDate: "",
        deathDate: "",
        joinDate: "",
        nid: "",
        birthCertificateNo: "",
        insuranceNumber: "",
        lifeStatus: "",
        gender: "",
        maritalStatus: "",
        monthlyEarning: "",
        uploadedNidFile: [],
        citizenship: "",
        uploadedBirthCertificateFile: [],
        permanentAddress: "",
        permanentLocation: "",
        presentLocation: "",
        presentAddress: "",
        organizationId: ""
      },
      scholarshipProgram: "",
      company: null,
      factory: selectedFactory || null,
      workforceFactoryId: workforceFactoryId || "",
      isSubmitted: "no",
      organizationType: "",
      applicationType: "",
      applicationForSelf: applicationForSelf,
      employeeBankInfo: [{}],
      employeeChildrenInfo: {},
      metadata: {},
      id: ""
    }),
    _useState24 = _slicedToArray(_useState23, 2),
    formData = _useState24[0],
    setFormData = _useState24[1];

  // Fetch employee data based on username
  var fetchEmployeeWithUser = function fetchEmployeeWithUser() {
    if (reduxState.workforce.selectedEmployee) {
      dispatch(fetchWorkforceEmployee(modulesManager, ["id: \"".concat(decodeId(reduxState.workforce.selectedEmployee.id), "\"")]));
    } else {
      dispatch(fetchWorkforceEmployee(modulesManager, ["relatedUser_LoginName_Iexact: \"".concat(reduxState.core.user.username, "\"")]));
    }
  };
  useEffect(function () {
    var _applicationId$;
    if (applicationId && applicationId.length > 0 && (_applicationId$ = applicationId[0]) !== null && _applicationId$ !== void 0 && _applicationId$.id) {
      setFormData(function (prev) {
        return _objectSpread$Q(_objectSpread$Q({}, prev), {}, {
          applicationId: applicationId[0].id
        });
      });
    }
  }, [applicationId]);
  useEffect(function () {
    if (reduxState.core.user.username) {
      fetchEmployeeWithUser();
    }
  }, [reduxState.core.user.username]);
  useEffect(function () {
    var _formData$workforceEm3, _formData$workforceEm4;
    if (!(employeeData !== null && employeeData !== void 0 && employeeData.id)) return;
    // When employeeData is fetched, set it into the form state
    setFormData({
      id: (parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.id) || "",
      workforceEmployee: {
        id: (employeeData === null || employeeData === void 0 ? void 0 : employeeData.id) || reduxState.core.user.id || "",
        organization: employeeData.organization,
        nameEn: employeeData.firstNameEn || "",
        nameBn: employeeData.firstNameBn || "",
        lastNameEn: " ",
        position: employeeData.position || "",
        fatherNameEn: employeeData.fatherNameEn || "",
        fatherNameBn: employeeData.fatherNameBn || "",
        motherNameEn: employeeData.motherNameEn || "",
        motherNameBn: employeeData.motherNameBn || "",
        spouseNameEn: employeeData.spouseNameEn || "",
        spouseNameBn: employeeData.spouseNameBn || "",
        phoneNumber: employeeData.phoneNumber || "",
        email: employeeData.email || "",
        citizenship: employeeData.citizenship || "",
        birthDate: employeeData.birthDate || "",
        deathDate: employeeData.deathDate || "",
        joinDate: employeeData.joinDate || "",
        nid: employeeData.nid || "",
        birthCertificateNo: employeeData.birthCertificateNo || "",
        insuranceNumber: employeeData.insuranceNumber || "",
        lifeStatus: employeeData.lifeStatus || "",
        gender: employeeData.gender || "",
        maritalStatus: employeeData.maritalStatus || "",
        monthlyEarning: employeeData.monthlyEarning || "",
        uploadedNidFile: employeeData.uploadedNidFile || [],
        uploadedBirthCertificateFile: employeeData.uploadedBirthCertificateFile || [],
        permanentAddress: employeeData.permanentAddress || "",
        permanentLocation: employeeData.permanentLocation || "",
        presentLocation: employeeData.presentLocation || "",
        presentAddress: employeeData.presentAddress || ""
      },
      company: employeeData.company || (formData === null || formData === void 0 || (_formData$workforceEm3 = formData.workforceEmployee) === null || _formData$workforceEm3 === void 0 || (_formData$workforceEm3 = _formData$workforceEm3.company) === null || _formData$workforceEm3 === void 0 ? void 0 : _formData$workforceEm3.id) || null,
      factory: employeeData.factory || (formData === null || formData === void 0 || (_formData$workforceEm4 = formData.workforceEmployee) === null || _formData$workforceEm4 === void 0 || (_formData$workforceEm4 = _formData$workforceEm4.factory) === null || _formData$workforceEm4 === void 0 ? void 0 : _formData$workforceEm4.id) || (parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.employeeFactory) || workforceFactoryId || selectedFactory || null,
      applicationForSelf: applicationForSelf,
      workforceFactoryId: workforceFactoryId || "",
      organizationType: (parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.organizationType) || organizationType,
      applicationType: (parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.applicationType) || selectedApplicationType,
      grantAmount: (parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.grantAmount) || (parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.employeeAccidentInfo.grantAmount),
      metadata: (parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.metadata) || (employeeData === null || employeeData === void 0 ? void 0 : employeeData.metadata) || {},
      employeeBankInfo: (parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.employeeBankInfo) || (employeeData === null || employeeData === void 0 ? void 0 : employeeData.employeeBankInfo) || [{}],
      employeeAccidentInfo: (parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.employeeAccidentInfo) || (employeeData === null || employeeData === void 0 ? void 0 : employeeData.employeeAccidentInfo) || {},
      employeeChildrenInfo: (parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.employeeChildrenInfo) || employeeData.employeeChildrenInfo || {}
    });
    // }
  }, [employeeData === null || employeeData === void 0 ? void 0 : employeeData.id, parsedApplicationData, user_type]); // Trigger this useEffect when `employeeData` changes.

  // Handle form input changes
  var _handleChange = function handleChange(key, value) {
    var parent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    setFormData(function (prev) {
      if (parent) {
        return _objectSpread$Q(_objectSpread$Q({}, prev), {}, _defineProperty({}, parent, _objectSpread$Q(_objectSpread$Q({}, prev[parent]), {}, _defineProperty({}, key, value))));
      }
      return _objectSpread$Q(_objectSpread$Q({}, prev), {}, _defineProperty({}, key, value));
    });
  };
  var handleNext = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var newErrors, isBankStep, isDetailsStep, isDocumentStep, documentValidation, BANK_DOC, bankDocsConfig, generalDocsConfig, hasErrors, _formData$workforceEm5, nextStep, fakeErrors, _formData$workforceEm6, _formData$workforceEm7, _formData$workforceEm8, _formData$workforceEm9, _formData$workforceEm10, _formData$workforceEm11, _formData$workforceEm12, _formData$workforceEm13, _formData$workforceEm14, _formData$workforceEm15, _formData$workforceEm16, _formData$workforceEm17, _formData$workforceEm18, _formData$workforceEm19, _formData$workforceEm20, _formData$workforceEm21, _formData$workforceEm22, _formData$workforceEm23, _formData$workforceEm24, _formData$workforceEm25, _formData$workforceEm26, _formData$workforceEm27, _formData$workforceEm28, workforceEmployeeData, _formData$workforceEm29, _parsedApplicationDat, _formData$workforceEm30, _formData$workforceEm31, _formData$workforceEm32, updateApplicationData, _formData$workforceEm33, _parsedApplicationDat2, _formData$workforceEm34, _formData$factory, _formData$factory2, createApplicationData, _formData$employeeChi, _formData$employeeChi2, _formData$employeeChi3, _formData$employeeChi4, _formData$employeeChi5, _formData$employeeChi6, _formData$employeeChi7, _formData$employeeChi8, _formData$employeeChi9, _formData$employeeChi10, _formData$employeeChi11, _formData$employeeChi12, _formData$employeeChi13, _formData$employeeChi14, _formData$employeeChi15, applicationMutation, applicationClientMutationId, fetchRes, applicationgetId, createEducation, _updateApplicationData, _parsedApplicationDat3, _formData$workforceEm35, _formData$factory3, _formData$factory4, _updateApplicationData2;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            console.log({
              formData: formData
            });
            newErrors = validateRequiredFields(stepRef, formatMessage, formData);
            newErrors === null || newErrors === void 0 || delete newErrors.documents;
            isBankStep = activeStep === 3;
            isDetailsStep = activeStep === 0;
            isDocumentStep = isDetailsStep || isBankStep;
            documentValidation = {
              isValid: true,
              errors: null
            };
            BANK_DOC = "applicants bank check copy";
            if (isBankStep) {
              bankDocsConfig = (documentType || []).filter(function (doc) {
                return doc.documentType === BANK_DOC;
              });
              documentValidation = validateMandatoryBankDocumentsForAccounts(bankDocsConfig, uploadBankFile || [], formData.employeeBankInfo || []);
            } else if (isDetailsStep) {
              generalDocsConfig = (documentType || []).filter(function (doc) {
                return doc.documentType !== BANK_DOC;
              });
              documentValidation = validateMandatoryDocuments(generalDocsConfig, uploadFile || []);
            }
            if (isDocumentStep && !documentValidation.isValid) {
              newErrors.documents = documentValidation.errors;
            }
            hasErrors = Object.keys(newErrors).length > 0;
            setShowErrorSnackbar(hasErrors);
            console.log({
              newErrors: newErrors
            });
            console.log({
              documentValidation: documentValidation
            });
            setErrors(newErrors);
            if (!(Object.keys(newErrors).length === 0)) {
              _context.next = 68;
              break;
            }
            nextStep = activeStep + 1;
            if (!(nextStep === 1 && !isAtLeast18YearsOld(formData === null || formData === void 0 || (_formData$workforceEm5 = formData.workforceEmployee) === null || _formData$workforceEm5 === void 0 ? void 0 : _formData$workforceEm5.birthDate))) {
              _context.next = 24;
              break;
            }
            fakeErrors = _objectSpread$Q(_objectSpread$Q({}, newErrors), {}, {
              rdmp: "core.error.workerAge"
            });
            setErrors(fakeErrors);
            console.log({
              fakeErrors: fakeErrors
            });
            return _context.abrupt("return", false);
          case 24:
            if (nextStep < steps.length) {
              setActiveStep(nextStep);
            }
            if (!(nextStep === 1 || nextStep === 2 && applicationForSelf === "no" || nextStep === 3 && applicationForSelf === "yes")) {
              _context.next = 32;
              break;
            }
            workforceEmployeeData = {
              nameEn: formData === null || formData === void 0 || (_formData$workforceEm6 = formData.workforceEmployee) === null || _formData$workforceEm6 === void 0 ? void 0 : _formData$workforceEm6.nameEn,
              nameBn: formData === null || formData === void 0 || (_formData$workforceEm7 = formData.workforceEmployee) === null || _formData$workforceEm7 === void 0 ? void 0 : _formData$workforceEm7.nameBn,
              lastNameEn: "",
              phoneNumber: formData === null || formData === void 0 || (_formData$workforceEm8 = formData.workforceEmployee) === null || _formData$workforceEm8 === void 0 ? void 0 : _formData$workforceEm8.phoneNumber,
              email: formData === null || formData === void 0 || (_formData$workforceEm9 = formData.workforceEmployee) === null || _formData$workforceEm9 === void 0 ? void 0 : _formData$workforceEm9.email,
              gender: formData === null || formData === void 0 || (_formData$workforceEm10 = formData.workforceEmployee) === null || _formData$workforceEm10 === void 0 || (_formData$workforceEm10 = _formData$workforceEm10.gender) === null || _formData$workforceEm10 === void 0 ? void 0 : _formData$workforceEm10.name,
              birthDate: formData === null || formData === void 0 || (_formData$workforceEm11 = formData.workforceEmployee) === null || _formData$workforceEm11 === void 0 ? void 0 : _formData$workforceEm11.birthDate,
              deathDate: formData === null || formData === void 0 || (_formData$workforceEm12 = formData.workforceEmployee) === null || _formData$workforceEm12 === void 0 ? void 0 : _formData$workforceEm12.deathDate,
              lifeStatus: formData === null || formData === void 0 || (_formData$workforceEm13 = formData.workforceEmployee) === null || _formData$workforceEm13 === void 0 ? void 0 : _formData$workforceEm13.lifeStatus,
              permanentAddress: formData === null || formData === void 0 || (_formData$workforceEm14 = formData.workforceEmployee) === null || _formData$workforceEm14 === void 0 ? void 0 : _formData$workforceEm14.permanentAddress,
              presentAddress: formData === null || formData === void 0 || (_formData$workforceEm15 = formData.workforceEmployee) === null || _formData$workforceEm15 === void 0 ? void 0 : _formData$workforceEm15.presentAddress,
              position: formData === null || formData === void 0 || (_formData$workforceEm16 = formData.workforceEmployee) === null || _formData$workforceEm16 === void 0 ? void 0 : _formData$workforceEm16.position,
              monthlyEarning: formData === null || formData === void 0 || (_formData$workforceEm17 = formData.workforceEmployee) === null || _formData$workforceEm17 === void 0 ? void 0 : _formData$workforceEm17.monthlyEarning,
              insuranceNumber: " ",
              fatherNameBn: formData === null || formData === void 0 || (_formData$workforceEm18 = formData.workforceEmployee) === null || _formData$workforceEm18 === void 0 ? void 0 : _formData$workforceEm18.fatherNameBn,
              fatherNameEn: formData === null || formData === void 0 || (_formData$workforceEm19 = formData.workforceEmployee) === null || _formData$workforceEm19 === void 0 ? void 0 : _formData$workforceEm19.fatherNameEn,
              motherNameBn: formData === null || formData === void 0 || (_formData$workforceEm20 = formData.workforceEmployee) === null || _formData$workforceEm20 === void 0 ? void 0 : _formData$workforceEm20.motherNameBn,
              motherNameEn: formData === null || formData === void 0 || (_formData$workforceEm21 = formData.workforceEmployee) === null || _formData$workforceEm21 === void 0 ? void 0 : _formData$workforceEm21.motherNameEn,
              spouseNameBn: formData === null || formData === void 0 || (_formData$workforceEm22 = formData.workforceEmployee) === null || _formData$workforceEm22 === void 0 ? void 0 : _formData$workforceEm22.spouseNameBn,
              spouseNameEn: formData === null || formData === void 0 || (_formData$workforceEm23 = formData.workforceEmployee) === null || _formData$workforceEm23 === void 0 ? void 0 : _formData$workforceEm23.spouseNameEn,
              citizenship: formData === null || formData === void 0 || (_formData$workforceEm24 = formData.workforceEmployee) === null || _formData$workforceEm24 === void 0 ? void 0 : _formData$workforceEm24.citizenship,
              maritalStatus: formData === null || formData === void 0 || (_formData$workforceEm25 = formData.workforceEmployee) === null || _formData$workforceEm25 === void 0 ? void 0 : _formData$workforceEm25.maritalStatus,
              presentLocation: formData === null || formData === void 0 || (_formData$workforceEm26 = formData.workforceEmployee) === null || _formData$workforceEm26 === void 0 ? void 0 : _formData$workforceEm26.presentLocation,
              permanentLocation: formData === null || formData === void 0 || (_formData$workforceEm27 = formData.workforceEmployee) === null || _formData$workforceEm27 === void 0 ? void 0 : _formData$workforceEm27.permanentLocation,
              id: (formData === null || formData === void 0 || (_formData$workforceEm28 = formData.workforceEmployee) === null || _formData$workforceEm28 === void 0 ? void 0 : _formData$workforceEm28.id) || reduxState.core.user.id
            };
            console.log("Update Submitting formData:", formData);
            _context.next = 30;
            return dispatch(updateWorkforceEmployee(workforceEmployeeData, "Update Workforce Employee ".concat(workforceEmployeeData.nameEn)));
          case 30:
            _context.next = 67;
            break;
          case 32:
            if (!(nextStep === 4)) {
              _context.next = 39;
              break;
            }
            updateApplicationData = {
              id: safeApplicationId(applicationId, parsedApplicationData),
              workforceEmployeeId: (formData === null || formData === void 0 || (_formData$workforceEm29 = formData.workforceEmployee) === null || _formData$workforceEm29 === void 0 ? void 0 : _formData$workforceEm29.id) || (parsedApplicationData === null || parsedApplicationData === void 0 || (_parsedApplicationDat = parsedApplicationData.workforceEmployee) === null || _parsedApplicationDat === void 0 ? void 0 : _parsedApplicationDat.id),
              company: formData === null || formData === void 0 || (_formData$workforceEm30 = formData.workforceEmployee) === null || _formData$workforceEm30 === void 0 || (_formData$workforceEm30 = _formData$workforceEm30.company) === null || _formData$workforceEm30 === void 0 ? void 0 : _formData$workforceEm30.id,
              factory: formData !== null && formData !== void 0 && (_formData$workforceEm31 = formData.workforceEmployee) !== null && _formData$workforceEm31 !== void 0 && (_formData$workforceEm31 = _formData$workforceEm31.factory) !== null && _formData$workforceEm31 !== void 0 && _formData$workforceEm31.id ? decodeId(formData === null || formData === void 0 || (_formData$workforceEm32 = formData.workforceEmployee) === null || _formData$workforceEm32 === void 0 || (_formData$workforceEm32 = _formData$workforceEm32.factory) === null || _formData$workforceEm32 === void 0 ? void 0 : _formData$workforceEm32.id) : null,
              organizationType: formData.organizationType,
              applicationType: formData.applicationType,
              employeeDesignationInfo: JSON.stringify(formData.employeeDesignationInfo),
              employeeBankInfo: JSON.stringify(formData.employeeBankInfo),
              employeeDependentInfo: JSON.stringify(formData.dependent),
              employeeChildrenInfo: JSON.stringify(formData.employeeChildrenInfo),
              metadata: JSON.stringify(formData.metadata),
              status: WORKFORCE_STATUS$1.DRAFT,
              applicationFor: applicationForSelf === "yes" ? "self" : "dependent"
            };
            console.log({
              updateApplicationData: updateApplicationData
            });
            console.log("i am from first update", updateApplicationData);
            dispatch(updateApplication(updateApplicationData, "update workforce application ".concat(formData.firstNameEn)));
            _context.next = 67;
            break;
          case 39:
            if (!(nextStep === 2 && applicationForSelf === "yes" || nextStep === 3 && applicationForSelf === "no")) {
              _context.next = 65;
              break;
            }
            createApplicationData = {
              workforceEmployeeId: (formData === null || formData === void 0 || (_formData$workforceEm33 = formData.workforceEmployee) === null || _formData$workforceEm33 === void 0 ? void 0 : _formData$workforceEm33.id) || (parsedApplicationData === null || parsedApplicationData === void 0 || (_parsedApplicationDat2 = parsedApplicationData.workforceEmployee) === null || _parsedApplicationDat2 === void 0 ? void 0 : _parsedApplicationDat2.id),
              organizationType: formData.organizationType,
              applicationType: formData.applicationType,
              company: formData === null || formData === void 0 || (_formData$workforceEm34 = formData.workforceEmployee) === null || _formData$workforceEm34 === void 0 || (_formData$workforceEm34 = _formData$workforceEm34.company) === null || _formData$workforceEm34 === void 0 ? void 0 : _formData$workforceEm34.id,
              factory: formData !== null && formData !== void 0 && (_formData$factory = formData.factory) !== null && _formData$factory !== void 0 && _formData$factory.id ? safeDecodeId(formData === null || formData === void 0 || (_formData$factory2 = formData.factory) === null || _formData$factory2 === void 0 ? void 0 : _formData$factory2.id) : null,
              employeeDesignationInfo: JSON.stringify(formData.employeeDesignationInfo),
              employeeBankInfo: JSON.stringify(formData.employeeBankInfo),
              employeeDependentInfo: JSON.stringify(formData.dependent),
              employeeChildrenInfo: JSON.stringify(formData.employeeChildrenInfo),
              metadata: JSON.stringify(formData.metadata),
              status: WORKFORCE_STATUS$1.DRAFT,
              applicationFor: applicationForSelf === "yes" ? "self" : "dependent"
            };
            if (parsedApplicationData) {
              _context.next = 60;
              break;
            }
            _context.next = 44;
            return formatMutation("createWorkforceApplication", formatApplicationeGQL(createApplicationData), "Created application ".concat(formData.workforceEmployee.nameEn));
          case 44:
            applicationMutation = _context.sent;
            applicationClientMutationId = applicationMutation.clientMutationId;
            console.log("applicationClientMutationId", applicationClientMutationId);
            _context.next = 49;
            return dispatch(createApplication(applicationMutation, "Created workforce application ".concat(formData.firstNameEn)));
          case 49:
            _context.next = 51;
            return dispatch(fetchInfoIdByClientMutationId(modulesManager, "workforceApplication", applicationClientMutationId, "WORKFORCE_APPLICATION_BY_CLIENT_MUTATION_ID"));
          case 51:
            fetchRes = _context.sent;
            applicationgetId = getInfoId(fetchRes, "workforceApplication");
            console.log("hello there", applicationgetId);
            if (!applicationgetId && applicationId) {
              applicationgetId = applicationId;
            }
            createEducation = {
              applicationId: applicationgetId,
              educationLevel: formData === null || formData === void 0 || (_formData$employeeChi = formData.employeeChildrenInfo) === null || _formData$employeeChi === void 0 ? void 0 : _formData$employeeChi.scholarshipFor,
              educationBoard: formData === null || formData === void 0 || (_formData$employeeChi2 = formData.employeeChildrenInfo) === null || _formData$employeeChi2 === void 0 ? void 0 : _formData$employeeChi2.board,
              passingYear: formData === null || formData === void 0 || (_formData$employeeChi3 = formData.employeeChildrenInfo) === null || _formData$employeeChi3 === void 0 ? void 0 : _formData$employeeChi3.passingYear,
              rollNumber: formData === null || formData === void 0 || (_formData$employeeChi4 = formData.employeeChildrenInfo) === null || _formData$employeeChi4 === void 0 ? void 0 : _formData$employeeChi4.rollNo,
              admissionYear: formData === null || formData === void 0 || (_formData$employeeChi5 = formData.employeeChildrenInfo) === null || _formData$employeeChi5 === void 0 ? void 0 : _formData$employeeChi5.admissionYear,
              IdNumber: formData === null || formData === void 0 || (_formData$employeeChi6 = formData.employeeChildrenInfo) === null || _formData$employeeChi6 === void 0 ? void 0 : _formData$employeeChi6.idNo,
              registrationNumber: formData === null || formData === void 0 || (_formData$employeeChi7 = formData.employeeChildrenInfo) === null || _formData$employeeChi7 === void 0 ? void 0 : _formData$employeeChi7.regNo,
              result: formData === null || formData === void 0 || (_formData$employeeChi8 = formData.employeeChildrenInfo) === null || _formData$employeeChi8 === void 0 ? void 0 : _formData$employeeChi8.cgpa,
              institution: formData === null || formData === void 0 || (_formData$employeeChi9 = formData.employeeChildrenInfo) === null || _formData$employeeChi9 === void 0 ? void 0 : _formData$employeeChi9.university,
              childBirthDate: formData === null || formData === void 0 || (_formData$employeeChi10 = formData.employeeChildrenInfo) === null || _formData$employeeChi10 === void 0 ? void 0 : _formData$employeeChi10.birthDate,
              childNameEn: formData === null || formData === void 0 || (_formData$employeeChi11 = formData.employeeChildrenInfo) === null || _formData$employeeChi11 === void 0 ? void 0 : _formData$employeeChi11.nameEn,
              childNameBn: formData === null || formData === void 0 || (_formData$employeeChi12 = formData.employeeChildrenInfo) === null || _formData$employeeChi12 === void 0 ? void 0 : _formData$employeeChi12.nameBn,
              childNidNo: formData === null || formData === void 0 || (_formData$employeeChi13 = formData.employeeChildrenInfo) === null || _formData$employeeChi13 === void 0 ? void 0 : _formData$employeeChi13.nid,
              childBirthCertificateNo: formData === null || formData === void 0 || (_formData$employeeChi14 = formData.employeeChildrenInfo) === null || _formData$employeeChi14 === void 0 ? void 0 : _formData$employeeChi14.nid,
              studyClass: formData === null || formData === void 0 || (_formData$employeeChi15 = formData.employeeChildrenInfo) === null || _formData$employeeChi15 === void 0 ? void 0 : _formData$employeeChi15.studyingClass
            };
            _context.next = 58;
            return dispatch(createEducationInfo(createEducation, "Created workforce education Info"));
          case 58:
            _context.next = 63;
            break;
          case 60:
            _updateApplicationData = _objectSpread$Q({
              id: parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.id
            }, createApplicationData);
            console.log("i am from update", _updateApplicationData);
            dispatch(updateApplication(_updateApplicationData, "update workforce application ".concat(formData.firstNameEn)));
          case 63:
            _context.next = 67;
            break;
          case 65:
            _updateApplicationData2 = {
              id: safeApplicationId(applicationId, parsedApplicationData),
              workforceEmployeeId: (formData === null || formData === void 0 ? void 0 : formData.workforceEmployee.id) || (parsedApplicationData === null || parsedApplicationData === void 0 || (_parsedApplicationDat3 = parsedApplicationData.workforceEmployee) === null || _parsedApplicationDat3 === void 0 ? void 0 : _parsedApplicationDat3.id),
              company: formData === null || formData === void 0 || (_formData$workforceEm35 = formData.workforceEmployee) === null || _formData$workforceEm35 === void 0 || (_formData$workforceEm35 = _formData$workforceEm35.company) === null || _formData$workforceEm35 === void 0 ? void 0 : _formData$workforceEm35.id,
              factory: formData !== null && formData !== void 0 && (_formData$factory3 = formData.factory) !== null && _formData$factory3 !== void 0 && _formData$factory3.id ? safeDecodeId(formData === null || formData === void 0 || (_formData$factory4 = formData.factory) === null || _formData$factory4 === void 0 ? void 0 : _formData$factory4.id) : null,
              organizationType: organizationType || (parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.organizationType),
              applicationType: selectedApplicationType || (parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.applicationType),
              employeeBankInfo: JSON.stringify(formData.employeeBankInfo) || JSON.stringify(parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.employeeBankInfo),
              employeeDependentInfo: JSON.stringify(formData.dependent) || JSON.stringify(parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.employeeDependentInfo),
              employeeChildrenInfo: JSON.stringify(formData.employeeChildrenInfo) || JSON.stringify(parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.employeeChildrenInfo),
              metadata: JSON.stringify(formData.metadata),
              status: WORKFORCE_STATUS$1.DRAFT,
              applicationFor: applicationForSelf === "yes" ? "self" : "dependent"
            };
            dispatch(updateApplication(_updateApplicationData2, "update workforce application ".concat(formData.firstNameEn)));
          case 67:
            return _context.abrupt("return", true);
          case 68:
            return _context.abrupt("return", false);
          case 69:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function handleNext() {
      return _ref2.apply(this, arguments);
    };
  }();
  var handleBack = function handleBack() {
    return setActiveStep(function (prevStep) {
      return prevStep - 1;
    });
  };
  var handleArrayFieldChange = function handleArrayFieldChange(fieldKey, index, key, value) {
    setFormData(function (prev) {
      var items = Array.isArray(prev[fieldKey]) ? _toConsumableArray(prev[fieldKey]) : [];
      var currentItem = items[index] || {};
      var nextValue = typeof value === "function" ? value(currentItem[key]) : value;
      items[index] = _objectSpread$Q(_objectSpread$Q({}, currentItem), {}, _defineProperty({}, key, nextValue));
      return _objectSpread$Q(_objectSpread$Q({}, prev), {}, _defineProperty({}, fieldKey, items));
    });
  };
  var addArrayFieldItem = function addArrayFieldItem(fieldKey) {
    var defaultItem = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    setFormData(function (prev) {
      var items = Array.isArray(prev[fieldKey]) ? _toConsumableArray(prev[fieldKey]) : [{}];
      var updated = [].concat(_toConsumableArray(items), [defaultItem]);
      setExpanded === null || setExpanded === void 0 || setExpanded(updated.length - 1); // optional chaining
      return _objectSpread$Q(_objectSpread$Q({}, prev), {}, _defineProperty({}, fieldKey, updated));
    });
  };
  var removeArrayFieldItem = function removeArrayFieldItem(fieldKey, index) {
    setFormData(function (prev) {
      var items = Array.isArray(prev[fieldKey]) ? _toConsumableArray(prev[fieldKey]) : [];
      var updated = items.filter(function (_, i) {
        return i !== index;
      });
      return _objectSpread$Q(_objectSpread$Q({}, prev), {}, _defineProperty({}, fieldKey, updated));
    });
  };
  var handleSubmit = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var _parsedApplicationDat4, _formData$workforceEm36, _formData$factory5, _formData$factory6;
      var submittedBy, updateApplicationData;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            if (!uploadBankFile) {
              _context2.next = 3;
              break;
            }
            _context2.next = 3;
            return Promise.all(uploadBankFile.map(function (file) {
              return dispatch(createWorkforceDocument(_objectSpread$Q(_objectSpread$Q({}, file), {}, {
                workforceApplicationId: safeApplicationId(applicationId, parsedApplicationData)
              }), "Created workforce document"));
            }));
          case 3:
            _context2.next = 5;
            return Promise.all(uploadFile.map(function (file, index) {
              dispatch(createWorkforceDocument(_objectSpread$Q(_objectSpread$Q({}, file), {}, {
                workforceApplicationId: safeApplicationId(applicationId)
              }), "Created workforce document "));
            }));
          case 5:
            submittedBy = user_type === WORKFORCE_USER_TYPE.APPLICANT ? "applicant" : user_type === WORKFORCE_USER_TYPE.FACTORY_ADMIN ? "factory_admin" : "UNKNOWN";
            updateApplicationData = {
              // id: decodeId(applicationId[0]?.id) || parsedApplicationData?.id,
              id: safeApplicationId(applicationId, parsedApplicationData),
              workforceEmployeeId: (formData === null || formData === void 0 ? void 0 : formData.workforceEmployee.id) || (parsedApplicationData === null || parsedApplicationData === void 0 || (_parsedApplicationDat4 = parsedApplicationData.workforceEmployee) === null || _parsedApplicationDat4 === void 0 ? void 0 : _parsedApplicationDat4.id),
              company: formData === null || formData === void 0 || (_formData$workforceEm36 = formData.workforceEmployee) === null || _formData$workforceEm36 === void 0 || (_formData$workforceEm36 = _formData$workforceEm36.company) === null || _formData$workforceEm36 === void 0 ? void 0 : _formData$workforceEm36.id,
              factory: formData !== null && formData !== void 0 && (_formData$factory5 = formData.factory) !== null && _formData$factory5 !== void 0 && _formData$factory5.id ? safeDecodeId(formData === null || formData === void 0 || (_formData$factory6 = formData.factory) === null || _formData$factory6 === void 0 ? void 0 : _formData$factory6.id) : null,
              organizationType: organizationType || (parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.organizationType),
              applicationType: selectedApplicationType || (parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.applicationType),
              employeeBankInfo: JSON.stringify(formData.employeeBankInfo) || JSON.stringify(parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.employeeBankInfo),
              employeeDependentInfo: JSON.stringify(formData.dependent) || JSON.stringify(parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.employeeDependentInfo),
              employeeAccidentInfo: JSON.stringify(formData === null || formData === void 0 ? void 0 : formData.employeeAccidentInfo) || JSON.stringify(parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.employeeAccidentInfo),
              employeeChildrenInfo: JSON.stringify(formData.employeeChildrenInfo) || JSON.stringify(parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.employeeChildrenInfo),
              metadata: JSON.stringify(formData.metadata),
              status: WORKFORCE_STATUS$1.NEW,
              applicationFor: applicationForSelf === "yes" ? "self" : "dependent",
              submittedBy: submittedBy
            }; // const createApplicationMovementData = {
            //   applicationId: safeApplicationId(applicationId, parsedApplicationData),
            //   status: WORKFORCE_STATUS.NEW,
            //   note: "একটি নতুন আবেদন করা হয়েছে",
            //   applicationFromId: reduxState.core?.user?.i_user?.id,
            //   applicationToId: 165,
            //   toRoleId: 25,
            // };
            console.log("hello i am from submit", updateApplicationData);
            dispatch(updateApplication(updateApplicationData, "update workforce application "));
            // dispatch(createApplicationMovement(createApplicationMovementData, `create workforce movement`));
            // setShowPreview(true);
            // setIsSubmitted(true);
          case 9:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function handleSubmit() {
      return _ref3.apply(this, arguments);
    };
  }();
  console.log({
    formData: formData
  });
  var steps = [{
    label: "workforce.application.steps.employeeDetails",
    content: /*#__PURE__*/React.createElement(EmployeeDetailsForm, {
      handleChange: function handleChange(key, value) {
        return _handleChange(key, value, "workforceEmployee");
      },
      formData: formData,
      setNidOrBcn: setNidOrBcn,
      nidOrBcn: nidOrBcn,
      errors: errors
    })
  }].concat(_toConsumableArray(applicationForSelf === "yes" ? [{
    label: "workforce.application.steps.education.details",
    content: /*#__PURE__*/React.createElement(ScholarshipApplicationCheckbox, {
      handleChange: function handleChange(key, value) {
        return _handleChange(key, value, "employeeChildrenInfo");
      },
      setSelectedScholarshipOption: setSelectedScholarshipOption,
      selectedScholarshipOption: selectedScholarshipOption,
      formData: formData,
      applicationForSelf: applicationForSelf,
      errors: errors
    })
  }] : []), [{
    label: "workforce.application.steps.location",
    content: /*#__PURE__*/React.createElement(EmployeeLocationForm, {
      handleChange: function handleChange(key, value) {
        return _handleChange(key, value, "workforceEmployee");
      },
      formData: formData
    })
  }], _toConsumableArray(applicationForSelf === "no" ? [{
    label: "workforce.application.steps.childInfo",
    content: /*#__PURE__*/React.createElement(ScholarshipApplicationCheckbox, {
      handleChange: function handleChange(key, value) {
        return _handleChange(key, value, "employeeChildrenInfo");
      },
      setSelectedScholarshipOption: setSelectedScholarshipOption,
      selectedScholarshipOption: selectedScholarshipOption,
      formData: formData,
      applicationForSelf: applicationForSelf,
      errors: errors
    })
  }] : []), [{
    label: "workforce.application.steps.account.info",
    content: /*#__PURE__*/React.createElement(EmployeeAccountInfoForm, {
      accounts: formData.employeeBankInfo,
      formdata: formData,
      handleChange: function handleChange(index, key, value) {
        return handleArrayFieldChange("employeeBankInfo", index, key, value);
      },
      addItem: function addItem() {
        return addArrayFieldItem("employeeBankInfo", {
          accountHolderName: "",
          bankName: "",
          accountNumber: "",
          branchName: ""
        });
      },
      removeItem: function removeItem(index) {
        return removeArrayFieldItem("employeeBankInfo", index);
      },
      expanded: expanded,
      setExpanded: setExpanded,
      errors: errors
    })
  }
  // {
  //   label: "workforce.application.steps.upload.documents",
  //   content: (

  //       <EmployeeDetailsForm2
  //         handleChange={handleChange}
  //         formData={formData}
  //         selectedApplicationType={selectedApplicationType}

  //         formStepNo={"workforceDocument"}
  //       />
  //   ),
  // },
  ]);
  if (showPreview) {
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ApplicationViewPage, {
      application: formData,
      language: "fr"
    }), /*#__PURE__*/React.createElement("div", {
      className: classes.buttonContainer
    }, /*#__PURE__*/React.createElement(Button, {
      variant: "outlined",
      color: "error",
      onClick: function onClick() {
        setShowPreview(false);
      }
    }, /*#__PURE__*/React.createElement(FormattedMessage, {
      module: "workforce",
      id: "workforce.back"
    })), /*#__PURE__*/React.createElement(Button, {
      variant: "contained",
      color: "primary",
      onClick: function onClick() {
        setShowPreview(false);
        setShowVerifyNid(true);
      }
    }, /*#__PURE__*/React.createElement(FormattedMessage, {
      module: "workforce",
      id: "workforce.submit"
    }))));
  }
  if (showVerifyNid) {
    return /*#__PURE__*/React.createElement("div", {
      className: classes.container
    }, /*#__PURE__*/React.createElement(Paper, {
      className: classes.paper,
      elevation: 0
    }, /*#__PURE__*/React.createElement(NidVerification, {
      formData: formData,
      nidOrBcn: nidOrBcn,
      setDisableConfirmSubmit: setDisableConfirmSubmit
    }), /*#__PURE__*/React.createElement("div", {
      className: classes.buttonContainer
    }, /*#__PURE__*/React.createElement(Button, {
      variant: "contained",
      color: "primary"
      // disabled={disableConfirmSubmit}
      ,
      onClick: /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return handleSubmit();
            case 2:
              setShowVerifyNid(false);
              setIsSubmitted(true);
            case 4:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))
    }, /*#__PURE__*/React.createElement(FormattedMessage, {
      module: "workforce",
      id: "workforce.confirm.submit"
    })))));
  }
  if (isSubmitted) {
    return /*#__PURE__*/React.createElement(ApplicationFormSubmitted, null);
  }
  return /*#__PURE__*/React.createElement("div", {
    className: classes.container
  }, /*#__PURE__*/React.createElement(Paper, {
    className: classes.paper,
    elevation: 0
  }, /*#__PURE__*/React.createElement(Stepper, {
    activeStep: activeStep,
    alternativeLabel: true,
    style: {
      padding: "0px"
    }
  }, steps.map(function (step, index) {
    return /*#__PURE__*/React.createElement(Step, {
      key: index
    }, /*#__PURE__*/React.createElement(StepLabel, null, /*#__PURE__*/React.createElement(FormattedMessage, {
      module: "workforce",
      id: step.label
    })));
  })), /*#__PURE__*/React.createElement(Box$1, {
    mt: 0,
    ref: stepRef
  }, steps[activeStep].content), activeStep === steps.length - 1 && /*#__PURE__*/React.createElement(Box$1, null, /*#__PURE__*/React.createElement(FormControlLabel, {
    control: /*#__PURE__*/React.createElement(Checkbox, {
      checked: acknowledged,
      onChange: function onChange(e) {
        return setAcknowledged(e.target.checked);
      },
      style: {
        color: "blue"
      }
    }),
    label: /*#__PURE__*/React.createElement(Typography, {
      variant: "body2"
    }, /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.application.acknowledgement.text",
      module: "workforce"
    }))
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.buttonContainer
  }, activeStep > 0 && /*#__PURE__*/React.createElement(Button, {
    onClick: handleBack,
    variant: "outlined"
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.back"
  }), " "), activeStep < steps.length - 1 ? /*#__PURE__*/React.createElement(Button, {
    variant: "contained",
    color: "primary",
    onClick: handleNext
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.save.next"
  })) : /*#__PURE__*/React.createElement(Button, {
    variant: "contained",
    color: "primary",
    disabled: !acknowledged,
    onClick: /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
      var isSuccess;
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return handleNext();
          case 2:
            isSuccess = _context4.sent;
            if (isSuccess) setShowPreview(true);
          case 4:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }))
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.submit"
  })))), /*#__PURE__*/React.createElement(CustomSnackbar, {
    open: showErrorSnackbar // Use the new state
    ,
    onClose: function onClose() {
      return setShowErrorSnackbar(false);
    } // Allow it to close
    ,
    type: "error",
    message: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "core.error.generel",
      module: "workforce"
    }),
    duration: 4000
  }));
};

function ownKeys$P(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$P(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$P(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$P(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var useStyles$10 = makeStyles(function (theme) {
  return {
    container: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center"
    },
    paper: {
      padding: theme.spacing(2),
      width: 700
    },
    buttonContainer: {
      marginTop: theme.spacing(2),
      display: "flex",
      justifyContent: "flex-end",
      gap: theme.spacing(1)
    }
  };
});
var steps = ["workforce.application.steps.aidReason", "workforce.application.steps.deademployee.applicant.Details", "workforce.application.steps.deathLabourDetails", "workforce.application.steps.location", "workforce.application.steps.dead.worker.extraInfo", "workforce.application.steps.prosurders", "workforce.application.steps.account.info"
// "workforce.application.steps.upload.documents",
];
var DeadlyGrantForm = function DeadlyGrantForm(_ref) {
  var _formData$workforceEm, _formData$workforceEm2;
  var workforceFactoryId = _ref.workforceFactoryId,
    organizationType = _ref.organizationType,
    selectedApplicationType = _ref.selectedApplicationType,
    parsedApplicationData = _ref.parsedApplicationData,
    applicationForSelf = _ref.applicationForSelf,
    selectedFactory = _ref.selectedFactory;
  var employeeData = useSelector(function (state) {
    var _state$workforce$work;
    return (_state$workforce$work = state.workforce["workforceEmployee"]) !== null && _state$workforce$work !== void 0 ? _state$workforce$work : [];
  });
  useSelector(function (state) {
    var _state$workforce$work2;
    return (_state$workforce$work2 = state.workforce["workforceApplicant"]) !== null && _state$workforce$work2 !== void 0 ? _state$workforce$work2 : [];
  });
  var documentType = useSelector(function (state) {
    return state.workforce.documentType;
  });
  var modulesManager = useModulesManager();
  var _useTranslations = useTranslations("workforce"),
    formatMessage = _useTranslations.formatMessage;
  var stepRef = useRef(null);
  var _useState = useState({}),
    _useState2 = _slicedToArray(_useState, 2),
    errors = _useState2[0],
    setErrors = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    acknowledged = _useState4[0],
    setAcknowledged = _useState4[1];
  var applicationId = useSelector(function (state) {
    var _state$workforce$fetc;
    return (_state$workforce$fetc = state.workforce["fetchedApplicationIdByClientMutationId"]) !== null && _state$workforce$fetc !== void 0 ? _state$workforce$fetc : [];
  });
  var uploadFile = useSelector(function (state) {
    return state.workforce.uploadFile;
  });
  var uploadDependentFile = useSelector(function (state) {
    return state.workforce.uploadDependentFile;
  });
  var uploadBankFile = useSelector(function (state) {
    return state.workforce.uploadBankFile;
  });
  var classes = useStyles$10();
  var dispatch = useDispatch();
  var _useState5 = useState(0),
    _useState6 = _slicedToArray(_useState5, 2),
    expanded = _useState6[0],
    setExpanded = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    isDependentSaved = _useState8[0],
    setIsDependentSaved = _useState8[1];
  var _useState9 = useState(0),
    _useState10 = _slicedToArray(_useState9, 2),
    activeStep = _useState10[0],
    setActiveStep = _useState10[1];
  var _useState11 = useState(false),
    _useState12 = _slicedToArray(_useState11, 2),
    isSubmitted = _useState12[0],
    setIsSubmitted = _useState12[1];
  var _useState13 = useState(false),
    _useState14 = _slicedToArray(_useState13, 2),
    showVerifyNid = _useState14[0],
    setShowVerifyNid = _useState14[1];
  var _useState15 = useState(false),
    _useState16 = _slicedToArray(_useState15, 2),
    showErrorSnackbar = _useState16[0],
    setShowErrorSnackbar = _useState16[1];
  var _useState17 = useState(false),
    _useState18 = _slicedToArray(_useState17, 2),
    showPreview = _useState18[0],
    setShowPreview = _useState18[1];
  var _useState19 = useState(""),
    _useState20 = _slicedToArray(_useState19, 2),
    deathType = _useState20[0],
    setDeathType = _useState20[1];
  var _useState21 = useState(false),
    _useState22 = _slicedToArray(_useState21, 2);
    _useState22[0];
    var setDisableConfirmSubmit = _useState22[1];
  var _useState23 = useState(false),
    _useState24 = _slicedToArray(_useState23, 2),
    isNavigationBlocked = _useState24[0],
    setIsNavigationBlocked = _useState24[1];
  var _useState25 = useState(false),
    _useState26 = _slicedToArray(_useState25, 2),
    showDuplicateError = _useState26[0],
    setShowDuplicateError = _useState26[1];
  var history = useHistory();
  var _useState27 = useState({
      nid: (formData === null || formData === void 0 || (_formData$workforceEm = formData.workforceEmployee) === null || _formData$workforceEm === void 0 ? void 0 : _formData$workforceEm.nid) || "",
      birthCertificateNo: formData === null || formData === void 0 || (_formData$workforceEm2 = formData.workforceEmployee) === null || _formData$workforceEm2 === void 0 ? void 0 : _formData$workforceEm2.birthCertificateNo
    }),
    _useState28 = _slicedToArray(_useState27, 2),
    nidOrBcn = _useState28[0],
    setNidOrBcn = _useState28[1];
  var reduxState = useSelector(function (state) {
    return state;
  });
  var user_type = getUserType();
  var _useState29 = useState({
      workforceEmployee: {
        nameEn: "",
        nameBn: "",
        lastNameEn: "",
        position: "",
        fatherNameEn: "",
        fatherNameBn: "",
        motherNameEn: "",
        motherNameBn: "",
        spouseNameEn: "",
        spouseNameBn: "",
        phoneNumber: "",
        email: "",
        birthDate: "",
        deathDate: "",
        joinDate: "",
        nid: "",
        birthCertificateNo: "",
        insuranceNumber: "",
        lifeStatus: "",
        gender: "",
        maritalStatus: "",
        monthlyEarning: "",
        uploadedNidFile: [],
        citizenship: "",
        uploadedBirthCertificateFile: [],
        permanentAddress: "",
        permanentLocation: "",
        presentLocation: "",
        presentAddress: "",
        organizationId: ""
      },
      workforceApplicant: {
        nameEn: "",
        nameBn: "",
        fatherNameEn: "",
        fatherNameBn: "",
        motherNameEn: "",
        motherNameBn: "",
        spouseNameEn: "",
        spouseNameBn: "",
        phoneNumber: "",
        birthDate: "",
        nid: "",
        birthCertificateNo: "",
        gender: "",
        permanentAddress: "",
        permanentLocation: "",
        presentLocation: "",
        presentAddress: "",
        organizationId: ""
      },
      deathType: deathType,
      company: null,
      factory: selectedFactory || null,
      workforceFactoryId: workforceFactoryId || "",
      isSubmitted: "no",
      organizationType: "",
      applicationType: "",
      dependents: [{}],
      employeeBankInfo: [{}],
      employeeAccidentInfo: {},
      institutionInfo: {},
      deceasedWorkerInfo: {},
      metadata: {},
      id: ""
    }),
    _useState30 = _slicedToArray(_useState29, 2),
    formData = _useState30[0],
    setFormData = _useState30[1];

  // Fetch employee data based on username
  var fetchEmployeeWithUser = function fetchEmployeeWithUser() {
    if (reduxState.workforce.selectedEmployee) {
      dispatch(fetchWorkforceEmployee(modulesManager, ["id: \"".concat(decodeId(reduxState.workforce.selectedEmployee.id), "\"")]));
    } else {
      dispatch(fetchWorkforceEmployee(modulesManager, ["relatedUser_LoginName_Iexact: \"".concat(reduxState.core.user.username, "\"")]));
    }
  };
  useEffect(function () {
    var _applicationId$;
    if (applicationId && applicationId.length > 0 && (_applicationId$ = applicationId[0]) !== null && _applicationId$ !== void 0 && _applicationId$.id) {
      setFormData(function (prev) {
        return _objectSpread$P(_objectSpread$P({}, prev), {}, {
          applicationId: applicationId[0].id
        });
      });
    }
  }, [applicationId]);
  useEffect(function () {
    if (reduxState.core.user.username) {
      fetchEmployeeWithUser();
    }
  }, [reduxState.core.user.username]);
  useEffect(function () {
    if (employeeData) {
      var _parsedApplicationDat, _parsedApplicationDat2, _parsedApplicationDat3, _parsedApplicationDat4, _parsedApplicationDat5, _parsedApplicationDat6, _parsedApplicationDat7, _parsedApplicationDat8, _parsedApplicationDat9, _parsedApplicationDat10, _parsedApplicationDat11, _parsedApplicationDat12, _parsedApplicationDat13, _parsedApplicationDat14, _parsedApplicationDat15, _parsedApplicationDat16, _parsedApplicationDat17, _parsedApplicationDat18, _parsedApplicationDat19, _parsedApplicationDat20, _parsedApplicationDat21, _parsedApplicationDat22, _parsedApplicationDat23, _parsedApplicationDat24, _parsedApplicationDat25, _parsedApplicationDat26, _parsedApplicationDat27, _parsedApplicationDat28, _parsedApplicationDat29, _parsedApplicationDat30, _parsedApplicationDat31, _parsedApplicationDat32, _parsedApplicationDat33, _parsedApplicationDat34, _parsedApplicationDat35, _parsedApplicationDat36, _parsedApplicationDat37, _parsedApplicationDat38, _parsedApplicationDat39, _parsedApplicationDat40, _formData$workforceEm3, _formData$employeeFac, _formData$workforceEm4;
      // When employeeData is fetched, set it into the form state
      setFormData({
        id: (parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.id) || "",
        workforceApplicant: {
          nameEn: parsedApplicationData !== null && parsedApplicationData !== void 0 && parsedApplicationData.id ? parsedApplicationData === null || parsedApplicationData === void 0 || (_parsedApplicationDat = parsedApplicationData.applicantInfo) === null || _parsedApplicationDat === void 0 ? void 0 : _parsedApplicationDat.nameEn : (employeeData === null || employeeData === void 0 ? void 0 : employeeData.firstNameEn) || "",
          nameBn: parsedApplicationData !== null && parsedApplicationData !== void 0 && parsedApplicationData.id ? parsedApplicationData === null || parsedApplicationData === void 0 || (_parsedApplicationDat2 = parsedApplicationData.applicantInfo) === null || _parsedApplicationDat2 === void 0 ? void 0 : _parsedApplicationDat2.nameBn : (employeeData === null || employeeData === void 0 ? void 0 : employeeData.firstNameBn) || "",
          fatherNameEn: parsedApplicationData !== null && parsedApplicationData !== void 0 && parsedApplicationData.id ? parsedApplicationData === null || parsedApplicationData === void 0 || (_parsedApplicationDat3 = parsedApplicationData.applicantInfo) === null || _parsedApplicationDat3 === void 0 ? void 0 : _parsedApplicationDat3.fatherNameEn : (employeeData === null || employeeData === void 0 ? void 0 : employeeData.fatherNameEn) || "",
          fatherNameBn: parsedApplicationData !== null && parsedApplicationData !== void 0 && parsedApplicationData.id ? parsedApplicationData === null || parsedApplicationData === void 0 || (_parsedApplicationDat4 = parsedApplicationData.applicantInfo) === null || _parsedApplicationDat4 === void 0 ? void 0 : _parsedApplicationDat4.fatherNameBn : (employeeData === null || employeeData === void 0 ? void 0 : employeeData.fatherNameBn) || "",
          motherNameEn: parsedApplicationData !== null && parsedApplicationData !== void 0 && parsedApplicationData.id ? parsedApplicationData === null || parsedApplicationData === void 0 || (_parsedApplicationDat5 = parsedApplicationData.applicantInfo) === null || _parsedApplicationDat5 === void 0 ? void 0 : _parsedApplicationDat5.motherNameEn : (employeeData === null || employeeData === void 0 ? void 0 : employeeData.motherNameEn) || "",
          motherNameBn: parsedApplicationData !== null && parsedApplicationData !== void 0 && parsedApplicationData.id ? parsedApplicationData === null || parsedApplicationData === void 0 || (_parsedApplicationDat6 = parsedApplicationData.applicantInfo) === null || _parsedApplicationDat6 === void 0 ? void 0 : _parsedApplicationDat6.motherNameBn : (employeeData === null || employeeData === void 0 ? void 0 : employeeData.motherNameBn) || "",
          spouseNameEn: parsedApplicationData !== null && parsedApplicationData !== void 0 && parsedApplicationData.id ? parsedApplicationData === null || parsedApplicationData === void 0 || (_parsedApplicationDat7 = parsedApplicationData.applicantInfo) === null || _parsedApplicationDat7 === void 0 ? void 0 : _parsedApplicationDat7.spouseNameEn : (employeeData === null || employeeData === void 0 ? void 0 : employeeData.spouseNameEn) || "",
          spouseNameBn: parsedApplicationData !== null && parsedApplicationData !== void 0 && parsedApplicationData.id ? parsedApplicationData === null || parsedApplicationData === void 0 || (_parsedApplicationDat8 = parsedApplicationData.applicantInfo) === null || _parsedApplicationDat8 === void 0 ? void 0 : _parsedApplicationDat8.spouseNameBn : (employeeData === null || employeeData === void 0 ? void 0 : employeeData.spouseNameBn) || "",
          phoneNumber: parsedApplicationData !== null && parsedApplicationData !== void 0 && parsedApplicationData.id ? parsedApplicationData === null || parsedApplicationData === void 0 || (_parsedApplicationDat9 = parsedApplicationData.applicantInfo) === null || _parsedApplicationDat9 === void 0 ? void 0 : _parsedApplicationDat9.phoneNumber : (employeeData === null || employeeData === void 0 ? void 0 : employeeData.phoneNumber) || "",
          relationWithApplicant: parsedApplicationData === null || parsedApplicationData === void 0 || (_parsedApplicationDat10 = parsedApplicationData.applicantInfo) === null || _parsedApplicationDat10 === void 0 ? void 0 : _parsedApplicationDat10.relationWithApplicant,
          birthDate: parsedApplicationData === null || parsedApplicationData === void 0 || (_parsedApplicationDat11 = parsedApplicationData.applicantInfo) === null || _parsedApplicationDat11 === void 0 ? void 0 : _parsedApplicationDat11.birthDate,
          gender: parsedApplicationData === null || parsedApplicationData === void 0 || (_parsedApplicationDat12 = parsedApplicationData.applicantInfo) === null || _parsedApplicationDat12 === void 0 ? void 0 : _parsedApplicationDat12.gender,
          citizenship: parsedApplicationData === null || parsedApplicationData === void 0 || (_parsedApplicationDat13 = parsedApplicationData.applicantInfo) === null || _parsedApplicationDat13 === void 0 ? void 0 : _parsedApplicationDat13.citizenship,
          nid: parsedApplicationData !== null && parsedApplicationData !== void 0 && parsedApplicationData.id ? parsedApplicationData === null || parsedApplicationData === void 0 || (_parsedApplicationDat14 = parsedApplicationData.applicantInfo) === null || _parsedApplicationDat14 === void 0 ? void 0 : _parsedApplicationDat14.nid : (employeeData === null || employeeData === void 0 ? void 0 : employeeData.nid) || "",
          birthCertificateNo: parsedApplicationData !== null && parsedApplicationData !== void 0 && parsedApplicationData.id ? parsedApplicationData === null || parsedApplicationData === void 0 || (_parsedApplicationDat15 = parsedApplicationData.applicantInfo) === null || _parsedApplicationDat15 === void 0 ? void 0 : _parsedApplicationDat15.birthCertificateNo : (employeeData === null || employeeData === void 0 ? void 0 : employeeData.birthCertificateNo) || "",
          permanentAddress: parsedApplicationData !== null && parsedApplicationData !== void 0 && parsedApplicationData.id ? parsedApplicationData === null || parsedApplicationData === void 0 || (_parsedApplicationDat16 = parsedApplicationData.applicantInfo) === null || _parsedApplicationDat16 === void 0 ? void 0 : _parsedApplicationDat16.permanentAddress : (employeeData === null || employeeData === void 0 ? void 0 : employeeData.permanentAddress) || "",
          permanentLocation: parsedApplicationData !== null && parsedApplicationData !== void 0 && parsedApplicationData.id ? parsedApplicationData === null || parsedApplicationData === void 0 || (_parsedApplicationDat17 = parsedApplicationData.applicantInfo) === null || _parsedApplicationDat17 === void 0 ? void 0 : _parsedApplicationDat17.permanentLocation : (employeeData === null || employeeData === void 0 ? void 0 : employeeData.permanentLocation) || "",
          presentLocation: parsedApplicationData !== null && parsedApplicationData !== void 0 && parsedApplicationData.id ? parsedApplicationData === null || parsedApplicationData === void 0 || (_parsedApplicationDat18 = parsedApplicationData.applicantInfo) === null || _parsedApplicationDat18 === void 0 ? void 0 : _parsedApplicationDat18.presentLocation : (employeeData === null || employeeData === void 0 ? void 0 : employeeData.presentLocation) || "",
          presentAddress: parsedApplicationData !== null && parsedApplicationData !== void 0 && parsedApplicationData.id ? parsedApplicationData === null || parsedApplicationData === void 0 || (_parsedApplicationDat19 = parsedApplicationData.applicantInfo) === null || _parsedApplicationDat19 === void 0 ? void 0 : _parsedApplicationDat19.presentAddress : (employeeData === null || employeeData === void 0 ? void 0 : employeeData.presentAddress) || ""
        },
        workforceEmployee: _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({
          nameEn: (parsedApplicationData === null || parsedApplicationData === void 0 || (_parsedApplicationDat20 = parsedApplicationData.deceasedWorkerInfo) === null || _parsedApplicationDat20 === void 0 ? void 0 : _parsedApplicationDat20.nameEn) || "",
          nameBn: (parsedApplicationData === null || parsedApplicationData === void 0 || (_parsedApplicationDat21 = parsedApplicationData.deceasedWorkerInfo) === null || _parsedApplicationDat21 === void 0 ? void 0 : _parsedApplicationDat21.nameBn) || "",
          fatherNameEn: (parsedApplicationData === null || parsedApplicationData === void 0 || (_parsedApplicationDat22 = parsedApplicationData.deceasedWorkerInfo) === null || _parsedApplicationDat22 === void 0 ? void 0 : _parsedApplicationDat22.fatherNameEn) || "",
          fatherNameBn: (parsedApplicationData === null || parsedApplicationData === void 0 || (_parsedApplicationDat23 = parsedApplicationData.deceasedWorkerInfo) === null || _parsedApplicationDat23 === void 0 ? void 0 : _parsedApplicationDat23.fatherNameBn) || "",
          motherNameEn: (parsedApplicationData === null || parsedApplicationData === void 0 || (_parsedApplicationDat24 = parsedApplicationData.deceasedWorkerInfo) === null || _parsedApplicationDat24 === void 0 ? void 0 : _parsedApplicationDat24.motherNameEn) || "",
          motherNameBn: (parsedApplicationData === null || parsedApplicationData === void 0 || (_parsedApplicationDat25 = parsedApplicationData.deceasedWorkerInfo) === null || _parsedApplicationDat25 === void 0 ? void 0 : _parsedApplicationDat25.motherNameBn) || "",
          spouseNameEn: (parsedApplicationData === null || parsedApplicationData === void 0 || (_parsedApplicationDat26 = parsedApplicationData.deceasedWorkerInfo) === null || _parsedApplicationDat26 === void 0 ? void 0 : _parsedApplicationDat26.spouseNameEn) || "",
          spouseNameBn: (parsedApplicationData === null || parsedApplicationData === void 0 || (_parsedApplicationDat27 = parsedApplicationData.deceasedWorkerInfo) === null || _parsedApplicationDat27 === void 0 ? void 0 : _parsedApplicationDat27.spouseNameBn) || "",
          phoneNumber: (parsedApplicationData === null || parsedApplicationData === void 0 || (_parsedApplicationDat28 = parsedApplicationData.deceasedWorkerInfo) === null || _parsedApplicationDat28 === void 0 ? void 0 : _parsedApplicationDat28.phoneNumber) || "",
          birthDate: parsedApplicationData === null || parsedApplicationData === void 0 || (_parsedApplicationDat29 = parsedApplicationData.deceasedWorkerInfo) === null || _parsedApplicationDat29 === void 0 ? void 0 : _parsedApplicationDat29.birthDate,
          gender: parsedApplicationData === null || parsedApplicationData === void 0 || (_parsedApplicationDat30 = parsedApplicationData.deceasedWorkerInfo) === null || _parsedApplicationDat30 === void 0 ? void 0 : _parsedApplicationDat30.gender,
          citizenship: parsedApplicationData === null || parsedApplicationData === void 0 || (_parsedApplicationDat31 = parsedApplicationData.deceasedWorkerInfo) === null || _parsedApplicationDat31 === void 0 ? void 0 : _parsedApplicationDat31.citizenship
        }, "citizenship", parsedApplicationData === null || parsedApplicationData === void 0 || (_parsedApplicationDat32 = parsedApplicationData.deceasedWorkerInfo) === null || _parsedApplicationDat32 === void 0 ? void 0 : _parsedApplicationDat32.citizenship), "maritalStatus", parsedApplicationData === null || parsedApplicationData === void 0 || (_parsedApplicationDat33 = parsedApplicationData.deceasedWorkerInfo) === null || _parsedApplicationDat33 === void 0 ? void 0 : _parsedApplicationDat33.maritalStatus), "nid", parsedApplicationData === null || parsedApplicationData === void 0 || (_parsedApplicationDat34 = parsedApplicationData.deceasedWorkerInfo) === null || _parsedApplicationDat34 === void 0 ? void 0 : _parsedApplicationDat34.nid), "nid", (parsedApplicationData === null || parsedApplicationData === void 0 || (_parsedApplicationDat35 = parsedApplicationData.deceasedWorkerInfo) === null || _parsedApplicationDat35 === void 0 ? void 0 : _parsedApplicationDat35.nid) || ""), "birthCertificateNo", (parsedApplicationData === null || parsedApplicationData === void 0 || (_parsedApplicationDat36 = parsedApplicationData.deceasedWorkerInfo) === null || _parsedApplicationDat36 === void 0 ? void 0 : _parsedApplicationDat36.birthCertificateNo) || ""), "permanentAddress", (parsedApplicationData === null || parsedApplicationData === void 0 || (_parsedApplicationDat37 = parsedApplicationData.deceasedWorkerInfo) === null || _parsedApplicationDat37 === void 0 ? void 0 : _parsedApplicationDat37.permanentAddress) || ""), "permanentLocation", (parsedApplicationData === null || parsedApplicationData === void 0 || (_parsedApplicationDat38 = parsedApplicationData.deceasedWorkerInfo) === null || _parsedApplicationDat38 === void 0 ? void 0 : _parsedApplicationDat38.permanentLocation) || ""), "presentLocation", (parsedApplicationData === null || parsedApplicationData === void 0 || (_parsedApplicationDat39 = parsedApplicationData.deceasedWorkerInfo) === null || _parsedApplicationDat39 === void 0 ? void 0 : _parsedApplicationDat39.presentLocation) || ""), "presentAddress", (parsedApplicationData === null || parsedApplicationData === void 0 || (_parsedApplicationDat40 = parsedApplicationData.deceasedWorkerInfo) === null || _parsedApplicationDat40 === void 0 ? void 0 : _parsedApplicationDat40.presentAddress) || ""), "factory", formData === null || formData === void 0 ? void 0 : formData.factory),
        company: (employeeData === null || employeeData === void 0 ? void 0 : employeeData.company) || (formData === null || formData === void 0 || (_formData$workforceEm3 = formData.workforceEmployee) === null || _formData$workforceEm3 === void 0 || (_formData$workforceEm3 = _formData$workforceEm3.company) === null || _formData$workforceEm3 === void 0 ? void 0 : _formData$workforceEm3.id) || null,
        factory: (formData === null || formData === void 0 ? void 0 : formData.factory) || (formData === null || formData === void 0 || (_formData$employeeFac = formData.employeeFactory) === null || _formData$employeeFac === void 0 ? void 0 : _formData$employeeFac.id) || employeeData.factory || (formData === null || formData === void 0 || (_formData$workforceEm4 = formData.workforceEmployee) === null || _formData$workforceEm4 === void 0 || (_formData$workforceEm4 = _formData$workforceEm4.factory) === null || _formData$workforceEm4 === void 0 ? void 0 : _formData$workforceEm4.id) || (parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.employeeFactory) || workforceFactoryId || selectedFactory || null,
        applicationForSelf: applicationForSelf,
        workforceFactoryId: workforceFactoryId || "",
        organizationType: (parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.organizationType) || organizationType,
        applicationType: (parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.applicationType) || selectedApplicationType,
        grantAmount: (parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.grantAmount) || (parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.employeeAccidentInfo.grantAmount),
        dependents: (parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.employeeDependentInfo) || [{}],
        employeeBankInfo: (parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.employeeBankInfo) || (employeeData === null || employeeData === void 0 ? void 0 : employeeData.employeeBankInfo) || [{}],
        employeeAccidentInfo: (parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.employeeAccidentInfo) || (employeeData === null || employeeData === void 0 ? void 0 : employeeData.employeeAccidentInfo) || {},
        metadata: (parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.metadata) || (employeeData === null || employeeData === void 0 ? void 0 : employeeData.metadata) || {},
        applicantInfo: (parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.applicantInfo) || (employeeData === null || employeeData === void 0 ? void 0 : employeeData.metadata) || {},
        deceasedWorkerInfo: (parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.deceasedWorkerInfo) || {}
      });
    }
    // if (parsedApplicationData?.id) {
    //   applicationId=parsedApplicationData?.id
    // }
  }, [employeeData === null || employeeData === void 0 ? void 0 : employeeData.id, parsedApplicationData]);

  // Handle form input changes
  var _handleChange = function handleChange(key, value) {
    var parent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    setFormData(function (prev) {
      if (parent) {
        return _objectSpread$P(_objectSpread$P({}, prev), {}, _defineProperty({}, parent, _objectSpread$P(_objectSpread$P({}, prev[parent]), {}, _defineProperty({}, key, value))));
      }
      return _objectSpread$P(_objectSpread$P({}, prev), {}, _defineProperty({}, key, value));
    });
  };
  var handleNext = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var newErrors, isApplicantStep, isEmployeeStep, isDependentStep, isBankStep, shouldValidateDocuments, documentValidation, BANK_DOC, bankDocsConfig, generalDocsConfig, _formData$workforceEm5, _formData$workforceEm6, _formData$metadata, nextStep, _formData$workforceEm7, _formData$metadata2, fakeErrors, _formData$deceasedWor, _formData$workforceEm8, _duplicacyResponse$pa, _formData$workforceEm9, _formData$workforceEm10, _formData$workforceEm11, _formData$workforceEm12, _formData$workforceEm13, _formData$workforceEm14, _formData$workforceEm15, _formData$workforceEm16, _formData$workforceEm17, _formData$workforceEm18, _formData$workforceEm19, _formData$workforceEm20, _formData$workforceEm21, _formData$workforceEm22, _formData$workforceEm23, _formData$workforceEm24, _formData$workforceEm25, _formData$workforceEm26, _formData$workforceEm27, _formData$workforceEm28, _formData$workforceEm29, _formData$workforceEm30, _formData$workforceEm31, _formData$workforceEm32, _formData$workforceEm33, _formData$deceasedWor2, _formData$workforceEm34, _formData$deceasedWor3, duplicacyFilters, duplicacyResponse, duplicacyData, updateApplicationData, _formData$workforceEm35, _formData$workforceEm36, _formData$deceasedWor4, _formData$workforceEm37, _formData$deceasedWor5, _formData$factory, createApplicationData, applicationMutation, applicationClientMutationId, fetchRes, applicationgetId, _updateApplicationData, _formData$workforceEm38, _formData$workforceEm39, _formData$deceasedWor6, _formData$workforceEm40, _formData$deceasedWor7, _formData$factory2, _updateApplicationData2, _formData$workforceEm41, _formData$workforceEm42, _formData$deceasedWor8, _formData$workforceEm43, _formData$deceasedWor9, _formData$factory3, _updateApplicationData3;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            console.log({
              formData: formData
            });
            newErrors = validateRequiredFields(stepRef, formatMessage, formData);
            isApplicantStep = activeStep === 1;
            isEmployeeStep = activeStep === 2;
            isDependentStep = activeStep === 5;
            isBankStep = activeStep === 6;
            shouldValidateDocuments = isApplicantStep || isEmployeeStep || isDependentStep || isBankStep;
            documentValidation = {
              isValid: true,
              errors: null
            };
            if (!shouldValidateDocuments) {
              newErrors === null || newErrors === void 0 || delete newErrors.documents;
            } else {
              BANK_DOC = "applicants bank check copy";
              if (isDependentStep) {
                // Specialized validation for the Dependent Step
                documentValidation = validateMandatoryDocumentsForDependents(documentType, uploadDependentFile || [], formData.dependents || []);
              } else if (isBankStep) {
                // Filter only for Bank Documents
                bankDocsConfig = (documentType || []).filter(function (doc) {
                  return doc.documentType === BANK_DOC;
                });
                documentValidation = validateMandatoryBankDocumentsForAccounts(bankDocsConfig, uploadBankFile || [], formData.employeeBankInfo || []);
              } else if (isApplicantStep || isEmployeeStep) {
                // Filter out Bank Documents for general info steps
                generalDocsConfig = (documentType || []).filter(function (doc) {
                  return doc.documentType !== BANK_DOC;
                });
                documentValidation = validateMandatoryDocuments(generalDocsConfig, uploadFile || []);
              }
              if (!documentValidation.isValid) {
                newErrors.documents = documentValidation.errors;
              }
            }
            setErrors(newErrors);
            console.log({
              newErrors: newErrors
            });
            console.log({
              documentValidation: documentValidation
            });
            if (Object.keys(newErrors).length > 0 && !(newErrors !== null && newErrors !== void 0 && newErrors.documents)) {
              setShowErrorSnackbar(true);
            } else {
              setShowErrorSnackbar(false);
            }
            if (!(Object.keys(newErrors).length === 0)) {
              _context.next = 84;
              break;
            }
            nextStep = activeStep + 1;
            if (!(nextStep === 3 && !isAtLeast18YearsOld(formData === null || formData === void 0 || (_formData$workforceEm5 = formData.workforceEmployee) === null || _formData$workforceEm5 === void 0 ? void 0 : _formData$workforceEm5.birthDate) && !isNotFutureDate(formData === null || formData === void 0 || (_formData$workforceEm6 = formData.workforceEmployee) === null || _formData$workforceEm6 === void 0 ? void 0 : _formData$workforceEm6.deathDate) || nextStep === 1 && !isNotFutureDate(formData === null || formData === void 0 || (_formData$metadata = formData.metadata) === null || _formData$metadata === void 0 ? void 0 : _formData$metadata.deathDate))) {
              _context.next = 23;
              break;
            }
            fakeErrors = _objectSpread$P(_objectSpread$P({}, newErrors), {}, {
              rdmp: "core.error.workerAge"
            });
            if ((nextStep === 1 || nextStep === 3) && (!isNotFutureDate(formData === null || formData === void 0 || (_formData$workforceEm7 = formData.workforceEmployee) === null || _formData$workforceEm7 === void 0 ? void 0 : _formData$workforceEm7.deathDate) || !isNotFutureDate(formData === null || formData === void 0 || (_formData$metadata2 = formData.metadata) === null || _formData$metadata2 === void 0 ? void 0 : _formData$metadata2.deathDate))) {
              fakeErrors = _objectSpread$P(_objectSpread$P({}, fakeErrors), {}, {
                deathDate: "core.error.deathTime"
              });
            }
            setErrors(fakeErrors);
            console.log({
              fakeErrors: fakeErrors
            });
            return _context.abrupt("return", false);
          case 23:
            if (nextStep < steps.length) {
              setActiveStep(nextStep);
            }
            if (!(nextStep === 3 || nextStep === 4)) {
              _context.next = 41;
              break;
            }
            // Duplicacy check
            duplicacyFilters = ["nid: \"".concat((formData === null || formData === void 0 || (_formData$deceasedWor = formData.deceasedWorkerInfo) === null || _formData$deceasedWor === void 0 ? void 0 : _formData$deceasedWor.nid) || (formData === null || formData === void 0 || (_formData$workforceEm8 = formData.workforceEmployee) === null || _formData$workforceEm8 === void 0 ? void 0 : _formData$workforceEm8.nid), "\""), "organizationType: \"".concat(organizationType, "\""), "getOtherApplicationList: false", "applicationTypeIn: [\"financialAssistance\",\"deadlyGrant\"]"];
            _context.next = 28;
            return dispatch(fetchPrevApplicationHistory(duplicacyFilters));
          case 28:
            duplicacyResponse = _context.sent;
            duplicacyData = duplicacyResponse === null || duplicacyResponse === void 0 || (_duplicacyResponse$pa = duplicacyResponse.payload) === null || _duplicacyResponse$pa === void 0 || (_duplicacyResponse$pa = _duplicacyResponse$pa.data) === null || _duplicacyResponse$pa === void 0 ? void 0 : _duplicacyResponse$pa.workforceCheckApplicationDuplicacy;
            if (!(duplicacyData && duplicacyData.length > 0)) {
              _context.next = 35;
              break;
            }
            setIsNavigationBlocked(true);
            setShowDuplicateError(true);
            setTimeout(function () {
              history.push("/home");
              window.location.reload();
            }, 5000);
            return _context.abrupt("return");
          case 35:
            ({
              nameEn: formData === null || formData === void 0 || (_formData$workforceEm9 = formData.workforceEmployee) === null || _formData$workforceEm9 === void 0 ? void 0 : _formData$workforceEm9.nameEn,
              nameBn: formData === null || formData === void 0 || (_formData$workforceEm10 = formData.workforceEmployee) === null || _formData$workforceEm10 === void 0 ? void 0 : _formData$workforceEm10.nameBn,
              lastNameEn: "",
              phoneNumber: formData === null || formData === void 0 || (_formData$workforceEm11 = formData.workforceEmployee) === null || _formData$workforceEm11 === void 0 ? void 0 : _formData$workforceEm11.phoneNumber,
              email: formData === null || formData === void 0 || (_formData$workforceEm12 = formData.workforceEmployee) === null || _formData$workforceEm12 === void 0 ? void 0 : _formData$workforceEm12.email,
              gender: formData === null || formData === void 0 || (_formData$workforceEm13 = formData.workforceEmployee) === null || _formData$workforceEm13 === void 0 || (_formData$workforceEm13 = _formData$workforceEm13.gender) === null || _formData$workforceEm13 === void 0 ? void 0 : _formData$workforceEm13.name,
              birthDate: formData === null || formData === void 0 || (_formData$workforceEm14 = formData.workforceEmployee) === null || _formData$workforceEm14 === void 0 ? void 0 : _formData$workforceEm14.birthDate,
              deathDate: formData === null || formData === void 0 || (_formData$workforceEm15 = formData.workforceEmployee) === null || _formData$workforceEm15 === void 0 ? void 0 : _formData$workforceEm15.deathDate,
              lifeStatus: formData === null || formData === void 0 || (_formData$workforceEm16 = formData.workforceEmployee) === null || _formData$workforceEm16 === void 0 ? void 0 : _formData$workforceEm16.lifeStatus,
              permanentAddress: formData === null || formData === void 0 || (_formData$workforceEm17 = formData.workforceEmployee) === null || _formData$workforceEm17 === void 0 ? void 0 : _formData$workforceEm17.permanentAddress,
              presentAddress: formData === null || formData === void 0 || (_formData$workforceEm18 = formData.workforceEmployee) === null || _formData$workforceEm18 === void 0 ? void 0 : _formData$workforceEm18.presentAddress,
              position: formData === null || formData === void 0 || (_formData$workforceEm19 = formData.workforceEmployee) === null || _formData$workforceEm19 === void 0 ? void 0 : _formData$workforceEm19.position,
              monthlyEarning: formData === null || formData === void 0 || (_formData$workforceEm20 = formData.workforceEmployee) === null || _formData$workforceEm20 === void 0 ? void 0 : _formData$workforceEm20.monthlyEarning,
              insuranceNumber: " ",
              fatherNameBn: formData === null || formData === void 0 || (_formData$workforceEm21 = formData.workforceEmployee) === null || _formData$workforceEm21 === void 0 ? void 0 : _formData$workforceEm21.fatherNameBn,
              fatherNameEn: formData === null || formData === void 0 || (_formData$workforceEm22 = formData.workforceEmployee) === null || _formData$workforceEm22 === void 0 ? void 0 : _formData$workforceEm22.fatherNameEn,
              motherNameBn: formData === null || formData === void 0 || (_formData$workforceEm23 = formData.workforceEmployee) === null || _formData$workforceEm23 === void 0 ? void 0 : _formData$workforceEm23.motherNameBn,
              motherNameEn: formData === null || formData === void 0 || (_formData$workforceEm24 = formData.workforceEmployee) === null || _formData$workforceEm24 === void 0 ? void 0 : _formData$workforceEm24.motherNameEn,
              spouseNameBn: formData === null || formData === void 0 || (_formData$workforceEm25 = formData.workforceEmployee) === null || _formData$workforceEm25 === void 0 ? void 0 : _formData$workforceEm25.spouseNameBn,
              spouseNameEn: formData === null || formData === void 0 || (_formData$workforceEm26 = formData.workforceEmployee) === null || _formData$workforceEm26 === void 0 ? void 0 : _formData$workforceEm26.spouseNameEn,
              citizenship: formData === null || formData === void 0 || (_formData$workforceEm27 = formData.workforceEmployee) === null || _formData$workforceEm27 === void 0 ? void 0 : _formData$workforceEm27.citizenship,
              maritalStatus: formData === null || formData === void 0 || (_formData$workforceEm28 = formData.workforceEmployee) === null || _formData$workforceEm28 === void 0 ? void 0 : _formData$workforceEm28.maritalStatus,
              presentLocation: formData === null || formData === void 0 || (_formData$workforceEm29 = formData.workforceEmployee) === null || _formData$workforceEm29 === void 0 ? void 0 : _formData$workforceEm29.presentLocation,
              permanentLocation: formData === null || formData === void 0 || (_formData$workforceEm30 = formData.workforceEmployee) === null || _formData$workforceEm30 === void 0 ? void 0 : _formData$workforceEm30.permanentLocation,
              id: (formData === null || formData === void 0 || (_formData$workforceEm31 = formData.workforceEmployee) === null || _formData$workforceEm31 === void 0 ? void 0 : _formData$workforceEm31.id) || reduxState.core.user.id
            });
            console.log("Update Submitting formData:", formData);
            // await dispatch(updateWorkforceEmployee(workforceEmployeeData, `Update Workforce Employee ${workforceEmployeeData.nameEn}`));
            updateApplicationData = {
              // id: decodeId(applicationId[0]?.id) || parsedApplicationData?.id,
              id: safeApplicationId(applicationId, parsedApplicationData),
              workforceEmployeeId: (employeeData === null || employeeData === void 0 ? void 0 : employeeData.id) || reduxState.core.user.id,
              company: formData === null || formData === void 0 || (_formData$workforceEm32 = formData.workforceEmployee) === null || _formData$workforceEm32 === void 0 || (_formData$workforceEm32 = _formData$workforceEm32.company) === null || _formData$workforceEm32 === void 0 ? void 0 : _formData$workforceEm32.id,
              factory: formData !== null && formData !== void 0 && (_formData$workforceEm33 = formData.workforceEmployee) !== null && _formData$workforceEm33 !== void 0 && (_formData$workforceEm33 = _formData$workforceEm33.factory) !== null && _formData$workforceEm33 !== void 0 && _formData$workforceEm33.id || formData !== null && formData !== void 0 && (_formData$deceasedWor2 = formData.deceasedWorkerInfo) !== null && _formData$deceasedWor2 !== void 0 && (_formData$deceasedWor2 = _formData$deceasedWor2.factory) !== null && _formData$deceasedWor2 !== void 0 && _formData$deceasedWor2.id ? decodeId((formData === null || formData === void 0 || (_formData$workforceEm34 = formData.workforceEmployee) === null || _formData$workforceEm34 === void 0 || (_formData$workforceEm34 = _formData$workforceEm34.factory) === null || _formData$workforceEm34 === void 0 ? void 0 : _formData$workforceEm34.id) || (formData === null || formData === void 0 || (_formData$deceasedWor3 = formData.deceasedWorkerInfo) === null || _formData$deceasedWor3 === void 0 || (_formData$deceasedWor3 = _formData$deceasedWor3.factory) === null || _formData$deceasedWor3 === void 0 ? void 0 : _formData$deceasedWor3.id)) : null,
              organizationType: organizationType || (parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.organizationType),
              applicationType: selectedApplicationType || (parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.applicationType),
              grantAmount: formData === null || formData === void 0 ? void 0 : formData.employeeAccidentInfo.grantAmount,
              employeeBankInfo: JSON.stringify(formData.employeeBankInfo) || JSON.stringify(parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.employeeBankInfo),
              // employeeDependentInfo: JSON.stringify(formData.dependents) || JSON.stringify(parsedApplicationData?.employeeDependentInfo),
              employeeDependentInfo: JSON.stringify(formData.dependents).replace(/\\/g, "").replace(/"{/g, "{").replace(/}"/g, "}") || JSON.stringify(parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.employeeDependentInfo).replace(/\\/g, "").replace(/"{/g, "{").replace(/}"/g, "}"),
              employeeAccidentInfo: JSON.stringify(formData === null || formData === void 0 ? void 0 : formData.employeeAccidentInfo) || JSON.stringify(parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.employeeAccidentInfo),
              metadata: JSON.stringify(formData.metadata),
              deceasedWorkerInfo: JSON.stringify(formData.workforceEmployee).replace(/\\/g, "").replace(/"{/g, "{").replace(/}"/g, "}").replace(/\\\\\\/g, "\\\\"),
              status: WORKFORCE_STATUS$1.DRAFT,
              applicationFor: applicationForSelf === "yes" ? "self" : applicationForSelf === "" ? "" : "dependent"
            };
            dispatch(updateApplication(updateApplicationData, "update workforce application"));
            _context.next = 83;
            break;
          case 41:
            if (!(nextStep === 1)) {
              _context.next = 65;
              break;
            }
            createApplicationData = {
              workforceEmployeeId: (employeeData === null || employeeData === void 0 ? void 0 : employeeData.id) || reduxState.core.user.id || "",
              company: formData === null || formData === void 0 || (_formData$workforceEm35 = formData.workforceEmployee) === null || _formData$workforceEm35 === void 0 || (_formData$workforceEm35 = _formData$workforceEm35.company) === null || _formData$workforceEm35 === void 0 ? void 0 : _formData$workforceEm35.id,
              factory: formData !== null && formData !== void 0 && (_formData$workforceEm36 = formData.workforceEmployee) !== null && _formData$workforceEm36 !== void 0 && (_formData$workforceEm36 = _formData$workforceEm36.factory) !== null && _formData$workforceEm36 !== void 0 && _formData$workforceEm36.id || formData !== null && formData !== void 0 && (_formData$deceasedWor4 = formData.deceasedWorkerInfo) !== null && _formData$deceasedWor4 !== void 0 && (_formData$deceasedWor4 = _formData$deceasedWor4.factory) !== null && _formData$deceasedWor4 !== void 0 && _formData$deceasedWor4.id || formData !== null && formData !== void 0 && formData.factory ? decodeId((formData === null || formData === void 0 || (_formData$workforceEm37 = formData.workforceEmployee) === null || _formData$workforceEm37 === void 0 || (_formData$workforceEm37 = _formData$workforceEm37.factory) === null || _formData$workforceEm37 === void 0 ? void 0 : _formData$workforceEm37.id) || (formData === null || formData === void 0 || (_formData$deceasedWor5 = formData.deceasedWorkerInfo) === null || _formData$deceasedWor5 === void 0 || (_formData$deceasedWor5 = _formData$deceasedWor5.factory) === null || _formData$deceasedWor5 === void 0 ? void 0 : _formData$deceasedWor5.id) || (formData === null || formData === void 0 || (_formData$factory = formData.factory) === null || _formData$factory === void 0 ? void 0 : _formData$factory.id)) : null,
              organizationType: formData.organizationType,
              applicationType: formData.applicationType,
              grantAmount: formData === null || formData === void 0 ? void 0 : formData.employeeAccidentInfo.grantAmount,
              employeeDesignationInfo: JSON.stringify(formData === null || formData === void 0 ? void 0 : formData.employeeDesignationInfo),
              employeeBankInfo: JSON.stringify(formData === null || formData === void 0 ? void 0 : formData.employeeBankInfo),
              employeeApplicantInfo: JSON.stringify(formData.workforceApplicant).replace(/\\/g, "").replace(/"{/g, "{").replace(/}"/g, "}") || JSON.stringify(parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.workforceApplicant).replace(/\\/g, "").replace(/"{/g, "{").replace(/}"/g, "}"),
              employeeDependentInfo: JSON.stringify(formData.dependents).replace(/\\/g, "").replace(/"{/g, "{").replace(/}"/g, "}") || JSON.stringify(parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.employeeDependentInfo).replace(/\\/g, "").replace(/"{/g, "{").replace(/}"/g, "}"),
              employeeAccidentInfo: JSON.stringify(formData === null || formData === void 0 ? void 0 : formData.employeeAccidentInfo),
              metadata: JSON.stringify(formData === null || formData === void 0 ? void 0 : formData.metadata),
              status: WORKFORCE_STATUS$1.DRAFT,
              applicationFor: applicationForSelf === "yes" ? "self" : applicationForSelf === "" ? "" : "dependent"
            };
            console.log({
              createApplicationData: createApplicationData
            });
            if (parsedApplicationData) {
              _context.next = 60;
              break;
            }
            _context.next = 47;
            return formatMutation("createWorkforceApplication", formatApplicationeGQL(createApplicationData), "Created application ");
          case 47:
            applicationMutation = _context.sent;
            applicationClientMutationId = applicationMutation.clientMutationId;
            console.log("applicationClientMutationId", applicationClientMutationId);
            _context.next = 52;
            return dispatch(createApplication(applicationMutation, "Created workforce application "));
          case 52:
            _context.next = 54;
            return dispatch(fetchInfoIdByClientMutationId(modulesManager, "workforceApplication", applicationClientMutationId, "WORKFORCE_APPLICATION_BY_CLIENT_MUTATION_ID"));
          case 54:
            fetchRes = _context.sent;
            applicationgetId = getInfoId(fetchRes, "workforceApplication");
            console.log("hello there", applicationgetId);
            if (!applicationgetId && applicationId) {
              applicationgetId = applicationId;
            }
            _context.next = 63;
            break;
          case 60:
            _updateApplicationData = _objectSpread$P({
              id: parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.id
            }, createApplicationData);
            console.log("i am from update", _updateApplicationData);
            dispatch(updateApplication(_updateApplicationData, "update workforce application "));
          case 63:
            _context.next = 83;
            break;
          case 65:
            if (!(nextStep === 6)) {
              _context.next = 81;
              break;
            }
            _updateApplicationData2 = {
              // id: decodeId(applicationId[0]?.id) || parsedApplicationData?.id,
              id: safeApplicationId(applicationId, parsedApplicationData),
              workforceEmployeeId: (employeeData === null || employeeData === void 0 ? void 0 : employeeData.id) || reduxState.core.user.id,
              company: formData === null || formData === void 0 || (_formData$workforceEm38 = formData.workforceEmployee) === null || _formData$workforceEm38 === void 0 || (_formData$workforceEm38 = _formData$workforceEm38.company) === null || _formData$workforceEm38 === void 0 ? void 0 : _formData$workforceEm38.id,
              factory: formData !== null && formData !== void 0 && (_formData$workforceEm39 = formData.workforceEmployee) !== null && _formData$workforceEm39 !== void 0 && (_formData$workforceEm39 = _formData$workforceEm39.factory) !== null && _formData$workforceEm39 !== void 0 && _formData$workforceEm39.id || formData !== null && formData !== void 0 && (_formData$deceasedWor6 = formData.deceasedWorkerInfo) !== null && _formData$deceasedWor6 !== void 0 && (_formData$deceasedWor6 = _formData$deceasedWor6.factory) !== null && _formData$deceasedWor6 !== void 0 && _formData$deceasedWor6.id || formData !== null && formData !== void 0 && formData.factory ? decodeId((formData === null || formData === void 0 || (_formData$workforceEm40 = formData.workforceEmployee) === null || _formData$workforceEm40 === void 0 || (_formData$workforceEm40 = _formData$workforceEm40.factory) === null || _formData$workforceEm40 === void 0 ? void 0 : _formData$workforceEm40.id) || (formData === null || formData === void 0 || (_formData$deceasedWor7 = formData.deceasedWorkerInfo) === null || _formData$deceasedWor7 === void 0 || (_formData$deceasedWor7 = _formData$deceasedWor7.factory) === null || _formData$deceasedWor7 === void 0 ? void 0 : _formData$deceasedWor7.id) || (formData === null || formData === void 0 || (_formData$factory2 = formData.factory) === null || _formData$factory2 === void 0 ? void 0 : _formData$factory2.id)) : null,
              organizationType: organizationType || (parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.organizationType),
              applicationType: selectedApplicationType || (parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.applicationType),
              grantAmount: formData === null || formData === void 0 ? void 0 : formData.employeeAccidentInfo.grantAmount,
              employeeApplicantInfo: JSON.stringify(formData.workforceApplicant).replace(/\\/g, "").replace(/"{/g, "{").replace(/}"/g, "}") || JSON.stringify(parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.workforceApplicant).replace(/\\/g, "").replace(/"{/g, "{").replace(/}"/g, "}"),
              employeeBankInfo: JSON.stringify(formData.employeeBankInfo) || JSON.stringify(parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.employeeBankInfo),
              employeeDependentInfo: JSON.stringify(formData.dependents).replace(/\\/g, "").replace(/"{/g, "{").replace(/}"/g, "}") || JSON.stringify(parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.employeeDependentInfo).replace(/\\/g, "").replace(/"{/g, "{").replace(/}"/g, "}"),
              employeeAccidentInfo: JSON.stringify(formData === null || formData === void 0 ? void 0 : formData.employeeAccidentInfo) || JSON.stringify(parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.employeeAccidentInfo),
              institutionInfo: JSON.stringify(formData.institutionInfo),
              metadata: JSON.stringify(formData.metadata),
              status: WORKFORCE_STATUS$1.DRAFT,
              applicationFor: applicationForSelf === "yes" ? "self" : applicationForSelf === "" ? "" : "dependent"
            };
            if (!uploadDependentFile) {
              _context.next = 70;
              break;
            }
            _context.next = 70;
            return uploadDependentFile.map(function (file) {
              applicationId || (formData === null || formData === void 0 ? void 0 : formData.id);
              return dispatch(createWorkforceDocument(_objectSpread$P(_objectSpread$P({}, file), {}, {
                workforceApplicationId: safeApplicationId(applicationId, parsedApplicationData)
              }), "Created workforce document"));
            });
          case 70:
            _context.next = 72;
            return dispatch(updateApplication(_updateApplicationData2, "update workforce application")).then(function (res) {
              return setIsDependentSaved(true);
            });
          case 72:
            if (!(parsedApplicationData !== null && parsedApplicationData !== void 0 && parsedApplicationData.id)) {
              _context.next = 77;
              break;
            }
            _context.next = 75;
            return dispatch(fetchEmployeeDependent(modulesManager, ["workforceApplication_Id:\"".concat(parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.id, "\"")]));
          case 75:
            _context.next = 79;
            break;
          case 77:
            _context.next = 79;
            return dispatch(fetchEmployeeDependent(modulesManager, ["workforceApplication_Id:\"".concat(safeApplicationId(applicationId), "\"")]));
          case 79:
            _context.next = 83;
            break;
          case 81:
            _updateApplicationData3 = {
              // id: decodeId(applicationId[0]?.id) || parsedApplicationData?.id,
              id: safeApplicationId(applicationId, parsedApplicationData),
              workforceEmployeeId: (employeeData === null || employeeData === void 0 ? void 0 : employeeData.id) || reduxState.core.user.id,
              company: formData === null || formData === void 0 || (_formData$workforceEm41 = formData.workforceEmployee) === null || _formData$workforceEm41 === void 0 || (_formData$workforceEm41 = _formData$workforceEm41.company) === null || _formData$workforceEm41 === void 0 ? void 0 : _formData$workforceEm41.id,
              factory: formData !== null && formData !== void 0 && (_formData$workforceEm42 = formData.workforceEmployee) !== null && _formData$workforceEm42 !== void 0 && (_formData$workforceEm42 = _formData$workforceEm42.factory) !== null && _formData$workforceEm42 !== void 0 && _formData$workforceEm42.id || formData !== null && formData !== void 0 && (_formData$deceasedWor8 = formData.deceasedWorkerInfo) !== null && _formData$deceasedWor8 !== void 0 && (_formData$deceasedWor8 = _formData$deceasedWor8.factory) !== null && _formData$deceasedWor8 !== void 0 && _formData$deceasedWor8.id || formData !== null && formData !== void 0 && formData.factory ? decodeId((formData === null || formData === void 0 || (_formData$workforceEm43 = formData.workforceEmployee) === null || _formData$workforceEm43 === void 0 || (_formData$workforceEm43 = _formData$workforceEm43.factory) === null || _formData$workforceEm43 === void 0 ? void 0 : _formData$workforceEm43.id) || (formData === null || formData === void 0 || (_formData$deceasedWor9 = formData.deceasedWorkerInfo) === null || _formData$deceasedWor9 === void 0 || (_formData$deceasedWor9 = _formData$deceasedWor9.factory) === null || _formData$deceasedWor9 === void 0 ? void 0 : _formData$deceasedWor9.id) || (formData === null || formData === void 0 || (_formData$factory3 = formData.factory) === null || _formData$factory3 === void 0 ? void 0 : _formData$factory3.id)) : null,
              organizationType: organizationType || (parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.organizationType),
              applicationType: selectedApplicationType || (parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.applicationType),
              grantAmount: formData === null || formData === void 0 ? void 0 : formData.employeeAccidentInfo.grantAmount,
              employeeBankInfo: JSON.stringify(formData.employeeBankInfo) || JSON.stringify(parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.employeeBankInfo),
              employeeDependentInfo: JSON.stringify(formData.dependents).replace(/\\/g, "").replace(/"{/g, "{").replace(/}"/g, "}") || JSON.stringify(parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.employeeDependentInfo).replace(/\\/g, "").replace(/"{/g, "{").replace(/}"/g, "}"),
              employeeAccidentInfo: JSON.stringify(formData === null || formData === void 0 ? void 0 : formData.employeeAccidentInfo) || JSON.stringify(parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.employeeAccidentInfo),
              employeeApplicantInfo: JSON.stringify(formData.workforceApplicant).replace(/\\/g, "").replace(/"{/g, "{").replace(/}"/g, "}") || JSON.stringify(parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.workforceApplicant).replace(/\\/g, "").replace(/"{/g, "{").replace(/}"/g, "}"),
              institutionInfo: JSON.stringify(formData.institutionInfo),
              metadata: JSON.stringify(formData.metadata),
              deceasedWorkerInfo: JSON.stringify(formData.deceasedWorkerInfo).replace(/\\/g, "").replace(/"{/g, "{").replace(/}"/g, "}").replace(/\\\\\\/g, "\\\\"),
              status: WORKFORCE_STATUS$1.DRAFT,
              applicationFor: applicationForSelf === "yes" ? "self" : applicationForSelf === "" ? "" : "dependent"
            }; // if (uploadBankFile) {
            //   await uploadBankFile.map((file) => {
            //     const appId = applicationId || formData?.id;
            //     return dispatch(
            //       createWorkforceDocument(
            //         { ...file, workforceApplicationId: safeApplicationId(applicationId, parsedApplicationData) },
            //         `Created workforce document`,
            //       ),
            //     );
            //   });
            // }
            dispatch(updateApplication(_updateApplicationData3, "update workforce application"));
          case 83:
            return _context.abrupt("return", true);
          case 84:
            return _context.abrupt("return", false);
          case 85:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function handleNext() {
      return _ref2.apply(this, arguments);
    };
  }();
  var handleBack = function handleBack() {
    return setActiveStep(function (prevStep) {
      return prevStep - 1;
    });
  };
  var handleArrayFieldChange = function handleArrayFieldChange(fieldKey, index, key, value) {
    setFormData(function (prev) {
      var items = Array.isArray(prev[fieldKey]) ? _toConsumableArray(prev[fieldKey]) : [];
      var currentItem = items[index] || {};
      var nextValue = typeof value === "function" ? value(currentItem[key]) : value;
      items[index] = _objectSpread$P(_objectSpread$P({}, currentItem), {}, _defineProperty({}, key, nextValue));
      return _objectSpread$P(_objectSpread$P({}, prev), {}, _defineProperty({}, fieldKey, items));
    });
  };
  var addArrayFieldItem = function addArrayFieldItem(fieldKey) {
    var defaultItem = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    setFormData(function (prev) {
      var items = Array.isArray(prev[fieldKey]) ? _toConsumableArray(prev[fieldKey]) : [{}];
      var updated = [].concat(_toConsumableArray(items), [defaultItem]);
      setExpanded === null || setExpanded === void 0 || setExpanded(updated.length - 1); // optional chaining
      return _objectSpread$P(_objectSpread$P({}, prev), {}, _defineProperty({}, fieldKey, updated));
    });
  };
  var removeArrayFieldItem = function removeArrayFieldItem(fieldKey, index) {
    setFormData(function (prev) {
      var items = Array.isArray(prev[fieldKey]) ? _toConsumableArray(prev[fieldKey]) : [];
      var updated = items.filter(function (_, i) {
        return i !== index;
      });
      return _objectSpread$P(_objectSpread$P({}, prev), {}, _defineProperty({}, fieldKey, updated));
    });
  };
  var handleSubmit = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var _parsedApplicationDat41, _formData$workforceEm44, _formData$workforceEm45, _formData$deceasedWor10, _formData$workforceEm46, _formData$deceasedWor11, _formData$factory4;
      var submittedBy, updateApplicationData;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            if (!uploadBankFile) {
              _context2.next = 3;
              break;
            }
            _context2.next = 3;
            return Promise.all(uploadBankFile.map(function (file) {
              return dispatch(createWorkforceDocument(_objectSpread$P(_objectSpread$P({}, file), {}, {
                workforceApplicationId: safeApplicationId(applicationId, parsedApplicationData)
              }), "Created workforce document"));
            }));
          case 3:
            _context2.next = 5;
            return Promise.all(uploadFile.map(function (file, index) {
              dispatch(createWorkforceDocument(_objectSpread$P(_objectSpread$P({}, file), {}, {
                workforceApplicationId: safeApplicationId(applicationId, parsedApplicationData)
              }), "Created workforce document "));
            }));
          case 5:
            submittedBy = user_type === WORKFORCE_USER_TYPE.APPLICANT ? "applicant" : user_type === WORKFORCE_USER_TYPE.FACTORY_ADMIN ? "factory_admin" : "UNKNOWN";
            updateApplicationData = {
              // id: decodeId(applicationId[0]?.id) || parsedApplicationData?.id,
              id: safeApplicationId(applicationId, parsedApplicationData),
              workforceEmployeeId: safeDecodeId(formData === null || formData === void 0 ? void 0 : formData.workforceEmployee.id) || safeDecodeId(parsedApplicationData === null || parsedApplicationData === void 0 || (_parsedApplicationDat41 = parsedApplicationData.workforceEmployee) === null || _parsedApplicationDat41 === void 0 ? void 0 : _parsedApplicationDat41.id),
              company: formData === null || formData === void 0 || (_formData$workforceEm44 = formData.workforceEmployee) === null || _formData$workforceEm44 === void 0 || (_formData$workforceEm44 = _formData$workforceEm44.company) === null || _formData$workforceEm44 === void 0 ? void 0 : _formData$workforceEm44.id,
              factory: formData !== null && formData !== void 0 && (_formData$workforceEm45 = formData.workforceEmployee) !== null && _formData$workforceEm45 !== void 0 && (_formData$workforceEm45 = _formData$workforceEm45.factory) !== null && _formData$workforceEm45 !== void 0 && _formData$workforceEm45.id || formData !== null && formData !== void 0 && (_formData$deceasedWor10 = formData.deceasedWorkerInfo) !== null && _formData$deceasedWor10 !== void 0 && (_formData$deceasedWor10 = _formData$deceasedWor10.factory) !== null && _formData$deceasedWor10 !== void 0 && _formData$deceasedWor10.id || formData !== null && formData !== void 0 && formData.factory ? decodeId((formData === null || formData === void 0 || (_formData$workforceEm46 = formData.workforceEmployee) === null || _formData$workforceEm46 === void 0 || (_formData$workforceEm46 = _formData$workforceEm46.factory) === null || _formData$workforceEm46 === void 0 ? void 0 : _formData$workforceEm46.id) || (formData === null || formData === void 0 || (_formData$deceasedWor11 = formData.deceasedWorkerInfo) === null || _formData$deceasedWor11 === void 0 || (_formData$deceasedWor11 = _formData$deceasedWor11.factory) === null || _formData$deceasedWor11 === void 0 ? void 0 : _formData$deceasedWor11.id) || (formData === null || formData === void 0 || (_formData$factory4 = formData.factory) === null || _formData$factory4 === void 0 ? void 0 : _formData$factory4.id)) : null,
              organizationType: organizationType || (parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.organizationType),
              applicationType: selectedApplicationType || (parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.applicationType),
              grantAmount: formData === null || formData === void 0 ? void 0 : formData.employeeAccidentInfo.grantAmount,
              employeeBankInfo: JSON.stringify(formData.employeeBankInfo) || JSON.stringify(parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.employeeBankInfo),
              employeeApplicantInfo: JSON.stringify(formData.workforceApplicant).replace(/\\/g, "").replace(/"{/g, "{").replace(/}"/g, "}") || JSON.stringify(parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.workforceApplicant).replace(/\\/g, "").replace(/"{/g, "{").replace(/}"/g, "}"),
              employeeDependentInfo: JSON.stringify(formData.dependents).replace(/\\/g, "").replace(/"{/g, "{").replace(/}"/g, "}") || JSON.stringify(parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.employeeDependentInfo).replace(/\\/g, "").replace(/"{/g, "{").replace(/}"/g, "}"),
              employeeAccidentInfo: JSON.stringify(formData === null || formData === void 0 ? void 0 : formData.employeeAccidentInfo) || JSON.stringify(parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.employeeAccidentInfo),
              institutionInfo: JSON.stringify(formData.institutionInfo),
              metadata: JSON.stringify(formData.metadata),
              deceasedWorkerInfo: JSON.stringify(formData.workforceEmployee).replace(/\\/g, "").replace(/"{/g, "{").replace(/}"/g, "}").replace(/\\\\\\/g, "\\\\"),
              status: WORKFORCE_STATUS$1.NEW,
              applicationFor: applicationForSelf === "yes" ? "self" : applicationForSelf === "" ? "" : "dependent",
              submittedBy: submittedBy
            };
            console.log("hello i am from submit", updateApplicationData);
            dispatch(updateApplication(updateApplicationData, "update workforce application "));
            // dispatch(createApplicationMovement(createApplicationMovementData, `create workforce movement`));
          case 9:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function handleSubmit() {
      return _ref3.apply(this, arguments);
    };
  }();
  if (showPreview) {
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ApplicationViewPage, {
      application: formData,
      language: "fr"
    }), /*#__PURE__*/React.createElement("div", {
      className: classes.buttonContainer
    }, /*#__PURE__*/React.createElement(Button, {
      variant: "outlined",
      color: "error",
      onClick: function onClick() {
        setShowPreview(false);
      }
    }, /*#__PURE__*/React.createElement(FormattedMessage, {
      module: "workforce",
      id: "workforce.back"
    })), /*#__PURE__*/React.createElement(Button, {
      variant: "contained",
      color: "primary",
      onClick: function onClick() {
        setShowPreview(false);
        setShowVerifyNid(true);
      }
    }, /*#__PURE__*/React.createElement(FormattedMessage, {
      module: "workforce",
      id: "workforce.submit"
    }))));
  }
  if (showVerifyNid) {
    return /*#__PURE__*/React.createElement("div", {
      className: classes.container
    }, /*#__PURE__*/React.createElement(Paper, {
      className: classes.paper,
      elevation: 0
    }, /*#__PURE__*/React.createElement(NidVerification, {
      formData: formData,
      nidOrBcn: nidOrBcn,
      setDisableConfirmSubmit: setDisableConfirmSubmit
    }), /*#__PURE__*/React.createElement("div", {
      className: classes.buttonContainer
    }, /*#__PURE__*/React.createElement(Button, {
      variant: "contained",
      color: "primary"
      // disabled={disableConfirmSubmit}
      ,
      onClick: /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return handleSubmit();
            case 2:
              setShowVerifyNid(false);
              setIsSubmitted(true);
            case 4:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))
    }, /*#__PURE__*/React.createElement(FormattedMessage, {
      module: "workforce",
      id: "workforce.confirm.submit"
    })))));
  }
  if (isSubmitted) {
    return /*#__PURE__*/React.createElement(ApplicationFormSubmitted, null);
  }
  console.log({
    tazwer: formData
  });
  console.log({
    fahimTazwer: uploadFile
  });
  return /*#__PURE__*/React.createElement("div", {
    className: classes.container
  }, /*#__PURE__*/React.createElement(Paper, {
    className: classes.paper,
    elevation: 0
  }, /*#__PURE__*/React.createElement(Stepper, {
    activeStep: activeStep,
    alternativeLabel: true,
    style: {
      padding: "0px"
    }
  }, steps.map(function (label) {
    return /*#__PURE__*/React.createElement(Step, {
      key: label
    }, /*#__PURE__*/React.createElement(StepLabel, null, /*#__PURE__*/React.createElement(FormattedMessage, {
      module: "workforce",
      id: label
    })));
  })), /*#__PURE__*/React.createElement(Box$1, {
    mt: 0,
    ref: stepRef
  }, activeStep === 0 ? /*#__PURE__*/React.createElement(ApplicationReason, {
    modulesManager: modulesManager,
    handleChange: function handleChange(key, value) {
      return _handleChange(key, value, "metadata");
    },
    formData: formData,
    setDeathType: setDeathType,
    deathType: deathType,
    errors: errors
  }) : activeStep === 1 ? /*#__PURE__*/React.createElement(Box$1, {
    mt: 0
  }, /*#__PURE__*/React.createElement(ApplicantDetailsForm, {
    handleChange: function handleChange(key, value) {
      return _handleChange(key, value, "workforceApplicant");
    },
    formData: formData,
    setNidOrBcn: setNidOrBcn,
    nidOrBcn: nidOrBcn,
    errors: errors
  })) : activeStep === 2 ? /*#__PURE__*/React.createElement(Box$1, {
    mt: 0
  }, /*#__PURE__*/React.createElement(EmployeeDetailsForm, {
    handleChange: function handleChange(key, value) {
      return _handleChange(key, value, "workforceEmployee");
    },
    formData: formData,
    setNidOrBcn: setNidOrBcn,
    nidOrBcn: nidOrBcn,
    errors: errors
  })) : activeStep === 3 ? /*#__PURE__*/React.createElement(Box$1, {
    mt: 0
  }, /*#__PURE__*/React.createElement(EmployeeLocationForm, {
    handleChange: function handleChange(key, value) {
      return _handleChange(key, value, "workforceEmployee");
    },
    formData: formData
  })) : activeStep === 4 ? /*#__PURE__*/React.createElement(Box$1, {
    mt: 0
  }, /*#__PURE__*/React.createElement(WorkerExtraInfo, {
    handleChange: function handleChange(key, value) {
      return _handleChange(key, value, "institutionInfo");
    },
    formData: formData,
    errors: errors
  })) : activeStep === 5 ? /*#__PURE__*/React.createElement(Box$1, {
    mt: 0
  }, /*#__PURE__*/React.createElement(EmployeeDependentForm, {
    applicationType: formData.applicationType,
    dependents: formData.dependents,
    handleChange: function handleChange(index, key, value) {
      return handleArrayFieldChange("dependents", index, key, value);
    },
    addItem: function addItem() {
      return addArrayFieldItem("dependents", {
        fullName: "",
        relationship: ""
      });
    },
    removeItem: function removeItem(index) {
      return removeArrayFieldItem("dependents", index);
    },
    expanded: expanded,
    setExpanded: setExpanded,
    formdata: formData,
    errors: errors
  })) : /*#__PURE__*/React.createElement(Box$1, {
    mt: 0
  }, !isDependentSaved ? /*#__PURE__*/React.createElement("b", null, "loading ...") : /*#__PURE__*/React.createElement(EmployeeAccountInfoForm, {
    formdata: formData,
    accounts: formData.employeeBankInfo,
    handleChange: function handleChange(index, key, value) {
      return handleArrayFieldChange("employeeBankInfo", index, key, value);
    },
    addItem: function addItem() {
      return addArrayFieldItem("employeeBankInfo", {
        accountHolderName: "",
        bankName: "",
        accountNumber: "",
        branchName: ""
      });
    },
    removeItem: function removeItem(index) {
      return removeArrayFieldItem("employeeBankInfo", index);
    },
    expanded: expanded,
    setExpanded: setExpanded,
    applicationId: applicationId,
    errors: errors
  }))), /*#__PURE__*/React.createElement(Box$1, null, activeStep === steps.length - 1 && /*#__PURE__*/React.createElement(Box$1, null, /*#__PURE__*/React.createElement(FormControlLabel, {
    control: /*#__PURE__*/React.createElement(Checkbox, {
      checked: acknowledged,
      onChange: function onChange(e) {
        return setAcknowledged(e.target.checked);
      },
      style: {
        color: "blue"
      }
    }),
    label: /*#__PURE__*/React.createElement(Typography, {
      variant: "body2"
    }, /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.application.acknowledgement.text",
      module: "workforce"
    }))
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.buttonContainer
  }, activeStep > 0 && /*#__PURE__*/React.createElement(Button, {
    onClick: handleBack,
    variant: "outlined"
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.back"
  }), " "), activeStep < steps.length - 1 ? /*#__PURE__*/React.createElement(Button, {
    variant: "contained",
    color: "primary",
    onClick: handleNext
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.save.next"
  })) : /*#__PURE__*/React.createElement(Button, {
    variant: "contained",
    color: "primary",
    disabled: !acknowledged,
    onClick: /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
      var isSuccess;
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return handleNext();
          case 2:
            isSuccess = _context4.sent;
            if (isSuccess) setShowPreview(true);
          case 4:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }))
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.submit"
  }))))), /*#__PURE__*/React.createElement(CustomSnackbar, {
    open: showErrorSnackbar // Use the new state
    ,
    onClose: function onClose() {
      return setShowErrorSnackbar(false);
    } // Allow it to close
    ,
    type: "error",
    message: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "core.error.generel",
      module: "workforce"
    }),
    duration: 4000
  }), /*#__PURE__*/React.createElement(CustomSnackbar, {
    open: showDuplicateError,
    onClose: function onClose() {
      return setShowDuplicateError(false);
    },
    type: "error",
    message: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.application.duplicate.found",
      module: "workforce"
    }),
    duration: 5000
  }), /*#__PURE__*/React.createElement(Dialog$1, {
    open: isNavigationBlocked,
    onClose: function onClose() {},
    disableBackdropClick: true,
    disableEscapeKeyDown: true,
    maxWidth: "sm",
    fullWidth: true
  }, /*#__PURE__*/React.createElement(Box$1, {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: 4,
    gap: 2
  }, /*#__PURE__*/React.createElement(CircularProgress$1, {
    size: 60,
    thickness: 4
  }), /*#__PURE__*/React.createElement(Typography, {
    variant: "h6",
    align: "center"
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "workforce.processing.data",
    module: "workforce"
  })), /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    align: "center",
    color: "textSecondary"
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "workforce.please.wait",
    module: "workforce"
  })))));
};

var ConfirmModal = function ConfirmModal(_ref) {
  var open = _ref.open,
    message = _ref.message,
    _onClose = _ref.onClose,
    loader = _ref.loader;
  var modulesManager = useModulesManager();
  var _useTranslations = useTranslations("core.RegistrationPage", modulesManager);
    _useTranslations.formatMessage;
  return /*#__PURE__*/React.createElement(Modal, {
    open: open,
    onClose: function onClose() {
      return _onClose(0);
    }
  }, /*#__PURE__*/React.createElement(Box$1, {
    sx: {
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      width: 400,
      bgcolor: "background.paper",
      borderRadius: 2,
      boxShadow: 24,
      p: 4,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6",
    gutterBottom: true
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "".concat(message),
    module: "workforce"
  }) || "Are you sure?"), /*#__PURE__*/React.createElement(Box$1, {
    sx: {
      mt: 3,
      display: "flex",
      justifyContent: "space-around"
    }
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "outlined",
    color: "secondary",
    onClick: function onClick() {
      return _onClose(0);
    } // cancel
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "workforce.confirm.modal.cancel",
    module: "workforce"
  }) || "Are you sure?"), /*#__PURE__*/React.createElement(Button, {
    disabled: loader,
    variant: "contained",
    color: "primary",
    onClick: function onClick() {
      return _onClose(1);
    } // ok
  }, !loader ? /*#__PURE__*/React.createElement(FormattedMessage, {
    id: isEisPath() ? "workforce.confirm.modal.ok" : "workforce.confirm.modal.ok.notEis",
    module: "workforce"
  }) || "Are you sure?" : "Loading ..."))));
};

var useStyles$$ = makeStyles(function (theme) {
  return {
    container: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center"
    },
    subPaper: {
      padding: theme.spacing(1),
      width: "100%",
      // Ensures it doesn't overflow
      maxWidth: 650,
      // Restrict max width
      margin: "auto",
      // Centers the Paper component
      minHeight: "fit-content" // Ensures a minimum height
    },
    paper: {
      padding: theme.spacing(1),
      width: "100%",
      minHeight: "fit-content" // Ensures a minimum height
    },
    buttonContainer: {
      marginTop: theme.spacing(2),
      display: "flex",
      justifyContent: "flex-end",
      gap: theme.spacing(1)
    },
    backButtonContainer: {
      display: "flex",
      alignItems: "center",
      marginBottom: theme.spacing(0.5)
    },
    backText: {
      marginLeft: theme.spacing(1),
      fontWeight: "bold"
    },
    title: {
      fontWeight: 800
    },
    section: {
      marginTop: theme.spacing(1)
    }
  };
});
var MultiStepApplyForm = function MultiStepApplyForm(_ref) {
  var workforceFactoryId = _ref.workforceFactoryId;
  var classes = useStyles$$();
  var modulesManager = useModulesManager();
  var _useParams = useParams(),
    application_uuid = _useParams.application_uuid;
  var dispatch = useDispatch();
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    parsedApplicationData = _useState2[0],
    setParsedApplicationData = _useState2[1];
  var loggedInUserId = useSelector(function (state) {
    var _state$core;
    return (_state$core = state.core) === null || _state$core === void 0 || (_state$core = _state$core.user) === null || _state$core === void 0 || (_state$core = _state$core.i_user) === null || _state$core === void 0 ? void 0 : _state$core.id;
  });
  var user_type = getUserType();
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    showForm = _useState4[0],
    setShowForm = _useState4[1];
  var _useState5 = useState(""),
    _useState6 = _slicedToArray(_useState5, 2),
    applicationForSelf = _useState6[0],
    setApplicationForSelf = _useState6[1];
  var _useState7 = useState((parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.organizationType)),
    _useState8 = _slicedToArray(_useState7, 2),
    organizationType = _useState8[0],
    setOrganizationType = _useState8[1];
  var _useState9 = useState((parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.applicationType)),
    _useState10 = _slicedToArray(_useState9, 2),
    selectedApplicationType = _useState10[0],
    setSelectedApplicationType = _useState10[1];
  var _useState11 = useState(true),
    _useState12 = _slicedToArray(_useState11, 2),
    isApplicationForSelfSelected = _useState12[0],
    setIsApplicationForSelfSelected = _useState12[1];
  var _useState13 = useState(false),
    _useState14 = _slicedToArray(_useState13, 2),
    openErrorModal = _useState14[0],
    setOpenErrorModal = _useState14[1];
  var _useState15 = useState(null),
    _useState16 = _slicedToArray(_useState15, 2),
    selectedFactory = _useState16[0],
    setSelectedFactory = _useState16[1];
  var _useState17 = useState(null),
    _useState18 = _slicedToArray(_useState17, 2),
    factoryId = _useState18[0],
    setFactoryId = _useState18[1];
  var reduxState = useSelector(function (state) {
    return state;
  });
  reduxState.core.user.username;
  useEffect(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    var fetchData;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          fetchData = /*#__PURE__*/function () {
            var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
              var filters, parsedData;
              return _regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) switch (_context.prev = _context.next) {
                  case 0:
                    filters = ["id: \"".concat(application_uuid, "\"")];
                    _context.next = 3;
                    return dispatch(getParsedApplication(modulesManager, filters));
                  case 3:
                    parsedData = _context.sent;
                    setParsedApplicationData(parsedData); // <- parsed data will now be set correctly
                  case 5:
                  case "end":
                    return _context.stop();
                }
              }, _callee);
            }));
            return function fetchData() {
              return _ref3.apply(this, arguments);
            };
          }();
          fetchData();
        case 2:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  })), [application_uuid, dispatch, modulesManager]);
  useEffect(function () {
    if (!workforceFactoryId && loggedInUserId && user_type === WORKFORCE_USER_TYPE.FACTORY_ADMIN) {
      var filters = ["relatedUser_Id: \"".concat(encodeId(modulesManager, "InteractiveUserGQLType", loggedInUserId), "\"")];
      dispatch(fetchFactoryEmployee(modulesManager, filters)).then(function (res) {
        var _res$payload, _edges$, _node$workforceFactor;
        var edges = (res === null || res === void 0 || (_res$payload = res.payload) === null || _res$payload === void 0 || (_res$payload = _res$payload.data) === null || _res$payload === void 0 || (_res$payload = _res$payload.workforceEmployerEmployees) === null || _res$payload === void 0 ? void 0 : _res$payload.edges) || [];
        var node = (_edges$ = edges[0]) === null || _edges$ === void 0 ? void 0 : _edges$.node;
        var factoryId = (node === null || node === void 0 || (_node$workforceFactor = node.workforceFactory) === null || _node$workforceFactor === void 0 ? void 0 : _node$workforceFactor.id) || null;
        setFactoryId(factoryId);
        dispatch(fetchWorkforceEmployeesSummary(modulesManager, ["workforceFactoryId:\"".concat(factoryId === null || factoryId === void 0 ? void 0 : factoryId.id, "\"")]));
      });
    }
  }, []);
  useEffect(function () {
    if (!(parsedApplicationData !== null && parsedApplicationData !== void 0 && parsedApplicationData.employeeDependentInfo)) return;
    Object.keys(parsedApplicationData.employeeDependentInfo).length === 0;
    setApplicationForSelf((parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.applicationFor) === "dependent" ? "no" : (parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.applicationFor) === "self" ? "yes" : "");
    setSelectedApplicationType(parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.applicationType);
    setOrganizationType(parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.organizationType);
    setSelectedFactory((parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.workforceFactory) || null);
  }, [parsedApplicationData]);
  var handleSelection = useCallback(function (applicationType, exportStatus) {
    setSelectedApplicationType(applicationType);
    if (exportStatus === "yes") {
      setOrganizationType("cf");
    } else if (exportStatus === "no") {
      setOrganizationType("blwf");
    }
  }, []);
  var handleBack = function handleBack() {
    setShowForm(false);
    setApplicationForSelf("");
  };
  var handleApplicationFor = function handleApplicationFor(event) {
    var value = event.target.value;
    setApplicationForSelf(value);
    // setIsApplicationForSelfSelected(false)
    // onSelect(selectedApplicationType, value); // Pass both selections
  };
  var handleNextButtonClicked = function handleNextButtonClicked() {
    if (selectedApplicationType === "financialAssistance") {
      // dispatch(
      //   fetchApplicationsSummary(modulesManager, [
      //     `applicationType: "financialAssistance",workforceEmployee_Nid: "${userName}",status:"new",organizationType:"${organizationType}"`,
      //   ]),
      // ).then((res) => {
      //   const data = res?.payload?.data?.workforceApplication?.edges;
      //   if (data && data.length > 0) {
      //     setOpenErrorModal(true);
      //     return;
      //   }
      //   setShowForm(true);
      // });
      setShowForm(true);
    } else {
      setShowForm(true);
    }
  };
  console.log({
    selectedFactory: selectedFactory
  });
  console.log({
    parsedApplicationData: parsedApplicationData
  });
  return /*#__PURE__*/React.createElement("div", {
    className: classes.container
  }, /*#__PURE__*/React.createElement(Paper, {
    className: classes.paper,
    elevation: 3
  }, /*#__PURE__*/React.createElement(CustomSnackbar, {
    open: openErrorModal,
    onClose: function onClose() {
      return setOpenErrorModal(false);
    },
    type: "error",
    message: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.financialAssistance.error.message",
      module: "workforce"
    })
  }), !showForm ? /*#__PURE__*/React.createElement(React.Fragment, null, !isEisPath() && !isBlwfPath() && /*#__PURE__*/React.createElement(Typography, {
    style: {
      color: "#990F02",
      textAlign: "center",
      fontWeight: 800,
      fontSize: "large"
    }
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "workforce.application.company.type",
    module: "workforce"
  })), /*#__PURE__*/React.createElement(ApplicationTypeSelector, {
    workforceFactoryId: workforceFactoryId || factoryId,
    modulesManager: modulesManager,
    onSelect: handleSelection,
    selectedApplicationType: selectedApplicationType,
    parsedApplicationData: parsedApplicationData,
    setSelectedFactory: setSelectedFactory,
    selectedFactory: selectedFactory
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.buttonContainer
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "contained",
    color: "primary",
    onClick: function onClick() {
      return handleNextButtonClicked();
    },
    disabled: !selectedApplicationType || !organizationType // Ensures both are selected
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.next"
  })))) : selectedApplicationType === "medicalDonation" ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: classes.backButtonContainer
  }, /*#__PURE__*/React.createElement(IconButton, {
    onClick: handleBack,
    color: "primary"
  }, /*#__PURE__*/React.createElement(ArrowBackIcon, null)), /*#__PURE__*/React.createElement(Typography, {
    variant: "body1",
    className: classes.backText
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.back.application.type"
  }))), applicationForSelf === "" || isApplicationForSelfSelected ? /*#__PURE__*/React.createElement(Paper, {
    className: classes.subPaper,
    elevation: 0
  }, /*#__PURE__*/React.createElement(FormControl, {
    component: "fieldset"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6",
    className: "".concat(classes.title, " ").concat(classes.section)
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "workforce.application.for",
    module: "workforce"
  })), /*#__PURE__*/React.createElement(RadioGroup, {
    value: applicationForSelf,
    onChange: handleApplicationFor
  }, /*#__PURE__*/React.createElement(FormControlLabel, {
    value: "yes",
    control: /*#__PURE__*/React.createElement(Radio, {
      color: "primary"
    }),
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.application.for.type.self",
      module: "workforce"
    })
  }), /*#__PURE__*/React.createElement(FormControlLabel, {
    value: "no",
    control: /*#__PURE__*/React.createElement(Radio, {
      color: "primary"
    }),
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.application.for.type.dependent",
      module: "workforce"
    })
  }))), /*#__PURE__*/React.createElement("div", {
    className: classes.buttonContainer
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "contained",
    color: "primary",
    onClick: function onClick() {
      return setIsApplicationForSelfSelected(false);
    }
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.next"
  })))) : /*#__PURE__*/React.createElement(MedicalDonationForm, {
    workforceFactoryId: workforceFactoryId,
    modulesManager: modulesManager,
    organizationType: organizationType,
    selectedApplicationType: selectedApplicationType,
    applicationForSelf: applicationForSelf,
    parsedApplicationData: parsedApplicationData,
    selectedFactory: selectedFactory
  })) : selectedApplicationType === "medicalAssistance" ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: classes.backButtonContainer
  }, /*#__PURE__*/React.createElement(IconButton, {
    onClick: handleBack,
    color: "primary"
  }, /*#__PURE__*/React.createElement(ArrowBackIcon, null)), /*#__PURE__*/React.createElement(Typography, {
    variant: "body1",
    className: classes.backText
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.back.application.type"
  }))), applicationForSelf === "" || isApplicationForSelfSelected ? /*#__PURE__*/React.createElement(Paper, {
    className: classes.subPaper,
    elevation: 0
  }, /*#__PURE__*/React.createElement(FormControl, {
    component: "fieldset"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6",
    className: "".concat(classes.title, " ").concat(classes.section)
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "workforce.application.for",
    module: "workforce"
  })), /*#__PURE__*/React.createElement(RadioGroup, {
    value: applicationForSelf,
    onChange: handleApplicationFor
  }, /*#__PURE__*/React.createElement(FormControlLabel, {
    value: "yes",
    control: /*#__PURE__*/React.createElement(Radio, {
      color: "primary"
    }),
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.application.for.type.self",
      module: "workforce"
    })
  }), /*#__PURE__*/React.createElement(FormControlLabel, {
    value: "no",
    control: /*#__PURE__*/React.createElement(Radio, {
      color: "primary"
    }),
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.application.for.type.dependent",
      module: "workforce"
    })
  }))), /*#__PURE__*/React.createElement("div", {
    className: classes.buttonContainer
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "contained",
    color: "primary",
    onClick: function onClick() {
      return setIsApplicationForSelfSelected(false);
    }
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.next"
  })))) : /*#__PURE__*/React.createElement(MedicalAssistanceForm, {
    workforceFactoryId: workforceFactoryId,
    modulesManager: modulesManager,
    organizationType: organizationType,
    parsedApplicationData: parsedApplicationData,
    selectedApplicationType: selectedApplicationType,
    applicationForSelf: applicationForSelf,
    selectedFactory: selectedFactory
  })) : selectedApplicationType === "maternityGrant" ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: classes.backButtonContainer
  }, /*#__PURE__*/React.createElement(IconButton, {
    onClick: handleBack,
    color: "primary"
  }, /*#__PURE__*/React.createElement(ArrowBackIcon, null)), /*#__PURE__*/React.createElement(Typography, {
    variant: "body1",
    className: classes.backText
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.back.application.type"
  }))), applicationForSelf === "" || isApplicationForSelfSelected ? /*#__PURE__*/React.createElement(Paper, {
    className: classes.subPaper,
    elevation: 0
  }, /*#__PURE__*/React.createElement(FormControl, {
    component: "fieldset"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6",
    className: "".concat(classes.title, " ").concat(classes.section)
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "workforce.application.for",
    module: "workforce"
  })), /*#__PURE__*/React.createElement(RadioGroup, {
    value: applicationForSelf,
    onChange: handleApplicationFor
  }, /*#__PURE__*/React.createElement(FormControlLabel, {
    value: "yes",
    control: /*#__PURE__*/React.createElement(Radio, {
      color: "primary"
    }),
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.application.for.type.self",
      module: "workforce"
    })
  }), /*#__PURE__*/React.createElement(FormControlLabel, {
    value: "no",
    control: /*#__PURE__*/React.createElement(Radio, {
      color: "primary"
    }),
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.application.for.type.dependent.mother",
      module: "workforce"
    })
  }))), /*#__PURE__*/React.createElement("div", {
    className: classes.buttonContainer
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "contained",
    color: "primary",
    onClick: function onClick() {
      return setIsApplicationForSelfSelected(false);
    }
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.next"
  })))) : /*#__PURE__*/React.createElement(MaternalGrantForm, {
    workforceFactoryId: workforceFactoryId,
    modulesManager: modulesManager,
    organizationType: organizationType,
    parsedApplicationData: parsedApplicationData,
    selectedApplicationType: selectedApplicationType,
    applicationForSelf: applicationForSelf,
    selectedFactory: selectedFactory
  })) : selectedApplicationType === "disabilityAssistance" ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: classes.backButtonContainer
  }, /*#__PURE__*/React.createElement(IconButton, {
    onClick: handleBack,
    color: "primary"
  }, /*#__PURE__*/React.createElement(ArrowBackIcon, null)), /*#__PURE__*/React.createElement(Typography, {
    variant: "body1",
    className: classes.backText
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.back.application.type"
  }))), /*#__PURE__*/React.createElement(DisabilityForm, {
    workforceFactoryId: workforceFactoryId,
    modulesManager: modulesManager,
    organizationType: organizationType,
    selectedApplicationType: selectedApplicationType,
    parsedApplicationData: parsedApplicationData,
    applicationForSelf: applicationForSelf,
    selectedFactory: selectedFactory
  })) : selectedApplicationType === "educationGrant" ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: classes.backButtonContainer
  }, /*#__PURE__*/React.createElement(IconButton, {
    onClick: handleBack,
    color: "primary"
  }, /*#__PURE__*/React.createElement(ArrowBackIcon, null)), /*#__PURE__*/React.createElement(Typography, {
    variant: "body1",
    className: classes.backText
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.back.application.type"
  }))), /*#__PURE__*/React.createElement(EducationGrantForm, {
    workforceFactoryId: workforceFactoryId,
    modulesManager: modulesManager,
    organizationType: organizationType,
    selectedApplicationType: selectedApplicationType,
    applicationForSelf: applicationForSelf,
    parsedApplicationData: parsedApplicationData,
    selectedFactory: selectedFactory
  })) : selectedApplicationType === "financialAssistance" ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: classes.backButtonContainer
  }, /*#__PURE__*/React.createElement(IconButton, {
    onClick: handleBack,
    color: "primary"
  }, /*#__PURE__*/React.createElement(ArrowBackIcon, null)), /*#__PURE__*/React.createElement(Typography, {
    variant: "body1",
    className: classes.backText
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.back.application.type"
  }))), /*#__PURE__*/React.createElement(FinancialAssistanceForm, {
    workforceFactoryId: workforceFactoryId,
    modulesManager: modulesManager,
    organizationType: organizationType,
    parsedApplicationData: parsedApplicationData,
    selectedApplicationType: selectedApplicationType,
    applicationForSelf: applicationForSelf,
    selectedFactory: selectedFactory
  })) : selectedApplicationType === "scholarship" ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: classes.backButtonContainer
  }, /*#__PURE__*/React.createElement(IconButton, {
    onClick: handleBack,
    color: "primary"
  }, /*#__PURE__*/React.createElement(ArrowBackIcon, null)), /*#__PURE__*/React.createElement(Typography, {
    variant: "body1",
    className: classes.backText
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.back.application.type"
  }))), applicationForSelf === "" || isApplicationForSelfSelected ? /*#__PURE__*/React.createElement(Paper, {
    className: classes.subPaper,
    elevation: 0
  }, /*#__PURE__*/React.createElement(FormControl, {
    component: "fieldset"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6",
    className: "".concat(classes.title, " ").concat(classes.section)
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "workforce.application.for",
    module: "workforce"
  })), /*#__PURE__*/React.createElement(RadioGroup, {
    value: applicationForSelf,
    onChange: handleApplicationFor
  }, /*#__PURE__*/React.createElement(FormControlLabel, {
    value: "yes",
    control: /*#__PURE__*/React.createElement(Radio, {
      color: "primary"
    }),
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.application.for.type.self",
      module: "workforce"
    })
  }), /*#__PURE__*/React.createElement(FormControlLabel, {
    value: "no",
    control: /*#__PURE__*/React.createElement(Radio, {
      color: "primary"
    }),
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.application.for.type.dependent.children",
      module: "workforce"
    })
  }))), /*#__PURE__*/React.createElement("div", {
    className: classes.buttonContainer
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "contained",
    color: "primary",
    onClick: function onClick() {
      return setIsApplicationForSelfSelected(false);
    }
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.next"
  })))) : /*#__PURE__*/React.createElement(ScholarshipApplicationForm, {
    workforceFactoryId: workforceFactoryId,
    modulesManager: modulesManager,
    organizationType: organizationType,
    selectedApplicationType: selectedApplicationType,
    applicationForSelf: applicationForSelf,
    parsedApplicationData: parsedApplicationData,
    selectedFactory: selectedFactory
  })) : selectedApplicationType === "deadlyGrant" ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: classes.backButtonContainer
  }, /*#__PURE__*/React.createElement(IconButton, {
    onClick: handleBack,
    color: "primary"
  }, /*#__PURE__*/React.createElement(ArrowBackIcon, null)), /*#__PURE__*/React.createElement(Typography, {
    variant: "body1",
    className: classes.backText
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.back.application.type"
  }))), /*#__PURE__*/React.createElement(DeadlyGrantForm, {
    workforceFactoryId: workforceFactoryId,
    modulesManager: modulesManager,
    organizationType: organizationType,
    parsedApplicationData: parsedApplicationData,
    selectedApplicationType: selectedApplicationType,
    applicationForSelf: applicationForSelf,
    selectedFactory: selectedFactory
  })) : /*#__PURE__*/React.createElement("div", null, "Please select an application type")));
};

function _callSuper$j(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$j() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$j() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$j = function _isNativeReflectConstruct() { return !!t; })(); }
var styles$k = function styles(theme) {
  return {
    dialogTitle: theme.dialog.title,
    dialogContent: theme.dialog.content,
    form: {
      padding: 0
    },
    item: {
      padding: theme.spacing(1)
    },
    paperDivider: theme.paper.divider
  };
};
var APPLICATION_PROCESS_FILTER_CONTRIBUTION_KEY = "application.process.Filter";
var ApplicationProcessFilter = /*#__PURE__*/function (_Component) {
  function ApplicationProcessFilter() {
    var _this;
    _classCallCheck(this, ApplicationProcessFilter);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper$j(this, ApplicationProcessFilter, [].concat(args));
    _defineProperty(_this, "debouncedOnChangeFilter", _debounce(_this.props.onChangeFilters, 800));
    _defineProperty(_this, "_filterValue", function (k) {
      var filters = _this.props.filters;
      return !!filters && !!filters[k] ? filters[k].value : null;
    });
    _defineProperty(_this, "_onChangeReporter", function (k, v) {
      _this.props.onChangeFilters([{
        id: k,
        value: v,
        filter: "".concat(k, ": \"").concat(decodeId(v === null || v === void 0 ? void 0 : v.id), "\"")
      }]);
    });
    _defineProperty(_this, "_onChangeCheckbox", function (key, value) {
      var filters = [{
        id: key,
        value: value,
        filter: "".concat(key, ": ").concat(value)
      }];
      _this.props.onChangeFilters(filters);
      _this.props.setShowHistoryFilter(value);
    });
    return _this;
  }
  _inherits(ApplicationProcessFilter, _Component);
  return _createClass(ApplicationProcessFilter, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        classes = _this$props.classes,
        filters = _this$props.filters,
        onChangeFilters = _this$props.onChangeFilters;
      var userType = getUserTypeFromRights(this.props.userRights);
      var type = (userType === null || userType === void 0 ? void 0 : userType.toLowerCase()) || "";
      var selectedOrgType = userType === WORKFORCE_USER_TYPE.BLWF_CHECKER || userType === WORKFORCE_USER_TYPE.BLWF_DOL_DIFE ? "blwf" : this._filterValue("organizationType") || "";
      var applicationTypeOptions = [];
      if (selectedOrgType === "eis") {
        applicationTypeOptions = eisApplicationTypeOptions;
      } else if (selectedOrgType === "blwf") {
        applicationTypeOptions = blwfApplicationTypeOptions;
      } else if (selectedOrgType === "cf") {
        applicationTypeOptions = cfApplicationTypeOptions;
      }
      var asociationOptions;
      if (isEisPath()) {
        asociationOptions = eisAssociationOptions;
      } else {
        asociationOptions = cfAssociationOptions;
      }
      var statusOptions;
      if (isEisPath()) {
        statusOptions = eisStatusOptions;
      } else if (type.includes("blwf")) {
        statusOptions = blwfStatusOptions;
      } else {
        statusOptions = cfStatusOptions;
      }
      return /*#__PURE__*/React.createElement(Grid, {
        container: true,
        className: classes.form
      }, userType.toLowerCase().includes("association") && /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 3,
        className: classes.item
      }, /*#__PURE__*/React.createElement(ControlledField, {
        module: MODULE_NAME,
        id: "workforce.employee.application.organizationType",
        field: /*#__PURE__*/React.createElement(FormControl, {
          fullWidth: true
        }, /*#__PURE__*/React.createElement(InputLabel, {
          id: "org-type-select-label"
        }, /*#__PURE__*/React.createElement(FormattedMessage, {
          id: "workforce.employee.application.organizationType",
          defaultMessage: "Organization Type"
        })), /*#__PURE__*/React.createElement(Select, {
          labelId: "org-type-select-label",
          id: "org-type-select",
          label: "workforce.employee.application.organizationType",
          value: this._filterValue("organizationType") || "",
          onChange: function onChange(e) {
            return _this2.debouncedOnChangeFilter([{
              id: "organizationType",
              value: e.target.value,
              filter: "organizationTypeIn: [\"".concat(e.target.value, "\"]")
            },
            // Clear the application type so old options aren't left behind
            {
              id: "applicationType",
              value: "",
              filter: ""
            }]);
          }
        }, organizationTypeOptions.map(function (opt) {
          return /*#__PURE__*/React.createElement(MenuItem, {
            key: opt.value,
            value: opt.value
          }, opt.label);
        })))
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 3,
        className: classes.item
      }, /*#__PURE__*/React.createElement(ControlledField, {
        module: MODULE_NAME,
        id: "workforce.employee.application.applicationType",
        field: /*#__PURE__*/React.createElement(FormControl, {
          fullWidth: true
        }, /*#__PURE__*/React.createElement(InputLabel, {
          id: "app-type-select-label"
        }, /*#__PURE__*/React.createElement(FormattedMessage, {
          id: "workforce.employee.application.applicationType",
          defaultMessage: "Application Type"
        })), /*#__PURE__*/React.createElement(Select, {
          labelId: "app-type-select-label",
          id: "app-type-select",
          label: "workforce.employee.application.applicationType",
          value: this._filterValue("applicationType") || "",
          disabled: !selectedOrgType // Disables dropdown if no Organization Type is selected
          ,
          onChange: function onChange(e) {
            return _this2.debouncedOnChangeFilter([{
              id: "applicationType",
              value: e.target.value,
              filter: "applicationTypeIn: [\"".concat(e.target.value, "\"]")
            }]);
          }
        }, applicationTypeOptions.map(function (opt) {
          return /*#__PURE__*/React.createElement(MenuItem, {
            key: opt.value,
            value: opt.value
          }, opt.label);
        })))
      })), userType.toLowerCase().includes("eis") && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ControlledField, {
        module: MODULE_NAME,
        id: "workforce.employee.application.associationType",
        field: /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 3,
          className: classes.item
        }, /*#__PURE__*/React.createElement(FormControl, {
          variant: "outlined",
          fullWidth: true
        }, /*#__PURE__*/React.createElement(InputLabel, null, /*#__PURE__*/React.createElement(FormattedMessage, {
          id: "workforce.employee.application.associationType",
          defaultMessage: "Application Type"
        })), /*#__PURE__*/React.createElement(Select, {
          label: "workforce.employee.application.associationType",
          value: this._filterValue("associationType") || "",
          onChange: function onChange(e) {
            return _this2.debouncedOnChangeFilter([{
              id: "associationType",
              value: e.target.value,
              filter: "associationTypeIn: [\"".concat(e.target.value, "\"]")
            }]);
          }
        }, asociationOptions.map(function (opt) {
          return /*#__PURE__*/React.createElement(MenuItem, {
            key: opt.value,
            value: opt.value
          }, opt.label);
        }))))
      }), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 3,
        className: classes.item
      }, /*#__PURE__*/React.createElement(PublishedComponent, {
        pubRef: "workforce.DatePicker",
        label: "workforce.application.startDate",
        value: this._filterValue("dateCreatedFrom") || "",
        onChange: function onChange(v) {
          return _this2.debouncedOnChangeFilter([{
            id: "dateCreatedFrom",
            value: v,
            filter: "dateCreatedFrom: \"".concat(v, "\"")
          }]);
        },
        readOnly: false
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 3,
        className: classes.item
      }, /*#__PURE__*/React.createElement(PublishedComponent, {
        pubRef: "workforce.DatePicker",
        label: "workforce.application.endDate",
        value: this._filterValue("dateCreatedTo") || "",
        onChange: function onChange(v) {
          return _this2.debouncedOnChangeFilter([{
            id: "dateCreatedTo",
            value: v,
            filter: "dateCreatedTo: \"".concat(v, "\"")
          }]);
        },
        readOnly: false
      }))), userType === WORKFORCE_USER_TYPE.EIS_COORDINATOR && /*#__PURE__*/React.createElement(ControlledField, {
        module: MODULE_NAME,
        id: "workforce.employee.application.status",
        field: /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 3,
          className: classes.item
        }, /*#__PURE__*/React.createElement(FormControl, {
          variant: "outlined",
          fullWidth: true
        }, /*#__PURE__*/React.createElement(InputLabel, null, /*#__PURE__*/React.createElement(FormattedMessage, {
          id: "workforce.employee.application.status",
          defaultMessage: "Status"
        })), /*#__PURE__*/React.createElement(Select, {
          label: "workforce.employee.application.status",
          value: this._filterValue("status") || "",
          onChange: function onChange(e) {
            return _this2.debouncedOnChangeFilter([{
              id: "status",
              value: e.target.value,
              filter: "statusIn: [\"".concat(e.target.value, "\"]")
            }]);
          }
        }, statusOptions.map(function (opt) {
          return /*#__PURE__*/React.createElement(MenuItem, {
            key: opt.value,
            value: opt.value
          }, opt.label);
        }))))
      }), userType === WORKFORCE_USER_TYPE.FACTORY_ADMIN && /*#__PURE__*/React.createElement(ControlledField, {
        mt: 3,
        module: MODULE_NAME,
        id: "workforce.application.submittedBy",
        field: /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 3,
          className: classes.item
        }, /*#__PURE__*/React.createElement(FormControl, {
          variant: "outlined",
          fullWidth: true
        }, /*#__PURE__*/React.createElement(InputLabel, null, /*#__PURE__*/React.createElement(FormattedMessage, {
          id: "workforce.application.submittedBy",
          defaultMessage: "Submitted By"
        })), /*#__PURE__*/React.createElement(Select, {
          label: "workforce.application.submittedBy",
          value: this._filterValue("submittedBy") || "",
          onChange: function onChange(e) {
            return _this2.debouncedOnChangeFilter([{
              id: "submittedBy",
              value: e.target.value,
              filter: "submittedByIn: \"".concat(e.target.value, "\"")
            }]);
          }
        }, submittedByOptions.map(function (opt) {
          return /*#__PURE__*/React.createElement(MenuItem, {
            key: opt.value,
            value: opt.value
          }, opt.label);
        }))))
      }), /*#__PURE__*/React.createElement(Contributions, {
        filters: filters,
        onChangeFilters: onChangeFilters,
        contributionKey: APPLICATION_PROCESS_FILTER_CONTRIBUTION_KEY
      }));
    }
  }]);
}(Component);
var ApplicationProcessFilter$1 = withModulesManager(withTheme(withStyles(styles$k)(ApplicationProcessFilter)));

var ForwardApplicationModal = function ForwardApplicationModal(_ref) {
  var _selectedApplication$, _officeData$selectedO2;
  var open = _ref.open,
    onClose = _ref.onClose,
    selectedApplication = _ref.selectedApplication,
    _ref$officeData = _ref.officeData,
    officeData = _ref$officeData === void 0 ? {} : _ref$officeData;
    _ref.onSubmitForward;
  var dispatch = useDispatch();
  useModulesManager();
  var _useState = useState(""),
    _useState2 = _slicedToArray(_useState, 2),
    editorContent = _useState2[0],
    setEditorContent = _useState2[1];
  var _useState3 = useState(""),
    _useState4 = _slicedToArray(_useState3, 2),
    selectedOffice = _useState4[0],
    setSelectedOffice = _useState4[1];
  var _useState5 = useState(""),
    _useState6 = _slicedToArray(_useState5, 2),
    selectedSuboffice = _useState6[0],
    setSelectedSuboffice = _useState6[1];
  var _useState7 = useState(""),
    _useState8 = _slicedToArray(_useState7, 2),
    selectedUser = _useState8[0],
    setSelectedUser = _useState8[1];
  var _useState9 = useState(false),
    _useState10 = _slicedToArray(_useState9, 2),
    submitting = _useState10[0],
    setSubmitting = _useState10[1];
  var _useState11 = useState(null),
    _useState12 = _slicedToArray(_useState11, 2),
    serverResponse = _useState12[0],
    setServerResponse = _useState12[1];
  var _useState13 = useState({
      nameBn: "সাবমিশনের ডকুমেন্ট",
      fieldId: "supporting_doc"
    }),
    _useState14 = _slicedToArray(_useState13, 2),
    document = _useState14[0];
    _useState14[1];

  // Reset modal state on close
  useEffect(function () {
    if (!open) {
      setEditorContent("");
      setSelectedOffice("");
      setSelectedSuboffice("");
      setSelectedUser("");
      setSubmitting(false);
      setServerResponse(null);
    }
  }, [open]);
  var handleOfficeChange = function handleOfficeChange(e) {
    var office = e.target.value;
    setSelectedOffice(office);
    setSelectedSuboffice("");
    setSelectedUser("");
  };
  var handleSubofficeChange = function handleSubofficeChange(e) {
    var _officeData$selectedO;
    var suboffice = e.target.value;
    setSelectedSuboffice(suboffice);
    var user = ((_officeData$selectedO = officeData[selectedOffice]) === null || _officeData$selectedO === void 0 || (_officeData$selectedO = _officeData$selectedO.suboffices) === null || _officeData$selectedO === void 0 ? void 0 : _officeData$selectedO[suboffice]) || "ইউজার খুঁজে পাওয়া যায়নি";
    setSelectedUser(user);
  };
  var handleSubmit = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(e) {
      var updateApplicationData;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            // e.preventDefault();
            // setSubmitting(true);
            // const payload = {
            //   comment: editorContent,
            //   office: selectedOffice,
            //   suboffice: selectedSuboffice,
            //   user: selectedUser,
            // };
            // try {
            //   const response = await onSubmitForward(payload); // expects a promise
            //   setServerResponse(response);
            // } catch (error) {
            //   setServerResponse({ status: "ERROR", message: "সাবমিশনে ব্যর্থ হয়েছে।" });
            // } finally {
            //   setSubmitting(false);
            // }
            updateApplicationData = {
              id: decodeId(selectedApplication.id),
              status: WORKFORCE_STATUS.SECOND_FORWARD
            };
            dispatch(updateApplication(updateApplicationData, "update workforce application ".concat(selectedApplication.workforceEmployee.firstNameEn)));
          case 2:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function handleSubmit(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  useEffect(function () {
    if ((serverResponse === null || serverResponse === void 0 ? void 0 : serverResponse.status) === "SUCCESS") {
      setTimeout(function () {
        window.location.reload();
      }, 2000);
    }
  }, [serverResponse]);
  return /*#__PURE__*/React.createElement(Modal, {
    open: open,
    onClose: onClose,
    "aria-labelledby": "forward-modal-title",
    "aria-describedby": "forward-modal-description"
  }, /*#__PURE__*/React.createElement(Box$1, {
    sx: {
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      width: 850,
      height: 700,
      bgcolor: "background.paper",
      borderRadius: 2,
      boxShadow: 24,
      p: 4,
      overflow: "auto"
    }
  }, /*#__PURE__*/React.createElement(Box$1, {
    style: {
      position: "absolute",
      top: 8,
      right: 8
    }
  }, /*#__PURE__*/React.createElement(Button, {
    size: "large",
    onClick: onClose
  }, "\u2715")), /*#__PURE__*/React.createElement(Typography, {
    id: "forward-modal-title",
    variant: "h6",
    component: "h2"
  }, "\u09AB\u09B0\u0993\u09DF\u09BE\u09B0\u09CD\u09A1 \u0985\u09CD\u09AF\u09BE\u09AA\u09CD\u09B2\u09BF\u0995\u09C7\u09B6\u09A8"), /*#__PURE__*/React.createElement(Typography, {
    id: "forward-modal-description",
    sx: {
      mt: 2
    }
  }, selectedApplication && "".concat((selectedApplication === null || selectedApplication === void 0 || (_selectedApplication$ = selectedApplication.workforceEmployee) === null || _selectedApplication$ === void 0 ? void 0 : _selectedApplication$.firstNameBn) || "আবেদনকারী", " \u098F\u09B0 \u0986\u09AC\u09C7\u09A6\u09A8 \u09AB\u09C7\u09B0\u09A4 \u09AA\u09BE\u09A0\u09BE\u09A4\u09C7 \u099A\u09BE\u09A8?")), /*#__PURE__*/React.createElement(Box$1, {
    component: "form",
    onSubmit: handleSubmit,
    sx: {
      mt: 3
    }
  }, (serverResponse === null || serverResponse === void 0 ? void 0 : serverResponse.status) === "SUCCESS" && /*#__PURE__*/React.createElement(Typography, {
    sx: {
      mb: 2,
      color: "green",
      fontWeight: "bold"
    }
  }, "\u2705 ", serverResponse.message), /*#__PURE__*/React.createElement(Box$1, {
    sx: {
      display: "flex",
      flexDirection: "column",
      gap: 2,
      mb: 3
    }
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.application.reasons.addComment"
  }), /*#__PURE__*/React.createElement(Box$1, {
    sx: {
      width: "100%",
      mb: 7
    }
  }, /*#__PURE__*/React.createElement(ReactQuill, {
    value: editorContent,
    onChange: setEditorContent,
    theme: "snow",
    style: {
      height: "150px"
    }
  })), /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.application.reasons.selectedOfficer"
  }), /*#__PURE__*/React.createElement(Box$1, {
    sx: {
      mb: 7
    }
  }, /*#__PURE__*/React.createElement(FormControl, {
    fullWidth: true,
    sx: {
      mb: 3
    }
  }, /*#__PURE__*/React.createElement(InputLabel, {
    id: "office-select-label"
  }, "\u0985\u09AB\u09BF\u09B8 \u09A8\u09BF\u09B0\u09CD\u09AC\u09BE\u099A\u09A8 \u0995\u09B0\u09C1\u09A8"), /*#__PURE__*/React.createElement(Select, {
    labelId: "office-select-label",
    value: selectedOffice,
    onChange: handleOfficeChange,
    required: true
  }, Object.keys(officeData).map(function (office) {
    return /*#__PURE__*/React.createElement(MenuItem, {
      key: office,
      value: office
    }, office);
  }))), selectedOffice && /*#__PURE__*/React.createElement(FormControl, {
    fullWidth: true,
    sx: {
      mb: 3
    }
  }, /*#__PURE__*/React.createElement(InputLabel, {
    id: "suboffice-select-label"
  }, "\u09B8\u09BE\u09AC\u0985\u09AB\u09BF\u09B8 \u09A8\u09BF\u09B0\u09CD\u09AC\u09BE\u099A\u09A8 \u0995\u09B0\u09C1\u09A8"), /*#__PURE__*/React.createElement(Select, {
    labelId: "suboffice-select-label",
    value: selectedSuboffice,
    onChange: handleSubofficeChange,
    required: true
  }, Object.keys(((_officeData$selectedO2 = officeData[selectedOffice]) === null || _officeData$selectedO2 === void 0 ? void 0 : _officeData$selectedO2.suboffices) || {}).map(function (suboffice) {
    return /*#__PURE__*/React.createElement(MenuItem, {
      key: suboffice,
      value: suboffice
    }, suboffice);
  }))), selectedSuboffice && selectedUser && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography, {
    sx: {
      mt: 2
    }
  }, selectedSuboffice, " \u098F\u09B0 \u099C\u09A8\u09CD\u09AF \u0987\u0989\u099C\u09BE\u09B0:"), /*#__PURE__*/React.createElement(Typography, {
    sx: {
      fontWeight: "bold",
      color: "green"
    }
  }, selectedUser))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    sx: {
      mt: 7,
      borderBottom: "1px solid #ccc",
      pb: 1
    }
  }, /*#__PURE__*/React.createElement(Typography, {
    fontWeight: "bold"
  }, "\u0987\u09A4\u0983\u09AA\u09C2\u09B0\u09CD\u09AC\u09C7\u09B0 \u09B8\u0982\u09AF\u09C1\u0995\u09CD\u09A4\u09BF\u09B8\u09AE\u09C2\u09B9")), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    sx: {
      mt: 7
    }
  }, /*#__PURE__*/React.createElement(Typography, null, "\u09AB\u09BE\u0987\u09B2 \u09AF\u09C1\u0995\u09CD\u09A4 \u0995\u09B0\u09C1\u09A8... ", document.nameBn), /*#__PURE__*/React.createElement(FileUploader, {
    fieldKey: document.fieldId
  }))), /*#__PURE__*/React.createElement(Box$1, {
    style: {
      marginTop: 2,
      display: "flex",
      gap: 2,
      justifyContent: 'space-between'
    }
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: onClose,
    variant: "outlined",
    color: "error"
  }, "\u09AC\u09A8\u09CD\u09A7 \u0995\u09B0\u09C1\u09A8"), /*#__PURE__*/React.createElement(Button, {
    type: "submit",
    variant: "contained",
    color: "primary",
    disabled: submitting
  }, submitting ? "ফরওয়ার্ড করা হচ্ছে..." : "ফরওয়ার্ড করুন")))));
};

var DistrictOfficePicker = function DistrictOfficePicker(_ref) {
  var modulesManager = _ref.modulesManager,
    _onChange = _ref.onChange,
    readOnly = _ref.readOnly,
    required = _ref.required,
    _ref$withLabel = _ref.withLabel,
    withLabel = _ref$withLabel === void 0 ? true : _ref$withLabel,
    withPlaceholder = _ref.withPlaceholder,
    value = _ref.value,
    label = _ref.label,
    placeholder = _ref.placeholder,
    filterOptions = _ref.filterOptions,
    filterSelectedOptions = _ref.filterSelectedOptions,
    multiple = _ref.multiple,
    officeType = _ref.officeType;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2);
    _useState2[0];
    var setSearchString = _useState2[1];
  var _useTranslations = useTranslations("workforce"),
    formatMessage = _useTranslations.formatMessage;
  var dispatch = useDispatch();
  useEffect(function () {
    var officeFilter = ["type:\"".concat(officeType, "\"")];
    return dispatch(fetchDistrictOfficePick(modulesManager, officeFilter));
  }, [officeType]);
  var isLoading = useSelector(function (state) {
    return state.workforce["fetchingDistrictOfficePick"];
  });
  var data = useSelector(function (state) {
    var _state$workforce;
    return (_state$workforce = state.workforce["districtOfficePick"]) !== null && _state$workforce !== void 0 ? _state$workforce : [];
  });
  var error = useSelector(function (state) {
    return state.workforce["errorDistrictOfficePick"];
  });
  var selectedOption = useMemo(function () {
    return data.find(function (option) {
      return option.id === value;
    }) || null;
  }, [value]);
  return /*#__PURE__*/React.createElement(Autocomplete, {
    multiple: multiple,
    required: required,
    placeholder: placeholder !== null && placeholder !== void 0 ? placeholder : "",
    label: label !== null && label !== void 0 ? label : formatMessage("workforce.officeType.selector.picker"),
    error: error,
    withLabel: withLabel,
    withPlaceholder: withPlaceholder,
    readOnly: readOnly,
    options: data,
    isLoading: isLoading,
    value: selectedOption,
    getOptionLabel: function getOptionLabel(option) {
      return "".concat(option.nameEn);
    },
    onChange: function onChange(option) {
      return _onChange(option, option ? "".concat(option) : null);
    },
    filterOptions: filterOptions,
    filterSelectedOptions: filterSelectedOptions,
    onInputChange: setSearchString
  });
};

var EmployeePicker = function EmployeePicker(_ref) {
  var _organizationEmployee;
  var modulesManager = _ref.modulesManager,
    _onChange = _ref.onChange,
    readOnly = _ref.readOnly,
    required = _ref.required,
    _ref$withLabel = _ref.withLabel,
    withLabel = _ref$withLabel === void 0 ? true : _ref$withLabel,
    withPlaceholder = _ref.withPlaceholder,
    value = _ref.value,
    label = _ref.label,
    placeholder = _ref.placeholder,
    filterOptions = _ref.filterOptions,
    filterSelectedOptions = _ref.filterSelectedOptions,
    multiple = _ref.multiple,
    organizationEmployee = _ref.organizationEmployee;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2);
    _useState2[0];
    var setSearchString = _useState2[1];
  var organizationId = organizationEmployee === null || organizationEmployee === void 0 || (_organizationEmployee = organizationEmployee.designations) === null || _organizationEmployee === void 0 || (_organizationEmployee = _organizationEmployee[0]) === null || _organizationEmployee === void 0 || (_organizationEmployee = _organizationEmployee.designation) === null || _organizationEmployee === void 0 || (_organizationEmployee = _organizationEmployee.unit) === null || _organizationEmployee === void 0 || (_organizationEmployee = _organizationEmployee.organization) === null || _organizationEmployee === void 0 ? void 0 : _organizationEmployee.id;
  var _useTranslations = useTranslations("workforce"),
    formatMessage = _useTranslations.formatMessage;
  var dispatch = useDispatch();
  var employeeData = useSelector(function (state) {
    var _state$workforce$orga;
    return (_state$workforce$orga = state.workforce["organizationEmployees"]) !== null && _state$workforce$orga !== void 0 ? _state$workforce$orga : [];
  });
  var isLoading = useSelector(function (state) {
    return state.workforce["fetchingOrganizationEmployees"];
  });
  useSelector(function (state) {
    return state.workforce["errorOrganizationEmployees"];
  });
  useEffect(function () {
    if (organizationId) {
      dispatch(fetchOrganizationEmployeesSummary(modulesManager, ["designations_Designation_Organization_Id:\"".concat(decodeId(organizationId), "\"")]));
    } else {
      dispatch(fetchOrganizationEmployee(modulesManager, []));
    }
  }, [dispatch, modulesManager, organizationId]);
  var selectedOption = useMemo(function () {
    return (employeeData === null || employeeData === void 0 ? void 0 : employeeData.find(function (option) {
      return option.id === value;
    })) || null;
  }, [value, employeeData]);
  console.log("OrganizationEmployeeData", employeeData);
  return /*#__PURE__*/React.createElement(Autocomplete, {
    multiple: multiple,
    required: required,
    placeholder: placeholder !== null && placeholder !== void 0 ? placeholder : "",
    label: label !== null && label !== void 0 ? label : formatMessage("workforce.organization.parent"),
    withLabel: withLabel,
    withPlaceholder: withPlaceholder,
    readOnly: readOnly,
    options: employeeData,
    isLoading: isLoading,
    value: selectedOption,
    getOptionLabel: function getOptionLabel(option) {
      return "".concat(option.nameEn);
    },
    onChange: function onChange(option) {
      return _onChange(option, option ? "".concat(option) : null);
    },
    filterOptions: filterOptions,
    filterSelectedOptions: filterSelectedOptions,
    onInputChange: setSearchString
  });
};

var useStyles$_ = makeStyles(function (theme) {
  return {
    modalContainer: {
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      width: 700,
      maxHeight: "90vh",
      backgroundColor: theme.palette.background.paper,
      borderRadius: theme.spacing(1.5),
      boxShadow: theme.shadows[5],
      padding: theme.spacing(4),
      overflowY: "auto"
    },
    closeButton: {
      position: "absolute",
      top: theme.spacing(1),
      right: theme.spacing(1),
      minWidth: 0,
      padding: theme.spacing(0.5, 1),
      fontSize: "1.2rem"
    },
    sectionPaper: {
      padding: theme.spacing(3),
      marginBottom: theme.spacing(3),
      borderRadius: theme.spacing(1),
      backgroundColor: theme.palette.grey[50]
    },
    buttonGroup: {
      marginTop: theme.spacing(3),
      display: "flex",
      justifyContent: "flex-end",
      gap: theme.spacing(2)
    },
    responseMessage: {
      marginBottom: theme.spacing(2),
      fontWeight: 600
    }
  };
});
var ForwardAdminPanel = function ForwardAdminPanel(_ref) {
  var open = _ref.open,
    onClose = _ref.onClose,
    selectedApplication = _ref.selectedApplication,
    onSubmitForward = _ref.onSubmitForward;
  var classes = useStyles$_();
  var dispatch = useDispatch();
  var modulesManager = useModulesManager();
  var _useState = useState(""),
    _useState2 = _slicedToArray(_useState, 2),
    editorContent = _useState2[0],
    setEditorContent = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    submitting = _useState4[0],
    setSubmitting = _useState4[1];
  var _useState5 = useState(null),
    _useState6 = _slicedToArray(_useState5, 2),
    serverResponse = _useState6[0],
    setServerResponse = _useState6[1];
  var _useState7 = useState(""),
    _useState8 = _slicedToArray(_useState7, 2),
    officeType = _useState8[0],
    setOfficeType = _useState8[1];
  var _useState9 = useState(""),
    _useState10 = _slicedToArray(_useState9, 2),
    employeeType = _useState10[0],
    setEmployeeType = _useState10[1];
  var _useState11 = useState(null),
    _useState12 = _slicedToArray(_useState11, 2),
    formData = _useState12[0],
    setFormData = _useState12[1];
  useEffect(function () {
    if (!open) {
      setEditorContent("");
      setSubmitting(false);
      setServerResponse(null);
      setFormData(null);
    }
    if (selectedApplication) {
      return dispatch(fetchApplication(modulesManager, ["id: \"".concat(decodeId(selectedApplication === null || selectedApplication === void 0 ? void 0 : selectedApplication.id), "\"")]));
    }
  }, [open]);
  var data = useSelector(function (state) {
    var _state$workforce;
    return (_state$workforce = state.workforce["application"]) !== null && _state$workforce !== void 0 ? _state$workforce : [];
  });
  var handleSubmit = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(e) {
      var payload, response;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            e.preventDefault();
            setSubmitting(true);
            payload = {
              comment: editorContent,
              destinationOffice: formData
            };
            _context.prev = 3;
            _context.next = 6;
            return onSubmitForward(payload);
          case 6:
            response = _context.sent;
            setServerResponse(response);
            _context.next = 13;
            break;
          case 10:
            _context.prev = 10;
            _context.t0 = _context["catch"](3);
            setServerResponse({
              status: "ERROR",
              message: "সাবমিশনে ব্যর্থ হয়েছে।"
            });
          case 13:
            _context.prev = 13;
            setSubmitting(false);
            return _context.finish(13);
          case 16:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[3, 10, 13, 16]]);
    }));
    return function handleSubmit(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  var handleApplicationReason = function handleApplicationReason(event) {
    var value = event.target.value;
    setOfficeType(value);
  };
  var handleInternalForward = function handleInternalForward(event) {
    var value = event.target.value;
    setEmployeeType(value);
  };
  var handleForward = function handleForward() {
    var updateApplicationData = {
      id: decodeId(selectedApplication.id),
      status: WORKFORCE_STATUS$1.SECOND_FORWARD
    };
    dispatch(updateApplication(updateApplicationData, "update workforce application ".concat(selectedApplication.workforceEmployee.firstNameEn)));
  };
  console.log({
    aha: data
  });
  useEffect(function () {
    if ((serverResponse === null || serverResponse === void 0 ? void 0 : serverResponse.status) === "SUCCESS") {
      setTimeout(function () {
        window.location.reload();
      }, 2000);
    }
  }, [serverResponse]);
  return /*#__PURE__*/React.createElement(Modal, {
    open: open,
    onClose: onClose
  }, /*#__PURE__*/React.createElement("form", {
    className: classes.modalContainer,
    onSubmit: handleSubmit
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: onClose,
    className: classes.closeButton
  }, "\u2715"), /*#__PURE__*/React.createElement(Typography, {
    variant: "h5",
    gutterBottom: true,
    style: {
      fontWeight: "bold",
      marginTop: 3,
      textAlign: "center"
    }
  }, "\u09AC\u09BF\u09AD\u09BE\u0997\u09C0\u09AF\u09BC \u09AC\u09BE \u099C\u09C7\u09B2\u09BE \u0985\u09AB\u09BF\u09B8\u09C7 \u09AA\u09BE\u09A0\u09BE\u09A8"), /*#__PURE__*/React.createElement(Typography, {
    variant: "body1",
    color: "textSecondary",
    gutterBottom: true,
    style: {
      fontWeight: 600,
      marginTop: 3,
      textAlign: "center"
    }
  }), (serverResponse === null || serverResponse === void 0 ? void 0 : serverResponse.status) && /*#__PURE__*/React.createElement(Typography, {
    className: classes.responseMessage,
    style: {
      color: serverResponse.status === "SUCCESS" ? "green" : "red"
    }
  }, serverResponse.status === "SUCCESS" ? "✅" : "⚠️", " ", serverResponse.message), /*#__PURE__*/React.createElement(Divider, {
    style: {
      marginBottom: 24
    }
  }), /*#__PURE__*/React.createElement(Paper, {
    className: classes.sectionPaper,
    elevation: 1
  }, /*#__PURE__*/React.createElement(FormControl, {
    component: "fieldset",
    className: classes.formSection
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body1",
    className: "".concat(classes.title, " ").concat(classes.section)
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "workforce.office.type",
    module: "workforce"
  })), /*#__PURE__*/React.createElement(RadioGroup, {
    value: officeType,
    onChange: handleApplicationReason
  }, /*#__PURE__*/React.createElement(FormControlLabel, {
    value: "dol",
    control: /*#__PURE__*/React.createElement(Radio, {
      color: "primary"
    }),
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.office.dol",
      module: "workforce"
    })
  }), /*#__PURE__*/React.createElement(FormControlLabel, {
    value: "dife",
    control: /*#__PURE__*/React.createElement(Radio, {
      color: "primary"
    }),
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.office.dife",
      module: "workforce"
    })
  }))), officeType && /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 3
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle1",
    gutterBottom: true,
    style: {
      fontWeight: "bold",
      marginTop: 3,
      textAlign: "center"
    }
  }, "\u0985\u09AB\u09BF\u09B8 \u09A8\u09BF\u09B0\u09CD\u09AC\u09BE\u099A\u09A8"), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 12
  }, /*#__PURE__*/React.createElement(DistrictOfficePicker, {
    value: formData === null || formData === void 0 ? void 0 : formData.id,
    officeType: officeType,
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.officeType.selector.picker",
      module: "workforce"
    }),
    required: true,
    onChange: function onChange(v) {
      return setFormData(v);
    }
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 12
  }, /*#__PURE__*/React.createElement(EmployeePicker, {
    value: employeeType === null || employeeType === void 0 ? void 0 : employeeType.id,
    employeeType: employeeType,
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.EmployeeType.selector.picker",
      module: "workforce"
    }),
    required: true,
    onChange: function onChange(v) {
      return handleInternalForward(v);
    }
  })))), /*#__PURE__*/React.createElement("div", {
    className: classes.buttonGroup
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: onClose,
    variant: "outlined",
    color: "secondary"
  }, "\u09AC\u09BE\u09A4\u09BF\u09B2 \u0995\u09B0\u09C1\u09A8"), /*#__PURE__*/React.createElement(Button, {
    type: "submit",
    variant: "contained",
    color: "primary",
    disabled: submitting,
    onClick: handleForward
  }, submitting ? "ফরওয়ার্ড করা হচ্ছে..." : "ফরওয়ার্ড করুন"))));
};

var useStyles$Z = makeStyles(function (theme) {
  return {
    modalContainer: {
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      width: 700,
      maxHeight: "90vh",
      backgroundColor: theme.palette.background.paper,
      borderRadius: theme.spacing(1.5),
      boxShadow: theme.shadows[5],
      padding: theme.spacing(4),
      overflowY: "auto"
    },
    closeButton: {
      position: "absolute",
      top: theme.spacing(1),
      right: theme.spacing(1),
      minWidth: 0,
      padding: theme.spacing(0.5, 1),
      fontSize: "1.2rem"
    },
    sectionPaper: {
      padding: theme.spacing(3),
      marginBottom: theme.spacing(3),
      borderRadius: theme.spacing(1),
      backgroundColor: theme.palette.grey[50]
    },
    buttonGroup: {
      marginTop: theme.spacing(3),
      display: "flex",
      justifyContent: "flex-end",
      gap: theme.spacing(2)
    },
    responseMessage: {
      marginBottom: theme.spacing(2),
      fontWeight: 600
    }
  };
});
var ForwardApplicationAdminModal = function ForwardApplicationAdminModal(_ref) {
  var open = _ref.open,
    onClose = _ref.onClose,
    selectedApplication = _ref.selectedApplication,
    onSubmitForward = _ref.onSubmitForward;
  var classes = useStyles$Z();
  var dispatch = useDispatch();
  var modulesManager = useModulesManager();
  var _useState = useState(""),
    _useState2 = _slicedToArray(_useState, 2),
    editorContent = _useState2[0],
    setEditorContent = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    submitting = _useState4[0],
    setSubmitting = _useState4[1];
  var _useState5 = useState(null),
    _useState6 = _slicedToArray(_useState5, 2),
    serverResponse = _useState6[0],
    setServerResponse = _useState6[1];
  var _useState7 = useState(""),
    _useState8 = _slicedToArray(_useState7, 2),
    officeType = _useState8[0],
    setOfficeType = _useState8[1];
  var _useState9 = useState(null),
    _useState10 = _slicedToArray(_useState9, 2),
    formData = _useState10[0],
    setFormData = _useState10[1];
  useEffect(function () {
    if (!open) {
      setEditorContent("");
      setSubmitting(false);
      setServerResponse(null);
      setFormData(null);
    }
    if (selectedApplication) {
      return dispatch(fetchApplication(modulesManager, ["id: \"".concat(decodeId(selectedApplication === null || selectedApplication === void 0 ? void 0 : selectedApplication.id), "\"")]));
    }
  }, [open]);
  useSelector(function (state) {
    var _state$workforce;
    return (_state$workforce = state.workforce["application"]) !== null && _state$workforce !== void 0 ? _state$workforce : [];
  });
  var handleSubmit = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(e) {
      var payload, response;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            e.preventDefault();
            setSubmitting(true);
            payload = {
              comment: editorContent,
              destinationOffice: formData
            };
            _context.prev = 3;
            _context.next = 6;
            return onSubmitForward(payload);
          case 6:
            response = _context.sent;
            setServerResponse(response);
            _context.next = 13;
            break;
          case 10:
            _context.prev = 10;
            _context.t0 = _context["catch"](3);
            setServerResponse({
              status: "ERROR",
              message: "সাবমিশনে ব্যর্থ হয়েছে।"
            });
          case 13:
            _context.prev = 13;
            setSubmitting(false);
            return _context.finish(13);
          case 16:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[3, 10, 13, 16]]);
    }));
    return function handleSubmit(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  var handleApplicationReason = function handleApplicationReason(event) {
    var value = event.target.value;
    setOfficeType(value);
  };
  var handleForward = function handleForward() {
    var updateApplicationData = {
      id: decodeId(selectedApplication.id),
      status: WORKFORCE_STATUS$1.FIRST_FORWARD
    };
    dispatch(updateApplication(updateApplicationData, "update workforce application ".concat(selectedApplication.workforceEmployee.firstNameEn)));
    setTimeout(function () {
      window.location.reload();
    }, 2000);
  };
  console.log({
    aha: selectedApplication
  });
  if ((selectedApplication === null || selectedApplication === void 0 ? void 0 : selectedApplication.status) === WORKFORCE_STATUS$1.APPROVER_FORWARD) {
    return /*#__PURE__*/React.createElement(ForwardAdminPanel, {
      open: open,
      onClose: onClose,
      selectedApplication: selectedApplication,
      onSubmitForward: onSubmitForward
    });
  }
  if ((selectedApplication === null || selectedApplication === void 0 ? void 0 : selectedApplication.status) === WORKFORCE_STATUS$1.DG_APPROVED) {
    return /*#__PURE__*/React.createElement(ForwardApplicationModal, {
      open: open,
      onClose: onClose,
      selectedApplication: selectedApplication,
      onSubmitForward: onSubmitForward
    });
  }
  return /*#__PURE__*/React.createElement(Modal, {
    open: open,
    onClose: onClose
  }, /*#__PURE__*/React.createElement("form", {
    className: classes.modalContainer,
    onSubmit: handleSubmit
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: onClose,
    className: classes.closeButton
  }, "\u2715"), /*#__PURE__*/React.createElement(Typography, {
    variant: "h5",
    gutterBottom: true,
    style: {
      fontWeight: "bold",
      marginTop: 3,
      textAlign: "center"
    }
  }, "\u09AC\u09BF\u09AD\u09BE\u0997\u09C0\u09AF\u09BC \u09AC\u09BE \u099C\u09C7\u09B2\u09BE \u0985\u09AB\u09BF\u09B8\u09C7 \u09AA\u09BE\u09A0\u09BE\u09A8"), /*#__PURE__*/React.createElement(Typography, {
    variant: "body1",
    color: "textSecondary",
    gutterBottom: true,
    style: {
      fontWeight: 600,
      marginTop: 3,
      textAlign: "center"
    }
  }), (serverResponse === null || serverResponse === void 0 ? void 0 : serverResponse.status) && /*#__PURE__*/React.createElement(Typography, {
    className: classes.responseMessage,
    style: {
      color: serverResponse.status === "SUCCESS" ? "green" : "red"
    }
  }, serverResponse.status === "SUCCESS" ? "✅" : "⚠️", " ", serverResponse.message), /*#__PURE__*/React.createElement(Divider, {
    style: {
      marginBottom: 24
    }
  }), /*#__PURE__*/React.createElement(Paper, {
    className: classes.sectionPaper,
    elevation: 1
  }, /*#__PURE__*/React.createElement(FormControl, {
    component: "fieldset",
    className: classes.formSection
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body1",
    className: "".concat(classes.title, " ").concat(classes.section)
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "workforce.office.type",
    module: "workforce"
  })), /*#__PURE__*/React.createElement(RadioGroup, {
    value: officeType,
    onChange: handleApplicationReason
  }, /*#__PURE__*/React.createElement(FormControlLabel, {
    value: "dol",
    control: /*#__PURE__*/React.createElement(Radio, {
      color: "primary"
    }),
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.office.dol",
      module: "workforce"
    })
  }), /*#__PURE__*/React.createElement(FormControlLabel, {
    value: "dife",
    control: /*#__PURE__*/React.createElement(Radio, {
      color: "primary"
    }),
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.office.dife",
      module: "workforce"
    })
  }))), officeType && /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 3,
    style: {
      marginTop: 3
    }
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle1",
    gutterBottom: true,
    style: {
      fontWeight: "bold",
      marginTop: 3,
      textAlign: "center"
    }
  }, "\u0985\u09AB\u09BF\u09B8 \u09A8\u09BF\u09B0\u09CD\u09AC\u09BE\u099A\u09A8"), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 12
  }, /*#__PURE__*/React.createElement(DistrictOfficePicker, {
    value: formData === null || formData === void 0 ? void 0 : formData.id,
    officeType: officeType,
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.officeType.selector.picker",
      module: "workforce"
    }),
    required: true,
    onChange: function onChange(v) {
      return setFormData(v);
    }
  })))), /*#__PURE__*/React.createElement("div", {
    className: classes.buttonGroup
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: onClose,
    variant: "outlined",
    color: "secondary"
  }, "\u09AC\u09BE\u09A4\u09BF\u09B2 \u0995\u09B0\u09C1\u09A8"), /*#__PURE__*/React.createElement(Button, {
    type: "submit",
    variant: "contained",
    color: "primary",
    disabled: submitting,
    onClick: handleForward
  }, submitting ? "ফরওয়ার্ড করা হচ্ছে..." : "ফরওয়ার্ড করুন"))));
};

makeStyles(function (theme) {
  return {
    modalContainer: {
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      width: 700,
      maxHeight: "90vh",
      backgroundColor: theme.palette.background.paper,
      borderRadius: theme.spacing(1.5),
      boxShadow: theme.shadows[5],
      padding: theme.spacing(4),
      overflowY: "auto"
    },
    closeButton: {
      position: "absolute",
      top: theme.spacing(1),
      right: theme.spacing(1),
      minWidth: 0,
      padding: theme.spacing(0.5, 1),
      fontSize: "1.2rem"
    },
    sectionPaper: {
      padding: theme.spacing(3),
      marginBottom: theme.spacing(3),
      borderRadius: theme.spacing(1),
      backgroundColor: theme.palette.grey[50]
    },
    buttonGroup: {
      marginTop: theme.spacing(3),
      display: "flex",
      justifyContent: "flex-end",
      gap: theme.spacing(2)
    },
    responseMessage: {
      marginBottom: theme.spacing(2),
      fontWeight: 600
    }
  };
});

function _createForOfIteratorHelper$a(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray$a(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray$a(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray$a(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray$a(r, a) : void 0; } }
function _arrayLikeToArray$a(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var forwardToAssociation = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var selectedApplicationIds, loggedInUserId, updateApplication, createApplicationMovement, dispatch, setServerResponse, userRights, fetchWorkforceDocument, modulesManager, roles, _selectedApplicationI, _parseData, _res$payload, id, res, fetchApplicationById, hasAccidentInfo, parsedOnce, parsedTwice, _iterator, _step, _workforceApplication, _workforceApplication2, _workforceApplication3, _workforceApplication4, _userToResp$payload, _res$payload$data$wor, _res$payload2, _documents$filter, selectedItem, decodedId, _res, workforceApplicationRes, workforceApplication, associationType, associationId, userToResp, applicationToUser, documents, allVerified, updateApplicationData, createApplicationMovementData;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          selectedApplicationIds = _ref.selectedApplicationIds, _ref.formData, loggedInUserId = _ref.loggedInUserId, updateApplication = _ref.updateApplication, createApplicationMovement = _ref.createApplicationMovement, dispatch = _ref.dispatch, setServerResponse = _ref.setServerResponse, userRights = _ref.userRights, fetchWorkforceDocument = _ref.fetchWorkforceDocument, modulesManager = _ref.modulesManager, roles = _ref.roles, _ref.history, _ref.historyPush;
          _context.prev = 1;
          getUserTypeFromRights(userRights);
          id = (_selectedApplicationI = selectedApplicationIds[0]) === null || _selectedApplicationI === void 0 ? void 0 : _selectedApplicationI.id; // Await the fetch so data is ready before checks/loops
          _context.next = 6;
          return dispatch(fetchApplication(modulesManager, ["id: \"".concat(safeDecodeId(id), "\"")]));
        case 6:
          res = _context.sent;
          fetchApplicationById = (_parseData = parseData(res === null || res === void 0 || (_res$payload = res.payload) === null || _res$payload === void 0 || (_res$payload = _res$payload.data) === null || _res$payload === void 0 ? void 0 : _res$payload.workforceApplication)) === null || _parseData === void 0 ? void 0 : _parseData[0];
          console.log({
            fetchApplicationById: fetchApplicationById
          });

          // Safe double-parse and check for empty accident info
          hasAccidentInfo = false;
          if (fetchApplicationById !== null && fetchApplicationById !== void 0 && fetchApplicationById.employeeAccidentInfo) {
            try {
              parsedOnce = JSON.parse(fetchApplicationById.employeeAccidentInfo);
              parsedTwice = JSON.parse(parsedOnce); // Check if it's a non-empty object (handles {} or null-like after parse)
              hasAccidentInfo = parsedTwice && _typeof(parsedTwice) === "object" && Object.keys(parsedTwice).length > 0;
            } catch (e) {
              console.warn("Failed to parse employeeAccidentInfo:", e);
              // Treat parse failure as empty/missing
              hasAccidentInfo = false;
            }
          }

          // The check you want: if eis and no accident info, error and return
          if (!((fetchApplicationById === null || fetchApplicationById === void 0 ? void 0 : fetchApplicationById.organizationType) === "eis" && !hasAccidentInfo)) {
            _context.next = 14;
            break;
          }
          setServerResponse({
            status: "ERROR",
            message: "দুর্ঘটনার তথ্য ফর্মটি পূরণ করুন।"
          });
          return _context.abrupt("return");
        case 14:
          // Now proceed with the loop (documents, etc.)
          _iterator = _createForOfIteratorHelper$a(selectedApplicationIds);
          _context.prev = 15;
          _iterator.s();
        case 17:
          if ((_step = _iterator.n()).done) {
            _context.next = 55;
            break;
          }
          selectedItem = _step.value;
          decodedId = safeDecodeId(selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.id);
          _context.next = 22;
          return dispatch(fetchWorkforceDocument(modulesManager, ["workforceApplication_Id: \"".concat(decodedId, "\"")]));
        case 22:
          _res = _context.sent;
          _context.next = 25;
          return dispatch(fetchApplicationFactoryAssociation(decodedId));
        case 25:
          workforceApplicationRes = _context.sent;
          workforceApplication = workforceApplicationRes === null || workforceApplicationRes === void 0 || (_workforceApplication = workforceApplicationRes.payload) === null || _workforceApplication === void 0 || (_workforceApplication = _workforceApplication.data) === null || _workforceApplication === void 0 || (_workforceApplication = _workforceApplication.workforceApplication) === null || _workforceApplication === void 0 || (_workforceApplication = _workforceApplication.edges[0]) === null || _workforceApplication === void 0 ? void 0 : _workforceApplication.node;
          associationType = (_workforceApplication2 = workforceApplication === null || workforceApplication === void 0 || (_workforceApplication3 = workforceApplication.employeeFactory) === null || _workforceApplication3 === void 0 || (_workforceApplication3 = _workforceApplication3.allAssociation) === null || _workforceApplication3 === void 0 ? void 0 : _workforceApplication3.shortNameEn) !== null && _workforceApplication2 !== void 0 ? _workforceApplication2 : "";
          associationId = safeDecodeId(workforceApplication === null || workforceApplication === void 0 || (_workforceApplication4 = workforceApplication.employeeFactory) === null || _workforceApplication4 === void 0 || (_workforceApplication4 = _workforceApplication4.allAssociation) === null || _workforceApplication4 === void 0 ? void 0 : _workforceApplication4.id);
          console.log("associationType", associationType);
          _context.next = 32;
          return dispatch(fetchWorkforceAssociationUserMaps(["allAssociationId: \"".concat(associationId, "\"")]));
        case 32:
          userToResp = _context.sent;
          applicationToUser = safeDecodeId(userToResp === null || userToResp === void 0 || (_userToResp$payload = userToResp.payload) === null || _userToResp$payload === void 0 || (_userToResp$payload = _userToResp$payload.data) === null || _userToResp$payload === void 0 || (_userToResp$payload = _userToResp$payload.workforceAssociationUserMap) === null || _userToResp$payload === void 0 || (_userToResp$payload = _userToResp$payload.edges[0]) === null || _userToResp$payload === void 0 || (_userToResp$payload = _userToResp$payload.node) === null || _userToResp$payload === void 0 ? void 0 : _userToResp$payload.user.id);
          console.log("applicationToUser", applicationToUser);
          documents = (_res$payload$data$wor = _res === null || _res === void 0 || (_res$payload2 = _res.payload) === null || _res$payload2 === void 0 || (_res$payload2 = _res$payload2.data) === null || _res$payload2 === void 0 || (_res$payload2 = _res$payload2.workforceDocuments) === null || _res$payload2 === void 0 || (_res$payload2 = _res$payload2.edges) === null || _res$payload2 === void 0 ? void 0 : _res$payload2.map(function (edge) {
            return edge.node;
          })) !== null && _res$payload$data$wor !== void 0 ? _res$payload$data$wor : [];
          allVerified = documents === null || documents === void 0 || (_documents$filter = documents.filter(function (doc) {
            var _doc$workforceDocumen;
            return (doc === null || doc === void 0 || (_doc$workforceDocumen = doc.workforceDocumentType) === null || _doc$workforceDocumen === void 0 ? void 0 : _doc$workforceDocumen.mandatoryForApplicant) === true;
          })) === null || _documents$filter === void 0 ? void 0 : _documents$filter.every(function (doc) {
            var documentMapData = parseData(doc === null || doc === void 0 ? void 0 : doc.workforceDocumentMapDocumentId);
            console.log({
              documentMapData: documentMapData
            }); // Keep for debugging
            var status = documentMapData === null || documentMapData === void 0 ? void 0 : documentMapData.find(function (mapdata) {
              var _mapdata$verifiedByRo, _roles$, _roles$2;
              var decodedRoleId = safeDecodeId(mapdata === null || mapdata === void 0 || (_mapdata$verifiedByRo = mapdata.verifiedByRole) === null || _mapdata$verifiedByRo === void 0 ? void 0 : _mapdata$verifiedByRo.id);
              var roleMatch = decodedRoleId === ((_roles$ = roles[0]) === null || _roles$ === void 0 ? void 0 : _roles$.roleId);
              var statusMatch = (mapdata === null || mapdata === void 0 ? void 0 : mapdata.status) === WORKFORCE_DOCUMENT_STATUS.FACTORY_ADMIN_VERIFIED;
              console.log("Decoded verifiedByRole.id:", decodedRoleId);
              console.log("roles[0]?.id:", (_roles$2 = roles[0]) === null || _roles$2 === void 0 ? void 0 : _roles$2.roleId);
              console.log("Role match:", roleMatch);
              console.log("Status match:", statusMatch);
              console.log("Mapdata status:", mapdata === null || mapdata === void 0 ? void 0 : mapdata.status);
              return roleMatch && statusMatch;
            });
            console.log({
              status: status
            }); // Keep for debugging

            if (doc.holderType === "applicant") {
              return !!status; // Only pass if status exists (verified)
            }
            if (doc.holderType === "factoryAdmin") {
              return true; // Always pass (as per current logic)
            }
            return true; // Pass for other types
          }); // Document check (removed the bad extra condition)
          if (allVerified) {
            _context.next = 40;
            break;
          }
          setServerResponse({
            status: "ERROR",
            message: "অনুগ্রহ করে সমস্ত নথি যাচাই করুন"
          });
          return _context.abrupt("return");
        case 40:
          updateApplicationData = {
            id: decodedId,
            status: WORKFORCE_STATUS$1.FORWARD_TO_ASSOCIATION,
            associationType: associationType
            // associationType: formData?.association,
          };
          createApplicationMovementData = {
            applicationId: decodedId,
            status: WORKFORCE_STATUS$1.FORWARD_TO_ASSOCIATION,
            note: "অ্যাসোসিয়েশনের কাছে প্রেরণ",
            action: "forward_to_association",
            applicationFromId: loggedInUserId,
            // applicationToId: formData?.association === "BGMEA"
            //           ? 93
            //           : formData?.association === "BKMEA"
            //           ? 276
            //           : formData?.association === "BEPZA"
            //           ? 219
            //           : formData?.association === "LFMEAB"
            //           ? 203
            //           : null,
            // applicationToId: associationType === "BGMEA"
            //                   ? 93
            //                   : associationType === "BKMEA"
            //                   ? 276
            //                   : associationType === "BEPZA"
            //                   ? 219
            //                   : associationType === "LFMEAB"
            //                   ? 203
            //                   : null,
            applicationToId: applicationToUser,
            toRoleId: 31
          };
          if (!dispatch) {
            _context.next = 49;
            break;
          }
          _context.next = 45;
          return dispatch(updateApplication(updateApplicationData, "update workforce application"));
        case 45:
          _context.next = 47;
          return dispatch(createApplicationMovement(createApplicationMovementData, "create workforce movement"));
        case 47:
          _context.next = 53;
          break;
        case 49:
          _context.next = 51;
          return updateApplication(updateApplicationData, "update workforce application");
        case 51:
          _context.next = 53;
          return createApplicationMovement(createApplicationMovementData, "create workforce movement");
        case 53:
          _context.next = 17;
          break;
        case 55:
          _context.next = 60;
          break;
        case 57:
          _context.prev = 57;
          _context.t0 = _context["catch"](15);
          _iterator.e(_context.t0);
        case 60:
          _context.prev = 60;
          _iterator.f();
          return _context.finish(60);
        case 63:
          setServerResponse === null || setServerResponse === void 0 || setServerResponse({
            status: "SUCCESS",
            message: "সাবমিশন সফল হয়েছে!"
          });
          _context.next = 70;
          break;
        case 66:
          _context.prev = 66;
          _context.t1 = _context["catch"](1);
          console.error("Forward to association failed:", _context.t1);
          setServerResponse === null || setServerResponse === void 0 || setServerResponse({
            status: "ERROR",
            message: "সাবমিশন ব্যর্থ হয়েছে!"
          });
        case 70:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[1, 66], [15, 57, 60, 63]]);
  }));
  return function forwardToAssociation(_x) {
    return _ref2.apply(this, arguments);
  };
}();
var handleBulkSelectedByAssociationLogic = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_ref3) {
    var selectedApplicationIds, loggedInUserId, userRights, fetchWorkforceDocument, updateApplication, createApplicationMovement, fetchUsersByRoleId, roles, setServerResponse, setConfirmModalOpen, setConfirmModalMessage, setConfirmModalCallback, modulesManager, history, setCloseLoader, confirmModalMessage;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          selectedApplicationIds = _ref3.selectedApplicationIds, loggedInUserId = _ref3.loggedInUserId, userRights = _ref3.userRights, fetchWorkforceDocument = _ref3.fetchWorkforceDocument, updateApplication = _ref3.updateApplication, createApplicationMovement = _ref3.createApplicationMovement, fetchUsersByRoleId = _ref3.fetchUsersByRoleId, roles = _ref3.roles, setServerResponse = _ref3.setServerResponse, setConfirmModalOpen = _ref3.setConfirmModalOpen, setConfirmModalMessage = _ref3.setConfirmModalMessage, setConfirmModalCallback = _ref3.setConfirmModalCallback, modulesManager = _ref3.modulesManager, history = _ref3.history, setCloseLoader = _ref3.setCloseLoader, _ref3.loader;
          getUserTypeFromRights(userRights);
          confirmModalMessage = "";
          if (!isEisPath() && WORKFORCE_USER_TYPE.ASSOCIATION
          //   userType === WORKFORCE_USER_TYPE.BGMEA_ASSOCIATION ||
          //   userType === WORKFORCE_USER_TYPE.BKMEA_ASSOCIATION
          ) {
            confirmModalMessage = "workforce.application.forward.message.toSectionAdmin";
          } else if (isEisPath() && WORKFORCE_USER_TYPE.ASSOCIATION
          // userType === WORKFORCE_USER_TYPE.BEPZA_ASSOCIATION ||
          // userType === WORKFORCE_USER_TYPE.LFMEAB_ASSOCIATION
          ) {
            confirmModalMessage = "workforce.application.forward.message.new.toEisCoordinator";
          }
          if (selectedApplicationIds !== null && selectedApplicationIds !== void 0 && selectedApplicationIds.length) {
            _context3.next = 7;
            break;
          }
          setServerResponse({
            status: "ERROR",
            message: "Please select at least one application."
          });
          return _context3.abrupt("return");
        case 7:
          setConfirmModalMessage(confirmModalMessage);
          setConfirmModalOpen(true);
          setConfirmModalCallback(/*#__PURE__*/function () {
            var _ref5 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(confirmed) {
              var _iterator2, _step2, _res$payload$data$wor2, _res$payload3, _documents$filter2, _applicationToResp$pa, selectedItem, decodedId, res, documents, allVerified, applicationToResp, applicationToUser, updateApplicationData, createApplicationMovementData;
              return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                while (1) switch (_context2.prev = _context2.next) {
                  case 0:
                    if (confirmed) {
                      _context2.next = 3;
                      break;
                    }
                    setConfirmModalOpen(false);
                    return _context2.abrupt("return");
                  case 3:
                    _context2.prev = 3;
                    setCloseLoader(true);
                    _iterator2 = _createForOfIteratorHelper$a(selectedApplicationIds);
                    _context2.prev = 6;
                    _iterator2.s();
                  case 8:
                    if ((_step2 = _iterator2.n()).done) {
                      _context2.next = 35;
                      break;
                    }
                    selectedItem = _step2.value;
                    console.log({
                      applicationFormActions: selectedItem
                    });
                    decodedId = safeDecodeId(selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.id);
                    _context2.next = 14;
                    return fetchWorkforceDocument(modulesManager, ["workforceApplication_Id: \"".concat(decodedId, "\"")]);
                  case 14:
                    res = _context2.sent;
                    documents = (_res$payload$data$wor2 = res === null || res === void 0 || (_res$payload3 = res.payload) === null || _res$payload3 === void 0 || (_res$payload3 = _res$payload3.data) === null || _res$payload3 === void 0 || (_res$payload3 = _res$payload3.workforceDocuments) === null || _res$payload3 === void 0 || (_res$payload3 = _res$payload3.edges) === null || _res$payload3 === void 0 ? void 0 : _res$payload3.map(function (edge) {
                      return edge.node;
                    })) !== null && _res$payload$data$wor2 !== void 0 ? _res$payload$data$wor2 : [];
                    allVerified = documents === null || documents === void 0 || (_documents$filter2 = documents.filter(function (doc) {
                      var _doc$workforceDocumen2;
                      return (doc === null || doc === void 0 || (_doc$workforceDocumen2 = doc.workforceDocumentType) === null || _doc$workforceDocumen2 === void 0 ? void 0 : _doc$workforceDocumen2.mandatoryForApplicant) === false && (doc === null || doc === void 0 ? void 0 : doc.documentType) === "Copy of online database of deceased workers";
                    })) === null || _documents$filter2 === void 0 ? void 0 : _documents$filter2.every(function (doc) {
                      var documentMapData = parseData(doc === null || doc === void 0 ? void 0 : doc.workforceDocumentMapDocumentId);
                      console.log({
                        documentMapData: documentMapData
                      }); // Keep for debugging
                      var status = documentMapData === null || documentMapData === void 0 ? void 0 : documentMapData.find(function (mapdata) {
                        var _mapdata$verifiedByRo2, _roles$3, _roles$4;
                        var decodedRoleId = safeDecodeId(mapdata === null || mapdata === void 0 || (_mapdata$verifiedByRo2 = mapdata.verifiedByRole) === null || _mapdata$verifiedByRo2 === void 0 ? void 0 : _mapdata$verifiedByRo2.id);
                        var roleMatch = decodedRoleId === ((_roles$3 = roles[0]) === null || _roles$3 === void 0 ? void 0 : _roles$3.roleId);
                        var statusMatch = (mapdata === null || mapdata === void 0 ? void 0 : mapdata.status) === WORKFORCE_DOCUMENT_STATUS.ASSOCIATION_VERIFIED;
                        console.log("Decoded verifiedByRole.id:", decodedRoleId);
                        console.log("roles[0]?.id:", (_roles$4 = roles[0]) === null || _roles$4 === void 0 ? void 0 : _roles$4.roleId);
                        console.log("Role match:", roleMatch);
                        console.log("Status match:", statusMatch);
                        console.log("Mapdata status:", mapdata === null || mapdata === void 0 ? void 0 : mapdata.status);
                        return roleMatch && statusMatch;
                      });
                      console.log({
                        status: status
                      }); // Keep for debugging

                      // if (doc.holderType === "applicant") {
                      //   return true; // Only pass if status exists (verified)
                      // }
                      // if (doc.holderType === "factoryAdmin") {
                      //   return !!status; // Always pass (as per current logic)
                      // }
                      return !!status; // Pass for other types
                    });
                    console.log({
                      allVerified: allVerified
                    });
                    if (allVerified) {
                      _context2.next = 21;
                      break;
                    }
                    setServerResponse({
                      status: "ERROR",
                      message: "অনুগ্রহ করে সমস্ত নথি যাচাই করুন"
                    });
                    return _context2.abrupt("return");
                  case 21:
                    console.log("documents porjnto aise");
                    _context2.next = 24;
                    return fetchUsersByRoleId([isEisPath() ? "46" : (selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.applicationType) === "disabilityAssistance" || (selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.applicationType) === "financialAssistance" ? "35" : "32"]);
                  case 24:
                    applicationToResp = _context2.sent;
                    console.log({
                      applicationToResp: applicationToResp
                    });
                    applicationToUser = safeDecodeId(applicationToResp === null || applicationToResp === void 0 || (_applicationToResp$pa = applicationToResp.payload) === null || _applicationToResp$pa === void 0 || (_applicationToResp$pa = _applicationToResp$pa.data) === null || _applicationToResp$pa === void 0 || (_applicationToResp$pa = _applicationToResp$pa.workforceUserRole[0]) === null || _applicationToResp$pa === void 0 ? void 0 : _applicationToResp$pa.userId);
                    updateApplicationData = {
                      id: decodedId,
                      status:
                      // userType === WORKFORCE_USER_TYPE.BGMEA_ASSOCIATION ||
                      // userType === WORKFORCE_USER_TYPE.BKMEA_ASSOCIATION
                      !((selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.organizationType) === "eis") && WORKFORCE_USER_TYPE.ASSOCIATION ? WORKFORCE_STATUS$1.FORWARD_TO_CF_SECTION :
                      // userType === WORKFORCE_USER_TYPE.BEPZA_ASSOCIATION ||
                      //   userType === WORKFORCE_USER_TYPE.LFMEAB_ASSOCIATION
                      (selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.organizationType) === "eis" && WORKFORCE_USER_TYPE.ASSOCIATION ? WORKFORCE_STATUS$1.FORWARD_TO_EIS_COORDINATOR : null
                    };
                    createApplicationMovementData = {
                      applicationId: decodedId,
                      status:
                      // userType === WORKFORCE_USER_TYPE.BGMEA_ASSOCIATION ||
                      // userType === WORKFORCE_USER_TYPE.BKMEA_ASSOCIATION
                      !((selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.organizationType) === "eis") && WORKFORCE_USER_TYPE.ASSOCIATION ? WORKFORCE_STATUS$1.FORWARD_TO_CF_SECTION :
                      // userType === WORKFORCE_USER_TYPE.BEPZA_ASSOCIATION ||
                      // userType === WORKFORCE_USER_TYPE.LFMEAB_ASSOCIATION
                      (selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.organizationType) === "eis" && WORKFORCE_USER_TYPE.ASSOCIATION ? WORKFORCE_STATUS$1.FORWARD_TO_EIS_COORDINATOR : null,
                      note: "আবেদন শাখায় প্রেরণ করা হয়েছে",
                      action:
                      // userType === WORKFORCE_USER_TYPE.BGMEA_ASSOCIATION ||
                      // userType === WORKFORCE_USER_TYPE.BKMEA_ASSOCIATION
                      !((selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.organizationType) === "eis") && WORKFORCE_USER_TYPE.ASSOCIATION ? "forward_to_cf_section" :
                      // userType === WORKFORCE_USER_TYPE.BEPZA_ASSOCIATION ||
                      // userType === WORKFORCE_USER_TYPE.LFMEAB_ASSOCIATION
                      (selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.organizationType) === "eis" && WORKFORCE_USER_TYPE.ASSOCIATION ? "forward_to_eis_coordinator" : null,
                      applicationFromId: loggedInUserId,
                      applicationToId: applicationToUser,
                      // userType === WORKFORCE_USER_TYPE.BGMEA_ASSOCIATION ||
                      // userType === WORKFORCE_USER_TYPE.BKMEA_ASSOCIATION
                      // !isEisPath() && WORKFORCE_USER_TYPE.ASSOCIATION
                      // ? 139
                      // :
                      // userType === WORKFORCE_USER_TYPE.BEPZA_ASSOCIATION ||
                      // userType === WORKFORCE_USER_TYPE.LFMEAB_ASSOCIATION
                      //   isEisPath() && WORKFORCE_USER_TYPE.ASSOCIATION
                      // ? 194
                      // : null,
                      toRoleId: (selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.organizationType) === "eis" ? 46 : (selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.applicationType) === "disabilityAssistance" || (selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.applicationType) === "financialAssistance" ? 35 : 32
                    };
                    _context2.next = 31;
                    return updateApplication(updateApplicationData, "update workforce application");
                  case 31:
                    _context2.next = 33;
                    return createApplicationMovement(createApplicationMovementData, "create workforce movement");
                  case 33:
                    _context2.next = 8;
                    break;
                  case 35:
                    _context2.next = 40;
                    break;
                  case 37:
                    _context2.prev = 37;
                    _context2.t0 = _context2["catch"](6);
                    _iterator2.e(_context2.t0);
                  case 40:
                    _context2.prev = 40;
                    _iterator2.f();
                    return _context2.finish(40);
                  case 43:
                    setServerResponse({
                      status: "SUCCESS",
                      message: "সফলভাবে ফরওয়ার্ড করা হয়েছে!"
                    });
                    _context2.next = 50;
                    break;
                  case 46:
                    _context2.prev = 46;
                    _context2.t1 = _context2["catch"](3);
                    console.error("Bulk selection failed:", _context2.t1);
                    setServerResponse({
                      status: "ERROR",
                      message: "ফরওয়ার্ড ব্যর্থ হয়েছে"
                    });
                  case 50:
                    _context2.prev = 50;
                    setTimeout(function () {
                      if (history.location.pathname !== "/") {
                        history.push("/");
                      }
                    }, 5000);
                    setConfirmModalOpen(false);
                    setConfirmModalCallback(null);
                    setCloseLoader(false);
                    return _context2.finish(50);
                  case 56:
                  case "end":
                    return _context2.stop();
                }
              }, _callee2, null, [[3, 46, 50, 56], [6, 37, 40, 43]]);
            }));
            return function (_x3) {
              return _ref5.apply(this, arguments);
            };
          }());
        case 10:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return function handleBulkSelectedByAssociationLogic(_x2) {
    return _ref4.apply(this, arguments);
  };
}();
var handleBulkSelectedByCheckerLogic = /*#__PURE__*/function () {
  var _ref7 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee5(_ref6) {
    var selectedApplicationIds, loggedInUserId, userRights, fetchWorkforceDocument, updateApplication, createApplicationMovement, roles, setServerResponse, setConfirmModalOpen, setConfirmModalMessage, setConfirmModalCallback, modulesManager, history, dispatch, setCloseLoader, userType, confirmModalMessage, allEmpty, _selectedApplicationI2, _res$payload4, id, res, fetchOtherCompensation;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          selectedApplicationIds = _ref6.selectedApplicationIds, loggedInUserId = _ref6.loggedInUserId, userRights = _ref6.userRights, fetchWorkforceDocument = _ref6.fetchWorkforceDocument, updateApplication = _ref6.updateApplication, createApplicationMovement = _ref6.createApplicationMovement, roles = _ref6.roles, setServerResponse = _ref6.setServerResponse, setConfirmModalOpen = _ref6.setConfirmModalOpen, setConfirmModalMessage = _ref6.setConfirmModalMessage, setConfirmModalCallback = _ref6.setConfirmModalCallback, modulesManager = _ref6.modulesManager, history = _ref6.history, dispatch = _ref6.dispatch, setCloseLoader = _ref6.setCloseLoader, _ref6.loader;
          userType = getUserTypeFromRights(userRights);
          confirmModalMessage = "";
          allEmpty = false;
          if (!(userType === WORKFORCE_USER_TYPE.CHECKER || userType === WORKFORCE_USER_TYPE.CHECKER_TWO || userType === WORKFORCE_USER_TYPE.BLWF_DOL_DIFE || userType === WORKFORCE_USER_TYPE.BLWF_CHECKER || userType === WORKFORCE_USER_TYPE.SEC1_DEPUTI_ASST_DIRECTOR || userType === WORKFORCE_USER_TYPE.SEC2_DEPUTI_ASST_DIRECTOR || userType === WORKFORCE_USER_TYPE.BLWF_DEPUTI_ASST_DIRECTOR)) {
            _context5.next = 8;
            break;
          }
          confirmModalMessage = "workforce.application.forward.message.toSectionAdmin";
          _context5.next = 20;
          break;
        case 8:
          if (!(userType === WORKFORCE_USER_TYPE.EIS_OFFICER)) {
            _context5.next = 20;
            break;
          }
          id = (_selectedApplicationI2 = selectedApplicationIds[0]) === null || _selectedApplicationI2 === void 0 ? void 0 : _selectedApplicationI2.id;
          console.log({
            checkerId: id
          });
          _context5.next = 13;
          return dispatch(fetchWorkforceOtherCompensation(modulesManager, ["workforceApplicationId: \"".concat(safeDecodeId(id), "\"")]));
        case 13:
          res = _context5.sent;
          _context5.next = 16;
          return parseData(res === null || res === void 0 || (_res$payload4 = res.payload) === null || _res$payload4 === void 0 || (_res$payload4 = _res$payload4.data) === null || _res$payload4 === void 0 ? void 0 : _res$payload4.workforceOtherCompensationInfo);
        case 16:
          fetchOtherCompensation = _context5.sent;
          allEmpty = fetchOtherCompensation === null || fetchOtherCompensation === void 0 ? void 0 : fetchOtherCompensation.every(function (item) {
            return item.isEisBenefitAdjustmentEligible === "";
          });
          console.log({
            allEmpty: allEmpty
          });
          if ((fetchOtherCompensation === null || fetchOtherCompensation === void 0 ? void 0 : fetchOtherCompensation.length) === 0) {
            confirmModalMessage = "workforce.application.forward.message.withoutCompensation.toEisCoordinator";
          } else if (allEmpty) {
            confirmModalMessage = "workforce.application.forward.message.withoutCompensation.eisOfficer.toEisCoordinator";
          } else {
            confirmModalMessage = "workforce.application.forward.message.toEisCoordinator";
          }
        case 20:
          if (selectedApplicationIds !== null && selectedApplicationIds !== void 0 && selectedApplicationIds.length) {
            _context5.next = 23;
            break;
          }
          setServerResponse({
            status: "ERROR",
            message: "Please select at least one application."
          });
          return _context5.abrupt("return");
        case 23:
          // 🧠 open modal confirmation
          setConfirmModalMessage(confirmModalMessage);
          setConfirmModalOpen(true);
          if (!allEmpty) {
            _context5.next = 27;
            break;
          }
          return _context5.abrupt("return");
        case 27:
          setConfirmModalCallback(/*#__PURE__*/function () {
            var _ref8 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee4(confirmed) {
              var isSuccess, _iterator3, _step3, _res2$payload$data$wo, _res2$payload, selectedItem, decodedId, _res2, documents, allVerified, updateApplicationData, createApplicationMovementData;
              return _regeneratorRuntime.wrap(function _callee4$(_context4) {
                while (1) switch (_context4.prev = _context4.next) {
                  case 0:
                    if (confirmed) {
                      _context4.next = 3;
                      break;
                    }
                    setConfirmModalOpen(false);
                    return _context4.abrupt("return");
                  case 3:
                    isSuccess = false;
                    setCloseLoader(true);
                    _context4.prev = 5;
                    _iterator3 = _createForOfIteratorHelper$a(selectedApplicationIds);
                    _context4.prev = 7;
                    _iterator3.s();
                  case 9:
                    if ((_step3 = _iterator3.n()).done) {
                      _context4.next = 28;
                      break;
                    }
                    selectedItem = _step3.value;
                    decodedId = safeDecodeId(selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.id);
                    _context4.next = 14;
                    return fetchWorkforceDocument(modulesManager, ["workforceApplication_Id: \"".concat(decodedId, "\"")]);
                  case 14:
                    _res2 = _context4.sent;
                    documents = (_res2$payload$data$wo = _res2 === null || _res2 === void 0 || (_res2$payload = _res2.payload) === null || _res2$payload === void 0 || (_res2$payload = _res2$payload.data) === null || _res2$payload === void 0 || (_res2$payload = _res2$payload.workforceDocuments) === null || _res2$payload === void 0 || (_res2$payload = _res2$payload.edges) === null || _res2$payload === void 0 ? void 0 : _res2$payload.map(function (edge) {
                      return edge.node;
                    })) !== null && _res2$payload$data$wo !== void 0 ? _res2$payload$data$wo : [];
                    allVerified = documents === null || documents === void 0 ? void 0 : documents.every(function (doc) {
                      var documentMapData = parseData(doc === null || doc === void 0 ? void 0 : doc.workforceDocumentMapDocumentId);
                      console.log({
                        documentMapData: documentMapData
                      }); // Keep for debugging
                      var status = documentMapData === null || documentMapData === void 0 ? void 0 : documentMapData.find(function (mapdata) {
                        var _mapdata$verifiedByRo3, _roles$5, _roles$6;
                        var decodedRoleId = safeDecodeId(mapdata === null || mapdata === void 0 || (_mapdata$verifiedByRo3 = mapdata.verifiedByRole) === null || _mapdata$verifiedByRo3 === void 0 ? void 0 : _mapdata$verifiedByRo3.id);
                        var roleMatch = decodedRoleId === ((_roles$5 = roles[0]) === null || _roles$5 === void 0 ? void 0 : _roles$5.roleId);
                        var statusMatch = isEisPath() ? (mapdata === null || mapdata === void 0 ? void 0 : mapdata.status) === WORKFORCE_DOCUMENT_STATUS.EIS_OFFICER_VERIFIED : userType === WORKFORCE_USER_TYPE.BLWF_DOL_DIFE ? (mapdata === null || mapdata === void 0 ? void 0 : mapdata.status) === WORKFORCE_DOCUMENT_STATUS.DOL_DIFE_VERIFIED : userType === WORKFORCE_USER_TYPE.BLWF_CHECKER ? (mapdata === null || mapdata === void 0 ? void 0 : mapdata.status) === WORKFORCE_DOCUMENT_STATUS.BLWF_SECTION_OFFICER_VERIFIED : (mapdata === null || mapdata === void 0 ? void 0 : mapdata.status) === WORKFORCE_DOCUMENT_STATUS.SECTION_OFFICER_VERIFIED;
                        console.log("Decoded verifiedByRole.id:", decodedRoleId);
                        console.log("roles[0]?.id:", (_roles$6 = roles[0]) === null || _roles$6 === void 0 ? void 0 : _roles$6.roleId);
                        console.log("Role match:", roleMatch);
                        console.log("Status match:", statusMatch);
                        console.log("Mapdata status:", mapdata === null || mapdata === void 0 ? void 0 : mapdata.status);
                        return roleMatch && statusMatch;
                      });
                      console.log({
                        status: status
                      }); // Keep for debugging
                      return !!status; // Pass for other types
                    }); // const allVerified = documents?.every((doc) => {
                    //   return doc?.status.includes("verified");
                    // });
                    if (allVerified) {
                      _context4.next = 20;
                      break;
                    }
                    setServerResponse({
                      status: "ERROR",
                      message: "অনুগ্রহ করে সমস্ত নথি যাচাই করুন"
                    });
                    return _context4.abrupt("return");
                  case 20:
                    updateApplicationData = {
                      id: decodedId,
                      status: userType === WORKFORCE_USER_TYPE.BLWF_DOL_DIFE ? WORKFORCE_STATUS$1.VERIFIED_BY_DOL_DIFE : WORKFORCE_STATUS$1.VERIFIED
                    };
                    createApplicationMovementData = {
                      applicationId: decodedId,
                      status: userType === WORKFORCE_USER_TYPE.BLWF_DOL_DIFE ? WORKFORCE_STATUS$1.VERIFIED_BY_DOL_DIFE : WORKFORCE_STATUS$1.VERIFIED,
                      note: "আবেদন যাচাইকৃত হয়েছে",
                      action: "verified",
                      applicationFromId: loggedInUserId,
                      applicationToId: userType === WORKFORCE_USER_TYPE.CHECKER ? 139 : userType === WORKFORCE_USER_TYPE.BLWF_CHECKER || userType === WORKFORCE_USER_TYPE.BLWF_DOL_DIFE ? 187 : userType === WORKFORCE_USER_TYPE.EIS_OFFICER ? 194 : null,
                      toRoleId: userType === WORKFORCE_USER_TYPE.CHECKER ? 32 : userType === WORKFORCE_USER_TYPE.EIS_OFFICER ? 47 : userType === WORKFORCE_USER_TYPE.BLWF_CHECKER || userType === WORKFORCE_USER_TYPE.BLWF_DOL_DIFE ? 40 : null
                    };
                    _context4.next = 24;
                    return updateApplication(updateApplicationData, "update workforce application");
                  case 24:
                    _context4.next = 26;
                    return createApplicationMovement(createApplicationMovementData, "create workforce movement");
                  case 26:
                    _context4.next = 9;
                    break;
                  case 28:
                    _context4.next = 33;
                    break;
                  case 30:
                    _context4.prev = 30;
                    _context4.t0 = _context4["catch"](7);
                    _iterator3.e(_context4.t0);
                  case 33:
                    _context4.prev = 33;
                    _iterator3.f();
                    return _context4.finish(33);
                  case 36:
                    setServerResponse({
                      status: "SUCCESS",
                      message: "সফলভাবে ফরওয়ার্ড করা হয়েছে!"
                    });
                    isSuccess = true;
                    _context4.next = 44;
                    break;
                  case 40:
                    _context4.prev = 40;
                    _context4.t1 = _context4["catch"](5);
                    console.error("Bulk selection failed:", _context4.t1);
                    setServerResponse({
                      status: "ERROR",
                      message: "ফরওয়ার্ড ব্যর্থ হয়েছে"
                    });
                  case 44:
                    _context4.prev = 44;
                    // history.push("/");
                    if (isSuccess) {
                      setTimeout(function () {
                        history.push("/");
                        //window.location.reload();
                      }, 200);
                    }
                    setConfirmModalOpen(false);
                    setConfirmModalCallback(null);
                    setCloseLoader(false);
                    return _context4.finish(44);
                  case 50:
                  case "end":
                    return _context4.stop();
                }
              }, _callee4, null, [[5, 40, 44, 50], [7, 30, 33, 36]]);
            }));
            return function (_x5) {
              return _ref8.apply(this, arguments);
            };
          }());
        case 28:
        case "end":
          return _context5.stop();
      }
    }, _callee5);
  }));
  return function handleBulkSelectedByCheckerLogic(_x4) {
    return _ref7.apply(this, arguments);
  };
}();
var handleApprovalByDoctor = /*#__PURE__*/function () {
  var _ref10 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee7(_ref9) {
    var selectedApplicationIds, loggedInUserId, userRights, updateApplication, createApplicationMovement, setServerResponse, setConfirmModalOpen, setConfirmModalMessage, setConfirmModalCallback, history, editedGrantMoney, setCloseLoader, userType, confirmModalMessage;
    return _regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) switch (_context7.prev = _context7.next) {
        case 0:
          selectedApplicationIds = _ref9.selectedApplicationIds, loggedInUserId = _ref9.loggedInUserId, userRights = _ref9.userRights, updateApplication = _ref9.updateApplication, createApplicationMovement = _ref9.createApplicationMovement, setServerResponse = _ref9.setServerResponse, setConfirmModalOpen = _ref9.setConfirmModalOpen, setConfirmModalMessage = _ref9.setConfirmModalMessage, setConfirmModalCallback = _ref9.setConfirmModalCallback, _ref9.modulesManager, history = _ref9.history, editedGrantMoney = _ref9.editedGrantMoney, setCloseLoader = _ref9.setCloseLoader, _ref9.loader;
          userType = getUserTypeFromRights(userRights);
          confirmModalMessage = "workforce.application.doctor.approve.message";
          if (selectedApplicationIds !== null && selectedApplicationIds !== void 0 && selectedApplicationIds.length) {
            _context7.next = 6;
            break;
          }
          setServerResponse({
            status: "ERROR",
            message: "Please select at least one application."
          });
          return _context7.abrupt("return");
        case 6:
          setConfirmModalMessage(confirmModalMessage);
          setConfirmModalOpen(true);
          setConfirmModalCallback(/*#__PURE__*/function () {
            var _ref11 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee6(confirmed) {
              var _iterator4, _step4, selectedItem, decodedId, updateApplicationData, createApplicationMovementData, hasOtherValues;
              return _regeneratorRuntime.wrap(function _callee6$(_context6) {
                while (1) switch (_context6.prev = _context6.next) {
                  case 0:
                    if (confirmed) {
                      _context6.next = 3;
                      break;
                    }
                    setConfirmModalOpen(false);
                    return _context6.abrupt("return");
                  case 3:
                    _context6.prev = 3;
                    setCloseLoader(true);
                    _iterator4 = _createForOfIteratorHelper$a(selectedApplicationIds);
                    _context6.prev = 6;
                    _iterator4.s();
                  case 8:
                    if ((_step4 = _iterator4.n()).done) {
                      _context6.next = 22;
                      break;
                    }
                    selectedItem = _step4.value;
                    decodedId = safeDecodeId(selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.id);
                    updateApplicationData = {
                      id: decodedId,
                      status: WORKFORCE_STATUS$1.APPROVED_BY_DOCTOR,
                      grantAmount: editedGrantMoney
                    };
                    createApplicationMovementData = {
                      applicationId: decodedId,
                      status: WORKFORCE_STATUS$1.APPROVED_BY_DOCTOR,
                      note: "আবেদন ডাক্তার দ্বারা অনুমোদন করা হয়েছে",
                      action: "approved_by_doctor",
                      applicationFromId: loggedInUserId,
                      applicationToId: userType === WORKFORCE_USER_TYPE.DOCTOR ? 139 : userType === WORKFORCE_USER_TYPE.BLWF_DOCTOR ? 187 : userType === WORKFORCE_USER_TYPE.EIS_DOCTOR ? 173 : null,
                      toRoleId: userType === WORKFORCE_USER_TYPE.DOCTOR ? 32 : userType === WORKFORCE_USER_TYPE.BLWF_DOCTOR ? 40 : userType === WORKFORCE_USER_TYPE.EIS_DOCTOR ? 42 : null
                    };
                    hasOtherValues = Object.entries(selectedItem).some(function (_ref12) {
                      var _ref13 = _slicedToArray(_ref12, 2),
                        key = _ref13[0],
                        value = _ref13[1];
                      return !["dateOfAssessment", "nameOfAssessmentMeeting", "briefInjuryDescription", "briefTreatmentDescription", "injurySiteLocation", "injuryDetailsDescription", "observationCurrentCondition"].includes(key) && value != null && value !== "";
                    });
                    if (!(isEisPath() && !hasOtherValues)) {
                      _context6.next = 16;
                      break;
                    }
                    throw new Error("অনুগ্রহ করে দুর্ঘটনা ও চিকিৎসা বিবরণ তথ্য প্রদান করুন। ");
                  case 16:
                    _context6.next = 18;
                    return updateApplication(updateApplicationData, "update workforce application");
                  case 18:
                    _context6.next = 20;
                    return createApplicationMovement(createApplicationMovementData, "create workforce movement");
                  case 20:
                    _context6.next = 8;
                    break;
                  case 22:
                    _context6.next = 27;
                    break;
                  case 24:
                    _context6.prev = 24;
                    _context6.t0 = _context6["catch"](6);
                    _iterator4.e(_context6.t0);
                  case 27:
                    _context6.prev = 27;
                    _iterator4.f();
                    return _context6.finish(27);
                  case 30:
                    setServerResponse({
                      status: "SUCCESS",
                      message: "আবেদনসমূহ সফলভাবে অনুমোদন করা হয়েছে!"
                    });
                    _context6.next = 37;
                    break;
                  case 33:
                    _context6.prev = 33;
                    _context6.t1 = _context6["catch"](3);
                    console.error("Bulk doctor approval failed:", _context6.t1);
                    setServerResponse({
                      status: "ERROR",
                      message: _context6.t1 !== null && _context6.t1 !== void 0 && _context6.t1.message ? _context6.t1 === null || _context6.t1 === void 0 ? void 0 : _context6.t1.message : "আবেদন অনুমোদন ব্যর্থ হয়েছে!"
                    });
                  case 37:
                    _context6.prev = 37;
                    history.push("/");
                    setConfirmModalOpen(false);
                    setConfirmModalCallback(null);
                    setCloseLoader(false);
                    return _context6.finish(37);
                  case 43:
                  case "end":
                    return _context6.stop();
                }
              }, _callee6, null, [[3, 33, 37, 43], [6, 24, 27, 30]]);
            }));
            return function (_x7) {
              return _ref11.apply(this, arguments);
            };
          }());
        case 9:
        case "end":
          return _context7.stop();
      }
    }, _callee7);
  }));
  return function handleApprovalByDoctor(_x6) {
    return _ref10.apply(this, arguments);
  };
}();
var handleApprovalByEisCommittee = /*#__PURE__*/function () {
  var _ref15 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee9(_ref14) {
    var selectedApplicationIds, loggedInUserId, updateApplication, createApplicationMovement, setServerResponse, setConfirmModalOpen, setConfirmModalMessage, setConfirmModalCallback, eisApprovalIds, eisApprovedByIds, setCloseLoader, confirmModalMessage;
    return _regeneratorRuntime.wrap(function _callee9$(_context9) {
      while (1) switch (_context9.prev = _context9.next) {
        case 0:
          selectedApplicationIds = _ref14.selectedApplicationIds, loggedInUserId = _ref14.loggedInUserId, _ref14.userRights, _ref14.modulesManager, _ref14.fetchWorkforceDocument, updateApplication = _ref14.updateApplication, createApplicationMovement = _ref14.createApplicationMovement, _ref14.updateApplicationSummary, setServerResponse = _ref14.setServerResponse, setConfirmModalOpen = _ref14.setConfirmModalOpen, setConfirmModalMessage = _ref14.setConfirmModalMessage, setConfirmModalCallback = _ref14.setConfirmModalCallback, _ref14.summaryId, eisApprovalIds = _ref14.eisApprovalIds, eisApprovedByIds = _ref14.eisApprovedByIds, _ref14.history, setCloseLoader = _ref14.setCloseLoader, _ref14.loader;
          confirmModalMessage = "workforce.application.sign.message.toEisCoordinator";
          if (selectedApplicationIds !== null && selectedApplicationIds !== void 0 && selectedApplicationIds.length) {
            _context9.next = 5;
            break;
          }
          setServerResponse({
            status: "ERROR",
            message: "Please select at least one application."
          });
          return _context9.abrupt("return");
        case 5:
          setConfirmModalMessage(confirmModalMessage);
          setConfirmModalOpen(true);
          setConfirmModalCallback(/*#__PURE__*/function () {
            var _ref16 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee8(confirmed) {
              var _iterator5, _step5, selectedItem, decodedId, approvalUserIds, approvedUserIds, majorityApproved, totalApprovers, totalApproved, updateApplicationData, createApplicationMovementData;
              return _regeneratorRuntime.wrap(function _callee8$(_context8) {
                while (1) switch (_context8.prev = _context8.next) {
                  case 0:
                    if (confirmed) {
                      _context8.next = 3;
                      break;
                    }
                    setConfirmModalOpen(false);
                    return _context8.abrupt("return");
                  case 3:
                    _context8.prev = 3;
                    setCloseLoader(true);
                    _iterator5 = _createForOfIteratorHelper$a(selectedApplicationIds);
                    _context8.prev = 6;
                    _iterator5.s();
                  case 8:
                    if ((_step5 = _iterator5.n()).done) {
                      _context8.next = 35;
                      break;
                    }
                    selectedItem = _step5.value;
                    decodedId = safeDecodeId(selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.id);
                    approvalUserIds = eisApprovalIds ? safeParse(eisApprovalIds) : [];
                    approvedUserIds = eisApprovedByIds ? safeParse(eisApprovedByIds) : [];
                    if (!approvedUserIds.includes(loggedInUserId)) {
                      _context8.next = 17;
                      break;
                    }
                    setServerResponse({
                      status: "ERROR",
                      message: "আপনি ইতিমধ্যে এই আবেদনটি অনুমোদন করেছেন!"
                    });
                    _context8.next = 33;
                    break;
                  case 17:
                    majorityApproved = false;
                    approvedUserIds.push(loggedInUserId);
                    totalApprovers = (approvalUserIds === null || approvalUserIds === void 0 ? void 0 : approvalUserIds.length) > 0 ? approvalUserIds.length : 1;
                    totalApproved = (approvedUserIds === null || approvedUserIds === void 0 ? void 0 : approvedUserIds.length) > 0 ? approvedUserIds.length : 0;
                    console.log("totalApprovers", totalApprovers);
                    console.log("totalApproved", totalApproved);
                    majorityApproved = totalApprovers > 0 ? totalApproved / totalApprovers >= 0.5 : true;
                    if (majorityApproved) {
                      console.log("majority hoiche");
                    } else {
                      console.log("majority hoynai");
                    }
                    updateApplicationData = {
                      id: decodedId,
                      status: majorityApproved ? WORKFORCE_STATUS$1.APPROVED_BY_COMMITTEE : WORKFORCE_STATUS$1.FORWARD_TO_COMIITEE,
                      eisApprovedByIds: JSON.stringify(approvedUserIds)
                    };
                    createApplicationMovementData = {
                      applicationId: decodedId,
                      status: WORKFORCE_STATUS$1.APPROVED_BY_COMMITTEE,
                      note: "আবেদন কমিটি দ্বারা অনুমোদন করা হয়েছে",
                      action: "approved_by_committee",
                      applicationFromId: loggedInUserId,
                      applicationToId: 173,
                      toRoleId: 42
                    }; // const updateApplicationSummaryData = {
                    //   id: safeDecodeId(summaryId),
                    //   status: WORKFORCE_STATUS.APPROVED_BY_COMMITTEE,
                    // };
                    _context8.next = 29;
                    return updateApplication(updateApplicationData, "update workforce application");
                  case 29:
                    if (!majorityApproved) {
                      _context8.next = 33;
                      break;
                    }
                    console.log("ekhane dhukse");
                    _context8.next = 33;
                    return createApplicationMovement(createApplicationMovementData, "create workforce movement");
                  case 33:
                    _context8.next = 8;
                    break;
                  case 35:
                    _context8.next = 40;
                    break;
                  case 37:
                    _context8.prev = 37;
                    _context8.t0 = _context8["catch"](6);
                    _iterator5.e(_context8.t0);
                  case 40:
                    _context8.prev = 40;
                    _iterator5.f();
                    return _context8.finish(40);
                  case 43:
                    setServerResponse({
                      status: "SUCCESS",
                      message: "নির্বাচিত আবেদনগুলোর জন্য আপনার অনুমোদন গৃহীত হয়েছে। মেজরিটি পূর্ণ হলে আবেদন অনুমোদিত হবে।"
                    });
                    _context8.next = 50;
                    break;
                  case 46:
                    _context8.prev = 46;
                    _context8.t1 = _context8["catch"](3);
                    console.error("Bulk committee approval failed:", _context8.t1);
                    setServerResponse({
                      status: "ERROR",
                      message: "আবেদন অনুমোদন ব্যর্থ হয়েছে!"
                    });
                  case 50:
                    _context8.prev = 50;
                    // history.push("/");
                    // //window.location.reload();
                    setTimeout(function () {
                      // history.push("/");
                      window.location.reload();
                    }, 500);
                    setConfirmModalOpen(false);
                    setConfirmModalCallback(null);
                    setCloseLoader(false);
                    return _context8.finish(50);
                  case 56:
                  case "end":
                    return _context8.stop();
                }
              }, _callee8, null, [[3, 46, 50, 56], [6, 37, 40, 43]]);
            }));
            return function (_x9) {
              return _ref16.apply(this, arguments);
            };
          }());
        case 8:
        case "end":
          return _context9.stop();
      }
    }, _callee9);
  }));
  return function handleApprovalByEisCommittee(_x8) {
    return _ref15.apply(this, arguments);
  };
}();

var useStyles$Y = makeStyles(function (theme) {
  return {
    modalContainer: {
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      width: 700,
      maxHeight: "90vh",
      backgroundColor: theme.palette.background.paper,
      borderRadius: theme.spacing(1.5),
      boxShadow: theme.shadows[5],
      padding: theme.spacing(4),
      overflowY: "auto"
    },
    closeButton: {
      position: "absolute",
      top: theme.spacing(1),
      right: theme.spacing(1),
      minWidth: 0,
      padding: theme.spacing(0.5, 1),
      fontSize: "1.2rem"
    },
    sectionPaper: {
      padding: theme.spacing(3),
      marginBottom: theme.spacing(3),
      borderRadius: theme.spacing(1),
      backgroundColor: theme.palette.grey[50]
    },
    buttonGroup: {
      marginTop: theme.spacing(3),
      display: "flex",
      justifyContent: "flex-end",
      gap: theme.spacing(2)
    },
    responseMessage: {
      marginBottom: theme.spacing(2),
      fontWeight: 600
    }
  };
});
var ForwardApplicationFactoryAdminModal = function ForwardApplicationFactoryAdminModal(_ref) {
  var open = _ref.open,
    onClose = _ref.onClose,
    selectedApplication = _ref.selectedApplication,
    selectedApplicationIds = _ref.selectedApplicationIds;
    _ref.onSubmitForward;
    _ref.organizationEmployee;
    var roles = _ref.roles;
  var classes = useStyles$Y();
  var dispatch = useDispatch();
  var modulesManager = useModulesManager();
  var history = useHistory();
  var _useState = useState(""),
    _useState2 = _slicedToArray(_useState, 2);
    _useState2[0];
    var setEditorContent = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    submitting = _useState4[0],
    setSubmitting = _useState4[1];
  var _useState5 = useState(null),
    _useState6 = _slicedToArray(_useState5, 2),
    serverResponse = _useState6[0],
    setServerResponse = _useState6[1];
  var _useState7 = useState(""),
    _useState8 = _slicedToArray(_useState7, 2);
    _useState8[0];
    _useState8[1];
  var _useState9 = useState(null),
    _useState10 = _slicedToArray(_useState9, 2),
    formData = _useState10[0],
    setFormData = _useState10[1];
  var loggedInUserId = useSelector(function (state) {
    var _state$core;
    return (_state$core = state.core) === null || _state$core === void 0 || (_state$core = _state$core.user) === null || _state$core === void 0 || (_state$core = _state$core.i_user) === null || _state$core === void 0 ? void 0 : _state$core.id;
  });
  var userRights = useSelector(function (state) {
    return state.core.user.i_user.rights;
  });
  console.log({
    userRights: userRights
  });
  useEffect(function () {
    if (!open) {
      setEditorContent("");
      setSubmitting(false);
      setServerResponse(null);
      setFormData(null);
    }
    if (selectedApplication) {
      return dispatch(fetchApplication(modulesManager, ["id: \"".concat(decodeId(selectedApplication === null || selectedApplication === void 0 ? void 0 : selectedApplication.id), "\"")]));
    }
  }, [open]);
  useSelector(function (state) {
    var _state$workforce;
    return (_state$workforce = state.workforce["application"]) !== null && _state$workforce !== void 0 ? _state$workforce : [];
  });
  console.log({
    selectedApplicationIds: selectedApplicationIds
  });
  var handleForward = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return forwardToAssociation({
              selectedApplicationIds: selectedApplicationIds,
              formData: formData,
              loggedInUserId: loggedInUserId,
              updateApplication: updateApplication,
              createApplicationMovement: createApplicationMovement,
              dispatch: dispatch,
              setServerResponse: setServerResponse,
              userRights: userRights,
              modulesManager: modulesManager,
              fetchWorkforceDocument: fetchWorkforceDocument,
              roles: roles,
              history: history,
              historyPush: historyPush$1
            });
          case 2:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function handleForward() {
      return _ref3.apply(this, arguments);
    };
  }();
  useEffect(function () {
    if ((serverResponse === null || serverResponse === void 0 ? void 0 : serverResponse.status) === "SUCCESS") {
      setTimeout(function () {
        // window.location.reload();
        // historyPush(modulesManager, history, "/")
        history.push("/");
      }, 5000);
    }
  }, [serverResponse]);
  console.log({
    aha: selectedApplication
  });
  return /*#__PURE__*/React.createElement(Modal, {
    open: open,
    onClose: onClose
  }, /*#__PURE__*/React.createElement("form", {
    className: classes.modalContainer
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: onClose,
    className: classes.closeButton
  }, "\u2715"), /*#__PURE__*/React.createElement(Typography, {
    variant: "h5",
    gutterBottom: true,
    style: {
      fontWeight: "bold",
      marginTop: 3,
      textAlign: "center"
    }
  }, "\u0986\u09AA\u09A8\u09BF \u0995\u09BF \u09A8\u09BF\u09B0\u09CD\u09AC\u09BE\u099A\u09BF\u09A4 \u0986\u09AC\u09C7\u09A6\u09A8\u09B8\u09AE\u09C2\u09B9 \u0985\u09CD\u09AF\u09BE\u09B8\u09CB\u09B8\u09BF\u09DF\u09C7\u09B6\u09A8\u09C7\u09B0 \u0995\u09BE\u099B\u09C7 \u09AB\u09B0\u0993\u09DF\u09BE\u09B0\u09CD\u09A1 \u0995\u09B0\u09A4\u09C7 \u099A\u09BE\u09A8?"), /*#__PURE__*/React.createElement(Typography, {
    variant: "body1",
    color: "textSecondary",
    gutterBottom: true,
    style: {
      fontWeight: 600,
      marginTop: 3,
      textAlign: "center"
    }
  }), (serverResponse === null || serverResponse === void 0 ? void 0 : serverResponse.status) && /*#__PURE__*/React.createElement(Typography, {
    className: classes.responseMessage,
    style: {
      color: serverResponse.status === "SUCCESS" ? "green" : "red"
    }
  }, serverResponse.status === "SUCCESS" ? "✅" : "⚠️", " ", serverResponse.message), /*#__PURE__*/React.createElement(Divider, {
    style: {
      marginBottom: 24
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.buttonGroup
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: onClose,
    variant: "contained",
    color: "secondary"
  }, "\u09AC\u09BE\u09A4\u09BF\u09B2 \u0995\u09B0\u09C1\u09A8"), /*#__PURE__*/React.createElement(Button, {
    type: "button",
    variant: "contained",
    color: "primary",
    disabled: submitting,
    onClick: handleForward
  }, submitting ? "ফরওয়ার্ড করা হচ্ছে..." : "ফরওয়ার্ড করুন"))));
};

function ownKeys$O(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$O(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$O(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$O(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _createForOfIteratorHelper$9(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray$9(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray$9(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray$9(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray$9(r, a) : void 0; } }
function _arrayLikeToArray$9(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var useStyles$X = makeStyles(function (theme) {
  return {
    modalContainer: {
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      width: 700,
      maxHeight: "90vh",
      backgroundColor: theme.palette.background.paper,
      borderRadius: theme.spacing(1.5),
      boxShadow: theme.shadows[5],
      padding: theme.spacing(4),
      overflowY: "auto"
    },
    closeButton: {
      position: "absolute",
      top: theme.spacing(1),
      right: theme.spacing(1),
      minWidth: 0,
      padding: theme.spacing(0.5, 1),
      fontSize: "1.2rem"
    },
    sectionPaper: {
      padding: theme.spacing(3),
      marginBottom: theme.spacing(3),
      borderRadius: theme.spacing(1),
      backgroundColor: theme.palette.grey[50]
    },
    buttonGroup: {
      marginTop: theme.spacing(3),
      display: "flex",
      justifyContent: "flex-end",
      gap: theme.spacing(2)
    },
    responseMessage: {
      marginBottom: theme.spacing(2),
      fontWeight: 600
    }
  };
});
var ForwardApplicationSectionAdminModal = function ForwardApplicationSectionAdminModal(_ref) {
  var _selectedApplication$;
  var open = _ref.open,
    onClose = _ref.onClose,
    selectedApplication = _ref.selectedApplication,
    selectedApplicationIds = _ref.selectedApplicationIds;
    _ref.onSubmitForward;
    _ref.userRights;
  var classes = useStyles$X();
  var dispatch = useDispatch();
  var history = useHistory();
  var modulesManager = useModulesManager();
  var _useState = useState(""),
    _useState2 = _slicedToArray(_useState, 2);
    _useState2[0];
    var setEditorContent = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    submitting = _useState4[0],
    setSubmitting = _useState4[1];
  var _useState5 = useState(null),
    _useState6 = _slicedToArray(_useState5, 2),
    serverResponse = _useState6[0],
    setServerResponse = _useState6[1];
  var _useState7 = useState(""),
    _useState8 = _slicedToArray(_useState7, 2);
    _useState8[0];
    _useState8[1];
  var _useState9 = useState(null),
    _useState10 = _slicedToArray(_useState9, 2),
    formData = _useState10[0],
    setFormData = _useState10[1];
  var loggedInUserId = useSelector(function (state) {
    var _state$core;
    return (_state$core = state.core) === null || _state$core === void 0 || (_state$core = _state$core.user) === null || _state$core === void 0 || (_state$core = _state$core.i_user) === null || _state$core === void 0 ? void 0 : _state$core.id;
  });
  useSelector(function (state) {
    var _state$core2;
    return (_state$core2 = state.core) === null || _state$core2 === void 0 || (_state$core2 = _state$core2.user) === null || _state$core2 === void 0 || (_state$core2 = _state$core2.i_user) === null || _state$core2 === void 0 ? void 0 : _state$core2.rights;
  });
  var userType = getUserType();
  var officers = useSelector(function (state) {
    return state.workforce.roleWiseUsers || [];
  });
  console.log("jjjjjjjjj", officers);
  useEffect(function () {
    if (!open) {
      setEditorContent("");
      setSubmitting(false);
      setServerResponse(null);
      setFormData(null);
    }
    if (selectedApplication) {
      return dispatch(fetchApplication(modulesManager, ["id: \"".concat(decodeId(selectedApplication === null || selectedApplication === void 0 ? void 0 : selectedApplication.id), "\"")]));
    }
  }, [open]);
  useEffect(function () {
    if (open) {
      setFormData({});
      var roleIds = [];
      if (userType === "section_admin") {
        roleIds = ["17", "37"];
      } else if (userType === "section_admin_two") {
        roleIds = ["36", "39"];
      } else if (userType === "blwf_section_admin") {
        roleIds = ["42", "43"];
      }
      if (roleIds.length > 0) {
        return dispatch(fetchWorkforceUserRoleWiseUser(modulesManager, {
          roleIds: roleIds || [],
          orderBy: "id"
        }));
      }
    }
  }, [open, userType]);
  useSelector(function (state) {
    var _state$workforce;
    return (_state$workforce = state.workforce["application"]) !== null && _state$workforce !== void 0 ? _state$workforce : [];
  });
  var handleForward = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _iterator, _step, encodedId, updateApplicationData, createApplicationMovementData;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            setSubmitting(true);
            if (formData !== null && formData !== void 0 && formData.userId) {
              _context.next = 5;
              break;
            }
            setServerResponse({
              status: "ERROR",
              message: "অফিসার নির্বাচন করুন!"
            });
            return _context.abrupt("return");
          case 5:
            _iterator = _createForOfIteratorHelper$9(selectedApplicationIds);
            _context.prev = 6;
            _iterator.s();
          case 8:
            if ((_step = _iterator.n()).done) {
              _context.next = 18;
              break;
            }
            encodedId = _step.value;
            updateApplicationData = {
              id: safeDecodeId(encodedId === null || encodedId === void 0 ? void 0 : encodedId.id),
              status: WORKFORCE_STATUS$1.FORWARD_FOR_VERIFICATION
            };
            _context.next = 13;
            return dispatch(updateApplication(updateApplicationData, "update workforce application"));
          case 13:
            createApplicationMovementData = {
              applicationId: safeDecodeId(encodedId === null || encodedId === void 0 ? void 0 : encodedId.id),
              applicationFromId: loggedInUserId,
              applicationToId: formData.userId,
              status: WORKFORCE_STATUS$1.FORWARD_FOR_VERIFICATION,
              action: "forward_for_verification"
            };
            _context.next = 16;
            return dispatch(createApplicationMovement(createApplicationMovementData, "create workforce movement"));
          case 16:
            _context.next = 8;
            break;
          case 18:
            _context.next = 23;
            break;
          case 20:
            _context.prev = 20;
            _context.t0 = _context["catch"](6);
            _iterator.e(_context.t0);
          case 23:
            _context.prev = 23;
            _iterator.f();
            return _context.finish(23);
          case 26:
            setServerResponse({
              status: "SUCCESS",
              message: "সাবমিশন সফল হয়েছে!"
            });
            _context.next = 33;
            break;
          case 29:
            _context.prev = 29;
            _context.t1 = _context["catch"](0);
            console.error("Forwarding error:", _context.t1);
            setServerResponse({
              status: "ERROR",
              message: "সাবমিশন ব্যর্থ হয়েছে!"
            });
          case 33:
            _context.prev = 33;
            setSubmitting(false);
            return _context.finish(33);
          case 36:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 29, 33, 36], [6, 20, 23, 26]]);
    }));
    return function handleForward() {
      return _ref2.apply(this, arguments);
    };
  }();
  useEffect(function () {
    if ((serverResponse === null || serverResponse === void 0 ? void 0 : serverResponse.status) === "SUCCESS") {
      setTimeout(function () {
        // window.location.reload();
        // historyPush(modulesManager, history, "/home")
        history.push("/");
      }, 2000);
    }
  }, [serverResponse]);
  console.log({
    newwwwwwwww: selectedApplicationIds
  });
  return /*#__PURE__*/React.createElement(Modal, {
    open: open,
    onClose: onClose
  }, /*#__PURE__*/React.createElement("form", {
    className: classes.modalContainer
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: onClose,
    className: classes.closeButton
  }, "\u2715"), /*#__PURE__*/React.createElement(Typography, {
    variant: "h5",
    gutterBottom: true,
    style: {
      fontWeight: "bold",
      marginTop: 3,
      textAlign: "center"
    }
  }, "\u0995\u09B0\u09CD\u09AE\u09AC\u09A8\u09CD\u099F\u09A8"), /*#__PURE__*/React.createElement(Typography, {
    variant: "body1",
    color: "textSecondary",
    gutterBottom: true,
    style: {
      fontWeight: 600,
      marginTop: 3,
      textAlign: "center"
    }
  }, selectedApplication && "".concat((selectedApplication === null || selectedApplication === void 0 || (_selectedApplication$ = selectedApplication.workforceEmployee) === null || _selectedApplication$ === void 0 ? void 0 : _selectedApplication$.firstNameBn) || "আবেদনকারী", " \u098F\u09B0 \u0986\u09AC\u09C7\u09A6\u09A8 \u09AB\u09C7\u09B0\u09A4 \u09AA\u09BE\u09A0\u09BE\u09A4\u09C7 \u099A\u09BE\u09A8?")), (serverResponse === null || serverResponse === void 0 ? void 0 : serverResponse.status) && /*#__PURE__*/React.createElement(Typography, {
    className: classes.responseMessage,
    style: {
      color: serverResponse.status === "SUCCESS" ? "green" : "red"
    }
  }, serverResponse.status === "SUCCESS" ? "✅" : "⚠️", " ", serverResponse.message), /*#__PURE__*/React.createElement(Divider, {
    style: {
      marginBottom: 24
    }
  }), /*#__PURE__*/React.createElement(Paper, {
    className: classes.sectionPaper,
    elevation: 1
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 3,
    style: {
      marginTop: 3
    }
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle1",
    gutterBottom: true,
    style: {
      fontWeight: "bold",
      marginTop: 3,
      textAlign: "center"
    }
  }, !isEisPath() ? "উপ-সহকারী পরিচালক/ ডাটা এন্ট্রি অপারেটর নির্বাচন করুন" : "অফিসার নির্বাচন করুন"), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 12
  }, /*#__PURE__*/React.createElement(FormControl, {
    fullWidth: true
  }, /*#__PURE__*/React.createElement(Select, {
    value: (formData === null || formData === void 0 ? void 0 : formData.userId) || "",
    onChange: function onChange(e) {
      return setFormData(_objectSpread$O(_objectSpread$O({}, formData), {}, {
        userId: e.target.value
      }));
    },
    displayEmpty: true
  }, /*#__PURE__*/React.createElement(MenuItem, {
    value: ""
  }, /*#__PURE__*/React.createElement("em", null, !isEisPath() ? "উপ-সহকারী পরিচালক/ ডাটা এন্ট্রি অপারেটর নির্বাচন করুন" : "অফিসার নির্বাচন করুন")), officers.map(function (officer) {
    return /*#__PURE__*/React.createElement(MenuItem, {
      key: officer.id,
      value: officer.userId
    }, officer.otherNames);
  })))))), /*#__PURE__*/React.createElement("div", {
    className: classes.buttonGroup
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: onClose,
    variant: "outlined",
    color: "secondary"
  }, "\u09AC\u09BE\u09A4\u09BF\u09B2 \u0995\u09B0\u09C1\u09A8"), /*#__PURE__*/React.createElement(Button, {
    type: "submit",
    variant: "contained",
    color: "primary",
    disabled: submitting,
    onClick: (/*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(e) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              e.preventDefault();
              _context2.next = 3;
              return handleForward();
            case 3:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return function (_x) {
        return _ref3.apply(this, arguments);
      };
    }())
  }, submitting ? "ফরওয়ার্ড করা হচ্ছে..." : "ফরওয়ার্ড করুন"))));
};

function ownKeys$N(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$N(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$N(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$N(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _createForOfIteratorHelper$8(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray$8(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray$8(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray$8(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray$8(r, a) : void 0; } }
function _arrayLikeToArray$8(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var useStyles$W = makeStyles(function (theme) {
  return {
    modalContainer: {
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      width: 700,
      maxHeight: "90vh",
      backgroundColor: theme.palette.background.paper,
      borderRadius: theme.spacing(1.5),
      boxShadow: theme.shadows[5],
      padding: theme.spacing(4),
      overflowY: "auto"
    },
    closeButton: {
      position: "absolute",
      top: theme.spacing(1),
      right: theme.spacing(1),
      minWidth: 0,
      padding: theme.spacing(0.5, 1),
      fontSize: "1.2rem"
    },
    sectionPaper: {
      padding: theme.spacing(3),
      marginBottom: theme.spacing(3),
      borderRadius: theme.spacing(1),
      backgroundColor: theme.palette.grey[50]
    },
    buttonGroup: {
      marginTop: theme.spacing(3),
      display: "flex",
      justifyContent: "flex-end",
      gap: theme.spacing(2)
    },
    responseMessage: {
      marginBottom: theme.spacing(2),
      fontWeight: 600
    }
  };
});
var ForwardApplicationEisCoordinatorModal = function ForwardApplicationEisCoordinatorModal(_ref) {
  var open = _ref.open,
    onClose = _ref.onClose,
    selectedApplication = _ref.selectedApplication,
    selectedApplicationIds = _ref.selectedApplicationIds;
    _ref.onSubmitForward;
    var userRights = _ref.userRights,
    summaryId = _ref.summaryId,
    roleIds = _ref.roleIds;
  var classes = useStyles$W();
  var dispatch = useDispatch();
  var history = useHistory();
  var modulesManager = useModulesManager();
  var _useState = useState(""),
    _useState2 = _slicedToArray(_useState, 2);
    _useState2[0];
    var setEditorContent = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    submitting = _useState4[0],
    setSubmitting = _useState4[1];
  var _useState5 = useState(null),
    _useState6 = _slicedToArray(_useState5, 2),
    serverResponse = _useState6[0],
    setServerResponse = _useState6[1];
  var _useState7 = useState(""),
    _useState8 = _slicedToArray(_useState7, 2);
    _useState8[0];
    _useState8[1];
  var _useState9 = useState(null),
    _useState10 = _slicedToArray(_useState9, 2),
    formData = _useState10[0],
    setFormData = _useState10[1];
  var userType = getUserTypeFromRights(userRights);
  var loggedInUserId = useSelector(function (state) {
    var _state$core;
    return (_state$core = state.core) === null || _state$core === void 0 || (_state$core = _state$core.user) === null || _state$core === void 0 || (_state$core = _state$core.i_user) === null || _state$core === void 0 ? void 0 : _state$core.id;
  });
  var officers = useSelector(function (state) {
    return state.workforce.roleWiseUsers || [];
  });
  console.log("jjjjjjjjj", officers);
  useEffect(function () {
    if (!open) {
      setEditorContent("");
      setSubmitting(false);
      setServerResponse(null);
      setFormData(null);
    }
    if (selectedApplication) {
      return dispatch(fetchApplication(modulesManager, ["id: \"".concat(safeDecodeId(selectedApplication === null || selectedApplication === void 0 ? void 0 : selectedApplication.id), "\"")]));
    }
  }, [open]);
  useEffect(function () {
    if (open) {
      var _roleIds;
      setFormData({});
      console.log("role id pathaisi", roleIds);
      if (userType === "eis_coordinator") {
        roleIds = roleIds;
      }
      if (((_roleIds = roleIds) === null || _roleIds === void 0 ? void 0 : _roleIds.length) > 0) {
        return dispatch(fetchWorkforceUserRoleWiseUser(modulesManager, {
          roleIds: roleIds,
          orderBy: "id"
        }));
      }
    }
  }, [open, userType]);
  useSelector(function (state) {
    var _state$workforce;
    return (_state$workforce = state.workforce["application"]) !== null && _state$workforce !== void 0 ? _state$workforce : [];
  });
  console.log("commitsummaryId", summaryId);
  var handleForward = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var numericRoleIds, forwardStatus, forwardAction, _iterator, _step, encodedId, updateApplicationData, userId, createApplicationMovementData, updateApplicationSummaryData;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            numericRoleIds = roleIds.map(function (id) {
              return Number(id);
            });
            setSubmitting(true);
            _context2.prev = 2;
            if (formData !== null && formData !== void 0 && formData.userId) {
              _context2.next = 6;
              break;
            }
            setServerResponse({
              status: "ERROR",
              message: "অফিসার নির্বাচন করুন!"
            });
            return _context2.abrupt("return");
          case 6:
            // Determine status + action from roleIds
            forwardStatus = "";
            forwardAction = "";
            if (!numericRoleIds.includes(47)) {
              _context2.next = 13;
              break;
            }
            forwardStatus = WORKFORCE_STATUS$1.FORWARD_FOR_VERIFICATION;
            forwardAction = "forward_for_verification";
            _context2.next = 20;
            break;
          case 13:
            if (!numericRoleIds.includes(49)) {
              _context2.next = 18;
              break;
            }
            forwardStatus = WORKFORCE_STATUS$1.FORWARD_TO_COMIITTEE;
            forwardAction = "forward_to_committee";
            _context2.next = 20;
            break;
          case 18:
            setServerResponse({
              status: "ERROR",
              message: "সঠিক রোল আইডি পাওয়া যায়নি!"
            });
            return _context2.abrupt("return");
          case 20:
            _iterator = _createForOfIteratorHelper$8(selectedApplicationIds);
            _context2.prev = 21;
            _iterator.s();
          case 23:
            if ((_step = _iterator.n()).done) {
              _context2.next = 38;
              break;
            }
            encodedId = _step.value;
            updateApplicationData = {
              id: safeDecodeId(encodedId === null || encodedId === void 0 ? void 0 : encodedId.id),
              status: forwardStatus
            };
            _context2.next = 28;
            return dispatch(updateApplication(updateApplicationData, "update workforce application"));
          case 28:
            // for (const userId of formData.userIds) {
            userId = formData === null || formData === void 0 ? void 0 : formData.userId;
            createApplicationMovementData = {
              applicationId: safeDecodeId(encodedId === null || encodedId === void 0 ? void 0 : encodedId.id),
              applicationFromId: loggedInUserId,
              applicationToId: userId,
              status: forwardStatus,
              action: forwardAction
            };
            _context2.next = 32;
            return dispatch(createApplicationMovement(createApplicationMovementData, "create workforce movement"));
          case 32:
            if (!(summaryId && numericRoleIds.includes(49))) {
              _context2.next = 36;
              break;
            }
            updateApplicationSummaryData = {
              id: safeDecodeId(summaryId),
              status: WORKFORCE_STATUS$1.FORWARD_TO_COMIITEE
            };
            _context2.next = 36;
            return dispatch(updateApplicationSummary(updateApplicationSummaryData, "update summary"));
          case 36:
            _context2.next = 23;
            break;
          case 38:
            _context2.next = 43;
            break;
          case 40:
            _context2.prev = 40;
            _context2.t0 = _context2["catch"](21);
            _iterator.e(_context2.t0);
          case 43:
            _context2.prev = 43;
            _iterator.f();
            return _context2.finish(43);
          case 46:
            setServerResponse({
              status: "SUCCESS",
              message: "সাবমিশন সফল হয়েছে!"
            });
            _context2.next = 53;
            break;
          case 49:
            _context2.prev = 49;
            _context2.t1 = _context2["catch"](2);
            console.error("Forwarding error:", _context2.t1);
            setServerResponse({
              status: "ERROR",
              message: "সাবমিশন ব্যর্থ হয়েছে!"
            });
          case 53:
            _context2.prev = 53;
            setSubmitting(false);
            onClose();
            return _context2.finish(53);
          case 57:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[2, 49, 53, 57], [21, 40, 43, 46]]);
    }));
    return function handleForward() {
      return _ref3.apply(this, arguments);
    };
  }();
  useEffect(function () {
    if ((serverResponse === null || serverResponse === void 0 ? void 0 : serverResponse.status) === "SUCCESS") {
      setTimeout(function () {
        // window.location.reload();
        history.push("/");
      }, 2000);
    }
  }, [serverResponse]);
  console.log({
    newwwwwwwww: selectedApplicationIds
  });
  return /*#__PURE__*/React.createElement(Modal, {
    open: open,
    onClose: onClose
  }, /*#__PURE__*/React.createElement("form", {
    className: classes.modalContainer
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: onClose,
    className: classes.closeButton
  }, "\u2715"), /*#__PURE__*/React.createElement(Typography, {
    variant: "h5",
    gutterBottom: true,
    style: {
      fontWeight: "bold",
      marginTop: 3,
      textAlign: "center"
    }
  }, "\u0995\u09B0\u09CD\u09AE\u09AC\u09A8\u09CD\u099F\u09A8"), /*#__PURE__*/React.createElement(Typography, {
    variant: "body1",
    color: "textSecondary",
    gutterBottom: true,
    style: {
      fontWeight: 600,
      marginTop: 3,
      textAlign: "center"
    }
  }), (serverResponse === null || serverResponse === void 0 ? void 0 : serverResponse.status) && /*#__PURE__*/React.createElement(Typography, {
    className: classes.responseMessage,
    style: {
      color: serverResponse.status === "SUCCESS" ? "green" : "red"
    }
  }, serverResponse.status === "SUCCESS" ? "✅" : "⚠️", " ", serverResponse.message), /*#__PURE__*/React.createElement(Divider, {
    style: {
      marginBottom: 24
    }
  }), /*#__PURE__*/React.createElement(Paper, {
    className: classes.sectionPaper,
    elevation: 1
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 3,
    style: {
      marginTop: 3
    }
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle1",
    gutterBottom: true,
    style: {
      fontWeight: "bold",
      marginTop: 3,
      textAlign: "center"
    }
  }, "\u0985\u09AB\u09BF\u09B8\u09BE\u09B0 \u09A8\u09BF\u09B0\u09CD\u09AC\u09BE\u099A\u09A8 \u0995\u09B0\u09C1\u09A8"), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 12
  }, /*#__PURE__*/React.createElement(FormControl, {
    fullWidth: true
  }, /*#__PURE__*/React.createElement(Select
  // multiple
  , {
    value: (formData === null || formData === void 0 ? void 0 : formData.userId) || "",
    onChange: function onChange(e) {
      return setFormData(_objectSpread$N(_objectSpread$N({}, formData), {}, {
        userId: e.target.value
      }));
    },
    renderValue: function renderValue(selected) {
      return officers.filter(function (officer) {
        return selected.includes(officer.userId);
      }).map(function (officer) {
        return officer.otherNames;
      }).join(", ");
    },
    displayEmpty: true,
    MenuProps: {
      PaperProps: {
        style: {
          backgroundColor: "#fff",
          color: "#000"
        }
      }
    }
  }, officers.map(function (officer) {
    return (
      /*#__PURE__*/
      // <MenuItem key={officer.id} value={officer.userId}>
      //   <Checkbox
      //     checked={formData?.userIds?.includes(officer.userId)}
      //     style={{ color: "#000" }} // checkbox tick color
      //   />
      //   <Typography style={{ color: "#000" }}>
      //     {officer.otherNames}
      //   </Typography>
      // </MenuItem>
      React.createElement(MenuItem, {
        key: officer.id,
        value: officer.userId
      }, /*#__PURE__*/React.createElement(Typography, {
        style: {
          color: "#000"
        }
      }, officer.otherNames))
    );
  })))))), /*#__PURE__*/React.createElement("div", {
    className: classes.buttonGroup
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: onClose,
    variant: "outlined",
    color: "secondary"
  }, "\u09AC\u09BE\u09A4\u09BF\u09B2 \u0995\u09B0\u09C1\u09A8"), /*#__PURE__*/React.createElement(Button, {
    type: "submit",
    variant: "contained",
    color: "primary",
    disabled: submitting,
    onClick: (/*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3(e) {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              e.preventDefault();
              _context3.next = 3;
              return handleForward();
            case 3:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      return function (_x2) {
        return _ref4.apply(this, arguments);
      };
    }())
  }, submitting ? "ফরওয়ার্ড করা হচ্ছে..." : "ফরওয়ার্ড করুন"))));
};

var useStyles$V = makeStyles(function (theme) {
  return {
    modalContainer: {
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      width: 700,
      maxHeight: "90vh",
      backgroundColor: theme.palette.background.paper,
      borderRadius: theme.spacing(1.5),
      boxShadow: theme.shadows[5],
      padding: theme.spacing(4),
      overflowY: "auto"
    },
    closeButton: {
      position: "absolute",
      top: theme.spacing(1),
      right: theme.spacing(1),
      minWidth: 0,
      padding: theme.spacing(0.5, 1),
      fontSize: "1.2rem"
    },
    sectionPaper: {
      padding: theme.spacing(3),
      marginBottom: theme.spacing(3),
      borderRadius: theme.spacing(1),
      backgroundColor: theme.palette.grey[50]
    },
    buttonGroup: {
      marginTop: theme.spacing(3),
      display: "flex",
      justifyContent: "flex-end",
      gap: theme.spacing(2)
    },
    responseMessage: {
      marginBottom: theme.spacing(2),
      fontWeight: 600
    }
  };
});
var ForwardApplicationApproverAdminModal = function ForwardApplicationApproverAdminModal(_ref) {
  var open = _ref.open,
    onClose = _ref.onClose,
    selectedApplication = _ref.selectedApplication;
    _ref.onSubmitForward;
  var classes = useStyles$V();
  var dispatch = useDispatch();
  var modulesManager = useModulesManager();
  var _useState = useState(""),
    _useState2 = _slicedToArray(_useState, 2);
    _useState2[0];
    var setEditorContent = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    submitting = _useState4[0],
    setSubmitting = _useState4[1];
  var _useState5 = useState(null),
    _useState6 = _slicedToArray(_useState5, 2),
    serverResponse = _useState6[0],
    setServerResponse = _useState6[1];
  var _useState7 = useState(""),
    _useState8 = _slicedToArray(_useState7, 2),
    officeType = _useState8[0];
    _useState8[1];
  var _useState9 = useState(null),
    _useState10 = _slicedToArray(_useState9, 2),
    formData = _useState10[0],
    setFormData = _useState10[1];
  useEffect(function () {
    if (!open) {
      setEditorContent("");
      setSubmitting(false);
      setServerResponse(null);
      setFormData(null);
    }
    if (selectedApplication) {
      return dispatch(fetchApplication(modulesManager, ["id: \"".concat(decodeId(selectedApplication === null || selectedApplication === void 0 ? void 0 : selectedApplication.id), "\"")]));
    }
  }, [open]);
  useSelector(function (state) {
    var _state$workforce;
    return (_state$workforce = state.workforce["application"]) !== null && _state$workforce !== void 0 ? _state$workforce : [];
  });
  var handleSubmit = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(e) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            e.preventDefault();
            setSubmitting(true);
            //   const response = await onSubmitForward(payload);
            //   setServerResponse(response);
            // } catch {
            //   setServerResponse({ status: "ERROR", message: "সাবমিশনে ব্যর্থ হয়েছে!" });
            // } finally {
            //   setSubmitting(false);
            // }
          case 3:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function handleSubmit(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  var handleForward = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var updateApplicationData, createApplicationMovementData;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            updateApplicationData = {
              id: decodeId(selectedApplication.id),
              status: WORKFORCE_STATUS$1.DG_APPROVED
            };
            createApplicationMovementData = {
              applicationId: decodeId(selectedApplication.id),
              status: WORKFORCE_STATUS$1.DG_APPROVED,
              note: "আবেদন ডিজির কাছে প্রেরণ করা হয়েছে",
              action: "send_for_dg_approve"
            };
            _context2.next = 4;
            return dispatch(updateApplication(updateApplicationData, "update workforce application"));
          case 4:
            _context2.next = 6;
            return dispatch(createApplicationMovement(createApplicationMovementData, "create workforce movement"));
          case 6:
            setServerResponse({
              status: "SUCCESS",
              message: "সাবমিশন সফল হয়েছে!"
            });
          case 7:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function handleForward() {
      return _ref3.apply(this, arguments);
    };
  }();
  useEffect(function () {
    if ((serverResponse === null || serverResponse === void 0 ? void 0 : serverResponse.status) === "SUCCESS") {
      setTimeout(function () {
        window.location.reload();
      }, 2000);
    }
  }, [serverResponse]);
  console.log({
    aha: selectedApplication
  });
  return /*#__PURE__*/React.createElement(Modal, {
    open: open,
    onClose: onClose
  }, /*#__PURE__*/React.createElement("form", {
    className: classes.modalContainer,
    onSubmit: handleSubmit
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: onClose,
    className: classes.closeButton
  }, "\u2715"), /*#__PURE__*/React.createElement(Typography, {
    variant: "h5",
    gutterBottom: true,
    style: {
      fontWeight: "bold",
      marginTop: 3,
      textAlign: "center"
    }
  }, "\u09A1\u09BF\u099C\u09BF\u09B0 \u0985\u09AB\u09BF\u09B8\u09C7 \u09AA\u09BE\u09A0\u09BE\u09A8"), /*#__PURE__*/React.createElement(Typography, {
    variant: "body1",
    color: "textSecondary",
    gutterBottom: true,
    style: {
      fontWeight: 600,
      marginTop: 3,
      textAlign: "center"
    }
  }), (serverResponse === null || serverResponse === void 0 ? void 0 : serverResponse.status) && /*#__PURE__*/React.createElement(Typography, {
    className: classes.responseMessage,
    style: {
      color: serverResponse.status === "SUCCESS" ? "green" : "red"
    }
  }, serverResponse.status === "SUCCESS" ? "✅" : "⚠️", " ", serverResponse.message), /*#__PURE__*/React.createElement(Divider, {
    style: {
      marginBottom: 24
    }
  }), /*#__PURE__*/React.createElement(Paper, {
    className: classes.sectionPaper,
    elevation: 1
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 3,
    style: {
      marginTop: 3
    }
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle1",
    gutterBottom: true,
    style: {
      fontWeight: "bold",
      marginTop: 3,
      textAlign: "center"
    }
  }, "\u0985\u09AB\u09BF\u09B8\u09BE\u09B0 \u09A8\u09BF\u09B0\u09CD\u09AC\u09BE\u099A\u09A8 \u0995\u09B0\u09C1\u09A8"), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 12
  }, /*#__PURE__*/React.createElement(EmployeePicker, {
    value: formData === null || formData === void 0 ? void 0 : formData.id,
    officeType: officeType,
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.officer.selector.picker",
      module: "workforce"
    }),
    modulesManager: modulesManager,
    required: true,
    onChange: function onChange(v) {
      return setFormData(v);
    }
  })))), /*#__PURE__*/React.createElement("div", {
    className: classes.buttonGroup
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: onClose,
    variant: "outlined",
    color: "secondary"
  }, "\u09AC\u09BE\u09A4\u09BF\u09B2 \u0995\u09B0\u09C1\u09A8"), /*#__PURE__*/React.createElement(Button, {
    type: "submit",
    variant: "contained",
    color: "primary",
    disabled: submitting,
    onClick: handleForward
  }, submitting ? "ফরওয়ার্ড করা হচ্ছে..." : "ফরওয়ার্ড করুন"))));
};

var useStyles$U = makeStyles(function (theme) {
  return {
    modalContainer: {
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      width: 700,
      maxHeight: "90vh",
      backgroundColor: theme.palette.background.paper,
      borderRadius: theme.spacing(1.5),
      boxShadow: theme.shadows[5],
      padding: theme.spacing(4),
      overflowY: "auto"
    },
    closeButton: {
      position: "absolute",
      top: theme.spacing(1),
      right: theme.spacing(1),
      minWidth: 0,
      padding: theme.spacing(0.5, 1),
      fontSize: "1.2rem"
    },
    sectionPaper: {
      padding: theme.spacing(2),
      marginBottom: theme.spacing(3),
      borderRadius: theme.spacing(1),
      backgroundColor: theme.palette.grey[50],
      minHeight: "100px",
      // Give it a min-height to avoid layout shifts
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    },
    buttonGroup: {
      marginTop: theme.spacing(3),
      display: "flex",
      justifyContent: "flex-end",
      gap: theme.spacing(2)
    },
    responseMessage: {
      marginBottom: theme.spacing(2),
      fontWeight: 600
    }
  };
});

// No changes to RevertPathSelector needed
var RevertPathSelector = function RevertPathSelector(_ref) {
  var users = _ref.users,
    userType = _ref.userType,
    selectedUser = _ref.selectedUser,
    _onChange = _ref.onChange;
  return /*#__PURE__*/React.createElement(Paper, {
    elevation: 1,
    style: {
      padding: "15px",
      marginBottom: "20px"
    }
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle1",
    gutterBottom: true,
    style: {
      fontWeight: "bold"
    }
  }, "\u0986\u09AC\u09C7\u09A6\u09A8 \u0995\u09BE\u0995\u09C7 \u09AB\u09C7\u09B0\u09A4 \u09AA\u09BE\u09A0\u09BE\u09A4\u09C7 \u099A\u09BE\u09A8 \u09A8\u09BF\u09B0\u09CD\u09AC\u09BE\u099A\u09A8 \u0995\u09B0\u09C1\u09A8:"), users.length > 0 ? /*#__PURE__*/React.createElement(Breadcrumbs, {
    separator: /*#__PURE__*/React.createElement(NavigateNextIcon, {
      fontSize: "small"
    }),
    "aria-label": "breadcrumb"
  }, isBlwfPath() && [WORKFORCE_USER_TYPE.CHECKER, WORKFORCE_USER_TYPE.CHECKER_TWO, WORKFORCE_USER_TYPE.BLWF_CHECKER, WORKFORCE_USER_TYPE.SEC1_DEPUTI_ASST_DIRECTOR, WORKFORCE_USER_TYPE.SEC2_DEPUTI_ASST_DIRECTOR, WORKFORCE_USER_TYPE.BLWF_DEPUTI_ASST_DIRECTOR].includes(userType) ? users.filter(function (row) {
    return isBlwfPath() && [WORKFORCE_USER_TYPE.CHECKER, WORKFORCE_USER_TYPE.CHECKER_TWO, WORKFORCE_USER_TYPE.BLWF_CHECKER, WORKFORCE_USER_TYPE.SEC1_DEPUTI_ASST_DIRECTOR, WORKFORCE_USER_TYPE.SEC2_DEPUTI_ASST_DIRECTOR, WORKFORCE_USER_TYPE.BLWF_DEPUTI_ASST_DIRECTOR].includes(userType) && ["Section Admin", "Section Admin Two", "BLWF Section Admin", "S1 Asst Deputy Director", "S2 Asst Deputy Director"].includes(row === null || row === void 0 ? void 0 : row.role);
  }).map(function (user) {
    return /*#__PURE__*/React.createElement(FormControlLabel, {
      key: user.id,
      value: user.id,
      control: /*#__PURE__*/React.createElement(Radio, {
        checked: selectedUser === user.id,
        onChange: function onChange() {
          return _onChange(user.id);
        },
        style: {
          color: selectedUser === user.id ? "#1976d2" : "black"
        }
      }),
      label: /*#__PURE__*/React.createElement(Typography, {
        color: selectedUser === user.id ? "primary" : "inherit"
      }, user.name, " (", user.role, ")")
    });
  }) : isEisPath() && (userType === WORKFORCE_USER_TYPE.EIS_COMMITTEE || userType === WORKFORCE_USER_TYPE.EIS_ASSOCIATION_COMMITTEE) ? Array.from(new Map(users.filter(function (user) {
    return user.role === WORKFORCE_USER_TYPE.EIS_COORDINATOR || user.role === "Eis Coordinator";
  }).map(function (user) {
    return [user.id, user];
  })).values()).map(function (user) {
    return /*#__PURE__*/React.createElement(FormControlLabel, {
      key: user.id,
      value: user.id,
      control: /*#__PURE__*/React.createElement(Radio, {
        checked: selectedUser === user.id,
        onChange: function onChange() {
          return _onChange(user.id);
        },
        style: {
          color: selectedUser === user.id ? "#1976d2" : "black"
        }
      }),
      label: /*#__PURE__*/React.createElement(Typography, {
        color: selectedUser === user.id ? "primary" : "inherit"
      }, user.name, " (", user.role, ")")
    });
  }) : users.map(function (user) {
    return /*#__PURE__*/React.createElement(FormControlLabel, {
      key: user.id,
      value: user.id,
      control: /*#__PURE__*/React.createElement(Radio, {
        checked: selectedUser === user.id,
        onChange: function onChange() {
          return _onChange(user.id);
        },
        style: {
          color: selectedUser === user.id ? "#1976d2" : "black"
        }
      }),
      label: /*#__PURE__*/React.createElement(Typography, {
        color: selectedUser === user.id ? "primary" : "inherit"
      }, user.name, " (", user.role, ")")
    });
  })) : /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    color: "textSecondary"
  }, "No revert path available."));
};
var RevertApplicationModal = function RevertApplicationModal(_ref2) {
  var _selectedApplication$2, _selectedApplication$3, _selectedApplication$4, _selectedApplication$5;
  var open = _ref2.open,
    onClose = _ref2.onClose,
    selectedApplication = _ref2.selectedApplication;
  var classes = useStyles$U();
  var dispatch = useDispatch();
  var modulesManager = useModulesManager();
  var userId = useSelector(function (state) {
    var _state$core;
    return (_state$core = state.core) === null || _state$core === void 0 || (_state$core = _state$core.user) === null || _state$core === void 0 || (_state$core = _state$core.i_user) === null || _state$core === void 0 ? void 0 : _state$core.id;
  });
  var userType = getUserType();
  var _useState = useState(""),
    _useState2 = _slicedToArray(_useState, 2),
    editorContent = _useState2[0],
    setEditorContent = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    submitting = _useState4[0],
    setSubmitting = _useState4[1];
  var _useState5 = useState(null),
    _useState6 = _slicedToArray(_useState5, 2),
    serverResponse = _useState6[0],
    setServerResponse = _useState6[1];
  var _useState7 = useState(null),
    _useState8 = _slicedToArray(_useState7, 2),
    selectedRevertUser = _useState8[0],
    setSelectedRevertUser = _useState8[1];
  var _useState9 = useState([]),
    _useState10 = _slicedToArray(_useState9, 2),
    movementUsers = _useState10[0],
    setMovementUsers = _useState10[1];
  var _useState11 = useState(false),
    _useState12 = _slicedToArray(_useState11, 2),
    isLoadingPath = _useState12[0],
    setIsLoadingPath = _useState12[1]; // State to track loading

  var hasFetchedRef = useRef(false);
  var appIdDecoded = useMemo(function () {
    return selectedApplication !== null && selectedApplication !== void 0 && selectedApplication.id ? safeDecodeId(selectedApplication.id) : null;
  }, [selectedApplication === null || selectedApplication === void 0 ? void 0 : selectedApplication.id]);
  var applicantName = useMemo(function () {
    var _selectedApplication$;
    return (selectedApplication === null || selectedApplication === void 0 || (_selectedApplication$ = selectedApplication.workforceEmployee) === null || _selectedApplication$ === void 0 ? void 0 : _selectedApplication$.firstNameBn) || "আবেদনকারী";
  }, [selectedApplication === null || selectedApplication === void 0 || (_selectedApplication$2 = selectedApplication.workforceEmployee) === null || _selectedApplication$2 === void 0 ? void 0 : _selectedApplication$2.firstNameBn]);
  useHistory();
  useEffect(function () {
    if (!open) {
      hasFetchedRef.current = false;
      setMovementUsers([]);
      setSelectedRevertUser(null);
      setEditorContent("");
      setServerResponse(null);
      setSubmitting(false);
      setIsLoadingPath(false);
      return;
    }
    if (open && appIdDecoded && !hasFetchedRef.current) {
      hasFetchedRef.current = true;
      setIsLoadingPath(true); // Start loading

      dispatch(fetchApplicationWiseMovementList(modulesManager, {
        applicationId: appIdDecoded,
        orderBy: ["-dateCreated"]
      })).then(function (res) {
        var _res$payload;
        var edges = (res === null || res === void 0 || (_res$payload = res.payload) === null || _res$payload === void 0 || (_res$payload = _res$payload.data) === null || _res$payload === void 0 || (_res$payload = _res$payload.workforceApplicationMovement) === null || _res$payload === void 0 ? void 0 : _res$payload.edges) || [];
        var allUsers = edges.flatMap(function (_ref3) {
          var node = _ref3.node;
          return node.applicationTo ? [node.applicationTo] : [];
        }).filter(Boolean);
        console.log("reverted", res);
        var users = [{
          id: "applicant001",
          name: applicantName,
          role: "Applicant"
        }].concat(_toConsumableArray(allUsers.map(function (u) {
          var _u$userRoles;
          return {
            id: u.id,
            name: u.loginName,
            role: (u === null || u === void 0 || (_u$userRoles = u.userRoles) === null || _u$userRoles === void 0 || (_u$userRoles = _u$userRoles[0]) === null || _u$userRoles === void 0 || (_u$userRoles = _u$userRoles.role) === null || _u$userRoles === void 0 ? void 0 : _u$userRoles.name) || "User"
          };
        })));
        console.log({
          users: users
        });
        // Apply user type-based filtering
        // const filteredUsers = filterUsersByType(users);
        setMovementUsers(users);
      })["catch"](function (err) {
        console.error("fetchApplicationWiseMovementList failed", err);
        setServerResponse({
          status: "ERROR",
          message: "Failed to load user path."
        });
      })["finally"](function () {
        setIsLoadingPath(false);
      });
    }
  }, [open, appIdDecoded, applicantName, dispatch, modulesManager]);
  var handleRevert = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var updateApplicationData, createApplicationMovementData;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (selectedRevertUser) {
              _context.next = 3;
              break;
            }
            setServerResponse({
              status: "ERROR",
              message: "একজন ব্যবহারকারী নির্বাচন করুন!"
            });
            return _context.abrupt("return");
          case 3:
            setSubmitting(true);
            if (appIdDecoded) {
              _context.next = 8;
              break;
            }
            setServerResponse({
              status: "ERROR",
              message: "Application ID is missing."
            });
            setSubmitting(false);
            return _context.abrupt("return");
          case 8:
            updateApplicationData = {
              id: appIdDecoded,
              status: WORKFORCE_STATUS$1.REVERT
            };
            createApplicationMovementData = {
              applicationId: appIdDecoded,
              status: WORKFORCE_STATUS$1.REVERT,
              note: "আবেদন ফেরত পাঠানো হয়েছে",
              revertNote: editorContent,
              isReverted: true,
              applicationFromId: userId,
              applicationToId: safeDecodeId(selectedRevertUser)
            };
            console.log({
              createApplicationMovementData: createApplicationMovementData
            });
            _context.prev = 11;
            _context.next = 14;
            return dispatch(updateApplication(updateApplicationData, "update workforce application"));
          case 14:
            _context.next = 16;
            return dispatch(createApplicationMovement(createApplicationMovementData, "create workforce movement"));
          case 16:
            setServerResponse({
              status: "SUCCESS",
              message: "সাবমিশন সফল হয়েছে!"
            });
            setTimeout(function () {
              window.location.href = "/";
            }, 1000);
            // setTimeout(() => {
            //   onClose();
            //   history.push("/home");
            // }, 1000);
            _context.next = 24;
            break;
          case 20:
            _context.prev = 20;
            _context.t0 = _context["catch"](11);
            console.error(_context.t0);
            setServerResponse({
              status: "ERROR",
              message: "সাবমিশন ব্যর্থ হয়েছে"
            });
          case 24:
            _context.prev = 24;
            setSubmitting(false);
            return _context.finish(24);
          case 27:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[11, 20, 24, 27]]);
    }));
    return function handleRevert() {
      return _ref4.apply(this, arguments);
    };
  }();
  console.log("RevertModal rendering with:", {
    selectedApplication: selectedApplication,
    movementUsers: movementUsers
  });
  console.log({
    selectedRevertUser: selectedRevertUser
  });
  var applicantInfo = ["financialAssistance", "deadlyGrant"].includes(selectedApplication === null || selectedApplication === void 0 ? void 0 : selectedApplication.applicationType) ? safeParse(selectedApplication === null || selectedApplication === void 0 ? void 0 : selectedApplication.applicantInfo) : null;
  var applicationTypeString = "";
  if (isBlwfPath()) {
    var chosenApplicationType = blwfApplicationTypeOptions.find(function (option) {
      return option.value === (selectedApplication === null || selectedApplication === void 0 ? void 0 : selectedApplication.applicationType);
    });
    applicationTypeString = chosenApplicationType ? chosenApplicationType.label : "";
  } else if (isEisPath()) {
    var _chosenApplicationType = eisApplicationTypeOptions.find(function (option) {
      return option.value === (selectedApplication === null || selectedApplication === void 0 ? void 0 : selectedApplication.applicationType);
    });
    applicationTypeString = _chosenApplicationType ? _chosenApplicationType.label : "";
  } else {
    var _chosenApplicationType2 = cfApplicationTypeOptions.find(function (option) {
      return option.value === (selectedApplication === null || selectedApplication === void 0 ? void 0 : selectedApplication.applicationType);
    });
    applicationTypeString = _chosenApplicationType2 ? _chosenApplicationType2.label : "";
  }
  return /*#__PURE__*/React.createElement(Modal, {
    open: open,
    onClose: onClose
  }, /*#__PURE__*/React.createElement("form", {
    className: classes.modalContainer
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: onClose,
    className: classes.closeButton
  }, "\u2715"), /*#__PURE__*/React.createElement(Typography, {
    variant: "h5",
    gutterBottom: true,
    style: {
      fontWeight: "bold",
      marginTop: 3,
      textAlign: "center"
    }
  }, "\u0986\u09AC\u09C7\u09A6\u09A8 \u09AB\u09C7\u09B0\u09A4 \u09AA\u09BE\u09A0\u09BE\u09A8"), (serverResponse === null || serverResponse === void 0 ? void 0 : serverResponse.status) && /*#__PURE__*/React.createElement(Typography, {
    className: classes.responseMessage,
    style: {
      color: serverResponse.status === "SUCCESS" ? "green" : "red"
    }
  }, serverResponse.status === "SUCCESS" ? "✅" : "⚠️", " ", serverResponse.message), /*#__PURE__*/React.createElement(Divider, {
    style: {
      marginBottom: 15
    }
  }), /*#__PURE__*/React.createElement(Paper, {
    className: classes.sectionPaper,
    elevation: 1
  }, selectedApplication ? /*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle1",
    gutterBottom: true,
    style: {
      width: "100%"
    }
  }, applicantInfo !== null ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("b", null, "\u0986\u09AC\u09C7\u09A6\u09A8\u0995\u09BE\u09B0\u09C0\u09B0 \u09A8\u09BE\u09AE :"), " ", applicantInfo.nameBn || "N/A", " ", /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("b", null, "\u0986\u09AC\u09C7\u09A6\u09A8\u09C7\u09B0 \u09A7\u09B0\u09A8 :"), " ", applicationTypeString || "N/A", " ", /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("b", null, "\u099C\u09BE\u09A4\u09C0\u09AF\u09BC \u09AA\u09B0\u09BF\u099A\u09AF\u09BC\u09AA\u09A4\u09CD\u09B0 :"), " ", (applicantInfo === null || applicantInfo === void 0 ? void 0 : applicantInfo.nid) || "N/A", " ", /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("b", null, "\u09AB\u09CB\u09A8 \u09A8\u09AE\u09CD\u09AC\u09B0 :"), " ", (applicantInfo === null || applicantInfo === void 0 ? void 0 : applicantInfo.phoneNumber) || "N/A", " ", /*#__PURE__*/React.createElement("br", null)) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("b", null, "\u0986\u09AC\u09C7\u09A6\u09A8\u0995\u09BE\u09B0\u09C0\u09B0 \u09A8\u09BE\u09AE :"), " ", (selectedApplication === null || selectedApplication === void 0 || (_selectedApplication$3 = selectedApplication.workforceEmployee) === null || _selectedApplication$3 === void 0 ? void 0 : _selectedApplication$3.firstNameBn) || "N/A", " ", /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("b", null, "\u0986\u09AC\u09C7\u09A6\u09A8\u09C7\u09B0 \u09A7\u09B0\u09A8 :"), " ", applicationTypeString || "N/A", " ", /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("b", null, "\u099C\u09BE\u09A4\u09C0\u09AF\u09BC \u09AA\u09B0\u09BF\u099A\u09AF\u09BC\u09AA\u09A4\u09CD\u09B0 :"), " ", (selectedApplication === null || selectedApplication === void 0 || (_selectedApplication$4 = selectedApplication.workforceEmployee) === null || _selectedApplication$4 === void 0 ? void 0 : _selectedApplication$4.nid) || "N/A", " ", /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("b", null, "\u09AB\u09CB\u09A8 \u09A8\u09AE\u09CD\u09AC\u09B0 :"), " ", (selectedApplication === null || selectedApplication === void 0 || (_selectedApplication$5 = selectedApplication.workforceEmployee) === null || _selectedApplication$5 === void 0 ? void 0 : _selectedApplication$5.phoneNumber) || "N/A", " ", /*#__PURE__*/React.createElement("br", null))) : /*#__PURE__*/React.createElement(CircularProgress$1, {
    size: 24
  })), isLoadingPath ? /*#__PURE__*/React.createElement(Box$1, {
    display: "flex",
    justifyContent: "center",
    my: 4
  }, /*#__PURE__*/React.createElement(CircularProgress$1, null)) : /*#__PURE__*/React.createElement(RevertPathSelector, {
    users: movementUsers,
    userType: userType,
    selectedUser: selectedRevertUser,
    onChange: setSelectedRevertUser
  }), /*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle1",
    gutterBottom: true,
    style: {
      fontWeight: "bold",
      marginTop: 1,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.application.revert.reasons.addComment"
  })), /*#__PURE__*/React.createElement(Box$1, {
    sx: {
      width: "100%",
      mb: 7
    }
  }, /*#__PURE__*/React.createElement(ReactQuill, {
    value: editorContent,
    onChange: setEditorContent,
    theme: "snow",
    style: {
      height: "150px"
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.buttonGroup
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: onClose,
    variant: "outlined",
    color: "secondary"
  }, "\u09AC\u09BE\u09A4\u09BF\u09B2 \u0995\u09B0\u09C1\u09A8"), /*#__PURE__*/React.createElement(Button, {
    variant: "contained",
    color: "primary",
    disabled: submitting || !selectedApplication || isLoadingPath,
    onClick: handleRevert
  }, submitting ? "ফেরত পাঠানো হচ্ছে..." : "ফেরত পাঠান"))));
};

function _createForOfIteratorHelper$7(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray$7(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray$7(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray$7(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray$7(r, a) : void 0; } }
function _arrayLikeToArray$7(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys$M(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$M(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$M(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$M(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var useStyles$T = makeStyles(function (theme) {
  return {
    modalContainer: {
      position: "absolute",
      top: "5%",
      left: "50%",
      transform: "translateX(-50%)",
      width: "90%",
      maxWidth: 1400,
      height: "90vh",
      backgroundColor: theme.palette.background.paper,
      borderRadius: theme.spacing(1.5),
      boxShadow: theme.shadows[5],
      padding: theme.spacing(4),
      overflowY: "auto"
    },
    closeButton: {
      position: "absolute",
      top: theme.spacing(1),
      right: theme.spacing(1),
      minWidth: 0,
      padding: theme.spacing(0.5, 1),
      fontSize: "1.2rem"
    },
    sectionPaper: {
      padding: theme.spacing(3),
      marginBottom: theme.spacing(3),
      borderRadius: theme.spacing(1),
      backgroundColor: theme.palette.grey[50]
    },
    buttonGroup: {
      marginTop: theme.spacing(3),
      display: "flex",
      justifyContent: "flex-end",
      gap: theme.spacing(2)
    },
    responseMessage: {
      marginBottom: theme.spacing(2),
      fontWeight: 600
    }
  };
});
var ForwardApplicationSummaryModal = function ForwardApplicationSummaryModal(_ref) {
  var open = _ref.open,
    onClose = _ref.onClose,
    selectedApplication = _ref.selectedApplication,
    selectedApplicationIds = _ref.selectedApplicationIds;
    _ref.onSubmitForward;
    var userRights = _ref.userRights,
    roleIds = _ref.roleIds;
  var classes = useStyles$T();
  var dispatch = useDispatch();
  var applicationSummaryId = "";
  var modulesManager = useModulesManager();
  var _useState = useState(""),
    _useState2 = _slicedToArray(_useState, 2);
    _useState2[0];
    var setEditorContent = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    submitting = _useState4[0],
    setSubmitting = _useState4[1];
  var _useState5 = useState(null),
    _useState6 = _slicedToArray(_useState5, 2),
    serverResponse = _useState6[0],
    setServerResponse = _useState6[1];
  var _useState7 = useState([]),
    _useState8 = _slicedToArray(_useState7, 2),
    meetingList = _useState8[0],
    setMeetingList = _useState8[1];
  var locale = useSelector(function (state) {
    var _state$core;
    return ((_state$core = state.core) === null || _state$core === void 0 ? void 0 : _state$core.locale) || "bn";
  });
  var _useState9 = useState({
      roleIds: [],
      userIds: [],
      year: "",
      month: "",
      meetingName: "",
      meetingDate: null,
      committeeIds: ""
    }),
    _useState10 = _slicedToArray(_useState9, 2),
    formData = _useState10[0],
    setFormData = _useState10[1];
  useSelector(function (state) {
    var _state$workforce;
    return (_state$workforce = state.workforce["application"]) !== null && _state$workforce !== void 0 ? _state$workforce : [];
  });
  var userType = getUserTypeFromRights(userRights);
  var loggedInUserId = useSelector(function (state) {
    var _state$core2;
    return (_state$core2 = state.core) === null || _state$core2 === void 0 || (_state$core2 = _state$core2.user) === null || _state$core2 === void 0 || (_state$core2 = _state$core2.i_user) === null || _state$core2 === void 0 ? void 0 : _state$core2.id;
  });
  var _useState11 = useState([]),
    _useState12 = _slicedToArray(_useState11, 2),
    committees = _useState12[0],
    setCommittees = _useState12[1];
  var officersRaw = useSelector(function (state) {
    return state.workforce.roleWiseUsers;
  });
  var officers = officersRaw || [];
  var ROLE_OPTIONS = committees.map(function (committee) {
    return {
      id: safeDecodeId(committee.assignedRole.id),
      committeeId: committee === null || committee === void 0 ? void 0 : committee.id,
      name: committee.nameEn || committee.nameBn || committee.id
    };
  });
  useEffect(function () {
    if (!open) {
      setEditorContent("");
      setSubmitting(false);
      setServerResponse(null);
      setFormData({
        roleIds: [],
        userIds: [],
        year: "",
        month: "",
        meetingName: "",
        meetingDate: null,
        committeeIds: ""
      });
    } else {
      var organizationType = isEisPath() ? "eis" : isBlwfPath() ? "blwf" : "cf";
      if (userType === WORKFORCE_USER_TYPE.SECTION_ADMIN || userType === WORKFORCE_USER_TYPE.SECTION_ADMIN_TWO || userType === WORKFORCE_USER_TYPE.BLWF_SECTION_ADMIN) {
        dispatch(fetchWorkforceCommittees({
          organizationType: organizationType
        })).then(function (response) {
          var _response$payload;
          setCommittees((response === null || response === void 0 || (_response$payload = response.payload) === null || _response$payload === void 0 || (_response$payload = _response$payload.data) === null || _response$payload === void 0 ? void 0 : _response$payload.workforceCommittees) || []);
        });
      }
    }
    if (selectedApplication) {
      return dispatch(fetchApplication(modulesManager, ["id: \"".concat(decodeId(selectedApplication === null || selectedApplication === void 0 ? void 0 : selectedApplication.id), "\"")]));
    }
  }, [open, dispatch, modulesManager, selectedApplication, userType]);
  useEffect(function () {
    if ((userType === WORKFORCE_USER_TYPE.SECTION_ADMIN || userType === WORKFORCE_USER_TYPE.SECTION_ADMIN_TWO || userType === WORKFORCE_USER_TYPE.BLWF_SECTION_ADMIN) && officersRaw && Array.isArray(officersRaw)) {
      setFormData(function (prevData) {
        return _objectSpread$M(_objectSpread$M({}, prevData), {}, {
          userIds: officersRaw.map(function (o) {
            return o.userId;
          })
        });
      });
    }
  }, [officersRaw, userType]);
  useEffect(function () {
    if (userType !== WORKFORCE_USER_TYPE.SECTION_ADMIN && userType !== WORKFORCE_USER_TYPE.SECTION_ADMIN_TWO && userType !== WORKFORCE_USER_TYPE.BLWF_SECTION_ADMIN || !(formData !== null && formData !== void 0 && formData.roleIds) || formData.roleIds.length === 0) return;
    dispatch(fetchWorkforceUserRoleWiseUser(modulesManager, {
      roleIds: formData.roleIds,
      orderBy: "id"
    }));
  }, [formData.roleIds, dispatch, modulesManager, userType]);
  useEffect(function () {
    if (!open) return;
    dispatch(fetchApplicationPackage(modulesManager, ["organizationType: \"eis\"", 'orderBy: ["-meetingDate"]'])).then(function (response) {
      var _response$payload2;
      var meetings = (response === null || response === void 0 || (_response$payload2 = response.payload) === null || _response$payload2 === void 0 || (_response$payload2 = _response$payload2.data) === null || _response$payload2 === void 0 || (_response$payload2 = _response$payload2.workforceApplicationSummary) === null || _response$payload2 === void 0 ? void 0 : _response$payload2.edges) || [];
      var formattedMeetings = meetings.map(function (item) {
        return item.node;
      });
      var today = new Date();
      today.setHours(0, 0, 0, 0);
      var excludedStatuses = ["forward_to_doctor", "approved_by_committee"];
      var filteredMeetings = formattedMeetings.filter(function (meeting) {
        // if (!meeting?.meetingDate) return false;
        // const [year, month, day] = meeting.meetingDate.split("-").map(Number);
        // const meetingDate = new Date(year, month - 1, day);
        // const diffTime = meetingDate.getTime() - today.getTime();
        // const diffDays = diffTime / (1000 * 60 * 60 * 24);
        // return diffDays >= 3 
        // && 
        return !excludedStatuses.includes(meeting.status);
      });
      setMeetingList(filteredMeetings);
    });
  }, [open, dispatch, modulesManager]);
  useEffect(function () {
    console.log("meetingList UPDATED:", meetingList);
  }, [meetingList]);
  var handleSubmit = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(e) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            e.preventDefault();
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function handleSubmit(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  var handleForward = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var invalidApplication, forwardStatus, forwardAction, numericRoleIds, ids, createApplicationSummaryData, applicationSummeryMutation, applicationSummeryClientMutationId, _iterator, _step, encodedId, updateApplicationData, _iterator2, _step2, userId, createApplicationMovementData, _createApplicationMovementData;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            invalidApplication = selectedApplicationIds === null || selectedApplicationIds === void 0 ? void 0 : selectedApplicationIds.find(function (app) {
              return (app === null || app === void 0 ? void 0 : app.applicationType) === "disabilityAssistance" && (app === null || app === void 0 ? void 0 : app.status) !== "approved_by_doctor";
            });
            if (!invalidApplication) {
              _context2.next = 5;
              break;
            }
            alert("ডাক্তার দ্বারা সুপারিশকৃত ছাড়া স্থায়ী ও আংশিক অক্ষমতা জনিত আর্থিক সহায়তা আবেদন মিটিং এ পাঠানো যাবে না।");
            window.location.href = "/home";
            return _context2.abrupt("return");
          case 5:
            if (!(!(formData !== null && formData !== void 0 && formData.year) || !(formData !== null && formData !== void 0 && formData.month))) {
              _context2.next = 8;
              break;
            }
            setServerResponse({
              status: "ERROR",
              message: "সকল আবশ্যিক ফিল্ড পূরণ করুন।"
            });
            return _context2.abrupt("return");
          case 8:
            forwardStatus = userType === WORKFORCE_USER_TYPE.SECTION_ADMIN || userType === WORKFORCE_USER_TYPE.SECTION_ADMIN_TWO || userType === WORKFORCE_USER_TYPE.BLWF_SECTION_ADMIN ? WORKFORCE_STATUS$1.MEETING_CREATED : WORKFORCE_STATUS$1.FORWARD_TO_EIS_ADVISOR;
            forwardAction = "forward_to_comiitee";
            if (!(userType === WORKFORCE_USER_TYPE.SECTION_ADMIN || userType === WORKFORCE_USER_TYPE.SECTION_ADMIN_TWO || userType === WORKFORCE_USER_TYPE.BLWF_SECTION_ADMIN)) {
              _context2.next = 27;
              break;
            }
            if (!(!(formData !== null && formData !== void 0 && formData.userIds) || formData.userIds.length === 0)) {
              _context2.next = 14;
              break;
            }
            setServerResponse({
              status: "ERROR",
              message: "অফিসার নির্বাচন করুন!"
            });
            return _context2.abrupt("return");
          case 14:
            numericRoleIds = roleIds.map(function (id) {
              return Number(id);
            });
            if (!numericRoleIds.includes(47)) {
              _context2.next = 20;
              break;
            }
            forwardStatus = WORKFORCE_STATUS$1.FORWARD_FOR_VERIFICATION;
            forwardAction = "forward_for_verification";
            _context2.next = 27;
            break;
          case 20:
            if (!numericRoleIds.includes(49)) {
              _context2.next = 25;
              break;
            }
            forwardStatus = WORKFORCE_STATUS$1.FORWARD_TO_COMIITEE;
            forwardAction = "forward_to_committee";
            _context2.next = 27;
            break;
          case 25:
            setServerResponse({
              status: "ERROR",
              message: "সঠিক রোল আইডি পাওয়া যায়নি!"
            });
            return _context2.abrupt("return");
          case 27:
            setSubmitting(true);
            ids = selectedApplicationIds.map(function (obj) {
              return obj.id;
            });
            createApplicationSummaryData = {
              status: forwardStatus,
              name: formData === null || formData === void 0 ? void 0 : formData.meetingName,
              meetingDate: formData === null || formData === void 0 ? void 0 : formData.meetingDate,
              year: formData === null || formData === void 0 ? void 0 : formData.year,
              month: formData === null || formData === void 0 ? void 0 : formData.month,
              organizationType: userType === WORKFORCE_USER_TYPE.SECTION_ADMIN || userType === WORKFORCE_USER_TYPE.SECTION_ADMIN_TWO ? "cf" : userType === WORKFORCE_USER_TYPE.BLWF_SECTION_ADMIN ? "blwf" : "eis",
              sectionType: userType === WORKFORCE_USER_TYPE.SECTION_ADMIN ? "section_one" : userType === WORKFORCE_USER_TYPE.SECTION_ADMIN_TWO ? "section_two" : null,
              applicationData: JSON.stringify(ids),
              userIds: JSON.stringify(formData.userIds)
            };
            applicationSummeryMutation = formatMutation("createWorkforceApplicationSummary", formatApplicationSummaryGQL(createApplicationSummaryData), "create workforce application summary");
            applicationSummeryClientMutationId = applicationSummeryMutation.clientMutationId;
            _context2.next = 34;
            return dispatch(createApplicationSummary(applicationSummeryMutation, "create workforce application summary"));
          case 34:
            _context2.next = 36;
            return dispatch(fetchApplicationSummaryByClientMutationId(modulesManager, applicationSummeryClientMutationId)).then(function (response) {
              var _response$payload3;
              applicationSummaryId = response === null || response === void 0 || (_response$payload3 = response.payload) === null || _response$payload3 === void 0 || (_response$payload3 = _response$payload3.data) === null || _response$payload3 === void 0 || (_response$payload3 = _response$payload3.workforceApplicationSummary) === null || _response$payload3 === void 0 || (_response$payload3 = _response$payload3.edges) === null || _response$payload3 === void 0 || (_response$payload3 = _response$payload3[0]) === null || _response$payload3 === void 0 || (_response$payload3 = _response$payload3.node) === null || _response$payload3 === void 0 ? void 0 : _response$payload3.id;
            });
          case 36:
            if (applicationSummaryId) {
              _context2.next = 40;
              break;
            }
            setServerResponse({
              status: "ERROR",
              message: "সারাংশ তৈরি ব্যর্থ হয়েছে!"
            });
            setSubmitting(false);
            return _context2.abrupt("return");
          case 40:
            _iterator = _createForOfIteratorHelper$7(selectedApplicationIds);
            _context2.prev = 41;
            _iterator.s();
          case 43:
            if ((_step = _iterator.n()).done) {
              _context2.next = 74;
              break;
            }
            encodedId = _step.value;
            updateApplicationData = _objectSpread$M(_objectSpread$M({
              id: decodeId(encodedId === null || encodedId === void 0 ? void 0 : encodedId.id)
            }, userType === WORKFORCE_USER_TYPE.SECTION_ADMIN || userType === WORKFORCE_USER_TYPE.SECTION_ADMIN_TWO ? {
              cfApplicationSummaryId: decodeId(applicationSummaryId)
            } : userType === WORKFORCE_USER_TYPE.BLWF_SECTION_ADMIN ? {
              blwfApplicationSummaryId: decodeId(applicationSummaryId)
            } : {
              eisApplicationSummaryId: decodeId(applicationSummaryId)
            }), {}, {
              status: forwardStatus
            }, (userType === WORKFORCE_USER_TYPE.SECTION_ADMIN || userType === WORKFORCE_USER_TYPE.SECTION_ADMIN_TWO || userType === WORKFORCE_USER_TYPE.BLWF_SECTION_ADMIN) && {
              eisApprovalIds: JSON.stringify(formData.userIds),
              committeeId: safeDecodeId(formData === null || formData === void 0 ? void 0 : formData.committeeIds)
            });
            _context2.next = 48;
            return dispatch(updateApplication(updateApplicationData, "update workforce application"));
          case 48:
            if (!(userType === WORKFORCE_USER_TYPE.SECTION_ADMIN || userType === WORKFORCE_USER_TYPE.SECTION_ADMIN_TWO || userType === WORKFORCE_USER_TYPE.BLWF_SECTION_ADMIN)) {
              _context2.next = 69;
              break;
            }
            _iterator2 = _createForOfIteratorHelper$7(formData.userIds);
            _context2.prev = 50;
            _iterator2.s();
          case 52:
            if ((_step2 = _iterator2.n()).done) {
              _context2.next = 59;
              break;
            }
            userId = _step2.value;
            createApplicationMovementData = {
              applicationId: decodeId(encodedId === null || encodedId === void 0 ? void 0 : encodedId.id),
              applicationFromId: loggedInUserId,
              applicationToId: userId,
              status: forwardStatus,
              action: forwardAction
            };
            _context2.next = 57;
            return dispatch(createApplicationMovement(createApplicationMovementData, "create workforce movement"));
          case 57:
            _context2.next = 52;
            break;
          case 59:
            _context2.next = 64;
            break;
          case 61:
            _context2.prev = 61;
            _context2.t0 = _context2["catch"](50);
            _iterator2.e(_context2.t0);
          case 64:
            _context2.prev = 64;
            _iterator2.f();
            return _context2.finish(64);
          case 67:
            _context2.next = 72;
            break;
          case 69:
            _createApplicationMovementData = {
              applicationId: decodeId(encodedId === null || encodedId === void 0 ? void 0 : encodedId.id),
              status: forwardStatus,
              note: "আবেদন কমিটির কাছে প্রেরণ হয়েছে",
              action: forwardAction,
              applicationFromId: loggedInUserId,
              applicationToId: userType === WORKFORCE_USER_TYPE.SECTION_ADMIN_TWO ? 69 : userType === WORKFORCE_USER_TYPE.BLWF_SECTION_ADMIN ? 198 : 196,
              toRoleId: userType === WORKFORCE_USER_TYPE.CHECKER ? 23 : 48
            };
            _context2.next = 72;
            return dispatch(createApplicationMovement(_createApplicationMovementData, "update workforce movement"));
          case 72:
            _context2.next = 43;
            break;
          case 74:
            _context2.next = 79;
            break;
          case 76:
            _context2.prev = 76;
            _context2.t1 = _context2["catch"](41);
            _iterator.e(_context2.t1);
          case 79:
            _context2.prev = 79;
            _iterator.f();
            return _context2.finish(79);
          case 82:
            setServerResponse({
              status: "SUCCESS",
              message: "সাবমিশন সফল হয়েছে!"
            });
          case 83:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[41, 76, 79, 82], [50, 61, 64, 67]]);
    }));
    return function handleForward() {
      return _ref3.apply(this, arguments);
    };
  }();
  var handleSave = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      var ids, createApplicationSummarySheetData, applicationSummeryMutation, applicationSummeryClientMutationId, _iterator3, _step3, encodedId, updateApplicationData;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            if (!(!(formData !== null && formData !== void 0 && formData.year) || !(formData !== null && formData !== void 0 && formData.month))) {
              _context3.next = 3;
              break;
            }
            setServerResponse({
              status: "ERROR",
              message: "সকল আবশ্যিক ফিল্ড পূরণ করুন।"
            });
            return _context3.abrupt("return");
          case 3:
            setSubmitting(true);
            ids = selectedApplicationIds.map(function (obj) {
              return obj.id;
            });
            createApplicationSummarySheetData = {
              status: userType === WORKFORCE_USER_TYPE.SECTION_ADMIN || userType === WORKFORCE_USER_TYPE.SECTION_ADMIN_TWO || userType === WORKFORCE_USER_TYPE.BLWF_SECTION_ADMIN ? WORKFORCE_STATUS$1.MEETING_CREATED : WORKFORCE_STATUS$1.MEETING_CREATED,
              name: formData === null || formData === void 0 ? void 0 : formData.meetingName,
              meetingDate: formData === null || formData === void 0 ? void 0 : formData.meetingDate,
              year: Number(formData === null || formData === void 0 ? void 0 : formData.year),
              month: formData === null || formData === void 0 ? void 0 : formData.month,
              organizationType: userType === WORKFORCE_USER_TYPE.SECTION_ADMIN || userType === WORKFORCE_USER_TYPE.SECTION_ADMIN_TWO ? "cf" : userType === WORKFORCE_USER_TYPE.BLWF_SECTION_ADMIN ? "blwf" : "eis",
              sectionType: userType === WORKFORCE_USER_TYPE.SECTION_ADMIN ? "section_one" : userType === WORKFORCE_USER_TYPE.SECTION_ADMIN_TWO ? "section_two" : null,
              applicationData: JSON.stringify(ids)
            };
            applicationSummeryMutation = formatMutation("createWorkforceApplicationSummary", formatApplicationSummaryGQL(createApplicationSummarySheetData), "create workforce application summary");
            applicationSummeryClientMutationId = applicationSummeryMutation.clientMutationId;
            _context3.next = 10;
            return dispatch(createApplicationSummary(applicationSummeryMutation, "create workforce application summary sheet"));
          case 10:
            _context3.next = 12;
            return dispatch(fetchApplicationSummaryByClientMutationId(modulesManager, applicationSummeryClientMutationId)).then(function (response) {
              var _response$payload4;
              applicationSummaryId = response === null || response === void 0 || (_response$payload4 = response.payload) === null || _response$payload4 === void 0 || (_response$payload4 = _response$payload4.data) === null || _response$payload4 === void 0 || (_response$payload4 = _response$payload4.workforceApplicationSummary) === null || _response$payload4 === void 0 || (_response$payload4 = _response$payload4.edges) === null || _response$payload4 === void 0 || (_response$payload4 = _response$payload4[0]) === null || _response$payload4 === void 0 || (_response$payload4 = _response$payload4.node) === null || _response$payload4 === void 0 ? void 0 : _response$payload4.id;
            });
          case 12:
            if (applicationSummaryId) {
              _context3.next = 16;
              break;
            }
            setServerResponse({
              status: "ERROR",
              message: "সারাংশ তৈরি ব্যর্থ হয়েছে!"
            });
            setSubmitting(false);
            return _context3.abrupt("return");
          case 16:
            _iterator3 = _createForOfIteratorHelper$7(selectedApplicationIds);
            _context3.prev = 17;
            _iterator3.s();
          case 19:
            if ((_step3 = _iterator3.n()).done) {
              _context3.next = 26;
              break;
            }
            encodedId = _step3.value;
            updateApplicationData = _objectSpread$M(_objectSpread$M({
              id: decodeId(encodedId === null || encodedId === void 0 ? void 0 : encodedId.id)
            }, userType === WORKFORCE_USER_TYPE.SECTION_ADMIN || userType === WORKFORCE_USER_TYPE.SECTION_ADMIN_TWO ? {
              cfApplicationSummaryId: decodeId(applicationSummaryId)
            } : userType === WORKFORCE_USER_TYPE.BLWF_SECTION_ADMIN ? {
              blwfApplicationSummaryId: decodeId(applicationSummaryId)
            } : {
              eisApplicationSummaryId: decodeId(applicationSummaryId)
            }), {}, {
              status: WORKFORCE_STATUS$1.MEETING_CREATED
            });
            _context3.next = 24;
            return dispatch(updateApplication(updateApplicationData, "update workforce application"));
          case 24:
            _context3.next = 19;
            break;
          case 26:
            _context3.next = 31;
            break;
          case 28:
            _context3.prev = 28;
            _context3.t0 = _context3["catch"](17);
            _iterator3.e(_context3.t0);
          case 31:
            _context3.prev = 31;
            _iterator3.f();
            return _context3.finish(31);
          case 34:
            setServerResponse({
              status: "SUCCESS",
              message: "সাবমিশন সফল হয়েছে!"
            });
          case 35:
          case "end":
            return _context3.stop();
        }
      }, _callee3, null, [[17, 28, 31, 34]]);
    }));
    return function handleSave() {
      return _ref4.apply(this, arguments);
    };
  }();
  var handleAddApplication = /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee4(meetingId, meetingStatus) {
      var _iterator4, _step4, encodedId, updateData;
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            if (!(!selectedApplicationIds || selectedApplicationIds.length === 0)) {
              _context4.next = 3;
              break;
            }
            setServerResponse({
              status: "ERROR",
              message: "দয়া করে অন্তত একটি আবেদন নির্বাচন করুন।"
            });
            return _context4.abrupt("return");
          case 3:
            setSubmitting(true);
            _context4.prev = 4;
            _iterator4 = _createForOfIteratorHelper$7(selectedApplicationIds);
            _context4.prev = 6;
            _iterator4.s();
          case 8:
            if ((_step4 = _iterator4.n()).done) {
              _context4.next = 15;
              break;
            }
            encodedId = _step4.value;
            updateData = {
              id: decodeId(encodedId.id),
              eisApplicationSummaryId: decodeId(meetingId),
              status: meetingStatus
            };
            _context4.next = 13;
            return dispatch(updateApplication(updateData, "Update application summary"));
          case 13:
            _context4.next = 8;
            break;
          case 15:
            _context4.next = 20;
            break;
          case 17:
            _context4.prev = 17;
            _context4.t0 = _context4["catch"](6);
            _iterator4.e(_context4.t0);
          case 20:
            _context4.prev = 20;
            _iterator4.f();
            return _context4.finish(20);
          case 23:
            setServerResponse({
              status: "SUCCESS",
              message: "আবেদন সফলভাবে মিটিং এর সাথে যুক্ত হয়েছে।"
            });
            setTimeout(function () {
              window.location.reload();
            }, 2000);
            _context4.next = 31;
            break;
          case 27:
            _context4.prev = 27;
            _context4.t1 = _context4["catch"](4);
            console.error(_context4.t1);
            setServerResponse({
              status: "ERROR",
              message: "আবেদন মিটিং এর সাথে যুক্ত করতে ব্যর্থ হয়েছে।"
            });
          case 31:
            _context4.prev = 31;
            setSubmitting(false);
            return _context4.finish(31);
          case 34:
          case "end":
            return _context4.stop();
        }
      }, _callee4, null, [[4, 27, 31, 34], [6, 17, 20, 23]]);
    }));
    return function handleAddApplication(_x2, _x3) {
      return _ref5.apply(this, arguments);
    };
  }();
  var getStatusDisplay = function getStatusDisplay(status) {
    var statusMap = locale === "en" ? STATUS_MAP_EN : STATUS_MAP_BN;
    return statusMap[status] || status;
  };
  useEffect(function () {
    if ((serverResponse === null || serverResponse === void 0 ? void 0 : serverResponse.status) === "SUCCESS") {
      setTimeout(function () {
        window.location.reload();
      }, 2000);
    }
  }, [serverResponse]);
  console.log({
    newwwwwwwww: formData
  });
  console.log({
    roleIds: roleIds
  });
  return /*#__PURE__*/React.createElement(Modal, {
    open: open,
    onClose: onClose
  }, /*#__PURE__*/React.createElement("form", {
    className: classes.modalContainer,
    onSubmit: handleSubmit
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: onClose,
    className: classes.closeButton
  }, "\u2715"), /*#__PURE__*/React.createElement(Typography, {
    variant: "h5",
    gutterBottom: true,
    style: {
      fontWeight: "bold",
      marginTop: 3,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.employee.application.forwardToSelectionOffice"
  })), (serverResponse === null || serverResponse === void 0 ? void 0 : serverResponse.status) && /*#__PURE__*/React.createElement(Typography, {
    className: classes.responseMessage,
    style: {
      color: serverResponse.status === "SUCCESS" ? "green" : "red"
    }
  }, serverResponse.status === "SUCCESS" ? "✅" : "⚠️", " ", serverResponse.message), /*#__PURE__*/React.createElement(Divider, {
    style: {
      marginBottom: 24
    }
  }), /*#__PURE__*/React.createElement(Paper, {
    className: classes.sectionPaper,
    elevation: 1
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6",
    style: {
      fontWeight: "bold",
      marginBottom: 16
    }
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.employee.application.preMeetingList"
  })), /*#__PURE__*/React.createElement(Divider, {
    style: {
      marginBottom: 16
    }
  }), /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 2
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement("table", {
    style: {
      width: "100%",
      borderCollapse: "collapse",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", {
    style: {
      background: "#f5f5f5"
    }
  }, /*#__PURE__*/React.createElement("th", {
    style: {
      padding: 10
    }
  }, "\u09AE\u09BF\u099F\u09BF\u0982 \u09A8\u09BE\u09AE"), /*#__PURE__*/React.createElement("th", {
    style: {
      padding: 10
    }
  }, "\u09AC\u099B\u09B0"), /*#__PURE__*/React.createElement("th", {
    style: {
      padding: 10
    }
  }, "\u09AE\u09BE\u09B8"), /*#__PURE__*/React.createElement("th", {
    style: {
      padding: 10
    }
  }, "\u09AE\u09BF\u099F\u09BF\u0982 \u09A4\u09BE\u09B0\u09BF\u0996"), /*#__PURE__*/React.createElement("th", {
    style: {
      padding: 10
    }
  }, "\u09B8\u09CD\u099F\u09CD\u09AF\u09BE\u099F\u09BE\u09B8"), /*#__PURE__*/React.createElement("th", {
    style: {
      padding: 10
    }
  }, "\u0985\u09CD\u09AF\u09BE\u0995\u09B6\u09A8"))), /*#__PURE__*/React.createElement("tbody", null, meetingList === null || meetingList === void 0 ? void 0 : meetingList.map(function (meeting) {
    return /*#__PURE__*/React.createElement("tr", {
      key: meeting.id,
      style: {
        borderBottom: "1px solid #ddd"
      }
    }, /*#__PURE__*/React.createElement("td", {
      style: {
        padding: 10
      }
    }, meeting.name), /*#__PURE__*/React.createElement("td", {
      style: {
        padding: 10
      }
    }, meeting.year), /*#__PURE__*/React.createElement("td", {
      style: {
        padding: 10
      }
    }, meeting.month), /*#__PURE__*/React.createElement("td", {
      style: {
        padding: 10
      }
    }, meeting.meetingDate), /*#__PURE__*/React.createElement("td", {
      style: {
        padding: 10
      }
    }, /*#__PURE__*/React.createElement(Typography, {
      style: {
        background: "#e3f2fd",
        padding: "4px 10px",
        borderRadius: 6,
        display: "inline-block",
        fontSize: 12
      }
    }, getStatusDisplay(meeting.status))), /*#__PURE__*/React.createElement("td", {
      style: {
        padding: 10
      }
    }, /*#__PURE__*/React.createElement(Button, {
      size: "small",
      variant: "contained",
      color: "primary",
      onClick: function onClick() {
        return handleAddApplication(meeting.id, meeting.status);
      }
    }, /*#__PURE__*/React.createElement(FormattedMessage, {
      module: "workforce",
      id: "workforce.employee.application.addApplication"
    }))));
  })))))), /*#__PURE__*/React.createElement(Paper, {
    className: classes.sectionPaper,
    elevation: 1
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 3,
    style: {
      marginTop: 3
    }
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle1",
    gutterBottom: true,
    style: {
      fontWeight: "bold",
      marginTop: 3,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.employee.application.provideMeetingInfo"
  }))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 6
  }, /*#__PURE__*/React.createElement(TextField, {
    fullWidth: true,
    select: true,
    label: "\u09AC\u099B\u09B0",
    variant: "outlined",
    required: true,
    value: (formData === null || formData === void 0 ? void 0 : formData.year) || "",
    onChange: function onChange(e) {
      return setFormData(_objectSpread$M(_objectSpread$M({}, formData), {}, {
        year: e.target.value
      }));
    }
  }, _toConsumableArray(Array(21)).map(function (_, index) {
    var year = 2020 + index;
    return /*#__PURE__*/React.createElement(MenuItem, {
      key: year,
      value: year
    }, year);
  }))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 6
  }, /*#__PURE__*/React.createElement(TextField, {
    fullWidth: true,
    select: true,
    label: "\u09AE\u09BE\u09B8",
    variant: "outlined",
    required: true,
    value: (formData === null || formData === void 0 ? void 0 : formData.month) || "",
    onChange: function onChange(e) {
      return setFormData(_objectSpread$M(_objectSpread$M({}, formData), {}, {
        month: e.target.value
      }));
    }
  }, ["জানুয়ারি", "ফেব্রুয়ারি", "মার্চ", "এপ্রিল", "মে", "জুন", "জুলাই", "আগস্ট", "সেপ্টেম্বর", "অক্টোবর", "নভেম্বর", "ডিসেম্বর"].map(function (month, index) {
    return /*#__PURE__*/React.createElement(MenuItem, {
      key: index,
      value: month
    }, month);
  }))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 6
  }, /*#__PURE__*/React.createElement(TextField, {
    fullWidth: true,
    label: "\u09AE\u09BF\u099F\u09BF\u0982 \u098F\u09B0 \u09A8\u09BE\u09AE",
    variant: "outlined",
    value: (formData === null || formData === void 0 ? void 0 : formData.meetingName) || "",
    onChange: function onChange(e) {
      return setFormData(_objectSpread$M(_objectSpread$M({}, formData), {}, {
        meetingName: e.target.value
      }));
    }
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6,
    className: classes.item
  }, /*#__PURE__*/React.createElement(PublishedComponent, {
    pubRef: "workforce.DatePicker",
    label: "\u09AE\u09BF\u099F\u09BF\u0982 \u098F\u09B0 \u09A4\u09BE\u09B0\u09BF\u0996",
    readOnly: false,
    style: {
      fontSize: "1.5rem"
    },
    value: (formData === null || formData === void 0 ? void 0 : formData.meetingDate) || "",
    onChange: function onChange(v) {
      return setFormData(_objectSpread$M(_objectSpread$M({}, formData), {}, {
        meetingDate: v
      }));
    }
  })))), (userType === WORKFORCE_USER_TYPE.SECTION_ADMIN || userType === WORKFORCE_USER_TYPE.SECTION_ADMIN_TWO || userType === WORKFORCE_USER_TYPE.BLWF_SECTION_ADMIN) && /*#__PURE__*/React.createElement(Paper, {
    className: classes.sectionPaper,
    elevation: 1
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 3,
    style: {
      marginTop: 3
    }
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    style: {
      marginBottom: 16
    }
  }, /*#__PURE__*/React.createElement(FormControl, {
    fullWidth: true
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle1",
    style: {
      fontWeight: "bold"
    }
  }, "\u0995\u09AE\u09BF\u099F\u09BF \u09A8\u09BF\u09B0\u09CD\u09AC\u09BE\u099A\u09A8 \u0995\u09B0\u09C1\u09A8"), /*#__PURE__*/React.createElement(Select, {
    multiple: true,
    displayEmpty: true,
    value: (formData === null || formData === void 0 ? void 0 : formData.roleIds) || [],
    onChange: function onChange(e) {
      var _selectedRoleIds$map;
      var selectedRoleIds = e.target.value;
      var selectedCommitteeIds = (_selectedRoleIds$map = selectedRoleIds.map(function (roleId) {
        var _ROLE_OPTIONS$find;
        return (_ROLE_OPTIONS$find = ROLE_OPTIONS.find(function (r) {
          return r.id === roleId;
        })) === null || _ROLE_OPTIONS$find === void 0 ? void 0 : _ROLE_OPTIONS$find.committeeId;
      })) === null || _selectedRoleIds$map === void 0 ? void 0 : _selectedRoleIds$map[0];
      setFormData(_objectSpread$M(_objectSpread$M({}, formData), {}, {
        roleIds: selectedRoleIds,
        committeeIds: selectedCommitteeIds,
        userIds: []
      }));
    },
    renderValue: function renderValue(selected) {
      return ROLE_OPTIONS.filter(function (r) {
        return selected.includes(r.id);
      }).map(function (r) {
        return r.name;
      }).join(", ");
    },
    MenuProps: {
      PaperProps: {
        style: {
          backgroundColor: "#fff",
          color: "#000"
        }
      }
    }
  }, ROLE_OPTIONS.map(function (role) {
    var _formData$roleIds;
    return /*#__PURE__*/React.createElement(MenuItem, {
      key: role.id,
      value: role.id
    }, /*#__PURE__*/React.createElement(Checkbox, {
      checked: (formData === null || formData === void 0 || (_formData$roleIds = formData.roleIds) === null || _formData$roleIds === void 0 ? void 0 : _formData$roleIds.includes(role.id)) || false,
      style: {
        color: "#000"
      }
    }), /*#__PURE__*/React.createElement(Typography, null, role.name));
  })))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle1",
    gutterBottom: true,
    style: {
      fontWeight: "bold"
    }
  }, "\u0995\u09AE\u09BF\u099F\u09BF\u09B0 \u09AE\u09C7\u09AE\u09CD\u09AC\u09BE\u09B0 \u09A8\u09BF\u09B0\u09CD\u09AC\u09BE\u099A\u09A8 \u0995\u09B0\u09C1\u09A8"), /*#__PURE__*/React.createElement(FormControl, {
    fullWidth: true
  }, /*#__PURE__*/React.createElement(Select, {
    multiple: true,
    displayEmpty: true,
    value: (formData === null || formData === void 0 ? void 0 : formData.userIds) || [],
    onChange: function onChange(e) {
      return setFormData(_objectSpread$M(_objectSpread$M({}, formData), {}, {
        userIds: e.target.value
      }));
    },
    renderValue: function renderValue(selected) {
      return officers.filter(function (o) {
        return selected.includes(o.userId);
      }).map(function (o) {
        return o.otherNames;
      }).join(", ");
    },
    MenuProps: {
      PaperProps: {
        style: {
          backgroundColor: "#fff",
          color: "#000"
        }
      }
    }
  }, officers.map(function (officer) {
    var _formData$userIds;
    return /*#__PURE__*/React.createElement(MenuItem, {
      key: officer.id,
      value: officer.userId
    }, /*#__PURE__*/React.createElement(Checkbox, {
      checked: (formData === null || formData === void 0 || (_formData$userIds = formData.userIds) === null || _formData$userIds === void 0 ? void 0 : _formData$userIds.includes(officer.userId)) || false,
      style: {
        color: "#000"
      }
    }), /*#__PURE__*/React.createElement(Typography, null, officer.otherNames));
  })))))), /*#__PURE__*/React.createElement("div", {
    className: classes.buttonGroup
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: onClose,
    variant: "outlined",
    color: "secondary"
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "core.LanguageQuickPicker.dialog.cancel"
  })), /*#__PURE__*/React.createElement(Button, {
    variant: "outlined",
    color: "default",
    onClick: handleSave,
    disabled: submitting
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.save"
  })), /*#__PURE__*/React.createElement(Button, {
    type: "button",
    variant: "contained",
    color: "primary",
    disabled: submitting,
    onClick: handleForward
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.employee.application.forwardTo"
  })))));
};

function _createForOfIteratorHelper$6(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray$6(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray$6(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray$6(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray$6(r, a) : void 0; } }
function _arrayLikeToArray$6(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys$L(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$L(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$L(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$L(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var useStyles$S = makeStyles(function (theme) {
  return {
    modalContainer: {
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      width: 700,
      maxHeight: "90vh",
      backgroundColor: theme.palette.background.paper,
      borderRadius: theme.spacing(1.5),
      boxShadow: theme.shadows[5],
      padding: theme.spacing(4),
      overflowY: "auto"
    },
    closeButton: {
      position: "absolute",
      top: theme.spacing(1),
      right: theme.spacing(1),
      minWidth: 0,
      padding: theme.spacing(0.5, 1),
      fontSize: "1.2rem"
    },
    sectionPaper: {
      padding: theme.spacing(3),
      marginBottom: theme.spacing(3),
      borderRadius: theme.spacing(1),
      backgroundColor: theme.palette.grey[50]
    },
    buttonGroup: {
      marginTop: theme.spacing(3),
      display: "flex",
      justifyContent: "flex-end",
      gap: theme.spacing(2)
    },
    responseMessage: {
      marginBottom: theme.spacing(2),
      fontWeight: 600
    }
  };
});
var ForwardApplicationEisCoordinatorToCommitteeModal = function ForwardApplicationEisCoordinatorToCommitteeModal(_ref) {
  var open = _ref.open,
    onClose = _ref.onClose,
    selectedApplication = _ref.selectedApplication,
    selectedApplicationIds = _ref.selectedApplicationIds;
    _ref.onSubmitForward;
    var userRights = _ref.userRights,
    summaryId = _ref.summaryId,
    roleIds = _ref.roleIds;
  var classes = useStyles$S();
  var dispatch = useDispatch();
  var modulesManager = useModulesManager();
  var _useState = useState(""),
    _useState2 = _slicedToArray(_useState, 2);
    _useState2[0];
    var setEditorContent = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    submitting = _useState4[0],
    setSubmitting = _useState4[1];
  var _useState5 = useState(null),
    _useState6 = _slicedToArray(_useState5, 2),
    serverResponse = _useState6[0],
    setServerResponse = _useState6[1];
  var _useState7 = useState(""),
    _useState8 = _slicedToArray(_useState7, 2);
    _useState8[0];
    _useState8[1];
  var _useState9 = useState({
      roleIds: [],
      committeeIds: "",
      userIds: []
    }),
    _useState10 = _slicedToArray(_useState9, 2),
    formData = _useState10[0],
    setFormData = _useState10[1];
  getUserTypeFromRights(userRights);
  var loggedInUserId = useSelector(function (state) {
    var _state$core;
    return (_state$core = state.core) === null || _state$core === void 0 || (_state$core = _state$core.user) === null || _state$core === void 0 || (_state$core = _state$core.i_user) === null || _state$core === void 0 ? void 0 : _state$core.id;
  });
  var _useState11 = useState([]),
    _useState12 = _slicedToArray(_useState11, 2),
    committees = _useState12[0],
    setCommittees = _useState12[1];

  // Separated raw redux data to reliably trigger our auto-select effect
  var officersRaw = useSelector(function (state) {
    return state.workforce.roleWiseUsers;
  });
  var officers = officersRaw || [];
  console.log("jjjjjjjjj", officers);

  // ADDED: Effect to auto-select all loaded users by default whenever officers data updates
  useEffect(function () {
    if (officersRaw && Array.isArray(officersRaw)) {
      setFormData(function (prevData) {
        if (!prevData) return prevData;
        return _objectSpread$L(_objectSpread$L({}, prevData), {}, {
          userIds: officersRaw.map(function (o) {
            return o.userId;
          }) // Automatically extract and set all userIds
        });
      });
    }
  }, [officersRaw]);
  useEffect(function () {
    if (!open) {
      setEditorContent("");
      setSubmitting(false);
      setServerResponse(null);
      setFormData(null);
    }
    if (open) {
      var committeesResponse = dispatch(fetchWorkforceCommittees());
      committeesResponse.then(function (response) {
        var _response$payload;
        setCommittees((response === null || response === void 0 || (_response$payload = response.payload) === null || _response$payload === void 0 || (_response$payload = _response$payload.data) === null || _response$payload === void 0 ? void 0 : _response$payload.workforceCommittees) || []);
      });
    }
    if (selectedApplication) {
      return dispatch(fetchApplication(modulesManager, ["id: \"".concat(decodeId(selectedApplication === null || selectedApplication === void 0 ? void 0 : selectedApplication.id), "\"")]));
    }
  }, [open, dispatch, modulesManager, selectedApplication]);
  var ROLE_OPTIONS = committees.map(function (committee) {
    return {
      id: safeDecodeId(committee.assignedRole.id),
      committeeId: committee === null || committee === void 0 ? void 0 : committee.id,
      name: committee.nameEn || committee.nameBn || committee.id
    };
  });
  useEffect(function () {
    if (!open) {
      setEditorContent("");
      setSubmitting(false);
      setServerResponse(null);
      setFormData({
        roleIds: [],
        userIds: []
      });
    }
    if (selectedApplication) {
      dispatch(fetchApplication(modulesManager, ["id: \"".concat(decodeId(selectedApplication === null || selectedApplication === void 0 ? void 0 : selectedApplication.id), "\"")]));
    }
  }, [open, selectedApplication, dispatch, modulesManager]);
  useEffect(function () {
    if (open) {
      setFormData({
        roleIds: [],
        userIds: []
      });
    }
  }, [open]);
  useEffect(function () {
    // added safe check for formData nullability to prevent crashing on close
    if (!formData || !Array.isArray(formData.roleIds)) return;
    if (formData.roleIds.length === 0) return;
    dispatch(fetchWorkforceUserRoleWiseUser(modulesManager, {
      roleIds: formData.roleIds,
      orderBy: "id"
    }));
  }, [formData === null || formData === void 0 ? void 0 : formData.roleIds, dispatch, modulesManager]);
  useSelector(function (state) {
    var _state$workforce;
    return (_state$workforce = state.workforce["application"]) !== null && _state$workforce !== void 0 ? _state$workforce : [];
  });
  console.log("commitsummaryId", summaryId);
  var handleForward = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var numericRoleIds, forwardStatus, forwardAction, _iterator, _step, encodedId, updateApplicationData, _iterator2, _step2, userId, createApplicationMovementData, updateApplicationSummaryData;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            numericRoleIds = roleIds.map(function (id) {
              return Number(id);
            });
            _context2.prev = 1;
            if (!(!(formData !== null && formData !== void 0 && formData.userIds) || formData.userIds.length === 0)) {
              _context2.next = 5;
              break;
            }
            setServerResponse({
              status: "ERROR",
              message: "অফিসার নির্বাচন করুন!"
            });
            return _context2.abrupt("return");
          case 5:
            // Determine status + action from roleIds
            forwardStatus = "";
            forwardAction = "";
            if (!numericRoleIds.includes(47)) {
              _context2.next = 12;
              break;
            }
            forwardStatus = WORKFORCE_STATUS$1.FORWARD_FOR_VERIFICATION;
            forwardAction = "forward_for_verification";
            _context2.next = 19;
            break;
          case 12:
            if (!numericRoleIds.includes(49)) {
              _context2.next = 17;
              break;
            }
            forwardStatus = WORKFORCE_STATUS$1.FORWARD_TO_COMIITEE;
            forwardAction = "forward_to_committee";
            _context2.next = 19;
            break;
          case 17:
            setServerResponse({
              status: "ERROR",
              message: "সঠিক রোল আইডি পাওয়া যায়নি!"
            });
            return _context2.abrupt("return");
          case 19:
            _iterator = _createForOfIteratorHelper$6(selectedApplicationIds);
            _context2.prev = 20;
            _iterator.s();
          case 22:
            if ((_step = _iterator.n()).done) {
              _context2.next = 51;
              break;
            }
            encodedId = _step.value;
            updateApplicationData = {
              id: decodeId(encodedId === null || encodedId === void 0 ? void 0 : encodedId.id),
              status: forwardStatus,
              eisApprovalIds: JSON.stringify(formData.userIds),
              committeeId: safeDecodeId(formData === null || formData === void 0 ? void 0 : formData.committeeIds)
            };
            _context2.next = 27;
            return dispatch(updateApplication(updateApplicationData, "update workforce application"));
          case 27:
            _iterator2 = _createForOfIteratorHelper$6(formData.userIds);
            _context2.prev = 28;
            _iterator2.s();
          case 30:
            if ((_step2 = _iterator2.n()).done) {
              _context2.next = 41;
              break;
            }
            userId = _step2.value;
            createApplicationMovementData = {
              applicationId: decodeId(encodedId === null || encodedId === void 0 ? void 0 : encodedId.id),
              applicationFromId: loggedInUserId,
              applicationToId: userId,
              status: forwardStatus,
              action: forwardAction
            };
            _context2.next = 35;
            return dispatch(createApplicationMovement(createApplicationMovementData, "create workforce movement"));
          case 35:
            if (!(summaryId && numericRoleIds.includes(49))) {
              _context2.next = 39;
              break;
            }
            updateApplicationSummaryData = {
              id: decodeId(summaryId),
              status: WORKFORCE_STATUS$1.FORWARD_TO_COMIITEE,
              userIds: JSON.stringify(formData.userIds)
            };
            _context2.next = 39;
            return dispatch(updateApplicationSummary(updateApplicationSummaryData, "update summary"));
          case 39:
            _context2.next = 30;
            break;
          case 41:
            _context2.next = 46;
            break;
          case 43:
            _context2.prev = 43;
            _context2.t0 = _context2["catch"](28);
            _iterator2.e(_context2.t0);
          case 46:
            _context2.prev = 46;
            _iterator2.f();
            return _context2.finish(46);
          case 49:
            _context2.next = 22;
            break;
          case 51:
            _context2.next = 56;
            break;
          case 53:
            _context2.prev = 53;
            _context2.t1 = _context2["catch"](20);
            _iterator.e(_context2.t1);
          case 56:
            _context2.prev = 56;
            _iterator.f();
            return _context2.finish(56);
          case 59:
            setServerResponse({
              status: "SUCCESS",
              message: "সাবমিশন সফল হয়েছে!"
            });
            setTimeout(function () {
              window.location.reload();
            }, 1500);
            _context2.next = 67;
            break;
          case 63:
            _context2.prev = 63;
            _context2.t2 = _context2["catch"](1);
            console.error("Forwarding error:", _context2.t2);
            setServerResponse({
              status: "ERROR",
              message: "সাবমিশন ব্যর্থ হয়েছে!"
            });
          case 67:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[1, 63], [20, 53, 56, 59], [28, 43, 46, 49]]);
    }));
    return function handleForward() {
      return _ref3.apply(this, arguments);
    };
  }();
  useEffect(function () {
    if ((serverResponse === null || serverResponse === void 0 ? void 0 : serverResponse.status) === "SUCCESS") ;
  }, [serverResponse]);
  console.log({
    newwwwwwwww: formData
  });
  console.log({
    roleIds: roleIds
  });
  return /*#__PURE__*/React.createElement(Modal, {
    open: open,
    onClose: onClose
  }, /*#__PURE__*/React.createElement("form", {
    className: classes.modalContainer
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: onClose,
    className: classes.closeButton
  }, "\u2715"), /*#__PURE__*/React.createElement(Typography, {
    variant: "h5",
    gutterBottom: true,
    style: {
      fontWeight: "bold",
      marginTop: 3,
      textAlign: "center"
    }
  }, "\u0995\u09B0\u09CD\u09AE\u09AC\u09A8\u09CD\u099F\u09A8"), /*#__PURE__*/React.createElement(Typography, {
    variant: "body1",
    color: "textSecondary",
    gutterBottom: true,
    style: {
      fontWeight: 600,
      marginTop: 3,
      textAlign: "center"
    }
  }), (serverResponse === null || serverResponse === void 0 ? void 0 : serverResponse.status) && /*#__PURE__*/React.createElement(Typography, {
    className: classes.responseMessage,
    style: {
      color: serverResponse.status === "SUCCESS" ? "green" : "red"
    }
  }, serverResponse.status === "SUCCESS" ? "✅" : "⚠️", " ", serverResponse.message), /*#__PURE__*/React.createElement(Divider, {
    style: {
      marginBottom: 24
    }
  }), /*#__PURE__*/React.createElement(Paper, {
    className: classes.sectionPaper,
    elevation: 1
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 3,
    style: {
      marginTop: 3
    }
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    style: {
      marginBottom: 16
    }
  }, /*#__PURE__*/React.createElement(FormControl, {
    fullWidth: true
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle1",
    style: {
      fontWeight: "bold"
    }
  }, "\u0995\u09AE\u09BF\u099F\u09BF \u09A8\u09BF\u09B0\u09CD\u09AC\u09BE\u099A\u09A8 \u0995\u09B0\u09C1\u09A8"), /*#__PURE__*/React.createElement(Select, {
    multiple: true,
    value: (formData === null || formData === void 0 ? void 0 : formData.roleIds) || [],
    onChange: function onChange(e) {
      var _selectedRoleIds$map;
      var selectedRoleIds = e.target.value;
      var selectedCommitteeIds = (_selectedRoleIds$map = selectedRoleIds.map(function (roleId) {
        var _ROLE_OPTIONS$find;
        return (_ROLE_OPTIONS$find = ROLE_OPTIONS.find(function (r) {
          return r.id === roleId;
        })) === null || _ROLE_OPTIONS$find === void 0 ? void 0 : _ROLE_OPTIONS$find.committeeId;
      })) === null || _selectedRoleIds$map === void 0 ? void 0 : _selectedRoleIds$map[0];
      setFormData(_objectSpread$L(_objectSpread$L({}, formData), {}, {
        roleIds: selectedRoleIds,
        committeeIds: selectedCommitteeIds,
        userIds: []
      }));
    },
    renderValue: function renderValue(selected) {
      return ROLE_OPTIONS.filter(function (r) {
        return selected.includes(r.id);
      }).map(function (r) {
        return r.name;
      }).join(", ");
    },
    displayEmpty: true,
    MenuProps: {
      PaperProps: {
        style: {
          backgroundColor: "#fff",
          color: "#000"
        }
      }
    }
  }, ROLE_OPTIONS.map(function (role) {
    var _formData$roleIds;
    return /*#__PURE__*/React.createElement(MenuItem, {
      key: role.id,
      value: role.id
    }, /*#__PURE__*/React.createElement(Checkbox, {
      checked: (formData === null || formData === void 0 || (_formData$roleIds = formData.roleIds) === null || _formData$roleIds === void 0 ? void 0 : _formData$roleIds.includes(role.id)) || false,
      style: {
        color: "#000"
      }
    }), /*#__PURE__*/React.createElement(Typography, null, role.name));
  })))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle1",
    gutterBottom: true,
    style: {
      fontWeight: "bold"
    }
  }, "\u0995\u09AE\u09BF\u099F\u09BF\u09B0 \u09AE\u09C7\u09AE\u09CD\u09AC\u09BE\u09B0 \u09A8\u09BF\u09B0\u09CD\u09AC\u09BE\u099A\u09A8 \u0995\u09B0\u09C1\u09A8"), /*#__PURE__*/React.createElement(FormControl, {
    fullWidth: true
  }, /*#__PURE__*/React.createElement(Select, {
    multiple: true,
    value: (formData === null || formData === void 0 ? void 0 : formData.userIds) || [],
    onChange: function onChange(e) {
      return setFormData(_objectSpread$L(_objectSpread$L({}, formData), {}, {
        userIds: e.target.value
      }));
    },
    renderValue: function renderValue(selected) {
      return officers.filter(function (o) {
        return selected.includes(o.userId);
      }).map(function (o) {
        return o.otherNames;
      }).join(", ");
    },
    displayEmpty: true,
    MenuProps: {
      PaperProps: {
        style: {
          backgroundColor: "#fff",
          color: "#000"
        }
      }
    }
  }, officers.map(function (officer) {
    var _formData$userIds;
    return /*#__PURE__*/React.createElement(MenuItem, {
      key: officer.id,
      value: officer.userId
    }, /*#__PURE__*/React.createElement(Checkbox, {
      checked: (formData === null || formData === void 0 || (_formData$userIds = formData.userIds) === null || _formData$userIds === void 0 ? void 0 : _formData$userIds.includes(officer.userId)) || false,
      style: {
        color: "#000"
      }
    }), /*#__PURE__*/React.createElement(Typography, null, officer.otherNames));
  })))))), /*#__PURE__*/React.createElement("div", {
    className: classes.buttonGroup
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: onClose,
    variant: "outlined",
    color: "secondary"
  }, "\u09AC\u09BE\u09A4\u09BF\u09B2 \u0995\u09B0\u09C1\u09A8"), /*#__PURE__*/React.createElement(Button, {
    type: "submit",
    variant: "contained",
    color: "primary",
    disabled: submitting,
    onClick: (/*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3(e) {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              e.preventDefault();
              _context3.next = 3;
              return handleForward();
            case 3:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      return function (_x2) {
        return _ref4.apply(this, arguments);
      };
    }())
  }, submitting ? "ফরওয়ার্ড করা হচ্ছে..." : "ফরওয়ার্ড করুন"))));
};

// export const itemAdminFormatters = (
//   isShowHistory,
//   modulesManager,
//   history,
//   component,
//   locale = "en"
// ) => {
//   const formatters = [
//     (application) => application?.trackingNumber,
//     (application) =>
//       conditionalEnToBn(application?.dateCreated.split("T")[0], locale),
//     (application) => application?.workforceEmployee?.firstNameBn,
//     (application) =>
//       locale === "en"
//         ? application?.employeeFactory?.nameEn
//         : application?.employeeFactory?.nameBn,
//     (application) =>
//       locale === "en"
//         ? application?.grantMoney?.applicationTypeNameEn
//         : application?.grantMoney?.applicationTypeNameBn,

//     (application) => (
//       <TextInput
//         value={application?.grantAmount}
//         onChange={(v) => component.setState({ editedGrantMoney: v })}
//       />
//     ),
//     (application) => {
//       const statusMap = locale === "en" ? STATUS_MAP_EN : STATUS_MAP_BN;
//       return statusMap[application?.status] || application?.status;
//     },
//     isShowHistory() ? application?.version : null,
//   ];

//   formatters.push((application) => (
//     <div className={component.props.classes.horizontalButtonContainer}>
//       <Tooltip title="View">
//         <IconButton
//           disabled={application?.isHistory}
//           onClick={() => {
//             historyPush(
//               modulesManager,
//               history,
//               "workforce.route.applications.application.process.view",
//               [decodeId(application?.id)],
//               false
//             );
//           }}
//         >
//           <TabIcon />
//         </IconButton>
//       </Tooltip>
//       {component.props.disableButtons!==1 && (
//         <>
//           <Tooltip title="Revert">
//           <IconButton
//             disabled={application?.isHistory}
//             onClick={() => component.handleOpenRevertModal(application)}
//           >
//             <UndoIcon />
//           </IconButton>
//         </Tooltip>
//         <Tooltip title="Reject">
//           <span>
//             <IconButton
//               onClick={() => component.handleRejectByDG(application)}
//               disabled={
//                 application?.isHistory ||
//                 application?.status === "approved_by_dg" ||
//                 application?.status === "forward_to_director" ||
//                 application?.status === "rejected_by_dg"

//               }
//               color="error"
//             >
//               <CloseIcon />
//             </IconButton>
//           </span>
//         </Tooltip>
//         </>
//       )}
//     </div>
//   ));
//   return formatters;
// };
var itemAdminFormatters = function itemAdminFormatters(isShowHistory, modulesManager, history, component) {
  var locale = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : "en";
  var formatters = [function (application) {
    return application === null || application === void 0 ? void 0 : application.trackingNumber;
  }, function (application) {
    return conditionalEnToBn(application === null || application === void 0 ? void 0 : application.dateCreated.split("T")[0], locale);
  }, function (application) {
    var _safeParse, _safeParse2, _application$workforc, _application$workforc2;
    return (application === null || application === void 0 ? void 0 : application.applicationType) === "financialAssistance" || (application === null || application === void 0 ? void 0 : application.applicationType) === "deadlyGrant" ? locale === "en" ? (_safeParse = safeParse(application === null || application === void 0 ? void 0 : application.deceasedWorkerInfo)) === null || _safeParse === void 0 ? void 0 : _safeParse.nameEn : (_safeParse2 = safeParse(application === null || application === void 0 ? void 0 : application.deceasedWorkerInfo)) === null || _safeParse2 === void 0 ? void 0 : _safeParse2.nameBn : locale === "en" ? application === null || application === void 0 || (_application$workforc = application.workforceEmployee) === null || _application$workforc === void 0 ? void 0 : _application$workforc.firstNameEn : application === null || application === void 0 || (_application$workforc2 = application.workforceEmployee) === null || _application$workforc2 === void 0 ? void 0 : _application$workforc2.firstNameBn;
  }, function (application) {
    var _application$employee, _application$employee2;
    return locale === "en" ? application === null || application === void 0 || (_application$employee = application.employeeFactory) === null || _application$employee === void 0 ? void 0 : _application$employee.nameEn : application === null || application === void 0 || (_application$employee2 = application.employeeFactory) === null || _application$employee2 === void 0 ? void 0 : _application$employee2.nameBn;
  }, function (application) {
    var _application$grantMon, _application$grantMon2;
    return locale === "en" ? application === null || application === void 0 || (_application$grantMon = application.grantMoney) === null || _application$grantMon === void 0 ? void 0 : _application$grantMon.applicationTypeNameEn : application === null || application === void 0 || (_application$grantMon2 = application.grantMoney) === null || _application$grantMon2 === void 0 ? void 0 : _application$grantMon2.applicationTypeNameBn;
  }].concat(_toConsumableArray(isEisPath() ? [] : [function (application) {
    return /*#__PURE__*/React.createElement(TextInput, {
      value: application === null || application === void 0 ? void 0 : application.grantAmount,
      onChange: function onChange(v) {
        return component.setState({
          editedGrantMoney: v
        });
      }
    });
  }]), [function (application) {
    var statusMap = locale === "en" ? STATUS_MAP_EN : STATUS_MAP_BN;
    return statusMap[application === null || application === void 0 ? void 0 : application.status] || (application === null || application === void 0 ? void 0 : application.status);
  }, isShowHistory() ? function (application) {
    return application === null || application === void 0 ? void 0 : application.version;
  } : null]);

  // 1️⃣ View Button
  formatters.push(function (application) {
    return /*#__PURE__*/React.createElement("div", {
      className: component.props.classes.horizontalButtonContainer
    }, /*#__PURE__*/React.createElement(Tooltip, {
      title: "View"
    }, /*#__PURE__*/React.createElement(IconButton, {
      disabled: application === null || application === void 0 ? void 0 : application.isHistory,
      onClick: function onClick() {
        historyPush$1(modulesManager, history, "workforce.route.applications.application.process.view", [decodeId(application === null || application === void 0 ? void 0 : application.id)], false);
      }
    }, /*#__PURE__*/React.createElement(Tab, {
      style: {
        color: "blue"
      }
    }))));
  });

  // 2️⃣ Revert Button (only when disableButtons !== 1)
  formatters.push(function (application) {
    return component.props.disableButtons !== 1 ? /*#__PURE__*/React.createElement("div", {
      className: component.props.classes.horizontalButtonContainer
    }, /*#__PURE__*/React.createElement(Tooltip, {
      title: "Revert"
    }, /*#__PURE__*/React.createElement(IconButton, {
      disabled: application === null || application === void 0 ? void 0 : application.isHistory,
      onClick: function onClick() {
        return component.handleOpenRevertModal(application);
      }
    }, /*#__PURE__*/React.createElement(UndoIcon, {
      style: {
        color: "red"
      }
    })))) : null;
  });

  // 3️⃣ Reject Button (only when disableButtons !== 1)
  formatters.push(function (application) {
    return component.props.disableButtons !== 1 ? /*#__PURE__*/React.createElement("div", {
      className: component.props.classes.horizontalButtonContainer
    }, /*#__PURE__*/React.createElement(Tooltip, {
      title: "Reject"
    }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(IconButton, {
      onClick: function onClick() {
        return component.handleRejectByDG(application);
      },
      disabled: (application === null || application === void 0 ? void 0 : application.isHistory) || (application === null || application === void 0 ? void 0 : application.status) === "approved_by_dg" || (application === null || application === void 0 ? void 0 : application.status) === "forward_to_director" || (application === null || application === void 0 ? void 0 : application.status) === "rejected_by_dg",
      color: "error"
    }, /*#__PURE__*/React.createElement(CloseIcon, {
      style: {
        color: "#750506"
      }
    }))))) : null;
  });
  formatters.push(function (application) {
    return component.props.status !== "approved" ? /*#__PURE__*/React.createElement("div", {
      className: component.props.classes.horizontalButtonContainer
    }, /*#__PURE__*/React.createElement(Tooltip, {
      title: "Verify"
    }, /*#__PURE__*/React.createElement(IconButton, {
      disabled: application === null || application === void 0 ? void 0 : application.isHistory,
      onClick: function onClick() {
        historyPush$1(modulesManager, history, "workforce.route.applications.application.verify", [decodeId(application === null || application === void 0 ? void 0 : application.id)], false);
      }
    }, /*#__PURE__*/React.createElement(VerifiedUserIcon, {
      style: {
        color: "green"
      }
    })))) : null;
  });
  formatters.push(function (application) {
    return component.props.status !== "approved" ? /*#__PURE__*/React.createElement("div", {
      className: component.props.classes.horizontalButtonContainer
    }, /*#__PURE__*/React.createElement(Tooltip, {
      title: "save"
    }, /*#__PURE__*/React.createElement(IconButton, {
      disabled: application === null || application === void 0 ? void 0 : application.isHistory,
      onClick: function onClick() {
        return component.handleUpdateGrantMoney(application);
      }
    }, /*#__PURE__*/React.createElement(SaveIcon, {
      style: {
        color: "primary"
      }
    })))) : null;
  });
  return formatters;
};
var itemFormattersSecretaryMinister = function itemFormattersSecretaryMinister(isShowHistory, modulesManager, history, component) {
  var locale = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : "en";
  var formatters = [function (application) {
    return application === null || application === void 0 ? void 0 : application.trackingNumber;
  }, function (application) {
    return conditionalEnToBn(application === null || application === void 0 ? void 0 : application.dateCreated.split("T")[0], locale);
  }, function (application) {
    var _safeParse3, _safeParse4, _application$workforc3, _application$workforc4;
    return (application === null || application === void 0 ? void 0 : application.applicationType) === "financialAssistance" || (application === null || application === void 0 ? void 0 : application.applicationType) === "deadlyGrant" ? locale === "en" ? (_safeParse3 = safeParse(application === null || application === void 0 ? void 0 : application.deceasedWorkerInfo)) === null || _safeParse3 === void 0 ? void 0 : _safeParse3.nameEn : (_safeParse4 = safeParse(application === null || application === void 0 ? void 0 : application.deceasedWorkerInfo)) === null || _safeParse4 === void 0 ? void 0 : _safeParse4.nameBn : locale === "en" ? application === null || application === void 0 || (_application$workforc3 = application.workforceEmployee) === null || _application$workforc3 === void 0 ? void 0 : _application$workforc3.firstNameEn : application === null || application === void 0 || (_application$workforc4 = application.workforceEmployee) === null || _application$workforc4 === void 0 ? void 0 : _application$workforc4.firstNameBn;
  }, function (application) {
    var _application$employee3, _application$employee4;
    return locale === "en" ? application === null || application === void 0 || (_application$employee3 = application.employeeFactory) === null || _application$employee3 === void 0 ? void 0 : _application$employee3.nameEn : application === null || application === void 0 || (_application$employee4 = application.employeeFactory) === null || _application$employee4 === void 0 ? void 0 : _application$employee4.nameBn;
  }, function (application) {
    var _application$grantMon3, _application$grantMon4;
    return locale === "en" ? application === null || application === void 0 || (_application$grantMon3 = application.grantMoney) === null || _application$grantMon3 === void 0 ? void 0 : _application$grantMon3.applicationTypeNameEn : application === null || application === void 0 || (_application$grantMon4 = application.grantMoney) === null || _application$grantMon4 === void 0 ? void 0 : _application$grantMon4.applicationTypeNameBn;
  }, function (application) {
    return conditionalEnToBn(application === null || application === void 0 ? void 0 : application.grantAmount);
  },
  // ...(isEisPath() ? [] : [(application) => <TextInput value={application?.grantAmount} onChange={(v) => component.setState({ editedGrantMoney: v })} />]),

  function (application) {
    var statusMap = locale === "en" ? STATUS_MAP_EN : STATUS_MAP_BN;
    return statusMap[application === null || application === void 0 ? void 0 : application.status] || (application === null || application === void 0 ? void 0 : application.status);
  }, isShowHistory() ? function (application) {
    return application === null || application === void 0 ? void 0 : application.version;
  } : null];

  // 1️⃣ View Button
  formatters.push(function (application) {
    return /*#__PURE__*/React.createElement("div", {
      className: component.props.classes.horizontalButtonContainer
    }, /*#__PURE__*/React.createElement(Tooltip, {
      title: "View"
    }, /*#__PURE__*/React.createElement(IconButton, {
      disabled: application === null || application === void 0 ? void 0 : application.isHistory,
      onClick: function onClick() {
        historyPush$1(modulesManager, history, "workforce.route.applications.application.process.view", [decodeId(application === null || application === void 0 ? void 0 : application.id)], false);
      }
    }, /*#__PURE__*/React.createElement(Tab, {
      style: {
        color: "blue"
      }
    }))));
  });

  // 2️⃣ Revert Button (only when disableButtons !== 1)
  formatters.push(function (application) {
    return component.props.disableButtons !== 1 ? /*#__PURE__*/React.createElement("div", {
      className: component.props.classes.horizontalButtonContainer
    }, /*#__PURE__*/React.createElement(Tooltip, {
      title: "Revert"
    }, /*#__PURE__*/React.createElement(IconButton, {
      disabled: application === null || application === void 0 ? void 0 : application.isHistory,
      onClick: function onClick() {
        return component.handleOpenRevertModal(application);
      }
    }, /*#__PURE__*/React.createElement(UndoIcon, {
      style: {
        color: "red"
      }
    })))) : null;
  });

  // 3️⃣ Reject Button (only when disableButtons !== 1)
  formatters.push(function (application) {
    return component.props.disableButtons !== 1 ? /*#__PURE__*/React.createElement("div", {
      className: component.props.classes.horizontalButtonContainer
    }, /*#__PURE__*/React.createElement(Tooltip, {
      title: "Reject"
    }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(IconButton, {
      onClick: function onClick() {
        return component.handleRejectByDG(application);
      },
      disabled: (application === null || application === void 0 ? void 0 : application.isHistory) || (application === null || application === void 0 ? void 0 : application.status) === "approved_by_dg" || (application === null || application === void 0 ? void 0 : application.status) === "forward_to_director" || (application === null || application === void 0 ? void 0 : application.status) === "rejected_by_dg",
      color: "error"
    }, /*#__PURE__*/React.createElement(CloseIcon, {
      style: {
        color: "#750506"
      }
    }))))) : null;
  });
  // formatters.push((application) => (
  //   <div className={component.props.classes.horizontalButtonContainer}>
  //     <Tooltip title="Verify">
  //       <IconButton
  //         disabled={application?.isHistory}
  //         onClick={() => {
  //           historyPush(modulesManager, history, "workforce.route.applications.application.verify", [decodeId(application?.id)], false);
  //         }}
  //       >
  //         <VerifiedUserIcon style={{ color: "green" }} />
  //       </IconButton>
  //     </Tooltip>
  //   </div>
  // ));
  // formatters.push((application) => (
  //   <div className={component.props.classes.horizontalButtonContainer}>
  //     <Tooltip title="save">
  //       <IconButton
  //         disabled={application?.isHistory}
  //         onClick={() => component.handleUpdateGrantMoney(application)}
  //       >
  //         <SaveIcon style={{ color: "primary" }} />
  //       </IconButton>
  //     </Tooltip>
  //   </div>
  // ));

  return formatters;
};
var itemFormattersDirector = function itemFormattersDirector(isShowHistory, modulesManager, history, component) {
  var _application;
  var locale = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : "en";
  var formatters = [function (application) {
    return application === null || application === void 0 ? void 0 : application.trackingNumber;
  }, function (application) {
    return conditionalEnToBn(application === null || application === void 0 ? void 0 : application.dateCreated.split("T")[0], locale);
  }, function (application) {
    var _safeParse5, _safeParse6, _application$workforc5, _application$workforc6;
    return (application === null || application === void 0 ? void 0 : application.applicationType) === "financialAssistance" || (application === null || application === void 0 ? void 0 : application.applicationType) === "deadlyGrant" ? locale === "en" ? (_safeParse5 = safeParse(application === null || application === void 0 ? void 0 : application.deceasedWorkerInfo)) === null || _safeParse5 === void 0 ? void 0 : _safeParse5.nameEn : (_safeParse6 = safeParse(application === null || application === void 0 ? void 0 : application.deceasedWorkerInfo)) === null || _safeParse6 === void 0 ? void 0 : _safeParse6.nameBn : locale === "en" ? application === null || application === void 0 || (_application$workforc5 = application.workforceEmployee) === null || _application$workforc5 === void 0 ? void 0 : _application$workforc5.firstNameEn : application === null || application === void 0 || (_application$workforc6 = application.workforceEmployee) === null || _application$workforc6 === void 0 ? void 0 : _application$workforc6.firstNameBn;
  }, function (application) {
    var _application$employee5, _application$employee6;
    return locale === "en" ? application === null || application === void 0 || (_application$employee5 = application.employeeFactory) === null || _application$employee5 === void 0 ? void 0 : _application$employee5.nameEn : application === null || application === void 0 || (_application$employee6 = application.employeeFactory) === null || _application$employee6 === void 0 ? void 0 : _application$employee6.nameBn;
  }, function (application) {
    var _application$grantMon5, _application$grantMon6;
    return locale === "en" ? application === null || application === void 0 || (_application$grantMon5 = application.grantMoney) === null || _application$grantMon5 === void 0 ? void 0 : _application$grantMon5.applicationTypeNameEn : application === null || application === void 0 || (_application$grantMon6 = application.grantMoney) === null || _application$grantMon6 === void 0 ? void 0 : _application$grantMon6.applicationTypeNameBn;
  }].concat(_toConsumableArray(isEisPath() ? [] : [function (application) {
    return /*#__PURE__*/React.createElement(TextInput, {
      value: application === null || application === void 0 ? void 0 : application.grantAmount,
      onChange: function onChange(v) {
        return component.setState({
          editedGrantMoney: v
        });
      }
    });
  }]), [
  // (application) => application?.grantAmount,
  function (application) {
    return application !== null && application !== void 0 && application.applicationReceiveDate ? conditionalEnToBn(application.applicationReceiveDate.split("T")[0], locale) : "N/A";
  }, function (application) {
    return application !== null && application !== void 0 && application.applicationForwardDate ? conditionalEnToBn(application.applicationForwardDate.split("T")[0], locale) : "N/A";
  }, function (application) {
    var statusMap = locale === "en" ? STATUS_MAP_EN : STATUS_MAP_BN;
    return statusMap[application === null || application === void 0 ? void 0 : application.status] || (application === null || application === void 0 ? void 0 : application.status);
  }, isShowHistory() ? (_application = application) === null || _application === void 0 ? void 0 : _application.version : null]);

  // formatters.push((application) => (
  //   <div className={component.props.classes.horizontalButtonContainer}>
  //     <Tooltip title="Verify">
  //       <IconButton
  //         disabled={application?.isHistory}
  //         onClick={() => {
  //           historyPush(modulesManager, history, "workforce.route.applications.application.verify", [decodeId(application?.id)], false);
  //         }}
  //       >
  //         <VerifiedUserIcon style={{ color: "green" }} />
  //       </IconButton>
  //     </Tooltip>
  //   </div>
  // ));
  formatters.push(function (application) {
    return /*#__PURE__*/React.createElement("div", {
      className: component.props.classes.horizontalButtonContainer
    }, component.props.status !== "approved" && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Tooltip, {
      title: "Verify"
    }, /*#__PURE__*/React.createElement(IconButton, {
      disabled: application === null || application === void 0 ? void 0 : application.isHistory,
      onClick: function onClick() {
        historyPush$1(modulesManager, history, "workforce.route.applications.application.verify", [decodeId(application === null || application === void 0 ? void 0 : application.id)], false);
      }
    }, /*#__PURE__*/React.createElement(VerifiedUserIcon, {
      style: {
        color: "green"
      }
    })))), /*#__PURE__*/React.createElement(Tooltip, {
      title: "View"
    }, /*#__PURE__*/React.createElement(IconButton, {
      disabled: application === null || application === void 0 ? void 0 : application.isHistory,
      onClick: function onClick() {
        historyPush$1(modulesManager, history, "workforce.route.applications.application.process.view", [decodeId(application === null || application === void 0 ? void 0 : application.id)], false);
      }
    }, /*#__PURE__*/React.createElement(Tab, null))), component.props.disableButtons !== 1 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Tooltip, {
      title: "Revert"
    }, /*#__PURE__*/React.createElement(IconButton, {
      disabled: application === null || application === void 0 ? void 0 : application.isHistory,
      onClick: function onClick() {
        return component.handleOpenRevertModal(application);
      }
    }, /*#__PURE__*/React.createElement(UndoIcon, null))), /*#__PURE__*/React.createElement(Tooltip, {
      title: "Reject"
    }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(IconButton, {
      onClick: function onClick() {
        return component.handleReject(application);
      },
      disabled: (application === null || application === void 0 ? void 0 : application.isHistory) || (application === null || application === void 0 ? void 0 : application.status) !== "forward_to_director",
      color: "error"
    }, /*#__PURE__*/React.createElement(CloseIcon, null))))), /*#__PURE__*/React.createElement(Tooltip, {
      title: "save"
    }, /*#__PURE__*/React.createElement(IconButton, {
      disabled: application === null || application === void 0 ? void 0 : application.isHistory,
      onClick: function onClick() {
        return component.handleUpdateGrantMoney(application);
      }
    }, /*#__PURE__*/React.createElement(SaveIcon, {
      style: {
        color: "primary"
      }
    }))));
  });
  return formatters;
};
var itemFormattersApplicant = function itemFormattersApplicant(isShowHistory, modulesManager, history, component) {
  var _application2;
  var locale = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : "en";
  var formatters = [function (application) {
    return application.trackingNumber;
  }, function (application) {
    return conditionalEnToBn(application.dateCreated.split("T")[0], locale);
  }, function (application) {
    var _safeParse7, _safeParse8, _application$workforc7, _application$workforc8;
    return (application === null || application === void 0 ? void 0 : application.applicationType) === "financialAssistance" || (application === null || application === void 0 ? void 0 : application.applicationType) === "deadlyGrant" ? locale === "en" ? (_safeParse7 = safeParse(application === null || application === void 0 ? void 0 : application.deceasedWorkerInfo)) === null || _safeParse7 === void 0 ? void 0 : _safeParse7.nameEn : (_safeParse8 = safeParse(application === null || application === void 0 ? void 0 : application.deceasedWorkerInfo)) === null || _safeParse8 === void 0 ? void 0 : _safeParse8.nameBn : locale === "en" ? application === null || application === void 0 || (_application$workforc7 = application.workforceEmployee) === null || _application$workforc7 === void 0 ? void 0 : _application$workforc7.firstNameEn : application === null || application === void 0 || (_application$workforc8 = application.workforceEmployee) === null || _application$workforc8 === void 0 ? void 0 : _application$workforc8.firstNameBn;
  }].concat(_toConsumableArray(!isBlwfPath() ? [function (application) {
    var _application$employee7, _application$employee8, _application$employee9, _application$employee10;
    return locale === "en" ? (_application$employee7 = application === null || application === void 0 || (_application$employee8 = application.employeeFactory) === null || _application$employee8 === void 0 ? void 0 : _application$employee8.nameEn) !== null && _application$employee7 !== void 0 ? _application$employee7 : "N/A" : (_application$employee9 = application === null || application === void 0 || (_application$employee10 = application.employeeFactory) === null || _application$employee10 === void 0 ? void 0 : _application$employee10.nameBn) !== null && _application$employee9 !== void 0 ? _application$employee9 : "প্রযোজ্য নয়";
  }] : []), [function (application) {
    return locale === "en" ? ORGANIZATION_TYPE_NAME_EN[application === null || application === void 0 ? void 0 : application.organizationType] : ORGANIZATION_TYPE_NAME_BN[application === null || application === void 0 ? void 0 : application.organizationType];
  }, function (application) {
    var _application$grantMon7, _application$grantMon8;
    return locale === "en" ? application === null || application === void 0 || (_application$grantMon7 = application.grantMoney) === null || _application$grantMon7 === void 0 ? void 0 : _application$grantMon7.applicationTypeNameEn : application === null || application === void 0 || (_application$grantMon8 = application.grantMoney) === null || _application$grantMon8 === void 0 ? void 0 : _application$grantMon8.applicationTypeNameBn;
  }, function (application) {
    var statusMap = locale === "en" ? STATUS_MAP_EN : STATUS_MAP_BN;
    return statusMap[application === null || application === void 0 ? void 0 : application.status] || (application === null || application === void 0 ? void 0 : application.status);
  }, isShowHistory() ? (_application2 = application) === null || _application2 === void 0 ? void 0 : _application2.version : null]);
  formatters.push(function (application) {
    return /*#__PURE__*/React.createElement("div", {
      className: component.props.classes.horizontalButtonContainer
    }, !component.props.applicationStatus ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Tooltip, {
      title: "View"
    }, /*#__PURE__*/React.createElement(IconButton, {
      disabled: application === null || application === void 0 ? void 0 : application.isHistory,
      onClick: function onClick() {
        historyPush$1(modulesManager, history, "workforce.route.applications.application.process.view", [decodeId(application === null || application === void 0 ? void 0 : application.id)], false);
      }
    }, /*#__PURE__*/React.createElement(Tab, null)))) : /*#__PURE__*/React.createElement(Tooltip, {
      title: "Complete Application"
    }, /*#__PURE__*/React.createElement(IconButton, {
      disabled: application === null || application === void 0 ? void 0 : application.isHistory,
      onClick: function onClick() {
        isEisPath() ? historyPush$1(modulesManager, history, "workforce.route.application.eis", [decodeId(application === null || application === void 0 ? void 0 : application.id)], false) : historyPush$1(modulesManager, history, "workforce.route.application", [decodeId(application === null || application === void 0 ? void 0 : application.id)], false);
      }
    }, /*#__PURE__*/React.createElement(DoubleArrowIcon, null))));
  });
  formatters.push(function (application) {
    return /*#__PURE__*/React.createElement("div", {
      className: component.props.classes.horizontalButtonContainer
    }, component.props.revertedApplication && /*#__PURE__*/React.createElement(Tooltip, {
      title: "Resend"
    }, /*#__PURE__*/React.createElement(IconButton, {
      disabled: application === null || application === void 0 ? void 0 : application.isHistory,
      onClick: function onClick() {
        historyPush$1(modulesManager, history, "workforce.route.applications.application.process.resend", [decodeId(application === null || application === void 0 ? void 0 : application.id)], false);
      }
    }, /*#__PURE__*/React.createElement(RestorePageIcon, null))));
  });
  return formatters;
};
var itemFormattersChecker = function itemFormattersChecker(isShowHistory, modulesManager, history, component) {
  var _application3;
  var locale = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : "en";
  var formatters = [function (application) {
    return application === null || application === void 0 ? void 0 : application.trackingNumber;
  }, function (application) {
    return conditionalEnToBn(application === null || application === void 0 ? void 0 : application.dateCreated.split("T")[0], locale);
  }, function (application) {
    var _safeParse9, _safeParse10, _application$workforc9, _application$workforc10;
    return (application === null || application === void 0 ? void 0 : application.applicationType) === "financialAssistance" || (application === null || application === void 0 ? void 0 : application.applicationType) === "deadlyGrant" ? locale === "en" ? (_safeParse9 = safeParse(application === null || application === void 0 ? void 0 : application.deceasedWorkerInfo)) === null || _safeParse9 === void 0 ? void 0 : _safeParse9.nameEn : (_safeParse10 = safeParse(application === null || application === void 0 ? void 0 : application.deceasedWorkerInfo)) === null || _safeParse10 === void 0 ? void 0 : _safeParse10.nameBn : locale === "en" ? application === null || application === void 0 || (_application$workforc9 = application.workforceEmployee) === null || _application$workforc9 === void 0 ? void 0 : _application$workforc9.firstNameEn : application === null || application === void 0 || (_application$workforc10 = application.workforceEmployee) === null || _application$workforc10 === void 0 ? void 0 : _application$workforc10.firstNameBn;
  }, function (application) {
    var _application$employee11, _application$employee12;
    return locale === "en" ? application === null || application === void 0 || (_application$employee11 = application.employeeFactory) === null || _application$employee11 === void 0 ? void 0 : _application$employee11.nameEn : application === null || application === void 0 || (_application$employee12 = application.employeeFactory) === null || _application$employee12 === void 0 ? void 0 : _application$employee12.nameBn;
  }, function (application) {
    var _application$grantMon9, _application$grantMon10;
    return locale === "en" ? application === null || application === void 0 || (_application$grantMon9 = application.grantMoney) === null || _application$grantMon9 === void 0 ? void 0 : _application$grantMon9.applicationTypeNameEn : application === null || application === void 0 || (_application$grantMon10 = application.grantMoney) === null || _application$grantMon10 === void 0 ? void 0 : _application$grantMon10.applicationTypeNameBn;
  },
  // (application) => conditionalEnToBn(application?.grantAmount, locale),
  function (application) {
    return application !== null && application !== void 0 && application.lastMovementDate ? conditionalEnToBn(application.lastMovementDate.split("T")[0], locale) : "N/A";
  }, function (application) {
    return application !== null && application !== void 0 && application.applicationForwardDate ? conditionalEnToBn(application.applicationForwardDate.split("T")[0], locale) : "N/A";
  }, function (application) {
    var statusMap = locale === "en" ? STATUS_MAP_EN : STATUS_MAP_BN;
    return statusMap[application === null || application === void 0 ? void 0 : application.status] || (application === null || application === void 0 ? void 0 : application.status);
  }, isShowHistory() ? (_application3 = application) === null || _application3 === void 0 ? void 0 : _application3.version : null];

  // --- VIEW BUTTON ---
  formatters.push(function (application) {
    return /*#__PURE__*/React.createElement("div", {
      className: component.props.classes.horizontalButtonContainer
    }, /*#__PURE__*/React.createElement(Tooltip, {
      title: "View"
    }, /*#__PURE__*/React.createElement(IconButton, {
      disabled: application === null || application === void 0 ? void 0 : application.isHistory,
      onClick: function onClick() {
        historyPush$1(modulesManager, history, "workforce.route.applications.application.process.view", [decodeId(application === null || application === void 0 ? void 0 : application.id)], false);
      }
    }, /*#__PURE__*/React.createElement(Tab, {
      style: {
        color: "blue"
      }
    }))));
  });

  // --- VERIFY BUTTON ---
  {
    var _component$props, _component$props2;
    !(component !== null && component !== void 0 && (_component$props = component.props) !== null && _component$props !== void 0 && _component$props.forwardedApplications) && !(component !== null && component !== void 0 && (_component$props2 = component.props) !== null && _component$props2 !== void 0 && _component$props2.revertedApplication) && formatters.push(function (application) {
      return /*#__PURE__*/React.createElement("div", {
        className: component.props.classes.horizontalButtonContainer
      }, /*#__PURE__*/React.createElement(Tooltip, {
        title: "Verify"
      }, /*#__PURE__*/React.createElement(IconButton, {
        disabled: application === null || application === void 0 ? void 0 : application.isHistory,
        onClick: function onClick() {
          historyPush$1(modulesManager, history, "workforce.route.applications.application.verify", [decodeId(application === null || application === void 0 ? void 0 : application.id)], false);
        }
      }, /*#__PURE__*/React.createElement(VerifiedUserIcon, {
        style: {
          color: "green"
        }
      }))));
    });
  }

  // --- REVERT BUTTON ---
  {
    var _component$props3;
    !(component !== null && component !== void 0 && (_component$props3 = component.props) !== null && _component$props3 !== void 0 && _component$props3.forwardedApplications) && formatters.push(function (application) {
      return /*#__PURE__*/React.createElement("div", {
        className: component.props.classes.horizontalButtonContainer
      }, /*#__PURE__*/React.createElement(Tooltip, {
        title: "Revert"
      }, /*#__PURE__*/React.createElement(IconButton, {
        disabled: application === null || application === void 0 ? void 0 : application.isHistory,
        onClick: function onClick() {
          component.handleOpenRevertModal(application);
          component.setState({
            revertByChecker: true
          });
        }
      }, /*#__PURE__*/React.createElement(UndoIcon, {
        style: {
          color: "red"
        }
      }))));
    });
  }

  ///---RESEND BUTTON ---
  {
    var _component$props4;
    !(component !== null && component !== void 0 && (_component$props4 = component.props) !== null && _component$props4 !== void 0 && _component$props4.forwardedApplications) && formatters.push(function (application) {
      return component.props.disableButtons !== 1 && component.props.revertedApplication ? /*#__PURE__*/React.createElement("div", {
        className: component.props.classes.horizontalButtonContainer
      }, /*#__PURE__*/React.createElement(Tooltip, {
        title: "Resend"
      }, /*#__PURE__*/React.createElement(IconButton, {
        disabled: application === null || application === void 0 ? void 0 : application.isHistory,
        onClick: function onClick() {
          historyPush$1(modulesManager, history, "workforce.route.applications.application.process.resend", [decodeId(application === null || application === void 0 ? void 0 : application.id)], false);
        }
      }, /*#__PURE__*/React.createElement(RestorePageIcon, {
        style: {
          color: "#1976D2"
        }
      })))) : null;
    });
  }
  return formatters;
};
var itemFormattersCheckerTwo = function itemFormattersCheckerTwo(isShowHistory, modulesManager, history, component) {
  var _application4;
  var locale = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : "en";
  var formatters = [function (application) {
    return application === null || application === void 0 ? void 0 : application.trackingNumber;
  }, function (application) {
    return conditionalEnToBn(application === null || application === void 0 ? void 0 : application.dateCreated.split("T")[0], locale);
  }, function (application) {
    var _safeParse11, _safeParse12, _application$workforc11, _application$workforc12;
    return (application === null || application === void 0 ? void 0 : application.applicationType) === "financialAssistance" || (application === null || application === void 0 ? void 0 : application.applicationType) === "deadlyGrant" ? locale === "en" ? (_safeParse11 = safeParse(application === null || application === void 0 ? void 0 : application.deceasedWorkerInfo)) === null || _safeParse11 === void 0 ? void 0 : _safeParse11.nameEn : (_safeParse12 = safeParse(application === null || application === void 0 ? void 0 : application.deceasedWorkerInfo)) === null || _safeParse12 === void 0 ? void 0 : _safeParse12.nameBn : locale === "en" ? application === null || application === void 0 || (_application$workforc11 = application.workforceEmployee) === null || _application$workforc11 === void 0 ? void 0 : _application$workforc11.firstNameEn : application === null || application === void 0 || (_application$workforc12 = application.workforceEmployee) === null || _application$workforc12 === void 0 ? void 0 : _application$workforc12.firstNameBn;
  }, function (application) {
    var _application$employee13, _application$employee14;
    return locale === "en" ? application === null || application === void 0 || (_application$employee13 = application.employeeFactory) === null || _application$employee13 === void 0 ? void 0 : _application$employee13.nameEn : application === null || application === void 0 || (_application$employee14 = application.employeeFactory) === null || _application$employee14 === void 0 ? void 0 : _application$employee14.nameBn;
  }, function (application) {
    var _application$grantMon11, _application$grantMon12;
    return locale === "en" ? application === null || application === void 0 || (_application$grantMon11 = application.grantMoney) === null || _application$grantMon11 === void 0 ? void 0 : _application$grantMon11.applicationTypeNameEn : application === null || application === void 0 || (_application$grantMon12 = application.grantMoney) === null || _application$grantMon12 === void 0 ? void 0 : _application$grantMon12.applicationTypeNameBn;
  }, function (application) {
    return conditionalEnToBn(application === null || application === void 0 ? void 0 : application.grantAmount, locale);
  }, function (application) {
    return application !== null && application !== void 0 && application.applicationReceiveDate ? conditionalEnToBn(application.applicationReceiveDate.split("T")[0], locale) : "N/A";
  }, function (application) {
    return application !== null && application !== void 0 && application.applicationForwardDate ? conditionalEnToBn(application.applicationForwardDate.split("T")[0], locale) : "N/A";
  }, function (application) {
    var statusMap = locale === "en" ? STATUS_MAP_EN : STATUS_MAP_BN;
    return statusMap[application === null || application === void 0 ? void 0 : application.status] || (application === null || application === void 0 ? void 0 : application.status);
  }, isShowHistory() ? (_application4 = application) === null || _application4 === void 0 ? void 0 : _application4.version : null];
  formatters.push(function (application) {
    return /*#__PURE__*/React.createElement("div", {
      className: component.props.classes.horizontalButtonContainer
    }, /*#__PURE__*/React.createElement(Tooltip, {
      title: "View"
    }, /*#__PURE__*/React.createElement(IconButton, {
      disabled: application === null || application === void 0 ? void 0 : application.isHistory,
      onClick: function onClick() {
        historyPush$1(modulesManager, history, "workforce.route.applications.application.process.view", [decodeId(application === null || application === void 0 ? void 0 : application.id)], false);
      }
    }, /*#__PURE__*/React.createElement(Tab, {
      style: {
        color: "blue"
      }
    }))));
  });
  formatters.push(function (application) {
    return /*#__PURE__*/React.createElement("div", {
      className: component.props.classes.horizontalButtonContainer
    }, /*#__PURE__*/React.createElement(Tooltip, {
      title: "Verify"
    }, /*#__PURE__*/React.createElement(IconButton, {
      disabled: application === null || application === void 0 ? void 0 : application.isHistory,
      onClick: function onClick() {
        historyPush$1(modulesManager, history, "workforce.route.applications.application.verify", [decodeId(application === null || application === void 0 ? void 0 : application.id)], false);
      }
    }, /*#__PURE__*/React.createElement(VerifiedUserIcon, {
      style: {
        color: "green"
      }
    }))));
  });
  // --- REVERT BUTTON ---
  formatters.push(function (application) {
    return /*#__PURE__*/React.createElement("div", {
      className: component.props.classes.horizontalButtonContainer
    }, component.props.disableButtons !== 1 && !component.props.revertedApplication && /*#__PURE__*/React.createElement(Tooltip, {
      title: "Revert"
    }, /*#__PURE__*/React.createElement(IconButton, {
      disabled: application === null || application === void 0 ? void 0 : application.isHistory,
      onClick: function onClick() {
        component.handleOpenRevertModal(application);
        component.setState({
          revertByChecker: true
        });
      }
    }, /*#__PURE__*/React.createElement(UndoIcon, {
      style: {
        color: "red"
      }
    }))));
  });

  // --- REJECT BUTTON ---
  formatters.push(function (application) {
    return /*#__PURE__*/React.createElement("div", {
      className: component.props.classes.horizontalButtonContainer
    }, component.props.disableButtons !== 1 && !component.props.revertedApplication && /*#__PURE__*/React.createElement(Tooltip, {
      title: "Reject"
    }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(IconButton, {
      onClick: function onClick() {
        return component.handleReject(application);
      }
    }, /*#__PURE__*/React.createElement(CloseIcon, {
      style: {
        color: "#750506"
      }
    })))));
  });
  return formatters;
};
var itemFormattersDeputyAsstDirector = function itemFormattersDeputyAsstDirector(isShowHistory, modulesManager, history, component) {
  var _application5;
  var locale = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : "en";
  var formatters = [function (application) {
    return application === null || application === void 0 ? void 0 : application.trackingNumber;
  }, function (application) {
    return conditionalEnToBn(application === null || application === void 0 ? void 0 : application.dateCreated.split("T")[0], locale);
  }, function (application) {
    var _safeParse13, _safeParse14, _application$workforc13, _application$workforc14;
    return (application === null || application === void 0 ? void 0 : application.applicationType) === "financialAssistance" || (application === null || application === void 0 ? void 0 : application.applicationType) === "deadlyGrant" ? locale === "en" ? (_safeParse13 = safeParse(application === null || application === void 0 ? void 0 : application.deceasedWorkerInfo)) === null || _safeParse13 === void 0 ? void 0 : _safeParse13.nameEn : (_safeParse14 = safeParse(application === null || application === void 0 ? void 0 : application.deceasedWorkerInfo)) === null || _safeParse14 === void 0 ? void 0 : _safeParse14.nameBn : locale === "en" ? application === null || application === void 0 || (_application$workforc13 = application.workforceEmployee) === null || _application$workforc13 === void 0 ? void 0 : _application$workforc13.firstNameEn : application === null || application === void 0 || (_application$workforc14 = application.workforceEmployee) === null || _application$workforc14 === void 0 ? void 0 : _application$workforc14.firstNameBn;
  }, function (application) {
    var _application$employee15, _application$employee16;
    return locale === "en" ? application === null || application === void 0 || (_application$employee15 = application.employeeFactory) === null || _application$employee15 === void 0 ? void 0 : _application$employee15.nameEn : application === null || application === void 0 || (_application$employee16 = application.employeeFactory) === null || _application$employee16 === void 0 ? void 0 : _application$employee16.nameBn;
  }, function (application) {
    var _application$grantMon13, _application$grantMon14;
    return locale === "en" ? application === null || application === void 0 || (_application$grantMon13 = application.grantMoney) === null || _application$grantMon13 === void 0 ? void 0 : _application$grantMon13.applicationTypeNameEn : application === null || application === void 0 || (_application$grantMon14 = application.grantMoney) === null || _application$grantMon14 === void 0 ? void 0 : _application$grantMon14.applicationTypeNameBn;
  },
  // (application) => conditionalEnToBn(application?.grantAmount, locale),
  function (application) {
    return application !== null && application !== void 0 && application.applicationReceiveDate ? conditionalEnToBn(application.applicationReceiveDate.split("T")[0], locale) : "N/A";
  }, function (application) {
    return application !== null && application !== void 0 && application.applicationForwardDate ? conditionalEnToBn(application.applicationForwardDate.split("T")[0], locale) : "N/A";
  }, function (application) {
    var statusMap = locale === "en" ? STATUS_MAP_EN : STATUS_MAP_BN;
    return statusMap[application === null || application === void 0 ? void 0 : application.status] || (application === null || application === void 0 ? void 0 : application.status);
  }, isShowHistory() ? (_application5 = application) === null || _application5 === void 0 ? void 0 : _application5.version : null];
  formatters.push(function (application) {
    return /*#__PURE__*/React.createElement("div", {
      className: component.props.classes.horizontalButtonContainer
    }, /*#__PURE__*/React.createElement(Tooltip, {
      title: "View"
    }, /*#__PURE__*/React.createElement(IconButton, {
      disabled: application === null || application === void 0 ? void 0 : application.isHistory,
      onClick: function onClick() {
        historyPush$1(modulesManager, history, "workforce.route.applications.application.process.view", [decodeId(application === null || application === void 0 ? void 0 : application.id)], false);
      }
    }, /*#__PURE__*/React.createElement(Tab, {
      style: {
        color: "blue"
      }
    }))));
  });
  formatters.push(function (application) {
    return /*#__PURE__*/React.createElement("div", {
      className: component.props.classes.horizontalButtonContainer
    }, /*#__PURE__*/React.createElement(Tooltip, {
      title: "Verify"
    }, /*#__PURE__*/React.createElement(IconButton, {
      disabled: application === null || application === void 0 ? void 0 : application.isHistory,
      onClick: function onClick() {
        historyPush$1(modulesManager, history, "workforce.route.applications.application.verify", [decodeId(application === null || application === void 0 ? void 0 : application.id)], false);
      }
    }, /*#__PURE__*/React.createElement(VerifiedUserIcon, {
      style: {
        color: "green"
      }
    }))));
  });
  // --- REVERT BUTTON ---
  formatters.push(function (application) {
    return /*#__PURE__*/React.createElement("div", {
      className: component.props.classes.horizontalButtonContainer
    }, component.props.disableButtons !== 1 && !component.props.revertedApplication && /*#__PURE__*/React.createElement(Tooltip, {
      title: "Revert"
    }, /*#__PURE__*/React.createElement(IconButton, {
      disabled: application === null || application === void 0 ? void 0 : application.isHistory,
      onClick: function onClick() {
        component.handleOpenRevertModal(application);
        component.setState({
          revertByChecker: true
        });
      }
    }, /*#__PURE__*/React.createElement(UndoIcon, {
      style: {
        color: "red"
      }
    }))));
  });

  // --- REJECT BUTTON ---
  formatters.push(function (application) {
    return /*#__PURE__*/React.createElement("div", {
      className: component.props.classes.horizontalButtonContainer
    }, component.props.disableButtons !== 1 && !component.props.revertedApplication && /*#__PURE__*/React.createElement(Tooltip, {
      title: "Reject"
    }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(IconButton, {
      onClick: function onClick() {
        return component.handleReject(application);
      }
    }, /*#__PURE__*/React.createElement(CloseIcon, {
      style: {
        color: "#750506"
      }
    })))));
  });
  return formatters;
};
var itemFormattersSectionAdmin = function itemFormattersSectionAdmin(isShowHistory, modulesManager, history, component) {
  var _component$props5, _application7;
  var locale = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : "en";
  var formatters = [function (application) {
    return application === null || application === void 0 ? void 0 : application.trackingNumber;
  }, function (application) {
    return conditionalEnToBn(application === null || application === void 0 ? void 0 : application.dateCreated.split("T")[0], locale);
  }, function (application) {
    var _safeParse17, _safeParse18, _application$workforc17, _application$workforc18;
    return (application === null || application === void 0 ? void 0 : application.applicationType) === "financialAssistance" || (application === null || application === void 0 ? void 0 : application.applicationType) === "deadlyGrant" ? locale === "en" ? (_safeParse17 = safeParse(application === null || application === void 0 ? void 0 : application.deceasedWorkerInfo)) === null || _safeParse17 === void 0 ? void 0 : _safeParse17.nameEn : (_safeParse18 = safeParse(application === null || application === void 0 ? void 0 : application.deceasedWorkerInfo)) === null || _safeParse18 === void 0 ? void 0 : _safeParse18.nameBn : locale === "en" ? application === null || application === void 0 || (_application$workforc17 = application.workforceEmployee) === null || _application$workforc17 === void 0 ? void 0 : _application$workforc17.firstNameEn : application === null || application === void 0 || (_application$workforc18 = application.workforceEmployee) === null || _application$workforc18 === void 0 ? void 0 : _application$workforc18.firstNameBn;
  }, function (application) {
    var _application$employee19, _application$employee20;
    return locale === "en" ? application === null || application === void 0 || (_application$employee19 = application.employeeFactory) === null || _application$employee19 === void 0 ? void 0 : _application$employee19.nameEn : application === null || application === void 0 || (_application$employee20 = application.employeeFactory) === null || _application$employee20 === void 0 ? void 0 : _application$employee20.nameBn;
  }, function (application) {
    var _application$grantMon17, _application$grantMon18;
    return locale === "en" ? application === null || application === void 0 || (_application$grantMon17 = application.grantMoney) === null || _application$grantMon17 === void 0 ? void 0 : _application$grantMon17.applicationTypeNameEn : application === null || application === void 0 || (_application$grantMon18 = application.grantMoney) === null || _application$grantMon18 === void 0 ? void 0 : _application$grantMon18.applicationTypeNameBn;
  }, function (application) {
    return application === null || application === void 0 ? void 0 : application.associationType;
  }, function (application) {
    var _application$workforc19;
    var parsedDeceasedInfo = JSON.parse(application === null || application === void 0 ? void 0 : application.deceasedWorkerInfo);
    var doubleParsedDeceasedInfo = JSON.parse(parsedDeceasedInfo);
    console.log({
      doubleParsedDeceasedInfo: doubleParsedDeceasedInfo
    });
    return (application === null || application === void 0 ? void 0 : application.applicationType) === "financialAssistance" || (application === null || application === void 0 ? void 0 : application.applicationType) === "deadlyGrant" ? doubleParsedDeceasedInfo === null || doubleParsedDeceasedInfo === void 0 ? void 0 : doubleParsedDeceasedInfo.nid : application === null || application === void 0 || (_application$workforc19 = application.workforceEmployee) === null || _application$workforc19 === void 0 ? void 0 : _application$workforc19.nid;
  }, function (application) {
    return application !== null && application !== void 0 && application.lastMovementDate ? conditionalEnToBn(application.lastMovementDate.split("T")[0], locale) : "N/A";
  }, function (application) {
    return application !== null && application !== void 0 && application.applicationForwardDate ? conditionalEnToBn(application.applicationForwardDate.split("T")[0], locale) : "N/A";
  }, function (application) {
    var statusMap = locale === "en" ? STATUS_MAP_EN : STATUS_MAP_BN;
    return statusMap[application === null || application === void 0 ? void 0 : application.status] || (application === null || application === void 0 ? void 0 : application.status);
  }].concat(_toConsumableArray(component !== null && component !== void 0 && (_component$props5 = component.props) !== null && _component$props5 !== void 0 && _component$props5.sentForVerificationApplications ? [function (application) {
    var _application$workforc20, _targettedApplication;
    var targettedApplication = application === null || application === void 0 || (_application$workforc20 = application.workforceApplicationMovements) === null || _application$workforc20 === void 0 ? void 0 : _application$workforc20.filter(function (app) {
      return (app === null || app === void 0 ? void 0 : app.status) === "forward_for_verification";
    });
    return (_targettedApplication = targettedApplication[0]) === null || _targettedApplication === void 0 || (_targettedApplication = _targettedApplication.applicationTo) === null || _targettedApplication === void 0 ? void 0 : _targettedApplication.loginName;
  }] : []), [isShowHistory() ? (_application7 = application) === null || _application7 === void 0 ? void 0 : _application7.version : null]);

  // --- VIEW BUTTON ---

  formatters.push(function (application) {
    return /*#__PURE__*/React.createElement("div", {
      className: component.props.classes.horizontalButtonContainer
    }, /*#__PURE__*/React.createElement(Tooltip, {
      title: "View"
    }, /*#__PURE__*/React.createElement(IconButton, {
      disabled: application === null || application === void 0 ? void 0 : application.isHistory,
      onClick: function onClick() {
        historyPush$1(modulesManager, history, "workforce.route.applications.application.process.view", [decodeId(application === null || application === void 0 ? void 0 : application.id)], false);
      }
    }, /*#__PURE__*/React.createElement(Tab, {
      style: {
        color: "blue"
      }
    }))));
  });

  // --- VERIFY BUTTON ---
  {
    var _component$props6;
    !(component !== null && component !== void 0 && (_component$props6 = component.props) !== null && _component$props6 !== void 0 && _component$props6.sentForVerificationApplications) && formatters.push(function (application) {
      return /*#__PURE__*/React.createElement("div", {
        className: component.props.classes.horizontalButtonContainer
      }, component.props.disableButtons !== 1 && /*#__PURE__*/React.createElement(Tooltip, {
        title: "Verify"
      }, /*#__PURE__*/React.createElement(IconButton, {
        disabled: application === null || application === void 0 ? void 0 : application.isHistory,
        onClick: function onClick() {
          historyPush$1(modulesManager, history, "workforce.route.applications.application.verify", [decodeId(application === null || application === void 0 ? void 0 : application.id)], false);
        }
      }, /*#__PURE__*/React.createElement(VerifiedUserIcon, {
        style: {
          color: "green"
        }
      }))));
    });
  }

  // --- REVERT BUTTON ---
  {
    var _component$props7;
    !(component !== null && component !== void 0 && (_component$props7 = component.props) !== null && _component$props7 !== void 0 && _component$props7.sentForVerificationApplications) && formatters.push(function (application) {
      return /*#__PURE__*/React.createElement("div", {
        className: component.props.classes.horizontalButtonContainer
      }, component.props.disableButtons !== 1 && !component.props.revertedApplication && /*#__PURE__*/React.createElement(Tooltip, {
        title: "Revert"
      }, /*#__PURE__*/React.createElement(IconButton, {
        disabled: application === null || application === void 0 ? void 0 : application.isHistory,
        onClick: function onClick() {
          component.handleOpenRevertModal(application);
          component.setState({
            revertByChecker: true
          });
        }
      }, /*#__PURE__*/React.createElement(UndoIcon, {
        style: {
          color: "red"
        }
      }))));
    });
  }

  // --- REJECT BUTTON ---
  {
    var _component$props8;
    !(component !== null && component !== void 0 && (_component$props8 = component.props) !== null && _component$props8 !== void 0 && _component$props8.sentForVerificationApplications) && formatters.push(function (application) {
      return /*#__PURE__*/React.createElement("div", {
        className: component.props.classes.horizontalButtonContainer
      }, component.props.disableButtons !== 1 && !component.props.revertedApplication && /*#__PURE__*/React.createElement(Tooltip, {
        title: "Reject"
      }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(IconButton, {
        onClick: function onClick() {
          return component.handleReject(application);
        }
      }, /*#__PURE__*/React.createElement(CloseIcon, {
        style: {
          color: "#750506"
        }
      })))));
    });
  }

  // --- RESEND BUTTON ---
  {
    var _component$props9;
    !(component !== null && component !== void 0 && (_component$props9 = component.props) !== null && _component$props9 !== void 0 && _component$props9.sentForVerificationApplications) && formatters.push(function (application) {
      return /*#__PURE__*/React.createElement("div", {
        className: component.props.classes.horizontalButtonContainer
      }, component.props.revertedApplication && /*#__PURE__*/React.createElement(Tooltip, {
        title: "Resend"
      }, /*#__PURE__*/React.createElement(IconButton, {
        disabled: application === null || application === void 0 ? void 0 : application.isHistory,
        onClick: function onClick() {
          historyPush$1(modulesManager, history, "workforce.route.applications.application.process.resend", [decodeId(application === null || application === void 0 ? void 0 : application.id)], false);
        }
      }, /*#__PURE__*/React.createElement(RestorePageIcon, {
        style: {
          color: "#1976D2"
        }
      }))));
    });
  }
  return formatters;
};
var itemFormattersSectionTwoAdmin = function itemFormattersSectionTwoAdmin(isShowHistory, modulesManager, history, component) {
  var _application8;
  var locale = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : "en";
  var formatters = [function (application) {
    return application === null || application === void 0 ? void 0 : application.trackingNumber;
  }, function (application) {
    return conditionalEnToBn(application === null || application === void 0 ? void 0 : application.dateCreated.split("T")[0], locale);
  }, function (application) {
    var _safeParse19, _safeParse20, _application$workforc21, _application$workforc22;
    return (application === null || application === void 0 ? void 0 : application.applicationType) === "financialAssistance" || (application === null || application === void 0 ? void 0 : application.applicationType) === "deadlyGrant" ? locale === "en" ? (_safeParse19 = safeParse(application === null || application === void 0 ? void 0 : application.deceasedWorkerInfo)) === null || _safeParse19 === void 0 ? void 0 : _safeParse19.nameEn : (_safeParse20 = safeParse(application === null || application === void 0 ? void 0 : application.deceasedWorkerInfo)) === null || _safeParse20 === void 0 ? void 0 : _safeParse20.nameBn : locale === "en" ? application === null || application === void 0 || (_application$workforc21 = application.workforceEmployee) === null || _application$workforc21 === void 0 ? void 0 : _application$workforc21.firstNameEn : application === null || application === void 0 || (_application$workforc22 = application.workforceEmployee) === null || _application$workforc22 === void 0 ? void 0 : _application$workforc22.firstNameBn;
  }, function (application) {
    var _application$employee21, _application$employee22;
    return locale === "en" ? application === null || application === void 0 || (_application$employee21 = application.employeeFactory) === null || _application$employee21 === void 0 ? void 0 : _application$employee21.nameEn : application === null || application === void 0 || (_application$employee22 = application.employeeFactory) === null || _application$employee22 === void 0 ? void 0 : _application$employee22.nameBn;
  }, function (application) {
    var _application$grantMon19, _application$grantMon20;
    return locale === "en" ? application === null || application === void 0 || (_application$grantMon19 = application.grantMoney) === null || _application$grantMon19 === void 0 ? void 0 : _application$grantMon19.applicationTypeNameEn : application === null || application === void 0 || (_application$grantMon20 = application.grantMoney) === null || _application$grantMon20 === void 0 ? void 0 : _application$grantMon20.applicationTypeNameBn;
  },
  // (application) => conditionalEnToBn(application?.grantAmount, locale),
  function (application) {
    var _application$workforc23;
    return application === null || application === void 0 || (_application$workforc23 = application.workforceEmployee) === null || _application$workforc23 === void 0 ? void 0 : _application$workforc23.nid;
  }, function (application) {
    return application !== null && application !== void 0 && application.applicationReceiveDate ? conditionalEnToBn(application.applicationReceiveDate.split("T")[0], locale) : "N/A";
  }, function (application) {
    return application !== null && application !== void 0 && application.applicationForwardDate ? conditionalEnToBn(application.applicationForwardDate.split("T")[0], locale) : "N/A";
  }, function (application) {
    var statusMap = locale === "en" ? STATUS_MAP_EN : STATUS_MAP_BN;
    return statusMap[application === null || application === void 0 ? void 0 : application.status] || (application === null || application === void 0 ? void 0 : application.status);
  }, isShowHistory() ? (_application8 = application) === null || _application8 === void 0 ? void 0 : _application8.version : null];

  // --- VIEW BUTTON ---
  formatters.push(function (application) {
    return /*#__PURE__*/React.createElement("div", {
      className: component.props.classes.horizontalButtonContainer
    }, /*#__PURE__*/React.createElement(Tooltip, {
      title: "View"
    }, /*#__PURE__*/React.createElement(IconButton, {
      disabled: application === null || application === void 0 ? void 0 : application.isHistory,
      onClick: function onClick() {
        return historyPush$1(modulesManager, history, "workforce.route.applications.application.process.view", [decodeId(application === null || application === void 0 ? void 0 : application.id)], false);
      }
    }, /*#__PURE__*/React.createElement(Tab, {
      style: {
        color: "blue"
      }
    }))));
  });

  // --- VERIFY BUTTON ---
  formatters.push(function (application) {
    return /*#__PURE__*/React.createElement("div", {
      className: component.props.classes.horizontalButtonContainer
    }, /*#__PURE__*/React.createElement(Tooltip, {
      title: "Verify"
    }, /*#__PURE__*/React.createElement(IconButton, {
      disabled: application === null || application === void 0 ? void 0 : application.isHistory,
      onClick: function onClick() {
        return historyPush$1(modulesManager, history, "workforce.route.applications.application.verify", [decodeId(application === null || application === void 0 ? void 0 : application.id)], false);
      }
    }, /*#__PURE__*/React.createElement(VerifiedUserIcon, {
      style: {
        color: "green"
      }
    }))));
  });

  // --- REVERT BUTTON ---
  formatters.push(function (application) {
    return /*#__PURE__*/React.createElement("div", {
      className: component.props.classes.horizontalButtonContainer
    }, !component.props.revertedApplication && /*#__PURE__*/React.createElement(Tooltip, {
      title: "Revert"
    }, /*#__PURE__*/React.createElement(IconButton, {
      disabled: application === null || application === void 0 ? void 0 : application.isHistory,
      onClick: function onClick() {
        component.handleOpenRevertModal(application);
        component.setState({
          revertByChecker: true
        });
      }
    }, /*#__PURE__*/React.createElement(UndoIcon, {
      style: {
        color: "red"
      }
    }))));
  });

  // --- REJECT BUTTON ---
  formatters.push(function (application) {
    return /*#__PURE__*/React.createElement("div", {
      className: component.props.classes.horizontalButtonContainer
    }, !component.props.revertedApplication && /*#__PURE__*/React.createElement(Tooltip, {
      title: "Reject"
    }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(IconButton, {
      onClick: function onClick() {
        return component.handleReject(application);
      }
    }, /*#__PURE__*/React.createElement(CloseIcon, {
      style: {
        color: "#750506"
      }
    })))));
  });

  // --- RESEND BUTTON ---
  formatters.push(function (application) {
    return /*#__PURE__*/React.createElement("div", {
      className: component.props.classes.horizontalButtonContainer
    }, component.props.revertedApplication && /*#__PURE__*/React.createElement(Tooltip, {
      title: "Resend"
    }, /*#__PURE__*/React.createElement(IconButton, {
      disabled: application === null || application === void 0 ? void 0 : application.isHistory,
      onClick: function onClick() {
        return historyPush$1(modulesManager, history, "workforce.route.applications.application.process.resend", [decodeId(application === null || application === void 0 ? void 0 : application.id)], false);
      }
    }, /*#__PURE__*/React.createElement(RestorePageIcon, {
      style: {
        color: "#1976D2"
      }
    }))));
  });
  return formatters;
};
var itemFormattersBlwfSectionAdmin = function itemFormattersBlwfSectionAdmin(isShowHistory, modulesManager, history, component) {
  var _application9;
  var locale = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : "en";
  var formatters = [function (application) {
    return application === null || application === void 0 ? void 0 : application.trackingNumber;
  }, function (application) {
    return conditionalEnToBn(application === null || application === void 0 ? void 0 : application.dateCreated.split("T")[0], locale);
  }, function (application) {
    var _safeParse21, _safeParse22, _application$workforc24, _application$workforc25;
    return (application === null || application === void 0 ? void 0 : application.applicationType) === "financialAssistance" || (application === null || application === void 0 ? void 0 : application.applicationType) === "deadlyGrant" ? locale === "en" ? (_safeParse21 = safeParse(application === null || application === void 0 ? void 0 : application.deceasedWorkerInfo)) === null || _safeParse21 === void 0 ? void 0 : _safeParse21.nameEn : (_safeParse22 = safeParse(application === null || application === void 0 ? void 0 : application.deceasedWorkerInfo)) === null || _safeParse22 === void 0 ? void 0 : _safeParse22.nameBn : locale === "en" ? application === null || application === void 0 || (_application$workforc24 = application.workforceEmployee) === null || _application$workforc24 === void 0 ? void 0 : _application$workforc24.firstNameEn : application === null || application === void 0 || (_application$workforc25 = application.workforceEmployee) === null || _application$workforc25 === void 0 ? void 0 : _application$workforc25.firstNameBn;
  }, function (application) {
    var _application$grantMon21, _application$grantMon22;
    return locale === "en" ? application === null || application === void 0 || (_application$grantMon21 = application.grantMoney) === null || _application$grantMon21 === void 0 ? void 0 : _application$grantMon21.applicationTypeNameEn : application === null || application === void 0 || (_application$grantMon22 = application.grantMoney) === null || _application$grantMon22 === void 0 ? void 0 : _application$grantMon22.applicationTypeNameBn;
  }].concat(_toConsumableArray(isEisPath() ? [] : [function (application) {
    return conditionalEnToBn(application === null || application === void 0 ? void 0 : application.grantAmount, locale);
  }]), [function (application) {
    var _application$workforc26;
    return application === null || application === void 0 || (_application$workforc26 = application.workforceEmployee) === null || _application$workforc26 === void 0 ? void 0 : _application$workforc26.nid;
  }, function (application) {
    return application !== null && application !== void 0 && application.applicationReceiveDate ? conditionalEnToBn(application.applicationReceiveDate.split("T")[0], locale) : "N/A";
  }, function (application) {
    return application !== null && application !== void 0 && application.applicationForwardDate ? conditionalEnToBn(application.applicationForwardDate.split("T")[0], locale) : "N/A";
  }, function (application) {
    var statusMap = locale === "en" ? STATUS_MAP_EN : STATUS_MAP_BN;
    return statusMap[application === null || application === void 0 ? void 0 : application.status] || (application === null || application === void 0 ? void 0 : application.status);
  }, isShowHistory() ? (_application9 = application) === null || _application9 === void 0 ? void 0 : _application9.version : null]);

  // -----------------------
  // ICON #1: View
  // -----------------------
  formatters.push(function (application) {
    return /*#__PURE__*/React.createElement("div", {
      className: component.props.classes.horizontalButtonContainer
    }, /*#__PURE__*/React.createElement(Tooltip, {
      title: "View"
    }, /*#__PURE__*/React.createElement(IconButton, {
      disabled: application === null || application === void 0 ? void 0 : application.isHistory,
      onClick: function onClick() {
        historyPush$1(modulesManager, history, "workforce.route.applications.application.process.view", [decodeId(application === null || application === void 0 ? void 0 : application.id)], false);
      }
    }, /*#__PURE__*/React.createElement(Tab, {
      style: {
        color: "blue"
      }
    }))));
  });

  // -----------------------
  // ICON #2: Verify
  // -----------------------
  formatters.push(function (application) {
    return /*#__PURE__*/React.createElement("div", {
      className: component.props.classes.horizontalButtonContainer
    }, component.props.disableButtons !== 1 && /*#__PURE__*/React.createElement(Tooltip, {
      title: "Verify"
    }, /*#__PURE__*/React.createElement(IconButton, {
      disabled: application === null || application === void 0 ? void 0 : application.isHistory,
      onClick: function onClick() {
        historyPush$1(modulesManager, history, "workforce.route.applications.application.verify", [decodeId(application === null || application === void 0 ? void 0 : application.id)], false);
      }
    }, /*#__PURE__*/React.createElement(VerifiedUserIcon, {
      style: {
        color: "green"
      }
    }))));
  });

  // -----------------------
  // ICON #3: Revert
  // -----------------------
  formatters.push(function (application) {
    return /*#__PURE__*/React.createElement("div", {
      className: component.props.classes.horizontalButtonContainer
    }, component.props.disableButtons !== 1 && !component.props.revertedApplication && /*#__PURE__*/React.createElement(Tooltip, {
      title: "Revert"
    }, /*#__PURE__*/React.createElement(IconButton, {
      disabled: application === null || application === void 0 ? void 0 : application.isHistory,
      onClick: function onClick() {
        component.handleOpenRevertModal(application);
        component.setState({
          revertByChecker: true
        });
      }
    }, /*#__PURE__*/React.createElement(UndoIcon, {
      style: {
        color: "red"
      }
    }))));
  });

  // -----------------------
  // ICON #4: Reject
  // -----------------------
  formatters.push(function (application) {
    return /*#__PURE__*/React.createElement("div", {
      className: component.props.classes.horizontalButtonContainer
    }, component.props.disableButtons !== 1 && !component.props.revertedApplication && /*#__PURE__*/React.createElement(Tooltip, {
      title: "Reject"
    }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(IconButton, {
      onClick: function onClick() {
        return component.handleReject(application);
      }
    }, /*#__PURE__*/React.createElement(CloseIcon, {
      style: {
        color: "#750506"
      }
    })))));
  });

  // -----------------------
  // ICON #5: Resend (for reverted applications)
  // -----------------------
  formatters.push(function (application) {
    return /*#__PURE__*/React.createElement("div", {
      className: component.props.classes.horizontalButtonContainer
    }, component.props.revertedApplication && /*#__PURE__*/React.createElement(Tooltip, {
      title: "Resend"
    }, /*#__PURE__*/React.createElement(IconButton, {
      disabled: application === null || application === void 0 ? void 0 : application.isHistory,
      onClick: function onClick() {
        historyPush$1(modulesManager, history, "workforce.route.applications.application.process.resend", [decodeId(application === null || application === void 0 ? void 0 : application.id)], false);
      }
    }, /*#__PURE__*/React.createElement(RestorePageIcon, {
      style: {
        color: "#1976D2"
      }
    }))));
  });
  return formatters;
};
var itemFormattersDoctor = function itemFormattersDoctor(isShowHistory, modulesManager, history, component) {
  var _application10;
  var locale = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : "en";
  var formatters = [function (application) {
    return application === null || application === void 0 ? void 0 : application.trackingNumber;
  }, function (application) {
    return conditionalEnToBn(application === null || application === void 0 ? void 0 : application.dateCreated.split("T")[0], locale);
  }, function (application) {
    var _safeParse23, _safeParse24, _application$workforc27, _application$workforc28;
    return (application === null || application === void 0 ? void 0 : application.applicationType) === "financialAssistance" || (application === null || application === void 0 ? void 0 : application.applicationType) === "deadlyGrant" ? locale === "en" ? (_safeParse23 = safeParse(application === null || application === void 0 ? void 0 : application.deceasedWorkerInfo)) === null || _safeParse23 === void 0 ? void 0 : _safeParse23.nameEn : (_safeParse24 = safeParse(application === null || application === void 0 ? void 0 : application.deceasedWorkerInfo)) === null || _safeParse24 === void 0 ? void 0 : _safeParse24.nameBn : locale === "en" ? application === null || application === void 0 || (_application$workforc27 = application.workforceEmployee) === null || _application$workforc27 === void 0 ? void 0 : _application$workforc27.firstNameEn : application === null || application === void 0 || (_application$workforc28 = application.workforceEmployee) === null || _application$workforc28 === void 0 ? void 0 : _application$workforc28.firstNameBn;
  }, function (application) {
    var _application$employee23, _application$employee24;
    return locale === "en" ? application === null || application === void 0 || (_application$employee23 = application.employeeFactory) === null || _application$employee23 === void 0 ? void 0 : _application$employee23.nameEn : application === null || application === void 0 || (_application$employee24 = application.employeeFactory) === null || _application$employee24 === void 0 ? void 0 : _application$employee24.nameBn;
  }, function (application) {
    var _application$grantMon23, _application$grantMon24;
    return locale === "en" ? application === null || application === void 0 || (_application$grantMon23 = application.grantMoney) === null || _application$grantMon23 === void 0 ? void 0 : _application$grantMon23.applicationTypeNameEn : application === null || application === void 0 || (_application$grantMon24 = application.grantMoney) === null || _application$grantMon24 === void 0 ? void 0 : _application$grantMon24.applicationTypeNameBn;
  }].concat(_toConsumableArray(isEisPath() ? [] : [function (application) {
    return /*#__PURE__*/React.createElement(TextInput, {
      value: application === null || application === void 0 ? void 0 : application.grantAmount,
      onChange: function onChange(v) {
        return component.setState({
          editedGrantMoney: v
        });
      }
    });
  }]), [function (application) {
    return application !== null && application !== void 0 && application.applicationReceiveDate ? conditionalEnToBn(application.applicationReceiveDate.split("T")[0], locale) : "N/A";
  }, function (application) {
    return application !== null && application !== void 0 && application.applicationForwardDate ? conditionalEnToBn(application.applicationForwardDate.split("T")[0], locale) : "N/A";
  }, function (application) {
    var statusMap = locale === "en" ? STATUS_MAP_EN : STATUS_MAP_BN;
    return statusMap[application === null || application === void 0 ? void 0 : application.status] || (application === null || application === void 0 ? void 0 : application.status);
  }, isShowHistory() ? (_application10 = application) === null || _application10 === void 0 ? void 0 : _application10.version : null]);

  // --- VIEW BUTTON ---
  formatters.push(function (application) {
    return /*#__PURE__*/React.createElement("div", {
      className: component.props.classes.horizontalButtonContainer
    }, /*#__PURE__*/React.createElement(Tooltip, {
      title: "View"
    }, /*#__PURE__*/React.createElement(IconButton, {
      disabled: application === null || application === void 0 ? void 0 : application.isHistory,
      onClick: function onClick() {
        historyPush$1(modulesManager, history, "workforce.route.applications.application.process.view", [decodeId(application === null || application === void 0 ? void 0 : application.id)], false);
      }
    }, /*#__PURE__*/React.createElement(Tab, {
      style: {
        color: "blue"
      }
    }))));
  });

  // --- VERIFY BUTTON ---
  if (component.props.disableButtons != 1) {
    formatters.push(function (application) {
      return /*#__PURE__*/React.createElement("div", {
        className: component.props.classes.horizontalButtonContainer
      }, /*#__PURE__*/React.createElement(Tooltip, {
        title: "Verify"
      }, /*#__PURE__*/React.createElement(IconButton, {
        disabled: application === null || application === void 0 ? void 0 : application.isHistory,
        onClick: function onClick() {
          historyPush$1(modulesManager, history, "workforce.route.applications.application.verify", [decodeId(application === null || application === void 0 ? void 0 : application.id)], false);
        }
      }, /*#__PURE__*/React.createElement(VerifiedUserIcon, {
        style: {
          color: "green"
        }
      }))));
    });
  }

  // --- APPROVE BUTTON ---
  if (component.props.disableButtons != 1 && !isEisPath()) {
    formatters.push(function (application) {
      if ((application === null || application === void 0 ? void 0 : application.status) === "approved_by_doctor") return null;
      return /*#__PURE__*/React.createElement("div", {
        className: component.props.classes.horizontalButtonContainer
      }, /*#__PURE__*/React.createElement(Tooltip, {
        title: "Approve"
      }, /*#__PURE__*/React.createElement(IconButton, {
        disabled: application === null || application === void 0 ? void 0 : application.isHistory,
        onClick: function onClick() {
          return component.handleApprovalByDoctor(application);
        }
      }, /*#__PURE__*/React.createElement(Check, {
        style: {
          color: "#006273"
        }
      }))));
    });
  }

  // --- REVERT BUTTON ---
  if (component.props.disableButtons != 1) {
    formatters.push(function (application) {
      return /*#__PURE__*/React.createElement("div", {
        className: component.props.classes.horizontalButtonContainer
      }, /*#__PURE__*/React.createElement(Tooltip, {
        title: "Revert"
      }, /*#__PURE__*/React.createElement(IconButton, {
        disabled: application === null || application === void 0 ? void 0 : application.isHistory,
        onClick: function onClick() {
          component.handleOpenRevertModal(application);
          component.setState({
            revertByChecker: true
          });
        }
      }, /*#__PURE__*/React.createElement(UndoIcon, {
        style: {
          color: "red"
        }
      }))));
    });
  }

  // --- RESEND BUTTON ---
  if (component.props.disableButtons != 1) {
    formatters.push(function (application) {
      return /*#__PURE__*/React.createElement("div", {
        className: component.props.classes.horizontalButtonContainer
      }, component.props.revertedApplication && /*#__PURE__*/React.createElement(Tooltip, {
        title: "Resend"
      }, /*#__PURE__*/React.createElement(IconButton, {
        disabled: application === null || application === void 0 ? void 0 : application.isHistory,
        onClick: function onClick() {
          historyPush$1(modulesManager, history, "workforce.route.applications.application.process.resend", [decodeId(application === null || application === void 0 ? void 0 : application.id)], false);
        }
      }, /*#__PURE__*/React.createElement(RestorePageIcon, {
        style: {
          color: "#1976D2"
        }
      }))));
    });
  }
  return formatters;
};
var itemFormattersAssociation = function itemFormattersAssociation(isShowHistory, modulesManager, history, component) {
  var _application11;
  var locale = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : "en";
  var formatters = [function (application) {
    return application.trackingNumber;
  }, function (application) {
    return conditionalEnToBn(application.dateCreated.split("T")[0], locale);
  }, function (application) {
    var _safeParse25, _safeParse26, _application$workforc29, _application$workforc30;
    return (application === null || application === void 0 ? void 0 : application.applicationType) === "financialAssistance" || (application === null || application === void 0 ? void 0 : application.applicationType) === "deadlyGrant" ? locale === "en" ? (_safeParse25 = safeParse(application === null || application === void 0 ? void 0 : application.deceasedWorkerInfo)) === null || _safeParse25 === void 0 ? void 0 : _safeParse25.nameEn : (_safeParse26 = safeParse(application === null || application === void 0 ? void 0 : application.deceasedWorkerInfo)) === null || _safeParse26 === void 0 ? void 0 : _safeParse26.nameBn : locale === "en" ? application === null || application === void 0 || (_application$workforc29 = application.workforceEmployee) === null || _application$workforc29 === void 0 ? void 0 : _application$workforc29.firstNameEn : application === null || application === void 0 || (_application$workforc30 = application.workforceEmployee) === null || _application$workforc30 === void 0 ? void 0 : _application$workforc30.firstNameBn;
  }, function (application) {
    var _application$employee25, _application$employee26;
    return locale === "en" ? application === null || application === void 0 || (_application$employee25 = application.employeeFactory) === null || _application$employee25 === void 0 ? void 0 : _application$employee25.nameEn : application === null || application === void 0 || (_application$employee26 = application.employeeFactory) === null || _application$employee26 === void 0 ? void 0 : _application$employee26.nameBn;
  }, function (application) {
    var _application$grantMon25, _application$grantMon26;
    return locale === "en" ? application === null || application === void 0 || (_application$grantMon25 = application.grantMoney) === null || _application$grantMon25 === void 0 ? void 0 : _application$grantMon25.applicationTypeNameEn : application === null || application === void 0 || (_application$grantMon26 = application.grantMoney) === null || _application$grantMon26 === void 0 ? void 0 : _application$grantMon26.applicationTypeNameBn;
  }, function (application) {
    return application !== null && application !== void 0 && application.lastMovementDate ? conditionalEnToBn(application.lastMovementDate.split("T")[0], locale) : "N/A";
  }, function (application) {
    return application !== null && application !== void 0 && application.applicationForwardDate ? conditionalEnToBn(application.applicationForwardDate.split("T")[0], locale) : "N/A";
  }, function (application) {
    return application !== null && application !== void 0 && application.organizationType ? locale === "en" ? ORGANIZATION_TYPE_NAME_EN[application === null || application === void 0 ? void 0 : application.organizationType] : ORGANIZATION_TYPE_NAME_BN[application === null || application === void 0 ? void 0 : application.organizationType] : "N/A";
  }, function (application) {
    var statusMap = locale === "en" ? STATUS_MAP_EN : STATUS_MAP_BN;
    return statusMap[application === null || application === void 0 ? void 0 : application.status] || (application === null || application === void 0 ? void 0 : application.status);
  }, isShowHistory() ? (_application11 = application) === null || _application11 === void 0 ? void 0 : _application11.version : null];

  // --- VIEW BUTTON ---
  formatters.push(function (application) {
    return /*#__PURE__*/React.createElement("div", {
      className: component.props.classes.horizontalButtonContainer
    }, /*#__PURE__*/React.createElement(Tooltip, {
      title: "View"
    }, /*#__PURE__*/React.createElement(IconButton, {
      disabled: application === null || application === void 0 ? void 0 : application.isHistory,
      onClick: function onClick() {
        historyPush$1(modulesManager, history, "workforce.route.applications.application.process.view", [decodeId(application === null || application === void 0 ? void 0 : application.id)], false);
      }
    }, /*#__PURE__*/React.createElement(Tab, {
      style: {
        color: "blue"
      }
    }))));
  });

  // --- VERIFY & REVERT BUTTONS ---
  {
    var _component$props10;
    !(component !== null && component !== void 0 && (_component$props10 = component.props) !== null && _component$props10 !== void 0 && _component$props10.forwardedApplications) && formatters.push(function (application) {
      return /*#__PURE__*/React.createElement("div", {
        className: component.props.classes.horizontalButtonContainer
      }, (component.props.disableButtons !== 1 || component.props.revertedApplication) && !component.props.revertedApplication && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Tooltip, {
        title: "Verify"
      }, /*#__PURE__*/React.createElement(IconButton, {
        disabled: application === null || application === void 0 ? void 0 : application.isHistory,
        onClick: function onClick() {
          historyPush$1(modulesManager, history, "workforce.route.applications.application.verify", [decodeId(application === null || application === void 0 ? void 0 : application.id)], false);
        }
      }, /*#__PURE__*/React.createElement(VerifiedUserIcon, {
        style: {
          color: "green"
        }
      })))));
    });
    formatters.push(function (application) {
      var _component$props11;
      return /*#__PURE__*/React.createElement("div", {
        className: component.props.classes.horizontalButtonContainer
      }, !(component !== null && component !== void 0 && (_component$props11 = component.props) !== null && _component$props11 !== void 0 && _component$props11.forwardedApplications) && (component.props.disableButtons !== 1 || component.props.revertedApplication) && /*#__PURE__*/React.createElement(Tooltip, {
        title: "Revert"
      }, /*#__PURE__*/React.createElement(IconButton, {
        disabled: application === null || application === void 0 ? void 0 : application.isHistory,
        onClick: function onClick() {
          component.handleOpenRevertModal(application);
          component.setState({
            revertByChecker: true
          });
        }
      }, /*#__PURE__*/React.createElement(UndoIcon, {
        style: {
          color: "red"
        }
      }))));
    });
    // --- RESEND BUTTON ---
    formatters.push(function (application) {
      return /*#__PURE__*/React.createElement("div", {
        className: component.props.classes.horizontalButtonContainer
      }, component.props.revertedApplication && /*#__PURE__*/React.createElement(Tooltip, {
        title: "Resend"
      }, /*#__PURE__*/React.createElement(IconButton, {
        disabled: application === null || application === void 0 ? void 0 : application.isHistory,
        onClick: function onClick() {
          historyPush$1(modulesManager, history, "workforce.route.applications.application.process.resend", [decodeId(application === null || application === void 0 ? void 0 : application.id)], false);
        }
      }, /*#__PURE__*/React.createElement(RestorePageIcon, {
        style: {
          color: "#1976D2"
        }
      }))));
    });
  }
  return formatters;
};
var itemFormattersFactoryAdmin = function itemFormattersFactoryAdmin(isShowHistory, modulesManager, history, component) {
  var _application12;
  var locale = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : "en";
  var formatters = [function (application) {
    return application.trackingNumber;
  }, function (application) {
    return conditionalEnToBn(application.dateCreated.split("T")[0], locale);
  }, function (application) {
    var _safeParse27, _safeParse28, _application$workforc31, _application$workforc32;
    return (application === null || application === void 0 ? void 0 : application.applicationType) === "financialAssistance" || (application === null || application === void 0 ? void 0 : application.applicationType) === "deadlyGrant" ? locale === "en" ? (_safeParse27 = safeParse(application === null || application === void 0 ? void 0 : application.deceasedWorkerInfo)) === null || _safeParse27 === void 0 ? void 0 : _safeParse27.nameEn : (_safeParse28 = safeParse(application === null || application === void 0 ? void 0 : application.deceasedWorkerInfo)) === null || _safeParse28 === void 0 ? void 0 : _safeParse28.nameBn : locale === "en" ? application === null || application === void 0 || (_application$workforc31 = application.workforceEmployee) === null || _application$workforc31 === void 0 ? void 0 : _application$workforc31.firstNameEn : application === null || application === void 0 || (_application$workforc32 = application.workforceEmployee) === null || _application$workforc32 === void 0 ? void 0 : _application$workforc32.firstNameBn;
  }, function (application) {
    var _application$employee27, _application$employee28;
    return locale === "en" ? application === null || application === void 0 || (_application$employee27 = application.employeeFactory) === null || _application$employee27 === void 0 ? void 0 : _application$employee27.nameEn : application === null || application === void 0 || (_application$employee28 = application.employeeFactory) === null || _application$employee28 === void 0 ? void 0 : _application$employee28.nameBn;
  }, function (application) {
    var _application$grantMon27, _application$grantMon28;
    return locale === "en" ? application === null || application === void 0 || (_application$grantMon27 = application.grantMoney) === null || _application$grantMon27 === void 0 ? void 0 : _application$grantMon27.applicationTypeNameEn : application === null || application === void 0 || (_application$grantMon28 = application.grantMoney) === null || _application$grantMon28 === void 0 ? void 0 : _application$grantMon28.applicationTypeNameBn;
  }, function (application) {
    return application !== null && application !== void 0 && application.applicationReceiveDate ? conditionalEnToBn(application.applicationReceiveDate.split("T")[0], locale) : "N/A";
  }, function (application) {
    return application !== null && application !== void 0 && application.applicationForwardDate ? conditionalEnToBn(application.applicationForwardDate.split("T")[0], locale) : "N/A";
  }, function (application) {
    var statusMap = locale === "en" ? STATUS_MAP_EN : STATUS_MAP_BN;
    return statusMap[application === null || application === void 0 ? void 0 : application.status] || (application === null || application === void 0 ? void 0 : application.status);
  }, function (application) {
    var userTypeMap = locale === "en" ? WORKFORCE_USER_TYPE_MAP_EN : WORKFORCE_USER_TYPE_MAP_BN;
    return userTypeMap[application === null || application === void 0 ? void 0 : application.submittedBy] || (application === null || application === void 0 ? void 0 : application.submittedBy);
  }, isShowHistory() ? (_application12 = application) === null || _application12 === void 0 ? void 0 : _application12.version : null];
  if (component.props.isDraft) {
    formatters.push(function (application) {
      return /*#__PURE__*/React.createElement("div", {
        className: component.props.classes.horizontalButtonContainer
      }, /*#__PURE__*/React.createElement(Tooltip, {
        title: "Resend"
      }, /*#__PURE__*/React.createElement(IconButton, {
        disabled: application === null || application === void 0 ? void 0 : application.isHistory,
        onClick: function onClick() {
          isEisPath() ? historyPush$1(modulesManager, history, "workforce.route.application.eis", [decodeId(application === null || application === void 0 ? void 0 : application.id)], false) : historyPush$1(modulesManager, history, "workforce.route.application", [decodeId(application === null || application === void 0 ? void 0 : application.id)], false);
        }
      }, /*#__PURE__*/React.createElement(DoubleArrowIcon, null))));
    });
  } else {
    // View button
    formatters.push(function (application) {
      return /*#__PURE__*/React.createElement("div", {
        className: component.props.classes.horizontalButtonContainer
      }, /*#__PURE__*/React.createElement(Tooltip, {
        title: "\u09AD\u09BF\u0989"
      }, /*#__PURE__*/React.createElement(IconButton, {
        disabled: application === null || application === void 0 ? void 0 : application.isHistory,
        onClick: function onClick() {
          historyPush$1(modulesManager, history, "workforce.route.applications.application.process.view", [decodeId(application === null || application === void 0 ? void 0 : application.id)], false);
        }
      }, /*#__PURE__*/React.createElement(Tab, {
        style: {
          color: "blue"
        }
      }))));
    });

    // Verify + Revert
    formatters.push(function (application) {
      return component.props.disableButtons !== 1 && !component.props.revertedApplication ? /*#__PURE__*/React.createElement("div", {
        className: component.props.classes.horizontalButtonContainer
      }, /*#__PURE__*/React.createElement(Tooltip, {
        title: "\u09AF\u09BE\u099A\u09BE\u0987"
      }, /*#__PURE__*/React.createElement(IconButton, {
        disabled: application === null || application === void 0 ? void 0 : application.isHistory,
        onClick: function onClick() {
          historyPush$1(modulesManager, history, "workforce.route.applications.application.verify", [decodeId(application === null || application === void 0 ? void 0 : application.id)], false);
        }
      }, /*#__PURE__*/React.createElement(VerifiedUserIcon, {
        style: {
          color: "green"
        }
      })))) : null;
    });
    formatters.push(function (application) {
      return component.props.disableButtons !== 1 && !component.props.revertedApplication ? /*#__PURE__*/React.createElement("div", {
        className: component.props.classes.horizontalButtonContainer
      }, /*#__PURE__*/React.createElement(Tooltip, {
        title: "\u09B0\u09BF\u09AD\u09BE\u09B0\u09CD\u099F"
      }, /*#__PURE__*/React.createElement(IconButton, {
        disabled: application === null || application === void 0 ? void 0 : application.isHistory,
        onClick: function onClick() {
          component.handleOpenRevertModal(application);
          component.setState({
            revertByChecker: true
          });
        }
      }, /*#__PURE__*/React.createElement(UndoIcon, {
        style: {
          color: "red"
        }
      })))) : null;
    });

    // Resend
    formatters.push(function (application) {
      return component.props.disableButtons !== 1 && component.props.revertedApplication ? /*#__PURE__*/React.createElement("div", {
        className: component.props.classes.horizontalButtonContainer
      }, /*#__PURE__*/React.createElement(Tooltip, {
        title: "Resend"
      }, /*#__PURE__*/React.createElement(IconButton, {
        disabled: application === null || application === void 0 ? void 0 : application.isHistory,
        onClick: function onClick() {
          historyPush$1(modulesManager, history, "workforce.route.applications.application.process.resend", [decodeId(application === null || application === void 0 ? void 0 : application.id)], false);
        }
      }, /*#__PURE__*/React.createElement(RestorePageIcon, {
        style: {
          color: "#1976D2"
        }
      })))) : null;
    });
  }
  return formatters;
};
var itemFormattersApprover = function itemFormattersApprover(isShowHistory, modulesManager, history, component) {
  var _application13;
  var locale = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : "en";
  var formatters = [function (application) {
    return application.trackingNumber;
  }, function (application) {
    return conditionalEnToBn(application.dateCreated.split("T")[0], locale);
  }, function (application) {
    var _safeParse29, _safeParse30, _application$workforc33, _application$workforc34;
    return (application === null || application === void 0 ? void 0 : application.applicationType) === "financialAssistance" || (application === null || application === void 0 ? void 0 : application.applicationType) === "deadlyGrant" ? locale === "en" ? (_safeParse29 = safeParse(application === null || application === void 0 ? void 0 : application.deceasedWorkerInfo)) === null || _safeParse29 === void 0 ? void 0 : _safeParse29.nameEn : (_safeParse30 = safeParse(application === null || application === void 0 ? void 0 : application.deceasedWorkerInfo)) === null || _safeParse30 === void 0 ? void 0 : _safeParse30.nameBn : locale === "en" ? application === null || application === void 0 || (_application$workforc33 = application.workforceEmployee) === null || _application$workforc33 === void 0 ? void 0 : _application$workforc33.firstNameEn : application === null || application === void 0 || (_application$workforc34 = application.workforceEmployee) === null || _application$workforc34 === void 0 ? void 0 : _application$workforc34.firstNameBn;
  }, function (application) {
    var _application$grantMon29, _application$grantMon30;
    return locale === "en" ? application === null || application === void 0 || (_application$grantMon29 = application.grantMoney) === null || _application$grantMon29 === void 0 ? void 0 : _application$grantMon29.applicationTypeNameEn : application === null || application === void 0 || (_application$grantMon30 = application.grantMoney) === null || _application$grantMon30 === void 0 ? void 0 : _application$grantMon30.applicationTypeNameBn;
  }].concat(_toConsumableArray(isEisPath() ? [] : [function (application) {
    return conditionalEnToBn(application === null || application === void 0 ? void 0 : application.grantAmount, locale);
  }]), [function (application) {
    return application !== null && application !== void 0 && application.applicationReceiveDate ? conditionalEnToBn(application.applicationReceiveDate.split("T")[0], locale) : "N/A";
  }, function (application) {
    return application !== null && application !== void 0 && application.applicationForwardDate ? conditionalEnToBn(application.applicationForwardDate.split("T")[0], locale) : "N/A";
  }, function (application) {
    var statusMap = locale === "en" ? STATUS_MAP_EN : STATUS_MAP_BN;
    return statusMap[application === null || application === void 0 ? void 0 : application.status] || (application === null || application === void 0 ? void 0 : application.status);
  },
  // ...(component?.props?.summaryId ? [(application) => application?.committeeRemarks]:[] ),
  isShowHistory() ? (_application13 = application) === null || _application13 === void 0 ? void 0 : _application13.version : null]);
  formatters.push(function (application) {
    return /*#__PURE__*/React.createElement("div", {
      className: component.props.classes.horizontalButtonContainer
    }, /*#__PURE__*/React.createElement(Tooltip, {
      title: "View"
    }, /*#__PURE__*/React.createElement(IconButton, {
      disabled: application === null || application === void 0 ? void 0 : application.isHistory,
      onClick: function onClick() {
        historyPush$1(modulesManager, history, "workforce.route.applications.application.process.view", [decodeId(application === null || application === void 0 ? void 0 : application.id)], false);
      }
    }, /*#__PURE__*/React.createElement(Tab, null))), component.props.disableButtons !== 1 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Tooltip, {
      title: "Revert"
    }, /*#__PURE__*/React.createElement(IconButton, {
      disabled: application === null || application === void 0 ? void 0 : application.isHistory,
      onClick: function onClick() {
        component.handleOpenRevertModal(application);
        component.setState({
          revertByChecker: true
        });
      }
    }, /*#__PURE__*/React.createElement(UndoIcon, null))), /*#__PURE__*/React.createElement(Tooltip, {
      title: "Reject"
    }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(IconButton, {
      onClick: function onClick() {
        return component.handleReject(application);
      }
    }, /*#__PURE__*/React.createElement(CloseIcon, {
      style: {
        color: "#750506"
      }
    }))))));
  });
  return formatters;
};

var MedicalMaternityView = function MedicalMaternityView(_ref) {
  var classes = _ref.classes,
    applications = _ref.applications,
    getTotalAmount = _ref.getTotalAmount;
  console.log({
    applications: applications
  });
  var stats = {
    TA: 0,
    MA: 0,
    Total: applications.length
  };
  applications.forEach(function (app) {
    if (app.applicationType === "maternityGrant") stats.MA += 1;else stats.TA += 1;
  });
  var getRows = function getRows() {
    var rows = [];
    applications.forEach(function (app, appIndex) {
      var _app$workforceEmploye, _app$workforceEmploye2, _app$workforceEmploye3;
      var bankInfos = [];
      try {
        var parsed = JSON.parse(app.employeeBankInfo);
        bankInfos = Array.isArray(parsed) ? parsed : JSON.parse(parsed);
      } catch (e) {}
      var diseaseType = app.applicationType === "maternityGrant" ? "Maternity" : "Treatment";
      try {
        var info = JSON.parse(JSON.parse(app.employeeAccidentInfo || "{}"));
        if (info.diseaseName) diseaseType = info.diseaseName;
      } catch (e) {}
      safeParse(app === null || app === void 0 || (_app$workforceEmploye = app.workforceEmployee) === null || _app$workforceEmploye === void 0 ? void 0 : _app$workforceEmploye.presentAddress) || {};
      var formattedAddress = formatAddress$3(app === null || app === void 0 || (_app$workforceEmploye2 = app.workforceEmployee) === null || _app$workforceEmploye2 === void 0 ? void 0 : _app$workforceEmploye2.presentLocation, // Make sure this matches your actual location key
      app === null || app === void 0 || (_app$workforceEmploye3 = app.workforceEmployee) === null || _app$workforceEmploye3 === void 0 ? void 0 : _app$workforceEmploye3.presentAddress);
      bankInfos.forEach(function (bankInfo, bankIndex) {
        var _app$workforceEmploye4, _app$workforceEmploye5, _app$workforceEmploye6, _app$workforceEmploye7, _app$employeeFactory, _app$employeeFactory2, _app$workforceEmploye8, _app$workforceEmploye9, _app$workforceEmploye10, _app$workforceEmploye11, _app$workforceEmploye12, _app$workforceEmploye13, _app$employeeFactory3, _bankInfo$branch;
        rows.push({
          sl: appIndex + 1 + bankIndex,
          mainListNo: app.dateCreated.split("T")[0] || "",
          workerName: ((_app$workforceEmploye4 = app.workforceEmployee) === null || _app$workforceEmploye4 === void 0 ? void 0 : _app$workforceEmploye4.firstNameBn) || ((_app$workforceEmploye5 = app.workforceEmployee) === null || _app$workforceEmploye5 === void 0 ? void 0 : _app$workforceEmploye5.firstNameEn) || "",
          fatherName: ((_app$workforceEmploye6 = app.workforceEmployee) === null || _app$workforceEmploye6 === void 0 ? void 0 : _app$workforceEmploye6.fatherNameBn) || ((_app$workforceEmploye7 = app.workforceEmployee) === null || _app$workforceEmploye7 === void 0 ? void 0 : _app$workforceEmploye7.fatherNameEn) || "",
          factoryName: ((_app$employeeFactory = app.employeeFactory) === null || _app$employeeFactory === void 0 ? void 0 : _app$employeeFactory.nameBn) || ((_app$employeeFactory2 = app.employeeFactory) === null || _app$employeeFactory2 === void 0 ? void 0 : _app$employeeFactory2.nameEn) || "",
          workerNid: ((_app$workforceEmploye8 = app.workforceEmployee) === null || _app$workforceEmploye8 === void 0 ? void 0 : _app$workforceEmploye8.nid) || "",
          workerMobile: ((_app$workforceEmploye9 = app.workforceEmployee) === null || _app$workforceEmploye9 === void 0 ? void 0 : _app$workforceEmploye9.phoneNumber) || "",
          address: "\u0997\u09CD\u09B0\u09BE\u09AE-".concat(formattedAddress.village || "", "\n\u09A1\u09BE\u0995-").concat(formattedAddress.postOffice || "", "\n\u0989\u09AA\u099C\u09C7\u09B2\u09BE-").concat(formattedAddress.thana || "", "\n\u099C\u09C7\u09B2\u09BE-").concat(formattedAddress.district || ""),
          district: formattedAddress.district || "",
          nomineeName: (bankInfo === null || bankInfo === void 0 ? void 0 : bankInfo.accountHolderName) || ((_app$workforceEmploye10 = app.workforceEmployee) === null || _app$workforceEmploye10 === void 0 ? void 0 : _app$workforceEmploye10.firstNameBn) || ((_app$workforceEmploye11 = app.workforceEmployee) === null || _app$workforceEmploye11 === void 0 ? void 0 : _app$workforceEmploye11.firstNameEn) || "",
          nomineeNid: ((_app$workforceEmploye12 = app.workforceEmployee) === null || _app$workforceEmploye12 === void 0 ? void 0 : _app$workforceEmploye12.nid) || "",
          nomineeMobile: ((_app$workforceEmploye13 = app.workforceEmployee) === null || _app$workforceEmploye13 === void 0 ? void 0 : _app$workforceEmploye13.phoneNumber) || "",
          relation: "নিজ",
          disease: diseaseType,
          details: "\u0986\u09AC\u09C7\u09A6\u09A8\u0995\u09BE\u09B0\u09C0 ".concat(diseaseType, " \u098F\u09B0 \u099C\u09A8\u09CD\u09AF \u099A\u09BF\u0995\u09BF\u09CE\u09B8\u09BE \u09B8\u09B9\u09BE\u09AF\u09BC\u09A4\u09BE \u099A\u09C7\u09AF\u09BC\u09C7\u099B\u09C7\u09A8\u0964"),
          profession: ((_app$employeeFactory3 = app.employeeFactory) === null || _app$employeeFactory3 === void 0 ? void 0 : _app$employeeFactory3.nameBn) || "গৃহ শ্রমিক",
          remarks: "শ্রম অধিদপ্তর",
          routingNo: (bankInfo === null || bankInfo === void 0 || (_bankInfo$branch = bankInfo.branch) === null || _bankInfo$branch === void 0 ? void 0 : _bankInfo$branch.routingNumber) || "",
          accountNo: (bankInfo === null || bankInfo === void 0 ? void 0 : bankInfo.accountNumber) || "",
          amount: app.grantAmount || ""
        });
      });
    });
    return rows;
  };
  var rows = getRows();
  console.log({
    MedicalMaternityView: applications
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("table", {
    className: classes.summaryTable
  }, /*#__PURE__*/React.createElement("tbody", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    style: {
      width: "50%"
    }
  }, /*#__PURE__*/React.createElement("strong", null, "Board Meeting:"), " 26th", /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("strong", null, "Fiscal Year:"), " 2025-2026", /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("strong", null, "Number of Application:"), " ", stats.Total, /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("strong", null, "Number of Nominees/Accounts:"), " ", rows.length, /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("strong", null, "Total Amount:"), " ", Number(getTotalAmount()).toLocaleString("en-IN"), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("strong", null, "In Words:")), /*#__PURE__*/React.createElement("td", {
    style: {
      width: "50%",
      padding: 0
    }
  }, /*#__PURE__*/React.createElement("table", {
    style: {
      width: "100%",
      height: "100%",
      borderCollapse: "collapse"
    }
  }, /*#__PURE__*/React.createElement("tbody", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    style: {
      border: "none",
      borderBottom: "1px solid #000"
    }
  }, "Application Type"), /*#__PURE__*/React.createElement("td", {
    style: {
      border: "none",
      borderBottom: "1px solid #000",
      borderLeft: "1px solid #000"
    }
  }, "Total")), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    style: {
      border: "none",
      borderBottom: "1px solid #000"
    }
  }, "Treatment Assistance (TA)"), /*#__PURE__*/React.createElement("td", {
    style: {
      border: "none",
      borderBottom: "1px solid #000",
      borderLeft: "1px solid #000"
    }
  }, stats.TA)), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    style: {
      border: "none",
      borderBottom: "1px solid #000"
    }
  }, "Maternity Assistance (MA)"), /*#__PURE__*/React.createElement("td", {
    style: {
      border: "none",
      borderBottom: "1px solid #000",
      borderLeft: "1px solid #000"
    }
  }, stats.MA)), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    style: {
      border: "none",
      fontWeight: "bold"
    }
  }, "Total"), /*#__PURE__*/React.createElement("td", {
    style: {
      border: "none",
      borderLeft: "1px solid #000",
      fontWeight: "bold"
    }
  }, stats.Total)))))))), isBlwfPath() ? /*#__PURE__*/React.createElement("table", {
    className: classes.excelTable
  }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, "\u0995\u09CD\u09B0\u09AE\u09BF\u0995 \u09A8\u0982"), /*#__PURE__*/React.createElement("th", null, "\u0986\u09AC\u09C7\u09A6\u09A8\u0995\u09BE\u09B0\u09C0 \u09B6\u09CD\u09B0\u09AE\u09BF\u0995\u09C7\u09B0 \u09A8\u09BE\u09AE/\u09AA\u09BF\u09A4\u09BE/\u098F\u09A8\u0986\u0987\u09A1\u09BF/\u09AE\u09CB\u09AC\u09BE-"), /*#__PURE__*/React.createElement("th", null, "\u09A0\u09BF\u0995\u09BE\u09A8\u09BE"), /*#__PURE__*/React.createElement("th", null, "\u09AF\u09BE\u09B0 \u099C\u09A8\u09CD\u09AF \u0986\u09AC\u09C7\u09A6\u09A8 /\u09AF\u09C7 \u0986\u09AC\u09C7\u09A6\u09A8 \u0995\u09B0\u09C7\u099B\u09C7\u09A8 \u09A8\u09BE\u09AE/\u098F\u09A8\u0986\u0987\u09A1\u09BF/\u09AE\u09CB\u09AC\u09BE-"), /*#__PURE__*/React.createElement("th", null, "\u09AC\u09BF\u09AC\u09B0\u09A3"), /*#__PURE__*/React.createElement("th", null, "\u0985\u09A8\u09C1\u09A6\u09BE\u09A8 \u09AA\u09B0\u09BF\u09AE\u09BE\u09A8"), /*#__PURE__*/React.createElement("th", null, "\u09AA\u09C7\u09B6\u09BE/\u09AA\u09CD\u09B0\u09A4\u09BF\u09B7\u09CD\u09A0\u09BE\u09A8"), /*#__PURE__*/React.createElement("th", null, "\u099C\u09C7\u09B2\u09BE"), /*#__PURE__*/React.createElement("th", null, "\u09AE\u09A8\u09CD\u09A4\u09AC\u09CD\u09AF"))), /*#__PURE__*/React.createElement("tbody", null, rows.map(function (row, i) {
    return /*#__PURE__*/React.createElement("tr", {
      key: i
    }, /*#__PURE__*/React.createElement("td", {
      style: {
        textAlign: "center"
      }
    }, i + 1), /*#__PURE__*/React.createElement("td", null, row.workerName, /*#__PURE__*/React.createElement("br", null), "\u09AA\u09BF\u09A4\u09BE-", row.fatherName, /*#__PURE__*/React.createElement("br", null), "\u098F\u09A8\u0986\u0987\u09A1\u09BF-", row.workerNid, /*#__PURE__*/React.createElement("br", null), "\u09AE\u09CB\u09AC\u09BE-", row.workerMobile), /*#__PURE__*/React.createElement("td", {
      style: {
        whiteSpace: "pre-line"
      }
    }, row.address), /*#__PURE__*/React.createElement("td", null, row.nomineeName, " (", row.relation, ")", /*#__PURE__*/React.createElement("br", null), "\u098F\u09A8\u0986\u0987\u09A1\u09BF-", row.nomineeNid, /*#__PURE__*/React.createElement("br", null), "\u09AE\u09CB\u09AC\u09BE-", row.nomineeMobile), /*#__PURE__*/React.createElement("td", null, row.details), /*#__PURE__*/React.createElement("td", {
      style: {
        textAlign: "right"
      }
    }, Number(row.amount).toLocaleString("en-IN")), /*#__PURE__*/React.createElement("td", {
      style: {
        textAlign: "center"
      }
    }, row.profession), /*#__PURE__*/React.createElement("td", {
      style: {
        textAlign: "center"
      }
    }, row.district), /*#__PURE__*/React.createElement("td", null, row.remarks));
  }))) : /*#__PURE__*/React.createElement("table", {
    className: classes.excelTable
  }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, "SL No"), /*#__PURE__*/React.createElement("th", null, "M:SL"), /*#__PURE__*/React.createElement("th", null, "Applicant Name"), /*#__PURE__*/React.createElement("th", null, "NID/Birth Certificate"), /*#__PURE__*/React.createElement("th", null, "Mobile"), /*#__PURE__*/React.createElement("th", null, "Factory Name"), /*#__PURE__*/React.createElement("th", null, "Relation"), /*#__PURE__*/React.createElement("th", null, "Type of Disease"), /*#__PURE__*/React.createElement("th", null, "Routing Number"), /*#__PURE__*/React.createElement("th", null, "Account No"), /*#__PURE__*/React.createElement("th", null, "Amount"))), /*#__PURE__*/React.createElement("tbody", null, rows.map(function (row, i) {
    return /*#__PURE__*/React.createElement("tr", {
      key: i
    }, /*#__PURE__*/React.createElement("td", {
      style: {
        textAlign: "center"
      }
    }, row.sl), /*#__PURE__*/React.createElement("td", {
      style: {
        textAlign: "center"
      }
    }, row.mainListNo), /*#__PURE__*/React.createElement("td", null, row.workerName), /*#__PURE__*/React.createElement("td", null, row.workerNid), /*#__PURE__*/React.createElement("td", null, row.workerMobile), /*#__PURE__*/React.createElement("td", null, row.factoryName), /*#__PURE__*/React.createElement("td", null, row.relation), /*#__PURE__*/React.createElement("td", null, row.disease), /*#__PURE__*/React.createElement("td", null, row.routingNo), /*#__PURE__*/React.createElement("td", null, row.accountNo), /*#__PURE__*/React.createElement("td", {
      style: {
        textAlign: "right"
      }
    }, Number(row.amount).toLocaleString("en-IN")));
  }))));
};

function ownKeys$K(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$K(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$K(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$K(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var getIncidentDetails$1 = function getIncidentDetails(rawInfo) {
  var type = "ND";
  var date = "";
  try {
    var parsed = typeof rawInfo === "string" ? JSON.parse(rawInfo) : rawInfo;
    var info = typeof parsed === "string" ? JSON.parse(parsed) : parsed;
    date = (info === null || info === void 0 ? void 0 : info.accidentDate) || (info === null || info === void 0 ? void 0 : info.dateOfDeath) || "";
    if ((info === null || info === void 0 ? void 0 : info.accidentMainType) === "workforce.accident.mainType.workplace") type = "WAD";else if ((info === null || info === void 0 ? void 0 : info.accidentMainType) === "workforce.accident.mainType.onDutyRTA") type = "OAD";else if ((info === null || info === void 0 ? void 0 : info.accidentMainType) === "workforce.accident.mainType.commuting") type = "OAD";
  } catch (e) {}
  return {
    type: type,
    date: date
  };
};
var DeathDisabilityView = function DeathDisabilityView(_ref) {
  var classes = _ref.classes,
    applications = _ref.applications;
    _ref.dependentData;
    var getTotalAmount = _ref.getTotalAmount;
  // const isFinancialAssistance = applications[0]?.applicationType === "financialAssistance";
  var stats = {
    ND: 0,
    OAD: 0,
    WAD: 0,
    WOD: 0,
    WPD: 0,
    WTD: 0,
    OTD: 0,
    Total: applications.length
  };
  applications.forEach(function (app) {
    var _getIncidentDetails = getIncidentDetails$1(app.employeeAccidentInfo),
      type = _getIncidentDetails.type;
    if (stats[type] !== undefined) stats[type] += 1;else stats.ND += 1;
  });
  var getRows = function getRows() {
    var rows = [];
    var slIndex = 1;
    applications.forEach(function (app) {
      var _app$employeeFactory, _app$employeeFactory2, _app$employeeFactory3, _app$workforceEmploye;
      var isDeathApp = ["financialAssistance", "deadlyGrant"].includes(app === null || app === void 0 ? void 0 : app.applicationType);
      var _getIncidentDetails2 = getIncidentDetails$1(app === null || app === void 0 ? void 0 : app.employeeAccidentInfo),
        type = _getIncidentDetails2.type,
        date = _getIncidentDetails2.date;
      var deceasedWorkerInfo = safeParse(app === null || app === void 0 ? void 0 : app.deceasedWorkerInfo) || {};
      var metadata = safeParse(app === null || app === void 0 ? void 0 : app.metadata) || {};
      var formattedAddress = formatAddress$3(deceasedWorkerInfo === null || deceasedWorkerInfo === void 0 ? void 0 : deceasedWorkerInfo.presentLocation, deceasedWorkerInfo === null || deceasedWorkerInfo === void 0 ? void 0 : deceasedWorkerInfo.presentAddress);
      var fullAddress = "\u0997\u09CD\u09B0\u09BE\u09AE-".concat(formattedAddress.village || "", "\n\u09A1\u09BE\u0995-").concat(formattedAddress.postOffice || "", "\n\u0989\u09AA\u099C\u09C7\u09B2\u09BE-").concat(formattedAddress.thana || "", "\n\u099C\u09C7\u09B2\u09BE-").concat(formattedAddress.district || "");
      var baseRow = {
        mainListNo: (app === null || app === void 0 ? void 0 : app.trackingNumber) || (app === null || app === void 0 ? void 0 : app.id) || "",
        workerName: (deceasedWorkerInfo === null || deceasedWorkerInfo === void 0 ? void 0 : deceasedWorkerInfo.nameBn) || (deceasedWorkerInfo === null || deceasedWorkerInfo === void 0 ? void 0 : deceasedWorkerInfo.nameEn) || "",
        fatherName: (deceasedWorkerInfo === null || deceasedWorkerInfo === void 0 ? void 0 : deceasedWorkerInfo.fatherNameBn) || (deceasedWorkerInfo === null || deceasedWorkerInfo === void 0 ? void 0 : deceasedWorkerInfo.fatherNameEn) || "",
        factoryName: (app === null || app === void 0 || (_app$employeeFactory = app.employeeFactory) === null || _app$employeeFactory === void 0 ? void 0 : _app$employeeFactory.nameBn) || (app === null || app === void 0 || (_app$employeeFactory2 = app.employeeFactory) === null || _app$employeeFactory2 === void 0 ? void 0 : _app$employeeFactory2.nameEn) || "",
        workerNid: (deceasedWorkerInfo === null || deceasedWorkerInfo === void 0 ? void 0 : deceasedWorkerInfo.nid) || "",
        workerMobile: (deceasedWorkerInfo === null || deceasedWorkerInfo === void 0 ? void 0 : deceasedWorkerInfo.phoneNumber) || "",
        address: fullAddress,
        district: formattedAddress.district || "",
        incidentDate: date || (metadata === null || metadata === void 0 ? void 0 : metadata.deathDate) || "",
        incidentType: type || (metadata === null || metadata === void 0 ? void 0 : metadata.deathType) || "",
        profession: (app === null || app === void 0 || (_app$employeeFactory3 = app.employeeFactory) === null || _app$employeeFactory3 === void 0 ? void 0 : _app$employeeFactory3.nameBn) || "গৃহ শ্রমিক",
        remarks: "শ্রম অধিদপ্তর",
        unitNo: (app === null || app === void 0 || (_app$workforceEmploye = app.workforceEmployee) === null || _app$workforceEmploye === void 0 ? void 0 : _app$workforceEmploye.phoneNumber) || ""
      };
      if (isDeathApp) {
        var dependents = safeParse(app === null || app === void 0 ? void 0 : app.employeeDependentInfo) || [];
        var bankInfos = safeParse(app === null || app === void 0 ? void 0 : app.employeeBankInfo) || [];
        (dependents.length > 0 ? dependents : [{}]).forEach(function (dep) {
          var _bankDetails$bank, _bankDetails$bank2, _bankDetails$branch, _bankDetails$district;
          var bankDetails = bankInfos.find(function (b) {
            return (b === null || b === void 0 ? void 0 : b.dependentNid) === (dep === null || dep === void 0 ? void 0 : dep.nid);
          }) || {};
          var grantPercent = parseFloat((dep === null || dep === void 0 ? void 0 : dep.percentage_of_grant) || (dep === null || dep === void 0 ? void 0 : dep.percentageOfCfGrant)) || 0;
          console.log({
            grantPercent: grantPercent
          });
          var approvedAmount = grantPercent > 0 ? grantPercent / 100 * (getTotalAmount() || 200000) : (app === null || app === void 0 ? void 0 : app.grantAmount) || "";
          console.log({
            approvedAmount: approvedAmount
          });
          rows.push(_objectSpread$K(_objectSpread$K({}, baseRow), {}, {
            sl: slIndex++,
            nomineeName: (dep === null || dep === void 0 ? void 0 : dep.nameBn) || (dep === null || dep === void 0 ? void 0 : dep.nameEn) || (bankDetails === null || bankDetails === void 0 ? void 0 : bankDetails.accountHolderName) || "",
            nomineeNid: (dep === null || dep === void 0 ? void 0 : dep.nid) || (bankDetails === null || bankDetails === void 0 ? void 0 : bankDetails.dependentNid) || "",
            nomineeMobile: (dep === null || dep === void 0 ? void 0 : dep.phoneNumber) || "",
            relation: RELATION_LABEL_MAP[(dep === null || dep === void 0 ? void 0 : dep.relationType) || (dep === null || dep === void 0 ? void 0 : dep.relationWithWorker)] || (dep === null || dep === void 0 ? void 0 : dep.relationType) || "",
            details: "\u0986\u09AC\u09C7\u09A6\u09A8\u0995\u09BE\u09B0\u09C0 \u098F\u0995\u099C\u09A8 \u09B6\u09CD\u09B0\u09AE\u09BF\u0995 \u099B\u09BF\u09B2\u09C7\u09A8\u0964 \u09A4\u09BF\u09A8\u09BF ".concat(date || (metadata === null || metadata === void 0 ? void 0 : metadata.deathDate) || "", " \u09A4\u09BE\u09B0\u09BF\u0996\u09C7 \u09AE\u09C3\u09A4\u09CD\u09AF\u09C1\u09AC\u09B0\u09A3 \u0995\u09B0\u09C7\u09A8\u0964"),
            bankName: (bankDetails === null || bankDetails === void 0 || (_bankDetails$bank = bankDetails.bank) === null || _bankDetails$bank === void 0 ? void 0 : _bankDetails$bank.nameEn) || (bankDetails === null || bankDetails === void 0 || (_bankDetails$bank2 = bankDetails.bank) === null || _bankDetails$bank2 === void 0 ? void 0 : _bankDetails$bank2.nameBn) || "",
            bankAc: (bankDetails === null || bankDetails === void 0 ? void 0 : bankDetails.accountNumber) || "",
            amount: approvedAmount,
            routingNo: (bankDetails === null || bankDetails === void 0 || (_bankDetails$branch = bankDetails.branch) === null || _bankDetails$branch === void 0 ? void 0 : _bankDetails$branch.routingNumber) || (bankDetails === null || bankDetails === void 0 || (_bankDetails$district = bankDetails.district) === null || _bankDetails$district === void 0 ? void 0 : _bankDetails$district.routingNumber) || "",
            mobile: (dep === null || dep === void 0 ? void 0 : dep.phoneNumber) || (deceasedWorkerInfo === null || deceasedWorkerInfo === void 0 ? void 0 : deceasedWorkerInfo.phoneNumber) || ""
          }));
        });
      } else {
        var _bankInfos = safeParse(app === null || app === void 0 ? void 0 : app.employeeBankInfo) || [];
        (_bankInfos.length > 0 ? _bankInfos : [{}]).forEach(function (bankInfo) {
          var _app$workforceEmploye2, _bankInfo$bank, _bankInfo$branch, _bankInfo$district, _app$workforceEmploye3;
          rows.push(_objectSpread$K(_objectSpread$K({}, baseRow), {}, {
            sl: slIndex++,
            nomineeName: (bankInfo === null || bankInfo === void 0 ? void 0 : bankInfo.accountHolderName) || (deceasedWorkerInfo === null || deceasedWorkerInfo === void 0 ? void 0 : deceasedWorkerInfo.nameBn) || (deceasedWorkerInfo === null || deceasedWorkerInfo === void 0 ? void 0 : deceasedWorkerInfo.nameEn) || "",
            nomineeNid: (bankInfo === null || bankInfo === void 0 ? void 0 : bankInfo.dependentNid) || "",
            nomineeMobile: (app === null || app === void 0 || (_app$workforceEmploye2 = app.workforceEmployee) === null || _app$workforceEmploye2 === void 0 ? void 0 : _app$workforceEmploye2.phoneNumber) || (deceasedWorkerInfo === null || deceasedWorkerInfo === void 0 ? void 0 : deceasedWorkerInfo.phoneNumber) || "",
            relation: "নিজ",
            details: "\u0986\u09AC\u09C7\u09A6\u09A8\u0995\u09BE\u09B0\u09C0 \u09A8\u09BF\u099C\u09C7 \u098F\u0995\u099C\u09A8 \u09B6\u09CD\u09B0\u09AE\u09BF\u0995\u0964 \u09A4\u09BF\u09A8\u09BF \u09A6\u09C1\u09B0\u09CD\u0998\u099F\u09A8\u09BE\u09B0 \u09B6\u09BF\u0995\u09BE\u09B0 \u09B9\u09AF\u09BC\u09C7\u099B\u09C7\u09A8\u0964",
            bankName: (bankInfo === null || bankInfo === void 0 || (_bankInfo$bank = bankInfo.bank) === null || _bankInfo$bank === void 0 ? void 0 : _bankInfo$bank.nameEn) || "",
            bankAc: (bankInfo === null || bankInfo === void 0 ? void 0 : bankInfo.accountNumber) || "",
            amount: (app === null || app === void 0 ? void 0 : app.grantAmount) || "",
            routingNo: (bankInfo === null || bankInfo === void 0 || (_bankInfo$branch = bankInfo.branch) === null || _bankInfo$branch === void 0 ? void 0 : _bankInfo$branch.routingNumber) || (bankInfo === null || bankInfo === void 0 || (_bankInfo$district = bankInfo.district) === null || _bankInfo$district === void 0 ? void 0 : _bankInfo$district.routingNumber) || "",
            mobile: (app === null || app === void 0 || (_app$workforceEmploye3 = app.workforceEmployee) === null || _app$workforceEmploye3 === void 0 ? void 0 : _app$workforceEmploye3.phoneNumber) || (deceasedWorkerInfo === null || deceasedWorkerInfo === void 0 ? void 0 : deceasedWorkerInfo.phoneNumber) || ""
          }));
        });
      }
    });
    return rows;
  };
  var rows = getRows();
  console.log({
    deathDisability: applications
  });
  console.log({
    rows: rows
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("table", {
    className: classes.summaryTable
  }, /*#__PURE__*/React.createElement("tbody", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    style: {
      width: "50%"
    }
  }, /*#__PURE__*/React.createElement("strong", null, "Board Meeting:"), " 26th", /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("strong", null, "Fiscal Year:"), " 2025-2026", /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("strong", null, "Number of Application:"), " ", stats.Total, /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("strong", null, "Number of Nominees/Accounts:"), " ", rows.length, /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("strong", null, "Total Amount:"), " ", Number(getTotalAmount()).toLocaleString("en-IN"), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("strong", null, "In Words:")), /*#__PURE__*/React.createElement("td", {
    style: {
      width: "50%",
      padding: 0
    }
  }, /*#__PURE__*/React.createElement("table", {
    style: {
      width: "100%",
      height: "100%",
      borderCollapse: "collapse"
    }
  }, /*#__PURE__*/React.createElement("tbody", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    style: {
      border: "none",
      borderBottom: "1px solid #000"
    }
  }, "Natural Death (ND)"), /*#__PURE__*/React.createElement("td", {
    style: {
      border: "none",
      borderBottom: "1px solid #000",
      borderLeft: "1px solid #000"
    }
  }, stats.ND)), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    style: {
      border: "none",
      borderBottom: "1px solid #000"
    }
  }, "Outside Accidental Death (OAD)"), /*#__PURE__*/React.createElement("td", {
    style: {
      border: "none",
      borderBottom: "1px solid #000",
      borderLeft: "1px solid #000"
    }
  }, stats.OAD)), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    style: {
      border: "none",
      borderBottom: "1px solid #000"
    }
  }, "Workplace Accidental Death (WAD)"), /*#__PURE__*/React.createElement("td", {
    style: {
      border: "none",
      borderBottom: "1px solid #000",
      borderLeft: "1px solid #000"
    }
  }, stats.WAD)), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    style: {
      border: "none",
      borderBottom: "1px solid #000"
    }
  }, "Workplace Occupational Death (WOD)"), /*#__PURE__*/React.createElement("td", {
    style: {
      border: "none",
      borderBottom: "1px solid #000",
      borderLeft: "1px solid #000"
    }
  }, stats.WOD)), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    style: {
      border: "none",
      borderBottom: "1px solid #000"
    }
  }, "Workplace Partial Disability (WPD)"), /*#__PURE__*/React.createElement("td", {
    style: {
      border: "none",
      borderBottom: "1px solid #000",
      borderLeft: "1px solid #000"
    }
  }, stats.WPD)), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    style: {
      border: "none",
      borderBottom: "1px solid #000"
    }
  }, "Workplace Total Disability (WTD)"), /*#__PURE__*/React.createElement("td", {
    style: {
      border: "none",
      borderBottom: "1px solid #000",
      borderLeft: "1px solid #000"
    }
  }, stats.WTD)), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    style: {
      border: "none",
      borderBottom: "1px solid #000"
    }
  }, "Outside Total Disability (OTD)"), /*#__PURE__*/React.createElement("td", {
    style: {
      border: "none",
      borderBottom: "1px solid #000",
      borderLeft: "1px solid #000"
    }
  }, stats.OTD)), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    style: {
      border: "none",
      fontWeight: "bold"
    }
  }, "Total"), /*#__PURE__*/React.createElement("td", {
    style: {
      border: "none",
      borderLeft: "1px solid #000",
      fontWeight: "bold"
    }
  }, stats.Total)))))))), isBlwfPath() ? /*#__PURE__*/React.createElement("table", {
    className: classes.excelTable
  }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, "\u0995\u09CD\u09B0\u09AE\u09BF\u0995 \u09A8\u0982"), /*#__PURE__*/React.createElement("th", null, "\u0986\u09AC\u09C7\u09A6\u09A8\u0995\u09BE\u09B0\u09C0 \u09B6\u09CD\u09B0\u09AE\u09BF\u0995\u09C7\u09B0 \u09A8\u09BE\u09AE/\u09AA\u09BF\u09A4\u09BE/\u098F\u09A8\u0986\u0987\u09A1\u09BF/\u09AE\u09CB\u09AC\u09BE-"), /*#__PURE__*/React.createElement("th", null, "\u09A0\u09BF\u0995\u09BE\u09A8\u09BE"), /*#__PURE__*/React.createElement("th", null, "\u09AF\u09BE\u09B0 \u099C\u09A8\u09CD\u09AF \u0986\u09AC\u09C7\u09A6\u09A8 /\u09AF\u09C7 \u0986\u09AC\u09C7\u09A6\u09A8 \u0995\u09B0\u09C7\u099B\u09C7\u09A8 \u09A8\u09BE\u09AE/\u098F\u09A8\u0986\u0987\u09A1\u09BF/\u09AE\u09CB\u09AC\u09BE-"), /*#__PURE__*/React.createElement("th", null, "\u09AC\u09BF\u09AC\u09B0\u09A3"), /*#__PURE__*/React.createElement("th", null, "\u0985\u09A8\u09C1\u09A6\u09BE\u09A8 \u09AA\u09B0\u09BF\u09AE\u09BE\u09A8"), /*#__PURE__*/React.createElement("th", null, "\u09AA\u09C7\u09B6\u09BE/\u09AA\u09CD\u09B0\u09A4\u09BF\u09B7\u09CD\u09A0\u09BE\u09A8"), /*#__PURE__*/React.createElement("th", null, "\u099C\u09C7\u09B2\u09BE"), /*#__PURE__*/React.createElement("th", null, "\u09AE\u09A8\u09CD\u09A4\u09AC\u09CD\u09AF"))), /*#__PURE__*/React.createElement("tbody", null, rows.map(function (row, i) {
    return /*#__PURE__*/React.createElement("tr", {
      key: i
    }, /*#__PURE__*/React.createElement("td", {
      style: {
        textAlign: "center"
      }
    }, i + 1), /*#__PURE__*/React.createElement("td", null, row.workerName, /*#__PURE__*/React.createElement("br", null), "\u09AA\u09BF\u09A4\u09BE-", row.fatherName, /*#__PURE__*/React.createElement("br", null), "\u098F\u09A8\u0986\u0987\u09A1\u09BF-", row.workerNid, /*#__PURE__*/React.createElement("br", null), "\u09AE\u09CB\u09AC\u09BE-", row.workerMobile), /*#__PURE__*/React.createElement("td", {
      style: {
        whiteSpace: "pre-line"
      }
    }, row.address), /*#__PURE__*/React.createElement("td", null, row.nomineeName, " (", row.relation, ")", /*#__PURE__*/React.createElement("br", null), "\u098F\u09A8\u0986\u0987\u09A1\u09BF-", row.nomineeNid, /*#__PURE__*/React.createElement("br", null), "\u09AE\u09CB\u09AC\u09BE-", row.nomineeMobile), /*#__PURE__*/React.createElement("td", null, row.details), /*#__PURE__*/React.createElement("td", {
      style: {
        textAlign: "right"
      }
    }, Number(row.amount).toLocaleString("en-IN")), /*#__PURE__*/React.createElement("td", {
      style: {
        textAlign: "center"
      }
    }, row.profession), /*#__PURE__*/React.createElement("td", {
      style: {
        textAlign: "center"
      }
    }, row.district), /*#__PURE__*/React.createElement("td", null, row.remarks));
  }))) : /*#__PURE__*/React.createElement("table", {
    className: classes.excelTable
  }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, "Sl"), /*#__PURE__*/React.createElement("th", null, "Main List No"), /*#__PURE__*/React.createElement("th", null, "Deceased Worker's Name"), /*#__PURE__*/React.createElement("th", null, "Factory Name"), /*#__PURE__*/React.createElement("th", null, "Deceased Worker's NID/BC"), /*#__PURE__*/React.createElement("th", null, "Date of Incident"), /*#__PURE__*/React.createElement("th", null, "Type of Incident"), /*#__PURE__*/React.createElement("th", null, "Nominee's Name"), /*#__PURE__*/React.createElement("th", null, "Nominee's NID/BC"), /*#__PURE__*/React.createElement("th", null, "Relation"), /*#__PURE__*/React.createElement("th", null, "Nominee's Bank name"), /*#__PURE__*/React.createElement("th", null, "Nominee's Bank A/C"), /*#__PURE__*/React.createElement("th", null, "Amount"), /*#__PURE__*/React.createElement("th", null, "Routing No"), /*#__PURE__*/React.createElement("th", null, "Nominee's Mobile No."), /*#__PURE__*/React.createElement("th", null, "Unit/No"))), /*#__PURE__*/React.createElement("tbody", null, rows.map(function (row, i) {
    return /*#__PURE__*/React.createElement("tr", {
      key: i
    }, /*#__PURE__*/React.createElement("td", {
      style: {
        textAlign: "center"
      }
    }, row.sl), /*#__PURE__*/React.createElement("td", {
      style: {
        textAlign: "center"
      }
    }, row.mainListNo), /*#__PURE__*/React.createElement("td", null, row.workerName), /*#__PURE__*/React.createElement("td", null, row.factoryName), /*#__PURE__*/React.createElement("td", null, row.workerNid), /*#__PURE__*/React.createElement("td", null, row.incidentDate), /*#__PURE__*/React.createElement("td", {
      style: {
        textAlign: "center"
      }
    }, row.incidentType), /*#__PURE__*/React.createElement("td", null, row.nomineeName), /*#__PURE__*/React.createElement("td", null, row.nomineeNid), /*#__PURE__*/React.createElement("td", null, row.relation), /*#__PURE__*/React.createElement("td", null, row.bankName), /*#__PURE__*/React.createElement("td", null, row.bankAc), /*#__PURE__*/React.createElement("td", {
      style: {
        textAlign: "right"
      }
    }, Number(row.amount).toLocaleString("en-IN")), /*#__PURE__*/React.createElement("td", null, row.routingNo), /*#__PURE__*/React.createElement("td", null, row.phoneNumber), /*#__PURE__*/React.createElement("td", null, row.unitNo));
  }))));
};

var EducationScholarshipView = function EducationScholarshipView(_ref) {
  var classes = _ref.classes,
    applications = _ref.applications,
    dependentData = _ref.dependentData,
    getTotalAmount = _ref.getTotalAmount;
  var stats = {
    self: 0,
    son: 0,
    daughter: 0,
    Total: applications.length
  };
  applications.forEach(function (app) {
    var dep = dependentData === null || dependentData === void 0 ? void 0 : dependentData.find(function (d) {
      return decodeId(d.workforceApplicationId) === decodeId(app.id);
    });
    var rel = (dep ? dep.relationWithWorker : "self").toLowerCase();
    if (rel.includes("son")) stats.son += 1;else if (rel.includes("daughter")) stats.daughter += 1;else stats.self += 1;
  });
  var getRows = function getRows() {
    var rows = [];
    applications.forEach(function (app, appIndex) {
      var _app$workforceEmploye, _app$workforceEmploye2, _app$workforceEmploye3;
      var bankInfos = [];
      try {
        var parsed = JSON.parse(app.employeeBankInfo);
        bankInfos = Array.isArray(parsed) ? parsed : JSON.parse(parsed);
      } catch (e) {}
      var dep = dependentData === null || dependentData === void 0 ? void 0 : dependentData.find(function (d) {
        return decodeId(d.workforceApplicationId) === decodeId(app.id);
      });
      var relation = dep ? RELATION_LABEL_MAP[dep.relationWithWorker] || dep.relationWithWorker : "Self";
      var gpa = "";
      try {
        var eduInfo = JSON.parse(app.educationInfo || "{}");
        gpa = eduInfo.gpa || (dep === null || dep === void 0 ? void 0 : dep.gpa) || "";
      } catch (e) {}
      safeParse(app === null || app === void 0 || (_app$workforceEmploye = app.workforceEmployee) === null || _app$workforceEmploye === void 0 ? void 0 : _app$workforceEmploye.presentAddress) || {};
      var formattedAddress = formatAddress$3(app === null || app === void 0 || (_app$workforceEmploye2 = app.workforceEmployee) === null || _app$workforceEmploye2 === void 0 ? void 0 : _app$workforceEmploye2.presentLocation, // Make sure this matches your actual location key
      app === null || app === void 0 || (_app$workforceEmploye3 = app.workforceEmployee) === null || _app$workforceEmploye3 === void 0 ? void 0 : _app$workforceEmploye3.presentAddress);
      bankInfos.forEach(function (bankInfo, bankIndex) {
        var _app$workforceEmploye4, _app$workforceEmploye5, _app$workforceEmploye6, _app$workforceEmploye7, _app$employeeFactory, _app$employeeFactory2, _app$workforceEmploye8, _app$workforceEmploye9, _app$workforceEmploye10, _app$workforceEmploye11, _app$workforceEmploye12, _app$workforceEmploye13, _app$workforceEmploye14, _app$employeeFactory3, _bankInfo$branch;
        rows.push({
          sl: app.trackingNumber || "".concat(appIndex + 1 + bankIndex),
          workerName: ((_app$workforceEmploye4 = app.workforceEmployee) === null || _app$workforceEmploye4 === void 0 ? void 0 : _app$workforceEmploye4.firstNameBn) || ((_app$workforceEmploye5 = app.workforceEmployee) === null || _app$workforceEmploye5 === void 0 ? void 0 : _app$workforceEmploye5.firstNameEn) || "",
          fatherName: ((_app$workforceEmploye6 = app.workforceEmployee) === null || _app$workforceEmploye6 === void 0 ? void 0 : _app$workforceEmploye6.fatherNameBn) || ((_app$workforceEmploye7 = app.workforceEmployee) === null || _app$workforceEmploye7 === void 0 ? void 0 : _app$workforceEmploye7.fatherNameEn) || "",
          factoryName: ((_app$employeeFactory = app.employeeFactory) === null || _app$employeeFactory === void 0 ? void 0 : _app$employeeFactory.nameBn) || ((_app$employeeFactory2 = app.employeeFactory) === null || _app$employeeFactory2 === void 0 ? void 0 : _app$employeeFactory2.nameEn) || "",
          workerNid: ((_app$workforceEmploye8 = app.workforceEmployee) === null || _app$workforceEmploye8 === void 0 ? void 0 : _app$workforceEmploye8.nid) || "",
          workerMobile: ((_app$workforceEmploye9 = app.workforceEmployee) === null || _app$workforceEmploye9 === void 0 ? void 0 : _app$workforceEmploye9.mobile) || ((_app$workforceEmploye10 = app.workforceEmployee) === null || _app$workforceEmploye10 === void 0 ? void 0 : _app$workforceEmploye10.phoneNumber) || "",
          address: "\u0997\u09CD\u09B0\u09BE\u09AE-".concat(formattedAddress.village || "", "\n\u09A1\u09BE\u0995-").concat(formattedAddress.postOffice || "", "\n\u0989\u09AA\u099C\u09C7\u09B2\u09BE-").concat(formattedAddress.thana || "", "\n\u099C\u09C7\u09B2\u09BE-").concat(formattedAddress.district || ""),
          district: formattedAddress.district || "",
          nomineeName: (dep === null || dep === void 0 ? void 0 : dep.nameBn) || (dep === null || dep === void 0 ? void 0 : dep.nameEn) || (bankInfo === null || bankInfo === void 0 ? void 0 : bankInfo.accountHolderName) || ((_app$workforceEmploye11 = app.workforceEmployee) === null || _app$workforceEmploye11 === void 0 ? void 0 : _app$workforceEmploye11.firstNameEn) || "",
          nomineeNid: (dep === null || dep === void 0 ? void 0 : dep.nid) || ((_app$workforceEmploye12 = app.workforceEmployee) === null || _app$workforceEmploye12 === void 0 ? void 0 : _app$workforceEmploye12.nid) || "",
          nomineeMobile: (dep === null || dep === void 0 ? void 0 : dep.mobile) || ((_app$workforceEmploye13 = app.workforceEmployee) === null || _app$workforceEmploye13 === void 0 ? void 0 : _app$workforceEmploye13.mobile) || ((_app$workforceEmploye14 = app.workforceEmployee) === null || _app$workforceEmploye14 === void 0 ? void 0 : _app$workforceEmploye14.phoneNumber) || "",
          relation: relation,
          details: "\u0986\u09AC\u09C7\u09A6\u09A8\u0995\u09BE\u09B0\u09C0\u09B0 \u09B8\u09A8\u09CD\u09A4\u09BE\u09A8 ".concat(gpa, " \u09AA\u09C7\u09AF\u09BC\u09C7 \u0989\u09A4\u09CD\u09A4\u09C0\u09B0\u09CD\u09A3 \u09B9\u09AF\u09BC\u09C7\u099B\u09C7\u09A8\u0964"),
          profession: ((_app$employeeFactory3 = app.employeeFactory) === null || _app$employeeFactory3 === void 0 ? void 0 : _app$employeeFactory3.nameBn) || "গৃহ শ্রমিক",
          remarks: "শ্রম অধিদপ্তর",
          gpa: gpa,
          routing: (bankInfo === null || bankInfo === void 0 || (_bankInfo$branch = bankInfo.branch) === null || _bankInfo$branch === void 0 ? void 0 : _bankInfo$branch.routingNumber) || "",
          accountNo: (bankInfo === null || bankInfo === void 0 ? void 0 : bankInfo.accountNumber) || "",
          amount: app.grantAmount || ""
        });
      });
    });
    return rows;
  };
  var rows = getRows();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("table", {
    className: classes.summaryTable
  }, /*#__PURE__*/React.createElement("tbody", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    style: {
      width: "50%"
    }
  }, /*#__PURE__*/React.createElement("strong", null, "Board Meeting:"), " 26th", /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("strong", null, "Fiscal Year:"), " 2025-2026", /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("strong", null, "Number of Application:"), " ", stats.Total, /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("strong", null, "Number of Nominees/Accounts:"), " ", rows.length, /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("strong", null, "Total Amount:"), " ", Number(getTotalAmount()).toLocaleString("en-IN"), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("strong", null, "In Words:")), /*#__PURE__*/React.createElement("td", {
    style: {
      width: "50%",
      padding: 0
    }
  }, /*#__PURE__*/React.createElement("table", {
    style: {
      width: "100%",
      height: "100%",
      borderCollapse: "collapse"
    }
  }, /*#__PURE__*/React.createElement("tbody", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    style: {
      border: "none",
      borderBottom: "1px solid #000"
    }
  }, "Application Type"), /*#__PURE__*/React.createElement("td", {
    style: {
      border: "none",
      borderBottom: "1px solid #000",
      borderLeft: "1px solid #000"
    }
  }, "Total")), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    style: {
      border: "none",
      borderBottom: "1px solid #000"
    }
  }, "Labour Self-Education/Skill"), /*#__PURE__*/React.createElement("td", {
    style: {
      border: "none",
      borderBottom: "1px solid #000",
      borderLeft: "1px solid #000"
    }
  }, stats.self)), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    style: {
      border: "none",
      borderBottom: "1px solid #000"
    }
  }, "Son (Education Support)"), /*#__PURE__*/React.createElement("td", {
    style: {
      border: "none",
      borderBottom: "1px solid #000",
      borderLeft: "1px solid #000"
    }
  }, stats.son)), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    style: {
      border: "none",
      borderBottom: "1px solid #000"
    }
  }, "Daughter (Education Support)"), /*#__PURE__*/React.createElement("td", {
    style: {
      border: "none",
      borderBottom: "1px solid #000",
      borderLeft: "1px solid #000"
    }
  }, stats.daughter)), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    style: {
      border: "none",
      fontWeight: "bold"
    }
  }, "Total"), /*#__PURE__*/React.createElement("td", {
    style: {
      border: "none",
      borderLeft: "1px solid #000",
      fontWeight: "bold"
    }
  }, stats.Total)))))))), isBlwfPath() ? /*#__PURE__*/React.createElement("table", {
    className: classes.excelTable
  }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, "\u0995\u09CD\u09B0\u09AE\u09BF\u0995 \u09A8\u0982"), /*#__PURE__*/React.createElement("th", null, "\u0986\u09AC\u09C7\u09A6\u09A8\u0995\u09BE\u09B0\u09C0 \u09B6\u09CD\u09B0\u09AE\u09BF\u0995\u09C7\u09B0 \u09A8\u09BE\u09AE/\u09AA\u09BF\u09A4\u09BE/\u098F\u09A8\u0986\u0987\u09A1\u09BF/\u09AE\u09CB\u09AC\u09BE-"), /*#__PURE__*/React.createElement("th", null, "\u09A0\u09BF\u0995\u09BE\u09A8\u09BE"), /*#__PURE__*/React.createElement("th", null, "\u09AF\u09BE\u09B0 \u099C\u09A8\u09CD\u09AF \u0986\u09AC\u09C7\u09A6\u09A8 /\u09AF\u09C7 \u0986\u09AC\u09C7\u09A6\u09A8 \u0995\u09B0\u09C7\u099B\u09C7\u09A8 \u09A8\u09BE\u09AE/\u098F\u09A8\u0986\u0987\u09A1\u09BF/\u09AE\u09CB\u09AC\u09BE-"), /*#__PURE__*/React.createElement("th", null, "\u09AC\u09BF\u09AC\u09B0\u09A3"), /*#__PURE__*/React.createElement("th", null, "\u0985\u09A8\u09C1\u09A6\u09BE\u09A8 \u09AA\u09B0\u09BF\u09AE\u09BE\u09A8"), /*#__PURE__*/React.createElement("th", null, "\u09AA\u09C7\u09B6\u09BE/\u09AA\u09CD\u09B0\u09A4\u09BF\u09B7\u09CD\u09A0\u09BE\u09A8"), /*#__PURE__*/React.createElement("th", null, "\u099C\u09C7\u09B2\u09BE"), /*#__PURE__*/React.createElement("th", null, "\u09AE\u09A8\u09CD\u09A4\u09AC\u09CD\u09AF"))), /*#__PURE__*/React.createElement("tbody", null, rows.map(function (row, i) {
    return /*#__PURE__*/React.createElement("tr", {
      key: i
    }, /*#__PURE__*/React.createElement("td", {
      style: {
        textAlign: "center"
      }
    }, i + 1), /*#__PURE__*/React.createElement("td", null, row.workerName, /*#__PURE__*/React.createElement("br", null), "\u09AA\u09BF\u09A4\u09BE-", row.fatherName, /*#__PURE__*/React.createElement("br", null), "\u098F\u09A8\u0986\u0987\u09A1\u09BF-", row.workerNid, /*#__PURE__*/React.createElement("br", null), "\u09AE\u09CB\u09AC\u09BE-", row.workerMobile), /*#__PURE__*/React.createElement("td", {
      style: {
        whiteSpace: "pre-line"
      }
    }, row.address), /*#__PURE__*/React.createElement("td", null, row.nomineeName, " (", row.relation, ")", /*#__PURE__*/React.createElement("br", null), "\u098F\u09A8\u0986\u0987\u09A1\u09BF-", row.nomineeNid, /*#__PURE__*/React.createElement("br", null), "\u09AE\u09CB\u09AC\u09BE-", row.nomineeMobile), /*#__PURE__*/React.createElement("td", null, row.details), /*#__PURE__*/React.createElement("td", {
      style: {
        textAlign: "right"
      }
    }, Number(row.amount).toLocaleString("en-IN")), /*#__PURE__*/React.createElement("td", {
      style: {
        textAlign: "center"
      }
    }, row.profession), /*#__PURE__*/React.createElement("td", {
      style: {
        textAlign: "center"
      }
    }, row.district), /*#__PURE__*/React.createElement("td", null, row.remarks));
  }))) : /*#__PURE__*/React.createElement("table", {
    className: classes.excelTable
  }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, "Sl.no"), /*#__PURE__*/React.createElement("th", null, "Applicant Name"), /*#__PURE__*/React.createElement("th", null, "NID Card/Birth Certificate Number"), /*#__PURE__*/React.createElement("th", null, "Applicant Mobile"), /*#__PURE__*/React.createElement("th", null, "Unit Name"), /*#__PURE__*/React.createElement("th", null, "Candidate Name"), /*#__PURE__*/React.createElement("th", null, "Relation"), /*#__PURE__*/React.createElement("th", null, "GPA"), /*#__PURE__*/React.createElement("th", null, "Routing"), /*#__PURE__*/React.createElement("th", null, "Account NO"), /*#__PURE__*/React.createElement("th", null, "Amount"))), /*#__PURE__*/React.createElement("tbody", null, rows.map(function (row, i) {
    return /*#__PURE__*/React.createElement("tr", {
      key: i
    }, /*#__PURE__*/React.createElement("td", {
      style: {
        textAlign: "center"
      }
    }, row.sl), /*#__PURE__*/React.createElement("td", null, row.workerName), /*#__PURE__*/React.createElement("td", null, row.workerNid), /*#__PURE__*/React.createElement("td", null, row.workerMobile), /*#__PURE__*/React.createElement("td", null, row.factoryName), /*#__PURE__*/React.createElement("td", null, row.nomineeName), /*#__PURE__*/React.createElement("td", null, row.relation), /*#__PURE__*/React.createElement("td", {
      style: {
        textAlign: "center"
      }
    }, row.gpa), /*#__PURE__*/React.createElement("td", {
      style: {
        textAlign: "center"
      }
    }, row.routing), /*#__PURE__*/React.createElement("td", {
      style: {
        textAlign: "center"
      }
    }, row.accountNo), /*#__PURE__*/React.createElement("td", {
      style: {
        textAlign: "right"
      }
    }, Number(row.amount).toLocaleString("en-IN")));
  }))));
};

var BLWFView = function BLWFView(_ref) {
  var classes = _ref.classes,
    applications = _ref.applications,
    getTotalAmount = _ref.getTotalAmount;
  var stats = {
    MedicalDonation: 0,
    maternityGrant: 0,
    educationGrant: 0,
    deadlyGrant: 0,
    Total: applications.length
  };
  applications.forEach(function (app) {
    var t = (app === null || app === void 0 ? void 0 : app.applicationType) || "";
    if (t === "medicalDonation") stats.MedicalDonation += 1;else if (t === "maternityGrant") stats.maternityGrant += 1;else if (t === "educationGrant") stats.educationGrant += 1;else if (t === "deadlyGrant") stats.deadlyGrant += 1;
  });
  var getRows = function getRows() {
    var rows = [];
    applications.forEach(function (app, appIndex) {
      var _app$workforceEmploye, _safeParse, _safeParse2, _app$workforceEmploye2, _app$workforceEmploye3, _safeParse3, _safeParse4, _app$workforceEmploye4, _app$workforceEmploye5, _safeParse5, _app$workforceEmploye6, _safeParse6, _safeParse7, _app$employeeFactory, _app$employeeFactory2, _deceasedWorkerInfo, _deceasedWorkerInfo2, _app$workforceEmploye7, _app$workforceEmploye8;
      var bankInfos = [];
      try {
        var parsed = JSON.parse(app.employeeBankInfo || "[]");
        bankInfos = Array.isArray(parsed) ? parsed : JSON.parse(parsed);
      } catch (e) {
        bankInfos = [];
      }
      safeParse(app === null || app === void 0 || (_app$workforceEmploye = app.workforceEmployee) === null || _app$workforceEmploye === void 0 ? void 0 : _app$workforceEmploye.presentAddress) || {};
      // const formattedAddress = formatAddress(app?.workforceEmployee?.presentLocation, app?.workforceEmployee?.presentAddress);
      var workerName = app.applicationType === "deadlyGrant" ? ((_safeParse = safeParse(app === null || app === void 0 ? void 0 : app.deceasedWorkerInfo)) === null || _safeParse === void 0 ? void 0 : _safeParse.nameBn) || ((_safeParse2 = safeParse(app === null || app === void 0 ? void 0 : app.deceasedWorkerInfo)) === null || _safeParse2 === void 0 ? void 0 : _safeParse2.nameEn) || "" : ((_app$workforceEmploye2 = app.workforceEmployee) === null || _app$workforceEmploye2 === void 0 ? void 0 : _app$workforceEmploye2.firstNameBn) || ((_app$workforceEmploye3 = app.workforceEmployee) === null || _app$workforceEmploye3 === void 0 ? void 0 : _app$workforceEmploye3.firstNameEn) || "";
      var fatherName = app.applicationType === "deadlyGrant" ? ((_safeParse3 = safeParse(app === null || app === void 0 ? void 0 : app.deceasedWorkerInfo)) === null || _safeParse3 === void 0 ? void 0 : _safeParse3.fatherNameBn) || ((_safeParse4 = safeParse(app === null || app === void 0 ? void 0 : app.deceasedWorkerInfo)) === null || _safeParse4 === void 0 ? void 0 : _safeParse4.fatherNameEn) || "" : ((_app$workforceEmploye4 = app.workforceEmployee) === null || _app$workforceEmploye4 === void 0 ? void 0 : _app$workforceEmploye4.fatherNameBn) || ((_app$workforceEmploye5 = app.workforceEmployee) === null || _app$workforceEmploye5 === void 0 ? void 0 : _app$workforceEmploye5.fatherNameEn) || "";
      var workerNid = app.applicationType === "deadlyGrant" ? ((_safeParse5 = safeParse(app === null || app === void 0 ? void 0 : app.deceasedWorkerInfo)) === null || _safeParse5 === void 0 ? void 0 : _safeParse5.nid) || "" : ((_app$workforceEmploye6 = app.workforceEmployee) === null || _app$workforceEmploye6 === void 0 ? void 0 : _app$workforceEmploye6.nid) || "";
      var factoryName = ((_safeParse6 = safeParse(app === null || app === void 0 ? void 0 : app.institutionInfo)) === null || _safeParse6 === void 0 ? void 0 : _safeParse6.instituteName) || ((_safeParse7 = safeParse(app === null || app === void 0 ? void 0 : app.institutionInfo)) === null || _safeParse7 === void 0 ? void 0 : _safeParse7.aboutWork) || ((_app$employeeFactory = app.employeeFactory) === null || _app$employeeFactory === void 0 ? void 0 : _app$employeeFactory.nameBn) || ((_app$employeeFactory2 = app.employeeFactory) === null || _app$employeeFactory2 === void 0 ? void 0 : _app$employeeFactory2.nameEn) || "";
      var deceasedWorkerInfo = null;
      if ((app === null || app === void 0 ? void 0 : app.applicationType) == "deadlyGrant") {
        deceasedWorkerInfo = safeParse(app === null || app === void 0 ? void 0 : app.deceasedWorkerInfo) || {};
        console.log({
          deceasedWorkerInfo: deceasedWorkerInfo
        });
      }
      var formattedAddress = deceasedWorkerInfo !== null && (app === null || app === void 0 ? void 0 : app.applicationType) == "deadlyGrant" ? formatAddress$3((_deceasedWorkerInfo = deceasedWorkerInfo) === null || _deceasedWorkerInfo === void 0 ? void 0 : _deceasedWorkerInfo.permanentLocation, (_deceasedWorkerInfo2 = deceasedWorkerInfo) === null || _deceasedWorkerInfo2 === void 0 ? void 0 : _deceasedWorkerInfo2.permanentAddress) : formatAddress$3(app === null || app === void 0 || (_app$workforceEmploye7 = app.workforceEmployee) === null || _app$workforceEmploye7 === void 0 ? void 0 : _app$workforceEmploye7.presentLocation, app === null || app === void 0 || (_app$workforceEmploye8 = app.workforceEmployee) === null || _app$workforceEmploye8 === void 0 ? void 0 : _app$workforceEmploye8.presentAddress);
      (bankInfos.length > 0 ? bankInfos : [{}]).forEach(function (bankInfo, bankIndex) {
        var _app$workforceEmploye9, _app$workforceEmploye10, _app$workforceEmploye11, _app$workforceEmploye12, _app$workforceEmploye13, _bankInfo$branch, _bankInfo$district;
        rows.push({
          sl: appIndex + 1 + bankIndex,
          mainListNo: app.dateCreated && app.dateCreated.split && app.dateCreated.split("T")[0] || app.trackingNumber || "",
          workerName: workerName,
          fatherName: fatherName,
          factoryName: factoryName,
          workerNid: workerNid || "",
          workerMobile: ((_app$workforceEmploye9 = app.workforceEmployee) === null || _app$workforceEmploye9 === void 0 ? void 0 : _app$workforceEmploye9.phoneNumber) || ((_app$workforceEmploye10 = app.workforceEmployee) === null || _app$workforceEmploye10 === void 0 ? void 0 : _app$workforceEmploye10.mobile) || "",
          address: "\u0997\u09CD\u09B0\u09BE\u09AE-".concat(formattedAddress.village || "", "\n\u09A1\u09BE\u0995-").concat(formattedAddress.postOffice || "", "\n\u0989\u09AA\u099C\u09C7\u09B2\u09BE-").concat(formattedAddress.thana || "", "\n\u099C\u09C7\u09B2\u09BE-").concat(formattedAddress.district || ""),
          district: formattedAddress.district || "",
          nomineeName: (bankInfo === null || bankInfo === void 0 ? void 0 : bankInfo.accountHolderName) || workerName || "",
          nomineeNid: (bankInfo === null || bankInfo === void 0 ? void 0 : bankInfo.dependentNid) || ((_app$workforceEmploye11 = app.workforceEmployee) === null || _app$workforceEmploye11 === void 0 ? void 0 : _app$workforceEmploye11.nid) || "",
          nomineeMobile: (bankInfo === null || bankInfo === void 0 ? void 0 : bankInfo.phoneNumber) || ((_app$workforceEmploye12 = app.workforceEmployee) === null || _app$workforceEmploye12 === void 0 ? void 0 : _app$workforceEmploye12.phoneNumber) || ((_app$workforceEmploye13 = app.workforceEmployee) === null || _app$workforceEmploye13 === void 0 ? void 0 : _app$workforceEmploye13.mobile) || "",
          relation: "নিজ",
          details: app.notes || app.applicationType || "",
          profession: factoryName || "গৃহ শ্রমিক",
          remarks: "শ্রম অধিদপ্তর",
          routingNo: (bankInfo === null || bankInfo === void 0 || (_bankInfo$branch = bankInfo.branch) === null || _bankInfo$branch === void 0 ? void 0 : _bankInfo$branch.routingNumber) || (bankInfo === null || bankInfo === void 0 || (_bankInfo$district = bankInfo.district) === null || _bankInfo$district === void 0 ? void 0 : _bankInfo$district.routingNumber) || "",
          accountNo: (bankInfo === null || bankInfo === void 0 ? void 0 : bankInfo.accountNumber) || "",
          amount: app.grantAmount || ""
        });
      });
    });
    return rows;
  };
  var rows = getRows();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("table", {
    className: classes.summaryTable
  }, /*#__PURE__*/React.createElement("tbody", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    style: {
      width: "50%"
    }
  }, /*#__PURE__*/React.createElement("strong", null, "Board Meeting:"), " 26th", /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("strong", null, "Fiscal Year:"), " 2025-2026", /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("strong", null, "Number of Application:"), " ", stats.Total, /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("strong", null, "Total Amount:"), " ", Number(getTotalAmount()).toLocaleString("en-IN"), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("strong", null, "In Words:")), /*#__PURE__*/React.createElement("td", {
    style: {
      width: "50%",
      padding: 0
    }
  }, /*#__PURE__*/React.createElement("table", {
    style: {
      width: "100%",
      height: "100%",
      borderCollapse: "collapse"
    }
  }, /*#__PURE__*/React.createElement("tbody", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    style: {
      border: "none",
      borderBottom: "1px solid #000",
      fontWeight: "bold"
    }
  }, "Application Type"), /*#__PURE__*/React.createElement("td", {
    style: {
      border: "none",
      borderBottom: "1px solid #000",
      borderLeft: "1px solid #000",
      fontWeight: "bold"
    }
  }, "Total")), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    style: {
      border: "none",
      borderBottom: "1px solid #000"
    }
  }, "Medical Donation"), /*#__PURE__*/React.createElement("td", {
    style: {
      border: "none",
      borderBottom: "1px solid #000",
      borderLeft: "1px solid #000"
    }
  }, stats.MedicalDonation)), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    style: {
      border: "none",
      borderBottom: "1px solid #000"
    }
  }, "Maternity"), /*#__PURE__*/React.createElement("td", {
    style: {
      border: "none",
      borderBottom: "1px solid #000",
      borderLeft: "1px solid #000"
    }
  }, stats.maternityGrant)), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    style: {
      border: "none",
      borderBottom: "1px solid #000"
    }
  }, "Education Grant"), /*#__PURE__*/React.createElement("td", {
    style: {
      border: "none",
      borderBottom: "1px solid #000",
      borderLeft: "1px solid #000"
    }
  }, stats.educationGrant)), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    style: {
      border: "none",
      borderBottom: "1px solid #000"
    }
  }, "Deadly Grant"), /*#__PURE__*/React.createElement("td", {
    style: {
      border: "none",
      borderBottom: "1px solid #000",
      borderLeft: "1px solid #000"
    }
  }, stats.deadlyGrant)), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    style: {
      border: "none",
      fontWeight: "bold"
    }
  }, "Total"), /*#__PURE__*/React.createElement("td", {
    style: {
      border: "none",
      borderLeft: "1px solid #000",
      fontWeight: "bold"
    }
  }, stats.Total)))))))), /*#__PURE__*/React.createElement("table", {
    className: classes.excelTable
  }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, "\u0995\u09CD\u09B0\u09AE\u09BF\u0995 \u09A8\u0982"), /*#__PURE__*/React.createElement("th", null, "\u0986\u09AC\u09C7\u09A6\u09A8\u0995\u09BE\u09B0\u09C0 \u09B6\u09CD\u09B0\u09AE\u09BF\u0995\u09C7\u09B0 \u09A8\u09BE\u09AE/\u09AA\u09BF\u09A4\u09BE/\u098F\u09A8\u0986\u0987\u09A1\u09BF/\u09AE\u09CB\u09AC\u09BE-"), /*#__PURE__*/React.createElement("th", null, "\u09A0\u09BF\u0995\u09BE\u09A8\u09BE"), /*#__PURE__*/React.createElement("th", null, "\u09AF\u09BE\u09B0 \u099C\u09A8\u09CD\u09AF \u0986\u09AC\u09C7\u09A6\u09A8 /\u09AF\u09C7 \u0986\u09AC\u09C7\u09A6\u09A8 \u0995\u09B0\u09C7\u099B\u09C7\u09A8 \u09A8\u09BE\u09AE/\u098F\u09A8\u0986\u0987\u09A1\u09BF/\u09AE\u09CB\u09AC\u09BE-"), /*#__PURE__*/React.createElement("th", null, "\u09AC\u09BF\u09AC\u09B0\u09A3"), /*#__PURE__*/React.createElement("th", null, "\u0985\u09A8\u09C1\u09A6\u09BE\u09A8 \u09AA\u09B0\u09BF\u09AE\u09BE\u09A8"), /*#__PURE__*/React.createElement("th", null, "\u09AA\u09C7\u09B6\u09BE/\u09AA\u09CD\u09B0\u09A4\u09BF\u09B7\u09CD\u09A0\u09BE\u09A8"), /*#__PURE__*/React.createElement("th", null, "\u099C\u09C7\u09B2\u09BE"), /*#__PURE__*/React.createElement("th", null, "\u09AE\u09A8\u09CD\u09A4\u09AC\u09CD\u09AF"))), /*#__PURE__*/React.createElement("tbody", null, rows.map(function (row, i) {
    return /*#__PURE__*/React.createElement("tr", {
      key: i
    }, /*#__PURE__*/React.createElement("td", {
      style: {
        textAlign: "center"
      }
    }, i + 1), /*#__PURE__*/React.createElement("td", null, row.workerName, /*#__PURE__*/React.createElement("br", null), "\u09AA\u09BF\u09A4\u09BE-", row.fatherName, /*#__PURE__*/React.createElement("br", null), "\u098F\u09A8\u0986\u0987\u09A1\u09BF-", row.workerNid, /*#__PURE__*/React.createElement("br", null), "\u09AE\u09CB\u09AC\u09BE-", row.workerMobile), /*#__PURE__*/React.createElement("td", {
      style: {
        whiteSpace: "pre-line"
      }
    }, row.address), /*#__PURE__*/React.createElement("td", null, row.nomineeName, " (", row.relation, ")", /*#__PURE__*/React.createElement("br", null), "\u098F\u09A8\u0986\u0987\u09A1\u09BF-", row.nomineeNid, /*#__PURE__*/React.createElement("br", null), "\u09AE\u09CB\u09AC\u09BE-", row.nomineeMobile), /*#__PURE__*/React.createElement("td", null, row.details), /*#__PURE__*/React.createElement("td", {
      style: {
        textAlign: "right"
      }
    }, Number(row.amount).toLocaleString("en-IN")), /*#__PURE__*/React.createElement("td", {
      style: {
        textAlign: "center"
      }
    }, row.profession), /*#__PURE__*/React.createElement("td", {
      style: {
        textAlign: "center"
      }
    }, row.district), /*#__PURE__*/React.createElement("td", null, row.remarks));
  }))));
};

var useStyles$R = makeStyles(function (theme) {
  return {
    docTitle: {
      fontWeight: "bold",
      fontSize: "18px",
      textAlign: "left",
      color: "#4a76a8",
      textDecoration: "underline",
      marginBottom: theme.spacing(2)
    },
    headerTitle: {
      fontWeight: "bold",
      fontSize: "18px",
      textAlign: "center",
      color: "#000"
    },
    docSubTitle: {
      fontWeight: "bold",
      fontSize: "16px",
      textAlign: "center",
      marginBottom: "4px",
      color: "#000"
    },
    docText: {
      fontSize: "12px",
      textAlign: "center",
      fontFamily: "Arial, sans-serif",
      color: "#000"
    },
    summaryTable: {
      width: "100%",
      maxWidth: "800px",
      borderCollapse: "collapse",
      marginBottom: theme.spacing(3),
      fontFamily: "Arial, sans-serif",
      "& td": {
        border: "1px solid #000",
        padding: "4px 8px",
        fontSize: "12px",
        color: "#000",
        verticalAlign: "top"
      }
    },
    excelTable: {
      width: "100%",
      borderCollapse: "collapse",
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
      tableLayout: "auto",
      "& th, & td": {
        border: "1px solid #000",
        padding: "4px",
        fontSize: "11px",
        fontFamily: "Arial, sans-serif",
        verticalAlign: "middle",
        color: "#000",
        wordWrap: "break-word"
      },
      "& th": {
        backgroundColor: "#2e528e",
        color: "#fff",
        fontWeight: "bold",
        textAlign: "center",
        "-webkit-print-color-adjust": "exact",
        "print-color-adjust": "exact"
      },
      "@media print": {
        "& th, & td": {
          fontSize: "8.5px",
          padding: "2px"
        }
      }
    },
    signatureContainer: {
      marginTop: "60px",
      width: "100%"
    },
    signatureBlock: {
      marginTop: "40px",
      borderTop: "1px solid #000",
      paddingTop: "5px",
      fontSize: "11px",
      whiteSpace: "pre-line",
      lineHeight: 1.2,
      color: "#000"
    },
    "@global": {
      "@media print": {
        "#root, #__next": {
          display: "none !important"
        },
        "body *": {
          visibility: "hidden"
        },
        "#printable-content, #printable-content *": {
          visibility: "visible"
        },
        "#printable-content": {
          position: "absolute",
          left: 0,
          top: 0,
          width: "100%",
          margin: 0,
          padding: 0
        },
        "html, body": {
          height: "max-content !important",
          minHeight: "0 !important",
          margin: 0,
          padding: 0,
          overflow: "hidden !important"
        },
        ".MuiDialog-root, .MuiDialog-container, .MuiDialog-paper": {
          height: "auto !important",
          minHeight: "0 !important",
          boxShadow: "none !important",
          border: "none !important",
          overflow: "visible !important",
          position: "static !important",
          transform: "none !important"
        },
        "@page": {
          size: "landscape",
          margin: "5mm"
        }
      }
    }
  };
});

// ============================================================================
// MAIN PARENT COMPONENT
// ============================================================================
var FormattedBankPaymentAdvice = function FormattedBankPaymentAdvice(_ref) {
  var _applications$, _ref3, _applications$2, _applications$3;
  var applications = _ref.applications,
    dependentData = _ref.dependentData,
    getTotalAmount = _ref.getTotalAmount,
    userRights = _ref.userRights,
    status = _ref.status,
    movements = _ref.movements;
  var classes = useStyles$R();
  var dispatch = useDispatch();
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    signatures = _useState2[0],
    setSignatures = _useState2[1];
  console.log({
    fromBankAdvice: applications
  });
  useEffect(function () {
    var getSignatures = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var senderIds, _res$payload, res;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!(movements && movements.length > 0)) {
                _context.next = 7;
                break;
              }
              senderIds = _toConsumableArray(new Set(movements.filter(function (item) {
                return (item === null || item === void 0 ? void 0 : item.status) === "forward_to_comiitee" || (item === null || item === void 0 ? void 0 : item.status) === "approved_by_committee";
              }).map(function (item) {
                var _item$applicationTo;
                return item !== null && item !== void 0 && (_item$applicationTo = item.applicationTo) !== null && _item$applicationTo !== void 0 && _item$applicationTo.id ? decodeId(item.applicationTo.id) : null;
              }).filter(function (id) {
                return id !== null;
              })));
              if (!(senderIds.length > 0)) {
                _context.next = 7;
                break;
              }
              _context.next = 5;
              return dispatch(fetchWorkforceSignatures(senderIds));
            case 5:
              res = _context.sent;
              setSignatures((res === null || res === void 0 || (_res$payload = res.payload) === null || _res$payload === void 0 || (_res$payload = _res$payload.data) === null || _res$payload === void 0 ? void 0 : _res$payload.workforceSignatures) || []);
            case 7:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function getSignatures() {
        return _ref2.apply(this, arguments);
      };
    }();
    getSignatures();
  }, [movements, dispatch]);
  var organization = "কেন্দ্রীয় তহবিল";
  var address = "২১ তলা, ভবন#৬, বাংলাদেশ সচিবালয়, ঢাকা-১০০০";
  var web = "www.centralfund.gov.bd";
  var logoSrc = "workforce_assets/centralfund.png";
  if ([WORKFORCE_USER_TYPE.BLWF_SECTION_ADMIN, WORKFORCE_USER_TYPE.BLWF_ACCOUNTANT, WORKFORCE_USER_TYPE.BLWF_DIRECTOR, WORKFORCE_USER_TYPE.BLWF_APPROVER, WORKFORCE_USER_TYPE.BLWF_DEPUTI_ASST_DIRECTOR].includes(getUserTypeFromRights(userRights))) {
    organization = "বাংলাদেশ শ্রমিক কল্যাণ ফাউন্ডেশন";
    address = "১৮ তলা, ভবন#৬, বাংলাদেশ সচিবালয়, ঢাকা-১০০০";
    web = "www.blwf.gov.bd";
    logoSrc = "workforce_assets/blwf.png";
  }

  // Determine App Category to render respective tables
  var filteredApplications = applications.filter(function (item) {
    return item.status === status;
  });
  console.log({
    fromBankAdvice: filteredApplications
  });
  var appType = applications === null || applications === void 0 || (_applications$ = applications[0]) === null || _applications$ === void 0 ? void 0 : _applications$.applicationType;
  console.log({
    fromBankAdvice: appType
  });
  var isMedicalOrMaternity = (_ref3 = ["medicalAssistance", "maternityGrant", "medicalDonation"]) === null || _ref3 === void 0 ? void 0 : _ref3.includes(appType);
  var isEducationOrScholarship = ["scholarship", "educationGrant"].includes(appType);
  console.log({
    fromBankAdvice: isMedicalOrMaternity
  });

  // Dynamic Title based on App Category
  var documentTitle = (applications === null || applications === void 0 || (_applications$2 = applications[0]) === null || _applications$2 === void 0 ? void 0 : _applications$2.organizationType) === "blwf" ? "বিএলডাব্লিউএফ এর আবেদন অনুযায়ী আর্থিক সহায়তা তালিকা" : isEducationOrScholarship ? "শিক্ষা আর্থিক সহায়তার তালিকা" : isMedicalOrMaternity ? "চিকিৎসা ও মাতৃত্বকালীন আর্থিক সহায়তার তালিকা" : "মৃত্যু ও দুর্ঘটনাজনিত আর্থিক সহায়তার তালিকা";
  return /*#__PURE__*/React.createElement("div", {
    id: "printable-content"
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    alignItems: "center",
    justify: "space-between",
    style: {
      paddingBottom: "16px",
      borderBottom: "1px solid #e0e0e0",
      marginBottom: "24px"
    }
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 3,
    style: {
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: logoSrc,
    alt: "Logo",
    style: {
      width: "120px",
      objectFit: "contain"
    }
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6,
    style: {
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.headerTitle
  }, "\u0997\u09A3\u09AA\u09CD\u09B0\u099C\u09BE\u09A4\u09A8\u09CD\u09A4\u09CD\u09B0\u09C0 \u09AC\u09BE\u0982\u09B2\u09BE\u09A6\u09C7\u09B6 \u09B8\u09B0\u0995\u09BE\u09B0"), /*#__PURE__*/React.createElement(Typography, {
    className: classes.docSubTitle
  }, "\u09B6\u09CD\u09B0\u09AE \u0993 \u0995\u09B0\u09CD\u09AE\u09B8\u0982\u09B8\u09CD\u09A5\u09BE\u09A8 \u09AE\u09A8\u09CD\u09A4\u09CD\u09B0\u09A3\u09BE\u09B2\u09AF\u09BC"), /*#__PURE__*/React.createElement(Typography, {
    className: classes.docText
  }, organization), /*#__PURE__*/React.createElement(Typography, {
    className: classes.docText
  }, address), /*#__PURE__*/React.createElement(Typography, {
    className: classes.docText
  }, web)), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 3,
    style: {
      textAlign: "right"
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: "workforce_assets/bdgov.png",
    alt: "BD Gov Logo",
    style: {
      width: "120px",
      objectFit: "contain"
    }
  }))), /*#__PURE__*/React.createElement(Typography, {
    className: classes.docTitle
  }, documentTitle), ["blwf"].includes((_applications$3 = applications[0]) === null || _applications$3 === void 0 ? void 0 : _applications$3.organizationType) ? /*#__PURE__*/React.createElement(BLWFView, {
    classes: classes,
    applications: applications,
    getTotalAmount: getTotalAmount
  }) : isEducationOrScholarship ? /*#__PURE__*/React.createElement(EducationScholarshipView, {
    classes: classes,
    applications: applications,
    dependentData: dependentData,
    getTotalAmount: getTotalAmount
  }) : isMedicalOrMaternity ? /*#__PURE__*/React.createElement(MedicalMaternityView, {
    classes: classes,
    applications: applications,
    getTotalAmount: getTotalAmount
  }) : /*#__PURE__*/React.createElement(DeathDisabilityView, {
    classes: classes,
    applications: applications,
    dependentData: dependentData,
    getTotalAmount: getTotalAmount
  }), /*#__PURE__*/React.createElement(Box$1, {
    mt: 4
  }, /*#__PURE__*/React.createElement(Typography, {
    style: {
      fontWeight: "bold",
      textDecoration: "underline",
      color: "#000"
    }
  }, "Signature of Members:"), /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 2,
    className: classes.signatureContainer
  }, signatures === null || signatures === void 0 ? void 0 : signatures.map(function (sig, i) {
    var _sig$workforce_docume, _sig$role;
    return /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 3,
      key: (sig === null || sig === void 0 ? void 0 : sig.user_id) || i
    }, sig !== null && sig !== void 0 && (_sig$workforce_docume = sig.workforce_document) !== null && _sig$workforce_docume !== void 0 && _sig$workforce_docume.url ? /*#__PURE__*/React.createElement("img", {
      src: sig.workforce_document.url,
      alt: "signature",
      style: {
        width: "100%",
        maxHeight: 80,
        objectFit: "contain"
      }
    }) : /*#__PURE__*/React.createElement(Typography, {
      variant: "caption",
      style: {
        fontStyle: "italic",
        color: "#999"
      }
    }, "Signature not available"), /*#__PURE__*/React.createElement("div", {
      className: classes.signatureBlock
    }, /*#__PURE__*/React.createElement("p", {
      style: {
        margin: 0,
        fontWeight: "bold"
      }
    }, sig === null || sig === void 0 ? void 0 : sig.last_name), /*#__PURE__*/React.createElement("p", {
      style: {
        margin: 0
      }
    }, sig === null || sig === void 0 || (_sig$role = sig.role) === null || _sig$role === void 0 ? void 0 : _sig$role.name)));
  }))));
};

function _createForOfIteratorHelper$5(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray$5(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray$5(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray$5(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray$5(r, a) : void 0; } }
function _arrayLikeToArray$5(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var useStyles$Q = makeStyles(function (theme) {
  return {
    noPrint: {
      "@media print": {
        display: "none !important"
      }
    },
    dialogPaper: {
      "@media print": {
        boxShadow: "none",
        border: "none",
        maxWidth: "100vw"
      }
    },
    dialogContent: {
      "@media print": {
        padding: 0
      }
    }
  };
});
var parseBankInfos = function parseBankInfos(raw) {
  try {
    var value = raw;
    while (typeof value === "string") value = JSON.parse(value);
    return Array.isArray(value) ? value : value ? [value] : [];
  } catch (_unused) {
    return [];
  }
};
var GenerateBFTN = function GenerateBFTN(_ref) {
  var open = _ref.open,
    onClose = _ref.onClose,
    _ref$applications = _ref.applications,
    applications = _ref$applications === void 0 ? [] : _ref$applications,
    userRights = _ref.userRights,
    status = _ref.status,
    summary_Id = _ref.summary_Id,
    summaryData = _ref.summaryData;
  var classes = useStyles$Q();
  var dispatch = useDispatch();
  var modulesManager = useModulesManager();
  var loggedInUserId = useSelector(function (state) {
    var _state$core;
    return (_state$core = state.core) === null || _state$core === void 0 || (_state$core = _state$core.user) === null || _state$core === void 0 || (_state$core = _state$core.i_user) === null || _state$core === void 0 ? void 0 : _state$core.id;
  });
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    movements = _useState2[0],
    setMovements = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2);
    _useState4[0];
    var setLastRevertMovement = _useState4[1];
  var _useState5 = useState([]),
    _useState6 = _slicedToArray(_useState5, 2);
    _useState6[0];
    var setRevertNotes = _useState6[1];
  var _useState7 = useState(null),
    _useState8 = _slicedToArray(_useState7, 2);
    _useState8[0];
    var setServerResponse = _useState8[1];
  var _useState9 = useState([]),
    _useState10 = _slicedToArray(_useState9, 2),
    dependentData = _useState10[0];
    _useState10[1];
  var _useState11 = useState(false),
    _useState12 = _slicedToArray(_useState11, 2),
    loader = _useState12[0],
    setLoader = _useState12[1];
  var _useState13 = useState([]),
    _useState14 = _slicedToArray(_useState13, 2),
    mappings = _useState14[0],
    setMappings = _useState14[1];
  var userIds = safeParse(summaryData === null || summaryData === void 0 ? void 0 : summaryData.userIds);
  var _useState15 = useState({}),
    _useState16 = _slicedToArray(_useState15, 2),
    dependentsByApplication = _useState16[0],
    setDependentsByApplication = _useState16[1];
  console.log({
    applications: applications
  });
  var getTotalAmount = function getTotalAmount() {
    return applications
    // .filter((item) => String(item.status) === String(status))
    .reduce(function (sum, item) {
      return sum + (parseFloat(item.grantAmount) || 0);
    }, 0).toFixed(2);
  };
  console.log({
    fromBFTN: applications
  });
  // console.log({ summary_Id: userIds });

  var handleForward = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var _filteredApplications, _activeMapping$commit;
      var filteredApplications, currentOrgType, activeMapping, approvalType, isQuorum, isRepresentative, _iterator, _step, item, decodedId, targetStatus, updatePayload, approvalUserIds, approvedUserIds, eligibleCount, majorityApproved, createApplicationMovementData, _iterator2, _step2, _mapItem$user, mapItem, _iterator3, _step3, _loop, _ret;
      return _regeneratorRuntime.wrap(function _callee2$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            // if (!window.confirm("আবেদনগুলো মহাপরিচালক কাছে অগ্রায়ন নিশ্চিত করছেন?")) return;
            setLoader(true);
            filteredApplications = applications;
            console.log({
              filteredApplications: filteredApplications
            });
            if (!(!filteredApplications || filteredApplications.length === 0)) {
              _context3.next = 6;
              break;
            }
            setLoader(false);
            return _context3.abrupt("return", setServerResponse({
              status: "ERROR",
              message: "কোনো উপযুক্ত আবেদন পাওয়া যায়নি।"
            }));
          case 6:
            // 1. Identify the organization type for the current batch of applications
            // (Since they are all the same, checking the first one is safe and highly efficient)
            currentOrgType = (_filteredApplications = filteredApplications[0]) === null || _filteredApplications === void 0 ? void 0 : _filteredApplications.organizationType; // 2. Find the exact mapping that corresponds to this organization type
            activeMapping = mappings === null || mappings === void 0 ? void 0 : mappings.find(function (item) {
              var _item$committee;
              return (item === null || item === void 0 || (_item$committee = item.committee) === null || _item$committee === void 0 ? void 0 : _item$committee.organizationType) === currentOrgType;
            }); // 3. Extract the approval type
            approvalType = activeMapping === null || activeMapping === void 0 || (_activeMapping$commit = activeMapping.committee) === null || _activeMapping$commit === void 0 ? void 0 : _activeMapping$commit.approvalType; // 4. Safely determine isQuorum and isRepresentative
            isQuorum = approvalType === "quorum" || !approvalType; // true for "quorum", null, or ""
            isRepresentative = approvalType === "representative"; // NOTE: You previously used `mappings.length` for totalApprovers.
            // Since 'mappings' contains ALL of the user's committee roles (both eis and blwf),
            // mappings.length would equal 2 here. You probably only want the approvers for the ACTIVE committee.
            // const totalApprovers = activeMapping ? 1 : mappings?.length || 1;
            (mappings === null || mappings === void 0 ? void 0 : mappings.length) || 1;
            _context3.prev = 12;
            if (!isQuorum) {
              _context3.next = 54;
              break;
            }
            console.log("hello from qorum");
            _iterator = _createForOfIteratorHelper$5(filteredApplications);
            _context3.prev = 17;
            _iterator.s();
          case 19:
            if ((_step = _iterator.n()).done) {
              _context3.next = 46;
              break;
            }
            item = _step.value;
            console.log("hello from qorum 2", item);
            decodedId = safeDecodeId(item.id);
            targetStatus = WORKFORCE_STATUS$1.FORWARD_TO_DIRECTOR;
            updatePayload = {
              id: decodedId
            };
            approvalUserIds = item.eisApprovalIds ? safeParse(item.eisApprovalIds) : [];
            approvedUserIds = item.eisApprovedByIds ? safeParse(item.eisApprovedByIds) : [];
            if (!approvedUserIds.includes(loggedInUserId)) {
              _context3.next = 29;
              break;
            }
            return _context3.abrupt("return", setServerResponse({
              status: "ERROR",
              message: "আপনি ইতিমধ্যে অনুমোদন করেছেন!"
            }));
          case 29:
            approvedUserIds.push(loggedInUserId);
            // const majorityApproved =
            //   approvedUserIds.length / approvalUserIds?.length >= 0.5;
            eligibleCount = Array.isArray(approvalUserIds) ? approvalUserIds.length : 0;
            majorityApproved = eligibleCount > 0 && approvedUserIds.length > eligibleCount / 2;
            targetStatus = majorityApproved ? WORKFORCE_STATUS$1.FORWARD_TO_DIRECTOR : WORKFORCE_STATUS$1.FORWARD_TO_COMIITEE;
            updatePayload.eisApprovedByIds = JSON.stringify(approvedUserIds);
            updatePayload.status = targetStatus;
            console.log({
              updatePayload: updatePayload
            });
            _context3.next = 39;
            return dispatch(updateApplication(updatePayload, "update workforce application"));
          case 39:
            createApplicationMovementData = {
              applicationId: decodedId,
              status: targetStatus,
              note: "আবেদন পরিচালকের কাছে পাঠানো হয়েছে",
              action: targetStatus
            };
            _context3.next = 42;
            return dispatch(createApplicationMovement(createApplicationMovementData, "create workforce movement"));
          case 42:
            _context3.next = 44;
            return dispatch(updateApplicationSummary({
              id: summary_Id,
              status: targetStatus
            }, "update workforce application summary"));
          case 44:
            _context3.next = 19;
            break;
          case 46:
            _context3.next = 51;
            break;
          case 48:
            _context3.prev = 48;
            _context3.t0 = _context3["catch"](17);
            _iterator.e(_context3.t0);
          case 51:
            _context3.prev = 51;
            _iterator.f();
            return _context3.finish(51);
          case 54:
            console.log("hello", isRepresentative);
            console.log("hello2", isQuorum);
            if (!isRepresentative) {
              _context3.next = 95;
              break;
            }
            console.log("hello");
            _iterator2 = _createForOfIteratorHelper$5(mappings || []);
            _context3.prev = 59;
            _iterator2.s();
          case 61:
            if ((_step2 = _iterator2.n()).done) {
              _context3.next = 87;
              break;
            }
            mapItem = _step2.value;
            console.log({
              mapItem: mapItem
            });
            if (!(mapItem !== null && mapItem !== void 0 && mapItem.isRepresentative && String(safeDecodeId(mapItem === null || mapItem === void 0 || (_mapItem$user = mapItem.user) === null || _mapItem$user === void 0 ? void 0 : _mapItem$user.id)) === String(loggedInUserId))) {
              _context3.next = 85;
              break;
            }
            // if ( String(safeDecodeId(mapItem?.user?.id)) === String(loggedInUserId)) {
            console.log("hello3");
            _iterator3 = _createForOfIteratorHelper$5(filteredApplications);
            _context3.prev = 67;
            _loop = /*#__PURE__*/_regeneratorRuntime.mark(function _loop() {
              var app, decodedId, targetStatus, updatePayload, approvedUserIds;
              return _regeneratorRuntime.wrap(function _loop$(_context2) {
                while (1) switch (_context2.prev = _context2.next) {
                  case 0:
                    app = _step3.value;
                    console.log("hello4");
                    decodedId = safeDecodeId(app.id);
                    targetStatus = WORKFORCE_STATUS$1.FORWARD_TO_DIRECTOR;
                    updatePayload = {
                      id: decodedId
                    };
                    approvedUserIds = app !== null && app !== void 0 && app.eisApprovedByIds ? safeParse(app === null || app === void 0 ? void 0 : app.eisApprovedByIds) : [];
                    if (!(approvedUserIds !== null && approvedUserIds !== void 0 && approvedUserIds.includes(loggedInUserId))) {
                      _context2.next = 9;
                      break;
                    }
                    setServerResponse({
                      status: "ERROR",
                      message: "আপনি ইতিমধ্যে অনুমোদন করেছেন!"
                    });
                    return _context2.abrupt("return", {
                      v: void 0
                    });
                  case 9:
                    console.log(approvedUserIds.includes(loggedInUserId));
                    approvedUserIds.push(loggedInUserId);
                    updatePayload.eisApprovedByIds = JSON.stringify(approvedUserIds);
                    updatePayload.status = targetStatus;
                    _context2.next = 15;
                    return dispatch(updateApplication(updatePayload, "update workforce application")).then(/*#__PURE__*/function () {
                      var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(res) {
                        var createApplicationMovementData;
                        return _regeneratorRuntime.wrap(function _callee$(_context) {
                          while (1) switch (_context.prev = _context.next) {
                            case 0:
                              createApplicationMovementData = {
                                applicationId: decodedId,
                                status: WORKFORCE_STATUS$1.FORWARD_TO_DIRECTOR,
                                note: "আবেদন পরিচালকের কাছে পাঠানো হয়েছে",
                                action: WORKFORCE_STATUS$1.FORWARD_TO_DIRECTOR
                              };
                              _context.next = 3;
                              return dispatch(createApplicationMovement(createApplicationMovementData, "create workforce movement"));
                            case 3:
                              _context.next = 5;
                              return dispatch(updateApplicationSummary({
                                id: summary_Id,
                                status: WORKFORCE_STATUS$1.FORWARD_TO_DIRECTOR
                              }, "update workforce application summary"));
                            case 5:
                            case "end":
                              return _context.stop();
                          }
                        }, _callee);
                      }));
                      return function (_x) {
                        return _ref3.apply(this, arguments);
                      };
                    }());
                  case 15:
                  case "end":
                    return _context2.stop();
                }
              }, _loop);
            });
            _iterator3.s();
          case 70:
            if ((_step3 = _iterator3.n()).done) {
              _context3.next = 77;
              break;
            }
            return _context3.delegateYield(_loop(), "t1", 72);
          case 72:
            _ret = _context3.t1;
            if (!_ret) {
              _context3.next = 75;
              break;
            }
            return _context3.abrupt("return", _ret.v);
          case 75:
            _context3.next = 70;
            break;
          case 77:
            _context3.next = 82;
            break;
          case 79:
            _context3.prev = 79;
            _context3.t2 = _context3["catch"](67);
            _iterator3.e(_context3.t2);
          case 82:
            _context3.prev = 82;
            _iterator3.f();
            return _context3.finish(82);
          case 85:
            _context3.next = 61;
            break;
          case 87:
            _context3.next = 92;
            break;
          case 89:
            _context3.prev = 89;
            _context3.t3 = _context3["catch"](59);
            _iterator2.e(_context3.t3);
          case 92:
            _context3.prev = 92;
            _iterator2.f();
            return _context3.finish(92);
          case 95:
            setServerResponse({
              status: "SUCCESS",
              message: "সাবমিশন সফল হয়েছে!"
            });
            _context3.next = 101;
            break;
          case 98:
            _context3.prev = 98;
            _context3.t4 = _context3["catch"](12);
            setServerResponse({
              status: "ERROR",
              message: "সাবমিশন ব্যর্থ হয়েছে!"
            });
          case 101:
            _context3.prev = 101;
            setLoader(false);
            onClose();
            window.location.reload();
            return _context3.finish(101);
          case 106:
          case "end":
            return _context3.stop();
        }
      }, _callee2, null, [[12, 98, 101, 106], [17, 48, 51, 54], [59, 89, 92, 95], [67, 79, 82, 85]]);
    }));
    return function handleForward() {
      return _ref2.apply(this, arguments);
    };
  }();
  var fetchApplicationMovement = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      var _mappingsData$payload, _applications$, _response$payload, mappingsData, response, movementsData, senderObjects, clean, lastRevert;
      return _regeneratorRuntime.wrap(function _callee3$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            _context4.prev = 0;
            _context4.next = 3;
            return dispatch(fetchWorkforceCommitteeUserMap({
              userIds: userIds || ["".concat(loggedInUserId)]
            }));
          case 3:
            mappingsData = _context4.sent;
            setMappings((mappingsData === null || mappingsData === void 0 || (_mappingsData$payload = mappingsData.payload) === null || _mappingsData$payload === void 0 || (_mappingsData$payload = _mappingsData$payload.data) === null || _mappingsData$payload === void 0 ? void 0 : _mappingsData$payload.workforceCommitteeUserMaps) || []);
            _context4.next = 7;
            return dispatch(fetchApplicationWiseMovementList(modulesManager, {
              applicationId: applications === null || applications === void 0 || (_applications$ = applications[0]) === null || _applications$ === void 0 ? void 0 : _applications$.id
            }));
          case 7:
            response = _context4.sent;
            console.log("movement response", response);
            movementsData = parseData(response === null || response === void 0 || (_response$payload = response.payload) === null || _response$payload === void 0 || (_response$payload = _response$payload.data) === null || _response$payload === void 0 ? void 0 : _response$payload.workforceApplicationMovement) || [];
            senderObjects = movementsData.filter(function (m) {
              return m.applicationFrom !== null;
            }).map(function (m) {
              return m.applicationFrom;
            }).filter(function (m) {
              var _m$userRoles, _m$userRoles2, _m$userRoles3;
              return ((_m$userRoles = m.userRoles) === null || _m$userRoles === void 0 || (_m$userRoles = _m$userRoles[0]) === null || _m$userRoles === void 0 || (_m$userRoles = _m$userRoles.role) === null || _m$userRoles === void 0 ? void 0 : _m$userRoles.name) === "Doctor" || ((_m$userRoles2 = m.userRoles) === null || _m$userRoles2 === void 0 || (_m$userRoles2 = _m$userRoles2[0]) === null || _m$userRoles2 === void 0 || (_m$userRoles2 = _m$userRoles2.role) === null || _m$userRoles2 === void 0 ? void 0 : _m$userRoles2.name) === "Blwf Doctor" || ((_m$userRoles3 = m.userRoles) === null || _m$userRoles3 === void 0 || (_m$userRoles3 = _m$userRoles3[0]) === null || _m$userRoles3 === void 0 || (_m$userRoles3 = _m$userRoles3.role) === null || _m$userRoles3 === void 0 ? void 0 : _m$userRoles3.name) === "Eis Doctor";
            });
            console.log("movement senderData", senderObjects);
            clean = function clean(html) {
              return (html === null || html === void 0 ? void 0 : html.replace(/<\/?[^>]+(>|$)/g, "")) || "";
            }; // Clone and find the last revert note
            lastRevert = _toConsumableArray(movementsData).reverse().find(function (m) {
              return m.revertNote;
            });
            if (lastRevert) {
              lastRevert.revertNote = clean(lastRevert.revertNote);
            }

            // Update State
            setMovements(movementsData);
            setLastRevertMovement(lastRevert);
            setRevertNotes(lastRevert ? [lastRevert.revertNote] : []);
            _context4.next = 23;
            break;
          case 20:
            _context4.prev = 20;
            _context4.t0 = _context4["catch"](0);
            console.error("Failed to load revert notes", _context4.t0);
          case 23:
          case "end":
            return _context4.stop();
        }
      }, _callee3, null, [[0, 20]]);
    }));
    return function fetchApplicationMovement() {
      return _ref4.apply(this, arguments);
    };
  }();
  useEffect(function () {
    if (open) {
      fetchApplicationMovement();
    }
  }, [open]);
  useEffect(function () {
    if (!open) return;
    var financialApplications = applications.filter(function (app) {
      return app.applicationType === "financialAssistance";
    });
    Promise.all(financialApplications.map(/*#__PURE__*/function () {
      var _ref5 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee4(app) {
        var _response$payload2;
        var applicationId, response;
        return _regeneratorRuntime.wrap(function _callee4$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              applicationId = safeDecodeId(app.id);
              _context5.next = 3;
              return dispatch(fetchWorkforceEmployeeDependent(modulesManager, ["workforceApplication_Id: \"".concat(applicationId, "\"")]));
            case 3:
              response = _context5.sent;
              return _context5.abrupt("return", [String(app.id), parseData(response === null || response === void 0 || (_response$payload2 = response.payload) === null || _response$payload2 === void 0 || (_response$payload2 = _response$payload2.data) === null || _response$payload2 === void 0 ? void 0 : _response$payload2.workforceEmployeeDependent) || []]);
            case 5:
            case "end":
              return _context5.stop();
          }
        }, _callee4);
      }));
      return function (_x2) {
        return _ref5.apply(this, arguments);
      };
    }())).then(function (entries) {
      return setDependentsByApplication(Object.fromEntries(entries));
    })["catch"](function (error) {
      return console.error("Failed to load dependent data", error);
    });
  }, [open, applications, dispatch, modulesManager]);
  var loadImageAsBuffer = /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee5(url) {
      var response;
      return _regeneratorRuntime.wrap(function _callee5$(_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            _context6.prev = 0;
            _context6.next = 3;
            return fetch(url);
          case 3:
            response = _context6.sent;
            if (response.ok) {
              _context6.next = 6;
              break;
            }
            throw new Error("Failed to fetch image: ".concat(url));
          case 6:
            _context6.next = 8;
            return response.arrayBuffer();
          case 8:
            return _context6.abrupt("return", _context6.sent);
          case 11:
            _context6.prev = 11;
            _context6.t0 = _context6["catch"](0);
            console.error("Error loading image:", _context6.t0);
            return _context6.abrupt("return", null);
          case 15:
          case "end":
            return _context6.stop();
        }
      }, _callee5, null, [[0, 11]]);
    }));
    return function loadImageAsBuffer(_x3) {
      return _ref6.apply(this, arguments);
    };
  }();
  var paymentRows = applications.flatMap(function (app) {
    if (app.applicationType === "financialAssistance") {
      var dependents = dependentsByApplication[String(app.id)] || [];
      return dependents.map(function (dep) {
        var _dep$bank, _app$employeeFactory;
        return {
          applicationId: app.id,
          applicationType: app.applicationType,
          date: app.dateCreated,
          accountName: dep.bankAccountHolderName,
          accountNumber: dep.bankAccountNo,
          receiverRoutingNumber: (_dep$bank = dep.bank) === null || _dep$bank === void 0 ? void 0 : _dep$bank.routingNumber,
          amount: Number(dep.percentageOfCfGrant) / 100 * Number(app.grantAmount || 0),
          factoryName: (_app$employeeFactory = app.employeeFactory) === null || _app$employeeFactory === void 0 ? void 0 : _app$employeeFactory.nameEn
        };
      });
    }
    return parseBankInfos(app.employeeBankInfo).map(function (bankInfo) {
      var _app$workforceEmploye, _bankInfo$branch, _app$employeeFactory2;
      return {
        applicationId: app.id,
        applicationType: app.applicationType,
        date: app.dateCreated,
        accountName: bankInfo.accountHolderName || ((_app$workforceEmploye = app.workforceEmployee) === null || _app$workforceEmploye === void 0 ? void 0 : _app$workforceEmploye.firstNameBn),
        accountNumber: bankInfo.accountNumber,
        receiverRoutingNumber: (_bankInfo$branch = bankInfo.branch) === null || _bankInfo$branch === void 0 ? void 0 : _bankInfo$branch.routingNumber,
        amount: Number(app.grantAmount || 0),
        factoryName: (_app$employeeFactory2 = app.employeeFactory) === null || _app$employeeFactory2 === void 0 ? void 0 : _app$employeeFactory2.nameEn
      };
    });
  });
  var exportToExcel = /*#__PURE__*/function () {
    var _ref7 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
      var workbook, worksheet, logo, organization, address, web, renderLogo, bdGovLogo, imageId1, imageId2, buffer, blob;
      return _regeneratorRuntime.wrap(function _callee6$(_context7) {
        while (1) switch (_context7.prev = _context7.next) {
          case 0:
            _context7.prev = 0;
            // Create a new workbook and worksheet
            workbook = new ExcelJS.Workbook();
            worksheet = workbook.addWorksheet("Applications", {
              properties: {
                defaultColWidth: 15
              }
            }); // Load logos as buffers
            logo = "/workforce_assets/centralfund.png";
            organization = "কেন্দ্রীয় তহবিল";
            address = "২১ তলা, ভবন#৬, বাংলাদেশ সচিবালয়, ঢাকা-১০০০";
            web = "www.centralfund.gov.bd";
            if (getUserTypeFromRights(userRights) === WORKFORCE_USER_TYPE.BLWF_SECTION_ADMIN || getUserTypeFromRights(userRights) === WORKFORCE_USER_TYPE.BLWF_ACCOUNTANT || getUserTypeFromRights(userRights) === WORKFORCE_USER_TYPE.BLWF_DIRECTOR || getUserTypeFromRights(userRights) === WORKFORCE_USER_TYPE.BLWF_APPROVER || getUserTypeFromRights(userRights) === WORKFORCE_USER_TYPE.BLWF_DEPUTI_ASST_DIRECTOR)
              // if(getUserTypeFromRights(userRights).includes("blwf"))
              {
                logo = "/workforce_assets/blwf.png";
                organization = "বাংলাদেশ শ্রমিক কল্যাণ ফাউন্ডেশন";
                address = "১৮ তলা, ভবন#৬, বাংলাদেশ সচিবালয়, ঢাকা-১০০০";
                web = "www.blwf.gov.bd";
              }
            // else if(getUserTypeFromRights(userRights) === WORKFORCE_USER_TYPE.EIS_SECTION_ADMIN)
            // {
            //   logo= `workforce_assets/eis.png`;
            // }
            _context7.next = 10;
            return loadImageAsBuffer("/front" + logo);
          case 10:
            renderLogo = _context7.sent;
            _context7.next = 13;
            return loadImageAsBuffer("/front/workforce_assets/bdgov.png");
          case 13:
            bdGovLogo = _context7.sent;
            // Add logos to workbook
            if (renderLogo) {
              imageId1 = workbook.addImage({
                buffer: renderLogo,
                extension: "png"
              });
              worksheet.addImage(imageId1, {
                tl: {
                  col: 0,
                  row: 0
                },
                ext: {
                  width: 120,
                  height: 120
                }
              });
            } else {
              worksheet.getCell("A1").value = "[Organization Logo]";
            }
            if (bdGovLogo) {
              imageId2 = workbook.addImage({
                buffer: bdGovLogo,
                extension: "png"
              });
              worksheet.addImage(imageId2, {
                tl: {
                  col: 7,
                  row: 0
                },
                ext: {
                  width: 120,
                  height: 120
                }
              });
            } else {
              worksheet.getCell("I1").value = "[BD Government Logo]";
            }

            // Header information
            worksheet.mergeCells("D1:F1");
            worksheet.getCell("D1").value = "গণপ্রজাতন্ত্রী বাংলাদেশ সরকার";
            worksheet.getCell("D1").alignment = {
              horizontal: "center"
            };
            worksheet.getCell("D1").font = {
              bold: true,
              size: 14
            };
            worksheet.mergeCells("D2:F2");
            worksheet.getCell("D2").value = "শ্রম ও কর্মসংস্থান মন্ত্রণালয়";
            worksheet.getCell("D2").alignment = {
              horizontal: "center"
            };
            worksheet.mergeCells("D3:F3");
            worksheet.getCell("D3").value = organization;
            worksheet.getCell("D3").alignment = {
              horizontal: "center"
            };
            worksheet.mergeCells("D4:F4");
            worksheet.getCell("D4").value = address;
            worksheet.getCell("D4").alignment = {
              horizontal: "center"
            };
            worksheet.mergeCells("D5:F5");
            worksheet.getCell("D5").value = web;
            worksheet.getCell("D5").alignment = {
              horizontal: "center"
            };
            worksheet.mergeCells("A6:I6");
            worksheet.getCell("A6").value = "মৃত্যু ও দূর্ঘটনাজনিত আর্থিক সহায়তা তালিকা";
            worksheet.getCell("A6").alignment = {
              horizontal: "center"
            };
            worksheet.getCell("A6").font = {
              underline: true
            };
            worksheet.mergeCells("A7:I7");
            worksheet.getCell("A7").value = "সুবিধাভোগী কল্যাণ হিসাব (নং ৪৪২৬৩৩৬০০১০৩৪)";
            worksheet.getCell("A7").alignment = {
              horizontal: "center"
            };
            worksheet.getCell("A7").font = {
              underline: true
            };
            worksheet.getCell("A8").value = "বোর্ড সভাঃ";
            worksheet.getCell("A9").value = "\u0986\u09AC\u09C7\u09A6\u09A8\u09C7\u09B0 \u09B8\u0982\u0996\u09CD\u09AF\u09BE\u0983 ".concat(enToBn(applications.length));
            worksheet.getCell("A10").value = "নমিনী/ব্যাংক হিসাবের সংখ্যাঃ";
            worksheet.getCell("A11").value = "\u0985\u09B0\u09CD\u09A5\u09C7\u09B0 \u09AA\u09B0\u09BF\u09AE\u09BE\u09A3\u0983 ".concat(Number(getTotalAmount()).toLocaleString("bn-BD"), "/-");

            // Add a blank row
            worksheet.getRow(12).height = 15;

            // Table headers

            // if (applications[0]?.applicationType === "financialAssistance") {
            //   /* ================= FINANCIAL ASSISTANCE ================= */

            //   const headers = [
            //     "SL No",
            //     "Date",
            //     "Sender A/C No",
            //     "Receiver's Routing Number",
            //     "Sender's Routing Number",
            //     "Dependent Account Name",
            //     "Dependent Account No",
            //     "Type(C/D)",
            //     "Approved Amount",
            //   ];
            //   worksheet.addRow(headers);
            //   worksheet.getRow(13).font = { bold: true };
            //   worksheet.getRow(13).alignment = { horizontal: "center" };

            //   dependentData.forEach((dep, index) => {
            //     const totalGrant = getTotalAmount() || 200000;
            //     const approvedAmount = ((parseFloat(dep.percentageOfCfGrant) || 0) / 100) * totalGrant;

            //     worksheet.addRow([
            //       index + 1,
            //       dep?.dateCreated?.split("T")[0] || "",
            //       "4426336001034",
            //       dep?.bank?.routingNumber || "",
            //       "200275714",
            //       dep?.bankAccountHolderName || "",
            //       dep?.bankAccountNo || "",
            //       "",
            //       approvedAmount,
            //     ]);
            //   });
            // } else {
            //   /* ================= OTHER APPLICATION TYPE ================= */

            //   const headers = [
            //     "SL No",
            //     "Date",
            //     "Sender A/C No",
            //     "Receiver's Routing Number",
            //     "Sender's Routing Number",
            //     "Customer Account Name",
            //     "Customer Account No",
            //     "Type(C/D)",
            //     "Approved Amount",
            //   ];
            //   worksheet.addRow(headers);
            //   worksheet.getRow(13).font = { bold: true };
            //   worksheet.getRow(13).alignment = { horizontal: "center" };

            //   applications
            //     .flatMap((row) => {
            //       let bankInfos = [];
            //       try {
            //         const parsed = JSON.parse(row.employeeBankInfo);
            //         const finalParsed = typeof parsed === "string" ? JSON.parse(parsed) : parsed;
            //         bankInfos = Array.isArray(finalParsed) ? finalParsed : [finalParsed];
            //       } catch (e) {
            //         console.error("Bank info parse error", e);
            //         return [];
            //       }
            //       return bankInfos.map((bankInfo) => ({ row, bankInfo }));
            //     })
            //     .forEach(({ row, bankInfo }, index) => {
            //       worksheet.addRow([
            //         index + 1,
            //         row?.dateCreated?.split("T")[0] || "",
            //         "4426336001034",
            //         bankInfo?.branch?.routingNumber || "",
            //         "200275714",
            //         bankInfo?.accountHolderName || row?.workforceEmployee?.firstNameBn || "",
            //         bankInfo?.accountNumber || "",
            //         "",
            //         row?.grantAmount || 0,
            //       ]);
            //     });
            // }

            paymentRows.forEach(function (row, index) {
              var _row$date;
              worksheet.addRow([index + 1, ((_row$date = row.date) === null || _row$date === void 0 ? void 0 : _row$date.split("T")[0]) || "", "4426336001034", row.receiverRoutingNumber || "", "200275714", row.accountName || "", row.accountNumber || "", row.factoryName || "", Number(row.amount) || 0]);
            });

            // Total matching the payment rows
            paymentRows.reduce(function (sum, row) {
              return sum + (Number(row.amount) || 0);
            }, 0); // Total amount row
            worksheet.addRow(["", "", "", "", "", "Total Amount", "", "", getTotalAmount() || 0]);
            worksheet.getRow(worksheet.rowCount).font = {
              bold: true
            };
            worksheet.getCell("I".concat(worksheet.rowCount)).alignment = {
              horizontal: "right"
            };

            // Set column widths
            worksheet.columns = [{
              width: 10
            },
            // SL No
            {
              width: 15
            },
            // Date
            {
              width: 15
            },
            // Sender A/C No
            {
              width: 20
            },
            // Receiver's Routing Number
            {
              width: 20
            },
            // Sender's Routing Number
            {
              width: 25
            },
            // Customer Account Name
            {
              width: 20
            },
            // Customer Account No
            {
              width: 10
            },
            // Type(C/D)
            {
              width: 15
            } // Approved Amount
            ];

            // Generate and download the file
            _context7.next = 53;
            return workbook.xlsx.writeBuffer();
          case 53:
            buffer = _context7.sent;
            blob = new Blob([buffer], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            });
            saveAs(blob, "Applications.xlsx");
            _context7.next = 62;
            break;
          case 58:
            _context7.prev = 58;
            _context7.t0 = _context7["catch"](0);
            console.error("Error exporting to Excel:", _context7.t0);
            alert("Failed to export data to Excel. Please try again.");
          case 62:
          case "end":
            return _context7.stop();
        }
      }, _callee6, null, [[0, 58]]);
    }));
    return function exportToExcel() {
      return _ref7.apply(this, arguments);
    };
  }();
  console.log({
    mappingsData: mappings
  });
  if (getUserTypeFromRights(userRights) === WORKFORCE_USER_TYPE.APPROVER || getUserTypeFromRights(userRights) === WORKFORCE_USER_TYPE.BLWF_APPROVER) {
    return /*#__PURE__*/React.createElement(Dialog$1, {
      open: open,
      onClose: onClose,
      maxWidth: "md",
      fullWidth: true
    }, /*#__PURE__*/React.createElement(DialogTitle, {
      disableTypography: true
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "h6"
    }, /*#__PURE__*/React.createElement(FormattedMessage, {
      module: "workforce",
      id: "workforce.application.modal.header"
    }))), /*#__PURE__*/React.createElement(DialogContent$1, {
      dividers: true
    }, /*#__PURE__*/React.createElement(FormattedBankPaymentAdvice, {
      applications: applications,
      dependentData: dependentData,
      getTotalAmount: getTotalAmount,
      userRights: userRights,
      status: status,
      movements: movements
    })), /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement(DialogActions$1, {
      className: classes.noPrint
    }, /*#__PURE__*/React.createElement(Button, {
      onClick: onClose,
      variant: "outlined",
      color: "primary"
    }, /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.table.close",
      defaultMessage: "\u09AC\u09A8\u09CD\u09A7 \u0995\u09B0\u09C1\u09A8"
    })), /*#__PURE__*/React.createElement(Button, {
      onClick: function onClick() {
        return window.print();
      },
      variant: "contained",
      color: "primary"
    }, /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.table.printSUmmary",
      defaultMessage: "\u09AE\u09C1\u09A6\u09CD\u09B0\u09A3\u09C7\u09B0 \u09B8\u09BE\u09B0\u09BE\u0982\u09B6"
    })), /*#__PURE__*/React.createElement(Button, {
      onClick: function onClick() {
        return handleForward();
      },
      variant: "contained",
      color: "primary",
      disabled: loader
    }, /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.table.forwardToDirector",
      defaultMessage: "\u09AE\u09B9\u09BE\u09AA\u09B0\u09BF\u099A\u09BE\u09B2\u0995 \u09AC\u09B0\u09BE\u09AC\u09B0 \u0985\u0997\u09CD\u09B0\u09BE\u09DF\u09A8 \u0995\u09B0\u09C1\u09A8"
    }), /*#__PURE__*/React.createElement(ForwardIcon, null))));
  } else if (getUserTypeFromRights(userRights) === WORKFORCE_USER_TYPE.ADMIN || getUserTypeFromRights(userRights) === WORKFORCE_USER_TYPE.SECTION_ADMIN || getUserTypeFromRights(userRights) === WORKFORCE_USER_TYPE.SECTION_ADMIN_TWO || getUserTypeFromRights(userRights) === WORKFORCE_USER_TYPE.BLWF_SECTION_ADMIN || getUserTypeFromRights(userRights) === WORKFORCE_USER_TYPE.BLWF_ACCOUNTANT || getUserTypeFromRights(userRights) === WORKFORCE_USER_TYPE.EIS_COORDINATOR || getUserTypeFromRights(userRights) === WORKFORCE_USER_TYPE.EIS_ADVISOR || getUserTypeFromRights(userRights) === WORKFORCE_USER_TYPE.DIRECTOR || getUserTypeFromRights(userRights) === WORKFORCE_USER_TYPE.BLWF_DIRECTOR || getUserTypeFromRights(userRights) === WORKFORCE_USER_TYPE.SECRETARY || getUserTypeFromRights(userRights) === WORKFORCE_USER_TYPE.MINISTER)
    // else if (!getUserTypeFromRights(userRights).includes("blwf"))
    {
      var _applications$2, _ref8, _applications$3;
      var logo = /*#__PURE__*/React.createElement("img", {
        src: "workforce_assets/centralfund.png",
        alt: "Logo",
        style: {
          width: "120px"
        }
      });
      var organization = "কেন্দ্রীয় তহবিল";
      var address = "২১ তলা, ভবন#৬, বাংলাদেশ সচিবালয়, ঢাকা-১০০০";
      var web = "www.centralfund.gov.bd";
      // if(getUserTypeFromRights(userRights) === WORKFORCE_USER_TYPE.BLWF_SECTION_ADMIN)
      if (getUserTypeFromRights(userRights) === WORKFORCE_USER_TYPE.BLWF_SECTION_ADMIN || getUserTypeFromRights(userRights) === WORKFORCE_USER_TYPE.BLWF_ACCOUNTANT || getUserTypeFromRights(userRights) === WORKFORCE_USER_TYPE.BLWF_DIRECTOR || getUserTypeFromRights(userRights) === WORKFORCE_USER_TYPE.BLWF_APPROVER || getUserTypeFromRights(userRights) === WORKFORCE_USER_TYPE.BLWF_DEPUTI_ASST_DIRECTOR) {
        logo = /*#__PURE__*/React.createElement("img", {
          src: "workforce_assets/blwf.png",
          alt: "Logo",
          style: {
            width: "120px"
          }
        });
        organization = "বাংলাদেশ শ্রমিক কল্যাণ ফাউন্ডেশন";
        address = "১৮ তলা, ভবন#৬, বাংলাদেশ সচিবালয়, ঢাকা-১০০০";
        web = "www.blwf.gov.bd";
      }
      var appType = applications === null || applications === void 0 || (_applications$2 = applications[0]) === null || _applications$2 === void 0 ? void 0 : _applications$2.applicationType;
      console.log({
        fromBankAdvice: appType
      });
      var isMedicalOrMaternity = (_ref8 = ["medicalAssistance", "maternityGrant", "medicalDonation"]) === null || _ref8 === void 0 ? void 0 : _ref8.includes(appType);
      var isEducationOrScholarship = ["scholarship", "educationGrant"].includes(appType);
      console.log({
        fromBankAdvice: isMedicalOrMaternity
      });

      // Dynamic Title based on App Category
      var documentTitle = (applications === null || applications === void 0 || (_applications$3 = applications[0]) === null || _applications$3 === void 0 ? void 0 : _applications$3.organizationType) === "blwf" ? "বিএলডাব্লিউএফ এর আবেদন অনুযায়ী আর্থিক সহায়তা তালিকা" : isEducationOrScholarship ? "শিক্ষা আর্থিক সহায়তার তালিকা" : isMedicalOrMaternity ? "চিকিৎসা ও মাতৃত্বকালীন আর্থিক সহায়তার তালিকা" : "মৃত্যু ও দুর্ঘটনাজনিত আর্থিক সহায়তার তালিকা";
      return /*#__PURE__*/React.createElement(Dialog$1, {
        open: open,
        onClose: onClose,
        maxWidth: "lg",
        fullWidth: true
      }, /*#__PURE__*/React.createElement(DialogTitle, {
        disableTypography: true
      }, /*#__PURE__*/React.createElement(Typography, {
        variant: "h6"
      }, " ", /*#__PURE__*/React.createElement(FormattedMessage, {
        id: "Bank Payment Advice (BFTN)"
      }))), /*#__PURE__*/React.createElement(DialogContent$1, {
        dividers: true,
        className: classes.dialogContent
      }, /*#__PURE__*/React.createElement(Table$2, null, /*#__PURE__*/React.createElement(TableHead, {
        style: {
          fontWeight: "bold"
        }
      }, /*#__PURE__*/React.createElement(TableRow, null, /*#__PURE__*/React.createElement(TableCell, {
        colSpan: 2,
        style: {
          textAlign: "left"
        }
      }, logo), /*#__PURE__*/React.createElement(TableCell, {
        colSpan: 5,
        style: {
          textAlign: "center"
        }
      }, /*#__PURE__*/React.createElement("h3", {
        style: {
          margin: 0
        }
      }, "\u0997\u09A3\u09AA\u09CD\u09B0\u099C\u09BE\u09A4\u09A8\u09CD\u09A4\u09CD\u09B0\u09C0 \u09AC\u09BE\u0982\u09B2\u09BE\u09A6\u09C7\u09B6 \u09B8\u09B0\u0995\u09BE\u09B0"), /*#__PURE__*/React.createElement("p", {
        style: {
          margin: 0
        }
      }, "\u09B6\u09CD\u09B0\u09AE \u0993 \u0995\u09B0\u09CD\u09AE\u09B8\u0982\u09B8\u09CD\u09A5\u09BE\u09A8 \u09AE\u09A8\u09CD\u09A4\u09CD\u09B0\u09A3\u09BE\u09B2\u09DF"), /*#__PURE__*/React.createElement("p", {
        style: {
          margin: 0
        }
      }, organization), /*#__PURE__*/React.createElement("p", {
        style: {
          margin: 0
        }
      }, address), /*#__PURE__*/React.createElement("p", {
        style: {
          margin: 0
        }
      }, web)), /*#__PURE__*/React.createElement(TableCell, {
        colSpan: 2,
        style: {
          textAlign: "right"
        }
      }, /*#__PURE__*/React.createElement("img", {
        src: "workforce_assets/bdgov.png",
        alt: "Logo",
        style: {
          width: "120px"
        }
      }))), /*#__PURE__*/React.createElement(TableRow, null, /*#__PURE__*/React.createElement(TableCell, {
        colSpan: 9,
        style: {
          textAlign: "center"
        }
      }, /*#__PURE__*/React.createElement("p", {
        style: {
          textDecoration: "underline",
          margin: 0
        }
      }, documentTitle, " "), /*#__PURE__*/React.createElement("p", {
        style: {
          textDecoration: "underline",
          margin: 0
        }
      }, "\u09B8\u09C1\u09AC\u09BF\u09A7\u09BE\u09AD\u09CB\u0997\u09C0 \u0995\u09B2\u09CD\u09AF\u09BE\u09A3 \u09B9\u09BF\u09B8\u09BE\u09AC (\u09A8\u0982 \u09EA\u09EA\u09E8\u09EC\u09E9\u09E9\u09EC\u09E6\u09E6\u09E7\u09E6\u09E9\u09EA)"))), /*#__PURE__*/React.createElement(TableRow, null, /*#__PURE__*/React.createElement(TableCell, {
        colSpan: 9,
        style: {
          textAlign: "left"
        }
      }, /*#__PURE__*/React.createElement("p", {
        style: {
          margin: 0
        }
      }, "\u09AC\u09CB\u09B0\u09CD\u09A1 \u09B8\u09AD\u09BE\u0983"), /*#__PURE__*/React.createElement("p", {
        style: {
          margin: 0
        }
      }, "\u0986\u09AC\u09C7\u09A6\u09A8\u09C7\u09B0 \u09B8\u0982\u0996\u09CD\u09AF\u09BE\u0983 ", enToBn(applications.length)), /*#__PURE__*/React.createElement("p", {
        style: {
          margin: 0
        }
      }, "\u09A8\u09AE\u09BF\u09A8\u09C0/\u09AC\u09CD\u09AF\u09BE\u0982\u0995 \u09B9\u09BF\u09B8\u09BE\u09AC\u09C7\u09B0 \u09B8\u0982\u0996\u09CD\u09AF\u09BE\u0983 "), /*#__PURE__*/React.createElement("p", {
        style: {
          margin: 0
        }
      }, "\u0985\u09B0\u09CD\u09A5\u09C7\u09B0 \u09AA\u09B0\u09BF\u09AE\u09BE\u09A3\u0983 ", Number(getTotalAmount()).toLocaleString("bn-BD"), "/-")))), /*#__PURE__*/React.createElement(TableHead, null, /*#__PURE__*/React.createElement(TableRow, null, /*#__PURE__*/React.createElement(TableCell, null, "SL No"), /*#__PURE__*/React.createElement(TableCell, null, "Date"), /*#__PURE__*/React.createElement(TableCell, null, "Sender A/C No"), /*#__PURE__*/React.createElement(TableCell, null, "Receiver's Routing Number"), /*#__PURE__*/React.createElement(TableCell, null, "Sender's Routing Number"), /*#__PURE__*/React.createElement(TableCell, null, "Account Name"), /*#__PURE__*/React.createElement(TableCell, null, "Account No"), /*#__PURE__*/React.createElement(TableCell, null, "Factory Name"), /*#__PURE__*/React.createElement(TableCell, {
        align: "right"
      }, "Approved Amount"))), /*#__PURE__*/React.createElement(TableBody, null, paymentRows.map(function (row, index) {
        var _row$date2;
        return /*#__PURE__*/React.createElement(TableRow, {
          key: "".concat(row.applicationId, "-").concat(index)
        }, /*#__PURE__*/React.createElement(TableCell, null, index + 1), /*#__PURE__*/React.createElement(TableCell, null, ((_row$date2 = row.date) === null || _row$date2 === void 0 ? void 0 : _row$date2.split("T")[0]) || ""), /*#__PURE__*/React.createElement(TableCell, null, "4426336001034"), /*#__PURE__*/React.createElement(TableCell, null, row.receiverRoutingNumber || ""), /*#__PURE__*/React.createElement(TableCell, null, "200275714"), /*#__PURE__*/React.createElement(TableCell, null, row.accountName || ""), /*#__PURE__*/React.createElement(TableCell, null, row.accountNumber || ""), /*#__PURE__*/React.createElement(TableCell, null, row.factoryName || ""), /*#__PURE__*/React.createElement(TableCell, {
          align: "right"
        }, row.amount || 0));
      }), /*#__PURE__*/React.createElement(TableRow, null, /*#__PURE__*/React.createElement(TableCell, {
        colSpan: 8
      }, /*#__PURE__*/React.createElement("strong", null, "Total Amount")), /*#__PURE__*/React.createElement(TableCell, {
        align: "right"
      }, /*#__PURE__*/React.createElement("strong", null, getTotalAmount())))))), /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement(DialogActions$1, {
        className: classes.noPrint
      }, /*#__PURE__*/React.createElement(Button, {
        onClick: onClose,
        variant: "outlined",
        color: "primary"
      }, /*#__PURE__*/React.createElement(FormattedMessage, {
        id: "workforce.modal.close"
      })), /*#__PURE__*/React.createElement(Button, {
        onClick: function onClick() {
          return window.print();
        },
        variant: "contained",
        color: "primary"
      }, /*#__PURE__*/React.createElement(FormattedMessage, {
        id: "workforce.modal.print.advice"
      })), /*#__PURE__*/React.createElement(Button, {
        onClick: exportToExcel,
        variant: "contained",
        color: "success"
      }, /*#__PURE__*/React.createElement(FormattedMessage, {
        id: "workforce.modal.excel"
      }))));
    } else if (getUserTypeFromRights(userRights) === WORKFORCE_USER_TYPE.DIRECTOR || getUserTypeFromRights(userRights) === WORKFORCE_USER_TYPE.BLWF_DIRECTOR) {
    var _applications$4;
    return /*#__PURE__*/React.createElement(Dialog$1, {
      open: open,
      onClose: onClose,
      maxWidth: "md",
      fullWidth: true
    }, /*#__PURE__*/React.createElement(DialogTitle, {
      disableTypography: true
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "h6"
    }, " ", /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.table.bftn"
    }))), /*#__PURE__*/React.createElement(DialogContent$1, {
      dividers: true
    }, ((_applications$4 = applications[0]) === null || _applications$4 === void 0 ? void 0 : _applications$4.applicationType) === "financialAssistance" ?
    /*#__PURE__*/
    /* ===== NEW BLOCK FOR FINANCIAL ASSISTANCE ===== */
    React.createElement("div", null, /*#__PURE__*/React.createElement(Typography, {
      variant: "h6"
    }, "Death grant"), /*#__PURE__*/React.createElement(Table$2, null, /*#__PURE__*/React.createElement(TableHead, null, /*#__PURE__*/React.createElement(TableRow, {
      style: {
        fontWeight: "bold"
      }
    }, /*#__PURE__*/React.createElement(TableCell, null, "Dependent Name"), /*#__PURE__*/React.createElement(TableCell, null, "Relation With Worker"), /*#__PURE__*/React.createElement(TableCell, null, "Application Type"), /*#__PURE__*/React.createElement(TableCell, {
      align: "right"
    }, "Grant Amount"), /*#__PURE__*/React.createElement(TableCell, null, "Account No"), /*#__PURE__*/React.createElement(TableCell, null, "Bank Name"), /*#__PURE__*/React.createElement(TableCell, null, "Branch"))), /*#__PURE__*/React.createElement(TableBody, null, dependentData.map(function (dep, index) {
      var _dep$bank2, _dep$bank3;
      var totalGrant = getTotalAmount() || 200000;
      var approvedAmount = (parseFloat(dep.percentageOfCfGrant) || 0) / 100 * totalGrant;
      return /*#__PURE__*/React.createElement(TableRow, {
        key: index
      }, /*#__PURE__*/React.createElement(TableCell, null, (dep === null || dep === void 0 ? void 0 : dep.nameEn) || ""), /*#__PURE__*/React.createElement(TableCell, null, RELATION_LABEL_MAP[(dep === null || dep === void 0 ? void 0 : dep.relationWithWorker) || ""]), /*#__PURE__*/React.createElement(TableCell, null, "Death grant"), /*#__PURE__*/React.createElement(TableCell, {
        align: "right"
      }, approvedAmount), /*#__PURE__*/React.createElement(TableCell, null, (dep === null || dep === void 0 ? void 0 : dep.bankAccountNo) || ""), /*#__PURE__*/React.createElement(TableCell, null, (dep === null || dep === void 0 || (_dep$bank2 = dep.bank) === null || _dep$bank2 === void 0 || (_dep$bank2 = _dep$bank2.parent) === null || _dep$bank2 === void 0 ? void 0 : _dep$bank2.nameEn) || ""), /*#__PURE__*/React.createElement(TableCell, null, (dep === null || dep === void 0 || (_dep$bank3 = dep.bank) === null || _dep$bank3 === void 0 ? void 0 : _dep$bank3.nameEn) || ""));
    }), /*#__PURE__*/React.createElement(TableRow, null, /*#__PURE__*/React.createElement(TableCell, {
      colSpan: 2
    }, /*#__PURE__*/React.createElement("strong", null, "Total Grant")), /*#__PURE__*/React.createElement(TableCell, {
      align: "right"
    }, /*#__PURE__*/React.createElement("strong", null, getTotalAmount())), /*#__PURE__*/React.createElement(TableCell, {
      colSpan: 3
    }))))) :
    /*#__PURE__*/
    /* ===== OLD BLOCK ===== */
    React.createElement(Table$2, null, /*#__PURE__*/React.createElement(TableHead, null, /*#__PURE__*/React.createElement(TableRow, {
      style: {
        fontWeight: "bold"
      }
    }, /*#__PURE__*/React.createElement(TableCell, null, "Applicant Name"), /*#__PURE__*/React.createElement(TableCell, null, "Application Type"), /*#__PURE__*/React.createElement(TableCell, {
      align: "right"
    }, "Grant Amount"), /*#__PURE__*/React.createElement(TableCell, null, "Account No"), /*#__PURE__*/React.createElement(TableCell, null, "Bank Name"), /*#__PURE__*/React.createElement(TableCell, null, "Branch"))), /*#__PURE__*/React.createElement(TableBody, null, applications.filter(function (item) {
      return item.status === status;
    }).map(function (row, index) {
      var _row$workforceEmploye, _bankInfo$bank, _bankInfo$branch2;
      var parseBankInfo = JSON.parse(row.employeeBankInfo);
      var bankInfo = JSON.parse(parseBankInfo);
      return /*#__PURE__*/React.createElement(TableRow, {
        key: index
      }, /*#__PURE__*/React.createElement(TableCell, null, (_row$workforceEmploye = row.workforceEmployee) === null || _row$workforceEmploye === void 0 ? void 0 : _row$workforceEmploye.firstNameEn), /*#__PURE__*/React.createElement(TableCell, null, row.applicationType), /*#__PURE__*/React.createElement(TableCell, {
        align: "right"
      }, row.grantAmount), /*#__PURE__*/React.createElement(TableCell, null, bankInfo.accountNumber), /*#__PURE__*/React.createElement(TableCell, null, bankInfo === null || bankInfo === void 0 || (_bankInfo$bank = bankInfo.bank) === null || _bankInfo$bank === void 0 ? void 0 : _bankInfo$bank.nameEn), /*#__PURE__*/React.createElement(TableCell, null, bankInfo === null || bankInfo === void 0 || (_bankInfo$branch2 = bankInfo.branch) === null || _bankInfo$branch2 === void 0 ? void 0 : _bankInfo$branch2.nameEn));
    }), /*#__PURE__*/React.createElement(TableRow, null, /*#__PURE__*/React.createElement(TableCell, {
      colSpan: 2
    }, /*#__PURE__*/React.createElement("strong", null, "Total Grant")), /*#__PURE__*/React.createElement(TableCell, {
      align: "right"
    }, /*#__PURE__*/React.createElement("strong", null, getTotalAmount())), /*#__PURE__*/React.createElement(TableCell, {
      colSpan: 3
    }))))), /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement(DialogActions$1, {
      className: classes.noPrint
    }, /*#__PURE__*/React.createElement(Button, {
      onClick: onClose,
      variant: "outlined",
      color: "primary"
    }, /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.table.close",
      defaultMessage: "\u09AC\u09A8\u09CD\u09A7 \u0995\u09B0\u09C1\u09A8"
    })), /*#__PURE__*/React.createElement(Button, {
      onClick: function onClick() {
        return window.print();
      },
      variant: "contained",
      color: "primary"
    }, /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.table.printAdvice"
    }))));
  }

  // Fallback for unhandled user types (e.g., MINISTER)
  return null;
};

var headersAdmin = function headersAdmin(component) {
  return ["workforce.application.tracking.number", "workforce.employee.application.applicationDate", "workforce.employee.name", "workforce.employee.application.factoryName", "workforce.employee.application.applicationType"].concat(_toConsumableArray(isEisPath() ? [] : ["workforce.employee.application.moneyAmount"]), ["workforce.employee.application.status",
  // 1️⃣ View header — always visible
  "view",
  // 2️⃣ Revert header — visible only when disableButtons !== 1
  component.props.disableButtons !== 1 && "revert",
  // 3️⃣ Reject header — visible only when disableButtons !== 1
  component.props.disableButtons !== 1 && "reject", ""]);
};
var headerDirector = function headerDirector(component) {
  return [
  //  "",
  "workforce.application.tracking.number", "workforce.employee.application.applicationDate", "workforce.employee.name", "workforce.employee.application.factoryName", "workforce.employee.application.applicationType"].concat(_toConsumableArray(isEisPath() ? [] : ["workforce.employee.application.moneyAmount"]), ["workforce.employee.application.receivedDate", "workforce.employee.application.sentDate", "workforce.employee.application.status", "", component.isShowHistory() ? "workforce.version" : ""]);
};
var headerApplicant = function headerApplicant(component) {
  return ["workforce.application.tracking.number", "workforce.employee.application.applicationDate", "workforce.employee.name"].concat(_toConsumableArray(!isBlwfPath() ? ["workforce.employee.application.factoryName"] : []), ["workforce.employee.application.serviceProviderName", "workforce.employee.application.applicationType", "workforce.employee.application.status", "view", component.isShowHistory() ? "workforce.version" : ""]);
};
var headerFactoryAdmin = function headerFactoryAdmin(component) {
  return [
  // "",
  "workforce.application.tracking.number", "workforce.employee.application.applicationDate", "workforce.employee.name", "workforce.employee.application.factoryName", "workforce.employee.application.applicationType", "workforce.employee.application.receivedDate", "workforce.employee.application.sentDate", "workforce.employee.application.status", "workforce.application.submittedBy", "view"].concat(_toConsumableArray(component.props.disableButtons !== 1 && !component.props.revertedApplication && !component.props.isDraft ? ["verify", "revert"] : []), [
  // "verify",
  // "revert",
  component.isShowHistory() ? "workforce.version" : ""]);
};
var headerChecker = function headerChecker(component) {
  var _component$props, _component$props2, _component$props3;
  return ["workforce.application.tracking.number", "workforce.employee.application.applicationDate", "workforce.employee.name", "workforce.employee.application.factoryName", "workforce.employee.application.applicationType",
  // "workforce.employee.application.moneyAmount",
  "workforce.employee.application.receivedDate", "workforce.employee.application.sentDate", "workforce.employee.application.status", "view"].concat(_toConsumableArray(component.props.disableButtons !== 1 && !(component !== null && component !== void 0 && (_component$props = component.props) !== null && _component$props !== void 0 && _component$props.forwardedApplications) && !(component !== null && component !== void 0 && (_component$props2 = component.props) !== null && _component$props2 !== void 0 && _component$props2.revertedApplication) ? ["verify", "revert"] : []), _toConsumableArray(component.props.revertedApplication && !(component !== null && component !== void 0 && (_component$props3 = component.props) !== null && _component$props3 !== void 0 && _component$props3.forwardedApplications) ? ["resend"] : []), _toConsumableArray(component.isShowHistory() ? ["workforce.version"] : []));
};
var headerCheckerTwo = function headerCheckerTwo(component) {
  return [
  // "",
  "workforce.application.tracking.number", "workforce.employee.application.applicationDate", "workforce.employee.name", "workforce.employee.application.factoryName", "workforce.employee.application.applicationType",
  // "workforce.employee.application.moneyAmount",
  "workforce.employee.application.receivedDate", "workforce.employee.application.sentDate", "workforce.employee.application.status", "view", "verify", component.isShowHistory() ? "workforce.version" : ""];
};
var headerDeputyAsstDirector = function headerDeputyAsstDirector(component) {
  return [
  // "",
  "workforce.application.tracking.number", "workforce.employee.application.applicationDate", "workforce.employee.name", "workforce.employee.application.factoryName", "workforce.employee.application.applicationType",
  // "workforce.employee.application.moneyAmount",
  "workforce.employee.application.receivedDate", "workforce.employee.application.sentDate", "workforce.employee.application.status", "view", "verify", component.isShowHistory() ? "workforce.version" : ""];
};
var headerSectionAdmin = function headerSectionAdmin(component) {
  var _component$props4, _component$props5;
  return ["workforce.application.tracking.number", "workforce.employee.application.applicationDate", "workforce.employee.name", "workforce.employee.application.factoryName", "workforce.employee.application.applicationType", "workforce.employee.application.associationType",
  // "workforce.employee.application.moneyAmount",
  "workforce.employee.application.nid", "workforce.employee.application.receivedDate", "workforce.employee.application.sentDate", "workforce.employee.application.status"].concat(_toConsumableArray(component !== null && component !== void 0 && (_component$props4 = component.props) !== null && _component$props4 !== void 0 && _component$props4.sentForVerificationApplications ? ["workforce.employee.application.sentTo"] : []), _toConsumableArray(component.isShowHistory() ? ["workforce.version"] : []), [
  // ✅ Always show "view"
  "view"], _toConsumableArray(component.props.disableButtons !== 1 && !component.props.revertedApplication && !(component !== null && component !== void 0 && (_component$props5 = component.props) !== null && _component$props5 !== void 0 && _component$props5.sentForVerificationApplications) ? ["verify", "revert", "reject"] : []), _toConsumableArray(component.props.revertedApplication ? ["resend"] : []));
};
var headerSectionTwoAdmin = function headerSectionTwoAdmin(component) {
  return ["workforce.application.tracking.number", "workforce.employee.application.applicationDate", "workforce.employee.name", "workforce.employee.application.factoryName", "workforce.employee.application.applicationType",
  // "workforce.employee.application.moneyAmount",
  "workforce.employee.application.nid", "workforce.employee.application.receivedDate", "workforce.employee.application.sentDate", "workforce.employee.application.status"].concat(_toConsumableArray(component.isShowHistory() ? ["workforce.version"] : []), [
  // ✅ Always show "view"
  "view"], _toConsumableArray(component.props.disableButtons !== 1 && !component.props.revertedApplication ? ["verify", "revert", "reject"] : []), _toConsumableArray(component.props.disableButtons !== 1 && component.props.revertedApplication ? ["resend"] : []));
};
var headerBlwfSectionAdmin = function headerBlwfSectionAdmin(component) {
  return ["workforce.application.tracking.number", "workforce.employee.application.applicationDate", "workforce.employee.name", "workforce.employee.application.applicationType"].concat(_toConsumableArray(isEisPath() ? [] : ["workforce.employee.application.moneyAmount"]), ["workforce.employee.application.nid", "workforce.employee.application.receivedDate", "workforce.employee.application.sentDate", "workforce.employee.application.status"], _toConsumableArray(component.isShowHistory() ? ["workforce.version"] : []), [
  // ✅ Always show "view"
  "view"], _toConsumableArray(component.props.disableButtons !== 1 && !component.props.revertedApplication ? ["verify", "revert", "reject"] : []), _toConsumableArray(component.props.disableButtons !== 1 && component.props.revertedApplication ? ["resend"] : []));
};
var headerDoctor = function headerDoctor(component) {
  return ["workforce.application.tracking.number", "workforce.employee.application.applicationDate", "workforce.employee.name", "workforce.employee.application.factoryName", "workforce.employee.application.applicationType"].concat(_toConsumableArray(isEisPath() ? [] : ["workforce.employee.application.moneyAmount"]), ["workforce.employee.application.receivedDate", "workforce.employee.application.sentDate", "workforce.employee.application.status"], _toConsumableArray(component.isShowHistory() ? ["workforce.version"] : []), [
  // ✅ Always show "view"
  "view"], _toConsumableArray(component.props.disableButtons !== 1 && !component.props.revertedApplication ? ["verify"] : []), _toConsumableArray(component.props.disableButtons !== 1 && !component.props.revertedApplication && !isEisPath() ? ["approve"] : []), _toConsumableArray(component.props.disableButtons !== 1 && !component.props.revertedApplication && !isEisPath() ? ["revert"] : []), _toConsumableArray(component.props.disableButtons !== 1 && component.props.revertedApplication ? ["resend"] : []));
};
var headerAssociation = function headerAssociation(component) {
  var _component$props6, _component$props7;
  return ["workforce.application.tracking.number", "workforce.employee.application.applicationDate", "workforce.employee.name", "workforce.employee.application.factoryName", "workforce.employee.application.applicationType", "workforce.employee.application.receivedDate", "workforce.employee.application.sentDate", "workforce.employee.application.organizationType", "workforce.employee.application.status", "view"].concat(_toConsumableArray(component.props.disableButtons !== 1 && !component.props.revertedApplication && !(component !== null && component !== void 0 && (_component$props6 = component.props) !== null && _component$props6 !== void 0 && _component$props6.forwardedApplications) ? ["verify", "revert"] : []), _toConsumableArray(component.props.disableButtons !== 1 && component.props.revertedApplication && !(component !== null && component !== void 0 && (_component$props7 = component.props) !== null && _component$props7 !== void 0 && _component$props7.forwardedApplications) ? ["resend"] : []), _toConsumableArray(component.isShowHistory() ? ["workforce.version"] : []));
};
var headerApprover = function headerApprover(component) {
  return [
  //  "",
  "workforce.application.tracking.number", "workforce.employee.application.applicationDate", "workforce.employee.name", "workforce.employee.application.applicationType"].concat(_toConsumableArray(isEisPath() ? [] : ["workforce.employee.application.moneyAmount"]), ["workforce.employee.application.receivedDate", "workforce.employee.application.sentDate", "workforce.employee.application.status",
  // ...(component?.props?.summaryId ?  ["workforce.compensation.remarks"]:[]),
  component.isShowHistory() ? "workforce.version" : ""]);
};

function cacheFilters(key, filters) {
  return function (dispatch) {
    dispatch({
      type: "CORE_CACHE_FILTER",
      payload: _defineProperty({}, key, filters)
    });
  };
}
function resetCacheFilters(key) {
  return function (dispatch) {
    dispatch({
      type: "CORE_CACHE_FILTER_RESET",
      payload: key
    });
  };
}
function saveCurrentPaginationPage(page, afterCursor, beforeCursor, module) {
  return function (dispatch) {
    dispatch({
      type: "CORE_PAGINATION_PAGE",
      payload: {
        page: page,
        afterCursor: afterCursor,
        beforeCursor: beforeCursor,
        module: module
      }
    });
  };
}

var ColoredRowLegends = function ColoredRowLegends() {
  var userType = getUserType();
  var locale = useSelector(function (state) {
    var _state$core$user$i_us, _state$core;
    return (_state$core$user$i_us = (_state$core = state.core) === null || _state$core === void 0 || (_state$core = _state$core.user) === null || _state$core === void 0 || (_state$core = _state$core.i_user) === null || _state$core === void 0 ? void 0 : _state$core.language) !== null && _state$core$user$i_us !== void 0 ? _state$core$user$i_us : "en";
  });
  // প্রতিটি শতাংশের সঙ্গে টেক্সট মেপ করছি
  var legends = userType === WORKFORCE_USER_TYPE.EIS_COMMITTEE ? [{
    percent: 0,
    label: locale === "fr" ? "সম্প্রতি প্রাপ্ত" : "Recently Received"
  }, {
    percent: 20,
    label: locale === "fr" ? "অনুমোদিত" : "Approved"
  }, {
    percent: 40,
    label: locale === "fr" ? "পুন নিরীক্ষণ" : "Review"
  }, {
    percent: 60,
    label: locale === "fr" ? "রিজেক্টেড" : "Rejected"
  }] : [{
    percent: 0,
    label: locale === "fr" ? "সম্প্রতি প্রাপ্ত" : "Recently Received"
  }, {
    percent: 20,
    label: locale === "fr" ? "পর্যাপ্ত সময়" : "Sufficient Time"
  }, {
    percent: 40,
    label: locale === "fr" ? "জরুরী" : "Urgent"
  }, {
    percent: 60,
    label: locale === "fr" ? "অগ্রাধিকার" : "Priority"
  }, {
    percent: 80,
    label: locale === "fr" ? "সর্বোচ্চ অগ্রাধিকার" : "Highest Priority"
  }, {
    percent: 100,
    label: locale === "fr" ? "সময় শেষ" : "Time Expired"
  }];
  return /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      alignItems: "center",
      flexWrap: "wrap",
      gap: "18px",
      margin: "10px 0"
    }
  }, legends.map(function (item, index) {
    return /*#__PURE__*/React.createElement("div", {
      key: index,
      style: {
        display: "flex",
        alignItems: "center",
        gap: "8px",
        fontSize: "14px"
      }
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        width: "20px",
        height: "20px",
        backgroundColor: colorCode[item.percent],
        borderRadius: "4px",
        border: "1px solid #ccc"
      }
    }), /*#__PURE__*/React.createElement("span", null, item.label));
  }));
};

var styles$j = function styles(theme) {
  return {
    table: theme.table,
    tableTitle: theme.table.title,
    tableHeader: {
      paddingTop: "10px",
      paddingBottom: "10px",
      fontWeight: "bold"
    },
    tableRow: {
      backgroundColor: "#edf6f6"
    },
    tableLockedRow: theme.table.lockedRow,
    tableLockedCell: theme.table.lockedCell,
    tableHighlightedRow: theme.table.highlightedRow,
    tableHighlightedCell: theme.table.highlightedCell,
    tableHighlightedAltRow: theme.table.highlightedAltRow,
    tableSecondaryHighlightedRow: theme.table.secondaryHighlightedRow,
    tableSecondaryHighlightedCell: theme.table.secondaryHighlightedCell,
    tableHighlightedAltCell: theme.table.highlightedAltCell,
    tableDisabledRow: theme.table.disabledRow,
    tableDisabledCell: theme.table.disabledCell,
    tableFooter: theme.table.footer,
    pager: theme.table.pager,
    left: {
      textAlign: "left"
    },
    right: {
      textAlign: "right"
    },
    center: {
      textAlign: "center"
    },
    clickable: {
      cursor: "pointer"
    },
    loader: {
      position: "absolute",
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
      background: "rgba(0, 0, 0, 0.12)"
    }
  };
};
function Table(_ref) {
  var modulesManager = _ref.modulesManager,
    classes = _ref.classes,
    module = _ref.module,
    header = _ref.header,
    preHeaders = _ref.preHeaders,
    headers = _ref.headers,
    _ref$aligns = _ref.aligns,
    aligns = _ref$aligns === void 0 ? [] : _ref$aligns,
    _ref$headerSpans = _ref.headerSpans,
    headerSpans = _ref$headerSpans === void 0 ? [] : _ref$headerSpans,
    _ref$headerActions = _ref.headerActions,
    headerActions = _ref$headerActions === void 0 ? [] : _ref$headerActions,
    _ref$colSpans = _ref.colSpans,
    colSpans = _ref$colSpans === void 0 ? [] : _ref$colSpans,
    _ref$items = _ref.items,
    items = _ref$items === void 0 ? [] : _ref$items,
    _ref$itemFormatters = _ref.itemFormatters,
    itemFormatters = _ref$itemFormatters === void 0 ? [] : _ref$itemFormatters,
    _ref$rowHighlighted = _ref.rowHighlighted,
    rowHighlighted = _ref$rowHighlighted === void 0 ? null : _ref$rowHighlighted,
    _ref$rowHighlightedAl = _ref.rowHighlightedAlt,
    rowHighlightedAlt = _ref$rowHighlightedAl === void 0 ? null : _ref$rowHighlightedAl,
    _ref$rowSecondaryHigh = _ref.rowSecondaryHighlighted,
    rowSecondaryHighlighted = _ref$rowSecondaryHigh === void 0 ? null : _ref$rowSecondaryHigh,
    _ref$rowDisabled = _ref.rowDisabled,
    rowDisabled = _ref$rowDisabled === void 0 ? null : _ref$rowDisabled,
    _ref$rowLocked = _ref.rowLocked,
    rowLocked = _ref$rowLocked === void 0 ? null : _ref$rowLocked,
    _ref$withPagination = _ref.withPagination,
    withPagination = _ref$withPagination === void 0 ? false : _ref$withPagination,
    _ref$page = _ref.page,
    page = _ref$page === void 0 ? 0 : _ref$page,
    pageSize = _ref.pageSize,
    count = _ref.count,
    size = _ref.size,
    _ref$rowsPerPageOptio = _ref.rowsPerPageOptions,
    rowsPerPageOptions = _ref$rowsPerPageOptio === void 0 ? [10, 20, 50] : _ref$rowsPerPageOptio,
    onChangeRowsPerPage = _ref.onChangeRowsPerPage,
    onChangePage = _ref.onChangePage,
    onDoubleClick = _ref.onDoubleClick,
    _ref$onDelete = _ref.onDelete,
    onDelete = _ref$onDelete === void 0 ? null : _ref$onDelete,
    _ref$fetching = _ref.fetching,
    fetching = _ref$fetching === void 0 ? null : _ref$fetching,
    _ref$error = _ref.error,
    error = _ref$error === void 0 ? null : _ref$error,
    _ref$showOrdinalNumbe = _ref.showOrdinalNumber,
    showOrdinalNumber = _ref$showOrdinalNumbe === void 0 ? false : _ref$showOrdinalNumbe,
    extendHeader = _ref.extendHeader,
    _ref$disableDeleteOnE = _ref.disableDeleteOnEmptyRow,
    disableDeleteOnEmptyRow = _ref$disableDeleteOnE === void 0 ? false : _ref$disableDeleteOnE,
    _ref$selectWithCheckb = _ref.selectWithCheckbox,
    selectWithCheckbox = _ref$selectWithCheckb === void 0 ? false : _ref$selectWithCheckb,
    _ref$withSelection = _ref.withSelection,
    withSelection = _ref$withSelection === void 0 ? false : _ref$withSelection,
    itemIdentifierProp = _ref.itemIdentifier,
    selectAllSignal = _ref.selectAll,
    clearAllSignal = _ref.clearAll,
    _ref$selection = _ref.selection,
    initialSelection = _ref$selection === void 0 ? [] : _ref$selection,
    onChangeSelection = _ref.onChangeSelection,
    onChangeSelectionIds = _ref.onChangeSelectionIds,
    _ref$coloredRow = _ref.coloredRow,
    coloredRow = _ref$coloredRow === void 0 ? false : _ref$coloredRow;
  var _useTranslations = useTranslations("workforce" ),
    formatMessage = _useTranslations.formatMessage,
    formatMessageWithValues = _useTranslations.formatMessageWithValues;
  var loggedInUserId = useSelector(function (state) {
    var _state$core;
    return (_state$core = state.core) === null || _state$core === void 0 || (_state$core = _state$core.user) === null || _state$core === void 0 || (_state$core = _state$core.i_user) === null || _state$core === void 0 ? void 0 : _state$core.id;
  });

  // Use selection from props directly instead of maintaining separate state
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    ordinalNumberFrom = _useState2[0],
    setOrdinalNumberFrom = _useState2[1];
  var prevSelectAllRef = useRef(selectAllSignal);
  var prevClearAllRef = useRef(clearAllSignal);

  // Normalize itemIdentifierProp to accept (item, idx)
  var itemIdentifier = useCallback(function (item, idx) {
    var _ref2, _ref3, _ref4, _item$uuid;
    if (typeof itemIdentifierProp === "function") return itemIdentifierProp(item, idx);
    return (_ref2 = (_ref3 = (_ref4 = (_item$uuid = item === null || item === void 0 ? void 0 : item.uuid) !== null && _item$uuid !== void 0 ? _item$uuid : item === null || item === void 0 ? void 0 : item.id) !== null && _ref4 !== void 0 ? _ref4 : item === null || item === void 0 ? void 0 : item.code) !== null && _ref3 !== void 0 ? _ref3 : item === null || item === void 0 ? void 0 : item.nid) !== null && _ref2 !== void 0 ? _ref2 : "idx-".concat(idx);
  }, [itemIdentifierProp]);

  // Convert array to map for O(1) lookups
  var selectionMap = useMemo(function () {
    if (!Array.isArray(initialSelection)) return {};
    return (initialSelection || []).reduce(function (m, it, idx) {
      var id = itemIdentifier(it, idx);
      m[id] = it;
      return m;
    }, {});
  }, [initialSelection, itemIdentifier]);
  useCallback(function (arr) {
    return (arr || []).reduce(function (m, it, idx) {
      m[itemIdentifier(it, idx)] = it;
      return m;
    }, {});
  }, [itemIdentifier]);

  // Normalize selection mode:
  // - false => no selection
  // - "multiple" => multi-selection (checkboxes)
  // - "single" => single-selection (row click)
  var selectionMode = useMemo(function () {
    if (!withSelection) return false;
    if (withSelection === "multiple") return "multiple";
    // if user passed boolean true and uses checkboxes -> treat as multiple
    if (withSelection === true && selectWithCheckbox) return "multiple";
    // boolean true + no checkbox => single selection
    if (withSelection === true) return "single";
    // any other truthy value -> single
    return "single";
  }, [withSelection, selectWithCheckbox]);

  // Handle selectAll signal (merge page items)
  useEffect(function () {
    if (!selectionMode) return;
    if (prevSelectAllRef.current !== selectAllSignal && selectAllSignal > 0) {
      var currentSelectionArray = Array.isArray(initialSelection) ? initialSelection : [];
      var merged = [].concat(_toConsumableArray(currentSelectionArray), _toConsumableArray(items.filter(function (item) {
        return !currentSelectionArray.find(function (selected) {
          return itemIdentifier(selected) === itemIdentifier(item);
        });
      })));
      onChangeSelection === null || onChangeSelection === void 0 || onChangeSelection(merged);
      onChangeSelectionIds === null || onChangeSelectionIds === void 0 || onChangeSelectionIds(merged.map(function (item) {
        return itemIdentifier(item);
      }));
      prevSelectAllRef.current = selectAllSignal;
    }
  }, [selectAllSignal, selectionMode, items, initialSelection, itemIdentifier, onChangeSelection, onChangeSelectionIds]);

  // Handle clearAll signal
  useEffect(function () {
    if (!selectionMode) return;
    if (prevClearAllRef.current !== clearAllSignal && clearAllSignal > 0) {
      onChangeSelection === null || onChangeSelection === void 0 || onChangeSelection([]);
      onChangeSelectionIds === null || onChangeSelectionIds === void 0 || onChangeSelectionIds([]);
      prevClearAllRef.current = clearAllSignal;
    }
  }, [clearAllSignal, selectionMode, onChangeSelection, onChangeSelectionIds]);
  var isSelected = useCallback(function (item, idx) {
    if (!selectionMode) return false;
    var id = itemIdentifier(item, idx);
    return !!selectionMap[id];
  }, [selectionMap, selectionMode, itemIdentifier]);
  var select = useCallback(function (item, idx) {
    if (!selectionMode || !onChangeSelection) return;
    var currentSelection = Array.isArray(initialSelection) ? _toConsumableArray(initialSelection) : [];
    var id = itemIdentifier(item, idx);
    var existingIndex = currentSelection.findIndex(function (selected) {
      return itemIdentifier(selected) === id;
    });
    var newSelection;
    if (existingIndex >= 0) {
      // Item is selected, remove it
      newSelection = currentSelection.filter(function (_, index) {
        return index !== existingIndex;
      });
    } else if (selectionMode === "multiple") {
      // Add item to selection
      newSelection = [].concat(_toConsumableArray(currentSelection), [item]);
    } else {
      // Single selection: replace
      newSelection = [item];
    }
    onChangeSelection(newSelection);
    onChangeSelectionIds === null || onChangeSelectionIds === void 0 || onChangeSelectionIds(newSelection.map(function (it) {
      return itemIdentifier(it);
    }));
  }, [selectionMode, itemIdentifier, onChangeSelection, onChangeSelectionIds, initialSelection]);
  var toggleSelectAllOnPage = useCallback(function () {
    if (!selectionMode || !onChangeSelection) return;
    var currentSelection = Array.isArray(initialSelection) ? _toConsumableArray(initialSelection) : [];
    var pageIds = items.map(function (item) {
      return itemIdentifier(item);
    });
    var allOnPageSelected = items.length > 0 && items.every(function (item) {
      return currentSelection.find(function (selected) {
        return itemIdentifier(selected) === itemIdentifier(item);
      });
    });
    var newSelection;
    if (allOnPageSelected) {
      // Remove all page items from selection
      newSelection = currentSelection.filter(function (selected) {
        return !pageIds.includes(itemIdentifier(selected));
      });
    } else {
      // Add all page items to selection (avoid duplicates)
      var itemsToAdd = items.filter(function (item) {
        return !currentSelection.find(function (selected) {
          return itemIdentifier(selected) === itemIdentifier(item);
        });
      });
      newSelection = [].concat(_toConsumableArray(currentSelection), _toConsumableArray(itemsToAdd));
    }
    onChangeSelection(newSelection);
    onChangeSelectionIds === null || onChangeSelectionIds === void 0 || onChangeSelectionIds(newSelection.map(function (item) {
      return itemIdentifier(item);
    }));
  }, [selectionMode, items, initialSelection, itemIdentifier, onChangeSelection, onChangeSelectionIds]);
  var _useMemo = useMemo(function () {
      if (!Array.isArray(initialSelection)) {
        return {
          selectedOnPageCount: 0,
          allOnPageSelected: false
        };
      }
      var selectedCount = items.reduce(function (acc, item) {
        var isItemSelected = initialSelection.find(function (selected) {
          return itemIdentifier(selected) === itemIdentifier(item);
        });
        return acc + (isItemSelected ? 1 : 0);
      }, 0);
      return {
        selectedOnPageCount: selectedCount,
        allOnPageSelected: items.length > 0 && selectedCount === items.length
      };
    }, [items, initialSelection, itemIdentifier]),
    selectedOnPageCount = _useMemo.selectedOnPageCount,
    allOnPageSelected = _useMemo.allOnPageSelected;
  var headerAction = function headerAction(a) {
    return /*#__PURE__*/React.createElement(Box$1, {
      flexGrow: 1
    }, /*#__PURE__*/React.createElement(Box$1, {
      display: "flex",
      justifyContent: "flex-end"
    }, a === null || a === void 0 ? void 0 : a()));
  };
  var calculateOrdinalNumber = useCallback(function (iidx, isPaginationEnabled) {
    if (isPaginationEnabled) {
      var from = Number(ordinalNumberFrom);
      return (isNaN(from) ? 0 : from) + iidx;
    }
    return iidx + 1;
  }, [ordinalNumberFrom]);
  var _useMemo2 = useMemo(function () {
      var _headers = headers ? _toConsumableArray(headers) : [];
      var _preHeaders = preHeaders ? _toConsumableArray(preHeaders) : null;
      var _formatters = itemFormatters ? _toConsumableArray(itemFormatters) : [];
      var _aligns = aligns ? _toConsumableArray(aligns) : [];
      var _hSpans = headerSpans ? _toConsumableArray(headerSpans) : [];
      var _hActions = headerActions ? _toConsumableArray(headerActions) : [];
      var _cSpans = colSpans ? _toConsumableArray(colSpans) : [];
      var i = _headers.length;
      while (i--) {
        if (modulesManager !== null && modulesManager !== void 0 && modulesManager.hideField(module, _headers[i])) {
          if (_preHeaders) _preHeaders.splice(i, 1);
          if (_aligns && _aligns.length > i) _aligns.splice(i, 1);
          if (_hSpans && _hSpans.length > i) _hSpans.splice(i, 1);
          if (_hActions && _hActions.length > i) _hActions.splice(i, 1);
          if (_cSpans && _cSpans.length > i) _cSpans.splice(i, 1);
          _headers.splice(i, 1);
          _formatters.splice(i, 1);
        }
      }
      if (!!onDelete) {
        if (_preHeaders) _preHeaders.push("");
        _headers.push("");
        _formatters.push(function (row, idx) {
          var isEmpty = disableDeleteOnEmptyRow ? _.isEmpty(row) : false;
          return /*#__PURE__*/React.createElement(IconButton, {
            disabled: isEmpty,
            onClick: function onClick() {
              return onDelete(idx);
            }
          }, /*#__PURE__*/React.createElement(DeleteIcon, null));
        });
      }
      return {
        localHeaders: _headers,
        localPreHeaders: _preHeaders,
        localItemFormatters: _formatters,
        localAligns: _aligns,
        localHeaderSpans: _hSpans,
        localHeaderActions: _hActions,
        localColSpans: _cSpans
      };
    }, [headers, preHeaders, itemFormatters, aligns, headerSpans, headerActions, colSpans, modulesManager, module, onDelete, disableDeleteOnEmptyRow]),
    localHeaders = _useMemo2.localHeaders,
    localPreHeaders = _useMemo2.localPreHeaders,
    localItemFormatters = _useMemo2.localItemFormatters,
    localAligns = _useMemo2.localAligns,
    localHeaderSpans = _useMemo2.localHeaderSpans,
    localHeaderActions = _useMemo2.localHeaderActions,
    localColSpans = _useMemo2.localColSpans;
  var rowsPerPage = pageSize || rowsPerPageOptions[0];
  var finalHeaders = useMemo(function () {
    var arr = _toConsumableArray(localHeaders);
    if (showOrdinalNumber) arr.unshift("core.Table.ordinalNumberHeader");
    return arr;
  }, [localHeaders, showOrdinalNumber]);

  // compute footer colSpan more accurately
  var totalColumns = useMemo(function () {
    var base = localItemFormatters.length;
    var checkboxCol = selectWithCheckbox && selectionMode === "multiple" ? 1 : 0;
    var ordinalCol = showOrdinalNumber ? 1 : 0;
    return base + checkboxCol + ordinalCol;
  }, [localItemFormatters.length, selectWithCheckbox, selectionMode, showOrdinalNumber]);
  var user_type = getUserType();
  items.forEach(function (item) {
    if (item !== null && item !== void 0 && item.trackingNumber && item !== null && item !== void 0 && item.dateUpdated) {
      var currentDate = new Date();
      var updatedDate = new Date(item === null || item === void 0 ? void 0 : item.dateUpdated);
      var timeDiff = currentDate.getTime() - updatedDate.getTime();
      var dayCount = Math.floor(timeDiff / (1000 * 3600 * 24));
      var duePercentage = dayCount * 100 / roleMaxDayCount[user_type];
      item.dueDayCount = dayCount;
      if (user_type === WORKFORCE_USER_TYPE.EIS_COMMITTEE) {
        var _safeParse, _safeParse2;
        var isApproved = (_safeParse = safeParse(item === null || item === void 0 ? void 0 : item.eisApprovedByIds)) === null || _safeParse === void 0 ? void 0 : _safeParse.includes(loggedInUserId);
        var isRejected = (_safeParse2 = safeParse(item === null || item === void 0 ? void 0 : item.rejectedIds)) === null || _safeParse2 === void 0 ? void 0 : _safeParse2.includes(loggedInUserId);
        if (isApproved) {
          item.rowColorCode = colorCode[20];
        } else if (isRejected) {
          item.rowColorCode = colorCode[60];
        } else if ((item === null || item === void 0 ? void 0 : item.status) === "revert") {
          item.rowColorCode = colorCode[40];
        } else if (duePercentage >= 0 && duePercentage <= 20) {
          item.rowColorCode = colorCode[0];
        } else if (duePercentage > 20 && duePercentage <= 40) {
          item.rowColorCode = colorCode[20];
        } else if (duePercentage > 40 && duePercentage <= 60) {
          item.rowColorCode = colorCode[40];
        } else if (duePercentage > 60 && duePercentage <= 80) {
          item.rowColorCode = colorCode[60];
        } else if (duePercentage > 80 && duePercentage <= 100) {
          item.rowColorCode = colorCode[80];
        } else if (duePercentage > 100) {
          item.rowColorCode = colorCode[100];
        }
      } else {
        if (duePercentage >= 0 && duePercentage <= 20) {
          item.rowColorCode = colorCode[0];
        } else if (duePercentage > 20 && duePercentage <= 40) {
          item.rowColorCode = colorCode[20];
        } else if (duePercentage > 40 && duePercentage <= 60) {
          item.rowColorCode = colorCode[40];
        } else if (duePercentage > 60 && duePercentage <= 80) {
          item.rowColorCode = colorCode[60];
        } else if (duePercentage > 80 && duePercentage <= 100) {
          item.rowColorCode = colorCode[80];
        } else if (duePercentage > 100) {
          item.rowColorCode = colorCode[100];
        }
      }
    }
  });
  return /*#__PURE__*/React.createElement(Box$1, {
    position: "relative",
    overflow: "auto"
  }, coloredRow ? /*#__PURE__*/React.createElement("div", {
    style: {
      marginLeft: '10px'
    }
  }, /*#__PURE__*/React.createElement(ColoredRowLegends, null)) : null, header && /*#__PURE__*/React.createElement(Grid, {
    container: true,
    alignItems: "center",
    justify: "space-between",
    className: classes.tableTitle
  }, extendHeader ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6"
  }, header)), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    container: true,
    direction: "row",
    alignItems: "center",
    justify: "space-between",
    xs: 6
  }, extendHeader && extendHeader())) : /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6"
  }, header))), /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement(Table$2, {
    className: classes.table,
    size: size
  }, !!localPreHeaders && localPreHeaders.length > 0 && /*#__PURE__*/React.createElement(TableHead, null, /*#__PURE__*/React.createElement(TableRow, null, localPreHeaders.map(function (h, idx) {
    if (localHeaderSpans.length > idx && !localHeaderSpans[idx]) return null;
    return /*#__PURE__*/React.createElement(TableCell, {
      key: "preh-".concat(idx),
      colSpan: localHeaderSpans.length > idx ? localHeaderSpans[idx] : 1,
      className: clsx(classes.tableHeader, localAligns.length > idx && classes[localAligns[idx]])
    }, !!h && h);
  }))), !!finalHeaders && finalHeaders.length > 0 && /*#__PURE__*/React.createElement(TableHead, {
    style: {
      backgroundColor: "#d7eceb"
    }
  }, /*#__PURE__*/React.createElement(TableRow, null, selectWithCheckbox && selectionMode === "multiple" && /*#__PURE__*/React.createElement(TableCell, {
    padding: "checkbox"
  }, /*#__PURE__*/React.createElement(Checkbox, {
    color: "primary",
    indeterminate: selectedOnPageCount > 0 && !allOnPageSelected,
    checked: allOnPageSelected,
    onChange: toggleSelectAllOnPage
  })), finalHeaders.map(function (h, idx) {
    if (localHeaderSpans.length > idx && !localHeaderSpans[idx]) return null;
    return /*#__PURE__*/React.createElement(TableCell, {
      colSpan: localHeaderSpans.length > idx ? localHeaderSpans[idx] : 1,
      key: "h-".concat(idx)
    }, !!h && /*#__PURE__*/React.createElement(Box$1, {
      style: {
        width: "100%",
        cursor: localHeaderActions.length > idx && !!localHeaderActions[idx][0] ? "pointer" : ""
      },
      onClick: localHeaderActions.length > idx ? localHeaderActions[idx][0] : null,
      display: "flex",
      className: classes.tableHeader,
      alignItems: "center",
      justifyContent: localAligns.length > idx ? localAligns[idx] : "left"
    }, /*#__PURE__*/React.createElement(Box$1, null, typeof h === "function" ? /*#__PURE__*/React.createElement(Box$1, null, h({
      state: {
        selection: selectionMap,
        ordinalNumberFrom: ordinalNumberFrom
      },
      props: {}
    })) : /*#__PURE__*/React.createElement(FormattedMessage, {
      module: module,
      id: h
    })), localHeaderActions.length > idx ? headerAction(localHeaderActions[idx][1]) : null));
  }))), /*#__PURE__*/React.createElement(TableBody, null, items && items.length > 0 && items.map(function (row, iidx) {
    return /*#__PURE__*/React.createElement(TableRow, {
      key: iidx,
      selected: isSelected(row, iidx),
      onClick: function onClick() {
        return !selectWithCheckbox && select(row, iidx);
      },
      onContextMenu: onDoubleClick ? function () {
        return onDoubleClick(row, true);
      } : undefined,
      onDoubleClick: onDoubleClick ? function () {
        return onDoubleClick(row);
      } : undefined,
      className: clsx(classes.tableRow, !!rowLocked && rowLocked(row) ? classes.tableLockedRow : null, !!rowHighlighted && rowHighlighted(row) ? classes.tableHighlightedRow : null, !!rowHighlightedAlt && rowHighlightedAlt(row) ? classes.tableHighlightedAltRow : null, !!rowSecondaryHighlighted && rowSecondaryHighlighted(row) ? classes.tableSecondaryHighlightedRow : null, !!rowDisabled && rowDisabled(row) ? classes.tableDisabledRow : null, !!onDoubleClick && classes.clickable),
      style: coloredRow && row !== null && row !== void 0 && row.rowColorCode ? {
        backgroundColor: row.rowColorCode
      } : null
    }, selectWithCheckbox && selectionMode === "multiple" && /*#__PURE__*/React.createElement(TableCell, {
      padding: "checkbox"
    }, /*#__PURE__*/React.createElement(Checkbox, {
      checked: isSelected(row, iidx),
      onChange: function onChange() {
        return select(row, iidx);
      },
      color: "primary"
    })), showOrdinalNumber && /*#__PURE__*/React.createElement(TableCell, {
      className: clsx(!!rowLocked && rowLocked(row) ? classes.tableLockedCell : null, !!rowHighlighted && rowHighlighted(row) ? classes.tableHighlightedCell : null, !!rowHighlightedAlt && rowHighlightedAlt(row) ? classes.tableHighlightedAltCell : null, !!rowSecondaryHighlighted && rowSecondaryHighlighted(row) ? classes.tableSecondaryHighlightedCell : null, !!rowDisabled && rowDisabled(row) ? classes.tableDisabledCell : null, localAligns.length > 0 && classes[localAligns[0]]),
      key: "v-".concat(calculateOrdinalNumber(iidx, withPagination), "-0")
    }, /*#__PURE__*/React.createElement("span", null, calculateOrdinalNumber(iidx, withPagination))), localItemFormatters && localItemFormatters.map(function (f, fidx) {
      if (localColSpans.length > fidx && !localColSpans[fidx]) return null;
      if (f === null) return null;
      return /*#__PURE__*/React.createElement(TableCell, {
        colSpan: localColSpans.length > fidx ? localColSpans[fidx] : 1,
        className: clsx(!!rowLocked && rowLocked(row) ? classes.tableLockedCell : null, !!rowHighlighted && rowHighlighted(row) ? classes.tableHighlightedCell : null, !!rowHighlightedAlt && rowHighlightedAlt(row) ? classes.tableHighlightedAltCell : null, !!rowSecondaryHighlighted && rowSecondaryHighlighted(row) ? classes.tableSecondaryHighlightedCell : null, !!rowDisabled && rowDisabled(row) ? classes.tableDisabledCell : null, localAligns.length > fidx && classes[localAligns[fidx]]),
        key: "v-".concat(iidx, "-").concat(fidx)
      }, f(row, iidx));
    }));
  })), !!withPagination && !!count && /*#__PURE__*/React.createElement(TableFooter, {
    className: classes.tableFooter
  }, /*#__PURE__*/React.createElement(TableRow, null, /*#__PURE__*/React.createElement(TablePagination, {
    className: classes.pager,
    colSpan: totalColumns,
    labelRowsPerPage: formatMessage("rowsPerPage"),
    labelDisplayedRows: function labelDisplayedRows(_ref5) {
      var from = _ref5.from,
        to = _ref5.to,
        count = _ref5.count;
      setOrdinalNumberFrom(function (prev) {
        return prev !== from ? from : prev;
      });
      return "".concat(from, "-").concat(to, " ").concat(formatMessageWithValues("ofPages"), " ").concat(count);
    },
    count: count,
    page: page,
    rowsPerPage: rowsPerPage,
    rowsPerPageOptions: rowsPerPageOptions,
    onRowsPerPageChange: function onRowsPerPageChange(e) {
      return onChangeRowsPerPage(e.target.value);
    },
    onPageChange: onChangePage,
    nextIconButtonText: formatMessage("Table.nextPage"),
    backIconButtonText: formatMessage("Table.previousPage")
  })))), (fetching || error) && /*#__PURE__*/React.createElement(Grid, {
    className: classes.loader,
    container: true,
    justifyContent: "center",
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(ProgressOrError, {
    progress: (items === null || items === void 0 ? void 0 : items.length) && fetching,
    error: error
  })));
}
var Table$1 = withModulesManager(withTheme(withStyles(styles$j)(Table)));

function _callSuper$i(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$i() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$i() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$i = function _isNativeReflectConstruct() { return !!t; })(); }
function ownKeys$J(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$J(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$J(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$J(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// import InfoButton from "./InfoButton";

var styles$i = function styles(theme) {
  return {
    root: {
      width: "100%"
    },
    paper: _objectSpread$J(_objectSpread$J({}, theme.paper.body), {}, {
      boxShadow: "none"
    }),
    paperHeader: theme.paper.header,
    paperHeaderTitle: theme.paper.title,
    paperHeaderMessage: theme.paper.message,
    paperHeaderAction: {
      paddingInline: 5
    },
    tableHeaderAction: theme.table.headerAction,
    processing: {
      margin: theme.spacing(1)
    },
    searcherActions: {
      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(1),
      gap: theme.spacing(1),
      backgroundColor: theme.palette.background["default"],
      border: 0
    },
    tableContainer: _objectSpread$J(_objectSpread$J({}, theme.table.container), {}, {
      boxShadow: theme.shadows[2]
    }),
    infoSection: {
      display: 'flex',
      justifyContent: 'start',
      alignItems: 'center',
      gap: theme.spacing(1)
    }
  };
};
var SelectionPane = /*#__PURE__*/function (_Component) {
  function SelectionPane() {
    _classCallCheck(this, SelectionPane);
    return _callSuper$i(this, SelectionPane, arguments);
  }
  _inherits(SelectionPane, _Component);
  return _createClass(SelectionPane, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        module = _this$props.module,
        selectionMessage = _this$props.selectionMessage,
        selection = _this$props.selection;
      if (!selectionMessage || !selection || !selection.length) return null;
      return /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(FormattedMessage, {
        module: module,
        id: selectionMessage,
        values: {
          count: /*#__PURE__*/React.createElement("b", null, selection.length)
        }
      }));
    }
  }]);
}(Component);
var SelectionMenu = /*#__PURE__*/function (_Component2) {
  function SelectionMenu() {
    var _this;
    _classCallCheck(this, SelectionMenu);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper$i(this, SelectionMenu, [].concat(args));
    _defineProperty(_this, "state", {
      anchorEl: null
    });
    _defineProperty(_this, "openMenu", function (e) {
      return _this.setState({
        anchorEl: e.currentTarget
      });
    });
    _defineProperty(_this, "closeMenu", function (e) {
      return _this.setState({
        anchorEl: null
      });
    });
    _defineProperty(_this, "action", function (a) {
      _this.setState({
        anchorEl: null
      }, function (e) {
        return _this.props.triggerAction(a);
      });
    });
    _defineProperty(_this, "renderButtons", function (entries, contributionKey) {
      return /*#__PURE__*/React.createElement(Grid, {
        item: true,
        className: _this.props.classes.paperHeader
      }, /*#__PURE__*/React.createElement(Grid, {
        container: true,
        alignItems: "center",
        className: _this.props.classes.paperHeaderAction
      }, entries.map(function (i, idx) {
        return /*#__PURE__*/React.createElement(Grid, {
          key: "selectionsButtons-".concat(idx),
          item: true,
          className: _this.props.classes.paperHeaderAction
        }, /*#__PURE__*/React.createElement(Button, {
          onClick: function onClick(e) {
            return _this.action(i.action);
          }
        }, i.text));
      }), _this.props.exportable && /*#__PURE__*/React.createElement(SearcherExport, {
        selection: _this.props.selection,
        selectWithCheckbox: _this.props.selectWithCheckbox,
        filters: _this.props.filters,
        exportFetch: _this.props.exportFetch,
        additionalExportFields: _this.props.additionalExportFields,
        exportFields: _this.props.exportFields,
        exportFieldsColumns: _this.props.exportFieldsColumns,
        chooseExportableColumns: _this.props.chooseExportableColumns,
        label: _this.props.exportFieldLabel,
        chooseFileFormat: _this.props.chooseFileFormat,
        exportFileFormats: _this.props.exportFileFormats,
        exportFileFormat: _this.props.exportFileFormat,
        setExportFileFormat: _this.props.setExportFileFormat,
        downloadWithIconButton: _this.props.downloadWithIconButton,
        displayClearAllColsButton: _this.props.displayClearAllColsButton
      }), !!contributionKey && /*#__PURE__*/React.createElement(Contributions, {
        actionHandler: _this.action,
        refetch: _this.props.refetch,
        clearSelected: _this.props.clearSelected,
        withSelection: _this.props.withSelection,
        selection: _this.props.selection,
        contributionKey: contributionKey,
        downloadWithIconButton: _this.props.downloadWithIconButton
      })));
    });
    _defineProperty(_this, "renderMenu", function (entries, contributionKey) {
      return /*#__PURE__*/React.createElement(Grid, {
        item: true,
        className: _this.props.classes.paperHeader
      }, /*#__PURE__*/React.createElement(Grid, {
        container: true,
        alignItems: "center"
      }, /*#__PURE__*/React.createElement(Grid, {
        item: true,
        className: _this.props.classes.paperHeaderAction
      }, /*#__PURE__*/React.createElement(IconButton, {
        onClick: _this.openMenu
      }, /*#__PURE__*/React.createElement(MoreHoriz, null)))), /*#__PURE__*/React.createElement(Menu, {
        open: !!_this.state.anchorEl,
        anchorEl: _this.state.anchorEl,
        onClose: _this.closeMenu,
        keepMounted: true
      }, entries.map(function (i, idx) {
        return /*#__PURE__*/React.createElement(MenuItem, {
          key: "selectionsMenu-".concat(idx),
          onClick: function onClick(e) {
            return _this.action(i.action);
          }
        }, i.text);
      }), _this.props.exportable && /*#__PURE__*/React.createElement(SearcherExport, {
        selection: _this.props.selection,
        selectWithCheckbox: _this.props.selectWithCheckbox,
        filters: _this.props.filters,
        exportFetch: _this.props.exportFetch,
        exportFields: _this.props.exportFields,
        exportFieldsColumns: _this.props.exportFieldsColumns,
        chooseExportableColumns: _this.props.chooseExportableColumns,
        additionalExportFields: _this.props.additionalExportFields,
        chooseFileFormat: _this.props.chooseFileFormat,
        exportFileFormats: _this.props.exportFileFormats,
        downloadWithIconButton: _this.props.downloadWithIconButton,
        displayClearAllColsButton: _this.props.displayClearAllColsButton
      }), !!contributionKey && /*#__PURE__*/React.createElement(Contributions, {
        actionHandler: _this.action,
        selection: _this.props.selection,
        contributionKey: contributionKey
      })));
    });
    return _this;
  }
  _inherits(SelectionMenu, _Component2);
  return _createClass(SelectionMenu, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        modulesManager = _this$props2.modulesManager;
        _this$props2.intl;
        var classes = _this$props2.classes,
        canSelectAll = _this$props2.canSelectAll,
        selection = _this$props2.selection,
        clearSelected = _this$props2.clearSelected,
        selectAll = _this$props2.selectAll,
        _this$props2$actions = _this$props2.actions,
        actions = _this$props2$actions === void 0 ? [] : _this$props2$actions,
        processing = _this$props2.processing,
        _this$props2$actionsC = _this$props2.actionsContributionKey,
        actionsContributionKey = _this$props2$actionsC === void 0 ? null : _this$props2$actionsC;
      var contributed_entries = modulesManager.getContribs(actionsContributionKey);
      if (!actions.length && !contributed_entries) return null;
      if (processing) {
        return /*#__PURE__*/React.createElement(CircularProgress$1, {
          className: classes.processing,
          size: 24
        });
      }
      var entries = [];
      var selectionCount = selection.length;
      if (!!selectionCount) {
        entries.push({
          text: /*#__PURE__*/React.createElement(FormattedMessage, {
            module: "workforce",
            id: "workforce.clearSelected"
          }),
          action: clearSelected
        });
      }
      if (!!canSelectAll && canSelectAll(this.props.selection)) {
        entries.push({
          text: /*#__PURE__*/React.createElement(FormattedMessage, {
            module: "workforce",
            id: "workforce.selectAll"
          }),
          action: selectAll
        });
      }
      actions.forEach(function (a) {
        if (a.enabled(selection)) {
          entries.push({
            text: /*#__PURE__*/React.createElement(FormattedMessage, {
              module: "workforce",
              id: a.label
            }),
            action: a.action
          });
        }
      });
      if (this.props.selectWithCheckbox) {
        return this.renderButtons([], actionsContributionKey);
      }
      if (entries.length > 2 || this.props.exportable && entries.length >= 1) {
        return this.renderMenu(entries, actionsContributionKey);
      }
      return this.renderButtons(entries, actionsContributionKey);
    }
  }]);
}(Component);
var StyledSelectionMenu = withModulesManager(withTheme(withStyles(styles$i)(SelectionMenu)));
var Searcher = /*#__PURE__*/function (_Component3) {
  function Searcher(_props) {
    var _this2;
    _classCallCheck(this, Searcher);
    _this2 = _callSuper$i(this, Searcher, [_props]);
    _defineProperty(_this2, "state", {
      filters: {},
      orderBy: null,
      page: 0,
      pageSize: _this2.props.defaultPageSize || 10,
      afterCursor: null,
      beforeCursor: null,
      selection: [],
      selectAll: 0,
      clearAll: 0,
      menuAnchor: null
    });
    _defineProperty(_this2, "filtersToQueryParams", function () {
      var _this2$state = _this2.state,
        page = _this2$state.page,
        afterCursor = _this2$state.afterCursor,
        beforeCursor = _this2$state.beforeCursor;
      var _this2$props = _this2.props,
        module = _this2$props.module,
        saveCurrentPaginationPage = _this2$props.saveCurrentPaginationPage;
      saveCurrentPaginationPage(page, afterCursor, beforeCursor, module);
      if (_this2.props.filtersToQueryParams) return _this2.props.filtersToQueryParams(_this2.state);
      var prms = Object.keys(_this2.state.filters).filter(function (f) {
        return !!_this2.state.filters[f]["filter"];
      }).map(function (f) {
        return _this2.state.filters[f]["filter"];
      });
      if (!_this2.state.beforeCursor && !_this2.state.afterCursor) {
        prms.push("first: ".concat(_this2.state.pageSize));
      }
      if (!!_this2.state.afterCursor) {
        prms.push("after: \"".concat(_this2.state.afterCursor, "\""));
        prms.push("first: ".concat(_this2.state.pageSize));
      }
      if (!!_this2.state.beforeCursor) {
        prms.push("before: \"".concat(_this2.state.beforeCursor, "\""));
        prms.push("last: ".concat(_this2.state.pageSize));
      }
      if (!!_this2.state.orderBy) {
        prms.push("orderBy: [\"".concat(_this2.state.orderBy, "\"]"));
      }
      return prms;
    });
    _defineProperty(_this2, "resetFilters", function () {
      _this2.setState(function (state, props) {
        return {
          filters: _objectSpread$J({}, _this2.props.defaultFilters),
          orderBy: props.defaultOrderBy
        };
      }, function (e) {
        return _this2.applyFilters();
      });
    });
    _defineProperty(_this2, "onChangeFilters", function (fltrs) {
      var filters = _objectSpread$J({}, _this2.state.filters);
      fltrs.forEach(function (filter) {
        if (filter.value === null) {
          delete filters[filter.id];
        } else {
          filters[filter.id] = {
            value: filter.value,
            filter: filter.filter
          };
        }
      });
      _this2.setState({
        filters: filters
      });
    });
    _defineProperty(_this2, "_notifyFiltersApplied", function () {
      if (_this2.props.onFiltersApplied) {
        _this2.props.onFiltersApplied(_this2.state.filters);
      }
    });
    _defineProperty(_this2, "_cacheAndApply", function () {
      var filters = _this2.filtersToQueryParams();
      if (!!_this2.props.cacheFiltersKey) {
        var cacheKey = _this2._getCacheKey();
        _this2.props.cacheFilters(cacheKey, _this2.state.filters);
        _this2.props.fetch(filters);
      } else {
        _this2.props.fetch(filters);
      }
      _this2._notifyFiltersApplied();
    });
    _defineProperty(_this2, "applyFilters", function () {
      _this2.setState(function (state, props) {
        return {
          page: 0,
          afterCursor: null,
          beforeCursor: null,
          clearAll: state.clearAll + 1,
          selection: [] // Clear selection when applying filters
        };
      }, _this2._cacheAndApply);
    });
    _defineProperty(_this2, "deleteFilter", function (filter) {
      var fltrs = _this2.state.filters;
      delete fltrs[filter];
      _this2.setState({
        filters: fltrs,
        page: 0,
        afterCursor: null,
        beforeCursor: null
      }, _this2._cacheAndApply);
    });
    _defineProperty(_this2, "clearSelected", function (e) {
      _this2.setState(function (state, props) {
        return {
          clearAll: state.clearAll + 1,
          selection: []
        };
      });
    });
    _defineProperty(_this2, "selectAll", function (e) {
      _this2.setState({
        selectAll: _this2.state.selectAll + 1
      });
    });
    // Updated to properly handle selection changes
    _defineProperty(_this2, "onChangeSelection", function (selection) {
      _this2.setState({
        selection: Array.isArray(selection) ? selection : []
      });

      // Call the parent callback if provided
      if (_this2.props.onCheckBoxSelect) {
        _this2.props.onCheckBoxSelect(Array.isArray(selection) ? selection : []);
      }
    });
    _defineProperty(_this2, "onChangeRowsPerPage", function (cnt) {
      _this2.setState({
        pageSize: cnt,
        page: 0,
        afterCursor: null,
        beforeCursor: null
      }, function (e) {
        return _this2.props.fetch(_this2.filtersToQueryParams());
      });
    });
    _defineProperty(_this2, "onChangePage", function (page, nbr) {
      if (nbr > _this2.state.page) {
        _this2.setState(function (state, props) {
          return {
            page: state.page + 1,
            beforeCursor: null,
            afterCursor: props.itemsPageInfo.endCursor
          };
        }, function (e) {
          return _this2.props.fetch(_this2.filtersToQueryParams());
        });
      } else if (nbr < _this2.state.page) {
        _this2.setState(function (state, props) {
          return {
            page: state.page - 1,
            beforeCursor: props.itemsPageInfo.startCursor,
            afterCursor: null
          };
        }, function (e) {
          return _this2.props.fetch(_this2.filtersToQueryParams());
        });
      }
    });
    _defineProperty(_this2, "openMenu", function (event) {
      _this2.setState({
        menuAnchor: event.currentTarget
      });
    });
    _defineProperty(_this2, "closeMenu", function () {
      _this2.setState({
        menuAnchor: null
      });
    });
    _defineProperty(_this2, "triggerAction", function (a) {
      var s = _toConsumableArray(_this2.state.selection);
      _this2.setState(function (state, props) {
        return {
          selection: [],
          clearAll: state.clearAll + 1
        };
      }, function (e) {
        return a(s);
      });
    });
    _defineProperty(_this2, "headerActions", function (filters) {
      if (!!_this2.props.headerActions) return _this2.props.headerActions(filters);
      if (!!_this2.props.sorts) {
        return _this2.props.sorts(filters).map(function (s) {
          return !!s ? [function () {
            return _this2.setState(function (state, props) {
              return {
                orderBy: sort(state.orderBy, s[0], s[1])
              };
            }, function (e) {
              return _this2.props.fetch(_this2.filtersToQueryParams());
            });
          }, function () {
            return formatSorter(_this2.state.orderBy, s[0], s[1]);
          }] : [null, function () {
            return null;
          }];
        });
      }
      return [];
    });
    _defineProperty(_this2, "renderSearcherActions", function () {
      var _this2$props2 = _this2.props,
        searcherActions = _this2$props2.searcherActions,
        classes = _this2$props2.classes;
      return searcherActions.map(function (action, idx) {
        return action.authorized && /*#__PURE__*/React.createElement(Grid, {
          item: true,
          key: "searcher-action-".concat(idx)
        }, /*#__PURE__*/React.createElement(Button, {
          key: action.label,
          onClick: action.onClick,
          startIcon: action.icon,
          variant: "contained",
          color: "primary",
          className: classes.actionButton
        }, /*#__PURE__*/React.createElement(Typography, {
          variant: "body2"
        }, action.label)));
      });
    });
    _this2.fetchEnabled = _props.modulesManager.getConf("fe-core", "shouldFetchInitially", true);
    _this2.isWorker = _props.modulesManager.getConf("fe-core", "isWorker", DEFAULT.IS_WORKER);
    return _this2;
  }
  _inherits(Searcher, _Component3);
  return _createClass(Searcher, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this3 = this;
      var cacheKey = this._getCacheKey();
      var filters = this.props.filtersCache[cacheKey] || this.props.defaultFilters || {};
      this.setState(function (state, props) {
        return {
          filters: filters,
          pageSize: props.defaultPageSize || 10,
          orderBy: props.defaultOrderBy
        };
      }, function (e) {
        if (_this3.fetchEnabled) {
          _this3.applyFilters();
        }
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.props.resetFiltersOnUnmount) {
        var cacheKey = this._getCacheKey();
        this.props.resetCacheFilters(cacheKey);
        this.resetFilters();
      }
    }
  }, {
    key: "_getCacheKey",
    value: function _getCacheKey() {
      var _this$props3 = this.props,
        cachePerTab = _this$props3.cachePerTab,
        cacheTabName = _this$props3.cacheTabName,
        cacheFiltersKey = _this$props3.cacheFiltersKey;
      return cachePerTab && cacheTabName ? "".concat(cacheFiltersKey, "-").concat(cacheTabName) : cacheFiltersKey;
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;
      var _this$props4 = this.props,
        classes = _this$props4.classes,
        module = _this$props4.module,
        _this$props4$canSelec = _this$props4.canSelectAll,
        canSelectAll = _this$props4$canSelec === void 0 ? null : _this$props4$canSelec,
        _this$props4$contribu = _this$props4.contributionKey,
        contributionKey = _this$props4$contribu === void 0 ? null : _this$props4$contribu,
        FilterPane = _this$props4.FilterPane,
        FilterExt = _this$props4.FilterExt,
        _this$props4$filterPa = _this$props4.filterPaneContributionsKey,
        filterPaneContributionsKey = _this$props4$filterPa === void 0 ? null : _this$props4$filterPa,
        tableTitle = _this$props4.tableTitle,
        rowIdentifier = _this$props4.rowIdentifier,
        rowsPerPageOptions = _this$props4.rowsPerPageOptions,
        _this$props4$rowLocke = _this$props4.rowLocked,
        _rowLocked = _this$props4$rowLocke === void 0 ? function () {
          return false;
        } : _this$props4$rowLocke,
        _this$props4$rowHighl = _this$props4.rowHighlighted,
        _rowHighlighted = _this$props4$rowHighl === void 0 ? function () {
          return false;
        } : _this$props4$rowHighl,
        _this$props4$rowHighl2 = _this$props4.rowHighlightedAlt,
        _rowHighlightedAlt = _this$props4$rowHighl2 === void 0 ? function () {
          return false;
        } : _this$props4$rowHighl2,
        _this$props4$rowSecon = _this$props4.rowSecondaryHighlighted,
        _rowSecondaryHighlighted = _this$props4$rowSecon === void 0 ? function () {
          return false;
        } : _this$props4$rowSecon,
        _this$props4$rowDisab = _this$props4.rowDisabled,
        _rowDisabled = _this$props4$rowDisab === void 0 ? function () {
          return false;
        } : _this$props4$rowDisab,
        _this$props4$selectio = _this$props4.selectionMessage,
        selectionMessage = _this$props4$selectio === void 0 ? null : _this$props4$selectio,
        _this$props4$preHeade = _this$props4.preHeaders,
        preHeaders = _this$props4$preHeade === void 0 ? null : _this$props4$preHeade,
        _this$props4$headers = _this$props4.headers,
        headers = _this$props4$headers === void 0 ? null : _this$props4$headers,
        _this$props4$aligns = _this$props4.aligns,
        aligns = _this$props4$aligns === void 0 ? null : _this$props4$aligns,
        items = _this$props4.items,
        itemsPageInfo = _this$props4.itemsPageInfo,
        fetchingItems = _this$props4.fetchingItems,
        fetchedItems = _this$props4.fetchedItems,
        errorItems = _this$props4.errorItems,
        itemFormatters = _this$props4.itemFormatters,
        onDoubleClick = _this$props4.onDoubleClick,
        actions = _this$props4.actions,
        _this$props4$processi = _this$props4.processing,
        processing = _this$props4$processi === void 0 ? false : _this$props4$processi,
        _this$props4$withSele = _this$props4.withSelection,
        withSelection = _this$props4$withSele === void 0 ? null : _this$props4$withSele,
        _this$props4$actionsC = _this$props4.actionsContributionKey,
        actionsContributionKey = _this$props4$actionsC === void 0 ? null : _this$props4$actionsC,
        _this$props4$withPagi = _this$props4.withPagination,
        withPagination = _this$props4$withPagi === void 0 ? true : _this$props4$withPagi,
        _this$props4$exportab = _this$props4.exportable,
        exportable = _this$props4$exportab === void 0 ? false : _this$props4$exportab,
        _this$props4$exportFe = _this$props4.exportFetch,
        exportFetch = _this$props4$exportFe === void 0 ? null : _this$props4$exportFe,
        _this$props4$exportFi = _this$props4.exportFields,
        exportFields = _this$props4$exportFi === void 0 ? ['id'] : _this$props4$exportFi,
        exportFieldsColumns = _this$props4.exportFieldsColumns;
        _this$props4.intl;
        var _this$props4$isCustom = _this$props4.isCustomFiltering,
        isCustomFiltering = _this$props4$isCustom === void 0 ? false : _this$props4$isCustom,
        _this$props4$objectFo = _this$props4.objectForCustomFiltering,
        objectForCustomFiltering = _this$props4$objectFo === void 0 ? null : _this$props4$objectFo,
        _this$props4$addition = _this$props4.additionalCustomFilterParams,
        additionalCustomFilterParams = _this$props4$addition === void 0 ? null : _this$props4$addition,
        _this$props4$moduleNa = _this$props4.moduleName,
        moduleName = _this$props4$moduleNa === void 0 ? null : _this$props4$moduleNa,
        _this$props4$objectTy = _this$props4.objectType,
        objectType = _this$props4$objectTy === void 0 ? null : _this$props4$objectTy,
        _this$props4$appliedC = _this$props4.appliedCustomFilters,
        appliedCustomFilters = _this$props4$appliedC === void 0 ? null : _this$props4$appliedC,
        _this$props4$setAppli = _this$props4.setAppliedCustomFilters,
        setAppliedCustomFilters = _this$props4$setAppli === void 0 ? null : _this$props4$setAppli,
        _this$props4$appliedF = _this$props4.appliedFiltersRowStructure,
        appliedFiltersRowStructure = _this$props4$appliedF === void 0 ? null : _this$props4$appliedF,
        _this$props4$setAppli2 = _this$props4.setAppliedFiltersRowStructure,
        setAppliedFiltersRowStructure = _this$props4$setAppli2 === void 0 ? null : _this$props4$setAppli2,
        _this$props4$applyNum = _this$props4.applyNumberCircle,
        applyNumberCircle = _this$props4$applyNum === void 0 ? null : _this$props4$applyNum,
        _this$props4$exportFi2 = _this$props4.exportFieldLabel,
        exportFieldLabel = _this$props4$exportFi2 === void 0 ? null : _this$props4$exportFi2,
        _this$props4$showOrdi = _this$props4.showOrdinalNumber,
        showOrdinalNumber = _this$props4$showOrdi === void 0 ? false : _this$props4$showOrdi,
        _this$props4$chooseEx = _this$props4.chooseExportableColumns,
        chooseExportableColumns = _this$props4$chooseEx === void 0 ? false : _this$props4$chooseEx,
        additionalExportFields = _this$props4.additionalExportFields,
        _this$props4$chooseFi = _this$props4.chooseFileFormat,
        chooseFileFormat = _this$props4$chooseFi === void 0 ? false : _this$props4$chooseFi,
        _this$props4$exportFi3 = _this$props4.exportFileFormats,
        exportFileFormats = _this$props4$exportFi3 === void 0 ? {} : _this$props4$exportFi3,
        exportFileFormat = _this$props4.exportFileFormat,
        setExportFileFormat = _this$props4.setExportFileFormat,
        _this$props4$selectWi = _this$props4.selectWithCheckbox,
        selectWithCheckbox = _this$props4$selectWi === void 0 ? false : _this$props4$selectWi,
        _this$props4$enableAc = _this$props4.enableActionButtons,
        enableActionButtons = _this$props4$enableAc === void 0 ? false : _this$props4$enableAc;
        _this$props4.searcherActions;
        var _this$props4$download = _this$props4.downloadWithIconButton,
        downloadWithIconButton = _this$props4$download === void 0 ? false : _this$props4$download,
        displayClearAllColsButton = _this$props4.displayClearAllColsButton,
        _this$props4$infoButt = _this$props4.infoButtonContent,
        infoButtonContent = _this$props4$infoButt === void 0 ? '' : _this$props4$infoButt;
        _this$props4.onCheckBoxSelect;
        var _this$props4$searcher2 = _this$props4.searcherActionsPosition,
        searcherActionsPosition = _this$props4$searcher2 === void 0 ? 'top-right' : _this$props4$searcher2,
        _this$props4$coloredR = _this$props4.coloredRow,
        coloredRow = _this$props4$coloredR === void 0 ? false : _this$props4$coloredR;
      return /*#__PURE__*/React.createElement(Fragment, null, !!FilterPane && /*#__PURE__*/React.createElement(SearcherPane, {
        module: module,
        reset: this.resetFilters,
        refresh: this.applyFilters,
        del: this.deleteFilter,
        filters: this.state.filters,
        filterPane: /*#__PURE__*/React.createElement(FilterPane, {
          filters: this.state.filters,
          onChangeFilters: this.onChangeFilters,
          FilterExt: FilterExt,
          filterPaneContributionsKey: filterPaneContributionsKey
        }),
        isCustomFiltering: isCustomFiltering,
        objectForCustomFiltering: objectForCustomFiltering,
        additionalCustomFilterParams: additionalCustomFilterParams,
        moduleName: moduleName,
        objectType: objectType,
        setAppliedCustomFilters: setAppliedCustomFilters,
        appliedCustomFilters: appliedCustomFilters,
        onChangeFilters: this.onChangeFilters,
        appliedFiltersRowStructure: appliedFiltersRowStructure,
        setAppliedFiltersRowStructure: setAppliedFiltersRowStructure,
        applyNumberCircle: applyNumberCircle
      }), !!contributionKey && /*#__PURE__*/React.createElement(Contributions, {
        contributionKey: contributionKey
      }), /*#__PURE__*/React.createElement(Paper, {
        className: classes.paper
      }, enableActionButtons && searcherActionsPosition !== "header-right" && /*#__PURE__*/React.createElement(Grid, {
        container: true,
        justifyContent: "flex-end",
        className: classes.searcherActions
      }, this.renderSearcherActions()), /*#__PURE__*/React.createElement(Grid, {
        container: true,
        className: classes.tableContainer
      }, errorItems ? /*#__PURE__*/React.createElement(ProgressOrError, {
        error: errorItems
      }) : /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(Grid, {
        container: true,
        item: true,
        alignItems: "center",
        xs: this.isWorker ? 7 : 8,
        className: classes.paperHeader
      }, /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 8,
        className: classes.paperHeaderTitle
      }, /*#__PURE__*/React.createElement("div", {
        className: classes.infoSection
      }, infoButtonContent && /*#__PURE__*/React.createElement(InfoButton, {
        content: infoButtonContent
      }), /*#__PURE__*/React.createElement(Grid, {
        item: true
      }, !fetchingItems ? tableTitle : /*#__PURE__*/React.createElement(FormattedMessage, {
        module: "core",
        id: "core.table.resultsLoading"
      })))), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 4,
        className: classes.paperHeaderMessage
      }, /*#__PURE__*/React.createElement(SelectionPane, {
        module: module,
        selectionMessage: selectionMessage,
        selection: this.state.selection
      }))), /*#__PURE__*/React.createElement(Grid, {
        container: true,
        alignItems: "center",
        item: true,
        xs: this.isWorker ? 5 : 4,
        className: classes.paperHeader
      }, fetchedItems && /*#__PURE__*/React.createElement(Grid, {
        container: true,
        direction: "row",
        justify: "flex-end",
        className: classes.paperHeaderAction
      }, searcherActionsPosition === "header-right" && this.renderSearcherActions(), /*#__PURE__*/React.createElement(Grid, {
        item: true
      }, /*#__PURE__*/React.createElement(StyledSelectionMenu, {
        selectWithCheckbox: selectWithCheckbox,
        refetch: this.applyFilters,
        withSelection: withSelection,
        canSelectAll: canSelectAll,
        selection: this.state.selection,
        items: items,
        clearSelected: this.clearSelected,
        selectAll: this.selectAll,
        triggerAction: this.triggerAction,
        actions: actions,
        processing: processing,
        actionsContributionKey: actionsContributionKey,
        filters: this.state.filters,
        exportable: exportable,
        exportFetch: exportFetch,
        exportFields: exportFields,
        exportFieldsColumns: exportFieldsColumns,
        exportFieldLabel: exportFieldLabel,
        chooseExportableColumns: chooseExportableColumns,
        additionalExportFields: additionalExportFields,
        chooseFileFormat: chooseFileFormat,
        exportFileFormats: exportFileFormats,
        exportFileFormat: exportFileFormat,
        setExportFileFormat: setExportFileFormat,
        downloadWithIconButton: downloadWithIconButton,
        displayClearAllColsButton: displayClearAllColsButton
      })))), /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12
      }, /*#__PURE__*/React.createElement(Table$1, {
        size: "small",
        module: module,
        selectWithCheckbox: selectWithCheckbox,
        fetching: fetchingItems,
        preHeaders: !!preHeaders && preHeaders(this.state.selection),
        headers: headers(this.state.filters),
        headerActions: this.headerActions(this.state.filters),
        aligns: !!aligns && aligns(),
        itemFormatters: itemFormatters(this.state.filters),
        rowLocked: function rowLocked(i) {
          return _rowLocked(_this4.state.selection, i);
        },
        rowHighlighted: function rowHighlighted(i) {
          return _rowHighlighted(_this4.state.selection, i);
        },
        rowHighlightedAlt: function rowHighlightedAlt(i) {
          return _rowHighlightedAlt(_this4.state.selection, i);
        },
        rowSecondaryHighlighted: function rowSecondaryHighlighted(i) {
          return _rowSecondaryHighlighted(i);
        },
        rowDisabled: function rowDisabled(i) {
          return _rowDisabled(_this4.state.selection, i);
        },
        items: items,
        withPagination: withPagination,
        withSelection: withSelection,
        itemIdentifier: rowIdentifier,
        selection: this.state.selection,
        selectAll: this.state.selectAll,
        clearAll: this.state.clearAll,
        onChangeSelection: this.onChangeSelection,
        onDoubleClick: onDoubleClick,
        page: this.state.page,
        pageSize: this.state.pageSize,
        count: itemsPageInfo.totalCount,
        onChangePage: this.onChangePage,
        rowsPerPageOptions: rowsPerPageOptions,
        onChangeRowsPerPage: this.onChangeRowsPerPage,
        showOrdinalNumber: showOrdinalNumber,
        coloredRow: coloredRow
        // itemIdentifier={(item) => item.id}
      }))))));
    }
  }]);
}(Component);
var mapStateToProps$h = function mapStateToProps(state) {
  var _state$core, _state$core2, _state$core3, _state$core$isSeconda;
  return {
    filtersCache: !!state.core && state.core.filtersCache,
    paginationPage: (_state$core = state.core) === null || _state$core === void 0 || (_state$core = _state$core.savedPagination) === null || _state$core === void 0 ? void 0 : _state$core.paginationPage,
    afterCursor: (_state$core2 = state.core) === null || _state$core2 === void 0 || (_state$core2 = _state$core2.savedPagination) === null || _state$core2 === void 0 ? void 0 : _state$core2.afterCursor,
    beforeCursor: (_state$core3 = state.core) === null || _state$core3 === void 0 || (_state$core3 = _state$core3.savedPagination) === null || _state$core3 === void 0 ? void 0 : _state$core3.beforeCursor,
    // This is not used directly, but is needed for Searcher component to be rerendered on change of calendar type
    isSecondaryCalendarEnabled: (_state$core$isSeconda = state.core.isSecondaryCalendarEnabled) !== null && _state$core$isSeconda !== void 0 ? _state$core$isSeconda : false
  };
};
var mapDispatchToProps$c = function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    cacheFilters: cacheFilters,
    resetCacheFilters: resetCacheFilters,
    saveCurrentPaginationPage: saveCurrentPaginationPage
  }, dispatch);
};
var Searcher$1 = withModulesManager(withTheme(withStyles(styles$i)(connect(mapStateToProps$h, mapDispatchToProps$c)(Searcher))));

function ownKeys$I(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$I(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$I(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$I(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var useStyles$P = makeStyles(function (theme) {
  return {
    modalContainer: {
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      width: 700,
      maxHeight: "90vh",
      backgroundColor: theme.palette.background.paper,
      borderRadius: theme.spacing(1.5),
      boxShadow: theme.shadows[5],
      padding: theme.spacing(4),
      overflowY: "auto"
    },
    closeButton: {
      position: "absolute",
      top: theme.spacing(1),
      right: theme.spacing(1),
      minWidth: 0,
      padding: theme.spacing(0.5, 1),
      fontSize: "1.2rem"
    },
    sectionPaper: {
      padding: theme.spacing(3),
      marginBottom: theme.spacing(3),
      borderRadius: theme.spacing(1),
      backgroundColor: theme.palette.grey[50]
    },
    buttonGroup: {
      marginTop: theme.spacing(3),
      display: "flex",
      justifyContent: "flex-end",
      gap: theme.spacing(2)
    },
    responseMessage: {
      marginBottom: theme.spacing(2),
      fontWeight: 600
    }
  };
});
var ForwardApplicationSummarySectionAdminModal = function ForwardApplicationSummarySectionAdminModal(_ref) {
  var open = _ref.open,
    onClose = _ref.onClose;
    _ref.selectedApplication;
    _ref.selectedApplicationIds;
    _ref.onSubmitForward;
    var userRights = _ref.userRights,
    summaryId = _ref.summaryId;
  var classes = useStyles$P();
  useHistory();
  var modulesManager = useModulesManager();
  var _useTranslations = useTranslations("core.RegistrationPage", modulesManager);
    _useTranslations.formatMessage;
  var dispatch = useDispatch();
  var _useState = useState(""),
    _useState2 = _slicedToArray(_useState, 2);
    _useState2[0];
    _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    submitting = _useState4[0];
    _useState4[1];
  var _useState5 = useState(null),
    _useState6 = _slicedToArray(_useState5, 2),
    serverResponse = _useState6[0],
    setServerResponse = _useState6[1];
  var _useState7 = useState(""),
    _useState8 = _slicedToArray(_useState7, 2);
    _useState8[0];
    _useState8[1];
  var _useState9 = useState(null),
    _useState10 = _slicedToArray(_useState9, 2);
    _useState10[0];
    _useState10[1];
  var _useState11 = useState([]),
    _useState12 = _slicedToArray(_useState11, 2);
    _useState12[0];
    var setUploadedFiles = _useState12[1];
  getUserTypeFromRights(userRights);
  useSelector(function (state) {
    var _state$core;
    return (_state$core = state.core) === null || _state$core === void 0 || (_state$core = _state$core.user) === null || _state$core === void 0 || (_state$core = _state$core.i_user) === null || _state$core === void 0 ? void 0 : _state$core.id;
  });
  var uploadFile = useSelector(function (state) {
    return state.workforce.uploadFile;
  });
  console.log({
    disburseId: summaryId
  });
  useEffect(function () {
    // if (!open) {
    //   setEditorContent("");
    //   setSubmitting(false);
    //   setServerResponse(null);
    //   setFormData(null);
    // }
    // if (selectedApplication) {
    //   return dispatch(fetchApplication(modulesManager, [`id: "${decodeId(selectedApplication?.id)}"`]));
    // }
    dispatch(fetchDocumentType(modulesManager, ["orderBy: [\"documentTypeNo\"]", "applicationType:\"section_admin\""]));
  }, [open]);

  // useEffect(() => {
  //   if (open) {
  //     setFormData({});
  //   }
  // }, [open]);

  // const data = useSelector((state) => state.workforce[`application`] ?? []);

  var documentData = useSelector(function (state) {
    var _state$workforce;
    return (_state$workforce = state.workforce["documentType"]) !== null && _state$workforce !== void 0 ? _state$workforce : [];
  });
  var locale = useSelector(function (state) {
    var _state$core$user$i_us, _state$core2;
    return (_state$core$user$i_us = (_state$core2 = state.core) === null || _state$core2 === void 0 || (_state$core2 = _state$core2.user) === null || _state$core2 === void 0 || (_state$core2 = _state$core2.i_user) === null || _state$core2 === void 0 ? void 0 : _state$core2.language) !== null && _state$core$user$i_us !== void 0 ? _state$core$user$i_us : "en";
  });
  var handleForward = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            try {
              // if (!formData?.userId) {
              //   setServerResponse({ status: "ERROR", message: "অফিসার নির্বাচন করুন!" });
              //   return;
              // }
              console.log({
                summaryId: safeDecodeId(summaryId)
              });
              uploadFile === null || uploadFile === void 0 || uploadFile.map(function (file, index) {
                dispatch(createWorkforceDocument(_objectSpread$I(_objectSpread$I({}, file), {}, {
                  applicationSummaryId: safeDecodeId(summaryId)
                }), "Created workforce document "));
              });

              // for (const encodedId of selectedApplicationIds) {
              //   const updateApplicationData = {
              //     id: decodeId(encodedId?.id),
              //     status: WORKFORCE_STATUS.FORWARD_FOR_VERIFICATION,
              //   };

              //   await dispatch(updateApplication(updateApplicationData, `update workforce application`));
              //   const createApplicationMovementData = {
              //     applicationId: decodeId(encodedId?.id),
              //     applicationFromId: loggedInUserId,
              //     applicationToId: formData.userId,
              //     status: WORKFORCE_STATUS.FORWARD_FOR_VERIFICATION,
              //     action: "forward_for_verification",
              //   };

              //   await dispatch(createApplicationMovement(createApplicationMovementData, "create workforce movement"));
              // }

              setServerResponse({
                status: "SUCCESS",
                message: "সাবমিশন সফল হয়েছে!"
              });
            } catch (error) {
              console.error("Forwarding error:", error);
              setServerResponse({
                status: "ERROR",
                message: "সাবমিশন ব্যর্থ হয়েছে!"
              });
            }
          case 1:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function handleForward() {
      return _ref3.apply(this, arguments);
    };
  }();
  var handleFileChange = function handleFileChange(fieldKey, files) {
    setUploadedFiles(function (prevFiles) {
      var existingIndex = prevFiles.findIndex(function (item) {
        return item.fieldKey === fieldKey;
      });
      var updatedFiles = _toConsumableArray(prevFiles);
      if (existingIndex !== -1) {
        updatedFiles[existingIndex] = {
          fieldKey: fieldKey,
          files: files
        };
      } else {
        updatedFiles.push({
          fieldKey: fieldKey,
          files: files
        });
      }
      return updatedFiles;
    });
  };

  // useEffect(() => {
  //   if (serverResponse?.status === "SUCCESS") {
  //     setTimeout(() => {
  //       window.location.reload();
  //     }, 2000);
  //   }
  // }, [serverResponse]);

  // console.log({ newwwwwwwww: selectedApplicationIds });

  return /*#__PURE__*/React.createElement(Modal, {
    open: open,
    onClose: onClose
  }, /*#__PURE__*/React.createElement("form", {
    className: classes.modalContainer
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: onClose,
    className: classes.closeButton
  }, "\u2715"), /*#__PURE__*/React.createElement(Typography, {
    variant: "h5",
    gutterBottom: true,
    style: {
      fontWeight: "bold",
      marginTop: 3,
      textAlign: "center"
    }
  }, "\u09AA\u09CD\u09B0\u09DF\u09CB\u099C\u09A8\u09C0\u09DF \u09AA\u09CD\u09B0\u09AE\u09BE\u09A8 \u09AA\u09A4\u09CD\u09B0 \u0986\u09AA\u09B2\u09CB\u09A1 \u0995\u09B0\u09C1\u09A8"), (serverResponse === null || serverResponse === void 0 ? void 0 : serverResponse.status) && /*#__PURE__*/React.createElement(Typography, {
    className: classes.responseMessage,
    style: {
      color: serverResponse.status === "SUCCESS" ? "green" : "red"
    }
  }, serverResponse.status === "SUCCESS" ? "✅" : "⚠️", " ", serverResponse.message), /*#__PURE__*/React.createElement(Divider, {
    style: {
      marginBottom: 24
    }
  }), /*#__PURE__*/React.createElement(Paper, {
    className: classes.sectionPaper,
    elevation: 1
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 3,
    style: {
      marginTop: 3
    }
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle1",
    gutterBottom: true,
    style: {
      fontWeight: "bold",
      marginTop: 3,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "workforce.previewDetails.uploadedBy.factoryAdmin",
    module: "workforce"
  }))), documentData === null || documentData === void 0 ? void 0 : documentData.map(function (data, item) {
    return /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "body2",
      gutterBottom: true,
      style: {
        fontWeight: "bold"
      }
    }, locale === "en" ? data === null || data === void 0 ? void 0 : data.nameEn : data === null || data === void 0 ? void 0 : data.nameBn), /*#__PURE__*/React.createElement(FileUploader, {
      fieldKey: data === null || data === void 0 ? void 0 : data.fieldId,
      onFileChange: handleFileChange,
      documentType: data === null || data === void 0 ? void 0 : data.documentType,
      documentProp: data
    }));
  }))), /*#__PURE__*/React.createElement("div", {
    className: classes.buttonGroup
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: onClose,
    variant: "outlined",
    color: "secondary"
  }, "\u09AC\u09BE\u09A4\u09BF\u09B2 \u0995\u09B0\u09C1\u09A8"), /*#__PURE__*/React.createElement(Button, {
    type: "submit",
    variant: "contained",
    color: "primary",
    disabled: submitting,
    onClick: (/*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3(e) {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              e.preventDefault();
              _context3.next = 3;
              return handleForward();
            case 3:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      return function (_x2) {
        return _ref4.apply(this, arguments);
      };
    }())
  }, submitting ? "ফরওয়ার্ড করা হচ্ছে..." : /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "workforce.submit",
    module: "workforce"
  })))));
};

function ownKeys$H(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$H(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$H(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$H(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _createForOfIteratorHelper$4(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray$4(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray$4(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray$4(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray$4(r, a) : void 0; } }
function _arrayLikeToArray$4(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var useStyles$O = makeStyles(function (theme) {
  return {
    modalContainer: {
      position: "absolute",
      top: "5%",
      left: "50%",
      transform: "translateX(-50%)",
      width: "90%",
      maxWidth: 1400,
      height: "90vh",
      backgroundColor: theme.palette.background.paper,
      borderRadius: theme.spacing(1.5),
      boxShadow: theme.shadows[5],
      padding: theme.spacing(4),
      overflowY: "auto"
    },
    closeButton: {
      position: "absolute",
      top: theme.spacing(1),
      right: theme.spacing(1),
      minWidth: 0
    },
    sectionPaper: {
      padding: theme.spacing(3),
      marginBottom: theme.spacing(3),
      borderRadius: theme.spacing(1)
    },
    buttonGroup: {
      marginTop: theme.spacing(3),
      display: "flex",
      justifyContent: "flex-end",
      gap: theme.spacing(2)
    },
    responseMessage: {
      marginBottom: theme.spacing(2),
      fontWeight: 600
    }
  };
});
var ForwardApplicationEisDoctorModal = function ForwardApplicationEisDoctorModal(_ref) {
  var open = _ref.open,
    onClose = _ref.onClose,
    selectedApplicationIds = _ref.selectedApplicationIds,
    userRights = _ref.userRights;
  var classes = useStyles$O();
  var dispatch = useDispatch();
  var applicationSummaryId = "";
  var modulesManager = useModulesManager();
  var userType = getUserTypeFromRights(userRights);
  var loggedInUserId = useSelector(function (state) {
    var _state$core;
    return (_state$core = state.core) === null || _state$core === void 0 || (_state$core = _state$core.user) === null || _state$core === void 0 || (_state$core = _state$core.i_user) === null || _state$core === void 0 ? void 0 : _state$core.id;
  });
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    meetingList = _useState2[0],
    setMeetingList = _useState2[1];
  var locale = useSelector(function (state) {
    var _state$core2;
    return ((_state$core2 = state.core) === null || _state$core2 === void 0 ? void 0 : _state$core2.locale) || "bn";
  });
  var _useState3 = useState({}),
    _useState4 = _slicedToArray(_useState3, 2),
    formData = _useState4[0],
    setFormData = _useState4[1];
  var _useState5 = useState(null),
    _useState6 = _slicedToArray(_useState5, 2),
    serverResponse = _useState6[0],
    setServerResponse = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    submitting = _useState8[0],
    setSubmitting = _useState8[1];
  var officers = useSelector(function (state) {
    return state.workforce.roleWiseUsers || [];
  });
  useEffect(function () {
    if (open) {
      setFormData({});
      var roleIds = [];
      // if (userType === "eis_coordinator") roleIds = ["53"];
      // else roleIds = ["33"];
      if (isEisPath()) roleIds = ["53"];else if (!isEisPath() && !isBlwfPath()) roleIds = ["33"];else if (isBlwfPath()) roleIds = ["50"];
      if (roleIds.length) {
        dispatch(fetchWorkforceUserRoleWiseUser(modulesManager, {
          roleIds: roleIds,
          orderBy: "id"
        }));
      }
    }
  }, [open, userType]);
  useEffect(function () {
    if (!open) return;
    dispatch(fetchApplicationPackage(modulesManager, ["organizationType: \"".concat(isEisPath() ? "eis" : !isEisPath() && !isBlwfPath() ? "cf" : "blwf", "\""), 'orderBy: ["-meetingDate"]'])).then(function (response) {
      var _response$payload;
      var meetings = (response === null || response === void 0 || (_response$payload = response.payload) === null || _response$payload === void 0 || (_response$payload = _response$payload.data) === null || _response$payload === void 0 || (_response$payload = _response$payload.workforceApplicationSummary) === null || _response$payload === void 0 ? void 0 : _response$payload.edges) || [];
      var formattedMeetings = meetings.map(function (item) {
        return item.node;
      });
      var today = new Date();
      today.setHours(0, 0, 0, 0);
      var includeddStatuses = ["forward_to_doctor"];
      var filteredMeetings = formattedMeetings.filter(function (meeting) {
        if (!(meeting !== null && meeting !== void 0 && meeting.meetingDate)) return false;

        // safely parse YYYY-MM-DD
        var _meeting$meetingDate$ = meeting.meetingDate.split("-").map(Number),
          _meeting$meetingDate$2 = _slicedToArray(_meeting$meetingDate$, 3),
          year = _meeting$meetingDate$2[0],
          month = _meeting$meetingDate$2[1],
          day = _meeting$meetingDate$2[2];
        var meetingDate = new Date(year, month - 1, day);

        // difference in days
        var diffTime = meetingDate.getTime() - today.getTime();
        var diffDays = diffTime / (1000 * 60 * 60 * 24);
        return diffDays >= 3 && includeddStatuses.includes(meeting.status);
      });
      setMeetingList(filteredMeetings);
    });
  }, [open]);
  var handleForward = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(e) {
      var allowedTypes, invalidApplication, _formData$userIds, ids, createApplicationSummaryData, applicationSummeryMutation, applicationSummeryClientMutationId, appToDoctorsMap, numDocs, baseShare, remainder, currentDocIndex, assignedToCurrentDoc, _iterator, _step, applicationId, targetUsers, _iterator2, _step2, userId;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            allowedTypes = isEisPath() ? ["disabilityAssistance"] : !isEisPath() && !isBlwfPath() ? ["medicalAssistance", "disabilityAssistance", "maternityGrant"] : ["medicalDonation", "maternityGrant"];
            invalidApplication = selectedApplicationIds === null || selectedApplicationIds === void 0 ? void 0 : selectedApplicationIds.find(function (app) {
              return !allowedTypes.includes(app === null || app === void 0 ? void 0 : app.applicationType);
            }); // const invalidApplication = selectedApplicationIds?.find((app) => app?.applicationType !== "disabilityAssistance");
            if (!invalidApplication) {
              _context.next = 6;
              break;
            }
            alert("আবেদনটি মিটিং এ পাঠানোর জন্য উপযুক্ত নয়, শুধুমাত্র স্থায়ী ও আংশিক অক্ষমতা জনিত আর্থিক সহায়তা আবেদন মিটিং এ পাঠানো যাবে।");
            window.location.href = "/home";
            return _context.abrupt("return");
          case 6:
            e.preventDefault();
            _context.prev = 7;
            setSubmitting(true);
            if (formData !== null && formData !== void 0 && (_formData$userIds = formData.userIds) !== null && _formData$userIds !== void 0 && _formData$userIds.length) {
              _context.next = 12;
              break;
            }
            setServerResponse({
              status: "ERROR",
              message: "ডক্টর নির্বাচন করুন!"
            });
            return _context.abrupt("return");
          case 12:
            if (!(!(formData !== null && formData !== void 0 && formData.year) || !(formData !== null && formData !== void 0 && formData.month) || !(formData !== null && formData !== void 0 && formData.meetingDate))) {
              _context.next = 15;
              break;
            }
            setServerResponse({
              status: "ERROR",
              message: "মিটিং এর তথ্য পূরণ করুন!"
            });
            return _context.abrupt("return");
          case 15:
            ids = selectedApplicationIds.map(function (obj) {
              return decodeId(obj.id);
            }); // ===== Create Meeting Summary =====
            createApplicationSummaryData = {
              status: WORKFORCE_STATUS$1.FORWARD_TO_DOCTOR,
              name: formData === null || formData === void 0 ? void 0 : formData.meetingName,
              meetingDate: formData === null || formData === void 0 ? void 0 : formData.meetingDate,
              year: Number(formData === null || formData === void 0 ? void 0 : formData.year),
              month: formData === null || formData === void 0 ? void 0 : formData.month,
              organizationType: isEisPath() ? "eis" : !isEisPath() && !isBlwfPath() ? "cf" : "blwf",
              sectionType: "",
              applicationData: JSON.stringify(ids),
              userIds: JSON.stringify((formData === null || formData === void 0 ? void 0 : formData.userIds) || [])
            };
            console.log("createApplicationSummaryData", createApplicationSummaryData);
            applicationSummeryMutation = formatMutation("createWorkforceApplicationSummary", formatApplicationSummaryGQL(createApplicationSummaryData), "create workforce application summary");
            applicationSummeryClientMutationId = applicationSummeryMutation.clientMutationId;
            _context.next = 22;
            return dispatch(createApplicationSummary(applicationSummeryMutation, "create workforce application summary"));
          case 22:
            _context.next = 24;
            return dispatch(fetchApplicationSummaryByClientMutationId(modulesManager, applicationSummeryClientMutationId)).then(function (response) {
              var _response$payload2;
              applicationSummaryId = response === null || response === void 0 || (_response$payload2 = response.payload) === null || _response$payload2 === void 0 || (_response$payload2 = _response$payload2.data) === null || _response$payload2 === void 0 || (_response$payload2 = _response$payload2.workforceApplicationSummary) === null || _response$payload2 === void 0 || (_response$payload2 = _response$payload2.edges) === null || _response$payload2 === void 0 || (_response$payload2 = _response$payload2[0]) === null || _response$payload2 === void 0 || (_response$payload2 = _response$payload2.node) === null || _response$payload2 === void 0 ? void 0 : _response$payload2.id;
              console.log({
                applicationSummaryId: applicationSummaryId
              });
            });
          case 24:
            if (applicationSummaryId) {
              _context.next = 27;
              break;
            }
            setServerResponse({
              status: "ERROR",
              message: "সারাংশ তৈরি ব্যর্থ হয়েছে!"
            });
            return _context.abrupt("return");
          case 27:
            // ===== Forward to Doctor =====
            appToDoctorsMap = {};
            if (!isEisPath()) {
              numDocs = formData.userIds.length;
              baseShare = Math.floor(ids.length / numDocs);
              remainder = ids.length % numDocs;
              currentDocIndex = 0;
              assignedToCurrentDoc = 0;
              ids.forEach(function (appId) {
                var currentDocShare = baseShare + (remainder > 0 ? 1 : 0);
                appToDoctorsMap[appId] = [formData.userIds[currentDocIndex]];
                assignedToCurrentDoc++;
                if (assignedToCurrentDoc === currentDocShare) {
                  currentDocIndex++;
                  assignedToCurrentDoc = 0;
                  remainder--;
                }
              });
            } else {
              ids.forEach(function (appId) {
                appToDoctorsMap[appId] = formData.userIds;
              });
            }
            _iterator = _createForOfIteratorHelper$4(ids);
            _context.prev = 30;
            _iterator.s();
          case 32:
            if ((_step = _iterator.n()).done) {
              _context.next = 56;
              break;
            }
            applicationId = _step.value;
            _context.next = 36;
            return dispatch(updateApplication(_objectSpread$H({
              id: applicationId,
              status: WORKFORCE_STATUS$1.FORWARD_TO_DOCTOR
            }, isEisPath() ? {
              eisApplicationSummaryId: decodeId(applicationSummaryId)
            } : isBlwfPath() ? {
              blwfApplicationSummaryId: decodeId(applicationSummaryId)
            } : {
              cfApplicationSummaryId: decodeId(applicationSummaryId)
            }), "update workforce application"));
          case 36:
            targetUsers = appToDoctorsMap[applicationId] || [];
            _iterator2 = _createForOfIteratorHelper$4(targetUsers);
            _context.prev = 38;
            _iterator2.s();
          case 40:
            if ((_step2 = _iterator2.n()).done) {
              _context.next = 46;
              break;
            }
            userId = _step2.value;
            _context.next = 44;
            return dispatch(createApplicationMovement({
              applicationId: applicationId,
              applicationFromId: loggedInUserId,
              applicationToId: userId,
              status: WORKFORCE_STATUS$1.FORWARD_TO_DOCTOR,
              action: "forward_to_doctor",
              note: "ডক্টরের কাছে প্রেরণ"
            }, "create workforce movement"));
          case 44:
            _context.next = 40;
            break;
          case 46:
            _context.next = 51;
            break;
          case 48:
            _context.prev = 48;
            _context.t0 = _context["catch"](38);
            _iterator2.e(_context.t0);
          case 51:
            _context.prev = 51;
            _iterator2.f();
            return _context.finish(51);
          case 54:
            _context.next = 32;
            break;
          case 56:
            _context.next = 61;
            break;
          case 58:
            _context.prev = 58;
            _context.t1 = _context["catch"](30);
            _iterator.e(_context.t1);
          case 61:
            _context.prev = 61;
            _iterator.f();
            return _context.finish(61);
          case 64:
            setServerResponse({
              status: "SUCCESS",
              message: "মিটিং তৈরি ও ডক্টরের কাছে পাঠানো হয়েছে!"
            });
            _context.next = 71;
            break;
          case 67:
            _context.prev = 67;
            _context.t2 = _context["catch"](7);
            console.error(_context.t2);
            setServerResponse({
              status: "ERROR",
              message: "প্রক্রিয়া ব্যর্থ হয়েছে!"
            });
          case 71:
            _context.prev = 71;
            setSubmitting(false);
            return _context.finish(71);
          case 74:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[7, 67, 71, 74], [30, 58, 61, 64], [38, 48, 51, 54]]);
    }));
    return function handleForward(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  var handleAddApplication = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(meetingId, meetingStatus) {
      var _iterator3, _step3, encodedId, updateData;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            if (!(!selectedApplicationIds || selectedApplicationIds.length === 0)) {
              _context2.next = 3;
              break;
            }
            setServerResponse({
              status: "ERROR",
              message: "দয়া করে অন্তত একটি আবেদন নির্বাচন করুন।"
            });
            return _context2.abrupt("return");
          case 3:
            setSubmitting(true);
            _context2.prev = 4;
            _iterator3 = _createForOfIteratorHelper$4(selectedApplicationIds);
            _context2.prev = 6;
            _iterator3.s();
          case 8:
            if ((_step3 = _iterator3.n()).done) {
              _context2.next = 15;
              break;
            }
            encodedId = _step3.value;
            updateData = _objectSpread$H({
              id: decodeId(encodedId.id),
              status: meetingStatus
            }, isEisPath() ? {
              eisApplicationSummaryId: decodeId(meetingId)
            } : !isEisPath() && isBlwfPath() ? {
              blwfApplicationSummaryId: decodeId(meetingId)
            } : {
              cfApplicationSummaryId: decodeId(meetingId)
            });
            _context2.next = 13;
            return dispatch(updateApplication(updateData, "Update application summary"));
          case 13:
            _context2.next = 8;
            break;
          case 15:
            _context2.next = 20;
            break;
          case 17:
            _context2.prev = 17;
            _context2.t0 = _context2["catch"](6);
            _iterator3.e(_context2.t0);
          case 20:
            _context2.prev = 20;
            _iterator3.f();
            return _context2.finish(20);
          case 23:
            setServerResponse({
              status: "SUCCESS",
              message: "আবেদন সফলভাবে মিটিং এর সাথে যুক্ত হয়েছে।"
            });
            setTimeout(function () {
              window.location.reload();
            }, 2000);
            _context2.next = 31;
            break;
          case 27:
            _context2.prev = 27;
            _context2.t1 = _context2["catch"](4);
            console.error(_context2.t1);
            setServerResponse({
              status: "ERROR",
              message: "আবেদন মিটিং এর সাথে যুক্ত করতে ব্যর্থ হয়েছে।"
            });
          case 31:
            _context2.prev = 31;
            setSubmitting(false);
            return _context2.finish(31);
          case 34:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[4, 27, 31, 34], [6, 17, 20, 23]]);
    }));
    return function handleAddApplication(_x2, _x3) {
      return _ref3.apply(this, arguments);
    };
  }();
  var getStatusDisplay = function getStatusDisplay(status) {
    var statusMap = locale === "en" ? STATUS_MAP_EN : STATUS_MAP_BN;
    return statusMap[status] || status;
  };
  useEffect(function () {
    if ((serverResponse === null || serverResponse === void 0 ? void 0 : serverResponse.status) === "SUCCESS") {
      setTimeout(function () {
        return window.location.reload();
      }, 1000);
    }
  }, [serverResponse]);
  console.log({
    selectedApplicationIds: formData
  });
  return /*#__PURE__*/React.createElement(Modal, {
    open: open,
    onClose: onClose
  }, /*#__PURE__*/React.createElement("form", {
    className: classes.modalContainer,
    onSubmit: handleForward
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: onClose,
    className: classes.closeButton
  }, "\u2715"), /*#__PURE__*/React.createElement(Typography, {
    variant: "h5",
    style: {
      fontWeight: "bold",
      textAlign: "center"
    }
  }, "\u0995\u09B0\u09CD\u09AE\u09AC\u09A8\u09CD\u099F\u09A8 (\u09AE\u09BF\u099F\u09BF\u0982 + \u09A1\u0995\u09CD\u099F\u09B0)"), (serverResponse === null || serverResponse === void 0 ? void 0 : serverResponse.status) && /*#__PURE__*/React.createElement(Typography, {
    className: classes.responseMessage,
    style: {
      color: serverResponse.status === "SUCCESS" ? "green" : "red"
    }
  }, serverResponse.status === "SUCCESS" ? "✅" : "⚠️", " ", serverResponse.message), /*#__PURE__*/React.createElement(Divider, {
    style: {
      marginBottom: 24
    }
  }), /*#__PURE__*/React.createElement(Paper, {
    className: classes.sectionPaper,
    elevation: 1
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6",
    style: {
      fontWeight: "bold",
      marginBottom: 16
    }
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.employee.application.preMeetingList"
  })), /*#__PURE__*/React.createElement(Divider, {
    style: {
      marginBottom: 16
    }
  }), /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 2
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement("table", {
    style: {
      width: "100%",
      borderCollapse: "collapse",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", {
    style: {
      background: "#f5f5f5"
    }
  }, /*#__PURE__*/React.createElement("th", {
    style: {
      padding: 10
    }
  }, "\u09AE\u09BF\u099F\u09BF\u0982 \u09A8\u09BE\u09AE"), /*#__PURE__*/React.createElement("th", {
    style: {
      padding: 10
    }
  }, "\u09AC\u099B\u09B0"), /*#__PURE__*/React.createElement("th", {
    style: {
      padding: 10
    }
  }, "\u09AE\u09BE\u09B8"), /*#__PURE__*/React.createElement("th", {
    style: {
      padding: 10
    }
  }, "\u09AE\u09BF\u099F\u09BF\u0982 \u09A4\u09BE\u09B0\u09BF\u0996"), /*#__PURE__*/React.createElement("th", {
    style: {
      padding: 10
    }
  }, "\u09B8\u09CD\u099F\u09CD\u09AF\u09BE\u099F\u09BE\u09B8"), /*#__PURE__*/React.createElement("th", {
    style: {
      padding: 10
    }
  }, "\u0985\u09CD\u09AF\u09BE\u0995\u09B6\u09A8"))), /*#__PURE__*/React.createElement("tbody", null, meetingList === null || meetingList === void 0 ? void 0 : meetingList.map(function (meeting, index) {
    return /*#__PURE__*/React.createElement("tr", {
      key: meeting.id,
      style: {
        borderBottom: "1px solid #ddd"
      }
    }, /*#__PURE__*/React.createElement("td", {
      style: {
        padding: 10
      }
    }, meeting.name), /*#__PURE__*/React.createElement("td", {
      style: {
        padding: 10
      }
    }, meeting.year), /*#__PURE__*/React.createElement("td", {
      style: {
        padding: 10
      }
    }, meeting.month), /*#__PURE__*/React.createElement("td", {
      style: {
        padding: 10
      }
    }, meeting.meetingDate), /*#__PURE__*/React.createElement("td", {
      style: {
        padding: 10
      }
    }, /*#__PURE__*/React.createElement(Typography, {
      style: {
        background: "#e3f2fd",
        padding: "4px 10px",
        borderRadius: 6,
        display: "inline-block",
        fontSize: 12
      }
    }, getStatusDisplay(meeting.status))), /*#__PURE__*/React.createElement("td", {
      style: {
        padding: 10
      }
    }, /*#__PURE__*/React.createElement(Button, {
      size: "small",
      variant: "contained",
      color: "primary",
      onClick: function onClick() {
        return handleAddApplication(meeting.id, meeting.status);
      }
    }, /*#__PURE__*/React.createElement(FormattedMessage, {
      module: "workforce",
      id: "workforce.employee.application.addApplication"
    }))));
  })))))), /*#__PURE__*/React.createElement(Paper, {
    className: classes.sectionPaper
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 3
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle1",
    style: {
      fontWeight: "bold",
      textAlign: "center"
    }
  }, "\u09AE\u09BF\u099F\u09BF\u0982 \u098F\u09B0 \u09A4\u09A5\u09CD\u09AF")), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 6
  }, /*#__PURE__*/React.createElement(Select, {
    fullWidth: true,
    value: formData.year || "",
    onChange: function onChange(e) {
      return setFormData(_objectSpread$H(_objectSpread$H({}, formData), {}, {
        year: e.target.value
      }));
    },
    displayEmpty: true
  }, /*#__PURE__*/React.createElement(MenuItem, {
    value: ""
  }, "\u09AC\u099B\u09B0 \u09A8\u09BF\u09B0\u09CD\u09AC\u09BE\u099A\u09A8 \u0995\u09B0\u09C1\u09A8"), _toConsumableArray(Array(21)).map(function (_, i) {
    var y = 2020 + i;
    return /*#__PURE__*/React.createElement(MenuItem, {
      key: y,
      value: y
    }, y);
  }))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 6
  }, /*#__PURE__*/React.createElement(Select, {
    fullWidth: true,
    value: formData.month || "",
    onChange: function onChange(e) {
      return setFormData(_objectSpread$H(_objectSpread$H({}, formData), {}, {
        month: e.target.value
      }));
    },
    displayEmpty: true
  }, /*#__PURE__*/React.createElement(MenuItem, {
    value: ""
  }, "\u09AE\u09BE\u09B8 \u09A8\u09BF\u09B0\u09CD\u09AC\u09BE\u099A\u09A8 \u0995\u09B0\u09C1\u09A8"), ["জানুয়ারি", "ফেব্রুয়ারি", "মার্চ", "এপ্রিল", "মে", "জুন", "জুলাই", "আগস্ট", "সেপ্টেম্বর", "অক্টোবর", "নভেম্বর", "ডিসেম্বর"].map(function (m) {
    return /*#__PURE__*/React.createElement(MenuItem, {
      key: m,
      value: m
    }, m);
  }))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 6
  }, /*#__PURE__*/React.createElement(TextField, {
    fullWidth: true,
    label: "\u09AE\u09BF\u099F\u09BF\u0982 \u098F\u09B0 \u09A8\u09BE\u09AE",
    variant: "outlined",
    value: formData.meetingName || "",
    onChange: function onChange(e) {
      return setFormData(_objectSpread$H(_objectSpread$H({}, formData), {}, {
        meetingName: e.target.value
      }));
    }
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 6
  }, /*#__PURE__*/React.createElement(PublishedComponent, {
    pubRef: "workforce.DatePicker",
    label: "\u09AE\u09BF\u099F\u09BF\u0982 \u098F\u09B0 \u09A4\u09BE\u09B0\u09BF\u0996",
    value: formData.meetingDate || "",
    onChange: function onChange(v) {
      return setFormData(_objectSpread$H(_objectSpread$H({}, formData), {}, {
        meetingDate: v
      }));
    }
  })))), /*#__PURE__*/React.createElement(Paper, {
    className: classes.sectionPaper,
    elevation: 1
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 3,
    style: {
      marginTop: 3
    }
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle1",
    gutterBottom: true,
    style: {
      fontWeight: "bold",
      marginTop: 3,
      textAlign: "center"
    }
  }, "\u09A1\u0995\u09CD\u099F\u09B0 \u09A8\u09BF\u09B0\u09CD\u09AC\u09BE\u099A\u09A8 \u0995\u09B0\u09C1\u09A8"), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 12
  }, /*#__PURE__*/React.createElement(FormControl, {
    fullWidth: true
  }, /*#__PURE__*/React.createElement(Select, {
    multiple: true,
    value: (formData === null || formData === void 0 ? void 0 : formData.userIds) || [],
    onChange: function onChange(e) {
      return setFormData(_objectSpread$H(_objectSpread$H({}, formData), {}, {
        userIds: e.target.value
      }));
    },
    renderValue: function renderValue(selected) {
      return officers.filter(function (officer) {
        return selected.includes(officer.userId);
      }).map(function (officer) {
        return officer.otherNames;
      }).join(", ");
    },
    displayEmpty: true,
    MenuProps: {
      PaperProps: {
        style: {
          backgroundColor: "#fff",
          color: "#000"
        }
      }
    }
  }, officers.map(function (officer) {
    var _formData$userIds2;
    return /*#__PURE__*/React.createElement(MenuItem, {
      key: officer.id,
      value: officer.userId
    }, /*#__PURE__*/React.createElement(Checkbox, {
      checked: formData === null || formData === void 0 || (_formData$userIds2 = formData.userIds) === null || _formData$userIds2 === void 0 ? void 0 : _formData$userIds2.includes(officer.userId),
      style: {
        color: "#000"
      }
    }), /*#__PURE__*/React.createElement(Typography, {
      style: {
        color: "#000"
      }
    }, officer.otherNames));
  })))))), /*#__PURE__*/React.createElement("div", {
    className: classes.buttonGroup
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: onClose,
    variant: "outlined",
    color: "secondary"
  }, "\u09AC\u09BE\u09A4\u09BF\u09B2"), /*#__PURE__*/React.createElement(Button, {
    type: "submit",
    variant: "contained",
    color: "primary",
    disabled: submitting
  }, submitting ? "প্রসেসিং..." : "মিটিং তৈরি ও ফরওয়ার্ড"))));
};

function _createForOfIteratorHelper$3(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray$3(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray$3(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray$3(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray$3(r, a) : void 0; } }
function _arrayLikeToArray$3(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var useStyles$N = makeStyles(function (theme) {
  return {
    modalContainer: {
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      width: 700,
      maxHeight: "90vh",
      backgroundColor: theme.palette.background.paper,
      borderRadius: theme.spacing(1.5),
      boxShadow: theme.shadows[5],
      padding: theme.spacing(4),
      overflowY: "auto"
    },
    closeButton: {
      position: "absolute",
      top: theme.spacing(1),
      right: theme.spacing(1),
      minWidth: 0,
      padding: theme.spacing(0.5, 1),
      fontSize: "1.2rem"
    },
    sectionPaper: {
      padding: theme.spacing(3),
      marginBottom: theme.spacing(3),
      borderRadius: theme.spacing(1),
      backgroundColor: theme.palette.grey[50]
    },
    buttonGroup: {
      marginTop: theme.spacing(3),
      display: "flex",
      justifyContent: "flex-end",
      gap: theme.spacing(2)
    },
    responseMessage: {
      marginBottom: theme.spacing(2),
      fontWeight: 600
    }
  };
});
var ForwardEisPaymentProcessModal = function ForwardEisPaymentProcessModal(_ref) {
  var open = _ref.open,
    onClose = _ref.onClose,
    selectedApplication = _ref.selectedApplication,
    selectedApplicationIds = _ref.selectedApplicationIds,
    userRights = _ref.userRights;
  var classes = useStyles$N();
  var dispatch = useDispatch();
  var modulesManager = useModulesManager();
  var _useState = useState(""),
    _useState2 = _slicedToArray(_useState, 2);
    _useState2[0];
    var setEditorContent = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    submitting = _useState4[0],
    setSubmitting = _useState4[1];
  var _useState5 = useState(null),
    _useState6 = _slicedToArray(_useState5, 2),
    serverResponse = _useState6[0],
    setServerResponse = _useState6[1];
  var _useState7 = useState(null),
    _useState8 = _slicedToArray(_useState7, 2);
    _useState8[0];
    var setFormData = _useState8[1];
  useSelector(function (state) {
    var _state$workforce;
    return (_state$workforce = state.workforce["application"]) !== null && _state$workforce !== void 0 ? _state$workforce : [];
  });
  getUserTypeFromRights(userRights);
  useSelector(function (state) {
    var _state$core;
    return (_state$core = state.core) === null || _state$core === void 0 || (_state$core = _state$core.user) === null || _state$core === void 0 || (_state$core = _state$core.i_user) === null || _state$core === void 0 ? void 0 : _state$core.id;
  });
  useEffect(function () {
    if (!open) {
      setEditorContent("");
      setSubmitting(false);
      setServerResponse(null);
      setFormData(null);
    }
    if (selectedApplication) {
      return dispatch(fetchApplication(modulesManager, ["id: \"".concat(decodeId(selectedApplication === null || selectedApplication === void 0 ? void 0 : selectedApplication.id), "\"")]));
    }
  }, [open]);
  var handleSubmit = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(e) {
      var sendApplicationIds, _iterator, _step, encodedId;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            e.preventDefault();
            setSubmitting(true);
            sendApplicationIds = [];
            _iterator = _createForOfIteratorHelper$3(selectedApplicationIds);
            try {
              for (_iterator.s(); !(_step = _iterator.n()).done;) {
                encodedId = _step.value;
                sendApplicationIds.push(isBase64Encoded(encodedId === null || encodedId === void 0 ? void 0 : encodedId.id) ? decodeId(encodedId === null || encodedId === void 0 ? void 0 : encodedId.id) : encodedId === null || encodedId === void 0 ? void 0 : encodedId.id);
              }
            } catch (err) {
              _iterator.e(err);
            } finally {
              _iterator.f();
            }
            _context.next = 7;
            return dispatch(eisPaymentProcessWithoutDate(sendApplicationIds, "Create Payment Process"));
          case 7:
            _context.sent;
            setServerResponse({
              status: "SUCCESS",
              message: "সাবমিশন সফল হয়েছে!"
            });
          case 9:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function handleSubmit(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  useEffect(function () {
    if ((serverResponse === null || serverResponse === void 0 ? void 0 : serverResponse.status) === "SUCCESS") ;
  }, [serverResponse]);
  return /*#__PURE__*/React.createElement(Modal, {
    open: open,
    onClose: onClose
  }, /*#__PURE__*/React.createElement("form", {
    className: classes.modalContainer,
    onSubmit: handleSubmit
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: onClose,
    className: classes.closeButton
  }, "\u2715"), /*#__PURE__*/React.createElement(Typography, {
    variant: "h5",
    gutterBottom: true,
    style: {
      fontWeight: "bold",
      marginTop: 3,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.employee.application.paymentProcess"
  })), /*#__PURE__*/React.createElement(Typography, {
    variant: "body1",
    color: "textSecondary",
    gutterBottom: true,
    style: {
      fontWeight: 600,
      marginTop: 3,
      textAlign: "center"
    }
  }), (serverResponse === null || serverResponse === void 0 ? void 0 : serverResponse.status) && /*#__PURE__*/React.createElement(Typography, {
    className: classes.responseMessage,
    style: {
      color: serverResponse.status === "SUCCESS" ? "green" : "red"
    }
  }, serverResponse.status === "SUCCESS" ? "✅" : "⚠️", " ", serverResponse.message), /*#__PURE__*/React.createElement(Divider, {
    style: {
      marginBottom: 24
    }
  }), /*#__PURE__*/React.createElement(Paper, {
    className: classes.sectionPaper,
    elevation: 1
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 3,
    style: {
      marginTop: 3
    }
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle1",
    gutterBottom: true,
    style: {
      fontWeight: "bold",
      marginTop: 3,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.application.providePaymentInfo"
  }))))), /*#__PURE__*/React.createElement("div", {
    className: classes.buttonGroup
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: onClose,
    variant: "contained",
    color: "secondary"
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "core.LanguageQuickPicker.dialog.cancel"
  })), /*#__PURE__*/React.createElement(Button, {
    type: "submit",
    variant: "contained",
    color: "primary",
    disabled: submitting
    // onClick={handleForward}
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.submit"
  })))));
};

function ownKeys$G(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$G(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$G(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$G(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var useStyles$M = makeStyles(function () {
  return {
    printContainer: {
      display: "none"
    }
  };
});
var GenerateEisBFTN = function GenerateEisBFTN(_ref) {
  var open = _ref.open,
    onClose = _ref.onClose;
    _ref.userRights;
    _ref.status;
    _ref.summary_Id;
    var selectedApplicationIds = _ref.selectedApplicationIds;
    _ref.OtherCompensationAmount;
  var classes = useStyles$M();
  var dispatch = useDispatch();
  var modulesManager = useModulesManager();
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    selectedRow = _useState2[0],
    setSelectedRow = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    printReady = _useState4[0],
    setPrintReady = _useState4[1];
  var _useState5 = useState(null),
    _useState6 = _slicedToArray(_useState5, 2),
    printWindow = _useState6[0],
    setPrintWindow = _useState6[1];
  var _useState7 = useState({
      noaSigner: null,
      noaSignature: null
    }),
    _useState8 = _slicedToArray(_useState7, 2),
    noaSignerInfo = _useState8[0],
    setNoaSignerInfo = _useState8[1];
  var _useState9 = useState(0),
    _useState10 = _slicedToArray(_useState9, 2),
    otherCompAmount = _useState10[0],
    setOtherCompAmount = _useState10[1];
  var _useState11 = useState([]),
    _useState12 = _slicedToArray(_useState11, 2),
    eisPayments = _useState12[0],
    setEisPayments = _useState12[1];
  console.log({
    selectedApplicationIds: selectedApplicationIds
  });
  var handleRowPrint = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(row) {
      var _row$workforceApplica;
      var year, monthIndex, monthFormatted, lastDay, selected, popup, eisApprovedByIds, _signatureResult$payl, _signerResult$payload, _yield$Promise$all, _yield$Promise$all2, signatureResult, signerResult;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            year = (row === null || row === void 0 ? void 0 : row.year) || "";
            monthIndex = (row === null || row === void 0 ? void 0 : row.monthIndex) || "";
            monthFormatted = String(monthIndex).padStart(2, "0");
            lastDay = new Date(year, monthIndex, 0).getDate();
            selected = _objectSpread$G(_objectSpread$G({}, row), {}, {
              payFrom: "01.".concat(monthFormatted, ".").concat(year),
              payTo: "".concat(lastDay, ".").concat(monthFormatted, ".").concat(year)
            });
            popup = window.open("", "_blank", "width=1000,height=800,scrollbars=yes,resizable=yes");
            if (popup) {
              popup.document.write("<html><body><p>Preparing print preview...</p></body></html>");
              popup.document.close();
              popup.focus();
            }
            setPrintWindow(popup);
            setPrintReady(false);
            setSelectedRow(selected);
            eisApprovedByIds = safeParse(row === null || row === void 0 || (_row$workforceApplica = row.workforceApplication) === null || _row$workforceApplica === void 0 ? void 0 : _row$workforceApplica.eisApprovedByIds) || [];
            if (!(eisApprovedByIds.length > 0)) {
              _context.next = 21;
              break;
            }
            _context.next = 14;
            return Promise.all([dispatch(fetchWorkforceNoaSignatureByApprovers(eisApprovedByIds)), dispatch(fetchWorkforceNoaSignerUserByApprovers(eisApprovedByIds))]);
          case 14:
            _yield$Promise$all = _context.sent;
            _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 2);
            signatureResult = _yield$Promise$all2[0];
            signerResult = _yield$Promise$all2[1];
            setNoaSignerInfo({
              noaSignature: ((_signatureResult$payl = signatureResult.payload) === null || _signatureResult$payl === void 0 || (_signatureResult$payl = _signatureResult$payl.data) === null || _signatureResult$payl === void 0 ? void 0 : _signatureResult$payl.fetchNoaSignatureByApprovers) || null,
              noaSigner: ((_signerResult$payload = signerResult.payload) === null || _signerResult$payload === void 0 || (_signerResult$payload = _signerResult$payload.data) === null || _signerResult$payload === void 0 ? void 0 : _signerResult$payload.fetchWorkforceNoaSignerUserByApprovers) || null
            });
            _context.next = 22;
            break;
          case 21:
            setNoaSignerInfo({
              noaSignature: null,
              noaSigner: null
            });
          case 22:
            setPrintReady(true);
          case 23:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function handleRowPrint(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  // New tab print logic (opens formatted preview in new tab)
  useEffect(function () {
    if (selectedRow && printReady && printWindow) {
      // Give React time to render the hidden template
      var timer = setTimeout(function () {
        var container = document.getElementById("print-area-container");
        if (container && container.innerHTML.trim()) {
          var content = container.innerHTML;
          var popup = printWindow;
          if (!popup.closed) {
            popup.document.open();
            popup.document.write("\n<!DOCTYPE html>\n<html lang=\"bn\">\n<head>\n  <meta charset=\"UTF-8\">\n  <title>\u09A8\u09CB\u099F\u09BF\u09B6 \u0985\u09AB \u0985\u09CD\u09AF\u09BE\u0993\u09AF\u09BC\u09BE\u09B0\u09CD\u09A1</title>\n  <link rel=\"stylesheet\" href=\"https://fonts.googleapis.com/css2?family=Noto+Sans+Bengali:wght@400;700&display=swap\">\n  <style type=\"text/css\">\n    html, body {\n      margin: 0;\n      padding: 0;\n      font-family: 'Noto Sans Bengali', sans-serif;\n      background: #fff;\n      color: #000;\n    }\n    body {\n      padding: 8mm 10mm;\n    }\n    @media print {\n      body {\n        padding: 5mm 8mm;\n      }\n      @page {\n        size: A4 portrait;\n        margin: 8mm 8mm 8mm 8mm;\n      }\n    }\n    .noa-page {\n      position: relative;\n      width: 100%;\n      box-sizing: border-box;\n      font-size: 12px;\n      page-break-inside: avoid;\n    }\n    .noa-header {\n      position: relative;\n      text-align: center;\n      margin-bottom: 4mm;\n    }\n    .noa-header h3, .noa-header h4, .noa-header p {\n      margin: 1px 0;\n      line-height: 1.2;\n    }\n    .noa-header h3 {\n      font-size: 12px;\n    }\n    .noa-header h4 {\n      font-size: 12px;\n      margin: 3px 0 2px 0;\n    }\n    .noa-body {\n      margin-top: 0;\n    }\n    .noa-additional-info{\n      position: relative;\n      margin-top: 3mm;\n      page-break-inside: avoid;\n      font-size: 12px;\n    }\n    .noa-footer {\n      position: relative;\n      margin-top: 3mm;\n      page-break-inside: avoid;\n      font-size: 12px;\n    }\n    .noa-table {\n      width: 100%;\n      border-collapse: collapse;\n      margin-bottom: 2px;\n      table-layout: fixed;\n    }\n    .noa-table td {\n      border: 1px solid #000;\n      padding: 2px 4px;\n      vertical-align: top;\n      word-wrap: break-word;\n      font-size: 12px;\n    }\n    .noa-label {\n      width: 35%;\n      font-weight: bold;\n      background-color: #f5f5f5;\n    }\n    .noa-value {\n      width: 65%;\n    }\n    .noa-section {\n      font-weight: bold;\n      text-align: center;\n      background-color: #e0e0e0;\n      padding: 2px 2px;\n      font-size: 12px;\n    }\n    .noa-signature {\n      text-align: right;\n      font-weight: bold;\n      font-size: 12px;\n    }\n    .noa-signature p {\n      margin: 1px 0;\n      line-height: 1.1;\n    }\n    * {\n      -webkit-print-color-adjust: exact !important;\n      color-adjust: exact !important;\n    }\n  </style>\n</head>\n<body>\n  ".concat(content, "\n</body>\n<script>\n    window.onload = function () {\n        window.print();\n      };\n</script>\n</html>\n            "));
            popup.document.close();
            popup.focus();
            // Uncomment the line below if you want auto-print (print dialog opens immediately)
            // popup.print();
          }
        }
        // Reset so next row can be printed
        setSelectedRow(null);
        setPrintWindow(null);
      }, 800);
      return function () {
        return clearTimeout(timer);
      };
    }
  }, [selectedRow, printReady, printWindow]);
  useEffect(function () {
    if (selectedApplicationIds.length > 0) {
      var applicationIds = selectedApplicationIds.map(function (x) {
        return safeDecodeId(x === null || x === void 0 ? void 0 : x.id);
      });
      dispatch(fetchEisPaymentProcess(applicationIds, modulesManager)).then(function (res) {
        var _res$payload;
        var fetchedData = res === null || res === void 0 || (_res$payload = res.payload) === null || _res$payload === void 0 || (_res$payload = _res$payload.data) === null || _res$payload === void 0 ? void 0 : _res$payload.workforceEisPaymentProcess;
        setEisPayments(fetchedData);
      });
      dispatch(fetchWorkforceOtherCompensation(modulesManager, ["workforceApplicationId: \"".concat(applicationIds, "\"")])).then(function (res) {
        var _res$payload2, _fetchOtherCompensati;
        var fetchOtherCompensation = parseData(res === null || res === void 0 || (_res$payload2 = res.payload) === null || _res$payload2 === void 0 || (_res$payload2 = _res$payload2.data) === null || _res$payload2 === void 0 ? void 0 : _res$payload2.workforceOtherCompensationInfo);
        var amount = (fetchOtherCompensation === null || fetchOtherCompensation === void 0 || (_fetchOtherCompensati = fetchOtherCompensation[0]) === null || _fetchOtherCompensati === void 0 ? void 0 : _fetchOtherCompensati.amount) || 0;
        setOtherCompAmount(amount);
      });
    }
  }, [open, selectedApplicationIds, dispatch, modulesManager]);
  var printYear = new Date().getFullYear();
  var printMonth = new Date().getMonth();
  var excelmonthFormatted = String(printMonth + 1).padStart(2, "0");
  var excelyear = printYear;
  var exportToExcel = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var workbook, sheet, tableHeader, headerRow, firstDataRow, lastDataRow, i, row, closingLines, buffer, blob;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            workbook = new ExcelJS.Workbook();
            sheet = workbook.addWorksheet("Bank Advice", {}); // Set column widths
            sheet.columns = [{
              width: 5
            }, {
              width: 20
            }, {
              width: 20
            }, {
              width: 20
            }, {
              width: 20
            }, {
              width: 20
            }, {
              width: 20
            }, {
              width: 20
            }, {
              width: 20
            }, {
              width: 15
            }, {
              width: 15
            }];

            // -----------------------------
            // Header (same as before)
            // -----------------------------
            sheet.mergeCells("A1:K1");
            sheet.getCell("A1").value = "Ref No: EIS.Bank Advice.Benefit.".concat(excelyear, ".").concat(excelmonthFormatted);
            sheet.getCell("A1").font = {
              bold: true
            };
            sheet.mergeCells("A3:K3");
            sheet.getCell("A3").value = "Manager";
            sheet.mergeCells("A4:K4");
            sheet.getCell("A4").value = "Sonali Bank Limited";
            sheet.mergeCells("A5:K5");
            sheet.getCell("A5").value = "Ramna Corporate Branch";
            sheet.mergeCells("A6:K6");
            sheet.getCell("A6").value = "1, Topkhana Road, Ramna, Dhaka, 1000";
            sheet.mergeCells("A8:K8");
            sheet.getCell("A8").value = "Subject: Bank Advice Letter (EIS Top-up Benefit)";
            sheet.getCell("A8").font = {
              bold: true,
              underline: true
            };
            sheet.mergeCells("A10:K10");
            sheet.getCell("A10").value = "Dear Sir:";
            sheet.mergeCells("A12:K12");
            sheet.getCell("A12").value = "Greetings from EIS Pilot!";
            sheet.mergeCells("A14:K14");
            sheet.getCell("A14").value = {
              richText: [{
                text: "EIS Pilot top-up benefits are required to be disbursed to the beneficiaries through bank transfer from your branch of EIS Pilot bank account,"
              }, {
                text: " Account Title: EMPLOYMENT INJURY SCHEME EIS",
                font: {
                  bold: true
                }
              }, {
                text: ", Account Number: 4426302003729",
                font: {
                  bold: true
                }
              }, {
                text: ". The validated list of account holders with their respective Account Titles, Bank Account Numbers, Bank Names, Branch info, Routing Numbers including Payment amounts have been mentioned below."
              }]
            };

            // -----------------------------
            // Table Header
            // -----------------------------
            tableHeader = ["Sl #", "Account Title", "Bank Account Number", "Bank", "Branch", "District", "Routing No.", "Amount (BDT)", "Beneficiary ID", "Pay From", "Pay To"];
            sheet.addRow([]);
            sheet.addRow([]);
            sheet.addRow([]);
            headerRow = sheet.addRow(tableHeader);
            headerRow.eachCell(function (cell) {
              cell.fill = {
                type: "pattern",
                pattern: "solid",
                fgColor: {
                  argb: "92D050"
                }
              };
              cell.font = {
                bold: true
              };
              cell.alignment = {
                horizontal: "center",
                vertical: "middle"
              };
              cell.border = {
                top: {
                  style: "thin"
                },
                left: {
                  style: "thin"
                },
                bottom: {
                  style: "thin"
                },
                right: {
                  style: "thin"
                }
              };
            });

            // const data = eisPayments?.[0] || {};
            // const parsingBankInfo = JSON.parse(data.workforceApplication?.);
            // const parsedBankInfo = JSON.parse(parsingBankInfo);
            // -----------------------------
            // REAL DATA FROM eisPayments
            // -----------------------------
            eisPayments.forEach(function (row, index) {
              var _row$bank, _row$bank2, _row$bank3, _row$bank4;
              // Format month as 01..12
              var year = (row === null || row === void 0 ? void 0 : row.year) || "";
              var monthIndex = (row === null || row === void 0 ? void 0 : row.monthIndex) || "";
              var monthFormatted = String(monthIndex).padStart(2, "0");

              // Pay period values
              var payFrom = "01.".concat(monthFormatted, ".").concat(year);
              var lastDay = new Date(year, monthIndex, 0).getDate();
              var payTo = "".concat(lastDay, ".").concat(monthFormatted, ".").concat(year);
              sheet.addRow([index + 1, (row === null || row === void 0 ? void 0 : row.bankAccountHolderName) || "", (row === null || row === void 0 ? void 0 : row.bankAccountNo) || "", (row === null || row === void 0 || (_row$bank = row.bank) === null || _row$bank === void 0 || (_row$bank = _row$bank.parent) === null || _row$bank === void 0 ? void 0 : _row$bank.nameEn) || "", (row === null || row === void 0 || (_row$bank2 = row.bank) === null || _row$bank2 === void 0 ? void 0 : _row$bank2.nameEn) || "", (row === null || row === void 0 || (_row$bank3 = row.bank) === null || _row$bank3 === void 0 ? void 0 : _row$bank3.districtNameEn) || "", (row === null || row === void 0 || (_row$bank4 = row.bank) === null || _row$bank4 === void 0 ? void 0 : _row$bank4.routingNumber) || "", (row === null || row === void 0 ? void 0 : row.eisMonthlyAmount) || 0, (row === null || row === void 0 ? void 0 : row.beneficiaryId) || "", payFrom, payTo]);
            });

            // -----------------------------
            // Apply border to all data rows
            // -----------------------------
            // Apply border only to table rows (after headerRow)
            firstDataRow = headerRow.number + 1;
            lastDataRow = firstDataRow + eisPayments.length - 1;
            for (i = firstDataRow; i <= lastDataRow; i++) {
              row = sheet.getRow(i);
              row.eachCell(function (cell) {
                cell.border = {
                  top: {
                    style: "thin"
                  },
                  left: {
                    style: "thin"
                  },
                  bottom: {
                    style: "thin"
                  },
                  right: {
                    style: "thin"
                  }
                };
                cell.alignment = {
                  vertical: "middle",
                  horizontal: "left",
                  wrapText: true
                };
              });
            }

            // -----------------------------
            // Add Closing / Signature Section
            // -----------------------------
            sheet.addRow([]);
            sheet.addRow([]);
            closingLines = ["Your prompt necessary steps in this matter will be highly appreciated.", "", "With warm regards", "", "Director General,", "Central Fund, Ministry of Labor and Employment &", "Member Secretary, EIS Pilot Governance Board", "Bangladesh Secretariat, Dhaka-1000", "", "Copy to (Not in order of seniority):", "1. PS to State Minister, Ministry of Labour and Employment, Bangladesh Secretariat, Dhaka-1000.", "2. PS to Secretary, Ministry of Labour and Employment, Bangladesh Secretariat, Dhaka-1000.", "3. Special Advisor, EIS Pilot Special Unit, 196, Sromo Bhaban (9th Floor), Bijoynagar, Dhaka-1000.", "4. PA to Director General, Central Fund, Bangladesh Secretariat, Dhaka-1000.", "5. Assistant Director, Welfare-2 and Development, Central Fund, Bangladesh Secretariat, Dhaka-1000.", "6. Assistant Director, Finance Department, Central Fund, Bangladesh Secretariat, Dhaka-1000."]; // Loop through lines and merge across all 10 columns
            closingLines.forEach(function (line) {
              var row = sheet.addRow([line]);
              sheet.mergeCells("A".concat(row.number, ":J").concat(row.number));
              row.getCell(1).alignment = {
                horizontal: "left",
                vertical: "top",
                wrapText: true
              };
            });

            // -----------------------------
            // Download Excel File
            // -----------------------------
            _context2.next = 39;
            return workbook.xlsx.writeBuffer();
          case 39:
            buffer = _context2.sent;
            blob = new Blob([buffer], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            });
            saveAs(blob, "BA-Advice.xlsx");
          case 42:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function exportToExcel() {
      return _ref3.apply(this, arguments);
    };
  }();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Dialog$1, {
    open: open,
    onClose: onClose,
    maxWidth: "md",
    fullWidth: true
  }, /*#__PURE__*/React.createElement(DialogTitle, {
    disableTypography: true
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6"
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "Eis Bank Payment Advice (BEFTN)"
  }))), /*#__PURE__*/React.createElement(DialogContent$1, {
    dividers: true
  }, eisPayments.length > 0 && function (_firstRow$workforceAp, _firstRow$workforceAp2, _firstRow$workforceAp3) {
    var firstRow = eisPayments[0];
    var employeeInfo = (firstRow === null || firstRow === void 0 ? void 0 : firstRow.workforceApplication.applicationType) === "financialAssistance" ? safeParse(firstRow === null || firstRow === void 0 || (_firstRow$workforceAp = firstRow.workforceApplication) === null || _firstRow$workforceAp === void 0 ? void 0 : _firstRow$workforceAp.deceasedWorkerInfo) : firstRow === null || firstRow === void 0 || (_firstRow$workforceAp2 = firstRow.workforceApplication) === null || _firstRow$workforceAp2 === void 0 ? void 0 : _firstRow$workforceAp2.workforceEmployee;
    var accidentInfo = safeParse(firstRow === null || firstRow === void 0 ? void 0 : firstRow.workforceApplication.employeeAccidentInfo);
    var applicationType = firstRow === null || firstRow === void 0 ? void 0 : firstRow.workforceApplication.applicationType;
    var lastSalary = Number((firstRow === null || firstRow === void 0 || (_firstRow$workforceAp3 = firstRow.workforceApplication) === null || _firstRow$workforceAp3 === void 0 ? void 0 : _firstRow$workforceAp3.lastBaseSalary) || 0);
    return /*#__PURE__*/React.createElement(Paper, {
      elevation: 2,
      style: {
        padding: 16,
        marginBottom: 20
      }
    }, /*#__PURE__*/React.createElement(Grid, {
      container: true,
      spacing: 2
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "h6"
    }, "Worker Information"), /*#__PURE__*/React.createElement(Divider, {
      style: {
        marginTop: 8,
        marginBottom: 16
      }
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 6
    }, /*#__PURE__*/React.createElement("strong", null, "Name of Worker:"), " ", applicationType === "financialAssistance" ? employeeInfo === null || employeeInfo === void 0 ? void 0 : employeeInfo.nameEn : employeeInfo === null || employeeInfo === void 0 ? void 0 : employeeInfo.firstNameEn), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 6
    }, /*#__PURE__*/React.createElement("strong", null, "Application Type:"), " ", applicationType === "financialAssistance" ? "Death" : "Disability"), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 6
    }, applicationType === "financialAssistance" ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("strong", null, "Date of Death:"), " ", new Date(accidentInfo === null || accidentInfo === void 0 ? void 0 : accidentInfo.dateOfDeath).toLocaleDateString("BD-en")) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("strong", null, "Date of Accident:"), " ", new Date(accidentInfo === null || accidentInfo === void 0 ? void 0 : accidentInfo.accidentDate).toLocaleDateString("BD-en"), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("strong", null, "Date of Rejoining:"), " ", new Date(accidentInfo === null || accidentInfo === void 0 ? void 0 : accidentInfo.dateOfRejoining).toLocaleDateString("BD-en"))), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 6
    }, /*#__PURE__*/React.createElement("strong", null, "Last Salary:"), " ", lastSalary.toLocaleString("BD-en", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }))));
  }(), /*#__PURE__*/React.createElement(Table$2, null, /*#__PURE__*/React.createElement(TableHead, null, /*#__PURE__*/React.createElement(TableRow, null, /*#__PURE__*/React.createElement(TableCell, null, "NOA Print"), /*#__PURE__*/React.createElement(TableCell, null, "SL"), /*#__PURE__*/React.createElement(TableCell, null, "Beneficiary ID"), /*#__PURE__*/React.createElement(TableCell, null, "Dependent Info"))), /*#__PURE__*/React.createElement(TableBody, null, eisPayments.map(function (row, index) {
    var _row$workforceEmploye, _row$workforceEmploye2;
    var dependent = (_row$workforceEmploye = row === null || row === void 0 || (_row$workforceEmploye2 = row.workforceEmployeeDependent) === null || _row$workforceEmploye2 === void 0 ? void 0 : _row$workforceEmploye2[0]) !== null && _row$workforceEmploye !== void 0 ? _row$workforceEmploye : null;
    return /*#__PURE__*/React.createElement(TableRow, {
      key: index
    }, /*#__PURE__*/React.createElement(TableCell, null, /*#__PURE__*/React.createElement(Button, {
      size: "small",
      variant: "contained",
      color: "primary",
      onClick: function onClick() {
        return handleRowPrint(row);
      }
    }, "Print")), /*#__PURE__*/React.createElement(TableCell, null, index + 1), /*#__PURE__*/React.createElement(TableCell, null, row === null || row === void 0 ? void 0 : row.beneficiaryId), /*#__PURE__*/React.createElement(TableCell, null, dependent ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography, {
      variant: "subtitle2"
    }, /*#__PURE__*/React.createElement("strong", null, dependent.nameEn)), /*#__PURE__*/React.createElement(Typography, {
      variant: "body2"
    }, RELATION_LABEL_BANGLA_MAP[dependent.relationWithWorker]), /*#__PURE__*/React.createElement(Typography, {
      variant: "body2"
    }, "Age: ", calculateAge(dependent.birthDate))) : /*#__PURE__*/React.createElement(Typography, {
      variant: "body2",
      color: "textSecondary"
    }, "No Dependent")));
  })))), /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement(DialogActions$1, null, /*#__PURE__*/React.createElement(Button, {
    onClick: onClose,
    variant: "outlined",
    color: "primary"
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "workforce.modal.close"
  })), /*#__PURE__*/React.createElement(Button, {
    onClick: exportToExcel,
    variant: "contained",
    color: "success"
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "workforce.modal.excel"
  })))), /*#__PURE__*/React.createElement("div", {
    id: "print-area-container",
    className: classes.printContainer
  }, selectedRow && printReady && /*#__PURE__*/React.createElement(NOAPrintTemplate, {
    row: selectedRow,
    payFrom: selectedRow.payFrom,
    payTo: selectedRow.payTo,
    OtherCompensationAmount: otherCompAmount,
    noaSigner: noaSignerInfo.noaSigner,
    noaSignature: noaSignerInfo.noaSignature
  })));
};
var NOAPrintTemplate = function NOAPrintTemplate(_ref4) {
  var _row$workforceApplica2, _row$workforceEmploye3, _row$workforceEmploye4, _row$workforceEmploye5, _row$workforceApplica3, _row$workforceApplica4, _row$workforceApplica5, _row$workforceApplica6, _ref5, _deceasedWorkerInfo$b, _row$workforceApplica7, _noaSignature$url, _row$workforceApplica8, _row$workforceApplica9, _row$workforceApplica10, _row$workforceApplica11, _row$workforceApplica12, _row$workforceApplica13, _row$workforceApplica14, _row$workforceEmploye6, _row$workforceEmploye7, _row$workforceEmploye8, _row$workforceEmploye9, _row$workforceEmploye10, _row$workforceEmploye11, _row$workforceEmploye12, _row$workforceEmploye13, _noaSigner$workforceC, _noaSigner$workforceC2, _noaSigner$committee;
  var row = _ref4.row;
    _ref4.payFrom;
    _ref4.payTo;
    var OtherCompensationAmount = _ref4.OtherCompensationAmount,
    noaSigner = _ref4.noaSigner,
    noaSignature = _ref4.noaSignature;
  var tryParse = function tryParse(value) {
    if (typeof value === "string") {
      try {
        var parsed = JSON.parse(value);
        if (_typeof(parsed) === "object" && parsed !== null) {
          return parsed;
        }
      } catch (_unused) {
        return value;
      }
    }
    return value;
  };
  var formatAddress = function formatAddress(locationData, addressData) {
    var _address$postOffice, _location$parent, _location$parent2, _location$parent3;
    var address = tryParse(addressData) || {};
    var location = tryParse(locationData) || {};
    var postOffice = (address === null || address === void 0 || (_address$postOffice = address.postOffice) === null || _address$postOffice === void 0 ? void 0 : _address$postOffice.nameBn) || (address === null || address === void 0 ? void 0 : address.postOffice);
    var village = [address.houseName, address.paraMahalla, address.villageRoad].filter(Boolean).join(", ");
    var thana = (location === null || location === void 0 || (_location$parent = location.parent) === null || _location$parent === void 0 ? void 0 : _location$parent.name) || (location === null || location === void 0 ? void 0 : location.name);
    var district = (location === null || location === void 0 || (_location$parent2 = location.parent) === null || _location$parent2 === void 0 || (_location$parent2 = _location$parent2.parent) === null || _location$parent2 === void 0 ? void 0 : _location$parent2.name) || (location === null || location === void 0 || (_location$parent3 = location.parent) === null || _location$parent3 === void 0 ? void 0 : _location$parent3.name);
    return {
      village: village,
      postOffice: postOffice,
      thana: thana,
      district: district
    };
  };
  var employeePresentAddress = formatAddress(row === null || row === void 0 || (_row$workforceApplica2 = row.workforceApplication) === null || _row$workforceApplica2 === void 0 || (_row$workforceApplica2 = _row$workforceApplica2.workforceEmployee) === null || _row$workforceApplica2 === void 0 ? void 0 : _row$workforceApplica2.presentLocation, row === null || row === void 0 || (_row$workforceEmploye3 = row.workforceEmployee) === null || _row$workforceEmploye3 === void 0 ? void 0 : _row$workforceEmploye3.employeePresentAddress);
  var depentPresentAddress = formatAddress(row === null || row === void 0 || (_row$workforceEmploye4 = row.workforceEmployeeDependent) === null || _row$workforceEmploye4 === void 0 || (_row$workforceEmploye4 = _row$workforceEmploye4[0]) === null || _row$workforceEmploye4 === void 0 ? void 0 : _row$workforceEmploye4.presentLocation, row === null || row === void 0 || (_row$workforceEmploye5 = row.workforceEmployeeDependent) === null || _row$workforceEmploye5 === void 0 || (_row$workforceEmploye5 = _row$workforceEmploye5[0]) === null || _row$workforceEmploye5 === void 0 ? void 0 : _row$workforceEmploye5.depentPresentAddress);
  var cfAndEisAmount = (parseFloat(row === null || row === void 0 ? void 0 : row.eisMonthlyAmount) || 0) + (parseFloat(OtherCompensationAmount) || 0);
  var applicationType = row === null || row === void 0 || (_row$workforceApplica3 = row.workforceApplication) === null || _row$workforceApplica3 === void 0 ? void 0 : _row$workforceApplica3.applicationType;
  var jsonEmployeeAccidentInfo = safeParse((row === null || row === void 0 || (_row$workforceApplica4 = row.workforceApplication) === null || _row$workforceApplica4 === void 0 ? void 0 : _row$workforceApplica4.employeeAccidentInfo) || "{}");
  console.log({
    jsonEmployeeAccidentInfo: jsonEmployeeAccidentInfo
  });
  var employeeAccidentInfo = jsonEmployeeAccidentInfo;
  var jsonDoctorEntryInfo = safeParse((row === null || row === void 0 || (_row$workforceApplica5 = row.workforceApplication) === null || _row$workforceApplica5 === void 0 ? void 0 : _row$workforceApplica5.doctorsEntry) || "{}");
  console.log({
    jsonDoctorEntryInfo: jsonDoctorEntryInfo
  });
  var doctorEntryInfo = jsonDoctorEntryInfo;

  // Use absolute paths for assets (adjust if your public folder path is different)
  var logo = /*#__PURE__*/React.createElement("img", {
    src: window.location.origin + "/front/workforce_assets/centralfund.png",
    alt: "Central Fund Logo",
    style: {
      width: "70px",
      position: "absolute",
      top: "0",
      right: "0"
    }
  });
  var eisLogo = /*#__PURE__*/React.createElement("img", {
    src: window.location.origin + "/front/workforce_assets/eis.png",
    alt: "EIS Logo",
    style: {
      width: "80px",
      position: "absolute",
      top: "8pt",
      left: "0"
    }
  });
  var deceasedWorkerInfo = safeParse(row === null || row === void 0 || (_row$workforceApplica6 = row.workforceApplication) === null || _row$workforceApplica6 === void 0 ? void 0 : _row$workforceApplica6.deceasedWorkerInfo);
  var workerBirthDate = (_ref5 = (_deceasedWorkerInfo$b = deceasedWorkerInfo === null || deceasedWorkerInfo === void 0 ? void 0 : deceasedWorkerInfo.birthDate) !== null && _deceasedWorkerInfo$b !== void 0 ? _deceasedWorkerInfo$b : row === null || row === void 0 || (_row$workforceApplica7 = row.workforceApplication) === null || _row$workforceApplica7 === void 0 || (_row$workforceApplica7 = _row$workforceApplica7.workforceEmployee) === null || _row$workforceApplica7 === void 0 ? void 0 : _row$workforceApplica7.birthDate) !== null && _ref5 !== void 0 ? _ref5 : "2026-01-01";
  var paymentType = row === null || row === void 0 ? void 0 : row.eisPaymentType;
  console.log("noa signature", noaSignature);
  var noaSignatureLogo = /*#__PURE__*/React.createElement("img", {
    src: window.location.origin + ((_noaSignature$url = noaSignature === null || noaSignature === void 0 ? void 0 : noaSignature.url) !== null && _noaSignature$url !== void 0 ? _noaSignature$url : ""),
    alt: "Central Fund Logo",
    style: {
      height: "70px"
    }
  });
  return /*#__PURE__*/React.createElement("div", {
    className: "noa-page"
  }, /*#__PURE__*/React.createElement("div", {
    className: "noa-header"
  }, /*#__PURE__*/React.createElement("div", null, eisLogo, /*#__PURE__*/React.createElement("p", {
    style: {
      margin: 0
    }
  }, "\u09AC\u09CD\u09AF\u0995\u09CD\u09A4\u09BF\u0997\u09A4"), /*#__PURE__*/React.createElement("h3", {
    style: {
      margin: "5px 0"
    }
  }, "\u098F\u09AE\u09AA\u09CD\u09B2\u09AF\u09BC\u09AE\u09C7\u09A8\u09CD\u099F \u0987\u09A8\u099C\u09C1\u09B0\u09BF \u09B8\u09CD\u0995\u09C0\u09AE-(\u0987.\u0986\u0987.\u098F\u09B8) \u09AA\u09BE\u0987\u09B2\u099F"), /*#__PURE__*/React.createElement("p", {
    style: {
      margin: "2px 0"
    }
  }, "\u09E7\u09EF\u09EC, \u09E7\u09E6\u09AE \u09A4\u09B2\u09BE, \u09B6\u09CD\u09B0\u09AE \u09AD\u09AC\u09A8, \u09B6\u09B9\u09C0\u09A6 \u09B8\u09C8\u09AF\u09BC\u09A6 \u09A8\u099C\u09B0\u09C1\u09B2 \u0987\u09B8\u09B2\u09BE\u09AE \u09B8\u09B0\u09A8\u09C0, \u09AC\u09BF\u099C\u09AF\u09BC\u09A8\u0997\u09B0, \u09A2\u09BE\u0995\u09BE-\u09E7\u09E6\u09E6\u09E6"), logo, /*#__PURE__*/React.createElement("p", {
    style: {
      margin: "2px 0"
    }
  }, "\u09AE\u09CB\u09AC\u09BE\u0987\u09B2: \u09E6\u09E7\u09EE\u09EE\u09EC-\u09EF\u09E8\u09E7\u09E6\u09E9\u09E6 | \u0987-\u09AE\u09C7\u0987\u09B2: verification@eis-pilot-bd.org | \u0993\u09AF\u09BC\u09C7\u09AC\u09B8\u09BE\u0987\u099F: eis-pilot-bd.org"), /*#__PURE__*/React.createElement("h4", {
    style: {
      margin: "10px 0"
    }
  }, applicationType === "financialAssistance" ? "নোটিশ অফ অ্যাওয়ার্ড- কর্মরত অবস্থায় দুর্ঘটনাজনিত মৃত্যু" : applicationType === "disabilityAssistance" ? "নোটিশ অফ অ্যাওয়ার্ড- কর্মরত অবস্থায় দুর্ঘটনাজনিত স্থায়ী আংশিক/সম্পূর্ণ অক্ষমতা" : ""), /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      justifyContent: "space-between",
      padding: "0 25mm",
      marginTop: "10px"
    }
  }, /*#__PURE__*/React.createElement("span", null, "\u09B8\u09C2\u09A4\u09CD\u09B0: ", (row === null || row === void 0 ? void 0 : row.beneficiaryId) || ""), /*#__PURE__*/React.createElement("span", null, "\u09A4\u09BE\u09B0\u09BF\u0996: ", new Date().toLocaleDateString("bn-BD"))))), /*#__PURE__*/React.createElement("div", {
    className: "noa-body"
  }, /*#__PURE__*/React.createElement("table", {
    className: "noa-table"
  }, /*#__PURE__*/React.createElement("tbody", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    colSpan: 2,
    className: "noa-section"
  }, applicationType === "financialAssistance" ? "মৃত" : "অক্ষম", " \u09B6\u09CD\u09B0\u09AE\u09BF\u0995\u09C7\u09B0 \u09A4\u09A5\u09CD\u09AF:")), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    className: "noa-label"
  }, "\u09B6\u09CD\u09B0\u09AE\u09BF\u0995\u09C7\u09B0 \u09A8\u09BE\u09AE:"), /*#__PURE__*/React.createElement("td", {
    className: "noa-value"
  }, (row === null || row === void 0 || (_row$workforceApplica8 = row.workforceApplication) === null || _row$workforceApplica8 === void 0 || (_row$workforceApplica8 = _row$workforceApplica8.workforceEmployee) === null || _row$workforceApplica8 === void 0 ? void 0 : _row$workforceApplica8.firstNameBn) || "")), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    className: "noa-label"
  }, "\u09B6\u09CD\u09B0\u09AE\u09BF\u0995\u09C7\u09B0 \u099C\u09BE\u09A4\u09C0\u09AF\u09BC \u09AA\u09B0\u09BF\u099A\u09AF\u09BC\u09AA\u09A4\u09CD\u09B0 \u09A8\u09AE\u09CD\u09AC\u09B0:"), /*#__PURE__*/React.createElement("td", {
    className: "noa-value"
  }, row !== null && row !== void 0 && (_row$workforceApplica9 = row.workforceApplication) !== null && _row$workforceApplica9 !== void 0 && (_row$workforceApplica9 = _row$workforceApplica9.workforceEmployee) !== null && _row$workforceApplica9 !== void 0 && _row$workforceApplica9.nid ? toBanglaNumber(row === null || row === void 0 || (_row$workforceApplica10 = row.workforceApplication) === null || _row$workforceApplica10 === void 0 || (_row$workforceApplica10 = _row$workforceApplica10.workforceEmployee) === null || _row$workforceApplica10 === void 0 ? void 0 : _row$workforceApplica10.nid) : "")), applicationType === "disabilityAssistance" && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    className: "noa-label"
  }, "\u09B6\u09CD\u09B0\u09AE\u09BF\u0995\u09C7\u09B0 \u099C\u09A8\u09CD\u09AE \u09A4\u09BE\u09B0\u09BF\u0996:"), /*#__PURE__*/React.createElement("td", {
    className: "noa-value"
  }, row !== null && row !== void 0 && (_row$workforceApplica11 = row.workforceApplication) !== null && _row$workforceApplica11 !== void 0 && (_row$workforceApplica11 = _row$workforceApplica11.workforceEmployee) !== null && _row$workforceApplica11 !== void 0 && _row$workforceApplica11.birthDate ? new Date(row === null || row === void 0 || (_row$workforceApplica12 = row.workforceApplication) === null || _row$workforceApplica12 === void 0 || (_row$workforceApplica12 = _row$workforceApplica12.workforceEmployee) === null || _row$workforceApplica12 === void 0 ? void 0 : _row$workforceApplica12.birthDate).toLocaleDateString("bn-BD") : ""))), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    className: "noa-label"
  }, "\u09A0\u09BF\u0995\u09BE\u09A8\u09BE:"), /*#__PURE__*/React.createElement("td", {
    className: "noa-value"
  }, "\u0997\u09CD\u09B0\u09BE\u09AE\u0983 ", (employeePresentAddress === null || employeePresentAddress === void 0 ? void 0 : employeePresentAddress.village) || "", ", \u09A1\u09BE\u0995\u0998\u09B0\u0983 ", (employeePresentAddress === null || employeePresentAddress === void 0 ? void 0 : employeePresentAddress.postOffice) || "", " , ", /*#__PURE__*/React.createElement("br", null), "\u0989\u09AA\u099C\u09C7\u09B2\u09BE/\u09A5\u09BE\u09A8\u09BE\u0983 ", (employeePresentAddress === null || employeePresentAddress === void 0 ? void 0 : employeePresentAddress.thana) || "", ", \u099C\u09C7\u09B2\u09BE\u0983  ", (employeePresentAddress === null || employeePresentAddress === void 0 ? void 0 : employeePresentAddress.district) || "")), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    className: "noa-label"
  }, "\u0995\u09B0\u09CD\u09AE\u09B8\u09CD\u09A5\u09B2\u09C7 \u09A6\u09C1\u09B0\u09CD\u0998\u099F\u09A8\u09BE\u09B0 \u09A4\u09BE\u09B0\u09BF\u0996:"), /*#__PURE__*/React.createElement("td", {
    className: "noa-value"
  }, employeeAccidentInfo !== null && employeeAccidentInfo !== void 0 && employeeAccidentInfo.accidentDate ? new Date(employeeAccidentInfo === null || employeeAccidentInfo === void 0 ? void 0 : employeeAccidentInfo.accidentDate).toLocaleDateString("bn-BD") : "")), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    className: "noa-label"
  }, "\u09AF\u09C7 \u0995\u09BE\u09B0\u0996\u09BE\u09A8\u09BE\u09AF\u09BC \u09A6\u09C1\u09B0\u09CD\u0998\u099F\u09A8\u09BE \u0998\u099F\u09C7\u099B\u09C7 \u09A4\u09BE\u09B0 \u09A8\u09BE\u09AE:"), /*#__PURE__*/React.createElement("td", {
    className: "noa-value"
  }, (row === null || row === void 0 || (_row$workforceApplica13 = row.workforceApplication) === null || _row$workforceApplica13 === void 0 || (_row$workforceApplica13 = _row$workforceApplica13.employeeFactory) === null || _row$workforceApplica13 === void 0 ? void 0 : _row$workforceApplica13.nameBn) || "")), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    className: "noa-label"
  }, "\u09A6\u09C1\u09B0\u09CD\u0998\u099F\u09A8\u09BE \u0998\u099F\u09BE\u09B0 \u09B8\u09AE\u09AF\u09BC\u0995\u09BE\u09B2\u09C0\u09A8 \u09B6\u09CD\u09B0\u09AE\u09BF\u0995\u09C7\u09B0 \u09AE\u09BE\u09B8\u09BF\u0995 \u09AE\u099C\u09C1\u09B0\u09BF:"), /*#__PURE__*/React.createElement("td", {
    className: "noa-value"
  }, Number(row === null || row === void 0 || (_row$workforceApplica14 = row.workforceApplication) === null || _row$workforceApplica14 === void 0 ? void 0 : _row$workforceApplica14.lastBaseSalary).toLocaleString("bn-BD") || "")), applicationType === "disabilityAssistance" && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    className: "noa-label"
  }, "\u09AA\u09C1\u09A8\u09B0\u09BE\u09AF\u09BC \u0995\u09B0\u09CD\u09AE\u09B8\u09CD\u09A5\u09B2\u09C7 \u09AF\u09CB\u0997\u09A6\u09BE\u09A8\u09C7\u09B0 \u09A4\u09BE\u09B0\u09BF\u0996: (\u09AE\u09BE\u09B8/\u09A6\u09BF\u09A8/\u09AC\u099B\u09B0)"), /*#__PURE__*/React.createElement("td", {
    className: "noa-value"
  }, employeeAccidentInfo !== null && employeeAccidentInfo !== void 0 && employeeAccidentInfo.dateOfRejoining ? new Date(employeeAccidentInfo === null || employeeAccidentInfo === void 0 ? void 0 : employeeAccidentInfo.dateOfRejoining).toLocaleDateString("bn-BD") : "")), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    className: "noa-label"
  }, "\u09B8\u09CD\u09A5\u09BE\u09AF\u09BC\u09C0 \u0985\u0995\u09CD\u09B7\u09AE\u09A4\u09BE\u09B0 (\u0989\u09AA\u09BE\u09B0\u09CD\u099C\u09A8\u0995\u09CD\u09B7\u09AE\u09A4\u09BE \u09B9\u09CD\u09B0\u09BE\u09B8) \u09B9\u09BE\u09B0:"), /*#__PURE__*/React.createElement("td", {
    className: "noa-value"
  }, Number(doctorEntryInfo === null || doctorEntryInfo === void 0 ? void 0 : doctorEntryInfo.disabilityPerSchedule).toLocaleString("bn-BD") || "0", "%")), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    className: "noa-label"
  }, "\u09B8\u09CD\u09A5\u09BE\u09AF\u09BC\u09C0 \u0985\u0995\u09CD\u09B7\u09AE\u09A4\u09BE \u09A8\u09BF\u09B0\u09C0\u0995\u09CD\u09B7\u09A3\u09C7\u09B0 \u09A4\u09BE\u09B0\u09BF\u0996:"), /*#__PURE__*/React.createElement("td", {
    className: "noa-value"
  }, doctorEntryInfo !== null && doctorEntryInfo !== void 0 && doctorEntryInfo.dateOfAssessment ? new Date(doctorEntryInfo === null || doctorEntryInfo === void 0 ? void 0 : doctorEntryInfo.dateOfAssessment).toLocaleDateString("bn-BD") : "")), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    className: "noa-label"
  }, "\u09B6\u09CD\u09B0\u09AE\u09BF\u0995\u09C7\u09B0 \u098F\u09AE.\u0986\u0987.\u098F\u09B8 \u0986\u0987\u09A1\u09BF \u09A8\u09AE\u09CD\u09AC\u09B0:"), /*#__PURE__*/React.createElement("td", {
    className: "noa-value"
  }, (row === null || row === void 0 ? void 0 : row.beneficiaryId) || "")), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    className: "noa-label"
  }, "\u0995\u09C7\u09A8\u09CD\u09A6\u09CD\u09B0\u09C0\u09AF\u09BC \u09A4\u09B9\u09AC\u09BF\u09B2 \u09A5\u09C7\u0995\u09C7 \u09AA\u09CD\u09B0\u09A6\u09A4\u09CD\u09A4 \u0985\u09B0\u09CD\u09A5\u09C7\u09B0 \u09AA\u09B0\u09BF\u09AE\u09BE\u09A3:"), /*#__PURE__*/React.createElement("td", {
    className: "noa-value"
  }, "  ", OtherCompensationAmount ? Number(OtherCompensationAmount).toLocaleString("bn-BD", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }) : "")), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    colSpan: 2,
    className: "noa-section"
  }, "\u09AE\u09BE\u09B8\u09BF\u0995 \u09AA\u09CD\u09B0\u09A6\u09C7\u09AF\u09BC \u099F\u09AA-\u0986\u09AA \u09AC\u09C7\u09A8\u09C7\u09AB\u09BF\u099F\u09C7\u09B0 \u09A4\u09A5\u09CD\u09AF:")), (paymentType === "onetime" || paymentType === "installment") && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    className: "noa-label"
  }, "\u09B8\u09B0\u09CD\u09AC\u09AE\u09CB\u099F \u09AA\u09CD\u09B0\u09A6\u09C7\u09AF\u09BC \u0987.\u0986\u0987.\u098F\u09B8 \u099F\u09AA-\u0986\u09AA \u09AC\u09C7\u09A8\u09C7\u09AB\u09BF\u099F\u09C7\u09B0 \u09AA\u09B0\u09BF\u09AE\u09BE\u09A3:"), /*#__PURE__*/React.createElement("td", {
    className: "noa-value"
  }, " ", cfAndEisAmount ? Number(cfAndEisAmount).toLocaleString("bn-BD", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }) : "")), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    className: "noa-label"
  }, "\u09AE\u09BE\u09B8\u09BF\u0995 \u0987.\u0986\u0987.\u098F\u09B8 \u099F\u09AA-\u0986\u09AA \u09AC\u09C7\u09A8\u09BF\u09AB\u09BF\u099F\u09C7\u09B0 \u0995\u09BE\u09B0\u09CD\u09AF\u0995\u09B0\u09C0 \u09A4\u09BE\u09B0\u09BF\u0996:"), /*#__PURE__*/React.createElement("td", {
    className: "noa-value"
  }, row !== null && row !== void 0 && row.processingDate ? new Date(row === null || row === void 0 ? void 0 : row.processingDate).toLocaleDateString("bn-BD") : ""))), paymentType === "monthly" && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    className: "noa-label"
  }, "\u09AE\u09BE\u09B8\u09BF\u0995 \u09AA\u09CD\u09B0\u09A6\u09C7\u09DF \u0987.\u0986\u0987.\u098F\u09B8 \u099F\u09AA-\u0986\u09AA \u09AC\u09C7\u09A8\u09C7\u09AB\u09BF\u099F\u09C7\u09B0 \u09AA\u09B0\u09BF\u09AE\u09BE\u09A3:"), /*#__PURE__*/React.createElement("td", {
    className: "noa-value"
  }, row !== null && row !== void 0 && row.eisMonthlyAmount ? Number(row.eisMonthlyAmount).toLocaleString("bn-BD", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }) : "")), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    className: "noa-label"
  }, "\u09AE\u09BE\u09B8\u09BF\u0995 \u0987.\u0986\u0987.\u098F\u09B8 \u099F\u09AA-\u0986\u09AA \u09AC\u09C7\u09A8\u09BF\u09AB\u09BF\u099F\u09C7\u09B0 \u0995\u09BE\u09B0\u09CD\u09AF\u0995\u09B0\u09C0 \u09A4\u09BE\u09B0\u09BF\u0996:"), /*#__PURE__*/React.createElement("td", {
    className: "noa-value"
  }, row !== null && row !== void 0 && row.processingDate ? new Date(row === null || row === void 0 ? void 0 : row.processingDate).toLocaleDateString("bn-BD") : "")))), applicationType === "financialAssistance" && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    className: "noa-label"
  }, "\u09AE\u09C3\u09A4\u09CD\u09AF\u09C1\u09B0 \u09A4\u09BE\u09B0\u09BF\u0996:"), /*#__PURE__*/React.createElement("td", {
    className: "noa-value"
  }, employeeAccidentInfo !== null && employeeAccidentInfo !== void 0 && employeeAccidentInfo.dateOfDeath ? new Date(employeeAccidentInfo === null || employeeAccidentInfo === void 0 ? void 0 : employeeAccidentInfo.dateOfDeath).toLocaleDateString("bn-BD") : "")), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    colSpan: 2,
    className: "noa-section"
  }, "\u0989\u09AA\u09AF\u09C1\u0995\u09CD\u09A4 \u09A8\u09BF\u09B0\u09CD\u09AD\u09B0\u09B6\u09C0\u09B2 \u09AC\u09CD\u09AF\u0995\u09CD\u09A4\u09BF\u09B0 \u09A4\u09A5\u09CD\u09AF:")), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    className: "noa-label"
  }, "\u0989\u09AA\u09AF\u09C1\u0995\u09CD\u09A4 \u09A8\u09BF\u09B0\u09CD\u09AD\u09B0\u09B6\u09C0\u09B2\u09C7\u09B0 \u09A8\u09BE\u09AE:"), /*#__PURE__*/React.createElement("td", {
    className: "noa-value"
  }, (row === null || row === void 0 || (_row$workforceEmploye6 = row.workforceEmployeeDependent) === null || _row$workforceEmploye6 === void 0 || (_row$workforceEmploye6 = _row$workforceEmploye6[0]) === null || _row$workforceEmploye6 === void 0 ? void 0 : _row$workforceEmploye6.nameBn) || "")), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    className: "noa-label"
  }, "\u09AE\u09C3\u09A4 \u09B6\u09CD\u09B0\u09AE\u09BF\u0995\u09C7\u09B0 \u09B8\u09BE\u09A5\u09C7 \u09B8\u09AE\u09CD\u09AA\u09B0\u09CD\u0995:"), /*#__PURE__*/React.createElement("td", {
    className: "noa-value"
  }, RELATION_LABEL_BANGLA_MAP[(row === null || row === void 0 || (_row$workforceEmploye7 = row.workforceEmployeeDependent) === null || _row$workforceEmploye7 === void 0 || (_row$workforceEmploye7 = _row$workforceEmploye7[0]) === null || _row$workforceEmploye7 === void 0 ? void 0 : _row$workforceEmploye7.relationWithWorker) || ""])), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    className: "noa-label"
  }, "\u09A8\u09BF\u09B0\u09CD\u09AD\u09B0\u09B6\u09C0\u09B2 \u09AC\u09CD\u09AF\u0995\u09CD\u09A4\u09BF\u09B0 \u099C\u09BE\u09A4\u09C0\u09AF\u09BC \u09AA\u09B0\u09BF\u099A\u09AF\u09BC\u09AA\u09A4\u09CD\u09B0 / \u099C\u09A8\u09CD\u09AE\u09B8\u09A8\u09A6 \u09A8\u09AE\u09CD\u09AC\u09B0:"), /*#__PURE__*/React.createElement("td", {
    className: "noa-value"
  }, row !== null && row !== void 0 && (_row$workforceEmploye8 = row.workforceEmployeeDependent) !== null && _row$workforceEmploye8 !== void 0 && (_row$workforceEmploye8 = _row$workforceEmploye8[0]) !== null && _row$workforceEmploye8 !== void 0 && _row$workforceEmploye8.nid ? toBanglaNumber(row === null || row === void 0 || (_row$workforceEmploye9 = row.workforceEmployeeDependent) === null || _row$workforceEmploye9 === void 0 || (_row$workforceEmploye9 = _row$workforceEmploye9[0]) === null || _row$workforceEmploye9 === void 0 ? void 0 : _row$workforceEmploye9.nid) : "")), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    className: "noa-label"
  }, "\u09A8\u09BF\u09B0\u09CD\u09AD\u09B0\u09B6\u09C0\u09B2 \u09AC\u09CD\u09AF\u0995\u09CD\u09A4\u09BF\u09B0 \u099C\u09A8\u09CD\u09AE \u09A4\u09BE\u09B0\u09BF\u0996: ", /*#__PURE__*/React.createElement("br", null), " (\u09AE\u09BE\u09B8/\u09A6\u09BF\u09A8/\u09AC\u099B\u09B0)"), /*#__PURE__*/React.createElement("td", {
    className: "noa-value"
  }, row !== null && row !== void 0 && (_row$workforceEmploye10 = row.workforceEmployeeDependent) !== null && _row$workforceEmploye10 !== void 0 && (_row$workforceEmploye10 = _row$workforceEmploye10[0]) !== null && _row$workforceEmploye10 !== void 0 && _row$workforceEmploye10.birthDate ? new Date(row === null || row === void 0 || (_row$workforceEmploye11 = row.workforceEmployeeDependent) === null || _row$workforceEmploye11 === void 0 || (_row$workforceEmploye11 = _row$workforceEmploye11[0]) === null || _row$workforceEmploye11 === void 0 ? void 0 : _row$workforceEmploye11.birthDate).toLocaleDateString("bn-BD") : "")), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    className: "noa-label"
  }, "\u09A0\u09BF\u0995\u09BE\u09A8\u09BE:"), /*#__PURE__*/React.createElement("td", {
    className: "noa-value"
  }, depentPresentAddress !== null && depentPresentAddress !== void 0 && depentPresentAddress.village ? "".concat(depentPresentAddress.village, ", ") : "", depentPresentAddress !== null && depentPresentAddress !== void 0 && depentPresentAddress.postOffice ? "".concat(depentPresentAddress.postOffice, ", ") : "", depentPresentAddress !== null && depentPresentAddress !== void 0 && depentPresentAddress.thana ? "".concat(depentPresentAddress.thana, ", ") : "", (depentPresentAddress === null || depentPresentAddress === void 0 ? void 0 : depentPresentAddress.district) || "")), calculateAge(row === null || row === void 0 || (_row$workforceEmploye12 = row.workforceEmployeeDependent) === null || _row$workforceEmploye12 === void 0 || (_row$workforceEmploye12 = _row$workforceEmploye12[0]) === null || _row$workforceEmploye12 === void 0 ? void 0 : _row$workforceEmploye12.birthDate) >= 18 ? /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    className: "noa-label"
  }, "\u0985\u09AA\u09CD\u09B0\u09BE\u09AA\u09CD\u09A4 \u09AC\u09AF\u09BC\u09B8\u09CD\u0995 \u09A8\u09BF\u09B0\u09CD\u09AD\u09B0\u09B6\u09C0\u09B2 \u09AC\u09CD\u09AF\u0995\u09CD\u09A4\u09BF\u09B0 \u0986\u0987\u09A8\u0997\u09A4 \u0985\u09AD\u09BF\u09AD\u09BE\u09AC\u0995:"), /*#__PURE__*/React.createElement("td", {
    className: "noa-value"
  })) : null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    className: "noa-label"
  }, "\u098F\u09AE.\u0986\u0987.\u098F\u09B8 \u09AC\u09C7\u09A8\u09BF\u09AB\u09BF\u09B6\u09BF\u09AF\u09BC\u09BE\u09B0\u09BF \u09A8\u09AE\u09CD\u09AC\u09B0:"), /*#__PURE__*/React.createElement("td", {
    className: "noa-value"
  }, (row === null || row === void 0 ? void 0 : row.beneficiaryId) || "")), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    className: "noa-label"
  }, "\u0995\u09C7\u09A8\u09CD\u09A6\u09CD\u09B0\u09C0\u09AF\u09BC \u09A4\u09B9\u09AC\u09BF\u09B2 \u09A5\u09C7\u0995\u09C7 \u09AA\u09CD\u09B0\u09A6\u09A4\u09CD\u09A4 \u0985\u09B0\u09CD\u09A5\u09C7\u09B0 \u09AA\u09B0\u09BF\u09AE\u09BE\u09A3:"), /*#__PURE__*/React.createElement("td", {
    className: "noa-value"
  }, OtherCompensationAmount ? Number(OtherCompensationAmount).toLocaleString("bn-BD", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }) : "")), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    colSpan: 2,
    className: "noa-section"
  }, "\u09AE\u09BE\u09B8\u09BF\u0995 \u09AA\u09CD\u09B0\u09A6\u09C7\u09AF\u09BC \u099F\u09AA-\u0986\u09AA \u09AC\u09C7\u09A8\u09C7\u09AB\u09BF\u099F\u09C7\u09B0 \u09A4\u09A5\u09CD\u09AF:")), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    className: "noa-label"
  }, "\u09AE\u09BE\u09B8\u09BF\u0995 \u09AA\u09CD\u09B0\u09A6\u09C7\u09AF\u09BC \u0987.\u0986\u0987.\u098F\u09B8 \u099F\u09AA-\u0986\u09AA \u09AC\u09C7\u09A8\u09C7\u09AB\u09BF\u099F\u09C7\u09B0 \u09AA\u09B0\u09BF\u09AE\u09BE\u09A3:"), /*#__PURE__*/React.createElement("td", {
    className: "noa-value"
  }, row.eisInitialMonthlyAmount ? Number(row.eisInitialMonthlyAmount).toLocaleString("bn-BD", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }) : "")), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    className: "noa-label"
  }, "\u0995\u09C7\u09A8\u09CD\u09A6\u09CD\u09B0\u09C0\u09AF\u09BC \u09A4\u09B9\u09AC\u09BF\u09B2 \u09AA\u09CD\u09B0\u09A6\u09A4\u09CD\u09A4 \u0985\u09B0\u09CD\u09A5 \u09B8\u09AE\u09A8\u09CD\u09A8\u09AF\u09BC\u09C7\u09B0 \u09AA\u09B0 \u09AA\u09CD\u09B0\u09A6\u09C7\u09AF\u09BC", /*#__PURE__*/React.createElement("br", null), "\u09AE\u09BE\u09B8\u09BF\u0995 \u0987.\u0986\u0987.\u098F\u09B8 \u099F\u09AA-\u0986\u09AA \u09AC\u09C7\u09A8\u09C7\u09AB\u09BF\u099F\u09C7\u09B0 \u09AA\u09B0\u09BF\u09AE\u09BE\u09A3:"), /*#__PURE__*/React.createElement("td", {
    className: "noa-value"
  }, row !== null && row !== void 0 && row.eisMonthlyAmount ? Number(row.eisMonthlyAmount).toLocaleString("bn-BD", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }) : "")), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    className: "noa-label"
  }, "\u09AE\u09BE\u09B8\u09BF\u0995 \u0987.\u0986\u0987.\u098F\u09B8 \u099F\u09AA-\u0986\u09AA \u09AC\u09C7\u09A8\u09BF\u09AB\u09BF\u099F\u09C7\u09B0 \u0995\u09BE\u09B0\u09CD\u09AF\u0995\u09B0\u09C0 \u09A4\u09BE\u09B0\u09BF\u0996:"), /*#__PURE__*/React.createElement("td", {
    className: "noa-value"
  }, applicationType == 'financialAssistance' ? new Date(employeeAccidentInfo.dateOfDeath).toLocaleDateString("bn-BD") : employeeAccidentInfo.dateOfRejoining ? new Date(employeeAccidentInfo.dateOfRejoining).toLocaleDateString("bn-BD") : new Date(employeeAccidentInfo.accidentDate).toLocaleDateString("bn-BD")))))), /*#__PURE__*/React.createElement("div", {
    className: "noa-additional-info"
  }, getFooterContentNew(row === null || row === void 0 || (_row$workforceEmploye13 = row.workforceEmployeeDependent) === null || _row$workforceEmploye13 === void 0 ? void 0 : _row$workforceEmploye13[0], workerBirthDate, applicationType, paymentType))), /*#__PURE__*/React.createElement("div", {
    className: "noa-footer"
  }, /*#__PURE__*/React.createElement("div", {
    className: "noa-signature"
  }, noaSignatureLogo, /*#__PURE__*/React.createElement("p", {
    style: {
      margin: "2px 0"
    }
  }, noaSigner === null || noaSigner === void 0 || (_noaSigner$workforceC = noaSigner.workforceCommitteeUser) === null || _noaSigner$workforceC === void 0 ? void 0 : _noaSigner$workforceC.designation), /*#__PURE__*/React.createElement("p", {
    style: {
      margin: "2px 0"
    }
  }, noaSigner === null || noaSigner === void 0 || (_noaSigner$workforceC2 = noaSigner.workforceCommitteeUser) === null || _noaSigner$workforceC2 === void 0 ? void 0 : _noaSigner$workforceC2.organizationName), /*#__PURE__*/React.createElement("p", {
    style: {
      margin: "2px 0"
    }
  }, "\u0993"), /*#__PURE__*/React.createElement("p", {
    style: {
      margin: "2px 0"
    }
  }, noaSigner === null || noaSigner === void 0 ? void 0 : noaSigner.roleInCommittee, ", ", noaSigner === null || noaSigner === void 0 || (_noaSigner$committee = noaSigner.committee) === null || _noaSigner$committee === void 0 ? void 0 : _noaSigner$committee.nameBn))));
};

function ownKeys$F(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$F(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$F(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$F(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _createForOfIteratorHelper$2(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray$2(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray$2(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray$2(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray$2(r, a) : void 0; } }
function _arrayLikeToArray$2(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var useStyles$L = makeStyles(function (theme) {
  return {
    noPrint: {
      '@media print': {
        display: 'none !important'
      }
    },
    dialogPaper: {
      minWidth: "90vw",
      "@media print": {
        boxShadow: "none",
        border: "none",
        minWidth: "100%",
        margin: 0,
        maxWidth: "100% !important" // Ensure full width print
      }
    },
    dialogContent: {
      backgroundColor: "#fff",
      padding: theme.spacing(4),
      "@media print": {
        padding: "0px !important",
        overflow: "visible !important"
      }
    },
    "@global": {
      "@media print": {
        "body *": {
          visibility: "hidden"
        },
        "#printable-content, #printable-content *": {
          visibility: "visible"
        },
        "#printable-content": {
          position: "absolute",
          left: 0,
          top: 0,
          width: "100%"
        },
        // Hide scrollbars in print
        "html, body": {
          height: "100%",
          overflow: "hidden"
        }
      }
    }
  };
});
var GenereteEisDependentBFTN = function GenereteEisDependentBFTN(_ref) {
  var _reduxState$core, _parsedAccidentInfo, _parsedAccidentInfo2, _parsedAccidentInfo3, _parsedDoctorEntry, _first$workforceAppli10, _first$workforceAppli11, _first$workforceAppli12, _first$workforceAppli13, _first$workforceAppli14, _first$workforceAppli15, _parsedDoctorEntry2, _parsedAccidentInfo4, _parsedAccidentInfo5, _first$workforceAppli16, _first$workforceAppli17, _first$workforceAppli18, _first$workforceAppli19;
  var open = _ref.open,
    onClose = _ref.onClose,
    userRights = _ref.userRights;
    _ref.status;
    _ref.summary_Id;
    var selectedApplicationIds = _ref.selectedApplicationIds;
  var reduxState = useSelector(function (state) {
    return state;
  });
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    eisPayments = _useState2[0],
    setEisPayments = _useState2[1];
  useSelector(function (state) {
    var _state$worforce;
    return state === null || state === void 0 || (_state$worforce = state.worforce) === null || _state$worforce === void 0 ? void 0 : _state$worforce.eisPayments;
  }) || [];
  (reduxState === null || reduxState === void 0 || (_reduxState$core = reduxState.core) === null || _reduxState$core === void 0 || (_reduxState$core = _reduxState$core.user) === null || _reduxState$core === void 0 || (_reduxState$core = _reduxState$core.i_user) === null || _reduxState$core === void 0 ? void 0 : _reduxState$core.language) || 'en';
  var classes = useStyles$L();
  var dispatch = useDispatch();
  var _useState3 = useState(true),
    _useState4 = _slicedToArray(_useState3, 2),
    loading = _useState4[0],
    setLoading = _useState4[1];
  var _useState5 = useState([]),
    _useState6 = _slicedToArray(_useState5, 2);
    _useState6[0];
    var setPaymentTypeMap = _useState6[1];
  var _useState7 = useState(""),
    _useState8 = _slicedToArray(_useState7, 2),
    appType = _useState8[0],
    setAppType = _useState8[1];
  var _useState9 = useState(""),
    _useState10 = _slicedToArray(_useState9, 2),
    benefitDate = _useState10[0],
    setBenefitDate = _useState10[1];
  var modulesManager = useModulesManager();
  var user_type = getUserTypeFromRights(userRights);
  var _useState11 = useState(0),
    _useState12 = _slicedToArray(_useState11, 2),
    recall = _useState12[0],
    setRecall = _useState12[1];
  var getTotalAmount = function getTotalAmount() {
    return eisPayments.reduce(function (sum, item) {
      return sum + (parseFloat(item.eisMonthlyAmount) || 0);
    }, 0).toFixed(2);
  };
  var loadData = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var sendApplicationIds, _iterator, _step, encodedId, applicationIds;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!((selectedApplicationIds === null || selectedApplicationIds === void 0 ? void 0 : selectedApplicationIds.length) > 0)) {
              _context.next = 12;
              break;
            }
            setLoading(true);
            // setDataCreated(false);
            sendApplicationIds = [];
            _iterator = _createForOfIteratorHelper$2(selectedApplicationIds);
            try {
              for (_iterator.s(); !(_step = _iterator.n()).done;) {
                encodedId = _step.value;
                sendApplicationIds.push(isBase64Encoded(encodedId === null || encodedId === void 0 ? void 0 : encodedId.id) ? decodeId(encodedId === null || encodedId === void 0 ? void 0 : encodedId.id) : encodedId === null || encodedId === void 0 ? void 0 : encodedId.id);
              }
            } catch (err) {
              _iterator.e(err);
            } finally {
              _iterator.f();
            }
            _context.next = 7;
            return dispatch(eisPaymentProcessWithoutDate(sendApplicationIds, recall == 1 ? "yes" : "no"));
          case 7:
            // setDataCreated(true);
            setLoading(false);
            applicationIds = selectedApplicationIds.map(function (x) {
              return isBase64Encoded(x.id) ? decodeId(x.id) : x.id;
            });
            _context.next = 11;
            return dispatch(fetchEisPaymentProcess(applicationIds, modulesManager)).then(function (res) {
              var _res$payload, _first$workforceAppli, _first$workforceAppli2, _first$workforceAppli3, _first$workforceAppli4, _first$workforceAppli5;
              var fetchedData = res === null || res === void 0 || (_res$payload = res.payload) === null || _res$payload === void 0 || (_res$payload = _res$payload.data) === null || _res$payload === void 0 ? void 0 : _res$payload.workforceEisPaymentProcess;
              setEisPayments(fetchedData);
              setPaymentTypeMap(fetchedData);
              var first = fetchedData === null || fetchedData === void 0 ? void 0 : fetchedData[0];
              if ((first === null || first === void 0 || (_first$workforceAppli = first.workforceApplication) === null || _first$workforceAppli === void 0 ? void 0 : _first$workforceAppli.applicationType) == 'disabilityAssistance') {
                setAppType("Disability");
              } else if ((first === null || first === void 0 || (_first$workforceAppli2 = first.workforceApplication) === null || _first$workforceAppli2 === void 0 ? void 0 : _first$workforceAppli2.applicationType) == 'financialAssistance') {
                setAppType("Death");
              }
              var parsingAccidentInfo = JSON.parse((first === null || first === void 0 || (_first$workforceAppli3 = first.workforceApplication) === null || _first$workforceAppli3 === void 0 ? void 0 : _first$workforceAppli3.employeeAccidentInfo) || "{}");
              var parsedAccidentInfo = typeof parsingAccidentInfo === 'string' ? JSON.parse(parsingAccidentInfo) : parsingAccidentInfo;
              var parsingDoctorEntry = JSON.parse((first === null || first === void 0 || (_first$workforceAppli4 = first.workforceApplication) === null || _first$workforceAppli4 === void 0 ? void 0 : _first$workforceAppli4.doctorsEntry) || "{}");
              var parsedDoctorEntry = typeof parsingDoctorEntry === 'string' ? JSON.parse(parsingDoctorEntry) : parsingDoctorEntry;
              var dateOfRejoining = (parsedAccidentInfo === null || parsedAccidentInfo === void 0 ? void 0 : parsedAccidentInfo.dateOfRejoining) || "";
              var dateOfAssessment = (parsedDoctorEntry === null || parsedDoctorEntry === void 0 ? void 0 : parsedDoctorEntry.dateOfAssessment) || "";
              var dateOfBenefitStart = "";
              if ((first === null || first === void 0 || (_first$workforceAppli5 = first.workforceApplication) === null || _first$workforceAppli5 === void 0 ? void 0 : _first$workforceAppli5.applicationType) == 'disabilityAssistance') {
                dateOfBenefitStart = dateOfRejoining || dateOfAssessment || (parsedAccidentInfo === null || parsedAccidentInfo === void 0 ? void 0 : parsedAccidentInfo.accidentDate) || "";
              } else {
                dateOfBenefitStart = (parsedAccidentInfo === null || parsedAccidentInfo === void 0 ? void 0 : parsedAccidentInfo.dateOfDeath) || "";
              }
              setBenefitDate(dateOfBenefitStart || "Not Available");
              // setBenefitDate(first?.workforceApplication?.dateCreated ? first?.workforceApplication?.dateCreated.split("T")[0] : "fg");
              // setBenefitDate(first?.workforceApplication?.dateCreated ? new Date(first?.workforceApplication?.dateCreated).toLocaleDateString("en-BD", {
              //   timeZone: "Asia/Dhaka",
              // }) : "fg");
            });
          case 11:
            setRecall(0);
          case 12:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function loadData() {
      return _ref2.apply(this, arguments);
    };
  }();
  useEffect(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          loadData();
        case 1:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  })), [open, recall === 1]);

  // -----------------------------
  // Excel generator (unchanged)
  // -----------------------------
  var exportToExcel = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      var _first$workforceAppli6, _first$workforceAppli7;
      var first, organizationType, applicationType;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            first = eisPayments === null || eisPayments === void 0 ? void 0 : eisPayments[0];
            if (first) {
              _context3.next = 4;
              break;
            }
            alert("No data found!");
            return _context3.abrupt("return");
          case 4:
            organizationType = first === null || first === void 0 || (_first$workforceAppli6 = first.workforceApplication) === null || _first$workforceAppli6 === void 0 ? void 0 : _first$workforceAppli6.organizationType;
            applicationType = first === null || first === void 0 || (_first$workforceAppli7 = first.workforceApplication) === null || _first$workforceAppli7 === void 0 ? void 0 : _first$workforceAppli7.applicationType; // ==========================
            //  DISABILITY EXCEL
            // ==========================
            if (!(organizationType === "eis" && applicationType === "disabilityAssistance")) {
              _context3.next = 8;
              break;
            }
            return _context3.abrupt("return", exportDisabilityExcel(eisPayments));
          case 8:
            if (!(organizationType === "eis" && applicationType === "financialAssistance")) {
              _context3.next = 10;
              break;
            }
            return _context3.abrupt("return", exportDeathExcel(eisPayments));
          case 10:
            // DEFAULT
            alert("Unsupported applicationType or organizationType");
          case 11:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return function exportToExcel() {
      return _ref4.apply(this, arguments);
    };
  }();
  var exportDisabilityExcel = /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee4(eisPayments) {
      var _data$workforceApplic, _data$workforceApplic2, _data$workforceApplic3, _data$workforceApplic4, _data$workforceApplic5;
      var workbook, sheet, data, parsingAccidentInfo, parsedAccidentInfo, parsingDoctorEntry, parsedDoctorEntry, dateOfRejoining, dateOfAssessment, accidentDate, leftItems, rightItems, titleRow, maxRows, _loop, i, benefitTitle, tableHeader, headerRow, totalMonthly, totalNet, totalRow, footerHeader, signatureBlocks, underlineRow, textRow, buffer, blob;
      return _regeneratorRuntime.wrap(function _callee4$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            workbook = new ExcelJS.Workbook();
            sheet = workbook.addWorksheet("Benefit Approval Note"); // ==========================
            // Set column widths
            // ==========================
            sheet.columns = [{
              width: 20
            },
            // A
            {
              width: 25
            },
            // B
            {
              width: 15
            },
            // C (gap)
            {
              width: 25
            },
            // D
            {
              width: 25
            },
            // E
            {
              width: 15
            },
            // F (gap)
            {
              width: 20
            },
            // G
            {
              width: 20
            },
            // H
            {
              width: 20
            } // I
            ];

            // ==========================
            // Top Headers
            // ==========================
            sheet.mergeCells("A1:I1");
            sheet.getCell("A1").value = "Employment Injury Scheme-Pilot";
            sheet.getCell("A1").font = {
              bold: true,
              size: 16
            };
            sheet.getCell("A1").alignment = {
              horizontal: "center"
            };
            sheet.mergeCells("A2:I2");
            sheet.getCell("A2").value = "Benefit Approval Note (Disability)";
            sheet.getCell("A2").font = {
              bold: true,
              size: 14
            };
            sheet.getCell("A2").alignment = {
              horizontal: "center"
            };
            sheet.mergeCells("A3:I3");
            sheet.getCell("A3").value = "EIS PILOT Special Unit, 196, Sromo Bhaban (9th Floor), Bijoynagar, Dhaka, 1000";
            sheet.getCell("A3").alignment = {
              horizontal: "center"
            };
            sheet.mergeCells("A4:I4");
            sheet.getCell("A4").value = "Email: specialunit@eis-pilot-bd.org, Phone: 01886-921030, Website: eis-pilot-bd.org";
            sheet.getCell("A4").alignment = {
              horizontal: "center"
            };

            // ==========================
            // Meeting Info
            // ==========================
            sheet.mergeCells("A6:F6");
            sheet.getCell("A6").value = "EIS-GB Sub Committee Meeting No:16";
            sheet.getCell("A6").font = {
              bold: true
            };
            sheet.getCell("A6").alignment = {
              horizontal: "left"
            };
            sheet.mergeCells("G6:I6");
            sheet.getCell("G6").value = "Date: " + (typeof benefitDate !== 'undefined' ? benefitDate : ""); // handling variable scope safety
            sheet.getCell("G6").font = {
              bold: true
            };
            sheet.getCell("G6").alignment = {
              horizontal: "right"
            };

            // ==========================
            // Worker, Factory & Accident Information
            // ==========================
            data = (eisPayments === null || eisPayments === void 0 ? void 0 : eisPayments[0]) || {};
            parsingAccidentInfo = JSON.parse(((_data$workforceApplic = data.workforceApplication) === null || _data$workforceApplic === void 0 ? void 0 : _data$workforceApplic.employeeAccidentInfo) || "{}");
            parsedAccidentInfo = typeof parsingAccidentInfo === 'string' ? JSON.parse(parsingAccidentInfo) : parsingAccidentInfo;
            parsingDoctorEntry = JSON.parse(((_data$workforceApplic2 = data.workforceApplication) === null || _data$workforceApplic2 === void 0 ? void 0 : _data$workforceApplic2.doctorsEntry) || "{}");
            parsedDoctorEntry = typeof parsingDoctorEntry === 'string' ? JSON.parse(parsingDoctorEntry) : parsingDoctorEntry;
            dateOfRejoining = (parsedAccidentInfo === null || parsedAccidentInfo === void 0 ? void 0 : parsedAccidentInfo.dateOfRejoining) || "";
            dateOfAssessment = (parsedDoctorEntry === null || parsedDoctorEntry === void 0 ? void 0 : parsedDoctorEntry.dateOfAssessment) || "";
            accidentDate = (parsedAccidentInfo === null || parsedAccidentInfo === void 0 ? void 0 : parsedAccidentInfo.accidentDate) || "";
            (parsedAccidentInfo === null || parsedAccidentInfo === void 0 ? void 0 : parsedAccidentInfo.dateOfDeath) || ""; // LOGIC CHANGE: Exclude "Date of Death" for Disability Excel
            leftItems = [["EIS Worker ID", (data === null || data === void 0 ? void 0 : data.beneficiaryId) || ""], ["Date of Accident", accidentDate || ""], ["Date of Rejoining", dateOfRejoining], ["Date of Disability Assessment", dateOfAssessment], ["Effective date of Benefit", dateOfRejoining || dateOfAssessment || ""]];
            rightItems = [["Name of the Factory", ((_data$workforceApplic3 = data.workforceApplication) === null || _data$workforceApplic3 === void 0 || (_data$workforceApplic3 = _data$workforceApplic3.employeeFactory) === null || _data$workforceApplic3 === void 0 ? void 0 : _data$workforceApplic3.nameEn) || ""], ["Name of Association", ((_data$workforceApplic4 = data.workforceApplication) === null || _data$workforceApplic4 === void 0 ? void 0 : _data$workforceApplic4.associationType) || ""], ["Gross Salary (BDT)", ((_data$workforceApplic5 = data.workforceApplication) === null || _data$workforceApplic5 === void 0 ? void 0 : _data$workforceApplic5.lastBaseSalary) || ""], ["Percentage of Disability", (parsedDoctorEntry === null || parsedDoctorEntry === void 0 ? void 0 : parsedDoctorEntry.disabilityPerSchedule) || ""], ["Type of Accident", ((parsedAccidentInfo === null || parsedAccidentInfo === void 0 ? void 0 : parsedAccidentInfo.accidentMainType) === "workforce.accident.mainType.workplace" ? "Workplace Accident" : (parsedAccidentInfo === null || parsedAccidentInfo === void 0 ? void 0 : parsedAccidentInfo.accidentMainType) === "workforce.accident.mainType.onDutyRTA" ? "On Duty RTA" : "Commuting") || ""]]; // Section Title
            titleRow = sheet.addRow([]);
            sheet.mergeCells("A".concat(titleRow.number, ":F").concat(titleRow.number));
            sheet.getCell("A".concat(titleRow.number)).value = "Worker, Factory & Accident Information:";
            sheet.getCell("A".concat(titleRow.number)).font = {
              bold: true
            };
            sheet.getCell("A".concat(titleRow.number)).alignment = {
              horizontal: "left"
            };

            // Add combined rows (Left + Right)
            // LOGIC CHANGE: Dynamic loop length to handle array sizes safely
            maxRows = Math.max(leftItems.length, rightItems.length);
            _loop = /*#__PURE__*/_regeneratorRuntime.mark(function _loop(i) {
              var _leftItems$i, _leftItems$i2, _rightItems$i, _rightItems$i2;
              var row;
              return _regeneratorRuntime.wrap(function _loop$(_context4) {
                while (1) switch (_context4.prev = _context4.next) {
                  case 0:
                    row = sheet.addRow([((_leftItems$i = leftItems[i]) === null || _leftItems$i === void 0 ? void 0 : _leftItems$i[0]) || "", ((_leftItems$i2 = leftItems[i]) === null || _leftItems$i2 === void 0 ? void 0 : _leftItems$i2[1]) || "", "",
                    // gap
                    ((_rightItems$i = rightItems[i]) === null || _rightItems$i === void 0 ? void 0 : _rightItems$i[0]) || "", ((_rightItems$i2 = rightItems[i]) === null || _rightItems$i2 === void 0 ? void 0 : _rightItems$i2[1]) || "", "" // gap
                    ]);
                    ["A", "B", "D", "E"].forEach(function (col) {
                      var cell = sheet.getCell("".concat(col).concat(row.number));
                      // Only draw border if there is content or it's within the valid list range
                      if (i < leftItems.length && (col === 'A' || col === 'B')) {
                        cell.border = {
                          top: {
                            style: "thin"
                          },
                          left: {
                            style: "thin"
                          },
                          bottom: {
                            style: "thin"
                          },
                          right: {
                            style: "thin"
                          }
                        };
                      }
                      if (i < rightItems.length && (col === 'D' || col === 'E')) {
                        cell.border = {
                          top: {
                            style: "thin"
                          },
                          left: {
                            style: "thin"
                          },
                          bottom: {
                            style: "thin"
                          },
                          right: {
                            style: "thin"
                          }
                        };
                      }
                      cell.alignment = {
                        vertical: "middle",
                        horizontal: "left",
                        wrapText: true
                      };
                      if (col === "A" || col === "D") cell.font = {
                        bold: true
                      };
                    });
                  case 2:
                  case "end":
                    return _context4.stop();
                }
              }, _loop);
            });
            i = 0;
          case 44:
            if (!(i < maxRows)) {
              _context5.next = 49;
              break;
            }
            return _context5.delegateYield(_loop(i), "t0", 46);
          case 46:
            i++;
            _context5.next = 44;
            break;
          case 49:
            // ==========================
            // Separate EIS Payments Table
            // ==========================
            sheet.addRow([]);
            benefitTitle = sheet.addRow(["Benefit Information:"]);
            benefitTitle.font = {
              bold: true,
              size: 12
            };
            benefitTitle.alignment = {
              horizontal: "left"
            };
            sheet.addRow([]);
            tableHeader = ["Sl #", "EIS Beneficiary ID", "NID/Birth Certificate of Worker", "Benefit Rate (%) of Gross Salary", "Monthly Payable Benefit (BDT)", "Net Monthly Payable After Adjustment (BDT)", "Total time amount (individual)", "After adjustment (individual)", "Type of Payment", "Approval Status", "Remarks"];
            headerRow = sheet.addRow(tableHeader);
            headerRow.eachCell(function (cell) {
              cell.fill = {
                type: "pattern",
                pattern: "solid",
                fgColor: "white"
              };
              cell.font = {
                bold: true
              };
              cell.alignment = {
                horizontal: "center",
                vertical: "middle",
                wrapText: true
              };
              cell.border = {
                top: {
                  style: "thin"
                },
                left: {
                  style: "thin"
                },
                bottom: {
                  style: "thin"
                },
                right: {
                  style: "thin"
                }
              };
            });
            totalMonthly = 0;
            totalNet = 0;
            eisPayments.forEach(function (row, index) {
              var _row$workforceApplica, _row$workforceEmploye, _row$workforceApplica2;
              var benefitRate = Number(row === null || row === void 0 ? void 0 : row.eisInitialReplacementRate) || 0;
              var excelRow = sheet.addRow([index + 1, (row === null || row === void 0 ? void 0 : row.beneficiaryId) || "", (row === null || row === void 0 || (_row$workforceApplica = row.workforceApplication) === null || _row$workforceApplica === void 0 ? void 0 : _row$workforceApplica.applicationType) === 'financialAssistance' ? row === null || row === void 0 || (_row$workforceEmploye = row.workforceEmployeeDependent) === null || _row$workforceEmploye === void 0 || (_row$workforceEmploye = _row$workforceEmploye[0]) === null || _row$workforceEmploye === void 0 ? void 0 : _row$workforceEmploye.nid : (row === null || row === void 0 || (_row$workforceApplica2 = row.workforceApplication) === null || _row$workforceApplica2 === void 0 || (_row$workforceApplica2 = _row$workforceApplica2.workforceEmployee) === null || _row$workforceApplica2 === void 0 ? void 0 : _row$workforceApplica2.nid) || "", "".concat(benefitRate * 100, "%"), Number((row === null || row === void 0 ? void 0 : row.eisInitialMonthlyAmount) || 0).toFixed(2), Number((row === null || row === void 0 ? void 0 : row.eisMonthlyAmount) || 0).toFixed(2), Number((row === null || row === void 0 ? void 0 : row.eisCalculatedAmount) || 0).toFixed(2), Number((row === null || row === void 0 ? void 0 : row.eisApprovedAmount) || 0).toFixed(2), (row === null || row === void 0 ? void 0 : row.eisPaymentType) || "", (row === null || row === void 0 ? void 0 : row.approvalStatus) || "", ""]);
              totalMonthly += Number((row === null || row === void 0 ? void 0 : row.eisInitialMonthlyAmount) || 0);
              totalNet += Number((row === null || row === void 0 ? void 0 : row.eisMonthlyAmount) || 0);
              excelRow.eachCell(function (cell) {
                cell.border = {
                  top: {
                    style: "thin"
                  },
                  left: {
                    style: "thin"
                  },
                  bottom: {
                    style: "thin"
                  },
                  right: {
                    style: "thin"
                  }
                };
                cell.alignment = {
                  vertical: "middle",
                  horizontal: "center",
                  wrapText: true
                };
              });
            });
            totalRow = sheet.addRow(["Total", "", "", "", Number(totalMonthly || 0).toFixed(2), Number(totalNet || 0).toFixed(2), "", "", "", "", ""]);
            totalRow.eachCell(function (cell, col) {
              if (col === 1 || col === 4) cell.font = {
                bold: true
              };
              cell.border = {
                top: {
                  style: "thin"
                },
                left: {
                  style: "thin"
                },
                bottom: {
                  style: "thin"
                },
                right: {
                  style: "thin"
                }
              };
              cell.alignment = {
                horizontal: "center",
                vertical: "middle"
              };
            });

            // ==========================
            // Footer
            // ==========================
            sheet.addRow([]);
            sheet.addRow([]);
            sheet.addRow([]);
            footerHeader = sheet.addRow(["Signature of EIS-GB Sub Committee Members:"]);
            footerHeader.font = {
              bold: true,
              size: 13
            };
            footerHeader.alignment = {
              horizontal: "left"
            };
            sheet.addRow([]);
            sheet.addRow([]);
            sheet.addRow([]);
            signatureBlocks = [["President-BAWF &\nExecutive Member,\nIBC\nMember\nEIS-GB Sub\nCommittee"], ["President-SLF\n& Member- NCCWE\nMember\nEIS-GB Sub\nCommittee"], ["Director\nBKMEA\nMember\nEIS-GB Sub\nCommittee"], ["Chairman,\nLabour & ILO Standing\nCommittee\nBGMEA\nMember\nEIS-GB Sub Committee"], ["Inspector General,\nDIFE\nMember\nEIS-GB Sub\nCommittee"], ["Director General,\nDepartment of Labour\nMember\nEIS-GB Sub Committee"], ["Director General,\nCentral Fund\nMember Secretary\nEIS-GB Sub Committee"], ["Additional Secretary,\nI.O. Wing, MoLE\nChairman\nEIS-GB Sub Committee"]];
            underlineRow = sheet.addRow(signatureBlocks.map(function () {
              return "__________________";
            }));
            underlineRow.height = 20;
            underlineRow.eachCell(function (cell) {
              cell.font = {
                bold: true
              };
              cell.alignment = {
                horizontal: "left",
                vertical: "bottom"
              };
            });
            textRow = sheet.addRow(signatureBlocks.map(function (sig) {
              return sig[0];
            }));
            textRow.height = 70;
            textRow.eachCell(function (cell) {
              cell.alignment = {
                horizontal: "left",
                vertical: "top",
                wrapText: true
              };
            });
            sheet.addRow([]);
            _context5.next = 82;
            return workbook.xlsx.writeBuffer();
          case 82:
            buffer = _context5.sent;
            blob = new Blob([buffer], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            });
            saveAs(blob, "Benefit Approval Note-Disability.xlsx");
          case 85:
          case "end":
            return _context5.stop();
        }
      }, _callee4);
    }));
    return function exportDisabilityExcel(_x) {
      return _ref5.apply(this, arguments);
    };
  }();
  var exportDeathExcel = /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee5(eisPayments) {
      var _data$workforceApplic6, _data$workforceApplic7, _data$workforceApplic8, _data$workforceApplic9, _data$workforceApplic10, _data$workforceApplic11;
      var workbook, sheet, data, parsingAccidentInfo, parsedAccidentInfo, parsingDoctorEntry, parsedDoctorEntry, dateOfRejoining, dateOfAssessment, effectiveDate, accidentDate, dateOfDeath, leftItems, rightItems, titleRow, maxRows, _loop2, i, benefitTitle, tableHeader, headerRow, totalMonthly, totalNet, totalRow, footerHeader, signatureBlocks, underlineRow, textRow, buffer, blob;
      return _regeneratorRuntime.wrap(function _callee5$(_context7) {
        while (1) switch (_context7.prev = _context7.next) {
          case 0:
            workbook = new ExcelJS.Workbook();
            sheet = workbook.addWorksheet("Benefit Approval Note"); // ==========================
            // Set column widths
            // ==========================
            sheet.columns = [{
              width: 20
            },
            // A
            {
              width: 25
            },
            // B
            {
              width: 15
            },
            // C (gap)
            {
              width: 25
            },
            // D
            {
              width: 25
            },
            // E
            {
              width: 15
            },
            // F (gap)
            {
              width: 20
            },
            // G
            {
              width: 20
            },
            // H
            {
              width: 20
            },
            // I
            {
              width: 20
            } // J
            ];

            // ==========================
            // Top Headers
            // ==========================
            sheet.mergeCells("A1:I1");
            sheet.getCell("A1").value = "Employment Injury Scheme-Pilot";
            sheet.getCell("A1").font = {
              bold: true,
              size: 16
            };
            sheet.getCell("A1").alignment = {
              horizontal: "center"
            };
            sheet.mergeCells("A2:I2");
            sheet.getCell("A2").value = "Benefit Approval Note (Death)";
            sheet.getCell("A2").font = {
              bold: true,
              size: 14
            };
            sheet.getCell("A2").alignment = {
              horizontal: "center"
            };
            sheet.mergeCells("A3:I3");
            sheet.getCell("A3").value = "EIS PILOT Special Unit, 196, Sromo Bhaban (9th Floor), Bijoynagar, Dhaka, 1000";
            sheet.getCell("A3").alignment = {
              horizontal: "center"
            };
            sheet.mergeCells("A4:I4");
            sheet.getCell("A4").value = "Email: specialunit@eis-pilot-bd.org, Phone: 01886-921030, Website: eis-pilot-bd.org";
            sheet.getCell("A4").alignment = {
              horizontal: "center"
            };

            // ==========================
            // Meeting Info
            // ==========================
            sheet.mergeCells("A6:F6");
            sheet.getCell("A6").value = "EIS-GB Sub Committee Meeting No:16";
            sheet.getCell("A6").font = {
              bold: true
            };
            sheet.getCell("A6").alignment = {
              horizontal: "left"
            };
            sheet.mergeCells("G6:I6");
            sheet.getCell("G6").value = "Date: 10/15/2025";
            sheet.getCell("G6").font = {
              bold: true
            };
            sheet.getCell("G6").alignment = {
              horizontal: "right"
            };

            // ==========================
            // Worker, Factory & Accident Information
            // ==========================
            data = (eisPayments === null || eisPayments === void 0 ? void 0 : eisPayments[0]) || {};
            parsingAccidentInfo = JSON.parse(((_data$workforceApplic6 = data.workforceApplication) === null || _data$workforceApplic6 === void 0 ? void 0 : _data$workforceApplic6.employeeAccidentInfo) || "{}");
            parsedAccidentInfo = typeof parsingAccidentInfo === 'string' ? JSON.parse(parsingAccidentInfo) : parsingAccidentInfo;
            parsingDoctorEntry = JSON.parse(((_data$workforceApplic7 = data.workforceApplication) === null || _data$workforceApplic7 === void 0 ? void 0 : _data$workforceApplic7.doctorsEntry) || "{}");
            parsedDoctorEntry = typeof parsingDoctorEntry === 'string' ? JSON.parse(parsingDoctorEntry) : parsingDoctorEntry; // We keep all variable extractions here as requested (don't remove fields)
            dateOfRejoining = (parsedAccidentInfo === null || parsedAccidentInfo === void 0 ? void 0 : parsedAccidentInfo.dateOfRejoining) || "";
            dateOfAssessment = (parsedDoctorEntry === null || parsedDoctorEntry === void 0 ? void 0 : parsedDoctorEntry.dateOfAssessment) || "";
            effectiveDate = dateOfRejoining || dateOfAssessment || "";
            accidentDate = (parsedAccidentInfo === null || parsedAccidentInfo === void 0 ? void 0 : parsedAccidentInfo.accidentDate) || "";
            dateOfDeath = (parsedAccidentInfo === null || parsedAccidentInfo === void 0 ? void 0 : parsedAccidentInfo.dateOfDeath) || ""; // LOGIC CHANGE: Exclude Rejoining, Assessment from Left
            // Items are now: Worker ID, Death Date, Accident Date, Effective Date
            leftItems = [["EIS Worker ID", (data === null || data === void 0 || (_data$workforceApplic8 = data.workforceApplication) === null || _data$workforceApplic8 === void 0 ? void 0 : _data$workforceApplic8.applicationType) == 'financialAssistance' ? data === null || data === void 0 ? void 0 : data.beneficiaryId.slice(0, 17) : (data === null || data === void 0 ? void 0 : data.beneficiaryId) || ""], ["Date of Death", dateOfDeath || ""], ["Date of Accident", accidentDate || ""],
            // Removed: ["Date of Rejoining", dateOfRejoining],
            // Removed: ["Date of Disability Assessment", dateOfAssessment],
            ["Effective date of Benefit", effectiveDate]]; // LOGIC CHANGE: Exclude Percentage of Disability from Right
            // Items are now: Factory, Association, Salary, Type of Accident
            rightItems = [["Name of the Factory", ((_data$workforceApplic9 = data.workforceApplication) === null || _data$workforceApplic9 === void 0 || (_data$workforceApplic9 = _data$workforceApplic9.employeeFactory) === null || _data$workforceApplic9 === void 0 ? void 0 : _data$workforceApplic9.nameEn) || ""], ["Name of Association", ((_data$workforceApplic10 = data.workforceApplication) === null || _data$workforceApplic10 === void 0 ? void 0 : _data$workforceApplic10.associationType) || ""], ["Gross Salary (BDT)", ((_data$workforceApplic11 = data.workforceApplication) === null || _data$workforceApplic11 === void 0 ? void 0 : _data$workforceApplic11.lastBaseSalary) || ""],
            // Removed: ["Percentage of Disability", parsedDoctorEntry?.disabilityPerSchedule || ""],
            ["Type of Accident", ((parsedAccidentInfo === null || parsedAccidentInfo === void 0 ? void 0 : parsedAccidentInfo.accidentMainType) === "workforce.accident.mainType.workplace" ? "Workplace Accident" : (parsedAccidentInfo === null || parsedAccidentInfo === void 0 ? void 0 : parsedAccidentInfo.accidentMainType) === "workforce.accident.mainType.onDutyRTA" ? "On Duty RTA" : "Commuting") || ""]]; // Section Title
            titleRow = sheet.addRow([]);
            sheet.mergeCells("A".concat(titleRow.number, ":F").concat(titleRow.number));
            sheet.getCell("A".concat(titleRow.number)).value = "Worker, Factory & Accident Information:";
            sheet.getCell("A".concat(titleRow.number)).font = {
              bold: true
            };
            sheet.getCell("A".concat(titleRow.number)).alignment = {
              horizontal: "left"
            };

            // Add combined rows (Left + Right)
            // LOGIC CHANGE: Calculate loop length dynamically instead of fixed 5
            maxRows = Math.max(leftItems.length, rightItems.length);
            _loop2 = /*#__PURE__*/_regeneratorRuntime.mark(function _loop2(i) {
              var _leftItems$i3, _leftItems$i4, _rightItems$i3, _rightItems$i4;
              var row;
              return _regeneratorRuntime.wrap(function _loop2$(_context6) {
                while (1) switch (_context6.prev = _context6.next) {
                  case 0:
                    row = sheet.addRow([((_leftItems$i3 = leftItems[i]) === null || _leftItems$i3 === void 0 ? void 0 : _leftItems$i3[0]) || "", ((_leftItems$i4 = leftItems[i]) === null || _leftItems$i4 === void 0 ? void 0 : _leftItems$i4[1]) || "", "",
                    // gap
                    ((_rightItems$i3 = rightItems[i]) === null || _rightItems$i3 === void 0 ? void 0 : _rightItems$i3[0]) || "", ((_rightItems$i4 = rightItems[i]) === null || _rightItems$i4 === void 0 ? void 0 : _rightItems$i4[1]) || "", "" // gap
                    ]);
                    ["A", "B", "D", "E"].forEach(function (col) {
                      var cell = sheet.getCell("".concat(col).concat(row.number));

                      // Only draw borders if content exists for this side
                      if (i < leftItems.length && (col === 'A' || col === 'B')) {
                        cell.border = {
                          top: {
                            style: "thin"
                          },
                          left: {
                            style: "thin"
                          },
                          bottom: {
                            style: "thin"
                          },
                          right: {
                            style: "thin"
                          }
                        };
                      }
                      if (i < rightItems.length && (col === 'D' || col === 'E')) {
                        cell.border = {
                          top: {
                            style: "thin"
                          },
                          left: {
                            style: "thin"
                          },
                          bottom: {
                            style: "thin"
                          },
                          right: {
                            style: "thin"
                          }
                        };
                      }
                      cell.alignment = {
                        vertical: "middle",
                        horizontal: "left",
                        wrapText: true
                      };
                      if (col === "A" || col === "D") cell.font = {
                        bold: true
                      };
                    });
                  case 2:
                  case "end":
                    return _context6.stop();
                }
              }, _loop2);
            });
            i = 0;
          case 45:
            if (!(i < maxRows)) {
              _context7.next = 50;
              break;
            }
            return _context7.delegateYield(_loop2(i), "t0", 47);
          case 47:
            i++;
            _context7.next = 45;
            break;
          case 50:
            // ==========================
            // Separate EIS Payments Table
            // ==========================
            sheet.addRow([]);
            benefitTitle = sheet.addRow(["Benefit Information:"]);
            benefitTitle.font = {
              bold: true,
              size: 12
            };
            benefitTitle.alignment = {
              horizontal: "left"
            };
            sheet.addRow([]);
            tableHeader = ["Sl #", "EIS Beneficiary ID", "NID/Birth Certificate of Worker", "Relationship with worker", "Benefit Rate (%) of Gross Salary", "Monthly Payable Benefit (BDT)", "Net Monthly Payable After Adjustment (BDT)", "Total time amount (individual)", "After adjustment (individual)", "Type of Payment", "Approval Status", "Remarks"];
            headerRow = sheet.addRow(tableHeader);
            headerRow.eachCell(function (cell) {
              cell.fill = {
                type: "pattern",
                pattern: "solid",
                fgColor: "white"
              };
              cell.font = {
                bold: true
              };
              cell.alignment = {
                horizontal: "center",
                vertical: "middle",
                wrapText: true
              };
              cell.border = {
                top: {
                  style: "thin"
                },
                left: {
                  style: "thin"
                },
                bottom: {
                  style: "thin"
                },
                right: {
                  style: "thin"
                }
              };
            });
            totalMonthly = 0;
            totalNet = 0;
            eisPayments.forEach(function (row, index) {
              var _row$workforceApplica3, _row$workforceEmploye2, _row$workforceApplica4, _row$workforceEmploye3, _row$workforceEmploye4;
              var benefitRate = Number(row === null || row === void 0 ? void 0 : row.eisInitialReplacementRate) || 0;
              var excelRow = sheet.addRow([index + 1, row === null || row === void 0 ? void 0 : row.beneficiaryId, (row === null || row === void 0 || (_row$workforceApplica3 = row.workforceApplication) === null || _row$workforceApplica3 === void 0 ? void 0 : _row$workforceApplica3.applicationType) === 'financialAssistance' ? row === null || row === void 0 || (_row$workforceEmploye2 = row.workforceEmployeeDependent) === null || _row$workforceEmploye2 === void 0 || (_row$workforceEmploye2 = _row$workforceEmploye2[0]) === null || _row$workforceEmploye2 === void 0 ? void 0 : _row$workforceEmploye2.nid : (row === null || row === void 0 || (_row$workforceApplica4 = row.workforceApplication) === null || _row$workforceApplica4 === void 0 || (_row$workforceApplica4 = _row$workforceApplica4.workforceEmployee) === null || _row$workforceApplica4 === void 0 ? void 0 : _row$workforceApplica4.nid) || "",
              // Note: Ensure RELATION_LABEL_MAP is defined in your component scope
              (typeof RELATION_LABEL_MAP !== 'undefined' ? RELATION_LABEL_MAP[row === null || row === void 0 || (_row$workforceEmploye3 = row.workforceEmployeeDependent) === null || _row$workforceEmploye3 === void 0 || (_row$workforceEmploye3 = _row$workforceEmploye3[0]) === null || _row$workforceEmploye3 === void 0 ? void 0 : _row$workforceEmploye3.relationWithWorker] : row === null || row === void 0 || (_row$workforceEmploye4 = row.workforceEmployeeDependent) === null || _row$workforceEmploye4 === void 0 || (_row$workforceEmploye4 = _row$workforceEmploye4[0]) === null || _row$workforceEmploye4 === void 0 ? void 0 : _row$workforceEmploye4.relationWithWorker) || "", "".concat(benefitRate * 100, "%"), Number((row === null || row === void 0 ? void 0 : row.eisInitialMonthlyAmount) || 0).toFixed(2), Number((row === null || row === void 0 ? void 0 : row.eisMonthlyAmount) || 0).toFixed(2), Number((row === null || row === void 0 ? void 0 : row.eisCalculatedAmount) || 0).toFixed(2), Number((row === null || row === void 0 ? void 0 : row.eisApprovedAmount) || 0).toFixed(2), (row === null || row === void 0 ? void 0 : row.eisPaymentType) || "", (row === null || row === void 0 ? void 0 : row.approvalStatus) || "", ""]);
              totalMonthly += Number((row === null || row === void 0 ? void 0 : row.eisInitialMonthlyAmount) || 0);
              totalNet += Number((row === null || row === void 0 ? void 0 : row.eisMonthlyAmount) || 0);
              excelRow.eachCell(function (cell) {
                cell.border = {
                  top: {
                    style: "thin"
                  },
                  left: {
                    style: "thin"
                  },
                  bottom: {
                    style: "thin"
                  },
                  right: {
                    style: "thin"
                  }
                };
                cell.alignment = {
                  vertical: "middle",
                  horizontal: "center",
                  wrapText: true
                };
              });
            });
            totalRow = sheet.addRow(["Total", "", "", "", "", "", Number(totalMonthly || 0).toFixed(2), "", Number(totalNet || 0).toFixed(2), "", "", ""]);
            totalRow.eachCell(function (cell, col) {
              if (col === 1 || col === 4) cell.font = {
                bold: true
              };
              cell.border = {
                top: {
                  style: "thin"
                },
                left: {
                  style: "thin"
                },
                bottom: {
                  style: "thin"
                },
                right: {
                  style: "thin"
                }
              };
              cell.alignment = {
                horizontal: "center",
                vertical: "middle"
              };
            });

            // ==========================
            // Footer
            // ==========================
            sheet.addRow([]);
            sheet.addRow([]);
            sheet.addRow([]);
            footerHeader = sheet.addRow(["Signature of EIS-GB Sub Committee Members:"]);
            footerHeader.font = {
              bold: true,
              size: 13
            };
            footerHeader.alignment = {
              horizontal: "left"
            };
            sheet.addRow([]);
            sheet.addRow([]);
            sheet.addRow([]);
            signatureBlocks = [["Executive Member\nIBC\nMember.\nEIS-GB Sub Committee"], ["Member,\nNCCWE.\nMember.\nEIS-GB Sub Committee"], ["Vice President\nBKMEA\nMember.\nEIS-GB Sub Committee"], ["Chairman,\nLabour & ILO Standing Committee\nBGMEA\nMember.\nEIS-GB Sub Committee"], ["Director General,\nDepartment of Labour\nMember Secretary.\nEIS-GB Sub Committee"], ["Director General,\nCentral Fund\nMember Secretary.\nEIS-GB Sub Committee"], ["Additional Secretary,\nI.O. Wing, MoLE\nChairman.\nEIS-GB Sub Committee"]];
            underlineRow = sheet.addRow(signatureBlocks.map(function () {
              return "__________________";
            }));
            underlineRow.height = 20;
            underlineRow.eachCell(function (cell) {
              cell.font = {
                bold: true
              };
              cell.alignment = {
                horizontal: "left",
                vertical: "bottom"
              };
            });
            textRow = sheet.addRow(signatureBlocks.map(function (sig) {
              return sig[0];
            }));
            textRow.height = 70;
            textRow.eachCell(function (cell) {
              cell.alignment = {
                horizontal: "left",
                vertical: "top",
                wrapText: true
              };
            });
            sheet.addRow([]);
            _context7.next = 83;
            return workbook.xlsx.writeBuffer();
          case 83:
            buffer = _context7.sent;
            blob = new Blob([buffer], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            });
            saveAs(blob, "Benefit Approval Note-Death.xlsx");
          case 86:
          case "end":
            return _context7.stop();
        }
      }, _callee5);
    }));
    return function exportDeathExcel(_x2) {
      return _ref6.apply(this, arguments);
    };
  }();

  // -----------------------------------
  // UI: Render all eisPayments (no filter)
  // -----------------------------------

  var first = (eisPayments === null || eisPayments === void 0 ? void 0 : eisPayments[0]) || {};
  var parsedAccidentInfo = {};
  var parsedDoctorEntry = {};
  try {
    var _first$workforceAppli8;
    parsedAccidentInfo = JSON.parse(JSON.parse(first === null || first === void 0 || (_first$workforceAppli8 = first.workforceApplication) === null || _first$workforceAppli8 === void 0 ? void 0 : _first$workforceAppli8.employeeAccidentInfo));
  } catch (e) {}
  try {
    var _first$workforceAppli9;
    parsedDoctorEntry = JSON.parse(JSON.parse(first === null || first === void 0 || (_first$workforceAppli9 = first.workforceApplication) === null || _first$workforceAppli9 === void 0 ? void 0 : _first$workforceAppli9.doctorsEntry));
  } catch (e) {}
  var dateOfRejoining = ((_parsedAccidentInfo = parsedAccidentInfo) === null || _parsedAccidentInfo === void 0 ? void 0 : _parsedAccidentInfo.dateOfRejoining) || "";
  var accidentDate = ((_parsedAccidentInfo2 = parsedAccidentInfo) === null || _parsedAccidentInfo2 === void 0 ? void 0 : _parsedAccidentInfo2.accidentDate) || "";
  var dateOfDeath = ((_parsedAccidentInfo3 = parsedAccidentInfo) === null || _parsedAccidentInfo3 === void 0 ? void 0 : _parsedAccidentInfo3.dateOfDeath) || "";
  var dateOfAssessment = ((_parsedDoctorEntry = parsedDoctorEntry) === null || _parsedDoctorEntry === void 0 ? void 0 : _parsedDoctorEntry.dateOfAssessment) || "";
  var _useState13 = useState({}),
    _useState14 = _slicedToArray(_useState13, 2),
    rowStateMap = _useState14[0],
    setRowStateMap = _useState14[1];
  var handlePaymentTypeChange = /*#__PURE__*/function () {
    var _ref7 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee6(paymentType, beneficiaryId) {
      return _regeneratorRuntime.wrap(function _callee6$(_context8) {
        while (1) switch (_context8.prev = _context8.next) {
          case 0:
            setRowStateMap(function (prev) {
              return _objectSpread$F(_objectSpread$F({}, prev), {}, _defineProperty({}, beneficiaryId, _objectSpread$F(_objectSpread$F({}, prev[beneficiaryId]), {}, {
                eisPaymentType: paymentType
              })));
            });
            _context8.prev = 1;
            _context8.next = 4;
            return dispatch(updateWorkforceEisPaymentProcessPaymentType({
              beneficiaryId: beneficiaryId,
              eisPaymentType: paymentType
            }));
          case 4:
            loadData();
            _context8.next = 10;
            break;
          case 7:
            _context8.prev = 7;
            _context8.t0 = _context8["catch"](1);
            console.error(_context8.t0);
          case 10:
          case "end":
            return _context8.stop();
        }
      }, _callee6, null, [[1, 7]]);
    }));
    return function handlePaymentTypeChange(_x3, _x4) {
      return _ref7.apply(this, arguments);
    };
  }();
  var handleApprovalChange = /*#__PURE__*/function () {
    var _ref8 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee7(value, beneficiaryId) {
      return _regeneratorRuntime.wrap(function _callee7$(_context9) {
        while (1) switch (_context9.prev = _context9.next) {
          case 0:
            setRowStateMap(function (prev) {
              return _objectSpread$F(_objectSpread$F({}, prev), {}, _defineProperty({}, beneficiaryId, _objectSpread$F(_objectSpread$F({}, prev[beneficiaryId]), {}, {
                approved: value
              })));
            });
            _context9.prev = 1;
            _context9.next = 4;
            return dispatch(updateWorkforceEisPaymentProcessApproval({
              beneficiaryId: beneficiaryId,
              approved: value
            }));
          case 4:
            _context9.next = 9;
            break;
          case 6:
            _context9.prev = 6;
            _context9.t0 = _context9["catch"](1);
            console.error(_context9.t0);
          case 9:
          case "end":
            return _context9.stop();
        }
      }, _callee7, null, [[1, 6]]);
    }));
    return function handleApprovalChange(_x5, _x6) {
      return _ref8.apply(this, arguments);
    };
  }();
  return /*#__PURE__*/React.createElement(Dialog$1, {
    open: open,
    onClose: onClose,
    maxWidth: "xl",
    fullWidth: true,
    classes: {
      paper: classes.dialogPaper
    }
  }, /*#__PURE__*/React.createElement(DialogTitle, {
    disableTypography: true
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6",
    align: "center"
  }, loading ? /*#__PURE__*/React.createElement("div", {
    style: {
      textAlign: 'center',
      padding: '20px'
    }
  }, /*#__PURE__*/React.createElement(CircularProgress$1, null), " ", /*#__PURE__*/React.createElement("br", null), "Loading...") : /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "EIS-Pilot Benefit Approval Note (Disability/Death)"
  }))), /*#__PURE__*/React.createElement(DialogContent$1, {
    dividers: true,
    className: classes.dialogContent
  }, /*#__PURE__*/React.createElement("div", {
    id: "printable-content"
  }, !loading && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5",
    align: "center",
    gutterBottom: true
  }, "Employment Injury Scheme-Pilot"), /*#__PURE__*/React.createElement(Typography, {
    variant: "h6",
    align: "center",
    gutterBottom: true
  }, "Benefit Approval Note (", appType, ")"), /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    align: "center"
  }, "EIS PILOT Special Unit, 196, Sromo Bhaban (9th Floor), Bijoynagar, Dhaka, 1000"), /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    align: "center",
    gutterBottom: true
  }, "Email: specialunit@eis-pilot-bd.org, Phone: 01886-921030, Website: eis-pilot-bd.org"), /*#__PURE__*/React.createElement(Divider, {
    style: {
      margin: "20px 0"
    }
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      justifyContent: "space-between",
      marginBottom: "16px"
    }
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle1",
    style: {
      fontWeight: "bold"
    }
  }, (_first$workforceAppli10 = first === null || first === void 0 || (_first$workforceAppli11 = first.workforceApplication) === null || _first$workforceAppli11 === void 0 || (_first$workforceAppli11 = _first$workforceAppli11.eisApplicationSummary) === null || _first$workforceAppli11 === void 0 ? void 0 : _first$workforceAppli11.name) !== null && _first$workforceAppli10 !== void 0 ? _first$workforceAppli10 : ""), /*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle1",
    style: {
      fontWeight: "bold"
    }
  }, "Date: ", new Date().toLocaleDateString())), /*#__PURE__*/React.createElement(Divider, {
    style: {
      margin: "16px 0"
    }
  }), /*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle1",
    style: {
      fontWeight: "bold",
      marginBottom: "12px"
    }
  }, "Worker, Factory & Accident Information:"), /*#__PURE__*/React.createElement("div", {
    style: {
      display: "grid",
      gridTemplateColumns: "1fr 1fr",
      gap: 24,
      marginBottom: "20px"
    }
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement("strong", null, "EIS Worker ID:"), " ", (first === null || first === void 0 || (_first$workforceAppli12 = first.workforceApplication) === null || _first$workforceAppli12 === void 0 ? void 0 : _first$workforceAppli12.applicationType) == 'financialAssistance' ? first === null || first === void 0 ? void 0 : first.beneficiaryId.slice(0, 17) : first === null || first === void 0 ? void 0 : first.beneficiaryId), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement("strong", null, "Date of Accident:"), " ", accidentDate), appType === "Death" ? /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement("strong", null, "Date of Death:"), " ", dateOfDeath) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement("strong", null, "Date of Rejoining:"), " ", dateOfRejoining), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement("strong", null, "Date of Disability Assessment:"), " ", dateOfAssessment)), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement("strong", null, "Effective Date of Benefit:"), " ", benefitDate)), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement("strong", null, "Name of the Factory:"), " ", first === null || first === void 0 || (_first$workforceAppli13 = first.workforceApplication) === null || _first$workforceAppli13 === void 0 || (_first$workforceAppli13 = _first$workforceAppli13.employeeFactory) === null || _first$workforceAppli13 === void 0 ? void 0 : _first$workforceAppli13.nameEn), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement("strong", null, "Name of Association:"), " ", first === null || first === void 0 || (_first$workforceAppli14 = first.workforceApplication) === null || _first$workforceAppli14 === void 0 ? void 0 : _first$workforceAppli14.associationType), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement("strong", null, "Gross Salary (BDT):"), " ", first === null || first === void 0 || (_first$workforceAppli15 = first.workforceApplication) === null || _first$workforceAppli15 === void 0 || (_first$workforceAppli15 = _first$workforceAppli15.lastBaseSalary) === null || _first$workforceAppli15 === void 0 ? void 0 : _first$workforceAppli15.toLocaleString('en-BD')), appType !== "Death" && /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement("strong", null, "Percentage of Disability:"), " ", (_parsedDoctorEntry2 = parsedDoctorEntry) === null || _parsedDoctorEntry2 === void 0 ? void 0 : _parsedDoctorEntry2.disabilityPerSchedule), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement("strong", null, "Type of Accident:"), " ", ((_parsedAccidentInfo4 = parsedAccidentInfo) === null || _parsedAccidentInfo4 === void 0 ? void 0 : _parsedAccidentInfo4.accidentMainType) === "workforce.accident.mainType.workplace" ? "Workplace Accident" : ((_parsedAccidentInfo5 = parsedAccidentInfo) === null || _parsedAccidentInfo5 === void 0 ? void 0 : _parsedAccidentInfo5.accidentMainType) === "workforce.accident.mainType.onDutyRTA" ? "On Duty RTA" : "Commuting"))), /*#__PURE__*/React.createElement(Divider, {
    style: {
      margin: "20px 0"
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.printTable
  }, /*#__PURE__*/React.createElement(Table$2, {
    size: "small"
  }, /*#__PURE__*/React.createElement(TableHead, null, /*#__PURE__*/React.createElement(TableRow, {
    style: {
      backgroundColor: "#f0f0f0"
    }
  }, /*#__PURE__*/React.createElement(TableCell, null, /*#__PURE__*/React.createElement("strong", null, "SL #")), /*#__PURE__*/React.createElement(TableCell, null, /*#__PURE__*/React.createElement("strong", null, "EIS Beneficiary ID")), /*#__PURE__*/React.createElement(TableCell, null, /*#__PURE__*/React.createElement("strong", null, "NID/Birth Certificate of ", appType == "Death" ? " Beneficiary" : " Worker")), appType === "Death" ? /*#__PURE__*/React.createElement(TableCell, null, /*#__PURE__*/React.createElement("strong", null, "Relationship with worker")) : null, /*#__PURE__*/React.createElement(TableCell, null, /*#__PURE__*/React.createElement("strong", null, "Benefit Rate (%)")), [WORKFORCE_USER_TYPE.EIS_ASSOCIATION_COMMITTEE, WORKFORCE_USER_TYPE.EIS_COMMITTEE].includes(user_type) ? null : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TableCell, null, /*#__PURE__*/React.createElement("strong", null, "Total Amount")), /*#__PURE__*/React.createElement(TableCell, null, /*#__PURE__*/React.createElement("strong", null, "After Adjustment"))), /*#__PURE__*/React.createElement(TableCell, null, /*#__PURE__*/React.createElement("strong", null, "Monthly Benefit")), /*#__PURE__*/React.createElement(TableCell, null, /*#__PURE__*/React.createElement("strong", null, "Net Monthly")), /*#__PURE__*/React.createElement(TableCell, null, /*#__PURE__*/React.createElement("strong", null, "Type of Payment")), /*#__PURE__*/React.createElement(TableCell, null, /*#__PURE__*/React.createElement("strong", null, "Approval Status")), /*#__PURE__*/React.createElement(TableCell, null, /*#__PURE__*/React.createElement("strong", null, "Remarks")))), /*#__PURE__*/React.createElement(TableBody, null, eisPayments.map(function (row, index) {
    var _row$workforceApplica5, _row$workforceEmploye5, _row$workforceApplica6, _row$workforceApplica7, _row$workforceEmploye6, _ref9, _rowStateMap$row$bene, _rowStateMap$row$bene2, _rowStateMap$row$bene3, _rowStateMap$row$bene4, _row$paymentTypeRemar;
    return /*#__PURE__*/React.createElement(TableRow, {
      key: index
    }, /*#__PURE__*/React.createElement(TableCell, null, index + 1), /*#__PURE__*/React.createElement(TableCell, null, row === null || row === void 0 ? void 0 : row.beneficiaryId), /*#__PURE__*/React.createElement(TableCell, null, (row === null || row === void 0 || (_row$workforceApplica5 = row.workforceApplication) === null || _row$workforceApplica5 === void 0 ? void 0 : _row$workforceApplica5.applicationType) === 'financialAssistance' ? row === null || row === void 0 || (_row$workforceEmploye5 = row.workforceEmployeeDependent) === null || _row$workforceEmploye5 === void 0 || (_row$workforceEmploye5 = _row$workforceEmploye5[0]) === null || _row$workforceEmploye5 === void 0 ? void 0 : _row$workforceEmploye5.nid : row === null || row === void 0 || (_row$workforceApplica6 = row.workforceApplication) === null || _row$workforceApplica6 === void 0 || (_row$workforceApplica6 = _row$workforceApplica6.workforceEmployee) === null || _row$workforceApplica6 === void 0 ? void 0 : _row$workforceApplica6.nid), (row === null || row === void 0 || (_row$workforceApplica7 = row.workforceApplication) === null || _row$workforceApplica7 === void 0 ? void 0 : _row$workforceApplica7.applicationType) === 'financialAssistance' && /*#__PURE__*/React.createElement(TableCell, null, getRelationString(row === null || row === void 0 || (_row$workforceEmploye6 = row.workforceEmployeeDependent) === null || _row$workforceEmploye6 === void 0 ? void 0 : _row$workforceEmploye6[0])), /*#__PURE__*/React.createElement(TableCell, null, row !== null && row !== void 0 && row.eisInitialReplacementRate ? (Number(row.eisInitialReplacementRate) * 100).toFixed(2) + "%" : ""), [WORKFORCE_USER_TYPE.EIS_ASSOCIATION_COMMITTEE, WORKFORCE_USER_TYPE.EIS_COMMITTEE].includes(user_type) ? null : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TableCell, null, Number((row === null || row === void 0 ? void 0 : row.eisCalculatedAmount) || 0).toFixed(2)), /*#__PURE__*/React.createElement(TableCell, null, Number((row === null || row === void 0 ? void 0 : row.eisApprovedAmount) || 0).toFixed(2))), /*#__PURE__*/React.createElement(TableCell, null, Number((row === null || row === void 0 ? void 0 : row.eisInitialMonthlyAmount) || 0).toFixed(2)), /*#__PURE__*/React.createElement(TableCell, null, Number((row === null || row === void 0 ? void 0 : row.eisMonthlyAmount) || 0).toFixed(2)), /*#__PURE__*/React.createElement(TableCell, null, user_type === WORKFORCE_USER_TYPE.EIS_COORDINATOR || user_type === WORKFORCE_USER_TYPE.EIS_ADVISOR || user_type === WORKFORCE_USER_TYPE.EIS_COMMITTEE || user_type === WORKFORCE_USER_TYPE.EIS_ASSOCIATION_COMMITTEE ? /*#__PURE__*/React.createElement("select", {
      value: (_ref9 = (_rowStateMap$row$bene = (_rowStateMap$row$bene2 = rowStateMap[row.beneficiaryId]) === null || _rowStateMap$row$bene2 === void 0 ? void 0 : _rowStateMap$row$bene2.eisPaymentType) !== null && _rowStateMap$row$bene !== void 0 ? _rowStateMap$row$bene : row.eisPaymentType) !== null && _ref9 !== void 0 ? _ref9 : "",
      onChange: function onChange(e) {
        return handlePaymentTypeChange(e.target.value, row === null || row === void 0 ? void 0 : row.beneficiaryId, index);
      }
    }, /*#__PURE__*/React.createElement("option", {
      value: "",
      disabled: true
    }, "Select"), /*#__PURE__*/React.createElement("option", {
      value: "monthly"
    }, "Monthly"), /*#__PURE__*/React.createElement("option", {
      value: "onetime"
    }, "One-time"), /*#__PURE__*/React.createElement("option", {
      value: "installment"
    }, "Tri Monthly Installment")) : EIS_PAYMENT_TYPES[row === null || row === void 0 ? void 0 : row.eisPaymentType]), /*#__PURE__*/React.createElement(TableCell, null, user_type === WORKFORCE_USER_TYPE.EIS_COMMITTEE || user_type === WORKFORCE_USER_TYPE.EIS_ASSOCIATION_COMMITTEE ? /*#__PURE__*/React.createElement("select", {
      value: (_rowStateMap$row$bene3 = (_rowStateMap$row$bene4 = rowStateMap[row.beneficiaryId]) === null || _rowStateMap$row$bene4 === void 0 ? void 0 : _rowStateMap$row$bene4.approved) !== null && _rowStateMap$row$bene3 !== void 0 ? _rowStateMap$row$bene3 : row !== null && row !== void 0 && row.approved ? "yes" : "",
      onChange: function onChange(e) {
        return handleApprovalChange(e.target.value, row === null || row === void 0 ? void 0 : row.beneficiaryId, index);
      }
    }, /*#__PURE__*/React.createElement("option", {
      value: ""
    }, "Not Approved"), /*#__PURE__*/React.createElement("option", {
      value: "yes"
    }, "Approved")) : getApprovalStatus(row === null || row === void 0 ? void 0 : row.isApproved)), /*#__PURE__*/React.createElement(TableCell, null, (_row$paymentTypeRemar = row === null || row === void 0 ? void 0 : row.paymentTypeRemarks) !== null && _row$paymentTypeRemar !== void 0 ? _row$paymentTypeRemar : ""));
  }), /*#__PURE__*/React.createElement(TableRow, null, /*#__PURE__*/React.createElement(TableCell, {
    colSpan: [WORKFORCE_USER_TYPE.EIS_ASSOCIATION_COMMITTEE, WORKFORCE_USER_TYPE.EIS_COMMITTEE].includes(user_type) ? appType === "Death" ? 6 : 5 : appType === "Death" ? 8 : 7,
    align: "right"
  }, /*#__PURE__*/React.createElement("strong", null, "Total Monthly Amount (BDT):")), /*#__PURE__*/React.createElement(TableCell, {
    align: "center"
  }, /*#__PURE__*/React.createElement("strong", null, Number(getTotalAmount() || 0).toFixed(2))), /*#__PURE__*/React.createElement(TableCell, {
    colSpan: 3
  })))))))), /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement(DialogActions$1, {
    className: classes.noPrint
  }, !loading && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
    onClick: onClose,
    variant: "outlined",
    color: "primary"
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "workforce.modal.close"
  })), user_type == WORKFORCE_USER_TYPE.EIS_COORDINATOR && first !== null && first !== void 0 && (_first$workforceAppli16 = first.workforceApplication) !== null && _first$workforceAppli16 !== void 0 && _first$workforceAppli16.status && ((first === null || first === void 0 || (_first$workforceAppli17 = first.workforceApplication) === null || _first$workforceAppli17 === void 0 ? void 0 : _first$workforceAppli17.status) === "verified" || (first === null || first === void 0 || (_first$workforceAppli18 = first.workforceApplication) === null || _first$workforceAppli18 === void 0 ? void 0 : _first$workforceAppli18.status) === "approved_by_doctor" || (first === null || first === void 0 || (_first$workforceAppli19 = first.workforceApplication) === null || _first$workforceAppli19 === void 0 ? void 0 : _first$workforceAppli19.status) === "approved_by_eis_advisor") ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
    onClick: function onClick() {
      return setRecall(1);
    },
    variant: "contained",
    color: "primary"
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "workforce.modal.recalculate"
  })), /*#__PURE__*/React.createElement(Button, {
    onClick: onClose,
    variant: "contained",
    color: "primary"
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "workforce.modal.saveCalculation"
  }))) : null, /*#__PURE__*/React.createElement(Button, {
    onClick: function onClick() {
      return window.print();
    },
    variant: "contained",
    color: "primary"
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "workforce.modal.print"
  })), /*#__PURE__*/React.createElement(Button, {
    onClick: exportToExcel,
    variant: "contained",
    color: "success"
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "workforce.modal.excel"
  })))));
};

// --- STYLES ---
var useStyles$K = makeStyles(function (theme) {
  return {
    noPrint: {
      "@media print": {
        display: "none !important"
      }
    },
    dialogPaper: {
      minWidth: "90vw",
      "@media print": {
        boxShadow: "none",
        border: "none",
        minWidth: "100%",
        margin: 0,
        maxWidth: "100% !important" // Ensure full width print
      }
    },
    dialogContent: {
      backgroundColor: "#fff",
      padding: theme.spacing(4),
      "@media print": {
        padding: "0px !important",
        overflow: "visible !important"
      }
    },
    // --- DOCUMENT STYLES ---
    docTitle: {
      fontWeight: "bold",
      fontSize: "18px",
      textAlign: "center",
      textTransform: "uppercase",
      color: "#000"
    },
    docSubTitle: {
      fontWeight: "bold",
      fontSize: "16px",
      textAlign: "center",
      marginBottom: "4px",
      color: "#000"
    },
    docText: {
      fontSize: "12px",
      textAlign: "center",
      fontFamily: "Arial, sans-serif",
      color: "#000"
    },
    sectionTitle: {
      fontWeight: "bold",
      fontSize: "14px",
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(1),
      textDecoration: "underline",
      color: "#000"
    },
    // --- EXCEL-LIKE TABLE ---
    excelTable: {
      width: "100%",
      borderCollapse: "collapse",
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
      "& th, & td": {
        border: "1px solid #000",
        padding: "5px",
        fontSize: "11px",
        fontFamily: "Arial, sans-serif",
        verticalAlign: "middle",
        color: "#000"
      },
      "& th": {
        backgroundColor: "#f0f0f0",
        fontWeight: "bold",
        textAlign: "center",
        "-webkit-print-color-adjust": "exact",
        // Chrome/Safari
        "print-color-adjust": "exact" // Firefox
      }
    },
    // --- SIGNATURES ---
    signatureContainer: {
      marginTop: "60px",
      width: "100%"
    },
    signatureBlock: {
      // marginTop: "40px",
      borderTop: "1px solid #000",
      paddingTop: "5px",
      fontSize: "11px",
      whiteSpace: "pre-line",
      lineHeight: 1.2,
      color: "#000"
    },
    // --- GLOBAL PRINT FIX ---
    // This ensures only the content div is visible when printing
    "@global": {
      "@media print": {
        "body *": {
          visibility: "hidden"
        },
        "#printable-content, #printable-content *": {
          visibility: "visible"
        },
        "#printable-content": {
          position: "absolute",
          left: 0,
          top: 0,
          width: "100%"
        },
        // Hide scrollbars in print
        "html, body": {
          height: "100%",
          overflow: "hidden"
        }
      }
    }
  };
});
var EisApprovalSignature = function EisApprovalSignature(_ref) {
  var _firstData$workforceA, _parsedAccidentInfo, _parsedDoctorEntry, _eisApprovalSignature, _eisPayments$, _firstData$workforceA4, _firstData$beneficiar, _firstData$workforceA5, _parsedAccidentInfo2, _firstData$workforceA6, _firstData$workforceA7, _firstData$workforceA8, _parsedDoctorEntry2, _firstData$workforceA9, _parsedAccidentInfo3, _parsedAccidentInfo4, _parsedAccidentInfo5, _parsedAccidentInfo6, _firstData$workforceA10, _firstData$workforceA11, _firstData$workforceA14, _firstData$workforceA15, _eisApprovalSignature2, _eisApprovalSignature3, _eisApprovalSignature4, _eisApprovalSignature5, _eisApprovalSignature6, _eisApprovalSignature7;
  var open = _ref.open,
    onClose = _ref.onClose,
    userRights = _ref.userRights,
    selectedApplicationIds = _ref.selectedApplicationIds;
  useSelector(function (state) {
    return state;
  });
  var classes = useStyles$K();
  var dispatch = useDispatch();
  var modulesManager = useModulesManager();
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    loading = _useState2[0],
    setLoading = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2);
    _useState4[0];
    _useState4[1];
  var _useState5 = useState({}),
    _useState6 = _slicedToArray(_useState5, 2),
    paymentTypeMap = _useState6[0],
    setPaymentTypeMap = _useState6[1];
  var _useState7 = useState([]),
    _useState8 = _slicedToArray(_useState7, 2);
    _useState8[0];
    var setMovements = _useState8[1];
  var _useState9 = useState(null),
    _useState10 = _slicedToArray(_useState9, 2);
    _useState10[0];
    var setLastRevertMovement = _useState10[1];
  var _useState11 = useState([]),
    _useState12 = _slicedToArray(_useState11, 2);
    _useState12[0];
    var setRevertNotes = _useState12[1];
  var _useState13 = useState([]),
    _useState14 = _slicedToArray(_useState13, 2),
    eisPayments = _useState14[0],
    setEisPayments = _useState14[1];
  var _useState15 = useState([]),
    _useState16 = _slicedToArray(_useState15, 2),
    eisApprovalSignature = _useState16[0],
    setEisApprovalSignature = _useState16[1];
  var _useState17 = useState([]),
    _useState18 = _slicedToArray(_useState17, 2);
    _useState18[0];
    _useState18[1];
  var user_type = getUserTypeFromRights(userRights);
  var fetchApplicationMovement = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _selectedApplicationI, _response$payload, _rawMovements$, _actualNodes, firstAppId, response, rawData, rawMovements, actualNodes, approvedIds, clean, lastRevert;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            // 1. Get Application ID
            firstAppId = selectedApplicationIds !== null && selectedApplicationIds !== void 0 && (_selectedApplicationI = selectedApplicationIds[0]) !== null && _selectedApplicationI !== void 0 && _selectedApplicationI.id ? decodeId(selectedApplicationIds[0].id) : null;
            if (firstAppId) {
              _context.next = 5;
              break;
            }
            console.log("No valid application ID found.");
            return _context.abrupt("return");
          case 5:
            _context.next = 7;
            return dispatch(fetchApplicationWiseMovementList(modulesManager, {
              applicationId: firstAppId
            }));
          case 7:
            response = _context.sent;
            // 3. Parse Data
            rawData = response === null || response === void 0 || (_response$payload = response.payload) === null || _response$payload === void 0 || (_response$payload = _response$payload.data) === null || _response$payload === void 0 ? void 0 : _response$payload.workforceApplicationMovement;
            rawMovements = [];
            console.log({
              rawData: rawData
            });
            // Handle parsing if it's a string, or use directly if object
            if (typeof rawData === "string") {
              try {
                rawMovements = JSON.parse(rawData);
              } catch (e) {}
            } else {
              rawMovements = rawData || [];
            }

            // Ensure it is an array
            if (!Array.isArray(rawMovements)) rawMovements = [rawMovements];

            // 4. Extract Nodes from 'edges'
            actualNodes = [];
            if (rawMovements.length > 0 && (_rawMovements$ = rawMovements[0]) !== null && _rawMovements$ !== void 0 && _rawMovements$.edges) {
              actualNodes = rawMovements[0].edges.map(function (edge) {
                return edge.node;
              });
            } else {
              actualNodes = rawMovements;
            }
            approvedIds = safeParse((_actualNodes = actualNodes) === null || _actualNodes === void 0 || (_actualNodes = _actualNodes[0]) === null || _actualNodes === void 0 || (_actualNodes = _actualNodes.application) === null || _actualNodes === void 0 ? void 0 : _actualNodes.eisApprovedByIds).map(String);
            console.log({
              actualNodes: actualNodes
            });
            console.log({
              approvedIds: approvedIds
            });

            // 5. Extract IDs
            _toConsumableArray(new Set(actualNodes.filter(function (item) {
              return (item === null || item === void 0 ? void 0 : item.status) === "forward_to_comiitee" || (item === null || item === void 0 ? void 0 : item.status) === "approved_by_committee";
            }).map(function (item) {
              var _node$applicationTo;
              var node = item.node || item; // Handle if double nested
              return node !== null && node !== void 0 && (_node$applicationTo = node.applicationTo) !== null && _node$applicationTo !== void 0 && _node$applicationTo.id ? decodeId(node.applicationTo.id) : null;
            }).filter(function (id) {
              return id !== null;
            })));
            console.log({
              actualNodes: actualNodes
            });
            _context.next = 22;
            return dispatch(fetchWorkforceSignatures(approvedIds)).then(function (res) {
              var _res$payload;
              setEisApprovalSignature(res === null || res === void 0 || (_res$payload = res.payload) === null || _res$payload === void 0 || (_res$payload = _res$payload.data) === null || _res$payload === void 0 ? void 0 : _res$payload.workforceSignatures);
            });
          case 22:
            // 6. Revert Note Logic
            clean = function clean(html) {
              return (html === null || html === void 0 ? void 0 : html.replace(/<\/?[^>]+(>|$)/g, "")) || "";
            };
            lastRevert = _toConsumableArray(actualNodes).reverse().find(function (m) {
              return m.revertNote;
            });
            if (lastRevert) lastRevert.revertNote = clean(lastRevert.revertNote);
            setMovements(actualNodes);
            setLastRevertMovement(lastRevert);
            setRevertNotes(lastRevert ? [lastRevert.revertNote] : []);
            _context.next = 33;
            break;
          case 30:
            _context.prev = 30;
            _context.t0 = _context["catch"](0);
            console.error("Failed to load application movements", _context.t0);
          case 33:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 30]]);
    }));
    return function fetchApplicationMovement() {
      return _ref2.apply(this, arguments);
    };
  }();

  // --- 1. DATA FETCHING LOGIC ---
  useEffect(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    var initialMap, applicationIds;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          if (!((selectedApplicationIds === null || selectedApplicationIds === void 0 ? void 0 : selectedApplicationIds.length) > 0)) {
            _context2.next = 8;
            break;
          }
          // Initialize map with existing values
          initialMap = {};
          eisPayments.forEach(function (p, idx) {
            initialMap[idx] = {
              eisPaymentType: p.eisPaymentType,
              approved: p.isApproved ? "yes" : ""
            };
          });
          setPaymentTypeMap(initialMap);
          applicationIds = selectedApplicationIds.map(function (x) {
            return decodeId(x.id);
          });
          _context2.next = 7;
          return dispatch(fetchEisPaymentProcess(applicationIds, modulesManager)).then(function (res) {
            var _res$payload2;
            var fetchedData = res === null || res === void 0 || (_res$payload2 = res.payload) === null || _res$payload2 === void 0 || (_res$payload2 = _res$payload2.data) === null || _res$payload2 === void 0 ? void 0 : _res$payload2.workforceEisPaymentProcess;
            setEisPayments(fetchedData);
            setPaymentTypeMap(eisPayments);
          });
        case 7:
          setLoading(false);
        case 8:
          fetchApplicationMovement();
        case 9:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  })), [open]);

  // --- 2. CALCULATIONS ---
  var getMonthlyTotalAmount = function getMonthlyTotalAmount() {
    return eisPayments.reduce(function (sum, item) {
      return sum + (parseFloat(item.eisInitialMonthlyAmount) || 0);
    }, 0).toFixed(2);
  };
  var getNetMonthlyTotalAmount = function getNetMonthlyTotalAmount() {
    return eisPayments.reduce(function (sum, item) {
      return sum + (parseFloat(item.eisMonthlyAmount) || 0);
    }, 0).toFixed(2);
  };

  // --- 4. EXCEL GENERATION LOGIC (Restored) ---
  var exportToExcel = /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
      var _first$workforceAppli, _first$workforceAppli2;
      var first, organizationType, applicationType;
      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            first = eisPayments === null || eisPayments === void 0 ? void 0 : eisPayments[0];
            if (first) {
              _context5.next = 4;
              break;
            }
            alert("No data found!");
            return _context5.abrupt("return");
          case 4:
            organizationType = first === null || first === void 0 || (_first$workforceAppli = first.workforceApplication) === null || _first$workforceAppli === void 0 ? void 0 : _first$workforceAppli.organizationType;
            applicationType = first === null || first === void 0 || (_first$workforceAppli2 = first.workforceApplication) === null || _first$workforceAppli2 === void 0 ? void 0 : _first$workforceAppli2.applicationType;
            if (!(organizationType === "eis" && applicationType === "disabilityAssistance")) {
              _context5.next = 8;
              break;
            }
            return _context5.abrupt("return", exportDisabilityExcel(eisPayments));
          case 8:
            if (!(organizationType === "eis" && applicationType === "financialAssistance")) {
              _context5.next = 10;
              break;
            }
            return _context5.abrupt("return", exportDeathExcel(eisPayments));
          case 10:
            alert("Unsupported applicationType or organizationType");
          case 11:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    }));
    return function exportToExcel() {
      return _ref6.apply(this, arguments);
    };
  }();

  // --- Disability Excel ---
  var exportDisabilityExcel = /*#__PURE__*/function () {
    var _ref7 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee6(eisPayments) {
      var _data$workforceApplic, _data$workforceApplic2, _data$workforceApplic3, _data$workforceApplic4, _data$workforceApplic5;
      var workbook, sheet, data, parsingAccidentInfo, parsedAccidentInfo, parsingDoctorEntry, parsedDoctorEntry, dateOfRejoining, dateOfAssessment, accidentDate, leftItems, rightItems, titleRow, maxRows, _loop, i, benefitTitle, tableHeader, headerRow, totalMonthly, totalNet, totalRow, footerHeader, signatureBlocks, underlineRow, textRow, buffer, blob;
      return _regeneratorRuntime.wrap(function _callee6$(_context7) {
        while (1) switch (_context7.prev = _context7.next) {
          case 0:
            workbook = new ExcelJS.Workbook();
            sheet = workbook.addWorksheet("Benefit Approval Note"); // ==========================
            // Set column widths
            // ==========================
            sheet.columns = [{
              width: 20
            },
            // A
            {
              width: 25
            },
            // B
            {
              width: 15
            },
            // C (gap)
            {
              width: 25
            },
            // D
            {
              width: 25
            },
            // E
            {
              width: 15
            },
            // F (gap)
            {
              width: 20
            },
            // G
            {
              width: 20
            },
            // H
            {
              width: 20
            } // I
            ];

            // ==========================
            // Top Headers
            // ==========================
            sheet.mergeCells("A1:I1");
            sheet.getCell("A1").value = "Employment Injury Scheme-Pilot";
            sheet.getCell("A1").font = {
              bold: true,
              size: 16
            };
            sheet.getCell("A1").alignment = {
              horizontal: "center"
            };
            sheet.mergeCells("A2:I2");
            sheet.getCell("A2").value = "Benefit Approval Note (Disability)";
            sheet.getCell("A2").font = {
              bold: true,
              size: 14
            };
            sheet.getCell("A2").alignment = {
              horizontal: "center"
            };
            sheet.mergeCells("A3:I3");
            sheet.getCell("A3").value = "EIS PILOT Special Unit, 196, Sromo Bhaban (9th Floor), Bijoynagar, Dhaka, 1000";
            sheet.getCell("A3").alignment = {
              horizontal: "center"
            };
            sheet.mergeCells("A4:I4");
            sheet.getCell("A4").value = "Email: specialunit@eis-pilot-bd.org, Phone: 01886-921030, Website: eis-pilot-bd.org";
            sheet.getCell("A4").alignment = {
              horizontal: "center"
            };

            // ==========================
            // Meeting Info
            // ==========================
            sheet.mergeCells("A6:F6");
            sheet.getCell("A6").value = "EIS-GB Sub Committee Meeting No:16";
            sheet.getCell("A6").font = {
              bold: true
            };
            sheet.getCell("A6").alignment = {
              horizontal: "left"
            };
            sheet.mergeCells("G6:I6");
            sheet.getCell("G6").value = "Date: " + (typeof benefitDate !== "undefined" ? benefitDate : ""); // handling variable scope safety
            sheet.getCell("G6").font = {
              bold: true
            };
            sheet.getCell("G6").alignment = {
              horizontal: "right"
            };

            // ==========================
            // Worker, Factory & Accident Information
            // ==========================
            data = (eisPayments === null || eisPayments === void 0 ? void 0 : eisPayments[0]) || {};
            parsingAccidentInfo = JSON.parse(((_data$workforceApplic = data.workforceApplication) === null || _data$workforceApplic === void 0 ? void 0 : _data$workforceApplic.employeeAccidentInfo) || "{}");
            parsedAccidentInfo = typeof parsingAccidentInfo === "string" ? JSON.parse(parsingAccidentInfo) : parsingAccidentInfo;
            parsingDoctorEntry = JSON.parse(((_data$workforceApplic2 = data.workforceApplication) === null || _data$workforceApplic2 === void 0 ? void 0 : _data$workforceApplic2.doctorsEntry) || "{}");
            parsedDoctorEntry = typeof parsingDoctorEntry === "string" ? JSON.parse(parsingDoctorEntry) : parsingDoctorEntry;
            dateOfRejoining = (parsedAccidentInfo === null || parsedAccidentInfo === void 0 ? void 0 : parsedAccidentInfo.dateOfRejoining) || "";
            dateOfAssessment = (parsedDoctorEntry === null || parsedDoctorEntry === void 0 ? void 0 : parsedDoctorEntry.dateOfAssessment) || "";
            accidentDate = (parsedAccidentInfo === null || parsedAccidentInfo === void 0 ? void 0 : parsedAccidentInfo.accidentDate) || "";
            (parsedAccidentInfo === null || parsedAccidentInfo === void 0 ? void 0 : parsedAccidentInfo.dateOfDeath) || ""; // LOGIC CHANGE: Exclude "Date of Death" for Disability Excel
            leftItems = [["EIS Worker ID", (data === null || data === void 0 ? void 0 : data.beneficiaryId) || ""], ["Date of Accident", accidentDate || ""], ["Date of Rejoining", dateOfRejoining], ["Date of Disability Assessment", dateOfAssessment], ["Effective date of Benefit", dateOfRejoining || dateOfAssessment || ""]];
            rightItems = [["Name of the Factory", ((_data$workforceApplic3 = data.workforceApplication) === null || _data$workforceApplic3 === void 0 || (_data$workforceApplic3 = _data$workforceApplic3.employeeFactory) === null || _data$workforceApplic3 === void 0 ? void 0 : _data$workforceApplic3.nameEn) || ""], ["Name of Association", ((_data$workforceApplic4 = data.workforceApplication) === null || _data$workforceApplic4 === void 0 ? void 0 : _data$workforceApplic4.associationType) || ""], ["Gross Salary (BDT)", ((_data$workforceApplic5 = data.workforceApplication) === null || _data$workforceApplic5 === void 0 ? void 0 : _data$workforceApplic5.lastBaseSalary) || ""], ["Percentage of Disability", (parsedDoctorEntry === null || parsedDoctorEntry === void 0 ? void 0 : parsedDoctorEntry.disabilityPerSchedule) || ""], ["Type of Accident", ((parsedAccidentInfo === null || parsedAccidentInfo === void 0 ? void 0 : parsedAccidentInfo.accidentMainType) === "workforce.accident.mainType.workplace" ? "Workplace Accident" : (parsedAccidentInfo === null || parsedAccidentInfo === void 0 ? void 0 : parsedAccidentInfo.accidentMainType) === "workforce.accident.mainType.onDutyRTA" ? "On Duty RTA" : "Commuting") || ""]]; // Section Title
            titleRow = sheet.addRow([]);
            sheet.mergeCells("A".concat(titleRow.number, ":F").concat(titleRow.number));
            sheet.getCell("A".concat(titleRow.number)).value = "Worker, Factory & Accident Information:";
            sheet.getCell("A".concat(titleRow.number)).font = {
              bold: true
            };
            sheet.getCell("A".concat(titleRow.number)).alignment = {
              horizontal: "left"
            };

            // Add combined rows (Left + Right)
            // LOGIC CHANGE: Dynamic loop length to handle array sizes safely
            maxRows = Math.max(leftItems.length, rightItems.length);
            _loop = /*#__PURE__*/_regeneratorRuntime.mark(function _loop(i) {
              var _leftItems$i, _leftItems$i2, _rightItems$i, _rightItems$i2;
              var row;
              return _regeneratorRuntime.wrap(function _loop$(_context6) {
                while (1) switch (_context6.prev = _context6.next) {
                  case 0:
                    row = sheet.addRow([((_leftItems$i = leftItems[i]) === null || _leftItems$i === void 0 ? void 0 : _leftItems$i[0]) || "", ((_leftItems$i2 = leftItems[i]) === null || _leftItems$i2 === void 0 ? void 0 : _leftItems$i2[1]) || "", "",
                    // gap
                    ((_rightItems$i = rightItems[i]) === null || _rightItems$i === void 0 ? void 0 : _rightItems$i[0]) || "", ((_rightItems$i2 = rightItems[i]) === null || _rightItems$i2 === void 0 ? void 0 : _rightItems$i2[1]) || "", "" // gap
                    ]);
                    ["A", "B", "D", "E"].forEach(function (col) {
                      var cell = sheet.getCell("".concat(col).concat(row.number));
                      // Only draw border if there is content or it's within the valid list range
                      if (i < leftItems.length && (col === "A" || col === "B")) {
                        cell.border = {
                          top: {
                            style: "thin"
                          },
                          left: {
                            style: "thin"
                          },
                          bottom: {
                            style: "thin"
                          },
                          right: {
                            style: "thin"
                          }
                        };
                      }
                      if (i < rightItems.length && (col === "D" || col === "E")) {
                        cell.border = {
                          top: {
                            style: "thin"
                          },
                          left: {
                            style: "thin"
                          },
                          bottom: {
                            style: "thin"
                          },
                          right: {
                            style: "thin"
                          }
                        };
                      }
                      cell.alignment = {
                        vertical: "middle",
                        horizontal: "left",
                        wrapText: true
                      };
                      if (col === "A" || col === "D") cell.font = {
                        bold: true
                      };
                    });
                  case 2:
                  case "end":
                    return _context6.stop();
                }
              }, _loop);
            });
            i = 0;
          case 44:
            if (!(i < maxRows)) {
              _context7.next = 49;
              break;
            }
            return _context7.delegateYield(_loop(i), "t0", 46);
          case 46:
            i++;
            _context7.next = 44;
            break;
          case 49:
            // ==========================
            // Separate EIS Payments Table
            // ==========================
            sheet.addRow([]);
            benefitTitle = sheet.addRow(["Benefit Information:"]);
            benefitTitle.font = {
              bold: true,
              size: 12
            };
            benefitTitle.alignment = {
              horizontal: "left"
            };
            sheet.addRow([]);
            tableHeader = ["Sl #", "EIS Beneficiary ID", "NID/Birth Certificate of Worker", "Benefit Rate (%) of Gross Salary", "Monthly Payable Benefit (BDT)", "Net Monthly Payable After Adjustment (BDT)",
            // "Total time amount (individual)", "After adjustment (individual)",
            "Type of Payment", "Approval Status", "Remarks"];
            headerRow = sheet.addRow(tableHeader);
            headerRow.eachCell(function (cell) {
              cell.fill = {
                type: "pattern",
                pattern: "solid",
                fgColor: "white"
              };
              cell.font = {
                bold: true
              };
              cell.alignment = {
                horizontal: "center",
                vertical: "middle",
                wrapText: true
              };
              cell.border = {
                top: {
                  style: "thin"
                },
                left: {
                  style: "thin"
                },
                bottom: {
                  style: "thin"
                },
                right: {
                  style: "thin"
                }
              };
            });
            totalMonthly = 0;
            totalNet = 0;
            eisPayments.forEach(function (row, index) {
              var _row$workforceApplica, _row$workforceEmploye, _row$workforceApplica2;
              var benefitRate = Number(row === null || row === void 0 ? void 0 : row.eisInitialReplacementRate) || 0;
              var excelRow = sheet.addRow([index + 1, (row === null || row === void 0 ? void 0 : row.beneficiaryId) || "", (row === null || row === void 0 || (_row$workforceApplica = row.workforceApplication) === null || _row$workforceApplica === void 0 ? void 0 : _row$workforceApplica.applicationType) === "financialAssistance" ? row === null || row === void 0 || (_row$workforceEmploye = row.workforceEmployeeDependent) === null || _row$workforceEmploye === void 0 || (_row$workforceEmploye = _row$workforceEmploye[0]) === null || _row$workforceEmploye === void 0 ? void 0 : _row$workforceEmploye.nid : (row === null || row === void 0 || (_row$workforceApplica2 = row.workforceApplication) === null || _row$workforceApplica2 === void 0 || (_row$workforceApplica2 = _row$workforceApplica2.workforceEmployee) === null || _row$workforceApplica2 === void 0 ? void 0 : _row$workforceApplica2.nid) || "", "".concat(Number(benefitRate * 100).toFixed(2), "%"), Number((row === null || row === void 0 ? void 0 : row.eisInitialMonthlyAmount) || 0).toFixed(2), Number((row === null || row === void 0 ? void 0 : row.eisMonthlyAmount) || 0).toFixed(2),
              // row?.eisCalculatedAmount || 0,
              // row?.eisApprovedAmount || 0,
              (row === null || row === void 0 ? void 0 : row.eisPaymentType) || "", (row === null || row === void 0 ? void 0 : row.approvalStatus) || "", ""]);
              totalMonthly += Number((row === null || row === void 0 ? void 0 : row.eisInitialMonthlyAmount) || 0);
              totalNet += Number((row === null || row === void 0 ? void 0 : row.eisMonthlyAmount) || 0);
              excelRow.eachCell(function (cell) {
                cell.border = {
                  top: {
                    style: "thin"
                  },
                  left: {
                    style: "thin"
                  },
                  bottom: {
                    style: "thin"
                  },
                  right: {
                    style: "thin"
                  }
                };
                cell.alignment = {
                  vertical: "middle",
                  horizontal: "center",
                  wrapText: true
                };
              });
            });
            totalRow = sheet.addRow(["Total", "", "", "", Number(totalMonthly).toFixed(2), Number(totalNet).toFixed(2), "", "", "", "", ""]);
            totalRow.eachCell(function (cell, col) {
              if (col === 1 || col === 4) cell.font = {
                bold: true
              };
              cell.border = {
                top: {
                  style: "thin"
                },
                left: {
                  style: "thin"
                },
                bottom: {
                  style: "thin"
                },
                right: {
                  style: "thin"
                }
              };
              cell.alignment = {
                horizontal: "center",
                vertical: "middle"
              };
            });

            // ==========================
            // Footer
            // ==========================
            sheet.addRow([]);
            sheet.addRow([]);
            sheet.addRow([]);
            footerHeader = sheet.addRow(["Signature of EIS-GB Sub Committee Members:"]);
            footerHeader.font = {
              bold: true,
              size: 13
            };
            footerHeader.alignment = {
              horizontal: "left"
            };
            sheet.addRow([]);
            sheet.addRow([]);
            sheet.addRow([]);
            signatureBlocks = [["President-BAWF &\nExecutive Member,\nIBC\nMember\nEIS-GB Sub\nCommittee"], ["President-SLF\n& Member- NCCWE\nMember\nEIS-GB Sub\nCommittee"], ["Director\nBKMEA\nMember\nEIS-GB Sub\nCommittee"], ["Chairman,\nLabour & ILO Standing\nCommittee\nBGMEA\nMember\nEIS-GB Sub Committee"], ["Inspector General,\nDIFE\nMember\nEIS-GB Sub\nCommittee"], ["Director General,\nDepartment of Labour\nMember\nEIS-GB Sub Committee"], ["Director General,\nCentral Fund\nMember Secretary\nEIS-GB Sub Committee"], ["Additional Secretary,\nI.O. Wing, MoLE\nChairman\nEIS-GB Sub Committee"]];
            underlineRow = sheet.addRow(signatureBlocks.map(function () {
              return "__________________";
            }));
            underlineRow.height = 20;
            underlineRow.eachCell(function (cell) {
              cell.font = {
                bold: true
              };
              cell.alignment = {
                horizontal: "left",
                vertical: "bottom"
              };
            });
            textRow = sheet.addRow(signatureBlocks.map(function (sig) {
              return sig[0];
            }));
            textRow.height = 70;
            textRow.eachCell(function (cell) {
              cell.alignment = {
                horizontal: "left",
                vertical: "top",
                wrapText: true
              };
            });
            sheet.addRow([]);
            _context7.next = 82;
            return workbook.xlsx.writeBuffer();
          case 82:
            buffer = _context7.sent;
            blob = new Blob([buffer], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            });
            saveAs(blob, "Benefit Approval Note-Disability.xlsx");
          case 85:
          case "end":
            return _context7.stop();
        }
      }, _callee6);
    }));
    return function exportDisabilityExcel(_x7) {
      return _ref7.apply(this, arguments);
    };
  }();
  var exportDeathExcel = /*#__PURE__*/function () {
    var _ref8 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee7(eisPayments) {
      var _data$workforceApplic6, _data$workforceApplic7, _data$workforceApplic8, _data$workforceApplic9, _data$workforceApplic10, _data$workforceApplic11;
      var workbook, sheet, data, parsingAccidentInfo, parsedAccidentInfo, parsingDoctorEntry, parsedDoctorEntry, dateOfRejoining, dateOfAssessment, effectiveDate, accidentDate, dateOfDeath, leftItems, rightItems, titleRow, maxRows, _loop2, i, benefitTitle, tableHeader, headerRow, totalMonthly, totalNet, totalRow, footerHeader, signatureBlocks, underlineRow, textRow, buffer, blob;
      return _regeneratorRuntime.wrap(function _callee7$(_context9) {
        while (1) switch (_context9.prev = _context9.next) {
          case 0:
            workbook = new ExcelJS.Workbook();
            sheet = workbook.addWorksheet("Benefit Approval Note"); // ==========================
            // Set column widths
            // ==========================
            sheet.columns = [{
              width: 20
            },
            // A
            {
              width: 25
            },
            // B
            {
              width: 15
            },
            // C (gap)
            {
              width: 25
            },
            // D
            {
              width: 25
            },
            // E
            {
              width: 15
            },
            // F (gap)
            {
              width: 20
            },
            // G
            {
              width: 20
            },
            // H
            {
              width: 20
            },
            // I
            {
              width: 20
            } // J
            ];

            // ==========================
            // Top Headers
            // ==========================
            sheet.mergeCells("A1:I1");
            sheet.getCell("A1").value = "Employment Injury Scheme-Pilot";
            sheet.getCell("A1").font = {
              bold: true,
              size: 16
            };
            sheet.getCell("A1").alignment = {
              horizontal: "center"
            };
            sheet.mergeCells("A2:I2");
            sheet.getCell("A2").value = "Benefit Approval Note (Death)";
            sheet.getCell("A2").font = {
              bold: true,
              size: 14
            };
            sheet.getCell("A2").alignment = {
              horizontal: "center"
            };
            sheet.mergeCells("A3:I3");
            sheet.getCell("A3").value = "EIS PILOT Special Unit, 196, Sromo Bhaban (9th Floor), Bijoynagar, Dhaka, 1000";
            sheet.getCell("A3").alignment = {
              horizontal: "center"
            };
            sheet.mergeCells("A4:I4");
            sheet.getCell("A4").value = "Email: specialunit@eis-pilot-bd.org, Phone: 01886-921030, Website: eis-pilot-bd.org";
            sheet.getCell("A4").alignment = {
              horizontal: "center"
            };

            // ==========================
            // Meeting Info
            // ==========================
            sheet.mergeCells("A6:F6");
            sheet.getCell("A6").value = "EIS-GB Sub Committee Meeting No:16";
            sheet.getCell("A6").font = {
              bold: true
            };
            sheet.getCell("A6").alignment = {
              horizontal: "left"
            };
            sheet.mergeCells("G6:I6");
            sheet.getCell("G6").value = "Date: 10/15/2025";
            sheet.getCell("G6").font = {
              bold: true
            };
            sheet.getCell("G6").alignment = {
              horizontal: "right"
            };

            // ==========================
            // Worker, Factory & Accident Information
            // ==========================
            data = (eisPayments === null || eisPayments === void 0 ? void 0 : eisPayments[0]) || {};
            parsingAccidentInfo = JSON.parse(((_data$workforceApplic6 = data.workforceApplication) === null || _data$workforceApplic6 === void 0 ? void 0 : _data$workforceApplic6.employeeAccidentInfo) || "{}");
            parsedAccidentInfo = typeof parsingAccidentInfo === "string" ? JSON.parse(parsingAccidentInfo) : parsingAccidentInfo;
            parsingDoctorEntry = JSON.parse(((_data$workforceApplic7 = data.workforceApplication) === null || _data$workforceApplic7 === void 0 ? void 0 : _data$workforceApplic7.doctorsEntry) || "{}");
            parsedDoctorEntry = typeof parsingDoctorEntry === "string" ? JSON.parse(parsingDoctorEntry) : parsingDoctorEntry; // We keep all variable extractions here as requested (don't remove fields)
            dateOfRejoining = (parsedAccidentInfo === null || parsedAccidentInfo === void 0 ? void 0 : parsedAccidentInfo.dateOfRejoining) || "";
            dateOfAssessment = (parsedDoctorEntry === null || parsedDoctorEntry === void 0 ? void 0 : parsedDoctorEntry.dateOfAssessment) || "";
            effectiveDate = dateOfRejoining || dateOfAssessment || "";
            accidentDate = (parsedAccidentInfo === null || parsedAccidentInfo === void 0 ? void 0 : parsedAccidentInfo.accidentDate) || "";
            dateOfDeath = (parsedAccidentInfo === null || parsedAccidentInfo === void 0 ? void 0 : parsedAccidentInfo.dateOfDeath) || ""; // LOGIC CHANGE: Exclude Rejoining, Assessment from Left
            // Items are now: Worker ID, Death Date, Accident Date, Effective Date
            leftItems = [["EIS Worker ID", (data === null || data === void 0 || (_data$workforceApplic8 = data.workforceApplication) === null || _data$workforceApplic8 === void 0 ? void 0 : _data$workforceApplic8.applicationType) == "financialAssistance" ? data === null || data === void 0 ? void 0 : data.beneficiaryId.slice(0, 17) : (data === null || data === void 0 ? void 0 : data.beneficiaryId) || ""], ["Date of Death", dateOfDeath || ""], ["Date of Accident", accidentDate || ""],
            // Removed: ["Date of Rejoining", dateOfRejoining],
            // Removed: ["Date of Disability Assessment", dateOfAssessment],
            ["Effective date of Benefit", effectiveDate]]; // LOGIC CHANGE: Exclude Percentage of Disability from Right
            // Items are now: Factory, Association, Salary, Type of Accident
            rightItems = [["Name of the Factory", ((_data$workforceApplic9 = data.workforceApplication) === null || _data$workforceApplic9 === void 0 || (_data$workforceApplic9 = _data$workforceApplic9.employeeFactory) === null || _data$workforceApplic9 === void 0 ? void 0 : _data$workforceApplic9.nameEn) || ""], ["Name of Association", ((_data$workforceApplic10 = data.workforceApplication) === null || _data$workforceApplic10 === void 0 ? void 0 : _data$workforceApplic10.associationType) || ""], ["Gross Salary (BDT)", ((_data$workforceApplic11 = data.workforceApplication) === null || _data$workforceApplic11 === void 0 ? void 0 : _data$workforceApplic11.lastBaseSalary) || ""],
            // Removed: ["Percentage of Disability", parsedDoctorEntry?.disabilityPerSchedule || ""],
            ["Type of Accident", ((parsedAccidentInfo === null || parsedAccidentInfo === void 0 ? void 0 : parsedAccidentInfo.accidentMainType) === "workforce.accident.mainType.workplace" ? "Workplace Accident" : (parsedAccidentInfo === null || parsedAccidentInfo === void 0 ? void 0 : parsedAccidentInfo.accidentMainType) === "workforce.accident.mainType.onDutyRTA" ? "On Duty RTA" : "Commuting") || ""]]; // Section Title
            titleRow = sheet.addRow([]);
            sheet.mergeCells("A".concat(titleRow.number, ":F").concat(titleRow.number));
            sheet.getCell("A".concat(titleRow.number)).value = "Worker, Factory & Accident Information:";
            sheet.getCell("A".concat(titleRow.number)).font = {
              bold: true
            };
            sheet.getCell("A".concat(titleRow.number)).alignment = {
              horizontal: "left"
            };

            // Add combined rows (Left + Right)
            // LOGIC CHANGE: Calculate loop length dynamically instead of fixed 5
            maxRows = Math.max(leftItems.length, rightItems.length);
            _loop2 = /*#__PURE__*/_regeneratorRuntime.mark(function _loop2(i) {
              var _leftItems$i3, _leftItems$i4, _rightItems$i3, _rightItems$i4;
              var row;
              return _regeneratorRuntime.wrap(function _loop2$(_context8) {
                while (1) switch (_context8.prev = _context8.next) {
                  case 0:
                    row = sheet.addRow([((_leftItems$i3 = leftItems[i]) === null || _leftItems$i3 === void 0 ? void 0 : _leftItems$i3[0]) || "", ((_leftItems$i4 = leftItems[i]) === null || _leftItems$i4 === void 0 ? void 0 : _leftItems$i4[1]) || "", "",
                    // gap
                    ((_rightItems$i3 = rightItems[i]) === null || _rightItems$i3 === void 0 ? void 0 : _rightItems$i3[0]) || "", ((_rightItems$i4 = rightItems[i]) === null || _rightItems$i4 === void 0 ? void 0 : _rightItems$i4[1]) || "", "" // gap
                    ]);
                    ["A", "B", "D", "E"].forEach(function (col) {
                      var cell = sheet.getCell("".concat(col).concat(row.number));

                      // Only draw borders if content exists for this side
                      if (i < leftItems.length && (col === "A" || col === "B")) {
                        cell.border = {
                          top: {
                            style: "thin"
                          },
                          left: {
                            style: "thin"
                          },
                          bottom: {
                            style: "thin"
                          },
                          right: {
                            style: "thin"
                          }
                        };
                      }
                      if (i < rightItems.length && (col === "D" || col === "E")) {
                        cell.border = {
                          top: {
                            style: "thin"
                          },
                          left: {
                            style: "thin"
                          },
                          bottom: {
                            style: "thin"
                          },
                          right: {
                            style: "thin"
                          }
                        };
                      }
                      cell.alignment = {
                        vertical: "middle",
                        horizontal: "left",
                        wrapText: true
                      };
                      if (col === "A" || col === "D") cell.font = {
                        bold: true
                      };
                    });
                  case 2:
                  case "end":
                    return _context8.stop();
                }
              }, _loop2);
            });
            i = 0;
          case 45:
            if (!(i < maxRows)) {
              _context9.next = 50;
              break;
            }
            return _context9.delegateYield(_loop2(i), "t0", 47);
          case 47:
            i++;
            _context9.next = 45;
            break;
          case 50:
            // ==========================
            // Separate EIS Payments Table
            // ==========================
            sheet.addRow([]);
            benefitTitle = sheet.addRow(["Benefit Information:"]);
            benefitTitle.font = {
              bold: true,
              size: 12
            };
            benefitTitle.alignment = {
              horizontal: "left"
            };
            sheet.addRow([]);
            tableHeader = ["Sl #", "EIS Beneficiary ID", "NID/Birth Certificate of Worker", "Relationship with worker", "Benefit Rate (%) of Gross Salary", "Monthly Payable Benefit (BDT)", "Net Monthly Payable After Adjustment (BDT)",
            // "Total time amount (individual)", "After adjustment (individual)",
            "Type of Payment", "Approval Status", "Remarks"];
            headerRow = sheet.addRow(tableHeader);
            headerRow.eachCell(function (cell) {
              cell.fill = {
                type: "pattern",
                pattern: "solid",
                fgColor: "white"
              };
              cell.font = {
                bold: true
              };
              cell.alignment = {
                horizontal: "center",
                vertical: "middle",
                wrapText: true
              };
              cell.border = {
                top: {
                  style: "thin"
                },
                left: {
                  style: "thin"
                },
                bottom: {
                  style: "thin"
                },
                right: {
                  style: "thin"
                }
              };
            });
            totalMonthly = 0;
            totalNet = 0;
            eisPayments.forEach(function (row, index) {
              var _row$workforceApplica3, _row$workforceEmploye2, _row$workforceApplica4, _row$workforceEmploye3, _row$workforceEmploye4;
              var benefitRate = Number(row === null || row === void 0 ? void 0 : row.eisInitialReplacementRate) || 0;
              var excelRow = sheet.addRow([index + 1, row === null || row === void 0 ? void 0 : row.beneficiaryId, (row === null || row === void 0 || (_row$workforceApplica3 = row.workforceApplication) === null || _row$workforceApplica3 === void 0 ? void 0 : _row$workforceApplica3.applicationType) === "financialAssistance" ? row === null || row === void 0 || (_row$workforceEmploye2 = row.workforceEmployeeDependent) === null || _row$workforceEmploye2 === void 0 || (_row$workforceEmploye2 = _row$workforceEmploye2[0]) === null || _row$workforceEmploye2 === void 0 ? void 0 : _row$workforceEmploye2.nid : (row === null || row === void 0 || (_row$workforceApplica4 = row.workforceApplication) === null || _row$workforceApplica4 === void 0 || (_row$workforceApplica4 = _row$workforceApplica4.workforceEmployee) === null || _row$workforceApplica4 === void 0 ? void 0 : _row$workforceApplica4.nid) || "",
              // Note: Ensure RELATION_LABEL_MAP is defined in your component scope
              (typeof RELATION_LABEL_MAP !== "undefined" ? RELATION_LABEL_MAP[row === null || row === void 0 || (_row$workforceEmploye3 = row.workforceEmployeeDependent) === null || _row$workforceEmploye3 === void 0 || (_row$workforceEmploye3 = _row$workforceEmploye3[0]) === null || _row$workforceEmploye3 === void 0 ? void 0 : _row$workforceEmploye3.relationWithWorker] : row === null || row === void 0 || (_row$workforceEmploye4 = row.workforceEmployeeDependent) === null || _row$workforceEmploye4 === void 0 || (_row$workforceEmploye4 = _row$workforceEmploye4[0]) === null || _row$workforceEmploye4 === void 0 ? void 0 : _row$workforceEmploye4.relationWithWorker) || "", "".concat(Number(benefitRate * 100).toFixed(2), "%"), Number((row === null || row === void 0 ? void 0 : row.eisInitialMonthlyAmount) || 0).toFixed(2), Number((row === null || row === void 0 ? void 0 : row.eisMonthlyAmount) || 0).toFixed(2),
              // row?.eisCalculatedAmount || 0,
              // row?.eisApprovedAmount || 0,
              (row === null || row === void 0 ? void 0 : row.eisPaymentType) || "", (row === null || row === void 0 ? void 0 : row.approvalStatus) || "", ""]);
              totalMonthly += Number((row === null || row === void 0 ? void 0 : row.eisInitialMonthlyAmount) || 0);
              totalNet += Number((row === null || row === void 0 ? void 0 : row.eisMonthlyAmount) || 0);
              excelRow.eachCell(function (cell) {
                cell.border = {
                  top: {
                    style: "thin"
                  },
                  left: {
                    style: "thin"
                  },
                  bottom: {
                    style: "thin"
                  },
                  right: {
                    style: "thin"
                  }
                };
                cell.alignment = {
                  vertical: "middle",
                  horizontal: "center",
                  wrapText: true
                };
              });
            });
            totalRow = sheet.addRow(["Total", "", "", "", "", "", Number(totalMonthly).toFixed(2), "", Number(totalNet).toFixed(2), "", "", ""]);
            totalRow.eachCell(function (cell, col) {
              if (col === 1 || col === 4) cell.font = {
                bold: true
              };
              cell.border = {
                top: {
                  style: "thin"
                },
                left: {
                  style: "thin"
                },
                bottom: {
                  style: "thin"
                },
                right: {
                  style: "thin"
                }
              };
              cell.alignment = {
                horizontal: "center",
                vertical: "middle"
              };
            });

            // ==========================
            // Footer
            // ==========================
            sheet.addRow([]);
            sheet.addRow([]);
            sheet.addRow([]);
            footerHeader = sheet.addRow(["Signature of EIS-GB Sub Committee Members:"]);
            footerHeader.font = {
              bold: true,
              size: 13
            };
            footerHeader.alignment = {
              horizontal: "left"
            };
            sheet.addRow([]);
            sheet.addRow([]);
            sheet.addRow([]);
            signatureBlocks = [["Executive Member\nIBC\nMember.\nEIS-GB Sub Committee"], ["Member,\nNCCWE.\nMember.\nEIS-GB Sub Committee"], ["Vice President\nBKMEA\nMember.\nEIS-GB Sub Committee"], ["Chairman,\nLabour & ILO Standing Committee\nBGMEA\nMember.\nEIS-GB Sub Committee"], ["Director General,\nDepartment of Labour\nMember Secretary.\nEIS-GB Sub Committee"], ["Director General,\nCentral Fund\nMember Secretary.\nEIS-GB Sub Committee"], ["Additional Secretary,\nI.O. Wing, MoLE\nChairman.\nEIS-GB Sub Committee"]];
            underlineRow = sheet.addRow(signatureBlocks.map(function () {
              return "__________________";
            }));
            underlineRow.height = 20;
            underlineRow.eachCell(function (cell) {
              cell.font = {
                bold: true
              };
              cell.alignment = {
                horizontal: "left",
                vertical: "bottom"
              };
            });
            textRow = sheet.addRow(signatureBlocks.map(function (sig) {
              return sig[0];
            }));
            textRow.height = 70;
            textRow.eachCell(function (cell) {
              cell.alignment = {
                horizontal: "left",
                vertical: "top",
                wrapText: true
              };
            });
            sheet.addRow([]);
            _context9.next = 83;
            return workbook.xlsx.writeBuffer();
          case 83:
            buffer = _context9.sent;
            blob = new Blob([buffer], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            });
            saveAs(blob, "Benefit Approval Note-Death.xlsx");
          case 86:
          case "end":
            return _context9.stop();
        }
      }, _callee7);
    }));
    return function exportDeathExcel(_x8) {
      return _ref8.apply(this, arguments);
    };
  }();

  // --- 5. UI PREPARATION ---
  var firstData = (eisPayments === null || eisPayments === void 0 ? void 0 : eisPayments[0]) || {};
  var appType = firstData === null || firstData === void 0 || (_firstData$workforceA = firstData.workforceApplication) === null || _firstData$workforceA === void 0 ? void 0 : _firstData$workforceA.applicationType;
  var isDeathCase = appType === "financialAssistance";

  // Parse JSONs for UI
  var parsedAccidentInfo = {};
  var parsedDoctorEntry = {};
  try {
    var _firstData$workforceA2, _firstData$workforceA3;
    var rawAccident = firstData === null || firstData === void 0 || (_firstData$workforceA2 = firstData.workforceApplication) === null || _firstData$workforceA2 === void 0 ? void 0 : _firstData$workforceA2.employeeAccidentInfo;
    if (rawAccident) parsedAccidentInfo = JSON.parse(JSON.parse(rawAccident));
    var rawDoctor = firstData === null || firstData === void 0 || (_firstData$workforceA3 = firstData.workforceApplication) === null || _firstData$workforceA3 === void 0 ? void 0 : _firstData$workforceA3.doctorsEntry;
    if (rawDoctor) parsedDoctorEntry = JSON.parse(JSON.parse(rawDoctor));
  } catch (e) {}
  var dateOfRejoining = ((_parsedAccidentInfo = parsedAccidentInfo) === null || _parsedAccidentInfo === void 0 ? void 0 : _parsedAccidentInfo.dateOfRejoining) || "";
  var dateOfAssessment = ((_parsedDoctorEntry = parsedDoctorEntry) === null || _parsedDoctorEntry === void 0 ? void 0 : _parsedDoctorEntry.dateOfAssessment) || "";
  console.log({
    eisPayments: eisPayments
  });
  console.log({
    eisApprovalSignature: eisApprovalSignature
  });

  // --- RENDER ---
  return /*#__PURE__*/React.createElement(Dialog$1, {
    open: open,
    onClose: onClose,
    maxWidth: "lg",
    fullWidth: true,
    classes: {
      paper: classes.dialogPaper
    }
  }, /*#__PURE__*/React.createElement(DialogTitle, {
    disableTypography: true,
    className: classes.noPrint
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6"
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "Preview & Print Approval Note"
  }))), /*#__PURE__*/React.createElement(DialogContent$1, {
    className: classes.dialogContent
  }, loading ? /*#__PURE__*/React.createElement(Box$1, {
    display: "flex",
    justifyContent: "center",
    p: 4
  }, /*#__PURE__*/React.createElement(CircularProgress$1, null), " ", /*#__PURE__*/React.createElement("span", {
    style: {
      marginLeft: 10
    }
  }, "Loading...")) :
  /*#__PURE__*/
  /* THIS ID "printable-content" IS KEY FOR THE PRINT FIX */
  React.createElement("div", {
    id: "printable-content"
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.docTitle
  }, "Employment Injury Scheme-Pilot"), /*#__PURE__*/React.createElement(Typography, {
    className: classes.docSubTitle
  }, "Benefit Approval Note (", isDeathCase ? "Death" : "Disability", ")"), /*#__PURE__*/React.createElement(Typography, {
    className: classes.docText
  }, "EIS PILOT Special Unit, 196, Sromo Bhaban (9th Floor), Bijoynagar, Dhaka, 1000"), /*#__PURE__*/React.createElement(Typography, {
    className: classes.docText
  }, "Email: specialunit@eis-pilot-bd.org, Phone: 01886-921030, Website: eis-pilot-bd.org"), /*#__PURE__*/React.createElement(Box$1, {
    mt: 3,
    mb: 1
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    justify: "space-between"
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true
  }, /*#__PURE__*/React.createElement(Typography, {
    style: {
      fontWeight: "bold",
      fontSize: "12px",
      fontFamily: "Arial"
    }
  }, eisApprovalSignature === null || eisApprovalSignature === void 0 || (_eisApprovalSignature = eisApprovalSignature[0]) === null || _eisApprovalSignature === void 0 || (_eisApprovalSignature = _eisApprovalSignature.role) === null || _eisApprovalSignature === void 0 ? void 0 : _eisApprovalSignature.name, " : ", (_eisPayments$ = eisPayments[0]) === null || _eisPayments$ === void 0 || (_eisPayments$ = _eisPayments$.workforceApplication) === null || _eisPayments$ === void 0 || (_eisPayments$ = _eisPayments$.eisApplicationSummary) === null || _eisPayments$ === void 0 ? void 0 : _eisPayments$.name)), /*#__PURE__*/React.createElement(Grid, {
    item: true
  }, /*#__PURE__*/React.createElement(Typography, {
    style: {
      fontWeight: "bold",
      fontSize: "12px",
      fontFamily: "Arial"
    }
  }, "Date: ", new Date().toLocaleDateString())))), /*#__PURE__*/React.createElement(Typography, {
    className: classes.sectionTitle
  }, "Worker, Factory & Accident Information:"), /*#__PURE__*/React.createElement("table", {
    className: classes.excelTable,
    style: {
      marginTop: 0
    }
  }, /*#__PURE__*/React.createElement("tbody", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    style: {
      width: "20%",
      fontWeight: "bold"
    }
  }, "EIS Beneficiary ID"), /*#__PURE__*/React.createElement("td", {
    style: {
      width: "25%"
    }
  }, (firstData === null || firstData === void 0 || (_firstData$workforceA4 = firstData.workforceApplication) === null || _firstData$workforceA4 === void 0 ? void 0 : _firstData$workforceA4.applicationType) === "financialAssistance" ? firstData === null || firstData === void 0 || (_firstData$beneficiar = firstData.beneficiaryId) === null || _firstData$beneficiar === void 0 ? void 0 : _firstData$beneficiar.slice(0, 17) : (firstData === null || firstData === void 0 ? void 0 : firstData.beneficiaryId) || ""), /*#__PURE__*/React.createElement("td", {
    style: {
      width: "5%",
      border: "none"
    }
  }), /*#__PURE__*/React.createElement("td", {
    style: {
      width: "20%",
      fontWeight: "bold"
    }
  }, "Name of the Factory"), /*#__PURE__*/React.createElement("td", {
    style: {
      width: "25%"
    }
  }, ((_firstData$workforceA5 = firstData.workforceApplication) === null || _firstData$workforceA5 === void 0 || (_firstData$workforceA5 = _firstData$workforceA5.employeeFactory) === null || _firstData$workforceA5 === void 0 ? void 0 : _firstData$workforceA5.nameEn) || "")), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    style: {
      fontWeight: "bold"
    }
  }, "Date of Accident"), /*#__PURE__*/React.createElement("td", null, ((_parsedAccidentInfo2 = parsedAccidentInfo) === null || _parsedAccidentInfo2 === void 0 ? void 0 : _parsedAccidentInfo2.accidentDate) || ""), /*#__PURE__*/React.createElement("td", {
    style: {
      border: "none"
    }
  }), /*#__PURE__*/React.createElement("td", {
    style: {
      fontWeight: "bold"
    }
  }, "Name of Association"), /*#__PURE__*/React.createElement("td", null, ((_firstData$workforceA6 = firstData.workforceApplication) === null || _firstData$workforceA6 === void 0 ? void 0 : _firstData$workforceA6.associationType) || "")), ((_firstData$workforceA7 = firstData.workforceApplication) === null || _firstData$workforceA7 === void 0 ? void 0 : _firstData$workforceA7.applicationType) === "disabilityAssistance" && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    style: {
      fontWeight: "bold"
    }
  }, "Date of Rejoining"), /*#__PURE__*/React.createElement("td", null, dateOfRejoining), /*#__PURE__*/React.createElement("td", {
    style: {
      border: "none"
    }
  }), /*#__PURE__*/React.createElement("td", {
    style: {
      fontWeight: "bold"
    }
  }, "Gross Salary (BDT)"), /*#__PURE__*/React.createElement("td", null, ((_firstData$workforceA8 = firstData.workforceApplication) === null || _firstData$workforceA8 === void 0 ? void 0 : _firstData$workforceA8.lastBaseSalary) || "")), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    style: {
      fontWeight: "bold"
    }
  }, "Date of Disability Assessment"), /*#__PURE__*/React.createElement("td", null, dateOfAssessment), /*#__PURE__*/React.createElement("td", {
    style: {
      border: "none"
    }
  }), /*#__PURE__*/React.createElement("td", {
    style: {
      fontWeight: "bold"
    }
  }, "Percentage of Disability"), /*#__PURE__*/React.createElement("td", null, ((_parsedDoctorEntry2 = parsedDoctorEntry) === null || _parsedDoctorEntry2 === void 0 ? void 0 : _parsedDoctorEntry2.disabilityPerSchedule) || ""))), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    style: {
      fontWeight: "bold"
    }
  }, "Effective date of Benefit"), /*#__PURE__*/React.createElement("td", null, (firstData === null || firstData === void 0 || (_firstData$workforceA9 = firstData.workforceApplication) === null || _firstData$workforceA9 === void 0 ? void 0 : _firstData$workforceA9.applicationType) === "financialAssistance" ? (_parsedAccidentInfo3 = parsedAccidentInfo) === null || _parsedAccidentInfo3 === void 0 ? void 0 : _parsedAccidentInfo3.dateOfDeath : dateOfRejoining || dateOfAssessment || ((_parsedAccidentInfo4 = parsedAccidentInfo) === null || _parsedAccidentInfo4 === void 0 ? void 0 : _parsedAccidentInfo4.accidentDate) || ""), /*#__PURE__*/React.createElement("td", {
    style: {
      border: "none"
    }
  }), /*#__PURE__*/React.createElement("td", {
    style: {
      fontWeight: "bold"
    }
  }, "Type of Accident"), /*#__PURE__*/React.createElement("td", null, ((_parsedAccidentInfo5 = parsedAccidentInfo) === null || _parsedAccidentInfo5 === void 0 ? void 0 : _parsedAccidentInfo5.accidentMainType) === "workforce.accident.mainType.workplace" ? "Workplace Accident" : ((_parsedAccidentInfo6 = parsedAccidentInfo) === null || _parsedAccidentInfo6 === void 0 ? void 0 : _parsedAccidentInfo6.accidentMainType) === "workforce.accident.mainType.onDutyRTA" ? "On Duty RTA" : "Commuting")))), /*#__PURE__*/React.createElement(Typography, {
    className: classes.sectionTitle
  }, "Benefit Information:"), /*#__PURE__*/React.createElement("table", {
    className: classes.excelTable
  }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, "Sl #"), /*#__PURE__*/React.createElement("th", null, "EIS Worker/Beneficiary ID"), /*#__PURE__*/React.createElement("th", null, "NID/Birth Certificate of ", isDeathCase ? " Beneficiary" : " Worker"), isDeathCase ? /*#__PURE__*/React.createElement("th", null, "Relation with worker") : null, /*#__PURE__*/React.createElement("th", null, "Benefit Rate (%)"), [WORKFORCE_USER_TYPE.EIS_ASSOCIATION_COMMITTEE, WORKFORCE_USER_TYPE.EIS_COMMITTEE].includes(user_type) ? null : firstData !== null && firstData !== void 0 && (_firstData$workforceA10 = firstData.workforceApplication) !== null && _firstData$workforceA10 !== void 0 && _firstData$workforceA10.status && (firstData === null || firstData === void 0 || (_firstData$workforceA11 = firstData.workforceApplication) === null || _firstData$workforceA11 === void 0 ? void 0 : _firstData$workforceA11.status) != "approved_by_committee" ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("th", null, "Total Time Amount"), /*#__PURE__*/React.createElement("th", null, "After Adjustment")) : null, /*#__PURE__*/React.createElement("th", null, "Monthly Payable (BDT)"), /*#__PURE__*/React.createElement("th", null, "Net Payable (BDT)"), /*#__PURE__*/React.createElement("th", null, "Payment Type"), /*#__PURE__*/React.createElement("th", null, "Approval Status"), /*#__PURE__*/React.createElement("th", null, "Remarks"))), /*#__PURE__*/React.createElement("tbody", null, eisPayments.map(function (row, index) {
    var _paymentTypeMap$index, _paymentTypeMap$index2, _row$workforceApplica5, _row$workforceEmploye5, _row$workforceApplica6, _row$workforceEmploye6, _firstData$workforceA12, _firstData$workforceA13, _row$paymentTypeRemar;
    var benefitRate = row !== null && row !== void 0 && row.eisInitialReplacementRate ? Number(row.eisInitialReplacementRate) * 100 : 0;
    ((_paymentTypeMap$index = paymentTypeMap[index]) === null || _paymentTypeMap$index === void 0 ? void 0 : _paymentTypeMap$index.eisPaymentType) || (row === null || row === void 0 ? void 0 : row.eisPaymentType) || "";
    ((_paymentTypeMap$index2 = paymentTypeMap[index]) === null || _paymentTypeMap$index2 === void 0 ? void 0 : _paymentTypeMap$index2.approved) || (row !== null && row !== void 0 && row.isApproved ? "yes" : "");
    return /*#__PURE__*/React.createElement("tr", {
      key: index
    }, /*#__PURE__*/React.createElement("td", {
      style: {
        textAlign: "center"
      }
    }, index + 1), /*#__PURE__*/React.createElement("td", null, row === null || row === void 0 ? void 0 : row.beneficiaryId), /*#__PURE__*/React.createElement("td", null, (row === null || row === void 0 || (_row$workforceApplica5 = row.workforceApplication) === null || _row$workforceApplica5 === void 0 ? void 0 : _row$workforceApplica5.applicationType) === "financialAssistance" ? row === null || row === void 0 || (_row$workforceEmploye5 = row.workforceEmployeeDependent) === null || _row$workforceEmploye5 === void 0 || (_row$workforceEmploye5 = _row$workforceEmploye5[0]) === null || _row$workforceEmploye5 === void 0 ? void 0 : _row$workforceEmploye5.nid : row === null || row === void 0 || (_row$workforceApplica6 = row.workforceApplication) === null || _row$workforceApplica6 === void 0 || (_row$workforceApplica6 = _row$workforceApplica6.workforceEmployee) === null || _row$workforceApplica6 === void 0 ? void 0 : _row$workforceApplica6.nid), isDeathCase ? /*#__PURE__*/React.createElement("td", null, (row === null || row === void 0 || (_row$workforceEmploye6 = row.workforceEmployeeDependent) === null || _row$workforceEmploye6 === void 0 ? void 0 : _row$workforceEmploye6.length) > 0 ? RELATION_LABEL_MAP[row.workforceEmployeeDependent[0].relationWithWorker] || row.workforceEmployeeDependent[0].relationWithWorker || "N/A" : "N/A") : null, /*#__PURE__*/React.createElement("td", {
      style: {
        textAlign: "center"
      }
    }, Number(benefitRate).toFixed(2), "%"), [WORKFORCE_USER_TYPE.EIS_ASSOCIATION_COMMITTEE, WORKFORCE_USER_TYPE.EIS_COMMITTEE].includes(user_type) ? null : firstData !== null && firstData !== void 0 && (_firstData$workforceA12 = firstData.workforceApplication) !== null && _firstData$workforceA12 !== void 0 && _firstData$workforceA12.status && (firstData === null || firstData === void 0 || (_firstData$workforceA13 = firstData.workforceApplication) === null || _firstData$workforceA13 === void 0 ? void 0 : _firstData$workforceA13.status) != "approved_by_committee" ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("td", {
      style: {
        textAlign: "right"
      }
    }, row === null || row === void 0 ? void 0 : row.eisCalculatedAmount), /*#__PURE__*/React.createElement("td", {
      style: {
        textAlign: "right"
      }
    }, row === null || row === void 0 ? void 0 : row.eisApprovedAmount)) : null, /*#__PURE__*/React.createElement("td", {
      style: {
        textAlign: "right"
      }
    }, Number((row === null || row === void 0 ? void 0 : row.eisInitialMonthlyAmount) || 0).toFixed(2)), /*#__PURE__*/React.createElement("td", {
      style: {
        textAlign: "right"
      }
    }, Number((row === null || row === void 0 ? void 0 : row.eisMonthlyAmount) || 0).toFixed(2)), /*#__PURE__*/React.createElement("td", {
      style: {
        textAlign: "center"
      }
    }, /*#__PURE__*/React.createElement(React.Fragment, null, EIS_PAYMENT_TYPES[row === null || row === void 0 ? void 0 : row.eisPaymentType], /*#__PURE__*/React.createElement("style", null, "@media print { .print-show { display: block !important; } }"))), /*#__PURE__*/React.createElement("td", {
      style: {
        textAlign: "center"
      }
    }, /*#__PURE__*/React.createElement(React.Fragment, null, getApprovalStatus(row === null || row === void 0 ? void 0 : row.approved))), /*#__PURE__*/React.createElement("td", null, (_row$paymentTypeRemar = row === null || row === void 0 ? void 0 : row.paymentTypeRemarks) !== null && _row$paymentTypeRemar !== void 0 ? _row$paymentTypeRemar : ""));
  }), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    colSpan: [WORKFORCE_USER_TYPE.EIS_ASSOCIATION_COMMITTEE, WORKFORCE_USER_TYPE.EIS_COMMITTEE].includes(user_type) ? isDeathCase ? 5 : 4 : firstData !== null && firstData !== void 0 && (_firstData$workforceA14 = firstData.workforceApplication) !== null && _firstData$workforceA14 !== void 0 && _firstData$workforceA14.status && (firstData === null || firstData === void 0 || (_firstData$workforceA15 = firstData.workforceApplication) === null || _firstData$workforceA15 === void 0 ? void 0 : _firstData$workforceA15.status) != "approved_by_committee" ? isDeathCase ? 7 : 6 : isDeathCase ? 5 : 4,
    style: {
      textAlign: "right",
      fontWeight: "bold"
    }
  }, "Total:"), /*#__PURE__*/React.createElement("td", {
    style: {
      textAlign: "right",
      fontWeight: "bold"
    }
  }, Number(getMonthlyTotalAmount() || 0).toFixed(2)), /*#__PURE__*/React.createElement("td", {
    style: {
      textAlign: "right",
      fontWeight: "bold"
    }
  }, Number(getNetMonthlyTotalAmount() || 0).toFixed(2)), /*#__PURE__*/React.createElement("td", {
    colSpan: 4
  })))), /*#__PURE__*/React.createElement(Box$1, {
    mt: 4
  }, /*#__PURE__*/React.createElement(Typography, {
    style: {
      fontWeight: "bold",
      textDecoration: "underline",
      color: "#000"
    }
  }, "Signature of ", eisApprovalSignature === null || eisApprovalSignature === void 0 || (_eisApprovalSignature2 = eisApprovalSignature[0]) === null || _eisApprovalSignature2 === void 0 || (_eisApprovalSignature2 = _eisApprovalSignature2.role) === null || _eisApprovalSignature2 === void 0 ? void 0 : _eisApprovalSignature2.name, " Members:"), /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 2,
    className: classes.signatureContainer
  }, eisApprovalSignature === null || eisApprovalSignature === void 0 || (_eisApprovalSignature3 = eisApprovalSignature.filter(function (item) {
    return (item === null || item === void 0 ? void 0 : item.representative_type) === "Worker" && !((item === null || item === void 0 ? void 0 : item.role_in_committee) === "Member Secretary" || (item === null || item === void 0 ? void 0 : item.role_in_committee) === "Chairman");
  })) === null || _eisApprovalSignature3 === void 0 ? void 0 : _eisApprovalSignature3.map(function (sig, i) {
    var _sig$workforce_docume, _sig$role_in_committe, _sig$role;
    return /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 3,
      key: (sig === null || sig === void 0 ? void 0 : sig.user_id) || i
    }, sig !== null && sig !== void 0 && (_sig$workforce_docume = sig.workforce_document) !== null && _sig$workforce_docume !== void 0 && _sig$workforce_docume.url ? /*#__PURE__*/React.createElement("img", {
      src: sig.workforce_document.url,
      alt: "signature",
      style: {
        width: "100%",
        maxHeight: 80,
        objectFit: "contain"
      }
    }) : /*#__PURE__*/React.createElement(Typography, {
      variant: "caption",
      style: {
        fontStyle: "italic",
        color: "#999"
      }
    }, "Signature not available"), /*#__PURE__*/React.createElement("div", {
      className: classes.signatureBlock
    }, /*#__PURE__*/React.createElement("p", {
      style: {
        margin: 0,
        fontWeight: "bold"
      }
    }, sig === null || sig === void 0 ? void 0 : sig.designation), /*#__PURE__*/React.createElement("p", {
      style: {
        margin: 0,
        fontWeight: "bold"
      }
    }, sig === null || sig === void 0 ? void 0 : sig.organization_name), /*#__PURE__*/React.createElement("p", {
      style: {
        margin: 0,
        fontWeight: "bold"
      }
    }, (_sig$role_in_committe = sig === null || sig === void 0 ? void 0 : sig.role_in_committee) !== null && _sig$role_in_committe !== void 0 ? _sig$role_in_committe : "Member"), /*#__PURE__*/React.createElement("p", {
      style: {
        margin: 0
      }
    }, sig === null || sig === void 0 || (_sig$role = sig.role) === null || _sig$role === void 0 ? void 0 : _sig$role.name)));
  }), eisApprovalSignature === null || eisApprovalSignature === void 0 || (_eisApprovalSignature4 = eisApprovalSignature.filter(function (item) {
    return (item === null || item === void 0 ? void 0 : item.representative_type) === "Employer" && !((item === null || item === void 0 ? void 0 : item.role_in_committee) === "Member Secretary" || (item === null || item === void 0 ? void 0 : item.role_in_committee) === "Chairman");
  })) === null || _eisApprovalSignature4 === void 0 ? void 0 : _eisApprovalSignature4.map(function (sig, i) {
    var _sig$workforce_docume2, _sig$role_in_committe2, _sig$role2;
    return /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 3,
      key: (sig === null || sig === void 0 ? void 0 : sig.user_id) || i
    }, sig !== null && sig !== void 0 && (_sig$workforce_docume2 = sig.workforce_document) !== null && _sig$workforce_docume2 !== void 0 && _sig$workforce_docume2.url ? /*#__PURE__*/React.createElement("img", {
      src: sig.workforce_document.url,
      alt: "signature",
      style: {
        width: "100%",
        maxHeight: 80,
        objectFit: "contain"
      }
    }) : /*#__PURE__*/React.createElement(Typography, {
      variant: "caption",
      style: {
        fontStyle: "italic",
        color: "#999"
      }
    }, "Signature not available"), /*#__PURE__*/React.createElement("div", {
      className: classes.signatureBlock
    }, /*#__PURE__*/React.createElement("p", {
      style: {
        margin: 0,
        fontWeight: "bold"
      }
    }, sig === null || sig === void 0 ? void 0 : sig.designation), /*#__PURE__*/React.createElement("p", {
      style: {
        margin: 0,
        fontWeight: "bold"
      }
    }, sig === null || sig === void 0 ? void 0 : sig.organization_name), /*#__PURE__*/React.createElement("p", {
      style: {
        margin: 0,
        fontWeight: "bold"
      }
    }, (_sig$role_in_committe2 = sig === null || sig === void 0 ? void 0 : sig.role_in_committee) !== null && _sig$role_in_committe2 !== void 0 ? _sig$role_in_committe2 : "Member"), /*#__PURE__*/React.createElement("p", {
      style: {
        margin: 0
      }
    }, sig === null || sig === void 0 || (_sig$role2 = sig.role) === null || _sig$role2 === void 0 ? void 0 : _sig$role2.name)));
  }), eisApprovalSignature === null || eisApprovalSignature === void 0 || (_eisApprovalSignature5 = eisApprovalSignature.filter(function (item) {
    return (item === null || item === void 0 ? void 0 : item.representative_type) === "Government" && !((item === null || item === void 0 ? void 0 : item.role_in_committee) === "Member Secretary" || (item === null || item === void 0 ? void 0 : item.role_in_committee) === "Chairman");
  })) === null || _eisApprovalSignature5 === void 0 ? void 0 : _eisApprovalSignature5.map(function (sig, i) {
    var _sig$workforce_docume3, _sig$role_in_committe3, _sig$role3;
    return /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 3,
      key: (sig === null || sig === void 0 ? void 0 : sig.user_id) || i
    }, sig !== null && sig !== void 0 && (_sig$workforce_docume3 = sig.workforce_document) !== null && _sig$workforce_docume3 !== void 0 && _sig$workforce_docume3.url ? /*#__PURE__*/React.createElement("img", {
      src: sig.workforce_document.url,
      alt: "signature",
      style: {
        width: "100%",
        maxHeight: 80,
        objectFit: "contain"
      }
    }) : /*#__PURE__*/React.createElement(Typography, {
      variant: "caption",
      style: {
        fontStyle: "italic",
        color: "#999"
      }
    }, "Signature not available"), /*#__PURE__*/React.createElement("div", {
      className: classes.signatureBlock
    }, /*#__PURE__*/React.createElement("p", {
      style: {
        margin: 0,
        fontWeight: "bold"
      }
    }, sig === null || sig === void 0 ? void 0 : sig.designation), /*#__PURE__*/React.createElement("p", {
      style: {
        margin: 0,
        fontWeight: "bold"
      }
    }, sig === null || sig === void 0 ? void 0 : sig.organization_name), /*#__PURE__*/React.createElement("p", {
      style: {
        margin: 0,
        fontWeight: "bold"
      }
    }, (_sig$role_in_committe3 = sig === null || sig === void 0 ? void 0 : sig.role_in_committee) !== null && _sig$role_in_committe3 !== void 0 ? _sig$role_in_committe3 : "Member"), /*#__PURE__*/React.createElement("p", {
      style: {
        margin: 0
      }
    }, sig === null || sig === void 0 || (_sig$role3 = sig.role) === null || _sig$role3 === void 0 ? void 0 : _sig$role3.name)));
  }), eisApprovalSignature === null || eisApprovalSignature === void 0 || (_eisApprovalSignature6 = eisApprovalSignature.filter(function (item) {
    return (item === null || item === void 0 ? void 0 : item.role_in_committee) === "Member Secretary";
  })) === null || _eisApprovalSignature6 === void 0 ? void 0 : _eisApprovalSignature6.map(function (sig, i) {
    var _sig$workforce_docume4, _sig$role_in_committe4, _sig$role4;
    return /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 3,
      key: (sig === null || sig === void 0 ? void 0 : sig.user_id) || i
    }, sig !== null && sig !== void 0 && (_sig$workforce_docume4 = sig.workforce_document) !== null && _sig$workforce_docume4 !== void 0 && _sig$workforce_docume4.url ? /*#__PURE__*/React.createElement("img", {
      src: sig.workforce_document.url,
      alt: "signature",
      style: {
        width: "100%",
        maxHeight: 80,
        objectFit: "contain"
      }
    }) : /*#__PURE__*/React.createElement(Typography, {
      variant: "caption",
      style: {
        fontStyle: "italic",
        color: "#999"
      }
    }, "Signature not available"), /*#__PURE__*/React.createElement("div", {
      className: classes.signatureBlock
    }, /*#__PURE__*/React.createElement("p", {
      style: {
        margin: 0,
        fontWeight: "bold"
      }
    }, sig === null || sig === void 0 ? void 0 : sig.designation), /*#__PURE__*/React.createElement("p", {
      style: {
        margin: 0,
        fontWeight: "bold"
      }
    }, sig === null || sig === void 0 ? void 0 : sig.organization_name), /*#__PURE__*/React.createElement("p", {
      style: {
        margin: 0,
        fontWeight: "bold"
      }
    }, (_sig$role_in_committe4 = sig === null || sig === void 0 ? void 0 : sig.role_in_committee) !== null && _sig$role_in_committe4 !== void 0 ? _sig$role_in_committe4 : "Member"), /*#__PURE__*/React.createElement("p", {
      style: {
        margin: 0
      }
    }, sig === null || sig === void 0 || (_sig$role4 = sig.role) === null || _sig$role4 === void 0 ? void 0 : _sig$role4.name)));
  }), eisApprovalSignature === null || eisApprovalSignature === void 0 || (_eisApprovalSignature7 = eisApprovalSignature.filter(function (item) {
    return (item === null || item === void 0 ? void 0 : item.role_in_committee) === "Chairman";
  })) === null || _eisApprovalSignature7 === void 0 ? void 0 : _eisApprovalSignature7.map(function (sig, i) {
    var _sig$workforce_docume5, _sig$role_in_committe5, _sig$role5;
    return /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 3,
      key: (sig === null || sig === void 0 ? void 0 : sig.user_id) || i
    }, sig !== null && sig !== void 0 && (_sig$workforce_docume5 = sig.workforce_document) !== null && _sig$workforce_docume5 !== void 0 && _sig$workforce_docume5.url ? /*#__PURE__*/React.createElement("img", {
      src: sig.workforce_document.url,
      alt: "signature",
      style: {
        width: "100%",
        maxHeight: 80,
        objectFit: "contain"
      }
    }) : /*#__PURE__*/React.createElement(Typography, {
      variant: "caption",
      style: {
        fontStyle: "italic",
        color: "#999"
      }
    }, "Signature not available"), /*#__PURE__*/React.createElement("div", {
      className: classes.signatureBlock
    }, /*#__PURE__*/React.createElement("p", {
      style: {
        margin: 0,
        fontWeight: "bold"
      }
    }, sig === null || sig === void 0 ? void 0 : sig.designation), /*#__PURE__*/React.createElement("p", {
      style: {
        margin: 0,
        fontWeight: "bold"
      }
    }, sig === null || sig === void 0 ? void 0 : sig.organization_name), /*#__PURE__*/React.createElement("p", {
      style: {
        margin: 0,
        fontWeight: "bold"
      }
    }, (_sig$role_in_committe5 = sig === null || sig === void 0 ? void 0 : sig.role_in_committee) !== null && _sig$role_in_committe5 !== void 0 ? _sig$role_in_committe5 : "Member"), /*#__PURE__*/React.createElement("p", {
      style: {
        margin: 0
      }
    }, sig === null || sig === void 0 || (_sig$role5 = sig.role) === null || _sig$role5 === void 0 ? void 0 : _sig$role5.name)));
  }))))), /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement(DialogActions$1, {
    className: classes.noPrint
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: onClose,
    variant: "outlined",
    color: "primary"
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "workforce.modal.close"
  })), /*#__PURE__*/React.createElement(Button, {
    onClick: function onClick() {
      return window.print();
    },
    variant: "contained",
    color: "primary"
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "workforce.modal.print"
  })), /*#__PURE__*/React.createElement(Button, {
    onClick: exportToExcel,
    variant: "contained",
    style: {
      backgroundColor: "#4caf50",
      color: "white"
    }
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "workforce.modal.excel"
  }))));
};

function _createForOfIteratorHelper$1(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray$1(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray$1(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray$1(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray$1(r, a) : void 0; } }
function _arrayLikeToArray$1(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var useStyles$J = makeStyles(function (theme) {
  return {
    noPrint: {
      "@media print": {
        display: "none !important"
      }
    },
    dialogPaper: {
      "@media print": {
        boxShadow: "none",
        border: "none",
        maxWidth: "100vw"
      }
    },
    dialogContent: {
      "@media print": {
        padding: 0
      }
    }
  };
});

// Add this helper function above your GenerateCommitteeReport component definition
var getIncidentDetails = function getIncidentDetails(rawInfo) {
  var type = "ND";
  var date = "";
  try {
    var parsed = typeof rawInfo === "string" ? JSON.parse(rawInfo) : rawInfo;
    var info = typeof parsed === "string" ? JSON.parse(parsed) : parsed;
    date = (info === null || info === void 0 ? void 0 : info.accidentDate) || (info === null || info === void 0 ? void 0 : info.dateOfDeath) || "";
    if ((info === null || info === void 0 ? void 0 : info.accidentMainType) === "workforce.accident.mainType.workplace") type = "WAD";else if ((info === null || info === void 0 ? void 0 : info.accidentMainType) === "workforce.accident.mainType.onDutyRTA") type = "OAD";else if ((info === null || info === void 0 ? void 0 : info.accidentMainType) === "workforce.accident.mainType.commuting") type = "OAD";
  } catch (e) {}
  return {
    type: type,
    date: date
  };
};
var GenerateCommitteeReport = function GenerateCommitteeReport(_ref) {
  var open = _ref.open,
    onClose = _ref.onClose,
    _ref$applications = _ref.applications,
    applications = _ref$applications === void 0 ? [] : _ref$applications,
    userRights = _ref.userRights,
    status = _ref.status,
    summary_Id = _ref.summary_Id,
    summaryData = _ref.summaryData;
  var classes = useStyles$J();
  var dispatch = useDispatch();
  var modulesManager = useModulesManager();
  var loggedInUserId = useSelector(function (state) {
    var _state$core;
    return (_state$core = state.core) === null || _state$core === void 0 || (_state$core = _state$core.user) === null || _state$core === void 0 || (_state$core = _state$core.i_user) === null || _state$core === void 0 ? void 0 : _state$core.id;
  });
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    movements = _useState2[0],
    setMovements = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2);
    _useState4[0];
    var setLastRevertMovement = _useState4[1];
  var _useState5 = useState([]),
    _useState6 = _slicedToArray(_useState5, 2);
    _useState6[0];
    var setRevertNotes = _useState6[1];
  var _useState7 = useState(null),
    _useState8 = _slicedToArray(_useState7, 2);
    _useState8[0];
    var setServerResponse = _useState8[1];
  var _useState9 = useState([]),
    _useState10 = _slicedToArray(_useState9, 2),
    dependentData = _useState10[0],
    setDependentData = _useState10[1];
  var _useState11 = useState(false),
    _useState12 = _slicedToArray(_useState11, 2),
    loader = _useState12[0],
    setLoader = _useState12[1];
  var _useState13 = useState([]),
    _useState14 = _slicedToArray(_useState13, 2),
    mappings = _useState14[0],
    setMappings = _useState14[1];
  var userIds = safeParse(summaryData === null || summaryData === void 0 ? void 0 : summaryData.userIds);
  console.log({
    applications: applications
  });
  var getTotalAmount = function getTotalAmount() {
    return applications
    // .filter((item) => String(item.status) === String(status))
    .reduce(function (sum, item) {
      return sum + (parseFloat(item.grantAmount) || 0);
    }, 0).toFixed(2);
  };
  console.log({
    fromBFTN: applications
  });
  // console.log({ summary_Id: userIds });

  var handleForward = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _mappings$;
      var filteredApplications, isQuorum, totalApprovers, allMajorityApproved, _iterator, _step, item, decodedId, targetStatus, _updatePayload, approvedUserIds, majorityApproved;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (window.confirm("আবেদনগুলো মহাপরিচালক কাছে অগ্রায়ন নিশ্চিত করছেন?")) {
              _context.next = 2;
              break;
            }
            return _context.abrupt("return");
          case 2:
            setLoader(true);
            filteredApplications = applications.filter(function (item) {
              return String(item.status) === String(status);
            });
            if (!(filteredApplications.length === 0)) {
              _context.next = 6;
              break;
            }
            return _context.abrupt("return", setServerResponse({
              status: "ERROR",
              message: "কোনো উপযুক্ত আবেদন পাওয়া যায়নি।"
            }));
          case 6:
            isQuorum = (mappings === null || mappings === void 0 || (_mappings$ = mappings[0]) === null || _mappings$ === void 0 || (_mappings$ = _mappings$.committee) === null || _mappings$ === void 0 ? void 0 : _mappings$.approvalType) === "quorum";
            totalApprovers = (mappings === null || mappings === void 0 ? void 0 : mappings.length) || 1;
            console.log({
              filteredApplications: filteredApplications
            });
            _context.prev = 9;
            allMajorityApproved = true;
            _iterator = _createForOfIteratorHelper$1(filteredApplications);
            _context.prev = 12;
            _iterator.s();
          case 14:
            if ((_step = _iterator.n()).done) {
              _context.next = 36;
              break;
            }
            item = _step.value;
            decodedId = safeDecodeId(item.id);
            targetStatus = WORKFORCE_STATUS$1.FORWARD_TO_DIRECTOR;
            _updatePayload = {
              id: decodedId
            };
            if (!isQuorum) {
              _context.next = 29;
              break;
            }
            approvedUserIds = item.eisApprovedByIds ? safeParse(item.eisApprovedByIds) : [];
            if (!approvedUserIds.includes(loggedInUserId)) {
              _context.next = 23;
              break;
            }
            return _context.abrupt("return", setServerResponse({
              status: "ERROR",
              message: "আপনি ইতিমধ্যে অনুমোদন করেছেন!"
            }));
          case 23:
            approvedUserIds.push(loggedInUserId);
            majorityApproved = approvedUserIds.length / totalApprovers >= 0.5;
            console.log({
              majorityApproved: majorityApproved
            });
            targetStatus = majorityApproved ? WORKFORCE_STATUS$1.APPROVED_BY_DG : WORKFORCE_STATUS$1.FORWARD_TO_COMIITEE;
            _updatePayload.eisApprovedByIds = JSON.stringify(approvedUserIds);
            if (!majorityApproved) {
              allMajorityApproved = false;
            }
          case 29:
            _updatePayload.status = targetStatus;
            _context.next = 32;
            return dispatch(updateApplication(_updatePayload, "update workforce application"));
          case 32:
            _context.next = 34;
            return dispatch(updateApplicationSummary({
              id: summary_Id,
              status: WORKFORCE_STATUS$1.APPROVED_BY_DG
            }, "update workforce application summary"));
          case 34:
            _context.next = 14;
            break;
          case 36:
            _context.next = 41;
            break;
          case 38:
            _context.prev = 38;
            _context.t0 = _context["catch"](12);
            _iterator.e(_context.t0);
          case 41:
            _context.prev = 41;
            _iterator.f();
            return _context.finish(41);
          case 44:
            if (!(!isQuorum || allMajorityApproved)) {
              _context.next = 49;
              break;
            }
            _context.next = 47;
            return dispatch(updateApplication(updatePayload, "update workforce application"));
          case 47:
            _context.next = 49;
            return dispatch(updateApplicationSummary({
              id: summary_Id,
              status: WORKFORCE_STATUS$1.FORWARD_TO_DIRECTOR
            }, "update workforce application summary"));
          case 49:
            setServerResponse({
              status: "SUCCESS",
              message: "সাবমিশন সফল হয়েছে!"
            });
            _context.next = 55;
            break;
          case 52:
            _context.prev = 52;
            _context.t1 = _context["catch"](9);
            setServerResponse({
              status: "ERROR",
              message: "সাবমিশন ব্যর্থ হয়েছে!"
            });
          case 55:
            _context.prev = 55;
            // setTimeout(() => {
            //   window.location.reload();
            // }, 1500);
            setLoader(false);
            onClose();
            return _context.finish(55);
          case 59:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[9, 52, 55, 59], [12, 38, 41, 44]]);
    }));
    return function handleForward() {
      return _ref2.apply(this, arguments);
    };
  }();
  var fetchApplicationMovement = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var _mappingsData$payload, _applications$, _response$payload, mappingsData, response, movementsData, senderObjects, clean, lastRevert;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            _context2.next = 3;
            return dispatch(fetchWorkforceCommitteeUserMap({
              userIds: userIds || ["".concat(loggedInUserId)]
            }));
          case 3:
            mappingsData = _context2.sent;
            setMappings((mappingsData === null || mappingsData === void 0 || (_mappingsData$payload = mappingsData.payload) === null || _mappingsData$payload === void 0 || (_mappingsData$payload = _mappingsData$payload.data) === null || _mappingsData$payload === void 0 ? void 0 : _mappingsData$payload.workforceCommitteeUserMaps) || []);
            _context2.next = 7;
            return dispatch(fetchApplicationWiseMovementList(modulesManager, {
              applicationId: applications === null || applications === void 0 || (_applications$ = applications[0]) === null || _applications$ === void 0 ? void 0 : _applications$.id
            }));
          case 7:
            response = _context2.sent;
            console.log("movement response", response);
            movementsData = parseData(response === null || response === void 0 || (_response$payload = response.payload) === null || _response$payload === void 0 || (_response$payload = _response$payload.data) === null || _response$payload === void 0 ? void 0 : _response$payload.workforceApplicationMovement) || [];
            senderObjects = movementsData.filter(function (m) {
              return m.applicationFrom !== null;
            }).map(function (m) {
              return m.applicationFrom;
            }).filter(function (m) {
              var _m$userRoles, _m$userRoles2, _m$userRoles3;
              return ((_m$userRoles = m.userRoles) === null || _m$userRoles === void 0 || (_m$userRoles = _m$userRoles[0]) === null || _m$userRoles === void 0 || (_m$userRoles = _m$userRoles.role) === null || _m$userRoles === void 0 ? void 0 : _m$userRoles.name) === "Doctor" || ((_m$userRoles2 = m.userRoles) === null || _m$userRoles2 === void 0 || (_m$userRoles2 = _m$userRoles2[0]) === null || _m$userRoles2 === void 0 || (_m$userRoles2 = _m$userRoles2.role) === null || _m$userRoles2 === void 0 ? void 0 : _m$userRoles2.name) === "Blwf Doctor" || ((_m$userRoles3 = m.userRoles) === null || _m$userRoles3 === void 0 || (_m$userRoles3 = _m$userRoles3[0]) === null || _m$userRoles3 === void 0 || (_m$userRoles3 = _m$userRoles3.role) === null || _m$userRoles3 === void 0 ? void 0 : _m$userRoles3.name) === "Eis Doctor";
            });
            console.log("movement senderData", senderObjects);
            clean = function clean(html) {
              return (html === null || html === void 0 ? void 0 : html.replace(/<\/?[^>]+(>|$)/g, "")) || "";
            }; // Clone and find the last revert note
            lastRevert = _toConsumableArray(movementsData).reverse().find(function (m) {
              return m.revertNote;
            });
            if (lastRevert) {
              lastRevert.revertNote = clean(lastRevert.revertNote);
            }

            // Update State
            setMovements(movementsData);
            setLastRevertMovement(lastRevert);
            setRevertNotes(lastRevert ? [lastRevert.revertNote] : []);
            _context2.next = 23;
            break;
          case 20:
            _context2.prev = 20;
            _context2.t0 = _context2["catch"](0);
            console.error("Failed to load revert notes", _context2.t0);
          case 23:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[0, 20]]);
    }));
    return function fetchApplicationMovement() {
      return _ref3.apply(this, arguments);
    };
  }();
  useEffect(function () {
    if (open) {
      fetchApplicationMovement();
    }
  }, [open]);
  var fetchApplicationEmployeeDependent = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      var _applications$2;
      var applicationId, _response$payload2, response, _dependentData;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            applicationId = safeDecodeId(applications === null || applications === void 0 || (_applications$2 = applications[0]) === null || _applications$2 === void 0 ? void 0 : _applications$2.id);
            _context3.prev = 1;
            _context3.next = 4;
            return dispatch(fetchWorkforceEmployeeDependent(modulesManager, ["workforceApplication_Id: \"".concat(applicationId, "\"")]));
          case 4:
            response = _context3.sent;
            _dependentData = parseData(response === null || response === void 0 || (_response$payload2 = response.payload) === null || _response$payload2 === void 0 || (_response$payload2 = _response$payload2.data) === null || _response$payload2 === void 0 ? void 0 : _response$payload2.workforceEmployeeDependent) || [];
            console.log("dependentData", _dependentData);
            setDependentData(_dependentData);
            _context3.next = 13;
            break;
          case 10:
            _context3.prev = 10;
            _context3.t0 = _context3["catch"](1);
            console.error("Failed to load dependent data", _context3.t0);
          case 13:
          case "end":
            return _context3.stop();
        }
      }, _callee3, null, [[1, 10]]);
    }));
    return function fetchApplicationEmployeeDependent() {
      return _ref4.apply(this, arguments);
    };
  }();
  useEffect(function () {
    if (open) {
      fetchApplicationEmployeeDependent();
    }
  }, [open]);
  var loadImageAsBuffer = /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee4(url) {
      var response;
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            _context4.prev = 0;
            _context4.next = 3;
            return fetch(url);
          case 3:
            response = _context4.sent;
            if (response.ok) {
              _context4.next = 6;
              break;
            }
            throw new Error("Failed to fetch image: ".concat(url));
          case 6:
            _context4.next = 8;
            return response.arrayBuffer();
          case 8:
            return _context4.abrupt("return", _context4.sent);
          case 11:
            _context4.prev = 11;
            _context4.t0 = _context4["catch"](0);
            console.error("Error loading image:", _context4.t0);
            return _context4.abrupt("return", null);
          case 15:
          case "end":
            return _context4.stop();
        }
      }, _callee4, null, [[0, 11]]);
    }));
    return function loadImageAsBuffer(_x) {
      return _ref5.apply(this, arguments);
    };
  }();
  var exportToExcel = /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
      var _applications$3, _exportApps, workbook, worksheet, blwfMode, exportApps, appType, isMedicalOrMaternity, isEducationOrScholarship, isFinancialAssistance, documentTitle, logo, organization, address, web, renderLogo, bdGovLogo, imageId1, imageId2, excelRows, buildBlwfRows, headers, columnsConfig, headerRowIndex, i, buffer, blob;
      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            _context5.prev = 0;
            workbook = new ExcelJS.Workbook();
            worksheet = workbook.addWorksheet("Applications", {
              properties: {
                defaultColWidth: 15
              }
            });
            blwfMode = isBlwfPath(); // FIX: Safely fallback to full applications array if status filter returns empty
            exportApps = applications.filter(function (item) {
              return String(item.status) === String(status);
            });
            if (exportApps.length === 0 && applications.length > 0) {
              exportApps = applications;
            }

            // FIX: Extract appType safely from the root applications array
            appType = (applications === null || applications === void 0 || (_applications$3 = applications[0]) === null || _applications$3 === void 0 ? void 0 : _applications$3.applicationType) || ((_exportApps = exportApps) === null || _exportApps === void 0 || (_exportApps = _exportApps[0]) === null || _exportApps === void 0 ? void 0 : _exportApps.applicationType);
            isMedicalOrMaternity = ["medicalAssistance", "medicalDonation", "maternityGrant"].includes(appType);
            isEducationOrScholarship = ["scholarship", "educationGrant", "educationalAssistance"].includes(appType);
            isFinancialAssistance = appType === "financialAssistance";
            documentTitle = "মৃত্যু ও দুর্ঘটনাজনিত আর্থিক সহায়তার তালিকা";
            if (isMedicalOrMaternity) documentTitle = "চিকিৎসা ও মাতৃত্বকালীন আর্থিক সহায়তার তালিকা";
            if (isEducationOrScholarship) documentTitle = "শিক্ষা আর্থিক সহায়তার তালিকা";

            // --- LOGO & HEADER SETUP ---
            logo = "/workforce_assets/centralfund.png";
            organization = "কেন্দ্রীয় তহবিল";
            address = "২১ তলা, ভবন#৬, বাংলাদেশ সচিবালয়, ঢাকা-১০০০";
            web = "www.centralfund.gov.bd";
            if ([WORKFORCE_USER_TYPE.BLWF_SECTION_ADMIN, WORKFORCE_USER_TYPE.BLWF_ACCOUNTANT, WORKFORCE_USER_TYPE.BLWF_DIRECTOR, WORKFORCE_USER_TYPE.BLWF_APPROVER, WORKFORCE_USER_TYPE.BLWF_DEPUTI_ASST_DIRECTOR].includes(getUserTypeFromRights(userRights))) {
              logo = "/workforce_assets/blwf.png";
              organization = "বাংলাদেশ শ্রমিক কল্যাণ ফাউন্ডেশন";
              address = "১৮ তলা, ভবন#৬, বাংলাদেশ সচিবালয়, ঢাকা-১০০০";
              web = "www.blwf.gov.bd";
            }
            _context5.next = 20;
            return loadImageAsBuffer("/front" + logo);
          case 20:
            renderLogo = _context5.sent;
            _context5.next = 23;
            return loadImageAsBuffer("/front/workforce_assets/bdgov.png");
          case 23:
            bdGovLogo = _context5.sent;
            if (renderLogo) {
              imageId1 = workbook.addImage({
                buffer: renderLogo,
                extension: "png"
              });
              worksheet.addImage(imageId1, {
                tl: {
                  col: 0,
                  row: 0
                },
                ext: {
                  width: 120,
                  height: 120
                }
              });
            }
            if (bdGovLogo) {
              imageId2 = workbook.addImage({
                buffer: bdGovLogo,
                extension: "png"
              });
              worksheet.addImage(imageId2, {
                tl: {
                  col: blwfMode ? 8 : 10,
                  row: 0
                },
                ext: {
                  width: 120,
                  height: 120
                }
              });
            }

            // Headers
            worksheet.mergeCells("D1:G1");
            worksheet.getCell("D1").value = "গণপ্রজাতন্ত্রী বাংলাদেশ সরকার";
            worksheet.getCell("D1").alignment = {
              horizontal: "center"
            };
            worksheet.getCell("D1").font = {
              bold: true,
              size: 14
            };
            worksheet.mergeCells("D2:G2");
            worksheet.getCell("D2").value = "শ্রম ও কর্মসংস্থান মন্ত্রণালয়";
            worksheet.getCell("D2").alignment = {
              horizontal: "center"
            };
            worksheet.mergeCells("D3:G3");
            worksheet.getCell("D3").value = organization;
            worksheet.getCell("D3").alignment = {
              horizontal: "center"
            };
            worksheet.mergeCells("D4:G4");
            worksheet.getCell("D4").value = address;
            worksheet.getCell("D4").alignment = {
              horizontal: "center"
            };
            worksheet.mergeCells("D5:G5");
            worksheet.getCell("D5").value = web;
            worksheet.getCell("D5").alignment = {
              horizontal: "center"
            };
            worksheet.mergeCells("A7:K7");
            worksheet.getCell("A7").value = documentTitle;
            worksheet.getCell("A7").alignment = {
              horizontal: "center"
            };
            worksheet.getCell("A7").font = {
              underline: true,
              bold: true,
              size: 12,
              color: {
                argb: "FF4A76A8"
              }
            };
            worksheet.mergeCells("A8:K8");
            worksheet.getCell("A8").value = "সুবিধাভোগী কল্যাণ হিসাব (নং ৪৪২৬৩৩৬০০১০৩৪)";
            worksheet.getCell("A8").alignment = {
              horizontal: "center"
            };
            worksheet.getCell("A8").font = {
              underline: true
            };
            worksheet.getCell("A10").value = "বোর্ড সভাঃ 26th";
            worksheet.getCell("A11").value = "\u0986\u09AC\u09C7\u09A6\u09A8\u09C7\u09B0 \u09B8\u0982\u0996\u09CD\u09AF\u09BE\u0983 ".concat(enToBn(exportApps.length));
            worksheet.getCell("I10").value = "নমিনী/ব্যাংক হিসাবের সংখ্যাঃ";
            worksheet.getCell("I11").value = "\u0985\u09B0\u09CD\u09A5\u09C7\u09B0 \u09AA\u09B0\u09BF\u09AE\u09BE\u09A3\u0983 ".concat(Number(getTotalAmount()).toLocaleString("bn-BD"), "/-");
            worksheet.getRow(12).height = 15;

            // --- DATA EXTRACTION LOGIC ---
            excelRows = [];
            buildBlwfRows = function buildBlwfRows(apps) {
              var rows = [];
              apps.forEach(function (app, appIndex) {
                var _app$workforceEmploye, _app$workforceEmploye2, _app$workforceEmploye3, _app$workforceEmploye4, _app$workforceEmploye5, _app$workforceEmploye6, _app$workforceEmploye7, _app$workforceEmploye8, _app$employeeFactory, _app$employeeFactory2, _app$workforceEmploye9, _app$workforceEmploye10;
                var bankInfos = safeParse(app === null || app === void 0 ? void 0 : app.employeeBankInfo) || [];
                bankInfos = Array.isArray(bankInfos) ? bankInfos : [bankInfos];
                if (bankInfos.length === 0) bankInfos = [{}];
                var deceasedInfo = safeParse(app === null || app === void 0 ? void 0 : app.deceasedWorkerInfo) || {};
                var institutionInfo = safeParse(app === null || app === void 0 ? void 0 : app.institutionInfo) || {};
                var workerName = app.applicationType === "deadlyGrant" ? (deceasedInfo === null || deceasedInfo === void 0 ? void 0 : deceasedInfo.nameBn) || (deceasedInfo === null || deceasedInfo === void 0 ? void 0 : deceasedInfo.nameEn) || ((_app$workforceEmploye = app.workforceEmployee) === null || _app$workforceEmploye === void 0 ? void 0 : _app$workforceEmploye.firstNameBn) || ((_app$workforceEmploye2 = app.workforceEmployee) === null || _app$workforceEmploye2 === void 0 ? void 0 : _app$workforceEmploye2.firstNameEn) || "" : ((_app$workforceEmploye3 = app.workforceEmployee) === null || _app$workforceEmploye3 === void 0 ? void 0 : _app$workforceEmploye3.firstNameBn) || ((_app$workforceEmploye4 = app.workforceEmployee) === null || _app$workforceEmploye4 === void 0 ? void 0 : _app$workforceEmploye4.firstNameEn) || "";
                var fatherName = app.applicationType === "deadlyGrant" ? (deceasedInfo === null || deceasedInfo === void 0 ? void 0 : deceasedInfo.fatherNameBn) || (deceasedInfo === null || deceasedInfo === void 0 ? void 0 : deceasedInfo.fatherNameEn) || ((_app$workforceEmploye5 = app.workforceEmployee) === null || _app$workforceEmploye5 === void 0 ? void 0 : _app$workforceEmploye5.fatherNameBn) || ((_app$workforceEmploye6 = app.workforceEmployee) === null || _app$workforceEmploye6 === void 0 ? void 0 : _app$workforceEmploye6.fatherNameEn) || "" : ((_app$workforceEmploye7 = app.workforceEmployee) === null || _app$workforceEmploye7 === void 0 ? void 0 : _app$workforceEmploye7.fatherNameBn) || ((_app$workforceEmploye8 = app.workforceEmployee) === null || _app$workforceEmploye8 === void 0 ? void 0 : _app$workforceEmploye8.fatherNameEn) || "";
                var factoryName = (institutionInfo === null || institutionInfo === void 0 ? void 0 : institutionInfo.instituteName) || (institutionInfo === null || institutionInfo === void 0 ? void 0 : institutionInfo.aboutWork) || ((_app$employeeFactory = app.employeeFactory) === null || _app$employeeFactory === void 0 ? void 0 : _app$employeeFactory.nameBn) || ((_app$employeeFactory2 = app.employeeFactory) === null || _app$employeeFactory2 === void 0 ? void 0 : _app$employeeFactory2.nameEn) || "গৃহ শ্রমিক";
                var formattedAddr = formatAddress$3(app === null || app === void 0 || (_app$workforceEmploye9 = app.workforceEmployee) === null || _app$workforceEmploye9 === void 0 ? void 0 : _app$workforceEmploye9.presentLocation, app === null || app === void 0 || (_app$workforceEmploye10 = app.workforceEmployee) === null || _app$workforceEmploye10 === void 0 ? void 0 : _app$workforceEmploye10.presentAddress);
                var addressValue = "\u0997\u09CD\u09B0\u09BE\u09AE-".concat(formattedAddr.village || "", "\n\u09A1\u09BE\u0995-").concat(formattedAddr.postOffice || "", "\n\u0989\u09AA\u099C\u09C7\u09B2\u09BE-").concat(formattedAddr.thana || "", "\n\u099C\u09C7\u09B2\u09BE-").concat(formattedAddr.district || "");
                bankInfos.forEach(function (bankInfo, bankIndex) {
                  var _app$workforceEmploye11, _app$workforceEmploye12, _app$workforceEmploye13, _app$workforceEmploye14, _app$workforceEmploye15, _app$workforceEmploye16, _bankInfo$branch, _bankInfo$district;
                  rows.push({
                    app: app,
                    mainListNo: app.dateCreated && app.dateCreated.split && app.dateCreated.split("T")[0] || app.trackingNumber || "",
                    workerName: workerName,
                    fatherName: fatherName,
                    factoryName: factoryName,
                    workerNid: ((_app$workforceEmploye11 = app.workforceEmployee) === null || _app$workforceEmploye11 === void 0 ? void 0 : _app$workforceEmploye11.nid) || "",
                    workerMobile: ((_app$workforceEmploye12 = app.workforceEmployee) === null || _app$workforceEmploye12 === void 0 ? void 0 : _app$workforceEmploye12.phoneNumber) || ((_app$workforceEmploye13 = app.workforceEmployee) === null || _app$workforceEmploye13 === void 0 ? void 0 : _app$workforceEmploye13.mobile) || "",
                    address: addressValue,
                    district: formattedAddr.district || "",
                    nomineeName: (bankInfo === null || bankInfo === void 0 ? void 0 : bankInfo.accountHolderName) || workerName || "",
                    nomineeNid: (bankInfo === null || bankInfo === void 0 ? void 0 : bankInfo.dependentNid) || ((_app$workforceEmploye14 = app.workforceEmployee) === null || _app$workforceEmploye14 === void 0 ? void 0 : _app$workforceEmploye14.nid) || "",
                    nomineeMobile: (bankInfo === null || bankInfo === void 0 ? void 0 : bankInfo.phoneNumber) || ((_app$workforceEmploye15 = app.workforceEmployee) === null || _app$workforceEmploye15 === void 0 ? void 0 : _app$workforceEmploye15.phoneNumber) || ((_app$workforceEmploye16 = app.workforceEmployee) === null || _app$workforceEmploye16 === void 0 ? void 0 : _app$workforceEmploye16.mobile) || "",
                    relation: "নিজ",
                    details: app.notes || app.applicationType || "",
                    profession: factoryName,
                    remarks: "শ্রম অধিদপ্তর",
                    routing: (bankInfo === null || bankInfo === void 0 || (_bankInfo$branch = bankInfo.branch) === null || _bankInfo$branch === void 0 ? void 0 : _bankInfo$branch.routingNumber) || (bankInfo === null || bankInfo === void 0 || (_bankInfo$district = bankInfo.district) === null || _bankInfo$district === void 0 ? void 0 : _bankInfo$district.routingNumber) || "",
                    account: (bankInfo === null || bankInfo === void 0 ? void 0 : bankInfo.accountNumber) || "",
                    amount: app.grantAmount || 0
                  });
                });
              });
              return rows;
            };
            if (blwfMode) {
              excelRows = buildBlwfRows(exportApps);
            } else {
              exportApps.forEach(function (app, appIndex) {
                var _app$workforceEmploye17, _app$workforceEmploye18;
                formatAddress$3(app === null || app === void 0 || (_app$workforceEmploye17 = app.workforceEmployee) === null || _app$workforceEmploye17 === void 0 ? void 0 : _app$workforceEmploye17.presentLocation, app === null || app === void 0 || (_app$workforceEmploye18 = app.workforceEmployee) === null || _app$workforceEmploye18 === void 0 ? void 0 : _app$workforceEmploye18.presentAddress);
                var _getIncidentDetails = getIncidentDetails(app.employeeAccidentInfo),
                  type = _getIncidentDetails.type,
                  date = _getIncidentDetails.date;
                var metadata = safeParse(app === null || app === void 0 ? void 0 : app.metadata);
                var bankInfos = [];
                try {
                  var parsed = JSON.parse(app.employeeBankInfo);
                  bankInfos = Array.isArray(parsed) ? parsed : JSON.parse(parsed);
                } catch (e) {}
                if (isFinancialAssistance) {
                  dependentData === null || dependentData === void 0 || dependentData.forEach(function (dep) {
                    if (safeDecodeId(dep.workforceApplicationId) === safeDecodeId(app.id)) {
                      var _dep$bank, _dep$bank2;
                      var approvedAmount = (parseFloat(dep.percentageOfCfGrant) || 0) / 100 * (getTotalAmount() || 200000);
                      excelRows.push({
                        app: app,
                        dep: dep,
                        bankInfo: dep.bank,
                        nomineeName: (dep === null || dep === void 0 ? void 0 : dep.nameBn) || (dep === null || dep === void 0 ? void 0 : dep.nameEn) || (dep === null || dep === void 0 ? void 0 : dep.bankAccountHolderName) || "",
                        nomineeNid: dep === null || dep === void 0 ? void 0 : dep.nid,
                        nomineeMobile: (dep === null || dep === void 0 ? void 0 : dep.mobile) || (dep === null || dep === void 0 ? void 0 : dep.phoneNumber),
                        relation: RELATION_LABEL_MAP[dep === null || dep === void 0 ? void 0 : dep.relationWithWorker] || (dep === null || dep === void 0 ? void 0 : dep.relationWithWorker) || "স্ত্রী",
                        amount: approvedAmount,
                        incidentDate: date || (metadata === null || metadata === void 0 ? void 0 : metadata.deathDate),
                        incidentType: type || (metadata === null || metadata === void 0 ? void 0 : metadata.deathType),
                        routing: dep === null || dep === void 0 || (_dep$bank = dep.bank) === null || _dep$bank === void 0 ? void 0 : _dep$bank.routingNumber,
                        account: dep === null || dep === void 0 ? void 0 : dep.bankAccountNo,
                        bankName: dep === null || dep === void 0 || (_dep$bank2 = dep.bank) === null || _dep$bank2 === void 0 ? void 0 : _dep$bank2.nameEn,
                        details: "\u0986\u09AC\u09C7\u09A6\u09A8\u0995\u09BE\u09B0\u09C0 \u098F\u0995\u099C\u09A8 \u09B6\u09CD\u09B0\u09AE\u09BF\u0995 \u099B\u09BF\u09B2\u09C7\u09A8\u0964 \u09A4\u09BF\u09A8\u09BF ".concat(date || (metadata === null || metadata === void 0 ? void 0 : metadata.deathDate) || "", " \u09A4\u09BE\u09B0\u09BF\u0996\u09C7 \u09AE\u09C3\u09A4\u09CD\u09AF\u09C1\u09AC\u09B0\u09A3 \u0995\u09B0\u09C7\u09A8\u0964"),
                        gpa: ""
                      });
                    }
                  });
                } else {
                  var diseaseType = appType === "maternityGrant" ? "Maternity" : "Treatment";
                  try {
                    var info = JSON.parse(JSON.parse(app.employeeAccidentInfo || "{}"));
                    if (info.diseaseName) diseaseType = info.diseaseName;
                  } catch (e) {}
                  var dep = dependentData === null || dependentData === void 0 ? void 0 : dependentData.find(function (d) {
                    return safeDecodeId(d.workforceApplicationId) === safeDecodeId(app.id);
                  });
                  var gpa = "";
                  try {
                    gpa = JSON.parse(app.educationInfo || "{}").gpa || (dep === null || dep === void 0 ? void 0 : dep.gpa) || "";
                  } catch (e) {}
                  bankInfos.forEach(function (bankInfo) {
                    var _app$workforceEmploye19, _app$workforceEmploye20, _app$workforceEmploye21, _app$workforceEmploye22, _app$workforceEmploye23, _bankInfo$branch2, _bankInfo$bank;
                    excelRows.push({
                      app: app,
                      dep: dep,
                      bankInfo: bankInfo,
                      nomineeName: (dep === null || dep === void 0 ? void 0 : dep.nameBn) || (dep === null || dep === void 0 ? void 0 : dep.nameEn) || (bankInfo === null || bankInfo === void 0 ? void 0 : bankInfo.accountHolderName) || ((_app$workforceEmploye19 = app.workforceEmployee) === null || _app$workforceEmploye19 === void 0 ? void 0 : _app$workforceEmploye19.firstNameBn) || ((_app$workforceEmploye20 = app.workforceEmployee) === null || _app$workforceEmploye20 === void 0 ? void 0 : _app$workforceEmploye20.firstNameEn) || "",
                      nomineeNid: (dep === null || dep === void 0 ? void 0 : dep.nid) || ((_app$workforceEmploye21 = app.workforceEmployee) === null || _app$workforceEmploye21 === void 0 ? void 0 : _app$workforceEmploye21.nid) || "",
                      nomineeMobile: (dep === null || dep === void 0 ? void 0 : dep.mobile) || ((_app$workforceEmploye22 = app.workforceEmployee) === null || _app$workforceEmploye22 === void 0 ? void 0 : _app$workforceEmploye22.mobile) || ((_app$workforceEmploye23 = app.workforceEmployee) === null || _app$workforceEmploye23 === void 0 ? void 0 : _app$workforceEmploye23.phoneNumber) || "",
                      relation: isEducationOrScholarship ? dep ? RELATION_LABEL_MAP[dep.relationWithWorker] || dep.relationWithWorker : "Self" : "নিজ",
                      amount: app.grantAmount || 0,
                      incidentDate: date,
                      incidentType: diseaseType,
                      routing: bankInfo === null || bankInfo === void 0 || (_bankInfo$branch2 = bankInfo.branch) === null || _bankInfo$branch2 === void 0 ? void 0 : _bankInfo$branch2.routingNumber,
                      account: bankInfo === null || bankInfo === void 0 ? void 0 : bankInfo.accountNumber,
                      bankName: bankInfo === null || bankInfo === void 0 || (_bankInfo$bank = bankInfo.bank) === null || _bankInfo$bank === void 0 ? void 0 : _bankInfo$bank.nameEn,
                      details: isEducationOrScholarship ? "\u0986\u09AC\u09C7\u09A6\u09A8\u0995\u09BE\u09B0\u09C0\u09B0 \u09B8\u09A8\u09CD\u09A4\u09BE\u09A8 ".concat(gpa, " \u09AA\u09C7\u09AF\u09BC\u09C7 \u0989\u09A4\u09CD\u09A4\u09C0\u09B0\u09CD\u09A3 \u09B9\u09AF\u09BC\u09C7\u099B\u09C7\u09A8\u0964") : "\u0986\u09AC\u09C7\u09A6\u09A8\u0995\u09BE\u09B0\u09C0 ".concat(diseaseType, " \u098F\u09B0 \u099C\u09A8\u09CD\u09AF \u099A\u09BF\u0995\u09BF\u09CE\u09B8\u09BE \u09B8\u09B9\u09BE\u09AF\u09BC\u09A4\u09BE \u099A\u09C7\u09AF\u09BC\u09C7\u099B\u09C7\u09A8\u0964"),
                      gpa: gpa
                    });
                  });
                }
              });
            }

            // --- RENDER TABLE HEADERS & ROWS ---
            headers = [];
            columnsConfig = [];
            if (blwfMode) {
              headers = ["ক্রমিক নং", "আবেদনকারী শ্রমিকের নাম/পিতা/এনআইডি/মোবা-", "ঠিকানা", "যার জন্য আবেদন /যে আবেদন করেছেন নাম/এনআইডি/মোবা-", "বিবরণ", "অনুদান পরিমান", "পেশা/প্রতিষ্ঠান", "জেলা", "মন্তব্য"];
              columnsConfig = [{
                width: 8
              }, {
                width: 30
              }, {
                width: 30
              }, {
                width: 30
              }, {
                width: 35
              }, {
                width: 15
              }, {
                width: 20
              }, {
                width: 15
              }, {
                width: 15
              }];
              worksheet.addRow(headers);
              excelRows.forEach(function (row, i) {
                worksheet.addRow([i + 1, "".concat(row.workerName || "", "\n\u09AA\u09BF\u09A4\u09BE-").concat(row.fatherName || "", "\n\u098F\u09A8\u0986\u0987\u09A1\u09BF-").concat(row.workerNid || "", "\n\u09AE\u09CB\u09AC\u09BE-").concat(row.workerMobile || ""), row.address || "", "".concat(row.nomineeName || "", " (").concat(row.relation || "", ")\n\u098F\u09A8\u0986\u0987\u09A1\u09BF-").concat(row.nomineeNid || "", "\n\u09AE\u09CB\u09AC\u09BE-").concat(row.nomineeMobile || ""), row.details || "", row.amount || 0, row.profession || "গৃহ শ্রমিক", row.district || "", row.remarks || "শ্রম অধিদপ্তর"]);
              });
            } else {
              if (isEducationOrScholarship) {
                headers = ["Sl.no", "Applicant Name", "NID/Birth Certificate", "Applicant Mobile", "Unit Name", "Candidate Name", "Relation", "GPA", "Routing", "Account NO", "Amount"];
                columnsConfig = [{
                  width: 8
                }, {
                  width: 20
                }, {
                  width: 20
                }, {
                  width: 15
                }, {
                  width: 25
                }, {
                  width: 20
                }, {
                  width: 15
                }, {
                  width: 10
                }, {
                  width: 15
                }, {
                  width: 20
                }, {
                  width: 15
                }];
                worksheet.addRow(headers);
                excelRows.forEach(function (row, i) {
                  var _row$app, _row$app2, _row$app3, _row$app4, _row$app5, _row$app6;
                  worksheet.addRow([((_row$app = row.app) === null || _row$app === void 0 ? void 0 : _row$app.trackingNumber) || i + 1, (_row$app2 = row.app) === null || _row$app2 === void 0 || (_row$app2 = _row$app2.workforceEmployee) === null || _row$app2 === void 0 ? void 0 : _row$app2.firstNameEn, (_row$app3 = row.app) === null || _row$app3 === void 0 || (_row$app3 = _row$app3.workforceEmployee) === null || _row$app3 === void 0 ? void 0 : _row$app3.nid, ((_row$app4 = row.app) === null || _row$app4 === void 0 || (_row$app4 = _row$app4.workforceEmployee) === null || _row$app4 === void 0 ? void 0 : _row$app4.mobile) || ((_row$app5 = row.app) === null || _row$app5 === void 0 || (_row$app5 = _row$app5.workforceEmployee) === null || _row$app5 === void 0 ? void 0 : _row$app5.phoneNumber), (_row$app6 = row.app) === null || _row$app6 === void 0 || (_row$app6 = _row$app6.employeeFactory) === null || _row$app6 === void 0 ? void 0 : _row$app6.nameEn, row.nomineeName, row.relation, row.gpa, row.routing, row.account, row.amount]);
                });
              } else if (isMedicalOrMaternity) {
                headers = ["SL No", "M:SL", "Applicant Name", "NID/Birth Certificate", "Mobile", "Factory Name", "Relation", "Type of Disease", "Routing Number", "Account No", "Amount"];
                columnsConfig = [{
                  width: 8
                }, {
                  width: 15
                }, {
                  width: 20
                }, {
                  width: 20
                }, {
                  width: 15
                }, {
                  width: 25
                }, {
                  width: 15
                }, {
                  width: 20
                }, {
                  width: 15
                }, {
                  width: 20
                }, {
                  width: 15
                }];
                worksheet.addRow(headers);
                excelRows.forEach(function (row, i) {
                  var _row$app7, _row$app8, _row$app9, _row$app10, _row$app11, _row$app12;
                  worksheet.addRow([i + 1, (_row$app7 = row.app) === null || _row$app7 === void 0 || (_row$app7 = _row$app7.dateCreated) === null || _row$app7 === void 0 ? void 0 : _row$app7.split("T")[0], (_row$app8 = row.app) === null || _row$app8 === void 0 || (_row$app8 = _row$app8.workforceEmployee) === null || _row$app8 === void 0 ? void 0 : _row$app8.firstNameEn, (_row$app9 = row.app) === null || _row$app9 === void 0 || (_row$app9 = _row$app9.workforceEmployee) === null || _row$app9 === void 0 ? void 0 : _row$app9.nid, ((_row$app10 = row.app) === null || _row$app10 === void 0 || (_row$app10 = _row$app10.workforceEmployee) === null || _row$app10 === void 0 ? void 0 : _row$app10.mobile) || ((_row$app11 = row.app) === null || _row$app11 === void 0 || (_row$app11 = _row$app11.workforceEmployee) === null || _row$app11 === void 0 ? void 0 : _row$app11.phoneNumber), (_row$app12 = row.app) === null || _row$app12 === void 0 || (_row$app12 = _row$app12.employeeFactory) === null || _row$app12 === void 0 ? void 0 : _row$app12.nameEn, row.relation, row.incidentType, row.routing, row.account, row.amount]);
                });
              } else {
                headers = ["Sl", "Main List No", "Deceased Worker's Name", "Factory Name", "Deceased Worker's NID/BC", "Date of Incident", "Type of Incident", "Nominee's Name", "Nominee's NID/BC", "Relation", "Nominee's Bank name", "Nominee's Bank A/C", "Amount", "Routing No", "Nominee's Mobile No.", "Unit/No"];
                columnsConfig = [{
                  width: 5
                }, {
                  width: 15
                }, {
                  width: 20
                }, {
                  width: 20
                }, {
                  width: 20
                }, {
                  width: 15
                }, {
                  width: 15
                }, {
                  width: 20
                }, {
                  width: 20
                }, {
                  width: 15
                }, {
                  width: 20
                }, {
                  width: 20
                }, {
                  width: 15
                }, {
                  width: 15
                }, {
                  width: 15
                }, {
                  width: 10
                }];
                worksheet.addRow(headers);
                excelRows.forEach(function (row, i) {
                  var _row$app13, _row$app14, _row$app15, _row$app16;
                  worksheet.addRow([i + 1, (_row$app13 = row.app) === null || _row$app13 === void 0 ? void 0 : _row$app13.trackingNumber, (_row$app14 = row.app) === null || _row$app14 === void 0 || (_row$app14 = _row$app14.workforceEmployee) === null || _row$app14 === void 0 ? void 0 : _row$app14.firstNameEn, (_row$app15 = row.app) === null || _row$app15 === void 0 || (_row$app15 = _row$app15.employeeFactory) === null || _row$app15 === void 0 ? void 0 : _row$app15.nameEn, (_row$app16 = row.app) === null || _row$app16 === void 0 || (_row$app16 = _row$app16.workforceEmployee) === null || _row$app16 === void 0 ? void 0 : _row$app16.nid, row.incidentDate, row.incidentType, row.nomineeName, row.nomineeNid, row.relation, row.bankName, row.account, row.amount, row.routing, row.nomineeMobile, ""]);
                });
              }
            }
            worksheet.columns = columnsConfig;

            // Style Header Row
            headerRowIndex = 13;
            worksheet.getRow(headerRowIndex).font = {
              bold: true,
              color: {
                argb: "FFFFFFFF"
              }
            };
            worksheet.getRow(headerRowIndex).alignment = {
              horizontal: "center",
              vertical: "middle"
            };
            worksheet.getRow(headerRowIndex).eachCell(function (cell) {
              cell.fill = {
                type: "pattern",
                pattern: "solid",
                fgColor: {
                  argb: "FF2E528E"
                }
              };
              cell.border = {
                top: {
                  style: "thin"
                },
                left: {
                  style: "thin"
                },
                bottom: {
                  style: "thin"
                },
                right: {
                  style: "thin"
                }
              };
            });

            // Style Data Rows 
            for (i = headerRowIndex + 1; i <= worksheet.rowCount; i++) {
              worksheet.getRow(i).eachCell(function (cell) {
                cell.alignment = {
                  wrapText: true,
                  vertical: "top"
                };
                cell.border = {
                  top: {
                    style: "thin"
                  },
                  left: {
                    style: "thin"
                  },
                  bottom: {
                    style: "thin"
                  },
                  right: {
                    style: "thin"
                  }
                };
              });
            }
            _context5.next = 69;
            return workbook.xlsx.writeBuffer();
          case 69:
            buffer = _context5.sent;
            blob = new Blob([buffer], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            });
            saveAs(blob, "Payment_Advice.xlsx");
            _context5.next = 78;
            break;
          case 74:
            _context5.prev = 74;
            _context5.t0 = _context5["catch"](0);
            console.error("Error exporting to Excel:", _context5.t0);
            alert("Failed to export data to Excel. Please try again.");
          case 78:
          case "end":
            return _context5.stop();
        }
      }, _callee5, null, [[0, 74]]);
    }));
    return function exportToExcel() {
      return _ref6.apply(this, arguments);
    };
  }();
  console.log({
    mappingsData: mappings
  });
  if (getUserTypeFromRights(userRights) === WORKFORCE_USER_TYPE.APPROVER || getUserTypeFromRights(userRights) === WORKFORCE_USER_TYPE.BLWF_APPROVER) {
    var _applications$4;
    return /*#__PURE__*/React.createElement(Dialog$1, {
      open: open,
      onClose: onClose,
      maxWidth: "md",
      fullWidth: true
    }, /*#__PURE__*/React.createElement(DialogTitle, {
      disableTypography: true
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "h6"
    }, /*#__PURE__*/React.createElement(FormattedMessage, {
      module: "workforce",
      id: "workforce.application.modal.header"
    }))), /*#__PURE__*/React.createElement(DialogContent$1, {
      dividers: true
    }, ((_applications$4 = applications[0]) === null || _applications$4 === void 0 ? void 0 : _applications$4.applicationType) === "financialAssistance" ?
    /*#__PURE__*/
    /* ===== NEW BLOCK FOR FINANCIAL ASSISTANCE ===== */
    React.createElement("div", null, /*#__PURE__*/React.createElement(Typography, {
      variant: "h6"
    }, "Death grant"), /*#__PURE__*/React.createElement(Table$2, null, /*#__PURE__*/React.createElement(TableHead, null, /*#__PURE__*/React.createElement(TableRow, {
      style: {
        fontWeight: "bold"
      }
    }, /*#__PURE__*/React.createElement(TableCell, null, "Dependent Name"), /*#__PURE__*/React.createElement(TableCell, null, "Relation With Worker"), /*#__PURE__*/React.createElement(TableCell, null, "Application Type"), /*#__PURE__*/React.createElement(TableCell, {
      align: "right"
    }, "Grant Amount"), /*#__PURE__*/React.createElement(TableCell, null, "Account No"), /*#__PURE__*/React.createElement(TableCell, null, "Bank Name"), /*#__PURE__*/React.createElement(TableCell, null, "Branch"))), /*#__PURE__*/React.createElement(TableBody, null, dependentData.map(function (dep, index) {
      var _dep$bank3, _dep$bank4;
      var totalGrant = getTotalAmount();
      var approvedAmount = (parseFloat(dep.percentageOfCfGrant) || 0) / 100 * totalGrant;
      return /*#__PURE__*/React.createElement(TableRow, {
        key: index
      }, /*#__PURE__*/React.createElement(TableCell, null, (dep === null || dep === void 0 ? void 0 : dep.nameEn) || ""), /*#__PURE__*/React.createElement(TableCell, null, RELATION_LABEL_MAP[(dep === null || dep === void 0 ? void 0 : dep.relationWithWorker) || ""]), /*#__PURE__*/React.createElement(TableCell, null, "Death grant"), /*#__PURE__*/React.createElement(TableCell, {
        align: "right"
      }, approvedAmount), /*#__PURE__*/React.createElement(TableCell, null, (dep === null || dep === void 0 ? void 0 : dep.bankAccountNo) || ""), /*#__PURE__*/React.createElement(TableCell, null, (dep === null || dep === void 0 || (_dep$bank3 = dep.bank) === null || _dep$bank3 === void 0 || (_dep$bank3 = _dep$bank3.parent) === null || _dep$bank3 === void 0 ? void 0 : _dep$bank3.nameEn) || ""), /*#__PURE__*/React.createElement(TableCell, null, (dep === null || dep === void 0 || (_dep$bank4 = dep.bank) === null || _dep$bank4 === void 0 ? void 0 : _dep$bank4.nameEn) || ""));
    }), /*#__PURE__*/React.createElement(TableRow, null, /*#__PURE__*/React.createElement(TableCell, {
      colSpan: 2
    }, /*#__PURE__*/React.createElement("strong", null, "Total Grant")), /*#__PURE__*/React.createElement(TableCell, {
      align: "right"
    }, /*#__PURE__*/React.createElement("strong", null, getTotalAmount())), /*#__PURE__*/React.createElement(TableCell, {
      colSpan: 3
    }))))) :
    /*#__PURE__*/
    /* ===== OLD BLOCK ===== */
    React.createElement(Table$2, null, /*#__PURE__*/React.createElement(TableHead, null, /*#__PURE__*/React.createElement(TableRow, {
      style: {
        fontWeight: "bold"
      }
    }, /*#__PURE__*/React.createElement(TableCell, null, "Applicant Name"), /*#__PURE__*/React.createElement(TableCell, null, "Application Type"), /*#__PURE__*/React.createElement(TableCell, {
      align: "right"
    }, "Grant Amount"), /*#__PURE__*/React.createElement(TableCell, null, "Account No"), /*#__PURE__*/React.createElement(TableCell, null, "Bank Name"), /*#__PURE__*/React.createElement(TableCell, null, "Branch"))), /*#__PURE__*/React.createElement(TableBody, null, applications.filter(function (item) {
      return item.status === status;
    }).map(function (row, index) {
      var _row$workforceEmploye, _bankInfo$bank2, _bankInfo$branch3;
      var parseBankInfo = JSON.parse(row.employeeBankInfo);
      var bankInfo = JSON.parse(parseBankInfo);
      return /*#__PURE__*/React.createElement(TableRow, {
        key: index
      }, /*#__PURE__*/React.createElement(TableCell, null, (_row$workforceEmploye = row.workforceEmployee) === null || _row$workforceEmploye === void 0 ? void 0 : _row$workforceEmploye.firstNameEn), /*#__PURE__*/React.createElement(TableCell, null, row.applicationType), /*#__PURE__*/React.createElement(TableCell, {
        align: "right"
      }, row.grantAmount), /*#__PURE__*/React.createElement(TableCell, null, bankInfo.accountNumber), /*#__PURE__*/React.createElement(TableCell, null, bankInfo === null || bankInfo === void 0 || (_bankInfo$bank2 = bankInfo.bank) === null || _bankInfo$bank2 === void 0 ? void 0 : _bankInfo$bank2.nameEn), /*#__PURE__*/React.createElement(TableCell, null, bankInfo === null || bankInfo === void 0 || (_bankInfo$branch3 = bankInfo.branch) === null || _bankInfo$branch3 === void 0 ? void 0 : _bankInfo$branch3.nameEn));
    }), /*#__PURE__*/React.createElement(TableRow, null, /*#__PURE__*/React.createElement(TableCell, {
      colSpan: 2
    }, /*#__PURE__*/React.createElement("strong", null, "Total Grant")), /*#__PURE__*/React.createElement(TableCell, {
      align: "right"
    }, /*#__PURE__*/React.createElement("strong", null, getTotalAmount())), /*#__PURE__*/React.createElement(TableCell, {
      colSpan: 3
    }))))), /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement(DialogActions$1, {
      className: classes.noPrint
    }, /*#__PURE__*/React.createElement(Button, {
      onClick: onClose,
      variant: "outlined",
      color: "primary"
    }, /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.table.close",
      defaultMessage: "\u09AC\u09A8\u09CD\u09A7 \u0995\u09B0\u09C1\u09A8"
    })), /*#__PURE__*/React.createElement(Button, {
      onClick: function onClick() {
        return window.print();
      },
      variant: "contained",
      color: "primary"
    }, /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.table.printSUmmary",
      defaultMessage: "\u09AE\u09C1\u09A6\u09CD\u09B0\u09A3\u09C7\u09B0 \u09B8\u09BE\u09B0\u09BE\u0982\u09B6"
    })), /*#__PURE__*/React.createElement(Button, {
      onClick: function onClick() {
        return handleForward();
      },
      variant: "contained",
      color: "primary",
      disabled: loader
    }, /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.table.forwardToDirector",
      defaultMessage: "\u09AE\u09B9\u09BE\u09AA\u09B0\u09BF\u099A\u09BE\u09B2\u0995 \u09AC\u09B0\u09BE\u09AC\u09B0 \u0985\u0997\u09CD\u09B0\u09BE\u09DF\u09A8 \u0995\u09B0\u09C1\u09A8"
    }), /*#__PURE__*/React.createElement(ForwardIcon, null))));
  } else if (getUserTypeFromRights(userRights) === WORKFORCE_USER_TYPE.ADMIN || getUserTypeFromRights(userRights) === WORKFORCE_USER_TYPE.SECTION_ADMIN || getUserTypeFromRights(userRights) === WORKFORCE_USER_TYPE.SECTION_ADMIN_TWO || getUserTypeFromRights(userRights) === WORKFORCE_USER_TYPE.BLWF_SECTION_ADMIN || getUserTypeFromRights(userRights) === WORKFORCE_USER_TYPE.BLWF_ACCOUNTANT || getUserTypeFromRights(userRights) === WORKFORCE_USER_TYPE.EIS_COORDINATOR || getUserTypeFromRights(userRights) === WORKFORCE_USER_TYPE.EIS_ADVISOR)
    // else if (!getUserTypeFromRights(userRights).includes("blwf"))
    {
      // if(getUserTypeFromRights(userRights) === WORKFORCE_USER_TYPE.BLWF_SECTION_ADMIN)
      if (getUserTypeFromRights(userRights) === WORKFORCE_USER_TYPE.BLWF_SECTION_ADMIN || getUserTypeFromRights(userRights) === WORKFORCE_USER_TYPE.BLWF_ACCOUNTANT || getUserTypeFromRights(userRights) === WORKFORCE_USER_TYPE.BLWF_DIRECTOR || getUserTypeFromRights(userRights) === WORKFORCE_USER_TYPE.BLWF_APPROVER || getUserTypeFromRights(userRights) === WORKFORCE_USER_TYPE.BLWF_DEPUTI_ASST_DIRECTOR) ;
      // else if(getUserTypeFromRights(userRights) === WORKFORCE_USER_TYPE.EIS_SECTION_ADMIN)
      // {
      //   logo= <img src={`workforce_assets/eis.png`} alt="Logo" style={{ width: "120px" }} />;
      // }
      return /*#__PURE__*/React.createElement(Dialog$1, {
        open: open,
        onClose: onClose,
        maxWidth: "lg",
        fullWidth: true
      }, /*#__PURE__*/React.createElement(DialogTitle, {
        disableTypography: true
      }, /*#__PURE__*/React.createElement(Typography, {
        variant: "h6"
      }, " ", /*#__PURE__*/React.createElement(FormattedMessage, {
        id: "Committee Report"
      }))), /*#__PURE__*/React.createElement(DialogContent$1, {
        dividers: true,
        className: classes.dialogContent
      }, /*#__PURE__*/React.createElement(FormattedBankPaymentAdvice, {
        applications: applications,
        dependentData: dependentData,
        getTotalAmount: getTotalAmount,
        userRights: userRights,
        status: status,
        movements: movements
      })), /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement(DialogActions$1, {
        className: classes.noPrint
      }, /*#__PURE__*/React.createElement(Button, {
        onClick: onClose,
        variant: "outlined",
        color: "primary"
      }, /*#__PURE__*/React.createElement(FormattedMessage, {
        id: "workforce.modal.close"
      })), /*#__PURE__*/React.createElement(Button, {
        onClick: function onClick() {
          return window.print();
        },
        variant: "contained",
        color: "primary"
      }, /*#__PURE__*/React.createElement(FormattedMessage, {
        id: "workforce.table.printSUmmary"
      })), /*#__PURE__*/React.createElement(Button, {
        onClick: exportToExcel,
        variant: "contained",
        color: "success"
      }, /*#__PURE__*/React.createElement(FormattedMessage, {
        id: "workforce.modal.excel"
      }))));
    } else if (getUserTypeFromRights(userRights) === WORKFORCE_USER_TYPE.DIRECTOR || getUserTypeFromRights(userRights) === WORKFORCE_USER_TYPE.BLWF_DIRECTOR) {
    var _applications$5;
    return /*#__PURE__*/React.createElement(Dialog$1, {
      open: open,
      onClose: onClose,
      maxWidth: "md",
      fullWidth: true
    }, /*#__PURE__*/React.createElement(DialogTitle, {
      disableTypography: true
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "h6"
    }, " ", /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.table.bftn"
    }))), /*#__PURE__*/React.createElement(DialogContent$1, {
      dividers: true
    }, ((_applications$5 = applications[0]) === null || _applications$5 === void 0 ? void 0 : _applications$5.applicationType) === "financialAssistance" ?
    /*#__PURE__*/
    /* ===== NEW BLOCK FOR FINANCIAL ASSISTANCE ===== */
    React.createElement("div", null, /*#__PURE__*/React.createElement(Typography, {
      variant: "h6"
    }, "Death grant"), /*#__PURE__*/React.createElement(Table$2, null, /*#__PURE__*/React.createElement(TableHead, null, /*#__PURE__*/React.createElement(TableRow, {
      style: {
        fontWeight: "bold"
      }
    }, /*#__PURE__*/React.createElement(TableCell, null, "Dependent Name"), /*#__PURE__*/React.createElement(TableCell, null, "Relation With Worker"), /*#__PURE__*/React.createElement(TableCell, null, "Application Type"), /*#__PURE__*/React.createElement(TableCell, {
      align: "right"
    }, "Grant Amount"), /*#__PURE__*/React.createElement(TableCell, null, "Account No"), /*#__PURE__*/React.createElement(TableCell, null, "Bank Name"), /*#__PURE__*/React.createElement(TableCell, null, "Branch"))), /*#__PURE__*/React.createElement(TableBody, null, dependentData.map(function (dep, index) {
      var _dep$bank5, _dep$bank6;
      var totalGrant = getTotalAmount() || 200000;
      var approvedAmount = (parseFloat(dep.percentageOfCfGrant) || 0) / 100 * totalGrant;
      return /*#__PURE__*/React.createElement(TableRow, {
        key: index
      }, /*#__PURE__*/React.createElement(TableCell, null, (dep === null || dep === void 0 ? void 0 : dep.nameEn) || ""), /*#__PURE__*/React.createElement(TableCell, null, RELATION_LABEL_MAP[(dep === null || dep === void 0 ? void 0 : dep.relationWithWorker) || ""]), /*#__PURE__*/React.createElement(TableCell, null, "Death grant"), /*#__PURE__*/React.createElement(TableCell, {
        align: "right"
      }, approvedAmount), /*#__PURE__*/React.createElement(TableCell, null, (dep === null || dep === void 0 ? void 0 : dep.bankAccountNo) || ""), /*#__PURE__*/React.createElement(TableCell, null, (dep === null || dep === void 0 || (_dep$bank5 = dep.bank) === null || _dep$bank5 === void 0 || (_dep$bank5 = _dep$bank5.parent) === null || _dep$bank5 === void 0 ? void 0 : _dep$bank5.nameEn) || ""), /*#__PURE__*/React.createElement(TableCell, null, (dep === null || dep === void 0 || (_dep$bank6 = dep.bank) === null || _dep$bank6 === void 0 ? void 0 : _dep$bank6.nameEn) || ""));
    }), /*#__PURE__*/React.createElement(TableRow, null, /*#__PURE__*/React.createElement(TableCell, {
      colSpan: 2
    }, /*#__PURE__*/React.createElement("strong", null, "Total Grant")), /*#__PURE__*/React.createElement(TableCell, {
      align: "right"
    }, /*#__PURE__*/React.createElement("strong", null, getTotalAmount())), /*#__PURE__*/React.createElement(TableCell, {
      colSpan: 3
    }))))) :
    /*#__PURE__*/
    /* ===== OLD BLOCK ===== */
    React.createElement(Table$2, null, /*#__PURE__*/React.createElement(TableHead, null, /*#__PURE__*/React.createElement(TableRow, {
      style: {
        fontWeight: "bold"
      }
    }, /*#__PURE__*/React.createElement(TableCell, null, "Applicant Name"), /*#__PURE__*/React.createElement(TableCell, null, "Application Type"), /*#__PURE__*/React.createElement(TableCell, {
      align: "right"
    }, "Grant Amount"), /*#__PURE__*/React.createElement(TableCell, null, "Account No"), /*#__PURE__*/React.createElement(TableCell, null, "Bank Name"), /*#__PURE__*/React.createElement(TableCell, null, "Branch"))), /*#__PURE__*/React.createElement(TableBody, null, applications.filter(function (item) {
      return item.status === status;
    }).map(function (row, index) {
      var _row$workforceEmploye2, _bankInfo$bank3, _bankInfo$branch4;
      var parseBankInfo = JSON.parse(row.employeeBankInfo);
      var bankInfo = JSON.parse(parseBankInfo);
      return /*#__PURE__*/React.createElement(TableRow, {
        key: index
      }, /*#__PURE__*/React.createElement(TableCell, null, (_row$workforceEmploye2 = row.workforceEmployee) === null || _row$workforceEmploye2 === void 0 ? void 0 : _row$workforceEmploye2.firstNameEn), /*#__PURE__*/React.createElement(TableCell, null, row.applicationType), /*#__PURE__*/React.createElement(TableCell, {
        align: "right"
      }, row.grantAmount), /*#__PURE__*/React.createElement(TableCell, null, bankInfo.accountNumber), /*#__PURE__*/React.createElement(TableCell, null, bankInfo === null || bankInfo === void 0 || (_bankInfo$bank3 = bankInfo.bank) === null || _bankInfo$bank3 === void 0 ? void 0 : _bankInfo$bank3.nameEn), /*#__PURE__*/React.createElement(TableCell, null, bankInfo === null || bankInfo === void 0 || (_bankInfo$branch4 = bankInfo.branch) === null || _bankInfo$branch4 === void 0 ? void 0 : _bankInfo$branch4.nameEn));
    }), /*#__PURE__*/React.createElement(TableRow, null, /*#__PURE__*/React.createElement(TableCell, {
      colSpan: 2
    }, /*#__PURE__*/React.createElement("strong", null, "Total Grant")), /*#__PURE__*/React.createElement(TableCell, {
      align: "right"
    }, /*#__PURE__*/React.createElement("strong", null, getTotalAmount())), /*#__PURE__*/React.createElement(TableCell, {
      colSpan: 3
    }))))), /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement(DialogActions$1, {
      className: classes.noPrint
    }, /*#__PURE__*/React.createElement(Button, {
      onClick: onClose,
      variant: "outlined",
      color: "primary"
    }, /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.table.close",
      defaultMessage: "\u09AC\u09A8\u09CD\u09A7 \u0995\u09B0\u09C1\u09A8"
    })), /*#__PURE__*/React.createElement(Button, {
      onClick: function onClick() {
        return window.print();
      },
      variant: "contained",
      color: "primary"
    }, /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.table.printAdvice"
    }))));
  }

  // Fallback for unhandled user types (e.g., MINISTER)
  return null;
};

var ConfirmRejectModal = function ConfirmRejectModal(_ref) {
  var open = _ref.open,
    onClose = _ref.onClose,
    addComment = _ref.addComment;
  var _React$useState = React.useState(""),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    comment = _React$useState2[0],
    setComment = _React$useState2[1];
  var handleCommentChange = function handleCommentChange(e) {
    var value = e.target.value;
    setComment(value);
    if (addComment) {
      addComment(value);
    }
  };
  var handleClose = function handleClose(flag) {
    if (flag === 0) {
      setComment("");
      onClose(0);
      return;
    }
    onClose(1);
  };
  return /*#__PURE__*/React.createElement(Modal, {
    open: open,
    onClose: function onClose() {
      return handleClose(0);
    }
  }, /*#__PURE__*/React.createElement(Box$1, {
    style: {
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      width: 450,
      backgroundColor: "#fff",
      borderRadius: 8,
      boxShadow: "0px 4px 20px rgba(0,0,0,0.2)",
      padding: 24,
      outline: "none"
    }
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6",
    gutterBottom: true
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "workforce.reject.reason",
    module: "workforce"
  })), /*#__PURE__*/React.createElement(TextField, {
    fullWidth: true,
    multiline: true,
    rows: 4,
    variant: "outlined",
    value: comment,
    onChange: handleCommentChange,
    placeholder: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.reject.reason.placeholder",
      module: "workforce"
    })
  }), /*#__PURE__*/React.createElement(Box$1, {
    mt: 3,
    display: "flex",
    justifyContent: "space-around"
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "outlined",
    color: "secondary",
    onClick: function onClick() {
      return handleClose(0);
    }
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "workforce.confirm.modal.cancel",
    module: "workforce"
  })), /*#__PURE__*/React.createElement(Button, {
    variant: "contained",
    color: "primary",
    onClick: function onClick() {
      return handleClose(1);
    },
    disabled: !comment.trim()
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "workforce.confirm.modal.ok",
    module: "workforce"
  })))));
};

function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _callSuper$h(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$h() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$h() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$h = function _isNativeReflectConstruct() { return !!t; })(); }
function ownKeys$E(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$E(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$E(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$E(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var styles$h = function styles(theme) {
  return {
    paper: _objectSpread$E(_objectSpread$E({}, theme.paper.paper), {}, {
      margin: 0
    }),
    paperHeader: _objectSpread$E(_objectSpread$E({}, theme.paper.header), {}, {
      padding: 10
    }),
    tableTitle: theme.table.title,
    fab: theme.fab,
    button: {
      margin: theme.spacing(1)
    },
    item: {
      padding: theme.spacing(1)
    },
    horizontalButtonContainer: theme.buttonContainer.horizontal
  };
};
var ApplicationProcessSearcher = /*#__PURE__*/function (_Component) {
  function ApplicationProcessSearcher(props) {
    var _this;
    _classCallCheck(this, ApplicationProcessSearcher);
    _this = _callSuper$h(this, ApplicationProcessSearcher, [props]);
    _defineProperty(_this, "fetch", /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(prms) {
        var _this$props, userRights, revertedApplication, rejectedApplication, userName, dynamicTableTitle, loggedInUserId, _this$state, showHistoryFilter, startDate, endDate, defaultStatusFilters, orderByFilter, _defaultStatusFilters, _orderByFilter, _defaultStatusFilters2, _orderByFilter2, _defaultStatusFilters3, additionalFilters, summaryId, sectionApplicationTypes, _orderByFilter3, nidFilters, finalFilters, hasStatusIn, hasAppType, hasApplicationTo, hasOrderBy, _defaultStatusFilters4, _additionalFilters, _summaryId, sectionTwoApplicationTypes, _orderByFilter4, _nidFilters, _finalFilters, _hasStatusIn, _hasAppType, _hasApplicationTo, _hasOrderBy, _defaultStatusFilters5, _additionalFilters2, _summaryId2, _orderByFilter5, _nidFilters2, _finalFilters2, _hasStatusIn2, _hasOrderBy2, _defaultStatusFilters6, _orderByFilter6, _defaultStatusFilters7, _orderByFilter7, _hasStatusIn3, _hasOrderBy3, _finalFilters3, _defaultStatusFilters8, _orderByFilter8, _hasStatusIn4, _hasOrderBy4, _finalFilters4, _defaultStatusFilters9, _orderByFilter9, _hasStatusIn5, _hasOrderBy5, _finalFilters5, _defaultStatusFilters10, _orderByFilter10, _hasStatusIn6, _hasOrderBy6, _finalFilters6, _defaultStatusFilters11, _this$props2, _orderByFilter11, _hasStatusIn7, _hasOrderBy7, _finalFilters7, organizationTypeIn, _defaultStatusFilters12, _orderByFilter12, _finalFilters8, _hasStatusIn8, hasApplicationTypeIn, hasOrganizationTypeIn, _hasApplicationTo2, hasApplicationFrom, _hasOrderBy8, hasEmployeeFactoryId, filters, _filters, isApproved, _this$props$workforce, _filters2, _this$props$workforce3, _this$props$workforce2, _this$props$workforce4, _this$props$workforce5, _this$props$workforce6, filtersBase, cfFilters, blwfFilters, _yield$Promise$all, _filtersBase, _filtersBase2, _filtersBase3, _cfFilters, _yield$Promise$all3, _filtersBase4, _filtersBase5, _blwfFilters, _yield$Promise$all5, _filtersBase6, _defaultStatusFilters13, _additionalFilters3, _summaryId3, _orderByFilter13, _nidFilters3, _finalFilters9, _hasStatusIn9, _hasOrderBy9, _hasApplicationTypeIn, hasAssociationTypeIn, _defaultStatusFilters14, _additionalFilters4, _summaryId4, _orderByFilter14, _nidFilters4, _finalFilters10, _hasStatusIn10, _hasOrderBy10, _hasApplicationTypeIn2, _hasAssociationTypeIn, _defaultStatusFilters15, _orderByFilter15, _finalFilters11, _hasStatusIn11, _hasOrderBy11, _hasApplicationTypeIn3, _hasAssociationTypeIn2, _hasApplicationTo3, _hasApplicationFrom, _summaryId5, _defaultStatusFilters16, _additionalFilters5, userType, _this$props3, _orderByFilter16, _nidFilters5, _finalFilters12, _hasStatusIn12, _hasOrderBy12, _hasApplicationTypeIn4, _hasOrganizationTypeIn, _hasApplicationFrom2, _summaryId6, _defaultStatusFilters17, _this$props4, organizationType, _defaultStatusFilters18, _additionalFilters6, _summaryId7, _orderByFilter17, _nidFilters6, _finalFilters13, _hasStatusIn13, _hasOrderBy13, _filtersBase7, _cfFilters2, _blwfFilters2, _yield$Promise$all7, _filtersBase8, _filtersBase9, _filtersBase10, _cfFilters3, _blwfFilters3, _yield$Promise$all9, _filtersBase11, _filtersBase12;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this$props = _this.props, _this$props.applicationType, userRights = _this$props.userRights, revertedApplication = _this$props.revertedApplication, rejectedApplication = _this$props.rejectedApplication, userName = _this$props.userName, _this$props.workforceEmployeesFactoryId, dynamicTableTitle = _this$props.dynamicTableTitle, loggedInUserId = _this$props.loggedInUserId;
              _this$state = _this.state, showHistoryFilter = _this$state.showHistoryFilter, startDate = _this$state.startDate, endDate = _this$state.endDate;
              if (dynamicTableTitle) {
                _this.dynamicTableTitle = dynamicTableTitle;
              }
              _this.props.fetchOrganizationEmployee(_this.props.modulesManager, ["username:\"".concat(userName, "\"")]);
              _context.next = 6;
              return _this.fetchApplicant();
            case 6:
              console.log(_this.props.i_user);
              console.log("user_type: " + getUserTypeFromRights(userRights));
              if (!(getUserTypeFromRights(userRights) === WORKFORCE_USER_TYPE.CHECKER || getUserTypeFromRights(userRights) === WORKFORCE_USER_TYPE.SEC1_DEPUTI_ASST_DIRECTOR)) {
                _context.next = 17;
                break;
              }
              _this.setState({
                displayVersion: showHistoryFilter
              });
              defaultStatusFilters = ['applicationTypeIn: ["scholarship", "medicalAssistance", "maternityGrant", "financialAssistance", "disabilityAssistance"], organizationTypeIn: ["cf"]'];
              if (_this.props.filedApplications) {
                defaultStatusFilters.push('statusIn:["forward_for_verification"]');
                if (loggedInUserId) {
                  defaultStatusFilters.push("applicationTo:\"".concat(loggedInUserId, "\""));
                }
              } else if (_this.props.forwardedApplications) {
                defaultStatusFilters.push('statusIn:["verified"]');
                if (loggedInUserId) {
                  defaultStatusFilters.push("applicationFrom:\"".concat(loggedInUserId, "\""));
                }
              } else if (revertedApplication) {
                defaultStatusFilters.push('statusIn: ["revert"]');
                if (loggedInUserId) {
                  defaultStatusFilters.push("applicationTo: \"".concat(loggedInUserId, "\""));
                }
              } else if (_this.props.returnedApplications) {
                defaultStatusFilters.push('statusIn:["revert"]');
                if (loggedInUserId) {
                  defaultStatusFilters.push("applicationFrom:\"".concat(loggedInUserId, "\""));
                }
              }
              orderByFilter = 'orderBy: ["-dateCreated"]';
              defaultStatusFilters.push(orderByFilter);
              _this.props.fetchApplicationsSummary(_this.props.modulesManager, defaultStatusFilters);
              _context.next = 368;
              break;
            case 17:
              if (!(getUserTypeFromRights(userRights) === WORKFORCE_USER_TYPE.BLWF_CHECKER || getUserTypeFromRights(userRights) === WORKFORCE_USER_TYPE.BLWF_DEPUTI_ASST_DIRECTOR)) {
                _context.next = 26;
                break;
              }
              _this.setState({
                displayVersion: showHistoryFilter
              });
              _defaultStatusFilters = [(prms === null || prms === void 0 ? void 0 : prms.find(function (filter) {
                return filter.includes("applicationTypeIn");
              })) || 'applicationTypeIn: ["educationGrant", "medicalDonation", "deadlyGrant", "maternityGrant"]', 'organizationTypeIn: ["blwf"]'];
              if (_this.props.filedApplications) {
                _defaultStatusFilters.push('statusIn:["forward_for_verification"]');
                if (loggedInUserId) {
                  _defaultStatusFilters.push("applicationTo:\"".concat(loggedInUserId, "\""));
                }
              } else if (_this.props.forwardedApplications) {
                _defaultStatusFilters.push('statusIn:["verified"]');
                if (loggedInUserId) {
                  _defaultStatusFilters.push("applicationFrom:\"".concat(loggedInUserId, "\""));
                }
              } else if (revertedApplication) {
                _defaultStatusFilters.push('statusIn: ["revert"]');
                if (loggedInUserId) {
                  _defaultStatusFilters.push("applicationTo: \"".concat(loggedInUserId, "\""));
                }
              } else if (_this.props.returnedApplications) {
                _defaultStatusFilters.push('statusIn:["revert"]');
                if (loggedInUserId) {
                  _defaultStatusFilters.push("applicationFrom:\"".concat(loggedInUserId, "\""));
                }
              }
              _orderByFilter = 'orderBy: ["-dateCreated"]';
              _defaultStatusFilters.push(_orderByFilter);
              _this.props.fetchApplicationsSummary(_this.props.modulesManager, _defaultStatusFilters);
              _context.next = 368;
              break;
            case 26:
              if (!(getUserTypeFromRights(userRights) === WORKFORCE_USER_TYPE.BLWF_DOL_DIFE)) {
                _context.next = 35;
                break;
              }
              _this.setState({
                displayVersion: showHistoryFilter
              });
              _defaultStatusFilters2 = [(prms === null || prms === void 0 ? void 0 : prms.find(function (filter) {
                return filter.includes("applicationTypeIn");
              })) || 'applicationTypeIn: ["educationGrant", "medicalDonation", "deadlyGrant", "maternityGrant"]', 'organizationTypeIn: ["blwf"]'];
              if (_this.props.filedApplications) {
                _defaultStatusFilters2.push('statusIn:["new"]');
                if (loggedInUserId) {
                  _defaultStatusFilters2.push("applicationTo:\"".concat(loggedInUserId, "\""));
                }
              } else if (_this.props.forwardedApplications) {
                _defaultStatusFilters2.push('statusIn:["verified"]');
                if (loggedInUserId) {
                  _defaultStatusFilters2.push("applicationFrom:\"".concat(loggedInUserId, "\""));
                }
              } else if (revertedApplication) {
                _defaultStatusFilters2.push('statusIn: ["revert"]');
                if (loggedInUserId) {
                  _defaultStatusFilters2.push("applicationTo: \"".concat(loggedInUserId, "\""));
                }
              } else if (_this.props.returnedApplications) {
                _defaultStatusFilters2.push('statusIn:["revert"]');
                if (loggedInUserId) {
                  _defaultStatusFilters2.push("applicationFrom:\"".concat(loggedInUserId, "\""));
                }
              }
              _orderByFilter2 = 'orderBy: ["-dateCreated"]';
              _defaultStatusFilters2.push(_orderByFilter2);
              _this.props.fetchApplicationsSummary(_this.props.modulesManager, _defaultStatusFilters2);
              _context.next = 368;
              break;
            case 35:
              if (!(getUserTypeFromRights(userRights) === WORKFORCE_USER_TYPE.SECTION_ADMIN)) {
                _context.next = 51;
                break;
              }
              _this.setState({
                displayVersion: showHistoryFilter
              });
              _defaultStatusFilters3 = [];
              additionalFilters = [];
              summaryId = _this.props.summaryId ? safeDecodeId(_this.props.summaryId) : null;
              sectionApplicationTypes = 'applicationTypeIn: ["scholarship","medicalAssistance","maternityGrant"]';
              if (rejectedApplication) {
                _defaultStatusFilters3.push('statusIn: ["rejected"]', 'applicationTypeIn: ["scholarship","medicalAssistance","maternityGrant","financialAssistance","disabilityAssistance"]');
              } else if (revertedApplication) {
                _defaultStatusFilters3.push('statusIn: ["revert"]', sectionApplicationTypes);
              } else if (_this.props.returnedApplications) {
                _defaultStatusFilters3.push('statusIn: ["revert"]', sectionApplicationTypes);
                if (loggedInUserId) {
                  _defaultStatusFilters3.push("applicationFrom: \"".concat(loggedInUserId, "\""));
                }
              } else if (_this.props.sentForVerificationApplications) {
                _defaultStatusFilters3.push('statusIn: ["forward_for_verification","forward_to_doctor"]', sectionApplicationTypes);
              } else if (_this.props.verifiedApplications) {
                _defaultStatusFilters3.push('statusIn: ["approved_by_doctor","verified"]', sectionApplicationTypes);
              } else if (summaryId) {
                if (_this.props.statusInSummary) {
                  _defaultStatusFilters3.push("statusIn: [\"".concat(_this.props.statusInSummary, "\"]"));
                }
                _defaultStatusFilters3.push(sectionApplicationTypes);
                additionalFilters.push("cfApplicationSummary_Id:\"".concat(summaryId, "\""));
              } else {
                _defaultStatusFilters3.push('statusIn: ["forward_to_cf_section"]', sectionApplicationTypes);
              }
              if (loggedInUserId) {
                _defaultStatusFilters3.push("applicationTo: \"".concat(loggedInUserId, "\""));
              }
              _orderByFilter3 = 'orderBy: ["-dateCreated"]';
              nidFilters = _this.props.nidFilters || [];
              finalFilters = [];
              if (nidFilters.length) {
                finalFilters = _toConsumableArray(nidFilters);
                if (!finalFilters.some(function (f) {
                  return f.includes("orderBy");
                })) {
                  finalFilters.push(_orderByFilter3);
                }
                if (summaryId && !finalFilters.some(function (f) {
                  return f.includes("cfApplicationSummary_Id");
                })) {
                  finalFilters.push("cfApplicationSummary_Id:\"".concat(summaryId, "\""));
                }
              } else if (prms !== null && prms !== void 0 && prms.length) {
                finalFilters = _toConsumableArray(prms);
                hasStatusIn = finalFilters.some(function (f) {
                  return f.includes("statusIn");
                });
                hasAppType = finalFilters.some(function (f) {
                  return f.includes("applicationTypeIn");
                });
                hasApplicationTo = finalFilters.some(function (f) {
                  return f.includes("applicationTo");
                });
                hasOrderBy = finalFilters.some(function (f) {
                  return f.includes("orderBy");
                });
                if (!hasStatusIn) finalFilters = [].concat(_toConsumableArray(_defaultStatusFilters3.filter(function (f) {
                  return f.includes("statusIn");
                })), _toConsumableArray(finalFilters));
                if (!hasAppType) finalFilters = [].concat(_toConsumableArray(_defaultStatusFilters3.filter(function (f) {
                  return f.includes("applicationTypeIn");
                })), _toConsumableArray(finalFilters));
                if (!hasApplicationTo) finalFilters = [].concat(_toConsumableArray(_defaultStatusFilters3.filter(function (f) {
                  return f.includes("applicationTo");
                })), _toConsumableArray(finalFilters));
                if (!hasOrderBy) finalFilters.push(_orderByFilter3);
                if (summaryId && !finalFilters.some(function (f) {
                  return f.includes("cfApplicationSummary_Id");
                })) {
                  finalFilters.push("cfApplicationSummary_Id:\"".concat(summaryId, "\""));
                }
              } else {
                finalFilters = [].concat(_defaultStatusFilters3, additionalFilters, [_orderByFilter3]);
              }
              finalFilters = finalFilters.filter(function (f, i, arr) {
                return i === arr.findIndex(function (x) {
                  if (x.includes("statusIn") && f.includes("statusIn")) return true;
                  if (x.includes("applicationTypeIn") && f.includes("applicationTypeIn")) return true;
                  if (x.includes("applicationTo") && f.includes("applicationTo")) return true;
                  if (x.includes("applicationFrom") && f.includes("applicationFrom")) return true;
                  if (x.includes("orderBy") && f.includes("orderBy")) return true;
                  if (x.includes("cfApplicationSummary_Id") && f.includes("cfApplicationSummary_Id")) return true;
                  return x === f;
                });
              });
              _this.props.fetchApplicationsSummary(_this.props.modulesManager, finalFilters);
              _context.next = 368;
              break;
            case 51:
              if (!(getUserTypeFromRights(userRights) === WORKFORCE_USER_TYPE.SECTION_ADMIN_TWO)) {
                _context.next = 67;
                break;
              }
              _this.setState({
                displayVersion: showHistoryFilter
              });
              _defaultStatusFilters4 = [];
              _additionalFilters = [];
              _summaryId = _this.props.summaryId ? decodeId(_this.props.summaryId) : null;
              sectionTwoApplicationTypes = 'applicationTypeIn: ["disabilityAssistance","financialAssistance"]';
              if (rejectedApplication) {
                _defaultStatusFilters4.push('statusIn: ["rejected"]', sectionTwoApplicationTypes);
              } else if (revertedApplication) {
                _defaultStatusFilters4.push('statusIn: ["revert"]', sectionTwoApplicationTypes);
              } else if (_this.props.returnedApplications) {
                _defaultStatusFilters4.push('statusIn: ["revert"]', sectionTwoApplicationTypes);
                if (loggedInUserId) {
                  _defaultStatusFilters4.push("applicationFrom: \"".concat(loggedInUserId, "\""));
                }
              } else if (_summaryId) {
                if (_this.props.statusInSummary) {
                  _defaultStatusFilters4.push("statusIn: [\"".concat(_this.props.statusInSummary, "\"]"), sectionTwoApplicationTypes);
                }
                _defaultStatusFilters4.push('statusIn: ["forward_to_cf_section","meeting_created","approved_by_dg","approved_by_secretary","approved_by_minister"]', sectionTwoApplicationTypes);
                _additionalFilters.push("cfApplicationSummary_Id:\"".concat(_summaryId, "\""));
              } else {
                _defaultStatusFilters4.push('statusIn: ["forward_to_cf_section","approved_by_doctor","verified"]', sectionTwoApplicationTypes);
              }
              if (loggedInUserId) {
                _defaultStatusFilters4.push("applicationTo: \"".concat(loggedInUserId, "\""));
              }
              _orderByFilter4 = 'orderBy: ["-dateCreated"]';
              _nidFilters = _this.props.nidFilters || [];
              _finalFilters = [];
              if (_nidFilters.length) {
                _finalFilters = _toConsumableArray(_nidFilters);
                if (!_finalFilters.some(function (f) {
                  return f.includes("orderBy");
                })) {
                  _finalFilters.push(_orderByFilter4);
                }
                if (_summaryId && !_finalFilters.some(function (f) {
                  return f.includes("cfApplicationSummary_Id");
                })) {
                  _finalFilters.push("cfApplicationSummary_Id:\"".concat(_summaryId, "\""));
                }
              } else if (prms !== null && prms !== void 0 && prms.length) {
                _finalFilters = _toConsumableArray(prms);
                _hasStatusIn = _finalFilters.some(function (f) {
                  return f.includes("statusIn");
                });
                _hasAppType = _finalFilters.some(function (f) {
                  return f.includes("applicationTypeIn");
                });
                _hasApplicationTo = _finalFilters.some(function (f) {
                  return f.includes("applicationTo");
                });
                _hasOrderBy = _finalFilters.some(function (f) {
                  return f.includes("orderBy");
                });
                if (!_hasStatusIn) _finalFilters = [].concat(_toConsumableArray(_defaultStatusFilters4.filter(function (f) {
                  return f.includes("statusIn");
                })), _toConsumableArray(_finalFilters));
                if (!_hasAppType) _finalFilters = [].concat(_toConsumableArray(_defaultStatusFilters4.filter(function (f) {
                  return f.includes("applicationTypeIn");
                })), _toConsumableArray(_finalFilters));
                if (!_hasApplicationTo) _finalFilters = [].concat(_toConsumableArray(_defaultStatusFilters4.filter(function (f) {
                  return f.includes("applicationTo");
                })), _toConsumableArray(_finalFilters));
                if (!_hasOrderBy) _finalFilters.push(_orderByFilter4);
                if (_summaryId && !_finalFilters.some(function (f) {
                  return f.includes("cfApplicationSummary_Id");
                })) {
                  _finalFilters.push("cfApplicationSummary_Id:\"".concat(_summaryId, "\""));
                }
              } else {
                _finalFilters = [].concat(_defaultStatusFilters4, _additionalFilters, [_orderByFilter4]);
              }
              _finalFilters = _finalFilters.filter(function (f, i, arr) {
                return i === arr.findIndex(function (x) {
                  if (x.includes("statusIn") && f.includes("statusIn")) return true;
                  if (x.includes("applicationTypeIn") && f.includes("applicationTypeIn")) return true;
                  if (x.includes("applicationTo") && f.includes("applicationTo")) return true;
                  if (x.includes("applicationFrom") && f.includes("applicationFrom")) return true;
                  if (x.includes("orderBy") && f.includes("orderBy")) return true;
                  if (x.includes("cfApplicationSummary_Id") && f.includes("cfApplicationSummary_Id")) return true;
                  return x === f;
                });
              });
              _this.props.fetchApplicationsSummary(_this.props.modulesManager, _finalFilters);
              _context.next = 368;
              break;
            case 67:
              if (!(getUserTypeFromRights(userRights) === WORKFORCE_USER_TYPE.BLWF_SECTION_ADMIN)) {
                _context.next = 80;
                break;
              }
              _this.setState({
                displayVersion: showHistoryFilter
              });
              _defaultStatusFilters5 = [];
              _additionalFilters2 = [];
              _summaryId2 = _this.props.summaryId ? decodeId(_this.props.summaryId) : null;
              if (rejectedApplication) {
                _defaultStatusFilters5.push('statusIn: ["rejected"]', 'organizationTypeIn: ["blwf"]');
              } else if (revertedApplication) {
                _defaultStatusFilters5.push('organizationTypeIn: ["blwf"]');
                _defaultStatusFilters5.push('statusIn: ["revert"]');
                if (loggedInUserId) {
                  _defaultStatusFilters5.push("applicationTo: \"".concat(loggedInUserId, "\""));
                }
              } else if (_this.props.returnedApplications) {
                _defaultStatusFilters5 = ['statusIn: ["revert"]'];
                if (loggedInUserId) {
                  _defaultStatusFilters5.push("applicationFrom: \"".concat(loggedInUserId, "\""));
                }
              } else if (_this.props.sentForVerificationApplications) {
                _defaultStatusFilters5.push('statusIn: ["forward_for_verification","forward_to_doctor"]', 'organizationTypeIn: ["blwf"]');
              } else if (_summaryId2) {
                if (_this.props.statusInSummary) {
                  _defaultStatusFilters5.push("statusIn: [\"".concat(_this.props.statusInSummary, "\"], 'organizationTypeIn: [\"blwf\"]"));
                } else {
                  _defaultStatusFilters5.push('statusIn: ["forward_to_blwf_section","meeting_created","approved_by_dg","approved_by_director","approved_by_secretary","approved_by_minister"]', 'organizationTypeIn: ["blwf"]');
                }
                _additionalFilters2.push("blwfApplicationSummary_Id:\"".concat(_summaryId2, "\""));
              } else if (_this.props.verifiedApplications) {
                _defaultStatusFilters5.push('statusIn: ["approved_by_doctor","verified"]', 'organizationTypeIn: ["blwf"]');
              } else {
                _defaultStatusFilters5.push('statusIn: ["verified_by_dol_dife"]', 'organizationTypeIn: ["blwf"]');
              }
              _orderByFilter5 = 'orderBy: ["-dateCreated"]';
              _nidFilters2 = _this.props.nidFilters || [];
              _finalFilters2 = [];
              if (_nidFilters2.length) {
                _finalFilters2 = _toConsumableArray(_nidFilters2);
                if (!_finalFilters2.some(function (f) {
                  return f.includes("orderBy");
                })) {
                  _finalFilters2.push(_orderByFilter5);
                }
                if (_summaryId2 && !_finalFilters2.some(function (f) {
                  return f.includes("blwfApplicationSummary_Id");
                })) {
                  _finalFilters2.push("blwfApplicationSummary_Id:\"".concat(_summaryId2, "\""));
                }
              } else if (prms !== null && prms !== void 0 && prms.length) {
                _finalFilters2 = _toConsumableArray(prms);
                _hasStatusIn2 = _finalFilters2.some(function (f) {
                  return f.includes("statusIn");
                });
                _hasOrderBy2 = _finalFilters2.some(function (f) {
                  return f.includes("orderBy");
                });
                if (!_hasStatusIn2) {
                  _finalFilters2 = [].concat(_toConsumableArray(_defaultStatusFilters5), _toConsumableArray(_finalFilters2));
                }
                if (!_hasOrderBy2) _finalFilters2.push(_orderByFilter5);
                if (_summaryId2 && !_finalFilters2.some(function (f) {
                  return f.includes("blwfApplicationSummary_Id");
                })) {
                  _finalFilters2.push("blwfApplicationSummary_Id:\"".concat(_summaryId2, "\""));
                }
              } else {
                _finalFilters2 = [].concat(_toConsumableArray(_defaultStatusFilters5), _additionalFilters2, [_orderByFilter5]);
              }
              _this.props.fetchApplicationsSummary(_this.props.modulesManager, _finalFilters2);
              _context.next = 368;
              break;
            case 80:
              if (!(getUserTypeFromRights(userRights) === WORKFORCE_USER_TYPE.CHECKER_TWO || getUserTypeFromRights(userRights) === WORKFORCE_USER_TYPE.SEC2_DEPUTI_ASST_DIRECTOR)) {
                _context.next = 89;
                break;
              }
              _this.setState({
                displayVersion: showHistoryFilter
              });
              _defaultStatusFilters6 = ['applicationTypeIn: ["disabilityAssistance","financialAssistance"], organizationTypeIn: ["cf"]'];
              if (_this.props.filedApplications) {
                _defaultStatusFilters6.push('statusIn:["forward_for_verification"]');
                if (loggedInUserId) {
                  _defaultStatusFilters6.push("applicationTo:\"".concat(loggedInUserId, "\""));
                }
              } else if (_this.props.forwardedApplications) {
                _defaultStatusFilters6.push('statusIn:["verified"]');
                if (loggedInUserId) {
                  _defaultStatusFilters6.push("applicationFrom:\"".concat(loggedInUserId, "\""));
                }
              } else if (revertedApplication) {
                _defaultStatusFilters6.push('statusIn: ["revert"]');
                if (loggedInUserId) {
                  _defaultStatusFilters6.push("applicationTo: \"".concat(loggedInUserId, "\""));
                }
              } else if (_this.props.returnedApplications) {
                _defaultStatusFilters6.push('statusIn:["revert"]');
                if (loggedInUserId) {
                  _defaultStatusFilters6.push("applicationFrom:\"".concat(loggedInUserId, "\""));
                }
              }
              _orderByFilter6 = 'orderBy: ["-dateCreated"]';
              _defaultStatusFilters6.push(_orderByFilter6);
              _this.props.fetchApplicationsSummary(_this.props.modulesManager, _defaultStatusFilters6);
              _context.next = 368;
              break;
            case 89:
              if (!(getUserTypeFromRights(userRights) === WORKFORCE_USER_TYPE.BGMEA_ASSOCIATION)) {
                _context.next = 101;
                break;
              }
              _this.setState({
                displayVersion: showHistoryFilter
              });
              _defaultStatusFilters7 = [];
              if (revertedApplication) {
                _defaultStatusFilters7 = ['organizationTypeIn: ["cf"]', 'statusIn: ["revert"]', 'associationTypeIn: "BGMEA"'];
                if (loggedInUserId) {
                  _defaultStatusFilters7.push("applicationTo: \"".concat(loggedInUserId, "\""));
                }
              } else if (_this.props.forwardedApplications) {
                _defaultStatusFilters7.push('statusIn: ["forward_to_cf_section"]', 'associationTypeIn: "BGMEA"');
              } else if (_this.props.returnedApplications) {
                _defaultStatusFilters7 = ['statusIn: ["revert"]', 'associationTypeIn: "BGMEA"'];
                if (loggedInUserId) {
                  _defaultStatusFilters7.push("applicationFrom: \"".concat(loggedInUserId, "\""));
                }
              } else {
                _defaultStatusFilters7.push('statusIn: ["forward_to_association","resubmitted_application"]', 'associationTypeIn: "BGMEA"');
                if (loggedInUserId) {
                  _defaultStatusFilters7.push("applicationTo: \"".concat(loggedInUserId, "\""));
                }
              }
              _orderByFilter7 = 'orderBy: ["-dateCreated"]';
              _hasStatusIn3 = prms === null || prms === void 0 ? void 0 : prms.some(function (f) {
                return f.includes("statusIn");
              });
              _hasOrderBy3 = prms === null || prms === void 0 ? void 0 : prms.some(function (f) {
                return f.includes("orderBy");
              });
              _finalFilters3 = [];
              if (prms !== null && prms !== void 0 && prms.length) {
                _finalFilters3 = _toConsumableArray(prms);
                if (!_hasStatusIn3) {
                  _finalFilters3 = [].concat(_toConsumableArray(_defaultStatusFilters7), _toConsumableArray(_finalFilters3));
                }
                if (!_hasOrderBy3) {
                  _finalFilters3.push(_orderByFilter7);
                }
              } else {
                _finalFilters3 = [].concat(_toConsumableArray(_defaultStatusFilters7), [_orderByFilter7]);
              }
              _this.props.fetchApplicationsSummary(_this.props.modulesManager, _finalFilters3);
              _context.next = 368;
              break;
            case 101:
              if (!(getUserTypeFromRights(userRights) === WORKFORCE_USER_TYPE.BKMEA_ASSOCIATION)) {
                _context.next = 113;
                break;
              }
              _this.setState({
                displayVersion: showHistoryFilter
              });
              _defaultStatusFilters8 = [];
              if (revertedApplication) {
                _defaultStatusFilters8 = ['organizationTypeIn: ["cf"]', 'statusIn: ["revert"]', 'associationTypeIn: "BKMEA"'];
                if (loggedInUserId) {
                  _defaultStatusFilters8.push("applicationTo: \"".concat(loggedInUserId, "\""));
                }
              } else if (_this.props.forwardedApplications) {
                _defaultStatusFilters8.push('statusIn: ["forward_to_cf_section","revert_to_applicant"]', 'associationTypeIn: ["BKMEA"]');
              } else if (_this.props.returnedApplications) {
                _defaultStatusFilters8 = ['statusIn: ["revert"]', 'associationTypeIn: "BKMEA"'];
                if (loggedInUserId) {
                  _defaultStatusFilters8.push("applicationFrom: \"".concat(loggedInUserId, "\""));
                }
              } else {
                _defaultStatusFilters8.push('statusIn: ["forward_to_association","resubmitted_application"]', 'associationTypeIn: ["BKMEA"]');
                if (loggedInUserId) {
                  _defaultStatusFilters8.push("applicationTo: \"".concat(loggedInUserId, "\""));
                }
              }
              _orderByFilter8 = 'orderBy: ["-dateCreated"]';
              _hasStatusIn4 = prms === null || prms === void 0 ? void 0 : prms.some(function (f) {
                return f.includes("statusIn");
              });
              _hasOrderBy4 = prms === null || prms === void 0 ? void 0 : prms.some(function (f) {
                return f.includes("orderBy");
              });
              _finalFilters4 = [];
              if (prms !== null && prms !== void 0 && prms.length) {
                _finalFilters4 = _toConsumableArray(prms);
                if (!_hasStatusIn4) {
                  _finalFilters4 = [].concat(_toConsumableArray(_defaultStatusFilters8), _toConsumableArray(_finalFilters4));
                }
                if (!_hasOrderBy4) {
                  _finalFilters4.push(_orderByFilter8);
                }
              } else {
                _finalFilters4 = [].concat(_toConsumableArray(_defaultStatusFilters8), [_orderByFilter8]);
              }
              _this.props.fetchApplicationsSummary(_this.props.modulesManager, _finalFilters4);
              _context.next = 368;
              break;
            case 113:
              if (!(getUserTypeFromRights(userRights) === WORKFORCE_USER_TYPE.BEPZA_ASSOCIATION)) {
                _context.next = 125;
                break;
              }
              _this.setState({
                displayVersion: showHistoryFilter
              });
              _defaultStatusFilters9 = [];
              if (revertedApplication) {
                _defaultStatusFilters9 = [
                // 'organizationTypeIn: ["eis"]',
                'statusIn: ["revert"]', 'associationTypeIn: "BEPZA"'];

                // if (loggedInUserId) {
                //   defaultStatusFilters.push(`applicationTo: "${loggedInUserId}"`);
                // }
              } else if (_this.props.forwardedApplications) {
                _defaultStatusFilters9.push('statusIn: ["forward_to_eis_coordinator","revert_to_applicant"]', 'associationTypeIn: ["BEPZA"]');
              } else if (_this.props.returnedApplications) {
                _defaultStatusFilters9 = ['statusIn: ["revert"]', 'associationTypeIn: "BEPZA"'];
                // if (loggedInUserId) {
                //   defaultStatusFilters.push(`applicationFrom: "${loggedInUserId}"`);
                // }
              } else {
                _defaultStatusFilters9.push('statusIn: ["forward_to_association","resubmitted_application"]', 'associationTypeIn: ["BEPZA"]');
                // if (loggedInUserId) {
                //   defaultStatusFilters.push(`applicationTo: "${loggedInUserId}"`);
                // }
              }
              _orderByFilter9 = 'orderBy: ["-dateCreated"]';
              _hasStatusIn5 = prms === null || prms === void 0 ? void 0 : prms.some(function (f) {
                return f.includes("statusIn");
              });
              _hasOrderBy5 = prms === null || prms === void 0 ? void 0 : prms.some(function (f) {
                return f.includes("orderBy");
              });
              _finalFilters5 = [];
              if (prms !== null && prms !== void 0 && prms.length) {
                _finalFilters5 = _toConsumableArray(prms);
                if (!_hasStatusIn5) {
                  _finalFilters5 = [].concat(_toConsumableArray(_defaultStatusFilters9), _toConsumableArray(_finalFilters5));
                }
                if (!_hasOrderBy5) {
                  _finalFilters5.push(_orderByFilter9);
                }
              } else {
                _finalFilters5 = [].concat(_toConsumableArray(_defaultStatusFilters9), [_orderByFilter9]);
              }
              _this.props.fetchApplicationsSummary(_this.props.modulesManager, _finalFilters5);
              _context.next = 368;
              break;
            case 125:
              if (!(getUserTypeFromRights(userRights) === WORKFORCE_USER_TYPE.LFMEAB_ASSOCIATION)) {
                _context.next = 137;
                break;
              }
              _this.setState({
                displayVersion: showHistoryFilter
              });
              _defaultStatusFilters10 = [];
              if (revertedApplication) {
                _defaultStatusFilters10 = [
                // 'organizationTypeIn: ["eis"]',
                'statusIn: ["revert"]', 'associationTypeIn: "LFMEAB"'];

                // if (loggedInUserId) {
                //   defaultStatusFilters.push(`applicationTo: "${loggedInUserId}"`);
                // }
              } else if (_this.props.forwardedApplications) {
                _defaultStatusFilters10.push('statusIn: ["forward_to_eis_coordinator","revert_to_applicant"]', 'associationTypeIn: ["LFMEAB"]');
              } else if (_this.props.returnedApplications) {
                _defaultStatusFilters10 = ['statusIn: ["revert"]', 'associationTypeIn: "LFMEAB"'];
                // if (loggedInUserId) {
                //   defaultStatusFilters.push(`applicationFrom: "${loggedInUserId}"`);
                // }
              } else {
                _defaultStatusFilters10.push('statusIn: ["forward_to_association","resubmitted_application"]', 'associationTypeIn: ["LFMEAB"]');
                // if (loggedInUserId) {
                //   defaultStatusFilters.push(`applicationTo: "${loggedInUserId}"`);
                // }
              }
              _orderByFilter10 = 'orderBy: ["-dateCreated"]';
              _hasStatusIn6 = prms === null || prms === void 0 ? void 0 : prms.some(function (f) {
                return f.includes("statusIn");
              });
              _hasOrderBy6 = prms === null || prms === void 0 ? void 0 : prms.some(function (f) {
                return f.includes("orderBy");
              });
              _finalFilters6 = [];
              if (prms !== null && prms !== void 0 && prms.length) {
                _finalFilters6 = _toConsumableArray(prms);
                if (!_hasStatusIn6) {
                  _finalFilters6 = [].concat(_toConsumableArray(_defaultStatusFilters10), _toConsumableArray(_finalFilters6));
                }
                if (!_hasOrderBy6) {
                  _finalFilters6.push(_orderByFilter10);
                }
              } else {
                _finalFilters6 = [].concat(_toConsumableArray(_defaultStatusFilters10), [_orderByFilter10]);
              }
              _this.props.fetchApplicationsSummary(_this.props.modulesManager, _finalFilters6);
              _context.next = 368;
              break;
            case 137:
              if (!(getUserTypeFromRights(userRights) === WORKFORCE_USER_TYPE.ASSOCIATION)) {
                _context.next = 150;
                break;
              }
              _this.setState({
                displayVersion: showHistoryFilter
              });
              _defaultStatusFilters11 = [];
              if (_this.props.associationIds && _this.props.associationIds.length > 0) {
                _defaultStatusFilters11.push("allAssociationIdIn: [".concat(_this.props.associationIds.map(function (id) {
                  return "\"".concat(safeDecodeId(id), "\"");
                }).join(","), "]"));
              }
              if (revertedApplication) {
                _defaultStatusFilters11 = ['statusIn: ["revert"]'];
                if (loggedInUserId) {
                  _defaultStatusFilters11.push("applicationTo: \"".concat(loggedInUserId, "\""));
                }
              } else if (_this.props.forwardedApplications) {
                _defaultStatusFilters11.push('statusIn: ["forward_to_eis_coordinator","revert_to_applicant"]');
              } else if (_this.props.approvedApplications) {
                _defaultStatusFilters11.push("applicationFrom:\"".concat((_this$props2 = _this.props) === null || _this$props2 === void 0 || (_this$props2 = _this$props2.i_user) === null || _this$props2 === void 0 ? void 0 : _this$props2.id, "\""));
              } else if (_this.props.returnedApplications) {
                _defaultStatusFilters11 = ['statusIn: ["revert"]'];
                // if (loggedInUserId) {
                //   defaultStatusFilters.push(`applicationFrom: "${loggedInUserId}"`);
                // }
              } else {
                _defaultStatusFilters11.push('statusIn: ["forward_to_association","resubmitted_application"]');
                // if (loggedInUserId) {
                //   defaultStatusFilters.push(`applicationTo: "${loggedInUserId}"`);
                // }
              }
              _orderByFilter11 = 'orderBy: ["-dateCreated"]';
              _hasStatusIn7 = prms === null || prms === void 0 ? void 0 : prms.some(function (f) {
                return f.includes("statusIn");
              });
              _hasOrderBy7 = prms === null || prms === void 0 ? void 0 : prms.some(function (f) {
                return f.includes("orderBy");
              });
              _finalFilters7 = [];
              if (prms !== null && prms !== void 0 && prms.length) {
                _finalFilters7 = _toConsumableArray(prms);
                if (!_hasStatusIn7) {
                  _finalFilters7 = [].concat(_toConsumableArray(_defaultStatusFilters11), _toConsumableArray(_finalFilters7));
                }
                if (!_hasOrderBy7) {
                  _finalFilters7.push(_orderByFilter11);
                }
              } else {
                _finalFilters7 = [].concat(_toConsumableArray(_defaultStatusFilters11), [_orderByFilter11]);
              }
              _this.props.fetchApplicationsSummary(_this.props.modulesManager, _finalFilters7);
              _context.next = 368;
              break;
            case 150:
              if (!(getUserTypeFromRights(userRights) === WORKFORCE_USER_TYPE.FACTORY_ADMIN)) {
                _context.next = 163;
                break;
              }
              _this.setState({
                displayVersion: showHistoryFilter
              });
              organizationTypeIn = '["cf"]';
              if (isEisPath()) {
                organizationTypeIn = '["eis"]';
              }
              _defaultStatusFilters12 = [];
              if (revertedApplication) {
                _defaultStatusFilters12.push('statusIn: ["revert"]', "organizationTypeIn: ".concat(organizationTypeIn));
                if (loggedInUserId) {
                  _defaultStatusFilters12.push("applicationFrom: \"".concat(loggedInUserId, "\""));
                }
              } else if (_this.props.returnedApplications) {
                _defaultStatusFilters12.push('statusIn: ["revert"]', "organizationTypeIn: ".concat(organizationTypeIn));
                if (loggedInUserId) {
                  _defaultStatusFilters12.push("applicationFrom: \"".concat(loggedInUserId, "\""));
                }
              } else if (rejectedApplication) {
                _defaultStatusFilters12.push('statusIn: ["rejected"]', "organizationTypeIn: ".concat(organizationTypeIn));
              } else if (_this.props.submittedByApplicants) {
                _defaultStatusFilters12.push('statusIn: ["new"]', 'submittedByIn:["applicant"]', "organizationTypeIn: ".concat(organizationTypeIn));
                if (_this.props.factoryId) {
                  console.log("factoryId from aps:", _this.props.factoryId);
                  _defaultStatusFilters12.push("employeeFactoryId: \"".concat(_this.props.factoryId, "\""));
                }
              } else if (_this.props.forwardedApplications) {
                _defaultStatusFilters12.push("organizationTypeIn: ".concat(organizationTypeIn));
                if (loggedInUserId) {
                  _defaultStatusFilters12.push("applicationFrom: \"".concat(loggedInUserId, "\""));
                }
              } else if (_this.props.isDraft) {
                _defaultStatusFilters12.push('statusIn: ["draft"]', "organizationTypeIn: ".concat(organizationTypeIn));
                if (_this.props.factoryId) {
                  _defaultStatusFilters12.push("employeeFactoryId: \"".concat(_this.props.factoryId, "\""));
                }
              } else {
                _defaultStatusFilters12.push('statusIn: ["new","resubmitted_application"]', "organizationTypeIn: ".concat(organizationTypeIn));
                if (_this.props.factoryId) {
                  _defaultStatusFilters12.push("employeeFactoryId: \"".concat(_this.props.factoryId, "\""));
                }
                // if (loggedInUserId) {
                //   defaultStatusFilters.push(`applicationTo: "${loggedInUserId}"`);
                // }
              }
              _orderByFilter12 = 'orderBy: ["-dateCreated"]';
              _finalFilters8 = [];
              if (prms !== null && prms !== void 0 && prms.length) {
                _finalFilters8 = _toConsumableArray(prms);
                _hasStatusIn8 = _finalFilters8.some(function (f) {
                  return f.includes("statusIn");
                });
                hasApplicationTypeIn = _finalFilters8.some(function (f) {
                  return f.includes("applicationTypeIn");
                });
                hasOrganizationTypeIn = _finalFilters8.some(function (f) {
                  return f.includes("organizationTypeIn");
                });
                _hasApplicationTo2 = _finalFilters8.some(function (f) {
                  return f.includes("applicationTo");
                });
                hasApplicationFrom = _finalFilters8.some(function (f) {
                  return f.includes("applicationFrom");
                });
                _hasOrderBy8 = _finalFilters8.some(function (f) {
                  return f.includes("orderBy");
                });
                hasEmployeeFactoryId = _finalFilters8.some(function (f) {
                  return f.includes("employeeFactoryId");
                });
                if (!_hasStatusIn8) _finalFilters8 = [].concat(_toConsumableArray(_defaultStatusFilters12.filter(function (f) {
                  return f.includes("statusIn");
                })), _toConsumableArray(_finalFilters8));
                if (!hasApplicationTypeIn) _finalFilters8 = [].concat(_toConsumableArray(_defaultStatusFilters12.filter(function (f) {
                  return f.includes("applicationTypeIn");
                })), _toConsumableArray(_finalFilters8));
                if (!hasOrganizationTypeIn) _finalFilters8 = [].concat(_toConsumableArray(_defaultStatusFilters12.filter(function (f) {
                  return f.includes("organizationTypeIn");
                })), _toConsumableArray(_finalFilters8));
                if (!_hasApplicationTo2) _finalFilters8 = [].concat(_toConsumableArray(_defaultStatusFilters12.filter(function (f) {
                  return f.includes("applicationTo");
                })), _toConsumableArray(_finalFilters8));
                if (!hasApplicationFrom) _finalFilters8 = [].concat(_toConsumableArray(_defaultStatusFilters12.filter(function (f) {
                  return f.includes("applicationFrom");
                })), _toConsumableArray(_finalFilters8));
                if (!_hasOrderBy8) _finalFilters8.push(_orderByFilter12);
                if (!hasEmployeeFactoryId) _finalFilters8 = [].concat(_toConsumableArray(_defaultStatusFilters12.filter(function (f) {
                  return f.includes("employeeFactoryId");
                })), _toConsumableArray(_finalFilters8));
              } else {
                _finalFilters8 = [].concat(_defaultStatusFilters12, [_orderByFilter12]);
              }
              _finalFilters8 = _finalFilters8.filter(function (f, i, arr) {
                return i === arr.findIndex(function (x) {
                  if (x.includes("applicationTypeIn") && f.includes("applicationTypeIn")) return true;
                  if (x.includes("statusIn") && f.includes("statusIn")) return true;
                  if (x.includes("orderBy") && f.includes("orderBy")) return true;
                  if (x.includes("organizationTypeIn") && f.includes("organizationTypeIn")) return true;
                  if (x.includes("applicationTo") && f.includes("applicationTo")) return true;
                  if (x.includes("applicationFrom") && f.includes("applicationFrom")) return true;
                  if (x.includes("employeeFactoryId") && f.includes("employeeFactoryId")) return true;
                  return x === f;
                });
              });
              _this.props.fetchApplicationsSummary(_this.props.modulesManager, _finalFilters8);
              _context.next = 368;
              break;
            case 163:
              if (!(getUserTypeFromRights(userRights) === WORKFORCE_USER_TYPE.APPROVER)) {
                _context.next = 171;
                break;
              }
              _this.setState({
                displayVersion: showHistoryFilter
              });
              filters = ["organizationTypeIn: [\"cf\"]", "orderBy: [\"-dateCreated\"]"];
              if (_this.props.summaryId) {
                filters.push("cfApplicationSummary_Id: \"".concat(decodeId(_this.props.summaryId), "\""));
                if (!_this.props.statusInSummary) {
                  console.log("HELLOO 234");
                  filters.push("statusIn:[\"forward_to_comiitee\",\"proposed_for_rejection\",\"selected\"]");
                }
              }
              if (_this.props.returnedApplications) {
                filters.push("statusIn: [\"revert\"]");
                if (loggedInUserId) {
                  filters.push("applicationFrom: \"".concat(loggedInUserId, "\""));
                }
              } else if (_this.props.revertedApplications) {
                filters.push("statusIn: [\"revert\"]");
                if (loggedInUserId) {
                  filters.push("applicationTo: \"".concat(loggedInUserId, "\""));
                }
              } else if (_this.props.statusInSummary) {
                filters.push("statusIn: [\"".concat(_this.props.statusInSummary, "\"]"));
              }
              // this.props.fetchApplicationsSummary(this.props.modulesManager, filters);
              _this.props.fetchApplicationsSummary(_this.props.modulesManager, filters);
              _context.next = 368;
              break;
            case 171:
              if (!(getUserTypeFromRights(userRights) === WORKFORCE_USER_TYPE.BLWF_APPROVER)) {
                _context.next = 180;
                break;
              }
              _this.setState({
                displayVersion: showHistoryFilter
              });
              _filters = ["organizationTypeIn: [\"blwf\"]", "orderBy: [\"-dateCreated\"]"];
              if (_this.props.summaryId) {
                _filters.push("blwfApplicationSummary_Id: \"".concat(safeDecodeId(_this.props.summaryId), "\""));
                if (!_this.props.statusInSummary) {
                  _filters.push("statusIn:[\"forward_to_comiitee\",\"proposed_for_rejection\",\"selected\",\"forward_to_dg\",\"forward_to_director\"]");
                }
                if (loggedInUserId) {
                  _filters.push("applicationTo: \"".concat(loggedInUserId, "\""));
                }
              }
              if (_this.props.statusInSummary) {
                _filters.push("statusIn: [\"".concat(_this.props.statusInSummary, "\"]"));
              }
              if (_this.props.returnedApplications) {
                _filters.push("statusIn: [\"revert\"]");
                if (loggedInUserId) {
                  _filters.push("applicationFrom: \"".concat(loggedInUserId, "\""));
                }
              }
              _this.props.fetchApplicationsSummary(_this.props.modulesManager, _filters);
              _context.next = 368;
              break;
            case 180:
              if (!(getUserTypeFromRights(userRights) === WORKFORCE_USER_TYPE.APPLICANT)) {
                _context.next = 186;
                break;
              }
              _this.setState({
                displayVersion: showHistoryFilter
              });
              isApproved = _this.props.isApproved ? _this.props.isApproved : false;
              if (revertedApplication) {
                _filters2 = ["workforceEmployee_Id: \"".concat((_this$props$workforce = _this.props.workforceEmployee) === null || _this$props$workforce === void 0 ? void 0 : _this$props$workforce.id, "\""), "statusIn: [\"revert\",\"revert_to_applicant\"], orderBy: [\"-dateCreated\"]"];
                if (loggedInUserId) {
                  _filters2.push("applicationTo:\"".concat(loggedInUserId, "\""));
                }
                _this.props.fetchApplicationsSummary(_this.props.modulesManager, _filters2);
              } else if (rejectedApplication) {
                if (loggedInUserId) {
                  _this.props.fetchApplicationsSummary(_this.props.modulesManager, ["workforceEmployee_Id: \"".concat((_this$props$workforce2 = _this.props.workforceEmployee) === null || _this$props$workforce2 === void 0 ? void 0 : _this$props$workforce2.id, "\""), "statusIn: [\"rejected\"], orderBy: [\"-dateCreated\"]", "applicationTo:\"".concat(loggedInUserId, "\"")]);
                }
                _this.props.fetchApplicationsSummary(_this.props.modulesManager, ["workforceEmployee_Id: \"".concat((_this$props$workforce3 = _this.props.workforceEmployee) === null || _this$props$workforce3 === void 0 ? void 0 : _this$props$workforce3.id, "\""), "statusIn: [\"rejected\"], orderBy: [\"-dateCreated\"]", "applicationTo:\"".concat(loggedInUserId, "\"")]);
              } else if (_this.props.applicationStatus) {
                _this.props.fetchApplicationsSummary(_this.props.modulesManager, ["workforceEmployee_Id: \"".concat((_this$props$workforce4 = _this.props.workforceEmployee) === null || _this$props$workforce4 === void 0 ? void 0 : _this$props$workforce4.id, "\""), "statusIn: [\"draft\"], orderBy: [\"-dateCreated\"]"]);
              } else if (isApproved) {
                _this.props.fetchApplicationsSummary(_this.props.modulesManager, ["workforceEmployee_Id: \"".concat((_this$props$workforce5 = _this.props.workforceEmployee) === null || _this$props$workforce5 === void 0 ? void 0 : _this$props$workforce5.id, "\""), 'statusIn: ["approved_by_dg"]', 'orderBy: ["-dateCreated"]']);
              } else {
                _this.props.fetchApplicationsSummary(_this.props.modulesManager, ["workforceEmployee_Id: \"".concat((_this$props$workforce6 = _this.props.workforceEmployee) === null || _this$props$workforce6 === void 0 ? void 0 : _this$props$workforce6.id, "\""), 'statusIn: ["new","forward_to_factory_admin","forward_to_association","forward_for_verification","verified","forward_to_doctor","approved_by_doctor","forward_to_eis_advisor","approved_by_eis_advisor,""forward_to_comiitee","approved_by_committee","forward_to_cf_section",]', 'orderBy: ["-dateCreated"]']
                // [`workforceEmployee_Id: "${this.props.workforceEmployee?.id}"`,`organizationType:"${isEisPath()?"eis":isBlwfPath()?"blwf":"cf"}"`, 'orderBy: ["-dateCreated"]']
                );
              }
              _context.next = 368;
              break;
            case 186:
              if (!(getUserTypeFromRights(userRights) === WORKFORCE_USER_TYPE.ADMIN)) {
                _context.next = 208;
                break;
              }
              _this.setState({
                displayVersion: showHistoryFilter
              });
              if (!_this.props.summaryId) {
                _context.next = 198;
                break;
              }
              filtersBase = ['statusIn: ["forward_to_director","approved_by_director","approved_by_dg"]', 'organizationTypeIn: ["cf","blwf"]', 'orderBy: ["-dateCreated"]'];
              cfFilters = [].concat(filtersBase, ["cfApplicationSummary_Id: \"".concat(decodeId(_this.props.summaryId), "\"")]);
              blwfFilters = [].concat(filtersBase, ["blwfApplicationSummary_Id: \"".concat(decodeId(_this.props.summaryId), "\"")]);
              _context.next = 194;
              return Promise.all([_this.props.fetchApplicationsSummary(_this.props.modulesManager, cfFilters), _this.props.fetchApplicationsSummary(_this.props.modulesManager, blwfFilters)]);
            case 194:
              _yield$Promise$all = _context.sent;
              _slicedToArray(_yield$Promise$all, 0);
              _context.next = 206;
              break;
            case 198:
              if (!rejectedApplication) {
                _context.next = 205;
                break;
              }
              _filtersBase = ['statusIn: ["rejected_by_dg"]', 'orderBy: ["-dateCreated"]'];
              if (loggedInUserId) {
                _filtersBase.push("applicationTo:\"".concat(loggedInUserId, "\""));
              }
              _context.next = 203;
              return _this.props.fetchApplicationsSummary(_this.props.modulesManager, _filtersBase);
            case 203:
              _context.next = 206;
              break;
            case 205:
              if (_this.props.returnedApplications) {
                _filtersBase2 = ['statusIn: ["revert"]', 'orderBy: ["-dateCreated"]'];
                if (loggedInUserId) {
                  _filtersBase2.push("applicationFrom:\"".concat(loggedInUserId, "\""));
                }
                _this.props.fetchApplicationsSummary(_this.props.modulesManager, _filtersBase2);
              }
            case 206:
              _context.next = 368;
              break;
            case 208:
              if (!(getUserTypeFromRights(userRights) === WORKFORCE_USER_TYPE.DIRECTOR)) {
                _context.next = 222;
                break;
              }
              _this.setState({
                displayVersion: showHistoryFilter
              });
              if (!_this.props.summaryId) {
                _context.next = 219;
                break;
              }
              _filtersBase3 = ['statusIn: ["forward_to_director","approved_by_director","approved_by_dg"]', 'organizationTypeIn: ["cf"]', 'orderBy: ["-dateCreated"]'];
              _cfFilters = [].concat(_filtersBase3, ["cfApplicationSummary_Id: \"".concat(safeDecodeId(_this.props.summaryId), "\"")]);
              _context.next = 215;
              return Promise.all([_this.props.fetchApplicationsSummary(_this.props.modulesManager, _cfFilters)]);
            case 215:
              _yield$Promise$all3 = _context.sent;
              _slicedToArray(_yield$Promise$all3, 0);
              _context.next = 220;
              break;
            case 219:
              if (_this.props.returnedApplications) {
                _filtersBase4 = ['statusIn: ["revert"]', 'organizationTypeIn: ["cf"]', 'orderBy: ["-dateCreated"]'];
                if (loggedInUserId) {
                  _filtersBase4.push("applicationFrom:\"".concat(loggedInUserId, "\""));
                }
                _this.props.fetchApplicationsSummary(_this.props.modulesManager, _filtersBase4);
              }
            case 220:
              _context.next = 368;
              break;
            case 222:
              if (!(getUserTypeFromRights(userRights) === WORKFORCE_USER_TYPE.BLWF_DIRECTOR)) {
                _context.next = 236;
                break;
              }
              _this.setState({
                displayVersion: showHistoryFilter
              });
              if (!_this.props.summaryId) {
                _context.next = 233;
                break;
              }
              _filtersBase5 = ['statusIn: ["forward_to_director","approved_by_director","approved_by_dg"]', 'organizationTypeIn: ["blwf"]', 'orderBy: ["-dateCreated"]'];
              _blwfFilters = [].concat(_filtersBase5, ["blwfApplicationSummary_Id: \"".concat(safeDecodeId(_this.props.summaryId), "\"")]);
              _context.next = 229;
              return Promise.all([_this.props.fetchApplicationsSummary(_this.props.modulesManager, _blwfFilters)]);
            case 229:
              _yield$Promise$all5 = _context.sent;
              _slicedToArray(_yield$Promise$all5, 0);
              _context.next = 234;
              break;
            case 233:
              if (_this.props.returnedApplications) {
                _filtersBase6 = ['statusIn: ["revert"]', 'organizationTypeIn: ["cf"]', 'orderBy: ["-dateCreated"]'];
                if (loggedInUserId) {
                  _filtersBase6.push("applicationFrom:\"".concat(loggedInUserId, "\""));
                }
                _this.props.fetchApplicationsSummary(_this.props.modulesManager, _filtersBase6);
              }
            case 234:
              _context.next = 368;
              break;
            case 236:
              if (!(getUserTypeFromRights(userRights) === WORKFORCE_USER_TYPE.EIS_COORDINATOR)) {
                _context.next = 252;
                break;
              }
              _this.setState({
                displayVersion: showHistoryFilter
              });
              _defaultStatusFilters13 = [];
              _additionalFilters3 = [];
              _summaryId3 = _this.props.summaryId ? decodeId(_this.props.summaryId) : null;
              if (rejectedApplication) {
                _defaultStatusFilters13.push('statusIn: ["rejected"]', 'applicationTypeIn: ["disabilityAssistance","financialAssistance"]', 'organizationTypeIn: ["eis"]');
              } else if (revertedApplication) {
                _defaultStatusFilters13.push(
                // 'applicationTypeIn: ["disabilityAssistance","financialAssistance"]','organizationTypeIn: ["eis"]'
                'statusIn: ["revert"],  applicationTypeIn: ["disabilityAssistance","financialAssistance"]', 'organizationTypeIn: ["eis"]');
                if (loggedInUserId) {
                  _defaultStatusFilters13.push("applicationTo: \"".concat(loggedInUserId, "\""));
                }
              } else if (_this.props.sentForVerificationApplications) {
                _defaultStatusFilters13.push('statusIn: ["forward_for_verification","forward_to_doctor"]', 'applicationTypeIn: ["disabilityAssistance","financialAssistance"]', 'organizationTypeIn: ["eis"]');
              } else if (_this.props.verifiedApplications) {
                _defaultStatusFilters13.push('statusIn: ["approved_by_doctor","verified"]', 'applicationTypeIn: ["disabilityAssistance","financialAssistance"]', 'organizationTypeIn: ["eis"]');
              } else if (_summaryId3) {
                _defaultStatusFilters13.push('applicationTypeIn: ["disabilityAssistance","financialAssistance"]');
                _additionalFilters3.push("eisApplicationSummary_Id:\"".concat(_summaryId3, "\""));
              } else {
                _defaultStatusFilters13.push('statusIn: ["forward_to_eis_coordinator"]', 'applicationTypeIn: ["disabilityAssistance","financialAssistance"]', 'organizationTypeIn: ["eis"]');
                if (loggedInUserId) {
                  _defaultStatusFilters13.push("applicationTo: \"".concat(loggedInUserId, "\""));
                }
              }
              _orderByFilter13 = 'orderBy: ["-dateCreated"]';
              _nidFilters3 = _this.props.nidFilters || [];
              _finalFilters9 = [];
              if (_nidFilters3.length) {
                _finalFilters9 = _toConsumableArray(_nidFilters3);
                if (!_finalFilters9.some(function (f) {
                  return f.includes("orderBy");
                })) {
                  _finalFilters9.push(_orderByFilter13);
                }
                if (_summaryId3 && !_finalFilters9.some(function (f) {
                  return f.includes("eisApplicationSummary_Id");
                })) {
                  _finalFilters9.push("eisApplicationSummary_Id:\"".concat(_summaryId3, "\""));
                }
              } else if (prms !== null && prms !== void 0 && prms.length) {
                _finalFilters9 = _toConsumableArray(prms);
                _hasStatusIn9 = _finalFilters9.some(function (f) {
                  return f.includes("statusIn");
                });
                _hasOrderBy9 = _finalFilters9.some(function (f) {
                  return f.includes("orderBy");
                });
                _hasApplicationTypeIn = _finalFilters9.some(function (f) {
                  return f.includes("applicationTypeIn");
                });
                hasAssociationTypeIn = _finalFilters9.some(function (f) {
                  return f.includes("associationTypeIn");
                });
                if (!_hasStatusIn9) {
                  _finalFilters9 = [].concat(_toConsumableArray(_defaultStatusFilters13.filter(function (f) {
                    return f.includes("statusIn");
                  })), _toConsumableArray(_finalFilters9));
                }
                if (!_hasApplicationTypeIn) {
                  _finalFilters9 = [].concat(_toConsumableArray(_defaultStatusFilters13.filter(function (f) {
                    return f.includes("applicationTypeIn");
                  })), _toConsumableArray(_finalFilters9));
                }
                if (!hasAssociationTypeIn) {
                  _finalFilters9 = [].concat(_toConsumableArray(_defaultStatusFilters13.filter(function (f) {
                    return f.includes("associationTypeIn");
                  })), _toConsumableArray(_finalFilters9));
                }
                if (!_finalFilters9.some(function (f) {
                  return f.includes("organizationTypeIn");
                })) {
                  _finalFilters9 = [].concat(_toConsumableArray(_defaultStatusFilters13.filter(function (f) {
                    return f.includes("organizationTypeIn");
                  })), _toConsumableArray(_finalFilters9));
                }
                if (!_hasOrderBy9) _finalFilters9.push(_orderByFilter13);
                if (_summaryId3 && !_finalFilters9.some(function (f) {
                  return f.includes("eisApplicationSummary_Id");
                })) {
                  _finalFilters9.push("eisApplicationSummary_Id:\"".concat(_summaryId3, "\""));
                }
              } else {
                _finalFilters9 = [].concat(_defaultStatusFilters13, _additionalFilters3, [_orderByFilter13]);
              }
              if (startDate) _finalFilters9.push("dateCreatedFrom: \"".concat(startDate, "\""));
              if (endDate) _finalFilters9.push("dateCreatedTo: \"".concat(endDate, "\""));

              // Final safety: remove duplicates by argument name
              _finalFilters9 = _finalFilters9.filter(function (f, i, arr) {
                return i === arr.findIndex(function (x) {
                  if (x.includes("applicationTypeIn") && f.includes("applicationTypeIn")) return true;
                  if (x.includes("statusIn") && f.includes("statusIn")) return true;
                  if (x.includes("orderBy") && f.includes("orderBy")) return true;
                  if (x.includes("organizationTypeIn") && f.includes("organizationTypeIn")) return true;
                  if (x.includes("associationTypeIn") && f.includes("associationTypeIn")) return true;
                  if (x.includes("dateCreatedFrom") && f.includes("dateCreatedFrom")) return true;
                  if (x.includes("dateCreatedTo") && f.includes("dateCreatedTo")) return true;
                  return x === f;
                });
              });
              _this.props.fetchApplicationsSummary(_this.props.modulesManager, _finalFilters9);
              _context.next = 368;
              break;
            case 252:
              if (!(getUserTypeFromRights(userRights) === WORKFORCE_USER_TYPE.EIS_COMMITTEE || getUserTypeFromRights(userRights) === WORKFORCE_USER_TYPE.EIS_ASSOCIATION_COMMITTEE)) {
                _context.next = 269;
                break;
              }
              _this.setState({
                displayVersion: showHistoryFilter
              });
              _defaultStatusFilters14 = [];
              _additionalFilters4 = [];
              _defaultStatusFilters14.push('applicationTypeIn: ["disabilityAssistance","financialAssistance"]');
              _summaryId4 = _this.props.summaryId ? decodeId(_this.props.summaryId) : null;
              if (_summaryId4) {
                _additionalFilters4.push("eisApplicationSummary_Id:\"".concat(_summaryId4, "\""));
              }
              _orderByFilter14 = 'orderBy: ["-dateCreated"]';
              _nidFilters4 = _this.props.nidFilters || [];
              _finalFilters10 = [];
              if (_nidFilters4.length) {
                _finalFilters10 = _toConsumableArray(_nidFilters4);
                if (!_finalFilters10.some(function (f) {
                  return f.includes("orderBy");
                })) {
                  _finalFilters10.push(_orderByFilter14);
                }
                if (_summaryId4 && !_finalFilters10.some(function (f) {
                  return f.includes("eisApplicationSummary_Id");
                })) {
                  _finalFilters10.push("eisApplicationSummary_Id:\"".concat(_summaryId4, "\""));
                }
              } else if (prms !== null && prms !== void 0 && prms.length) {
                _finalFilters10 = _toConsumableArray(prms);
                _hasStatusIn10 = _finalFilters10.some(function (f) {
                  return f.includes("statusIn");
                });
                _hasOrderBy10 = _finalFilters10.some(function (f) {
                  return f.includes("orderBy");
                });
                _hasApplicationTypeIn2 = _finalFilters10.some(function (f) {
                  return f.includes("applicationTypeIn");
                });
                _hasAssociationTypeIn = _finalFilters10.some(function (f) {
                  return f.includes("associationTypeIn");
                });
                if (!_hasStatusIn10) {
                  _finalFilters10 = [].concat(_toConsumableArray(_defaultStatusFilters14.filter(function (f) {
                    return f.includes("statusIn");
                  })), _toConsumableArray(_finalFilters10));
                }
                if (!_hasApplicationTypeIn2) {
                  _finalFilters10 = [].concat(_toConsumableArray(_defaultStatusFilters14.filter(function (f) {
                    return f.includes("applicationTypeIn");
                  })), _toConsumableArray(_finalFilters10));
                }
                if (!_hasAssociationTypeIn) {
                  _finalFilters10 = [].concat(_toConsumableArray(_defaultStatusFilters14.filter(function (f) {
                    return f.includes("associationTypeIn");
                  })), _toConsumableArray(_finalFilters10));
                }
                if (!_finalFilters10.some(function (f) {
                  return f.includes("organizationTypeIn");
                })) {
                  _finalFilters10 = [].concat(_toConsumableArray(_defaultStatusFilters14.filter(function (f) {
                    return f.includes("organizationTypeIn");
                  })), _toConsumableArray(_finalFilters10));
                }
                if (!_hasOrderBy10) _finalFilters10.push(_orderByFilter14);
                if (_summaryId4 && !_finalFilters10.some(function (f) {
                  return f.includes("eisApplicationSummary_Id");
                })) {
                  _finalFilters10.push("eisApplicationSummary_Id:\"".concat(_summaryId4, "\""));
                }
              } else {
                _finalFilters10 = [].concat(_defaultStatusFilters14, _additionalFilters4, [_orderByFilter14]);
              }
              if (startDate) _finalFilters10.push("dateCreatedFrom: \"".concat(startDate, "\""));
              if (endDate) _finalFilters10.push("dateCreatedTo: \"".concat(endDate, "\""));

              // Final safety: remove duplicates by argument name
              _finalFilters10 = _finalFilters10.filter(function (f, i, arr) {
                return i === arr.findIndex(function (x) {
                  if (x.includes("applicationTypeIn") && f.includes("applicationTypeIn")) return true;
                  if (x.includes("statusIn") && f.includes("statusIn")) return true;
                  if (x.includes("orderBy") && f.includes("orderBy")) return true;
                  if (x.includes("organizationTypeIn") && f.includes("organizationTypeIn")) return true;
                  if (x.includes("associationTypeIn") && f.includes("associationTypeIn")) return true;
                  if (x.includes("dateCreatedFrom") && f.includes("dateCreatedFrom")) return true;
                  if (x.includes("dateCreatedTo") && f.includes("dateCreatedTo")) return true;
                  return x === f;
                });
              });
              _this.props.fetchApplicationsSummary(_this.props.modulesManager, _finalFilters10);
              _context.next = 368;
              break;
            case 269:
              if (!(getUserTypeFromRights(userRights) === WORKFORCE_USER_TYPE.EIS_OFFICER)) {
                _context.next = 283;
                break;
              }
              _this.setState({
                displayVersion: showHistoryFilter
              });
              _defaultStatusFilters15 = [];
              if (_this.props.filedApplications) {
                _defaultStatusFilters15.push('statusIn: ["forward_for_verification"]', 'applicationTypeIn: ["disabilityAssistance","financialAssistance"]', 'organizationTypeIn: ["eis"]'
                // 'associationTypeIn: ["BEPZA","LFMEAB"]'
                );
                if (loggedInUserId) {
                  console.log("loggedin user id", loggedInUserId);
                  _defaultStatusFilters15.push("applicationTo: \"".concat(loggedInUserId, "\""));
                }
              } else if (_this.props.forwardedApplications) {
                _defaultStatusFilters15.push('statusIn: ["verified"]', 'applicationTypeIn: ["disabilityAssistance","financialAssistance"]', 'organizationTypeIn: ["eis"]'
                // 'associationTypeIn: ["BEPZA","LFMEAB"]'
                );
                if (loggedInUserId) _defaultStatusFilters15.push("applicationFrom: \"".concat(loggedInUserId, "\""));
              } else if (revertedApplication) {
                _defaultStatusFilters15.push('statusIn: ["revert"]', 'applicationTypeIn: ["disabilityAssistance","financialAssistance"]', 'organizationTypeIn: ["eis"]'
                // 'associationTypeIn: ["BEPZA","LFMEAB"]'
                );
                if (loggedInUserId) _defaultStatusFilters15.push("applicationTo: \"".concat(loggedInUserId, "\""));
              } else if (_this.props.returnedApplications) {
                _defaultStatusFilters15.push('statusIn: ["revert"]', 'applicationTypeIn: ["disabilityAssistance","financialAssistance"]', 'organizationTypeIn: ["eis"]'
                // 'associationTypeIn: ["BEPZA","LFMEAB"]'
                );
                if (loggedInUserId) _defaultStatusFilters15.push("applicationFrom: \"".concat(loggedInUserId, "\""));
              } else {
                _defaultStatusFilters15.push('statusIn: ["forward_to_eis_officer"]', 'applicationTypeIn: ["disabilityAssistance","financialAssistance"]', 'organizationTypeIn: ["eis"]'
                // 'associationTypeIn: ["BEPZA","LFMEAB"]'
                );
                if (loggedInUserId) _defaultStatusFilters15.push("applicationTo: \"".concat(loggedInUserId, "\""));
              }
              _orderByFilter15 = 'orderBy: ["-dateCreated"]';
              _finalFilters11 = [];
              if (prms !== null && prms !== void 0 && prms.length) {
                _finalFilters11 = _toConsumableArray(prms);
                _hasStatusIn11 = _finalFilters11.some(function (f) {
                  return f.includes("statusIn");
                });
                _hasOrderBy11 = _finalFilters11.some(function (f) {
                  return f.includes("orderBy");
                });
                _hasApplicationTypeIn3 = _finalFilters11.some(function (f) {
                  return f.includes("applicationTypeIn");
                });
                _hasAssociationTypeIn2 = _finalFilters11.some(function (f) {
                  return f.includes("associationTypeIn");
                });
                _hasApplicationTo3 = _finalFilters11.some(function (f) {
                  return f.includes("applicationTo");
                });
                _hasApplicationFrom = _finalFilters11.some(function (f) {
                  return f.includes("applicationFrom");
                });
                if (!_hasStatusIn11) _finalFilters11 = [].concat(_toConsumableArray(_defaultStatusFilters15.filter(function (f) {
                  return f.includes("statusIn");
                })), _toConsumableArray(_finalFilters11));
                if (!_hasApplicationTypeIn3) _finalFilters11 = [].concat(_toConsumableArray(_defaultStatusFilters15.filter(function (f) {
                  return f.includes("applicationTypeIn");
                })), _toConsumableArray(_finalFilters11));
                if (!_hasAssociationTypeIn2) _finalFilters11 = [].concat(_toConsumableArray(_defaultStatusFilters15.filter(function (f) {
                  return f.includes("associationTypeIn");
                })), _toConsumableArray(_finalFilters11));
                if (!_finalFilters11.some(function (f) {
                  return f.includes("organizationTypeIn");
                })) _finalFilters11 = [].concat(_toConsumableArray(_defaultStatusFilters15.filter(function (f) {
                  return f.includes("organizationTypeIn");
                })), _toConsumableArray(_finalFilters11));
                if (!_hasApplicationTo3) _finalFilters11 = [].concat(_toConsumableArray(_defaultStatusFilters15.filter(function (f) {
                  return f.includes("applicationTo");
                })), _toConsumableArray(_finalFilters11));
                if (!_hasApplicationFrom) _finalFilters11 = [].concat(_toConsumableArray(_defaultStatusFilters15.filter(function (f) {
                  return f.includes("applicationFrom");
                })), _toConsumableArray(_finalFilters11));
                if (!_hasOrderBy11) _finalFilters11.push(_orderByFilter15);
              } else {
                _finalFilters11 = [].concat(_defaultStatusFilters15, [_orderByFilter15]);
              }
              if (startDate) _finalFilters11.push("dateCreatedFrom: \"".concat(startDate, "\""));
              if (endDate) _finalFilters11.push("dateCreatedTo: \"".concat(endDate, "\""));
              _finalFilters11 = _finalFilters11.filter(function (f, i, arr) {
                return i === arr.findIndex(function (x) {
                  if (x.includes("applicationTypeIn") && f.includes("applicationTypeIn")) return true;
                  if (x.includes("statusIn") && f.includes("statusIn")) return true;
                  if (x.includes("orderBy") && f.includes("orderBy")) return true;
                  if (x.includes("organizationTypeIn") && f.includes("organizationTypeIn")) return true;
                  if (x.includes("associationTypeIn") && f.includes("associationTypeIn")) return true;
                  if (x.includes("dateCreatedFrom") && f.includes("dateCreatedFrom")) return true;
                  if (x.includes("dateCreatedTo") && f.includes("dateCreatedTo")) return true;
                  return x === f;
                });
              });
              console.log("finalFilters", _finalFilters11);
              _this.props.fetchApplicationsSummary(_this.props.modulesManager, _finalFilters11);
              _context.next = 368;
              break;
            case 283:
              if (![WORKFORCE_USER_TYPE.EIS_ADVISOR, WORKFORCE_USER_TYPE.EIS_DOCTOR].includes(getUserTypeFromRights(userRights))) {
                _context.next = 303;
                break;
              }
              _this.setState({
                displayVersion: showHistoryFilter
              });
              _summaryId5 = _this.props.summaryId ? decodeId(_this.props.summaryId) : null;
              _defaultStatusFilters16 = [];
              _additionalFilters5 = [];
              userType = getUserTypeFromRights(userRights);
              if (userType === WORKFORCE_USER_TYPE.EIS_ADVISOR) {
                _defaultStatusFilters16.push('statusIn: ["forward_to_eis_advisor","approved_by_eis_director"]');
              } else if (userType === WORKFORCE_USER_TYPE.EIS_DOCTOR) {
                // defaultStatusFilters.push('statusIn: ["approved_by_doctor"]');
                if (_this.props.filedMeetingSheet) {
                  _defaultStatusFilters16.push('statusIn: ["forward_to_doctor"]');
                  if (loggedInUserId) _defaultStatusFilters16.push("applicationTo: \"".concat(loggedInUserId, "\""));
                } else if (_this.props.forwardedApplications) {
                  // defaultStatusFilters.push('statusIn: ["approved_by_doctor"]');
                  _defaultStatusFilters16.push("applicationFrom:\"".concat((_this$props3 = _this.props) === null || _this$props3 === void 0 || (_this$props3 = _this$props3.i_user) === null || _this$props3 === void 0 ? void 0 : _this$props3.id, "\""));
                } else if (_this.props.returnedApplications) {
                  _defaultStatusFilters16.push('statusIn: ["revert"]');
                  if (loggedInUserId) _defaultStatusFilters16.push("applicationFrom: \"".concat(loggedInUserId, "\""));
                }
              }
              _defaultStatusFilters16.push('applicationTypeIn: ["disabilityAssistance","financialAssistance"]');
              _defaultStatusFilters16.push('organizationTypeIn: ["eis"]');
              _orderByFilter16 = 'orderBy: ["-dateCreated"]';
              if (_summaryId5) {
                console.log("summaryId", _summaryId5);
                _additionalFilters5.push("eisApplicationSummary_Id:\"".concat(_summaryId5, "\""));
              }
              _nidFilters5 = _this.props.nidFilters || [];
              _finalFilters12 = [];
              if (_nidFilters5.length) {
                _finalFilters12 = _toConsumableArray(_nidFilters5);
                if (!_finalFilters12.some(function (f) {
                  return f.includes("orderBy");
                })) {
                  _finalFilters12.push(_orderByFilter16);
                }
                if (_summaryId5 && !_finalFilters12.some(function (f) {
                  return f.includes("eisApplicationSummary_Id");
                })) {
                  _finalFilters12.push("eisApplicationSummary_Id:\"".concat(_summaryId5, "\""));
                }
              } else if (prms !== null && prms !== void 0 && prms.length) {
                _finalFilters12 = _toConsumableArray(prms);
                _hasStatusIn12 = _finalFilters12.some(function (f) {
                  return f.includes("statusIn");
                });
                _hasOrderBy12 = _finalFilters12.some(function (f) {
                  return f.includes("orderBy");
                });
                _hasApplicationTypeIn4 = _finalFilters12.some(function (f) {
                  return f.includes("applicationTypeIn");
                });
                _hasOrganizationTypeIn = _finalFilters12.some(function (f) {
                  return f.includes("organizationTypeIn");
                });
                if (!_hasStatusIn12) {
                  _finalFilters12 = [].concat(_toConsumableArray(_defaultStatusFilters16.filter(function (f) {
                    return f.includes("statusIn");
                  })), _toConsumableArray(_finalFilters12));
                }
                if (!_hasApplicationTypeIn4) {
                  _finalFilters12 = [].concat(_toConsumableArray(_defaultStatusFilters16.filter(function (f) {
                    return f.includes("applicationTypeIn");
                  })), _toConsumableArray(_finalFilters12));
                }
                if (!_hasOrganizationTypeIn) {
                  _finalFilters12 = [].concat(_toConsumableArray(_defaultStatusFilters16.filter(function (f) {
                    return f.includes("organizationTypeIn");
                  })), _toConsumableArray(_finalFilters12));
                }
                if (!_hasOrderBy12) _finalFilters12.push(_orderByFilter16);
                if (_summaryId5 && !_finalFilters12.some(function (f) {
                  return f.includes("eisApplicationSummary_Id");
                })) {
                  _finalFilters12.push("eisApplicationSummary_Id:\"".concat(_summaryId5, "\""));
                }
                _hasApplicationFrom2 = _finalFilters12.some(function (f) {
                  return f.includes("applicationFrom");
                });
                if (!_hasApplicationFrom2) {
                  _finalFilters12 = [].concat(_toConsumableArray(_defaultStatusFilters16.filter(function (f) {
                    return f.includes("applicationFrom");
                  })), _toConsumableArray(_finalFilters12));
                }
              } else {
                _finalFilters12 = [].concat(_defaultStatusFilters16, _additionalFilters5, [_orderByFilter16]);
              }
              if (startDate) _finalFilters12.push("dateCreatedFrom: \"".concat(startDate, "\""));
              if (endDate) _finalFilters12.push("dateCreatedTo: \"".concat(endDate, "\""));
              _finalFilters12 = _finalFilters12.filter(function (f, i, arr) {
                return i === arr.findIndex(function (x) {
                  if (x.includes("statusIn") && f.includes("statusIn")) return true;
                  if (x.includes("applicationTypeIn") && f.includes("applicationTypeIn")) return true;
                  if (x.includes("organizationTypeIn") && f.includes("organizationTypeIn")) return true;
                  if (x.includes("orderBy") && f.includes("orderBy")) return true;
                  if (x.includes("dateCreatedFrom") && f.includes("dateCreatedFrom")) return true;
                  if (x.includes("dateCreatedTo") && f.includes("dateCreatedTo")) return true;
                  return x === f;
                });
              });
              _this.props.fetchApplicationsSummary(_this.props.modulesManager, _finalFilters12);
              // ---------------- DOCTOR / BLWF_DOCTOR ----------------
              _context.next = 368;
              break;
            case 303:
              if (!(getUserTypeFromRights(userRights) === WORKFORCE_USER_TYPE.DOCTOR || getUserTypeFromRights(userRights) === WORKFORCE_USER_TYPE.BLWF_DOCTOR)) {
                _context.next = 313;
                break;
              }
              _this.setState({
                displayVersion: showHistoryFilter
              });
              _summaryId6 = _this.props.summaryId ? decodeId(_this.props.summaryId) : null;
              _defaultStatusFilters17 = [];
              if (_this.props.returnedApplications) {
                _defaultStatusFilters17 = ['statusIn: ["revert"]'];
                if (loggedInUserId) _defaultStatusFilters17.push("applicationFrom: \"".concat(loggedInUserId, "\""));
              } else if (_this.props.revertedApplications) {
                _defaultStatusFilters17 = ['statusIn: ["revert"]'];
                if (loggedInUserId) _defaultStatusFilters17.push("applicationTo: \"".concat(loggedInUserId, "\""));
              } else if (_this.props.forwardedApplications) {
                // defaultStatusFilters = ['statusIn: ["approved_by_doctor"]'];
                _defaultStatusFilters17.push("applicationFrom:\"".concat((_this$props4 = _this.props) === null || _this$props4 === void 0 || (_this$props4 = _this$props4.i_user) === null || _this$props4 === void 0 ? void 0 : _this$props4.id, "\""));
              } else if (loggedInUserId) {
                _defaultStatusFilters17 = ['statusIn: ["forward_to_doctor"]'];
                _defaultStatusFilters17.push("applicationTo: \"".concat(loggedInUserId, "\""));
              }
              if (_summaryId6) {
                console.log("summaryId", _summaryId6);
                if (isBlwfPath()) {
                  _defaultStatusFilters17.push("blwfApplicationSummary_Id:\"".concat(_summaryId6, "\""));
                } else {
                  _defaultStatusFilters17.push("cfApplicationSummary_Id:\"".concat(_summaryId6, "\""));
                }
              }
              organizationType = getUserTypeFromRights(userRights) === WORKFORCE_USER_TYPE.BLWF_DOCTOR ? "blwf" : "cf";
              _this.props.fetchApplicationsSummary(_this.props.modulesManager, _defaultStatusFilters17, ["organizationTypeIn: [\"".concat(organizationType, "\"]"), 'orderBy: ["-dateCreated"]']);
              _context.next = 368;
              break;
            case 313:
              if (!(getUserTypeFromRights(userRights) === WORKFORCE_USER_TYPE.BLWF_ACCOUNTANT)) {
                _context.next = 326;
                break;
              }
              _this.setState({
                displayVersion: showHistoryFilter
              });
              _defaultStatusFilters18 = [];
              _additionalFilters6 = [];
              _summaryId7 = _this.props.summaryId ? decodeId(_this.props.summaryId) : null;
              if (rejectedApplication) {
                _defaultStatusFilters18.push('statusIn: ["rejected"]', 'organizationTypeIn: ["blwf"]');
              } else if (_summaryId7) {
                _defaultStatusFilters18.push('statusIn: ["forward_to_blwf_section","meeting_created","approved_by_dg"]', 'organizationTypeIn: ["blwf"]');
                _additionalFilters6.push("blwfApplicationSummary_Id:\"".concat(_summaryId7, "\""));
              } else if (_this.props.verifiedApplications) {
                _defaultStatusFilters18.push('statusIn: ["approved_by_doctor","verified"]', 'organizationTypeIn: ["blwf"]');
              } else {
                _defaultStatusFilters18.push('statusIn: ["verified_by_dol_dife"]', 'organizationTypeIn: ["blwf"]');
              }
              _orderByFilter17 = 'orderBy: ["-dateCreated"]';
              _nidFilters6 = _this.props.nidFilters || [];
              _finalFilters13 = [];
              if (_nidFilters6.length) {
                _finalFilters13 = _toConsumableArray(_nidFilters6);
                if (!_finalFilters13.some(function (f) {
                  return f.includes("orderBy");
                })) {
                  _finalFilters13.push(_orderByFilter17);
                }
                if (_summaryId7 && !_finalFilters13.some(function (f) {
                  return f.includes("blwfApplicationSummary_Id");
                })) {
                  _finalFilters13.push("blwfApplicationSummary_Id:\"".concat(_summaryId7, "\""));
                }
              } else if (prms !== null && prms !== void 0 && prms.length) {
                _finalFilters13 = _toConsumableArray(prms);
                _hasStatusIn13 = _finalFilters13.some(function (f) {
                  return f.includes("statusIn");
                });
                _hasOrderBy13 = _finalFilters13.some(function (f) {
                  return f.includes("orderBy");
                });
                if (!_hasStatusIn13) {
                  _finalFilters13 = [].concat(_defaultStatusFilters18, _toConsumableArray(_finalFilters13));
                }
                if (!_hasOrderBy13) _finalFilters13.push(_orderByFilter17);
                if (_summaryId7 && !_finalFilters13.some(function (f) {
                  return f.includes("blwfApplicationSummary_Id");
                })) {
                  _finalFilters13.push("blwfApplicationSummary_Id:\"".concat(_summaryId7, "\""));
                }
              } else {
                _finalFilters13 = [].concat(_defaultStatusFilters18, _additionalFilters6, [_orderByFilter17]);
              }
              _this.props.fetchApplicationsSummary(_this.props.modulesManager, _finalFilters13);
              _context.next = 368;
              break;
            case 326:
              if (!(getUserTypeFromRights(userRights) === WORKFORCE_USER_TYPE.SECRETARY)) {
                _context.next = 348;
                break;
              }
              _this.setState({
                displayVersion: showHistoryFilter
              });
              if (!_this.props.summaryId) {
                _context.next = 338;
                break;
              }
              _filtersBase7 = ['statusIn: ["forward_to_director","approved_by_director","approved_by_dg","approved_by_secretary"]', 'organizationTypeIn: ["cf","blwf"]', 'orderBy: ["-dateCreated"]'];
              _cfFilters2 = [].concat(_filtersBase7, ["cfApplicationSummary_Id: \"".concat(decodeId(_this.props.summaryId), "\"")]);
              _blwfFilters2 = [].concat(_filtersBase7, ["blwfApplicationSummary_Id: \"".concat(decodeId(_this.props.summaryId), "\"")]);
              _context.next = 334;
              return Promise.all([_this.props.fetchApplicationsSummary(_this.props.modulesManager, _cfFilters2), _this.props.fetchApplicationsSummary(_this.props.modulesManager, _blwfFilters2)]);
            case 334:
              _yield$Promise$all7 = _context.sent;
              _slicedToArray(_yield$Promise$all7, 0);
              _context.next = 346;
              break;
            case 338:
              if (!rejectedApplication) {
                _context.next = 345;
                break;
              }
              _filtersBase8 = ['statusIn: ["rejected_by_dg"]', 'orderBy: ["-dateCreated"]'];
              if (loggedInUserId) {
                _filtersBase8.push("applicationTo:\"".concat(loggedInUserId, "\""));
              }
              _context.next = 343;
              return _this.props.fetchApplicationsSummary(_this.props.modulesManager, _filtersBase8);
            case 343:
              _context.next = 346;
              break;
            case 345:
              if (_this.props.returnedApplications) {
                _filtersBase9 = ['statusIn: ["revert"]', 'orderBy: ["-dateCreated"]'];
                if (loggedInUserId) {
                  _filtersBase9.push("applicationFrom:\"".concat(loggedInUserId, "\""));
                }
                _this.props.fetchApplicationsSummary(_this.props.modulesManager, _filtersBase9);
              }
            case 346:
              _context.next = 368;
              break;
            case 348:
              if (!(getUserTypeFromRights(userRights) === WORKFORCE_USER_TYPE.MINISTER)) {
                _context.next = 368;
                break;
              }
              _this.setState({
                displayVersion: showHistoryFilter
              });
              if (!_this.props.summaryId) {
                _context.next = 360;
                break;
              }
              _filtersBase10 = ['statusIn: ["forward_to_director","approved_by_director","approved_by_secretary"]', 'organizationTypeIn: ["cf","blwf"]', 'orderBy: ["-dateCreated"]'];
              _cfFilters3 = [].concat(_filtersBase10, ["cfApplicationSummary_Id: \"".concat(decodeId(_this.props.summaryId), "\"")]);
              _blwfFilters3 = [].concat(_filtersBase10, ["blwfApplicationSummary_Id: \"".concat(decodeId(_this.props.summaryId), "\"")]);
              _context.next = 356;
              return Promise.all([_this.props.fetchApplicationsSummary(_this.props.modulesManager, _cfFilters3), _this.props.fetchApplicationsSummary(_this.props.modulesManager, _blwfFilters3)]);
            case 356:
              _yield$Promise$all9 = _context.sent;
              _slicedToArray(_yield$Promise$all9, 0);
              _context.next = 368;
              break;
            case 360:
              if (!rejectedApplication) {
                _context.next = 367;
                break;
              }
              _filtersBase11 = ['statusIn: ["rejected_by_dg"]', 'orderBy: ["-dateCreated"]'];
              if (loggedInUserId) {
                _filtersBase11.push("applicationTo:\"".concat(loggedInUserId, "\""));
              }
              _context.next = 365;
              return _this.props.fetchApplicationsSummary(_this.props.modulesManager, _filtersBase11);
            case 365:
              _context.next = 368;
              break;
            case 367:
              if (_this.props.returnedApplications) {
                _filtersBase12 = ['statusIn: ["revert"]', 'orderBy: ["-dateCreated"]'];
                if (loggedInUserId) {
                  _filtersBase12.push("applicationFrom:\"".concat(loggedInUserId, "\""));
                }
                _this.props.fetchApplicationsSummary(_this.props.modulesManager, _filtersBase12);
              }
            case 368:
              _this.props.fetchRoles(loggedInUserId);
            case 369:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
    _defineProperty(_this, "rowIdentifier", function (r) {
      return r.id;
    });
    _defineProperty(_this, "isShowHistory", function () {
      return _this.state.displayVersion;
    });
    _defineProperty(_this, "filtersToQueryParams", function (state) {
      var prms = Object.keys(state.filters).filter(function (f) {
        return !!state.filters[f].filter;
      }).map(function (f) {
        return state.filters[f].filter;
      });
      prms.push("first: ".concat(state.pageSize));
      if (state.afterCursor) {
        prms.push("after: \"".concat(state.afterCursor, "\""));
      }
      if (state.beforeCursor) {
        prms.push("before: \"".concat(state.beforeCursor, "\""));
      }
      if (state.orderBy) {
        prms.push("orderBy: [\"".concat(state.orderBy, "\"]"));
      }
      return prms;
    });
    _defineProperty(_this, "handleOpenForwardModal", function (application) {
      _this.setState({
        forwardModalOpen: true,
        selectedApplication: application
      });
    });
    _defineProperty(_this, "handleOpenForwardPaymentModal", function (application) {
      _this.setState({
        forwardPaymentModalOpen: true,
        selectedApplication: application
      });
    });
    _defineProperty(_this, "handleOpenForwardModalForSectionAdmin", function (application) {
      _this.setState({
        forwardModalOpenSA: true,
        selectedApplication: application
      });
    });
    _defineProperty(_this, "handleOpenForwardModalForEIS", function (application) {
      _this.setState({
        forwardModalOpenEIS: true,
        selectedApplication: application
      });
    });
    _defineProperty(_this, "handleOpenForwardModalForEISToCommittee", function (application) {
      _this.setState({
        forwardModalOpenEISToCoordinator: true,
        selectedApplication: application
      });
    });
    _defineProperty(_this, "handleCloseForwardModalForSectionAdmin", function () {
      _this.setState({
        forwardModalOpenSA: false,
        selectedApplication: null
      });
    });
    _defineProperty(_this, "handleCloseForwardModalForSummarySectionAdmin", function () {
      _this.setState({
        forwardModalOpenSummarySA: false,
        selectedApplication: null
      });
    });
    _defineProperty(_this, "handleCloseForwardModalForFA", function () {
      _this.setState({
        forwardModalOpenFA: false,
        selectedApplication: null
      });
    });
    _defineProperty(_this, "handleCloseForwardModalForEisAdvisor", function () {
      _this.setState({
        forwardModalOpenSA: false,
        selectedApplication: null
      });
    });
    _defineProperty(_this, "handleCloseForwardModalForEisCoordinator", function () {
      _this.setState({
        forwardModalOpenEIS: false,
        selectedApplication: null
      });
    });
    _defineProperty(_this, "handleCloseForwardModalForEisCoordinatorToCommittee", function () {
      _this.setState({
        forwardModalOpenEISToCoordinator: false,
        selectedApplication: null
      });
    });
    _defineProperty(_this, "handleCloseForwardModalForEisDoctor", function () {
      _this.setState({
        forwardModalOpenEisDoctor: false,
        selectedApplication: null
      });
    });
    _defineProperty(_this, "handleCloseForwardModal", function () {
      _this.setState({
        forwardModalOpen: false,
        selectedApplication: null
      });
    });
    _defineProperty(_this, "handleCloseForwardPaymentModal", function () {
      _this.setState({
        forwardPaymentModalOpen: false,
        selectedApplication: null
      });
    });
    _defineProperty(_this, "handleOpenRevertModal", function (application) {
      _this.setState({
        revertModalOpen: true,
        selectedApplication: application
      });
    });
    _defineProperty(_this, "handleCloseRevertModal", function () {
      _this.setState({
        revertModalOpen: false,
        revertByChecker: false,
        revertByApprover: false,
        revertByFactoryAdmin: false,
        selectedApplication: null
      });
    });
    _defineProperty(_this, "handleUserChange", function (event) {
      _this.setState({
        selectedUserId: event.target.value
      });
    });
    _defineProperty(_this, "handleDeadlineChange", function (event) {
      _this.setState({
        deadline: event.target.value
      });
    });
    _defineProperty(_this, "handleOfficeChange", function (event) {
      var selectedOffice = event.target.value;
      _this.setState({
        selectedOffice: selectedOffice,
        selectedSuboffice: "",
        selectedUser: ""
      });
    });
    _defineProperty(_this, "handleSubofficeChange", function (event) {
      var selectedSuboffice = event.target.value;
      _this.setState({
        selectedSuboffice: selectedSuboffice,
        selectedUser: _this.state.officeData[_this.state.selectedOffice].suboffices[selectedSuboffice]
      });
    });
    _defineProperty(_this, "handleCheckboxChange", function (id) {
      return function (event) {
        var selectedApplicationIds = _this.state.selectedApplicationIds;
        var selectedIndex = selectedApplicationIds.indexOf(id);
        var newSelected = [];
        if (selectedIndex === -1) {
          newSelected = [].concat(_toConsumableArray(selectedApplicationIds), [id]);
        } else {
          newSelected = selectedApplicationIds.filter(function (item) {
            return item !== id;
          });
        }
        _this.setState({
          selectedApplicationIds: newSelected
        });
      };
    });
    _defineProperty(_this, "handleReject", function (application) {
      var selectedApplication = _this.state.selectedApplication;
      var _this$props5 = _this.props,
        history = _this$props5.history,
        loggedInUserId = _this$props5.loggedInUserId;
      var userType = getUserTypeFromRights(_this.props.userRights);
      var isApprover = userType === WORKFORCE_USER_TYPE.BLWF_APPROVER || userType === WORKFORCE_USER_TYPE.APPROVER;
      _this.setState({
        openRejectModal: true,
        modalFlag: "reject",
        confirmModalCallback: function () {
          var _confirmModalCallback = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3(confirmed) {
            return _regeneratorRuntime.wrap(function _callee3$(_context3) {
              while (1) switch (_context3.prev = _context3.next) {
                case 0:
                  if (confirmed) {
                    _this.setState({
                      selectedApplication: _objectSpread$E(_objectSpread$E({}, selectedApplication), {}, {
                        isHistory: true
                      })
                    }, /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
                      var rejectComment, summary, _mappingsData$payload, _mappings$, mappingsData, mappings, isQuorum, isRepresentative, totalApprovers, mapItem, applicationIds, updatedApplicationIds, updateApplicationData, createApplicationMovementData, _updateApplicationData, _createApplicationMovementData, rejectedUserIds, majorityRejected, targetStatus, _updateApplicationData2, _applicationIds, _updatedApplicationIds, _createApplicationMovementData2, _applicationIds2, _updatedApplicationIds2, _updateApplicationData3, _createApplicationMovementData3, _applicationIds3, _updatedApplicationIds3, _updateApplicationData4, _createApplicationMovementData4;
                      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                        while (1) switch (_context2.prev = _context2.next) {
                          case 0:
                            rejectComment = _this.state.rejectComment;
                            summary = application.blwfApplicationSummary || application.cfApplicationSummary || application.eisApplicationSummary;
                            _context2.prev = 2;
                            if (!isApprover) {
                              _context2.next = 80;
                              break;
                            }
                            _context2.next = 6;
                            return _this.props.fetchWorkforceCommitteeUserMap({
                              userIds: [String(loggedInUserId)]
                            });
                          case 6:
                            mappingsData = _context2.sent;
                            console.log("handle reject clicked", mappingsData);
                            mappings = (mappingsData === null || mappingsData === void 0 || (_mappingsData$payload = mappingsData.payload) === null || _mappingsData$payload === void 0 || (_mappingsData$payload = _mappingsData$payload.data) === null || _mappingsData$payload === void 0 ? void 0 : _mappingsData$payload.workforceCommitteeUserMaps) || [];
                            isQuorum = (mappings === null || mappings === void 0 || (_mappings$ = mappings[0]) === null || _mappings$ === void 0 || (_mappings$ = _mappings$.committee) === null || _mappings$ === void 0 ? void 0 : _mappings$.approvalType) === "quorum";
                            isRepresentative = mappings === null || mappings === void 0 ? void 0 : mappings.find(function (item) {
                              var _item$committee, _item$committee2, _item$committee3;
                              return (item === null || item === void 0 || (_item$committee = item.committee) === null || _item$committee === void 0 ? void 0 : _item$committee.approvalType) === "representative" || (item === null || item === void 0 || (_item$committee2 = item.committee) === null || _item$committee2 === void 0 ? void 0 : _item$committee2.approvalType) === null || (item === null || item === void 0 || (_item$committee3 = item.committee) === null || _item$committee3 === void 0 ? void 0 : _item$committee3.approvalType) === "";
                            });
                            totalApprovers = (mappings === null || mappings === void 0 ? void 0 : mappings.length) || 1;
                            if (!isRepresentative) {
                              _context2.next = 46;
                              break;
                            }
                            // Representative path: find if current user is the representative
                            mapItem = mappings.find(function (m) {
                              var _m$user;
                              return (m === null || m === void 0 ? void 0 : m.isRepresentative) && String(safeDecodeId(m === null || m === void 0 || (_m$user = m.user) === null || _m$user === void 0 ? void 0 : _m$user.id)) === String(loggedInUserId);
                            });
                            if (!mapItem) {
                              _context2.next = 29;
                              break;
                            }
                            // Representative directly rejects with REJECTED_BY_COMMITTEE
                            if (summary) {
                              applicationIds = JSON.parse(summary.applicationData);
                              updatedApplicationIds = applicationIds.filter(function (id) {
                                return safeDecodeId(id) !== safeDecodeId(application.id);
                              });
                              console.log("handle reject console 1", {
                                id: safeDecodeId(summary === null || summary === void 0 ? void 0 : summary.id),
                                applicationData: JSON.stringify(updatedApplicationIds)
                              });
                              _this.props.updateApplicationSummary({
                                id: safeDecodeId(summary === null || summary === void 0 ? void 0 : summary.id),
                                applicationData: JSON.stringify(updatedApplicationIds)
                              }, "update application summary");
                            }
                            updateApplicationData = {
                              id: decodeId(application.id),
                              status: WORKFORCE_STATUS$1.REJECTED_BY_COMMITTEE,
                              committeeRemarks: rejectComment
                            };
                            createApplicationMovementData = {
                              applicationId: decodeId(application.id),
                              status: WORKFORCE_STATUS$1.REJECTED_BY_COMMITTEE,
                              note: "আবেদন প্রতিনিধি দ্বারা বাতিল করা হয়েছে",
                              action: "rejected"
                            };
                            console.log("handle reject console 2", updateApplicationData);
                            console.log("handle reject console 3", createApplicationMovementData);
                            _context2.next = 22;
                            return _this.props.updateApplication(updateApplicationData, "update workforce application");
                          case 22:
                            _context2.next = 24;
                            return _this.props.createApplicationMovement(createApplicationMovementData, "create workforce movement");
                          case 24:
                            _this.setState({
                              serverResponse: {
                                status: "SUCCESS",
                                message: "আবেদন বাতিল করা হয়েছে!"
                              }
                            });
                            historyPush(modulesManager, history, "/");
                            window.location.reload();
                            _context2.next = 44;
                            break;
                          case 29:
                            if (isQuorum) {
                              _context2.next = 43;
                              break;
                            }
                            // Non-quorum committee: non-representative can propose rejection
                            // if (summary) {
                            //   const applicationIds = JSON.parse(summary.applicationData);
                            //   const updatedApplicationIds = applicationIds.filter((id) => safeDecodeId(id) !== safeDecodeId(application.id));
                            // }
                            _updateApplicationData = {
                              id: decodeId(application.id),
                              status: WORKFORCE_STATUS$1.PROPOSED_FOR_REJECTION,
                              committeeRemarks: rejectComment
                            };
                            _createApplicationMovementData = {
                              applicationId: decodeId(application.id),
                              status: WORKFORCE_STATUS$1.PROPOSED_FOR_REJECTION,
                              note: "আবেদন প্রতিনিধি দ্বারা বাতিলের প্রস্তাব করা হয়েছে",
                              action: "rejected"
                            };
                            console.log("handle reject console 2", _updateApplicationData);
                            console.log("handle reject console 3", _createApplicationMovementData);
                            _context2.next = 36;
                            return _this.props.updateApplication(_updateApplicationData, "update workforce application");
                          case 36:
                            _context2.next = 38;
                            return _this.props.createApplicationMovement(_createApplicationMovementData, "create workforce movement");
                          case 38:
                            _this.setState({
                              serverResponse: {
                                status: "SUCCESS",
                                message: "বাতিলের প্রস্তাব পাঠানো হয়েছে!"
                              }
                            });
                            historyPush(modulesManager, history, "/");
                            window.location.reload();
                            _context2.next = 44;
                            break;
                          case 43:
                            // Quorum committee: only representative can reject
                            _this.setState({
                              serverResponse: {
                                status: "ERROR",
                                message: "আপনি কমিটির প্রতিনিধি নন!"
                              }
                            });
                          case 44:
                            _context2.next = 78;
                            break;
                          case 46:
                            if (!isQuorum) {
                              _context2.next = 68;
                              break;
                            }
                            // Quorum path: track rejections via eisRejectedByIds
                            rejectedUserIds = application.rejectedIds ? safeParse(application.rejectedIds) : [];
                            if (!rejectedUserIds.includes(loggedInUserId)) {
                              _context2.next = 51;
                              break;
                            }
                            _this.setState({
                              serverResponse: {
                                status: "ERROR",
                                message: "আপনি ইতিমধ্যে বাতিল করেছেন!"
                              }
                            });
                            return _context2.abrupt("return");
                          case 51:
                            rejectedUserIds.push(loggedInUserId);
                            majorityRejected = rejectedUserIds.length / totalApprovers >= 0.5;
                            targetStatus = majorityRejected ? WORKFORCE_STATUS$1.REJECTED_BY_COMMITTEE : WORKFORCE_STATUS$1.PROPOSED_FOR_REJECTION; // Update the application with rejected IDs and status
                            _updateApplicationData2 = {
                              id: decodeId(application.id),
                              rejectedIds: JSON.stringify(rejectedUserIds),
                              status: targetStatus,
                              committeeRemarks: rejectComment
                            };
                            console.log("handle reject console 4", _updateApplicationData2);
                            if (majorityRejected && summary) {
                              // Majority rejected - remove from summary
                              _applicationIds = JSON.parse(summary.applicationData);
                              _updatedApplicationIds = _applicationIds.filter(function (id) {
                                return safeDecodeId(id) !== safeDecodeId(application.id);
                              });
                              console.log("handle reject console 5", {
                                id: safeDecodeId(summary === null || summary === void 0 ? void 0 : summary.id),
                                applicationData: JSON.stringify(_updatedApplicationIds)
                              });
                              _this.props.updateApplicationSummary({
                                id: safeDecodeId(summary === null || summary === void 0 ? void 0 : summary.id),
                                applicationData: JSON.stringify(_updatedApplicationIds)
                              }, "update application summary");
                            }
                            _createApplicationMovementData2 = {
                              applicationId: decodeId(application.id),
                              status: targetStatus,
                              note: majorityRejected ? "আবেদন সংখ্যাগরিষ্ঠ দ্বারা বাতিল করা হয়েছে" : "আবেদন বাতিল করার ভোট দেওয়া হয়েছে",
                              action: "rejected"
                            };
                            console.log("handle reject console 6", _createApplicationMovementData2);
                            _context2.next = 61;
                            return _this.props.updateApplication(_updateApplicationData2, "update workforce application");
                          case 61:
                            _context2.next = 63;
                            return _this.props.createApplicationMovement(_createApplicationMovementData2, "create workforce movement");
                          case 63:
                            _this.setState({
                              serverResponse: {
                                status: "SUCCESS",
                                message: majorityRejected ? "আবেদন বাতিল করা হয়েছে!" : "আপনার বাতিল ভোট রেকর্ড করা হয়েছে।"
                              }
                            });
                            historyPush(modulesManager, history, "/");
                            window.location.reload();
                            _context2.next = 78;
                            break;
                          case 68:
                            // Non-committee approver: keep existing behavior
                            if (summary) {
                              _applicationIds2 = JSON.parse(summary.applicationData);
                              _updatedApplicationIds2 = _applicationIds2.filter(function (id) {
                                return safeDecodeId(id) !== safeDecodeId(application.id);
                              });
                              _this.props.updateApplicationSummary({
                                id: safeDecodeId(summary === null || summary === void 0 ? void 0 : summary.id),
                                applicationData: JSON.stringify(_updatedApplicationIds2)
                              }, "update application summary");
                            }
                            _updateApplicationData3 = {
                              id: decodeId(application.id),
                              status: WORKFORCE_STATUS$1.REJECTED_BY_COMMITTEE,
                              committeeRemarks: rejectComment
                            };
                            _createApplicationMovementData3 = {
                              applicationId: decodeId(application.id),
                              status: WORKFORCE_STATUS$1.REJECTED_BY_COMMITTEE,
                              note: "আবেদন বাতিল করা হয়েছে",
                              action: "rejected"
                            };
                            _context2.next = 73;
                            return _this.props.updateApplication(_updateApplicationData3, "update workforce application");
                          case 73:
                            _context2.next = 75;
                            return _this.props.createApplicationMovement(_createApplicationMovementData3, "create workforce movement");
                          case 75:
                            _this.setState({
                              serverResponse: {
                                status: "SUCCESS",
                                message: "আবেদন বাতিল করা হয়েছে!"
                              }
                            });
                            historyPush(modulesManager, history, "/");
                            window.location.reload();
                          case 78:
                            _context2.next = 90;
                            break;
                          case 80:
                            // Non-approver user types: keep existing behavior
                            if (summary) {
                              _applicationIds3 = JSON.parse(summary.applicationData);
                              _updatedApplicationIds3 = _applicationIds3.filter(function (id) {
                                return safeDecodeId(id) !== safeDecodeId(application.id);
                              });
                              _this.props.updateApplicationSummary({
                                id: safeDecodeId(summary === null || summary === void 0 ? void 0 : summary.id),
                                applicationData: JSON.stringify(_updatedApplicationIds3)
                              }, "update application summary");
                            }
                            _updateApplicationData4 = {
                              id: decodeId(application.id),
                              status: WORKFORCE_STATUS$1.REJECTED,
                              committeeRemarks: rejectComment
                            };
                            _createApplicationMovementData4 = {
                              applicationId: decodeId(application.id),
                              status: WORKFORCE_STATUS$1.REJECTED,
                              note: "আবেদন বাতিল করা হয়েছে",
                              action: "rejected"
                            };
                            _context2.next = 85;
                            return _this.props.updateApplication(_updateApplicationData4, "update workforce application");
                          case 85:
                            _context2.next = 87;
                            return _this.props.createApplicationMovement(_createApplicationMovementData4, "create workforce movement");
                          case 87:
                            _this.setState({
                              serverResponse: {
                                status: "SUCCESS",
                                message: "আবেদন বাতিল করা হয়েছে!"
                              }
                            });
                            historyPush(modulesManager, history, "/");
                            window.location.reload();
                          case 90:
                            _context2.next = 96;
                            break;
                          case 92:
                            _context2.prev = 92;
                            _context2.t0 = _context2["catch"](2);
                            console.error("Rejection failed:", _context2.t0);
                            _this.setState({
                              serverResponse: {
                                status: "ERROR",
                                message: "আবেদন বাতিল ব্যর্থ হয়েছে!"
                              }
                            });
                          case 96:
                          case "end":
                            return _context2.stop();
                        }
                      }, _callee2, null, [[2, 92]]);
                    })));
                  }
                  _this.setState({
                    confirmModalOpen: false,
                    confirmModalCallback: null
                  });
                case 2:
                case "end":
                  return _context3.stop();
              }
            }, _callee3);
          }));
          function confirmModalCallback(_x2) {
            return _confirmModalCallback.apply(this, arguments);
          }
          return confirmModalCallback;
        }()
      });
    });
    _defineProperty(_this, "handleRejectByDG", /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee6(application) {
        var selectedApplication, _this$props6, loggedInUserId, history;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              selectedApplication = _this.state.selectedApplication;
              _this$props6 = _this.props, loggedInUserId = _this$props6.loggedInUserId, history = _this$props6.history;
              _this.setState({
                confirmModalOpen: true,
                confirmModalMessage: "workforce.application.reject.message",
                confirmModalCallback: function () {
                  var _confirmModalCallback2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee5(confirmed) {
                    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
                      while (1) switch (_context5.prev = _context5.next) {
                        case 0:
                          if (confirmed) {
                            _this.setState({
                              selectedApplication: _objectSpread$E(_objectSpread$E({}, selectedApplication), {}, {
                                isHistory: true
                              })
                            }, /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
                              var updateApplicationData, createApplicationMovementData;
                              return _regeneratorRuntime.wrap(function _callee4$(_context4) {
                                while (1) switch (_context4.prev = _context4.next) {
                                  case 0:
                                    updateApplicationData = {
                                      id: decodeId(application.id),
                                      status: WORKFORCE_STATUS$1.REJECTED_BY_DG
                                    };
                                    createApplicationMovementData = {
                                      applicationId: decodeId(application.id),
                                      status: WORKFORCE_STATUS$1.REJECTED_BY_DG,
                                      note: "আবেদন ডিজি কর্তৃক বাতিল করা হয়েছে",
                                      action: "rejected_by_dg",
                                      applicationFromId: loggedInUserId,
                                      applicationToId: 1
                                    };
                                    _context4.prev = 2;
                                    _context4.next = 5;
                                    return _this.props.updateApplication(updateApplicationData, "update workforce application");
                                  case 5:
                                    _context4.next = 7;
                                    return _this.props.createApplicationMovement(createApplicationMovementData, "create workforce movement");
                                  case 7:
                                    _this.setState({
                                      serverResponse: {
                                        status: "SUCCESS",
                                        message: "আবেদন বাতিল করা হয়েছে!"
                                      }
                                    });
                                    historyPush(modulesManager, history, "/");
                                    window.location.reload();
                                    _context4.next = 16;
                                    break;
                                  case 12:
                                    _context4.prev = 12;
                                    _context4.t0 = _context4["catch"](2);
                                    console.error("Approval failed:", _context4.t0);
                                    _this.setState({
                                      serverResponse: {
                                        status: "ERROR",
                                        message: "আবেদন বাতিল ব্যর্থ হয়েছে!"
                                      }
                                    });
                                  case 16:
                                  case "end":
                                    return _context4.stop();
                                }
                              }, _callee4, null, [[2, 12]]);
                            })));
                          }
                          _this.setState({
                            confirmModalOpen: false,
                            confirmModalCallback: null
                          });
                        case 2:
                        case "end":
                          return _context5.stop();
                      }
                    }, _callee5);
                  }));
                  function confirmModalCallback(_x4) {
                    return _confirmModalCallback2.apply(this, arguments);
                  }
                  return confirmModalCallback;
                }()
              });
            case 3:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }));
      return function (_x3) {
        return _ref3.apply(this, arguments);
      };
    }());
    _defineProperty(_this, "handleApproval", /*#__PURE__*/function () {
      var _ref5 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee9(application) {
        var selectedApplication, history;
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              selectedApplication = _this.state.selectedApplication;
              history = _this.props.history;
              _this.setState({
                confirmModalOpen: true,
                confirmModalMessage: "workforce.application.approve.message",
                confirmModalCallback: function () {
                  var _confirmModalCallback3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee8(confirmed) {
                    return _regeneratorRuntime.wrap(function _callee8$(_context8) {
                      while (1) switch (_context8.prev = _context8.next) {
                        case 0:
                          if (confirmed) {
                            _this.setState({
                              selectedApplication: _objectSpread$E(_objectSpread$E({}, selectedApplication), {}, {
                                isHistory: true,
                                loader: true
                              })
                            }, /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
                              var updateApplicationData;
                              return _regeneratorRuntime.wrap(function _callee7$(_context7) {
                                while (1) switch (_context7.prev = _context7.next) {
                                  case 0:
                                    updateApplicationData = {
                                      id: decodeId(application.id),
                                      status: WORKFORCE_STATUS$1.APPROVED_BY_DG,
                                      grantAmount: _this.state.editedGrantMoney
                                    };
                                    _context7.prev = 1;
                                    _context7.next = 4;
                                    return _this.props.updateApplication(updateApplicationData, "update workforce application");
                                  case 4:
                                    _this.setState({
                                      serverResponse: {
                                        status: "SUCCESS",
                                        message: "আবেদন অনুমোদন করা হয়েছে!"
                                      }
                                    });
                                    historyPush(modulesManager, history, "/");
                                    window.location.reload();
                                    _context7.next = 13;
                                    break;
                                  case 9:
                                    _context7.prev = 9;
                                    _context7.t0 = _context7["catch"](1);
                                    console.error("Approval failed:", _context7.t0);
                                    _this.setState({
                                      serverResponse: {
                                        status: "ERROR",
                                        message: "আবেদন অনুমোদন ব্যর্থ হয়েছে!"
                                      }
                                    });
                                  case 13:
                                  case "end":
                                    return _context7.stop();
                                }
                              }, _callee7, null, [[1, 9]]);
                            })));
                          }
                          _this.setState({
                            confirmModalOpen: false,
                            confirmModalCallback: null,
                            loader: false
                          });
                        case 2:
                        case "end":
                          return _context8.stop();
                      }
                    }, _callee8);
                  }));
                  function confirmModalCallback(_x6) {
                    return _confirmModalCallback3.apply(this, arguments);
                  }
                  return confirmModalCallback;
                }()
              });
            case 3:
            case "end":
              return _context9.stop();
          }
        }, _callee9);
      }));
      return function (_x5) {
        return _ref5.apply(this, arguments);
      };
    }());
    _defineProperty(_this, "handleApprovalByDirector", /*#__PURE__*/function () {
      var _ref7 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee12(application) {
        var selectedApplication, history;
        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              selectedApplication = _this.state.selectedApplication;
              history = _this.props.history;
              _this.setState({
                confirmModalOpen: true,
                confirmModalMessage: "workforce.application.approve.message",
                confirmModalCallback: function () {
                  var _confirmModalCallback4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee11(confirmed) {
                    return _regeneratorRuntime.wrap(function _callee11$(_context11) {
                      while (1) switch (_context11.prev = _context11.next) {
                        case 0:
                          if (confirmed) {
                            _this.setState({
                              selectedApplication: _objectSpread$E(_objectSpread$E({}, selectedApplication), {}, {
                                isHistory: true,
                                loader: true
                              })
                            }, /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee10() {
                              var updateApplicationData;
                              return _regeneratorRuntime.wrap(function _callee10$(_context10) {
                                while (1) switch (_context10.prev = _context10.next) {
                                  case 0:
                                    updateApplicationData = {
                                      id: decodeId(application.id),
                                      status: WORKFORCE_STATUS$1.APPROVED_BY_DIRECTOR,
                                      grantAmount: _this.state.editedGrantMoney
                                    };
                                    _context10.prev = 1;
                                    _context10.next = 4;
                                    return _this.props.updateApplication(updateApplicationData, "update workforce application");
                                  case 4:
                                    _this.setState({
                                      serverResponse: {
                                        status: "SUCCESS",
                                        message: "আবেদন অনুমোদন করা হয়েছে!"
                                      }
                                    });
                                    historyPush(modulesManager, history, "/");
                                    window.location.reload();
                                    _context10.next = 13;
                                    break;
                                  case 9:
                                    _context10.prev = 9;
                                    _context10.t0 = _context10["catch"](1);
                                    console.error("Approval failed:", _context10.t0);
                                    _this.setState({
                                      serverResponse: {
                                        status: "ERROR",
                                        message: "আবেদন অনুমোদন ব্যর্থ হয়েছে!"
                                      }
                                    });
                                  case 13:
                                  case "end":
                                    return _context10.stop();
                                }
                              }, _callee10, null, [[1, 9]]);
                            })));
                          }
                          _this.setState({
                            confirmModalOpen: false,
                            confirmModalCallback: null,
                            loader: false
                          });
                        case 2:
                        case "end":
                          return _context11.stop();
                      }
                    }, _callee11);
                  }));
                  function confirmModalCallback(_x8) {
                    return _confirmModalCallback4.apply(this, arguments);
                  }
                  return confirmModalCallback;
                }()
              });
            case 3:
            case "end":
              return _context12.stop();
          }
        }, _callee12);
      }));
      return function (_x7) {
        return _ref7.apply(this, arguments);
      };
    }());
    _defineProperty(_this, "handleApprovalByDoctor", /*#__PURE__*/function () {
      var _ref9 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee15(application) {
        var selectedApplication, _this$props7, loggedInUserId, history, userType;
        return _regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) switch (_context15.prev = _context15.next) {
            case 0:
              selectedApplication = _this.state.selectedApplication;
              _this$props7 = _this.props, loggedInUserId = _this$props7.loggedInUserId, history = _this$props7.history;
              userType = getUserTypeFromRights(_this.props.userRights);
              _this.setState({
                confirmModalOpen: true,
                confirmModalMessage: "workforce.application.doctor.approve.message",
                confirmModalCallback: function () {
                  var _confirmModalCallback5 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee14(confirmed) {
                    return _regeneratorRuntime.wrap(function _callee14$(_context14) {
                      while (1) switch (_context14.prev = _context14.next) {
                        case 0:
                          if (confirmed) {
                            _this.setState({
                              selectedApplication: _objectSpread$E(_objectSpread$E({}, selectedApplication), {}, {
                                isHistory: true,
                                loader: true
                              })
                            }, /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee13() {
                              var _application$eisAppli, _application$blwfAppl, _application$cfApplic, _application$blwfAppl2, _application$blwfAppl3, _application$blwfAppl4;
                              var updateApplicationData, updateApplicationSummaryData, createApplicationMovementData, summaryApplications, shouldUpdateSummary;
                              return _regeneratorRuntime.wrap(function _callee13$(_context13) {
                                while (1) switch (_context13.prev = _context13.next) {
                                  case 0:
                                    updateApplicationData = {
                                      id: decodeId(application.id),
                                      status: WORKFORCE_STATUS$1.APPROVED_BY_DOCTOR,
                                      grantAmount: _this.state.editedGrantMoney
                                    };
                                    updateApplicationSummaryData = {
                                      id: isEisPath() ? safeDecodeId(application === null || application === void 0 || (_application$eisAppli = application.eisApplicationSummary) === null || _application$eisAppli === void 0 ? void 0 : _application$eisAppli.id) : isBlwfPath() ? safeDecodeId(application === null || application === void 0 || (_application$blwfAppl = application.blwfApplicationSummary) === null || _application$blwfAppl === void 0 ? void 0 : _application$blwfAppl.id) : safeDecodeId(application === null || application === void 0 || (_application$cfApplic = application.cfApplicationSummary) === null || _application$cfApplic === void 0 ? void 0 : _application$cfApplic.id),
                                      status: WORKFORCE_STATUS$1.APPROVED_BY_DOCTOR
                                      // grantAmount: this.state.editedGrantMoney,
                                    };
                                    console.log({
                                      updateApplicationSummaryData: application
                                    });
                                    console.log({
                                      updateApplicationSummaryData: updateApplicationSummaryData
                                    });
                                    createApplicationMovementData = {
                                      applicationId: decodeId(application.id),
                                      status: WORKFORCE_STATUS$1.APPROVED_BY_DOCTOR,
                                      note: "আবেদন ডাক্তার দ্বারা অনুমোদন করা হয়েছে",
                                      action: "approved_by_doctor",
                                      applicationFromId: loggedInUserId,
                                      applicationToId: userType === WORKFORCE_USER_TYPE.DOCTOR ? 139 : userType === WORKFORCE_USER_TYPE.BLWF_DOCTOR ? 187 : userType === WORKFORCE_USER_TYPE.EIS_DOCTOR ? 173 : null,
                                      toRoleId: userType === WORKFORCE_USER_TYPE.DOCTOR ? 32 : userType === WORKFORCE_USER_TYPE.BLWF_DOCTOR ? 40 : userType === WORKFORCE_USER_TYPE.EIS_DOCTOR ? 42 : null
                                    };
                                    summaryApplications = isEisPath() ? parseData(application === null || application === void 0 || (_application$blwfAppl2 = application.blwfApplicationSummary) === null || _application$blwfAppl2 === void 0 ? void 0 : _application$blwfAppl2.cfApplicationSummary) : isBlwfPath() ? parseData(application === null || application === void 0 || (_application$blwfAppl3 = application.blwfApplicationSummary) === null || _application$blwfAppl3 === void 0 ? void 0 : _application$blwfAppl3.blwfApplicationSummary) : parseData(application === null || application === void 0 || (_application$blwfAppl4 = application.blwfApplicationSummary) === null || _application$blwfAppl4 === void 0 ? void 0 : _application$blwfAppl4.cfApplicationSummary);
                                    shouldUpdateSummary = summaryApplications.every(function (app) {
                                      return app.status === "approved_by_doctor" || decodeId(app.id) === decodeId(application.id);
                                    });
                                    console.log({
                                      summaryApplications: summaryApplications
                                    });
                                    console.log({
                                      shouldUpdateSummary: shouldUpdateSummary
                                    });
                                    _context13.prev = 9;
                                    _context13.next = 12;
                                    return _this.props.updateApplication(updateApplicationData, "update workforce application");
                                  case 12:
                                    if (!shouldUpdateSummary) {
                                      _context13.next = 15;
                                      break;
                                    }
                                    _context13.next = 15;
                                    return _this.props.updateApplicationSummary(updateApplicationSummaryData, "update workforce application summary");
                                  case 15:
                                    _context13.next = 17;
                                    return _this.props.createApplicationMovement(createApplicationMovementData, "create workforce movement");
                                  case 17:
                                    _this.setState({
                                      serverResponse: {
                                        status: "SUCCESS",
                                        message: "আবেদন অনুমোদন করা হয়েছে!"
                                      }
                                    });
                                    //historyPush(modulesManager, history, "/home");
                                    history.push("/");
                                    window.location.reload();
                                    _context13.next = 26;
                                    break;
                                  case 22:
                                    _context13.prev = 22;
                                    _context13.t0 = _context13["catch"](9);
                                    console.error("Approval failed:", _context13.t0);
                                    _this.setState({
                                      serverResponse: {
                                        status: "ERROR",
                                        message: "আবেদন অনুমোদন ব্যর্থ হয়েছে!"
                                      }
                                    });
                                  case 26:
                                  case "end":
                                    return _context13.stop();
                                }
                              }, _callee13, null, [[9, 22]]);
                            })));
                          }
                          _this.setState({
                            confirmModalOpen: false,
                            confirmModalCallback: null,
                            loader: false
                          });
                        case 2:
                        case "end":
                          return _context14.stop();
                      }
                    }, _callee14);
                  }));
                  function confirmModalCallback(_x10) {
                    return _confirmModalCallback5.apply(this, arguments);
                  }
                  return confirmModalCallback;
                }()
              });
            case 4:
            case "end":
              return _context15.stop();
          }
        }, _callee15);
      }));
      return function (_x9) {
        return _ref9.apply(this, arguments);
      };
    }());
    _defineProperty(_this, "handleSelected", /*#__PURE__*/function () {
      var _ref11 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee18(application) {
        var selectedApplication, history;
        return _regeneratorRuntime.wrap(function _callee18$(_context18) {
          while (1) switch (_context18.prev = _context18.next) {
            case 0:
              selectedApplication = _this.state.selectedApplication;
              history = _this.props.history;
              _this.setState({
                confirmModalOpen: true,
                confirmModalMessage: "workforce.application.select.message",
                confirmModalCallback: function () {
                  var _confirmModalCallback6 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee17(confirmed) {
                    return _regeneratorRuntime.wrap(function _callee17$(_context17) {
                      while (1) switch (_context17.prev = _context17.next) {
                        case 0:
                          if (confirmed) {
                            _this.setState({
                              selectedApplication: _objectSpread$E(_objectSpread$E({}, selectedApplication), {}, {
                                isHistory: true,
                                loader: true
                              })
                            }, /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee16() {
                              var updateApplicationData, createApplicationMovementData;
                              return _regeneratorRuntime.wrap(function _callee16$(_context16) {
                                while (1) switch (_context16.prev = _context16.next) {
                                  case 0:
                                    updateApplicationData = {
                                      id: decodeId(application.id),
                                      grantAmount: _this.state.editedGrantMoney,
                                      status: WORKFORCE_STATUS$1.SELECTED
                                    };
                                    createApplicationMovementData = {
                                      applicationId: decodeId(application.id),
                                      status: WORKFORCE_STATUS$1.SELECTED,
                                      note: "আবেদন নির্বাচন করা হয়েছে",
                                      action: "approved"
                                    };
                                    _context16.prev = 2;
                                    _context16.next = 5;
                                    return _this.props.updateApplication(updateApplicationData, "update workforce application");
                                  case 5:
                                    _context16.next = 7;
                                    return _this.props.createApplicationMovement(createApplicationMovementData, "create workforce movement");
                                  case 7:
                                    _this.setState({
                                      serverResponse: {
                                        status: "SUCCESS",
                                        message: "আবেদন নির্বাচন করা হয়েছে!"
                                      }
                                    });
                                    //historyPush(modulesManager, history, "/home");
                                    history.push("/");
                                    window.location.reload();
                                    _context16.next = 16;
                                    break;
                                  case 12:
                                    _context16.prev = 12;
                                    _context16.t0 = _context16["catch"](2);
                                    console.error("Approval failed:", _context16.t0);
                                    _this.setState({
                                      serverResponse: {
                                        status: "ERROR",
                                        message: "আবেদন নির্বাচন ব্যর্থ হয়েছে!"
                                      }
                                    });
                                  case 16:
                                  case "end":
                                    return _context16.stop();
                                }
                              }, _callee16, null, [[2, 12]]);
                            })));
                          }
                          _this.setState({
                            confirmModalOpen: false,
                            confirmModalCallback: null,
                            loader: false
                          });
                        case 2:
                        case "end":
                          return _context17.stop();
                      }
                    }, _callee17);
                  }));
                  function confirmModalCallback(_x12) {
                    return _confirmModalCallback6.apply(this, arguments);
                  }
                  return confirmModalCallback;
                }()
              });
            case 3:
            case "end":
              return _context18.stop();
          }
        }, _callee18);
      }));
      return function (_x11) {
        return _ref11.apply(this, arguments);
      };
    }());
    _defineProperty(_this, "handleForwardPendingMeetingSheet", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee19() {
      var selectedApplicationIds, _this$props8, summaryId, loggedInUserId, forwardStatus, normalizedSummaryId, _iterator, _step, item, appId;
      return _regeneratorRuntime.wrap(function _callee19$(_context19) {
        while (1) switch (_context19.prev = _context19.next) {
          case 0:
            selectedApplicationIds = _this.state.selectedApplicationIds;
            _this$props8 = _this.props, summaryId = _this$props8.summaryId, loggedInUserId = _this$props8.loggedInUserId;
            console.log({
              fromMeetingSheet: selectedApplicationIds
            });
            if (summaryId) {
              _context19.next = 6;
              break;
            }
            _this.setState({
              serverResponse: {
                status: "ERROR",
                message: "ফরওয়ার্ডের জন্য একটি সেভ করা মিটিং শিট নির্বাচন করুন।"
              }
            });
            return _context19.abrupt("return");
          case 6:
            if (!(!selectedApplicationIds || selectedApplicationIds.length === 0)) {
              _context19.next = 9;
              break;
            }
            _this.setState({
              serverResponse: {
                status: "ERROR",
                message: "দয়া করে অন্তত একটি আবেদন নির্বাচন করুন।"
              }
            });
            return _context19.abrupt("return");
          case 9:
            _this.setState({
              submitting: true,
              serverResponse: null
            });
            _context19.prev = 10;
            forwardStatus = WORKFORCE_STATUS$1.FORWARD_TO_EIS_ADVISOR;
            normalizedSummaryId = safeDecodeId(summaryId);
            _context19.next = 15;
            return _this.props.updateApplicationSummary({
              id: normalizedSummaryId,
              status: forwardStatus
            }, "update application summary");
          case 15:
            _iterator = _createForOfIteratorHelper(selectedApplicationIds);
            _context19.prev = 16;
            _iterator.s();
          case 18:
            if ((_step = _iterator.n()).done) {
              _context19.next = 27;
              break;
            }
            item = _step.value;
            appId = decodeId((item === null || item === void 0 ? void 0 : item.id) || item);
            _context19.next = 23;
            return _this.props.updateApplication({
              id: appId,
              eisApplicationSummaryId: normalizedSummaryId,
              status: forwardStatus
            }, "update workforce application");
          case 23:
            _context19.next = 25;
            return _this.props.createApplicationMovement({
              applicationId: appId,
              applicationFromId: loggedInUserId,
              applicationToId: 196,
              toRoleId: 48,
              status: forwardStatus,
              note: "মিটিং শিট ইআইএস উপদেষ্টার কাছে প্রেরণ করা হয়েছে",
              action: "forward_to_eis_advisor"
            }, "create workforce movement");
          case 25:
            _context19.next = 18;
            break;
          case 27:
            _context19.next = 32;
            break;
          case 29:
            _context19.prev = 29;
            _context19.t0 = _context19["catch"](16);
            _iterator.e(_context19.t0);
          case 32:
            _context19.prev = 32;
            _iterator.f();
            return _context19.finish(32);
          case 35:
            _this.setState({
              submitting: false,
              serverResponse: {
                status: "SUCCESS",
                message: "মিটিং শিট ও আবেদনসমূহ ইআইএস উপদেষ্টার কাছে সফলভাবে পাঠানো হয়েছে!"
              }
            });
            setTimeout(function () {
              window.location.reload();
            }, 1500);
            _context19.next = 43;
            break;
          case 39:
            _context19.prev = 39;
            _context19.t1 = _context19["catch"](10);
            console.error("Pending meeting sheet forward failed:", _context19.t1);
            _this.setState({
              submitting: false,
              serverResponse: {
                status: "ERROR",
                message: "মিটিং শিট ফরওয়ার্ড ব্যর্থ হয়েছে!"
              }
            });
          case 43:
          case "end":
            return _context19.stop();
        }
      }, _callee19, null, [[10, 39], [16, 29, 32, 35]]);
    })));
    _defineProperty(_this, "handleForwardSubmit", function (event) {
      _this.state.editorContent;
      event.preventDefault();
      _this.state.userList.find(function (user) {
        return user.id === _this.state.selectedUserId;
      });
      _this.setState({
        submitting: true
      });
      setTimeout(function () {
        _this.setState({
          submitting: false,
          serverResponse: {
            status: "SUCCESS",
            message: "আবেদন সফলভাবে Forward করা হয়েছে!"
          }
        });
        setTimeout(function () {
          _this.setState({
            revertModalOpen: false,
            selectedUserId: "",
            deadline: "",
            selectedApplication: null,
            serverResponse: null
          });
        }, 2000);
      }, 2000);
    });
    _defineProperty(_this, "handleRevertSubmit", function (event) {
      _this.state.editorContent;
      event.preventDefault();
      _this.state.userList.find(function (user) {
        return user.id === _this.state.selectedUserId;
      });
      _this.setState({
        submitting: true
      });

      // Simulate async submit
      setTimeout(function () {
        _this.setState({
          submitting: false,
          serverResponse: {
            status: "SUCCESS",
            message: "আবেদন সফলভাবে revert করা হয়েছে!"
          }
        });

        // After 2 seconds, close modal and reset form
        setTimeout(function () {
          _this.setState({
            revertModalOpen: false,
            selectedUserId: "",
            deadline: "",
            selectedApplication: null,
            serverResponse: null
          });
        }, 2000);
      }, 2000);
    });
    _defineProperty(_this, "headers", function () {
      var userType = getUserTypeFromRights(_this.props.userRights);
      return userType === WORKFORCE_USER_TYPE.APPLICANT ? headerApplicant(_this) : userType === WORKFORCE_USER_TYPE.CHECKER || userType === WORKFORCE_USER_TYPE.EIS_OFFICER || userType === WORKFORCE_USER_TYPE.BLWF_DEPUTI_ASST_DIRECTOR || userType === WORKFORCE_USER_TYPE.BLWF_DEPUTI_ASST_DIRECTOR || userType === WORKFORCE_USER_TYPE.BLWF_CHECKER || userType === WORKFORCE_USER_TYPE.BLWF_DOL_DIFE ? headerChecker(_this) : userType === WORKFORCE_USER_TYPE.CHECKER_TWO ? headerCheckerTwo(_this) : userType === WORKFORCE_USER_TYPE.SEC1_DEPUTI_ASST_DIRECTOR || userType === WORKFORCE_USER_TYPE.SEC2_DEPUTI_ASST_DIRECTOR ? headerDeputyAsstDirector(_this) : userType === WORKFORCE_USER_TYPE.SECTION_ADMIN || userType === WORKFORCE_USER_TYPE.EIS_COORDINATOR ? headerSectionAdmin(_this) : userType === WORKFORCE_USER_TYPE.SECTION_ADMIN_TWO ? headerSectionTwoAdmin(_this) : userType === WORKFORCE_USER_TYPE.BLWF_SECTION_ADMIN || userType === WORKFORCE_USER_TYPE.BLWF_ACCOUNTANT ? headerBlwfSectionAdmin(_this) : userType === WORKFORCE_USER_TYPE.DOCTOR || userType === WORKFORCE_USER_TYPE.BLWF_DOCTOR || userType === WORKFORCE_USER_TYPE.EIS_DOCTOR ? headerDoctor(_this) : userType === WORKFORCE_USER_TYPE.BGMEA_ASSOCIATION || userType === WORKFORCE_USER_TYPE.ASSOCIATION || userType === WORKFORCE_USER_TYPE.BKMEA_ASSOCIATION || userType === WORKFORCE_USER_TYPE.BEPZA_ASSOCIATION || userType === WORKFORCE_USER_TYPE.LFMEAB_ASSOCIATION ? headerAssociation(_this) : userType === WORKFORCE_USER_TYPE.APPROVER || userType === WORKFORCE_USER_TYPE.EIS_COMMITTEE || userType === WORKFORCE_USER_TYPE.EIS_ASSOCIATION_COMMITTEE || userType === WORKFORCE_USER_TYPE.BLWF_APPROVER || userType === WORKFORCE_USER_TYPE.EIS_FINANCIAL_OFFICER ? headerApprover(_this) : userType === WORKFORCE_USER_TYPE.FACTORY_ADMIN ? headerFactoryAdmin(_this) : userType === WORKFORCE_USER_TYPE.DIRECTOR || userType === WORKFORCE_USER_TYPE.BLWF_DIRECTOR ? headerDirector(_this) : headersAdmin(_this);
    });
    _defineProperty(_this, "itemFormatters", function () {
      var userType = getUserTypeFromRights(_this.props.userRights);
      var locale = _this.props.locale;
      return userType === WORKFORCE_USER_TYPE.APPLICANT ? itemFormattersApplicant(_this.isShowHistory, _this.props.modulesManager, _this.props.history, _this, locale, _this.revertedApplication, _this.rejectedApplication) : userType === WORKFORCE_USER_TYPE.CHECKER || userType === WORKFORCE_USER_TYPE.EIS_OFFICER || userType === WORKFORCE_USER_TYPE.BLWF_CHECKER || userType === WORKFORCE_USER_TYPE.BLWF_DOL_DIFE || userType === WORKFORCE_USER_TYPE.BLWF_DEPUTI_ASST_DIRECTOR || userType === WORKFORCE_USER_TYPE.BLWF_DEPUTI_ASST_DIRECTOR ? itemFormattersChecker(_this.isShowHistory, _this.props.modulesManager, _this.props.history, _this, locale, _this.revertedApplication) : userType === WORKFORCE_USER_TYPE.CHECKER_TWO ? itemFormattersCheckerTwo(_this.isShowHistory, _this.props.modulesManager, _this.props.history, _this, locale, _this.revertedApplication) : userType === WORKFORCE_USER_TYPE.SEC1_DEPUTI_ASST_DIRECTOR || userType === WORKFORCE_USER_TYPE.SEC2_DEPUTI_ASST_DIRECTOR ? itemFormattersDeputyAsstDirector(_this.isShowHistory, _this.props.modulesManager, _this.props.history, _this, locale, _this.revertedApplication) : userType === WORKFORCE_USER_TYPE.SECTION_ADMIN || userType === WORKFORCE_USER_TYPE.EIS_COORDINATOR ? itemFormattersSectionAdmin(_this.isShowHistory, _this.props.modulesManager, _this.props.history, _this, locale, _this.revertedApplication, _this.rejectedApplication, _this.nidFilters) : userType === WORKFORCE_USER_TYPE.SECTION_ADMIN_TWO ? itemFormattersSectionTwoAdmin(_this.isShowHistory, _this.props.modulesManager, _this.props.history, _this, locale, _this.revertedApplication, _this.rejectedApplication, _this.nidFilters) : userType === WORKFORCE_USER_TYPE.BLWF_SECTION_ADMIN || userType === WORKFORCE_USER_TYPE.BLWF_ACCOUNTANT ? itemFormattersBlwfSectionAdmin(_this.isShowHistory, _this.props.modulesManager, _this.props.history, _this, locale, _this.revertedApplication, _this.rejectedApplication, _this.nidFilters) : userType === WORKFORCE_USER_TYPE.DOCTOR || userType === WORKFORCE_USER_TYPE.BLWF_DOCTOR || userType === WORKFORCE_USER_TYPE.EIS_DOCTOR ? itemFormattersDoctor(_this.isShowHistory, _this.props.modulesManager, _this.props.history, _this, locale, _this.revertedApplication) : userType === WORKFORCE_USER_TYPE.BGMEA_ASSOCIATION || userType === WORKFORCE_USER_TYPE.ASSOCIATION || userType === WORKFORCE_USER_TYPE.BKMEA_ASSOCIATION || userType === WORKFORCE_USER_TYPE.BEPZA_ASSOCIATION || userType === WORKFORCE_USER_TYPE.LFMEAB_ASSOCIATION ? itemFormattersAssociation(_this.isShowHistory, _this.props.modulesManager, _this.props.history, _this, locale, _this.revertedApplication) : userType === WORKFORCE_USER_TYPE.APPROVER || userType === WORKFORCE_USER_TYPE.BLWF_APPROVER || userType === WORKFORCE_USER_TYPE.EIS_COMMITTEE || userType === WORKFORCE_USER_TYPE.EIS_ASSOCIATION_COMMITTEE || userType === WORKFORCE_USER_TYPE.EIS_FINANCIAL_OFFICER ? itemFormattersApprover(_this.isShowHistory, _this.props.modulesManager, _this.props.history, _this, locale, _this.revertedApplication) : userType === WORKFORCE_USER_TYPE.FACTORY_ADMIN ? itemFormattersFactoryAdmin(_this.isShowHistory, _this.props.modulesManager, _this.props.history, _this, locale, _this.revertedApplication, _this.rejectedApplication) : userType === WORKFORCE_USER_TYPE.DIRECTOR || userType === WORKFORCE_USER_TYPE.BLWF_DIRECTOR ? itemFormattersDirector(_this.isShowHistory, _this.props.modulesManager, _this.props.history, _this, locale, _this.rejectedApplication, _this.revertedApplication) : userType === WORKFORCE_USER_TYPE.SECRETARY || userType === WORKFORCE_USER_TYPE.MINISTER ? itemFormattersSecretaryMinister(_this.isShowHistory, _this.props.modulesManager, _this.props.history, _this, locale, _this.rejectedApplication, _this.revertedApplication) : itemAdminFormatters(_this.isShowHistory, _this.props.modulesManager, _this.props.history, _this, locale, _this.rejectedApplication, _this.revertedApplication);
    });
    _defineProperty(_this, "sorts", function () {
      return [];
    });
    _defineProperty(_this, "getUserOrganization", /*#__PURE__*/function () {
      var _ref14 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee20(userId) {
        return _regeneratorRuntime.wrap(function _callee20$(_context20) {
          while (1) switch (_context20.prev = _context20.next) {
            case 0:
              _context20.next = 2;
              return _this.fetchOrganizationEmployeeDesignation(_this.props.modulesManager, decodeId(userId));
            case 2:
            case "end":
              return _context20.stop();
          }
        }, _callee20);
      }));
      return function (_x13) {
        return _ref14.apply(this, arguments);
      };
    }());
    _defineProperty(_this, "handleBulkSelectedByApprover", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee23() {
      var selectedApplicationIds, _this$props9, history;
      return _regeneratorRuntime.wrap(function _callee23$(_context23) {
        while (1) switch (_context23.prev = _context23.next) {
          case 0:
            selectedApplicationIds = _this.state.selectedApplicationIds;
            _this$props9 = _this.props, _this$props9.loggedInUserId, history = _this$props9.history;
            getUserTypeFromRights(_this.props.userRights);
            if (!(selectedApplicationIds.length === 0)) {
              _context23.next = 6;
              break;
            }
            alert("Please select at least one application.");
            return _context23.abrupt("return");
          case 6:
            _this.setState({
              confirmModalOpen: true,
              confirmModalMessage: "workforce.application.select.message",
              confirmModalCallback: function () {
                var _confirmModalCallback7 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee22(confirmed) {
                  var _this$props10, _updateApplication, _createApplicationMovement;
                  return _regeneratorRuntime.wrap(function _callee22$(_context22) {
                    while (1) switch (_context22.prev = _context22.next) {
                      case 0:
                        if (!confirmed) {
                          _context22.next = 17;
                          break;
                        }
                        _this.setState({
                          loader: true
                        });
                        _this$props10 = _this.props, _updateApplication = _this$props10.updateApplication, _createApplicationMovement = _this$props10.createApplicationMovement;
                        _context22.prev = 3;
                        _context22.next = 6;
                        return Promise.all(selectedApplicationIds.map(/*#__PURE__*/function () {
                          var _ref16 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee21(selectedItem) {
                            var decodedId, updateApplicationData, createApplicationMovementData;
                            return _regeneratorRuntime.wrap(function _callee21$(_context21) {
                              while (1) switch (_context21.prev = _context21.next) {
                                case 0:
                                  decodedId = decodeId(selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.id);
                                  updateApplicationData = {
                                    id: decodedId,
                                    status: WORKFORCE_STATUS$1.SELECTED
                                  };
                                  createApplicationMovementData = {
                                    applicationId: decodedId,
                                    status: WORKFORCE_STATUS$1.SELECTED,
                                    note: "আবেদন নির্বাচন করা হয়েছে",
                                    action: "approved"
                                  };
                                  _context21.next = 5;
                                  return _updateApplication(updateApplicationData, "update workforce application");
                                case 5:
                                  _context21.next = 7;
                                  return _createApplicationMovement(createApplicationMovementData, "create workforce movement");
                                case 7:
                                case "end":
                                  return _context21.stop();
                              }
                            }, _callee21);
                          }));
                          return function (_x15) {
                            return _ref16.apply(this, arguments);
                          };
                        }()));
                      case 6:
                        _this.setState({
                          serverResponse: {
                            status: "SUCCESS",
                            message: "আবেদনসমূহ সফলভাবে নির্বাচন করা হয়েছে!"
                          }
                        });
                        _context22.next = 13;
                        break;
                      case 9:
                        _context22.prev = 9;
                        _context22.t0 = _context22["catch"](3);
                        console.error("Bulk selection failed:", _context22.t0);
                        _this.setState({
                          serverResponse: {
                            status: "ERROR",
                            message: "একাধিক আবেদন নির্বাচন ব্যর্থ হয়েছে!"
                          }
                        });
                      case 13:
                        _context22.prev = 13;
                        //historyPush(modulesManager, history, "/home");
                        history.push("/");
                        window.location.reload();
                        return _context22.finish(13);
                      case 17:
                        _this.setState({
                          confirmModalOpen: false,
                          confirmModalCallback: null,
                          loader: false
                        });
                      case 18:
                      case "end":
                        return _context22.stop();
                    }
                  }, _callee22, null, [[3, 9, 13, 17]]);
                }));
                function confirmModalCallback(_x14) {
                  return _confirmModalCallback7.apply(this, arguments);
                }
                return confirmModalCallback;
              }()
            });
          case 7:
          case "end":
            return _context23.stop();
        }
      }, _callee23);
    })));
    _defineProperty(_this, "handleBulkSelectedbyAssociation", function () {
      var selectedApplicationIds = _this.state.selectedApplicationIds;
      var _this$props11 = _this.props,
        loggedInUserId = _this$props11.loggedInUserId,
        updateApplication = _this$props11.updateApplication,
        createApplicationMovement = _this$props11.createApplicationMovement,
        userRights = _this$props11.userRights,
        modulesManager = _this$props11.modulesManager,
        fetchWorkforceDocument = _this$props11.fetchWorkforceDocument,
        fetchUsersByRoleId = _this$props11.fetchUsersByRoleId,
        testWorkforcePayment = _this$props11.testWorkforcePayment,
        roles = _this$props11.roles,
        history = _this$props11.history;
      handleBulkSelectedByAssociationLogic({
        selectedApplicationIds: selectedApplicationIds,
        loggedInUserId: loggedInUserId,
        updateApplication: updateApplication,
        createApplicationMovement: createApplicationMovement,
        userRights: userRights,
        fetchWorkforceDocument: fetchWorkforceDocument,
        testWorkforcePayment: testWorkforcePayment,
        fetchUsersByRoleId: fetchUsersByRoleId,
        modulesManager: modulesManager,
        roles: roles,
        setServerResponse: function setServerResponse(resp) {
          return _this.setState({
            serverResponse: resp
          });
        },
        setConfirmModalOpen: function setConfirmModalOpen(v) {
          return _this.setState({
            confirmModalOpen: v
          });
        },
        setConfirmModalMessage: function setConfirmModalMessage(msg) {
          return _this.setState({
            confirmModalMessage: msg
          });
        },
        setConfirmModalCallback: function setConfirmModalCallback(cb) {
          return _this.setState({
            confirmModalCallback: cb
          });
        },
        history: history,
        setCloseLoader: function setCloseLoader(l) {
          return _this.setState({
            loader: l
          });
        },
        loader: _this.state.loader
      });
    });
    _defineProperty(_this, "handleBulkSelectedbySectionAdminToDoctor", function () {
      var selectedApplicationIds = _this.state.selectedApplicationIds;
      var _this$props12 = _this.props,
        loggedInUserId = _this$props12.loggedInUserId,
        history = _this$props12.history;
      var userType = getUserTypeFromRights(_this.props.userRights);
      if (selectedApplicationIds.length === 0) {
        alert("Please select at least one application.");
        return;
      }
      _this.setState({
        confirmModalOpen: true,
        confirmModalMessage: "workforce.application.forward.message.toDoctor",
        confirmModalCallback: function () {
          var _confirmModalCallback8 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee25(confirmed) {
            var _this$props13, _updateApplication2, _createApplicationMovement2;
            return _regeneratorRuntime.wrap(function _callee25$(_context25) {
              while (1) switch (_context25.prev = _context25.next) {
                case 0:
                  if (!confirmed) {
                    _context25.next = 17;
                    break;
                  }
                  _this.setState({
                    loader: true
                  });
                  _this$props13 = _this.props, _updateApplication2 = _this$props13.updateApplication, _createApplicationMovement2 = _this$props13.createApplicationMovement;
                  _context25.prev = 3;
                  _context25.next = 6;
                  return Promise.all(selectedApplicationIds.map(/*#__PURE__*/function () {
                    var _ref17 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee24(selectedItem) {
                      var decodedId, updateApplicationData, createApplicationMovementData;
                      return _regeneratorRuntime.wrap(function _callee24$(_context24) {
                        while (1) switch (_context24.prev = _context24.next) {
                          case 0:
                            decodedId = decodeId(selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.id);
                            updateApplicationData = {
                              id: decodedId,
                              status: WORKFORCE_STATUS$1.FORWARD_TO_DOCTOR
                            };
                            createApplicationMovementData = {
                              applicationId: decodedId,
                              status: WORKFORCE_STATUS$1.FORWARD_TO_DOCTOR,
                              note: "আবেদন ডক্টরের কাছে প্রেরণ করা হয়েছে",
                              action: "forward_to_doctor",
                              applicationFromId: loggedInUserId,
                              applicationToId: userType === WORKFORCE_USER_TYPE.SECTION_ADMIN ? 151 : userType === WORKFORCE_USER_TYPE.BLWF_SECTION_ADMIN ? 199 : null,
                              toRoleId: userType === WORKFORCE_USER_TYPE.SECTION_ADMIN ? 33 : userType === WORKFORCE_USER_TYPE.BLWF_SECTION_ADMIN ? 50 : null
                            };
                            _context24.next = 5;
                            return _updateApplication2(updateApplicationData, "update workforce application");
                          case 5:
                            _context24.next = 7;
                            return _createApplicationMovement2(createApplicationMovementData, "create workforce movement");
                          case 7:
                          case "end":
                            return _context24.stop();
                        }
                      }, _callee24);
                    }));
                    return function (_x17) {
                      return _ref17.apply(this, arguments);
                    };
                  }()));
                case 6:
                  _this.setState({
                    serverResponse: {
                      status: "SUCCESS",
                      message: "আবেদনসমূহ সফলভাবে নির্বাচন করা হয়েছে!"
                    }
                  });
                  _context25.next = 13;
                  break;
                case 9:
                  _context25.prev = 9;
                  _context25.t0 = _context25["catch"](3);
                  console.error("Bulk selection failed:", _context25.t0);
                  _this.setState({
                    serverResponse: {
                      status: "ERROR",
                      message: "একাধিক আবেদন নির্বাচন ব্যর্থ হয়েছে!"
                    }
                  });
                case 13:
                  _context25.prev = 13;
                  //historyPush(modulesManager, history, "/home");
                  history.push("/");
                  window.location.reload();
                  return _context25.finish(13);
                case 17:
                  _this.setState({
                    confirmModalOpen: false,
                    confirmModalCallback: null,
                    loader: false
                  });
                case 18:
                case "end":
                  return _context25.stop();
              }
            }, _callee25, null, [[3, 9, 13, 17]]);
          }));
          function confirmModalCallback(_x16) {
            return _confirmModalCallback8.apply(this, arguments);
          }
          return confirmModalCallback;
        }()
      });
    });
    _defineProperty(_this, "handleBulkSelectedbyChecker", function () {
      var selectedApplicationIds = _this.state.selectedApplicationIds;
      var _this$props14 = _this.props,
        loggedInUserId = _this$props14.loggedInUserId,
        userRights = _this$props14.userRights,
        fetchWorkforceDocument = _this$props14.fetchWorkforceDocument,
        updateApplication = _this$props14.updateApplication,
        createApplicationMovement = _this$props14.createApplicationMovement,
        modulesManager = _this$props14.modulesManager,
        roles = _this$props14.roles;
      getUserTypeFromRights(_this.props.userRights);
      handleBulkSelectedByCheckerLogic({
        selectedApplicationIds: selectedApplicationIds,
        loggedInUserId: loggedInUserId,
        userRights: userRights,
        fetchWorkforceDocument: fetchWorkforceDocument,
        updateApplication: updateApplication,
        createApplicationMovement: createApplicationMovement,
        modulesManager: modulesManager,
        roles: roles,
        setServerResponse: function setServerResponse(res) {
          return _this.setState({
            serverResponse: res
          });
        },
        setConfirmModalOpen: function setConfirmModalOpen(val) {
          return _this.setState({
            confirmModalOpen: val
          });
        },
        setConfirmModalMessage: function setConfirmModalMessage(msg) {
          return _this.setState({
            confirmModalMessage: msg
          });
        },
        setConfirmModalCallback: function setConfirmModalCallback(cb) {
          return _this.setState({
            confirmModalCallback: cb
          });
        },
        history: _this.props.history,
        dispatch: _this.props.dispatch,
        setCloseLoader: function setCloseLoader(l) {
          return _this.setState({
            loader: l
          });
        },
        loader: _this.state.loader
      });
    });
    _defineProperty(_this, "handleBulkSelectedbyFactoryAdmin", function () {
      var selectedApplicationIds = _this.state.selectedApplicationIds;
      var _this$props15 = _this.props,
        loggedInUserId = _this$props15.loggedInUserId,
        history = _this$props15.history;
      console.log("FACTORYADMINWEEE", loggedInUserId);
      if (selectedApplicationIds.length === 0) {
        alert("Please select at least one application.");
        return;
      }
      _this.setState({
        confirmModalOpen: true,
        confirmModalMessage: "workforce.application.forward.message.toAssociation",
        confirmModalCallback: function () {
          var _confirmModalCallback9 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee27(confirmed) {
            var _this$props16, _updateApplication3, _createApplicationMovement3;
            return _regeneratorRuntime.wrap(function _callee27$(_context27) {
              while (1) switch (_context27.prev = _context27.next) {
                case 0:
                  if (!confirmed) {
                    _context27.next = 17;
                    break;
                  }
                  _this.setState({
                    loader: true
                  });
                  _this$props16 = _this.props, _updateApplication3 = _this$props16.updateApplication, _createApplicationMovement3 = _this$props16.createApplicationMovement;
                  _context27.prev = 3;
                  _context27.next = 6;
                  return Promise.all(selectedApplicationIds.map(/*#__PURE__*/function () {
                    var _ref18 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee26(selectedItem) {
                      var decodedId, updateApplicationData, createApplicationMovementData;
                      return _regeneratorRuntime.wrap(function _callee26$(_context26) {
                        while (1) switch (_context26.prev = _context26.next) {
                          case 0:
                            decodedId = decodeId(selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.id);
                            updateApplicationData = {
                              id: decodedId,
                              status: WORKFORCE_STATUS$1.FORWARD_TO_ASSOCIATION
                            };
                            createApplicationMovementData = {
                              applicationId: decodedId,
                              status: WORKFORCE_STATUS$1.FORWARD_TO_ASSOCIATION,
                              note: "অ্যাসোসিয়েশনের কাছে প্রেরণ",
                              action: "forward_to_association",
                              applicationFromId: loggedInUserId,
                              applicationToId: 93,
                              toRoleId: 31
                            };
                            _context26.next = 5;
                            return _updateApplication3(updateApplicationData, "update workforce application");
                          case 5:
                            _context26.next = 7;
                            return _createApplicationMovement3(createApplicationMovementData, "create workforce movement");
                          case 7:
                          case "end":
                            return _context26.stop();
                        }
                      }, _callee26);
                    }));
                    return function (_x19) {
                      return _ref18.apply(this, arguments);
                    };
                  }()));
                case 6:
                  _this.setState({
                    serverResponse: {
                      status: "SUCCESS",
                      message: "আবেদনসমূহ সফলভাবে নির্বাচন করা হয়েছে!"
                    }
                  });
                  _context27.next = 13;
                  break;
                case 9:
                  _context27.prev = 9;
                  _context27.t0 = _context27["catch"](3);
                  console.error("Bulk selection failed:", _context27.t0);
                  _this.setState({
                    serverResponse: {
                      status: "ERROR",
                      message: "একাধিক আবেদন নির্বাচন ব্যর্থ হয়েছে!"
                    }
                  });
                case 13:
                  _context27.prev = 13;
                  //historyPush(modulesManager, history, "/home");
                  history.push("/");
                  window.location.reload();
                  return _context27.finish(13);
                case 17:
                  _this.setState({
                    confirmModalOpen: false,
                    confirmModalCallback: null,
                    loader: false
                  });
                case 18:
                case "end":
                  return _context27.stop();
              }
            }, _callee27, null, [[3, 9, 13, 17]]);
          }));
          function confirmModalCallback(_x18) {
            return _confirmModalCallback9.apply(this, arguments);
          }
          return confirmModalCallback;
        }()
      });
    });
    _defineProperty(_this, "handleBulkSelectedbySectionAdmin", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee30() {
      var selectedApplicationIds, history;
      return _regeneratorRuntime.wrap(function _callee30$(_context30) {
        while (1) switch (_context30.prev = _context30.next) {
          case 0:
            selectedApplicationIds = _this.state.selectedApplicationIds;
            history = _this.props.history;
            if (!(selectedApplicationIds.length === 0)) {
              _context30.next = 5;
              break;
            }
            alert("Please select at least one application.");
            return _context30.abrupt("return");
          case 5:
            _this.setState({
              confirmModalOpen: true,
              confirmModalMessage: "workforce.application.forward.message.toSectionUser",
              confirmModalCallback: function () {
                var _confirmModalCallback10 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee29(confirmed) {
                  var _this$props17, _updateApplication4, _createApplicationMovement4;
                  return _regeneratorRuntime.wrap(function _callee29$(_context29) {
                    while (1) switch (_context29.prev = _context29.next) {
                      case 0:
                        if (!confirmed) {
                          _context29.next = 17;
                          break;
                        }
                        _this.setState({
                          loader: true
                        });
                        _this$props17 = _this.props, _updateApplication4 = _this$props17.updateApplication, _createApplicationMovement4 = _this$props17.createApplicationMovement;
                        _context29.prev = 3;
                        _context29.next = 6;
                        return Promise.all(selectedApplicationIds.map(/*#__PURE__*/function () {
                          var _ref20 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee28(selectedItem) {
                            var decodedId, updateApplicationData, createApplicationMovementData;
                            return _regeneratorRuntime.wrap(function _callee28$(_context28) {
                              while (1) switch (_context28.prev = _context28.next) {
                                case 0:
                                  decodedId = decodeId(selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.id);
                                  updateApplicationData = {
                                    id: decodedId,
                                    status: WORKFORCE_STATUS$1.FORWARD_TO_CF_SECTION_ONE
                                  };
                                  createApplicationMovementData = {
                                    applicationId: decodedId,
                                    status: WORKFORCE_STATUS$1.FORWARD_TO_CF_SECTION_ONE,
                                    note: "আবেদন সিএফ শাখা-১ এ প্রেরণ করা হয়েছে",
                                    action: "forward_to_cf_section_one"
                                  };
                                  _context28.next = 5;
                                  return _updateApplication4(updateApplicationData, "update workforce application");
                                case 5:
                                  _context28.next = 7;
                                  return _createApplicationMovement4(createApplicationMovementData, "create workforce movement");
                                case 7:
                                case "end":
                                  return _context28.stop();
                              }
                            }, _callee28);
                          }));
                          return function (_x21) {
                            return _ref20.apply(this, arguments);
                          };
                        }()));
                      case 6:
                        _this.setState({
                          serverResponse: {
                            status: "SUCCESS",
                            message: "আবেদনসমূহ সফলভাবে নির্বাচন করা হয়েছে!"
                          }
                        });
                        _context29.next = 13;
                        break;
                      case 9:
                        _context29.prev = 9;
                        _context29.t0 = _context29["catch"](3);
                        console.error("Bulk selection failed:", _context29.t0);
                        _this.setState({
                          serverResponse: {
                            status: "ERROR",
                            message: "একাধিক আবেদন নির্বাচন ব্যর্থ হয়েছে!"
                          }
                        });
                      case 13:
                        _context29.prev = 13;
                        //historyPush(modulesManager, history, "/home");
                        history.push("/");
                        window.location.reload();
                        return _context29.finish(13);
                      case 17:
                        _this.setState({
                          confirmModalOpen: false,
                          confirmModalCallback: null,
                          loader: false
                        });
                      case 18:
                      case "end":
                        return _context29.stop();
                    }
                  }, _callee29, null, [[3, 9, 13, 17]]);
                }));
                function confirmModalCallback(_x20) {
                  return _confirmModalCallback10.apply(this, arguments);
                }
                return confirmModalCallback;
              }()
            });
          case 6:
          case "end":
            return _context30.stop();
        }
      }, _callee30);
    })));
    _defineProperty(_this, "handleBulkSelectedbySectionTwoAdmin", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee33() {
      var selectedApplicationIds, history;
      return _regeneratorRuntime.wrap(function _callee33$(_context33) {
        while (1) switch (_context33.prev = _context33.next) {
          case 0:
            selectedApplicationIds = _this.state.selectedApplicationIds;
            history = _this.props.history;
            if (!(selectedApplicationIds.length === 0)) {
              _context33.next = 5;
              break;
            }
            alert("Please select at least one application.");
            return _context33.abrupt("return");
          case 5:
            _this.setState({
              confirmModalOpen: true,
              confirmModalMessage: "workforce.application.forward.message.toSectionUser",
              confirmModalCallback: function () {
                var _confirmModalCallback11 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee32(confirmed) {
                  var _this$props18, _updateApplication5, _createApplicationMovement5;
                  return _regeneratorRuntime.wrap(function _callee32$(_context32) {
                    while (1) switch (_context32.prev = _context32.next) {
                      case 0:
                        if (!confirmed) {
                          _context32.next = 17;
                          break;
                        }
                        _this.setState({
                          loader: true
                        });
                        _this$props18 = _this.props, _updateApplication5 = _this$props18.updateApplication, _createApplicationMovement5 = _this$props18.createApplicationMovement;
                        _context32.prev = 3;
                        _context32.next = 6;
                        return Promise.all(selectedApplicationIds.map(/*#__PURE__*/function () {
                          var _ref22 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee31(selectedItem) {
                            var decodedId, updateApplicationData, createApplicationMovementData;
                            return _regeneratorRuntime.wrap(function _callee31$(_context31) {
                              while (1) switch (_context31.prev = _context31.next) {
                                case 0:
                                  decodedId = decodeId(selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.id);
                                  updateApplicationData = {
                                    id: decodedId,
                                    status: WORKFORCE_STATUS$1.FORWARD_TO_CF_SECTION_TWO
                                  };
                                  createApplicationMovementData = {
                                    applicationId: decodedId,
                                    status: WORKFORCE_STATUS$1.FORWARD_TO_CF_SECTION_TWO,
                                    note: "আবেদন সিএফ শাখা-২ এ প্রেরণ করা হয়েছে",
                                    action: "forward_to_cf_section_two"
                                  };
                                  _context31.next = 5;
                                  return _updateApplication5(updateApplicationData, "update workforce application");
                                case 5:
                                  _context31.next = 7;
                                  return _createApplicationMovement5(createApplicationMovementData, "create workforce movement");
                                case 7:
                                case "end":
                                  return _context31.stop();
                              }
                            }, _callee31);
                          }));
                          return function (_x23) {
                            return _ref22.apply(this, arguments);
                          };
                        }()));
                      case 6:
                        _this.setState({
                          serverResponse: {
                            status: "SUCCESS",
                            message: "আবেদনসমূহ সফলভাবে নির্বাচন করা হয়েছে!"
                          }
                        });
                        _context32.next = 13;
                        break;
                      case 9:
                        _context32.prev = 9;
                        _context32.t0 = _context32["catch"](3);
                        console.error("Bulk selection failed:", _context32.t0);
                        _this.setState({
                          serverResponse: {
                            status: "ERROR",
                            message: "একাধিক আবেদন নির্বাচন ব্যর্থ হয়েছে!"
                          }
                        });
                      case 13:
                        _context32.prev = 13;
                        //historyPush(modulesManager, history, "/home");
                        history.push("/");
                        window.location.reload();
                        return _context32.finish(13);
                      case 17:
                        _this.setState({
                          confirmModalOpen: false,
                          confirmModalCallback: null,
                          loader: false
                        });
                      case 18:
                      case "end":
                        return _context32.stop();
                    }
                  }, _callee32, null, [[3, 9, 13, 17]]);
                }));
                function confirmModalCallback(_x22) {
                  return _confirmModalCallback11.apply(this, arguments);
                }
                return confirmModalCallback;
              }()
            });
          case 6:
          case "end":
            return _context33.stop();
        }
      }, _callee33);
    })));
    _defineProperty(_this, "handleBulkApproveByAdmin", function () {
      var selectedApplicationIds = _this.state.selectedApplicationIds;
      var _this$props19 = _this.props,
        loggedInUserId = _this$props19.loggedInUserId,
        history = _this$props19.history;
      var userType = getUserTypeFromRights(_this.props.userRights);
      if (selectedApplicationIds.length === 0) {
        alert("Please select at least one application.");
        return;
      }
      _this.setState({
        confirmModalOpen: true,
        confirmModalMessage: "workforce.application.approve.message",
        confirmModalCallback: function () {
          var _confirmModalCallback12 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee35(confirmed) {
            var _this$props20, _updateApplication6, _createApplicationMovement6, _updateApplicationSummary;
            return _regeneratorRuntime.wrap(function _callee35$(_context35) {
              while (1) switch (_context35.prev = _context35.next) {
                case 0:
                  if (!confirmed) {
                    _context35.next = 17;
                    break;
                  }
                  _this.setState({
                    loader: true
                  });
                  _this$props20 = _this.props, _updateApplication6 = _this$props20.updateApplication, _createApplicationMovement6 = _this$props20.createApplicationMovement, _updateApplicationSummary = _this$props20.updateApplicationSummary;
                  _context35.prev = 3;
                  _context35.next = 6;
                  return Promise.all(selectedApplicationIds.map(/*#__PURE__*/function () {
                    var _ref23 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee34(selectedItem) {
                      var decodedId, updateApplicationData, createApplicationMovementData, updateApplicationSummaryData;
                      return _regeneratorRuntime.wrap(function _callee34$(_context34) {
                        while (1) switch (_context34.prev = _context34.next) {
                          case 0:
                            decodedId = decodeId(selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.id);
                            updateApplicationData = {
                              id: decodedId,
                              status: userType === WORKFORCE_USER_TYPE.ADMIN ? WORKFORCE_STATUS$1.APPROVED_BY_DG : userType === WORKFORCE_USER_TYPE.SECRETARY ? WORKFORCE_STATUS$1.APPROVED_BY_SECRETARY : userType === WORKFORCE_USER_TYPE.MINISTER ? WORKFORCE_STATUS$1.APPROVED_BY_MINISTER : "",
                              grantAmount: _this.state.editedGrantMoney
                            };
                            createApplicationMovementData = {
                              applicationId: decodedId,
                              status: userType === WORKFORCE_USER_TYPE.ADMIN ? WORKFORCE_STATUS$1.APPROVED_BY_DG : userType === WORKFORCE_USER_TYPE.SECRETARY ? WORKFORCE_STATUS$1.APPROVED_BY_SECRETARY : userType === WORKFORCE_USER_TYPE.MINISTER ? WORKFORCE_STATUS$1.APPROVED_BY_MINISTER : "",
                              note: "আবেদন ডিজি দ্বারা অনুমোদন করা হয়েছে",
                              action: "approved_by_dg",
                              applicationFromId: loggedInUserId,
                              applicationToId: 1,
                              toRoleId: 1
                            };
                            updateApplicationSummaryData = {
                              id: decodeId(_this.props.summaryId),
                              status: userType === WORKFORCE_USER_TYPE.ADMIN ? WORKFORCE_STATUS$1.APPROVED_BY_DG : userType === WORKFORCE_USER_TYPE.SECRETARY ? WORKFORCE_STATUS$1.APPROVED_BY_SECRETARY : userType === WORKFORCE_USER_TYPE.MINISTER ? WORKFORCE_STATUS$1.APPROVED_BY_MINISTER : ""
                            };
                            _context34.next = 6;
                            return _updateApplication6(updateApplicationData, "update workforce application");
                          case 6:
                            _context34.next = 8;
                            return _createApplicationMovement6(createApplicationMovementData, "create workforce movement");
                          case 8:
                            _context34.next = 10;
                            return _updateApplicationSummary(updateApplicationSummaryData, "update workforce application summary");
                          case 10:
                          case "end":
                            return _context34.stop();
                        }
                      }, _callee34);
                    }));
                    return function (_x25) {
                      return _ref23.apply(this, arguments);
                    };
                  }()));
                case 6:
                  _this.setState({
                    serverResponse: {
                      status: "SUCCESS",
                      message: "আবেদনসমূহ সফলভাবে নির্বাচন করা হয়েছে!"
                    }
                  });
                  //historyPush(modulesManager, history, "/home");
                  history.push("/");
                  window.location.reload();
                  _context35.next = 17;
                  break;
                case 11:
                  _context35.prev = 11;
                  _context35.t0 = _context35["catch"](3);
                  console.error("Bulk selection failed:", _context35.t0);
                  _this.setState({
                    serverResponse: {
                      status: "ERROR",
                      message: "একাধিক আবেদন নির্বাচন ব্যর্থ হয়েছে!"
                    }
                  });
                  //historyPush(modulesManager, history, "/home");
                  history.push("/");
                  window.location.reload();
                case 17:
                  _this.setState({
                    confirmModalOpen: false,
                    confirmModalCallback: null,
                    loader: false
                  });
                case 18:
                case "end":
                  return _context35.stop();
              }
            }, _callee35, null, [[3, 11]]);
          }));
          function confirmModalCallback(_x24) {
            return _confirmModalCallback12.apply(this, arguments);
          }
          return confirmModalCallback;
        }()
      });
    });
    _defineProperty(_this, "handleBulkApproveByDirector", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee38() {
      var selectedApplicationIds, _this$props21, _this$props22, loggedInUserId, history;
      return _regeneratorRuntime.wrap(function _callee38$(_context38) {
        while (1) switch (_context38.prev = _context38.next) {
          case 0:
            selectedApplicationIds = _this.state.selectedApplicationIds;
            _this$props21 = _this.props, _this$props21.updateApplication, _this$props21.createApplicationMovement, _this$props21.updateApplicationSummary;
            _this$props22 = _this.props, loggedInUserId = _this$props22.loggedInUserId, history = _this$props22.history;
            if (!(selectedApplicationIds.length === 0)) {
              _context38.next = 6;
              break;
            }
            alert("Please select at least one application.");
            return _context38.abrupt("return");
          case 6:
            _this.setState({
              confirmModalOpen: true,
              confirmModalMessage: "workforce.application.approve.message",
              confirmModalCallback: function () {
                var _confirmModalCallback13 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee37(confirmed) {
                  var _this$props23, _updateApplication7, _createApplicationMovement7, _updateApplicationSummary2;
                  return _regeneratorRuntime.wrap(function _callee37$(_context37) {
                    while (1) switch (_context37.prev = _context37.next) {
                      case 0:
                        if (!confirmed) {
                          _context37.next = 17;
                          break;
                        }
                        _this.setState({
                          loader: true
                        });
                        _context37.prev = 2;
                        _this$props23 = _this.props, _updateApplication7 = _this$props23.updateApplication, _createApplicationMovement7 = _this$props23.createApplicationMovement, _updateApplicationSummary2 = _this$props23.updateApplicationSummary;
                        _context37.next = 6;
                        return Promise.all(selectedApplicationIds === null || selectedApplicationIds === void 0 ? void 0 : selectedApplicationIds.map(/*#__PURE__*/function () {
                          var _ref25 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee36(selectedItem) {
                            var decodedId, updateApplicationData, createApplicationMovementData, updateApplicationSummaryData;
                            return _regeneratorRuntime.wrap(function _callee36$(_context36) {
                              while (1) switch (_context36.prev = _context36.next) {
                                case 0:
                                  decodedId = decodeId(selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.id);
                                  updateApplicationData = {
                                    id: decodedId,
                                    status: WORKFORCE_STATUS$1.APPROVED_BY_DIRECTOR,
                                    grantAmount: _this.state.editedGrantMoney
                                  };
                                  createApplicationMovementData = {
                                    applicationId: decodedId,
                                    status: WORKFORCE_STATUS$1.APPROVED_BY_DIRECTOR,
                                    note: "আবেদন পরিচালক দ্বারা অনুমোদন করা হয়েছে",
                                    action: "approved_by_director",
                                    applicationFromId: loggedInUserId,
                                    applicationToId: 1,
                                    toRoleId: 1
                                  };
                                  updateApplicationSummaryData = {
                                    id: decodeId(_this.props.summaryId),
                                    status: WORKFORCE_STATUS$1.APPROVED_BY_DIRECTOR
                                  }; // console.log("summay row id", id);
                                  _context36.next = 6;
                                  return _updateApplication7(updateApplicationData, "update workforce application");
                                case 6:
                                  _context36.next = 8;
                                  return _createApplicationMovement7(createApplicationMovementData, "create workforce movement");
                                case 8:
                                  _context36.next = 10;
                                  return _updateApplicationSummary2(updateApplicationSummaryData, "update workforce application summary");
                                case 10:
                                case "end":
                                  return _context36.stop();
                              }
                            }, _callee36);
                          }));
                          return function (_x27) {
                            return _ref25.apply(this, arguments);
                          };
                        }()));
                      case 6:
                        _this.setState({
                          serverResponse: {
                            status: "SUCCESS",
                            message: "আবেদনসমূহ সফলভাবে নির্বাচন করা হয়েছে!"
                          }
                        });
                        _context37.next = 13;
                        break;
                      case 9:
                        _context37.prev = 9;
                        _context37.t0 = _context37["catch"](2);
                        console.error("Bulk selection failed:", _context37.t0);
                        _this.setState({
                          serverResponse: {
                            status: "ERROR",
                            message: "একাধিক আবেদন নির্বাচন ব্যর্থ হয়েছে!"
                          }
                        });
                      case 13:
                        _context37.prev = 13;
                        //historyPush(modulesManager, history, "/home");
                        history.push("/");
                        window.location.reload();
                        return _context37.finish(13);
                      case 17:
                        _this.setState({
                          confirmModalOpen: false,
                          confirmModalCallback: null,
                          loader: false
                        });
                      case 18:
                      case "end":
                        return _context37.stop();
                    }
                  }, _callee37, null, [[2, 9, 13, 17]]);
                }));
                function confirmModalCallback(_x26) {
                  return _confirmModalCallback13.apply(this, arguments);
                }
                return confirmModalCallback;
              }()
            });
          case 7:
          case "end":
            return _context38.stop();
        }
      }, _callee38);
    })));
    _defineProperty(_this, "handleBulkApproveByEisAdvisor", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee41() {
      var selectedApplicationIds, _this$props24, _this$props25, loggedInUserId, history;
      return _regeneratorRuntime.wrap(function _callee41$(_context41) {
        while (1) switch (_context41.prev = _context41.next) {
          case 0:
            selectedApplicationIds = _this.state.selectedApplicationIds;
            _this$props24 = _this.props, _this$props24.updateApplication, _this$props24.createApplicationMovement, _this$props24.updateApplicationSummary;
            _this$props25 = _this.props, loggedInUserId = _this$props25.loggedInUserId, history = _this$props25.history;
            if (!(selectedApplicationIds.length === 0)) {
              _context41.next = 6;
              break;
            }
            alert("Please select at least one application.");
            return _context41.abrupt("return");
          case 6:
            _this.setState({
              confirmModalOpen: true,
              confirmModalMessage: "workforce.application.approve.message",
              confirmModalCallback: function () {
                var _confirmModalCallback14 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee40(confirmed) {
                  var _this$props26, _updateApplication8, _createApplicationMovement8, _updateApplicationSummary3;
                  return _regeneratorRuntime.wrap(function _callee40$(_context40) {
                    while (1) switch (_context40.prev = _context40.next) {
                      case 0:
                        if (!confirmed) {
                          _context40.next = 17;
                          break;
                        }
                        _this.setState({
                          loader: true
                        });
                        _context40.prev = 2;
                        _this$props26 = _this.props, _updateApplication8 = _this$props26.updateApplication, _createApplicationMovement8 = _this$props26.createApplicationMovement, _updateApplicationSummary3 = _this$props26.updateApplicationSummary;
                        _context40.next = 6;
                        return Promise.all(selectedApplicationIds === null || selectedApplicationIds === void 0 ? void 0 : selectedApplicationIds.map(/*#__PURE__*/function () {
                          var _ref27 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee39(selectedItem) {
                            var decodedId, updateApplicationData, createApplicationMovementData, updateApplicationSummaryData;
                            return _regeneratorRuntime.wrap(function _callee39$(_context39) {
                              while (1) switch (_context39.prev = _context39.next) {
                                case 0:
                                  decodedId = decodeId(selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.id);
                                  updateApplicationData = {
                                    id: decodedId,
                                    status: WORKFORCE_STATUS$1.APPROVED_BY_EIS_ADVISOR,
                                    grantAmount: _this.state.editedGrantMoney
                                  };
                                  createApplicationMovementData = {
                                    applicationId: decodedId,
                                    status: WORKFORCE_STATUS$1.APPROVED_BY_EIS_ADVISOR,
                                    note: "আবেদন ইআইএস উপদেষ্টা দ্বারা অনুমোদন করা হয়েছে",
                                    action: "approved_by_eis_advisor",
                                    applicationFromId: loggedInUserId,
                                    applicationToId: 173,
                                    toRoleId: 42
                                  };
                                  updateApplicationSummaryData = {
                                    id: decodeId(_this.props.summaryId),
                                    status: WORKFORCE_STATUS$1.APPROVED_BY_EIS_ADVISOR
                                  }; // console.log("summay row id", id);
                                  _context39.next = 6;
                                  return _updateApplication8(updateApplicationData, "update workforce application");
                                case 6:
                                  _context39.next = 8;
                                  return _createApplicationMovement8(createApplicationMovementData, "create workforce movement");
                                case 8:
                                  _context39.next = 10;
                                  return _updateApplicationSummary3(updateApplicationSummaryData, "update workforce application summary");
                                case 10:
                                case "end":
                                  return _context39.stop();
                              }
                            }, _callee39);
                          }));
                          return function (_x29) {
                            return _ref27.apply(this, arguments);
                          };
                        }()));
                      case 6:
                        _this.setState({
                          serverResponse: {
                            status: "SUCCESS",
                            message: "আবেদনসমূহ সফলভাবে নির্বাচন করা হয়েছে!"
                          }
                        });
                        _context40.next = 13;
                        break;
                      case 9:
                        _context40.prev = 9;
                        _context40.t0 = _context40["catch"](2);
                        console.error("Bulk selection failed:", _context40.t0);
                        _this.setState({
                          serverResponse: {
                            status: "ERROR",
                            message: "একাধিক আবেদন নির্বাচন ব্যর্থ হয়েছে!"
                          }
                        });
                      case 13:
                        _context40.prev = 13;
                        //historyPush(modulesManager, history, "/home");
                        history.push("/");
                        window.location.reload();
                        return _context40.finish(13);
                      case 17:
                        _this.setState({
                          confirmModalOpen: false,
                          confirmModalCallback: null,
                          loader: false
                        });
                      case 18:
                      case "end":
                        return _context40.stop();
                    }
                  }, _callee40, null, [[2, 9, 13, 17]]);
                }));
                function confirmModalCallback(_x28) {
                  return _confirmModalCallback14.apply(this, arguments);
                }
                return confirmModalCallback;
              }()
            });
          case 7:
          case "end":
            return _context41.stop();
        }
      }, _callee41);
    })));
    _defineProperty(_this, "handleBulkSelectedbyEisCommittee", function () {
      var selectedApplicationIds = _this.state.selectedApplicationIds;
      var _this$props27 = _this.props,
        loggedInUserId = _this$props27.loggedInUserId,
        history = _this$props27.history;
      if (!selectedApplicationIds || selectedApplicationIds.length === 0) {
        alert("Please select at least one application.");
        return;
      }
      _this.setState({
        confirmModalOpen: true,
        confirmModalMessage: "workforce.application.forward.message.toEisCoordinator",
        confirmModalCallback: function () {
          var _confirmModalCallback15 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee43(confirmed) {
            var _this$props28, updateApplication, createApplicationMovement, updateApplicationSummary, allHaveMajority;
            return _regeneratorRuntime.wrap(function _callee43$(_context43) {
              while (1) switch (_context43.prev = _context43.next) {
                case 0:
                  if (confirmed) {
                    _context43.next = 3;
                    break;
                  }
                  _this.setState({
                    confirmModalOpen: false,
                    confirmModalCallback: null
                  });
                  return _context43.abrupt("return");
                case 3:
                  _this$props28 = _this.props, updateApplication = _this$props28.updateApplication, createApplicationMovement = _this$props28.createApplicationMovement, updateApplicationSummary = _this$props28.updateApplicationSummary;
                  _context43.prev = 4;
                  /* -------------------------------------------------
                     STEP 1: Validate Majority Approval For ALL
                  ------------------------------------------------- */
                  _this.setState({
                    loader: true
                  });
                  allHaveMajority = selectedApplicationIds.every(function (item) {
                    var approvalUserIds = item !== null && item !== void 0 && item.eisApprovalIds ? safeParse(item.eisApprovalIds) : [];
                    var approvedUserIds = item !== null && item !== void 0 && item.eisApprovedByIds ? safeParse(item.eisApprovedByIds) : [];
                    var totalApprovals = Array.isArray(approvalUserIds) && approvalUserIds.length > 0 ? approvalUserIds.length : 1;
                    var totalApproved = Array.isArray(approvedUserIds) ? approvedUserIds.length : 0;
                    if (totalApprovals === 0) return false;
                    return totalApproved / totalApprovals > 0.5;
                  });
                  /* -------------------------------------------------
                     STEP 2: Stop If Any Application Fails
                  ------------------------------------------------- */
                  if (allHaveMajority) {
                    _context43.next = 10;
                    break;
                  }
                  _this.setState({
                    serverResponse: {
                      status: "ERROR",
                      message: "অন্ততঃ একটি নির্বাচিত আবেদন মেজরিটি অনুমোদনপ্রাপ্ত নয়! অনুগ্রহ করে কমিটি সদস্যদের অনুমোদন প্রদান করতে বলুন"
                    }
                  });
                  return _context43.abrupt("return");
                case 10:
                  _context43.next = 12;
                  return Promise.all(selectedApplicationIds.map(/*#__PURE__*/function () {
                    var _ref28 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee42(item) {
                      var decodedId, updateApplicationData, createApplicationMovementData;
                      return _regeneratorRuntime.wrap(function _callee42$(_context42) {
                        while (1) switch (_context42.prev = _context42.next) {
                          case 0:
                            decodedId = decodeId(item === null || item === void 0 ? void 0 : item.id);
                            updateApplicationData = {
                              id: decodedId,
                              status: WORKFORCE_STATUS$1.APPROVED_BY_COMMITTEE
                            };
                            createApplicationMovementData = {
                              applicationId: decodedId,
                              status: WORKFORCE_STATUS$1.APPROVED_BY_DG,
                              note: "আবেদন কমিটি দ্বারা অনুমোদন করা হয়েছে",
                              action: "approved_by_committee",
                              applicationFromId: loggedInUserId,
                              applicationToId: 173,
                              toRoleId: 42
                            };
                            _context42.next = 5;
                            return updateApplication(updateApplicationData, "update workforce application");
                          case 5:
                            _context42.next = 7;
                            return createApplicationMovement(createApplicationMovementData, "create workforce movement");
                          case 7:
                          case "end":
                            return _context42.stop();
                        }
                      }, _callee42);
                    }));
                    return function (_x31) {
                      return _ref28.apply(this, arguments);
                    };
                  }()));
                case 12:
                  _context43.next = 14;
                  return updateApplicationSummary({
                    id: decodeId(_this.props.summaryId),
                    status: WORKFORCE_STATUS$1.APPROVED_BY_COMMITTEE
                  }, "update workforce application summary");
                case 14:
                  _this.setState({
                    serverResponse: {
                      status: "SUCCESS",
                      message: "আবেদনসমূহ সফলভাবে নির্বাচন করা হয়েছে!"
                    }
                  });
                  //historyPush(modulesManager, history, "/home");
                  history.push("/");
                  window.location.reload();
                  _context43.next = 23;
                  break;
                case 19:
                  _context43.prev = 19;
                  _context43.t0 = _context43["catch"](4);
                  console.error("Bulk selection failed:", _context43.t0);
                  _this.setState({
                    serverResponse: {
                      status: "ERROR",
                      message: "একাধিক আবেদন নির্বাচন ব্যর্থ হয়েছে!"
                    }
                  });
                case 23:
                  _this.setState({
                    confirmModalOpen: false,
                    confirmModalCallback: null,
                    loader: false
                  });
                case 24:
                case "end":
                  return _context43.stop();
              }
            }, _callee43, null, [[4, 19]]);
          }));
          function confirmModalCallback(_x30) {
            return _confirmModalCallback15.apply(this, arguments);
          }
          return confirmModalCallback;
        }()
      });
    });
    _defineProperty(_this, "handleUpdateGrantMoney", /*#__PURE__*/function () {
      var _ref29 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee44(application) {
        var updateApplication, decodedId, updateApplicationData;
        return _regeneratorRuntime.wrap(function _callee44$(_context44) {
          while (1) switch (_context44.prev = _context44.next) {
            case 0:
              updateApplication = _this.props.updateApplication;
              decodedId = safeDecodeId(application === null || application === void 0 ? void 0 : application.id);
              updateApplicationData = {
                id: decodedId,
                grantAmount: _this.state.editedGrantMoney
              };
              _context44.next = 5;
              return updateApplication(updateApplicationData, "update workforce application");
            case 5:
            case "end":
              return _context44.stop();
          }
        }, _callee44);
      }));
      return function (_x32) {
        return _ref29.apply(this, arguments);
      };
    }());
    _defineProperty(_this, "handleApprovalByEisCommittee", function (selectedItem) {
      var _this$props29 = _this.props,
        loggedInUserId = _this$props29.loggedInUserId,
        history = _this$props29.history;
      var majorityApproved = false;
      _this.setState({
        confirmModalOpen: true,
        confirmModalMessage: "workforce.application.forward.message.toEisCoordinator",
        confirmModalCallback: function () {
          var _confirmModalCallback16 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee45(confirmed) {
            var _this$props30, _updateApplication9, approvalUserIds, approvedUserIds, numberOfApprovals, numberOfApproved, decodedId, updateApplicationData;
            return _regeneratorRuntime.wrap(function _callee45$(_context45) {
              while (1) switch (_context45.prev = _context45.next) {
                case 0:
                  if (!confirmed) {
                    _context45.next = 28;
                    break;
                  }
                  _this.setState({
                    loader: true
                  });
                  _this$props30 = _this.props, _updateApplication9 = _this$props30.updateApplication, _this$props30.createApplicationMovement, _this$props30.updateApplicationSummary;
                  _context45.prev = 3;
                  approvalUserIds = selectedItem !== null && selectedItem !== void 0 && selectedItem.eisApprovalIds ? safeParse(selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.eisApprovalIds) : [];
                  approvedUserIds = selectedItem !== null && selectedItem !== void 0 && selectedItem.eisApprovedByIds ? safeParse(selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.eisApprovedByIds) : [];
                  if (approvedUserIds.includes(loggedInUserId)) {
                    _context45.next = 10;
                    break;
                  }
                  approvedUserIds.push(loggedInUserId);
                  _context45.next = 12;
                  break;
                case 10:
                  _this.setState({
                    serverResponse: {
                      status: "ERROR",
                      message: "আপনি ইতিমধ্যে এই আবেদনটি অনুমোদন করেছেন!"
                    }
                  });
                  return _context45.abrupt("return");
                case 12:
                  numberOfApprovals = (approvalUserIds === null || approvalUserIds === void 0 ? void 0 : approvalUserIds.length) > 0 ? approvalUserIds === null || approvalUserIds === void 0 ? void 0 : approvalUserIds.length : 1;
                  numberOfApproved = (approvedUserIds === null || approvedUserIds === void 0 ? void 0 : approvedUserIds.length) > 0 ? approvedUserIds === null || approvedUserIds === void 0 ? void 0 : approvedUserIds.length : 0;
                  if (numberOfApprovals > 0) {
                    majorityApproved = numberOfApproved / numberOfApprovals > 0.5;
                  } else {
                    majorityApproved = true;
                  }
                  decodedId = decodeId(selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.id);
                  updateApplicationData = {
                    id: decodedId,
                    status: majorityApproved ? WORKFORCE_STATUS$1.APPROVED_BY_COMMITTEE : selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.status,
                    eisApprovedByIds: JSON.stringify(approvedUserIds)
                  }; // const createApplicationMovementData = {
                  //   applicationId: decodedId,
                  //   status: WORKFORCE_STATUS.APPROVED_BY_DG,
                  //   note: "আবেদন কমিটি দ্বারা অনুমোদন করা হয়েছে",
                  //   action: "approved_by_committee",
                  //   applicationFromId: loggedInUserId,
                  //   applicationToId: 173,
                  //   toRoleId: 42,
                  // };
                  // const updateApplicationSummaryData = {
                  //   id: decodeId(this.props.summaryId),
                  //   status: WORKFORCE_STATUS.APPROVED_BY_COMMITTEE,
                  // };
                  _context45.next = 19;
                  return _updateApplication9(updateApplicationData, "update workforce application");
                case 19:
                  // if (majorityApproved) {
                  //   await createApplicationMovement(createApplicationMovementData, "create workforce movement");
                  //   await updateApplicationSummary(updateApplicationSummaryData, "update workforce application summary");
                  // }
                  _this.setState({
                    serverResponse: {
                      status: "SUCCESS",
                      message: "নির্বাচিত আবেদনটির অনুমোদনের জন্য আপনার সাক্ষর গৃহিত হয়েছে। অপেক্ষা করুন যতক্ষণ না কমিটির অন্যান্য সদস্যরাও তাদের অনুমোদন প্রদান করেন।"
                      // message: majorityApproved?"নির্বাচিত আবেদনটিতে মেজরিটি অনুমোদন প্রাপ্ত হয়েছে এবং আবেদনটি অনুমোদিত হয়েছে" :"নির্বাচিত আবেদনটির অনুমোদনের জন্য আপনার সাক্ষর গৃহিত হয়েছে। অপেক্ষা করুন যতক্ষণ না কমিটির অন্যান্য সদস্যরাও তাদের অনুমোদন প্রদান করেন।",
                    }
                  });
                  //historyPush(modulesManager, history, "/home");
                  history.push("/");
                  window.location.reload();
                  _context45.next = 28;
                  break;
                case 24:
                  _context45.prev = 24;
                  _context45.t0 = _context45["catch"](3);
                  console.error("Approval failed:", _context45.t0);
                  _this.setState({
                    serverResponse: {
                      status: "ERROR",
                      message: "আবেদন অনুমোদন ব্যর্থ হয়েছে!"
                    }
                  });
                case 28:
                  _this.setState({
                    confirmModalOpen: false,
                    confirmModalCallback: null,
                    loader: false
                  });
                case 29:
                case "end":
                  return _context45.stop();
              }
            }, _callee45, null, [[3, 24]]);
          }));
          function confirmModalCallback(_x33) {
            return _confirmModalCallback16.apply(this, arguments);
          }
          return confirmModalCallback;
        }()
      });
    });
    _defineProperty(_this, "handleCloseBFTN", function () {
      _this.setState({
        openGenerateBFTN: false
      });
    });
    _defineProperty(_this, "handleCloseCommitteeReport", function () {
      _this.setState({
        openGenerateCommitteeReport: false
      });
    });
    _defineProperty(_this, "handleCloseEisBFTN", function () {
      _this.setState({
        openGenerateEisBFTN: false
      });
    });
    _defineProperty(_this, "handleCloseEisDependentBFTN", function () {
      _this.setState({
        openGenerateEisDependentBFTN: false
      });
    });
    _defineProperty(_this, "handleOpenBFTN", function () {
      _this.setState({
        openGenerateBFTN: true
      });
    });
    _defineProperty(_this, "handleOpenGenerateCommitteeReport", function () {
      _this.setState({
        openGenerateCommitteeReport: true
      });
    });
    _defineProperty(_this, "handleOpenEisBFTN", function () {
      _this.setState({
        openGenerateEisBFTN: true
      });
    });
    _defineProperty(_this, "handleOpenEisDependentBFTN", function () {
      _this.setState({
        openGenerateEisDependentBFTN: true
      });
    });
    _defineProperty(_this, "onCheckBoxSelect", function (selection) {
      _this.setState({
        selectedApplicationIds: selection
      });
    });
    _defineProperty(_this, "rowDisabled", function (selection, i) {
      return !!i.validityTo;
    });
    _defineProperty(_this, "rowLocked", function (selection, i) {
      return !!i.clientMutationId;
    });
    // Modal close handler for ConfirmModal
    _defineProperty(_this, "handleConfirmModalClose", function (result) {
      if (_this.state.confirmModalCallback) {
        _this.state.confirmModalCallback(result === 1);
      } else {
        _this.setState({
          confirmModalOpen: false
        });
      }
    });
    _defineProperty(_this, "handleConfirmRejectModalClose", function (result) {
      if (_this.state.confirmModalCallback) {
        _this.state.confirmModalCallback(result === 1);
      } else {
        _this.setState({
          openRejectModal: false
        });
      }
    });
    _defineProperty(_this, "handleAddComment", function (args) {
      _this.setState({
        rejectComment: args
      });
    });
    _this.state = {
      chfid: null,
      confirmedAction: null,
      reset: 0,
      showHistoryFilter: false,
      displayVersion: false,
      // 🆕 Modal state
      forwardModalOpen: false,
      forwardPaymentModalOpen: false,
      forwardModalOpenSA: false,
      forwardModalOpenEIS: false,
      forwardModalOpenEISToCoordinator: false,
      forwardModalOpenEisDoctor: false,
      forwardModalOpenSummarySA: false,
      forwardModalOpenFA: false,
      revertModalOpen: false,
      selectedApplication: null,
      selectedUserId: "",
      deadline: "",
      userList: [],
      openGenerateBFTN: false,
      openGenerateEisBFTN: false,
      openGenerateEisDependentBFTN: false,
      openEisApprovalSignature: false,
      submitting: false,
      serverResponse: null,
      editedGrantMoney: "",
      editorContent: "",
      selectedOffice: "",
      selectedSuboffice: "",
      selectedUser: "",
      selectedApplicationIds: [],
      revertByChecker: false,
      revertByFactoryAdmin: false,
      dynamicTableTitle: "",
      confirmModalOpen: false,
      rejectComment: "",
      modalFlag: "",
      openRejectModal: false,
      confirmModalMessage: "",
      confirmModalCallback: null,
      loader: false
    };
    _this.rowsPerPageOptions = [10, 20, 50, 100];
    _this.defaultPageSize = 10;
    return _this;
  }
  _inherits(ApplicationProcessSearcher, _Component);
  return _createClass(ApplicationProcessSearcher, [{
    key: "fetchApplicant",
    value: function () {
      var _fetchApplicant = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee46() {
        return _regeneratorRuntime.wrap(function _callee46$(_context46) {
          while (1) switch (_context46.prev = _context46.next) {
            case 0:
              _context46.next = 2;
              return this.props.fetchFactoryEmployee(this.props.modulesManager, ["relatedUser_LoginName_Iexact:\"".concat(this.props.userName, "\"")]);
            case 2:
            case "end":
              return _context46.stop();
          }
        }, _callee46, this);
      }));
      function fetchApplicant() {
        return _fetchApplicant.apply(this, arguments);
      }
      return fetchApplicant;
    }()
  }, {
    key: "render",
    value: function render() {
      var _this2 = this,
        _this$props$summaryDa,
        _this$state$serverRes,
        _this$state$serverRes2;
      var _this$state2 = this.state,
        forwardModalOpen = _this$state2.forwardModalOpen,
        forwardPaymentModalOpen = _this$state2.forwardPaymentModalOpen,
        forwardModalOpenSA = _this$state2.forwardModalOpenSA,
        forwardModalOpenEisDoctor = _this$state2.forwardModalOpenEisDoctor,
        forwardModalOpenEIS = _this$state2.forwardModalOpenEIS,
        forwardModalOpenEISToCoordinator = _this$state2.forwardModalOpenEISToCoordinator,
        revertModalOpen = _this$state2.revertModalOpen,
        revertByChecker = _this$state2.revertByChecker;
        _this$state2.revertByApprover;
        _this$state2.revertByFactoryAdmin;
        var selectedApplication = _this$state2.selectedApplication,
        openGenerateBFTN = _this$state2.openGenerateBFTN,
        openGenerateCommitteeReport = _this$state2.openGenerateCommitteeReport,
        openGenerateEisBFTN = _this$state2.openGenerateEisBFTN,
        openGenerateEisDependentBFTN = _this$state2.openGenerateEisDependentBFTN,
        openEisApprovalSignature = _this$state2.openEisApprovalSignature;
        _this$state2.showHistoryFilter;
        var selectedApplicationIds = _this$state2.selectedApplicationIds;
      applications === null || applications === void 0 ? void 0 : applications.reduce(function (acc, app) {
        var amount = parseFloat(app.moneyAmount) || 0;
        return acc + amount;
      }, 0);
      var _this$props31 = this.props,
        applications = _this$props31.applications,
        applicationsPageInfo = _this$props31.applicationsPageInfo,
        fetchingApplications = _this$props31.fetchingApplications,
        fetchedApplications = _this$props31.fetchedApplications,
        errorApplications = _this$props31.errorApplications,
        filterPaneContributionsKey = _this$props31.filterPaneContributionsKey,
        cacheFiltersKey = _this$props31.cacheFiltersKey,
        _onDoubleClick = _this$props31.onDoubleClick,
        userRights = _this$props31.userRights,
        userName = _this$props31.userName,
        organizationEmployee = _this$props31.organizationEmployee;
        _this$props31.isApproved;
        var coloredRow = _this$props31.coloredRow,
        eisPayments = _this$props31.eisPayments,
        roles = _this$props31.roles;
      applicationsPageInfo.totalCount;
      var userType = getUserTypeFromRights(userRights);
      var filterPane = function filterPane(_ref30) {
        var filters = _ref30.filters,
          onChangeFilters = _ref30.onChangeFilters;
        return /*#__PURE__*/React.createElement(ApplicationProcessFilter$1, {
          userRights: userRights,
          filters: filters,
          onChangeFilters: onChangeFilters,
          setShowHistoryFilter: function setShowHistoryFilter(showHistoryFilter) {
            return _this2.setState({
              showHistoryFilter: showHistoryFilter
            });
          }
        });
      };
      console.log({
        Ids: selectedApplicationIds
      });
      var disableButtons = this.props.disableButtons ? decodeId(this.props.disableButtons) : null;
      var approvedButton = this.props.approvedButton ? decodeId(this.props.approvedButton) : null;
      var meetingForwardButton = this.props.meetingForwardButton ? decodeId(this.props.meetingForwardButton) : null;
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Searcher$1, {
        module: MODULE_NAME,
        selectWithCheckbox: getUserTypeFromRights(userRights) !== WORKFORCE_USER_TYPE.APPLICANT ? true : false,
        withSelection: getUserTypeFromRights(userRights) !== WORKFORCE_USER_TYPE.APPLICANT ? "multiple" : false,
        cacheFiltersKey: cacheFiltersKey,
        FilterPane: getUserTypeFromRights(userRights) === WORKFORCE_USER_TYPE.APPLICANT ? null : filterPane,
        filterPaneContributionsKey: filterPaneContributionsKey,
        items: applications,
        itemsPageInfo: applicationsPageInfo,
        fetchingItems: fetchingApplications,
        fetchedItems: fetchedApplications,
        errorItems: errorApplications,
        tableTitle: /*#__PURE__*/React.createElement(FormattedMessage, {
          module: MODULE_NAME,
          id: this.dynamicTableTitle ? this.dynamicTableTitle : "workforce.employee.application.process"
        }),
        rowsPerPageOptions: this.rowsPerPageOptions,
        defaultPageSize: this.defaultPageSize,
        fetch: this.fetch,
        rowIdentifier: this.rowIdentifier,
        filtersToQueryParams: this.filtersToQueryParams,
        defaultOrderBy: "-dateCreated",
        headers: this.headers,
        itemFormatters: this.itemFormatters,
        sorts: this.sorts,
        rowDisabled: this.rowDisabled,
        rowLocked: this.rowLocked,
        onDoubleClick: function onDoubleClick(i) {
          return !i.clientMutationId && _onDoubleClick(i);
        },
        reset: this.state.reset
        // onCheckBoxSelect={this.onCheckBoxSelect}
        // onChangeSelectionIds={(ids) => console.log("Selected ids:", ids)}
        ,
        onCheckBoxSelect: function onCheckBoxSelect(ids) {
          return _this2.onCheckBoxSelect(ids);
        },
        coloredRow: coloredRow
      }), userType === WORKFORCE_USER_TYPE.SECTION_ADMIN || userType === WORKFORCE_USER_TYPE.BLWF_SECTION_ADMIN || userType === WORKFORCE_USER_TYPE.BLWF_ACCOUNTANT || userType === WORKFORCE_USER_TYPE.EIS_COORDINATOR ? /*#__PURE__*/React.createElement(Box$1, {
        style: {
          marginTop: 10,
          display: "flex",
          gap: 10,
          justifyContent: "space-between"
        }
      }, userType === WORKFORCE_USER_TYPE.EIS_COORDINATOR && approvedButton === 1 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
        variant: "contained",
        color: "primary",
        onClick: function onClick() {
          return _this2.setState({
            forwardModalOpenEISToCoordinator: true
          });
        }
      }, /*#__PURE__*/React.createElement(FormattedMessage, {
        module: "workforce",
        id: "workforce.employee.application.forwardToSelectionOffice"
      })), this.props.verifiedApplications && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
        variant: "contained",
        color: "primary",
        onClick: this.handleOpenEisDependentBFTN
      }, /*#__PURE__*/React.createElement(FormattedMessage, {
        module: "workforce",
        id: "workforce.employee.application.paymentProcess"
      })))), this.props.pendingMeetingSheet && /*#__PURE__*/React.createElement(Button, {
        variant: "contained",
        color: "primary",
        disabled: ((_this$props$summaryDa = this.props.summaryData) === null || _this$props$summaryDa === void 0 ? void 0 : _this$props$summaryDa.status) !== "meeting_created",
        onClick: this.handleForwardPendingMeetingSheet
      }, /*#__PURE__*/React.createElement(FormattedMessage, {
        module: "workforce",
        id: "workforce.employee.application.forwardPendingMeetingSheet"
      })), disableButtons == 1 ? /*#__PURE__*/React.createElement(React.Fragment, null, userType !== WORKFORCE_USER_TYPE.EIS_COORDINATOR && !this.props.returnedApplications && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(IconButton, {
        onClick: this.handleOpenBFTN
      }, /*#__PURE__*/React.createElement(PrintIcon, null)), userType !== WORKFORCE_USER_TYPE.BLWF_ACCOUNTANT && /*#__PURE__*/React.createElement(Button, {
        variant: "contained",
        color: "primary",
        onClick: this.handleOpenGenerateCommitteeReport,
        style: {
          color: "white",
          paddingX: 0.1,
          fontSize: "small"
        }
      }, /*#__PURE__*/React.createElement(IconButton, {
        style: {
          color: "white"
        }
      }, /*#__PURE__*/React.createElement(PrintIcon, null)), /*#__PURE__*/React.createElement(FormattedMessage, {
        id: "workforce.generate.committee.report"
      }))), userType === WORKFORCE_USER_TYPE.EIS_COORDINATOR && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(IconButton, {
        onClick: this.handleOpenEisBFTN
      }, /*#__PURE__*/React.createElement(PrintIcon, null)), /*#__PURE__*/React.createElement(Button, {
        variant: "contained",
        color: "primary",
        onClick: function onClick() {
          _this2.setState({
            openEisApprovalSignature: true
          });
        }
      }, /*#__PURE__*/React.createElement(FormattedMessage, {
        module: "workforce",
        id: "workforce.employee.application.eisApproval.signature"
      })))) : /*#__PURE__*/React.createElement(React.Fragment, null, meetingForwardButton == 1 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
        variant: "contained",
        color: "primary",
        onClick: function onClick() {
          return _this2.setState({
            forwardModalOpen: true
          });
        }
      }, /*#__PURE__*/React.createElement(FormattedMessage, {
        module: "workforce",
        id: "workforce.employee.application.createMeetingSheet"
      })), userType === WORKFORCE_USER_TYPE.EIS_COORDINATOR && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
        variant: "contained",
        color: "primary",
        onClick: this.handleOpenEisDependentBFTN
      }, /*#__PURE__*/React.createElement(FormattedMessage, {
        module: "workforce",
        id: "workforce.employee.application.paymentProcess"
      }))), ![WORKFORCE_USER_TYPE.EIS_ADVISOR, WORKFORCE_USER_TYPE.EIS_COORDINATOR].includes(userType) && /*#__PURE__*/React.createElement(Button, {
        variant: "contained",
        color: "primary"
        // onClick={this.handleBulkSelectedbySectionAdminToDoctor}
        ,
        onClick: function onClick() {
          return _this2.setState({
            forwardModalOpenEisDoctor: true
          });
        }
      }, /*#__PURE__*/React.createElement(FormattedMessage, {
        module: "workforce",
        id: "workforce.employee.application.forwardToDoctor"
      })), WORKFORCE_USER_TYPE.EIS_COORDINATOR.includes(userType) && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
        variant: "contained",
        color: "primary",
        onClick: function onClick() {
          return _this2.setState({
            forwardModalOpenEisDoctor: true
          });
        }
      }, /*#__PURE__*/React.createElement(FormattedMessage, {
        module: "workforce",
        id: "workforce.employee.application.forwardToDoctor"
      })))) : /*#__PURE__*/React.createElement(React.Fragment, null, ![WORKFORCE_USER_TYPE.EIS_ADVISOR, WORKFORCE_USER_TYPE.EIS_COORDINATOR].includes(userType) && /*#__PURE__*/React.createElement(Button, {
        variant: "contained",
        color: "primary",
        onClick: function onClick() {
          return _this2.setState({
            forwardModalOpenSA: true
          });
        }
      }, /*#__PURE__*/React.createElement(FormattedMessage, {
        module: "workforce",
        id: "workforce.employee.application.forward"
      })), WORKFORCE_USER_TYPE.EIS_COORDINATOR.includes(userType) && this.props.filedApplications && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
        variant: "contained",
        color: "primary",
        onClick: function onClick() {
          return _this2.setState({
            forwardModalOpenEIS: true
          });
        }
      }, /*#__PURE__*/React.createElement(FormattedMessage, {
        module: "workforce",
        id: "workforce.employee.application.forward"
      })))))) : null, userType === WORKFORCE_USER_TYPE.SECTION_ADMIN_TWO ? /*#__PURE__*/React.createElement(Box$1, {
        style: {
          marginTop: 10,
          display: "flex",
          gap: 10,
          justifyContent: "space-between"
        }
      }, meetingForwardButton == 1 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
        variant: "contained",
        color: "primary",
        onClick: function onClick() {
          return _this2.setState({
            forwardModalOpen: true
          });
        }
      }, /*#__PURE__*/React.createElement(FormattedMessage, {
        module: "workforce",
        id: "workforce.employee.application.createMeetingSheet"
      })), /*#__PURE__*/React.createElement(Button, {
        variant: "contained",
        color: "primary"
        // onClick={this.handleBulkSelectedbySectionAdminToDoctor}
        ,
        onClick: function onClick() {
          return _this2.setState({
            forwardModalOpenEisDoctor: true
          });
        }
      }, /*#__PURE__*/React.createElement(FormattedMessage, {
        module: "workforce",
        id: "workforce.employee.application.forwardToDoctor"
      }))) : disableButtons != 1 && /*#__PURE__*/React.createElement(Button, {
        variant: "contained",
        color: "primary",
        onClick: function onClick() {
          return _this2.setState({
            forwardModalOpenSA: true
          });
        }
      }, /*#__PURE__*/React.createElement(FormattedMessage, {
        module: "workforce",
        id: "workforce.employee.application.forward"
      })), this.props.approveMeetingSheet && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
        variant: "contained",
        color: "primary",
        onClick: this.handleOpenBFTN,
        style: {
          color: "white",
          paddingX: 0.25,
          fontSize: "small"
        }
      }, /*#__PURE__*/React.createElement(IconButton, {
        style: {
          color: "white"
        }
      }, /*#__PURE__*/React.createElement(PrintIcon, null)), /*#__PURE__*/React.createElement(FormattedMessage, {
        id: "workforce.generateBFTN.beneficiary.payment.calculation"
      })), /*#__PURE__*/React.createElement(Button, {
        variant: "contained",
        color: "primary",
        onClick: this.handleOpenGenerateCommitteeReport,
        style: {
          color: "white",
          paddingX: 0.1,
          fontSize: "small"
        }
      }, /*#__PURE__*/React.createElement(IconButton, {
        style: {
          color: "white"
        }
      }, /*#__PURE__*/React.createElement(PrintIcon, null)), /*#__PURE__*/React.createElement(FormattedMessage, {
        id: "workforce.generate.committee.report"
      })))) : null, userType === WORKFORCE_USER_TYPE.CHECKER || userType === WORKFORCE_USER_TYPE.CHECKER_TWO || userType === WORKFORCE_USER_TYPE.SEC1_DEPUTI_ASST_DIRECTOR || userType === WORKFORCE_USER_TYPE.SEC2_DEPUTI_ASST_DIRECTOR || userType === WORKFORCE_USER_TYPE.BLWF_CHECKER || userType === WORKFORCE_USER_TYPE.BLWF_DOL_DIFE || userType === WORKFORCE_USER_TYPE.BLWF_DEPUTI_ASST_DIRECTOR || userType === WORKFORCE_USER_TYPE.EIS_OFFICER ? /*#__PURE__*/React.createElement(Box$1, {
        style: {
          marginTop: 10,
          display: "flex",
          gap: 10,
          justifyContent: "space-between"
        }
      }, /*#__PURE__*/React.createElement(Button, {
        variant: "contained",
        color: "primary",
        onClick: this.handleBulkSelectedbyChecker
      }, /*#__PURE__*/React.createElement(FormattedMessage, {
        module: "workforce",
        id: "workforce.employee.application.forward"
      }))) : null, /*#__PURE__*/React.createElement(CustomSnackbar, {
        open: !!this.state.serverResponse,
        onClose: function onClose() {
          return _this2.setState({
            serverResponse: null
          });
        },
        autoHideDuration: 3000,
        type: ((_this$state$serverRes = this.state.serverResponse) === null || _this$state$serverRes === void 0 || (_this$state$serverRes = _this$state$serverRes.status) === null || _this$state$serverRes === void 0 ? void 0 : _this$state$serverRes.toLowerCase()) || "info",
        message: (_this$state$serverRes2 = this.state.serverResponse) === null || _this$state$serverRes2 === void 0 ? void 0 : _this$state$serverRes2.message
      }), userType === WORKFORCE_USER_TYPE.APPROVER || userType === WORKFORCE_USER_TYPE.BLWF_APPROVER ? /*#__PURE__*/React.createElement(Box$1, {
        style: {
          marginTop: 10,
          display: "flex",
          gap: 2,
          justifyContent: "space-between"
        }
      }, disableButtons !== 1 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
        variant: "contained",
        color: "primary",
        onClick: this.handleBulkSelectedByApprover
      }, /*#__PURE__*/React.createElement(FormattedMessage, {
        module: "workforce",
        id: "workforce.employee.application.bulkApprove"
      })), /*#__PURE__*/React.createElement(Button, {
        variant: "contained",
        color: "primary",
        onClick: this.handleOpenBFTN
      }, /*#__PURE__*/React.createElement(PrintIcon, null), " \xA0", /*#__PURE__*/React.createElement(FormattedMessage, {
        module: "workforce",
        id: "workforce.employee.application.printAndForwardToDirector"
      })))) : null, userType === WORKFORCE_USER_TYPE.BGMEA_ASSOCIATION || userType === WORKFORCE_USER_TYPE.BKMEA_ASSOCIATION || userType === WORKFORCE_USER_TYPE.BEPZA_ASSOCIATION || userType === WORKFORCE_USER_TYPE.LFMEAB_ASSOCIATION || userType === WORKFORCE_USER_TYPE.BEPZA_ASSOCIATION || userType === WORKFORCE_USER_TYPE.ASSOCIATION ? /*#__PURE__*/React.createElement(Box$1, {
        style: {
          marginTop: 10,
          display: "flex",
          gap: 2,
          justifyContent: "space-between"
        }
      }, /*#__PURE__*/React.createElement(Button, {
        variant: "contained",
        color: "primary",
        onClick: this.handleBulkSelectedbyAssociation
      }, /*#__PURE__*/React.createElement(FormattedMessage, {
        module: "workforce",
        id: "workforce.employee.application.forward"
      }))) : null, userType === WORKFORCE_USER_TYPE.FACTORY_ADMIN ? /*#__PURE__*/React.createElement(Box$1, {
        style: {
          marginTop: 10,
          display: "flex",
          gap: 2,
          justifyContent: "space-between"
        }
      }, disableButtons !== 1 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
        variant: "contained",
        color: "primary",
        onClick: function onClick() {
          return _this2.setState({
            forwardModalOpenFA: true
          });
        }
      }, /*#__PURE__*/React.createElement(FormattedMessage, {
        module: "workforce",
        id: "workforce.employee.application.forwardToAssociation"
      })))) : null, userType === WORKFORCE_USER_TYPE.ADMIN || userType === WORKFORCE_USER_TYPE.SECRETARY || userType === WORKFORCE_USER_TYPE.MINISTER ? disableButtons !== 1 && /*#__PURE__*/React.createElement(Box$1, {
        style: {
          marginTop: 10,
          display: "flex",
          gap: 2,
          justifyContent: "space-between"
        }
      }, /*#__PURE__*/React.createElement(Button, {
        variant: "contained",
        color: "primary",
        onClick: this.handleBulkApproveByAdmin
      }, /*#__PURE__*/React.createElement(FormattedMessage, {
        module: "workforce",
        id: "workforce.employee.application.bulkApprove"
      })), /*#__PURE__*/React.createElement(IconButton, {
        onClick: function onClick() {
          return _this2.handleOpenBFTN();
        }
      }, /*#__PURE__*/React.createElement(PrintIcon, null))) : null, userType === WORKFORCE_USER_TYPE.EIS_COMMITTEE || userType === WORKFORCE_USER_TYPE.EIS_ASSOCIATION_COMMITTEE ? /*#__PURE__*/React.createElement(Box$1, {
        style: {
          marginTop: 10,
          display: "flex",
          gap: 2,
          justifyContent: "space-between"
        }
      }, /*#__PURE__*/React.createElement(Button, {
        variant: "contained",
        color: "primary",
        onClick: this.handleOpenEisDependentBFTN
      }, /*#__PURE__*/React.createElement(FormattedMessage, {
        module: "workforce",
        id: "workforce.employee.application.eisApproval"
      })), /*#__PURE__*/React.createElement(GenereteEisDependentBFTN, {
        open: openGenerateEisDependentBFTN,
        onClose: this.handleCloseEisDependentBFTN,
        eisPayments: eisPayments,
        status: "approved_by_committee",
        userRights: userRights,
        selectedApplicationIds: this.state.selectedApplicationIds
      })) : null, userType === WORKFORCE_USER_TYPE.DIRECTOR || userType === WORKFORCE_USER_TYPE.BLWF_DIRECTOR ? disableButtons !== 1 && /*#__PURE__*/React.createElement(Box$1, {
        style: {
          marginTop: 10,
          display: "flex",
          gap: 2,
          justifyContent: "space-between"
        }
      }, /*#__PURE__*/React.createElement(Button, {
        variant: "contained",
        color: "primary",
        onClick: this.handleBulkApproveByDirector
      }, /*#__PURE__*/React.createElement(FormattedMessage, {
        module: "workforce",
        id: "workforce.employee.application.bulkApprove"
      })), /*#__PURE__*/React.createElement(Button, {
        variant: "contained",
        color: "primary",
        onClick: this.handleOpenBFTN,
        style: {
          color: "white",
          paddingX: 0.25,
          fontSize: "small"
        }
      }, /*#__PURE__*/React.createElement(IconButton, {
        style: {
          color: "white"
        }
      }, /*#__PURE__*/React.createElement(PrintIcon, null)), /*#__PURE__*/React.createElement(FormattedMessage, {
        id: "workforce.generateBFTN.beneficiary.payment.calculation"
      })), /*#__PURE__*/React.createElement(GenerateBFTN, {
        open: openGenerateBFTN,
        onClose: this.handleCloseBFTN,
        applications: applications,
        status: "forward_to_director",
        userRights: userRights
      }), /*#__PURE__*/React.createElement(RevertApplicationModal, {
        open: revertModalOpen,
        onClose: this.handleCloseRevertModal,
        revertByChecker: revertByChecker,
        selectedApplication: this.state.selectedApplication,
        onSubmitRevert: this.handleRevertSubmit
      })) : null, userType === WORKFORCE_USER_TYPE.EIS_ADVISOR ? disableButtons !== 1 && /*#__PURE__*/React.createElement(Box$1, {
        style: {
          marginTop: 10,
          display: "flex",
          gap: 2,
          justifyContent: "space-between"
        }
      }, /*#__PURE__*/React.createElement(Button, {
        variant: "contained",
        color: "primary",
        onClick: this.handleBulkApproveByEisAdvisor
      }, /*#__PURE__*/React.createElement(FormattedMessage, {
        module: "workforce",
        id: "workforce.employee.application.eis_advisor.recommended"
      })), /*#__PURE__*/React.createElement(Button, {
        variant: "outlined",
        color: "primary",
        onClick: this.handleOpenEisDependentBFTN
      }, /*#__PURE__*/React.createElement(FormattedMessage, {
        module: "workforce",
        id: "workforce.employee.application.eisApproval"
      })), /*#__PURE__*/React.createElement(RevertApplicationModal, {
        open: revertModalOpen,
        onClose: this.handleCloseRevertModal,
        revertByChecker: revertByChecker,
        selectedApplication: this.state.selectedApplication,
        onSubmitRevert: this.handleRevertSubmit
      }), /*#__PURE__*/React.createElement(GenereteEisDependentBFTN, {
        open: openGenerateEisDependentBFTN,
        onClose: this.handleCloseEisDependentBFTN,
        eisPayments: eisPayments,
        status: "approved_by_committee",
        userRights: userRights,
        selectedApplicationIds: this.state.selectedApplicationIds
      }), /*#__PURE__*/React.createElement(EisApprovalSignature, {
        open: openEisApprovalSignature,
        onClose: function onClose() {
          return _this2.setState({
            openEisApprovalSignature: false
          });
        },
        eisPayments: eisPayments,
        status: "approved_by_committee",
        userRights: userRights,
        selectedApplicationIds: this.state.selectedApplicationIds
      })) : null, function () {
        var userType = getUserTypeFromRights(userRights);
        if (userType === WORKFORCE_USER_TYPE.APPLICANT) {
          return /*#__PURE__*/React.createElement(ForwardApplicationModal, {
            open: forwardModalOpen,
            onClose: _this2.handleCloseForwardModal,
            selectedApplication: selectedApplication,
            onSubmitForward: _this2.handleForwardSubmit
          });
        } else if (userType === WORKFORCE_USER_TYPE.DOCTOR || userType === WORKFORCE_USER_TYPE.BLWF_DOCTOR || userType === WORKFORCE_USER_TYPE.CHECKER || userType === WORKFORCE_USER_TYPE.CHECKER_TWO || userType === WORKFORCE_USER_TYPE.BLWF_DOL_DIFE || userType === WORKFORCE_USER_TYPE.SEC1_DEPUTI_ASST_DIRECTOR || userType === WORKFORCE_USER_TYPE.SEC2_DEPUTI_ASST_DIRECTOR || userType === WORKFORCE_USER_TYPE.BLWF_DEPUTI_ASST_DIRECTOR || userType === WORKFORCE_USER_TYPE.EIS_OFFICER || userType === WORKFORCE_USER_TYPE.BLWF_CHECKER || userType === WORKFORCE_USER_TYPE.EIS_DOCTOR) {
          return /*#__PURE__*/React.createElement(RevertApplicationModal, {
            open: revertModalOpen,
            onClose: _this2.handleCloseRevertModal,
            revertByChecker: revertByChecker,
            selectedApplication: _this2.state.selectedApplication,
            onSubmitRevert: _this2.handleRevertSubmit
          });
        } else if (userType === WORKFORCE_USER_TYPE.ADMIN || userType === WORKFORCE_USER_TYPE.SECRETARY || userType === WORKFORCE_USER_TYPE.MINISTER) {
          return disableButtons !== 1 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ForwardApplicationAdminModal, {
            open: forwardModalOpen,
            onClose: _this2.handleCloseForwardModal,
            selectedApplication: selectedApplication,
            onSubmitForward: _this2.handleForwardSubmit
          }), /*#__PURE__*/React.createElement(GenerateBFTN, {
            open: openGenerateBFTN,
            onClose: _this2.handleCloseBFTN,
            applications: applications,
            status: "approved_by_director",
            userRights: userRights
          }), /*#__PURE__*/React.createElement(RevertApplicationModal, {
            open: revertModalOpen,
            onClose: _this2.handleCloseRevertModal,
            revertByChecker: revertByChecker,
            selectedApplication: _this2.state.selectedApplication,
            onSubmitRevert: _this2.handleRevertSubmit
          }));
        } else if (userType === WORKFORCE_USER_TYPE.FACTORY_ADMIN) {
          return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ForwardApplicationFactoryAdminModal, {
            open: _this2.state.forwardModalOpenFA,
            onClose: _this2.handleCloseForwardModalForFA,
            selectedApplicationIds: _this2.state.selectedApplicationIds,
            onSubmitForward: _this2.handleForwardSubmit,
            organizationEmployee: organizationEmployee,
            roles: roles
          }), /*#__PURE__*/React.createElement(RevertApplicationModal, {
            open: revertModalOpen,
            onClose: _this2.handleCloseRevertModal,
            revertByChecker: revertByChecker,
            selectedApplication: _this2.state.selectedApplication,
            onSubmitRevert: _this2.handleRevertSubmit
          }));
        } else if (userType === WORKFORCE_USER_TYPE.ASSOCIATION) {
          return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(RevertApplicationModal, {
            open: revertModalOpen,
            onClose: _this2.handleCloseRevertModal,
            revertByChecker: revertByChecker,
            selectedApplication: _this2.state.selectedApplication,
            onSubmitRevert: _this2.handleRevertSubmit
          }));
        } else if (userType === WORKFORCE_USER_TYPE.SECTION_ADMIN || userType === WORKFORCE_USER_TYPE.BLWF_SECTION_ADMIN || userType === WORKFORCE_USER_TYPE.BLWF_ACCOUNTANT || userType === WORKFORCE_USER_TYPE.EIS_COORDINATOR) {
          return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ForwardApplicationSectionAdminModal, {
            open: forwardModalOpenSA,
            onClose: _this2.handleCloseForwardModalForSectionAdmin,
            selectedApplicationIds: _this2.state.selectedApplicationIds,
            onSubmitForward: _this2.handleForwardSubmit,
            userRights: userRights
          }), /*#__PURE__*/React.createElement(ForwardApplicationSummarySectionAdminModal, {
            open: _this2.state.forwardModalOpenSummarySA,
            onClose: _this2.handleCloseForwardModalForSummarySectionAdmin,
            selectedApplicationIds: _this2.state.selectedApplicationIds,
            onSubmitForward: _this2.handleForwardSubmit,
            userRights: userRights
          }), /*#__PURE__*/React.createElement(RevertApplicationModal, {
            open: revertModalOpen,
            onClose: _this2.handleCloseRevertModal,
            revertByChecker: revertByChecker,
            selectedApplication: _this2.state.selectedApplication,
            onSubmitRevert: _this2.handleRevertSubmit
          }), /*#__PURE__*/React.createElement(ForwardApplicationSummaryModal, {
            open: forwardModalOpen,
            onClose: _this2.handleCloseForwardModal,
            selectedApplication: _this2.state.selectedApplication,
            selectedApplicationIds: _this2.state.selectedApplicationIds,
            userRights: userRights,
            roleIds: _this2.props.roleIds
          }), /*#__PURE__*/React.createElement(ForwardEisPaymentProcessModal, {
            open: forwardPaymentModalOpen,
            onClose: _this2.handleCloseForwardPaymentModal,
            selectedApplication: _this2.state.selectedApplication,
            selectedApplicationIds: _this2.state.selectedApplicationIds,
            userRights: userRights
          }), userType !== WORKFORCE_USER_TYPE.EIS_COORDINATOR && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(GenerateBFTN, {
            open: openGenerateBFTN,
            onClose: _this2.handleCloseBFTN,
            applications: applications,
            status: "approved_by_dg",
            userRights: userRights
          }), /*#__PURE__*/React.createElement(GenerateCommitteeReport, {
            open: openGenerateCommitteeReport,
            onClose: _this2.handleCloseCommitteeReport,
            applications: applications,
            status: "approved_by_dg",
            userRights: userRights
          })), userType === WORKFORCE_USER_TYPE.EIS_COORDINATOR && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(GenerateEisBFTN, {
            open: openGenerateEisBFTN,
            onClose: _this2.handleCloseEisBFTN,
            eisPayments: eisPayments,
            status: "approved_by_committee",
            userRights: userRights,
            selectedApplicationIds: _this2.state.selectedApplicationIds
          }), /*#__PURE__*/React.createElement(EisApprovalSignature, {
            open: openEisApprovalSignature,
            onClose: function onClose() {
              return _this2.setState({
                openEisApprovalSignature: false
              });
            },
            eisPayments: eisPayments,
            status: "approved_by_committee",
            userRights: userRights,
            selectedApplicationIds: _this2.state.selectedApplicationIds
          }), /*#__PURE__*/React.createElement(GenereteEisDependentBFTN, {
            open: openGenerateEisDependentBFTN,
            onClose: _this2.handleCloseEisDependentBFTN,
            eisPayments: eisPayments,
            status: "approved_by_committee",
            userRights: userRights,
            selectedApplicationIds: _this2.state.selectedApplicationIds
          })), /*#__PURE__*/React.createElement(ForwardApplicationEisDoctorModal, {
            open: forwardModalOpenEisDoctor,
            onClose: _this2.handleCloseForwardModalForEisDoctor,
            selectedApplicationIds: _this2.state.selectedApplicationIds,
            onSubmitForward: _this2.handleForwardSubmit,
            userRights: userRights
          }), /*#__PURE__*/React.createElement(ForwardApplicationEisCoordinatorModal, {
            open: forwardModalOpenEIS,
            onClose: _this2.handleCloseForwardModalForEisCoordinator,
            selectedApplicationIds: _this2.state.selectedApplicationIds,
            onSubmitForward: _this2.handleForwardSubmit,
            userRights: userRights,
            summaryId: _this2.props.summaryId,
            roleIds: _this2.props.roleIds
          }), /*#__PURE__*/React.createElement(ForwardApplicationEisCoordinatorToCommitteeModal, {
            open: forwardModalOpenEISToCoordinator,
            onClose: _this2.handleCloseForwardModalForEisCoordinatorToCommittee,
            selectedApplicationIds: _this2.state.selectedApplicationIds,
            onSubmitForward: _this2.handleForwardSubmit,
            userRights: userRights,
            summaryId: _this2.props.summaryId,
            roleIds: _this2.props.roleIds
          }));
        } else if (userType === WORKFORCE_USER_TYPE.SECTION_ADMIN_TWO) {
          return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ForwardApplicationSectionAdminModal, {
            open: forwardModalOpenSA,
            onClose: _this2.handleCloseForwardModalForSectionAdmin,
            selectedApplicationIds: _this2.state.selectedApplicationIds,
            onSubmitForward: _this2.handleForwardSubmit,
            userRights: userRights
          }), /*#__PURE__*/React.createElement(ForwardApplicationEisDoctorModal, {
            open: forwardModalOpenEisDoctor,
            onClose: _this2.handleCloseForwardModalForEisDoctor,
            selectedApplicationIds: _this2.state.selectedApplicationIds,
            onSubmitForward: _this2.handleForwardSubmit,
            userRights: userRights
          }), /*#__PURE__*/React.createElement(RevertApplicationModal, {
            open: revertModalOpen,
            onClose: _this2.handleCloseRevertModal,
            revertByChecker: revertByChecker,
            selectedApplication: _this2.state.selectedApplication,
            onSubmitRevert: _this2.handleRevertSubmit
          }), /*#__PURE__*/React.createElement(ForwardApplicationSummaryModal, {
            open: forwardModalOpen,
            onClose: _this2.handleCloseForwardModal,
            selectedApplication: _this2.state.selectedApplication,
            selectedApplicationIds: _this2.state.selectedApplicationIds,
            userRights: userRights,
            roleIds: _this2.props.roleIds
          }), /*#__PURE__*/React.createElement(GenerateBFTN, {
            open: openGenerateBFTN,
            onClose: _this2.handleCloseBFTN,
            applications: applications,
            status: "approved_by_dg",
            userRights: userRights
          }), /*#__PURE__*/React.createElement(GenerateCommitteeReport, {
            open: openGenerateCommitteeReport,
            onClose: _this2.handleCloseCommitteeReport,
            applications: applications,
            status: "approved_by_dg",
            userRights: userRights
          }));
        } else if (userType === WORKFORCE_USER_TYPE.APPROVER || userType === WORKFORCE_USER_TYPE.BLWF_APPROVER) {
          return disableButtons !== 1 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ForwardApplicationApproverAdminModal, {
            open: forwardModalOpen,
            onClose: _this2.handleCloseForwardModal,
            selectedApplication: selectedApplication,
            onSubmitForward: _this2.handleForwardSubmit,
            userName: userName
          }), /*#__PURE__*/React.createElement(RevertApplicationModal, {
            open: revertModalOpen,
            onClose: _this2.handleCloseRevertModal,
            revertByChecker: revertByChecker,
            selectedApplication: _this2.state.selectedApplication,
            onSubmitRevert: _this2.handleRevertSubmit
          }), /*#__PURE__*/React.createElement(GenerateBFTN, {
            open: openGenerateBFTN,
            onClose: _this2.handleCloseBFTN,
            applications: applications,
            status: "selected",
            summary_Id: decodeId(_this2.props.summaryId),
            summaryData: _this2.props.summaryData,
            userRights: userRights
          }));
        } else if (userType === WORKFORCE_USER_TYPE.EIS_COMMITTEE || userType === WORKFORCE_USER_TYPE.EIS_ASSOCIATION_COMMITTEE) {
          return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(RevertApplicationModal, {
            open: revertModalOpen,
            onClose: _this2.handleCloseRevertModal,
            revertByChecker: revertByChecker,
            selectedApplication: _this2.state.selectedApplication,
            onSubmitRevert: _this2.handleRevertSubmit
          }));
        }
        return null;
      }(), /*#__PURE__*/React.createElement(ConfirmModal, {
        open: this.state.confirmModalOpen,
        message: this.state.confirmModalMessage,
        onClose: this.handleConfirmModalClose,
        loader: this.state.loader,
        addComment: this.handleAddComment,
        modalFlag: this.state.modalFlag
      }), /*#__PURE__*/React.createElement(ConfirmRejectModal, {
        open: this.state.openRejectModal,
        onClose: this.handleConfirmRejectModalClose,
        addComment: this.handleAddComment,
        modalFlag: "reject"
      }));
    }
  }]);
}(Component);
var mapStateToProps$g = function mapStateToProps(state) {
  var _state$workforce$work, _state$workforce$work2, _state$core, _state$core2, _state$workforce;
  return {
    i_user: state.core && state.core.user && state.core.user.i_user,
    rights: !!state.core && !!state.core.user && !!state.core.user.i_user ? state.core.user.i_user.rights : [],
    applications: state.workforce.applications,
    eisPayments: state.workforce.eisPayments,
    applicationsPageInfo: state.workforce.applicationsPageInfo,
    fetchingApplications: state.workforce.fetchingApplications,
    fetchedApplications: state.workforce.fetchedApplications,
    // designationId:state.workforce.fetchedWorkforceOrganizationByDesignationId,
    errorApplications: state.workforce.errorApplications,
    submittingMutation: state.workforce.submittingMutation,
    mutation: state.workforce.mutation,
    confirmed: state.core.confirmed,
    userRights: state.core.user.i_user.rights,
    userId: state.core.user.i_user.uuid,
    userName: state.core.user.username,
    organizationEmployee: state.workforce.organizationEmployee,
    workforceEmployeesFactoryId: (_state$workforce$work = (_state$workforce$work2 = state.workforce.workforceEmployee) === null || _state$workforce$work2 === void 0 || (_state$workforce$work2 = _state$workforce$work2.edges) === null || _state$workforce$work2 === void 0 || (_state$workforce$work2 = _state$workforce$work2[0]) === null || _state$workforce$work2 === void 0 || (_state$workforce$work2 = _state$workforce$work2.employeeDesignationEmployeeId) === null || _state$workforce$work2 === void 0 || (_state$workforce$work2 = _state$workforce$work2.edges) === null || _state$workforce$work2 === void 0 || (_state$workforce$work2 = _state$workforce$work2[0]) === null || _state$workforce$work2 === void 0 || (_state$workforce$work2 = _state$workforce$work2.node) === null || _state$workforce$work2 === void 0 || (_state$workforce$work2 = _state$workforce$work2.workforceFactory) === null || _state$workforce$work2 === void 0 ? void 0 : _state$workforce$work2.id) !== null && _state$workforce$work !== void 0 ? _state$workforce$work : null,
    workforceEmployee: state.workforce.workforceEmployee,
    locale: ((_state$core = state.core) === null || _state$core === void 0 || (_state$core = _state$core.user) === null || _state$core === void 0 || (_state$core = _state$core.i_user) === null || _state$core === void 0 ? void 0 : _state$core.language) || "en",
    loggedInUserId: (_state$core2 = state.core) === null || _state$core2 === void 0 || (_state$core2 = _state$core2.user) === null || _state$core2 === void 0 || (_state$core2 = _state$core2.i_user) === null || _state$core2 === void 0 ? void 0 : _state$core2.id,
    roles: state === null || state === void 0 || (_state$workforce = state.workforce) === null || _state$workforce === void 0 ? void 0 : _state$workforce.roles
  };
};
var mapDispatchToProps$b = function mapDispatchToProps(dispatch) {
  return _objectSpread$E(_objectSpread$E({}, bindActionCreators({
    fetchApplicationsSummary: fetchApplicationsSummary,
    fetchApplicationMovementsSummary: fetchApplicationMovementsSummary,
    fetchOrganizationEmployeeDesignation: fetchOrganizationEmployeeDesignation,
    updateApplication: updateApplication,
    updateApplicationSummary: updateApplicationSummary,
    createApplicationMovement: createApplicationMovement,
    fetchOrganizationEmployee: fetchOrganizationEmployee,
    fetchFactoryEmployee: fetchFactoryEmployee,
    fetchWorkforceDocument: fetchWorkforceDocument,
    testWorkforcePayment: testWorkforcePayment,
    fetchUsersByRoleId: fetchUsersByRoleId,
    fetchRoles: fetchRoles,
    fetchWorkforceCommitteeUserMap: fetchWorkforceCommitteeUserMap,
    journalize: journalize,
    coreConfirm: coreConfirm
  }, dispatch)), {}, {
    dispatch: dispatch
  });
};
var ApplicationProcessSearcher$1 = withModulesManager(withHistory(connect(mapStateToProps$g, mapDispatchToProps$b)(withTheme(withStyles(styles$h)(ApplicationProcessSearcher)))));

var _excluded = ["children", "value", "index"];
var TabPanel = function TabPanel(props) {
  var children = props.children,
    value = props.value,
    index = props.index,
    other = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/React.createElement("div", _extends({
    role: "tabpanel",
    hidden: value !== index,
    id: "simple-tabpanel-".concat(index),
    "aria-labelledby": "simple-tab-".concat(index)
  }, other), value === index && /*#__PURE__*/React.createElement(Box, {
    p: 0
  }, /*#__PURE__*/React.createElement(Typography$1, null, children)));
};

function _callSuper$g(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$g() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$g() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$g = function _isNativeReflectConstruct() { return !!t; })(); }
function ownKeys$D(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$D(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$D(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$D(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var styles$g = function styles(theme) {
  return {
    page: theme.page,
    fab: _objectSpread$D(_objectSpread$D({}, theme.fab), {}, {
      display: "flex",
      flexDirection: "column"
    })
  };
};
var ApplicationsProcessPage = /*#__PURE__*/function (_Component) {
  function ApplicationsProcessPage(props) {
    var _this;
    _classCallCheck(this, ApplicationsProcessPage);
    _this = _callSuper$g(this, ApplicationsProcessPage, [props]);
    _defineProperty(_this, "handleCloseBFTN", function () {
      _this.setState({
        openGenerateBFTN: false
      });
    });
    _defineProperty(_this, "handleOpenBFTN", function () {
      _this.setState({
        openGenerateBFTN: true
      });
    });
    _defineProperty(_this, "onDoubleClick", function (application) {
      var newTab = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var routeParams = ["workforce.route.application", [decodeId(application.id)]];
      if (application !== null && application !== void 0 && application.isHistory) {
        routeParams[1].push(application.version);
      }
      historyPush$1.apply(void 0, [_this.props.modulesManager, _this.props.history].concat(routeParams, [newTab]));
    });
    _defineProperty(_this, "onAdd", function () {
      historyPush$1(_this.props.modulesManager, _this.props.history, "workforce.route.application");
    });
    _defineProperty(_this, "getQueryStatus", function () {
      var urlParams = new URLSearchParams(window.location.search);
      var status = urlParams.get("status");
      console.log(status);
      if (status) {
        switch (status) {
          case "pending":
            _this.setState({
              value: 1
            });
            break;
          case "approved":
            _this.setState({
              value: 2
            });
            break;
          case "rejected":
            _this.setState({
              value: 3
            });
            break;
          default:
            _this.setState({
              value: 0
            });
        }
      }
    });
    _defineProperty(_this, "handleChange", function (event, newValue) {
      _this.setState({
        value: newValue
      }, function () {
        console.log("Current tab index:", _this.state.value);
      });
    });
    _defineProperty(_this, "handleAccordionChange", function (panelId, listKey) {
      return function (event, isExpanded) {
        if (isExpanded) {
          _this.setState({
            expanded: panelId,
            activeAccordion: {
              id: panelId,
              listKey: listKey
            }
          });
        } else {
          _this.setState({
            expanded: null,
            activeAccordion: {
              id: null,
              listKey: null
            }
          });
        }
      };
    });
    _defineProperty(_this, "reorderWithActiveOnTop", function (list, listKey) {
      var activeAccordion = _this.state.activeAccordion;
      if (activeAccordion.listKey !== listKey || !activeAccordion.id) {
        return list; // return as is if no active accordion for this list
      }
      var clicked = list.find(function (item) {
        return item.id === activeAccordion.id;
      });
      if (!clicked) return list;
      var rest = list.filter(function (item) {
        return item.id !== activeAccordion.id;
      });
      return [clicked].concat(_toConsumableArray(rest));
    });
    _this.state = {
      value: props.value || 0,
      openGenerateBFTN: false,
      expanded: null,
      activeAccordion: {
        id: null,
        listKey: null
      },
      allSummariesView: [],
      pendingSummariesView: [],
      approvedSummariesView: [],
      rejectedSummariesView: []
    };
    return _this;
  }
  _inherits(ApplicationsProcessPage, _Component);
  return _createClass(ApplicationsProcessPage, [{
    key: "a11yProps",
    value: function a11yProps(index) {
      return {
        id: "simple-tab-".concat(index),
        "aria-controls": "simple-tabpanel-".concat(index)
      };
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
        modulesManager = _this$props.modulesManager,
        fetchSummaryApplications = _this$props.fetchSummaryApplications;
      fetchSummaryApplications(modulesManager);
      this.getQueryStatus();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.location.search !== prevProps.location.search) {
        this.getQueryStatus();
      }
      if (prevProps.summaryData !== this.props.summaryData) {
        var summaryData = this.props.summaryData;
        this.setState({
          allSummariesView: summaryData.filter(function (i) {
            return ["forward_to_director", "approved_by_director", "approved_by_dg"].includes(i.status);
          }),
          pendingSummariesView: summaryData.filter(function (i) {
            return ["forward_to_director", "approved_by_director"].includes(i.status);
          }),
          approvedSummariesView: summaryData.filter(function (i) {
            return i.status === "approved_by_dg";
          }),
          rejectedSummariesView: summaryData.filter(function (i) {
            return i.status === "rejected";
          })
          // do the same for directorSummaries, blwfDirectorSummaries etc
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this,
        _this$reorderWithActi,
        _this$reorderWithActi2,
        _this$reorderWithActi3;
      var _this$props2 = this.props;
        _this$props2.intl;
        var classes = _this$props2.classes,
        rights = _this$props2.rights,
        applications = _this$props2.applications;
      var _this$state = this.state,
        value = _this$state.value,
        openGenerateBFTN = _this$state.openGenerateBFTN,
        expanded = _this$state.expanded;
      var summaryData = this.props.summaryData || [];
      var loggedInUserId = this.props.loggedInUserId;

      // console.clear();
      console.log("summary data", summaryData);
      summaryData.filter(function (item) {
        return item.status === "approved_by_dg";
      });
      summaryData.filter(function (item) {
        return item.status === "forward_to_director" || item.status === "approved_by_director";
      });
      summaryData.filter(function (item) {
        return item.status === "rejected";
      });
      summaryData.filter(function (item) {
        return item.status === "forward_to_director" || item.status === "approved_by_director" || item.status === "approved_by_dg";
      });
      summaryData.filter(function (item) {
        return item.status === "approved_by_director";
      });
      summaryData.filter(function (item) {
        return item.status === "forward_to_director";
      });
      summaryData.filter(function (item) {
        return item.status === "rejected";
      });
      summaryData.filter(function (item) {
        return item.status === "forward_to_director" || item.status === "approved_by_director" || item.status === "forward_to_dg";
      });
      var directorSummaries = summaryData.filter(function (item) {
        return getUserTypeFromRights(rights) === WORKFORCE_USER_TYPE.DIRECTOR && item.organizationType === "cf";
      });
      var blwfDirectorSummaries = summaryData.filter(function (item) {
        return getUserTypeFromRights(rights) === WORKFORCE_USER_TYPE.BLWF_DIRECTOR && item.organizationType === "blwf";
      });
      return /*#__PURE__*/React.createElement("div", {
        className: classes.page
      }, /*#__PURE__*/React.createElement(AppBar, {
        position: "static"
      }, /*#__PURE__*/React.createElement(Tabs, {
        value: value,
        onChange: this.handleChange,
        "aria-label": "simple tabs example"
      }, /*#__PURE__*/React.createElement(Tab$1, _extends({
        label: /*#__PURE__*/React.createElement(FormattedMessage, {
          module: "workforce",
          id: "workforce.application.process.all"
        })
      }, this.a11yProps(0))), /*#__PURE__*/React.createElement(Tab$1, _extends({
        label: /*#__PURE__*/React.createElement(FormattedMessage, {
          module: "workforce",
          id: "workforce.application.process.pending"
        })
      }, this.a11yProps(1))), /*#__PURE__*/React.createElement(Tab$1, _extends({
        label: /*#__PURE__*/React.createElement(FormattedMessage, {
          module: "workforce",
          id: "workforce.application.process.approved"
        })
      }, this.a11yProps(2))), /*#__PURE__*/React.createElement(Tab$1, _extends({
        label: /*#__PURE__*/React.createElement(FormattedMessage, {
          module: "workforce",
          id: "workforce.application.process.rejected"
        })
      }, this.a11yProps(3))))), getUserTypeFromRights(rights) === WORKFORCE_USER_TYPE.ADMIN ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TabPanel, {
        value: value,
        index: 0
      }, this.reorderWithActiveOnTop(this.state.allSummariesView, "allSummariesView").map(function (item) {
        return /*#__PURE__*/React.createElement(Accordion, {
          key: item.id,
          expanded: expanded === item.id,
          onChange: _this2.handleAccordionChange(item.id, "allSummariesView"),
          className: classes.accordion
        }, /*#__PURE__*/React.createElement(AccordionSummary, {
          className: classes.accordionSummary,
          expandIcon: /*#__PURE__*/React.createElement(ExpandMoreIcon, {
            className: "material-icons"
          })
        }, /*#__PURE__*/React.createElement(Typography, {
          variant: "subtitle1",
          style: {
            flex: 1
          }
        }, /*#__PURE__*/React.createElement("strong", null, item.name)), /*#__PURE__*/React.createElement(Typography, {
          variant: "body2",
          style: {
            marginLeft: "auto",
            color: "#015C63"
          }
        }, item.meetingDate, " | ", item.month, " ", item.year)), /*#__PURE__*/React.createElement(AccordionDetails, {
          className: classes.accordionDetails
        }, /*#__PURE__*/React.createElement(Card, {
          style: {
            width: "100%"
          }
        }, /*#__PURE__*/React.createElement(CardContent, null, expanded === item.id && /*#__PURE__*/React.createElement(ApplicationProcessSearcher$1, {
          summaryId: item.id,
          cacheFiltersKey: "all",
          onDoubleClick: _this2.onDoubleClick,
          loggedInUserId: _this2.props.loggedInUserId
        })))));
      })), /*#__PURE__*/React.createElement(TabPanel, {
        value: value,
        index: 1
      }, (_this$reorderWithActi = this.reorderWithActiveOnTop(this.state.pendingSummariesView, "pendingSummariesView")) === null || _this$reorderWithActi === void 0 ? void 0 : _this$reorderWithActi.map(function (item, index) {
        return /*#__PURE__*/React.createElement(Accordion, {
          key: index,
          expanded: _this2.state.expanded === item.id,
          onChange: _this2.handleAccordionChange(item.id, "pendingSummariesView"),
          className: classes.accordion
        }, /*#__PURE__*/React.createElement(AccordionSummary, {
          className: classes.accordionSummary,
          expandIcon: /*#__PURE__*/React.createElement(ExpandMoreIcon, {
            className: "material-icons"
          })
        }, /*#__PURE__*/React.createElement(Typography, {
          variant: "subtitle1",
          style: {
            flex: 1
          }
        }, /*#__PURE__*/React.createElement("strong", null, item.name)), /*#__PURE__*/React.createElement(Typography, {
          variant: "body2",
          style: {
            marginLeft: "auto",
            color: "#015C63"
          }
        }, item.meetingDate, " | ", item.month, " ", item.year)), /*#__PURE__*/React.createElement(AccordionDetails, {
          className: classes.accordionDetails
        }, /*#__PURE__*/React.createElement(Card, {
          style: {
            width: "100%"
          }
        }, /*#__PURE__*/React.createElement(CardContent, null, _this2.state.expanded === item.id && /*#__PURE__*/React.createElement(ApplicationProcessSearcher$1, {
          summaryId: item.id,
          cacheFiltersKey: "pending",
          onDoubleClick: _this2.onDoubleClick,
          loggedInUserId: loggedInUserId
        })))));
      }), /*#__PURE__*/React.createElement(GenerateBFTN, {
        open: openGenerateBFTN,
        onClose: this.handleCloseBFTN,
        applications: applications,
        userRights: rights
      })), /*#__PURE__*/React.createElement(TabPanel, {
        value: value,
        index: 2
      }, (_this$reorderWithActi2 = this.reorderWithActiveOnTop(this.state.approvedSummariesView, "approvedSummariesView")) === null || _this$reorderWithActi2 === void 0 ? void 0 : _this$reorderWithActi2.map(function (item, index) {
        return /*#__PURE__*/React.createElement(Accordion, {
          key: index,
          expanded: _this2.state.expanded === item.id,
          onChange: _this2.handleAccordionChange(item.id, "approvedSummariesView"),
          className: classes.accordion
        }, /*#__PURE__*/React.createElement(AccordionSummary, {
          className: classes.accordionSummary,
          expandIcon: /*#__PURE__*/React.createElement(ExpandMoreIcon, {
            className: "material-icons"
          })
        }, /*#__PURE__*/React.createElement(Typography, {
          variant: "subtitle1",
          style: {
            flex: 1
          }
        }, /*#__PURE__*/React.createElement("strong", null, item.name)), /*#__PURE__*/React.createElement(Typography, {
          variant: "body2",
          style: {
            marginLeft: "auto",
            color: "#015C63"
          }
        }, item.meetingDate, " | ", item.month, " ", item.year)), /*#__PURE__*/React.createElement(AccordionDetails, {
          className: classes.accordionDetails
        }, /*#__PURE__*/React.createElement(Card, {
          style: {
            width: "100%"
          }
        }, /*#__PURE__*/React.createElement(CardContent, null, _this2.state.expanded === item.id && /*#__PURE__*/React.createElement(ApplicationProcessSearcher$1, {
          summaryId: item.id,
          cacheFiltersKey: "approved",
          onDoubleClick: _this2.onDoubleClick,
          loggedInUserId: loggedInUserId
        })))));
      }), /*#__PURE__*/React.createElement(GenerateBFTN, {
        open: openGenerateBFTN,
        onClose: this.handleCloseBFTN,
        applications: applications,
        userRights: rights
      })), /*#__PURE__*/React.createElement(TabPanel, {
        value: value,
        index: 3
      }, /*#__PURE__*/React.createElement(ApplicationProcessSearcher$1, {
        cacheFiltersKey: "rejected",
        rejectedApplication: true,
        onDoubleClick: this.onDoubleClick,
        loggedInUserId: loggedInUserId
      }), /*#__PURE__*/React.createElement(GenerateBFTN, {
        open: openGenerateBFTN,
        onClose: this.handleCloseBFTN,
        applications: applications,
        userRights: rights
      }))) : getUserTypeFromRights(rights) === WORKFORCE_USER_TYPE.DIRECTOR || getUserTypeFromRights(rights) === WORKFORCE_USER_TYPE.BLWF_DIRECTOR ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TabPanel, {
        value: value,
        index: 0
      }, (_this$reorderWithActi3 = this.reorderWithActiveOnTop(getUserTypeFromRights(rights) === WORKFORCE_USER_TYPE.DIRECTOR ? directorSummaries : blwfDirectorSummaries, "directorAllSummariesView")) === null || _this$reorderWithActi3 === void 0 ? void 0 : _this$reorderWithActi3.map(function (item, index) {
        return /*#__PURE__*/React.createElement(Accordion, {
          key: index,
          expanded: _this2.state.expanded === item.id,
          onChange: _this2.handleAccordionChange(item.id),
          className: classes.accordion
        }, /*#__PURE__*/React.createElement(AccordionSummary, {
          className: classes.accordionSummary,
          expandIcon: /*#__PURE__*/React.createElement(ExpandMoreIcon, {
            className: "material-icons"
          })
        }, /*#__PURE__*/React.createElement(Typography, {
          variant: "subtitle1",
          style: {
            flex: 1
          }
        }, /*#__PURE__*/React.createElement("strong", null, item.name)), /*#__PURE__*/React.createElement(Typography, {
          variant: "body2",
          style: {
            marginLeft: "auto",
            color: "#015C63"
          }
        }, item.meetingDate, " | ", item.month, " ", item.year)), /*#__PURE__*/React.createElement(AccordionDetails, {
          className: classes.accordionDetails
        }, /*#__PURE__*/React.createElement(Card, {
          style: {
            width: "100%"
          }
        }, /*#__PURE__*/React.createElement(CardContent, null, _this2.state.expanded === item.id && /*#__PURE__*/React.createElement(ApplicationProcessSearcher$1, {
          summaryId: item.id,
          cacheFiltersKey: "all",
          onDoubleClick: _this2.onDoubleClick,
          loggedInUserId: loggedInUserId
        })))));
      }), /*#__PURE__*/React.createElement(GenerateBFTN, {
        open: openGenerateBFTN,
        onClose: this.handleCloseBFTN,
        applications: applications,
        userRights: rights
      })), /*#__PURE__*/React.createElement(TabPanel, {
        value: value,
        index: 1
      }, this.reorderWithActiveOnTop(getUserTypeFromRights(rights) === WORKFORCE_USER_TYPE.DIRECTOR ? directorSummaries.filter(function (item) {
        return item.status === "forward_to_director";
      }) : blwfDirectorSummaries.filter(function (item) {
        return item.status === "forward_to_director";
      }), "directorAllSummariesView").map(function (item, index) {
        return /*#__PURE__*/React.createElement(Accordion, {
          key: index,
          expanded: _this2.state.expanded === item.id,
          onChange: _this2.handleAccordionChange(item.id),
          className: classes.accordion
        }, /*#__PURE__*/React.createElement(AccordionSummary, {
          className: classes.accordionSummary,
          expandIcon: /*#__PURE__*/React.createElement(ExpandMoreIcon, {
            className: "material-icons"
          })
        }, /*#__PURE__*/React.createElement(Typography, {
          variant: "subtitle1",
          style: {
            flex: 1
          }
        }, /*#__PURE__*/React.createElement("strong", null, item.name)), /*#__PURE__*/React.createElement(Typography, {
          variant: "body2",
          style: {
            marginLeft: "auto",
            color: "#015C63"
          }
        }, item.meetingDate, " | ", item.month, " ", item.year)), /*#__PURE__*/React.createElement(AccordionDetails, {
          className: classes.accordionDetails
        }, /*#__PURE__*/React.createElement(Card, {
          style: {
            width: "100%"
          }
        }, /*#__PURE__*/React.createElement(CardContent, null, _this2.state.expanded === item.id && /*#__PURE__*/React.createElement(ApplicationProcessSearcher$1, {
          summaryId: item.id,
          cacheFiltersKey: "pending",
          onDoubleClick: _this2.onDoubleClick,
          loggedInUserId: loggedInUserId
        })))));
      }), /*#__PURE__*/React.createElement(GenerateBFTN, {
        open: openGenerateBFTN,
        onClose: this.handleCloseBFTN,
        applications: applications,
        userRights: rights
      })), /*#__PURE__*/React.createElement(TabPanel, {
        value: value,
        index: 2
      }, this.reorderWithActiveOnTop(getUserTypeFromRights(rights) === WORKFORCE_USER_TYPE.DIRECTOR ? directorSummaries.filter(function (item) {
        return item.status === "approved_by_director";
      }) : blwfDirectorSummaries.filter(function (item) {
        return item.status === "approved_by_director";
      }), "directorAllSummariesView").map(function (item, index) {
        return /*#__PURE__*/React.createElement(Accordion, {
          key: index,
          expanded: _this2.state.expanded === item.id,
          onChange: _this2.handleAccordionChange(item.id),
          className: classes.accordion
        }, /*#__PURE__*/React.createElement(AccordionSummary, {
          className: classes.accordionSummary,
          expandIcon: /*#__PURE__*/React.createElement(ExpandMoreIcon, {
            className: "material-icons"
          })
        }, /*#__PURE__*/React.createElement(Typography, {
          variant: "subtitle1",
          style: {
            flex: 1
          }
        }, /*#__PURE__*/React.createElement("strong", null, item.name)), /*#__PURE__*/React.createElement(Typography, {
          variant: "body2",
          style: {
            marginLeft: "auto",
            color: "#015C63"
          }
        }, item.meetingDate, " | ", item.month, " ", item.year)), /*#__PURE__*/React.createElement(AccordionDetails, {
          className: classes.accordionDetails
        }, /*#__PURE__*/React.createElement(Card, {
          style: {
            width: "100%"
          }
        }, /*#__PURE__*/React.createElement(CardContent, null, _this2.state.expanded === item.id && /*#__PURE__*/React.createElement(ApplicationProcessSearcher$1, {
          summaryId: item.id,
          cacheFiltersKey: "approved",
          onDoubleClick: _this2.onDoubleClick,
          loggedInUserId: loggedInUserId
        })))));
      }), /*#__PURE__*/React.createElement(GenerateBFTN, {
        open: openGenerateBFTN,
        onClose: this.handleCloseBFTN,
        applications: applications,
        userRights: rights
      })), /*#__PURE__*/React.createElement(TabPanel, {
        value: value,
        index: 3
      }, this.reorderWithActiveOnTop(getUserTypeFromRights(rights) === WORKFORCE_USER_TYPE.DIRECTOR ? directorSummaries.filter(function (item) {
        return item.status === "rejected";
      }) : blwfDirectorSummaries.filter(function (item) {
        return item.status === "rejected";
      }), "directorAllSummariesView").map(function (item, index) {
        return /*#__PURE__*/React.createElement(Accordion, {
          key: index,
          expanded: _this2.state.expanded === item.id,
          onChange: _this2.handleAccordionChange(item.id),
          className: classes.accordion
        }, /*#__PURE__*/React.createElement(AccordionSummary, {
          className: classes.accordionSummary,
          expandIcon: /*#__PURE__*/React.createElement(ExpandMoreIcon, {
            className: "material-icons"
          })
        }, /*#__PURE__*/React.createElement(Typography, {
          variant: "subtitle1",
          style: {
            flex: 1
          }
        }, /*#__PURE__*/React.createElement("strong", null, item.name)), /*#__PURE__*/React.createElement(Typography, {
          variant: "body2",
          style: {
            marginLeft: "auto",
            color: "#015C63"
          }
        }, item.meetingDate, " | ", item.month, " ", item.year)), /*#__PURE__*/React.createElement(AccordionDetails, {
          className: classes.accordionDetails
        }, /*#__PURE__*/React.createElement(Card, {
          style: {
            width: "100%"
          }
        }, /*#__PURE__*/React.createElement(CardContent, null, _this2.state.expanded === item.id && /*#__PURE__*/React.createElement(ApplicationProcessSearcher$1, {
          summaryId: item.id,
          cacheFiltersKey: "rejected",
          onDoubleClick: _this2.onDoubleClick,
          loggedInUserId: loggedInUserId
        })))));
      }), /*#__PURE__*/React.createElement(GenerateBFTN, {
        open: openGenerateBFTN,
        onClose: this.handleCloseBFTN,
        applications: applications,
        userRights: rights
      }))) : /*#__PURE__*/React.createElement(React.Fragment, null), withTooltip(/*#__PURE__*/React.createElement("div", {
        className: classes.fab
      }, /*#__PURE__*/React.createElement(Fab, {
        color: "primary",
        onClick: this.onAdd,
        style: {
          marginBottom: 10
        }
      }, /*#__PURE__*/React.createElement(AddIcon, null)), /*#__PURE__*/React.createElement(Fab, {
        color: "primary",
        onClick: this.handleOpenBFTN
      }, /*#__PURE__*/React.createElement(PrintIcon, null))), /*#__PURE__*/React.createElement(FormattedMessage, {
        module: MODULE_NAME,
        id: "workforce.employee.application.addNewTooltip"
      })));
    }
  }]);
}(Component);
var mapStateToProps$f = function mapStateToProps(state) {
  var _state$workforce$appl, _state$core;
  return {
    rights: !!state.core && !!state.core.user && !!state.core.user.i_user ? state.core.user.i_user.rights : [],
    applications: state.workforce.applications,
    summaryData: (_state$workforce$appl = state.workforce.applicationsSummary) !== null && _state$workforce$appl !== void 0 ? _state$workforce$appl : [],
    loggedInUserId: (_state$core = state.core) === null || _state$core === void 0 || (_state$core = _state$core.user) === null || _state$core === void 0 || (_state$core = _state$core.i_user) === null || _state$core === void 0 ? void 0 : _state$core.id
  };
};
var mapDispatchToProps$a = function mapDispatchToProps(dispatch) {
  return {
    fetchSummaryApplications: function fetchSummaryApplications$1(modulesManager) {
      return dispatch(fetchSummaryApplications(modulesManager, ""));
    }
  };
};
var ApplicationsProcessPage$1 = withModulesManager(withHistory(connect(mapStateToProps$f, mapDispatchToProps$a)(withTheme(withStyles(styles$g)(ApplicationsProcessPage)))));

var useStyles$I = makeStyles$1(function (theme) {
  return {
    container: {
      margin: "auto",
      display: "inline-block",
      // flexWrap:"wrap",
      alignItems: "center"
    },
    title: {
      fontSize: "small",
      // fontWeight:500,
      display: "inline"
    },
    inlineButton: {
      fontSize: "0.875rem",
      fontWeight: "bold",
      padding: theme.spacing(0.5),
      // minWidth: "unset",
      textTransform: "none",
      marginLeft: theme.spacing(1),
      backgroundColor: "#B2D0D5",
      display: "inline" // crucial to stay inline
    },
    paper: theme.paper.paper,
    footerContainer: {
      marginTop: theme.spacing(4),
      // Fixes the "theme not defined" error
      textAlign: "center"
    },
    logoBox: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      // Keeps logos vertically centered
      marginTop: theme.spacing(2),
      flexWrap: "wrap",
      // Allows wrapping if the screen is too narrow
      gap: "10px"
    },
    footerLogo: {
      height: "50px",
      // Increased from 35px for better visibility
      width: "auto",
      // Maintains aspect ratio
      maxWidth: "100px",
      // Prevents any single logo from taking over
      objectFit: "contain"
    }
  };
});
var RegistrationButton = function RegistrationButton() {
  var _useState = useState("bn"),
    _useState2 = _slicedToArray(_useState, 2),
    lang = _useState2[0];
    _useState2[1];
  var classes = useStyles$I();
  var history = useHistory();
  var modulesManager = useModulesManager();
  var _useTranslations = useTranslations("core.RegistrationButton", modulesManager);
    _useTranslations.formatMessage;
  var redirectToRegistrationPage = function redirectToRegistrationPage(e) {
    e.preventDefault();
    history.push("/registration");
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Box$1, {
    className: classes.container
  }, /*#__PURE__*/React.createElement(Typography, {
    varient: "p",
    className: classes.title
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: lang === "bn" ? "workforce.registration.desclaimer" : "New here? Register today!"
  })), /*#__PURE__*/React.createElement(Button, {
    className: classes.inlineButton,
    onClick: redirectToRegistrationPage
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: lang === "bn" ? "workforce.register.button" : "Register"
  }))));
};

function ownKeys$C(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$C(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$C(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$C(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper$f(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$f() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$f() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$f = function _isNativeReflectConstruct() { return !!t; })(); }
var styles$f = function styles(theme) {
  return {
    paper: theme.paper.paper,
    tableTitle: theme.table.title,
    item: theme.paper.item,
    fullHeight: {
      height: "100%"
    }
  };
};
var AddApplicationPage = /*#__PURE__*/function (_Component) {
  function AddApplicationPage(props) {
    var _this;
    _classCallCheck(this, AddApplicationPage);
    _this = _callSuper$f(this, AddApplicationPage, [props]);
    _defineProperty(_this, "save", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var stateEdited, dispatch, workforceEmployeeData;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            stateEdited = _this.state.stateEdited;
            dispatch = _this.props.dispatch;
            workforceEmployeeData = {
              nameBn: stateEdited.titleBn,
              nameEn: stateEdited.title,
              phoneNumber: stateEdited.phone,
              email: stateEdited.email,
              birthDate: stateEdited.birthDate,
              gender: stateEdited.gender.id,
              firstJoiningDate: stateEdited.firstJoiningDate,
              birthCertificateNo: stateEdited.birthCertificateNo,
              nid: stateEdited.nid,
              passportNo: stateEdited.passportNo,
              address: stateEdited.address,
              location: stateEdited.location,
              status: WORKFORCE_STATUS$1.ACTIVE,
              organizationEmployee: stateEdited.organizationEmployee
            };
            _context.next = 5;
            return dispatch(createOrganizationEmployee(workforceEmployeeData, "Created Organization Employee ".concat(workforceEmployeeData.nameEn)));
          case 5:
            _this.setState({
              isSaved: true
            });
          case 6:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })));
    _defineProperty(_this, "updateAttribute", function (key, value) {
      _this.setState(function (prevState) {
        return {
          stateEdited: _objectSpread$C(_objectSpread$C({}, prevState.stateEdited), {}, _defineProperty({}, key, value)),
          isSaved: false
        };
      });
    });
    _this.state = {
      stateEdited: {},
      isSaved: false
    };
    return _this;
  }
  _inherits(AddApplicationPage, _Component);
  return _createClass(AddApplicationPage, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props = this.props,
        submittingMutation = _this$props.submittingMutation,
        mutation = _this$props.mutation,
        dispatch = _this$props.dispatch;
      if (!submittingMutation && prevProps.submittingMutation !== submittingMutation) {
        dispatch(journalize(mutation));
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this,
        _stateEdited$gender;
      var classes = this.props.classes;
      var _this$state = this.state,
        stateEdited = _this$state.stateEdited,
        isSaved = _this$state.isSaved;
      console.log({
        stateEdited: stateEdited
      });
      return /*#__PURE__*/React.createElement("div", {
        className: classes.page
      }, /*#__PURE__*/React.createElement(Grid, {
        container: true
      }, /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12
      }, /*#__PURE__*/React.createElement(Paper, {
        className: classes.paper
      }, /*#__PURE__*/React.createElement(Grid, {
        container: true,
        className: classes.tableTitle
      }, /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12,
        className: classes.tableTitle
      }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(FormattedMessage, {
        module: MODULE_NAME,
        id: "Organizations Employee",
        values: {
          label: EMPTY_STRING
        }
      })))), /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement(Grid, {
        container: true,
        className: classes.item
      }, /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.organization.employee.name.en",
        value: stateEdited.title || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("title", v);
        },
        required: true,
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.organization.employee.name.bn",
        value: stateEdited.titleBn || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("titleBn", v);
        },
        required: true,
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.organization.employee.phone",
        value: stateEdited.phone || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("phone", v);
        },
        type: "number",
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.organization.employee.email",
        value: stateEdited.email || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("email", v);
        },
        type: "email",
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(EmployeeGenderPicker, {
        value: stateEdited === null || stateEdited === void 0 || (_stateEdited$gender = stateEdited.gender) === null || _stateEdited$gender === void 0 ? void 0 : _stateEdited$gender.id,
        label: /*#__PURE__*/React.createElement(FormattedMessage, {
          id: "workforce.organization.employee.gender",
          module: "workforce"
        }),
        onChange: function onChange(v) {
          return _this2.updateAttribute("gender", v);
        },
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(PublishedComponent, {
        pubRef: "workforce.DatePicker",
        label: "workforce.organization.employee.birthdate",
        value: stateEdited.birthDate || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("birthDate", v);
        },
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(PublishedComponent, {
        pubRef: "workforce.DatePicker",
        label: "workforce.organization.employee.joining_date",
        value: stateEdited.firstJoiningDate || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("firstJoiningDate", v);
        },
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.organization.employee.birth_certificate_no",
        value: stateEdited.birthCertificateNo || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("birthCertificateNo", v);
        },
        type: "number",
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.organization.employee.nid",
        value: stateEdited.nid || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("nid", v);
        },
        type: "number",
        required: true,
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.organization.employee.passport_no",
        value: stateEdited.passportNo || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("passportNo", v);
        },
        type: "number",
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12,
        className: classes.item
      }, /*#__PURE__*/React.createElement(PublishedComponent, {
        pubRef: "location.DetailedLocation",
        withNull: true,
        value: stateEdited.location || null,
        onChange: function onChange(location) {
          return _this2.updateAttribute("location", location);
        },
        readOnly: isSaved,
        required: true,
        split: true
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.organization.employee.address",
        value: stateEdited.address || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("address", v);
        },
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 11,
        className: classes.item
      }), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 1,
        className: classes.item
      }, /*#__PURE__*/React.createElement(IconButton, {
        variant: "contained",
        component: "label",
        color: "primary",
        onClick: this.save,
        disabled: isSaved
      }, /*#__PURE__*/React.createElement(Save, null)))), /*#__PURE__*/React.createElement(Divider, null)))));
    }
  }]);
}(Component);
var mapStateToProps$e = function mapStateToProps(state) {
  return {
    submittingMutation: state.workforce.submittingMutation,
    mutation: state.workforce.mutation
  };
};
var AddApplicationPage$1 = connect(mapStateToProps$e)(withStyles(styles$f)(AddApplicationPage));

// --- ROBUST STYLES FOR PRINTING (NO CHANGES) ---
var useStyles$H = makeStyles({
  "@global": {
    fontSize: "small",
    "@media all": {
      ".page-break": {
        display: "none"
      }
    },
    "@media print": {
      "html, body": {
        height: "initial !important",
        overflow: "initial !important",
        WebkitPrintColorAdjust: "exact"
      },
      ".page-break": {
        marginTop: "1rem",
        display: "block",
        pageBreakBefore: "auto"
      },
      "table, tr, td, th": {
        pageBreakInside: "avoid !important"
      },
      "div, p, section, article, header, footer, main": {
        pageBreakInside: "avoid !important"
      },
      ".MuiGrid-container": {
        pageBreakInside: "avoid !important"
      },
      ".MuiTable-root": {
        pageBreakInside: "avoid !important"
      },
      "@page": {
        size: "auto",
        margin: "20mm"
      }
    }
  },
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    overflowY: "scroll"
  },
  modalContent: {
    backgroundColor: "#fff",
    boxShadow: "0 4px 12px rgba(0,0,0,0.3)",
    padding: "16px",
    width: "90%",
    maxWidth: "210mm",
    maxHeight: "90vh",
    overflowY: "auto"
  },
  printControls: {
    textAlign: "right",
    marginBottom: "16px",
    paddingRight: "16px"
  },
  paper: {
    fontFamily: "'Siyam Rupali', Arial, sans-serif",
    padding: "32px",
    color: "#000",
    backgroundColor: "#fff",
    boxSizing: "border-box"
  },
  headerContainer: {
    marginBottom: "16px",
    position: "relative"
  },
  logo: {
    maxWidth: "70px",
    maxHeight: "70px"
  },
  headerText: {
    textAlign: "center"
  },
  title: {
    fontSize: "small",
    fontWeight: "bold",
    textAlign: "center",
    margin: "8px 0 5px 0",
    textDecoration: "underline"
  },
  sectionTitle: {
    fontWeight: "bold",
    fontSize: "small",
    marginTop: "8px",
    marginBottom: "4px",
    borderBottom: "1px solid #000",
    paddingBottom: "4px"
  },
  fieldValue: {
    borderBottom: "1px dotted #000",
    minHeight: "20px",
    paddingLeft: "8px",
    width: "100%",
    display: "block",
    fontSize: "0.9rem"
  },
  fieldLabel: {
    textAlign: "left",
    fontSize: "0.9rem",
    paddingRight: "8px"
  },
  checkboxContainer: {
    display: "flex",
    alignItems: "center",
    marginRight: "16px"
  },
  checkbox: {
    width: "15px",
    height: "15px",
    border: "1px solid #000",
    marginRight: "4px",
    display: "inline-block",
    backgroundColor: "transparent"
  },
  checked: {
    backgroundColor: "#000"
  },
  table: {
    width: "100%",
    borderCollapse: "collapse",
    color: "black",
    marginTop: "8px",
    "& th, & td": {
      border: "1px solid #000",
      padding: "8px",
      textAlign: "left",
      verticalAlign: "top"
    },
    "& th": {
      fontWeight: "bold",
      backgroundColor: "#f0f0f0",
      textAlign: "center"
    }
  },
  signatureBox: {
    marginTop: "40px",
    paddingTop: "8px",
    display: "flex",
    justifyContent: "space-between",
    flexWrap: "wrap"
  },
  signatureItem: {
    width: "30%",
    textAlign: "center",
    borderTop: "1px solid #000",
    paddingTop: "8px",
    fontSize: "0.8rem"
  },
  photoBox: {
    border: "1px solid #000",
    width: "120px",
    height: "155px",
    textAlign: "center",
    padding: "8px",
    fontSize: "12px",
    lineHeight: "1.2",
    position: "absolute",
    right: 0,
    top: "60px"
  },
  note: {
    fontSize: "0.85rem",
    marginTop: "8px",
    marginBottom: "8px"
  },
  list: {
    listStyleType: "disc",
    paddingLeft: "24px",
    "& li": {
      marginBottom: "4px",
      fontSize: "0.9rem"
    }
  },
  documentPage: {
    textAlign: "center"
  },
  documentTitle: {
    marginBottom: "16px",
    textDecoration: "underline"
  },
  documentImage: {
    maxWidth: "100%",
    height: "auto",
    maxHeight: "900px"
  }
});

// --- HELPER FUNCTIONS ---
var safeJsonParse$1 = function safeJsonParse(str) {
  try {
    var parsed = JSON.parse(str);
    return _typeof(parsed) === "object" && parsed !== null ? parsed : {};
  } catch (e) {
    return {};
  }
};
var formatDate$1 = function formatDate(dateString) {
  if (!dateString) return "";
  try {
    var date = new Date(dateString);
    var day = String(date.getDate()).padStart(2, "0");
    var month = String(date.getMonth() + 1).padStart(2, "0");
    var year = date.getFullYear();
    return "".concat(day, "-").concat(month, "-").concat(year);
  } catch (e) {
    return dateString;
  }
};
var formatAddress$1 = function formatAddress(locationData, addressInput) {
  var _address, _address2, _address3, _address4, _address5, _locationData$parent, _locationData$parent2;
  var address = {};
  if (typeof addressInput === 'string') {
    address = safeJsonParse$1(addressInput);
  } else if (_typeof(addressInput) === 'object' && addressInput !== null) {
    address = addressInput;
  }
  var postOffice = ((_address = address) === null || _address === void 0 || (_address = _address.postOffice) === null || _address === void 0 ? void 0 : _address.nameBn) || ((_address2 = address) === null || _address2 === void 0 || (_address2 = _address2.postOffice) === null || _address2 === void 0 ? void 0 : _address2.nameEn);
  var village = [(_address3 = address) === null || _address3 === void 0 ? void 0 : _address3.houseName, (_address4 = address) === null || _address4 === void 0 ? void 0 : _address4.paraMahalla, (_address5 = address) === null || _address5 === void 0 ? void 0 : _address5.villageRoad].filter(Boolean).join(", ") || (locationData === null || locationData === void 0 ? void 0 : locationData.name);
  var thana = locationData === null || locationData === void 0 || (_locationData$parent = locationData.parent) === null || _locationData$parent === void 0 ? void 0 : _locationData$parent.name;
  var district = locationData === null || locationData === void 0 || (_locationData$parent2 = locationData.parent) === null || _locationData$parent2 === void 0 || (_locationData$parent2 = _locationData$parent2.parent) === null || _locationData$parent2 === void 0 ? void 0 : _locationData$parent2.name;
  return {
    village: village || "N/A",
    postOffice: postOffice || "N/A",
    thana: thana || "N/A",
    district: district || "N/A"
  };
};
var translateRelation = function translateRelation(relationKey) {
  var map = {
    "workforce.relation.father": "পিতা",
    "workforce.relation.mother": "মাতা",
    "workforce.relation.wife": "স্ত্রী",
    "workforce.relation.husband": "স্বামী",
    "workforce.relation.son": "পুত্র",
    "workforce.relation.daughter": "কন্যা",
    "workforce.relation.brother": "ভাই",
    "workforce.relation.sister": "বোন"
  };
  return map[relationKey] || relationKey;
};
function DeathApplicationPrint(_ref) {
  var _data$employeeAcciden;
  _ref.printRef;
    var data = _ref.data,
    documents = _ref.documents,
    logoLeftUrl = _ref.logoLeftUrl,
    logoLeft = _ref.logoLeft;
  var classes = useStyles$H();
  if (!data) return /*#__PURE__*/React.createElement("p", null, "\u0986\u09AC\u09C7\u09A6\u09A8\u09C7\u09B0 \u0995\u09CB\u09A8\u09CB \u09A4\u09A5\u09CD\u09AF \u09AA\u09BE\u0993\u09AF\u09BC\u09BE \u09AF\u09BE\u09AF\u09BC\u09A8\u09BF\u0964");
  var workforceEmployee = data.workforceEmployee,
    employeeBankInfo = data.employeeBankInfo,
    employeeFactory = data.employeeFactory,
    dateCreated = data.dateCreated,
    applicantInfo = data.applicantInfo,
    deceasedWorkerInfo = data.deceasedWorkerInfo,
    metadata = data.metadata,
    _data$movementLogs = data.movementLogs,
    movementLogs = _data$movementLogs === void 0 ? [] : _data$movementLogs;

  // --- 1. APPLICANT INFO ---
  var applicantName = (applicantInfo === null || applicantInfo === void 0 ? void 0 : applicantInfo.nameBn) || (applicantInfo === null || applicantInfo === void 0 ? void 0 : applicantInfo.nameEn) || "N/A";
  var applicantRelation = translateRelation(applicantInfo === null || applicantInfo === void 0 ? void 0 : applicantInfo.relationWithApplicant) || "N/A";
  var applicantNid = (applicantInfo === null || applicantInfo === void 0 ? void 0 : applicantInfo.nid) || "N/A";
  var applicantDOB = (applicantInfo === null || applicantInfo === void 0 ? void 0 : applicantInfo.birthDate) || "N/A";
  var applicantMobile = (applicantInfo === null || applicantInfo === void 0 ? void 0 : applicantInfo.phoneNumber) || "N/A";
  var appPermLoc = applicantInfo === null || applicantInfo === void 0 ? void 0 : applicantInfo.permanentLocation;
  var appPermAddrObj = applicantInfo === null || applicantInfo === void 0 ? void 0 : applicantInfo.permanentAddress;
  var applicantPermanentAddress = formatAddress$1(appPermLoc, appPermAddrObj);
  var appPresLoc = applicantInfo === null || applicantInfo === void 0 ? void 0 : applicantInfo.presentLocation;
  var appPresAddrObj = applicantInfo === null || applicantInfo === void 0 ? void 0 : applicantInfo.presentAddress;
  var applicantPresentAddress = formatAddress$1(appPresLoc, appPresAddrObj);

  // --- 3. DECEASED WORKER INFO ---
  var deceasedName = (deceasedWorkerInfo === null || deceasedWorkerInfo === void 0 ? void 0 : deceasedWorkerInfo.nameBn) || (deceasedWorkerInfo === null || deceasedWorkerInfo === void 0 ? void 0 : deceasedWorkerInfo.nameEn) || "N/A";
  var deceasedFatherName = (deceasedWorkerInfo === null || deceasedWorkerInfo === void 0 ? void 0 : deceasedWorkerInfo.fatherNameBn) || (deceasedWorkerInfo === null || deceasedWorkerInfo === void 0 ? void 0 : deceasedWorkerInfo.fatherNameEn) || "N/A";
  var deceasedMotherName = (deceasedWorkerInfo === null || deceasedWorkerInfo === void 0 ? void 0 : deceasedWorkerInfo.motherNameBn) || (deceasedWorkerInfo === null || deceasedWorkerInfo === void 0 ? void 0 : deceasedWorkerInfo.motherNameEn) || "N/A";
  var deceasedPosition = (workforceEmployee === null || workforceEmployee === void 0 ? void 0 : workforceEmployee.position) || "N/A";
  var deceasedNid = (deceasedWorkerInfo === null || deceasedWorkerInfo === void 0 ? void 0 : deceasedWorkerInfo.nid) || "N/A";
  var deathDate = (metadata === null || metadata === void 0 ? void 0 : metadata.deathDate) || (data === null || data === void 0 || (_data$employeeAcciden = data.employeeAccidentInfo) === null || _data$employeeAcciden === void 0 ? void 0 : _data$employeeAcciden.dateOfDeath) || "N/A";
  var gender = workforceEmployee === null || workforceEmployee === void 0 ? void 0 : workforceEmployee.gender;
  var decPermLoc = deceasedWorkerInfo === null || deceasedWorkerInfo === void 0 ? void 0 : deceasedWorkerInfo.permanentLocation;
  var decPermAddrObj = deceasedWorkerInfo === null || deceasedWorkerInfo === void 0 ? void 0 : deceasedWorkerInfo.permanentAddress;
  var deceasedPermanentAddress = formatAddress$1(decPermLoc, decPermAddrObj);

  // Checkbox logic based on metadata
  var isNormalDeath = (metadata === null || metadata === void 0 ? void 0 : metadata.deathType) === "normalDeath";
  formatDate$1(dateCreated);
  var requiredAttachments = [{
    label: "রেজিস্টার্ড চিকিৎসক/ ইউনিয়ন পরিষদ / পৌরসভা বা সিটি কর্পোরেশন কর্তৃক প্রদত্ত মৃত্যু সনদ (মূলকপি)",
    checked: true
  }, {
    label: "মৃত শ্রমিকের নিয়োগপত্র",
    checked: true
  }, {
    label: "প্রতিষ্ঠান কর্তৃক প্রদত্ত আইডি কার্ড",
    checked: true
  }, {
    label: "ইউনিয়ন পরিষদ / পৌরসভা বা সিটি কর্পোরেশন হতে ওয়ারিশান সনদ (মূলকপি)",
    checked: true
  }, {
    label: "মৃত শ্রমিকের জাতীয় পরিচয়পত্র এবং ছবি",
    checked: true
  }, {
    label: "প্রতিষ্ঠান কর্তৃক প্রদত্ত প্রত্যয়ন পত্র (শ্রমিকের সকল তথ্যসহ)",
    checked: true
  }, {
    label: "নমিনীর জাতীয় পরিচয়পত্র/ জন্মসনদ এবং ছবি",
    checked: true
  }, {
    label: "মৃত শ্রমিকের শেষ ছয় মাসের বেতন শীটের কপি",
    checked: true
  }, {
    label: "প্রতিষ্ঠান কর্তৃক প্রদত্ত প্রত্যয়ন পত্র (নমিনীর সকল তথ্যসহ)",
    checked: true
  }, {
    label: "নমিনীর ব্যাংক হিসাবের চেক বা স্টেটমেন্টের কপি",
    checked: true
  }, {
    label: "প্রতিষ্ঠানের মেম্বারশীপ সনদপত্র",
    checked: true
  }, {
    label: "মৃত শ্রমিকের অনলাইন ডেটাবেজের কপি",
    checked: true
  }];
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Paper, {
    id: "print-container",
    className: "".concat(classes.paper, " printable-paper")
  }, /*#__PURE__*/React.createElement(Box$1, {
    position: "relative"
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    alignItems: "center",
    className: classes.headerContainer
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 2,
    style: {
      textAlign: "left"
    }
  }, logoLeft && /*#__PURE__*/React.createElement("img", {
    src: logoLeft,
    alt: "Govt Logo",
    className: classes.logo
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 8,
    className: classes.headerText
  }, logoLeftUrl && /*#__PURE__*/React.createElement("img", {
    src: logoLeftUrl,
    alt: "Govt Logo",
    className: classes.logo
  }), /*#__PURE__*/React.createElement(Typography, {
    variant: "body1",
    style: {
      marginTop: "4px"
    }
  }, "\u0997\u09A3\u09AA\u09CD\u09B0\u099C\u09BE\u09A4\u09A8\u09CD\u09A4\u09CD\u09B0\u09C0 \u09AC\u09BE\u0982\u09B2\u09BE\u09A6\u09C7\u09B6 \u09B8\u09B0\u0995\u09BE\u09B0"), /*#__PURE__*/React.createElement(Typography, {
    variant: "body1"
  }, (data === null || data === void 0 ? void 0 : data.organizationType) === "cf" ? "কেন্দ্রীয় তহবিল" : (data === null || data === void 0 ? void 0 : data.organizationType) === "eis" ? "ই.আই.এস." : "বাংলাদেশ শ্রমিক কল্যাণ ফাউন্ডেশন"), /*#__PURE__*/React.createElement(Typography, {
    variant: "body1"
  }, "\u09B6\u09CD\u09B0\u09AE \u0993 \u0995\u09B0\u09CD\u09AE\u09B8\u0982\u09B8\u09CD\u09A5\u09BE\u09A8 \u09AE\u09A8\u09CD\u09A4\u09CD\u09B0\u09A3\u09BE\u09B2\u09AF\u09BC"), /*#__PURE__*/React.createElement(Typography, {
    variant: "body2"
  }, "\u09E8\u09E7 \u09A4\u09B2\u09BE, \u09AD\u09AC\u09A8 \u09A8\u0982: \u09EC, \u09AC\u09BE\u0982\u09B2\u09BE\u09A6\u09C7\u09B6 \u09B8\u099A\u09BF\u09AC\u09BE\u09B2\u09AF\u09BC, \u09A2\u09BE\u0995\u09BE-\u09E7\u09E6\u09E6\u09E6\u0964"), /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    style: {
      color: "blue"
    }
  }, "www.centralfund.gov.bd")), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 2
  }, /*#__PURE__*/React.createElement(Box$1, {
    className: classes.photoBox
  }, documents && documents.length > 0 && documents.map(function (doc, index) {
    var _doc$workforceDocumen, _doc$workforceDocumen2;
    return (doc === null || doc === void 0 || (_doc$workforceDocumen = doc.workforceDocumentType) === null || _doc$workforceDocumen === void 0 ? void 0 : _doc$workforceDocumen.nameBn) === 'শ্রমিকের ছবি' && /*#__PURE__*/React.createElement("img", {
      src: doc === null || doc === void 0 ? void 0 : doc.url,
      alt: doc === null || doc === void 0 || (_doc$workforceDocumen2 = doc.workforceDocumentType) === null || _doc$workforceDocumen2 === void 0 ? void 0 : _doc$workforceDocumen2.nameBn,
      style: {
        width: "100%"
      }
    });
  })))), /*#__PURE__*/React.createElement(Typography, {
    className: classes.title
  }, "\u09AE\u09C3\u09A4\u09CD\u09AF\u09C1\u099C\u09A8\u09BF\u09A4 \u0995\u09BE\u09B0\u09A3\u09C7 \u0986\u09B0\u09CD\u09A5\u09BF\u0995 \u09B8\u09B9\u09BE\u09AF\u09BC\u09A4\u09BE\u09B0 \u0986\u09AC\u09C7\u09A6\u09A8 \u09AB\u09B0\u09AE"), /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    style: {
      textAlign: "center"
    }
  }, "(\u09B6\u09A4\u09AD\u09BE\u0997 \u09B0\u09AA\u09CD\u09A4\u09BE\u09A8\u09BF\u09AE\u09C1\u0996\u09BF \u09B6\u09BF\u09B2\u09CD\u09AA \u0995\u09BE\u09B0\u0996\u09BE\u09A8\u09BE\u09AF\u09BC \u0995\u09B0\u09CD\u09AE\u09B0\u09A4 \u09B6\u09CD\u09B0\u09AE\u09BF\u0995\u09C7\u09B0 \u0993\u09AF\u09BC\u09BE\u09B0\u09BF\u09B6\u09BE\u09A8/\u0993\u09AF\u09BC\u09BE\u09B0\u09BF\u09B6\u09BE\u09A8\u09A6\u09C7\u09B0 \u099C\u09A8\u09CD\u09AF)"), /*#__PURE__*/React.createElement(Typography, {
    variant: "body1",
    style: {
      textAlign: "left"
    }
  }, "\u09AC\u09B0\u09BE\u09AC\u09B0"), /*#__PURE__*/React.createElement(Typography, {
    variant: "body1",
    style: {
      textAlign: "left"
    }
  }, "\u09AE\u09B9\u09BE\u09AA\u09B0\u09BF\u099A\u09BE\u09B2\u0995"), /*#__PURE__*/React.createElement(Typography, {
    variant: "body1",
    style: {
      textAlign: "left"
    }
  }, "\u0995\u09C7\u09A8\u09CD\u09A6\u09CD\u09B0\u09C0\u09AF\u09BC \u09A4\u09B9\u09AC\u09BF\u09B2"), /*#__PURE__*/React.createElement(Typography, {
    className: classes.sectionTitle
  }, "\u0986\u09B0\u09CD\u09A5\u09BF\u0995 \u09B8\u09B9\u09BE\u09AF\u09BC\u09A4\u09BE \u099A\u09BE\u0993\u09AF\u09BC\u09BE\u09B0 \u0995\u09BE\u09B0\u09A3\u0983- \u09B8\u0982\u09B6\u09CD\u09B2\u09BF\u09B7\u09CD\u099F \u0995\u09CD\u09B7\u09C7\u09A4\u09CD\u09B0\u09C7 \u099F\u09BF\u0995 \u099A\u09BF\u09B9\u09CD\u09A8 (\u2713) \u09A6\u09BF\u09A8"), /*#__PURE__*/React.createElement(Box$1, {
    display: "flex",
    style: {
      marginBottom: "8px"
    }
  }, /*#__PURE__*/React.createElement(Box$1, {
    className: classes.checkboxContainer
  }, /*#__PURE__*/React.createElement(Checkbox, {
    checked: !isNormalDeath,
    color: "default",
    size: "small",
    style: {
      padding: 0,
      paddingRight: "4px",
      color: "black"
    }
  }), /*#__PURE__*/React.createElement(Typography, {
    variant: "body1"
  }, "(\u0996) \u09A6\u09C1\u09B0\u09CD\u0998\u099F\u09A8\u09BE\u099C\u09A8\u09BF\u09A4 \u0995\u09BE\u09B0\u09A3\u09C7 \u09AE\u09C3\u09A4\u09CD\u09AF\u09C1")), /*#__PURE__*/React.createElement(Box$1, {
    className: classes.checkboxContainer
  }, /*#__PURE__*/React.createElement(Checkbox, {
    checked: isNormalDeath,
    color: "default",
    size: "small",
    style: {
      padding: 0,
      paddingRight: "4px",
      color: "black"
    }
  }), /*#__PURE__*/React.createElement(Typography, {
    variant: "body1"
  }, "(\u0995) \u09B8\u09CD\u09AC\u09BE\u09AD\u09BE\u09AC\u09BF\u0995 \u09AE\u09C3\u09A4\u09CD\u09AF\u09C1"))), /*#__PURE__*/React.createElement(Typography, {
    className: classes.note,
    style: {
      marginTop: 0
    }
  }, "\u09AC\u09BF\u0983\u09A6\u09CD\u09B0\u0983 \u0986\u09AC\u09C7\u09A6\u09A8\u09C7\u09B0 \u09B8\u09AE\u09AF\u09BC\u09B8\u09C0\u09AE\u09BE \u09AE\u09C3\u09A4\u09CD\u09AF\u09C1\u09B0 \u09E7\u09E8\u09E6 \u09A6\u09BF\u09A8\u09C7\u09B0 \u09AE\u09A7\u09CD\u09AF\u09C7 \u09B9\u09A4\u09C7 \u09B9\u09AC\u09C7\u0964"), /*#__PURE__*/React.createElement(Typography, {
    className: classes.sectionTitle
  }, "\u09E7\u0964 \u0986\u09AC\u09C7\u09A6\u09A8\u0995\u09BE\u09B0\u09C0 \u09AC\u09CD\u09AF\u0995\u09CD\u09A4\u09BF\u0997\u09A4 \u09A4\u09A5\u09CD\u09AF\u09AC\u09B2\u09C0\u0983-"), /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 1
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 2
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.fieldLabel
  }, "\u09A8\u09BE\u09AE\u0983")), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 10
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.fieldValue
  }, applicantName)), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 3
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.fieldLabel
  }, "\u09AE\u09C3\u09A4 \u09B6\u09CD\u09B0\u09AE\u09BF\u0995\u09C7\u09B0 \u09B8\u09BE\u09A5\u09C7 \u09B8\u09AE\u09CD\u09AA\u09B0\u09CD\u0995\u0983")), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 3
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.fieldValue
  }, applicantRelation)), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 2
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.fieldLabel
  }, "\u099C\u09A8\u09CD\u09AE \u09A4\u09BE\u09B0\u09BF\u0996\u0983")), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 4
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.fieldValue
  }, formatDate$1(applicantDOB))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 5
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.fieldLabel
  }, "\u099C\u09BE\u09A4\u09C0\u09AF\u09BC \u09AA\u09B0\u09BF\u099A\u09AF\u09BC\u09AA\u09A4\u09CD\u09B0/ \u099C\u09A8\u09CD\u09AE \u09B8\u09A8\u09A6 \u09A8\u09BE\u09AE\u09CD\u09AC\u09BE\u09B0\u0983")), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 7
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.fieldValue
  }, applicantNid)), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 4
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.fieldLabel
  }, "\u09AE\u09CB\u09AC\u09BE\u0987\u09B2 \u09A8\u09BE\u09AE\u09CD\u09AC\u09B0 (\u0986\u09AC\u09B6\u09CD\u09AF\u09BF\u0995):-")), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 8
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.fieldValue
  }, applicantMobile))), /*#__PURE__*/React.createElement(Typography, {
    style: {
      marginTop: "8px",
      fontWeight: "bold"
    }
  }, "\u09B8\u09CD\u09A5\u09BE\u09AF\u09BC\u09C0 \u09A0\u09BF\u0995\u09BE\u09A8\u09BE\u0983"), /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 1
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 2
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.fieldLabel
  }, "\u0997\u09CD\u09B0\u09BE\u09AE/\u09AE\u09B9\u09B2\u09CD\u09B2\u09BE\u0983")), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 4
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.fieldValue
  }, applicantPermanentAddress.village)), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 2
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.fieldLabel
  }, "\u09A1\u09BE\u0995\u0998\u09B0\u0983")), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 4
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.fieldValue
  }, applicantPermanentAddress.postOffice)), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 2
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.fieldLabel
  }, "\u09A5\u09BE\u09A8\u09BE/\u0989\u09AA\u099C\u09C7\u09B2\u09BE\u0983")), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 4
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.fieldValue
  }, applicantPermanentAddress.thana)), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 2
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.fieldLabel
  }, "\u099C\u09C7\u09B2\u09BE\u0983")), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 4
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.fieldValue
  }, applicantPermanentAddress.district))), /*#__PURE__*/React.createElement(Typography, {
    style: {
      marginTop: "8px",
      fontWeight: "bold"
    }
  }, "\u09AC\u09B0\u09CD\u09A4\u09AE\u09BE\u09A8 \u09A0\u09BF\u0995\u09BE\u09A8\u09BE\u0983-"), /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 1
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 2
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.fieldLabel
  }, "\u0997\u09CD\u09B0\u09BE\u09AE/\u09AE\u09B9\u09B2\u09CD\u09B2\u09BE\u0983")), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 4
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.fieldValue
  }, applicantPresentAddress.village)), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 2
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.fieldLabel
  }, "\u09A1\u09BE\u0995\u0998\u09B0\u0983")), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 4
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.fieldValue
  }, applicantPresentAddress.postOffice)), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 2
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.fieldLabel
  }, "\u09A5\u09BE\u09A8\u09BE/\u0989\u09AA\u099C\u09C7\u09B2\u09BE\u0983")), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 4
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.fieldValue
  }, applicantPresentAddress.thana)), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 2
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.fieldLabel
  }, "\u099C\u09C7\u09B2\u09BE\u0983")), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 4
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.fieldValue
  }, applicantPresentAddress.district))), /*#__PURE__*/React.createElement(Typography, {
    className: classes.sectionTitle
  }, "\u09E8\u0964 \u09AE\u09C3\u09A4 \u09B6\u09CD\u09B0\u09AE\u09BF\u0995\u09C7\u09B0 \u0995\u09B0\u09CD\u09AE\u09B0\u09A4 \u09AA\u09CD\u09B0\u09A4\u09BF\u09B7\u09CD\u09A0\u09BE\u09A8\u09C7\u09B0 / \u0995\u09BE\u09B0\u0996\u09BE\u09A8\u09BE\u09B0 \u09A8\u09BE\u09AE \u0993 \u09A0\u09BF\u0995\u09BE\u09A8\u09BE (\u09B8\u09CD\u09AA\u09B7\u09CD\u099F \u0985\u0995\u09CD\u09B7\u09B0\u09C7) \u09B2\u09BF\u0996\u09C1\u09A8\u0983-"), /*#__PURE__*/React.createElement(Typography, {
    className: classes.fieldValue
  }, (employeeFactory === null || employeeFactory === void 0 ? void 0 : employeeFactory.nameBn) || (employeeFactory === null || employeeFactory === void 0 ? void 0 : employeeFactory.nameEn) || "N/A"), /*#__PURE__*/React.createElement(Typography, {
    className: classes.fieldValue,
    style: {
      marginTop: "5px"
    }
  }), /*#__PURE__*/React.createElement(Typography, {
    className: classes.sectionTitle
  }, "\u09E9\u0964 \u09AE\u09C3\u09A4 \u09B6\u09CD\u09B0\u09AE\u09BF\u0995\u09C7\u09B0 \u09AC\u09BF\u09AC\u09B0\u09A3\u0983-"), /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 1
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 2
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.fieldLabel
  }, "\u09A8\u09BE\u09AE\u0983")), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 7
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.fieldValue
  }, deceasedName)), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 3,
    container: true,
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(Box$1, {
    className: classes.checkboxContainer
  }, /*#__PURE__*/React.createElement(Box$1, {
    className: "".concat(classes.checkbox, " ").concat(gender === "M" || gender === "workforce.gender.male" ? classes.checked : "")
  }), "\u09AA\u09C1\u09B0\u09C1\u09B7"), /*#__PURE__*/React.createElement(Box$1, {
    className: classes.checkboxContainer
  }, /*#__PURE__*/React.createElement(Box$1, {
    className: "".concat(classes.checkbox, " ").concat(gender === "F" || gender === "workforce.gender.female" ? classes.checked : ""),
    style: {
      marginLeft: "8px"
    }
  }), "\u09A8\u09BE\u09B0\u09C0")), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 2
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.fieldLabel
  }, "\u09AA\u09BF\u09A4\u09BE\u09B0 \u09A8\u09BE\u09AE\u0983")), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 4
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.fieldValue
  }, deceasedFatherName)), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 2
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.fieldLabel
  }, "\u09AE\u09BE\u09A4\u09BE\u09B0 \u09A8\u09BE\u09AE\u0983")), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 4
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.fieldValue
  }, deceasedMotherName)), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 2
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.fieldLabel
  }, "\u09AA\u09A6\u09AC\u09BF\u0983")), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 4
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.fieldValue
  }, deceasedPosition)), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 2
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.fieldLabel
  }, "\u09AE\u09C3\u09A4\u09CD\u09AF\u09C1\u09B0 \u09A4\u09BE\u09B0\u09BF\u0996\u0983")), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 4
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.fieldValue
  }, formatDate$1(deathDate))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 2
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.fieldLabel
  }, "\u09AE\u09C3\u09A4\u09CD\u09AF\u09C1\u09B0 \u0995\u09BE\u09B0\u09A3\u0983")), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 10
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.fieldValue
  }, isNormalDeath ? "স্বাভাবিক মৃত্যু" : "দুর্ঘটনা", " (\u09AA\u09CD\u09B0\u09BE\u09B8\u0999\u09CD\u0997\u09BF\u0995 \u09AA\u09CD\u09B0\u09AE\u09BE\u09A3\u09AA\u09A4\u09CD\u09B0 \u0985\u09A8\u09C1\u09AF\u09BE\u09AF\u09BC\u09C0)")), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 4
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.fieldLabel
  }, "\u099C\u09BE\u09A4\u09C0\u09AF\u09BC \u09AA\u09B0\u09BF\u099A\u09AF\u09BC \u09AA\u09A4\u09CD\u09B0/\u099C\u09A8\u09CD\u09AE \u09B8\u09A8\u09A6 \u09AA\u09A4\u09CD\u09B0\u09C7\u09B0 \u09A8\u09BE\u09AE\u09CD\u09AC\u09BE\u09B0\u0983")), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 8
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.fieldValue
  }, deceasedNid))), /*#__PURE__*/React.createElement(Typography, {
    style: {
      marginTop: "8px"
    }
  }, "\u09B8\u09CD\u09A5\u09BE\u09AF\u09BC\u09C0 \u09A0\u09BF\u0995\u09BE\u09A8\u09BE\u0983"), /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 1
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 2
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.fieldLabel
  }, "\u0997\u09CD\u09B0\u09BE\u09AE/\u09AE\u09B9\u09B2\u09CD\u09B2\u09BE\u0983")), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 4
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.fieldValue
  }, deceasedPermanentAddress.village)), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 2
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.fieldLabel
  }, "\u09A1\u09BE\u0995\u0998\u09B0\u0983")), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 4
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.fieldValue
  }, deceasedPermanentAddress.postOffice)), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 2
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.fieldLabel
  }, "\u09A5\u09BE\u09A8\u09BE/\u0989\u09AA\u099C\u09C7\u09B2\u09BE\u0983")), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 4
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.fieldValue
  }, deceasedPermanentAddress.thana)), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 2
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.fieldLabel
  }, "\u099C\u09C7\u09B2\u09BE\u0983")), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 4
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.fieldValue
  }, deceasedPermanentAddress.district))), /*#__PURE__*/React.createElement("div", {
    className: "page-break-before"
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.sectionTitle
  }, "\u09EA\u0964 \u09AE\u09C3\u09A4 \u09B6\u09CD\u09B0\u09AE\u09BF\u0995\u09C7\u09B0 \u0993\u09AF\u09BC\u09BE\u09B0\u09BF\u09B6 / \u0993\u09AF\u09BC\u09BE\u09B0\u09BF\u09B6\u09BE\u09A8\u09C7\u09B0 \u09AC\u09CD\u09AF\u09BE\u0982\u0995 \u09B9\u09BF\u09B8\u09BE\u09AC\u09C7\u09B0 \u09AC\u09BF\u09AC\u09B0\u09A3\u09C0\u0983-"), /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    style: {
      marginBottom: "8px"
    }
  }, "(\u098F\u0995\u09BE\u09A7\u09BF\u0995 \u0993\u09AF\u09BC\u09BE\u09B0\u09BF\u09B6\u09BE\u09A8\u09C7\u09B0 \u0995\u09CD\u09B7\u09C7\u09A4\u09CD\u09B0\u09C7 \u09AA\u09CD\u09B0\u09BE\u09AA\u09CD\u09AF\u09A4\u09BE (%) \u0989\u09B2\u09CD\u09B2\u09C7\u0996 \u0995\u09B0\u09A4\u09C7 \u09B9\u09AC\u09C7)"), /*#__PURE__*/React.createElement(TableContainer, {
    component: Box$1
  }, /*#__PURE__*/React.createElement(Table$2, {
    className: classes.table
  }, /*#__PURE__*/React.createElement(TableHead, null, /*#__PURE__*/React.createElement(TableRow, null, /*#__PURE__*/React.createElement(TableCell, null, "\u0995\u09CD\u09B0\u09AE"), /*#__PURE__*/React.createElement(TableCell, null, "\u09AE\u09C3\u09A4 \u09B6\u09CD\u09B0\u09AE\u09BF\u0995\u09C7\u09B0 \u0993\u09AF\u09BC\u09BE\u09B0\u09BF\u09B6 / \u0993\u09AF\u09BC\u09BE\u09B0\u09BF\u09B6\u09BE\u09A8\u09C7\u09B0 \u09A8\u09BE\u09AE"), /*#__PURE__*/React.createElement(TableCell, null, "\u09B8\u09AE\u09CD\u09AA\u09B0\u09CD\u0995"), /*#__PURE__*/React.createElement(TableCell, null, "\u09AC\u09CD\u09AF\u09BE\u0982\u0995 \u09B9\u09BF\u09B8\u09BE\u09AC \u09A8\u09BE\u09AE\u09CD\u09AC\u09BE\u09B0, \u09B6\u09BE\u0996\u09BE\u09B0 \u09A8\u09BE\u09AE"), /*#__PURE__*/React.createElement(TableCell, null, "\u09AC\u09CD\u09AF\u09BE\u0982\u0995\u09C7\u09B0 \u09B0\u09BE\u0989\u099F\u09BF\u0982 \u09A8\u09BE\u09AE\u09CD\u09AC\u09BE\u09B0"), /*#__PURE__*/React.createElement(TableCell, null, "\u09AA\u09CD\u09B0\u09BE\u09AA\u09CD\u09AF\u09A4\u09BE (%)"))), /*#__PURE__*/React.createElement(TableBody, null, employeeBankInfo === null || employeeBankInfo === void 0 ? void 0 : employeeBankInfo.map(function (bankInfo, index) {
    var _bankInfo$bank, _bankInfo$branch, _bankInfo$branch2;
    var bankName = (bankInfo === null || bankInfo === void 0 || (_bankInfo$bank = bankInfo.bank) === null || _bankInfo$bank === void 0 ? void 0 : _bankInfo$bank.nameBn) || "N/A";
    var branchName = (bankInfo === null || bankInfo === void 0 || (_bankInfo$branch = bankInfo.branch) === null || _bankInfo$branch === void 0 ? void 0 : _bankInfo$branch.nameBn) || "N/A";
    var accountHolderName = (bankInfo === null || bankInfo === void 0 ? void 0 : bankInfo.accountHolderName) || "N/A";
    var accountNumber = (bankInfo === null || bankInfo === void 0 ? void 0 : bankInfo.accountNumber) || "N/A";
    var routingNumber = (bankInfo === null || bankInfo === void 0 || (_bankInfo$branch2 = bankInfo.branch) === null || _bankInfo$branch2 === void 0 ? void 0 : _bankInfo$branch2.routingNumber) || "N/A";
    var relation = (bankInfo === null || bankInfo === void 0 ? void 0 : bankInfo.relationshipWithAccountHolder) || "N/A";
    return /*#__PURE__*/React.createElement(TableRow, {
      key: index
    }, /*#__PURE__*/React.createElement(TableCell, null, index + 1), /*#__PURE__*/React.createElement(TableCell, null, accountHolderName), /*#__PURE__*/React.createElement(TableCell, null, translateRelation(relation)), /*#__PURE__*/React.createElement(TableCell, null, accountNumber, ", ", branchName, ", ", bankName), /*#__PURE__*/React.createElement(TableCell, null, routingNumber), /*#__PURE__*/React.createElement(TableCell, null, "100% (\u0989\u09A6\u09BE\u09B9\u09B0\u09A3)"));
  }))))), /*#__PURE__*/React.createElement(Typography, {
    className: classes.sectionTitle
  }, "\u09EB\u0964 \u0985\u09A8\u09CD\u09AF \u0995\u09CB\u09A8\u09CB \u09A4\u09A5\u09CD\u09AF (\u09AF\u09A6\u09BF \u09A5\u09BE\u0995\u09C7):-"), /*#__PURE__*/React.createElement(Typography, {
    className: classes.fieldValue,
    style: {
      minHeight: "40px"
    }
  }), /*#__PURE__*/React.createElement(Typography, {
    className: classes.sectionTitle
  }, "\u09EC\u0964 \u09B8\u0982\u09AF\u09C1\u0995\u09CD\u09A4\u09BF\u0983- (\u0986\u09AC\u09C7\u09A6\u09A8 \u09A6\u09BE\u0996\u09BF\u09B2\u09C7\u09B0 \u09AA\u09C2\u09B0\u09CD\u09AC \u09A8\u09BF\u09AE\u09CD\u09A8\u09CB\u0995\u09CD\u09A4 \u09A6\u09B2\u09BF\u09B2\u09BE\u09A6\u09BF \u09B8\u0982\u09AF\u09C1\u0995\u09CD\u09A4 \u0995\u09B0\u09A4\u09C7 \u09B9\u09AC\u09C7)"), /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 1
  }, requiredAttachments.map(function (item, index) {
    return /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      key: index
    }, /*#__PURE__*/React.createElement(Box$1, {
      display: "flex",
      alignItems: "center"
    }, /*#__PURE__*/React.createElement(Box$1, {
      className: "".concat(classes.checkbox, " ").concat(item.checked ? classes.checked : "")
    }), /*#__PURE__*/React.createElement(Typography, {
      variant: "body2"
    }, item.label)));
  })), /*#__PURE__*/React.createElement(Box$1, {
    mt: 4
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6"
  }, "\u09ED\u0964 \u09AE\u09C1\u09AD\u09AE\u09C7\u09A8\u09CD\u099F \u09B2\u0997 / Movement Log"), /*#__PURE__*/React.createElement(Divider, null), movementLogs.length > 0 ? /*#__PURE__*/React.createElement(Table$2, {
    style: {
      marginTop: 8
    },
    size: "small",
    className: classes.table
  }, /*#__PURE__*/React.createElement(TableHead, null, /*#__PURE__*/React.createElement(TableRow, null, /*#__PURE__*/React.createElement(TableCell, null, /*#__PURE__*/React.createElement("b", null, "\u09A4\u09BE\u09B0\u09BF\u0996 / Date")), /*#__PURE__*/React.createElement(TableCell, null, /*#__PURE__*/React.createElement("b", null, "\u0985\u09AB\u09BF\u09B8\u09BE\u09B0\u09C7\u09B0 \u09A8\u09BE\u09AE / Action Taken")), /*#__PURE__*/React.createElement(TableCell, null, /*#__PURE__*/React.createElement("b", null, "\u09A6\u09BE\u09AF\u09BC\u09BF\u09A4\u09CD\u09AC\u09AA\u09CD\u09B0\u09BE\u09AA\u09CD\u09A4 \u09AA\u09A6\u09AC\u09C0 / Officer")), /*#__PURE__*/React.createElement(TableCell, null, /*#__PURE__*/React.createElement("b", null, "\u09AE\u09A8\u09CD\u09A4\u09AC\u09CD\u09AF / Remarks")))), /*#__PURE__*/React.createElement(TableBody, null, movementLogs.map(function (log, index) {
    return /*#__PURE__*/React.createElement(TableRow, {
      key: index
    }, /*#__PURE__*/React.createElement(TableCell, null, log.date || "-"), /*#__PURE__*/React.createElement(TableCell, null, log.name || "-"), /*#__PURE__*/React.createElement(TableCell, null, log.role || "-"), /*#__PURE__*/React.createElement(TableCell, null, log.revertNote || "-"));
  }))) : /*#__PURE__*/React.createElement(Typography, {
    color: "textSecondary",
    style: {
      marginTop: 8
    }
  }, "No movement data found.")), /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    className: classes.note,
    style: {
      textAlign: "center",
      marginTop: "15px"
    }
  }, "(\u09AC\u09BF\u0983\u09A6\u09CD\u09B0\u0983- \u0985\u09B8\u09AE\u09CD\u09AA\u09C2\u09B0\u09CD\u09A3 \u0993 \u09AD\u09C1\u09B2 \u0986\u09AC\u09C7\u09A6\u09A8 \u09AC\u09BE\u09A4\u09BF\u09B2\u09C7\u09B0 \u0995\u09CD\u09B7\u09C7\u09A4\u09CD\u09B0\u09C7 \u0995\u09C7\u09A8\u09CD\u09A6\u09CD\u09B0\u09C0\u09AF\u09BC \u09A4\u09B9\u09AC\u09BF\u09B2\u09C7\u09B0 \u09B8\u09BF\u09A6\u09CD\u09A7\u09BE\u09A8\u09CD\u09A4\u0987 \u099A\u09C2\u09A1\u09BC\u09BE\u09A8\u09CD\u09A4 \u09AC\u09B2\u09C7 \u0997\u09A3\u09CD\u09AF \u09B9\u09AC\u09C7\u0964)"))), documents && documents.length > 0 && documents.map(function (doc, index) {
    var _doc$workforceDocumen3, _doc$workforceDocumen4;
    return /*#__PURE__*/React.createElement(Paper, {
      key: (doc === null || doc === void 0 ? void 0 : doc.id) || index,
      className: "".concat(classes.paper, " printable-paper page-break-before")
    }, /*#__PURE__*/React.createElement(Box$1, {
      className: classes.documentPage
    }, /*#__PURE__*/React.createElement(Typography, {
      className: classes.documentTitle,
      variant: "h6"
    }, "\u09B8\u0982\u09AF\u09C1\u0995\u09CD\u09A4\u09BF: ", (doc === null || doc === void 0 || (_doc$workforceDocumen3 = doc.workforceDocumentType) === null || _doc$workforceDocumen3 === void 0 ? void 0 : _doc$workforceDocumen3.nameBn) || "\u09A6\u09B2\u09BF\u09B2\u09BE\u09A6\u09BF ".concat(index + 1)), /*#__PURE__*/React.createElement("img", {
      src: doc === null || doc === void 0 ? void 0 : doc.url,
      alt: doc === null || doc === void 0 || (_doc$workforceDocumen4 = doc.workforceDocumentType) === null || _doc$workforceDocumen4 === void 0 ? void 0 : _doc$workforceDocumen4.nameBn,
      className: classes.documentImage
    })));
  }));
}

// --- Styles ---
var useStyles$G = makeStyles({
  "@global": {
    "@media print": {
      html: {
        overflow: "initial !important"
      },
      body: {
        overflow: "initial !important"
      },
      "*": {
        color: "#000 !important"
      },
      ".page-break": {
        display: "block",
        pageBreakBefore: "auto"
      },
      "table, tr, td, th": {
        pageBreakInside: "avoid !important"
      }
    }
  },
  paper: {
    padding: 32,
    fontFamily: "'Siyam Rupali', Arial, sans-serif",
    color: "black"
  },
  headerContainer: {
    marginBottom: 16,
    position: "relative",
    color: "black"
  },
  logo: {
    maxWidth: 70,
    maxHeight: 70
  },
  headerText: {
    textAlign: "center",
    color: "black"
  },
  title: {
    fontSize: "small",
    fontWeight: "bold",
    textAlign: "center",
    margin: "8px 0 5px 0",
    textDecoration: "underline",
    color: "black"
  },
  sectionTitle: {
    fontWeight: "bold",
    fontSize: "small",
    marginTop: 8,
    marginBottom: 4,
    borderBottom: "1px solid #000",
    paddingBottom: 4,
    color: "black"
  },
  fieldLabel: {
    textAlign: "left",
    fontSize: "0.9rem",
    paddingRight: 8,
    color: "black"
  },
  fieldValue: {
    borderBottom: "1px dotted #000",
    minHeight: 20,
    paddingLeft: 8,
    display: "block",
    fontSize: "0.9rem",
    color: "black"
  },
  checkboxContainer: {
    display: "flex",
    alignItems: "center",
    marginRight: 16,
    color: "black"
  },
  checked: {
    backgroundColor: "#000"
  },
  checkboxGroup: {
    display: "flex",
    alignItems: "center",
    gap: "24px"
  },
  table: {
    width: "100%",
    borderCollapse: "collapse",
    marginTop: 8,
    "& th, & td": {
      border: "1px solid #000",
      padding: 8
    },
    "& th": {
      fontWeight: "bold",
      textAlign: "center",
      color: "black"
    }
  },
  photoBox: {
    border: "1px solid #000",
    width: "120px",
    height: "155px",
    textAlign: "center",
    padding: 8,
    fontSize: 12,
    lineHeight: 1.2,
    position: "absolute",
    right: 0,
    top: 60,
    color: "black"
  },
  note: {
    fontSize: "0.85rem",
    marginTop: 8,
    marginBottom: 8,
    color: "black"
  }
});

// --- Helpers ---
var safeJsonParse = function safeJsonParse(str) {
  try {
    var parsed = JSON.parse(str);
    return _typeof(parsed) === "object" && parsed !== null ? parsed : {};
  } catch (_unused) {
    return {};
  }
};
var formatDate = function formatDate(dateString) {
  if (!dateString) return "";
  var date = new Date(dateString);
  return "".concat(String(date.getDate()).padStart(2, "0"), "-").concat(String(date.getMonth() + 1).padStart(2, "0"), "-").concat(date.getFullYear());
};
var formatAddress = function formatAddress(locationData, addressInput) {
  var _address, _address2, _address3, _address4, _address5, _locationData$parent, _locationData$parent2;
  var address = {};
  if (typeof addressInput === "string") {
    address = safeJsonParse(addressInput);
  } else if (_typeof(addressInput) === "object" && addressInput !== null) {
    address = addressInput;
  }
  var postOffice = ((_address = address) === null || _address === void 0 || (_address = _address.postOffice) === null || _address === void 0 ? void 0 : _address.nameBn) || ((_address2 = address) === null || _address2 === void 0 || (_address2 = _address2.postOffice) === null || _address2 === void 0 ? void 0 : _address2.nameEn);
  var village = [(_address3 = address) === null || _address3 === void 0 ? void 0 : _address3.houseName, (_address4 = address) === null || _address4 === void 0 ? void 0 : _address4.paraMahalla, (_address5 = address) === null || _address5 === void 0 ? void 0 : _address5.villageRoad].filter(Boolean).join(", ") || (locationData === null || locationData === void 0 ? void 0 : locationData.name);
  var thana = locationData === null || locationData === void 0 || (_locationData$parent = locationData.parent) === null || _locationData$parent === void 0 ? void 0 : _locationData$parent.name;
  var district = locationData === null || locationData === void 0 || (_locationData$parent2 = locationData.parent) === null || _locationData$parent2 === void 0 || (_locationData$parent2 = _locationData$parent2.parent) === null || _locationData$parent2 === void 0 ? void 0 : _locationData$parent2.name;
  return {
    village: village || "N/A",
    postOffice: postOffice || "N/A",
    thana: thana || "N/A",
    district: district || "N/A"
  };
};

// --- Component ---
function MedicalAssistancePrint(_ref) {
  var _accidentInfo$cronicD;
  _ref.printRef;
    var data = _ref.data,
    documents = _ref.documents,
    logoLeftUrl = _ref.logoLeftUrl,
    logoLeft = _ref.logoLeft;
  var classes = useStyles$G();
  if (!data) return /*#__PURE__*/React.createElement("p", null, "\u0986\u09AC\u09C7\u09A6\u09A8\u09C7\u09B0 \u0995\u09CB\u09A8\u09CB \u09A4\u09A5\u09CD\u09AF \u09AA\u09BE\u0993\u09AF\u09BC\u09BE \u09AF\u09BE\u09AF\u09BC\u09A8\u09BF\u0964");
  var workforceEmployee = data.workforceEmployee,
    dateCreated = data.dateCreated,
    movementLogs = data.movementLogs;

  // --- 1. APPLICANT INFO ---
  var applicantName = (workforceEmployee === null || workforceEmployee === void 0 ? void 0 : workforceEmployee.firstNameBn) || (workforceEmployee === null || workforceEmployee === void 0 ? void 0 : workforceEmployee.firstNameEn) || "N/A";
  var applicantRelation = "নিজ";
  var applicantNid = (workforceEmployee === null || workforceEmployee === void 0 ? void 0 : workforceEmployee.nid) || "N/A";
  var applicantDOB = (workforceEmployee === null || workforceEmployee === void 0 ? void 0 : workforceEmployee.birthDate) || "N/A";
  var applicantMobile = (workforceEmployee === null || workforceEmployee === void 0 ? void 0 : workforceEmployee.phoneNumber) || "N/A";
  var applicantFatherName = (workforceEmployee === null || workforceEmployee === void 0 ? void 0 : workforceEmployee.fatherNameBn) || "N/A";
  var applicantMotherName = (workforceEmployee === null || workforceEmployee === void 0 ? void 0 : workforceEmployee.motherNameBn) || "N/A";
  var permanentAddress = formatAddress(workforceEmployee === null || workforceEmployee === void 0 ? void 0 : workforceEmployee.permanentLocation, workforceEmployee === null || workforceEmployee === void 0 ? void 0 : workforceEmployee.permanentAddress);
  var presentAddress = formatAddress(workforceEmployee === null || workforceEmployee === void 0 ? void 0 : workforceEmployee.presentLocation, workforceEmployee === null || workforceEmployee === void 0 ? void 0 : workforceEmployee.presentAddress);

  // --- 2. ACCIDENT/DISEASE INFO ---
  // Ensure accidentInfo is at least an empty object to avoid crashes
  var accidentInfo = (data === null || data === void 0 ? void 0 : data.employeeAccidentInfo) || {};

  // Decide whether to show Disease Table or Accident Grid.
  // Default to Accident Grid if type is 'accident' OR null/undefined (to ensure fields show)
  var isDisease = (accidentInfo === null || accidentInfo === void 0 ? void 0 : accidentInfo.aidReasonType) === "disease";
  formatDate(dateCreated);
  var requiredAttachments = [{
    label: "শ্রমিকের নিয়োগপত্র",
    checked: true
  }, {
    label: "প্রতিষ্ঠান কর্তৃক প্রদত্ত আইডি কার্ড",
    checked: true
  }, {
    label: "ইউনিয়ন পরিষদ / পৌরসভা বা সিটি কর্পোরেশন হতে ওয়ারিশান সনদ (মূলকপি)",
    checked: true
  }, {
    label: "প্রতিষ্ঠান কর্তৃক প্রদত্ত প্রত্যয়ন পত্র (শ্রমিকের সকল তথ্যসহ)",
    checked: true
  }, {
    label: "নমিনীর জাতীয় পরিচয়পত্র/ জন্মসনদ এবং ছবি",
    checked: true
  }, {
    label: "শ্রমিকের শেষ ছয় মাসের বেতন শীটের কপি",
    checked: true
  }, {
    label: "প্রতিষ্ঠান কর্তৃক প্রদত্ত প্রত্যয়ন পত্র (নমিনীর সকল তথ্যসহ)",
    checked: true
  }, {
    label: "নমিনীর ব্যাংক হিসাবের চেক বা স্টেটমেন্টের কপি",
    checked: true
  }, {
    label: "প্রতিষ্ঠানের মেম্বারশীপ সনদপত্র",
    checked: true
  }];
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Paper, {
    id: "print-container",
    className: "".concat(classes.paper, " printable-paper")
  }, /*#__PURE__*/React.createElement(Box$1, {
    position: "relative"
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    alignItems: "center",
    className: classes.headerContainer
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 2,
    style: {
      textAlign: "left"
    }
  }, logoLeft && /*#__PURE__*/React.createElement("img", {
    src: logoLeft,
    alt: "Govt Logo",
    className: classes.logo
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 8,
    className: classes.headerText
  }, logoLeftUrl && /*#__PURE__*/React.createElement("img", {
    src: logoLeftUrl,
    alt: "Govt Logo",
    className: classes.logo
  }), /*#__PURE__*/React.createElement(Typography, {
    variant: "body1"
  }, "\u0997\u09A3\u09AA\u09CD\u09B0\u099C\u09BE\u09A4\u09A8\u09CD\u09A4\u09CD\u09B0\u09C0 \u09AC\u09BE\u0982\u09B2\u09BE\u09A6\u09C7\u09B6 \u09B8\u09B0\u0995\u09BE\u09B0"), /*#__PURE__*/React.createElement(Typography, {
    variant: "body1"
  }, (data === null || data === void 0 ? void 0 : data.organizationType) === "cf" ? "কেন্দ্রীয় তহবিল" : (data === null || data === void 0 ? void 0 : data.organizationType) === "eis" ? "ই.আই.এস." : "বাংলাদেশ শ্রমিক কল্যাণ ফাউন্ডেশন"), /*#__PURE__*/React.createElement(Typography, {
    variant: "body1"
  }, "\u09B6\u09CD\u09B0\u09AE \u0993 \u0995\u09B0\u09CD\u09AE\u09B8\u0982\u09B8\u09CD\u09A5\u09BE\u09A8 \u09AE\u09A8\u09CD\u09A4\u09CD\u09B0\u09A3\u09BE\u09B2\u09AF\u09BC"), /*#__PURE__*/React.createElement(Typography, {
    variant: "body2"
  }, "\u09E8\u09E7 \u09A4\u09B2\u09BE, \u09AD\u09AC\u09A8 \u09A8\u0982: \u09EC, \u09AC\u09BE\u0982\u09B2\u09BE\u09A6\u09C7\u09B6 \u09B8\u099A\u09BF\u09AC\u09BE\u09B2\u09AF\u09BC, \u09A2\u09BE\u0995\u09BE-\u09E7\u09E6\u09E6\u09E6\u0964"), /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    style: {
      color: "blue"
    }
  }, "www.centralfund.gov.bd")), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 2
  }, /*#__PURE__*/React.createElement(Box$1, {
    className: classes.photoBox
  }, documents && documents.length > 0 && documents.map(function (doc, index) {
    var _doc$workforceDocumen, _doc$workforceDocumen2;
    return (doc === null || doc === void 0 || (_doc$workforceDocumen = doc.workforceDocumentType) === null || _doc$workforceDocumen === void 0 ? void 0 : _doc$workforceDocumen.nameBn) === 'শ্রমিকের ছবি' && /*#__PURE__*/React.createElement("img", {
      src: doc === null || doc === void 0 ? void 0 : doc.url,
      alt: doc === null || doc === void 0 || (_doc$workforceDocumen2 = doc.workforceDocumentType) === null || _doc$workforceDocumen2 === void 0 ? void 0 : _doc$workforceDocumen2.nameBn,
      style: {
        width: "100%"
      }
    });
  })))), /*#__PURE__*/React.createElement(Typography, {
    className: classes.title
  }, "\u099A\u09BF\u0995\u09BF\u09CE\u09B8\u09BE \u0985\u09A8\u09C1\u09A6\u09BE\u09A8 \u0986\u09AC\u09C7\u09A6\u09A8 \u09AB\u09B0\u09AE"), /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    style: {
      textAlign: "center"
    }
  }, "(\u09B6\u09A4\u09AD\u09BE\u0997 \u09B0\u09AA\u09CD\u09A4\u09BE\u09A8\u09BF\u09AE\u09C1\u0996\u09BF \u09B6\u09BF\u09B2\u09CD\u09AA \u0995\u09BE\u09B0\u0996\u09BE\u09A8\u09BE\u09AF\u09BC \u0995\u09B0\u09CD\u09AE\u09B0\u09A4 \u09B6\u09CD\u09B0\u09AE\u09BF\u0995\u09C7\u09B0 \u0993\u09AF\u09BC\u09BE\u09B0\u09BF\u09B6\u09BE\u09A8/\u0993\u09AF\u09BC\u09BE\u09B0\u09BF\u09B6\u09BE\u09A8\u09A6\u09C7\u09B0 \u099C\u09A8\u09CD\u09AF)"), /*#__PURE__*/React.createElement(Typography, {
    className: classes.sectionTitle
  }, "\u09E7\u0964 \u0986\u09AC\u09C7\u09A6\u09A8\u0995\u09BE\u09B0\u09C0 \u09AC\u09CD\u09AF\u0995\u09CD\u09A4\u09BF\u0997\u09A4 \u09A4\u09A5\u09CD\u09AF\u09AC\u09B2\u09C0\u0983-"), /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 1
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 2
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.fieldLabel
  }, "\u09A8\u09BE\u09AE\u0983")), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 10
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.fieldValue
  }, applicantName)), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 3
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.fieldLabel
  }, "\u09B6\u09CD\u09B0\u09AE\u09BF\u0995\u09C7\u09B0 \u09B8\u09BE\u09A5\u09C7 \u09B8\u09AE\u09CD\u09AA\u09B0\u09CD\u0995\u0983")), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 3
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.fieldValue
  }, applicantRelation)), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 2
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.fieldLabel
  }, "\u099C\u09A8\u09CD\u09AE \u09A4\u09BE\u09B0\u09BF\u0996\u0983")), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 4
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.fieldValue
  }, formatDate(applicantDOB))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 5
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.fieldLabel
  }, "\u099C\u09BE\u09A4\u09C0\u09AF\u09BC \u09AA\u09B0\u09BF\u099A\u09AF\u09BC\u09AA\u09A4\u09CD\u09B0/ \u099C\u09A8\u09CD\u09AE \u09B8\u09A8\u09A6 \u09A8\u09BE\u09AE\u09CD\u09AC\u09BE\u09B0\u0983")), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 7
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.fieldValue
  }, applicantNid)), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 4
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.fieldLabel
  }, "\u09AE\u09CB\u09AC\u09BE\u0987\u09B2 \u09A8\u09BE\u09AE\u09CD\u09AC\u09B0 (\u0986\u09AC\u09B6\u09CD\u09AF\u09BF\u0995):-")), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 8
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.fieldValue
  }, applicantMobile)), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 2
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.fieldLabel
  }, "\u09AA\u09BF\u09A4\u09BE\u09B0 \u09A8\u09BE\u09AE\u0983")), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 4
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.fieldValue
  }, applicantFatherName)), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 2
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.fieldLabel
  }, "\u09AE\u09BE\u09A4\u09BE\u09B0 \u09A8\u09BE\u09AE\u0983")), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 4
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.fieldValue
  }, applicantMotherName))), /*#__PURE__*/React.createElement(Typography, {
    style: {
      marginTop: 8,
      fontWeight: "bold"
    }
  }, "\u09B8\u09CD\u09A5\u09BE\u09AF\u09BC\u09C0 \u09A0\u09BF\u0995\u09BE\u09A8\u09BE\u0983"), /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 1
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 2
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.fieldLabel
  }, "\u0997\u09CD\u09B0\u09BE\u09AE/\u09AE\u09B9\u09B2\u09CD\u09B2\u09BE\u0983")), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 4
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.fieldValue
  }, permanentAddress.village)), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 2
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.fieldLabel
  }, "\u09A1\u09BE\u0995\u0998\u09B0\u0983")), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 4
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.fieldValue
  }, permanentAddress.postOffice)), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 2
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.fieldLabel
  }, "\u09A5\u09BE\u09A8\u09BE/\u0989\u09AA\u099C\u09C7\u09B2\u09BE\u0983")), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 4
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.fieldValue
  }, permanentAddress.thana)), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 2
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.fieldLabel
  }, "\u099C\u09C7\u09B2\u09BE\u0983")), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 4
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.fieldValue
  }, permanentAddress.district))), /*#__PURE__*/React.createElement(Typography, {
    style: {
      marginTop: 8,
      fontWeight: "bold"
    }
  }, "\u09AC\u09B0\u09CD\u09A4\u09AE\u09BE\u09A8 \u09A0\u09BF\u0995\u09BE\u09A8\u09BE\u0983-"), /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 1
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 2
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.fieldLabel
  }, "\u0997\u09CD\u09B0\u09BE\u09AE/\u09AE\u09B9\u09B2\u09CD\u09B2\u09BE\u0983")), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 4
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.fieldValue
  }, presentAddress.village)), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 2
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.fieldLabel
  }, "\u09A1\u09BE\u0995\u0998\u09B0\u0983")), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 4
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.fieldValue
  }, presentAddress.postOffice)), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 2
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.fieldLabel
  }, "\u09A5\u09BE\u09A8\u09BE/\u0989\u09AA\u099C\u09C7\u09B2\u09BE\u0983")), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 4
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.fieldValue
  }, presentAddress.thana)), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 2
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.fieldLabel
  }, "\u099C\u09C7\u09B2\u09BE\u0983")), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 4
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.fieldValue
  }, presentAddress.district))), /*#__PURE__*/React.createElement(Typography, {
    className: classes.sectionTitle
  }, "\u09E9\u0964 \u09B0\u09CB\u0997\u09C7\u09B0 \u09A4\u09A5\u09CD\u09AF "), isDisease ?
  /*#__PURE__*/
  // DISEASE LAYOUT
  React.createElement(TableContainer, {
    component: Box$1
  }, /*#__PURE__*/React.createElement(Table$2, {
    className: classes.table
  }, /*#__PURE__*/React.createElement(TableHead, null, /*#__PURE__*/React.createElement(TableRow, null, /*#__PURE__*/React.createElement(TableCell, null, "\u0995\u09CD\u09B0\u09AE"), /*#__PURE__*/React.createElement(TableCell, null, "\u09B0\u09CB\u0997\u09C7\u09B0 \u09A8\u09BE\u09AE"), /*#__PURE__*/React.createElement(TableCell, null, "\u09B0\u09CB\u0997\u09C7\u09B0 \u0997\u09CD\u09B0\u09C7\u09A1"), /*#__PURE__*/React.createElement(TableCell, null, "\u09A8\u09BF\u09B0\u09CD\u09A3\u09AF\u09BC\u09C7\u09B0 \u09A4\u09BE\u09B0\u09BF\u0996"), /*#__PURE__*/React.createElement(TableCell, null, "\u09B8\u09B0\u09CD\u09AC\u09A8\u09BF\u09AE\u09CD\u09A8 \u0985\u09A8\u09C1\u09A6\u09BE\u09A8"), /*#__PURE__*/React.createElement(TableCell, null, "\u09B8\u09B0\u09CD\u09AC\u09CB\u099A\u09CD\u099A \u0985\u09A8\u09C1\u09A6\u09BE\u09A8"), /*#__PURE__*/React.createElement(TableCell, null, "\u09AA\u09CD\u09B0\u09B8\u09CD\u09A4\u09BE\u09AC\u09BF\u09A4 \u0985\u09A8\u09C1\u09A6\u09BE\u09A8"))), /*#__PURE__*/React.createElement(TableBody, null, accidentInfo === null || accidentInfo === void 0 || (_accidentInfo$cronicD = accidentInfo.cronicDiseaseType) === null || _accidentInfo$cronicD === void 0 ? void 0 : _accidentInfo$cronicD.map(function (disease, index) {
    return /*#__PURE__*/React.createElement(TableRow, {
      key: disease.id || index
    }, /*#__PURE__*/React.createElement(TableCell, null, index + 1), /*#__PURE__*/React.createElement(TableCell, null, disease.diseaseName || "N/A"), /*#__PURE__*/React.createElement(TableCell, null, disease.grade || "N/A"), /*#__PURE__*/React.createElement(TableCell, null, formatDate(accidentInfo === null || accidentInfo === void 0 ? void 0 : accidentInfo.diagnosisDate)), /*#__PURE__*/React.createElement(TableCell, null, disease.minimumDonationAmount || 0), /*#__PURE__*/React.createElement(TableCell, null, disease.maximumDonationAmount || 0), /*#__PURE__*/React.createElement(TableCell, null, (accidentInfo === null || accidentInfo === void 0 ? void 0 : accidentInfo.grantAmount) || 0));
  }), (!(accidentInfo !== null && accidentInfo !== void 0 && accidentInfo.cronicDiseaseType) || (accidentInfo === null || accidentInfo === void 0 ? void 0 : accidentInfo.cronicDiseaseType.length) === 0) && /*#__PURE__*/React.createElement(TableRow, null, /*#__PURE__*/React.createElement(TableCell, {
    colSpan: 7,
    align: "center"
  }, "\u0995\u09CB\u09A8\u09CB \u09B0\u09CB\u0997 \u09B8\u09AE\u09CD\u09AA\u09B0\u09CD\u0995\u09BF\u09A4 \u09A4\u09A5\u09CD\u09AF \u09AA\u09BE\u0993\u09AF\u09BC\u09BE \u09AF\u09BE\u09AF\u09BC\u09A8\u09BF\u0964"))))) :
  /*#__PURE__*/
  // ACCIDENT LAYOUT (Default)
  React.createElement(Grid, {
    container: true,
    spacing: 1
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 3
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.fieldLabel
  }, "\u09A6\u09C1\u09B0\u09CD\u0998\u099F\u09A8\u09BE\u09B0 \u09A7\u09B0\u09A8:")), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 3
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.fieldValue
  }, (accidentInfo === null || accidentInfo === void 0 ? void 0 : accidentInfo.accidentSpecificType) || "N/A")), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 3
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.fieldLabel
  }, "\u09A6\u09C1\u09B0\u09CD\u0998\u099F\u09A8\u09BE\u09B0 \u09B8\u09CD\u09A5\u09BE\u09A8:")), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 3
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.fieldValue
  }, (accidentInfo === null || accidentInfo === void 0 ? void 0 : accidentInfo.accidentPlace) || "N/A")), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 3
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.fieldLabel
  }, "\u09A6\u09C1\u09B0\u09CD\u0998\u099F\u09A8\u09BE\u09B0 \u09A4\u09BE\u09B0\u09BF\u0996:")), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 3
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.fieldValue
  }, formatDate(accidentInfo === null || accidentInfo === void 0 ? void 0 : accidentInfo.accidentDate))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 3
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.fieldLabel
  }, "\u09A6\u09C1\u09B0\u09CD\u0998\u099F\u09A8\u09BE\u09B0 \u09B8\u09AE\u09AF\u09BC:")), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 3
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.fieldValue
  }, (accidentInfo === null || accidentInfo === void 0 ? void 0 : accidentInfo.accidentTime) || "N/A")), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 3
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.fieldLabel
  }, "\u0995\u09CB\u09A8 \u09AA\u09B0\u09BF\u09B8\u09CD\u09A5\u09BF\u09A4\u09BF\u09A4\u09C7 \u09A6\u09C1\u09B0\u09CD\u0998\u099F\u09A8\u09BE \u09B9\u09AF\u09BC\u09C7\u099B\u09C7?")), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 3
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.fieldValue
  }, (accidentInfo === null || accidentInfo === void 0 ? void 0 : accidentInfo.inOutsideFactory) || "N/A")), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.fieldLabel
  }, "\u0986\u09AA\u09A8\u09BF \u0995\u09BF \u09B8\u09C1\u09B8\u09CD\u09A5 \u09B9\u0993\u09AF\u09BC\u09BE\u09B0 \u09AA\u09B0\u09C7 \u09AA\u09C1\u09A8\u09B0\u09BE\u09AF\u09BC \u0995\u09B0\u09CD\u09AE\u09B8\u09CD\u09A5\u09B2\u09C7 \u09AF\u09CB\u0997\u09A6\u09BE\u09A8 \u0995\u09B0\u09C7\u099B\u09C7\u09A8?"), /*#__PURE__*/React.createElement(Box$1, {
    className: classes.checkboxGroup
  }, /*#__PURE__*/React.createElement(Box$1, {
    className: classes.checkboxContainer
  }, /*#__PURE__*/React.createElement(Checkbox, {
    checked: (accidentInfo === null || accidentInfo === void 0 ? void 0 : accidentInfo.hasRejoined) === "yes",
    color: "default",
    size: "small",
    style: {
      padding: 0,
      paddingRight: "4px",
      color: "black"
    }
  }), /*#__PURE__*/React.createElement(Typography, {
    variant: "body2"
  }, "\u09B9\u09CD\u09AF\u09BE\u0981")), /*#__PURE__*/React.createElement(Box$1, {
    className: classes.checkboxContainer
  }, /*#__PURE__*/React.createElement(Checkbox, {
    checked: (accidentInfo === null || accidentInfo === void 0 ? void 0 : accidentInfo.hasRejoined) === "no",
    color: "default",
    size: "small",
    style: {
      padding: 0,
      paddingRight: "4px",
      color: "black"
    }
  }), /*#__PURE__*/React.createElement(Typography, {
    variant: "body2"
  }, "\u09A8\u09BE")))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 3
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.fieldLabel
  }, "\u09B8\u09C1\u09B8\u09CD\u09A5 \u09B9\u0993\u09AF\u09BC\u09BE\u09B0 \u09AA\u09B0\u09C7 \u09AA\u09C1\u09A8\u09B0\u09BE\u09AF\u09BC \u0995\u09B0\u09CD\u09AE\u09B8\u09CD\u09A5\u09B2\u09C7 \u09AF\u09CB\u0997\u09A6\u09BE\u09A8\u09C7\u09B0 \u09A4\u09BE\u09B0\u09BF\u0996")), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 3
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.fieldValue
  }, formatDate(accidentInfo === null || accidentInfo === void 0 ? void 0 : accidentInfo.dateOfRejoining))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.fieldLabel
  }, "\u09B9\u09BE\u09B8\u09AA\u09BE\u09A4\u09BE\u09B2\u09C7 \u09AD\u09B0\u09CD\u09A4\u09BF \u09B9\u09AF\u09BC\u09C7\u099B\u09BF\u09B2\u09C7\u09A8?"), /*#__PURE__*/React.createElement(Box$1, {
    className: classes.checkboxGroup
  }, /*#__PURE__*/React.createElement(Box$1, {
    className: classes.checkboxContainer
  }, /*#__PURE__*/React.createElement(Checkbox, {
    checked: (accidentInfo === null || accidentInfo === void 0 ? void 0 : accidentInfo.admitted) === "yes",
    color: "default",
    size: "small",
    style: {
      padding: 0,
      paddingRight: "4px",
      color: "black"
    }
  }), /*#__PURE__*/React.createElement(Typography, {
    variant: "body2"
  }, "\u09B9\u09CD\u09AF\u09BE\u0981")), /*#__PURE__*/React.createElement(Box$1, {
    className: classes.checkboxContainer
  }, /*#__PURE__*/React.createElement(Checkbox, {
    checked: (accidentInfo === null || accidentInfo === void 0 ? void 0 : accidentInfo.admitted) === "no",
    color: "default",
    size: "small",
    style: {
      padding: 0,
      paddingRight: "4px",
      color: "black"
    }
  }), /*#__PURE__*/React.createElement(Typography, {
    variant: "body2"
  }, "\u09A8\u09BE")))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 3
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.fieldLabel
  }, "\u09B9\u09BE\u09B8\u09AA\u09BE\u09A4\u09BE\u09B2\u09C7\u09B0 \u09A8\u09BE\u09AE")), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 3
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.fieldValue
  }, (accidentInfo === null || accidentInfo === void 0 ? void 0 : accidentInfo.hospitalName) || "N/A")), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 3
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.fieldLabel
  }, "\u09AD\u09B0\u09CD\u09A4\u09BF\u09B0 \u09A4\u09BE\u09B0\u09BF\u0996")), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 3
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.fieldValue
  }, formatDate(accidentInfo === null || accidentInfo === void 0 ? void 0 : accidentInfo.admitDate))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 3
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.fieldLabel
  }, "\u09B0\u09BF\u09B2\u09BF\u099C\u09C7\u09B0 \u09A4\u09BE\u09B0\u09BF\u0996")), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 3
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.fieldValue
  }, formatDate(accidentInfo === null || accidentInfo === void 0 ? void 0 : accidentInfo.releaseDate))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 3
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.fieldLabel
  }, "\u09A1\u09BE\u0995\u09CD\u09A4\u09BE\u09B0\u09C7\u09B0 \u09A8\u09BE\u09AE")), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 3
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.fieldValue
  }, (accidentInfo === null || accidentInfo === void 0 ? void 0 : accidentInfo.hospitalDoctorName) || "N/A"))), /*#__PURE__*/React.createElement(Typography, {
    className: classes.sectionTitle
  }, "\u09EB\u0964 \u0985\u09A8\u09CD\u09AF \u0995\u09CB\u09A8\u09CB \u09A4\u09A5\u09CD\u09AF (\u09AF\u09A6\u09BF \u09A5\u09BE\u0995\u09C7):-"), /*#__PURE__*/React.createElement(Typography, {
    className: classes.fieldValue,
    style: {
      minHeight: "40px"
    }
  }), /*#__PURE__*/React.createElement(Typography, {
    className: classes.sectionTitle
  }, "\u09EC\u0964 \u09B8\u0982\u09AF\u09C1\u0995\u09CD\u09A4\u09BF\u0983- (\u0986\u09AC\u09C7\u09A6\u09A8 \u09A6\u09BE\u0996\u09BF\u09B2\u09C7\u09B0 \u09AA\u09C2\u09B0\u09CD\u09AC \u09A8\u09BF\u09AE\u09CD\u09A8\u09CB\u0995\u09CD\u09A4 \u09A6\u09B2\u09BF\u09B2\u09BE\u09A6\u09BF \u09B8\u0982\u09AF\u09C1\u0995\u09CD\u09A4 \u0995\u09B0\u09A4\u09C7 \u09B9\u09AC\u09C7)"), /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 1
  }, requiredAttachments.map(function (item, index) {
    return /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      key: index
    }, /*#__PURE__*/React.createElement(Box$1, {
      display: "flex",
      alignItems: "center"
    }, /*#__PURE__*/React.createElement(Checkbox, {
      checked: item.checked,
      color: "default",
      size: "small",
      style: {
        padding: 0,
        paddingRight: "8px",
        color: "black"
      }
    }), /*#__PURE__*/React.createElement(Typography, {
      variant: "body2"
    }, item.label)));
  })), /*#__PURE__*/React.createElement(Box$1, {
    mt: 4
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6"
  }, "\u09ED\u0964 \u09AE\u09C1\u09AD\u09AE\u09C7\u09A8\u09CD\u099F \u09B2\u0997 / Movement Log"), /*#__PURE__*/React.createElement(Divider, null), (movementLogs === null || movementLogs === void 0 ? void 0 : movementLogs.length) > 0 ? /*#__PURE__*/React.createElement(Table$2, {
    style: {
      marginTop: 8
    },
    size: "small",
    className: classes.table
  }, /*#__PURE__*/React.createElement(TableHead, null, /*#__PURE__*/React.createElement(TableRow, null, /*#__PURE__*/React.createElement(TableCell, null, /*#__PURE__*/React.createElement("b", null, "\u09A4\u09BE\u09B0\u09BF\u0996 / Date")), /*#__PURE__*/React.createElement(TableCell, null, /*#__PURE__*/React.createElement("b", null, "\u0985\u09AB\u09BF\u09B8\u09BE\u09B0\u09C7\u09B0 \u09A8\u09BE\u09AE / Action Taken")), /*#__PURE__*/React.createElement(TableCell, null, /*#__PURE__*/React.createElement("b", null, "\u09A6\u09BE\u09AF\u09BC\u09BF\u09A4\u09CD\u09AC\u09AA\u09CD\u09B0\u09BE\u09AA\u09CD\u09A4 \u09AA\u09A6\u09AC\u09C0 / Officer")), /*#__PURE__*/React.createElement(TableCell, null, /*#__PURE__*/React.createElement("b", null, "\u09AE\u09A8\u09CD\u09A4\u09AC\u09CD\u09AF / Remarks")))), /*#__PURE__*/React.createElement(TableBody, null, movementLogs === null || movementLogs === void 0 ? void 0 : movementLogs.map(function (log, index) {
    return /*#__PURE__*/React.createElement(TableRow, {
      key: index
    }, /*#__PURE__*/React.createElement(TableCell, null, log.date || "-"), /*#__PURE__*/React.createElement(TableCell, null, log.name || "-"), /*#__PURE__*/React.createElement(TableCell, null, log.role || "-"), /*#__PURE__*/React.createElement(TableCell, null, log.revertNote || "-"));
  }))) : /*#__PURE__*/React.createElement(Typography, {
    color: "textSecondary",
    style: {
      marginTop: 8
    }
  }, "No movement data found.")), /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    className: classes.note,
    style: {
      textAlign: "center",
      marginTop: "15px"
    }
  }, "(\u09AC\u09BF\u0983\u09A6\u09CD\u09B0\u0983- \u0985\u09B8\u09AE\u09CD\u09AA\u09C2\u09B0\u09CD\u09A3 \u0993 \u09AD\u09C1\u09B2 \u0986\u09AC\u09C7\u09A6\u09A8 \u09AC\u09BE\u09A4\u09BF\u09B2\u09C7\u09B0 \u0995\u09CD\u09B7\u09C7\u09A4\u09CD\u09B0\u09C7 \u0995\u09C7\u09A8\u09CD\u09A6\u09CD\u09B0\u09C0\u09AF\u09BC \u09A4\u09B9\u09AC\u09BF\u09B2\u09C7\u09B0 \u09B8\u09BF\u09A6\u09CD\u09A7\u09BE\u09A8\u09CD\u09A4\u0987 \u099A\u09C2\u09A1\u09BC\u09BE\u09A8\u09CD\u09A4 \u09AC\u09B2\u09C7 \u0997\u09A3\u09CD\u09AF \u09B9\u09AC\u09C7\u0964)"))), documents && (documents === null || documents === void 0 ? void 0 : documents.length) > 0 && (documents === null || documents === void 0 ? void 0 : documents.map(function (doc, index) {
    var _doc$workforceDocumen3, _doc$workforceDocumen4;
    return /*#__PURE__*/React.createElement(Paper, {
      key: (doc === null || doc === void 0 ? void 0 : doc.id) || index,
      className: "".concat(classes.paper, " printable-paper page-break-before")
    }, /*#__PURE__*/React.createElement(Box$1, {
      className: classes.documentPage
    }, /*#__PURE__*/React.createElement(Typography, {
      className: classes.documentTitle,
      variant: "h6"
    }, "\u09B8\u0982\u09AF\u09C1\u0995\u09CD\u09A4\u09BF: ", (doc === null || doc === void 0 || (_doc$workforceDocumen3 = doc.workforceDocumentType) === null || _doc$workforceDocumen3 === void 0 ? void 0 : _doc$workforceDocumen3.nameBn) || "\u09A6\u09B2\u09BF\u09B2\u09BE\u09A6\u09BF ".concat(index + 1)), /*#__PURE__*/React.createElement("img", {
      src: doc === null || doc === void 0 ? void 0 : doc.url,
      alt: doc === null || doc === void 0 || (_doc$workforceDocumen4 = doc.workforceDocumentType) === null || _doc$workforceDocumen4 === void 0 ? void 0 : _doc$workforceDocumen4.nameBn,
      className: classes.documentImage
    })));
  })));
}

function ownKeys$B(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$B(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$B(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$B(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var useStyles$F = makeStyles({
  "@global": {
    "@media all": {
      ".page-break": {
        display: "none"
      }
    },
    "@media print": {
      "html, body": {
        height: "initial !important",
        overflow: "initial !important",
        WebkitPrintColorAdjust: "exact"
      },
      ".page-break": {
        marginTop: "1rem",
        display: "block",
        pageBreakBefore: "auto"
      }
    },
    "@page": {
      size: "auto",
      margin: "20mm"
    }
  },
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    overflowY: "scroll"
  },
  modalContent: {
    backgroundColor: "#fff",
    boxShadow: "0 4px 12px rgba(0,0,0,0.3)",
    padding: 16,
    width: "90%",
    maxWidth: "210mm",
    maxHeight: "90vh",
    overflowY: "auto"
  }
});
var ApplicationPrintPreview = function ApplicationPrintPreview(_ref) {
  var data = _ref.data,
    documents = _ref.documents,
    logoLeftUrl = _ref.logoLeftUrl,
    logoLeft = _ref.logoLeft;
  var classes = useStyles$F();
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2);
    _useState2[0];
    _useState2[1];
  var _useState3 = useState(),
    _useState4 = _slicedToArray(_useState3, 2),
    movementLogs = _useState4[0];
    _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2);
    _useState6[0];
    _useState6[1];
  useModulesManager();
  useDispatch();
  useSelector(function (state) {
    var _state$core;
    return (_state$core = state.core) === null || _state$core === void 0 || (_state$core = _state$core.user) === null || _state$core === void 0 || (_state$core = _state$core.i_user) === null || _state$core === void 0 ? void 0 : _state$core.language;
  });
  useRef(false);
  var printRef = useRef();
  console.log("hellooww", data);

  // 1️⃣ Setup the printer hook
  var handlePrint = useReactToPrint({
    content: function content() {
      return printRef.current;
    },
    contentRef: printRef,
    documentTitle: "Death Application Form"
    // removeAfterPrint: false,
  });

  // 2️⃣ Safe print trigger with delay (important for MUI modal portal)
  var handleSafePrint = function handleSafePrint() {
    if (!printRef.current) {
      // wait a moment for the modal DOM to render
      setTimeout(function () {
        if (printRef.current) handlePrint();else console.error("Still no content to print!");
      }, 300);
    } else {
      handlePrint();
    }
  };

  // useEffect(() => {
  //   if (!data?.id || hasFetchedRef.current) return;

  //   hasFetchedRef.current = true;
  //   setIsLoadingPath(true);

  //   dispatch(
  //     fetchApplicationWiseMovementList(modulesManager, {
  //       applicationId: data?.id,
  //       orderBy: ["-dateCreated"],
  //     })
  //   )
  //     .then((res) => {
  //       console.log(res);
  //       const edges = res?.payload?.data?.workforceApplicationMovement?.edges || [];
  //       const allUsers = edges.flatMap(({ node }) => (node.applicationTo ? [node.applicationTo] : [])).filter(Boolean);
  //       console.log({ edges });
  //       console.log({ allUsers });
  //       const users = [
  //         {
  //           id: "applicant001",
  //           name: data?.workforceEmployee?.firstNameBn || "আবেদনকারী",
  //           note: "একটি নতুন আবেদন করা হয়েছে",
  //           status: "new",
  //           role: "Applicant",
  //           date: conditionalEnToBn(data?.dateCreated?.split("T")[0], locale),
  //         },
  //         ...allUsers.map((u, index) => ({
  //           id: u.id,
  //           name: u.loginName,
  //           role: u?.userRoles?.[0]?.role?.name || "User",
  //           note: edges?.[index]?.node?.note,
  //           status: edges?.[index]?.node?.status,
  //           revertNote: edges?.[index]?.node?.revertNote,
  //           date: conditionalEnToBn(edges?.[index]?.node?.dateCreated?.split("T")[0], locale),
  //         })),
  //       ];

  //       console.log(users);
  //       setMovementLogs(users);
  //     })
  //     .catch((err) => console.error("Movement fetch failed", err))
  //     .finally(() => setIsLoadingPath(false));
  // }, []);

  if (!data || !data.workforceEmployee) return /*#__PURE__*/React.createElement("p", null, "\u0986\u09AC\u09C7\u09A6\u09A8\u09C7\u09B0 \u0995\u09CB\u09A8\u09CB \u09A4\u09A5\u09CD\u09AF \u09AA\u09BE\u0993\u09DF\u09BE \u09AF\u09BE\u09DF\u09A8\u09BF\u0964");
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Paper, {
    className: classes.modalContent
  }, /*#__PURE__*/React.createElement("div", {
    className: "print-button-container",
    style: {
      textAlign: "right",
      marginBottom: 16
    }
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "contained",
    color: "secondary",
    startIcon: /*#__PURE__*/React.createElement(PrintIcon, null),
    onClick: handleSafePrint
  }, "Print")), /*#__PURE__*/React.createElement("div", {
    id: "print-container",
    ref: printRef
  }, (data === null || data === void 0 ? void 0 : data.applicationType) === ("financialAssistance" ) ? /*#__PURE__*/React.createElement(DeathApplicationPrint, {
    data: _objectSpread$B(_objectSpread$B({}, data), {}, {
      movementLogs: movementLogs
    }),
    documents: documents,
    logoLeft: logoLeft,
    logoLeftUrl: logoLeftUrl
  }) : (data === null || data === void 0 ? void 0 : data.applicationType) === "medicalAssistance" || (data === null || data === void 0 ? void 0 : data.applicationType) === "medicalDonation" || (data === null || data === void 0 ? void 0 : data.applicationType) === "disabilityAssistance" ? /*#__PURE__*/React.createElement(MedicalAssistancePrint, {
    data: _objectSpread$B(_objectSpread$B({}, data), {}, {
      movementLogs: movementLogs
    }),
    documents: documents,
    logoLeft: logoLeft,
    logoLeftUrl: logoLeftUrl
  }) : null)));
};

function ownKeys$A(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$A(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$A(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$A(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper$e(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$e() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$e() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$e = function _isNativeReflectConstruct() { return !!t; })(); }
var styles$e = function styles(theme) {
  return {
    paper: {
      padding: theme.spacing(1),
      width: "100%",
      margin: "0 auto"
    },
    modal: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      overflowY: "scroll"
    },
    container: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center"
    },
    title: {
      fontSize: "medium",
      fontWeight: "bold"
    },
    overrideReadOnly: {
      "& .Mui-disabled": {
        color: "".concat(theme.palette.text.primary, " !important")
      }
    },
    buttonContainer: {
      marginTop: theme.spacing(2),
      display: "flex",
      justifyContent: "flex-end",
      gap: theme.spacing(1)
    }
  };
};
var ViewApplicationPage = /*#__PURE__*/function (_Component) {
  function ViewApplicationPage(props) {
    var _props$application;
    var _this;
    _classCallCheck(this, ViewApplicationPage);
    _this = _callSuper$e(this, ViewApplicationPage, [props]);
    // ✅ Safe JSON parser
    _defineProperty(_this, "safeParse", function (data) {
      if (typeof data === "string") {
        try {
          return JSON.parse(data);
        } catch (e) {
          console.warn("Failed to parse JSON:", data);
          return {};
        }
      }
      return data || {};
    });
    _defineProperty(_this, "handleOpenForwardModal", function () {
      _this.setState({
        isForwardModalOpen: true
      });
    });
    _defineProperty(_this, "handleCloseForwardModal", function () {
      _this.setState({
        isForwardModalOpen: false
      });
    });
    _defineProperty(_this, "handlePrint", function () {
      _this.setState({
        open: true
      });
    });
    _defineProperty(_this, "handleReject", function () {
      var _this$props = _this.props;
        _this$props.user_rights;
        var application = _this$props.application;
        _this$props.loggedInUserId;
      _this.state.selectedApplication;
      _this.setState({
        confirmModalOpen: true,
        confirmModalMessage: "workforce.application.reject.message",
        confirmModalCallback: function () {
          var _confirmModalCallback = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(confirmed) {
            return _regeneratorRuntime.wrap(function _callee2$(_context2) {
              while (1) switch (_context2.prev = _context2.next) {
                case 0:
                  if (confirmed) {
                    _this.setState({
                      selectedApplication: _objectSpread$A(_objectSpread$A({}, application), {}, {
                        isHistory: true
                      })
                    }, /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
                      var updateApplicationData, createApplicationMovementData;
                      return _regeneratorRuntime.wrap(function _callee$(_context) {
                        while (1) switch (_context.prev = _context.next) {
                          case 0:
                            updateApplicationData = {
                              id: safeDecodeId(application === null || application === void 0 ? void 0 : application.id),
                              status: WORKFORCE_STATUS$1.REJECTED
                            };
                            createApplicationMovementData = {
                              applicationId: safeDecodeId(application === null || application === void 0 ? void 0 : application.id),
                              status: WORKFORCE_STATUS$1.REJECTED,
                              note: "আবেদন বাতিল করা হয়েছে",
                              action: "rejected"
                            };
                            _context.prev = 2;
                            _context.next = 5;
                            return _this.props.updateApplication(updateApplicationData, "update workforce application");
                          case 5:
                            _context.next = 7;
                            return _this.props.createApplicationMovement(createApplicationMovementData, "create workforce movement");
                          case 7:
                            _this.setState({
                              serverResponse: {
                                status: "SUCCESS",
                                message: "আবেদন বাতিল করা হয়েছে!"
                              }
                            });
                            window.location.reload();
                            _context.next = 15;
                            break;
                          case 11:
                            _context.prev = 11;
                            _context.t0 = _context["catch"](2);
                            console.error("Approval failed:", _context.t0);
                            _this.setState({
                              serverResponse: {
                                status: "ERROR",
                                message: "আবেদন বাতিল ব্যর্থ হয়েছে!"
                              }
                            });
                          case 15:
                          case "end":
                            return _context.stop();
                        }
                      }, _callee, null, [[2, 11]]);
                    })));
                  }
                  _this.setState({
                    confirmModalOpen: false,
                    confirmModalCallback: null
                  });
                case 2:
                case "end":
                  return _context2.stop();
              }
            }, _callee2);
          }));
          function confirmModalCallback(_x) {
            return _confirmModalCallback.apply(this, arguments);
          }
          return confirmModalCallback;
        }()
      });
    });
    _defineProperty(_this, "handleForward", function () {
      var _this$props2 = _this.props,
        user_rights = _this$props2.user_rights,
        application = _this$props2.application,
        loggedInUserId = _this$props2.loggedInUserId;
      var user_type = getUserTypeFromRights(user_rights);
      if (user_type === WORKFORCE_USER_TYPE.FACTORY_ADMIN) {
        _this.setState({
          forwardModalOpenFA: true
        });
      } else if (user_type === WORKFORCE_USER_TYPE.FACTORY_ADMIN) {
        _this.setState({
          forwardModalOpenSA: true
        });
      } else if (user_type === WORKFORCE_USER_TYPE.CHECKER || user_type === WORKFORCE_USER_TYPE.CHECKER_TWO || user_type === WORKFORCE_USER_TYPE.SEC1_DEPUTI_ASST_DIRECTOR || user_type === WORKFORCE_USER_TYPE.SEC2_DEPUTI_ASST_DIRECTOR || user_type === WORKFORCE_USER_TYPE.BLWF_CHECKER || user_type === WORKFORCE_USER_TYPE.BLWF_DOL_DIFE || user_type === WORKFORCE_USER_TYPE.BLWF_DEPUTI_ASST_DIRECTOR || user_type === WORKFORCE_USER_TYPE.EIS_OFFICER) {
        handleBulkSelectedByCheckerLogic({
          selectedApplicationIds: [{
            id: application === null || application === void 0 ? void 0 : application.id
          }],
          loggedInUserId: _this.props.loggedInUserId,
          userRights: _this.props.user_rights,
          fetchWorkforceDocument: _this.props.fetchWorkforceDocument,
          updateApplication: _this.props.updateApplication,
          createApplicationMovement: _this.props.createApplicationMovement,
          modulesManager: _this.props.modulesManager,
          setServerResponse: function setServerResponse(res) {
            return _this.setState({
              serverResponse: res
            });
          },
          setConfirmModalOpen: function setConfirmModalOpen(val) {
            return _this.setState({
              confirmModalOpen: val
            });
          },
          setConfirmModalMessage: function setConfirmModalMessage(msg) {
            return _this.setState({
              confirmModalMessage: msg
            });
          },
          setConfirmModalCallback: function setConfirmModalCallback(cb) {
            return _this.setState({
              confirmModalCallback: cb
            });
          },
          history: _this.props.history,
          dispatch: _this.props.dispatch
        });
      } else if (user_type === WORKFORCE_USER_TYPE.EIS_COMMITTEE || user_type === WORKFORCE_USER_TYPE.EIS_ASSOCIATION_COMMITTEE) {
        var _application$eisAppli;
        handleApprovalByEisCommittee({
          selectedApplicationIds: [{
            id: application === null || application === void 0 ? void 0 : application.id
          }],
          loggedInUserId: _this.props.loggedInUserId,
          userRights: _this.props.user_rights,
          modulesManager: _this.props.modulesManager,
          fetchWorkforceDocument: _this.props.fetchWorkforceDocument,
          updateApplication: _this.props.updateApplication,
          createApplicationMovement: _this.props.createApplicationMovement,
          updateApplicationSummary: _this.props.updateApplicationSummary,
          setServerResponse: function setServerResponse(res) {
            return _this.setState({
              serverResponse: res
            });
          },
          setConfirmModalOpen: function setConfirmModalOpen(val) {
            return _this.setState({
              confirmModalOpen: val
            });
          },
          setConfirmModalMessage: function setConfirmModalMessage(msg) {
            return _this.setState({
              confirmModalMessage: msg
            });
          },
          setConfirmModalCallback: function setConfirmModalCallback(cb) {
            return _this.setState({
              confirmModalCallback: cb
            });
          },
          summaryId: application === null || application === void 0 || (_application$eisAppli = application.eisApplicationSummary) === null || _application$eisAppli === void 0 ? void 0 : _application$eisAppli.id,
          eisApprovalIds: application === null || application === void 0 ? void 0 : application.eisApprovalIds,
          eisApprovedByIds: application === null || application === void 0 ? void 0 : application.eisApprovedByIds,
          dispatch: _this.props.dispatch,
          history: _this.props.history,
          setCloseLoader: function setCloseLoader(l) {
            return _this.setState({
              loader: l
            });
          },
          loader: _this.state.loader
        });
      } else {
        handleBulkSelectedByAssociationLogic({
          selectedApplicationIds: [_objectSpread$A({
            id: application === null || application === void 0 ? void 0 : application.id,
            applicationType: application === null || application === void 0 ? void 0 : application.applicationType
          }, application)],
          loggedInUserId: loggedInUserId,
          updateApplication: _this.props.updateApplication,
          createApplicationMovement: _this.props.createApplicationMovement,
          setServerResponse: function setServerResponse(res) {
            return _this.setState({
              serverResponse: res
            });
          },
          setConfirmModalOpen: function setConfirmModalOpen(val) {
            return _this.setState({
              confirmModalOpen: val
            });
          },
          setConfirmModalMessage: function setConfirmModalMessage(msg) {
            return _this.setState({
              confirmModalMessage: msg
            });
          },
          setConfirmModalCallback: function setConfirmModalCallback(cb) {
            return _this.setState({
              confirmModalCallback: cb
            });
          }
        });
      }
    });
    _defineProperty(_this, "handleRevert", function () {
      _this.setState({
        revertModalOpen: true,
        selectedApplication: _this.props.application
      });
    });
    _this.state = _defineProperty(_defineProperty(_defineProperty({
      stateEdited: props.application || {},
      workforceEmployee: (props === null || props === void 0 || (_props$application = props.application) === null || _props$application === void 0 ? void 0 : _props$application.workforceEmployee) || {},
      isForwardModalOpen: false,
      forwardModalOpenFA: false,
      revertModalOpen: false,
      selectedApplication: null,
      confirmModalOpen: false,
      confirmModalMessage: "",
      serverResponse: "",
      confirmModalCallback: null,
      movementLogs: null,
      open: false
    }, "selectedApplication", null), "eisDependentBFTNModalOpen", false), "loader", false);
    return _this;
  }
  _inherits(ViewApplicationPage, _Component);
  return _createClass(ViewApplicationPage, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.application !== this.props.application) {
        var _this$props$applicati;
        this.setState({
          workforceEmployee: ((_this$props$applicati = this.props.application) === null || _this$props$applicati === void 0 ? void 0 : _this$props$applicati.workforceEmployee) || {},
          stateEdited: this.props.application || {}
        });
      }

      // FIX: Update the memoized application ONLY if the ID or the object reference changes
      // Use prevProps.application?.id !== this.props.application?.id OR this.props.application !== prevProps.application
      // if (this.props.application !== prevProps.application) {
      //   this.memoizedApplication = this.props.application;
      // }

      if (prevProps.submittingMutation && !this.props.submittingMutation) {
        this.props.dispatch(journalize(this.props.mutation));
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      var _this$props3 = this.props;
        _this$props3.dispatch;
        var modulesManager = _this$props3.modulesManager,
        application = _this$props3.application;
      this.props.fetchWorkforceDocument(modulesManager, ["workforceApplication_Id:\"".concat(application === null || application === void 0 ? void 0 : application.id, "\"")]);
      this.props.fetchApplicationWiseMovementList(modulesManager, {
        applicationId: application === null || application === void 0 ? void 0 : application.id,
        orderBy: ["-dateCreated"]
      }).then(function (res) {
        var _res$payload, _application$workforc, _application$dateCrea;
        console.log(res);
        var edges = (res === null || res === void 0 || (_res$payload = res.payload) === null || _res$payload === void 0 || (_res$payload = _res$payload.data) === null || _res$payload === void 0 || (_res$payload = _res$payload.workforceApplicationMovement) === null || _res$payload === void 0 ? void 0 : _res$payload.edges) || [];
        var allUsers = edges.flatMap(function (_ref2) {
          var node = _ref2.node;
          return node.applicationTo ? [node.applicationTo] : [];
        }).filter(Boolean);
        console.log({
          edges: edges
        });
        console.log({
          allUsers: allUsers
        });
        var users = [{
          id: "applicant001",
          name: (application === null || application === void 0 || (_application$workforc = application.workforceEmployee) === null || _application$workforc === void 0 ? void 0 : _application$workforc.firstNameBn) || "আবেদনকারী",
          note: "একটি নতুন আবেদন করা হয়েছে",
          status: "new",
          role: "Applicant",
          date: conditionalEnToBn(application === null || application === void 0 || (_application$dateCrea = application.dateCreated) === null || _application$dateCrea === void 0 ? void 0 : _application$dateCrea.split("T")[0], _this2.props.locale)
        }].concat(_toConsumableArray(allUsers.map(function (u, index) {
          var _u$userRoles, _edges$index, _edges$index2, _edges$index3, _edges$index4;
          return {
            id: u.id,
            name: u.loginName,
            role: (u === null || u === void 0 || (_u$userRoles = u.userRoles) === null || _u$userRoles === void 0 || (_u$userRoles = _u$userRoles[0]) === null || _u$userRoles === void 0 || (_u$userRoles = _u$userRoles.role) === null || _u$userRoles === void 0 ? void 0 : _u$userRoles.name) || "User",
            note: edges === null || edges === void 0 || (_edges$index = edges[index]) === null || _edges$index === void 0 || (_edges$index = _edges$index.node) === null || _edges$index === void 0 ? void 0 : _edges$index.note,
            status: edges === null || edges === void 0 || (_edges$index2 = edges[index]) === null || _edges$index2 === void 0 || (_edges$index2 = _edges$index2.node) === null || _edges$index2 === void 0 ? void 0 : _edges$index2.status,
            revertNote: edges === null || edges === void 0 || (_edges$index3 = edges[index]) === null || _edges$index3 === void 0 || (_edges$index3 = _edges$index3.node) === null || _edges$index3 === void 0 ? void 0 : _edges$index3.revertNote,
            date: conditionalEnToBn(edges === null || edges === void 0 || (_edges$index4 = edges[index]) === null || _edges$index4 === void 0 || (_edges$index4 = _edges$index4.node) === null || _edges$index4 === void 0 || (_edges$index4 = _edges$index4.dateCreated) === null || _edges$index4 === void 0 ? void 0 : _edges$index4.split("T")[0], _this2.props.locale)
          };
        })));
        // setMovementLogs(users);
        _this2.setState({
          movementLogs: users
        });
      })["catch"](function (err) {
        return console.error("Movement fetch failed", err);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _application$employee,
        _this3 = this,
        _safeParse,
        _this$props$applicati2,
        _this$props$applicati3,
        _this$props$applicati4;
      var _this$props4 = this.props,
        classes = _this$props4.classes,
        user_rights = _this$props4.user_rights,
        documents = _this$props4.documents,
        application = _this$props4.application,
        locale = _this$props4.locale,
        organizationEmployee = _this$props4.organizationEmployee;
        _this$props4.history;
        var edited_id = _this$props4.edited_id,
        fetchingApplication = _this$props4.fetchingApplication,
        fetchingDocument = _this$props4.fetchingDocument,
        fetchingApplicationMovements = _this$props4.fetchingApplicationMovements;
      var _this$state2 = this.state,
        stateEdited = _this$state2.stateEdited,
        workforceEmployee = _this$state2.workforceEmployee,
        isForwardModalOpen = _this$state2.isForwardModalOpen;
        _this$state2.forwardModalOpenFA;
      // const application = this.memoizedApplication

      var user_type = getUserTypeFromRights(user_rights);
      var bankInfo = this.safeParse(stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.employeeBankInfo);
      var AccidentInfo = this.safeParse(stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.employeeAccidentInfo);
      var dependentInfo = this.safeParse(stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.employeeDependentInfo);
      var childrenInfo = this.safeParse(stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.employeeChildrenInfo);
      var applicantInfo = this.safeParse(stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.applicantInfo);
      var institutionInfo = this.safeParse(stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.institutionInfo);
      var deceasedWorkerInfo = this.safeParse(stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.deceasedWorkerInfo);
      var metaInfo = this.safeParse(stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.metadata);
      var doctorsEntry = this.safeParse(stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.doctorsEntry);
      var parsedWorkforceEmployeeDependentApplication = application === null || application === void 0 ? void 0 : application.workforceEmployeeDependentApplication;
      var tempBankInfo = application === null || application === void 0 || (_application$employee = application.employeeBankingInfoApplication) === null || _application$employee === void 0 ? void 0 : _application$employee.map(function (item) {
        var _item$branch;
        return _objectSpread$A(_objectSpread$A({}, item), {}, {
          bank: _objectSpread$A({}, item === null || item === void 0 || (_item$branch = item.branch) === null || _item$branch === void 0 ? void 0 : _item$branch.parent)
        });
      });

      // ✅ Safely parse nested stringified objects
      var formData = _objectSpread$A(_objectSpread$A({}, stateEdited), {}, {
        workforceEmployee: workforceEmployee,
        employeeAccidentInfo: this.safeParse(AccidentInfo),
        employeeBankInfo: this.safeParse(bankInfo),
        employeeDependentInfo: this.safeParse(dependentInfo),
        employeeChildrenInfo: this.safeParse(childrenInfo),
        applicantInfo: this.safeParse(applicantInfo),
        institutionInfo: this.safeParse(institutionInfo),
        doctorsEntry: this.safeParse(doctorsEntry),
        deceasedWorkerInfo: this.safeParse(deceasedWorkerInfo),
        workforceEmployeeDependentApplication: parsedWorkforceEmployeeDependentApplication,
        metadata: this.safeParse(metaInfo),
        employeeBankingInfoApplication: tempBankInfo
      });
      documents === null || documents === void 0 ? void 0 : documents.filter(function (doc) {
        return doc.holderType === "applicant";
      });
      documents === null || documents === void 0 ? void 0 : documents.filter(function (doc) {
        return doc.holderType === "factoryAdmin";
      });
      console.log({
        formData: formData
      });
      console.log({
        parsedWorkforceEmployeeDependentApplication: parsedWorkforceEmployeeDependentApplication
      });
      console.log({
        movementLogs: this.state.movementLogs
      });
      var isLoading = !application || fetchingApplication || fetchingDocument || fetchingApplicationMovements;
      if (isLoading) {
        return /*#__PURE__*/React.createElement(Box$1, {
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "500px"
        }, /*#__PURE__*/React.createElement(CircularProgress$1, null));
      }
      return /*#__PURE__*/React.createElement("div", {
        className: classes.container
      }, /*#__PURE__*/React.createElement(Box$1, {
        p: 0,
        className: classes.paper
      }, /*#__PURE__*/React.createElement(Grid, {
        container: true,
        spacing: 2,
        className: classes.gridRightPad,
        style: {
          marginTop: "16px",
          padding: 4,
          display: "flex",
          justifyContent: "flex-end"
        }
      }, (user_type === WORKFORCE_USER_TYPE.EIS_ASSOCIATION_COMMITTEE || user_type === WORKFORCE_USER_TYPE.EIS_COMMITTEE) && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 2
      }, /*#__PURE__*/React.createElement(Button, {
        variant: "contained",
        color: "primary",
        fullWidth: true,
        onClick: function onClick() {
          return _this3.setState({
            eisDependentBFTNModalOpen: true
          });
        }
      }, /*#__PURE__*/React.createElement(FormattedMessage, {
        id: "workforce.employee.application.paymentProcess",
        defaultMessage: "Payment Calculation"
      }))), !((_safeParse = safeParse((_this$props$applicati2 = this.props.application) === null || _this$props$applicati2 === void 0 ? void 0 : _this$props$applicati2.eisApprovedByIds)) !== null && _safeParse !== void 0 && _safeParse.includes(this.props.loggedInUserId)) && /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 2
      }, /*#__PURE__*/React.createElement(Button, {
        variant: "contained",
        color: "primary",
        fullWidth: true,
        disabled: (_this$props$applicati3 = this.props.application) === null || _this$props$applicati3 === void 0 ? void 0 : _this$props$applicati3.isHistory,
        onClick: function onClick() {
          _this3.handleForward();
        }
      }, /*#__PURE__*/React.createElement(FormattedMessage, {
        module: "workforce",
        id: "workforce.employee.application.eis_committee.recommended"
      }))), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 2
      }, /*#__PURE__*/React.createElement(Button, {
        variant: "contained",
        color: "primary",
        fullWidth: true,
        onClick: this.handleRevert
      }, /*#__PURE__*/React.createElement(FormattedMessage, {
        module: "workforce",
        id: "workforce.employee.application.revert.further.investigation"
      }))), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 2
      }, /*#__PURE__*/React.createElement(Button, {
        variant: "outlined",
        style: {
          backgroundColor: "#D10000",
          color: "white"
        },
        fullWidth: true,
        onClick: function onClick() {
          return _this3.handleReject();
        }
      }, /*#__PURE__*/React.createElement(FormattedMessage, {
        module: "workforce",
        id: "workforce.application.reject"
      }))))), /*#__PURE__*/React.createElement(Grid, {
        container: true,
        spacing: 2
      }, /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12
      }, /*#__PURE__*/React.createElement(ApplicationViewPage, {
        application: formData,
        language: locale,
        fileStates: documents,
        viewedFromFlag: "view",
        movementLogs: this.state.movementLogs
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 8
      }), user_type != WORKFORCE_USER_TYPE.FACTORY_ADMIN || user_type != WORKFORCE_USER_TYPE.BGMEA_ASSOCIATION || user_type != WORKFORCE_USER_TYPE.BKMEA_ASSOCIATION || user_type != WORKFORCE_USER_TYPE.BEPZA_ASSOCIATION || user_type != WORKFORCE_USER_TYPE.LFMEAB_ASSOCIATION ? /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 2
      }) : null, /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 2,
        style: {
          textAlign: "center"
        }
      }, /*#__PURE__*/React.createElement(Button, {
        variant: "contained",
        color: "primary",
        onClick: this.handlePrint,
        fullWidth: true
      }, /*#__PURE__*/React.createElement(PrintIcon, null), " ", /*#__PURE__*/React.createElement(FormattedMessage, {
        id: "workforce.modal.print",
        module: "workforce"
      }))), user_type === WORKFORCE_USER_TYPE.FACTORY_ADMIN || user_type === WORKFORCE_USER_TYPE.BGMEA_ASSOCIATION || user_type === WORKFORCE_USER_TYPE.BKMEA_ASSOCIATION || user_type === WORKFORCE_USER_TYPE.BEPZA_ASSOCIATION || user_type === WORKFORCE_USER_TYPE.LFMEAB_ASSOCIATION ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 1
      }, /*#__PURE__*/React.createElement(Button, {
        variant: "contained",
        color: "primary",
        onClick: function onClick() {
          return _this3.handleForward();
        },
        style: {
          paddingLeft: "4px",
          paddingRight: "4px"
        },
        fullWidth: true
      }, /*#__PURE__*/React.createElement(FormattedMessage, {
        module: "workforce",
        id: "workforce.employee.application.forward"
      }))), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 1
      }, /*#__PURE__*/React.createElement(Button, {
        variant: "contained",
        color: "primary",
        onClick: function onClick() {
          _this3.setState({
            revertModalOpen: true,
            selectedApplication: application
          });
          console.log("button clicked");
        },
        fullWidth: true // <-- Add this
      }, /*#__PURE__*/React.createElement(FormattedMessage, {
        module: "workforce",
        id: "workforce.employee.application.revert"
      })))) : null), user_type === WORKFORCE_USER_TYPE.ADMIN && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
        className: classes.buttonContainer
      }, /*#__PURE__*/React.createElement(Button, {
        variant: "outlined",
        style: {
          backgroundColor: "#D10000",
          color: "white"
        }
      }, /*#__PURE__*/React.createElement(FormattedMessage, {
        module: "workforce",
        id: "workforce.application.reject"
      })), /*#__PURE__*/React.createElement(Button, {
        variant: "contained",
        color: "primary"
      }, /*#__PURE__*/React.createElement(FormattedMessage, {
        module: "workforce",
        id: "workforce.application.approve"
      }))), /*#__PURE__*/React.createElement(ForwardApplicationAdminModal, {
        open: isForwardModalOpen,
        onClose: this.handleCloseForwardModal,
        application: application
      }))), /*#__PURE__*/React.createElement(Modal, {
        open: this.state.open,
        className: classes.modal,
        onClose: function onClose() {
          return _this3.setState({
            open: false
          });
        }
      }, /*#__PURE__*/React.createElement(ApplicationPrintPreview, {
        open: this.state.open,
        onClose: function onClose() {
          return _this3.setState({
            open: false
          });
        },
        onOpen: function onOpen() {
          return _this3.setState({
            open: true
          });
        },
        data: formData,
        documents: documents,
        movementLogs: this.state.movementLogs,
        logoLeft: (application === null || application === void 0 ? void 0 : application.organizationType) === "blwf" ? "/front/workforce_assets/blwf.png" : "/front/workforce_assets/centralfund.png",
        logoLeftUrl: "/front/workforce_assets/bdgov.png"
      })), user_type === WORKFORCE_USER_TYPE.FACTORY_ADMIN && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ForwardApplicationFactoryAdminModal, {
        open: this.state.forwardModalOpenFA,
        onClose: function onClose() {
          return _this3.setState({
            forwardModalOpenFA: false
          });
        },
        selectedApplicationIds: [{
          id: edited_id
        }],
        organizationEmployee: organizationEmployee
      })), this.state.eisDependentBFTNModalOpen && /*#__PURE__*/React.createElement(GenereteEisDependentBFTN, {
        open: this.state.eisDependentBFTNModalOpen,
        onClose: function onClose() {
          return _this3.setState({
            eisDependentBFTNModalOpen: false
          });
        },
        status: "approved_by_committee",
        userRights: this.props.user_rights,
        selectedApplicationIds: [{
          id: (_this$props$applicati4 = this.props.application) === null || _this$props$applicati4 === void 0 ? void 0 : _this$props$applicati4.id
        }]
      }), user_type !== WORKFORCE_USER_TYPE.APPLICANT && /*#__PURE__*/React.createElement(React.Fragment, null, this.state.revertModalOpen && /*#__PURE__*/React.createElement(RevertApplicationModal, {
        open: this.state.revertModalOpen,
        onClose: function onClose() {
          return _this3.setState({
            revertModalOpen: false
          });
        },
        selectedApplication: this.state.selectedApplication
      })), /*#__PURE__*/React.createElement(ConfirmModal, {
        open: this.state.confirmModalOpen,
        message: this.state.confirmModalMessage,
        onClose: function onClose(result) {
          if (_this3.state.confirmModalCallback) {
            _this3.state.confirmModalCallback(result === 1);
          } else {
            _this3.setState({
              confirmModalOpen: false
            });
          }
        },
        loader: this.state.loader
      }));
    }
  }]);
}(Component);
var mapStateToProps$d = function mapStateToProps(state, props) {
  var _state$core, _state$core2, _state$core3;
  return {
    fetchingApplication: state.workforce.fetchingApplication,
    fetchingDocument: state.workforce.fetchingDocument,
    fetchingApplicationMovements: state.workforce.fetchingApplicationMovements,
    application: state.workforce.application,
    user_rights: ((_state$core = state.core) === null || _state$core === void 0 || (_state$core = _state$core.user) === null || _state$core === void 0 || (_state$core = _state$core.i_user) === null || _state$core === void 0 ? void 0 : _state$core.rights) || {},
    documents: state.workforce.document,
    locale: (_state$core2 = state.core) === null || _state$core2 === void 0 || (_state$core2 = _state$core2.user) === null || _state$core2 === void 0 || (_state$core2 = _state$core2.i_user) === null || _state$core2 === void 0 ? void 0 : _state$core2.language,
    organizationEmployee: state.workforce.organizationEmployee,
    loggedInUserId: (_state$core3 = state.core) === null || _state$core3 === void 0 || (_state$core3 = _state$core3.user) === null || _state$core3 === void 0 || (_state$core3 = _state$core3.i_user) === null || _state$core3 === void 0 ? void 0 : _state$core3.id
    // applicationUuid: props.match.params.application_uuid,
  };
};
var mapDispatchToProps$9 = function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    fetchWorkforceDocument: fetchWorkforceDocument,
    updateApplication: updateApplication,
    createApplicationMovement: createApplicationMovement,
    fetchApplicationWiseMovementList: fetchApplicationWiseMovementList,
    updateApplicationSummary: updateApplicationSummary,
    journalize: journalize,
    coreConfirm: coreConfirm
  }, dispatch);
};
var ViewApplicationPage$1 = withModulesManager(withHistory(connect(mapStateToProps$d, mapDispatchToProps$9)(withStyles(styles$e)(ViewApplicationPage))));

function ownKeys$z(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$z(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$z(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$z(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var useStyles$E = makeStyles$2(function (theme) {
  return {
    root: {
      minWidth: 500
    },
    input: {
      width: "100%",
      marginBottom: theme.spacing(2)
    }
  };
});
var AddDependentModal = function AddDependentModal(_ref) {
  var open = _ref.open,
    onClose = _ref.onClose,
    application = _ref.application;
  useStyles$E();
  var modulesManager = useModulesManager();
  var dispatch = useDispatch();
  var _useTranslations = useTranslations("workforce"),
    formatMessage = _useTranslations.formatMessage;
  var stepRef = useRef(null);
  console.log({
    addDependentModal: application
  });
  // 0 = Dependents, 1 = Bank Info
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    activeStep = _useState2[0],
    setActiveStep = _useState2[1];
  var _useState3 = useState(0),
    _useState4 = _slicedToArray(_useState3, 2),
    expanded = _useState4[0],
    setExpanded = _useState4[1];
  var _useState5 = useState({}),
    _useState6 = _slicedToArray(_useState5, 2),
    errors = _useState6[0],
    setErrors = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    showErrorSnackbar = _useState8[0],
    setShowErrorSnackbar = _useState8[1];
  var _useState9 = useState(false),
    _useState10 = _slicedToArray(_useState9, 2),
    dependentErr = _useState10[0],
    setDependentErr = _useState10[1];
  var _useState11 = useState(false),
    _useState12 = _slicedToArray(_useState11, 2),
    isProcessing = _useState12[0],
    setIsProcessing = _useState12[1];
  var uploadDependentFile = useSelector(function (state) {
    return state.workforce.uploadDependentFile;
  });
  var uploadBankFile = useSelector(function (state) {
    return state.workforce.uploadBankFile;
  });
  var safeParseJson = function safeParseJson(val) {
    if (!val) return [];
    if (typeof val === "string") {
      try {
        var parsed = JSON.parse(val);
        return Array.isArray(parsed) ? parsed : [];
      } catch (_unused) {
        return [];
      }
    }
    return Array.isArray(val) ? val : [];
  };

  // const [formData, setFormData] = useState(() => {
  //   // 1. Parse all dependents; collect every attachment entry into a flat pool
  //   const rawDependents = application?.workforceEmployeeDependentApplication ?? [];
  //   const allEntries = [];
  //   rawDependents.forEach((dep) => allEntries.push(...safeParseJson(dep?.attachments)));

  //   // 2. Redistribute: each dependent keeps ONLY entries whose fieldKey starts with
  //   //    "dependent_<index>_" (e.g. "dependent_0_…" for index 0)
  //   const fullyParsedDependentInfo = rawDependents.map((dep, index) => {
  //     const prefix = `dependent_${index}_`;
  //     const ownAttachments = allEntries.filter((att) => String(att?.fieldKey ?? "").startsWith(prefix));
  //     return { ...dep, attachments: ownAttachments };
  //   });

  //   // Map over employeeBankInfo (the main DB table with bank/branch details)
  //   const fullyParsedBankInfo = application?.employeeBankInfo?.map((bank) => {
  //     // Match using the Account Number instead of NID!
  //     const matched = application?.employeeBankingInfoApplication?.find((appBank) => String(appBank?.dependentNid) === String(bank?.dependentNid));

  //     // Safely grab attachments from the matched object
  //     const rawAttachments = matched?.attachments || bank?.attachments;

  //     let parsedAttachments = [];
  //     if (rawAttachments) {
  //       parsedAttachments = typeof rawAttachments === "string" ? JSON.parse(rawAttachments) : rawAttachments;
  //     }

  //     return {
  //       ...bank,
  //       accountNumber: bank?.accountNumber, // Standardize key for the UI
  //       attachments: parsedAttachments,
  //     };
  //   });

  //   return {
  //     ...application,
  //     employeeDependentInfo: fullyParsedDependentInfo,
  //     employeeBankInfo: fullyParsedBankInfo,
  //   };
  // });
  var _useState13 = useState(function () {
      var _application$workforc, _application$employee;
      // Helper function to rewrite old index keys to the current runtime index
      var reindexAttachments = function reindexAttachments(attachments, prefix, currentIndex) {
        return attachments.map(function (att) {
          if (att.fieldKey) {
            // Strips 'dependent_X_' or 'account_X_' to get the raw fieldId, then applies the current index
            var baseKey = att.fieldKey.replace(new RegExp("^".concat(prefix, "_\\d+_")), '');
            return _objectSpread$z(_objectSpread$z({}, att), {}, {
              fieldKey: "".concat(prefix, "_").concat(currentIndex, "_").concat(baseKey)
            });
          }
          return att;
        });
      };
      return _objectSpread$z(_objectSpread$z({}, application), {}, {
        employeeDependentInfo: ((_application$workforc = application === null || application === void 0 ? void 0 : application.workforceEmployeeDependentApplication) !== null && _application$workforc !== void 0 ? _application$workforc : []).map(function (dep, index) {
          var rawAttachments = safeParseJson(dep === null || dep === void 0 ? void 0 : dep.attachments);
          return _objectSpread$z(_objectSpread$z({}, dep), {}, {
            attachments: reindexAttachments(rawAttachments, "dependent", index)
          });
        }),
        employeeBankInfo: ((_application$employee = application === null || application === void 0 ? void 0 : application.employeeBankInfo) !== null && _application$employee !== void 0 ? _application$employee : []).map(function (bank, index) {
          var _application$employee2;
          var matched = application === null || application === void 0 || (_application$employee2 = application.employeeBankingInfoApplication) === null || _application$employee2 === void 0 ? void 0 : _application$employee2.find(function (appBank) {
            return String(appBank === null || appBank === void 0 ? void 0 : appBank.accountNumber) === String(bank === null || bank === void 0 ? void 0 : bank.accountNumber);
          });
          var rawAttachments = safeParseJson((matched === null || matched === void 0 ? void 0 : matched.attachments) || (bank === null || bank === void 0 ? void 0 : bank.attachments));
          return _objectSpread$z(_objectSpread$z({}, bank), {}, {
            attachments: reindexAttachments(rawAttachments, "account", index)
          });
        })
      });
    }),
    _useState14 = _slicedToArray(_useState13, 2),
    formData = _useState14[0],
    setFormData = _useState14[1];
  var handleArrayFieldChange = function handleArrayFieldChange(fieldKey, index, key, value) {
    setFormData(function (prev) {
      var items = prev[fieldKey] ? _toConsumableArray(prev[fieldKey]) : [];
      var currentItem = items[index] || {};
      var nextValue = typeof value === "function" ? value(currentItem[key]) : value;
      items[index] = _objectSpread$z(_objectSpread$z({}, currentItem), {}, _defineProperty({}, key, nextValue));
      return _objectSpread$z(_objectSpread$z({}, prev), {}, _defineProperty({}, fieldKey, items));
    });
  };
  var addArrayFieldItem = function addArrayFieldItem(fieldKey) {
    var defaultItem = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    setFormData(function (prev) {
      var items = prev[fieldKey] ? _toConsumableArray(prev[fieldKey]) : [];
      var updated = [].concat(_toConsumableArray(items), [defaultItem]);
      setExpanded(updated.length - 1);
      return _objectSpread$z(_objectSpread$z({}, prev), {}, _defineProperty({}, fieldKey, updated));
    });
  };
  var removeArrayFieldItem = function removeArrayFieldItem(fieldKey, index) {
    setFormData(function (prev) {
      var items = prev[fieldKey] ? _toConsumableArray(prev[fieldKey]) : [];
      var updated = items.filter(function (_, i) {
        return i !== index;
      });
      return _objectSpread$z(_objectSpread$z({}, prev), {}, _defineProperty({}, fieldKey, updated));
    });
  };
  var formatPayloadJson = function formatPayloadJson(data) {
    return JSON.stringify(data).replace(/\\/g, "").replace(/"{/g, "{").replace(/}"/g, "}");
  };
  var handleSaveDependents = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _formData$deceasedWor, _formData$workforceEm;
      var newErrors, workerBirthDate, currentDependents, validDependents, finalDependentList, finalBankList, payload, activeNids;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            newErrors = validateRequiredFields(stepRef, formatMessage, formData);
            setErrors(newErrors);
            if (!(Object.keys(newErrors).length > 0)) {
              _context.next = 8;
              break;
            }
            setShowErrorSnackbar(true);
            setIsProcessing(false);
            return _context.abrupt("return");
          case 8:
            setShowErrorSnackbar(false);
          case 9:
            workerBirthDate = (formData === null || formData === void 0 || (_formData$deceasedWor = formData.deceasedWorkerInfo) === null || _formData$deceasedWor === void 0 ? void 0 : _formData$deceasedWor.birthDate) || (formData === null || formData === void 0 || (_formData$workforceEm = formData.workforceEmployee) === null || _formData$workforceEm === void 0 ? void 0 : _formData$workforceEm.birthDate);
            currentDependents = (formData === null || formData === void 0 ? void 0 : formData.employeeDependentInfo) || [{}];
            validDependents = currentDependents === null || currentDependents === void 0 ? void 0 : currentDependents.filter(function (dep) {
              var _formData$metadata;
              return getRelationForApi(dep, workerBirthDate, formData === null || formData === void 0 || (_formData$metadata = formData.metadata) === null || _formData$metadata === void 0 ? void 0 : _formData$metadata.deathDate);
            });
            if (!((validDependents === null || validDependents === void 0 ? void 0 : validDependents.length) !== (currentDependents === null || currentDependents === void 0 ? void 0 : currentDependents.length))) {
              _context.next = 16;
              break;
            }
            setDependentErr(true);
            setIsProcessing(false);
            return _context.abrupt("return");
          case 16:
            setIsProcessing(true);
            finalDependentList = formData.employeeDependentInfo || [];
            finalBankList = formData.employeeBankInfo || [];
            payload = {
              id: application.id,
              status: application === null || application === void 0 ? void 0 : application.status,
              employeeDependentInfo: formatPayloadJson(finalDependentList),
              employeeBankInfo: formatPayloadJson(finalBankList)
            };
            _context.prev = 20;
            if (!uploadDependentFile) {
              _context.next = 24;
              break;
            }
            _context.next = 24;
            return Promise.all(uploadDependentFile.map(function (file) {
              return dispatch(createWorkforceDocument(_objectSpread$z(_objectSpread$z({}, file), {}, {
                status: "verified",
                workforceApplicationId: safeDecodeId(application === null || application === void 0 ? void 0 : application.id)
              }), "Created workforce document"));
            }));
          case 24:
            _context.next = 26;
            return dispatch(updateApplication(payload, "update dependent info"));
          case 26:
            _context.next = 28;
            return dispatch(fetchEmployeeDependent(modulesManager, ["workforceApplication_Id:\"".concat(safeDecodeId(application === null || application === void 0 ? void 0 : application.id), "\"")]));
          case 28:
            activeNids = finalDependentList.map(function (dep) {
              return String(dep.nid);
            });
            setFormData(function (prev) {
              var cleansedBankInfo = (prev.employeeBankInfo || []).filter(function (bank) {
                if (bank !== null && bank !== void 0 && bank.dependentNid) {
                  return activeNids.includes(String(bank.dependentNid));
                }
                return true;
              });
              return _objectSpread$z(_objectSpread$z({}, prev), {}, {
                employeeBankInfo: cleansedBankInfo
              });
            });
            setActiveStep(1);
            setExpanded(0);
            _context.next = 37;
            break;
          case 34:
            _context.prev = 34;
            _context.t0 = _context["catch"](20);
            setShowErrorSnackbar(true);
          case 37:
            _context.prev = 37;
            setIsProcessing(false);
            return _context.finish(37);
          case 40:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[20, 34, 37, 40]]);
    }));
    return function handleSaveDependents() {
      return _ref2.apply(this, arguments);
    };
  }();
  var handleSaveBankInfo = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var finalBankList, finalDependentList, payload;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            if (!uploadBankFile) {
              _context2.next = 3;
              break;
            }
            _context2.next = 3;
            return Promise.all(uploadBankFile.map(function (file) {
              return dispatch(createWorkforceDocument(_objectSpread$z(_objectSpread$z({}, file), {}, {
                status: "verified",
                workforceApplicationId: safeDecodeId(application === null || application === void 0 ? void 0 : application.id)
              }), "Created workforce document"));
            }));
          case 3:
            finalBankList = formData.employeeBankInfo || [];
            finalDependentList = formData.employeeDependentInfo || [];
            payload = {
              id: application.id,
              status: application === null || application === void 0 ? void 0 : application.status,
              employeeDependentInfo: formatPayloadJson(finalDependentList),
              employeeBankInfo: formatPayloadJson(finalBankList)
            };
            _context2.next = 8;
            return Promise.all(dispatch(updateApplication(payload, "update bank info")).then(function (res) {
              onClose();
              window.location.reload();
            }));
          case 8:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function handleSaveBankInfo() {
      return _ref3.apply(this, arguments);
    };
  }();

  // --- Navigation: Back Button ---
  var handleBack = function handleBack() {
    setActiveStep(0);
    setExpanded(0);
  };
  useEffect(function () {
    var _formData$employeeDep, _formData$employeeBan;
    var prefillReduxFiles = function prefillReduxFiles(dataArray) {
      dataArray === null || dataArray === void 0 || dataArray.forEach(function (item) {
        // Handle both parsed array (from stringified JSON) and direct array
        var attachments = typeof (item === null || item === void 0 ? void 0 : item.attachments) === "string" ? JSON.parse(item.attachments) : item === null || item === void 0 ? void 0 : item.attachments;
        attachments === null || attachments === void 0 || attachments.forEach(function (att) {
          var _att$files;
          if ((att === null || att === void 0 || (_att$files = att.files) === null || _att$files === void 0 ? void 0 : _att$files.length) > 0 && att !== null && att !== void 0 && att.fieldKey) {
            // Use the fieldKey exactly as it comes from the DB
            dispatch(setUploadedFiles(att.fieldKey, att.files));
          }
        });
      });
    };
    if (formData !== null && formData !== void 0 && (_formData$employeeDep = formData.employeeDependentInfo) !== null && _formData$employeeDep !== void 0 && _formData$employeeDep.length) {
      prefillReduxFiles(formData.employeeDependentInfo);
    }
    if (formData !== null && formData !== void 0 && (_formData$employeeBan = formData.employeeBankInfo) !== null && _formData$employeeBan !== void 0 && _formData$employeeBan.length) {
      prefillReduxFiles(formData.employeeBankInfo);
    }
  }, [dispatch]); // Removed formData from dependency to avoid infinite loops, runs once on mount
  console.log({
    tazwer: formData
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Dialog$1, {
    open: open,
    onClose: onClose,
    maxWidth: "md",
    fullWidth: true
  }, /*#__PURE__*/React.createElement(DialogTitle, null, activeStep === 0 ? isCfPath() || isBlwfPath() ? /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "workforce.application.steps.warishAdd",
    defaultMessage: "Add Nominee"
  }) : /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "workforce.application.steps.dependentAdd",
    defaultMessage: "Add New Dependent"
  }) : /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "workforce.application.steps.bankInfo",
    defaultMessage: "Bank Account Info"
  })), /*#__PURE__*/React.createElement(DialogContent$1, null, /*#__PURE__*/React.createElement(Box$1, {
    mt: 0,
    ref: stepRef
  }, activeStep === 0 && /*#__PURE__*/React.createElement(EmployeeDependentForm, {
    applicationType: formData.applicationType,
    dependents: formData === null || formData === void 0 ? void 0 : formData.employeeDependentInfo,
    handleChange: function handleChange(index, key, value) {
      return handleArrayFieldChange("employeeDependentInfo", index, key, value);
    },
    addItem: function addItem() {
      return addArrayFieldItem("employeeDependentInfo", {
        fullName: "",
        relationship: "",
        isDisabled: "no"
      });
    },
    removeItem: function removeItem(index) {
      return removeArrayFieldItem("employeeDependentInfo", index);
    },
    expanded: expanded,
    setExpanded: setExpanded,
    formdata: formData,
    errors: errors
  }), activeStep === 1 && /*#__PURE__*/React.createElement(EmployeeDeathAccountInfoForm, {
    formdata: formData,
    accounts: formData.employeeBankInfo,
    handleChange: function handleChange(index, key, value) {
      return handleArrayFieldChange("employeeBankInfo", index, key, value);
    },
    addItem: function addItem() {
      return addArrayFieldItem("employeeBankInfo", {
        accountHolderName: "",
        bankName: "",
        accountNumber: "",
        branchName: ""
      });
    },
    removeItem: function removeItem(index) {
      return removeArrayFieldItem("employeeBankInfo", index);
    },
    expanded: expanded,
    setExpanded: setExpanded,
    applicationId: application === null || application === void 0 ? void 0 : application.id,
    errors: errors
  }))), /*#__PURE__*/React.createElement(DialogActions$1, null, /*#__PURE__*/React.createElement(Button, {
    onClick: onClose,
    color: "secondary",
    variant: "outlined"
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "core.LanguageQuickPicker.dialog.cancel",
    defaultMessage: "Cancel"
  })), activeStep === 0 ?
  /*#__PURE__*/
  // STEP 1: Calls handleSaveDependents (Mutation + Next)
  React.createElement(Button, {
    onClick: handleSaveDependents,
    color: "primary",
    variant: "contained"
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "workforce.next",
    defaultMessage: "Next"
  })) :
  /*#__PURE__*/
  // STEP 2: Calls handleSaveBankInfo (Mutation + Close)
  React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
    onClick: handleBack,
    color: "primary",
    variant: "outlined"
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "workforce.back",
    defaultMessage: "Back"
  })), /*#__PURE__*/React.createElement(Button, {
    onClick: handleSaveBankInfo,
    color: "primary",
    variant: "contained"
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "workforce.save",
    defaultMessage: "Save"
  }))))), /*#__PURE__*/React.createElement(Dialog$1, {
    open: isProcessing,
    onClose: function onClose() {},
    disableBackdropClick: true,
    disableEscapeKeyDown: true,
    maxWidth: "sm",
    fullWidth: true
  }, /*#__PURE__*/React.createElement(Box$1, {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: 4,
    gap: 2
  }, /*#__PURE__*/React.createElement(CircularProgress$1, {
    size: 60,
    thickness: 4
  }), /*#__PURE__*/React.createElement(Typography, {
    variant: "h6",
    align: "center"
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "workforce.processing.data",
    module: "workforce"
  })), /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    align: "center",
    color: "textSecondary"
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "workforce.please.wait",
    module: "workforce"
  })))), /*#__PURE__*/React.createElement(CustomSnackbar, {
    open: showErrorSnackbar // Use the new state
    ,
    onClose: function onClose() {
      return setShowErrorSnackbar(false);
    } // Allow it to close
    ,
    type: "error",
    message: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "core.error.generel",
      module: "workforce"
    }),
    duration: 4000
  }), /*#__PURE__*/React.createElement(CustomSnackbar, {
    open: dependentErr,
    onClose: function onClose() {
      return setDependentErr(false);
    },
    type: "error",
    message: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "core.error.inEligible.dependent"
    }),
    duration: 5000
  }));
};

function ownKeys$y(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$y(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$y(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$y(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper$d(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$d() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$d() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$d = function _isNativeReflectConstruct() { return !!t; })(); }
pdfjs.GlobalWorkerOptions.workerSrc = "//cdnjs.cloudflare.com/ajax/libs/pdf.js/".concat(pdfjs.version, "/pdf.worker.js");
var styles$d = function styles(theme) {
  return {
    paper: {
      padding: theme.spacing(1),
      width: 700,
      margin: "0 auto"
    },
    container: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center"
    },
    title: {
      fontSize: "medium",
      fontWeight: "bold"
    },
    fullHeight: {
      height: "100%"
    },
    overrideReadOnly: {
      "& .Mui-disabled": {
        color: "".concat(theme.palette.text.primary, " !important")
      }
    },
    rootGrid: {
      height: "auto",
      overflow: "visible"
    },
    leftGrid: {
      overflowY: "visible",
      height: "auto"
    },
    rightGrid: {
      height: "100%",
      overflowY: "auto",
      paddingLeft: 8
    },
    cardSpacing: {
      marginBottom: theme.spacing(2)
    },
    gridRightPad: {
      paddingRight: "30px !important"
    }
  };
};
var VerifyApplicationPage = /*#__PURE__*/function (_Component) {
  function VerifyApplicationPage(props) {
    var _this;
    _classCallCheck(this, VerifyApplicationPage);
    _this = _callSuper$d(this, VerifyApplicationPage, [props]);
    _defineProperty(_this, "handlePreviewOpen", function (file) {
      _this.setState({
        preview: file
      });
    });
    _defineProperty(_this, "handlePreviewClose", function () {
      _this.setState({
        preview: null
      });
    });
    _defineProperty(_this, "handleFileCommentChange", function (index, value) {
      console.log(index, value);
      _this.setState(function (prevState) {
        if (!prevState.fileStates || !prevState.fileStates[index]) {
          return {};
        }
        var updatedFiles = _toConsumableArray(prevState.fileStates);
        updatedFiles[index] = _objectSpread$y(_objectSpread$y({}, updatedFiles[index]), {}, {
          note: value
        });
        return {
          fileStates: updatedFiles
        };
      });
    });
    _defineProperty(_this, "handleCommentChange", function (e) {
      _this.setState({
        note: e.target.value
      });
    });
    _defineProperty(_this, "handleFileVerify", function (index) {
      var _this$props = _this.props,
        user_rights = _this$props.user_rights,
        application = _this$props.application,
        loggedInUserId = _this$props.loggedInUserId;
        _this$props.user;
        var roles = _this$props.roles;
      var user_type = getUserTypeFromRights(user_rights);
      var file = _this.state.fileStates[index];
      var today = new Date().toLocaleDateString("en-CA");
      var payload = _objectSpread$y(_objectSpread$y({}, file), {}, {
        id: safeDecodeId(file.id),
        status: user_type === WORKFORCE_USER_TYPE.FACTORY_ADMIN ? WORKFORCE_DOCUMENT_STATUS.FACTORY_ADMIN_VERIFIED : user_type === WORKFORCE_USER_TYPE.ASSOCIATION ? WORKFORCE_DOCUMENT_STATUS.ASSOCIATION_VERIFIED : user_type === WORKFORCE_USER_TYPE.EIS_OFFICER ? WORKFORCE_DOCUMENT_STATUS.EIS_OFFICER_VERIFIED : user_type === WORKFORCE_USER_TYPE.BLWF_DOL_DIFE ? WORKFORCE_DOCUMENT_STATUS.DOL_DIFE_VERIFIED : isBlwfPath() ? WORKFORCE_DOCUMENT_STATUS.BLWF_SECTION_OFFICER_VERIFIED : WORKFORCE_DOCUMENT_STATUS.SECTION_OFFICER_VERIFIED ,
        note: file.note,
        verifierId: loggedInUserId,
        verificationDate: today,
        holderType: user_type
      });
      _this.props.updateWorkforceDocument(payload, "update workforce document").then(function () {
        var _roles$;
        var payload = _objectSpread$y(_objectSpread$y({}, file), {}, {
          id: safeDecodeId(file.id),
          workforceApplicationId: safeDecodeId(application === null || application === void 0 ? void 0 : application.id),
          workforceDocumentId: safeDecodeId(file === null || file === void 0 ? void 0 : file.id),
          status: user_type === WORKFORCE_USER_TYPE.FACTORY_ADMIN ? WORKFORCE_DOCUMENT_STATUS.FACTORY_ADMIN_VERIFIED : user_type === WORKFORCE_USER_TYPE.ASSOCIATION ? WORKFORCE_DOCUMENT_STATUS.ASSOCIATION_VERIFIED : user_type === WORKFORCE_USER_TYPE.EIS_OFFICER ? WORKFORCE_DOCUMENT_STATUS.EIS_OFFICER_VERIFIED : user_type === WORKFORCE_USER_TYPE.BLWF_DOL_DIFE ? WORKFORCE_DOCUMENT_STATUS.DOL_DIFE_VERIFIED : isBlwfPath() ? WORKFORCE_DOCUMENT_STATUS.BLWF_SECTION_OFFICER_VERIFIED : WORKFORCE_DOCUMENT_STATUS.SECTION_OFFICER_VERIFIED ,
          note: file.note,
          verifiedById: loggedInUserId,
          verifiedByRoleId: (_roles$ = roles[0]) === null || _roles$ === void 0 ? void 0 : _roles$.roleId,
          verificationDate: today
        });
        _this.props.createWorkforceDocumentMap(payload, "create document map data");
      });

      // optionally update UI optimistically
      _this.setState(function (prevState) {
        var updated = _toConsumableArray(prevState.fileStates);
        updated[index].status = user_type === WORKFORCE_USER_TYPE.FACTORY_ADMIN ? WORKFORCE_DOCUMENT_STATUS.FACTORY_ADMIN_VERIFIED : user_type === WORKFORCE_USER_TYPE.ASSOCIATION ? WORKFORCE_DOCUMENT_STATUS.ASSOCIATION_VERIFIED : user_type === WORKFORCE_USER_TYPE.EIS_OFFICER ? WORKFORCE_DOCUMENT_STATUS.EIS_OFFICER_VERIFIED : user_type === WORKFORCE_USER_TYPE.BLWF_DOL_DIFE ? WORKFORCE_DOCUMENT_STATUS.DOL_DIFE_VERIFIED : isBlwfPath() ? WORKFORCE_DOCUMENT_STATUS.BLWF_SECTION_OFFICER_VERIFIED : WORKFORCE_DOCUMENT_STATUS.SECTION_OFFICER_VERIFIED ;
        return {
          fileStates: updated
        };
      });
    });
    _defineProperty(_this, "handleFileReject", function (index) {
      var _this$props2 = _this.props,
        user_rights = _this$props2.user_rights,
        application = _this$props2.application,
        loggedInUserId = _this$props2.loggedInUserId;
        _this$props2.user;
        var roles = _this$props2.roles;
      var user_type = getUserTypeFromRights(user_rights);
      var file = _this.state.fileStates[index];
      var today = new Date().toLocaleDateString("en-CA");
      var payload = _objectSpread$y(_objectSpread$y({}, file), {}, {
        id: safeDecodeId(file.id),
        status: user_type === WORKFORCE_USER_TYPE.FACTORY_ADMIN ? WORKFORCE_DOCUMENT_STATUS.FACTORY_ADMIN_REJECTED : user_type === WORKFORCE_USER_TYPE.ASSOCIATION ? WORKFORCE_DOCUMENT_STATUS.ASSOCIATION_REJECTED : user_type === WORKFORCE_USER_TYPE.EIS_OFFICER ? WORKFORCE_DOCUMENT_STATUS.EIS_OFFICER_REJECTED : user_type === WORKFORCE_USER_TYPE.BLWF_DOL_DIFE ? WORKFORCE_DOCUMENT_STATUS.DOL_DIFE_REJECTED : isBlwfPath() ? WORKFORCE_DOCUMENT_STATUS.BLWF_SECTION_OFFICER_REJECTED : WORKFORCE_DOCUMENT_STATUS.SECTION_OFFICER_REJECTED ,
        note: file.note,
        verifierId: loggedInUserId,
        verificationDate: today
      });
      _this.props.updateWorkforceDocument(payload, "update workforce document").then(function () {
        var _roles$2;
        var payload = _objectSpread$y(_objectSpread$y({}, file), {}, {
          id: safeDecodeId(file.id),
          workforceApplicationId: safeDecodeId(application === null || application === void 0 ? void 0 : application.id),
          workforceDocumentId: safeDecodeId(file === null || file === void 0 ? void 0 : file.id),
          status: user_type === WORKFORCE_USER_TYPE.FACTORY_ADMIN ? WORKFORCE_DOCUMENT_STATUS.FACTORY_ADMIN_REJECTED : user_type === WORKFORCE_USER_TYPE.ASSOCIATION ? WORKFORCE_DOCUMENT_STATUS.ASSOCIATION_REJECTED : user_type === WORKFORCE_USER_TYPE.EIS_OFFICER ? WORKFORCE_DOCUMENT_STATUS.EIS_OFFICER_REJECTED : user_type === WORKFORCE_USER_TYPE.BLWF_DOL_DIFE ? WORKFORCE_DOCUMENT_STATUS.DOL_DIFE_REJECTED : isBlwfPath() ? WORKFORCE_DOCUMENT_STATUS.BLWF_SECTION_OFFICER_REJECTED : WORKFORCE_DOCUMENT_STATUS.SECTION_OFFICER_REJECTED ,
          note: file.note,
          verifiedById: loggedInUserId,
          verifiedByRoleId: (_roles$2 = roles[0]) === null || _roles$2 === void 0 ? void 0 : _roles$2.roleId,
          verificationDate: today
        });
        _this.props.createWorkforceDocumentMap(payload, "create document map data");
      });
      _this.setState(function (prevState) {
        var updated = _toConsumableArray(prevState.fileStates);
        updated[index].status = user_type === WORKFORCE_USER_TYPE.FACTORY_ADMIN ? WORKFORCE_DOCUMENT_STATUS.FACTORY_ADMIN_REJECTED : user_type === WORKFORCE_USER_TYPE.ASSOCIATION ? WORKFORCE_DOCUMENT_STATUS.ASSOCIATION_REJECTED : user_type === WORKFORCE_USER_TYPE.EIS_OFFICER ? WORKFORCE_DOCUMENT_STATUS.EIS_OFFICER_REJECTED : user_type === WORKFORCE_USER_TYPE.BLWF_DOL_DIFE ? WORKFORCE_DOCUMENT_STATUS.DOL_DIFE_REJECTED : isBlwfPath() ? WORKFORCE_DOCUMENT_STATUS.BLWF_SECTION_OFFICER_REJECTED : WORKFORCE_DOCUMENT_STATUS.SECTION_OFFICER_REJECTED ;
        return {
          fileStates: updated
        };
      });
    });
    _defineProperty(_this, "safeParse", function (data) {
      if (typeof data === "string") {
        try {
          return JSON.parse(data);
        } catch (e) {
          console.warn("Failed to parse JSON:", data);
          return {};
        }
      }
      return data || {};
    });
    _defineProperty(_this, "handleFileChange", function (fieldKey, files) {
      _this.setState(function (prevState) {
        var existingIndex = prevState.uploadedFiles.findIndex(function (item) {
          return item.fieldKey === fieldKey;
        });
        var updatedFiles = _toConsumableArray(prevState.uploadedFiles);
        if (existingIndex !== -1) {
          updatedFiles[existingIndex] = {
            fieldKey: fieldKey,
            files: files
          };
        } else {
          updatedFiles.push({
            fieldKey: fieldKey,
            files: files
          });
        }
        return {
          uploadedFiles: updatedFiles
        };
      });
    });
    _defineProperty(_this, "handleForward", function () {
      var _this$props3 = _this.props,
        user_rights = _this$props3.user_rights,
        application = _this$props3.application,
        loggedInUserId = _this$props3.loggedInUserId,
        roles = _this$props3.roles;
        _this$props3.history;
      var user_type = getUserTypeFromRights(user_rights);
      if (user_type === WORKFORCE_USER_TYPE.FACTORY_ADMIN) {
        _this.setState({
          forwardModalOpenFA: true
        });
      } else if (user_type === WORKFORCE_USER_TYPE.SECTION_ADMIN || user_type === WORKFORCE_USER_TYPE.SECTION_ADMIN_TWO || user_type === WORKFORCE_USER_TYPE.BLWF_SECTION_ADMIN) {
        _this.setState({
          forwardModalOpenSA: true
        });
      } else if (user_type === WORKFORCE_USER_TYPE.CHECKER || user_type === WORKFORCE_USER_TYPE.CHECKER_TWO || user_type === WORKFORCE_USER_TYPE.SEC1_DEPUTI_ASST_DIRECTOR || user_type === WORKFORCE_USER_TYPE.SEC2_DEPUTI_ASST_DIRECTOR || user_type === WORKFORCE_USER_TYPE.BLWF_CHECKER || user_type === WORKFORCE_USER_TYPE.BLWF_DOL_DIFE || user_type === WORKFORCE_USER_TYPE.BLWF_DEPUTI_ASST_DIRECTOR || user_type === WORKFORCE_USER_TYPE.EIS_OFFICER) {
        handleBulkSelectedByCheckerLogic({
          selectedApplicationIds: [{
            id: safeDecodeId(application === null || application === void 0 ? void 0 : application.id)
          }],
          loggedInUserId: _this.props.loggedInUserId,
          userRights: _this.props.user_rights,
          fetchWorkforceDocument: _this.props.fetchWorkforceDocument,
          updateApplication: _this.props.updateApplication,
          createApplicationMovement: _this.props.createApplicationMovement,
          modulesManager: _this.props.modulesManager,
          roles: roles,
          setServerResponse: function setServerResponse(res) {
            return _this.setState({
              serverResponse: res
            });
          },
          setConfirmModalOpen: function setConfirmModalOpen(val) {
            return _this.setState({
              confirmModalOpen: val
            });
          },
          setConfirmModalMessage: function setConfirmModalMessage(msg) {
            return _this.setState({
              confirmModalMessage: msg
            });
          },
          setConfirmModalCallback: function setConfirmModalCallback(cb) {
            return _this.setState({
              confirmModalCallback: cb
            });
          },
          history: _this.props.history,
          dispatch: _this.props.dispatch,
          setCloseLoader: function setCloseLoader(l) {
            return _this.setState({
              loader: l
            });
          },
          loader: _this.state.loader
        });
      } else if (user_type === WORKFORCE_USER_TYPE.EIS_COORDINATOR) {
        _this.setState({
          forwardModalOpenEIS: true
        });
      } else if (user_type === WORKFORCE_USER_TYPE.EIS_DOCTOR) {
        handleApprovalByDoctor({
          selectedApplicationIds: [{
            id: application === null || application === void 0 ? void 0 : application.id
          }],
          loggedInUserId: _this.props.loggedInUserId,
          userRights: _this.props.user_rights,
          fetchWorkforceDocument: _this.props.fetchWorkforceDocument,
          updateApplication: _this.props.updateApplication,
          createApplicationMovement: _this.props.createApplicationMovement,
          modulesManager: _this.props.modulesManager,
          setServerResponse: function setServerResponse(res) {
            return _this.setState({
              serverResponse: res
            });
          },
          setConfirmModalOpen: function setConfirmModalOpen(val) {
            return _this.setState({
              confirmModalOpen: val
            });
          },
          setConfirmModalMessage: function setConfirmModalMessage(msg) {
            return _this.setState({
              confirmModalMessage: msg
            });
          },
          setConfirmModalCallback: function setConfirmModalCallback(cb) {
            return _this.setState({
              confirmModalCallback: cb
            });
          },
          // historyPush:historyPush,
          history: _this.props.history,
          setCloseLoader: function setCloseLoader(l) {
            return _this.setState({
              loader: l
            });
          },
          loader: _this.state.loader
        });
      } else if (user_type === WORKFORCE_USER_TYPE.EIS_COMMITTEE || user_type === WORKFORCE_USER_TYPE.EIS_ASSOCIATION_COMMITTEE) {
        var _summaryApplicationRe, _summaryApplicationRe2, _application$eisAppli;
        var summaryApplicationRes = _this.props.dispatch(fetchApplication(_this.props.modulesManager, ["eisApplicationSummaryId: \"".concat(safeDecodeId(summaryId), "\""), "statusIn: [\"".concat(WORKFORCE_STATUS.FORWARD_TO_COMIITEE, "\"]")]));
        Number((_summaryApplicationRe = summaryApplicationRes === null || summaryApplicationRes === void 0 || (_summaryApplicationRe2 = summaryApplicationRes.payload) === null || _summaryApplicationRe2 === void 0 || (_summaryApplicationRe2 = _summaryApplicationRe2.data) === null || _summaryApplicationRe2 === void 0 || (_summaryApplicationRe2 = _summaryApplicationRe2.workforceApplication) === null || _summaryApplicationRe2 === void 0 ? void 0 : _summaryApplicationRe2.totalCount) !== null && _summaryApplicationRe !== void 0 ? _summaryApplicationRe : 0);
        handleApprovalByEisCommittee({
          selectedApplicationIds: [{
            id: application === null || application === void 0 ? void 0 : application.id
          }],
          loggedInUserId: _this.props.loggedInUserId,
          userRights: _this.props.user_rights,
          modulesManager: _this.props.modulesManager,
          fetchWorkforceDocument: _this.props.fetchWorkforceDocument,
          updateApplication: _this.props.updateApplication,
          createApplicationMovement: _this.props.createApplicationMovement,
          updateApplicationSummary: _this.props.updateApplicationSummary,
          setServerResponse: function setServerResponse(res) {
            return _this.setState({
              serverResponse: res
            });
          },
          setConfirmModalOpen: function setConfirmModalOpen(val) {
            return _this.setState({
              confirmModalOpen: val
            });
          },
          setConfirmModalMessage: function setConfirmModalMessage(msg) {
            return _this.setState({
              confirmModalMessage: msg
            });
          },
          setConfirmModalCallback: function setConfirmModalCallback(cb) {
            return _this.setState({
              confirmModalCallback: cb
            });
          },
          summaryId: application === null || application === void 0 || (_application$eisAppli = application.eisApplicationSummary) === null || _application$eisAppli === void 0 ? void 0 : _application$eisAppli.id,
          eisApprovalIds: application === null || application === void 0 ? void 0 : application.eisApprovalIds,
          eisApprovedByIds: application === null || application === void 0 ? void 0 : application.eisApprovedByIds,
          // historyPush:historyPush,
          history: _this.props.history,
          setCloseLoader: function setCloseLoader(l) {
            return _this.setState({
              loader: l
            });
          },
          loader: _this.state.loader
        });
      } else {
        handleBulkSelectedByAssociationLogic({
          selectedApplicationIds: [_objectSpread$y({
            id: application === null || application === void 0 ? void 0 : application.id,
            applicationType: application === null || application === void 0 ? void 0 : application.applicationType
          }, application)],
          loggedInUserId: loggedInUserId,
          updateApplication: _this.props.updateApplication,
          createApplicationMovement: _this.props.createApplicationMovement,
          userRights: _this.props.user_rights,
          fetchWorkforceDocument: _this.props.fetchWorkforceDocument,
          testWorkforcePayment: _this.props.testWorkforcePayment,
          fetchUsersByRoleId: _this.props.fetchUsersByRoleId,
          modulesManager: _this.props.modulesManager,
          roles: roles,
          setServerResponse: function setServerResponse(res) {
            return _this.setState({
              serverResponse: res
            });
          },
          setConfirmModalOpen: function setConfirmModalOpen(val) {
            return _this.setState({
              confirmModalOpen: val
            });
          },
          setConfirmModalMessage: function setConfirmModalMessage(msg) {
            return _this.setState({
              confirmModalMessage: msg
            });
          },
          setConfirmModalCallback: function setConfirmModalCallback(cb) {
            return _this.setState({
              confirmModalCallback: cb
            });
          },
          // historyPush:historyPush,
          history: _this.props.history,
          setCloseLoader: function setCloseLoader(l) {
            return _this.setState({
              loader: l
            });
          },
          loader: _this.state.loader
        });
      }
    });
    _defineProperty(_this, "handleRevert", function () {
      _this.setState({
        revertModalOpen: true,
        selectedApplication: _this.props.application
      });
    });
    _defineProperty(_this, "handleForwardSubmit", function (event) {
      _this.state.editorContent;
      event.preventDefault();
      _this.state.userList.find(function (user) {
        return user.id === _this.state.selectedUserId;
      });
      _this.setState({
        submitting: true
      });
      setTimeout(function () {
        _this.setState({
          submitting: false,
          serverResponse: {
            status: "SUCCESS",
            message: "আবেদন সফলভাবে Forward করা হয়েছে!"
          }
        });
        setTimeout(function () {
          _this.setState({
            revertModalOpen: false,
            selectedUserId: "",
            deadline: "",
            selectedApplication: null,
            serverResponse: null
          });
        }, 2000);
      }, 2000);
    });
    var mockFiles = [{
      type: "image",
      src: "https://upload.wikimedia.org/wikipedia/commons/b/b9/Smart_NID_Card_%28Bangladesh%29.jpg",
      comment: "Clear image, all info visible.",
      status: "verified"
    }, {
      type: "pdf",
      src: "/assets/Fahim_tazwer_cv.pdf",
      comment: "Missing signature on last page.",
      status: "rejected"
    }];
    _this.state = {
      isSaved: false,
      preview: null,
      note: "",
      mockFiles: mockFiles,
      uploadedFiles: [],
      fileStates: mockFiles.map(function (file) {
        return _objectSpread$y(_objectSpread$y({}, file), {}, {
          note: "",
          status: null
        });
      }),
      addDependentModalOpen: false,
      forwardModalOpenFA: false,
      forwardModalOpenSA: false,
      revertModalOpen: false,
      confirmModalOpen: false,
      forwardModalOpenEIS: false,
      confirmModalMessage: "",
      confirmModalCallback: null,
      loader: false,
      serverResponse: "",
      selectedApplication: null,
      eisDependentBFTNModalOpen: false
    };
    return _this;
  }
  _inherits(VerifyApplicationPage, _Component);
  return _createClass(VerifyApplicationPage, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.application !== this.props.application) {
        this.setState({
          stateEdited: this.props.application
        });
      }
      if (prevProps.documents !== this.props.documents) {
        this.setState({
          fileStates: this.props.documents || []
        });
      }
      if (prevProps.submittingMutation && !this.props.submittingMutation) {
        this.props.dispatch(journalize(this.props.mutation));
      }
    }
  }, {
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _this$props5;
        var _this$props4, modulesManager, applicationUuid, loggedInUserId, application, applicationType, organizationType, applicationFor, applicationForType, doubleParseApplicationFor;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this$props4 = this.props, _this$props4.dispatch, modulesManager = _this$props4.modulesManager, applicationUuid = _this$props4.applicationUuid, loggedInUserId = _this$props4.loggedInUserId;
              _context.next = 3;
              return this.props.fetchApplication(modulesManager, ["id:\"".concat(applicationUuid, "\"")]);
            case 3:
              application = this.props.application;
              applicationType = application === null || application === void 0 ? void 0 : application.applicationType;
              organizationType = application === null || application === void 0 ? void 0 : application.organizationType;
              applicationFor = application === null || application === void 0 ? void 0 : application.applicationFor;
              applicationForType = this.safeParse(application === null || application === void 0 ? void 0 : application.metadata);
              doubleParseApplicationFor = this.safeParse(applicationForType);
              if (applicationType !== ("financialAssistance" ) && organizationType && applicationFor !== (null)) {
                this.props.fetchDocumentType(modulesManager, ["applicationType:\"".concat(applicationType, "\""), "organizationType:\"".concat(organizationType, "\""), "mandatoryForApplicant: false", "applicationFor_Icontains:\"".concat(applicationFor, "\"")]);
              } else if (applicationType === "disabilityAssistance" && organizationType && applicationFor === (null)) {
                console.log({
                  hello: doubleParseApplicationFor
                });
                doubleParseApplicationFor.disabilityType === "partial" ? this.props.fetchDocumentType(modulesManager, ["applicationType:\"".concat(applicationType, "\""), "organizationType:\"".concat(organizationType, "\""), "mandatoryForApplicant: false", "applicationFor_Icontains:\"temporary_disability\""]) : this.props.fetchDocumentType(modulesManager, ["applicationType:\"".concat(applicationType, "\""), "organizationType:\"".concat(organizationType, "\""), "mandatoryForApplicant: false", "applicationFor_Icontains:\"temporary_disability\""]);
              } else if (applicationType === "financialAssistance" && organizationType) {
                console.log({
                  helloFormFinance: doubleParseApplicationFor
                });
                doubleParseApplicationFor.deathType === "normalDeath" ? this.props.fetchDocumentType(modulesManager, ["applicationType:\"".concat(applicationType, "\""), "organizationType:\"".concat(organizationType, "\""), "mandatoryForApplicant: false", "applicationFor_Icontains:\"normal_death\""]) : this.props.fetchDocumentType(modulesManager, ["applicationType:\"".concat(applicationType, "\""), "organizationType:\"".concat(organizationType, "\""), "mandatoryForApplicant: false", "applicationFor_Icontains:\"accidental_death\""]);
              } else {
                this.props.fetchDocumentType(modulesManager, ["applicationType:\"".concat(applicationType, "\""), "organizationType:\"".concat(organizationType, "\""), "mandatoryForApplicant: false"]);
              }
              this.props.fetchWorkforceDocument(modulesManager, ["workforceApplication_Id:\"".concat(applicationUuid, "\"")]);
              this === null || this === void 0 || (_this$props5 = this.props) === null || _this$props5 === void 0 || _this$props5.fetchRoles(loggedInUserId);
            case 12:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }
      return componentDidMount;
    }()
  }, {
    key: "render",
    value: function render() {
      var _application$employee,
        _this2 = this,
        _safeParse,
        _this$props$applicati,
        _this$props$applicati2,
        _safeParse2,
        _this$props$applicati3,
        _this$props$applicati4,
        _this$props$applicati5,
        _this$props$applicati6,
        _this$props$applicati7,
        _this$state$serverRes,
        _this$state$serverRes2;
      var _this$props6 = this.props,
        classes = _this$props6.classes,
        applicationUuid = _this$props6.applicationUuid;
        _this$props6.documents;
        var application = _this$props6.application,
        documentType = _this$props6.documentType,
        locale = _this$props6.locale,
        user_rights = _this$props6.user_rights;
        _this$props6.user;
        var roles = _this$props6.roles,
        fetchingApplication = _this$props6.fetchingApplication,
        fetchingDocument = _this$props6.fetchingDocument;
        _this$props6.fetchingApplicationMovements;
      var _this$state = this.state,
        stateEdited = _this$state.stateEdited;
        _this$state.preview;
        var fileStates = _this$state.fileStates;
        _this$state.comment;
        _this$state.applicationType;
      var user_type = getUserTypeFromRights(user_rights);
      var bankInfo = this.safeParse(application === null || application === void 0 ? void 0 : application.employeeBankInfo);
      var AccidentInfo = this.safeParse(application === null || application === void 0 ? void 0 : application.employeeAccidentInfo);
      var dependentInfo = this.safeParse(application === null || application === void 0 ? void 0 : application.employeeDependentInfo);
      var childrenInfo = this.safeParse(application === null || application === void 0 ? void 0 : application.employeeChildrenInfo);
      var applicantInfo = this.safeParse(application === null || application === void 0 ? void 0 : application.applicantInfo);
      var institutionInfo = this.safeParse(stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.institutionInfo);
      var deceasedWorkerInfo = this.safeParse(stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.deceasedWorkerInfo);
      var doctorsEntryInfo = this.safeParse(stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.doctorsEntry);
      var metaInfo = this.safeParse(application === null || application === void 0 ? void 0 : application.metadata);
      var parsedWorkforceEmployeeDependentApplication = application === null || application === void 0 ? void 0 : application.workforceEmployeeDependentApplication;
      var tempBankInfo = application === null || application === void 0 || (_application$employee = application.employeeBankingInfoApplication) === null || _application$employee === void 0 ? void 0 : _application$employee.map(function (item) {
        var _item$branch;
        return _objectSpread$y(_objectSpread$y({}, item), {}, {
          bank: _objectSpread$y({}, item === null || item === void 0 || (_item$branch = item.branch) === null || _item$branch === void 0 ? void 0 : _item$branch.parent)
        });
      });
      console.log("verify application", application);
      var formData = _objectSpread$y(_objectSpread$y({}, application), {}, {
        workforceEmployee: application === null || application === void 0 ? void 0 : application.workforceEmployee,
        employeeAccidentInfo: this.safeParse(AccidentInfo),
        employeeBankInfo: this.safeParse(bankInfo),
        employeeDependentInfo: this.safeParse(dependentInfo),
        employeeChildrenInfo: this.safeParse(childrenInfo),
        applicantInfo: this.safeParse(applicantInfo),
        institutionInfo: this.safeParse(institutionInfo),
        deceasedWorkerInfo: this.safeParse(deceasedWorkerInfo),
        doctorsEntry: this.safeParse(doctorsEntryInfo),
        metadata: this.safeParse(metaInfo),
        otherInfo: this.safeParse(metaInfo),
        workforceEmployeeDependentApplication: parsedWorkforceEmployeeDependentApplication,
        employeeBankingInfoApplication: tempBankInfo
      });
      var filteredDocumentTypes = documentType === null || documentType === void 0 ? void 0 : documentType.filter(function (doc) {
        // check if there’s already a file uploaded for this doc
        var isUploaded = fileStates === null || fileStates === void 0 ? void 0 : fileStates.some(function (file) {
          var _file$workforceDocume;
          return (file === null || file === void 0 || (_file$workforceDocume = file.workforceDocumentType) === null || _file$workforceDocume === void 0 ? void 0 : _file$workforceDocume.id) === (doc === null || doc === void 0 ? void 0 : doc.id);
        });
        console.log({
          isUploaded: isUploaded
        });

        // return docs that are not uploaded
        return !isUploaded;
      });
      var isLoading = fetchingApplication || !application && fetchingDocument;
      if (isLoading) {
        return /*#__PURE__*/React.createElement(Box$1, {
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "500px"
        }, /*#__PURE__*/React.createElement(CircularProgress$1, null));
      }
      console.log({
        roles: roles
      });
      return /*#__PURE__*/React.createElement(React.Fragment, null, isEisPath() && (user_type === WORKFORCE_USER_TYPE.FACTORY_ADMIN || user_type === WORKFORCE_USER_TYPE.BGMEA_ASSOCIATION || user_type === WORKFORCE_USER_TYPE.BKMEA_ASSOCIATION || user_type === WORKFORCE_USER_TYPE.SECTION_ADMIN || user_type === WORKFORCE_USER_TYPE.BLWF_SECTION_ADMIN || user_type === WORKFORCE_USER_TYPE.EIS_COORDINATOR || user_type === WORKFORCE_USER_TYPE.EIS_ASSOCIATION_COMMITTEE || user_type === WORKFORCE_USER_TYPE.EIS_COMMITTEE || user_type === WORKFORCE_USER_TYPE.EIS_ADVISOR || user_type === WORKFORCE_USER_TYPE.CHECKER || user_type === WORKFORCE_USER_TYPE.CHECKER_TWO || user_type === WORKFORCE_USER_TYPE.SEC1_DEPUTI_ASST_DIRECTOR || user_type === WORKFORCE_USER_TYPE.SEC2_DEPUTI_ASST_DIRECTOR || user_type === WORKFORCE_USER_TYPE.BLWF_CHECKER || user_type === WORKFORCE_USER_TYPE.BLWF_DOL_DIFE || user_type === WORKFORCE_USER_TYPE.BLWF_DEPUTI_ASST_DIRECTOR || user_type === WORKFORCE_USER_TYPE.EIS_OFFICER || user_type === WORKFORCE_USER_TYPE.ASSOCIATION || user_type === WORKFORCE_USER_TYPE.EIS_DOCTOR) && /*#__PURE__*/React.createElement(Grid, {
        container: true,
        spacing: 2,
        className: classes.gridRightPad,
        style: {
          marginTop: "16px",
          padding: 4,
          display: "flex",
          justifyContent: "flex-end"
        }
      }, user_type === WORKFORCE_USER_TYPE.EIS_OFFICER && (application === null || application === void 0 ? void 0 : application.applicationType) === "financialAssistance" && /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 2
      }, /*#__PURE__*/React.createElement(Button, {
        variant: "contained",
        color: "primary",
        fullWidth: true,
        onClick: function onClick() {
          return _this2.setState({
            addDependentModalOpen: true
          });
        }
      }, isCfPath() || isBlwfPath() ? /*#__PURE__*/React.createElement(FormattedMessage, {
        id: "workforce.application.steps.warishAdd",
        defaultMessage: "Add Nominee"
      }) : /*#__PURE__*/React.createElement(FormattedMessage, {
        id: "workforce.application.steps.dependentAdd",
        defaultMessage: "Add New Dependent"
      }))), (user_type === WORKFORCE_USER_TYPE.EIS_COORDINATOR || user_type === WORKFORCE_USER_TYPE.EIS_ASSOCIATION_COMMITTEE || user_type === WORKFORCE_USER_TYPE.EIS_COMMITTEE || user_type === WORKFORCE_USER_TYPE.EIS_ADVISOR) && /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 2
      }, /*#__PURE__*/React.createElement(Button, {
        variant: "contained",
        color: "primary",
        fullWidth: true,
        onClick: function onClick() {
          return _this2.setState({
            eisDependentBFTNModalOpen: true
          });
        }
      }, /*#__PURE__*/React.createElement(FormattedMessage, {
        id: "workforce.employee.application.paymentProcess",
        defaultMessage: "Payment Calculation"
      }))), user_type === WORKFORCE_USER_TYPE.EIS_COMMITTEE || user_type === WORKFORCE_USER_TYPE.EIS_ASSOCIATION_COMMITTEE ? !((_safeParse = safeParse((_this$props$applicati = this.props.application) === null || _this$props$applicati === void 0 ? void 0 : _this$props$applicati.eisApprovedByIds)) !== null && _safeParse !== void 0 && _safeParse.includes(this.props.loggedInUserId)) && /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 2
      }, /*#__PURE__*/React.createElement(Button, {
        variant: "contained",
        color: "primary",
        fullWidth: true,
        disabled: (_this$props$applicati2 = this.props.application) === null || _this$props$applicati2 === void 0 ? void 0 : _this$props$applicati2.isHistory,
        onClick: function onClick() {
          _this2.handleForward();
        }
      }, /*#__PURE__*/React.createElement(FormattedMessage, {
        module: "workforce",
        id: "workforce.employee.application.eis_committee.recommended"
      }))) : !(user_type === WORKFORCE_USER_TYPE.EIS_COORDINATOR && (application === null || application === void 0 ? void 0 : application.status) === "verified") && /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 2
      }, /*#__PURE__*/React.createElement(Button, {
        variant: "contained",
        color: "primary",
        fullWidth: true,
        onClick: this.handleForward
      }, /*#__PURE__*/React.createElement(FormattedMessage, {
        module: "workforce",
        id: "workforce.employee.application.forward"
      }))), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 2
      }, /*#__PURE__*/React.createElement(Button, {
        variant: "contained",
        color: "primary",
        fullWidth: true,
        onClick: this.handleRevert
      }, /*#__PURE__*/React.createElement(FormattedMessage, {
        module: "workforce",
        id: "workforce.employee.application.revert"
      })))), /*#__PURE__*/React.createElement(Grid, {
        container: true,
        spacing: 3,
        className: classes.rootGrid
      }, /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12,
        md: 12,
        className: classes.leftGrid
      }, user_type !== WORKFORCE_USER_TYPE.APPLICANT && filteredDocumentTypes ? /*#__PURE__*/React.createElement(ApplicationViewPage, {
        application: formData,
        language: locale,
        filteredDocumentTypes: filteredDocumentTypes,
        applicationUuid: applicationUuid,
        onFileChange: this.handleFileChange,
        fileStates: fileStates,
        handleCommentChange: this.handleFileCommentChange,
        handleFileVerify: this.handleFileVerify,
        handleFileReject: this.handleFileReject,
        viewedFromFlag: "verify"
      }) : /*#__PURE__*/React.createElement(ApplicationViewPage, {
        application: formData,
        language: locale,
        filteredDocumentTypes: filteredDocumentTypes,
        applicationUuid: applicationUuid,
        onFileChange: this.handleFileChange,
        fileStates: fileStates,
        handleCommentChange: this.handleFileCommentChange,
        handleFileVerify: this.handleFileVerify,
        handleFileReject: this.handleFileReject,
        viewedFromFlag: "verify"
      }))), !isEisPath() && (user_type === WORKFORCE_USER_TYPE.FACTORY_ADMIN || user_type === WORKFORCE_USER_TYPE.BGMEA_ASSOCIATION || user_type === WORKFORCE_USER_TYPE.BKMEA_ASSOCIATION || user_type === WORKFORCE_USER_TYPE.ASSOCIATION || user_type === WORKFORCE_USER_TYPE.SECTION_ADMIN || user_type === WORKFORCE_USER_TYPE.BLWF_SECTION_ADMIN || user_type === WORKFORCE_USER_TYPE.EIS_COORDINATOR || user_type === WORKFORCE_USER_TYPE.EIS_ASSOCIATION_COMMITTEE || user_type === WORKFORCE_USER_TYPE.EIS_COMMITTEE || user_type === WORKFORCE_USER_TYPE.EIS_ADVISOR || user_type === WORKFORCE_USER_TYPE.CHECKER || user_type === WORKFORCE_USER_TYPE.CHECKER_TWO || user_type === WORKFORCE_USER_TYPE.SEC1_DEPUTI_ASST_DIRECTOR || user_type === WORKFORCE_USER_TYPE.SEC2_DEPUTI_ASST_DIRECTOR || user_type === WORKFORCE_USER_TYPE.BLWF_CHECKER || user_type === WORKFORCE_USER_TYPE.BLWF_DOL_DIFE || user_type === WORKFORCE_USER_TYPE.BLWF_DEPUTI_ASST_DIRECTOR || user_type === WORKFORCE_USER_TYPE.EIS_OFFICER || user_type === WORKFORCE_USER_TYPE.EIS_DOCTOR || user_type === WORKFORCE_USER_TYPE.DIRECTOR || user_type === WORKFORCE_USER_TYPE.ADMIN) && /*#__PURE__*/React.createElement(Grid, {
        container: true,
        spacing: 2,
        className: classes.gridRightPad,
        style: {
          marginTop: "16px",
          padding: 4,
          display: "flex",
          justifyContent: "flex-end"
        }
      }, (user_type === WORKFORCE_USER_TYPE.EIS_OFFICER || user_type === WORKFORCE_USER_TYPE.DIRECTOR || user_type === WORKFORCE_USER_TYPE.ADMIN) && (application === null || application === void 0 ? void 0 : application.applicationType) === "financialAssistance" && /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 2
      }, /*#__PURE__*/React.createElement(Button, {
        variant: "contained",
        color: "primary",
        fullWidth: true,
        onClick: function onClick() {
          return _this2.setState({
            addDependentModalOpen: true
          });
        }
      }, isCfPath() || isBlwfPath() ? /*#__PURE__*/React.createElement(FormattedMessage, {
        id: "workforce.application.steps.warishAdd",
        defaultMessage: "Add Nominee"
      }) : /*#__PURE__*/React.createElement(FormattedMessage, {
        id: "workforce.application.steps.dependentAdd",
        defaultMessage: "Add New Dependent"
      }))), (user_type === WORKFORCE_USER_TYPE.EIS_COORDINATOR || user_type === WORKFORCE_USER_TYPE.EIS_ASSOCIATION_COMMITTEE || user_type === WORKFORCE_USER_TYPE.EIS_COMMITTEE || user_type === WORKFORCE_USER_TYPE.EIS_ADVISOR) && /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 2
      }, /*#__PURE__*/React.createElement(Button, {
        variant: "contained",
        color: "primary",
        fullWidth: true,
        onClick: function onClick() {
          return _this2.setState({
            eisDependentBFTNModalOpen: true
          });
        }
      }, /*#__PURE__*/React.createElement(FormattedMessage, {
        id: "workforce.employee.application.paymentProcess",
        defaultMessage: "Payment Calculation"
      }))), user_type === WORKFORCE_USER_TYPE.EIS_COMMITTEE || user_type === WORKFORCE_USER_TYPE.EIS_ASSOCIATION_COMMITTEE ? !((_safeParse2 = safeParse((_this$props$applicati3 = this.props.application) === null || _this$props$applicati3 === void 0 ? void 0 : _this$props$applicati3.eisApprovedByIds)) !== null && _safeParse2 !== void 0 && _safeParse2.includes(this.props.loggedInUserId)) && /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 2
      }, /*#__PURE__*/React.createElement(Button, {
        variant: "contained",
        color: "primary",
        fullWidth: true,
        disabled: (_this$props$applicati4 = this.props.application) === null || _this$props$applicati4 === void 0 ? void 0 : _this$props$applicati4.isHistory,
        onClick: function onClick() {
          _this2.handleForward();
        }
      }, /*#__PURE__*/React.createElement(FormattedMessage, {
        module: "workforce",
        id: "workforce.employee.application.eis_committee.recommended"
      }))) : /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 2
      }, /*#__PURE__*/React.createElement(Button, {
        variant: "contained",
        color: "primary",
        fullWidth: true,
        onClick: this.handleForward
      }, /*#__PURE__*/React.createElement(FormattedMessage, {
        module: "workforce",
        id: "workforce.employee.application.forward"
      }))), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 2
      }, /*#__PURE__*/React.createElement(Button, {
        variant: "contained",
        color: "primary",
        fullWidth: true,
        onClick: this.handleRevert
      }, /*#__PURE__*/React.createElement(FormattedMessage, {
        module: "workforce",
        id: "workforce.employee.application.revert"
      })))), this.state.addDependentModalOpen && /*#__PURE__*/React.createElement(AddDependentModal, {
        open: this.state.addDependentModalOpen,
        onClose: function onClose() {
          return _this2.setState({
            addDependentModalOpen: false
          });
        },
        application: formData
      }), this.state.eisDependentBFTNModalOpen && /*#__PURE__*/React.createElement(GenereteEisDependentBFTN, {
        open: this.state.eisDependentBFTNModalOpen,
        onClose: function onClose() {
          return _this2.setState({
            eisDependentBFTNModalOpen: false
          });
        },
        status: "approved_by_committee",
        userRights: this.props.user_rights,
        selectedApplicationIds: [{
          id: (_this$props$applicati5 = this.props.application) === null || _this$props$applicati5 === void 0 ? void 0 : _this$props$applicati5.id
        }]
      }), user_type === WORKFORCE_USER_TYPE.FACTORY_ADMIN && /*#__PURE__*/React.createElement(ForwardApplicationFactoryAdminModal, {
        open: this.state.forwardModalOpenFA,
        onClose: function onClose() {
          return _this2.setState({
            forwardModalOpenFA: false
          });
        },
        selectedApplicationIds: [{
          id: (_this$props$applicati6 = this.props.application) === null || _this$props$applicati6 === void 0 ? void 0 : _this$props$applicati6.id
        }],
        organizationEmployee: this.props.organizationEmployee,
        roles: roles
      }), (user_type === WORKFORCE_USER_TYPE.SECTION_ADMIN || user_type === WORKFORCE_USER_TYPE.BLWF_SECTION_ADMIN || user_type === WORKFORCE_USER_TYPE.EIS_COORDINATOR) && /*#__PURE__*/React.createElement(ForwardApplicationSectionAdminModal, {
        open: this.state.forwardModalOpenSA,
        onClose: function onClose() {
          return _this2.setState({
            forwardModalOpenSA: false
          });
        },
        selectedApplicationIds: [{
          id: (_this$props$applicati7 = this.props.application) === null || _this$props$applicati7 === void 0 ? void 0 : _this$props$applicati7.id
        }]
        // onSubmitForward={th  is.handleForwardSubmit}
        ,
        userRights: user_rights
      }), user_type === WORKFORCE_USER_TYPE.EIS_COORDINATOR && /*#__PURE__*/React.createElement(ForwardApplicationEisCoordinatorModal, {
        open: this.state.forwardModalOpenEIS,
        onClose: function onClose() {
          return _this2.setState({
            forwardModalOpenEIS: false
          });
        },
        selectedApplicationIds: [{
          id: application === null || application === void 0 ? void 0 : application.id
        }],
        onSubmitForward: this.handleForwardSubmit,
        userRights: user_rights,
        summaryId: this.props.summaryId,
        roleIds: ["47"]
      }), user_type !== WORKFORCE_USER_TYPE.APPLICANT && /*#__PURE__*/React.createElement(RevertApplicationModal, {
        open: this.state.revertModalOpen,
        onClose: function onClose() {
          return _this2.setState({
            revertModalOpen: false
          });
        },
        selectedApplication: this.state.selectedApplication
      }), /*#__PURE__*/React.createElement(CustomSnackbar, {
        open: !!this.state.serverResponse,
        onClose: function onClose() {
          return _this2.setState({
            serverResponse: null
          });
        },
        autoHideDuration: 3000,
        type: ((_this$state$serverRes = this.state.serverResponse) === null || _this$state$serverRes === void 0 || (_this$state$serverRes = _this$state$serverRes.status) === null || _this$state$serverRes === void 0 ? void 0 : _this$state$serverRes.toLowerCase()) || "info",
        message: (_this$state$serverRes2 = this.state.serverResponse) === null || _this$state$serverRes2 === void 0 ? void 0 : _this$state$serverRes2.message
      }), /*#__PURE__*/React.createElement(ConfirmModal, {
        open: this.state.confirmModalOpen,
        message: this.state.confirmModalMessage,
        onClose: function onClose(result) {
          if (_this2.state.confirmModalCallback) {
            _this2.state.confirmModalCallback(result === 1);
          } else {
            _this2.setState({
              confirmModalOpen: false
            });
          }
        },
        loader: this.state.loader
      }));
    }
  }]);
}(Component);
var mapStateToProps$c = function mapStateToProps(state, props) {
  var _state$core, _state$core2, _state$core3, _state$workforce;
  return {
    fetchingApplication: state.workforce.fetchingApplication,
    fetchingDocument: state.workforce.fetchingDocument,
    fetchingApplicationMovements: state.workforce.fetchingApplicationMovements,
    application: state.workforce.application,
    applicationUuid: props.match.params.application_uuid,
    documents: state.workforce.document,
    documentType: state.workforce.documentType,
    user_rights: (_state$core = state.core) === null || _state$core === void 0 || (_state$core = _state$core.user) === null || _state$core === void 0 || (_state$core = _state$core.i_user) === null || _state$core === void 0 ? void 0 : _state$core.rights,
    locale: (_state$core2 = state.core) === null || _state$core2 === void 0 || (_state$core2 = _state$core2.user) === null || _state$core2 === void 0 || (_state$core2 = _state$core2.i_user) === null || _state$core2 === void 0 ? void 0 : _state$core2.language,
    loggedInUserId: (_state$core3 = state.core) === null || _state$core3 === void 0 || (_state$core3 = _state$core3.user) === null || _state$core3 === void 0 || (_state$core3 = _state$core3.i_user) === null || _state$core3 === void 0 ? void 0 : _state$core3.id,
    user: state.profile.user,
    roles: state === null || state === void 0 || (_state$workforce = state.workforce) === null || _state$workforce === void 0 ? void 0 : _state$workforce.roles
  };
};
var mapDispatchToProps$8 = function mapDispatchToProps(dispatch) {
  return _objectSpread$y(_objectSpread$y({}, bindActionCreators(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({
    fetchApplication: fetchApplication,
    fetchWorkforceDocument: fetchWorkforceDocument,
    fetchDocumentType: fetchDocumentType,
    updateWorkforceDocument: updateWorkforceDocument,
    journalize: journalize,
    coreConfirm: coreConfirm,
    updateApplication: updateApplication,
    createApplicationMovement: createApplicationMovement,
    updateApplicationSummary: updateApplicationSummary
  }, "createApplicationMovement", createApplicationMovement), "createWorkforceDocumentMap", createWorkforceDocumentMap), "fetchRoles", fetchRoles), "testWorkforcePayment", testWorkforcePayment), "fetchUsersByRoleId", fetchUsersByRoleId), dispatch)), {}, {
    dispatch: dispatch
  });
};
var VerifyApplicationPage$1 = withModulesManager(withHistory(connect(mapStateToProps$c, mapDispatchToProps$8)(withStyles(styles$d)(VerifyApplicationPage))));

function _callSuper$c(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$c() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$c() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$c = function _isNativeReflectConstruct() { return !!t; })(); }
var styles$c = function styles(theme) {
  return {
    paper: {
      padding: theme.spacing(1),
      width: 700,
      margin: "0 auto"
    },
    container: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center"
    },
    title: {
      fontSize: "medium",
      fontWeight: "bold"
    },
    fullHeight: {
      height: "100%"
    },
    overrideReadOnly: {
      "& .Mui-disabled": {
        color: "".concat(theme.palette.text.primary, " !important")
      }
    },
    rootGrid: {
      height: 'calc(100vh - 64px)',
      // Adjust if you have AppBar
      overflow: 'hidden'
    },
    leftGrid: {
      position: 'sticky',
      top: 0,
      height: '100%',
      overflowY: 'auto',
      paddingRight: 8
    },
    rightGrid: {
      height: '100%',
      overflowY: 'auto',
      paddingLeft: 8
    },
    cardSpacing: {
      marginBottom: theme.spacing(2)
    }
  };
};
var ActionsApplicationPage = /*#__PURE__*/function (_Component) {
  function ActionsApplicationPage(props) {
    var _props$application;
    var _this;
    _classCallCheck(this, ActionsApplicationPage);
    _this = _callSuper$c(this, ActionsApplicationPage, [props]);
    var mockFiles = [{
      type: "image",
      src: "https://upload.wikimedia.org/wikipedia/commons/b/b9/Smart_NID_Card_%28Bangladesh%29.jpg",
      comment: "Clear image, all info visible.",
      status: "verified"
    }];
    _this.state = {
      applicationType: (props === null || props === void 0 ? void 0 : props.application) || {},
      stateEdited: ((_props$application = props.application) === null || _props$application === void 0 ? void 0 : _props$application.workforceEmployee) || {},
      isSaved: false,
      preview: null,
      comment: "",
      mockFiles: mockFiles,
      fileStates: mockFiles
    };
    return _this;
  }
  _inherits(ActionsApplicationPage, _Component);
  return _createClass(ActionsApplicationPage, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.application !== this.props.application) {
        this.setState({
          stateEdited: this.props.application
        });
      }
      if (prevProps.submittingMutation && !this.props.submittingMutation) {
        this.props.dispatch(journalize(this.props.mutation));
      }
    }
  }, {
    key: "render",
    value: function render() {
      this.props.classes;
      var _this$state = this.state,
        stateEdited = _this$state.stateEdited;
        _this$state.preview;
        _this$state.fileStates;
        _this$state.comment;
        _this$state.applicationType;
      console.log({
        stateEdited: stateEdited
      });
      return /*#__PURE__*/React.createElement(Box$1, {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        bgcolor: "#f0f2f5"
      }, /*#__PURE__*/React.createElement(Box$1, {
        display: "flex",
        alignItems: "flex-start",
        maxWidth: 900,
        p: 2
      }, /*#__PURE__*/React.createElement(Box$1, {
        mr: 2
      }, /*#__PURE__*/React.createElement(Avatar, {
        style: {
          width: 64,
          height: 64
        }
      }, "\uD83D\uDC64")), /*#__PURE__*/React.createElement(Card, {
        style: {
          flex: 1,
          backgroundColor: '#f8f9fc',
          position: 'relative'
        }
      }, /*#__PURE__*/React.createElement(CardContent, null, /*#__PURE__*/React.createElement(Box$1, {
        position: "absolute",
        top: 8,
        right: 8
      }, /*#__PURE__*/React.createElement(IconButton, {
        size: "small"
      }, /*#__PURE__*/React.createElement(PrintIcon, null))), /*#__PURE__*/React.createElement(Typography, {
        variant: "subtitle1",
        style: {
          fontWeight: 'bold',
          marginBottom: 8
        }
      }, "(\u09E7) \u09AA\u09A6\u0995\u09CD\u09B7\u09C7\u09AA: \u09A8\u09A4\u09C1\u09A8 \u0986\u09AC\u09C7\u09A6\u09A8 \u09AA\u09CD\u09B0\u09BE\u09AA\u09CD\u09A4\u09BF"), /*#__PURE__*/React.createElement(Divider, {
        style: {
          marginBottom: 12
        }
      }), /*#__PURE__*/React.createElement(Typography, {
        variant: "body2",
        component: "div",
        gutterBottom: true
      }, "\u0986\u09AC\u09C7\u09A6\u09A8\u0995\u09BE\u09B0\u09C0 \u0995\u09B0\u09CD\u09A4\u09C3\u0995", ' ', /*#__PURE__*/React.createElement(Box$1, {
        component: "span",
        color: "teal",
        fontWeight: "fontWeightMedium"
      }, "\u09AE\u09C0\u09B0 \u09AE\u09CB\u09AB\u09BE\u099C\u09CD\u099C\u09B2 \u09B9\u09CB\u09B8\u09C7\u09A8, \u09AC\u09CD\u09AF\u09AC\u09B8\u09CD\u09A5\u09BE\u09AA\u09A8\u09BE \u09AA\u09B0\u09BF\u099A\u09BE\u09B2\u0995, \u0995\u09C7\u09A8\u09CD\u09A6\u09CD\u09B0\u09C0\u09AF\u09BC \u09A4\u09B9\u09AC\u09BF\u09B2"), ' ', "\u098F\u09B0 \u09A8\u09BF\u0995\u099F \u0986\u09AC\u09C7\u09A6\u09A8 \u09A6\u09BE\u0996\u09BF\u09B2\u0964"), /*#__PURE__*/React.createElement(Typography, {
        variant: "body2",
        color: "textSecondary",
        style: {
          marginTop: 8
        }
      }, "\u09A4\u09BE\u09B0\u09BF\u0996: \u09AC\u09C1\u09A7\u09AC\u09BE\u09B0, \u09E7\u09EB \u09AE\u09C7 \u09E8\u09E6\u09E8\u09EB : \u09E7\u09E8:\u09EB\u09EB \u0985\u09AA\u09B0\u09BE\u09B9\u09CD\u09A8"), /*#__PURE__*/React.createElement(Typography, {
        variant: "subtitle2",
        style: {
          marginTop: 16,
          fontWeight: 'bold'
        }
      }, "\u09AC\u09BF\u09B8\u09CD\u09A4\u09BE\u09B0\u09BF\u09A4"), /*#__PURE__*/React.createElement(Typography, {
        variant: "body2",
        style: {
          marginTop: 4
        }
      }, "\u0986\u09AC\u09C7\u09A6\u09A8\u0995\u09BE\u09B0\u09C0 \u098F\u0995\u099F\u09BF \u09A8\u09A4\u09C1\u09A8 \u0986\u09AC\u09C7\u09A6\u09A8 \u099C\u09AE\u09BE \u09A6\u09BF\u09AF\u09BC\u09C7\u099B\u09C7\u09A8")))));
    }
  }]);
}(Component);
var mapStateToProps$b = function mapStateToProps(state) {
  return {
    application: state.workforce.application
  };
};
var ActionsApplicationPage$1 = connect(mapStateToProps$b)(withStyles(styles$c)(ActionsApplicationPage));

function ownKeys$x(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$x(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$x(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$x(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper$b(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$b() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$b() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$b = function _isNativeReflectConstruct() { return !!t; })(); }
var ApplicationProcessForm = /*#__PURE__*/function (_Component) {
  function ApplicationProcessForm(props) {
    var _this;
    _classCallCheck(this, ApplicationProcessForm);
    _this = _callSuper$b(this, ApplicationProcessForm, [props]);
    _defineProperty(_this, "reload", function () {});
    _defineProperty(_this, "canSave", function () {});
    _defineProperty(_this, "_save", function (ticket) {
      _this.setState({
        lockNew: !ticket.uuid
      }, function () {
        return _this.props.save(ticket);
      });
    });
    _defineProperty(_this, "onEditedChanged", function (ticket) {
      _this.setState({
        ticket: ticket
      });
    });
    _defineProperty(_this, "reopenTicket", function () {
      var _this$props = _this.props,
        intl = _this$props.intl,
        ticket = _this$props.ticket;
      _this.props.reopenTicket(ticket.id, formatMessage(intl, MODULE_NAME, "reopenTicket.mutation.label"));
    });
    _this.state = {
      lockNew: false,
      reset: 0,
      applicationUuid: null,
      ticket: _this._newTicket()
    };
    return _this;
  }
  _inherits(ApplicationProcessForm, _Component);
  return _createClass(ApplicationProcessForm, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.applicationUuid) {
        this.setState(function (state, props) {
          return {
            applicationUuid: props.applicationUuid
          };
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {}
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState, snapshot) {
      if (prevProps.fetchedApplication !== this.props.fetchedApplication && !!this.props.fetchedApplication && !!this.props.organizationEmployee) {
        this.setState(function (state, props) {
          return {
            organizationEmployee: _objectSpread$x({}, props.organizationEmployee),
            applicationUuid: props.organizationEmployee.id,
            lockNew: false
          };
        });
      } else if (prevState.applicationUuid !== this.state.applicationUuid) {
        var filters = ["id: \"".concat(this.state.applicationUuid, "\"")];
        if (this.props.applicationUuid && !this.props.isVerify) {
          this.props.fetchApplication(this.props.modulesManager, filters);
        } else {
          this.props.fetchApplication(this.props.modulesManager, filters);
        }
      } else if (prevProps.submittingMutation && !this.props.submittingMutation) {
        var _this$props2;
        this.props.journalize(this.props.mutation);
        this.setState(function (state) {
          return {
            reset: state.reset + 1
          };
        });
        if ((_this$props2 = this.props) !== null && _this$props2 !== void 0 && (_this$props2 = _this$props2.organizationEmployee) !== null && _this$props2 !== void 0 && _this$props2.id) {
          if (this.props.applicationUuid && !this.props.isVerify) {
            this.props.fetchApplication(this.props.modulesManager, ["id: \"".concat(this.state.applicationUuid, "\"")]);
          } else {
            this.props.fetchApplication(this.props.modulesManager, ["id: \"".concat(this.state.applicationUuid, "\"")]);
          }
        }
      }
    }
  }, {
    key: "_newTicket",
    value: function _newTicket() {
      return {};
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props;
        _this$props3.fetchingTicket;
        var fetchingApplication = _this$props3.fetchingApplication,
        fetchedApplication = _this$props3.fetchedApplication,
        errorTicket = _this$props3.errorTicket,
        save = _this$props3.save,
        back = _this$props3.back,
        isVerify = _this$props3.isVerify,
        isActions = _this$props3.isActions;
      var _this$state = this.state,
        lockNew = _this$state.lockNew,
        reset = _this$state.reset,
        update = _this$state.update,
        overview = _this$state.overview,
        applicationUuid = _this$state.applicationUuid,
        ticket = _this$state.ticket;
      var readOnly = lockNew || !!ticket.validityTo || this.props.readOnly;
      [{
        doIt: this.reopenTicket,
        icon: /*#__PURE__*/React.createElement(LockOpenIcon, null),
        disabled: ticket.isHistory
      }];
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ProgressOrError, {
        progress: fetchingApplication,
        error: errorTicket
      }), (!!fetchedApplication || !applicationUuid) && /*#__PURE__*/React.createElement(Form, {
        module: MODULE_NAME,
        edited_id: applicationUuid,
        edited: ticket,
        reset: reset,
        update: update,
        title: "Workforce Application",
        titleParams: {
          label: "Label"
        },
        back: back,
        save: save ? this._save : null,
        canSave: this.canSave,
        reload: (applicationUuid || readOnly) && this.reload,
        readOnly: readOnly,
        overview: overview,
        Panels: applicationUuid && !isVerify ? [ViewApplicationPage$1] : applicationUuid && isActions ? [ActionsApplicationPage$1] : applicationUuid && isVerify ? [VerifyApplicationPage$1] : [AddApplicationPage$1],
        onEditedChanged: this.onEditedChanged
      }));
    }
  }]);
}(Component); // eslint-disable-next-line no-unused-vars
var mapStateToProps$a = function mapStateToProps(state, props) {
  return {
    rights: !!state.core && !!state.core.user && !!state.core.user.i_user ? state.core.user.i_user.rights : [],
    fetchingTicket: state.workforce.fetchingTicket,
    errorTicket: state.workforce.errorTicket,
    fetchedApplication: state.workforce.fetchedApplication,
    ticket: state.workforce.ticket,
    submittingMutation: state.workforce.submittingMutation,
    mutation: state.workforce.mutation,
    grievanceConfig: state.workforce.grievanceConfig,
    fetchingApplication: state.workforce.fetchingApplication,
    fetchingDocument: state.workforce.fetchingDocument,
    fetchingApplicationMovements: state.workforce.fetchingApplicationMovements
  };
};
var mapDispatchToProps$7 = function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    fetchApplication: fetchApplication,
    journalize: journalize
  }, dispatch);
};
var ApplicationProcessForm$1 = withModulesManager(connect(mapStateToProps$a, mapDispatchToProps$7)(ApplicationProcessForm));

function _callSuper$a(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$a() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$a() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$a = function _isNativeReflectConstruct() { return !!t; })(); }
var styles$b = function styles(theme) {
  return {
    page: theme.page,
    lockedPage: theme.page.locked
  };
};
var ApplicationProcessPage = /*#__PURE__*/function (_Component) {
  function ApplicationProcessPage() {
    var _this;
    _classCallCheck(this, ApplicationProcessPage);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper$a(this, ApplicationProcessPage, [].concat(args));
    _defineProperty(_this, "add", function () {
      historyPush$1(_this.props.modulesManager, _this.props.history, "grievance.route.ticket");
    });
    _defineProperty(_this, "save", function (application) {
      if (!application.id) {
        _this.props.createWorkforceCompany(_this.props.modulesManager, application, "Create");
      } else {
        _this.props.updateWorkforceCompany(_this.props.modulesManager, application, "Update");
      }
    });
    return _this;
  }
  _inherits(ApplicationProcessPage, _Component);
  return _createClass(ApplicationProcessPage, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        classes = _this$props.classes,
        modulesManager = _this$props.modulesManager,
        history = _this$props.history,
        rights = _this$props.rights,
        applicationUuid = _this$props.applicationUuid,
        overview = _this$props.overview,
        organizationVersion = _this$props.organizationVersion,
        user_rights = _this$props.user_rights;
      var readOnly = false;
      var path = this.props.history.location.pathname;
      var isVerify = path.includes("verify");
      path.includes("approve");
      var isActions = path.includes("actions");
      var user_type = getUserTypeFromRights(user_rights);
      return /*#__PURE__*/React.createElement("div", {
        className: "".concat(null, " ").concat(classes.page)
      }, /*#__PURE__*/React.createElement(ApplicationProcessForm$1, {
        overview: overview,
        applicationUuid: applicationUuid,
        organizationVersion: organizationVersion,
        readOnly: readOnly,
        back: function back() {
          return user_type === WORKFORCE_USER_TYPE.ADMIN ? historyPush$1(modulesManager, history, "workforce.route.applications.process") : historyPush$1(modulesManager, history, "route.home");
        },
        add: rights.includes(RIGHT_ORGANIZATION_CREATE) ? this.add : null,
        save: rights.includes(RIGHT_ORGANIZATION_EDIT) ? this.save : null,
        isVerify: isVerify,
        isActions: isActions
      }));
    }
  }]);
}(Component);
var mapStateToProps$9 = function mapStateToProps(state, props) {
  var _state$core;
  return {
    rights: !!state.core && !!state.core.user && !!state.core.user.i_user ? state.core.user.i_user.rights : [],
    applicationUuid: props.match.params.application_uuid,
    organizationVersion: props.match.params.version,
    user_rights: ((_state$core = state.core) === null || _state$core === void 0 || (_state$core = _state$core.user) === null || _state$core === void 0 || (_state$core = _state$core.i_user) === null || _state$core === void 0 ? void 0 : _state$core.rights) || {},
    application: state.workforce.application
  };
};
var mapDispatchToProps$6 = function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    createApplication: createApplication,
    updateApplication: updateApplication
  }, dispatch);
};
var ApplicationProcessPage$1 = withHistory(withModulesManager(connect(mapStateToProps$9, mapDispatchToProps$6)(withTheme(withStyles(styles$b)(ApplicationProcessPage)))));

// import { RESCHEDULE_MEETING_MUTATION } from "../../graphql/mutations";

var RescheduleMeetingDialog = function RescheduleMeetingDialog(_ref) {
  var open = _ref.open,
    onClose = _ref.onClose,
    summaryId = _ref.summaryId,
    onSuccess = _ref.onSuccess;
  var _useState = useState(""),
    _useState2 = _slicedToArray(_useState, 2),
    newDate = _useState2[0],
    setNewDate = _useState2[1];
  var dispatch = useDispatch();
  useModulesManager();
  console.log({
    fromReschedule: summaryId
  });
  // TODO: Uncomment and configure your actual mutation
  /*
  const [rescheduleMeeting, { loading }] = useMutation(RESCHEDULE_MEETING_MUTATION, {
    onCompleted: () => {
      onSuccess(); // Refresh data in parent or show success message
      handleClose();
    },
    onError: (error) => {
      console.error("Error rescheduling meeting:", error);
    }
  });
  */

  // Mock loading state if mutation is commented out
  var loading = false;
  var handleClose = function handleClose() {
    setNewDate(""); // Reset state on close
    onClose();
  };
  var handleSubmit = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var updateApplicationSummaryData;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (newDate) {
              _context.next = 2;
              break;
            }
            return _context.abrupt("return");
          case 2:
            console.log("Submitting mutation for ID: ".concat(summaryId, " with new date: ").concat(newDate));
            updateApplicationSummaryData = {
              id: decodeId(summaryId),
              meetingDate: newDate
            };
            _context.next = 6;
            return dispatch(updateApplicationSummary(updateApplicationSummaryData, "update summary"));
          case 6:
            if (onSuccess) onSuccess();
            handleClose();
          case 8:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function handleSubmit() {
      return _ref2.apply(this, arguments);
    };
  }();
  return /*#__PURE__*/React.createElement(Dialog$1, {
    open: open,
    onClose: handleClose,
    maxWidth: "sm",
    fullWidth: true
  }, /*#__PURE__*/React.createElement(DialogTitle, null, "Reschedule Meeting"), /*#__PURE__*/React.createElement(DialogContent$1, null, /*#__PURE__*/React.createElement(PublishedComponent, {
    pubRef: "workforce.DatePicker",
    label: "workforce.employee.application.meetingDate",
    value: newDate || "",
    onChange: function onChange(e) {
      return setNewDate(e);
    },
    readOnly: false,
    required: true
  })), /*#__PURE__*/React.createElement(DialogActions$1, null, /*#__PURE__*/React.createElement(Button, {
    onClick: handleClose,
    color: "secondary",
    disabled: loading
  }, "Cancel"), /*#__PURE__*/React.createElement(Button, {
    onClick: handleSubmit,
    color: "primary",
    variant: "contained",
    disabled: !newDate || loading
  }, "Submit")));
};

function _callSuper$9(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$9() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$9() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$9 = function _isNativeReflectConstruct() { return !!t; })(); }
function ownKeys$w(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$w(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$w(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$w(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var styles$a = function styles(theme) {
  return _defineProperty(_defineProperty(_defineProperty(_defineProperty({
    page: theme.page,
    fab: _objectSpread$w(_objectSpread$w({}, theme.fab), {}, {
      display: "flex",
      flexDirection: "column"
    })
  }, "page", {
    width: "100%",
    overflowX: "hidden"
  }), "accordion", {
    marginBottom: theme.spacing(1)
  }), "accordionSummary", {
    display: "flex",
    alignItems: "center"
  }), "accordionDetails", {
    padding: theme.spacing(2)
  });
};
var ApplicationSummaryPage = /*#__PURE__*/function (_Component) {
  function ApplicationSummaryPage(props) {
    var _this;
    _classCallCheck(this, ApplicationSummaryPage);
    _this = _callSuper$9(this, ApplicationSummaryPage, [props]);
    // ADDED: Handlers for Reschedule Dialog
    _defineProperty(_this, "handleOpenReschedule", function (event, id) {
      event.stopPropagation(); // Prevents the accordion from expanding/collapsing
      _this.setState({
        rescheduleDialogOpen: true,
        selectedRescheduleId: id
      });
    });
    _defineProperty(_this, "handleCloseReschedule", function () {
      _this.setState({
        rescheduleDialogOpen: false,
        selectedRescheduleId: null
      }, function () {
        // This callback runs AFTER the state is updated
        var _this$props = _this.props,
          modulesManager = _this$props.modulesManager,
          fetchSummaryApplications = _this$props.fetchSummaryApplications;
        fetchSummaryApplications(modulesManager);
      });
    });
    _defineProperty(_this, "handleRescheduleSuccess", function () {
      var _this$props2 = _this.props,
        modulesManager = _this$props2.modulesManager,
        fetchSummaryApplications = _this$props2.fetchSummaryApplications;
      // Refresh the data
      fetchSummaryApplications(modulesManager);
      // Close the dialog automatically after success
      _this.handleCloseReschedule();
    });
    _defineProperty(_this, "handleCloseBFTN", function () {
      _this.setState({
        openGenerateBFTN: false
      });
    });
    _defineProperty(_this, "handleOpenBFTN", function () {
      _this.setState({
        openGenerateBFTN: true
      });
    });
    _defineProperty(_this, "onDoubleClick", function (application) {
      var newTab = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var routeParams = ["workforce.route.application", [decodeId(application.id)]];
      if (application !== null && application !== void 0 && application.isHistory) {
        routeParams[1].push(application.version);
      }
      historyPush$1.apply(void 0, [_this.props.modulesManager, _this.props.history].concat(routeParams, [newTab]));
    });
    _defineProperty(_this, "onAdd", function () {
      historyPush$1(_this.props.modulesManager, _this.props.history, "workforce.route.application");
    });
    _defineProperty(_this, "handleChange", function (event, newValue) {
      _this.setState({
        value: newValue
      }, function () {
        console.log("Current tab index:", _this.state.value);
      });
    });
    _defineProperty(_this, "handleAccordionChange", function (panelId) {
      return function (event, isExpanded) {
        _this.setState(function (prev) {
          if (isExpanded) {
            var _this2 = _this,
              renderSummaryData = _this2.renderSummaryData;
            var reordered = [renderSummaryData.find(function (i) {
              return i.id === panelId;
            })].concat(_toConsumableArray(renderSummaryData.filter(function (i) {
              return i.id !== panelId;
            })));
            return {
              expanded: panelId,
              reorderedData: reordered
            };
          } else {
            return {
              expanded: null,
              reorderedData: null
            };
          }
        });
      };
    });
    _this.state = {
      value: props.value || 0,
      openGenerateBFTN: false,
      expanded: null,
      reorderedData: null,
      // ADDED: State for Reschedule Dialog
      rescheduleDialogOpen: false,
      selectedRescheduleId: null,
      isLoading: true
    };
    return _this;
  }
  _inherits(ApplicationSummaryPage, _Component);
  return _createClass(ApplicationSummaryPage, [{
    key: "a11yProps",
    value: function a11yProps(index) {
      return {
        id: "simple-tab-".concat(index),
        "aria-controls": "simple-tabpanel-".concat(index)
      };
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this3 = this;
      var _this$props3 = this.props,
        modulesManager = _this$props3.modulesManager,
        fetchSummaryApplications = _this$props3.fetchSummaryApplications;
      Promise.resolve(fetchSummaryApplications(modulesManager))["finally"](function () {
        return _this3.setState({
          isLoading: false
        });
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.state.isLoading && prevProps.summaryData !== this.props.summaryData) {
        this.setState({
          isLoading: false
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;
      var _this$props4 = this.props,
        classes = _this$props4.classes,
        rights = _this$props4.rights,
        applications = _this$props4.applications,
        summaryData = _this$props4.summaryData,
        loggedInUserId = _this$props4.loggedInUserId,
        status = _this$props4.status,
        _this$props4$disableB = _this$props4.disableButtons,
        disableButtons = _this$props4$disableB === void 0 ? 0 : _this$props4$disableB,
        isLoading = _this$props4.isLoading;
      // EXTRACTED new state variables
      var _this$state = this.state;
        _this$state.value;
        var openGenerateBFTN = _this$state.openGenerateBFTN,
        expanded = _this$state.expanded,
        reorderedData = _this$state.reorderedData,
        rescheduleDialogOpen = _this$state.rescheduleDialogOpen,
        selectedRescheduleId = _this$state.selectedRescheduleId;
      var renderSummaryData = [];
      var currentUserType = getUserTypeFromRights(rights);
      if (currentUserType === WORKFORCE_USER_TYPE.DIRECTOR) {
        if (status === "pending") {
          renderSummaryData = summaryData.filter(function (item) {
            return item.status === "forward_to_director" && (isBlwfPath() ? item.organizationType = "blwf" : item.organizationType === "cf");
          });
        } else if (status === "rejected") {
          renderSummaryData = summaryData.filter(function (item) {
            return item.status === "rejected" && (isBlwfPath() ? item.organizationType = "blwf" : item.organizationType === "cf");
          });
        } else if (status === "approved") {
          renderSummaryData = summaryData.filter(function (item) {
            return (item.status === "forward_to_dg" || item.status === "approved_by_dg" || item.status === "approved_by_secretary" || (item === null || item === void 0 ? void 0 : item.status) === "approved_by_minister") && (isBlwfPath() ? item.organizationType = "blwf" : item.organizationType === "cf");
          });
        }
      } else if (currentUserType === WORKFORCE_USER_TYPE.BLWF_DIRECTOR) {
        if (status === "pending") {
          renderSummaryData = summaryData.filter(function (item) {
            return item.status === "forward_to_director" && item.organizationType === "blwf";
          });
        } else if (status === "rejected") {
          renderSummaryData = summaryData.filter(function (item) {
            return item.status === "rejected" && item.organizationType === "blwf";
          });
        } else if (status === "approved") {
          renderSummaryData = summaryData.filter(function (item) {
            return (item.status === "forward_to_dg" || item.status === "approved_by_director" || item.status === "approved_by_dg" || (item === null || item === void 0 ? void 0 : item.status) === "approved_by_secretary" || (item === null || item === void 0 ? void 0 : item.status) === "approved_by_minister") && item.organizationType === "blwf";
          });
        }
      } else if (currentUserType === WORKFORCE_USER_TYPE.ADMIN) {
        if (status === "pending") {
          renderSummaryData = summaryData.filter(function (item) {
            return item.status === "approved_by_director";
          });
        } else if (status === "rejected") {
          renderSummaryData = summaryData.filter(function (item) {
            return item.status === "rejected";
          });
        } else if (status === "approved") {
          renderSummaryData = summaryData.filter(function (item) {
            return item.status === "approved_by_dg" || (item === null || item === void 0 ? void 0 : item.status) === "approved_by_secretary" || (item === null || item === void 0 ? void 0 : item.status) === "approved_by_minister";
          });
        }
      } else if (currentUserType === WORKFORCE_USER_TYPE.EIS_ADVISOR) {
        if (status === "pending") {
          renderSummaryData = summaryData.filter(function (item) {
            return (item.status === "forward_to_eis_advisor" || item.status === "meeting_created") && item.organizationType === "eis";
          });
        } else if (status === "rejected") {
          renderSummaryData = summaryData.filter(function (item) {
            return item.status === "rejected" && item.organizationType === "eis";
          });
        } else if (status === "approved") {
          renderSummaryData = summaryData.filter(function (item) {
            return (item.status === "approved_by_eis_director" || item.status === "approved_by_eis_advisor") && item.organizationType === "eis";
          });
        }
      } else if (currentUserType === WORKFORCE_USER_TYPE.SECRETARY) {
        if (status === "pending") {
          renderSummaryData = summaryData.filter(function (item) {
            return item.status === "approved_by_dg";
          });
        } else if (status === "rejected") {
          renderSummaryData = summaryData.filter(function (item) {
            return item.status === "rejected";
          });
        } else if (status === "approved") {
          renderSummaryData = summaryData.filter(function (item) {
            return item.status === "approved_by_secretary";
          });
        }
      } else if (currentUserType === WORKFORCE_USER_TYPE.MINISTER) {
        if (status === "pending") {
          renderSummaryData = summaryData.filter(function (item) {
            return item.status === "approved_by_secretary";
          });
        } else if (status === "rejected") {
          renderSummaryData = summaryData.filter(function (item) {
            return item.status === "rejected";
          });
        } else if (status === "approved") {
          renderSummaryData = summaryData.filter(function (item) {
            return item.status === "approved_by_minister";
          });
        }
      }
      this.renderSummaryData = renderSummaryData;
      var dataToRender = reorderedData || renderSummaryData;
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Grid, {
        container: true,
        spacing: 2
      }, isLoading ? /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12,
        style: {
          display: "flex",
          justifyContent: "center",
          marginTop: "20px"
        }
      }, /*#__PURE__*/React.createElement(CircularProgress$1, null)) : dataToRender.length === 0 && /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12
      }, /*#__PURE__*/React.createElement(Typography, {
        variant: "h6",
        align: "center",
        style: {
          marginTop: "20px"
        }
      }, "No Records Found")), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12
      }, dataToRender.map(function (item, index) {
        return /*#__PURE__*/React.createElement(Accordion, {
          key: index,
          expanded: expanded === item.id,
          onChange: _this4.handleAccordionChange(item.id),
          className: classes.accordion
        }, /*#__PURE__*/React.createElement(AccordionSummary, {
          className: classes.accordionSummary,
          expandIcon: /*#__PURE__*/React.createElement(ExpandMoreIcon, {
            className: "material-icons"
          })
        }, /*#__PURE__*/React.createElement(Typography, {
          variant: "subtitle1",
          style: {
            flex: 1
          }
        }, /*#__PURE__*/React.createElement("strong", null, item.name)), /*#__PURE__*/React.createElement(Typography, {
          variant: "body2",
          style: {
            marginLeft: "auto",
            color: "#015C63",
            display: "flex",
            alignItems: "center"
          }
        }, item.meetingDate, " | ", item.month, " ", item.year, currentUserType === WORKFORCE_USER_TYPE.EIS_ADVISOR && /*#__PURE__*/React.createElement(Button, {
          variant: "outlined",
          size: "small",
          color: "primary",
          style: {
            marginLeft: "16px"
          },
          onClick: function onClick(e) {
            return _this4.handleOpenReschedule(e, item.id);
          } // CHANGED: Calls our new handler
        }, "Reschedule"))), /*#__PURE__*/React.createElement(AccordionDetails, {
          className: classes.accordionDetails
        }, /*#__PURE__*/React.createElement(Card, {
          style: {
            width: "100%"
          }
        }, /*#__PURE__*/React.createElement(CardContent, null, expanded === item.id && /*#__PURE__*/React.createElement(ApplicationProcessSearcher$1, {
          summaryId: item === null || item === void 0 ? void 0 : item.id,
          cacheFiltersKey: "pending",
          onDoubleClick: _this4.onDoubleClick,
          loggedInUserId: loggedInUserId,
          disableButtons: disableButtons,
          status: status
        })))));
      }), /*#__PURE__*/React.createElement(GenerateBFTN, {
        open: openGenerateBFTN,
        onClose: this.handleCloseBFTN,
        applications: applications,
        userRights: rights
      }), /*#__PURE__*/React.createElement(RescheduleMeetingDialog, {
        open: rescheduleDialogOpen,
        onClose: this.handleCloseReschedule,
        summaryId: selectedRescheduleId,
        onSuccess: this.handleRescheduleSuccess
      }))));
    }
  }]);
}(Component);
var mapStateToProps$8 = function mapStateToProps(state) {
  var _state$workforce$appl, _state$core;
  return {
    rights: !!state.core && !!state.core.user && !!state.core.user.i_user ? state.core.user.i_user.rights : [],
    applications: state.workforce.applications,
    summaryData: (_state$workforce$appl = state.workforce.applicationsSummary) !== null && _state$workforce$appl !== void 0 ? _state$workforce$appl : [],
    loggedInUserId: (_state$core = state.core) === null || _state$core === void 0 || (_state$core = _state$core.user) === null || _state$core === void 0 || (_state$core = _state$core.i_user) === null || _state$core === void 0 ? void 0 : _state$core.id
  };
};
var mapDispatchToProps$5 = function mapDispatchToProps(dispatch) {
  return {
    fetchSummaryApplications: function fetchSummaryApplications$1(modulesManager) {
      return dispatch(fetchSummaryApplications(modulesManager, ""));
    }
  };
};
var ApplicationSummaryPage$1 = withModulesManager(withHistory(connect(mapStateToProps$8, mapDispatchToProps$5)(withTheme(withStyles(styles$a)(ApplicationSummaryPage)))));

var useStyles$D = makeStyles(function (theme) {
  return {
    modalContainer: {
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      width: '80%',
      maxHeight: "90vh",
      backgroundColor: theme.palette.background.paper,
      borderRadius: theme.spacing(1.5),
      boxShadow: theme.shadows[5],
      padding: theme.spacing(4),
      overflowY: "auto"
    },
    closeButton: {
      position: "absolute",
      top: theme.spacing(1),
      right: theme.spacing(1),
      minWidth: 0,
      padding: theme.spacing(0.5, 1),
      fontSize: "1.2rem"
    },
    sectionPaper: {
      padding: theme.spacing(2),
      marginBottom: theme.spacing(3),
      borderRadius: theme.spacing(1),
      backgroundColor: theme.palette.grey[50]
    },
    buttonGroup: {
      marginTop: theme.spacing(3),
      display: "flex",
      justifyContent: "flex-end",
      gap: theme.spacing(2)
    },
    responseMessage: {
      marginBottom: theme.spacing(2),
      fontWeight: 600
    }
  };
});
var AgingReportModal = function AgingReportModal(_ref) {
  var _data$type;
  var open = _ref.open,
    onClose = _ref.onClose,
    data = _ref.data,
    organizationType = _ref.organizationType;
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    thisApplicationType = _useState2[0],
    setThisApplicationType = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    thisOrganizationType = _useState4[0],
    setThisOrganizationType = _useState4[1];
  var classes = useStyles$D();
  var dispatch = useDispatch();
  var _useState5 = useState([]),
    _useState6 = _slicedToArray(_useState5, 2),
    barData = _useState6[0],
    setBarData = _useState6[1];
  var _useState7 = useState(null),
    _useState8 = _slicedToArray(_useState7, 2);
    _useState8[0];
    var setSelectedDay = _useState8[1];
  var _useState9 = useState([]),
    _useState10 = _slicedToArray(_useState9, 2),
    tableData = _useState10[0],
    setTableData = _useState10[1];
  var _useState11 = useState(''),
    _useState12 = _slicedToArray(_useState11, 2),
    tableSectionHeading = _useState12[0],
    setTableSectionHeading = _useState12[1];
  useEffect(function () {
    function fetchData() {
      return _fetchData.apply(this, arguments);
    }
    function _fetchData() {
      _fetchData = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var res, applicationType, dayWiseCount;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              setTableData([]);
              setThisOrganizationType(organizationType);
              _context.prev = 2;
              res = null;
              applicationType = [];
              if (organizationType === 'cf' && data.appType) {
                if (data.appType === 'medical') applicationType = ['medicalAssistance'];else if (data.appType === 'death') applicationType = ['financialAssistance'];else if (data.appType === 'educational') applicationType = ['scholarship'];else if (data.appType === 'maternityGrant') applicationType = ['maternityGrant'];else if (data.appType === 'disabilityAssistance') applicationType = ['disabilityAssistance'];
              } else if (organizationType === 'blwf' && data.appType) {
                if (data.appType === 'medical') applicationType = ['medicalDonation'];else if (data.appType === 'death') applicationType = ['deadlyGrant'];else if (data.appType === 'educational') applicationType = ['educationGrant'];else if (data.appType === 'maternityGrant') applicationType = ['maternityGrant'];
              } else {
                if (data.appType === 'medical' && data.appType) applicationType = ['medicalAssistance', 'medicalDonation'];else if (data.appType === 'death' && data.appType) applicationType = ['financialAssistance', 'deadlyGrant'];else if (data.appType === 'educational' && data.appType) applicationType = ['scholarship', 'educationGrant'];else if (data.appType === 'maternityGrant' && data.appType) applicationType = ['maternityGrant'];else if (data.appType === 'disabilityAssistance' && data.appType) applicationType = ['disabilityAssistance'];
              }
              setThisApplicationType(applicationType);
              _context.next = 9;
              return dispatch(fetchApplicationTimeWiseMatrix(organizationType, applicationType, null)).then(function (response) {
                var _response$payload;
                res = ((_response$payload = response.payload) === null || _response$payload === void 0 || (_response$payload = _response$payload.data) === null || _response$payload === void 0 ? void 0 : _response$payload.workforceApplicationTimewiseMatrix) || [];
              });
            case 9:
              dayWiseCount = res.dayWiseCount || {};
              setBarData([{
                days: "১ দিন",
                applications: dayWiseCount.day1,
                color: "#1ba000ff",
                dayCount: "1"
              }, {
                days: "৩ দিন",
                applications: dayWiseCount.day3,
                color: "#87c067ff",
                dayCount: "3"
              }, {
                days: "৭ দিন",
                applications: dayWiseCount.day7,
                color: "#cfbb00ff",
                dayCount: "7"
              }, {
                days: "১০ দিন",
                applications: dayWiseCount.day10,
                color: "#c4811cff",
                dayCount: "10"
              }, {
                days: "১৫ দিন",
                applications: dayWiseCount.day15,
                color: "#c20000ff",
                dayCount: "15"
              }, {
                days: "১৫ এর অধিক দিন",
                applications: dayWiseCount.moreThan15,
                color: "#4e0000ff",
                dayCount: "15+"
              }]);
              _context.next = 16;
              break;
            case 13:
              _context.prev = 13;
              _context.t0 = _context["catch"](2);
              console.log(_context.t0);
            case 16:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[2, 13]]);
      }));
      return _fetchData.apply(this, arguments);
    }
    fetchData();
  }, [open]);

  // When user clicks a bar
  var handleBarClick = function handleBarClick(dataItem) {
    console.log("Bar clicked:", dataItem);
    var res = null;
    var roleWiseCount = [];
    dispatch(fetchApplicationTimeWiseMatrix(thisOrganizationType, thisApplicationType, dataItem.dayCount)).then(function (response) {
      var _response$payload2;
      res = ((_response$payload2 = response.payload) === null || _response$payload2 === void 0 || (_response$payload2 = _response$payload2.data) === null || _response$payload2 === void 0 ? void 0 : _response$payload2.workforceApplicationTimewiseMatrix) || [];
      roleWiseCount = res.roleWiseCount || [];
      var buildData = [];
      roleWiseCount.forEach(function (item) {
        var tempitem = {
          user: (item === null || item === void 0 ? void 0 : item.otherNames) + ' (' + item.roleName + ')',
          applications: item === null || item === void 0 ? void 0 : item.applicationCount
        };
        buildData.push(tempitem);
      });
      setSelectedDay(dataItem.dayCount);
      setTableSectionHeading("".concat(dataItem.days, " \u09A7\u09B0\u09C7 \u09AA\u09CD\u09B0\u0995\u09CD\u09B0\u09BF\u09DF\u09BE\u09A7\u09C0\u09A8\u09B0\u09A4 \u0986\u09AC\u09C7\u09A6\u09A8\u09C7\u09B0 \u0985\u09AC\u09B8\u09CD\u09A5\u09BE\u09A8\u09B8\u09AE\u09C2\u09B9"));
      setTableData(buildData);
    });
  };
  return /*#__PURE__*/React.createElement(Modal, {
    open: open,
    onClose: onClose
  }, /*#__PURE__*/React.createElement("form", {
    className: classes.modalContainer
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: onClose,
    className: classes.closeButton
  }, "\u2715"), /*#__PURE__*/React.createElement(Typography, {
    variant: "h5",
    gutterBottom: true,
    style: {
      fontWeight: "bold",
      marginTop: 3,
      textAlign: "center"
    }
  }, (_data$type = data === null || data === void 0 ? void 0 : data.type) !== null && _data$type !== void 0 ? _data$type : '', " \u0986\u09AC\u09C7\u09A6\u09A8\u09C7\u09B0 \u09AA\u09CD\u09B0\u0995\u09CD\u09B0\u09BF\u09DF\u09BE\u09A7\u09C0\u09A8\u09B0\u09A4 \u09B8\u09AE\u09DF \u09AD\u09BF\u09A4\u09CD\u09A4\u09BF\u0995 \u09AA\u09CD\u09B0\u09A4\u09BF\u09AC\u09C7\u09A6\u09A8"), /*#__PURE__*/React.createElement(Divider, {
    style: {
      marginBottom: 15
    }
  }), /*#__PURE__*/React.createElement(Paper, {
    className: classes.sectionPaper,
    elevation: 1
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    md: tableData.length > 0 ? 6 : 12,
    xs: tableData.length > 0 ? 6 : 12
  }, /*#__PURE__*/React.createElement(ResponsiveContainer, {
    width: "100%",
    height: 300
  }, /*#__PURE__*/React.createElement(BarChart, {
    data: barData,
    layout: "vertical",
    margin: {
      top: 20,
      right: 30,
      left: 50,
      bottom: 5
    },
    onClick: function onClick(e) {
      if (e && e.activeLabel) {
        handleBarClick(e.activePayload[0].payload);
      }
    }
  }, /*#__PURE__*/React.createElement(CartesianGrid, {
    strokeDasharray: "3 3"
  }), /*#__PURE__*/React.createElement(XAxis, {
    type: "number"
  }), /*#__PURE__*/React.createElement(YAxis, {
    dataKey: "days",
    type: "category"
  }), /*#__PURE__*/React.createElement(Tooltip$1, null), /*#__PURE__*/React.createElement(Bar, {
    dataKey: "applications",
    radius: [0, 8, 8, 0]
  }, barData.map(function (entry, index) {
    return /*#__PURE__*/React.createElement(Cell, {
      key: "cell-".concat(index),
      fill: entry.color,
      cursor: "pointer"
    });
  }))))), tableData.length > 0 && /*#__PURE__*/React.createElement(Grid, {
    item: true,
    md: 6,
    xs: 6
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6",
    gutterBottom: true,
    style: {
      fontWeight: 'bold',
      textAlign: 'center',
      marginBottom: 10
    }
  }, tableSectionHeading), /*#__PURE__*/React.createElement(Table$2, {
    size: "small"
  }, /*#__PURE__*/React.createElement(TableHead, null, /*#__PURE__*/React.createElement(TableRow, null, /*#__PURE__*/React.createElement(TableCell, {
    style: {
      fontWeight: 'bold'
    }
  }, "\u09AC\u09CD\u09AF\u09AC\u09B9\u09BE\u09B0\u0995\u09BE\u09B0\u09C0"), /*#__PURE__*/React.createElement(TableCell, {
    align: "right",
    style: {
      fontWeight: 'bold'
    }
  }, "\u0985\u09AA\u09C7\u0995\u09CD\u09B7\u09AE\u09BE\u09A8 \u0986\u09AC\u09C7\u09A6\u09A8\u09C7\u09B0 \u09B8\u0982\u0996\u09CD\u09AF\u09BE"))), /*#__PURE__*/React.createElement(TableBody, null, tableData.map(function (row, idx) {
    return /*#__PURE__*/React.createElement(TableRow, {
      key: idx
    }, /*#__PURE__*/React.createElement(TableCell, null, row.user), /*#__PURE__*/React.createElement(TableCell, {
      align: "right"
    }, Number(row.applications).toLocaleString('bn')));
  }))))))));
};

function ownKeys$v(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$v(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$v(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$v(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var useStyles$C = makeStyles(function (theme) {
  return {
    root: {
      flexGrow: 1,
      padding: theme.spacing(2),
      height: "fit-content",
      // assuming 64px header/appbar, adjust as needed
      overflow: "visible"
    },
    sidebar: {
      position: "sticky",
      top: 85,
      height: "50vh"
    },
    content: {
      height: "fit-content",
      padding: theme.spacing(2)
    },
    tableContainer: {
      marginTop: theme.spacing(0)
    },
    tableHeadCell: {
      fontWeight: "bold"
    },
    noData: {
      textAlign: "center",
      padding: theme.spacing(2)
    },
    searchInput: {
      border: "1px solid #ccc",
      borderRadius: 4,
      padding: "4px 8px",
      width: 200
    },
    pagination: {
      display: "flex",
      justifyContent: "flex-end",
      marginTop: theme.spacing(2),
      alignItems: "center"
    },
    tableHeader: {
      backgroundColor: "#B7D4D8"
    },
    accordion: {
      boxShadow: "1px 1px 1px 1px",
      border: "none",
      backgroundColor: "white",
      marginBottom: "12px",
      borderRadius: "6px",
      "&::before": {
        display: "none"
      }
    },
    accordionPadding: {
      paddingBottom: "40px !important"
    },
    accordionSummary: {
      padding: "8px 16px",
      backgroundColor: "white",
      borderRadius: "6px",
      "& .MuiTypography-root": {
        color: "#015C63",
        // teal-like tone
        fontWeight: 600
      }
    },
    accordionDetails: {
      backgroundColor: "white",
      padding: "16px",
      borderTop: "1px solid #ddd"
    },
    item: {
      display: "flex",
      alignItems: "center",
      gap: theme.spacing(0.5),
      cursor: "pointer",
      padding: "7px",
      borderRadius: "10px",
      "&:hover": {
        backgroundColor: "#517688",
        color: "#fff"
      }
    }
  };
});
var ReturnedApplications$d = function ReturnedApplications() {
  var classes = useStyles$C();
  var loggedInUserId = useSelector(function (state) {
    var _state$core;
    return (_state$core = state.core) === null || _state$core === void 0 || (_state$core = _state$core.user) === null || _state$core === void 0 || (_state$core = _state$core.i_user) === null || _state$core === void 0 ? void 0 : _state$core.id;
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ApplicationProcessSearcher$1, {
    returnedApplications: true,
    loggedInUserId: loggedInUserId,
    disableButtons: 1,
    dynamicTableTitle: "workforce.application.returned"
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.pagination
  }, /*#__PURE__*/React.createElement(Button, null, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.back"
  })), /*#__PURE__*/React.createElement(Button, null, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.next"
  }))));
};
var RejectApplication$8 = function RejectApplication() {
  var classes = useStyles$C();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ApplicationProcessSearcher$1, {
    rejectedApplication: true,
    dynamicTableTitle: "workforce.application.rejectedApplication"
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.pagination
  }, /*#__PURE__*/React.createElement(Button, null, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.back"
  })), /*#__PURE__*/React.createElement(Button, null, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.next"
  }))));
};
var Dashboard$5 = function Dashboard() {
  var _reduxState$core;
  var dispatch = useDispatch();
  var theme = useTheme();
  useHistory();
  var user_type = getUserType();
  var reduxState = useSelector(function (state) {
    return state;
  });
  var locale = (reduxState === null || reduxState === void 0 || (_reduxState$core = reduxState.core) === null || _reduxState$core === void 0 || (_reduxState$core = _reduxState$core.user) === null || _reduxState$core === void 0 || (_reduxState$core = _reduxState$core.i_user) === null || _reduxState$core === void 0 ? void 0 : _reduxState$core.language) || 'en';
  var thisuser = useSelector(function (state) {
    var _state$core2;
    return (_state$core2 = state.core) === null || _state$core2 === void 0 || (_state$core2 = _state$core2.user) === null || _state$core2 === void 0 ? void 0 : _state$core2.i_user;
  });
  console.log('ei holo tor user', thisuser);
  var applicationTypeNames = locale == 'en' ? APP_TYPE_DASHBOARD_EN : APP_TYPE_DASHBOARD_BN;
  var applicantTypeNames = locale == 'en' ? APPLICANT_TYPE_EN : APPLICANT_TYPE_BN;
  var buttonOptions = {};
  if (locale == 'fr') {
    buttonOptions = {
      1: "১ মাস",
      3: "৩ মাস",
      6: "৬ মাস",
      12: "১২ মাস"
    };
  } else {
    buttonOptions = {
      1: "1 Month",
      3: "3 Months",
      6: "6 Months",
      12: "12 Months"
    };
  }
  var getMonthName = function getMonthName(index) {
    var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "en-US";
    var date = new Date(2000, index, 1);
    return date.toLocaleString(locale, {
      month: "long"
    });
  };
  var getBanglaDate = function getBanglaDate(dateStr) {
    var date = new Date(dateStr);
    return date.toLocaleDateString('bn-BD');
  };
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    months = _useState2[0],
    setMonths = _useState2[1];
  var _useState3 = useState(""),
    _useState4 = _slicedToArray(_useState3, 2),
    monthString = _useState4[0],
    setMonthString = _useState4[1];
  var _useState5 = useState(locale == 'fr' ? "সব" : "All"),
    _useState6 = _slicedToArray(_useState5, 2),
    filter = _useState6[0],
    setFilter = _useState6[1];
  var _useState7 = useState(""),
    _useState8 = _slicedToArray(_useState7, 2),
    fromDate = _useState8[0],
    setFromDate = _useState8[1];
  var _useState9 = useState(""),
    _useState10 = _slicedToArray(_useState9, 2),
    fromDateString = _useState10[0],
    setFromDateString = _useState10[1];
  var _useState11 = useState(""),
    _useState12 = _slicedToArray(_useState11, 2),
    toDate = _useState12[0],
    setToDate = _useState12[1];
  var _useState13 = useState(locale == "fr" ? " আজ পর্যন্ত" : " To Date"),
    _useState14 = _slicedToArray(_useState13, 2),
    toDateString = _useState14[0],
    setToDateString = _useState14[1];
  var _useState15 = useState(locale == 'fr' ? "সকল তহবিল" : "All Funds"),
    _useState16 = _slicedToArray(_useState15, 2),
    organizationName = _useState16[0],
    setOrganizationName = _useState16[1];
  var _useState17 = useState(6),
    _useState18 = _slicedToArray(_useState17, 2),
    graphMonths = _useState18[0],
    setGraphMonths = _useState18[1];
  var _useState19 = useState(""),
    _useState20 = _slicedToArray(_useState19, 2),
    graphFromDate = _useState20[0],
    setGraphFromDate = _useState20[1];
  var _useState21 = useState(""),
    _useState22 = _slicedToArray(_useState21, 2),
    graphToDate = _useState22[0],
    setGraphToDate = _useState22[1];
  var handleFilter = function handleFilter(f) {
    setFilter(f);
    if (f === (locale == 'fr' ? "সব" : "All") || f == "") {
      setOrganizationName(locale == 'fr' ? "সকল তহবিল" : "All Funds");
    } else if (f === "CF") {
      setOrganizationName(locale == 'fr' ? "কেন্দ্রীয় তহবিল" : "Central Fund");
    } else if (f === "BLWF") {
      setOrganizationName(locale == 'fr' ? "বাংলাদেশ শ্রমিক কল্যাণ ফাউন্ডেশন" : "Bangladesh Labour Welfare Foundation");
    } else if (f === "EIS") {
      setOrganizationName(locale == 'fr' ? "এমপ্লয়ি ইন্জুরি স্কিম" : "Employee Injury Scheme");
    }
  };
  var handleMonthChange = function handleMonthChange(month) {
    setMonths(month);
    if (locale == 'fr') {
      setMonthString("সর্বশেষ " + Number(month).toLocaleString("bn-BD") + " মাসের তথ্য");
    } else {
      setMonthString("Last " + month + " Month(s) Data");
    }
  };
  var handleFromDateChange = function handleFromDateChange(date) {
    setFromDate(date);
    if (locale == 'fr') {
      var datestr = getBanglaDate(date);
      datestr += ' হতে ';
      setFromDateString(datestr);
    } else {
      setFromDateString("From " + date);
    }
  };
  var handleToDateChange = function handleToDateChange(date) {
    setToDate(date);
    if (locale == 'fr') {
      var datestr = getBanglaDate(date);
      setToDateString(datestr + " পর্যন্ত");
    } else {
      setToDateString(" To " + date);
    }
  };
  useEffect(function () {
    if (months > 0) {
      setFromDate("");
      setToDate("");
    }
  }, [months]);
  useEffect(function () {
    setMonths(0);
    setMonthString("");
  }, [fromDate, toDate]);
  var handleGraphMonthChange = function handleGraphMonthChange(month) {
    setGraphMonths(month);
    setGraphFromDate("");
    setGraphToDate("");
  };
  var _useState23 = useState([]),
    _useState24 = _slicedToArray(_useState23, 2),
    tableRows = _useState24[0],
    setTableRows = _useState24[1];
  var _useState25 = useState({
      total: 0,
      approved: 0,
      cancelled: 0,
      processing: 0
    }),
    _useState26 = _slicedToArray(_useState25, 2),
    totals = _useState26[0],
    setTotals = _useState26[1];
  var _useState27 = useState([]),
    _useState28 = _slicedToArray(_useState27, 2),
    pendingApplicationTypes = _useState28[0],
    setPendingApplicationTypes = _useState28[1];
  var _useState29 = useState([]),
    _useState30 = _slicedToArray(_useState29, 2),
    applicationTypes = _useState30[0],
    setApplicationTypes = _useState30[1];
  var _useState31 = useState([]),
    _useState32 = _slicedToArray(_useState31, 2),
    applicationCounts = _useState32[0],
    setApplicationCounts = _useState32[1];
  var _useState33 = useState(0),
    _useState34 = _slicedToArray(_useState33, 2),
    totalBenefitAmount = _useState34[0],
    setTotalBenefitAmount = _useState34[1];
  var _useState35 = useState([]),
    _useState36 = _slicedToArray(_useState35, 2),
    pieData = _useState36[0],
    setPieData = _useState36[1];
  var _useState37 = useState([]),
    _useState38 = _slicedToArray(_useState37, 2),
    barData = _useState38[0],
    setBarData = _useState38[1];
  useEffect(function () {
    function loadData() {
      return _loadData.apply(this, arguments);
    }
    function _loadData() {
      _loadData = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var orgType, res, rows, appTypes, pendingAppTypes, totalsCalc, approvedTotal, cancelledTotal, processingTotal, genderRes, _applicationCounts;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              orgType = filter === "সব" || filter === "All" ? "" : filter.toLowerCase();
              console.log(orgType);
              res = [];
              _context.next = 6;
              return dispatch(fetchApplicationByDate(months, fromDate, toDate, orgType)).then(function (response) {
                var _response$payload;
                res = ((_response$payload = response.payload) === null || _response$payload === void 0 || (_response$payload = _response$payload.data) === null || _response$payload === void 0 ? void 0 : _response$payload.workforceApplicationMatrix) || [];
              });
            case 6:
              // Map API response to table structure
              rows = [];
              res.forEach(function (item) {
                var type = item.applicationType;
                var allow = false;
                if (orgType === "blwf") {
                  // include all except disabilityAssistance
                  allow = type !== "disabilityAssistance";
                } else if (orgType === "eis") {
                  // include only disabilityAssistance and financialAssistance
                  allow = ["disabilityAssistance", "financialAssistance", "death"].includes(type);
                } else {
                  // include all
                  allow = true;
                }
                if (allow) {
                  rows.push({
                    type: applicationTypeNames[type],
                    total: Number(item.applicationCount),
                    approved: Number(item.approvedCount),
                    cancelled: Number(item.rejectedCount),
                    processing: Number(item.applicationCount) - (Number(item.approvedCount) + Number(item.rejectedCount))
                  });
                } else {
                  console.log("Skipping", type, "for org:", orgType);
                }
              });
              // const rows = res.map((item) => ({
              //   type: applicationTypeNames[item.applicationType],
              //   total: Number(item.applicationCount),
              //   approved: Number(item.approvedCount),
              //   cancelled: Number(item.rejectedCount),
              //   processing: Number(item.applicationCount) - (Number(item.approvedCount) + Number(item.rejectedCount)),
              // }));
              appTypes = [];
              pendingAppTypes = [];
              res.forEach(function (item) {
                var type = item.applicationType;
                var allow = false;
                if (orgType === "blwf") {
                  // include all except disabilityAssistance
                  allow = type !== "disabilityAssistance";
                } else if (orgType === "eis") {
                  // include only disabilityAssistance and financialAssistance
                  allow = ["disabilityAssistance", "financialAssistance", "death"].includes(type);
                } else {
                  // include all types
                  allow = true;
                }
                if (allow) {
                  appTypes.push({
                    appType: type,
                    type: applicationTypeNames[type],
                    count: Number(item.applicationCount)
                  });
                  pendingAppTypes.push({
                    appType: type,
                    type: applicationTypeNames[type],
                    count: Number(item.applicationCount) - (Number(item.approvedCount) + Number(item.rejectedCount))
                  });
                }
              });
              setApplicationTypes(appTypes);
              setPendingApplicationTypes(pendingAppTypes);

              // Calculate totals
              totalsCalc = rows.reduce(function (acc, r) {
                acc.total += Number(r.total);
                acc.approved += Number(r.approved);
                acc.cancelled += Number(r.cancelled);
                acc.processing += Number(r.processing);
                return acc;
              }, {
                total: 0,
                approved: 0,
                cancelled: 0,
                processing: 0
              });
              approvedTotal = 0;
              cancelledTotal = 0;
              processingTotal = 0;
              rows.map(function (r) {
                approvedTotal += Number(r.approved);
                cancelledTotal += Number(r.cancelled);
                processingTotal += Number(r.processing);
              });
              setPieData([{
                name: locale == 'fr' ? "প্রক্রিয়াধীন" : 'Processing',
                value: processingTotal,
                color: "#6cdfdfff"
              }, {
                name: locale == 'fr' ? "অনুমোদিত" : 'Approved',
                value: approvedTotal,
                color: "#68b88cff"
              }, {
                name: locale == 'fr' ? "বাতিল" : 'Reverted',
                value: cancelledTotal,
                color: "#d48aa3ff"
              }]);
              setTableRows(rows);
              setTotals(totalsCalc);
              genderRes = [];
              _context.next = 24;
              return dispatch(fetchGenderWiseApplicationMatrixByDate(months, fromDate, toDate, orgType)).then(function (response) {
                var _response$payload2;
                genderRes = ((_response$payload2 = response.payload) === null || _response$payload2 === void 0 || (_response$payload2 = _response$payload2.data) === null || _response$payload2 === void 0 ? void 0 : _response$payload2.workforceGenderwiseMatrix[0]) || [];
              });
            case 24:
              _applicationCounts = [{
                type: applicantTypeNames['totalApplicant'],
                count: genderRes.totalApplicant
              }, {
                type: applicantTypeNames['maleApplicant'],
                count: genderRes.maleApplicant
              }, {
                type: applicantTypeNames['femaleApplicant'],
                count: genderRes.femaleApplicant
              }, {
                type: applicantTypeNames['totalDependent'],
                count: genderRes.totalDependent
              }
              // { type: applicantTypeNames['maleDependent'], count: genderRes.maleDependent },
              // { type: applicantTypeNames['femaleDependent'], count: genderRes.femaleDependent },
              ];
              setApplicationCounts(_applicationCounts);
              setTotalBenefitAmount(genderRes.totalBenefitAmount || 0);
              _context.next = 32;
              break;
            case 29:
              _context.prev = 29;
              _context.t0 = _context["catch"](0);
              console.error("Failed to fetch data", _context.t0);
            case 32:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[0, 29]]);
      }));
      return _loadData.apply(this, arguments);
    }
    loadData();
  }, [months, fromDate, toDate, filter]);
  useEffect(function () {
    console.log("graphMonths/From/To changed");
    function loadMonthWiseData() {
      return _loadMonthWiseData.apply(this, arguments);
    }
    function _loadMonthWiseData() {
      _loadMonthWiseData = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var monthWiseRes, barDataArray;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              monthWiseRes = [];
              _context2.next = 4;
              return dispatch(fetchApplicationMonthWise(graphMonths)).then(function (response) {
                var _response$payload3;
                monthWiseRes = ((_response$payload3 = response.payload) === null || _response$payload3 === void 0 || (_response$payload3 = _response$payload3.data) === null || _response$payload3 === void 0 ? void 0 : _response$payload3.workforceMonthwiseApplications) || [];
              });
            case 4:
              console.log("monthWiseRes", monthWiseRes);
              barDataArray = [];
              monthWiseRes.map(function (item) {
                barDataArray.push(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({
                  month: getMonthName(Number(item.month) - 1)
                }, locale == 'fr' ? "চিকিৎসা" : "Medical", item.medical), locale == 'fr' ? "মৃত্যু" : "Death", item.death), locale == 'fr' ? "শিক্ষা" : "Educational", item.educational), locale == 'fr' ? "মাতৃত্ব" : "Maternity", item.maternityGrant), locale == 'fr' ? "স্থায়ী ও অস্থায়ী অক্ষমতা" : "Permanent Or Curable Disability", item.disabilityAssistance));
              });
              setBarData(barDataArray);
              _context2.next = 13;
              break;
            case 10:
              _context2.prev = 10;
              _context2.t0 = _context2["catch"](0);
              console.error("Failed to fetch month wise data", _context2.t0);
            case 13:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[0, 10]]);
      }));
      return _loadMonthWiseData.apply(this, arguments);
    }
    loadMonthWiseData();
  }, [graphMonths, graphFromDate, graphToDate]);
  var application_status_count_data = useSelector(function (state) {
    return state.workforce["workforceApplicationStatusCount"];
  });
  if (user_type === WORKFORCE_USER_TYPE.DIRECTOR) {
    var _application_status_c, _application_status_c2, _application_status_c3;
    application_status_count_data === null || application_status_count_data === void 0 || (_application_status_c = application_status_count_data.pendingForDirector) === null || _application_status_c === void 0 ? void 0 : _application_status_c.totalCount;
    application_status_count_data === null || application_status_count_data === void 0 || (_application_status_c2 = application_status_count_data.rejectedForDirector) === null || _application_status_c2 === void 0 ? void 0 : _application_status_c2.totalCount;
    application_status_count_data === null || application_status_count_data === void 0 || (_application_status_c3 = application_status_count_data.approvedForDirector) === null || _application_status_c3 === void 0 ? void 0 : _application_status_c3.totalCount;
  } else {
    var _application_status_c4, _application_status_c5, _application_status_c6;
    application_status_count_data === null || application_status_count_data === void 0 || (_application_status_c4 = application_status_count_data.pending) === null || _application_status_c4 === void 0 ? void 0 : _application_status_c4.totalCount;
    application_status_count_data === null || application_status_count_data === void 0 || (_application_status_c5 = application_status_count_data.rejected) === null || _application_status_c5 === void 0 ? void 0 : _application_status_c5.totalCount;
    application_status_count_data === null || application_status_count_data === void 0 || (_application_status_c6 = application_status_count_data.approved) === null || _application_status_c6 === void 0 ? void 0 : _application_status_c6.totalCount;
  }
  var newCard = {
    height: "100%",
    borderRadius: "20px",
    boxShadow: theme.shadows[2],
    // color: "#000",
    padding: "10px"
  };
  var _useState39 = useState(false),
    _useState40 = _slicedToArray(_useState39, 2),
    openModal = _useState40[0],
    setOpenModal = _useState40[1];
  var handleCloseModal = function handleCloseModal() {
    setOpenModal(false);
  };
  var _useState41 = useState(null),
    _useState42 = _slicedToArray(_useState41, 2),
    selectedType = _useState42[0],
    setSelectedType = _useState42[1];
  var Filters = function Filters() {
    return /*#__PURE__*/React.createElement(Grid, {
      container: true,
      spacing: 2,
      style: {
        marginTop: "15px",
        marginBottom: "10px",
        color: "red"
      }
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 6,
      md: 6
    }, organizationName), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 6,
      md: 6,
      style: {
        textAlign: "right"
      }
    }, fromDate && fromDate != "" ? fromDateString + toDateString : "", monthString != "" ? monthString : ""));
  };
  var handleOpenModal = function handleOpenModal(type) {
    setSelectedType(type);
    setOpenModal(true);
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 2
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 12
  }, /*#__PURE__*/React.createElement(Card, {
    style: _objectSpread$v(_objectSpread$v({}, newCard), {}, {
      padding: "30px",
      borderRadius: "15px",
      overflow: "visible"
    })
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 2,
    style: {
      marginBottom: "10px"
    }
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 12
  }, /*#__PURE__*/React.createElement(Typography, {
    style: {
      fontWeight: "bold"
    }
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "workforce.select.time.range"
  })), /*#__PURE__*/React.createElement(Box$1, {
    gap: 2
  }, /*#__PURE__*/React.createElement(ButtonGroup, {
    variant: "outlined",
    style: {
      display: "flex",
      margin: "auto",
      gap: "10px"
    }
  }, Object.entries(buttonOptions).map(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      label = _ref2[1];
    return /*#__PURE__*/React.createElement(Button, {
      key: key,
      variant: months === key ? "contained" : "outlined",
      onClick: function onClick() {
        return handleMonthChange(key);
      },
      style: {
        border: "1px solid #aaa",
        borderRadius: "10px",
        width: "100%"
      }
    }, label);
  })))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    md: 12
  }, /*#__PURE__*/React.createElement(Card, {
    style: _objectSpread$v(_objectSpread$v({}, newCard), {}, {
      padding: "10px",
      borderRadius: "15px",
      overflow: "visible"
    })
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 2
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    md: 3,
    xs: 3,
    style: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center"
    }
  }, /*#__PURE__*/React.createElement(PublishedComponent, {
    pubRef: "workforce.DatePicker",
    label: "workforce.from.date",
    onChange: function onChange(datevalue) {
      return handleFromDateChange(datevalue);
    },
    width: "100%",
    style: {
      border: "1px solid #aaa",
      padding: "10px",
      borderRadius: "10px",
      width: "100%"
    }
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    md: 3,
    xs: 3,
    style: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center"
    }
  }, /*#__PURE__*/React.createElement(PublishedComponent, {
    pubRef: "workforce.DatePicker",
    label: "workforce.to.date",
    onChange: function onChange(datevalue) {
      return handleToDateChange(datevalue);
    },
    style: {
      border: "1px solid #aaa",
      padding: "10px",
      borderRadius: "10px"
    }
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    md: 6,
    xs: 6
  }, /*#__PURE__*/React.createElement(Card, {
    style: _objectSpread$v(_objectSpread$v({}, newCard), {}, {
      padding: "10px",
      borderRadius: "15px",
      overflow: "visible",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center"
    })
  }, /*#__PURE__*/React.createElement(Typography, {
    component: "div"
  }, locale == 'fr' ? "তহবিল নির্বাচন করুন" : "Fund Type"), /*#__PURE__*/React.createElement(Box$1, {
    mb: 2,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(Box$1, null, /*#__PURE__*/React.createElement(ButtonGroup, {
    size: "small",
    variant: "outlined"
  }, [locale == 'fr' ? "সব" : "All", "CF", "BLWF"].map(function (l) {
    return /*#__PURE__*/React.createElement(Button, {
      key: l,
      variant: filter === l ? "contained" : "outlined",
      onClick: function onClick() {
        return handleFilter(l);
      }
    }, l);
  }))), /*#__PURE__*/React.createElement(Box$1, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "caption",
    style: {
      color: "red"
    }
  }, locale == 'fr' ? "নির্বাচিত তহবিল" : "Selected Fund", ": ", /*#__PURE__*/React.createElement("strong", null, organizationName)))))))))))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 4
  }, /*#__PURE__*/React.createElement(Card, {
    style: newCard
  }, /*#__PURE__*/React.createElement(CardContent, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5",
    gutterBottom: true
  }, locale == 'fr' ? "প্রক্রিয়াধীন আবেদনসমূহ" : "Pending Applications", /*#__PURE__*/React.createElement(DescriptionIcon, {
    style: {
      verticalAlign: 'middle',
      marginRight: 8,
      "float": "right"
    }
  })), /*#__PURE__*/React.createElement(Filters, null), /*#__PURE__*/React.createElement("table", {
    cellPadding: "6px",
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React.createElement("tbody", null, pendingApplicationTypes.map(function (item) {
    return /*#__PURE__*/React.createElement("tr", {
      style: {
        paddingTop: "10px",
        paddingBottom: "10px"
      }
    }, /*#__PURE__*/React.createElement("th", {
      style: {
        textAlign: "left"
      }
    }, /*#__PURE__*/React.createElement(Typography, null, item.type)), /*#__PURE__*/React.createElement("td", {
      style: {
        textAlign: "right"
      }
    }, /*#__PURE__*/React.createElement(Link, {
      component: "button",
      variant: "body2",
      onClick: function onClick() {
        return handleOpenModal(item);
      }
    }, /*#__PURE__*/React.createElement(Typography, null, item.count))));
  }))), /*#__PURE__*/React.createElement(AgingReportModal, {
    open: openModal,
    onClose: handleCloseModal,
    data: selectedType,
    organizationType: filter.toLowerCase()
  })))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 4
  }, /*#__PURE__*/React.createElement(Card, {
    style: newCard
  }, /*#__PURE__*/React.createElement(CardContent, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5",
    gutterBottom: true
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "workforce.dashboard.applicant.types"
  }), /*#__PURE__*/React.createElement(PeopleAltIcon, {
    style: {
      verticalAlign: 'middle',
      marginRight: 8,
      "float": "right"
    }
  })), /*#__PURE__*/React.createElement(Filters, null), applicationCounts.map(function (item) {
    return /*#__PURE__*/React.createElement(Card, {
      style: _objectSpread$v(_objectSpread$v({}, newCard), {}, {
        margin: "10px",
        padding: "0px"
      })
    }, /*#__PURE__*/React.createElement(CardContent, null, /*#__PURE__*/React.createElement(Typography, null, item.type, /*#__PURE__*/React.createElement(PersonIcon, {
      style: {
        verticalAlign: 'middle',
        marginLeft: 8,
        "float": "right"
      }
    })), /*#__PURE__*/React.createElement(Typography, {
      variant: "h5"
    }, /*#__PURE__*/React.createElement("b", null, item.count))));
  })))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 4
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 2,
    style: {
      marginBottom: "10px"
    }
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 12
  }, /*#__PURE__*/React.createElement(Card, {
    style: newCard
  }, /*#__PURE__*/React.createElement(CardContent, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6",
    gutterBottom: true
  }, locale == 'fr' ? "মোট আবেদন" : "Total Applications", /*#__PURE__*/React.createElement(DescriptionIcon, {
    style: {
      verticalAlign: 'middle',
      marginRight: 8,
      "float": "right"
    }
  })), /*#__PURE__*/React.createElement(Filters, null), /*#__PURE__*/React.createElement("table", {
    cellPadding: "6px",
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React.createElement("tbody", null, applicationTypes.map(function (type) {
    return /*#__PURE__*/React.createElement("tr", {
      style: {
        paddingTop: "10px",
        paddingBottom: "10px"
      }
    }, /*#__PURE__*/React.createElement("th", {
      style: {
        textAlign: "left"
      }
    }, /*#__PURE__*/React.createElement(Typography, null, type.type)), /*#__PURE__*/React.createElement("td", {
      style: {
        textAlign: "right"
      }
    }, /*#__PURE__*/React.createElement(Typography, null, type.count)));
  })))))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 12
  }, /*#__PURE__*/React.createElement(Card, {
    style: newCard
  }, /*#__PURE__*/React.createElement(CardContent, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6",
    gutterBottom: true
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "workforce.dashboard.financial.info"
  }), /*#__PURE__*/React.createElement(LocalAtmIcon, {
    style: {
      verticalAlign: 'middle',
      marginRight: 8,
      "float": "right"
    }
  })), /*#__PURE__*/React.createElement(Filters, null), /*#__PURE__*/React.createElement(Card, {
    style: _objectSpread$v(_objectSpread$v({}, newCard), {}, {
      margin: "10px",
      padding: "0px"
    })
  }, /*#__PURE__*/React.createElement(CardContent, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "workforce.dashboard.total.beneficiary.amount"
  })), /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, /*#__PURE__*/React.createElement("b", null, "\u09F3 ", locale == 'fr' ? Number(totalBenefitAmount).toLocaleString('bn') : Number(totalBenefitAmount).toLocaleString('en')))))))))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 12
  }, /*#__PURE__*/React.createElement(Card, {
    style: _objectSpread$v(_objectSpread$v({}, newCard), {}, {
      overflow: "visible"
    }),
    sx: {
      borderRadius: "12px",
      boxShadow: 2
    }
  }, /*#__PURE__*/React.createElement(CardHeader, {
    title: /*#__PURE__*/React.createElement(Box$1, null, /*#__PURE__*/React.createElement(Typography, {
      variant: "h6",
      component: "div"
    }, locale == 'fr' ? "আবেদন প্রকার ম্যাট্রিক্স" : "Application Type Matrix"), /*#__PURE__*/React.createElement(Typography, {
      variant: "body2",
      color: "textSecondary"
    }, locale == 'fr' ? "বিস্তারিত আবেদনের প্রতিবেদন - ফান্ড প্রকার অনুসারে" : "Detailed Application Report - By Fund Type")),
    action: /*#__PURE__*/React.createElement(Filters, null)
  }), /*#__PURE__*/React.createElement(CardContent, null, /*#__PURE__*/React.createElement(Table$2, null, /*#__PURE__*/React.createElement(TableHead, null, /*#__PURE__*/React.createElement(TableRow, null, /*#__PURE__*/React.createElement(TableCell, {
    style: {
      fontWeight: "bold"
    }
  }, locale == 'fr' ? "মোট আবেদন" : "Total Applications"), /*#__PURE__*/React.createElement(TableCell, {
    align: "right",
    style: {
      fontWeight: "bold"
    }
  }, locale == 'fr' ? "আবেদনের প্রকার" : "Application Type"), /*#__PURE__*/React.createElement(TableCell, {
    align: "right",
    style: {
      fontWeight: "bold"
    }
  }, locale == 'fr' ? "অনুমোদিত/ সুপারিশকৃত" : "Approved/ Recommended"), /*#__PURE__*/React.createElement(TableCell, {
    align: "right",
    style: {
      fontWeight: "bold"
    }
  }, locale == 'fr' ? "বাতিল/ ফেরত" : "Reverted/ Rejected"), /*#__PURE__*/React.createElement(TableCell, {
    align: "right",
    style: {
      fontWeight: "bold"
    }
  }, locale == 'fr' ? "প্রক্রিয়াধীন" : "Processing"), /*#__PURE__*/React.createElement(TableCell, {
    align: "center",
    style: {
      fontWeight: "bold"
    }
  }, locale == 'fr' ? "বিস্তারিত" : "Detail"))), /*#__PURE__*/React.createElement(TableBody, null, tableRows.map(function (r, idx) {
    return /*#__PURE__*/React.createElement(TableRow, {
      key: idx,
      hover: true
    }, /*#__PURE__*/React.createElement(TableCell, null, r.type), /*#__PURE__*/React.createElement(TableCell, {
      align: "right"
    }, r.total), /*#__PURE__*/React.createElement(TableCell, {
      align: "right"
    }, r.approved), /*#__PURE__*/React.createElement(TableCell, {
      align: "right"
    }, r.cancelled), /*#__PURE__*/React.createElement(TableCell, {
      align: "right"
    }, r.processing), /*#__PURE__*/React.createElement(TableCell, {
      align: "center"
    }, /*#__PURE__*/React.createElement(Link, {
      component: "button",
      variant: "body2",
      onClick: function onClick() {
        // replace with real navigation
        console.log("বিস্তারিত:", r.type);
      },
      sx: {
        color: "#138a66"
      }
    }, locale == 'fr' ? "বিস্তারিত দেখুন" : "See Detail")));
  })), /*#__PURE__*/React.createElement(TableFooter, null, /*#__PURE__*/React.createElement(TableRow, null, /*#__PURE__*/React.createElement(TableCell, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle2"
  }, locale == 'fr' ? "মোট" : "Total")), /*#__PURE__*/React.createElement(TableCell, {
    align: "right"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle2",
    fontWeight: "bold"
  }, totals.total)), /*#__PURE__*/React.createElement(TableCell, {
    align: "right"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle2",
    fontWeight: "bold"
  }, totals.approved)), /*#__PURE__*/React.createElement(TableCell, {
    align: "right"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle2",
    fontWeight: "bold"
  }, totals.cancelled)), /*#__PURE__*/React.createElement(TableCell, {
    align: "right"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle2",
    fontWeight: "bold"
  }, totals.processing)), /*#__PURE__*/React.createElement(TableCell, null))))))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 7
  }, /*#__PURE__*/React.createElement(Card, {
    style: newCard,
    sx: {
      borderRadius: "16px",
      boxShadow: 3
    }
  }, /*#__PURE__*/React.createElement(CardHeader, {
    title: locale == 'fr' ? 'মাসিক ডেটা ওভারভিউ' : 'Monthly Data Overview',
    subheader: locale == 'fr' ? 'আবেদনের ধরণ অনুসারে' : 'By Application Type',
    action: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Card, {
      style: {
        padding: "10px",
        borderRadius: "12px"
      }
    }, /*#__PURE__*/React.createElement(Typography, {
      style: {
        textAlign: "center",
        fontWeight: "bold"
      }
    }, /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.select.time.range"
    })), /*#__PURE__*/React.createElement(ButtonGroup, {
      variant: "outlined",
      style: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
      }
    }, Object.entries(buttonOptions).map(function (_ref3) {
      var _ref4 = _slicedToArray(_ref3, 2),
        key = _ref4[0],
        label = _ref4[1];
      return /*#__PURE__*/React.createElement(Button, {
        key: key,
        variant: graphMonths === key ? "contained" : "outlined",
        onClick: function onClick() {
          return handleGraphMonthChange(key);
        }
      }, label);
    }))))
  }), /*#__PURE__*/React.createElement(CardContent, null, /*#__PURE__*/React.createElement(ResponsiveContainer, {
    width: "100%",
    height: 300
  }, /*#__PURE__*/React.createElement(BarChart, {
    data: barData
  }, /*#__PURE__*/React.createElement(CartesianGrid, {
    strokeDasharray: "3 3"
  }), /*#__PURE__*/React.createElement(XAxis, {
    dataKey: "month"
  }), /*#__PURE__*/React.createElement(YAxis, null), /*#__PURE__*/React.createElement(Tooltip$1, null), /*#__PURE__*/React.createElement(Legend, null), /*#__PURE__*/React.createElement(Bar, {
    dataKey: locale == 'fr' ? "চিকিৎসা" : "Medical",
    stackId: "a",
    fill: "#009688"
  }), /*#__PURE__*/React.createElement(Bar, {
    dataKey: locale == 'fr' ? "মৃত্যু" : "Death",
    stackId: "a",
    fill: "#90CAF9"
  }), /*#__PURE__*/React.createElement(Bar, {
    dataKey: locale == 'fr' ? "শিক্ষা" : "Educational",
    stackId: "a",
    fill: "#FBC02D"
  }), /*#__PURE__*/React.createElement(Bar, {
    dataKey: locale == 'fr' ? "মাতৃত্ব" : "Maternity",
    stackId: "a",
    fill: "#FF9800"
  }), /*#__PURE__*/React.createElement(Bar, {
    dataKey: locale == 'fr' ? "স্থায়ী ও অস্থায়ী অক্ষমতা" : "Permanent Or Curable Disability",
    stackId: "a",
    fill: "#212121"
  })))))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 5
  }, /*#__PURE__*/React.createElement(Card, {
    style: newCard,
    sx: {
      borderRadius: "16px",
      boxShadow: 3
    }
  }, /*#__PURE__*/React.createElement(CardHeader, {
    title: locale == 'fr' ? 'আবেদনের অবস্থা' : 'Application Status',
    subheader: locale == 'fr' ? 'একনজরে আবেদনসমূহের অবস্থা' : 'Status At a Glance',
    action: /*#__PURE__*/React.createElement(Filters, null)
  }), /*#__PURE__*/React.createElement(CardContent, null, /*#__PURE__*/React.createElement(ResponsiveContainer, {
    width: "100%",
    height: 300
  }, /*#__PURE__*/React.createElement(PieChart, null, /*#__PURE__*/React.createElement(Pie, {
    data: pieData,
    dataKey: "value",
    nameKey: "name",
    innerRadius: 60,
    outerRadius: 100,
    label: true
  }, pieData.map(function (entry, index) {
    return /*#__PURE__*/React.createElement(Cell, {
      key: "cell-".concat(index),
      fill: entry.color
    });
  })), /*#__PURE__*/React.createElement(Tooltip$1, null), /*#__PURE__*/React.createElement(Legend, {
    verticalAlign: "bottom",
    align: "center",
    iconType: "circle" // optional: circle, square, line
    ,
    layout: "horizontal"
  }))))))));
};
var DashboardPage = function DashboardPage() {
  var reduxState = useSelector(function (state) {
    return state;
  });
  var user_rights = reduxState.core.user.i_user.rights;
  var approvedTextId = getUserTypeFromRights(user_rights) === WORKFORCE_USER_TYPE.DIRECTOR ? "workforce.application.forwarded" : "workforce.application.approved";
  var SidebarMenu = [{
    id: "dashboard",
    text: /*#__PURE__*/React.createElement(FormattedMessage, {
      module: "workforce",
      id: "workforce.application.dashboard"
    }),
    icon: /*#__PURE__*/React.createElement(DashboardIcon, null)
  }, {
    id: "waitingApplications",
    text: /*#__PURE__*/React.createElement(FormattedMessage, {
      module: "workforce",
      id: "workforce.employee.application.meetingSheet"
    }),
    icon: /*#__PURE__*/React.createElement(DashboardIcon, null)
  }, {
    id: "rejectedApplications",
    text: /*#__PURE__*/React.createElement(FormattedMessage, {
      module: "workforce",
      id: "workforce.application.rejectedApplication"
    }),
    icon: /*#__PURE__*/React.createElement(DashboardIcon, null)
  }, {
    id: "approvedApplications",
    text: /*#__PURE__*/React.createElement(FormattedMessage, {
      module: "workforce",
      id: approvedTextId
    }),
    icon: /*#__PURE__*/React.createElement(DashboardIcon, null)
  }, {
    id: "returnedApplications",
    text: /*#__PURE__*/React.createElement(FormattedMessage, {
      module: "workforce",
      id: "workforce.application.returned"
    }),
    icon: /*#__PURE__*/React.createElement(DashboardIcon, null)
  }];
  useTheme();
  var classes = useStyles$C();
  useDispatch();
  useModulesManager();
  var _useState43 = useState("dashboard"),
    _useState44 = _slicedToArray(_useState43, 2),
    selectedMenu = _useState44[0],
    setSelectedMenu = _useState44[1];
  var urlParams = new URLSearchParams(window.location.search);
  var status = urlParams.get("status");
  useEffect(function () {
    if (status) {
      switch (status) {
        case "pending":
          setSelectedMenu("waitingApplications");
          break;
        case "approved":
          setSelectedMenu("approvedApplications");
          break;
        case "rejected":
          setSelectedMenu("rejectedApplications");
          break;
        case "returnedApplications":
          setSelectedMenu("returnedApplications");
          break;
        default:
          setSelectedMenu("dashboard");
      }
    }
  }, [status]);
  var renderContent = function renderContent() {
    switch (selectedMenu) {
      case "dashboard":
        return /*#__PURE__*/React.createElement(Dashboard$5, null);
      case "waitingApplications":
        return /*#__PURE__*/React.createElement(ApplicationSummaryPage$1, {
          key: "pending",
          status: "pending"
        });
      case "rejectedApplications":
        return /*#__PURE__*/React.createElement(RejectApplication$8, null);
      case "approvedApplications":
        return /*#__PURE__*/React.createElement(ApplicationSummaryPage$1, {
          key: "approved",
          status: "approved",
          disableButtons: 1
        });
      case "returnedApplications":
        return /*#__PURE__*/React.createElement(ReturnedApplications$d, null);
      default:
        return /*#__PURE__*/React.createElement(Dashboard$5, null);
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: classes.root
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 2,
    className: classes.root
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 3,
    className: classes.sidebar
  }, /*#__PURE__*/React.createElement(Paper, {
    className: classes.sidebar
  }, /*#__PURE__*/React.createElement(List, null, SidebarMenu.map(function (item) {
    return /*#__PURE__*/React.createElement(ListItem, {
      button: true,
      key: item.id,
      selected: selectedMenu === item.id,
      onClick: function onClick() {
        return setSelectedMenu(item.id);
      }
    }, /*#__PURE__*/React.createElement(ListItemIcon, null, item.icon), /*#__PURE__*/React.createElement(ListItemText, {
      primary: item.text
    }));
  })))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 9,
    className: classes.content
  }, renderContent())));
};

var useStyles$B = makeStyles(function (theme) {
  return {
    title: {
      fontWeight: 800
    },
    paper: {
      padding: theme.spacing(2),
      width: "100%",
      maxWidth: 650,
      margin: "auto"
    },
    section: {
      marginTop: theme.spacing(3)
    }
  };
});
var EisApplicationTypeSelector = function EisApplicationTypeSelector(_ref) {
  var _parsedApplicationDat;
  var workforceFactoryId = _ref.workforceFactoryId,
    modulesManager = _ref.modulesManager,
    onSelect = _ref.onSelect;
    _ref.selectedApplicationType;
    var parsedApplicationData = _ref.parsedApplicationData;
  var classes = useStyles$B();
  var dispatch = useDispatch();
  var history = useHistory();
  var _useState = useState(""),
    _useState2 = _slicedToArray(_useState, 2),
    localApplicationType = _useState2[0],
    setLocalApplicationType = _useState2[1];
  var _useState3 = useState(""),
    _useState4 = _slicedToArray(_useState3, 2);
    _useState4[0];
    var setIsExportOriented = _useState4[1];
  var selectedEmployee = useSelector(function (state) {
    return state.selectedEmployee;
  });
  var user_type = getUserType();
  useEffect(function () {
    if (parsedApplicationData) {
      var orgType = parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.organizationType;
      var appType = parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.applicationType;
      setLocalApplicationType(appType || ""); // ✅ set locally
      var exportStatus = orgType === "cf" ? "yes" : "no";
      setIsExportOriented(exportStatus);
      dispatch({
        type: "SET_SELECTED_EMPLOYEE",
        payload: parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.workforceEmployee
      });
    }
  }, [parsedApplicationData]);
  var handleApplicationTypeChange = function handleApplicationTypeChange(event) {
    var value = event.target.value;
    setLocalApplicationType(value);
    onSelect(value);
  };
  var handleEmployeeChange = function handleEmployeeChange(employee) {
    console.log({
      employee: employee
    });
    dispatch({
      type: "SET_SELECTED_EMPLOYEE",
      payload: employee
    });
  };
  console.log({
    workforceFactoryId: workforceFactoryId
  });
  console.log({
    selectedEmployee: selectedEmployee
  });
  return /*#__PURE__*/React.createElement(Paper, {
    className: classes.paper,
    elevation: 0
  }, user_type !== WORKFORCE_USER_TYPE.APPLICANT && /*#__PURE__*/React.createElement(Box$1, null, /*#__PURE__*/React.createElement(Typography, {
    style: {
      textAlign: "center",
      color: "red",
      fontWeight: "bold",
      marginBottom: 8
    }
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "workforce.application.header.employeeSelector.note",
    module: "workforce"
  })), /*#__PURE__*/React.createElement(Grid, {
    container: true,
    alignItems: "center",
    spacing: 2
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 8
  }, /*#__PURE__*/React.createElement(WorkforceEmployeePicker, {
    modulesManager: modulesManager,
    workforceFactoryId: workforceFactoryId === null || workforceFactoryId === void 0 ? void 0 : workforceFactoryId.id,
    value: selectedEmployee || (parsedApplicationData === null || parsedApplicationData === void 0 || (_parsedApplicationDat = parsedApplicationData.workforceEmployee) === null || _parsedApplicationDat === void 0 ? void 0 : _parsedApplicationDat.id),
    onChange: handleEmployeeChange,
    required: true,
    readOnly: false,
    withLabel: true,
    withPlaceholder: true,
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      module: "workforce",
      id: "workforce.application.employee.selector"
    }),
    placeholder: "Type to search employee"
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 4
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "contained",
    color: "primary",
    onClick: function onClick() {
      return historyPush$1(modulesManager, history, "workforce.route.employees.employee");
    }
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.application.add.employee"
  }))))), /*#__PURE__*/React.createElement(FormControl, {
    component: "fieldset",
    className: classes.section
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6",
    className: classes.title
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "workforce.application.type.title",
    module: "workforce"
  })), /*#__PURE__*/React.createElement(RadioGroup, {
    value: localApplicationType,
    onChange: handleApplicationTypeChange
  }, /*#__PURE__*/React.createElement(FormControlLabel, {
    value: "financialAssistance",
    control: /*#__PURE__*/React.createElement(Radio, {
      color: "primary"
    }),
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.application.type.eis.deadly.grant",
      module: "workforce"
    })
  }), /*#__PURE__*/React.createElement(FormControlLabel, {
    value: "disabilityAssistance",
    control: /*#__PURE__*/React.createElement(Radio, {
      color: "primary"
    }),
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.application.type.eis.medical.disability",
      module: "workforce"
    })
  }))));
};

var useStyles$A = makeStyles(function (theme) {
  return {
    container: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center"
    },
    subPaper: {
      padding: theme.spacing(1),
      width: "100%",
      // Ensures it doesn't overflow
      maxWidth: 650,
      // Restrict max width
      margin: "auto",
      // Centers the Paper component
      minHeight: "fit-content" // Ensures a minimum height
    },
    paper: {
      padding: theme.spacing(1),
      width: "100%",
      minHeight: "fit-content" // Ensures a minimum height
    },
    buttonContainer: {
      marginTop: theme.spacing(2),
      display: "flex",
      justifyContent: "flex-end",
      gap: theme.spacing(1)
    },
    backButtonContainer: {
      display: "flex",
      alignItems: "center",
      marginBottom: theme.spacing(0.5)
    },
    backText: {
      marginLeft: theme.spacing(1),
      fontWeight: "bold"
    },
    title: {
      fontWeight: 800
    },
    section: {
      marginTop: theme.spacing(1)
    }
  };
});
var EisMultiStepApplyForm = function EisMultiStepApplyForm(_ref) {
  var workforceFactoryId = _ref.workforceFactoryId;
  var classes = useStyles$A();
  var modulesManager = useModulesManager();
  var _useParams = useParams(),
    application_uuid = _useParams.application_uuid;
  var dispatch = useDispatch();
  var loggedInUserId = useSelector(function (state) {
    var _state$core;
    return (_state$core = state.core) === null || _state$core === void 0 || (_state$core = _state$core.user) === null || _state$core === void 0 || (_state$core = _state$core.i_user) === null || _state$core === void 0 ? void 0 : _state$core.id;
  });
  var user_type = getUserType();
  var selectedEmployeeData = useSelector(function (state) {
    var _state$workforce$sele;
    return (_state$workforce$sele = state.workforce["selectedEmployee"]) !== null && _state$workforce$sele !== void 0 ? _state$workforce$sele : [];
  });
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    parsedApplicationData = _useState2[0],
    setParsedApplicationData = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    showForm = _useState4[0],
    setShowForm = _useState4[1];
  var _useState5 = useState(""),
    _useState6 = _slicedToArray(_useState5, 2),
    applicationForSelf = _useState6[0],
    setApplicationForSelf = _useState6[1];
  var _useState7 = useState("eis" ),
    _useState8 = _slicedToArray(_useState7, 2),
    organizationType = _useState8[0],
    setOrganizationType = _useState8[1];
  var _useState9 = useState((parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.applicationType) || ""),
    _useState10 = _slicedToArray(_useState9, 2),
    selectedApplicationType = _useState10[0],
    setSelectedApplicationType = _useState10[1];
  var _useState11 = useState(true),
    _useState12 = _slicedToArray(_useState11, 2);
    _useState12[0];
    _useState12[1];
  var _useState13 = useState(false),
    _useState14 = _slicedToArray(_useState13, 2),
    openErrorModal = _useState14[0],
    setOpenErrorModal = _useState14[1];
  var _useState15 = useState(null),
    _useState16 = _slicedToArray(_useState15, 2),
    factoryId = _useState16[0],
    setFactoryId = _useState16[1];
  var reduxState = useSelector(function (state) {
    return state;
  });
  var userName = reduxState.core.user.username;
  useEffect(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    var fetchData;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          fetchData = /*#__PURE__*/function () {
            var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
              var filters, parsedData;
              return _regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) switch (_context.prev = _context.next) {
                  case 0:
                    filters = ["id: \"".concat(application_uuid, "\"")];
                    _context.next = 3;
                    return dispatch(getParsedApplication(modulesManager, filters));
                  case 3:
                    parsedData = _context.sent;
                    setParsedApplicationData(parsedData); // <- parsed data will now be set correctly
                  case 5:
                  case "end":
                    return _context.stop();
                }
              }, _callee);
            }));
            return function fetchData() {
              return _ref3.apply(this, arguments);
            };
          }();
          fetchData();
        case 2:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  })), []);
  useEffect(function () {
    if (!workforceFactoryId && loggedInUserId && user_type === WORKFORCE_USER_TYPE.FACTORY_ADMIN) {
      var filters = ["relatedUser_Id: \"".concat(encodeId(modulesManager, "InteractiveUserGQLType", loggedInUserId), "\"")];
      dispatch(fetchFactoryEmployee(modulesManager, filters)).then(function (res) {
        var _res$payload, _edges$;
        var edges = (res === null || res === void 0 || (_res$payload = res.payload) === null || _res$payload === void 0 || (_res$payload = _res$payload.data) === null || _res$payload === void 0 || (_res$payload = _res$payload.workforceEmployerEmployees) === null || _res$payload === void 0 ? void 0 : _res$payload.edges) || [];
        var node = (_edges$ = edges[0]) === null || _edges$ === void 0 ? void 0 : _edges$.node;
        var factoryId = (node === null || node === void 0 ? void 0 : node.workforceFactory) || null;
        setFactoryId(factoryId);
        dispatch(fetchWorkforceEmployeesSummary(modulesManager, ["workforceFactoryId:\"".concat(factoryId === null || factoryId === void 0 ? void 0 : factoryId.id, "\"")]));
      });
    }
  }, []);
  useEffect(function () {
    if (!(parsedApplicationData !== null && parsedApplicationData !== void 0 && parsedApplicationData.employeeDependentInfo)) return;
    Object.keys(parsedApplicationData.employeeDependentInfo).length === 0;
    setApplicationForSelf((parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.applicationFor) === "dependent" ? "no" : (parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.applicationFor) === "self" ? "yes" : "");
    setSelectedApplicationType(parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.applicationType);
    setOrganizationType(parsedApplicationData === null || parsedApplicationData === void 0 ? void 0 : parsedApplicationData.organizationType);
  }, [parsedApplicationData]);
  var handleSelection = function handleSelection(applicationType) {
    setSelectedApplicationType(applicationType);
  };
  var handleBack = function handleBack() {
    setShowForm(false);
    setApplicationForSelf("");
  };
  var handleNextButtonClicked = function handleNextButtonClicked() {
    if (selectedApplicationType === "financialAssistance") {
      dispatch(fetchApplicationsSummary(modulesManager, ["applicationType: \"financialAssistance\",workforceEmployee_Nid: \"".concat(userName, "\",status:\"new\",organizationType:\"eis\"")])).then(function (res) {
        var _res$payload2;
        var data = res === null || res === void 0 || (_res$payload2 = res.payload) === null || _res$payload2 === void 0 || (_res$payload2 = _res$payload2.data) === null || _res$payload2 === void 0 || (_res$payload2 = _res$payload2.workforceApplication) === null || _res$payload2 === void 0 ? void 0 : _res$payload2.edges;
        if (data && data.length > 0) {
          setOpenErrorModal(true);
          return;
        }
        setShowForm(true);
      });
    } else {
      setShowForm(true);
    }
  };
  console.log({
    eis: workforceFactoryId
  });
  console.log({
    eis: factoryId
  });
  return /*#__PURE__*/React.createElement("div", {
    className: classes.container
  }, /*#__PURE__*/React.createElement(Paper, {
    className: classes.paper,
    elevation: 3
  }, /*#__PURE__*/React.createElement(CustomSnackbar, {
    open: openErrorModal,
    onClose: function onClose() {
      return setOpenErrorModal(false);
    },
    type: "error",
    message: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.financialAssistance.error.message",
      module: "workforce"
    })
  }), !showForm ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography, {
    style: {
      color: "#990F02",
      textAlign: "center",
      fontWeight: 800,
      fontSize: "large"
    }
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "workforce.application.before.eis.startDate.error",
    module: "workforce"
  })), /*#__PURE__*/React.createElement(EisApplicationTypeSelector, {
    workforceFactoryId: workforceFactoryId || factoryId,
    modulesManager: modulesManager,
    onSelect: handleSelection,
    selectedApplicationType: selectedApplicationType,
    parsedApplicationData: parsedApplicationData
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.buttonContainer
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "contained",
    color: "primary",
    onClick: function onClick() {
      return handleNextButtonClicked();
    },
    disabled: !selectedApplicationType // Ensures both are selected
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.next"
  })))) : selectedApplicationType === "disabilityAssistance" ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: classes.backButtonContainer
  }, /*#__PURE__*/React.createElement(IconButton, {
    onClick: handleBack,
    color: "primary"
  }, /*#__PURE__*/React.createElement(ArrowBackIcon, null)), /*#__PURE__*/React.createElement(Typography, {
    variant: "body1",
    className: classes.backText
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.back.application.type"
  }))), /*#__PURE__*/React.createElement(DisabilityForm, {
    selectedEmployeeData: selectedEmployeeData,
    workforceFactoryId: workforceFactoryId,
    modulesManager: modulesManager,
    organizationType: organizationType,
    selectedApplicationType: selectedApplicationType,
    parsedApplicationData: parsedApplicationData,
    applicationForSelf: applicationForSelf
  })) : selectedApplicationType === "financialAssistance" ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: classes.backButtonContainer
  }, /*#__PURE__*/React.createElement(IconButton, {
    onClick: handleBack,
    color: "primary"
  }, /*#__PURE__*/React.createElement(ArrowBackIcon, null)), /*#__PURE__*/React.createElement(Typography, {
    variant: "body1",
    className: classes.backText
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.back.application.type"
  }))), /*#__PURE__*/React.createElement(FinancialAssistanceForm, {
    selectedEmployeeData: selectedEmployeeData,
    workforceFactoryId: workforceFactoryId,
    modulesManager: modulesManager,
    organizationType: organizationType,
    parsedApplicationData: parsedApplicationData,
    selectedApplicationType: selectedApplicationType,
    applicationForSelf: applicationForSelf
  })) : /*#__PURE__*/React.createElement("div", null, "Please select an application type")));
};
var EisMultiStepApplyForm$1 = withModulesManager(withHistory(EisMultiStepApplyForm));

var useStyles$z = makeStyles(function (theme) {
  return {
    root: {
      flexGrow: 1,
      padding: theme.spacing(2),
      // height: '100vh', // assuming 64px header/appbar, adjust as needed
      overflow: 'visible'
    },
    sidebar: _defineProperty({
      position: "sticky",
      top: 0,
      height: "45vh",
      overflowY: "auto",
      backgroundColor: theme.palette.background.paper,
      borderRight: "1px solid ".concat(theme.palette.divider)
    }, "overflowY", "auto"),
    content: {
      height: 'fit-content',
      // overflowY: 'auto',
      padding: theme.spacing(2)
    },
    tableContainer: {
      marginTop: theme.spacing(0)
    },
    tableHeadCell: {
      fontWeight: "bold"
    },
    noData: {
      textAlign: "center",
      padding: theme.spacing(2)
    },
    searchInput: {
      border: "1px solid #ccc",
      borderRadius: 4,
      padding: "4px 8px",
      width: 200
    },
    pagination: {
      display: "flex",
      justifyContent: "flex-end",
      marginTop: theme.spacing(2),
      alignItems: "center"
    },
    tableHeader: {
      backgroundColor: "#B7D4D8"
    }
  };
});
var SidebarMenu$d = [{
  id: "pendingApplications",
  text: /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.application.myself"
  }),
  icon: /*#__PURE__*/React.createElement(DescriptionIcon, null)
}, {
  id: "newApplications",
  text: /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.new.application"
  }),
  icon: /*#__PURE__*/React.createElement(AddCircleOutlineIcon, null)
}, {
  id: "revertedApplication",
  text: /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.application.reverted"
  }),
  icon: /*#__PURE__*/React.createElement(RestorePageIcon, null)
}, {
  id: "rejectedApplication",
  text: /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.application.rejectedApplication"
  }),
  icon: /*#__PURE__*/React.createElement(CancelIcon, null)
}, {
  id: "draftApplications",
  text: /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.application.draft_applications"
  }),
  icon: /*#__PURE__*/React.createElement(DraftsIcon, null)
}, {
  id: "applicationStatus",
  text: /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.application.status"
  }),
  icon: /*#__PURE__*/React.createElement(AssignmentIcon, null)
}, {
  id: "approvedApplications",
  text: /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.application.approve.applications"
  }),
  icon: /*#__PURE__*/React.createElement(CheckIcon, null)
}];

// ----------- Components to Render in Main Content -----------

var FiledApplications$c = function FiledApplications() {
  useStyles$z();
  useSelector(function (state) {
    return state.core.user.username;
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ApplicationProcessSearcher$1, {
    dynamicTableTitle: "workforce.applicant.dashboard"
  }));
};
var DraftApplications$1 = function DraftApplications() {
  useStyles$z();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ApplicationProcessSearcher$1, {
    applicationStatus: "draft",
    dynamicTableTitle: "workforce.application.draft_applications"
  }));
};
var ApplicationStatus$6 = function ApplicationStatus() {
  var _reduxState$core, _applicationData$gran, _applicationData$gran2, _applicationData$date;
  var dispatch = useDispatch();
  var mm = useModulesManager();
  var _useState = useState(""),
    _useState2 = _slicedToArray(_useState, 2);
    _useState2[0];
    _useState2[1];
  var _useState3 = useState(""),
    _useState4 = _slicedToArray(_useState3, 2),
    trackingNumber = _useState4[0],
    setTrackingNumber = _useState4[1];
  var _useState5 = useState(null),
    _useState6 = _slicedToArray(_useState5, 2),
    applicationData = _useState6[0],
    setApplicationData = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    showResult = _useState8[0],
    setShowResult = _useState8[1];
  useHistory();
  var reduxState = useSelector(function (state) {
    return state;
  });
  var locale = (reduxState === null || reduxState === void 0 || (_reduxState$core = reduxState.core) === null || _reduxState$core === void 0 || (_reduxState$core = _reduxState$core.user) === null || _reduxState$core === void 0 || (_reduxState$core = _reduxState$core.i_user) === null || _reduxState$core === void 0 ? void 0 : _reduxState$core.language) || 'en';
  var handleApplicationSearch = function handleApplicationSearch() {
    var filters = ["trackingNumber: \"".concat(trackingNumber, "\"")];
    dispatch(fetchApplicationsSummary(mm, filters)).then(function (res) {
      var _res$payload, _edges$;
      var edges = ((_res$payload = res.payload) === null || _res$payload === void 0 || (_res$payload = _res$payload.data) === null || _res$payload === void 0 || (_res$payload = _res$payload.workforceApplication) === null || _res$payload === void 0 ? void 0 : _res$payload.edges) || [];
      var matchedApp = ((_edges$ = edges[0]) === null || _edges$ === void 0 ? void 0 : _edges$.node) || null;
      setApplicationData(matchedApp);
      setShowResult(true);
    });
  };
  return /*#__PURE__*/React.createElement(Card, {
    style: {
      marginTop: 0,
      padding: "32px",
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement(CardContent, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5",
    gutterBottom: true
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.application.status"
  })), /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 2,
    justifyContent: "center",
    style: {
      marginTop: 16
    }
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 6
  }, /*#__PURE__*/React.createElement(TextField, {
    fullWidth: true,
    variant: "outlined",
    size: "small",
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      module: "workforce",
      id: "workforce.application.tracking.number"
    }),
    value: trackingNumber,
    onChange: function onChange(e) {
      return setTrackingNumber(e.target.value);
    },
    style: {
      marginBottom: 16
    }
  }), /*#__PURE__*/React.createElement(Button, {
    variant: "contained",
    color: "primary",
    fullWidth: true,
    onClick: handleApplicationSearch
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.search.here"
  })))), showResult && (applicationData ? /*#__PURE__*/React.createElement(Box$1, {
    mt: 4,
    p: 3,
    border: 1,
    borderColor: "#ccc",
    borderRadius: 2,
    textAlign: "left",
    maxWidth: 800,
    margin: "32px auto 0"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6",
    gutterBottom: true,
    style: {
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.tracking.summary",
    defaultMessage: "\u099F\u09CD\u09B0\u09CD\u09AF\u09BE\u0995\u09BF\u0982 \u09B8\u09BE\u09B0\u09BE\u0982\u09B6"
  })), /*#__PURE__*/React.createElement(Grid, {
    container: true,
    style: {
      marginTop: 16
    },
    spacing: 2
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement("strong", null, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.application.tracking.number"
  }), ":"), " ", applicationData.trackingNumber), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement("strong", null, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.employee.application.currentStatus"
  }), ":"), (locale === "en" ? STATUS_MAP_EN : STATUS_MAP_BN)[applicationData === null || applicationData === void 0 ? void 0 : applicationData.status] || (applicationData === null || applicationData === void 0 ? void 0 : applicationData.status))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement("strong", null, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.employee.application.applicationType"
  }), ":"), " ", locale === "en" ? applicationData === null || applicationData === void 0 || (_applicationData$gran = applicationData.grantMoney) === null || _applicationData$gran === void 0 ? void 0 : _applicationData$gran.applicationTypeNameEn : applicationData === null || applicationData === void 0 || (_applicationData$gran2 = applicationData.grantMoney) === null || _applicationData$gran2 === void 0 ? void 0 : _applicationData$gran2.applicationTypeNameBn), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement("strong", null, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.employee.application.applicationDate"
  }), ":"), " ", applicationData !== null && applicationData !== void 0 && applicationData.dateCreated ? conditionalEnToBn(applicationData === null || applicationData === void 0 || (_applicationData$date = applicationData.dateCreated) === null || _applicationData$date === void 0 ? void 0 : _applicationData$date.split("T")[0], locale) : "-")))) : /*#__PURE__*/React.createElement(Typography, {
    color: "error",
    style: {
      marginTop: 32
    }
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.tracking.notfound",
    defaultMessage: "\u0995\u09CB\u09A8\u09CB \u0986\u09AC\u09C7\u09A6\u09A8 \u09AA\u09BE\u0993\u09AF\u09BC\u09BE \u09AF\u09BE\u09AF\u09BC\u09A8\u09BF\u0964"
  })))));
};
var RevertApplication$5 = function RevertApplication() {
  var classes = useStyles$z();
  var loggedInUserId = useSelector(function (state) {
    var _state$core;
    return (_state$core = state.core) === null || _state$core === void 0 || (_state$core = _state$core.user) === null || _state$core === void 0 || (_state$core = _state$core.i_user) === null || _state$core === void 0 ? void 0 : _state$core.id;
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ApplicationProcessSearcher$1, _defineProperty({
    revertedApplication: true,
    loggedInUserId: loggedInUserId,
    dynamicTableTitle: "workforce.application.reverted"
  }, "revertedApplication", true)), /*#__PURE__*/React.createElement("div", {
    className: classes.pagination
  }, /*#__PURE__*/React.createElement(Button, null, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.back"
  })), /*#__PURE__*/React.createElement(Button, null, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.next"
  }))));
};
var RejectApplication$7 = function RejectApplication() {
  var classes = useStyles$z();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ApplicationProcessSearcher$1, {
    rejectedApplication: true,
    dynamicTableTitle: "workforce.application.rejectedApplication"
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.pagination
  }, /*#__PURE__*/React.createElement(Button, null, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.back"
  })), /*#__PURE__*/React.createElement(Button, null, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.next"
  }))));
};
var ApprovedApplications$6 = function ApprovedApplications() {
  var classes = useStyles$z();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ApplicationProcessSearcher$1, {
    disableButtons: 1,
    isApproved: true
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.pagination
  }, /*#__PURE__*/React.createElement(Button, null, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.back"
  })), /*#__PURE__*/React.createElement(Button, null, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.next"
  }))));
};
var ApplicantDashboard = function ApplicantDashboard() {
  var classes = useStyles$z();
  useHistory();
  // const isEisPath = isEisPath()
  // console.log({isEisPath})
  var _useState9 = useState(function () {
      var hash = window.location.hash.substring(1);
      return SidebarMenu$d.some(function (item) {
        return item.id === hash;
      }) ? hash : "pendingApplications";
    }),
    _useState10 = _slicedToArray(_useState9, 2),
    selectedMenu = _useState10[0],
    setSelectedMenu = _useState10[1];
  var renderContent = function renderContent() {
    useEffect(function () {
      window.history.pushState(null, "", "#".concat(selectedMenu));
    }, [selectedMenu]);
    switch (selectedMenu) {
      case "pendingApplications":
        return /*#__PURE__*/React.createElement(FiledApplications$c, null);
      case "newApplications":
        return isEisPath() ? /*#__PURE__*/React.createElement(EisMultiStepApplyForm$1, null) : /*#__PURE__*/React.createElement(MultiStepApplyForm, null);
      // case "newEisApplications":
      //   return <EisMultiStepApplyForm />;
      case "revertedApplication":
        return /*#__PURE__*/React.createElement(RevertApplication$5, null);
      case "rejectedApplication":
        return /*#__PURE__*/React.createElement(RejectApplication$7, null);
      case "applicationStatus":
        return /*#__PURE__*/React.createElement(ApplicationStatus$6, null);
      case "draftApplications":
        return /*#__PURE__*/React.createElement(DraftApplications$1, null);
      case "approvedApplications":
        return /*#__PURE__*/React.createElement(ApprovedApplications$6, null);
      default:
        return /*#__PURE__*/React.createElement(FiledApplications$c, null);
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: classes.root
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 2,
    className: classes.root
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 3
  }, /*#__PURE__*/React.createElement(Paper, {
    className: classes.sidebar
  }, /*#__PURE__*/React.createElement(List, null, SidebarMenu$d.map(function (item) {
    return /*#__PURE__*/React.createElement(ListItem, {
      button: true,
      key: item.id,
      selected: selectedMenu === item.id,
      onClick: function onClick() {
        return setSelectedMenu(item.id);
      }
    }, /*#__PURE__*/React.createElement(ListItemIcon, null, item.icon), /*#__PURE__*/React.createElement(ListItemText, {
      primary: item.text
    }));
  })))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 9,
    className: classes.content
  }, renderContent())));
};

var useStyles$y = makeStyles(function (theme) {
  return {
    root: {
      flexGrow: 1,
      padding: theme.spacing(2),
      height: 'calc(100vh - 64px)',
      // assuming 64px header/appbar, adjust as needed
      overflow: 'visible'
    },
    sidebar: {
      position: "sticky",
      top: 0,
      height: "40vh",
      backgroundColor: theme.palette.background.paper,
      borderRight: "1px solid ".concat(theme.palette.divider),
      overflowY: "auto"
    },
    content: {
      height: '100vh',
      overflowY: 'auto',
      padding: theme.spacing(2)
    },
    tableContainer: {
      marginTop: theme.spacing(0)
    },
    tableHeadCell: {
      fontWeight: "bold"
    },
    noData: {
      textAlign: "center",
      padding: theme.spacing(2)
    },
    searchInput: {
      border: "1px solid #ccc",
      borderRadius: 4,
      padding: "4px 8px",
      width: 200
    },
    pagination: {
      display: "flex",
      justifyContent: "flex-end",
      marginTop: theme.spacing(2),
      alignItems: "center"
    },
    tableHeader: {
      backgroundColor: "#B7D4D8"
    },
    accordion: {
      boxShadow: "1px 1px 1px 1px",
      border: "none",
      backgroundColor: "white",
      marginBottom: "12px",
      borderRadius: "6px",
      "&::before": {
        display: "none"
      }
    },
    accordionSummary: {
      padding: "8px 16px",
      backgroundColor: "white",
      borderRadius: "6px",
      "& .MuiTypography-root": {
        color: "#015C63",
        // teal-like tone
        fontWeight: 600
      }
    },
    accordionDetails: {
      backgroundColor: "white",
      padding: "16px",
      borderTop: "1px solid #ddd"
    }
  };
});
var SidebarMenu$c = [{
  id: "pendingApplications",
  text: /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.application.pending"
  }),
  icon: /*#__PURE__*/React.createElement(HourglassFullTwoToneIcon, null)
}, {
  id: "forwardedApplications",
  text: /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.application.forwarded"
  }),
  icon: /*#__PURE__*/React.createElement(ForwardIcon, null)
}, {
  id: "revertedApplication",
  text: /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.application.reverted"
  }),
  icon: /*#__PURE__*/React.createElement(RestorePageIcon, null)
}, {
  id: "returnedApplications",
  text: /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.application.returned"
  }),
  icon: /*#__PURE__*/React.createElement(ArrowBackIcon, null)
}];

// ----------- Components to Render in Main Content -----------

var ReturnedApplications$c = function ReturnedApplications() {
  var classes = useStyles$y();
  var loggedInUserId = useSelector(function (state) {
    var _state$core;
    return (_state$core = state.core) === null || _state$core === void 0 || (_state$core = _state$core.user) === null || _state$core === void 0 || (_state$core = _state$core.i_user) === null || _state$core === void 0 ? void 0 : _state$core.id;
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ApplicationProcessSearcher$1, {
    returnedApplications: true,
    loggedInUserId: loggedInUserId,
    disableButtons: 1,
    dynamicTableTitle: "workforce.application.returned",
    isMenuFilter: true
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.pagination
  }, /*#__PURE__*/React.createElement(Button, null, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.back"
  })), /*#__PURE__*/React.createElement(Button, null, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.next"
  }))));
};
var FiledApplications$b = function FiledApplications() {
  var classes = useStyles$y();
  var loggedInUserId = useSelector(function (state) {
    var _state$core2;
    return (_state$core2 = state.core) === null || _state$core2 === void 0 || (_state$core2 = _state$core2.user) === null || _state$core2 === void 0 || (_state$core2 = _state$core2.i_user) === null || _state$core2 === void 0 ? void 0 : _state$core2.id;
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Card, {
    className: classes.tableContainer
  }, /*#__PURE__*/React.createElement(CardContent, null, /*#__PURE__*/React.createElement(ApplicationProcessSearcher$1, {
    loggedInUserId: loggedInUserId,
    filedApplications: true,
    isMenuFilter: true,
    coloredRow: true
  }))), /*#__PURE__*/React.createElement("div", {
    className: classes.pagination
  }, /*#__PURE__*/React.createElement(Button, null, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.back"
  })), /*#__PURE__*/React.createElement(Button, null, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.next"
  }))));
};
var ForwardedApplications$4 = function ForwardedApplications() {
  var classes = useStyles$y();
  var loggedInUserId = useSelector(function (state) {
    var _state$core3;
    return (_state$core3 = state.core) === null || _state$core3 === void 0 || (_state$core3 = _state$core3.user) === null || _state$core3 === void 0 || (_state$core3 = _state$core3.i_user) === null || _state$core3 === void 0 ? void 0 : _state$core3.id;
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Card, {
    className: classes.tableContainer
  }, /*#__PURE__*/React.createElement(CardContent, null, /*#__PURE__*/React.createElement(ApplicationProcessSearcher$1, {
    loggedInUserId: loggedInUserId,
    forwardedApplications: true,
    isMenuFilter: true
  }))), /*#__PURE__*/React.createElement("div", {
    className: classes.pagination
  }, /*#__PURE__*/React.createElement(Button, null, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.back"
  })), /*#__PURE__*/React.createElement(Button, null, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.next"
  }))));
};
var RevertedApplications$3 = function RevertedApplications() {
  var classes = useStyles$y();
  var loggedInUserId = useSelector(function (state) {
    var _state$core4;
    return (_state$core4 = state.core) === null || _state$core4 === void 0 || (_state$core4 = _state$core4.user) === null || _state$core4 === void 0 || (_state$core4 = _state$core4.i_user) === null || _state$core4 === void 0 ? void 0 : _state$core4.id;
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Card, {
    className: classes.tableContainer
  }, /*#__PURE__*/React.createElement(CardContent, null, /*#__PURE__*/React.createElement(ApplicationProcessSearcher$1, {
    loggedInUserId: loggedInUserId,
    revertedApplication: true,
    isMenuFilter: true
  }))), /*#__PURE__*/React.createElement("div", {
    className: classes.pagination
  }, /*#__PURE__*/React.createElement(Button, null, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.back"
  })), /*#__PURE__*/React.createElement(Button, null, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.next"
  }))));
};

// ------------------------------------------------------------

var CheckerDashboard = function CheckerDashboard() {
  var classes = useStyles$y();
  var _useState = useState("pendingApplications"),
    _useState2 = _slicedToArray(_useState, 2),
    selectedMenu = _useState2[0],
    setSelectedMenu = _useState2[1];
  var user_type = getUserType();
  var renderContent = function renderContent() {
    switch (selectedMenu) {
      case "pendingApplications":
        return /*#__PURE__*/React.createElement(FiledApplications$b, null);
      case "forwardedApplications":
        return /*#__PURE__*/React.createElement(ForwardedApplications$4, null);
      case "revertedApplication":
        return /*#__PURE__*/React.createElement(RevertedApplications$3, null);
      case "returnedApplications":
        return /*#__PURE__*/React.createElement(ReturnedApplications$c, null);
      default:
        return /*#__PURE__*/React.createElement(FiledApplications$b, null);
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: classes.root
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 2,
    className: classes.root
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 3
  }, /*#__PURE__*/React.createElement(Paper, {
    className: classes.sidebar
  }, /*#__PURE__*/React.createElement(List, null, SidebarMenu$c.map(function (item) {
    return /*#__PURE__*/React.createElement(ListItem, {
      button: true,
      key: item.id,
      selected: selectedMenu === item.id,
      onClick: function onClick() {
        return setSelectedMenu(item.id);
      }
    }, /*#__PURE__*/React.createElement(ListItemIcon, null, item.icon), /*#__PURE__*/React.createElement(ListItemText, {
      primary: item.text
    }));
  })))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 9,
    className: classes.content
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5",
    gutterBottom: true
  }, user_type === WORKFORCE_USER_TYPE.CHECKER &&
  /*#__PURE__*/
  // <FormattedMessage module="workforce" id="workforce.checker1.dashboard" />
  React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.dashboard"
  }), user_type === WORKFORCE_USER_TYPE.CHECKER_TWO &&
  /*#__PURE__*/
  // <FormattedMessage module="workforce" id="workforce.checker2.dashboard" />
  React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.dashboard"
  }), user_type === WORKFORCE_USER_TYPE.BLWF_CHECKER && /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.blwf.checker.dashboard"
  }), user_type === WORKFORCE_USER_TYPE.BLWF_DOL_DIFE && /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.blwf.dol-dife.dashboard"
  }), user_type === WORKFORCE_USER_TYPE.EIS_OFFICER && /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.eis.officer.dashboard"
  })), renderContent())));
};

var useStyles$x = makeStyles(function (theme) {
  return {
    root: {
      flexGrow: 1,
      padding: theme.spacing(2),
      height: 'calc(100vh - 64px)',
      // assuming 64px header/appbar, adjust as needed
      overflow: 'visible'
    },
    sidebar: {
      position: "sticky",
      top: 0,
      height: "40vh",
      backgroundColor: theme.palette.background.paper,
      borderRight: "1px solid ".concat(theme.palette.divider),
      overflowY: "auto"
    },
    content: {
      height: '100vh',
      overflowY: 'auto',
      padding: theme.spacing(2)
    },
    tableContainer: {
      marginTop: theme.spacing(0)
    },
    tableHeadCell: {
      fontWeight: "bold"
    },
    noData: {
      textAlign: "center",
      padding: theme.spacing(2)
    },
    searchInput: {
      border: "1px solid #ccc",
      borderRadius: 4,
      padding: "4px 8px",
      width: 200
    },
    pagination: {
      display: "flex",
      justifyContent: "flex-end",
      marginTop: theme.spacing(2),
      alignItems: "center"
    },
    tableHeader: {
      backgroundColor: "#B7D4D8"
    },
    accordion: {
      boxShadow: "1px 1px 1px 1px",
      border: "none",
      backgroundColor: "white",
      marginBottom: "12px",
      borderRadius: "6px",
      "&::before": {
        display: "none"
      }
    },
    accordionSummary: {
      padding: "8px 16px",
      backgroundColor: "white",
      borderRadius: "6px",
      "& .MuiTypography-root": {
        color: "#015C63",
        // teal-like tone
        fontWeight: 600
      }
    },
    accordionDetails: {
      backgroundColor: "white",
      padding: "16px",
      borderTop: "1px solid #ddd"
    }
  };
});
var SidebarMenu$b = [{
  id: "pendingApplications",
  text: /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.application.pending"
  }),
  icon: /*#__PURE__*/React.createElement(HourglassFullTwoToneIcon, null)
}, {
  id: "forwardedApplications",
  text: /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.application.forwarded"
  }),
  icon: /*#__PURE__*/React.createElement(ForwardIcon, null)
}, {
  id: "revertedApplications",
  text: /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.application.reverted"
  }),
  icon: /*#__PURE__*/React.createElement(RestorePageIcon, null)
}, {
  id: "returnedApplications",
  text: /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.application.returned"
  }),
  icon: /*#__PURE__*/React.createElement(ArrowBackIcon, null)
}];

// ----------- Components to Render in Main Content -----------

var FiledApplications$a = function FiledApplications() {
  var classes = useStyles$x();
  var loggedInUserId = useSelector(function (state) {
    var _state$core;
    return (_state$core = state.core) === null || _state$core === void 0 || (_state$core = _state$core.user) === null || _state$core === void 0 || (_state$core = _state$core.i_user) === null || _state$core === void 0 ? void 0 : _state$core.id;
  });
  var user_type = getUserType();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5",
    gutterBottom: true
  }, user_type === WORKFORCE_USER_TYPE.SEC1_DEPUTI_ASST_DIRECTOR && /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.section1.deputy1.admin.dashboard"
  }), user_type === WORKFORCE_USER_TYPE.SEC2_DEPUTI_ASST_DIRECTOR && /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.section2.deputy2.admin.dashboard"
  }), user_type === WORKFORCE_USER_TYPE.BLWF_DEPUTI_ASST_DIRECTOR && /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.blwf.deputy.admin.dashboard"
  })), /*#__PURE__*/React.createElement(Card, {
    className: classes.tableContainer
  }, /*#__PURE__*/React.createElement(CardContent, null, /*#__PURE__*/React.createElement(ApplicationProcessSearcher$1, {
    oggedInUserId: loggedInUserId,
    filedApplications: true,
    isMenuFilter: true,
    coloredRow: true
  }))), /*#__PURE__*/React.createElement("div", {
    className: classes.pagination
  }, /*#__PURE__*/React.createElement(Button, null, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.back"
  })), /*#__PURE__*/React.createElement(Button, null, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.next"
  }))));
};
var ForwardedApplications$3 = function ForwardedApplications() {
  var classes = useStyles$x();
  var loggedInUserId = useSelector(function (state) {
    var _state$core2;
    return (_state$core2 = state.core) === null || _state$core2 === void 0 || (_state$core2 = _state$core2.user) === null || _state$core2 === void 0 || (_state$core2 = _state$core2.i_user) === null || _state$core2 === void 0 ? void 0 : _state$core2.id;
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Card, {
    className: classes.tableContainer
  }, /*#__PURE__*/React.createElement(CardContent, null, /*#__PURE__*/React.createElement(ApplicationProcessSearcher$1, {
    loggedInUserId: loggedInUserId,
    forwardedApplications: true,
    isMenuFilter: true
  }))), /*#__PURE__*/React.createElement("div", {
    className: classes.pagination
  }, /*#__PURE__*/React.createElement(Button, null, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.back"
  })), /*#__PURE__*/React.createElement(Button, null, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.next"
  }))));
};
var RevertedApplications$2 = function RevertedApplications() {
  var classes = useStyles$x();
  var loggedInUserId = useSelector(function (state) {
    var _state$core3;
    return (_state$core3 = state.core) === null || _state$core3 === void 0 || (_state$core3 = _state$core3.user) === null || _state$core3 === void 0 || (_state$core3 = _state$core3.i_user) === null || _state$core3 === void 0 ? void 0 : _state$core3.id;
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Card, {
    className: classes.tableContainer
  }, /*#__PURE__*/React.createElement(CardContent, null, /*#__PURE__*/React.createElement(ApplicationProcessSearcher$1, {
    loggedInUserId: loggedInUserId,
    revertedApplication: true,
    isMenuFilter: true
  }))), /*#__PURE__*/React.createElement("div", {
    className: classes.pagination
  }, /*#__PURE__*/React.createElement(Button, null, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.back"
  })), /*#__PURE__*/React.createElement(Button, null, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.next"
  }))));
};
var ReturnedApplications$b = function ReturnedApplications() {
  var classes = useStyles$x();
  var loggedInUserId = useSelector(function (state) {
    var _state$core4;
    return (_state$core4 = state.core) === null || _state$core4 === void 0 || (_state$core4 = _state$core4.user) === null || _state$core4 === void 0 || (_state$core4 = _state$core4.i_user) === null || _state$core4 === void 0 ? void 0 : _state$core4.id;
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ApplicationProcessSearcher$1, {
    returnedApplications: true,
    loggedInUserId: loggedInUserId,
    disableButtons: 1,
    dynamicTableTitle: "workforce.application.returned",
    isMenuFilter: true
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.pagination
  }, /*#__PURE__*/React.createElement(Button, null, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.back"
  })), /*#__PURE__*/React.createElement(Button, null, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.next"
  }))));
};
// ------------------------------------------------------------

var DeputyAsstDirectorDashboardPage = function DeputyAsstDirectorDashboardPage() {
  var classes = useStyles$x();
  var dispatch = useDispatch();
  var modulesManager = useModulesManager();
  var _useState = useState("pendingApplications"),
    _useState2 = _slicedToArray(_useState, 2),
    selectedMenu = _useState2[0],
    setSelectedMenu = _useState2[1];
  useEffect(function () {
    return dispatch(fetchSummaryApplications(modulesManager, ['status:"meeting_created"']));
  }, []);
  useSelector(function (state) {
    var _state$workforce;
    return (_state$workforce = state.workforce["applicationsSummary"]) !== null && _state$workforce !== void 0 ? _state$workforce : [];
  });
  var renderContent = function renderContent() {
    switch (selectedMenu) {
      case "pendingApplications":
        return /*#__PURE__*/React.createElement(FiledApplications$a, null);
      case "forwardedApplications":
        return /*#__PURE__*/React.createElement(ForwardedApplications$3, null);
      case "revertedApplications":
        return /*#__PURE__*/React.createElement(RevertedApplications$2, null);
      case "returnedApplications":
        return /*#__PURE__*/React.createElement(ReturnedApplications$b, null);
      default:
        return /*#__PURE__*/React.createElement(FiledApplications$a, null);
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: classes.root
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 2,
    className: classes.root
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 3
  }, /*#__PURE__*/React.createElement(Paper, {
    className: classes.sidebar
  }, /*#__PURE__*/React.createElement(List, null, SidebarMenu$b.map(function (item) {
    return /*#__PURE__*/React.createElement(ListItem, {
      button: true,
      key: item.id,
      selected: selectedMenu === item.id,
      onClick: function onClick() {
        return setSelectedMenu(item.id);
      }
    }, /*#__PURE__*/React.createElement(ListItemIcon, null, item.icon), /*#__PURE__*/React.createElement(ListItemText, {
      primary: item.text
    }));
  })))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 9,
    className: classes.content
  }, renderContent())));
};

var useStyles$w = makeStyles(function (theme) {
  return {
    root: {
      flexGrow: 1,
      padding: theme.spacing(2),
      height: 'calc(100vh - 64px)',
      // assuming 64px header/appbar, adjust as needed
      overflow: 'visible'
    },
    sidebar: {
      position: "sticky",
      top: 0,
      height: "40vh",
      backgroundColor: theme.palette.background.paper,
      borderRight: "1px solid ".concat(theme.palette.divider),
      overflowY: "auto"
    },
    content: {
      height: '100vh',
      overflowY: 'auto',
      padding: theme.spacing(2)
    },
    tableContainer: {
      marginTop: theme.spacing(0)
    },
    tableHeadCell: {
      fontWeight: "bold"
    },
    noData: {
      textAlign: "center",
      padding: theme.spacing(2)
    },
    searchInput: {
      border: "1px solid #ccc",
      borderRadius: 4,
      padding: "4px 8px",
      width: 200
    },
    pagination: {
      display: "flex",
      justifyContent: "flex-end",
      marginTop: theme.spacing(2),
      alignItems: "center"
    },
    tableHeader: {
      backgroundColor: "#B7D4D8"
    },
    accordion: {
      boxShadow: "1px 1px 1px 1px",
      border: "none",
      backgroundColor: "white",
      marginBottom: "12px",
      borderRadius: "6px",
      "&::before": {
        display: "none"
      }
    },
    accordionSummary: {
      padding: "8px 16px",
      backgroundColor: "white",
      borderRadius: "6px",
      "& .MuiTypography-root": {
        color: "#015C63",
        // teal-like tone
        fontWeight: 600
      }
    },
    accordionDetails: {
      backgroundColor: "white",
      padding: "16px",
      borderTop: "1px solid #ddd"
    }
  };
});
var SidebarMenu$a = [{
  id: "pendingApplications",
  text: /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.application.pending"
  }),
  icon: /*#__PURE__*/React.createElement(HourglassFullTwoToneIcon, null)
}, {
  id: "forwardedApplications",
  text: /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.application.forwarded"
  }),
  icon: /*#__PURE__*/React.createElement(ArrowForwardIcon, null)
}, {
  id: "approvedApplications",
  text: /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.application.approved"
  }),
  icon: /*#__PURE__*/React.createElement(ArrowForwardIcon, null)
},
// {
//   id: "revertedApplication",
//   text: (
//     <FormattedMessage module="workforce" id="workforce.application.reverted" />
//   ),
//   icon: <RestorePageIcon />,
// },
{
  id: "returnedApplication",
  text: /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.application.returned"
  }),
  icon: /*#__PURE__*/React.createElement(ArrowBackIcon, null)
}];

// ----------- Components to Render in Main Content -----------

var FiledApplications$9 = function FiledApplications() {
  var classes = useStyles$w();
  var dispatch = useDispatch();
  var loggedInUserId = useSelector(function (state) {
    var _state$core;
    return (_state$core = state.core) === null || _state$core === void 0 || (_state$core = _state$core.user) === null || _state$core === void 0 || (_state$core = _state$core.i_user) === null || _state$core === void 0 ? void 0 : _state$core.id;
  });
  var language = useSelector(function (state) {
    var _state$core2;
    return (_state$core2 = state.core) === null || _state$core2 === void 0 || (_state$core2 = _state$core2.user) === null || _state$core2 === void 0 || (_state$core2 = _state$core2.i_user) === null || _state$core2 === void 0 ? void 0 : _state$core2.language;
  });
  var _useState = useState(""),
    _useState2 = _slicedToArray(_useState, 2),
    associationNames = _useState2[0],
    setAssociationNames = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    associations = _useState4[0],
    setAssociations = _useState4[1];
  useEffect(function () {
    if (!loggedInUserId) return;
    var filters = [];
    filters.push("userId:" + loggedInUserId);
    dispatch(fetchWorkforceAssociationUserMaps(filters)).then(function (response) {
      var _response$payload$dat, _response$payload;
      var edges = (_response$payload$dat = response === null || response === void 0 || (_response$payload = response.payload) === null || _response$payload === void 0 || (_response$payload = _response$payload.data) === null || _response$payload === void 0 || (_response$payload = _response$payload.workforceAssociationUserMap) === null || _response$payload === void 0 ? void 0 : _response$payload.edges) !== null && _response$payload$dat !== void 0 ? _response$payload$dat : [];
      setAssociations(edges.map(function (a) {
        var _a$node;
        return a === null || a === void 0 || (_a$node = a.node) === null || _a$node === void 0 ? void 0 : _a$node.allAssociation.id;
      }));
      var names = edges.map(function (a) {
        var _a$node2, _a$node3;
        return language === "en" ? a === null || a === void 0 || (_a$node2 = a.node) === null || _a$node2 === void 0 || (_a$node2 = _a$node2.allAssociation) === null || _a$node2 === void 0 ? void 0 : _a$node2.shortNameEn : a === null || a === void 0 || (_a$node3 = a.node) === null || _a$node3 === void 0 || (_a$node3 = _a$node3.allAssociation) === null || _a$node3 === void 0 ? void 0 : _a$node3.shortNameBn;
      }).join(", ");
      setAssociationNames(names);
    })["catch"](function (err) {
      console.error("Association fetch error:", err);
    });
  }, [dispatch, loggedInUserId, language]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5",
    gutterBottom: true
  }, associationNames && associationNames != "" ? associationNames + " " : "", /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.dashboard"
  })), /*#__PURE__*/React.createElement(Card, {
    className: classes.tableContainer
  }, /*#__PURE__*/React.createElement(CardContent, null, /*#__PURE__*/React.createElement(ApplicationProcessSearcher$1, {
    associationIds: associations,
    loggedInUserId: loggedInUserId,
    coloredRow: true
  }))), /*#__PURE__*/React.createElement("div", {
    className: classes.pagination
  }, /*#__PURE__*/React.createElement(Button, null, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.back"
  })), /*#__PURE__*/React.createElement(Button, null, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.next"
  }))));
};
var ReturnedApplications$a = function ReturnedApplications() {
  var classes = useStyles$w();
  var dispatch = useDispatch();
  var loggedInUserId = useSelector(function (state) {
    var _state$core3;
    return (_state$core3 = state.core) === null || _state$core3 === void 0 || (_state$core3 = _state$core3.user) === null || _state$core3 === void 0 || (_state$core3 = _state$core3.i_user) === null || _state$core3 === void 0 ? void 0 : _state$core3.id;
  });
  var language = useSelector(function (state) {
    var _state$core4;
    return (_state$core4 = state.core) === null || _state$core4 === void 0 || (_state$core4 = _state$core4.user) === null || _state$core4 === void 0 || (_state$core4 = _state$core4.i_user) === null || _state$core4 === void 0 ? void 0 : _state$core4.language;
  });
  var _useState5 = useState(""),
    _useState6 = _slicedToArray(_useState5, 2);
    _useState6[0];
    var setAssociationNames = _useState6[1];
  var _useState7 = useState([]),
    _useState8 = _slicedToArray(_useState7, 2),
    associations = _useState8[0],
    setAssociations = _useState8[1];
  useEffect(function () {
    if (!loggedInUserId) return;
    var filters = [];
    filters.push("userId:" + loggedInUserId);
    dispatch(fetchWorkforceAssociationUserMaps(filters)).then(function (response) {
      var _response$payload$dat2, _response$payload2;
      var edges = (_response$payload$dat2 = response === null || response === void 0 || (_response$payload2 = response.payload) === null || _response$payload2 === void 0 || (_response$payload2 = _response$payload2.data) === null || _response$payload2 === void 0 || (_response$payload2 = _response$payload2.workforceAssociationUserMap) === null || _response$payload2 === void 0 ? void 0 : _response$payload2.edges) !== null && _response$payload$dat2 !== void 0 ? _response$payload$dat2 : [];
      setAssociations(edges.map(function (a) {
        var _a$node4;
        return a === null || a === void 0 || (_a$node4 = a.node) === null || _a$node4 === void 0 ? void 0 : _a$node4.allAssociation.id;
      }));
      var names = edges.map(function (a) {
        var _a$node5, _a$node6;
        return language === "en" ? a === null || a === void 0 || (_a$node5 = a.node) === null || _a$node5 === void 0 || (_a$node5 = _a$node5.allAssociation) === null || _a$node5 === void 0 ? void 0 : _a$node5.shortNameEn : a === null || a === void 0 || (_a$node6 = a.node) === null || _a$node6 === void 0 || (_a$node6 = _a$node6.allAssociation) === null || _a$node6 === void 0 ? void 0 : _a$node6.shortNameBn;
      }).join(", ");
      setAssociationNames(names);
    })["catch"](function (err) {
      console.error("Association fetch error:", err);
    });
  }, [dispatch, loggedInUserId, language]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ApplicationProcessSearcher$1
  // returnedApplications={true}
  , {
    revertedApplication: true,
    loggedInUserId: loggedInUserId,
    associationIds: associations,
    disableButtons: 1,
    dynamicTableTitle: "workforce.application.returned"
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.pagination
  }, /*#__PURE__*/React.createElement(Button, null, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.back"
  })), /*#__PURE__*/React.createElement(Button, null, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.next"
  }))));
};
var ForwardedApplications$2 = function ForwardedApplications() {
  var classes = useStyles$w();
  var dispatch = useDispatch();
  var loggedInUserId = useSelector(function (state) {
    var _state$core5;
    return (_state$core5 = state.core) === null || _state$core5 === void 0 || (_state$core5 = _state$core5.user) === null || _state$core5 === void 0 || (_state$core5 = _state$core5.i_user) === null || _state$core5 === void 0 ? void 0 : _state$core5.id;
  });
  var language = useSelector(function (state) {
    var _state$core6;
    return (_state$core6 = state.core) === null || _state$core6 === void 0 || (_state$core6 = _state$core6.user) === null || _state$core6 === void 0 || (_state$core6 = _state$core6.i_user) === null || _state$core6 === void 0 ? void 0 : _state$core6.language;
  });
  var _useState9 = useState(""),
    _useState10 = _slicedToArray(_useState9, 2);
    _useState10[0];
    var setAssociationNames = _useState10[1];
  var _useState11 = useState([]),
    _useState12 = _slicedToArray(_useState11, 2),
    associations = _useState12[0],
    setAssociations = _useState12[1];
  useEffect(function () {
    if (!loggedInUserId) return;
    var filters = [];
    filters.push("userId:" + loggedInUserId);
    dispatch(fetchWorkforceAssociationUserMaps(filters)).then(function (response) {
      var _response$payload$dat3, _response$payload3;
      var edges = (_response$payload$dat3 = response === null || response === void 0 || (_response$payload3 = response.payload) === null || _response$payload3 === void 0 || (_response$payload3 = _response$payload3.data) === null || _response$payload3 === void 0 || (_response$payload3 = _response$payload3.workforceAssociationUserMap) === null || _response$payload3 === void 0 ? void 0 : _response$payload3.edges) !== null && _response$payload$dat3 !== void 0 ? _response$payload$dat3 : [];
      setAssociations(edges.map(function (a) {
        var _a$node7;
        return a === null || a === void 0 || (_a$node7 = a.node) === null || _a$node7 === void 0 ? void 0 : _a$node7.allAssociation.id;
      }));
      var names = edges.map(function (a) {
        var _a$node8, _a$node9;
        return language === "en" ? a === null || a === void 0 || (_a$node8 = a.node) === null || _a$node8 === void 0 || (_a$node8 = _a$node8.allAssociation) === null || _a$node8 === void 0 ? void 0 : _a$node8.shortNameEn : a === null || a === void 0 || (_a$node9 = a.node) === null || _a$node9 === void 0 || (_a$node9 = _a$node9.allAssociation) === null || _a$node9 === void 0 ? void 0 : _a$node9.shortNameBn;
      }).join(", ");
      setAssociationNames(names);
    })["catch"](function (err) {
      console.error("Association fetch error:", err);
    });
  }, [dispatch, loggedInUserId, language]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ApplicationProcessSearcher$1, {
    forwardedApplications: true,
    associationIds: associations,
    disableButtons: 1,
    dynamicTableTitle: "workforce.application.forwarded"
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.pagination
  }, /*#__PURE__*/React.createElement(Button, null, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.back"
  })), /*#__PURE__*/React.createElement(Button, null, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.next"
  }))));
};
var ApprovedApplications$5 = function ApprovedApplications() {
  var classes = useStyles$w();
  var dispatch = useDispatch();
  var loggedInUserId = useSelector(function (state) {
    var _state$core7;
    return (_state$core7 = state.core) === null || _state$core7 === void 0 || (_state$core7 = _state$core7.user) === null || _state$core7 === void 0 || (_state$core7 = _state$core7.i_user) === null || _state$core7 === void 0 ? void 0 : _state$core7.id;
  });
  var language = useSelector(function (state) {
    var _state$core8;
    return (_state$core8 = state.core) === null || _state$core8 === void 0 || (_state$core8 = _state$core8.user) === null || _state$core8 === void 0 || (_state$core8 = _state$core8.i_user) === null || _state$core8 === void 0 ? void 0 : _state$core8.language;
  });
  var _useState13 = useState(""),
    _useState14 = _slicedToArray(_useState13, 2);
    _useState14[0];
    var setAssociationNames = _useState14[1];
  var _useState15 = useState([]),
    _useState16 = _slicedToArray(_useState15, 2),
    associations = _useState16[0],
    setAssociations = _useState16[1];
  useEffect(function () {
    if (!loggedInUserId) return;
    var filters = [];
    filters.push("userId:" + loggedInUserId);
    dispatch(fetchWorkforceAssociationUserMaps(filters)).then(function (response) {
      var _response$payload$dat4, _response$payload4;
      var edges = (_response$payload$dat4 = response === null || response === void 0 || (_response$payload4 = response.payload) === null || _response$payload4 === void 0 || (_response$payload4 = _response$payload4.data) === null || _response$payload4 === void 0 || (_response$payload4 = _response$payload4.workforceAssociationUserMap) === null || _response$payload4 === void 0 ? void 0 : _response$payload4.edges) !== null && _response$payload$dat4 !== void 0 ? _response$payload$dat4 : [];
      setAssociations(edges.map(function (a) {
        var _a$node10;
        return a === null || a === void 0 || (_a$node10 = a.node) === null || _a$node10 === void 0 ? void 0 : _a$node10.allAssociation.id;
      }));
      var names = edges.map(function (a) {
        var _a$node11, _a$node12;
        return language === "en" ? a === null || a === void 0 || (_a$node11 = a.node) === null || _a$node11 === void 0 || (_a$node11 = _a$node11.allAssociation) === null || _a$node11 === void 0 ? void 0 : _a$node11.shortNameEn : a === null || a === void 0 || (_a$node12 = a.node) === null || _a$node12 === void 0 || (_a$node12 = _a$node12.allAssociation) === null || _a$node12 === void 0 ? void 0 : _a$node12.shortNameBn;
      }).join(", ");
      setAssociationNames(names);
    })["catch"](function (err) {
      console.error("Association fetch error:", err);
    });
  }, [dispatch, loggedInUserId, language]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ApplicationProcessSearcher$1, {
    approvedApplications: true,
    associationIds: associations,
    disableButtons: 1,
    dynamicTableTitle: "workforce.application.forwarded"
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.pagination
  }, /*#__PURE__*/React.createElement(Button, null, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.back"
  })), /*#__PURE__*/React.createElement(Button, null, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.next"
  }))));
};

// ------------------------------------------------------------

var AssociationDashboard = function AssociationDashboard() {
  var classes = useStyles$w();
  var dispatch = useDispatch();
  var modulesManager = useModulesManager();
  var _useState17 = useState("pendingApplications"),
    _useState18 = _slicedToArray(_useState17, 2),
    selectedMenu = _useState18[0],
    setSelectedMenu = _useState18[1];
  useEffect(function () {
    return dispatch(fetchSummaryApplications(modulesManager, ['status:"meeting_created"']));
  }, []);
  useSelector(function (state) {
    var _state$workforce;
    return (_state$workforce = state.workforce["applicationsSummary"]) !== null && _state$workforce !== void 0 ? _state$workforce : [];
  });
  var renderContent = function renderContent() {
    switch (selectedMenu) {
      case "pendingApplications":
        return /*#__PURE__*/React.createElement(FiledApplications$9, null);
      case "forwardedApplications":
        return /*#__PURE__*/React.createElement(ForwardedApplications$2, null);
      case "approvedApplications":
        return /*#__PURE__*/React.createElement(ApprovedApplications$5, null);
      // case "revertedApplication":
      //   return <RevertApplication />;
      case "returnedApplication":
        return /*#__PURE__*/React.createElement(ReturnedApplications$a, null);
      default:
        return /*#__PURE__*/React.createElement(FiledApplications$9, null);
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: classes.root
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 2,
    className: classes.root
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 3
  }, /*#__PURE__*/React.createElement(Paper, {
    className: classes.sidebar
  }, /*#__PURE__*/React.createElement(List, null, SidebarMenu$a.map(function (item) {
    return /*#__PURE__*/React.createElement(ListItem, {
      button: true,
      key: item.id,
      selected: selectedMenu === item.id,
      onClick: function onClick() {
        return setSelectedMenu(item.id);
      }
    }, /*#__PURE__*/React.createElement(ListItemIcon, null, item.icon), /*#__PURE__*/React.createElement(ListItemText, {
      primary: item.text
    }));
  })))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 9,
    className: classes.content
  }, renderContent())));
};

var useStyles$v = makeStyles(function (theme) {
  return {
    root: {
      flexGrow: 1,
      padding: theme.spacing(2),
      height: "calc(100vh - 64px)",
      // assuming 64px header/appbar, adjust as needed
      overflow: "visible"
    },
    sidebar: {
      position: "sticky",
      top: 0,
      height: "40vh",
      backgroundColor: theme.palette.background.paper,
      borderRight: "1px solid ".concat(theme.palette.divider),
      overflowY: "auto"
    },
    content: {
      height: "100vh",
      overflowY: "auto",
      padding: theme.spacing(2)
    },
    tableContainer: {
      marginTop: theme.spacing(0)
    },
    tableHeadCell: {
      fontWeight: "bold"
    },
    noData: {
      textAlign: "center",
      padding: theme.spacing(2)
    },
    searchInput: {
      border: "1px solid #ccc",
      borderRadius: 4,
      padding: "4px 8px",
      width: 200
    },
    pagination: {
      display: "flex",
      justifyContent: "flex-end",
      marginTop: theme.spacing(2),
      alignItems: "center"
    },
    tableHeader: {
      backgroundColor: "#B7D4D8"
    },
    accordion: {
      boxShadow: "1px 1px 1px 1px",
      border: "none",
      backgroundColor: "white",
      marginBottom: "12px",
      borderRadius: "6px",
      "&::before": {
        display: "none"
      }
    },
    accordionPadding: {
      paddingBottom: "40px !important"
    },
    accordionSummary: {
      padding: "8px 16px",
      backgroundColor: "white",
      borderRadius: "6px",
      "& .MuiTypography-root": {
        color: "#015C63",
        // teal-like tone
        fontWeight: 600
      }
    },
    accordionDetails: {
      backgroundColor: "white",
      padding: "16px",
      borderTop: "1px solid #ddd"
    }
  };
});
var SidebarMenu$9 = [{
  id: "pendingMeetingSheet",
  text: /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.employee.application.meetingSheet"
  }),
  icon: /*#__PURE__*/React.createElement(HourglassFullTwoToneIcon, null)
}, {
  id: "approveMeetingSheet",
  text: /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.application.forwarded"
  }),
  icon: /*#__PURE__*/React.createElement(CheckCircleOutlineTwoToneIcon, null)
}, {
  id: "revertedApplications",
  text: /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.application.reverted"
  }),
  icon: /*#__PURE__*/React.createElement(RestorePageIcon, null)
}, {
  id: "returnedApplications",
  text: /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.application.returned"
  }),
  icon: /*#__PURE__*/React.createElement(ArrowBackIcon, null)
}, {
  id: "rejectedApplications",
  text: /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.application.rejected"
  }),
  // Add appropriate i18n id
  icon: /*#__PURE__*/React.createElement(CancelTwoToneIcon, null)
}];

// ----------- Components to Render in Main Content -----------

var ReturnedApplications$9 = function ReturnedApplications() {
  var classes = useStyles$v();
  var loggedInUserId = useSelector(function (state) {
    var _state$core;
    return (_state$core = state.core) === null || _state$core === void 0 || (_state$core = _state$core.user) === null || _state$core === void 0 || (_state$core = _state$core.i_user) === null || _state$core === void 0 ? void 0 : _state$core.id;
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ApplicationProcessSearcher$1, {
    returnedApplications: true,
    loggedInUserId: loggedInUserId,
    disableButtons: 1,
    dynamicTableTitle: "workforce.application.returned"
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.pagination
  }, /*#__PURE__*/React.createElement(Button, null, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.back"
  })), /*#__PURE__*/React.createElement(Button, null, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.next"
  }))));
};
var RevertedApplications$1 = function RevertedApplications() {
  var classes = useStyles$v();
  var loggedInUserId = useSelector(function (state) {
    var _state$core2;
    return (_state$core2 = state.core) === null || _state$core2 === void 0 || (_state$core2 = _state$core2.user) === null || _state$core2 === void 0 || (_state$core2 = _state$core2.i_user) === null || _state$core2 === void 0 ? void 0 : _state$core2.id;
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ApplicationProcessSearcher$1, {
    revertedApplications: true,
    loggedInUserId: loggedInUserId,
    disableButtons: 1,
    dynamicTableTitle: "workforce.application.reverted"
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.pagination
  }, /*#__PURE__*/React.createElement(Button, null, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.back"
  })), /*#__PURE__*/React.createElement(Button, null, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.next"
  }))));
};
var FiledApplications$8 = function FiledApplications(_ref) {
  var _ref$summaryData = _ref.summaryData,
    summaryData = _ref$summaryData === void 0 ? [] : _ref$summaryData,
    _ref$disableButtons = _ref.disableButtons,
    disableButtons = _ref$disableButtons === void 0 ? 0 : _ref$disableButtons;
    _ref.rejectedByCommittee;
  var classes = useStyles$v();
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    expanded = _useState2[0],
    setExpanded = _useState2[1];
  var _useState3 = useState(summaryData),
    _useState4 = _slicedToArray(_useState3, 2),
    currentData = _useState4[0],
    setCurrentData = _useState4[1];
  var _useState5 = useState(summaryData),
    _useState6 = _slicedToArray(_useState5, 2),
    originalData = _useState6[0],
    setOriginalData = _useState6[1];
  var loggedInUserId = useSelector(function (state) {
    var _state$core3;
    return (_state$core3 = state.core) === null || _state$core3 === void 0 || (_state$core3 = _state$core3.user) === null || _state$core3 === void 0 || (_state$core3 = _state$core3.i_user) === null || _state$core3 === void 0 ? void 0 : _state$core3.id;
  });

  // keep originalData and currentData in sync when props change
  useEffect(function () {
    setCurrentData(summaryData);
    setOriginalData(summaryData);
  }, [summaryData]);
  var handleChange = function handleChange(panelId) {
    return function (event, isExpanded) {
      if (isExpanded) {
        // move clicked item to top
        setCurrentData(function (prev) {
          var idx = prev.findIndex(function (item) {
            return item.id === panelId;
          });
          if (idx === -1) return prev;
          var newList = _toConsumableArray(prev);
          var _newList$splice = newList.splice(idx, 1),
            _newList$splice2 = _slicedToArray(_newList$splice, 1),
            selected = _newList$splice2[0];
          newList.unshift(selected);
          return newList;
        });
        setExpanded(panelId);
      } else {
        setExpanded(null);
        setCurrentData(originalData);
      }
    };
  };
  return /*#__PURE__*/React.createElement("div", {
    className: classes.accordionPadding
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5",
    gutterBottom: true
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.cf.approver.dashboard"
  })), currentData.map(function (item) {
    return /*#__PURE__*/React.createElement(Accordion, {
      key: item.id,
      expanded: expanded === item.id,
      onChange: handleChange(item.id),
      className: classes.accordion
    }, /*#__PURE__*/React.createElement(AccordionSummary, {
      className: classes.accordionSummary,
      expandIcon: /*#__PURE__*/React.createElement(ExpandMoreIcon, {
        className: "material-icons"
      })
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "subtitle1",
      style: {
        flex: 1
      }
    }, /*#__PURE__*/React.createElement("strong", null, item.name)), /*#__PURE__*/React.createElement(Typography, {
      variant: "body2",
      style: {
        marginLeft: "auto",
        color: "#015C63"
      }
    }, item.meetingDate, " | ", item.month, " ", item.year)), /*#__PURE__*/React.createElement(AccordionDetails, {
      className: classes.accordionDetails
    }, /*#__PURE__*/React.createElement(Card, {
      style: {
        width: "100%"
      }
    }, /*#__PURE__*/React.createElement(CardContent, null, expanded === item.id && /*#__PURE__*/React.createElement(ApplicationProcessSearcher$1, {
      summaryId: item.id,
      disableButtons: disableButtons,
      loggedInUserId: loggedInUserId,
      coloredRow: true,
      summaryData: item
    })))));
  }));
};
var RejectedApplications$4 = function RejectedApplications(_ref2) {
  var _ref2$disableButtons = _ref2.disableButtons,
    disableButtons = _ref2$disableButtons === void 0 ? 0 : _ref2$disableButtons;
  var classes = useStyles$v();
  var dispatch = useDispatch();
  var modulesManager = useModulesManager();
  var _useState7 = useState(null),
    _useState8 = _slicedToArray(_useState7, 2),
    expanded = _useState8[0],
    setExpanded = _useState8[1];
  var loggedInUserId = useSelector(function (state) {
    var _state$core4;
    return (_state$core4 = state.core) === null || _state$core4 === void 0 || (_state$core4 = _state$core4.user) === null || _state$core4 === void 0 || (_state$core4 = _state$core4.i_user) === null || _state$core4 === void 0 ? void 0 : _state$core4.id;
  });
  useEffect(function () {
    // Adjust the fetch action/parameters for rejected applications as needed
    dispatch(fetchSummaryApplications(modulesManager, ['organizationType:"cf"', 'status:"forward_to_comiitee"', 'applicationStatusIn:["rejected_by_committee"]']));
  }, [dispatch, modulesManager]);
  var data = useSelector(function (state) {
    var _state$workforce;
    return (_state$workforce = state.workforce["applicationsSummary"]) !== null && _state$workforce !== void 0 ? _state$workforce : [];
  });
  var handleChange = function handleChange(panelId) {
    return function (event, isExpanded) {
      setExpanded(isExpanded ? panelId : null);
    };
  };
  return /*#__PURE__*/React.createElement("div", {
    className: classes.accordionPadding
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5",
    gutterBottom: true
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.dashboard"
  })), data.map(function (item, index) {
    return /*#__PURE__*/React.createElement(Accordion, {
      key: index,
      expanded: expanded === item.id,
      onChange: handleChange(item.id),
      className: classes.accordion
    }, /*#__PURE__*/React.createElement(AccordionSummary, {
      className: classes.accordionSummary,
      expandIcon: /*#__PURE__*/React.createElement(ExpandMoreIcon, {
        className: "material-icons"
      })
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "subtitle1",
      style: {
        flex: 1
      }
    }, /*#__PURE__*/React.createElement("strong", null, item.name)), /*#__PURE__*/React.createElement(Typography, {
      variant: "body2",
      style: {
        marginLeft: "auto",
        color: "#015C63"
      }
    }, item.meetingDate, " | ", item.month, " ", item.year)), /*#__PURE__*/React.createElement(AccordionDetails, {
      className: classes.accordionDetails
    }, /*#__PURE__*/React.createElement(Card, {
      style: {
        width: "100%"
      }
    }, /*#__PURE__*/React.createElement(CardContent, null, expanded === item.id && /*#__PURE__*/React.createElement(ApplicationProcessSearcher$1, {
      coloredRow: true,
      summaryId: item.id,
      loggedInUserId: loggedInUserId,
      disableButtons: disableButtons,
      statusInSummary: "rejected_by_committee"
    })))));
  }));
};

// ------------------------------------------------------------

var ApproverDashboard = function ApproverDashboard() {
  var classes = useStyles$v();
  var dispatch = useDispatch();
  var modulesManager = useModulesManager();
  var _useState9 = useState("pendingMeetingSheet"),
    _useState10 = _slicedToArray(_useState9, 2),
    selectedMenu = _useState10[0],
    setSelectedMenu = _useState10[1];
  useEffect(function () {
    return dispatch(fetchSummaryApplications(modulesManager, ['organizationType:"cf"']));
  }, []);
  var data = useSelector(function (state) {
    var _state$workforce2;
    return (_state$workforce2 = state.workforce["applicationsSummary"]) !== null && _state$workforce2 !== void 0 ? _state$workforce2 : [];
  });
  var pendingSummaryData = data.filter(function (d) {
    return d.status === "meeting_created" || d.status === "forward_to_comiitee";
  });
  var sentSummaryData = data.filter(function (d) {
    return d.status === "forward_to_dg" || d.status === "forward_to_director" || d.status === "approved_by_committee";
  });
  data.filter(function (d) {
    return d.status === "forward_to_comiitee";
  });
  var renderContent = function renderContent() {
    switch (selectedMenu) {
      case "pendingMeetingSheet":
        return /*#__PURE__*/React.createElement(FiledApplications$8, {
          summaryData: pendingSummaryData
        });
      case "approveMeetingSheet":
        return /*#__PURE__*/React.createElement(FiledApplications$8, {
          summaryData: sentSummaryData,
          disableButtons: 1
        });
      case "revertedApplications":
        return /*#__PURE__*/React.createElement(RevertedApplications$1, null);
      case "returnedApplications":
        return /*#__PURE__*/React.createElement(ReturnedApplications$9, null);
      case "rejectedApplications":
        return /*#__PURE__*/React.createElement(RejectedApplications$4, null);
      default:
        return /*#__PURE__*/React.createElement(FiledApplications$8, null);
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: classes.root
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 2,
    className: classes.root
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 3
  }, /*#__PURE__*/React.createElement(Paper, {
    className: classes.sidebar
  }, /*#__PURE__*/React.createElement(List, null, SidebarMenu$9.map(function (item) {
    return /*#__PURE__*/React.createElement(ListItem, {
      button: true,
      key: item.id,
      selected: selectedMenu === item.id,
      onClick: function onClick() {
        return setSelectedMenu(item.id);
      }
    }, /*#__PURE__*/React.createElement(ListItemIcon, null, item.icon), /*#__PURE__*/React.createElement(ListItemText, {
      primary: item.text
    }));
  })))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 9,
    className: classes.content
  }, renderContent())));
};

var useStyles$u = makeStyles(function (theme) {
  return {
    root: {
      flexGrow: 1,
      padding: theme.spacing(2),
      height: "100vh",
      overflow: "visible"
    },
    sidebar: _defineProperty({
      position: "sticky",
      top: 0,
      height: "70vh",
      overflowY: "auto",
      backgroundColor: theme.palette.background.paper,
      borderRight: "1px solid ".concat(theme.palette.divider)
    }, "overflowY", "auto"),
    content: {
      height: "100vh",
      overflowY: "auto",
      padding: theme.spacing(2)
    },
    tableContainer: {
      marginTop: theme.spacing(0)
    },
    tableHeadCell: {
      fontWeight: "bold"
    },
    noData: {
      textAlign: "center",
      padding: theme.spacing(2)
    },
    searchInput: {
      border: "1px solid #ccc",
      borderRadius: 4,
      padding: "4px 8px",
      width: 200
    },
    pagination: {
      display: "flex",
      justifyContent: "flex-end",
      marginTop: theme.spacing(2),
      alignItems: "center"
    },
    tableHeader: {
      backgroundColor: "#B7D4D8"
    }
  };
});
var SidebarMenu$8 = [{
  id: "pendingApplications",
  text: /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.application.myself"
  }),
  icon: /*#__PURE__*/React.createElement(DescriptionIcon, null)
}, {
  id: "newApplications",
  text: /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.new.application.factory"
  }),
  icon: /*#__PURE__*/React.createElement(AddCircleOutlineIcon, null)
}, {
  id: "submittedByApplicants",
  text: /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.new.application.submittedbyapplicant"
  }),
  icon: /*#__PURE__*/React.createElement(VerifiedUserIcon, null)
}, {
  id: "forwardedApplications",
  text: /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.application.forwarded"
  }),
  icon: /*#__PURE__*/React.createElement(ArrowForwardIcon, null)
}, {
  id: "revertedApplication",
  text: /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.application.reverted"
  }),
  icon: /*#__PURE__*/React.createElement(RestorePageIcon, null)
}, {
  id: "returnedApplication",
  text: /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.application.returned"
  }),
  icon: /*#__PURE__*/React.createElement(ArrowBackIcon, null)
}, {
  id: "rejectedApplication",
  text: /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.application.rejectedApplication"
  }),
  icon: /*#__PURE__*/React.createElement(CancelIcon, null)
}, {
  id: "draftApplications",
  text: /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.application.draft_applications"
  }),
  icon: /*#__PURE__*/React.createElement(DraftsIcon, null)
}, {
  id: "applicationStatus",
  text: /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.application.status"
  }),
  icon: /*#__PURE__*/React.createElement(AssignmentIcon, null)
}];

// ----------- Components to Render in Main Content -----------

var FiledApplications$7 = function FiledApplications() {
  var classes = useStyles$u();
  var dispatch = useDispatch();
  var modulesManager = useModulesManager();
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    workforceFactoryId = _useState2[0],
    setWorkforceFactoryId = _useState2[1];
  var _useState3 = useState(true),
    _useState4 = _slicedToArray(_useState3, 2),
    loading = _useState4[0],
    setLoading = _useState4[1];
  var loggedInUserId = useSelector(function (state) {
    var _state$core;
    return (_state$core = state.core) === null || _state$core === void 0 || (_state$core = _state$core.user) === null || _state$core === void 0 || (_state$core = _state$core.i_user) === null || _state$core === void 0 ? void 0 : _state$core.id;
  });
  useEffect(function () {
    var fetchFactory = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _res$payload, _edges$, _node$workforceFactor, filters, res, edges, node, factoryId;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (loggedInUserId) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return");
            case 2:
              console.log({
                loggedInUserId: loggedInUserId
              });
              _context.prev = 3;
              filters = ["relatedUser_Id: ".concat(safeDecodeId(loggedInUserId))];
              _context.next = 7;
              return dispatch(fetchFactoryEmployee(modulesManager, filters));
            case 7:
              res = _context.sent;
              edges = (res === null || res === void 0 || (_res$payload = res.payload) === null || _res$payload === void 0 || (_res$payload = _res$payload.data) === null || _res$payload === void 0 || (_res$payload = _res$payload.workforceEmployerEmployees) === null || _res$payload === void 0 ? void 0 : _res$payload.edges) || [];
              node = (_edges$ = edges[0]) === null || _edges$ === void 0 ? void 0 : _edges$.node;
              factoryId = (node === null || node === void 0 || (_node$workforceFactor = node.workforceFactory) === null || _node$workforceFactor === void 0 ? void 0 : _node$workforceFactor.id) || null;
              setWorkforceFactoryId(factoryId);
              _context.next = 18;
              break;
            case 14:
              _context.prev = 14;
              _context.t0 = _context["catch"](3);
              console.error("Error fetching factory:", _context.t0);
              setWorkforceFactoryId(null);
            case 18:
              _context.prev = 18;
              setLoading(false);
              return _context.finish(18);
            case 21:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[3, 14, 18, 21]]);
      }));
      return function fetchFactory() {
        return _ref.apply(this, arguments);
      };
    }();
    fetchFactory();
  }, [loggedInUserId, dispatch, modulesManager]);
  useEffect(function () {
    console.log("factoryId paisi:", workforceFactoryId);
  }, [workforceFactoryId]);
  if (loading) {
    return /*#__PURE__*/React.createElement("div", null, "Loading...");
  }
  if (!workforceFactoryId) {
    return /*#__PURE__*/React.createElement("div", null, "No factory found");
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5",
    gutterBottom: true
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.factory_admin.dashboard"
  })), /*#__PURE__*/React.createElement(Card, {
    className: classes.tableContainer
  }, /*#__PURE__*/React.createElement(CardContent, null, /*#__PURE__*/React.createElement(ApplicationProcessSearcher$1, {
    loggedInUserId: loggedInUserId,
    factoryId: workforceFactoryId
  }))), /*#__PURE__*/React.createElement("div", {
    className: classes.pagination
  }, /*#__PURE__*/React.createElement(Button, null, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.back"
  })), /*#__PURE__*/React.createElement(Button, null, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.next"
  }))));
};
var DraftApplications = function DraftApplications(_ref2) {
  var workforceFactoryId = _ref2.workforceFactoryId;
  useStyles$u();
  var dispatch = useDispatch();
  var modulesManager = useModulesManager();

  // const [workforceFactoryId, setWorkforceFactoryId] = useState(null);
  var _useState5 = useState(true),
    _useState6 = _slicedToArray(_useState5, 2),
    loading = _useState6[0],
    setLoading = _useState6[1];
  var loggedInUserId = useSelector(function (state) {
    var _state$core2;
    return (_state$core2 = state.core) === null || _state$core2 === void 0 || (_state$core2 = _state$core2.user) === null || _state$core2 === void 0 || (_state$core2 = _state$core2.i_user) === null || _state$core2 === void 0 ? void 0 : _state$core2.id;
  });
  useEffect(function () {
    var fetchFactory = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var _res$payload2, _edges$2, _node$workforceFactor2, filters, res, edges, node;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (loggedInUserId) {
                _context2.next = 2;
                break;
              }
              return _context2.abrupt("return");
            case 2:
              _context2.prev = 2;
              filters = ["relatedUser_Id: \"".concat(loggedInUserId, "\"")];
              console.log({
                filters: filters
              });
              _context2.next = 7;
              return dispatch(fetchFactoryEmployee(modulesManager, filters));
            case 7:
              res = _context2.sent;
              edges = (res === null || res === void 0 || (_res$payload2 = res.payload) === null || _res$payload2 === void 0 || (_res$payload2 = _res$payload2.data) === null || _res$payload2 === void 0 || (_res$payload2 = _res$payload2.workforceEmployerEmployees) === null || _res$payload2 === void 0 ? void 0 : _res$payload2.edges) || [];
              node = (_edges$2 = edges[0]) === null || _edges$2 === void 0 ? void 0 : _edges$2.node;
              (node === null || node === void 0 || (_node$workforceFactor2 = node.workforceFactory) === null || _node$workforceFactor2 === void 0 ? void 0 : _node$workforceFactor2.id) || null; // setWorkforceFactoryId(factoryId);
              _context2.next = 16;
              break;
            case 13:
              _context2.prev = 13;
              _context2.t0 = _context2["catch"](2);
              console.error("Error fetching factory:", _context2.t0);
              // setWorkforceFactoryId(null);
            case 16:
              _context2.prev = 16;
              setLoading(false);
              return _context2.finish(16);
            case 19:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[2, 13, 16, 19]]);
      }));
      return function fetchFactory() {
        return _ref3.apply(this, arguments);
      };
    }();
    fetchFactory();
  }, [loggedInUserId, dispatch, modulesManager]);
  useEffect(function () {
    console.log("factoryId paisi:", workforceFactoryId === null || workforceFactoryId === void 0 ? void 0 : workforceFactoryId.id);
  }, [workforceFactoryId]);
  if (loading) {
    return /*#__PURE__*/React.createElement("div", null, "Loading...");
  }
  if (!workforceFactoryId) {
    return /*#__PURE__*/React.createElement("div", null, "No factory found");
  } else {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ApplicationProcessSearcher$1, {
      isDraft: true,
      applicationStatus: "draft",
      factoryId: workforceFactoryId.id,
      dynamicTableTitle: "workforce.application.draft_applications"
    }));
  }
};
var ApplicationStatus$5 = function ApplicationStatus() {
  var _reduxState$core, _applicationData$gran, _applicationData$gran2, _applicationData$date;
  var dispatch = useDispatch();
  var mm = useModulesManager();
  var _useState7 = useState(""),
    _useState8 = _slicedToArray(_useState7, 2);
    _useState8[0];
    _useState8[1];
  var _useState9 = useState(""),
    _useState10 = _slicedToArray(_useState9, 2),
    trackingNumber = _useState10[0],
    setTrackingNumber = _useState10[1];
  var _useState11 = useState(null),
    _useState12 = _slicedToArray(_useState11, 2),
    applicationData = _useState12[0],
    setApplicationData = _useState12[1];
  var _useState13 = useState(false),
    _useState14 = _slicedToArray(_useState13, 2),
    showResult = _useState14[0],
    setShowResult = _useState14[1];
  var reduxState = useSelector(function (state) {
    return state;
  });
  var locale = (reduxState === null || reduxState === void 0 || (_reduxState$core = reduxState.core) === null || _reduxState$core === void 0 || (_reduxState$core = _reduxState$core.user) === null || _reduxState$core === void 0 || (_reduxState$core = _reduxState$core.i_user) === null || _reduxState$core === void 0 ? void 0 : _reduxState$core.language) || "en";
  var handleApplicationSearch = function handleApplicationSearch() {
    var filters = ["trackingNumber: \"".concat(trackingNumber, "\"")];
    dispatch(fetchApplicationsSummary(mm, filters)).then(function (res) {
      var _res$payload3, _edges$3;
      var edges = ((_res$payload3 = res.payload) === null || _res$payload3 === void 0 || (_res$payload3 = _res$payload3.data) === null || _res$payload3 === void 0 || (_res$payload3 = _res$payload3.workforceApplication) === null || _res$payload3 === void 0 ? void 0 : _res$payload3.edges) || [];
      var matchedApp = ((_edges$3 = edges[0]) === null || _edges$3 === void 0 ? void 0 : _edges$3.node) || null;
      setApplicationData(matchedApp);
      setShowResult(true);
    });
  };
  return /*#__PURE__*/React.createElement(Card, {
    style: {
      marginTop: 0,
      padding: "32px",
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement(CardContent, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5",
    gutterBottom: true
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.application.status"
  })), /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 2,
    justifyContent: "center",
    style: {
      marginTop: 16
    }
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 6
  }, /*#__PURE__*/React.createElement(TextField, {
    fullWidth: true,
    variant: "outlined",
    size: "small",
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      module: "workforce",
      id: "workforce.application.tracking.number"
    }),
    value: trackingNumber,
    onChange: function onChange(e) {
      return setTrackingNumber(e.target.value);
    },
    style: {
      marginBottom: 16
    }
  }), /*#__PURE__*/React.createElement(Button, {
    variant: "contained",
    color: "primary",
    fullWidth: true,
    onClick: handleApplicationSearch
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.search.here"
  })))), showResult && (applicationData ? /*#__PURE__*/React.createElement(Box$1, {
    mt: 4,
    p: 3,
    border: 1,
    borderColor: "#ccc",
    borderRadius: 2,
    textAlign: "left",
    maxWidth: 800,
    margin: "32px auto 0"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6",
    gutterBottom: true,
    style: {
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.tracking.summary",
    defaultMessage: "\u099F\u09CD\u09B0\u09CD\u09AF\u09BE\u0995\u09BF\u0982 \u09B8\u09BE\u09B0\u09BE\u0982\u09B6"
  })), /*#__PURE__*/React.createElement(Grid, {
    container: true,
    style: {
      marginTop: 16
    },
    spacing: 2
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement("strong", null, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.application.tracking.number"
  }), ":"), " ", applicationData.trackingNumber), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement("strong", null, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.employee.application.currentStatus"
  }), ":"), (locale === "en" ? STATUS_MAP_EN : STATUS_MAP_BN)[applicationData === null || applicationData === void 0 ? void 0 : applicationData.status] || (applicationData === null || applicationData === void 0 ? void 0 : applicationData.status))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement("strong", null, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.employee.application.applicationType"
  }), ":"), " ", locale === "en" ? applicationData === null || applicationData === void 0 || (_applicationData$gran = applicationData.grantMoney) === null || _applicationData$gran === void 0 ? void 0 : _applicationData$gran.applicationTypeNameEn : applicationData === null || applicationData === void 0 || (_applicationData$gran2 = applicationData.grantMoney) === null || _applicationData$gran2 === void 0 ? void 0 : _applicationData$gran2.applicationTypeNameBn), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement("strong", null, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.employee.application.applicationDate"
  }), ":"), " ", applicationData !== null && applicationData !== void 0 && applicationData.dateCreated ? conditionalEnToBn(applicationData === null || applicationData === void 0 || (_applicationData$date = applicationData.dateCreated) === null || _applicationData$date === void 0 ? void 0 : _applicationData$date.split("T")[0], locale) : "-")))) : /*#__PURE__*/React.createElement(Typography, {
    color: "error",
    style: {
      marginTop: 32
    }
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.tracking.notfound",
    defaultMessage: "\u0995\u09CB\u09A8\u09CB \u0986\u09AC\u09C7\u09A6\u09A8 \u09AA\u09BE\u0993\u09AF\u09BC\u09BE \u09AF\u09BE\u09AF\u09BC\u09A8\u09BF\u0964"
  })))));
};
var RevertApplication$4 = function RevertApplication() {
  var classes = useStyles$u();
  var dispatch = useDispatch();
  var modulesManager = useModulesManager();
  var _useState15 = useState(null),
    _useState16 = _slicedToArray(_useState15, 2),
    workforceFactoryId = _useState16[0],
    setWorkforceFactoryId = _useState16[1];
  var _useState17 = useState(true),
    _useState18 = _slicedToArray(_useState17, 2),
    loading = _useState18[0],
    setLoading = _useState18[1];
  var loggedInUserId = useSelector(function (state) {
    var _state$core3;
    return (_state$core3 = state.core) === null || _state$core3 === void 0 || (_state$core3 = _state$core3.user) === null || _state$core3 === void 0 || (_state$core3 = _state$core3.i_user) === null || _state$core3 === void 0 ? void 0 : _state$core3.id;
  });
  useEffect(function () {
    var fetchFactory = /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var _res$payload4, _edges$4, _node$workforceFactor3, filters, res, edges, node, factoryId;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (loggedInUserId) {
                _context3.next = 2;
                break;
              }
              return _context3.abrupt("return");
            case 2:
              _context3.prev = 2;
              filters = ["relatedUser_Id: \"".concat(safeDecodeId(loggedInUserId), "\"")];
              _context3.next = 6;
              return dispatch(fetchFactoryEmployee(modulesManager, filters));
            case 6:
              res = _context3.sent;
              edges = (res === null || res === void 0 || (_res$payload4 = res.payload) === null || _res$payload4 === void 0 || (_res$payload4 = _res$payload4.data) === null || _res$payload4 === void 0 || (_res$payload4 = _res$payload4.workforceEmployerEmployees) === null || _res$payload4 === void 0 ? void 0 : _res$payload4.edges) || [];
              node = (_edges$4 = edges[0]) === null || _edges$4 === void 0 ? void 0 : _edges$4.node;
              factoryId = (node === null || node === void 0 || (_node$workforceFactor3 = node.workforceFactory) === null || _node$workforceFactor3 === void 0 ? void 0 : _node$workforceFactor3.id) || null;
              setWorkforceFactoryId(factoryId);
              _context3.next = 17;
              break;
            case 13:
              _context3.prev = 13;
              _context3.t0 = _context3["catch"](2);
              console.error("Error fetching factory:", _context3.t0);
              setWorkforceFactoryId(null);
            case 17:
              _context3.prev = 17;
              setLoading(false);
              return _context3.finish(17);
            case 20:
            case "end":
              return _context3.stop();
          }
        }, _callee3, null, [[2, 13, 17, 20]]);
      }));
      return function fetchFactory() {
        return _ref4.apply(this, arguments);
      };
    }();
    fetchFactory();
  }, [loggedInUserId, dispatch, modulesManager]);
  useEffect(function () {
    console.log("factoryId paisi:", workforceFactoryId);
  }, [workforceFactoryId]);
  if (loading) {
    return /*#__PURE__*/React.createElement("div", null, "Loading...");
  }
  if (!workforceFactoryId) {
    return /*#__PURE__*/React.createElement("div", null, "No factory found");
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5",
    gutterBottom: true
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.application.reverted"
  })), /*#__PURE__*/React.createElement(Card, {
    className: classes.tableContainer
  }, /*#__PURE__*/React.createElement(CardContent, null, /*#__PURE__*/React.createElement(ApplicationProcessSearcher$1, {
    revertedApplication: true,
    loggedInUserId: loggedInUserId,
    factoryId: workforceFactoryId
  }))), /*#__PURE__*/React.createElement("div", {
    className: classes.pagination
  }, /*#__PURE__*/React.createElement(Button, null, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.back"
  })), /*#__PURE__*/React.createElement(Button, null, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.next"
  }))));
};
var ReturnedApplications$8 = function ReturnedApplications() {
  var classes = useStyles$u();
  var dispatch = useDispatch();
  var modulesManager = useModulesManager();
  var _useState19 = useState(null),
    _useState20 = _slicedToArray(_useState19, 2),
    workforceFactoryId = _useState20[0],
    setWorkforceFactoryId = _useState20[1];
  var _useState21 = useState(true),
    _useState22 = _slicedToArray(_useState21, 2),
    loading = _useState22[0],
    setLoading = _useState22[1];
  var loggedInUserId = useSelector(function (state) {
    var _state$core4;
    return (_state$core4 = state.core) === null || _state$core4 === void 0 || (_state$core4 = _state$core4.user) === null || _state$core4 === void 0 || (_state$core4 = _state$core4.i_user) === null || _state$core4 === void 0 ? void 0 : _state$core4.id;
  });
  useEffect(function () {
    var fetchFactory = /*#__PURE__*/function () {
      var _ref5 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var _res$payload5, _edges$5, _node$workforceFactor4, filters, res, edges, node, factoryId;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              if (loggedInUserId) {
                _context4.next = 2;
                break;
              }
              return _context4.abrupt("return");
            case 2:
              _context4.prev = 2;
              filters = ["relatedUser_Id: \"".concat(safeDecodeId(loggedInUserId), "\"")];
              _context4.next = 6;
              return dispatch(fetchFactoryEmployee(modulesManager, filters));
            case 6:
              res = _context4.sent;
              edges = (res === null || res === void 0 || (_res$payload5 = res.payload) === null || _res$payload5 === void 0 || (_res$payload5 = _res$payload5.data) === null || _res$payload5 === void 0 || (_res$payload5 = _res$payload5.workforceEmployerEmployees) === null || _res$payload5 === void 0 ? void 0 : _res$payload5.edges) || [];
              node = (_edges$5 = edges[0]) === null || _edges$5 === void 0 ? void 0 : _edges$5.node;
              factoryId = (node === null || node === void 0 || (_node$workforceFactor4 = node.workforceFactory) === null || _node$workforceFactor4 === void 0 ? void 0 : _node$workforceFactor4.id) || null;
              setWorkforceFactoryId(factoryId);
              _context4.next = 17;
              break;
            case 13:
              _context4.prev = 13;
              _context4.t0 = _context4["catch"](2);
              console.error("Error fetching factory:", _context4.t0);
              setWorkforceFactoryId(null);
            case 17:
              _context4.prev = 17;
              setLoading(false);
              return _context4.finish(17);
            case 20:
            case "end":
              return _context4.stop();
          }
        }, _callee4, null, [[2, 13, 17, 20]]);
      }));
      return function fetchFactory() {
        return _ref5.apply(this, arguments);
      };
    }();
    fetchFactory();
  }, [loggedInUserId, dispatch, modulesManager]);
  useEffect(function () {
    console.log("factoryId paisi:", workforceFactoryId);
  }, [workforceFactoryId]);
  if (loading) {
    return /*#__PURE__*/React.createElement("div", null, "Loading...");
  }
  if (!workforceFactoryId) {
    return /*#__PURE__*/React.createElement("div", null, "No factory found");
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ApplicationProcessSearcher$1, {
    returnedApplications: true,
    loggedInUserId: loggedInUserId,
    disableButtons: 1,
    dynamicTableTitle: "workforce.application.returned",
    factoryId: workforceFactoryId
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.pagination
  }, /*#__PURE__*/React.createElement(Button, null, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.back"
  })), /*#__PURE__*/React.createElement(Button, null, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.next"
  }))));
};
var RejectApplication$6 = function RejectApplication() {
  var classes = useStyles$u();
  var dispatch = useDispatch();
  var modulesManager = useModulesManager();
  var _useState23 = useState(null),
    _useState24 = _slicedToArray(_useState23, 2),
    workforceFactoryId = _useState24[0],
    setWorkforceFactoryId = _useState24[1];
  var _useState25 = useState(true),
    _useState26 = _slicedToArray(_useState25, 2),
    loading = _useState26[0],
    setLoading = _useState26[1];
  var loggedInUserId = useSelector(function (state) {
    var _state$core5;
    return (_state$core5 = state.core) === null || _state$core5 === void 0 || (_state$core5 = _state$core5.user) === null || _state$core5 === void 0 || (_state$core5 = _state$core5.i_user) === null || _state$core5 === void 0 ? void 0 : _state$core5.id;
  });
  useEffect(function () {
    var fetchFactory = /*#__PURE__*/function () {
      var _ref6 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var _res$payload6, _edges$6, _node$workforceFactor5, filters, res, edges, node, factoryId;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              if (loggedInUserId) {
                _context5.next = 2;
                break;
              }
              return _context5.abrupt("return");
            case 2:
              _context5.prev = 2;
              // const filters = [
              //   `relatedUser_Id: "${encodeId(
              //     modulesManager,
              //     "InteractiveUserGQLType",
              //     loggedInUserId
              //   )}"`
              // ];
              filters = ["relatedUser_Id: \"".concat(safeDecodeId(loggedInUserId), "\"")];
              _context5.next = 6;
              return dispatch(fetchFactoryEmployee(modulesManager, filters));
            case 6:
              res = _context5.sent;
              edges = (res === null || res === void 0 || (_res$payload6 = res.payload) === null || _res$payload6 === void 0 || (_res$payload6 = _res$payload6.data) === null || _res$payload6 === void 0 || (_res$payload6 = _res$payload6.workforceEmployerEmployees) === null || _res$payload6 === void 0 ? void 0 : _res$payload6.edges) || [];
              node = (_edges$6 = edges[0]) === null || _edges$6 === void 0 ? void 0 : _edges$6.node;
              factoryId = (node === null || node === void 0 || (_node$workforceFactor5 = node.workforceFactory) === null || _node$workforceFactor5 === void 0 ? void 0 : _node$workforceFactor5.id) || null;
              setWorkforceFactoryId(factoryId);
              _context5.next = 17;
              break;
            case 13:
              _context5.prev = 13;
              _context5.t0 = _context5["catch"](2);
              console.error("Error fetching factory:", _context5.t0);
              setWorkforceFactoryId(null);
            case 17:
              _context5.prev = 17;
              setLoading(false);
              return _context5.finish(17);
            case 20:
            case "end":
              return _context5.stop();
          }
        }, _callee5, null, [[2, 13, 17, 20]]);
      }));
      return function fetchFactory() {
        return _ref6.apply(this, arguments);
      };
    }();
    fetchFactory();
  }, [loggedInUserId, dispatch, modulesManager]);
  useEffect(function () {
    console.log("factoryId paisi:", workforceFactoryId);
  }, [workforceFactoryId]);
  if (loading) {
    return /*#__PURE__*/React.createElement("div", null, "Loading...");
  }
  if (!workforceFactoryId) {
    return /*#__PURE__*/React.createElement("div", null, "No factory found");
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ApplicationProcessSearcher$1, {
    rejectedApplication: true,
    dynamicTableTitle: "workforce.application.rejectedApplication",
    loggedInUserId: loggedInUserId,
    factoryId: workforceFactoryId
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.pagination
  }, /*#__PURE__*/React.createElement(Button, null, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.back"
  })), /*#__PURE__*/React.createElement(Button, null, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.next"
  }))));
};
var SubmittedByApplicants = function SubmittedByApplicants() {
  var classes = useStyles$u();
  var dispatch = useDispatch();
  var modulesManager = useModulesManager();
  var _useState27 = useState(null),
    _useState28 = _slicedToArray(_useState27, 2),
    workforceFactoryId = _useState28[0],
    setWorkforceFactoryId = _useState28[1];
  var _useState29 = useState(true),
    _useState30 = _slicedToArray(_useState29, 2),
    loading = _useState30[0],
    setLoading = _useState30[1];
  var loggedInUserId = useSelector(function (state) {
    var _state$core6;
    return (_state$core6 = state.core) === null || _state$core6 === void 0 || (_state$core6 = _state$core6.user) === null || _state$core6 === void 0 || (_state$core6 = _state$core6.i_user) === null || _state$core6 === void 0 ? void 0 : _state$core6.id;
  });
  useEffect(function () {
    var fetchFactory = /*#__PURE__*/function () {
      var _ref7 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        var _res$payload7, _edges$7, _node$workforceFactor6, filters, res, edges, node, factoryId;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              if (loggedInUserId) {
                _context6.next = 2;
                break;
              }
              return _context6.abrupt("return");
            case 2:
              _context6.prev = 2;
              // const filters = [
              //   `relatedUser_Id: "${encodeId(
              //     modulesManager,
              //     "InteractiveUserGQLType",
              //     loggedInUserId
              //   )}"`
              // ];
              filters = ["relatedUser_Id: \"".concat(safeDecodeId(loggedInUserId), "\"")];
              _context6.next = 6;
              return dispatch(fetchFactoryEmployee(modulesManager, filters));
            case 6:
              res = _context6.sent;
              edges = (res === null || res === void 0 || (_res$payload7 = res.payload) === null || _res$payload7 === void 0 || (_res$payload7 = _res$payload7.data) === null || _res$payload7 === void 0 || (_res$payload7 = _res$payload7.workforceEmployerEmployees) === null || _res$payload7 === void 0 ? void 0 : _res$payload7.edges) || [];
              node = (_edges$7 = edges[0]) === null || _edges$7 === void 0 ? void 0 : _edges$7.node;
              factoryId = (node === null || node === void 0 || (_node$workforceFactor6 = node.workforceFactory) === null || _node$workforceFactor6 === void 0 ? void 0 : _node$workforceFactor6.id) || null;
              setWorkforceFactoryId(factoryId);
              _context6.next = 17;
              break;
            case 13:
              _context6.prev = 13;
              _context6.t0 = _context6["catch"](2);
              console.error("Error fetching factory:", _context6.t0);
              setWorkforceFactoryId(null);
            case 17:
              _context6.prev = 17;
              setLoading(false);
              return _context6.finish(17);
            case 20:
            case "end":
              return _context6.stop();
          }
        }, _callee6, null, [[2, 13, 17, 20]]);
      }));
      return function fetchFactory() {
        return _ref7.apply(this, arguments);
      };
    }();
    fetchFactory();
  }, [loggedInUserId, dispatch, modulesManager]);
  useEffect(function () {
    console.log("factoryId paisi:", workforceFactoryId);
  }, [workforceFactoryId]);
  if (loading) {
    return /*#__PURE__*/React.createElement("div", null, "Loading...");
  }
  if (!workforceFactoryId) {
    return /*#__PURE__*/React.createElement("div", null, "No factory found");
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ApplicationProcessSearcher$1, {
    submittedByApplicants: true,
    dynamicTableTitle: "workforce.new.application.submittedbyapplicant",
    loggedInUserId: loggedInUserId,
    factoryId: workforceFactoryId
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.pagination
  }, /*#__PURE__*/React.createElement(Button, null, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.back"
  })), /*#__PURE__*/React.createElement(Button, null, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.next"
  }))));
};
var ForwardedApplications$1 = function ForwardedApplications() {
  var classes = useStyles$u();
  var dispatch = useDispatch();
  var modulesManager = useModulesManager();
  var _useState31 = useState(null),
    _useState32 = _slicedToArray(_useState31, 2),
    workforceFactoryId = _useState32[0],
    setWorkforceFactoryId = _useState32[1];
  var _useState33 = useState(true),
    _useState34 = _slicedToArray(_useState33, 2),
    loading = _useState34[0],
    setLoading = _useState34[1];
  var loggedInUserId = useSelector(function (state) {
    var _state$core7;
    return (_state$core7 = state.core) === null || _state$core7 === void 0 || (_state$core7 = _state$core7.user) === null || _state$core7 === void 0 || (_state$core7 = _state$core7.i_user) === null || _state$core7 === void 0 ? void 0 : _state$core7.id;
  });
  useEffect(function () {
    var fetchFactory = /*#__PURE__*/function () {
      var _ref8 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
        var _res$payload8, _edges$8, _node$workforceFactor7, filters, res, edges, node, factoryId;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              if (loggedInUserId) {
                _context7.next = 2;
                break;
              }
              return _context7.abrupt("return");
            case 2:
              _context7.prev = 2;
              // const filters = [
              //   `relatedUser_Id: "${encodeId(
              //     modulesManager,
              //     "InteractiveUserGQLType",
              //     loggedInUserId
              //   )}"`
              // ];
              filters = ["relatedUser_Id: \"".concat(safeDecodeId(loggedInUserId), "\"")];
              _context7.next = 6;
              return dispatch(fetchFactoryEmployee(modulesManager, filters));
            case 6:
              res = _context7.sent;
              edges = (res === null || res === void 0 || (_res$payload8 = res.payload) === null || _res$payload8 === void 0 || (_res$payload8 = _res$payload8.data) === null || _res$payload8 === void 0 || (_res$payload8 = _res$payload8.workforceEmployerEmployees) === null || _res$payload8 === void 0 ? void 0 : _res$payload8.edges) || [];
              node = (_edges$8 = edges[0]) === null || _edges$8 === void 0 ? void 0 : _edges$8.node;
              factoryId = (node === null || node === void 0 || (_node$workforceFactor7 = node.workforceFactory) === null || _node$workforceFactor7 === void 0 ? void 0 : _node$workforceFactor7.id) || null;
              setWorkforceFactoryId(factoryId);
              _context7.next = 17;
              break;
            case 13:
              _context7.prev = 13;
              _context7.t0 = _context7["catch"](2);
              console.error("Error fetching factory:", _context7.t0);
              setWorkforceFactoryId(null);
            case 17:
              _context7.prev = 17;
              setLoading(false);
              return _context7.finish(17);
            case 20:
            case "end":
              return _context7.stop();
          }
        }, _callee7, null, [[2, 13, 17, 20]]);
      }));
      return function fetchFactory() {
        return _ref8.apply(this, arguments);
      };
    }();
    fetchFactory();
  }, [loggedInUserId, dispatch, modulesManager]);
  useEffect(function () {
    console.log("factoryId paisi:", workforceFactoryId);
  }, [workforceFactoryId]);
  if (loading) {
    return /*#__PURE__*/React.createElement("div", null, "Loading...");
  }
  if (!workforceFactoryId) {
    return /*#__PURE__*/React.createElement("div", null, "No factory found");
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ApplicationProcessSearcher$1, {
    forwardedApplications: true,
    disableButtons: 1,
    dynamicTableTitle: "workforce.application.forwarded",
    loggedInUserId: loggedInUserId,
    factoryId: workforceFactoryId
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.pagination
  }, /*#__PURE__*/React.createElement(Button, null, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.back"
  })), /*#__PURE__*/React.createElement(Button, null, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.next"
  }))));
};

// ------------------------------------------------------------

var FactoryAdminDashboard = function FactoryAdminDashboard() {
  var classes = useStyles$u();
  useHistory();
  // const path = window.location.href;
  // const isEisPath = path.includes("eis");
  // console.log({ isEisPath });
  var _useState35 = useState(false),
    _useState36 = _slicedToArray(_useState35, 2),
    showActivationError = _useState36[0],
    setShowActivationError = _useState36[1]; // Default first menu
  var _useState37 = useState("pendingApplications"),
    _useState38 = _slicedToArray(_useState37, 2),
    selectedMenu = _useState38[0],
    setSelectedMenu = _useState38[1]; // Default first menu
  var _useState39 = useState(null),
    _useState40 = _slicedToArray(_useState39, 2),
    workforceFactoryId = _useState40[0],
    setWorkforceFactoryId = _useState40[1];
  var dispatch = useDispatch();
  var modulesManager = useModulesManager();
  var loggedInUserId = useSelector(function (state) {
    var _state$core8;
    return (_state$core8 = state.core) === null || _state$core8 === void 0 || (_state$core8 = _state$core8.user) === null || _state$core8 === void 0 || (_state$core8 = _state$core8.i_user) === null || _state$core8 === void 0 ? void 0 : _state$core8.id;
  });
  useEffect(function () {
    if (loggedInUserId) {
      // const filters = [`relatedUser_Id: "${encodeId(modulesManager, "InteractiveUserGQLType", loggedInUserId)}"`];
      var filters = ["relatedUser_Id: \"".concat(safeDecodeId(loggedInUserId), "\"")];
      console.log({
        filters: filters
      });
      dispatch(fetchFactoryEmployee(modulesManager, filters)).then(function (res) {
        var _res$payload9, _edges$9;
        var edges = (res === null || res === void 0 || (_res$payload9 = res.payload) === null || _res$payload9 === void 0 || (_res$payload9 = _res$payload9.data) === null || _res$payload9 === void 0 || (_res$payload9 = _res$payload9.workforceEmployerEmployees) === null || _res$payload9 === void 0 ? void 0 : _res$payload9.edges) || [];
        var node = (_edges$9 = edges[0]) === null || _edges$9 === void 0 ? void 0 : _edges$9.node;
        var factoryId = (node === null || node === void 0 ? void 0 : node.workforceFactory) || null;
        setWorkforceFactoryId(factoryId);
      });
    }
  }, [loggedInUserId]);

  // useEffect(() => {
  //   if (workforceFactoryId?.status === "draft") {
  //     setSelectedMenu("newApplications");
  //   }
  // }, [workforceFactoryId]);
  console.log({
    workforceFactoryId: workforceFactoryId
  });
  var renderContent = function renderContent() {
    switch (selectedMenu) {
      case "pendingApplications":
        return /*#__PURE__*/React.createElement(FiledApplications$7, null);
      case "newApplications":
        return isEisPath() ? /*#__PURE__*/React.createElement(EisMultiStepApplyForm$1, {
          workforceFactoryId: workforceFactoryId
        }) : /*#__PURE__*/React.createElement(MultiStepApplyForm, {
          workforceFactoryId: workforceFactoryId
        });
      case "submittedByApplicants":
        return /*#__PURE__*/React.createElement(SubmittedByApplicants, null);
      case "forwardedApplications":
        return /*#__PURE__*/React.createElement(ForwardedApplications$1, null);
      case "revertedApplication":
        return /*#__PURE__*/React.createElement(RevertApplication$4, null);
      case "returnedApplication":
        return /*#__PURE__*/React.createElement(ReturnedApplications$8, null);
      case "rejectedApplication":
        return /*#__PURE__*/React.createElement(RejectApplication$6, null);
      case "draftApplications":
        return /*#__PURE__*/React.createElement(DraftApplications, {
          workforceFactoryId: workforceFactoryId
        });
      case "applicationStatus":
        return /*#__PURE__*/React.createElement(ApplicationStatus$5, null);
      default:
        return /*#__PURE__*/React.createElement(FiledApplications$7, null);
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: classes.root
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 2,
    className: classes.root
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 3
  }, /*#__PURE__*/React.createElement(Paper, {
    className: classes.sidebar
  }, (workforceFactoryId === null || workforceFactoryId === void 0 ? void 0 : workforceFactoryId.status) === "draft" && /*#__PURE__*/React.createElement(Typography, {
    style: {
      color: "red",
      textAlign: "center",
      fontWeight: "bold"
    }
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "workforce.application.factory.activation.error"
  })), /*#__PURE__*/React.createElement(List, null, SidebarMenu$8.map(function (item) {
    // Determine if this item should be disabled
    var isDraftStatus = (workforceFactoryId === null || workforceFactoryId === void 0 ? void 0 : workforceFactoryId.status) === "draft";
    item.id !== "newApplications";
    // const isDisabled = isDraftStatus && isNotNewApplication;
    var isDisabled = isDraftStatus;
    // const isDisabled = false;

    return /*#__PURE__*/React.createElement(ListItem, {
      button: true,
      key: item.id,
      selected: selectedMenu === item.id
      // Disable the click and apply the disabled look
      ,
      disabled: isDisabled,
      onClick: function onClick() {
        if (!isDisabled) {
          setSelectedMenu(item.id);
        } else {
          setShowActivationError(true);
        }
      }
    }, /*#__PURE__*/React.createElement(ListItemIcon, null, item.icon), /*#__PURE__*/React.createElement(ListItemText, {
      primary: item.text
    }));
  })))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 9,
    className: classes.content
  }, renderContent())), /*#__PURE__*/React.createElement(CustomSnackbar, {
    open: showActivationError,
    onClose: function onClose() {
      return setShowActivationError(false);
    },
    type: "error",
    message: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.application.factory.activation.error",
      module: "workforce"
    })
  }));
};

var BeneficiaryReport = function BeneficiaryReport(props) {
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    loading = _useState2[0],
    setLoading = _useState2[1];
  var modulesManager = useModulesManager();
  var dispatch = useDispatch();
  useEffect(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return dispatch(fetchApplicationsSummary(modulesManager)).then(function () {
            setLoading(false);
          });
        case 2:
        case "end":
          return _context.stop();
      }
    }, _callee);
  })), []);
  var rawApplications = useSelector(function (state) {
    return state.workforce.applications;
  });
  var applications = getParsedApplicationFromArray(rawApplications);
  console.log("Applications in BeneficiaryReport:", applications);
  return /*#__PURE__*/React.createElement("div", {
    style: {
      marginBottom: "100px"
    }
  }, /*#__PURE__*/React.createElement("table", {
    cellPadding: "5px",
    border: 1,
    style: {
      width: "100%",
      borderCollapse: "collapse"
    }
  }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", {
    colSpan: 15,
    style: {
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 2
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 2,
    lg: 2,
    md: 2
  }), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 8,
    lg: 8,
    md: 8
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      width: "100%",
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("h3", null, "\u0997\u09A3\u09AA\u09CD\u09B0\u099C\u09BE\u09A4\u09A8\u09CD\u09A4\u09CD\u09B0\u09C0 \u09AC\u09BE\u0982\u09B2\u09BE\u09A6\u09C7\u09B6 \u09B8\u09B0\u0995\u09BE\u09B0"), /*#__PURE__*/React.createElement("p", null, "\u09B6\u09CD\u09B0\u09AE \u0993 \u0995\u09B0\u09CD\u09AE\u09B8\u0982\u09B8\u09CD\u09A5\u09BE\u09A8 \u09AE\u09A8\u09CD\u09A4\u09CD\u09B0\u09A3\u09BE\u09B2\u09DF"), /*#__PURE__*/React.createElement("p", null, "\u0995\u09C7\u09A8\u09CD\u09A6\u09CD\u09B0\u09C0\u09DF \u09A4\u09B9\u09AC\u09BF\u09B2"), /*#__PURE__*/React.createElement("p", null, "\u09E8\u09E7 \u09A4\u09B2\u09BE, \u09AD\u09AC\u09A8#\u09EC, \u09AC\u09BE\u0982\u09B2\u09BE\u09A6\u09C7\u09B6 \u09B8\u099A\u09BF\u09AC\u09BE\u09B2\u09DF, \u09A2\u09BE\u0995\u09BE-\u09E7\u09E6\u09E6\u09E6"), /*#__PURE__*/React.createElement("p", null, "www.centralfund.gov.bd"))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 2,
    lg: 2,
    md: 2
  })))), /*#__PURE__*/React.createElement("tr", {
    style: {
      backgroundColor: "#E8EDEC"
    }
  }, /*#__PURE__*/React.createElement("th", {
    colSpan: 15,
    style: {
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 2
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    lg: 12,
    md: 12
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      width: "100%",
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("p", {
    style: {
      textDecoration: "underline"
    }
  }, "\u09AE\u09C3\u09A4\u09CD\u09AF\u09C1 \u0993 \u09A6\u09C2\u09B0\u09CD\u0998\u099F\u09A8\u09BE\u099C\u09A8\u09BF\u09A4 \u0986\u09B0\u09CD\u09A5\u09BF\u0995 \u09B8\u09B9\u09BE\u09DF\u09A4\u09BE \u09A4\u09BE\u09B2\u09BF\u0995\u09BE "), /*#__PURE__*/React.createElement("p", {
    style: {
      textDecoration: "underline"
    }
  }, "\u09B8\u09C1\u09AC\u09BF\u09A7\u09BE\u09AD\u09CB\u0997\u09C0 \u0995\u09B2\u09CD\u09AF\u09BE\u09A3 \u09B9\u09BF\u09B8\u09BE\u09AC (\u09A8\u0982 \u09EA\u09EA\u09E8\u09EC\u09E9\u09E9\u09EC\u09E6\u09E6\u09E7\u09E6\u09E9\u09EA)")))))), /*#__PURE__*/React.createElement("tr", {
    style: {
      backgroundColor: "#f6fffeff"
    }
  }, /*#__PURE__*/React.createElement("th", {
    colSpan: 15
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 2
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    lg: 12,
    md: 12
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("p", null, "\u09AC\u09CB\u09B0\u09CD\u09A1 \u09B8\u09AD\u09BE\u0983  "), /*#__PURE__*/React.createElement("p", null, "\u0986\u09AC\u09C7\u09A6\u09A8\u09C7\u09B0 \u09B8\u0982\u0996\u09CD\u09AF\u09BE\u0983 "), /*#__PURE__*/React.createElement("p", null, "\u09A8\u09AE\u09BF\u09A8\u09C0/\u09AC\u09CD\u09AF\u09BE\u0982\u0995 \u09B9\u09BF\u09B8\u09BE\u09AC\u09C7\u09B0 \u09B8\u0982\u0996\u09CD\u09AF\u09BE\u0983 "), /*#__PURE__*/React.createElement("p", null, "\u0985\u09B0\u09CD\u09A5\u09C7\u09B0 \u09AA\u09B0\u09BF\u09AE\u09BE\u09A3\u0983 ")))))), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, "Sl."), /*#__PURE__*/React.createElement("th", null, "Main List No."), /*#__PURE__*/React.createElement("th", null, "Date"), /*#__PURE__*/React.createElement("th", null, "Ref. No."), /*#__PURE__*/React.createElement("th", null, "Sender A/C No."), /*#__PURE__*/React.createElement("th", null, "Receiver's Routing No."), /*#__PURE__*/React.createElement("th", null, "Sender's Routing No."), /*#__PURE__*/React.createElement("th", null, "Type (C/D)"), /*#__PURE__*/React.createElement("th", null, "Customer/ Nominee's Account Name"), /*#__PURE__*/React.createElement("th", null, "Customer/ Nominee's Account No."), /*#__PURE__*/React.createElement("th", null, "Amount"), /*#__PURE__*/React.createElement("th", null, "Institute"), /*#__PURE__*/React.createElement("th", null, "Entry Description"), /*#__PURE__*/React.createElement("th", null, "Deceased Worker's Name"), /*#__PURE__*/React.createElement("th", null, "Factory Name"))), /*#__PURE__*/React.createElement("tbody", null, (applications === null || applications === void 0 ? void 0 : applications.length) > 0 ? applications.map(function (app, index) {
    return /*#__PURE__*/React.createElement("tr", {
      key: app.id
    }, /*#__PURE__*/React.createElement("td", null, enToBn(index + 1)), /*#__PURE__*/React.createElement("td", null, app.trackingNumber), /*#__PURE__*/React.createElement("td", null, app.dateModified), /*#__PURE__*/React.createElement("td", null), /*#__PURE__*/React.createElement("td", null, "4426336001034"), /*#__PURE__*/React.createElement("td", null, app.employeeBankInfo.map(function (bank) {
      return /*#__PURE__*/React.createElement("span", null);
    })), /*#__PURE__*/React.createElement("td", null), /*#__PURE__*/React.createElement("td", null), /*#__PURE__*/React.createElement("td", null, app.workforceEmployee.firstNameBn), /*#__PURE__*/React.createElement("td", null), /*#__PURE__*/React.createElement("td", null), /*#__PURE__*/React.createElement("td", null), /*#__PURE__*/React.createElement("td", null), /*#__PURE__*/React.createElement("td", null), /*#__PURE__*/React.createElement("td", null));
  }) : /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    colSpan: "15",
    style: {
      textAlign: "center"
    }
  }, loading === true ? /*#__PURE__*/React.createElement("span", null, "\u09B2\u09CB\u09A1 \u09B9\u099A\u09CD\u099B\u09C7...") : /*#__PURE__*/React.createElement("span", null, "\u09A4\u09A5\u09CD\u09AF \u09AA\u09BE\u0993\u09DF\u09BE \u09AF\u09BE\u09DF\u09A8\u09BF\u0964"))))));
};

var useStyles$t = makeStyles(function (theme) {
  return {
    root: {
      flexGrow: 1,
      padding: theme.spacing(2),
      height: 'calc(100vh - 64px)',
      // assuming 64px header/appbar, adjust as needed
      overflow: 'visible'
    },
    sidebar: {
      position: "sticky",
      top: "100px",
      height: "70vh",
      backgroundColor: theme.palette.background.paper,
      borderRight: "1px solid ".concat(theme.palette.divider),
      overflowY: "auto"
    },
    content: {
      height: '100vh',
      overflowY: 'auto',
      padding: theme.spacing(2)
    },
    tableContainer: {
      marginTop: theme.spacing(0)
    },
    tableHeadCell: {
      fontWeight: "bold"
    },
    noData: {
      textAlign: "center",
      padding: theme.spacing(2)
    },
    searchInput: {
      border: "1px solid #ccc",
      borderRadius: 4,
      padding: "4px 8px",
      width: 200
    },
    pagination: {
      display: "flex",
      justifyContent: "flex-end",
      marginTop: theme.spacing(2),
      alignItems: "center"
    },
    tableHeader: {
      backgroundColor: "#B7D4D8"
    },
    accordion: {
      boxShadow: "1px 1px 1px 1px",
      border: "none",
      backgroundColor: "white",
      marginBottom: "12px",
      borderRadius: "6px",
      "&::before": {
        display: "none"
      }
    },
    accordionSummary: {
      padding: "8px 16px",
      backgroundColor: "white",
      borderRadius: "6px",
      "& .MuiTypography-root": {
        color: "#015C63",
        // teal-like tone
        fontWeight: 600
      }
    },
    accordionDetails: {
      backgroundColor: "white",
      padding: "16px",
      borderTop: "1px solid #ddd"
    }
  };
});
var SidebarMenu$7 = [{
  id: "pendingApplications",
  text: /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.application.pending"
  }),
  icon: /*#__PURE__*/React.createElement(AssignmentReturnedIcon, null)
}, {
  id: "sentForVerificationApplications",
  text: /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.application.sentforverification"
  }),
  icon: /*#__PURE__*/React.createElement(HourglassFullTwoToneIcon, null)
}, {
  id: "verifiedApplications",
  text: /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.application.verified"
  }),
  icon: /*#__PURE__*/React.createElement(VerifiedUserIcon, null)
}, {
  id: "rejectedApplication",
  text: /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.application.rejectedApplication"
  }),
  icon: /*#__PURE__*/React.createElement(CancelIcon, null)
}, {
  id: "pendingMeetingSheet",
  text: /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.employee.application.pendingMeetingSheet"
  }),
  icon: /*#__PURE__*/React.createElement(HourglassFullTwoToneIcon, null)
}, {
  id: "revertedApplication",
  text: /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.application.reverted"
  }),
  icon: /*#__PURE__*/React.createElement(RestorePageIcon, null)
}, {
  id: "returnedApplication",
  text: /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.application.returned"
  }),
  icon: /*#__PURE__*/React.createElement(ArrowBackIcon, null)
}, {
  id: "sentMeetingSheet",
  text: /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.employee.application.sentMeetingSheet"
  }),
  icon: /*#__PURE__*/React.createElement(ForwardIcon, null)
}, {
  id: "approveMeetingSheet",
  text: /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.employee.application.approveMeetingSheet"
  }),
  icon: /*#__PURE__*/React.createElement(CheckCircleOutlineTwoToneIcon, null)
}, {
  id: "applicationStatus",
  text: /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.application.status"
  }),
  icon: /*#__PURE__*/React.createElement(AssignmentIcon, null)
}];

// ----------- Components to Render in Main Content -----------

var ReturnedApplications$7 = function ReturnedApplications() {
  var classes = useStyles$t();
  var loggedInUserId = useSelector(function (state) {
    var _state$core;
    return (_state$core = state.core) === null || _state$core === void 0 || (_state$core = _state$core.user) === null || _state$core === void 0 || (_state$core = _state$core.i_user) === null || _state$core === void 0 ? void 0 : _state$core.id;
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ApplicationProcessSearcher$1, {
    returnedApplications: true,
    loggedInUserId: loggedInUserId,
    disableButtons: 1,
    dynamicTableTitle: "workforce.application.returned"
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.pagination
  }, /*#__PURE__*/React.createElement(Button, null, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.back"
  })), /*#__PURE__*/React.createElement(Button, null, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.next"
  }))));
};
var FiledApplications$6 = function FiledApplications() {
  var classes = useStyles$t();
  var loggedInUserId = useSelector(function (state) {
    var _state$core2;
    return (_state$core2 = state.core) === null || _state$core2 === void 0 || (_state$core2 = _state$core2.user) === null || _state$core2 === void 0 || (_state$core2 = _state$core2.i_user) === null || _state$core2 === void 0 ? void 0 : _state$core2.id;
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5",
    gutterBottom: true
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.dashboard"
  })), /*#__PURE__*/React.createElement(Card, {
    className: classes.tableContainer
  }, /*#__PURE__*/React.createElement(CardContent, null, /*#__PURE__*/React.createElement(ApplicationProcessSearcher$1, {
    loggedInUserId: loggedInUserId,
    coloredRow: true
  }))), /*#__PURE__*/React.createElement("div", {
    className: classes.pagination
  }, /*#__PURE__*/React.createElement(Button, null, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.back"
  })), /*#__PURE__*/React.createElement(Button, null, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.next"
  }))));
};
var ApprovedApplications$4 = function ApprovedApplications(_ref) {
  var _ref$summaryData = _ref.summaryData,
    summaryData = _ref$summaryData === void 0 ? [] : _ref$summaryData,
    _ref$disableButtons = _ref.disableButtons,
    disableButtons = _ref$disableButtons === void 0 ? 0 : _ref$disableButtons;
  var classes = useStyles$t();
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    expanded = _useState2[0],
    setExpanded = _useState2[1];
  var _useState3 = useState(summaryData),
    _useState4 = _slicedToArray(_useState3, 2),
    renderedData = _useState4[0],
    setRenderedData = _useState4[1];
  var dispatch = useDispatch();
  var modulesManager = useModulesManager();
  useEffect(function () {
    if (expanded) {
      dispatch(fetchWorkforceDocument(modulesManager, ["applicationSummaryId:\"".concat(expanded, "\"")]));
    }
  }, [expanded]);
  var documents = useSelector(function (state) {
    var _state$workforce;
    return state === null || state === void 0 || (_state$workforce = state.workforce) === null || _state$workforce === void 0 ? void 0 : _state$workforce.document;
  });
  var type = getFileType(documents === null || documents === void 0 ? void 0 : documents.url);
  var handleChange = function handleChange(panelId) {
    return function (event, isExpanded) {
      if (isExpanded) {
        // Move the clicked item to the top
        console.log({
          panelId: panelId
        });
        var selectedItem = summaryData.find(function (item) {
          return item.id === panelId;
        });
        var others = summaryData.filter(function (item) {
          return item.id !== panelId;
        });
        setRenderedData([selectedItem].concat(_toConsumableArray(others)));
        setExpanded(panelId);
      } else {
        // Collapse → restore original order
        setRenderedData(summaryData);
        setExpanded(null);
      }
    };
  };
  console.log("clear");
  console.log("summary data", summaryData);
  return /*#__PURE__*/React.createElement("div", {
    className: classes.accordionPadding
  }, renderedData.map(function (item) {
    return /*#__PURE__*/React.createElement(Accordion, {
      key: item.id,
      expanded: expanded === item.id,
      onChange: handleChange(item.id),
      className: classes.accordion
    }, /*#__PURE__*/React.createElement(AccordionSummary, {
      className: classes.accordionSummary,
      expandIcon: /*#__PURE__*/React.createElement(ExpandMoreIcon, {
        className: "material-icons"
      })
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "subtitle1",
      style: {
        flex: 1
      }
    }, /*#__PURE__*/React.createElement("strong", null, item.name)), /*#__PURE__*/React.createElement(Typography, {
      variant: "body2",
      style: {
        marginLeft: "auto",
        color: "#015C63"
      }
    }, item.meetingDate, " | ", item.month, " ", item.year)), /*#__PURE__*/React.createElement(AccordionDetails, {
      className: classes.accordionDetails
    }, /*#__PURE__*/React.createElement(Card, {
      style: {
        width: "100%"
      }
    }, /*#__PURE__*/React.createElement(CardContent, null, expanded === item.id && /*#__PURE__*/React.createElement(ApplicationProcessSearcher$1, {
      summaryId: item.id,
      disableButtons: disableButtons
    }))), type === "image" && /*#__PURE__*/React.createElement("img", {
      src: documents === null || documents === void 0 ? void 0 : documents.url,
      alt: "preview",
      style: {
        width: "100%",
        maxHeight: 300,
        objectFit: "contain"
      }
    }), type === "pdf" && /*#__PURE__*/React.createElement("iframe", {
      title: "PDF Viewer",
      src: documents === null || documents === void 0 ? void 0 : documents.url,
      width: "100%",
      height: "600px",
      style: {
        border: "1px solid #ccc",
        borderRadius: 4
      }
    })));
  }));
};
var SentMeetingSheet$3 = function SentMeetingSheet(_ref2) {
  var _ref2$summaryData = _ref2.summaryData,
    summaryData = _ref2$summaryData === void 0 ? [] : _ref2$summaryData,
    _ref2$disableButtons = _ref2.disableButtons,
    disableButtons = _ref2$disableButtons === void 0 ? 0 : _ref2$disableButtons;
  var classes = useStyles$t();
  var _useState5 = useState(null),
    _useState6 = _slicedToArray(_useState5, 2),
    expanded = _useState6[0],
    setExpanded = _useState6[1];
  var _useState7 = useState(summaryData),
    _useState8 = _slicedToArray(_useState7, 2),
    renderedData = _useState8[0],
    setRenderedData = _useState8[1];
  var handleChange = function handleChange(panelId) {
    return function (event, isExpanded) {
      if (isExpanded) {
        // Move the clicked item to the top
        var selectedItem = summaryData === null || summaryData === void 0 ? void 0 : summaryData.find(function (item) {
          return item.id === panelId;
        });
        var others = summaryData === null || summaryData === void 0 ? void 0 : summaryData.filter(function (item) {
          return item.id !== panelId;
        });
        setRenderedData([selectedItem].concat(_toConsumableArray(others)));
        setExpanded(panelId);
      } else {
        // Collapse → restore original order
        setRenderedData(summaryData);
        setExpanded(null);
      }
    };
  };
  console.log("clear");
  console.log("summary data", summaryData);
  return /*#__PURE__*/React.createElement("div", {
    className: classes.accordionPadding
  }, renderedData.map(function (item) {
    return /*#__PURE__*/React.createElement(Accordion, {
      key: item.id,
      expanded: expanded === item.id,
      onChange: handleChange(item.id),
      className: classes.accordion
    }, /*#__PURE__*/React.createElement(AccordionSummary, {
      className: classes.accordionSummary,
      expandIcon: /*#__PURE__*/React.createElement(ExpandMoreIcon, {
        className: "material-icons"
      })
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "subtitle1",
      style: {
        flex: 1
      }
    }, /*#__PURE__*/React.createElement("strong", null, item.name)), /*#__PURE__*/React.createElement(Typography, {
      variant: "body2",
      style: {
        marginLeft: "auto",
        color: "#015C63"
      }
    }, item.meetingDate, " | ", item.month, " ", item.year)), /*#__PURE__*/React.createElement(AccordionDetails, {
      className: classes.accordionDetails
    }, /*#__PURE__*/React.createElement(Card, {
      style: {
        width: "100%"
      }
    }, /*#__PURE__*/React.createElement(CardContent, null, expanded === item.id && /*#__PURE__*/React.createElement(ApplicationProcessSearcher$1, {
      summaryId: item.id,
      disableButtons: disableButtons
    })))));
  }));
};
var SentForVerificationApplications$3 = function SentForVerificationApplications() {
  var classes = useStyles$t();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5",
    gutterBottom: true
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.application.sentforverification"
  })), /*#__PURE__*/React.createElement(Card, {
    className: classes.tableContainer
  }, /*#__PURE__*/React.createElement(CardContent, null, /*#__PURE__*/React.createElement(ApplicationProcessSearcher$1, {
    sentForVerificationApplications: true
  }))), /*#__PURE__*/React.createElement("div", {
    className: classes.pagination
  }, /*#__PURE__*/React.createElement(Button, null, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.back"
  })), /*#__PURE__*/React.createElement(Button, null, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.next"
  }))));
};
var VerifiedApplications$3 = function VerifiedApplications() {
  var classes = useStyles$t();
  var loggedInUserId = useSelector(function (state) {
    var _state$core3;
    return (_state$core3 = state.core) === null || _state$core3 === void 0 || (_state$core3 = _state$core3.user) === null || _state$core3 === void 0 || (_state$core3 = _state$core3.i_user) === null || _state$core3 === void 0 ? void 0 : _state$core3.id;
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5",
    gutterBottom: true
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.application.verified"
  })), /*#__PURE__*/React.createElement(Card, {
    className: classes.tableContainer
  }, /*#__PURE__*/React.createElement(CardContent, null, /*#__PURE__*/React.createElement(ApplicationProcessSearcher$1, {
    verifiedApplications: true,
    meetingForwardButton: 1,
    loggedInUserId: loggedInUserId,
    roleIds: ["49"]
  }))), /*#__PURE__*/React.createElement("div", {
    className: classes.pagination
  }, /*#__PURE__*/React.createElement(Button, null, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.back"
  })), /*#__PURE__*/React.createElement(Button, null, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.next"
  }))));
};
var BeneficiaryReportSheet$3 = function BeneficiaryReportSheet() {
  // historyPush("/workforce/reports/beneficiary-report");
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5",
    gutterBottom: true
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.employee.application.beneficiaryReportSheet"
  })), /*#__PURE__*/React.createElement(BeneficiaryReport, null));
};
var ApplicationStatus$4 = function ApplicationStatus() {
  var dispatch = useDispatch();
  var mm = useModulesManager();
  var _useState9 = useState(""),
    _useState10 = _slicedToArray(_useState9, 2),
    nid = _useState10[0],
    setNid = _useState10[1];
  var _useState11 = useState(false),
    _useState12 = _slicedToArray(_useState11, 2),
    showResult = _useState12[0],
    setShowResult = _useState12[1];
  var _useState13 = useState(null),
    _useState14 = _slicedToArray(_useState13, 2);
    _useState14[0];
    var setApplicationData = _useState14[1];
  var classes = useStyles$t();
  var _useState15 = useState(true),
    _useState16 = _slicedToArray(_useState15, 2),
    hasResults = _useState16[0],
    setHasResults = _useState16[1];
  var handleApplicationSearch = function handleApplicationSearch() {
    var filters = ["workforceEmployee_Nid: \"".concat(nid, "\"")];
    dispatch(fetchApplicationsSummary(mm, filters)).then(function (res) {
      var _res$payload;
      var edges = ((_res$payload = res.payload) === null || _res$payload === void 0 || (_res$payload = _res$payload.data) === null || _res$payload === void 0 || (_res$payload = _res$payload.workforceApplication) === null || _res$payload === void 0 ? void 0 : _res$payload.edges) || [];
      setApplicationData(edges.map(function (e) {
        return e.node;
      }));
      setShowResult(true);
    });
  };
  return /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(CardContent, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5",
    gutterBottom: true
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.application.status"
  })), /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 2,
    justifyContent: "center",
    style: {
      marginTop: 16,
      padding: "32px",
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 6
  }, /*#__PURE__*/React.createElement(TextField, {
    fullWidth: true,
    variant: "outlined",
    size: "small",
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      module: "workforce",
      id: "workforce.representative.nid"
    }),
    value: nid,
    onChange: function onChange(e) {
      return setNid(e.target.value);
    },
    style: {
      marginBottom: 16
    }
  }), /*#__PURE__*/React.createElement(Button, {
    variant: "contained",
    color: "primary",
    fullWidth: true,
    onClick: handleApplicationSearch
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.search.here"
  })))), showResult && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Card, {
    className: classes.tableContainer,
    style: {
      marginTop: 10
    }
  }, /*#__PURE__*/React.createElement(CardContent, null, /*#__PURE__*/React.createElement(ApplicationProcessSearcher$1, {
    nidFilters: ["workforceEmployee_Nid: \"".concat(nid, "\"")],
    onDataLoaded: function onDataLoaded(data) {
      return setHasResults(data && data.length > 0);
    },
    disableButtons: 1
  }))), !hasResults && /*#__PURE__*/React.createElement(Typography, {
    color: "error",
    style: {
      marginTop: 32
    }
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.tracking.notfound",
    defaultMessage: "\u0995\u09CB\u09A8\u09CB \u0986\u09AC\u09C7\u09A6\u09A8 \u09AA\u09BE\u0993\u09AF\u09BC\u09BE \u09AF\u09BE\u09AF\u09BC\u09A8\u09BF\u0964"
  })))));
};
var RevertApplication$3 = function RevertApplication() {
  var classes = useStyles$t();
  var loggedInUserId = useSelector(function (state) {
    var _state$core4;
    return (_state$core4 = state.core) === null || _state$core4 === void 0 || (_state$core4 = _state$core4.user) === null || _state$core4 === void 0 || (_state$core4 = _state$core4.i_user) === null || _state$core4 === void 0 ? void 0 : _state$core4.id;
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5",
    gutterBottom: true
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.application.reverted"
  })), /*#__PURE__*/React.createElement(Card, {
    className: classes.tableContainer
  }, /*#__PURE__*/React.createElement(CardContent, null, /*#__PURE__*/React.createElement(ApplicationProcessSearcher$1, {
    revertedApplication: true,
    loggedInUserId: loggedInUserId
  }))), /*#__PURE__*/React.createElement("div", {
    className: classes.pagination
  }, /*#__PURE__*/React.createElement(Button, null, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.back"
  })), /*#__PURE__*/React.createElement(Button, null, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.next"
  }))));
};
var RejectApplication$5 = function RejectApplication() {
  var classes = useStyles$t();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ApplicationProcessSearcher$1, {
    rejectedApplication: true,
    dynamicTableTitle: "workforce.application.rejectedApplication"
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.pagination
  }, /*#__PURE__*/React.createElement(Button, null, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.back"
  })), /*#__PURE__*/React.createElement(Button, null, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.next"
  }))));
};
var RejectedApplications$3 = function RejectedApplications(_ref3) {
  var _ref3$disableButtons = _ref3.disableButtons,
    disableButtons = _ref3$disableButtons === void 0 ? 0 : _ref3$disableButtons;
  var classes = useStyles$t();
  var dispatch = useDispatch();
  var modulesManager = useModulesManager();
  var _useState17 = useState(null),
    _useState18 = _slicedToArray(_useState17, 2),
    expanded = _useState18[0],
    setExpanded = _useState18[1];
  var loggedInUserId = useSelector(function (state) {
    var _state$core5;
    return (_state$core5 = state.core) === null || _state$core5 === void 0 || (_state$core5 = _state$core5.user) === null || _state$core5 === void 0 || (_state$core5 = _state$core5.i_user) === null || _state$core5 === void 0 ? void 0 : _state$core5.id;
  });
  useEffect(function () {
    // Adjust the fetch action/parameters for rejected applications as needed
    dispatch(fetchSummaryApplications(modulesManager, ['organizationType:"blwf"', 'status:["forward_to_comiitee","forward_to_director","forward_to_dg","approved_by_dg","approved_by_committee"]', 'applicationStatusIn:["rejected_by_committee"]']));
  }, [dispatch, modulesManager]);
  var data = useSelector(function (state) {
    var _state$workforce2;
    return (_state$workforce2 = state.workforce["applicationsSummary"]) !== null && _state$workforce2 !== void 0 ? _state$workforce2 : [];
  });
  // Adjust the filter based on your API response
  // const summaryData = data.filter(d => d.status === "rejected" || d.status === "forward_to_comiitee"); 

  var handleChange = function handleChange(panelId) {
    return function (event, isExpanded) {
      setExpanded(isExpanded ? panelId : null);
    };
  };
  return /*#__PURE__*/React.createElement("div", {
    className: classes.accordionPadding
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5",
    gutterBottom: true
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.dashboard"
  })), data.map(function (item, index) {
    return /*#__PURE__*/React.createElement(Accordion, {
      key: index,
      expanded: expanded === item.id,
      onChange: handleChange(item.id),
      className: classes.accordion
    }, /*#__PURE__*/React.createElement(AccordionSummary, {
      className: classes.accordionSummary,
      expandIcon: /*#__PURE__*/React.createElement(ExpandMoreIcon, {
        className: "material-icons"
      })
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "subtitle1",
      style: {
        flex: 1
      }
    }, /*#__PURE__*/React.createElement("strong", null, item.name)), /*#__PURE__*/React.createElement(Typography, {
      variant: "body2",
      style: {
        marginLeft: "auto",
        color: "#015C63"
      }
    }, item.meetingDate, " | ", item.month, " ", item.year)), /*#__PURE__*/React.createElement(AccordionDetails, {
      className: classes.accordionDetails
    }, /*#__PURE__*/React.createElement(Card, {
      style: {
        width: "100%"
      }
    }, /*#__PURE__*/React.createElement(CardContent, null, expanded === item.id && /*#__PURE__*/React.createElement(ApplicationProcessSearcher$1, {
      coloredRow: true,
      summaryId: item.id,
      loggedInUserId: loggedInUserId,
      disableButtons: disableButtons,
      statusInSummary: "rejected_by_committee" // Update status if needed
    })))));
  }));
};
var PendingMeetingSheet$3 = function PendingMeetingSheet(_ref4) {
  var _ref4$summaryData = _ref4.summaryData,
    summaryData = _ref4$summaryData === void 0 ? [] : _ref4$summaryData;
  console.log("summary data", summaryData);
  var classes = useStyles$t();
  return /*#__PURE__*/React.createElement(React.Fragment, null, summaryData.map(function (item, index) {
    return /*#__PURE__*/React.createElement(Accordion, {
      key: index,
      defaultExpanded: false,
      className: classes.accordion
    }, /*#__PURE__*/React.createElement(AccordionSummary, {
      className: classes.accordionSummary,
      expandIcon: /*#__PURE__*/React.createElement(ExpandMoreIcon, {
        className: "material-icons"
      })
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "subtitle1",
      style: {
        flex: 1
      }
    }, /*#__PURE__*/React.createElement("strong", null, item.name)), /*#__PURE__*/React.createElement(Typography, {
      variant: "body2",
      color: "textSecondary",
      style: {
        marginLeft: 'auto'
      }
    }, item.meetingDate, " | ", item.month, " ", item.year)), /*#__PURE__*/React.createElement(AccordionDetails, {
      className: classes.AccordionDetails
    }, /*#__PURE__*/React.createElement(Card, {
      style: {
        width: "100%"
      }
    }, /*#__PURE__*/React.createElement(CardContent, null, /*#__PURE__*/React.createElement(ApplicationProcessSearcher$1, {
      summaryId: item.id
    })))));
  }));
};

// ------------------------------------------------------------

var SectionAdminDashboard = function SectionAdminDashboard() {
  var classes = useStyles$t();
  var dispatch = useDispatch();
  var modulesManager = useModulesManager();
  var _useState19 = useState("pendingApplications"),
    _useState20 = _slicedToArray(_useState19, 2),
    selectedMenu = _useState20[0],
    setSelectedMenu = _useState20[1]; // Default first menu
  useEffect(function () {
    return dispatch(fetchSummaryApplications(modulesManager, ['sectionTypeIn: ["section_one"]', 'organizationType:"cf"']));
  }, []);
  var data = useSelector(function (state) {
    var _state$workforce3;
    return (_state$workforce3 = state.workforce["applicationsSummary"]) !== null && _state$workforce3 !== void 0 ? _state$workforce3 : [];
  });
  var pendingSummaryData = data.filter(function (d) {
    return d.status !== "approved_by_dg";
  });
  var approvedSummaryData = data.filter(function (d) {
    return d.status === "approved_by_dg" || d.status === "approved_by_minister" || d.status === "approved_by_secretary";
  });
  var sentSummaryData = data.filter(function (d) {
    return d.status === "forward_to_comiitee";
  });
  console.log({
    approvedSummaryData: approvedSummaryData
  });
  var renderContent = function renderContent() {
    switch (selectedMenu) {
      case "pendingApplications":
        return /*#__PURE__*/React.createElement(FiledApplications$6, null);
      case "sentForVerificationApplications":
        return /*#__PURE__*/React.createElement(SentForVerificationApplications$3, null);
      case "verifiedApplications":
        return /*#__PURE__*/React.createElement(VerifiedApplications$3, null);
      case "rejectedApplication":
        return !isEisPath() ? /*#__PURE__*/React.createElement(RejectedApplications$3, null) : /*#__PURE__*/React.createElement(RejectApplication$5, null);
      case "revertedApplication":
        return /*#__PURE__*/React.createElement(RevertApplication$3, null);
      case "returnedApplication":
        return /*#__PURE__*/React.createElement(ReturnedApplications$7, null);
      case "pendingMeetingSheet":
        return /*#__PURE__*/React.createElement(PendingMeetingSheet$3, {
          summaryData: pendingSummaryData,
          disableButtons: 1
        });
      case "sentMeetingSheet":
        return /*#__PURE__*/React.createElement(SentMeetingSheet$3, {
          summaryData: sentSummaryData,
          disableButtons: 1
        });
      case "approveMeetingSheet":
        return /*#__PURE__*/React.createElement(ApprovedApplications$4, {
          summaryData: approvedSummaryData,
          disableButtons: 1
        });
      case "applicationStatus":
        return /*#__PURE__*/React.createElement(ApplicationStatus$4, null);
      case "beneficiaryReportSheet":
        return /*#__PURE__*/React.createElement(BeneficiaryReportSheet$3, null);
      default:
        return /*#__PURE__*/React.createElement(FiledApplications$6, null);
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: classes.root
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 2,
    className: classes.root
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 3
  }, /*#__PURE__*/React.createElement(Paper, {
    className: classes.sidebar
  }, /*#__PURE__*/React.createElement(List, null, SidebarMenu$7.map(function (item) {
    return /*#__PURE__*/React.createElement(ListItem, {
      button: true,
      key: item.id,
      selected: selectedMenu === item.id,
      onClick: function onClick() {
        return setSelectedMenu(item.id);
      }
    }, /*#__PURE__*/React.createElement(ListItemIcon, null, item.icon), /*#__PURE__*/React.createElement(ListItemText, {
      primary: item.text
    }));
  })))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 9,
    className: classes.content
  }, renderContent())));
};

var useStyles$s = makeStyles(function (theme) {
  return {
    root: {
      flexGrow: 1,
      padding: theme.spacing(2),
      height: 'calc(100vh - 64px)',
      // assuming 64px header/appbar, adjust as needed
      overflow: 'visible'
    },
    sidebar: {
      position: "sticky",
      top: 0,
      height: "40vh",
      backgroundColor: theme.palette.background.paper,
      borderRight: "1px solid ".concat(theme.palette.divider),
      overflowY: "auto"
    },
    content: {
      height: '100vh',
      overflowY: 'auto',
      padding: theme.spacing(2)
    },
    tableContainer: {
      marginTop: theme.spacing(0)
    },
    tableHeadCell: {
      fontWeight: "bold"
    },
    noData: {
      textAlign: "center",
      padding: theme.spacing(2)
    },
    searchInput: {
      border: "1px solid #ccc",
      borderRadius: 4,
      padding: "4px 8px",
      width: 200
    },
    pagination: {
      display: "flex",
      justifyContent: "flex-end",
      marginTop: theme.spacing(2),
      alignItems: "center"
    },
    tableHeader: {
      backgroundColor: "#B7D4D8"
    },
    accordion: {
      boxShadow: "1px 1px 1px 1px",
      border: "none",
      backgroundColor: "white",
      marginBottom: "12px",
      borderRadius: "6px",
      "&::before": {
        display: "none"
      }
    },
    accordionSummary: {
      padding: "8px 16px",
      backgroundColor: "white",
      borderRadius: "6px",
      "& .MuiTypography-root": {
        color: "#015C63",
        // teal-like tone
        fontWeight: 600
      }
    },
    accordionDetails: {
      backgroundColor: "white",
      padding: "16px",
      borderTop: "1px solid #ddd"
    }
  };
});
var SidebarMenu$6 = [{
  id: "pendingApplications",
  text: /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.application.pending"
  }),
  icon: /*#__PURE__*/React.createElement(AssignmentReturnedIcon, null)
}, {
  id: "sentForVerificationApplications",
  text: /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.application.sentforverification"
  }),
  icon: /*#__PURE__*/React.createElement(HourglassFullTwoToneIcon, null)
}, {
  id: "verifiedApplications",
  text: /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.application.verified"
  }),
  icon: /*#__PURE__*/React.createElement(VerifiedUserIcon, null)
}, {
  id: "rejectedApplication",
  text: /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.application.rejectedApplication"
  }),
  icon: /*#__PURE__*/React.createElement(CancelIcon, null)
}, {
  id: "pendingMeetingSheet",
  text: /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.employee.application.pendingMeetingSheet"
  }),
  icon: /*#__PURE__*/React.createElement(HourglassFullTwoToneIcon, null)
}, {
  id: "revertedApplication",
  text: /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.application.reverted"
  }),
  icon: /*#__PURE__*/React.createElement(RestorePageIcon, null)
}, {
  id: "returnedApplication",
  text: /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.application.returned"
  }),
  icon: /*#__PURE__*/React.createElement(ArrowBackIcon, null)
}, {
  id: "sentMeetingSheet",
  text: /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.employee.application.sentMeetingSheet"
  }),
  icon: /*#__PURE__*/React.createElement(ForwardIcon, null)
}, {
  id: "approveMeetingSheet",
  text: /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.employee.application.approveMeetingSheet"
  }),
  icon: /*#__PURE__*/React.createElement(CheckCircleOutlineTwoToneIcon, null)
}, {
  id: "applicationStatus",
  text: /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.application.status"
  }),
  icon: /*#__PURE__*/React.createElement(AssignmentIcon, null)
}];

// ----------- Components to Render in Main Content -----------

var ReturnedApplications$6 = function ReturnedApplications() {
  var classes = useStyles$s();
  var loggedInUserId = useSelector(function (state) {
    var _state$core;
    return (_state$core = state.core) === null || _state$core === void 0 || (_state$core = _state$core.user) === null || _state$core === void 0 || (_state$core = _state$core.i_user) === null || _state$core === void 0 ? void 0 : _state$core.id;
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ApplicationProcessSearcher$1, {
    returnedApplications: true,
    loggedInUserId: loggedInUserId,
    disableButtons: 1,
    dynamicTableTitle: "workforce.application.returned"
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.pagination
  }, /*#__PURE__*/React.createElement(Button, null, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.back"
  })), /*#__PURE__*/React.createElement(Button, null, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.next"
  }))));
};
var FiledApplications$5 = function FiledApplications() {
  var classes = useStyles$s();
  var loggedInUserId = useSelector(function (state) {
    var _state$core2;
    return (_state$core2 = state.core) === null || _state$core2 === void 0 || (_state$core2 = _state$core2.user) === null || _state$core2 === void 0 || (_state$core2 = _state$core2.i_user) === null || _state$core2 === void 0 ? void 0 : _state$core2.id;
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5",
    gutterBottom: true
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.dashboard"
  })), /*#__PURE__*/React.createElement(Card, {
    className: classes.tableContainer
  }, /*#__PURE__*/React.createElement(CardContent, null, /*#__PURE__*/React.createElement(ApplicationProcessSearcher$1, {
    loggedInUserId: loggedInUserId,
    coloredRow: true
  }))), /*#__PURE__*/React.createElement("div", {
    className: classes.pagination
  }, /*#__PURE__*/React.createElement(Button, null, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.back"
  })), /*#__PURE__*/React.createElement(Button, null, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.next"
  }))));
};
var ApprovedApplications$3 = function ApprovedApplications(_ref) {
  var _ref$summaryData = _ref.summaryData,
    summaryData = _ref$summaryData === void 0 ? [] : _ref$summaryData,
    _ref$disableButtons = _ref.disableButtons,
    disableButtons = _ref$disableButtons === void 0 ? 0 : _ref$disableButtons;
  var classes = useStyles$s();
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    expanded = _useState2[0],
    setExpanded = _useState2[1];
  var handleChange = function handleChange(panelId) {
    return function (event, isExpanded) {
      setExpanded(isExpanded ? panelId : null);
    };
  };
  console.log("clear");
  console.log("summary data", summaryData);
  return /*#__PURE__*/React.createElement("div", {
    className: classes.accordionPadding
  }, summaryData.map(function (item, index) {
    return /*#__PURE__*/React.createElement(Accordion, {
      key: index,
      expanded: expanded === item.id,
      onChange: handleChange(item.id),
      className: classes.accordion
    }, /*#__PURE__*/React.createElement(AccordionSummary, {
      className: classes.accordionSummary,
      expandIcon: /*#__PURE__*/React.createElement(ExpandMoreIcon, {
        className: "material-icons"
      })
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "subtitle1",
      style: {
        flex: 1
      }
    }, /*#__PURE__*/React.createElement("strong", null, item.name)), /*#__PURE__*/React.createElement(Typography, {
      variant: "body2",
      style: {
        marginLeft: "auto",
        color: "#015C63"
      }
    }, item.meetingDate, " | ", item.month, " ", item.year)), /*#__PURE__*/React.createElement(AccordionDetails, {
      className: classes.accordionDetails
    }, /*#__PURE__*/React.createElement(Card, {
      style: {
        width: "100%"
      }
    }, /*#__PURE__*/React.createElement(CardContent, null, expanded === item.id && /*#__PURE__*/React.createElement(ApplicationProcessSearcher$1, {
      summaryId: item.id,
      disableButtons: disableButtons,
      approveMeetingSheet: true
    })))));
  }));
};
var SentMeetingSheet$2 = function SentMeetingSheet(_ref2) {
  var _ref2$summaryData = _ref2.summaryData,
    summaryData = _ref2$summaryData === void 0 ? [] : _ref2$summaryData,
    _ref2$disableButtons = _ref2.disableButtons,
    disableButtons = _ref2$disableButtons === void 0 ? 0 : _ref2$disableButtons;
  var classes = useStyles$s();
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    expanded = _useState4[0],
    setExpanded = _useState4[1];
  var handleChange = function handleChange(panelId) {
    return function (event, isExpanded) {
      setExpanded(isExpanded ? panelId : null);
    };
  };
  console.log("clear");
  console.log("summary data", summaryData);
  return /*#__PURE__*/React.createElement("div", {
    className: classes.accordionPadding
  }, summaryData.map(function (item, index) {
    return /*#__PURE__*/React.createElement(Accordion, {
      key: index,
      expanded: expanded === item.id,
      onChange: handleChange(item.id),
      className: classes.accordion
    }, /*#__PURE__*/React.createElement(AccordionSummary, {
      className: classes.accordionSummary,
      expandIcon: /*#__PURE__*/React.createElement(ExpandMoreIcon, {
        className: "material-icons"
      })
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "subtitle1",
      style: {
        flex: 1
      }
    }, /*#__PURE__*/React.createElement("strong", null, item.name)), /*#__PURE__*/React.createElement(Typography, {
      variant: "body2",
      style: {
        marginLeft: "auto",
        color: "#015C63"
      }
    }, item.meetingDate, " | ", item.month, " ", item.year)), /*#__PURE__*/React.createElement(AccordionDetails, {
      className: classes.accordionDetails
    }, /*#__PURE__*/React.createElement(Card, {
      style: {
        width: "100%"
      }
    }, /*#__PURE__*/React.createElement(CardContent, null, expanded === item.id && /*#__PURE__*/React.createElement(ApplicationProcessSearcher$1, {
      summaryId: item.id,
      disableButtons: disableButtons
    })))));
  }));
};
var SentForVerificationApplications$2 = function SentForVerificationApplications() {
  var classes = useStyles$s();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5",
    gutterBottom: true
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.application.sentforverification"
  })), /*#__PURE__*/React.createElement(Card, {
    className: classes.tableContainer
  }, /*#__PURE__*/React.createElement(CardContent, null, /*#__PURE__*/React.createElement(ApplicationProcessSearcher$1, {
    sentForVerificationApplications: true
  }))), /*#__PURE__*/React.createElement("div", {
    className: classes.pagination
  }, /*#__PURE__*/React.createElement(Button, null, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.back"
  })), /*#__PURE__*/React.createElement(Button, null, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.next"
  }))));
};
var VerifiedApplications$2 = function VerifiedApplications() {
  var classes = useStyles$s();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5",
    gutterBottom: true
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.application.verified"
  })), /*#__PURE__*/React.createElement(Card, {
    className: classes.tableContainer
  }, /*#__PURE__*/React.createElement(CardContent, null, /*#__PURE__*/React.createElement(ApplicationProcessSearcher$1, {
    verifiedApplications: true,
    meetingForwardButton: 1,
    roleIds: ["49"]
  }))), /*#__PURE__*/React.createElement("div", {
    className: classes.pagination
  }, /*#__PURE__*/React.createElement(Button, null, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.back"
  })), /*#__PURE__*/React.createElement(Button, null, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.next"
  }))));
};
var ApplicationStatus$3 = function ApplicationStatus() {
  var dispatch = useDispatch();
  var mm = useModulesManager();
  var _useState5 = useState(""),
    _useState6 = _slicedToArray(_useState5, 2),
    nid = _useState6[0],
    setNid = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    showResult = _useState8[0],
    setShowResult = _useState8[1];
  var _useState9 = useState(null),
    _useState10 = _slicedToArray(_useState9, 2);
    _useState10[0];
    var setApplicationData = _useState10[1];
  var classes = useStyles$s();
  var _useState11 = useState(true),
    _useState12 = _slicedToArray(_useState11, 2),
    hasResults = _useState12[0],
    setHasResults = _useState12[1];
  var handleApplicationSearch = function handleApplicationSearch() {
    var filters = ["workforceEmployee_Nid: \"".concat(nid, "\"")];
    dispatch(fetchApplicationsSummary(mm, filters)).then(function (res) {
      var _res$payload;
      var edges = ((_res$payload = res.payload) === null || _res$payload === void 0 || (_res$payload = _res$payload.data) === null || _res$payload === void 0 || (_res$payload = _res$payload.workforceApplication) === null || _res$payload === void 0 ? void 0 : _res$payload.edges) || [];
      setApplicationData(edges.map(function (e) {
        return e.node;
      }));
      setShowResult(true);
    });
  };
  return /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(CardContent, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5",
    gutterBottom: true
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.application.status"
  })), /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 2,
    justifyContent: "center",
    style: {
      marginTop: 16,
      padding: "32px",
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 6
  }, /*#__PURE__*/React.createElement(TextField, {
    fullWidth: true,
    variant: "outlined",
    size: "small",
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      module: "workforce",
      id: "workforce.representative.nid"
    }),
    value: nid,
    onChange: function onChange(e) {
      return setNid(e.target.value);
    },
    style: {
      marginBottom: 16
    }
  }), /*#__PURE__*/React.createElement(Button, {
    variant: "contained",
    color: "primary",
    fullWidth: true,
    onClick: handleApplicationSearch
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.search.here"
  })))), showResult && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Card, {
    className: classes.tableContainer,
    style: {
      marginTop: 10
    }
  }, /*#__PURE__*/React.createElement(CardContent, null, /*#__PURE__*/React.createElement(ApplicationProcessSearcher$1, {
    nidFilters: ["workforceEmployee_Nid: \"".concat(nid, "\"")],
    onDataLoaded: function onDataLoaded(data) {
      return setHasResults(data && data.length > 0);
    },
    disableButtons: 1
  }))), !hasResults && /*#__PURE__*/React.createElement(Typography, {
    color: "error",
    style: {
      marginTop: 32
    }
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.tracking.notfound",
    defaultMessage: "\u0995\u09CB\u09A8\u09CB \u0986\u09AC\u09C7\u09A6\u09A8 \u09AA\u09BE\u0993\u09AF\u09BC\u09BE \u09AF\u09BE\u09AF\u09BC\u09A8\u09BF\u0964"
  })))));
};
var RevertApplication$2 = function RevertApplication() {
  var classes = useStyles$s();
  var loggedInUserId = useSelector(function (state) {
    var _state$core3;
    return (_state$core3 = state.core) === null || _state$core3 === void 0 || (_state$core3 = _state$core3.user) === null || _state$core3 === void 0 || (_state$core3 = _state$core3.i_user) === null || _state$core3 === void 0 ? void 0 : _state$core3.id;
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5",
    gutterBottom: true
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.application.reverted"
  })), /*#__PURE__*/React.createElement(Card, {
    className: classes.tableContainer
  }, /*#__PURE__*/React.createElement(CardContent, null, /*#__PURE__*/React.createElement(ApplicationProcessSearcher$1, {
    revertedApplication: true,
    loggedInUserId: loggedInUserId
  }))), /*#__PURE__*/React.createElement("div", {
    className: classes.pagination
  }, /*#__PURE__*/React.createElement(Button, null, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.back"
  })), /*#__PURE__*/React.createElement(Button, null, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.next"
  }))));
};
var RejectApplication$4 = function RejectApplication() {
  var classes = useStyles$s();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ApplicationProcessSearcher$1, {
    rejectedApplication: true,
    dynamicTableTitle: "workforce.application.rejectedApplication"
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.pagination
  }, /*#__PURE__*/React.createElement(Button, null, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.back"
  })), /*#__PURE__*/React.createElement(Button, null, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.next"
  }))));
};
var RejectedApplications$2 = function RejectedApplications(_ref3) {
  var _ref3$disableButtons = _ref3.disableButtons,
    disableButtons = _ref3$disableButtons === void 0 ? 0 : _ref3$disableButtons;
  var classes = useStyles$s();
  var dispatch = useDispatch();
  var modulesManager = useModulesManager();
  var _useState13 = useState(null),
    _useState14 = _slicedToArray(_useState13, 2),
    expanded = _useState14[0],
    setExpanded = _useState14[1];
  var loggedInUserId = useSelector(function (state) {
    var _state$core4;
    return (_state$core4 = state.core) === null || _state$core4 === void 0 || (_state$core4 = _state$core4.user) === null || _state$core4 === void 0 || (_state$core4 = _state$core4.i_user) === null || _state$core4 === void 0 ? void 0 : _state$core4.id;
  });
  useEffect(function () {
    // Adjust the fetch action/parameters for rejected applications as needed
    dispatch(fetchSummaryApplications(modulesManager, ['organizationType:"blwf"', 'status:["forward_to_comiitee","forward_to_director","forward_to_dg","approved_by_dg","approved_by_committee"]', 'applicationStatusIn:["rejected_by_committee"]']));
  }, [dispatch, modulesManager]);
  var data = useSelector(function (state) {
    var _state$workforce;
    return (_state$workforce = state.workforce["applicationsSummary"]) !== null && _state$workforce !== void 0 ? _state$workforce : [];
  });
  // Adjust the filter based on your API response
  // const summaryData = data.filter(d => d.status === "rejected" || d.status === "forward_to_comiitee"); 

  var handleChange = function handleChange(panelId) {
    return function (event, isExpanded) {
      setExpanded(isExpanded ? panelId : null);
    };
  };
  return /*#__PURE__*/React.createElement("div", {
    className: classes.accordionPadding
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5",
    gutterBottom: true
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.dashboard"
  })), data.map(function (item, index) {
    return /*#__PURE__*/React.createElement(Accordion, {
      key: index,
      expanded: expanded === item.id,
      onChange: handleChange(item.id),
      className: classes.accordion
    }, /*#__PURE__*/React.createElement(AccordionSummary, {
      className: classes.accordionSummary,
      expandIcon: /*#__PURE__*/React.createElement(ExpandMoreIcon, {
        className: "material-icons"
      })
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "subtitle1",
      style: {
        flex: 1
      }
    }, /*#__PURE__*/React.createElement("strong", null, item.name)), /*#__PURE__*/React.createElement(Typography, {
      variant: "body2",
      style: {
        marginLeft: "auto",
        color: "#015C63"
      }
    }, item.meetingDate, " | ", item.month, " ", item.year)), /*#__PURE__*/React.createElement(AccordionDetails, {
      className: classes.accordionDetails
    }, /*#__PURE__*/React.createElement(Card, {
      style: {
        width: "100%"
      }
    }, /*#__PURE__*/React.createElement(CardContent, null, expanded === item.id && /*#__PURE__*/React.createElement(ApplicationProcessSearcher$1, {
      coloredRow: true,
      summaryId: item.id,
      loggedInUserId: loggedInUserId,
      disableButtons: disableButtons,
      statusInSummary: "rejected_by_committee" // Update status if needed
    })))));
  }));
};
var PendingMeetingSheet$2 = function PendingMeetingSheet(_ref4) {
  var _ref4$summaryData = _ref4.summaryData,
    summaryData = _ref4$summaryData === void 0 ? [] : _ref4$summaryData;
  console.log("summary data", summaryData);
  var classes = useStyles$s();
  return /*#__PURE__*/React.createElement(React.Fragment, null, summaryData.map(function (item, index) {
    return /*#__PURE__*/React.createElement(Accordion, {
      key: index,
      defaultExpanded: false,
      className: classes.accordion
    }, /*#__PURE__*/React.createElement(AccordionSummary, {
      className: classes.accordionSummary,
      expandIcon: /*#__PURE__*/React.createElement(ExpandMoreIcon, {
        className: "material-icons"
      })
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "subtitle1",
      style: {
        flex: 1
      }
    }, /*#__PURE__*/React.createElement("strong", null, item.name)), /*#__PURE__*/React.createElement(Typography, {
      variant: "body2",
      color: "textSecondary",
      style: {
        marginLeft: 'auto'
      }
    }, item.meetingDate, " | ", item.month, " ", item.year)), /*#__PURE__*/React.createElement(AccordionDetails, {
      className: classes.AccordionDetails
    }, /*#__PURE__*/React.createElement(Card, {
      style: {
        width: "100%"
      }
    }, /*#__PURE__*/React.createElement(CardContent, null, /*#__PURE__*/React.createElement(ApplicationProcessSearcher$1, {
      summaryId: item.id
    })))));
  }));
};

// ------------------------------------------------------------

var SectionTwoAdminDashboardPage = function SectionTwoAdminDashboardPage() {
  var classes = useStyles$s();
  var dispatch = useDispatch();
  var modulesManager = useModulesManager();
  var _useState15 = useState("pendingApplications"),
    _useState16 = _slicedToArray(_useState15, 2),
    selectedMenu = _useState16[0],
    setSelectedMenu = _useState16[1]; // Default first menu
  useEffect(function () {
    return dispatch(fetchSummaryApplications(modulesManager, ['sectionTypeIn: ["section_two"]', 'organizationType:"cf"']));
  }, []);
  var data = useSelector(function (state) {
    var _state$workforce2;
    return (_state$workforce2 = state.workforce["applicationsSummary"]) !== null && _state$workforce2 !== void 0 ? _state$workforce2 : [];
  });
  var pendingSummaryData = data.filter(function (d) {
    return d.status !== "approved_by_dg";
  });
  //  const approvedSummaryData = data.filter(d => d.status === "approved_by_dg");
  var approvedSummaryData = data.filter(function (d) {
    return d.status === "approved_by_dg" || d.status === "approved_by_minister" || d.status === "approved_by_secretary";
  });
  var sentSummaryData = data.filter(function (d) {
    return d.status === "forward_to_comiitee";
  });
  var renderContent = function renderContent() {
    switch (selectedMenu) {
      case "pendingApplications":
        return /*#__PURE__*/React.createElement(FiledApplications$5, null);
      case "sentForVerificationApplications":
        return /*#__PURE__*/React.createElement(SentForVerificationApplications$2, null);
      case "verifiedApplications":
        return /*#__PURE__*/React.createElement(VerifiedApplications$2, null);
      case "rejectedApplication":
        return !isEisPath() ? /*#__PURE__*/React.createElement(RejectedApplications$2, null) : /*#__PURE__*/React.createElement(RejectApplication$4, null);
      case "revertedApplication":
        return /*#__PURE__*/React.createElement(RevertApplication$2, null);
      case "returnedApplication":
        return /*#__PURE__*/React.createElement(ReturnedApplications$6, null);
      case "pendingMeetingSheet":
        return /*#__PURE__*/React.createElement(PendingMeetingSheet$2, {
          summaryData: pendingSummaryData,
          disableButtons: 1
        });
      case "sentMeetingSheet":
        return /*#__PURE__*/React.createElement(SentMeetingSheet$2, {
          summaryData: sentSummaryData,
          disableButtons: 1
        });
      case "approveMeetingSheet":
        return /*#__PURE__*/React.createElement(ApprovedApplications$3, {
          summaryData: approvedSummaryData,
          disableButtons: 1
        });
      case "applicationStatus":
        return /*#__PURE__*/React.createElement(ApplicationStatus$3, null);
      case "beneficiaryReportSheet":
        return /*#__PURE__*/React.createElement(BeneficiaryReportSheet, null);
      default:
        return /*#__PURE__*/React.createElement(FiledApplications$5, null);
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: classes.root
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 2,
    className: classes.root
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 3
  }, /*#__PURE__*/React.createElement(Paper, {
    className: classes.sidebar
  }, /*#__PURE__*/React.createElement(List, null, SidebarMenu$6.map(function (item) {
    return /*#__PURE__*/React.createElement(ListItem, {
      button: true,
      key: item.id,
      selected: selectedMenu === item.id,
      onClick: function onClick() {
        return setSelectedMenu(item.id);
      }
    }, /*#__PURE__*/React.createElement(ListItemIcon, null, item.icon), /*#__PURE__*/React.createElement(ListItemText, {
      primary: item.text
    }));
  })))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 9,
    className: classes.content
  }, renderContent())));
};

var useStyles$r = makeStyles(function (theme) {
  return {
    root: {
      flexGrow: 1,
      padding: theme.spacing(2),
      height: 'calc(100vh - 64px)',
      // assuming 64px header/appbar, adjust as needed
      overflow: 'visible'
    },
    sidebar: {
      position: "sticky",
      top: 0,
      height: "70vh",
      backgroundColor: theme.palette.background.paper,
      borderRight: "1px solid ".concat(theme.palette.divider),
      overflowY: "auto"
    },
    content: {
      height: '100vh',
      overflowY: 'auto',
      padding: theme.spacing(2)
    },
    tableContainer: {
      marginTop: theme.spacing(0)
    },
    tableHeadCell: {
      fontWeight: "bold"
    },
    noData: {
      textAlign: "center",
      padding: theme.spacing(2)
    },
    searchInput: {
      border: "1px solid #ccc",
      borderRadius: 4,
      padding: "4px 8px",
      width: 200
    },
    pagination: {
      display: "flex",
      justifyContent: "flex-end",
      marginTop: theme.spacing(2),
      alignItems: "center"
    },
    tableHeader: {
      backgroundColor: "#B7D4D8"
    },
    accordion: {
      boxShadow: "1px 1px 1px 1px",
      border: "none",
      backgroundColor: "white",
      marginBottom: "12px",
      borderRadius: "6px",
      "&::before": {
        display: "none"
      }
    },
    accordionSummary: {
      padding: "8px 16px",
      backgroundColor: "white",
      borderRadius: "6px",
      "& .MuiTypography-root": {
        color: "#015C63",
        // teal-like tone
        fontWeight: 600
      }
    },
    accordionDetails: {
      backgroundColor: "white",
      padding: "16px",
      borderTop: "1px solid #ddd"
    }
  };
});
var SidebarMenu$5 = [{
  id: "pendingApplications",
  text: /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.application.pending"
  }),
  icon: /*#__PURE__*/React.createElement(AssignmentReturnedIcon, null)
}, {
  id: "sentForVerificationApplications",
  text: /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.application.sentforverification"
  }),
  icon: /*#__PURE__*/React.createElement(HourglassFullTwoToneIcon, null)
}, {
  id: "verifiedApplications",
  text: /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.application.verified"
  }),
  icon: /*#__PURE__*/React.createElement(VerifiedUserIcon, null)
}, {
  id: "rejectedApplication",
  text: /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.application.rejectedApplication"
  }),
  icon: /*#__PURE__*/React.createElement(CancelIcon, null)
}, {
  id: "pendingMeetingSheet",
  text: /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.employee.application.pendingMeetingSheet"
  }),
  icon: /*#__PURE__*/React.createElement(HourglassFullTwoToneIcon, null)
}, {
  id: "revertedApplication",
  text: /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.application.reverted"
  }),
  icon: /*#__PURE__*/React.createElement(RestorePageIcon, null)
}, {
  id: "returnedApplication",
  text: /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.application.returned"
  }),
  icon: /*#__PURE__*/React.createElement(ArrowBackIcon, null)
}, {
  id: "sentMeetingSheet",
  text: /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.employee.application.sentMeetingSheet"
  }),
  icon: /*#__PURE__*/React.createElement(ForwardIcon, null)
}, {
  id: "approveMeetingSheet",
  text: /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.employee.application.approveMeetingSheet"
  }),
  icon: /*#__PURE__*/React.createElement(CheckCircleOutlineTwoToneIcon, null)
}, {
  id: "applicationStatus",
  text: /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.application.status"
  }),
  icon: /*#__PURE__*/React.createElement(AssignmentIcon, null)
}];

// ----------- Components to Render in Main Content -----------

var ReturnedApplications$5 = function ReturnedApplications() {
  var classes = useStyles$r();
  var loggedInUserId = useSelector(function (state) {
    var _state$core;
    return (_state$core = state.core) === null || _state$core === void 0 || (_state$core = _state$core.user) === null || _state$core === void 0 || (_state$core = _state$core.i_user) === null || _state$core === void 0 ? void 0 : _state$core.id;
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ApplicationProcessSearcher$1, {
    returnedApplications: true,
    loggedInUserId: loggedInUserId,
    disableButtons: 1,
    dynamicTableTitle: "workforce.application.returned"
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.pagination
  }, /*#__PURE__*/React.createElement(Button, null, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.back"
  })), /*#__PURE__*/React.createElement(Button, null, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.next"
  }))));
};
var FiledApplications$4 = function FiledApplications() {
  var classes = useStyles$r();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5",
    gutterBottom: true
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.dashboard"
  })), /*#__PURE__*/React.createElement(Card, {
    className: classes.tableContainer
  }, /*#__PURE__*/React.createElement(CardContent, null, /*#__PURE__*/React.createElement(ApplicationProcessSearcher$1, {
    coloredRow: true
  }))), /*#__PURE__*/React.createElement("div", {
    className: classes.pagination
  }, /*#__PURE__*/React.createElement(Button, null, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.back"
  })), /*#__PURE__*/React.createElement(Button, null, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.next"
  }))));
};
var ApprovedApplications$2 = function ApprovedApplications(_ref) {
  var _ref$summaryData = _ref.summaryData,
    summaryData = _ref$summaryData === void 0 ? [] : _ref$summaryData,
    _ref$disableButtons = _ref.disableButtons,
    disableButtons = _ref$disableButtons === void 0 ? 0 : _ref$disableButtons;
  var classes = useStyles$r();
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    expanded = _useState2[0],
    setExpanded = _useState2[1];
  var handleChange = function handleChange(panelId) {
    return function (event, isExpanded) {
      setExpanded(isExpanded ? panelId : null);
    };
  };
  console.log("clear");
  console.log("summary data", summaryData);
  return /*#__PURE__*/React.createElement("div", {
    className: classes.accordionPadding
  }, summaryData.map(function (item, index) {
    return /*#__PURE__*/React.createElement(Accordion, {
      key: index,
      expanded: expanded === item.id,
      onChange: handleChange(item.id),
      className: classes.accordion
    }, /*#__PURE__*/React.createElement(AccordionSummary, {
      className: classes.accordionSummary,
      expandIcon: /*#__PURE__*/React.createElement(ExpandMoreIcon, {
        className: "material-icons"
      })
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "subtitle1",
      style: {
        flex: 1
      }
    }, /*#__PURE__*/React.createElement("strong", null, item.name)), /*#__PURE__*/React.createElement(Typography, {
      variant: "body2",
      style: {
        marginLeft: "auto",
        color: "#015C63"
      }
    }, item.meetingDate, " | ", item.month, " ", item.year)), /*#__PURE__*/React.createElement(AccordionDetails, {
      className: classes.accordionDetails
    }, /*#__PURE__*/React.createElement(Card, {
      style: {
        width: "100%"
      }
    }, /*#__PURE__*/React.createElement(CardContent, null, expanded === item.id && /*#__PURE__*/React.createElement(ApplicationProcessSearcher$1, {
      summaryId: item.id,
      disableButtons: disableButtons
    })))));
  }));
};
var SentMeetingSheet$1 = function SentMeetingSheet(_ref2) {
  var _ref2$summaryData = _ref2.summaryData,
    summaryData = _ref2$summaryData === void 0 ? [] : _ref2$summaryData,
    _ref2$disableButtons = _ref2.disableButtons,
    disableButtons = _ref2$disableButtons === void 0 ? 0 : _ref2$disableButtons;
  var classes = useStyles$r();
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    expanded = _useState4[0],
    setExpanded = _useState4[1];
  var handleChange = function handleChange(panelId) {
    return function (event, isExpanded) {
      setExpanded(isExpanded ? panelId : null);
    };
  };
  console.log("clear");
  console.log("summary data", summaryData);
  return /*#__PURE__*/React.createElement("div", {
    className: classes.accordionPadding
  }, summaryData.map(function (item, index) {
    return /*#__PURE__*/React.createElement(Accordion, {
      key: index,
      expanded: expanded === item.id,
      onChange: handleChange(item.id),
      className: classes.accordion
    }, /*#__PURE__*/React.createElement(AccordionSummary, {
      className: classes.accordionSummary,
      expandIcon: /*#__PURE__*/React.createElement(ExpandMoreIcon, {
        className: "material-icons"
      })
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "subtitle1",
      style: {
        flex: 1
      }
    }, /*#__PURE__*/React.createElement("strong", null, item.name)), /*#__PURE__*/React.createElement(Typography, {
      variant: "body2",
      style: {
        marginLeft: "auto",
        color: "#015C63"
      }
    }, item.meetingDate, " | ", item.month, " ", item.year)), /*#__PURE__*/React.createElement(AccordionDetails, {
      className: classes.accordionDetails
    }, /*#__PURE__*/React.createElement(Card, {
      style: {
        width: "100%"
      }
    }, /*#__PURE__*/React.createElement(CardContent, null, expanded === item.id && /*#__PURE__*/React.createElement(ApplicationProcessSearcher$1, {
      summaryId: item.id,
      disableButtons: disableButtons
    })))));
  }));
};
var SentForVerificationApplications$1 = function SentForVerificationApplications() {
  var classes = useStyles$r();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5",
    gutterBottom: true
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.application.sentforverification"
  })), /*#__PURE__*/React.createElement(Card, {
    className: classes.tableContainer
  }, /*#__PURE__*/React.createElement(CardContent, null, /*#__PURE__*/React.createElement(ApplicationProcessSearcher$1, {
    sentForVerificationApplications: true
  }))), /*#__PURE__*/React.createElement("div", {
    className: classes.pagination
  }, /*#__PURE__*/React.createElement(Button, null, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.back"
  })), /*#__PURE__*/React.createElement(Button, null, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.next"
  }))));
};
var VerifiedApplications$1 = function VerifiedApplications() {
  var classes = useStyles$r();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5",
    gutterBottom: true
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.application.verified"
  })), /*#__PURE__*/React.createElement(Card, {
    className: classes.tableContainer
  }, /*#__PURE__*/React.createElement(CardContent, null, /*#__PURE__*/React.createElement(ApplicationProcessSearcher$1, {
    verifiedApplications: true,
    meetingForwardButton: 1,
    roleIds: ["49"]
  }))), /*#__PURE__*/React.createElement("div", {
    className: classes.pagination
  }, /*#__PURE__*/React.createElement(Button, null, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.back"
  })), /*#__PURE__*/React.createElement(Button, null, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.next"
  }))));
};
var BeneficiaryReportSheet$2 = function BeneficiaryReportSheet() {
  // historyPush("/workforce/reports/beneficiary-report");
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5",
    gutterBottom: true
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.employee.application.beneficiaryReportSheet"
  })), /*#__PURE__*/React.createElement(BeneficiaryReport, null));
};
var ApplicationStatus$2 = function ApplicationStatus() {
  var dispatch = useDispatch();
  var mm = useModulesManager();
  var _useState5 = useState(""),
    _useState6 = _slicedToArray(_useState5, 2),
    nid = _useState6[0],
    setNid = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    showResult = _useState8[0],
    setShowResult = _useState8[1];
  var _useState9 = useState(null),
    _useState10 = _slicedToArray(_useState9, 2);
    _useState10[0];
    var setApplicationData = _useState10[1];
  var classes = useStyles$r();
  var _useState11 = useState(true),
    _useState12 = _slicedToArray(_useState11, 2),
    hasResults = _useState12[0],
    setHasResults = _useState12[1];
  var handleApplicationSearch = function handleApplicationSearch() {
    var filters = ["workforceEmployee_Nid: \"".concat(nid, "\"")];
    dispatch(fetchApplicationsSummary(mm, filters)).then(function (res) {
      var _res$payload;
      var edges = ((_res$payload = res.payload) === null || _res$payload === void 0 || (_res$payload = _res$payload.data) === null || _res$payload === void 0 || (_res$payload = _res$payload.workforceApplication) === null || _res$payload === void 0 ? void 0 : _res$payload.edges) || [];
      setApplicationData(edges.map(function (e) {
        return e.node;
      }));
      setShowResult(true);
    });
  };
  return /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(CardContent, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5",
    gutterBottom: true
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.application.status"
  })), /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 2,
    justifyContent: "center",
    style: {
      marginTop: 16,
      padding: "32px",
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 6
  }, /*#__PURE__*/React.createElement(TextField, {
    fullWidth: true,
    variant: "outlined",
    size: "small",
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      module: "workforce",
      id: "workforce.representative.nid"
    }),
    value: nid,
    onChange: function onChange(e) {
      return setNid(e.target.value);
    },
    style: {
      marginBottom: 16
    }
  }), /*#__PURE__*/React.createElement(Button, {
    variant: "contained",
    color: "primary",
    fullWidth: true,
    onClick: handleApplicationSearch
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.search.here"
  })))), showResult && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Card, {
    className: classes.tableContainer,
    style: {
      marginTop: 10
    }
  }, /*#__PURE__*/React.createElement(CardContent, null, /*#__PURE__*/React.createElement(ApplicationProcessSearcher$1, {
    nidFilters: ["workforceEmployee_Nid: \"".concat(nid, "\"")],
    onDataLoaded: function onDataLoaded(data) {
      return setHasResults(data && data.length > 0);
    },
    disableButtons: 1
  }))), !hasResults && /*#__PURE__*/React.createElement(Typography, {
    color: "error",
    style: {
      marginTop: 32
    }
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.tracking.notfound",
    defaultMessage: "\u0995\u09CB\u09A8\u09CB \u0986\u09AC\u09C7\u09A6\u09A8 \u09AA\u09BE\u0993\u09AF\u09BC\u09BE \u09AF\u09BE\u09AF\u09BC\u09A8\u09BF\u0964"
  })))));
};
var RevertApplication$1 = function RevertApplication() {
  var classes = useStyles$r();
  var loggedInUserId = useSelector(function (state) {
    var _state$core2;
    return (_state$core2 = state.core) === null || _state$core2 === void 0 || (_state$core2 = _state$core2.user) === null || _state$core2 === void 0 || (_state$core2 = _state$core2.i_user) === null || _state$core2 === void 0 ? void 0 : _state$core2.id;
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5",
    gutterBottom: true
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.application.reverted"
  })), /*#__PURE__*/React.createElement(Card, {
    className: classes.tableContainer
  }, /*#__PURE__*/React.createElement(CardContent, null, /*#__PURE__*/React.createElement(ApplicationProcessSearcher$1, {
    revertedApplication: true,
    loggedInUserId: loggedInUserId
  }))), /*#__PURE__*/React.createElement("div", {
    className: classes.pagination
  }, /*#__PURE__*/React.createElement(Button, null, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.back"
  })), /*#__PURE__*/React.createElement(Button, null, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.next"
  }))));
};
var RejectApplication$3 = function RejectApplication() {
  var classes = useStyles$r();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ApplicationProcessSearcher$1, {
    rejectedApplication: true,
    dynamicTableTitle: "workforce.application.rejectedApplication"
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.pagination
  }, /*#__PURE__*/React.createElement(Button, null, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.back"
  })), /*#__PURE__*/React.createElement(Button, null, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.next"
  }))));
};
var RejectedApplications$1 = function RejectedApplications(_ref3) {
  var _ref3$disableButtons = _ref3.disableButtons,
    disableButtons = _ref3$disableButtons === void 0 ? 0 : _ref3$disableButtons;
  var classes = useStyles$r();
  var dispatch = useDispatch();
  var modulesManager = useModulesManager();
  var _useState13 = useState(null),
    _useState14 = _slicedToArray(_useState13, 2),
    expanded = _useState14[0],
    setExpanded = _useState14[1];
  var loggedInUserId = useSelector(function (state) {
    var _state$core3;
    return (_state$core3 = state.core) === null || _state$core3 === void 0 || (_state$core3 = _state$core3.user) === null || _state$core3 === void 0 || (_state$core3 = _state$core3.i_user) === null || _state$core3 === void 0 ? void 0 : _state$core3.id;
  });
  useEffect(function () {
    // Adjust the fetch action/parameters for rejected applications as needed
    dispatch(fetchSummaryApplications(modulesManager, ['organizationType:"blwf"', 'statusIn:["forward_to_comiitee","forward_to_director","forward_to_dg","approved_by_dg","approved_by_committee"]', 'applicationStatusIn:["rejected_by_committee"]']));
  }, [dispatch, modulesManager]);
  var data = useSelector(function (state) {
    var _state$workforce;
    return (_state$workforce = state.workforce["applicationsSummary"]) !== null && _state$workforce !== void 0 ? _state$workforce : [];
  });
  // Adjust the filter based on your API response
  // const summaryData = data.filter(d => d.status === "rejected" || d.status === "forward_to_comiitee"); 

  var handleChange = function handleChange(panelId) {
    return function (event, isExpanded) {
      setExpanded(isExpanded ? panelId : null);
    };
  };
  return /*#__PURE__*/React.createElement("div", {
    className: classes.accordionPadding
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5",
    gutterBottom: true
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.dashboard"
  })), data.map(function (item, index) {
    return /*#__PURE__*/React.createElement(Accordion, {
      key: index,
      expanded: expanded === item.id,
      onChange: handleChange(item.id),
      className: classes.accordion
    }, /*#__PURE__*/React.createElement(AccordionSummary, {
      className: classes.accordionSummary,
      expandIcon: /*#__PURE__*/React.createElement(ExpandMoreIcon, {
        className: "material-icons"
      })
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "subtitle1",
      style: {
        flex: 1
      }
    }, /*#__PURE__*/React.createElement("strong", null, item.name)), /*#__PURE__*/React.createElement(Typography, {
      variant: "body2",
      style: {
        marginLeft: "auto",
        color: "#015C63"
      }
    }, item.meetingDate, " | ", item.month, " ", item.year)), /*#__PURE__*/React.createElement(AccordionDetails, {
      className: classes.accordionDetails
    }, /*#__PURE__*/React.createElement(Card, {
      style: {
        width: "100%"
      }
    }, /*#__PURE__*/React.createElement(CardContent, null, expanded === item.id && /*#__PURE__*/React.createElement(ApplicationProcessSearcher$1, {
      coloredRow: true,
      summaryId: item.id,
      loggedInUserId: loggedInUserId,
      disableButtons: disableButtons,
      statusInSummary: "rejected_by_committee"
    })))));
  }));
};
var PendingMeetingSheet$1 = function PendingMeetingSheet(_ref4) {
  var _ref4$summaryData = _ref4.summaryData,
    summaryData = _ref4$summaryData === void 0 ? [] : _ref4$summaryData;
  console.log("summary data", summaryData);
  var classes = useStyles$r();
  return /*#__PURE__*/React.createElement(React.Fragment, null, summaryData.map(function (item, index) {
    return /*#__PURE__*/React.createElement(Accordion, {
      key: index,
      defaultExpanded: false,
      className: classes.accordion
    }, /*#__PURE__*/React.createElement(AccordionSummary, {
      className: classes.accordionSummary,
      expandIcon: /*#__PURE__*/React.createElement(ExpandMoreIcon, {
        className: "material-icons"
      })
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "subtitle1",
      style: {
        flex: 1
      }
    }, /*#__PURE__*/React.createElement("strong", null, item.name)), /*#__PURE__*/React.createElement(Typography, {
      variant: "body2",
      color: "textSecondary",
      style: {
        marginLeft: 'auto'
      }
    }, item.meetingDate, " | ", item.month, " ", item.year)), /*#__PURE__*/React.createElement(AccordionDetails, {
      className: classes.AccordionDetails
    }, /*#__PURE__*/React.createElement(Card, {
      style: {
        width: "100%"
      }
    }, /*#__PURE__*/React.createElement(CardContent, null, /*#__PURE__*/React.createElement(ApplicationProcessSearcher$1, {
      summaryId: item.id
    })))));
  }));
};

// ------------------------------------------------------------

var BlwfSectionAdminDashboard = function BlwfSectionAdminDashboard() {
  var classes = useStyles$r();
  var dispatch = useDispatch();
  var modulesManager = useModulesManager();
  var _useState15 = useState("pendingApplications"),
    _useState16 = _slicedToArray(_useState15, 2),
    selectedMenu = _useState16[0],
    setSelectedMenu = _useState16[1]; // Default first menu
  useEffect(function () {
    return dispatch(fetchSummaryApplications(modulesManager, ['organizationType:"blwf"']));
  }, []);
  var data = useSelector(function (state) {
    var _state$workforce2;
    return (_state$workforce2 = state.workforce["applicationsSummary"]) !== null && _state$workforce2 !== void 0 ? _state$workforce2 : [];
  });
  var pendingSummaryData = data.filter(function (d) {
    return d.status !== "approved_by_dg";
  });
  var approvedSummaryData = data.filter(function (d) {
    return d.status === "approved_by_dg" || d.status === "approved_by_minister" || d.status === "approved_by_secretary";
  });
  var sentSummaryData = data.filter(function (d) {
    return d.status === "forward_to_comiitee";
  });
  var renderContent = function renderContent() {
    switch (selectedMenu) {
      case "pendingApplications":
        return /*#__PURE__*/React.createElement(FiledApplications$4, null);
      case "sentForVerificationApplications":
        return /*#__PURE__*/React.createElement(SentForVerificationApplications$1, null);
      case "verifiedApplications":
        return /*#__PURE__*/React.createElement(VerifiedApplications$1, null);
      case "rejectedApplication":
        return !isEisPath() ? /*#__PURE__*/React.createElement(RejectedApplications$1, null) : /*#__PURE__*/React.createElement(RejectApplication$3, null);
      case "revertedApplication":
        return /*#__PURE__*/React.createElement(RevertApplication$1, null);
      case "returnedApplication":
        return /*#__PURE__*/React.createElement(ReturnedApplications$5, null);
      case "pendingMeetingSheet":
        return /*#__PURE__*/React.createElement(PendingMeetingSheet$1, {
          summaryData: pendingSummaryData,
          disableButtons: 1
        });
      case "sentMeetingSheet":
        return /*#__PURE__*/React.createElement(SentMeetingSheet$1, {
          summaryData: sentSummaryData,
          disableButtons: 1
        });
      case "approveMeetingSheet":
        return /*#__PURE__*/React.createElement(ApprovedApplications$2, {
          summaryData: approvedSummaryData,
          disableButtons: 1
        });
      case "applicationStatus":
        return /*#__PURE__*/React.createElement(ApplicationStatus$2, null);
      case "beneficiaryReportSheet":
        return /*#__PURE__*/React.createElement(BeneficiaryReportSheet$2, null);
      default:
        return /*#__PURE__*/React.createElement(FiledApplications$4, null);
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: classes.root
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 2,
    className: classes.root
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 3
  }, /*#__PURE__*/React.createElement(Paper, {
    className: classes.sidebar
  }, /*#__PURE__*/React.createElement(List, null, SidebarMenu$5.map(function (item) {
    return /*#__PURE__*/React.createElement(ListItem, {
      button: true,
      key: item.id,
      selected: selectedMenu === item.id,
      onClick: function onClick() {
        return setSelectedMenu(item.id);
      }
    }, /*#__PURE__*/React.createElement(ListItemIcon, null, item.icon), /*#__PURE__*/React.createElement(ListItemText, {
      primary: item.text
    }));
  })))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 9,
    className: classes.content
  }, renderContent())));
};

var useStyles$q = makeStyles(function (theme) {
  return {
    root: {
      flexGrow: 1,
      padding: theme.spacing(2),
      height: "calc(100vh - 64px)",
      // assuming 64px header/appbar, adjust as needed
      overflow: "visible"
    },
    sidebar: {
      position: "sticky",
      top: 0,
      height: "40vh",
      backgroundColor: theme.palette.background.paper,
      borderRight: "1px solid ".concat(theme.palette.divider),
      overflowY: "auto"
    },
    content: {
      height: "100vh",
      overflowY: "auto",
      padding: theme.spacing(2)
    },
    tableContainer: {
      marginTop: theme.spacing(0)
    },
    tableHeadCell: {
      fontWeight: "bold"
    },
    noData: {
      textAlign: "center",
      padding: theme.spacing(2)
    },
    searchInput: {
      border: "1px solid #ccc",
      borderRadius: 4,
      padding: "4px 8px",
      width: 200
    },
    pagination: {
      display: "flex",
      justifyContent: "flex-end",
      marginTop: theme.spacing(2),
      alignItems: "center"
    },
    tableHeader: {
      backgroundColor: "#B7D4D8"
    },
    accordion: {
      boxShadow: "1px 1px 1px 1px",
      border: "none",
      backgroundColor: "white",
      marginBottom: "12px",
      borderRadius: "6px",
      "&::before": {
        display: "none"
      }
    },
    accordionSummary: {
      padding: "8px 16px",
      backgroundColor: "white",
      borderRadius: "6px",
      "& .MuiTypography-root": {
        color: "#015C63",
        // teal-like tone
        fontWeight: 600
      }
    },
    accordionDetails: {
      backgroundColor: "white",
      padding: "16px",
      borderTop: "1px solid #ddd"
    }
  };
});
var getSidebarMenu = function getSidebarMenu(user_type) {
  var allMenu = [];
  if (user_type === WORKFORCE_USER_TYPE.EIS_DOCTOR) {
    allMenu = [{
      id: "dashboard",
      text: /*#__PURE__*/React.createElement(FormattedMessage, {
        module: "workforce",
        id: "workforce.application.dashboard"
      }),
      icon: /*#__PURE__*/React.createElement(DashboardIcon, null)
    }, {
      id: "pendingMeetingSheet",
      text: /*#__PURE__*/React.createElement(FormattedMessage, {
        module: "workforce",
        id: "workforce.employee.application.pendingMeetingSheet"
      }),
      icon: /*#__PURE__*/React.createElement(HourglassFullTwoToneIcon, null)
    },
    // {
    //   id: "forwardedMeetingSheet",
    //   text: (
    //     <FormattedMessage
    //       module="workforce"
    //       id="workforce.employee.application.forwardedMeetingSheet"
    //     />
    //   ),
    //   icon: <ForwardIcon />,
    // },
    {
      id: "forwardedApplications",
      text: /*#__PURE__*/React.createElement(FormattedMessage, {
        module: "workforce",
        id: "workforce.application.forwarded"
      }),
      icon: /*#__PURE__*/React.createElement(ForwardIcon, null)
    }, {
      id: "returnedApplications",
      text: /*#__PURE__*/React.createElement(FormattedMessage, {
        module: "workforce",
        id: "workforce.application.returned"
      }),
      icon: /*#__PURE__*/React.createElement(ArrowBackIcon, null)
    }];
  } else {
    allMenu = [{
      id: "dashboard",
      text: /*#__PURE__*/React.createElement(FormattedMessage, {
        module: "workforce",
        id: "workforce.application.dashboard"
      }),
      icon: /*#__PURE__*/React.createElement(DashboardIcon, null)
    }, {
      id: "pendingApplications",
      text: /*#__PURE__*/React.createElement(FormattedMessage, {
        module: "workforce",
        id: "workforce.application.pending"
      }),
      icon: /*#__PURE__*/React.createElement(HourglassFullTwoToneIcon, null)
    }, {
      id: "forwardedApplications",
      text: /*#__PURE__*/React.createElement(FormattedMessage, {
        module: "workforce",
        id: "workforce.application.forwarded"
      }),
      icon: /*#__PURE__*/React.createElement(ForwardIcon, null)
    }, {
      id: "revertedApplications",
      text: /*#__PURE__*/React.createElement(FormattedMessage, {
        module: "workforce",
        id: "workforce.application.reverted"
      }),
      icon: /*#__PURE__*/React.createElement(RestorePageIcon, null)
    }, {
      id: "returnedApplications",
      text: /*#__PURE__*/React.createElement(FormattedMessage, {
        module: "workforce",
        id: "workforce.application.returned"
      }),
      icon: /*#__PURE__*/React.createElement(ArrowBackIcon, null)
    }];
  }

  // if (user_type === WORKFORCE_USER_TYPE.EIS_DOCTOR) {
  //   return allMenu.filter((m) => m.id === "pendingMeetingSheet");
  // }

  // if (
  //   user_type === WORKFORCE_USER_TYPE.DOCTOR ||
  //   user_type === WORKFORCE_USER_TYPE.BLWF_DOCTOR
  // ) {
  //   return allMenu.filter((m) => m.id !== "pendingMeetingSheet");
  // }

  return allMenu;
};

// ----------- Components to Render in Main Content -----------

var ForwardedApplications = function ForwardedApplications() {
  var classes = useStyles$q();
  var loggedInUserId = useSelector(function (state) {
    var _state$core;
    return (_state$core = state.core) === null || _state$core === void 0 || (_state$core = _state$core.user) === null || _state$core === void 0 || (_state$core = _state$core.i_user) === null || _state$core === void 0 ? void 0 : _state$core.id;
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ApplicationProcessSearcher$1, {
    forwardedApplications: true,
    loggedInUserId: loggedInUserId,
    disableButtons: 1,
    dynamicTableTitle: "workforce.application.forwarded"
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.pagination
  }, /*#__PURE__*/React.createElement(Button, null, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.back"
  })), /*#__PURE__*/React.createElement(Button, null, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.next"
  }))));
};
var RevertedApplications = function RevertedApplications() {
  var classes = useStyles$q();
  var loggedInUserId = useSelector(function (state) {
    var _state$core2;
    return (_state$core2 = state.core) === null || _state$core2 === void 0 || (_state$core2 = _state$core2.user) === null || _state$core2 === void 0 || (_state$core2 = _state$core2.i_user) === null || _state$core2 === void 0 ? void 0 : _state$core2.id;
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ApplicationProcessSearcher$1, {
    revertedApplications: true,
    loggedInUserId: loggedInUserId,
    disableButtons: 1,
    dynamicTableTitle: "workforce.application.reverted"
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.pagination
  }, /*#__PURE__*/React.createElement(Button, null, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.back"
  })), /*#__PURE__*/React.createElement(Button, null, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.next"
  }))));
};
var ReturnedApplications$4 = function ReturnedApplications() {
  var classes = useStyles$q();
  var loggedInUserId = useSelector(function (state) {
    var _state$core3;
    return (_state$core3 = state.core) === null || _state$core3 === void 0 || (_state$core3 = _state$core3.user) === null || _state$core3 === void 0 || (_state$core3 = _state$core3.i_user) === null || _state$core3 === void 0 ? void 0 : _state$core3.id;
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ApplicationProcessSearcher$1, {
    returnedApplications: true,
    loggedInUserId: loggedInUserId,
    disableButtons: 1,
    dynamicTableTitle: "workforce.application.returned"
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.pagination
  }, /*#__PURE__*/React.createElement(Button, null, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.back"
  })), /*#__PURE__*/React.createElement(Button, null, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.next"
  }))));
};
var DashboardCard$3 = function DashboardCard(_ref) {
  var title = _ref.title,
    children = _ref.children;
  return /*#__PURE__*/React.createElement(Card, {
    style: {
      height: "100%",
      borderRadius: "16px",
      boxShadow: "0 4px 12px 0 rgba(0,0,0,0.05)",
      padding: "10px"
    }
  }, /*#__PURE__*/React.createElement(CardHeader, {
    title: /*#__PURE__*/React.createElement(Typography, {
      variant: "h6",
      style: {
        fontWeight: "bold"
      }
    }, title)
  }), /*#__PURE__*/React.createElement(CardContent, {
    style: {
      paddingTop: 0
    }
  }, children));
};
var StatRow$3 = function StatRow(_ref2) {
  var label = _ref2.label,
    count = _ref2.count,
    color = _ref2.color;
  return /*#__PURE__*/React.createElement(Box$1, {
    display: "flex",
    justifyContent: "space-between",
    py: 1,
    borderBottom: "1px solid #f0f0f0"
  }, /*#__PURE__*/React.createElement(Typography, {
    style: {
      color: color || "inherit"
    }
  }, label), /*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle1",
    style: {
      fontWeight: "bold",
      color: color || "inherit"
    }
  }, count));
};
var Dashboard$4 = function Dashboard() {
  var _reduxState$core;
  var dispatch = useDispatch();
  useTheme();
  var reduxState = useSelector(function (state) {
    return state;
  });
  (reduxState === null || reduxState === void 0 || (_reduxState$core = reduxState.core) === null || _reduxState$core === void 0 || (_reduxState$core = _reduxState$core.user) === null || _reduxState$core === void 0 || (_reduxState$core = _reduxState$core.i_user) === null || _reduxState$core === void 0 ? void 0 : _reduxState$core.language) || "en";

  // --- 1. RETAINED STATE FOR EFFECTS ---
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    months = _useState2[0];
    _useState2[1];
  var _useState3 = useState(""),
    _useState4 = _slicedToArray(_useState3, 2),
    fromDate = _useState4[0];
    _useState4[1];
  var _useState5 = useState(""),
    _useState6 = _slicedToArray(_useState5, 2),
    toDate = _useState6[0];
    _useState6[1];
  var _useState7 = useState("eis"),
    _useState8 = _slicedToArray(_useState7, 2),
    filter = _useState8[0];
    _useState8[1];
  var _useState9 = useState(6),
    _useState10 = _slicedToArray(_useState9, 2),
    graphMonths = _useState10[0];
    _useState10[1];

  // --- 2. NEW ASSESSMENT SPECIFIC STATE ---
  var _useState11 = useState({
      male: 0,
      female: 0
    }),
    _useState12 = _slicedToArray(_useState11, 2),
    previousAssessments = _useState12[0];
    _useState12[1];
  var _useState13 = useState({
      male: 0,
      female: 0
    }),
    _useState14 = _slicedToArray(_useState13, 2),
    ongoingAssessments = _useState14[0];
    _useState14[1];
  var _useState15 = useState({
      gender: {
        male: 0,
        female: 0
      },
      accidentType: {
        commuting: 0,
        workplace: 0,
        rta: 0
      }
    }),
    _useState16 = _slicedToArray(_useState15, 2),
    totalAssessments = _useState16[0];
    _useState16[1];

  // --- 3. RETAINED EFFECTS ---
  useEffect(function () {
    function loadData() {
      return _loadData.apply(this, arguments);
    }
    function _loadData() {
      _loadData = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var orgType;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              orgType = filter === "সব" || filter === "All" ? "" : filter.toLowerCase(); // Retained background fetch logic as requested
              _context.next = 4;
              return dispatch(fetchApplicationByDate(months, fromDate, toDate, orgType));
            case 4:
              _context.next = 9;
              break;
            case 6:
              _context.prev = 6;
              _context.t0 = _context["catch"](0);
              console.error("Failed to fetch data", _context.t0);
            case 9:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[0, 6]]);
      }));
      return _loadData.apply(this, arguments);
    }
    loadData();
  }, [months, fromDate, toDate, filter, dispatch]);
  useEffect(function () {
    function loadMonthWiseData() {
      return _loadMonthWiseData.apply(this, arguments);
    }
    function _loadMonthWiseData() {
      _loadMonthWiseData = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return dispatch(fetchApplicationMonthWise(graphMonths));
            case 3:
              _context2.next = 8;
              break;
            case 5:
              _context2.prev = 5;
              _context2.t0 = _context2["catch"](0);
              console.error("Failed to fetch month wise data", _context2.t0);
            case 8:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[0, 5]]);
      }));
      return _loadMonthWiseData.apply(this, arguments);
    }
    loadMonthWiseData();
  }, [graphMonths, dispatch]);

  // --- 4. NEW ASSESSMENT DATA EFFECT ---
  useEffect(function () {
    function loadAssessmentData() {
      return _loadAssessmentData.apply(this, arguments);
    }
    function _loadAssessmentData() {
      _loadAssessmentData = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      return _loadAssessmentData.apply(this, arguments);
    }
    loadAssessmentData();
  }, [fromDate, toDate]);
  return /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 3,
    style: {
      marginTop: "20px"
    }
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 4
  }, /*#__PURE__*/React.createElement(DashboardCard$3, {
    title: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.dashboard.assessments.previous"
    })
  }, /*#__PURE__*/React.createElement(StatRow$3, {
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.dashboard.assessments.maleCount"
    }),
    count: previousAssessments.male
  }), /*#__PURE__*/React.createElement(StatRow$3, {
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.dashboard.assessments.femaleCount"
    }),
    count: previousAssessments.female
  }))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 4
  }, /*#__PURE__*/React.createElement(DashboardCard$3, {
    title: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.dashboard.assessments.ongoing"
    })
  }, /*#__PURE__*/React.createElement(StatRow$3, {
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.dashboard.assessments.maleCount"
    }),
    count: ongoingAssessments.male,
    color: "#ed6c02"
  }), /*#__PURE__*/React.createElement(StatRow$3, {
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.dashboard.assessments.femaleCount"
    }),
    count: ongoingAssessments.female,
    color: "#ed6c02"
  }))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 4
  }, /*#__PURE__*/React.createElement(DashboardCard$3, {
    title: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.dashboard.assessments.total"
    })
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle2",
    style: {
      color: "#1976d2",
      marginTop: 10
    }
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "workforce.dashboard.assessments.byGender"
  })), /*#__PURE__*/React.createElement(Box$1, {
    pl: 2,
    mb: 2
  }, /*#__PURE__*/React.createElement(StatRow$3, {
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.dashboard.assessments.maleOnly"
    }),
    count: totalAssessments.gender.male
  }), /*#__PURE__*/React.createElement(StatRow$3, {
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.dashboard.assessments.femaleOnly"
    }),
    count: totalAssessments.gender.female
  })), /*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle2",
    style: {
      color: "#d32f2f"
    }
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "workforce.dashboard.assessments.byAccidentType"
  })), /*#__PURE__*/React.createElement(Box$1, {
    pl: 2
  }, /*#__PURE__*/React.createElement(StatRow$3, {
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.dashboard.assessments.commuting"
    }),
    count: totalAssessments.accidentType.commuting
  }), /*#__PURE__*/React.createElement(StatRow$3, {
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.dashboard.assessments.workplace"
    }),
    count: totalAssessments.accidentType.workplace
  }), /*#__PURE__*/React.createElement(StatRow$3, {
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.dashboard.assessments.rta"
    }),
    count: totalAssessments.accidentType.rta
  })))));
};
var MeetingSheet = function MeetingSheet(_ref3) {
  var _ref3$summaryData = _ref3.summaryData,
    summaryData = _ref3$summaryData === void 0 ? [] : _ref3$summaryData;
    _ref3.disableButtons;
  var classes = useStyles$q();
  var _useState17 = useState(null),
    _useState18 = _slicedToArray(_useState17, 2),
    expanded = _useState18[0],
    setExpanded = _useState18[1];
  var loggedInUserId = useSelector(function (state) {
    var _state$core5;
    return (_state$core5 = state.core) === null || _state$core5 === void 0 || (_state$core5 = _state$core5.user) === null || _state$core5 === void 0 || (_state$core5 = _state$core5.i_user) === null || _state$core5 === void 0 ? void 0 : _state$core5.id;
  });
  console.log(loggedInUserId);
  var handleChange = function handleChange(panelId) {
    return function (event, isExpanded) {
      setExpanded(isExpanded ? panelId : null);
    };
  };
  return /*#__PURE__*/React.createElement("div", {
    className: classes.accordionPadding
  }, summaryData.map(function (item, index) {
    var parsedUserIds = JSON.parse(item === null || item === void 0 ? void 0 : item.userIds);
    console.log({
      item: item
    });
    var isLoggedInUserValid = parsedUserIds === null || parsedUserIds === void 0 ? void 0 : parsedUserIds.includes(loggedInUserId);
    console.log({
      isLoggedInUserValid: isLoggedInUserValid
    });
    if (!isLoggedInUserValid) {
      return;
    }
    return /*#__PURE__*/React.createElement(Accordion, {
      key: index,
      expanded: expanded === item.id,
      onChange: handleChange(item.id),
      className: classes.accordion
    }, /*#__PURE__*/React.createElement(AccordionSummary, {
      className: classes.accordionSummary,
      expandIcon: /*#__PURE__*/React.createElement(ExpandMoreIcon, {
        className: "material-icons"
      })
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "subtitle1",
      style: {
        flex: 1
      }
    }, /*#__PURE__*/React.createElement("strong", null, item.name)), /*#__PURE__*/React.createElement(Typography, {
      variant: "body2",
      style: {
        marginLeft: "auto",
        color: "#015C63"
      }
    }, item.meetingDate, " | ", item.month, " ", item.year)), /*#__PURE__*/React.createElement(AccordionDetails, {
      className: classes.accordionDetails
    }, /*#__PURE__*/React.createElement(Card, {
      style: {
        width: "100%"
      }
    }, /*#__PURE__*/React.createElement(CardContent, null, expanded === item.id && /*#__PURE__*/React.createElement(ApplicationProcessSearcher$1, {
      summaryId: item.id,
      loggedInUserId: loggedInUserId,
      filedMeetingSheet: true
      // disableButtons={disableButtons}
    })))));
  }));
};

// ------------------------------------------------------------

var DoctorDashboard = function DoctorDashboard() {
  var classes = useStyles$q();
  var dispatch = useDispatch();
  var modulesManager = useModulesManager();
  var user_type = getUserType();
  var SidebarMenu = useMemo(function () {
    return getSidebarMenu(user_type);
  }, [user_type]);
  var _useState19 = useState(user_type === WORKFORCE_USER_TYPE.EIS_DOCTOR ? "dashboard" : "dashboard"),
    _useState20 = _slicedToArray(_useState19, 2),
    selectedMenu = _useState20[0],
    setSelectedMenu = _useState20[1];
  var organizationType = isEisPath() ? "eis" : !isEisPath() && !isBlwfPath() ? "cf" : "blwf";
  useEffect(function () {
    return dispatch(fetchSummaryApplications(modulesManager, ["organizationType:\"".concat(organizationType, "\"")]));
  }, []);
  var data = useSelector(function (state) {
    var _state$workforce;
    return (_state$workforce = state.workforce["applicationsSummary"]) !== null && _state$workforce !== void 0 ? _state$workforce : [];
  });
  var pendingSummaryData = data.filter(function (d) {
    return d.status === "forward_to_doctor" && organizationType;
  });
  data.filter(function (d) {
    return d.status === "approved_by_doctor" && organizationType;
  });
  console.log({
    faltuData: pendingSummaryData
  });
  var renderContent = function renderContent() {
    var user_type = getUserType();
    if (user_type === WORKFORCE_USER_TYPE.EIS_DOCTOR) {
      switch (selectedMenu) {
        case "dashboard":
          return /*#__PURE__*/React.createElement(Dashboard$4, null);
        case "pendingMeetingSheet":
          return /*#__PURE__*/React.createElement(MeetingSheet, {
            summaryData: pendingSummaryData,
            disableButtons: 1
          });
        case "forwardedApplications":
          return /*#__PURE__*/React.createElement(ForwardedApplications, null);
        case "returnedApplications":
          return /*#__PURE__*/React.createElement(ReturnedApplications$4, null);
        default:
          return /*#__PURE__*/React.createElement(Dashboard$4, null);
      }
    } else {
      switch (selectedMenu) {
        case "dashboard":
          return /*#__PURE__*/React.createElement(Dashboard$4, null);
        case "pendingApplications":
          // return <FiledApplications />;
          return /*#__PURE__*/React.createElement(MeetingSheet, {
            summaryData: pendingSummaryData,
            disableButtons: 1
          });
        case "forwardedApplications":
          return /*#__PURE__*/React.createElement(ForwardedApplications, null);
        case "revertedApplications":
          return /*#__PURE__*/React.createElement(RevertedApplications, null);
        case "returnedApplications":
          return /*#__PURE__*/React.createElement(ReturnedApplications$4, null);
        default:
          return /*#__PURE__*/React.createElement(Dashboard$4, null);
      }
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: classes.root
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 2,
    className: classes.root
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 3
  }, /*#__PURE__*/React.createElement(Paper, {
    className: classes.sidebar
  }, /*#__PURE__*/React.createElement(List, null, SidebarMenu.map(function (item) {
    return /*#__PURE__*/React.createElement(ListItem, {
      button: true,
      key: item.id,
      selected: selectedMenu === item.id,
      onClick: function onClick() {
        return setSelectedMenu(item.id);
      }
    }, /*#__PURE__*/React.createElement(ListItemIcon, null, item.icon), /*#__PURE__*/React.createElement(ListItemText, {
      primary: item.text
    }));
  })))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 9,
    className: classes.content
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5",
    gutterBottom: true
  }, user_type === WORKFORCE_USER_TYPE.DOCTOR && /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.section.cf.doctor.dashboard"
  }), user_type === WORKFORCE_USER_TYPE.BLWF_DOCTOR && /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.section.blwf.doctor.dashboard"
  }), user_type === WORKFORCE_USER_TYPE.EIS_DOCTOR && /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.section.eis.doctor.dashboard"
  })), renderContent())));
};

var useStyles$p = makeStyles(function (theme) {
  return {
    root: {
      flexGrow: 1,
      padding: theme.spacing(2),
      height: "calc(100vh - 64px)",
      // assuming 64px header/appbar, adjust as needed
      overflow: "visible"
    },
    sidebar: {
      position: "sticky",
      top: 0,
      height: "40vh",
      backgroundColor: theme.palette.background.paper,
      borderRight: "1px solid ".concat(theme.palette.divider),
      overflowY: "auto"
    },
    content: {
      height: "100vh",
      overflowY: "auto",
      padding: theme.spacing(2)
    },
    tableContainer: {
      marginTop: theme.spacing(0)
    },
    tableHeadCell: {
      fontWeight: "bold"
    },
    noData: {
      textAlign: "center",
      padding: theme.spacing(2)
    },
    searchInput: {
      border: "1px solid #ccc",
      borderRadius: 4,
      padding: "4px 8px",
      width: 200
    },
    pagination: {
      display: "flex",
      justifyContent: "flex-end",
      marginTop: theme.spacing(2),
      alignItems: "center"
    },
    tableHeader: {
      backgroundColor: "#B7D4D8"
    },
    accordion: {
      boxShadow: "1px 1px 1px 1px",
      border: "none",
      backgroundColor: "white",
      marginBottom: "12px",
      borderRadius: "6px",
      "&::before": {
        display: "none"
      }
    },
    accordionPadding: {
      paddingBottom: "40px !important"
    },
    accordionSummary: {
      padding: "8px 16px",
      backgroundColor: "white",
      borderRadius: "6px",
      "& .MuiTypography-root": {
        color: "#015C63",
        // teal-like tone
        fontWeight: 600
      }
    },
    accordionDetails: {
      backgroundColor: "white",
      padding: "16px",
      borderTop: "1px solid #ddd"
    }
  };
});
var SidebarMenu$4 = [{
  id: "pendingMeetingSheet",
  text: /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.employee.application.meetingSheet"
  }),
  icon: /*#__PURE__*/React.createElement(HourglassFullTwoToneIcon, null)
}, {
  id: "approveMeetingSheet",
  text: /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.application.forwarded"
  }),
  icon: /*#__PURE__*/React.createElement(CheckCircleOutlineTwoToneIcon, null)
}, {
  id: "returnedApplications",
  text: /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.application.returned"
  }),
  icon: /*#__PURE__*/React.createElement(ArrowBackIcon, null)
}, {
  id: "rejectedApplications",
  text: /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.application.rejected"
  }),
  // Add appropriate i18n id
  icon: /*#__PURE__*/React.createElement(CancelTwoToneIcon, null)
}];

// ----------- Components to Render in Main Content -----------

var ReturnedApplications$3 = function ReturnedApplications() {
  var classes = useStyles$p();
  var loggedInUserId = useSelector(function (state) {
    var _state$core;
    return (_state$core = state.core) === null || _state$core === void 0 || (_state$core = _state$core.user) === null || _state$core === void 0 || (_state$core = _state$core.i_user) === null || _state$core === void 0 ? void 0 : _state$core.id;
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ApplicationProcessSearcher$1, {
    returnedApplications: true,
    loggedInUserId: loggedInUserId,
    disableButtons: 1,
    dynamicTableTitle: "workforce.application.returned"
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.pagination
  }, /*#__PURE__*/React.createElement(Button, null, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.back"
  })), /*#__PURE__*/React.createElement(Button, null, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.next"
  }))));
};
var FiledApplications$3 = function FiledApplications(_ref) {
  var _ref$summaryData = _ref.summaryData,
    summaryData = _ref$summaryData === void 0 ? [] : _ref$summaryData,
    _ref$disableButtons = _ref.disableButtons,
    disableButtons = _ref$disableButtons === void 0 ? 0 : _ref$disableButtons;
    _ref.rejectedByCommittee;
  var classes = useStyles$p();
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    expanded = _useState2[0],
    setExpanded = _useState2[1];
  var loggedInUserId = useSelector(function (state) {
    var _state$core2;
    return (_state$core2 = state.core) === null || _state$core2 === void 0 || (_state$core2 = _state$core2.user) === null || _state$core2 === void 0 || (_state$core2 = _state$core2.i_user) === null || _state$core2 === void 0 ? void 0 : _state$core2.id;
  });
  var handleChange = function handleChange(panelId) {
    return function (event, isExpanded) {
      setExpanded(isExpanded ? panelId : null);
    };
  };
  console.log("summary data", summaryData);
  return /*#__PURE__*/React.createElement("div", {
    className: classes.accordionPadding
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5",
    gutterBottom: true
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.dashboard"
  })), summaryData.map(function (item, index) {
    return /*#__PURE__*/React.createElement(Accordion, {
      key: index,
      expanded: expanded === item.id,
      onChange: handleChange(item.id),
      className: classes.accordion
    }, /*#__PURE__*/React.createElement(AccordionSummary, {
      className: classes.accordionSummary,
      expandIcon: /*#__PURE__*/React.createElement(ExpandMoreIcon, {
        className: "material-icons"
      })
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "subtitle1",
      style: {
        flex: 1
      }
    }, /*#__PURE__*/React.createElement("strong", null, item.name)), /*#__PURE__*/React.createElement(Typography, {
      variant: "body2",
      style: {
        marginLeft: "auto",
        color: "#015C63"
      }
    }, item.meetingDate, " | ", item.month, " ", item.year)), /*#__PURE__*/React.createElement(AccordionDetails, {
      className: classes.accordionDetails
    }, /*#__PURE__*/React.createElement(Card, {
      style: {
        width: "100%"
      }
    }, /*#__PURE__*/React.createElement(CardContent, null, expanded === item.id && /*#__PURE__*/React.createElement(ApplicationProcessSearcher$1, {
      coloredRow: true,
      summaryId: item.id,
      loggedInUserId: loggedInUserId,
      disableButtons: disableButtons
    })))));
  }));
};

// 1. Create the new RejectedApplications component
var RejectedApplications = function RejectedApplications(_ref2) {
  var _ref2$disableButtons = _ref2.disableButtons,
    disableButtons = _ref2$disableButtons === void 0 ? 0 : _ref2$disableButtons;
  var classes = useStyles$p();
  var dispatch = useDispatch();
  var modulesManager = useModulesManager();
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    expanded = _useState4[0],
    setExpanded = _useState4[1];
  var loggedInUserId = useSelector(function (state) {
    var _state$core3;
    return (_state$core3 = state.core) === null || _state$core3 === void 0 || (_state$core3 = _state$core3.user) === null || _state$core3 === void 0 || (_state$core3 = _state$core3.i_user) === null || _state$core3 === void 0 ? void 0 : _state$core3.id;
  });
  useEffect(function () {
    // Adjust the fetch action/parameters for rejected applications as needed
    dispatch(fetchSummaryApplications(modulesManager, ['organizationType:"blwf"', 'status:"forward_to_comiitee"', 'applicationStatusIn:["rejected_by_committee"]']));
  }, [dispatch, modulesManager]);
  var data = useSelector(function (state) {
    var _state$workforce;
    return (_state$workforce = state.workforce["applicationsSummary"]) !== null && _state$workforce !== void 0 ? _state$workforce : [];
  });
  var handleChange = function handleChange(panelId) {
    return function (event, isExpanded) {
      setExpanded(isExpanded ? panelId : null);
    };
  };
  return /*#__PURE__*/React.createElement("div", {
    className: classes.accordionPadding
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5",
    gutterBottom: true
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.dashboard"
  })), data.map(function (item, index) {
    return /*#__PURE__*/React.createElement(Accordion, {
      key: index,
      expanded: expanded === item.id,
      onChange: handleChange(item.id),
      className: classes.accordion
    }, /*#__PURE__*/React.createElement(AccordionSummary, {
      className: classes.accordionSummary,
      expandIcon: /*#__PURE__*/React.createElement(ExpandMoreIcon, {
        className: "material-icons"
      })
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "subtitle1",
      style: {
        flex: 1
      }
    }, /*#__PURE__*/React.createElement("strong", null, item.name)), /*#__PURE__*/React.createElement(Typography, {
      variant: "body2",
      style: {
        marginLeft: "auto",
        color: "#015C63"
      }
    }, item.meetingDate, " | ", item.month, " ", item.year)), /*#__PURE__*/React.createElement(AccordionDetails, {
      className: classes.accordionDetails
    }, /*#__PURE__*/React.createElement(Card, {
      style: {
        width: "100%"
      }
    }, /*#__PURE__*/React.createElement(CardContent, null, expanded === item.id && /*#__PURE__*/React.createElement(ApplicationProcessSearcher$1, {
      coloredRow: true,
      summaryId: item.id,
      loggedInUserId: loggedInUserId,
      disableButtons: disableButtons,
      statusInSummary: "rejected_by_committee"
    })))));
  }));
};

// ------------------------------------------------------------

var BlwfApproverDashboard = function BlwfApproverDashboard() {
  var classes = useStyles$p();
  var dispatch = useDispatch();
  var modulesManager = useModulesManager();
  var _useState5 = useState("pendingMeetingSheet"),
    _useState6 = _slicedToArray(_useState5, 2),
    selectedMenu = _useState6[0],
    setSelectedMenu = _useState6[1];
  useEffect(function () {
    return dispatch(fetchSummaryApplications(modulesManager, ['organizationType:"blwf"']));
  }, []);
  var data = useSelector(function (state) {
    var _state$workforce2;
    return (_state$workforce2 = state.workforce["applicationsSummary"]) !== null && _state$workforce2 !== void 0 ? _state$workforce2 : [];
  });
  var pendingSummaryData = data.filter(function (d) {
    return d.status === "forward_to_comiitee";
  });
  var sentSummaryData = data.filter(function (d) {
    return d.status === "forward_to_dg" || d.status === 'forward_to_director';
  });
  data.filter(function (d) {
    return d.status === "forward_to_comiitee";
  });
  var renderContent = function renderContent() {
    switch (selectedMenu) {
      case "pendingMeetingSheet":
        return /*#__PURE__*/React.createElement(FiledApplications$3, {
          summaryData: pendingSummaryData
        });
      case "approveMeetingSheet":
        return /*#__PURE__*/React.createElement(FiledApplications$3, {
          summaryData: sentSummaryData,
          disableButtons: 1
        });
      case "returnedApplications":
        return /*#__PURE__*/React.createElement(ReturnedApplications$3, null);
      case "rejectedApplications":
        return /*#__PURE__*/React.createElement(RejectedApplications, null);
      default:
        return /*#__PURE__*/React.createElement(FiledApplications$3, null);
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: classes.root
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 2,
    className: classes.root
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 3
  }, /*#__PURE__*/React.createElement(Paper, {
    className: classes.sidebar
  }, /*#__PURE__*/React.createElement(List, null, SidebarMenu$4.map(function (item) {
    return /*#__PURE__*/React.createElement(ListItem, {
      button: true,
      key: item.id,
      selected: selectedMenu === item.id,
      onClick: function onClick() {
        return setSelectedMenu(item.id);
      }
    }, /*#__PURE__*/React.createElement(ListItemIcon, null, item.icon), /*#__PURE__*/React.createElement(ListItemText, {
      primary: item.text
    }));
  })))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 9,
    className: classes.content
  }, renderContent())));
};

function ownKeys$u(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$u(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$u(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$u(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var INITIAL_STATE$1 = {
  reason: "",
  remarriageOrDeathDate: null,
  status: "",
  remarks: "",
  // Main Beneficiary Adjustments
  incrementAmount: "",
  incrementDate: null,
  decrementAmount: "",
  decrementDate: null,
  // Other Beneficiaries Adjustments (Nested Object)
  adjustments: {}
};
var PHOTO_TYPES = ["nominee's photo", "nominee photo", "employee photo", "workers photo", "photo of worker"];
var BeneficiaryManageModal = function BeneficiaryManageModal(_ref) {
  var _beneficiary$workforc, _beneficiary$workforc4, _beneficiary$workforc5, _safeParse, _beneficiary$workforc6, _beneficiary$workforc7, _beneficiary$workforc8, _beneficiary$workforc9, _beneficiary$workforc10, _beneficiary$remarks, _Number$toLocaleStrin, _Number$toLocaleStrin2, _beneficiary$incremen, _beneficiary$decremen;
  var open = _ref.open,
    onClose = _ref.onClose,
    onSuccess = _ref.onSuccess,
    beneficiaryId = _ref.beneficiaryId;
  var _useState = useState({}),
    _useState2 = _slicedToArray(_useState, 2),
    beneficiary = _useState2[0],
    setBeneficiary = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    loader = _useState4[0],
    setLoader = _useState4[1];
  var dispatch = useDispatch();
  var modulesManager = useModulesManager();
  var dep = beneficiary === null || beneficiary === void 0 || (_beneficiary$workforc = beneficiary.workforceEmployeeDependent) === null || _beneficiary$workforc === void 0 ? void 0 : _beneficiary$workforc[0];

  // 1. Single State Variable for all form data
  var _useState5 = useState(INITIAL_STATE$1),
    _useState6 = _slicedToArray(_useState5, 2),
    formData = _useState6[0],
    setFormData = _useState6[1];

  // API Data state (kept separate from form state as per best practice)
  var _useState7 = useState([]),
    _useState8 = _slicedToArray(_useState7, 2),
    otherBeneficiaries = _useState8[0],
    setOtherBeneficiaries = _useState8[1];

  /* -------------------- DERIVED STATE (Calculated on render) -------------------- */
  // Instead of storing these in state, we calculate them based on the current 'reason'.
  // This prevents state desync issues.
  formData.reason === "remarried" || formData.reason === "died";
  var statusSelectable = formData.reason === "live_check_denial";
  var dateFieldLabel = "";
  if (formData.reason === "remarried") dateFieldLabel = "Date of Remarriage";else if (formData.reason === "died") dateFieldLabel = "Date of Death";else if (formData.reason === "live_check_denial") dateFieldLabel = "Date of Hold/Closure";

  /* -------------------- HANDLERS -------------------- */

  // Helper for updating flat fields
  var handleChange = function handleChange(field, value) {
    setFormData(function (prev) {
      return _objectSpread$u(_objectSpread$u({}, prev), {}, _defineProperty({}, field, value));
    });
  };
  useEffect(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var _processRes$payload, _yield$Promise$all, _yield$Promise$all2, processRes;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          if (!open) {
            _context.next = 9;
            break;
          }
          setLoader(true);
          _context.next = 4;
          return Promise.all([dispatch(fetchEisPaymentProcessWithFilters({
            processId: "".concat(safeDecodeId(beneficiaryId)),
            workforceApplicationTrackingNumber: "",
            workforceFactoryId: "",
            allAssociationId: "",
            beneficiaryId: "",
            status: "active",
            approved: "yes",
            approvalDateFrom: "",
            approvalDateTo: "",
            accidentDateFrom: "",
            accidentDateTo: ""
          }, modulesManager))]);
        case 4:
          _yield$Promise$all = _context.sent;
          _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 1);
          processRes = _yield$Promise$all2[0];
          setBeneficiary((processRes === null || processRes === void 0 || (_processRes$payload = processRes.payload) === null || _processRes$payload === void 0 || (_processRes$payload = _processRes$payload.data) === null || _processRes$payload === void 0 || (_processRes$payload = _processRes$payload.workforceEisPaymentProcess) === null || _processRes$payload === void 0 ? void 0 : _processRes$payload[0]) || {});
          setLoader(false);
        case 9:
        case "end":
          return _context.stop();
      }
    }, _callee);
  })), [beneficiaryId, modulesManager, dispatch]);
  useEffect(function () {
    var _beneficiary$benefici;
    dispatch(fetchWorkforceEisLastPaymentDate({
      beneficiaryId: (_beneficiary$benefici = beneficiary === null || beneficiary === void 0 ? void 0 : beneficiary.beneficiaryId) !== null && _beneficiary$benefici !== void 0 ? _beneficiary$benefici : ""
    })).then(function (res) {
      var data = res.payload.data.workforceEisLastPaymentDate;
      var responseMonth = data === null || data === void 0 ? void 0 : data.monthIndex;
      var responseYear = data === null || data === void 0 ? void 0 : data.year;
      if (data) {
        var lastPaymentDate = new Date(responseYear, responseMonth, 0);
        console.log("Last Payment Date:", lastPaymentDate);
        formData.remarriageOrDeathDate !== null ? new Date(formData.remarriageOrDeathDate) : null;
        // if (selectedDate !== null && selectedDate < lastPaymentDate) {
        //   alert(`Selected date (${selectedDate.toLocaleDateString("en-BD")}) cannot be earlier than the last payment month (${formatter.format(lastPaymentDate)}).`);
        //   setFormData((prev) => ({
        //     ...prev,
        //     remarriageOrDeathDate: null,
        //   }));
        // }
      }
    });
  }, [formData.remarriageOrDeathDate]);

  // Helper for updating nested adjustments for other beneficiaries
  var updateAdjustment = function updateAdjustment(beneficiaryId, field, value) {
    setFormData(function (prev) {
      var numericValue = Number(value) || 0;
      var maxAllowed = Number(beneficiary === null || beneficiary === void 0 ? void 0 : beneficiary.payableAmount) || 0;

      // Create a copy of adjustments with updated value
      var updatedAdjustments = _objectSpread$u(_objectSpread$u({}, prev.adjustments), {}, _defineProperty({}, beneficiaryId, _objectSpread$u(_objectSpread$u({}, prev.adjustments[beneficiaryId]), {}, _defineProperty({}, field, numericValue))));

      // Only validate for incrementAmount fields
      if (field === "incrementAmount") {
        // Calculate total of all incrementAmount fields
        var totalIncrement = Object.values(updatedAdjustments).reduce(function (sum, adj) {
          return sum + (Number(adj === null || adj === void 0 ? void 0 : adj.incrementAmount) || 0);
        }, 0);
        if (totalIncrement > maxAllowed) {
          alert("Total increment amount (".concat(totalIncrement.toLocaleString("en-BD"), ") \n                     cannot exceed payable amount (").concat(maxAllowed.toLocaleString("en-BD"), ")"));

          // Revert only current field to 0
          updatedAdjustments[beneficiaryId].incrementAmount = 0;
        }
      }
      return _objectSpread$u(_objectSpread$u({}, prev), {}, {
        adjustments: updatedAdjustments
      });
    });
  };
  /* -------------------- RESET ON OPEN -------------------- */
  useEffect(function () {
    if (open) {
      setFormData(INITIAL_STATE$1);
      setOtherBeneficiaries([]);
    }
  }, [open]);

  /* -------------------- REASON CHANGE -------------------- */
  var handleReasonChange = function handleReasonChange(e) {
    var value = e.target.value;
    var newStatus = "";

    // Determine status based on reason logic
    if (value === "remarried" || value === "died") {
      newStatus = "closed";
    } else if (value === "live_check_denial") {
      newStatus = ""; // User must select
    }

    // Update State
    setFormData(function (prev) {
      return _objectSpread$u(_objectSpread$u({}, prev), {}, {
        reason: value,
        status: newStatus
      });
    });

    // Fetch Logic
    if (value === "remarried" || value === "died" || formData.status === "closed") {
      var _safeDecodeId;
      dispatch(fetchEisPaymentProcessWithFilters({
        workforceApplicationId: (_safeDecodeId = safeDecodeId(beneficiary === null || beneficiary === void 0 ? void 0 : beneficiary.workforceApplication.id)) !== null && _safeDecodeId !== void 0 ? _safeDecodeId : "",
        status: "active"
      }, modulesManager)).then(function (res) {
        var data = res.payload.data.workforceEisPaymentProcess;
        var eligibleOthers = data.filter(function (b) {
          return b.beneficiaryStatus === "eligible" && b.beneficiaryId !== beneficiary.beneficiaryId;
        });
        setOtherBeneficiaries(eligibleOthers);
      });
    }
  };

  /*---------------------SEND SMS---------------*/
  var handleSendSms = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var _beneficiary$workforc2, _beneficiary$workforc3, _targetDoc, appType, docs, targetDoc, docId, link, name, message;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            console.log("hello");
            appType = beneficiary === null || beneficiary === void 0 || (_beneficiary$workforc2 = beneficiary.workforceApplication) === null || _beneficiary$workforc2 === void 0 ? void 0 : _beneficiary$workforc2.applicationType;
            docs = parseData(beneficiary === null || beneficiary === void 0 || (_beneficiary$workforc3 = beneficiary.workforceApplication) === null || _beneficiary$workforc3 === void 0 ? void 0 : _beneficiary$workforc3.workforceDocumentApplication) || [];
            console.log("handle send sms", appType);
            console.log("handle send sms", docs);
            targetDoc = null;
            if (appType === "financialAssistance") {
              targetDoc = docs.find(function (d) {
                var _d$workforceDependent;
                return PHOTO_TYPES.includes(d.documentType) && ((_d$workforceDependent = d.workforceDependent) === null || _d$workforceDependent === void 0 ? void 0 : _d$workforceDependent.id) === (dep === null || dep === void 0 ? void 0 : dep.id);
              } // Adjust dependent ID field based on your schema
              );
            } else if (appType === "disabilityAssistance") {
              targetDoc = docs.find(function (d) {
                return PHOTO_TYPES.includes(d.documentType);
              });
            }
            if ((_targetDoc = targetDoc) !== null && _targetDoc !== void 0 && _targetDoc.id) {
              _context2.next = 10;
              break;
            }
            return _context2.abrupt("return", alert("No matching photo document found."));
          case 10:
            docId = safeDecodeId(targetDoc.id);
            link = "".concat(window.location.origin, "/front/biometric/verify/").concat(docId);
            name = (dep === null || dep === void 0 ? void 0 : dep.nameBn) || (dep === null || dep === void 0 ? void 0 : dep.nameEn) || "Beneficiary";
            message = "Hi, ".concat(name, ", Please verify your identity at ").concat(link);
            console.log({
              targetDoc: targetDoc
            });
            console.log({
              message: message
            });
            // Ensure sendSmsNotification is imported at the top
            // await dispatch(sendSmsNotification("01537457083", message));
            _context2.next = 18;
            return dispatch(sendSmsNotification(beneficiary === null || beneficiary === void 0 ? void 0 : beneficiary.phoneNumber, message));
          case 18:
            alert("Message Sent!");
            _context2.next = 25;
            break;
          case 21:
            _context2.prev = 21;
            _context2.t0 = _context2["catch"](0);
            console.error(_context2.t0);
            alert("Failed to send SMS");
          case 25:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[0, 21]]);
    }));
    return function handleSendSms() {
      return _ref3.apply(this, arguments);
    };
  }();
  console.log({
    beneficiary: beneficiary
  });
  /* -------------------- SAVE -------------------- */
  var handleSave = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      var payload;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            // You can now access all data from 'formData'
            console.log("Submitting Complete Form Data:", formData);
            if (!(formData.incrementAmount > 0 || formData.decrementAmount > 0 || formData.reason && formData.status)) {
              _context3.next = 10;
              break;
            }
            if (!(formData.reason === "live_check_denial" && formData.status === "hold")) {
              _context3.next = 5;
              break;
            }
            _context3.next = 5;
            return handleSendSms();
          case 5:
            payload = {
              beneficiaryId: beneficiary.beneficiaryId || null,
              reason: formData.reason || null,
              beneficiaryStatus: formData.status || null,
              remarks: formData.remarks || null,
              remarriageOrDeathDate: formData.remarriageOrDeathDate || null,
              incrementAmount: formData.incrementAmount || null,
              incrementDate: formData.incrementDate || null,
              decrementAmount: formData.decrementAmount || null,
              decrementDate: formData.decrementDate || null,
              otherBeneficiaryData: JSON.stringify(formData.adjustments)
              // Include other fields if your API needs them
            };
            console.log("Payload to submit:", payload);
            dispatch(updateWorkforceEisBeneficiary(payload)).then(function () {
              onSuccess();
            });
            _context3.next = 11;
            break;
          case 10:
            return _context3.abrupt("return", alert("Please provide at least one change (Increment/Decrement/Status Change) to save."));
          case 11:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return function handleSave() {
      return _ref4.apply(this, arguments);
    };
  }();
  console.log({
    formData: formData
  });
  var worker = (beneficiary === null || beneficiary === void 0 || (_beneficiary$workforc4 = beneficiary.workforceApplication) === null || _beneficiary$workforc4 === void 0 ? void 0 : _beneficiary$workforc4.applicationType) === "financialAssistance" || (beneficiary === null || beneficiary === void 0 || (_beneficiary$workforc5 = beneficiary.workforceApplication) === null || _beneficiary$workforc5 === void 0 ? void 0 : _beneficiary$workforc5.applicationType) === "deadlyGrant" ? (_safeParse = safeParse(beneficiary === null || beneficiary === void 0 || (_beneficiary$workforc6 = beneficiary.workforceApplication) === null || _beneficiary$workforc6 === void 0 ? void 0 : _beneficiary$workforc6.deceasedWorkerInfo)) === null || _safeParse === void 0 ? void 0 : _safeParse.nameBn : beneficiary === null || beneficiary === void 0 || (_beneficiary$workforc7 = beneficiary.workforceApplication) === null || _beneficiary$workforc7 === void 0 || (_beneficiary$workforc7 = _beneficiary$workforc7.workforceEmployee) === null || _beneficiary$workforc7 === void 0 ? void 0 : _beneficiary$workforc7.firstNameBn;

  /* -------------------- RENDER -------------------- */
  if (!beneficiary) return null;
  return /*#__PURE__*/React.createElement(React.Fragment, null, loader ? /*#__PURE__*/React.createElement(Box$1, {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "200px"
  }, /*#__PURE__*/React.createElement(CircularProgress$1, null)) : /*#__PURE__*/React.createElement(Dialog$1, {
    open: open,
    onClose: onClose,
    maxWidth: "lg",
    fullWidth: true
  }, /*#__PURE__*/React.createElement(DialogTitle, null, "Manage Beneficiary"), /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement(DialogContent$1, null, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 2
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    md: 3
  }, /*#__PURE__*/React.createElement(Box$1, {
    mb: 2
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle2"
  }, /*#__PURE__*/React.createElement("strong", null, "Beneficiary ID")), /*#__PURE__*/React.createElement(Typography, null, beneficiary.beneficiaryId))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    md: 3
  }, /*#__PURE__*/React.createElement(Box$1, {
    mb: 2
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle2"
  }, /*#__PURE__*/React.createElement("strong", null, "Name")), /*#__PURE__*/React.createElement(Typography, null, (dep === null || dep === void 0 ? void 0 : dep.nameBn) || (dep === null || dep === void 0 ? void 0 : dep.nameEn) || "N/A"))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    md: 3
  }, /*#__PURE__*/React.createElement(Box$1, {
    mb: 2
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle2"
  }, /*#__PURE__*/React.createElement("strong", null, "Worker's Detail")), /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    style: {
      fontWeight: 500
    }
  }, worker), /*#__PURE__*/React.createElement(Typography, {
    variant: "caption",
    display: "block",
    color: "textSecondary"
  }, beneficiary === null || beneficiary === void 0 || (_beneficiary$workforc8 = beneficiary.workforceApplication) === null || _beneficiary$workforc8 === void 0 || (_beneficiary$workforc8 = _beneficiary$workforc8.employeeFactory) === null || _beneficiary$workforc8 === void 0 ? void 0 : _beneficiary$workforc8.nameBn), /*#__PURE__*/React.createElement(Typography, {
    variant: "caption",
    display: "block",
    color: "textSecondary"
  }, (beneficiary === null || beneficiary === void 0 || (_beneficiary$workforc9 = beneficiary.workforceApplication) === null || _beneficiary$workforc9 === void 0 || (_beneficiary$workforc9 = _beneficiary$workforc9.employeeFactory) === null || _beneficiary$workforc9 === void 0 || (_beneficiary$workforc9 = _beneficiary$workforc9.allAssociation) === null || _beneficiary$workforc9 === void 0 ? void 0 : _beneficiary$workforc9.shortNameBn) || (beneficiary === null || beneficiary === void 0 || (_beneficiary$workforc10 = beneficiary.workforceApplication) === null || _beneficiary$workforc10 === void 0 || (_beneficiary$workforc10 = _beneficiary$workforc10.employeeFactory) === null || _beneficiary$workforc10 === void 0 || (_beneficiary$workforc10 = _beneficiary$workforc10.allAssociation) === null || _beneficiary$workforc10 === void 0 ? void 0 : _beneficiary$workforc10.nameEn) || "N/A"))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    md: 3
  }, /*#__PURE__*/React.createElement(Box$1, {
    mb: 2
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle2"
  }, /*#__PURE__*/React.createElement("strong", null, "Current Status")), /*#__PURE__*/React.createElement(Chip, {
    label: beneficiary.beneficiaryStatus,
    size: "small",
    color: "primary"
  }), beneficiary.remarriageOrDeathDate && /*#__PURE__*/React.createElement(Typography, {
    variant: "caption",
    display: "block",
    color: "textSecondary"
  }, beneficiary.reason === "remarried" ? "Beneficiary Remarried on: " : beneficiary.reason === "died" ? "Beneficiary Died on: " : "Beneficiary Denied Last Live Check on: ", beneficiary.remarriageOrDeathDate ? new Date(beneficiary.remarriageOrDeathDate).toLocaleDateString("en-BD") : "N/A"), /*#__PURE__*/React.createElement(Typography, {
    variant: "caption",
    style: {
      fontWeight: 700
    }
  }, (_beneficiary$remarks = beneficiary === null || beneficiary === void 0 ? void 0 : beneficiary.remarks) !== null && _beneficiary$remarks !== void 0 ? _beneficiary$remarks : ""))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    md: 3
  }, /*#__PURE__*/React.createElement(Box$1, {
    mb: 2
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle2"
  }, /*#__PURE__*/React.createElement("strong", null, "Payment Detail:")), /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    style: {
      fontWeight: 700
    }
  }, (_Number$toLocaleStrin = Number(beneficiary === null || beneficiary === void 0 ? void 0 : beneficiary.payableAmount).toLocaleString("en-BD")) !== null && _Number$toLocaleStrin !== void 0 ? _Number$toLocaleStrin : Number(beneficiary === null || beneficiary === void 0 ? void 0 : beneficiary.payableAmount).toLocaleString("en-BD")), /*#__PURE__*/React.createElement(Typography, {
    variant: "caption",
    color: "textSecondary"
  }, "Total: " + ((_Number$toLocaleStrin2 = Number(beneficiary === null || beneficiary === void 0 ? void 0 : beneficiary.eisApprovedAmount).toLocaleString("en-BD")) !== null && _Number$toLocaleStrin2 !== void 0 ? _Number$toLocaleStrin2 : "--")), /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    style: {
      fontWeight: 700
    }
  }, getPaymentTypeString(beneficiary.eisPaymentType)))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    md: 3
  }, /*#__PURE__*/React.createElement(Box$1, {
    mb: 2
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle2"
  }, /*#__PURE__*/React.createElement("strong", null, "Last Changes")), /*#__PURE__*/React.createElement(Typography, {
    variant: "caption",
    display: "block",
    color: "textSecondary"
  }, /*#__PURE__*/React.createElement("strong", null, "Last Increment: "), " ", Number((_beneficiary$incremen = beneficiary === null || beneficiary === void 0 ? void 0 : beneficiary.incrementAmount) !== null && _beneficiary$incremen !== void 0 ? _beneficiary$incremen : 0).toLocaleString("en-BD"), " (", beneficiary !== null && beneficiary !== void 0 && beneficiary.incrementDate ? new Date(beneficiary.incrementDate).toLocaleDateString("en-BD") : "N/A", ")"), /*#__PURE__*/React.createElement(Typography, {
    variant: "caption",
    display: "block",
    color: "textSecondary"
  }, /*#__PURE__*/React.createElement("strong", null, "Last Decrement: "), " ", Number((_beneficiary$decremen = beneficiary === null || beneficiary === void 0 ? void 0 : beneficiary.decrementAmount) !== null && _beneficiary$decremen !== void 0 ? _beneficiary$decremen : 0).toLocaleString("en-BD"), " ", /*#__PURE__*/React.createElement("strong", null, "Decrement End Date: "), "(", beneficiary !== null && beneficiary !== void 0 && beneficiary.decrementEndDate ? new Date(beneficiary.decrementEndDate).toLocaleDateString("en-BD") : "N/A", ")"))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    md: 3
  }, /*#__PURE__*/React.createElement(Box$1, {
    p: 2,
    borderRadius: 8,
    bgcolor: "#f1f8e9",
    border: "1px solid #dcedc8"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle2",
    style: {
      fontWeight: 600,
      marginBottom: 8,
      color: "#558b2f"
    }
  }, "Increment"), /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 2
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(TextField, {
    fullWidth: true,
    type: "number",
    variant: "outlined",
    label: "Amount",
    size: "small",
    value: formData.incrementAmount,
    onChange: function onChange(e) {
      return handleChange("incrementAmount", e.target.value);
    }
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(PublishedComponent, {
    pubRef: "workforce.DatePicker",
    label: "Effective Date",
    value: formData.incrementDate,
    onChange: function onChange(date) {
      return handleChange("incrementDate", date);
    },
    required: true
  }))))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    md: 3
  }, /*#__PURE__*/React.createElement(Box$1, {
    p: 2,
    borderRadius: 8,
    bgcolor: "#fdecea",
    border: "1px solid #f5c6cb"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle2",
    style: {
      fontWeight: 600,
      marginBottom: 8,
      color: "#c62828"
    }
  }, "Decrement"), /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 2
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(TextField, {
    fullWidth: true,
    type: "number",
    variant: "outlined",
    label: "Amount",
    size: "small",
    value: formData.decrementAmount,
    onChange: function onChange(e) {
      return handleChange("decrementAmount", e.target.value);
    }
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(PublishedComponent, {
    pubRef: "workforce.DatePicker",
    label: "Effective Date",
    value: formData.decrementDate,
    onChange: function onChange(date) {
      return handleChange("decrementDate", date);
    },
    required: true
  })))))), /*#__PURE__*/React.createElement(Box$1, {
    mt: 3
  }, /*#__PURE__*/React.createElement(TextField, {
    select: true,
    fullWidth: true,
    required: true,
    label: "Update Status of Beneficiary",
    variant: "outlined",
    size: "small",
    value: formData.reason,
    onChange: handleReasonChange,
    disabled: beneficiary.beneficiaryStatus === "closed"
  }, /*#__PURE__*/React.createElement(MenuItem, {
    value: ""
  }, /*#__PURE__*/React.createElement("em", null, "Select status")), /*#__PURE__*/React.createElement(MenuItem, {
    value: "remarried"
  }, "Beneficiary Remarried"), /*#__PURE__*/React.createElement(MenuItem, {
    value: "died"
  }, "Beneficiary Died"), /*#__PURE__*/React.createElement(MenuItem, {
    value: "live_check_denial"
  }, "Beneficiary has not confirmed live check"))), formData.reason && /*#__PURE__*/React.createElement(Box$1, {
    mt: 2
  }, /*#__PURE__*/React.createElement(TextField, {
    select: true,
    fullWidth: true,
    required: true,
    label: "Resulting Status",
    variant: "outlined",
    size: "small",
    value: formData.status,
    onChange: function onChange(e) {
      return handleChange("status", e.target.value);
    },
    disabled: !statusSelectable
  }, !statusSelectable && /*#__PURE__*/React.createElement(MenuItem, {
    value: formData.status
  }, formData.status.toUpperCase()), statusSelectable && [/*#__PURE__*/React.createElement(MenuItem, {
    key: "empty",
    value: ""
  }, /*#__PURE__*/React.createElement("em", null, "Select status")), /*#__PURE__*/React.createElement(MenuItem, {
    key: "hold",
    value: "hold"
  }, "Hold"), /*#__PURE__*/React.createElement(MenuItem, {
    key: "closed",
    value: "closed"
  }, "Closed")])), dateFieldLabel && /*#__PURE__*/React.createElement(Box$1, {
    mt: 2
  }, /*#__PURE__*/React.createElement(PublishedComponent, {
    pubRef: "workforce.DatePicker",
    label: dateFieldLabel,
    value: formData.remarriageOrDeathDate,
    onChange: function onChange(date) {
      return handleChange("remarriageOrDeathDate", date);
    },
    required: true
  })), /*#__PURE__*/React.createElement(Box$1, {
    mt: 2
  }, /*#__PURE__*/React.createElement(TextField, {
    fullWidth: true,
    label: "Remarks / Notes",
    variant: "outlined",
    size: "small",
    multiline: true,
    rows: 3,
    value: formData.remarks,
    onChange: function onChange(e) {
      return handleChange("remarks", e.target.value);
    }
  })), formData.status === "closed" && otherBeneficiaries.length > 0 ? /*#__PURE__*/React.createElement(TableContainer, {
    component: Paper,
    elevation: 0,
    style: {
      borderRadius: "12px",
      border: "1px solid #e0e0e0",
      marginTop: "24px"
    }
  }, /*#__PURE__*/React.createElement(Table$2, null, /*#__PURE__*/React.createElement(TableHead, {
    style: {
      backgroundColor: "#f8fafd"
    }
  }, /*#__PURE__*/React.createElement(TableRow, null, /*#__PURE__*/React.createElement(TableCell, {
    colspan: 5
  }, /*#__PURE__*/React.createElement("strong", null, "Other Beneficiaries"), /*#__PURE__*/React.createElement(Typography, {
    variant: "caption",
    display: "block",
    color: "textSecondary"
  }, "Adjust increments/decrements for other beneficiaries linked to the same worker.", /*#__PURE__*/React.createElement("span", {
    style: {
      display: "block",
      marginTop: 4,
      color: "#c90000"
    }
  }, "Note: Decrements are automatically calculated based on the main beneficiary's changes.")))), /*#__PURE__*/React.createElement(TableRow, null, /*#__PURE__*/React.createElement(TableCell, {
    style: {
      fontWeight: 600
    }
  }, "Beneficiary Details"), /*#__PURE__*/React.createElement(TableCell, {
    style: {
      fontWeight: 600
    }
  }, "Payment Method"), /*#__PURE__*/React.createElement(TableCell, {
    align: "right",
    style: {
      fontWeight: 600
    }
  }, "Amounts"), /*#__PURE__*/React.createElement(TableCell, {
    align: "right",
    style: {
      fontWeight: 600
    }
  }, "Increment"))), /*#__PURE__*/React.createElement(TableBody, null, otherBeneficiaries.map(function (row) {
    var _row$workforceEmploye, _row$workforceApplica, _row$bank, _row$bank2, _row$bank3, _Number$toLocaleStrin3, _Number$toLocaleStrin4;
    var dep = (row === null || row === void 0 || (_row$workforceEmploye = row.workforceEmployeeDependent) === null || _row$workforceEmploye === void 0 ? void 0 : _row$workforceEmploye[0]) || {};
    // Safely access nested adjustments
    var currentAdjustment = formData.adjustments[row.beneficiaryId] || {};
    return /*#__PURE__*/React.createElement(TableRow, {
      key: row.id,
      hover: true
    }, /*#__PURE__*/React.createElement(TableCell, null, /*#__PURE__*/React.createElement(Typography, {
      variant: "subtitle2",
      style: {
        fontWeight: 600
      }
    }, (dep === null || dep === void 0 ? void 0 : dep.nameEn) || (dep === null || dep === void 0 ? void 0 : dep.nameBn) || (row === null || row === void 0 || (_row$workforceApplica = row.workforceApplication) === null || _row$workforceApplica === void 0 || (_row$workforceApplica = _row$workforceApplica.workforceEmployee) === null || _row$workforceApplica === void 0 ? void 0 : _row$workforceApplica.firstNameBn) || "—"), /*#__PURE__*/React.createElement(Typography, {
      variant: "caption",
      color: "primary"
    }, getRelationString(dep)), /*#__PURE__*/React.createElement(Box$1, {
      mt: 0.5
    }, /*#__PURE__*/React.createElement(Chip, {
      label: row.beneficiaryId,
      size: "small",
      variant: "outlined",
      style: {
        height: 20,
        fontSize: 10
      }
    }))), /*#__PURE__*/React.createElement(TableCell, null, /*#__PURE__*/React.createElement(Typography, {
      variant: "body2"
    }, ((_row$bank = row.bank) === null || _row$bank === void 0 || (_row$bank = _row$bank.parent) === null || _row$bank === void 0 ? void 0 : _row$bank.nameEn) || "N/A"), /*#__PURE__*/React.createElement(Typography, {
      variant: "body2"
    }, ((_row$bank2 = row.bank) === null || _row$bank2 === void 0 ? void 0 : _row$bank2.nameEn) + " (Routing #" + ((_row$bank3 = row.bank) === null || _row$bank3 === void 0 ? void 0 : _row$bank3.routingNumber) + ")" || "N/A"), /*#__PURE__*/React.createElement(Typography, {
      variant: "caption",
      color: "textSecondary"
    }, "A/C: " + row.bankAccountNo)), /*#__PURE__*/React.createElement(TableCell, {
      align: "right"
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "body2",
      style: {
        fontWeight: 700
      }
    }, (_Number$toLocaleStrin3 = Number(row === null || row === void 0 ? void 0 : row.payableAmount).toLocaleString("en-BD")) !== null && _Number$toLocaleStrin3 !== void 0 ? _Number$toLocaleStrin3 : Number(row === null || row === void 0 ? void 0 : row.payableAmount).toLocaleString("en-BD")), /*#__PURE__*/React.createElement(Typography, {
      variant: "caption",
      color: "textSecondary"
    }, "Total: " + ((_Number$toLocaleStrin4 = Number(row === null || row === void 0 ? void 0 : row.eisApprovedAmount).toLocaleString("en-BD")) !== null && _Number$toLocaleStrin4 !== void 0 ? _Number$toLocaleStrin4 : "--")), /*#__PURE__*/React.createElement(Typography, {
      variant: "body2",
      style: {
        fontWeight: 700
      }
    }, getPaymentTypeString(row.eisPaymentType))), /*#__PURE__*/React.createElement(TableCell, null, /*#__PURE__*/React.createElement(Box$1, {
      p: 2,
      borderRadius: 8,
      bgcolor: "#f1f8e9",
      border: "1px solid #dcedc8"
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "subtitle2",
      style: {
        fontWeight: 600,
        marginBottom: 8,
        color: "#558b2f"
      }
    }, "Increment"), /*#__PURE__*/React.createElement(Grid, {
      container: true,
      spacing: 2
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12
    }, /*#__PURE__*/React.createElement(TextField, {
      fullWidth: true,
      type: "number",
      variant: "outlined",
      label: "Amount",
      size: "small",
      value: currentAdjustment.incrementAmount || "",
      onChange: function onChange(e) {
        return updateAdjustment(row.beneficiaryId, "incrementAmount", e.target.value);
      }
    }))))));
  })))) : null), /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement(DialogActions$1, null, /*#__PURE__*/React.createElement(Button, {
    onClick: onClose,
    color: "default"
  }, "Cancel"), /*#__PURE__*/React.createElement(Button, {
    variant: "contained",
    color: "primary"
    // disabled={!formData.reason || !formData.status ||!formData.incrementAmount <= 0 || formData.incrementAmount <= 0}
    ,
    onClick: function onClick() {
      handleSave();
      // onClose();
    }
  }, "Save Changes"))));
};

function ownKeys$t(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$t(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$t(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$t(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var INITIAL_STATE = {
  bank: null,
  bankObj: null,
  districtBank: null,
  branch: null,
  accountHolderName: "",
  routingNumber: "",
  accountNumber: "",
  phoneNumber: ""
};
var useStyles$o = makeStyles(function (theme) {
  return {
    item: {
      marginBottom: theme.spacing(2)
    }
  };
});
var BeneficiaryEditModal = function BeneficiaryEditModal(_ref) {
  var _beneficiary$workforc, _beneficiary$workforc2, _beneficiary$workforc3, _safeParse, _beneficiary$workforc4, _beneficiary$workforc5, _beneficiary$workforc6, _beneficiary$workforc7, _beneficiary$workforc8, _beneficiary$remarks, _Number$toLocaleStrin, _beneficiary$incremen, _beneficiary$decremen, _formData$bankObj, _formData$bankObj2, _formData$districtBan;
  var open = _ref.open,
    onClose = _ref.onClose,
    onSuccess = _ref.onSuccess,
    beneficiaryId = _ref.beneficiaryId;
  var classes = useStyles$o();
  var _useState = useState({}),
    _useState2 = _slicedToArray(_useState, 2),
    beneficiary = _useState2[0],
    setBeneficiary = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    loader = _useState4[0],
    setLoader = _useState4[1];
  var dispatch = useDispatch();
  var modulesManager = useModulesManager();
  var dep = beneficiary === null || beneficiary === void 0 || (_beneficiary$workforc = beneficiary.workforceEmployeeDependent) === null || _beneficiary$workforc === void 0 ? void 0 : _beneficiary$workforc[0];
  var _useState5 = useState(INITIAL_STATE),
    _useState6 = _slicedToArray(_useState5, 2),
    formData = _useState6[0],
    setFormData = _useState6[1];
  var handleAccountChange = function handleAccountChange(field, value) {
    setFormData(function (prev) {
      var updated = _objectSpread$t(_objectSpread$t({}, prev), {}, _defineProperty({}, field, value));
      if (field === "bank") {
        var _value$id;
        updated.bank = (_value$id = value === null || value === void 0 ? void 0 : value.id) !== null && _value$id !== void 0 ? _value$id : null;
        updated.bankObj = value;
        updated.districtBank = null;
        updated.branch = null;
      } else if (field === "districtBank") {
        updated.branch = null;
      } else if (field === "branch") {
        updated.routingNumber = value.routingNumber;
      }
      return updated;
    });
  };
  useEffect(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var _processRes$payload, _yield$Promise$all, _yield$Promise$all2, processRes;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          if (!open) {
            _context.next = 9;
            break;
          }
          setLoader(true);
          _context.next = 4;
          return Promise.all([dispatch(fetchEisPaymentProcessWithFilters({
            processId: "".concat(safeDecodeId(beneficiaryId)),
            workforceApplicationTrackingNumber: "",
            workforceFactoryId: "",
            allAssociationId: "",
            beneficiaryId: "",
            status: "active",
            approved: "yes",
            approvalDateFrom: "",
            approvalDateTo: "",
            accidentDateFrom: "",
            accidentDateTo: ""
          }, modulesManager))]);
        case 4:
          _yield$Promise$all = _context.sent;
          _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 1);
          processRes = _yield$Promise$all2[0];
          setBeneficiary((processRes === null || processRes === void 0 || (_processRes$payload = processRes.payload) === null || _processRes$payload === void 0 || (_processRes$payload = _processRes$payload.data) === null || _processRes$payload === void 0 || (_processRes$payload = _processRes$payload.workforceEisPaymentProcess) === null || _processRes$payload === void 0 ? void 0 : _processRes$payload[0]) || {});
          setLoader(false);
        case 9:
        case "end":
          return _context.stop();
      }
    }, _callee);
  })), [beneficiaryId, modulesManager, dispatch]);
  useEffect(function () {
    if (open && beneficiary) {
      var _beneficiary$bank, _beneficiary$bank2, _beneficiary$bank3;
      setFormData(_objectSpread$t(_objectSpread$t({}, INITIAL_STATE), {}, {
        bank: (beneficiary === null || beneficiary === void 0 || (_beneficiary$bank = beneficiary.bank) === null || _beneficiary$bank === void 0 || (_beneficiary$bank = _beneficiary$bank.parent) === null || _beneficiary$bank === void 0 ? void 0 : _beneficiary$bank.id) || null,
        bankObj: (beneficiary === null || beneficiary === void 0 || (_beneficiary$bank2 = beneficiary.bank) === null || _beneficiary$bank2 === void 0 ? void 0 : _beneficiary$bank2.parent) || null,
        districtBank: (beneficiary === null || beneficiary === void 0 ? void 0 : beneficiary.bank) || null,
        branch: (beneficiary === null || beneficiary === void 0 ? void 0 : beneficiary.bank) || null,
        accountHolderName: (beneficiary === null || beneficiary === void 0 ? void 0 : beneficiary.bankAccountHolderName) || "",
        routingNumber: (beneficiary === null || beneficiary === void 0 || (_beneficiary$bank3 = beneficiary.bank) === null || _beneficiary$bank3 === void 0 ? void 0 : _beneficiary$bank3.routingNumber) || "",
        accountNumber: (beneficiary === null || beneficiary === void 0 ? void 0 : beneficiary.bankAccountNo) || "",
        phoneNumber: (beneficiary === null || beneficiary === void 0 ? void 0 : beneficiary.phoneNumber) || ""
      }));
    }
  }, [open, beneficiary]);
  var handleSave = function handleSave() {
    var payload = {
      beneficiaryId: beneficiary.beneficiaryId || null,
      bank: formData.bank,
      bankObjs: formData.bankObj,
      districtBank: formData.districtBank,
      branch: formData.branch,
      bankAccountHolderName: formData.accountHolderName,
      routingNumber: formData.routingNumber,
      bankAccountNo: formData.accountNumber,
      phoneNumber: formData.phoneNumber
    };
    dispatch(updateWorkforceEisBeneficiaryBank(payload)).then(function () {
      return onSuccess();
    });
  };
  var worker = (beneficiary === null || beneficiary === void 0 || (_beneficiary$workforc2 = beneficiary.workforceApplication) === null || _beneficiary$workforc2 === void 0 ? void 0 : _beneficiary$workforc2.applicationType) === "financialAssistance" || (beneficiary === null || beneficiary === void 0 || (_beneficiary$workforc3 = beneficiary.workforceApplication) === null || _beneficiary$workforc3 === void 0 ? void 0 : _beneficiary$workforc3.applicationType) === "deadlyGrant" ? (_safeParse = safeParse(beneficiary === null || beneficiary === void 0 || (_beneficiary$workforc4 = beneficiary.workforceApplication) === null || _beneficiary$workforc4 === void 0 ? void 0 : _beneficiary$workforc4.deceasedWorkerInfo)) === null || _safeParse === void 0 ? void 0 : _safeParse.nameBn : beneficiary === null || beneficiary === void 0 || (_beneficiary$workforc5 = beneficiary.workforceApplication) === null || _beneficiary$workforc5 === void 0 || (_beneficiary$workforc5 = _beneficiary$workforc5.workforceEmployee) === null || _beneficiary$workforc5 === void 0 ? void 0 : _beneficiary$workforc5.firstNameBn;
  if (!beneficiary) return null;
  console.log({
    formData: formData
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, loader ? /*#__PURE__*/React.createElement(Box$1, {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "200px"
  }, /*#__PURE__*/React.createElement(CircularProgress$1, null)) : /*#__PURE__*/React.createElement(Dialog$1, {
    open: open,
    onClose: onClose,
    maxWidth: "lg",
    fullWidth: true
  }, /*#__PURE__*/React.createElement(DialogTitle, null, "Edit Beneficiary Information"), /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement(DialogContent$1, null, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 2
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    md: 3
  }, /*#__PURE__*/React.createElement(Box$1, {
    mb: 2
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle2"
  }, /*#__PURE__*/React.createElement("strong", null, "Beneficiary ID")), /*#__PURE__*/React.createElement(Typography, null, beneficiary.beneficiaryId))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    md: 3
  }, /*#__PURE__*/React.createElement(Box$1, {
    mb: 2
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle2"
  }, /*#__PURE__*/React.createElement("strong", null, "Name")), /*#__PURE__*/React.createElement(Typography, null, (dep === null || dep === void 0 ? void 0 : dep.nameBn) || (dep === null || dep === void 0 ? void 0 : dep.nameEn) || "N/A"))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    md: 3
  }, /*#__PURE__*/React.createElement(Box$1, {
    mb: 2
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle2"
  }, /*#__PURE__*/React.createElement("strong", null, "Worker's Detail")), /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    style: {
      fontWeight: 500
    }
  }, worker), /*#__PURE__*/React.createElement(Typography, {
    variant: "caption",
    display: "block",
    color: "textSecondary"
  }, beneficiary === null || beneficiary === void 0 || (_beneficiary$workforc6 = beneficiary.workforceApplication) === null || _beneficiary$workforc6 === void 0 || (_beneficiary$workforc6 = _beneficiary$workforc6.employeeFactory) === null || _beneficiary$workforc6 === void 0 ? void 0 : _beneficiary$workforc6.nameBn), /*#__PURE__*/React.createElement(Typography, {
    variant: "caption",
    display: "block",
    color: "textSecondary"
  }, (beneficiary === null || beneficiary === void 0 || (_beneficiary$workforc7 = beneficiary.workforceApplication) === null || _beneficiary$workforc7 === void 0 || (_beneficiary$workforc7 = _beneficiary$workforc7.employeeFactory) === null || _beneficiary$workforc7 === void 0 || (_beneficiary$workforc7 = _beneficiary$workforc7.allAssociation) === null || _beneficiary$workforc7 === void 0 ? void 0 : _beneficiary$workforc7.shortNameBn) || (beneficiary === null || beneficiary === void 0 || (_beneficiary$workforc8 = beneficiary.workforceApplication) === null || _beneficiary$workforc8 === void 0 || (_beneficiary$workforc8 = _beneficiary$workforc8.employeeFactory) === null || _beneficiary$workforc8 === void 0 || (_beneficiary$workforc8 = _beneficiary$workforc8.allAssociation) === null || _beneficiary$workforc8 === void 0 ? void 0 : _beneficiary$workforc8.nameEn) || "N/A"))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    md: 3
  }, /*#__PURE__*/React.createElement(Box$1, {
    mb: 2
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle2"
  }, /*#__PURE__*/React.createElement("strong", null, "Current Status")), /*#__PURE__*/React.createElement(Chip, {
    label: beneficiary.beneficiaryStatus,
    size: "small",
    color: "primary"
  }), beneficiary.remarriageOrDeathDate && /*#__PURE__*/React.createElement(Typography, {
    variant: "caption",
    display: "block",
    color: "textSecondary"
  }, beneficiary.reason === "remarried" ? "Beneficiary Remarried on: " : beneficiary.reason === "died" ? "Beneficiary Died on: " : "Beneficiary Denied Last Live Check on: ", beneficiary.remarriageOrDeathDate ? new Date(beneficiary.remarriageOrDeathDate).toLocaleDateString("en-BD") : "N/A"), /*#__PURE__*/React.createElement(Typography, {
    variant: "caption",
    style: {
      fontWeight: 700
    }
  }, (_beneficiary$remarks = beneficiary === null || beneficiary === void 0 ? void 0 : beneficiary.remarks) !== null && _beneficiary$remarks !== void 0 ? _beneficiary$remarks : ""))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    md: 3
  }, /*#__PURE__*/React.createElement(Box$1, {
    mb: 2
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle2"
  }, /*#__PURE__*/React.createElement("strong", null, "Payment Detail:")), /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    style: {
      fontWeight: 700
    }
  }, Number(beneficiary === null || beneficiary === void 0 ? void 0 : beneficiary.payableAmount).toLocaleString("en-BD")), /*#__PURE__*/React.createElement(Typography, {
    variant: "caption",
    color: "textSecondary"
  }, "Total: " + ((_Number$toLocaleStrin = Number(beneficiary === null || beneficiary === void 0 ? void 0 : beneficiary.eisApprovedAmount).toLocaleString("en-BD")) !== null && _Number$toLocaleStrin !== void 0 ? _Number$toLocaleStrin : "--")), /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    style: {
      fontWeight: 700
    }
  }, getPaymentTypeString(beneficiary.eisPaymentType)))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    md: 3
  }, /*#__PURE__*/React.createElement(Box$1, {
    mb: 2
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle2"
  }, /*#__PURE__*/React.createElement("strong", null, "Last Changes")), /*#__PURE__*/React.createElement(Typography, {
    variant: "caption",
    display: "block",
    color: "textSecondary"
  }, /*#__PURE__*/React.createElement("strong", null, "Last Increment: "), Number((_beneficiary$incremen = beneficiary === null || beneficiary === void 0 ? void 0 : beneficiary.incrementAmount) !== null && _beneficiary$incremen !== void 0 ? _beneficiary$incremen : 0).toLocaleString("en-BD"), " (", beneficiary !== null && beneficiary !== void 0 && beneficiary.incrementDate ? new Date(beneficiary.incrementDate).toLocaleDateString("en-BD") : "N/A", ")"), /*#__PURE__*/React.createElement(Typography, {
    variant: "caption",
    display: "block",
    color: "textSecondary"
  }, /*#__PURE__*/React.createElement("strong", null, "Last Decrement: "), Number((_beneficiary$decremen = beneficiary === null || beneficiary === void 0 ? void 0 : beneficiary.decrementAmount) !== null && _beneficiary$decremen !== void 0 ? _beneficiary$decremen : 0).toLocaleString("en-BD"), " ", /*#__PURE__*/React.createElement("strong", null, "Decrement End Date: "), "(", beneficiary !== null && beneficiary !== void 0 && beneficiary.decrementEndDate ? new Date(beneficiary.decrementEndDate).toLocaleDateString("en-BD") : "N/A", ")")))), /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 2
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6,
    className: classes.item
  }, /*#__PURE__*/React.createElement(PublishedComponent, {
    pubRef: "workforce.BanksPicker",
    value: formData.bank,
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.bank.picker"
    }),
    onChange: function onChange(v) {
      return handleAccountChange("bank", v);
    },
    required: true
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6,
    className: classes.item
  }, /*#__PURE__*/React.createElement(DistrictBanks, {
    id: "districtBank",
    value: formData.districtBank,
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.district.branch.picker"
    }),
    bankId: ((_formData$bankObj = formData.bankObj) === null || _formData$bankObj === void 0 ? void 0 : _formData$bankObj.bankCode) || formData.bank,
    onChange: function onChange(v) {
      return handleAccountChange("districtBank", v);
    },
    required: true
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6,
    className: classes.item
  }, /*#__PURE__*/React.createElement(BranchPicker, {
    id: "branch",
    value: formData.branch,
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.branch.picker"
    }),
    bankId: ((_formData$bankObj2 = formData.bankObj) === null || _formData$bankObj2 === void 0 ? void 0 : _formData$bankObj2.bankCode) || formData.bank,
    districtName: (_formData$districtBan = formData.districtBank) === null || _formData$districtBan === void 0 ? void 0 : _formData$districtBan.districtNameBn,
    onChange: function onChange(v) {
      return handleAccountChange("branch", v);
    },
    required: true
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6,
    className: classes.item
  }, /*#__PURE__*/React.createElement(TextInput, {
    id: "accountHolderName",
    label: "workforce.employee.account.info.accountHolderName",
    value: formData.accountHolderName,
    onChange: function onChange(v) {
      return handleAccountChange("accountHolderName", v);
    },
    required: true
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6,
    className: classes.item
  }, /*#__PURE__*/React.createElement(TextInput, {
    id: "routingNumber",
    label: "workforce.employee.account.info.routingNumber",
    value: formData.routingNumber,
    onChange: function onChange(v) {
      return handleAccountChange("routingNumber", v);
    },
    readonly: true,
    required: true
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6,
    className: classes.item
  }, /*#__PURE__*/React.createElement(TextInput, {
    id: "accountNumber",
    label: "workforce.employee.account.info.accountNumber",
    value: formData.accountNumber,
    onChange: function onChange(v) {
      return handleAccountChange("accountNumber", v);
    },
    required: true
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6,
    className: classes.item
  }, /*#__PURE__*/React.createElement(TextInput, {
    id: "phoneNumber",
    label: "workforce.employee.phone",
    value: formData.phoneNumber,
    onChange: function onChange(v) {
      return handleAccountChange("phoneNumber", v);
    },
    required: true
  })))), /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement(DialogActions$1, null, /*#__PURE__*/React.createElement(Button, {
    onClick: onClose,
    color: "default"
  }, "Cancel"), /*#__PURE__*/React.createElement(Button, {
    variant: "contained",
    color: "primary",
    onClick: handleSave
  }, "Save Changes"))));
};

function ownKeys$s(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$s(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$s(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$s(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var AssociationManageModal = function AssociationManageModal(_ref) {
  var open = _ref.open,
    onClose = _ref.onClose,
    onSuccess = _ref.onSuccess,
    association = _ref.association;
  console.log("AssociationManageModal Props:", {
    open: open,
    onClose: onClose,
    onSuccess: onSuccess,
    association: association
  });
  var INITIAL_STATE = {
    associationId: association === null || association === void 0 ? void 0 : association.id,
    // Main Beneficiary Adjustments
    increment: "",
    incrementDate: null,
    decrement: "",
    decrementDate: null
  };
  var dispatch = useDispatch();
  useModulesManager();
  var _useState = useState(INITIAL_STATE),
    _useState2 = _slicedToArray(_useState, 2),
    formData = _useState2[0],
    setFormData = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    loading = _useState4[0],
    setLoading = _useState4[1];
  var handleChange = function handleChange(field, value) {
    setFormData(function (prev) {
      return _objectSpread$s(_objectSpread$s({}, prev), {}, _defineProperty({}, field, value));
    });
  };

  /* -------------------- SAVE -------------------- */
  var handleSave = function handleSave() {
    setLoading(true);
    if (formData.increment > 0 || formData.decrement > 0 || formData.reason && formData.status) {
      var payload = {
        associationId: (association === null || association === void 0 ? void 0 : association.id) || null,
        increment: formData.increment || null,
        // incrementDate: formData.incrementDate || null,
        decrement: formData.decrement || null
        // decrementDate: formData.decrementDate || null,
      };
      console.log("Payload to submit:", payload);
      dispatch(updateWorkforceEisPaymentByAssociation(payload)).then(function () {
        onSuccess();
        formData.increment = "";
        formData.decrement = "";
        setLoading(false);
      });
    } else {
      return alert("Please provide at least one change (Increment or Decrement) to save.");
    }
  };
  return /*#__PURE__*/React.createElement(Dialog$1, {
    open: open,
    onClose: onClose,
    maxWidth: "lg",
    fullWidth: true
  }, /*#__PURE__*/React.createElement(DialogTitle, null, "Increase or Decrease Beneficiary Payments for ", /*#__PURE__*/React.createElement("strong", null, association === null || association === void 0 ? void 0 : association.nameEn, " (", association === null || association === void 0 ? void 0 : association.shortNameEn, ")")), /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement(DialogContent$1, null, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 2,
    style: {
      marginBottom: 16
    }
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body1",
    style: {
      color: "#555"
    }
  }, "Use the options below to apply a percentage increase or decrease to the payments of all beneficiaries associated with ", /*#__PURE__*/React.createElement("strong", null, association === null || association === void 0 ? void 0 : association.nameEn), ". You can specify either an increment, a decrement, or both. Changes will be effective immediately.")), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 6,
    md: 6
  }, /*#__PURE__*/React.createElement(Box$1, {
    p: 2,
    borderRadius: 8,
    bgcolor: "#f1f8e9",
    border: "1px solid #dcedc8"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle2",
    style: {
      fontWeight: 600,
      marginBottom: 8,
      color: "#558b2f"
    }
  }, "Increment Percentage"), /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 2
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(TextField, {
    fullWidth: true,
    type: "number",
    variant: "outlined",
    label: "Percent (%)",
    size: "small",
    inputProps: {
      max: 100
    },
    onChange: function onChange(e) {
      return handleChange('increment', e.target.value);
    }
  }))))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 6,
    md: 6
  }, /*#__PURE__*/React.createElement(Box$1, {
    p: 2,
    borderRadius: 8,
    bgcolor: "#fdecea",
    border: "1px solid #f5c6cb"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle2",
    style: {
      fontWeight: 600,
      marginBottom: 8,
      color: "#c62828"
    }
  }, "Decrement Percentage"), /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 2
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(TextField, {
    fullWidth: true,
    type: "number",
    variant: "outlined",
    label: "Percent (%)",
    size: "small",
    onChange: function onChange(e) {
      return handleChange('decrement', e.target.value);
    }
  }))))))), /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement(DialogActions$1, null, /*#__PURE__*/React.createElement(Button, {
    onClick: onClose,
    color: "default"
  }, "Cancel"), /*#__PURE__*/React.createElement(Button, {
    variant: "contained",
    color: "primary",
    disabled: loading,
    onClick: function onClick() {
      handleSave();
    }
  }, loading ? /*#__PURE__*/React.createElement(Box$1, {
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(CircularProgress$1, null)) : "Save Changes")));
};

function ownKeys$r(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$r(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$r(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$r(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var IncrementDecrementModal = function IncrementDecrementModal(_ref) {
  var open = _ref.open,
    onClose = _ref.onClose,
    onSuccess = _ref.onSuccess,
    association = _ref.association,
    selectedIds = _ref.selectedIds;
  console.log("IncrementDecrementModal Props:", {
    open: open,
    onClose: onClose,
    onSuccess: onSuccess,
    selectedIds: selectedIds
  });
  var INITIAL_STATE = {
    associationId: association === null || association === void 0 ? void 0 : association.id,
    // Main Beneficiary Adjustments
    increment: "",
    incrementDate: null,
    decrement: "",
    decrementDate: null
  };
  var dispatch = useDispatch();
  useModulesManager();
  var _useState = useState(INITIAL_STATE),
    _useState2 = _slicedToArray(_useState, 2),
    formData = _useState2[0],
    setFormData = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    loading = _useState4[0],
    setLoading = _useState4[1];
  var handleChange = function handleChange(field, value) {
    setFormData(function (prev) {
      return _objectSpread$r(_objectSpread$r({}, prev), {}, _defineProperty({}, field, value));
    });
  };
  var handleDateChange = function handleDateChange(field, value) {
    setFormData(function (prev) {
      return _objectSpread$r(_objectSpread$r({}, prev), {}, _defineProperty({}, field, value));
    });
  };

  /* -------------------- SAVE -------------------- */
  var handleSave = function handleSave() {
    setLoading(true);
    if (formData.increment > 0 || formData.decrement > 0 || (formData === null || formData === void 0 ? void 0 : formData.associationId) !== "" || (formData === null || formData === void 0 ? void 0 : formData.associationId) !== null) {
      var payload = {
        associationId: (association === null || association === void 0 ? void 0 : association.id) || null,
        selectedIds: selectedIds || null,
        increment: formData.increment || null,
        incrementDate: formData.incrementDate || null,
        decrement: formData.decrement || null,
        decrementDate: formData.decrementDate || null
      };
      console.log("Payload to submit:", payload);
      dispatch(updateWorkforceEisPaymentByAssociation(payload)).then(function () {
        onSuccess();
        formData.increment = "";
        formData.decrement = "";
        formData.incrementDate = "";
        formData.decrementDate = "";
        setLoading(false);
      });
    } else {
      return alert("Please provide at least one change (Increment or Decrement) and Select an Association to save.");
    }
  };
  return /*#__PURE__*/React.createElement(Dialog$1, {
    open: open,
    onClose: onClose,
    maxWidth: "lg",
    fullWidth: true,
    style: {
      overflow: "visible"
    },
    PaperProps: {
      style: {
        overflow: "visible"
      }
    }
  }, /*#__PURE__*/React.createElement(DialogTitle, null, "Increase or Decrease Amounts for Selected Beneficiaries for ", /*#__PURE__*/React.createElement("strong", null, association === null || association === void 0 ? void 0 : association.nameEn, " (", association === null || association === void 0 ? void 0 : association.shortNameEn, ")")), /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement(DialogContent$1, {
    style: {
      overflow: "visible"
    }
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 2,
    style: {
      marginBottom: 16
    }
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body1",
    style: {
      color: "#555"
    }
  }, "Use the options below to apply a percentage increase or decrease to the payments of all beneficiaries associated with ", /*#__PURE__*/React.createElement("strong", null, association === null || association === void 0 ? void 0 : association.nameEn), ". You can specify either an increment, a decrement, or both. Changes will be effective immediately.")), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 6,
    md: 6
  }, /*#__PURE__*/React.createElement(Box$1, {
    p: 2,
    borderRadius: 8,
    bgcolor: "#f1f8e9",
    border: "1px solid #dcedc8"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle2",
    style: {
      fontWeight: 600,
      marginBottom: 8,
      color: "#558b2f"
    }
  }, "Increment Percentage"), /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 2
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(TextField, {
    fullWidth: true,
    type: "number",
    variant: "outlined",
    label: "Percent (%)",
    size: "small",
    inputProps: {
      max: 100
    },
    onChange: function onChange(e) {
      return handleChange('increment', e.target.value);
    }
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(PublishedComponent, {
    pubRef: "workforce.DatePicker",
    label: "Effective Date"
    // value={formData.incrementDate || null}
    ,
    PopperProps: {
      container: document.body,
      style: {
        zIndex: 2000
      }
    },
    onChange: function onChange(date) {
      return handleDateChange('incrementDate', date);
    },
    required: true
  }))))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 6,
    md: 6
  }, /*#__PURE__*/React.createElement(Box$1, {
    p: 2,
    borderRadius: 8,
    bgcolor: "#fdecea",
    border: "1px solid #f5c6cb"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle2",
    style: {
      fontWeight: 600,
      marginBottom: 8,
      color: "#c62828"
    }
  }, "Decrement Percentage"), /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 2
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(TextField, {
    fullWidth: true,
    type: "number",
    variant: "outlined",
    label: "Percent (%)",
    size: "small",
    onChange: function onChange(e) {
      return handleChange('decrement', e.target.value);
    }
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(PublishedComponent, {
    pubRef: "workforce.DatePicker",
    label: "Effective Date",
    PopperProps: {
      container: document.body,
      style: {
        zIndex: 2000
      }
    }
    // value={formData.decrementDate || null}
    ,
    onChange: function onChange(date) {
      return handleDateChange('decrementDate', date);
    },
    required: true
  }))))))), /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement(DialogActions$1, null, /*#__PURE__*/React.createElement(Button, {
    onClick: onClose,
    color: "default"
  }, "Cancel"), /*#__PURE__*/React.createElement(Button, {
    variant: "contained",
    color: "primary",
    disabled: loading,
    onClick: function onClick() {
      handleSave();
    }
  }, loading ? /*#__PURE__*/React.createElement(Box$1, {
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(CircularProgress$1, null)) : "Save Changes")));
};

function ownKeys$q(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$q(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$q(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$q(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var BeneficiaryManagement = function BeneficiaryManagement() {
  var _associations$find, _associations$find2;
  var dispatch = useDispatch();
  var modulesManager = useModulesManager();
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    loading = _useState2[0],
    setLoading = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    data = _useState4[0],
    setData = _useState4[1];
  var _useState5 = useState([]),
    _useState6 = _slicedToArray(_useState5, 2),
    factories = _useState6[0],
    setFactories = _useState6[1];
  var _useState7 = useState([]),
    _useState8 = _slicedToArray(_useState7, 2),
    associations = _useState8[0],
    setAssociations = _useState8[1];
  var _useState9 = useState(false),
    _useState10 = _slicedToArray(_useState9, 2);
    _useState10[0];
    _useState10[1];
  var _useState11 = useState([]),
    _useState12 = _slicedToArray(_useState11, 2),
    selectedIds = _useState12[0],
    setSelectedIds = _useState12[1];
  var _useState13 = useState({
      trackingNo: "",
      factory: "",
      association: "",
      beneficiaryId: "",
      approvalDateFrom: "",
      approvalDateTo: "",
      accidentDateFrom: "",
      accidentDateTo: ""
    }),
    _useState14 = _slicedToArray(_useState13, 2),
    filters = _useState14[0],
    setFilters = _useState14[1];
  var _useState15 = useState(false),
    _useState16 = _slicedToArray(_useState15, 2),
    openModal = _useState16[0],
    setOpenModal = _useState16[1];
  var _useState17 = useState(false),
    _useState18 = _slicedToArray(_useState17, 2),
    openAssociationModal = _useState18[0],
    setOpenAssociationModal = _useState18[1];
  var _useState19 = useState(false),
    _useState20 = _slicedToArray(_useState19, 2),
    openIncrementDecrementModal = _useState20[0],
    setOpenIncrementDecrementModal = _useState20[1];
  var _useState21 = useState(false),
    _useState22 = _slicedToArray(_useState21, 2),
    openEditModal = _useState22[0],
    setOpenEditModal = _useState22[1];
  var _useState23 = useState(null),
    _useState24 = _slicedToArray(_useState23, 2),
    selectedBeneficiary = _useState24[0],
    setSelectedBeneficiary = _useState24[1];
  var _useState25 = useState(null),
    _useState26 = _slicedToArray(_useState25, 2);
    _useState26[0];
    var setSelectedAssociation = _useState26[1];
  var handleOpenModal = function handleOpenModal(row) {
    setSelectedBeneficiary(row);
    setOpenModal(true);
  };
  var handleCloseModal = function handleCloseModal() {
    setOpenModal(false);
    setSelectedBeneficiary(null);
  };
  var handleOpenEditModal = function handleOpenEditModal(row) {
    setSelectedBeneficiary(row);
    setOpenEditModal(true);
  };
  var handleCloseEditModal = function handleCloseEditModal() {
    setOpenEditModal(false);
    setSelectedBeneficiary(null);
  };
  var handleCloseAssociationModal = function handleCloseAssociationModal() {
    setOpenAssociationModal(false);
    setSelectedAssociation(null);
  };
  var handleOpenIcrementDecrementModal = function handleOpenIcrementDecrementModal() {
    setSelectedAssociation(filters.association);
    setOpenIncrementDecrementModal(true);
  };
  var handleCloseIncrementDecrementModal = function handleCloseIncrementDecrementModal() {
    setOpenIncrementDecrementModal(false);
    setSelectedAssociation(null);
  };
  var handleRowSelect = function handleRowSelect(id) {
    setSelectedIds(function (prev) {
      return prev.includes(id) ? prev.filter(function (x) {
        return x !== id;
      }) : [].concat(_toConsumableArray(prev), [id]);
    });
  };
  var handleSelectAll = function handleSelectAll(checked) {
    if (checked) {
      setSelectedIds(data.map(function (row) {
        return row.id;
      }));
    } else {
      setSelectedIds([]);
    }
  };

  // 1. Updated Fetching Logic to accept filter parameters
  var loadData = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _safeDecodeId, _safeDecodeId2, _filters$approvalDate, _filters$approvalDate2, _filters$accidentDate, _filters$accidentDate2, _processRes$payload, _yield$Promise$all, _yield$Promise$all2, processRes;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            setLoading(true);
            _context.prev = 1;
            // Pass the filter state directly to the backend action
            dispatch(fetchWorkforceFactoriesSummary(modulesManager, [])).then(function (factoryRes) {
              var _factoryRes$payload;
              setFactories((factoryRes === null || factoryRes === void 0 || (_factoryRes$payload = factoryRes.payload) === null || _factoryRes$payload === void 0 || (_factoryRes$payload = _factoryRes$payload.data) === null || _factoryRes$payload === void 0 || (_factoryRes$payload = _factoryRes$payload.workforceEmployerFactories) === null || _factoryRes$payload === void 0 ? void 0 : _factoryRes$payload.edges) || []);
            });
            dispatch(fetchWorkforceAllAssociationSummary([])).then(function (assocRes) {
              var _assocRes$payload;
              setAssociations((assocRes === null || assocRes === void 0 || (_assocRes$payload = assocRes.payload) === null || _assocRes$payload === void 0 || (_assocRes$payload = _assocRes$payload.data) === null || _assocRes$payload === void 0 || (_assocRes$payload = _assocRes$payload.workforceAllAssociation) === null || _assocRes$payload === void 0 ? void 0 : _assocRes$payload.edges) || []);
            });
            _context.next = 6;
            return Promise.all([dispatch(fetchEisPaymentProcessWithoutFilters({
              workforceApplicationTrackingNumber: filters.trackingNo,
              workforceFactoryId: (_safeDecodeId = safeDecodeId(filters.factory)) !== null && _safeDecodeId !== void 0 ? _safeDecodeId : "",
              allAssociationId: (_safeDecodeId2 = safeDecodeId(filters.association)) !== null && _safeDecodeId2 !== void 0 ? _safeDecodeId2 : "",
              beneficiaryId: filters.beneficiaryId,
              status: "active",
              approved: "yes",
              approvalDateFrom: (_filters$approvalDate = filters.approvalDateFrom) !== null && _filters$approvalDate !== void 0 ? _filters$approvalDate : "",
              approvalDateTo: (_filters$approvalDate2 = filters.approvalDateTo) !== null && _filters$approvalDate2 !== void 0 ? _filters$approvalDate2 : "",
              accidentDateFrom: (_filters$accidentDate = filters.accidentDateFrom) !== null && _filters$accidentDate !== void 0 ? _filters$accidentDate : "",
              accidentDateTo: (_filters$accidentDate2 = filters.accidentDateTo) !== null && _filters$accidentDate2 !== void 0 ? _filters$accidentDate2 : ""
            }, modulesManager))]);
          case 6:
            _yield$Promise$all = _context.sent;
            _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 1);
            processRes = _yield$Promise$all2[0];
            setData((processRes === null || processRes === void 0 || (_processRes$payload = processRes.payload) === null || _processRes$payload === void 0 || (_processRes$payload = _processRes$payload.data) === null || _processRes$payload === void 0 ? void 0 : _processRes$payload.workforceEisPaymentProcess) || []);
            _context.next = 15;
            break;
          case 12:
            _context.prev = 12;
            _context.t0 = _context["catch"](1);
            console.error("Data Load Error:", _context.t0);
          case 15:
            _context.prev = 15;
            setLoading(false);
            return _context.finish(15);
          case 18:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[1, 12, 15, 18]]);
    }));
    return function loadData() {
      return _ref.apply(this, arguments);
    };
  }();
  useEffect(function () {
    loadData();
  }, [dispatch, modulesManager]);

  // 2. Filter Handlers
  var handleFilterChange = function handleFilterChange(e) {
    var _e$target = e.target,
      name = _e$target.name,
      value = _e$target.value;
    setFilters(function (prev) {
      return _objectSpread$q(_objectSpread$q({}, prev), {}, _defineProperty({}, name, value));
    });
    // if(name!=="approvalDateFrom" && name!=="approvalDateTo" && name!=="accidentDateFrom" && name!=="accidentDateTo"){
    //   loadData(); // Trigger data reload on filter change
    // }
    // loadData(); // Trigger data reload on filter change
  };
  var handleDateChange = function handleDateChange(field, value) {
    setFilters(function (prev) {
      return _objectSpread$q(_objectSpread$q({}, prev), {}, _defineProperty({}, field, value));
    });
    // loadData(); // Trigger data reload on date change
  };
  var clearFilters = function clearFilters() {
    setFilters({
      trackingNo: "",
      factory: "",
      association: "",
      beneficiaryId: "",
      approvalDateFrom: "",
      approvalDateTo: "",
      accidentDateFrom: "",
      accidentDateTo: ""
    });
  };

  // 3. Status Chip Helper
  var getStatusChip = function getStatusChip(row) {
    if ((row === null || row === void 0 ? void 0 : row.beneficiaryStatus) === "eligible") return /*#__PURE__*/React.createElement(Chip, {
      label: "Eligible",
      size: "small",
      style: {
        backgroundColor: '#e8f5e9',
        color: '#2e7d32'
      }
    });
    if ((row === null || row === void 0 ? void 0 : row.beneficiaryStatus) === "closed") return /*#__PURE__*/React.createElement(Chip, {
      label: "Closed",
      size: "small",
      style: {
        backgroundColor: '#f5e8e8ff',
        color: '#7d2e2eff'
      }
    });
    if ((row === null || row === void 0 ? void 0 : row.beneficiaryStatus) === "hold") return /*#__PURE__*/React.createElement(Chip, {
      label: "On Hold",
      size: "small",
      style: {
        backgroundColor: '#f5f4e8ff',
        color: '#787d2eff'
      }
    });
    return /*#__PURE__*/React.createElement(Chip, {
      label: row === null || row === void 0 ? void 0 : row.beneficiaryStatus,
      size: "small",
      variant: "outlined"
    });
  };
  var handleSearchClick = function handleSearchClick() {
    loadData();
  };
  return /*#__PURE__*/React.createElement(Box$1, {
    bgcolor: "#fafafa",
    minHeight: "100vh"
  }, /*#__PURE__*/React.createElement(Box$1, {
    mb: 2,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-end"
  }, /*#__PURE__*/React.createElement(Box$1, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5",
    style: {
      fontWeight: 700,
      marginBottom: 4
    }
  }, "Beneficiary Management"), /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    color: "textSecondary"
  }, "Manage and track beneficiaries, their payment statuses, and related details."))), /*#__PURE__*/React.createElement(Paper, {
    elevation: 0,
    style: {
      padding: '24px',
      marginBottom: '24px',
      borderRadius: '12px',
      border: '1px solid #eceff1'
    }
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 3,
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 6,
    md: 3
  }, /*#__PURE__*/React.createElement(TextField, {
    fullWidth: true,
    label: "Application Tracking No",
    name: "trackingNo",
    variant: "outlined",
    size: "small",
    value: filters.trackingNo,
    onChange: handleFilterChange,
    disabled: loading
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 6,
    md: 3
  }, /*#__PURE__*/React.createElement(TextField, {
    fullWidth: true,
    label: "Beneficiary ID",
    name: "beneficiaryId",
    variant: "outlined",
    size: "small",
    value: filters.beneficiaryId,
    onChange: handleFilterChange,
    disabled: loading
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 6,
    md: 3
  }, /*#__PURE__*/React.createElement(TextField, {
    fullWidth: true,
    select: true,
    label: "Factory",
    name: "factory",
    variant: "outlined",
    size: "small",
    value: filters.factory,
    onChange: handleFilterChange,
    disabled: loading
  }, /*#__PURE__*/React.createElement(MenuItem, {
    value: ""
  }, /*#__PURE__*/React.createElement("em", null, "All Factories")), factories.map(function (f) {
    return /*#__PURE__*/React.createElement(MenuItem, {
      key: f.node.id,
      value: f.node.id
    }, f.node.nameBn || f.node.nameEn);
  }))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 6,
    md: 3
  }, /*#__PURE__*/React.createElement(TextField, {
    fullWidth: true,
    select: true,
    label: "Association",
    name: "association",
    variant: "outlined",
    size: "small",
    value: filters.association,
    onChange: handleFilterChange,
    disabled: loading
  }, /*#__PURE__*/React.createElement(MenuItem, {
    value: ""
  }, /*#__PURE__*/React.createElement("em", null, "All Associations")), associations.map(function (a) {
    return /*#__PURE__*/React.createElement(MenuItem, {
      key: a.node.id,
      value: a.node.id
    }, a.node.shortNameBn || a.node.nameEn);
  }))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 6,
    md: 3
  }, /*#__PURE__*/React.createElement(Box$1, {
    mb: true,
    style: {
      border: '1px solid #ccc',
      borderRadius: '4px',
      padding: '8px 12px'
    },
    display: "flex",
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(PublishedComponent, {
    pubRef: "workforce.DatePicker",
    label: "Approval Date From",
    value: filters.approvalDateFrom,
    onChange: function onChange(date) {
      return handleDateChange("approvalDateFrom", date);
    },
    required: true,
    readOnly: loading
  }))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 6,
    md: 3
  }, /*#__PURE__*/React.createElement(Box$1, {
    style: {
      border: '1px solid #ccc',
      borderRadius: '4px',
      padding: '8px 12px'
    },
    display: "flex",
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(PublishedComponent, {
    pubRef: "workforce.DatePicker",
    label: "Approval Date To",
    value: filters.approvalDateTo,
    onChange: function onChange(date) {
      return handleDateChange("approvalDateTo", date);
    },
    required: true,
    readOnly: loading
  }))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 6,
    md: 3
  }, /*#__PURE__*/React.createElement(Box$1, {
    mb: true,
    style: {
      border: '1px solid #ccc',
      borderRadius: '4px',
      padding: '8px 12px'
    },
    display: "flex",
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(PublishedComponent, {
    pubRef: "workforce.DatePicker",
    label: "Accident Date From",
    value: filters.accidentDateFrom,
    onChange: function onChange(date) {
      return handleDateChange("accidentDateFrom", date);
    },
    required: true,
    readOnly: loading
  }))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 6,
    md: 3
  }, /*#__PURE__*/React.createElement(Box$1, {
    style: {
      border: '1px solid #ccc',
      borderRadius: '4px',
      padding: '8px 12px'
    },
    display: "flex",
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(PublishedComponent, {
    pubRef: "workforce.DatePicker",
    label: "Accident Date To",
    value: filters.accidentDateTo,
    onChange: function onChange(date) {
      return handleDateChange("accidentDateTo", date);
    },
    required: true,
    readOnly: loading
  }))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 6
  }, /*#__PURE__*/React.createElement(Box$1, {
    display: "flex",
    gap: "8px"
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: handleSearchClick,
    fullWidth: true,
    variant: "contained",
    color: "primary",
    startIcon: /*#__PURE__*/React.createElement(SearchIcon, null)
  }, "Search"), /*#__PURE__*/React.createElement(Button, {
    onClick: clearFilters,
    fullWidth: true,
    variant: "text",
    color: "default",
    startIcon: /*#__PURE__*/React.createElement(ClearAllIcon, null)
  }, "Reset"))))), loading ? /*#__PURE__*/React.createElement(Box$1, {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "200px"
  }, /*#__PURE__*/React.createElement(CircularProgress$1, null)) : /*#__PURE__*/React.createElement(TableContainer, {
    component: Paper,
    elevation: 0,
    style: {
      borderRadius: '12px',
      border: '1px solid #e0e0e0'
    }
  }, /*#__PURE__*/React.createElement(Table$2, null, /*#__PURE__*/React.createElement(TableHead, {
    style: {
      backgroundColor: '#f8fafd'
    }
  }, /*#__PURE__*/React.createElement(TableRow, null, /*#__PURE__*/React.createElement(TableCell, {
    padding: "checkbox",
    align: "center"
  }, /*#__PURE__*/React.createElement("input", {
    type: "checkbox",
    checked: selectedIds.length === data.length && data.length > 0,
    onChange: function onChange(e) {
      return handleSelectAll(e.target.checked);
    }
  })), /*#__PURE__*/React.createElement(TableCell, {
    style: {
      fontWeight: 600
    }
  }, "Beneficiary Details"), /*#__PURE__*/React.createElement(TableCell, {
    style: {
      fontWeight: 600
    }
  }, "Worker, Factory & Association"), /*#__PURE__*/React.createElement(TableCell, {
    style: {
      fontWeight: 600
    }
  }, "Payment Method"), /*#__PURE__*/React.createElement(TableCell, {
    align: "right",
    style: {
      fontWeight: 600
    }
  }, "Amounts"), /*#__PURE__*/React.createElement(TableCell, {
    align: "center",
    style: {
      fontWeight: 600
    }
  }, "Status"), /*#__PURE__*/React.createElement(TableCell, {
    align: "center",
    style: {
      fontWeight: 600
    }
  }, "Action"))), /*#__PURE__*/React.createElement(TableBody, null, data.map(function (row) {
    var _row$workforceEmploye, _row$workforceApplica, _row$workforceApplica2, _safeParse, _row$workforceApplica3, _row$workforceApplica4, _row$workforceApplica5, _row$workforceApplica6, _row$workforceApplica7, _row$workforceApplica8, _row$workforceApplica9, _row$bank, _row$bank2, _row$bank3, _row$bank4, _row$bank5, _Number$toLocaleStrin, _Number$toLocaleStrin2;
    var dep = (row === null || row === void 0 || (_row$workforceEmploye = row.workforceEmployeeDependent) === null || _row$workforceEmploye === void 0 ? void 0 : _row$workforceEmploye[0]) || {};
    var worker = (row === null || row === void 0 || (_row$workforceApplica = row.workforceApplication) === null || _row$workforceApplica === void 0 ? void 0 : _row$workforceApplica.applicationType) === "financialAssistance" || (row === null || row === void 0 || (_row$workforceApplica2 = row.workforceApplication) === null || _row$workforceApplica2 === void 0 ? void 0 : _row$workforceApplica2.applicationType) === "deadlyGrant" ? (_safeParse = safeParse(row === null || row === void 0 || (_row$workforceApplica3 = row.workforceApplication) === null || _row$workforceApplica3 === void 0 ? void 0 : _row$workforceApplica3.deceasedWorkerInfo)) === null || _safeParse === void 0 ? void 0 : _safeParse.nameEn : row === null || row === void 0 || (_row$workforceApplica4 = row.workforceApplication) === null || _row$workforceApplica4 === void 0 || (_row$workforceApplica4 = _row$workforceApplica4.workforceEmployee) === null || _row$workforceApplica4 === void 0 ? void 0 : _row$workforceApplica4.firstNameEn;
    return /*#__PURE__*/React.createElement(TableRow, {
      key: row.id,
      hover: true
    }, /*#__PURE__*/React.createElement(TableCell, {
      padding: "checkbox",
      align: "center"
    }, /*#__PURE__*/React.createElement("input", {
      type: "checkbox",
      checked: selectedIds.includes(row.id),
      onChange: function onChange() {
        return handleRowSelect(row.id);
      }
      // disabled={row?.isDisbursed}
    })), /*#__PURE__*/React.createElement(TableCell, null, /*#__PURE__*/React.createElement(Typography, {
      variant: "subtitle2",
      style: {
        fontWeight: 600
      }
    }, (dep === null || dep === void 0 ? void 0 : dep.nameEn) || (dep === null || dep === void 0 ? void 0 : dep.nameBn) || (row === null || row === void 0 || (_row$workforceApplica5 = row.workforceApplication) === null || _row$workforceApplica5 === void 0 || (_row$workforceApplica5 = _row$workforceApplica5.workforceEmployee) === null || _row$workforceApplica5 === void 0 ? void 0 : _row$workforceApplica5.firstNameEn) || "—"), /*#__PURE__*/React.createElement(Typography, {
      variant: "caption",
      color: "primary"
    }, getRelationString(dep)), /*#__PURE__*/React.createElement(Box$1, {
      mt: 0.5,
      mb: 0.5
    }, /*#__PURE__*/React.createElement(Chip, {
      label: row.beneficiaryId,
      variant: "outlined",
      style: {
        height: 20
      }
    })), /*#__PURE__*/React.createElement(Typography, {
      variant: "caption",
      display: "block",
      color: "textSecondary"
    }, "ATN: " + (row === null || row === void 0 || (_row$workforceApplica6 = row.workforceApplication) === null || _row$workforceApplica6 === void 0 ? void 0 : _row$workforceApplica6.trackingNumber) || "N/A")), /*#__PURE__*/React.createElement(TableCell, null, /*#__PURE__*/React.createElement(Typography, {
      variant: "body2",
      style: {
        fontWeight: 500
      }
    }, worker), /*#__PURE__*/React.createElement(Typography, {
      variant: "caption",
      display: "block",
      color: "textSecondary"
    }, row === null || row === void 0 || (_row$workforceApplica7 = row.workforceApplication) === null || _row$workforceApplica7 === void 0 || (_row$workforceApplica7 = _row$workforceApplica7.employeeFactory) === null || _row$workforceApplica7 === void 0 ? void 0 : _row$workforceApplica7.nameEn), /*#__PURE__*/React.createElement(Typography, {
      variant: "caption",
      display: "block",
      color: "textSecondary"
    }, (row === null || row === void 0 || (_row$workforceApplica8 = row.workforceApplication) === null || _row$workforceApplica8 === void 0 || (_row$workforceApplica8 = _row$workforceApplica8.employeeFactory) === null || _row$workforceApplica8 === void 0 || (_row$workforceApplica8 = _row$workforceApplica8.allAssociation) === null || _row$workforceApplica8 === void 0 ? void 0 : _row$workforceApplica8.shortNameEn) || (row === null || row === void 0 || (_row$workforceApplica9 = row.workforceApplication) === null || _row$workforceApplica9 === void 0 || (_row$workforceApplica9 = _row$workforceApplica9.employeeFactory) === null || _row$workforceApplica9 === void 0 || (_row$workforceApplica9 = _row$workforceApplica9.allAssociation) === null || _row$workforceApplica9 === void 0 ? void 0 : _row$workforceApplica9.nameEn) || "N/A")), /*#__PURE__*/React.createElement(TableCell, null, /*#__PURE__*/React.createElement(Typography, {
      variant: "body2"
    }, ((_row$bank = row.bank) === null || _row$bank === void 0 || (_row$bank = _row$bank.parent) === null || _row$bank === void 0 ? void 0 : _row$bank.nameEn) || "N/A"), /*#__PURE__*/React.createElement(Typography, {
      variant: "body2"
    }, ((_row$bank2 = row.bank) === null || _row$bank2 === void 0 ? void 0 : _row$bank2.nameEn) + " (Routing #" + ((row === null || row === void 0 || (_row$bank3 = row.bank) === null || _row$bank3 === void 0 ? void 0 : _row$bank3.routingNumber) == '0' || (row === null || row === void 0 || (_row$bank4 = row.bank) === null || _row$bank4 === void 0 ? void 0 : _row$bank4.routingNumber) == null ? row === null || row === void 0 ? void 0 : row.routingNumber : row === null || row === void 0 || (_row$bank5 = row.bank) === null || _row$bank5 === void 0 ? void 0 : _row$bank5.routingNumber) + ")" || "N/A"), /*#__PURE__*/React.createElement(Typography, {
      variant: "caption",
      color: "textSecondary"
    }, "A/C: " + row.bankAccountNo)), /*#__PURE__*/React.createElement(TableCell, {
      align: "right"
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "body2",
      style: {
        fontWeight: 700
      }
    }, (_Number$toLocaleStrin = Number(row.payableAmount).toLocaleString("en-BD")) !== null && _Number$toLocaleStrin !== void 0 ? _Number$toLocaleStrin : Number(row.payableAmount).toLocaleString("en-BD")), /*#__PURE__*/React.createElement(Typography, {
      variant: "caption",
      color: "textSecondary"
    }, "Total: " + ((_Number$toLocaleStrin2 = Number(row === null || row === void 0 ? void 0 : row.eisApprovedAmount).toLocaleString("en-BD")) !== null && _Number$toLocaleStrin2 !== void 0 ? _Number$toLocaleStrin2 : "--")), /*#__PURE__*/React.createElement(Typography, {
      variant: "body2",
      style: {
        fontWeight: 700
      }
    }, getPaymentTypeString(row.eisPaymentType))), /*#__PURE__*/React.createElement(TableCell, {
      align: "center"
    }, getStatusChip(row)), /*#__PURE__*/React.createElement(TableCell, null, /*#__PURE__*/React.createElement(Button, {
      variant: "contained",
      color: "primary",
      size: "small",
      startIcon: /*#__PURE__*/React.createElement(ListIcon, null),
      title: "Manage Beneficiary",
      onClick: function onClick() {
        return handleOpenModal(row);
      },
      style: {
        margin: "5px"
      }
    }), /*#__PURE__*/React.createElement(Button, {
      variant: "contained",
      color: "primary",
      size: "small",
      startIcon: /*#__PURE__*/React.createElement(EditIcon, null),
      title: "Edit Information",
      onClick: function onClick() {
        return handleOpenEditModal(row);
      },
      style: {
        margin: "5px"
      }
    })));
  }))), data.length === 0 && /*#__PURE__*/React.createElement(Box$1, {
    p: 5,
    textAlign: "center"
  }, /*#__PURE__*/React.createElement(Typography, {
    color: "textSecondary"
  }, "No data found matching current filters."))), /*#__PURE__*/React.createElement(Box$1, {
    spacing: "15px"
  }, selectedIds.length > 0 && filters.association !== "" && filters.association !== null ? /*#__PURE__*/React.createElement(Button, {
    variant: "contained",
    color: "primary",
    size: "small"
    // startIcon={<EditIcon />}
    ,
    title: "Set Increment or Decrement",
    onClick: function onClick() {
      return handleOpenIcrementDecrementModal();
    },
    style: {
      margin: "5px"
    }
  }, "Set Increment or Decrement") : /*#__PURE__*/React.createElement(React.Fragment, null)), /*#__PURE__*/React.createElement(BeneficiaryManageModal, {
    open: openModal,
    onClose: handleCloseModal,
    onSuccess: function onSuccess() {
      handleCloseModal();
      loadData();
    },
    beneficiaryId: selectedBeneficiary === null || selectedBeneficiary === void 0 ? void 0 : selectedBeneficiary.id
  }), /*#__PURE__*/React.createElement(BeneficiaryEditModal, {
    open: openEditModal,
    onClose: handleCloseEditModal,
    onSuccess: function onSuccess() {
      handleCloseEditModal();
      loadData();
    },
    beneficiaryId: selectedBeneficiary === null || selectedBeneficiary === void 0 ? void 0 : selectedBeneficiary.id
  }), /*#__PURE__*/React.createElement(AssociationManageModal, {
    open: openAssociationModal,
    onClose: handleCloseAssociationModal,
    onSuccess: function onSuccess() {
      handleCloseAssociationModal();
      loadData();
    },
    association: (_associations$find = associations.find(function (a) {
      return a.node.id === filters.association;
    })) === null || _associations$find === void 0 ? void 0 : _associations$find.node
  }), /*#__PURE__*/React.createElement(IncrementDecrementModal, {
    open: openIncrementDecrementModal,
    onClose: handleCloseIncrementDecrementModal,
    onSuccess: function onSuccess() {
      handleCloseIncrementDecrementModal();
      loadData();
    },
    association: (_associations$find2 = associations.find(function (a) {
      return a.node.id === filters.association;
    })) === null || _associations$find2 === void 0 ? void 0 : _associations$find2.node,
    selectedIds: selectedIds
  }));
};

function ownKeys$p(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$p(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$p(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$p(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var BeneficiaryPaymentProcess = function BeneficiaryPaymentProcess() {
  var dispatch = useDispatch();
  // Generate years dynamically (previous year to 10 years back)
  var currentYear = new Date().getFullYear();
  var currentMonth = new Date().getMonth() + 1; // Months are 0-indexed
  var yearOptions = Array.from({
    length: 11
  }, function (_, i) {
    return currentYear - i;
  });
  var monthOptions = Array.from({
    length: 12
  }, function (_, i) {
    return i + 1;
  });
  var monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
  var modulesManager = useModulesManager();
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    loading = _useState2[0],
    setLoading = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    data = _useState4[0],
    setData = _useState4[1];
  var _useState5 = useState([]),
    _useState6 = _slicedToArray(_useState5, 2),
    selectedIds = _useState6[0],
    setSelectedIds = _useState6[1];
  var _useState7 = useState([]),
    _useState8 = _slicedToArray(_useState7, 2),
    factories = _useState8[0],
    setFactories = _useState8[1];
  var _useState9 = useState([]),
    _useState10 = _slicedToArray(_useState9, 2),
    associations = _useState10[0],
    setAssociations = _useState10[1];
  var _useState11 = useState({
      month: currentMonth,
      year: currentYear,
      factory: "",
      association: ""
    }),
    _useState12 = _slicedToArray(_useState11, 2),
    filters = _useState12[0],
    setFilters = _useState12[1];
  var _useState13 = useState(false),
    _useState14 = _slicedToArray(_useState13, 2),
    openModal = _useState14[0],
    setOpenModal = _useState14[1];
  var _useState15 = useState(null),
    _useState16 = _slicedToArray(_useState15, 2),
    selectedBeneficiary = _useState16[0],
    setSelectedBeneficiary = _useState16[1];
  function extractYearMonth(date) {
    var d = new Date(date);
    return {
      year: d.getFullYear(),
      month: d.getMonth() + 1
    };
  }
  var handleCloseModal = function handleCloseModal() {
    setOpenModal(false);
    setSelectedBeneficiary(null);
  };
  var loadData = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _safeDecodeId, _safeDecodeId2, _processRes$payload, _yield$Promise$all, _yield$Promise$all2, processRes;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            setLoading(true);
            _context.prev = 1;
            dispatch(fetchWorkforceFactoriesSummary(modulesManager, [])).then(function (res) {
              var _res$payload;
              return setFactories((res === null || res === void 0 || (_res$payload = res.payload) === null || _res$payload === void 0 || (_res$payload = _res$payload.data) === null || _res$payload === void 0 || (_res$payload = _res$payload.workforceEmployerFactories) === null || _res$payload === void 0 ? void 0 : _res$payload.edges) || []);
            });
            dispatch(fetchWorkforceAllAssociationSummary([])).then(function (res) {
              var _res$payload2;
              return setAssociations((res === null || res === void 0 || (_res$payload2 = res.payload) === null || _res$payload2 === void 0 || (_res$payload2 = _res$payload2.data) === null || _res$payload2 === void 0 || (_res$payload2 = _res$payload2.workforceAllAssociation) === null || _res$payload2 === void 0 ? void 0 : _res$payload2.edges) || []);
            });
            _context.next = 6;
            return Promise.all([dispatch(fetchEisPaymentProcessWithoutFilters({
              month: filters.month,
              year: filters.year,
              workforceFactoryId: (_safeDecodeId = safeDecodeId(filters.factory)) !== null && _safeDecodeId !== void 0 ? _safeDecodeId : "",
              allAssociationId: (_safeDecodeId2 = safeDecodeId(filters.association)) !== null && _safeDecodeId2 !== void 0 ? _safeDecodeId2 : "",
              status: "active",
              // beneficiaryStatus: "eligible",
              approved: "yes",
              notInStage: "yes"
            }, modulesManager))]);
          case 6:
            _yield$Promise$all = _context.sent;
            _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 1);
            processRes = _yield$Promise$all2[0];
            setData((processRes === null || processRes === void 0 || (_processRes$payload = processRes.payload) === null || _processRes$payload === void 0 || (_processRes$payload = _processRes$payload.data) === null || _processRes$payload === void 0 ? void 0 : _processRes$payload.workforceEisPaymentProcess) || []);
            _context.next = 15;
            break;
          case 12:
            _context.prev = 12;
            _context.t0 = _context["catch"](1);
            console.error("Data Load Error:", _context.t0);
          case 15:
            _context.prev = 15;
            setLoading(false);
            return _context.finish(15);
          case 18:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[1, 12, 15, 18]]);
    }));
    return function loadData() {
      return _ref.apply(this, arguments);
    };
  }();
  useEffect(function () {
    loadData();
  }, [dispatch, modulesManager]);
  var handleFilterChange = function handleFilterChange(e) {
    var _e$target = e.target,
      name = _e$target.name,
      value = _e$target.value;
    setFilters(function (prev) {
      return _objectSpread$p(_objectSpread$p({}, prev), {}, _defineProperty({}, name, value));
    });
  };
  var clearFilters = function clearFilters() {
    setFilters({
      month: currentMonth,
      year: currentYear,
      factory: "",
      association: ""
    });
  };
  var getStatusChip = function getStatusChip(row) {
    if ((row === null || row === void 0 ? void 0 : row.beneficiaryStatus) === "eligible") return /*#__PURE__*/React.createElement(Chip, {
      label: "Eligible",
      size: "small",
      style: {
        backgroundColor: '#e8f5e9',
        color: '#2e7d32'
      }
    });
    if ((row === null || row === void 0 ? void 0 : row.beneficiaryStatus) === "closed") return /*#__PURE__*/React.createElement(Chip, {
      label: "Closed",
      size: "small",
      style: {
        backgroundColor: '#f5e8e8ff',
        color: '#7d2e2eff'
      }
    });
    if ((row === null || row === void 0 ? void 0 : row.beneficiaryStatus) === "hold") return /*#__PURE__*/React.createElement(Chip, {
      label: "On Hold",
      size: "small",
      style: {
        backgroundColor: '#f5f4e8ff',
        color: '#787d2eff'
      }
    });
    return /*#__PURE__*/React.createElement(Chip, {
      label: row === null || row === void 0 ? void 0 : row.beneficiaryStatus,
      size: "small",
      variant: "outlined"
    });
  };
  var handleRowSelect = function handleRowSelect(id) {
    setSelectedIds(function (prev) {
      return prev.includes(id) ? prev.filter(function (x) {
        return x !== id;
      }) : [].concat(_toConsumableArray(prev), [id]);
    });
  };
  var handleSelectAll = function handleSelectAll(checked) {
    if (checked) {
      setSelectedIds(data.map(function (row) {
        return row.id;
      }));
    } else {
      setSelectedIds([]);
    }
  };
  var handleApprove = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(ids) {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            if (ids !== null && ids !== void 0 && ids.length) {
              _context2.next = 2;
              break;
            }
            return _context2.abrupt("return");
          case 2:
            console.log("Approving IDs:", ids);
            console.log("month IDs:", filters.month);
            console.log("year IDs:", filters.year);
            _context2.next = 7;
            return dispatch(createWorkforceEisPaymentStage(ids, filters.month, filters.year));
          case 7:
            loadData();
          case 8:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function handleApprove(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  return /*#__PURE__*/React.createElement(Box$1, {
    bgcolor: "#fafafa",
    minHeight: "100vh"
  }, /*#__PURE__*/React.createElement(Box$1, {
    mb: 2,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-end"
  }, /*#__PURE__*/React.createElement(Box$1, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5",
    style: {
      fontWeight: 700,
      marginBottom: 4
    }
  }, "Beneficiary Payment Processing"), /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    color: "textSecondary"
  }, "Beneficiary payment processing, and related details."))), /*#__PURE__*/React.createElement(Paper, {
    elevation: 0,
    style: {
      padding: '24px',
      marginBottom: '24px',
      borderRadius: '12px',
      border: '1px solid #eceff1'
    }
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 3,
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 6,
    md: 3
  }, /*#__PURE__*/React.createElement(TextField, {
    fullWidth: true,
    select: true,
    label: "Factory",
    name: "factory",
    variant: "outlined",
    size: "small",
    value: filters.factory,
    onChange: handleFilterChange,
    disabled: loading
  }, /*#__PURE__*/React.createElement(MenuItem, {
    value: ""
  }, /*#__PURE__*/React.createElement("em", null, "All Factories")), factories.map(function (f) {
    return /*#__PURE__*/React.createElement(MenuItem, {
      key: f.node.id,
      value: f.node.id
    }, f.node.nameBn || f.node.nameEn);
  }))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 6,
    md: 3
  }, /*#__PURE__*/React.createElement(TextField, {
    fullWidth: true,
    select: true,
    label: "Association",
    name: "association",
    variant: "outlined",
    size: "small",
    value: filters.association,
    onChange: handleFilterChange,
    disabled: loading
  }, /*#__PURE__*/React.createElement(MenuItem, {
    value: ""
  }, /*#__PURE__*/React.createElement("em", null, "All Associations")), associations.map(function (a) {
    return /*#__PURE__*/React.createElement(MenuItem, {
      key: a.node.id,
      value: a.node.id
    }, a.node.shortNameBn || a.node.nameEn);
  }))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 6,
    md: 3
  }, /*#__PURE__*/React.createElement(TextField, {
    fullWidth: true,
    select: true,
    label: "Month",
    name: "month",
    variant: "outlined",
    size: "small",
    value: filters.month || currentMonth,
    onChange: handleFilterChange,
    disabled: loading
  }, /*#__PURE__*/React.createElement(MenuItem, {
    value: ""
  }, /*#__PURE__*/React.createElement("em", null, "All Months")), monthOptions.map(function (month) {
    return /*#__PURE__*/React.createElement(MenuItem, {
      key: month,
      value: month
    }, monthNames[month - 1]);
  }))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 6,
    md: 3
  }, /*#__PURE__*/React.createElement(TextField, {
    fullWidth: true,
    select: true,
    label: "Year",
    name: "year",
    variant: "outlined",
    size: "small",
    value: filters.year || currentYear,
    onChange: handleFilterChange,
    disabled: loading
  }, yearOptions.map(function (year) {
    return /*#__PURE__*/React.createElement(MenuItem, {
      key: year,
      value: year
    }, year);
  }))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 2
  }, /*#__PURE__*/React.createElement(Box$1, {
    display: "flex",
    gap: "8px"
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: loadData,
    fullWidth: true,
    variant: "contained",
    color: "primary",
    startIcon: /*#__PURE__*/React.createElement(SearchIcon, null)
  }, "Search"), /*#__PURE__*/React.createElement(Button, {
    onClick: clearFilters,
    fullWidth: true,
    variant: "text",
    color: "default",
    startIcon: /*#__PURE__*/React.createElement(ClearAllIcon, null)
  }, "Reset"))))), loading ? /*#__PURE__*/React.createElement(Box$1, {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "200px"
  }, /*#__PURE__*/React.createElement(CircularProgress$1, null)) : /*#__PURE__*/React.createElement(TableContainer, {
    component: Paper,
    elevation: 0,
    style: {
      borderRadius: '12px',
      border: '1px solid #e0e0e0'
    }
  }, /*#__PURE__*/React.createElement(Table$2, null, /*#__PURE__*/React.createElement(TableHead, {
    style: {
      backgroundColor: '#f8fafd'
    }
  }, /*#__PURE__*/React.createElement(TableRow, null, /*#__PURE__*/React.createElement(TableCell, {
    padding: "checkbox",
    align: "center"
  }, /*#__PURE__*/React.createElement("input", {
    type: "checkbox",
    checked: selectedIds.length === data.length && data.length > 0,
    onChange: function onChange(e) {
      return handleSelectAll(e.target.checked);
    }
  })), /*#__PURE__*/React.createElement(TableCell, {
    style: {
      fontWeight: 600
    }
  }, "Beneficiary Details"), /*#__PURE__*/React.createElement(TableCell, {
    style: {
      fontWeight: 600
    }
  }, "Worker, Factory & Association"), /*#__PURE__*/React.createElement(TableCell, {
    style: {
      fontWeight: 600
    }
  }, "Payment Method"), /*#__PURE__*/React.createElement(TableCell, {
    align: "right",
    style: {
      fontWeight: 600
    }
  }, "Amounts"), /*#__PURE__*/React.createElement(TableCell, {
    align: "right",
    style: {
      fontWeight: 600
    }
  }, "This Month Payable"), /*#__PURE__*/React.createElement(TableCell, {
    align: "center",
    style: {
      fontWeight: 600
    }
  }, "Status"), /*#__PURE__*/React.createElement(TableCell, {
    align: "center",
    style: {
      fontWeight: 600
    }
  }, "Action"))), /*#__PURE__*/React.createElement(TableBody, null, data.map(function (row) {
    var _row$workforceEmploye, _row$workforceApplica, _row$workforceApplica2, _safeParse, _row$workforceApplica3, _row$workforceApplica4, _row$workforceApplica5, _row$workforceApplica6, _row$workforceApplica7, _row$workforceApplica8, _row$workforceApplica9, _row$bank, _row$bank2, _row$bank3, _row$bank4, _row$bank5, _Number$toLocaleStrin, _Number$toLocaleStrin2;
    var dep = (row === null || row === void 0 || (_row$workforceEmploye = row.workforceEmployeeDependent) === null || _row$workforceEmploye === void 0 ? void 0 : _row$workforceEmploye[0]) || {};
    var worker = (row === null || row === void 0 || (_row$workforceApplica = row.workforceApplication) === null || _row$workforceApplica === void 0 ? void 0 : _row$workforceApplica.applicationType) === "financialAssistance" || (row === null || row === void 0 || (_row$workforceApplica2 = row.workforceApplication) === null || _row$workforceApplica2 === void 0 ? void 0 : _row$workforceApplica2.applicationType) === "deadlyGrant" ? (_safeParse = safeParse(row === null || row === void 0 || (_row$workforceApplica3 = row.workforceApplication) === null || _row$workforceApplica3 === void 0 ? void 0 : _row$workforceApplica3.deceasedWorkerInfo)) === null || _safeParse === void 0 ? void 0 : _safeParse.nameEn : row === null || row === void 0 || (_row$workforceApplica4 = row.workforceApplication) === null || _row$workforceApplica4 === void 0 || (_row$workforceApplica4 = _row$workforceApplica4.workforceEmployee) === null || _row$workforceApplica4 === void 0 ? void 0 : _row$workforceApplica4.firstNameEn;
    var incrementMonth = row !== null && row !== void 0 && row.incrementDate ? extractYearMonth(row === null || row === void 0 ? void 0 : row.incrementDate) : null;
    var decrementMonth = row !== null && row !== void 0 && row.decrementDate ? extractYearMonth(row === null || row === void 0 ? void 0 : row.decrementDate) : null;
    var incrementYearMonth = 0;
    var decrementYearMonth = 0;
    var payableAmount = Number(row === null || row === void 0 ? void 0 : row.payableAmount);
    var filterYearMonth = Number(filters.year.toString() + filters.month.toString().padStart(2, '0'));
    if (incrementMonth !== null) {
      incrementYearMonth = Number(incrementMonth.year.toString() + incrementMonth.month.toString().padStart(2, '0'));
    }
    if (decrementMonth !== null) {
      decrementYearMonth = Number(decrementMonth.year.toString() + decrementMonth.month.toString().padStart(2, '0'));
    }
    if (incrementYearMonth > 0 || decrementYearMonth > 0) {
      console.log("incrementMonth", incrementYearMonth);
      console.log("decrementMonth", decrementYearMonth);
      console.log("filterYearMonth", filterYearMonth);
    }
    if (filterYearMonth < incrementYearMonth) {
      payableAmount -= Number(row === null || row === void 0 ? void 0 : row.incrementAmount);
    }
    if (filterYearMonth < decrementYearMonth) {
      payableAmount += Number(row === null || row === void 0 ? void 0 : row.decrementAmount);
    }
    return /*#__PURE__*/React.createElement(TableRow, {
      key: row.id,
      hover: true
    }, /*#__PURE__*/React.createElement(TableCell, {
      padding: "checkbox",
      align: "center"
    }, /*#__PURE__*/React.createElement("input", {
      type: "checkbox",
      checked: selectedIds.includes(row.id),
      onChange: function onChange() {
        return handleRowSelect(row.id);
      }
    })), /*#__PURE__*/React.createElement(TableCell, null, /*#__PURE__*/React.createElement(Typography, {
      variant: "subtitle2",
      style: {
        fontWeight: 600
      }
    }, (dep === null || dep === void 0 ? void 0 : dep.nameEn) || (dep === null || dep === void 0 ? void 0 : dep.nameBn) || (row === null || row === void 0 || (_row$workforceApplica5 = row.workforceApplication) === null || _row$workforceApplica5 === void 0 || (_row$workforceApplica5 = _row$workforceApplica5.workforceEmployee) === null || _row$workforceApplica5 === void 0 ? void 0 : _row$workforceApplica5.firstNameEn) || "—"), /*#__PURE__*/React.createElement(Typography, {
      variant: "caption",
      color: "primary"
    }, getRelationString(dep)), /*#__PURE__*/React.createElement(Box$1, {
      mt: 0.5,
      mb: 0.5
    }, /*#__PURE__*/React.createElement(Chip, {
      label: row.beneficiaryId,
      variant: "outlined",
      style: {
        height: 20
      }
    })), /*#__PURE__*/React.createElement(Typography, {
      variant: "caption",
      display: "block",
      color: "textSecondary"
    }, "ATN: " + (row === null || row === void 0 || (_row$workforceApplica6 = row.workforceApplication) === null || _row$workforceApplica6 === void 0 ? void 0 : _row$workforceApplica6.trackingNumber) || "N/A")), /*#__PURE__*/React.createElement(TableCell, null, /*#__PURE__*/React.createElement(Typography, {
      variant: "body2",
      style: {
        fontWeight: 500
      }
    }, worker), /*#__PURE__*/React.createElement(Typography, {
      variant: "caption",
      display: "block",
      color: "textSecondary"
    }, row === null || row === void 0 || (_row$workforceApplica7 = row.workforceApplication) === null || _row$workforceApplica7 === void 0 || (_row$workforceApplica7 = _row$workforceApplica7.employeeFactory) === null || _row$workforceApplica7 === void 0 ? void 0 : _row$workforceApplica7.nameEn), /*#__PURE__*/React.createElement(Typography, {
      variant: "caption",
      display: "block",
      color: "textSecondary"
    }, (row === null || row === void 0 || (_row$workforceApplica8 = row.workforceApplication) === null || _row$workforceApplica8 === void 0 || (_row$workforceApplica8 = _row$workforceApplica8.employeeFactory) === null || _row$workforceApplica8 === void 0 || (_row$workforceApplica8 = _row$workforceApplica8.allAssociation) === null || _row$workforceApplica8 === void 0 ? void 0 : _row$workforceApplica8.shortNameEn) || (row === null || row === void 0 || (_row$workforceApplica9 = row.workforceApplication) === null || _row$workforceApplica9 === void 0 || (_row$workforceApplica9 = _row$workforceApplica9.employeeFactory) === null || _row$workforceApplica9 === void 0 || (_row$workforceApplica9 = _row$workforceApplica9.allAssociation) === null || _row$workforceApplica9 === void 0 ? void 0 : _row$workforceApplica9.nameEn) || "N/A")), /*#__PURE__*/React.createElement(TableCell, null, /*#__PURE__*/React.createElement(Typography, {
      variant: "body2"
    }, ((_row$bank = row.bank) === null || _row$bank === void 0 || (_row$bank = _row$bank.parent) === null || _row$bank === void 0 ? void 0 : _row$bank.nameEn) || "N/A"), /*#__PURE__*/React.createElement(Typography, {
      variant: "body2"
    }, ((_row$bank2 = row.bank) === null || _row$bank2 === void 0 ? void 0 : _row$bank2.nameEn) + " (Routing #" + ((row === null || row === void 0 || (_row$bank3 = row.bank) === null || _row$bank3 === void 0 ? void 0 : _row$bank3.routingNumber) == '0' || (row === null || row === void 0 || (_row$bank4 = row.bank) === null || _row$bank4 === void 0 ? void 0 : _row$bank4.routingNumber) == null ? row === null || row === void 0 ? void 0 : row.routingNumber : row === null || row === void 0 || (_row$bank5 = row.bank) === null || _row$bank5 === void 0 ? void 0 : _row$bank5.routingNumber) + ")" || "N/A"), /*#__PURE__*/React.createElement(Typography, {
      variant: "caption",
      color: "textSecondary"
    }, "A/C: " + row.bankAccountNo)), /*#__PURE__*/React.createElement(TableCell, {
      align: "right"
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "body2",
      style: {
        fontWeight: 700
      }
    }, (_Number$toLocaleStrin = Number(payableAmount).toLocaleString("en-BD")) !== null && _Number$toLocaleStrin !== void 0 ? _Number$toLocaleStrin : Number(payableAmount).toLocaleString("en-BD")), /*#__PURE__*/React.createElement(Typography, {
      variant: "caption",
      color: "textSecondary"
    }, "Total: " + ((_Number$toLocaleStrin2 = Number(row === null || row === void 0 ? void 0 : row.eisApprovedAmount).toLocaleString("en-BD")) !== null && _Number$toLocaleStrin2 !== void 0 ? _Number$toLocaleStrin2 : "--")), /*#__PURE__*/React.createElement(Typography, {
      variant: "body2",
      style: {
        fontWeight: 700
      }
    }, getPaymentTypeString(row.eisPaymentType))), /*#__PURE__*/React.createElement(TableCell, {
      align: "right"
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "body2",
      style: {
        fontWeight: 700
      }
    }, Number(row === null || row === void 0 ? void 0 : row.arrearPaymentMonth) === Number(filters.month) - 1 && Number(row === null || row === void 0 ? void 0 : row.arrearPaymentYear) === Number(filters.year) ? (Number(payableAmount) + Number(row === null || row === void 0 ? void 0 : row.arrearAmount)).toLocaleString("en-BD") : Number(payableAmount).toLocaleString("en-BD")), Number(row === null || row === void 0 ? void 0 : row.arrearPaymentMonth) === Number(filters.month) - 1 && Number(row === null || row === void 0 ? void 0 : row.arrearPaymentYear) === Number(filters.year) ? /*#__PURE__*/React.createElement(Typography, {
      variant: "caption",
      color: "textSecondary"
    }, "Includes increments of previous months of amount:" + Number(row === null || row === void 0 ? void 0 : row.arrearAmount).toLocaleString("en-BD")) : /*#__PURE__*/React.createElement(Typography, {
      variant: "caption",
      color: "textSecondary"
    }, "Payable for selected Month")), /*#__PURE__*/React.createElement(TableCell, {
      align: "center"
    }, getStatusChip(row), (row === null || row === void 0 ? void 0 : row.beneficiaryStatus) === "hold" && /*#__PURE__*/React.createElement(Typography, {
      variant: "caption",
      color: "success"
    }, "Payment on hold From " + (row === null || row === void 0 ? void 0 : row.lastLiveCheckDate)), (row === null || row === void 0 ? void 0 : row.beneficiaryStatus) === "closed" && /*#__PURE__*/React.createElement(Typography, {
      variant: "caption",
      color: "success"
    }, "Payment closed From " + (row === null || row === void 0 ? void 0 : row.remarriageOrDeathDate))), /*#__PURE__*/React.createElement(TableCell, {
      align: "center"
    }, /*#__PURE__*/React.createElement(Button, {
      variant: "outlined",
      size: "small",
      onClick: function onClick() {
        return handleApprove([row.id]);
      },
      style: {
        marginLeft: 6
      }
    }, "Process")));
  }))), data.length === 0 && /*#__PURE__*/React.createElement(Box$1, {
    p: 5,
    textAlign: "center"
  }, /*#__PURE__*/React.createElement(Typography, {
    color: "textSecondary"
  }, "No data found matching current filters."))), /*#__PURE__*/React.createElement(Box$1, {
    mt: 2,
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    gap: "8px"
  }, selectedIds.length > 0 && /*#__PURE__*/React.createElement(Button, {
    variant: "contained",
    color: "primary",
    disabled: !selectedIds.length,
    onClick: function onClick() {
      return handleApprove(selectedIds);
    }
  }, "Approve Selected")), /*#__PURE__*/React.createElement(BeneficiaryManageModal, {
    open: openModal,
    onClose: handleCloseModal,
    onSuccess: function onSuccess() {
      handleCloseModal();
      loadData(); // Re-fetch table data after modal action
    },
    beneficiary: selectedBeneficiary
  }));
};

var generateTopText = function generateTopText() {
  var printYear = new Date().getFullYear();
  var printMonth = new Date().getMonth();
  var excelmonthFormatted = String(printMonth + 1).padStart(2, "0");
  var excelyear = printYear;
  return "\n    <p style=\"text-align: right;\">Ref No: EIS.Bank Advice.Benefit.".concat(excelyear, ".").concat(excelmonthFormatted, "</p>\n    <p><strong>Manager</strong></p>\n    <p>Sonali Bank Limited</p>\n    <p>Ramna Corporate Branch</p>\n    <p>1, Topkhana Road, Ramna, Dhaka, 1000</p>\n    <p><br></p>\n    <p><strong><u>Subject: Bank Advice Letter (EIS Top-up Benefit)</u></strong></p>\n    <p><br></p>\n    <p>Dear Sir:</p>\n    <p>Greetings from EIS Pilot!</p>\n    <p>EIS Pilot top-up benefits are required to be disbursed to the beneficiaries through bank transfer from your branch of EIS Pilot bank account, <strong>Account Title: EMPLOYMENT INJURY SCHEME EIS</strong>, <strong>Account Number: 4426302003729</strong>. The validated list of account holders with their respective Account Titles, Bank Account Numbers, Bank Names, Branch info, Routing Numbers including Payment amounts have been mentioned below.</p>\n  ");
};
var generateBottomText = function generateBottomText() {
  return "\n    <p>Your prompt necessary steps in this matter will be highly appreciated.</p>\n    <p><br></p>\n    <p>With warm regards</p>\n    <p><br></p>\n    <p><strong>Director General,</strong></p>\n    <p>Central Fund, Ministry of Labor and Employment &amp;</p>\n    <p>Member Secretary, EIS Pilot Governance Board</p>\n    <p>Bangladesh Secretariat, Dhaka-1000</p>\n    <p><br></p>\n    <p>Copy to (Not in order of seniority):</p>\n    <p style=\"margin-left: 20px;\">1. PS to State Minister, Ministry of Labour and Employment, Bangladesh Secretariat, Dhaka-1000.</p>\n    <p style=\"margin-left: 20px;\">2. PS to Secretary, Ministry of Labour and Employment, Bangladesh Secretariat, Dhaka-1000.</p>\n    <p style=\"margin-left: 20px;\">3. Special Advisor, EIS Pilot Special Unit, 196, Sromo Bhaban (9th Floor), Bijoynagar, Dhaka-1000.</p>\n    <p style=\"margin-left: 20px;\">4. PA to Director General, Central Fund, Bangladesh Secretariat, Dhaka-1000.</p>\n    <p style=\"margin-left: 20px;\">5. Assistant Director, Welfare-2 and Development, Central Fund, Bangladesh Secretariat, Dhaka-1000.</p>\n    <p style=\"margin-left: 20px;\">6. Assistant Director, Finance Department, Central Fund, Bangladesh Secretariat, Dhaka-1000.</p>\n  ";
};
var generateEmptyTableHTML = function generateEmptyTableHTML() {
  return "<table style=\"width: 100%; border-collapse: collapse; margin: 20px 0; border: 1px solid #000;\">\n   <thead>\n     <tr style=\"background-color: #92D050;\">\n       <th style=\"border: 1px solid #000; padding: 8px; text-align: center; font-weight: bold;\">SL</th>\n       <th style=\"border: 1px solid #000; padding: 8px; text-align: center; font-weight: bold;\">Account Title</th>\n       <th style=\"border: 1px solid #000; padding: 8px; text-align: center; font-weight: bold;\">Account No</th>\n       <th style=\"border: 1px solid #000; padding: 8px; text-align: center; font-weight: bold;\">Bank</th>\n       <th style=\"border: 1px solid #000; padding: 8px; text-align: center; font-weight: bold;\">Branch</th>\n       <th style=\"border: 1px solid #000; padding: 8px; text-align: center; font-weight: bold;\">District</th>\n       <th style=\"border: 1px solid #000; padding: 8px; text-align: center; font-weight: bold;\">Routing</th>\n       <th style=\"border: 1px solid #000; padding: 8px; text-align: center; font-weight: bold;\">Amount</th>\n       <th style=\"border: 1px solid #000; padding: 8px; text-align: center; font-weight: bold;\">Beneficiary ID</th>\n       <th style=\"border: 1px solid #000; padding: 8px; text-align: center; font-weight: bold;\">Pay From</th>\n       <th style=\"border: 1px solid #000; padding: 8px; text-align: center; font-weight: bold;\">Pay To</th>\n     </tr>\n   </thead>\n   <tbody>\n     <tr>\n       <td style=\"border: 1px solid #000; padding: 8px; text-align: center;\"></td>\n       <td style=\"border: 1px solid #000; padding: 8px;\"></td>\n       <td style=\"border: 1px solid #000; padding: 8px;\"></td>\n       <td style=\"border: 1px solid #000; padding: 8px;\"></td>\n       <td style=\"border: 1px solid #000; padding: 8px;\"></td>\n       <td style=\"border: 1px solid #000; padding: 8px;\"></td>\n       <td style=\"border: 1px solid #000; padding: 8px;\"></td>\n       <td style=\"border: 1px solid #000; padding: 8px;\"></td>\n       <td style=\"border: 1px solid #000; padding: 8px;\"></td>\n       <td style=\"border: 1px solid #000; padding: 8px;\"></td>\n       <td style=\"border: 1px solid #000; padding: 8px;\"></td>\n     </tr>\n   </tbody>\n </table>";
};
var generateBankAdviceTemplate = function generateBankAdviceTemplate() {
  var topText = generateTopText();
  var emptyTable = generateEmptyTableHTML();
  var totalHTML = "<p style=\"text-align: right; font-weight: bold;\">Total Amount (BDT): <span id=\"total-amount\">0.00</span></p>";
  var bottomText = generateBottomText();
  return "\n    ".concat(topText, "\n    ").concat(emptyTable, "\n    ").concat(totalHTML, "\n    ").concat(bottomText, "\n  ");
};

var useStyles$n = makeStyles(function (theme) {
  return {
    noPrint: {
      '@media print': {
        display: 'none !important'
      }
    },
    dialogPaper: {
      minWidth: "90vw",
      "@media print": {
        boxShadow: "none",
        border: "none",
        minWidth: "100%",
        margin: 0,
        maxWidth: "100% !important"
      }
    },
    dialogContent: {
      backgroundColor: "#fff",
      padding: theme.spacing(4),
      "@media print": {
        padding: "8px !important",
        overflow: "visible !important"
      }
    },
    "@global": {
      "@media print": {
        "body *": {
          visibility: "hidden"
        },
        "#printable-content, #printable-content *": {
          visibility: "visible"
        },
        "#printable-content": {
          position: "absolute",
          left: 0,
          top: 0,
          width: "100%",
          maxWidth: "100%",
          margin: 0,
          padding: 0
        },
        "html, body": {
          height: "100%",
          overflow: "hidden",
          margin: 0,
          padding: 0
        },
        // Force the table to fit the page width in portrait
        "table": {
          width: "100% !important",
          tableLayout: "fixed !important",
          // critical
          fontSize: "9px !important",
          // smaller font so columns fit
          borderCollapse: "collapse"
        },
        "th, td": {
          padding: "3px 4px !important",
          wordWrap: "break-word",
          overflowWrap: "break-word",
          whiteSpace: "normal",
          fontSize: "9px !important"
        }
      }
    }
  };
});
var GenerateBeneficiaryAdvice = function GenerateBeneficiaryAdvice(_ref) {
  var _paymentData$2, _eisPayments$, _eisPayments$2;
  var open = _ref.open,
    onClose = _ref.onClose,
    paymentData = _ref.paymentData,
    month = _ref.month,
    year = _ref.year,
    _ref$fromAdviceList = _ref.fromAdviceList,
    fromAdviceList = _ref$fromAdviceList === void 0 ? false : _ref$fromAdviceList,
    committeeId = _ref.committeeId;
  var dispatch = useDispatch();
  useModulesManager();
  var classes = useStyles$n();
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    eisPayments = _useState2[0],
    setEisPayments = _useState2[1];
  var _useState3 = useState(""),
    _useState4 = _slicedToArray(_useState3, 2),
    topHtml = _useState4[0],
    setTopHtml = _useState4[1];
  var _useState5 = useState(""),
    _useState6 = _slicedToArray(_useState5, 2);
    _useState6[0];
    _useState6[1];
  var _useState7 = useState(""),
    _useState8 = _slicedToArray(_useState7, 2),
    rawTemplate = _useState8[0],
    setRawTemplate = _useState8[1];
  function getTotalAmount() {
    return eisPayments.reduce(function (sum, item) {
      return sum + (parseFloat(item.paidAmount) || 0);
    }, 0).toFixed(2);
  }
  useEffect(function () {
    var loadData = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              // Only update if paymentData actually changed (deep compare)
              if (JSON.stringify(paymentData) !== JSON.stringify(eisPayments)) {
                setEisPayments(paymentData);
              }
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function loadData() {
        return _ref2.apply(this, arguments);
      };
    }();
    loadData();
  }, [open, paymentData]);

  // Derive stable committeeId from paymentData to avoid unnecessary effect triggers
  var derivedCommitteeId = React.useMemo(function () {
    var _paymentData$;
    return paymentData === null || paymentData === void 0 || (_paymentData$ = paymentData[0]) === null || _paymentData$ === void 0 || (_paymentData$ = _paymentData$.workforceApplication) === null || _paymentData$ === void 0 ? void 0 : _paymentData$.committeeId;
  }, [paymentData === null || paymentData === void 0 || (_paymentData$2 = paymentData[0]) === null || _paymentData$2 === void 0 || (_paymentData$2 = _paymentData$2.workforceApplication) === null || _paymentData$2 === void 0 ? void 0 : _paymentData$2.committeeId]);
  var effectiveCommitteeId = committeeId || derivedCommitteeId;
  useEffect(function () {
    if (open && effectiveCommitteeId) {
      dispatch(fetchCommitteeBankAdviceMap(["committeeId:\"".concat(effectiveCommitteeId, "\"")])).then(function (response) {
        var _response$payload, _parsedData$;
        var parsedData = parseData(response === null || response === void 0 || (_response$payload = response.payload) === null || _response$payload === void 0 || (_response$payload = _response$payload.data) === null || _response$payload === void 0 ? void 0 : _response$payload.workforceCommitteeBankAdviceMaps);
        var templateString = Array.isArray(parsedData) ? (_parsedData$ = parsedData[0]) === null || _parsedData$ === void 0 ? void 0 : _parsedData$.adviceTemplate : parsedData === null || parsedData === void 0 ? void 0 : parsedData.adviceTemplate;
        if (typeof templateString === "string") {
          setRawTemplate(templateString);
        } else {
          setRawTemplate("");
        }
      });
    } else {
      setRawTemplate("");
    }
  }, [open, effectiveCommitteeId, dispatch]);

  // Use refs to track previous values and prevent infinite loops
  var prevRawTemplateRef = useRef('');
  var prevEisPaymentsRef = useRef([]);
  useEffect(function () {
    // Case 1: We have a template but no payment data yet - just display the template
    if (rawTemplate && eisPayments.length === 0) {
      if (topHtml !== rawTemplate) {
        setTopHtml(rawTemplate);
      }
      return;
    }

    // Case 2: We have both template and payment data - merge them
    if (rawTemplate && eisPayments.length > 0) {
      // Guard: skip if rawTemplate and eisPayments content haven't changed
      if (rawTemplate === prevRawTemplateRef.current && JSON.stringify(eisPayments) === JSON.stringify(prevEisPaymentsRef.current)) {
        return;
      }
      prevRawTemplateRef.current = rawTemplate;
      prevEisPaymentsRef.current = eisPayments;
      var modifiedTemplate = rawTemplate;

      // Generate data rows
      var dataRowsHTML = '';
      eisPayments.forEach(function (row, index) {
        var _row$bank, _row$bank2, _row$bank3, _row$bank4, _row$bank5, _row$bank6, _row$paidAmount;
        var rowYear = (row === null || row === void 0 ? void 0 : row.year) || "";
        var monthIndex = (row === null || row === void 0 ? void 0 : row.monthIndex) || "";
        var monthFormatted = String(monthIndex).padStart(2, "0");
        var lastDay = new Date(rowYear, monthIndex, 0).getDate();
        var printPayFrom = row !== null && row !== void 0 && row.payFromDate ? new Date(row === null || row === void 0 ? void 0 : row.payFromDate).toLocaleDateString("en-GB") : "01.".concat(monthFormatted, ".").concat(rowYear);
        var printPayTo = row !== null && row !== void 0 && row.payToDate ? new Date(row === null || row === void 0 ? void 0 : row.payToDate).toLocaleDateString("en-GB") : "".concat(lastDay, ".").concat(monthFormatted, ".").concat(rowYear);
        var paymentRows = "";
        if ((row === null || row === void 0 ? void 0 : row.eisPaymentType) == 'installment') {
          paymentRows = "<td style=\"border: 1px solid #000; padding: 3px 4px; text-align: right;\" colspan=\"2\">".concat(getOrdinalNumber(row === null || row === void 0 ? void 0 : row.installmentNumber), " Installment</td>");
        } else if ((row === null || row === void 0 ? void 0 : row.eisPaymentType) == 'onetime') {
          paymentRows = "<td style=\"border: 1px solid #000; padding: 3px 4px; text-align: right;\" colspan=\"2\">Lifetime</td>";
        } else {
          paymentRows = "<td style=\"border: 1px solid #000; padding: 3px 4px; text-align: right;\">".concat(printPayFrom, "</td>\n                      <td style=\"border: 1px solid #000; padding: 3px 4px; text-align: right;\">").concat(printPayTo, "</td>");
        }
        dataRowsHTML += "<tr>\n      <td style=\"border: 1px solid #000; padding: 3px 4px; text-align: center;\">".concat(index + 1, "</td>\n      <td style=\"border: 1px solid #000; padding: 3px 4px;\">").concat((row === null || row === void 0 ? void 0 : row.bankAccountHolderName) || "", "</td>\n      <td style=\"border: 1px solid #000; padding: 3px 4px;\">").concat((row === null || row === void 0 ? void 0 : row.bankAccountNo) || "", "</td>\n      <td style=\"border: 1px solid #000; padding: 3px 4px;\">").concat((row === null || row === void 0 || (_row$bank = row.bank) === null || _row$bank === void 0 || (_row$bank = _row$bank.parent) === null || _row$bank === void 0 ? void 0 : _row$bank.nameEn) || "", "</td>\n      <td style=\"border: 1px solid #000; padding: 3px 4px;\">").concat((row === null || row === void 0 || (_row$bank2 = row.bank) === null || _row$bank2 === void 0 ? void 0 : _row$bank2.nameEn) || "", "</td>\n      <td style=\"border: 1px solid #000; padding: 3px 4px;\">").concat((row === null || row === void 0 || (_row$bank3 = row.bank) === null || _row$bank3 === void 0 ? void 0 : _row$bank3.districtNameEn) || "", "</td>\n      <td style=\"border: 1px solid #000; padding: 3px 4px;\">").concat((((_row$bank4 = row.bank) === null || _row$bank4 === void 0 ? void 0 : _row$bank4.routingNumber) == '0' || (row === null || row === void 0 || (_row$bank5 = row.bank) === null || _row$bank5 === void 0 ? void 0 : _row$bank5.routingNumber) == null ? row === null || row === void 0 ? void 0 : row.routingNumber : (_row$bank6 = row.bank) === null || _row$bank6 === void 0 ? void 0 : _row$bank6.routingNumber) || "", "</td>\n      <td style=\"border: 1px solid #000; padding: 3px 4px; text-align: right;\">").concat(Number(row === null || row === void 0 || (_row$paidAmount = row.paidAmount) === null || _row$paidAmount === void 0 ? void 0 : _row$paidAmount.toFixed(2)) || "0.00", "</td>\n      <td style=\"border: 1px solid #000; padding: 3px 4px; text-align: right;\">").concat((row === null || row === void 0 ? void 0 : row.beneficiaryId) || "", "</td>\n      ").concat(paymentRows, "\n    </tr>");
      });
      var hasTable = modifiedTemplate.includes('<table');
      modifiedTemplate.includes('<tbody');
      if (hasTable) {
        var tbodyPattern = /<tbody>[\s\S]*?<\/tbody>/;
        if (modifiedTemplate.match(tbodyPattern)) {
          var newTbody = "<tbody>".concat(dataRowsHTML, "</tbody>");
          modifiedTemplate = modifiedTemplate.replace(tbodyPattern, newTbody);
        } else {
          var theadPattern = /(<thead>[\s\S]*?<\/thead>)/;
          if (modifiedTemplate.match(theadPattern)) {
            modifiedTemplate = modifiedTemplate.replace(theadPattern, function (match) {
              return match + "<tbody>".concat(dataRowsHTML, "</tbody>");
            });
          } else {
            var tablePattern = /(<table[\s\S]*?>)([\s\S]*?)(<\/table>)/;
            if (modifiedTemplate.match(tablePattern)) {
              modifiedTemplate = modifiedTemplate.replace(tablePattern, function (match, p1, p2, p3) {
                return "".concat(p1, "<tbody>").concat(dataRowsHTML, "</tbody>").concat(p3);
              });
            }
          }
        }
      } else {
        // Build full table
        var headerRow = "<tr style=\"background-color: #92D050;\">\n      <th style=\"border: 1px solid #000; padding: 3px 4px; text-align: center; font-weight: bold;\">SL</th>\n      <th style=\"border: 1px solid #000; padding: 3px 4px; text-align: center; font-weight: bold;\">Account Title</th>\n      <th style=\"border: 1px solid #000; padding: 3px 4px; text-align: center; font-weight: bold;\">Account No</th>\n      <th style=\"border: 1px solid #000; padding: 3px 4px; text-align: center; font-weight: bold;\">Bank</th>\n      <th style=\"border: 1px solid #000; padding: 3px 4px; text-align: center; font-weight: bold;\">Branch</th>\n      <th style=\"border: 1px solid #000; padding: 3px 4px; text-align: center; font-weight: bold;\">District</th>\n      <th style=\"border: 1px solid #000; padding: 3px 4px; text-align: center; font-weight: bold;\">Routing</th>\n      <th style=\"border: 1px solid #000; padding: 3px 4px; text-align: center; font-weight: bold;\">Amount</th>\n      <th style=\"border: 1px solid #000; padding: 3px 4px; text-align: center; font-weight: bold;\">Beneficiary ID</th>\n      <th style=\"border: 1px solid #000; padding: 3px 4px; text-align: center; font-weight: bold;\">Pay From</th>\n      <th style=\"border: 1px solid #000; padding: 3px 4px; text-align: center; font-weight: bold;\">Pay To</th>\n    </tr>";
        var fullTable = "<table style=\"width: 100%; table-layout: fixed; border-collapse: collapse; margin: 10px 0; border: 1px solid #000; font-size: 9px;\">\n          <thead>".concat(headerRow, "</thead>\n          <tbody>").concat(dataRowsHTML, "</tbody>\n        </table>");

        // Insert table after the total amount paragraph (after </p> that follows "Total Amount")
        var totalAmountParaPattern = /(<p[^>]*>[\s\S]*?Total Amount[\s\S]*?<\/p>)/i;
        if (totalAmountParaPattern.test(modifiedTemplate)) {
          modifiedTemplate = modifiedTemplate.replace(totalAmountParaPattern, '$1\n' + fullTable);
        } else {
          // Fallback: insert at end
          modifiedTemplate = modifiedTemplate + fullTable;
        }
      }

      // First, update the total amount value
      // Try to replace inside <span id="total-amount">...</span>
      var totalSpanPattern = /<span id="total-amount">[\d.,]*<\/span>/;
      var newTotalSpan = "<span id=\"total-amount\">".concat(getTotalAmount(), "</span>");
      if (totalSpanPattern.test(modifiedTemplate)) {
        modifiedTemplate = modifiedTemplate.replace(totalSpanPattern, newTotalSpan);
      } else {
        // Fallback: replace number after "Total Amount (BDT):" text
        var totalTextPattern = /(Total Amount\s*\(BDT\):\s*)([\d.,]+)/i;
        if (totalTextPattern.test(modifiedTemplate)) {
          modifiedTemplate = modifiedTemplate.replace(totalTextPattern, "$1".concat(getTotalAmount()));
        }
      }
      setTopHtml(modifiedTemplate);
    }
  }, [rawTemplate, eisPayments, topHtml]);
  var adviceMonth = eisPayments.length > 0 ? (_eisPayments$ = eisPayments[0]) === null || _eisPayments$ === void 0 ? void 0 : _eisPayments$.monthIndex : 0;
  var adviceYear = eisPayments.length > 0 ? (_eisPayments$2 = eisPayments[0]) === null || _eisPayments$2 === void 0 ? void 0 : _eisPayments$2.year : 0;
  var printYear = new Date().getFullYear();
  var printMonth = adviceMonth === 0 ? new Date().getMonth() : adviceMonth;
  var excelmonthFormatted = String(adviceMonth > 0 ? adviceMonth : printMonth + 1).padStart(2, "0");
  var excelyear = adviceYear === 0 ? printYear : adviceYear;
  var exportToExcel = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var workbook, sheet, tableHeader, headerRow, firstDataRow, lastDataRow, i, row, closingLines, buffer, blob;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            workbook = new ExcelJS.Workbook();
            sheet = workbook.addWorksheet("Bank Advice", {});
            sheet.columns = [{
              width: 5
            }, {
              width: 20
            }, {
              width: 20
            }, {
              width: 20
            }, {
              width: 20
            }, {
              width: 20
            }, {
              width: 20
            }, {
              width: 20
            }, {
              width: 20
            }, {
              width: 15
            }, {
              width: 15
            }];
            sheet.mergeCells("A1:K1");
            sheet.getCell("A1").value = "Ref No: EIS.Bank Advice.Benefit.".concat(excelyear, ".").concat(excelmonthFormatted);
            sheet.getCell("A1").font = {
              bold: true
            };
            sheet.mergeCells("A3:K3");
            sheet.getCell("A3").value = "Manager";
            sheet.mergeCells("A4:K4");
            sheet.getCell("A4").value = "Sonali Bank Limited";
            sheet.mergeCells("A5:K5");
            sheet.getCell("A5").value = "Ramna Corporate Branch";
            sheet.mergeCells("A6:K6");
            sheet.getCell("A6").value = "1, Topkhana Road, Ramna, Dhaka, 1000";
            sheet.mergeCells("A8:K8");
            sheet.getCell("A8").value = "Subject: Bank Advice Letter (EIS Top-up Benefit)";
            sheet.getCell("A8").font = {
              bold: true,
              underline: true
            };
            sheet.mergeCells("A10:K10");
            sheet.getCell("A10").value = "Dear Sir:";
            sheet.mergeCells("A12:K12");
            sheet.getCell("A12").value = "Greetings from EIS Pilot!";
            sheet.mergeCells("A14:K14");
            sheet.getCell("A14").value = {
              richText: [{
                text: "EIS Pilot top-up benefits are required to be disbursed to the beneficiaries through bank transfer from your branch of EIS Pilot bank account,"
              }, {
                text: " Account Title: EMPLOYMENT INJURY SCHEME EIS",
                font: {
                  bold: true
                }
              }, {
                text: ", Account Number: 4426302003729",
                font: {
                  bold: true
                }
              }, {
                text: ". The validated list of account holders with their respective Account Titles, Bank Account Numbers, Bank Names, Branch info, Routing Numbers including Payment amounts have been mentioned below."
              }]
            };
            sheet.addRow([]);
            sheet.addRow([]);
            sheet.addRow([]);
            tableHeader = ["Sl #", "Account Title", "Bank Account Number", "Bank", "Branch", "District", "Routing No.", "Amount (BDT)", "Beneficiary ID", "Pay From", "Pay To"];
            headerRow = sheet.addRow(tableHeader);
            headerRow.eachCell(function (cell) {
              cell.fill = {
                type: "pattern",
                pattern: "solid",
                fgColor: {
                  argb: "92D050"
                }
              };
              cell.font = {
                bold: true
              };
              cell.alignment = {
                horizontal: "center",
                vertical: "middle"
              };
              cell.border = {
                top: {
                  style: "thin"
                },
                left: {
                  style: "thin"
                },
                bottom: {
                  style: "thin"
                },
                right: {
                  style: "thin"
                }
              };
            });
            eisPayments.forEach(function (row, index) {
              var _row$bank7, _row$bank8, _row$bank9, _row$bank10, _row$bank11, _row$bank12;
              var rowYear = (row === null || row === void 0 ? void 0 : row.year) || "";
              var monthIndex = (row === null || row === void 0 ? void 0 : row.monthIndex) || "";
              var monthFormatted = String(monthIndex).padStart(2, "0");
              var payFrom = row !== null && row !== void 0 && row.payFromDate ? new Date(row === null || row === void 0 ? void 0 : row.payFromDate).toLocaleDateString("en-GB") : "01.".concat(monthFormatted, ".").concat(rowYear);
              var lastDay = new Date(rowYear, monthIndex, 0).getDate();
              var payTo = row !== null && row !== void 0 && row.payToDate ? new Date(row === null || row === void 0 ? void 0 : row.payToDate).toLocaleDateString("en-GB") : "".concat(lastDay, ".").concat(monthFormatted, ".").concat(rowYear);
              sheet.addRow([index + 1, (row === null || row === void 0 ? void 0 : row.bankAccountHolderName) || "", (row === null || row === void 0 ? void 0 : row.bankAccountNo) || "", (row === null || row === void 0 || (_row$bank7 = row.bank) === null || _row$bank7 === void 0 || (_row$bank7 = _row$bank7.parent) === null || _row$bank7 === void 0 ? void 0 : _row$bank7.nameEn) || "", (row === null || row === void 0 || (_row$bank8 = row.bank) === null || _row$bank8 === void 0 ? void 0 : _row$bank8.nameEn) || "", (row === null || row === void 0 || (_row$bank9 = row.bank) === null || _row$bank9 === void 0 ? void 0 : _row$bank9.districtNameEn) || "", (((_row$bank10 = row.bank) === null || _row$bank10 === void 0 ? void 0 : _row$bank10.routingNumber) == '0' || (row === null || row === void 0 || (_row$bank11 = row.bank) === null || _row$bank11 === void 0 ? void 0 : _row$bank11.routingNumber) == null ? row === null || row === void 0 ? void 0 : row.routingNumber : (_row$bank12 = row.bank) === null || _row$bank12 === void 0 ? void 0 : _row$bank12.routingNumber) || "", (row === null || row === void 0 ? void 0 : row.paidAmount) || 0, (row === null || row === void 0 ? void 0 : row.beneficiaryId) || "", payFrom, payTo]);
            });
            firstDataRow = headerRow.number + 1;
            lastDataRow = firstDataRow + eisPayments.length - 1;
            for (i = firstDataRow; i <= lastDataRow; i++) {
              row = sheet.getRow(i);
              row.eachCell(function (cell) {
                cell.border = {
                  top: {
                    style: "thin"
                  },
                  left: {
                    style: "thin"
                  },
                  bottom: {
                    style: "thin"
                  },
                  right: {
                    style: "thin"
                  }
                };
                cell.alignment = {
                  vertical: "middle",
                  horizontal: "left",
                  wrapText: true
                };
              });
            }
            sheet.addRow([]);
            sheet.addRow([]);
            closingLines = ["Your prompt necessary steps in this matter will be highly appreciated.", "", "With warm regards", "", "Director General,", "Central Fund, Ministry of Labor and Employment &", "Member Secretary, EIS Pilot Governance Board", "Bangladesh Secretariat, Dhaka-1000", "", "Copy to (Not in order of seniority):", "1. PS to State Minister, Ministry of Labour and Employment, Bangladesh Secretariat, Dhaka-1000.", "2. PS to Secretary, Ministry of Labour and Employment, Bangladesh Secretariat, Dhaka-1000.", "3. Special Advisor, EIS Pilot Special Unit, 196, Sromo Bhaban (9th Floor), Bijoynagar, Dhaka-1000.", "4. PA to Director General, Central Fund, Bangladesh Secretariat, Dhaka-1000.", "5. Assistant Director, Welfare-2 and Development, Central Fund, Bangladesh Secretariat, Dhaka-1000.", "6. Assistant Director, Finance Department, Central Fund, Bangladesh Secretariat, Dhaka-1000."];
            closingLines.forEach(function (line) {
              var row = sheet.addRow([line]);
              sheet.mergeCells("A".concat(row.number, ":J").concat(row.number));
              row.getCell(1).alignment = {
                horizontal: "left",
                vertical: "top",
                wrapText: true
              };
            });
            _context2.next = 39;
            return workbook.xlsx.writeBuffer();
          case 39:
            buffer = _context2.sent;
            blob = new Blob([buffer], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            });
            saveAs(blob, "BA-Advice.xlsx");
          case 42:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function exportToExcel() {
      return _ref3.apply(this, arguments);
    };
  }();
  var handleDialogPrint = function handleDialogPrint() {
    window.print();
  };
  var handleSaveAdvice = function handleSaveAdvice() {
    if (window.confirm("Are You sure you want to save this Bank Advice?")) {
      var ids = [];
      paymentData.forEach(function (data) {
        ids.push(data.id);
      });
      try {
        dispatch(createWorkforceEisBankAdvice(ids, month, year)).then(function () {
          onClose();
        });
      } catch (e) {
        alert("Bank Advice Creation Failed!");
      }
    } else {
      alert("Bank Advice Creation Failed!");
    }
  };
  return /*#__PURE__*/React.createElement(Dialog$1, {
    open: open,
    onClose: onClose,
    maxWidth: "lg",
    fullWidth: true,
    classes: {
      paper: classes.dialogPaper
    },
    PaperProps: {
      id: "printable-content"
    }
  }, /*#__PURE__*/React.createElement(DialogTitle, {
    disableTypography: true,
    className: classes.noPrint
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6"
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "EIS Bank Payment Advice (BEFTN)"
  }))), /*#__PURE__*/React.createElement(DialogContent$1, {
    className: classes.dialogContent
  }, topHtml ? /*#__PURE__*/React.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: topHtml
    }
  }) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography, {
    align: "right",
    paragraph: true
  }, "Ref No: EIS.Bank Advice.Benefit.", excelyear, ".", excelmonthFormatted), /*#__PURE__*/React.createElement(Typography, {
    align: "left",
    variant: "subtitle1",
    paragraph: true
  }, "Manager"), /*#__PURE__*/React.createElement(Typography, {
    align: "left",
    paragraph: true
  }, "Sonali Bank Limited"), /*#__PURE__*/React.createElement(Typography, {
    align: "left",
    paragraph: true
  }, "Ramna Corporate Branch"), /*#__PURE__*/React.createElement(Typography, {
    align: "left",
    paragraph: true
  }, "1, Topkhana Road, Ramna, Dhaka, 1000"), /*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle1",
    style: {
      fontWeight: "bold",
      textDecoration: "underline"
    },
    paragraph: true
  }, /*#__PURE__*/React.createElement("strong", null, "Subject:"), " Bank Advice Letter (EIS Top-up Benefit)"), /*#__PURE__*/React.createElement(Typography, {
    paragraph: true
  }, "Dear Sir:"), /*#__PURE__*/React.createElement(Typography, {
    paragraph: true
  }, "Greetings from EIS Pilot!"), /*#__PURE__*/React.createElement(Typography, {
    paragraph: true
  }, "EIS Pilot top-up benefits are required to be disbursed to the beneficiaries through bank transfer from your branch of EIS Pilot bank account,", " ", /*#__PURE__*/React.createElement("strong", null, "Account Title: EMPLOYMENT INJURY SCHEME EIS"), ",", " ", /*#__PURE__*/React.createElement("strong", null, "Account Number: 4426302003729"), ".", " ", "The validated list of account holders with their respective Account Titles, Bank Account Numbers, Bank Names, Branch info, Routing Numbers including Payment amounts have been mentioned below."), /*#__PURE__*/React.createElement(Table$2, {
    size: "small"
  }, /*#__PURE__*/React.createElement(TableHead, null, /*#__PURE__*/React.createElement(TableRow, null, /*#__PURE__*/React.createElement(TableCell, {
    align: "left"
  }, "SL"), /*#__PURE__*/React.createElement(TableCell, {
    align: "left"
  }, "Account Title"), /*#__PURE__*/React.createElement(TableCell, {
    align: "left"
  }, "Account No"), /*#__PURE__*/React.createElement(TableCell, {
    align: "left"
  }, "Bank"), /*#__PURE__*/React.createElement(TableCell, {
    align: "left"
  }, "Branch"), /*#__PURE__*/React.createElement(TableCell, {
    align: "left"
  }, "District"), /*#__PURE__*/React.createElement(TableCell, {
    align: "left"
  }, "Routing"), /*#__PURE__*/React.createElement(TableCell, {
    align: "left"
  }, "Amount"), /*#__PURE__*/React.createElement(TableCell, {
    align: "left"
  }, "Beneficiary ID"), /*#__PURE__*/React.createElement(TableCell, {
    align: "left"
  }, "Pay From"), /*#__PURE__*/React.createElement(TableCell, {
    align: "left"
  }, "Pay To"))), /*#__PURE__*/React.createElement(TableBody, null, eisPayments.map(function (row, index) {
    var _row$workforceApplica, _row$bank13, _row$bank14, _row$bank15, _row$bank16, _row$bank17, _row$bank18;
    var rowYear = (row === null || row === void 0 ? void 0 : row.year) || "";
    var monthIndex = (row === null || row === void 0 ? void 0 : row.monthIndex) || "";
    var monthFormatted = String(monthIndex).padStart(2, "0");
    var lastDay = new Date(rowYear, monthIndex, 0).getDate();
    var onBehalfOf = "";
    if ((row === null || row === void 0 || (_row$workforceApplica = row.workforceApplication) === null || _row$workforceApplica === void 0 ? void 0 : _row$workforceApplica.applicationType) == 'financialAssistance') {
      var _row$workforceEmploye;
      var dependent = (row === null || row === void 0 || (_row$workforceEmploye = row.workforceEmployeeDependent[0]) === null || _row$workforceEmploye === void 0 ? void 0 : _row$workforceEmploye.nameEn) || "";
      onBehalfOf = dependent;
    }
    // else
    // {
    //   let applicant_info = safeParse(row?.workforceApplication?.applicantInfo || "{}");
    //   onBehalfOf = applicant_info?.nameEn || "";
    // }

    return /*#__PURE__*/React.createElement(TableRow, {
      key: index
    }, /*#__PURE__*/React.createElement(TableCell, {
      align: "left"
    }, index + 1), /*#__PURE__*/React.createElement(TableCell, {
      align: "left"
    }, row === null || row === void 0 ? void 0 : row.bankAccountHolderName, " ", onBehalfOf !== "" && "(".concat(onBehalfOf, ")")), /*#__PURE__*/React.createElement(TableCell, {
      align: "left"
    }, row === null || row === void 0 ? void 0 : row.bankAccountNo), /*#__PURE__*/React.createElement(TableCell, {
      align: "left"
    }, row === null || row === void 0 || (_row$bank13 = row.bank) === null || _row$bank13 === void 0 || (_row$bank13 = _row$bank13.parent) === null || _row$bank13 === void 0 ? void 0 : _row$bank13.nameEn), /*#__PURE__*/React.createElement(TableCell, {
      align: "left"
    }, row === null || row === void 0 || (_row$bank14 = row.bank) === null || _row$bank14 === void 0 ? void 0 : _row$bank14.nameEn), /*#__PURE__*/React.createElement(TableCell, {
      align: "left"
    }, row === null || row === void 0 || (_row$bank15 = row.bank) === null || _row$bank15 === void 0 ? void 0 : _row$bank15.districtNameEn), /*#__PURE__*/React.createElement(TableCell, {
      align: "left"
    }, (row === null || row === void 0 || (_row$bank16 = row.bank) === null || _row$bank16 === void 0 ? void 0 : _row$bank16.routingNumber) == '0' || (row === null || row === void 0 || (_row$bank17 = row.bank) === null || _row$bank17 === void 0 ? void 0 : _row$bank17.routingNumber) == null ? row === null || row === void 0 ? void 0 : row.routingNumber : row === null || row === void 0 || (_row$bank18 = row.bank) === null || _row$bank18 === void 0 ? void 0 : _row$bank18.routingNumber), /*#__PURE__*/React.createElement(TableCell, {
      align: "left"
    }, Number(row === null || row === void 0 ? void 0 : row.paidAmount).toFixed(2)), /*#__PURE__*/React.createElement(TableCell, {
      align: "left"
    }, row === null || row === void 0 ? void 0 : row.beneficiaryId), (row === null || row === void 0 ? void 0 : row.eisPaymentType) == 'installment' ? /*#__PURE__*/React.createElement(TableCell, {
      align: "left",
      colSpan: 2
    }, "".concat(getOrdinalNumber(row === null || row === void 0 ? void 0 : row.installmentNumber), " Installment")) : (row === null || row === void 0 ? void 0 : row.eisPaymentType) == 'onetime' ? /*#__PURE__*/React.createElement(TableCell, {
      align: "left",
      colSpan: 2
    }, "Lifetime") : /*#__PURE__*/React.createElement(React.Fragment, null, row !== null && row !== void 0 && row.payFromDate ? /*#__PURE__*/React.createElement(TableCell, {
      align: "left"
    }, new Date(row === null || row === void 0 ? void 0 : row.payFromDate).toLocaleDateString("en-GB")) : /*#__PURE__*/React.createElement(TableCell, {
      align: "left"
    }, "01.", monthFormatted, ".", rowYear), row !== null && row !== void 0 && row.payToDate ? /*#__PURE__*/React.createElement(TableCell, {
      align: "left"
    }, new Date(row === null || row === void 0 ? void 0 : row.payToDate).toLocaleDateString("en-GB")) : /*#__PURE__*/React.createElement(TableCell, {
      align: "left"
    }, lastDay, ".", monthFormatted, ".", rowYear)));
  }))), /*#__PURE__*/React.createElement(Typography, {
    align: "right",
    variant: "subtitle1",
    style: {
      fontWeight: "bold",
      marginTop: "20px"
    },
    paragraph: true
  }, "Total Amount (BDT): ", getTotalAmount()), /*#__PURE__*/React.createElement(Typography, {
    paragraph: true
  }, "Your prompt necessary steps in this matter will be highly appreciated."), /*#__PURE__*/React.createElement(Typography, {
    paragraph: true
  }, "With warm regards"), /*#__PURE__*/React.createElement(Typography, {
    paragraph: true
  }, /*#__PURE__*/React.createElement("strong", null, "Director General,"), /*#__PURE__*/React.createElement("br", null), "Central Fund, Ministry of Labor and Employment &", /*#__PURE__*/React.createElement("br", null), "Member Secretary, EIS Pilot Governance Board", /*#__PURE__*/React.createElement("br", null), "Bangladesh Secretariat, Dhaka-1000"), /*#__PURE__*/React.createElement(Typography, {
    paragraph: true
  }, "Copy to (Not in order of seniority):"), /*#__PURE__*/React.createElement(Typography, {
    paragraph: true,
    style: {
      marginLeft: "20px"
    }
  }, "1. PS to State Minister, Ministry of Labour and Employment, Bangladesh Secretariat, Dhaka-1000.", /*#__PURE__*/React.createElement("br", null), "2. PS to Secretary, Ministry of Labour and Employment, Bangladesh Secretariat, Dhaka-1000.", /*#__PURE__*/React.createElement("br", null), "3. Special Advisor, EIS Pilot Special Unit, 196, Sromo Bhaban (9th Floor), Bijoynagar, Dhaka-1000.", /*#__PURE__*/React.createElement("br", null), "4. PA to Director General, Central Fund, Bangladesh Secretariat, Dhaka-1000.", /*#__PURE__*/React.createElement("br", null), "5. Assistant Director, Welfare-2 and Development, Central Fund, Bangladesh Secretariat, Dhaka-1000.", /*#__PURE__*/React.createElement("br", null), "6. Assistant Director, Finance Department, Central Fund, Bangladesh Secretariat, Dhaka-1000."))), /*#__PURE__*/React.createElement(Divider, {
    className: classes.noPrint
  }), /*#__PURE__*/React.createElement(DialogActions$1, {
    className: classes.noPrint
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: onClose,
    variant: "outlined",
    color: "primary"
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "workforce.modal.close"
  })), fromAdviceList ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
    onClick: handleDialogPrint,
    variant: "contained",
    color: "primary"
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "workforce.modal.print.advice"
  })), /*#__PURE__*/React.createElement(Button, {
    onClick: exportToExcel,
    variant: "contained",
    color: "secondary"
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "workforce.modal.excel"
  }))) : /*#__PURE__*/React.createElement(Button, {
    onClick: handleSaveAdvice,
    variant: "contained",
    color: "primary"
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "workforce.modal.save.advice"
  }))));
};

function ownKeys$o(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$o(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$o(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$o(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var BeneficiaryProcessedPaymentList = function BeneficiaryProcessedPaymentList() {
  var dispatch = useDispatch();
  // Generate years dynamically (previous year to 10 years back)
  var currentYear = new Date().getFullYear();
  var currentMonth = new Date().getMonth() + 1; // Months are 0-indexed
  var yearOptions = Array.from({
    length: 11
  }, function (_, i) {
    return currentYear - i;
  });
  var monthOptions = Array.from({
    length: 12
  }, function (_, i) {
    return i + 1;
  });
  var monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
  var modulesManager = useModulesManager();
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    openGenerateBeneficiaryAdvice = _useState2[0],
    setOpenGenerateBeneficiaryAdvice = _useState2[1];
  var _useState3 = useState(true),
    _useState4 = _slicedToArray(_useState3, 2),
    loading = _useState4[0],
    setLoading = _useState4[1];
  var _useState5 = useState([]),
    _useState6 = _slicedToArray(_useState5, 2),
    data = _useState6[0],
    setData = _useState6[1];
  var _useState7 = useState([]),
    _useState8 = _slicedToArray(_useState7, 2),
    selectedIds = _useState8[0],
    setSelectedIds = _useState8[1];
  var _useState9 = useState(false),
    _useState10 = _slicedToArray(_useState9, 2),
    confirmOpen = _useState10[0],
    setConfirmOpen = _useState10[1];
  var _useState11 = useState([]),
    _useState12 = _slicedToArray(_useState11, 2),
    pendingApproveIds = _useState12[0],
    setPendingApproveIds = _useState12[1];
  var _useState13 = useState([]),
    _useState14 = _slicedToArray(_useState13, 2),
    factories = _useState14[0],
    setFactories = _useState14[1];
  var _useState15 = useState([]),
    _useState16 = _slicedToArray(_useState15, 2),
    associations = _useState16[0],
    setAssociations = _useState16[1];
  var _useState17 = useState([]),
    _useState18 = _slicedToArray(_useState17, 2),
    committees = _useState18[0],
    setCommittees = _useState18[1];
  var closeApproveConfirm = function closeApproveConfirm() {
    setConfirmOpen(false);
    setPendingApproveIds([]);
  };
  var _useState19 = useState({
      month: currentMonth,
      year: currentYear,
      isDisbursed: "all",
      factory: "",
      association: "",
      committee: ""
    }),
    _useState20 = _slicedToArray(_useState19, 2),
    filters = _useState20[0],
    setFilters = _useState20[1];
  var loadData = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _safeDecodeId, _safeDecodeId2, _processRes$payload, _yield$Promise$all, _yield$Promise$all2, processRes, allData, filteredData;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            setLoading(true);
            _context.prev = 1;
            dispatch(fetchWorkforceFactoriesSummary(modulesManager, [])).then(function (res) {
              var _res$payload;
              return setFactories((res === null || res === void 0 || (_res$payload = res.payload) === null || _res$payload === void 0 || (_res$payload = _res$payload.data) === null || _res$payload === void 0 || (_res$payload = _res$payload.workforceEmployerFactories) === null || _res$payload === void 0 ? void 0 : _res$payload.edges) || []);
            });
            dispatch(fetchWorkforceAllAssociationSummary([])).then(function (res) {
              var _res$payload2;
              return setAssociations((res === null || res === void 0 || (_res$payload2 = res.payload) === null || _res$payload2 === void 0 || (_res$payload2 = _res$payload2.data) === null || _res$payload2 === void 0 || (_res$payload2 = _res$payload2.workforceAllAssociation) === null || _res$payload2 === void 0 ? void 0 : _res$payload2.edges) || []);
            });
            _context.next = 6;
            return Promise.all([dispatch(fetchWorkforceEisPaymentDisbursementStage({
              month: filters.month,
              year: filters.year,
              isDisbursed: filters.isDisbursed,
              workforceFactoryId: (_safeDecodeId = safeDecodeId(filters.factory)) !== null && _safeDecodeId !== void 0 ? _safeDecodeId : "",
              allAssociationId: (_safeDecodeId2 = safeDecodeId(filters.association)) !== null && _safeDecodeId2 !== void 0 ? _safeDecodeId2 : ""
              // notInDisburse: "yes"
            }, modulesManager))]);
          case 6:
            _yield$Promise$all = _context.sent;
            _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 1);
            processRes = _yield$Promise$all2[0];
            allData = (processRes === null || processRes === void 0 || (_processRes$payload = processRes.payload) === null || _processRes$payload === void 0 || (_processRes$payload = _processRes$payload.data) === null || _processRes$payload === void 0 ? void 0 : _processRes$payload.workforceEisPaymentDisbursementStage) || [];
            filteredData = filters.committee ? allData.filter(function (row) {
              var _row$workforceApplica;
              return safeDecodeId(row === null || row === void 0 || (_row$workforceApplica = row.workforceApplication) === null || _row$workforceApplica === void 0 ? void 0 : _row$workforceApplica.committeeId) === safeDecodeId(filters.committee);
            }) : allData;
            setData(filteredData);
            _context.next = 17;
            break;
          case 14:
            _context.prev = 14;
            _context.t0 = _context["catch"](1);
            console.error("Data Load Error:", _context.t0);
          case 17:
            _context.prev = 17;
            setLoading(false);
            return _context.finish(17);
          case 20:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[1, 14, 17, 20]]);
    }));
    return function loadData() {
      return _ref.apply(this, arguments);
    };
  }();
  useEffect(function () {
    dispatch(fetchWorkforceCommittees()).then(function (res) {
      var _res$payload3;
      setCommittees((res === null || res === void 0 || (_res$payload3 = res.payload) === null || _res$payload3 === void 0 || (_res$payload3 = _res$payload3.data) === null || _res$payload3 === void 0 ? void 0 : _res$payload3.workforceCommittees) || []);
    });
  }, [dispatch]);
  useEffect(function () {
    loadData();
  }, [dispatch, modulesManager]);
  var handleFilterChange = function handleFilterChange(e) {
    var _e$target = e.target,
      name = _e$target.name,
      value = _e$target.value;
    setFilters(function (prev) {
      return _objectSpread$o(_objectSpread$o({}, prev), {}, _defineProperty({}, name, value));
    });
  };
  var clearFilters = function clearFilters() {
    setFilters({
      month: currentMonth,
      year: currentYear,
      isDisbursed: "all",
      factory: "",
      association: ""
    });
  };
  var getStatusChip = function getStatusChip(row) {
    var _row$workforceEisBank;
    if (row !== null && row !== void 0 && row.isDisbursed || row !== null && row !== void 0 && (_row$workforceEisBank = row.workforceEisBankAdvice) !== null && _row$workforceEisBank !== void 0 && _row$workforceEisBank.isConfirmed) return /*#__PURE__*/React.createElement(Chip, {
      label: "Disbursed",
      size: "small",
      style: {
        backgroundColor: '#e8f5e9',
        color: '#2e7d32'
      }
    });
    return /*#__PURE__*/React.createElement(Chip, {
      label: "Processed",
      size: "small",
      variant: "outlined"
    });
  };
  var handleRowSelect = function handleRowSelect(id) {
    setSelectedIds(function (prev) {
      return prev.includes(id) ? prev.filter(function (x) {
        return x !== id;
      }) : [].concat(_toConsumableArray(prev), [id]);
    });
  };
  var handleSelectAll = function handleSelectAll(checked) {
    if (checked) {
      setSelectedIds(data.map(function (row) {
        return row.id;
      }));
    } else {
      setSelectedIds([]);
    }
  };
  var handleApprove = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(ids) {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            if (ids !== null && ids !== void 0 && ids.length) {
              _context2.next = 2;
              break;
            }
            return _context2.abrupt("return");
          case 2:
            _context2.next = 4;
            return dispatch(createWorkforceEisPaymentDisbursement(ids, filters.month, filters.year));
          case 4:
            loadData();
          case 5:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function handleApprove(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  var handleRevert = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3(ids) {
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            if (ids !== null && ids !== void 0 && ids.length) {
              _context3.next = 2;
              break;
            }
            return _context3.abrupt("return");
          case 2:
            _context3.next = 4;
            return dispatch(deleteWorkforceEisPaymentStage(ids));
          case 4:
            loadData();
          case 5:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return function handleRevert(_x2) {
      return _ref3.apply(this, arguments);
    };
  }();
  return /*#__PURE__*/React.createElement(Box$1, {
    bgcolor: "#fafafa",
    minHeight: "100vh"
  }, /*#__PURE__*/React.createElement(Box$1, {
    mb: 2,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-end"
  }, /*#__PURE__*/React.createElement(Box$1, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5",
    style: {
      fontWeight: 700,
      marginBottom: 4
    }
  }, "List of Processed Beneficiary Payments"), /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    color: "textSecondary"
  }, "Disburse payments to beneficiaries whose payments have been processed."))), /*#__PURE__*/React.createElement(Paper, {
    elevation: 0,
    style: {
      padding: '24px',
      marginBottom: '24px',
      borderRadius: '12px',
      border: '1px solid #eceff1'
    }
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 3,
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 6,
    md: 3
  }, /*#__PURE__*/React.createElement(TextField, {
    fullWidth: true,
    select: true,
    label: "Factory",
    name: "factory",
    variant: "outlined",
    size: "small",
    value: filters.factory,
    onChange: handleFilterChange
  }, /*#__PURE__*/React.createElement(MenuItem, {
    value: ""
  }, /*#__PURE__*/React.createElement("em", null, "All Factories")), factories.map(function (f) {
    return /*#__PURE__*/React.createElement(MenuItem, {
      key: f.node.id,
      value: f.node.id
    }, f.node.nameBn || f.node.nameEn);
  }))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 6,
    md: 3
  }, /*#__PURE__*/React.createElement(TextField, {
    fullWidth: true,
    select: true,
    label: "Association",
    name: "association",
    variant: "outlined",
    size: "small",
    value: filters.association,
    onChange: handleFilterChange
  }, /*#__PURE__*/React.createElement(MenuItem, {
    value: ""
  }, /*#__PURE__*/React.createElement("em", null, "All Associations")), associations.map(function (a) {
    return /*#__PURE__*/React.createElement(MenuItem, {
      key: a.node.id,
      value: a.node.id
    }, a.node.shortNameBn || a.node.nameEn);
  }))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 6,
    md: 3
  }, /*#__PURE__*/React.createElement(TextField, {
    fullWidth: true,
    select: true,
    label: "Committee",
    name: "committee",
    variant: "outlined",
    size: "small",
    value: filters.committee,
    onChange: handleFilterChange
  }, /*#__PURE__*/React.createElement(MenuItem, {
    value: ""
  }, /*#__PURE__*/React.createElement("em", null, "All Committees")), committees.map(function (committee) {
    return /*#__PURE__*/React.createElement(MenuItem, {
      key: committee.id,
      value: committee.id
    }, committee.nameBn || committee.nameEn || committee.id);
  }))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 6,
    md: 3
  }, /*#__PURE__*/React.createElement(TextField, {
    fullWidth: true,
    select: true,
    label: "Month",
    name: "month",
    variant: "outlined",
    size: "small",
    value: filters.month || currentMonth,
    onChange: handleFilterChange
  }, /*#__PURE__*/React.createElement(MenuItem, {
    value: ""
  }, /*#__PURE__*/React.createElement("em", null, "All Months")), monthOptions.map(function (month) {
    return /*#__PURE__*/React.createElement(MenuItem, {
      key: month,
      value: month
    }, monthNames[month - 1]);
  }))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 6,
    md: 3
  }, /*#__PURE__*/React.createElement(TextField, {
    fullWidth: true,
    select: true,
    label: "Year",
    name: "year",
    variant: "outlined",
    size: "small",
    value: filters.year || currentYear,
    onChange: handleFilterChange
  }, yearOptions.map(function (year) {
    return /*#__PURE__*/React.createElement(MenuItem, {
      key: year,
      value: year
    }, year);
  }))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 6,
    md: 3
  }, /*#__PURE__*/React.createElement(TextField, {
    fullWidth: true,
    select: true,
    label: "Status",
    name: "isDisbursed",
    variant: "outlined",
    size: "small",
    value: filters.isDisbursed || "all",
    onChange: handleFilterChange
  }, /*#__PURE__*/React.createElement(MenuItem, {
    key: "all",
    value: "all"
  }, "All"), /*#__PURE__*/React.createElement(MenuItem, {
    key: "yes",
    value: "yes"
  }, "Disbursed"), /*#__PURE__*/React.createElement(MenuItem, {
    key: "no",
    value: "no"
  }, "Processed"))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 2
  }, /*#__PURE__*/React.createElement(Box$1, {
    display: "flex",
    gap: "8px"
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: loadData,
    fullWidth: true,
    variant: "contained",
    color: "primary",
    startIcon: /*#__PURE__*/React.createElement(SearchIcon, null)
  }, "Search"), /*#__PURE__*/React.createElement(Button, {
    onClick: clearFilters,
    fullWidth: true,
    variant: "text",
    color: "default",
    startIcon: /*#__PURE__*/React.createElement(ClearAllIcon, null)
  }, "Reset"))))), loading ? /*#__PURE__*/React.createElement(Box$1, {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "200px"
  }, /*#__PURE__*/React.createElement(CircularProgress$1, null)) : /*#__PURE__*/React.createElement(TableContainer, {
    component: Paper,
    elevation: 0,
    style: {
      borderRadius: '12px',
      border: '1px solid #e0e0e0'
    }
  }, /*#__PURE__*/React.createElement(Table$2, null, /*#__PURE__*/React.createElement(TableHead, {
    style: {
      backgroundColor: '#f8fafd'
    }
  }, /*#__PURE__*/React.createElement(TableRow, null, /*#__PURE__*/React.createElement(TableCell, {
    padding: "checkbox",
    align: "center"
  }, /*#__PURE__*/React.createElement("input", {
    type: "checkbox",
    checked: selectedIds.length === data.length && data.length > 0,
    onChange: function onChange(e) {
      return handleSelectAll(e.target.checked);
    }
  })), /*#__PURE__*/React.createElement(TableCell, {
    style: {
      fontWeight: 600
    }
  }, "Beneficiary Details"), /*#__PURE__*/React.createElement(TableCell, {
    style: {
      fontWeight: 600
    }
  }, "Worker, Factory & Association"), /*#__PURE__*/React.createElement(TableCell, {
    style: {
      fontWeight: 600
    }
  }, "Payment Method"), /*#__PURE__*/React.createElement(TableCell, {
    align: "right",
    style: {
      fontWeight: 600
    }
  }, "Amounts"), /*#__PURE__*/React.createElement(TableCell, {
    align: "center",
    style: {
      fontWeight: 600
    }
  }, "Status"), /*#__PURE__*/React.createElement(TableCell, {
    align: "center",
    style: {
      fontWeight: 600
    }
  }, "Action"))), /*#__PURE__*/React.createElement(TableBody, null, data.map(function (row) {
    var _row$workforceEmploye, _row$workforceApplica2, _row$workforceApplica3, _safeParse, _row$workforceApplica4, _row$workforceApplica5, _row$workforceApplica6, _row$workforceApplica7, _row$workforceApplica8, _row$workforceApplica9, _row$workforceApplica10, _row$bank, _row$bank2, _row$bank3, _row$bank4, _row$bank5, _Number$toLocaleStrin, _Number$toLocaleStrin2, _row$workforceEisBank2, _row$workforceEisBank3, _row$workforceEisBank4, _row$workforceEisBank5;
    var dep = (row === null || row === void 0 || (_row$workforceEmploye = row.workforceEmployeeDependent) === null || _row$workforceEmploye === void 0 ? void 0 : _row$workforceEmploye[0]) || {};
    var worker = (row === null || row === void 0 || (_row$workforceApplica2 = row.workforceApplication) === null || _row$workforceApplica2 === void 0 ? void 0 : _row$workforceApplica2.applicationType) === "financialAssistance" || (row === null || row === void 0 || (_row$workforceApplica3 = row.workforceApplication) === null || _row$workforceApplica3 === void 0 ? void 0 : _row$workforceApplica3.applicationType) === "deadlyGrant" ? (_safeParse = safeParse(row === null || row === void 0 || (_row$workforceApplica4 = row.workforceApplication) === null || _row$workforceApplica4 === void 0 ? void 0 : _row$workforceApplica4.deceasedWorkerInfo)) === null || _safeParse === void 0 ? void 0 : _safeParse.nameEn : row === null || row === void 0 || (_row$workforceApplica5 = row.workforceApplication) === null || _row$workforceApplica5 === void 0 || (_row$workforceApplica5 = _row$workforceApplica5.workforceEmployee) === null || _row$workforceApplica5 === void 0 ? void 0 : _row$workforceApplica5.firstNameEn;
    return /*#__PURE__*/React.createElement(TableRow, {
      key: row.id,
      hover: true
    }, /*#__PURE__*/React.createElement(TableCell, {
      padding: "checkbox",
      align: "center"
    }, /*#__PURE__*/React.createElement("input", {
      type: "checkbox",
      checked: selectedIds.includes(row.id),
      onChange: function onChange() {
        return handleRowSelect(row.id);
      }
      // disabled={row?.isDisbursed}
    })), /*#__PURE__*/React.createElement(TableCell, null, /*#__PURE__*/React.createElement(Typography, {
      variant: "subtitle2",
      style: {
        fontWeight: 600
      }
    }, (dep === null || dep === void 0 ? void 0 : dep.nameEn) || (dep === null || dep === void 0 ? void 0 : dep.nameBn) || (row === null || row === void 0 || (_row$workforceApplica6 = row.workforceApplication) === null || _row$workforceApplica6 === void 0 || (_row$workforceApplica6 = _row$workforceApplica6.workforceEmployee) === null || _row$workforceApplica6 === void 0 ? void 0 : _row$workforceApplica6.firstNameEn) || "—"), /*#__PURE__*/React.createElement(Typography, {
      variant: "caption",
      color: "primary"
    }, getRelationString(dep)), /*#__PURE__*/React.createElement(Box$1, {
      mt: 0.5,
      mb: 0.5
    }, /*#__PURE__*/React.createElement(Chip, {
      label: row.beneficiaryId,
      variant: "outlined",
      style: {
        height: 20
      }
    })), /*#__PURE__*/React.createElement(Typography, {
      variant: "caption",
      display: "block",
      color: "textSecondary"
    }, "ATN: " + (row === null || row === void 0 || (_row$workforceApplica7 = row.workforceApplication) === null || _row$workforceApplica7 === void 0 ? void 0 : _row$workforceApplica7.trackingNumber) || "N/A")), /*#__PURE__*/React.createElement(TableCell, null, /*#__PURE__*/React.createElement(Typography, {
      variant: "body2",
      style: {
        fontWeight: 500
      }
    }, worker), /*#__PURE__*/React.createElement(Typography, {
      variant: "caption",
      display: "block",
      color: "textSecondary"
    }, row === null || row === void 0 || (_row$workforceApplica8 = row.workforceApplication) === null || _row$workforceApplica8 === void 0 || (_row$workforceApplica8 = _row$workforceApplica8.employeeFactory) === null || _row$workforceApplica8 === void 0 ? void 0 : _row$workforceApplica8.nameEn), /*#__PURE__*/React.createElement(Typography, {
      variant: "caption",
      display: "block",
      color: "textSecondary"
    }, (row === null || row === void 0 || (_row$workforceApplica9 = row.workforceApplication) === null || _row$workforceApplica9 === void 0 || (_row$workforceApplica9 = _row$workforceApplica9.employeeFactory) === null || _row$workforceApplica9 === void 0 || (_row$workforceApplica9 = _row$workforceApplica9.allAssociation) === null || _row$workforceApplica9 === void 0 ? void 0 : _row$workforceApplica9.shortNameEn) || (row === null || row === void 0 || (_row$workforceApplica10 = row.workforceApplication) === null || _row$workforceApplica10 === void 0 || (_row$workforceApplica10 = _row$workforceApplica10.employeeFactory) === null || _row$workforceApplica10 === void 0 || (_row$workforceApplica10 = _row$workforceApplica10.allAssociation) === null || _row$workforceApplica10 === void 0 ? void 0 : _row$workforceApplica10.nameEn) || "N/A")), /*#__PURE__*/React.createElement(TableCell, null, /*#__PURE__*/React.createElement(Typography, {
      variant: "body2"
    }, ((_row$bank = row.bank) === null || _row$bank === void 0 || (_row$bank = _row$bank.parent) === null || _row$bank === void 0 ? void 0 : _row$bank.nameEn) || "N/A"), /*#__PURE__*/React.createElement(Typography, {
      variant: "body2"
    }, ((_row$bank2 = row.bank) === null || _row$bank2 === void 0 ? void 0 : _row$bank2.nameEn) + " (Routing #" + ((row === null || row === void 0 || (_row$bank3 = row.bank) === null || _row$bank3 === void 0 ? void 0 : _row$bank3.routingNumber) == '0' || (row === null || row === void 0 || (_row$bank4 = row.bank) === null || _row$bank4 === void 0 ? void 0 : _row$bank4.routingNumber) == null ? row === null || row === void 0 ? void 0 : row.routingNumber : row === null || row === void 0 || (_row$bank5 = row.bank) === null || _row$bank5 === void 0 ? void 0 : _row$bank5.routingNumber) + ")" || "N/A"), /*#__PURE__*/React.createElement(Typography, {
      variant: "caption",
      color: "textSecondary"
    }, "A/C: " + row.bankAccountNo)), /*#__PURE__*/React.createElement(TableCell, {
      align: "right"
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "body2",
      style: {
        fontWeight: 700
      }
    }, (_Number$toLocaleStrin = Number(row === null || row === void 0 ? void 0 : row.paidAmount).toLocaleString("en-BD")) !== null && _Number$toLocaleStrin !== void 0 ? _Number$toLocaleStrin : Number(row === null || row === void 0 ? void 0 : row.paidAmount).toLocaleString("en-BD")), /*#__PURE__*/React.createElement(Typography, {
      variant: "caption",
      color: "textSecondary"
    }, "Total: " + ((_Number$toLocaleStrin2 = Number(row === null || row === void 0 ? void 0 : row.eisApprovedAmount).toLocaleString("en-BD")) !== null && _Number$toLocaleStrin2 !== void 0 ? _Number$toLocaleStrin2 : "--")), /*#__PURE__*/React.createElement(Typography, {
      variant: "body2",
      style: {
        fontWeight: 700
      }
    }, getPaymentTypeString(row.eisPaymentType))), /*#__PURE__*/React.createElement(TableCell, {
      align: "center"
    }, getStatusChip(row), /*#__PURE__*/React.createElement(Box$1, {
      mt: 2
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "caption",
      style: {
        display: "block"
      },
      color: "textSecondary"
    }, row !== null && row !== void 0 && row.isDisbursed && row !== null && row !== void 0 && row.disbursementDate || row !== null && row !== void 0 && (_row$workforceEisBank2 = row.workforceEisBankAdvice) !== null && _row$workforceEisBank2 !== void 0 && _row$workforceEisBank2.isConfirmed && row !== null && row !== void 0 && (_row$workforceEisBank3 = row.workforceEisBankAdvice) !== null && _row$workforceEisBank3 !== void 0 && _row$workforceEisBank3.confirmationDate ? "Disbursed on: ".concat(new Date((row === null || row === void 0 ? void 0 : row.disbursementDate) || (row === null || row === void 0 || (_row$workforceEisBank4 = row.workforceEisBankAdvice) === null || _row$workforceEisBank4 === void 0 ? void 0 : _row$workforceEisBank4.confirmationDate)).toLocaleDateString("en-GB")) : ""), /*#__PURE__*/React.createElement(Typography, {
      variant: "caption",
      style: {
        display: "block"
      },
      color: "textSecondary"
    }, row !== null && row !== void 0 && row.processingDate ? "Payment Processed on: ".concat(new Date(row === null || row === void 0 ? void 0 : row.processingDate).toLocaleDateString("en-GB")) : ""))), /*#__PURE__*/React.createElement(TableCell, {
      align: "center"
    }, row !== null && row !== void 0 && row.isDisbursed || row !== null && row !== void 0 && (_row$workforceEisBank5 = row.workforceEisBankAdvice) !== null && _row$workforceEisBank5 !== void 0 && _row$workforceEisBank5.isConfirmed ? /*#__PURE__*/React.createElement(React.Fragment, null) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
      variant: "outlined",
      size: "small",
      onClick: function onClick() {
        return handleRevert([row.id]);
      },
      style: {
        marginLeft: 6
      }
    }, "Revert"))));
  }))), data.length === 0 && /*#__PURE__*/React.createElement(Box$1, {
    p: 5,
    textAlign: "center"
  }, /*#__PURE__*/React.createElement(Typography, {
    color: "textSecondary"
  }, "No data found matching current filters."))), /*#__PURE__*/React.createElement(Box$1, {
    mt: 2,
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    gap: "8px"
  }, selectedIds.length > 0 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
    variant: "contained",
    color: "primary",
    disabled: !selectedIds.length || selectedIds.length == 0,
    onClick: function onClick() {
      return setOpenGenerateBeneficiaryAdvice(true);
    }
  }, "Generate Advice"), "\xA0 \xA0 \xA0", /*#__PURE__*/React.createElement(Button, {
    variant: "contained",
    color: "primary",
    disabled: !selectedIds.length,
    onClick: function onClick() {
      return handleRevert(selectedIds);
    }
  }, "Revert Selected"))), /*#__PURE__*/React.createElement(Dialog$1, {
    open: confirmOpen,
    onClose: closeApproveConfirm
  }, /*#__PURE__*/React.createElement(DialogTitle, null, "Confirm Disbursement"), /*#__PURE__*/React.createElement(DialogContent$1, null, /*#__PURE__*/React.createElement(Typography, null, "Are you sure you want to disburse payment ", pendingApproveIds.length > 1 ? "s for ".concat(pendingApproveIds.length, " beneficiaries") : " for this beneficiary", " You will not be able to undo or revert this operation!")), /*#__PURE__*/React.createElement(DialogActions$1, null, /*#__PURE__*/React.createElement(Button, {
    onClick: closeApproveConfirm,
    color: "default"
  }, "Cancel"), /*#__PURE__*/React.createElement(Button, {
    onClick: /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return handleApprove(pendingApproveIds);
          case 2:
            closeApproveConfirm();
          case 3:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    })),
    color: "primary",
    variant: "contained"
  }, "Confirm"))), /*#__PURE__*/React.createElement(GenerateBeneficiaryAdvice, {
    open: openGenerateBeneficiaryAdvice,
    onClose: function onClose() {
      setOpenGenerateBeneficiaryAdvice(false);
      loadData();
    },
    paymentData: data.filter(function (d) {
      return selectedIds.includes(d.id);
    }),
    month: filters.month,
    year: filters.year,
    committeeId: filters === null || filters === void 0 ? void 0 : filters.committee
  }));
};

function ownKeys$n(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$n(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$n(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$n(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var BeneficiaryBankAdviceList = function BeneficiaryBankAdviceList() {
  var dispatch = useDispatch();
  // Generate years dynamically (previous year to 10 years back)
  var currentYear = new Date().getFullYear();
  var currentMonth = new Date().getMonth() + 1; // Months are 0-indexed
  var yearOptions = Array.from({
    length: 11
  }, function (_, i) {
    return currentYear - i;
  });
  var monthOptions = Array.from({
    length: 12
  }, function (_, i) {
    return i + 1;
  });
  var monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
  var modulesManager = useModulesManager();
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    openGenerateBeneficiaryAdvice = _useState2[0],
    setOpenGenerateBeneficiaryAdvice = _useState2[1];
  var _useState3 = useState(true),
    _useState4 = _slicedToArray(_useState3, 2),
    loading = _useState4[0],
    setLoading = _useState4[1];
  var _useState5 = useState([]),
    _useState6 = _slicedToArray(_useState5, 2),
    data = _useState6[0],
    setData = _useState6[1];
  var _useState7 = useState([]),
    _useState8 = _slicedToArray(_useState7, 2);
    _useState8[0];
    _useState8[1];
  var _useState9 = useState(false),
    _useState10 = _slicedToArray(_useState9, 2),
    confirmOpen = _useState10[0],
    setConfirmOpen = _useState10[1];
  var _useState11 = useState(null),
    _useState12 = _slicedToArray(_useState11, 2),
    pendingAdviceId = _useState12[0],
    setpendingAdviceId = _useState12[1];
  var _useState13 = useState([]),
    _useState14 = _slicedToArray(_useState13, 2);
    _useState14[0];
    _useState14[1];
  var _useState15 = useState([]),
    _useState16 = _slicedToArray(_useState15, 2);
    _useState16[0];
    _useState16[1];
  var _useState17 = useState(false),
    _useState18 = _slicedToArray(_useState17, 2);
    _useState18[0];
    var setDisableApproval = _useState18[1];
  var _useState19 = useState(null),
    _useState20 = _slicedToArray(_useState19, 2);
    _useState20[0];
    _useState20[1];
  var _useState21 = useState([]),
    _useState22 = _slicedToArray(_useState21, 2),
    paymentData = _useState22[0],
    setPaymentData = _useState22[1];
  var _useState23 = useState(false),
    _useState24 = _slicedToArray(_useState23, 2),
    btnLoading = _useState24[0],
    setBtnLoading = _useState24[1];
  var openApproveConfirm = function openApproveConfirm(id) {
    setpendingAdviceId(id);
    setConfirmOpen(true);
  };
  var closeApproveConfirm = function closeApproveConfirm() {
    setConfirmOpen(false);
    setpendingAdviceId([]);
  };
  var handleApprove = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(id) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return dispatch(updateWorkforceEisBankAdvice(safeDecodeId(id)));
          case 3:
            loadData();
            _context.next = 9;
            break;
          case 6:
            _context.prev = 6;
            _context.t0 = _context["catch"](0);
            loadData();
          case 9:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 6]]);
    }));
    return function handleApprove(_x) {
      return _ref.apply(this, arguments);
    };
  }();
  var _useState25 = useState({
      month: currentMonth,
      year: currentYear,
      isConfirmed: null
    }),
    _useState26 = _slicedToArray(_useState25, 2),
    filters = _useState26[0],
    setFilters = _useState26[1];
  var loadData = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var _processRes$payload, _yield$Promise$all, _yield$Promise$all2, processRes;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            setLoading(true);
            _context2.prev = 1;
            _context2.next = 4;
            return Promise.all([dispatch(fetchWorkforceEisBankAdvice({
              month: filters.month,
              year: filters.year,
              isConfirmed: filters.isConfirmed
            }))]);
          case 4:
            _yield$Promise$all = _context2.sent;
            _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 1);
            processRes = _yield$Promise$all2[0];
            setData((processRes === null || processRes === void 0 || (_processRes$payload = processRes.payload) === null || _processRes$payload === void 0 || (_processRes$payload = _processRes$payload.data) === null || _processRes$payload === void 0 ? void 0 : _processRes$payload.workforceEisBankAdvice) || []);
            _context2.next = 13;
            break;
          case 10:
            _context2.prev = 10;
            _context2.t0 = _context2["catch"](1);
            console.error("Data Load Error:", _context2.t0);
          case 13:
            _context2.prev = 13;
            setLoading(false);
            return _context2.finish(13);
          case 16:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[1, 10, 13, 16]]);
    }));
    return function loadData() {
      return _ref2.apply(this, arguments);
    };
  }();
  useEffect(function () {
    loadData();
    var confirmedExists = data.filter(function (d) {
      return d.isConfirmed == true;
    });
    if (confirmedExists.length > 0) {
      setDisableApproval(true);
    }
  }, [dispatch, modulesManager, filters]);
  var handleFilterChange = function handleFilterChange(e) {
    var _e$target = e.target,
      name = _e$target.name,
      value = _e$target.value;
    setFilters(function (prev) {
      return _objectSpread$n(_objectSpread$n({}, prev), {}, _defineProperty({}, name, value));
    });
  };
  var clearFilters = function clearFilters() {
    setFilters({
      month: currentMonth,
      year: currentYear,
      isConfirmed: null
    });
  };
  var getStatusChip = function getStatusChip(isConfirmed) {
    if (isConfirmed) return /*#__PURE__*/React.createElement(Chip, {
      label: "Confirmed",
      size: "small",
      style: {
        backgroundColor: "#e8f5e9",
        color: "#2e7d32"
      }
    });
    return /*#__PURE__*/React.createElement(Chip, {
      label: "Not Confirmed Yet",
      size: "small",
      style: {
        backgroundColor: "#f5d5d5",
        color: "#7d2e2e"
      }
    });
  };
  var handleAdviceView = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3(adviceId) {
      var _response$payload$dat, _response$payload;
      var response, dataList;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            setBtnLoading(true);
            _context3.next = 3;
            return dispatch(fetchWorkforceEisPaymentDisbursementStage({
              workforceEisBankAdviceId: safeDecodeId(adviceId)
            }, modulesManager));
          case 3:
            response = _context3.sent;
            dataList = (_response$payload$dat = response === null || response === void 0 || (_response$payload = response.payload) === null || _response$payload === void 0 || (_response$payload = _response$payload.data) === null || _response$payload === void 0 ? void 0 : _response$payload.workforceEisPaymentDisbursementStage) !== null && _response$payload$dat !== void 0 ? _response$payload$dat : [];
            setPaymentData(dataList);
            setBtnLoading(false);
          case 7:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return function handleAdviceView(_x2) {
      return _ref3.apply(this, arguments);
    };
  }();
  console.log("hello from bank advice list", data);
  return /*#__PURE__*/React.createElement(Box$1, {
    bgcolor: "#fafafa",
    minHeight: "100vh"
  }, /*#__PURE__*/React.createElement(Box$1, {
    mb: 2,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-end"
  }, /*#__PURE__*/React.createElement(Box$1, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5",
    style: {
      fontWeight: 700,
      marginBottom: 4
    }
  }, "List of Processed Bank Advice"), /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    color: "textSecondary"
  }, "Confirm Bank Advice that are approved"))), /*#__PURE__*/React.createElement(Paper, {
    elevation: 0,
    style: {
      padding: "24px",
      marginBottom: "24px",
      borderRadius: "12px",
      border: "1px solid #eceff1"
    }
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 3,
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 6,
    md: 3
  }, /*#__PURE__*/React.createElement(TextField, {
    fullWidth: true,
    select: true,
    label: "Month",
    name: "month",
    variant: "outlined",
    size: "small",
    value: filters.month || currentMonth,
    onChange: handleFilterChange
  }, /*#__PURE__*/React.createElement(MenuItem, {
    value: ""
  }, /*#__PURE__*/React.createElement("em", null, "All Months")), monthOptions.map(function (month) {
    return /*#__PURE__*/React.createElement(MenuItem, {
      key: month,
      value: month
    }, monthNames[month - 1]);
  }))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 6,
    md: 3
  }, /*#__PURE__*/React.createElement(TextField, {
    fullWidth: true,
    select: true,
    label: "Year",
    name: "year",
    variant: "outlined",
    size: "small",
    value: filters.year || currentYear,
    onChange: handleFilterChange
  }, yearOptions.map(function (year) {
    return /*#__PURE__*/React.createElement(MenuItem, {
      key: year,
      value: year
    }, year);
  }))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 6,
    md: 3
  }, /*#__PURE__*/React.createElement(TextField, {
    fullWidth: true,
    select: true,
    label: "Status",
    name: "isConfirmed",
    variant: "outlined",
    size: "small",
    value: filters.isConfirmed || null,
    onChange: handleFilterChange
  }, /*#__PURE__*/React.createElement(MenuItem, {
    key: null,
    value: null
  }, "All"), /*#__PURE__*/React.createElement(MenuItem, {
    key: true,
    value: true
  }, "Confirmed"), /*#__PURE__*/React.createElement(MenuItem, {
    key: false,
    value: false
  }, "Not Confirmed"))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 2
  }, /*#__PURE__*/React.createElement(Box$1, {
    display: "flex",
    gap: "8px"
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: loadData,
    fullWidth: true,
    variant: "contained",
    color: "primary",
    startIcon: /*#__PURE__*/React.createElement(SearchIcon, null)
  }, "Search"), /*#__PURE__*/React.createElement(Button, {
    onClick: clearFilters,
    fullWidth: true,
    variant: "text",
    color: "default",
    startIcon: /*#__PURE__*/React.createElement(ClearAllIcon, null)
  }, "Reset"))))), loading ? /*#__PURE__*/React.createElement(Box$1, {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "200px"
  }, /*#__PURE__*/React.createElement(CircularProgress$1, null)) : /*#__PURE__*/React.createElement(TableContainer, {
    component: Paper,
    elevation: 0,
    style: {
      borderRadius: "12px",
      border: "1px solid #e0e0e0"
    }
  }, /*#__PURE__*/React.createElement(Table$2, null, /*#__PURE__*/React.createElement(TableHead, {
    style: {
      backgroundColor: "#f8fafd"
    }
  }, /*#__PURE__*/React.createElement(TableRow, null, /*#__PURE__*/React.createElement(TableCell, {
    align: "center",
    style: {
      fontWeight: 600
    }
  }, "Serial"), /*#__PURE__*/React.createElement(TableCell, {
    style: {
      fontWeight: 600
    }
  }, "Advice Date"), /*#__PURE__*/React.createElement(TableCell, {
    style: {
      fontWeight: 600
    }
  }, "Name"), /*#__PURE__*/React.createElement(TableCell, {
    align: "center",
    style: {
      fontWeight: 600
    }
  }, "Status"), /*#__PURE__*/React.createElement(TableCell, {
    align: "center",
    style: {
      fontWeight: 600
    }
  }, "Action"))), /*#__PURE__*/React.createElement(TableBody, null, data.map(function (row, index) {
    return /*#__PURE__*/React.createElement(TableRow, {
      key: row.id,
      hover: true
    }, /*#__PURE__*/React.createElement(TableCell, {
      align: "center"
    }, index + 1), /*#__PURE__*/React.createElement(TableCell, null, /*#__PURE__*/React.createElement(Typography, {
      variant: "body2"
    }, new Date(row === null || row === void 0 ? void 0 : row.adviceDate).toLocaleDateString("BD-en") || "N/A")), /*#__PURE__*/React.createElement(TableCell, null, /*#__PURE__*/React.createElement(Typography, {
      variant: "body2"
    }, "".concat(new Date(2000, (row === null || row === void 0 ? void 0 : row.month) - 1).toLocaleString("en-US", {
      month: "long"
    }), ",").concat(row === null || row === void 0 ? void 0 : row.year))), /*#__PURE__*/React.createElement(TableCell, {
      align: "center"
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "body2",
      style: {
        fontWeight: 700
      }
    }, getStatusChip(row === null || row === void 0 ? void 0 : row.isConfirmed))), /*#__PURE__*/React.createElement(TableCell, {
      align: "center"
    }, /*#__PURE__*/React.createElement(Button, {
      variant: "contained",
      color: "primary",
      onClick: /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return handleAdviceView(row === null || row === void 0 ? void 0 : row.id);
            case 2:
              // setSelectedAdviceId(row?.id);
              // if (selectedAdviceId && selectedAdviceId !==null)
              // {
              setOpenGenerateBeneficiaryAdvice(true);
              // }

              // setTimeout(() => {
              //   setOpenGenerateBeneficiaryAdvice(true);
              // }, 800);
            case 3:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))
    }, btnLoading ? "Loading..." : "View Advice"), !(row !== null && row !== void 0 && row.isConfirmed) ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
      variant: "outlined",
      size: "small",
      onClick: function onClick() {
        return openApproveConfirm(row.id);
      },
      style: {
        marginLeft: 6
      }
    }, "Confirm Now")) : /*#__PURE__*/React.createElement(React.Fragment, null)));
  }))), data.length === 0 && /*#__PURE__*/React.createElement(Box$1, {
    p: 5,
    textAlign: "center"
  }, /*#__PURE__*/React.createElement(Typography, {
    color: "textSecondary"
  }, "No data found matching current filters."))), /*#__PURE__*/React.createElement(Dialog$1, {
    open: confirmOpen,
    onClose: closeApproveConfirm
  }, /*#__PURE__*/React.createElement(DialogTitle, null, "Confirm Selected Bank Advice"), /*#__PURE__*/React.createElement(DialogContent$1, null, /*#__PURE__*/React.createElement(Typography, null, "Are you sure you want to Confirm the selected bank advice?")), /*#__PURE__*/React.createElement(DialogActions$1, null, /*#__PURE__*/React.createElement(Button, {
    onClick: closeApproveConfirm,
    color: "default"
  }, "Cancel"), /*#__PURE__*/React.createElement(Button, {
    onClick: /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            _context5.next = 2;
            return handleApprove(pendingAdviceId);
          case 2:
            closeApproveConfirm();
          case 3:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    })),
    color: "primary",
    variant: "contained"
  }, "Confirm"))), /*#__PURE__*/React.createElement(GenerateBeneficiaryAdvice, {
    open: openGenerateBeneficiaryAdvice,
    onClose: function onClose() {
      return setOpenGenerateBeneficiaryAdvice(false);
    },
    paymentData: paymentData,
    month: filters.month,
    year: filters.year,
    fromAdviceList: true
  }));
};

function ownKeys$m(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$m(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$m(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$m(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var BeneficiaryDisbursedPayments = function BeneficiaryDisbursedPayments() {
  var dispatch = useDispatch();
  // Generate years dynamically (previous year to 10 years back)
  var currentYear = new Date().getFullYear();
  var currentMonth = new Date().getMonth() + 1; // Months are 0-indexed
  var yearOptions = Array.from({
    length: 11
  }, function (_, i) {
    return currentYear - i;
  });
  var monthOptions = Array.from({
    length: 12
  }, function (_, i) {
    return i + 1;
  });
  var monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
  var modulesManager = useModulesManager();
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2);
    _useState2[0];
    _useState2[1];
  var _useState3 = useState(true),
    _useState4 = _slicedToArray(_useState3, 2),
    loading = _useState4[0],
    setLoading = _useState4[1];
  var _useState5 = useState([]),
    _useState6 = _slicedToArray(_useState5, 2),
    data = _useState6[0],
    setData = _useState6[1];
  var _useState7 = useState([]),
    _useState8 = _slicedToArray(_useState7, 2);
    _useState8[0];
    _useState8[1];
  var _useState9 = useState(false),
    _useState10 = _slicedToArray(_useState9, 2);
    _useState10[0];
    _useState10[1];
  var _useState11 = useState([]),
    _useState12 = _slicedToArray(_useState11, 2);
    _useState12[0];
    _useState12[1];
  var _useState13 = useState([]),
    _useState14 = _slicedToArray(_useState13, 2),
    factories = _useState14[0],
    setFactories = _useState14[1];
  var _useState15 = useState([]),
    _useState16 = _slicedToArray(_useState15, 2),
    associations = _useState16[0],
    setAssociations = _useState16[1];
  var _useState17 = useState([]),
    _useState18 = _slicedToArray(_useState17, 2),
    committees = _useState18[0],
    setCommittees = _useState18[1];
  var handleSendSms = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(row, name) {
      var longUrl, link, month, year, message;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            longUrl = window.location.origin + "/front/workforce/confirmation?disbursement_id=".concat(safeDecodeId(row.id));
            link = longUrl; // const link = await shortenUrl(longUrl);
            month = monthNames[Number(row === null || row === void 0 ? void 0 : row.monthIndex) - 1];
            year = row === null || row === void 0 ? void 0 : row.year;
            message = "Dear beneficiary, Please confirm your payment of ".concat(month, ", ").concat(year, " From EIS-PILOT With the following link. Please Contact: 01886921030 For any query. ").concat(link);
            _context.next = 8;
            return dispatch(sendSmsNotification(row.phoneNumber, message));
          case 8:
            alert("Message Sent!");
            loadData();
            _context.next = 16;
            break;
          case 12:
            _context.prev = 12;
            _context.t0 = _context["catch"](0);
            console.error(_context.t0);
            alert("Failed to send SMS");
          case 16:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 12]]);
    }));
    return function handleSendSms(_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
  var _useState19 = useState({
      month: currentMonth,
      year: currentYear,
      isDisbursed: "all",
      factory: "",
      association: "",
      committee: ""
    }),
    _useState20 = _slicedToArray(_useState19, 2),
    filters = _useState20[0],
    setFilters = _useState20[1];
  var loadData = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var _safeDecodeId, _safeDecodeId2, _processRes$payload, _yield$Promise$all, _yield$Promise$all2, processRes, allData, filteredData;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            setLoading(true);
            _context2.prev = 1;
            dispatch(fetchWorkforceFactoriesSummary(modulesManager, [])).then(function (res) {
              var _res$payload;
              return setFactories((res === null || res === void 0 || (_res$payload = res.payload) === null || _res$payload === void 0 || (_res$payload = _res$payload.data) === null || _res$payload === void 0 || (_res$payload = _res$payload.workforceEmployerFactories) === null || _res$payload === void 0 ? void 0 : _res$payload.edges) || []);
            });
            dispatch(fetchWorkforceAllAssociationSummary([])).then(function (res) {
              var _res$payload2;
              return setAssociations((res === null || res === void 0 || (_res$payload2 = res.payload) === null || _res$payload2 === void 0 || (_res$payload2 = _res$payload2.data) === null || _res$payload2 === void 0 || (_res$payload2 = _res$payload2.workforceAllAssociation) === null || _res$payload2 === void 0 ? void 0 : _res$payload2.edges) || []);
            });
            _context2.next = 6;
            return Promise.all([dispatch(fetchWorkforceEisPaymentDisbursementStage({
              month: filters.month,
              year: filters.year,
              isDisbursed: true,
              // Only fetch disbursed payments
              workforceFactoryId: (_safeDecodeId = safeDecodeId(filters.factory)) !== null && _safeDecodeId !== void 0 ? _safeDecodeId : "",
              allAssociationId: (_safeDecodeId2 = safeDecodeId(filters.association)) !== null && _safeDecodeId2 !== void 0 ? _safeDecodeId2 : ""
              // notInDisburse: "yes"
            }, modulesManager))]);
          case 6:
            _yield$Promise$all = _context2.sent;
            _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 1);
            processRes = _yield$Promise$all2[0];
            allData = (processRes === null || processRes === void 0 || (_processRes$payload = processRes.payload) === null || _processRes$payload === void 0 || (_processRes$payload = _processRes$payload.data) === null || _processRes$payload === void 0 ? void 0 : _processRes$payload.workforceEisPaymentDisbursementStage) || [];
            filteredData = filters.committee ? allData.filter(function (row) {
              var _row$workforceApplica;
              return safeDecodeId(row === null || row === void 0 || (_row$workforceApplica = row.workforceApplication) === null || _row$workforceApplica === void 0 ? void 0 : _row$workforceApplica.committeeId) === safeDecodeId(filters.committee);
            }) : allData;
            setData(filteredData);
            _context2.next = 17;
            break;
          case 14:
            _context2.prev = 14;
            _context2.t0 = _context2["catch"](1);
            console.error("Data Load Error:", _context2.t0);
          case 17:
            _context2.prev = 17;
            setLoading(false);
            return _context2.finish(17);
          case 20:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[1, 14, 17, 20]]);
    }));
    return function loadData() {
      return _ref2.apply(this, arguments);
    };
  }();
  useEffect(function () {
    dispatch(fetchWorkforceCommittees()).then(function (res) {
      var _res$payload3;
      setCommittees((res === null || res === void 0 || (_res$payload3 = res.payload) === null || _res$payload3 === void 0 || (_res$payload3 = _res$payload3.data) === null || _res$payload3 === void 0 ? void 0 : _res$payload3.workforceCommittees) || []);
    });
  }, [dispatch]);
  useEffect(function () {
    loadData();
  }, [dispatch, modulesManager, filters]);
  var handleFilterChange = function handleFilterChange(e) {
    var _e$target = e.target,
      name = _e$target.name,
      value = _e$target.value;
    setFilters(function (prev) {
      return _objectSpread$m(_objectSpread$m({}, prev), {}, _defineProperty({}, name, value));
    });
  };
  var clearFilters = function clearFilters() {
    setFilters({
      month: currentMonth,
      year: currentYear,
      isDisbursed: "all",
      factory: "",
      association: ""
    });
  };
  var getStatusChip = function getStatusChip(row) {
    var _row$workforceEisBank;
    if (row !== null && row !== void 0 && row.isDisbursed || row !== null && row !== void 0 && (_row$workforceEisBank = row.workforceEisBankAdvice) !== null && _row$workforceEisBank !== void 0 && _row$workforceEisBank.isConfirmed) return /*#__PURE__*/React.createElement(Chip, {
      label: "Disbursed",
      size: "small",
      style: {
        backgroundColor: '#e8f5e9',
        color: '#2e7d32'
      }
    });
    return /*#__PURE__*/React.createElement(Chip, {
      label: "Processed",
      size: "small",
      variant: "outlined"
    });
  };
  var getUserConfirmationStatusChip = function getUserConfirmationStatusChip(row) {
    if (row !== null && row !== void 0 && row.userConfirmed) return /*#__PURE__*/React.createElement(Chip, {
      label: "User Confirmed",
      size: "small",
      style: {
        backgroundColor: '#e8f5e9',
        color: '#2e7d32'
      }
    });
    return /*#__PURE__*/React.createElement(Chip, {
      label: "Not Confirmed",
      size: "small",
      variant: "outlined"
    });
  };
  var handleApprove = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3(id) {
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            if (id) {
              _context3.next = 2;
              break;
            }
            return _context3.abrupt("return");
          case 2:
            _context3.next = 4;
            return dispatch(userPaymentConfirmation(safeDecodeId(id), true));
          case 4:
            // Assuming single approval for now
            loadData();
          case 5:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return function handleApprove(_x3) {
      return _ref3.apply(this, arguments);
    };
  }();
  return /*#__PURE__*/React.createElement(Box$1, {
    bgcolor: "#fafafa",
    minHeight: "100vh"
  }, /*#__PURE__*/React.createElement(Box$1, {
    mb: 2,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-end"
  }, /*#__PURE__*/React.createElement(Box$1, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5",
    style: {
      fontWeight: 700,
      marginBottom: 4
    }
  }, "List of Disbursed Payments"), /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    color: "textSecondary"
  }, "Confirmed disbursements for beneficiaries. Send confirmation SMS to beneficiaries and receive confirmation from them."))), /*#__PURE__*/React.createElement(Paper, {
    elevation: 0,
    style: {
      padding: '24px',
      marginBottom: '24px',
      borderRadius: '12px',
      border: '1px solid #eceff1'
    }
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 3,
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 6,
    md: 3
  }, /*#__PURE__*/React.createElement(TextField, {
    fullWidth: true,
    select: true,
    label: "Factory",
    name: "factory",
    variant: "outlined",
    size: "small",
    value: filters.factory,
    onChange: handleFilterChange
  }, /*#__PURE__*/React.createElement(MenuItem, {
    value: ""
  }, /*#__PURE__*/React.createElement("em", null, "All Factories")), factories.map(function (f) {
    return /*#__PURE__*/React.createElement(MenuItem, {
      key: f.node.id,
      value: f.node.id
    }, f.node.nameBn || f.node.nameEn);
  }))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 6,
    md: 3
  }, /*#__PURE__*/React.createElement(TextField, {
    fullWidth: true,
    select: true,
    label: "Association",
    name: "association",
    variant: "outlined",
    size: "small",
    value: filters.association,
    onChange: handleFilterChange
  }, /*#__PURE__*/React.createElement(MenuItem, {
    value: ""
  }, /*#__PURE__*/React.createElement("em", null, "All Associations")), associations.map(function (a) {
    return /*#__PURE__*/React.createElement(MenuItem, {
      key: a.node.id,
      value: a.node.id
    }, a.node.shortNameBn || a.node.nameEn);
  }))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 6,
    md: 3
  }, /*#__PURE__*/React.createElement(TextField, {
    fullWidth: true,
    select: true,
    label: "Committee",
    name: "committee",
    variant: "outlined",
    size: "small",
    value: filters.committee,
    onChange: handleFilterChange
  }, /*#__PURE__*/React.createElement(MenuItem, {
    value: ""
  }, /*#__PURE__*/React.createElement("em", null, "All Committees")), committees.map(function (committee) {
    return /*#__PURE__*/React.createElement(MenuItem, {
      key: committee.id,
      value: committee.id
    }, committee.nameBn || committee.nameEn || committee.id);
  }))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 6,
    md: 3
  }, /*#__PURE__*/React.createElement(TextField, {
    fullWidth: true,
    select: true,
    label: "Month",
    name: "month",
    variant: "outlined",
    size: "small",
    value: filters.month || currentMonth,
    onChange: handleFilterChange
  }, /*#__PURE__*/React.createElement(MenuItem, {
    value: ""
  }, /*#__PURE__*/React.createElement("em", null, "All Months")), monthOptions.map(function (month) {
    return /*#__PURE__*/React.createElement(MenuItem, {
      key: month,
      value: month
    }, monthNames[month - 1]);
  }))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 6,
    md: 3
  }, /*#__PURE__*/React.createElement(TextField, {
    fullWidth: true,
    select: true,
    label: "Year",
    name: "year",
    variant: "outlined",
    size: "small",
    value: filters.year || currentYear,
    onChange: handleFilterChange
  }, yearOptions.map(function (year) {
    return /*#__PURE__*/React.createElement(MenuItem, {
      key: year,
      value: year
    }, year);
  }))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 2
  }, /*#__PURE__*/React.createElement(Box$1, {
    display: "flex",
    gap: "8px"
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: loadData,
    fullWidth: true,
    variant: "contained",
    color: "primary",
    startIcon: /*#__PURE__*/React.createElement(SearchIcon, null)
  }, "Search"), /*#__PURE__*/React.createElement(Button, {
    onClick: clearFilters,
    fullWidth: true,
    variant: "text",
    color: "default",
    startIcon: /*#__PURE__*/React.createElement(ClearAllIcon, null)
  }, "Reset"))))), loading ? /*#__PURE__*/React.createElement(Box$1, {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "200px"
  }, /*#__PURE__*/React.createElement(CircularProgress$1, null)) : /*#__PURE__*/React.createElement(TableContainer, {
    component: Paper,
    elevation: 0,
    style: {
      borderRadius: '12px',
      border: '1px solid #e0e0e0'
    }
  }, /*#__PURE__*/React.createElement(Table$2, null, /*#__PURE__*/React.createElement(TableHead, {
    style: {
      backgroundColor: '#f8fafd'
    }
  }, /*#__PURE__*/React.createElement(TableRow, null, /*#__PURE__*/React.createElement(TableCell, {
    style: {
      fontWeight: 600
    }
  }, "Beneficiary Details"), /*#__PURE__*/React.createElement(TableCell, {
    style: {
      fontWeight: 600
    }
  }, "Worker, Factory & Association"), /*#__PURE__*/React.createElement(TableCell, {
    style: {
      fontWeight: 600
    }
  }, "Payment Method"), /*#__PURE__*/React.createElement(TableCell, {
    align: "right",
    style: {
      fontWeight: 600
    }
  }, "Amounts"), /*#__PURE__*/React.createElement(TableCell, {
    align: "center",
    style: {
      fontWeight: 600
    }
  }, "Status"), /*#__PURE__*/React.createElement(TableCell, {
    align: "center",
    style: {
      fontWeight: 600
    }
  }, "Action"))), /*#__PURE__*/React.createElement(TableBody, null, data.map(function (row) {
    var _row$workforceEmploye, _row$workforceApplica2, _row$workforceApplica3, _safeParse, _row$workforceApplica4, _row$workforceApplica5, _row$workforceApplica6, _row$workforceApplica7, _row$workforceApplica8, _row$workforceApplica9, _row$workforceApplica10, _row$bank, _row$bank2, _row$bank3, _row$bank4, _row$bank5, _Number$toLocaleStrin, _Number$toLocaleStrin2, _row$workforceEisBank2, _row$workforceEisBank3, _row$workforceEisBank4;
    var dep = (row === null || row === void 0 || (_row$workforceEmploye = row.workforceEmployeeDependent) === null || _row$workforceEmploye === void 0 ? void 0 : _row$workforceEmploye[0]) || {};
    var worker = (row === null || row === void 0 || (_row$workforceApplica2 = row.workforceApplication) === null || _row$workforceApplica2 === void 0 ? void 0 : _row$workforceApplica2.applicationType) === "financialAssistance" || (row === null || row === void 0 || (_row$workforceApplica3 = row.workforceApplication) === null || _row$workforceApplica3 === void 0 ? void 0 : _row$workforceApplica3.applicationType) === "deadlyGrant" ? (_safeParse = safeParse(row === null || row === void 0 || (_row$workforceApplica4 = row.workforceApplication) === null || _row$workforceApplica4 === void 0 ? void 0 : _row$workforceApplica4.deceasedWorkerInfo)) === null || _safeParse === void 0 ? void 0 : _safeParse.nameEn : row === null || row === void 0 || (_row$workforceApplica5 = row.workforceApplication) === null || _row$workforceApplica5 === void 0 || (_row$workforceApplica5 = _row$workforceApplica5.workforceEmployee) === null || _row$workforceApplica5 === void 0 ? void 0 : _row$workforceApplica5.firstNameEn;
    return /*#__PURE__*/React.createElement(TableRow, {
      key: row.id,
      hover: true
    }, /*#__PURE__*/React.createElement(TableCell, null, /*#__PURE__*/React.createElement(Typography, {
      variant: "subtitle2",
      style: {
        fontWeight: 600
      }
    }, (dep === null || dep === void 0 ? void 0 : dep.nameEn) || (dep === null || dep === void 0 ? void 0 : dep.nameBn) || (row === null || row === void 0 || (_row$workforceApplica6 = row.workforceApplication) === null || _row$workforceApplica6 === void 0 || (_row$workforceApplica6 = _row$workforceApplica6.workforceEmployee) === null || _row$workforceApplica6 === void 0 ? void 0 : _row$workforceApplica6.firstNameEn) || "—"), /*#__PURE__*/React.createElement(Typography, {
      variant: "caption",
      color: "primary"
    }, getRelationString(dep)), /*#__PURE__*/React.createElement(Box$1, {
      mt: 0.5,
      mb: 0.5
    }, /*#__PURE__*/React.createElement(Chip, {
      label: row.beneficiaryId,
      variant: "outlined",
      style: {
        height: 20
      }
    })), /*#__PURE__*/React.createElement(Typography, {
      variant: "caption",
      display: "block",
      color: "textSecondary"
    }, "ATN: " + (row === null || row === void 0 || (_row$workforceApplica7 = row.workforceApplication) === null || _row$workforceApplica7 === void 0 ? void 0 : _row$workforceApplica7.trackingNumber) || "N/A")), /*#__PURE__*/React.createElement(TableCell, null, /*#__PURE__*/React.createElement(Typography, {
      variant: "body2",
      style: {
        fontWeight: 500
      }
    }, worker), /*#__PURE__*/React.createElement(Typography, {
      variant: "caption",
      display: "block",
      color: "textSecondary"
    }, row === null || row === void 0 || (_row$workforceApplica8 = row.workforceApplication) === null || _row$workforceApplica8 === void 0 || (_row$workforceApplica8 = _row$workforceApplica8.employeeFactory) === null || _row$workforceApplica8 === void 0 ? void 0 : _row$workforceApplica8.nameEn), /*#__PURE__*/React.createElement(Typography, {
      variant: "caption",
      display: "block",
      color: "textSecondary"
    }, (row === null || row === void 0 || (_row$workforceApplica9 = row.workforceApplication) === null || _row$workforceApplica9 === void 0 || (_row$workforceApplica9 = _row$workforceApplica9.employeeFactory) === null || _row$workforceApplica9 === void 0 || (_row$workforceApplica9 = _row$workforceApplica9.allAssociation) === null || _row$workforceApplica9 === void 0 ? void 0 : _row$workforceApplica9.shortNameEn) || (row === null || row === void 0 || (_row$workforceApplica10 = row.workforceApplication) === null || _row$workforceApplica10 === void 0 || (_row$workforceApplica10 = _row$workforceApplica10.employeeFactory) === null || _row$workforceApplica10 === void 0 || (_row$workforceApplica10 = _row$workforceApplica10.allAssociation) === null || _row$workforceApplica10 === void 0 ? void 0 : _row$workforceApplica10.nameEn) || "N/A")), /*#__PURE__*/React.createElement(TableCell, null, /*#__PURE__*/React.createElement(Typography, {
      variant: "body2"
    }, ((_row$bank = row.bank) === null || _row$bank === void 0 || (_row$bank = _row$bank.parent) === null || _row$bank === void 0 ? void 0 : _row$bank.nameEn) || "N/A"), /*#__PURE__*/React.createElement(Typography, {
      variant: "body2"
    }, ((_row$bank2 = row.bank) === null || _row$bank2 === void 0 ? void 0 : _row$bank2.nameEn) + " (Routing #" + ((row === null || row === void 0 || (_row$bank3 = row.bank) === null || _row$bank3 === void 0 ? void 0 : _row$bank3.routingNumber) == '0' || (row === null || row === void 0 || (_row$bank4 = row.bank) === null || _row$bank4 === void 0 ? void 0 : _row$bank4.routingNumber) == null ? row === null || row === void 0 ? void 0 : row.routingNumber : row === null || row === void 0 || (_row$bank5 = row.bank) === null || _row$bank5 === void 0 ? void 0 : _row$bank5.routingNumber) + ")" || "N/A"), /*#__PURE__*/React.createElement(Typography, {
      variant: "caption",
      color: "textSecondary"
    }, "A/C: " + row.bankAccountNo)), /*#__PURE__*/React.createElement(TableCell, {
      align: "right"
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "body2",
      style: {
        fontWeight: 700
      }
    }, (_Number$toLocaleStrin = Number(row === null || row === void 0 ? void 0 : row.paidAmount).toLocaleString("en-BD")) !== null && _Number$toLocaleStrin !== void 0 ? _Number$toLocaleStrin : Number(row === null || row === void 0 ? void 0 : row.paidAmount).toLocaleString("en-BD")), /*#__PURE__*/React.createElement(Typography, {
      variant: "caption",
      color: "textSecondary"
    }, "Total: " + ((_Number$toLocaleStrin2 = Number(row === null || row === void 0 ? void 0 : row.eisApprovedAmount).toLocaleString("en-BD")) !== null && _Number$toLocaleStrin2 !== void 0 ? _Number$toLocaleStrin2 : "--")), /*#__PURE__*/React.createElement(Typography, {
      variant: "body2",
      style: {
        fontWeight: 700
      }
    }, getPaymentTypeString(row.eisPaymentType))), /*#__PURE__*/React.createElement(TableCell, {
      align: "center"
    }, getStatusChip(row), /*#__PURE__*/React.createElement(Box$1, {
      mt: 2
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "caption",
      style: {
        display: "block"
      },
      color: "textSecondary"
    }, row !== null && row !== void 0 && row.isDisbursed && row !== null && row !== void 0 && row.disbursementDate || row !== null && row !== void 0 && (_row$workforceEisBank2 = row.workforceEisBankAdvice) !== null && _row$workforceEisBank2 !== void 0 && _row$workforceEisBank2.isConfirmed && row !== null && row !== void 0 && (_row$workforceEisBank3 = row.workforceEisBankAdvice) !== null && _row$workforceEisBank3 !== void 0 && _row$workforceEisBank3.confirmationDate ? "Disbursed on: ".concat(new Date((row === null || row === void 0 ? void 0 : row.disbursementDate) || (row === null || row === void 0 || (_row$workforceEisBank4 = row.workforceEisBankAdvice) === null || _row$workforceEisBank4 === void 0 ? void 0 : _row$workforceEisBank4.confirmationDate)).toLocaleDateString("en-GB")) : ""), /*#__PURE__*/React.createElement(Typography, {
      variant: "caption",
      style: {
        display: "block"
      },
      color: "textSecondary"
    }, row !== null && row !== void 0 && row.processingDate ? "Payment Processed on: ".concat(new Date(row === null || row === void 0 ? void 0 : row.processingDate).toLocaleDateString("en-GB")) : ""))), /*#__PURE__*/React.createElement(TableCell, {
      align: "center"
    }, row !== null && row !== void 0 && row.userConfirmed ? /*#__PURE__*/React.createElement(React.Fragment, null, getUserConfirmationStatusChip(row)) : /*#__PURE__*/React.createElement(React.Fragment, null, getUserConfirmationStatusChip(row), /*#__PURE__*/React.createElement(Button, {
      variant: "outlined",
      size: "small",
      onClick: function onClick() {
        return handleApprove(row.id);
      },
      style: {
        marginLeft: 6
      }
    }, "Confirm Manually"), /*#__PURE__*/React.createElement(Button, {
      variant: "contained",
      color: "primary",
      size: "small",
      startIcon: /*#__PURE__*/React.createElement(EmailIcon, null),
      onClick: function onClick() {
        var _row$workforceApplica11;
        return handleSendSms(row, (dep === null || dep === void 0 ? void 0 : dep.nameEn) || (dep === null || dep === void 0 ? void 0 : dep.nameBn) || (row === null || row === void 0 || (_row$workforceApplica11 = row.workforceApplication) === null || _row$workforceApplica11 === void 0 || (_row$workforceApplica11 = _row$workforceApplica11.workforceEmployee) === null || _row$workforceApplica11 === void 0 ? void 0 : _row$workforceApplica11.firstNameBn) || "—");
      },
      style: {
        margin: "5px"
      }
    }, "Send SMS Again"))));
  }))), data.length === 0 && /*#__PURE__*/React.createElement(Box$1, {
    p: 5,
    textAlign: "center"
  }, /*#__PURE__*/React.createElement(Typography, {
    color: "textSecondary"
  }, "No data found matching current filters."))));
};

var useStyles$m = makeStyles(function (theme) {
  return {
    noPrint: {
      '@media print': {
        display: 'none !important'
      }
    },
    dialogPaper: {
      minWidth: "90vw",
      "@media print": {
        boxShadow: "none",
        border: "none",
        minWidth: "100%",
        margin: 0,
        maxWidth: "100% !important"
      }
    },
    dialogContent: {
      backgroundColor: "#fff",
      padding: theme.spacing(2),
      "@media print": {
        padding: "0 !important",
        overflow: "visible !important"
      }
    },
    "@global": {
      ".noa-page": {
        width: "100%",
        fontFamily: "Arial, Helvetica, sans-serif",
        color: "#000",
        fontSize: "12px",
        position: "relative",
        background: "#fff"
      },
      ".noa-header": {
        textAlign: "center",
        marginBottom: "10px",
        position: "relative"
      },
      ".noa-header h3": {
        margin: "4px 0",
        fontSize: "18px",
        fontWeight: 700
      },
      ".noa-header h4": {
        margin: "8px 0",
        fontSize: "15px",
        fontWeight: 700
      },
      ".noa-body": {
        marginTop: "10px"
      },
      ".noa-table": {
        width: "100%",
        borderCollapse: "collapse",
        tableLayout: "fixed",
        border: "1px solid #000",
        fontSize: "12px"
      },
      ".noa-table tbody tr": {
        pageBreakInside: "avoid"
      },
      ".noa-table td": {
        border: "1px solid #000",
        padding: "3px 6px",
        verticalAlign: "middle",
        lineHeight: "1.25",
        wordBreak: "break-word"
      },
      ".noa-label": {
        width: "50%",
        fontWeight: 600,
        textAlign: "left"
      },
      ".noa-value": {
        width: "50%",
        textAlign: "left"
      },
      ".noa-section": {
        textAlign: "center",
        fontWeight: "bold",
        backgroundColor: "#f5f5f5",
        fontSize: "12px",
        padding: "5px"
      },
      ".noa-additional-info": {
        marginTop: "12px",
        fontSize: "12px",
        lineHeight: "1.5"
      },
      ".noa-additional-info ol": {
        marginTop: "5px",
        paddingLeft: "20px"
      },
      ".noa-additional-info li": {
        marginBottom: "4px"
      },
      ".noa-footer": {
        marginTop: "35px",
        textAlign: "right"
      },
      ".noa-signature": {
        display: "inline-block",
        minWidth: "250px",
        textAlign: "center"
      },
      ".noa-signature img": {
        maxHeight: "70px",
        marginBottom: "4px"
      },
      "@media print": {
        "body *": {
          visibility: "hidden"
        },
        "#printable-content, #printable-content *": {
          visibility: "visible"
        },
        "#printable-content": {
          position: "absolute",
          left: 0,
          top: 0,
          width: "100%"
        },
        "html, body": {
          height: "100%",
          overflow: "hidden"
        },
        ".noa-page": {
          width: "100%",
          margin: 0,
          padding: 0
        },
        ".noa-table": {
          width: "100%",
          borderCollapse: "collapse"
        },
        ".noa-table td": {
          border: "1px solid #000 !important",
          padding: "3px 6px !important"
        }
      }
    }
  };
});
var GenerateNoaView = function GenerateNoaView(_ref) {
  var _reduxState$core, _row$workforceApplica, _row$workforceApplica2, _row$workforceEmploye, _row$workforceEmploye2, _row$workforceApplica6, _row$workforceApplica7, _row$workforceApplica8, _row$workforceApplica9, _ref3, _deceasedWorkerInfo$b, _row$workforceApplica10, _noaSignature$url, _row$workforceApplica11, _row$workforceApplica12, _row$workforceApplica13, _row$workforceApplica14, _row$workforceApplica15, _row$workforceApplica16, _row$workforceApplica17, _row$workforceApplica18, _row$workforceApplica19, _row$workforceApplica20, _row$workforceApplica21, _row$workforceEmploye3, _row$workforceEmploye4, _row$workforceEmploye5, _row$workforceEmploye6, _row$workforceEmploye7, _row$workforceEmploye8, _row$workforceEmploye9, _employeeAccidentInfo, _row$workforceEmploye10, _noaSigner$workforceC, _noaSigner$workforceC2, _noaSigner$committee, _noaSigner$committee2;
  var open = _ref.open,
    onClose = _ref.onClose;
    _ref.onSuccess;
    var row = _ref.row;
  var dispatch = useDispatch();
  var modulesManager = useModulesManager();
  var classes = useStyles$m();
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2);
    _useState2[0];
    _useState2[1];
  var _useState3 = useState(""),
    _useState4 = _slicedToArray(_useState3, 2),
    topHtml = _useState4[0];
    _useState4[1];
  var _useState5 = useState(""),
    _useState6 = _slicedToArray(_useState5, 2);
    _useState6[0];
    _useState6[1];
  var _useState7 = useState(""),
    _useState8 = _slicedToArray(_useState7, 2);
    _useState8[0];
    _useState8[1];
  var _useState9 = useState(0),
    _useState10 = _slicedToArray(_useState9, 2),
    otherCompAmount = _useState10[0],
    setOtherCompAmount = _useState10[1];
  var _useState11 = useState({
      noaSigner: null,
      noaSignature: null
    }),
    _useState12 = _slicedToArray(_useState11, 2);
    _useState12[0];
    _useState12[1];
  var _useState13 = useState(null),
    _useState14 = _slicedToArray(_useState13, 2),
    noaSignature = _useState14[0],
    setNoaSignature = _useState14[1];
  var _useState15 = useState(null),
    _useState16 = _slicedToArray(_useState15, 2),
    noaSigner = _useState16[0],
    setNoaSigner = _useState16[1];
  var reduxState = useSelector(function (state) {
    return state;
  });
  var locale = (reduxState === null || reduxState === void 0 || (_reduxState$core = reduxState.core) === null || _reduxState$core === void 0 || (_reduxState$core = _reduxState$core.user) === null || _reduxState$core === void 0 || (_reduxState$core = _reduxState$core.i_user) === null || _reduxState$core === void 0 ? void 0 : _reduxState$core.language) || "en";
  var tryParse = function tryParse(value) {
    if (typeof value === "string") {
      try {
        var parsed = JSON.parse(value);
        if (_typeof(parsed) === "object" && parsed !== null) {
          return parsed;
        }
      } catch (_unused) {
        return value;
      }
    }
    return value;
  };
  var formatAddress = function formatAddress(locationData, addressData) {
    var _address$postOffice, _location$parent, _location$parent2, _location$parent3;
    var address = tryParse(addressData) || {};
    var location = tryParse(locationData) || {};
    var postOffice = (address === null || address === void 0 || (_address$postOffice = address.postOffice) === null || _address$postOffice === void 0 ? void 0 : _address$postOffice.nameBn) || (address === null || address === void 0 ? void 0 : address.postOffice);
    var village = [address.houseName, address.paraMahalla, address.villageRoad].filter(Boolean).join(", ");
    var thana = (location === null || location === void 0 || (_location$parent = location.parent) === null || _location$parent === void 0 ? void 0 : _location$parent.name) || (location === null || location === void 0 ? void 0 : location.name);
    var district = (location === null || location === void 0 || (_location$parent2 = location.parent) === null || _location$parent2 === void 0 || (_location$parent2 = _location$parent2.parent) === null || _location$parent2 === void 0 ? void 0 : _location$parent2.name) || (location === null || location === void 0 || (_location$parent3 = location.parent) === null || _location$parent3 === void 0 ? void 0 : _location$parent3.name);
    return {
      village: village,
      postOffice: postOffice,
      thana: thana,
      district: district
    };
  };
  var getRoleInCommitteeLabel = function getRoleInCommitteeLabel() {
    var role = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "Member";
    var locale = arguments.length > 1 ? arguments[1] : undefined;
    switch (role) {
      case "Member":
        return locale === "fr" ? "সদস্য" : "Member";
      case "Member Secretary":
        return locale === "fr" ? "সদস্য সচিব" : "Member Secretary";
      case "Chairman":
        return locale === "fr" ? "চেয়ারম্যান" : "Chairman";
      default:
        return role;
    }
  };
  var employeePresentAddress = formatAddress(row === null || row === void 0 || (_row$workforceApplica = row.workforceApplication) === null || _row$workforceApplica === void 0 || (_row$workforceApplica = _row$workforceApplica.workforceEmployee) === null || _row$workforceApplica === void 0 ? void 0 : _row$workforceApplica.presentLocation, row === null || row === void 0 || (_row$workforceApplica2 = row.workforceApplication) === null || _row$workforceApplica2 === void 0 || (_row$workforceApplica2 = _row$workforceApplica2.workforceEmployee) === null || _row$workforceApplica2 === void 0 ? void 0 : _row$workforceApplica2.presentAddress);
  var depentPresentAddress = formatAddress(row === null || row === void 0 || (_row$workforceEmploye = row.workforceEmployeeDependent) === null || _row$workforceEmploye === void 0 || (_row$workforceEmploye = _row$workforceEmploye[0]) === null || _row$workforceEmploye === void 0 ? void 0 : _row$workforceEmploye.presentLocation, row === null || row === void 0 || (_row$workforceEmploye2 = row.workforceEmployeeDependent) === null || _row$workforceEmploye2 === void 0 || (_row$workforceEmploye2 = _row$workforceEmploye2[0]) === null || _row$workforceEmploye2 === void 0 ? void 0 : _row$workforceEmploye2.presentAddress);
  useEffect(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var _row$workforceApplica3, _row$workforceApplica5;
    var _row$workforceApplica4, eisApprovedByIds, _signatureResult$payl, _signerResult$payload, _yield$Promise$all, _yield$Promise$all2, signatureResult, signerResult;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          if (row !== null && row !== void 0 && (_row$workforceApplica3 = row.workforceApplication) !== null && _row$workforceApplica3 !== void 0 && _row$workforceApplica3.id) {
            dispatch(fetchWorkforceOtherCompensation(modulesManager, ["workforceApplicationId: \"".concat(safeDecodeId(row === null || row === void 0 || (_row$workforceApplica4 = row.workforceApplication) === null || _row$workforceApplica4 === void 0 ? void 0 : _row$workforceApplica4.id), "\"")])).then(function (res) {
              var _res$payload;
              var fetchOtherCompensation = parseData(res === null || res === void 0 || (_res$payload = res.payload) === null || _res$payload === void 0 || (_res$payload = _res$payload.data) === null || _res$payload === void 0 ? void 0 : _res$payload.workforceOtherCompensationInfo);
              var amount = 0;
              fetchOtherCompensation.forEach(function (element) {
                var _element$amount;
                amount += Number((_element$amount = element === null || element === void 0 ? void 0 : element.amount) !== null && _element$amount !== void 0 ? _element$amount : 0);
              });
              setOtherCompAmount(amount);
            });
          }
          console.log("Working Row", row);
          eisApprovedByIds = safeParse(row === null || row === void 0 || (_row$workforceApplica5 = row.workforceApplication) === null || _row$workforceApplica5 === void 0 ? void 0 : _row$workforceApplica5.eisApprovedByIds) || [];
          console.log(eisApprovedByIds, "eisApprovedByIds");
          if (!(eisApprovedByIds.length > 0)) {
            _context.next = 15;
            break;
          }
          _context.next = 7;
          return Promise.all([dispatch(fetchWorkforceNoaSignatureByApprovers(eisApprovedByIds)), dispatch(fetchWorkforceNoaSignerUserByApprovers(eisApprovedByIds))]);
        case 7:
          _yield$Promise$all = _context.sent;
          _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 2);
          signatureResult = _yield$Promise$all2[0];
          signerResult = _yield$Promise$all2[1];
          setNoaSignature(((_signatureResult$payl = signatureResult.payload) === null || _signatureResult$payl === void 0 || (_signatureResult$payl = _signatureResult$payl.data) === null || _signatureResult$payl === void 0 ? void 0 : _signatureResult$payl.fetchNoaSignatureByApprovers) || null);
          setNoaSigner(((_signerResult$payload = signerResult.payload) === null || _signerResult$payload === void 0 || (_signerResult$payload = _signerResult$payload.data) === null || _signerResult$payload === void 0 ? void 0 : _signerResult$payload.fetchWorkforceNoaSignerUserByApprovers) || null);
          _context.next = 17;
          break;
        case 15:
          setNoaSignature(null);
          setNoaSigner(null);
        case 17:
        case "end":
          return _context.stop();
      }
    }, _callee);
  })), [open, dispatch, modulesManager]);
  var handleDialogPrint = function handleDialogPrint() {
    window.print();
  };
  var cfAndEisAmount = (parseFloat(row === null || row === void 0 ? void 0 : row.eisMonthlyAmount) || 0) + (parseFloat(otherCompAmount) || 0);
  var applicationType = row === null || row === void 0 || (_row$workforceApplica6 = row.workforceApplication) === null || _row$workforceApplica6 === void 0 ? void 0 : _row$workforceApplica6.applicationType;
  var jsonEmployeeAccidentInfo = safeParse((row === null || row === void 0 || (_row$workforceApplica7 = row.workforceApplication) === null || _row$workforceApplica7 === void 0 ? void 0 : _row$workforceApplica7.employeeAccidentInfo) || "{}");
  console.log({
    jsonEmployeeAccidentInfo: jsonEmployeeAccidentInfo
  });
  var employeeAccidentInfo = jsonEmployeeAccidentInfo;
  var jsonDoctorEntryInfo = safeParse((row === null || row === void 0 || (_row$workforceApplica8 = row.workforceApplication) === null || _row$workforceApplica8 === void 0 ? void 0 : _row$workforceApplica8.doctorsEntry) || "{}");
  console.log({
    jsonDoctorEntryInfo: jsonDoctorEntryInfo
  });
  var doctorEntryInfo = jsonDoctorEntryInfo;

  // Use absolute paths for assets (adjust if your public folder path is different)
  var logo = /*#__PURE__*/React.createElement("img", {
    src: window.location.origin + "/front/workforce_assets/centralfund.png",
    alt: "Central Fund Logo",
    style: {
      width: "70px",
      position: "absolute",
      top: "0",
      right: "0"
    }
  });
  var eisLogo = /*#__PURE__*/React.createElement("img", {
    src: window.location.origin + "/front/workforce_assets/eis.png",
    alt: "EIS Logo",
    style: {
      width: "80px",
      position: "absolute",
      top: "8pt",
      left: "0"
    }
  });
  var deceasedWorkerInfo = safeParse(row === null || row === void 0 || (_row$workforceApplica9 = row.workforceApplication) === null || _row$workforceApplica9 === void 0 ? void 0 : _row$workforceApplica9.deceasedWorkerInfo);
  var workerBirthDate = (_ref3 = (_deceasedWorkerInfo$b = deceasedWorkerInfo === null || deceasedWorkerInfo === void 0 ? void 0 : deceasedWorkerInfo.birthDate) !== null && _deceasedWorkerInfo$b !== void 0 ? _deceasedWorkerInfo$b : row === null || row === void 0 || (_row$workforceApplica10 = row.workforceApplication) === null || _row$workforceApplica10 === void 0 || (_row$workforceApplica10 = _row$workforceApplica10.workforceEmployee) === null || _row$workforceApplica10 === void 0 ? void 0 : _row$workforceApplica10.birthDate) !== null && _ref3 !== void 0 ? _ref3 : "2026-01-01";
  var paymentType = row === null || row === void 0 ? void 0 : row.eisPaymentType;
  console.log("noa signature", noaSignature);
  var deceasedEmployeePresentAddress = formatAddress(deceasedWorkerInfo === null || deceasedWorkerInfo === void 0 ? void 0 : deceasedWorkerInfo.presentLocation, deceasedWorkerInfo === null || deceasedWorkerInfo === void 0 ? void 0 : deceasedWorkerInfo.presentAddress);
  var noaSignatureLogo = /*#__PURE__*/React.createElement("img", {
    src: window.location.origin + ((_noaSignature$url = noaSignature === null || noaSignature === void 0 ? void 0 : noaSignature.url) !== null && _noaSignature$url !== void 0 ? _noaSignature$url : ""),
    alt: "Central Fund Logo",
    style: {
      height: "70px"
    }
  });
  if (!row || row == null || row == 'undefined') return /*#__PURE__*/React.createElement(React.Fragment, null);else return /*#__PURE__*/React.createElement(Dialog$1, {
    open: open,
    onClose: onClose,
    maxWidth: "lg",
    fullWidth: true,
    classes: {
      paper: classes.dialogPaper
    },
    PaperProps: {
      id: "printable-content"
    }
  }, /*#__PURE__*/React.createElement(DialogTitle, {
    disableTypography: true,
    className: classes.noPrint
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6"
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "EIS Notice of Award Certificate for Beneficary"
  }))), /*#__PURE__*/React.createElement(DialogContent$1, {
    className: classes.dialogContent
  }, topHtml ? /*#__PURE__*/React.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: topHtml
    }
  }) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "noa-page"
  }, /*#__PURE__*/React.createElement("div", {
    className: "noa-header"
  }, /*#__PURE__*/React.createElement("div", null, eisLogo, /*#__PURE__*/React.createElement("p", {
    style: {
      margin: 0
    }
  }, "\u09AC\u09CD\u09AF\u0995\u09CD\u09A4\u09BF\u0997\u09A4"), /*#__PURE__*/React.createElement("h3", {
    style: {
      margin: "5px 0"
    }
  }, "\u098F\u09AE\u09AA\u09CD\u09B2\u09AF\u09BC\u09AE\u09C7\u09A8\u09CD\u099F \u0987\u09A8\u099C\u09C1\u09B0\u09BF \u09B8\u09CD\u0995\u09C0\u09AE-(\u0987.\u0986\u0987.\u098F\u09B8) \u09AA\u09BE\u0987\u09B2\u099F"), /*#__PURE__*/React.createElement("p", {
    style: {
      margin: "2px 0"
    }
  }, "\u09E7\u09EF\u09EC, \u09E7\u09E6\u09AE \u09A4\u09B2\u09BE, \u09B6\u09CD\u09B0\u09AE \u09AD\u09AC\u09A8, \u09B6\u09B9\u09C0\u09A6 \u09B8\u09C8\u09AF\u09BC\u09A6 \u09A8\u099C\u09B0\u09C1\u09B2 \u0987\u09B8\u09B2\u09BE\u09AE \u09B8\u09B0\u09A8\u09C0, \u09AC\u09BF\u099C\u09AF\u09BC\u09A8\u0997\u09B0, \u09A2\u09BE\u0995\u09BE-\u09E7\u09E6\u09E6\u09E6"), logo, /*#__PURE__*/React.createElement("p", {
    style: {
      margin: "2px 0"
    }
  }, "\u09AE\u09CB\u09AC\u09BE\u0987\u09B2: \u09E6\u09E7\u09EE\u09EE\u09EC-\u09EF\u09E8\u09E7\u09E6\u09E9\u09E6 | \u0987-\u09AE\u09C7\u0987\u09B2: verification@eis-pilot-bd.org | \u0993\u09AF\u09BC\u09C7\u09AC\u09B8\u09BE\u0987\u099F: eis-pilot-bd.org"), /*#__PURE__*/React.createElement("h4", {
    style: {
      margin: "10px 0"
    }
  }, applicationType === "financialAssistance" ? "নোটিশ অফ অ্যাওয়ার্ড- কর্মরত অবস্থায় দুর্ঘটনাজনিত মৃত্যু" : applicationType === "disabilityAssistance" ? "নোটিশ অফ অ্যাওয়ার্ড- কর্মরত অবস্থায় দুর্ঘটনাজনিত স্থায়ী আংশিক/সম্পূর্ণ অক্ষমতা" : ""), /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      justifyContent: "space-between",
      padding: "0 25mm",
      marginTop: "10px"
    }
  }, /*#__PURE__*/React.createElement("span", null, "\u09B8\u09C2\u09A4\u09CD\u09B0: ", (row === null || row === void 0 ? void 0 : row.beneficiaryId) || ""), /*#__PURE__*/React.createElement("span", null, "\u09A4\u09BE\u09B0\u09BF\u0996: ", new Date().toLocaleDateString("bn-BD"))))), /*#__PURE__*/React.createElement("div", {
    className: "noa-body"
  }, /*#__PURE__*/React.createElement("table", {
    className: "noa-table"
  }, /*#__PURE__*/React.createElement("colgroup", null, /*#__PURE__*/React.createElement("col", {
    style: {
      width: "50%"
    }
  }), /*#__PURE__*/React.createElement("col", {
    style: {
      width: "50%"
    }
  })), /*#__PURE__*/React.createElement("tbody", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    colSpan: 2,
    className: "noa-section"
  }, applicationType === "financialAssistance" ? "মৃত" : "অক্ষম", " \u09B6\u09CD\u09B0\u09AE\u09BF\u0995\u09C7\u09B0 \u09A4\u09A5\u09CD\u09AF:")), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    className: "noa-label"
  }, "\u09B6\u09CD\u09B0\u09AE\u09BF\u0995\u09C7\u09B0 \u09A8\u09BE\u09AE:"), (row === null || row === void 0 || (_row$workforceApplica11 = row.workforceApplication) === null || _row$workforceApplica11 === void 0 ? void 0 : _row$workforceApplica11.applicationType) === "financialAssistance" ? /*#__PURE__*/React.createElement("td", {
    className: "noa-value"
  }, (deceasedWorkerInfo === null || deceasedWorkerInfo === void 0 ? void 0 : deceasedWorkerInfo.nameBn) || "") : /*#__PURE__*/React.createElement("td", {
    className: "noa-value"
  }, (row === null || row === void 0 || (_row$workforceApplica12 = row.workforceApplication) === null || _row$workforceApplica12 === void 0 || (_row$workforceApplica12 = _row$workforceApplica12.workforceEmployee) === null || _row$workforceApplica12 === void 0 ? void 0 : _row$workforceApplica12.firstNameBn) || "")), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    className: "noa-label"
  }, "\u09B6\u09CD\u09B0\u09AE\u09BF\u0995\u09C7\u09B0 \u099C\u09BE\u09A4\u09C0\u09AF\u09BC \u09AA\u09B0\u09BF\u099A\u09AF\u09BC\u09AA\u09A4\u09CD\u09B0 \u09A8\u09AE\u09CD\u09AC\u09B0:"), (row === null || row === void 0 || (_row$workforceApplica13 = row.workforceApplication) === null || _row$workforceApplica13 === void 0 ? void 0 : _row$workforceApplica13.applicationType) === "financialAssistance" ? /*#__PURE__*/React.createElement("td", {
    className: "noa-value"
  }, deceasedWorkerInfo !== null && deceasedWorkerInfo !== void 0 && deceasedWorkerInfo.nid ? toBanglaNumber(deceasedWorkerInfo === null || deceasedWorkerInfo === void 0 ? void 0 : deceasedWorkerInfo.nid) : "") : /*#__PURE__*/React.createElement("td", {
    className: "noa-value"
  }, row !== null && row !== void 0 && (_row$workforceApplica14 = row.workforceApplication) !== null && _row$workforceApplica14 !== void 0 && (_row$workforceApplica14 = _row$workforceApplica14.workforceEmployee) !== null && _row$workforceApplica14 !== void 0 && _row$workforceApplica14.nid ? toBanglaNumber(row === null || row === void 0 || (_row$workforceApplica15 = row.workforceApplication) === null || _row$workforceApplica15 === void 0 || (_row$workforceApplica15 = _row$workforceApplica15.workforceEmployee) === null || _row$workforceApplica15 === void 0 ? void 0 : _row$workforceApplica15.nid) : "")), applicationType === "disabilityAssistance" && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    className: "noa-label"
  }, "\u09B6\u09CD\u09B0\u09AE\u09BF\u0995\u09C7\u09B0 \u099C\u09A8\u09CD\u09AE \u09A4\u09BE\u09B0\u09BF\u0996:"), (row === null || row === void 0 || (_row$workforceApplica16 = row.workforceApplication) === null || _row$workforceApplica16 === void 0 ? void 0 : _row$workforceApplica16.applicationType) === "financialAssistance" ? /*#__PURE__*/React.createElement("td", {
    className: "noa-value"
  }, deceasedWorkerInfo !== null && deceasedWorkerInfo !== void 0 && deceasedWorkerInfo.birthDate ? new Date(deceasedWorkerInfo === null || deceasedWorkerInfo === void 0 ? void 0 : deceasedWorkerInfo.birthDate).toLocaleDateString("bn-BD") : "") : /*#__PURE__*/React.createElement("td", {
    className: "noa-value"
  }, row !== null && row !== void 0 && (_row$workforceApplica17 = row.workforceApplication) !== null && _row$workforceApplica17 !== void 0 && (_row$workforceApplica17 = _row$workforceApplica17.workforceEmployee) !== null && _row$workforceApplica17 !== void 0 && _row$workforceApplica17.birthDate ? new Date(row === null || row === void 0 || (_row$workforceApplica18 = row.workforceApplication) === null || _row$workforceApplica18 === void 0 || (_row$workforceApplica18 = _row$workforceApplica18.workforceEmployee) === null || _row$workforceApplica18 === void 0 ? void 0 : _row$workforceApplica18.birthDate).toLocaleDateString("bn-BD") : ""))), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    className: "noa-label"
  }, "\u09A0\u09BF\u0995\u09BE\u09A8\u09BE:"), (row === null || row === void 0 || (_row$workforceApplica19 = row.workforceApplication) === null || _row$workforceApplica19 === void 0 ? void 0 : _row$workforceApplica19.applicationType) === "financialAssistance" ? /*#__PURE__*/React.createElement("td", {
    className: "noa-value"
  }, /*#__PURE__*/React.createElement("b", null, "\u0997\u09CD\u09B0\u09BE\u09AE\u0983"), " ", (deceasedEmployeePresentAddress === null || deceasedEmployeePresentAddress === void 0 ? void 0 : deceasedEmployeePresentAddress.village) || "", ", ", /*#__PURE__*/React.createElement("b", null, "\u09A1\u09BE\u0995\u0998\u09B0\u0983"), " ", (deceasedEmployeePresentAddress === null || deceasedEmployeePresentAddress === void 0 ? void 0 : deceasedEmployeePresentAddress.postOffice) || "", " , ", /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("b", null, "\u0989\u09AA\u099C\u09C7\u09B2\u09BE/\u09A5\u09BE\u09A8\u09BE\u0983"), " ", (deceasedEmployeePresentAddress === null || deceasedEmployeePresentAddress === void 0 ? void 0 : deceasedEmployeePresentAddress.thana) || "", ", ", /*#__PURE__*/React.createElement("b", null, "\u099C\u09C7\u09B2\u09BE\u0983"), "  ", (deceasedEmployeePresentAddress === null || deceasedEmployeePresentAddress === void 0 ? void 0 : deceasedEmployeePresentAddress.district) || "") : /*#__PURE__*/React.createElement("td", {
    className: "noa-value"
  }, /*#__PURE__*/React.createElement("b", null, "\u0997\u09CD\u09B0\u09BE\u09AE\u0983"), " ", (employeePresentAddress === null || employeePresentAddress === void 0 ? void 0 : employeePresentAddress.village) || "", ", ", /*#__PURE__*/React.createElement("b", null, "\u09A1\u09BE\u0995\u0998\u09B0\u0983"), " ", (employeePresentAddress === null || employeePresentAddress === void 0 ? void 0 : employeePresentAddress.postOffice) || "", " , ", /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("b", null, "\u0989\u09AA\u099C\u09C7\u09B2\u09BE/\u09A5\u09BE\u09A8\u09BE\u0983"), " ", (employeePresentAddress === null || employeePresentAddress === void 0 ? void 0 : employeePresentAddress.thana) || "", ", ", /*#__PURE__*/React.createElement("b", null, "\u099C\u09C7\u09B2\u09BE\u0983"), "  ", (employeePresentAddress === null || employeePresentAddress === void 0 ? void 0 : employeePresentAddress.district) || "")), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    className: "noa-label"
  }, "\u0995\u09B0\u09CD\u09AE\u09B8\u09CD\u09A5\u09B2\u09C7 \u09A6\u09C1\u09B0\u09CD\u0998\u099F\u09A8\u09BE\u09B0 \u09A4\u09BE\u09B0\u09BF\u0996:"), /*#__PURE__*/React.createElement("td", {
    className: "noa-value"
  }, employeeAccidentInfo !== null && employeeAccidentInfo !== void 0 && employeeAccidentInfo.accidentDate ? new Date(employeeAccidentInfo === null || employeeAccidentInfo === void 0 ? void 0 : employeeAccidentInfo.accidentDate).toLocaleDateString("bn-BD") : "")), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    className: "noa-label"
  }, "\u09AF\u09C7 \u0995\u09BE\u09B0\u0996\u09BE\u09A8\u09BE\u09AF\u09BC \u09A6\u09C1\u09B0\u09CD\u0998\u099F\u09A8\u09BE \u0998\u099F\u09C7\u099B\u09C7 \u09A4\u09BE\u09B0 \u09A8\u09BE\u09AE:"), /*#__PURE__*/React.createElement("td", {
    className: "noa-value"
  }, (row === null || row === void 0 || (_row$workforceApplica20 = row.workforceApplication) === null || _row$workforceApplica20 === void 0 || (_row$workforceApplica20 = _row$workforceApplica20.employeeFactory) === null || _row$workforceApplica20 === void 0 ? void 0 : _row$workforceApplica20.nameBn) || "")), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    className: "noa-label"
  }, "\u09A6\u09C1\u09B0\u09CD\u0998\u099F\u09A8\u09BE \u0998\u099F\u09BE\u09B0 \u09B8\u09AE\u09AF\u09BC\u0995\u09BE\u09B2\u09C0\u09A8 \u09B6\u09CD\u09B0\u09AE\u09BF\u0995\u09C7\u09B0 \u09AE\u09BE\u09B8\u09BF\u0995 \u09AE\u099C\u09C1\u09B0\u09BF:"), /*#__PURE__*/React.createElement("td", {
    className: "noa-value"
  }, Number(row === null || row === void 0 || (_row$workforceApplica21 = row.workforceApplication) === null || _row$workforceApplica21 === void 0 ? void 0 : _row$workforceApplica21.lastBaseSalary).toLocaleString("bn-BD") || "")), applicationType === "disabilityAssistance" && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    className: "noa-label"
  }, "\u09AA\u09C1\u09A8\u09B0\u09BE\u09AF\u09BC \u0995\u09B0\u09CD\u09AE\u09B8\u09CD\u09A5\u09B2\u09C7 \u09AF\u09CB\u0997\u09A6\u09BE\u09A8\u09C7\u09B0 \u09A4\u09BE\u09B0\u09BF\u0996: (\u09AE\u09BE\u09B8/\u09A6\u09BF\u09A8/\u09AC\u099B\u09B0)"), /*#__PURE__*/React.createElement("td", {
    className: "noa-value"
  }, employeeAccidentInfo !== null && employeeAccidentInfo !== void 0 && employeeAccidentInfo.dateOfRejoining ? new Date(employeeAccidentInfo === null || employeeAccidentInfo === void 0 ? void 0 : employeeAccidentInfo.dateOfRejoining).toLocaleDateString("bn-BD") : "")), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    className: "noa-label"
  }, "\u09B8\u09CD\u09A5\u09BE\u09AF\u09BC\u09C0 \u0985\u0995\u09CD\u09B7\u09AE\u09A4\u09BE\u09B0 (\u0989\u09AA\u09BE\u09B0\u09CD\u099C\u09A8\u0995\u09CD\u09B7\u09AE\u09A4\u09BE \u09B9\u09CD\u09B0\u09BE\u09B8) \u09B9\u09BE\u09B0:"), /*#__PURE__*/React.createElement("td", {
    className: "noa-value"
  }, Number(doctorEntryInfo === null || doctorEntryInfo === void 0 ? void 0 : doctorEntryInfo.disabilityPerSchedule).toLocaleString("bn-BD") || "0", "%")), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    className: "noa-label"
  }, "\u09B8\u09CD\u09A5\u09BE\u09AF\u09BC\u09C0 \u0985\u0995\u09CD\u09B7\u09AE\u09A4\u09BE \u09A8\u09BF\u09B0\u09C0\u0995\u09CD\u09B7\u09A3\u09C7\u09B0 \u09A4\u09BE\u09B0\u09BF\u0996:"), /*#__PURE__*/React.createElement("td", {
    className: "noa-value"
  }, doctorEntryInfo !== null && doctorEntryInfo !== void 0 && doctorEntryInfo.dateOfAssessment ? new Date(doctorEntryInfo === null || doctorEntryInfo === void 0 ? void 0 : doctorEntryInfo.dateOfAssessment).toLocaleDateString("bn-BD") : "")), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    className: "noa-label"
  }, "\u09B6\u09CD\u09B0\u09AE\u09BF\u0995\u09C7\u09B0 \u098F\u09AE.\u0986\u0987.\u098F\u09B8 \u0986\u0987\u09A1\u09BF \u09A8\u09AE\u09CD\u09AC\u09B0:"), /*#__PURE__*/React.createElement("td", {
    className: "noa-value"
  }, (row === null || row === void 0 ? void 0 : row.beneficiaryId) || "")), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    className: "noa-label"
  }, "\u0995\u09C7\u09A8\u09CD\u09A6\u09CD\u09B0\u09C0\u09AF\u09BC \u09A4\u09B9\u09AC\u09BF\u09B2 \u09A5\u09C7\u0995\u09C7 \u09AA\u09CD\u09B0\u09A6\u09A4\u09CD\u09A4 \u0985\u09B0\u09CD\u09A5\u09C7\u09B0 \u09AA\u09B0\u09BF\u09AE\u09BE\u09A3:"), /*#__PURE__*/React.createElement("td", {
    className: "noa-value"
  }, "  ", otherCompAmount ? Number(otherCompAmount).toLocaleString("bn-BD", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }) : "")), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    colSpan: 2,
    className: "noa-section"
  }, "\u09AE\u09BE\u09B8\u09BF\u0995 \u09AA\u09CD\u09B0\u09A6\u09C7\u09AF\u09BC \u099F\u09AA-\u0986\u09AA \u09AC\u09C7\u09A8\u09C7\u09AB\u09BF\u099F\u09C7\u09B0 \u09A4\u09A5\u09CD\u09AF:")), (paymentType === "onetime" || paymentType === "installment") && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    className: "noa-label"
  }, "\u09B8\u09B0\u09CD\u09AC\u09AE\u09CB\u099F \u09AA\u09CD\u09B0\u09A6\u09C7\u09AF\u09BC \u0987.\u0986\u0987.\u098F\u09B8 \u099F\u09AA-\u0986\u09AA \u09AC\u09C7\u09A8\u09C7\u09AB\u09BF\u099F\u09C7\u09B0 \u09AA\u09B0\u09BF\u09AE\u09BE\u09A3:"), /*#__PURE__*/React.createElement("td", {
    className: "noa-value"
  }, " ", cfAndEisAmount ? Number(cfAndEisAmount).toLocaleString("bn-BD", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }) : "")), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    className: "noa-label"
  }, "\u09AE\u09BE\u09B8\u09BF\u0995 \u0987.\u0986\u0987.\u098F\u09B8 \u099F\u09AA-\u0986\u09AA \u09AC\u09C7\u09A8\u09BF\u09AB\u09BF\u099F\u09C7\u09B0 \u0995\u09BE\u09B0\u09CD\u09AF\u0995\u09B0\u09C0 \u09A4\u09BE\u09B0\u09BF\u0996:"), /*#__PURE__*/React.createElement("td", {
    className: "noa-value"
  }, row !== null && row !== void 0 && row.processingDate ? new Date(row === null || row === void 0 ? void 0 : row.processingDate).toLocaleDateString("bn-BD") : ""))), paymentType === "monthly" && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    className: "noa-label"
  }, "\u09AE\u09BE\u09B8\u09BF\u0995 \u09AA\u09CD\u09B0\u09A6\u09C7\u09DF \u0987.\u0986\u0987.\u098F\u09B8 \u099F\u09AA-\u0986\u09AA \u09AC\u09C7\u09A8\u09C7\u09AB\u09BF\u099F\u09C7\u09B0 \u09AA\u09B0\u09BF\u09AE\u09BE\u09A3:"), /*#__PURE__*/React.createElement("td", {
    className: "noa-value"
  }, row !== null && row !== void 0 && row.eisMonthlyAmount ? Number(row.eisMonthlyAmount).toLocaleString("bn-BD", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }) : "")), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    className: "noa-label"
  }, "\u09AE\u09BE\u09B8\u09BF\u0995 \u0987.\u0986\u0987.\u098F\u09B8 \u099F\u09AA-\u0986\u09AA \u09AC\u09C7\u09A8\u09BF\u09AB\u09BF\u099F\u09C7\u09B0 \u0995\u09BE\u09B0\u09CD\u09AF\u0995\u09B0\u09C0 \u09A4\u09BE\u09B0\u09BF\u0996:"), /*#__PURE__*/React.createElement("td", {
    className: "noa-value"
  }, row !== null && row !== void 0 && row.processingDate ? new Date(row === null || row === void 0 ? void 0 : row.processingDate).toLocaleDateString("bn-BD") : "")))), applicationType === "financialAssistance" && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    className: "noa-label"
  }, "\u09AE\u09C3\u09A4\u09CD\u09AF\u09C1\u09B0 \u09A4\u09BE\u09B0\u09BF\u0996:"), /*#__PURE__*/React.createElement("td", {
    className: "noa-value"
  }, employeeAccidentInfo !== null && employeeAccidentInfo !== void 0 && employeeAccidentInfo.dateOfDeath ? new Date(employeeAccidentInfo === null || employeeAccidentInfo === void 0 ? void 0 : employeeAccidentInfo.dateOfDeath).toLocaleDateString("bn-BD") : "")), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    colSpan: 2,
    className: "noa-section"
  }, "\u0989\u09AA\u09AF\u09C1\u0995\u09CD\u09A4 \u09A8\u09BF\u09B0\u09CD\u09AD\u09B0\u09B6\u09C0\u09B2 \u09AC\u09CD\u09AF\u0995\u09CD\u09A4\u09BF\u09B0 \u09A4\u09A5\u09CD\u09AF:")), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    className: "noa-label"
  }, "\u0989\u09AA\u09AF\u09C1\u0995\u09CD\u09A4 \u09A8\u09BF\u09B0\u09CD\u09AD\u09B0\u09B6\u09C0\u09B2\u09C7\u09B0 \u09A8\u09BE\u09AE:"), /*#__PURE__*/React.createElement("td", {
    className: "noa-value"
  }, (row === null || row === void 0 || (_row$workforceEmploye3 = row.workforceEmployeeDependent) === null || _row$workforceEmploye3 === void 0 || (_row$workforceEmploye3 = _row$workforceEmploye3[0]) === null || _row$workforceEmploye3 === void 0 ? void 0 : _row$workforceEmploye3.nameBn) || "")), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    className: "noa-label"
  }, "\u09AE\u09C3\u09A4 \u09B6\u09CD\u09B0\u09AE\u09BF\u0995\u09C7\u09B0 \u09B8\u09BE\u09A5\u09C7 \u09B8\u09AE\u09CD\u09AA\u09B0\u09CD\u0995:"), /*#__PURE__*/React.createElement("td", {
    className: "noa-value"
  }, RELATION_LABEL_BANGLA_MAP[(row === null || row === void 0 || (_row$workforceEmploye4 = row.workforceEmployeeDependent) === null || _row$workforceEmploye4 === void 0 || (_row$workforceEmploye4 = _row$workforceEmploye4[0]) === null || _row$workforceEmploye4 === void 0 ? void 0 : _row$workforceEmploye4.relationWithWorker) || ""])), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    className: "noa-label"
  }, "\u09A8\u09BF\u09B0\u09CD\u09AD\u09B0\u09B6\u09C0\u09B2 \u09AC\u09CD\u09AF\u0995\u09CD\u09A4\u09BF\u09B0 \u099C\u09BE\u09A4\u09C0\u09AF\u09BC \u09AA\u09B0\u09BF\u099A\u09AF\u09BC\u09AA\u09A4\u09CD\u09B0 / \u099C\u09A8\u09CD\u09AE\u09B8\u09A8\u09A6 \u09A8\u09AE\u09CD\u09AC\u09B0:"), /*#__PURE__*/React.createElement("td", {
    className: "noa-value"
  }, row !== null && row !== void 0 && (_row$workforceEmploye5 = row.workforceEmployeeDependent) !== null && _row$workforceEmploye5 !== void 0 && (_row$workforceEmploye5 = _row$workforceEmploye5[0]) !== null && _row$workforceEmploye5 !== void 0 && _row$workforceEmploye5.nid ? toBanglaNumber(row === null || row === void 0 || (_row$workforceEmploye6 = row.workforceEmployeeDependent) === null || _row$workforceEmploye6 === void 0 || (_row$workforceEmploye6 = _row$workforceEmploye6[0]) === null || _row$workforceEmploye6 === void 0 ? void 0 : _row$workforceEmploye6.nid) : "")), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    className: "noa-label"
  }, "\u09A8\u09BF\u09B0\u09CD\u09AD\u09B0\u09B6\u09C0\u09B2 \u09AC\u09CD\u09AF\u0995\u09CD\u09A4\u09BF\u09B0 \u099C\u09A8\u09CD\u09AE \u09A4\u09BE\u09B0\u09BF\u0996: ", /*#__PURE__*/React.createElement("br", null), " (\u09AE\u09BE\u09B8/\u09A6\u09BF\u09A8/\u09AC\u099B\u09B0)"), /*#__PURE__*/React.createElement("td", {
    className: "noa-value"
  }, row !== null && row !== void 0 && (_row$workforceEmploye7 = row.workforceEmployeeDependent) !== null && _row$workforceEmploye7 !== void 0 && (_row$workforceEmploye7 = _row$workforceEmploye7[0]) !== null && _row$workforceEmploye7 !== void 0 && _row$workforceEmploye7.birthDate ? new Date(row === null || row === void 0 || (_row$workforceEmploye8 = row.workforceEmployeeDependent) === null || _row$workforceEmploye8 === void 0 || (_row$workforceEmploye8 = _row$workforceEmploye8[0]) === null || _row$workforceEmploye8 === void 0 ? void 0 : _row$workforceEmploye8.birthDate).toLocaleDateString("bn-BD") : "")), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    className: "noa-label"
  }, "\u09A0\u09BF\u0995\u09BE\u09A8\u09BE:"), /*#__PURE__*/React.createElement("td", {
    className: "noa-value"
  }, depentPresentAddress !== null && depentPresentAddress !== void 0 && depentPresentAddress.village ? "".concat(depentPresentAddress.village, ", ") : "", depentPresentAddress !== null && depentPresentAddress !== void 0 && depentPresentAddress.postOffice ? "".concat(depentPresentAddress.postOffice, ", ") : "", depentPresentAddress !== null && depentPresentAddress !== void 0 && depentPresentAddress.thana ? "".concat(depentPresentAddress.thana, ", ") : "", (depentPresentAddress === null || depentPresentAddress === void 0 ? void 0 : depentPresentAddress.district) || "")), calculateAge(row === null || row === void 0 || (_row$workforceEmploye9 = row.workforceEmployeeDependent) === null || _row$workforceEmploye9 === void 0 || (_row$workforceEmploye9 = _row$workforceEmploye9[0]) === null || _row$workforceEmploye9 === void 0 ? void 0 : _row$workforceEmploye9.birthDate, (_employeeAccidentInfo = employeeAccidentInfo.dateOfDeath) !== null && _employeeAccidentInfo !== void 0 ? _employeeAccidentInfo : null) < 18 ? /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    className: "noa-label"
  }, "\u0985\u09AA\u09CD\u09B0\u09BE\u09AA\u09CD\u09A4 \u09AC\u09AF\u09BC\u09B8\u09CD\u0995 \u09A8\u09BF\u09B0\u09CD\u09AD\u09B0\u09B6\u09C0\u09B2 \u09AC\u09CD\u09AF\u0995\u09CD\u09A4\u09BF\u09B0 \u0986\u0987\u09A8\u0997\u09A4 \u0985\u09AD\u09BF\u09AD\u09BE\u09AC\u0995:"), /*#__PURE__*/React.createElement("td", {
    className: "noa-value"
  })) : null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    className: "noa-label"
  }, "\u098F\u09AE.\u0986\u0987.\u098F\u09B8 \u09AC\u09C7\u09A8\u09BF\u09AB\u09BF\u09B6\u09BF\u09AF\u09BC\u09BE\u09B0\u09BF \u09A8\u09AE\u09CD\u09AC\u09B0:"), /*#__PURE__*/React.createElement("td", {
    className: "noa-value"
  }, (row === null || row === void 0 ? void 0 : row.beneficiaryId) || "")), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    className: "noa-label"
  }, "\u0995\u09C7\u09A8\u09CD\u09A6\u09CD\u09B0\u09C0\u09AF\u09BC \u09A4\u09B9\u09AC\u09BF\u09B2 \u09A5\u09C7\u0995\u09C7 \u09AA\u09CD\u09B0\u09A6\u09A4\u09CD\u09A4 \u0985\u09B0\u09CD\u09A5\u09C7\u09B0 \u09AA\u09B0\u09BF\u09AE\u09BE\u09A3:"), /*#__PURE__*/React.createElement("td", {
    className: "noa-value"
  }, otherCompAmount ? Number(otherCompAmount).toLocaleString("bn-BD", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }) : "")), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    colSpan: 2,
    className: "noa-section"
  }, "\u09AE\u09BE\u09B8\u09BF\u0995 \u09AA\u09CD\u09B0\u09A6\u09C7\u09AF\u09BC \u099F\u09AA-\u0986\u09AA \u09AC\u09C7\u09A8\u09C7\u09AB\u09BF\u099F\u09C7\u09B0 \u09A4\u09A5\u09CD\u09AF:")), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    className: "noa-label"
  }, "\u09AE\u09BE\u09B8\u09BF\u0995 \u09AA\u09CD\u09B0\u09A6\u09C7\u09AF\u09BC \u0987.\u0986\u0987.\u098F\u09B8 \u099F\u09AA-\u0986\u09AA \u09AC\u09C7\u09A8\u09C7\u09AB\u09BF\u099F\u09C7\u09B0 \u09AA\u09B0\u09BF\u09AE\u09BE\u09A3:"), /*#__PURE__*/React.createElement("td", {
    className: "noa-value"
  }, row.eisInitialMonthlyAmount ? Number(row.eisInitialMonthlyAmount).toLocaleString("bn-BD", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }) : "")), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    className: "noa-label"
  }, "\u0995\u09C7\u09A8\u09CD\u09A6\u09CD\u09B0\u09C0\u09AF\u09BC \u09A4\u09B9\u09AC\u09BF\u09B2 \u09AA\u09CD\u09B0\u09A6\u09A4\u09CD\u09A4 \u0985\u09B0\u09CD\u09A5 \u09B8\u09AE\u09A8\u09CD\u09A8\u09AF\u09BC\u09C7\u09B0 \u09AA\u09B0 \u09AA\u09CD\u09B0\u09A6\u09C7\u09AF\u09BC", /*#__PURE__*/React.createElement("br", null), "\u09AE\u09BE\u09B8\u09BF\u0995 \u0987.\u0986\u0987.\u098F\u09B8 \u099F\u09AA-\u0986\u09AA \u09AC\u09C7\u09A8\u09C7\u09AB\u09BF\u099F\u09C7\u09B0 \u09AA\u09B0\u09BF\u09AE\u09BE\u09A3:"), /*#__PURE__*/React.createElement("td", {
    className: "noa-value"
  }, row !== null && row !== void 0 && row.eisMonthlyAmount ? Number(row.eisMonthlyAmount).toLocaleString("bn-BD", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }) : "")), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    className: "noa-label"
  }, "\u09AE\u09BE\u09B8\u09BF\u0995 \u0987.\u0986\u0987.\u098F\u09B8 \u099F\u09AA-\u0986\u09AA \u09AC\u09C7\u09A8\u09BF\u09AB\u09BF\u099F\u09C7\u09B0 \u0995\u09BE\u09B0\u09CD\u09AF\u0995\u09B0\u09C0 \u09A4\u09BE\u09B0\u09BF\u0996:"), /*#__PURE__*/React.createElement("td", {
    className: "noa-value"
  }, applicationType == 'financialAssistance' ? new Date(employeeAccidentInfo.dateOfDeath).toLocaleDateString("bn-BD") : employeeAccidentInfo.dateOfRejoining ? new Date(employeeAccidentInfo.dateOfRejoining).toLocaleDateString("bn-BD") : new Date(employeeAccidentInfo.accidentDate).toLocaleDateString("bn-BD")))))), /*#__PURE__*/React.createElement("div", {
    className: "noa-additional-info"
  }, getFooterContentNew(row === null || row === void 0 || (_row$workforceEmploye10 = row.workforceEmployeeDependent) === null || _row$workforceEmploye10 === void 0 ? void 0 : _row$workforceEmploye10[0], workerBirthDate, applicationType, paymentType))), /*#__PURE__*/React.createElement("div", {
    className: "noa-footer"
  }, /*#__PURE__*/React.createElement("div", {
    className: "noa-signature"
  }, noaSignatureLogo, /*#__PURE__*/React.createElement("p", {
    style: {
      margin: "2px 0"
    }
  }, noaSigner === null || noaSigner === void 0 || (_noaSigner$workforceC = noaSigner.workforceCommitteeUser) === null || _noaSigner$workforceC === void 0 ? void 0 : _noaSigner$workforceC.designation), /*#__PURE__*/React.createElement("p", {
    style: {
      margin: "2px 0"
    }
  }, noaSigner === null || noaSigner === void 0 || (_noaSigner$workforceC2 = noaSigner.workforceCommitteeUser) === null || _noaSigner$workforceC2 === void 0 ? void 0 : _noaSigner$workforceC2.organizationName), /*#__PURE__*/React.createElement("p", {
    style: {
      margin: "2px 0"
    }
  }, "\u0993"), /*#__PURE__*/React.createElement("p", {
    style: {
      margin: "2px 0"
    }
  }, getRoleInCommitteeLabel((noaSigner === null || noaSigner === void 0 ? void 0 : noaSigner.roleInCommittee) || "Member", locale), ", ", locale === "fr" ? noaSigner === null || noaSigner === void 0 || (_noaSigner$committee = noaSigner.committee) === null || _noaSigner$committee === void 0 ? void 0 : _noaSigner$committee.nameBn : noaSigner === null || noaSigner === void 0 || (_noaSigner$committee2 = noaSigner.committee) === null || _noaSigner$committee2 === void 0 ? void 0 : _noaSigner$committee2.nameEn)))))), /*#__PURE__*/React.createElement(Divider, {
    className: classes.noPrint
  }), /*#__PURE__*/React.createElement(DialogActions$1, {
    className: classes.noPrint
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: onClose,
    variant: "outlined",
    color: "primary"
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "workforce.modal.close"
  })), /*#__PURE__*/React.createElement(Button, {
    onClick: handleDialogPrint,
    variant: "contained",
    color: "primary"
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "workforce.modal.print.noa"
  }))));
};

function ownKeys$l(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$l(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$l(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$l(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var BeneficiaryNoaConfirmation = function BeneficiaryNoaConfirmation() {
  var dispatch = useDispatch();
  var modulesManager = useModulesManager();
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    loading = _useState2[0],
    setLoading = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    data = _useState4[0],
    setData = _useState4[1];
  var _useState5 = useState([]),
    _useState6 = _slicedToArray(_useState5, 2),
    factories = _useState6[0],
    setFactories = _useState6[1];
  var _useState7 = useState([]),
    _useState8 = _slicedToArray(_useState7, 2),
    associations = _useState8[0],
    setAssociations = _useState8[1];
  var _useState9 = useState(false),
    _useState10 = _slicedToArray(_useState9, 2);
    _useState10[0];
    _useState10[1];
  var _useState11 = useState([]),
    _useState12 = _slicedToArray(_useState11, 2),
    selectedIds = _useState12[0],
    setSelectedIds = _useState12[1];
  var _useState13 = useState({
      trackingNo: "",
      factory: "",
      association: "",
      beneficiaryId: "",
      approvalDateFrom: "",
      approvalDateTo: "",
      accidentDateFrom: "",
      accidentDateTo: ""
    }),
    _useState14 = _slicedToArray(_useState13, 2),
    filters = _useState14[0],
    setFilters = _useState14[1];
  var _useState15 = useState(false),
    _useState16 = _slicedToArray(_useState15, 2),
    openNoaModal = _useState16[0],
    setOpenNoaModal = _useState16[1];
  var _useState17 = useState(null),
    _useState18 = _slicedToArray(_useState17, 2),
    selectedBeneficiary = _useState18[0],
    setSelectedBeneficiary = _useState18[1];
  var _useState19 = useState(null),
    _useState20 = _slicedToArray(_useState19, 2);
    _useState20[0];
    _useState20[1];
  var handleSendSms = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(row, name) {
      var longUrl, link, message;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            longUrl = window.location.origin + "/front/noa/confirmation?process_id=".concat(safeDecodeId(row.id));
            link = longUrl; // const link = await shortenUrl(longUrl);
            message = "Hi, ".concat(name, ", Please Download EIS NOA From ").concat(link);
            _context.next = 6;
            return dispatch(sendSmsNotification(row.phoneNumber, message));
          case 6:
            _context.next = 8;
            return dispatch(confirmNoa(safeDecodeId(row.id), true, false));
          case 8:
            alert("Message Sent!");
            loadData();
            _context.next = 16;
            break;
          case 12:
            _context.prev = 12;
            _context.t0 = _context["catch"](0);
            console.error(_context.t0);
            alert("Failed to send SMS");
          case 16:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 12]]);
    }));
    return function handleSendSms(_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
  var handleOpenNoaModal = function handleOpenNoaModal(row) {
    setSelectedBeneficiary(row);
    setOpenNoaModal(true);
  };
  var handleCloseNoaModal = function handleCloseNoaModal() {
    setOpenNoaModal(false);
    setSelectedBeneficiary(null);
  };
  var handleRowSelect = function handleRowSelect(id) {
    setSelectedIds(function (prev) {
      return prev.includes(id) ? prev.filter(function (x) {
        return x !== id;
      }) : [].concat(_toConsumableArray(prev), [id]);
    });
  };
  var handleSelectAll = function handleSelectAll(checked) {
    if (checked) {
      setSelectedIds(data.map(function (row) {
        return row.id;
      }));
    } else {
      setSelectedIds([]);
    }
  };

  // 1. Updated Fetching Logic to accept filter parameters
  var loadData = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var _safeDecodeId, _safeDecodeId2, _filters$approvalDate, _filters$approvalDate2, _filters$accidentDate, _filters$accidentDate2, _processRes$payload, _yield$Promise$all, _yield$Promise$all2, processRes;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            setLoading(true);
            _context2.prev = 1;
            // Pass the filter state directly to the backend action
            dispatch(fetchWorkforceFactoriesSummary(modulesManager, [])).then(function (factoryRes) {
              var _factoryRes$payload;
              setFactories((factoryRes === null || factoryRes === void 0 || (_factoryRes$payload = factoryRes.payload) === null || _factoryRes$payload === void 0 || (_factoryRes$payload = _factoryRes$payload.data) === null || _factoryRes$payload === void 0 || (_factoryRes$payload = _factoryRes$payload.workforceEmployerFactories) === null || _factoryRes$payload === void 0 ? void 0 : _factoryRes$payload.edges) || []);
            });
            dispatch(fetchWorkforceAllAssociationSummary([])).then(function (assocRes) {
              var _assocRes$payload;
              setAssociations((assocRes === null || assocRes === void 0 || (_assocRes$payload = assocRes.payload) === null || _assocRes$payload === void 0 || (_assocRes$payload = _assocRes$payload.data) === null || _assocRes$payload === void 0 || (_assocRes$payload = _assocRes$payload.workforceAllAssociation) === null || _assocRes$payload === void 0 ? void 0 : _assocRes$payload.edges) || []);
            });
            _context2.next = 6;
            return Promise.all([dispatch(fetchEisPaymentProcessWithFilters({
              workforceApplicationTrackingNumber: filters.trackingNo,
              workforceFactoryId: (_safeDecodeId = safeDecodeId(filters.factory)) !== null && _safeDecodeId !== void 0 ? _safeDecodeId : "",
              allAssociationId: (_safeDecodeId2 = safeDecodeId(filters.association)) !== null && _safeDecodeId2 !== void 0 ? _safeDecodeId2 : "",
              beneficiaryId: filters.beneficiaryId,
              status: "active",
              approved: "yes",
              approvalDateFrom: (_filters$approvalDate = filters.approvalDateFrom) !== null && _filters$approvalDate !== void 0 ? _filters$approvalDate : "",
              approvalDateTo: (_filters$approvalDate2 = filters.approvalDateTo) !== null && _filters$approvalDate2 !== void 0 ? _filters$approvalDate2 : "",
              accidentDateFrom: (_filters$accidentDate = filters.accidentDateFrom) !== null && _filters$accidentDate !== void 0 ? _filters$accidentDate : "",
              accidentDateTo: (_filters$accidentDate2 = filters.accidentDateTo) !== null && _filters$accidentDate2 !== void 0 ? _filters$accidentDate2 : ""
            }, modulesManager))]);
          case 6:
            _yield$Promise$all = _context2.sent;
            _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 1);
            processRes = _yield$Promise$all2[0];
            setData((processRes === null || processRes === void 0 || (_processRes$payload = processRes.payload) === null || _processRes$payload === void 0 || (_processRes$payload = _processRes$payload.data) === null || _processRes$payload === void 0 ? void 0 : _processRes$payload.workforceEisPaymentProcess) || []);
            _context2.next = 15;
            break;
          case 12:
            _context2.prev = 12;
            _context2.t0 = _context2["catch"](1);
            console.error("Data Load Error:", _context2.t0);
          case 15:
            _context2.prev = 15;
            setLoading(false);
            return _context2.finish(15);
          case 18:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[1, 12, 15, 18]]);
    }));
    return function loadData() {
      return _ref2.apply(this, arguments);
    };
  }();
  useEffect(function () {
    loadData();
  }, [dispatch, modulesManager]);

  // 2. Filter Handlers
  var handleFilterChange = function handleFilterChange(e) {
    var _e$target = e.target,
      name = _e$target.name,
      value = _e$target.value;
    setFilters(function (prev) {
      return _objectSpread$l(_objectSpread$l({}, prev), {}, _defineProperty({}, name, value));
    });
    if (name !== "approvalDateFrom" && name !== "approvalDateTo" && name !== "accidentDateFrom" && name !== "accidentDateTo") {
      loadData(); // Trigger data reload on filter change
    }
    // loadData(); // Trigger data reload on filter change
  };
  var clearFilters = function clearFilters() {
    setFilters({
      trackingNo: "",
      factory: "",
      association: "",
      beneficiaryId: "",
      approvalDateFrom: "",
      approvalDateTo: "",
      accidentDateFrom: "",
      accidentDateTo: ""
    });
  };

  // 3. Status Chip Helper
  var getStatusChip = function getStatusChip(row) {
    if ((row === null || row === void 0 ? void 0 : row.beneficiaryStatus) === "eligible") return /*#__PURE__*/React.createElement(Chip, {
      label: "Eligible",
      size: "small",
      style: {
        backgroundColor: '#e8f5e9',
        color: '#2e7d32'
      }
    });
    if ((row === null || row === void 0 ? void 0 : row.beneficiaryStatus) === "closed") return /*#__PURE__*/React.createElement(Chip, {
      label: "Closed",
      size: "small",
      style: {
        backgroundColor: '#f5e8e8ff',
        color: '#7d2e2eff'
      }
    });
    if ((row === null || row === void 0 ? void 0 : row.beneficiaryStatus) === "hold") return /*#__PURE__*/React.createElement(Chip, {
      label: "On Hold",
      size: "small",
      style: {
        backgroundColor: '#f5f4e8ff',
        color: '#787d2eff'
      }
    });
    return /*#__PURE__*/React.createElement(Chip, {
      label: row === null || row === void 0 ? void 0 : row.beneficiaryStatus,
      size: "small",
      variant: "outlined"
    });
  };
  var getNoaStatusChip = function getNoaStatusChip(row) {
    if (row !== null && row !== void 0 && row.noaBlocked) return /*#__PURE__*/React.createElement(Chip, {
      label: "NOA Blocked",
      size: "small",
      style: {
        backgroundColor: '#f5e8e8',
        color: '#7d2e2e'
      }
    });
    if (row !== null && row !== void 0 && row.noaConfirmed) return /*#__PURE__*/React.createElement(Chip, {
      label: "Noa Confirmed",
      size: "small",
      style: {
        backgroundColor: '#e8f5e9',
        color: '#2e7d32'
      }
    });
    if (row !== null && row !== void 0 && row.noaSmsSent) return /*#__PURE__*/React.createElement(Chip, {
      label: "NOA SMS Sent",
      size: "small",
      style: {
        backgroundColor: 'rgb(242, 245, 232)',
        color: 'rgb(113, 125, 46)'
      }
    });
    return /*#__PURE__*/React.createElement(Chip, {
      label: "NOA Not Confirmed Yet",
      size: "small",
      style: {
        backgroundColor: '#f5e8e8ff',
        color: '#7d2e2eff'
      }
    });
  };
  var handleSearchClick = function handleSearchClick() {
    loadData();
  };
  var handleConfirmNoa = function handleConfirmNoa(row) {
    dispatch(confirmNoa(safeDecodeId(row.id), true, true)).then(function (response) {
      alert("NOA for selected user was confirmed Manually!");
      loadData();
    });
  };
  var handleBlockNoa = function handleBlockNoa(row, isBlocked) {
    dispatch(blockNoa(safeDecodeId(row.id), isBlocked)).then(function (response) {
      if (isBlocked) {
        alert("NOA Downloading for selected user is BLOCKED!");
      } else {
        alert("NOA Downloading for selected user is UNBLOCKED!");
      }
      loadData();
    });
  };
  return /*#__PURE__*/React.createElement(Box$1, {
    bgcolor: "#fafafa",
    minHeight: "100vh"
  }, /*#__PURE__*/React.createElement(Box$1, {
    mb: 2,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-end"
  }, /*#__PURE__*/React.createElement(Box$1, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5",
    style: {
      fontWeight: 700,
      marginBottom: 4
    }
  }, "Beneficiary NOA Management"), /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    color: "textSecondary"
  }, "Manage NOA of beneficiaries, confirm NOA details, and perform necessary actions for each beneficiary."))), /*#__PURE__*/React.createElement(Paper, {
    elevation: 0,
    style: {
      padding: '24px',
      marginBottom: '24px',
      borderRadius: '12px',
      border: '1px solid #eceff1'
    }
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 3,
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 6,
    md: 3
  }, /*#__PURE__*/React.createElement(TextField, {
    fullWidth: true,
    label: "Application Tracking No",
    name: "trackingNo",
    variant: "outlined",
    size: "small",
    value: filters.trackingNo,
    onChange: handleFilterChange
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 6,
    md: 3
  }, /*#__PURE__*/React.createElement(TextField, {
    fullWidth: true,
    label: "Beneficiary ID",
    name: "beneficiaryId",
    variant: "outlined",
    size: "small",
    value: filters.beneficiaryId,
    onChange: handleFilterChange
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 6,
    md: 3
  }, /*#__PURE__*/React.createElement(TextField, {
    fullWidth: true,
    select: true,
    label: "Factory",
    name: "factory",
    variant: "outlined",
    size: "small",
    value: filters.factory,
    onChange: handleFilterChange
  }, /*#__PURE__*/React.createElement(MenuItem, {
    value: ""
  }, /*#__PURE__*/React.createElement("em", null, "All Factories")), factories.map(function (f) {
    return /*#__PURE__*/React.createElement(MenuItem, {
      key: f.node.id,
      value: f.node.id
    }, f.node.nameBn || f.node.nameEn);
  }))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 6,
    md: 3
  }, /*#__PURE__*/React.createElement(TextField, {
    fullWidth: true,
    select: true,
    label: "Association",
    name: "association",
    variant: "outlined",
    size: "small",
    value: filters.association,
    onChange: handleFilterChange
  }, /*#__PURE__*/React.createElement(MenuItem, {
    value: ""
  }, /*#__PURE__*/React.createElement("em", null, "All Associations")), associations.map(function (a) {
    return /*#__PURE__*/React.createElement(MenuItem, {
      key: a.node.id,
      value: a.node.id
    }, a.node.shortNameBn || a.node.nameEn);
  }))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 6
  }, /*#__PURE__*/React.createElement(Box$1, {
    display: "flex",
    gap: "8px"
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: handleSearchClick,
    fullWidth: true,
    variant: "contained",
    color: "primary",
    startIcon: /*#__PURE__*/React.createElement(SearchIcon, null)
  }, "Search"), /*#__PURE__*/React.createElement(Button, {
    onClick: clearFilters,
    fullWidth: true,
    variant: "text",
    color: "default",
    startIcon: /*#__PURE__*/React.createElement(ClearAllIcon, null)
  }, "Reset"))))), loading ? /*#__PURE__*/React.createElement(Box$1, {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "200px"
  }, /*#__PURE__*/React.createElement(CircularProgress$1, null)) : /*#__PURE__*/React.createElement(TableContainer, {
    component: Paper,
    elevation: 0,
    style: {
      borderRadius: '12px',
      border: '1px solid #e0e0e0'
    }
  }, /*#__PURE__*/React.createElement(Table$2, null, /*#__PURE__*/React.createElement(TableHead, {
    style: {
      backgroundColor: '#f8fafd'
    }
  }, /*#__PURE__*/React.createElement(TableRow, null, /*#__PURE__*/React.createElement(TableCell, {
    padding: "checkbox",
    align: "center"
  }, /*#__PURE__*/React.createElement("input", {
    type: "checkbox",
    checked: selectedIds.length === data.length && data.length > 0,
    onChange: function onChange(e) {
      return handleSelectAll(e.target.checked);
    }
  })), /*#__PURE__*/React.createElement(TableCell, {
    style: {
      fontWeight: 600
    }
  }, "Beneficiary Details"), /*#__PURE__*/React.createElement(TableCell, {
    style: {
      fontWeight: 600
    }
  }, "Worker, Factory & Association"), /*#__PURE__*/React.createElement(TableCell, {
    style: {
      fontWeight: 600
    }
  }, "Payment Method"), /*#__PURE__*/React.createElement(TableCell, {
    align: "right",
    style: {
      fontWeight: 600
    }
  }, "Amounts"), /*#__PURE__*/React.createElement(TableCell, {
    align: "center",
    style: {
      fontWeight: 600
    }
  }, "Status"), /*#__PURE__*/React.createElement(TableCell, {
    align: "center",
    style: {
      fontWeight: 600
    }
  }, "NOA Status"), /*#__PURE__*/React.createElement(TableCell, {
    align: "center",
    style: {
      fontWeight: 600
    }
  }, "Action"))), /*#__PURE__*/React.createElement(TableBody, null, data.map(function (row) {
    var _row$workforceEmploye, _row$workforceApplica, _row$workforceApplica2, _safeParse, _row$workforceApplica3, _row$workforceApplica4, _row$workforceApplica5, _row$workforceApplica6, _row$workforceApplica7, _row$workforceApplica8, _row$workforceApplica9, _row$bank, _row$bank2, _row$bank3, _row$bank4, _row$bank5, _Number$toLocaleStrin, _Number$toLocaleStrin2;
    var dep = (row === null || row === void 0 || (_row$workforceEmploye = row.workforceEmployeeDependent) === null || _row$workforceEmploye === void 0 ? void 0 : _row$workforceEmploye[0]) || {};
    var worker = (row === null || row === void 0 || (_row$workforceApplica = row.workforceApplication) === null || _row$workforceApplica === void 0 ? void 0 : _row$workforceApplica.applicationType) === "financialAssistance" || (row === null || row === void 0 || (_row$workforceApplica2 = row.workforceApplication) === null || _row$workforceApplica2 === void 0 ? void 0 : _row$workforceApplica2.applicationType) === "deadlyGrant" ? (_safeParse = safeParse(row === null || row === void 0 || (_row$workforceApplica3 = row.workforceApplication) === null || _row$workforceApplica3 === void 0 ? void 0 : _row$workforceApplica3.deceasedWorkerInfo)) === null || _safeParse === void 0 ? void 0 : _safeParse.nameEn : row === null || row === void 0 || (_row$workforceApplica4 = row.workforceApplication) === null || _row$workforceApplica4 === void 0 || (_row$workforceApplica4 = _row$workforceApplica4.workforceEmployee) === null || _row$workforceApplica4 === void 0 ? void 0 : _row$workforceApplica4.firstNameEn;
    return /*#__PURE__*/React.createElement(TableRow, {
      key: row.id,
      hover: true
    }, /*#__PURE__*/React.createElement(TableCell, {
      padding: "checkbox",
      align: "center"
    }, /*#__PURE__*/React.createElement("input", {
      type: "checkbox",
      checked: selectedIds.includes(row.id),
      onChange: function onChange() {
        return handleRowSelect(row.id);
      }
      // disabled={row?.isDisbursed}
    })), /*#__PURE__*/React.createElement(TableCell, null, /*#__PURE__*/React.createElement(Typography, {
      variant: "subtitle2",
      style: {
        fontWeight: 600
      }
    }, (dep === null || dep === void 0 ? void 0 : dep.nameEn) || (dep === null || dep === void 0 ? void 0 : dep.nameBn) || (row === null || row === void 0 || (_row$workforceApplica5 = row.workforceApplication) === null || _row$workforceApplica5 === void 0 || (_row$workforceApplica5 = _row$workforceApplica5.workforceEmployee) === null || _row$workforceApplica5 === void 0 ? void 0 : _row$workforceApplica5.firstNameEn) || "—"), /*#__PURE__*/React.createElement(Typography, {
      variant: "caption",
      color: "primary"
    }, getRelationString(dep)), /*#__PURE__*/React.createElement(Box$1, {
      mt: 0.5,
      mb: 0.5
    }, /*#__PURE__*/React.createElement(Chip, {
      label: row.beneficiaryId,
      variant: "outlined",
      style: {
        height: 20
      }
    })), /*#__PURE__*/React.createElement(Typography, {
      variant: "caption",
      display: "block",
      color: "textSecondary"
    }, "ATN: " + (row === null || row === void 0 || (_row$workforceApplica6 = row.workforceApplication) === null || _row$workforceApplica6 === void 0 ? void 0 : _row$workforceApplica6.trackingNumber) || "N/A")), /*#__PURE__*/React.createElement(TableCell, null, /*#__PURE__*/React.createElement(Typography, {
      variant: "body2",
      style: {
        fontWeight: 500
      }
    }, worker), /*#__PURE__*/React.createElement(Typography, {
      variant: "caption",
      display: "block",
      color: "textSecondary"
    }, row === null || row === void 0 || (_row$workforceApplica7 = row.workforceApplication) === null || _row$workforceApplica7 === void 0 || (_row$workforceApplica7 = _row$workforceApplica7.employeeFactory) === null || _row$workforceApplica7 === void 0 ? void 0 : _row$workforceApplica7.nameEn), /*#__PURE__*/React.createElement(Typography, {
      variant: "caption",
      display: "block",
      color: "textSecondary"
    }, (row === null || row === void 0 || (_row$workforceApplica8 = row.workforceApplication) === null || _row$workforceApplica8 === void 0 || (_row$workforceApplica8 = _row$workforceApplica8.employeeFactory) === null || _row$workforceApplica8 === void 0 || (_row$workforceApplica8 = _row$workforceApplica8.allAssociation) === null || _row$workforceApplica8 === void 0 ? void 0 : _row$workforceApplica8.shortNameEn) || (row === null || row === void 0 || (_row$workforceApplica9 = row.workforceApplication) === null || _row$workforceApplica9 === void 0 || (_row$workforceApplica9 = _row$workforceApplica9.employeeFactory) === null || _row$workforceApplica9 === void 0 || (_row$workforceApplica9 = _row$workforceApplica9.allAssociation) === null || _row$workforceApplica9 === void 0 ? void 0 : _row$workforceApplica9.nameEn) || "N/A")), /*#__PURE__*/React.createElement(TableCell, null, /*#__PURE__*/React.createElement(Typography, {
      variant: "body2"
    }, ((_row$bank = row.bank) === null || _row$bank === void 0 || (_row$bank = _row$bank.parent) === null || _row$bank === void 0 ? void 0 : _row$bank.nameEn) || "N/A"), /*#__PURE__*/React.createElement(Typography, {
      variant: "body2"
    }, ((_row$bank2 = row.bank) === null || _row$bank2 === void 0 ? void 0 : _row$bank2.nameEn) + " (Routing #" + ((row === null || row === void 0 || (_row$bank3 = row.bank) === null || _row$bank3 === void 0 ? void 0 : _row$bank3.routingNumber) == '0' || (row === null || row === void 0 || (_row$bank4 = row.bank) === null || _row$bank4 === void 0 ? void 0 : _row$bank4.routingNumber) == null ? row === null || row === void 0 ? void 0 : row.routingNumber : row === null || row === void 0 || (_row$bank5 = row.bank) === null || _row$bank5 === void 0 ? void 0 : _row$bank5.routingNumber) + ")" || "N/A"), /*#__PURE__*/React.createElement(Typography, {
      variant: "caption",
      color: "textSecondary"
    }, "A/C: " + row.bankAccountNo)), /*#__PURE__*/React.createElement(TableCell, {
      align: "right"
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "body2",
      style: {
        fontWeight: 700
      }
    }, (_Number$toLocaleStrin = Number(row.payableAmount).toLocaleString("en-BD")) !== null && _Number$toLocaleStrin !== void 0 ? _Number$toLocaleStrin : Number(row.payableAmount).toLocaleString("en-BD")), /*#__PURE__*/React.createElement(Typography, {
      variant: "caption",
      color: "textSecondary"
    }, "Total: " + ((_Number$toLocaleStrin2 = Number(row === null || row === void 0 ? void 0 : row.eisApprovedAmount).toLocaleString("en-BD")) !== null && _Number$toLocaleStrin2 !== void 0 ? _Number$toLocaleStrin2 : "--")), /*#__PURE__*/React.createElement(Typography, {
      variant: "body2",
      style: {
        fontWeight: 700
      }
    }, getPaymentTypeString(row.eisPaymentType))), /*#__PURE__*/React.createElement(TableCell, {
      align: "center"
    }, getStatusChip(row)), /*#__PURE__*/React.createElement(TableCell, {
      align: "center"
    }, getNoaStatusChip(row)), /*#__PURE__*/React.createElement(TableCell, null, /*#__PURE__*/React.createElement(Button, {
      variant: "contained",
      color: "primary",
      size: "small",
      startIcon: /*#__PURE__*/React.createElement(VisibilityIcon, null),
      title: "View NOA",
      onClick: function onClick() {
        return handleOpenNoaModal(row);
      },
      style: {
        margin: "5px"
      }
    }, "View NOA"), row.noaBlocked ? /*#__PURE__*/React.createElement(Button, {
      variant: "contained",
      color: "primary",
      size: "small",
      startIcon: /*#__PURE__*/React.createElement(LockOpenIcon, null),
      onClick: function onClick() {
        return handleBlockNoa(row, false);
      },
      style: {
        margin: "5px"
      }
    }, "Unblock NOA Download") : /*#__PURE__*/React.createElement(React.Fragment, null, !row.noaSmsSent ? /*#__PURE__*/React.createElement(Button, {
      variant: "contained",
      color: "primary",
      size: "small",
      startIcon: /*#__PURE__*/React.createElement(EmailIcon, null),
      onClick: function onClick() {
        var _row$workforceApplica10;
        return handleSendSms(row, (dep === null || dep === void 0 ? void 0 : dep.nameEn) || (dep === null || dep === void 0 ? void 0 : dep.nameBn) || (row === null || row === void 0 || (_row$workforceApplica10 = row.workforceApplication) === null || _row$workforceApplica10 === void 0 || (_row$workforceApplica10 = _row$workforceApplica10.workforceEmployee) === null || _row$workforceApplica10 === void 0 ? void 0 : _row$workforceApplica10.firstNameEn) || "—");
      },
      style: {
        margin: "5px"
      }
    }, "Send Confirmation SMS") : !row.noaConfirmed ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
      variant: "contained",
      color: "primary",
      size: "small",
      startIcon: /*#__PURE__*/React.createElement(EmailIcon, null),
      onClick: function onClick() {
        var _row$workforceApplica11;
        return handleSendSms(row, (dep === null || dep === void 0 ? void 0 : dep.nameEn) || (dep === null || dep === void 0 ? void 0 : dep.nameBn) || (row === null || row === void 0 || (_row$workforceApplica11 = row.workforceApplication) === null || _row$workforceApplica11 === void 0 || (_row$workforceApplica11 = _row$workforceApplica11.workforceEmployee) === null || _row$workforceApplica11 === void 0 ? void 0 : _row$workforceApplica11.firstNameEn) || "—");
      },
      style: {
        margin: "5px"
      }
    }, "Send SMS Again"), /*#__PURE__*/React.createElement(Button, {
      variant: "contained",
      color: "primary",
      size: "small",
      startIcon: /*#__PURE__*/React.createElement(EditIcon, null),
      onClick: function onClick() {
        return handleConfirmNoa(row);
      },
      style: {
        margin: "5px"
      }
    }, "Confirm NOA Manually")) : /*#__PURE__*/React.createElement(Button, {
      variant: "contained",
      color: "secondary",
      size: "small",
      startIcon: /*#__PURE__*/React.createElement(BlockIcon, null),
      onClick: function onClick() {
        return handleBlockNoa(row, true);
      },
      style: {
        margin: "5px"
      }
    }, "Block NOA Download"))));
  }))), data.length === 0 && /*#__PURE__*/React.createElement(Box$1, {
    p: 5,
    textAlign: "center"
  }, /*#__PURE__*/React.createElement(Typography, {
    color: "textSecondary"
  }, "No data found matching current filters."))), selectedBeneficiary != null && /*#__PURE__*/React.createElement(GenerateNoaView, {
    open: openNoaModal,
    onClose: handleCloseNoaModal,
    onSuccess: function onSuccess() {
      handleCloseNoaModal();
      loadData();
    },
    row: selectedBeneficiary
  }));
};

function ownKeys$k(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$k(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$k(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$k(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var BeneficiaryPaymentList = function BeneficiaryPaymentList() {
  var dispatch = useDispatch();
  var currentYear = new Date().getFullYear();
  var yearOptions = Array.from({
    length: 11
  }, function (_, i) {
    return currentYear - i;
  });
  var monthOptions = Array.from({
    length: 12
  }, function (_, i) {
    return i + 1;
  });
  var monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
  var _useState = useState({
      year: "",
      month: ""
    }),
    _useState2 = _slicedToArray(_useState, 2),
    filters = _useState2[0],
    setFilters = _useState2[1];
  var _useState3 = useState(""),
    _useState4 = _slicedToArray(_useState3, 2),
    beneficiaryInput = _useState4[0],
    setBeneficiaryInput = _useState4[1];
  var _useState5 = useState(null),
    _useState6 = _slicedToArray(_useState5, 2),
    selectedBeneficiary = _useState6[0],
    setSelectedBeneficiary = _useState6[1];
  var _useState7 = useState([]),
    _useState8 = _slicedToArray(_useState7, 2),
    beneficiaries = _useState8[0],
    setBeneficiaries = _useState8[1];
  var _useState9 = useState(false),
    _useState10 = _slicedToArray(_useState9, 2),
    loadingBeneficiaries = _useState10[0],
    setLoadingBeneficiaries = _useState10[1];
  var _useState11 = useState([]),
    _useState12 = _slicedToArray(_useState11, 2),
    data = _useState12[0],
    setData = _useState12[1];
  var _useState13 = useState(false),
    _useState14 = _slicedToArray(_useState13, 2),
    loading = _useState14[0],
    setLoading = _useState14[1];
  var _useState15 = useState(""),
    _useState16 = _slicedToArray(_useState15, 2),
    error = _useState16[0],
    setError = _useState16[1];
  var beneficiaryRequest = useRef(0);
  var paymentRequest = useRef(0);
  var handleBeneficiaryInputChange = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(event, value, reason) {
      var requestId, _response$payload, _response$payload2, response;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            setBeneficiaryInput(value);
            if (!(reason === "reset")) {
              _context.next = 3;
              break;
            }
            return _context.abrupt("return");
          case 3:
            setSelectedBeneficiary(null);
            requestId = ++beneficiaryRequest.current;
            setError("");
            if (value.trim()) {
              _context.next = 10;
              break;
            }
            setBeneficiaries([]);
            setLoadingBeneficiaries(false);
            return _context.abrupt("return");
          case 10:
            if (!(reason !== "input")) {
              _context.next = 12;
              break;
            }
            return _context.abrupt("return");
          case 12:
            setLoadingBeneficiaries(true);
            _context.prev = 13;
            _context.next = 16;
            return dispatch(fetchWorkforceEisBeneficiaries({
              beneficiaryId: value.trim()
            }));
          case 16:
            response = _context.sent;
            if (!(requestId !== beneficiaryRequest.current)) {
              _context.next = 19;
              break;
            }
            return _context.abrupt("return");
          case 19:
            if (!(response !== null && response !== void 0 && response.error || response !== null && response !== void 0 && (_response$payload = response.payload) !== null && _response$payload !== void 0 && _response$payload.errors)) {
              _context.next = 21;
              break;
            }
            throw new Error("Unable to load beneficiary IDs.");
          case 21:
            setBeneficiaries((response === null || response === void 0 || (_response$payload2 = response.payload) === null || _response$payload2 === void 0 || (_response$payload2 = _response$payload2.data) === null || _response$payload2 === void 0 ? void 0 : _response$payload2.workforceEisBeneficiaries) || []);
            _context.next = 30;
            break;
          case 24:
            _context.prev = 24;
            _context.t0 = _context["catch"](13);
            if (!(requestId !== beneficiaryRequest.current)) {
              _context.next = 28;
              break;
            }
            return _context.abrupt("return");
          case 28:
            setBeneficiaries([]);
            setError(_context.t0.message || "Unable to load beneficiary IDs.");
          case 30:
            _context.prev = 30;
            if (requestId === beneficiaryRequest.current) {
              setLoadingBeneficiaries(false);
            }
            return _context.finish(30);
          case 33:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[13, 24, 30, 33]]);
    }));
    return function handleBeneficiaryInputChange(_x, _x2, _x3) {
      return _ref.apply(this, arguments);
    };
  }();
  var handleSearch = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var requestId, _response$payload3, _response$payload4, response;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            if (selectedBeneficiary !== null && selectedBeneficiary !== void 0 && selectedBeneficiary.beneficiaryId) {
              _context2.next = 3;
              break;
            }
            setError("Select a beneficiary ID before searching.");
            return _context2.abrupt("return");
          case 3:
            requestId = ++paymentRequest.current;
            setLoading(true);
            setError("");
            _context2.prev = 6;
            _context2.next = 9;
            return dispatch(fetchWorkforceEisBeneficiaryPayments({
              beneficiaryId: selectedBeneficiary.beneficiaryId,
              year: filters.year,
              month: filters.month
            }));
          case 9:
            response = _context2.sent;
            if (!(response !== null && response !== void 0 && response.error || response !== null && response !== void 0 && (_response$payload3 = response.payload) !== null && _response$payload3 !== void 0 && _response$payload3.errors)) {
              _context2.next = 12;
              break;
            }
            throw new Error("Unable to load beneficiary payments.");
          case 12:
            if (!(requestId !== paymentRequest.current)) {
              _context2.next = 14;
              break;
            }
            return _context2.abrupt("return");
          case 14:
            setData((response === null || response === void 0 || (_response$payload4 = response.payload) === null || _response$payload4 === void 0 || (_response$payload4 = _response$payload4.data) === null || _response$payload4 === void 0 ? void 0 : _response$payload4.workforceEisBeneficiaryPayments) || []);
            _context2.next = 23;
            break;
          case 17:
            _context2.prev = 17;
            _context2.t0 = _context2["catch"](6);
            if (!(requestId !== paymentRequest.current)) {
              _context2.next = 21;
              break;
            }
            return _context2.abrupt("return");
          case 21:
            setData([]);
            setError(_context2.t0.message || "Unable to load beneficiary payments.");
          case 23:
            _context2.prev = 23;
            if (requestId === paymentRequest.current) setLoading(false);
            return _context2.finish(23);
          case 26:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[6, 17, 23, 26]]);
    }));
    return function handleSearch() {
      return _ref2.apply(this, arguments);
    };
  }();
  var clearFilters = function clearFilters() {
    beneficiaryRequest.current += 1;
    paymentRequest.current += 1;
    setFilters({
      year: "",
      month: ""
    });
    setBeneficiaryInput("");
    setSelectedBeneficiary(null);
    setBeneficiaries([]);
    setLoadingBeneficiaries(false);
    setLoading(false);
    setData([]);
    setError("");
  };
  var totalPaidAmount = data.reduce(function (total, row) {
    return total + (Number(row === null || row === void 0 ? void 0 : row.paidAmount) || 0);
  }, 0);
  var formatDate = function formatDate(value) {
    if (!value) return "—";
    var date = new Date(value);
    return Number.isNaN(date.getTime()) ? "—" : date.toLocaleDateString("en-GB");
  };
  return /*#__PURE__*/React.createElement(Box$1, {
    bgcolor: "#fafafa",
    minHeight: "100vh"
  }, /*#__PURE__*/React.createElement(Box$1, {
    mb: 2
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5",
    style: {
      fontWeight: 700,
      marginBottom: 4
    }
  }, "Beneficiary Payment Report")), /*#__PURE__*/React.createElement(Paper, {
    elevation: 0,
    style: {
      padding: 24,
      marginBottom: 24,
      borderRadius: 12,
      border: "1px solid #eceff1"
    }
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 3,
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 6,
    md: 4
  }, /*#__PURE__*/React.createElement(Autocomplete$2, {
    options: beneficiaries,
    value: selectedBeneficiary,
    inputValue: beneficiaryInput,
    loading: loadingBeneficiaries,
    getOptionLabel: function getOptionLabel(option) {
      return (option === null || option === void 0 ? void 0 : option.beneficiaryId) || "";
    },
    getOptionSelected: function getOptionSelected(option, value) {
      return (option === null || option === void 0 ? void 0 : option.id) === (value === null || value === void 0 ? void 0 : value.id);
    },
    onInputChange: handleBeneficiaryInputChange,
    onChange: function onChange(event, beneficiary) {
      setSelectedBeneficiary(beneficiary);
      setBeneficiaryInput((beneficiary === null || beneficiary === void 0 ? void 0 : beneficiary.beneficiaryId) || "");
      setError("");
    },
    noOptionsText: beneficiaryInput ? "No beneficiary IDs found" : "Enter a beneficiary ID",
    renderInput: function renderInput(params) {
      return /*#__PURE__*/React.createElement(TextField, _extends({}, params, {
        required: true,
        label: "Beneficiary ID",
        variant: "outlined",
        size: "small",
        error: !selectedBeneficiary && Boolean(error),
        helperText: !selectedBeneficiary && error ? error : "",
        InputProps: _objectSpread$k(_objectSpread$k({}, params.InputProps), {}, {
          endAdornment: /*#__PURE__*/React.createElement(React.Fragment, null, loadingBeneficiaries ? /*#__PURE__*/React.createElement(CircularProgress$1, {
            color: "inherit",
            size: 18
          }) : null, params.InputProps.endAdornment)
        })
      }));
    }
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 6,
    md: 3
  }, /*#__PURE__*/React.createElement(TextField, {
    fullWidth: true,
    select: true,
    label: "Year",
    name: "year",
    variant: "outlined",
    size: "small",
    value: filters.year,
    onChange: function onChange(event) {
      return setFilters(function (prev) {
        return _objectSpread$k(_objectSpread$k({}, prev), {}, {
          year: event.target.value
        });
      });
    }
  }, /*#__PURE__*/React.createElement(MenuItem, {
    value: ""
  }, /*#__PURE__*/React.createElement("em", null, "All Years")), yearOptions.map(function (year) {
    return /*#__PURE__*/React.createElement(MenuItem, {
      key: year,
      value: year
    }, year);
  }))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 6,
    md: 3
  }, /*#__PURE__*/React.createElement(TextField, {
    fullWidth: true,
    select: true,
    label: "Month",
    name: "month",
    variant: "outlined",
    size: "small",
    value: filters.month,
    onChange: function onChange(event) {
      return setFilters(function (prev) {
        return _objectSpread$k(_objectSpread$k({}, prev), {}, {
          month: event.target.value
        });
      });
    }
  }, /*#__PURE__*/React.createElement(MenuItem, {
    value: ""
  }, /*#__PURE__*/React.createElement("em", null, "All Months")), monthOptions.map(function (month) {
    return /*#__PURE__*/React.createElement(MenuItem, {
      key: month,
      value: month
    }, monthNames[month - 1]);
  }))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 6,
    md: 2
  }, /*#__PURE__*/React.createElement(Box$1, {
    display: "flex",
    gridGap: 8
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: handleSearch,
    fullWidth: true,
    variant: "contained",
    color: "primary",
    startIcon: /*#__PURE__*/React.createElement(SearchIcon, null),
    disabled: loading
  }, "Search"), /*#__PURE__*/React.createElement(Button, {
    onClick: clearFilters,
    fullWidth: true,
    variant: "text",
    color: "default",
    startIcon: /*#__PURE__*/React.createElement(ClearAllIcon, null)
  }, "Reset"))))), error && selectedBeneficiary && /*#__PURE__*/React.createElement(Box$1, {
    mb: 2
  }, /*#__PURE__*/React.createElement(Typography, {
    color: "error"
  }, error)), loading ? /*#__PURE__*/React.createElement(Box$1, {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: 200
  }, /*#__PURE__*/React.createElement(CircularProgress$1, null)) : /*#__PURE__*/React.createElement(TableContainer, {
    component: Paper,
    elevation: 0,
    style: {
      borderRadius: 12,
      border: "1px solid #e0e0e0"
    }
  }, /*#__PURE__*/React.createElement(Table$2, null, /*#__PURE__*/React.createElement(TableHead, {
    style: {
      backgroundColor: "#f8fafd"
    }
  }, /*#__PURE__*/React.createElement(TableRow, null, /*#__PURE__*/React.createElement(TableCell, {
    style: {
      fontWeight: 600
    }
  }, "Beneficiary ID"), /*#__PURE__*/React.createElement(TableCell, {
    style: {
      fontWeight: 600
    }
  }, "Year"), /*#__PURE__*/React.createElement(TableCell, {
    style: {
      fontWeight: 600
    }
  }, "Month"), /*#__PURE__*/React.createElement(TableCell, {
    align: "right",
    style: {
      fontWeight: 600
    }
  }, "Paid Amount"), /*#__PURE__*/React.createElement(TableCell, {
    style: {
      fontWeight: 600
    }
  }, "EIS Payment Type"), /*#__PURE__*/React.createElement(TableCell, {
    style: {
      fontWeight: 600
    }
  }, "Installment Number"), /*#__PURE__*/React.createElement(TableCell, {
    style: {
      fontWeight: 600
    }
  }, "Processing Date"), /*#__PURE__*/React.createElement(TableCell, {
    style: {
      fontWeight: 600
    }
  }, "Disbursement Date"))), /*#__PURE__*/React.createElement(TableBody, null, data.map(function (row) {
    return /*#__PURE__*/React.createElement(TableRow, {
      key: row.id || "".concat(row.beneficiaryId, "-").concat(row.year, "-").concat(row.monthIndex, "-").concat(row.installmentNumber)
    }, /*#__PURE__*/React.createElement(TableCell, null, row.beneficiaryId || "—"), /*#__PURE__*/React.createElement(TableCell, null, row.year || "—"), /*#__PURE__*/React.createElement(TableCell, null, monthNames[Number(row.monthIndex) - 1] || row.monthIndex || "—"), /*#__PURE__*/React.createElement(TableCell, {
      align: "right"
    }, (Number(row.paidAmount) || 0).toLocaleString("en-BD")), /*#__PURE__*/React.createElement(TableCell, null, getPaymentTypeString(row.eisPaymentType) || row.eisPaymentType || "—"), /*#__PURE__*/React.createElement(TableCell, null, row.installmentNumber || "—"), /*#__PURE__*/React.createElement(TableCell, null, formatDate(row.processingDate)), /*#__PURE__*/React.createElement(TableCell, null, formatDate(row.disbursementDate)));
  }), data.length === 0 && /*#__PURE__*/React.createElement(TableRow, null, /*#__PURE__*/React.createElement(TableCell, {
    colSpan: 8,
    align: "center"
  }, /*#__PURE__*/React.createElement(Typography, {
    color: "textSecondary"
  }, selectedBeneficiary ? "No payments found." : "Select a beneficiary ID to search for payments.")))), /*#__PURE__*/React.createElement(TableFooter, null, /*#__PURE__*/React.createElement(TableRow, null, /*#__PURE__*/React.createElement(TableCell, {
    colSpan: 3,
    style: {
      fontWeight: 700
    }
  }, "Total (", data.length, " ", data.length === 1 ? "row" : "rows", ")"), /*#__PURE__*/React.createElement(TableCell, {
    align: "right",
    style: {
      fontWeight: 700
    }
  }, totalPaidAmount.toLocaleString("en-BD")), /*#__PURE__*/React.createElement(TableCell, {
    colSpan: 4
  }))))));
};

function ownKeys$j(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$j(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$j(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$j(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var useStyles$l = makeStyles(function (theme) {
  return {
    root: {
      flexGrow: 1,
      padding: theme.spacing(2),
      height: "100%",
      // assuming 64px header/appbar, adjust as needed
      overflow: "visible"
    },
    sidebar: {
      position: "sticky",
      top: "100px",
      height: "70vh",
      backgroundColor: theme.palette.background.paper,
      borderRight: "1px solid ".concat(theme.palette.divider),
      overflowY: "auto"
    },
    content: {
      height: "100%",
      overflowY: "visible",
      padding: theme.spacing(2)
    },
    tableContainer: {
      marginTop: theme.spacing(0)
    },
    tableHeadCell: {
      fontWeight: "bold"
    },
    noData: {
      textAlign: "center",
      padding: theme.spacing(2)
    },
    searchInput: {
      border: "1px solid #ccc",
      borderRadius: 4,
      padding: "4px 8px",
      width: 200
    },
    pagination: {
      display: "flex",
      justifyContent: "flex-end",
      marginTop: theme.spacing(2),
      alignItems: "center"
    },
    tableHeader: {
      backgroundColor: "#B7D4D8"
    },
    accordion: {
      boxShadow: "1px 1px 1px 1px",
      border: "none",
      backgroundColor: "white",
      marginBottom: "12px",
      borderRadius: "6px",
      "&::before": {
        display: "none"
      }
    },
    accordionSummary: {
      padding: "8px 16px",
      backgroundColor: "white",
      borderRadius: "6px",
      "& .MuiTypography-root": {
        color: "#015C63",
        // teal-like tone
        fontWeight: 600
      }
    },
    accordionDetails: {
      backgroundColor: "white",
      padding: "16px",
      borderTop: "1px solid #ddd"
    }
  };
});
var SidebarMenu$3 = [{
  id: "dashboard",
  text: /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.application.dashboard"
  }),
  icon: /*#__PURE__*/React.createElement(DashboardIcon, null)
}, {
  id: "pendingApplications",
  text: /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.application.pending"
  }),
  icon: /*#__PURE__*/React.createElement(AssignmentReturnedIcon, null)
}, {
  id: "sentForVerificationApplications",
  text: /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.application.sentforverification"
  }),
  icon: /*#__PURE__*/React.createElement(HourglassFullTwoToneIcon, null)
}, {
  id: "verifiedApplications",
  text: /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.application.verified"
  }),
  icon: /*#__PURE__*/React.createElement(VerifiedUserIcon, null)
}, {
  id: "rejectedApplication",
  text: /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.application.rejectedApplication"
  }),
  icon: /*#__PURE__*/React.createElement(CancelIcon, null)
}, {
  id: "pendingMeetingSheet",
  text: /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.employee.application.pendingMeetingSheet"
  }),
  icon: /*#__PURE__*/React.createElement(HourglassFullTwoToneIcon, null)
}, {
  id: "advisorApproveMeetingSheet",
  text: /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.employee.application.advisorApproveMeetingSheet"
  }),
  icon: /*#__PURE__*/React.createElement(CheckCircleOutlineTwoToneIcon, null)
}, {
  id: "revertedApplication",
  text: /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.application.reverted"
  }),
  icon: /*#__PURE__*/React.createElement(RestorePageIcon, null)
}, {
  id: "sentMeetingSheet",
  text: /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.employee.application.sentMeetingSheet"
  }),
  icon: /*#__PURE__*/React.createElement(ForwardIcon, null)
}, {
  id: "approveMeetingSheet",
  text: /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.employee.application.approveMeetingSheet"
  }),
  icon: /*#__PURE__*/React.createElement(CheckCircleOutlineTwoToneIcon, null)
}, {
  id: "applicationStatus",
  text: /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.application.status"
  }),
  icon: /*#__PURE__*/React.createElement(AssignmentIcon, null)
}, {
  id: "beneficiaryManagement",
  text: /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.application.beneficiaryManagement"
  }),
  icon: /*#__PURE__*/React.createElement(AssignmentIcon, null)
}, {
  id: "beneficiaryPaymentProcess",
  text: /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.application.beneficiaryPaymentProcess"
  }),
  icon: /*#__PURE__*/React.createElement(AssignmentIcon, null)
}, {
  id: "beneficiaryProcessedPaymentList",
  text: /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.application.beneficiaryProcessedPaymentList"
  }),
  icon: /*#__PURE__*/React.createElement(AssignmentIcon, null)
}, {
  id: "beneficiaryPayments",
  text: /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.application.beneficiaryPayments"
  }),
  icon: /*#__PURE__*/React.createElement(AssignmentIcon, null)
}, {
  id: "beneficiaryBankAdviceList",
  text: /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.application.beneficiaryBankAdviceList"
  }),
  icon: /*#__PURE__*/React.createElement(AssignmentIcon, null)
}, {
  id: "beneficiaryDisbursedPayments",
  text: /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.application.beneficiaryDisbursedPayments"
  }),
  icon: /*#__PURE__*/React.createElement(AssignmentIcon, null)
}, {
  id: "beneficiaryNoaConfirmation",
  text: /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.application.beneficiaryNoaConfirmation"
  }),
  icon: /*#__PURE__*/React.createElement(AssignmentIcon, null)
}];

// ----------- Components to Render in Main Content -----------

var FiledApplications$2 = function FiledApplications() {
  var classes = useStyles$l();
  var loggedInUserId = useSelector(function (state) {
    var _state$core;
    return (_state$core = state.core) === null || _state$core === void 0 || (_state$core = _state$core.user) === null || _state$core === void 0 || (_state$core = _state$core.i_user) === null || _state$core === void 0 ? void 0 : _state$core.id;
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5",
    gutterBottom: true
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.eis.coordinator.dashboard"
  })), /*#__PURE__*/React.createElement(Card, {
    className: classes.tableContainer
  }, /*#__PURE__*/React.createElement(CardContent, null, /*#__PURE__*/React.createElement(ApplicationProcessSearcher$1, {
    filedApplications: true,
    loggedInUserId: loggedInUserId,
    coloredRow: true,
    roleIds: ["47"]
  }))), /*#__PURE__*/React.createElement("div", {
    className: classes.pagination
  }, /*#__PURE__*/React.createElement(Button, null, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.back"
  })), /*#__PURE__*/React.createElement(Button, null, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.next"
  }))));
};
var ApprovedApplications$1 = function ApprovedApplications(_ref) {
  var _ref$summaryData = _ref.summaryData,
    summaryData = _ref$summaryData === void 0 ? [] : _ref$summaryData,
    _ref$disableButtons = _ref.disableButtons,
    disableButtons = _ref$disableButtons === void 0 ? 0 : _ref$disableButtons;
  var classes = useStyles$l();
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    expanded = _useState2[0],
    setExpanded = _useState2[1];
  var handleChange = function handleChange(panelId) {
    return function (event, isExpanded) {
      setExpanded(isExpanded ? panelId : null);
    };
  };
  console.log("clear");
  console.log("summary data", summaryData);
  return /*#__PURE__*/React.createElement("div", {
    className: classes.accordionPadding
  }, summaryData.map(function (item, index) {
    return /*#__PURE__*/React.createElement(Accordion, {
      key: index,
      expanded: expanded === item.id,
      onChange: handleChange(item.id),
      className: classes.accordion
    }, /*#__PURE__*/React.createElement(AccordionSummary, {
      className: classes.accordionSummary,
      expandIcon: /*#__PURE__*/React.createElement(ExpandMoreIcon, {
        className: "material-icons"
      })
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "subtitle1",
      style: {
        flex: 1
      }
    }, /*#__PURE__*/React.createElement("strong", null, item.name)), /*#__PURE__*/React.createElement(Typography, {
      variant: "body2",
      style: {
        marginLeft: "auto",
        color: "#015C63"
      }
    }, item.meetingDate, " | ", item.month, " ", item.year)), /*#__PURE__*/React.createElement(AccordionDetails, {
      className: classes.accordionDetails
    }, /*#__PURE__*/React.createElement(Card, {
      style: {
        width: "100%"
      }
    }, /*#__PURE__*/React.createElement(CardContent, null, expanded === item.id && /*#__PURE__*/React.createElement(ApplicationProcessSearcher$1, {
      summaryId: item.id,
      disableButtons: disableButtons
    })))));
  }));
};
var AdvisorApprovedApplications = function AdvisorApprovedApplications(_ref2) {
  var _ref2$summaryData = _ref2.summaryData,
    summaryData = _ref2$summaryData === void 0 ? [] : _ref2$summaryData;
  var classes = useStyles$l();
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    expanded = _useState4[0],
    setExpanded = _useState4[1];
  var handleChange = function handleChange(panelId) {
    return function (event, isExpanded) {
      setExpanded(isExpanded ? panelId : null);
    };
  };
  console.log("clear");
  console.log("summary data", summaryData);
  return /*#__PURE__*/React.createElement("div", {
    className: classes.accordionPadding
  }, summaryData.length === 0 && /*#__PURE__*/React.createElement(Typography, {
    variant: "h6",
    align: "center",
    style: {
      marginTop: "20px"
    }
  }, "Loading..."), summaryData.map(function (item, index) {
    return /*#__PURE__*/React.createElement(Accordion, {
      key: index,
      expanded: expanded === item.id,
      onChange: handleChange(item.id),
      className: classes.accordion
    }, /*#__PURE__*/React.createElement(AccordionSummary, {
      className: classes.accordionSummary,
      expandIcon: /*#__PURE__*/React.createElement(ExpandMoreIcon, {
        className: "material-icons"
      })
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "subtitle1",
      style: {
        flex: 1
      }
    }, /*#__PURE__*/React.createElement("strong", null, item.name)), /*#__PURE__*/React.createElement(Typography, {
      variant: "body2",
      style: {
        marginLeft: "auto",
        color: "#015C63"
      }
    }, item.meetingDate, " | ", item.month, " ", item.year)), /*#__PURE__*/React.createElement(AccordionDetails, {
      className: classes.accordionDetails
    }, /*#__PURE__*/React.createElement(Card, {
      style: {
        width: "100%"
      }
    }, /*#__PURE__*/React.createElement(CardContent, null, expanded === item.id && /*#__PURE__*/React.createElement(ApplicationProcessSearcher$1, {
      summaryId: item.id,
      approvedButton: 1,
      roleIds: ["49"],
      meetingForwardButton: 0
    })))));
  }));
};
var SentMeetingSheet = function SentMeetingSheet(_ref3) {
  var _ref3$summaryData = _ref3.summaryData,
    summaryData = _ref3$summaryData === void 0 ? [] : _ref3$summaryData,
    _ref3$disableButtons = _ref3.disableButtons,
    disableButtons = _ref3$disableButtons === void 0 ? 0 : _ref3$disableButtons;
  var classes = useStyles$l();
  var _useState5 = useState(null),
    _useState6 = _slicedToArray(_useState5, 2),
    expanded = _useState6[0],
    setExpanded = _useState6[1];
  var handleChange = function handleChange(panelId) {
    return function (event, isExpanded) {
      setExpanded(isExpanded ? panelId : null);
    };
  };
  console.log("clear");
  console.log("summary data", summaryData);
  return /*#__PURE__*/React.createElement("div", {
    className: classes.accordionPadding
  }, summaryData.map(function (item, index) {
    return /*#__PURE__*/React.createElement(Accordion, {
      key: index,
      expanded: expanded === item.id,
      onChange: handleChange(item.id),
      className: classes.accordion
    }, /*#__PURE__*/React.createElement(AccordionSummary, {
      className: classes.accordionSummary,
      expandIcon: /*#__PURE__*/React.createElement(ExpandMoreIcon, {
        className: "material-icons"
      })
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "subtitle1",
      style: {
        flex: 1
      }
    }, /*#__PURE__*/React.createElement("strong", null, item.name)), /*#__PURE__*/React.createElement(Typography, {
      variant: "body2",
      style: {
        marginLeft: "auto",
        color: "#015C63"
      }
    }, item.meetingDate, " | ", item.month, " ", item.year)), /*#__PURE__*/React.createElement(AccordionDetails, {
      className: classes.accordionDetails
    }, /*#__PURE__*/React.createElement(Card, {
      style: {
        width: "100%"
      }
    }, /*#__PURE__*/React.createElement(CardContent, null, expanded === item.id && /*#__PURE__*/React.createElement(ApplicationProcessSearcher$1, {
      summaryId: item.id,
      disableButtons: disableButtons
    })))));
  }));
};
var SentForVerificationApplications = function SentForVerificationApplications() {
  var classes = useStyles$l();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5",
    gutterBottom: true
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.application.sentforverification"
  })), /*#__PURE__*/React.createElement(Card, {
    className: classes.tableContainer
  }, /*#__PURE__*/React.createElement(CardContent, null, /*#__PURE__*/React.createElement(ApplicationProcessSearcher$1, {
    sentForVerificationApplications: true
  }))), /*#__PURE__*/React.createElement("div", {
    className: classes.pagination
  }, /*#__PURE__*/React.createElement(Button, null, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.back"
  })), /*#__PURE__*/React.createElement(Button, null, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.next"
  }))));
};
var VerifiedApplications = function VerifiedApplications() {
  var classes = useStyles$l();
  var loggedInUserId = useSelector(function (state) {
    var _state$core2;
    return (_state$core2 = state.core) === null || _state$core2 === void 0 || (_state$core2 = _state$core2.user) === null || _state$core2 === void 0 || (_state$core2 = _state$core2.i_user) === null || _state$core2 === void 0 ? void 0 : _state$core2.id;
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5",
    gutterBottom: true
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.application.verified"
  })), /*#__PURE__*/React.createElement(Card, {
    className: classes.tableContainer
  }, /*#__PURE__*/React.createElement(CardContent, null, /*#__PURE__*/React.createElement(ApplicationProcessSearcher$1, {
    verifiedApplications: true,
    meetingForwardButton: 1,
    loggedInUserId: loggedInUserId
  }))), /*#__PURE__*/React.createElement("div", {
    className: classes.pagination
  }, /*#__PURE__*/React.createElement(Button, null, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.back"
  })), /*#__PURE__*/React.createElement(Button, null, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.next"
  }))));
};
var BeneficiaryReportSheet$1 = function BeneficiaryReportSheet() {
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5",
    gutterBottom: true
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.employee.application.beneficiaryReportSheet"
  })), /*#__PURE__*/React.createElement(BeneficiaryReport, null));
};
var ApplicationStatus$1 = function ApplicationStatus() {
  var dispatch = useDispatch();
  var mm = useModulesManager();
  var _useState7 = useState(""),
    _useState8 = _slicedToArray(_useState7, 2),
    nid = _useState8[0],
    setNid = _useState8[1];
  var _useState9 = useState(false),
    _useState10 = _slicedToArray(_useState9, 2),
    showResult = _useState10[0],
    setShowResult = _useState10[1];
  var _useState11 = useState(null),
    _useState12 = _slicedToArray(_useState11, 2);
    _useState12[0];
    var setApplicationData = _useState12[1];
  var classes = useStyles$l();
  var _useState13 = useState(true),
    _useState14 = _slicedToArray(_useState13, 2),
    hasResults = _useState14[0],
    setHasResults = _useState14[1];
  var handleApplicationSearch = function handleApplicationSearch() {
    var filters = ["workforceEmployee_Nid: \"".concat(nid, "\"")];
    dispatch(fetchApplicationsSummary(mm, filters)).then(function (res) {
      var _res$payload;
      var edges = ((_res$payload = res.payload) === null || _res$payload === void 0 || (_res$payload = _res$payload.data) === null || _res$payload === void 0 || (_res$payload = _res$payload.workforceApplication) === null || _res$payload === void 0 ? void 0 : _res$payload.edges) || [];
      setApplicationData(edges.map(function (e) {
        return e.node;
      }));
      setShowResult(true);
    });
  };
  return /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(CardContent, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5",
    gutterBottom: true
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.application.status"
  })), /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 2,
    justifyContent: "center",
    style: {
      marginTop: 16,
      padding: "32px",
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 6
  }, /*#__PURE__*/React.createElement(TextField, {
    fullWidth: true,
    variant: "outlined",
    size: "small",
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      module: "workforce",
      id: "workforce.representative.nid"
    }),
    value: nid,
    onChange: function onChange(e) {
      return setNid(e.target.value);
    },
    style: {
      marginBottom: 16
    }
  }), /*#__PURE__*/React.createElement(Button, {
    variant: "contained",
    color: "primary",
    fullWidth: true,
    onClick: handleApplicationSearch
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.search.here"
  })))), showResult && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Card, {
    className: classes.tableContainer,
    style: {
      marginTop: 10
    }
  }, /*#__PURE__*/React.createElement(CardContent, null, /*#__PURE__*/React.createElement(ApplicationProcessSearcher$1, {
    nidFilters: ["workforceEmployee_Nid: \"".concat(nid, "\"")],
    onDataLoaded: function onDataLoaded(data) {
      return setHasResults(data && data.length > 0);
    },
    disableButtons: 1
  }))), !hasResults && /*#__PURE__*/React.createElement(Typography, {
    color: "error",
    style: {
      marginTop: 32
    }
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.tracking.notfound",
    defaultMessage: "\u0995\u09CB\u09A8\u09CB \u0986\u09AC\u09C7\u09A6\u09A8 \u09AA\u09BE\u0993\u09AF\u09BC\u09BE \u09AF\u09BE\u09AF\u09BC\u09A8\u09BF\u0964"
  })))));
};
var DashboardCard$2 = function DashboardCard(_ref4) {
  var title = _ref4.title,
    subtitle = _ref4.subtitle,
    children = _ref4.children;
  return /*#__PURE__*/React.createElement(Card, {
    style: {
      height: "100%",
      borderRadius: "16px",
      boxShadow: "0 4px 12px 0 rgba(0,0,0,0.05)",
      padding: "10px"
    }
  }, /*#__PURE__*/React.createElement(CardHeader, {
    title: /*#__PURE__*/React.createElement(Typography, {
      variant: "h6",
      style: {
        fontWeight: "bold"
      }
    }, title),
    subheader: subtitle ? /*#__PURE__*/React.createElement(Typography, {
      variant: "body2",
      color: "textSecondary"
    }, subtitle) : null
  }), /*#__PURE__*/React.createElement(CardContent, {
    style: {
      paddingTop: 0
    }
  }, children));
};
var StatRow$2 = function StatRow(_ref5) {
  var label = _ref5.label,
    count = _ref5.count,
    onClick = _ref5.onClick,
    color = _ref5.color;
  return /*#__PURE__*/React.createElement(Box$1, {
    display: "flex",
    justifyContent: "space-between",
    py: 1,
    borderBottom: "1px solid #f0f0f0"
  }, /*#__PURE__*/React.createElement(Typography, {
    style: {
      color: color || "inherit"
    }
  }, label), onClick ? /*#__PURE__*/React.createElement(Link, {
    component: "button",
    variant: "subtitle1",
    style: {
      fontWeight: "bold",
      color: color || "#1976d2"
    },
    onClick: onClick
  }, count) : /*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle1",
    style: {
      fontWeight: "bold",
      color: color || "inherit"
    }
  }, count));
};
var filterPaymentRecordsByOverallFilters = function filterPaymentRecordsByOverallFilters(records, filters) {
  if (!Array.isArray(records)) return [];
  var fromDate = filters.fromDate,
    toDate = filters.toDate,
    accFromDate = filters.accFromDate,
    accToDate = filters.accToDate,
    association = filters.association;
  var from = fromDate ? new Date(fromDate) : null;
  var to = toDate ? new Date(toDate) : null;
  var accidentFrom = accFromDate ? new Date(accFromDate) : null;
  var accidentTo = accToDate ? new Date(accToDate) : null;
  if (to) to.setHours(23, 59, 59, 999);
  if (accidentTo) accidentTo.setHours(23, 59, 59, 999);
  return records.filter(function (record) {
    var _application$associat;
    var application = record === null || record === void 0 ? void 0 : record.workforceApplication;
    if (!application) return false;
    if (association !== "all" && ((_application$associat = application.associationType) === null || _application$associat === void 0 ? void 0 : _application$associat.toLowerCase()) !== association.toLowerCase()) return false;
    var submissionDate = application.dateCreated ? new Date(application.dateCreated) : null;
    if (from && (!submissionDate || submissionDate < from)) return false;
    if (to && (!submissionDate || submissionDate > to)) return false;
    if (!accidentFrom && !accidentTo) return true;
    var accidentInfo = typeof application.employeeAccidentInfo === "string" ? safeParse(application.employeeAccidentInfo) : application.employeeAccidentInfo;
    var accidentDate = accidentInfo !== null && accidentInfo !== void 0 && accidentInfo.accidentDate ? new Date(accidentInfo.accidentDate) : null;
    if (!accidentDate) return false;
    if (accidentFrom && accidentDate < accidentFrom) return false;
    if (accidentTo && accidentDate > accidentTo) return false;
    return true;
  });
};
var Dashboard$3 = function Dashboard(_ref6) {
  var _reduxState$core;
  var selectedMenu = _ref6.selectedMenu;
  var dispatch = useDispatch();
  useTheme();
  var history = useHistory();
  getUserType();
  var modulesManager = useModulesManager();
  var reduxState = useSelector(function (state) {
    return state;
  });
  var locale = (reduxState === null || reduxState === void 0 || (_reduxState$core = reduxState.core) === null || _reduxState$core === void 0 || (_reduxState$core = _reduxState$core.user) === null || _reduxState$core === void 0 || (_reduxState$core = _reduxState$core.i_user) === null || _reduxState$core === void 0 ? void 0 : _reduxState$core.language) || "en";
  var isBn = locale === "fr" || locale === "bn";
  var applicationTypeNames = locale === "en" ? APP_TYPE_DASHBOARD_EN : APP_TYPE_DASHBOARD_BN;
  var applicantTypeNames = locale === "en" ? APPLICANT_TYPE_EN : APPLICANT_TYPE_BN;

  // --- 1. ORIGINAL STATE ---
  var _useState15 = useState([]),
    _useState16 = _slicedToArray(_useState15, 2),
    applications = _useState16[0],
    setApplications = _useState16[1];
  var _useState17 = useState([]),
    _useState18 = _slicedToArray(_useState17, 2),
    disbursedApplication = _useState18[0],
    setDisbursedApplication = _useState18[1];
  var _useState19 = useState(0),
    _useState20 = _slicedToArray(_useState19, 2),
    months = _useState20[0],
    setMonths = _useState20[1];
  var _useState21 = useState(""),
    _useState22 = _slicedToArray(_useState21, 2);
    _useState22[0];
    var setMonthString = _useState22[1];
  var _useState23 = useState("eis"),
    _useState24 = _slicedToArray(_useState23, 2),
    filter = _useState24[0];
    _useState24[1];
  var _useState25 = useState(""),
    _useState26 = _slicedToArray(_useState25, 2),
    fromDate = _useState26[0],
    setFromDate = _useState26[1];
  var _useState27 = useState(""),
    _useState28 = _slicedToArray(_useState27, 2);
    _useState28[0];
    _useState28[1];
  var _useState29 = useState(""),
    _useState30 = _slicedToArray(_useState29, 2),
    toDate = _useState30[0],
    setToDate = _useState30[1];
  var _useState31 = useState(""),
    _useState32 = _slicedToArray(_useState31, 2);
    _useState32[0];
    _useState32[1];
  var _useState33 = useState(""),
    _useState34 = _slicedToArray(_useState33, 2);
    _useState34[0];
    _useState34[1];
  var _useState35 = useState(6),
    _useState36 = _slicedToArray(_useState35, 2),
    graphMonths = _useState36[0];
    _useState36[1];
  var _useState37 = useState(""),
    _useState38 = _slicedToArray(_useState37, 2);
    _useState38[0];
    _useState38[1];
  var _useState39 = useState(""),
    _useState40 = _slicedToArray(_useState39, 2);
    _useState40[0];
    _useState40[1];
  var _useState41 = useState([]),
    _useState42 = _slicedToArray(_useState41, 2);
    _useState42[0];
    var setTableRows = _useState42[1];
  var _useState43 = useState({
      total: 0,
      approved: 0,
      cancelled: 0,
      processing: 0
    }),
    _useState44 = _slicedToArray(_useState43, 2);
    _useState44[0];
    var setTotals = _useState44[1];
  var _useState45 = useState([]),
    _useState46 = _slicedToArray(_useState45, 2);
    _useState46[0];
    var setPendingApplicationTypes = _useState46[1];
  var _useState47 = useState([]),
    _useState48 = _slicedToArray(_useState47, 2);
    _useState48[0];
    var setApplicationTypes = _useState48[1];
  var _useState49 = useState([]),
    _useState50 = _slicedToArray(_useState49, 2),
    applicationCounts = _useState50[0],
    setApplicationCounts = _useState50[1];
  var _useState51 = useState(0),
    _useState52 = _slicedToArray(_useState51, 2);
    _useState52[0];
    var setTotalBenefitAmount = _useState52[1];
  var _useState53 = useState([]),
    _useState54 = _slicedToArray(_useState53, 2),
    pieData = _useState54[0],
    setPieData = _useState54[1];
  var _useState55 = useState([]),
    _useState56 = _slicedToArray(_useState55, 2),
    barData = _useState56[0],
    setBarData = _useState56[1];
  var _useState57 = useState(false),
    _useState58 = _slicedToArray(_useState57, 2),
    openModal = _useState58[0],
    setOpenModal = _useState58[1];
  var _useState59 = useState(null),
    _useState60 = _slicedToArray(_useState59, 2),
    selectedType = _useState60[0];
    _useState60[1];

  // --- 2. GLOBAL FILTERS STATE ---
  var _useState61 = useState(""),
    _useState62 = _slicedToArray(_useState61, 2),
    accFromDate = _useState62[0],
    setAccFromDate = _useState62[1];
  var _useState63 = useState(""),
    _useState64 = _slicedToArray(_useState63, 2),
    accToDate = _useState64[0],
    setAccToDate = _useState64[1];
  var _useState65 = useState("all"),
    _useState66 = _slicedToArray(_useState65, 2),
    association = _useState66[0],
    setAssociation = _useState66[1];
  var _useState67 = useState([]),
    _useState68 = _slicedToArray(_useState67, 2),
    associationOptions = _useState68[0],
    setAssociationOptions = _useState68[1];
  var _useState69 = useState({
      male: 0,
      female: 0,
      total: 0
    }),
    _useState70 = _slicedToArray(_useState69, 2),
    beneficiaryCounts = _useState70[0],
    setBeneficiaryCounts = _useState70[1];

  // --- 3. EIS ADVISOR STATE ---
  var _useState71 = useState({
      almost18: 0,
      adultFemaleUnmarried: 0,
      elderly: 0,
      widowUnder35: 0
    }),
    _useState72 = _slicedToArray(_useState71, 2),
    beneficiaryMonitoring = _useState72[0],
    setBeneficiaryMonitoring = _useState72[1];
  var _useState73 = useState({
      pending1m: 0,
      pending3m: 0,
      pending6m: 0,
      pending9m: 0,
      successful: 0
    }),
    _useState74 = _slicedToArray(_useState73, 2),
    verificationOverview = _useState74[0];
    _useState74[1];
  var _useState75 = useState({
      unmarriedWidow: 0,
      unmarriedWidower: 0,
      unmarriedSister: 0,
      unmarriedDaughter: 0,
      unmarriedGrandDaughter: 0
    }),
    _useState76 = _slicedToArray(_useState75, 2),
    marriageStatus = _useState76[0],
    setMarriageStatus = _useState76[1];
  var _useState77 = useState({
      disbursed: 0,
      pending: 0,
      onHold: 0
    }),
    _useState78 = _slicedToArray(_useState77, 2),
    paymentStatus = _useState78[0],
    setPaymentStatus = _useState78[1];
  var _useState79 = useState([]),
    _useState80 = _slicedToArray(_useState79, 2);
    _useState80[0];
    var setMonthlyPaymentStatus = _useState80[1];

  // --- 4. PREVIOUS OVERVIEW STATES ---
  var _useState81 = useState({
      factory: 0,
      association: 0,
      eis: 0
    }),
    _useState82 = _slicedToArray(_useState81, 2);
    _useState82[0];
    _useState82[1];
  var _useState83 = useState({
      verified: {
        death: 0,
        disability: 0
      },
      nonVerified: {
        death: 0,
        disability: 0
      }
    }),
    _useState84 = _slicedToArray(_useState83, 2);
    _useState84[0];
    _useState84[1];
  var _useState85 = useState({
      death: {
        male: 0,
        female: 0
      },
      disability: {
        male: 0,
        female: 0
      }
    }),
    _useState86 = _slicedToArray(_useState85, 2);
    _useState86[0];
    _useState86[1];
  var _useState87 = useState({
      death: {
        workplace: 0,
        commuting: 0,
        rta: 0
      },
      disability: {
        workplace: 0,
        commuting: 0,
        rta: 0
      }
    }),
    _useState88 = _slicedToArray(_useState87, 2);
    _useState88[0];
    _useState88[1];
  var _useState89 = useState({
      paid: {
        death: 0,
        disability: 0
      },
      lifetime: {
        death: 0,
        disability: 0
      }
    }),
    _useState90 = _slicedToArray(_useState89, 2),
    financialCounts = _useState90[0],
    setFinancialCounts = _useState90[1];

  // Chart String Translations (Used for Recharts Data objects)
  var chartLabels = {
    processing: isBn ? "প্রক্রিয়াধীন" : "Processing",
    approved: isBn ? "অনুমোদিত" : "Approved",
    reverted: isBn ? "বাতিল" : "Reverted",
    rejected: isBn ? "প্রত্যাখ্যান" : "Rejected",
    medical: isBn ? "চিকিৎসা" : "Medical",
    death: isBn ? "মৃত্যু" : "Death",
    educational: isBn ? "শিক্ষা" : "Educational",
    maternity: isBn ? "মাতৃত্ব" : "Maternity",
    disability: isBn ? "স্থায়ী ও অস্থায়ী অক্ষমতা" : "Permanent Or Curable Disability"
  };

  // --- HELPER FUNCTIONS ---
  var getMonthName = function getMonthName(index) {
    var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "en-US";
    var date = new Date(2000, index, 1);
    return date.toLocaleString(locale, {
      month: "long"
    });
  };
  var handleFromDateChange = function handleFromDateChange(date) {
    return setFromDate(date);
  };
  var handleToDateChange = function handleToDateChange(date) {
    return setToDate(date);
  };
  var handleBeneficiaryClick = function handleBeneficiaryClick(filterValue) {
    history.push("/beneficiary-management?filter=".concat(filterValue));
  };

  // --- EFFECTS ---
  useEffect(function () {
    if (months > 0) {
      setFromDate("");
      setToDate("");
    }
  }, [months]);
  useEffect(function () {
    setMonths(0);
    setMonthString("");
  }, [fromDate, toDate]);
  useEffect(function () {
    dispatch(fetchWorkforceAllAssociationSummary([])).then(function (response) {
      var _response$payload;
      setAssociationOptions((response === null || response === void 0 || (_response$payload = response.payload) === null || _response$payload === void 0 || (_response$payload = _response$payload.data) === null || _response$payload === void 0 || (_response$payload = _response$payload.workforceAllAssociation) === null || _response$payload === void 0 ? void 0 : _response$payload.edges) || []);
    });
  }, [dispatch]);
  useEffect(function () {
    var loadMonthlyPaymentStatus = /*#__PURE__*/function () {
      var _ref7 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var monthCount, today, requests, rows, latestMonth;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              monthCount = Number(graphMonths) > 0 ? Number(graphMonths) : 6;
              today = new Date();
              requests = Array.from({
                length: monthCount
              }, function (_, index) {
                var monthDate = new Date(today.getFullYear(), today.getMonth() - (monthCount - index - 1), 1);
                var params = new URLSearchParams({
                  year: String(monthDate.getFullYear()),
                  month: String(monthDate.getMonth() + 1)
                });
                return fetch("/api/workforce/dashboard/counts?".concat(params.toString())).then(/*#__PURE__*/function () {
                  var _ref8 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(response) {
                    var _payload$data, _payload$data2, _payload$data3;
                    var payload;
                    return _regeneratorRuntime.wrap(function _callee$(_context) {
                      while (1) switch (_context.prev = _context.next) {
                        case 0:
                          _context.next = 2;
                          return response.json();
                        case 2:
                          payload = _context.sent;
                          if (!(!response.ok || (payload === null || payload === void 0 ? void 0 : payload.status) !== "success")) {
                            _context.next = 5;
                            break;
                          }
                          throw new Error((payload === null || payload === void 0 ? void 0 : payload.detail) || (payload === null || payload === void 0 ? void 0 : payload.message) || "Failed to load monthly payment status");
                        case 5:
                          return _context.abrupt("return", {
                            month: monthDate.toLocaleString(isBn ? "bn-BD" : "en-US", {
                              month: "short"
                            }),
                            disbursed: Number(payload === null || payload === void 0 || (_payload$data = payload.data) === null || _payload$data === void 0 || (_payload$data = _payload$data.status_counts) === null || _payload$data === void 0 ? void 0 : _payload$data.disbursed_count) || 0,
                            pending: Number(payload === null || payload === void 0 || (_payload$data2 = payload.data) === null || _payload$data2 === void 0 || (_payload$data2 = _payload$data2.status_counts) === null || _payload$data2 === void 0 ? void 0 : _payload$data2.pending_count) || 0,
                            onHold: Number(payload === null || payload === void 0 || (_payload$data3 = payload.data) === null || _payload$data3 === void 0 || (_payload$data3 = _payload$data3.status_counts) === null || _payload$data3 === void 0 ? void 0 : _payload$data3.on_hold_count) || 0
                          });
                        case 6:
                        case "end":
                          return _context.stop();
                      }
                    }, _callee);
                  }));
                  return function (_x) {
                    return _ref8.apply(this, arguments);
                  };
                }());
              });
              _context2.next = 6;
              return Promise.all(requests);
            case 6:
              rows = _context2.sent;
              setMonthlyPaymentStatus(rows);
              latestMonth = rows[rows.length - 1];
              setPaymentStatus({
                disbursed: (latestMonth === null || latestMonth === void 0 ? void 0 : latestMonth.disbursed) || 0,
                pending: (latestMonth === null || latestMonth === void 0 ? void 0 : latestMonth.pending) || 0,
                onHold: (latestMonth === null || latestMonth === void 0 ? void 0 : latestMonth.onHold) || 0
              });
              _context2.next = 17;
              break;
            case 12:
              _context2.prev = 12;
              _context2.t0 = _context2["catch"](0);
              console.error("Failed to load monthly payment status", _context2.t0);
              setMonthlyPaymentStatus([]);
              setPaymentStatus({
                disbursed: 0,
                pending: 0,
                onHold: 0
              });
            case 17:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[0, 12]]);
      }));
      return function loadMonthlyPaymentStatus() {
        return _ref7.apply(this, arguments);
      };
    }();
    loadMonthlyPaymentStatus();
  }, [graphMonths, isBn]);
  useEffect(function () {
    var loadFinancialOverview = /*#__PURE__*/function () {
      var _ref9 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var _payload$data4, response, payload, amountsByType, _totals;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              _context3.next = 3;
              return fetch("/api/workforce/dashboard/counts");
            case 3:
              response = _context3.sent;
              _context3.next = 6;
              return response.json();
            case 6:
              payload = _context3.sent;
              if (!(!response.ok || (payload === null || payload === void 0 ? void 0 : payload.status) !== "success")) {
                _context3.next = 9;
                break;
              }
              throw new Error((payload === null || payload === void 0 ? void 0 : payload.detail) || (payload === null || payload === void 0 ? void 0 : payload.message) || "Failed to load financial overview");
            case 9:
              amountsByType = (payload === null || payload === void 0 || (_payload$data4 = payload.data) === null || _payload$data4 === void 0 ? void 0 : _payload$data4.amounts_by_application_type) || [];
              _totals = amountsByType.reduce(function (result, row) {
                var applicationType = String((row === null || row === void 0 ? void 0 : row.workforce_application__application_type) || "").toLowerCase();
                var isDeath = ["financialasistant", "financialassistance"].includes(applicationType);
                var isDisability = applicationType === "disabilityassistance";
                if (!isDeath && !isDisability) return result;
                var key = isDeath ? "death" : "disability";
                result.paid[key] += Number(row === null || row === void 0 ? void 0 : row.total_paid) || 0;
                result.lifetime[key] += Number(row === null || row === void 0 ? void 0 : row.total_approved) || 0;
                return result;
              }, {
                paid: {
                  death: 0,
                  disability: 0
                },
                lifetime: {
                  death: 0,
                  disability: 0
                }
              });
              setFinancialCounts(_totals);
              _context3.next = 18;
              break;
            case 14:
              _context3.prev = 14;
              _context3.t0 = _context3["catch"](0);
              console.error("Failed to load financial overview", _context3.t0);
              setFinancialCounts({
                paid: {
                  death: 0,
                  disability: 0
                },
                lifetime: {
                  death: 0,
                  disability: 0
                }
              });
            case 18:
            case "end":
              return _context3.stop();
          }
        }, _callee3, null, [[0, 14]]);
      }));
      return function loadFinancialOverview() {
        return _ref9.apply(this, arguments);
      };
    }();
    loadFinancialOverview();
  }, []);
  useEffect(function () {
    function loadData() {
      return _loadData.apply(this, arguments);
    }
    function _loadData() {
      _loadData = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var orgType, res, rows, appTypes, pendingAppTypes, totalsCalc, genderRes, appCounts;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              orgType = filter === "সব" || filter === "All" ? "" : filter.toLowerCase();
              res = [];
              _context4.next = 5;
              return dispatch(fetchApplicationByDate(months, fromDate, toDate, orgType)).then(function (response) {
                var _response$payload2;
                res = ((_response$payload2 = response.payload) === null || _response$payload2 === void 0 || (_response$payload2 = _response$payload2.data) === null || _response$payload2 === void 0 ? void 0 : _response$payload2.workforceApplicationMatrix) || [];
              });
            case 5:
              rows = [];
              appTypes = [];
              pendingAppTypes = [];
              res.forEach(function (item) {
                var type = item.applicationType;
                var allow = false;
                if (orgType === "blwf") allow = type !== "disabilityAssistance";else if (orgType === "eis") allow = ["disabilityAssistance", "financialAssistance", "death"].includes(type);else allow = true;
                if (allow) {
                  rows.push({
                    type: applicationTypeNames[type],
                    total: Number(item.applicationCount),
                    approved: Number(item.approvedCount),
                    cancelled: Number(item.rejectedCount),
                    processing: Number(item.applicationCount) - (Number(item.approvedCount) + Number(item.rejectedCount))
                  });
                  appTypes.push({
                    appType: type,
                    type: applicationTypeNames[type],
                    count: Number(item.applicationCount)
                  });
                  pendingAppTypes.push({
                    appType: type,
                    type: applicationTypeNames[type],
                    count: Number(item.applicationCount) - (Number(item.approvedCount) + Number(item.rejectedCount))
                  });
                }
              });
              setApplicationTypes(appTypes);
              setPendingApplicationTypes(pendingAppTypes);
              totalsCalc = rows.reduce(function (acc, r) {
                acc.total += Number(r.total);
                acc.approved += Number(r.approved);
                acc.cancelled += Number(r.cancelled);
                acc.processing += Number(r.processing);
                return acc;
              }, {
                total: 0,
                approved: 0,
                cancelled: 0,
                processing: 0
              });
              totalsCalc.processing = Math.max(0, totalsCalc.total - totalsCalc.approved - totalsCalc.cancelled);
              setTableRows(rows);
              setTotals(totalsCalc);
              setPieData([{
                name: chartLabels.processing,
                value: totalsCalc.processing,
                color: "#6cdfdfff"
              }, {
                name: chartLabels.approved,
                value: totalsCalc.approved,
                color: "#68b88cff"
              }, {
                name: chartLabels.rejected,
                value: totalsCalc.cancelled,
                color: "#d48aa3ff"
              }]);
              genderRes = [];
              _context4.next = 19;
              return dispatch(fetchGenderWiseApplicationMatrixByDate(months, fromDate, toDate, orgType)).then(function (response) {
                var _response$payload3;
                genderRes = ((_response$payload3 = response.payload) === null || _response$payload3 === void 0 || (_response$payload3 = _response$payload3.data) === null || _response$payload3 === void 0 ? void 0 : _response$payload3.workforceGenderwiseMatrix[0]) || [];
              });
            case 19:
              appCounts = [{
                type: applicantTypeNames["maleDependent"],
                count: genderRes.maleDependent
              }, {
                type: applicantTypeNames["femaleDependent"],
                count: genderRes.femaleDependent
              }, {
                type: applicantTypeNames["totalDependent"],
                count: genderRes.totalDependent
              }];
              setApplicationCounts(appCounts);
              setTotalBenefitAmount(genderRes.totalBenefitAmount || 0);
              _context4.next = 27;
              break;
            case 24:
              _context4.prev = 24;
              _context4.t0 = _context4["catch"](0);
              console.error("Failed to fetch data", _context4.t0);
            case 27:
            case "end":
              return _context4.stop();
          }
        }, _callee4, null, [[0, 24]]);
      }));
      return _loadData.apply(this, arguments);
    }
    loadData();
  }, [months, fromDate, toDate, filter, chartLabels.processing, chartLabels.approved, chartLabels.reverted]);
  useEffect(function () {
    function loadMonthWiseData() {
      return _loadMonthWiseData.apply(this, arguments);
    }
    function _loadMonthWiseData() {
      _loadMonthWiseData = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var monthWiseRes, barDataArray;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.prev = 0;
              monthWiseRes = [];
              _context5.next = 4;
              return dispatch(fetchApplicationMonthWise(graphMonths)).then(function (response) {
                var _response$payload4;
                monthWiseRes = ((_response$payload4 = response.payload) === null || _response$payload4 === void 0 || (_response$payload4 = _response$payload4.data) === null || _response$payload4 === void 0 ? void 0 : _response$payload4.workforceMonthwiseApplications) || [];
              });
            case 4:
              barDataArray = [];
              monthWiseRes.map(function (item) {
                barDataArray.push(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({
                  month: getMonthName(Number(item.month) - 1)
                }, chartLabels.medical, item.medical), chartLabels.death, item.death), chartLabels.educational, item.educational), chartLabels.maternity, item.maternityGrant), chartLabels.disability, item.disabilityAssistance));
              });
              setBarData(barDataArray);
              _context5.next = 12;
              break;
            case 9:
              _context5.prev = 9;
              _context5.t0 = _context5["catch"](0);
              console.error("Failed to fetch month wise data", _context5.t0);
            case 12:
            case "end":
              return _context5.stop();
          }
        }, _callee5, null, [[0, 9]]);
      }));
      return _loadMonthWiseData.apply(this, arguments);
    }
    loadMonthWiseData();
  }, [graphMonths, chartLabels.medical, chartLabels.death, chartLabels.educational, chartLabels.maternity, chartLabels.disability]);
  useEffect(function () {
    function loadNewDashboardRequirements() {
      return _loadNewDashboardRequirements.apply(this, arguments);
    }
    function _loadNewDashboardRequirements() {
      _loadNewDashboardRequirements = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        var filtersBase, dashboardFilters, statusCountFilters;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              filtersBase = [
              // 'statusIn: ["forward_to_eis_advisor","approved_by_eis_director"]',
              'organizationTypeIn: ["eis"]', 'orderBy: ["-dateCreated"]'];
              dashboardFilters = [].concat(filtersBase);
              if (fromDate) dashboardFilters.push("dateCreatedFrom: \"".concat(fromDate, "\""));
              if (toDate) dashboardFilters.push("dateCreatedTo: \"".concat(toDate, "\""));
              if (association !== "all") dashboardFilters.push("associationTypeIn: [\"".concat(association.toUpperCase(), "\"]"));
              dispatch(fetchApplicationsSummaryDashboard(modulesManager, dashboardFilters)).then(function (res) {
                var _res$payload2;
                var response = parseData(res === null || res === void 0 || (_res$payload2 = res.payload) === null || _res$payload2 === void 0 || (_res$payload2 = _res$payload2.data) === null || _res$payload2 === void 0 ? void 0 : _res$payload2.workforceApplication);
                var formData = Array.isArray(response) ? response.map(function (application) {
                  var parsedMetadata = safeParse(application === null || application === void 0 ? void 0 : application.metadata);
                  var parsedApplicantInfo = safeParse(application === null || application === void 0 ? void 0 : application.applicantInfo);
                  var parsedDeceasedWorkerInfo = safeParse(application === null || application === void 0 ? void 0 : application.deceasedWorkerInfo);
                  var parsedEmployeeAccidentInfo = safeParse(application === null || application === void 0 ? void 0 : application.employeeAccidentInfo);
                  // const parsedEmployeeDependentInfo = JSON.parse(application?.employeeDependentInfo)
                  // const parsedEmployeeBankInfo = JSON.parse(application?.employeeBankInfo)

                  return _objectSpread$j(_objectSpread$j({}, application), {}, {
                    applicantInfo: parsedApplicantInfo,
                    metadata: parsedMetadata,
                    deceasedWorkerInfo: parsedDeceasedWorkerInfo,
                    employeeAccidentInfo: parsedEmployeeAccidentInfo
                    // employeeDependentInfo:JSON.parse(parsedEmployeeDependentInfo),
                    // employeeBankInfo:JSON.parse(parsedEmployeeBankInfo)
                  });
                }) : [];
                var filteredApplications = formData.filter(function (application) {
                  if (association !== "all") {
                    var _application$associat2;
                    if ((application === null || application === void 0 || (_application$associat2 = application.associationType) === null || _application$associat2 === void 0 ? void 0 : _application$associat2.toLowerCase()) !== association.toLowerCase()) return false;
                  }
                  var accidentInfo = typeof (application === null || application === void 0 ? void 0 : application.employeeAccidentInfo) === "string" ? safeParse(application.employeeAccidentInfo) : application === null || application === void 0 ? void 0 : application.employeeAccidentInfo;
                  var accidentDate = accidentInfo === null || accidentInfo === void 0 ? void 0 : accidentInfo.accidentDate;
                  if (!accFromDate && !accToDate) return true;
                  if (!accidentDate) return false;
                  var accidentDateValue = new Date(accidentDate);
                  var fromDateValue = accFromDate ? new Date(accFromDate) : null;
                  var toDateValue = accToDate ? new Date(accToDate) : null;
                  if (fromDateValue && accidentDateValue < fromDateValue) return false;
                  if (toDateValue) {
                    toDateValue.setHours(23, 59, 59, 999);
                    if (accidentDateValue > toDateValue) return false;
                  }
                  return true;
                });
                setApplications(filteredApplications);
                setBeneficiaryCounts(getFilteredBeneficiaryCounts(filteredApplications));
                setMarriageStatus(getMarriageStatusCounts(filteredApplications));
                setBeneficiaryMonitoring(getBeneficiaryMonitoringCounts(filteredApplications));
                console.log({
                  fromEISAdvisor: formData
                });
              });
              statusCountFilters = dashboardFilters.filter(function (filterValue) {
                return !filterValue.startsWith("orderBy");
              });
              dispatch(fetchApplicationStatusCounts(statusCountFilters)).then(function (res) {
                var _res$payload3, _counts$total, _counts$approved, _counts$rejected;
                var counts = (res === null || res === void 0 || (_res$payload3 = res.payload) === null || _res$payload3 === void 0 ? void 0 : _res$payload3.data) || {};
                var total = Number((_counts$total = counts.total) === null || _counts$total === void 0 ? void 0 : _counts$total.totalCount) || 0;
                var approved = Number((_counts$approved = counts.approved) === null || _counts$approved === void 0 ? void 0 : _counts$approved.totalCount) || 0;
                var rejected = Number((_counts$rejected = counts.rejected) === null || _counts$rejected === void 0 ? void 0 : _counts$rejected.totalCount) || 0;
                setPieData([{
                  name: chartLabels.processing,
                  value: Math.max(0, total - approved - rejected),
                  color: "#6cdfdfff"
                }, {
                  name: chartLabels.approved,
                  value: approved,
                  color: "#68b88cff"
                }, {
                  name: chartLabels.rejected,
                  value: rejected,
                  color: "#d48aa3ff"
                }]);
              });
              dispatch(fetchWorkforceEisPaymentDisbursementStage({
                isDisbursed: true
              }, modulesManager)).then(function (r) {
                var _r$payload;
                var response = r === null || r === void 0 || (_r$payload = r.payload) === null || _r$payload === void 0 || (_r$payload = _r$payload.data) === null || _r$payload === void 0 ? void 0 : _r$payload.workforceEisPaymentDisbursementStage;
                setDisbursedApplication(response);
                console.log({
                  response: response
                });
              });
            case 9:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }));
      return _loadNewDashboardRequirements.apply(this, arguments);
    }
    if (selectedMenu === "dashboard") {
      loadNewDashboardRequirements();
    }
  }, [selectedMenu, fromDate, toDate, accFromDate, accToDate, association]);
  var getBeneficiaryCount = function getBeneficiaryCount(key) {
    var beneficiaryCountKeys = {
      maleDependent: "male",
      femaleDependent: "female",
      totalDependent: "total"
    };
    if (beneficiaryCountKeys[key]) return beneficiaryCounts[beneficiaryCountKeys[key]];
    var found = applicationCounts.find(function (item) {
      return item.type === applicantTypeNames[key];
    });
    return found ? found.count : 0;
  };
  filterPaymentRecordsByOverallFilters(disbursedApplication, {
    fromDate: fromDate,
    toDate: toDate,
    accFromDate: accFromDate,
    accToDate: accToDate,
    association: association
  });
  return /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 3
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(Card, {
    style: {
      borderRadius: "16px",
      padding: "20px",
      boxShadow: "0 2px 8px rgba(0,0,0,0.1)"
    }
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6",
    style: {
      marginBottom: "15px",
      fontWeight: "bold"
    }
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "workforce.dashboard.overallFilters"
  })), /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 3,
    alignItems: "flex-end"
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 4
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "caption",
    color: "textSecondary"
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "workforce.dashboard.appSubmissionDate"
  })), /*#__PURE__*/React.createElement(Box$1, {
    display: "flex",
    gridGap: 10
  }, /*#__PURE__*/React.createElement(TextField, {
    type: "date",
    size: "small",
    variant: "outlined",
    fullWidth: true,
    value: fromDate,
    onChange: function onChange(e) {
      return handleFromDateChange(e.target.value);
    }
  }), /*#__PURE__*/React.createElement(TextField, {
    type: "date",
    size: "small",
    variant: "outlined",
    fullWidth: true,
    value: toDate,
    onChange: function onChange(e) {
      return handleToDateChange(e.target.value);
    }
  }))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 4
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "caption",
    color: "textSecondary"
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "workforce.dashboard.accidentDate"
  })), /*#__PURE__*/React.createElement(Box$1, {
    display: "flex",
    gridGap: 10
  }, /*#__PURE__*/React.createElement(TextField, {
    type: "date",
    size: "small",
    variant: "outlined",
    fullWidth: true,
    value: accFromDate,
    onChange: function onChange(e) {
      return setAccFromDate(e.target.value);
    }
  }), /*#__PURE__*/React.createElement(TextField, {
    type: "date",
    size: "small",
    variant: "outlined",
    fullWidth: true,
    value: accToDate,
    onChange: function onChange(e) {
      return setAccToDate(e.target.value);
    }
  }))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 4
  }, /*#__PURE__*/React.createElement(FormControl, {
    variant: "outlined",
    size: "small",
    fullWidth: true
  }, /*#__PURE__*/React.createElement(Select, {
    value: association,
    onChange: function onChange(e) {
      return setAssociation(e.target.value);
    },
    displayEmpty: true
  }, /*#__PURE__*/React.createElement(MenuItem, {
    value: "all"
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "workforce.dashboard.allAssociations"
  })), associationOptions.map(function (_ref10) {
    var associationOption = _ref10.node;
    var value = (associationOption === null || associationOption === void 0 ? void 0 : associationOption.shortNameEn) || (associationOption === null || associationOption === void 0 ? void 0 : associationOption.nameEn);
    if (!value) return null;
    return /*#__PURE__*/React.createElement(MenuItem, {
      key: associationOption.id || value,
      value: value
    }, (associationOption === null || associationOption === void 0 ? void 0 : associationOption.nameEn) || value);
  }))))))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(DashboardCard$2, {
    title: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.dashboard.pipeline"
    }),
    subtitle: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.dashboard.pipeline.subtitle"
    })
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 4
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 4
  }, /*#__PURE__*/React.createElement(StatRow$2, {
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.dashboard.pipeline.factory"
    }),
    count: applications !== null ? applications === null || applications === void 0 ? void 0 : applications.filter(function (item) {
      return item.status === "new";
    }).length : 0
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 4
  }, /*#__PURE__*/React.createElement(StatRow$2, {
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.dashboard.pipeline.association"
    }),
    count: applications !== null ? applications === null || applications === void 0 ? void 0 : applications.filter(function (item) {
      return item.status === "forward_to_association";
    }).length : 0
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 4
  }, /*#__PURE__*/React.createElement(StatRow$2, {
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.dashboard.pipeline.eis"
    }),
    count: applications !== null ? applications === null || applications === void 0 ? void 0 : applications.filter(function (item) {
      return item.status != "forward_to_association" || item.status != "new" || item.status != "draft";
    }).length : 0
  }))))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 4
  }, /*#__PURE__*/React.createElement(DashboardCard$2, {
    title: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.dashboard.pending"
    }),
    subtitle: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.dashboard.pending.subtitle"
    })
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle2",
    style: {
      color: "#1976d2",
      marginTop: 10
    }
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "workforce.dashboard.pending.verified"
  })), /*#__PURE__*/React.createElement(Box$1, {
    pl: 2,
    mb: 2
  }, /*#__PURE__*/React.createElement(StatRow$2, {
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.dashboard.pending.death"
    }),
    count: applications !== null ? applications === null || applications === void 0 ? void 0 : applications.filter(function (item) {
      return item.applicationType === "financialAssistance" && (item === null || item === void 0 ? void 0 : item.eisVerified);
    }).length : 0
  }), /*#__PURE__*/React.createElement(StatRow$2, {
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.dashboard.pending.disability"
    }),
    count: applications !== null ? applications === null || applications === void 0 ? void 0 : applications.filter(function (item) {
      return item.applicationType === "disabilityAssistance" && (item === null || item === void 0 ? void 0 : item.eisVerified);
    }).length : 0
  })), /*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle2",
    style: {
      color: "#d32f2f"
    }
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "workforce.dashboard.pending.nonVerified"
  })), /*#__PURE__*/React.createElement(Box$1, {
    pl: 2
  }, /*#__PURE__*/React.createElement(StatRow$2, {
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.dashboard.pending.death"
    }),
    count: applications !== null ? applications === null || applications === void 0 ? void 0 : applications.filter(function (item) {
      return item.applicationType === "financialAssistance" && !(item !== null && item !== void 0 && item.eisVerified);
    }).length : 0
  }), /*#__PURE__*/React.createElement(StatRow$2, {
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.dashboard.pending.disability"
    }),
    count: applications !== null ? applications === null || applications === void 0 ? void 0 : applications.filter(function (item) {
      return item.applicationType === "disabilityAssistance" && !(item !== null && item !== void 0 && item.eisVerified);
    }).length : 0
  })))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 4
  }, /*#__PURE__*/React.createElement(DashboardCard$2, {
    title: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.dashboard.overview"
    }),
    subtitle: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.dashboard.overview.subtitle"
    })
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle2",
    style: {
      marginTop: 10
    }
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "workforce.dashboard.overview.death"
  })), /*#__PURE__*/React.createElement(Box$1, {
    pl: 2,
    mb: 2
  }, /*#__PURE__*/React.createElement(StatRow$2, {
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.dashboard.overview.deadMale"
    }),
    count: applications !== null ? applications === null || applications === void 0 ? void 0 : applications.filter(function (item) {
      var _item$deceasedWorkerI;
      return item.applicationType === "financialAssistance" && (item === null || item === void 0 ? void 0 : item.status) === "approved_by_committee" && (item === null || item === void 0 || (_item$deceasedWorkerI = item.deceasedWorkerInfo) === null || _item$deceasedWorkerI === void 0 || (_item$deceasedWorkerI = _item$deceasedWorkerI.gender) === null || _item$deceasedWorkerI === void 0 ? void 0 : _item$deceasedWorkerI.name) === "workforce.gender.male";
    }).length : 0
  }), /*#__PURE__*/React.createElement(StatRow$2, {
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.dashboard.overview.deadFemale"
    }),
    count: applications !== null ? applications === null || applications === void 0 ? void 0 : applications.filter(function (item) {
      var _item$deceasedWorkerI2;
      return item.applicationType === "financialAssistance" && (item === null || item === void 0 ? void 0 : item.status) === "approved_by_committee" && (item === null || item === void 0 || (_item$deceasedWorkerI2 = item.deceasedWorkerInfo) === null || _item$deceasedWorkerI2 === void 0 || (_item$deceasedWorkerI2 = _item$deceasedWorkerI2.gender) === null || _item$deceasedWorkerI2 === void 0 ? void 0 : _item$deceasedWorkerI2.name) === "workforce.gender.female";
    }).length : 0
  })), /*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle2"
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "workforce.dashboard.overview.disability"
  })), /*#__PURE__*/React.createElement(Box$1, {
    pl: 2
  }, /*#__PURE__*/React.createElement(StatRow$2, {
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.dashboard.overview.maleWorker"
    }),
    count: applications !== null ? applications === null || applications === void 0 ? void 0 : applications.filter(function (item) {
      var _item$workforceEmploy;
      return item.applicationType === "disabilityAssistance" && (item === null || item === void 0 ? void 0 : item.status) === "approved_by_committee" && (item === null || item === void 0 || (_item$workforceEmploy = item.workforceEmployee) === null || _item$workforceEmploy === void 0 ? void 0 : _item$workforceEmploy.gender) === "workforce.gender.male";
    }).length : 0
  }), /*#__PURE__*/React.createElement(StatRow$2, {
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.dashboard.overview.femaleWorker"
    }),
    count: applications !== null ? applications === null || applications === void 0 ? void 0 : applications.filter(function (item) {
      var _item$workforceEmploy2;
      return item.applicationType === "disabilityAssistance" && (item === null || item === void 0 ? void 0 : item.status) === "approved_by_committee" && (item === null || item === void 0 || (_item$workforceEmploy2 = item.workforceEmployee) === null || _item$workforceEmploy2 === void 0 ? void 0 : _item$workforceEmploy2.gender) === "workforce.gender.female";
    }).length : 0
  })))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 4
  }, /*#__PURE__*/React.createElement(DashboardCard$2, {
    title: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.dashboard.beneficiary"
    }),
    subtitle: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.dashboard.beneficiary.subtitle"
    })
  }, /*#__PURE__*/React.createElement(StatRow$2, {
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.dashboard.beneficiary.male"
    }),
    count: getBeneficiaryCount("maleDependent"),
    onClick: function onClick() {
      return handleBeneficiaryClick("approvedMale");
    }
  }), /*#__PURE__*/React.createElement(StatRow$2, {
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.dashboard.beneficiary.female"
    }),
    count: getBeneficiaryCount("femaleDependent"),
    onClick: function onClick() {
      return handleBeneficiaryClick("approvedFemale");
    }
  }), /*#__PURE__*/React.createElement(Box$1, {
    mt: 2,
    p: 1,
    bgcolor: "#f9f9f9",
    borderRadius: "8px"
  }, /*#__PURE__*/React.createElement(StatRow$2, {
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.dashboard.beneficiary.total"
    }),
    count: getBeneficiaryCount("totalDependent"),
    onClick: function onClick() {
      return handleBeneficiaryClick("approvedTotal");
    }
  })))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 6
  }, /*#__PURE__*/React.createElement(DashboardCard$2, {
    title: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.dashboard.accidentSegregation"
    }),
    subtitle: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.dashboard.accidentSegregation.subtitle"
    })
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 3
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle2",
    style: {
      marginTop: 10
    }
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "workforce.dashboard.overview.death"
  })), /*#__PURE__*/React.createElement(StatRow$2, {
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.dashboard.accidentSegregation.workplace"
    }),
    count: applications !== null ? applications === null || applications === void 0 ? void 0 : applications.filter(function (item) {
      var _item$employeeAcciden;
      return item.applicationType === "financialAssistance" && (item === null || item === void 0 || (_item$employeeAcciden = item.employeeAccidentInfo) === null || _item$employeeAcciden === void 0 ? void 0 : _item$employeeAcciden.accidentMainType) === "workforce.accident.mainType.workplace";
    }).length : 0
  }), /*#__PURE__*/React.createElement(StatRow$2, {
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.dashboard.accidentSegregation.commuting"
    }),
    count: applications !== null ? applications === null || applications === void 0 ? void 0 : applications.filter(function (item) {
      var _item$employeeAcciden2;
      return item.applicationType === "financialAssistance" && (item === null || item === void 0 || (_item$employeeAcciden2 = item.employeeAccidentInfo) === null || _item$employeeAcciden2 === void 0 ? void 0 : _item$employeeAcciden2.accidentMainType) === "workforce.accident.mainType.commuting";
    }).length : 0
  }), /*#__PURE__*/React.createElement(StatRow$2, {
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.dashboard.accidentSegregation.rta"
    }),
    count: applications !== null ? applications === null || applications === void 0 ? void 0 : applications.filter(function (item) {
      var _item$employeeAcciden3;
      return item.applicationType === "financialAssistance" && (item === null || item === void 0 || (_item$employeeAcciden3 = item.employeeAccidentInfo) === null || _item$employeeAcciden3 === void 0 ? void 0 : _item$employeeAcciden3.accidentMainType) === "workforce.accident.mainType.onDutyRTA";
    }).length : 0
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle2",
    style: {
      marginTop: 10
    }
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "workforce.dashboard.overview.disability"
  })), /*#__PURE__*/React.createElement(StatRow$2, {
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.dashboard.accidentSegregation.workplace"
    }),
    count: applications !== null ? applications === null || applications === void 0 ? void 0 : applications.filter(function (item) {
      var _item$employeeAcciden4;
      return item.applicationType === "disabilityAssistance" && (item === null || item === void 0 || (_item$employeeAcciden4 = item.employeeAccidentInfo) === null || _item$employeeAcciden4 === void 0 ? void 0 : _item$employeeAcciden4.accidentMainType) === "workforce.accident.mainType.workplace";
    }).length : 0
  }), /*#__PURE__*/React.createElement(StatRow$2, {
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.dashboard.accidentSegregation.commuting"
    }),
    count: applications !== null ? applications === null || applications === void 0 ? void 0 : applications.filter(function (item) {
      var _item$employeeAcciden5;
      return item.applicationType === "financialAssistance" && (item === null || item === void 0 || (_item$employeeAcciden5 = item.employeeAccidentInfo) === null || _item$employeeAcciden5 === void 0 ? void 0 : _item$employeeAcciden5.accidentMainType) === "workforce.accident.mainType.commuting";
    }).length : 0
  }), /*#__PURE__*/React.createElement(StatRow$2, {
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.dashboard.accidentSegregation.rta"
    }),
    count: applications !== null ? applications === null || applications === void 0 ? void 0 : applications.filter(function (item) {
      var _item$employeeAcciden6;
      return item.applicationType === "financialAssistance" && (item === null || item === void 0 || (_item$employeeAcciden6 = item.employeeAccidentInfo) === null || _item$employeeAcciden6 === void 0 ? void 0 : _item$employeeAcciden6.accidentMainType) === "workforce.accident.mainType.onDutyRTA";
    }).length : 0
  }))))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 6
  }, /*#__PURE__*/React.createElement(DashboardCard$2, {
    title: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.dashboard.financialOverview"
    })
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 3
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle2",
    style: {
      marginTop: 10,
      color: "#2e7d32"
    }
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "workforce.dashboard.financial.paidTillNow"
  })), /*#__PURE__*/React.createElement(StatRow$2, {
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.dashboard.financial.deathTotal"
    }),
    count: "\u09F3 ".concat(financialCounts.paid.death.toFixed(2))
  }), /*#__PURE__*/React.createElement(StatRow$2, {
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.dashboard.financial.disabilityTotal"
    }),
    count: "\u09F3 ".concat(financialCounts.paid.disability.toFixed(2))
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle2",
    style: {
      marginTop: 10,
      color: "#ed6c02"
    }
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "workforce.dashboard.financial.approxLifetime"
  })), /*#__PURE__*/React.createElement(StatRow$2, {
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.dashboard.financial.deathTotal"
    }),
    count: "\u09F3 ".concat(financialCounts.lifetime.death.toFixed(2))
  }), /*#__PURE__*/React.createElement(StatRow$2, {
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.dashboard.financial.disabilityTotal"
    }),
    count: "\u09F3 ".concat(financialCounts.lifetime.disability.toFixed(2))
  }))))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 5
  }, /*#__PURE__*/React.createElement(DashboardCard$2, {
    title: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.dashboard.appSegregation"
    })
  }, /*#__PURE__*/React.createElement(ResponsiveContainer, {
    width: "100%",
    height: 300
  }, /*#__PURE__*/React.createElement(PieChart, null, /*#__PURE__*/React.createElement(Pie, {
    data: pieData,
    dataKey: "value",
    nameKey: "name",
    innerRadius: 60,
    outerRadius: 100,
    label: true
  }, pieData.map(function (entry, index) {
    return /*#__PURE__*/React.createElement(Cell, {
      key: "cell-".concat(index),
      fill: entry.color
    });
  })), /*#__PURE__*/React.createElement(Tooltip$1, null), /*#__PURE__*/React.createElement(Legend, {
    verticalAlign: "bottom",
    align: "center"
  }))))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 7
  }, /*#__PURE__*/React.createElement(DashboardCard$2, {
    title: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.dashboard.accidentVsTime"
    })
  }, /*#__PURE__*/React.createElement(ResponsiveContainer, {
    width: "100%",
    height: 300
  }, /*#__PURE__*/React.createElement(BarChart, {
    data: barData
  }, /*#__PURE__*/React.createElement(CartesianGrid, {
    strokeDasharray: "3 3"
  }), /*#__PURE__*/React.createElement(XAxis, {
    dataKey: "month"
  }), /*#__PURE__*/React.createElement(YAxis, {
    label: {
      value: isBn ? "দুর্ঘটনার সংখ্যা" : "Number of accidents",
      angle: -90,
      position: "insideLeft"
    }
  }), /*#__PURE__*/React.createElement(Tooltip$1, null), /*#__PURE__*/React.createElement(Legend, null), /*#__PURE__*/React.createElement(Bar, {
    dataKey: chartLabels.death,
    stackId: "death",
    fill: "#d32f2f"
  }), /*#__PURE__*/React.createElement(Bar, {
    dataKey: chartLabels.disability,
    stackId: "disability",
    fill: "#1976d2"
  }))))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 6
  }, /*#__PURE__*/React.createElement(DashboardCard$2, {
    title: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.dashboard.monitoring"
    })
  }, /*#__PURE__*/React.createElement(StatRow$2, {
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.dashboard.monitoring.almost18"
    }),
    count: beneficiaryMonitoring.almost18,
    onClick: function onClick() {
      return handleBeneficiaryClick("almost18");
    }
  }), /*#__PURE__*/React.createElement(StatRow$2, {
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.dashboard.monitoring.adultFemale"
    }),
    count: beneficiaryMonitoring.adultFemaleUnmarried,
    onClick: function onClick() {
      return handleBeneficiaryClick("adultFemaleUnmarried");
    }
  }), /*#__PURE__*/React.createElement(StatRow$2, {
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.dashboard.monitoring.elderly"
    }),
    count: beneficiaryMonitoring.elderly,
    onClick: function onClick() {
      return handleBeneficiaryClick("elderly");
    }
  }), /*#__PURE__*/React.createElement(StatRow$2, {
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.dashboard.monitoring.widowUnder35"
    }),
    count: beneficiaryMonitoring.widowUnder35,
    onClick: function onClick() {
      return handleBeneficiaryClick("widowUnder35");
    }
  }))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 6
  }, /*#__PURE__*/React.createElement(DashboardCard$2, {
    title: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.dashboard.verification"
    })
  }, /*#__PURE__*/React.createElement(StatRow$2, {
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.dashboard.verification.pending1m"
    }),
    count: verificationOverview.pending1m,
    onClick: function onClick() {
      return handleBeneficiaryClick("pending1m");
    },
    color: "#ed6c02"
  }), /*#__PURE__*/React.createElement(StatRow$2, {
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.dashboard.verification.pending3m"
    }),
    count: verificationOverview.pending3m,
    onClick: function onClick() {
      return handleBeneficiaryClick("pending3m");
    },
    color: "#ed6c02"
  }), /*#__PURE__*/React.createElement(StatRow$2, {
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.dashboard.verification.pending6m"
    }),
    count: verificationOverview.pending6m,
    onClick: function onClick() {
      return handleBeneficiaryClick("pending6m");
    },
    color: "#ed6c02"
  }), /*#__PURE__*/React.createElement(StatRow$2, {
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.dashboard.verification.pending9m"
    }),
    count: verificationOverview.pending9m,
    onClick: function onClick() {
      return handleBeneficiaryClick("pending9m");
    },
    color: "#d32f2f"
  }), /*#__PURE__*/React.createElement(StatRow$2, {
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.dashboard.verification.successful"
    }),
    count: verificationOverview.successful,
    onClick: function onClick() {
      return handleBeneficiaryClick("successfulVerified");
    },
    color: "#2e7d32"
  }))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 6
  }, /*#__PURE__*/React.createElement(DashboardCard$2, {
    title: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.dashboard.marriage"
    })
  }, /*#__PURE__*/React.createElement(StatRow$2, {
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.dashboard.marriage.widow"
    }),
    count: marriageStatus.unmarriedWidow,
    onClick: function onClick() {
      return handleBeneficiaryClick("unmarriedWidow");
    }
  }), /*#__PURE__*/React.createElement(StatRow$2, {
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.dashboard.marriage.widower"
    }),
    count: marriageStatus.unmarriedWidower,
    onClick: function onClick() {
      return handleBeneficiaryClick("unmarriedWidower");
    }
  }), /*#__PURE__*/React.createElement(StatRow$2, {
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.dashboard.marriage.sister"
    }),
    count: marriageStatus.unmarriedSister,
    onClick: function onClick() {
      return handleBeneficiaryClick("unmarriedSister");
    }
  }), /*#__PURE__*/React.createElement(StatRow$2, {
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.dashboard.marriage.daughter"
    }),
    count: marriageStatus.unmarriedDaughter,
    onClick: function onClick() {
      return handleBeneficiaryClick("unmarriedDaughter");
    }
  }), /*#__PURE__*/React.createElement(StatRow$2, {
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.dashboard.marriage.grandDaughter"
    }),
    count: marriageStatus.unmarriedGrandDaughter,
    onClick: function onClick() {
      return handleBeneficiaryClick("unmarriedGrandDaughter");
    }
  }))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 6
  }, /*#__PURE__*/React.createElement(DashboardCard$2, {
    title: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.dashboard.payment"
    }),
    subtitle: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.dashboard.payment.subtitle"
    })
  }, /*#__PURE__*/React.createElement(StatRow$2, {
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.dashboard.payment.disbursed"
    }),
    count: paymentStatus.disbursed,
    onClick: function onClick() {
      return handleBeneficiaryClick("paymentDisbursed");
    },
    color: "#2e7d32"
  }), /*#__PURE__*/React.createElement(StatRow$2, {
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.dashboard.payment.pending"
    }),
    count: paymentStatus.pending,
    onClick: function onClick() {
      return handleBeneficiaryClick("paymentPending");
    },
    color: "#ed6c02"
  }), /*#__PURE__*/React.createElement(StatRow$2, {
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.dashboard.payment.onHold"
    }),
    count: paymentStatus.onHold,
    onClick: function onClick() {
      return handleBeneficiaryClick("paymentOnHold");
    },
    color: "#d32f2f"
  }))), /*#__PURE__*/React.createElement(AgingReportModal, {
    open: openModal,
    onClose: function onClose() {
      return setOpenModal(false);
    },
    data: selectedType,
    organizationType: filter.toLowerCase()
  }));
};
var RevertApplication = function RevertApplication() {
  var classes = useStyles$l();
  var loggedInUserId = useSelector(function (state) {
    var _state$core3;
    return (_state$core3 = state.core) === null || _state$core3 === void 0 || (_state$core3 = _state$core3.user) === null || _state$core3 === void 0 || (_state$core3 = _state$core3.i_user) === null || _state$core3 === void 0 ? void 0 : _state$core3.id;
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5",
    gutterBottom: true
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.application.reverted"
  })), /*#__PURE__*/React.createElement(Card, {
    className: classes.tableContainer
  }, /*#__PURE__*/React.createElement(CardContent, null, /*#__PURE__*/React.createElement(ApplicationProcessSearcher$1, {
    revertedApplication: true,
    loggedInUserId: loggedInUserId
  }))), /*#__PURE__*/React.createElement("div", {
    className: classes.pagination
  }, /*#__PURE__*/React.createElement(Button, null, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.back"
  })), /*#__PURE__*/React.createElement(Button, null, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.next"
  }))));
};
var RejectApplication$2 = function RejectApplication() {
  var classes = useStyles$l();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ApplicationProcessSearcher$1, {
    rejectedApplication: true,
    dynamicTableTitle: "workforce.application.rejectedApplication"
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.pagination
  }, /*#__PURE__*/React.createElement(Button, null, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.back"
  })), /*#__PURE__*/React.createElement(Button, null, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.next"
  }))));
};
var PendingMeetingSheet = function PendingMeetingSheet(_ref11) {
  var _reduxState$core2;
  var _ref11$summaryData = _ref11.summaryData,
    summaryData = _ref11$summaryData === void 0 ? [] : _ref11$summaryData;
  console.log("summary data", summaryData);
  var classes = useStyles$l();
  var reduxState = useSelector(function (state) {
    return state;
  });
  var locale = (reduxState === null || reduxState === void 0 || (_reduxState$core2 = reduxState.core) === null || _reduxState$core2 === void 0 || (_reduxState$core2 = _reduxState$core2.user) === null || _reduxState$core2 === void 0 || (_reduxState$core2 = _reduxState$core2.i_user) === null || _reduxState$core2 === void 0 ? void 0 : _reduxState$core2.language) || "en";
  return /*#__PURE__*/React.createElement(React.Fragment, null, summaryData.map(function (item, index) {
    return /*#__PURE__*/React.createElement(Accordion, {
      key: index,
      defaultExpanded: false,
      className: classes.accordion
    }, /*#__PURE__*/React.createElement(AccordionSummary, {
      className: classes.accordionSummary,
      expandIcon: /*#__PURE__*/React.createElement(ExpandMoreIcon, {
        className: "material-icons"
      })
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "subtitle1",
      style: {
        flex: 1
      }
    }, /*#__PURE__*/React.createElement("strong", null, item.name)), /*#__PURE__*/React.createElement(Typography, {
      variant: "body2",
      color: "textSecondary",
      style: {
        marginLeft: "auto"
      }
    }, locale === "en" ? STATUS_MAP_EN[item === null || item === void 0 ? void 0 : item.status] : STATUS_MAP_BN[item === null || item === void 0 ? void 0 : item.status], " |", item.meetingDate, " | ", item.month, " ", item.year)), /*#__PURE__*/React.createElement(AccordionDetails, {
      className: classes.AccordionDetails
    }, /*#__PURE__*/React.createElement(Card, {
      style: {
        width: "100%"
      }
    }, /*#__PURE__*/React.createElement(CardContent, null, /*#__PURE__*/React.createElement(ApplicationProcessSearcher$1, {
      summaryId: item.id,
      pendingMeetingSheet: true,
      summaryData: item
    })))));
  }));
};

// ------------------------------------------------------------

var FEMALE_BENEFICIARY_RELATIONS = new Set(["workforce.relation.daughter", "workforce.relation.mother", "workforce.relation.wife", "workforce.relation.sister"]);
var flattenDependents = function flattenDependents(value) {
  if (Array.isArray(value)) return value;
  if (!value || _typeof(value) !== "object") return [];
  if (Array.isArray(value.edges)) return value.edges.map(function (edge) {
    return (edge === null || edge === void 0 ? void 0 : edge.node) || edge;
  });
  return [value];
};
var getFilteredBeneficiaryCounts = function getFilteredBeneficiaryCounts(applications) {
  return applications.reduce(function (counts, application) {
    if ((application === null || application === void 0 ? void 0 : application.status) === "draft") return counts;
    var tableDependents = (application === null || application === void 0 ? void 0 : application.workforceEmployeeDependentApplication) || (application === null || application === void 0 ? void 0 : application.workforceEmployeeDependent);
    var dependents = flattenDependents(tableDependents);
    dependents.forEach(function (dependent) {
      var relation = (dependent === null || dependent === void 0 ? void 0 : dependent.relationWithWorker) || (dependent === null || dependent === void 0 ? void 0 : dependent.relationType) || (dependent === null || dependent === void 0 ? void 0 : dependent.relation) || "";
      if (FEMALE_BENEFICIARY_RELATIONS.has(relation)) {
        counts.female += 1;
      } else {
        counts.male += 1;
      }
    });
    counts.total = counts.male + counts.female;
    return counts;
  }, {
    male: 0,
    female: 0,
    total: 0
  });
};
var getMarriageStatusCounts = function getMarriageStatusCounts(applications) {
  return applications.reduce(function (counts, application) {
    var dependents = safeParse(application === null || application === void 0 ? void 0 : application.employeeDependentInfo);
    if (!Array.isArray(dependents)) return counts;
    dependents.forEach(function (dependent) {
      var relation = (dependent === null || dependent === void 0 ? void 0 : dependent.relationWithWorker) || (dependent === null || dependent === void 0 ? void 0 : dependent.relationType);
      var maritalStatus = dependent === null || dependent === void 0 ? void 0 : dependent.maritalStatus;
      if (relation === "workforce.relation.wife" && maritalStatus === "workforce.marital_status.widow") {
        counts.unmarriedWidow += 1;
      } else if (relation === "workforce.relation.husband" && maritalStatus === "workforce.marital_status.widower") {
        counts.unmarriedWidower += 1;
      } else if (relation === "workforce.relation.sister" && maritalStatus === "workforce.marital_status.single") {
        counts.unmarriedSister += 1;
      } else if (relation === "workforce.relation.daughter" && maritalStatus === "workforce.marital_status.single") {
        counts.unmarriedDaughter += 1;
      } else if (["workforce.relation.grand_daughter", "workforce.relation.grand_daughter_from_daughter"].includes(relation) && maritalStatus === "workforce.marital_status.single") {
        counts.unmarriedGrandDaughter += 1;
      }
    });
    return counts;
  }, {
    unmarriedWidow: 0,
    unmarriedWidower: 0,
    unmarriedSister: 0,
    unmarriedDaughter: 0,
    unmarriedGrandDaughter: 0
  });
};
var getBeneficiaryMonitoringCounts = function getBeneficiaryMonitoringCounts(applications) {
  return applications.reduce(function (counts, application) {
    var dependents = safeParse(application === null || application === void 0 ? void 0 : application.employeeDependentInfo);
    if (!Array.isArray(dependents)) return counts;
    dependents.forEach(function (dependent) {
      var age = calculateAge(dependent === null || dependent === void 0 ? void 0 : dependent.birthDate);
      var relation = (dependent === null || dependent === void 0 ? void 0 : dependent.relationWithWorker) || (dependent === null || dependent === void 0 ? void 0 : dependent.relationType);
      var maritalStatus = dependent === null || dependent === void 0 ? void 0 : dependent.maritalStatus;
      var isFemale = ["workforce.relation.wife", "workforce.relation.daughter", "workforce.relation.sister", "workforce.relation.grand_daughter", "workforce.relation.grand_daughter_from_daughter"].includes(relation);
      if (age >= 17 && age < 18) {
        counts.almost18 += 1;
      }
      if (age >= 18 && isFemale && maritalStatus === "workforce.marital_status.single") {
        counts.adultFemaleUnmarried += 1;
      }
      if (age > 60) {
        counts.elderly += 1;
      }
      if (age < 35 && ["workforce.marital_status.widow", "workforce.marital_status.widower"].includes(maritalStatus)) {
        counts.widowUnder35 += 1;
      }
    });
    return counts;
  }, {
    almost18: 0,
    adultFemaleUnmarried: 0,
    elderly: 0,
    widowUnder35: 0
  });
};
var EisCoordinatorDashboardPage = function EisCoordinatorDashboardPage() {
  var classes = useStyles$l();
  var dispatch = useDispatch();
  var modulesManager = useModulesManager();
  var _useState91 = useState("dashboard"),
    _useState92 = _slicedToArray(_useState91, 2),
    selectedMenu = _useState92[0],
    setSelectedMenu = _useState92[1];
  useEffect(function () {
    return dispatch(fetchSummaryApplications(modulesManager, ['organizationType:"eis"']));
  }, []);
  var data = useSelector(function (state) {
    var _state$workforce;
    return (_state$workforce = state.workforce["applicationsSummary"]) !== null && _state$workforce !== void 0 ? _state$workforce : [];
  });
  var pendingSummaryData = data.filter(function (d) {
    return d.status === "forward_to_dg" || d.status === "forward_to_eis_advisor" || d.status === "meeting_created";
  });
  var approvedSummaryData = data.filter(function (d) {
    return d.status === "approved_by_committee";
  });
  var advisorApprovedSummaryData = data.filter(function (d) {
    return d.status === "approved_by_eis_advisor";
  });
  var sentSummaryData = data.filter(function (d) {
    return d.status === "forward_to_comiitee";
  });
  var renderContent = function renderContent() {
    switch (selectedMenu) {
      case "dashboard":
        return /*#__PURE__*/React.createElement(Dashboard$3, {
          selectedMenu: selectedMenu
        });
      case "pendingApplications":
        return /*#__PURE__*/React.createElement(FiledApplications$2, null);
      case "sentForVerificationApplications":
        return /*#__PURE__*/React.createElement(SentForVerificationApplications, null);
      case "verifiedApplications":
        return /*#__PURE__*/React.createElement(VerifiedApplications, null);
      case "rejectedApplication":
        return /*#__PURE__*/React.createElement(RejectApplication$2, null);
      case "revertedApplication":
        return /*#__PURE__*/React.createElement(RevertApplication, null);
      case "pendingMeetingSheet":
        return /*#__PURE__*/React.createElement(PendingMeetingSheet, {
          summaryData: pendingSummaryData,
          disableButtons: 1
        });
      case "advisorApproveMeetingSheet":
        return /*#__PURE__*/React.createElement(AdvisorApprovedApplications, {
          summaryData: advisorApprovedSummaryData,
          approvedButton: 1
        });
      case "sentMeetingSheet":
        return /*#__PURE__*/React.createElement(SentMeetingSheet, {
          summaryData: sentSummaryData,
          disableButtons: 1
        });
      case "approveMeetingSheet":
        return /*#__PURE__*/React.createElement(ApprovedApplications$1, {
          summaryData: approvedSummaryData,
          disableButtons: 1
        });
      case "applicationStatus":
        return /*#__PURE__*/React.createElement(ApplicationStatus$1, null);
      case "beneficiaryReportSheet":
        return /*#__PURE__*/React.createElement(BeneficiaryReportSheet$1, null);
      case "beneficiaryManagement":
        return /*#__PURE__*/React.createElement(BeneficiaryManagement, null);
      case "beneficiaryPaymentProcess":
        return /*#__PURE__*/React.createElement(BeneficiaryPaymentProcess, null);
      case "beneficiaryProcessedPaymentList":
        return /*#__PURE__*/React.createElement(BeneficiaryProcessedPaymentList, null);
      case "beneficiaryPayments":
        return /*#__PURE__*/React.createElement(BeneficiaryPaymentList, null);
      case "beneficiaryBankAdviceList":
        return /*#__PURE__*/React.createElement(BeneficiaryBankAdviceList, null);
      case "beneficiaryDisbursedPayments":
        return /*#__PURE__*/React.createElement(BeneficiaryDisbursedPayments, null);
      case "beneficiaryNoaConfirmation":
        return /*#__PURE__*/React.createElement(BeneficiaryNoaConfirmation, null);
      default:
        return /*#__PURE__*/React.createElement(Dashboard$3, {
          selectedMenu: selectedMenu
        });
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: classes.root
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 2,
    className: classes.root
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 3
  }, /*#__PURE__*/React.createElement(Paper, {
    className: classes.sidebar
  }, /*#__PURE__*/React.createElement(List, null, SidebarMenu$3.map(function (item) {
    return /*#__PURE__*/React.createElement(ListItem, {
      button: true,
      key: item.id,
      selected: selectedMenu === item.id,
      onClick: function onClick() {
        return setSelectedMenu(item.id);
      }
    }, /*#__PURE__*/React.createElement(ListItemIcon, null, item.icon), /*#__PURE__*/React.createElement(ListItemText, {
      primary: item.text
    }));
  })))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 9,
    className: classes.content
  }, renderContent())));
};

function ownKeys$i(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$i(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$i(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$i(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var useStyles$k = makeStyles(function (theme) {
  return {
    root: {
      flexGrow: 1,
      padding: theme.spacing(2),
      height: "calc(100vh - 64px)",
      overflow: "visible"
    },
    sidebar: {
      position: "sticky",
      top: 0,
      height: "40vh",
      backgroundColor: theme.palette.background.paper,
      borderRight: "1px solid ".concat(theme.palette.divider),
      overflowY: "auto"
    },
    content: {
      height: "100vh",
      overflowY: "auto",
      padding: theme.spacing(2)
    },
    tableContainer: {
      marginTop: theme.spacing(0)
    },
    tableHeadCell: {
      fontWeight: "bold"
    },
    noData: {
      textAlign: "center",
      padding: theme.spacing(2)
    },
    searchInput: {
      border: "1px solid #ccc",
      borderRadius: 4,
      padding: "4px 8px",
      width: 200
    },
    pagination: {
      display: "flex",
      justifyContent: "flex-end",
      marginTop: theme.spacing(2),
      alignItems: "center"
    },
    tableHeader: {
      backgroundColor: "#B7D4D8"
    },
    accordion: {
      boxShadow: "1px 1px 1px 1px",
      border: "none",
      backgroundColor: "white",
      marginBottom: "12px",
      borderRadius: "6px",
      "&::before": {
        display: "none"
      }
    },
    accordionPadding: {
      paddingBottom: "40px !important"
    },
    accordionSummary: {
      padding: "8px 16px",
      backgroundColor: "white",
      borderRadius: "6px",
      "& .MuiTypography-root": {
        color: "#015C63",
        // teal-like tone
        fontWeight: 600
      }
    },
    accordionDetails: {
      backgroundColor: "white",
      padding: "16px",
      borderTop: "1px solid #ddd"
    }
  };
});
var SidebarMenu$2 = [{
  id: "dashboard",
  text: /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.application.dashboard"
  }),
  icon: /*#__PURE__*/React.createElement(DashboardIcon, null)
}, {
  id: "pendingMeetingSheet",
  text: /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.employee.application.meetingSheet"
  }),
  icon: /*#__PURE__*/React.createElement(HourglassFullTwoToneIcon, null)
}, {
  id: "approveMeetingSheet",
  text: /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.application.forwarded"
  }),
  icon: /*#__PURE__*/React.createElement(CheckCircleOutlineTwoToneIcon, null)
}];

// ----------- Components to Render in Main Content -----------

var FiledApplications$1 = function FiledApplications(_ref) {
  var _ref$summaryData = _ref.summaryData,
    summaryData = _ref$summaryData === void 0 ? [] : _ref$summaryData,
    _ref$disableButtons = _ref.disableButtons,
    disableButtons = _ref$disableButtons === void 0 ? 0 : _ref$disableButtons;
  var classes = useStyles$k();
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    expanded = _useState2[0],
    setExpanded = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    renderedData = _useState4[0],
    setRenderedData = _useState4[1];
  var loggedInUserId = useSelector(function (state) {
    var _state$core;
    return (_state$core = state.core) === null || _state$core === void 0 || (_state$core = _state$core.user) === null || _state$core === void 0 || (_state$core = _state$core.i_user) === null || _state$core === void 0 ? void 0 : _state$core.id;
  });
  var user_type = getUserType();
  useEffect(function () {
    setRenderedData(summaryData);
  }, [summaryData]);
  var handleChange = function handleChange(panelId) {
    return function (event, isExpanded) {
      if (isExpanded) {
        setRenderedData(function (prev) {
          var clickedItem = prev.find(function (item) {
            return item.id === panelId;
          });
          var rest = prev.filter(function (item) {
            return item.id !== panelId;
          });
          return [clickedItem].concat(_toConsumableArray(rest));
        });
        setExpanded(panelId);
      } else {
        setExpanded(null);
      }
    };
  };
  return /*#__PURE__*/React.createElement("div", {
    className: classes.accordionPadding
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5",
    gutterBottom: true
  }, user_type === WORKFORCE_USER_TYPE.BLWF_DOL_DIFE && /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.eis.committe.dashboard"
  }), user_type === WORKFORCE_USER_TYPE.BLWF_DOL_DIFE && /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.eis.association.committe.dashboard"
  })), renderedData.map(function (item, index) {
    return /*#__PURE__*/React.createElement(Accordion, {
      key: item.id,
      expanded: expanded === item.id,
      onChange: handleChange(item.id),
      className: classes.accordion
    }, /*#__PURE__*/React.createElement(AccordionSummary, {
      className: classes.accordionSummary,
      expandIcon: /*#__PURE__*/React.createElement(ExpandMoreIcon, {
        className: "material-icons"
      })
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "subtitle1",
      style: {
        flex: 1
      }
    }, /*#__PURE__*/React.createElement("strong", null, item.name)), /*#__PURE__*/React.createElement(Typography, {
      variant: "body2",
      style: {
        marginLeft: "auto",
        color: "#015C63"
      }
    }, item.meetingDate, " | ", item.month, " ", item.year)), /*#__PURE__*/React.createElement(AccordionDetails, {
      className: classes.accordionDetails
    }, /*#__PURE__*/React.createElement(Card, {
      style: {
        width: "100%"
      }
    }, /*#__PURE__*/React.createElement(CardContent, null, expanded === item.id && /*#__PURE__*/React.createElement(ApplicationProcessSearcher$1, {
      summaryId: item.id,
      disableButtons: disableButtons,
      loggedInUserId: loggedInUserId,
      coloredRow: true
    })))));
  }));
};
var DashboardCard$1 = function DashboardCard(_ref2) {
  var title = _ref2.title,
    subtitle = _ref2.subtitle,
    children = _ref2.children;
  return /*#__PURE__*/React.createElement(Card, {
    style: {
      height: "100%",
      borderRadius: "16px",
      boxShadow: "0 4px 12px 0 rgba(0,0,0,0.05)",
      padding: "10px"
    }
  }, /*#__PURE__*/React.createElement(CardHeader, {
    title: /*#__PURE__*/React.createElement(Typography, {
      variant: "h6",
      style: {
        fontWeight: "bold"
      }
    }, title),
    subheader: subtitle ? /*#__PURE__*/React.createElement(Typography, {
      variant: "body2",
      color: "textSecondary"
    }, subtitle) : null
  }), /*#__PURE__*/React.createElement(CardContent, {
    style: {
      paddingTop: 0
    }
  }, children));
};
var StatRow$1 = function StatRow(_ref3) {
  var label = _ref3.label,
    count = _ref3.count,
    color = _ref3.color;
  return /*#__PURE__*/React.createElement(Box$1, {
    display: "flex",
    justifyContent: "space-between",
    py: 1,
    borderBottom: "1px solid #f0f0f0"
  }, /*#__PURE__*/React.createElement(Typography, {
    style: {
      color: color || "inherit"
    }
  }, label), /*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle1",
    style: {
      fontWeight: "bold",
      color: color || "inherit"
    }
  }, count));
};
var Dashboard$2 = function Dashboard() {
  var _reduxState$core;
  var dispatch = useDispatch();
  useTheme();
  useHistory();
  var reduxState = useSelector(function (state) {
    return state;
  });
  var modulesManager = useModulesManager();
  var locale = (reduxState === null || reduxState === void 0 || (_reduxState$core = reduxState.core) === null || _reduxState$core === void 0 || (_reduxState$core = _reduxState$core.user) === null || _reduxState$core === void 0 || (_reduxState$core = _reduxState$core.i_user) === null || _reduxState$core === void 0 ? void 0 : _reduxState$core.language) || "en";
  var isBn = locale === "fr" || locale === "bn"; // Handling your existing language toggle

  // --- 1. GLOBAL FILTERS STATE ---
  var _useState5 = useState([]),
    _useState6 = _slicedToArray(_useState5, 2),
    applications = _useState6[0],
    setApplications = _useState6[1];
  var _useState7 = useState([]),
    _useState8 = _slicedToArray(_useState7, 2),
    disbursedApplication = _useState8[0],
    setDisbursedApplication = _useState8[1];
  var _useState9 = useState("eis"),
    _useState10 = _slicedToArray(_useState9, 2),
    filter = _useState10[0],
    setFilter = _useState10[1];
  var _useState11 = useState(""),
    _useState12 = _slicedToArray(_useState11, 2),
    fromDate = _useState12[0],
    setFromDate = _useState12[1];
  var _useState13 = useState(""),
    _useState14 = _slicedToArray(_useState13, 2),
    toDate = _useState14[0],
    setToDate = _useState14[1];
  var _useState15 = useState(""),
    _useState16 = _slicedToArray(_useState15, 2),
    accFromDate = _useState16[0],
    setAccFromDate = _useState16[1];
  var _useState17 = useState(""),
    _useState18 = _slicedToArray(_useState17, 2),
    accToDate = _useState18[0],
    setAccToDate = _useState18[1];
  var _useState19 = useState("all"),
    _useState20 = _slicedToArray(_useState19, 2),
    association = _useState20[0],
    setAssociation = _useState20[1];
  var _useState21 = useState(0),
    _useState22 = _slicedToArray(_useState21, 2),
    months = _useState22[0];
    _useState22[1];
  var _useState23 = useState(6),
    _useState24 = _slicedToArray(_useState23, 2),
    graphMonths = _useState24[0];
    _useState24[1];

  // --- 2. NEW MEETING SPECIFIC STATE ---
  var _useState25 = useState({
      presented: 0,
      approved: 0,
      rejected: 0,
      reverted: 0
    }),
    _useState26 = _slicedToArray(_useState25, 2),
    lastMeetingOverview = _useState26[0];
    _useState26[1];
  var _useState27 = useState({
      caseType: {
        death: 0,
        disability: 0
      },
      accidentType: {
        commuting: 0,
        workplace: 0,
        rta: 0
      }
    }),
    _useState28 = _slicedToArray(_useState27, 2);
    _useState28[0];
    _useState28[1];

  // --- 3. RETAINED METRICS STATE ---
  var _useState29 = useState({
      paid: {
        death: 0,
        disability: 0
      },
      lifetime: {
        death: 0,
        disability: 0
      }
    }),
    _useState30 = _slicedToArray(_useState29, 2);
    _useState30[0];
    _useState30[1];
  var _useState31 = useState([]),
    _useState32 = _slicedToArray(_useState31, 2),
    pieData = _useState32[0],
    setPieData = _useState32[1];
  var _useState33 = useState([]),
    _useState34 = _slicedToArray(_useState33, 2),
    barData = _useState34[0],
    setBarData = _useState34[1];

  // --- HELPER FUNCTIONS ---
  var getMonthName = function getMonthName(index) {
    var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "en-US";
    var date = new Date(2000, index, 1);
    return date.toLocaleString(locale, {
      month: "long"
    });
  };
  var handleFilter = function handleFilter(f) {
    return setFilter(f);
  };

  // Strings needed as raw values for Recharts tooltips/legends
  var chartLabels = {
    processing: isBn ? "প্রক্রিয়াধীন" : "Processing",
    approved: isBn ? "অনুমোদিত" : "Approved",
    reverted: isBn ? "বাতিল" : "Reverted/Rejected",
    death: isBn ? "মৃত্যু" : "Death",
    disability: isBn ? "স্থায়ী ও অস্থায়ী অক্ষমতা" : "Permanent Or Curable Disability"
  };

  // --- EFFECTS ---

  useEffect(function () {
    function loadPieData() {
      return _loadPieData.apply(this, arguments);
    }
    function _loadPieData() {
      _loadPieData = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var orgType, res, approvedTotal, cancelledTotal, processingTotal;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              orgType = filter === "সব" || filter === "All" ? "" : filter.toLowerCase();
              res = [];
              _context.next = 5;
              return dispatch(fetchApplicationByDate(months, fromDate, toDate, orgType)).then(function (response) {
                var _response$payload;
                res = ((_response$payload = response.payload) === null || _response$payload === void 0 || (_response$payload = _response$payload.data) === null || _response$payload === void 0 ? void 0 : _response$payload.workforceApplicationMatrix) || [];
              });
            case 5:
              approvedTotal = 0;
              cancelledTotal = 0;
              processingTotal = 0;
              res.forEach(function (item) {
                var type = item.applicationType;
                var allow = false;
                if (orgType === "blwf") allow = type !== "disabilityAssistance";else if (orgType === "eis") allow = ["disabilityAssistance", "financialAssistance", "death"].includes(type);else allow = true;
                if (allow) {
                  approvedTotal += Number(item.approvedCount);
                  cancelledTotal += Number(item.rejectedCount);
                  processingTotal += Number(item.applicationCount) - (Number(item.approvedCount) + Number(item.rejectedCount));
                }
              });
              setPieData([{
                name: chartLabels.processing,
                value: processingTotal,
                color: "#6cdfdfff"
              }, {
                name: chartLabels.approved,
                value: approvedTotal,
                color: "#68b88cff"
              }, {
                name: chartLabels.reverted,
                value: cancelledTotal,
                color: "#d48aa3ff"
              }]);
              _context.next = 15;
              break;
            case 12:
              _context.prev = 12;
              _context.t0 = _context["catch"](0);
              console.error("Failed to fetch pie data", _context.t0);
            case 15:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[0, 12]]);
      }));
      return _loadPieData.apply(this, arguments);
    }
    loadPieData();
  }, [months, fromDate, toDate, filter, chartLabels.processing, chartLabels.approved, chartLabels.reverted]);
  useEffect(function () {
    function loadBarData() {
      return _loadBarData.apply(this, arguments);
    }
    function _loadBarData() {
      _loadBarData = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var monthWiseRes, barDataArray;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              monthWiseRes = [];
              _context2.next = 4;
              return dispatch(fetchApplicationMonthWise(graphMonths)).then(function (response) {
                var _response$payload2;
                monthWiseRes = ((_response$payload2 = response.payload) === null || _response$payload2 === void 0 || (_response$payload2 = _response$payload2.data) === null || _response$payload2 === void 0 ? void 0 : _response$payload2.workforceMonthwiseApplications) || [];
              });
            case 4:
              barDataArray = [];
              monthWiseRes.map(function (item) {
                barDataArray.push(_defineProperty(_defineProperty({
                  month: getMonthName(Number(item.month) - 1)
                }, chartLabels.death, item.death), chartLabels.disability, item.disabilityAssistance));
              });
              setBarData(barDataArray);
              _context2.next = 12;
              break;
            case 9:
              _context2.prev = 9;
              _context2.t0 = _context2["catch"](0);
              console.error("Failed to fetch bar data", _context2.t0);
            case 12:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[0, 9]]);
      }));
      return _loadBarData.apply(this, arguments);
    }
    loadBarData();
  }, [graphMonths, chartLabels.death, chartLabels.disability]);
  useEffect(function () {
    function loadNewDashboardRequirements() {
      return _loadNewDashboardRequirements.apply(this, arguments);
    }
    function _loadNewDashboardRequirements() {
      _loadNewDashboardRequirements = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var filtersBase;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              // Dispatch new API actions here using accFromDate, accToDate, association
              filtersBase = ['statusIn: ["forward_to_eis_advisor","approved_by_committee","forward_to_committee","approved_by_eis_advisor"]', 'organizationTypeIn: ["eis"]', 'orderBy: ["-dateCreated"]'];
              dispatch(fetchApplicationsSummaryDashboard(modulesManager, filtersBase)).then(function (res) {
                var _res$payload;
                console.log({
                  fromEIScommittee: res
                });
                var response = parseData(res === null || res === void 0 || (_res$payload = res.payload) === null || _res$payload === void 0 || (_res$payload = _res$payload.data) === null || _res$payload === void 0 ? void 0 : _res$payload.workforceApplication);
                var formData = response === null || response === void 0 ? void 0 : response.map(function (application) {
                  var parsedMetadata = JSON.parse(application === null || application === void 0 ? void 0 : application.metadata);
                  var parsedApplicantInfo = JSON.parse(application === null || application === void 0 ? void 0 : application.applicantInfo);
                  var parsedDeceasedWorkerInfo = JSON.parse(application === null || application === void 0 ? void 0 : application.deceasedWorkerInfo);
                  var parsedEmployeeAccidentInfo = JSON.parse(application === null || application === void 0 ? void 0 : application.employeeAccidentInfo);
                  // const parsedEmployeeDependentInfo = JSON.parse(application?.employeeDependentInfo)
                  // const parsedEmployeeBankInfo = JSON.parse(application?.employeeBankInfo)

                  return _objectSpread$i(_objectSpread$i({}, application), {}, {
                    applicantInfo: JSON.parse(parsedApplicantInfo),
                    metadata: JSON.parse(parsedMetadata),
                    deceasedWorkerInfo: JSON.parse(parsedDeceasedWorkerInfo),
                    employeeAccidentInfo: JSON.parse(parsedEmployeeAccidentInfo)
                    // employeeDependentInfo:JSON.parse(parsedEmployeeDependentInfo),
                    // employeeBankInfo:JSON.parse(parsedEmployeeBankInfo)
                  });
                });
                setApplications(formData);
                console.log({
                  fromEISAdvisor: formData
                });
              });
              dispatch(fetchWorkforceEisPaymentDisbursementStage({
                isDisbursed: true
              }, modulesManager)).then(function (r) {
                var _r$payload;
                var response = r === null || r === void 0 || (_r$payload = r.payload) === null || _r$payload === void 0 || (_r$payload = _r$payload.data) === null || _r$payload === void 0 ? void 0 : _r$payload.workforceEisPaymentDisbursementStage;
                setDisbursedApplication(response);
                console.log({
                  response: response
                });
              });
            case 3:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      return _loadNewDashboardRequirements.apply(this, arguments);
    }
    loadNewDashboardRequirements();
  }, []);

  // console.log({fromEIScommittee:applications})
  return /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 3
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(Card, {
    style: {
      borderRadius: "16px",
      padding: "20px",
      boxShadow: "0 2px 8px rgba(0,0,0,0.1)"
    }
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6",
    style: {
      marginBottom: "15px",
      fontWeight: "bold"
    }
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "workforce.dashboard.overallFilters"
  })), /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 3,
    alignItems: "flex-end"
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 3
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "caption",
    color: "textSecondary"
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "workforce.dashboard.appSubmissionDate"
  })), /*#__PURE__*/React.createElement(Box$1, {
    display: "flex",
    gridGap: 10
  }, /*#__PURE__*/React.createElement(TextField, {
    type: "date",
    size: "small",
    variant: "outlined",
    fullWidth: true,
    value: fromDate,
    onChange: function onChange(e) {
      return setFromDate(e.target.value);
    }
  }), /*#__PURE__*/React.createElement(TextField, {
    type: "date",
    size: "small",
    variant: "outlined",
    fullWidth: true,
    value: toDate,
    onChange: function onChange(e) {
      return setToDate(e.target.value);
    }
  }))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 3
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "caption",
    color: "textSecondary"
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "workforce.dashboard.accidentDate"
  })), /*#__PURE__*/React.createElement(Box$1, {
    display: "flex",
    gridGap: 10
  }, /*#__PURE__*/React.createElement(TextField, {
    type: "date",
    size: "small",
    variant: "outlined",
    fullWidth: true,
    value: accFromDate,
    onChange: function onChange(e) {
      return setAccFromDate(e.target.value);
    }
  }), /*#__PURE__*/React.createElement(TextField, {
    type: "date",
    size: "small",
    variant: "outlined",
    fullWidth: true,
    value: accToDate,
    onChange: function onChange(e) {
      return setAccToDate(e.target.value);
    }
  }))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 3
  }, /*#__PURE__*/React.createElement(FormControl, {
    variant: "outlined",
    size: "small",
    fullWidth: true
  }, /*#__PURE__*/React.createElement(Select, {
    value: association,
    onChange: function onChange(e) {
      return setAssociation(e.target.value);
    },
    displayEmpty: true
  }, /*#__PURE__*/React.createElement(MenuItem, {
    value: "all"
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "workforce.dashboard.allAssociations"
  })), /*#__PURE__*/React.createElement(MenuItem, {
    value: "bgmea"
  }, "BGMEA"), /*#__PURE__*/React.createElement(MenuItem, {
    value: "bkmea"
  }, "BKMEA")))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 3
  }, /*#__PURE__*/React.createElement(ButtonGroup, {
    size: "small",
    variant: "outlined",
    fullWidth: true
  }, ["All", "CF", "EIS"].map(function (f) {
    return /*#__PURE__*/React.createElement(Button, {
      key: f,
      variant: filter === f ? "contained" : "outlined",
      onClick: function onClick() {
        return handleFilter(f);
      }
    }, f === "All" ? /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.dashboard.filter.all",
      defaultMessage: "All"
    }) : f);
  })))))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 6
  }, /*#__PURE__*/React.createElement(DashboardCard$1, {
    title: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.dashboard.lastMeetingOverview"
    })
  }, /*#__PURE__*/React.createElement(StatRow$1, {
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.dashboard.lastMeeting.presented"
    }),
    count: applications.length
  }), /*#__PURE__*/React.createElement(StatRow$1, {
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.dashboard.lastMeeting.approved"
    }),
    count: applications.filter(function (application) {
      return (application === null || application === void 0 ? void 0 : application.eisVerified) === true;
    }).length,
    color: "#2e7d32"
  }), /*#__PURE__*/React.createElement(StatRow$1, {
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.dashboard.lastMeeting.rejected"
    }),
    count: lastMeetingOverview.rejected,
    color: "#d32f2f"
  }), /*#__PURE__*/React.createElement(StatRow$1, {
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.dashboard.lastMeeting.reverted"
    }),
    count: lastMeetingOverview.reverted,
    color: "#ed6c02"
  }))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 6
  }, /*#__PURE__*/React.createElement(DashboardCard$1, {
    title: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.dashboard.ongoingMeetingOverview"
    })
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 3
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle2",
    style: {
      marginTop: 10,
      color: "#1976d2"
    }
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "workforce.dashboard.ongoingMeeting.caseType"
  })), /*#__PURE__*/React.createElement(StatRow$1, {
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.dashboard.ongoingMeeting.deathCount"
    }),
    count: applications !== null ? applications === null || applications === void 0 ? void 0 : applications.filter(function (item) {
      return item.applicationType === "financialAssistance" && (item === null || item === void 0 ? void 0 : item.status) === "forward_to_comiitee";
    }).length : 0
  }), /*#__PURE__*/React.createElement(StatRow$1, {
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.dashboard.ongoingMeeting.disabilityCount"
    }),
    count: applications !== null ? applications === null || applications === void 0 ? void 0 : applications.filter(function (item) {
      return item.applicationType === "disabilityAssistance" && (item === null || item === void 0 ? void 0 : item.status) === "forward_to_comiitee";
    }).length : 0
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle2",
    style: {
      marginTop: 10,
      color: "#ed6c02"
    }
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "workforce.dashboard.ongoingMeeting.accidentType"
  })), /*#__PURE__*/React.createElement(StatRow$1, {
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.dashboard.ongoingMeeting.commutingCount"
    }),
    count: applications !== null ? applications === null || applications === void 0 ? void 0 : applications.filter(function (item) {
      var _item$employeeAcciden;
      return (item.applicationType === "financialAssistance" || item.applicationType === "disabilityAssistance") && (item === null || item === void 0 || (_item$employeeAcciden = item.employeeAccidentInfo) === null || _item$employeeAcciden === void 0 ? void 0 : _item$employeeAcciden.accidentMainType) === "workforce.accident.mainType.commuting";
    }).length : 0
  }), /*#__PURE__*/React.createElement(StatRow$1, {
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.dashboard.ongoingMeeting.workplaceCount"
    }),
    count: applications !== null ? applications === null || applications === void 0 ? void 0 : applications.filter(function (item) {
      var _item$employeeAcciden2;
      return (item.applicationType === "financialAssistance" || item.applicationType === "disabilityAssistance") && (item === null || item === void 0 || (_item$employeeAcciden2 = item.employeeAccidentInfo) === null || _item$employeeAcciden2 === void 0 ? void 0 : _item$employeeAcciden2.accidentMainType) === "workforce.accident.mainType.workplace";
    }).length : 0
  }), /*#__PURE__*/React.createElement(StatRow$1, {
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.dashboard.ongoingMeeting.rtaCount"
    }),
    count: applications !== null ? applications === null || applications === void 0 ? void 0 : applications.filter(function (item) {
      var _item$employeeAcciden3;
      return (item.applicationType === "financialAssistance" || item.applicationType === "disabilityAssistance") && (item === null || item === void 0 || (_item$employeeAcciden3 = item.employeeAccidentInfo) === null || _item$employeeAcciden3 === void 0 ? void 0 : _item$employeeAcciden3.accidentMainType) === "workforce.accident.mainType.onDutyRTA";
    }).length : 0
  }))))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(DashboardCard$1, {
    title: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.dashboard.financialOverview"
    })
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 3
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle2",
    style: {
      marginTop: 10,
      color: "#2e7d32"
    }
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "workforce.dashboard.financial.paidTillNow"
  })), /*#__PURE__*/React.createElement(StatRow$1, {
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.dashboard.financial.deathTotal"
    }),
    count: "\u09F3 ".concat(disbursedApplication !== null ? disbursedApplication.filter(function (item) {
      var _item$workforceApplic;
      return ((_item$workforceApplic = item.workforceApplication) === null || _item$workforceApplic === void 0 ? void 0 : _item$workforceApplic.applicationType) === "financialAssistance";
    }).reduce(function (acc, obj) {
      return acc + (Number(parseFloat(obj === null || obj === void 0 ? void 0 : obj.paidAmount).toFixed(2)) || 0);
    }, 0).toFixed(2) : 0)
  }), /*#__PURE__*/React.createElement(StatRow$1, {
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.dashboard.financial.disabilityTotal"
    }),
    count: "\u09F3 ".concat(disbursedApplication !== null ? disbursedApplication.filter(function (item) {
      var _item$workforceApplic2;
      return ((_item$workforceApplic2 = item.workforceApplication) === null || _item$workforceApplic2 === void 0 ? void 0 : _item$workforceApplic2.applicationType) === "disabilityAssistance";
    }).reduce(function (acc, obj) {
      return acc + (Number(parseFloat(obj === null || obj === void 0 ? void 0 : obj.paidAmount).toFixed(2)) || 0);
    }, 0).toFixed(2) : 0)
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle2",
    style: {
      marginTop: 10,
      color: "#ed6c02"
    }
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "workforce.dashboard.financial.approxLifetime"
  })), /*#__PURE__*/React.createElement(StatRow$1, {
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.dashboard.financial.deathTotal"
    }),
    count: "\u09F3 ".concat(disbursedApplication !== null ? disbursedApplication.filter(function (item) {
      var _item$workforceApplic3;
      return ((_item$workforceApplic3 = item.workforceApplication) === null || _item$workforceApplic3 === void 0 ? void 0 : _item$workforceApplic3.applicationType) === "financialAssistance";
    }).reduce(function (acc, obj) {
      return acc + (Number(parseFloat(obj === null || obj === void 0 ? void 0 : obj.eisCalculatedAmount).toFixed(2)) || 0);
    }, 0) : 0)
  }), /*#__PURE__*/React.createElement(StatRow$1, {
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.dashboard.financial.disabilityTotal"
    }),
    count: "\u09F3 ".concat(disbursedApplication !== null ? disbursedApplication.filter(function (item) {
      var _item$workforceApplic4;
      return ((_item$workforceApplic4 = item.workforceApplication) === null || _item$workforceApplic4 === void 0 ? void 0 : _item$workforceApplic4.applicationType) === "financialAssistance";
    }).reduce(function (acc, obj) {
      return acc + (Number(parseFloat(obj === null || obj === void 0 ? void 0 : obj.eisCalculatedAmount).toFixed(2)) || 0);
    }, 0) : 0)
  }))))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 5
  }, /*#__PURE__*/React.createElement(DashboardCard$1, {
    title: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.dashboard.appSegregation"
    })
  }, /*#__PURE__*/React.createElement(ResponsiveContainer, {
    width: "100%",
    height: 300
  }, /*#__PURE__*/React.createElement(PieChart, null, /*#__PURE__*/React.createElement(Pie, {
    data: pieData,
    dataKey: "value",
    nameKey: "name",
    innerRadius: 60,
    outerRadius: 100,
    label: true
  }, pieData.map(function (entry, index) {
    return /*#__PURE__*/React.createElement(Cell, {
      key: "cell-".concat(index),
      fill: entry.color
    });
  })), /*#__PURE__*/React.createElement(Tooltip$1, null), /*#__PURE__*/React.createElement(Legend, {
    verticalAlign: "bottom",
    align: "center"
  }))))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 7
  }, /*#__PURE__*/React.createElement(DashboardCard$1, {
    title: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.dashboard.accidentVsTime"
    })
  }, /*#__PURE__*/React.createElement(ResponsiveContainer, {
    width: "100%",
    height: 300
  }, /*#__PURE__*/React.createElement(BarChart, {
    data: barData
  }, /*#__PURE__*/React.createElement(CartesianGrid, {
    strokeDasharray: "3 3"
  }), /*#__PURE__*/React.createElement(XAxis, {
    dataKey: "month"
  }), /*#__PURE__*/React.createElement(YAxis, {
    label: {
      value: isBn ? "দুর্ঘটনার সংখ্যা" : "Number of accidents",
      angle: -90,
      position: "insideLeft"
    }
  }), /*#__PURE__*/React.createElement(Tooltip$1, null), /*#__PURE__*/React.createElement(Legend, null), /*#__PURE__*/React.createElement(Bar, {
    dataKey: chartLabels.death,
    stackId: "death",
    fill: "#d32f2f"
  }), /*#__PURE__*/React.createElement(Bar, {
    dataKey: chartLabels.disability,
    stackId: "disability",
    fill: "#1976d2"
  }))))));
};

// ------------------------------------------------------------

var EisCommitteeDashboardPage = function EisCommitteeDashboardPage() {
  var classes = useStyles$k();
  var dispatch = useDispatch();
  var loggedInUserId = useSelector(function (state) {
    var _state$core2;
    return (_state$core2 = state.core) === null || _state$core2 === void 0 || (_state$core2 = _state$core2.user) === null || _state$core2 === void 0 || (_state$core2 = _state$core2.i_user) === null || _state$core2 === void 0 ? void 0 : _state$core2.id;
  });
  var modulesManager = useModulesManager();
  var _useState35 = useState("dashboard"),
    _useState36 = _slicedToArray(_useState35, 2),
    selectedMenu = _useState36[0],
    setSelectedMenu = _useState36[1]; // Default first menu
  useEffect(function () {
    return dispatch(fetchSummaryApplications(modulesManager, ["organizationType:\"eis\"", "userId:\"".concat(loggedInUserId, "\"")]));
  }, [loggedInUserId]);
  var data = useSelector(function (state) {
    var _state$workforce;
    return (_state$workforce = state.workforce["applicationsSummary"]) !== null && _state$workforce !== void 0 ? _state$workforce : [];
  });
  var pendingSummaryData = data.filter(function (d) {
    return d.status === "forward_to_comiitee";
  });
  var sentSummaryData = data.filter(function (d) {
    return d.status === "approved_by_committee";
  });
  console.log("Pending Summary Data:", pendingSummaryData);
  var renderContent = function renderContent() {
    console.log("Selected Menu:", selectedMenu);
    switch (selectedMenu) {
      case "dashboard":
        return /*#__PURE__*/React.createElement(Dashboard$2, null);
      case "pendingMeetingSheet":
        return /*#__PURE__*/React.createElement(FiledApplications$1, {
          summaryData: pendingSummaryData
        });
      case "approveMeetingSheet":
        return /*#__PURE__*/React.createElement(FiledApplications$1, {
          summaryData: sentSummaryData,
          disableButtons: 1
        });
      // default:
      //   return <FiledApplications summaryData={pendingSummaryData} />;
      default:
        return /*#__PURE__*/React.createElement(Dashboard$2, null);
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: classes.root
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 2,
    className: classes.root
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 3
  }, /*#__PURE__*/React.createElement(Paper, {
    className: classes.sidebar
  }, /*#__PURE__*/React.createElement(List, null, SidebarMenu$2.map(function (item) {
    return /*#__PURE__*/React.createElement(ListItem, {
      button: true,
      key: item.id,
      selected: selectedMenu === item.id,
      onClick: function onClick() {
        return setSelectedMenu(item.id);
      }
    }, /*#__PURE__*/React.createElement(ListItemIcon, null, item.icon), /*#__PURE__*/React.createElement(ListItemText, {
      primary: item.text
    }));
  })))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 9,
    className: classes.content
  }, renderContent())));
};

var useStyles$j = makeStyles(function (theme) {
  return {
    root: {
      flexGrow: 1,
      padding: theme.spacing(2),
      height: "calc(100vh - 64px)",
      // assuming 64px header/appbar, adjust as needed
      overflow: "visible"
    },
    sidebar: {
      position: "sticky",
      top: 0,
      height: "40vh",
      backgroundColor: theme.palette.background.paper,
      borderRight: "1px solid ".concat(theme.palette.divider),
      overflowY: "auto"
    },
    content: {
      height: "100vh",
      overflowY: "auto",
      padding: theme.spacing(2)
    },
    tableContainer: {
      marginTop: theme.spacing(0)
    },
    tableHeadCell: {
      fontWeight: "bold"
    },
    noData: {
      textAlign: "center",
      padding: theme.spacing(2)
    },
    searchInput: {
      border: "1px solid #ccc",
      borderRadius: 4,
      padding: "4px 8px",
      width: 200
    },
    pagination: {
      display: "flex",
      justifyContent: "flex-end",
      marginTop: theme.spacing(2),
      alignItems: "center"
    },
    tableHeader: {
      backgroundColor: "#B7D4D8"
    },
    accordion: {
      boxShadow: "1px 1px 1px 1px",
      border: "none",
      backgroundColor: "white",
      marginBottom: "12px",
      borderRadius: "6px",
      "&::before": {
        display: "none"
      }
    },
    accordionPadding: {
      paddingBottom: "40px !important"
    },
    accordionSummary: {
      padding: "8px 16px",
      backgroundColor: "white",
      borderRadius: "6px",
      "& .MuiTypography-root": {
        color: "#015C63",
        // teal-like tone
        fontWeight: 600
      }
    },
    accordionDetails: {
      backgroundColor: "white",
      padding: "16px",
      borderTop: "1px solid #ddd"
    }
  };
});
var SidebarMenu$1 = [{
  id: "pendingMeetingSheet",
  text: /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.employee.application.meetingSheet"
  }),
  icon: /*#__PURE__*/React.createElement(HourglassFullTwoToneIcon, null)
}, {
  id: "approveMeetingSheet",
  text: /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.application.forwarded"
  }),
  icon: /*#__PURE__*/React.createElement(CheckCircleOutlineTwoToneIcon, null)
}, {
  id: "returnedApplications",
  text: /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.application.returned"
  }),
  icon: /*#__PURE__*/React.createElement(ArrowBackIcon, null)
}];

// ----------- Components to Render in Main Content -----------

var ReturnedApplications$2 = function ReturnedApplications() {
  var classes = useStyles$j();
  var loggedInUserId = useSelector(function (state) {
    var _state$core;
    return (_state$core = state.core) === null || _state$core === void 0 || (_state$core = _state$core.user) === null || _state$core === void 0 || (_state$core = _state$core.i_user) === null || _state$core === void 0 ? void 0 : _state$core.id;
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ApplicationProcessSearcher$1, {
    returnedApplications: true,
    loggedInUserId: loggedInUserId,
    disableButtons: 1,
    dynamicTableTitle: "workforce.application.returned"
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.pagination
  }, /*#__PURE__*/React.createElement(Button, null, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.back"
  })), /*#__PURE__*/React.createElement(Button, null, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.next"
  }))));
};
var FiledApplications = function FiledApplications(_ref) {
  var _ref$summaryData = _ref.summaryData,
    summaryData = _ref$summaryData === void 0 ? [] : _ref$summaryData,
    _ref$disableButtons = _ref.disableButtons,
    disableButtons = _ref$disableButtons === void 0 ? 0 : _ref$disableButtons;
  var classes = useStyles$j();
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    expanded = _useState2[0],
    setExpanded = _useState2[1];
  var _useState3 = useState(summaryData),
    _useState4 = _slicedToArray(_useState3, 2),
    currentData = _useState4[0],
    setCurrentData = _useState4[1];
  var _useState5 = useState(summaryData),
    _useState6 = _slicedToArray(_useState5, 1),
    originalData = _useState6[0];
  var loggedInUserId = useSelector(function (state) {
    var _state$core2;
    return (_state$core2 = state.core) === null || _state$core2 === void 0 || (_state$core2 = _state$core2.user) === null || _state$core2 === void 0 || (_state$core2 = _state$core2.i_user) === null || _state$core2 === void 0 ? void 0 : _state$core2.id;
  });
  var handleChange = function handleChange(panelId) {
    return function (event, isExpanded) {
      if (isExpanded) {
        setCurrentData(function (prev) {
          var idx = prev.findIndex(function (item) {
            return item.id === panelId;
          });
          if (idx === -1) return prev;
          var newList = _toConsumableArray(prev);
          var _newList$splice = newList.splice(idx, 1),
            _newList$splice2 = _slicedToArray(_newList$splice, 1),
            selected = _newList$splice2[0];
          newList.unshift(selected);
          return newList;
        });
        setExpanded(panelId);
      } else {
        setExpanded(null);
        setCurrentData(originalData);
      }
    };
  };
  return /*#__PURE__*/React.createElement("div", {
    className: classes.accordionPadding
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5",
    gutterBottom: true
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.eis.financial.dashboard"
  })), currentData.map(function (item) {
    return /*#__PURE__*/React.createElement(Accordion, {
      key: item.id,
      expanded: expanded === item.id,
      onChange: handleChange(item.id),
      className: classes.accordion
    }, /*#__PURE__*/React.createElement(AccordionSummary, {
      className: classes.accordionSummary,
      expandIcon: /*#__PURE__*/React.createElement(ExpandMoreIcon, {
        className: "material-icons"
      })
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "subtitle1",
      style: {
        flex: 1
      }
    }, /*#__PURE__*/React.createElement("strong", null, item.name)), /*#__PURE__*/React.createElement(Typography, {
      variant: "body2",
      style: {
        marginLeft: "auto",
        color: "#015C63"
      }
    }, item.meetingDate, " | ", item.month, " ", item.year)), /*#__PURE__*/React.createElement(AccordionDetails, {
      className: classes.accordionDetails
    }, /*#__PURE__*/React.createElement(Card, {
      style: {
        width: "100%"
      }
    }, /*#__PURE__*/React.createElement(CardContent, null, expanded === item.id && /*#__PURE__*/React.createElement(ApplicationProcessSearcher$1, {
      summaryId: item.id,
      disableButtons: disableButtons,
      loggedInUserId: loggedInUserId,
      coloredRow: true
    })))));
  }));
};

// ------------------------------------------------------------

var EisFinancialOfficerDashboard = function EisFinancialOfficerDashboard() {
  var classes = useStyles$j();
  var dispatch = useDispatch();
  var modulesManager = useModulesManager();
  var _useState7 = useState("pendingMeetingSheet"),
    _useState8 = _slicedToArray(_useState7, 2),
    selectedMenu = _useState8[0],
    setSelectedMenu = _useState8[1];
  useEffect(function () {
    return dispatch(fetchSummaryApplications(modulesManager, ['organizationType:"eis"']));
  }, []);
  var data = useSelector(function (state) {
    var _state$workforce;
    return (_state$workforce = state.workforce["applicationsSummary"]) !== null && _state$workforce !== void 0 ? _state$workforce : [];
  });
  var pendingSummaryData = data.filter(function (d) {
    return d.status === "forward_to_eis_financial_officer";
  });
  var sentSummaryData = data.filter(function (d) {
    return d.status === "forward_to_dg" || d.status === 'forward_to_director';
  });
  var renderContent = function renderContent() {
    switch (selectedMenu) {
      case "pendingMeetingSheet":
        return /*#__PURE__*/React.createElement(FiledApplications, {
          summaryData: pendingSummaryData
        });
      case "approveMeetingSheet":
        return /*#__PURE__*/React.createElement(FiledApplications, {
          summaryData: sentSummaryData,
          disableButtons: 1
        });
      case "returnedApplications":
        return /*#__PURE__*/React.createElement(ReturnedApplications$2, null);
      default:
        return /*#__PURE__*/React.createElement(FiledApplications, null);
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: classes.root
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 2,
    className: classes.root
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 3
  }, /*#__PURE__*/React.createElement(Paper, {
    className: classes.sidebar
  }, /*#__PURE__*/React.createElement(List, null, SidebarMenu$1.map(function (item) {
    return /*#__PURE__*/React.createElement(ListItem, {
      button: true,
      key: item.id,
      selected: selectedMenu === item.id,
      onClick: function onClick() {
        return setSelectedMenu(item.id);
      }
    }, /*#__PURE__*/React.createElement(ListItemIcon, null, item.icon), /*#__PURE__*/React.createElement(ListItemText, {
      primary: item.text
    }));
  })))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 9,
    className: classes.content
  }, renderContent())));
};

function ownKeys$h(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$h(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$h(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$h(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var useStyles$i = makeStyles(function (theme) {
  return {
    root: {
      flexGrow: 1,
      padding: theme.spacing(2),
      height: "fit-content",
      // assuming 64px header/appbar, adjust as needed
      overflow: "visible"
    },
    sidebar: {
      position: "sticky",
      top: 85,
      height: "50vh"
    },
    content: {
      height: "fit-content",
      padding: theme.spacing(2)
    },
    tableContainer: {
      marginTop: theme.spacing(0)
    },
    tableHeadCell: {
      fontWeight: "bold"
    },
    noData: {
      textAlign: "center",
      padding: theme.spacing(2)
    },
    searchInput: {
      border: "1px solid #ccc",
      borderRadius: 4,
      padding: "4px 8px",
      width: 200
    },
    pagination: {
      display: "flex",
      justifyContent: "flex-end",
      marginTop: theme.spacing(2),
      alignItems: "center"
    },
    tableHeader: {
      backgroundColor: "#B7D4D8"
    },
    accordion: {
      boxShadow: "1px 1px 1px 1px",
      border: "none",
      backgroundColor: "white",
      marginBottom: "12px",
      borderRadius: "6px",
      "&::before": {
        display: "none"
      }
    },
    accordionPadding: {
      paddingBottom: "40px !important"
    },
    accordionSummary: {
      padding: "8px 16px",
      backgroundColor: "white",
      borderRadius: "6px",
      "& .MuiTypography-root": {
        color: "#015C63",
        // teal-like tone
        fontWeight: 600
      }
    },
    accordionDetails: {
      backgroundColor: "white",
      padding: "16px",
      borderTop: "1px solid #ddd"
    },
    item: {
      display: "flex",
      alignItems: "center",
      gap: theme.spacing(0.5),
      cursor: "pointer",
      padding: "7px",
      borderRadius: "10px",
      "&:hover": {
        backgroundColor: "#517688",
        color: "#fff"
      }
    }
  };
});
var ReturnedApplications$1 = function ReturnedApplications() {
  var classes = useStyles$i();
  var loggedInUserId = useSelector(function (state) {
    var _state$core;
    return (_state$core = state.core) === null || _state$core === void 0 || (_state$core = _state$core.user) === null || _state$core === void 0 || (_state$core = _state$core.i_user) === null || _state$core === void 0 ? void 0 : _state$core.id;
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ApplicationProcessSearcher$1, {
    returnedApplications: true,
    loggedInUserId: loggedInUserId,
    disableButtons: 1,
    dynamicTableTitle: "workforce.application.returned"
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.pagination
  }, /*#__PURE__*/React.createElement(Button, null, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.back"
  })), /*#__PURE__*/React.createElement(Button, null, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.next"
  }))));
};
var RejectApplication$1 = function RejectApplication() {
  var classes = useStyles$i();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ApplicationProcessSearcher$1, {
    rejectedApplication: true,
    dynamicTableTitle: "workforce.application.rejectedApplication"
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.pagination
  }, /*#__PURE__*/React.createElement(Button, null, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.back"
  })), /*#__PURE__*/React.createElement(Button, null, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.next"
  }))));
};

// --- Reusable UI Wrapper for New Cards ---
var DashboardCard = function DashboardCard(_ref) {
  var title = _ref.title,
    subtitle = _ref.subtitle,
    children = _ref.children;
  return /*#__PURE__*/React.createElement(Card, {
    style: {
      height: "100%",
      borderRadius: "16px",
      boxShadow: "0 4px 12px 0 rgba(0,0,0,0.05)",
      padding: "10px"
    }
  }, /*#__PURE__*/React.createElement(CardHeader, {
    title: /*#__PURE__*/React.createElement(Typography, {
      variant: "h6",
      style: {
        fontWeight: "bold"
      }
    }, title),
    subheader: subtitle ? /*#__PURE__*/React.createElement(Typography, {
      variant: "body2",
      color: "textSecondary"
    }, subtitle) : null
  }), /*#__PURE__*/React.createElement(CardContent, {
    style: {
      paddingTop: 0
    }
  }, children));
};
var StatRow = function StatRow(_ref2) {
  var label = _ref2.label,
    count = _ref2.count,
    onClick = _ref2.onClick,
    color = _ref2.color;
  return /*#__PURE__*/React.createElement(Box$1, {
    display: "flex",
    justifyContent: "space-between",
    py: 1,
    borderBottom: "1px solid #f0f0f0"
  }, /*#__PURE__*/React.createElement(Typography, {
    style: {
      color: color || "inherit"
    }
  }, label), onClick ? /*#__PURE__*/React.createElement(Link, {
    component: "button",
    variant: "subtitle1",
    style: {
      fontWeight: "bold"
    },
    onClick: onClick
  }, count) : /*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle1",
    style: {
      fontWeight: "bold"
    }
  }, count));
};
var Dashboard$1 = function Dashboard() {
  var _reduxState$core;
  var dispatch = useDispatch();
  useTheme();
  var history = useHistory();
  getUserType();
  var modulesManager = useModulesManager();
  var reduxState = useSelector(function (state) {
    return state;
  });
  var locale = (reduxState === null || reduxState === void 0 || (_reduxState$core = reduxState.core) === null || _reduxState$core === void 0 || (_reduxState$core = _reduxState$core.user) === null || _reduxState$core === void 0 || (_reduxState$core = _reduxState$core.i_user) === null || _reduxState$core === void 0 ? void 0 : _reduxState$core.language) || "en";
  var isBn = locale === "fr" || locale === "bn";
  var applicationTypeNames = locale === "en" ? APP_TYPE_DASHBOARD_EN : APP_TYPE_DASHBOARD_BN;
  var applicantTypeNames = locale === "en" ? APPLICANT_TYPE_EN : APPLICANT_TYPE_BN;
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    applications = _useState2[0],
    setApplications = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    disbursedApplication = _useState4[0],
    setDisbursedApplication = _useState4[1];
  var _useState5 = useState(0),
    _useState6 = _slicedToArray(_useState5, 2),
    months = _useState6[0],
    setMonths = _useState6[1];
  var _useState7 = useState(""),
    _useState8 = _slicedToArray(_useState7, 2);
    _useState8[0];
    var setMonthString = _useState8[1];
  var _useState9 = useState("eis"),
    _useState10 = _slicedToArray(_useState9, 2),
    filter = _useState10[0];
    _useState10[1];
  var _useState11 = useState(""),
    _useState12 = _slicedToArray(_useState11, 2),
    fromDate = _useState12[0],
    setFromDate = _useState12[1];
  var _useState13 = useState(""),
    _useState14 = _slicedToArray(_useState13, 2);
    _useState14[0];
    var setFromDateString = _useState14[1];
  var _useState15 = useState(""),
    _useState16 = _slicedToArray(_useState15, 2),
    toDate = _useState16[0],
    setToDate = _useState16[1];
  var _useState17 = useState(isBn ? " আজ পর্যন্ত" : " To Date"),
    _useState18 = _slicedToArray(_useState17, 2);
    _useState18[0];
    var setToDateString = _useState18[1];
  var _useState19 = useState(isBn ? "সকল তহবিল" : "All Funds"),
    _useState20 = _slicedToArray(_useState19, 2);
    _useState20[0];
    _useState20[1];
  var _useState21 = useState(6),
    _useState22 = _slicedToArray(_useState21, 2),
    graphMonths = _useState22[0];
    _useState22[1];
  var _useState23 = useState(""),
    _useState24 = _slicedToArray(_useState23, 2);
    _useState24[0];
    _useState24[1];
  var _useState25 = useState(""),
    _useState26 = _slicedToArray(_useState25, 2);
    _useState26[0];
    _useState26[1];
  var _useState27 = useState([]),
    _useState28 = _slicedToArray(_useState27, 2);
    _useState28[0];
    var setTableRows = _useState28[1];
  var _useState29 = useState({
      total: 0,
      approved: 0,
      cancelled: 0,
      processing: 0
    }),
    _useState30 = _slicedToArray(_useState29, 2);
    _useState30[0];
    var setTotals = _useState30[1];
  var _useState31 = useState([]),
    _useState32 = _slicedToArray(_useState31, 2);
    _useState32[0];
    var setPendingApplicationTypes = _useState32[1];
  var _useState33 = useState([]),
    _useState34 = _slicedToArray(_useState33, 2);
    _useState34[0];
    var setApplicationTypes = _useState34[1];
  var _useState35 = useState([]),
    _useState36 = _slicedToArray(_useState35, 2),
    applicationCounts = _useState36[0],
    setApplicationCounts = _useState36[1];
  var _useState37 = useState(0),
    _useState38 = _slicedToArray(_useState37, 2);
    _useState38[0];
    var setTotalBenefitAmount = _useState38[1];
  var _useState39 = useState([]),
    _useState40 = _slicedToArray(_useState39, 2),
    pieData = _useState40[0],
    setPieData = _useState40[1];
  var _useState41 = useState([]),
    _useState42 = _slicedToArray(_useState41, 2),
    barData = _useState42[0],
    setBarData = _useState42[1];
  var _useState43 = useState(false),
    _useState44 = _slicedToArray(_useState43, 2),
    openModal = _useState44[0],
    setOpenModal = _useState44[1];
  var _useState45 = useState(null),
    _useState46 = _slicedToArray(_useState45, 2),
    selectedType = _useState46[0];
    _useState46[1];

  // --- 2. GLOBAL FILTERS STATE ---
  var _useState47 = useState(""),
    _useState48 = _slicedToArray(_useState47, 2),
    accFromDate = _useState48[0],
    setAccFromDate = _useState48[1];
  var _useState49 = useState(""),
    _useState50 = _slicedToArray(_useState49, 2),
    accToDate = _useState50[0],
    setAccToDate = _useState50[1];
  var _useState51 = useState("all"),
    _useState52 = _slicedToArray(_useState51, 2),
    association = _useState52[0],
    setAssociation = _useState52[1];

  // Chart Strings
  var chartLabels = {
    processing: isBn ? "প্রক্রিয়াধীন" : "Processing",
    approved: isBn ? "অনুমোদিত" : "Approved",
    reverted: isBn ? "বাতিল" : "Reverted",
    medical: isBn ? "চিকিৎসা" : "Medical",
    death: isBn ? "মৃত্যু" : "Death",
    educational: isBn ? "শিক্ষা" : "Educational",
    maternity: isBn ? "মাতৃত্ব" : "Maternity",
    disability: isBn ? "স্থায়ী ও অস্থায়ী অক্ষমতা" : "Permanent Or Curable Disability"
  };

  // --- HELPER FUNCTIONS ---
  var getMonthName = function getMonthName(index) {
    var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "en-US";
    var date = new Date(2000, index, 1);
    return date.toLocaleString(locale, {
      month: "long"
    });
  };
  var getBanglaDate = function getBanglaDate(dateStr) {
    var date = new Date(dateStr);
    return date.toLocaleDateString("bn-BD");
  };
  var handleFromDateChange = function handleFromDateChange(date) {
    setFromDate(date);
    if (isBn) setFromDateString(getBanglaDate(date) + " হতে ");else setFromDateString("From " + date);
  };
  var handleToDateChange = function handleToDateChange(date) {
    setToDate(date);
    if (isBn) setToDateString(getBanglaDate(date) + " পর্যন্ত");else setToDateString(" To " + date);
  };
  var navigateToBeneficiaries = function navigateToBeneficiaries() {
    return history.push("/beneficiary-management");
  };
  var getBeneficiaryCount = function getBeneficiaryCount(key) {
    var found = applicationCounts.find(function (item) {
      return item.type === applicantTypeNames[key];
    });
    return found ? found.count : 0;
  };

  // --- EFFECTS ---
  useEffect(function () {
    if (months > 0) {
      setFromDate("");
      setToDate("");
    }
  }, [months]);
  useEffect(function () {
    setMonths(0);
    setMonthString("");
  }, [fromDate, toDate]);
  useEffect(function () {
    function loadData() {
      return _loadData.apply(this, arguments);
    }
    function _loadData() {
      _loadData = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var orgType, res, rows, appTypes, pendingAppTypes, totalsCalc, approvedTotal, cancelledTotal, processingTotal, genderRes, appCounts;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              orgType = filter === "সব" || filter === "All" ? "" : filter.toLowerCase();
              res = [];
              _context.next = 5;
              return dispatch(fetchApplicationByDate(months, fromDate, toDate, orgType)).then(function (response) {
                var _response$payload;
                res = ((_response$payload = response.payload) === null || _response$payload === void 0 || (_response$payload = _response$payload.data) === null || _response$payload === void 0 ? void 0 : _response$payload.workforceApplicationMatrix) || [];
              });
            case 5:
              rows = [];
              appTypes = [];
              pendingAppTypes = [];
              res.forEach(function (item) {
                var type = item.applicationType;
                var allow = false;
                if (orgType === "blwf") allow = type !== "disabilityAssistance";else if (orgType === "eis") allow = ["disabilityAssistance", "financialAssistance", "death"].includes(type);else allow = true;
                if (allow) {
                  rows.push({
                    type: applicationTypeNames[type],
                    total: Number(item.applicationCount),
                    approved: Number(item.approvedCount),
                    cancelled: Number(item.rejectedCount),
                    processing: Number(item.applicationCount) - (Number(item.approvedCount) + Number(item.rejectedCount))
                  });
                  appTypes.push({
                    appType: type,
                    type: applicationTypeNames[type],
                    count: Number(item.applicationCount)
                  });
                  pendingAppTypes.push({
                    appType: type,
                    type: applicationTypeNames[type],
                    count: Number(item.applicationCount) - (Number(item.approvedCount) + Number(item.rejectedCount))
                  });
                }
              });
              setApplicationTypes(appTypes);
              setPendingApplicationTypes(pendingAppTypes);
              totalsCalc = rows.reduce(function (acc, r) {
                acc.total += Number(r.total);
                acc.approved += Number(r.approved);
                acc.cancelled += Number(r.cancelled);
                acc.processing += Number(r.processing);
                return acc;
              }, {
                total: 0,
                approved: 0,
                cancelled: 0,
                processing: 0
              });
              approvedTotal = 0;
              cancelledTotal = 0;
              processingTotal = 0;
              rows.map(function (r) {
                approvedTotal += Number(r.approved);
                cancelledTotal += Number(r.cancelled);
                processingTotal += Number(r.processing);
              });
              setPieData([{
                name: chartLabels.processing,
                value: processingTotal,
                color: "#6cdfdfff"
              }, {
                name: chartLabels.approved,
                value: approvedTotal,
                color: "#68b88cff"
              }, {
                name: chartLabels.reverted,
                value: cancelledTotal,
                color: "#d48aa3ff"
              }]);
              setTableRows(rows);
              setTotals(totalsCalc);
              genderRes = [];
              _context.next = 22;
              return dispatch(fetchGenderWiseApplicationMatrixByDate(months, fromDate, toDate, orgType)).then(function (response) {
                var _response$payload2;
                genderRes = ((_response$payload2 = response.payload) === null || _response$payload2 === void 0 || (_response$payload2 = _response$payload2.data) === null || _response$payload2 === void 0 ? void 0 : _response$payload2.workforceGenderwiseMatrix[0]) || [];
              });
            case 22:
              appCounts = [{
                type: applicantTypeNames["totalApplicant"],
                count: genderRes.totalApplicant
              }, {
                type: applicantTypeNames["maleApplicant"],
                count: genderRes.maleApplicant
              }, {
                type: applicantTypeNames["femaleApplicant"],
                count: genderRes.femaleApplicant
              }, {
                type: applicantTypeNames["totalDependent"],
                count: genderRes.totalDependent
              }];
              setApplicationCounts(appCounts);
              setTotalBenefitAmount(genderRes.totalBenefitAmount || 0);
              _context.next = 30;
              break;
            case 27:
              _context.prev = 27;
              _context.t0 = _context["catch"](0);
              console.error("Failed to fetch data", _context.t0);
            case 30:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[0, 27]]);
      }));
      return _loadData.apply(this, arguments);
    }
    loadData();
  }, [months, fromDate, toDate, filter, chartLabels.processing, chartLabels.approved, chartLabels.reverted]);
  useEffect(function () {
    function loadMonthWiseData() {
      return _loadMonthWiseData.apply(this, arguments);
    }
    function _loadMonthWiseData() {
      _loadMonthWiseData = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var monthWiseRes, barDataArray;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              monthWiseRes = [];
              _context2.next = 4;
              return dispatch(fetchApplicationMonthWise(graphMonths)).then(function (response) {
                var _response$payload3;
                monthWiseRes = ((_response$payload3 = response.payload) === null || _response$payload3 === void 0 || (_response$payload3 = _response$payload3.data) === null || _response$payload3 === void 0 ? void 0 : _response$payload3.workforceMonthwiseApplications) || [];
              });
            case 4:
              barDataArray = [];
              monthWiseRes.map(function (item) {
                barDataArray.push(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({
                  month: getMonthName(Number(item.month) - 1)
                }, chartLabels.medical, item.medical), chartLabels.death, item.death), chartLabels.educational, item.educational), chartLabels.maternity, item.maternityGrant), chartLabels.disability, item.disabilityAssistance));
              });
              setBarData(barDataArray);
              _context2.next = 12;
              break;
            case 9:
              _context2.prev = 9;
              _context2.t0 = _context2["catch"](0);
              console.error("Failed to fetch month wise data", _context2.t0);
            case 12:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[0, 9]]);
      }));
      return _loadMonthWiseData.apply(this, arguments);
    }
    loadMonthWiseData();
  }, [graphMonths, chartLabels.medical, chartLabels.death, chartLabels.educational, chartLabels.maternity, chartLabels.disability]);
  useEffect(function () {
    function loadNewDashboardRequirements() {
      return _loadNewDashboardRequirements.apply(this, arguments);
    }
    function _loadNewDashboardRequirements() {
      _loadNewDashboardRequirements = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var filtersBase;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              // Dispatch new API actions here using accFromDate, accToDate, association
              filtersBase = [
              // 'statusIn: ["forward_to_eis_advisor","approved_by_eis_director"]',
              'organizationTypeIn: ["eis"]', 'orderBy: ["-dateCreated"]'];
              dispatch(fetchApplicationsSummaryDashboard(modulesManager, filtersBase)).then(function (res) {
                var _res$payload;
                var response = parseData(res === null || res === void 0 || (_res$payload = res.payload) === null || _res$payload === void 0 || (_res$payload = _res$payload.data) === null || _res$payload === void 0 ? void 0 : _res$payload.workforceApplication);
                var formData = response === null || response === void 0 ? void 0 : response.map(function (application) {
                  var parsedMetadata = JSON.parse(application === null || application === void 0 ? void 0 : application.metadata);
                  var parsedApplicantInfo = JSON.parse(application === null || application === void 0 ? void 0 : application.applicantInfo);
                  var parsedDeceasedWorkerInfo = JSON.parse(application === null || application === void 0 ? void 0 : application.deceasedWorkerInfo);
                  var parsedEmployeeAccidentInfo = JSON.parse(application === null || application === void 0 ? void 0 : application.employeeAccidentInfo);
                  // const parsedEmployeeDependentInfo = JSON.parse(application?.employeeDependentInfo)
                  // const parsedEmployeeBankInfo = JSON.parse(application?.employeeBankInfo)

                  return _objectSpread$h(_objectSpread$h({}, application), {}, {
                    applicantInfo: safeParse(parsedApplicantInfo),
                    metadata: safeParse(parsedMetadata),
                    deceasedWorkerInfo: safeParse(parsedDeceasedWorkerInfo),
                    employeeAccidentInfo: safeParse(parsedEmployeeAccidentInfo)
                    // employeeDependentInfo:JSON.parse(parsedEmployeeDependentInfo),
                    // employeeBankInfo:JSON.parse(parsedEmployeeBankInfo)
                  });
                });
                setApplications(formData);
                console.log({
                  fromEISAdvisor: formData
                });
              });
              dispatch(fetchWorkforceEisPaymentDisbursementStage({
                isDisbursed: true
              }, modulesManager)).then(function (r) {
                var _r$payload;
                var response = r === null || r === void 0 || (_r$payload = r.payload) === null || _r$payload === void 0 || (_r$payload = _r$payload.data) === null || _r$payload === void 0 ? void 0 : _r$payload.workforceEisPaymentDisbursementStage;
                setDisbursedApplication(response);
                console.log({
                  response: response
                });
              });
            case 3:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      return _loadNewDashboardRequirements.apply(this, arguments);
    }
    loadNewDashboardRequirements();
  }, []);
  return /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 3
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(Card, {
    style: {
      borderRadius: "16px",
      padding: "20px",
      boxShadow: "0 2px 8px rgba(0,0,0,0.1)"
    }
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6",
    style: {
      marginBottom: "15px",
      fontWeight: "bold"
    }
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "workforce.dashboard.overallFilters"
  })), /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 3,
    alignItems: "flex-end"
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 4
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "caption",
    color: "textSecondary"
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "workforce.dashboard.appSubmissionDate"
  })), /*#__PURE__*/React.createElement(Box$1, {
    display: "flex",
    gridGap: 10
  }, /*#__PURE__*/React.createElement(TextField, {
    type: "date",
    size: "small",
    variant: "outlined",
    fullWidth: true,
    value: fromDate,
    onChange: function onChange(e) {
      return handleFromDateChange(e.target.value);
    }
  }), /*#__PURE__*/React.createElement(TextField, {
    type: "date",
    size: "small",
    variant: "outlined",
    fullWidth: true,
    value: toDate,
    onChange: function onChange(e) {
      return handleToDateChange(e.target.value);
    }
  }))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 4
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "caption",
    color: "textSecondary"
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "workforce.dashboard.accidentDate"
  })), /*#__PURE__*/React.createElement(Box$1, {
    display: "flex",
    gridGap: 10
  }, /*#__PURE__*/React.createElement(TextField, {
    type: "date",
    size: "small",
    variant: "outlined",
    fullWidth: true,
    value: accFromDate,
    onChange: function onChange(e) {
      return setAccFromDate(e.target.value);
    }
  }), /*#__PURE__*/React.createElement(TextField, {
    type: "date",
    size: "small",
    variant: "outlined",
    fullWidth: true,
    value: accToDate,
    onChange: function onChange(e) {
      return setAccToDate(e.target.value);
    }
  }))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 4
  }, /*#__PURE__*/React.createElement(FormControl, {
    variant: "outlined",
    size: "small",
    fullWidth: true
  }, /*#__PURE__*/React.createElement(Select, {
    value: association,
    onChange: function onChange(e) {
      return setAssociation(e.target.value);
    },
    displayEmpty: true
  }, /*#__PURE__*/React.createElement(MenuItem, {
    value: "all"
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "workforce.dashboard.allAssociations"
  })), /*#__PURE__*/React.createElement(MenuItem, {
    value: "bgmea"
  }, "BGMEA"), /*#__PURE__*/React.createElement(MenuItem, {
    value: "bkmea"
  }, "BKMEA"))))))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(DashboardCard, {
    title: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.dashboard.pipeline"
    }),
    subtitle: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.dashboard.pipeline.subtitle"
    })
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 4
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 4
  }, /*#__PURE__*/React.createElement(StatRow, {
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.dashboard.pipeline.factory"
    }),
    count: applications === null || applications === void 0 ? void 0 : applications.filter(function (item) {
      return item.status === "new";
    }).length
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 4
  }, /*#__PURE__*/React.createElement(StatRow, {
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.dashboard.pipeline.association"
    }),
    count: applications === null || applications === void 0 ? void 0 : applications.filter(function (item) {
      return item.status === "forward_to_association";
    }).length
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 4
  }, /*#__PURE__*/React.createElement(StatRow, {
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.dashboard.pipeline.eis"
    }),
    count: applications === null || applications === void 0 ? void 0 : applications.filter(function (item) {
      return item.status != "forward_to_association" || item.status != "new" || item.status != "draft";
    }).length
  }))))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 4
  }, /*#__PURE__*/React.createElement(DashboardCard, {
    title: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.dashboard.pending"
    }),
    subtitle: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.dashboard.pending.subtitle"
    })
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle2",
    style: {
      color: "#1976d2",
      marginTop: 10
    }
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "workforce.dashboard.pending.verified"
  })), /*#__PURE__*/React.createElement(Box$1, {
    pl: 2,
    mb: 2
  }, /*#__PURE__*/React.createElement(StatRow, {
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.dashboard.pending.death"
    }),
    count: applications === null || applications === void 0 ? void 0 : applications.filter(function (item) {
      return item.applicationType === "financialAssistance" && (item === null || item === void 0 ? void 0 : item.eisVerified);
    }).length
  }), /*#__PURE__*/React.createElement(StatRow, {
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.dashboard.pending.disability"
    }),
    count: applications === null || applications === void 0 ? void 0 : applications.filter(function (item) {
      return item.applicationType === "disabilityAssistance" && (item === null || item === void 0 ? void 0 : item.eisVerified);
    }).length
  })), /*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle2",
    style: {
      color: "#d32f2f"
    }
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "workforce.dashboard.pending.nonVerified"
  })), /*#__PURE__*/React.createElement(Box$1, {
    pl: 2
  }, /*#__PURE__*/React.createElement(StatRow, {
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.dashboard.pending.death"
    }),
    count: applications === null || applications === void 0 ? void 0 : applications.filter(function (item) {
      return item.applicationType === "financialAssistance" && !(item !== null && item !== void 0 && item.eisVerified);
    }).length
  }), /*#__PURE__*/React.createElement(StatRow, {
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.dashboard.pending.disability"
    }),
    count: applications === null || applications === void 0 ? void 0 : applications.filter(function (item) {
      return item.applicationType === "disabilityAssistance" && !(item !== null && item !== void 0 && item.eisVerified);
    }).length
  })))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 4
  }, /*#__PURE__*/React.createElement(DashboardCard, {
    title: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.dashboard.overview"
    }),
    subtitle: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.dashboard.overview.subtitle"
    })
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle2",
    style: {
      marginTop: 10
    }
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "workforce.dashboard.overview.death"
  })), /*#__PURE__*/React.createElement(Box$1, {
    pl: 2,
    mb: 2
  }, /*#__PURE__*/React.createElement(StatRow, {
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.dashboard.overview.deadMale"
    }),
    count: applications === null || applications === void 0 ? void 0 : applications.filter(function (item) {
      var _item$deceasedWorkerI;
      return item.applicationType === "financialAssistance" && (item === null || item === void 0 ? void 0 : item.status) === "approved_by_committee" && (item === null || item === void 0 || (_item$deceasedWorkerI = item.deceasedWorkerInfo) === null || _item$deceasedWorkerI === void 0 || (_item$deceasedWorkerI = _item$deceasedWorkerI.gender) === null || _item$deceasedWorkerI === void 0 ? void 0 : _item$deceasedWorkerI.name) === "workforce.gender.male";
    }).length
  }), /*#__PURE__*/React.createElement(StatRow, {
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.dashboard.overview.deadFemale"
    }),
    count: applications === null || applications === void 0 ? void 0 : applications.filter(function (item) {
      var _item$deceasedWorkerI2;
      return item.applicationType === "financialAssistance" && (item === null || item === void 0 ? void 0 : item.status) === "approved_by_committee" && (item === null || item === void 0 || (_item$deceasedWorkerI2 = item.deceasedWorkerInfo) === null || _item$deceasedWorkerI2 === void 0 || (_item$deceasedWorkerI2 = _item$deceasedWorkerI2.gender) === null || _item$deceasedWorkerI2 === void 0 ? void 0 : _item$deceasedWorkerI2.name) === "workforce.gender.female";
    }).length
  })), /*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle2"
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "workforce.dashboard.overview.disability"
  })), /*#__PURE__*/React.createElement(Box$1, {
    pl: 2
  }, /*#__PURE__*/React.createElement(StatRow, {
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.dashboard.overview.maleWorker"
    }),
    count: applications === null || applications === void 0 ? void 0 : applications.filter(function (item) {
      var _item$workforceEmploy;
      return item.applicationType === "disabilityAssistance" && (item === null || item === void 0 ? void 0 : item.status) === "approved_by_committee" && (item === null || item === void 0 || (_item$workforceEmploy = item.workforceEmployee) === null || _item$workforceEmploy === void 0 ? void 0 : _item$workforceEmploy.gender) === "workforce.gender.male";
    }).length
  }), /*#__PURE__*/React.createElement(StatRow, {
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.dashboard.overview.femaleWorker"
    }),
    count: applications === null || applications === void 0 ? void 0 : applications.filter(function (item) {
      var _item$workforceEmploy2;
      return item.applicationType === "disabilityAssistance" && (item === null || item === void 0 ? void 0 : item.status) === "approved_by_committee" && (item === null || item === void 0 || (_item$workforceEmploy2 = item.workforceEmployee) === null || _item$workforceEmploy2 === void 0 ? void 0 : _item$workforceEmploy2.gender) === "workforce.gender.female";
    }).length
  })))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 4
  }, /*#__PURE__*/React.createElement(DashboardCard, {
    title: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.dashboard.beneficiary"
    }),
    subtitle: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.dashboard.beneficiary.subtitle"
    })
  }, /*#__PURE__*/React.createElement(StatRow, {
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.dashboard.beneficiary.male"
    }),
    count: getBeneficiaryCount("maleApplicant"),
    onClick: navigateToBeneficiaries
  }), /*#__PURE__*/React.createElement(StatRow, {
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.dashboard.beneficiary.female"
    }),
    count: getBeneficiaryCount("femaleApplicant"),
    onClick: navigateToBeneficiaries
  }), /*#__PURE__*/React.createElement(Box$1, {
    mt: 2,
    p: 1,
    bgcolor: "#f9f9f9",
    borderRadius: "8px"
  }, /*#__PURE__*/React.createElement(StatRow, {
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.dashboard.beneficiary.total"
    }),
    count: getBeneficiaryCount("totalApplicant"),
    onClick: navigateToBeneficiaries
  })))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 6
  }, /*#__PURE__*/React.createElement(DashboardCard, {
    title: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.dashboard.accidentSegregation"
    }),
    subtitle: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.dashboard.accidentSegregation.subtitle"
    })
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 3
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle2",
    style: {
      marginTop: 10
    }
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "workforce.dashboard.overview.death"
  })), /*#__PURE__*/React.createElement(StatRow, {
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.dashboard.accidentSegregation.workplace"
    }),
    count: applications === null || applications === void 0 ? void 0 : applications.filter(function (item) {
      var _item$employeeAcciden;
      return item.applicationType === "financialAssistance" && (item === null || item === void 0 || (_item$employeeAcciden = item.employeeAccidentInfo) === null || _item$employeeAcciden === void 0 ? void 0 : _item$employeeAcciden.accidentMainType) === "workforce.accident.mainType.workplace";
    }).length
  }), /*#__PURE__*/React.createElement(StatRow, {
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.dashboard.accidentSegregation.commuting"
    }),
    count: applications === null || applications === void 0 ? void 0 : applications.filter(function (item) {
      var _item$employeeAcciden2;
      return item.applicationType === "financialAssistance" && (item === null || item === void 0 || (_item$employeeAcciden2 = item.employeeAccidentInfo) === null || _item$employeeAcciden2 === void 0 ? void 0 : _item$employeeAcciden2.accidentMainType) === "workforce.accident.mainType.commuting";
    }).length
  }), /*#__PURE__*/React.createElement(StatRow, {
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.dashboard.accidentSegregation.rta"
    }),
    count: applications === null || applications === void 0 ? void 0 : applications.filter(function (item) {
      var _item$employeeAcciden3;
      return item.applicationType === "financialAssistance" && (item === null || item === void 0 || (_item$employeeAcciden3 = item.employeeAccidentInfo) === null || _item$employeeAcciden3 === void 0 ? void 0 : _item$employeeAcciden3.accidentMainType) === "workforce.accident.mainType.onDutyRTA";
    }).length
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle2",
    style: {
      marginTop: 10
    }
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "workforce.dashboard.overview.disability"
  })), /*#__PURE__*/React.createElement(StatRow, {
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.dashboard.accidentSegregation.workplace"
    }),
    count: applications === null || applications === void 0 ? void 0 : applications.filter(function (item) {
      var _item$employeeAcciden4;
      return item.applicationType === "disabilityAssistance" && (item === null || item === void 0 || (_item$employeeAcciden4 = item.employeeAccidentInfo) === null || _item$employeeAcciden4 === void 0 ? void 0 : _item$employeeAcciden4.accidentMainType) === "workforce.accident.mainType.workplace";
    }).length
  }), /*#__PURE__*/React.createElement(StatRow, {
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.dashboard.accidentSegregation.commuting"
    }),
    count: applications === null || applications === void 0 ? void 0 : applications.filter(function (item) {
      var _item$employeeAcciden5;
      return item.applicationType === "financialAssistance" && (item === null || item === void 0 || (_item$employeeAcciden5 = item.employeeAccidentInfo) === null || _item$employeeAcciden5 === void 0 ? void 0 : _item$employeeAcciden5.accidentMainType) === "workforce.accident.mainType.commuting";
    }).length
  }), /*#__PURE__*/React.createElement(StatRow, {
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.dashboard.accidentSegregation.rta"
    }),
    count: applications === null || applications === void 0 ? void 0 : applications.filter(function (item) {
      var _item$employeeAcciden6;
      return item.applicationType === "financialAssistance" && (item === null || item === void 0 || (_item$employeeAcciden6 = item.employeeAccidentInfo) === null || _item$employeeAcciden6 === void 0 ? void 0 : _item$employeeAcciden6.accidentMainType) === "workforce.accident.mainType.onDutyRTA";
    }).length
  }))))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 6
  }, /*#__PURE__*/React.createElement(DashboardCard, {
    title: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.dashboard.financialOverview"
    })
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 3
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle2",
    style: {
      marginTop: 10,
      color: "#2e7d32"
    }
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "workforce.dashboard.financial.paidTillNow"
  })), /*#__PURE__*/React.createElement(StatRow, {
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.dashboard.financial.deathTotal"
    }),
    count: "\u09F3 ".concat(disbursedApplication.filter(function (item) {
      var _item$workforceApplic;
      return ((_item$workforceApplic = item.workforceApplication) === null || _item$workforceApplic === void 0 ? void 0 : _item$workforceApplic.applicationType) === "financialAssistance";
    }).reduce(function (acc, obj) {
      return acc + (parseFloat(obj === null || obj === void 0 ? void 0 : obj.paidAmount) || 0);
    }, 0).toFixed(2))
  }), /*#__PURE__*/React.createElement(StatRow, {
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.dashboard.financial.disabilityTotal"
    }),
    count: "\u09F3 ".concat(disbursedApplication.filter(function (item) {
      var _item$workforceApplic2;
      return ((_item$workforceApplic2 = item.workforceApplication) === null || _item$workforceApplic2 === void 0 ? void 0 : _item$workforceApplic2.applicationType) === "disabilityAssistance";
    }).reduce(function (acc, obj) {
      return acc + (parseFloat(obj === null || obj === void 0 ? void 0 : obj.paidAmount) || 0);
    }, 0).toFixed(2))
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle2",
    style: {
      marginTop: 10,
      color: "#ed6c02"
    }
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "workforce.dashboard.financial.approxLifetime"
  })), /*#__PURE__*/React.createElement(StatRow, {
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.dashboard.financial.deathTotal"
    }),
    count: "\u09F3 ".concat(disbursedApplication.filter(function (item) {
      var _item$workforceApplic3;
      return ((_item$workforceApplic3 = item.workforceApplication) === null || _item$workforceApplic3 === void 0 ? void 0 : _item$workforceApplic3.applicationType) === "financialAssistance";
    }).reduce(function (acc, obj) {
      return acc + (Number(parseFloat(obj === null || obj === void 0 ? void 0 : obj.eisCalculatedAmount).toFixed(2)) || 0);
    }, 0).toFixed(2))
  }), /*#__PURE__*/React.createElement(StatRow, {
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.dashboard.financial.disabilityTotal"
    }),
    count: "\u09F3 ".concat(disbursedApplication.filter(function (item) {
      var _item$workforceApplic4;
      return ((_item$workforceApplic4 = item.workforceApplication) === null || _item$workforceApplic4 === void 0 ? void 0 : _item$workforceApplic4.applicationType) === "financialAssistance";
    }).reduce(function (acc, obj) {
      return acc + (Number(parseFloat(obj === null || obj === void 0 ? void 0 : obj.eisCalculatedAmount).toFixed(2)) || 0);
    }, 0).toFixed(2))
  }))))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 5
  }, /*#__PURE__*/React.createElement(DashboardCard, {
    title: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.dashboard.appSegregation"
    })
  }, /*#__PURE__*/React.createElement(ResponsiveContainer, {
    width: "100%",
    height: 300
  }, /*#__PURE__*/React.createElement(PieChart, null, /*#__PURE__*/React.createElement(Pie, {
    data: pieData,
    dataKey: "value",
    nameKey: "name",
    innerRadius: 60,
    outerRadius: 100,
    label: true
  }, pieData.map(function (entry, index) {
    return /*#__PURE__*/React.createElement(Cell, {
      key: "cell-".concat(index),
      fill: entry.color
    });
  })), /*#__PURE__*/React.createElement(Tooltip$1, null), /*#__PURE__*/React.createElement(Legend, {
    verticalAlign: "bottom",
    align: "center"
  }))))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 7
  }, /*#__PURE__*/React.createElement(DashboardCard, {
    title: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.dashboard.accidentVsTime"
    })
  }, /*#__PURE__*/React.createElement(ResponsiveContainer, {
    width: "100%",
    height: 300
  }, /*#__PURE__*/React.createElement(BarChart, {
    data: barData
  }, /*#__PURE__*/React.createElement(CartesianGrid, {
    strokeDasharray: "3 3"
  }), /*#__PURE__*/React.createElement(XAxis, {
    dataKey: "month"
  }), /*#__PURE__*/React.createElement(YAxis, {
    label: {
      value: isBn ? "দুর্ঘটনার সংখ্যা" : "Number of accidents",
      angle: -90,
      position: "insideLeft"
    }
  }), /*#__PURE__*/React.createElement(Tooltip$1, null), /*#__PURE__*/React.createElement(Legend, null), /*#__PURE__*/React.createElement(Bar, {
    dataKey: chartLabels.death,
    stackId: "death",
    fill: "#d32f2f"
  }), /*#__PURE__*/React.createElement(Bar, {
    dataKey: chartLabels.disability,
    stackId: "disability",
    fill: "#1976d2"
  }))))), /*#__PURE__*/React.createElement(AgingReportModal, {
    open: openModal,
    onClose: function onClose() {
      return setOpenModal(false);
    },
    data: selectedType,
    organizationType: filter.toLowerCase()
  }));
};
var EISAdvisorDashboardPage = function EISAdvisorDashboardPage() {
  var reduxState = useSelector(function (state) {
    return state;
  });
  var user_rights = reduxState.core.user.i_user.rights;
  var approvedTextId = getUserTypeFromRights(user_rights) === WORKFORCE_USER_TYPE.DIRECTOR ? "workforce.application.forwarded" : "workforce.application.approved";
  var SidebarMenu = [{
    id: "dashboard",
    text: /*#__PURE__*/React.createElement(FormattedMessage, {
      module: "workforce",
      id: "workforce.application.dashboard"
    }),
    icon: /*#__PURE__*/React.createElement(DashboardIcon, null)
  }, {
    id: "waitingApplications",
    text: /*#__PURE__*/React.createElement(FormattedMessage, {
      module: "workforce",
      id: "workforce.employee.application.meetingSheet"
    }),
    icon: /*#__PURE__*/React.createElement(DashboardIcon, null)
  }, {
    id: "rejectedApplications",
    text: /*#__PURE__*/React.createElement(FormattedMessage, {
      module: "workforce",
      id: "workforce.application.rejectedApplication"
    }),
    icon: /*#__PURE__*/React.createElement(DashboardIcon, null)
  }, {
    id: "approvedApplications",
    text: /*#__PURE__*/React.createElement(FormattedMessage, {
      module: "workforce",
      id: approvedTextId
    }),
    icon: /*#__PURE__*/React.createElement(DashboardIcon, null)
  }, {
    id: "returnedApplications",
    text: /*#__PURE__*/React.createElement(FormattedMessage, {
      module: "workforce",
      id: "workforce.application.returned"
    }),
    icon: /*#__PURE__*/React.createElement(DashboardIcon, null)
  }];
  useTheme();
  var classes = useStyles$i();
  useDispatch();
  useModulesManager();
  var _useState53 = useState("dashboard"),
    _useState54 = _slicedToArray(_useState53, 2),
    selectedMenu = _useState54[0],
    setSelectedMenu = _useState54[1];
  var urlParams = new URLSearchParams(window.location.search);
  var status = urlParams.get("status");
  useEffect(function () {
    if (status) {
      switch (status) {
        case "pending":
          setSelectedMenu("waitingApplications");
          break;
        case "approved":
          setSelectedMenu("approvedApplications");
          break;
        case "rejected":
          setSelectedMenu("rejectedApplications");
          break;
        case "returnedApplications":
          setSelectedMenu("returnedApplications");
          break;
        default:
          setSelectedMenu("dashboard");
      }
    }
  }, [status]);
  var renderContent = function renderContent() {
    switch (selectedMenu) {
      case "dashboard":
        return /*#__PURE__*/React.createElement(Dashboard$1, null);
      case "waitingApplications":
        return /*#__PURE__*/React.createElement(ApplicationSummaryPage$1, {
          status: "pending"
        });
      case "rejectedApplications":
        return /*#__PURE__*/React.createElement(RejectApplication$1, null);
      case "approvedApplications":
        return /*#__PURE__*/React.createElement(ApplicationSummaryPage$1, {
          status: "approved",
          disableButtons: 1
        });
      case "returnedApplications":
        return /*#__PURE__*/React.createElement(ReturnedApplications$1, null);
      default:
        return /*#__PURE__*/React.createElement(Dashboard$1, null);
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: classes.root
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 2,
    className: classes.root
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 3,
    className: classes.sidebar
  }, /*#__PURE__*/React.createElement(Paper, {
    className: classes.sidebar
  }, /*#__PURE__*/React.createElement(List, null, SidebarMenu.map(function (item) {
    return /*#__PURE__*/React.createElement(ListItem, {
      button: true,
      key: item.id,
      selected: selectedMenu === item.id,
      onClick: function onClick() {
        return setSelectedMenu(item.id);
      }
    }, /*#__PURE__*/React.createElement(ListItemIcon, null, item.icon), /*#__PURE__*/React.createElement(ListItemText, {
      primary: item.text
    }));
  })))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 9,
    className: classes.content
  }, renderContent())));
};

function ownKeys$g(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$g(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$g(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$g(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var useStyles$h = makeStyles(function (theme) {
  return {
    root: {
      flexGrow: 1,
      padding: theme.spacing(2),
      height: "fit-content",
      // assuming 64px header/appbar, adjust as needed
      overflow: "visible"
    },
    sidebar: {
      position: "sticky",
      top: 85,
      height: "50vh"
    },
    content: {
      height: "fit-content",
      padding: theme.spacing(2)
    },
    tableContainer: {
      marginTop: theme.spacing(0)
    },
    tableHeadCell: {
      fontWeight: "bold"
    },
    noData: {
      textAlign: "center",
      padding: theme.spacing(2)
    },
    searchInput: {
      border: "1px solid #ccc",
      borderRadius: 4,
      padding: "4px 8px",
      width: 200
    },
    pagination: {
      display: "flex",
      justifyContent: "flex-end",
      marginTop: theme.spacing(2),
      alignItems: "center"
    },
    tableHeader: {
      backgroundColor: "#B7D4D8"
    },
    accordion: {
      boxShadow: "1px 1px 1px 1px",
      border: "none",
      backgroundColor: "white",
      marginBottom: "12px",
      borderRadius: "6px",
      "&::before": {
        display: "none"
      }
    },
    accordionPadding: {
      paddingBottom: "40px !important"
    },
    accordionSummary: {
      padding: "8px 16px",
      backgroundColor: "white",
      borderRadius: "6px",
      "& .MuiTypography-root": {
        color: "#015C63",
        // teal-like tone
        fontWeight: 600
      }
    },
    accordionDetails: {
      backgroundColor: "white",
      padding: "16px",
      borderTop: "1px solid #ddd"
    },
    item: {
      display: "flex",
      alignItems: "center",
      gap: theme.spacing(0.5),
      cursor: "pointer",
      padding: "7px",
      borderRadius: "10px",
      "&:hover": {
        backgroundColor: "#517688",
        color: "#fff"
      }
    }
  };
});
var ReturnedApplications = function ReturnedApplications() {
  var classes = useStyles$h();
  var loggedInUserId = useSelector(function (state) {
    var _state$core;
    return (_state$core = state.core) === null || _state$core === void 0 || (_state$core = _state$core.user) === null || _state$core === void 0 || (_state$core = _state$core.i_user) === null || _state$core === void 0 ? void 0 : _state$core.id;
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ApplicationProcessSearcher$1, {
    returnedApplications: true,
    loggedInUserId: loggedInUserId,
    disableButtons: 1,
    dynamicTableTitle: "workforce.application.returned"
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.pagination
  }, /*#__PURE__*/React.createElement(Button, null, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.back"
  })), /*#__PURE__*/React.createElement(Button, null, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.next"
  }))));
};
var RejectApplication = function RejectApplication() {
  var classes = useStyles$h();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ApplicationProcessSearcher$1, {
    rejectedApplication: true,
    dynamicTableTitle: "workforce.application.rejectedApplication"
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.pagination
  }, /*#__PURE__*/React.createElement(Button, null, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.back"
  })), /*#__PURE__*/React.createElement(Button, null, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.next"
  }))));
};
var Dashboard = function Dashboard() {
  var _reduxState$core;
  var dispatch = useDispatch();
  var theme = useTheme();
  useHistory();
  var user_type = getUserType();
  var reduxState = useSelector(function (state) {
    return state;
  });
  var locale = (reduxState === null || reduxState === void 0 || (_reduxState$core = reduxState.core) === null || _reduxState$core === void 0 || (_reduxState$core = _reduxState$core.user) === null || _reduxState$core === void 0 || (_reduxState$core = _reduxState$core.i_user) === null || _reduxState$core === void 0 ? void 0 : _reduxState$core.language) || 'en';
  var applicationTypeNames = locale == 'en' ? APP_TYPE_DASHBOARD_EN : APP_TYPE_DASHBOARD_BN;
  var applicantTypeNames = locale == 'en' ? APPLICANT_TYPE_EN : APPLICANT_TYPE_BN;
  var buttonOptions = {};
  if (locale == 'fr') {
    buttonOptions = {
      1: "১ মাস",
      3: "৩ মাস",
      6: "৬ মাস",
      12: "১২ মাস"
    };
  } else {
    buttonOptions = {
      1: "1 Month",
      3: "3 Months",
      6: "6 Months",
      12: "12 Months"
    };
  }
  var getMonthName = function getMonthName(index) {
    var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "en-US";
    var date = new Date(2000, index, 1);
    return date.toLocaleString(locale, {
      month: "long"
    });
  };
  var getBanglaDate = function getBanglaDate(dateStr) {
    var date = new Date(dateStr);
    return date.toLocaleDateString('bn-BD');
  };
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    months = _useState2[0],
    setMonths = _useState2[1];
  var _useState3 = useState(""),
    _useState4 = _slicedToArray(_useState3, 2),
    monthString = _useState4[0],
    setMonthString = _useState4[1];
  var _useState5 = useState(locale == 'fr' ? "সব" : "All"),
    _useState6 = _slicedToArray(_useState5, 2),
    filter = _useState6[0],
    setFilter = _useState6[1];
  var _useState7 = useState(""),
    _useState8 = _slicedToArray(_useState7, 2),
    fromDate = _useState8[0],
    setFromDate = _useState8[1];
  var _useState9 = useState(""),
    _useState10 = _slicedToArray(_useState9, 2),
    fromDateString = _useState10[0],
    setFromDateString = _useState10[1];
  var _useState11 = useState(""),
    _useState12 = _slicedToArray(_useState11, 2),
    toDate = _useState12[0],
    setToDate = _useState12[1];
  var _useState13 = useState(locale == "fr" ? " আজ পর্যন্ত" : " To Date"),
    _useState14 = _slicedToArray(_useState13, 2),
    toDateString = _useState14[0],
    setToDateString = _useState14[1];
  var _useState15 = useState(locale == 'fr' ? "সকল তহবিল" : "All Funds"),
    _useState16 = _slicedToArray(_useState15, 2),
    organizationName = _useState16[0],
    setOrganizationName = _useState16[1];
  var _useState17 = useState(6),
    _useState18 = _slicedToArray(_useState17, 2),
    graphMonths = _useState18[0],
    setGraphMonths = _useState18[1];
  var _useState19 = useState(""),
    _useState20 = _slicedToArray(_useState19, 2),
    graphFromDate = _useState20[0],
    setGraphFromDate = _useState20[1];
  var _useState21 = useState(""),
    _useState22 = _slicedToArray(_useState21, 2),
    graphToDate = _useState22[0],
    setGraphToDate = _useState22[1];
  var handleFilter = function handleFilter(f) {
    setFilter(f);
    if (f === (locale == 'fr' ? "সব" : "All") || f == "") {
      setOrganizationName(locale == 'fr' ? "সকল তহবিল" : "All Funds");
    } else if (f === "CF") {
      setOrganizationName(locale == 'fr' ? "কেন্দ্রীয় তহবিল" : "Central Fund");
    } else if (f === "BLWF") {
      setOrganizationName(locale == 'fr' ? "বাংলাদেশ শ্রমিক কল্যাণ ফাউন্ডেশন" : "Bangladesh Labour Welfare Foundation");
    } else if (f === "EIS") {
      setOrganizationName(locale == 'fr' ? "এমপ্লয়ি ইন্জুরি স্কিম" : "Employee Injury Scheme");
    }
  };
  var handleMonthChange = function handleMonthChange(month) {
    setMonths(month);
    if (locale == 'fr') {
      setMonthString("সর্বশেষ " + Number(month).toLocaleString("bn-BD") + " মাসের তথ্য");
    } else {
      setMonthString("Last " + month + " Month(s) Data");
    }
  };
  var handleFromDateChange = function handleFromDateChange(date) {
    setFromDate(date);
    if (locale == 'fr') {
      var datestr = getBanglaDate(date);
      datestr += ' হতে ';
      setFromDateString(datestr);
    } else {
      setFromDateString("From " + date);
    }
  };
  var handleToDateChange = function handleToDateChange(date) {
    setToDate(date);
    if (locale == 'fr') {
      var datestr = getBanglaDate(date);
      setToDateString(datestr + " পর্যন্ত");
    } else {
      setToDateString(" To " + date);
    }
  };
  useEffect(function () {
    if (months > 0) {
      setFromDate("");
      setToDate("");
    }
  }, [months]);
  useEffect(function () {
    setMonths(0);
    setMonthString("");
  }, [fromDate, toDate]);
  var handleGraphMonthChange = function handleGraphMonthChange(month) {
    setGraphMonths(month);
    setGraphFromDate("");
    setGraphToDate("");
  };
  var _useState23 = useState([]),
    _useState24 = _slicedToArray(_useState23, 2),
    tableRows = _useState24[0],
    setTableRows = _useState24[1];
  var _useState25 = useState({
      total: 0,
      approved: 0,
      cancelled: 0,
      processing: 0
    }),
    _useState26 = _slicedToArray(_useState25, 2),
    totals = _useState26[0],
    setTotals = _useState26[1];
  var _useState27 = useState([]),
    _useState28 = _slicedToArray(_useState27, 2),
    pendingApplicationTypes = _useState28[0],
    setPendingApplicationTypes = _useState28[1];
  var _useState29 = useState([]),
    _useState30 = _slicedToArray(_useState29, 2),
    applicationTypes = _useState30[0],
    setApplicationTypes = _useState30[1];
  var _useState31 = useState([]),
    _useState32 = _slicedToArray(_useState31, 2),
    applicationCounts = _useState32[0],
    setApplicationCounts = _useState32[1];
  var _useState33 = useState(0),
    _useState34 = _slicedToArray(_useState33, 2),
    totalBenefitAmount = _useState34[0],
    setTotalBenefitAmount = _useState34[1];
  var _useState35 = useState([]),
    _useState36 = _slicedToArray(_useState35, 2),
    pieData = _useState36[0],
    setPieData = _useState36[1];
  var _useState37 = useState([]),
    _useState38 = _slicedToArray(_useState37, 2),
    barData = _useState38[0],
    setBarData = _useState38[1];
  useEffect(function () {
    function loadData() {
      return _loadData.apply(this, arguments);
    }
    function _loadData() {
      _loadData = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var orgType, res, rows, appTypes, pendingAppTypes, totalsCalc, approvedTotal, cancelledTotal, processingTotal, genderRes, _applicationCounts;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              orgType = filter === "সব" || filter === "All" ? "" : filter.toLowerCase();
              console.log(orgType);
              res = [];
              _context.next = 6;
              return dispatch(fetchApplicationByDate(months, fromDate, toDate, orgType)).then(function (response) {
                var _response$payload;
                res = ((_response$payload = response.payload) === null || _response$payload === void 0 || (_response$payload = _response$payload.data) === null || _response$payload === void 0 ? void 0 : _response$payload.workforceApplicationMatrix) || [];
              });
            case 6:
              // Map API response to table structure
              rows = [];
              res.forEach(function (item) {
                var type = item.applicationType;
                var allow = false;
                if (orgType === "blwf") {
                  // include all except disabilityAssistance
                  allow = type !== "disabilityAssistance";
                } else if (orgType === "eis") {
                  // include only disabilityAssistance and financialAssistance
                  allow = ["disabilityAssistance", "financialAssistance", "death"].includes(type);
                } else {
                  // include all
                  allow = true;
                }
                if (allow) {
                  rows.push({
                    type: applicationTypeNames[type],
                    total: Number(item.applicationCount),
                    approved: Number(item.approvedCount),
                    cancelled: Number(item.rejectedCount),
                    processing: Number(item.applicationCount) - (Number(item.approvedCount) + Number(item.rejectedCount))
                  });
                } else {
                  console.log("Skipping", type, "for org:", orgType);
                }
              });
              // const rows = res.map((item) => ({
              //   type: applicationTypeNames[item.applicationType],
              //   total: Number(item.applicationCount),
              //   approved: Number(item.approvedCount),
              //   cancelled: Number(item.rejectedCount),
              //   processing: Number(item.applicationCount) - (Number(item.approvedCount) + Number(item.rejectedCount)),
              // }));
              appTypes = [];
              pendingAppTypes = [];
              res.forEach(function (item) {
                var type = item.applicationType;
                var allow = false;
                if (orgType === "blwf") {
                  // include all except disabilityAssistance
                  allow = type !== "disabilityAssistance";
                } else if (orgType === "eis") {
                  // include only disabilityAssistance and financialAssistance
                  allow = ["disabilityAssistance", "financialAssistance", "death"].includes(type);
                } else {
                  // include all types
                  allow = true;
                }
                if (allow) {
                  appTypes.push({
                    appType: type,
                    type: applicationTypeNames[type],
                    count: Number(item.applicationCount)
                  });
                  pendingAppTypes.push({
                    appType: type,
                    type: applicationTypeNames[type],
                    count: Number(item.applicationCount) - (Number(item.approvedCount) + Number(item.rejectedCount))
                  });
                }
              });
              setApplicationTypes(appTypes);
              setPendingApplicationTypes(pendingAppTypes);

              // Calculate totals
              totalsCalc = rows.reduce(function (acc, r) {
                acc.total += Number(r.total);
                acc.approved += Number(r.approved);
                acc.cancelled += Number(r.cancelled);
                acc.processing += Number(r.processing);
                return acc;
              }, {
                total: 0,
                approved: 0,
                cancelled: 0,
                processing: 0
              });
              approvedTotal = 0;
              cancelledTotal = 0;
              processingTotal = 0;
              rows.map(function (r) {
                approvedTotal += Number(r.approved);
                cancelledTotal += Number(r.cancelled);
                processingTotal += Number(r.processing);
              });
              setPieData([{
                name: locale == 'fr' ? "প্রক্রিয়াধীন" : 'Processing',
                value: processingTotal,
                color: "#6cdfdfff"
              }, {
                name: locale == 'fr' ? "অনুমোদিত" : 'Approved',
                value: approvedTotal,
                color: "#68b88cff"
              }, {
                name: locale == 'fr' ? "বাতিল" : 'Reverted',
                value: cancelledTotal,
                color: "#d48aa3ff"
              }]);
              setTableRows(rows);
              setTotals(totalsCalc);
              genderRes = [];
              _context.next = 24;
              return dispatch(fetchGenderWiseApplicationMatrixByDate(months, fromDate, toDate, orgType)).then(function (response) {
                var _response$payload2;
                genderRes = ((_response$payload2 = response.payload) === null || _response$payload2 === void 0 || (_response$payload2 = _response$payload2.data) === null || _response$payload2 === void 0 ? void 0 : _response$payload2.workforceGenderwiseMatrix[0]) || [];
              });
            case 24:
              _applicationCounts = [{
                type: applicantTypeNames['totalApplicant'],
                count: genderRes.totalApplicant
              }, {
                type: applicantTypeNames['maleApplicant'],
                count: genderRes.maleApplicant
              }, {
                type: applicantTypeNames['femaleApplicant'],
                count: genderRes.femaleApplicant
              }, {
                type: applicantTypeNames['totalDependent'],
                count: genderRes.totalDependent
              }
              // { type: applicantTypeNames['maleDependent'], count: genderRes.maleDependent },
              // { type: applicantTypeNames['femaleDependent'], count: genderRes.femaleDependent },
              ];
              setApplicationCounts(_applicationCounts);
              setTotalBenefitAmount(genderRes.totalBenefitAmount || 0);
              _context.next = 32;
              break;
            case 29:
              _context.prev = 29;
              _context.t0 = _context["catch"](0);
              console.error("Failed to fetch data", _context.t0);
            case 32:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[0, 29]]);
      }));
      return _loadData.apply(this, arguments);
    }
    loadData();
  }, [months, fromDate, toDate, filter]);
  useEffect(function () {
    console.log("graphMonths/From/To changed");
    function loadMonthWiseData() {
      return _loadMonthWiseData.apply(this, arguments);
    }
    function _loadMonthWiseData() {
      _loadMonthWiseData = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var monthWiseRes, barDataArray;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              monthWiseRes = [];
              _context2.next = 4;
              return dispatch(fetchApplicationMonthWise(graphMonths)).then(function (response) {
                var _response$payload3;
                monthWiseRes = ((_response$payload3 = response.payload) === null || _response$payload3 === void 0 || (_response$payload3 = _response$payload3.data) === null || _response$payload3 === void 0 ? void 0 : _response$payload3.workforceMonthwiseApplications) || [];
              });
            case 4:
              console.log("monthWiseRes", monthWiseRes);
              barDataArray = [];
              monthWiseRes.map(function (item) {
                barDataArray.push(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({
                  month: getMonthName(Number(item.month) - 1)
                }, locale == 'fr' ? "চিকিৎসা" : "Medical", item.medical), locale == 'fr' ? "মৃত্যু" : "Death", item.death), locale == 'fr' ? "শিক্ষা" : "Educational", item.educational), locale == 'fr' ? "মাতৃত্ব" : "Maternity", item.maternityGrant), locale == 'fr' ? "স্থায়ী ও অস্থায়ী অক্ষমতা" : "Permanent Or Curable Disability", item.disabilityAssistance));
              });
              setBarData(barDataArray);
              _context2.next = 13;
              break;
            case 10:
              _context2.prev = 10;
              _context2.t0 = _context2["catch"](0);
              console.error("Failed to fetch month wise data", _context2.t0);
            case 13:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[0, 10]]);
      }));
      return _loadMonthWiseData.apply(this, arguments);
    }
    loadMonthWiseData();
  }, [graphMonths, graphFromDate, graphToDate]);
  var application_status_count_data = useSelector(function (state) {
    return state.workforce["workforceApplicationStatusCount"];
  });
  if (user_type === WORKFORCE_USER_TYPE.DIRECTOR) {
    var _application_status_c, _application_status_c2, _application_status_c3;
    application_status_count_data === null || application_status_count_data === void 0 || (_application_status_c = application_status_count_data.pendingForDirector) === null || _application_status_c === void 0 ? void 0 : _application_status_c.totalCount;
    application_status_count_data === null || application_status_count_data === void 0 || (_application_status_c2 = application_status_count_data.rejectedForDirector) === null || _application_status_c2 === void 0 ? void 0 : _application_status_c2.totalCount;
    application_status_count_data === null || application_status_count_data === void 0 || (_application_status_c3 = application_status_count_data.approvedForDirector) === null || _application_status_c3 === void 0 ? void 0 : _application_status_c3.totalCount;
  } else {
    var _application_status_c4, _application_status_c5, _application_status_c6;
    application_status_count_data === null || application_status_count_data === void 0 || (_application_status_c4 = application_status_count_data.pending) === null || _application_status_c4 === void 0 ? void 0 : _application_status_c4.totalCount;
    application_status_count_data === null || application_status_count_data === void 0 || (_application_status_c5 = application_status_count_data.rejected) === null || _application_status_c5 === void 0 ? void 0 : _application_status_c5.totalCount;
    application_status_count_data === null || application_status_count_data === void 0 || (_application_status_c6 = application_status_count_data.approved) === null || _application_status_c6 === void 0 ? void 0 : _application_status_c6.totalCount;
  }
  var newCard = {
    height: "100%",
    borderRadius: "20px",
    boxShadow: theme.shadows[2],
    // color: "#000",
    padding: "10px"
  };
  var _useState39 = useState(false),
    _useState40 = _slicedToArray(_useState39, 2),
    openModal = _useState40[0],
    setOpenModal = _useState40[1];
  var handleCloseModal = function handleCloseModal() {
    setOpenModal(false);
  };
  var _useState41 = useState(null),
    _useState42 = _slicedToArray(_useState41, 2),
    selectedType = _useState42[0],
    setSelectedType = _useState42[1];
  var Filters = function Filters() {
    return /*#__PURE__*/React.createElement(Grid, {
      container: true,
      spacing: 2,
      style: {
        marginTop: "15px",
        marginBottom: "10px",
        color: "red"
      }
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 6,
      md: 6
    }, organizationName), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 6,
      md: 6,
      style: {
        textAlign: "right"
      }
    }, fromDate && fromDate != "" ? fromDateString + toDateString : "", monthString != "" ? monthString : ""));
  };
  var handleOpenModal = function handleOpenModal(type) {
    setSelectedType(type);
    setOpenModal(true);
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 2
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 12
  }, /*#__PURE__*/React.createElement(Card, {
    style: _objectSpread$g(_objectSpread$g({}, newCard), {}, {
      padding: "30px",
      borderRadius: "15px",
      overflow: "visible"
    })
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 2,
    style: {
      marginBottom: "10px"
    }
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 12
  }, /*#__PURE__*/React.createElement(Typography, {
    style: {
      fontWeight: "bold"
    }
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "workforce.select.time.range"
  })), /*#__PURE__*/React.createElement(Box$1, {
    gap: 2
  }, /*#__PURE__*/React.createElement(ButtonGroup, {
    variant: "outlined",
    style: {
      display: "flex",
      margin: "auto",
      gap: "10px"
    }
  }, Object.entries(buttonOptions).map(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      label = _ref2[1];
    return /*#__PURE__*/React.createElement(Button, {
      key: key,
      variant: months === key ? "contained" : "outlined",
      onClick: function onClick() {
        return handleMonthChange(key);
      },
      style: {
        border: "1px solid #aaa",
        borderRadius: "10px",
        width: "100%"
      }
    }, label);
  })))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    md: 12
  }, /*#__PURE__*/React.createElement(Card, {
    style: _objectSpread$g(_objectSpread$g({}, newCard), {}, {
      padding: "10px",
      borderRadius: "15px",
      overflow: "visible"
    })
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 2
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    md: 3,
    xs: 3,
    style: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center"
    }
  }, /*#__PURE__*/React.createElement(PublishedComponent, {
    pubRef: "workforce.DatePicker",
    label: "workforce.from.date",
    onChange: function onChange(datevalue) {
      return handleFromDateChange(datevalue);
    },
    width: "100%",
    style: {
      border: "1px solid #aaa",
      padding: "10px",
      borderRadius: "10px",
      width: "100%"
    }
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    md: 3,
    xs: 3,
    style: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center"
    }
  }, /*#__PURE__*/React.createElement(PublishedComponent, {
    pubRef: "workforce.DatePicker",
    label: "workforce.to.date",
    onChange: function onChange(datevalue) {
      return handleToDateChange(datevalue);
    },
    style: {
      border: "1px solid #aaa",
      padding: "10px",
      borderRadius: "10px"
    }
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    md: 6,
    xs: 6
  }, /*#__PURE__*/React.createElement(Card, {
    style: _objectSpread$g(_objectSpread$g({}, newCard), {}, {
      padding: "10px",
      borderRadius: "15px",
      overflow: "visible",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center"
    })
  }, /*#__PURE__*/React.createElement(Typography, {
    component: "div"
  }, locale == 'fr' ? "তহবিল নির্বাচন করুন" : "Fund Type"), /*#__PURE__*/React.createElement(Box$1, {
    mb: 2,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(Box$1, null, /*#__PURE__*/React.createElement(ButtonGroup, {
    size: "small",
    variant: "outlined"
  }, [locale == 'fr' ? "সব" : "All", "CF", "BLWF", "EIS"].map(function (l) {
    return /*#__PURE__*/React.createElement(Button, {
      key: l,
      variant: filter === l ? "contained" : "outlined",
      onClick: function onClick() {
        return handleFilter(l);
      }
    }, l);
  }))), /*#__PURE__*/React.createElement(Box$1, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "caption",
    style: {
      color: "red"
    }
  }, locale == 'fr' ? "নির্বাচিত তহবিল" : "Selected Fund", ": ", /*#__PURE__*/React.createElement("strong", null, organizationName)))))))))))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 4
  }, /*#__PURE__*/React.createElement(Card, {
    style: newCard
  }, /*#__PURE__*/React.createElement(CardContent, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5",
    gutterBottom: true
  }, locale == 'fr' ? "প্রক্রিয়াধীন আবেদনসমূহ" : "Pending Applications", /*#__PURE__*/React.createElement(DescriptionIcon, {
    style: {
      verticalAlign: 'middle',
      marginRight: 8,
      "float": "right"
    }
  })), /*#__PURE__*/React.createElement(Filters, null), /*#__PURE__*/React.createElement("table", {
    cellPadding: "6px",
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React.createElement("tbody", null, pendingApplicationTypes.map(function (item) {
    return /*#__PURE__*/React.createElement("tr", {
      style: {
        paddingTop: "10px",
        paddingBottom: "10px"
      }
    }, /*#__PURE__*/React.createElement("th", {
      style: {
        textAlign: "left"
      }
    }, /*#__PURE__*/React.createElement(Typography, null, item.type)), /*#__PURE__*/React.createElement("td", {
      style: {
        textAlign: "right"
      }
    }, /*#__PURE__*/React.createElement(Link, {
      component: "button",
      variant: "body2",
      onClick: function onClick() {
        return handleOpenModal(item);
      }
    }, /*#__PURE__*/React.createElement(Typography, null, item.count))));
  }))), /*#__PURE__*/React.createElement(AgingReportModal, {
    open: openModal,
    onClose: handleCloseModal,
    data: selectedType,
    organizationType: filter.toLowerCase()
  })))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 4
  }, /*#__PURE__*/React.createElement(Card, {
    style: newCard
  }, /*#__PURE__*/React.createElement(CardContent, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5",
    gutterBottom: true
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "workforce.dashboard.applicant.types"
  }), /*#__PURE__*/React.createElement(PeopleAltIcon, {
    style: {
      verticalAlign: 'middle',
      marginRight: 8,
      "float": "right"
    }
  })), /*#__PURE__*/React.createElement(Filters, null), applicationCounts.map(function (item) {
    return /*#__PURE__*/React.createElement(Card, {
      style: _objectSpread$g(_objectSpread$g({}, newCard), {}, {
        margin: "10px",
        padding: "0px"
      })
    }, /*#__PURE__*/React.createElement(CardContent, null, /*#__PURE__*/React.createElement(Typography, null, item.type, /*#__PURE__*/React.createElement(PersonIcon, {
      style: {
        verticalAlign: 'middle',
        marginLeft: 8,
        "float": "right"
      }
    })), /*#__PURE__*/React.createElement(Typography, {
      variant: "h5"
    }, /*#__PURE__*/React.createElement("b", null, item.count))));
  })))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 4
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 2,
    style: {
      marginBottom: "10px"
    }
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 12
  }, /*#__PURE__*/React.createElement(Card, {
    style: newCard
  }, /*#__PURE__*/React.createElement(CardContent, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6",
    gutterBottom: true
  }, locale == 'fr' ? "মোট আবেদন" : "Total Applications", /*#__PURE__*/React.createElement(DescriptionIcon, {
    style: {
      verticalAlign: 'middle',
      marginRight: 8,
      "float": "right"
    }
  })), /*#__PURE__*/React.createElement(Filters, null), /*#__PURE__*/React.createElement("table", {
    cellPadding: "6px",
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React.createElement("tbody", null, applicationTypes.map(function (type) {
    return /*#__PURE__*/React.createElement("tr", {
      style: {
        paddingTop: "10px",
        paddingBottom: "10px"
      }
    }, /*#__PURE__*/React.createElement("th", {
      style: {
        textAlign: "left"
      }
    }, /*#__PURE__*/React.createElement(Typography, null, type.type)), /*#__PURE__*/React.createElement("td", {
      style: {
        textAlign: "right"
      }
    }, /*#__PURE__*/React.createElement(Typography, null, type.count)));
  })))))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 12
  }, /*#__PURE__*/React.createElement(Card, {
    style: newCard
  }, /*#__PURE__*/React.createElement(CardContent, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6",
    gutterBottom: true
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "workforce.dashboard.financial.info"
  }), /*#__PURE__*/React.createElement(LocalAtmIcon, {
    style: {
      verticalAlign: 'middle',
      marginRight: 8,
      "float": "right"
    }
  })), /*#__PURE__*/React.createElement(Filters, null), /*#__PURE__*/React.createElement(Card, {
    style: _objectSpread$g(_objectSpread$g({}, newCard), {}, {
      margin: "10px",
      padding: "0px"
    })
  }, /*#__PURE__*/React.createElement(CardContent, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "workforce.dashboard.total.beneficiary.amount"
  })), /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, /*#__PURE__*/React.createElement("b", null, "\u09F3 ", locale == 'fr' ? Number(totalBenefitAmount).toLocaleString('bn') : Number(totalBenefitAmount).toLocaleString('en')))))))))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 12
  }, /*#__PURE__*/React.createElement(Card, {
    style: _objectSpread$g(_objectSpread$g({}, newCard), {}, {
      overflow: "visible"
    }),
    sx: {
      borderRadius: "12px",
      boxShadow: 2
    }
  }, /*#__PURE__*/React.createElement(CardHeader, {
    title: /*#__PURE__*/React.createElement(Box$1, null, /*#__PURE__*/React.createElement(Typography, {
      variant: "h6",
      component: "div"
    }, locale == 'fr' ? "আবেদন প্রকার ম্যাট্রিক্স" : "Application Type Matrix"), /*#__PURE__*/React.createElement(Typography, {
      variant: "body2",
      color: "textSecondary"
    }, locale == 'fr' ? "বিস্তারিত আবেদনের প্রতিবেদন - ফান্ড প্রকার অনুসারে" : "Detailed Application Report - By Fund Type")),
    action: /*#__PURE__*/React.createElement(Filters, null)
  }), /*#__PURE__*/React.createElement(CardContent, null, /*#__PURE__*/React.createElement(Table$2, null, /*#__PURE__*/React.createElement(TableHead, null, /*#__PURE__*/React.createElement(TableRow, null, /*#__PURE__*/React.createElement(TableCell, {
    style: {
      fontWeight: "bold"
    }
  }, locale == 'fr' ? "মোট আবেদন" : "Total Applications"), /*#__PURE__*/React.createElement(TableCell, {
    align: "right",
    style: {
      fontWeight: "bold"
    }
  }, locale == 'fr' ? "আবেদনের প্রকার" : "Application Type"), /*#__PURE__*/React.createElement(TableCell, {
    align: "right",
    style: {
      fontWeight: "bold"
    }
  }, locale == 'fr' ? "অনুমোদিত/ সুপারিশকৃত" : "Approved/ Recommended"), /*#__PURE__*/React.createElement(TableCell, {
    align: "right",
    style: {
      fontWeight: "bold"
    }
  }, locale == 'fr' ? "বাতিল/ ফেরত" : "Reverted/ Rejected"), /*#__PURE__*/React.createElement(TableCell, {
    align: "right",
    style: {
      fontWeight: "bold"
    }
  }, locale == 'fr' ? "প্রক্রিয়াধীন" : "Processing"), /*#__PURE__*/React.createElement(TableCell, {
    align: "center",
    style: {
      fontWeight: "bold"
    }
  }, locale == 'fr' ? "বিস্তারিত" : "Detail"))), /*#__PURE__*/React.createElement(TableBody, null, tableRows.map(function (r, idx) {
    return /*#__PURE__*/React.createElement(TableRow, {
      key: idx,
      hover: true
    }, /*#__PURE__*/React.createElement(TableCell, null, r.type), /*#__PURE__*/React.createElement(TableCell, {
      align: "right"
    }, r.total), /*#__PURE__*/React.createElement(TableCell, {
      align: "right"
    }, r.approved), /*#__PURE__*/React.createElement(TableCell, {
      align: "right"
    }, r.cancelled), /*#__PURE__*/React.createElement(TableCell, {
      align: "right"
    }, r.processing), /*#__PURE__*/React.createElement(TableCell, {
      align: "center"
    }, /*#__PURE__*/React.createElement(Link, {
      component: "button",
      variant: "body2",
      onClick: function onClick() {
        // replace with real navigation
        console.log("বিস্তারিত:", r.type);
      },
      sx: {
        color: "#138a66"
      }
    }, locale == 'fr' ? "বিস্তারিত দেখুন" : "See Detail")));
  })), /*#__PURE__*/React.createElement(TableFooter, null, /*#__PURE__*/React.createElement(TableRow, null, /*#__PURE__*/React.createElement(TableCell, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle2"
  }, locale == 'fr' ? "মোট" : "Total")), /*#__PURE__*/React.createElement(TableCell, {
    align: "right"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle2",
    fontWeight: "bold"
  }, totals.total)), /*#__PURE__*/React.createElement(TableCell, {
    align: "right"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle2",
    fontWeight: "bold"
  }, totals.approved)), /*#__PURE__*/React.createElement(TableCell, {
    align: "right"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle2",
    fontWeight: "bold"
  }, totals.cancelled)), /*#__PURE__*/React.createElement(TableCell, {
    align: "right"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle2",
    fontWeight: "bold"
  }, totals.processing)), /*#__PURE__*/React.createElement(TableCell, null))))))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 7
  }, /*#__PURE__*/React.createElement(Card, {
    style: newCard,
    sx: {
      borderRadius: "16px",
      boxShadow: 3
    }
  }, /*#__PURE__*/React.createElement(CardHeader, {
    title: locale == 'fr' ? 'মাসিক ডেটা ওভারভিউ' : 'Monthly Data Overview',
    subheader: locale == 'fr' ? 'আবেদনের ধরণ অনুসারে' : 'By Application Type',
    action: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Card, {
      style: {
        padding: "10px",
        borderRadius: "12px"
      }
    }, /*#__PURE__*/React.createElement(Typography, {
      style: {
        textAlign: "center",
        fontWeight: "bold"
      }
    }, /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.select.time.range"
    })), /*#__PURE__*/React.createElement(ButtonGroup, {
      variant: "outlined",
      style: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
      }
    }, Object.entries(buttonOptions).map(function (_ref3) {
      var _ref4 = _slicedToArray(_ref3, 2),
        key = _ref4[0],
        label = _ref4[1];
      return /*#__PURE__*/React.createElement(Button, {
        key: key,
        variant: graphMonths === key ? "contained" : "outlined",
        onClick: function onClick() {
          return handleGraphMonthChange(key);
        }
      }, label);
    }))))
  }), /*#__PURE__*/React.createElement(CardContent, null, /*#__PURE__*/React.createElement(ResponsiveContainer, {
    width: "100%",
    height: 300
  }, /*#__PURE__*/React.createElement(BarChart, {
    data: barData
  }, /*#__PURE__*/React.createElement(CartesianGrid, {
    strokeDasharray: "3 3"
  }), /*#__PURE__*/React.createElement(XAxis, {
    dataKey: "month"
  }), /*#__PURE__*/React.createElement(YAxis, null), /*#__PURE__*/React.createElement(Tooltip$1, null), /*#__PURE__*/React.createElement(Legend, null), /*#__PURE__*/React.createElement(Bar, {
    dataKey: locale == 'fr' ? "চিকিৎসা" : "Medical",
    stackId: "a",
    fill: "#009688"
  }), /*#__PURE__*/React.createElement(Bar, {
    dataKey: locale == 'fr' ? "মৃত্যু" : "Death",
    stackId: "a",
    fill: "#90CAF9"
  }), /*#__PURE__*/React.createElement(Bar, {
    dataKey: locale == 'fr' ? "শিক্ষা" : "Educational",
    stackId: "a",
    fill: "#FBC02D"
  }), /*#__PURE__*/React.createElement(Bar, {
    dataKey: locale == 'fr' ? "মাতৃত্ব" : "Maternity",
    stackId: "a",
    fill: "#FF9800"
  }), /*#__PURE__*/React.createElement(Bar, {
    dataKey: locale == 'fr' ? "স্থায়ী ও অস্থায়ী অক্ষমতা" : "Permanent Or Curable Disability",
    stackId: "a",
    fill: "#212121"
  })))))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 5
  }, /*#__PURE__*/React.createElement(Card, {
    style: newCard,
    sx: {
      borderRadius: "16px",
      boxShadow: 3
    }
  }, /*#__PURE__*/React.createElement(CardHeader, {
    title: locale == 'fr' ? 'আবেদনের অবস্থা' : 'Application Status',
    subheader: locale == 'fr' ? 'একনজরে আবেদনসমূহের অবস্থা' : 'Status At a Glance',
    action: /*#__PURE__*/React.createElement(Filters, null)
  }), /*#__PURE__*/React.createElement(CardContent, null, /*#__PURE__*/React.createElement(ResponsiveContainer, {
    width: "100%",
    height: 300
  }, /*#__PURE__*/React.createElement(PieChart, null, /*#__PURE__*/React.createElement(Pie, {
    data: pieData,
    dataKey: "value",
    nameKey: "name",
    innerRadius: 60,
    outerRadius: 100,
    label: true
  }, pieData.map(function (entry, index) {
    return /*#__PURE__*/React.createElement(Cell, {
      key: "cell-".concat(index),
      fill: entry.color
    });
  })), /*#__PURE__*/React.createElement(Tooltip$1, null), /*#__PURE__*/React.createElement(Legend, {
    verticalAlign: "bottom",
    align: "center",
    iconType: "circle" // optional: circle, square, line
    ,
    layout: "horizontal"
  }))))))));
};
var SecretaryDashboardPage = function SecretaryDashboardPage() {
  var reduxState = useSelector(function (state) {
    return state;
  });
  var user_rights = reduxState.core.user.i_user.rights;
  var approvedTextId = getUserTypeFromRights(user_rights) === WORKFORCE_USER_TYPE.DIRECTOR ? "workforce.application.forwarded" : "workforce.application.approved";
  var SidebarMenu = [{
    id: "dashboard",
    text: /*#__PURE__*/React.createElement(FormattedMessage, {
      module: "workforce",
      id: "workforce.application.dashboard"
    }),
    icon: /*#__PURE__*/React.createElement(DashboardIcon, null)
  }, {
    id: "waitingApplications",
    text: /*#__PURE__*/React.createElement(FormattedMessage, {
      module: "workforce",
      id: "workforce.employee.application.meetingSheet"
    }),
    icon: /*#__PURE__*/React.createElement(DashboardIcon, null)
  }, {
    id: "rejectedApplications",
    text: /*#__PURE__*/React.createElement(FormattedMessage, {
      module: "workforce",
      id: "workforce.application.rejectedApplication"
    }),
    icon: /*#__PURE__*/React.createElement(DashboardIcon, null)
  }, {
    id: "approvedApplications",
    text: /*#__PURE__*/React.createElement(FormattedMessage, {
      module: "workforce",
      id: approvedTextId
    }),
    icon: /*#__PURE__*/React.createElement(DashboardIcon, null)
  }, {
    id: "returnedApplications",
    text: /*#__PURE__*/React.createElement(FormattedMessage, {
      module: "workforce",
      id: "workforce.application.returned"
    }),
    icon: /*#__PURE__*/React.createElement(DashboardIcon, null)
  }];
  useTheme();
  var classes = useStyles$h();
  useDispatch();
  useModulesManager();
  var _useState43 = useState("dashboard"),
    _useState44 = _slicedToArray(_useState43, 2),
    selectedMenu = _useState44[0],
    setSelectedMenu = _useState44[1];
  var urlParams = new URLSearchParams(window.location.search);
  var status = urlParams.get("status");
  useEffect(function () {
    if (status) {
      switch (status) {
        case "pending":
          setSelectedMenu("waitingApplications");
          break;
        case "approved":
          setSelectedMenu("approvedApplications");
          break;
        case "rejected":
          setSelectedMenu("rejectedApplications");
          break;
        case "returnedApplications":
          setSelectedMenu("returnedApplications");
          break;
        default:
          setSelectedMenu("dashboard");
      }
    }
  }, [status]);
  var renderContent = function renderContent() {
    switch (selectedMenu) {
      case "dashboard":
        return /*#__PURE__*/React.createElement(Dashboard, null);
      case "waitingApplications":
        return /*#__PURE__*/React.createElement(ApplicationSummaryPage$1, {
          status: "pending"
        });
      case "rejectedApplications":
        return /*#__PURE__*/React.createElement(RejectApplication, null);
      case "approvedApplications":
        return /*#__PURE__*/React.createElement(ApplicationSummaryPage$1, {
          status: "approved",
          disableButtons: 1
        });
      case "returnedApplications":
        return /*#__PURE__*/React.createElement(ReturnedApplications, null);
      default:
        return /*#__PURE__*/React.createElement(Dashboard, null);
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: classes.root
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 2,
    className: classes.root
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 3,
    className: classes.sidebar
  }, /*#__PURE__*/React.createElement(Paper, {
    className: classes.sidebar
  }, /*#__PURE__*/React.createElement(List, null, SidebarMenu.map(function (item) {
    return /*#__PURE__*/React.createElement(ListItem, {
      button: true,
      key: item.id,
      selected: selectedMenu === item.id,
      onClick: function onClick() {
        return setSelectedMenu(item.id);
      }
    }, /*#__PURE__*/React.createElement(ListItemIcon, null, item.icon), /*#__PURE__*/React.createElement(ListItemText, {
      primary: item.text
    }));
  })))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 9,
    className: classes.content
  }, renderContent())));
};

var useStyles$g = makeStyles(function (theme) {
  return {
    root: {
      flexGrow: 1,
      padding: theme.spacing(2),
      height: 'calc(100vh - 64px)',
      // assuming 64px header/appbar, adjust as needed
      overflow: 'visible'
    },
    sidebar: {
      position: "sticky",
      top: 0,
      height: "70vh",
      backgroundColor: theme.palette.background.paper,
      borderRight: "1px solid ".concat(theme.palette.divider),
      overflowY: "auto"
    },
    content: {
      height: '100vh',
      overflowY: 'auto',
      padding: theme.spacing(2)
    },
    tableContainer: {
      marginTop: theme.spacing(0)
    },
    tableHeadCell: {
      fontWeight: "bold"
    },
    noData: {
      textAlign: "center",
      padding: theme.spacing(2)
    },
    searchInput: {
      border: "1px solid #ccc",
      borderRadius: 4,
      padding: "4px 8px",
      width: 200
    },
    pagination: {
      display: "flex",
      justifyContent: "flex-end",
      marginTop: theme.spacing(2),
      alignItems: "center"
    },
    tableHeader: {
      backgroundColor: "#B7D4D8"
    },
    accordion: {
      boxShadow: "1px 1px 1px 1px",
      border: "none",
      backgroundColor: "white",
      marginBottom: "12px",
      borderRadius: "6px",
      "&::before": {
        display: "none"
      }
    },
    accordionSummary: {
      padding: "8px 16px",
      backgroundColor: "white",
      borderRadius: "6px",
      "& .MuiTypography-root": {
        color: "#015C63",
        // teal-like tone
        fontWeight: 600
      }
    },
    accordionDetails: {
      backgroundColor: "white",
      padding: "16px",
      borderTop: "1px solid #ddd"
    }
  };
});
var SidebarMenu = [{
  id: "approveMeetingSheet",
  text: /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.employee.application.approveMeetingSheet"
  }),
  icon: /*#__PURE__*/React.createElement(CheckCircleOutlineTwoToneIcon, null)
}, {
  id: "applicationStatus",
  text: /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.application.status"
  }),
  icon: /*#__PURE__*/React.createElement(AssignmentIcon, null)
}];

// ----------- Components to Render in Main Content -----------

var ApprovedApplications = function ApprovedApplications(_ref) {
  var _ref$summaryData = _ref.summaryData,
    summaryData = _ref$summaryData === void 0 ? [] : _ref$summaryData,
    _ref$disableButtons = _ref.disableButtons,
    disableButtons = _ref$disableButtons === void 0 ? 0 : _ref$disableButtons;
  var classes = useStyles$g();
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    expanded = _useState2[0],
    setExpanded = _useState2[1];
  var handleChange = function handleChange(panelId) {
    return function (event, isExpanded) {
      setExpanded(isExpanded ? panelId : null);
    };
  };
  console.log("clear");
  console.log("summary data", summaryData);
  return /*#__PURE__*/React.createElement("div", {
    className: classes.accordionPadding
  }, summaryData.map(function (item, index) {
    return /*#__PURE__*/React.createElement(Accordion, {
      key: index,
      expanded: expanded === item.id,
      onChange: handleChange(item.id),
      className: classes.accordion
    }, /*#__PURE__*/React.createElement(AccordionSummary, {
      className: classes.accordionSummary,
      expandIcon: /*#__PURE__*/React.createElement(ExpandMoreIcon, {
        className: "material-icons"
      })
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "subtitle1",
      style: {
        flex: 1
      }
    }, /*#__PURE__*/React.createElement("strong", null, item.name)), /*#__PURE__*/React.createElement(Typography, {
      variant: "body2",
      style: {
        marginLeft: "auto",
        color: "#015C63"
      }
    }, item.meetingDate, " | ", item.month, " ", item.year)), /*#__PURE__*/React.createElement(AccordionDetails, {
      className: classes.accordionDetails
    }, /*#__PURE__*/React.createElement(Card, {
      style: {
        width: "100%"
      }
    }, /*#__PURE__*/React.createElement(CardContent, null, expanded === item.id && /*#__PURE__*/React.createElement(ApplicationProcessSearcher$1, {
      summaryId: item.id,
      disableButtons: disableButtons
    })))));
  }));
};
var ApplicationStatus = function ApplicationStatus() {
  var dispatch = useDispatch();
  var mm = useModulesManager();
  var _useState3 = useState(""),
    _useState4 = _slicedToArray(_useState3, 2),
    nid = _useState4[0],
    setNid = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    showResult = _useState6[0],
    setShowResult = _useState6[1];
  var _useState7 = useState(null),
    _useState8 = _slicedToArray(_useState7, 2);
    _useState8[0];
    var setApplicationData = _useState8[1];
  var classes = useStyles$g();
  var _useState9 = useState(true),
    _useState10 = _slicedToArray(_useState9, 2),
    hasResults = _useState10[0],
    setHasResults = _useState10[1];
  var handleApplicationSearch = function handleApplicationSearch() {
    var filters = ["workforceEmployee_Nid: \"".concat(nid, "\"")];
    dispatch(fetchApplicationsSummary(mm, filters)).then(function (res) {
      var _res$payload;
      var edges = ((_res$payload = res.payload) === null || _res$payload === void 0 || (_res$payload = _res$payload.data) === null || _res$payload === void 0 || (_res$payload = _res$payload.workforceApplication) === null || _res$payload === void 0 ? void 0 : _res$payload.edges) || [];
      setApplicationData(edges.map(function (e) {
        return e.node;
      }));
      setShowResult(true);
    });
  };
  return /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(CardContent, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5",
    gutterBottom: true
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.application.status"
  })), /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 2,
    justifyContent: "center",
    style: {
      marginTop: 16,
      padding: "32px",
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 6
  }, /*#__PURE__*/React.createElement(TextField, {
    fullWidth: true,
    variant: "outlined",
    size: "small",
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      module: "workforce",
      id: "workforce.representative.nid"
    }),
    value: nid,
    onChange: function onChange(e) {
      return setNid(e.target.value);
    },
    style: {
      marginBottom: 16
    }
  }), /*#__PURE__*/React.createElement(Button, {
    variant: "contained",
    color: "primary",
    fullWidth: true,
    onClick: handleApplicationSearch
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.search.here"
  })))), showResult && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Card, {
    className: classes.tableContainer,
    style: {
      marginTop: 10
    }
  }, /*#__PURE__*/React.createElement(CardContent, null, /*#__PURE__*/React.createElement(ApplicationProcessSearcher$1, {
    nidFilters: ["workforceEmployee_Nid: \"".concat(nid, "\"")],
    onDataLoaded: function onDataLoaded(data) {
      return setHasResults(data && data.length > 0);
    },
    disableButtons: 1
  }))), !hasResults && /*#__PURE__*/React.createElement(Typography, {
    color: "error",
    style: {
      marginTop: 32
    }
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.tracking.notfound",
    defaultMessage: "\u0995\u09CB\u09A8\u09CB \u0986\u09AC\u09C7\u09A6\u09A8 \u09AA\u09BE\u0993\u09AF\u09BC\u09BE \u09AF\u09BE\u09AF\u09BC\u09A8\u09BF\u0964"
  })))));
};

// ------------------------------------------------------------

var BlwfAccountantDashboardPage = function BlwfAccountantDashboardPage() {
  var classes = useStyles$g();
  var dispatch = useDispatch();
  var modulesManager = useModulesManager();
  var _useState11 = useState("pendingApplications"),
    _useState12 = _slicedToArray(_useState11, 2),
    selectedMenu = _useState12[0],
    setSelectedMenu = _useState12[1]; // Default first menu
  useEffect(function () {
    return dispatch(fetchSummaryApplications(modulesManager, ['status:"approved_by_dg"', 'organizationType:"blwf"']));
  }, []);
  var data = useSelector(function (state) {
    var _state$workforce;
    return (_state$workforce = state.workforce["applicationsSummary"]) !== null && _state$workforce !== void 0 ? _state$workforce : [];
  });
  data.filter(function (d) {
    return d.status !== "approved_by_dg";
  });
  var approvedSummaryData = data.filter(function (d) {
    return d.status === "approved_by_dg";
  });
  data.filter(function (d) {
    return d.status === "forward_to_comiitee";
  });
  var renderContent = function renderContent() {
    switch (selectedMenu) {
      case "approveMeetingSheet":
        return /*#__PURE__*/React.createElement(ApprovedApplications, {
          summaryData: approvedSummaryData,
          disableButtons: 1
        });
      case "applicationStatus":
        return /*#__PURE__*/React.createElement(ApplicationStatus, null);
      // case "beneficiaryReportSheet":
      //   return <BeneficiaryReportSheet />;
      default:
        return /*#__PURE__*/React.createElement(ApprovedApplications, {
          summaryData: approvedSummaryData,
          disableButtons: 1
        });
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: classes.root
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 2,
    className: classes.root
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 3
  }, /*#__PURE__*/React.createElement(Paper, {
    className: classes.sidebar
  }, /*#__PURE__*/React.createElement(List, null, SidebarMenu.map(function (item) {
    return /*#__PURE__*/React.createElement(ListItem, {
      button: true,
      key: item.id,
      selected: selectedMenu === item.id,
      onClick: function onClick() {
        return setSelectedMenu(item.id);
      }
    }, /*#__PURE__*/React.createElement(ListItemIcon, null, item.icon), /*#__PURE__*/React.createElement(ListItemText, {
      primary: item.text
    }));
  })))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 9,
    className: classes.content
  }, renderContent())));
};

var DashboardRelay = function DashboardRelay() {
  var user_type = getUserType();
  console.log("userTpe", user_type);
  if (user_type === WORKFORCE_USER_TYPE.APPLICANT) {
    return /*#__PURE__*/React.createElement(ApplicantDashboard, null);
  } else if (user_type === WORKFORCE_USER_TYPE.CHECKER || user_type === WORKFORCE_USER_TYPE.CHECKER_TWO || user_type === WORKFORCE_USER_TYPE.BLWF_CHECKER || user_type === WORKFORCE_USER_TYPE.BLWF_DOL_DIFE || user_type === WORKFORCE_USER_TYPE.EIS_OFFICER) {
    return /*#__PURE__*/React.createElement(CheckerDashboard, null);
  } else if (user_type === WORKFORCE_USER_TYPE.SEC1_DEPUTI_ASST_DIRECTOR || user_type === WORKFORCE_USER_TYPE.SEC2_DEPUTI_ASST_DIRECTOR || user_type === WORKFORCE_USER_TYPE.BLWF_DEPUTI_ASST_DIRECTOR) {
    return /*#__PURE__*/React.createElement(DeputyAsstDirectorDashboardPage, null);
  } else if (user_type === WORKFORCE_USER_TYPE.SECTION_ADMIN) {
    return /*#__PURE__*/React.createElement(SectionAdminDashboard, null);
  } else if (user_type === WORKFORCE_USER_TYPE.SECTION_ADMIN_TWO) {
    return /*#__PURE__*/React.createElement(SectionTwoAdminDashboardPage, null);
  } else if (user_type === WORKFORCE_USER_TYPE.BLWF_SECTION_ADMIN) {
    return /*#__PURE__*/React.createElement(BlwfSectionAdminDashboard, null);
  } else if (user_type === WORKFORCE_USER_TYPE.DOCTOR || user_type === WORKFORCE_USER_TYPE.BLWF_DOCTOR || user_type === WORKFORCE_USER_TYPE.EIS_DOCTOR) {
    return /*#__PURE__*/React.createElement(DoctorDashboard, null);
  } else if (user_type === WORKFORCE_USER_TYPE.APPROVER) {
    return /*#__PURE__*/React.createElement(ApproverDashboard, null);
  } else if (user_type === WORKFORCE_USER_TYPE.BLWF_APPROVER) {
    return /*#__PURE__*/React.createElement(BlwfApproverDashboard, null);
  } else if (user_type === WORKFORCE_USER_TYPE.ADMIN || user_type === WORKFORCE_USER_TYPE.DIRECTOR || user_type === WORKFORCE_USER_TYPE.BLWF_DIRECTOR) {
    return /*#__PURE__*/React.createElement(DashboardPage, null);
  } else if (user_type === WORKFORCE_USER_TYPE.BGMEA_ASSOCIATION || user_type === WORKFORCE_USER_TYPE.BKMEA_ASSOCIATION || user_type === WORKFORCE_USER_TYPE.BEPZA_ASSOCIATION || user_type === WORKFORCE_USER_TYPE.LFMEAB_ASSOCIATION) {
    return /*#__PURE__*/React.createElement(AssociationDashboard, null);
  } else if (user_type === WORKFORCE_USER_TYPE.ASSOCIATION) {
    return /*#__PURE__*/React.createElement(AssociationDashboard, null);
  } else if (user_type === WORKFORCE_USER_TYPE.FACTORY_ADMIN) {
    return /*#__PURE__*/React.createElement(FactoryAdminDashboard, null);
  } else if (user_type === WORKFORCE_USER_TYPE.EIS_COORDINATOR) {
    return /*#__PURE__*/React.createElement(EisCoordinatorDashboardPage, null);
  } else if (user_type === WORKFORCE_USER_TYPE.EIS_COMMITTEE || user_type === WORKFORCE_USER_TYPE.EIS_ASSOCIATION_COMMITTEE) {
    return /*#__PURE__*/React.createElement(EisCommitteeDashboardPage, null);
  } else if (user_type === WORKFORCE_USER_TYPE.EIS_FINANCIAL_OFFICER) {
    return /*#__PURE__*/React.createElement(EisFinancialOfficerDashboard, null);
  } else if (user_type === WORKFORCE_USER_TYPE.EIS_ADVISOR) {
    return /*#__PURE__*/React.createElement(EISAdvisorDashboardPage, null);
  } else if (user_type === WORKFORCE_USER_TYPE.SECRETARY || user_type === WORKFORCE_USER_TYPE.MINISTER) {
    return /*#__PURE__*/React.createElement(SecretaryDashboardPage, null);
  } else if (user_type === WORKFORCE_USER_TYPE.BLWF_ACCOUNTANT) {
    return /*#__PURE__*/React.createElement(BlwfAccountantDashboardPage, null);
  } else {
    return /*#__PURE__*/React.createElement(FactoryAdminDashboard, null);
  }
};

var styles$9 = function styles(theme) {
  return {
    root: {
      display: "flex",
      justifyContent: "flex-start",
      alignItems: "center",
      padding: theme.spacing(1),
      backgroundColor: "transparent",
      gap: theme.spacing(2)
    },
    item: {
      display: "flex",
      alignItems: "center",
      gap: theme.spacing(0.5),
      cursor: "pointer",
      padding: "7px",
      borderRadius: "10px",
      "&:hover": {
        backgroundColor: "#517688",
        color: "#fff"
      }
    },
    label: {
      fontWeight: 500,
      fontSize: "0.875rem"
    }
  };
};
var NotificationBar = function NotificationBar(_ref) {
  var _status_count$pending, _status_count$rejecte, _status_count$approve, _status_count$pending2, _status_count$rejecte2, _status_count$approve2, _status_count$pending3, _status_count$rejecte3, _status_count$reverte, _status_count$pending4, _status_count$rejecte4, _status_count$reverte2, _status_count$pending5, _status_count$rejecte5, _status_count$reverte3, _status_count$pending6, _status_count$rejecte6, _status_count$reverte4, _status_count$pending7, _status_count$pending8, _status_count$pending9, _status_count$pending10;
  var classes = _ref.classes;
  var user_type = getUserType();
  var history = useHistory();
  var dispatch = useDispatch();
  useSelector(function (state) {
    return state.core.user.i_user;
  });
  useEffect(function () {
    return dispatch(fetchWorkforceApplicationStatusCount());
  }, []);
  var status_count = useSelector(function (state) {
    return state.workforce["workforceApplicationStatusCount"];
  });
  console.log("Status Count in NotificationBar:", status_count);
  var status_data = {
    pending: (status_count === null || status_count === void 0 || (_status_count$pending = status_count.pending) === null || _status_count$pending === void 0 ? void 0 : _status_count$pending.totalCount) || 0,
    rejected: (status_count === null || status_count === void 0 || (_status_count$rejecte = status_count.rejected) === null || _status_count$rejecte === void 0 ? void 0 : _status_count$rejecte.totalCount) || 0,
    approved: (status_count === null || status_count === void 0 || (_status_count$approve = status_count.approved) === null || _status_count$approve === void 0 ? void 0 : _status_count$approve.totalCount) || 0,
    pendingForDirector: (status_count === null || status_count === void 0 || (_status_count$pending2 = status_count.pendingForDirector) === null || _status_count$pending2 === void 0 ? void 0 : _status_count$pending2.totalCount) || 0,
    rejectedForDirector: (status_count === null || status_count === void 0 || (_status_count$rejecte2 = status_count.rejectedForDirector) === null || _status_count$rejecte2 === void 0 ? void 0 : _status_count$rejecte2.totalCount) || 0,
    approvedForDirector: (status_count === null || status_count === void 0 || (_status_count$approve2 = status_count.approvedForDirector) === null || _status_count$approve2 === void 0 ? void 0 : _status_count$approve2.totalCount) || 0,
    pendingForFactoryAdmin: (status_count === null || status_count === void 0 || (_status_count$pending3 = status_count.pendingForFactoryAdmin) === null || _status_count$pending3 === void 0 ? void 0 : _status_count$pending3.totalCount) || 0,
    rejectedForFactoryAdmin: (status_count === null || status_count === void 0 || (_status_count$rejecte3 = status_count.rejectedForFactoryAdmin) === null || _status_count$rejecte3 === void 0 ? void 0 : _status_count$rejecte3.totalCount) || 0,
    revertedForFactoryAdmin: (status_count === null || status_count === void 0 || (_status_count$reverte = status_count.revertedForFactoryAdmin) === null || _status_count$reverte === void 0 ? void 0 : _status_count$reverte.totalCount) || 0,
    pendingForBGMEAAssociation: (status_count === null || status_count === void 0 || (_status_count$pending4 = status_count.pendingForBGMEAAssociation) === null || _status_count$pending4 === void 0 ? void 0 : _status_count$pending4.totalCount) || 0,
    rejectedForBGMEAAssociation: (status_count === null || status_count === void 0 || (_status_count$rejecte4 = status_count.rejectedForBGMEAAssociation) === null || _status_count$rejecte4 === void 0 ? void 0 : _status_count$rejecte4.totalCount) || 0,
    revertedForBGMEAAssociation: (status_count === null || status_count === void 0 || (_status_count$reverte2 = status_count.revertedForBGMEAAssociation) === null || _status_count$reverte2 === void 0 ? void 0 : _status_count$reverte2.totalCount) || 0,
    pendingForBKMEAAssociation: (status_count === null || status_count === void 0 || (_status_count$pending5 = status_count.pendingForBKMEAAssociation) === null || _status_count$pending5 === void 0 ? void 0 : _status_count$pending5.totalCount) || 0,
    rejectedForBKMEAAssociation: (status_count === null || status_count === void 0 || (_status_count$rejecte5 = status_count.rejectedForBKMEAAssociation) === null || _status_count$rejecte5 === void 0 ? void 0 : _status_count$rejecte5.totalCount) || 0,
    revertedForBKMEAAssociation: (status_count === null || status_count === void 0 || (_status_count$reverte3 = status_count.revertedForBKMEAAssociation) === null || _status_count$reverte3 === void 0 ? void 0 : _status_count$reverte3.totalCount) || 0,
    pendingForSectionAdmin: (status_count === null || status_count === void 0 || (_status_count$pending6 = status_count.pendingForSectionAdmin) === null || _status_count$pending6 === void 0 ? void 0 : _status_count$pending6.totalCount) || 0,
    rejectedForSectionAdmin: (status_count === null || status_count === void 0 || (_status_count$rejecte6 = status_count.rejectedForSectionAdmin) === null || _status_count$rejecte6 === void 0 ? void 0 : _status_count$rejecte6.totalCount) || 0,
    revertedForSectionAdmin: (status_count === null || status_count === void 0 || (_status_count$reverte4 = status_count.revertedForSectionAdmin) === null || _status_count$reverte4 === void 0 ? void 0 : _status_count$reverte4.totalCount) || 0,
    pendingForChecker: (status_count === null || status_count === void 0 || (_status_count$pending7 = status_count.pendingForChecker) === null || _status_count$pending7 === void 0 ? void 0 : _status_count$pending7.totalCount) || 0,
    pendingForCheckerTwo: (status_count === null || status_count === void 0 || (_status_count$pending8 = status_count.pendingForCheckerTwo) === null || _status_count$pending8 === void 0 ? void 0 : _status_count$pending8.totalCount) || 0,
    pendingForDoctor: (status_count === null || status_count === void 0 || (_status_count$pending9 = status_count.pendingForDoctor) === null || _status_count$pending9 === void 0 ? void 0 : _status_count$pending9.totalCount) || 0,
    pendingForApprover: (status_count === null || status_count === void 0 || (_status_count$pending10 = status_count.pendingForApprover) === null || _status_count$pending10 === void 0 ? void 0 : _status_count$pending10.totalCount) || 0
  };
  var data = [];
  var approveLabel = user_type === WORKFORCE_USER_TYPE.DIRECTOR ? "workforce.application.process.forwarded" : "workforce.application.process.approved";
  if (user_type === WORKFORCE_USER_TYPE.APPLICANT) {
    return /*#__PURE__*/React.createElement(React.Fragment, null);
  }
  if (user_type === WORKFORCE_USER_TYPE.DIRECTOR) {
    data.pending = status_data.pendingForDirector;
    data.rejected = status_data.rejectedForDirector;
    data.approved = status_data.approvedForDirector;
  } else if (user_type === WORKFORCE_USER_TYPE.ADMIN) {
    data.pending = status_data.pending;
    data.rejected = status_data.rejected;
    data.approved = status_data.approved;
  } else if (user_type === WORKFORCE_USER_TYPE.FACTORY_ADMIN) {
    data.pending = status_data.pendingForFactoryAdmin;
    data.rejected = status_data.rejectedForFactoryAdmin;
    data.revert = status_data.revertedForFactoryAdmin;
  } else if (user_type === WORKFORCE_USER_TYPE.BGMEA_ASSOCIATION) {
    data.pending = status_data.pendingForBGMEAAssociation;
    data.rejected = status_data.rejectedForBGMEAAssociation;
    data.revert = status_data.revertedForBGMEAAssociation;
  } else if (user_type === WORKFORCE_USER_TYPE.BKMEA_ASSOCIATION) {
    data.pending = status_data.pendingForBKMEAAssociation;
    data.rejected = status_data.rejectedForBKMEAAssociation;
    data.revert = status_data.revertedForBKMEAAssociation;
  } else if (user_type === WORKFORCE_USER_TYPE.SECTION_ADMIN) {
    data.pending = status_data.pendingForSectionAdmin;
    data.rejected = status_data.rejectedForSectionAdmin;
    data.revert = status_data.revertedForSectionAdmin;
  } else if (user_type === WORKFORCE_USER_TYPE.CHECKER) {
    data.pending = status_data.pendingForChecker;
  } else if (user_type === WORKFORCE_USER_TYPE.CHECKER_TWO) {
    data.pending = status_data.pendingForCheckerTwo;
  } else if (user_type === WORKFORCE_USER_TYPE.DOCTOR) {
    data.pending = status_data.pendingForDoctor;
  } else if (user_type === WORKFORCE_USER_TYPE.APPROVER) {
    data.pending = status_data.pendingForApprover;
  }
  return /*#__PURE__*/React.createElement(Box$1, {
    className: classes.root
  }, (user_type === WORKFORCE_USER_TYPE.ADMIN || user_type === WORKFORCE_USER_TYPE.DIRECTOR) && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Tooltip, {
    title: "Pending Applications"
  }, /*#__PURE__*/React.createElement(Box$1, {
    className: classes.item,
    onClick: function onClick() {
      return history.push("/home?status=pending");
    }
    // onClick={() => history.push("/workforce/applications/process?status=pending")}
  }, /*#__PURE__*/React.createElement(Badge, {
    badgeContent: data.pending || 0,
    color: "primary"
  }, /*#__PURE__*/React.createElement(HourglassEmptyIcon, {
    color: "yellow"
  })), /*#__PURE__*/React.createElement(Typography, {
    className: classes.label
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.application.process.pending"
  })))), /*#__PURE__*/React.createElement(Tooltip, {
    title: "Rejected Applications"
  }, /*#__PURE__*/React.createElement(Box$1, {
    className: classes.item
    // onClick={() => history.push("/workforce/applications/process?status=rejected")}
    ,
    onClick: function onClick() {
      return history.push("/home?status=rejected");
    }
  }, /*#__PURE__*/React.createElement(Badge, {
    badgeContent: data.rejected || 0,
    color: "primary"
  }, /*#__PURE__*/React.createElement(RestorePageIcon, {
    color: "red"
  })), /*#__PURE__*/React.createElement(Typography, {
    className: classes.label
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.application.process.rejected"
  })))), /*#__PURE__*/React.createElement(Tooltip, {
    title: "Verified Applications"
  }, /*#__PURE__*/React.createElement(Box$1, {
    className: classes.item,
    onClick: function onClick() {
      return history.push("/home?status=approved");
    }
    // onClick={() => history.push("/workforce/applications/process?status=approved")}
  }, /*#__PURE__*/React.createElement(Badge, {
    badgeContent: data.approved || 0,
    color: "primary"
  }, /*#__PURE__*/React.createElement(VerifiedUserIcon, {
    style: {
      color: "#4caf50"
    }
  })), /*#__PURE__*/React.createElement(Typography, {
    className: classes.label
  }, "  ", /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: approveLabel
  }))))), (user_type === WORKFORCE_USER_TYPE.FACTORY_ADMIN || user_type === WORKFORCE_USER_TYPE.BGMEA_ASSOCIATION || user_type === WORKFORCE_USER_TYPE.BKMEA_ASSOCIATION || user_type === WORKFORCE_USER_TYPE.DOCTOR) && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Tooltip, {
    title: "Pending Applications"
  }, /*#__PURE__*/React.createElement(Box$1, {
    className: classes.item
  }, /*#__PURE__*/React.createElement(Badge, {
    badgeContent: data.pending || 0,
    color: "primary"
  }, /*#__PURE__*/React.createElement(HourglassEmptyIcon, {
    color: "yellow"
  })), /*#__PURE__*/React.createElement(Typography, {
    className: classes.label
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.application.process.pending"
  })))), /*#__PURE__*/React.createElement(Tooltip, {
    title: "Rejected Applications"
  }, /*#__PURE__*/React.createElement(Box$1, {
    className: classes.item
  }, /*#__PURE__*/React.createElement(Badge, {
    badgeContent: data.rejected || 0,
    color: "primary"
  }, /*#__PURE__*/React.createElement(RestorePageIcon, {
    color: "red"
  })), /*#__PURE__*/React.createElement(Typography, {
    className: classes.label
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.application.process.rejected"
  })))), /*#__PURE__*/React.createElement(Tooltip, {
    title: "Reverted Applications"
  }, /*#__PURE__*/React.createElement(Box$1, {
    className: classes.item
  }, /*#__PURE__*/React.createElement(Badge, {
    badgeContent: data.revert || 0,
    color: "primary"
  }, /*#__PURE__*/React.createElement(VerifiedUserIcon, {
    style: {
      color: "#4caf50"
    }
  })), /*#__PURE__*/React.createElement(Typography, {
    className: classes.label
  }, "  ", /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.application.process.reverted"
  }))))), user_type === WORKFORCE_USER_TYPE.SECTION_ADMIN && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Tooltip, {
    title: "Pending Applications"
  }, /*#__PURE__*/React.createElement(Box$1, {
    className: classes.item
  }, /*#__PURE__*/React.createElement(Badge, {
    badgeContent: data.pending || 0,
    color: "primary"
  }, /*#__PURE__*/React.createElement(HourglassEmptyIcon, {
    color: "yellow"
  })), /*#__PURE__*/React.createElement(Typography, {
    className: classes.label
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.application.process.pending"
  })))), /*#__PURE__*/React.createElement(Tooltip, {
    title: "Rejected Applications"
  }, /*#__PURE__*/React.createElement(Box$1, {
    className: classes.item
  }, /*#__PURE__*/React.createElement(Badge, {
    badgeContent: data.rejected || 0,
    color: "primary"
  }, /*#__PURE__*/React.createElement(RestorePageIcon, {
    color: "red"
  })), /*#__PURE__*/React.createElement(Typography, {
    className: classes.label
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.application.process.rejected"
  }))))), (user_type === WORKFORCE_USER_TYPE.DOCTOR || user_type === WORKFORCE_USER_TYPE.CHECKER || user_type === WORKFORCE_USER_TYPE.CHECKER_TWO || user_type === WORKFORCE_USER_TYPE.APPROVER) && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Tooltip, {
    title: "Pending Applications"
  }, /*#__PURE__*/React.createElement(Box$1, {
    className: classes.item
  }, /*#__PURE__*/React.createElement(Badge, {
    badgeContent: data.pending || 0,
    color: "primary"
  }, /*#__PURE__*/React.createElement(HourglassEmptyIcon, {
    color: "yellow"
  })), /*#__PURE__*/React.createElement(Typography, {
    className: classes.label
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.application.process.pending"
  }))))));
};
withStyles(styles$9)(NotificationBar);

var CustomConfirmModal = function CustomConfirmModal(_ref) {
  var open = _ref.open,
    message = _ref.message,
    _onClose = _ref.onClose,
    onConfirm = _ref.onConfirm;
  var modulesManager = useModulesManager();
  var _useTranslations = useTranslations("core.RegistrationPage", modulesManager);
    _useTranslations.formatMessage;
  return /*#__PURE__*/React.createElement(Modal, {
    open: open,
    onClose: function onClose() {
      return _onClose();
    }
  }, /*#__PURE__*/React.createElement(Box$1, {
    sx: {
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      width: 400,
      bgcolor: "background.paper",
      borderRadius: 2,
      boxShadow: 24,
      p: 4,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6",
    gutterBottom: true
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "".concat(message),
    module: "workforce"
  }) || "Are you sure?"), /*#__PURE__*/React.createElement(Box$1, {
    sx: {
      mt: 3,
      display: "flex",
      justifyContent: "space-around"
    }
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "contained",
    color: "secondary",
    onClick: function onClick() {
      return _onClose();
    } // cancel
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "workforce.confirm.modal.cancel",
    module: "workforce"
  }) || "Are you sure?"), /*#__PURE__*/React.createElement(Button, {
    variant: "contained",
    color: "primary",
    onClick: function onClick() {
      _onClose();
      onConfirm();
    } // ok
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: isEisPath() ? "workforce.confirm.modal.ok" : "workforce.confirm.modal.ok.notEis",
    module: "workforce"
  }) || "Are you sure?"))));
};

function ownKeys$f(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$f(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$f(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$f(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper$8(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$8() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$8() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$8 = function _isNativeReflectConstruct() { return !!t; })(); }
var styles$8 = function styles(theme) {
  return {
    paper: {
      padding: theme.spacing(1),
      width: 700,
      margin: "0 auto"
    },
    container: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center"
    },
    title: {
      fontSize: "medium",
      fontWeight: "bold"
    },
    fullHeight: {
      height: "100%"
    },
    overrideReadOnly: {
      "& .Mui-disabled": {
        color: "".concat(theme.palette.text.primary, " !important")
      }
    },
    rootGrid: {
      minHeight: "calc(100vh - 64px)",
      overflowY: "auto",
      paddingBottom: theme.spacing(4)
    },
    leftGrid: {
      position: "sticky",
      top: 0,
      height: "100%",
      overflowY: "auto",
      paddingRight: 8
    },
    rightGrid: {
      height: "100%",
      overflowY: "auto",
      paddingLeft: 8
    },
    cardSpacing: {
      marginBottom: theme.spacing(2)
    }
  };
};
var ResendApplicationPage = /*#__PURE__*/function (_Component) {
  function ResendApplicationPage(props) {
    var _this;
    _classCallCheck(this, ResendApplicationPage);
    _this = _callSuper$8(this, ResendApplicationPage, [props]);
    _defineProperty(_this, "handlePreviewOpen", function (file) {
      _this.setState({
        preview: file
      });
    });
    _defineProperty(_this, "handlePreviewClose", function () {
      _this.setState({
        preview: null
      });
    });
    _defineProperty(_this, "handleOpenResendModal", function (fileIndex) {
      _this.setState({
        resendFile: fileIndex
      });
    });
    _defineProperty(_this, "handleCloseResendModal", function () {
      _this.setState({
        resendFile: null
      });
    });
    _defineProperty(_this, "handleFileCommentChange", function (index, value) {
      console.log(index, value);
      _this.setState(function (prevState) {
        if (!prevState.fileStates || !prevState.fileStates[index]) {
          return {};
        }
        var updatedFiles = _toConsumableArray(prevState.fileStates);
        updatedFiles[index] = _objectSpread$f(_objectSpread$f({}, updatedFiles[index]), {}, {
          note: value
        });
        return {
          fileStates: updatedFiles
        };
      });
    });
    _defineProperty(_this, "handleCommentChange", function (e) {
      _this.setState({
        note: e.target.value
      });
    });
    _defineProperty(_this, "handleFileVerify", function (index) {
      var file = _this.state.fileStates[index];
      var payload = _objectSpread$f(_objectSpread$f({}, file), {}, {
        id: decodeId(file.id),
        status: "verified",
        note: file.note
      });
      _this.props.updateWorkforceDocument(payload, "update workforce document");

      // optionally update UI optimistically
      _this.setState(function (prevState) {
        var updated = _toConsumableArray(prevState.fileStates);
        updated[index].status = "verified";
        return {
          fileStates: updated
        };
      });
    });
    _defineProperty(_this, "handleFileReject", function (index) {
      var file = _this.state.fileStates[index];
      var payload = _objectSpread$f(_objectSpread$f({}, file), {}, {
        id: decodeId(file.id),
        status: "rejected",
        note: file.note
      });
      _this.props.updateWorkforceDocument(payload, "update workforce document"); // 👈 dispatch here

      _this.setState(function (prevState) {
        var updated = _toConsumableArray(prevState.fileStates);
        updated[index].status = "rejected";
        return {
          fileStates: updated
        };
      });
    });
    _defineProperty(_this, "handleCommentChange", function (e) {
      _this.setState({
        comment: e.target.value
      });
    });
    _defineProperty(_this, "handleFileChange", function (fieldKey, fileData) {
      _this.setState(function (prevState) {
        var existingIndex = prevState.uploadedFiles.findIndex(function (item) {
          return item.fieldKey === fieldKey;
        });
        var updatedFiles = _toConsumableArray(prevState.uploadedFiles);
        if (existingIndex !== -1) {
          updatedFiles[existingIndex] = _objectSpread$f({
            fieldKey: fieldKey
          }, fileData);
        } else {
          updatedFiles.push(_objectSpread$f({
            fieldKey: fieldKey
          }, fileData));
        }
        return {
          uploadedFiles: updatedFiles
        };
      });
    });
    _defineProperty(_this, "handleResendDocument", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _this$props, applicationUuid, updateApplication, updateApplicationData, result;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _this$props = _this.props, applicationUuid = _this$props.applicationUuid, updateApplication = _this$props.updateApplication;
            console.log("UUID:", applicationUuid);
            updateApplicationData = {
              id: applicationUuid,
              status: WORKFORCE_STATUS$1.NEW
            };
            _context.prev = 3;
            _context.next = 6;
            return updateApplication(updateApplicationData, "update workforce application");
          case 6:
            result = _context.sent;
            console.log("GraphQL mutation result:", result);
            _context.next = 13;
            break;
          case 10:
            _context.prev = 10;
            _context.t0 = _context["catch"](3);
            console.error("Mutation error:", _context.t0);
          case 13:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[3, 10]]);
    })));
    _defineProperty(_this, "fetchApplicationMovement", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var _this$props2, modulesManager, applicationUuid, _response$payload, response, movements, clean, lastRevertMovement;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _this$props2 = _this.props, modulesManager = _this$props2.modulesManager, applicationUuid = _this$props2.applicationUuid;
            _context2.prev = 1;
            _context2.next = 4;
            return _this.props.fetchApplicationWiseMovementList(modulesManager, {
              applicationId: applicationUuid
            });
          case 4:
            response = _context2.sent;
            console.log("response", response);
            movements = (response === null || response === void 0 || (_response$payload = response.payload) === null || _response$payload === void 0 || (_response$payload = _response$payload.data) === null || _response$payload === void 0 || (_response$payload = _response$payload.workforceApplicationMovement) === null || _response$payload === void 0 || (_response$payload = _response$payload.edges) === null || _response$payload === void 0 ? void 0 : _response$payload.map(function (e) {
              return e.node;
            })) || [];
            console.log("movements", movements);
            clean = function clean(html) {
              return (html === null || html === void 0 ? void 0 : html.replace(/<\/?[^>]+(>|$)/g, "")) || "";
            };
            lastRevertMovement = _toConsumableArray(movements).reverse().find(function (m) {
              return m.revertNote;
            });
            if (lastRevertMovement) {
              lastRevertMovement.revertNote = clean(lastRevertMovement.revertNote);
            }
            _this.setState({
              movements: movements,
              lastRevertMovement: lastRevertMovement,
              // keep the whole object
              revertNotes: lastRevertMovement ? [lastRevertMovement.revertNote] : []
            });
            _context2.next = 17;
            break;
          case 14:
            _context2.prev = 14;
            _context2.t0 = _context2["catch"](1);
            console.error("Failed to load revert notes", _context2.t0);
          case 17:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[1, 14]]);
    })));
    _defineProperty(_this, "handleForward", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      var _targetMovement$appli;
      var _this$props3, applicationUuid, updateApplication, lastRevertMovement, userRights, stateRevertMovement, user_type, targetMovement, fromId, updateApplicationData, result, createApplicationMovementData;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            _this$props3 = _this.props, applicationUuid = _this$props3.applicationUuid, updateApplication = _this$props3.updateApplication, lastRevertMovement = _this$props3.lastRevertMovement, userRights = _this$props3.userRights;
            stateRevertMovement = _this.state.lastRevertMovement;
            user_type = getUserTypeFromRights(userRights);
            targetMovement = lastRevertMovement || stateRevertMovement;
            if (targetMovement !== null && targetMovement !== void 0 && (_targetMovement$appli = targetMovement.applicationFrom) !== null && _targetMovement$appli !== void 0 && _targetMovement$appli.id) {
              _context3.next = 7;
              break;
            }
            console.error("No valid fromId found in lastRevertMovement");
            return _context3.abrupt("return");
          case 7:
            fromId = decodeId(targetMovement.applicationFrom.id);
            updateApplicationData = {
              id: applicationUuid,
              status: WORKFORCE_STATUS$1.RESUBMITTED_APPLICATION
            };
            _context3.prev = 9;
            _context3.next = 12;
            return updateApplication(updateApplicationData, "forward workforce application");
          case 12:
            result = _context3.sent;
            console.log("Application updated:", result);
            createApplicationMovementData = {
              applicationId: applicationUuid,
              applicationFromId: _this.props.loggedInUserId,
              applicationToId: fromId,
              note: "resubmitted application",
              status: WORKFORCE_STATUS$1.RESUBMITTED_APPLICATION
            };
            _context3.next = 17;
            return _this.props.createApplicationMovement(createApplicationMovementData, "create workforce application movement");
          case 17:
            console.log("New movement inserted:", createApplicationMovementData);
            _this.setState({
              confirmModalOpen: true,
              confirmModalMessage: "DONE",
              confirmModalCallback: true
            });
            _this.state.uploadedFiles.forEach(function (_ref4) {
              var documentId = _ref4.documentId,
                files = _ref4.files;
              if (!documentId || !(files !== null && files !== void 0 && files.length)) return;
              files.forEach(function (file) {
                _this.props.updateWorkforceDocument({
                  id: safeDecodeId(documentId),
                  path: file.path,
                  url: file.url,
                  workforceApplicationId: safeApplicationId(_this.props.applicationUuid),
                  note: "Resubmitted document",
                  holderType: user_type
                }, "update workforce document");
              });
            });
            _context3.next = 25;
            break;
          case 22:
            _context3.prev = 22;
            _context3.t0 = _context3["catch"](9);
            console.error("Forward mutation error:", _context3.t0);
          case 25:
          case "end":
            return _context3.stop();
        }
      }, _callee3, null, [[9, 22]]);
    })));
    _defineProperty(_this, "handleConfirmModalClose", function (result) {
      // if (this.state.confirmModalCallback) {
      //   this.state.confirmModalCallback(result === 1);
      // }else{
      //   this.setState({ confirmModalOpen: false });
      // }
      _this.setState({
        confirmModalOpen: false
      });
    });
    var mockFiles = [{
      type: "image",
      src: "https://upload.wikimedia.org/wikipedia/commons/b/b9/Smart_NID_Card_%28Bangladesh%29.jpg",
      comment: "Clear image, all info visible.",
      status: "verified"
    }, {
      type: "pdf",
      src: "/assets/Fahim_tazwer_cv.pdf",
      comment: "Missing signature on last page.",
      status: "rejected"
    }];
    _this.state = {
      // applicationType: props?.application || {},
      // stateEdited: props.application?.workforceEmployee || {},
      isSaved: false,
      preview: null,
      note: "",
      mockFiles: mockFiles,
      uploadedFiles: [],
      fileStates: mockFiles.map(function (file) {
        return _objectSpread$f(_objectSpread$f({}, file), {}, {
          note: "",
          status: null
        });
      }),
      lastRevertMovement: [],
      confirmModalOpen: false,
      confirmModalMessage: "",
      confirmModalCallback: null
      // fileStates: mockFiles.map((file) => ({
      //   ...file,
      //   comment: "",
      //   status: null,
      // })),
    };
    return _this;
  }
  _inherits(ResendApplicationPage, _Component);
  return _createClass(ResendApplicationPage, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props4 = this.props;
        _this$props4.dispatch;
        var modulesManager = _this$props4.modulesManager;
        _this$props4.application;
        var applicationUuid = _this$props4.applicationUuid;
      this.props.fetchWorkforceDocument(modulesManager, ["workforceApplication_Id:\"".concat(applicationUuid, "\"")]);
      if (applicationUuid) {
        this.fetchApplicationMovement();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.application !== this.props.application) {
        this.setState({
          stateEdited: this.props.application
        });
      }
      if (prevProps.documents !== this.props.documents) {
        this.setState({
          fileStates: this.props.documents || []
        });
      }
      if (prevProps.submittingMutation && !this.props.submittingMutation) {
        this.props.dispatch(journalize(this.props.mutation));
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this,
        _lastRevertMovement$a,
        _lastRevertMovement$a2;
      var _this$props5 = this.props,
        classes = _this$props5.classes;
        _this$props5.applicationUuid;
        var documents = _this$props5.documents,
        locale = _this$props5.locale,
        uploadFile = _this$props5.uploadFile;
        _this$props5.userRights;
      var _this$state = this.state;
        _this$state.stateEdited;
        _this$state.preview;
        _this$state.fileStates;
        _this$state.comment;
        _this$state.applicationType;
        var revertNotes = _this$state.revertNotes,
        lastRevertMovement = _this$state.lastRevertMovement;
      console.log({
        uploadFile: uploadFile
      });
      console.log({
        revertNotes: revertNotes
      });
      return /*#__PURE__*/React.createElement(Grid, {
        container: true,
        spacing: 3,
        className: classes.rootGrid
      }, /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12,
        className: classes.rightGrid
      }, documents === null || documents === void 0 ? void 0 : documents.map(function (file, index) {
        return /*#__PURE__*/React.createElement(DocumentReviewAccordion, {
          key: (file === null || file === void 0 ? void 0 : file.id) || index,
          file: file,
          index: index,
          documentId: file === null || file === void 0 ? void 0 : file.id,
          onFileChange: _this2.handleFileChange,
          onCommentChange: _this2.handleFileCommentChange,
          onVerify: _this2.handleFileVerify,
          onReject: _this2.handleFileReject,
          locale: locale,
          fromResend: true
        });
      })), lastRevertMovement && /*#__PURE__*/React.createElement(Card, {
        variant: "outlined",
        className: classes.cardSpacing,
        style: {
          marginTop: 16,
          paddingLeft: 24
        }
      }, /*#__PURE__*/React.createElement(CardContent, null, /*#__PURE__*/React.createElement(Typography, {
        variant: "h6"
      }, "Last Revert Movement"), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement("b", null, "From:"), " ", (_lastRevertMovement$a = lastRevertMovement.applicationFrom) === null || _lastRevertMovement$a === void 0 ? void 0 : _lastRevertMovement$a.loginName), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement("b", null, "To:"), " ", (_lastRevertMovement$a2 = lastRevertMovement.applicationTo) === null || _lastRevertMovement$a2 === void 0 ? void 0 : _lastRevertMovement$a2.loginName), /*#__PURE__*/React.createElement(Typography, {
        color: "error"
      }, /*#__PURE__*/React.createElement("b", null, "Revert Note:"), " ", lastRevertMovement.revertNote))), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12,
        className: classes.rootGrid,
        style: {
          paddingLeft: 24
        }
      }, /*#__PURE__*/React.createElement(Button, {
        variant: "contained",
        color: "primary",
        style: {
          marginTop: 16
        },
        onClick: function onClick() {
          return _this2.setState({
            confirmModalOpen: true
          });
        }
      }, /*#__PURE__*/React.createElement(FormattedMessage, {
        module: "workforce",
        id: "workforce.employee.application.forward",
        defaultMessage: "Forward"
      }))), /*#__PURE__*/React.createElement(CustomConfirmModal, {
        open: this.state.confirmModalOpen,
        message: "workforce.application.forward.message",
        onClose: this.handleConfirmModalClose,
        onConfirm: this.handleForward
      }));
    }
  }]);
}(Component);
var mapDispatchToProps$4 = function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    updateApplication: updateApplication,
    fetchApplicationWiseMovementList: fetchApplicationWiseMovementList,
    fetchWorkforceDocument: fetchWorkforceDocument,
    updateWorkforceDocument: updateWorkforceDocument,
    createApplicationMovement: createApplicationMovement
  }, dispatch);
};
var mapStateToProps$7 = function mapStateToProps(state, props) {
  var _props$match, _state$core;
  return {
    application: state.workforce.application,
    applicationUuid: props === null || props === void 0 || (_props$match = props.match) === null || _props$match === void 0 || (_props$match = _props$match.params) === null || _props$match === void 0 ? void 0 : _props$match.application_uuid,
    documents: state.workforce.document,
    uploadFile: state.workforce.uploadFile,
    locale: (_state$core = state.core) === null || _state$core === void 0 || (_state$core = _state$core.user) === null || _state$core === void 0 || (_state$core = _state$core.i_user) === null || _state$core === void 0 ? void 0 : _state$core.language,
    userRights: state.core.user.i_user.rights
  };
};
var ResendApplicationPage$1 = withHistory(withModulesManager(connect(mapStateToProps$7, mapDispatchToProps$4)(withTheme(withStyles(styles$8)(ResendApplicationPage)))));

function ownKeys$e(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$e(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$e(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$e(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var styles$7 = function styles(theme) {
  return {
    dialogTitle: theme.dialog.title,
    dialogContent: theme.dialog.content,
    form: {
      padding: 0
    },
    item: {
      padding: theme.spacing(1)
    },
    paperDivider: theme.paper.divider
  };
};
var useStyles$f = makeStyles(function (theme) {
  return {
    paper: theme.paper.paper,
    tableTitle: _objectSpread$e(_objectSpread$e({}, theme.table.title), {}, {
      padding: theme.spacing(0.5, 1) // Reduced vertical padding
    }),
    headerButton: _objectSpread$e(_objectSpread$e({}, theme.table.title), {}, {
      padding: theme.spacing(0),
      textAlign: "right"
    }),
    item: theme.paper.item,
    fullHeight: {
      height: "100%"
    },
    largeButton: {
      fontSize: "1rem" // Larger font size for buttons
      // padding: theme.spacing(1.5), // Larger padding for buttons
    }
  };
});
var WorkforceEmployeeDesignationSearcher = function WorkforceEmployeeDesignationSearcher(_ref) {
  var handleSearch = _ref.handleSearch,
    onEmailChange = _ref.onEmailChange,
    onNidChange = _ref.onNidChange;
  var classes = useStyles$f();
  useDispatch();
  // const modulesManager = useModulesManager();

  var _useState = useState(""),
    _useState2 = _slicedToArray(_useState, 2),
    email = _useState2[0],
    setEmail = _useState2[1];
  var _useState3 = useState(""),
    _useState4 = _slicedToArray(_useState3, 2),
    nid = _useState4[0],
    setNid = _useState4[1];

  // const handleSearch = () => {
  //   const prms = [];
  //   prms.push(`email: "${email}"`);
  //   // prms.push(`designations_Status: "${WORKFORCE_STATUS.ACTIVE}"`);
  //   dispatch(fetchEmployeeDesignations(modulesManager, prms));
  // };

  var handleReset = function handleReset() {
    setEmail("");
    setNid("");
    console.log("Filters reset");
  };
  return /*#__PURE__*/React.createElement("div", {
    className: classes.page
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    className: classes.form
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(Paper, {
    className: classes.paper
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    className: classes.tableTitle,
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 9
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5",
    fontWeight: "bold"
  }, "Employee Designation")), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 2,
    className: classes.headerButton
  }, /*#__PURE__*/React.createElement(Button, {
    size: "large",
    className: classes.largeButton,
    onClick: handleReset,
    startIcon: /*#__PURE__*/React.createElement(YoutubeSearchedFor, null)
  }, "Reset Filters")), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 1,
    className: classes.tableTitle
  }, /*#__PURE__*/React.createElement(Button, {
    size: "large",
    className: classes.largeButton,
    onClick: function onClick() {
      return handleSearch();
    },
    startIcon: /*#__PURE__*/React.createElement(Search, null)
  }, "Search"))), /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 2,
    className: classes.item
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6,
    className: classes.item
  }, /*#__PURE__*/React.createElement(TextInput, {
    label: "Email",
    value: email || "",
    onChange: function onChange(value) {
      return onEmailChange(value);
    },
    required: true,
    readOnly: false,
    type: "email"
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6,
    className: classes.item
  }, /*#__PURE__*/React.createElement(TextInput, {
    label: "User NID",
    value: nid,
    onChange: function onChange(value) {
      return onNidChange(value);
    },
    required: true,
    readOnly: false,
    type: "number"
  })))))));
};

// export default WorkforceEmployeeDesignationSearcher
var WorkforceEmployeeDesignationSearcher$1 = withModulesManager(withTheme(withStyles(styles$7)(WorkforceEmployeeDesignationSearcher)));

function ownKeys$d(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$d(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$d(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$d(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var useStyles$e = makeStyles(function (theme) {
  return {
    paper: theme.paper.paper,
    root: _objectSpread$d(_objectSpread$d({}, theme.paper.paper), {}, {
      padding: theme.spacing(0),
      justifyContent: "space-around"
    }),
    userCard: _objectSpread$d(_objectSpread$d({}, theme.paper.paper), {}, {
      padding: theme.spacing(0)
    }),
    userCard2: _objectSpread$d(_objectSpread$d({}, theme.paper.paper), {}, {
      padding: theme.spacing(1),
      textAlign: "left",
      margin: "0px"
    }),
    tableContainer: {
      padding: theme.spacing(1)
    },
    tableHeader: _objectSpread$d(_objectSpread$d({}, theme.table.title), {}, {
      padding: theme.spacing(0.5, 1),
      fontSize: "18px",
      fontWeight: "bold"
    }),
    deleteButton: {
      color: theme.palette.error.main
    }
  };
});
var WorkforceEmployeeDesignaitonInfo = function WorkforceEmployeeDesignaitonInfo(_ref) {
  var userData = _ref.userData,
    workforceEmployeeDesignation = _ref.workforceEmployeeDesignation,
    onReleaseDateChange = _ref.onReleaseDateChange;
  var classes = useStyles$e();
  var dispatch = useDispatch();
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    releaseDate = _useState2[0],
    setReleaseDate = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    tableData = _useState4[0],
    setTableData = _useState4[1];
  var _useState5 = useState(),
    _useState6 = _slicedToArray(_useState5, 2),
    releaseReason = _useState6[0],
    setReleaseReason = _useState6[1];
  useEffect(function () {
    // Assign data only when workforceEmployeeDesignation changes
    if (workforceEmployeeDesignation) {
      setTableData(workforceEmployeeDesignation);
    }
  }, [workforceEmployeeDesignation]);
  var handleRelease = function handleRelease(row) {
    var _row$workforceEmploye, _row$workforceCompany;
    var updateReleaseDate = {
      id: decodeId(row.id),
      resignatioDate: releaseDate,
      workforceEmployeeId: decodeId(row === null || row === void 0 || (_row$workforceEmploye = row.workforceEmployee) === null || _row$workforceEmploye === void 0 ? void 0 : _row$workforceEmploye.id),
      workforceCompany: decodeId(row === null || row === void 0 || (_row$workforceCompany = row.workforceCompany) === null || _row$workforceCompany === void 0 ? void 0 : _row$workforceCompany.id),
      resignatioReason: releaseReason,
      // position:"",
      status: "inactive"
    };
    console.log({
      updateReleaseDate: updateReleaseDate
    });
    dispatch(updateWorkforceEmployeeAssignDesignation(updateReleaseDate, "updated workforce Employee designation"));
    setTableData(function (prevData) {
      return prevData.map(function (item) {
        return item.id === row.id ? _objectSpread$d(_objectSpread$d({}, item), {}, {
          status: "inactive"
        }) : item;
      });
    });
    onReleaseDateChange(releaseDate);
  };
  console.log({
    tableData: tableData
  });
  return /*#__PURE__*/React.createElement(Paper, {
    className: classes.paper
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 0,
    className: classes.root
  }, userData && userData.name && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 4
  }, /*#__PURE__*/React.createElement(Paper, {
    className: classes.userCard
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.tableHeader
  }, "Employee Info"), /*#__PURE__*/React.createElement(Paper, {
    className: classes.userCard2
  }, /*#__PURE__*/React.createElement(Typography, null, "Name: ", userData.name), /*#__PURE__*/React.createElement(Typography, null, "Email: ", userData.email), /*#__PURE__*/React.createElement(Typography, null, "Phone: ", userData.phone), /*#__PURE__*/React.createElement(Typography, null, "NID: ", userData.nid)))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 8
  }, /*#__PURE__*/React.createElement(Paper, {
    className: classes.paper
  }, /*#__PURE__*/React.createElement(TableContainer, null, /*#__PURE__*/React.createElement(Table$2, {
    size: "small"
  }, /*#__PURE__*/React.createElement(TableHead, {
    className: classes.tableHeader
  }, /*#__PURE__*/React.createElement(TableRow, null, /*#__PURE__*/React.createElement(TableCell, null, "Company"), /*#__PURE__*/React.createElement(TableCell, null, "Factory"), /*#__PURE__*/React.createElement(TableCell, null, "Designation"), /*#__PURE__*/React.createElement(TableCell, null, "Release Date"), /*#__PURE__*/React.createElement(TableCell, null, "Release Reason"), /*#__PURE__*/React.createElement(TableCell, null))), /*#__PURE__*/React.createElement(TableBody, null, tableData.map(function (row, index) {
    var _row$workforceCompany2, _row$workforceFactory;
    return (row === null || row === void 0 ? void 0 : row.status) === WORKFORCE_STATUS$1.ACTIVE && /*#__PURE__*/React.createElement(TableRow, {
      key: index
    }, /*#__PURE__*/React.createElement(TableCell, null, row === null || row === void 0 || (_row$workforceCompany2 = row.workforceCompany) === null || _row$workforceCompany2 === void 0 ? void 0 : _row$workforceCompany2.nameBn), /*#__PURE__*/React.createElement(TableCell, null, row === null || row === void 0 || (_row$workforceFactory = row.workforceFactory) === null || _row$workforceFactory === void 0 ? void 0 : _row$workforceFactory.nameBn), /*#__PURE__*/React.createElement(TableCell, null, row === null || row === void 0 ? void 0 : row.position), /*#__PURE__*/React.createElement(TableCell, null, /*#__PURE__*/React.createElement(PublishedComponent, {
      pubRef: "workforce.DatePicker",
      label: "Release Date",
      onChange: function onChange(v) {
        return setReleaseDate(v);
      },
      readOnly: false,
      required: false
    })), /*#__PURE__*/React.createElement(TableCell, null, /*#__PURE__*/React.createElement(TextInput, {
      label: "Release Reason",
      value: releaseReason || "",
      onChange: function onChange(v) {
        return setReleaseReason(v);
      },
      required: true,
      readOnly: false
    })), /*#__PURE__*/React.createElement(TableCell, null, /*#__PURE__*/React.createElement(IconButton, {
      className: classes.deleteButton,
      onClick: function onClick() {
        return handleRelease(row);
      }
    }, /*#__PURE__*/React.createElement(DeleteIcon, null))));
  })))))))));
};

// export default WorkforceEmployeeDesignaitonInfo;
var WorkforceEmployeeDesignaitonInfo$1 = withModulesManager(withTheme(WorkforceEmployeeDesignaitonInfo));

function ownKeys$c(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$c(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$c(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$c(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var useStyles$d = makeStyles(function (theme) {
  return {
    paper: theme.paper.paper,
    root: _objectSpread$c(_objectSpread$c({}, theme.paper.paper), {}, {
      padding: theme.spacing(0),
      justifyContent: "space-around"
    }),
    table: {
      borderCollapse: "collapse" // Ensure the borders look seamless
    },
    tableRow: {
      "&:hover": {
        backgroundColor: theme.palette.action.hover // Optional: Highlight on hover
      },
      height: "40px",
      maxHeight: "20px",
      minHeight: 0
    },
    tableCell: {
      border: "1px solid #bab5b5",
      // Light border for each cell
      padding: "0px 10px",
      // Remove all padding for maximum compactness
      lineHeight: 0.5,
      // Reduce line height
      fontSize: "0.8rem" // Optional: Adjust font size for better compactness
    },
    userCard: _objectSpread$c(_objectSpread$c({}, theme.paper.paper), {}, {
      padding: theme.spacing(0)
    }),
    userCard2: _objectSpread$c(_objectSpread$c({}, theme.paper.paper), {}, {
      padding: theme.spacing(1),
      textAlign: "left",
      margin: "0px"
    }),
    tableContainer: {
      padding: theme.spacing(1)
    },
    tableHeader: _objectSpread$c(_objectSpread$c({}, theme.table.title), {}, {
      padding: theme.spacing(0.5, 1),
      fontSize: "16px",
      // Reduce header font size slightly
      fontWeight: "bold"
    }),
    assignButton: {
      color: theme.palette.success.main
    }
  };
});
var AssignEmployeeDesignation = function AssignEmployeeDesignation(_ref) {
  var _formData$company, _formData$factory2, _formData$company2;
  _ref.userData;
    var stateEdited = _ref.stateEdited;
    _ref.updateAttribute;
    _ref.tableData;
    var handleSearch = _ref.handleSearch;
    _ref.unitWiseDesignations;
    var fetchWorkforceEmployeeDesignations = _ref.fetchWorkforceEmployeeDesignations;
  var classes = useStyles$d();
  useModulesManager();
  var dispatch = useDispatch();
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    assignDate = _useState2[0],
    setAssignDate = _useState2[1];
  var _useState3 = useState({}),
    _useState4 = _slicedToArray(_useState3, 2),
    position = _useState4[0],
    setPosition = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    disabledAssignButton = _useState6[0],
    setDisabledAssignButton = _useState6[1]; // Track button disabled state
  var _useState7 = useState({
      company: null,
      factory: null
    }),
    _useState8 = _slicedToArray(_useState7, 2),
    formData = _useState8[0],
    setFormData = _useState8[1];
  var handleChange = function handleChange(key, value) {
    setFormData(function (prev) {
      return _objectSpread$c(_objectSpread$c({}, prev), {}, _defineProperty({}, key, value));
    });
    if (key === "factory" && value !== null && value !== void 0 && value.id) {
      fetchWorkforceEmployeeDesignations(value.id);
    }
  };
  var employeeDesignationData = useSelector(function (state) {
    return state.workforce["workforceEmployeeDesignation"];
  });
  useEffect(function () {
    var _formData$factory;
    if (formData !== null && formData !== void 0 && (_formData$factory = formData.factory) !== null && _formData$factory !== void 0 && _formData$factory.id) {
      var fetchData = /*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return fetchWorkforceEmployeeDesignations(formData.factory);
              case 2:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }));
        return function fetchData() {
          return _ref2.apply(this, arguments);
        };
      }();
      fetchData();
    }
  }, [formData.factory]);
  var handleAssign = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(row) {
      var _row$workforceEmploye, _row$workforceCompany;
      var assignData;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            setDisabledAssignButton(true);
            assignData = {
              id: decodeId(row.id),
              workforceEmployeeId: decodeId(row === null || row === void 0 || (_row$workforceEmploye = row.workforceEmployee) === null || _row$workforceEmploye === void 0 ? void 0 : _row$workforceEmploye.id),
              joiningDate: assignDate,
              position: position[row.id],
              workforceCompany: decodeId(row === null || row === void 0 || (_row$workforceCompany = row.workforceCompany) === null || _row$workforceCompany === void 0 ? void 0 : _row$workforceCompany.id),
              status: WORKFORCE_STATUS$1.ACTIVE
            };
            console.log({
              assignData: assignData
            });
            _context2.next = 5;
            return dispatch(updateWorkforceEmployeeAssignDesignation(assignData, "updated workforce Employee designation"));
          case 5:
            handleSearch();
          case 6:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function handleAssign(_x) {
      return _ref3.apply(this, arguments);
    };
  }();
  console.log({
    employeeDesignationData: employeeDesignationData
  });
  console.log({
    formData: formData
  });
  return /*#__PURE__*/React.createElement(Paper, {
    className: classes.paper
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 0,
    className: classes.root
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    className: classes.userCard,
    spacing: 2
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.tableHeader
  }, "Assign")), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 4
  }, /*#__PURE__*/React.createElement(CompanyPicker, {
    value: formData === null || formData === void 0 || (_formData$company = formData.company) === null || _formData$company === void 0 ? void 0 : _formData$company.id,
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.employee.workforce_employer",
      module: "workforce"
    }),
    required: true,
    onChange: function onChange(v) {
      // handleChange("company", v, "employeeDesignation");
      // fetchWorkforceEmployeeDesignation(v);
      handleChange("company", v);
    },
    readOnly: false
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 4
  }, /*#__PURE__*/React.createElement(FactoryPicker, {
    value: formData === null || formData === void 0 || (_formData$factory2 = formData.factory) === null || _formData$factory2 === void 0 ? void 0 : _formData$factory2.id,
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "workforce.employee.workforce_factory",
      module: "workforce"
    }),
    required: true,
    companyId: formData === null || formData === void 0 || (_formData$company2 = formData.company) === null || _formData$company2 === void 0 ? void 0 : _formData$company2.id,
    onChange: function onChange(v) {
      // handleChange("factory", v, "employeeDesignation");
      handleChange("factory", v);
    },
    readOnly: false
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 4
  }, /*#__PURE__*/React.createElement(PublishedComponent, {
    pubRef: "workforceOrganization.OrganizationPicker",
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      module: "workforce",
      id: "workforce.organization.picker"
    }),
    value: stateEdited.organization || null,
    onChange: function onChange(v) {
      return fetchWorkforceEmployeeDesignations(v);
    },
    required: true,
    readOnly: false
  })), employeeDesignationData === null || employeeDesignationData === void 0 ? void 0 : employeeDesignationData.map(function (unit) {
    var _unit$workforceEmploy;
    return /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      key: unit.id
    }, /*#__PURE__*/React.createElement(TableContainer, null, /*#__PURE__*/React.createElement(Table$2, {
      size: "small"
    }, /*#__PURE__*/React.createElement(TableHead, {
      className: classes.tableHeader
    }, /*#__PURE__*/React.createElement(TableRow, null, /*#__PURE__*/React.createElement(TableCell, {
      colSpan: 4
    }, /*#__PURE__*/React.createElement("b", null, unit === null || unit === void 0 ? void 0 : unit.nameBn, " Factory designation ")))), /*#__PURE__*/React.createElement(TableBody, null, /*#__PURE__*/React.createElement(TableRow, {
      className: classes.tableRow
    }, /*#__PURE__*/React.createElement(TableCell, {
      className: classes.tableCell,
      style: {
        width: "30%"
      }
    }, /*#__PURE__*/React.createElement(TextInput, {
      key: unit === null || unit === void 0 ? void 0 : unit.id,
      label: "Assign Designation",
      value: position[unit === null || unit === void 0 ? void 0 : unit.id] || "",
      onChange: function onChange(v) {
        return setPosition(function (prev) {
          return _objectSpread$c(_objectSpread$c({}, prev), {}, _defineProperty({}, unit.id, v));
        });
      },
      required: true,
      readOnly: false
    })), /*#__PURE__*/React.createElement(TableCell, {
      className: classes.tableCell,
      style: {
        width: "30%"
      }
    }, unit === null || unit === void 0 || (_unit$workforceEmploy = unit.workforceEmployee) === null || _unit$workforceEmploy === void 0 ? void 0 : _unit$workforceEmploy.email), /*#__PURE__*/React.createElement(TableCell, {
      className: classes.tableCell,
      style: {
        width: "30%"
      }
    }, /*#__PURE__*/React.createElement(PublishedComponent, {
      pubRef: "workforce.DatePicker",
      label: "Assign Date",
      onChange: function onChange(v) {
        return setAssignDate(v);
      },
      readOnly: disabledAssignButton ? true : false,
      required: false
    })), /*#__PURE__*/React.createElement(TableCell, {
      className: classes.tableCell,
      style: {
        width: "20%"
      }
    }, /*#__PURE__*/React.createElement(IconButton, {
      disabled: disabledAssignButton,
      className: classes.assignButton,
      onClick: function onClick() {
        return handleAssign(unit);
      }
    }, /*#__PURE__*/React.createElement(AddBoxIcon, null))))))));
  })))));
};

// export default AssignDesignation;
var AssignEmployeeDesignation$1 = withModulesManager(withTheme(AssignEmployeeDesignation));

function ownKeys$b(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$b(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$b(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$b(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper$7(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$7() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$7() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$7 = function _isNativeReflectConstruct() { return !!t; })(); }
var WorkforceEmployeeDesignationPage = /*#__PURE__*/function (_Component) {
  function WorkforceEmployeeDesignationPage(props) {
    var _this;
    _classCallCheck(this, WorkforceEmployeeDesignationPage);
    _this = _callSuper$7(this, WorkforceEmployeeDesignationPage, [props]);
    _defineProperty(_this, "updateAttribute", function (key, value) {
      _this.setState(function (prevState) {
        return {
          stateEdited: _objectSpread$b(_objectSpread$b({}, prevState.stateEdited), {}, _defineProperty({}, key, value)),
          isSaved: false
        };
      });
    });
    _defineProperty(_this, "handleSearch", function () {
      var _this$state = _this.state,
        email = _this$state.email,
        nid = _this$state.nid;
      var prms = [];
      if (email) {
        prms.push("workforceEmployee_Email: \"".concat(email, "\""));
      }
      if (nid) {
        prms.push("nid: \"".concat(nid, "\""));
      }
      _this.props.fetchWorkforceEmployeeDesignation(_this.props.modulesManager, prms);
    });
    _defineProperty(_this, "handleEmailChange", function (email) {
      _this.setState({
        email: email
      });
    });
    _defineProperty(_this, "handleNidChange", function (nid) {
      _this.setState({
        nid: nid
      });
    });
    _defineProperty(_this, "fetchWorkforceEmployeeDesignations", /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(factory) {
        var prms;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (factory !== null && factory !== void 0 && factory.id) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return");
            case 2:
              prms = [];
              prms.push("workforceFactoryId: \"".concat(factory.id, "\""));
              console.log({
                prms: prms
              });
              _context.next = 7;
              return _this.props.fetchWorkforceEmployeeDesignation(_this.props.modulesManager, prms);
            case 7:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
    _defineProperty(_this, "handleReleaseDateChange", function (date) {
      _this.setState({
        releaseDate: date
      });
    });
    _this.state = {
      stateEdited: {},
      isSaved: false
    };
    return _this;
  }
  _inherits(WorkforceEmployeeDesignationPage, _Component);
  return _createClass(WorkforceEmployeeDesignationPage, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var _this$props$workforce;
      if (prevProps.workforceEmployeeDesignation !== this.props.workforceEmployeeDesignation && (_this$props$workforce = this.props.workforceEmployeeDesignation) !== null && _this$props$workforce !== void 0 && _this$props$workforce.organization) {
        this.fetchWorkforceEmployeeDesignations(this.props.workforceEmployeeDesignation.organization);
      }
      if (prevState.releaseDate !== this.state.releaseDate && this.state.selectedOrganization) {
        this.fetchWorkforceEmployeeDesignations(this.state.selectedOrganization);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _workforceEmployeeDes, _workforceEmployeeDes2, _workforceEmployeeDes3, _workforceEmployeeDes4;
      var _this$props = this.props,
        workforceEmployeeDesignation = _this$props.workforceEmployeeDesignation,
        unitWiseDesignationData = _this$props.unitWiseDesignationData;
        _this$props.workforceEmployee;
      var _this$state2 = this.state,
        stateEdited = _this$state2.stateEdited;
        _this$state2.isSaved;
        _this$state2.email;
        _this$state2.nid;
        _this$state2.releaseDate;
        _this$state2.selectedOrganization;
      var userData = {
        name: (workforceEmployeeDesignation === null || workforceEmployeeDesignation === void 0 || (_workforceEmployeeDes = workforceEmployeeDesignation[0]) === null || _workforceEmployeeDes === void 0 || (_workforceEmployeeDes = _workforceEmployeeDes.workforceEmployee) === null || _workforceEmployeeDes === void 0 ? void 0 : _workforceEmployeeDes.firstNameBn) || "",
        email: (workforceEmployeeDesignation === null || workforceEmployeeDesignation === void 0 || (_workforceEmployeeDes2 = workforceEmployeeDesignation[0]) === null || _workforceEmployeeDes2 === void 0 || (_workforceEmployeeDes2 = _workforceEmployeeDes2.workforceEmployee) === null || _workforceEmployeeDes2 === void 0 ? void 0 : _workforceEmployeeDes2.email) || "",
        phone: (workforceEmployeeDesignation === null || workforceEmployeeDesignation === void 0 || (_workforceEmployeeDes3 = workforceEmployeeDesignation[0]) === null || _workforceEmployeeDes3 === void 0 || (_workforceEmployeeDes3 = _workforceEmployeeDes3.workforceEmployee) === null || _workforceEmployeeDes3 === void 0 ? void 0 : _workforceEmployeeDes3.phoneNumber) || "",
        nid: (workforceEmployeeDesignation === null || workforceEmployeeDesignation === void 0 || (_workforceEmployeeDes4 = workforceEmployeeDesignation[0]) === null || _workforceEmployeeDes4 === void 0 || (_workforceEmployeeDes4 = _workforceEmployeeDes4.workforceEmployee) === null || _workforceEmployeeDes4 === void 0 ? void 0 : _workforceEmployeeDes4.nid) || ""
      };
      var tableData = (workforceEmployeeDesignation === null || workforceEmployeeDesignation === void 0 ? void 0 : workforceEmployeeDesignation.designations) || [];
      // console.clear()
      console.log({
        userData: userData
      });
      console.log({
        workforceEmployeeDesignation: workforceEmployeeDesignation
      });
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(WorkforceEmployeeDesignationSearcher$1, {
        handleSearch: this.handleSearch,
        onEmailChange: this.handleEmailChange,
        onNidChange: this.handleNidChange
      }), /*#__PURE__*/React.createElement(WorkforceEmployeeDesignaitonInfo$1, {
        workforceEmployeeDesignation: workforceEmployeeDesignation,
        userData: userData,
        tableData: tableData,
        fetchWorkforceEmployeeDesignations: this.fetchWorkforceEmployeeDesignations,
        onReleaseDateChange: this.handleReleaseDateChange
      }), /*#__PURE__*/React.createElement(AssignEmployeeDesignation$1, {
        userData: userData,
        stateEdited: stateEdited,
        updateAttribute: this.updateAttribute,
        tableData: tableData,
        handleSearch: this.handleSearch,
        unitWiseDesignations: unitWiseDesignationData,
        fetchWorkforceEmployeeDesignations: this.fetchWorkforceEmployeeDesignations,
        onValueChange: this.handleValueChange
      }));
    }
  }]);
}(Component);
var mapStateToProps$6 = function mapStateToProps(state) {
  return {
    workforceEmployeeDesignation: state.workforce.workforceEmployeeDesignation,
    unitWiseDesignationData: state.workforce.unitWiseDesignationData,
    workforceEmployee: state.workforce.workforceEmployee
  };
};

// const mapDispatchToProps = (dispatch) => ({
//   // fetchEmployeeDesignations: bindActionCreators(fetchEmployeeDesignations, dispatch),
// });

var mapDispatchToProps$3 = function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    fetchWorkforceEmployee: fetchWorkforceEmployee,
    fetchWorkforceEmployeeDesignation: fetchWorkforceEmployeeDesignation,
    fetchWorkforceUnitsWithEmployeeDesignation: fetchWorkforceUnitsWithEmployeeDesignation
  }, dispatch);
};
var WorkforceEmployeeDesignationPage$1 = connect(mapStateToProps$6, mapDispatchToProps$3)(withModulesManager(WorkforceEmployeeDesignationPage));

var useStyles$c = makeStyles$1(function (theme) {
  return {
    container: {
      position: "absolute",
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
      margin: "auto",
      display: "flex",
      justifyContent: "center",
      alignItems: "center"
    },
    paper: theme.paper.paper,
    logo: {
      width: "45%",
      padding: theme.spacing(2),
      display: "block"
    }
  };
});
function LoginHeader() {
  var _useState = useState("bn"),
    _useState2 = _slicedToArray(_useState, 2),
    lang = _useState2[0],
    setLang = _useState2[1];
  var classes = useStyles$c();
  var logo = "/api/workforce/logo";
  if (isBlwfPath()) {
    logo = window.location.origin + "/front/workforce_assets/blwf.png";
  } else if (isEisPath()) {
    logo = window.location.origin + "/front/workforce_assets/eis.png";
  } else {
    logo = window.location.origin + "/front/workforce_assets/centralfund.png";
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Box$1, {
    display: "flex",
    justifyContent: "flex-start"
  }, /*#__PURE__*/React.createElement(Button, {
    startIcon: /*#__PURE__*/React.createElement(ArrowBackIcon, null),
    href: getReturnUrl(),
    variant: "text",
    color: "primary",
    style: {
      padding: "3px"
    }
  }, lang === "bn" ? "পেছনে যান" : "Back")), /*#__PURE__*/React.createElement(Box$1, {
    display: "flex",
    justifyContent: "flex-end",
    mt: -4
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "primary",
    color: "primary",
    style: {
      padding: "3px"
    },
    onClick: function onClick() {
      return setLang(lang == "bn" ? "en" : "bn");
    }
  }, lang == "bn" ? "বাংলা" : "English")), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    container: true,
    direction: "column",
    alignItems: "center",
    justifyContent: "center"
  }, /*#__PURE__*/React.createElement("img", {
    className: classes.logo,
    src: logo
  }), /*#__PURE__*/React.createElement(React.Fragment, null, isEisPath() ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Box$1, {
    pl: 2,
    fontWeight: "fontWeightBold",
    fontSize: "h6.fontSize",
    textAlign: "center"
  }, lang === "bn" ? "শ্রম ও কর্মসংস্থান মন্ত্রণালয়" : "Ministry of Labour and Employment"), /*#__PURE__*/React.createElement(Divider, {
    style: {
      flex: '1 1 0%',
      // Shorthand for flex-grow, flex-shrink, flex-basis
      marginTop: '3px',
      marginBottom: '3px',
      background: '#006273'
    }
  }), /*#__PURE__*/React.createElement(Box$1, {
    pl: 2,
    fontWeight: "fontWeightBold",
    fontSize: "h6.fontSize",
    textAlign: "center" /* Make sure all props are complete */
  }, isEisPath() ? lang === "bn" ? "ই.আই.এস. ম্যানেজমেন্ট সিস্টেম" : "EIS Management System" : lang === "bn" ? "শ্রমিক কল্যাণ সহায়তার আবেদন ব্যবস্থাপনা সিস্টেম" : "Worker Welfare Assistance Application Management System")) : !isBlwfPath() && !isEisPath() ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Typography, {
    pl: 2,
    variant: "h6",
    style: {
      marginTop: 2
    }
    // fontWeight="fontWeightBold"
    // fontSize="h6.fontSize"
    ,
    textAlign: "center"
  }, lang === "bn" ? "কেন্দ্রীয় তহবিল" : "Central Fund")) : /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Typography, {
    pl: 2,
    variant: "h6",
    style: {
      marginTop: 2,
      fontWeight: "bold"
    }
    // fontWeight="fontWeightBold"
    // fontSize="h6.fontSize"
    ,
    textAlign: "center"
  }, lang === "bn" ? "বাংলাদেশ শ্রমিক কল্যাণ ফাউন্ডেশন" : "Bangladesh Labour Welfare Foundation")))));
}

function ownKeys$a(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$a(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$a(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$a(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var RECAPTCHA_SITE_KEY = "6LetjAAsAAAAANxUe7M2ePfj_2Nxgkgn9xzlPFqd";
var useStyles$b = makeStyles$1(function (theme) {
  return {
    container: {
      position: "absolute",
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
      margin: "auto",
      display: "flex",
      justifyContent: "center",
      alignItems: "center"
    },
    paper: theme.paper.paper,
    otpInput: {
      width: "100% !important",
      height: "2.2rem",
      margin: "0 .8rem",
      fontSize: "2rem",
      borderRadius: 8,
      border: "1px solid #006273",
      color: "#00668f",
      background: "transparent !important",
      textAlign: "center",
      outline: "none",
      transition: "border-color 0.2s ease-in-out",
      "&:focus": {
        borderColor: "#1976d2"
      }
    }
  };
});
var errorMessages$1 = {
  INVALID_PHONE_NUMBER: "মোবাইল নম্বর ভুল দিয়েছেন। পুনরায় চেষ্টা করুন।",
  INCORRECT_CREDENTIALS: "তথ্য ভুল দিয়েছেন। পুনরায় চেষ্টা করুন।",
  GENERAL: "যান্ত্রিক ত্রুটি হয়েছে।"
};
var getErrorMessage$1 = function getErrorMessage(key) {
  return errorMessages$1[key] || key;
};
var getMyCookie = function getMyCookie(name) {
  return document.cookie.split("; ").reduce(function (prev, current) {
    var _current$split = current.split("="),
      _current$split2 = _slicedToArray(_current$split, 2),
      k = _current$split2[0],
      v = _current$split2[1];
    return k === name ? decodeURIComponent(v) : prev;
  }, null);
};
function LoginForm() {
  var _useState = useState("bn"),
    _useState2 = _slicedToArray(_useState, 2),
    lang = _useState2[0];
    _useState2[1];
  var classes = useStyles$b();
  var _useState3 = useState({}),
    _useState4 = _slicedToArray(_useState3, 2),
    credentials = _useState4[0],
    setCredentials = _useState4[1];
  var _useState5 = useState(""),
    _useState6 = _slicedToArray(_useState5, 2),
    mobileNumber = _useState6[0],
    setMobileNumber = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    isOtpSent = _useState8[0],
    setIsOtpSent = _useState8[1];
  var _useState9 = useState(false),
    _useState10 = _slicedToArray(_useState9, 2),
    isAuthenticating = _useState10[0],
    setAuthenticating = _useState10[1];
  var _useState11 = useState({
      loginStatus: "",
      message: null
    }),
    _useState12 = _slicedToArray(_useState11, 2),
    serverResponse = _useState12[0],
    setServerResponse = _useState12[1];
  var _useState13 = useState(null),
    _useState14 = _slicedToArray(_useState13, 2),
    recaptchaToken = _useState14[0],
    setRecaptchaToken = _useState14[1];
  useRef(null);
  var auth = useAuthentication();
  var history = useHistory();
  useEffect(function () {
    var userType = getMyCookie("userType");
    if (userType === "administrative") history.push("/administrative/login");
    var loadRecaptcha = function loadRecaptcha() {
      return new Promise(function (resolve) {
        if (window.grecaptcha) return resolve(window.grecaptcha);
        var script = document.createElement("script");
        script.src = "https://www.google.com/recaptcha/api.js?render=explicit";
        script.async = true;
        script.defer = true;
        script.onload = function () {
          return resolve(window.grecaptcha);
        };
        document.body.appendChild(script);
      });
    };
    loadRecaptcha().then(function (grecaptcha) {
      grecaptcha.ready(function () {
        var container = document.getElementById("recaptcha-container");
        if (!container) return;
        if (window.__recaptchaWidgetId !== undefined) {
          try {
            grecaptcha.reset(window.__recaptchaWidgetId);
          } catch (e) {
            console.warn("Error resetting reCAPTCHA:", e);
          }
          return;
        }
        var widgetId = grecaptcha.render("recaptcha-container", {
          sitekey: RECAPTCHA_SITE_KEY,
          size: "normal",
          callback: function callback(token) {
            return setRecaptchaToken(token);
          },
          "expired-callback": function expiredCallback() {
            return setRecaptchaToken(null);
          }
        });
        window.__recaptchaWidgetId = widgetId;
      });
    });
  }, [history]);
  var handleLoginError = function handleLoginError(msg) {
    setServerResponse({
      loginStatus: "CORE_AUTH_ERR",
      message: msg
    });
    setAuthenticating(false);
  };
  var onSubmit = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _response$payload, cookieexpires, response, loginStatus, message;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            setAuthenticating(true);
            _context.prev = 1;
            cookieexpires = "; expires=".concat(-1);
            document.cookie = "userType=".concat(encodeURIComponent("")).concat(cookieexpires, "; path=/");
            _context.next = 6;
            return auth.login(credentials);
          case 6:
            response = _context.sent;
            if (!((_response$payload = response.payload) !== null && _response$payload !== void 0 && (_response$payload = _response$payload.errors) !== null && _response$payload !== void 0 && _response$payload.length)) {
              _context.next = 10;
              break;
            }
            handleLoginError(response.payload.errors[0].message);
            return _context.abrupt("return");
          case 10:
            loginStatus = response.loginStatus, message = response.message;
            setServerResponse({
              loginStatus: loginStatus,
              message: message
            });
            if (loginStatus === "CORE_AUTH_ERR") setAuthenticating(false);else history.push("/");
            _context.next = 18;
            break;
          case 15:
            _context.prev = 15;
            _context.t0 = _context["catch"](1);
            setAuthenticating(false);
          case 18:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[1, 15]]);
    }));
    return function onSubmit() {
      return _ref.apply(this, arguments);
    };
  }();

  // ✅ Only send OTP if user verified reCAPTCHA
  var sendOtp = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var formData, response, data;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            if (recaptchaToken) {
              _context2.next = 3;
              break;
            }
            alert(lang === "bn" ? "অনুগ্রহ করে 'আমি রোবট নই' চেকবক্সটি টিক দিন।" : "Please tick the 'I am not a robot' checkbox.");
            return _context2.abrupt("return");
          case 3:
            formData = new FormData();
            formData.append("phone_number", mobileNumber);
            formData.append("recaptcha_token", recaptchaToken);
            _context2.prev = 6;
            _context2.next = 9;
            return fetch("/api/workforce/send/otp", {
              method: "POST",
              body: formData
            });
          case 9:
            response = _context2.sent;
            _context2.next = 12;
            return response.json();
          case 12:
            data = _context2.sent;
            if (!response.ok || data.status !== "success") {
              setServerResponse({
                loginStatus: "CORE_AUTH_ERR",
                message: data.message
              });
            } else {
              setCredentials(_objectSpread$a(_objectSpread$a({}, credentials), {}, {
                username: data.username
              }));
              setIsOtpSent(true);
            }
            _context2.next = 20;
            break;
          case 16:
            _context2.prev = 16;
            _context2.t0 = _context2["catch"](6);
            console.error(_context2.t0);
            setServerResponse({
              loginStatus: "CORE_AUTH_ERR",
              message: errorMessages$1.GENERAL
            });
          case 20:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[6, 16]]);
    }));
    return function sendOtp() {
      return _ref2.apply(this, arguments);
    };
  }();
  var setInput = function setInput(type, value) {
    if (type === "mobile_number") setMobileNumber(value);
    if (type === "otp") setCredentials(_objectSpread$a(_objectSpread$a({}, credentials), {}, {
      password: value
    }));
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, isAuthenticating && /*#__PURE__*/React.createElement(Box$1, {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0
  }, /*#__PURE__*/React.createElement(LinearProgress, {
    className: "bootstrap"
  })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    style: {
      marginTop: "1rem"
    }
  }, /*#__PURE__*/React.createElement(TextInput, {
    required: true,
    label: lang === "bn" ? "মোবাইল নাম্বার" : "Mobile Number",
    fullWidth: true,
    defaultValue: "",
    onChange: function onChange(mobileNumber) {
      return setInput("mobile_number", mobileNumber);
    }
  })), /*#__PURE__*/React.createElement("div", {
    id: "recaptcha-container",
    style: {
      marginTop: "1rem"
    }
  }), (serverResponse === null || serverResponse === void 0 ? void 0 : serverResponse.message) && /*#__PURE__*/React.createElement(Grid, {
    item: true,
    style: {
      marginTop: "1rem"
    }
  }, /*#__PURE__*/React.createElement(Box$1, {
    color: "error.main"
  }, getErrorMessage$1(serverResponse.message))), isOtpSent ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    style: {
      marginTop: "1rem"
    }
  }, /*#__PURE__*/React.createElement(InputLabel, {
    required: true,
    fullWidth: true,
    shrink: true,
    style: {
      marginBottom: 8
    }
  }, lang === "bn" ? "ওটিপি কোড" : "OTP Code"), /*#__PURE__*/React.createElement(OtpInput, {
    value: credentials.password,
    onChange: function onChange(otp) {
      return setInput("otp", otp);
    },
    numInputs: 5,
    renderSeparator: /*#__PURE__*/React.createElement("span", null, "-"),
    inputStyle: classes.otpInput,
    renderInput: function renderInput(props) {
      return /*#__PURE__*/React.createElement("input", props);
    }
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    style: {
      marginTop: "1rem"
    }
  }, /*#__PURE__*/React.createElement(Button, {
    fullWidth: true,
    disabled: !(credentials.username && credentials.password),
    color: "primary",
    variant: "contained",
    onClick: onSubmit
  }, lang === "bn" ? "লগইন করুন" : "Login"))) : /*#__PURE__*/React.createElement(Grid, {
    item: true,
    style: {
      marginTop: "1rem"
    }
  }, /*#__PURE__*/React.createElement(Button, {
    fullWidth: true,
    disabled: mobileNumber.length !== 11,
    color: "primary",
    variant: "contained",
    onClick: sendOtp
  }, lang === "bn" ? "ওটিপি পাঠান" : "Send OTP"))));
}

function ownKeys$9(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$9(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$9(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$9(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var useStyles$a = makeStyles$1(function (theme) {
  return {
    container: {
      position: "absolute",
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
      margin: "auto",
      display: "flex",
      justifyContent: "center",
      alignItems: "center"
    },
    paper: theme.paper.paper,
    logo: {
      width: "45%",
      padding: theme.spacing(2)
    },
    otpInput: _defineProperty(_defineProperty(_defineProperty({
      width: "100% !important",
      height: "2.2rem",
      margin: "0 .8rem",
      fontSize: "2rem",
      borderRadius: 8,
      border: "1px solid #006273",
      color: "#00668f",
      background: "transparent !important",
      textAlign: "center",
      outline: "none"
    }, "fontSize", "inherit"), "transition", "border-color 0.2s ease-in-out"), "&:focus", {
      borderColor: "#1976d2" // MUI primary color
    }),
    footerContainer: {
      marginTop: theme.spacing(4),
      // Fixes the "theme not defined" error
      textAlign: "center"
    },
    logoBox: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      // Keeps logos vertically centered
      marginTop: theme.spacing(2),
      flexWrap: "wrap",
      // Allows wrapping if the screen is too narrow
      gap: "10px"
    },
    footerLogo: {
      height: "50px",
      // Increased from 35px for better visibility
      width: "auto",
      // Maintains aspect ratio
      maxWidth: "100px",
      // Prevents any single logo from taking over
      objectFit: "contain"
    }
  };
});
var errorMessages = {
  INVALID_PHONE_NUMBER: "মোবাইল নম্বর ভুল দিয়েছেন। পুনরায় চেষ্টা করুন।",
  INCORRECT_CREDENTIALS: "তথ্য ভুল দিয়েছেন। পুনরায় চেষ্টা করুন।",
  GENERAL: "যান্ত্রিক ত্রুটি হয়েছে।"
};
var getErrorMessage = function getErrorMessage(messageKey) {
  return errorMessages[messageKey] || messageKey;
};
function LoginFormAdministrative() {
  var _useState = useState("bn"),
    _useState2 = _slicedToArray(_useState, 2),
    lang = _useState2[0];
    _useState2[1];
  var classes = useStyles$a();
  var modulesManager = useModulesManager();
  var _useTranslations = useTranslations("core.LoginPage", modulesManager);
    _useTranslations.formatMessage;
  var _useState3 = useState({}),
    _useState4 = _slicedToArray(_useState3, 2),
    credentials = _useState4[0],
    setCredentials = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    showPassword = _useState6[0],
    setShowPassword = _useState6[1];
  var auth = useAuthentication();
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    isAuthenticating = _useState8[0],
    setAuthenticating = _useState8[1];
  var _useState9 = useState({
      loginStatus: "",
      message: null
    }),
    _useState10 = _slicedToArray(_useState9, 2),
    serverResponse = _useState10[0],
    setServerResponse = _useState10[1];
  var history = useHistory();
  var handleLoginError = function handleLoginError(errorMessage) {
    setServerResponse({
      loginStatus: "CORE_AUTH_ERR",
      message: errorMessage
    });
    setAuthenticating(false);
  };
  var onSubmit = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(e) {
      var _response$payload, cookieexpires, response, loginStatus, message;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            e.preventDefault();
            setAuthenticating(true);
            _context.prev = 2;
            cookieexpires = "; expires=".concat(new Date(Date.now() + 864e5).toUTCString());
            document.cookie = "userType=".concat(encodeURIComponent("administrative")).concat(cookieexpires, "; path=/");
            _context.next = 7;
            return auth.login(credentials);
          case 7:
            response = _context.sent;
            if (!((_response$payload = response.payload) !== null && _response$payload !== void 0 && (_response$payload = _response$payload.errors) !== null && _response$payload !== void 0 && _response$payload.length)) {
              _context.next = 11;
              break;
            }
            handleLoginError(response.payload.errors[0].message);
            return _context.abrupt("return");
          case 11:
            loginStatus = response.loginStatus, message = response.message;
            setServerResponse({
              loginStatus: loginStatus,
              message: message
            });
            if (loginStatus === "CORE_AUTH_ERR") {
              setAuthenticating(false);
            } else {
              history.push("/");
            }
            _context.next = 19;
            break;
          case 16:
            _context.prev = 16;
            _context.t0 = _context["catch"](2);
            setAuthenticating(false);
          case 19:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[2, 16]]);
    }));
    return function onSubmit(_x) {
      return _ref.apply(this, arguments);
    };
  }();
  return /*#__PURE__*/React.createElement(React.Fragment, null, isAuthenticating && /*#__PURE__*/React.createElement(Box$1, {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0
  }, /*#__PURE__*/React.createElement(LinearProgress, {
    className: "bootstrap"
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.container
  }, /*#__PURE__*/React.createElement(Paper, {
    className: classes.paper,
    elevation: 2
  }, /*#__PURE__*/React.createElement("form", {
    onSubmit: onSubmit
  }, /*#__PURE__*/React.createElement(Box$1, {
    p: 6,
    width: 500
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 2,
    direction: "column",
    alignItems: "stretch"
  }, /*#__PURE__*/React.createElement(LoginHeader, null), /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Grid, {
    item: true
  }, /*#__PURE__*/React.createElement(TextInput, {
    required: true,
    readOnly: isAuthenticating,
    label: lang === "bn" ? "ইউজারনেম" : "Username",
    fullWidth: true,
    defaultValue: credentials.username,
    onChange: function onChange(username) {
      return setCredentials(_objectSpread$9(_objectSpread$9({}, credentials), {}, {
        username: username
      }));
    }
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true
  }, /*#__PURE__*/React.createElement(TextField, {
    required: true,
    readOnly: isAuthenticating,
    type: showPassword ? "text" : "password",
    label: lang === "bn" ? "পাসওয়ার্ড" : "Password",
    fullWidth: true,
    onChange: function onChange(e) {
      return setCredentials(_objectSpread$9(_objectSpread$9({}, credentials), {}, {
        password: e.target.value
      }));
    },
    InputProps: {
      endAdornment: /*#__PURE__*/React.createElement(InputAdornment, {
        position: "end"
      }, /*#__PURE__*/React.createElement(IconButton, {
        onClick: function onClick() {
          return setShowPassword(!showPassword);
        },
        edge: "end"
      }, showPassword ? /*#__PURE__*/React.createElement(VisibilityOff, null) : /*#__PURE__*/React.createElement(Visibility, null)))
    }
  })), (serverResponse === null || serverResponse === void 0 ? void 0 : serverResponse.message) && /*#__PURE__*/React.createElement(Grid, {
    item: true
  }, /*#__PURE__*/React.createElement(Box$1, {
    color: "error.main"
  }, getErrorMessage(serverResponse.message))), /*#__PURE__*/React.createElement(Grid, {
    item: true
  }, /*#__PURE__*/React.createElement(Button, {
    fullWidth: true,
    type: "submit",
    disabled: isAuthenticating || !(credentials.username && credentials.password),
    color: "primary",
    variant: "contained"
  }, lang === "bn" ? "লগইন করুন" : "Login")))))))));
}

var styles$6 = function styles(theme) {
  return {
    root: {
      display: "flex",
      justifyContent: "flex-start",
      alignItems: "center",
      padding: theme.spacing(1),
      backgroundColor: "transparent",
      gap: theme.spacing(2)
    },
    item: {
      display: "flex",
      alignItems: "center",
      gap: theme.spacing(0.5),
      cursor: "pointer",
      padding: "7px",
      borderRadius: "10px",
      "&:hover": {
        backgroundColor: "#517688",
        color: "#fff"
      }
    },
    label: {
      fontWeight: 500,
      fontSize: "0.875rem"
    }
  };
};
var UserInfo = function UserInfo(_ref) {
  var classes = _ref.classes;
  var user_type = getUserType();
  useHistory();
  useDispatch();
  var reduxStateUserInfo = useSelector(function (state) {
    return state.core.user.i_user;
  });
  return /*#__PURE__*/React.createElement(Box$1, {
    className: classes.root
  }, /*#__PURE__*/React.createElement(Box$1, {
    style: {
      display: "flex",
      flexDirection: "column",
      flexWrap: "wrap",
      textAlign: "right"
    }
  }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement("strong", null, reduxStateUserInfo.last_name)), /*#__PURE__*/React.createElement(Typography, null, user_type === WORKFORCE_USER_TYPE.ADMIN && /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.user.role.admin",
    defaultMessage: "Admin"
  }), user_type === WORKFORCE_USER_TYPE.DIRECTOR && /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.user.role.director",
    defaultMessage: "Director"
  }), user_type === WORKFORCE_USER_TYPE.FACTORY_ADMIN && /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.user.role.factoryAdmin",
    defaultMessage: "Factory Admin"
  }), user_type === WORKFORCE_USER_TYPE.BGMEA_ASSOCIATION && /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.user.role.bgmeaAssociation",
    defaultMessage: "BGMEA Association"
  }), user_type === WORKFORCE_USER_TYPE.BKMEA_ASSOCIATION && /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.user.role.bkmeaAssociation",
    defaultMessage: "BKMEA Association"
  }), user_type === WORKFORCE_USER_TYPE.SECTION_ADMIN && /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.user.role.sectionAdmin",
    defaultMessage: "Section Admin"
  }), user_type === WORKFORCE_USER_TYPE.CHECKER && /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.user.role.checker",
    defaultMessage: "Checker"
  }), user_type === WORKFORCE_USER_TYPE.CHECKER_TWO && /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.user.role.checkerTwo",
    defaultMessage: "Checker Two"
  }), user_type === WORKFORCE_USER_TYPE.DOCTOR && /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.user.role.doctor",
    defaultMessage: "Doctor"
  }), user_type === WORKFORCE_USER_TYPE.APPROVER && /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.user.role.approver",
    defaultMessage: "Approver"
  }), user_type === WORKFORCE_USER_TYPE.APPLICANT && /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.user.role.applicant",
    defaultMessage: "Applicant"
  }), user_type === WORKFORCE_USER_TYPE.SECRETARY && /*#__PURE__*/React.createElement(FormattedMessage, {
    module: "workforce",
    id: "workforce.user.role.secretary",
    defaultMessage: "Secretary"
  }))), /*#__PURE__*/React.createElement(AccountCircleIcon, null));
};
var UserInfo$1 = withStyles(styles$6)(UserInfo);

function _callSuper$6(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$6() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$6() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$6 = function _isNativeReflectConstruct() { return !!t; })(); }
var styles$5 = function styles(theme) {
  return {
    dialogTitle: theme.dialog.title,
    dialogContent: theme.dialog.content,
    form: {
      padding: 0
    },
    item: {
      padding: theme.spacing(1)
    },
    paperDivider: theme.paper.divider
  };
};
var WORKFORCE_ASSOCIATION_FILTER_CONTRIBUTION_KEY = "workforce.association.Filter";
var WorkforceAssociationFilter = /*#__PURE__*/function (_Component) {
  function WorkforceAssociationFilter() {
    var _this;
    _classCallCheck(this, WorkforceAssociationFilter);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper$6(this, WorkforceAssociationFilter, [].concat(args));
    _defineProperty(_this, "debouncedOnChangeFilter", _debounce(_this.props.onChangeFilters, 800));
    _defineProperty(_this, "_filterValue", function (k) {
      var filters = _this.props.filters;
      return !!filters && !!filters[k] ? filters[k].value : null;
    });
    _defineProperty(_this, "_onChangeReporter", function (k, v) {
      _this.props.onChangeFilters([{
        id: k,
        value: v,
        filter: "".concat(k, ": \"").concat(decodeId(v === null || v === void 0 ? void 0 : v.id), "\"")
      }]);
    });
    _defineProperty(_this, "_onChangeCheckbox", function (key, value) {
      var filters = [{
        id: key,
        value: value,
        filter: "".concat(key, ": ").concat(value)
      }];
      _this.props.onChangeFilters(filters);
      _this.props.setShowHistoryFilter(value);
    });
    return _this;
  }
  _inherits(WorkforceAssociationFilter, _Component);
  return _createClass(WorkforceAssociationFilter, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        classes = _this$props.classes,
        filters = _this$props.filters,
        onChangeFilters = _this$props.onChangeFilters;
      return /*#__PURE__*/React.createElement(Grid, {
        container: true,
        className: classes.form
      }, /*#__PURE__*/React.createElement(ControlledField, {
        module: MODULE_NAME,
        id: "workforce.association.name.en",
        field: /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 3,
          className: classes.item
        }, /*#__PURE__*/React.createElement(TextInput, {
          module: MODULE_NAME,
          label: "workforce.association.name.en",
          name: "nameEn",
          value: this._filterValue("nameEn"),
          onChange: function onChange(v) {
            return _this2.debouncedOnChangeFilter([{
              id: "nameEn",
              value: v,
              filter: "nameEn_Icontains: \"".concat(v, "\"")
            }]);
          }
        }))
      }), /*#__PURE__*/React.createElement(ControlledField, {
        module: MODULE_NAME,
        id: "workforce.association.name.en",
        field: /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 3,
          className: classes.item
        }, /*#__PURE__*/React.createElement(TextInput, {
          module: MODULE_NAME,
          label: "workforce.employee.first.name.bn",
          name: "nameBn",
          value: this._filterValue("nameBn"),
          onChange: function onChange(v) {
            return _this2.debouncedOnChangeFilter([{
              id: "nameBn",
              value: v,
              filter: "nameBn: \"".concat(v, "\"")
            }]);
          }
        }))
      }), /*#__PURE__*/React.createElement(ControlledField, {
        module: MODULE_NAME,
        id: "workforce.association.phone",
        field: /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 3,
          className: classes.item
        }, /*#__PURE__*/React.createElement(TextInput, {
          module: MODULE_NAME,
          label: "workforce.association.phone",
          name: "phone",
          value: this._filterValue("phone"),
          onChange: function onChange(v) {
            return _this2.debouncedOnChangeFilter([{
              id: "phone",
              value: v,
              filter: "phone: \"".concat(v, "\"")
            }]);
          }
        }))
      }), /*#__PURE__*/React.createElement(Contributions, {
        filters: filters,
        onChangeFilters: onChangeFilters,
        contributionKey: WORKFORCE_ASSOCIATION_FILTER_CONTRIBUTION_KEY
      }));
    }
  }]);
}(Component);
var WorkforceAssociationFilter$1 = withModulesManager(withTheme(withStyles(styles$5)(WorkforceAssociationFilter)));

function _callSuper$5(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$5() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$5() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$5 = function _isNativeReflectConstruct() { return !!t; })(); }
function ownKeys$8(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$8(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$8(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$8(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var styles$4 = function styles(theme) {
  return {
    paper: _objectSpread$8(_objectSpread$8({}, theme.paper.paper), {}, {
      margin: 0
    }),
    paperHeader: _objectSpread$8(_objectSpread$8({}, theme.paper.header), {}, {
      padding: 10
    }),
    tableTitle: theme.table.title,
    fab: theme.fab,
    button: {
      margin: theme.spacing(1)
    },
    item: {
      padding: theme.spacing(1)
    },
    horizontalButtonContainer: _objectSpread$8(_objectSpread$8({}, theme.buttonContainer.horizontal), {}, {
      display: "flex",
      alignItems: "center",
      gap: theme.spacing(1)
    }),
    compactButton: {
      maxHeight: "30px",
      minWidth: "80px",
      padding: "1px 4px",
      borderRadius: "6px",
      backgroundColor: "#006273",
      color: "white",
      fontSize: "0.7rem",
      textTransform: "none",
      marginRight: "2px",
      "&:hover": {
        backgroundColor: "#004a5e"
      }
    },
    buttonContainer: {
      display: "flex",
      gap: theme.spacing(1)
    }
  };
};
var WorkforceAssociationSearcher = /*#__PURE__*/function (_Component) {
  function WorkforceAssociationSearcher(props) {
    var _this;
    _classCallCheck(this, WorkforceAssociationSearcher);
    _this = _callSuper$5(this, WorkforceAssociationSearcher, [props]);
    _defineProperty(_this, "fetch", function (prms) {
      var showHistoryFilter = _this.state.showHistoryFilter;
      _this.setState({
        displayVersion: showHistoryFilter
      });
      _this.props.fetchWorkforceAllAssociationSummary(
      // this.props.modulesManager,
      prms);
    });
    _defineProperty(_this, "rowIdentifier", function (r) {
      return r.uuid;
    });
    _defineProperty(_this, "isShowHistory", function () {
      return _this.state.displayVersion;
    });
    _defineProperty(_this, "filtersToQueryParams", function (state) {
      var prms = Object.keys(state.filters).filter(function (f) {
        return !!state.filters[f].filter;
      }).map(function (f) {
        return state.filters[f].filter;
      });
      prms.push("first: ".concat(state.pageSize));
      if (state.afterCursor) {
        prms.push("after: \"".concat(state.afterCursor, "\""));
      }
      if (state.beforeCursor) {
        prms.push("before: \"".concat(state.beforeCursor, "\""));
      }
      return prms;
    });
    _defineProperty(_this, "headers", function () {
      return ["workforce.association.name.bn", "workforce.association.name.en", "workforce.association.phone", "workforce.association.email", "workforce.association.minimumSalary", _this.isShowHistory() ? "workforce.version" : ""];
    });
    _defineProperty(_this, "sorts", function () {
      return [];
    });
    _defineProperty(_this, "itemFormatters", function () {
      var formatters = [function (workforceassociation) {
        return workforceassociation.nameBn;
      }, function (workforceassociation) {
        return workforceassociation.nameEn;
      }, function (workforceassociation) {
        return workforceassociation.phone;
      }, function (workforceassociation) {
        return workforceassociation.email;
      }, function (workforceassociation) {
        return workforceassociation.minimumSalary;
      }, function (workforceassociation) {
        return _this.isShowHistory() ? workforceassociation === null || workforceassociation === void 0 ? void 0 : workforceassociation.version : null;
      }];
      formatters.push(function (workforceassociation) {
        return /*#__PURE__*/React.createElement("div", {
          className: _this.props.classes.horizontalButtonContainer
        }, /*#__PURE__*/React.createElement(Tooltip, {
          title: "Edit"
        }, /*#__PURE__*/React.createElement(IconButton, {
          disabled: workforceassociation === null || workforceassociation === void 0 ? void 0 : workforceassociation.isHistory,
          onClick: function onClick() {
            historyPush$1(_this.props.modulesManager, _this.props.history, "workforce.route.associations.association", [decodeId(workforceassociation.id)], false);
          }
        }, /*#__PURE__*/React.createElement(EditIcon, null))));
      });
      return formatters;
    });
    _defineProperty(_this, "rowDisabled", function (selection, i) {
      return !!i.validityTo;
    });
    _defineProperty(_this, "rowLocked", function (selection, i) {
      return !!i.clientMutationId;
    });
    _this.state = {
      chfid: null,
      confirmedAction: null,
      reset: 0,
      showHistoryFilter: false,
      displayVersion: false
    };
    _this.rowsPerPageOptions = [10, 20, 50, 100];
    _this.defaultPageSize = 10;
    return _this;
  }
  _inherits(WorkforceAssociationSearcher, _Component);
  return _createClass(WorkforceAssociationSearcher, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState, snapshot) {
      if (prevProps.submittingMutation && !this.props.submittingMutation) {
        this.props.journalize(this.props.mutation);
        this.setState({
          reset: prevState.reset + 1
        });
      } else if (!prevProps.confirmed && this.props.confirmed) {
        this.state.confirmedAction();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props;
        _this$props.intl;
        var workforceAllAssociations = _this$props.workforceAllAssociations,
        workforceAllAssociationsPageInfo = _this$props.workforceAllAssociationsPageInfo,
        fetchingWorkforceAllAssociations = _this$props.fetchingWorkforceAllAssociations,
        fetchedWorkforceAllAssociations = _this$props.fetchedWorkforceAllAssociations,
        errorWorkforceAllAssociations = _this$props.errorWorkforceAllAssociations,
        filterPaneContributionsKey = _this$props.filterPaneContributionsKey,
        cacheFiltersKey = _this$props.cacheFiltersKey,
        _onDoubleClick = _this$props.onDoubleClick;
      console.log({
        workforceAllAssociations: workforceAllAssociations
      });
      workforceAllAssociationsPageInfo.totalCount;
      var filterPane = function filterPane(_ref) {
        var filters = _ref.filters,
          onChangeFilters = _ref.onChangeFilters;
        return /*#__PURE__*/React.createElement(WorkforceAssociationFilter$1, {
          filters: filters,
          onChangeFilters: onChangeFilters,
          setShowHistoryFilter: function setShowHistoryFilter(showHistoryFilter) {
            return _this2.setState({
              showHistoryFilter: showHistoryFilter
            });
          }
        });
      };
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Searcher$2, {
        module: MODULE_NAME,
        cacheFiltersKey: cacheFiltersKey,
        FilterPane: filterPane,
        filterPaneContributionsKey: filterPaneContributionsKey,
        items: workforceAllAssociations,
        itemsPageInfo: workforceAllAssociationsPageInfo,
        fetchingItems: fetchingWorkforceAllAssociations,
        fetchedItems: fetchedWorkforceAllAssociations,
        errorItems: errorWorkforceAllAssociations,
        tableTitle: /*#__PURE__*/React.createElement(FormattedMessage, {
          module: MODULE_NAME,
          id: "menu.workforce.association"
        }),
        rowsPerPageOptions: this.rowsPerPageOptions,
        defaultPageSize: this.defaultPageSize,
        fetch: this.fetch,
        rowIdentifier: this.rowIdentifier,
        filtersToQueryParams: this.filtersToQueryParams,
        defaultOrderBy: "-dateCreated",
        headers: this.headers,
        itemFormatters: this.itemFormatters,
        sorts: this.sorts,
        rowDisabled: this.rowDisabled,
        rowLocked: this.rowLocked,
        onDoubleClick: function onDoubleClick(i) {
          return !i.clientMutationId && _onDoubleClick(i);
        },
        reset: this.state.reset
      }));
    }
  }]);
}(Component);
var mapStateToProps$5 = function mapStateToProps(state) {
  return {
    rights: !!state.core && !!state.core.user && !!state.core.user.i_user ? state.core.user.i_user.rights : [],
    workforceAllAssociations: state.workforce.workforceAllAssociations,
    workforceAllAssociationsPageInfo: state.workforce.workforceAllAssociationsPageInfo,
    fetchingWorkforceAllAssociations: state.workforce.fetchingWorkforceAllAssociations,
    fetchedWorkforceAllAssociations: state.workforce.fetchedWorkforceAllAssociations,
    errorWorkforceAllAssociations: state.workforce.errorWorkforceAllAssociations,
    submittingMutation: state.workforce.submittingMutation,
    mutation: state.workforce.mutation,
    confirmed: state.core.confirmed
  };
};
var mapDispatchToProps$2 = function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    fetchWorkforceAllAssociationSummary: fetchWorkforceAllAssociationSummary,
    journalize: journalize,
    coreConfirm: coreConfirm
  }, dispatch);
};
var WorkforceAssociationSearcher$1 = withModulesManager(withHistory(connect(mapStateToProps$5, mapDispatchToProps$2)(withTheme(withStyles(styles$4)(WorkforceAssociationSearcher)))));

function _callSuper$4(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$4() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$4() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$4 = function _isNativeReflectConstruct() { return !!t; })(); }
var styles$3 = function styles(theme) {
  return {
    page: theme.page,
    fab: theme.fab,
    ROUTE_WORKFORCE_ASSOCIATIONS_ASSOCIATION: ROUTE_WORKFORCE_ASSOCIATIONS_ASSOCIATION
  };
};
var WorkforceAsociationsPage = /*#__PURE__*/function (_Component) {
  function WorkforceAsociationsPage() {
    var _this;
    _classCallCheck(this, WorkforceAsociationsPage);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper$4(this, WorkforceAsociationsPage, [].concat(args));
    _defineProperty(_this, "onDoubleClick", function (assocition) {
      var newTab = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var routeParams = ["workforce.route.associations.association", [decodeId(assocition.id)]];
      if (assocition !== null && assocition !== void 0 && assocition.isHistory) {
        routeParams[1].push(assocition.version);
      }
      historyPush$1.apply(void 0, [_this.props.modulesManager, _this.props.history].concat(routeParams, [newTab]));
    });
    _defineProperty(_this, "onAdd", function () {
      historyPush$1(_this.props.modulesManager, _this.props.history, "workforce.route.associations.association");
    });
    return _this;
  }
  _inherits(WorkforceAsociationsPage, _Component);
  return _createClass(WorkforceAsociationsPage, [{
    key: "render",
    value: function render() {
      var _this$props = this.props;
        _this$props.intl;
        var classes = _this$props.classes;
        _this$props.rights;
      return /*#__PURE__*/React.createElement("div", {
        className: classes.page
      }, /*#__PURE__*/React.createElement(WorkforceAssociationSearcher$1, {
        cacheFiltersKey: "ticketPageFiltersCache",
        onDoubleClick: this.onDoubleClick
      }), withTooltip(/*#__PURE__*/React.createElement("div", {
        className: classes.fab
      }, /*#__PURE__*/React.createElement(Fab, {
        color: "primary",
        onClick: this.onAdd
      }, /*#__PURE__*/React.createElement(AddIcon, null))), /*#__PURE__*/React.createElement(FormattedMessage, {
        module: MODULE_NAME,
        id: "workforce.assocition.addNewTooltip"
      })));
    }
  }]);
}(Component);
var mapStateToProps$4 = function mapStateToProps(state) {
  return {
    rights: !!state.core && !!state.core.user && !!state.core.user.i_user ? state.core.user.i_user.rights : [],
    userType: getUserTypeFromRights(state.core.user.i_user.rights)
  };
};
var WorkforceAsociationsPage$1 = withModulesManager(withHistory(connect(mapStateToProps$4)(withTheme(withStyles(styles$3)(WorkforceAsociationsPage)))));

function ownKeys$7(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$7(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$7(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$7(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper$3(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$3() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$3() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$3 = function _isNativeReflectConstruct() { return !!t; })(); }
var styles$2 = function styles(theme) {
  return {
    paper: theme.paper.paper,
    tableTitle: theme.table.title,
    item: theme.paper.item,
    fullHeight: {
      height: "100%"
    }
  };
};
var EditWorkforceAssociationPage = /*#__PURE__*/function (_Component) {
  function EditWorkforceAssociationPage(props) {
    var _this;
    _classCallCheck(this, EditWorkforceAssociationPage);
    _this = _callSuper$3(this, EditWorkforceAssociationPage, [props]);
    _defineProperty(_this, "updateAttribute", function (key, value) {
      _this.setState(function (prevState) {
        return {
          stateEdited: _objectSpread$7(_objectSpread$7({}, prevState.stateEdited), {}, _defineProperty({}, key, value)),
          isSaved: false
        };
      });
    });
    _defineProperty(_this, "save", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var dispatch, stateEdited, workforceAssociationData;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            dispatch = _this.props.dispatch;
            stateEdited = _this.state.stateEdited;
            workforceAssociationData = {
              nameBn: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.nameBn) || stateEdited.nameBn,
              nameEn: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.nameEn) || stateEdited.nameEn,
              shortNameBn: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.shortNameBn) || stateEdited.shortNameBn,
              shortNameEn: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.shortNameEn) || stateEdited.shortNameEn,
              phone: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.phone) || stateEdited.phone,
              email: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.email) || stateEdited.email,
              status: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.status) || stateEdited.status,
              webAddress: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.webAddress) || stateEdited.webAddress,
              address: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.address) || stateEdited.address,
              minimumSalary: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.minimumSalary) || stateEdited.minimumSalary,
              id: stateEdited.id
            };
            _context.prev = 3;
            _context.next = 6;
            return dispatch(updateWorkforceAssociation(workforceAssociationData, "Update Workforce Association ".concat(workforceAssociationData.nameEn))).then(function (res) {
              return window.location.reload();
            });
          case 6:
            _this.setState({
              isSaved: true
            });
            _context.next = 12;
            break;
          case 9:
            _context.prev = 9;
            _context.t0 = _context["catch"](3);
            console.error("Failed to update workforce association:", _context.t0);
          case 12:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[3, 9]]);
    })));
    _this.state = {
      stateEdited: _objectSpread$7({}, props.workforceAllAssociation || {}),
      isSaved: false
    };
    return _this;
  }
  _inherits(EditWorkforceAssociationPage, _Component);
  return _createClass(EditWorkforceAssociationPage, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var previousAssociation = prevProps.workforceAllAssociation;
      var currentAssociation = this.props.workforceAllAssociation;
      if (currentAssociation && currentAssociation !== previousAssociation && currentAssociation.id) {
        this.setState({
          stateEdited: _objectSpread$7({}, currentAssociation),
          isSaved: false
        });
      }
      if (prevProps.submittingMutation && !this.props.submittingMutation) {
        this.props.dispatch(journalize(this.props.mutation));
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var classes = this.props.classes;
      var _this$state = this.state,
        stateEdited = _this$state.stateEdited,
        isSaved = _this$state.isSaved;
      console.log("Redux association:", this.props.workforceAllAssociation);
      console.log("Form state:", this.state.stateEdited);
      return /*#__PURE__*/React.createElement("div", {
        className: classes.page
      }, /*#__PURE__*/React.createElement(Grid, {
        container: true
      }, /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12
      }, /*#__PURE__*/React.createElement(Paper, {
        className: classes.paper
      }, /*#__PURE__*/React.createElement(Grid, {
        container: true,
        className: classes.tableTitle
      }, /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12,
        className: classes.tableTitle
      }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(FormattedMessage, {
        module: MODULE_NAME,
        id: "Workforce Association",
        values: {
          label: EMPTY_STRING
        }
      })))), /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement(Grid, {
        container: true,
        className: classes.item
      }, /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.association.name.en",
        value: stateEdited.nameEn || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("nameEn", v);
        },
        required: true,
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.association.name.bn",
        value: stateEdited.nameBn || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("nameBn", v);
        },
        required: true,
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.association.address",
        value: stateEdited.address || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("address", v);
        },
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.association.webAddress",
        value: stateEdited.webAddress || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("webAddress", v);
        },
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.association.phone",
        value: stateEdited.phone || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("phone", v);
        },
        type: "number",
        readOnly: isSaved,
        required: true
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.association.email",
        value: stateEdited.email || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("email", v);
        },
        type: "email",
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.association.status",
        value: stateEdited.status || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("status", v);
        },
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.association.shortName.en",
        value: stateEdited.shortNameEn || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("shortNameEn", v);
        },
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.association.shortName.bn",
        value: stateEdited.shortNameBn || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("shortNameBn", v);
        },
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.association.minimumSalary",
        value: stateEdited.minimumSalary || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("minimumSalary", v);
        },
        required: true,
        type: "number",
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 11,
        className: classes.item
      }), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 1,
        className: classes.item
      }, /*#__PURE__*/React.createElement(IconButton, {
        variant: "contained",
        component: "label",
        color: "primary",
        onClick: function onClick() {
          return _this2.save();
        },
        disabled: isSaved
      }, /*#__PURE__*/React.createElement(Save, null)))), /*#__PURE__*/React.createElement(Divider, null)))));
    }
  }]);
}(Component);
var mapStateToProps$3 = function mapStateToProps(state) {
  var _state$workforce$work;
  return {
    workforceAllAssociation: ((_state$workforce$work = state.workforce.workforceAllAssociations) === null || _state$workforce$work === void 0 ? void 0 : _state$workforce$work[0]) || {},
    submittingMutation: state.workforce.submittingMutation,
    mutation: state.workforce.mutation
  };
};
var EditWorkforceAssociationPage$1 = withHistory(connect(mapStateToProps$3)(withStyles(styles$2)(EditWorkforceAssociationPage)));

function ownKeys$6(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$6(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$6(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$6(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper$2(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$2() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$2() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$2 = function _isNativeReflectConstruct() { return !!t; })(); }
var styles$1 = function styles(theme) {
  return {
    paper: theme.paper.paper,
    tableTitle: theme.table.title,
    item: theme.paper.item,
    fullHeight: {
      height: "100%"
    }
  };
};
var AddWorkforceAssociationPage = /*#__PURE__*/function (_Component) {
  function AddWorkforceAssociationPage(props) {
    var _this;
    _classCallCheck(this, AddWorkforceAssociationPage);
    _this = _callSuper$2(this, AddWorkforceAssociationPage, [props]);
    _defineProperty(_this, "toggleSecondaryCalendar", function () {
      var isSecondaryCalendarEnabled = true;
      var dispatch = _this.props.dispatch;
      dispatch({
        type: "CORE_CALENDAR_TYPE_TOGGLE",
        payload: {
          isSecondaryCalendarEnabled: isSecondaryCalendarEnabled
        }
      });
    });
    _defineProperty(_this, "save", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var stateEdited, dispatch, workforceAssociationData;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            stateEdited = _this.state.stateEdited;
            dispatch = _this.props.dispatch;
            workforceAssociationData = {
              nameBn: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.nameBn) || stateEdited.nameBn,
              nameEn: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.nameEn) || stateEdited.nameEn,
              shortNameBn: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.shortNameBn) || stateEdited.shortNameBn,
              shortNameEn: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.shortNameEn) || stateEdited.shortNameEn,
              phone: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.phone) || stateEdited.phone,
              email: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.email) || stateEdited.email,
              status: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.status) || stateEdited.status,
              webAddress: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.webAddress) || stateEdited.webAddress,
              startDate: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.startDate) || stateEdited.startDate,
              address: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.address) || stateEdited.address,
              minimumSalary: (stateEdited === null || stateEdited === void 0 ? void 0 : stateEdited.minimumSalary) || stateEdited.minimumSalary,
              workforceAssociation: stateEdited.workforceAssociation
            };
            console.log({
              workforceAssociationData: workforceAssociationData
            });
            _context.next = 6;
            return dispatch(createWorkforceAssociation(workforceAssociationData, "Created Workforce Association ".concat(stateEdited.title)));
          case 6:
            _this.setState({
              isSaved: true
            });
          case 7:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })));
    _defineProperty(_this, "updateAttribute", function (key, value) {
      _this.setState(function (prevState) {
        return {
          stateEdited: _objectSpread$6(_objectSpread$6({}, prevState.stateEdited), {}, _defineProperty({}, key, value)),
          isSaved: false
        };
      });
    });
    _this.state = {
      stateEdited: {},
      isSaved: false
    };
    return _this;
  }
  _inherits(AddWorkforceAssociationPage, _Component);
  return _createClass(AddWorkforceAssociationPage, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props = this.props,
        submittingMutation = _this$props.submittingMutation,
        mutation = _this$props.mutation,
        dispatch = _this$props.dispatch;
      if (!submittingMutation && prevProps.submittingMutation !== submittingMutation) {
        dispatch(journalize(mutation));
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      // this.toggleSecondaryCalendar()
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var classes = this.props.classes;
      var _this$state = this.state,
        stateEdited = _this$state.stateEdited,
        isSaved = _this$state.isSaved;
      return /*#__PURE__*/React.createElement("div", {
        className: classes.page
      }, /*#__PURE__*/React.createElement(Grid, {
        container: true
      }, /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12
      }, /*#__PURE__*/React.createElement(Paper, {
        className: classes.paper
      }, /*#__PURE__*/React.createElement(Grid, {
        container: true,
        className: classes.tableTitle
      }, /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12,
        className: classes.tableTitle
      }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(FormattedMessage, {
        module: MODULE_NAME,
        id: "Workforce Association",
        values: {
          label: EMPTY_STRING
        }
      })))), /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement(Grid, {
        container: true,
        className: classes.item
      }, /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.association.name.en",
        value: stateEdited.nameEn || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("nameEn", v);
        },
        required: true,
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.association.name.bn",
        value: stateEdited.nameBn || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("nameBn", v);
        },
        required: true,
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.association.address",
        value: stateEdited.presentAddress || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("address", v);
        },
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.association.webAddress",
        value: stateEdited.webAddress || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("webAddress", v);
        },
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(PublishedComponent, {
        pubRef: "workforce.DatePicker",
        label: "workforce.association.startDate",
        value: stateEdited.startDate || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("startDate", v);
        },
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.association.phone",
        value: stateEdited.phone || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("phone", v);
        },
        type: "number",
        readOnly: isSaved,
        required: true
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.association.email",
        value: stateEdited.email || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("email", v);
        },
        type: "email",
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.association.status",
        value: stateEdited.status || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("status", v);
        },
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.association.shortName.en",
        value: stateEdited.shortNameEn || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("shortNameEn", v);
        },
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.association.shortName.bn",
        value: stateEdited.lastNameBn || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("shortNameBn", v);
        },
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 6,
        className: classes.item
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: "workforce.association.minimumSalary",
        value: stateEdited.minimumSalary || "",
        onChange: function onChange(v) {
          return _this2.updateAttribute("minimumSalary", v);
        },
        required: true,
        type: "number",
        readOnly: isSaved
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 11,
        className: classes.item
      }), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 1,
        className: classes.item
      }, /*#__PURE__*/React.createElement(IconButton, {
        variant: "contained",
        component: "label",
        color: "primary",
        onClick: function onClick() {
          return _this2.save();
        },
        disabled: isSaved
      }, /*#__PURE__*/React.createElement(Save, null)))), /*#__PURE__*/React.createElement(Divider, null)))));
    }
  }]);
}(Component);
var mapStateToProps$2 = function mapStateToProps(state) {
  return {
    submittingMutation: state.workforce.submittingMutation,
    mutation: state.workforce.mutation
  };
};
var AddWorkforceAssociationPage$1 = connect(mapStateToProps$2)(withStyles(styles$1)(AddWorkforceAssociationPage));

function ownKeys$5(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$5(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$5(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$5(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper$1(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$1() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$1() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$1 = function _isNativeReflectConstruct() { return !!t; })(); }
var WorkforceAssociationForm = /*#__PURE__*/function (_Component) {
  function WorkforceAssociationForm(props) {
    var _this;
    _classCallCheck(this, WorkforceAssociationForm);
    _this = _callSuper$1(this, WorkforceAssociationForm, [props]);
    _defineProperty(_this, "reload", function () {});
    _defineProperty(_this, "canSave", function () {});
    _defineProperty(_this, "_save", function (workforceAllAssociation) {
      _this.setState({
        lockNew: !workforceAllAssociation.uuid
      }, function () {
        return _this.props.save(workforceAllAssociation);
      });
    });
    _defineProperty(_this, "onEditedChanged", function (workforceAllAssociation) {
      _this.setState({
        workforceAllAssociation: workforceAllAssociation
      });
    });
    _defineProperty(_this, "reopenTicket", function () {
      var _this$props = _this.props,
        intl = _this$props.intl,
        workforceAllAssociation = _this$props.workforceAllAssociation;
      _this.props.reopenTicket(workforceAllAssociation.id, formatMessage(intl, MODULE_NAME, "reopenTicket.mutation.label"));
    });
    _this.lastRefreshedMutationId = null;
    _this.state = {
      lockNew: false,
      reset: 0,
      workforceAssociationUuid: null,
      workforceAllAssociation: _this._newTicket()
    };
    return _this;
  }
  _inherits(WorkforceAssociationForm, _Component);
  return _createClass(WorkforceAssociationForm, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.workforceAssociationUuid) {
        this.setState({
          workforceAssociationUuid: safeDecodeId(this.props.workforceAssociationUuid)
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {}
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState, snapshot) {
      if (prevProps.fetchedWorkforceAllAssociation !== this.props.fetchedWorkforceAllAssociation && !!this.props.fetchedWorkforceAllAssociation && !!this.props.workforceAllAssociation) {
        this.setState(function (state, props) {
          return {
            workforceAllAssociation: _objectSpread$5({}, props.workforceAllAssociation),
            workforceAssociationUuid: safeDecodeId(props.workforceAllAssociation.id),
            lockNew: false
          };
        });
      } else if (prevState.workforceAssociationUuid !== this.state.workforceAssociationUuid) {
        var filters = ["id: \"".concat(safeDecodeId(this.state.workforceAssociationUuid), "\"")];
        this.props.fetchWorkforceAllAssociation(this.props.modulesManager, filters);
      } else if (prevProps.submittingMutation && !this.props.submittingMutation) {
        var _this$props$mutation, _this$props2;
        var mutationId = ((_this$props$mutation = this.props.mutation) === null || _this$props$mutation === void 0 ? void 0 : _this$props$mutation.clientMutationId) || JSON.stringify(this.props.mutation || {});
        if (mutationId === this.lastRefreshedMutationId) {
          return;
        }
        this.lastRefreshedMutationId = mutationId;
        this.props.journalize(this.props.mutation);
        // this.setState((state) => ({ reset: state.reset + 1 }));
        if ((_this$props2 = this.props) !== null && _this$props2 !== void 0 && (_this$props2 = _this$props2.workforceAllAssociation) !== null && _this$props2 !== void 0 && _this$props2.id) {
          this.props.fetchWorkforceAllAssociation(this.props.modulesManager, ["id: \"".concat(safeDecodeId(this.state.workforceAssociationUuid), "\"")]);
        }
      }
    }
  }, {
    key: "_newTicket",
    value: function _newTicket() {
      return {};
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
        fetchingTicket = _this$props3.fetchingTicket,
        fetchedWorkforceAllAssociation = _this$props3.fetchedWorkforceAllAssociation,
        workforceAllAssociation = _this$props3.workforceAllAssociation,
        errorTicket = _this$props3.errorTicket,
        save = _this$props3.save,
        back = _this$props3.back;
      var _this$state = this.state,
        lockNew = _this$state.lockNew,
        reset = _this$state.reset,
        update = _this$state.update,
        overview = _this$state.overview,
        workforceAssociationUuid = _this$state.workforceAssociationUuid;
      var readOnly = lockNew || this.props.readOnly;
      [{
        doIt: this.reopenTicket,
        icon: /*#__PURE__*/React.createElement(LockOpenIcon, null),
        disabled: workforceAllAssociation
      }];
      console.log("workforceAllAssociation", workforceAllAssociation);
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ProgressOrError, {
        progress: fetchingTicket,
        error: errorTicket
      }), (!!fetchedWorkforceAllAssociation || !workforceAssociationUuid) && /*#__PURE__*/React.createElement(Form, {
        module: MODULE_NAME,
        edited_id: workforceAssociationUuid,
        edited: workforceAllAssociation,
        reset: reset,
        update: update,
        title: "Workforce Association",
        titleParams: {
          label: "Label"
        },
        back: back,
        save: save ? this._save : null,
        canSave: this.canSave,
        reload: (workforceAssociationUuid || readOnly) && this.reload,
        readOnly: readOnly,
        overview: overview,
        Panels: workforceAssociationUuid ? [EditWorkforceAssociationPage$1] : [AddWorkforceAssociationPage$1],
        onEditedChanged: this.onEditedChanged
      }));
    }
  }]);
}(Component); // eslint-disable-next-line no-unused-vars
var mapStateToProps$1 = function mapStateToProps(state, props) {
  var _state$core, _state$workforce$work;
  return {
    rights: ((_state$core = state.core) === null || _state$core === void 0 || (_state$core = _state$core.user) === null || _state$core === void 0 || (_state$core = _state$core.i_user) === null || _state$core === void 0 ? void 0 : _state$core.rights) || [],
    fetchingTicket: state.workforce.fetchingWorkforceAllAssociations,
    errorTicket: state.workforce.errorWorkforceAllAssociations,
    workforceAllAssociation: (_state$workforce$work = state.workforce.workforceAllAssociations) === null || _state$workforce$work === void 0 ? void 0 : _state$workforce$work[0],
    fetchingWorkforceAllAssociation: state.workforce.fetchingWorkforceAllAssociations,
    fetchedWorkforceAllAssociation: state.workforce.fetchedWorkforceAllAssociations,
    errorWorkforceAllAssociation: state.workforce.errorWorkforceAllAssociations,
    submittingMutation: state.workforce.submittingMutation,
    mutation: state.workforce.mutation
  };
};
var mapDispatchToProps$1 = function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    fetchWorkforceAllAssociation: fetchWorkforceAllAssociation,
    journalize: journalize
  }, dispatch);
};
var WorkforceAssociationForm$1 = withModulesManager(connect(mapStateToProps$1, mapDispatchToProps$1)(WorkforceAssociationForm));

function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var styles = function styles(theme) {
  return {
    page: theme.page,
    lockedPage: theme.page.locked
  };
};
var WorkforceAsociationPage = /*#__PURE__*/function (_Component) {
  function WorkforceAsociationPage() {
    var _this;
    _classCallCheck(this, WorkforceAsociationPage);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, WorkforceAsociationPage, [].concat(args));
    _defineProperty(_this, "add", function () {
      historyPush$1(_this.props.modulesManager, _this.props.history, "grievance.route.ticket");
    });
    _defineProperty(_this, "save", function (employee) {
      if (!employee.id) {
        _this.props.createWorkforceAssociation(_this.props.modulesManager, employee, "Create");
      } else {
        _this.props.updateWorkforceAssociation(_this.props.modulesManager, employee, "Update");
      }
    });
    return _this;
  }
  _inherits(WorkforceAsociationPage, _Component);
  return _createClass(WorkforceAsociationPage, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        classes = _this$props.classes,
        modulesManager = _this$props.modulesManager,
        history = _this$props.history,
        rights = _this$props.rights,
        workforceAssociationUuid = _this$props.workforceAssociationUuid,
        overview = _this$props.overview,
        organizationVersion = _this$props.organizationVersion;
      // const readOnly = organization?.status === TICKET_STATUSES.CLOSED || ticket?.isHistory;
      var readOnly = false;
      // if (!(rights.includes(RIGHT_ORGANIZATION_CREATE) || rights.includes(RIGHT_ORGANIZATION_EDIT))) return null;
      return /*#__PURE__*/React.createElement("div", {
        className: "".concat(null, " ").concat(classes.page)
      }, /*#__PURE__*/React.createElement(WorkforceAssociationForm$1, {
        overview: overview,
        workforceAssociationUuid: workforceAssociationUuid,
        organizationVersion: organizationVersion,
        readOnly: readOnly,
        back: function back() {
          return historyPush$1(modulesManager, history, "workforce.route.associations");
        },
        add: rights.includes(RIGHT_ORGANIZATION_CREATE) ? this.add : null,
        save: rights.includes(RIGHT_ORGANIZATION_EDIT) ? this.save : null
      }));
    }
  }]);
}(Component);
var mapStateToProps = function mapStateToProps(state, props) {
  return {
    rights: !!state.core && !!state.core.user && !!state.core.user.i_user ? state.core.user.i_user.rights : [],
    workforceAssociationUuid: props.match.params.workforce_association_uuid,
    organizationVersion: props.match.params.version,
    employee: state.workforce.employee,
    userType: getUserTypeFromRights(state.core.user.i_user.rights)
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    createWorkforceEmployee: createWorkforceEmployee,
    updateWorkforceEmployee: updateWorkforceEmployee,
    createWorkforceAssociation: createWorkforceAssociation,
    updateWorkforceAssociation: updateWorkforceAssociation
  }, dispatch);
};
var WorkforceAsociationPage$1 = withHistory(withModulesManager(connect(mapStateToProps, mapDispatchToProps)(withTheme(withStyles(styles)(WorkforceAsociationPage)))));

var useStyles$9 = makeStyles(function (theme) {
  return {
    card: {
      marginBottom: theme.spacing(3)
    },
    formControl: {
      margin: theme.spacing(1),
      minWidth: '100%'
    },
    submitButton: {
      marginTop: theme.spacing(2),
      height: '56px' // Matches standard MUI input height
    },
    tableHeader: {
      backgroundColor: theme.palette.grey[100],
      fontWeight: 'bold'
    }
  };
});
var AssociationUserMappingPage = function AssociationUserMappingPage() {
  var _reduxState$core;
  var classes = useStyles$9();
  var dispatch = useDispatch();

  // Local State for form selections
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    selectedAssociation = _useState2[0],
    setSelectedAssociation = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    selectedUser = _useState4[0],
    setSelectedUser = _useState4[1];
  var currentUserId = useSelector(function (state) {
    var _state$core;
    return (_state$core = state.core) === null || _state$core === void 0 || (_state$core = _state$core.user) === null || _state$core === void 0 || (_state$core = _state$core.i_user) === null || _state$core === void 0 ? void 0 : _state$core.id;
  });
  var userRights = useSelector(function (state) {
    return state.core.user.i_user.rights;
  });
  var userType = getUserTypeFromRights(userRights);
  // Redux Selectors - IMPORTANT: Adjust these paths to match your actual Redux store
  var _useState5 = useState([]),
    _useState6 = _slicedToArray(_useState5, 2),
    associations = _useState6[0],
    setAssociations = _useState6[1];
  var _useState7 = useState([]),
    _useState8 = _slicedToArray(_useState7, 2),
    users = _useState8[0],
    setUsers = _useState8[1];
  var _useState9 = useState([]),
    _useState10 = _slicedToArray(_useState9, 2),
    mappings = _useState10[0],
    setMappings = _useState10[1];
  var _useState11 = useState([]),
    _useState12 = _slicedToArray(_useState11, 2);
    _useState12[0];
    var setCurrentUserAssociations = _useState12[1];
  var _useState13 = useState(false),
    _useState14 = _slicedToArray(_useState13, 2);
    _useState14[0];
    var setMainDataLoaded = _useState14[1];

  // const loadAssociationData = async () => {

  //     const associationFilters = [];
  //     if (currentUserAssociations.length > 0) {
  //         const associationFilterString = currentUserAssociations.map(id => `"${id}"`).join(",");
  //         associationFilters.push(`idIn:[${associationFilterString}]`);
  //     }
  //     else{
  //     }
  //     dispatch(fetchWorkforceAllAssociationSummary(associationFilters))
  //         .then((response) => {
  //             setAssociations(response?.payload?.data?.workforceAllAssociation?.edges || []);
  //         });
  //     console.log("Association Filters for fetching associations:", associationFilters);
  // };

  // useEffect(() => {
  //     if (userType === WORKFORCE_USER_TYPE.ASSOCIATION) {
  //         loadAssociationData();
  //     }
  // }, [mainDataLoaded==true]);

  // Fetch initial data on component mount
  var loadData = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _mapResponse$payload;
      var mapFilters, mapResponse, edges, associationIds, associationFilters, associationFilterString;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            setMainDataLoaded(false);
            mapFilters = [];
            _context.next = 4;
            return dispatch(fetchWorkforceInteractiveUsers([])).then(function (response) {
              var _response$payload;
              setUsers((response === null || response === void 0 || (_response$payload = response.payload) === null || _response$payload === void 0 || (_response$payload = _response$payload.data) === null || _response$payload === void 0 ? void 0 : _response$payload.workforceInteractiveUsers) || []);
            });
          case 4:
            if (currentUserId && userType === WORKFORCE_USER_TYPE.ASSOCIATION) {
              mapFilters.push("userId:".concat(currentUserId));
            }
            _context.next = 7;
            return dispatch(fetchWorkforceAssociationUserMaps(mapFilters));
          case 7:
            mapResponse = _context.sent;
            edges = (mapResponse === null || mapResponse === void 0 || (_mapResponse$payload = mapResponse.payload) === null || _mapResponse$payload === void 0 || (_mapResponse$payload = _mapResponse$payload.data) === null || _mapResponse$payload === void 0 || (_mapResponse$payload = _mapResponse$payload.workforceAssociationUserMap) === null || _mapResponse$payload === void 0 ? void 0 : _mapResponse$payload.edges) || [];
            setMappings(edges);

            // ✅ Use edges directly
            associationIds = edges.map(function (mapping) {
              return safeDecodeId(mapping.node.allAssociation.id);
            });
            setCurrentUserAssociations(associationIds);
            console.log("Current User Associations:", associationIds);
            associationFilters = [];
            if (userType === WORKFORCE_USER_TYPE.ASSOCIATION && associationIds.length > 0) {
              associationFilterString = associationIds.map(function (id) {
                return "\"".concat(id, "\"");
              }).join(",");
              associationFilters.push("idIn:[".concat(associationFilterString, "]"));
            }
            dispatch(fetchWorkforceAllAssociationSummary(associationFilters)).then(function (response) {
              var _response$payload2;
              setAssociations((response === null || response === void 0 || (_response$payload2 = response.payload) === null || _response$payload2 === void 0 || (_response$payload2 = _response$payload2.data) === null || _response$payload2 === void 0 || (_response$payload2 = _response$payload2.workforceAllAssociation) === null || _response$payload2 === void 0 ? void 0 : _response$payload2.edges) || []);
            });
            console.log("Association Filters for fetching associations:", associationFilters);
            setMainDataLoaded(true);
          case 18:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function loadData() {
      return _ref.apply(this, arguments);
    };
  }();
  useEffect(function () {
    loadData();
  }, [dispatch, currentUserId, userType]);

  // Handle Form Submission
  var handleSaveMapping = function handleSaveMapping() {
    if (!selectedAssociation || !selectedUser) return;
    var payload = {
      associationId: safeDecodeId(selectedAssociation),
      userId: safeDecodeId(selectedUser)
    };
    dispatch(createWorkforceAssociationUserMap(payload, "createWorkforceAssociationUserMap")).then(function () {
      // Clear form after successful creation
      setSelectedAssociation('');
      setSelectedUser('');
      // Re-fetch the mappings to update the table below
      loadData();
    })["catch"](function (error) {
      console.error("Failed to map association to user:", error);
      // Add toast/snackbar error handling here if needed
    });
  };
  var handleDelete = function handleDelete(mappingId) {
    if (!confirm("Are you sure you want to delete this mapping?")) {
      return;
    }
    console.log("Attempting to delete mapping with ID:", safeDecodeId(mappingId));
    dispatch(deleteWorkforceAssociationUserMap({
      id: safeDecodeId(mappingId)
    })).then(function () {
      setSelectedAssociation('');
      setSelectedUser('');
      loadData();
    })["catch"](function (error) {
      console.error("Failed to delete association user mapping:", error);
    });
  };
  var reduxState = useSelector(function (state) {
    return state;
  });
  var locale = (reduxState === null || reduxState === void 0 || (_reduxState$core = reduxState.core) === null || _reduxState$core === void 0 || (_reduxState$core = _reduxState$core.user) === null || _reduxState$core === void 0 || (_reduxState$core = _reduxState$core.i_user) === null || _reduxState$core === void 0 ? void 0 : _reduxState$core.language) || 'en';
  return /*#__PURE__*/React.createElement("div", {
    style: {
      width: "90%",
      margin: "auto",
      marginTop: "40px"
    }
  }, /*#__PURE__*/React.createElement(Card, {
    className: classes.card,
    elevation: 2
  }, /*#__PURE__*/React.createElement(CardHeader, {
    title: locale === 'fr' ? "অ্যাসোসিএশনের ব্যবহারকারী ম্যাপিং" : "Association-User Mapping",
    subheader: locale === 'fr' ? "একটি অ্যাসোসিয়েশনকে একজন ব্যবহারকারীর সাথে ম্যাপ করুন" : "Map an association to a user"
  }), /*#__PURE__*/React.createElement(CardContent, null, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 3,
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 5
  }, /*#__PURE__*/React.createElement(Autocomplete$2, {
    id: "association-select-autocomplete",
    options: associations,
    getOptionLabel: function getOptionLabel(option) {
      return locale === 'fr' ? "".concat(option.node.nameBn, " (").concat(option.node.shortNameBn, ")") : "".concat(option.node.nameEn, " (").concat(option.node.shortNameEn, ")");
    }

    // IMPORTANT FOR MUI v4: This prevents warnings when React compares the selected object to the options array
    ,
    getOptionSelected: function getOptionSelected(option, value) {
      return option.node.id === value.node.id;
    },
    value: selectedAssociation ? associations.find(function (assoc) {
      return assoc.node.id === selectedAssociation;
    }) || null : null,
    onChange: function onChange(event, newValue) {
      setSelectedAssociation(newValue ? newValue.node.id : "");
    },
    renderInput: function renderInput(params) {
      return /*#__PURE__*/React.createElement(TextField, _extends({}, params, {
        label: locale === 'fr' ? "অ্যাসোসিয়েশন নির্বাচন করুন" : "Select Association",
        variant: "outlined"
        // Apply your existing class here to maintain spacing/styling
        ,
        className: classes.formControl
      }));
    }
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 5
  }, /*#__PURE__*/React.createElement(Autocomplete$2, {
    id: "user-select-autocomplete",
    options: users,
    getOptionLabel: function getOptionLabel(option) {
      return locale === 'fr' ? "".concat(option.loginName, " (").concat(option.lastNameBn, ")") : "".concat(option.loginName, " (").concat(option.lastNameEn, ")");
    }

    // IMPORTANT FOR MUI v4: This prevents warnings when React compares the selected object to the options array
    ,
    getOptionSelected: function getOptionSelected(option, value) {
      return option.id === value.id;
    },
    value: users.find(function (user) {
      return user.id === selectedUser;
    }) || null,
    onChange: function onChange(event, newValue) {
      setSelectedUser(newValue ? newValue.id : "");
    },
    renderInput: function renderInput(params) {
      return /*#__PURE__*/React.createElement(TextField, _extends({}, params, {
        label: locale === 'fr' ? "ব্যবহারকারী" : "User",
        variant: "outlined"
        // Apply your existing class here to maintain spacing/styling
        ,
        className: classes.formControl
      }));
    }
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 2
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "contained",
    color: "primary",
    fullWidth: true,
    className: classes.submitButton,
    startIcon: /*#__PURE__*/React.createElement(SaveIcon, null),
    onClick: handleSaveMapping,
    disabled: !selectedAssociation || !selectedUser,
    style: {
      marginTop: "-7px"
    }
  }, locale === 'fr' ? "সংরক্ষণ করুন" : "Save"))))), /*#__PURE__*/React.createElement(Card, {
    elevation: 2
  }, /*#__PURE__*/React.createElement(CardHeader, {
    title: locale === 'fr' ? "বিদ্যমান ম্যাপিং" : "Existing Mappings"
  }), /*#__PURE__*/React.createElement(CardContent, null, mappings.length === 0 ? /*#__PURE__*/React.createElement(Typography, {
    color: "textSecondary"
  }, locale === 'fr' ? "কোন ম্যাপিং পাওয়া যায়নি।" : "No mappings found.") : /*#__PURE__*/React.createElement(TableContainer, {
    component: Paper,
    elevation: 0,
    variant: "outlined"
  }, /*#__PURE__*/React.createElement(Table$2, {
    "aria-label": "mappings table"
  }, /*#__PURE__*/React.createElement(TableHead, null, /*#__PURE__*/React.createElement(TableRow, null, /*#__PURE__*/React.createElement(TableCell, {
    className: classes.tableHeader
  }, locale === 'fr' ? "অ্যাসোসিএশন" : "Association"), /*#__PURE__*/React.createElement(TableCell, {
    className: classes.tableHeader
  }, locale === 'fr' ? "ব্যবহারকারী" : "User"), /*#__PURE__*/React.createElement(TableCell, {
    className: classes.tableHeader
  }, locale === 'fr' ? "ক্রিয়া" : "Actions"))), /*#__PURE__*/React.createElement(TableBody, null, mappings.map(function (row) {
    var _row$node$allAssociat, _row$node$allAssociat2, _row$node$allAssociat3, _row$node$allAssociat4, _row$node$user, _row$node$user2, _row$node$user3;
    return /*#__PURE__*/React.createElement(TableRow, {
      key: row.node.id
    }, /*#__PURE__*/React.createElement(TableCell, null, locale === 'fr' ? ((_row$node$allAssociat = row.node.allAssociation) === null || _row$node$allAssociat === void 0 ? void 0 : _row$node$allAssociat.nameBn) + " (" + ((_row$node$allAssociat2 = row.node.allAssociation) === null || _row$node$allAssociat2 === void 0 ? void 0 : _row$node$allAssociat2.shortNameBn) + ")" : ((_row$node$allAssociat3 = row.node.allAssociation) === null || _row$node$allAssociat3 === void 0 ? void 0 : _row$node$allAssociat3.nameEn) + " (" + ((_row$node$allAssociat4 = row.node.allAssociation) === null || _row$node$allAssociat4 === void 0 ? void 0 : _row$node$allAssociat4.shortNameEn) + ")"), /*#__PURE__*/React.createElement(TableCell, null, ((_row$node$user = row.node.user) === null || _row$node$user === void 0 ? void 0 : _row$node$user.loginName) + "(" + (locale === 'fr' ? (_row$node$user2 = row.node.user) === null || _row$node$user2 === void 0 ? void 0 : _row$node$user2.lastNameBn : (_row$node$user3 = row.node.user) === null || _row$node$user3 === void 0 ? void 0 : _row$node$user3.lastNameEn) + ")" || row.node.userId), /*#__PURE__*/React.createElement(TableCell, null, /*#__PURE__*/React.createElement(IconButton, {
      color: "error",
      onClick: function onClick() {
        return handleDelete(row.node.id);
      }
    }, /*#__PURE__*/React.createElement(DeleteIcon, null))));
  })))))));
};

function ownKeys$4(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$4(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$4(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$4(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var useStyles$8 = makeStyles$2(function (theme) {
  return {
    dialogForm: {
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(2)
    },
    dialogActions: {
      padding: theme.spacing(2),
      gap: theme.spacing(1)
    }
  };
});
var AddCommitteeDialog = function AddCommitteeDialog(_ref) {
  var open = _ref.open,
    onClose = _ref.onClose,
    onSave = _ref.onSave,
    committee = _ref.committee,
    setCommittee = _ref.setCommittee,
    associations = _ref.associations,
    locale = _ref.locale;
  var classes = useStyles$8();
  var handleSave = function handleSave() {
    if (!committee.nameEn || !committee.nameBn) {
      alert('Please fill in all required fields');
      return;
    }
    onSave();
  };
  return /*#__PURE__*/React.createElement(Dialog$1, {
    open: open,
    onClose: onClose,
    maxWidth: "sm",
    fullWidth: true
  }, /*#__PURE__*/React.createElement(DialogTitle, null, locale === 'fr' ? "নতুন কমিটি যোগ করুন" : "Add New Committee"), /*#__PURE__*/React.createElement(DialogContent$1, {
    className: classes.dialogForm
  }, /*#__PURE__*/React.createElement(TextField, {
    label: locale === 'fr' ? "কমিটির নাম (ইংরেজি) *" : "Committee Name (English) *",
    value: committee.nameEn,
    onChange: function onChange(e) {
      return setCommittee(_objectSpread$4(_objectSpread$4({}, committee), {}, {
        nameEn: e.target.value
      }));
    },
    fullWidth: true,
    variant: "outlined",
    required: true
  }), /*#__PURE__*/React.createElement(TextField, {
    label: locale === 'fr' ? "কমিটির নাম (বাংলা) *" : "Committee Name (Bangla) *",
    value: committee.nameBn,
    onChange: function onChange(e) {
      return setCommittee(_objectSpread$4(_objectSpread$4({}, committee), {}, {
        nameBn: e.target.value
      }));
    },
    fullWidth: true,
    variant: "outlined",
    required: true
  }), /*#__PURE__*/React.createElement(TextField, {
    label: locale === 'fr' ? "বিবরণ" : "Description",
    value: committee.description,
    onChange: function onChange(e) {
      return setCommittee(_objectSpread$4(_objectSpread$4({}, committee), {}, {
        description: e.target.value
      }));
    },
    fullWidth: true,
    variant: "outlined",
    multiline: true,
    rows: 3
  }), !isBlwfPath() && /*#__PURE__*/React.createElement(Autocomplete$2, {
    multiple: true,
    id: "included-sectors-autocomplete",
    options: associations,
    getOptionLabel: function getOptionLabel(option) {
      return locale === 'fr' ? "".concat(option.node.nameBn, " (").concat(option.node.shortNameBn, ")") : "".concat(option.node.nameEn, " (").concat(option.node.shortNameEn, ")");
    },
    getOptionSelected: function getOptionSelected(option, value) {
      return option.node.id === value.node.id;
    },
    value: committee.includedSectors || [],
    onChange: function onChange(event, newValue) {
      setCommittee(_objectSpread$4(_objectSpread$4({}, committee), {}, {
        includedSectors: newValue
      }));
    },
    renderInput: function renderInput(params) {
      return /*#__PURE__*/React.createElement(TextField, _extends({}, params, {
        label: locale === 'fr' ? "অন্তর্ভুক্ত সেক্টর" : "Included Sectors",
        variant: "outlined",
        required: true
      }));
    }
  })), /*#__PURE__*/React.createElement(DialogActions$1, {
    className: classes.dialogActions
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: onClose,
    color: "default"
  }, locale === 'fr' ? "বাতিল" : "Cancel"), /*#__PURE__*/React.createElement(Button, {
    onClick: handleSave,
    color: "primary",
    variant: "contained",
    startIcon: /*#__PURE__*/React.createElement(SaveIcon, null)
  }, locale === 'fr' ? "সংরক্ষণ করুন" : "Save")));
};

function ownKeys$3(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$3(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$3(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$3(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var useStyles$7 = makeStyles$2(function (theme) {
  return {
    dialogForm: {
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(2)
    },
    dialogActions: {
      padding: theme.spacing(2),
      gap: theme.spacing(1)
    }
  };
});
var AddUserDialog = function AddUserDialog(_ref) {
  var open = _ref.open,
    onClose = _ref.onClose,
    onSave = _ref.onSave,
    user = _ref.user,
    setUser = _ref.setUser,
    locale = _ref.locale;
  var classes = useStyles$7();
  var handleSave = function handleSave() {
    if (!user.loginName || !user.representativeName || !user.representativeNameBn || !user.organizationName || !user.representativeType) {
      alert('Please fill in all required fields');
      return;
    }
    onSave();
  };
  return /*#__PURE__*/React.createElement(Dialog$1, {
    open: open,
    onClose: onClose,
    maxWidth: "sm",
    fullWidth: true
  }, /*#__PURE__*/React.createElement(DialogTitle, null, locale === 'fr' ? "নতুন ব্যবহারকারী যোগ করুন" : "Add New User"), /*#__PURE__*/React.createElement(DialogContent$1, {
    className: classes.dialogForm
  }, /*#__PURE__*/React.createElement(TextField, {
    label: locale === 'fr' ? "লগইন আইডি" : "Login ID",
    value: user.loginName,
    onChange: function onChange(e) {
      return setUser(_objectSpread$3(_objectSpread$3({}, user), {}, {
        loginName: e.target.value
      }));
    },
    fullWidth: true,
    variant: "outlined",
    required: true
  }), /*#__PURE__*/React.createElement(TextField, {
    label: locale === 'fr' ? "প্রতিনিধির নাম (ইংরেজিতে)" : "Name of the Representative (English)",
    value: user.representativeName,
    onChange: function onChange(e) {
      return setUser(_objectSpread$3(_objectSpread$3({}, user), {}, {
        representativeName: e.target.value
      }));
    },
    fullWidth: true,
    variant: "outlined",
    required: true
  }), /*#__PURE__*/React.createElement(TextField, {
    label: locale === 'fr' ? "প্রতিনিধির নাম (বাংলায়)" : "Name of the Representative (Bengali)",
    value: user.representativeNameBn,
    onChange: function onChange(e) {
      return setUser(_objectSpread$3(_objectSpread$3({}, user), {}, {
        representativeNameBn: e.target.value
      }));
    },
    fullWidth: true,
    variant: "outlined",
    required: true
  }), /*#__PURE__*/React.createElement(TextField, {
    label: locale === 'fr' ? "সংস্থার নাম" : "Name of the Organization",
    value: user.organizationName,
    onChange: function onChange(e) {
      return setUser(_objectSpread$3(_objectSpread$3({}, user), {}, {
        organizationName: e.target.value
      }));
    },
    fullWidth: true,
    variant: "outlined",
    required: true
  }), /*#__PURE__*/React.createElement(TextField, {
    label: locale === 'fr' ? "বর্তমান সংস্থায় পদবি" : "Designation on Current Organization",
    value: user.designation,
    onChange: function onChange(e) {
      return setUser(_objectSpread$3(_objectSpread$3({}, user), {}, {
        designation: e.target.value
      }));
    },
    fullWidth: true,
    variant: "outlined"
  }), /*#__PURE__*/React.createElement(TextField, {
    select: true,
    label: locale === 'fr' ? "প্রতিনিধির ধরন" : "Type of Representative",
    value: user.representativeType,
    onChange: function onChange(e) {
      return setUser(_objectSpread$3(_objectSpread$3({}, user), {}, {
        representativeType: e.target.value
      }));
    },
    fullWidth: true,
    variant: "outlined",
    required: true
  }, /*#__PURE__*/React.createElement(MenuItem, {
    value: ""
  }, locale === 'fr' ? "নির্বাচন করুন" : "Select"), isBlwfPath() ? /*#__PURE__*/React.createElement(MenuItem, {
    value: "Employer"
  }, locale === 'fr' ? "মালিক" : "Employer") : /*#__PURE__*/React.createElement(MenuItem, {
    value: "Employer"
  }, locale === 'fr' ? "নিয়োগকর্তা" : "Employer"), /*#__PURE__*/React.createElement(MenuItem, {
    value: "Worker"
  }, locale === 'fr' ? "শ্রমিক" : "Worker"), /*#__PURE__*/React.createElement(MenuItem, {
    value: "Government"
  }, locale === 'fr' ? "সরকার" : "Government")), /*#__PURE__*/React.createElement(TextField, {
    label: locale === 'fr' ? "ফোন নম্বর" : "Phone Number",
    value: user.phoneNumber,
    onChange: function onChange(e) {
      return setUser(_objectSpread$3(_objectSpread$3({}, user), {}, {
        phoneNumber: e.target.value
      }));
    },
    fullWidth: true,
    variant: "outlined",
    type: "tel"
  }), /*#__PURE__*/React.createElement(TextField, {
    label: locale === 'fr' ? "ইমেইল ঠিকানা" : "Email Address",
    value: user.email,
    onChange: function onChange(e) {
      return setUser(_objectSpread$3(_objectSpread$3({}, user), {}, {
        email: e.target.value
      }));
    },
    fullWidth: true,
    variant: "outlined",
    type: "email"
  }), /*#__PURE__*/React.createElement(TextField, {
    label: locale === 'fr' ? "অফিস ঠিকানা" : "Office Address",
    value: user.officeAddress,
    onChange: function onChange(e) {
      return setUser(_objectSpread$3(_objectSpread$3({}, user), {}, {
        officeAddress: e.target.value
      }));
    },
    fullWidth: true,
    variant: "outlined",
    multiline: true,
    rows: 2
  }), /*#__PURE__*/React.createElement(TextField, {
    label: locale === 'fr' ? "বর্তমান ঠিকানা" : "Current Address",
    value: user.currentAddress,
    onChange: function onChange(e) {
      return setUser(_objectSpread$3(_objectSpread$3({}, user), {}, {
        currentAddress: e.target.value
      }));
    },
    fullWidth: true,
    variant: "outlined",
    multiline: true,
    rows: 2
  })), /*#__PURE__*/React.createElement(DialogActions$1, {
    className: classes.dialogActions
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: onClose,
    color: "default"
  }, locale === 'fr' ? "বাতিল" : "Cancel"), /*#__PURE__*/React.createElement(Button, {
    onClick: handleSave,
    color: "primary",
    variant: "contained",
    startIcon: /*#__PURE__*/React.createElement(SaveIcon, null)
  }, locale === 'fr' ? "সংরক্ষণ করুন" : "Save")));
};

var useStyles$6 = makeStyles(function (theme) {
  return {
    dialogPaper: {
      minWidth: "90vw"
    },
    dialogContent: {
      padding: theme.spacing(4)
    },
    quillEditor: {
      "& .ql-editor table": {
        pointerEvents: "none",
        userSelect: "none"
      },
      "& .ql-editor table td, & .ql-editor table th": {
        pointerEvents: "none"
      }
    }
  };
});
var BankAdviceEditModal = function BankAdviceEditModal(_ref) {
  var open = _ref.open,
    onClose = _ref.onClose;
    _ref.paymentData;
    _ref.month;
    _ref.year;
    var committee = _ref.committee;
  var classes = useStyles$6();
  var _useState = useState(""),
    _useState2 = _slicedToArray(_useState, 2),
    editorContent = _useState2[0],
    setEditorContent = _useState2[1];
  var dispatch = useDispatch();
  useEffect(function () {
    if (open) {
      var fullContent = generateBankAdviceTemplate();
      setEditorContent(fullContent);
    }
  }, [open]);
  var quillModules = {
    toolbar: [[{
      'header': [1, 2, false]
    }], ['bold', 'italic', 'underline'], [{
      'list': 'ordered'
    }, {
      'list': 'bullet'
    }], [{
      'align': []
    }], ['clean']],
    clipboard: {
      matchVisual: false
    },
    // Disable table editing - make tables read-only
    table: false
  };

  // Custom handler to prevent table modification
  useEffect(function () {
    var editor = document.querySelector('.ql-editor');
    if (editor) {
      editor.addEventListener('keydown', function (e) {
        // Check if cursor is inside a table
        var isInTable = e.target.closest('table') || e.target.closest('td') || e.target.closest('th');
        if (isInTable) {
          e.preventDefault();
          e.stopPropagation();
          return false;
        }
      });

      // Prevent paste in tables
      editor.addEventListener('paste', function (e) {
        var isInTable = e.target.closest('table') || e.target.closest('td') || e.target.closest('th');
        if (isInTable) {
          e.preventDefault();
          return false;
        }
      });
    }
  }, []);
  var handleSave = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var payload;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            console.log(editorContent);
            // TODO: Handle save logic, e.g., dispatch action or update state
            payload = {
              adviceTemplate: editorContent,
              committeeId: safeDecodeId(committee === null || committee === void 0 ? void 0 : committee.id)
            };
            dispatch(createWorkforceCommitteeBankAdviceMap(payload, "bank advice template created")).then(function (res) {
              return onClose();
            });

            // onClose();
          case 3:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function handleSave() {
      return _ref2.apply(this, arguments);
    };
  }();
  return /*#__PURE__*/React.createElement(Dialog$1, {
    open: open,
    onClose: onClose,
    maxWidth: "lg",
    fullWidth: true,
    classes: {
      paper: classes.dialogPaper
    }
  }, /*#__PURE__*/React.createElement(DialogTitle, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6"
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "Edit Bank Advice Template"
  }))), /*#__PURE__*/React.createElement(DialogContent$1, {
    className: classes.dialogContent
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.quillEditor
  }, /*#__PURE__*/React.createElement(ReactQuill, {
    theme: "snow",
    value: editorContent,
    onChange: setEditorContent,
    modules: quillModules,
    style: {
      color: '#000'
    }
  }))), /*#__PURE__*/React.createElement(DialogActions$1, null, /*#__PURE__*/React.createElement(Button, {
    onClick: onClose,
    variant: "outlined",
    color: "primary"
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "workforce.modal.close"
  })), /*#__PURE__*/React.createElement(Button, {
    onClick: handleSave,
    variant: "contained",
    color: "primary"
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "workforce.modal.save"
  }))));
};

function ownKeys$2(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$2(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$2(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$2(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var useStyles$5 = makeStyles(function (theme) {
  return {
    pageContainer: {
      width: "90%",
      margin: "auto",
      marginTop: "40px",
      marginBottom: "40px"
    },
    card: {
      marginBottom: theme.spacing(3)
    },
    formControl: {
      margin: theme.spacing(1),
      minWidth: "100%"
    },
    submitButton: {
      marginTop: theme.spacing(2),
      height: "56px"
    },
    addButton: {
      marginBottom: theme.spacing(2)
    },
    tableHeader: {
      backgroundColor: theme.palette.grey[100],
      fontWeight: "bold"
    },
    actionButtons: {
      display: "flex",
      gap: theme.spacing(1)
    },
    emptyState: {
      textAlign: "center",
      padding: theme.spacing(3)
    },
    sectionTitle: {
      marginBottom: theme.spacing(2),
      fontWeight: "bold",
      color: theme.palette.primary.main
    },
    statusChip: {
      marginRight: theme.spacing(1)
    },
    formGrid: {
      marginBottom: theme.spacing(2)
    },
    dialogForm: {
      display: "flex",
      flexDirection: "column",
      gap: theme.spacing(2)
    },
    successMessage: {
      marginBottom: theme.spacing(2)
    },
    dialogActions: {
      padding: theme.spacing(2),
      gap: theme.spacing(1)
    },
    noaButton: {
      marginLeft: theme.spacing(1)
    },
    noaSignatureChip: {
      marginLeft: theme.spacing(1),
      backgroundColor: theme.palette.success.light,
      color: theme.palette.success.dark
    },
    radioGroupContainer: {
      display: "flex",
      alignItems: "center",
      marginRight: theme.spacing(2),
      backgroundColor: theme.palette.background.paper,
      padding: "0 10px",
      borderRadius: theme.shape.borderRadius,
      border: "1px solid ".concat(theme.palette.divider)
    }
  };
});
var CommitteeManagementPage = function CommitteeManagementPage() {
  var _reduxState$core;
  var classes = useStyles$5();
  var dispatch = useDispatch();
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    committees = _useState2[0],
    setCommittees = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    mappings = _useState4[0],
    setMappings = _useState4[1];
  var _useState5 = useState([]),
    _useState6 = _slicedToArray(_useState5, 2),
    committeeUsers = _useState6[0],
    setCommitteeUsers = _useState6[1];
  var _useState7 = useState([]),
    _useState8 = _slicedToArray(_useState7, 2),
    associations = _useState8[0],
    setAssociations = _useState8[1];
  var _useState9 = useState(false),
    _useState10 = _slicedToArray(_useState9, 2),
    openAdviceEditModal = _useState10[0],
    setOpenAdviceEditModal = _useState10[1];
  var _useState11 = useState(""),
    _useState12 = _slicedToArray(_useState11, 2),
    selectedCommittee = _useState12[0],
    setSelectedCommittee = _useState12[1];
  var _useState13 = useState(""),
    _useState14 = _slicedToArray(_useState13, 2),
    selectedUser = _useState14[0],
    setSelectedUser = _useState14[1];
  var _useState15 = useState(""),
    _useState16 = _slicedToArray(_useState15, 2),
    selectedRole = _useState16[0],
    setSelectedRole = _useState16[1];
  var _useState17 = useState(false),
    _useState18 = _slicedToArray(_useState17, 2),
    openAddCommitteeDialog = _useState18[0],
    setOpenAddCommitteeDialog = _useState18[1];
  var _useState19 = useState(false),
    _useState20 = _slicedToArray(_useState19, 2);
    _useState20[0];
    _useState20[1];
  var _useState21 = useState(false),
    _useState22 = _slicedToArray(_useState21, 2),
    openAddUserDialog = _useState22[0],
    setOpenAddUserDialog = _useState22[1];
  var _useState23 = useState({
      nameEn: "",
      nameBn: "",
      description: "",
      status: "ACTIVE",
      includedSectors: []
    }),
    _useState24 = _slicedToArray(_useState23, 2),
    newCommittee = _useState24[0],
    setNewCommittee = _useState24[1];
  var _useState25 = useState({
      loginName: "",
      representativeName: "",
      representativeNameBn: "",
      organizationName: "",
      designation: "",
      representativeType: "",
      phoneNumber: "",
      email: "",
      officeAddress: "",
      currentAddress: ""
    }),
    _useState26 = _slicedToArray(_useState25, 2),
    newUser = _useState26[0],
    setNewUser = _useState26[1];
  var _useState27 = useState(null),
    _useState28 = _slicedToArray(_useState27, 2);
    _useState28[0];
    _useState28[1];
  var _useState29 = useState(""),
    _useState30 = _slicedToArray(_useState29, 2),
    successMessage = _useState30[0],
    setSuccessMessage = _useState30[1];
  var _useState31 = useState(false),
    _useState32 = _slicedToArray(_useState31, 2);
    _useState32[0];
    _useState32[1];
  var _useState33 = useState(null),
    _useState34 = _slicedToArray(_useState33, 2),
    committee = _useState34[0],
    setCommittee = _useState34[1];
  useSelector(function (state) {
    var _state$core;
    return (_state$core = state.core) === null || _state$core === void 0 || (_state$core = _state$core.user) === null || _state$core === void 0 || (_state$core = _state$core.i_user) === null || _state$core === void 0 ? void 0 : _state$core.id;
  });
  useSelector(function (state) {
    var _state$core2;
    return ((_state$core2 = state.core) === null || _state$core2 === void 0 || (_state$core2 = _state$core2.user) === null || _state$core2 === void 0 || (_state$core2 = _state$core2.i_user) === null || _state$core2 === void 0 ? void 0 : _state$core2.rights) || [];
  });
  var reduxState = useSelector(function (state) {
    return state;
  });
  var locale = (reduxState === null || reduxState === void 0 || (_reduxState$core = reduxState.core) === null || _reduxState$core === void 0 || (_reduxState$core = _reduxState$core.user) === null || _reduxState$core === void 0 || (_reduxState$core = _reduxState$core.i_user) === null || _reduxState$core === void 0 ? void 0 : _reduxState$core.language) || "en";
  var mapUserToCommittee = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3(committeeId, userId, roleInCommittee) {
      var payload;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            _context3.prev = 0;
            payload = {
              committeeId: safeDecodeId(committeeId),
              userId: userId,
              roleInCommittee: roleInCommittee
            };
            console.log("Mapping user to committee:", {
              committeeId: committeeId,
              userId: userId,
              roleInCommittee: roleInCommittee
            });
            _context3.next = 5;
            return dispatch(createWorkforceCommitteeUserMap(payload, "createWorkforceCommitteeUserMap"));
          case 5:
            setSuccessMessage("Committee Mapped with selected User successfully!");
            setTimeout(function () {
              return setSuccessMessage("");
            }, 3000);
            fetchPreloadData();
            return _context3.abrupt("return", {
              success: true
            });
          case 11:
            _context3.prev = 11;
            _context3.t0 = _context3["catch"](0);
            console.error("Failed to map user to committee:", _context3.t0);
            throw _context3.t0;
          case 15:
          case "end":
            return _context3.stop();
        }
      }, _callee3, null, [[0, 11]]);
    }));
    return function mapUserToCommittee(_x2, _x3, _x4) {
      return _ref3.apply(this, arguments);
    };
  }();
  var deleteCommitteeMapping = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee4(mappingId) {
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            _context4.prev = 0;
            _context4.next = 3;
            return dispatch(deleteWorkforceCommitteeUserMap(safeDecodeId(mappingId)));
          case 3:
            console.log("Deleting committee-user mapping:", mappingId);
            fetchPreloadData();
            setSuccessMessage("User Mapping deleted successfully!");
            setTimeout(function () {
              return setSuccessMessage("");
            }, 3000);
            return _context4.abrupt("return", {
              success: true
            });
          case 10:
            _context4.prev = 10;
            _context4.t0 = _context4["catch"](0);
            console.error("Failed to delete mapping:", _context4.t0);
            throw _context4.t0;
          case 14:
          case "end":
            return _context4.stop();
        }
      }, _callee4, null, [[0, 10]]);
    }));
    return function deleteCommitteeMapping(_x5) {
      return _ref4.apply(this, arguments);
    };
  }();
  var handleRepresentativeToggle = /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee5(mapping, event) {
      var _mapping$committee, _mapping$user, payload;
      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            _context5.prev = 0;
            payload = {
              id: safeDecodeId(mapping.id),
              committeeId: safeDecodeId((_mapping$committee = mapping.committee) === null || _mapping$committee === void 0 ? void 0 : _mapping$committee.id),
              userId: safeDecodeId((_mapping$user = mapping.user) === null || _mapping$user === void 0 ? void 0 : _mapping$user.id),
              isRepresentative: event.target.checked
            };
            _context5.next = 4;
            return dispatch(updateWorkforceCommitteeUserMap(payload, "updateWorkforceCommitteeUserMap"));
          case 4:
            setSuccessMessage("Representative status updated successfully!");
            setTimeout(function () {
              return setSuccessMessage("");
            }, 3000);
            _context5.next = 8;
            return fetchPreloadData();
          case 8:
            _context5.next = 14;
            break;
          case 10:
            _context5.prev = 10;
            _context5.t0 = _context5["catch"](0);
            console.error("Failed to update representative status:", _context5.t0);
            alert("Failed to update representative status: " + _context5.t0.message);
          case 14:
          case "end":
            return _context5.stop();
        }
      }, _callee5, null, [[0, 10]]);
    }));
    return function handleRepresentativeToggle(_x6, _x7) {
      return _ref5.apply(this, arguments);
    };
  }();
  var fetchPreloadData = /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
      var _committeesData$paylo, _committeeUsersData$p, _associationsData$pay, _mappingsData$payload, organizationType, committeesData, committeeUsersData, associationsData, mappingsData;
      return _regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            _context6.prev = 0;
            organizationType = isEisPath() ? "eis" : isBlwfPath() ? "blwf" : "cf";
            _context6.next = 4;
            return dispatch(fetchWorkforceCommittees({
              organizationType: organizationType
            }));
          case 4:
            committeesData = _context6.sent;
            setCommittees((committeesData === null || committeesData === void 0 || (_committeesData$paylo = committeesData.payload) === null || _committeesData$paylo === void 0 || (_committeesData$paylo = _committeesData$paylo.data) === null || _committeesData$paylo === void 0 ? void 0 : _committeesData$paylo.workforceCommittees) || []);
            _context6.next = 8;
            return dispatch(fetchWorkforceCommitteeUser());
          case 8:
            committeeUsersData = _context6.sent;
            setCommitteeUsers((committeeUsersData === null || committeeUsersData === void 0 || (_committeeUsersData$p = committeeUsersData.payload) === null || _committeeUsersData$p === void 0 || (_committeeUsersData$p = _committeeUsersData$p.data) === null || _committeeUsersData$p === void 0 ? void 0 : _committeeUsersData$p.workforceCommitteeUsers) || []);
            _context6.next = 12;
            return dispatch(fetchWorkforceAllAssociation([]));
          case 12:
            associationsData = _context6.sent;
            setAssociations((associationsData === null || associationsData === void 0 || (_associationsData$pay = associationsData.payload) === null || _associationsData$pay === void 0 || (_associationsData$pay = _associationsData$pay.data) === null || _associationsData$pay === void 0 || (_associationsData$pay = _associationsData$pay.workforceAllAssociation) === null || _associationsData$pay === void 0 ? void 0 : _associationsData$pay.edges) || []);
            _context6.next = 16;
            return dispatch(fetchWorkforceCommitteeUserMap({}));
          case 16:
            mappingsData = _context6.sent;
            setMappings((mappingsData === null || mappingsData === void 0 || (_mappingsData$payload = mappingsData.payload) === null || _mappingsData$payload === void 0 || (_mappingsData$payload = _mappingsData$payload.data) === null || _mappingsData$payload === void 0 ? void 0 : _mappingsData$payload.workforceCommitteeUserMaps) || []);
            _context6.next = 23;
            break;
          case 20:
            _context6.prev = 20;
            _context6.t0 = _context6["catch"](0);
            console.error("Failed to fetch preload data:", _context6.t0);
          case 23:
          case "end":
            return _context6.stop();
        }
      }, _callee6, null, [[0, 20]]);
    }));
    return function fetchPreloadData() {
      return _ref6.apply(this, arguments);
    };
  }();
  var checkLoginNameExists = /*#__PURE__*/function () {
    var _ref7 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee7(loginName) {
      var _result$payload, result, users;
      return _regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) switch (_context7.prev = _context7.next) {
          case 0:
            _context7.prev = 0;
            _context7.next = 3;
            return dispatch(fetchWorkforceInteractiveUsers({
              loginName: loginName
            }));
          case 3:
            result = _context7.sent;
            users = (result === null || result === void 0 || (_result$payload = result.payload) === null || _result$payload === void 0 || (_result$payload = _result$payload.data) === null || _result$payload === void 0 ? void 0 : _result$payload.workforceInteractiveUsers) || [];
            return _context7.abrupt("return", users.length > 0);
          case 8:
            _context7.prev = 8;
            _context7.t0 = _context7["catch"](0);
            console.error("Error checking login name:", _context7.t0);
            return _context7.abrupt("return", false);
          case 12:
          case "end":
            return _context7.stop();
        }
      }, _callee7, null, [[0, 8]]);
    }));
    return function checkLoginNameExists(_x8) {
      return _ref7.apply(this, arguments);
    };
  }();
  useEffect(function () {
    fetchPreloadData();
  }, [dispatch]);
  var handleOpenAddCommitteeDialog = function handleOpenAddCommitteeDialog() {
    setNewCommittee({
      nameEn: "",
      nameBn: "",
      description: "",
      status: "ACTIVE",
      includedSectors: []
    });
    setOpenAddCommitteeDialog(true);
  };
  var handleCloseAddCommitteeDialog = function handleCloseAddCommitteeDialog() {
    setOpenAddCommitteeDialog(false);
    setNewCommittee({
      nameEn: "",
      nameBn: "",
      description: "",
      status: "ACTIVE",
      includedSectors: []
    });
  };
  var handleAddCommittee = /*#__PURE__*/function () {
    var _ref8 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
      var payload;
      return _regeneratorRuntime.wrap(function _callee8$(_context8) {
        while (1) switch (_context8.prev = _context8.next) {
          case 0:
            if (!(!newCommittee.nameEn || !newCommittee.nameBn)) {
              _context8.next = 3;
              break;
            }
            alert("Please fill in all required fields");
            return _context8.abrupt("return");
          case 3:
            _context8.prev = 3;
            payload = {
              nameEn: newCommittee.nameEn,
              nameBn: newCommittee.nameBn,
              organizationType: isEisPath() ? "eis" : !isEisPath() && isBlwfPath() ? "blwf" : "cf",
              associations: JSON.stringify(newCommittee.includedSectors)
            };
            _context8.next = 7;
            return dispatch(createWorkforceCommittee(payload, "createWorkforceCommittee"));
          case 7:
            setSuccessMessage("Committee created successfully!");
            setOpenAddCommitteeDialog(false);
            setTimeout(function () {
              return setSuccessMessage("");
            }, 3000);
            fetchPreloadData();
            _context8.next = 16;
            break;
          case 13:
            _context8.prev = 13;
            _context8.t0 = _context8["catch"](3);
            console.error("Error creating committee:", _context8.t0);
          case 16:
          case "end":
            return _context8.stop();
        }
      }, _callee8, null, [[3, 13]]);
    }));
    return function handleAddCommittee() {
      return _ref8.apply(this, arguments);
    };
  }();
  var handleDeleteCommittee = /*#__PURE__*/function () {
    var _ref10 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee10(committeeId) {
      return _regeneratorRuntime.wrap(function _callee10$(_context10) {
        while (1) switch (_context10.prev = _context10.next) {
          case 0:
            if (window.confirm("Are you sure you want to delete this committee?")) {
              _context10.next = 2;
              break;
            }
            return _context10.abrupt("return");
          case 2:
            _context10.prev = 2;
            _context10.next = 5;
            return dispatch(deleteWorkforceCommittee(safeDecodeId(committeeId)));
          case 5:
            setSuccessMessage("Committee deleted successfully!");
            setTimeout(function () {
              return setSuccessMessage("");
            }, 3000);
            fetchPreloadData();
            _context10.next = 13;
            break;
          case 10:
            _context10.prev = 10;
            _context10.t0 = _context10["catch"](2);
            alert("Failed to delete committee: " + _context10.t0.message);
          case 13:
          case "end":
            return _context10.stop();
        }
      }, _callee10, null, [[2, 10]]);
    }));
    return function handleDeleteCommittee(_x9) {
      return _ref10.apply(this, arguments);
    };
  }();
  var handleSaveMapping = /*#__PURE__*/function () {
    var _ref11 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee11() {
      return _regeneratorRuntime.wrap(function _callee11$(_context11) {
        while (1) switch (_context11.prev = _context11.next) {
          case 0:
            if (!(!selectedCommittee || !selectedUser || !selectedRole)) {
              _context11.next = 3;
              break;
            }
            alert("Please select committee, user, and role");
            return _context11.abrupt("return");
          case 3:
            _context11.prev = 3;
            _context11.next = 6;
            return mapUserToCommittee(selectedCommittee, safeDecodeId(selectedUser), selectedRole);
          case 6:
            setSelectedCommittee("");
            setSelectedUser("");
            setSelectedRole("");
            _context11.next = 14;
            break;
          case 11:
            _context11.prev = 11;
            _context11.t0 = _context11["catch"](3);
            alert("Failed to map user to committee: " + _context11.t0.message);
          case 14:
          case "end":
            return _context11.stop();
        }
      }, _callee11, null, [[3, 11]]);
    }));
    return function handleSaveMapping() {
      return _ref11.apply(this, arguments);
    };
  }();
  var handleDeleteMapping = /*#__PURE__*/function () {
    var _ref12 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee12(mappingId) {
      return _regeneratorRuntime.wrap(function _callee12$(_context12) {
        while (1) switch (_context12.prev = _context12.next) {
          case 0:
            if (window.confirm("Are you sure you want to delete this mapping?")) {
              _context12.next = 2;
              break;
            }
            return _context12.abrupt("return");
          case 2:
            _context12.prev = 2;
            _context12.next = 5;
            return dispatch(deleteCommitteeMapping(mappingId));
          case 5:
            setSuccessMessage("Mapping deleted successfully!");
            setTimeout(function () {
              return setSuccessMessage("");
            }, 3000);
            fetchPreloadData();
            _context12.next = 13;
            break;
          case 10:
            _context12.prev = 10;
            _context12.t0 = _context12["catch"](2);
            alert("Failed to delete mapping: " + _context12.t0.message);
          case 13:
          case "end":
            return _context12.stop();
        }
      }, _callee12, null, [[2, 10]]);
    }));
    return function handleDeleteMapping(_x10) {
      return _ref12.apply(this, arguments);
    };
  }();
  var handleSetNoaSignatureUser = /*#__PURE__*/function () {
    var _ref13 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee13(committeeId, mapId) {
      return _regeneratorRuntime.wrap(function _callee13$(_context13) {
        while (1) switch (_context13.prev = _context13.next) {
          case 0:
            _context13.prev = 0;
            _context13.next = 3;
            return dispatch(updateWorkforceCommitteeUserMapNoaSignature(safeDecodeId(committeeId), safeDecodeId(mapId), true));
          case 3:
            setSuccessMessage("NOA Signature User set successfully!");
            setTimeout(function () {
              return setSuccessMessage("");
            }, 3000);
            fetchPreloadData();
            _context13.next = 11;
            break;
          case 8:
            _context13.prev = 8;
            _context13.t0 = _context13["catch"](0);
            alert("Failed to set NOA Signature User: " + _context13.t0.message);
          case 11:
          case "end":
            return _context13.stop();
        }
      }, _callee13, null, [[0, 8]]);
    }));
    return function handleSetNoaSignatureUser(_x11, _x12) {
      return _ref13.apply(this, arguments);
    };
  }();
  var handleOpenAddUserDialog = function handleOpenAddUserDialog() {
    setNewUser({
      loginName: "",
      representativeName: "",
      representativeNameBn: "",
      organizationName: "",
      designation: "",
      representativeType: "",
      phoneNumber: "",
      email: "",
      officeAddress: "",
      currentAddress: ""
    });
    setOpenAddUserDialog(true);
  };
  var handleCloseAddUserDialog = function handleCloseAddUserDialog() {
    setOpenAddUserDialog(false);
    setNewUser({
      loginName: "",
      representativeName: "",
      representativeNameBn: "",
      organizationName: "",
      designation: "",
      representativeType: "",
      phoneNumber: "",
      email: "",
      officeAddress: "",
      currentAddress: ""
    });
  };
  var handleAddUser = /*#__PURE__*/function () {
    var _ref15 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee15() {
      var loginNameExists, payload;
      return _regeneratorRuntime.wrap(function _callee15$(_context15) {
        while (1) switch (_context15.prev = _context15.next) {
          case 0:
            if (!(!newUser.loginName || !newUser.representativeName || !newUser.representativeNameBn || !newUser.organizationName || !newUser.representativeType)) {
              _context15.next = 3;
              break;
            }
            alert("Please fill in all required fields");
            return _context15.abrupt("return");
          case 3:
            _context15.next = 5;
            return checkLoginNameExists(newUser.loginName);
          case 5:
            loginNameExists = _context15.sent;
            if (!loginNameExists) {
              _context15.next = 9;
              break;
            }
            alert("Login ID \"".concat(newUser.loginName, "\" already exists. Please use a different Login ID."));
            return _context15.abrupt("return");
          case 9:
            _context15.prev = 9;
            payload = {
              loginName: newUser.loginName,
              representativeName: newUser.representativeName,
              representativeNameBn: newUser.representativeNameBn,
              organizationName: newUser.organizationName,
              designation: newUser.designation,
              representativeType: newUser.representativeType,
              phoneNumber: newUser.phoneNumber,
              email: newUser.email,
              officeAddress: newUser.officeAddress,
              currentAddress: newUser.currentAddress
            };
            _context15.next = 13;
            return dispatch(createWorkforceCommitteeUser(payload, "createWorkforceCommitteeUser"));
          case 13:
            setSuccessMessage("User created successfully!");
            setOpenAddUserDialog(false);
            setTimeout(function () {
              return setSuccessMessage("");
            }, 3000);
            fetchPreloadData();
            _context15.next = 23;
            break;
          case 19:
            _context15.prev = 19;
            _context15.t0 = _context15["catch"](9);
            console.error("Error creating user:", _context15.t0);
            alert("Failed to create user: " + _context15.t0.message);
          case 23:
          case "end":
            return _context15.stop();
        }
      }, _callee15, null, [[9, 19]]);
    }));
    return function handleAddUser() {
      return _ref15.apply(this, arguments);
    };
  }();
  var fetchAssociations = /*#__PURE__*/function () {
    var _ref16 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee16() {
      var _response$payload, response;
      return _regeneratorRuntime.wrap(function _callee16$(_context16) {
        while (1) switch (_context16.prev = _context16.next) {
          case 0:
            _context16.prev = 0;
            _context16.next = 3;
            return dispatch(fetchWorkforceAllAssociation([]));
          case 3:
            response = _context16.sent;
            setAssociations((response === null || response === void 0 || (_response$payload = response.payload) === null || _response$payload === void 0 || (_response$payload = _response$payload.data) === null || _response$payload === void 0 || (_response$payload = _response$payload.workforceAllAssociation) === null || _response$payload === void 0 ? void 0 : _response$payload.edges) || []);
            _context16.next = 10;
            break;
          case 7:
            _context16.prev = 7;
            _context16.t0 = _context16["catch"](0);
            console.error("Failed to fetch associations:", _context16.t0);
          case 10:
          case "end":
            return _context16.stop();
        }
      }, _callee16, null, [[0, 7]]);
    }));
    return function fetchAssociations() {
      return _ref16.apply(this, arguments);
    };
  }();
  var handleApprovalProcessChange = /*#__PURE__*/function () {
    var _ref17 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee17(event, currentCommittee) {
      var newApprovalProcess, payload;
      return _regeneratorRuntime.wrap(function _callee17$(_context17) {
        while (1) switch (_context17.prev = _context17.next) {
          case 0:
            event.stopPropagation();
            newApprovalProcess = event.target.value;
            setCommittees(function (prevCommittees) {
              return prevCommittees.map(function (c) {
                return c.id === currentCommittee.id ? _objectSpread$2(_objectSpread$2({}, c), {}, {
                  approvalType: newApprovalProcess
                }) : c;
              });
            });
            _context17.prev = 3;
            payload = _objectSpread$2(_objectSpread$2({}, currentCommittee), {}, {
              id: safeDecodeId(currentCommittee === null || currentCommittee === void 0 ? void 0 : currentCommittee.id),
              approvalType: newApprovalProcess,
              associations: JSON.stringify(currentCommittee.includedSectors || [])
            });
            _context17.next = 7;
            return dispatch(updateWorkforceCommittee(payload, "updateWorkforceCommittee"));
          case 7:
            setSuccessMessage("Approval process updated successfully!");
            setTimeout(function () {
              return setSuccessMessage("");
            }, 3000);
            fetchPreloadData();
            _context17.next = 16;
            break;
          case 12:
            _context17.prev = 12;
            _context17.t0 = _context17["catch"](3);
            alert("Failed to update approval process: " + _context17.t0.message);
            fetchPreloadData();
          case 16:
          case "end":
            return _context17.stop();
        }
      }, _callee17, null, [[3, 12]]);
    }));
    return function handleApprovalProcessChange(_x15, _x16) {
      return _ref17.apply(this, arguments);
    };
  }();
  useEffect(function () {
    fetchAssociations();
  }, [dispatch]);
  return /*#__PURE__*/React.createElement("div", {
    className: classes.pageContainer
  }, successMessage && /*#__PURE__*/React.createElement(Alert$2, {
    severity: "success",
    onClose: function onClose() {
      return setSuccessMessage("");
    },
    className: classes.successMessage
  }, successMessage), /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 2
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    md: 3
  }, /*#__PURE__*/React.createElement(Card, {
    className: classes.card,
    elevation: 2,
    style: {
      height: "89%"
    }
  }, /*#__PURE__*/React.createElement(CardHeader, {
    title: locale === "fr" ? "কমিটি যোগ করুন" : "Add Committee",
    subheader: locale === "fr" ? "নতুন কমিটি তৈরি করুন" : "Create a new committee"
  }), /*#__PURE__*/React.createElement(CardContent, null, /*#__PURE__*/React.createElement(Button, {
    variant: "contained",
    color: "primary",
    startIcon: /*#__PURE__*/React.createElement(AddIcon, null),
    onClick: handleOpenAddCommitteeDialog,
    className: classes.addButton
  }, locale === "fr" ? "যোগ করুন" : "Add"))), /*#__PURE__*/React.createElement(AddCommitteeDialog, {
    open: openAddCommitteeDialog,
    onClose: handleCloseAddCommitteeDialog,
    onSave: handleAddCommittee,
    committee: newCommittee,
    setCommittee: setNewCommittee,
    associations: associations,
    locale: locale
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    md: 3
  }, /*#__PURE__*/React.createElement(Card, {
    className: classes.card,
    elevation: 2,
    style: {
      height: "89%"
    }
  }, /*#__PURE__*/React.createElement(CardHeader, {
    title: locale === "fr" ? "নতুন ইউজার" : "Create User",
    subheader: locale === "fr" ? "কমিটির জন্য নতুন ইউজার যোগ করুন" : "Create a new user for committee"
  }), /*#__PURE__*/React.createElement(CardContent, null, /*#__PURE__*/React.createElement(Button, {
    variant: "contained",
    color: "primary",
    startIcon: /*#__PURE__*/React.createElement(AddIcon, null),
    onClick: handleOpenAddUserDialog,
    className: classes.addButton
  }, locale === "fr" ? "যোগ করুন" : "Add"))), /*#__PURE__*/React.createElement(AddUserDialog, {
    open: openAddUserDialog,
    onClose: handleCloseAddUserDialog,
    onSave: handleAddUser,
    user: newUser,
    setUser: setNewUser,
    locale: locale
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    md: 6
  }, /*#__PURE__*/React.createElement(Card, {
    className: classes.card,
    elevation: 2
  }, /*#__PURE__*/React.createElement(CardHeader, {
    title: locale === "fr" ? "ব্যবহারকারীকে কমিটিতে ম্যাপ করুন" : "Map User to Committee",
    subheader: locale === "fr" ? "একজন ব্যবহারকারীকে একটি কমিটিতে অ্যাসাইন করুন" : "Assign a user to a committee"
  }), /*#__PURE__*/React.createElement(CardContent, null, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 3,
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 5,
    className: classes.formGrid
  }, /*#__PURE__*/React.createElement(Autocomplete$2, {
    id: "committee-select-autocomplete",
    options: committees,
    getOptionLabel: function getOptionLabel(option) {
      return locale === "fr" ? option.nameBn : option.nameEn;
    },
    getOptionSelected: function getOptionSelected(option, value) {
      return option.id === value.id;
    },
    value: committees.find(function (c) {
      return c.id === selectedCommittee;
    }) || null,
    onChange: function onChange(event, newValue) {
      setSelectedCommittee(newValue ? newValue.id : "");
    },
    renderInput: function renderInput(params) {
      return /*#__PURE__*/React.createElement(TextField, _extends({}, params, {
        label: locale === "fr" ? "কমিটি নির্বাচন করুন" : "Select Committee",
        variant: "outlined"
      }));
    }
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 5,
    className: classes.formGrid
  }, /*#__PURE__*/React.createElement(Autocomplete$2, {
    id: "user-select-autocomplete",
    options: committeeUsers,
    getOptionLabel: function getOptionLabel(option) {
      return locale === "fr" ? "".concat(option.loginName, " (").concat(fixBrokenUnicode(option.representativeNameBn), ")") : "".concat(option.loginName, " (").concat(fixBrokenUnicode(option.representativeName), ")");
    },
    getOptionSelected: function getOptionSelected(option, value) {
      return option.relatedUser.id === value.relatedUser.id;
    },
    value: committeeUsers.find(function (user) {
      return user.relatedUser.id === selectedUser;
    }) || null,
    onChange: function onChange(event, newValue) {
      setSelectedUser(newValue ? newValue.relatedUser.id : "");
    },
    renderInput: function renderInput(params) {
      return /*#__PURE__*/React.createElement(TextField, _extends({}, params, {
        label: locale === "fr" ? "ব্যবহারকারী নির্বাচন করুন" : "Select User",
        variant: "outlined"
      }));
    }
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 5,
    className: classes.formGrid
  }, isEisPath() ? /*#__PURE__*/React.createElement(TextField, {
    select: true,
    label: locale === "fr" ? "কমিটিতে ভূমিকা" : "Role in Committee",
    value: selectedRole,
    onChange: function onChange(e) {
      return setSelectedRole(e.target.value);
    },
    fullWidth: true,
    variant: "outlined",
    required: true,
    placeholder: locale === "fr" ? "ভূমিকা লিখুন" : "Enter role"
  }, /*#__PURE__*/React.createElement(MenuItem, {
    value: ""
  }, locale === "fr" ? "নির্বাচন করুন" : "Select"), /*#__PURE__*/React.createElement(MenuItem, {
    value: "Member"
  }, locale === "fr" ? "সদস্য" : "Member"), /*#__PURE__*/React.createElement(MenuItem, {
    value: "Member Secretary"
  }, locale === "fr" ? "সদস্য-সচিব" : "Member Secretary"), /*#__PURE__*/React.createElement(MenuItem, {
    value: "Chairman"
  }, locale === "fr" ? "চেয়ারম্যান" : "Chairman")) : /*#__PURE__*/React.createElement(TextField, {
    select: true,
    label: locale === "fr" ? "কমিটিতে ভূমিকা" : "Role in Committee",
    value: selectedRole,
    onChange: function onChange(e) {
      return setSelectedRole(e.target.value);
    },
    fullWidth: true,
    variant: "outlined",
    required: true,
    placeholder: locale === "fr" ? "ভূমিকা লিখুন" : "Enter role"
    // SelectProps={{
    //   native: true,
    // }}
  }, /*#__PURE__*/React.createElement(MenuItem, {
    value: ""
  }, locale === "fr" ? "নির্বাচন করুন" : "Select"), /*#__PURE__*/React.createElement(MenuItem, {
    value: "Member"
  }, locale === "fr" ? "সদস্য" : "Member"), /*#__PURE__*/React.createElement(MenuItem, {
    value: "President"
  }, locale === "fr" ? "সভাপতি" : "President"), /*#__PURE__*/React.createElement(MenuItem, {
    value: "Secretary General"
  }, locale === "fr" ? "সদস্য সচিব" : "Member Secretary"))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 2
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "contained",
    color: "primary",
    fullWidth: true,
    className: classes.submitButton,
    startIcon: /*#__PURE__*/React.createElement(SaveIcon, null),
    onClick: handleSaveMapping,
    disabled: !selectedCommittee || !selectedUser || !selectedRole,
    style: {
      marginTop: "-10px"
    }
  }, locale === "fr" ? "সংরক্ষণ করুন" : "Save"))))))), /*#__PURE__*/React.createElement(Card, {
    className: classes.card,
    elevation: 2
  }, /*#__PURE__*/React.createElement(CardHeader, {
    title: locale === "fr" ? "বিদ্যমান কমিটি এবং ব্যবহারকারী ম্যাপিং" : "Existing Committees and User Mappings",
    subheader: locale === "fr" ? "কমিটি এবং তাদের ব্যবহারকারীদের দেখুন" : "View committees and their users"
  }), /*#__PURE__*/React.createElement(CardContent, null, committees.length === 0 ? /*#__PURE__*/React.createElement("div", {
    className: classes.emptyState
  }, /*#__PURE__*/React.createElement(Typography, {
    color: "textSecondary"
  }, locale === "fr" ? "কোন কমিটি পাওয়া যায়নি।" : "No committees found.")) : committees.map(function (committee) {
    var committeeHasUsers = mappings.filter(function (mapping) {
      return mapping.committee.id === committee.id;
    }).length > 0;
    return /*#__PURE__*/React.createElement(Accordion, {
      key: committee.id
    }, /*#__PURE__*/React.createElement(AccordionSummary, {
      expandIcon: /*#__PURE__*/React.createElement(ExpandMoreIcon, null),
      "aria-controls": "panel-".concat(committee.id, "-content"),
      id: "panel-".concat(committee.id, "-header"),
      style: {
        justifyContent: "space-around"
      }
    }, /*#__PURE__*/React.createElement(Typography, {
      style: {
        flex: 1,
        alignSelf: "center"
      }
    }, locale === "fr" ? committee.nameBn : committee.nameEn), /*#__PURE__*/React.createElement("div", {
      className: classes.radioGroupContainer,
      onClick: function onClick(e) {
        return e.stopPropagation();
      }
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "body2",
      color: "textSecondary",
      style: {
        marginRight: 10
      }
    }, locale === "fr" ? "অনুমোদন প্রক্রিয়া:" : "Approval Process:"), /*#__PURE__*/React.createElement(RadioGroup, {
      row: true,
      value: committee.approvalType || (isEisPath() ? "quorum" : "representative"),
      onChange: function onChange(e) {
        return handleApprovalProcessChange(e, committee);
      }
    }, /*#__PURE__*/React.createElement(FormControlLabel, {
      value: "quorum",
      control: /*#__PURE__*/React.createElement(Radio, {
        size: "small",
        color: "primary"
      }),
      label: /*#__PURE__*/React.createElement(Typography, {
        variant: "body2"
      }, locale === "fr" ? "কোরাম" : "Quorum"),
      style: {
        marginRight: 15
      }
    }), /*#__PURE__*/React.createElement(FormControlLabel, {
      value: "representative",
      control: /*#__PURE__*/React.createElement(Radio, {
        size: "small",
        color: "primary"
      }),
      label: /*#__PURE__*/React.createElement(Typography, {
        variant: "body2"
      }, locale === "fr" ? "প্রতিনিধি" : "Representative"),
      style: {
        marginRight: 0
      }
    }))), /*#__PURE__*/React.createElement(Button, {
      variant: "contained",
      color: "primary",
      onClick: function onClick(e) {
        e.stopPropagation();
        setOpenAdviceEditModal(true);
        setCommittee(committee);
      },
      style: {
        marginRight: 5,
        alignSelf: "center"
      }
    }, "Edit Bank Advice Template"), /*#__PURE__*/React.createElement(IconButton, {
      color: "error",
      size: "small",
      disabled: committeeHasUsers,
      onClick: function onClick(e) {
        e.stopPropagation();
        handleDeleteCommittee(committee.id);
      },
      title: committeeHasUsers ? locale === "fr" ? "কমিটিতে ব্যবহারকারী থাকায় মুছে ফেলা সম্ভব হচ্ছে না" : "Cannot delete committee with mapped users" : locale === "fr" ? "কমিটি সরান" : "Delete Committee"
    }, /*#__PURE__*/React.createElement(DeleteIcon, null))), /*#__PURE__*/React.createElement(AccordionDetails, null, mappings.filter(function (mapping) {
      return mapping.committee.id === committee.id;
    }).length === 0 ? /*#__PURE__*/React.createElement(Typography, {
      color: "textSecondary"
    }, locale === "fr" ? "কোন ব্যবহারকারী ম্যাপ করা হয়নি।" : "No users mapped.") : /*#__PURE__*/React.createElement(TableContainer, {
      component: Paper,
      elevation: 0,
      variant: "outlined"
    }, /*#__PURE__*/React.createElement(Table$2, {
      "aria-label": "user mappings table"
    }, /*#__PURE__*/React.createElement(TableHead, null, /*#__PURE__*/React.createElement(TableRow, null, /*#__PURE__*/React.createElement(TableCell, {
      className: classes.tableHeader
    }, locale === "fr" ? "ব্যবহারকারী" : "User"), /*#__PURE__*/React.createElement(TableCell, {
      className: classes.tableHeader
    }, locale === "fr" ? "ভূমিকা" : "Role"), /*#__PURE__*/React.createElement(TableCell, {
      className: classes.tableHeader
    }, locale === "fr" ? "প্রতিষ্ঠান" : "Organization"), /*#__PURE__*/React.createElement(TableCell, {
      className: classes.tableHeader
    }, locale === "fr" ? "পদবী" : "Designation"), /*#__PURE__*/React.createElement(TableCell, {
      className: classes.tableHeader
    }, locale === "fr" ? "প্রতিনিধির ধরণ" : "Representative Type"), /*#__PURE__*/React.createElement(TableCell, {
      className: classes.tableHeader
    }, locale === "fr" ? "ফোন" : "Phone Number"), /*#__PURE__*/React.createElement(TableCell, {
      className: classes.tableHeader
    }, locale === "fr" ? "ইমেইল" : "Email"), /*#__PURE__*/React.createElement(TableCell, {
      className: classes.tableHeader
    }, locale === "fr" ? "ইমেইল" : "Email"), /*#__PURE__*/React.createElement(TableCell, {
      className: classes.tableHeader,
      align: "right"
    }, locale === "fr" ? "একশন" : "Actions"))), /*#__PURE__*/React.createElement(TableBody, null, mappings.filter(function (mapping) {
      return mapping.committee.id === committee.id;
    }).map(function (mapping) {
      var _mapping$user2, _mapping$user3, _mapping$user4, _mapping$workforceCom, _mapping$workforceCom2, _mapping$workforceCom3, _mapping$workforceCom4, _mapping$workforceCom5, _mapping$workforceCom6, _mapping$workforceCom7;
      return /*#__PURE__*/React.createElement(TableRow, {
        key: mapping.id
      }, /*#__PURE__*/React.createElement(TableCell, null, /*#__PURE__*/React.createElement("div", {
        style: {
          display: "flex",
          alignItems: "center"
        }
      }, /*#__PURE__*/React.createElement("span", null, (_mapping$user2 = mapping.user) === null || _mapping$user2 === void 0 ? void 0 : _mapping$user2.loginName, " (", locale === "fr" ? (_mapping$user3 = mapping.user) === null || _mapping$user3 === void 0 ? void 0 : _mapping$user3.lastName : (_mapping$user4 = mapping.user) === null || _mapping$user4 === void 0 ? void 0 : _mapping$user4.lastName, ")"), mapping.isNoaSignatureUser && /*#__PURE__*/React.createElement(Chip, {
        label: locale === "fr" ? "NOA স্বাক্ষর ব্যবহারকারী" : "NOA Signature User",
        className: classes.noaSignatureChip,
        size: "small",
        style: {
          marginLeft: "10px"
        }
      }))), /*#__PURE__*/React.createElement(TableCell, null, mapping.role || "Member"), /*#__PURE__*/React.createElement(TableCell, null, ((_mapping$workforceCom = mapping.workforceCommitteeUser) === null || _mapping$workforceCom === void 0 ? void 0 : _mapping$workforceCom.organizationName) || ""), /*#__PURE__*/React.createElement(TableCell, null, ((_mapping$workforceCom2 = mapping.workforceCommitteeUser) === null || _mapping$workforceCom2 === void 0 ? void 0 : _mapping$workforceCom2.designation) || ""), /*#__PURE__*/React.createElement(TableCell, null, ((_mapping$workforceCom3 = mapping.workforceCommitteeUser) === null || _mapping$workforceCom3 === void 0 ? void 0 : _mapping$workforceCom3.representativeType) || ""), /*#__PURE__*/React.createElement(TableCell, null, ((_mapping$workforceCom4 = mapping.workforceCommitteeUser) === null || _mapping$workforceCom4 === void 0 ? void 0 : _mapping$workforceCom4.phoneNumber) || ""), /*#__PURE__*/React.createElement(TableCell, null, ((_mapping$workforceCom5 = mapping.workforceCommitteeUser) === null || _mapping$workforceCom5 === void 0 ? void 0 : _mapping$workforceCom5.email) || ""), /*#__PURE__*/React.createElement(TableCell, null, locale === "fr" ? "অফিসের ঠিকানা" : "Office Address", ": ", ((_mapping$workforceCom6 = mapping.workforceCommitteeUser) === null || _mapping$workforceCom6 === void 0 ? void 0 : _mapping$workforceCom6.officeAddress) || "", /*#__PURE__*/React.createElement("br", null), locale === "fr" ? "বর্তমান ঠিকানা" : "Current Address", ": ", ((_mapping$workforceCom7 = mapping.workforceCommitteeUser) === null || _mapping$workforceCom7 === void 0 ? void 0 : _mapping$workforceCom7.currentAddress) || ""), /*#__PURE__*/React.createElement(TableCell, {
        align: "right"
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          display: "flex",
          gap: "8px",
          justifyContent: "flex-end",
          flexWrap: "wrap"
        }
      }, /*#__PURE__*/React.createElement(FormControlLabel, {
        control: /*#__PURE__*/React.createElement(Checkbox, {
          checked: Boolean(mapping.isRepresentative),
          onChange: function onChange(e) {
            return handleRepresentativeToggle(mapping, e);
          },
          color: "primary"
        }),
        label: locale === "fr" ? "আবেদন অনুমোদনের প্রতিনিধি" : "Application approval representative"
      }), !mapping.isNoaSignatureUser ? /*#__PURE__*/React.createElement(Button, {
        variant: "outlined",
        color: "primary",
        size: "small",
        onClick: function onClick() {
          return handleSetNoaSignatureUser(committee.id, mapping.id);
        },
        className: classes.noaButton
      }, locale === "fr" ? "NOA স্বাক্ষরকারী করুন" : "Set as NOA Signer") : /*#__PURE__*/React.createElement(React.Fragment, null), /*#__PURE__*/React.createElement(IconButton, {
        color: "error",
        onClick: function onClick() {
          return handleDeleteMapping(mapping.id);
        },
        size: "small"
      }, /*#__PURE__*/React.createElement(DeleteIcon, null)))));
    }))))));
  }))), /*#__PURE__*/React.createElement(BankAdviceEditModal, {
    open: openAdviceEditModal,
    onClose: function onClose() {
      return setOpenAdviceEditModal(false);
    },
    committee: committee
  }));
};

function ownKeys$1(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$1(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$1(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var POLL_INTERVAL_MS = 300000;
var useStyles$4 = makeStyles(function (theme) {
  return {
    "@keyframes glow": {
      "0%": {
        boxShadow: "0 0 0px rgba(0, 98, 115, 0)"
      },
      "50%": {
        boxShadow: "0 0 15px rgba(0, 98, 115, 0.8), 0 0 5px rgba(0, 98, 115, 0.5)"
      },
      "100%": {
        boxShadow: "0 0 0px rgba(0, 98, 115, 0)"
      }
    },
    glowingIcon: {
      animation: "$glow 2s infinite alternate",
      borderRadius: "50%",
      color: theme.palette.common.white
    },
    defaultIcon: {
      color: theme.palette.common.white
    },
    bellIcon: {
      color: "inherit"
    },
    menuPaper: {
      width: 360,
      maxHeight: 420,
      overflowY: "auto",
      padding: 0
    },
    notificationItem: {
      whiteSpace: "normal",
      alignItems: "flex-start",
      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(1)
    },
    notificationUnread: {
      backgroundColor: theme.palette.action.selected
    },
    notificationRead: {
      backgroundColor: "transparent"
    },
    notificationText: {
      display: "block",
      wordBreak: "break-word"
    },
    badge: {
      backgroundColor: "#f44336",
      color: "#ffffff"
    },
    statusText: {
      marginTop: theme.spacing(0.5),
      color: theme.palette.text.secondary
    },
    menuHeader: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      padding: theme.spacing(1, 2)
    },
    dateText: {
      marginTop: theme.spacing(0.25),
      color: theme.palette.text.secondary
    }
  };
});
var isNotificationRead = function isNotificationRead(notification) {
  if ((notification === null || notification === void 0 ? void 0 : notification.isRead) === undefined || (notification === null || notification === void 0 ? void 0 : notification.isRead) === null) {
    return false;
  }
  return notification.isRead === true || notification.isRead === "true";
};
var normalizeNotifications = function normalizeNotifications(response) {
  var _response$payload, _raw$edges$map, _raw$edges;
  var raw = response === null || response === void 0 || (_response$payload = response.payload) === null || _response$payload === void 0 || (_response$payload = _response$payload.data) === null || _response$payload === void 0 ? void 0 : _response$payload.workforceNotifications;
  if (!raw) {
    return [];
  }
  if (Array.isArray(raw)) {
    return raw;
  }
  return (_raw$edges$map = (_raw$edges = raw.edges) === null || _raw$edges === void 0 ? void 0 : _raw$edges.map(function (edge) {
    return edge.node;
  })) !== null && _raw$edges$map !== void 0 ? _raw$edges$map : [];
};
var PushNotification = function PushNotification() {
  var _reduxState$core;
  var classes = useStyles$4();
  var dispatch = useDispatch();
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    anchorEl = _useState2[0],
    setAnchorEl = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    notifications = _useState4[0],
    setNotifications = _useState4[1];
  var _useState5 = useState(0),
    _useState6 = _slicedToArray(_useState5, 2),
    unreadCount = _useState6[0],
    setUnreadCount = _useState6[1];
  var intervalRef = useRef(null);
  var userRights = useSelector(function (state) {
    var _state$core;
    return (_state$core = state.core) === null || _state$core === void 0 || (_state$core = _state$core.user) === null || _state$core === void 0 || (_state$core = _state$core.i_user) === null || _state$core === void 0 ? void 0 : _state$core.rights;
  });
  var reduxState = useSelector(function (state) {
    return state;
  });
  var locale = (reduxState === null || reduxState === void 0 || (_reduxState$core = reduxState.core) === null || _reduxState$core === void 0 || (_reduxState$core = _reduxState$core.user) === null || _reduxState$core === void 0 || (_reduxState$core = _reduxState$core.i_user) === null || _reduxState$core === void 0 ? void 0 : _reduxState$core.language) || "en";
  var userId = useSelector(function (state) {
    var _state$core2;
    return (_state$core2 = state.core) === null || _state$core2 === void 0 || (_state$core2 = _state$core2.user) === null || _state$core2 === void 0 || (_state$core2 = _state$core2.i_user) === null || _state$core2 === void 0 ? void 0 : _state$core2.id;
  });
  var userType = getUserTypeFromRights(userRights);
  var refreshNotifications = useCallback(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var response, fetchedNotifications;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          if (userId) {
            _context.next = 2;
            break;
          }
          return _context.abrupt("return");
        case 2:
          _context.prev = 2;
          _context.next = 5;
          return dispatch(fetchNotificationData(["loggedInUserId:\"".concat(userId, "\"")]));
        case 5:
          response = _context.sent;
          fetchedNotifications = normalizeNotifications(response);
          setNotifications(fetchedNotifications);
          setUnreadCount(fetchedNotifications.filter(function (n) {
            return !isNotificationRead(n);
          }).length);
          _context.next = 14;
          break;
        case 11:
          _context.prev = 11;
          _context.t0 = _context["catch"](2);
          console.error("Failed to load notifications:", _context.t0);
        case 14:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[2, 11]]);
  })), [dispatch, userId]);
  useEffect(function () {
    if (!userId || userType === WORKFORCE_USER_TYPE.APPLICANT) {
      return undefined;
    }
    refreshNotifications();
    intervalRef.current = setInterval(refreshNotifications, POLL_INTERVAL_MS);
    return function () {
      clearInterval(intervalRef.current);
    };
  }, [userId, userType, refreshNotifications]);
  var handleBellClick = function handleBellClick(event) {
    if (anchorEl) {
      setAnchorEl(null);
      return;
    }
    setAnchorEl(event.currentTarget);
    refreshNotifications();
  };
  var handleClose = function handleClose() {
    setAnchorEl(null);
  };
  var markNotificationAsRead = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(notification) {
      var skipNavigation,
        _notification$workfor,
        payload,
        _args2 = arguments;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            skipNavigation = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : false;
            if (!(!notification || !notification.id || isNotificationRead(notification))) {
              _context2.next = 3;
              break;
            }
            return _context2.abrupt("return");
          case 3:
            _context2.prev = 3;
            payload = {
              id: safeDecodeId(notification.id),
              isRead: true,
              userId: safeDecodeId(notification.user.id),
              status: notification.status,
              notification: notification.notification,
              notificationBn: notification.notificationBn,
              workforceApplicationId: safeDecodeId(notification.workforceApplication.id)
            };
            _context2.next = 7;
            return dispatch(updateNotification(payload, "updateNotification"));
          case 7:
            setNotifications(function (prev) {
              return prev.map(function (item) {
                return item.id === notification.id ? _objectSpread$1(_objectSpread$1({}, item), {}, {
                  isRead: true
                }) : item;
              });
            });
            setUnreadCount(function (prev) {
              return Math.max(prev - 1, 0);
            });
            if (!skipNavigation && (_notification$workfor = notification.workforceApplication) !== null && _notification$workfor !== void 0 && _notification$workfor.id) {
              window.location.href = "".concat(window.location.origin, "/front/workforce/applications/application/verify/").concat(safeDecodeId(notification.workforceApplication.id));
            }
            _context2.next = 15;
            break;
          case 12:
            _context2.prev = 12;
            _context2.t0 = _context2["catch"](3);
            console.error("Failed to mark notification read:", _context2.t0);
          case 15:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[3, 12]]);
    }));
    return function markNotificationAsRead(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  var markAllAsRead = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return dispatch(markAllNotificationAsRead(userId));
          case 2:
            _context3.next = 4;
            return refreshNotifications();
          case 4:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return function markAllAsRead() {
      return _ref3.apply(this, arguments);
    };
  }();
  if (userType === WORKFORCE_USER_TYPE.APPLICANT) {
    return null;
  }
  console.log({
    emnei: notifications
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(IconButton$1, {
    onClick: handleBellClick,
    className: classes.defaultIcon,
    "aria-label": "show notifications",
    color: "inherit"
  }, unreadCount > 0 ? /*#__PURE__*/React.createElement(Badge$1, {
    badgeContent: locale === "en" ? unreadCount : Number(unreadCount).toLocaleString("bn-BD"),
    classes: {
      badge: classes.badge
    }
  }, /*#__PURE__*/React.createElement(NotificationsIcon, {
    className: classes.glowingIcon
  })) : /*#__PURE__*/React.createElement(NotificationsIcon, {
    className: classes.bellIcon
  })), /*#__PURE__*/React.createElement(Menu$1, {
    anchorEl: anchorEl,
    keepMounted: true,
    open: Boolean(anchorEl),
    onClose: handleClose,
    getContentAnchorEl: null,
    anchorOrigin: {
      vertical: "bottom",
      horizontal: "center"
    },
    transformOrigin: {
      vertical: "top",
      horizontal: "center"
    },
    PaperProps: {
      className: classes.menuPaper
    }
  }, /*#__PURE__*/React.createElement(Box, {
    className: classes.menuHeader
  }, unreadCount < 1 && /*#__PURE__*/React.createElement(Typography$1, {
    variant: "subtitle1"
  }, locale === "en" ? "Notifications" : "নোটিফিকেশন"), /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    alignItems: "center",
    gap: 1
  }, unreadCount > 0 && /*#__PURE__*/React.createElement(Typography$1, {
    variant: "body2"
  }, locale === "en" ? unreadCount : Number(unreadCount).toLocaleString("bn-BD"), " ", locale === "en" ? " Unread Notifications" : " টি নোটিফিকেশন অপঠিত"), unreadCount > 0 && /*#__PURE__*/React.createElement(Button$1, {
    size: "small",
    color: "primary",
    variant: "outlined",
    onClick: function onClick() {
      return markAllAsRead();
    },
    disabled: unreadCount === 0,
    style: {
      marginLeft: "10px"
    }
  }, locale === "en" ? "Mark all as read" : "সবগুলো পড়া হয়েছে"))), /*#__PURE__*/React.createElement(Divider$1, null), notifications.length === 0 ? /*#__PURE__*/React.createElement(MenuItem$1, {
    disabled: true
  }, /*#__PURE__*/React.createElement(ListItemText$1, {
    primary: locale === "en" ? "No notifications" : "কোনো নোটিফিকেশন নেই"
  })) : notifications.map(function (notification) {
    var read = isNotificationRead(notification);
    return /*#__PURE__*/React.createElement(MenuItem$1, {
      key: notification.id,
      className: "".concat(classes.notificationItem, " ").concat(read ? classes.notificationRead : classes.notificationUnread),
      onClick: function onClick() {
        return markNotificationAsRead(notification);
      }
    }, /*#__PURE__*/React.createElement(ListItemText$1, {
      primary: /*#__PURE__*/React.createElement(Typography$1, {
        className: classes.notificationText,
        variant: "body2"
      }, locale === "en" ? notification.notification || "No message" : notification.notificationBn || "No message"),
      secondary: /*#__PURE__*/React.createElement(Box, null, notification.status && /*#__PURE__*/React.createElement(Typography$1, {
        className: classes.statusText,
        variant: "caption"
      }, locale === "en" ? STATUS_MAP_EN[notification.status] : STATUS_MAP_BN[notification.status]), notification.dateCreated && /*#__PURE__*/React.createElement(Typography$1, {
        variant: "caption",
        display: "block",
        color: "textSecondary",
        className: classes.dateText
      }, conditionalEnToBn(notification.dateCreated.split("T")[0], locale)))
    }));
  })));
};

var useStyles$3 = makeStyles$2(function (theme) {
  return {
    root: {
      minHeight: "100vh",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      padding: theme.spacing(2),
      backgroundColor: "#f5f5f5"
    },
    card: {
      width: "100%",
      maxWidth: 500,
      padding: theme.spacing(4),
      borderRadius: 12,
      textAlign: "center"
    },
    title: _defineProperty({
      fontWeight: 600,
      marginBottom: theme.spacing(3)
    }, theme.breakpoints.down("sm"), {
      fontSize: "1rem"
    }),
    radioGroup: _defineProperty({
      display: "flex",
      justifyContent: "center",
      flexDirection: "row",
      gap: theme.spacing(3)
    }, theme.breakpoints.down("xs"), {
      flexDirection: "column",
      alignItems: "center",
      gap: theme.spacing(1)
    }),
    successCard: {
      width: "100%",
      maxWidth: 500,
      padding: theme.spacing(6),
      borderRadius: 12,
      textAlign: "center",
      background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
      color: "white",
      boxShadow: "0 10px 40px rgba(102, 126, 234, 0.4)"
    },
    successIcon: {
      fontSize: 80,
      marginBottom: theme.spacing(2),
      color: "#4caf50",
      animation: "$checkAnimation 0.6s ease-in-out"
    },
    "@keyframes checkAnimation": {
      "0%": {
        transform: "scale(0) rotate(-45deg)",
        opacity: 0
      },
      "50%": {
        transform: "scale(1.2) rotate(10deg)"
      },
      "100%": {
        transform: "scale(1) rotate(0deg)",
        opacity: 1
      }
    },
    successTitle: {
      fontWeight: 700,
      marginBottom: theme.spacing(2),
      fontSize: "1.5rem"
    },
    successMessage: {
      fontWeight: 500,
      fontSize: "1.1rem",
      lineHeight: 1.6,
      marginBottom: theme.spacing(3)
    },
    redirectText: {
      fontSize: "0.9rem",
      marginTop: theme.spacing(2),
      opacity: 0.9
    }
  };
});
var VerifyConfirmationLink = function VerifyConfirmationLink() {
  var classes = useStyles$3();
  var _useState = useState(""),
    _useState2 = _slicedToArray(_useState, 2),
    value = _useState2[0],
    setValue = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isLoading = _useState4[0],
    setIsLoading = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isSuccess = _useState6[0],
    setIsSuccess = _useState6[1];
  var dispatch = useDispatch();
  var history = useHistory$1();

  // Extract disbursement_id from URL query params
  var searchParams = new URLSearchParams(window.location.search);
  var disbursementId = searchParams.get("disbursement_id");
  var handleChange = function handleChange(event) {
    setValue(event.target.value);
  };
  var handleConfirm = function handleConfirm() {
    setIsLoading(true);
    var isConfirmed = value === "yes";
    dispatch(userPaymentConfirmation(disbursementId, isConfirmed));

    // Show success message after a brief delay
    setTimeout(function () {
      setIsLoading(false);
      setIsSuccess(true);
    }, 1500);
  };

  // Redirect to login after showing success message
  useEffect(function () {
    if (isSuccess) {
      var redirectTimer = setTimeout(function () {
        window.location.href = "/"; // Redirect to home page
      }, 3000); // Show success message for 3 seconds before redirecting

      return function () {
        return clearTimeout(redirectTimer);
      };
    }
  }, [isSuccess, history]);
  if (isSuccess) {
    return /*#__PURE__*/React.createElement(Box$1, {
      className: classes.root
    }, /*#__PURE__*/React.createElement(Fade, {
      "in": isSuccess,
      timeout: 800
    }, /*#__PURE__*/React.createElement(Paper, {
      elevation: 8,
      className: classes.successCard
    }, /*#__PURE__*/React.createElement(CheckCircleOutlineIcon, {
      className: classes.successIcon
    }), /*#__PURE__*/React.createElement(Typography, {
      variant: "h5",
      className: classes.successTitle
    }, "Confirmation Successful"), /*#__PURE__*/React.createElement(Typography, {
      className: classes.successMessage
    }, "Your Confirmation has been recorded sucessfully"), /*#__PURE__*/React.createElement(Typography, {
      className: classes.successMessage
    }, "\u0986\u09AA\u09A8\u09BE\u09B0 \u099F\u09BE\u0995\u09BE \u09AA\u09CD\u09B0\u09BE\u09AA\u09CD\u09A4\u09BF \u09A8\u09BF\u09B6\u09CD\u099A\u09BF\u09A4\u0995\u09B0\u09A3 \u09AA\u09CD\u09B0\u0995\u09CD\u09B0\u09BF\u09AF\u09BC\u09BE \u09B8\u09AE\u09CD\u09AA\u09A8\u09CD\u09A8 \u09B9\u09AF\u09BC\u09C7\u099B\u09C7\u0964"), /*#__PURE__*/React.createElement(Typography, {
      className: classes.redirectText
    }, "Redirecting to home page..."), /*#__PURE__*/React.createElement(Box$1, {
      mt: 2
    }, /*#__PURE__*/React.createElement(CircularProgress$1, {
      size: 30,
      style: {
        color: "white"
      }
    })))));
  }
  return /*#__PURE__*/React.createElement(Box$1, {
    className: classes.root
  }, /*#__PURE__*/React.createElement(Paper, {
    elevation: 3,
    className: classes.card
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5",
    className: classes.title
  }, "Did you receive any disbursed amount? / \u0986\u09AA\u09A8\u09BF \u0995\u09BF \u099F\u09BE\u0995\u09BE \u09AA\u09C7\u09DF\u09C7\u099B\u09C7\u09A8?"), /*#__PURE__*/React.createElement(FormControl, {
    component: "fieldset"
  }, /*#__PURE__*/React.createElement(RadioGroup, {
    value: value,
    onChange: handleChange,
    className: classes.radioGroup
  }, /*#__PURE__*/React.createElement(FormControlLabel, {
    value: "yes",
    control: /*#__PURE__*/React.createElement(Radio, {
      color: "primary"
    }),
    label: "Yes / \u09B9\u09CD\u09AF\u09BE\u0981"
  }), /*#__PURE__*/React.createElement(FormControlLabel, {
    value: "no",
    control: /*#__PURE__*/React.createElement(Radio, {
      color: "primary"
    }),
    label: "No / \u09A8\u09BE"
  }))), /*#__PURE__*/React.createElement(Box$1, {
    mt: 3
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "contained",
    color: "primary",
    disabled: !value || isLoading,
    onClick: handleConfirm,
    style: {
      minWidth: 140,
      height: 44,
      fontSize: "1rem"
    }
  }, isLoading ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(CircularProgress$1, {
    size: 20,
    style: {
      color: "white",
      marginRight: 8
    }
  }), "Processing...") : "Confirm / নিশ্চিত করুন"))));
};

var useStyles$2 = makeStyles(function (theme) {
  return {
    pageContainer: {
      width: "90%",
      margin: "auto",
      marginTop: "40px",
      marginBottom: "40px"
    }
  };
});
var LegalGuidelines = function LegalGuidelines() {
  var classes = useStyles$2();
  var dispatch = useDispatch();
  var _useState = useState(""),
    _useState2 = _slicedToArray(_useState, 2),
    description = _useState2[0],
    setDescription = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    uploadedFile = _useState4[0],
    setUploadedFile = _useState4[1];
  var _useState5 = useState(null),
    _useState6 = _slicedToArray(_useState5, 2),
    existingRecord = _useState6[0],
    setExistingRecord = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    openSuccess = _useState8[0],
    setOpenSuccess = _useState8[1];

  // Fetch existing legal guideline record on component mount
  useEffect(function () {
    dispatch(fetchWebsiteLegalGuidelines()).then(function (res) {
      var _res$data;
      var record = res === null || res === void 0 || (_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.websiteLegalGuidelines; // Assuming only one record exists
      if (record != null) {
        setExistingRecord(record);
        setDescription(record.description);
        setUploadedFile({
          url: record.documentUrl,
          path: record.documentPath
        });
      }
    });
  }, [dispatch]);

  // Handle file upload
  var handleFileChange = function handleFileChange(fieldKey, fileData) {
    setUploadedFile(fileData.files[0]);
  };

  // Handle save or update
  var handleSave = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (existingRecord) {
              // Update existing record
              dispatch(updateWebsiteLegalGuideline({
                id: existingRecord.id,
                description: description,
                documentUrl: uploadedFile === null || uploadedFile === void 0 ? void 0 : uploadedFile.url,
                documentPath: uploadedFile === null || uploadedFile === void 0 ? void 0 : uploadedFile.path
              }, "updateWebsiteLegalGuideline")).then(function () {
                setOpenSuccess(true);
                setTimeout(function () {
                  window.location.href = '/'; // Reload the page to reflect changes
                }, 1500);
              });
            } else {
              // Create new record
              dispatch(createWebsiteLegalGuideline({
                description: description,
                documentUrl: uploadedFile === null || uploadedFile === void 0 ? void 0 : uploadedFile.url,
                documentPath: uploadedFile === null || uploadedFile === void 0 ? void 0 : uploadedFile.path
              }, "createWebsiteLegalGuideline")).then(function () {
                setOpenSuccess(true);
                setTimeout(function () {
                  window.location.href = '/'; // Reload the page to reflect changes
                }, 1500);
              });
            }
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function handleSave() {
      return _ref.apply(this, arguments);
    };
  }();
  return /*#__PURE__*/React.createElement(Box$1, {
    sx: {
      padding: 4
    },
    className: classes.pageContainer
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 5,
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    md: 8
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4",
    gutterBottom: true
  }, "Legal Guideline Management"), /*#__PURE__*/React.createElement(Paper, {
    sx: {
      padding: 3,
      marginBottom: 4
    }
  }, /*#__PURE__*/React.createElement(TextField, {
    label: "Description",
    value: description,
    onChange: function onChange(e) {
      return setDescription(e.target.value);
    },
    fullWidth: true,
    margin: "normal",
    disabled: !!existingRecord // Disable if record exists
    ,
    marginBottom: 2
  }), /*#__PURE__*/React.createElement(FileUploader, _defineProperty({
    fieldKey: "legalGuideline",
    documentType: "website-legal-guideline",
    documentProp: {
      id: "12345"
    },
    onFileChange: handleFileChange,
    dispatch: dispatch,
    uploadedBy: "admin"
  }, "documentType", "legalGuideline")), uploadedFile &&
  /*#__PURE__*/
  // <Box sx={{ marginTop: 2 }}>
  //   <Typography variant="subtitle1">Uploaded Document:</Typography>
  //   <a href={uploadedFile.url} target="_blank" rel="noopener noreferrer">
  //     Preview Document
  //   </a>
  // </Box>
  React.createElement("iframe", {
    title: "DOCX Viewer",
    src: "".concat(uploadedFile.url),
    width: "100%",
    height: "600px",
    frameBorder: "0"
  })), /*#__PURE__*/React.createElement(Button, {
    variant: "contained",
    color: "primary",
    onClick: handleSave,
    disabled: !uploadedFile || !description,
    style: {
      marginTop: "20px"
    }
  }, existingRecord ? "Update Record" : "Save Record"))), /*#__PURE__*/React.createElement(Snackbar, {
    open: openSuccess,
    autoHideDuration: 6000,
    onClose: function onClose() {
      return setOpenSuccess(false);
    },
    anchorOrigin: {
      vertical: "top",
      horizontal: "right"
    }
  }, /*#__PURE__*/React.createElement(Alert$2, {
    onClose: function onClose() {
      return setOpenSuccess(false);
    },
    severity: "success",
    sx: {
      width: "100%"
    }
  }, existingRecord ? "Record updated successfully!" : "Record saved successfully!")));
};

var useStyles$1 = makeStyles(function (theme) {
  return {
    root: {
      padding: theme.spacing(3),
      background: "#f5f7fb",
      minHeight: "100vh"
    },
    headerCard: {
      padding: theme.spacing(3),
      borderRadius: 20,
      marginBottom: theme.spacing(3),
      background: "linear-gradient(135deg, #0f172a 0%, #1e293b 50%, #334155 100%)",
      color: "#fff",
      boxShadow: "0 10px 30px rgba(0,0,0,0.15)"
    },
    title: {
      fontWeight: 700,
      fontSize: 28,
      marginBottom: theme.spacing(1)
    },
    subtitle: {
      opacity: 0.85,
      fontSize: 14
    },
    statsCard: {
      padding: theme.spacing(2),
      borderRadius: 18,
      background: "#fff",
      boxShadow: "0 4px 15px rgba(0,0,0,0.06)",
      textAlign: "center",
      height: "100%"
    },
    statsValue: {
      fontSize: 28,
      fontWeight: 700,
      color: "#1e293b"
    },
    statsLabel: {
      fontSize: 14,
      color: "#64748b"
    },
    tableContainer: {
      marginTop: theme.spacing(3),
      borderRadius: 20,
      overflow: "hidden",
      boxShadow: "0 6px 25px rgba(0,0,0,0.08)"
    },
    tableHeader: {
      background: "#0f172a"
    },
    headerCell: {
      color: "#fff",
      fontWeight: 700,
      fontSize: 14
    },
    tableRow: {
      transition: "all 0.2s ease",
      "&:hover": {
        background: "#f8fafc"
      }
    },
    visitorBox: {
      display: "flex",
      alignItems: "center",
      gap: 12
    },
    avatar: {
      background: "#2563eb",
      width: 42,
      height: 42,
      fontWeight: 700
    },
    visitorName: {
      fontWeight: 600,
      color: "#0f172a"
    },
    contactLink: {
      textDecoration: "none",
      display: "flex",
      alignItems: "center",
      gap: 6,
      color: "#2563eb",
      fontWeight: 500,
      "&:hover": {
        textDecoration: "underline"
      }
    },
    messageBox: {
      maxWidth: 350,
      whiteSpace: "pre-wrap",
      wordBreak: "break-word",
      color: "#334155"
    },
    emptyBox: {
      padding: theme.spacing(6),
      textAlign: "center",
      background: "#fff",
      borderRadius: 20
    },
    chip: {
      fontWeight: 600
    },
    loadingBox: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      padding: theme.spacing(6)
    }
  };
});
var VisitorMessages = function VisitorMessages() {
  var classes = useStyles$1();
  var dispatch = useDispatch();
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    visitorMessages = _useState2[0],
    setVisitorMessages = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    loading = _useState4[0],
    setLoading = _useState4[1];
  useEffect(function () {
    setLoading(true);
    dispatch(fetchWebsiteVisitorMessages()).then(function (response) {
      var _response$payload;
      console.log("Visitor Messages Response:", response);
      setVisitorMessages((response === null || response === void 0 || (_response$payload = response.payload) === null || _response$payload === void 0 || (_response$payload = _response$payload.data) === null || _response$payload === void 0 ? void 0 : _response$payload.websiteVisitorMessages) || []);
    });
    setLoading(false);
  }, [dispatch]);
  return /*#__PURE__*/React.createElement(Box$1, {
    className: classes.root
  }, /*#__PURE__*/React.createElement(Paper, {
    className: classes.headerCard,
    elevation: 0
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    md: 8
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.title
  }, "Website Visitor Messages"), /*#__PURE__*/React.createElement(Typography, {
    className: classes.subtitle
  }, "Reply to your website visitors with email and contact number from here (Latest Records are at the top).")), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    md: 4
  }, /*#__PURE__*/React.createElement(Paper, {
    className: classes.statsCard
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.statsValue
  }, (visitorMessages === null || visitorMessages === void 0 ? void 0 : visitorMessages.length) || 0), /*#__PURE__*/React.createElement(Typography, {
    className: classes.statsLabel
  }, "Total Messages"))))), loading && /*#__PURE__*/React.createElement(Box$1, {
    className: classes.loadingBox
  }, /*#__PURE__*/React.createElement(CircularProgress$1, null)), !loading && (!visitorMessages || visitorMessages.length === 0) && /*#__PURE__*/React.createElement(Box$1, {
    className: classes.emptyBox,
    style: {
      marginTop: 24
    }
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6",
    gutterBottom: true
  }, "No Visitor Messages Found"), /*#__PURE__*/React.createElement(Typography, {
    color: "textSecondary"
  }, "Visitor messages from your website will appear here.")), !loading && (visitorMessages === null || visitorMessages === void 0 ? void 0 : visitorMessages.length) > 0 && /*#__PURE__*/React.createElement(TableContainer, {
    component: Paper,
    className: classes.tableContainer,
    style: {
      marginTop: 24
    }
  }, /*#__PURE__*/React.createElement(Table$2, null, /*#__PURE__*/React.createElement(TableHead, {
    className: classes.tableHeader
  }, /*#__PURE__*/React.createElement(TableRow, null, /*#__PURE__*/React.createElement(TableCell, {
    className: classes.headerCell
  }, "Visitor"), /*#__PURE__*/React.createElement(TableCell, {
    className: classes.headerCell
  }, "Email"), /*#__PURE__*/React.createElement(TableCell, {
    className: classes.headerCell
  }, "Phone"), /*#__PURE__*/React.createElement(TableCell, {
    className: classes.headerCell
  }, "Message"), /*#__PURE__*/React.createElement(TableCell, {
    className: classes.headerCell
  }, "Date"))), /*#__PURE__*/React.createElement(TableBody, null, visitorMessages.map(function (item, index) {
    var _item$visitorName;
    return /*#__PURE__*/React.createElement(TableRow, {
      key: item.id || index,
      className: classes.tableRow
    }, /*#__PURE__*/React.createElement(TableCell, null, /*#__PURE__*/React.createElement(Box$1, {
      className: classes.visitorBox
    }, /*#__PURE__*/React.createElement(Avatar, {
      className: classes.avatar
    }, (item === null || item === void 0 || (_item$visitorName = item.visitorName) === null || _item$visitorName === void 0 || (_item$visitorName = _item$visitorName.charAt(0)) === null || _item$visitorName === void 0 ? void 0 : _item$visitorName.toUpperCase()) || "V"), /*#__PURE__*/React.createElement(Box$1, null, /*#__PURE__*/React.createElement(Typography, {
      className: classes.visitorName
    }, item.visitorName), /*#__PURE__*/React.createElement(Chip, {
      size: "small",
      icon: /*#__PURE__*/React.createElement(PersonIcon, null),
      label: "Visitor",
      className: classes.chip
    })))), /*#__PURE__*/React.createElement(TableCell, null, /*#__PURE__*/React.createElement(Tooltip, {
      title: "Send Email"
    }, /*#__PURE__*/React.createElement("a", {
      href: "mailto:".concat(item.visitorEmail),
      className: classes.contactLink
    }, /*#__PURE__*/React.createElement(EmailIcon, {
      fontSize: "small"
    }), item.visitorEmail))), /*#__PURE__*/React.createElement(TableCell, null, /*#__PURE__*/React.createElement(Tooltip, {
      title: "Call Number"
    }, /*#__PURE__*/React.createElement("a", {
      href: "tel:".concat(item.visitorNumber),
      className: classes.contactLink
    }, /*#__PURE__*/React.createElement(PhoneIcon, {
      fontSize: "small"
    }), item.visitorNumber))), /*#__PURE__*/React.createElement(TableCell, null, /*#__PURE__*/React.createElement(Box$1, {
      display: "flex",
      alignItems: "flex-start",
      gridGap: 8
    }, /*#__PURE__*/React.createElement(MessageIcon, {
      fontSize: "small",
      style: {
        marginTop: 2,
        color: "#64748b"
      }
    }), /*#__PURE__*/React.createElement(Typography, {
      variant: "body2",
      className: classes.messageBox
    }, item.visitorMessage))), /*#__PURE__*/React.createElement(TableCell, null, /*#__PURE__*/React.createElement(Box$1, {
      display: "flex",
      alignItems: "center",
      gridGap: 6
    }, /*#__PURE__*/React.createElement(TodayIcon, {
      fontSize: "small",
      style: {
        color: "#64748b"
      }
    }), /*#__PURE__*/React.createElement(Typography, {
      variant: "body2"
    }, item.dateCreated ? new Date(item.dateCreated).toLocaleString() : "-"))));
  })))));
};

var useStyles = makeStyles$2(function (theme) {
  return {
    root: {
      minHeight: "100vh",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      padding: theme.spacing(2),
      backgroundColor: "#f5f5f5"
    },
    card: {
      width: "100%",
      maxWidth: 500,
      padding: theme.spacing(4),
      borderRadius: 12,
      textAlign: "center"
    },
    title: _defineProperty({
      fontWeight: 600,
      marginBottom: theme.spacing(3)
    }, theme.breakpoints.down("sm"), {
      fontSize: "1rem"
    }),
    radioGroup: _defineProperty({
      display: "flex",
      justifyContent: "center",
      flexDirection: "row",
      gap: theme.spacing(3)
    }, theme.breakpoints.down("xs"), {
      flexDirection: "column",
      alignItems: "center",
      gap: theme.spacing(1)
    }),
    successCard: {
      width: "100%",
      maxWidth: 500,
      padding: theme.spacing(6),
      borderRadius: 12,
      textAlign: "center",
      background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
      color: "white",
      boxShadow: "0 10px 40px rgba(102, 126, 234, 0.4)"
    },
    successIcon: {
      fontSize: 80,
      marginBottom: theme.spacing(2),
      color: "#4caf50",
      animation: "$checkAnimation 0.6s ease-in-out"
    },
    "@keyframes checkAnimation": {
      "0%": {
        transform: "scale(0) rotate(-45deg)",
        opacity: 0
      },
      "50%": {
        transform: "scale(1.2) rotate(10deg)"
      },
      "100%": {
        transform: "scale(1) rotate(0deg)",
        opacity: 1
      }
    },
    successTitle: {
      fontWeight: 700,
      marginBottom: theme.spacing(2),
      fontSize: "1.5rem"
    },
    successMessage: {
      fontWeight: 500,
      fontSize: "1.1rem",
      lineHeight: 1.6,
      marginBottom: theme.spacing(3)
    },
    redirectText: {
      fontSize: "0.9rem",
      marginTop: theme.spacing(2),
      opacity: 0.9
    },
    logo: {
      width: "45%",
      padding: theme.spacing(2),
      display: "block",
      marginBottom: "20px",
      alignSelf: "center"
    }
  };
});
var NoaVerificationLink = function NoaVerificationLink() {
  var classes = useStyles();
  var _useState = useState(""),
    _useState2 = _slicedToArray(_useState, 2),
    value = _useState2[0],
    setValue = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isLoading = _useState4[0],
    setIsLoading = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isSuccess = _useState6[0],
    setIsSuccess = _useState6[1];
  var _useState7 = useState(null),
    _useState8 = _slicedToArray(_useState7, 2),
    beneficiary = _useState8[0],
    setBeneficiary = _useState8[1];
  var _useState9 = useState(false),
    _useState10 = _slicedToArray(_useState9, 2),
    openNoaModal = _useState10[0],
    setOpenNoaModal = _useState10[1];
  var dispatch = useDispatch();
  var modulesManager = useModulesManager();
  var history = useHistory$1();
  var searchParams = new URLSearchParams(window.location.search);
  var processId = searchParams.get("process_id");
  var handleOpenNoaModal = function handleOpenNoaModal() {
    setOpenNoaModal(true);
  };
  var handleCloseNoaModal = function handleCloseNoaModal() {
    setOpenNoaModal(false);
  };
  useEffect(function () {
    dispatch(fetchEisPaymentProcessWithFilters({
      processId: processId
    }, modulesManager)).then(function (response) {
      var _response$payload;
      var res = response === null || response === void 0 || (_response$payload = response.payload) === null || _response$payload === void 0 || (_response$payload = _response$payload.data) === null || _response$payload === void 0 ? void 0 : _response$payload.workforceEisPaymentProcess;
      setBeneficiary(res[0]);
    });
  }, [dispatch, processId]);
  var handleChange = function handleChange(event) {
    setValue(event.target.value);
  };
  var handleConfirm = function handleConfirm() {
    setIsLoading(true);
    var isConfirmed = value === "yes";
    dispatch(confirmNoa(processId, true, isConfirmed));

    // Show success message after a brief delay
    setTimeout(function () {
      setIsLoading(false);
      setIsSuccess(true);
    }, 1500);
  };

  // Redirect to login after showing success message
  useEffect(function () {
    if (isSuccess) {
      var redirectTimer = setTimeout(function () {
        window.location.href = "/"; // Redirect to home page
      }, 3000); // Show success message for 3 seconds before redirecting

      return function () {
        return clearTimeout(redirectTimer);
      };
    }
  }, [isSuccess, history]);
  if (isSuccess) {
    return /*#__PURE__*/React.createElement(Box$1, {
      className: classes.root
    }, /*#__PURE__*/React.createElement(Fade, {
      "in": isSuccess,
      timeout: 800
    }, /*#__PURE__*/React.createElement(Paper, {
      elevation: 8,
      className: classes.successCard
    }, /*#__PURE__*/React.createElement(CheckCircleOutlineIcon, {
      className: classes.successIcon
    }), /*#__PURE__*/React.createElement(Typography, {
      variant: "h5",
      className: classes.successTitle
    }, "Notice of Award Confirmation Successful"), /*#__PURE__*/React.createElement(Typography, {
      className: classes.successMessage
    }, "Your Confirmation has been recorded sucessfully"), /*#__PURE__*/React.createElement(Typography, {
      className: classes.successMessage
    }, "\u09A8\u09CB\u099F\u09BF\u09B6 \u0985\u09AB \u098F\u0993\u09DF\u09BE\u09B0\u09CD\u09A1 \u09A8\u09BF\u09B6\u09CD\u099A\u09BF\u09A4\u0995\u09B0\u09A3 \u09AA\u09CD\u09B0\u0995\u09CD\u09B0\u09BF\u09AF\u09BC\u09BE \u09B8\u09AE\u09CD\u09AA\u09A8\u09CD\u09A8 \u09B9\u09AF\u09BC\u09C7\u099B\u09C7\u0964"), /*#__PURE__*/React.createElement(Typography, {
      className: classes.redirectText
    }, "Redirecting to home page..."), /*#__PURE__*/React.createElement(Box$1, {
      mt: 2
    }, /*#__PURE__*/React.createElement(CircularProgress$1, {
      size: 30,
      style: {
        color: "white"
      }
    })))));
  }
  var logo = window.location.origin + "/front/workforce_assets/eis.png";
  return /*#__PURE__*/React.createElement(Box$1, {
    className: classes.root
  }, /*#__PURE__*/React.createElement(Paper, {
    elevation: 3,
    className: classes.card
  }, /*#__PURE__*/React.createElement(Box$1, {
    style: {
      textAlign: "center",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      marginBottom: "25px"
    }
  }, /*#__PURE__*/React.createElement("img", {
    style: {
      width: "45%"
    },
    src: logo
  })), /*#__PURE__*/React.createElement(Typography, {
    variant: "h5",
    className: classes.title
  }, "Have you Downloaded your Notice of Award Certificate? / \u0986\u09AA\u09A8\u09BF \u0995\u09BF \u0986\u09AA\u09A8\u09BE\u09B0 \u09A8\u09CB\u099F\u09BF\u09B6 \u0985\u09AB \u098F\u0993\u09DF\u09BE\u09B0\u09CD\u09A1 \u09B8\u09BE\u09B0\u09CD\u099F\u09BF\u09AB\u09BF\u0995\u09C7\u099F \u09A1\u09BE\u0989\u09A8\u09B2\u09CB\u09A1 \u0995\u09B0\u09C7\u099B\u09C7\u09A8?"), /*#__PURE__*/React.createElement(FormControl, {
    component: "fieldset"
  }, /*#__PURE__*/React.createElement(RadioGroup, {
    value: value,
    onChange: handleChange,
    className: classes.radioGroup
  }, /*#__PURE__*/React.createElement(FormControlLabel, {
    value: "yes",
    control: /*#__PURE__*/React.createElement(Radio, {
      color: "primary"
    }),
    label: "Yes / \u09B9\u09CD\u09AF\u09BE\u0981"
  }), /*#__PURE__*/React.createElement(FormControlLabel, {
    value: "no",
    control: /*#__PURE__*/React.createElement(Radio, {
      color: "primary"
    }),
    label: "No / \u09A8\u09BE"
  }))), /*#__PURE__*/React.createElement(Box$1, {
    mt: 3
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "contained",
    color: "primary",
    disabled: !value || isLoading,
    onClick: handleConfirm,
    style: {
      minWidth: 140,
      height: 44,
      fontSize: "1rem"
    }
  }, isLoading ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(CircularProgress$1, {
    size: 20,
    style: {
      color: "white",
      marginRight: 8
    }
  }), "Processing...") : "Confirm / নিশ্চিত করুন")), !(beneficiary !== null && beneficiary !== void 0 && beneficiary.noaBlocked) && /*#__PURE__*/React.createElement(Box$1, {
    mt: 3
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6",
    className: classes.title
  }, "Please Download your Notice of Award if you have not downloaded. / \u09A8\u09CB\u099F\u09BF\u09B6 \u0985\u09AB \u098F\u0993\u09DF\u09BE\u09B0\u09CD\u09A1 \u09B8\u09BE\u09B0\u09CD\u099F\u09BF\u09AB\u09BF\u0995\u09C7\u099F \u09A1\u09BE\u0989\u09A8\u09B2\u09CB\u09A1 \u09A8\u09BF\u09B6\u09CD\u099A\u09BF\u09A4 \u0995\u09B0\u09C1\u09A8..."), /*#__PURE__*/React.createElement(Button, {
    variant: "contained",
    color: "primary",
    size: "small",
    startIcon: /*#__PURE__*/React.createElement(VisibilityIcon, null),
    title: "View NOA",
    onClick: function onClick() {
      return handleOpenNoaModal();
    },
    style: {
      marginTop: "20px",
      marginBottom: "20px"
    }
  }, "View Notice of Award / \u09A8\u09CB\u099F\u09BF\u09B6 \u0985\u09AB \u098F\u0993\u09DF\u09BE\u09B0\u09CD\u09A1 \u09A6\u09C7\u0996\u09C1\u09A8"))), beneficiary != null && /*#__PURE__*/React.createElement(GenerateNoaView, {
    open: openNoaModal,
    onClose: handleCloseNoaModal,
    onSuccess: function onSuccess() {
      handleCloseNoaModal();
      loadData();
    },
    row: beneficiary
  }));
};

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var workforceTheme = createTheme({
  palette: {
    primary: {
      main: "#006273"
    },
    secondary: {
      main: "#006273"
    },
    text: {
      primary: "#006273"
    },
    typography: {
      fontFamily: '"Nikosh", sans-serif !important'
    }
  },
  overrides: {
    MuiCssBaseline: {
      '@global': {
        // 1. Force the font and color on the root levels
        'html, body, #root': {
          fontFamily: '"Nikosh", sans-serif !important',
          // fontSize: "1.35em !important", // High priority to override default 14px
          color: "#006273"
        },
        '.MuiFormLabel-root, .MuiInputLabel-root, .MuiFormLabel-root.Mui-focused': {
          color: "#006273 !important"
        },
        // 2. Explicitly target Autocomplete elements (labels, options, underlines)
        '.MuiAutocomplete-option, .MuiAutocomplete-input, .MuiInputLabel-root, .MuiInput-underline:before': {
          fontFamily: '"Nikosh", sans-serif !important',
          color: "#006273 !important"
        },
        // 3. Force the underline color specifically
        '.MuiInput-underline:after': {
          borderBottomColor: "#006273 !important"
        },
        // 4. Catch-all for any text inside the system
        'div, span, p, label, input,h1, h2, h3, h4, h5, h6,tbody,td': {
          fontFamily: '"Nikosh", sans-serif !important'
        },
        'label': {
          fontFamily: '"Nikosh", sans-serif !important',
          // fontSize:"1rem !important",
          lineHeight: 1
        },
        '.rmdp-container': {
          width: '100%',
          padding: '0px',
          lineHeight: 1
        },
        '.rmdp-container input': {
          border: 'none !important',
          borderBottom: '1px solid #006273 !important',
          borderRadius: '0 !important',
          padding: '0px 0 0px !important',
          backgroundColor: 'transparent !important',
          boxShadow: 'none !important',
          color: '#006273 !important',
          fontFamily: '"Nikosh", sans-serif !important',
          // fontSize: '1rem !important',
          outline: 'none !important',
          width: '100%'
        },
        '.rmdp-container input:focus': {
          borderBottom: '2px solid #006273 !important'
        }
      }
    },
    MuiInput: {
      underline: {
        '&:before': {
          borderBottomColor: "#006273"
        },
        '&:after': {
          borderBottomColor: "#006273"
        },
        '&:hover:not($disabled):before': {
          borderBottomColor: "#006273"
        }
      }
    }
  }
});
var withNikoshFont = function withNikoshFont(WrappedComponent) {
  return function (props) {
    return /*#__PURE__*/React.createElement(ThemeProvider, {
      theme: workforceTheme
    }, /*#__PURE__*/React.createElement(CssBaseline, null), /*#__PURE__*/React.createElement(WrappedComponent, props));
  };
};
var baseRouter = [{
  path: ROUTE_WORKFORCE_ORGANIZATIONS,
  component: WorkforceOrganizationsPage$1
}, {
  path: ROUTE_WORKFORCE_ORGANIZATIONS_ORGANIZATION,
  component: WorkforceOrganizationPage$1
}, {
  path: "".concat(ROUTE_WORKFORCE_ORGANIZATIONS_ORGANIZATION, "/:organization_uuid"),
  component: WorkforceOrganizationPage$1
}, {
  path: ROUTE_WORKFORCE_ORGANIZATIONS_UNITS,
  component: WorkforceOrganizationUnitsPage
}, {
  path: ROUTE_WORKFORCE_ORGANIZATIONS_UNITS_UNIT,
  component: WorkforceOrganizationUnitPage$1
}, {
  path: "".concat(ROUTE_WORKFORCE_ORGANIZATIONS_UNITS_UNIT, "/:organization_unit_uuid"),
  component: WorkforceOrganizationUnitPage$1
}, {
  path: ROUTE_ORGANIZATIONS_UNIT_DESIGNATIONS,
  component: UnitDesignationsPage$1
}, {
  path: ROUTE_ORGANIZATIONS_UNIT_DESIGNATIONS_DESIGNATION,
  component: UnitDesignationPage$1
}, {
  path: "".concat(ROUTE_ORGANIZATIONS_UNIT_DESIGNATIONS_DESIGNATION, "/:organization_unit_designation_uuid"),
  component: UnitDesignationPage$1
}, {
  path: ROUTE_WORKFORCE_ORGANIZATIONS_EMPLOYEES,
  component: OrganizationEmployeesPage$1
}, {
  path: ROUTE_WORKFORCE_ORGANIZATIONS_EMPLOYEES_EMPLOYEE,
  component: OrganizationEmployeePage$1
}, {
  path: "".concat(ROUTE_WORKFORCE_ORGANIZATIONS_EMPLOYEES_EMPLOYEE, "/:organization_employee_uuid"),
  component: OrganizationEmployeePage$1
}, {
  path: ROUTE_WORKFORCE_OFFICES,
  component: OrganizationOfficesPage
}, {
  path: ROUTE_WORKFORCE_OFFICES_OFFICE,
  component: OrganizationOfficePage
}, {
  path: "".concat(ROUTE_WORKFORCE_OFFICES_OFFICE, "/:workforce_office_uuid"),
  component: OrganizationOfficePage
}, {
  path: ROUTE_WORKFORCE_COMPANIES,
  component: OrganizationCompaniesPage$1
}, {
  path: ROUTE_WORKFORCE_COMPANIES_COMPANY,
  component: OrganizationCompanyPage
}, {
  path: "".concat(ROUTE_WORKFORCE_COMPANIES_COMPANY, "/:workforce_company_uuid"),
  component: OrganizationCompanyPage
}, {
  path: "".concat(ROUTE_WORKFORCE_EDIT_COMPANIES_COMPANY, "/:workforce_company_uuid"),
  component: OrganizationCompanyPage
}, {
  path: "".concat(ROUTE_WORKFORCE_APPROVE_COMPANIES_COMPANY, "/:workforce_company_uuid"),
  component: OrganizationCompanyPage
}, {
  path: ROUTE_WORKFORCE_APPROVE_COMPANIES_COMPANY,
  component: OrganizationCompanyPage
}, {
  path: "".concat(ROUTE_WORKFORCE_APPROVE_EDIT_COMPANIES_COMPANY, "/:workforce_company_uuid"),
  component: OrganizationCompanyPage
}, {
  path: ROUTE_WORKFORCE_APPROVE_COMPANIES,
  component: OrganizationCompaniesPage$1
}, {
  path: ROUTE_WORKFORCE_FACTORIES,
  component: OrganizationFactoriesPage$1
}, {
  path: "".concat(ROUTE_WORKFORCE_FACTORIES_FACTORY, "/:workforce_factory_uuid"),
  component: OrganizationFactoryPage
}, {
  path: "".concat(ROUTE_WORKFORCE_FACTORIES_FACTORY_VIEW, "/:workforce_factory_uuid"),
  component: WorkforceFactoryViewPage$1
}, {
  path: ROUTE_WORKFORCE_EMPLOYEES,
  component: WorkforceEmployeesPage$1
}, {
  path: ROUTE_WORKFORCE_EMPLOYEES_EMPLOYEE,
  component: WorkforceEmployeePage$1
}, {
  path: "".concat(ROUTE_WORKFORCE_EMPLOYEES_EMPLOYEE, "/:workforce_employee_uuid"),
  component: WorkforceEmployeePage$1
}, {
  path: "".concat(ROUTE_WORKFORCE_EMPLOYEES_DEPENDENTS, "/:workforce_employee_uuid"),
  component: DependentsPage$1
}, {
  path: ROUTE_WORKFORCE_EMPLOYEES_DEPENDENTS_DEPENDENT,
  component: DependentPage$1
}, {
  path: "".concat(ROUTE_WORKFORCE_EMPLOYEES_DEPENDENTS_DEPENDENT, "/:dependent_uuid"),
  component: DependentPage$1
}, {
  path: "".concat(ROUTE_WORKFORCE_EMPLOYEES_SERVICES, "/:dependent_uuid"),
  component: ServicesPage$1
}, {
  path: ROUTE_WORKFORCE_EMPLOYEES_SERVICES_SERVICE,
  component: ServicePage$1
}, {
  path: "".concat(ROUTE_WORKFORCE_EMPLOYEES_SERVICES_SERVICE, "/:service_uuid"),
  component: ServicePage$1
}, {
  path: "".concat(ROUTE_WORKFORCE_EMPLOYEES_ACCIDENT_INFOS, "/:workforce_employee_uuid"),
  component: AccidentInfosPage$1
}, {
  path: ROUTE_WORKFORCE_EMPLOYEES_ACCIDENT_INFOS_INFO,
  component: AccidentInfoPage$1
}, {
  path: "".concat(ROUTE_WORKFORCE_EMPLOYEES_ACCIDENT_INFOS_INFO, "/:workforce_employee_uuid"),
  component: AccidentInfoPage$1
}, {
  path: "".concat(ROUTE_WORKFORCE_EMPLOYEES_ACCOUNT_INFOS, "/:workforce_employee_uuid"),
  component: AccountInfosPage$1
}, {
  path: ROUTE_WORKFORCE_EMPLOYEES_ACCOUNT_INFOS_INFO,
  component: AccountInfoPage
}, {
  path: "".concat(ROUTE_WORKFORCE_EMPLOYEES_ACCOUNT_INFOS_INFO, "/:workforce_employee_uuid"),
  component: AccountInfoPage
}, {
  path: ROUTE_WORKFORCE_ASSOCIATIONS,
  component: WorkforceAsociationsPage$1
}, {
  path: ROUTE_WORKFORCE_ASSOCIATIONS_ASSOCIATION,
  component: WorkforceAsociationPage$1
}, {
  path: "".concat(ROUTE_WORKFORCE_ASSOCIATIONS_ASSOCIATION, "/:workforce_association_uuid"),
  component: WorkforceAsociationPage$1
}, {
  path: "".concat(ROUTE_WORKFORCE_ASSOCIATION_USER_MAP),
  component: AssociationUserMappingPage
}, {
  path: "".concat(ROUTE_WORKFORCE_COMMITTEE_MANAGEMENT),
  component: CommitteeManagementPage
}, {
  path: ROUTE_WORKFORCE_ORGANIZATIONS_EMPLOYEES_DESIGNATION,
  component: OrganizationEmployeeDesignationPage$1
}, {
  path: ROUTE_WORKFORCE_FACTORY_EMPLOYEE_DESIGNATION,
  component: WorkforceEmployeeDesignationPage$1
},
// { path: ROUTE_WORKFORCE_EMPLOYEE_FACTORIES, component: WorkforceEmployeeDesignationPage },
{
  path: ROUTE_WORKFORCE_BANKS,
  component: WorkforceBanksPage
}, {
  path: ROUTE_WORKFORCE_BANKS_BANK,
  component: WorkforceBankPage$1
}, {
  path: "".concat(ROUTE_WORKFORCE_BANKS_BANK, "/:bank_uuid"),
  component: WorkforceBankPage$1
}, {
  path: ROUTE_WORKFORCE_APPLICATION,
  component: MultiStepApplyForm
}, {
  path: "".concat(ROUTE_WORKFORCE_APPLICATION, "/:application_uuid"),
  component: MultiStepApplyForm
}, {
  path: ROUTE_WORKFORCE_APPLICATION_EIS,
  component: EisMultiStepApplyForm$1
}, {
  path: "".concat(ROUTE_WORKFORCE_APPLICATION_EIS, "/:application_uuid"),
  component: EisMultiStepApplyForm$1
}, {
  path: ROUTE_WORKFORCE_APPLICATIONS_PROCESS,
  component: ApplicationsProcessPage$1
}, {
  path: ROUTE_WORKFORCE_APPLICATIONS_APPLICATION_VIEW_PROCESS,
  component: ApplicationProcessPage$1
}, {
  path: "".concat(ROUTE_WORKFORCE_APPLICATIONS_APPLICATION_VIEW_PROCESS, "/:application_uuid"),
  component: ApplicationProcessPage$1
}, {
  path: ROUTE_WORKFORCE_APPLICATIONS_APPLICATION_ACTIONS,
  component: ActionsApplicationPage$1
}, {
  path: "".concat(ROUTE_WORKFORCE_APPLICATIONS_APPLICATION_ACTIONS, "/:application_uuid"),
  component: ActionsApplicationPage$1
}, {
  path: ROUTE_WORKFORCE_APPLICATIONS_APPLICATION_RESEND,
  component: ResendApplicationPage$1
}, {
  path: "".concat(ROUTE_WORKFORCE_APPLICATIONS_APPLICATION_RESEND, "/:application_uuid"),
  component: ResendApplicationPage$1
}, {
  path: ROUTE_WORKFORCE_APPLICATIONS_PROCESS,
  component: ApplicationsProcessPage$1
}, {
  path: ROUTE_WORKFORCE_APPLICATIONS_APPLICATION_VERIFY,
  component: ApplicationProcessPage$1
}, {
  path: "".concat(ROUTE_WORKFORCE_APPLICATIONS_APPLICATION_VERIFY, "/:application_uuid"),
  component: VerifyApplicationPage$1
}, {
  path: ROUTE_WORKFORCE_REPORTS_BENEFICIARY_REPORT,
  component: BeneficiaryReport
},
//WEBSITE CMS ROUTES
{
  path: ROUTE_WEBSITE_LEGAL_GUIDELINES,
  component: LegalGuidelines
}, {
  path: ROUTE_WEBSITE_VISITOR_MESSAGES,
  component: VisitorMessages
}];
var baseUnauthenticatedRouter = [{
  path: ROUTE_WORKFORCE_REGISTRATION,
  component: RegistrationPage
}, {
  path: ROUTE_ADMINISTRATIVE_LOGIN,
  component: LoginFormAdministrative
}, {
  path: ROUTE_WORKFORCE_FACTORIES_FACTORY,
  component: OrganizationFactoryPage
}, {
  path: "".concat(ROUTE_WORKFORCE_VERIFY_CONFIRMATION),
  component: VerifyConfirmationLink
}, {
  path: "".concat(ROUTE_WORKFORCE_NOA_CONFIRMATION),
  component: NoaVerificationLink
}];
var DEFAULT_CONFIG = {
  translations: [{
    key: "fr",
    messages: messages_bn
  }, {
    key: "en",
    messages: messages_en
  }],
  "DistrictPicker.selectThreshold": 100,
  "RegionPicker.selectThreshold": 100,
  "AutoSuggestion.limitDisplay": 100,
  reducers: [{
    key: "workforce",
    reducer: reducer
  }],
  refs: [{
    key: "route.home",
    ref: ROUTE_HOME
  }, {
    key: "workforce.route.organizations",
    ref: ROUTE_WORKFORCE_ORGANIZATIONS
  }, {
    key: "workforce.route.organizations.organization",
    ref: ROUTE_WORKFORCE_ORGANIZATIONS_ORGANIZATION
  }, {
    key: "workforce.route.organizations.units.unit",
    ref: ROUTE_WORKFORCE_ORGANIZATIONS_UNITS_UNIT
  }, {
    key: "workforce.route.organizations.units",
    ref: ROUTE_WORKFORCE_ORGANIZATIONS_UNITS
  }, {
    key: "workforce.route.unit.designations",
    ref: ROUTE_ORGANIZATIONS_UNIT_DESIGNATIONS
  }, {
    key: "workforce.route.unit.designations.designation",
    ref: ROUTE_ORGANIZATIONS_UNIT_DESIGNATIONS_DESIGNATION
  }, {
    key: "workforce.route.organizations.employees.employee",
    ref: ROUTE_WORKFORCE_ORGANIZATIONS_EMPLOYEES_EMPLOYEE
  }, {
    key: "workforce.route.organizations.employees.employee.account.info",
    ref: ROUTE_WORKFORCE_ORGANIZATIONS_EMPLOYEES_EMPLOYEE_ACCOUNT_INFO
  }, {
    key: "workforce.route.organizations.employees.employee.services",
    ref: ROUTE_WORKFORCE_ORGANIZATIONS_EMPLOYEES_EMPLOYEE_SERVICES
  },
  // { key: "workforce.route.organizations.employees.employee.dependent", ref: ROUTE_WORKFORCE_ORGANIZATIONS_EMPLOYEES_EMPLOYEE_DEPENDENT },
  {
    key: "workforce.route.organizations.employees",
    ref: ROUTE_WORKFORCE_ORGANIZATIONS_EMPLOYEES
  }, {
    key: "workforce.route.offices.office",
    ref: ROUTE_WORKFORCE_OFFICES_OFFICE
  }, {
    key: "workforce.route.offices",
    ref: ROUTE_WORKFORCE_OFFICES
  }, {
    key: "workforce.route.companies.company",
    ref: ROUTE_WORKFORCE_COMPANIES_COMPANY
  }, {
    key: "workforce.route.edit.companies.company",
    ref: ROUTE_WORKFORCE_EDIT_COMPANIES_COMPANY
  }, {
    key: "workforce.route.approve.edit.companies.company",
    ref: ROUTE_WORKFORCE_APPROVE_EDIT_COMPANIES_COMPANY
  }, {
    key: "workforce.route.approve.companies.company",
    ref: ROUTE_WORKFORCE_APPROVE_COMPANIES_COMPANY
  }, {
    key: "workforce.route.companies",
    ref: ROUTE_WORKFORCE_COMPANIES
  }, {
    key: "workforce.route.approve.companies",
    ref: ROUTE_WORKFORCE_APPROVE_COMPANIES
  }, {
    key: "workforce.route.factories.factory",
    ref: ROUTE_WORKFORCE_FACTORIES_FACTORY
  }, {
    key: "workforce.route.factories.factory.view",
    ref: ROUTE_WORKFORCE_FACTORIES_FACTORY_VIEW
  }, {
    key: "workforce.route.factories",
    ref: ROUTE_WORKFORCE_FACTORIES
  }, {
    key: "workforce.route.verify.confirmation",
    ref: ROUTE_WORKFORCE_VERIFY_CONFIRMATION
  }, {
    key: "workforce.route.employees.employee",
    ref: ROUTE_WORKFORCE_EMPLOYEES_EMPLOYEE
  }, {
    key: "workforce.route.employees",
    ref: ROUTE_WORKFORCE_EMPLOYEES
  }, {
    key: "workforce.route.registration",
    ref: ROUTE_WORKFORCE_REGISTRATION
  }, {
    key: "workforce.route.application",
    ref: ROUTE_WORKFORCE_APPLICATION
  }, {
    key: "workforce.route.application.eis",
    ref: ROUTE_WORKFORCE_APPLICATION_EIS
  }, {
    key: "workforce.route.applications.application.process.view",
    ref: ROUTE_WORKFORCE_APPLICATIONS_APPLICATION_VIEW_PROCESS
  }, {
    key: "workforce.route.applications.application.process.actions",
    ref: ROUTE_WORKFORCE_APPLICATIONS_APPLICATION_ACTIONS
  }, {
    key: "workforce.route.applications.application.process.resend",
    ref: ROUTE_WORKFORCE_APPLICATIONS_APPLICATION_RESEND
  }, {
    key: "workforce.route.applications.application.verify",
    ref: ROUTE_WORKFORCE_APPLICATIONS_APPLICATION_VERIFY
  }, {
    key: "workforce.route.applications.process",
    ref: ROUTE_WORKFORCE_APPLICATIONS_PROCESS
  }, {
    key: "workforce.route.employees.accident.infos",
    ref: ROUTE_WORKFORCE_EMPLOYEES_ACCIDENT_INFOS
  }, {
    key: "workforce.route.employees.accident.infos.info",
    ref: ROUTE_WORKFORCE_EMPLOYEES_ACCIDENT_INFOS_INFO
  }, {
    key: "workforce.route.employees.account.infos",
    ref: ROUTE_WORKFORCE_EMPLOYEES_ACCOUNT_INFOS
  }, {
    key: "workforce.route.employees.account.infos.info",
    ref: ROUTE_WORKFORCE_EMPLOYEES_ACCOUNT_INFOS_INFO
  }, {
    key: "workforce.route.employees.dependents",
    ref: ROUTE_WORKFORCE_EMPLOYEES_DEPENDENTS
  }, {
    key: "workforce.route.employees.dependents.dependent",
    ref: ROUTE_WORKFORCE_EMPLOYEES_DEPENDENTS_DEPENDENT
  }, {
    key: "workforce.route.employees.services",
    ref: ROUTE_WORKFORCE_EMPLOYEES_SERVICES
  }, {
    key: "workforce.route.employees.services.service",
    ref: ROUTE_WORKFORCE_EMPLOYEES_SERVICES_SERVICE
  }, {
    key: "workforce.route.employee.factories",
    ref: ROUTE_WORKFORCE_EMPLOYEE_FACTORIES
  }, {
    key: "workforce.route.banks",
    ref: ROUTE_WORKFORCE_BANKS
  }, {
    key: "workforce.route.banks.bank",
    ref: ROUTE_WORKFORCE_BANKS_BANK
  }, {
    key: "workforce.route.banks.bank",
    ref: ROUTE_WORKFORCE_BANKS_BANK
  }, {
    key: "workforce.route.associations",
    ref: ROUTE_WORKFORCE_ASSOCIATIONS
  }, {
    key: "workforce.route.associations.association",
    ref: ROUTE_WORKFORCE_ASSOCIATIONS_ASSOCIATION
  }, {
    key: "workforce.route.associations.association.user.map",
    ref: ROUTE_WORKFORCE_ASSOCIATION_USER_MAP
  }, {
    key: "workforce.route.committee.management",
    ref: ROUTE_WORKFORCE_COMMITTEE_MANAGEMENT
  }, {
    key: "workforce.route.reports.beneficiaryReport",
    ref: ROUTE_WORKFORCE_REPORTS_BENEFICIARY_REPORT
  },
  //WEBSITE CMS ROUTES
  {
    key: "workforce.route.website.legal.guidelines",
    ref: ROUTE_WEBSITE_LEGAL_GUIDELINES
  }, {
    key: "workforce.route.website.visitor.messages",
    ref: ROUTE_WEBSITE_VISITOR_MESSAGES
  },
  //WBSITE CMS ROUTES END

  {
    key: "workforceOrganization.OrganizationPicker",
    ref: OrganizationPicker
  }, {
    key: "workforce.BanksPicker",
    ref: BanksPicker$1
  }, {
    key: "workforceOrganization.CompanyPicker",
    ref: CompanyPicker
  }, {
    key: "workforceOrganization.OfficePicker",
    ref: OfficePicker
  }, {
    key: "workforceOrganization.FactoryPicker",
    ref: FactoryPicker
  }, {
    key: "workforce.DatePicker",
    ref: DatePicker
  }],
  "core.Router": baseRouter.map(function (route) {
    return _objectSpread(_objectSpread({}, route), {}, {
      component: withNikoshFont(route.component)
    });
  }),
  "core.UnauthenticatedRouter": baseUnauthenticatedRouter.map(function (route) {
    return _objectSpread(_objectSpread({}, route), {}, {
      component: withNikoshFont(route.component)
    });
  }),
  "core.MainMenu": [WorkforceMainMenu$1],
  "core.LoginPage": RegistrationButton,
  "core.LoginPageLogo": withNikoshFont(LoginHeader),
  "core.LoginPageForm": withNikoshFont(LoginForm),
  "core.AppBar": PushNotification,
  "core.userInfo": UserInfo$1,
  "home.HomePage.Blocks": withNikoshFont(DashboardRelay),
  "core.showJournalSidebar": false
};
var WorkforceModule = function WorkforceModule(cfg) {
  return _objectSpread(_objectSpread({}, DEFAULT_CONFIG), cfg);
};

export { WorkforceModule };
//# sourceMappingURL=index.es.js.map
